var zne = Object.defineProperty;
var One = (e, t, i) => t in e ? zne(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var Bg = (e, t, i) => (One(e, typeof t != "symbol" ? t + "" : t, i), i), A9 = (e, t, i) => {
  if (!t.has(e))
    throw TypeError("Cannot " + i);
};
var b9 = (e, t, i) => (A9(e, t, "read from private field"), i ? i.call(e) : t.get(e)), m9 = (e, t, i) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, i);
}, h9 = (e, t, i, n) => (A9(e, t, "write to private field"), n ? n.call(e, i) : t.set(e, i), i);
import "./style.css";
import * as YB from "react/jsx-runtime";
import xg, { jsx as ne, jsxs as Ci } from "react/jsx-runtime";
import * as Y from "react";
import Se, { forwardRef as Sl, useContext as Hn, Children as xz, isValidElement as IB, cloneElement as wu, createElement as ga, createContext as Bs, useState as At, useRef as Ct, useEffect as et, useMemo as je, lazy as AI, Suspense as $V, useCallback as ft, Component as Qne, useLayoutEffect as Um, memo as pZ, useReducer as BZ, PureComponent as jne } from "react";
import { CacheProvider as _ne, Global as $ne, ThemeContext as c5, css as Fd, keyframes as Zs, createElement as qne, ThemeProvider as ege } from "@emotion/react";
import tge from "@emotion/styled";
import * as ige from "react-dom";
import T0, { createPortal as Dz, unstable_batchedUpdates as em } from "react-dom";
import * as dc from "three";
import { Vector3 as xt, MeshStandardMaterial as Jz, Box3 as qV, Quaternion as Kz, Euler as d5, REVISION as nge, Color as Ez, CompressedTexture as $H, Texture as Nz, MathUtils as GS, RGBAFormat as gge, DoubleSide as rge, BufferAttribute as Jy, PropertyBinding as yS, InterpolateDiscrete as oge, Matrix4 as Lz, Scene as qF, PlaneGeometry as Ige, ShaderMaterial as lge, Uniform as sge, Mesh as Tz, PerspectiveCamera as Mz, WebGLRenderer as age, InterpolateLinear as cge, NearestFilter as dge, NearestMipmapNearestFilter as Cge, NearestMipmapLinearFilter as uge, LinearFilter as Age, LinearMipmapNearestFilter as bge, LinearMipmapLinearFilter as mge, ClampToEdgeWrapping as hge, RepeatWrapping as pge, MirroredRepeatWrapping as Bge, MeshPhysicalMaterial as Zge, Vector2 as Uz, Box3Helper as fge, LineBasicMaterial as Gge, Plane as Ky, Line3 as yge } from "three";
import * as Wge from "@react-three/drei";
import { RoundedBox as Sge, Box as Vge, Line as eS, Text as wge, useProgress as C5, useBounds as ew, Html as vge, useGLTF as Rge, PivotControls as Xge, useContextBridge as Hge } from "@react-three/drei";
import * as kge from "@react-three/fiber";
import { useThree as Mu, useFrame as tw, Canvas as Pz } from "@react-three/fiber";
import * as Fge from "@react-three/postprocessing";
function zz(e, t) {
  for (var i = 0; i < t.length; i++) {
    const n = t[i];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const g in n)
        if (g !== "default" && !(g in e)) {
          const r = Object.getOwnPropertyDescriptor(n, g);
          r && Object.defineProperty(e, g, r.get ? r : {
            enumerable: !0,
            get: () => n[g]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
const Yge = "9.5.3", xge = "3.15", _l = (e) => {
  var t, i;
  return (
    // @ts-ignore
    ((t = import.meta.env) == null ? void 0 : t[`VITE_${e}`]) || ((i = process.env) == null ? void 0 : i[`REACT_APP_${e}`])
  );
}, Ey = (e) => {
  throw new Error(`environment variable ${e} not provided.`);
}, jo = {
  /** The URL of the API */
  apiUrl: _l("API_URL") || Ey("API_URL"),
  /** The Analytics key for the Admin Analytics. Only provide this in Frontend */
  adminAnalytics: _l("ADMIN_ANALYTICS") || null,
  /** The URL of the docs */
  helpUrl: _l("HELP_URL") || Ey("HELP_URL"),
  /** The URL of the default topic in the help documentation */
  defaultHelpTopicUrl: _l("DEFAULT_HELP_TOPIC_URL") ?? "/docs/user",
  /** The URL of assets not shipped by the API */
  docUrl: _l("DOC_URL") || Ey("DOC_URL"),
  /* Key for bugsnag exception tracking or null */
  bugsnagKey: _l("BUGSNAG_KEY") || null,
  /** The Draco compression lib url */
  libsUrl: _l("LIBS_URL") || Ey("LIBS_URL"),
  disable3D: _l("DISABLE_3D") || !1,
  originalDomain: _l("ORIGINAL_DOMAIN") || "k3.objectcode.de",
  enableReduxDevChecks: _l("ENABLE_REDUX_DEV_CHECKS") || !1,
  shopifyLinkId: _l("SHOPIFY_K3_LINK_ID") || null
}, Dt = {
  id: "",
  instance: {
    id: "",
    isInstanceLauncher: !0,
    belongsToInstanceId: "",
    belongsToVariableId: null,
    hierarchyLevel: 0
  },
  variableId: null,
  valueId: 0
};
function Dge(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Jge(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Kge = /* @__PURE__ */ function() {
  function e(i) {
    var n = this;
    this._insertTag = function(g) {
      var r;
      n.tags.length === 0 ? n.insertionPoint ? r = n.insertionPoint.nextSibling : n.prepend ? r = n.container.firstChild : r = n.before : r = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(g, r), n.tags.push(g);
    }, this.isSpeedy = i.speedy === void 0 ? !0 : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Jge(this));
    var g = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var r = Dge(g);
      try {
        r.insertRule(n, r.cssRules.length);
      } catch {
      }
    } else
      g.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Or = "-ms-", WS = "-moz-", en = "-webkit-", Oz = "comm", u5 = "rule", A5 = "decl", Ege = "@import", Qz = "@keyframes", Nge = "@layer", Lge = Math.abs, iw = String.fromCharCode, Tge = Object.assign;
function Mge(e, t) {
  return Yr(e, 0) ^ 45 ? (((t << 2 ^ Yr(e, 0)) << 2 ^ Yr(e, 1)) << 2 ^ Yr(e, 2)) << 2 ^ Yr(e, 3) : 0;
}
function jz(e) {
  return e.trim();
}
function Uge(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function tn(e, t, i) {
  return e.replace(t, i);
}
function eY(e, t) {
  return e.indexOf(t);
}
function Yr(e, t) {
  return e.charCodeAt(t) | 0;
}
function xB(e, t, i) {
  return e.slice(t, i);
}
function zs(e) {
  return e.length;
}
function b5(e) {
  return e.length;
}
function Ny(e, t) {
  return t.push(e), e;
}
function Pge(e, t) {
  return e.map(t).join("");
}
var nw = 1, Gm = 1, _z = 0, _o = 0, Fg = 0, Pm = "";
function gw(e, t, i, n, g, r, o) {
  return { value: e, root: t, parent: i, type: n, props: g, children: r, line: nw, column: Gm, length: o, return: "" };
}
function u0(e, t) {
  return Tge(gw("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function zge() {
  return Fg;
}
function Oge() {
  return Fg = _o > 0 ? Yr(Pm, --_o) : 0, Gm--, Fg === 10 && (Gm = 1, nw--), Fg;
}
function wI() {
  return Fg = _o < _z ? Yr(Pm, _o++) : 0, Gm++, Fg === 10 && (Gm = 1, nw++), Fg;
}
function ra() {
  return Yr(Pm, _o);
}
function tS() {
  return _o;
}
function ZZ(e, t) {
  return xB(Pm, e, t);
}
function DB(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function $z(e) {
  return nw = Gm = 1, _z = zs(Pm = e), _o = 0, [];
}
function qz(e) {
  return Pm = "", e;
}
function iS(e) {
  return jz(ZZ(_o - 1, tY(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Qge(e) {
  for (; (Fg = ra()) && Fg < 33; )
    wI();
  return DB(e) > 2 || DB(Fg) > 3 ? "" : " ";
}
function jge(e, t) {
  for (; --t && wI() && !(Fg < 48 || Fg > 102 || Fg > 57 && Fg < 65 || Fg > 70 && Fg < 97); )
    ;
  return ZZ(e, tS() + (t < 6 && ra() == 32 && wI() == 32));
}
function tY(e) {
  for (; wI(); )
    switch (Fg) {
      case e:
        return _o;
      case 34:
      case 39:
        e !== 34 && e !== 39 && tY(Fg);
        break;
      case 40:
        e === 41 && tY(e);
        break;
      case 92:
        wI();
        break;
    }
  return _o;
}
function _ge(e, t) {
  for (; wI() && e + Fg !== 57; )
    if (e + Fg === 84 && ra() === 47)
      break;
  return "/*" + ZZ(t, _o - 1) + "*" + iw(e === 47 ? e : wI());
}
function $ge(e) {
  for (; !DB(ra()); )
    wI();
  return ZZ(e, _o);
}
function qge(e) {
  return qz(nS("", null, null, null, [""], e = $z(e), 0, [0], e));
}
function nS(e, t, i, n, g, r, o, I, s) {
  for (var a = 0, d = 0, C = o, u = 0, A = 0, m = 0, h = 1, B = 1, f = 1, G = 0, y = "", W = g, V = r, w = n, v = y; B; )
    switch (m = G, G = wI()) {
      case 40:
        if (m != 108 && Yr(v, C - 1) == 58) {
          eY(v += tn(iS(G), "&", "&\f"), "&\f") != -1 && (f = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        v += iS(G);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        v += Qge(m);
        break;
      case 92:
        v += jge(tS() - 1, 7);
        continue;
      case 47:
        switch (ra()) {
          case 42:
          case 47:
            Ny(ere(_ge(wI(), tS()), t, i), s);
            break;
          default:
            v += "/";
        }
        break;
      case 123 * h:
        I[a++] = zs(v) * f;
      case 125 * h:
      case 59:
      case 0:
        switch (G) {
          case 0:
          case 125:
            B = 0;
          case 59 + d:
            f == -1 && (v = tn(v, /\f/g, "")), A > 0 && zs(v) - C && Ny(A > 32 ? B9(v + ";", n, i, C - 1) : B9(tn(v, " ", "") + ";", n, i, C - 2), s);
            break;
          case 59:
            v += ";";
          default:
            if (Ny(w = p9(v, t, i, a, d, g, I, y, W = [], V = [], C), r), G === 123)
              if (d === 0)
                nS(v, t, w, w, W, r, C, I, V);
              else
                switch (u === 99 && Yr(v, 3) === 110 ? 100 : u) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    nS(e, w, w, n && Ny(p9(e, w, w, 0, 0, g, I, y, g, W = [], C), V), g, V, C, I, n ? W : V);
                    break;
                  default:
                    nS(v, w, w, w, [""], V, 0, I, V);
                }
        }
        a = d = A = 0, h = f = 1, y = v = "", C = o;
        break;
      case 58:
        C = 1 + zs(v), A = m;
      default:
        if (h < 1) {
          if (G == 123)
            --h;
          else if (G == 125 && h++ == 0 && Oge() == 125)
            continue;
        }
        switch (v += iw(G), G * h) {
          case 38:
            f = d > 0 ? 1 : (v += "\f", -1);
            break;
          case 44:
            I[a++] = (zs(v) - 1) * f, f = 1;
            break;
          case 64:
            ra() === 45 && (v += iS(wI())), u = ra(), d = C = zs(y = v += $ge(tS())), G++;
            break;
          case 45:
            m === 45 && zs(v) == 2 && (h = 0);
        }
    }
  return r;
}
function p9(e, t, i, n, g, r, o, I, s, a, d) {
  for (var C = g - 1, u = g === 0 ? r : [""], A = b5(u), m = 0, h = 0, B = 0; m < n; ++m)
    for (var f = 0, G = xB(e, C + 1, C = Lge(h = o[m])), y = e; f < A; ++f)
      (y = jz(h > 0 ? u[f] + " " + G : tn(G, /&\f/g, u[f]))) && (s[B++] = y);
  return gw(e, t, i, g === 0 ? u5 : I, s, a, d);
}
function ere(e, t, i) {
  return gw(e, t, i, Oz, iw(zge()), xB(e, 2, -2), 0);
}
function B9(e, t, i, n) {
  return gw(e, t, i, A5, xB(e, 0, n), xB(e, n + 1, -1), n);
}
function bm(e, t) {
  for (var i = "", n = b5(e), g = 0; g < n; g++)
    i += t(e[g], g, e, t) || "";
  return i;
}
function tre(e, t, i, n) {
  switch (e.type) {
    case Nge:
      if (e.children.length)
        break;
    case Ege:
    case A5:
      return e.return = e.return || e.value;
    case Oz:
      return "";
    case Qz:
      return e.return = e.value + "{" + bm(e.children, n) + "}";
    case u5:
      e.value = e.props.join(",");
  }
  return zs(i = bm(e.children, n)) ? e.return = e.value + "{" + i + "}" : "";
}
function ire(e) {
  var t = b5(e);
  return function(i, n, g, r) {
    for (var o = "", I = 0; I < t; I++)
      o += e[I](i, n, g, r) || "";
    return o;
  };
}
function nre(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function gre(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return t[i] === void 0 && (t[i] = e(i)), t[i];
  };
}
var rre = function(t, i, n) {
  for (var g = 0, r = 0; g = r, r = ra(), g === 38 && r === 12 && (i[n] = 1), !DB(r); )
    wI();
  return ZZ(t, _o);
}, ore = function(t, i) {
  var n = -1, g = 44;
  do
    switch (DB(g)) {
      case 0:
        g === 38 && ra() === 12 && (i[n] = 1), t[n] += rre(_o - 1, i, n);
        break;
      case 2:
        t[n] += iS(g);
        break;
      case 4:
        if (g === 44) {
          t[++n] = ra() === 58 ? "&\f" : "", i[n] = t[n].length;
          break;
        }
      default:
        t[n] += iw(g);
    }
  while (g = wI());
  return t;
}, Ire = function(t, i) {
  return qz(ore($z(t), i));
}, Z9 = /* @__PURE__ */ new WeakMap(), lre = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var i = t.value, n = t.parent, g = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(t.props.length === 1 && i.charCodeAt(0) !== 58 && !Z9.get(n)) && !g) {
      Z9.set(t, !0);
      for (var r = [], o = Ire(i, r), I = n.props, s = 0, a = 0; s < o.length; s++)
        for (var d = 0; d < I.length; d++, a++)
          t.props[a] = r[s] ? o[s].replace(/&\f/g, I[d]) : I[d] + " " + o[s];
    }
  }
}, sre = function(t) {
  if (t.type === "decl") {
    var i = t.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function e4(e, t) {
  switch (Mge(e, t)) {
    case 5103:
      return en + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return en + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return en + e + WS + e + Or + e + e;
    case 6828:
    case 4268:
      return en + e + Or + e + e;
    case 6165:
      return en + e + Or + "flex-" + e + e;
    case 5187:
      return en + e + tn(e, /(\w+).+(:[^]+)/, en + "box-$1$2" + Or + "flex-$1$2") + e;
    case 5443:
      return en + e + Or + "flex-item-" + tn(e, /flex-|-self/, "") + e;
    case 4675:
      return en + e + Or + "flex-line-pack" + tn(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return en + e + Or + tn(e, "shrink", "negative") + e;
    case 5292:
      return en + e + Or + tn(e, "basis", "preferred-size") + e;
    case 6060:
      return en + "box-" + tn(e, "-grow", "") + en + e + Or + tn(e, "grow", "positive") + e;
    case 4554:
      return en + tn(e, /([^-])(transform)/g, "$1" + en + "$2") + e;
    case 6187:
      return tn(tn(tn(e, /(zoom-|grab)/, en + "$1"), /(image-set)/, en + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return tn(e, /(image-set\([^]*)/, en + "$1$`$1");
    case 4968:
      return tn(tn(e, /(.+:)(flex-)?(.*)/, en + "box-pack:$3" + Or + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + en + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return tn(e, /(.+)-inline(.+)/, en + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (zs(e) - 1 - t > 6)
        switch (Yr(e, t + 1)) {
          case 109:
            if (Yr(e, t + 4) !== 45)
              break;
          case 102:
            return tn(e, /(.+:)(.+)-([^]+)/, "$1" + en + "$2-$3$1" + WS + (Yr(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~eY(e, "stretch") ? e4(tn(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Yr(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Yr(e, zs(e) - 3 - (~eY(e, "!important") && 10))) {
        case 107:
          return tn(e, ":", ":" + en) + e;
        case 101:
          return tn(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + en + (Yr(e, 14) === 45 ? "inline-" : "") + "box$3$1" + en + "$2$3$1" + Or + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Yr(e, t + 11)) {
        case 114:
          return en + e + Or + tn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return en + e + Or + tn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return en + e + Or + tn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return en + e + Or + e + e;
  }
  return e;
}
var are = function(t, i, n, g) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case A5:
        t.return = e4(t.value, t.length);
        break;
      case Qz:
        return bm([u0(t, {
          value: tn(t.value, "@", "@" + en)
        })], g);
      case u5:
        if (t.length)
          return Pge(t.props, function(r) {
            switch (Uge(r, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return bm([u0(t, {
                  props: [tn(r, /:(read-\w+)/, ":" + WS + "$1")]
                })], g);
              case "::placeholder":
                return bm([u0(t, {
                  props: [tn(r, /:(plac\w+)/, ":" + en + "input-$1")]
                }), u0(t, {
                  props: [tn(r, /:(plac\w+)/, ":" + WS + "$1")]
                }), u0(t, {
                  props: [tn(r, /:(plac\w+)/, Or + "input-$1")]
                })], g);
            }
            return "";
          });
    }
}, cre = [are], t4 = function(t) {
  var i = t.key;
  if (i === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(h) {
      var B = h.getAttribute("data-emotion");
      B.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var g = t.stylisPlugins || cre, r = {}, o, I = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(h) {
      for (var B = h.getAttribute("data-emotion").split(" "), f = 1; f < B.length; f++)
        r[B[f]] = !0;
      I.push(h);
    }
  );
  var s, a = [lre, sre];
  {
    var d, C = [tre, nre(function(h) {
      d.insert(h);
    })], u = ire(a.concat(g, C)), A = function(B) {
      return bm(qge(B), u);
    };
    s = function(B, f, G, y) {
      d = G, A(B ? B + "{" + f.styles + "}" : f.styles), y && (m.inserted[f.name] = !0);
    };
  }
  var m = {
    key: i,
    sheet: new Kge({
      key: i,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: r,
    registered: {},
    insert: s
  };
  return m.sheet.hydrate(I), m;
};
function k() {
  return k = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, k.apply(this, arguments);
}
var Zn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Tr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function yc(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var i = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    i.prototype = t.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var g = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(i, n, g.get ? g : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), i;
}
var i4 = { exports: {} }, fn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar = typeof Symbol == "function" && Symbol.for, m5 = Ar ? Symbol.for("react.element") : 60103, h5 = Ar ? Symbol.for("react.portal") : 60106, rw = Ar ? Symbol.for("react.fragment") : 60107, ow = Ar ? Symbol.for("react.strict_mode") : 60108, Iw = Ar ? Symbol.for("react.profiler") : 60114, lw = Ar ? Symbol.for("react.provider") : 60109, sw = Ar ? Symbol.for("react.context") : 60110, p5 = Ar ? Symbol.for("react.async_mode") : 60111, aw = Ar ? Symbol.for("react.concurrent_mode") : 60111, cw = Ar ? Symbol.for("react.forward_ref") : 60112, dw = Ar ? Symbol.for("react.suspense") : 60113, dre = Ar ? Symbol.for("react.suspense_list") : 60120, Cw = Ar ? Symbol.for("react.memo") : 60115, uw = Ar ? Symbol.for("react.lazy") : 60116, Cre = Ar ? Symbol.for("react.block") : 60121, ure = Ar ? Symbol.for("react.fundamental") : 60117, Are = Ar ? Symbol.for("react.responder") : 60118, bre = Ar ? Symbol.for("react.scope") : 60119;
function DI(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case m5:
        switch (e = e.type, e) {
          case p5:
          case aw:
          case rw:
          case Iw:
          case ow:
          case dw:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case sw:
              case cw:
              case uw:
              case Cw:
              case lw:
                return e;
              default:
                return t;
            }
        }
      case h5:
        return t;
    }
  }
}
function n4(e) {
  return DI(e) === aw;
}
fn.AsyncMode = p5;
fn.ConcurrentMode = aw;
fn.ContextConsumer = sw;
fn.ContextProvider = lw;
fn.Element = m5;
fn.ForwardRef = cw;
fn.Fragment = rw;
fn.Lazy = uw;
fn.Memo = Cw;
fn.Portal = h5;
fn.Profiler = Iw;
fn.StrictMode = ow;
fn.Suspense = dw;
fn.isAsyncMode = function(e) {
  return n4(e) || DI(e) === p5;
};
fn.isConcurrentMode = n4;
fn.isContextConsumer = function(e) {
  return DI(e) === sw;
};
fn.isContextProvider = function(e) {
  return DI(e) === lw;
};
fn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === m5;
};
fn.isForwardRef = function(e) {
  return DI(e) === cw;
};
fn.isFragment = function(e) {
  return DI(e) === rw;
};
fn.isLazy = function(e) {
  return DI(e) === uw;
};
fn.isMemo = function(e) {
  return DI(e) === Cw;
};
fn.isPortal = function(e) {
  return DI(e) === h5;
};
fn.isProfiler = function(e) {
  return DI(e) === Iw;
};
fn.isStrictMode = function(e) {
  return DI(e) === ow;
};
fn.isSuspense = function(e) {
  return DI(e) === dw;
};
fn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === rw || e === aw || e === Iw || e === ow || e === dw || e === dre || typeof e == "object" && e !== null && (e.$$typeof === uw || e.$$typeof === Cw || e.$$typeof === lw || e.$$typeof === sw || e.$$typeof === cw || e.$$typeof === ure || e.$$typeof === Are || e.$$typeof === bre || e.$$typeof === Cre);
};
fn.typeOf = DI;
i4.exports = fn;
var mre = i4.exports, B5 = mre, hre = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, pre = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Bre = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, g4 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Z5 = {};
Z5[B5.ForwardRef] = Bre;
Z5[B5.Memo] = g4;
function f9(e) {
  return B5.isMemo(e) ? g4 : Z5[e.$$typeof] || hre;
}
var Zre = Object.defineProperty, fre = Object.getOwnPropertyNames, G9 = Object.getOwnPropertySymbols, Gre = Object.getOwnPropertyDescriptor, yre = Object.getPrototypeOf, y9 = Object.prototype;
function r4(e, t, i) {
  if (typeof t != "string") {
    if (y9) {
      var n = yre(t);
      n && n !== y9 && r4(e, n, i);
    }
    var g = fre(t);
    G9 && (g = g.concat(G9(t)));
    for (var r = f9(e), o = f9(t), I = 0; I < g.length; ++I) {
      var s = g[I];
      if (!pre[s] && !(i && i[s]) && !(o && o[s]) && !(r && r[s])) {
        var a = Gre(t, s);
        try {
          Zre(e, s, a);
        } catch {
        }
      }
    }
  }
  return e;
}
var Wre = r4;
const W9 = /* @__PURE__ */ Tr(Wre);
var Sre = !0;
function Vre(e, t, i) {
  var n = "";
  return i.split(" ").forEach(function(g) {
    e[g] !== void 0 ? t.push(e[g] + ";") : n += g + " ";
  }), n;
}
var o4 = function(t, i, n) {
  var g = t.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Sre === !1) && t.registered[g] === void 0 && (t.registered[g] = i.styles);
}, wre = function(t, i, n) {
  o4(t, i, n);
  var g = t.key + "-" + i.name;
  if (t.inserted[i.name] === void 0) {
    var r = i;
    do
      t.insert(i === r ? "." + g : "", r, t.sheet, !0), r = r.next;
    while (r !== void 0);
  }
};
function vre(e) {
  for (var t = 0, i, n = 0, g = e.length; g >= 4; ++n, g -= 4)
    i = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, t = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (g) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Rre = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Xre = /[A-Z]|^ms/g, Hre = /_EMO_([^_]+?)_([^]*?)_EMO_/g, I4 = function(t) {
  return t.charCodeAt(1) === 45;
}, S9 = function(t) {
  return t != null && typeof t != "boolean";
}, qH = /* @__PURE__ */ gre(function(e) {
  return I4(e) ? e : e.replace(Xre, "-$&").toLowerCase();
}), V9 = function(t, i) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(Hre, function(n, g, r) {
          return Os = {
            name: g,
            styles: r,
            next: Os
          }, g;
        });
  }
  return Rre[t] !== 1 && !I4(t) && typeof i == "number" && i !== 0 ? i + "px" : i;
};
function JB(e, t, i) {
  if (i == null)
    return "";
  if (i.__emotion_styles !== void 0)
    return i;
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      if (i.anim === 1)
        return Os = {
          name: i.name,
          styles: i.styles,
          next: Os
        }, i.name;
      if (i.styles !== void 0) {
        var n = i.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Os = {
              name: n.name,
              styles: n.styles,
              next: Os
            }, n = n.next;
        var g = i.styles + ";";
        return g;
      }
      return kre(e, t, i);
    }
    case "function": {
      if (e !== void 0) {
        var r = Os, o = i(e);
        return Os = r, JB(e, t, o);
      }
      break;
    }
  }
  return i;
}
function kre(e, t, i) {
  var n = "";
  if (Array.isArray(i))
    for (var g = 0; g < i.length; g++)
      n += JB(e, t, i[g]) + ";";
  else
    for (var r in i) {
      var o = i[r];
      if (typeof o != "object")
        S9(o) && (n += qH(r) + ":" + V9(r, o) + ";");
      else if (Array.isArray(o) && typeof o[0] == "string" && t == null)
        for (var I = 0; I < o.length; I++)
          S9(o[I]) && (n += qH(r) + ":" + V9(r, o[I]) + ";");
      else {
        var s = JB(e, t, o);
        switch (r) {
          case "animation":
          case "animationName": {
            n += qH(r) + ":" + s + ";";
            break;
          }
          default:
            n += r + "{" + s + "}";
        }
      }
    }
  return n;
}
var w9 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Os, Fre = function(t, i, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var g = !0, r = "";
  Os = void 0;
  var o = t[0];
  o == null || o.raw === void 0 ? (g = !1, r += JB(n, i, o)) : r += o[0];
  for (var I = 1; I < t.length; I++)
    r += JB(n, i, t[I]), g && (r += o[I]);
  w9.lastIndex = 0;
  for (var s = "", a; (a = w9.exec(r)) !== null; )
    s += "-" + // $FlowFixMe we know it's not null
    a[1];
  var d = vre(r) + s;
  return {
    name: d,
    styles: r,
    next: Os
  };
}, Yre = function(t) {
  return t();
}, xre = Y.useInsertionEffect ? Y.useInsertionEffect : !1, Dre = xre || Yre, Aw = {}.hasOwnProperty, l4 = /* @__PURE__ */ Y.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ t4({
    key: "css"
  }) : null
);
l4.Provider;
var Jre = function(t) {
  return /* @__PURE__ */ Sl(function(i, n) {
    var g = Hn(l4);
    return t(i, g, n);
  });
}, Kre = /* @__PURE__ */ Y.createContext({}), iY = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", s4 = function(t, i) {
  var n = {};
  for (var g in i)
    Aw.call(i, g) && (n[g] = i[g]);
  return n[iY] = t, n;
}, Ere = function(t) {
  var i = t.cache, n = t.serialized, g = t.isStringTag;
  return o4(i, n, g), Dre(function() {
    return wre(i, n, g);
  }), null;
}, Nre = /* @__PURE__ */ Jre(function(e, t, i) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var g = e[iY], r = [n], o = "";
  typeof e.className == "string" ? o = Vre(t.registered, r, e.className) : e.className != null && (o = e.className + " ");
  var I = Fre(r, void 0, Y.useContext(Kre));
  o += t.key + "-" + I.name;
  var s = {};
  for (var a in e)
    Aw.call(e, a) && a !== "css" && a !== iY && (s[a] = e[a]);
  return s.ref = i, s.className = o, /* @__PURE__ */ Y.createElement(Y.Fragment, null, /* @__PURE__ */ Y.createElement(Ere, {
    cache: t,
    serialized: I,
    isStringTag: typeof g == "string"
  }), /* @__PURE__ */ Y.createElement(g, s));
}), a4 = Nre, Bt = YB.Fragment;
function p(e, t, i) {
  return Aw.call(t, "css") ? YB.jsx(a4, s4(e, t), i) : YB.jsx(e, t, i);
}
function ge(e, t, i) {
  return Aw.call(t, "css") ? YB.jsxs(a4, s4(e, t), i) : YB.jsxs(e, t, i);
}
/**
 * @remix-run/router v1.0.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function KB() {
  return KB = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, KB.apply(this, arguments);
}
var Gd;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Gd || (Gd = {}));
const v9 = "popstate";
function Lre(e) {
  e === void 0 && (e = {});
  function t(g, r) {
    let {
      pathname: o = "/",
      search: I = "",
      hash: s = ""
    } = Uu(g.location.hash.substr(1));
    return nY(
      "",
      {
        pathname: o,
        search: I,
        hash: s
      },
      // state defaults to `null` because `window.history.state` does
      r.state && r.state.usr || null,
      r.state && r.state.key || "default"
    );
  }
  function i(g, r) {
    let o = g.document.querySelector("base"), I = "";
    if (o && o.getAttribute("href")) {
      let s = g.location.href, a = s.indexOf("#");
      I = a === -1 ? s : s.slice(0, a);
    }
    return I + "#" + (typeof r == "string" ? r : EB(r));
  }
  function n(g, r) {
    Tre(g.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(r) + ")");
  }
  return Pre(t, i, n, e);
}
function Tre(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Mre() {
  return Math.random().toString(36).substr(2, 8);
}
function R9(e) {
  return {
    usr: e.state,
    key: e.key
  };
}
function nY(e, t, i, n) {
  return i === void 0 && (i = null), KB({
    pathname: typeof e == "string" ? e : e.pathname,
    search: "",
    hash: ""
  }, typeof t == "string" ? Uu(t) : t, {
    state: i,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: t && t.key || n || Mre()
  });
}
function EB(e) {
  let {
    pathname: t = "/",
    search: i = "",
    hash: n = ""
  } = e;
  return i && i !== "?" && (t += i.charAt(0) === "?" ? i : "?" + i), n && n !== "#" && (t += n.charAt(0) === "#" ? n : "#" + n), t;
}
function Uu(e) {
  let t = {};
  if (e) {
    let i = e.indexOf("#");
    i >= 0 && (t.hash = e.substr(i), e = e.substr(0, i));
    let n = e.indexOf("?");
    n >= 0 && (t.search = e.substr(n), e = e.substr(0, n)), e && (t.pathname = e);
  }
  return t;
}
function Ure(e) {
  let t = typeof window < "u" && typeof window.location < "u" && window.location.origin !== "null" ? window.location.origin : "unknown://unknown", i = typeof e == "string" ? e : EB(e);
  return new URL(i, t);
}
function Pre(e, t, i, n) {
  n === void 0 && (n = {});
  let {
    window: g = document.defaultView,
    v5Compat: r = !1
  } = n, o = g.history, I = Gd.Pop, s = null;
  function a() {
    I = Gd.Pop, s && s({
      action: I,
      location: u.location
    });
  }
  function d(A, m) {
    I = Gd.Push;
    let h = nY(u.location, A, m);
    i && i(h, A);
    let B = R9(h), f = u.createHref(h);
    try {
      o.pushState(B, "", f);
    } catch {
      g.location.assign(f);
    }
    r && s && s({
      action: I,
      location: u.location
    });
  }
  function C(A, m) {
    I = Gd.Replace;
    let h = nY(u.location, A, m);
    i && i(h, A);
    let B = R9(h), f = u.createHref(h);
    o.replaceState(B, "", f), r && s && s({
      action: I,
      location: u.location
    });
  }
  let u = {
    get action() {
      return I;
    },
    get location() {
      return e(g, o);
    },
    listen(A) {
      if (s)
        throw new Error("A history only accepts one active listener");
      return g.addEventListener(v9, a), s = A, () => {
        g.removeEventListener(v9, a), s = null;
      };
    },
    createHref(A) {
      return t(g, A);
    },
    encodeLocation(A) {
      let m = Ure(EB(A));
      return KB({}, A, {
        pathname: m.pathname,
        search: m.search,
        hash: m.hash
      });
    },
    push: d,
    replace: C,
    go(A) {
      return o.go(A);
    }
  };
  return u;
}
var X9;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(X9 || (X9 = {}));
function zre(e, t, i) {
  i === void 0 && (i = "/");
  let n = typeof t == "string" ? Uu(t) : t, g = C4(n.pathname || "/", i);
  if (g == null)
    return null;
  let r = c4(e);
  Ore(r);
  let o = null;
  for (let I = 0; o == null && I < r.length; ++I)
    o = noe(
      r[I],
      // Incoming pathnames are generally encoded from either window.location
      // or from router.navigate, but we want to match against the unencoded
      // paths in the route definitions.  Memory router locations won't be
      // encoded here but there also shouldn't be anything to decode so this
      // should be a safe operation.  This avoids needing matchRoutes to be
      // history-aware.
      roe(g)
    );
  return o;
}
function c4(e, t, i, n) {
  return t === void 0 && (t = []), i === void 0 && (i = []), n === void 0 && (n = ""), e.forEach((g, r) => {
    let o = {
      relativePath: g.path || "",
      caseSensitive: g.caseSensitive === !0,
      childrenIndex: r,
      route: g
    };
    o.relativePath.startsWith("/") && (Yg(o.relativePath.startsWith(n), 'Absolute route path "' + o.relativePath + '" nested under path ' + ('"' + n + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), o.relativePath = o.relativePath.slice(n.length));
    let I = Vd([n, o.relativePath]), s = i.concat(o);
    g.children && g.children.length > 0 && (Yg(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      g.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + I + '".')
    ), c4(g.children, t, s, I)), !(g.path == null && !g.index) && t.push({
      path: I,
      score: toe(I, g.index),
      routesMeta: s
    });
  }), t;
}
function Ore(e) {
  e.sort((t, i) => t.score !== i.score ? i.score - t.score : ioe(t.routesMeta.map((n) => n.childrenIndex), i.routesMeta.map((n) => n.childrenIndex)));
}
const Qre = /^:\w+$/, jre = 3, _re = 2, $re = 1, qre = 10, eoe = -2, H9 = (e) => e === "*";
function toe(e, t) {
  let i = e.split("/"), n = i.length;
  return i.some(H9) && (n += eoe), t && (n += _re), i.filter((g) => !H9(g)).reduce((g, r) => g + (Qre.test(r) ? jre : r === "" ? $re : qre), n);
}
function ioe(e, t) {
  return e.length === t.length && e.slice(0, -1).every((n, g) => n === t[g]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function noe(e, t) {
  let {
    routesMeta: i
  } = e, n = {}, g = "/", r = [];
  for (let o = 0; o < i.length; ++o) {
    let I = i[o], s = o === i.length - 1, a = g === "/" ? t : t.slice(g.length) || "/", d = d4({
      path: I.relativePath,
      caseSensitive: I.caseSensitive,
      end: s
    }, a);
    if (!d)
      return null;
    Object.assign(n, d.params);
    let C = I.route;
    r.push({
      // TODO: Can this as be avoided?
      params: n,
      pathname: Vd([g, d.pathname]),
      pathnameBase: soe(Vd([g, d.pathnameBase])),
      route: C
    }), d.pathnameBase !== "/" && (g = Vd([g, d.pathnameBase]));
  }
  return r;
}
function d4(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [i, n] = goe(e.path, e.caseSensitive, e.end), g = t.match(i);
  if (!g)
    return null;
  let r = g[0], o = r.replace(/(.)\/+$/, "$1"), I = g.slice(1);
  return {
    params: n.reduce((a, d, C) => {
      if (d === "*") {
        let u = I[C] || "";
        o = r.slice(0, r.length - u.length).replace(/(.)\/+$/, "$1");
      }
      return a[d] = ooe(I[C] || "", d), a;
    }, {}),
    pathname: r,
    pathnameBase: o,
    pattern: e
  };
}
function goe(e, t, i) {
  t === void 0 && (t = !1), i === void 0 && (i = !0), f5(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let n = [], g = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^$?{}|()[\]]/g, "\\$&").replace(/:(\w+)/g, (o, I) => (n.push(I), "([^\\/]+)"));
  return e.endsWith("*") ? (n.push("*"), g += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : i ? g += "\\/*$" : e !== "" && e !== "/" && (g += "(?:(?=\\/|$))"), [new RegExp(g, t ? void 0 : "i"), n];
}
function roe(e) {
  try {
    return decodeURI(e);
  } catch (t) {
    return f5(!1, 'The URL path "' + e + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + t + ").")), e;
  }
}
function ooe(e, t) {
  try {
    return decodeURIComponent(e);
  } catch (i) {
    return f5(!1, 'The value for the URL param "' + t + '" will not be decoded because' + (' the string "' + e + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + i + ").")), e;
  }
}
function C4(e, t) {
  if (t === "/")
    return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let i = t.endsWith("/") ? t.length - 1 : t.length, n = e.charAt(i);
  return n && n !== "/" ? null : e.slice(i) || "/";
}
function Yg(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function f5(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Ioe(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: i,
    search: n = "",
    hash: g = ""
  } = typeof e == "string" ? Uu(e) : e;
  return {
    pathname: i ? i.startsWith("/") ? i : loe(i, t) : t,
    search: aoe(n),
    hash: coe(g)
  };
}
function loe(e, t) {
  let i = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((g) => {
    g === ".." ? i.length > 1 && i.pop() : g !== "." && i.push(g);
  }), i.length > 1 ? i.join("/") : "/";
}
function ek(e, t, i, n) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(n) + "].  Please separate it out to the ") + ("`to." + i + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function u4(e) {
  return e.filter((t, i) => i === 0 || t.route.path && t.route.path.length > 0);
}
function A4(e, t, i, n) {
  n === void 0 && (n = !1);
  let g;
  typeof e == "string" ? g = Uu(e) : (g = KB({}, e), Yg(!g.pathname || !g.pathname.includes("?"), ek("?", "pathname", "search", g)), Yg(!g.pathname || !g.pathname.includes("#"), ek("#", "pathname", "hash", g)), Yg(!g.search || !g.search.includes("#"), ek("#", "search", "hash", g)));
  let r = e === "" || g.pathname === "", o = r ? "/" : g.pathname, I;
  if (n || o == null)
    I = i;
  else {
    let C = t.length - 1;
    if (o.startsWith("..")) {
      let u = o.split("/");
      for (; u[0] === ".."; )
        u.shift(), C -= 1;
      g.pathname = u.join("/");
    }
    I = C >= 0 ? t[C] : "/";
  }
  let s = Ioe(g, I), a = o && o !== "/" && o.endsWith("/"), d = (r || o === ".") && i.endsWith("/");
  return !s.pathname.endsWith("/") && (a || d) && (s.pathname += "/"), s;
}
const Vd = (e) => e.join("/").replace(/\/\/+/g, "/"), soe = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), aoe = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, coe = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
class doe {
  constructor(t, i, n) {
    this.status = t, this.statusText = i || "", this.data = n;
  }
}
function Coe(e) {
  return e instanceof doe;
}
const uoe = /* @__PURE__ */ new Set(["POST", "PUT", "PATCH", "DELETE"]);
[...uoe];
/**
 * React Router v6.4.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function gY() {
  return gY = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, gY.apply(this, arguments);
}
const Aoe = /* @__PURE__ */ Y.createContext(null), boe = /* @__PURE__ */ Y.createContext(null), bw = /* @__PURE__ */ Y.createContext(null), G5 = /* @__PURE__ */ Y.createContext(null), mw = /* @__PURE__ */ Y.createContext(null), Pu = /* @__PURE__ */ Y.createContext({
  outlet: null,
  matches: []
}), b4 = /* @__PURE__ */ Y.createContext(null);
function moe(e, t) {
  let {
    relative: i
  } = t === void 0 ? {} : t;
  zu() || Yg(!1);
  let {
    basename: n,
    navigator: g
  } = Y.useContext(G5), {
    hash: r,
    pathname: o,
    search: I
  } = W5(e, {
    relative: i
  }), s = o;
  return n !== "/" && (s = o === "/" ? n : Vd([n, o])), g.createHref({
    pathname: s,
    search: I,
    hash: r
  });
}
function zu() {
  return Y.useContext(mw) != null;
}
function Ud() {
  return zu() || Yg(!1), Y.useContext(mw).location;
}
function tDt(e) {
  zu() || Yg(!1);
  let {
    pathname: t
  } = Ud();
  return Y.useMemo(() => d4(e, t), [t, e]);
}
function ha() {
  zu() || Yg(!1);
  let {
    basename: e,
    navigator: t
  } = Y.useContext(G5), {
    matches: i
  } = Y.useContext(Pu), {
    pathname: n
  } = Ud(), g = JSON.stringify(u4(i).map((I) => I.pathnameBase)), r = Y.useRef(!1);
  return Y.useEffect(() => {
    r.current = !0;
  }), Y.useCallback(function(I, s) {
    if (s === void 0 && (s = {}), !r.current)
      return;
    if (typeof I == "number") {
      t.go(I);
      return;
    }
    let a = A4(I, JSON.parse(g), n, s.relative === "path");
    e !== "/" && (a.pathname = a.pathname === "/" ? e : Vd([e, a.pathname])), (s.replace ? t.replace : t.push)(a, s.state, s);
  }, [e, t, g, n]);
}
const hoe = /* @__PURE__ */ Y.createContext(null);
function poe(e) {
  let t = Y.useContext(Pu).outlet;
  return t && /* @__PURE__ */ Y.createElement(hoe.Provider, {
    value: e
  }, t);
}
function y5() {
  let {
    matches: e
  } = Y.useContext(Pu), t = e[e.length - 1];
  return t ? t.params : {};
}
function W5(e, t) {
  let {
    relative: i
  } = t === void 0 ? {} : t, {
    matches: n
  } = Y.useContext(Pu), {
    pathname: g
  } = Ud(), r = JSON.stringify(u4(n).map((o) => o.pathnameBase));
  return Y.useMemo(() => A4(e, JSON.parse(r), g, i === "path"), [e, r, g, i]);
}
function Boe(e, t) {
  zu() || Yg(!1);
  let i = Y.useContext(bw), {
    matches: n
  } = Y.useContext(Pu), g = n[n.length - 1], r = g ? g.params : {};
  g && g.pathname;
  let o = g ? g.pathnameBase : "/";
  g && g.route;
  let I = Ud(), s;
  if (t) {
    var a;
    let m = typeof t == "string" ? Uu(t) : t;
    o === "/" || (a = m.pathname) != null && a.startsWith(o) || Yg(!1), s = m;
  } else
    s = I;
  let d = s.pathname || "/", C = o === "/" ? d : d.slice(o.length) || "/", u = zre(e, {
    pathname: C
  }), A = yoe(u && u.map((m) => Object.assign({}, m, {
    params: Object.assign({}, r, m.params),
    pathname: Vd([o, m.pathname]),
    pathnameBase: m.pathnameBase === "/" ? o : Vd([o, m.pathnameBase])
  })), n, i || void 0);
  return t && A ? /* @__PURE__ */ Y.createElement(mw.Provider, {
    value: {
      location: gY({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, s),
      navigationType: Gd.Pop
    }
  }, A) : A;
}
function Zoe() {
  let e = Soe(), t = Coe(e) ? e.status + " " + e.statusText : e instanceof Error ? e.message : JSON.stringify(e), i = e instanceof Error ? e.stack : null, n = "rgba(200,200,200, 0.5)", g = {
    padding: "0.5rem",
    backgroundColor: n
  }, r = {
    padding: "2px 4px",
    backgroundColor: n
  };
  return /* @__PURE__ */ Y.createElement(Y.Fragment, null, /* @__PURE__ */ Y.createElement("h2", null, "Unhandled Thrown Error!"), /* @__PURE__ */ Y.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, t), i ? /* @__PURE__ */ Y.createElement("pre", {
    style: g
  }, i) : null, /* @__PURE__ */ Y.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ Y.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ Y.createElement("code", {
    style: r
  }, "errorElement"), " props on ", /* @__PURE__ */ Y.createElement("code", {
    style: r
  }, "<Route>")));
}
class foe extends Y.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return {
      error: t
    };
  }
  static getDerivedStateFromProps(t, i) {
    return i.location !== t.location ? {
      error: t.error,
      location: t.location
    } : {
      error: t.error || i.error,
      location: i.location
    };
  }
  componentDidCatch(t, i) {
    console.error("React Router caught the following error during render", t, i);
  }
  render() {
    return this.state.error ? /* @__PURE__ */ Y.createElement(b4.Provider, {
      value: this.state.error,
      children: this.props.component
    }) : this.props.children;
  }
}
function Goe(e) {
  let {
    routeContext: t,
    match: i,
    children: n
  } = e, g = Y.useContext(Aoe);
  return g && i.route.errorElement && (g._deepestRenderedBoundaryId = i.route.id), /* @__PURE__ */ Y.createElement(Pu.Provider, {
    value: t
  }, n);
}
function yoe(e, t, i) {
  if (t === void 0 && (t = []), e == null)
    if (i != null && i.errors)
      e = i.matches;
    else
      return null;
  let n = e, g = i == null ? void 0 : i.errors;
  if (g != null) {
    let r = n.findIndex((o) => o.route.id && (g == null ? void 0 : g[o.route.id]));
    r >= 0 || Yg(!1), n = n.slice(0, Math.min(n.length, r + 1));
  }
  return n.reduceRight((r, o, I) => {
    let s = o.route.id ? g == null ? void 0 : g[o.route.id] : null, a = i ? o.route.errorElement || /* @__PURE__ */ Y.createElement(Zoe, null) : null, d = () => /* @__PURE__ */ Y.createElement(Goe, {
      match: o,
      routeContext: {
        outlet: r,
        matches: t.concat(n.slice(0, I + 1))
      }
    }, s ? a : o.route.element !== void 0 ? o.route.element : r);
    return i && (o.route.errorElement || I === 0) ? /* @__PURE__ */ Y.createElement(foe, {
      location: i.location,
      component: a,
      error: s,
      children: d()
    }) : d();
  }, null);
}
var k9;
(function(e) {
  e.UseRevalidator = "useRevalidator";
})(k9 || (k9 = {}));
var rY;
(function(e) {
  e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator";
})(rY || (rY = {}));
function Woe(e) {
  let t = Y.useContext(bw);
  return t || Yg(!1), t;
}
function Soe() {
  var e;
  let t = Y.useContext(b4), i = Woe(rY.UseRouteError), n = Y.useContext(Pu), g = n.matches[n.matches.length - 1];
  return t || (n || Yg(!1), g.route.id || Yg(!1), (e = i.errors) == null ? void 0 : e[g.route.id]);
}
function iDt(e) {
  let {
    to: t,
    replace: i,
    state: n,
    relative: g
  } = e;
  zu() || Yg(!1);
  let r = Y.useContext(bw), o = ha();
  return Y.useEffect(() => {
    r && r.navigation.state !== "idle" || o(t, {
      replace: i,
      state: n,
      relative: g
    });
  }), null;
}
function nDt(e) {
  return poe(e.context);
}
function oY(e) {
  Yg(!1);
}
function Voe(e) {
  let {
    basename: t = "/",
    children: i = null,
    location: n,
    navigationType: g = Gd.Pop,
    navigator: r,
    static: o = !1
  } = e;
  zu() && Yg(!1);
  let I = t.replace(/^\/*/, "/"), s = Y.useMemo(() => ({
    basename: I,
    navigator: r,
    static: o
  }), [I, r, o]);
  typeof n == "string" && (n = Uu(n));
  let {
    pathname: a = "/",
    search: d = "",
    hash: C = "",
    state: u = null,
    key: A = "default"
  } = n, m = Y.useMemo(() => {
    let h = C4(a, I);
    return h == null ? null : {
      pathname: h,
      search: d,
      hash: C,
      state: u,
      key: A
    };
  }, [I, a, d, C, u, A]);
  return m == null ? null : /* @__PURE__ */ Y.createElement(G5.Provider, {
    value: s
  }, /* @__PURE__ */ Y.createElement(mw.Provider, {
    children: i,
    value: {
      location: m,
      navigationType: g
    }
  }));
}
function woe(e) {
  let {
    children: t,
    location: i
  } = e, n = Y.useContext(boe), g = n && !t ? n.router.routes : IY(t);
  return Boe(g, i);
}
var F9;
(function(e) {
  e[e.pending = 0] = "pending", e[e.success = 1] = "success", e[e.error = 2] = "error";
})(F9 || (F9 = {}));
new Promise(() => {
});
function IY(e, t) {
  t === void 0 && (t = []);
  let i = [];
  return Y.Children.forEach(e, (n, g) => {
    if (!/* @__PURE__ */ Y.isValidElement(n))
      return;
    if (n.type === Y.Fragment) {
      i.push.apply(i, IY(n.props.children, t));
      return;
    }
    n.type !== oY && Yg(!1), !n.props.index || !n.props.children || Yg(!1);
    let r = [...t, g], o = {
      id: n.props.id || r.join("-"),
      caseSensitive: n.props.caseSensitive,
      element: n.props.element,
      index: n.props.index,
      path: n.props.path,
      loader: n.props.loader,
      action: n.props.action,
      errorElement: n.props.errorElement,
      hasErrorBoundary: n.props.errorElement != null,
      shouldRevalidate: n.props.shouldRevalidate,
      handle: n.props.handle
    };
    n.props.children && (o.children = IY(n.props.children, r)), i.push(o);
  }), i;
}
/**
 * React Router DOM v6.4.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function SS() {
  return SS = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, SS.apply(this, arguments);
}
function m4(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), g, r;
  for (r = 0; r < n.length; r++)
    g = n[r], !(t.indexOf(g) >= 0) && (i[g] = e[g]);
  return i;
}
function voe(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Roe(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !voe(e);
}
const Xoe = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset"], Hoe = ["aria-current", "caseSensitive", "className", "end", "style", "to", "children"];
function koe(e) {
  let {
    basename: t,
    children: i,
    window: n
  } = e, g = Y.useRef();
  g.current == null && (g.current = Lre({
    window: n,
    v5Compat: !0
  }));
  let r = g.current, [o, I] = Y.useState({
    action: r.action,
    location: r.location
  });
  return Y.useLayoutEffect(() => r.listen(I), [r]), /* @__PURE__ */ Y.createElement(Voe, {
    basename: t,
    children: i,
    location: o.location,
    navigationType: o.action,
    navigator: r
  });
}
const S5 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  let {
    onClick: n,
    relative: g,
    reloadDocument: r,
    replace: o,
    state: I,
    target: s,
    to: a,
    preventScrollReset: d
  } = t, C = m4(t, Xoe), u = moe(a, {
    relative: g
  }), A = Foe(a, {
    replace: o,
    state: I,
    target: s,
    preventScrollReset: d,
    relative: g
  });
  function m(h) {
    n && n(h), h.defaultPrevented || A(h);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ Y.createElement("a", SS({}, C, {
      href: u,
      onClick: r ? n : m,
      ref: i,
      target: s
    }))
  );
}), gDt = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  let {
    "aria-current": n = "page",
    caseSensitive: g = !1,
    className: r = "",
    end: o = !1,
    style: I,
    to: s,
    children: a
  } = t, d = m4(t, Hoe), C = W5(s, {
    relative: d.relative
  }), u = Ud(), A = Y.useContext(bw), m = C.pathname, h = u.pathname, B = A && A.navigation && A.navigation.location ? A.navigation.location.pathname : null;
  g || (h = h.toLowerCase(), B = B ? B.toLowerCase() : null, m = m.toLowerCase());
  let f = h === m || !o && h.startsWith(m) && h.charAt(m.length) === "/", G = B != null && (B === m || !o && B.startsWith(m) && B.charAt(m.length) === "/"), y = f ? n : void 0, W;
  typeof r == "function" ? W = r({
    isActive: f,
    isPending: G
  }) : W = [r, f ? "active" : null, G ? "pending" : null].filter(Boolean).join(" ");
  let V = typeof I == "function" ? I({
    isActive: f,
    isPending: G
  }) : I;
  return /* @__PURE__ */ Y.createElement(S5, SS({}, d, {
    "aria-current": y,
    className: W,
    ref: i,
    style: V,
    to: s
  }), typeof a == "function" ? a({
    isActive: f,
    isPending: G
  }) : a);
});
var Y9;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmitImpl = "useSubmitImpl", e.UseFetcher = "useFetcher";
})(Y9 || (Y9 = {}));
var x9;
(function(e) {
  e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(x9 || (x9 = {}));
function Foe(e, t) {
  let {
    target: i,
    replace: n,
    state: g,
    preventScrollReset: r,
    relative: o
  } = t === void 0 ? {} : t, I = ha(), s = Ud(), a = W5(e, {
    relative: o
  });
  return Y.useCallback((d) => {
    if (Roe(d, i)) {
      d.preventDefault();
      let C = n !== void 0 ? n : EB(s) === EB(a);
      I(e, {
        replace: C,
        state: g,
        preventScrollReset: r,
        relative: o
      });
    }
  }, [s, I, a, n, g, i, e, r, o]);
}
const NB = {
  black: "#000",
  white: "#fff"
}, Xb = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Hb = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, kb = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Fb = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Yb = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, A0 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, h4 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function sa(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let i = 1; i < arguments.length; i += 1)
    t += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const Yoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sa
}, Symbol.toStringTag, { value: "Module" })), Hu = "$$material";
function Ue(e, t) {
  if (e == null)
    return {};
  var i = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      i[n] = e[n];
    }
  return i;
}
var p4 = { exports: {} }, xoe = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Doe = xoe, Joe = Doe;
function B4() {
}
function Z4() {
}
Z4.resetWarningCache = B4;
var Koe = function() {
  function e(n, g, r, o, I, s) {
    if (s !== Joe) {
      var a = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw a.name = "Invariant Violation", a;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var i = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: Z4,
    resetWarningCache: B4
  };
  return i.PropTypes = i, i;
};
p4.exports = Koe();
var hw = p4.exports;
const rDt = /* @__PURE__ */ Tr(hw);
let lY;
typeof document == "object" && (lY = t4({
  key: "css",
  prepend: !0
}));
function Eoe(e) {
  const {
    injectFirst: t,
    children: i
  } = e;
  return t && lY ? /* @__PURE__ */ ne(_ne, {
    value: lY,
    children: i
  }) : i;
}
function Noe(e) {
  return e == null || Object.keys(e).length === 0;
}
function f4(e) {
  const {
    styles: t,
    defaultTheme: i = {}
  } = e;
  return /* @__PURE__ */ ne($ne, {
    styles: typeof t == "function" ? (g) => t(Noe(g) ? i : g) : t
  });
}
function V5(e, t) {
  return tge(e, t);
}
const G4 = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, Loe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: f4,
  StyledEngineProvider: Eoe,
  ThemeContext: c5,
  css: Fd,
  default: V5,
  internal_processStyles: G4,
  keyframes: Zs
}, Symbol.toStringTag, { value: "Module" }));
function cc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function y4(e) {
  if (!cc(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((i) => {
    t[i] = y4(e[i]);
  }), t;
}
function dr(e, t, i = {
  clone: !0
}) {
  const n = i.clone ? k({}, e) : e;
  return cc(e) && cc(t) && Object.keys(t).forEach((g) => {
    g !== "__proto__" && (cc(t[g]) && g in e && cc(e[g]) ? n[g] = dr(e[g], t[g], i) : i.clone ? n[g] = cc(t[g]) ? y4(t[g]) : t[g] : n[g] = t[g]);
  }), n;
}
const Toe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dr,
  isPlainObject: cc
}, Symbol.toStringTag, { value: "Module" })), Moe = ["values", "unit", "step"], Uoe = (e) => {
  const t = Object.keys(e).map((i) => ({
    key: i,
    val: e[i]
  })) || [];
  return t.sort((i, n) => i.val - n.val), t.reduce((i, n) => k({}, i, {
    [n.key]: n.val
  }), {});
};
function W4(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: i = "px",
    step: n = 5
  } = e, g = Ue(e, Moe), r = Uoe(t), o = Object.keys(r);
  function I(u) {
    return `@media (min-width:${typeof t[u] == "number" ? t[u] : u}${i})`;
  }
  function s(u) {
    return `@media (max-width:${(typeof t[u] == "number" ? t[u] : u) - n / 100}${i})`;
  }
  function a(u, A) {
    const m = o.indexOf(A);
    return `@media (min-width:${typeof t[u] == "number" ? t[u] : u}${i}) and (max-width:${(m !== -1 && typeof t[o[m]] == "number" ? t[o[m]] : A) - n / 100}${i})`;
  }
  function d(u) {
    return o.indexOf(u) + 1 < o.length ? a(u, o[o.indexOf(u) + 1]) : I(u);
  }
  function C(u) {
    const A = o.indexOf(u);
    return A === 0 ? I(o[1]) : A === o.length - 1 ? s(o[A]) : a(u, o[o.indexOf(u) + 1]).replace("@media", "@media not all and");
  }
  return k({
    keys: o,
    values: r,
    up: I,
    down: s,
    between: a,
    only: d,
    not: C,
    unit: i
  }, g);
}
const Poe = {
  borderRadius: 4
};
function lB(e, t) {
  return t ? dr(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const w5 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, D9 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${w5[e]}px)`
};
function As(e, t, i) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const r = n.breakpoints || D9;
    return t.reduce((o, I, s) => (o[r.up(r.keys[s])] = i(t[s]), o), {});
  }
  if (typeof t == "object") {
    const r = n.breakpoints || D9;
    return Object.keys(t).reduce((o, I) => {
      if (Object.keys(r.values || w5).indexOf(I) !== -1) {
        const s = r.up(I);
        o[s] = i(t[I], I);
      } else {
        const s = I;
        o[s] = t[s];
      }
      return o;
    }, {});
  }
  return i(t);
}
function S4(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, g) => {
    const r = e.up(g);
    return n[r] = {}, n;
  }, {})) || {};
}
function V4(e, t) {
  return e.reduce((i, n) => {
    const g = i[n];
    return (!g || Object.keys(g).length === 0) && delete i[n], i;
  }, t);
}
function zoe(e, ...t) {
  const i = S4(e), n = [i, ...t].reduce((g, r) => dr(g, r), {});
  return V4(Object.keys(i), n);
}
function Ooe(e, t) {
  if (typeof e != "object")
    return {};
  const i = {}, n = Object.keys(t);
  return Array.isArray(e) ? n.forEach((g, r) => {
    r < e.length && (i[g] = !0);
  }) : n.forEach((g) => {
    e[g] != null && (i[g] = !0);
  }), i;
}
function tk({
  values: e,
  breakpoints: t,
  base: i
}) {
  const n = i || Ooe(e, t), g = Object.keys(n);
  if (g.length === 0)
    return e;
  let r;
  return g.reduce((o, I, s) => (Array.isArray(e) ? (o[I] = e[s] != null ? e[s] : e[r], r = s) : typeof e == "object" ? (o[I] = e[I] != null ? e[I] : e[r], r = I) : o[I] = e, o), {});
}
function Re(e) {
  if (typeof e != "string")
    throw new Error(sa(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Qoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Re
}, Symbol.toStringTag, { value: "Module" }));
function ym(e, t, i = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && i) {
    const n = `vars.${t}`.split(".").reduce((g, r) => g && g[r] ? g[r] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, g) => n && n[g] != null ? n[g] : null, e);
}
function VS(e, t, i, n = i) {
  let g;
  return typeof e == "function" ? g = e(i) : Array.isArray(e) ? g = e[i] || n : g = ym(e, i) || n, t && (g = t(g, n, e)), g;
}
function Wg(e) {
  const {
    prop: t,
    cssProperty: i = e.prop,
    themeKey: n,
    transform: g
  } = e, r = (o) => {
    if (o[t] == null)
      return null;
    const I = o[t], s = o.theme, a = ym(s, n) || {};
    return As(o, I, (C) => {
      let u = VS(a, g, C);
      return C === u && typeof C == "string" && (u = VS(a, g, `${t}${C === "default" ? "" : Re(C)}`, C)), i === !1 ? u : {
        [i]: u
      };
    });
  };
  return r.propTypes = {}, r.filterProps = [t], r;
}
function joe(e) {
  const t = {};
  return (i) => (t[i] === void 0 && (t[i] = e(i)), t[i]);
}
const _oe = {
  m: "margin",
  p: "padding"
}, $oe = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, J9 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, qoe = joe((e) => {
  if (e.length > 2)
    if (J9[e])
      e = J9[e];
    else
      return [e];
  const [t, i] = e.split(""), n = _oe[t], g = $oe[i] || "";
  return Array.isArray(g) ? g.map((r) => n + r) : [n + g];
}), v5 = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], R5 = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...v5, ...R5];
function fZ(e, t, i, n) {
  var g;
  const r = (g = ym(e, t, !1)) != null ? g : i;
  return typeof r == "number" ? (o) => typeof o == "string" ? o : r * o : Array.isArray(r) ? (o) => typeof o == "string" ? o : r[o] : typeof r == "function" ? r : () => {
  };
}
function X5(e) {
  return fZ(e, "spacing", 8);
}
function ku(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const i = Math.abs(t), n = e(i);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function eIe(e, t) {
  return (i) => e.reduce((n, g) => (n[g] = ku(t, i), n), {});
}
function tIe(e, t, i, n) {
  if (t.indexOf(i) === -1)
    return null;
  const g = qoe(i), r = eIe(g, n), o = e[i];
  return As(e, o, r);
}
function w4(e, t) {
  const i = X5(e.theme);
  return Object.keys(e).map((n) => tIe(e, t, n, i)).reduce(lB, {});
}
function sg(e) {
  return w4(e, v5);
}
sg.propTypes = {};
sg.filterProps = v5;
function ag(e) {
  return w4(e, R5);
}
ag.propTypes = {};
ag.filterProps = R5;
function iIe(e = 8) {
  if (e.mui)
    return e;
  const t = X5({
    spacing: e
  }), i = (...n) => (n.length === 0 ? [1] : n).map((r) => {
    const o = t(r);
    return typeof o == "number" ? `${o}px` : o;
  }).join(" ");
  return i.mui = !0, i;
}
function pw(...e) {
  const t = e.reduce((n, g) => (g.filterProps.forEach((r) => {
    n[r] = g;
  }), n), {}), i = (n) => Object.keys(n).reduce((g, r) => t[r] ? lB(g, t[r](n)) : g, {});
  return i.propTypes = {}, i.filterProps = e.reduce((n, g) => n.concat(g.filterProps), []), i;
}
function cl(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Vl(e, t) {
  return Wg({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const nIe = Vl("border", cl), gIe = Vl("borderTop", cl), rIe = Vl("borderRight", cl), oIe = Vl("borderBottom", cl), IIe = Vl("borderLeft", cl), lIe = Vl("borderColor"), sIe = Vl("borderTopColor"), aIe = Vl("borderRightColor"), cIe = Vl("borderBottomColor"), dIe = Vl("borderLeftColor"), CIe = Vl("outline", cl), uIe = Vl("outlineColor"), Bw = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = fZ(e.theme, "shape.borderRadius", 4), i = (n) => ({
      borderRadius: ku(t, n)
    });
    return As(e, e.borderRadius, i);
  }
  return null;
};
Bw.propTypes = {};
Bw.filterProps = ["borderRadius"];
pw(nIe, gIe, rIe, oIe, IIe, lIe, sIe, aIe, cIe, dIe, Bw, CIe, uIe);
const Zw = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = fZ(e.theme, "spacing", 8), i = (n) => ({
      gap: ku(t, n)
    });
    return As(e, e.gap, i);
  }
  return null;
};
Zw.propTypes = {};
Zw.filterProps = ["gap"];
const fw = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = fZ(e.theme, "spacing", 8), i = (n) => ({
      columnGap: ku(t, n)
    });
    return As(e, e.columnGap, i);
  }
  return null;
};
fw.propTypes = {};
fw.filterProps = ["columnGap"];
const Gw = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = fZ(e.theme, "spacing", 8), i = (n) => ({
      rowGap: ku(t, n)
    });
    return As(e, e.rowGap, i);
  }
  return null;
};
Gw.propTypes = {};
Gw.filterProps = ["rowGap"];
const AIe = Wg({
  prop: "gridColumn"
}), bIe = Wg({
  prop: "gridRow"
}), mIe = Wg({
  prop: "gridAutoFlow"
}), hIe = Wg({
  prop: "gridAutoColumns"
}), pIe = Wg({
  prop: "gridAutoRows"
}), BIe = Wg({
  prop: "gridTemplateColumns"
}), ZIe = Wg({
  prop: "gridTemplateRows"
}), fIe = Wg({
  prop: "gridTemplateAreas"
}), GIe = Wg({
  prop: "gridArea"
});
pw(Zw, fw, Gw, AIe, bIe, mIe, hIe, pIe, BIe, ZIe, fIe, GIe);
function mm(e, t) {
  return t === "grey" ? t : e;
}
const yIe = Wg({
  prop: "color",
  themeKey: "palette",
  transform: mm
}), WIe = Wg({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: mm
}), SIe = Wg({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: mm
});
pw(yIe, WIe, SIe);
function pI(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const VIe = Wg({
  prop: "width",
  transform: pI
}), H5 = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (i) => {
      var n, g;
      const r = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[i]) || w5[i];
      return r ? ((g = e.theme) == null || (g = g.breakpoints) == null ? void 0 : g.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: pI(i)
      };
    };
    return As(e, e.maxWidth, t);
  }
  return null;
};
H5.filterProps = ["maxWidth"];
const wIe = Wg({
  prop: "minWidth",
  transform: pI
}), vIe = Wg({
  prop: "height",
  transform: pI
}), RIe = Wg({
  prop: "maxHeight",
  transform: pI
}), XIe = Wg({
  prop: "minHeight",
  transform: pI
});
Wg({
  prop: "size",
  cssProperty: "width",
  transform: pI
});
Wg({
  prop: "size",
  cssProperty: "height",
  transform: pI
});
const HIe = Wg({
  prop: "boxSizing"
});
pw(VIe, H5, wIe, vIe, RIe, XIe, HIe);
const GZ = {
  // borders
  border: {
    themeKey: "borders",
    transform: cl
  },
  borderTop: {
    themeKey: "borders",
    transform: cl
  },
  borderRight: {
    themeKey: "borders",
    transform: cl
  },
  borderBottom: {
    themeKey: "borders",
    transform: cl
  },
  borderLeft: {
    themeKey: "borders",
    transform: cl
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: cl
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Bw
  },
  // palette
  color: {
    themeKey: "palette",
    transform: mm
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: mm
  },
  backgroundColor: {
    themeKey: "palette",
    transform: mm
  },
  // spacing
  p: {
    style: ag
  },
  pt: {
    style: ag
  },
  pr: {
    style: ag
  },
  pb: {
    style: ag
  },
  pl: {
    style: ag
  },
  px: {
    style: ag
  },
  py: {
    style: ag
  },
  padding: {
    style: ag
  },
  paddingTop: {
    style: ag
  },
  paddingRight: {
    style: ag
  },
  paddingBottom: {
    style: ag
  },
  paddingLeft: {
    style: ag
  },
  paddingX: {
    style: ag
  },
  paddingY: {
    style: ag
  },
  paddingInline: {
    style: ag
  },
  paddingInlineStart: {
    style: ag
  },
  paddingInlineEnd: {
    style: ag
  },
  paddingBlock: {
    style: ag
  },
  paddingBlockStart: {
    style: ag
  },
  paddingBlockEnd: {
    style: ag
  },
  m: {
    style: sg
  },
  mt: {
    style: sg
  },
  mr: {
    style: sg
  },
  mb: {
    style: sg
  },
  ml: {
    style: sg
  },
  mx: {
    style: sg
  },
  my: {
    style: sg
  },
  margin: {
    style: sg
  },
  marginTop: {
    style: sg
  },
  marginRight: {
    style: sg
  },
  marginBottom: {
    style: sg
  },
  marginLeft: {
    style: sg
  },
  marginX: {
    style: sg
  },
  marginY: {
    style: sg
  },
  marginInline: {
    style: sg
  },
  marginInlineStart: {
    style: sg
  },
  marginInlineEnd: {
    style: sg
  },
  marginBlock: {
    style: sg
  },
  marginBlockStart: {
    style: sg
  },
  marginBlockEnd: {
    style: sg
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Zw
  },
  rowGap: {
    style: Gw
  },
  columnGap: {
    style: fw
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: pI
  },
  maxWidth: {
    style: H5
  },
  minWidth: {
    transform: pI
  },
  height: {
    transform: pI
  },
  maxHeight: {
    transform: pI
  },
  minHeight: {
    transform: pI
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function kIe(...e) {
  const t = e.reduce((n, g) => n.concat(Object.keys(g)), []), i = new Set(t);
  return e.every((n) => i.size === Object.keys(n).length);
}
function FIe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function v4() {
  function e(i, n, g, r) {
    const o = {
      [i]: n,
      theme: g
    }, I = r[i];
    if (!I)
      return {
        [i]: n
      };
    const {
      cssProperty: s = i,
      themeKey: a,
      transform: d,
      style: C
    } = I;
    if (n == null)
      return null;
    if (a === "typography" && n === "inherit")
      return {
        [i]: n
      };
    const u = ym(g, a) || {};
    return C ? C(o) : As(o, n, (m) => {
      let h = VS(u, d, m);
      return m === h && typeof m == "string" && (h = VS(u, d, `${i}${m === "default" ? "" : Re(m)}`, m)), s === !1 ? h : {
        [s]: h
      };
    });
  }
  function t(i) {
    var n;
    const {
      sx: g,
      theme: r = {}
    } = i || {};
    if (!g)
      return null;
    const o = (n = r.unstable_sxConfig) != null ? n : GZ;
    function I(s) {
      let a = s;
      if (typeof s == "function")
        a = s(r);
      else if (typeof s != "object")
        return s;
      if (!a)
        return null;
      const d = S4(r.breakpoints), C = Object.keys(d);
      let u = d;
      return Object.keys(a).forEach((A) => {
        const m = FIe(a[A], r);
        if (m != null)
          if (typeof m == "object")
            if (o[A])
              u = lB(u, e(A, m, r, o));
            else {
              const h = As({
                theme: r
              }, m, (B) => ({
                [A]: B
              }));
              kIe(h, m) ? u[A] = t({
                sx: m,
                theme: r
              }) : u = lB(u, h);
            }
          else
            u = lB(u, e(A, m, r, o));
      }), V4(C, u);
    }
    return Array.isArray(g) ? g.map(I) : I(g);
  }
  return t;
}
const zm = v4();
zm.filterProps = ["sx"];
function R4(e, t) {
  const i = this;
  return i.vars && typeof i.getColorSchemeSelector == "function" ? {
    [i.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : i.palette.mode === e ? t : {};
}
const YIe = ["breakpoints", "palette", "spacing", "shape"];
function yZ(e = {}, ...t) {
  const {
    breakpoints: i = {},
    palette: n = {},
    spacing: g,
    shape: r = {}
  } = e, o = Ue(e, YIe), I = W4(i), s = iIe(g);
  let a = dr({
    breakpoints: I,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: k({
      mode: "light"
    }, n),
    spacing: s,
    shape: k({}, Poe, r)
  }, o);
  return a.applyStyles = R4, a = t.reduce((d, C) => dr(d, C), a), a.unstable_sxConfig = k({}, GZ, o == null ? void 0 : o.unstable_sxConfig), a.unstable_sx = function(C) {
    return zm({
      sx: C,
      theme: this
    });
  }, a;
}
const xIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yZ,
  private_createBreakpoints: W4,
  unstable_applyStyles: R4
}, Symbol.toStringTag, { value: "Module" }));
function DIe(e) {
  return Object.keys(e).length === 0;
}
function k5(e = null) {
  const t = Y.useContext(c5);
  return !t || DIe(t) ? e : t;
}
const JIe = yZ();
function yw(e = JIe) {
  return k5(e);
}
function KIe({
  styles: e,
  themeId: t,
  defaultTheme: i = {}
}) {
  const n = yw(i), g = typeof e == "function" ? e(t && n[t] || n) : e;
  return /* @__PURE__ */ ne(f4, {
    styles: g
  });
}
const EIe = ["sx"], NIe = (e) => {
  var t, i;
  const n = {
    systemProps: {},
    otherProps: {}
  }, g = (t = e == null || (i = e.theme) == null ? void 0 : i.unstable_sxConfig) != null ? t : GZ;
  return Object.keys(e).forEach((r) => {
    g[r] ? n.systemProps[r] = e[r] : n.otherProps[r] = e[r];
  }), n;
};
function Ww(e) {
  const {
    sx: t
  } = e, i = Ue(e, EIe), {
    systemProps: n,
    otherProps: g
  } = NIe(i);
  let r;
  return Array.isArray(t) ? r = [n, ...t] : typeof t == "function" ? r = (...o) => {
    const I = t(...o);
    return cc(I) ? k({}, n, I) : n;
  } : r = k({}, n, t), k({}, g, {
    sx: r
  });
}
const LIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zm,
  extendSxProp: Ww,
  unstable_createStyleFunctionSx: v4,
  unstable_defaultSxConfig: GZ
}, Symbol.toStringTag, { value: "Module" })), K9 = (e) => e, TIe = () => {
  let e = K9;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = K9;
    }
  };
}, Sw = TIe();
function X4(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var g = e.length;
      for (t = 0; t < g; t++)
        e[t] && (i = X4(e[t])) && (n && (n += " "), n += i);
    } else
      for (i in e)
        e[i] && (n && (n += " "), n += i);
  return n;
}
function Ve() {
  for (var e, t, i = 0, n = "", g = arguments.length; i < g; i++)
    (e = arguments[i]) && (t = X4(e)) && (n && (n += " "), n += t);
  return n;
}
const MIe = ["className", "component"];
function H4(e = {}) {
  const {
    themeId: t,
    defaultTheme: i,
    defaultClassName: n = "MuiBox-root",
    generateClassName: g
  } = e, r = V5("div", {
    shouldForwardProp: (I) => I !== "theme" && I !== "sx" && I !== "as"
  })(zm);
  return /* @__PURE__ */ Y.forwardRef(function(s, a) {
    const d = yw(i), C = Ww(s), {
      className: u,
      component: A = "div"
    } = C, m = Ue(C, MIe);
    return /* @__PURE__ */ ne(r, k({
      as: A,
      ref: a,
      className: Ve(u, g ? g(n) : n),
      theme: t && d[t] || d
    }, m));
  });
}
const k4 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function St(e, t, i = "Mui") {
  const n = k4[t];
  return n ? `${i}-${n}` : `${Sw.generate(e)}-${t}`;
}
function Wt(e, t, i = "Mui") {
  const n = {};
  return t.forEach((g) => {
    n[g] = St(e, g, i);
  }), n;
}
const UIe = Wt("MuiBox", ["root"]), Cc = H4({
  defaultClassName: UIe.root,
  generateClassName: Sw.generate
});
var F4 = { exports: {} }, Gn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F5 = Symbol.for("react.element"), Y5 = Symbol.for("react.portal"), Vw = Symbol.for("react.fragment"), ww = Symbol.for("react.strict_mode"), vw = Symbol.for("react.profiler"), Rw = Symbol.for("react.provider"), Xw = Symbol.for("react.context"), PIe = Symbol.for("react.server_context"), Hw = Symbol.for("react.forward_ref"), kw = Symbol.for("react.suspense"), Fw = Symbol.for("react.suspense_list"), Yw = Symbol.for("react.memo"), xw = Symbol.for("react.lazy"), zIe = Symbol.for("react.offscreen"), Y4;
Y4 = Symbol.for("react.module.reference");
function wl(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case F5:
        switch (e = e.type, e) {
          case Vw:
          case vw:
          case ww:
          case kw:
          case Fw:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case PIe:
              case Xw:
              case Hw:
              case xw:
              case Yw:
              case Rw:
                return e;
              default:
                return t;
            }
        }
      case Y5:
        return t;
    }
  }
}
Gn.ContextConsumer = Xw;
Gn.ContextProvider = Rw;
Gn.Element = F5;
Gn.ForwardRef = Hw;
Gn.Fragment = Vw;
Gn.Lazy = xw;
Gn.Memo = Yw;
Gn.Portal = Y5;
Gn.Profiler = vw;
Gn.StrictMode = ww;
Gn.Suspense = kw;
Gn.SuspenseList = Fw;
Gn.isAsyncMode = function() {
  return !1;
};
Gn.isConcurrentMode = function() {
  return !1;
};
Gn.isContextConsumer = function(e) {
  return wl(e) === Xw;
};
Gn.isContextProvider = function(e) {
  return wl(e) === Rw;
};
Gn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === F5;
};
Gn.isForwardRef = function(e) {
  return wl(e) === Hw;
};
Gn.isFragment = function(e) {
  return wl(e) === Vw;
};
Gn.isLazy = function(e) {
  return wl(e) === xw;
};
Gn.isMemo = function(e) {
  return wl(e) === Yw;
};
Gn.isPortal = function(e) {
  return wl(e) === Y5;
};
Gn.isProfiler = function(e) {
  return wl(e) === vw;
};
Gn.isStrictMode = function(e) {
  return wl(e) === ww;
};
Gn.isSuspense = function(e) {
  return wl(e) === kw;
};
Gn.isSuspenseList = function(e) {
  return wl(e) === Fw;
};
Gn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Vw || e === vw || e === ww || e === kw || e === Fw || e === zIe || typeof e == "object" && e !== null && (e.$$typeof === xw || e.$$typeof === Yw || e.$$typeof === Rw || e.$$typeof === Xw || e.$$typeof === Hw || e.$$typeof === Y4 || e.getModuleId !== void 0);
};
Gn.typeOf = wl;
F4.exports = Gn;
var E9 = F4.exports;
const OIe = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function x4(e) {
  const t = `${e}`.match(OIe);
  return t && t[1] || "";
}
function D4(e, t = "") {
  return e.displayName || e.name || x4(e) || t;
}
function N9(e, t, i) {
  const n = D4(t);
  return e.displayName || (n !== "" ? `${i}(${n})` : i);
}
function QIe(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return D4(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case E9.ForwardRef:
          return N9(e, e.render, "ForwardRef");
        case E9.Memo:
          return N9(e, e.type, "memo");
        default:
          return;
      }
  }
}
const jIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: QIe,
  getFunctionName: x4
}, Symbol.toStringTag, { value: "Module" })), _Ie = ["ownerState"], $Ie = ["variants"], qIe = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function ele(e) {
  return Object.keys(e).length === 0;
}
function tle(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function ik(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ile = yZ(), nle = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Ly({
  defaultTheme: e,
  theme: t,
  themeId: i
}) {
  return ele(t) ? e : t[i] || t;
}
function gle(e) {
  return e ? (t, i) => i[e] : null;
}
function gS(e, t) {
  let {
    ownerState: i
  } = t, n = Ue(t, _Ie);
  const g = typeof e == "function" ? e(k({
    ownerState: i
  }, n)) : e;
  if (Array.isArray(g))
    return g.flatMap((r) => gS(r, k({
      ownerState: i
    }, n)));
  if (g && typeof g == "object" && Array.isArray(g.variants)) {
    const {
      variants: r = []
    } = g;
    let I = Ue(g, $Ie);
    return r.forEach((s) => {
      let a = !0;
      typeof s.props == "function" ? a = s.props(k({
        ownerState: i
      }, n, i)) : Object.keys(s.props).forEach((d) => {
        (i == null ? void 0 : i[d]) !== s.props[d] && n[d] !== s.props[d] && (a = !1);
      }), a && (Array.isArray(I) || (I = [I]), I.push(typeof s.style == "function" ? s.style(k({
        ownerState: i
      }, n, i)) : s.style));
    }), I;
  }
  return g;
}
function rle(e = {}) {
  const {
    themeId: t,
    defaultTheme: i = ile,
    rootShouldForwardProp: n = ik,
    slotShouldForwardProp: g = ik
  } = e, r = (o) => zm(k({}, o, {
    theme: Ly(k({}, o, {
      defaultTheme: i,
      themeId: t
    }))
  }));
  return r.__mui_systemSx = !0, (o, I = {}) => {
    G4(o, (V) => V.filter((w) => !(w != null && w.__mui_systemSx)));
    const {
      name: s,
      slot: a,
      skipVariantsResolver: d,
      skipSx: C,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: u = gle(nle(a))
    } = I, A = Ue(I, qIe), m = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      a && a !== "Root" && a !== "root" || !1
    ), h = C || !1;
    let B, f = ik;
    a === "Root" || a === "root" ? f = n : a ? f = g : tle(o) && (f = void 0);
    const G = V5(o, k({
      shouldForwardProp: f,
      label: B
    }, A)), y = (V) => typeof V == "function" && V.__emotion_real !== V || cc(V) ? (w) => gS(V, k({}, w, {
      theme: Ly({
        theme: w.theme,
        defaultTheme: i,
        themeId: t
      })
    })) : V, W = (V, ...w) => {
      let v = y(V);
      const H = w ? w.map(y) : [];
      s && u && H.push((M) => {
        const $ = Ly(k({}, M, {
          defaultTheme: i,
          themeId: t
        }));
        if (!$.components || !$.components[s] || !$.components[s].styleOverrides)
          return null;
        const q = $.components[s].styleOverrides, E = {};
        return Object.entries(q).forEach(([L, P]) => {
          E[L] = gS(P, k({}, M, {
            theme: $
          }));
        }), u(M, E);
      }), s && !m && H.push((M) => {
        var $;
        const q = Ly(k({}, M, {
          defaultTheme: i,
          themeId: t
        })), E = q == null || ($ = q.components) == null || ($ = $[s]) == null ? void 0 : $.variants;
        return gS({
          variants: E
        }, k({}, M, {
          theme: q
        }));
      }), h || H.push(r);
      const x = H.length - w.length;
      if (Array.isArray(V) && x > 0) {
        const M = new Array(x).fill("");
        v = [...V, ...M], v.raw = [...V.raw, ...M];
      }
      const N = G(v, ...H);
      return o.muiName && (N.muiName = o.muiName), N;
    };
    return G.withConfig && (W.withConfig = G.withConfig), W;
  };
}
const ole = rle();
function Dw(e, t) {
  const i = k({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      i[n] = k({}, e[n], i[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const g = e[n] || {}, r = t[n];
      i[n] = {}, !r || !Object.keys(r) ? i[n] = g : !g || !Object.keys(g) ? i[n] = r : (i[n] = k({}, r), Object.keys(g).forEach((o) => {
        i[n][o] = Dw(g[o], r[o]);
      }));
    } else
      i[n] === void 0 && (i[n] = e[n]);
  }), i;
}
function J4(e) {
  const {
    theme: t,
    name: i,
    props: n
  } = e;
  return !t || !t.components || !t.components[i] || !t.components[i].defaultProps ? n : Dw(t.components[i].defaultProps, n);
}
function K4({
  props: e,
  name: t,
  defaultTheme: i,
  themeId: n
}) {
  let g = yw(i);
  return n && (g = g[n] || g), J4({
    theme: g,
    name: t,
    props: e
  });
}
const eo = typeof window < "u" ? Y.useLayoutEffect : Y.useEffect;
function Ile(e, t, i, n, g) {
  const [r, o] = Y.useState(() => g && i ? i(e).matches : n ? n(e).matches : t);
  return eo(() => {
    let I = !0;
    if (!i)
      return;
    const s = i(e), a = () => {
      I && o(s.matches);
    };
    return a(), s.addListener(a), () => {
      I = !1, s.removeListener(a);
    };
  }, [e, i]), r;
}
const E4 = Y.useSyncExternalStore;
function lle(e, t, i, n, g) {
  const r = Y.useCallback(() => t, [t]), o = Y.useMemo(() => {
    if (g && i)
      return () => i(e).matches;
    if (n !== null) {
      const {
        matches: d
      } = n(e);
      return () => d;
    }
    return r;
  }, [r, e, n, g, i]), [I, s] = Y.useMemo(() => {
    if (i === null)
      return [r, () => () => {
      }];
    const d = i(e);
    return [() => d.matches, (C) => (d.addListener(C), () => {
      d.removeListener(C);
    })];
  }, [r, i, e]);
  return E4(s, I, o);
}
function N4(e, t = {}) {
  const i = k5(), n = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: g = !1,
    matchMedia: r = n ? window.matchMedia : null,
    ssrMatchMedia: o = null,
    noSsr: I = !1
  } = J4({
    name: "MuiUseMediaQuery",
    props: t,
    theme: i
  });
  let s = typeof e == "function" ? e(i) : e;
  return s = s.replace(/^@media( ?)/m, ""), (E4 !== void 0 ? lle : Ile)(s, g, r, o, I);
}
function bu(e, t = Number.MIN_SAFE_INTEGER, i = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, i));
}
const sle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bu
}, Symbol.toStringTag, { value: "Module" }));
function x5(e, t = 0, i = 1) {
  return bu(e, t, i);
}
function ale(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(t);
  return i && i[0].length === 1 && (i = i.map((n) => n + n)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((n, g) => g < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Jw(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Jw(ale(e));
  const t = e.indexOf("("), i = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(sa(9, e));
  let n = e.substring(t + 1, e.length - 1), g;
  if (i === "color") {
    if (n = n.split(" "), g = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(g) === -1)
      throw new Error(sa(10, g));
  } else
    n = n.split(",");
  return n = n.map((r) => parseFloat(r)), {
    type: i,
    values: n,
    colorSpace: g
  };
}
function D5(e) {
  const {
    type: t,
    colorSpace: i
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((g, r) => r < 3 ? parseInt(g, 10) : g) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${i} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function M0(e, t) {
  return e = Jw(e), t = x5(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, D5(e);
}
function oDt(e, t) {
  if (e = Jw(e), t = x5(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - t;
  return D5(e);
}
function IDt(e, t) {
  if (e = Jw(e), t = x5(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * t;
  return D5(e);
}
const sY = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
function wS(...e) {
  return e.reduce((t, i) => i == null ? t : function(...g) {
    t.apply(this, g), i.apply(this, g);
  }, () => {
  });
}
function Om(e, t = 166) {
  let i;
  function n(...g) {
    const r = () => {
      e.apply(this, g);
    };
    clearTimeout(i), i = setTimeout(r, t);
  }
  return n.clear = () => {
    clearTimeout(i);
  }, n;
}
function cle(e, t) {
  return () => null;
}
function sB(e, t) {
  var i, n;
  return /* @__PURE__ */ Y.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (i = e.type.muiName) != null ? i : (n = e.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function Gg(e) {
  return e && e.ownerDocument || document;
}
function pl(e) {
  return Gg(e).defaultView || window;
}
function dle(e, t) {
  return () => null;
}
function LB(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let L9 = 0;
function Cle(e) {
  const [t, i] = Y.useState(e), n = e || t;
  return Y.useEffect(() => {
    t == null && (L9 += 1, i(`mui-${L9}`));
  }, [t]), n;
}
const T9 = Y.useId;
function Ou(e) {
  if (T9 !== void 0) {
    const t = T9();
    return e ?? t;
  }
  return Cle(e);
}
function ule(e, t, i, n, g) {
  return null;
}
function ds({
  controlled: e,
  default: t,
  name: i,
  state: n = "value"
}) {
  const {
    current: g
  } = Y.useRef(e !== void 0), [r, o] = Y.useState(t), I = g ? e : r, s = Y.useCallback((a) => {
    g || o(a);
  }, []);
  return [I, s];
}
function zg(e) {
  const t = Y.useRef(e);
  return eo(() => {
    t.current = e;
  }), Y.useRef((...i) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...i)
  )).current;
}
function gn(...e) {
  return Y.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((i) => {
      LB(i, t);
    });
  }, e);
}
const M9 = {};
function Ale(e, t) {
  const i = Y.useRef(M9);
  return i.current === M9 && (i.current = e(t)), i;
}
const ble = [];
function mle(e) {
  Y.useEffect(e, ble);
}
class WZ {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new WZ();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, i) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, i();
    }, t);
  }
}
function Zu() {
  const e = Ale(WZ.create).current;
  return mle(e.disposeEffect), e;
}
let Kw = !0, aY = !1;
const hle = new WZ(), ple = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Ble(e) {
  const {
    type: t,
    tagName: i
  } = e;
  return !!(i === "INPUT" && ple[t] && !e.readOnly || i === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Zle(e) {
  e.metaKey || e.altKey || e.ctrlKey || (Kw = !0);
}
function nk() {
  Kw = !1;
}
function fle() {
  this.visibilityState === "hidden" && aY && (Kw = !0);
}
function Gle(e) {
  e.addEventListener("keydown", Zle, !0), e.addEventListener("mousedown", nk, !0), e.addEventListener("pointerdown", nk, !0), e.addEventListener("touchstart", nk, !0), e.addEventListener("visibilitychange", fle, !0);
}
function yle(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return Kw || Ble(t);
}
function SZ() {
  const e = Y.useCallback((g) => {
    g != null && Gle(g.ownerDocument);
  }, []), t = Y.useRef(!1);
  function i() {
    return t.current ? (aY = !0, hle.start(100, () => {
      aY = !1;
    }), t.current = !1, !0) : !1;
  }
  function n(g) {
    return yle(g) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: i,
    ref: e
  };
}
function L4(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
let xb;
function T4() {
  if (xb)
    return xb;
  const e = document.createElement("div"), t = document.createElement("div");
  return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), xb = "reverse", e.scrollLeft > 0 ? xb = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (xb = "negative")), document.body.removeChild(e), xb;
}
function Wle(e, t) {
  const i = e.scrollLeft;
  if (t !== "rtl")
    return i;
  switch (T4()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + i;
    case "reverse":
      return e.scrollWidth - e.clientWidth - i;
    default:
      return i;
  }
}
const Sle = (e) => {
  const t = Y.useRef({});
  return Y.useEffect(() => {
    t.current = e;
  }), t.current;
};
function M4(e) {
  return Y.Children.toArray(e).filter((t) => /* @__PURE__ */ Y.isValidElement(t));
}
const Vle = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function Vt(e, t, i = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (g) => {
      n[g] = e[g].reduce((r, o) => {
        if (o) {
          const I = t(o);
          I !== "" && r.push(I), i && i[o] && r.push(i[o]);
        }
        return r;
      }, []).join(" ");
    }
  ), n;
}
const U4 = /* @__PURE__ */ Y.createContext(null);
function P4() {
  return Y.useContext(U4);
}
const wle = typeof Symbol == "function" && Symbol.for, vle = wle ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function Rle(e, t) {
  return typeof t == "function" ? t(e) : k({}, e, t);
}
function Xle(e) {
  const {
    children: t,
    theme: i
  } = e, n = P4(), g = Y.useMemo(() => {
    const r = n === null ? i : Rle(n, i);
    return r != null && (r[vle] = n !== null), r;
  }, [i, n]);
  return /* @__PURE__ */ ne(U4.Provider, {
    value: g,
    children: t
  });
}
const Hle = ["value"], z4 = /* @__PURE__ */ Y.createContext();
function kle(e) {
  let {
    value: t
  } = e, i = Ue(e, Hle);
  return /* @__PURE__ */ ne(z4.Provider, k({
    value: t ?? !0
  }, i));
}
const Qm = () => {
  const e = Y.useContext(z4);
  return e ?? !1;
}, U9 = {};
function P9(e, t, i, n = !1) {
  return Y.useMemo(() => {
    const g = e && t[e] || t;
    if (typeof i == "function") {
      const r = i(g), o = e ? k({}, t, {
        [e]: r
      }) : r;
      return n ? () => o : o;
    }
    return e ? k({}, t, {
      [e]: i
    }) : k({}, t, i);
  }, [e, t, i, n]);
}
function Fle(e) {
  const {
    children: t,
    theme: i,
    themeId: n
  } = e, g = k5(U9), r = P4() || U9, o = P9(n, g, i), I = P9(n, r, i, !0), s = o.direction === "rtl";
  return /* @__PURE__ */ ne(Xle, {
    theme: I,
    children: /* @__PURE__ */ ne(c5.Provider, {
      value: o,
      children: /* @__PURE__ */ ne(kle, {
        value: s,
        children: t
      })
    })
  });
}
function Cs(e) {
  "@babel/helpers - typeof";
  return Cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cs(e);
}
function Yle(e, t) {
  if (Cs(e) != "object" || !e)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(e, t || "default");
    if (Cs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function O4(e) {
  var t = Yle(e, "string");
  return Cs(t) == "symbol" ? t : t + "";
}
const xle = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], Dle = yZ(), Jle = ole("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function Kle(e) {
  return K4({
    props: e,
    name: "MuiStack",
    defaultTheme: Dle
  });
}
function Ele(e, t) {
  const i = Y.Children.toArray(e).filter(Boolean);
  return i.reduce((n, g, r) => (n.push(g), r < i.length - 1 && n.push(/* @__PURE__ */ Y.cloneElement(t, {
    key: `separator-${r}`
  })), n), []);
}
const Nle = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], Lle = ({
  ownerState: e,
  theme: t
}) => {
  let i = k({
    display: "flex",
    flexDirection: "column"
  }, As({
    theme: t
  }, tk({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (n) => ({
    flexDirection: n
  })));
  if (e.spacing) {
    const n = X5(t), g = Object.keys(t.breakpoints.values).reduce((s, a) => ((typeof e.spacing == "object" && e.spacing[a] != null || typeof e.direction == "object" && e.direction[a] != null) && (s[a] = !0), s), {}), r = tk({
      values: e.direction,
      base: g
    }), o = tk({
      values: e.spacing,
      base: g
    });
    typeof r == "object" && Object.keys(r).forEach((s, a, d) => {
      if (!r[s]) {
        const u = a > 0 ? r[d[a - 1]] : "column";
        r[s] = u;
      }
    }), i = dr(i, As({
      theme: t
    }, o, (s, a) => e.useFlexGap ? {
      gap: ku(n, s)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${Nle(a ? r[a] : e.direction)}`]: ku(n, s)
      }
    }));
  }
  return i = zoe(t.breakpoints, i), i;
};
function Tle(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = Jle,
    useThemeProps: i = Kle,
    componentName: n = "MuiStack"
  } = e, g = () => Vt({
    root: ["root"]
  }, (s) => St(n, s), {}), r = t(Lle);
  return /* @__PURE__ */ Y.forwardRef(function(s, a) {
    const d = i(s), C = Ww(d), {
      component: u = "div",
      direction: A = "column",
      spacing: m = 0,
      divider: h,
      children: B,
      className: f,
      useFlexGap: G = !1
    } = C, y = Ue(C, xle), W = {
      direction: A,
      spacing: m,
      useFlexGap: G
    }, V = g();
    return /* @__PURE__ */ ne(r, k({
      as: u,
      ownerState: W,
      ref: a,
      className: Ve(V.root, f)
    }, y, {
      children: h ? Ele(B, h) : B
    }));
  });
}
function Mle(e, t) {
  return k({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var Sg = {}, Q4 = { exports: {} };
(function(e) {
  function t(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Q4);
var Cg = Q4.exports;
const Ule = /* @__PURE__ */ yc(Yoe), Ple = /* @__PURE__ */ yc(sle);
var j4 = Cg;
Object.defineProperty(Sg, "__esModule", {
  value: !0
});
var di = Sg.alpha = eO;
Sg.blend = nse;
Sg.colorChannel = void 0;
var Wm = Sg.darken = K5;
Sg.decomposeColor = Bl;
var z9 = Sg.emphasize = tO, zle = Sg.getContrastRatio = $le;
Sg.getLuminance = vS;
Sg.hexToRgb = _4;
Sg.hslToRgb = q4;
var Sm = Sg.lighten = E5;
Sg.private_safeAlpha = qle;
Sg.private_safeColorChannel = void 0;
Sg.private_safeDarken = ese;
Sg.private_safeEmphasize = ise;
Sg.private_safeLighten = tse;
Sg.recomposeColor = jm;
Sg.rgbToHex = _le;
var O9 = j4(Ule), Ole = j4(Ple);
function J5(e, t = 0, i = 1) {
  return (0, Ole.default)(e, t, i);
}
function _4(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(t);
  return i && i[0].length === 1 && (i = i.map((n) => n + n)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((n, g) => g < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Qle(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function Bl(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Bl(_4(e));
  const t = e.indexOf("("), i = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error((0, O9.default)(9, e));
  let n = e.substring(t + 1, e.length - 1), g;
  if (i === "color") {
    if (n = n.split(" "), g = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(g) === -1)
      throw new Error((0, O9.default)(10, g));
  } else
    n = n.split(",");
  return n = n.map((r) => parseFloat(r)), {
    type: i,
    values: n,
    colorSpace: g
  };
}
const $4 = (e) => {
  const t = Bl(e);
  return t.values.slice(0, 3).map((i, n) => t.type.indexOf("hsl") !== -1 && n !== 0 ? `${i}%` : i).join(" ");
};
Sg.colorChannel = $4;
const jle = (e, t) => {
  try {
    return $4(e);
  } catch {
    return e;
  }
};
Sg.private_safeColorChannel = jle;
function jm(e) {
  const {
    type: t,
    colorSpace: i
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((g, r) => r < 3 ? parseInt(g, 10) : g) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${i} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function _le(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = Bl(e);
  return `#${t.map((i, n) => Qle(n === 3 ? Math.round(255 * i) : i)).join("")}`;
}
function q4(e) {
  e = Bl(e);
  const {
    values: t
  } = e, i = t[0], n = t[1] / 100, g = t[2] / 100, r = n * Math.min(g, 1 - g), o = (a, d = (a + i / 30) % 12) => g - r * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let I = "rgb";
  const s = [Math.round(o(0) * 255), Math.round(o(8) * 255), Math.round(o(4) * 255)];
  return e.type === "hsla" && (I += "a", s.push(t[3])), jm({
    type: I,
    values: s
  });
}
function vS(e) {
  e = Bl(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Bl(q4(e)).values : e.values;
  return t = t.map((i) => (e.type !== "color" && (i /= 255), i <= 0.03928 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function $le(e, t) {
  const i = vS(e), n = vS(t);
  return (Math.max(i, n) + 0.05) / (Math.min(i, n) + 0.05);
}
function eO(e, t) {
  return e = Bl(e), t = J5(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, jm(e);
}
function qle(e, t, i) {
  try {
    return eO(e, t);
  } catch {
    return e;
  }
}
function K5(e, t) {
  if (e = Bl(e), t = J5(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - t;
  return jm(e);
}
function ese(e, t, i) {
  try {
    return K5(e, t);
  } catch {
    return e;
  }
}
function E5(e, t) {
  if (e = Bl(e), t = J5(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * t;
  return jm(e);
}
function tse(e, t, i) {
  try {
    return E5(e, t);
  } catch {
    return e;
  }
}
function tO(e, t = 0.15) {
  return vS(e) > 0.5 ? K5(e, t) : E5(e, t);
}
function ise(e, t, i) {
  try {
    return tO(e, t);
  } catch {
    return e;
  }
}
function nse(e, t, i, n = 1) {
  const g = (s, a) => Math.round((s ** (1 / n) * (1 - i) + a ** (1 / n) * i) ** n), r = Bl(e), o = Bl(t), I = [g(r.values[0], o.values[0]), g(r.values[1], o.values[1]), g(r.values[2], o.values[2])];
  return jm({
    type: "rgb",
    values: I
  });
}
const gse = ["mode", "contrastThreshold", "tonalOffset"], Q9 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: NB.white,
    default: NB.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, gk = {
  text: {
    primary: NB.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: NB.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function j9(e, t, i, n) {
  const g = n.light || n, r = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(i) ? e[t] = e[i] : t === "light" ? e.light = Sm(e.main, g) : t === "dark" && (e.dark = Wm(e.main, r)));
}
function rse(e = "light") {
  return e === "dark" ? {
    main: kb[200],
    light: kb[50],
    dark: kb[400]
  } : {
    main: kb[700],
    light: kb[400],
    dark: kb[800]
  };
}
function ose(e = "light") {
  return e === "dark" ? {
    main: Hb[200],
    light: Hb[50],
    dark: Hb[400]
  } : {
    main: Hb[500],
    light: Hb[300],
    dark: Hb[700]
  };
}
function Ise(e = "light") {
  return e === "dark" ? {
    main: Xb[500],
    light: Xb[300],
    dark: Xb[700]
  } : {
    main: Xb[700],
    light: Xb[400],
    dark: Xb[800]
  };
}
function lse(e = "light") {
  return e === "dark" ? {
    main: Fb[400],
    light: Fb[300],
    dark: Fb[700]
  } : {
    main: Fb[700],
    light: Fb[500],
    dark: Fb[900]
  };
}
function sse(e = "light") {
  return e === "dark" ? {
    main: Yb[400],
    light: Yb[300],
    dark: Yb[700]
  } : {
    main: Yb[800],
    light: Yb[500],
    dark: Yb[900]
  };
}
function ase(e = "light") {
  return e === "dark" ? {
    main: A0[400],
    light: A0[300],
    dark: A0[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: A0[500],
    dark: A0[900]
  };
}
function cse(e) {
  const {
    mode: t = "light",
    contrastThreshold: i = 3,
    tonalOffset: n = 0.2
  } = e, g = Ue(e, gse), r = e.primary || rse(t), o = e.secondary || ose(t), I = e.error || Ise(t), s = e.info || lse(t), a = e.success || sse(t), d = e.warning || ase(t);
  function C(h) {
    return zle(h, gk.text.primary) >= i ? gk.text.primary : Q9.text.primary;
  }
  const u = ({
    color: h,
    name: B,
    mainShade: f = 500,
    lightShade: G = 300,
    darkShade: y = 700
  }) => {
    if (h = k({}, h), !h.main && h[f] && (h.main = h[f]), !h.hasOwnProperty("main"))
      throw new Error(sa(11, B ? ` (${B})` : "", f));
    if (typeof h.main != "string")
      throw new Error(sa(12, B ? ` (${B})` : "", JSON.stringify(h.main)));
    return j9(h, "light", G, n), j9(h, "dark", y, n), h.contrastText || (h.contrastText = C(h.main)), h;
  }, A = {
    dark: gk,
    light: Q9
  };
  return dr(k({
    // A collection of common colors.
    common: k({}, NB),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: u({
      color: r,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: u({
      color: o,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: u({
      color: I,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: u({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: u({
      color: s,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: u({
      color: a,
      name: "success"
    }),
    // The grey colors.
    grey: h4,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: i,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: C,
    // Generate a rich color object.
    augmentColor: u,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, A[t]), g);
}
const dse = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function Cse(e) {
  return Math.round(e * 1e5) / 1e5;
}
const _9 = {
  textTransform: "uppercase"
}, $9 = '"Roboto", "Helvetica", "Arial", sans-serif';
function use(e, t) {
  const i = typeof t == "function" ? t(e) : t, {
    fontFamily: n = $9,
    // The default font size of the Material Specification.
    fontSize: g = 14,
    // px
    fontWeightLight: r = 300,
    fontWeightRegular: o = 400,
    fontWeightMedium: I = 500,
    fontWeightBold: s = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: a = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: C
  } = i, u = Ue(i, dse), A = g / 14, m = C || ((f) => `${f / a * A}rem`), h = (f, G, y, W, V) => k({
    fontFamily: n,
    fontWeight: f,
    fontSize: m(G),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: y
  }, n === $9 ? {
    letterSpacing: `${Cse(W / G)}em`
  } : {}, V, d), B = {
    h1: h(r, 96, 1.167, -1.5),
    h2: h(r, 60, 1.2, -0.5),
    h3: h(o, 48, 1.167, 0),
    h4: h(o, 34, 1.235, 0.25),
    h5: h(o, 24, 1.334, 0),
    h6: h(I, 20, 1.6, 0.15),
    subtitle1: h(o, 16, 1.75, 0.15),
    subtitle2: h(I, 14, 1.57, 0.1),
    body1: h(o, 16, 1.5, 0.15),
    body2: h(o, 14, 1.43, 0.15),
    button: h(I, 14, 1.75, 0.4, _9),
    caption: h(o, 12, 1.66, 0.4),
    overline: h(o, 12, 2.66, 1, _9),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return dr(k({
    htmlFontSize: a,
    pxToRem: m,
    fontFamily: n,
    fontSize: g,
    fontWeightLight: r,
    fontWeightRegular: o,
    fontWeightMedium: I,
    fontWeightBold: s
  }, B), u, {
    clone: !1
    // No need to clone deep
  });
}
const Ase = 0.2, bse = 0.14, mse = 0.12;
function Qn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Ase})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${bse})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${mse})`].join(",");
}
const hse = ["none", Qn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Qn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Qn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Qn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Qn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Qn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Qn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Qn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Qn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Qn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Qn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Qn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Qn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Qn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Qn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Qn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Qn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Qn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Qn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Qn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Qn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Qn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Qn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Qn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], pse = ["duration", "easing", "delay"], Bse = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, iO = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function q9(e) {
  return `${Math.round(e)}ms`;
}
function Zse(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function fse(e) {
  const t = k({}, Bse, e.easing), i = k({}, iO, e.duration);
  return k({
    getAutoHeightDuration: Zse,
    create: (g = ["all"], r = {}) => {
      const {
        duration: o = i.standard,
        easing: I = t.easeInOut,
        delay: s = 0
      } = r;
      return Ue(r, pse), (Array.isArray(g) ? g : [g]).map((a) => `${a} ${typeof o == "string" ? o : q9(o)} ${I} ${typeof s == "string" ? s : q9(s)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: i
  });
}
const Gse = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, yse = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function _m(e = {}, ...t) {
  const {
    mixins: i = {},
    palette: n = {},
    transitions: g = {},
    typography: r = {}
  } = e, o = Ue(e, yse);
  if (e.vars)
    throw new Error(sa(18));
  const I = cse(n), s = yZ(e);
  let a = dr(s, {
    mixins: Mle(s.breakpoints, i),
    palette: I,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: hse.slice(),
    typography: use(I, r),
    transitions: fse(g),
    zIndex: k({}, Gse)
  });
  return a = dr(a, o), a = t.reduce((d, C) => dr(d, C), a), a.unstable_sxConfig = k({}, GZ, o == null ? void 0 : o.unstable_sxConfig), a.unstable_sx = function(C) {
    return zm({
      sx: C,
      theme: this
    });
  }, a;
}
function eN(e) {
  return String(parseFloat(e)).length === String(e).length;
}
function nO(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Ad(e) {
  return parseFloat(e);
}
function Wse(e) {
  return (t, i) => {
    const n = nO(t);
    if (n === i)
      return t;
    let g = Ad(t);
    n !== "px" && (n === "em" || n === "rem") && (g = Ad(t) * Ad(e));
    let r = g;
    if (i !== "px")
      if (i === "em")
        r = g / Ad(e);
      else if (i === "rem")
        r = g / Ad(e);
      else
        return t;
    return parseFloat(r.toFixed(5)) + i;
  };
}
function Sse({
  size: e,
  grid: t
}) {
  const i = e - e % t, n = i + t;
  return e - i < n - e ? i : n;
}
function Vse({
  lineHeight: e,
  pixels: t,
  htmlFontSize: i
}) {
  return t / (e * i);
}
function wse({
  cssProperty: e,
  min: t,
  max: i,
  unit: n = "rem",
  breakpoints: g = [600, 900, 1200],
  transform: r = null
}) {
  const o = {
    [e]: `${t}${n}`
  }, I = (i - t) / g[g.length - 1];
  return g.forEach((s) => {
    let a = t + I * s;
    r !== null && (a = r(a)), o[`@media (min-width:${s}px)`] = {
      [e]: `${Math.round(a * 1e4) / 1e4}${n}`
    };
  }), o;
}
function N5(e, t = {}) {
  const {
    breakpoints: i = ["sm", "md", "lg"],
    disableAlign: n = !1,
    factor: g = 2,
    variants: r = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = t, o = k({}, e);
  o.typography = k({}, o.typography);
  const I = o.typography, s = Wse(I.htmlFontSize), a = i.map((d) => o.breakpoints.values[d]);
  return r.forEach((d) => {
    const C = I[d], u = parseFloat(s(C.fontSize, "rem"));
    if (u <= 1)
      return;
    const A = u, m = 1 + (A - 1) / g;
    let {
      lineHeight: h
    } = C;
    if (!eN(h) && !n)
      throw new Error(sa(6));
    eN(h) || (h = parseFloat(s(h, "rem")) / parseFloat(u));
    let B = null;
    n || (B = (f) => Sse({
      size: f,
      grid: Vse({
        pixels: 4,
        lineHeight: h,
        htmlFontSize: I.htmlFontSize
      })
    })), I[d] = k({}, C, wse({
      cssProperty: "fontSize",
      min: m,
      max: A,
      unit: "rem",
      breakpoints: a,
      transform: B
    }));
  }), o;
}
const Ew = _m();
function qo() {
  const e = yw(Ew);
  return e[Hu] || e;
}
function Ft({
  props: e,
  name: t
}) {
  return K4({
    props: e,
    name: t,
    defaultTheme: Ew,
    themeId: Hu
  });
}
var VZ = {}, rk = { exports: {} }, tN;
function vse() {
  return tN || (tN = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(i) {
        for (var n = 1; n < arguments.length; n++) {
          var g = arguments[n];
          for (var r in g)
            Object.prototype.hasOwnProperty.call(g, r) && (i[r] = g[r]);
        }
        return i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(rk)), rk.exports;
}
var ok = { exports: {} }, iN;
function Rse() {
  return iN || (iN = 1, function(e) {
    function t(i, n) {
      if (i == null)
        return {};
      var g = {};
      for (var r in i)
        if (Object.prototype.hasOwnProperty.call(i, r)) {
          if (n.indexOf(r) >= 0)
            continue;
          g[r] = i[r];
        }
      return g;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ok)), ok.exports;
}
const gO = /* @__PURE__ */ yc(Loe), Xse = /* @__PURE__ */ yc(Toe), Hse = /* @__PURE__ */ yc(Qoe), kse = /* @__PURE__ */ yc(jIe), Fse = /* @__PURE__ */ yc(xIe), Yse = /* @__PURE__ */ yc(LIe);
var $m = Cg;
Object.defineProperty(VZ, "__esModule", {
  value: !0
});
var xse = VZ.default = Qse;
VZ.shouldForwardProp = rS;
VZ.systemDefaultTheme = void 0;
var Il = $m(vse()), cY = $m(Rse()), nN = Tse(gO), Dse = Xse;
$m(Hse);
$m(kse);
var Jse = $m(Fse), Kse = $m(Yse);
const Ese = ["ownerState"], Nse = ["variants"], Lse = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function rO(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
  return (rO = function(n) {
    return n ? i : t;
  })(e);
}
function Tse(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var i = rO(t);
  if (i && i.has(e))
    return i.get(e);
  var n = { __proto__: null }, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var r in e)
    if (r !== "default" && Object.prototype.hasOwnProperty.call(e, r)) {
      var o = g ? Object.getOwnPropertyDescriptor(e, r) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e[r];
    }
  return n.default = e, i && i.set(e, n), n;
}
function Mse(e) {
  return Object.keys(e).length === 0;
}
function Use(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function rS(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Pse = VZ.systemDefaultTheme = (0, Jse.default)(), zse = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Ty({
  defaultTheme: e,
  theme: t,
  themeId: i
}) {
  return Mse(t) ? e : t[i] || t;
}
function Ose(e) {
  return e ? (t, i) => i[e] : null;
}
function oS(e, t) {
  let {
    ownerState: i
  } = t, n = (0, cY.default)(t, Ese);
  const g = typeof e == "function" ? e((0, Il.default)({
    ownerState: i
  }, n)) : e;
  if (Array.isArray(g))
    return g.flatMap((r) => oS(r, (0, Il.default)({
      ownerState: i
    }, n)));
  if (g && typeof g == "object" && Array.isArray(g.variants)) {
    const {
      variants: r = []
    } = g;
    let I = (0, cY.default)(g, Nse);
    return r.forEach((s) => {
      let a = !0;
      typeof s.props == "function" ? a = s.props((0, Il.default)({
        ownerState: i
      }, n, i)) : Object.keys(s.props).forEach((d) => {
        (i == null ? void 0 : i[d]) !== s.props[d] && n[d] !== s.props[d] && (a = !1);
      }), a && (Array.isArray(I) || (I = [I]), I.push(typeof s.style == "function" ? s.style((0, Il.default)({
        ownerState: i
      }, n, i)) : s.style));
    }), I;
  }
  return g;
}
function Qse(e = {}) {
  const {
    themeId: t,
    defaultTheme: i = Pse,
    rootShouldForwardProp: n = rS,
    slotShouldForwardProp: g = rS
  } = e, r = (o) => (0, Kse.default)((0, Il.default)({}, o, {
    theme: Ty((0, Il.default)({}, o, {
      defaultTheme: i,
      themeId: t
    }))
  }));
  return r.__mui_systemSx = !0, (o, I = {}) => {
    (0, nN.internal_processStyles)(o, (V) => V.filter((w) => !(w != null && w.__mui_systemSx)));
    const {
      name: s,
      slot: a,
      skipVariantsResolver: d,
      skipSx: C,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: u = Ose(zse(a))
    } = I, A = (0, cY.default)(I, Lse), m = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      a && a !== "Root" && a !== "root" || !1
    ), h = C || !1;
    let B, f = rS;
    a === "Root" || a === "root" ? f = n : a ? f = g : Use(o) && (f = void 0);
    const G = (0, nN.default)(o, (0, Il.default)({
      shouldForwardProp: f,
      label: B
    }, A)), y = (V) => typeof V == "function" && V.__emotion_real !== V || (0, Dse.isPlainObject)(V) ? (w) => oS(V, (0, Il.default)({}, w, {
      theme: Ty({
        theme: w.theme,
        defaultTheme: i,
        themeId: t
      })
    })) : V, W = (V, ...w) => {
      let v = y(V);
      const H = w ? w.map(y) : [];
      s && u && H.push((M) => {
        const $ = Ty((0, Il.default)({}, M, {
          defaultTheme: i,
          themeId: t
        }));
        if (!$.components || !$.components[s] || !$.components[s].styleOverrides)
          return null;
        const q = $.components[s].styleOverrides, E = {};
        return Object.entries(q).forEach(([L, P]) => {
          E[L] = oS(P, (0, Il.default)({}, M, {
            theme: $
          }));
        }), u(M, E);
      }), s && !m && H.push((M) => {
        var $;
        const q = Ty((0, Il.default)({}, M, {
          defaultTheme: i,
          themeId: t
        })), E = q == null || ($ = q.components) == null || ($ = $[s]) == null ? void 0 : $.variants;
        return oS({
          variants: E
        }, (0, Il.default)({}, M, {
          theme: q
        }));
      }), h || H.push(r);
      const x = H.length - w.length;
      if (Array.isArray(V) && x > 0) {
        const M = new Array(x).fill("");
        v = [...V, ...M], v.raw = [...V.raw, ...M];
      }
      const N = G(v, ...H);
      return o.muiName && (N.muiName = o.muiName), N;
    };
    return G.withConfig && (W.withConfig = G.withConfig), W;
  };
}
function Nw(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const br = (e) => Nw(e) && e !== "classes", ye = xse({
  themeId: Hu,
  defaultTheme: Ew,
  rootShouldForwardProp: br
}), jse = ["theme"];
function oO(e) {
  let {
    theme: t
  } = e, i = Ue(e, jse);
  const n = t[Hu];
  return /* @__PURE__ */ ne(Fle, k({}, i, {
    themeId: n ? Hu : void 0,
    theme: n || t
  }));
}
const gN = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
};
function _se(e) {
  return St("MuiSvgIcon", e);
}
Wt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const $se = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], qse = (e) => {
  const {
    color: t,
    fontSize: i,
    classes: n
  } = e, g = {
    root: ["root", t !== "inherit" && `color${Re(t)}`, `fontSize${Re(i)}`]
  };
  return Vt(g, _se, n);
}, eae = ye("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.color !== "inherit" && t[`color${Re(i.color)}`], t[`fontSize${Re(i.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i, n, g, r, o, I, s, a, d, C, u, A, m;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (i = e.transitions) == null || (n = i.create) == null ? void 0 : n.call(i, "fill", {
      duration: (g = e.transitions) == null || (g = g.duration) == null ? void 0 : g.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((r = e.typography) == null || (o = r.pxToRem) == null ? void 0 : o.call(r, 20)) || "1.25rem",
      medium: ((I = e.typography) == null || (s = I.pxToRem) == null ? void 0 : s.call(I, 24)) || "1.5rem",
      large: ((a = e.typography) == null || (d = a.pxToRem) == null ? void 0 : d.call(a, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (C = (u = (e.vars || e).palette) == null || (u = u[t.color]) == null ? void 0 : u.main) != null ? C : {
      action: (A = (e.vars || e).palette) == null || (A = A.action) == null ? void 0 : A.active,
      disabled: (m = (e.vars || e).palette) == null || (m = m.action) == null ? void 0 : m.disabled,
      inherit: void 0
    }[t.color]
  };
}), RS = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: g,
    className: r,
    color: o = "inherit",
    component: I = "svg",
    fontSize: s = "medium",
    htmlColor: a,
    inheritViewBox: d = !1,
    titleAccess: C,
    viewBox: u = "0 0 24 24"
  } = n, A = Ue(n, $se), m = /* @__PURE__ */ Y.isValidElement(g) && g.type === "svg", h = k({}, n, {
    color: o,
    component: I,
    fontSize: s,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: u,
    hasSvgAsChild: m
  }), B = {};
  d || (B.viewBox = u);
  const f = qse(h);
  return /* @__PURE__ */ Ci(eae, k({
    as: I,
    className: Ve(f.root, r),
    focusable: "false",
    color: a,
    "aria-hidden": C ? void 0 : !0,
    role: C ? "img" : void 0,
    ref: i
  }, B, A, m && g.props, {
    ownerState: h,
    children: [m ? g.props.children : g, C ? /* @__PURE__ */ ne("title", {
      children: C
    }) : null]
  }));
});
RS.muiName = "SvgIcon";
function ti(e, t) {
  function i(n, g) {
    return /* @__PURE__ */ ne(RS, k({
      "data-testid": `${t}Icon`,
      ref: g
    }, n, {
      children: e
    }));
  }
  return i.muiName = RS.muiName, /* @__PURE__ */ Y.memo(/* @__PURE__ */ Y.forwardRef(i));
}
const tae = {
  configure: (e) => {
    Sw.configure(e);
  }
}, iae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Re,
  createChainedFunction: wS,
  createSvgIcon: ti,
  debounce: Om,
  deprecatedPropType: cle,
  isMuiElement: sB,
  ownerDocument: Gg,
  ownerWindow: pl,
  requirePropFactory: dle,
  setRef: LB,
  unstable_ClassNameGenerator: tae,
  unstable_useEnhancedEffect: eo,
  unstable_useId: Ou,
  unsupportedProp: ule,
  useControlled: ds,
  useEventCallback: zg,
  useForkRef: gn,
  useIsFocusVisible: SZ
}, Symbol.toStringTag, { value: "Module" }));
function Qu(e) {
  return Ft;
}
function XS(e, t) {
  return XS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, g) {
    return n.__proto__ = g, n;
  }, XS(e, t);
}
function wZ(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, XS(e, t);
}
const rN = {
  disabled: !1
}, HS = Se.createContext(null);
var nae = function(t) {
  return t.scrollTop;
}, U0 = "unmounted", lu = "exited", su = "entering", tm = "entered", dY = "exiting", JI = /* @__PURE__ */ function(e) {
  wZ(t, e);
  function t(n, g) {
    var r;
    r = e.call(this, n, g) || this;
    var o = g, I = o && !o.isMounting ? n.enter : n.appear, s;
    return r.appearStatus = null, n.in ? I ? (s = lu, r.appearStatus = su) : s = tm : n.unmountOnExit || n.mountOnEnter ? s = U0 : s = lu, r.state = {
      status: s
    }, r.nextCallback = null, r;
  }
  t.getDerivedStateFromProps = function(g, r) {
    var o = g.in;
    return o && r.status === U0 ? {
      status: lu
    } : null;
  };
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, i.componentDidUpdate = function(g) {
    var r = null;
    if (g !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== su && o !== tm && (r = su) : (o === su || o === tm) && (r = dY);
    }
    this.updateStatus(!1, r);
  }, i.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, i.getTimeouts = function() {
    var g = this.props.timeout, r, o, I;
    return r = o = I = g, g != null && typeof g != "number" && (r = g.exit, o = g.enter, I = g.appear !== void 0 ? g.appear : o), {
      exit: r,
      enter: o,
      appear: I
    };
  }, i.updateStatus = function(g, r) {
    if (g === void 0 && (g = !1), r !== null)
      if (this.cancelNextCallback(), r === su) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var o = this.props.nodeRef ? this.props.nodeRef.current : T0.findDOMNode(this);
          o && nae(o);
        }
        this.performEnter(g);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === lu && this.setState({
        status: U0
      });
  }, i.performEnter = function(g) {
    var r = this, o = this.props.enter, I = this.context ? this.context.isMounting : g, s = this.props.nodeRef ? [I] : [T0.findDOMNode(this), I], a = s[0], d = s[1], C = this.getTimeouts(), u = I ? C.appear : C.enter;
    if (!g && !o || rN.disabled) {
      this.safeSetState({
        status: tm
      }, function() {
        r.props.onEntered(a);
      });
      return;
    }
    this.props.onEnter(a, d), this.safeSetState({
      status: su
    }, function() {
      r.props.onEntering(a, d), r.onTransitionEnd(u, function() {
        r.safeSetState({
          status: tm
        }, function() {
          r.props.onEntered(a, d);
        });
      });
    });
  }, i.performExit = function() {
    var g = this, r = this.props.exit, o = this.getTimeouts(), I = this.props.nodeRef ? void 0 : T0.findDOMNode(this);
    if (!r || rN.disabled) {
      this.safeSetState({
        status: lu
      }, function() {
        g.props.onExited(I);
      });
      return;
    }
    this.props.onExit(I), this.safeSetState({
      status: dY
    }, function() {
      g.props.onExiting(I), g.onTransitionEnd(o.exit, function() {
        g.safeSetState({
          status: lu
        }, function() {
          g.props.onExited(I);
        });
      });
    });
  }, i.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, i.safeSetState = function(g, r) {
    r = this.setNextCallback(r), this.setState(g, r);
  }, i.setNextCallback = function(g) {
    var r = this, o = !0;
    return this.nextCallback = function(I) {
      o && (o = !1, r.nextCallback = null, g(I));
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, i.onTransitionEnd = function(g, r) {
    this.setNextCallback(r);
    var o = this.props.nodeRef ? this.props.nodeRef.current : T0.findDOMNode(this), I = g == null && !this.props.addEndListener;
    if (!o || I) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var s = this.props.nodeRef ? [this.nextCallback] : [o, this.nextCallback], a = s[0], d = s[1];
      this.props.addEndListener(a, d);
    }
    g != null && setTimeout(this.nextCallback, g);
  }, i.render = function() {
    var g = this.state.status;
    if (g === U0)
      return null;
    var r = this.props, o = r.children;
    r.in, r.mountOnEnter, r.unmountOnExit, r.appear, r.enter, r.exit, r.timeout, r.addEndListener, r.onEnter, r.onEntering, r.onEntered, r.onExit, r.onExiting, r.onExited, r.nodeRef;
    var I = Ue(r, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Se.createElement(HS.Provider, {
        value: null
      }, typeof o == "function" ? o(g, I) : Se.cloneElement(Se.Children.only(o), I))
    );
  }, t;
}(Se.Component);
JI.contextType = HS;
JI.propTypes = {};
function Db() {
}
JI.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Db,
  onEntering: Db,
  onEntered: Db,
  onExit: Db,
  onExiting: Db,
  onExited: Db
};
JI.UNMOUNTED = U0;
JI.EXITED = lu;
JI.ENTERING = su;
JI.ENTERED = tm;
JI.EXITING = dY;
function us(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function L5(e, t) {
  var i = function(r) {
    return t && IB(r) ? t(r) : r;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && xz.map(e, function(g) {
    return g;
  }).forEach(function(g) {
    n[g.key] = i(g);
  }), n;
}
function gae(e, t) {
  e = e || {}, t = t || {};
  function i(d) {
    return d in t ? t[d] : e[d];
  }
  var n = /* @__PURE__ */ Object.create(null), g = [];
  for (var r in e)
    r in t ? g.length && (n[r] = g, g = []) : g.push(r);
  var o, I = {};
  for (var s in t) {
    if (n[s])
      for (o = 0; o < n[s].length; o++) {
        var a = n[s][o];
        I[n[s][o]] = i(a);
      }
    I[s] = i(s);
  }
  for (o = 0; o < g.length; o++)
    I[g[o]] = i(g[o]);
  return I;
}
function fu(e, t, i) {
  return i[t] != null ? i[t] : e.props[t];
}
function rae(e, t) {
  return L5(e.children, function(i) {
    return wu(i, {
      onExited: t.bind(null, i),
      in: !0,
      appear: fu(i, "appear", e),
      enter: fu(i, "enter", e),
      exit: fu(i, "exit", e)
    });
  });
}
function oae(e, t, i) {
  var n = L5(e.children), g = gae(t, n);
  return Object.keys(g).forEach(function(r) {
    var o = g[r];
    if (IB(o)) {
      var I = r in t, s = r in n, a = t[r], d = IB(a) && !a.props.in;
      s && (!I || d) ? g[r] = wu(o, {
        onExited: i.bind(null, o),
        in: !0,
        exit: fu(o, "exit", e),
        enter: fu(o, "enter", e)
      }) : !s && I && !d ? g[r] = wu(o, {
        in: !1
      }) : s && I && IB(a) && (g[r] = wu(o, {
        onExited: i.bind(null, o),
        in: a.props.in,
        exit: fu(o, "exit", e),
        enter: fu(o, "enter", e)
      }));
    }
  }), g;
}
var Iae = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, lae = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, T5 = /* @__PURE__ */ function(e) {
  wZ(t, e);
  function t(n, g) {
    var r;
    r = e.call(this, n, g) || this;
    var o = r.handleExited.bind(us(r));
    return r.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: o,
      firstRender: !0
    }, r;
  }
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, i.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(g, r) {
    var o = r.children, I = r.handleExited, s = r.firstRender;
    return {
      children: s ? rae(g, I) : oae(g, o, I),
      firstRender: !1
    };
  }, i.handleExited = function(g, r) {
    var o = L5(this.props.children);
    g.key in o || (g.props.onExited && g.props.onExited(r), this.mounted && this.setState(function(I) {
      var s = k({}, I.children);
      return delete s[g.key], {
        children: s
      };
    }));
  }, i.render = function() {
    var g = this.props, r = g.component, o = g.childFactory, I = Ue(g, ["component", "childFactory"]), s = this.state.contextValue, a = Iae(this.state.children).map(o);
    return delete I.appear, delete I.enter, delete I.exit, r === null ? /* @__PURE__ */ Se.createElement(HS.Provider, {
      value: s
    }, a) : /* @__PURE__ */ Se.createElement(HS.Provider, {
      value: s
    }, /* @__PURE__ */ Se.createElement(r, I, a));
  }, t;
}(Se.Component);
T5.propTypes = {};
T5.defaultProps = lae;
const Lw = (e) => e.scrollTop;
function aa(e, t) {
  var i, n;
  const {
    timeout: g,
    easing: r,
    style: o = {}
  } = e;
  return {
    duration: (i = o.transitionDuration) != null ? i : typeof g == "number" ? g : g[t.mode] || 0,
    easing: (n = o.transitionTimingFunction) != null ? n : typeof r == "object" ? r[t.mode] : r,
    delay: o.transitionDelay
  };
}
function sae(e) {
  return St("MuiCollapse", e);
}
Wt("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const aae = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], cae = (e) => {
  const {
    orientation: t,
    classes: i
  } = e, n = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Vt(n, sae, i);
}, dae = ye("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.orientation], i.state === "entered" && t.entered, i.state === "exited" && !i.in && i.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && k({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), Cae = ye("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => k({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), uae = ye("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => k({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), vZ = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: g,
    children: r,
    className: o,
    collapsedSize: I = "0px",
    component: s,
    easing: a,
    in: d,
    onEnter: C,
    onEntered: u,
    onEntering: A,
    onExit: m,
    onExited: h,
    onExiting: B,
    orientation: f = "vertical",
    style: G,
    timeout: y = iO.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: W = JI
  } = n, V = Ue(n, aae), w = k({}, n, {
    orientation: f,
    collapsedSize: I
  }), v = cae(w), H = qo(), x = Zu(), N = Y.useRef(null), M = Y.useRef(), $ = typeof I == "number" ? `${I}px` : I, q = f === "horizontal", E = q ? "width" : "height", L = Y.useRef(null), P = gn(i, L), Q = (ue) => (Xe) => {
    if (ue) {
      const Ze = L.current;
      Xe === void 0 ? ue(Ze) : ue(Ze, Xe);
    }
  }, te = () => N.current ? N.current[q ? "clientWidth" : "clientHeight"] : 0, le = Q((ue, Xe) => {
    N.current && q && (N.current.style.position = "absolute"), ue.style[E] = $, C && C(ue, Xe);
  }), Ae = Q((ue, Xe) => {
    const Ze = te();
    N.current && q && (N.current.style.position = "");
    const {
      duration: Ke,
      easing: $e
    } = aa({
      style: G,
      timeout: y,
      easing: a
    }, {
      mode: "enter"
    });
    if (y === "auto") {
      const rt = H.transitions.getAutoHeightDuration(Ze);
      ue.style.transitionDuration = `${rt}ms`, M.current = rt;
    } else
      ue.style.transitionDuration = typeof Ke == "string" ? Ke : `${Ke}ms`;
    ue.style[E] = `${Ze}px`, ue.style.transitionTimingFunction = $e, A && A(ue, Xe);
  }), we = Q((ue, Xe) => {
    ue.style[E] = "auto", u && u(ue, Xe);
  }), Ee = Q((ue) => {
    ue.style[E] = `${te()}px`, m && m(ue);
  }), Je = Q(h), ve = Q((ue) => {
    const Xe = te(), {
      duration: Ze,
      easing: Ke
    } = aa({
      style: G,
      timeout: y,
      easing: a
    }, {
      mode: "exit"
    });
    if (y === "auto") {
      const $e = H.transitions.getAutoHeightDuration(Xe);
      ue.style.transitionDuration = `${$e}ms`, M.current = $e;
    } else
      ue.style.transitionDuration = typeof Ze == "string" ? Ze : `${Ze}ms`;
    ue.style[E] = $, ue.style.transitionTimingFunction = Ke, B && B(ue);
  });
  return /* @__PURE__ */ ne(W, k({
    in: d,
    onEnter: le,
    onEntered: we,
    onEntering: Ae,
    onExit: Ee,
    onExited: Je,
    onExiting: ve,
    addEndListener: (ue) => {
      y === "auto" && x.start(M.current || 0, ue), g && g(L.current, ue);
    },
    nodeRef: L,
    timeout: y === "auto" ? null : y
  }, V, {
    children: (ue, Xe) => /* @__PURE__ */ ne(dae, k({
      as: s,
      className: Ve(v.root, o, {
        entered: v.entered,
        exited: !d && $ === "0px" && v.hidden
      }[ue]),
      style: k({
        [q ? "minWidth" : "minHeight"]: $
      }, G),
      ref: P
    }, Xe, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: k({}, w, {
        state: ue
      }),
      children: /* @__PURE__ */ ne(Cae, {
        ownerState: k({}, w, {
          state: ue
        }),
        className: v.wrapper,
        ref: N,
        children: /* @__PURE__ */ ne(uae, {
          ownerState: k({}, w, {
            state: ue
          }),
          className: v.wrapperInner,
          children: r
        })
      })
    }))
  }));
});
vZ.muiSupportAuto = !0;
function Aae(e) {
  return St("MuiPaper", e);
}
Wt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const bae = ["className", "component", "elevation", "square", "variant"], mae = (e) => {
  const {
    square: t,
    elevation: i,
    variant: n,
    classes: g
  } = e, r = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${i}`]
  };
  return Vt(r, Aae, g);
}, hae = ye("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], !i.square && t.rounded, i.variant === "elevation" && t[`elevation${i.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i;
  return k({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && k({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${di("#fff", gN(t.elevation))}, ${di("#fff", gN(t.elevation))})`
  }, e.vars && {
    backgroundImage: (i = e.vars.overlays) == null ? void 0 : i[t.elevation]
  }));
}), So = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiPaper"
  }), {
    className: g,
    component: r = "div",
    elevation: o = 1,
    square: I = !1,
    variant: s = "elevation"
  } = n, a = Ue(n, bae), d = k({}, n, {
    component: r,
    elevation: o,
    square: I,
    variant: s
  }), C = mae(d);
  return /* @__PURE__ */ ne(hae, k({
    as: r,
    ownerState: d,
    className: Ve(C.root, g),
    ref: i
  }, a));
}), IO = /* @__PURE__ */ Y.createContext({});
function oa(e) {
  return typeof e == "string";
}
function lm(e, t, i) {
  return e === void 0 || oa(e) ? t : k({}, t, {
    ownerState: k({}, t.ownerState, i)
  });
}
function pae(e, t, i = (n, g) => n === g) {
  return e.length === t.length && e.every((n, g) => i(n, t[g]));
}
const Bae = {
  disableDefaultClasses: !1
}, Zae = /* @__PURE__ */ Y.createContext(Bae);
function fae(e) {
  const {
    disableDefaultClasses: t
  } = Y.useContext(Zae);
  return (i) => t ? "" : e(i);
}
function aB(e, t = []) {
  if (e === void 0)
    return {};
  const i = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    i[n] = e[n];
  }), i;
}
function lO(e, t, i) {
  return typeof e == "function" ? e(t, i) : e;
}
function oN(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((i) => !(i.match(/^on[A-Z]/) && typeof e[i] == "function")).forEach((i) => {
    t[i] = e[i];
  }), t;
}
function sO(e) {
  const {
    getSlotProps: t,
    additionalProps: i,
    externalSlotProps: n,
    externalForwardedProps: g,
    className: r
  } = e;
  if (!t) {
    const A = Ve(i == null ? void 0 : i.className, r, g == null ? void 0 : g.className, n == null ? void 0 : n.className), m = k({}, i == null ? void 0 : i.style, g == null ? void 0 : g.style, n == null ? void 0 : n.style), h = k({}, i, g, n);
    return A.length > 0 && (h.className = A), Object.keys(m).length > 0 && (h.style = m), {
      props: h,
      internalRef: void 0
    };
  }
  const o = aB(k({}, g, n)), I = oN(n), s = oN(g), a = t(o), d = Ve(a == null ? void 0 : a.className, i == null ? void 0 : i.className, r, g == null ? void 0 : g.className, n == null ? void 0 : n.className), C = k({}, a == null ? void 0 : a.style, i == null ? void 0 : i.style, g == null ? void 0 : g.style, n == null ? void 0 : n.style), u = k({}, a, i, s, I);
  return d.length > 0 && (u.className = d), Object.keys(C).length > 0 && (u.style = C), {
    props: u,
    internalRef: a.ref
  };
}
const Gae = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function kg(e) {
  var t;
  const {
    elementType: i,
    externalSlotProps: n,
    ownerState: g,
    skipResolvingSlotProps: r = !1
  } = e, o = Ue(e, Gae), I = r ? {} : lO(n, g), {
    props: s,
    internalRef: a
  } = sO(k({}, o, {
    externalSlotProps: I
  })), d = gn(a, I == null ? void 0 : I.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return lm(i, k({}, s, {
    ref: d
  }), g);
}
const yae = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], Wae = ["component", "slots", "slotProps"], Sae = ["component"];
function aO(e, t) {
  const {
    className: i,
    elementType: n,
    ownerState: g,
    externalForwardedProps: r,
    getSlotOwnerState: o,
    internalForwardedProps: I
  } = t, s = Ue(t, yae), {
    component: a,
    slots: d = {
      [e]: void 0
    },
    slotProps: C = {
      [e]: void 0
    }
  } = r, u = Ue(r, Wae), A = d[e] || n, m = lO(C[e], g), h = sO(k({
    className: i
  }, s, {
    externalForwardedProps: e === "root" ? u : void 0,
    externalSlotProps: m
  })), {
    props: {
      component: B
    },
    internalRef: f
  } = h, G = Ue(h.props, Sae), y = gn(f, m == null ? void 0 : m.ref, t.ref), W = o ? o(G) : {}, V = k({}, g, W), w = e === "root" ? B || a : B, v = lm(A, k({}, e === "root" && !a && !d[e] && I, e !== "root" && !d[e] && I, G, w && {
    as: w
  }, {
    ref: y
  }), V);
  return Object.keys(W).forEach((H) => {
    delete v[H];
  }), [A, v];
}
function Vae(e) {
  return St("MuiAccordion", e);
}
const My = Wt("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), wae = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], vae = Qu(), Rae = (e) => {
  const {
    classes: t,
    square: i,
    expanded: n,
    disabled: g,
    disableGutters: r
  } = e;
  return Vt({
    root: ["root", !i && "rounded", n && "expanded", g && "disabled", !r && "gutters"],
    region: ["region"]
  }, Vae, t);
}, Xae = ye(So, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${My.region}`]: t.region
    }, t.root, !i.square && t.rounded, !i.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${My.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${My.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${My.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
})), M5 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = vae({
    props: t,
    name: "MuiAccordion"
  }), {
    children: g,
    className: r,
    defaultExpanded: o = !1,
    disabled: I = !1,
    disableGutters: s = !1,
    expanded: a,
    onChange: d,
    square: C = !1,
    slots: u = {},
    slotProps: A = {},
    TransitionComponent: m,
    TransitionProps: h
  } = n, B = Ue(n, wae), [f, G] = ds({
    controlled: a,
    default: o,
    name: "Accordion",
    state: "expanded"
  }), y = Y.useCallback((q) => {
    G(!f), d && d(q, !f);
  }, [f, d, G]), [W, ...V] = Y.Children.toArray(g), w = Y.useMemo(() => ({
    expanded: f,
    disabled: I,
    disableGutters: s,
    toggle: y
  }), [f, I, s, y]), v = k({}, n, {
    square: C,
    disabled: I,
    disableGutters: s,
    expanded: f
  }), H = Rae(v), x = k({
    transition: m
  }, u), N = k({
    transition: h
  }, A), [M, $] = aO("transition", {
    elementType: vZ,
    externalForwardedProps: {
      slots: x,
      slotProps: N
    },
    ownerState: v
  });
  return /* @__PURE__ */ Ci(Xae, k({
    className: Ve(H.root, r),
    ref: i,
    ownerState: v,
    square: C
  }, B, {
    children: [/* @__PURE__ */ ne(IO.Provider, {
      value: w,
      children: W
    }), /* @__PURE__ */ ne(M, k({
      in: f,
      timeout: "auto"
    }, $, {
      children: /* @__PURE__ */ ne("div", {
        "aria-labelledby": W.props.id,
        id: W.props["aria-controls"],
        role: "region",
        className: H.region,
        children: V
      })
    }))]
  }));
});
function Hae(e) {
  return St("MuiAccordionDetails", e);
}
Wt("MuiAccordionDetails", ["root"]);
const kae = ["className"], Fae = Qu(), Yae = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, Hae, t);
}, xae = ye("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), U5 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Fae({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: g
  } = n, r = Ue(n, kae), o = n, I = Yae(o);
  return /* @__PURE__ */ ne(xae, k({
    className: Ve(I.root, g),
    ref: i,
    ownerState: o
  }, r));
});
function Dae(e) {
  const {
    className: t,
    classes: i,
    pulsate: n = !1,
    rippleX: g,
    rippleY: r,
    rippleSize: o,
    in: I,
    onExited: s,
    timeout: a
  } = e, [d, C] = Y.useState(!1), u = Ve(t, i.ripple, i.rippleVisible, n && i.ripplePulsate), A = {
    width: o,
    height: o,
    top: -(o / 2) + r,
    left: -(o / 2) + g
  }, m = Ve(i.child, d && i.childLeaving, n && i.childPulsate);
  return !I && !d && C(!0), Y.useEffect(() => {
    if (!I && s != null) {
      const h = setTimeout(s, a);
      return () => {
        clearTimeout(h);
      };
    }
  }, [s, I, a]), /* @__PURE__ */ ne("span", {
    className: u,
    style: A,
    children: /* @__PURE__ */ ne("span", {
      className: m
    })
  });
}
const sl = Wt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Jae = ["center", "classes", "className"];
let Tw = (e) => e, IN, lN, sN, aN;
const CY = 550, Kae = 80, Eae = Zs(IN || (IN = Tw`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), Nae = Zs(lN || (lN = Tw`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), Lae = Zs(sN || (sN = Tw`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), Tae = ye("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Mae = ye(Dae, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(aN || (aN = Tw`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), sl.rippleVisible, Eae, CY, ({
  theme: e
}) => e.transitions.easing.easeInOut, sl.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, sl.child, sl.childLeaving, Nae, CY, ({
  theme: e
}) => e.transitions.easing.easeInOut, sl.childPulsate, Lae, ({
  theme: e
}) => e.transitions.easing.easeInOut), Uae = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: g = !1,
    classes: r = {},
    className: o
  } = n, I = Ue(n, Jae), [s, a] = Y.useState([]), d = Y.useRef(0), C = Y.useRef(null);
  Y.useEffect(() => {
    C.current && (C.current(), C.current = null);
  }, [s]);
  const u = Y.useRef(!1), A = Zu(), m = Y.useRef(null), h = Y.useRef(null), B = Y.useCallback((W) => {
    const {
      pulsate: V,
      rippleX: w,
      rippleY: v,
      rippleSize: H,
      cb: x
    } = W;
    a((N) => [...N, /* @__PURE__ */ ne(Mae, {
      classes: {
        ripple: Ve(r.ripple, sl.ripple),
        rippleVisible: Ve(r.rippleVisible, sl.rippleVisible),
        ripplePulsate: Ve(r.ripplePulsate, sl.ripplePulsate),
        child: Ve(r.child, sl.child),
        childLeaving: Ve(r.childLeaving, sl.childLeaving),
        childPulsate: Ve(r.childPulsate, sl.childPulsate)
      },
      timeout: CY,
      pulsate: V,
      rippleX: w,
      rippleY: v,
      rippleSize: H
    }, d.current)]), d.current += 1, C.current = x;
  }, [r]), f = Y.useCallback((W = {}, V = {}, w = () => {
  }) => {
    const {
      pulsate: v = !1,
      center: H = g || V.pulsate,
      fakeElement: x = !1
      // For test purposes
    } = V;
    if ((W == null ? void 0 : W.type) === "mousedown" && u.current) {
      u.current = !1;
      return;
    }
    (W == null ? void 0 : W.type) === "touchstart" && (u.current = !0);
    const N = x ? null : h.current, M = N ? N.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let $, q, E;
    if (H || W === void 0 || W.clientX === 0 && W.clientY === 0 || !W.clientX && !W.touches)
      $ = Math.round(M.width / 2), q = Math.round(M.height / 2);
    else {
      const {
        clientX: L,
        clientY: P
      } = W.touches && W.touches.length > 0 ? W.touches[0] : W;
      $ = Math.round(L - M.left), q = Math.round(P - M.top);
    }
    if (H)
      E = Math.sqrt((2 * M.width ** 2 + M.height ** 2) / 3), E % 2 === 0 && (E += 1);
    else {
      const L = Math.max(Math.abs((N ? N.clientWidth : 0) - $), $) * 2 + 2, P = Math.max(Math.abs((N ? N.clientHeight : 0) - q), q) * 2 + 2;
      E = Math.sqrt(L ** 2 + P ** 2);
    }
    W != null && W.touches ? m.current === null && (m.current = () => {
      B({
        pulsate: v,
        rippleX: $,
        rippleY: q,
        rippleSize: E,
        cb: w
      });
    }, A.start(Kae, () => {
      m.current && (m.current(), m.current = null);
    })) : B({
      pulsate: v,
      rippleX: $,
      rippleY: q,
      rippleSize: E,
      cb: w
    });
  }, [g, B, A]), G = Y.useCallback(() => {
    f({}, {
      pulsate: !0
    });
  }, [f]), y = Y.useCallback((W, V) => {
    if (A.clear(), (W == null ? void 0 : W.type) === "touchend" && m.current) {
      m.current(), m.current = null, A.start(0, () => {
        y(W, V);
      });
      return;
    }
    m.current = null, a((w) => w.length > 0 ? w.slice(1) : w), C.current = V;
  }, [A]);
  return Y.useImperativeHandle(i, () => ({
    pulsate: G,
    start: f,
    stop: y
  }), [G, f, y]), /* @__PURE__ */ ne(Tae, k({
    className: Ve(sl.root, r.root, o),
    ref: h
  }, I, {
    children: /* @__PURE__ */ ne(T5, {
      component: null,
      exit: !0,
      children: s
    })
  }));
});
function Pae(e) {
  return St("MuiButtonBase", e);
}
const zae = Wt("MuiButtonBase", ["root", "disabled", "focusVisible"]), Oae = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], Qae = (e) => {
  const {
    disabled: t,
    focusVisible: i,
    focusVisibleClassName: n,
    classes: g
  } = e, o = Vt({
    root: ["root", t && "disabled", i && "focusVisible"]
  }, Pae, g);
  return i && n && (o.root += ` ${n}`), o;
}, jae = ye("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${zae.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), fo = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: g,
    centerRipple: r = !1,
    children: o,
    className: I,
    component: s = "button",
    disabled: a = !1,
    disableRipple: d = !1,
    disableTouchRipple: C = !1,
    focusRipple: u = !1,
    LinkComponent: A = "a",
    onBlur: m,
    onClick: h,
    onContextMenu: B,
    onDragLeave: f,
    onFocus: G,
    onFocusVisible: y,
    onKeyDown: W,
    onKeyUp: V,
    onMouseDown: w,
    onMouseLeave: v,
    onMouseUp: H,
    onTouchEnd: x,
    onTouchMove: N,
    onTouchStart: M,
    tabIndex: $ = 0,
    TouchRippleProps: q,
    touchRippleRef: E,
    type: L
  } = n, P = Ue(n, Oae), Q = Y.useRef(null), te = Y.useRef(null), le = gn(te, E), {
    isFocusVisibleRef: Ae,
    onFocus: we,
    onBlur: Ee,
    ref: Je
  } = SZ(), [ve, Be] = Y.useState(!1);
  a && ve && Be(!1), Y.useImperativeHandle(g, () => ({
    focusVisible: () => {
      Be(!0), Q.current.focus();
    }
  }), []);
  const [ue, Xe] = Y.useState(!1);
  Y.useEffect(() => {
    Xe(!0);
  }, []);
  const Ze = ue && !d && !a;
  Y.useEffect(() => {
    ve && u && !d && ue && te.current.pulsate();
  }, [d, u, ve, ue]);
  function Ke(pe, _e, Gt = C) {
    return zg((Jt) => (_e && _e(Jt), !Gt && te.current && te.current[pe](Jt), !0));
  }
  const $e = Ke("start", w), rt = Ke("stop", B), dt = Ke("stop", f), ot = Ke("stop", H), ze = Ke("stop", (pe) => {
    ve && pe.preventDefault(), v && v(pe);
  }), tt = Ke("start", M), st = Ke("stop", x), Kt = Ke("stop", N), ie = Ke("stop", (pe) => {
    Ee(pe), Ae.current === !1 && Be(!1), m && m(pe);
  }, !1), J = zg((pe) => {
    Q.current || (Q.current = pe.currentTarget), we(pe), Ae.current === !0 && (Be(!0), y && y(pe)), G && G(pe);
  }), Ce = () => {
    const pe = Q.current;
    return s && s !== "button" && !(pe.tagName === "A" && pe.href);
  }, xe = Y.useRef(!1), Le = zg((pe) => {
    u && !xe.current && ve && te.current && pe.key === " " && (xe.current = !0, te.current.stop(pe, () => {
      te.current.start(pe);
    })), pe.target === pe.currentTarget && Ce() && pe.key === " " && pe.preventDefault(), W && W(pe), pe.target === pe.currentTarget && Ce() && pe.key === "Enter" && !a && (pe.preventDefault(), h && h(pe));
  }), Ye = zg((pe) => {
    u && pe.key === " " && te.current && ve && !pe.defaultPrevented && (xe.current = !1, te.current.stop(pe, () => {
      te.current.pulsate(pe);
    })), V && V(pe), h && pe.target === pe.currentTarget && Ce() && pe.key === " " && !pe.defaultPrevented && h(pe);
  });
  let qe = s;
  qe === "button" && (P.href || P.to) && (qe = A);
  const Yt = {};
  qe === "button" ? (Yt.type = L === void 0 ? "button" : L, Yt.disabled = a) : (!P.href && !P.to && (Yt.role = "button"), a && (Yt["aria-disabled"] = a));
  const qt = gn(i, Je, Q), Ut = k({}, n, {
    centerRipple: r,
    component: s,
    disabled: a,
    disableRipple: d,
    disableTouchRipple: C,
    focusRipple: u,
    tabIndex: $,
    focusVisible: ve
  }), Ge = Qae(Ut);
  return /* @__PURE__ */ Ci(jae, k({
    as: qe,
    className: Ve(Ge.root, I),
    ownerState: Ut,
    onBlur: ie,
    onClick: h,
    onContextMenu: rt,
    onFocus: J,
    onKeyDown: Le,
    onKeyUp: Ye,
    onMouseDown: $e,
    onMouseLeave: ze,
    onMouseUp: ot,
    onDragLeave: dt,
    onTouchEnd: st,
    onTouchMove: Kt,
    onTouchStart: tt,
    ref: qt,
    tabIndex: a ? -1 : $,
    type: L
  }, Yt, P, {
    children: [o, Ze ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ ne(Uae, k({
        ref: le,
        center: r
      }, q))
    ) : null]
  }));
});
function _ae(e) {
  return St("MuiAccordionSummary", e);
}
const sm = Wt("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), $ae = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], qae = Qu(), ece = (e) => {
  const {
    classes: t,
    expanded: i,
    disabled: n,
    disableGutters: g
  } = e;
  return Vt({
    root: ["root", i && "expanded", n && "disabled", !g && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", i && "expanded", !g && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", i && "expanded"]
  }, _ae, t);
}, tce = ye(fo, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${sm.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${sm.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${sm.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (i) => !i.disableGutters,
      style: {
        [`&.${sm.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
}), ice = ye("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${sm.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
})), nce = ye("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${sm.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), P5 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = qae({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: g,
    className: r,
    expandIcon: o,
    focusVisibleClassName: I,
    onClick: s
  } = n, a = Ue(n, $ae), {
    disabled: d = !1,
    disableGutters: C,
    expanded: u,
    toggle: A
  } = Y.useContext(IO), m = (f) => {
    A && A(f), s && s(f);
  }, h = k({}, n, {
    expanded: u,
    disabled: d,
    disableGutters: C
  }), B = ece(h);
  return /* @__PURE__ */ Ci(tce, k({
    focusRipple: !1,
    disableRipple: !0,
    disabled: d,
    component: "div",
    "aria-expanded": u,
    className: Ve(B.root, r),
    focusVisibleClassName: Ve(B.focusVisible, I),
    onClick: m,
    ref: i,
    ownerState: h
  }, a, {
    children: [/* @__PURE__ */ ne(ice, {
      className: B.content,
      ownerState: h,
      children: g
    }), o && /* @__PURE__ */ ne(nce, {
      className: B.expandIconWrapper,
      ownerState: h,
      children: o
    })]
  }));
});
function gce(e) {
  return St("MuiIconButton", e);
}
const rce = Wt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), oce = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], Ice = (e) => {
  const {
    classes: t,
    disabled: i,
    color: n,
    edge: g,
    size: r
  } = e, o = {
    root: ["root", i && "disabled", n !== "default" && `color${Re(n)}`, g && `edge${Re(g)}`, `size${Re(r)}`]
  };
  return Vt(o, gce, t);
}, lce = ye(fo, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.color !== "default" && t[`color${Re(i.color)}`], i.edge && t[`edge${Re(i.edge)}`], t[`size${Re(i.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var i;
  const n = (i = (e.vars || e).palette) == null ? void 0 : i[t.color];
  return k({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && k({
    color: n == null ? void 0 : n.main
  }, !t.disableRipple && {
    "&:hover": k({}, n && {
      backgroundColor: e.vars ? `rgba(${n.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(n.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${rce.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), mi = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: g = !1,
    children: r,
    className: o,
    color: I = "default",
    disabled: s = !1,
    disableFocusRipple: a = !1,
    size: d = "medium"
  } = n, C = Ue(n, oce), u = k({}, n, {
    edge: g,
    color: I,
    disabled: s,
    disableFocusRipple: a,
    size: d
  }), A = Ice(u);
  return /* @__PURE__ */ ne(lce, k({
    className: Ve(A.root, o),
    centerRipple: !0,
    focusRipple: !a,
    disabled: s,
    ref: i
  }, C, {
    ownerState: u,
    children: r
  }));
}), sce = ti(/* @__PURE__ */ ne("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function ace(e) {
  return St("MuiTypography", e);
}
const cce = Wt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), lDt = cce, dce = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], Cce = (e) => {
  const {
    align: t,
    gutterBottom: i,
    noWrap: n,
    paragraph: g,
    variant: r,
    classes: o
  } = e, I = {
    root: ["root", r, e.align !== "inherit" && `align${Re(t)}`, i && "gutterBottom", n && "noWrap", g && "paragraph"]
  };
  return Vt(I, ace, o);
}, uce = ye("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.variant && t[i.variant], i.align !== "inherit" && t[`align${Re(i.align)}`], i.noWrap && t.noWrap, i.gutterBottom && t.gutterBottom, i.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), cN = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Ace = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, bce = (e) => Ace[e] || e, Ne = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTypography"
  }), g = bce(n.color), r = Ww(k({}, n, {
    color: g
  })), {
    align: o = "inherit",
    className: I,
    component: s,
    gutterBottom: a = !1,
    noWrap: d = !1,
    paragraph: C = !1,
    variant: u = "body1",
    variantMapping: A = cN
  } = r, m = Ue(r, dce), h = k({}, r, {
    align: o,
    color: g,
    className: I,
    component: s,
    gutterBottom: a,
    noWrap: d,
    paragraph: C,
    variant: u,
    variantMapping: A
  }), B = s || (C ? "p" : A[u] || cN[u]) || "span", f = Cce(h);
  return /* @__PURE__ */ ne(uce, k({
    as: B,
    ref: i,
    ownerState: h,
    className: Ve(f.root, I)
  }, m));
});
function mce(e) {
  return St("MuiAppBar", e);
}
Wt("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
const hce = ["className", "color", "enableColorOnDark", "position"], pce = (e) => {
  const {
    color: t,
    position: i,
    classes: n
  } = e, g = {
    root: ["root", `color${Re(t)}`, `position${Re(i)}`]
  };
  return Vt(g, mce, n);
}, Uy = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, Bce = ye(So, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`position${Re(i.position)}`], t[`color${Re(i.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[900];
  return k({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, t.position === "fixed" && {
    position: "fixed",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0,
    "@media print": {
      // Prevent the app bar to be visible on each printed page.
      position: "absolute"
    }
  }, t.position === "absolute" && {
    position: "absolute",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "sticky" && {
    // ⚠️ sticky is not supported by IE11.
    position: "sticky",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "static" && {
    position: "static"
  }, t.position === "relative" && {
    position: "relative"
  }, !e.vars && k({}, t.color === "default" && {
    backgroundColor: i,
    color: e.palette.getContrastText(i)
  }, t.color && t.color !== "default" && t.color !== "inherit" && t.color !== "transparent" && {
    backgroundColor: e.palette[t.color].main,
    color: e.palette[t.color].contrastText
  }, t.color === "inherit" && {
    color: "inherit"
  }, e.palette.mode === "dark" && !t.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, t.color === "transparent" && k({
    backgroundColor: "transparent",
    color: "inherit"
  }, e.palette.mode === "dark" && {
    backgroundImage: "none"
  })), e.vars && k({}, t.color === "default" && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette.AppBar.defaultBg : Uy(e.vars.palette.AppBar.darkBg, e.vars.palette.AppBar.defaultBg),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette.text.primary : Uy(e.vars.palette.AppBar.darkColor, e.vars.palette.text.primary)
  }, t.color && !t.color.match(/^(default|inherit|transparent)$/) && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette[t.color].main : Uy(e.vars.palette.AppBar.darkBg, e.vars.palette[t.color].main),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette[t.color].contrastText : Uy(e.vars.palette.AppBar.darkColor, e.vars.palette[t.color].contrastText)
  }, {
    backgroundColor: "var(--AppBar-background)",
    color: t.color === "inherit" ? "inherit" : "var(--AppBar-color)"
  }, t.color === "transparent" && {
    backgroundImage: "none",
    backgroundColor: "transparent",
    color: "inherit"
  }));
}), Zce = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiAppBar"
  }), {
    className: g,
    color: r = "primary",
    enableColorOnDark: o = !1,
    position: I = "fixed"
  } = n, s = Ue(n, hce), a = k({}, n, {
    color: r,
    position: I,
    enableColorOnDark: o
  }), d = pce(a);
  return /* @__PURE__ */ ne(Bce, k({
    square: !0,
    component: "header",
    ownerState: a,
    elevation: 4,
    className: Ve(d.root, g, I === "fixed" && "mui-fixed"),
    ref: i
  }, s));
}), cO = "base";
function fce(e) {
  return `${cO}--${e}`;
}
function Gce(e, t) {
  return `${cO}-${e}-${t}`;
}
function dO(e, t) {
  const i = k4[t];
  return i ? fce(i) : Gce(e, t);
}
function yce(e, t) {
  const i = {};
  return t.forEach((n) => {
    i[n] = dO(e, n);
  }), i;
}
const Wce = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Sce(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function Vce(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let i = t(`[name="${e.name}"]:checked`);
  return i || (i = t(`[name="${e.name}"]`)), i !== e;
}
function wce(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Vce(e));
}
function vce(e) {
  const t = [], i = [];
  return Array.from(e.querySelectorAll(Wce)).forEach((n, g) => {
    const r = Sce(n);
    r === -1 || !wce(n) || (r === 0 ? t.push(n) : i.push({
      documentOrder: g,
      tabIndex: r,
      node: n
    }));
  }), i.sort((n, g) => n.tabIndex === g.tabIndex ? n.documentOrder - g.documentOrder : n.tabIndex - g.tabIndex).map((n) => n.node).concat(t);
}
function Rce() {
  return !0;
}
function Xce(e) {
  const {
    children: t,
    disableAutoFocus: i = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: g = !1,
    getTabbable: r = vce,
    isEnabled: o = Rce,
    open: I
  } = e, s = Y.useRef(!1), a = Y.useRef(null), d = Y.useRef(null), C = Y.useRef(null), u = Y.useRef(null), A = Y.useRef(!1), m = Y.useRef(null), h = gn(t.ref, m), B = Y.useRef(null);
  Y.useEffect(() => {
    !I || !m.current || (A.current = !i);
  }, [i, I]), Y.useEffect(() => {
    if (!I || !m.current)
      return;
    const y = Gg(m.current);
    return m.current.contains(y.activeElement) || (m.current.hasAttribute("tabIndex") || m.current.setAttribute("tabIndex", "-1"), A.current && m.current.focus()), () => {
      g || (C.current && C.current.focus && (s.current = !0, C.current.focus()), C.current = null);
    };
  }, [I]), Y.useEffect(() => {
    if (!I || !m.current)
      return;
    const y = Gg(m.current), W = (v) => {
      B.current = v, !(n || !o() || v.key !== "Tab") && y.activeElement === m.current && v.shiftKey && (s.current = !0, d.current && d.current.focus());
    }, V = () => {
      const v = m.current;
      if (v === null)
        return;
      if (!y.hasFocus() || !o() || s.current) {
        s.current = !1;
        return;
      }
      if (v.contains(y.activeElement) || n && y.activeElement !== a.current && y.activeElement !== d.current)
        return;
      if (y.activeElement !== u.current)
        u.current = null;
      else if (u.current !== null)
        return;
      if (!A.current)
        return;
      let H = [];
      if ((y.activeElement === a.current || y.activeElement === d.current) && (H = r(m.current)), H.length > 0) {
        var x, N;
        const M = !!((x = B.current) != null && x.shiftKey && ((N = B.current) == null ? void 0 : N.key) === "Tab"), $ = H[0], q = H[H.length - 1];
        typeof $ != "string" && typeof q != "string" && (M ? q.focus() : $.focus());
      } else
        v.focus();
    };
    y.addEventListener("focusin", V), y.addEventListener("keydown", W, !0);
    const w = setInterval(() => {
      y.activeElement && y.activeElement.tagName === "BODY" && V();
    }, 50);
    return () => {
      clearInterval(w), y.removeEventListener("focusin", V), y.removeEventListener("keydown", W, !0);
    };
  }, [i, n, g, o, I, r]);
  const f = (y) => {
    C.current === null && (C.current = y.relatedTarget), A.current = !0, u.current = y.target;
    const W = t.props.onFocus;
    W && W(y);
  }, G = (y) => {
    C.current === null && (C.current = y.relatedTarget), A.current = !0;
  };
  return /* @__PURE__ */ Ci(Y.Fragment, {
    children: [/* @__PURE__ */ ne("div", {
      tabIndex: I ? 0 : -1,
      onFocus: G,
      ref: a,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ Y.cloneElement(t, {
      ref: h,
      onFocus: f
    }), /* @__PURE__ */ ne("div", {
      tabIndex: I ? 0 : -1,
      onFocus: G,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
function Hce(e) {
  return typeof e == "function" ? e() : e;
}
const CO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    children: n,
    container: g,
    disablePortal: r = !1
  } = t, [o, I] = Y.useState(null), s = gn(/* @__PURE__ */ Y.isValidElement(n) ? n.ref : null, i);
  if (eo(() => {
    r || I(Hce(g) || document.body);
  }, [g, r]), eo(() => {
    if (o && !r)
      return LB(i, o), () => {
        LB(i, null);
      };
  }, [i, o, r]), r) {
    if (/* @__PURE__ */ Y.isValidElement(n)) {
      const a = {
        ref: s
      };
      return /* @__PURE__ */ Y.cloneElement(n, a);
    }
    return /* @__PURE__ */ ne(Y.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ ne(Y.Fragment, {
    children: o && /* @__PURE__ */ ige.createPortal(n, o)
  });
});
function kce(e) {
  const t = Gg(e);
  return t.body === e ? pl(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function cB(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function dN(e) {
  return parseInt(pl(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Fce(e) {
  const i = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return i || n;
}
function CN(e, t, i, n, g) {
  const r = [t, i, ...n];
  [].forEach.call(e.children, (o) => {
    const I = r.indexOf(o) === -1, s = !Fce(o);
    I && s && cB(o, g);
  });
}
function Ik(e, t) {
  let i = -1;
  return e.some((n, g) => t(n) ? (i = g, !0) : !1), i;
}
function Yce(e, t) {
  const i = [], n = e.container;
  if (!t.disableScrollLock) {
    if (kce(n)) {
      const o = L4(Gg(n));
      i.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${dN(n) + o}px`;
      const I = Gg(n).querySelectorAll(".mui-fixed");
      [].forEach.call(I, (s) => {
        i.push({
          value: s.style.paddingRight,
          property: "padding-right",
          el: s
        }), s.style.paddingRight = `${dN(s) + o}px`;
      });
    }
    let r;
    if (n.parentNode instanceof DocumentFragment)
      r = Gg(n).body;
    else {
      const o = n.parentElement, I = pl(n);
      r = (o == null ? void 0 : o.nodeName) === "HTML" && I.getComputedStyle(o).overflowY === "scroll" ? o : n;
    }
    i.push({
      value: r.style.overflow,
      property: "overflow",
      el: r
    }, {
      value: r.style.overflowX,
      property: "overflow-x",
      el: r
    }, {
      value: r.style.overflowY,
      property: "overflow-y",
      el: r
    }), r.style.overflow = "hidden";
  }
  return () => {
    i.forEach(({
      value: r,
      el: o,
      property: I
    }) => {
      r ? o.style.setProperty(I, r) : o.style.removeProperty(I);
    });
  };
}
function xce(e) {
  const t = [];
  return [].forEach.call(e.children, (i) => {
    i.getAttribute("aria-hidden") === "true" && t.push(i);
  }), t;
}
class Dce {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, i) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && cB(t.modalRef, !1);
    const g = xce(i);
    CN(i, t.mount, t.modalRef, g, !0);
    const r = Ik(this.containers, (o) => o.container === i);
    return r !== -1 ? (this.containers[r].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: i,
      restore: null,
      hiddenSiblings: g
    }), n);
  }
  mount(t, i) {
    const n = Ik(this.containers, (r) => r.modals.indexOf(t) !== -1), g = this.containers[n];
    g.restore || (g.restore = Yce(g, i));
  }
  remove(t, i = !0) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const g = Ik(this.containers, (o) => o.modals.indexOf(t) !== -1), r = this.containers[g];
    if (r.modals.splice(r.modals.indexOf(t), 1), this.modals.splice(n, 1), r.modals.length === 0)
      r.restore && r.restore(), t.modalRef && cB(t.modalRef, i), CN(r.container, t.mount, t.modalRef, r.hiddenSiblings, !1), this.containers.splice(g, 1);
    else {
      const o = r.modals[r.modals.length - 1];
      o.modalRef && cB(o.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function Jce(e) {
  return typeof e == "function" ? e() : e;
}
function Kce(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Ece = new Dce();
function Nce(e) {
  const {
    container: t,
    disableEscapeKeyDown: i = !1,
    disableScrollLock: n = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: g = Ece,
    closeAfterTransition: r = !1,
    onTransitionEnter: o,
    onTransitionExited: I,
    children: s,
    onClose: a,
    open: d,
    rootRef: C
  } = e, u = Y.useRef({}), A = Y.useRef(null), m = Y.useRef(null), h = gn(m, C), [B, f] = Y.useState(!d), G = Kce(s);
  let y = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (y = !1);
  const W = () => Gg(A.current), V = () => (u.current.modalRef = m.current, u.current.mount = A.current, u.current), w = () => {
    g.mount(V(), {
      disableScrollLock: n
    }), m.current && (m.current.scrollTop = 0);
  }, v = zg(() => {
    const P = Jce(t) || W().body;
    g.add(V(), P), m.current && w();
  }), H = Y.useCallback(() => g.isTopModal(V()), [g]), x = zg((P) => {
    A.current = P, P && (d && H() ? w() : m.current && cB(m.current, y));
  }), N = Y.useCallback(() => {
    g.remove(V(), y);
  }, [y, g]);
  Y.useEffect(() => () => {
    N();
  }, [N]), Y.useEffect(() => {
    d ? v() : (!G || !r) && N();
  }, [d, N, G, r, v]);
  const M = (P) => (Q) => {
    var te;
    (te = P.onKeyDown) == null || te.call(P, Q), !(Q.key !== "Escape" || Q.which === 229 || // Wait until IME is settled.
    !H()) && (i || (Q.stopPropagation(), a && a(Q, "escapeKeyDown")));
  }, $ = (P) => (Q) => {
    var te;
    (te = P.onClick) == null || te.call(P, Q), Q.target === Q.currentTarget && a && a(Q, "backdropClick");
  };
  return {
    getRootProps: (P = {}) => {
      const Q = aB(e);
      delete Q.onTransitionEnter, delete Q.onTransitionExited;
      const te = k({}, Q, P);
      return k({
        role: "presentation"
      }, te, {
        onKeyDown: M(te),
        ref: h
      });
    },
    getBackdropProps: (P = {}) => {
      const Q = P;
      return k({
        "aria-hidden": !0
      }, Q, {
        onClick: $(Q),
        open: d
      });
    },
    getTransitionProps: () => {
      const P = () => {
        f(!1), o && o();
      }, Q = () => {
        f(!0), I && I(), r && N();
      };
      return {
        onEnter: wS(P, s == null ? void 0 : s.props.onEnter),
        onExited: wS(Q, s == null ? void 0 : s.props.onExited)
      };
    },
    rootRef: h,
    portalRef: x,
    isTopModal: H,
    exited: B,
    hasTransition: G
  };
}
var Uo = "top", Zl = "bottom", fl = "right", Po = "left", z5 = "auto", RZ = [Uo, Zl, fl, Po], Vm = "start", TB = "end", Lce = "clippingParents", uO = "viewport", b0 = "popper", Tce = "reference", uN = /* @__PURE__ */ RZ.reduce(function(e, t) {
  return e.concat([t + "-" + Vm, t + "-" + TB]);
}, []), AO = /* @__PURE__ */ [].concat(RZ, [z5]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Vm, t + "-" + TB]);
}, []), Mce = "beforeRead", Uce = "read", Pce = "afterRead", zce = "beforeMain", Oce = "main", Qce = "afterMain", jce = "beforeWrite", _ce = "write", $ce = "afterWrite", qce = [Mce, Uce, Pce, zce, Oce, Qce, jce, _ce, $ce];
function ca(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function kI(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Fu(e) {
  var t = kI(e).Element;
  return e instanceof t || e instanceof Element;
}
function bl(e) {
  var t = kI(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function O5(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = kI(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function ede(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(i) {
    var n = t.styles[i] || {}, g = t.attributes[i] || {}, r = t.elements[i];
    !bl(r) || !ca(r) || (Object.assign(r.style, n), Object.keys(g).forEach(function(o) {
      var I = g[o];
      I === !1 ? r.removeAttribute(o) : r.setAttribute(o, I === !0 ? "" : I);
    }));
  });
}
function tde(e) {
  var t = e.state, i = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var g = t.elements[n], r = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : i[n]), I = o.reduce(function(s, a) {
        return s[a] = "", s;
      }, {});
      !bl(g) || !ca(g) || (Object.assign(g.style, I), Object.keys(r).forEach(function(s) {
        g.removeAttribute(s);
      }));
    });
  };
}
const ide = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ede,
  effect: tde,
  requires: ["computeStyles"]
};
function Ia(e) {
  return e.split("-")[0];
}
var vu = Math.max, kS = Math.min, wm = Math.round;
function uY() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function bO() {
  return !/^((?!chrome|android).)*safari/i.test(uY());
}
function vm(e, t, i) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  var n = e.getBoundingClientRect(), g = 1, r = 1;
  t && bl(e) && (g = e.offsetWidth > 0 && wm(n.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && wm(n.height) / e.offsetHeight || 1);
  var o = Fu(e) ? kI(e) : window, I = o.visualViewport, s = !bO() && i, a = (n.left + (s && I ? I.offsetLeft : 0)) / g, d = (n.top + (s && I ? I.offsetTop : 0)) / r, C = n.width / g, u = n.height / r;
  return {
    width: C,
    height: u,
    top: d,
    right: a + C,
    bottom: d + u,
    left: a,
    x: a,
    y: d
  };
}
function Q5(e) {
  var t = vm(e), i = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: i,
    height: n
  };
}
function mO(e, t) {
  var i = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (i && O5(i)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function bc(e) {
  return kI(e).getComputedStyle(e);
}
function nde(e) {
  return ["table", "td", "th"].indexOf(ca(e)) >= 0;
}
function Pd(e) {
  return ((Fu(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Mw(e) {
  return ca(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (O5(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Pd(e)
  );
}
function AN(e) {
  return !bl(e) || // https://github.com/popperjs/popper-core/issues/837
  bc(e).position === "fixed" ? null : e.offsetParent;
}
function gde(e) {
  var t = /firefox/i.test(uY()), i = /Trident/i.test(uY());
  if (i && bl(e)) {
    var n = bc(e);
    if (n.position === "fixed")
      return null;
  }
  var g = Mw(e);
  for (O5(g) && (g = g.host); bl(g) && ["html", "body"].indexOf(ca(g)) < 0; ) {
    var r = bc(g);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || t && r.willChange === "filter" || t && r.filter && r.filter !== "none")
      return g;
    g = g.parentNode;
  }
  return null;
}
function XZ(e) {
  for (var t = kI(e), i = AN(e); i && nde(i) && bc(i).position === "static"; )
    i = AN(i);
  return i && (ca(i) === "html" || ca(i) === "body" && bc(i).position === "static") ? t : i || gde(e) || t;
}
function j5(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function dB(e, t, i) {
  return vu(e, kS(t, i));
}
function rde(e, t, i) {
  var n = dB(e, t, i);
  return n > i ? i : n;
}
function hO() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function pO(e) {
  return Object.assign({}, hO(), e);
}
function BO(e, t) {
  return t.reduce(function(i, n) {
    return i[n] = e, i;
  }, {});
}
var ode = function(t, i) {
  return t = typeof t == "function" ? t(Object.assign({}, i.rects, {
    placement: i.placement
  })) : t, pO(typeof t != "number" ? t : BO(t, RZ));
};
function Ide(e) {
  var t, i = e.state, n = e.name, g = e.options, r = i.elements.arrow, o = i.modifiersData.popperOffsets, I = Ia(i.placement), s = j5(I), a = [Po, fl].indexOf(I) >= 0, d = a ? "height" : "width";
  if (!(!r || !o)) {
    var C = ode(g.padding, i), u = Q5(r), A = s === "y" ? Uo : Po, m = s === "y" ? Zl : fl, h = i.rects.reference[d] + i.rects.reference[s] - o[s] - i.rects.popper[d], B = o[s] - i.rects.reference[s], f = XZ(r), G = f ? s === "y" ? f.clientHeight || 0 : f.clientWidth || 0 : 0, y = h / 2 - B / 2, W = C[A], V = G - u[d] - C[m], w = G / 2 - u[d] / 2 + y, v = dB(W, w, V), H = s;
    i.modifiersData[n] = (t = {}, t[H] = v, t.centerOffset = v - w, t);
  }
}
function lde(e) {
  var t = e.state, i = e.options, n = i.element, g = n === void 0 ? "[data-popper-arrow]" : n;
  g != null && (typeof g == "string" && (g = t.elements.popper.querySelector(g), !g) || mO(t.elements.popper, g) && (t.elements.arrow = g));
}
const sde = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ide,
  effect: lde,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Rm(e) {
  return e.split("-")[1];
}
var ade = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function cde(e, t) {
  var i = e.x, n = e.y, g = t.devicePixelRatio || 1;
  return {
    x: wm(i * g) / g || 0,
    y: wm(n * g) / g || 0
  };
}
function bN(e) {
  var t, i = e.popper, n = e.popperRect, g = e.placement, r = e.variation, o = e.offsets, I = e.position, s = e.gpuAcceleration, a = e.adaptive, d = e.roundOffsets, C = e.isFixed, u = o.x, A = u === void 0 ? 0 : u, m = o.y, h = m === void 0 ? 0 : m, B = typeof d == "function" ? d({
    x: A,
    y: h
  }) : {
    x: A,
    y: h
  };
  A = B.x, h = B.y;
  var f = o.hasOwnProperty("x"), G = o.hasOwnProperty("y"), y = Po, W = Uo, V = window;
  if (a) {
    var w = XZ(i), v = "clientHeight", H = "clientWidth";
    if (w === kI(i) && (w = Pd(i), bc(w).position !== "static" && I === "absolute" && (v = "scrollHeight", H = "scrollWidth")), w = w, g === Uo || (g === Po || g === fl) && r === TB) {
      W = Zl;
      var x = C && w === V && V.visualViewport ? V.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        w[v]
      );
      h -= x - n.height, h *= s ? 1 : -1;
    }
    if (g === Po || (g === Uo || g === Zl) && r === TB) {
      y = fl;
      var N = C && w === V && V.visualViewport ? V.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        w[H]
      );
      A -= N - n.width, A *= s ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: I
  }, a && ade), $ = d === !0 ? cde({
    x: A,
    y: h
  }, kI(i)) : {
    x: A,
    y: h
  };
  if (A = $.x, h = $.y, s) {
    var q;
    return Object.assign({}, M, (q = {}, q[W] = G ? "0" : "", q[y] = f ? "0" : "", q.transform = (V.devicePixelRatio || 1) <= 1 ? "translate(" + A + "px, " + h + "px)" : "translate3d(" + A + "px, " + h + "px, 0)", q));
  }
  return Object.assign({}, M, (t = {}, t[W] = G ? h + "px" : "", t[y] = f ? A + "px" : "", t.transform = "", t));
}
function dde(e) {
  var t = e.state, i = e.options, n = i.gpuAcceleration, g = n === void 0 ? !0 : n, r = i.adaptive, o = r === void 0 ? !0 : r, I = i.roundOffsets, s = I === void 0 ? !0 : I, a = {
    placement: Ia(t.placement),
    variation: Rm(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: g,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, bN(Object.assign({}, a, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, bN(Object.assign({}, a, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Cde = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: dde,
  data: {}
};
var Py = {
  passive: !0
};
function ude(e) {
  var t = e.state, i = e.instance, n = e.options, g = n.scroll, r = g === void 0 ? !0 : g, o = n.resize, I = o === void 0 ? !0 : o, s = kI(t.elements.popper), a = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return r && a.forEach(function(d) {
    d.addEventListener("scroll", i.update, Py);
  }), I && s.addEventListener("resize", i.update, Py), function() {
    r && a.forEach(function(d) {
      d.removeEventListener("scroll", i.update, Py);
    }), I && s.removeEventListener("resize", i.update, Py);
  };
}
const Ade = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ude,
  data: {}
};
var bde = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function IS(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return bde[t];
  });
}
var mde = {
  start: "end",
  end: "start"
};
function mN(e) {
  return e.replace(/start|end/g, function(t) {
    return mde[t];
  });
}
function _5(e) {
  var t = kI(e), i = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: n
  };
}
function $5(e) {
  return vm(Pd(e)).left + _5(e).scrollLeft;
}
function hde(e, t) {
  var i = kI(e), n = Pd(e), g = i.visualViewport, r = n.clientWidth, o = n.clientHeight, I = 0, s = 0;
  if (g) {
    r = g.width, o = g.height;
    var a = bO();
    (a || !a && t === "fixed") && (I = g.offsetLeft, s = g.offsetTop);
  }
  return {
    width: r,
    height: o,
    x: I + $5(e),
    y: s
  };
}
function pde(e) {
  var t, i = Pd(e), n = _5(e), g = (t = e.ownerDocument) == null ? void 0 : t.body, r = vu(i.scrollWidth, i.clientWidth, g ? g.scrollWidth : 0, g ? g.clientWidth : 0), o = vu(i.scrollHeight, i.clientHeight, g ? g.scrollHeight : 0, g ? g.clientHeight : 0), I = -n.scrollLeft + $5(e), s = -n.scrollTop;
  return bc(g || i).direction === "rtl" && (I += vu(i.clientWidth, g ? g.clientWidth : 0) - r), {
    width: r,
    height: o,
    x: I,
    y: s
  };
}
function q5(e) {
  var t = bc(e), i = t.overflow, n = t.overflowX, g = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + g + n);
}
function ZO(e) {
  return ["html", "body", "#document"].indexOf(ca(e)) >= 0 ? e.ownerDocument.body : bl(e) && q5(e) ? e : ZO(Mw(e));
}
function CB(e, t) {
  var i;
  t === void 0 && (t = []);
  var n = ZO(e), g = n === ((i = e.ownerDocument) == null ? void 0 : i.body), r = kI(n), o = g ? [r].concat(r.visualViewport || [], q5(n) ? n : []) : n, I = t.concat(o);
  return g ? I : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    I.concat(CB(Mw(o)))
  );
}
function AY(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Bde(e, t) {
  var i = vm(e, !1, t === "fixed");
  return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
}
function hN(e, t, i) {
  return t === uO ? AY(hde(e, i)) : Fu(t) ? Bde(t, i) : AY(pde(Pd(e)));
}
function Zde(e) {
  var t = CB(Mw(e)), i = ["absolute", "fixed"].indexOf(bc(e).position) >= 0, n = i && bl(e) ? XZ(e) : e;
  return Fu(n) ? t.filter(function(g) {
    return Fu(g) && mO(g, n) && ca(g) !== "body";
  }) : [];
}
function fde(e, t, i, n) {
  var g = t === "clippingParents" ? Zde(e) : [].concat(t), r = [].concat(g, [i]), o = r[0], I = r.reduce(function(s, a) {
    var d = hN(e, a, n);
    return s.top = vu(d.top, s.top), s.right = kS(d.right, s.right), s.bottom = kS(d.bottom, s.bottom), s.left = vu(d.left, s.left), s;
  }, hN(e, o, n));
  return I.width = I.right - I.left, I.height = I.bottom - I.top, I.x = I.left, I.y = I.top, I;
}
function fO(e) {
  var t = e.reference, i = e.element, n = e.placement, g = n ? Ia(n) : null, r = n ? Rm(n) : null, o = t.x + t.width / 2 - i.width / 2, I = t.y + t.height / 2 - i.height / 2, s;
  switch (g) {
    case Uo:
      s = {
        x: o,
        y: t.y - i.height
      };
      break;
    case Zl:
      s = {
        x: o,
        y: t.y + t.height
      };
      break;
    case fl:
      s = {
        x: t.x + t.width,
        y: I
      };
      break;
    case Po:
      s = {
        x: t.x - i.width,
        y: I
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var a = g ? j5(g) : null;
  if (a != null) {
    var d = a === "y" ? "height" : "width";
    switch (r) {
      case Vm:
        s[a] = s[a] - (t[d] / 2 - i[d] / 2);
        break;
      case TB:
        s[a] = s[a] + (t[d] / 2 - i[d] / 2);
        break;
    }
  }
  return s;
}
function MB(e, t) {
  t === void 0 && (t = {});
  var i = t, n = i.placement, g = n === void 0 ? e.placement : n, r = i.strategy, o = r === void 0 ? e.strategy : r, I = i.boundary, s = I === void 0 ? Lce : I, a = i.rootBoundary, d = a === void 0 ? uO : a, C = i.elementContext, u = C === void 0 ? b0 : C, A = i.altBoundary, m = A === void 0 ? !1 : A, h = i.padding, B = h === void 0 ? 0 : h, f = pO(typeof B != "number" ? B : BO(B, RZ)), G = u === b0 ? Tce : b0, y = e.rects.popper, W = e.elements[m ? G : u], V = fde(Fu(W) ? W : W.contextElement || Pd(e.elements.popper), s, d, o), w = vm(e.elements.reference), v = fO({
    reference: w,
    element: y,
    strategy: "absolute",
    placement: g
  }), H = AY(Object.assign({}, y, v)), x = u === b0 ? H : w, N = {
    top: V.top - x.top + f.top,
    bottom: x.bottom - V.bottom + f.bottom,
    left: V.left - x.left + f.left,
    right: x.right - V.right + f.right
  }, M = e.modifiersData.offset;
  if (u === b0 && M) {
    var $ = M[g];
    Object.keys(N).forEach(function(q) {
      var E = [fl, Zl].indexOf(q) >= 0 ? 1 : -1, L = [Uo, Zl].indexOf(q) >= 0 ? "y" : "x";
      N[q] += $[L] * E;
    });
  }
  return N;
}
function Gde(e, t) {
  t === void 0 && (t = {});
  var i = t, n = i.placement, g = i.boundary, r = i.rootBoundary, o = i.padding, I = i.flipVariations, s = i.allowedAutoPlacements, a = s === void 0 ? AO : s, d = Rm(n), C = d ? I ? uN : uN.filter(function(m) {
    return Rm(m) === d;
  }) : RZ, u = C.filter(function(m) {
    return a.indexOf(m) >= 0;
  });
  u.length === 0 && (u = C);
  var A = u.reduce(function(m, h) {
    return m[h] = MB(e, {
      placement: h,
      boundary: g,
      rootBoundary: r,
      padding: o
    })[Ia(h)], m;
  }, {});
  return Object.keys(A).sort(function(m, h) {
    return A[m] - A[h];
  });
}
function yde(e) {
  if (Ia(e) === z5)
    return [];
  var t = IS(e);
  return [mN(e), t, mN(t)];
}
function Wde(e) {
  var t = e.state, i = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var g = i.mainAxis, r = g === void 0 ? !0 : g, o = i.altAxis, I = o === void 0 ? !0 : o, s = i.fallbackPlacements, a = i.padding, d = i.boundary, C = i.rootBoundary, u = i.altBoundary, A = i.flipVariations, m = A === void 0 ? !0 : A, h = i.allowedAutoPlacements, B = t.options.placement, f = Ia(B), G = f === B, y = s || (G || !m ? [IS(B)] : yde(B)), W = [B].concat(y).reduce(function(ve, Be) {
      return ve.concat(Ia(Be) === z5 ? Gde(t, {
        placement: Be,
        boundary: d,
        rootBoundary: C,
        padding: a,
        flipVariations: m,
        allowedAutoPlacements: h
      }) : Be);
    }, []), V = t.rects.reference, w = t.rects.popper, v = /* @__PURE__ */ new Map(), H = !0, x = W[0], N = 0; N < W.length; N++) {
      var M = W[N], $ = Ia(M), q = Rm(M) === Vm, E = [Uo, Zl].indexOf($) >= 0, L = E ? "width" : "height", P = MB(t, {
        placement: M,
        boundary: d,
        rootBoundary: C,
        altBoundary: u,
        padding: a
      }), Q = E ? q ? fl : Po : q ? Zl : Uo;
      V[L] > w[L] && (Q = IS(Q));
      var te = IS(Q), le = [];
      if (r && le.push(P[$] <= 0), I && le.push(P[Q] <= 0, P[te] <= 0), le.every(function(ve) {
        return ve;
      })) {
        x = M, H = !1;
        break;
      }
      v.set(M, le);
    }
    if (H)
      for (var Ae = m ? 3 : 1, we = function(Be) {
        var ue = W.find(function(Xe) {
          var Ze = v.get(Xe);
          if (Ze)
            return Ze.slice(0, Be).every(function(Ke) {
              return Ke;
            });
        });
        if (ue)
          return x = ue, "break";
      }, Ee = Ae; Ee > 0; Ee--) {
        var Je = we(Ee);
        if (Je === "break")
          break;
      }
    t.placement !== x && (t.modifiersData[n]._skip = !0, t.placement = x, t.reset = !0);
  }
}
const Sde = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Wde,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function pN(e, t, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - i.y,
    right: e.right - t.width + i.x,
    bottom: e.bottom - t.height + i.y,
    left: e.left - t.width - i.x
  };
}
function BN(e) {
  return [Uo, fl, Zl, Po].some(function(t) {
    return e[t] >= 0;
  });
}
function Vde(e) {
  var t = e.state, i = e.name, n = t.rects.reference, g = t.rects.popper, r = t.modifiersData.preventOverflow, o = MB(t, {
    elementContext: "reference"
  }), I = MB(t, {
    altBoundary: !0
  }), s = pN(o, n), a = pN(I, g, r), d = BN(s), C = BN(a);
  t.modifiersData[i] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: a,
    isReferenceHidden: d,
    hasPopperEscaped: C
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": C
  });
}
const wde = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Vde
};
function vde(e, t, i) {
  var n = Ia(e), g = [Po, Uo].indexOf(n) >= 0 ? -1 : 1, r = typeof i == "function" ? i(Object.assign({}, t, {
    placement: e
  })) : i, o = r[0], I = r[1];
  return o = o || 0, I = (I || 0) * g, [Po, fl].indexOf(n) >= 0 ? {
    x: I,
    y: o
  } : {
    x: o,
    y: I
  };
}
function Rde(e) {
  var t = e.state, i = e.options, n = e.name, g = i.offset, r = g === void 0 ? [0, 0] : g, o = AO.reduce(function(d, C) {
    return d[C] = vde(C, t.rects, r), d;
  }, {}), I = o[t.placement], s = I.x, a = I.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += a), t.modifiersData[n] = o;
}
const Xde = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Rde
};
function Hde(e) {
  var t = e.state, i = e.name;
  t.modifiersData[i] = fO({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const kde = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Hde,
  data: {}
};
function Fde(e) {
  return e === "x" ? "y" : "x";
}
function Yde(e) {
  var t = e.state, i = e.options, n = e.name, g = i.mainAxis, r = g === void 0 ? !0 : g, o = i.altAxis, I = o === void 0 ? !1 : o, s = i.boundary, a = i.rootBoundary, d = i.altBoundary, C = i.padding, u = i.tether, A = u === void 0 ? !0 : u, m = i.tetherOffset, h = m === void 0 ? 0 : m, B = MB(t, {
    boundary: s,
    rootBoundary: a,
    padding: C,
    altBoundary: d
  }), f = Ia(t.placement), G = Rm(t.placement), y = !G, W = j5(f), V = Fde(W), w = t.modifiersData.popperOffsets, v = t.rects.reference, H = t.rects.popper, x = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, N = typeof x == "number" ? {
    mainAxis: x,
    altAxis: x
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, x), M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, $ = {
    x: 0,
    y: 0
  };
  if (w) {
    if (r) {
      var q, E = W === "y" ? Uo : Po, L = W === "y" ? Zl : fl, P = W === "y" ? "height" : "width", Q = w[W], te = Q + B[E], le = Q - B[L], Ae = A ? -H[P] / 2 : 0, we = G === Vm ? v[P] : H[P], Ee = G === Vm ? -H[P] : -v[P], Je = t.elements.arrow, ve = A && Je ? Q5(Je) : {
        width: 0,
        height: 0
      }, Be = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : hO(), ue = Be[E], Xe = Be[L], Ze = dB(0, v[P], ve[P]), Ke = y ? v[P] / 2 - Ae - Ze - ue - N.mainAxis : we - Ze - ue - N.mainAxis, $e = y ? -v[P] / 2 + Ae + Ze + Xe + N.mainAxis : Ee + Ze + Xe + N.mainAxis, rt = t.elements.arrow && XZ(t.elements.arrow), dt = rt ? W === "y" ? rt.clientTop || 0 : rt.clientLeft || 0 : 0, ot = (q = M == null ? void 0 : M[W]) != null ? q : 0, ze = Q + Ke - ot - dt, tt = Q + $e - ot, st = dB(A ? kS(te, ze) : te, Q, A ? vu(le, tt) : le);
      w[W] = st, $[W] = st - Q;
    }
    if (I) {
      var Kt, ie = W === "x" ? Uo : Po, J = W === "x" ? Zl : fl, Ce = w[V], xe = V === "y" ? "height" : "width", Le = Ce + B[ie], Ye = Ce - B[J], qe = [Uo, Po].indexOf(f) !== -1, Yt = (Kt = M == null ? void 0 : M[V]) != null ? Kt : 0, qt = qe ? Le : Ce - v[xe] - H[xe] - Yt + N.altAxis, Ut = qe ? Ce + v[xe] + H[xe] - Yt - N.altAxis : Ye, Ge = A && qe ? rde(qt, Ce, Ut) : dB(A ? qt : Le, Ce, A ? Ut : Ye);
      w[V] = Ge, $[V] = Ge - Ce;
    }
    t.modifiersData[n] = $;
  }
}
const xde = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Yde,
  requiresIfExists: ["offset"]
};
function Dde(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Jde(e) {
  return e === kI(e) || !bl(e) ? _5(e) : Dde(e);
}
function Kde(e) {
  var t = e.getBoundingClientRect(), i = wm(t.width) / e.offsetWidth || 1, n = wm(t.height) / e.offsetHeight || 1;
  return i !== 1 || n !== 1;
}
function Ede(e, t, i) {
  i === void 0 && (i = !1);
  var n = bl(t), g = bl(t) && Kde(t), r = Pd(t), o = vm(e, g, i), I = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !i) && ((ca(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  q5(r)) && (I = Jde(t)), bl(t) ? (s = vm(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : r && (s.x = $5(r))), {
    x: o.left + I.scrollLeft - s.x,
    y: o.top + I.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function Nde(e) {
  var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(r) {
    t.set(r.name, r);
  });
  function g(r) {
    i.add(r.name);
    var o = [].concat(r.requires || [], r.requiresIfExists || []);
    o.forEach(function(I) {
      if (!i.has(I)) {
        var s = t.get(I);
        s && g(s);
      }
    }), n.push(r);
  }
  return e.forEach(function(r) {
    i.has(r.name) || g(r);
  }), n;
}
function Lde(e) {
  var t = Nde(e);
  return qce.reduce(function(i, n) {
    return i.concat(t.filter(function(g) {
      return g.phase === n;
    }));
  }, []);
}
function Tde(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(i) {
      Promise.resolve().then(function() {
        t = void 0, i(e());
      });
    })), t;
  };
}
function Mde(e) {
  var t = e.reduce(function(i, n) {
    var g = i[n.name];
    return i[n.name] = g ? Object.assign({}, g, n, {
      options: Object.assign({}, g.options, n.options),
      data: Object.assign({}, g.data, n.data)
    }) : n, i;
  }, {});
  return Object.keys(t).map(function(i) {
    return t[i];
  });
}
var ZN = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function fN() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Ude(e) {
  e === void 0 && (e = {});
  var t = e, i = t.defaultModifiers, n = i === void 0 ? [] : i, g = t.defaultOptions, r = g === void 0 ? ZN : g;
  return function(I, s, a) {
    a === void 0 && (a = r);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ZN, r),
      modifiersData: {},
      elements: {
        reference: I,
        popper: s
      },
      attributes: {},
      styles: {}
    }, C = [], u = !1, A = {
      state: d,
      setOptions: function(f) {
        var G = typeof f == "function" ? f(d.options) : f;
        h(), d.options = Object.assign({}, r, d.options, G), d.scrollParents = {
          reference: Fu(I) ? CB(I) : I.contextElement ? CB(I.contextElement) : [],
          popper: CB(s)
        };
        var y = Lde(Mde([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = y.filter(function(W) {
          return W.enabled;
        }), m(), A.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!u) {
          var f = d.elements, G = f.reference, y = f.popper;
          if (fN(G, y)) {
            d.rects = {
              reference: Ede(G, XZ(y), d.options.strategy === "fixed"),
              popper: Q5(y)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(N) {
              return d.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var W = 0; W < d.orderedModifiers.length; W++) {
              if (d.reset === !0) {
                d.reset = !1, W = -1;
                continue;
              }
              var V = d.orderedModifiers[W], w = V.fn, v = V.options, H = v === void 0 ? {} : v, x = V.name;
              typeof w == "function" && (d = w({
                state: d,
                options: H,
                name: x,
                instance: A
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Tde(function() {
        return new Promise(function(B) {
          A.forceUpdate(), B(d);
        });
      }),
      destroy: function() {
        h(), u = !0;
      }
    };
    if (!fN(I, s))
      return A;
    A.setOptions(a).then(function(B) {
      !u && a.onFirstUpdate && a.onFirstUpdate(B);
    });
    function m() {
      d.orderedModifiers.forEach(function(B) {
        var f = B.name, G = B.options, y = G === void 0 ? {} : G, W = B.effect;
        if (typeof W == "function") {
          var V = W({
            state: d,
            name: f,
            instance: A,
            options: y
          }), w = function() {
          };
          C.push(V || w);
        }
      });
    }
    function h() {
      C.forEach(function(B) {
        return B();
      }), C = [];
    }
    return A;
  };
}
var Pde = [Ade, kde, Cde, ide, Xde, Sde, xde, sde, wde], zde = /* @__PURE__ */ Ude({
  defaultModifiers: Pde
});
const GO = "Popper";
function Ode(e) {
  return dO(GO, e);
}
yce(GO, ["root"]);
const Qde = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], jde = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function _de(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function bY(e) {
  return typeof e == "function" ? e() : e;
}
function $de(e) {
  return e.nodeType !== void 0;
}
const qde = () => Vt({
  root: ["root"]
}, fae(Ode)), eCe = {}, tCe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n;
  const {
    anchorEl: g,
    children: r,
    direction: o,
    disablePortal: I,
    modifiers: s,
    open: a,
    placement: d,
    popperOptions: C,
    popperRef: u,
    slotProps: A = {},
    slots: m = {},
    TransitionProps: h
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, B = Ue(t, Qde), f = Y.useRef(null), G = gn(f, i), y = Y.useRef(null), W = gn(y, u), V = Y.useRef(W);
  eo(() => {
    V.current = W;
  }, [W]), Y.useImperativeHandle(u, () => y.current, []);
  const w = _de(d, o), [v, H] = Y.useState(w), [x, N] = Y.useState(bY(g));
  Y.useEffect(() => {
    y.current && y.current.forceUpdate();
  }), Y.useEffect(() => {
    g && N(bY(g));
  }, [g]), eo(() => {
    if (!x || !a)
      return;
    const L = (te) => {
      H(te.placement);
    };
    let P = [{
      name: "preventOverflow",
      options: {
        altBoundary: I
      }
    }, {
      name: "flip",
      options: {
        altBoundary: I
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: te
      }) => {
        L(te);
      }
    }];
    s != null && (P = P.concat(s)), C && C.modifiers != null && (P = P.concat(C.modifiers));
    const Q = zde(x, f.current, k({
      placement: w
    }, C, {
      modifiers: P
    }));
    return V.current(Q), () => {
      Q.destroy(), V.current(null);
    };
  }, [x, I, s, a, C, w]);
  const M = {
    placement: v
  };
  h !== null && (M.TransitionProps = h);
  const $ = qde(), q = (n = m.root) != null ? n : "div", E = kg({
    elementType: q,
    externalSlotProps: A.root,
    externalForwardedProps: B,
    additionalProps: {
      role: "tooltip",
      ref: G
    },
    ownerState: t,
    className: $.root
  });
  return /* @__PURE__ */ ne(q, k({}, E, {
    children: typeof r == "function" ? r(M) : r
  }));
}), iCe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    anchorEl: n,
    children: g,
    container: r,
    direction: o = "ltr",
    disablePortal: I = !1,
    keepMounted: s = !1,
    modifiers: a,
    open: d,
    placement: C = "bottom",
    popperOptions: u = eCe,
    popperRef: A,
    style: m,
    transition: h = !1,
    slotProps: B = {},
    slots: f = {}
  } = t, G = Ue(t, jde), [y, W] = Y.useState(!0), V = () => {
    W(!1);
  }, w = () => {
    W(!0);
  };
  if (!s && !d && (!h || y))
    return null;
  let v;
  if (r)
    v = r;
  else if (n) {
    const N = bY(n);
    v = N && $de(N) ? Gg(N).body : Gg(null).body;
  }
  const H = !d && s && (!h || y) ? "none" : void 0, x = h ? {
    in: d,
    onEnter: V,
    onExited: w
  } : void 0;
  return /* @__PURE__ */ ne(CO, {
    disablePortal: I,
    container: v,
    children: /* @__PURE__ */ ne(tCe, k({
      anchorEl: n,
      direction: o,
      disablePortal: I,
      modifiers: a,
      ref: i,
      open: h ? !y : d,
      placement: C,
      popperOptions: u,
      popperRef: A,
      slotProps: B,
      slots: f
    }, G, {
      style: k({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: H
      }, m),
      TransitionProps: x,
      children: g
    }))
  });
}), nCe = 2;
function yO(e, t) {
  return e - t;
}
function GN(e, t) {
  var i;
  const {
    index: n
  } = (i = e.reduce((g, r, o) => {
    const I = Math.abs(t - r);
    return g === null || I < g.distance || I === g.distance ? {
      distance: I,
      index: o
    } : g;
  }, null)) != null ? i : {};
  return n;
}
function zy(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const i = e;
    for (let n = 0; n < i.changedTouches.length; n += 1) {
      const g = i.changedTouches[n];
      if (g.identifier === t.current)
        return {
          x: g.clientX,
          y: g.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function FS(e, t, i) {
  return (e - t) * 100 / (i - t);
}
function gCe(e, t, i) {
  return (i - t) * e + t;
}
function rCe(e) {
  if (Math.abs(e) < 1) {
    const i = e.toExponential().split("e-"), n = i[0].split(".")[1];
    return (n ? n.length : 0) + parseInt(i[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function oCe(e, t, i) {
  const n = Math.round((e - i) / t) * t + i;
  return Number(n.toFixed(rCe(t)));
}
function yN({
  values: e,
  newValue: t,
  index: i
}) {
  const n = e.slice();
  return n[i] = t, n.sort(yO);
}
function Oy({
  sliderRef: e,
  activeIndex: t,
  setActive: i
}) {
  var n, g;
  const r = Gg(e.current);
  if (!((n = e.current) != null && n.contains(r.activeElement)) || Number(r == null || (g = r.activeElement) == null ? void 0 : g.getAttribute("data-index")) !== t) {
    var o;
    (o = e.current) == null || o.querySelector(`[type="range"][data-index="${t}"]`).focus();
  }
  i && i(t);
}
function Qy(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? pae(e, t) : !1;
}
const ICe = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, lCe = (e) => e;
let jy;
function WN() {
  return jy === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? jy = CSS.supports("touch-action", "none") : jy = !0), jy;
}
function sCe(e) {
  const {
    "aria-labelledby": t,
    defaultValue: i,
    disabled: n = !1,
    disableSwap: g = !1,
    isRtl: r = !1,
    marks: o = !1,
    max: I = 100,
    min: s = 0,
    name: a,
    onChange: d,
    onChangeCommitted: C,
    orientation: u = "horizontal",
    rootRef: A,
    scale: m = lCe,
    step: h = 1,
    shiftStep: B = 10,
    tabIndex: f,
    value: G
  } = e, y = Y.useRef(), [W, V] = Y.useState(-1), [w, v] = Y.useState(-1), [H, x] = Y.useState(!1), N = Y.useRef(0), [M, $] = ds({
    controlled: G,
    default: i ?? s,
    name: "Slider"
  }), q = d && ((Ge, pe, _e) => {
    const Gt = Ge.nativeEvent || Ge, Jt = new Gt.constructor(Gt.type, Gt);
    Object.defineProperty(Jt, "target", {
      writable: !0,
      value: {
        value: pe,
        name: a
      }
    }), d(Jt, pe, _e);
  }), E = Array.isArray(M);
  let L = E ? M.slice().sort(yO) : [M];
  L = L.map((Ge) => Ge == null ? s : bu(Ge, s, I));
  const P = o === !0 && h !== null ? [...Array(Math.floor((I - s) / h) + 1)].map((Ge, pe) => ({
    value: s + h * pe
  })) : o || [], Q = P.map((Ge) => Ge.value), {
    isFocusVisibleRef: te,
    onBlur: le,
    onFocus: Ae,
    ref: we
  } = SZ(), [Ee, Je] = Y.useState(-1), ve = Y.useRef(), Be = gn(we, ve), ue = gn(A, Be), Xe = (Ge) => (pe) => {
    var _e;
    const Gt = Number(pe.currentTarget.getAttribute("data-index"));
    Ae(pe), te.current === !0 && Je(Gt), v(Gt), Ge == null || (_e = Ge.onFocus) == null || _e.call(Ge, pe);
  }, Ze = (Ge) => (pe) => {
    var _e;
    le(pe), te.current === !1 && Je(-1), v(-1), Ge == null || (_e = Ge.onBlur) == null || _e.call(Ge, pe);
  }, Ke = (Ge, pe) => {
    const _e = Number(Ge.currentTarget.getAttribute("data-index")), Gt = L[_e], Jt = Q.indexOf(Gt);
    let Te = pe;
    if (P && h == null) {
      const Xt = Q[Q.length - 1];
      Te > Xt ? Te = Xt : Te < Q[0] ? Te = Q[0] : Te = Te < Gt ? Q[Jt - 1] : Q[Jt + 1];
    }
    if (Te = bu(Te, s, I), E) {
      g && (Te = bu(Te, L[_e - 1] || -1 / 0, L[_e + 1] || 1 / 0));
      const Xt = Te;
      Te = yN({
        values: L,
        newValue: Te,
        index: _e
      });
      let Pe = _e;
      g || (Pe = Te.indexOf(Xt)), Oy({
        sliderRef: ve,
        activeIndex: Pe
      });
    }
    $(Te), Je(_e), q && !Qy(Te, M) && q(Ge, Te, _e), C && C(Ge, Te);
  }, $e = (Ge) => (pe) => {
    var _e;
    if (h !== null) {
      const Gt = Number(pe.currentTarget.getAttribute("data-index")), Jt = L[Gt];
      let Te = null;
      (pe.key === "ArrowLeft" || pe.key === "ArrowDown") && pe.shiftKey || pe.key === "PageDown" ? Te = Math.max(Jt - B, s) : ((pe.key === "ArrowRight" || pe.key === "ArrowUp") && pe.shiftKey || pe.key === "PageUp") && (Te = Math.min(Jt + B, I)), Te !== null && (Ke(pe, Te), pe.preventDefault());
    }
    Ge == null || (_e = Ge.onKeyDown) == null || _e.call(Ge, pe);
  };
  eo(() => {
    if (n && ve.current.contains(document.activeElement)) {
      var Ge;
      (Ge = document.activeElement) == null || Ge.blur();
    }
  }, [n]), n && W !== -1 && V(-1), n && Ee !== -1 && Je(-1);
  const rt = (Ge) => (pe) => {
    var _e;
    (_e = Ge.onChange) == null || _e.call(Ge, pe), Ke(pe, pe.target.valueAsNumber);
  }, dt = Y.useRef();
  let ot = u;
  r && u === "horizontal" && (ot += "-reverse");
  const ze = ({
    finger: Ge,
    move: pe = !1
  }) => {
    const {
      current: _e
    } = ve, {
      width: Gt,
      height: Jt,
      bottom: Te,
      left: Xt
    } = _e.getBoundingClientRect();
    let Pe;
    ot.indexOf("vertical") === 0 ? Pe = (Te - Ge.y) / Jt : Pe = (Ge.x - Xt) / Gt, ot.indexOf("-reverse") !== -1 && (Pe = 1 - Pe);
    let Oe;
    if (Oe = gCe(Pe, s, I), h)
      Oe = oCe(Oe, h, s);
    else {
      const Nt = GN(Q, Oe);
      Oe = Q[Nt];
    }
    Oe = bu(Oe, s, I);
    let kt = 0;
    if (E) {
      pe ? kt = dt.current : kt = GN(L, Oe), g && (Oe = bu(Oe, L[kt - 1] || -1 / 0, L[kt + 1] || 1 / 0));
      const Nt = Oe;
      Oe = yN({
        values: L,
        newValue: Oe,
        index: kt
      }), g && pe || (kt = Oe.indexOf(Nt), dt.current = kt);
    }
    return {
      newValue: Oe,
      activeIndex: kt
    };
  }, tt = zg((Ge) => {
    const pe = zy(Ge, y);
    if (!pe)
      return;
    if (N.current += 1, Ge.type === "mousemove" && Ge.buttons === 0) {
      st(Ge);
      return;
    }
    const {
      newValue: _e,
      activeIndex: Gt
    } = ze({
      finger: pe,
      move: !0
    });
    Oy({
      sliderRef: ve,
      activeIndex: Gt,
      setActive: V
    }), $(_e), !H && N.current > nCe && x(!0), q && !Qy(_e, M) && q(Ge, _e, Gt);
  }), st = zg((Ge) => {
    const pe = zy(Ge, y);
    if (x(!1), !pe)
      return;
    const {
      newValue: _e
    } = ze({
      finger: pe,
      move: !0
    });
    V(-1), Ge.type === "touchend" && v(-1), C && C(Ge, _e), y.current = void 0, ie();
  }), Kt = zg((Ge) => {
    if (n)
      return;
    WN() || Ge.preventDefault();
    const pe = Ge.changedTouches[0];
    pe != null && (y.current = pe.identifier);
    const _e = zy(Ge, y);
    if (_e !== !1) {
      const {
        newValue: Jt,
        activeIndex: Te
      } = ze({
        finger: _e
      });
      Oy({
        sliderRef: ve,
        activeIndex: Te,
        setActive: V
      }), $(Jt), q && !Qy(Jt, M) && q(Ge, Jt, Te);
    }
    N.current = 0;
    const Gt = Gg(ve.current);
    Gt.addEventListener("touchmove", tt, {
      passive: !0
    }), Gt.addEventListener("touchend", st, {
      passive: !0
    });
  }), ie = Y.useCallback(() => {
    const Ge = Gg(ve.current);
    Ge.removeEventListener("mousemove", tt), Ge.removeEventListener("mouseup", st), Ge.removeEventListener("touchmove", tt), Ge.removeEventListener("touchend", st);
  }, [st, tt]);
  Y.useEffect(() => {
    const {
      current: Ge
    } = ve;
    return Ge.addEventListener("touchstart", Kt, {
      passive: WN()
    }), () => {
      Ge.removeEventListener("touchstart", Kt), ie();
    };
  }, [ie, Kt]), Y.useEffect(() => {
    n && ie();
  }, [n, ie]);
  const J = (Ge) => (pe) => {
    var _e;
    if ((_e = Ge.onMouseDown) == null || _e.call(Ge, pe), n || pe.defaultPrevented || pe.button !== 0)
      return;
    pe.preventDefault();
    const Gt = zy(pe, y);
    if (Gt !== !1) {
      const {
        newValue: Te,
        activeIndex: Xt
      } = ze({
        finger: Gt
      });
      Oy({
        sliderRef: ve,
        activeIndex: Xt,
        setActive: V
      }), $(Te), q && !Qy(Te, M) && q(pe, Te, Xt);
    }
    N.current = 0;
    const Jt = Gg(ve.current);
    Jt.addEventListener("mousemove", tt, {
      passive: !0
    }), Jt.addEventListener("mouseup", st);
  }, Ce = FS(E ? L[0] : s, s, I), xe = FS(L[L.length - 1], s, I) - Ce, Le = (Ge = {}) => {
    const pe = aB(Ge), _e = {
      onMouseDown: J(pe || {})
    }, Gt = k({}, pe, _e);
    return k({}, Ge, {
      ref: ue
    }, Gt);
  }, Ye = (Ge) => (pe) => {
    var _e;
    (_e = Ge.onMouseOver) == null || _e.call(Ge, pe);
    const Gt = Number(pe.currentTarget.getAttribute("data-index"));
    v(Gt);
  }, qe = (Ge) => (pe) => {
    var _e;
    (_e = Ge.onMouseLeave) == null || _e.call(Ge, pe), v(-1);
  };
  return {
    active: W,
    axis: ot,
    axisProps: ICe,
    dragging: H,
    focusedThumbIndex: Ee,
    getHiddenInputProps: (Ge = {}) => {
      var pe;
      const _e = aB(Ge), Gt = {
        onChange: rt(_e || {}),
        onFocus: Xe(_e || {}),
        onBlur: Ze(_e || {}),
        onKeyDown: $e(_e || {})
      }, Jt = k({}, _e, Gt);
      return k({
        tabIndex: f,
        "aria-labelledby": t,
        "aria-orientation": u,
        "aria-valuemax": m(I),
        "aria-valuemin": m(s),
        name: a,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (pe = e.step) != null ? pe : void 0,
        disabled: n
      }, Ge, Jt, {
        style: k({}, Vle, {
          direction: r ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: Le,
    getThumbProps: (Ge = {}) => {
      const pe = aB(Ge), _e = {
        onMouseOver: Ye(pe || {}),
        onMouseLeave: qe(pe || {})
      };
      return k({}, Ge, pe, _e);
    },
    marks: P,
    open: w,
    range: E,
    rootRef: ue,
    trackLeap: xe,
    trackOffset: Ce,
    values: L,
    getThumbStyle: (Ge) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: W !== -1 && W !== Ge ? "none" : void 0
    })
  };
}
const aCe = ["onChange", "maxRows", "minRows", "style", "value"];
function _y(e) {
  return parseInt(e, 10) || 0;
}
const cCe = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function dCe(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const CCe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    onChange: n,
    maxRows: g,
    minRows: r = 1,
    style: o,
    value: I
  } = t, s = Ue(t, aCe), {
    current: a
  } = Y.useRef(I != null), d = Y.useRef(null), C = gn(i, d), u = Y.useRef(null), A = Y.useCallback(() => {
    const B = d.current, G = pl(B).getComputedStyle(B);
    if (G.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const y = u.current;
    y.style.width = G.width, y.value = B.value || t.placeholder || "x", y.value.slice(-1) === `
` && (y.value += " ");
    const W = G.boxSizing, V = _y(G.paddingBottom) + _y(G.paddingTop), w = _y(G.borderBottomWidth) + _y(G.borderTopWidth), v = y.scrollHeight;
    y.value = "x";
    const H = y.scrollHeight;
    let x = v;
    r && (x = Math.max(Number(r) * H, x)), g && (x = Math.min(Number(g) * H, x)), x = Math.max(x, H);
    const N = x + (W === "border-box" ? V + w : 0), M = Math.abs(x - v) <= 1;
    return {
      outerHeightStyle: N,
      overflowing: M
    };
  }, [g, r, t.placeholder]), m = Y.useCallback(() => {
    const B = A();
    if (dCe(B))
      return;
    const f = d.current;
    f.style.height = `${B.outerHeightStyle}px`, f.style.overflow = B.overflowing ? "hidden" : "";
  }, [A]);
  eo(() => {
    const B = () => {
      m();
    };
    let f;
    const G = Om(B), y = d.current, W = pl(y);
    W.addEventListener("resize", G);
    let V;
    return typeof ResizeObserver < "u" && (V = new ResizeObserver(B), V.observe(y)), () => {
      G.clear(), cancelAnimationFrame(f), W.removeEventListener("resize", G), V && V.disconnect();
    };
  }, [A, m]), eo(() => {
    m();
  });
  const h = (B) => {
    a || m(), n && n(B);
  };
  return /* @__PURE__ */ Ci(Y.Fragment, {
    children: [/* @__PURE__ */ ne("textarea", k({
      value: I,
      onChange: h,
      ref: C,
      rows: r,
      style: o
    }, s)), /* @__PURE__ */ ne("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: u,
      tabIndex: -1,
      style: k({}, cCe.shadow, o, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
function SN(e) {
  return typeof e.normalize < "u" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function uCe(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: i = !0,
    limit: n,
    matchFrom: g = "any",
    stringify: r,
    trim: o = !1
  } = e;
  return (I, {
    inputValue: s,
    getOptionLabel: a
  }) => {
    let d = o ? s.trim() : s;
    i && (d = d.toLowerCase()), t && (d = SN(d));
    const C = d ? I.filter((u) => {
      let A = (r || a)(u);
      return i && (A = A.toLowerCase()), t && (A = SN(A)), g === "start" ? A.indexOf(d) === 0 : A.indexOf(d) > -1;
    }) : I;
    return typeof n == "number" ? C.slice(0, n) : C;
  };
}
function $y(e, t) {
  for (let i = 0; i < e.length; i += 1)
    if (t(e[i]))
      return i;
  return -1;
}
const ACe = uCe(), VN = 5, bCe = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
};
function mCe(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = bCe,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: i = "Mui",
    autoComplete: n = !1,
    autoHighlight: g = !1,
    autoSelect: r = !1,
    blurOnSelect: o = !1,
    clearOnBlur: I = !e.freeSolo,
    clearOnEscape: s = !1,
    componentName: a = "useAutocomplete",
    defaultValue: d = e.multiple ? [] : null,
    disableClearable: C = !1,
    disableCloseOnSelect: u = !1,
    disabled: A,
    disabledItemsFocusable: m = !1,
    disableListWrap: h = !1,
    filterOptions: B = ACe,
    filterSelectedOptions: f = !1,
    freeSolo: G = !1,
    getOptionDisabled: y,
    getOptionKey: W,
    getOptionLabel: V = (He) => {
      var We;
      return (We = He.label) != null ? We : He;
    },
    groupBy: w,
    handleHomeEndKeys: v = !e.freeSolo,
    id: H,
    includeInputInList: x = !1,
    inputValue: N,
    isOptionEqualToValue: M = (He, We) => He === We,
    multiple: $ = !1,
    onChange: q,
    onClose: E,
    onHighlightChange: L,
    onInputChange: P,
    onOpen: Q,
    open: te,
    openOnFocus: le = !1,
    options: Ae,
    readOnly: we = !1,
    selectOnFocus: Ee = !e.freeSolo,
    value: Je
  } = e, ve = Ou(H);
  let Be = V;
  Be = (He) => {
    const We = V(He);
    return typeof We != "string" ? String(We) : We;
  };
  const ue = Y.useRef(!1), Xe = Y.useRef(!0), Ze = Y.useRef(null), Ke = Y.useRef(null), [$e, rt] = Y.useState(null), [dt, ot] = Y.useState(-1), ze = g ? 0 : -1, tt = Y.useRef(ze), [st, Kt] = ds({
    controlled: Je,
    default: d,
    name: a
  }), [ie, J] = ds({
    controlled: N,
    default: "",
    name: a,
    state: "inputValue"
  }), [Ce, xe] = Y.useState(!1), Le = Y.useCallback((He, We) => {
    if (!($ ? st.length < We.length : We !== null) && !I)
      return;
    let at;
    if ($)
      at = "";
    else if (We == null)
      at = "";
    else {
      const Lt = Be(We);
      at = typeof Lt == "string" ? Lt : "";
    }
    ie !== at && (J(at), P && P(He, at, "reset"));
  }, [Be, ie, $, P, J, I, st]), [Ye, qe] = ds({
    controlled: te,
    default: !1,
    name: a,
    state: "open"
  }), [Yt, qt] = Y.useState(!0), Ut = !$ && st != null && ie === Be(st), Ge = Ye && !we, pe = Ge ? B(
    Ae.filter((He) => !(f && ($ ? st : [st]).some((We) => We !== null && M(He, We)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Ut && Yt ? "" : ie,
      getOptionLabel: Be
    }
  ) : [], _e = Sle({
    filteredOptions: pe,
    value: st,
    inputValue: ie
  });
  Y.useEffect(() => {
    const He = st !== _e.value;
    Ce && !He || G && !He || Le(null, st);
  }, [st, Le, Ce, _e.value, G]);
  const Gt = Ye && pe.length > 0 && !we, Jt = zg((He) => {
    He === -1 ? Ze.current.focus() : $e.querySelector(`[data-tag-index="${He}"]`).focus();
  });
  Y.useEffect(() => {
    $ && dt > st.length - 1 && (ot(-1), Jt(-1));
  }, [st, $, dt, Jt]);
  function Te(He, We) {
    if (!Ke.current || He < 0 || He >= pe.length)
      return -1;
    let yt = He;
    for (; ; ) {
      const at = Ke.current.querySelector(`[data-option-index="${yt}"]`), Lt = m ? !1 : !at || at.disabled || at.getAttribute("aria-disabled") === "true";
      if (at && at.hasAttribute("tabindex") && !Lt)
        return yt;
      if (We === "next" ? yt = (yt + 1) % pe.length : yt = (yt - 1 + pe.length) % pe.length, yt === He)
        return -1;
    }
  }
  const Xt = zg(({
    event: He,
    index: We,
    reason: yt = "auto"
  }) => {
    if (tt.current = We, We === -1 ? Ze.current.removeAttribute("aria-activedescendant") : Ze.current.setAttribute("aria-activedescendant", `${ve}-option-${We}`), L && L(He, We === -1 ? null : pe[We], yt), !Ke.current)
      return;
    const at = Ke.current.querySelector(`[role="option"].${i}-focused`);
    at && (at.classList.remove(`${i}-focused`), at.classList.remove(`${i}-focusVisible`));
    let Lt = Ke.current;
    if (Ke.current.getAttribute("role") !== "listbox" && (Lt = Ke.current.parentElement.querySelector('[role="listbox"]')), !Lt)
      return;
    if (We === -1) {
      Lt.scrollTop = 0;
      return;
    }
    const Ht = Ke.current.querySelector(`[data-option-index="${We}"]`);
    if (Ht && (Ht.classList.add(`${i}-focused`), yt === "keyboard" && Ht.classList.add(`${i}-focusVisible`), Lt.scrollHeight > Lt.clientHeight && yt !== "mouse" && yt !== "touch")) {
      const oi = Ht, mg = Lt.clientHeight + Lt.scrollTop, kl = oi.offsetTop + oi.offsetHeight;
      kl > mg ? Lt.scrollTop = kl - Lt.clientHeight : oi.offsetTop - oi.offsetHeight * (w ? 1.3 : 0) < Lt.scrollTop && (Lt.scrollTop = oi.offsetTop - oi.offsetHeight * (w ? 1.3 : 0));
    }
  }), Pe = zg(({
    event: He,
    diff: We,
    direction: yt = "next",
    reason: at = "auto"
  }) => {
    if (!Ge)
      return;
    const Ht = Te((() => {
      const oi = pe.length - 1;
      if (We === "reset")
        return ze;
      if (We === "start")
        return 0;
      if (We === "end")
        return oi;
      const mg = tt.current + We;
      return mg < 0 ? mg === -1 && x ? -1 : h && tt.current !== -1 || Math.abs(We) > 1 ? 0 : oi : mg > oi ? mg === oi + 1 && x ? -1 : h || Math.abs(We) > 1 ? oi : 0 : mg;
    })(), yt);
    if (Xt({
      index: Ht,
      reason: at,
      event: He
    }), n && We !== "reset")
      if (Ht === -1)
        Ze.current.value = ie;
      else {
        const oi = Be(pe[Ht]);
        Ze.current.value = oi, oi.toLowerCase().indexOf(ie.toLowerCase()) === 0 && ie.length > 0 && Ze.current.setSelectionRange(ie.length, oi.length);
      }
  }), Oe = () => {
    const He = (We, yt) => {
      const at = We ? Be(We) : "", Lt = yt ? Be(yt) : "";
      return at === Lt;
    };
    if (tt.current !== -1 && _e.filteredOptions && _e.filteredOptions.length !== pe.length && _e.inputValue === ie && ($ ? st.length === _e.value.length && _e.value.every((We, yt) => Be(st[yt]) === Be(We)) : He(_e.value, st))) {
      const We = _e.filteredOptions[tt.current];
      if (We)
        return $y(pe, (yt) => Be(yt) === Be(We));
    }
    return -1;
  }, kt = Y.useCallback(() => {
    if (!Ge)
      return;
    const He = Oe();
    if (He !== -1) {
      tt.current = He;
      return;
    }
    const We = $ ? st[0] : st;
    if (pe.length === 0 || We == null) {
      Pe({
        diff: "reset"
      });
      return;
    }
    if (Ke.current) {
      if (We != null) {
        const yt = pe[tt.current];
        if ($ && yt && $y(st, (Lt) => M(yt, Lt)) !== -1)
          return;
        const at = $y(pe, (Lt) => M(Lt, We));
        at === -1 ? Pe({
          diff: "reset"
        }) : Xt({
          index: at
        });
        return;
      }
      if (tt.current >= pe.length - 1) {
        Xt({
          index: pe.length - 1
        });
        return;
      }
      Xt({
        index: tt.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    pe.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $ ? !1 : st,
    f,
    Pe,
    Xt,
    Ge,
    ie,
    $
  ]), Nt = zg((He) => {
    LB(Ke, He), He && kt();
  });
  Y.useEffect(() => {
    kt();
  }, [kt]);
  const ni = (He) => {
    Ye || (qe(!0), qt(!0), Q && Q(He));
  }, si = (He, We) => {
    Ye && (qe(!1), E && E(He, We));
  }, jt = (He, We, yt, at) => {
    if ($) {
      if (st.length === We.length && st.every((Lt, Ht) => Lt === We[Ht]))
        return;
    } else if (st === We)
      return;
    q && q(He, We, yt, at), Kt(We);
  }, Zi = Y.useRef(!1), fi = (He, We, yt = "selectOption", at = "options") => {
    let Lt = yt, Ht = We;
    if ($) {
      Ht = Array.isArray(st) ? st.slice() : [];
      const oi = $y(Ht, (mg) => M(We, mg));
      oi === -1 ? Ht.push(We) : at !== "freeSolo" && (Ht.splice(oi, 1), Lt = "removeOption");
    }
    Le(He, Ht), jt(He, Ht, Lt, {
      option: We
    }), !u && (!He || !He.ctrlKey && !He.metaKey) && si(He, Lt), (o === !0 || o === "touch" && Zi.current || o === "mouse" && !Zi.current) && Ze.current.blur();
  };
  function on(He, We) {
    if (He === -1)
      return -1;
    let yt = He;
    for (; ; ) {
      if (We === "next" && yt === st.length || We === "previous" && yt === -1)
        return -1;
      const at = $e.querySelector(`[data-tag-index="${yt}"]`);
      if (!at || !at.hasAttribute("tabindex") || at.disabled || at.getAttribute("aria-disabled") === "true")
        yt += We === "next" ? 1 : -1;
      else
        return yt;
    }
  }
  const In = (He, We) => {
    if (!$)
      return;
    ie === "" && si(He, "toggleInput");
    let yt = dt;
    dt === -1 ? ie === "" && We === "previous" && (yt = st.length - 1) : (yt += We === "next" ? 1 : -1, yt < 0 && (yt = 0), yt === st.length && (yt = -1)), yt = on(yt, We), ot(yt), Jt(yt);
  }, xn = (He) => {
    ue.current = !0, J(""), P && P(He, "", "clear"), jt(He, $ ? [] : null, "clear");
  }, ln = (He) => (We) => {
    if (He.onKeyDown && He.onKeyDown(We), !We.defaultMuiPrevented && (dt !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(We.key) === -1 && (ot(-1), Jt(-1)), We.which !== 229))
      switch (We.key) {
        case "Home":
          Ge && v && (We.preventDefault(), Pe({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: We
          }));
          break;
        case "End":
          Ge && v && (We.preventDefault(), Pe({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: We
          }));
          break;
        case "PageUp":
          We.preventDefault(), Pe({
            diff: -VN,
            direction: "previous",
            reason: "keyboard",
            event: We
          }), ni(We);
          break;
        case "PageDown":
          We.preventDefault(), Pe({
            diff: VN,
            direction: "next",
            reason: "keyboard",
            event: We
          }), ni(We);
          break;
        case "ArrowDown":
          We.preventDefault(), Pe({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: We
          }), ni(We);
          break;
        case "ArrowUp":
          We.preventDefault(), Pe({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: We
          }), ni(We);
          break;
        case "ArrowLeft":
          In(We, "previous");
          break;
        case "ArrowRight":
          In(We, "next");
          break;
        case "Enter":
          if (tt.current !== -1 && Ge) {
            const yt = pe[tt.current], at = y ? y(yt) : !1;
            if (We.preventDefault(), at)
              return;
            fi(We, yt, "selectOption"), n && Ze.current.setSelectionRange(Ze.current.value.length, Ze.current.value.length);
          } else
            G && ie !== "" && Ut === !1 && ($ && We.preventDefault(), fi(We, ie, "createOption", "freeSolo"));
          break;
        case "Escape":
          Ge ? (We.preventDefault(), We.stopPropagation(), si(We, "escape")) : s && (ie !== "" || $ && st.length > 0) && (We.preventDefault(), We.stopPropagation(), xn(We));
          break;
        case "Backspace":
          if ($ && !we && ie === "" && st.length > 0) {
            const yt = dt === -1 ? st.length - 1 : dt, at = st.slice();
            at.splice(yt, 1), jt(We, at, "removeOption", {
              option: st[yt]
            });
          }
          break;
        case "Delete":
          if ($ && !we && ie === "" && st.length > 0 && dt !== -1) {
            const yt = dt, at = st.slice();
            at.splice(yt, 1), jt(We, at, "removeOption", {
              option: st[yt]
            });
          }
          break;
      }
  }, ug = (He) => {
    xe(!0), le && !ue.current && ni(He);
  }, Ti = (He) => {
    if (t(Ke)) {
      Ze.current.focus();
      return;
    }
    xe(!1), Xe.current = !0, ue.current = !1, r && tt.current !== -1 && Ge ? fi(He, pe[tt.current], "blur") : r && G && ie !== "" ? fi(He, ie, "blur", "freeSolo") : I && Le(He, st), si(He, "blur");
  }, vi = (He) => {
    const We = He.target.value;
    ie !== We && (J(We), qt(!1), P && P(He, We, "input")), We === "" ? !C && !$ && jt(He, null, "clear") : ni(He);
  }, ei = (He) => {
    const We = Number(He.currentTarget.getAttribute("data-option-index"));
    tt.current !== We && Xt({
      event: He,
      index: We,
      reason: "mouse"
    });
  }, yn = (He) => {
    Xt({
      event: He,
      index: Number(He.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Zi.current = !0;
  }, Mi = (He) => {
    const We = Number(He.currentTarget.getAttribute("data-option-index"));
    fi(He, pe[We], "selectOption"), Zi.current = !1;
  }, bn = (He) => (We) => {
    const yt = st.slice();
    yt.splice(He, 1), jt(We, yt, "removeOption", {
      option: st[He]
    });
  }, Ag = (He) => {
    Ye ? si(He, "toggleInput") : ni(He);
  }, sn = (He) => {
    He.currentTarget.contains(He.target) && He.target.getAttribute("id") !== ve && He.preventDefault();
  }, bg = (He) => {
    He.currentTarget.contains(He.target) && (Ze.current.focus(), Ee && Xe.current && Ze.current.selectionEnd - Ze.current.selectionStart === 0 && Ze.current.select(), Xe.current = !1);
  }, Kn = (He) => {
    !A && (ie === "" || !Ye) && Ag(He);
  };
  let Mn = G && ie.length > 0;
  Mn = Mn || ($ ? st.length > 0 : st !== null);
  let Br = pe;
  return w && (Br = pe.reduce((He, We, yt) => {
    const at = w(We);
    return He.length > 0 && He[He.length - 1].group === at ? He[He.length - 1].options.push(We) : He.push({
      key: yt,
      index: yt,
      group: at,
      options: [We]
    }), He;
  }, [])), A && Ce && Ti(), {
    getRootProps: (He = {}) => k({
      "aria-owns": Gt ? `${ve}-listbox` : null
    }, He, {
      onKeyDown: ln(He),
      onMouseDown: sn,
      onClick: bg
    }),
    getInputLabelProps: () => ({
      id: `${ve}-label`,
      htmlFor: ve
    }),
    getInputProps: () => ({
      id: ve,
      value: ie,
      onBlur: Ti,
      onFocus: ug,
      onChange: vi,
      onMouseDown: Kn,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Ge ? "" : null,
      "aria-autocomplete": n ? "both" : "list",
      "aria-controls": Gt ? `${ve}-listbox` : void 0,
      "aria-expanded": Gt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Ze,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: A
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: xn
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Ag
    }),
    getTagProps: ({
      index: He
    }) => k({
      key: He,
      "data-tag-index": He,
      tabIndex: -1
    }, !we && {
      onDelete: bn(He)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${ve}-listbox`,
      "aria-labelledby": `${ve}-label`,
      ref: Nt,
      onMouseDown: (He) => {
        He.preventDefault();
      }
    }),
    getOptionProps: ({
      index: He,
      option: We
    }) => {
      var yt;
      const at = ($ ? st : [st]).some((Ht) => Ht != null && M(We, Ht)), Lt = y ? y(We) : !1;
      return {
        key: (yt = W == null ? void 0 : W(We)) != null ? yt : Be(We),
        tabIndex: -1,
        role: "option",
        id: `${ve}-option-${He}`,
        onMouseMove: ei,
        onClick: Mi,
        onTouchStart: yn,
        "data-option-index": He,
        "aria-disabled": Lt,
        "aria-selected": at
      };
    },
    id: ve,
    inputValue: ie,
    value: st,
    dirty: Mn,
    expanded: Ge && $e,
    popupOpen: Ge,
    focused: Ce || dt !== -1,
    anchorEl: $e,
    setAnchorEl: rt,
    focusedTag: dt,
    groupedOptions: Br
  };
}
var eD = {};
Object.defineProperty(eD, "__esModule", {
  value: !0
});
var WO = eD.default = void 0, hCe = BCe(Se), pCe = gO;
function SO(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
  return (SO = function(n) {
    return n ? i : t;
  })(e);
}
function BCe(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var i = SO(t);
  if (i && i.has(e))
    return i.get(e);
  var n = { __proto__: null }, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var r in e)
    if (r !== "default" && Object.prototype.hasOwnProperty.call(e, r)) {
      var o = g ? Object.getOwnPropertyDescriptor(e, r) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e[r];
    }
  return n.default = e, i && i.set(e, n), n;
}
function ZCe(e) {
  return Object.keys(e).length === 0;
}
function fCe(e = null) {
  const t = hCe.useContext(pCe.ThemeContext);
  return !t || ZCe(t) ? e : t;
}
WO = eD.default = fCe;
const GCe = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], yCe = ye(iCe, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Uw = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n;
  const g = WO(), r = Ft({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: o,
    component: I,
    components: s,
    componentsProps: a,
    container: d,
    disablePortal: C,
    keepMounted: u,
    modifiers: A,
    open: m,
    placement: h,
    popperOptions: B,
    popperRef: f,
    transition: G,
    slots: y,
    slotProps: W
  } = r, V = Ue(r, GCe), w = (n = y == null ? void 0 : y.root) != null ? n : s == null ? void 0 : s.Root, v = k({
    anchorEl: o,
    container: d,
    disablePortal: C,
    keepMounted: u,
    modifiers: A,
    open: m,
    placement: h,
    popperOptions: B,
    popperRef: f,
    transition: G
  }, V);
  return /* @__PURE__ */ ne(yCe, k({
    as: I,
    direction: g == null ? void 0 : g.direction,
    slots: {
      root: w
    },
    slotProps: W ?? a
  }, v, {
    ref: i
  }));
});
function WCe(e) {
  return St("MuiListSubheader", e);
}
Wt("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const SCe = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], VCe = (e) => {
  const {
    classes: t,
    color: i,
    disableGutters: n,
    inset: g,
    disableSticky: r
  } = e, o = {
    root: ["root", i !== "default" && `color${Re(i)}`, !n && "gutters", g && "inset", !r && "sticky"]
  };
  return Vt(o, WCe, t);
}, wCe = ye("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.color !== "default" && t[`color${Re(i.color)}`], !i.disableGutters && t.gutters, i.inset && t.inset, !i.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), VO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: g,
    color: r = "default",
    component: o = "li",
    disableGutters: I = !1,
    disableSticky: s = !1,
    inset: a = !1
  } = n, d = Ue(n, SCe), C = k({}, n, {
    color: r,
    component: o,
    disableGutters: I,
    disableSticky: s,
    inset: a
  }), u = VCe(C);
  return /* @__PURE__ */ ne(wCe, k({
    as: o,
    className: Ve(u.root, g),
    ref: i,
    ownerState: C
  }, d));
});
VO.muiSkipListHighlight = !0;
const vCe = ti(/* @__PURE__ */ ne("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function RCe(e) {
  return St("MuiChip", e);
}
const Oi = Wt("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), XCe = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], HCe = (e) => {
  const {
    classes: t,
    disabled: i,
    size: n,
    color: g,
    iconColor: r,
    onDelete: o,
    clickable: I,
    variant: s
  } = e, a = {
    root: ["root", s, i && "disabled", `size${Re(n)}`, `color${Re(g)}`, I && "clickable", I && `clickableColor${Re(g)}`, o && "deletable", o && `deletableColor${Re(g)}`, `${s}${Re(g)}`],
    label: ["label", `label${Re(n)}`],
    avatar: ["avatar", `avatar${Re(n)}`, `avatarColor${Re(g)}`],
    icon: ["icon", `icon${Re(n)}`, `iconColor${Re(r)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Re(n)}`, `deleteIconColor${Re(g)}`, `deleteIcon${Re(s)}Color${Re(g)}`]
  };
  return Vt(a, RCe, t);
}, kCe = ye("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e, {
      color: n,
      iconColor: g,
      clickable: r,
      onDelete: o,
      size: I,
      variant: s
    } = i;
    return [{
      [`& .${Oi.avatar}`]: t.avatar
    }, {
      [`& .${Oi.avatar}`]: t[`avatar${Re(I)}`]
    }, {
      [`& .${Oi.avatar}`]: t[`avatarColor${Re(n)}`]
    }, {
      [`& .${Oi.icon}`]: t.icon
    }, {
      [`& .${Oi.icon}`]: t[`icon${Re(I)}`]
    }, {
      [`& .${Oi.icon}`]: t[`iconColor${Re(g)}`]
    }, {
      [`& .${Oi.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Oi.deleteIcon}`]: t[`deleteIcon${Re(I)}`]
    }, {
      [`& .${Oi.deleteIcon}`]: t[`deleteIconColor${Re(n)}`]
    }, {
      [`& .${Oi.deleteIcon}`]: t[`deleteIcon${Re(s)}Color${Re(n)}`]
    }, t.root, t[`size${Re(I)}`], t[`color${Re(n)}`], r && t.clickable, r && n !== "default" && t[`clickableColor${Re(n)})`], o && t.deletable, o && n !== "default" && t[`deletableColor${Re(n)}`], t[s], t[`${s}${Re(n)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return k({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Oi.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Oi.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : i,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Oi.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Oi.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Oi.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Oi.icon}`]: k({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && k({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : i
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${Oi.deleteIcon}`]: k({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : di(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : di(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : di(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${Oi.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : di(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${Oi.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => k({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : di(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${Oi.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : di(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${Oi.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => k({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${Oi.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Oi.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${Oi.avatar}`]: {
    marginLeft: 4
  },
  [`& .${Oi.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${Oi.icon}`]: {
    marginLeft: 4
  },
  [`& .${Oi.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${Oi.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${Oi.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : di(e.palette[t.color].main, 0.7)}`,
  [`&.${Oi.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${Oi.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : di(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${Oi.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : di(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), FCe = ye("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e, {
      size: n
    } = i;
    return [t.label, t[`label${Re(n)}`]];
  }
})(({
  ownerState: e
}) => k({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function wN(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const YCe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiChip"
  }), {
    avatar: g,
    className: r,
    clickable: o,
    color: I = "default",
    component: s,
    deleteIcon: a,
    disabled: d = !1,
    icon: C,
    label: u,
    onClick: A,
    onDelete: m,
    onKeyDown: h,
    onKeyUp: B,
    size: f = "medium",
    variant: G = "filled",
    tabIndex: y,
    skipFocusWhenDisabled: W = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = n, V = Ue(n, XCe), w = Y.useRef(null), v = gn(w, i), H = (le) => {
    le.stopPropagation(), m && m(le);
  }, x = (le) => {
    le.currentTarget === le.target && wN(le) && le.preventDefault(), h && h(le);
  }, N = (le) => {
    le.currentTarget === le.target && (m && wN(le) ? m(le) : le.key === "Escape" && w.current && w.current.blur()), B && B(le);
  }, M = o !== !1 && A ? !0 : o, $ = M || m ? fo : s || "div", q = k({}, n, {
    component: $,
    disabled: d,
    size: f,
    color: I,
    iconColor: /* @__PURE__ */ Y.isValidElement(C) && C.props.color || I,
    onDelete: !!m,
    clickable: M,
    variant: G
  }), E = HCe(q), L = $ === fo ? k({
    component: s || "div",
    focusVisibleClassName: E.focusVisible
  }, m && {
    disableRipple: !0
  }) : {};
  let P = null;
  m && (P = a && /* @__PURE__ */ Y.isValidElement(a) ? /* @__PURE__ */ Y.cloneElement(a, {
    className: Ve(a.props.className, E.deleteIcon),
    onClick: H
  }) : /* @__PURE__ */ ne(vCe, {
    className: Ve(E.deleteIcon),
    onClick: H
  }));
  let Q = null;
  g && /* @__PURE__ */ Y.isValidElement(g) && (Q = /* @__PURE__ */ Y.cloneElement(g, {
    className: Ve(E.avatar, g.props.className)
  }));
  let te = null;
  return C && /* @__PURE__ */ Y.isValidElement(C) && (te = /* @__PURE__ */ Y.cloneElement(C, {
    className: Ve(E.icon, C.props.className)
  })), /* @__PURE__ */ Ci(kCe, k({
    as: $,
    className: Ve(E.root, r),
    disabled: M && d ? !0 : void 0,
    onClick: A,
    onKeyDown: x,
    onKeyUp: N,
    ref: v,
    tabIndex: W && d ? -1 : y,
    ownerState: q
  }, L, V, {
    children: [Q || te, /* @__PURE__ */ ne(FCe, {
      className: Ve(E.label),
      ownerState: q,
      children: u
    }), P]
  }));
});
function zd({
  props: e,
  states: t,
  muiFormControl: i
}) {
  return t.reduce((n, g) => (n[g] = e[g], i && typeof e[g] > "u" && (n[g] = i[g]), n), {});
}
const Pw = /* @__PURE__ */ Y.createContext(void 0);
function pa() {
  return Y.useContext(Pw);
}
function tD(e) {
  return /* @__PURE__ */ ne(KIe, k({}, e, {
    defaultTheme: Ew,
    themeId: Hu
  }));
}
function vN(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function YS(e, t = !1) {
  return e && (vN(e.value) && e.value !== "" || t && vN(e.defaultValue) && e.defaultValue !== "");
}
function xCe(e) {
  return e.startAdornment;
}
function DCe(e) {
  return St("MuiInputBase", e);
}
const mI = Wt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), JCe = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], zw = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.formControl && t.formControl, i.startAdornment && t.adornedStart, i.endAdornment && t.adornedEnd, i.error && t.error, i.size === "small" && t.sizeSmall, i.multiline && t.multiline, i.color && t[`color${Re(i.color)}`], i.fullWidth && t.fullWidth, i.hiddenLabel && t.hiddenLabel];
}, Ow = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.input, i.size === "small" && t.inputSizeSmall, i.multiline && t.inputMultiline, i.type === "search" && t.inputTypeSearch, i.startAdornment && t.inputAdornedStart, i.endAdornment && t.inputAdornedEnd, i.hiddenLabel && t.inputHiddenLabel];
}, KCe = (e) => {
  const {
    classes: t,
    color: i,
    disabled: n,
    error: g,
    endAdornment: r,
    focused: o,
    formControl: I,
    fullWidth: s,
    hiddenLabel: a,
    multiline: d,
    readOnly: C,
    size: u,
    startAdornment: A,
    type: m
  } = e, h = {
    root: ["root", `color${Re(i)}`, n && "disabled", g && "error", s && "fullWidth", o && "focused", I && "formControl", u && u !== "medium" && `size${Re(u)}`, d && "multiline", A && "adornedStart", r && "adornedEnd", a && "hiddenLabel", C && "readOnly"],
    input: ["input", n && "disabled", m === "search" && "inputTypeSearch", d && "inputMultiline", u === "small" && "inputSizeSmall", a && "inputHiddenLabel", A && "inputAdornedStart", r && "inputAdornedEnd", C && "readOnly"]
  };
  return Vt(h, DCe, t);
}, Qw = ye("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: zw
})(({
  theme: e,
  ownerState: t
}) => k({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${mI.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && k({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), jw = ye("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Ow
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light", n = k({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: i ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), g = {
    opacity: "0 !important"
  }, r = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: i ? 0.42 : 0.5
  };
  return k({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&:-ms-input-placeholder": n,
    // IE11
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${mI.formControl} &`]: {
      "&::-webkit-input-placeholder": g,
      "&::-moz-placeholder": g,
      // Firefox 19+
      "&:-ms-input-placeholder": g,
      // IE11
      "&::-ms-input-placeholder": g,
      // Edge
      "&:focus::-webkit-input-placeholder": r,
      "&:focus::-moz-placeholder": r,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": r,
      // IE11
      "&:focus::-ms-input-placeholder": r
      // Edge
    },
    [`&.${mI.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), ECe = /* @__PURE__ */ ne(tD, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), _w = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n;
  const g = Ft({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": r,
    autoComplete: o,
    autoFocus: I,
    className: s,
    components: a = {},
    componentsProps: d = {},
    defaultValue: C,
    disabled: u,
    disableInjectingGlobalStyles: A,
    endAdornment: m,
    fullWidth: h = !1,
    id: B,
    inputComponent: f = "input",
    inputProps: G = {},
    inputRef: y,
    maxRows: W,
    minRows: V,
    multiline: w = !1,
    name: v,
    onBlur: H,
    onChange: x,
    onClick: N,
    onFocus: M,
    onKeyDown: $,
    onKeyUp: q,
    placeholder: E,
    readOnly: L,
    renderSuffix: P,
    rows: Q,
    slotProps: te = {},
    slots: le = {},
    startAdornment: Ae,
    type: we = "text",
    value: Ee
  } = g, Je = Ue(g, JCe), ve = G.value != null ? G.value : Ee, {
    current: Be
  } = Y.useRef(ve != null), ue = Y.useRef(), Xe = Y.useCallback((Ge) => {
  }, []), Ze = gn(ue, y, G.ref, Xe), [Ke, $e] = Y.useState(!1), rt = pa(), dt = zd({
    props: g,
    muiFormControl: rt,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  dt.focused = rt ? rt.focused : Ke, Y.useEffect(() => {
    !rt && u && Ke && ($e(!1), H && H());
  }, [rt, u, Ke, H]);
  const ot = rt && rt.onFilled, ze = rt && rt.onEmpty, tt = Y.useCallback((Ge) => {
    YS(Ge) ? ot && ot() : ze && ze();
  }, [ot, ze]);
  eo(() => {
    Be && tt({
      value: ve
    });
  }, [ve, tt, Be]);
  const st = (Ge) => {
    if (dt.disabled) {
      Ge.stopPropagation();
      return;
    }
    M && M(Ge), G.onFocus && G.onFocus(Ge), rt && rt.onFocus ? rt.onFocus(Ge) : $e(!0);
  }, Kt = (Ge) => {
    H && H(Ge), G.onBlur && G.onBlur(Ge), rt && rt.onBlur ? rt.onBlur(Ge) : $e(!1);
  }, ie = (Ge, ...pe) => {
    if (!Be) {
      const _e = Ge.target || ue.current;
      if (_e == null)
        throw new Error(sa(1));
      tt({
        value: _e.value
      });
    }
    G.onChange && G.onChange(Ge, ...pe), x && x(Ge, ...pe);
  };
  Y.useEffect(() => {
    tt(ue.current);
  }, []);
  const J = (Ge) => {
    ue.current && Ge.currentTarget === Ge.target && ue.current.focus(), N && N(Ge);
  };
  let Ce = f, xe = G;
  w && Ce === "input" && (Q ? xe = k({
    type: void 0,
    minRows: Q,
    maxRows: Q
  }, xe) : xe = k({
    type: void 0,
    maxRows: W,
    minRows: V
  }, xe), Ce = CCe);
  const Le = (Ge) => {
    tt(Ge.animationName === "mui-auto-fill-cancel" ? ue.current : {
      value: "x"
    });
  };
  Y.useEffect(() => {
    rt && rt.setAdornedStart(!!Ae);
  }, [rt, Ae]);
  const Ye = k({}, g, {
    color: dt.color || "primary",
    disabled: dt.disabled,
    endAdornment: m,
    error: dt.error,
    focused: dt.focused,
    formControl: rt,
    fullWidth: h,
    hiddenLabel: dt.hiddenLabel,
    multiline: w,
    size: dt.size,
    startAdornment: Ae,
    type: we
  }), qe = KCe(Ye), Yt = le.root || a.Root || Qw, qt = te.root || d.root || {}, Ut = le.input || a.Input || jw;
  return xe = k({}, xe, (n = te.input) != null ? n : d.input), /* @__PURE__ */ Ci(Y.Fragment, {
    children: [!A && ECe, /* @__PURE__ */ Ci(Yt, k({}, qt, !oa(Yt) && {
      ownerState: k({}, Ye, qt.ownerState)
    }, {
      ref: i,
      onClick: J
    }, Je, {
      className: Ve(qe.root, qt.className, s, L && "MuiInputBase-readOnly"),
      children: [Ae, /* @__PURE__ */ ne(Pw.Provider, {
        value: null,
        children: /* @__PURE__ */ ne(Ut, k({
          ownerState: Ye,
          "aria-invalid": dt.error,
          "aria-describedby": r,
          autoComplete: o,
          autoFocus: I,
          defaultValue: C,
          disabled: dt.disabled,
          id: B,
          onAnimationStart: Le,
          name: v,
          placeholder: E,
          readOnly: L,
          required: dt.required,
          rows: Q,
          value: ve,
          onKeyDown: $,
          onKeyUp: q,
          type: we
        }, xe, !oa(Ut) && {
          as: Ce,
          ownerState: k({}, Ye, xe.ownerState)
        }, {
          ref: Ze,
          className: Ve(qe.input, xe.className, L && "MuiInputBase-readOnly"),
          onBlur: Kt,
          onChange: ie,
          onFocus: st
        }))
      }), m, P ? P(k({}, dt, {
        startAdornment: Ae
      })) : null]
    }))]
  });
});
function NCe(e) {
  return St("MuiInput", e);
}
const fd = k({}, mI, Wt("MuiInput", ["root", "underline", "input"]));
function LCe(e) {
  return St("MuiOutlinedInput", e);
}
const Ps = k({}, mI, Wt("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function TCe(e) {
  return St("MuiFilledInput", e);
}
const hI = k({}, mI, Wt("MuiFilledInput", ["root", "underline", "input"])), wO = ti(/* @__PURE__ */ ne("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function MCe(e) {
  return St("MuiAutocomplete", e);
}
const Xi = Wt("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var RN, XN;
const UCe = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], PCe = ["ref"], zCe = Qu(), OCe = (e) => {
  const {
    classes: t,
    disablePortal: i,
    expanded: n,
    focused: g,
    fullWidth: r,
    hasClearIcon: o,
    hasPopupIcon: I,
    inputFocused: s,
    popupOpen: a,
    size: d
  } = e, C = {
    root: ["root", n && "expanded", g && "focused", r && "fullWidth", o && "hasClearIcon", I && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", s && "inputFocused"],
    tag: ["tag", `tagSize${Re(d)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", a && "popupIndicatorOpen"],
    popper: ["popper", i && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Vt(C, MCe, t);
}, QCe = ye("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e, {
      fullWidth: n,
      hasClearIcon: g,
      hasPopupIcon: r,
      inputFocused: o,
      size: I
    } = i;
    return [{
      [`& .${Xi.tag}`]: t.tag
    }, {
      [`& .${Xi.tag}`]: t[`tagSize${Re(I)}`]
    }, {
      [`& .${Xi.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Xi.input}`]: t.input
    }, {
      [`& .${Xi.input}`]: o && t.inputFocused
    }, t.root, n && t.fullWidth, r && t.hasPopupIcon, g && t.hasClearIcon];
  }
})({
  [`&.${Xi.focused} .${Xi.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Xi.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Xi.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Xi.inputRoot}`]: {
    flexWrap: "wrap",
    [`.${Xi.hasPopupIcon}&, .${Xi.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Xi.hasPopupIcon}.${Xi.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Xi.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${fd.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${fd.root}.${mI.sizeSmall}`]: {
    [`& .${fd.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Ps.root}`]: {
    padding: 9,
    [`.${Xi.hasPopupIcon}&, .${Xi.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Xi.hasPopupIcon}.${Xi.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Xi.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Xi.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Ps.root}.${mI.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Xi.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${hI.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Xi.hasPopupIcon}&, .${Xi.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Xi.hasPopupIcon}.${Xi.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${hI.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Xi.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${hI.root}.${mI.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${hI.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${mI.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${hI.root}.${mI.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Xi.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${hI.root}.${mI.hiddenLabel}.${mI.sizeSmall}`]: {
    [`& .${Xi.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Xi.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Xi.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Xi.input}`]: {
        opacity: 1
      }
    }
  }]
}), jCe = ye("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), _Ce = ye(mi, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), $Ce = ye(mi, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => k({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), qCe = ye(Uw, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${Xi.option}`]: t.option
    }, t.popper, i.disablePortal && t.popperDisablePortal];
  }
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
})), eue = ye(So, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => k({}, e.typography.body1, {
  overflow: "auto"
})), tue = ye("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), iue = ye("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), nue = ye("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Xi.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Xi.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Xi.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Xi.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Xi.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), gue = ye(VO, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), rue = ye("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Xi.option}`]: {
    paddingLeft: 24
  }
}), oue = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o;
  const I = zCe({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: s = !1,
    autoHighlight: a = !1,
    autoSelect: d = !1,
    blurOnSelect: C = !1,
    ChipProps: u,
    className: A,
    clearIcon: m = RN || (RN = /* @__PURE__ */ ne(sce, {
      fontSize: "small"
    })),
    clearOnBlur: h = !I.freeSolo,
    clearOnEscape: B = !1,
    clearText: f = "Clear",
    closeText: G = "Close",
    componentsProps: y = {},
    defaultValue: W = I.multiple ? [] : null,
    disableClearable: V = !1,
    disableCloseOnSelect: w = !1,
    disabled: v = !1,
    disabledItemsFocusable: H = !1,
    disableListWrap: x = !1,
    disablePortal: N = !1,
    filterSelectedOptions: M = !1,
    forcePopupIcon: $ = "auto",
    freeSolo: q = !1,
    fullWidth: E = !1,
    getLimitTagsText: L = (at) => `+${at}`,
    getOptionLabel: P,
    groupBy: Q,
    handleHomeEndKeys: te = !I.freeSolo,
    includeInputInList: le = !1,
    limitTags: Ae = -1,
    ListboxComponent: we = "ul",
    ListboxProps: Ee,
    loading: Je = !1,
    loadingText: ve = "Loading…",
    multiple: Be = !1,
    noOptionsText: ue = "No options",
    openOnFocus: Xe = !1,
    openText: Ze = "Open",
    PaperComponent: Ke = So,
    PopperComponent: $e = Uw,
    popupIcon: rt = XN || (XN = /* @__PURE__ */ ne(wO, {})),
    readOnly: dt = !1,
    renderGroup: ot,
    renderInput: ze,
    renderOption: tt,
    renderTags: st,
    selectOnFocus: Kt = !I.freeSolo,
    size: ie = "medium",
    slotProps: J = {}
  } = I, Ce = Ue(I, UCe), {
    getRootProps: xe,
    getInputProps: Le,
    getInputLabelProps: Ye,
    getPopupIndicatorProps: qe,
    getClearProps: Yt,
    getTagProps: qt,
    getListboxProps: Ut,
    getOptionProps: Ge,
    value: pe,
    dirty: _e,
    expanded: Gt,
    id: Jt,
    popupOpen: Te,
    focused: Xt,
    focusedTag: Pe,
    anchorEl: Oe,
    setAnchorEl: kt,
    inputValue: Nt,
    groupedOptions: ni
  } = mCe(k({}, I, {
    componentName: "Autocomplete"
  })), si = !V && !v && _e && !dt, jt = (!q || $ === !0) && $ !== !1, {
    onMouseDown: Zi
  } = Le(), {
    ref: fi
  } = Ee ?? {}, on = Ut(), {
    ref: In
  } = on, xn = Ue(on, PCe), ln = gn(In, fi), Ti = P || ((at) => {
    var Lt;
    return (Lt = at.label) != null ? Lt : at;
  }), vi = k({}, I, {
    disablePortal: N,
    expanded: Gt,
    focused: Xt,
    fullWidth: E,
    getOptionLabel: Ti,
    hasClearIcon: si,
    hasPopupIcon: jt,
    inputFocused: Pe === -1,
    popupOpen: Te,
    size: ie
  }), ei = OCe(vi);
  let yn;
  if (Be && pe.length > 0) {
    const at = (Lt) => k({
      className: ei.tag,
      disabled: v
    }, qt(Lt));
    st ? yn = st(pe, at, vi) : yn = pe.map((Lt, Ht) => /* @__PURE__ */ ne(YCe, k({
      label: Ti(Lt),
      size: ie
    }, at({
      index: Ht
    }), u)));
  }
  if (Ae > -1 && Array.isArray(yn)) {
    const at = yn.length - Ae;
    !Xt && at > 0 && (yn = yn.splice(0, Ae), yn.push(/* @__PURE__ */ ne("span", {
      className: ei.tag,
      children: L(at)
    }, yn.length)));
  }
  const bn = ot || ((at) => /* @__PURE__ */ Ci("li", {
    children: [/* @__PURE__ */ ne(gue, {
      className: ei.groupLabel,
      ownerState: vi,
      component: "div",
      children: at.group
    }), /* @__PURE__ */ ne(rue, {
      className: ei.groupUl,
      ownerState: vi,
      children: at.children
    })]
  }, at.key)), sn = tt || ((at, Lt) => /* @__PURE__ */ ga("li", k({}, at, {
    key: at.key
  }), Ti(Lt))), bg = (at, Lt) => {
    const Ht = Ge({
      option: at,
      index: Lt
    });
    return sn(k({}, Ht, {
      className: ei.option
    }), at, {
      selected: Ht["aria-selected"],
      index: Lt,
      inputValue: Nt
    }, vi);
  }, Kn = (n = J.clearIndicator) != null ? n : y.clearIndicator, Mn = (g = J.paper) != null ? g : y.paper, Br = (r = J.popper) != null ? r : y.popper, He = (o = J.popupIndicator) != null ? o : y.popupIndicator, We = (at) => /* @__PURE__ */ ne(qCe, k({
    as: $e,
    disablePortal: N,
    style: {
      width: Oe ? Oe.clientWidth : null
    },
    ownerState: vi,
    role: "presentation",
    anchorEl: Oe,
    open: Te
  }, Br, {
    className: Ve(ei.popper, Br == null ? void 0 : Br.className),
    children: /* @__PURE__ */ ne(eue, k({
      ownerState: vi,
      as: Ke
    }, Mn, {
      className: Ve(ei.paper, Mn == null ? void 0 : Mn.className),
      children: at
    }))
  }));
  let yt = null;
  return ni.length > 0 ? yt = We(/* @__PURE__ */ ne(nue, k({
    as: we,
    className: ei.listbox,
    ownerState: vi
  }, xn, Ee, {
    ref: ln,
    children: ni.map((at, Lt) => Q ? bn({
      key: at.key,
      group: at.group,
      children: at.options.map((Ht, oi) => bg(Ht, at.index + oi))
    }) : bg(at, Lt))
  }))) : Je && ni.length === 0 ? yt = We(/* @__PURE__ */ ne(tue, {
    className: ei.loading,
    ownerState: vi,
    children: ve
  })) : ni.length === 0 && !q && !Je && (yt = We(/* @__PURE__ */ ne(iue, {
    className: ei.noOptions,
    ownerState: vi,
    role: "presentation",
    onMouseDown: (at) => {
      at.preventDefault();
    },
    children: ue
  }))), /* @__PURE__ */ Ci(Y.Fragment, {
    children: [/* @__PURE__ */ ne(QCe, k({
      ref: i,
      className: Ve(ei.root, A),
      ownerState: vi
    }, xe(Ce), {
      children: ze({
        id: Jt,
        disabled: v,
        fullWidth: !0,
        size: ie === "small" ? "small" : void 0,
        InputLabelProps: Ye(),
        InputProps: k({
          ref: kt,
          className: ei.inputRoot,
          startAdornment: yn,
          onClick: (at) => {
            at.target === at.currentTarget && Zi(at);
          }
        }, (si || jt) && {
          endAdornment: /* @__PURE__ */ Ci(jCe, {
            className: ei.endAdornment,
            ownerState: vi,
            children: [si ? /* @__PURE__ */ ne(_Ce, k({}, Yt(), {
              "aria-label": f,
              title: f,
              ownerState: vi
            }, Kn, {
              className: Ve(ei.clearIndicator, Kn == null ? void 0 : Kn.className),
              children: m
            })) : null, jt ? /* @__PURE__ */ ne($Ce, k({}, qe(), {
              disabled: v,
              "aria-label": Te ? G : Ze,
              title: Te ? G : Ze,
              ownerState: vi
            }, He, {
              className: Ve(ei.popupIndicator, He == null ? void 0 : He.className),
              children: rt
            })) : null]
          })
        }),
        inputProps: k({
          className: ei.input,
          disabled: v,
          readOnly: dt
        }, Le())
      })
    })), Oe ? yt : null]
  });
}), Iue = ti(/* @__PURE__ */ ne("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function lue(e) {
  return St("MuiAvatar", e);
}
Wt("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const sue = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"], aue = Qu(), cue = (e) => {
  const {
    classes: t,
    variant: i,
    colorDefault: n
  } = e;
  return Vt({
    root: ["root", i, n && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, lue, t);
}, due = ye("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], i.colorDefault && t.colorDefault];
  }
})(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: k({
      color: (e.vars || e).palette.background.default
    }, e.vars ? {
      backgroundColor: e.vars.palette.Avatar.defaultBg
    } : k({
      backgroundColor: e.palette.grey[400]
    }, e.applyStyles("dark", {
      backgroundColor: e.palette.grey[600]
    })))
  }]
})), Cue = ye("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), uue = ye(Iue, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function Aue({
  crossOrigin: e,
  referrerPolicy: t,
  src: i,
  srcSet: n
}) {
  const [g, r] = Y.useState(!1);
  return Y.useEffect(() => {
    if (!i && !n)
      return;
    r(!1);
    let o = !0;
    const I = new Image();
    return I.onload = () => {
      o && r("loaded");
    }, I.onerror = () => {
      o && r("error");
    }, I.crossOrigin = e, I.referrerPolicy = t, I.src = i, n && (I.srcset = n), () => {
      o = !1;
    };
  }, [e, t, i, n]), g;
}
const bue = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = aue({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: g,
    children: r,
    className: o,
    component: I = "div",
    slots: s = {},
    slotProps: a = {},
    imgProps: d,
    sizes: C,
    src: u,
    srcSet: A,
    variant: m = "circular"
  } = n, h = Ue(n, sue);
  let B = null;
  const f = Aue(k({}, d, {
    src: u,
    srcSet: A
  })), G = u || A, y = G && f !== "error", W = k({}, n, {
    colorDefault: !y,
    component: I,
    variant: m
  }), V = cue(W), [w, v] = aO("img", {
    className: V.img,
    elementType: Cue,
    externalForwardedProps: {
      slots: s,
      slotProps: {
        img: k({}, d, a.img)
      }
    },
    additionalProps: {
      alt: g,
      src: u,
      srcSet: A,
      sizes: C
    },
    ownerState: W
  });
  return y ? B = /* @__PURE__ */ ne(w, k({}, v)) : r || r === 0 ? B = r : G && g ? B = g[0] : B = /* @__PURE__ */ ne(uue, {
    ownerState: W,
    className: V.fallback
  }), /* @__PURE__ */ ne(due, k({
    as: I,
    ownerState: W,
    className: Ve(V.root, o),
    ref: i
  }, h, {
    children: B
  }));
}), mue = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], hue = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, vO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = qo(), g = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: r,
    appear: o = !0,
    children: I,
    easing: s,
    in: a,
    onEnter: d,
    onEntered: C,
    onEntering: u,
    onExit: A,
    onExited: m,
    onExiting: h,
    style: B,
    timeout: f = g,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: G = JI
  } = t, y = Ue(t, mue), W = Y.useRef(null), V = gn(W, I.ref, i), w = (E) => (L) => {
    if (E) {
      const P = W.current;
      L === void 0 ? E(P) : E(P, L);
    }
  }, v = w(u), H = w((E, L) => {
    Lw(E);
    const P = aa({
      style: B,
      timeout: f,
      easing: s
    }, {
      mode: "enter"
    });
    E.style.webkitTransition = n.transitions.create("opacity", P), E.style.transition = n.transitions.create("opacity", P), d && d(E, L);
  }), x = w(C), N = w(h), M = w((E) => {
    const L = aa({
      style: B,
      timeout: f,
      easing: s
    }, {
      mode: "exit"
    });
    E.style.webkitTransition = n.transitions.create("opacity", L), E.style.transition = n.transitions.create("opacity", L), A && A(E);
  }), $ = w(m);
  return /* @__PURE__ */ ne(G, k({
    appear: o,
    in: a,
    nodeRef: W,
    onEnter: H,
    onEntered: x,
    onEntering: v,
    onExit: M,
    onExited: $,
    onExiting: N,
    addEndListener: (E) => {
      r && r(W.current, E);
    },
    timeout: f
  }, y, {
    children: (E, L) => /* @__PURE__ */ Y.cloneElement(I, k({
      style: k({
        opacity: 0,
        visibility: E === "exited" && !a ? "hidden" : void 0
      }, hue[E], B, I.props.style),
      ref: V
    }, L))
  }));
});
function pue(e) {
  return St("MuiBackdrop", e);
}
Wt("MuiBackdrop", ["root", "invisible"]);
const Bue = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], Zue = (e) => {
  const {
    classes: t,
    invisible: i
  } = e;
  return Vt({
    root: ["root", i && "invisible"]
  }, pue, t);
}, fue = ye("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => k({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), $w = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r;
  const o = Ft({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: I,
    className: s,
    component: a = "div",
    components: d = {},
    componentsProps: C = {},
    invisible: u = !1,
    open: A,
    slotProps: m = {},
    slots: h = {},
    TransitionComponent: B = vO,
    transitionDuration: f
  } = o, G = Ue(o, Bue), y = k({}, o, {
    component: a,
    invisible: u
  }), W = Zue(y), V = (n = m.root) != null ? n : C.root;
  return /* @__PURE__ */ ne(B, k({
    in: A,
    timeout: f
  }, G, {
    children: /* @__PURE__ */ ne(fue, k({
      "aria-hidden": !0
    }, V, {
      as: (g = (r = h.root) != null ? r : d.Root) != null ? g : a,
      className: Ve(W.root, s, V == null ? void 0 : V.className),
      ownerState: k({}, y, V == null ? void 0 : V.ownerState),
      classes: W,
      ref: i,
      children: I
    }))
  }));
}), Gue = Wt("MuiBox", ["root"]), yue = Gue, Wue = _m(), fe = H4({
  themeId: Hu,
  defaultTheme: Wue,
  defaultClassName: yue.root,
  generateClassName: Sw.generate
}), Sue = ti(/* @__PURE__ */ ne("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), Vue = ["slots", "slotProps"], wue = ye(fo)(({
  theme: e
}) => k({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`
}, e.palette.mode === "light" ? {
  backgroundColor: e.palette.grey[100],
  color: e.palette.grey[700]
} : {
  backgroundColor: e.palette.grey[700],
  color: e.palette.grey[100]
}, {
  borderRadius: 2,
  "&:hover, &:focus": k({}, e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[200]
  } : {
    backgroundColor: e.palette.grey[600]
  }),
  "&:active": k({
    boxShadow: e.shadows[0]
  }, e.palette.mode === "light" ? {
    backgroundColor: z9(e.palette.grey[200], 0.12)
  } : {
    backgroundColor: z9(e.palette.grey[600], 0.12)
  })
})), vue = ye(Sue)({
  width: 24,
  height: 16
});
function Rue(e) {
  const {
    slots: t = {},
    slotProps: i = {}
  } = e, n = Ue(e, Vue), g = e;
  return /* @__PURE__ */ ne("li", {
    children: /* @__PURE__ */ ne(wue, k({
      focusRipple: !0
    }, n, {
      ownerState: g,
      children: /* @__PURE__ */ ne(vue, k({
        as: t.CollapsedIcon,
        ownerState: g
      }, i.collapsedIcon))
    }))
  });
}
function Xue(e) {
  return St("MuiBreadcrumbs", e);
}
const Hue = Wt("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), kue = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"], Fue = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, Xue, t);
}, Yue = ye(Ne, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${Hue.li}`]: t.li
  }, t.root]
})({}), xue = ye("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), Due = ye("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function Jue(e, t, i, n) {
  return e.reduce((g, r, o) => (o < e.length - 1 ? g = g.concat(r, /* @__PURE__ */ ne(Due, {
    "aria-hidden": !0,
    className: t,
    ownerState: n,
    children: i
  }, `separator-${o}`)) : g.push(r), g), []);
}
const RO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: g,
    className: r,
    component: o = "nav",
    slots: I = {},
    slotProps: s = {},
    expandText: a = "Show path",
    itemsAfterCollapse: d = 1,
    itemsBeforeCollapse: C = 1,
    maxItems: u = 8,
    separator: A = "/"
  } = n, m = Ue(n, kue), [h, B] = Y.useState(!1), f = k({}, n, {
    component: o,
    expanded: h,
    expandText: a,
    itemsAfterCollapse: d,
    itemsBeforeCollapse: C,
    maxItems: u,
    separator: A
  }), G = Fue(f), y = kg({
    elementType: I.CollapsedIcon,
    externalSlotProps: s.collapsedIcon,
    ownerState: f
  }), W = Y.useRef(null), V = (v) => {
    const H = () => {
      B(!0);
      const x = W.current.querySelector("a[href],button,[tabindex]");
      x && x.focus();
    };
    return C + d >= v.length ? v : [...v.slice(0, C), /* @__PURE__ */ ne(Rue, {
      "aria-label": a,
      slots: {
        CollapsedIcon: I.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: y
      },
      onClick: H
    }, "ellipsis"), ...v.slice(v.length - d, v.length)];
  }, w = Y.Children.toArray(g).filter((v) => /* @__PURE__ */ Y.isValidElement(v)).map((v, H) => /* @__PURE__ */ ne("li", {
    className: G.li,
    children: v
  }, `child-${H}`));
  return /* @__PURE__ */ ne(Yue, k({
    ref: i,
    component: o,
    color: "text.secondary",
    className: Ve(G.root, r),
    ownerState: f
  }, m, {
    children: /* @__PURE__ */ ne(xue, {
      className: G.ol,
      ref: W,
      ownerState: f,
      children: Jue(h || u && w.length <= u ? w : V(w), G.separator, A, f)
    })
  }));
});
function Kue(e) {
  return St("MuiButton", e);
}
const Eue = Wt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), qy = Eue, XO = /* @__PURE__ */ Y.createContext({}), HO = /* @__PURE__ */ Y.createContext(void 0), Nue = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], Lue = (e) => {
  const {
    color: t,
    disableElevation: i,
    fullWidth: n,
    size: g,
    variant: r,
    classes: o
  } = e, I = {
    root: ["root", r, `${r}${Re(t)}`, `size${Re(g)}`, `${r}Size${Re(g)}`, `color${Re(t)}`, i && "disableElevation", n && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${Re(g)}`],
    endIcon: ["icon", "endIcon", `iconSize${Re(g)}`]
  }, s = Vt(I, Kue, o);
  return k({}, o, s);
}, kO = (e) => k({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), Tue = ye(fo, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`${i.variant}${Re(i.color)}`], t[`size${Re(i.size)}`], t[`${i.variant}Size${Re(i.size)}`], i.color === "inherit" && t.colorInherit, i.disableElevation && t.disableElevation, i.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i, n;
  const g = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], r = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return k({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": k({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : r,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": k({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${qy.focusVisible}`]: k({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${qy.disabled}`]: k({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${di(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (i = (n = e.palette).getContrastText) == null ? void 0 : i.call(n, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : g,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${qy.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${qy.disabled}`]: {
    boxShadow: "none"
  }
}), Mue = ye("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.startIcon, t[`iconSize${Re(i.size)}`]];
  }
})(({
  ownerState: e
}) => k({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, kO(e))), Uue = ye("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.endIcon, t[`iconSize${Re(i.size)}`]];
  }
})(({
  ownerState: e
}) => k({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, kO(e))), Si = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Y.useContext(XO), g = Y.useContext(HO), r = Dw(n, t), o = Ft({
    props: r,
    name: "MuiButton"
  }), {
    children: I,
    color: s = "primary",
    component: a = "button",
    className: d,
    disabled: C = !1,
    disableElevation: u = !1,
    disableFocusRipple: A = !1,
    endIcon: m,
    focusVisibleClassName: h,
    fullWidth: B = !1,
    size: f = "medium",
    startIcon: G,
    type: y,
    variant: W = "text"
  } = o, V = Ue(o, Nue), w = k({}, o, {
    color: s,
    component: a,
    disabled: C,
    disableElevation: u,
    disableFocusRipple: A,
    fullWidth: B,
    size: f,
    type: y,
    variant: W
  }), v = Lue(w), H = G && /* @__PURE__ */ ne(Mue, {
    className: v.startIcon,
    ownerState: w,
    children: G
  }), x = m && /* @__PURE__ */ ne(Uue, {
    className: v.endIcon,
    ownerState: w,
    children: m
  }), N = g || "";
  return /* @__PURE__ */ Ci(Tue, k({
    ownerState: w,
    className: Ve(n.className, v.root, d, N),
    component: a,
    disabled: C,
    focusRipple: !A,
    focusVisibleClassName: Ve(v.focusVisible, h),
    ref: i,
    type: y
  }, V, {
    classes: v,
    children: [H, I, x]
  }));
});
function Pue(e) {
  return St("MuiButtonGroup", e);
}
const Fr = Wt("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "vertical", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), zue = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"], Oue = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [{
    [`& .${Fr.grouped}`]: t.grouped
  }, {
    [`& .${Fr.grouped}`]: t[`grouped${Re(i.orientation)}`]
  }, {
    [`& .${Fr.grouped}`]: t[`grouped${Re(i.variant)}`]
  }, {
    [`& .${Fr.grouped}`]: t[`grouped${Re(i.variant)}${Re(i.orientation)}`]
  }, {
    [`& .${Fr.grouped}`]: t[`grouped${Re(i.variant)}${Re(i.color)}`]
  }, {
    [`& .${Fr.firstButton}`]: t.firstButton
  }, {
    [`& .${Fr.lastButton}`]: t.lastButton
  }, {
    [`& .${Fr.middleButton}`]: t.middleButton
  }, t.root, t[i.variant], i.disableElevation === !0 && t.disableElevation, i.fullWidth && t.fullWidth, i.orientation === "vertical" && t.vertical];
}, Que = (e) => {
  const {
    classes: t,
    color: i,
    disabled: n,
    disableElevation: g,
    fullWidth: r,
    orientation: o,
    variant: I
  } = e, s = {
    root: ["root", I, o === "vertical" && "vertical", r && "fullWidth", g && "disableElevation"],
    grouped: ["grouped", `grouped${Re(o)}`, `grouped${Re(I)}`, `grouped${Re(I)}${Re(o)}`, `grouped${Re(I)}${Re(i)}`, n && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Vt(s, Pue, t);
}, jue = ye("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: Oue
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "contained" && {
  boxShadow: (e.vars || e).shadows[2]
}, t.disableElevation && {
  boxShadow: "none"
}, t.fullWidth && {
  width: "100%"
}, t.orientation === "vertical" && {
  flexDirection: "column"
}, {
  [`& .${Fr.grouped}`]: k({
    minWidth: 40,
    "&:hover": k({}, t.variant === "contained" && {
      boxShadow: "none"
    })
  }, t.variant === "contained" && {
    boxShadow: "none"
  }),
  [`& .${Fr.firstButton},& .${Fr.middleButton}`]: k({}, t.orientation === "horizontal" && {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, t.orientation === "vertical" && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }, t.variant === "text" && t.orientation === "horizontal" && {
    borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Fr.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.orientation === "vertical" && {
    borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Fr.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.color !== "inherit" && {
    borderColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : di(e.palette[t.color].main, 0.5)
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    borderRightColor: "transparent"
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    borderBottomColor: "transparent"
  }, t.variant === "contained" && t.orientation === "horizontal" && {
    borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Fr.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.orientation === "vertical" && {
    borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Fr.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.color !== "inherit" && {
    borderColor: (e.vars || e).palette[t.color].dark
  }, {
    "&:hover": k({}, t.variant === "outlined" && t.orientation === "horizontal" && {
      borderRightColor: "currentColor"
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      borderBottomColor: "currentColor"
    })
  }),
  [`& .${Fr.lastButton},& .${Fr.middleButton}`]: k({}, t.orientation === "horizontal" && {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, t.orientation === "vertical" && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    marginLeft: -1
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    marginTop: -1
  })
})), _ue = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: g,
    className: r,
    color: o = "primary",
    component: I = "div",
    disabled: s = !1,
    disableElevation: a = !1,
    disableFocusRipple: d = !1,
    disableRipple: C = !1,
    fullWidth: u = !1,
    orientation: A = "horizontal",
    size: m = "medium",
    variant: h = "outlined"
  } = n, B = Ue(n, zue), f = k({}, n, {
    color: o,
    component: I,
    disabled: s,
    disableElevation: a,
    disableFocusRipple: d,
    disableRipple: C,
    fullWidth: u,
    orientation: A,
    size: m,
    variant: h
  }), G = Que(f), y = Y.useMemo(() => ({
    className: G.grouped,
    color: o,
    disabled: s,
    disableElevation: a,
    disableFocusRipple: d,
    disableRipple: C,
    fullWidth: u,
    size: m,
    variant: h
  }), [o, s, a, d, C, u, m, h, G.grouped]), W = M4(g), V = W.length, w = (v) => {
    const H = v === 0, x = v === V - 1;
    return H && x ? "" : H ? G.firstButton : x ? G.lastButton : G.middleButton;
  };
  return /* @__PURE__ */ ne(jue, k({
    as: I,
    role: "group",
    className: Ve(G.root, r),
    ref: i,
    ownerState: f
  }, B, {
    children: /* @__PURE__ */ ne(XO.Provider, {
      value: y,
      children: W.map((v, H) => /* @__PURE__ */ ne(HO.Provider, {
        value: w(H),
        children: v
      }, H))
    })
  }));
});
function $ue(e) {
  return St("PrivateSwitchBase", e);
}
Wt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const que = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], eAe = (e) => {
  const {
    classes: t,
    checked: i,
    disabled: n,
    edge: g
  } = e, r = {
    root: ["root", i && "checked", n && "disabled", g && `edge${Re(g)}`],
    input: ["input"]
  };
  return Vt(r, $ue, t);
}, tAe = ye(fo)(({
  ownerState: e
}) => k({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), iAe = ye("input", {
  shouldForwardProp: br
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), iD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    autoFocus: n,
    checked: g,
    checkedIcon: r,
    className: o,
    defaultChecked: I,
    disabled: s,
    disableFocusRipple: a = !1,
    edge: d = !1,
    icon: C,
    id: u,
    inputProps: A,
    inputRef: m,
    name: h,
    onBlur: B,
    onChange: f,
    onFocus: G,
    readOnly: y,
    required: W = !1,
    tabIndex: V,
    type: w,
    value: v
  } = t, H = Ue(t, que), [x, N] = ds({
    controlled: g,
    default: !!I,
    name: "SwitchBase",
    state: "checked"
  }), M = pa(), $ = (le) => {
    G && G(le), M && M.onFocus && M.onFocus(le);
  }, q = (le) => {
    B && B(le), M && M.onBlur && M.onBlur(le);
  }, E = (le) => {
    if (le.nativeEvent.defaultPrevented)
      return;
    const Ae = le.target.checked;
    N(Ae), f && f(le, Ae);
  };
  let L = s;
  M && typeof L > "u" && (L = M.disabled);
  const P = w === "checkbox" || w === "radio", Q = k({}, t, {
    checked: x,
    disabled: L,
    disableFocusRipple: a,
    edge: d
  }), te = eAe(Q);
  return /* @__PURE__ */ Ci(tAe, k({
    component: "span",
    className: Ve(te.root, o),
    centerRipple: !0,
    focusRipple: !a,
    disabled: L,
    tabIndex: null,
    role: void 0,
    onFocus: $,
    onBlur: q,
    ownerState: Q,
    ref: i
  }, H, {
    children: [/* @__PURE__ */ ne(iAe, k({
      autoFocus: n,
      checked: g,
      defaultChecked: I,
      className: te.input,
      disabled: L,
      id: P ? u : void 0,
      name: h,
      onChange: E,
      readOnly: y,
      ref: m,
      required: W,
      ownerState: Q,
      tabIndex: V,
      type: w
    }, w === "checkbox" && v === void 0 ? {} : {
      value: v
    }, A)), x ? r : C]
  }));
}), nAe = ti(/* @__PURE__ */ ne("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), gAe = ti(/* @__PURE__ */ ne("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), rAe = ti(/* @__PURE__ */ ne("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function oAe(e) {
  return St("MuiCheckbox", e);
}
const lk = Wt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), IAe = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], lAe = (e) => {
  const {
    classes: t,
    indeterminate: i,
    color: n,
    size: g
  } = e, r = {
    root: ["root", i && "indeterminate", `color${Re(n)}`, `size${Re(g)}`]
  }, o = Vt(r, oAe, t);
  return k({}, t, o);
}, sAe = ye(iD, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.indeterminate && t.indeterminate, t[`size${Re(i.size)}`], i.color !== "default" && t[`color${Re(i.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${lk.checked}, &.${lk.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${lk.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), aAe = /* @__PURE__ */ ne(gAe, {}), cAe = /* @__PURE__ */ ne(nAe, {}), dAe = /* @__PURE__ */ ne(rAe, {}), qm = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g;
  const r = Ft({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: o = aAe,
    color: I = "primary",
    icon: s = cAe,
    indeterminate: a = !1,
    indeterminateIcon: d = dAe,
    inputProps: C,
    size: u = "medium",
    className: A
  } = r, m = Ue(r, IAe), h = a ? d : s, B = a ? d : o, f = k({}, r, {
    color: I,
    indeterminate: a,
    size: u
  }), G = lAe(f);
  return /* @__PURE__ */ ne(sAe, k({
    type: "checkbox",
    inputProps: k({
      "data-indeterminate": a
    }, C),
    icon: /* @__PURE__ */ Y.cloneElement(h, {
      fontSize: (n = h.props.fontSize) != null ? n : u
    }),
    checkedIcon: /* @__PURE__ */ Y.cloneElement(B, {
      fontSize: (g = B.props.fontSize) != null ? g : u
    }),
    ownerState: f,
    ref: i,
    className: Ve(G.root, A)
  }, m, {
    classes: G
  }));
});
function CAe(e) {
  return St("MuiCircularProgress", e);
}
Wt("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const uAe = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let qw = (e) => e, HN, kN, FN, YN;
const sd = 44, AAe = Zs(HN || (HN = qw`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), bAe = Zs(kN || (kN = qw`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), mAe = (e) => {
  const {
    classes: t,
    variant: i,
    color: n,
    disableShrink: g
  } = e, r = {
    root: ["root", i, `color${Re(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Re(i)}`, g && "circleDisableShrink"]
  };
  return Vt(r, CAe, t);
}, hAe = ye("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`color${Re(i.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (t.vars || t).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && Fd(FN || (FN = qw`
      animation: ${0} 1.4s linear infinite;
    `), AAe)), pAe = ye("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), BAe = ye("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.circle, t[`circle${Re(i.variant)}`], i.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && Fd(YN || (YN = qw`
      animation: ${0} 1.4s ease-in-out infinite;
    `), bAe)), hm = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: g,
    color: r = "primary",
    disableShrink: o = !1,
    size: I = 40,
    style: s,
    thickness: a = 3.6,
    value: d = 0,
    variant: C = "indeterminate"
  } = n, u = Ue(n, uAe), A = k({}, n, {
    color: r,
    disableShrink: o,
    size: I,
    thickness: a,
    value: d,
    variant: C
  }), m = mAe(A), h = {}, B = {}, f = {};
  if (C === "determinate") {
    const G = 2 * Math.PI * ((sd - a) / 2);
    h.strokeDasharray = G.toFixed(3), f["aria-valuenow"] = Math.round(d), h.strokeDashoffset = `${((100 - d) / 100 * G).toFixed(3)}px`, B.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ ne(hAe, k({
    className: Ve(m.root, g),
    style: k({
      width: I,
      height: I
    }, B, s),
    ownerState: A,
    ref: i,
    role: "progressbar"
  }, f, u, {
    children: /* @__PURE__ */ ne(pAe, {
      className: m.svg,
      ownerState: A,
      viewBox: `${sd / 2} ${sd / 2} ${sd} ${sd}`,
      children: /* @__PURE__ */ ne(BAe, {
        className: m.circle,
        style: h,
        ownerState: A,
        cx: sd,
        cy: sd,
        r: (sd - a) / 2,
        fill: "none",
        strokeWidth: a
      })
    })
  }));
}), ZAe = (e, t) => k({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, t && !e.vars && {
  colorScheme: e.palette.mode
}), fAe = (e) => k({
  color: (e.vars || e).palette.text.primary
}, e.typography.body1, {
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
});
function GAe(e) {
  return St("MuiModal", e);
}
Wt("MuiModal", ["root", "hidden", "backdrop"]);
const yAe = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], WAe = (e) => {
  const {
    open: t,
    exited: i,
    classes: n
  } = e;
  return Vt({
    root: ["root", !t && i && "hidden"],
    backdrop: ["backdrop"]
  }, GAe, n);
}, SAe = ye("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.open && i.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), VAe = ye($w, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), FO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o, I, s;
  const a = Ft({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: d = VAe,
    BackdropProps: C,
    className: u,
    closeAfterTransition: A = !1,
    children: m,
    container: h,
    component: B,
    components: f = {},
    componentsProps: G = {},
    disableAutoFocus: y = !1,
    disableEnforceFocus: W = !1,
    disableEscapeKeyDown: V = !1,
    disablePortal: w = !1,
    disableRestoreFocus: v = !1,
    disableScrollLock: H = !1,
    hideBackdrop: x = !1,
    keepMounted: N = !1,
    onBackdropClick: M,
    open: $,
    slotProps: q,
    slots: E
    // eslint-disable-next-line react/prop-types
  } = a, L = Ue(a, yAe), P = k({}, a, {
    closeAfterTransition: A,
    disableAutoFocus: y,
    disableEnforceFocus: W,
    disableEscapeKeyDown: V,
    disablePortal: w,
    disableRestoreFocus: v,
    disableScrollLock: H,
    hideBackdrop: x,
    keepMounted: N
  }), {
    getRootProps: Q,
    getBackdropProps: te,
    getTransitionProps: le,
    portalRef: Ae,
    isTopModal: we,
    exited: Ee,
    hasTransition: Je
  } = Nce(k({}, P, {
    rootRef: i
  })), ve = k({}, P, {
    exited: Ee
  }), Be = WAe(ve), ue = {};
  if (m.props.tabIndex === void 0 && (ue.tabIndex = "-1"), Je) {
    const {
      onEnter: ot,
      onExited: ze
    } = le();
    ue.onEnter = ot, ue.onExited = ze;
  }
  const Xe = (n = (g = E == null ? void 0 : E.root) != null ? g : f.Root) != null ? n : SAe, Ze = (r = (o = E == null ? void 0 : E.backdrop) != null ? o : f.Backdrop) != null ? r : d, Ke = (I = q == null ? void 0 : q.root) != null ? I : G.root, $e = (s = q == null ? void 0 : q.backdrop) != null ? s : G.backdrop, rt = kg({
    elementType: Xe,
    externalSlotProps: Ke,
    externalForwardedProps: L,
    getSlotProps: Q,
    additionalProps: {
      ref: i,
      as: B
    },
    ownerState: ve,
    className: Ve(u, Ke == null ? void 0 : Ke.className, Be == null ? void 0 : Be.root, !ve.open && ve.exited && (Be == null ? void 0 : Be.hidden))
  }), dt = kg({
    elementType: Ze,
    externalSlotProps: $e,
    additionalProps: C,
    getSlotProps: (ot) => te(k({}, ot, {
      onClick: (ze) => {
        M && M(ze), ot != null && ot.onClick && ot.onClick(ze);
      }
    })),
    className: Ve($e == null ? void 0 : $e.className, C == null ? void 0 : C.className, Be == null ? void 0 : Be.backdrop),
    ownerState: ve
  });
  return !N && !$ && (!Je || Ee) ? null : /* @__PURE__ */ ne(CO, {
    ref: Ae,
    container: h,
    disablePortal: w,
    children: /* @__PURE__ */ Ci(Xe, k({}, rt, {
      children: [!x && d ? /* @__PURE__ */ ne(Ze, k({}, dt)) : null, /* @__PURE__ */ ne(Xce, {
        disableEnforceFocus: W,
        disableAutoFocus: y,
        disableRestoreFocus: v,
        isEnabled: we,
        open: $,
        children: /* @__PURE__ */ Y.cloneElement(m, ue)
      })]
    }))
  });
});
function wAe(e) {
  return St("MuiDialog", e);
}
const sk = Wt("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), YO = /* @__PURE__ */ Y.createContext({}), vAe = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], RAe = ye($w, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), XAe = (e) => {
  const {
    classes: t,
    scroll: i,
    maxWidth: n,
    fullWidth: g,
    fullScreen: r
  } = e, o = {
    root: ["root"],
    container: ["container", `scroll${Re(i)}`],
    paper: ["paper", `paperScroll${Re(i)}`, `paperWidth${Re(String(n))}`, g && "paperFullWidth", r && "paperFullScreen"]
  };
  return Vt(o, wAe, t);
}, HAe = ye(FO, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), kAe = ye("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.container, t[`scroll${Re(i.scroll)}`]];
  }
})(({
  ownerState: e
}) => k({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), FAe = ye(So, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.paper, t[`scrollPaper${Re(i.scroll)}`], t[`paperWidth${Re(String(i.maxWidth))}`], i.fullWidth && t.paperFullWidth, i.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${sk.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${sk.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${sk.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), Yd = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiDialog"
  }), g = qo(), r = {
    enter: g.transitions.duration.enteringScreen,
    exit: g.transitions.duration.leavingScreen
  }, {
    "aria-describedby": o,
    "aria-labelledby": I,
    BackdropComponent: s,
    BackdropProps: a,
    children: d,
    className: C,
    disableEscapeKeyDown: u = !1,
    fullScreen: A = !1,
    fullWidth: m = !1,
    maxWidth: h = "sm",
    onBackdropClick: B,
    onClick: f,
    onClose: G,
    open: y,
    PaperComponent: W = So,
    PaperProps: V = {},
    scroll: w = "paper",
    TransitionComponent: v = vO,
    transitionDuration: H = r,
    TransitionProps: x
  } = n, N = Ue(n, vAe), M = k({}, n, {
    disableEscapeKeyDown: u,
    fullScreen: A,
    fullWidth: m,
    maxWidth: h,
    scroll: w
  }), $ = XAe(M), q = Y.useRef(), E = (te) => {
    q.current = te.target === te.currentTarget;
  }, L = (te) => {
    f && f(te), q.current && (q.current = null, B && B(te), G && G(te, "backdropClick"));
  }, P = Ou(I), Q = Y.useMemo(() => ({
    titleId: P
  }), [P]);
  return /* @__PURE__ */ ne(HAe, k({
    className: Ve($.root, C),
    closeAfterTransition: !0,
    components: {
      Backdrop: RAe
    },
    componentsProps: {
      backdrop: k({
        transitionDuration: H,
        as: s
      }, a)
    },
    disableEscapeKeyDown: u,
    onClose: G,
    open: y,
    ref: i,
    onClick: L,
    ownerState: M
  }, N, {
    children: /* @__PURE__ */ ne(v, k({
      appear: !0,
      in: y,
      timeout: H,
      role: "presentation"
    }, x, {
      children: /* @__PURE__ */ ne(kAe, {
        className: Ve($.container),
        onMouseDown: E,
        ownerState: M,
        children: /* @__PURE__ */ ne(FAe, k({
          as: W,
          elevation: 24,
          role: "dialog",
          "aria-describedby": o,
          "aria-labelledby": P
        }, V, {
          className: Ve($.paper, V.className),
          ownerState: M,
          children: /* @__PURE__ */ ne(YO.Provider, {
            value: Q,
            children: d
          })
        }))
      })
    }))
  }));
});
function YAe(e) {
  return St("MuiDialogActions", e);
}
Wt("MuiDialogActions", ["root", "spacing"]);
const xAe = ["className", "disableSpacing"], DAe = (e) => {
  const {
    classes: t,
    disableSpacing: i
  } = e;
  return Vt({
    root: ["root", !i && "spacing"]
  }, YAe, t);
}, JAe = ye("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => k({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), Yu = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: g,
    disableSpacing: r = !1
  } = n, o = Ue(n, xAe), I = k({}, n, {
    disableSpacing: r
  }), s = DAe(I);
  return /* @__PURE__ */ ne(JAe, k({
    className: Ve(s.root, g),
    ownerState: I,
    ref: i
  }, o));
});
function KAe(e) {
  return St("MuiDialogContent", e);
}
Wt("MuiDialogContent", ["root", "dividers"]);
function EAe(e) {
  return St("MuiDialogTitle", e);
}
const NAe = Wt("MuiDialogTitle", ["root"]), LAe = ["className", "dividers"], TAe = (e) => {
  const {
    classes: t,
    dividers: i
  } = e;
  return Vt({
    root: ["root", i && "dividers"]
  }, KAe, t);
}, MAe = ye("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${NAe.root} + &`]: {
    paddingTop: 0
  }
})), xd = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: g,
    dividers: r = !1
  } = n, o = Ue(n, LAe), I = k({}, n, {
    dividers: r
  }), s = TAe(I);
  return /* @__PURE__ */ ne(MAe, k({
    className: Ve(s.root, g),
    ownerState: I,
    ref: i
  }, o));
});
function UAe(e) {
  return St("MuiDialogContentText", e);
}
Wt("MuiDialogContentText", ["root"]);
const PAe = ["children", "className"], zAe = (e) => {
  const {
    classes: t
  } = e, n = Vt({
    root: ["root"]
  }, UAe, t);
  return k({}, t, n);
}, OAe = ye(Ne, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiDialogContentText",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Cr = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiDialogContentText"
  }), {
    className: g
  } = n, r = Ue(n, PAe), o = zAe(r);
  return /* @__PURE__ */ ne(OAe, k({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: i,
    ownerState: r,
    className: Ve(o.root, g)
  }, n, {
    classes: o
  }));
}), QAe = ["className", "id"], jAe = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, EAe, t);
}, _Ae = ye(Ne, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), Dd = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: g,
    id: r
  } = n, o = Ue(n, QAe), I = n, s = jAe(I), {
    titleId: a = r
  } = Y.useContext(YO);
  return /* @__PURE__ */ ne(_Ae, k({
    component: "h2",
    className: Ve(s.root, g),
    ownerState: I,
    ref: i,
    variant: "h6",
    id: r ?? a
  }, o));
});
function $Ae(e) {
  return St("MuiDivider", e);
}
const qAe = Wt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), xN = qAe, ebe = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], tbe = (e) => {
  const {
    absolute: t,
    children: i,
    classes: n,
    flexItem: g,
    light: r,
    orientation: o,
    textAlign: I,
    variant: s
  } = e;
  return Vt({
    root: ["root", t && "absolute", s, r && "light", o === "vertical" && "vertical", g && "flexItem", i && "withChildren", i && o === "vertical" && "withChildrenVertical", I === "right" && o !== "vertical" && "textAlignRight", I === "left" && o !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", o === "vertical" && "wrapperVertical"]
  }, $Ae, n);
}, ibe = ye("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.absolute && t.absolute, t[i.variant], i.light && t.light, i.orientation === "vertical" && t.vertical, i.flexItem && t.flexItem, i.children && t.withChildren, i.children && i.orientation === "vertical" && t.withChildrenVertical, i.textAlign === "right" && i.orientation !== "vertical" && t.textAlignRight, i.textAlign === "left" && i.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : di(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => k({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => k({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  theme: e,
  ownerState: t
}) => k({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  ownerState: e
}) => k({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), nbe = ye("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.wrapper, i.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), xO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: g = !1,
    children: r,
    className: o,
    component: I = r ? "div" : "hr",
    flexItem: s = !1,
    light: a = !1,
    orientation: d = "horizontal",
    role: C = I !== "hr" ? "separator" : void 0,
    textAlign: u = "center",
    variant: A = "fullWidth"
  } = n, m = Ue(n, ebe), h = k({}, n, {
    absolute: g,
    component: I,
    flexItem: s,
    light: a,
    orientation: d,
    role: C,
    textAlign: u,
    variant: A
  }), B = tbe(h);
  return /* @__PURE__ */ ne(ibe, k({
    as: I,
    className: Ve(B.root, o),
    role: C,
    ref: i,
    ownerState: h
  }, m, {
    children: r ? /* @__PURE__ */ ne(nbe, {
      className: B.wrapper,
      ownerState: h,
      children: r
    }) : null
  }));
});
xO.muiSkipListHighlight = !0;
const bs = xO, gbe = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function rbe(e, t, i) {
  const n = t.getBoundingClientRect(), g = i && i.getBoundingClientRect(), r = pl(t);
  let o;
  if (t.fakeTransform)
    o = t.fakeTransform;
  else {
    const a = r.getComputedStyle(t);
    o = a.getPropertyValue("-webkit-transform") || a.getPropertyValue("transform");
  }
  let I = 0, s = 0;
  if (o && o !== "none" && typeof o == "string") {
    const a = o.split("(")[1].split(")")[0].split(",");
    I = parseInt(a[4], 10), s = parseInt(a[5], 10);
  }
  return e === "left" ? g ? `translateX(${g.right + I - n.left}px)` : `translateX(${r.innerWidth + I - n.left}px)` : e === "right" ? g ? `translateX(-${n.right - g.left - I}px)` : `translateX(-${n.left + n.width - I}px)` : e === "up" ? g ? `translateY(${g.bottom + s - n.top}px)` : `translateY(${r.innerHeight + s - n.top}px)` : g ? `translateY(-${n.top - g.top + n.height - s}px)` : `translateY(-${n.top + n.height - s}px)`;
}
function obe(e) {
  return typeof e == "function" ? e() : e;
}
function eW(e, t, i) {
  const n = obe(i), g = rbe(e, t, n);
  g && (t.style.webkitTransform = g, t.style.transform = g);
}
const Ibe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = qo(), g = {
    enter: n.transitions.easing.easeOut,
    exit: n.transitions.easing.sharp
  }, r = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: o,
    appear: I = !0,
    children: s,
    container: a,
    direction: d = "down",
    easing: C = g,
    in: u,
    onEnter: A,
    onEntered: m,
    onEntering: h,
    onExit: B,
    onExited: f,
    onExiting: G,
    style: y,
    timeout: W = r,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: V = JI
  } = t, w = Ue(t, gbe), v = Y.useRef(null), H = gn(s.ref, v, i), x = (te) => (le) => {
    te && (le === void 0 ? te(v.current) : te(v.current, le));
  }, N = x((te, le) => {
    eW(d, te, a), Lw(te), A && A(te, le);
  }), M = x((te, le) => {
    const Ae = aa({
      timeout: W,
      style: y,
      easing: C
    }, {
      mode: "enter"
    });
    te.style.webkitTransition = n.transitions.create("-webkit-transform", k({}, Ae)), te.style.transition = n.transitions.create("transform", k({}, Ae)), te.style.webkitTransform = "none", te.style.transform = "none", h && h(te, le);
  }), $ = x(m), q = x(G), E = x((te) => {
    const le = aa({
      timeout: W,
      style: y,
      easing: C
    }, {
      mode: "exit"
    });
    te.style.webkitTransition = n.transitions.create("-webkit-transform", le), te.style.transition = n.transitions.create("transform", le), eW(d, te, a), B && B(te);
  }), L = x((te) => {
    te.style.webkitTransition = "", te.style.transition = "", f && f(te);
  }), P = (te) => {
    o && o(v.current, te);
  }, Q = Y.useCallback(() => {
    v.current && eW(d, v.current, a);
  }, [d, a]);
  return Y.useEffect(() => {
    if (u || d === "down" || d === "right")
      return;
    const te = Om(() => {
      v.current && eW(d, v.current, a);
    }), le = pl(v.current);
    return le.addEventListener("resize", te), () => {
      te.clear(), le.removeEventListener("resize", te);
    };
  }, [d, u, a]), Y.useEffect(() => {
    u || Q();
  }, [u, Q]), /* @__PURE__ */ ne(V, k({
    nodeRef: v,
    onEnter: N,
    onEntered: $,
    onEntering: M,
    onExit: E,
    onExited: L,
    onExiting: q,
    addEndListener: P,
    appear: I,
    in: u,
    timeout: W
  }, w, {
    children: (te, le) => /* @__PURE__ */ Y.cloneElement(s, k({
      ref: H,
      style: k({
        visibility: te === "exited" && !u ? "hidden" : void 0
      }, y, s.props.style)
    }, le))
  }));
}), lbe = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], sbe = (e) => {
  const {
    classes: t,
    disableUnderline: i
  } = e, g = Vt({
    root: ["root", !i && "underline"],
    input: ["input"]
  }, TCe, t);
  return k({}, t, g);
}, abe = ye(Qw, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [...zw(e, t), !i.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i;
  const n = e.palette.mode === "light", g = n ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = n ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = n ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", I = n ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return k({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${hI.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${hI.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : I
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(i = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : i.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${hI.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${hI.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : g}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${hI.disabled}, .${hI.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${hI.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && k({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), cbe = ye(jw, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Ow
})(({
  theme: e,
  ownerState: t
}) => k({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), nD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o;
  const I = Ft({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: s = {},
    componentsProps: a,
    fullWidth: d = !1,
    // declare here to prevent spreading to DOM
    inputComponent: C = "input",
    multiline: u = !1,
    slotProps: A,
    slots: m = {},
    type: h = "text"
  } = I, B = Ue(I, lbe), f = k({}, I, {
    fullWidth: d,
    inputComponent: C,
    multiline: u,
    type: h
  }), G = sbe(I), y = {
    root: {
      ownerState: f
    },
    input: {
      ownerState: f
    }
  }, W = A ?? a ? dr(y, A ?? a) : y, V = (n = (g = m.root) != null ? g : s.Root) != null ? n : abe, w = (r = (o = m.input) != null ? o : s.Input) != null ? r : cbe;
  return /* @__PURE__ */ ne(_w, k({
    slots: {
      root: V,
      input: w
    },
    componentsProps: W,
    fullWidth: d,
    inputComponent: C,
    multiline: u,
    ref: i,
    type: h
  }, B, {
    classes: G
  }));
});
nD.muiName = "Input";
function dbe(e) {
  return St("MuiFormControl", e);
}
Wt("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const Cbe = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], ube = (e) => {
  const {
    classes: t,
    margin: i,
    fullWidth: n
  } = e, g = {
    root: ["root", i !== "none" && `margin${Re(i)}`, n && "fullWidth"]
  };
  return Vt(g, dbe, t);
}, Abe = ye("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => k({}, t.root, t[`margin${Re(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => k({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), fs = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiFormControl"
  }), {
    children: g,
    className: r,
    color: o = "primary",
    component: I = "div",
    disabled: s = !1,
    error: a = !1,
    focused: d,
    fullWidth: C = !1,
    hiddenLabel: u = !1,
    margin: A = "none",
    required: m = !1,
    size: h = "medium",
    variant: B = "outlined"
  } = n, f = Ue(n, Cbe), G = k({}, n, {
    color: o,
    component: I,
    disabled: s,
    error: a,
    fullWidth: C,
    hiddenLabel: u,
    margin: A,
    required: m,
    size: h,
    variant: B
  }), y = ube(G), [W, V] = Y.useState(() => {
    let q = !1;
    return g && Y.Children.forEach(g, (E) => {
      if (!sB(E, ["Input", "Select"]))
        return;
      const L = sB(E, ["Select"]) ? E.props.input : E;
      L && xCe(L.props) && (q = !0);
    }), q;
  }), [w, v] = Y.useState(() => {
    let q = !1;
    return g && Y.Children.forEach(g, (E) => {
      sB(E, ["Input", "Select"]) && (YS(E.props, !0) || YS(E.props.inputProps, !0)) && (q = !0);
    }), q;
  }), [H, x] = Y.useState(!1);
  s && H && x(!1);
  const N = d !== void 0 && !s ? d : H;
  let M;
  const $ = Y.useMemo(() => ({
    adornedStart: W,
    setAdornedStart: V,
    color: o,
    disabled: s,
    error: a,
    filled: w,
    focused: N,
    fullWidth: C,
    hiddenLabel: u,
    size: h,
    onBlur: () => {
      x(!1);
    },
    onEmpty: () => {
      v(!1);
    },
    onFilled: () => {
      v(!0);
    },
    onFocus: () => {
      x(!0);
    },
    registerEffect: M,
    required: m,
    variant: B
  }), [W, o, s, a, w, N, C, u, M, m, h, B]);
  return /* @__PURE__ */ ne(Pw.Provider, {
    value: $,
    children: /* @__PURE__ */ ne(Abe, k({
      as: I,
      ownerState: G,
      className: Ve(y.root, r),
      ref: i
    }, f, {
      children: g
    }))
  });
}), _t = Tle({
  createStyledComponent: ye("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Ft({
    props: e,
    name: "MuiStack"
  })
});
function bbe(e) {
  return St("MuiFormControlLabel", e);
}
const P0 = Wt("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), mbe = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], hbe = (e) => {
  const {
    classes: t,
    disabled: i,
    labelPlacement: n,
    error: g,
    required: r
  } = e, o = {
    root: ["root", i && "disabled", `labelPlacement${Re(n)}`, g && "error", r && "required"],
    label: ["label", i && "disabled"],
    asterisk: ["asterisk", g && "error"]
  };
  return Vt(o, bbe, t);
}, pbe = ye("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${P0.label}`]: t.label
    }, t.root, t[`labelPlacement${Re(i.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${P0.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${P0.label}`]: {
    [`&.${P0.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), Bbe = ye("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${P0.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), e1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g;
  const r = Ft({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: o,
    componentsProps: I = {},
    control: s,
    disabled: a,
    disableTypography: d,
    label: C,
    labelPlacement: u = "end",
    required: A,
    slotProps: m = {}
  } = r, h = Ue(r, mbe), B = pa(), f = (n = a ?? s.props.disabled) != null ? n : B == null ? void 0 : B.disabled, G = A ?? s.props.required, y = {
    disabled: f,
    required: G
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((x) => {
    typeof s.props[x] > "u" && typeof r[x] < "u" && (y[x] = r[x]);
  });
  const W = zd({
    props: r,
    muiFormControl: B,
    states: ["error"]
  }), V = k({}, r, {
    disabled: f,
    labelPlacement: u,
    required: G,
    error: W.error
  }), w = hbe(V), v = (g = m.typography) != null ? g : I.typography;
  let H = C;
  return H != null && H.type !== Ne && !d && (H = /* @__PURE__ */ ne(Ne, k({
    component: "span"
  }, v, {
    className: Ve(w.label, v == null ? void 0 : v.className),
    children: H
  }))), /* @__PURE__ */ Ci(pbe, k({
    className: Ve(w.root, o),
    ownerState: V,
    ref: i
  }, h, {
    children: [/* @__PURE__ */ Y.cloneElement(s, y), G ? /* @__PURE__ */ Ci(_t, {
      display: "block",
      children: [H, /* @__PURE__ */ Ci(Bbe, {
        ownerState: V,
        "aria-hidden": !0,
        className: w.asterisk,
        children: [" ", "*"]
      })]
    }) : H]
  }));
});
function Zbe(e) {
  return St("MuiFormGroup", e);
}
Wt("MuiFormGroup", ["root", "row", "error"]);
const fbe = ["className", "row"], Gbe = (e) => {
  const {
    classes: t,
    row: i,
    error: n
  } = e;
  return Vt({
    root: ["root", i && "row", n && "error"]
  }, Zbe, t);
}, ybe = ye("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.row && t.row];
  }
})(({
  ownerState: e
}) => k({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), Wbe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: g,
    row: r = !1
  } = n, o = Ue(n, fbe), I = pa(), s = zd({
    props: n,
    muiFormControl: I,
    states: ["error"]
  }), a = k({}, n, {
    row: r,
    error: s.error
  }), d = Gbe(a);
  return /* @__PURE__ */ ne(ybe, k({
    className: Ve(d.root, g),
    ownerState: a,
    ref: i
  }, o));
});
function Sbe(e) {
  return St("MuiFormHelperText", e);
}
const DN = Wt("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var JN;
const Vbe = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], wbe = (e) => {
  const {
    classes: t,
    contained: i,
    size: n,
    disabled: g,
    error: r,
    filled: o,
    focused: I,
    required: s
  } = e, a = {
    root: ["root", g && "disabled", r && "error", n && `size${Re(n)}`, i && "contained", I && "focused", o && "filled", s && "required"]
  };
  return Vt(a, Sbe, t);
}, vbe = ye("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.size && t[`size${Re(i.size)}`], i.contained && t.contained, i.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${DN.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${DN.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), UB = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: g,
    className: r,
    component: o = "p"
  } = n, I = Ue(n, Vbe), s = pa(), a = zd({
    props: n,
    muiFormControl: s,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), d = k({}, n, {
    component: o,
    contained: a.variant === "filled" || a.variant === "outlined",
    variant: a.variant,
    size: a.size,
    disabled: a.disabled,
    error: a.error,
    filled: a.filled,
    focused: a.focused,
    required: a.required
  }), C = wbe(d);
  return /* @__PURE__ */ ne(vbe, k({
    as: o,
    ownerState: d,
    className: Ve(C.root, r),
    ref: i
  }, I, {
    children: g === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      JN || (JN = /* @__PURE__ */ ne("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : g
  }));
});
function Rbe(e) {
  return St("MuiFormLabel", e);
}
const uB = Wt("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Xbe = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], Hbe = (e) => {
  const {
    classes: t,
    color: i,
    focused: n,
    disabled: g,
    error: r,
    filled: o,
    required: I
  } = e, s = {
    root: ["root", `color${Re(i)}`, g && "disabled", r && "error", o && "filled", n && "focused", I && "required"],
    asterisk: ["asterisk", r && "error"]
  };
  return Vt(s, Rbe, t);
}, kbe = ye("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => k({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => k({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${uB.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${uB.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${uB.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Fbe = ye("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${uB.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Ybe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: g,
    className: r,
    component: o = "label"
  } = n, I = Ue(n, Xbe), s = pa(), a = zd({
    props: n,
    muiFormControl: s,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), d = k({}, n, {
    color: a.color || "primary",
    component: o,
    disabled: a.disabled,
    error: a.error,
    filled: a.filled,
    focused: a.focused,
    required: a.required
  }), C = Hbe(d);
  return /* @__PURE__ */ Ci(kbe, k({
    as: o,
    ownerState: d,
    className: Ve(C.root, r),
    ref: i
  }, I, {
    children: [g, a.required && /* @__PURE__ */ Ci(Fbe, {
      ownerState: d,
      "aria-hidden": !0,
      className: C.asterisk,
      children: [" ", "*"]
    })]
  }));
}), xbe = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function mY(e) {
  return `scale(${e}, ${e ** 2})`;
}
const Dbe = {
  entering: {
    opacity: 1,
    transform: mY(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, ak = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), xS = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    addEndListener: n,
    appear: g = !0,
    children: r,
    easing: o,
    in: I,
    onEnter: s,
    onEntered: a,
    onEntering: d,
    onExit: C,
    onExited: u,
    onExiting: A,
    style: m,
    timeout: h = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: B = JI
  } = t, f = Ue(t, xbe), G = Zu(), y = Y.useRef(), W = qo(), V = Y.useRef(null), w = gn(V, r.ref, i), v = (L) => (P) => {
    if (L) {
      const Q = V.current;
      P === void 0 ? L(Q) : L(Q, P);
    }
  }, H = v(d), x = v((L, P) => {
    Lw(L);
    const {
      duration: Q,
      delay: te,
      easing: le
    } = aa({
      style: m,
      timeout: h,
      easing: o
    }, {
      mode: "enter"
    });
    let Ae;
    h === "auto" ? (Ae = W.transitions.getAutoHeightDuration(L.clientHeight), y.current = Ae) : Ae = Q, L.style.transition = [W.transitions.create("opacity", {
      duration: Ae,
      delay: te
    }), W.transitions.create("transform", {
      duration: ak ? Ae : Ae * 0.666,
      delay: te,
      easing: le
    })].join(","), s && s(L, P);
  }), N = v(a), M = v(A), $ = v((L) => {
    const {
      duration: P,
      delay: Q,
      easing: te
    } = aa({
      style: m,
      timeout: h,
      easing: o
    }, {
      mode: "exit"
    });
    let le;
    h === "auto" ? (le = W.transitions.getAutoHeightDuration(L.clientHeight), y.current = le) : le = P, L.style.transition = [W.transitions.create("opacity", {
      duration: le,
      delay: Q
    }), W.transitions.create("transform", {
      duration: ak ? le : le * 0.666,
      delay: ak ? Q : Q || le * 0.333,
      easing: te
    })].join(","), L.style.opacity = 0, L.style.transform = mY(0.75), C && C(L);
  }), q = v(u);
  return /* @__PURE__ */ ne(B, k({
    appear: g,
    in: I,
    nodeRef: V,
    onEnter: x,
    onEntered: N,
    onEntering: H,
    onExit: $,
    onExited: q,
    onExiting: M,
    addEndListener: (L) => {
      h === "auto" && G.start(y.current || 0, L), n && n(V.current, L);
    },
    timeout: h === "auto" ? null : h
  }, f, {
    children: (L, P) => /* @__PURE__ */ Y.cloneElement(r, k({
      style: k({
        opacity: 0,
        transform: mY(0.75),
        visibility: L === "exited" && !I ? "hidden" : void 0
      }, Dbe[L], m, r.props.style),
      ref: w
    }, P))
  }));
});
xS.muiSupportAuto = !0;
const Jbe = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], Kbe = (e) => {
  const {
    classes: t,
    disableUnderline: i
  } = e, g = Vt({
    root: ["root", !i && "underline"],
    input: ["input"]
  }, NCe, t);
  return k({}, t, g);
}, Ebe = ye(Qw, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [...zw(e, t), !i.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), k({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${fd.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${fd.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${n}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${fd.disabled}, .${fd.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${n}`
      }
    },
    [`&.${fd.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), Nbe = ye(jw, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Ow
})({}), t1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o;
  const I = Ft({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: s,
    components: a = {},
    componentsProps: d,
    fullWidth: C = !1,
    inputComponent: u = "input",
    multiline: A = !1,
    slotProps: m,
    slots: h = {},
    type: B = "text"
  } = I, f = Ue(I, Jbe), G = Kbe(I), W = {
    root: {
      ownerState: {
        disableUnderline: s
      }
    }
  }, V = m ?? d ? dr(m ?? d, W) : W, w = (n = (g = h.root) != null ? g : a.Root) != null ? n : Ebe, v = (r = (o = h.input) != null ? o : a.Input) != null ? r : Nbe;
  return /* @__PURE__ */ ne(_w, k({
    slots: {
      root: w,
      input: v
    },
    slotProps: V,
    fullWidth: C,
    inputComponent: u,
    multiline: A,
    ref: i,
    type: B
  }, f, {
    classes: G
  }));
});
t1.muiName = "Input";
function Lbe(e) {
  return St("MuiInputAdornment", e);
}
const KN = Wt("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var EN;
const Tbe = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], Mbe = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, t[`position${Re(i.position)}`], i.disablePointerEvents === !0 && t.disablePointerEvents, t[i.variant]];
}, Ube = (e) => {
  const {
    classes: t,
    disablePointerEvents: i,
    hiddenLabel: n,
    position: g,
    size: r,
    variant: o
  } = e, I = {
    root: ["root", i && "disablePointerEvents", g && `position${Re(g)}`, o, n && "hiddenLabel", r && `size${Re(r)}`]
  };
  return Vt(I, Lbe, t);
}, Pbe = ye("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: Mbe
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${KN.positionStart}&:not(.${KN.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), pm = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: g,
    className: r,
    component: o = "div",
    disablePointerEvents: I = !1,
    disableTypography: s = !1,
    position: a,
    variant: d
  } = n, C = Ue(n, Tbe), u = pa() || {};
  let A = d;
  d && u.variant, u && !A && (A = u.variant);
  const m = k({}, n, {
    hiddenLabel: u.hiddenLabel,
    size: u.size,
    disablePointerEvents: I,
    position: a,
    variant: A
  }), h = Ube(m);
  return /* @__PURE__ */ ne(Pw.Provider, {
    value: null,
    children: /* @__PURE__ */ ne(Pbe, k({
      as: o,
      ownerState: m,
      className: Ve(h.root, r),
      ref: i
    }, C, {
      children: typeof g == "string" && !s ? /* @__PURE__ */ ne(Ne, {
        color: "text.secondary",
        children: g
      }) : /* @__PURE__ */ Ci(Y.Fragment, {
        children: [a === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          EN || (EN = /* @__PURE__ */ ne("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, g]
      })
    }))
  });
});
function zbe(e) {
  return St("MuiInputLabel", e);
}
Wt("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const Obe = ["disableAnimation", "margin", "shrink", "variant", "className"], Qbe = (e) => {
  const {
    classes: t,
    formControl: i,
    size: n,
    shrink: g,
    disableAnimation: r,
    variant: o,
    required: I
  } = e, s = {
    root: ["root", i && "formControl", !r && "animated", g && "shrink", n && n !== "normal" && `size${Re(n)}`, o],
    asterisk: [I && "asterisk"]
  }, a = Vt(s, zbe, t);
  return k({}, t, a);
}, jbe = ye(Ybe, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${uB.asterisk}`]: t.asterisk
    }, t.root, i.formControl && t.formControl, i.size === "small" && t.sizeSmall, i.shrink && t.shrink, !i.disableAnimation && t.animated, i.focused && t.focused, t[i.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && k({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && k({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && k({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), DO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: g = !1,
    shrink: r,
    className: o
  } = n, I = Ue(n, Obe), s = pa();
  let a = r;
  typeof a > "u" && s && (a = s.filled || s.focused || s.adornedStart);
  const d = zd({
    props: n,
    muiFormControl: s,
    states: ["size", "variant", "required", "focused"]
  }), C = k({}, n, {
    disableAnimation: g,
    formControl: s,
    shrink: a,
    size: d.size,
    variant: d.variant,
    required: d.required,
    focused: d.focused
  }), u = Qbe(C);
  return /* @__PURE__ */ ne(jbe, k({
    "data-shrink": a,
    ownerState: C,
    ref: i,
    className: Ve(u.root, o)
  }, I, {
    classes: u
  }));
});
function _be(e) {
  return St("MuiLinearProgress", e);
}
Wt("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const $be = ["className", "color", "value", "valueBuffer", "variant"];
let eh = (e) => e, NN, LN, TN, MN, UN, PN;
const hY = 4, qbe = Zs(NN || (NN = eh`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), eme = Zs(LN || (LN = eh`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), tme = Zs(TN || (TN = eh`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), ime = (e) => {
  const {
    classes: t,
    variant: i,
    color: n
  } = e, g = {
    root: ["root", `color${Re(n)}`, i],
    dashed: ["dashed", `dashedColor${Re(n)}`],
    bar1: ["bar", `barColor${Re(n)}`, (i === "indeterminate" || i === "query") && "bar1Indeterminate", i === "determinate" && "bar1Determinate", i === "buffer" && "bar1Buffer"],
    bar2: ["bar", i !== "buffer" && `barColor${Re(n)}`, i === "buffer" && `color${Re(n)}`, (i === "indeterminate" || i === "query") && "bar2Indeterminate", i === "buffer" && "bar2Buffer"]
  };
  return Vt(g, _be, t);
}, gD = (e, t) => t === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? Sm(e.palette[t].main, 0.62) : Wm(e.palette[t].main, 0.5), nme = ye("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`color${Re(i.color)}`], t[i.variant]];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: gD(t, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), gme = ye("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.dashed, t[`dashedColor${Re(i.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const i = gD(t, e.color);
  return k({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${i} 0%, ${i} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, Fd(MN || (MN = eh`
    animation: ${0} 3s infinite linear;
  `), tme)), rme = ye("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.bar, t[`barColor${Re(i.color)}`], (i.variant === "indeterminate" || i.variant === "query") && t.bar1Indeterminate, i.variant === "determinate" && t.bar1Determinate, i.variant === "buffer" && t.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${hY}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${hY}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Fd(UN || (UN = eh`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), qbe)), ome = ye("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.bar, t[`barColor${Re(i.color)}`], (i.variant === "indeterminate" || i.variant === "query") && t.bar2Indeterminate, i.variant === "buffer" && t.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: gD(t, e.color),
  transition: `transform .${hY}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Fd(PN || (PN = eh`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), eme)), Ime = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: g,
    color: r = "primary",
    value: o,
    valueBuffer: I,
    variant: s = "indeterminate"
  } = n, a = Ue(n, $be), d = k({}, n, {
    color: r,
    variant: s
  }), C = ime(d), u = Qm(), A = {}, m = {
    bar1: {},
    bar2: {}
  };
  if ((s === "determinate" || s === "buffer") && o !== void 0) {
    A["aria-valuenow"] = Math.round(o), A["aria-valuemin"] = 0, A["aria-valuemax"] = 100;
    let h = o - 100;
    u && (h = -h), m.bar1.transform = `translateX(${h}%)`;
  }
  if (s === "buffer" && I !== void 0) {
    let h = (I || 0) - 100;
    u && (h = -h), m.bar2.transform = `translateX(${h}%)`;
  }
  return /* @__PURE__ */ Ci(nme, k({
    className: Ve(C.root, g),
    ownerState: d,
    role: "progressbar"
  }, A, {
    ref: i
  }, a, {
    children: [s === "buffer" ? /* @__PURE__ */ ne(gme, {
      className: C.dashed,
      ownerState: d
    }) : null, /* @__PURE__ */ ne(rme, {
      className: C.bar1,
      ownerState: d,
      style: m.bar1
    }), s === "determinate" ? null : /* @__PURE__ */ ne(ome, {
      className: C.bar2,
      ownerState: d,
      style: m.bar2
    })]
  }));
});
function lme(e) {
  return St("MuiLink", e);
}
const sme = Wt("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), ame = sme, JO = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, cme = (e) => JO[e] || e, dme = ({
  theme: e,
  ownerState: t
}) => {
  const i = cme(t.color), n = ym(e, `palette.${i}`, !1) || t.color, g = ym(e, `palette.${i}Channel`);
  return "vars" in e && g ? `rgba(${g} / 0.4)` : di(n, 0.4);
}, Cme = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], ume = (e) => {
  const {
    classes: t,
    component: i,
    focusVisible: n,
    underline: g
  } = e, r = {
    root: ["root", `underline${Re(g)}`, i === "button" && "button", n && "focusVisible"]
  };
  return Vt(r, lme, t);
}, Ame = ye(Ne, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`underline${Re(i.underline)}`], i.component === "button" && t.button];
  }
})(({
  theme: e,
  ownerState: t
}) => k({}, t.underline === "none" && {
  textDecoration: "none"
}, t.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, t.underline === "always" && k({
  textDecoration: "underline"
}, t.color !== "inherit" && {
  textDecorationColor: dme({
    theme: e,
    ownerState: t
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), t.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${ame.focusVisible}`]: {
    outline: "auto"
  }
})), bme = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiLink"
  }), {
    className: g,
    color: r = "primary",
    component: o = "a",
    onBlur: I,
    onFocus: s,
    TypographyClasses: a,
    underline: d = "always",
    variant: C = "inherit",
    sx: u
  } = n, A = Ue(n, Cme), {
    isFocusVisibleRef: m,
    onBlur: h,
    onFocus: B,
    ref: f
  } = SZ(), [G, y] = Y.useState(!1), W = gn(i, f), V = (x) => {
    h(x), m.current === !1 && y(!1), I && I(x);
  }, w = (x) => {
    B(x), m.current === !0 && y(!0), s && s(x);
  }, v = k({}, n, {
    color: r,
    component: o,
    focusVisible: G,
    underline: d,
    variant: C
  }), H = ume(v);
  return /* @__PURE__ */ ne(Ame, k({
    color: r,
    className: Ve(H.root, g),
    classes: a,
    component: o,
    onBlur: V,
    onFocus: w,
    ref: W,
    ownerState: v,
    variant: C,
    sx: [...Object.keys(JO).includes(r) ? [] : [{
      color: r
    }], ...Array.isArray(u) ? u : [u]]
  }, A));
}), as = bme, ml = /* @__PURE__ */ Y.createContext({});
function mme(e) {
  return St("MuiList", e);
}
Wt("MuiList", ["root", "padding", "dense", "subheader"]);
const hme = ["children", "className", "component", "dense", "disablePadding", "subheader"], pme = (e) => {
  const {
    classes: t,
    disablePadding: i,
    dense: n,
    subheader: g
  } = e;
  return Vt({
    root: ["root", !i && "padding", n && "dense", g && "subheader"]
  }, mme, t);
}, Bme = ye("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.disablePadding && t.padding, i.dense && t.dense, i.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => k({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), PB = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiList"
  }), {
    children: g,
    className: r,
    component: o = "ul",
    dense: I = !1,
    disablePadding: s = !1,
    subheader: a
  } = n, d = Ue(n, hme), C = Y.useMemo(() => ({
    dense: I
  }), [I]), u = k({}, n, {
    component: o,
    dense: I,
    disablePadding: s
  }), A = pme(u);
  return /* @__PURE__ */ ne(ml.Provider, {
    value: C,
    children: /* @__PURE__ */ Ci(Bme, k({
      as: o,
      className: Ve(A.root, r),
      ref: i,
      ownerState: u
    }, d, {
      children: [a, g]
    }))
  });
});
function Zme(e) {
  return St("MuiListItem", e);
}
const im = Wt("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]);
function fme(e) {
  return St("MuiListItemButton", e);
}
const nm = Wt("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), Gme = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"], yme = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.dense && t.dense, i.alignItems === "flex-start" && t.alignItemsFlexStart, i.divider && t.divider, !i.disableGutters && t.gutters];
}, Wme = (e) => {
  const {
    alignItems: t,
    classes: i,
    dense: n,
    disabled: g,
    disableGutters: r,
    divider: o,
    selected: I
  } = e, a = Vt({
    root: ["root", n && "dense", !r && "gutters", o && "divider", g && "disabled", t === "flex-start" && "alignItemsFlexStart", I && "selected"]
  }, fme, i);
  return k({}, i, a);
}, Sme = ye(fo, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: yme
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${nm.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${nm.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${nm.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${nm.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${nm.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
})), rD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: g = "center",
    autoFocus: r = !1,
    component: o = "div",
    children: I,
    dense: s = !1,
    disableGutters: a = !1,
    divider: d = !1,
    focusVisibleClassName: C,
    selected: u = !1,
    className: A
  } = n, m = Ue(n, Gme), h = Y.useContext(ml), B = Y.useMemo(() => ({
    dense: s || h.dense || !1,
    alignItems: g,
    disableGutters: a
  }), [g, h.dense, s, a]), f = Y.useRef(null);
  eo(() => {
    r && f.current && f.current.focus();
  }, [r]);
  const G = k({}, n, {
    alignItems: g,
    dense: B.dense,
    disableGutters: a,
    divider: d,
    selected: u
  }), y = Wme(G), W = gn(f, i);
  return /* @__PURE__ */ ne(ml.Provider, {
    value: B,
    children: /* @__PURE__ */ ne(Sme, k({
      ref: W,
      href: m.href || m.to,
      component: (m.href || m.to) && o === "div" ? "button" : o,
      focusVisibleClassName: Ve(y.focusVisible, C),
      ownerState: G,
      className: Ve(y.root, A)
    }, m, {
      classes: y,
      children: I
    }))
  });
});
function Vme(e) {
  return St("MuiListItemSecondaryAction", e);
}
Wt("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const wme = ["className"], vme = (e) => {
  const {
    disableGutters: t,
    classes: i
  } = e;
  return Vt({
    root: ["root", t && "disableGutters"]
  }, Vme, i);
}, Rme = ye("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => k({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), KO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: g
  } = n, r = Ue(n, wme), o = Y.useContext(ml), I = k({}, n, {
    disableGutters: o.disableGutters
  }), s = vme(I);
  return /* @__PURE__ */ ne(Rme, k({
    className: Ve(s.root, g),
    ownerState: I,
    ref: i
  }, r));
});
KO.muiName = "ListItemSecondaryAction";
const Xme = ["className"], Hme = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], kme = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.dense && t.dense, i.alignItems === "flex-start" && t.alignItemsFlexStart, i.divider && t.divider, !i.disableGutters && t.gutters, !i.disablePadding && t.padding, i.button && t.button, i.hasSecondaryAction && t.secondaryAction];
}, Fme = (e) => {
  const {
    alignItems: t,
    button: i,
    classes: n,
    dense: g,
    disabled: r,
    disableGutters: o,
    disablePadding: I,
    divider: s,
    hasSecondaryAction: a,
    selected: d
  } = e;
  return Vt({
    root: ["root", g && "dense", !o && "gutters", !I && "padding", s && "divider", r && "disabled", i && "button", t === "flex-start" && "alignItemsFlexStart", a && "secondaryAction", d && "selected"],
    container: ["container"]
  }, Zme, n);
}, Yme = ye("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: kme
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && k({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${nm.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${im.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${im.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${im.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${im.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${im.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), xme = ye("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), oD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: g = "center",
    autoFocus: r = !1,
    button: o = !1,
    children: I,
    className: s,
    component: a,
    components: d = {},
    componentsProps: C = {},
    ContainerComponent: u = "li",
    ContainerProps: {
      className: A
    } = {},
    dense: m = !1,
    disabled: h = !1,
    disableGutters: B = !1,
    disablePadding: f = !1,
    divider: G = !1,
    focusVisibleClassName: y,
    secondaryAction: W,
    selected: V = !1,
    slotProps: w = {},
    slots: v = {}
  } = n, H = Ue(n.ContainerProps, Xme), x = Ue(n, Hme), N = Y.useContext(ml), M = Y.useMemo(() => ({
    dense: m || N.dense || !1,
    alignItems: g,
    disableGutters: B
  }), [g, N.dense, m, B]), $ = Y.useRef(null);
  eo(() => {
    r && $.current && $.current.focus();
  }, [r]);
  const q = Y.Children.toArray(I), E = q.length && sB(q[q.length - 1], ["ListItemSecondaryAction"]), L = k({}, n, {
    alignItems: g,
    autoFocus: r,
    button: o,
    dense: M.dense,
    disabled: h,
    disableGutters: B,
    disablePadding: f,
    divider: G,
    hasSecondaryAction: E,
    selected: V
  }), P = Fme(L), Q = gn($, i), te = v.root || d.Root || Yme, le = w.root || C.root || {}, Ae = k({
    className: Ve(P.root, le.className, s),
    disabled: h
  }, x);
  let we = a || "li";
  return o && (Ae.component = a || "div", Ae.focusVisibleClassName = Ve(im.focusVisible, y), we = fo), E ? (we = !Ae.component && !a ? "div" : we, u === "li" && (we === "li" ? we = "div" : Ae.component === "li" && (Ae.component = "div")), /* @__PURE__ */ ne(ml.Provider, {
    value: M,
    children: /* @__PURE__ */ Ci(xme, k({
      as: u,
      className: Ve(P.container, A),
      ref: Q,
      ownerState: L
    }, H, {
      children: [/* @__PURE__ */ ne(te, k({}, le, !oa(te) && {
        as: we,
        ownerState: k({}, L, le.ownerState)
      }, Ae, {
        children: q
      })), q.pop()]
    }))
  })) : /* @__PURE__ */ ne(ml.Provider, {
    value: M,
    children: /* @__PURE__ */ Ci(te, k({}, le, {
      as: we,
      ref: Q
    }, !oa(te) && {
      ownerState: k({}, L, le.ownerState)
    }, Ae, {
      children: [q, W && /* @__PURE__ */ ne(KO, {
        children: W
      })]
    }))
  });
});
function Dme(e) {
  return St("MuiListItemAvatar", e);
}
Wt("MuiListItemAvatar", ["root", "alignItemsFlexStart"]);
const Jme = ["className"], Kme = (e) => {
  const {
    alignItems: t,
    classes: i
  } = e;
  return Vt({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, Dme, i);
}, Eme = ye("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  ownerState: e
}) => k({
  minWidth: 56,
  flexShrink: 0
}, e.alignItems === "flex-start" && {
  marginTop: 8
})), Nme = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: g
  } = n, r = Ue(n, Jme), o = Y.useContext(ml), I = k({}, n, {
    alignItems: o.alignItems
  }), s = Kme(I);
  return /* @__PURE__ */ ne(Eme, k({
    className: Ve(s.root, g),
    ownerState: I,
    ref: i
  }, r));
});
function Lme(e) {
  return St("MuiListItemIcon", e);
}
const zN = Wt("MuiListItemIcon", ["root", "alignItemsFlexStart"]), Tme = ["className"], Mme = (e) => {
  const {
    alignItems: t,
    classes: i
  } = e;
  return Vt({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, Lme, i);
}, Ume = ye("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex"
}, t.alignItems === "flex-start" && {
  marginTop: 8
})), Pme = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: g
  } = n, r = Ue(n, Tme), o = Y.useContext(ml), I = k({}, n, {
    alignItems: o.alignItems
  }), s = Mme(I);
  return /* @__PURE__ */ ne(Ume, k({
    className: Ve(s.root, g),
    ownerState: I,
    ref: i
  }, r));
});
function zme(e) {
  return St("MuiListItemText", e);
}
const DS = Wt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), Ome = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], Qme = (e) => {
  const {
    classes: t,
    inset: i,
    primary: n,
    secondary: g,
    dense: r
  } = e;
  return Vt({
    root: ["root", i && "inset", r && "dense", n && g && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, zme, t);
}, jme = ye("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${DS.primary}`]: t.primary
    }, {
      [`& .${DS.secondary}`]: t.secondary
    }, t.root, i.inset && t.inset, i.primary && i.secondary && t.multiline, i.dense && t.dense];
  }
})(({
  ownerState: e
}) => k({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), ID = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiListItemText"
  }), {
    children: g,
    className: r,
    disableTypography: o = !1,
    inset: I = !1,
    primary: s,
    primaryTypographyProps: a,
    secondary: d,
    secondaryTypographyProps: C
  } = n, u = Ue(n, Ome), {
    dense: A
  } = Y.useContext(ml);
  let m = s ?? g, h = d;
  const B = k({}, n, {
    disableTypography: o,
    inset: I,
    primary: !!m,
    secondary: !!h,
    dense: A
  }), f = Qme(B);
  return m != null && m.type !== Ne && !o && (m = /* @__PURE__ */ ne(Ne, k({
    variant: A ? "body2" : "body1",
    className: f.primary,
    component: a != null && a.variant ? void 0 : "span",
    display: "block"
  }, a, {
    children: m
  }))), h != null && h.type !== Ne && !o && (h = /* @__PURE__ */ ne(Ne, k({
    variant: "body2",
    className: f.secondary,
    color: "text.secondary",
    display: "block"
  }, C, {
    children: h
  }))), /* @__PURE__ */ Ci(jme, k({
    className: Ve(f.root, r),
    ownerState: B,
    ref: i
  }, u, {
    children: [m, h]
  }));
}), _me = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function ck(e, t, i) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : i ? null : e.firstChild;
}
function ON(e, t, i) {
  return e === t ? i ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : i ? null : e.lastChild;
}
function EO(e, t) {
  if (t === void 0)
    return !0;
  let i = e.innerText;
  return i === void 0 && (i = e.textContent), i = i.trim().toLowerCase(), i.length === 0 ? !1 : t.repeating ? i[0] === t.keys[0] : i.indexOf(t.keys.join("")) === 0;
}
function m0(e, t, i, n, g, r) {
  let o = !1, I = g(e, t, t ? i : !1);
  for (; I; ) {
    if (I === e.firstChild) {
      if (o)
        return !1;
      o = !0;
    }
    const s = n ? !1 : I.disabled || I.getAttribute("aria-disabled") === "true";
    if (!I.hasAttribute("tabindex") || !EO(I, r) || s)
      I = g(e, I, i);
    else
      return I.focus(), !0;
  }
  return !1;
}
const $me = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: g = !1,
    autoFocusItem: r = !1,
    children: o,
    className: I,
    disabledItemsFocusable: s = !1,
    disableListWrap: a = !1,
    onKeyDown: d,
    variant: C = "selectedMenu"
  } = t, u = Ue(t, _me), A = Y.useRef(null), m = Y.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  eo(() => {
    g && A.current.focus();
  }, [g]), Y.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (y, {
      direction: W
    }) => {
      const V = !A.current.style.width;
      if (y.clientHeight < A.current.clientHeight && V) {
        const w = `${L4(Gg(y))}px`;
        A.current.style[W === "rtl" ? "paddingLeft" : "paddingRight"] = w, A.current.style.width = `calc(100% + ${w})`;
      }
      return A.current;
    }
  }), []);
  const h = (y) => {
    const W = A.current, V = y.key, w = Gg(W).activeElement;
    if (V === "ArrowDown")
      y.preventDefault(), m0(W, w, a, s, ck);
    else if (V === "ArrowUp")
      y.preventDefault(), m0(W, w, a, s, ON);
    else if (V === "Home")
      y.preventDefault(), m0(W, null, a, s, ck);
    else if (V === "End")
      y.preventDefault(), m0(W, null, a, s, ON);
    else if (V.length === 1) {
      const v = m.current, H = V.toLowerCase(), x = performance.now();
      v.keys.length > 0 && (x - v.lastTime > 500 ? (v.keys = [], v.repeating = !0, v.previousKeyMatched = !0) : v.repeating && H !== v.keys[0] && (v.repeating = !1)), v.lastTime = x, v.keys.push(H);
      const N = w && !v.repeating && EO(w, v);
      v.previousKeyMatched && (N || m0(W, w, !1, s, ck, v)) ? y.preventDefault() : v.previousKeyMatched = !1;
    }
    d && d(y);
  }, B = gn(A, i);
  let f = -1;
  Y.Children.forEach(o, (y, W) => {
    if (!/* @__PURE__ */ Y.isValidElement(y)) {
      f === W && (f += 1, f >= o.length && (f = -1));
      return;
    }
    y.props.disabled || (C === "selectedMenu" && y.props.selected || f === -1) && (f = W), f === W && (y.props.disabled || y.props.muiSkipListHighlight || y.type.muiSkipListHighlight) && (f += 1, f >= o.length && (f = -1));
  });
  const G = Y.Children.map(o, (y, W) => {
    if (W === f) {
      const V = {};
      return r && (V.autoFocus = !0), y.props.tabIndex === void 0 && C === "selectedMenu" && (V.tabIndex = 0), /* @__PURE__ */ Y.cloneElement(y, V);
    }
    return y;
  });
  return /* @__PURE__ */ ne(PB, k({
    role: "menu",
    ref: B,
    className: I,
    onKeyDown: h,
    tabIndex: g ? 0 : -1
  }, u, {
    children: G
  }));
});
function qme(e) {
  return St("MuiPopover", e);
}
Wt("MuiPopover", ["root", "paper"]);
const ehe = ["onEntering"], the = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], ihe = ["slotProps"];
function QN(e, t) {
  let i = 0;
  return typeof t == "number" ? i = t : t === "center" ? i = e.height / 2 : t === "bottom" && (i = e.height), i;
}
function jN(e, t) {
  let i = 0;
  return typeof t == "number" ? i = t : t === "center" ? i = e.width / 2 : t === "right" && (i = e.width), i;
}
function _N(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function dk(e) {
  return typeof e == "function" ? e() : e;
}
const nhe = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"],
    paper: ["paper"]
  }, qme, t);
}, ghe = ye(FO, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), NO = ye(So, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), lD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r;
  const o = Ft({
    props: t,
    name: "MuiPopover"
  }), {
    action: I,
    anchorEl: s,
    anchorOrigin: a = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: C = "anchorEl",
    children: u,
    className: A,
    container: m,
    elevation: h = 8,
    marginThreshold: B = 16,
    open: f,
    PaperProps: G = {},
    slots: y,
    slotProps: W,
    transformOrigin: V = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: w = xS,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: H
    } = {},
    disableScrollLock: x = !1
  } = o, N = Ue(o.TransitionProps, ehe), M = Ue(o, the), $ = (n = W == null ? void 0 : W.paper) != null ? n : G, q = Y.useRef(), E = gn(q, $.ref), L = k({}, o, {
    anchorOrigin: a,
    anchorReference: C,
    elevation: h,
    marginThreshold: B,
    externalPaperSlotProps: $,
    transformOrigin: V,
    TransitionComponent: w,
    transitionDuration: v,
    TransitionProps: N
  }), P = nhe(L), Q = Y.useCallback(() => {
    if (C === "anchorPosition")
      return d;
    const ot = dk(s), tt = (ot && ot.nodeType === 1 ? ot : Gg(q.current).body).getBoundingClientRect();
    return {
      top: tt.top + QN(tt, a.vertical),
      left: tt.left + jN(tt, a.horizontal)
    };
  }, [s, a.horizontal, a.vertical, d, C]), te = Y.useCallback((ot) => ({
    vertical: QN(ot, V.vertical),
    horizontal: jN(ot, V.horizontal)
  }), [V.horizontal, V.vertical]), le = Y.useCallback((ot) => {
    const ze = {
      width: ot.offsetWidth,
      height: ot.offsetHeight
    }, tt = te(ze);
    if (C === "none")
      return {
        top: null,
        left: null,
        transformOrigin: _N(tt)
      };
    const st = Q();
    let Kt = st.top - tt.vertical, ie = st.left - tt.horizontal;
    const J = Kt + ze.height, Ce = ie + ze.width, xe = pl(dk(s)), Le = xe.innerHeight - B, Ye = xe.innerWidth - B;
    if (B !== null && Kt < B) {
      const qe = Kt - B;
      Kt -= qe, tt.vertical += qe;
    } else if (B !== null && J > Le) {
      const qe = J - Le;
      Kt -= qe, tt.vertical += qe;
    }
    if (B !== null && ie < B) {
      const qe = ie - B;
      ie -= qe, tt.horizontal += qe;
    } else if (Ce > Ye) {
      const qe = Ce - Ye;
      ie -= qe, tt.horizontal += qe;
    }
    return {
      top: `${Math.round(Kt)}px`,
      left: `${Math.round(ie)}px`,
      transformOrigin: _N(tt)
    };
  }, [s, C, Q, te, B]), [Ae, we] = Y.useState(f), Ee = Y.useCallback(() => {
    const ot = q.current;
    if (!ot)
      return;
    const ze = le(ot);
    ze.top !== null && (ot.style.top = ze.top), ze.left !== null && (ot.style.left = ze.left), ot.style.transformOrigin = ze.transformOrigin, we(!0);
  }, [le]);
  Y.useEffect(() => (x && window.addEventListener("scroll", Ee), () => window.removeEventListener("scroll", Ee)), [s, x, Ee]);
  const Je = (ot, ze) => {
    H && H(ot, ze), Ee();
  }, ve = () => {
    we(!1);
  };
  Y.useEffect(() => {
    f && Ee();
  }), Y.useImperativeHandle(I, () => f ? {
    updatePosition: () => {
      Ee();
    }
  } : null, [f, Ee]), Y.useEffect(() => {
    if (!f)
      return;
    const ot = Om(() => {
      Ee();
    }), ze = pl(s);
    return ze.addEventListener("resize", ot), () => {
      ot.clear(), ze.removeEventListener("resize", ot);
    };
  }, [s, f, Ee]);
  let Be = v;
  v === "auto" && !w.muiSupportAuto && (Be = void 0);
  const ue = m || (s ? Gg(dk(s)).body : void 0), Xe = (g = y == null ? void 0 : y.root) != null ? g : ghe, Ze = (r = y == null ? void 0 : y.paper) != null ? r : NO, Ke = kg({
    elementType: Ze,
    externalSlotProps: k({}, $, {
      style: Ae ? $.style : k({}, $.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: h,
      ref: E
    },
    ownerState: L,
    className: Ve(P.paper, $ == null ? void 0 : $.className)
  }), $e = kg({
    elementType: Xe,
    externalSlotProps: (W == null ? void 0 : W.root) || {},
    externalForwardedProps: M,
    additionalProps: {
      ref: i,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: ue,
      open: f
    },
    ownerState: L,
    className: Ve(P.root, A)
  }), {
    slotProps: rt
  } = $e, dt = Ue($e, ihe);
  return /* @__PURE__ */ ne(Xe, k({}, dt, !oa(Xe) && {
    slotProps: rt,
    disableScrollLock: x
  }, {
    children: /* @__PURE__ */ ne(w, k({
      appear: !0,
      in: f,
      onEntering: Je,
      onExited: ve,
      timeout: Be
    }, N, {
      children: /* @__PURE__ */ ne(Ze, k({}, Ke, {
        children: u
      }))
    }))
  }));
});
function rhe(e) {
  return St("MuiMenu", e);
}
Wt("MuiMenu", ["root", "paper", "list"]);
const ohe = ["onEntering"], Ihe = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], lhe = {
  vertical: "top",
  horizontal: "right"
}, she = {
  vertical: "top",
  horizontal: "left"
}, ahe = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, rhe, t);
}, che = ye(lD, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), dhe = ye(NO, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Che = ye($me, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), uhe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g;
  const r = Ft({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: o = !0,
    children: I,
    className: s,
    disableAutoFocusItem: a = !1,
    MenuListProps: d = {},
    onClose: C,
    open: u,
    PaperProps: A = {},
    PopoverClasses: m,
    transitionDuration: h = "auto",
    TransitionProps: {
      onEntering: B
    } = {},
    variant: f = "selectedMenu",
    slots: G = {},
    slotProps: y = {}
  } = r, W = Ue(r.TransitionProps, ohe), V = Ue(r, Ihe), w = Qm(), v = k({}, r, {
    autoFocus: o,
    disableAutoFocusItem: a,
    MenuListProps: d,
    onEntering: B,
    PaperProps: A,
    transitionDuration: h,
    TransitionProps: W,
    variant: f
  }), H = ahe(v), x = o && !a && u, N = Y.useRef(null), M = (te, le) => {
    N.current && N.current.adjustStyleForScrollbar(te, {
      direction: w ? "rtl" : "ltr"
    }), B && B(te, le);
  }, $ = (te) => {
    te.key === "Tab" && (te.preventDefault(), C && C(te, "tabKeyDown"));
  };
  let q = -1;
  Y.Children.map(I, (te, le) => {
    /* @__PURE__ */ Y.isValidElement(te) && (te.props.disabled || (f === "selectedMenu" && te.props.selected || q === -1) && (q = le));
  });
  const E = (n = G.paper) != null ? n : dhe, L = (g = y.paper) != null ? g : A, P = kg({
    elementType: G.root,
    externalSlotProps: y.root,
    ownerState: v,
    className: [H.root, s]
  }), Q = kg({
    elementType: E,
    externalSlotProps: L,
    ownerState: v,
    className: H.paper
  });
  return /* @__PURE__ */ ne(che, k({
    onClose: C,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: w ? "right" : "left"
    },
    transformOrigin: w ? lhe : she,
    slots: {
      paper: E,
      root: G.root
    },
    slotProps: {
      root: P,
      paper: Q
    },
    open: u,
    ref: i,
    transitionDuration: h,
    TransitionProps: k({
      onEntering: M
    }, W),
    ownerState: v
  }, V, {
    classes: m,
    children: /* @__PURE__ */ ne(Che, k({
      onKeyDown: $,
      actions: N,
      autoFocus: o && (q === -1 || a),
      autoFocusItem: x,
      variant: f
    }, d, {
      className: Ve(H.list, d.className),
      children: I
    }))
  }));
});
function Ahe(e) {
  return St("MuiMenuItem", e);
}
const h0 = Wt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), bhe = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], mhe = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.dense && t.dense, i.divider && t.divider, !i.disableGutters && t.gutters];
}, hhe = (e) => {
  const {
    disabled: t,
    dense: i,
    divider: n,
    disableGutters: g,
    selected: r,
    classes: o
  } = e, s = Vt({
    root: ["root", i && "dense", t && "disabled", !g && "gutters", n && "divider", r && "selected"]
  }, Ahe, o);
  return k({}, o, s);
}, phe = ye(fo, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: mhe
})(({
  theme: e,
  ownerState: t
}) => k({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${h0.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${h0.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${h0.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${h0.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${h0.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${xN.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${xN.inset}`]: {
    marginLeft: 52
  },
  [`& .${DS.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${DS.inset}`]: {
    paddingLeft: 36
  },
  [`& .${zN.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && k({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${zN.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), bd = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: g = !1,
    component: r = "li",
    dense: o = !1,
    divider: I = !1,
    disableGutters: s = !1,
    focusVisibleClassName: a,
    role: d = "menuitem",
    tabIndex: C,
    className: u
  } = n, A = Ue(n, bhe), m = Y.useContext(ml), h = Y.useMemo(() => ({
    dense: o || m.dense || !1,
    disableGutters: s
  }), [m.dense, o, s]), B = Y.useRef(null);
  eo(() => {
    g && B.current && B.current.focus();
  }, [g]);
  const f = k({}, n, {
    dense: h.dense,
    divider: I,
    disableGutters: s
  }), G = hhe(n), y = gn(B, i);
  let W;
  return n.disabled || (W = C !== void 0 ? C : -1), /* @__PURE__ */ ne(ml.Provider, {
    value: h,
    children: /* @__PURE__ */ ne(phe, k({
      ref: y,
      role: d,
      tabIndex: W,
      component: r,
      focusVisibleClassName: Ve(G.focusVisible, a),
      className: Ve(G.root, u)
    }, A, {
      ownerState: f,
      classes: G
    }))
  });
});
function Bhe(e) {
  return St("MuiNativeSelect", e);
}
const sD = Wt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), Zhe = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], fhe = (e) => {
  const {
    classes: t,
    variant: i,
    disabled: n,
    multiple: g,
    open: r,
    error: o
  } = e, I = {
    select: ["select", i, n && "disabled", g && "multiple", o && "error"],
    icon: ["icon", `icon${Re(i)}`, r && "iconOpen", n && "disabled"]
  };
  return Vt(I, Bhe, t);
}, LO = ({
  ownerState: e,
  theme: t
}) => k({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": k({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${sD.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), Ghe = ye("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: br,
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.select, t[i.variant], i.error && t.error, {
      [`&.${sD.multiple}`]: t.multiple
    }];
  }
})(LO), TO = ({
  ownerState: e,
  theme: t
}) => k({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${sD.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), yhe = ye("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.icon, i.variant && t[`icon${Re(i.variant)}`], i.open && t.iconOpen];
  }
})(TO), Whe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    className: n,
    disabled: g,
    error: r,
    IconComponent: o,
    inputRef: I,
    variant: s = "standard"
  } = t, a = Ue(t, Zhe), d = k({}, t, {
    disabled: g,
    variant: s,
    error: r
  }), C = fhe(d);
  return /* @__PURE__ */ Ci(Y.Fragment, {
    children: [/* @__PURE__ */ ne(Ghe, k({
      ownerState: d,
      className: Ve(C.select, n),
      disabled: g,
      ref: I || i
    }, a)), t.multiple ? null : /* @__PURE__ */ ne(yhe, {
      as: o,
      ownerState: d,
      className: C.icon
    })]
  });
});
var $N;
const She = ["children", "classes", "className", "label", "notched"], Vhe = ye("fieldset", {
  shouldForwardProp: br
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), whe = ye("legend", {
  shouldForwardProp: br
})(({
  ownerState: e,
  theme: t
}) => k({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && k({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function vhe(e) {
  const {
    className: t,
    label: i,
    notched: n
  } = e, g = Ue(e, She), r = i != null && i !== "", o = k({}, e, {
    notched: n,
    withLabel: r
  });
  return /* @__PURE__ */ ne(Vhe, k({
    "aria-hidden": !0,
    className: t,
    ownerState: o
  }, g, {
    children: /* @__PURE__ */ ne(whe, {
      ownerState: o,
      children: r ? /* @__PURE__ */ ne("span", {
        children: i
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        $N || ($N = /* @__PURE__ */ ne("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
const Rhe = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], Xhe = (e) => {
  const {
    classes: t
  } = e, n = Vt({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, LCe, t);
  return k({}, t, n);
}, Hhe = ye(Qw, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: zw
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return k({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Ps.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Ps.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : i
      }
    },
    [`&.${Ps.focused} .${Ps.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${Ps.error} .${Ps.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${Ps.disabled} .${Ps.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && k({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), khe = ye(vhe, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), Fhe = ye(jw, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Ow
})(({
  theme: e,
  ownerState: t
}) => k({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), aD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o, I;
  const s = Ft({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: a = {},
    fullWidth: d = !1,
    inputComponent: C = "input",
    label: u,
    multiline: A = !1,
    notched: m,
    slots: h = {},
    type: B = "text"
  } = s, f = Ue(s, Rhe), G = Xhe(s), y = pa(), W = zd({
    props: s,
    muiFormControl: y,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), V = k({}, s, {
    color: W.color || "primary",
    disabled: W.disabled,
    error: W.error,
    focused: W.focused,
    formControl: y,
    fullWidth: d,
    hiddenLabel: W.hiddenLabel,
    multiline: A,
    size: W.size,
    type: B
  }), w = (n = (g = h.root) != null ? g : a.Root) != null ? n : Hhe, v = (r = (o = h.input) != null ? o : a.Input) != null ? r : Fhe;
  return /* @__PURE__ */ ne(_w, k({
    slots: {
      root: w,
      input: v
    },
    renderSuffix: (H) => /* @__PURE__ */ ne(khe, {
      ownerState: V,
      className: G.notchedOutline,
      label: u != null && u !== "" && W.required ? I || (I = /* @__PURE__ */ Ci(Y.Fragment, {
        children: [u, " ", "*"]
      })) : u,
      notched: typeof m < "u" ? m : !!(H.startAdornment || H.filled || H.focused)
    }),
    fullWidth: d,
    inputComponent: C,
    multiline: A,
    ref: i,
    type: B
  }, f, {
    classes: k({}, G, {
      notchedOutline: null
    })
  }));
});
aD.muiName = "Input";
const Yhe = ti(/* @__PURE__ */ ne("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), xhe = ti(/* @__PURE__ */ ne("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Dhe = ye("span", {
  shouldForwardProp: br
})({
  position: "relative",
  display: "flex"
}), Jhe = ye(Yhe)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), Khe = ye(xhe)(({
  theme: e,
  ownerState: t
}) => k({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function MO(e) {
  const {
    checked: t = !1,
    classes: i = {},
    fontSize: n
  } = e, g = k({}, e, {
    checked: t
  });
  return /* @__PURE__ */ Ci(Dhe, {
    className: i.root,
    ownerState: g,
    children: [/* @__PURE__ */ ne(Jhe, {
      fontSize: n,
      className: i.background,
      ownerState: g
    }), /* @__PURE__ */ ne(Khe, {
      fontSize: n,
      className: i.dot,
      ownerState: g
    })]
  });
}
const UO = /* @__PURE__ */ Y.createContext(void 0);
function Ehe() {
  return Y.useContext(UO);
}
function Nhe(e) {
  return St("MuiRadio", e);
}
const qN = Wt("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), Lhe = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], The = (e) => {
  const {
    classes: t,
    color: i,
    size: n
  } = e, g = {
    root: ["root", `color${Re(i)}`, n !== "medium" && `size${Re(n)}`]
  };
  return k({}, t, Vt(g, Nhe, t));
}, Mhe = ye(iD, {
  shouldForwardProp: (e) => br(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.size !== "medium" && t[`size${Re(i.size)}`], t[`color${Re(i.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${qN.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${qN.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function Uhe(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const eL = /* @__PURE__ */ ne(MO, {
  checked: !0
}), tL = /* @__PURE__ */ ne(MO, {}), Phe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g;
  const r = Ft({
    props: t,
    name: "MuiRadio"
  }), {
    checked: o,
    checkedIcon: I = eL,
    color: s = "primary",
    icon: a = tL,
    name: d,
    onChange: C,
    size: u = "medium",
    className: A
  } = r, m = Ue(r, Lhe), h = k({}, r, {
    color: s,
    size: u
  }), B = The(h), f = Ehe();
  let G = o;
  const y = wS(C, f && f.onChange);
  let W = d;
  return f && (typeof G > "u" && (G = Uhe(f.value, r.value)), typeof W > "u" && (W = f.name)), /* @__PURE__ */ ne(Mhe, k({
    type: "radio",
    icon: /* @__PURE__ */ Y.cloneElement(a, {
      fontSize: (n = tL.props.fontSize) != null ? n : u
    }),
    checkedIcon: /* @__PURE__ */ Y.cloneElement(I, {
      fontSize: (g = eL.props.fontSize) != null ? g : u
    }),
    ownerState: h,
    classes: B,
    name: W,
    checked: G,
    onChange: y,
    ref: i,
    className: Ve(B.root, A)
  }, m));
});
function zhe(e) {
  return St("MuiRadioGroup", e);
}
Wt("MuiRadioGroup", ["root", "row", "error"]);
const Ohe = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"], Qhe = (e) => {
  const {
    classes: t,
    row: i,
    error: n
  } = e;
  return Vt({
    root: ["root", i && "row", n && "error"]
  }, zhe, t);
}, jhe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    children: g,
    className: r,
    defaultValue: o,
    name: I,
    onChange: s,
    value: a
  } = t, d = Ue(t, Ohe), C = Y.useRef(null), u = Qhe(t), [A, m] = ds({
    controlled: a,
    default: o,
    name: "RadioGroup"
  });
  Y.useImperativeHandle(n, () => ({
    focus: () => {
      let G = C.current.querySelector("input:not(:disabled):checked");
      G || (G = C.current.querySelector("input:not(:disabled)")), G && G.focus();
    }
  }), []);
  const h = gn(i, C), B = Ou(I), f = Y.useMemo(() => ({
    name: B,
    onChange(G) {
      m(G.target.value), s && s(G, G.target.value);
    },
    value: A
  }), [B, s, m, A]);
  return /* @__PURE__ */ ne(UO.Provider, {
    value: f,
    children: /* @__PURE__ */ ne(Wbe, k({
      role: "radiogroup",
      ref: h,
      className: Ve(u.root, r)
    }, d, {
      children: g
    }))
  });
});
function _he(e) {
  return St("MuiScopedCssBaseline", e);
}
Wt("MuiScopedCssBaseline", ["root"]);
const $he = ["className", "component", "enableColorScheme"], qhe = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, _he, t);
}, epe = ye("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  const i = {};
  return t.enableColorScheme && e.colorSchemes && Object.entries(e.colorSchemes).forEach(([n, g]) => {
    var r;
    i[`&${e.getColorSchemeSelector(n).replace(/\s*&/, "")}`] = {
      colorScheme: (r = g.palette) == null ? void 0 : r.mode
    };
  }), k({}, ZAe(e, t.enableColorScheme), fAe(e), {
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    }
  }, i);
}), tpe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiScopedCssBaseline"
  }), {
    className: g,
    component: r = "div"
  } = n, o = Ue(n, $he), I = k({}, n, {
    component: r
  }), s = qhe(I);
  return /* @__PURE__ */ ne(epe, k({
    as: r,
    className: Ve(s.root, g),
    ref: i,
    ownerState: I
  }, o));
});
function ipe(e) {
  return St("MuiSelect", e);
}
const p0 = Wt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var iL;
const npe = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], gpe = ye("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${p0.select}`]: t.select
      },
      {
        [`&.${p0.select}`]: t[i.variant]
      },
      {
        [`&.${p0.error}`]: t.error
      },
      {
        [`&.${p0.multiple}`]: t.multiple
      }
    ];
  }
})(LO, {
  // Win specificity over the input base
  [`&.${p0.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), rpe = ye("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.icon, i.variant && t[`icon${Re(i.variant)}`], i.open && t.iconOpen];
  }
})(TO), ope = ye("input", {
  shouldForwardProp: (e) => Nw(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function nL(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function Ipe(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const lpe = (e) => {
  const {
    classes: t,
    variant: i,
    disabled: n,
    multiple: g,
    open: r,
    error: o
  } = e, I = {
    select: ["select", i, n && "disabled", g && "multiple", o && "error"],
    icon: ["icon", `icon${Re(i)}`, r && "iconOpen", n && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Vt(I, ipe, t);
}, spe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n;
  const {
    "aria-describedby": g,
    "aria-label": r,
    autoFocus: o,
    autoWidth: I,
    children: s,
    className: a,
    defaultOpen: d,
    defaultValue: C,
    disabled: u,
    displayEmpty: A,
    error: m = !1,
    IconComponent: h,
    inputRef: B,
    labelId: f,
    MenuProps: G = {},
    multiple: y,
    name: W,
    onBlur: V,
    onChange: w,
    onClose: v,
    onFocus: H,
    onOpen: x,
    open: N,
    readOnly: M,
    renderValue: $,
    SelectDisplayProps: q = {},
    tabIndex: E,
    value: L,
    variant: P = "standard"
  } = t, Q = Ue(t, npe), [te, le] = ds({
    controlled: L,
    default: C,
    name: "Select"
  }), [Ae, we] = ds({
    controlled: N,
    default: d,
    name: "Select"
  }), Ee = Y.useRef(null), Je = Y.useRef(null), [ve, Be] = Y.useState(null), {
    current: ue
  } = Y.useRef(N != null), [Xe, Ze] = Y.useState(), Ke = gn(i, B), $e = Y.useCallback((Te) => {
    Je.current = Te, Te && Be(Te);
  }, []), rt = ve == null ? void 0 : ve.parentNode;
  Y.useImperativeHandle(Ke, () => ({
    focus: () => {
      Je.current.focus();
    },
    node: Ee.current,
    value: te
  }), [te]), Y.useEffect(() => {
    d && Ae && ve && !ue && (Ze(I ? null : rt.clientWidth), Je.current.focus());
  }, [ve, I]), Y.useEffect(() => {
    o && Je.current.focus();
  }, [o]), Y.useEffect(() => {
    if (!f)
      return;
    const Te = Gg(Je.current).getElementById(f);
    if (Te) {
      const Xt = () => {
        getSelection().isCollapsed && Je.current.focus();
      };
      return Te.addEventListener("click", Xt), () => {
        Te.removeEventListener("click", Xt);
      };
    }
  }, [f]);
  const dt = (Te, Xt) => {
    Te ? x && x(Xt) : v && v(Xt), ue || (Ze(I ? null : rt.clientWidth), we(Te));
  }, ot = (Te) => {
    Te.button === 0 && (Te.preventDefault(), Je.current.focus(), dt(!0, Te));
  }, ze = (Te) => {
    dt(!1, Te);
  }, tt = Y.Children.toArray(s), st = (Te) => {
    const Xt = tt.find((Pe) => Pe.props.value === Te.target.value);
    Xt !== void 0 && (le(Xt.props.value), w && w(Te, Xt));
  }, Kt = (Te) => (Xt) => {
    let Pe;
    if (Xt.currentTarget.hasAttribute("tabindex")) {
      if (y) {
        Pe = Array.isArray(te) ? te.slice() : [];
        const Oe = te.indexOf(Te.props.value);
        Oe === -1 ? Pe.push(Te.props.value) : Pe.splice(Oe, 1);
      } else
        Pe = Te.props.value;
      if (Te.props.onClick && Te.props.onClick(Xt), te !== Pe && (le(Pe), w)) {
        const Oe = Xt.nativeEvent || Xt, kt = new Oe.constructor(Oe.type, Oe);
        Object.defineProperty(kt, "target", {
          writable: !0,
          value: {
            value: Pe,
            name: W
          }
        }), w(kt, Te);
      }
      y || dt(!1, Xt);
    }
  }, ie = (Te) => {
    M || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Te.key) !== -1 && (Te.preventDefault(), dt(!0, Te));
  }, J = ve !== null && Ae, Ce = (Te) => {
    !J && V && (Object.defineProperty(Te, "target", {
      writable: !0,
      value: {
        value: te,
        name: W
      }
    }), V(Te));
  };
  delete Q["aria-invalid"];
  let xe, Le;
  const Ye = [];
  let qe = !1;
  (YS({
    value: te
  }) || A) && ($ ? xe = $(te) : qe = !0);
  const Yt = tt.map((Te) => {
    if (!/* @__PURE__ */ Y.isValidElement(Te))
      return null;
    let Xt;
    if (y) {
      if (!Array.isArray(te))
        throw new Error(sa(2));
      Xt = te.some((Pe) => nL(Pe, Te.props.value)), Xt && qe && Ye.push(Te.props.children);
    } else
      Xt = nL(te, Te.props.value), Xt && qe && (Le = Te.props.children);
    return /* @__PURE__ */ Y.cloneElement(Te, {
      "aria-selected": Xt ? "true" : "false",
      onClick: Kt(Te),
      onKeyUp: (Pe) => {
        Pe.key === " " && Pe.preventDefault(), Te.props.onKeyUp && Te.props.onKeyUp(Pe);
      },
      role: "option",
      selected: Xt,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Te.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  qe && (y ? Ye.length === 0 ? xe = null : xe = Ye.reduce((Te, Xt, Pe) => (Te.push(Xt), Pe < Ye.length - 1 && Te.push(", "), Te), []) : xe = Le);
  let qt = Xe;
  !I && ue && ve && (qt = rt.clientWidth);
  let Ut;
  typeof E < "u" ? Ut = E : Ut = u ? null : 0;
  const Ge = q.id || (W ? `mui-component-select-${W}` : void 0), pe = k({}, t, {
    variant: P,
    value: te,
    open: J,
    error: m
  }), _e = lpe(pe), Gt = k({}, G.PaperProps, (n = G.slotProps) == null ? void 0 : n.paper), Jt = Ou();
  return /* @__PURE__ */ Ci(Y.Fragment, {
    children: [/* @__PURE__ */ ne(gpe, k({
      ref: $e,
      tabIndex: Ut,
      role: "combobox",
      "aria-controls": Jt,
      "aria-disabled": u ? "true" : void 0,
      "aria-expanded": J ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": r,
      "aria-labelledby": [f, Ge].filter(Boolean).join(" ") || void 0,
      "aria-describedby": g,
      onKeyDown: ie,
      onMouseDown: u || M ? null : ot,
      onBlur: Ce,
      onFocus: H
    }, q, {
      ownerState: pe,
      className: Ve(q.className, _e.select, a),
      id: Ge,
      children: Ipe(xe) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        iL || (iL = /* @__PURE__ */ ne("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : xe
    })), /* @__PURE__ */ ne(ope, k({
      "aria-invalid": m,
      value: Array.isArray(te) ? te.join(",") : te,
      name: W,
      ref: Ee,
      "aria-hidden": !0,
      onChange: st,
      tabIndex: -1,
      disabled: u,
      className: _e.nativeInput,
      autoFocus: o,
      ownerState: pe
    }, Q)), /* @__PURE__ */ ne(rpe, {
      as: h,
      className: _e.icon,
      ownerState: pe
    }), /* @__PURE__ */ ne(uhe, k({
      id: `menu-${W || ""}`,
      anchorEl: rt,
      open: J,
      onClose: ze,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, G, {
      MenuListProps: k({
        "aria-labelledby": f,
        role: "listbox",
        "aria-multiselectable": y ? "true" : void 0,
        disableListWrap: !0,
        id: Jt
      }, G.MenuListProps),
      slotProps: k({}, G.slotProps, {
        paper: k({}, Gt, {
          style: k({
            minWidth: qt
          }, Gt != null ? Gt.style : null)
        })
      }),
      children: Yt
    }))]
  });
}), ape = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], cpe = ["root"], dpe = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, cD = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => br(e) && e !== "variant",
  slot: "Root"
}, Cpe = ye(t1, cD)(""), upe = ye(aD, cD)(""), Ape = ye(nD, cD)(""), i1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: g = !1,
    children: r,
    classes: o = {},
    className: I,
    defaultOpen: s = !1,
    displayEmpty: a = !1,
    IconComponent: d = wO,
    id: C,
    input: u,
    inputProps: A,
    label: m,
    labelId: h,
    MenuProps: B,
    multiple: f = !1,
    native: G = !1,
    onClose: y,
    onOpen: W,
    open: V,
    renderValue: w,
    SelectDisplayProps: v,
    variant: H = "outlined"
  } = n, x = Ue(n, ape), N = G ? Whe : spe, M = pa(), $ = zd({
    props: n,
    muiFormControl: M,
    states: ["variant", "error"]
  }), q = $.variant || H, E = k({}, n, {
    variant: q,
    classes: o
  }), L = dpe(E), P = Ue(L, cpe), Q = u || {
    standard: /* @__PURE__ */ ne(Cpe, {
      ownerState: E
    }),
    outlined: /* @__PURE__ */ ne(upe, {
      label: m,
      ownerState: E
    }),
    filled: /* @__PURE__ */ ne(Ape, {
      ownerState: E
    })
  }[q], te = gn(i, Q.ref);
  return /* @__PURE__ */ ne(Y.Fragment, {
    children: /* @__PURE__ */ Y.cloneElement(Q, k({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: N,
      inputProps: k({
        children: r,
        error: $.error,
        IconComponent: d,
        variant: q,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: f
      }, G ? {
        id: C
      } : {
        autoWidth: g,
        defaultOpen: s,
        displayEmpty: a,
        labelId: h,
        MenuProps: B,
        onClose: y,
        onOpen: W,
        open: V,
        renderValue: w,
        SelectDisplayProps: k({
          id: C
        }, v)
      }, A, {
        classes: A ? dr(P, A.classes) : P
      }, u ? u.props.inputProps : {})
    }, (f && G || a) && q === "outlined" ? {
      notched: !0
    } : {}, {
      ref: te,
      className: Ve(Q.props.className, I, L.root)
    }, !u && {
      variant: q
    }, x))
  });
});
i1.muiName = "Select";
function bpe(e) {
  return St("MuiSkeleton", e);
}
Wt("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const mpe = ["animation", "className", "component", "height", "style", "variant", "width"];
let JS = (e) => e, gL, rL, oL, IL;
const hpe = (e) => {
  const {
    classes: t,
    variant: i,
    animation: n,
    hasChildren: g,
    width: r,
    height: o
  } = e;
  return Vt({
    root: ["root", i, n, g && "withChildren", g && !r && "fitContent", g && !o && "heightAuto"]
  }, bpe, t);
}, ppe = Zs(gL || (gL = JS`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), Bpe = Zs(rL || (rL = JS`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), Zpe = ye("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], i.animation !== !1 && t[i.animation], i.hasChildren && t.withChildren, i.hasChildren && !i.width && t.fitContent, i.hasChildren && !i.height && t.heightAuto];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const i = nO(e.shape.borderRadius) || "px", n = Ad(e.shape.borderRadius);
  return k({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : M0(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, t.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${n}${i}/${Math.round(n / 0.6 * 10) / 10}${i}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, t.variant === "circular" && {
    borderRadius: "50%"
  }, t.variant === "rounded" && {
    borderRadius: (e.vars || e).shape.borderRadius
  }, t.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, t.hasChildren && !t.width && {
    maxWidth: "fit-content"
  }, t.hasChildren && !t.height && {
    height: "auto"
  });
}, ({
  ownerState: e
}) => e.animation === "pulse" && Fd(oL || (oL = JS`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), ppe), ({
  ownerState: e,
  theme: t
}) => e.animation === "wave" && Fd(IL || (IL = JS`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), Bpe, (t.vars || t).palette.action.hover)), PO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: g = "pulse",
    className: r,
    component: o = "span",
    height: I,
    style: s,
    variant: a = "text",
    width: d
  } = n, C = Ue(n, mpe), u = k({}, n, {
    animation: g,
    component: o,
    variant: a,
    hasChildren: !!C.children
  }), A = hpe(u);
  return /* @__PURE__ */ ne(Zpe, k({
    as: o,
    ref: i,
    className: Ve(A.root, r),
    ownerState: u
  }, C, {
    style: k({
      width: d,
      height: I
    }, s)
  }));
}), fpe = (e) => !e || !oa(e);
function Gpe(e) {
  return St("MuiSlider", e);
}
const Cl = Wt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), ype = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: Ve(t && Cl.valueLabelOpen),
    circle: Cl.valueLabelCircle,
    label: Cl.valueLabelLabel
  };
};
function Wpe(e) {
  const {
    children: t,
    className: i,
    value: n
  } = e, g = ype(e);
  return t ? /* @__PURE__ */ Y.cloneElement(t, {
    className: Ve(t.props.className)
  }, /* @__PURE__ */ Ci(Y.Fragment, {
    children: [t.props.children, /* @__PURE__ */ ne("span", {
      className: Ve(g.offset, i),
      "aria-hidden": !0,
      children: /* @__PURE__ */ ne("span", {
        className: g.circle,
        children: /* @__PURE__ */ ne("span", {
          className: g.label,
          children: n
        })
      })
    })]
  })) : null;
}
const Spe = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"], Vpe = Qu();
function lL(e) {
  return e;
}
const wpe = ye("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`color${Re(i.color)}`], i.size !== "medium" && t[`size${Re(i.size)}`], i.marked && t.marked, i.orientation === "vertical" && t.vertical, i.track === "inverted" && t.trackInverted, i.track === !1 && t.trackFalse];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    borderRadius: 12,
    boxSizing: "content-box",
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    touchAction: "none",
    WebkitTapHighlightColor: "transparent",
    "@media print": {
      colorAdjust: "exact"
    },
    [`&.${Cl.disabled}`]: {
      pointerEvents: "none",
      cursor: "default",
      color: (e.vars || e).palette.grey[400]
    },
    [`&.${Cl.dragging}`]: {
      [`& .${Cl.thumb}, & .${Cl.track}`]: {
        transition: "none"
      }
    },
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((i) => {
      var n;
      return ((n = e.vars) != null ? n : e).palette[i].main;
    }).map((i) => ({
      props: {
        color: i
      },
      style: {
        color: (e.vars || e).palette[i].main
      }
    })), {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: 4,
        width: "100%",
        padding: "13px 0",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "20px 0"
        }
      }
    }, {
      props: {
        orientation: "horizontal",
        size: "small"
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: "horizontal",
        marked: !0
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        height: "100%",
        width: 4,
        padding: "0 13px",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "0 20px"
        }
      }
    }, {
      props: {
        orientation: "vertical",
        size: "small"
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: "vertical",
        marked: !0
      },
      style: {
        marginRight: 44
      }
    }]
  };
}), vpe = ye("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), Rpe = ye("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => {
  var t;
  return {
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: "small"
      },
      style: {
        border: "none"
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
      }
    }, {
      props: {
        track: !1
      },
      style: {
        display: "none"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((i) => {
      var n;
      return ((n = e.vars) != null ? n : e).palette[i].main;
    }).map((i) => ({
      props: {
        color: i,
        track: "inverted"
      },
      style: k({}, e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${i}Track`],
        borderColor: e.vars.palette.Slider[`${i}Track`]
      } : k({
        backgroundColor: Sm(e.palette[i].main, 0.62),
        borderColor: Sm(e.palette[i].main, 0.62)
      }, e.applyStyles("dark", {
        backgroundColor: Wm(e.palette[i].main, 0.5)
      }), e.applyStyles("dark", {
        borderColor: Wm(e.palette[i].main, 0.5)
      })))
    }))]
  };
}), Xpe = ye("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.thumb, t[`thumbColor${Re(i.color)}`], i.size !== "medium" && t[`thumbSize${Re(i.size)}`]];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    position: "absolute",
    width: 20,
    height: 20,
    boxSizing: "border-box",
    borderRadius: "50%",
    outline: 0,
    backgroundColor: "currentColor",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: e.transitions.create(["box-shadow", "left", "bottom"], {
      duration: e.transitions.duration.shortest
    }),
    "&::before": {
      position: "absolute",
      content: '""',
      borderRadius: "inherit",
      width: "100%",
      height: "100%",
      boxShadow: (e.vars || e).shadows[2]
    },
    "&::after": {
      position: "absolute",
      content: '""',
      borderRadius: "50%",
      // 42px is the hit target
      width: 42,
      height: 42,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    [`&.${Cl.disabled}`]: {
      "&:hover": {
        boxShadow: "none"
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        width: 12,
        height: 12,
        "&::before": {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        top: "50%",
        transform: "translate(-50%, -50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        left: "50%",
        transform: "translate(-50%, 50%)"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((i) => {
      var n;
      return ((n = e.vars) != null ? n : e).palette[i].main;
    }).map((i) => ({
      props: {
        color: i
      },
      style: {
        [`&:hover, &.${Cl.focusVisible}`]: k({}, e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[i].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${di(e.palette[i].main, 0.16)}`
        }, {
          "@media (hover: none)": {
            boxShadow: "none"
          }
        }),
        [`&.${Cl.active}`]: k({}, e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[i].mainChannel} / 0.16)}`
        } : {
          boxShadow: `0px 0px 0px 14px ${di(e.palette[i].main, 0.16)}`
        })
      }
    }))]
  };
}), Hpe = ye(Wpe, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(({
  theme: e
}) => k({
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${Cl.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${Cl.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})), kpe = ye("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => Nw(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: i
    } = e;
    return [t.mark, i && t.markActive];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
})), Fpe = ye("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => Nw(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(({
  theme: e
}) => k({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
})), Ype = (e) => {
  const {
    disabled: t,
    dragging: i,
    marked: n,
    orientation: g,
    track: r,
    classes: o,
    color: I,
    size: s
  } = e, a = {
    root: ["root", t && "disabled", i && "dragging", n && "marked", g === "vertical" && "vertical", r === "inverted" && "trackInverted", r === !1 && "trackFalse", I && `color${Re(I)}`, s && `size${Re(s)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", s && `thumbSize${Re(s)}`, I && `thumbColor${Re(I)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return Vt(a, Gpe, o);
}, xpe = ({
  children: e
}) => e, Dpe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o, I, s, a, d, C, u, A, m, h, B, f, G, y, W, V, w, v, H, x, N;
  const M = Vpe({
    props: t,
    name: "MuiSlider"
  }), $ = Qm(), {
    "aria-label": q,
    "aria-valuetext": E,
    "aria-labelledby": L,
    // eslint-disable-next-line react/prop-types
    component: P = "span",
    components: Q = {},
    componentsProps: te = {},
    color: le = "primary",
    classes: Ae,
    className: we,
    disableSwap: Ee = !1,
    disabled: Je = !1,
    getAriaLabel: ve,
    getAriaValueText: Be,
    marks: ue = !1,
    max: Xe = 100,
    min: Ze = 0,
    orientation: Ke = "horizontal",
    shiftStep: $e = 10,
    size: rt = "medium",
    step: dt = 1,
    scale: ot = lL,
    slotProps: ze,
    slots: tt,
    track: st = "normal",
    valueLabelDisplay: Kt = "off",
    valueLabelFormat: ie = lL
  } = M, J = Ue(M, Spe), Ce = k({}, M, {
    isRtl: $,
    max: Xe,
    min: Ze,
    classes: Ae,
    disabled: Je,
    disableSwap: Ee,
    orientation: Ke,
    marks: ue,
    color: le,
    size: rt,
    step: dt,
    shiftStep: $e,
    scale: ot,
    track: st,
    valueLabelDisplay: Kt,
    valueLabelFormat: ie
  }), {
    axisProps: xe,
    getRootProps: Le,
    getHiddenInputProps: Ye,
    getThumbProps: qe,
    open: Yt,
    active: qt,
    axis: Ut,
    focusedThumbIndex: Ge,
    range: pe,
    dragging: _e,
    marks: Gt,
    values: Jt,
    trackOffset: Te,
    trackLeap: Xt,
    getThumbStyle: Pe
  } = sCe(k({}, Ce, {
    rootRef: i
  }));
  Ce.marked = Gt.length > 0 && Gt.some((He) => He.label), Ce.dragging = _e, Ce.focusedThumbIndex = Ge;
  const Oe = Ype(Ce), kt = (n = (g = tt == null ? void 0 : tt.root) != null ? g : Q.Root) != null ? n : wpe, Nt = (r = (o = tt == null ? void 0 : tt.rail) != null ? o : Q.Rail) != null ? r : vpe, ni = (I = (s = tt == null ? void 0 : tt.track) != null ? s : Q.Track) != null ? I : Rpe, si = (a = (d = tt == null ? void 0 : tt.thumb) != null ? d : Q.Thumb) != null ? a : Xpe, jt = (C = (u = tt == null ? void 0 : tt.valueLabel) != null ? u : Q.ValueLabel) != null ? C : Hpe, Zi = (A = (m = tt == null ? void 0 : tt.mark) != null ? m : Q.Mark) != null ? A : kpe, fi = (h = (B = tt == null ? void 0 : tt.markLabel) != null ? B : Q.MarkLabel) != null ? h : Fpe, on = (f = (G = tt == null ? void 0 : tt.input) != null ? G : Q.Input) != null ? f : "input", In = (y = ze == null ? void 0 : ze.root) != null ? y : te.root, xn = (W = ze == null ? void 0 : ze.rail) != null ? W : te.rail, ln = (V = ze == null ? void 0 : ze.track) != null ? V : te.track, ug = (w = ze == null ? void 0 : ze.thumb) != null ? w : te.thumb, Ti = (v = ze == null ? void 0 : ze.valueLabel) != null ? v : te.valueLabel, vi = (H = ze == null ? void 0 : ze.mark) != null ? H : te.mark, ei = (x = ze == null ? void 0 : ze.markLabel) != null ? x : te.markLabel, yn = (N = ze == null ? void 0 : ze.input) != null ? N : te.input, Mi = kg({
    elementType: kt,
    getSlotProps: Le,
    externalSlotProps: In,
    externalForwardedProps: J,
    additionalProps: k({}, fpe(kt) && {
      as: P
    }),
    ownerState: k({}, Ce, In == null ? void 0 : In.ownerState),
    className: [Oe.root, we]
  }), bn = kg({
    elementType: Nt,
    externalSlotProps: xn,
    ownerState: Ce,
    className: Oe.rail
  }), Ag = kg({
    elementType: ni,
    externalSlotProps: ln,
    additionalProps: {
      style: k({}, xe[Ut].offset(Te), xe[Ut].leap(Xt))
    },
    ownerState: k({}, Ce, ln == null ? void 0 : ln.ownerState),
    className: Oe.track
  }), sn = kg({
    elementType: si,
    getSlotProps: qe,
    externalSlotProps: ug,
    ownerState: k({}, Ce, ug == null ? void 0 : ug.ownerState),
    className: Oe.thumb
  }), bg = kg({
    elementType: jt,
    externalSlotProps: Ti,
    ownerState: k({}, Ce, Ti == null ? void 0 : Ti.ownerState),
    className: Oe.valueLabel
  }), Kn = kg({
    elementType: Zi,
    externalSlotProps: vi,
    ownerState: Ce,
    className: Oe.mark
  }), Mn = kg({
    elementType: fi,
    externalSlotProps: ei,
    ownerState: Ce,
    className: Oe.markLabel
  }), Br = kg({
    elementType: on,
    getSlotProps: Ye,
    externalSlotProps: yn,
    ownerState: Ce
  });
  return /* @__PURE__ */ Ci(kt, k({}, Mi, {
    children: [/* @__PURE__ */ ne(Nt, k({}, bn)), /* @__PURE__ */ ne(ni, k({}, Ag)), Gt.filter((He) => He.value >= Ze && He.value <= Xe).map((He, We) => {
      const yt = FS(He.value, Ze, Xe), at = xe[Ut].offset(yt);
      let Lt;
      return st === !1 ? Lt = Jt.indexOf(He.value) !== -1 : Lt = st === "normal" && (pe ? He.value >= Jt[0] && He.value <= Jt[Jt.length - 1] : He.value <= Jt[0]) || st === "inverted" && (pe ? He.value <= Jt[0] || He.value >= Jt[Jt.length - 1] : He.value >= Jt[0]), /* @__PURE__ */ Ci(Y.Fragment, {
        children: [/* @__PURE__ */ ne(Zi, k({
          "data-index": We
        }, Kn, !oa(Zi) && {
          markActive: Lt
        }, {
          style: k({}, at, Kn.style),
          className: Ve(Kn.className, Lt && Oe.markActive)
        })), He.label != null ? /* @__PURE__ */ ne(fi, k({
          "aria-hidden": !0,
          "data-index": We
        }, Mn, !oa(fi) && {
          markLabelActive: Lt
        }, {
          style: k({}, at, Mn.style),
          className: Ve(Oe.markLabel, Mn.className, Lt && Oe.markLabelActive),
          children: He.label
        })) : null]
      }, We);
    }), Jt.map((He, We) => {
      const yt = FS(He, Ze, Xe), at = xe[Ut].offset(yt), Lt = Kt === "off" ? xpe : jt;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ ne(Lt, k({}, !oa(Lt) && {
          valueLabelFormat: ie,
          valueLabelDisplay: Kt,
          value: typeof ie == "function" ? ie(ot(He), We) : ie,
          index: We,
          open: Yt === We || qt === We || Kt === "on",
          disabled: Je
        }, bg, {
          children: /* @__PURE__ */ ne(si, k({
            "data-index": We
          }, sn, {
            className: Ve(Oe.thumb, sn.className, qt === We && Oe.active, Ge === We && Oe.focusVisible),
            style: k({}, at, Pe(We), sn.style),
            children: /* @__PURE__ */ ne(on, k({
              "data-index": We,
              "aria-label": ve ? ve(We) : q,
              "aria-valuenow": ot(He),
              "aria-labelledby": L,
              "aria-valuetext": Be ? Be(ot(He), We) : E,
              value: Jt[We]
            }, Br))
          }))
        }), We)
      );
    })]
  }));
}), Jpe = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], Kpe = {
  entering: {
    transform: "none"
  },
  entered: {
    transform: "none"
  }
}, zO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = qo(), g = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: r,
    appear: o = !0,
    children: I,
    easing: s,
    in: a,
    onEnter: d,
    onEntered: C,
    onEntering: u,
    onExit: A,
    onExited: m,
    onExiting: h,
    style: B,
    timeout: f = g,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: G = JI
  } = t, y = Ue(t, Jpe), W = Y.useRef(null), V = gn(W, I.ref, i), w = (E) => (L) => {
    if (E) {
      const P = W.current;
      L === void 0 ? E(P) : E(P, L);
    }
  }, v = w(u), H = w((E, L) => {
    Lw(E);
    const P = aa({
      style: B,
      timeout: f,
      easing: s
    }, {
      mode: "enter"
    });
    E.style.webkitTransition = n.transitions.create("transform", P), E.style.transition = n.transitions.create("transform", P), d && d(E, L);
  }), x = w(C), N = w(h), M = w((E) => {
    const L = aa({
      style: B,
      timeout: f,
      easing: s
    }, {
      mode: "exit"
    });
    E.style.webkitTransition = n.transitions.create("transform", L), E.style.transition = n.transitions.create("transform", L), A && A(E);
  }), $ = w(m);
  return /* @__PURE__ */ ne(G, k({
    appear: o,
    in: a,
    nodeRef: W,
    onEnter: H,
    onEntered: x,
    onEntering: v,
    onExit: M,
    onExited: $,
    onExiting: N,
    addEndListener: (E) => {
      r && r(W.current, E);
    },
    timeout: f
  }, y, {
    children: (E, L) => /* @__PURE__ */ Y.cloneElement(I, k({
      style: k({
        transform: "scale(0)",
        visibility: E === "exited" && !a ? "hidden" : void 0
      }, Kpe[E], B, I.props.style),
      ref: V
    }, L))
  }));
});
function Epe(e) {
  return St("MuiTooltip", e);
}
const yd = Wt("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), Npe = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function Lpe(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Tpe = (e) => {
  const {
    classes: t,
    disableInteractive: i,
    arrow: n,
    touch: g,
    placement: r
  } = e, o = {
    popper: ["popper", !i && "popperInteractive", n && "popperArrow"],
    tooltip: ["tooltip", n && "tooltipArrow", g && "touch", `tooltipPlacement${Re(r.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Vt(o, Epe, t);
}, Mpe = ye(Uw, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.popper, !i.disableInteractive && t.popperInteractive, i.arrow && t.popperArrow, !i.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: i
}) => k({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !i && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${yd.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${yd.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${yd.arrow}`]: k({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${yd.arrow}`]: k({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), Upe = ye("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.tooltip, i.touch && t.touch, i.arrow && t.tooltipArrow, t[`tooltipPlacement${Re(i.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : di(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${Lpe(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${yd.popper}[data-popper-placement*="left"] &`]: k({
    transformOrigin: "right center"
  }, t.isRtl ? k({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : k({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${yd.popper}[data-popper-placement*="right"] &`]: k({
    transformOrigin: "left center"
  }, t.isRtl ? k({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : k({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${yd.popper}[data-popper-placement*="top"] &`]: k({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${yd.popper}[data-popper-placement*="bottom"] &`]: k({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), Ppe = ye("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : di(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let tW = !1;
const sL = new WZ();
let B0 = {
  x: 0,
  y: 0
};
function iW(e, t) {
  return (i, ...n) => {
    t && t(i, ...n), e(i, ...n);
  };
}
const Cn = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g, r, o, I, s, a, d, C, u, A, m, h, B, f, G, y, W, V;
  const w = Ft({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: v = !1,
    children: H,
    components: x = {},
    componentsProps: N = {},
    describeChild: M = !1,
    disableFocusListener: $ = !1,
    disableHoverListener: q = !1,
    disableInteractive: E = !1,
    disableTouchListener: L = !1,
    enterDelay: P = 100,
    enterNextDelay: Q = 0,
    enterTouchDelay: te = 700,
    followCursor: le = !1,
    id: Ae,
    leaveDelay: we = 0,
    leaveTouchDelay: Ee = 1500,
    onClose: Je,
    onOpen: ve,
    open: Be,
    placement: ue = "bottom",
    PopperComponent: Xe,
    PopperProps: Ze = {},
    slotProps: Ke = {},
    slots: $e = {},
    title: rt,
    TransitionComponent: dt = xS,
    TransitionProps: ot
  } = w, ze = Ue(w, Npe), tt = /* @__PURE__ */ Y.isValidElement(H) ? H : /* @__PURE__ */ ne("span", {
    children: H
  }), st = qo(), Kt = Qm(), [ie, J] = Y.useState(), [Ce, xe] = Y.useState(null), Le = Y.useRef(!1), Ye = E || le, qe = Zu(), Yt = Zu(), qt = Zu(), Ut = Zu(), [Ge, pe] = ds({
    controlled: Be,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let _e = Ge;
  const Gt = Ou(Ae), Jt = Y.useRef(), Te = zg(() => {
    Jt.current !== void 0 && (document.body.style.WebkitUserSelect = Jt.current, Jt.current = void 0), Ut.clear();
  });
  Y.useEffect(() => Te, [Te]);
  const Xt = (Ht) => {
    sL.clear(), tW = !0, pe(!0), ve && !_e && ve(Ht);
  }, Pe = zg(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ht) => {
      sL.start(800 + we, () => {
        tW = !1;
      }), pe(!1), Je && _e && Je(Ht), qe.start(st.transitions.duration.shortest, () => {
        Le.current = !1;
      });
    }
  ), Oe = (Ht) => {
    Le.current && Ht.type !== "touchstart" || (ie && ie.removeAttribute("title"), Yt.clear(), qt.clear(), P || tW && Q ? Yt.start(tW ? Q : P, () => {
      Xt(Ht);
    }) : Xt(Ht));
  }, kt = (Ht) => {
    Yt.clear(), qt.start(we, () => {
      Pe(Ht);
    });
  }, {
    isFocusVisibleRef: Nt,
    onBlur: ni,
    onFocus: si,
    ref: jt
  } = SZ(), [, Zi] = Y.useState(!1), fi = (Ht) => {
    ni(Ht), Nt.current === !1 && (Zi(!1), kt(Ht));
  }, on = (Ht) => {
    ie || J(Ht.currentTarget), si(Ht), Nt.current === !0 && (Zi(!0), Oe(Ht));
  }, In = (Ht) => {
    Le.current = !0;
    const oi = tt.props;
    oi.onTouchStart && oi.onTouchStart(Ht);
  }, xn = (Ht) => {
    In(Ht), qt.clear(), qe.clear(), Te(), Jt.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Ut.start(te, () => {
      document.body.style.WebkitUserSelect = Jt.current, Oe(Ht);
    });
  }, ln = (Ht) => {
    tt.props.onTouchEnd && tt.props.onTouchEnd(Ht), Te(), qt.start(Ee, () => {
      Pe(Ht);
    });
  };
  Y.useEffect(() => {
    if (!_e)
      return;
    function Ht(oi) {
      (oi.key === "Escape" || oi.key === "Esc") && Pe(oi);
    }
    return document.addEventListener("keydown", Ht), () => {
      document.removeEventListener("keydown", Ht);
    };
  }, [Pe, _e]);
  const ug = gn(tt.ref, jt, J, i);
  !rt && rt !== 0 && (_e = !1);
  const Ti = Y.useRef(), vi = (Ht) => {
    const oi = tt.props;
    oi.onMouseMove && oi.onMouseMove(Ht), B0 = {
      x: Ht.clientX,
      y: Ht.clientY
    }, Ti.current && Ti.current.update();
  }, ei = {}, yn = typeof rt == "string";
  M ? (ei.title = !_e && yn && !q ? rt : null, ei["aria-describedby"] = _e ? Gt : null) : (ei["aria-label"] = yn ? rt : null, ei["aria-labelledby"] = _e && !yn ? Gt : null);
  const Mi = k({}, ei, ze, tt.props, {
    className: Ve(ze.className, tt.props.className),
    onTouchStart: In,
    ref: ug
  }, le ? {
    onMouseMove: vi
  } : {}), bn = {};
  L || (Mi.onTouchStart = xn, Mi.onTouchEnd = ln), q || (Mi.onMouseOver = iW(Oe, Mi.onMouseOver), Mi.onMouseLeave = iW(kt, Mi.onMouseLeave), Ye || (bn.onMouseOver = Oe, bn.onMouseLeave = kt)), $ || (Mi.onFocus = iW(on, Mi.onFocus), Mi.onBlur = iW(fi, Mi.onBlur), Ye || (bn.onFocus = on, bn.onBlur = fi));
  const Ag = Y.useMemo(() => {
    var Ht;
    let oi = [{
      name: "arrow",
      enabled: !!Ce,
      options: {
        element: Ce,
        padding: 4
      }
    }];
    return (Ht = Ze.popperOptions) != null && Ht.modifiers && (oi = oi.concat(Ze.popperOptions.modifiers)), k({}, Ze.popperOptions, {
      modifiers: oi
    });
  }, [Ce, Ze]), sn = k({}, w, {
    isRtl: Kt,
    arrow: v,
    disableInteractive: Ye,
    placement: ue,
    PopperComponentProp: Xe,
    touch: Le.current
  }), bg = Tpe(sn), Kn = (n = (g = $e.popper) != null ? g : x.Popper) != null ? n : Mpe, Mn = (r = (o = (I = $e.transition) != null ? I : x.Transition) != null ? o : dt) != null ? r : xS, Br = (s = (a = $e.tooltip) != null ? a : x.Tooltip) != null ? s : Upe, He = (d = (C = $e.arrow) != null ? C : x.Arrow) != null ? d : Ppe, We = lm(Kn, k({}, Ze, (u = Ke.popper) != null ? u : N.popper, {
    className: Ve(bg.popper, Ze == null ? void 0 : Ze.className, (A = (m = Ke.popper) != null ? m : N.popper) == null ? void 0 : A.className)
  }), sn), yt = lm(Mn, k({}, ot, (h = Ke.transition) != null ? h : N.transition), sn), at = lm(Br, k({}, (B = Ke.tooltip) != null ? B : N.tooltip, {
    className: Ve(bg.tooltip, (f = (G = Ke.tooltip) != null ? G : N.tooltip) == null ? void 0 : f.className)
  }), sn), Lt = lm(He, k({}, (y = Ke.arrow) != null ? y : N.arrow, {
    className: Ve(bg.arrow, (W = (V = Ke.arrow) != null ? V : N.arrow) == null ? void 0 : W.className)
  }), sn);
  return /* @__PURE__ */ Ci(Y.Fragment, {
    children: [/* @__PURE__ */ Y.cloneElement(tt, Mi), /* @__PURE__ */ ne(Kn, k({
      as: Xe ?? Uw,
      placement: ue,
      anchorEl: le ? {
        getBoundingClientRect: () => ({
          top: B0.y,
          left: B0.x,
          right: B0.x,
          bottom: B0.y,
          width: 0,
          height: 0
        })
      } : ie,
      popperRef: Ti,
      open: ie ? _e : !1,
      id: Gt,
      transition: !0
    }, bn, We, {
      popperOptions: Ag,
      children: ({
        TransitionProps: Ht
      }) => /* @__PURE__ */ ne(Mn, k({
        timeout: st.transitions.duration.shorter
      }, Ht, yt, {
        children: /* @__PURE__ */ Ci(Br, k({}, at, {
          children: [rt, v ? /* @__PURE__ */ ne(He, k({}, Lt, {
            ref: xe
          })) : null]
        }))
      }))
    }))]
  });
}), n1 = /* @__PURE__ */ Y.createContext({}), dD = /* @__PURE__ */ Y.createContext({});
function zpe(e) {
  return St("MuiStep", e);
}
Wt("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]);
const Ope = ["active", "children", "className", "component", "completed", "disabled", "expanded", "index", "last"], Qpe = (e) => {
  const {
    classes: t,
    orientation: i,
    alternativeLabel: n,
    completed: g
  } = e;
  return Vt({
    root: ["root", i, n && "alternativeLabel", g && "completed"]
  }, zpe, t);
}, jpe = ye("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.orientation], i.alternativeLabel && t.alternativeLabel, i.completed && t.completed];
  }
})(({
  ownerState: e
}) => k({}, e.orientation === "horizontal" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.alternativeLabel && {
  flex: 1,
  position: "relative"
})), _pe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiStep"
  }), {
    active: g,
    children: r,
    className: o,
    component: I = "div",
    completed: s,
    disabled: a,
    expanded: d = !1,
    index: C,
    last: u
  } = n, A = Ue(n, Ope), {
    activeStep: m,
    connector: h,
    alternativeLabel: B,
    orientation: f,
    nonLinear: G
  } = Y.useContext(n1);
  let [y = !1, W = !1, V = !1] = [g, s, a];
  m === C ? y = g !== void 0 ? g : !0 : !G && m > C ? W = s !== void 0 ? s : !0 : !G && m < C && (V = a !== void 0 ? a : !0);
  const w = Y.useMemo(() => ({
    index: C,
    last: u,
    expanded: d,
    icon: C + 1,
    active: y,
    completed: W,
    disabled: V
  }), [C, u, d, y, W, V]), v = k({}, n, {
    active: y,
    orientation: f,
    alternativeLabel: B,
    completed: W,
    disabled: V,
    expanded: d,
    component: I
  }), H = Qpe(v), x = /* @__PURE__ */ Ci(jpe, k({
    as: I,
    className: Ve(H.root, o),
    ref: i,
    ownerState: v
  }, A, {
    children: [h && B && C !== 0 ? h : null, r]
  }));
  return /* @__PURE__ */ ne(dD.Provider, {
    value: w,
    children: h && !B && C !== 0 ? /* @__PURE__ */ Ci(Y.Fragment, {
      children: [h, x]
    }) : x
  });
}), $pe = ti(/* @__PURE__ */ ne("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), qpe = ti(/* @__PURE__ */ ne("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function e0e(e) {
  return St("MuiStepIcon", e);
}
const Ck = Wt("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var aL;
const t0e = ["active", "className", "completed", "error", "icon"], i0e = (e) => {
  const {
    classes: t,
    active: i,
    completed: n,
    error: g
  } = e;
  return Vt({
    root: ["root", i && "active", n && "completed", g && "error"],
    text: ["text"]
  }, e0e, t);
}, uk = ye(RS, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  color: (e.vars || e).palette.text.disabled,
  [`&.${Ck.completed}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Ck.active}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Ck.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), n0e = ye("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (e, t) => t.text
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.contrastText,
  fontSize: e.typography.caption.fontSize,
  fontFamily: e.typography.fontFamily
})), g0e = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiStepIcon"
  }), {
    active: g = !1,
    className: r,
    completed: o = !1,
    error: I = !1,
    icon: s
  } = n, a = Ue(n, t0e), d = k({}, n, {
    active: g,
    completed: o,
    error: I
  }), C = i0e(d);
  if (typeof s == "number" || typeof s == "string") {
    const u = Ve(r, C.root);
    return I ? /* @__PURE__ */ ne(uk, k({
      as: qpe,
      className: u,
      ref: i,
      ownerState: d
    }, a)) : o ? /* @__PURE__ */ ne(uk, k({
      as: $pe,
      className: u,
      ref: i,
      ownerState: d
    }, a)) : /* @__PURE__ */ Ci(uk, k({
      className: u,
      ref: i,
      ownerState: d
    }, a, {
      children: [aL || (aL = /* @__PURE__ */ ne("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ ne(n0e, {
        className: C.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: d,
        children: s
      })]
    }));
  }
  return s;
});
function r0e(e) {
  return St("MuiStepLabel", e);
}
const Wd = Wt("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), o0e = ["children", "className", "componentsProps", "error", "icon", "optional", "slotProps", "StepIconComponent", "StepIconProps"], I0e = (e) => {
  const {
    classes: t,
    orientation: i,
    active: n,
    completed: g,
    error: r,
    disabled: o,
    alternativeLabel: I
  } = e;
  return Vt({
    root: ["root", i, r && "error", o && "disabled", I && "alternativeLabel"],
    label: ["label", n && "active", g && "completed", r && "error", o && "disabled", I && "alternativeLabel"],
    iconContainer: ["iconContainer", n && "active", g && "completed", r && "error", o && "disabled", I && "alternativeLabel"],
    labelContainer: ["labelContainer", I && "alternativeLabel"]
  }, r0e, t);
}, l0e = ye("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.orientation]];
  }
})(({
  ownerState: e
}) => k({
  display: "flex",
  alignItems: "center",
  [`&.${Wd.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${Wd.disabled}`]: {
    cursor: "default"
  }
}, e.orientation === "vertical" && {
  textAlign: "left",
  padding: "8px 0"
})), s0e = ye("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(({
  theme: e
}) => k({}, e.typography.body2, {
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Wd.active}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${Wd.completed}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${Wd.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${Wd.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), a0e = ye("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})(() => ({
  flexShrink: 0,
  // Fix IE11 issue
  display: "flex",
  paddingRight: 8,
  [`&.${Wd.alternativeLabel}`]: {
    paddingRight: 0
  }
})), c0e = ye("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => ({
  width: "100%",
  color: (e.vars || e).palette.text.secondary,
  [`&.${Wd.alternativeLabel}`]: {
    textAlign: "center"
  }
})), OO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n;
  const g = Ft({
    props: t,
    name: "MuiStepLabel"
  }), {
    children: r,
    className: o,
    componentsProps: I = {},
    error: s = !1,
    icon: a,
    optional: d,
    slotProps: C = {},
    StepIconComponent: u,
    StepIconProps: A
  } = g, m = Ue(g, o0e), {
    alternativeLabel: h,
    orientation: B
  } = Y.useContext(n1), {
    active: f,
    disabled: G,
    completed: y,
    icon: W
  } = Y.useContext(dD), V = a || W;
  let w = u;
  V && !w && (w = g0e);
  const v = k({}, g, {
    active: f,
    alternativeLabel: h,
    completed: y,
    disabled: G,
    error: s,
    orientation: B
  }), H = I0e(v), x = (n = C.label) != null ? n : I.label;
  return /* @__PURE__ */ Ci(l0e, k({
    className: Ve(H.root, o),
    ref: i,
    ownerState: v
  }, m, {
    children: [V || w ? /* @__PURE__ */ ne(a0e, {
      className: H.iconContainer,
      ownerState: v,
      children: /* @__PURE__ */ ne(w, k({
        completed: y,
        active: f,
        error: s,
        icon: V
      }, A))
    }) : null, /* @__PURE__ */ Ci(c0e, {
      className: H.labelContainer,
      ownerState: v,
      children: [r ? /* @__PURE__ */ ne(s0e, k({
        ownerState: v
      }, x, {
        className: Ve(H.label, x == null ? void 0 : x.className),
        children: r
      })) : null, d]
    })]
  }));
});
OO.muiName = "StepLabel";
function d0e(e) {
  return St("MuiStepConnector", e);
}
Wt("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]);
const C0e = ["className"], u0e = (e) => {
  const {
    classes: t,
    orientation: i,
    alternativeLabel: n,
    active: g,
    completed: r,
    disabled: o
  } = e, I = {
    root: ["root", i, n && "alternativeLabel", g && "active", r && "completed", o && "disabled"],
    line: ["line", `line${Re(i)}`]
  };
  return Vt(I, d0e, t);
}, A0e = ye("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.orientation], i.alternativeLabel && t.alternativeLabel, i.completed && t.completed];
  }
})(({
  ownerState: e
}) => k({
  flex: "1 1 auto"
}, e.orientation === "vertical" && {
  marginLeft: 12
  // half icon
}, e.alternativeLabel && {
  position: "absolute",
  top: 12,
  left: "calc(-50% + 20px)",
  right: "calc(50% + 20px)"
})), b0e = ye("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.line, t[`line${Re(i.orientation)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const i = t.palette.mode === "light" ? t.palette.grey[400] : t.palette.grey[600];
  return k({
    display: "block",
    borderColor: t.vars ? t.vars.palette.StepConnector.border : i
  }, e.orientation === "horizontal" && {
    borderTopStyle: "solid",
    borderTopWidth: 1
  }, e.orientation === "vertical" && {
    borderLeftStyle: "solid",
    borderLeftWidth: 1,
    minHeight: 24
  });
}), m0e = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiStepConnector"
  }), {
    className: g
  } = n, r = Ue(n, C0e), {
    alternativeLabel: o,
    orientation: I = "horizontal"
  } = Y.useContext(n1), {
    active: s,
    disabled: a,
    completed: d
  } = Y.useContext(dD), C = k({}, n, {
    alternativeLabel: o,
    orientation: I,
    active: s,
    completed: d,
    disabled: a
  }), u = u0e(C);
  return /* @__PURE__ */ ne(A0e, k({
    className: Ve(u.root, g),
    ref: i,
    ownerState: C
  }, r, {
    children: /* @__PURE__ */ ne(b0e, {
      className: u.line,
      ownerState: C
    })
  }));
});
function h0e(e) {
  return St("MuiStepper", e);
}
Wt("MuiStepper", ["root", "horizontal", "vertical", "alternativeLabel"]);
const p0e = ["activeStep", "alternativeLabel", "children", "className", "component", "connector", "nonLinear", "orientation"], B0e = (e) => {
  const {
    orientation: t,
    alternativeLabel: i,
    classes: n
  } = e;
  return Vt({
    root: ["root", t, i && "alternativeLabel"]
  }, h0e, n);
}, Z0e = ye("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.orientation], i.alternativeLabel && t.alternativeLabel];
  }
})(({
  ownerState: e
}) => k({
  display: "flex"
}, e.orientation === "horizontal" && {
  flexDirection: "row",
  alignItems: "center"
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.alternativeLabel && {
  alignItems: "flex-start"
})), f0e = /* @__PURE__ */ ne(m0e, {}), G0e = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiStepper"
  }), {
    activeStep: g = 0,
    alternativeLabel: r = !1,
    children: o,
    className: I,
    component: s = "div",
    connector: a = f0e,
    nonLinear: d = !1,
    orientation: C = "horizontal"
  } = n, u = Ue(n, p0e), A = k({}, n, {
    alternativeLabel: r,
    orientation: C,
    component: s
  }), m = B0e(A), h = Y.Children.toArray(o).filter(Boolean), B = h.map((G, y) => /* @__PURE__ */ Y.cloneElement(G, k({
    index: y,
    last: y + 1 === h.length
  }, G.props))), f = Y.useMemo(() => ({
    activeStep: g,
    alternativeLabel: r,
    connector: a,
    nonLinear: d,
    orientation: C
  }), [g, r, a, d, C]);
  return /* @__PURE__ */ ne(n1.Provider, {
    value: f,
    children: /* @__PURE__ */ ne(Z0e, k({
      as: s,
      ownerState: A,
      className: Ve(m.root, I),
      ref: i
    }, u, {
      children: B
    }))
  });
});
function y0e(e) {
  return St("MuiSwitch", e);
}
const W0e = Wt("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), Ao = W0e, S0e = ["className", "color", "edge", "size", "sx"], V0e = Qu(), w0e = (e) => {
  const {
    classes: t,
    edge: i,
    size: n,
    color: g,
    checked: r,
    disabled: o
  } = e, I = {
    root: ["root", i && `edge${Re(i)}`, `size${Re(n)}`],
    switchBase: ["switchBase", `color${Re(g)}`, r && "checked", o && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, s = Vt(I, y0e, t);
  return k({}, t, s);
}, v0e = ye("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.edge && t[`edge${Re(i.edge)}`], t[`size${Re(i.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${Ao.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${Ao.switchBase}`]: {
        padding: 4,
        [`&.${Ao.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), R0e = ye(iD, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.switchBase, {
      [`& .${Ao.input}`]: t.input
    }, i.color !== "default" && t[`color${Re(i.color)}`]];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Ao.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Ao.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${Ao.checked} + .${Ao.track}`]: {
    opacity: 0.5
  },
  [`&.${Ao.disabled} + .${Ao.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Ao.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter(([, t]) => t.main && t.light).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Ao.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : di(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Ao.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? Sm(e.palette[t].main, 0.62) : Wm(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${Ao.checked} + .${Ao.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
})), X0e = ye("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
})), H0e = ye("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), k0e = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = V0e({
    props: t,
    name: "MuiSwitch"
  }), {
    className: g,
    color: r = "primary",
    edge: o = !1,
    size: I = "medium",
    sx: s
  } = n, a = Ue(n, S0e), d = k({}, n, {
    color: r,
    edge: o,
    size: I
  }), C = w0e(d), u = /* @__PURE__ */ ne(H0e, {
    className: C.thumb,
    ownerState: d
  });
  return /* @__PURE__ */ Ci(v0e, {
    className: Ve(C.root, g),
    sx: s,
    ownerState: d,
    children: [/* @__PURE__ */ ne(R0e, k({
      type: "checkbox",
      icon: u,
      checkedIcon: u,
      ref: i,
      ownerState: d
    }, a, {
      classes: k({}, C, {
        root: C.switchBase
      })
    })), /* @__PURE__ */ ne(X0e, {
      className: C.track,
      ownerState: d
    })]
  });
}), QO = k0e;
function F0e(e) {
  return St("MuiTab", e);
}
const nu = Wt("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), Y0e = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], x0e = (e) => {
  const {
    classes: t,
    textColor: i,
    fullWidth: n,
    wrapped: g,
    icon: r,
    label: o,
    selected: I,
    disabled: s
  } = e, a = {
    root: ["root", r && o && "labelIcon", `textColor${Re(i)}`, n && "fullWidth", g && "wrapped", I && "selected", s && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return Vt(a, F0e, t);
}, D0e = ye(fo, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.label && i.icon && t.labelIcon, t[`textColor${Re(i.textColor)}`], i.fullWidth && t.fullWidth, i.wrapped && t.wrapped];
  }
})(({
  theme: e,
  ownerState: t
}) => k({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${nu.iconWrapper}`]: k({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${nu.selected}`]: {
    opacity: 1
  },
  [`&.${nu.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${nu.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${nu.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${nu.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${nu.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), mc = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTab"
  }), {
    className: g,
    disabled: r = !1,
    disableFocusRipple: o = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: I,
    icon: s,
    iconPosition: a = "top",
    // eslint-disable-next-line react/prop-types
    indicator: d,
    label: C,
    onChange: u,
    onClick: A,
    onFocus: m,
    // eslint-disable-next-line react/prop-types
    selected: h,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: B,
    // eslint-disable-next-line react/prop-types
    textColor: f = "inherit",
    value: G,
    wrapped: y = !1
  } = n, W = Ue(n, Y0e), V = k({}, n, {
    disabled: r,
    disableFocusRipple: o,
    selected: h,
    icon: !!s,
    iconPosition: a,
    label: !!C,
    fullWidth: I,
    textColor: f,
    wrapped: y
  }), w = x0e(V), v = s && C && /* @__PURE__ */ Y.isValidElement(s) ? /* @__PURE__ */ Y.cloneElement(s, {
    className: Ve(w.iconWrapper, s.props.className)
  }) : s, H = (N) => {
    !h && u && u(N, G), A && A(N);
  }, x = (N) => {
    B && !h && u && u(N, G), m && m(N);
  };
  return /* @__PURE__ */ Ci(D0e, k({
    focusRipple: !o,
    className: Ve(w.root, g),
    ref: i,
    role: "tab",
    "aria-selected": h,
    disabled: r,
    onClick: H,
    onFocus: x,
    ownerState: V,
    tabIndex: h ? 0 : -1
  }, W, {
    children: [a === "top" || a === "start" ? /* @__PURE__ */ Ci(Y.Fragment, {
      children: [v, C]
    }) : /* @__PURE__ */ Ci(Y.Fragment, {
      children: [C, v]
    }), d]
  }));
}), jO = /* @__PURE__ */ Y.createContext();
function J0e(e) {
  return St("MuiTable", e);
}
Wt("MuiTable", ["root", "stickyHeader"]);
const K0e = ["className", "component", "padding", "size", "stickyHeader"], E0e = (e) => {
  const {
    classes: t,
    stickyHeader: i
  } = e;
  return Vt({
    root: ["root", i && "stickyHeader"]
  }, J0e, t);
}, N0e = ye("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": k({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, t.stickyHeader && {
  borderCollapse: "separate"
})), cL = "table", g1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTable"
  }), {
    className: g,
    component: r = cL,
    padding: o = "normal",
    size: I = "medium",
    stickyHeader: s = !1
  } = n, a = Ue(n, K0e), d = k({}, n, {
    component: r,
    padding: o,
    size: I,
    stickyHeader: s
  }), C = E0e(d), u = Y.useMemo(() => ({
    padding: o,
    size: I,
    stickyHeader: s
  }), [o, I, s]);
  return /* @__PURE__ */ ne(jO.Provider, {
    value: u,
    children: /* @__PURE__ */ ne(N0e, k({
      as: r,
      role: r === cL ? null : "table",
      ref: i,
      className: Ve(C.root, g),
      ownerState: d
    }, a))
  });
}), r1 = /* @__PURE__ */ Y.createContext();
function L0e(e) {
  return St("MuiTableBody", e);
}
Wt("MuiTableBody", ["root"]);
const T0e = ["className", "component"], M0e = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, L0e, t);
}, U0e = ye("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), P0e = {
  variant: "body"
}, dL = "tbody", o1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTableBody"
  }), {
    className: g,
    component: r = dL
  } = n, o = Ue(n, T0e), I = k({}, n, {
    component: r
  }), s = M0e(I);
  return /* @__PURE__ */ ne(r1.Provider, {
    value: P0e,
    children: /* @__PURE__ */ ne(U0e, k({
      className: Ve(s.root, g),
      as: r,
      ref: i,
      role: r === dL ? null : "rowgroup",
      ownerState: I
    }, o))
  });
});
function z0e(e) {
  return St("MuiTableCell", e);
}
const _O = Wt("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), O0e = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], Q0e = (e) => {
  const {
    classes: t,
    variant: i,
    align: n,
    padding: g,
    size: r,
    stickyHeader: o
  } = e, I = {
    root: ["root", i, o && "stickyHeader", n !== "inherit" && `align${Re(n)}`, g !== "normal" && `padding${Re(g)}`, `size${Re(r)}`]
  };
  return Vt(I, z0e, t);
}, j0e = ye("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`size${Re(i.size)}`], i.padding !== "normal" && t[`padding${Re(i.padding)}`], i.align !== "inherit" && t[`align${Re(i.align)}`], i.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => k({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? Sm(di(e.palette.divider, 1), 0.88) : Wm(di(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${_O.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), xi = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTableCell"
  }), {
    align: g = "inherit",
    className: r,
    component: o,
    padding: I,
    scope: s,
    size: a,
    sortDirection: d,
    variant: C
  } = n, u = Ue(n, O0e), A = Y.useContext(jO), m = Y.useContext(r1), h = m && m.variant === "head";
  let B;
  o ? B = o : B = h ? "th" : "td";
  let f = s;
  B === "td" ? f = void 0 : !f && h && (f = "col");
  const G = C || m && m.variant, y = k({}, n, {
    align: g,
    component: B,
    padding: I || (A && A.padding ? A.padding : "normal"),
    size: a || (A && A.size ? A.size : "medium"),
    sortDirection: d,
    stickyHeader: G === "head" && A && A.stickyHeader,
    variant: G
  }), W = Q0e(y);
  let V = null;
  return d && (V = d === "asc" ? "ascending" : "descending"), /* @__PURE__ */ ne(j0e, k({
    as: B,
    ref: i,
    className: Ve(W.root, r),
    "aria-sort": V,
    scope: f,
    ownerState: y
  }, u));
});
function _0e(e) {
  return St("MuiTableContainer", e);
}
Wt("MuiTableContainer", ["root"]);
const $0e = ["className", "component"], q0e = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, _0e, t);
}, eBe = ye("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), CD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: g,
    component: r = "div"
  } = n, o = Ue(n, $0e), I = k({}, n, {
    component: r
  }), s = q0e(I);
  return /* @__PURE__ */ ne(eBe, k({
    ref: i,
    as: r,
    className: Ve(s.root, g),
    ownerState: I
  }, o));
});
function tBe(e) {
  return St("MuiTableHead", e);
}
Wt("MuiTableHead", ["root"]);
const iBe = ["className", "component"], nBe = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, tBe, t);
}, gBe = ye("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), rBe = {
  variant: "head"
}, CL = "thead", $O = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTableHead"
  }), {
    className: g,
    component: r = CL
  } = n, o = Ue(n, iBe), I = k({}, n, {
    component: r
  }), s = nBe(I);
  return /* @__PURE__ */ ne(r1.Provider, {
    value: rBe,
    children: /* @__PURE__ */ ne(gBe, k({
      as: r,
      className: Ve(s.root, g),
      ref: i,
      role: r === CL ? null : "rowgroup",
      ownerState: I
    }, o))
  });
});
function oBe(e) {
  return St("MuiToolbar", e);
}
Wt("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const IBe = ["className", "component", "disableGutters", "variant"], lBe = (e) => {
  const {
    classes: t,
    disableGutters: i,
    variant: n
  } = e;
  return Vt({
    root: ["root", !i && "gutters", n]
  }, oBe, t);
}, sBe = ye("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.disableGutters && t.gutters, t[i.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => k({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), qO = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiToolbar"
  }), {
    className: g,
    component: r = "div",
    disableGutters: o = !1,
    variant: I = "regular"
  } = n, s = Ue(n, IBe), a = k({}, n, {
    component: r,
    disableGutters: o,
    variant: I
  }), d = lBe(a);
  return /* @__PURE__ */ ne(sBe, k({
    as: r,
    className: Ve(d.root, g),
    ref: i,
    ownerState: a
  }, s));
}), aBe = ti(/* @__PURE__ */ ne("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), cBe = ti(/* @__PURE__ */ ne("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function dBe(e) {
  return St("MuiTableRow", e);
}
const uL = Wt("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), CBe = ["className", "component", "hover", "selected"], uBe = (e) => {
  const {
    classes: t,
    selected: i,
    hover: n,
    head: g,
    footer: r
  } = e;
  return Vt({
    root: ["root", i && "selected", n && "hover", g && "head", r && "footer"]
  }, dBe, t);
}, ABe = ye("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.head && t.head, i.footer && t.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${uL.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${uL.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : di(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : di(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), AL = "tr", Jd = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTableRow"
  }), {
    className: g,
    component: r = AL,
    hover: o = !1,
    selected: I = !1
  } = n, s = Ue(n, CBe), a = Y.useContext(r1), d = k({}, n, {
    component: r,
    hover: o,
    selected: I,
    head: a && a.variant === "head",
    footer: a && a.variant === "footer"
  }), C = uBe(d);
  return /* @__PURE__ */ ne(ABe, k({
    as: r,
    ref: i,
    className: Ve(C.root, g),
    role: r === AL ? null : "row",
    ownerState: d
  }, s));
});
function bBe(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function mBe(e, t, i, n = {}, g = () => {
}) {
  const {
    ease: r = bBe,
    duration: o = 300
    // standard
  } = n;
  let I = null;
  const s = t[e];
  let a = !1;
  const d = () => {
    a = !0;
  }, C = (u) => {
    if (a) {
      g(new Error("Animation cancelled"));
      return;
    }
    I === null && (I = u);
    const A = Math.min(1, (u - I) / o);
    if (t[e] = r(A) * (i - s) + s, A >= 1) {
      requestAnimationFrame(() => {
        g(null);
      });
      return;
    }
    requestAnimationFrame(C);
  };
  return s === i ? (g(new Error("Element already at target position")), d) : (requestAnimationFrame(C), d);
}
const hBe = ["onChange"], pBe = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function BBe(e) {
  const {
    onChange: t
  } = e, i = Ue(e, hBe), n = Y.useRef(), g = Y.useRef(null), r = () => {
    n.current = g.current.offsetHeight - g.current.clientHeight;
  };
  return eo(() => {
    const o = Om(() => {
      const s = n.current;
      r(), s !== n.current && t(n.current);
    }), I = pl(g.current);
    return I.addEventListener("resize", o), () => {
      o.clear(), I.removeEventListener("resize", o);
    };
  }, [t]), Y.useEffect(() => {
    r(), t(n.current);
  }, [t]), /* @__PURE__ */ ne("div", k({
    style: pBe,
    ref: g
  }, i));
}
function ZBe(e) {
  return St("MuiTabScrollButton", e);
}
const fBe = Wt("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), GBe = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], yBe = (e) => {
  const {
    classes: t,
    orientation: i,
    disabled: n
  } = e;
  return Vt({
    root: ["root", i, n && "disabled"]
  }, ZBe, t);
}, WBe = ye(fo, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.orientation && t[i.orientation]];
  }
})(({
  ownerState: e
}) => k({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${fBe.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), SBe = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  var n, g;
  const r = Ft({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: o,
    slots: I = {},
    slotProps: s = {},
    direction: a
  } = r, d = Ue(r, GBe), C = Qm(), u = k({
    isRtl: C
  }, r), A = yBe(u), m = (n = I.StartScrollButtonIcon) != null ? n : aBe, h = (g = I.EndScrollButtonIcon) != null ? g : cBe, B = kg({
    elementType: m,
    externalSlotProps: s.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: u
  }), f = kg({
    elementType: h,
    externalSlotProps: s.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: u
  });
  return /* @__PURE__ */ ne(WBe, k({
    component: "div",
    className: Ve(A.root, o),
    ref: i,
    role: null,
    ownerState: u,
    tabIndex: null
  }, d, {
    children: a === "left" ? /* @__PURE__ */ ne(m, k({}, B)) : /* @__PURE__ */ ne(h, k({}, f))
  }));
});
function VBe(e) {
  return St("MuiTabs", e);
}
const Ak = Wt("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), wBe = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], bL = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, mL = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, nW = (e, t, i) => {
  let n = !1, g = i(e, t);
  for (; g; ) {
    if (g === e.firstChild) {
      if (n)
        return;
      n = !0;
    }
    const r = g.disabled || g.getAttribute("aria-disabled") === "true";
    if (!g.hasAttribute("tabindex") || r)
      g = i(e, g);
    else {
      g.focus();
      return;
    }
  }
}, vBe = (e) => {
  const {
    vertical: t,
    fixed: i,
    hideScrollbar: n,
    scrollableX: g,
    scrollableY: r,
    centered: o,
    scrollButtonsHideMobile: I,
    classes: s
  } = e;
  return Vt({
    root: ["root", t && "vertical"],
    scroller: ["scroller", i && "fixed", n && "hideScrollbar", g && "scrollableX", r && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", o && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", I && "scrollButtonsHideMobile"],
    scrollableX: [g && "scrollableX"],
    hideScrollbar: [n && "hideScrollbar"]
  }, VBe, s);
}, RBe = ye("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${Ak.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${Ak.scrollButtons}`]: i.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, i.vertical && t.vertical];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${Ak.scrollButtons}`]: {
    [t.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), XBe = ye("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.scroller, i.fixed && t.fixed, i.hideScrollbar && t.hideScrollbar, i.scrollableX && t.scrollableX, i.scrollableY && t.scrollableY];
  }
})(({
  ownerState: e
}) => k({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), HBe = ye("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.flexContainer, i.vertical && t.flexContainerVertical, i.centered && t.centered];
  }
})(({
  ownerState: e
}) => k({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), kBe = ye("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(({
  ownerState: e,
  theme: t
}) => k({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (t.vars || t).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (t.vars || t).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), FBe = ye(BBe)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), hL = {}, I1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTabs"
  }), g = qo(), r = Qm(), {
    "aria-label": o,
    "aria-labelledby": I,
    action: s,
    centered: a = !1,
    children: d,
    className: C,
    component: u = "div",
    allowScrollButtonsMobile: A = !1,
    indicatorColor: m = "primary",
    onChange: h,
    orientation: B = "horizontal",
    ScrollButtonComponent: f = SBe,
    scrollButtons: G = "auto",
    selectionFollowsFocus: y,
    slots: W = {},
    slotProps: V = {},
    TabIndicatorProps: w = {},
    TabScrollButtonProps: v = {},
    textColor: H = "primary",
    value: x,
    variant: N = "standard",
    visibleScrollbar: M = !1
  } = n, $ = Ue(n, wBe), q = N === "scrollable", E = B === "vertical", L = E ? "scrollTop" : "scrollLeft", P = E ? "top" : "left", Q = E ? "bottom" : "right", te = E ? "clientHeight" : "clientWidth", le = E ? "height" : "width", Ae = k({}, n, {
    component: u,
    allowScrollButtonsMobile: A,
    indicatorColor: m,
    orientation: B,
    vertical: E,
    scrollButtons: G,
    textColor: H,
    variant: N,
    visibleScrollbar: M,
    fixed: !q,
    hideScrollbar: q && !M,
    scrollableX: q && !E,
    scrollableY: q && E,
    centered: a && !q,
    scrollButtonsHideMobile: !A
  }), we = vBe(Ae), Ee = kg({
    elementType: W.StartScrollButtonIcon,
    externalSlotProps: V.startScrollButtonIcon,
    ownerState: Ae
  }), Je = kg({
    elementType: W.EndScrollButtonIcon,
    externalSlotProps: V.endScrollButtonIcon,
    ownerState: Ae
  }), [ve, Be] = Y.useState(!1), [ue, Xe] = Y.useState(hL), [Ze, Ke] = Y.useState(!1), [$e, rt] = Y.useState(!1), [dt, ot] = Y.useState(!1), [ze, tt] = Y.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), st = /* @__PURE__ */ new Map(), Kt = Y.useRef(null), ie = Y.useRef(null), J = () => {
    const Pe = Kt.current;
    let Oe;
    if (Pe) {
      const Nt = Pe.getBoundingClientRect();
      Oe = {
        clientWidth: Pe.clientWidth,
        scrollLeft: Pe.scrollLeft,
        scrollTop: Pe.scrollTop,
        scrollLeftNormalized: Wle(Pe, r ? "rtl" : "ltr"),
        scrollWidth: Pe.scrollWidth,
        top: Nt.top,
        bottom: Nt.bottom,
        left: Nt.left,
        right: Nt.right
      };
    }
    let kt;
    if (Pe && x !== !1) {
      const Nt = ie.current.children;
      if (Nt.length > 0) {
        const ni = Nt[st.get(x)];
        kt = ni ? ni.getBoundingClientRect() : null;
      }
    }
    return {
      tabsMeta: Oe,
      tabMeta: kt
    };
  }, Ce = zg(() => {
    const {
      tabsMeta: Pe,
      tabMeta: Oe
    } = J();
    let kt = 0, Nt;
    if (E)
      Nt = "top", Oe && Pe && (kt = Oe.top - Pe.top + Pe.scrollTop);
    else if (Nt = r ? "right" : "left", Oe && Pe) {
      const si = r ? Pe.scrollLeftNormalized + Pe.clientWidth - Pe.scrollWidth : Pe.scrollLeft;
      kt = (r ? -1 : 1) * (Oe[Nt] - Pe[Nt] + si);
    }
    const ni = {
      [Nt]: kt,
      // May be wrong until the font is loaded.
      [le]: Oe ? Oe[le] : 0
    };
    if (isNaN(ue[Nt]) || isNaN(ue[le]))
      Xe(ni);
    else {
      const si = Math.abs(ue[Nt] - ni[Nt]), jt = Math.abs(ue[le] - ni[le]);
      (si >= 1 || jt >= 1) && Xe(ni);
    }
  }), xe = (Pe, {
    animation: Oe = !0
  } = {}) => {
    Oe ? mBe(L, Kt.current, Pe, {
      duration: g.transitions.duration.standard
    }) : Kt.current[L] = Pe;
  }, Le = (Pe) => {
    let Oe = Kt.current[L];
    E ? Oe += Pe : (Oe += Pe * (r ? -1 : 1), Oe *= r && T4() === "reverse" ? -1 : 1), xe(Oe);
  }, Ye = () => {
    const Pe = Kt.current[te];
    let Oe = 0;
    const kt = Array.from(ie.current.children);
    for (let Nt = 0; Nt < kt.length; Nt += 1) {
      const ni = kt[Nt];
      if (Oe + ni[te] > Pe) {
        Nt === 0 && (Oe = Pe);
        break;
      }
      Oe += ni[te];
    }
    return Oe;
  }, qe = () => {
    Le(-1 * Ye());
  }, Yt = () => {
    Le(Ye());
  }, qt = Y.useCallback((Pe) => {
    tt({
      overflow: null,
      scrollbarWidth: Pe
    });
  }, []), Ut = () => {
    const Pe = {};
    Pe.scrollbarSizeListener = q ? /* @__PURE__ */ ne(FBe, {
      onChange: qt,
      className: Ve(we.scrollableX, we.hideScrollbar)
    }) : null;
    const kt = q && (G === "auto" && (Ze || $e) || G === !0);
    return Pe.scrollButtonStart = kt ? /* @__PURE__ */ ne(f, k({
      slots: {
        StartScrollButtonIcon: W.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: Ee
      },
      orientation: B,
      direction: r ? "right" : "left",
      onClick: qe,
      disabled: !Ze
    }, v, {
      className: Ve(we.scrollButtons, v.className)
    })) : null, Pe.scrollButtonEnd = kt ? /* @__PURE__ */ ne(f, k({
      slots: {
        EndScrollButtonIcon: W.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: Je
      },
      orientation: B,
      direction: r ? "left" : "right",
      onClick: Yt,
      disabled: !$e
    }, v, {
      className: Ve(we.scrollButtons, v.className)
    })) : null, Pe;
  }, Ge = zg((Pe) => {
    const {
      tabsMeta: Oe,
      tabMeta: kt
    } = J();
    if (!(!kt || !Oe)) {
      if (kt[P] < Oe[P]) {
        const Nt = Oe[L] + (kt[P] - Oe[P]);
        xe(Nt, {
          animation: Pe
        });
      } else if (kt[Q] > Oe[Q]) {
        const Nt = Oe[L] + (kt[Q] - Oe[Q]);
        xe(Nt, {
          animation: Pe
        });
      }
    }
  }), pe = zg(() => {
    q && G !== !1 && ot(!dt);
  });
  Y.useEffect(() => {
    const Pe = Om(() => {
      Kt.current && Ce();
    });
    let Oe;
    const kt = (si) => {
      si.forEach((jt) => {
        jt.removedNodes.forEach((Zi) => {
          var fi;
          (fi = Oe) == null || fi.unobserve(Zi);
        }), jt.addedNodes.forEach((Zi) => {
          var fi;
          (fi = Oe) == null || fi.observe(Zi);
        });
      }), Pe(), pe();
    }, Nt = pl(Kt.current);
    Nt.addEventListener("resize", Pe);
    let ni;
    return typeof ResizeObserver < "u" && (Oe = new ResizeObserver(Pe), Array.from(ie.current.children).forEach((si) => {
      Oe.observe(si);
    })), typeof MutationObserver < "u" && (ni = new MutationObserver(kt), ni.observe(ie.current, {
      childList: !0
    })), () => {
      var si, jt;
      Pe.clear(), Nt.removeEventListener("resize", Pe), (si = ni) == null || si.disconnect(), (jt = Oe) == null || jt.disconnect();
    };
  }, [Ce, pe]), Y.useEffect(() => {
    const Pe = Array.from(ie.current.children), Oe = Pe.length;
    if (typeof IntersectionObserver < "u" && Oe > 0 && q && G !== !1) {
      const kt = Pe[0], Nt = Pe[Oe - 1], ni = {
        root: Kt.current,
        threshold: 0.99
      }, si = (on) => {
        Ke(!on[0].isIntersecting);
      }, jt = new IntersectionObserver(si, ni);
      jt.observe(kt);
      const Zi = (on) => {
        rt(!on[0].isIntersecting);
      }, fi = new IntersectionObserver(Zi, ni);
      return fi.observe(Nt), () => {
        jt.disconnect(), fi.disconnect();
      };
    }
  }, [q, G, dt, d == null ? void 0 : d.length]), Y.useEffect(() => {
    Be(!0);
  }, []), Y.useEffect(() => {
    Ce();
  }), Y.useEffect(() => {
    Ge(hL !== ue);
  }, [Ge, ue]), Y.useImperativeHandle(s, () => ({
    updateIndicator: Ce,
    updateScrollButtons: pe
  }), [Ce, pe]);
  const _e = /* @__PURE__ */ ne(kBe, k({}, w, {
    className: Ve(we.indicator, w.className),
    ownerState: Ae,
    style: k({}, ue, w.style)
  }));
  let Gt = 0;
  const Jt = Y.Children.map(d, (Pe) => {
    if (!/* @__PURE__ */ Y.isValidElement(Pe))
      return null;
    const Oe = Pe.props.value === void 0 ? Gt : Pe.props.value;
    st.set(Oe, Gt);
    const kt = Oe === x;
    return Gt += 1, /* @__PURE__ */ Y.cloneElement(Pe, k({
      fullWidth: N === "fullWidth",
      indicator: kt && !ve && _e,
      selected: kt,
      selectionFollowsFocus: y,
      onChange: h,
      textColor: H,
      value: Oe
    }, Gt === 1 && x === !1 && !Pe.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), Te = (Pe) => {
    const Oe = ie.current, kt = Gg(Oe).activeElement;
    if (kt.getAttribute("role") !== "tab")
      return;
    let ni = B === "horizontal" ? "ArrowLeft" : "ArrowUp", si = B === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (B === "horizontal" && r && (ni = "ArrowRight", si = "ArrowLeft"), Pe.key) {
      case ni:
        Pe.preventDefault(), nW(Oe, kt, mL);
        break;
      case si:
        Pe.preventDefault(), nW(Oe, kt, bL);
        break;
      case "Home":
        Pe.preventDefault(), nW(Oe, null, bL);
        break;
      case "End":
        Pe.preventDefault(), nW(Oe, null, mL);
        break;
    }
  }, Xt = Ut();
  return /* @__PURE__ */ Ci(RBe, k({
    className: Ve(we.root, C),
    ownerState: Ae,
    ref: i,
    as: u
  }, $, {
    children: [Xt.scrollButtonStart, Xt.scrollbarSizeListener, /* @__PURE__ */ Ci(XBe, {
      className: we.scroller,
      ownerState: Ae,
      style: {
        overflow: ze.overflow,
        [E ? `margin${r ? "Left" : "Right"}` : "marginBottom"]: M ? void 0 : -ze.scrollbarWidth
      },
      ref: Kt,
      children: [/* @__PURE__ */ ne(HBe, {
        "aria-label": o,
        "aria-labelledby": I,
        "aria-orientation": B === "vertical" ? "vertical" : null,
        className: we.flexContainer,
        ownerState: Ae,
        onKeyDown: Te,
        ref: ie,
        role: "tablist",
        children: Jt
      }), ve && _e]
    }), Xt.scrollButtonEnd]
  }));
});
function YBe(e) {
  return St("MuiTextField", e);
}
Wt("MuiTextField", ["root"]);
const xBe = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], DBe = {
  standard: t1,
  filled: nD,
  outlined: aD
}, JBe = (e) => {
  const {
    classes: t
  } = e;
  return Vt({
    root: ["root"]
  }, YBe, t);
}, KBe = ye(fs, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Gu = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: g,
    autoFocus: r = !1,
    children: o,
    className: I,
    color: s = "primary",
    defaultValue: a,
    disabled: d = !1,
    error: C = !1,
    FormHelperTextProps: u,
    fullWidth: A = !1,
    helperText: m,
    id: h,
    InputLabelProps: B,
    inputProps: f,
    InputProps: G,
    inputRef: y,
    label: W,
    maxRows: V,
    minRows: w,
    multiline: v = !1,
    name: H,
    onBlur: x,
    onChange: N,
    onFocus: M,
    placeholder: $,
    required: q = !1,
    rows: E,
    select: L = !1,
    SelectProps: P,
    type: Q,
    value: te,
    variant: le = "outlined"
  } = n, Ae = Ue(n, xBe), we = k({}, n, {
    autoFocus: r,
    color: s,
    disabled: d,
    error: C,
    fullWidth: A,
    multiline: v,
    required: q,
    select: L,
    variant: le
  }), Ee = JBe(we), Je = {};
  le === "outlined" && (B && typeof B.shrink < "u" && (Je.notched = B.shrink), Je.label = W), L && ((!P || !P.native) && (Je.id = void 0), Je["aria-describedby"] = void 0);
  const ve = Ou(h), Be = m && ve ? `${ve}-helper-text` : void 0, ue = W && ve ? `${ve}-label` : void 0, Xe = DBe[le], Ze = /* @__PURE__ */ ne(Xe, k({
    "aria-describedby": Be,
    autoComplete: g,
    autoFocus: r,
    defaultValue: a,
    fullWidth: A,
    multiline: v,
    name: H,
    rows: E,
    maxRows: V,
    minRows: w,
    type: Q,
    value: te,
    id: ve,
    inputRef: y,
    onBlur: x,
    onChange: N,
    onFocus: M,
    placeholder: $,
    inputProps: f
  }, Je, G));
  return /* @__PURE__ */ Ci(KBe, k({
    className: Ve(Ee.root, I),
    disabled: d,
    error: C,
    fullWidth: A,
    ref: i,
    required: q,
    color: s,
    variant: le,
    ownerState: we
  }, Ae, {
    children: [W != null && W !== "" && /* @__PURE__ */ ne(DO, k({
      htmlFor: ve,
      id: ue
    }, B, {
      children: W
    })), L ? /* @__PURE__ */ ne(i1, k({
      "aria-describedby": Be,
      id: ve,
      labelId: ue,
      value: te,
      input: Ze
    }, P, {
      children: o
    })) : Ze, m && /* @__PURE__ */ ne(UB, k({
      id: Be
    }, u, {
      children: m
    }))]
  }));
});
function EBe(e) {
  return St("MuiToggleButton", e);
}
const am = Wt("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge", "fullWidth"]), eQ = /* @__PURE__ */ Y.createContext({}), tQ = /* @__PURE__ */ Y.createContext(void 0);
function NBe(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.indexOf(e) >= 0 : e === t;
}
const LBe = ["value"], TBe = ["children", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "onChange", "onClick", "selected", "size", "value"], MBe = (e) => {
  const {
    classes: t,
    fullWidth: i,
    selected: n,
    disabled: g,
    size: r,
    color: o
  } = e, I = {
    root: ["root", n && "selected", g && "disabled", i && "fullWidth", `size${Re(r)}`, o]
  };
  return Vt(I, EBe, t);
}, UBe = ye(fo, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`size${Re(i.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let i = t.color === "standard" ? e.palette.text.primary : e.palette[t.color].main, n;
  return e.vars && (i = t.color === "standard" ? e.vars.palette.text.primary : e.vars.palette[t.color].main, n = t.color === "standard" ? e.vars.palette.text.primaryChannel : e.vars.palette[t.color].mainChannel), k({}, e.typography.button, {
    borderRadius: (e.vars || e).shape.borderRadius,
    padding: 11,
    border: `1px solid ${(e.vars || e).palette.divider}`,
    color: (e.vars || e).palette.action.active
  }, t.fullWidth && {
    width: "100%"
  }, {
    [`&.${am.disabled}`]: {
      color: (e.vars || e).palette.action.disabled,
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    },
    "&:hover": {
      textDecoration: "none",
      // Reset on mouse devices
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : M0(e.palette.text.primary, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${am.selected}`]: {
      color: i,
      backgroundColor: e.vars ? `rgba(${n} / ${e.vars.palette.action.selectedOpacity})` : M0(i, e.palette.action.selectedOpacity),
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${n} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : M0(i, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.vars ? `rgba(${n} / ${e.vars.palette.action.selectedOpacity})` : M0(i, e.palette.action.selectedOpacity)
        }
      }
    }
  }, t.size === "small" && {
    padding: 7,
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && {
    padding: 15,
    fontSize: e.typography.pxToRem(15)
  });
}), l1 = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Y.useContext(eQ), {
    value: g
  } = n, r = Ue(n, LBe), o = Y.useContext(tQ), I = Dw(k({}, r, {
    selected: NBe(t.value, g)
  }), t), s = Ft({
    props: I,
    name: "MuiToggleButton"
  }), {
    children: a,
    className: d,
    color: C = "standard",
    disabled: u = !1,
    disableFocusRipple: A = !1,
    fullWidth: m = !1,
    onChange: h,
    onClick: B,
    selected: f,
    size: G = "medium",
    value: y
  } = s, W = Ue(s, TBe), V = k({}, s, {
    color: C,
    disabled: u,
    disableFocusRipple: A,
    fullWidth: m,
    size: G
  }), w = MBe(V), v = (x) => {
    B && (B(x, y), x.defaultPrevented) || h && h(x, y);
  }, H = o || "";
  return /* @__PURE__ */ ne(UBe, k({
    className: Ve(r.className, w.root, d, H),
    disabled: u,
    focusRipple: !A,
    ref: i,
    onClick: v,
    onChange: h,
    value: y,
    ownerState: V,
    "aria-pressed": f
  }, W, {
    children: a
  }));
});
function PBe(e) {
  return St("MuiToggleButtonGroup", e);
}
const jn = Wt("MuiToggleButtonGroup", ["root", "selected", "vertical", "disabled", "grouped", "groupedHorizontal", "groupedVertical", "fullWidth", "firstButton", "lastButton", "middleButton"]), zBe = ["children", "className", "color", "disabled", "exclusive", "fullWidth", "onChange", "orientation", "size", "value"], OBe = (e) => {
  const {
    classes: t,
    orientation: i,
    fullWidth: n,
    disabled: g
  } = e, r = {
    root: ["root", i === "vertical" && "vertical", n && "fullWidth"],
    grouped: ["grouped", `grouped${Re(i)}`, g && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Vt(r, PBe, t);
}, QBe = ye("div", {
  name: "MuiToggleButtonGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${jn.grouped}`]: t.grouped
    }, {
      [`& .${jn.grouped}`]: t[`grouped${Re(i.orientation)}`]
    }, {
      [`& .${jn.firstButton}`]: t.firstButton
    }, {
      [`& .${jn.lastButton}`]: t.lastButton
    }, {
      [`& .${jn.middleButton}`]: t.middleButton
    }, t.root, i.orientation === "vertical" && t.vertical, i.fullWidth && t.fullWidth];
  }
})(({
  ownerState: e,
  theme: t
}) => k({
  display: "inline-flex",
  borderRadius: (t.vars || t).shape.borderRadius
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.fullWidth && {
  width: "100%"
}, {
  [`& .${jn.grouped}`]: k({}, e.orientation === "horizontal" ? {
    [`&.${jn.selected} + .${jn.grouped}.${jn.selected}`]: {
      borderLeft: 0,
      marginLeft: 0
    }
  } : {
    [`&.${jn.selected} + .${jn.grouped}.${jn.selected}`]: {
      borderTop: 0,
      marginTop: 0
    }
  })
}, e.orientation === "horizontal" ? {
  [`& .${jn.firstButton},& .${jn.middleButton}`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  [`& .${jn.lastButton},& .${jn.middleButton}`]: {
    marginLeft: -1,
    borderLeft: "1px solid transparent",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
} : {
  [`& .${jn.firstButton},& .${jn.middleButton}`]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  [`& .${jn.lastButton},& .${jn.middleButton}`]: {
    marginTop: -1,
    borderTop: "1px solid transparent",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  }
}, e.orientation === "horizontal" ? {
  [`& .${jn.lastButton}.${am.disabled},& .${jn.middleButton}.${am.disabled}`]: {
    borderLeft: "1px solid transparent"
  }
} : {
  [`& .${jn.lastButton}.${am.disabled},& .${jn.middleButton}.${am.disabled}`]: {
    borderTop: "1px solid transparent"
  }
})), uD = /* @__PURE__ */ Y.forwardRef(function(t, i) {
  const n = Ft({
    props: t,
    name: "MuiToggleButtonGroup"
  }), {
    children: g,
    className: r,
    color: o = "standard",
    disabled: I = !1,
    exclusive: s = !1,
    fullWidth: a = !1,
    onChange: d,
    orientation: C = "horizontal",
    size: u = "medium",
    value: A
  } = n, m = Ue(n, zBe), h = k({}, n, {
    disabled: I,
    fullWidth: a,
    orientation: C,
    size: u
  }), B = OBe(h), f = Y.useCallback((v, H) => {
    if (!d)
      return;
    const x = A && A.indexOf(H);
    let N;
    A && x >= 0 ? (N = A.slice(), N.splice(x, 1)) : N = A ? A.concat(H) : [H], d(v, N);
  }, [d, A]), G = Y.useCallback((v, H) => {
    d && d(v, A === H ? null : H);
  }, [d, A]), y = Y.useMemo(() => ({
    className: B.grouped,
    onChange: s ? G : f,
    value: A,
    size: u,
    fullWidth: a,
    color: o,
    disabled: I
  }), [B.grouped, s, G, f, A, u, a, o, I]), W = M4(g), V = W.length, w = (v) => {
    const H = v === 0, x = v === V - 1;
    return H && x ? "" : H ? B.firstButton : x ? B.lastButton : B.middleButton;
  };
  return /* @__PURE__ */ ne(QBe, k({
    role: "group",
    className: Ve(B.root, r),
    ref: i,
    ownerState: h
  }, m, {
    children: /* @__PURE__ */ ne(eQ.Provider, {
      value: y,
      children: W.map((v, H) => /* @__PURE__ */ ne(tQ.Provider, {
        value: w(H),
        children: v
      }, H))
    })
  }));
});
function Gs(e, t, i) {
  return t = O4(t), t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function ys(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pL(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, O4(n.key), n);
  }
}
function Ws(e, t, i) {
  return t && pL(e.prototype, t), i && pL(e, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var jBe = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, _Be = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, $Be = function(t) {
  return _Be[t];
}, qBe = function(t) {
  return t.replace(jBe, $Be);
};
function BL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function ZL(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BL(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : BL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var pY = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: qBe
}, iQ, eZe = Bs();
function tZe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  pY = ZL(ZL({}, pY), e);
}
function iZe() {
  return pY;
}
var nZe = function() {
  function e() {
    ys(this, e), this.usedNamespaces = {};
  }
  return Ws(e, [{
    key: "addUsedNamespaces",
    value: function(i) {
      var n = this;
      i.forEach(function(g) {
        n.usedNamespaces[g] || (n.usedNamespaces[g] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}();
function gZe(e) {
  iQ = e;
}
function rZe() {
  return iQ;
}
var oZe = {
  type: "3rdParty",
  init: function(t) {
    tZe(t.options.react), gZe(t);
  }
};
function IZe() {
  if (console && console.warn) {
    for (var e, t = arguments.length, i = new Array(t), n = 0; n < t; n++)
      i[n] = arguments[n];
    typeof i[0] == "string" && (i[0] = "react-i18next:: ".concat(i[0])), (e = console).warn.apply(e, i);
  }
}
var fL = {};
function BY() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  typeof t[0] == "string" && fL[t[0]] || (typeof t[0] == "string" && (fL[t[0]] = /* @__PURE__ */ new Date()), IZe.apply(void 0, t));
}
function GL(e, t, i) {
  e.loadNamespaces(t, function() {
    if (e.isInitialized)
      i();
    else {
      var n = function g() {
        setTimeout(function() {
          e.off("initialized", g);
        }, 0), i();
      };
      e.on("initialized", n);
    }
  });
}
function lZe(e, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = t.languages[0], g = t.options ? t.options.fallbackLng : !1, r = t.languages[t.languages.length - 1];
  if (n.toLowerCase() === "cimode")
    return !0;
  var o = function(s, a) {
    var d = t.services.backendConnector.state["".concat(s, "|").concat(a)];
    return d === -1 || d === 2;
  };
  return i.bindI18n && i.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !o(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(n, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || o(n, e) && (!g || o(r, e)));
}
function sZe(e, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return BY("i18n.languages were undefined or empty", t.languages), !0;
  var n = t.options.ignoreJSONStructure !== void 0;
  return n ? t.hasLoadedNamespace(e, {
    precheck: function(r, o) {
      if (i.bindI18n && i.bindI18n.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !o(r.isLanguageChangingTo, e))
        return !1;
    }
  }) : lZe(e, t, i);
}
function nQ(e) {
  if (Array.isArray(e))
    return e;
}
function aZe(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n, g, r, o, I = [], s = !0, a = !1;
    try {
      if (r = (i = i.call(e)).next, t !== 0)
        for (; !(s = (n = r.call(i)).done) && (I.push(n.value), I.length !== t); s = !0)
          ;
    } catch (d) {
      a = !0, g = d;
    } finally {
      try {
        if (!s && i.return != null && (o = i.return(), Object(o) !== o))
          return;
      } finally {
        if (a)
          throw g;
      }
    }
    return I;
  }
}
function yL(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = new Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function gQ(e, t) {
  if (e) {
    if (typeof e == "string")
      return yL(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
      return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
      return yL(e, t);
  }
}
function rQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cZe(e, t) {
  return nQ(e) || aZe(e, t) || gQ(e, t) || rQ();
}
function WL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function bk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WL(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : WL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var dZe = function(t, i) {
  var n = Ct();
  return et(function() {
    n.current = t;
  }, [t, i]), n.current;
};
function ii(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = t.i18n, n = Hn(eZe) || {}, g = n.i18n, r = n.defaultNS, o = i || g || rZe();
  if (o && !o.reportNamespaces && (o.reportNamespaces = new nZe()), !o) {
    BY("You will need to pass in an i18next instance by using initReactI18next");
    var I = function(x) {
      return Array.isArray(x) ? x[x.length - 1] : x;
    }, s = [I, {}, !1];
    return s.t = I, s.i18n = {}, s.ready = !1, s;
  }
  o.options.react && o.options.react.wait !== void 0 && BY("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var a = bk(bk(bk({}, iZe()), o.options.react), t), d = a.useSuspense, C = a.keyPrefix, u = r || o.options && o.options.defaultNS;
  u = typeof u == "string" ? [u] : u || ["translation"], o.reportNamespaces.addUsedNamespaces && o.reportNamespaces.addUsedNamespaces(u);
  var A = (o.isInitialized || o.initializedStoreOnce) && u.every(function(H) {
    return sZe(H, o, a);
  });
  function m() {
    return o.getFixedT(null, a.nsMode === "fallback" ? u : u[0], C);
  }
  var h = At(m), B = cZe(h, 2), f = B[0], G = B[1], y = u.join(), W = dZe(y), V = Ct(!0);
  et(function() {
    var H = a.bindI18n, x = a.bindI18nStore;
    V.current = !0, !A && !d && GL(o, u, function() {
      V.current && G(m);
    }), A && W && W !== y && V.current && G(m);
    function N() {
      V.current && G(m);
    }
    return H && o && o.on(H, N), x && o && o.store.on(x, N), function() {
      V.current = !1, H && o && H.split(" ").forEach(function(M) {
        return o.off(M, N);
      }), x && o && x.split(" ").forEach(function(M) {
        return o.store.off(M, N);
      });
    };
  }, [o, y]);
  var w = Ct(!0);
  et(function() {
    V.current && !w.current && G(m), w.current = !1;
  }, [o, C]);
  var v = [f, o, A];
  if (v.t = f, v.i18n = o, v.ready = A, A || !A && !d)
    return v;
  throw new Promise(function(H) {
    GL(o, u, function() {
      H();
    });
  });
}
const CZe = {
  zIndex: (e) => {
    var t;
    return (((t = e.zIndex) == null ? void 0 : t.modal) ?? 0) + 1;
  },
  color: "#fff",
  display: "flex",
  flexDirection: "column"
};
function oQ({
  loading: e,
  delay: t = 500
}) {
  const [i, n] = At(!1);
  return et(() => {
    if (!e)
      return;
    const g = setTimeout(() => n(!0), t);
    return () => {
      clearTimeout(g), n(!1);
    };
  }, [e, t]), e && i ? /* @__PURE__ */ p($w, { sx: CZe, open: e, "data-cy": "CircularProgress", children: /* @__PURE__ */ p(hm, { color: "inherit", size: 200 }) }) : null;
}
function Hr(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var uZe = typeof Symbol == "function" && Symbol.observable || "@@observable", SL = uZe, mk = () => Math.random().toString(36).substring(7).split("").join("."), AZe = {
  INIT: `@@redux/INIT${/* @__PURE__ */ mk()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ mk()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${mk()}`
}, KS = AZe;
function AD(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function IQ(e, t, i) {
  if (typeof e != "function")
    throw new Error(Hr(2));
  if (typeof t == "function" && typeof i == "function" || typeof i == "function" && typeof arguments[3] == "function")
    throw new Error(Hr(0));
  if (typeof t == "function" && typeof i > "u" && (i = t, t = void 0), typeof i < "u") {
    if (typeof i != "function")
      throw new Error(Hr(1));
    return i(IQ)(e, t);
  }
  let n = e, g = t, r = /* @__PURE__ */ new Map(), o = r, I = 0, s = !1;
  function a() {
    o === r && (o = /* @__PURE__ */ new Map(), r.forEach((B, f) => {
      o.set(f, B);
    }));
  }
  function d() {
    if (s)
      throw new Error(Hr(3));
    return g;
  }
  function C(B) {
    if (typeof B != "function")
      throw new Error(Hr(4));
    if (s)
      throw new Error(Hr(5));
    let f = !0;
    a();
    const G = I++;
    return o.set(G, B), function() {
      if (f) {
        if (s)
          throw new Error(Hr(6));
        f = !1, a(), o.delete(G), r = null;
      }
    };
  }
  function u(B) {
    if (!AD(B))
      throw new Error(Hr(7));
    if (typeof B.type > "u")
      throw new Error(Hr(8));
    if (typeof B.type != "string")
      throw new Error(Hr(17));
    if (s)
      throw new Error(Hr(9));
    try {
      s = !0, g = n(g, B);
    } finally {
      s = !1;
    }
    return (r = o).forEach((G) => {
      G();
    }), B;
  }
  function A(B) {
    if (typeof B != "function")
      throw new Error(Hr(10));
    n = B, u({
      type: KS.REPLACE
    });
  }
  function m() {
    const B = C;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(f) {
        if (typeof f != "object" || f === null)
          throw new Error(Hr(11));
        function G() {
          const W = f;
          W.next && W.next(d());
        }
        return G(), {
          unsubscribe: B(G)
        };
      },
      [SL]() {
        return this;
      }
    };
  }
  return u({
    type: KS.INIT
  }), {
    dispatch: u,
    subscribe: C,
    getState: d,
    replaceReducer: A,
    [SL]: m
  };
}
function bZe(e) {
  Object.keys(e).forEach((t) => {
    const i = e[t];
    if (typeof i(void 0, {
      type: KS.INIT
    }) > "u")
      throw new Error(Hr(12));
    if (typeof i(void 0, {
      type: KS.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(Hr(13));
  });
}
function lQ(e) {
  const t = Object.keys(e), i = {};
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    typeof e[o] == "function" && (i[o] = e[o]);
  }
  const n = Object.keys(i);
  let g;
  try {
    bZe(i);
  } catch (r) {
    g = r;
  }
  return function(o = {}, I) {
    if (g)
      throw g;
    let s = !1;
    const a = {};
    for (let d = 0; d < n.length; d++) {
      const C = n[d], u = i[C], A = o[C], m = u(A, I);
      if (typeof m > "u")
        throw I && I.type, new Error(Hr(14));
      a[C] = m, s = s || m !== A;
    }
    return s = s || n.length !== Object.keys(o).length, s ? a : o;
  };
}
function ES(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, i) => (...n) => t(i(...n)));
}
function mZe(...e) {
  return (t) => (i, n) => {
    const g = t(i, n);
    let r = () => {
      throw new Error(Hr(15));
    };
    const o = {
      getState: g.getState,
      dispatch: (s, ...a) => r(s, ...a)
    }, I = e.map((s) => s(o));
    return r = ES(...I)(g.dispatch), {
      ...g,
      dispatch: r
    };
  };
}
function hZe(e) {
  return AD(e) && "type" in e && typeof e.type == "string";
}
var sQ = Symbol.for("immer-nothing"), VL = Symbol.for("immer-draftable"), FI = Symbol.for("immer-state");
function Is(e, ...t) {
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Xm = Object.getPrototypeOf;
function Kd(e) {
  return !!e && !!e[FI];
}
function hc(e) {
  var t;
  return e ? aQ(e) || Array.isArray(e) || !!e[VL] || !!((t = e.constructor) != null && t[VL]) || a1(e) || c1(e) : !1;
}
var pZe = Object.prototype.constructor.toString();
function aQ(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Xm(e);
  if (t === null)
    return !0;
  const i = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return i === Object ? !0 : typeof i == "function" && Function.toString.call(i) === pZe;
}
function NS(e, t) {
  s1(e) === 0 ? Reflect.ownKeys(e).forEach((i) => {
    t(i, e[i], e);
  }) : e.forEach((i, n) => t(n, i, e));
}
function s1(e) {
  const t = e[FI];
  return t ? t.type_ : Array.isArray(e) ? 1 : a1(e) ? 2 : c1(e) ? 3 : 0;
}
function ZY(e, t) {
  return s1(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function cQ(e, t, i) {
  const n = s1(e);
  n === 2 ? e.set(t, i) : n === 3 ? e.add(i) : e[t] = i;
}
function BZe(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function a1(e) {
  return e instanceof Map;
}
function c1(e) {
  return e instanceof Set;
}
function au(e) {
  return e.copy_ || e.base_;
}
function fY(e, t) {
  if (a1(e))
    return new Map(e);
  if (c1(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const i = aQ(e);
  if (t === !0 || t === "class_only" && !i) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[FI];
    let g = Reflect.ownKeys(n);
    for (let r = 0; r < g.length; r++) {
      const o = g[r], I = n[o];
      I.writable === !1 && (I.writable = !0, I.configurable = !0), (I.get || I.set) && (n[o] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: I.enumerable,
        value: e[o]
      });
    }
    return Object.create(Xm(e), n);
  } else {
    const n = Xm(e);
    if (n !== null && i)
      return { ...e };
    const g = Object.create(n);
    return Object.assign(g, e);
  }
}
function bD(e, t = !1) {
  return d1(e) || Kd(e) || !hc(e) || (s1(e) > 1 && (e.set = e.add = e.clear = e.delete = ZZe), Object.freeze(e), t && Object.entries(e).forEach(([i, n]) => bD(n, !0))), e;
}
function ZZe() {
  Is(2);
}
function d1(e) {
  return Object.isFrozen(e);
}
var fZe = {};
function xu(e) {
  const t = fZe[e];
  return t || Is(0, e), t;
}
var zB;
function dQ() {
  return zB;
}
function GZe(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function wL(e, t) {
  t && (xu("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function GY(e) {
  yY(e), e.drafts_.forEach(yZe), e.drafts_ = null;
}
function yY(e) {
  e === zB && (zB = e.parent_);
}
function vL(e) {
  return zB = GZe(zB, e);
}
function yZe(e) {
  const t = e[FI];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function RL(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const i = t.drafts_[0];
  return e !== void 0 && e !== i ? (i[FI].modified_ && (GY(t), Is(4)), hc(e) && (e = LS(t, e), t.parent_ || TS(t, e)), t.patches_ && xu("Patches").generateReplacementPatches_(
    i[FI].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = LS(t, i, []), GY(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== sQ ? e : void 0;
}
function LS(e, t, i) {
  if (d1(t))
    return t;
  const n = t[FI];
  if (!n)
    return NS(
      t,
      (g, r) => XL(e, n, t, g, r, i)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return TS(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const g = n.copy_;
    let r = g, o = !1;
    n.type_ === 3 && (r = new Set(g), g.clear(), o = !0), NS(
      r,
      (I, s) => XL(e, n, g, I, s, i, o)
    ), TS(e, g, !1), i && e.patches_ && xu("Patches").generatePatches_(
      n,
      i,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function XL(e, t, i, n, g, r, o) {
  if (Kd(g)) {
    const I = r && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ZY(t.assigned_, n) ? r.concat(n) : void 0, s = LS(e, g, I);
    if (cQ(i, n, s), Kd(s))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    o && i.add(g);
  if (hc(g) && !d1(g)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    LS(e, g), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(i, n) && TS(e, g);
  }
}
function TS(e, t, i = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && bD(t, i);
}
function WZe(e, t) {
  const i = Array.isArray(e), n = {
    type_: i ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : dQ(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let g = n, r = mD;
  i && (g = [n], r = OB);
  const { revoke: o, proxy: I } = Proxy.revocable(g, r);
  return n.draft_ = I, n.revoke_ = o, I;
}
var mD = {
  get(e, t) {
    if (t === FI)
      return e;
    const i = au(e);
    if (!ZY(i, t))
      return SZe(e, i, t);
    const n = i[t];
    return e.finalized_ || !hc(n) ? n : n === hk(e.base_, t) ? (pk(e), e.copy_[t] = SY(n, e)) : n;
  },
  has(e, t) {
    return t in au(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(au(e));
  },
  set(e, t, i) {
    const n = CQ(au(e), t);
    if (n != null && n.set)
      return n.set.call(e.draft_, i), !0;
    if (!e.modified_) {
      const g = hk(au(e), t), r = g == null ? void 0 : g[FI];
      if (r && r.base_ === i)
        return e.copy_[t] = i, e.assigned_[t] = !1, !0;
      if (BZe(i, g) && (i !== void 0 || ZY(e.base_, t)))
        return !0;
      pk(e), WY(e);
    }
    return e.copy_[t] === i && // special case: handle new props with value 'undefined'
    (i !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(i) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = i, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return hk(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, pk(e), WY(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const i = au(e), n = Reflect.getOwnPropertyDescriptor(i, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: i[t]
    };
  },
  defineProperty() {
    Is(11);
  },
  getPrototypeOf(e) {
    return Xm(e.base_);
  },
  setPrototypeOf() {
    Is(12);
  }
}, OB = {};
NS(mD, (e, t) => {
  OB[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
OB.deleteProperty = function(e, t) {
  return OB.set.call(this, e, t, void 0);
};
OB.set = function(e, t, i) {
  return mD.set.call(this, e[0], t, i, e[0]);
};
function hk(e, t) {
  const i = e[FI];
  return (i ? au(i) : e)[t];
}
function SZe(e, t, i) {
  var g;
  const n = CQ(t, i);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (g = n.get) == null ? void 0 : g.call(e.draft_)
  ) : void 0;
}
function CQ(e, t) {
  if (!(t in e))
    return;
  let i = Xm(e);
  for (; i; ) {
    const n = Object.getOwnPropertyDescriptor(i, t);
    if (n)
      return n;
    i = Xm(i);
  }
}
function WY(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && WY(e.parent_));
}
function pk(e) {
  e.copy_ || (e.copy_ = fY(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var VZe = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, i, n) => {
      if (typeof t == "function" && typeof i != "function") {
        const r = i;
        i = t;
        const o = this;
        return function(s = r, ...a) {
          return o.produce(s, (d) => i.call(this, d, ...a));
        };
      }
      typeof i != "function" && Is(6), n !== void 0 && typeof n != "function" && Is(7);
      let g;
      if (hc(t)) {
        const r = vL(this), o = SY(t, void 0);
        let I = !0;
        try {
          g = i(o), I = !1;
        } finally {
          I ? GY(r) : yY(r);
        }
        return wL(r, n), RL(g, r);
      } else if (!t || typeof t != "object") {
        if (g = i(t), g === void 0 && (g = t), g === sQ && (g = void 0), this.autoFreeze_ && bD(g, !0), n) {
          const r = [], o = [];
          xu("Patches").generateReplacementPatches_(t, g, r, o), n(r, o);
        }
        return g;
      } else
        Is(1, t);
    }, this.produceWithPatches = (t, i) => {
      if (typeof t == "function")
        return (o, ...I) => this.produceWithPatches(o, (s) => t(s, ...I));
      let n, g;
      return [this.produce(t, i, (o, I) => {
        n = o, g = I;
      }), n, g];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    hc(e) || Is(8), Kd(e) && (e = uQ(e));
    const t = vL(this), i = SY(e, void 0);
    return i[FI].isManual_ = !0, yY(t), i;
  }
  finishDraft(e, t) {
    const i = e && e[FI];
    (!i || !i.isManual_) && Is(9);
    const { scope_: n } = i;
    return wL(n, t), RL(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let i;
    for (i = t.length - 1; i >= 0; i--) {
      const g = t[i];
      if (g.path.length === 0 && g.op === "replace") {
        e = g.value;
        break;
      }
    }
    i > -1 && (t = t.slice(i + 1));
    const n = xu("Patches").applyPatches_;
    return Kd(e) ? n(e, t) : this.produce(
      e,
      (g) => n(g, t)
    );
  }
};
function SY(e, t) {
  const i = a1(e) ? xu("MapSet").proxyMap_(e, t) : c1(e) ? xu("MapSet").proxySet_(e, t) : WZe(e, t);
  return (t ? t.scope_ : dQ()).drafts_.push(i), i;
}
function uQ(e) {
  return Kd(e) || Is(10, e), AQ(e);
}
function AQ(e) {
  if (!hc(e) || d1(e))
    return e;
  const t = e[FI];
  let i;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, i = fY(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    i = fY(e, !0);
  return NS(i, (n, g) => {
    cQ(i, n, AQ(g));
  }), t && (t.finalized_ = !1), i;
}
var YI = new VZe(), hD = YI.produce;
YI.produceWithPatches.bind(
  YI
);
var HL = YI.setAutoFreeze.bind(YI);
YI.setUseStrictShallowCopy.bind(YI);
YI.applyPatches.bind(YI);
YI.createDraft.bind(YI);
YI.finishDraft.bind(YI);
function wZe(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function vZe(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function RZe(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((i) => typeof i == "function")) {
    const i = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${i}]`);
  }
}
var kL = (e) => Array.isArray(e) ? e : [e];
function XZe(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return RZe(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function HZe(e, t) {
  const i = [], { length: n } = e;
  for (let g = 0; g < n; g++)
    i.push(e[g].apply(null, t));
  return i;
}
var kZe = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, FZe = typeof WeakRef < "u" ? WeakRef : kZe, YZe = 0, FL = 1;
function gW() {
  return {
    s: YZe,
    v: void 0,
    o: null,
    p: null
  };
}
function pD(e, t = {}) {
  let i = gW();
  const { resultEqualityCheck: n } = t;
  let g, r = 0;
  function o() {
    var C;
    let I = i;
    const { length: s } = arguments;
    for (let u = 0, A = s; u < A; u++) {
      const m = arguments[u];
      if (typeof m == "function" || typeof m == "object" && m !== null) {
        let h = I.o;
        h === null && (I.o = h = /* @__PURE__ */ new WeakMap());
        const B = h.get(m);
        B === void 0 ? (I = gW(), h.set(m, I)) : I = B;
      } else {
        let h = I.p;
        h === null && (I.p = h = /* @__PURE__ */ new Map());
        const B = h.get(m);
        B === void 0 ? (I = gW(), h.set(m, I)) : I = B;
      }
    }
    const a = I;
    let d;
    if (I.s === FL ? d = I.v : (d = e.apply(null, arguments), r++), a.s = FL, n) {
      const u = ((C = g == null ? void 0 : g.deref) == null ? void 0 : C.call(g)) ?? g;
      u != null && n(u, d) && (d = u, r !== 0 && r--), g = typeof d == "object" && d !== null || typeof d == "function" ? new FZe(d) : d;
    }
    return a.v = d, d;
  }
  return o.clearCache = () => {
    i = gW(), o.resetResultsCount();
  }, o.resultsCount = () => r, o.resetResultsCount = () => {
    r = 0;
  }, o;
}
function bQ(e, ...t) {
  const i = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...g) => {
    let r = 0, o = 0, I, s = {}, a = g.pop();
    typeof a == "object" && (s = a, a = g.pop()), wZe(
      a,
      `createSelector expects an output function after the inputs, but received: [${typeof a}]`
    );
    const d = {
      ...i,
      ...s
    }, {
      memoize: C,
      memoizeOptions: u = [],
      argsMemoize: A = pD,
      argsMemoizeOptions: m = [],
      devModeChecks: h = {}
    } = d, B = kL(u), f = kL(m), G = XZe(g), y = C(function() {
      return r++, a.apply(
        null,
        arguments
      );
    }, ...B), W = A(function() {
      o++;
      const w = HZe(
        G,
        arguments
      );
      return I = y.apply(null, w), I;
    }, ...f);
    return Object.assign(W, {
      resultFunc: a,
      memoizedResultFunc: y,
      dependencies: G,
      dependencyRecomputations: () => o,
      resetDependencyRecomputations: () => {
        o = 0;
      },
      lastResult: () => I,
      recomputations: () => r,
      resetRecomputations: () => {
        r = 0;
      },
      memoize: C,
      argsMemoize: A
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Pt = /* @__PURE__ */ bQ(pD), xZe = Object.assign(
  (e, t = Pt) => {
    vZe(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const i = Object.keys(e), n = i.map(
      (r) => e[r]
    );
    return t(
      n,
      (...r) => r.reduce((o, I, s) => (o[i[s]] = I, o), {})
    );
  },
  { withTypes: () => xZe }
);
function mQ(e) {
  return ({ dispatch: i, getState: n }) => (g) => (r) => typeof r == "function" ? r(i, n, e) : g(r);
}
var DZe = mQ(), JZe = mQ, KZe = (...e) => {
  const t = bQ(...e), i = Object.assign((...n) => {
    const g = t(...n), r = (o, ...I) => g(Kd(o) ? uQ(o) : o, ...I);
    return Object.assign(r, g), r;
  }, {
    withTypes: () => i
  });
  return i;
};
KZe(pD);
var EZe = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? ES : ES.apply(null, arguments);
};
function Hm(e, t) {
  function i(...n) {
    if (t) {
      let g = t(...n);
      if (!g)
        throw new Error(zo(0));
      return {
        type: e,
        payload: g.payload,
        ..."meta" in g && {
          meta: g.meta
        },
        ..."error" in g && {
          error: g.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return i.toString = () => `${e}`, i.type = e, i.match = (n) => hZe(n) && n.type === e, i;
}
var hQ = class z0 extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, z0.prototype);
  }
  static get [Symbol.species]() {
    return z0;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new z0(...t[0].concat(this)) : new z0(...t.concat(this));
  }
};
function YL(e) {
  return hc(e) ? hD(e, () => {
  }) : e;
}
function xL(e, t, i) {
  if (e.has(t)) {
    let g = e.get(t);
    return i.update && (g = i.update(g, t, e), e.set(t, g)), g;
  }
  if (!i.insert)
    throw new Error(zo(10));
  const n = i.insert(t, e);
  return e.set(t, n), n;
}
function NZe(e) {
  return typeof e == "boolean";
}
var LZe = () => function(t) {
  const {
    thunk: i = !0,
    immutableCheck: n = !0,
    serializableCheck: g = !0,
    actionCreatorCheck: r = !0
  } = t ?? {};
  let o = new hQ();
  return i && (NZe(i) ? o.push(DZe) : o.push(JZe(i.extraArgument))), o;
}, TZe = "RTK_autoBatch", pQ = (e) => (t) => {
  setTimeout(t, e);
}, MZe = typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : pQ(10), UZe = (e = {
  type: "raf"
}) => (t) => (...i) => {
  const n = t(...i);
  let g = !0, r = !1, o = !1;
  const I = /* @__PURE__ */ new Set(), s = e.type === "tick" ? queueMicrotask : e.type === "raf" ? MZe : e.type === "callback" ? e.queueNotification : pQ(e.timeout), a = () => {
    o = !1, r && (r = !1, I.forEach((d) => d()));
  };
  return Object.assign({}, n, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(d) {
      const C = () => g && d(), u = n.subscribe(C);
      return I.add(d), () => {
        u(), I.delete(d);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(d) {
      var C;
      try {
        return g = !((C = d == null ? void 0 : d.meta) != null && C[TZe]), r = !g, r && (o || (o = !0, s(a))), n.dispatch(d);
      } finally {
        g = !0;
      }
    }
  });
}, PZe = (e) => function(i) {
  const {
    autoBatch: n = !0
  } = i ?? {};
  let g = new hQ(e);
  return n && g.push(UZe(typeof n == "object" ? n : void 0)), g;
}, zZe = !0;
function OZe(e) {
  const t = LZe(), {
    reducer: i = void 0,
    middleware: n,
    devTools: g = !0,
    preloadedState: r = void 0,
    enhancers: o = void 0
  } = e || {};
  let I;
  if (typeof i == "function")
    I = i;
  else if (AD(i))
    I = lQ(i);
  else
    throw new Error(zo(1));
  let s;
  typeof n == "function" ? s = n(t) : s = t();
  let a = ES;
  g && (a = EZe({
    // Enable capture of stack traces for dispatched Redux actions
    trace: !zZe,
    ...typeof g == "object" && g
  }));
  const d = mZe(...s), C = PZe(d);
  let u = typeof o == "function" ? o(C) : C();
  const A = a(...u);
  return IQ(I, r, A);
}
function BQ(e) {
  const t = {}, i = [];
  let n;
  const g = {
    addCase(r, o) {
      const I = typeof r == "string" ? r : r.type;
      if (!I)
        throw new Error(zo(28));
      if (I in t)
        throw new Error(zo(29));
      return t[I] = o, g;
    },
    addMatcher(r, o) {
      return i.push({
        matcher: r,
        reducer: o
      }), g;
    },
    addDefaultCase(r) {
      return n = r, g;
    }
  };
  return e(g), [t, i, n];
}
function QZe(e) {
  return typeof e == "function";
}
function jZe(e, t) {
  let [i, n, g] = BQ(t), r;
  if (QZe(e))
    r = () => YL(e());
  else {
    const I = YL(e);
    r = () => I;
  }
  function o(I = r(), s) {
    let a = [i[s.type], ...n.filter(({
      matcher: d
    }) => d(s)).map(({
      reducer: d
    }) => d)];
    return a.filter((d) => !!d).length === 0 && (a = [g]), a.reduce((d, C) => {
      if (C)
        if (Kd(d)) {
          const A = C(d, s);
          return A === void 0 ? d : A;
        } else {
          if (hc(d))
            return hD(d, (u) => C(u, s));
          {
            const u = C(d, s);
            if (u === void 0) {
              if (d === null)
                return d;
              throw new Error(zo(9));
            }
            return u;
          }
        }
      return d;
    }, I);
  }
  return o.getInitialState = r, o;
}
var _Ze = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", ZQ = (e = 21) => {
  let t = "", i = e;
  for (; i--; )
    t += _Ze[Math.random() * 64 | 0];
  return t;
}, $Ze = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function qZe(e, t) {
  return `${e}/${t}`;
}
function efe({
  creators: e
} = {}) {
  var i;
  const t = (i = e == null ? void 0 : e.asyncThunk) == null ? void 0 : i[$Ze];
  return function(g) {
    const {
      name: r,
      reducerPath: o = r
    } = g;
    if (!r)
      throw new Error(zo(11));
    typeof process < "u";
    const I = (typeof g.reducers == "function" ? g.reducers(ife()) : g.reducers) || {}, s = Object.keys(I), a = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, d = {
      addCase(y, W) {
        const V = typeof y == "string" ? y : y.type;
        if (!V)
          throw new Error(zo(12));
        if (V in a.sliceCaseReducersByType)
          throw new Error(zo(13));
        return a.sliceCaseReducersByType[V] = W, d;
      },
      addMatcher(y, W) {
        return a.sliceMatchers.push({
          matcher: y,
          reducer: W
        }), d;
      },
      exposeAction(y, W) {
        return a.actionCreators[y] = W, d;
      },
      exposeCaseReducer(y, W) {
        return a.sliceCaseReducersByName[y] = W, d;
      }
    };
    s.forEach((y) => {
      const W = I[y], V = {
        reducerName: y,
        type: qZe(r, y),
        createNotation: typeof g.reducers == "function"
      };
      gfe(W) ? ofe(V, W, d, t) : nfe(V, W, d);
    });
    function C() {
      const [y = {}, W = [], V = void 0] = typeof g.extraReducers == "function" ? BQ(g.extraReducers) : [g.extraReducers], w = {
        ...y,
        ...a.sliceCaseReducersByType
      };
      return jZe(g.initialState, (v) => {
        for (let H in w)
          v.addCase(H, w[H]);
        for (let H of a.sliceMatchers)
          v.addMatcher(H.matcher, H.reducer);
        for (let H of W)
          v.addMatcher(H.matcher, H.reducer);
        V && v.addDefaultCase(V);
      });
    }
    const u = (y) => y, A = /* @__PURE__ */ new Map();
    let m;
    function h(y, W) {
      return m || (m = C()), m(y, W);
    }
    function B() {
      return m || (m = C()), m.getInitialState();
    }
    function f(y, W = !1) {
      function V(v) {
        let H = v[y];
        return typeof H > "u" && W && (H = B()), H;
      }
      function w(v = u) {
        const H = xL(A, W, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return xL(H, v, {
          insert: () => {
            const x = {};
            for (const [N, M] of Object.entries(g.selectors ?? {}))
              x[N] = tfe(M, v, B, W);
            return x;
          }
        });
      }
      return {
        reducerPath: y,
        getSelectors: w,
        get selectors() {
          return w(V);
        },
        selectSlice: V
      };
    }
    const G = {
      name: r,
      reducer: h,
      actions: a.actionCreators,
      caseReducers: a.sliceCaseReducersByName,
      getInitialState: B,
      ...f(o),
      injectInto(y, {
        reducerPath: W,
        ...V
      } = {}) {
        const w = W ?? o;
        return y.inject({
          reducerPath: w,
          reducer: h
        }, V), {
          ...G,
          ...f(w, !0)
        };
      }
    };
    return G;
  };
}
function tfe(e, t, i, n) {
  function g(r, ...o) {
    let I = t(r);
    return typeof I > "u" && n && (I = i()), e(I, ...o);
  }
  return g.unwrapped = e, g;
}
var Vg = /* @__PURE__ */ efe();
function ife() {
  function e(t, i) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...i
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...i) {
          return t(...i);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, i) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: i
      };
    },
    asyncThunk: e
  };
}
function nfe({
  type: e,
  reducerName: t,
  createNotation: i
}, n, g) {
  let r, o;
  if ("reducer" in n) {
    if (i && !rfe(n))
      throw new Error(zo(17));
    r = n.reducer, o = n.prepare;
  } else
    r = n;
  g.addCase(e, r).exposeCaseReducer(t, r).exposeAction(t, o ? Hm(e, o) : Hm(e));
}
function gfe(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function rfe(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function ofe({
  type: e,
  reducerName: t
}, i, n, g) {
  if (!g)
    throw new Error(zo(18));
  const {
    payloadCreator: r,
    fulfilled: o,
    pending: I,
    rejected: s,
    settled: a,
    options: d
  } = i, C = g(e, r, d);
  n.exposeAction(t, C), o && n.addCase(C.fulfilled, o), I && n.addCase(C.pending, I), s && n.addCase(C.rejected, s), a && n.addMatcher(C.settled, a), n.exposeCaseReducer(t, {
    fulfilled: o || rW,
    pending: I || rW,
    rejected: s || rW,
    settled: a || rW
  });
}
function rW() {
}
var Ife = (e, t) => {
  if (typeof e != "function")
    throw new Error(zo(32));
}, BD = "listenerMiddleware", lfe = (e) => {
  let {
    type: t,
    actionCreator: i,
    matcher: n,
    predicate: g,
    effect: r
  } = e;
  if (t)
    g = Hm(t).match;
  else if (i)
    t = i.type, g = i.match;
  else if (n)
    g = n;
  else if (!g)
    throw new Error(zo(21));
  return Ife(r), {
    predicate: g,
    type: t,
    effect: r
  };
}, sfe = Object.assign((e) => {
  const {
    type: t,
    predicate: i,
    effect: n
  } = lfe(e);
  return {
    id: ZQ(),
    effect: n,
    type: t,
    predicate: i,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(zo(22));
    }
  };
}, {
  withTypes: () => sfe
}), afe = Object.assign(Hm(`${BD}/add`), {
  withTypes: () => afe
});
Hm(`${BD}/removeAll`);
var cfe = Object.assign(Hm(`${BD}/remove`), {
  withTypes: () => cfe
});
function zo(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var MS = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
MS.exports;
(function(e, t) {
  (function() {
    var i, n = "4.17.21", g = 200, r = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", I = "Invalid `variable` option passed into `_.template`", s = "__lodash_hash_undefined__", a = 500, d = "__lodash_placeholder__", C = 1, u = 2, A = 4, m = 1, h = 2, B = 1, f = 2, G = 4, y = 8, W = 16, V = 32, w = 64, v = 128, H = 256, x = 512, N = 30, M = "...", $ = 800, q = 16, E = 1, L = 2, P = 3, Q = 1 / 0, te = 9007199254740991, le = 17976931348623157e292, Ae = NaN, we = 4294967295, Ee = we - 1, Je = we >>> 1, ve = [
      ["ary", v],
      ["bind", B],
      ["bindKey", f],
      ["curry", y],
      ["curryRight", W],
      ["flip", x],
      ["partial", V],
      ["partialRight", w],
      ["rearg", H]
    ], Be = "[object Arguments]", ue = "[object Array]", Xe = "[object AsyncFunction]", Ze = "[object Boolean]", Ke = "[object Date]", $e = "[object DOMException]", rt = "[object Error]", dt = "[object Function]", ot = "[object GeneratorFunction]", ze = "[object Map]", tt = "[object Number]", st = "[object Null]", Kt = "[object Object]", ie = "[object Promise]", J = "[object Proxy]", Ce = "[object RegExp]", xe = "[object Set]", Le = "[object String]", Ye = "[object Symbol]", qe = "[object Undefined]", Yt = "[object WeakMap]", qt = "[object WeakSet]", Ut = "[object ArrayBuffer]", Ge = "[object DataView]", pe = "[object Float32Array]", _e = "[object Float64Array]", Gt = "[object Int8Array]", Jt = "[object Int16Array]", Te = "[object Int32Array]", Xt = "[object Uint8Array]", Pe = "[object Uint8ClampedArray]", Oe = "[object Uint16Array]", kt = "[object Uint32Array]", Nt = /\b__p \+= '';/g, ni = /\b(__p \+=) '' \+/g, si = /(__e\(.*?\)|\b__t\)) \+\n'';/g, jt = /&(?:amp|lt|gt|quot|#39);/g, Zi = /[&<>"']/g, fi = RegExp(jt.source), on = RegExp(Zi.source), In = /<%-([\s\S]+?)%>/g, xn = /<%([\s\S]+?)%>/g, ln = /<%=([\s\S]+?)%>/g, ug = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ti = /^\w*$/, vi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ei = /[\\^$.*+?()[\]{}|]/g, yn = RegExp(ei.source), Mi = /^\s+/, bn = /\s/, Ag = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, sn = /\{\n\/\* \[wrapped with (.+)\] \*/, bg = /,? & /, Kn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Mn = /[()=,{}\[\]\/\s]/, Br = /\\(\\)?/g, He = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, We = /\w*$/, yt = /^[-+]0x[0-9a-f]+$/i, at = /^0b[01]+$/i, Lt = /^\[object .+?Constructor\]$/, Ht = /^0o[0-7]+$/i, oi = /^(?:0|[1-9]\d*)$/, mg = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, kl = /($^)/, oI = /['\n\r\u2028\u2029\\]/g, wa = "\\ud800-\\udfff", AA = "\\u0300-\\u036f", II = "\\ufe20-\\ufe2f", Zr = "\\u20d0-\\u20ff", lI = AA + II + Zr, Rs = "\\u2700-\\u27bf", CC = "a-z\\xdf-\\xf6\\xf8-\\xff", va = "\\xac\\xb1\\xd7\\xf7", bA = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ra = "\\u2000-\\u206f", Fl = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Hc = "A-Z\\xc0-\\xd6\\xd8-\\xde", kc = "\\ufe0e\\ufe0f", Xa = va + bA + Ra + Fl, Ha = "['’]", uC = "[" + wa + "]", Fc = "[" + Xa + "]", Xs = "[" + lI + "]", ka = "\\d+", AC = "[" + Rs + "]", bC = "[" + CC + "]", mC = "[^" + wa + Xa + ka + Rs + CC + Hc + "]", hC = "\\ud83c[\\udffb-\\udfff]", Yc = "(?:" + Xs + "|" + hC + ")", xc = "[^" + wa + "]", pC = "(?:\\ud83c[\\udde6-\\uddff]){2}", BC = "[\\ud800-\\udbff][\\udc00-\\udfff]", Hs = "[" + Hc + "]", ZC = "\\u200d", Dc = "(?:" + bC + "|" + mC + ")", Jc = "(?:" + Hs + "|" + mC + ")", mA = "(?:" + Ha + "(?:d|ll|m|re|s|t|ve))?", fC = "(?:" + Ha + "(?:D|LL|M|RE|S|T|VE))?", Fa = Yc + "?", Yl = "[" + kc + "]?", GC = "(?:" + ZC + "(?:" + [xc, pC, BC].join("|") + ")" + Yl + Fa + ")*", Xh = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", yC = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", hA = Yl + Fa + GC, Hh = "(?:" + [AC, pC, BC].join("|") + ")" + hA, pA = "(?:" + [xc + Xs + "?", Xs, pC, BC, uC].join("|") + ")", WC = RegExp(Ha, "g"), kh = RegExp(Xs, "g"), SC = RegExp(hC + "(?=" + hC + ")|" + pA + hA, "g"), NI = RegExp([
      Hs + "?" + bC + "+" + mA + "(?=" + [Fc, Hs, "$"].join("|") + ")",
      Jc + "+" + fC + "(?=" + [Fc, Hs + Dc, "$"].join("|") + ")",
      Hs + "?" + Dc + "+" + mA,
      Hs + "+" + fC,
      yC,
      Xh,
      ka,
      Hh
    ].join("|"), "g"), Fh = RegExp("[" + ZC + wa + lI + kc + "]"), Yh = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, xh = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Dh = -1, Gi = {};
    Gi[pe] = Gi[_e] = Gi[Gt] = Gi[Jt] = Gi[Te] = Gi[Xt] = Gi[Pe] = Gi[Oe] = Gi[kt] = !0, Gi[Be] = Gi[ue] = Gi[Ut] = Gi[Ze] = Gi[Ge] = Gi[Ke] = Gi[rt] = Gi[dt] = Gi[ze] = Gi[tt] = Gi[Kt] = Gi[Ce] = Gi[xe] = Gi[Le] = Gi[Yt] = !1;
    var F = {};
    F[Be] = F[ue] = F[Ut] = F[Ge] = F[Ze] = F[Ke] = F[pe] = F[_e] = F[Gt] = F[Jt] = F[Te] = F[ze] = F[tt] = F[Kt] = F[Ce] = F[xe] = F[Le] = F[Ye] = F[Xt] = F[Pe] = F[Oe] = F[kt] = !0, F[rt] = F[dt] = F[Yt] = !1;
    var U = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ee = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, j = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, ae = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, be = parseFloat, ke = parseInt, gt = typeof Zn == "object" && Zn && Zn.Object === Object && Zn, Qe = typeof self == "object" && self && self.Object === Object && self, ut = gt || Qe || Function("return this")(), wt = t && !t.nodeType && t, Et = wt && !0 && e && !e.nodeType && e, ht = Et && Et.exports === wt, ci = ht && gt.process, ai = function() {
      try {
        var T = Et && Et.require && Et.require("util").types;
        return T || ci && ci.binding && ci.binding("util");
      } catch {
      }
    }(), vn = ai && ai.isArrayBuffer, Ot = ai && ai.isDate, yi = ai && ai.isMap, og = ai && ai.isRegExp, Un = ai && ai.isSet, Ig = ai && ai.isTypedArray;
    function Ui(T, re, X) {
      switch (X.length) {
        case 0:
          return T.call(re);
        case 1:
          return T.call(re, X[0]);
        case 2:
          return T.call(re, X[0], X[1]);
        case 3:
          return T.call(re, X[0], X[1], X[2]);
      }
      return T.apply(re, X);
    }
    function Ya(T, re, X, De) {
      for (var It = -1, lt = T == null ? 0 : T.length; ++It < lt; ) {
        var Ji = T[It];
        re(De, Ji, X(Ji), T);
      }
      return De;
    }
    function Eg(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length; ++X < De && re(T[X], X, T) !== !1; )
        ;
      return T;
    }
    function BA(T, re) {
      for (var X = T == null ? 0 : T.length; X-- && re(T[X], X, T) !== !1; )
        ;
      return T;
    }
    function ZA(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length; ++X < De; )
        if (!re(T[X], X, T))
          return !1;
      return !0;
    }
    function ks(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length, It = 0, lt = []; ++X < De; ) {
        var Ji = T[X];
        re(Ji, X, T) && (lt[It++] = Ji);
      }
      return lt;
    }
    function VC(T, re) {
      var X = T == null ? 0 : T.length;
      return !!X && Kc(T, re, 0) > -1;
    }
    function wC(T, re, X) {
      for (var De = -1, It = T == null ? 0 : T.length; ++De < It; )
        if (X(re, T[De]))
          return !0;
      return !1;
    }
    function Wn(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length, It = Array(De); ++X < De; )
        It[X] = re(T[X], X, T);
      return It;
    }
    function go(T, re) {
      for (var X = -1, De = re.length, It = T.length; ++X < De; )
        T[It + X] = re[X];
      return T;
    }
    function fA(T, re, X, De) {
      var It = -1, lt = T == null ? 0 : T.length;
      for (De && lt && (X = T[++It]); ++It < lt; )
        X = re(X, T[It], It, T);
      return X;
    }
    function Nf(T, re, X, De) {
      var It = T == null ? 0 : T.length;
      for (De && It && (X = T[--It]); It--; )
        X = re(X, T[It], It, T);
      return X;
    }
    function Jh(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length; ++X < De; )
        if (re(T[X], X, T))
          return !0;
      return !1;
    }
    var Lf = Nh("length");
    function Tf(T) {
      return T.split("");
    }
    function Mf(T) {
      return T.match(Kn) || [];
    }
    function Kh(T, re, X) {
      var De;
      return X(T, function(It, lt, Ji) {
        if (re(It, lt, Ji))
          return De = lt, !1;
      }), De;
    }
    function GA(T, re, X, De) {
      for (var It = T.length, lt = X + (De ? 1 : -1); De ? lt-- : ++lt < It; )
        if (re(T[lt], lt, T))
          return lt;
      return -1;
    }
    function Kc(T, re, X) {
      return re === re ? $f(T, re, X) : GA(T, Eh, X);
    }
    function gv(T, re, X, De) {
      for (var It = X - 1, lt = T.length; ++It < lt; )
        if (De(T[It], re))
          return It;
      return -1;
    }
    function Eh(T) {
      return T !== T;
    }
    function Uf(T, re) {
      var X = T == null ? 0 : T.length;
      return X ? Mh(T, re) / X : Ae;
    }
    function Nh(T) {
      return function(re) {
        return re == null ? i : re[T];
      };
    }
    function Lh(T) {
      return function(re) {
        return T == null ? i : T[re];
      };
    }
    function Pf(T, re, X, De, It) {
      return It(T, function(lt, Ji, ji) {
        X = De ? (De = !1, lt) : re(X, lt, Ji, ji);
      }), X;
    }
    function Th(T, re) {
      var X = T.length;
      for (T.sort(re); X--; )
        T[X] = T[X].value;
      return T;
    }
    function Mh(T, re) {
      for (var X, De = -1, It = T.length; ++De < It; ) {
        var lt = re(T[De]);
        lt !== i && (X = X === i ? lt : X + lt);
      }
      return X;
    }
    function Uh(T, re) {
      for (var X = -1, De = Array(T); ++X < T; )
        De[X] = re(X);
      return De;
    }
    function rv(T, re) {
      return Wn(re, function(X) {
        return [X, T[X]];
      });
    }
    function zf(T) {
      return T && T.slice(0, Oh(T) + 1).replace(Mi, "");
    }
    function ro(T) {
      return function(re) {
        return T(re);
      };
    }
    function mn(T, re) {
      return Wn(re, function(X) {
        return T[X];
      });
    }
    function Pi(T, re) {
      return T.has(re);
    }
    function Of(T, re) {
      for (var X = -1, De = T.length; ++X < De && Kc(re, T[X], 0) > -1; )
        ;
      return X;
    }
    function Qf(T, re) {
      for (var X = T.length; X-- && Kc(re, T[X], 0) > -1; )
        ;
      return X;
    }
    function ov(T, re) {
      for (var X = T.length, De = 0; X--; )
        T[X] === re && ++De;
      return De;
    }
    var Iv = Lh(U), lv = Lh(ee);
    function sv(T) {
      return "\\" + ae[T];
    }
    function jf(T, re) {
      return T == null ? i : T[re];
    }
    function Ec(T) {
      return Fh.test(T);
    }
    function Ng(T) {
      return Yh.test(T);
    }
    function Ph(T) {
      for (var re, X = []; !(re = T.next()).done; )
        X.push(re.value);
      return X;
    }
    function xl(T) {
      var re = -1, X = Array(T.size);
      return T.forEach(function(De, It) {
        X[++re] = [It, De];
      }), X;
    }
    function zh(T, re) {
      return function(X) {
        return T(re(X));
      };
    }
    function LI(T, re) {
      for (var X = -1, De = T.length, It = 0, lt = []; ++X < De; ) {
        var Ji = T[X];
        (Ji === re || Ji === d) && (T[X] = d, lt[It++] = X);
      }
      return lt;
    }
    function fr(T) {
      var re = -1, X = Array(T.size);
      return T.forEach(function(De) {
        X[++re] = De;
      }), X;
    }
    function _f(T) {
      var re = -1, X = Array(T.size);
      return T.forEach(function(De) {
        X[++re] = [De, De];
      }), X;
    }
    function $f(T, re, X) {
      for (var De = X - 1, It = T.length; ++De < It; )
        if (T[De] === re)
          return De;
      return -1;
    }
    function qf(T, re, X) {
      for (var De = X + 1; De--; )
        if (T[De] === re)
          return De;
      return De;
    }
    function xa(T) {
      return Ec(T) ? cv(T) : Lf(T);
    }
    function vo(T) {
      return Ec(T) ? dv(T) : Tf(T);
    }
    function Oh(T) {
      for (var re = T.length; re-- && bn.test(T.charAt(re)); )
        ;
      return re;
    }
    var av = Lh(j);
    function cv(T) {
      for (var re = SC.lastIndex = 0; SC.test(T); )
        ++re;
      return re;
    }
    function dv(T) {
      return T.match(SC) || [];
    }
    function Cv(T) {
      return T.match(NI) || [];
    }
    var uv = function T(re) {
      re = re == null ? ut : sI.defaults(ut.Object(), re, sI.pick(ut, xh));
      var X = re.Array, De = re.Date, It = re.Error, lt = re.Function, Ji = re.Math, ji = re.Object, Qh = re.RegExp, Da = re.String, Ro = re.TypeError, yA = X.prototype, Av = lt.prototype, Nc = ji.prototype, WA = re["__core-js_shared__"], Xo = Av.toString, _i = Nc.hasOwnProperty, bv = 0, eG = function() {
        var l = /[^.]+$/.exec(WA && WA.keys && WA.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), SA = Nc.toString, mv = Xo.call(ji), Dl = ut._, hv = Qh(
        "^" + Xo.call(_i).replace(ei, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), VA = ht ? re.Buffer : i, Fs = re.Symbol, wA = re.Uint8Array, tG = VA ? VA.allocUnsafe : i, TI = zh(ji.getPrototypeOf, ji), iG = ji.create, nG = Nc.propertyIsEnumerable, Mr = yA.splice, gG = Fs ? Fs.isConcatSpreadable : i, vC = Fs ? Fs.iterator : i, Ja = Fs ? Fs.toStringTag : i, vA = function() {
        try {
          var l = za(ji, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), pv = re.clearTimeout !== ut.clearTimeout && re.clearTimeout, rG = De && De.now !== ut.Date.now && De.now, oG = re.setTimeout !== ut.setTimeout && re.setTimeout, RA = Ji.ceil, XA = Ji.floor, RC = ji.getOwnPropertySymbols, XC = VA ? VA.isBuffer : i, HC = re.isFinite, Bv = yA.join, IG = zh(ji.keys, ji), hg = Ji.max, Dn = Ji.min, jh = De.now, Ka = re.parseInt, oo = Ji.random, Zv = yA.reverse, HA = za(re, "DataView"), Lc = za(re, "Map"), Ea = za(re, "Promise"), Tc = za(re, "Set"), Ys = za(re, "WeakMap"), kC = za(ji, "create"), FC = Ys && new Ys(), Pn = {}, MI = Oa(HA), _h = Oa(Lc), kA = Oa(Ea), Na = Oa(Tc), lG = Oa(Ys), Rg = Fs ? Fs.prototype : i, La = Rg ? Rg.valueOf : i, sG = Rg ? Rg.toString : i;
      function z(l) {
        if (Xn(l) && !li(l) && !(l instanceof Vi)) {
          if (l instanceof Ho)
            return l;
          if (_i.call(l, "__wrapped__"))
            return OC(l);
        }
        return new Ho(l);
      }
      var Mc = /* @__PURE__ */ function() {
        function l() {
        }
        return function(c) {
          if (!Nn(c))
            return {};
          if (iG)
            return iG(c);
          l.prototype = c;
          var b = new l();
          return l.prototype = i, b;
        };
      }();
      function Uc() {
      }
      function Ho(l, c) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = i;
      }
      z.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: In,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: xn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: ln,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: z
        }
      }, z.prototype = Uc.prototype, z.prototype.constructor = z, Ho.prototype = Mc(Uc.prototype), Ho.prototype.constructor = Ho;
      function Vi(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = we, this.__views__ = [];
      }
      function aG() {
        var l = new Vi(this.__wrapped__);
        return l.__actions__ = yr(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = yr(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = yr(this.__views__), l;
      }
      function fv() {
        if (this.__filtered__) {
          var l = new Vi(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function Gv() {
        var l = this.__wrapped__.value(), c = this.__dir__, b = li(l), Z = c < 0, S = b ? l.length : 0, R = NG(0, S, this.__views__), D = R.start, K = R.end, O = K - D, se = Z ? K : D - 1, oe = this.__iteratees__, de = oe.length, Fe = 0, Me = Dn(O, this.__takeCount__);
        if (!b || !Z && S == O && Me == O)
          return _A(l, this.__actions__);
        var it = [];
        e:
          for (; O-- && Fe < Me; ) {
            se += c;
            for (var Zt = -1, nt = l[se]; ++Zt < de; ) {
              var vt = oe[Zt], Rt = vt.iteratee, an = vt.type, cn = Rt(nt);
              if (an == L)
                nt = cn;
              else if (!cn) {
                if (an == E)
                  continue e;
                break e;
              }
            }
            it[Fe++] = nt;
          }
        return it;
      }
      Vi.prototype = Mc(Uc.prototype), Vi.prototype.constructor = Vi;
      function aI(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.clear(); ++c < b; ) {
          var Z = l[c];
          this.set(Z[0], Z[1]);
        }
      }
      function yv() {
        this.__data__ = kC ? kC(null) : {}, this.size = 0;
      }
      function Wv(l) {
        var c = this.has(l) && delete this.__data__[l];
        return this.size -= c ? 1 : 0, c;
      }
      function $h(l) {
        var c = this.__data__;
        if (kC) {
          var b = c[l];
          return b === s ? i : b;
        }
        return _i.call(c, l) ? c[l] : i;
      }
      function cG(l) {
        var c = this.__data__;
        return kC ? c[l] !== i : _i.call(c, l);
      }
      function Sv(l, c) {
        var b = this.__data__;
        return this.size += this.has(l) ? 0 : 1, b[l] = kC && c === i ? s : c, this;
      }
      aI.prototype.clear = yv, aI.prototype.delete = Wv, aI.prototype.get = $h, aI.prototype.has = cG, aI.prototype.set = Sv;
      function Jl(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.clear(); ++c < b; ) {
          var Z = l[c];
          this.set(Z[0], Z[1]);
        }
      }
      function Vv() {
        this.__data__ = [], this.size = 0;
      }
      function dG(l) {
        var c = this.__data__, b = YA(c, l);
        if (b < 0)
          return !1;
        var Z = c.length - 1;
        return b == Z ? c.pop() : Mr.call(c, b, 1), --this.size, !0;
      }
      function qh(l) {
        var c = this.__data__, b = YA(c, l);
        return b < 0 ? i : c[b][1];
      }
      function wv(l) {
        return YA(this.__data__, l) > -1;
      }
      function ep(l, c) {
        var b = this.__data__, Z = YA(b, l);
        return Z < 0 ? (++this.size, b.push([l, c])) : b[Z][1] = c, this;
      }
      Jl.prototype.clear = Vv, Jl.prototype.delete = dG, Jl.prototype.get = qh, Jl.prototype.has = wv, Jl.prototype.set = ep;
      function UI(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.clear(); ++c < b; ) {
          var Z = l[c];
          this.set(Z[0], Z[1]);
        }
      }
      function CG() {
        this.size = 0, this.__data__ = {
          hash: new aI(),
          map: new (Lc || Jl)(),
          string: new aI()
        };
      }
      function uG(l) {
        var c = rb(this, l).delete(l);
        return this.size -= c ? 1 : 0, c;
      }
      function FA(l) {
        return rb(this, l).get(l);
      }
      function vv(l) {
        return rb(this, l).has(l);
      }
      function AG(l, c) {
        var b = rb(this, l), Z = b.size;
        return b.set(l, c), this.size += b.size == Z ? 0 : 1, this;
      }
      UI.prototype.clear = CG, UI.prototype.delete = uG, UI.prototype.get = FA, UI.prototype.has = vv, UI.prototype.set = AG;
      function xs(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.__data__ = new UI(); ++c < b; )
          this.add(l[c]);
      }
      function Rv(l) {
        return this.__data__.set(l, s), this;
      }
      function bG(l) {
        return this.__data__.has(l);
      }
      xs.prototype.add = xs.prototype.push = Rv, xs.prototype.has = bG;
      function cI(l) {
        var c = this.__data__ = new Jl(l);
        this.size = c.size;
      }
      function tp() {
        this.__data__ = new Jl(), this.size = 0;
      }
      function mG(l) {
        var c = this.__data__, b = c.delete(l);
        return this.size = c.size, b;
      }
      function ip(l) {
        return this.__data__.get(l);
      }
      function Xv(l) {
        return this.__data__.has(l);
      }
      function np(l, c) {
        var b = this.__data__;
        if (b instanceof Jl) {
          var Z = b.__data__;
          if (!Lc || Z.length < g - 1)
            return Z.push([l, c]), this.size = ++b.size, this;
          b = this.__data__ = new UI(Z);
        }
        return b.set(l, c), this.size = b.size, this;
      }
      cI.prototype.clear = tp, cI.prototype.delete = mG, cI.prototype.get = ip, cI.prototype.has = Xv, cI.prototype.set = np;
      function wi(l, c) {
        var b = li(l), Z = !b && Ls(l), S = !b && !Z && uI(l), R = !b && !Z && !S && Ql(l), D = b || Z || S || R, K = D ? Uh(l.length, Da) : [], O = K.length;
        for (var se in l)
          (c || _i.call(l, se)) && !(D && // Safari 9 has enumerable `arguments.length` in strict mode.
          (se == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          S && (se == "offset" || se == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          R && (se == "buffer" || se == "byteLength" || se == "byteOffset") || // Skip index properties.
          Tl(se, O))) && K.push(se);
        return K;
      }
      function hG(l) {
        var c = l.length;
        return c ? l[NC(0, c - 1)] : i;
      }
      function Hv(l, c) {
        return zC(yr(l), Ur(c, 0, l.length));
      }
      function YC(l) {
        return zC(yr(l));
      }
      function gp(l, c, b) {
        (b !== i && !$i(l[c], b) || b === i && !(c in l)) && PI(l, c, b);
      }
      function $g(l, c, b) {
        var Z = l[c];
        (!(_i.call(l, c) && $i(Z, b)) || b === i && !(c in l)) && PI(l, c, b);
      }
      function YA(l, c) {
        for (var b = l.length; b--; )
          if ($i(l[b][0], c))
            return b;
        return -1;
      }
      function xA(l, c, b, Z) {
        return Kl(l, function(S, R, D) {
          c(Z, S, b(S), D);
        }), Z;
      }
      function DA(l, c) {
        return l && $I(c, Hg(c), l);
      }
      function pG(l, c) {
        return l && $I(c, vr(c), l);
      }
      function PI(l, c, b) {
        c == "__proto__" && vA ? vA(l, c, {
          configurable: !0,
          enumerable: !0,
          value: b,
          writable: !0
        }) : l[c] = b;
      }
      function Gr(l, c) {
        for (var b = -1, Z = c.length, S = X(Z), R = l == null; ++b < Z; )
          S[b] = R ? i : qI(l, c[b]);
        return S;
      }
      function Ur(l, c, b) {
        return l === l && (b !== i && (l = l <= b ? l : b), c !== i && (l = l >= c ? l : c)), l;
      }
      function Pr(l, c, b, Z, S, R) {
        var D, K = c & C, O = c & u, se = c & A;
        if (b && (D = S ? b(l, Z, S, R) : b(l)), D !== i)
          return D;
        if (!Nn(l))
          return l;
        var oe = li(l);
        if (oe) {
          if (D = eR(l), !K)
            return yr(l, D);
        } else {
          var de = ir(l), Fe = de == dt || de == ot;
          if (uI(l))
            return pp(l, K);
          if (de == Kt || de == Be || Fe && !S) {
            if (D = O || Fe ? {} : LG(l), !K)
              return O ? Uv(l, pG(D, l)) : Mv(l, DA(D, l));
          } else {
            if (!F[de])
              return S ? l : {};
            D = tR(l, de, K);
          }
        }
        R || (R = new cI());
        var Me = R.get(l);
        if (Me)
          return Me;
        R.set(l, D), by(l) ? l.forEach(function(nt) {
          D.add(Pr(nt, c, b, nt, l, R));
        }) : Pl(l) && l.forEach(function(nt, vt) {
          D.set(vt, Pr(nt, c, b, vt, l, R));
        });
        var it = se ? O ? Sp : Wp : O ? vr : Hg, Zt = oe ? i : it(l);
        return Eg(Zt || l, function(nt, vt) {
          Zt && (vt = nt, nt = l[vt]), $g(D, vt, Pr(nt, c, b, vt, l, R));
        }), D;
      }
      function BG(l) {
        var c = Hg(l);
        return function(b) {
          return xC(b, l, c);
        };
      }
      function xC(l, c, b) {
        var Z = b.length;
        if (l == null)
          return !Z;
        for (l = ji(l); Z--; ) {
          var S = b[Z], R = c[S], D = l[S];
          if (D === i && !(S in l) || !R(D))
            return !1;
        }
        return !0;
      }
      function rp(l, c, b) {
        if (typeof l != "function")
          throw new Ro(o);
        return PC(function() {
          l.apply(i, b);
        }, c);
      }
      function Ta(l, c, b, Z) {
        var S = -1, R = VC, D = !0, K = l.length, O = [], se = c.length;
        if (!K)
          return O;
        b && (c = Wn(c, ro(b))), Z ? (R = wC, D = !1) : c.length >= g && (R = Pi, D = !1, c = new xs(c));
        e:
          for (; ++S < K; ) {
            var oe = l[S], de = b == null ? oe : b(oe);
            if (oe = Z || oe !== 0 ? oe : 0, D && de === de) {
              for (var Fe = se; Fe--; )
                if (c[Fe] === de)
                  continue e;
              O.push(oe);
            } else
              R(c, de, Z) || O.push(oe);
          }
        return O;
      }
      var Kl = RG(zI), JA = RG(KA, !0);
      function op(l, c) {
        var b = !0;
        return Kl(l, function(Z, S, R) {
          return b = !!c(Z, S, R), b;
        }), b;
      }
      function dI(l, c, b) {
        for (var Z = -1, S = l.length; ++Z < S; ) {
          var R = l[Z], D = c(R);
          if (D != null && (K === i ? D === D && !so(D) : b(D, K)))
            var K = D, O = R;
        }
        return O;
      }
      function Ds(l, c, b, Z) {
        var S = l.length;
        for (b = Qt(b), b < 0 && (b = -b > S ? 0 : S + b), Z = Z === i || Z > S ? S : Qt(Z), Z < 0 && (Z += S), Z = b > Z ? 0 : py(Z); b < Z; )
          l[b++] = c;
        return l;
      }
      function Ip(l, c) {
        var b = [];
        return Kl(l, function(Z, S, R) {
          c(Z, S, R) && b.push(Z);
        }), b;
      }
      function pg(l, c, b, Z, S) {
        var R = -1, D = l.length;
        for (b || (b = nR), S || (S = []); ++R < D; ) {
          var K = l[R];
          c > 0 && b(K) ? c > 1 ? pg(K, c - 1, b, Z, S) : go(S, K) : Z || (S[S.length] = K);
        }
        return S;
      }
      var lp = XG(), ZG = XG(!0);
      function zI(l, c) {
        return l && lp(l, c, Hg);
      }
      function KA(l, c) {
        return l && ZG(l, c, Hg);
      }
      function DC(l, c) {
        return ks(c, function(b) {
          return Do(l[b]);
        });
      }
      function Ma(l, c) {
        c = Ks(c, l);
        for (var b = 0, Z = c.length; l != null && b < Z; )
          l = l[CI(c[b++])];
        return b && b == Z ? l : i;
      }
      function sp(l, c, b) {
        var Z = c(l);
        return li(l) ? Z : go(Z, b(l));
      }
      function qg(l) {
        return l == null ? l === i ? qe : st : Ja && Ja in ji(l) ? vp(l) : sR(l);
      }
      function er(l, c) {
        return l > c;
      }
      function OI(l, c) {
        return l != null && _i.call(l, c);
      }
      function kv(l, c) {
        return l != null && c in ji(l);
      }
      function Fv(l, c, b) {
        return l >= Dn(c, b) && l < hg(c, b);
      }
      function Pc(l, c, b) {
        for (var Z = b ? wC : VC, S = l[0].length, R = l.length, D = R, K = X(R), O = 1 / 0, se = []; D--; ) {
          var oe = l[D];
          D && c && (oe = Wn(oe, ro(c))), O = Dn(oe.length, O), K[D] = !b && (c || S >= 120 && oe.length >= 120) ? new xs(D && oe) : i;
        }
        oe = l[0];
        var de = -1, Fe = K[0];
        e:
          for (; ++de < S && se.length < O; ) {
            var Me = oe[de], it = c ? c(Me) : Me;
            if (Me = b || Me !== 0 ? Me : 0, !(Fe ? Pi(Fe, it) : Z(se, it, b))) {
              for (D = R; --D; ) {
                var Zt = K[D];
                if (!(Zt ? Pi(Zt, it) : Z(l[D], it, b)))
                  continue e;
              }
              Fe && Fe.push(it), se.push(Me);
            }
          }
        return se;
      }
      function zc(l, c, b, Z) {
        return zI(l, function(S, R, D) {
          c(Z, b(S), R, D);
        }), Z;
      }
      function Oc(l, c, b) {
        c = Ks(c, l), l = UG(l, c);
        var Z = l == null ? l : l[CI(wr(c))];
        return Z == null ? i : Ui(Z, l, b);
      }
      function ap(l) {
        return Xn(l) && qg(l) == Be;
      }
      function Yv(l) {
        return Xn(l) && qg(l) == Ut;
      }
      function fG(l) {
        return Xn(l) && qg(l) == Ke;
      }
      function QI(l, c, b, Z, S) {
        return l === c ? !0 : l == null || c == null || !Xn(l) && !Xn(c) ? l !== l && c !== c : JC(l, c, b, Z, QI, S);
      }
      function JC(l, c, b, Z, S, R) {
        var D = li(l), K = li(c), O = D ? ue : ir(l), se = K ? ue : ir(c);
        O = O == Be ? Kt : O, se = se == Be ? Kt : se;
        var oe = O == Kt, de = se == Kt, Fe = O == se;
        if (Fe && uI(l)) {
          if (!uI(c))
            return !1;
          D = !0, oe = !1;
        }
        if (Fe && !oe)
          return R || (R = new cI()), D || Ql(l) ? KG(l, c, b, Z, S, R) : _v(l, c, O, b, Z, S, R);
        if (!(b & m)) {
          var Me = oe && _i.call(l, "__wrapped__"), it = de && _i.call(c, "__wrapped__");
          if (Me || it) {
            var Zt = Me ? l.value() : l, nt = it ? c.value() : c;
            return R || (R = new cI()), S(Zt, nt, b, Z, R);
          }
        }
        return Fe ? (R || (R = new cI()), $v(l, c, b, Z, S, R)) : !1;
      }
      function xv(l) {
        return Xn(l) && ir(l) == ze;
      }
      function EA(l, c, b, Z) {
        var S = b.length, R = S, D = !Z;
        if (l == null)
          return !R;
        for (l = ji(l); S--; ) {
          var K = b[S];
          if (D && K[2] ? K[1] !== l[K[0]] : !(K[0] in l))
            return !1;
        }
        for (; ++S < R; ) {
          K = b[S];
          var O = K[0], se = l[O], oe = K[1];
          if (D && K[2]) {
            if (se === i && !(O in l))
              return !1;
          } else {
            var de = new cI();
            if (Z)
              var Fe = Z(se, oe, O, l, c, de);
            if (!(Fe === i ? QI(oe, se, m | h, Z, de) : Fe))
              return !1;
          }
        }
        return !0;
      }
      function cp(l) {
        if (!Nn(l) || rR(l))
          return !1;
        var c = Do(l) ? hv : Lt;
        return c.test(Oa(l));
      }
      function NA(l) {
        return Xn(l) && qg(l) == Ce;
      }
      function GG(l) {
        return Xn(l) && ir(l) == xe;
      }
      function LA(l) {
        return Xn(l) && Bb(l.length) && !!Gi[qg(l)];
      }
      function TA(l) {
        return typeof l == "function" ? l : l == null ? Tg : typeof l == "object" ? li(l) ? UA(l[0], l[1]) : dp(l) : s0(l);
      }
      function Qc(l) {
        if (!td(l))
          return IG(l);
        var c = [];
        for (var b in ji(l))
          _i.call(l, b) && b != "constructor" && c.push(b);
        return c;
      }
      function Dv(l) {
        if (!Nn(l))
          return lR(l);
        var c = td(l), b = [];
        for (var Z in l)
          Z == "constructor" && (c || !_i.call(l, Z)) || b.push(Z);
        return b;
      }
      function MA(l, c) {
        return l < c;
      }
      function KC(l, c) {
        var b = -1, Z = gr(l) ? X(l.length) : [];
        return Kl(l, function(S, R, D) {
          Z[++b] = c(S, R, D);
        }), Z;
      }
      function dp(l) {
        var c = wp(l);
        return c.length == 1 && c[0][2] ? TG(c[0][0], c[0][1]) : function(b) {
          return b === l || EA(b, l, c);
        };
      }
      function UA(l, c) {
        return Rp(l) && Hp(c) ? TG(CI(l), c) : function(b) {
          var Z = qI(b, l);
          return Z === i && Z === c ? iu(b, l) : QI(c, Z, m | h);
        };
      }
      function EC(l, c, b, Z, S) {
        l !== c && lp(c, function(R, D) {
          if (S || (S = new cI()), Nn(R))
            El(l, c, D, b, EC, Z, S);
          else {
            var K = Z ? Z(kp(l, D), R, D + "", l, c, S) : i;
            K === i && (K = R), gp(l, D, K);
          }
        }, vr);
      }
      function El(l, c, b, Z, S, R, D) {
        var K = kp(l, b), O = kp(c, b), se = D.get(O);
        if (se) {
          gp(l, b, se);
          return;
        }
        var oe = R ? R(K, O, b + "", l, c, D) : i, de = oe === i;
        if (de) {
          var Fe = li(O), Me = !Fe && uI(O), it = !Fe && !Me && Ql(O);
          oe = O, Fe || Me || it ? li(K) ? oe = K : eg(K) ? oe = yr(K) : Me ? (de = !1, oe = pp(O, !0)) : it ? (de = !1, oe = Zp(O, !0)) : oe = [] : zl(O) || Ls(O) ? (oe = K, Ls(K) ? oe = jp(K) : (!Nn(K) || Do(K)) && (oe = LG(O))) : de = !1;
        }
        de && (D.set(O, oe), S(oe, O, Z, R, D), D.delete(O)), gp(l, b, oe);
      }
      function Cp(l, c) {
        var b = l.length;
        if (b)
          return c += c < 0 ? b : 0, Tl(c, b) ? l[c] : i;
      }
      function up(l, c, b) {
        c.length ? c = Wn(c, function(R) {
          return li(R) ? function(D) {
            return Ma(D, R.length === 1 ? R[0] : R);
          } : R;
        }) : c = [Tg];
        var Z = -1;
        c = Wn(c, ro(ri()));
        var S = KC(l, function(R, D, K) {
          var O = Wn(c, function(se) {
            return se(R);
          });
          return { criteria: O, index: ++Z, value: R };
        });
        return Th(S, function(R, D) {
          return _I(R, D, b);
        });
      }
      function Jv(l, c) {
        return Ap(l, c, function(b, Z) {
          return iu(l, Z);
        });
      }
      function Ap(l, c, b) {
        for (var Z = -1, S = c.length, R = {}; ++Z < S; ) {
          var D = c[Z], K = Ma(l, D);
          b(K, D) && Ua(R, Ks(D, l), K);
        }
        return R;
      }
      function Kv(l) {
        return function(c) {
          return Ma(c, l);
        };
      }
      function bp(l, c, b, Z) {
        var S = Z ? gv : Kc, R = -1, D = c.length, K = l;
        for (l === c && (c = yr(c)), b && (K = Wn(l, ro(b))); ++R < D; )
          for (var O = 0, se = c[R], oe = b ? b(se) : se; (O = S(K, oe, O, Z)) > -1; )
            K !== l && Mr.call(K, O, 1), Mr.call(l, O, 1);
        return l;
      }
      function jI(l, c) {
        for (var b = l ? c.length : 0, Z = b - 1; b--; ) {
          var S = c[b];
          if (b == Z || S !== R) {
            var R = S;
            Tl(S) ? Mr.call(l, S, 1) : Lg(l, S);
          }
        }
        return l;
      }
      function NC(l, c) {
        return l + XA(oo() * (c - l + 1));
      }
      function mp(l, c, b, Z) {
        for (var S = -1, R = hg(RA((c - l) / (b || 1)), 0), D = X(R); R--; )
          D[Z ? R : ++S] = l, l += b;
        return D;
      }
      function jc(l, c) {
        var b = "";
        if (!l || c < 1 || c > te)
          return b;
        do
          c % 2 && (b += l), c = XA(c / 2), c && (l += l);
        while (c);
        return b;
      }
      function bi(l, c) {
        return Fp(MG(l, c, Tg), l + "");
      }
      function gi(l) {
        return hG(Id(l));
      }
      function PA(l, c) {
        var b = Id(l);
        return zC(b, Ur(c, 0, b.length));
      }
      function Ua(l, c, b, Z) {
        if (!Nn(l))
          return l;
        c = Ks(c, l);
        for (var S = -1, R = c.length, D = R - 1, K = l; K != null && ++S < R; ) {
          var O = CI(c[S]), se = b;
          if (O === "__proto__" || O === "constructor" || O === "prototype")
            return l;
          if (S != D) {
            var oe = K[O];
            se = Z ? Z(oe, O, K) : i, se === i && (se = Nn(oe) ? oe : Tl(c[S + 1]) ? [] : {});
          }
          $g(K, O, se), K = K[O];
        }
        return l;
      }
      var Js = FC ? function(l, c) {
        return FC.set(l, c), l;
      } : Tg, Ev = vA ? function(l, c) {
        return vA(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: r0(c),
          writable: !0
        });
      } : Tg;
      function Nv(l) {
        return zC(Id(l));
      }
      function ko(l, c, b) {
        var Z = -1, S = l.length;
        c < 0 && (c = -c > S ? 0 : S + c), b = b > S ? S : b, b < 0 && (b += S), S = c > b ? 0 : b - c >>> 0, c >>>= 0;
        for (var R = X(S); ++Z < S; )
          R[Z] = l[Z + c];
        return R;
      }
      function yG(l, c) {
        var b;
        return Kl(l, function(Z, S, R) {
          return b = c(Z, S, R), !b;
        }), !!b;
      }
      function zA(l, c, b) {
        var Z = 0, S = l == null ? Z : l.length;
        if (typeof c == "number" && c === c && S <= Je) {
          for (; Z < S; ) {
            var R = Z + S >>> 1, D = l[R];
            D !== null && !so(D) && (b ? D <= c : D < c) ? Z = R + 1 : S = R;
          }
          return S;
        }
        return OA(l, c, Tg, b);
      }
      function OA(l, c, b, Z) {
        var S = 0, R = l == null ? 0 : l.length;
        if (R === 0)
          return 0;
        c = b(c);
        for (var D = c !== c, K = c === null, O = so(c), se = c === i; S < R; ) {
          var oe = XA((S + R) / 2), de = b(l[oe]), Fe = de !== i, Me = de === null, it = de === de, Zt = so(de);
          if (D)
            var nt = Z || it;
          else
            se ? nt = it && (Z || Fe) : K ? nt = it && Fe && (Z || !Me) : O ? nt = it && Fe && !Me && (Z || !Zt) : Me || Zt ? nt = !1 : nt = Z ? de <= c : de < c;
          nt ? S = oe + 1 : R = oe;
        }
        return Dn(R, Ee);
      }
      function WG(l, c) {
        for (var b = -1, Z = l.length, S = 0, R = []; ++b < Z; ) {
          var D = l[b], K = c ? c(D) : D;
          if (!b || !$i(K, O)) {
            var O = K;
            R[S++] = D === 0 ? 0 : D;
          }
        }
        return R;
      }
      function SG(l) {
        return typeof l == "number" ? l : so(l) ? Ae : +l;
      }
      function Io(l) {
        if (typeof l == "string")
          return l;
        if (li(l))
          return Wn(l, Io) + "";
        if (so(l))
          return sG ? sG.call(l) : "";
        var c = l + "";
        return c == "0" && 1 / l == -Q ? "-0" : c;
      }
      function tr(l, c, b) {
        var Z = -1, S = VC, R = l.length, D = !0, K = [], O = K;
        if (b)
          D = !1, S = wC;
        else if (R >= g) {
          var se = c ? null : Qv(l);
          if (se)
            return fr(se);
          D = !1, S = Pi, O = new xs();
        } else
          O = c ? [] : K;
        e:
          for (; ++Z < R; ) {
            var oe = l[Z], de = c ? c(oe) : oe;
            if (oe = b || oe !== 0 ? oe : 0, D && de === de) {
              for (var Fe = O.length; Fe--; )
                if (O[Fe] === de)
                  continue e;
              c && O.push(de), K.push(oe);
            } else
              S(O, de, b) || (O !== K && O.push(de), K.push(oe));
          }
        return K;
      }
      function Lg(l, c) {
        return c = Ks(c, l), l = UG(l, c), l == null || delete l[CI(wr(c))];
      }
      function QA(l, c, b, Z) {
        return Ua(l, c, b(Ma(l, c)), Z);
      }
      function jA(l, c, b, Z) {
        for (var S = l.length, R = Z ? S : -1; (Z ? R-- : ++R < S) && c(l[R], R, l); )
          ;
        return b ? ko(l, Z ? 0 : R, Z ? R + 1 : S) : ko(l, Z ? R + 1 : 0, Z ? S : R);
      }
      function _A(l, c) {
        var b = l;
        return b instanceof Vi && (b = b.value()), fA(c, function(Z, S) {
          return S.func.apply(S.thisArg, go([Z], S.args));
        }, b);
      }
      function hp(l, c, b) {
        var Z = l.length;
        if (Z < 2)
          return Z ? tr(l[0]) : [];
        for (var S = -1, R = X(Z); ++S < Z; )
          for (var D = l[S], K = -1; ++K < Z; )
            K != S && (R[S] = Ta(R[S] || D, l[K], c, b));
        return tr(pg(R, 1), c, b);
      }
      function _c(l, c, b) {
        for (var Z = -1, S = l.length, R = c.length, D = {}; ++Z < S; ) {
          var K = Z < R ? c[Z] : i;
          b(D, l[Z], K);
        }
        return D;
      }
      function $A(l) {
        return eg(l) ? l : [];
      }
      function qA(l) {
        return typeof l == "function" ? l : Tg;
      }
      function Ks(l, c) {
        return li(l) ? l : Rp(l, c) ? [l] : Dp(Ki(l));
      }
      var Lv = bi;
      function Es(l, c, b) {
        var Z = l.length;
        return b = b === i ? Z : b, !c && b >= Z ? l : ko(l, c, b);
      }
      var VG = pv || function(l) {
        return ut.clearTimeout(l);
      };
      function pp(l, c) {
        if (c)
          return l.slice();
        var b = l.length, Z = tG ? tG(b) : new l.constructor(b);
        return l.copy(Z), Z;
      }
      function eb(l) {
        var c = new l.constructor(l.byteLength);
        return new wA(c).set(new wA(l)), c;
      }
      function Tv(l, c) {
        var b = c ? eb(l.buffer) : l.buffer;
        return new l.constructor(b, l.byteOffset, l.byteLength);
      }
      function Bp(l) {
        var c = new l.constructor(l.source, We.exec(l));
        return c.lastIndex = l.lastIndex, c;
      }
      function wG(l) {
        return La ? ji(La.call(l)) : {};
      }
      function Zp(l, c) {
        var b = c ? eb(l.buffer) : l.buffer;
        return new l.constructor(b, l.byteOffset, l.length);
      }
      function LC(l, c) {
        if (l !== c) {
          var b = l !== i, Z = l === null, S = l === l, R = so(l), D = c !== i, K = c === null, O = c === c, se = so(c);
          if (!K && !se && !R && l > c || R && D && O && !K && !se || Z && D && O || !b && O || !S)
            return 1;
          if (!Z && !R && !se && l < c || se && b && S && !Z && !R || K && b && S || !D && S || !O)
            return -1;
        }
        return 0;
      }
      function _I(l, c, b) {
        for (var Z = -1, S = l.criteria, R = c.criteria, D = S.length, K = b.length; ++Z < D; ) {
          var O = LC(S[Z], R[Z]);
          if (O) {
            if (Z >= K)
              return O;
            var se = b[Z];
            return O * (se == "desc" ? -1 : 1);
          }
        }
        return l.index - c.index;
      }
      function Ns(l, c, b, Z) {
        for (var S = -1, R = l.length, D = b.length, K = -1, O = c.length, se = hg(R - D, 0), oe = X(O + se), de = !Z; ++K < O; )
          oe[K] = c[K];
        for (; ++S < D; )
          (de || S < R) && (oe[b[S]] = l[S]);
        for (; se--; )
          oe[K++] = l[S++];
        return oe;
      }
      function vG(l, c, b, Z) {
        for (var S = -1, R = l.length, D = -1, K = b.length, O = -1, se = c.length, oe = hg(R - K, 0), de = X(oe + se), Fe = !Z; ++S < oe; )
          de[S] = l[S];
        for (var Me = S; ++O < se; )
          de[Me + O] = c[O];
        for (; ++D < K; )
          (Fe || S < R) && (de[Me + b[D]] = l[S++]);
        return de;
      }
      function yr(l, c) {
        var b = -1, Z = l.length;
        for (c || (c = X(Z)); ++b < Z; )
          c[b] = l[b];
        return c;
      }
      function $I(l, c, b, Z) {
        var S = !b;
        b || (b = {});
        for (var R = -1, D = c.length; ++R < D; ) {
          var K = c[R], O = Z ? Z(b[K], l[K], K, b, l) : i;
          O === i && (O = l[K]), S ? PI(b, K, O) : $g(b, K, O);
        }
        return b;
      }
      function Mv(l, c) {
        return $I(l, ob(l), c);
      }
      function Uv(l, c) {
        return $I(l, EG(l), c);
      }
      function tb(l, c) {
        return function(b, Z) {
          var S = li(b) ? Ya : xA, R = c ? c() : {};
          return S(b, l, ri(Z, 2), R);
        };
      }
      function $c(l) {
        return bi(function(c, b) {
          var Z = -1, S = b.length, R = S > 1 ? b[S - 1] : i, D = S > 2 ? b[2] : i;
          for (R = l.length > 3 && typeof R == "function" ? (S--, R) : i, D && Sr(b[0], b[1], D) && (R = S < 3 ? i : R, S = 1), c = ji(c); ++Z < S; ) {
            var K = b[Z];
            K && l(c, K, Z, R);
          }
          return c;
        });
      }
      function RG(l, c) {
        return function(b, Z) {
          if (b == null)
            return b;
          if (!gr(b))
            return l(b, Z);
          for (var S = b.length, R = c ? S : -1, D = ji(b); (c ? R-- : ++R < S) && Z(D[R], R, D) !== !1; )
            ;
          return b;
        };
      }
      function XG(l) {
        return function(c, b, Z) {
          for (var S = -1, R = ji(c), D = Z(c), K = D.length; K--; ) {
            var O = D[l ? K : ++S];
            if (b(R[O], O, R) === !1)
              break;
          }
          return c;
        };
      }
      function Pv(l, c, b) {
        var Z = c & B, S = qc(l);
        function R() {
          var D = this && this !== ut && this instanceof R ? S : l;
          return D.apply(Z ? b : this, arguments);
        }
        return R;
      }
      function fp(l) {
        return function(c) {
          c = Ki(c);
          var b = Ec(c) ? vo(c) : i, Z = b ? b[0] : c.charAt(0), S = b ? Es(b, 1).join("") : c.slice(1);
          return Z[l]() + S;
        };
      }
      function Pa(l) {
        return function(c) {
          return fA(Hy(vy(c).replace(WC, "")), l, "");
        };
      }
      function qc(l) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new l();
            case 1:
              return new l(c[0]);
            case 2:
              return new l(c[0], c[1]);
            case 3:
              return new l(c[0], c[1], c[2]);
            case 4:
              return new l(c[0], c[1], c[2], c[3]);
            case 5:
              return new l(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var b = Mc(l.prototype), Z = l.apply(b, c);
          return Nn(Z) ? Z : b;
        };
      }
      function zv(l, c, b) {
        var Z = qc(l);
        function S() {
          for (var R = arguments.length, D = X(R), K = R, O = ed(S); K--; )
            D[K] = arguments[K];
          var se = R < 3 && D[0] !== O && D[R - 1] !== O ? [] : LI(D, O);
          if (R -= se.length, R < b)
            return xG(
              l,
              c,
              TC,
              S.placeholder,
              i,
              D,
              se,
              i,
              i,
              b - R
            );
          var oe = this && this !== ut && this instanceof S ? Z : l;
          return Ui(oe, this, D);
        }
        return S;
      }
      function HG(l) {
        return function(c, b, Z) {
          var S = ji(c);
          if (!gr(c)) {
            var R = ri(b, 3);
            c = Hg(c), b = function(K) {
              return R(S[K], K, S);
            };
          }
          var D = l(c, b, Z);
          return D > -1 ? S[R ? c[D] : D] : i;
        };
      }
      function kG(l) {
        return Ll(function(c) {
          var b = c.length, Z = b, S = Ho.prototype.thru;
          for (l && c.reverse(); Z--; ) {
            var R = c[Z];
            if (typeof R != "function")
              throw new Ro(o);
            if (S && !D && gb(R) == "wrapper")
              var D = new Ho([], !0);
          }
          for (Z = D ? Z : b; ++Z < b; ) {
            R = c[Z];
            var K = gb(R), O = K == "wrapper" ? Vp(R) : i;
            O && Xp(O[0]) && O[1] == (v | y | V | H) && !O[4].length && O[9] == 1 ? D = D[gb(O[0])].apply(D, O[3]) : D = R.length == 1 && Xp(R) ? D[K]() : D.thru(R);
          }
          return function() {
            var se = arguments, oe = se[0];
            if (D && se.length == 1 && li(oe))
              return D.plant(oe).value();
            for (var de = 0, Fe = b ? c[de].apply(this, se) : oe; ++de < b; )
              Fe = c[de].call(this, Fe);
            return Fe;
          };
        });
      }
      function TC(l, c, b, Z, S, R, D, K, O, se) {
        var oe = c & v, de = c & B, Fe = c & f, Me = c & (y | W), it = c & x, Zt = Fe ? i : qc(l);
        function nt() {
          for (var vt = arguments.length, Rt = X(vt), an = vt; an--; )
            Rt[an] = arguments[an];
          if (Me)
            var cn = ed(nt), lg = ov(Rt, cn);
          if (Z && (Rt = Ns(Rt, Z, S, Me)), R && (Rt = vG(Rt, R, D, Me)), vt -= lg, Me && vt < se) {
            var Bi = LI(Rt, cn);
            return xG(
              l,
              c,
              TC,
              nt.placeholder,
              b,
              Rt,
              Bi,
              K,
              O,
              se - vt
            );
          }
          var On = de ? b : this, ao = Fe ? On[l] : l;
          return vt = Rt.length, K ? Rt = aR(Rt, K) : it && vt > 1 && Rt.reverse(), oe && O < vt && (Rt.length = O), this && this !== ut && this instanceof nt && (ao = Zt || qc(ao)), ao.apply(On, Rt);
        }
        return nt;
      }
      function FG(l, c) {
        return function(b, Z) {
          return zc(b, l, c(Z), {});
        };
      }
      function ib(l, c) {
        return function(b, Z) {
          var S;
          if (b === i && Z === i)
            return c;
          if (b !== i && (S = b), Z !== i) {
            if (S === i)
              return Z;
            typeof b == "string" || typeof Z == "string" ? (b = Io(b), Z = Io(Z)) : (b = SG(b), Z = SG(Z)), S = l(b, Z);
          }
          return S;
        };
      }
      function Gp(l) {
        return Ll(function(c) {
          return c = Wn(c, ro(ri())), bi(function(b) {
            var Z = this;
            return l(c, function(S) {
              return Ui(S, Z, b);
            });
          });
        });
      }
      function Wr(l, c) {
        c = c === i ? " " : Io(c);
        var b = c.length;
        if (b < 2)
          return b ? jc(c, l) : c;
        var Z = jc(c, RA(l / xa(c)));
        return Ec(c) ? Es(vo(Z), 0, l).join("") : Z.slice(0, l);
      }
      function Ov(l, c, b, Z) {
        var S = c & B, R = qc(l);
        function D() {
          for (var K = -1, O = arguments.length, se = -1, oe = Z.length, de = X(oe + O), Fe = this && this !== ut && this instanceof D ? R : l; ++se < oe; )
            de[se] = Z[se];
          for (; O--; )
            de[se++] = arguments[++K];
          return Ui(Fe, S ? b : this, de);
        }
        return D;
      }
      function YG(l) {
        return function(c, b, Z) {
          return Z && typeof Z != "number" && Sr(c, b, Z) && (b = Z = i), c = hn(c), b === i ? (b = c, c = 0) : b = hn(b), Z = Z === i ? c < b ? 1 : -1 : hn(Z), mp(c, b, Z, l);
        };
      }
      function MC(l) {
        return function(c, b) {
          return typeof c == "string" && typeof b == "string" || (c = Jo(c), b = Jo(b)), l(c, b);
        };
      }
      function xG(l, c, b, Z, S, R, D, K, O, se) {
        var oe = c & y, de = oe ? D : i, Fe = oe ? i : D, Me = oe ? R : i, it = oe ? i : R;
        c |= oe ? V : w, c &= ~(oe ? w : V), c & G || (c &= ~(B | f));
        var Zt = [
          l,
          c,
          S,
          Me,
          de,
          it,
          Fe,
          K,
          O,
          se
        ], nt = b.apply(i, Zt);
        return Xp(l) && PG(nt, Zt), nt.placeholder = Z, Yp(nt, l, c);
      }
      function yp(l) {
        var c = Ji[l];
        return function(b, Z) {
          if (b = Jo(b), Z = Z == null ? 0 : Dn(Qt(Z), 292), Z && HC(b)) {
            var S = (Ki(b) + "e").split("e"), R = c(S[0] + "e" + (+S[1] + Z));
            return S = (Ki(R) + "e").split("e"), +(S[0] + "e" + (+S[1] - Z));
          }
          return c(b);
        };
      }
      var Qv = Tc && 1 / fr(new Tc([, -0]))[1] == Q ? function(l) {
        return new Tc(l);
      } : l0;
      function nb(l) {
        return function(c) {
          var b = ir(c);
          return b == ze ? xl(c) : b == xe ? _f(c) : rv(c, l(c));
        };
      }
      function Nl(l, c, b, Z, S, R, D, K) {
        var O = c & f;
        if (!O && typeof l != "function")
          throw new Ro(o);
        var se = Z ? Z.length : 0;
        if (se || (c &= ~(V | w), Z = S = i), D = D === i ? D : hg(Qt(D), 0), K = K === i ? K : Qt(K), se -= S ? S.length : 0, c & w) {
          var oe = Z, de = S;
          Z = S = i;
        }
        var Fe = O ? i : Vp(l), Me = [
          l,
          c,
          b,
          Z,
          S,
          oe,
          de,
          R,
          D,
          K
        ];
        if (Fe && IR(Me, Fe), l = Me[0], c = Me[1], b = Me[2], Z = Me[3], S = Me[4], K = Me[9] = Me[9] === i ? O ? 0 : l.length : hg(Me[9] - se, 0), !K && c & (y | W) && (c &= ~(y | W)), !c || c == B)
          var it = Pv(l, c, b);
        else
          c == y || c == W ? it = zv(l, c, K) : (c == V || c == (B | V)) && !S.length ? it = Ov(l, c, b, Z) : it = TC.apply(i, Me);
        var Zt = Fe ? Js : PG;
        return Yp(Zt(it, Me), l, c);
      }
      function DG(l, c, b, Z) {
        return l === i || $i(l, Nc[b]) && !_i.call(Z, b) ? c : l;
      }
      function JG(l, c, b, Z, S, R) {
        return Nn(l) && Nn(c) && (R.set(c, l), EC(l, c, i, JG, R), R.delete(c)), l;
      }
      function jv(l) {
        return zl(l) ? i : l;
      }
      function KG(l, c, b, Z, S, R) {
        var D = b & m, K = l.length, O = c.length;
        if (K != O && !(D && O > K))
          return !1;
        var se = R.get(l), oe = R.get(c);
        if (se && oe)
          return se == c && oe == l;
        var de = -1, Fe = !0, Me = b & h ? new xs() : i;
        for (R.set(l, c), R.set(c, l); ++de < K; ) {
          var it = l[de], Zt = c[de];
          if (Z)
            var nt = D ? Z(Zt, it, de, c, l, R) : Z(it, Zt, de, l, c, R);
          if (nt !== i) {
            if (nt)
              continue;
            Fe = !1;
            break;
          }
          if (Me) {
            if (!Jh(c, function(vt, Rt) {
              if (!Pi(Me, Rt) && (it === vt || S(it, vt, b, Z, R)))
                return Me.push(Rt);
            })) {
              Fe = !1;
              break;
            }
          } else if (!(it === Zt || S(it, Zt, b, Z, R))) {
            Fe = !1;
            break;
          }
        }
        return R.delete(l), R.delete(c), Fe;
      }
      function _v(l, c, b, Z, S, R, D) {
        switch (b) {
          case Ge:
            if (l.byteLength != c.byteLength || l.byteOffset != c.byteOffset)
              return !1;
            l = l.buffer, c = c.buffer;
          case Ut:
            return !(l.byteLength != c.byteLength || !R(new wA(l), new wA(c)));
          case Ze:
          case Ke:
          case tt:
            return $i(+l, +c);
          case rt:
            return l.name == c.name && l.message == c.message;
          case Ce:
          case Le:
            return l == c + "";
          case ze:
            var K = xl;
          case xe:
            var O = Z & m;
            if (K || (K = fr), l.size != c.size && !O)
              return !1;
            var se = D.get(l);
            if (se)
              return se == c;
            Z |= h, D.set(l, c);
            var oe = KG(K(l), K(c), Z, S, R, D);
            return D.delete(l), oe;
          case Ye:
            if (La)
              return La.call(l) == La.call(c);
        }
        return !1;
      }
      function $v(l, c, b, Z, S, R) {
        var D = b & m, K = Wp(l), O = K.length, se = Wp(c), oe = se.length;
        if (O != oe && !D)
          return !1;
        for (var de = O; de--; ) {
          var Fe = K[de];
          if (!(D ? Fe in c : _i.call(c, Fe)))
            return !1;
        }
        var Me = R.get(l), it = R.get(c);
        if (Me && it)
          return Me == c && it == l;
        var Zt = !0;
        R.set(l, c), R.set(c, l);
        for (var nt = D; ++de < O; ) {
          Fe = K[de];
          var vt = l[Fe], Rt = c[Fe];
          if (Z)
            var an = D ? Z(Rt, vt, Fe, c, l, R) : Z(vt, Rt, Fe, l, c, R);
          if (!(an === i ? vt === Rt || S(vt, Rt, b, Z, R) : an)) {
            Zt = !1;
            break;
          }
          nt || (nt = Fe == "constructor");
        }
        if (Zt && !nt) {
          var cn = l.constructor, lg = c.constructor;
          cn != lg && "constructor" in l && "constructor" in c && !(typeof cn == "function" && cn instanceof cn && typeof lg == "function" && lg instanceof lg) && (Zt = !1);
        }
        return R.delete(l), R.delete(c), Zt;
      }
      function Ll(l) {
        return Fp(MG(l, i, Vr), l + "");
      }
      function Wp(l) {
        return sp(l, Hg, ob);
      }
      function Sp(l) {
        return sp(l, vr, EG);
      }
      var Vp = FC ? function(l) {
        return FC.get(l);
      } : l0;
      function gb(l) {
        for (var c = l.name + "", b = Pn[c], Z = _i.call(Pn, c) ? b.length : 0; Z--; ) {
          var S = b[Z], R = S.func;
          if (R == null || R == l)
            return S.name;
        }
        return c;
      }
      function ed(l) {
        var c = _i.call(z, "placeholder") ? z : l;
        return c.placeholder;
      }
      function ri() {
        var l = z.iteratee || o0;
        return l = l === o0 ? TA : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function rb(l, c) {
        var b = l.__data__;
        return gR(c) ? b[typeof c == "string" ? "string" : "hash"] : b.map;
      }
      function wp(l) {
        for (var c = Hg(l), b = c.length; b--; ) {
          var Z = c[b], S = l[Z];
          c[b] = [Z, S, Hp(S)];
        }
        return c;
      }
      function za(l, c) {
        var b = jf(l, c);
        return cp(b) ? b : i;
      }
      function vp(l) {
        var c = _i.call(l, Ja), b = l[Ja];
        try {
          l[Ja] = i;
          var Z = !0;
        } catch {
        }
        var S = SA.call(l);
        return Z && (c ? l[Ja] = b : delete l[Ja]), S;
      }
      var ob = RC ? function(l) {
        return l == null ? [] : (l = ji(l), ks(RC(l), function(c) {
          return nG.call(l, c);
        }));
      } : a0, EG = RC ? function(l) {
        for (var c = []; l; )
          go(c, ob(l)), l = TI(l);
        return c;
      } : a0, ir = qg;
      (HA && ir(new HA(new ArrayBuffer(1))) != Ge || Lc && ir(new Lc()) != ze || Ea && ir(Ea.resolve()) != ie || Tc && ir(new Tc()) != xe || Ys && ir(new Ys()) != Yt) && (ir = function(l) {
        var c = qg(l), b = c == Kt ? l.constructor : i, Z = b ? Oa(b) : "";
        if (Z)
          switch (Z) {
            case MI:
              return Ge;
            case _h:
              return ze;
            case kA:
              return ie;
            case Na:
              return xe;
            case lG:
              return Yt;
          }
        return c;
      });
      function NG(l, c, b) {
        for (var Z = -1, S = b.length; ++Z < S; ) {
          var R = b[Z], D = R.size;
          switch (R.type) {
            case "drop":
              l += D;
              break;
            case "dropRight":
              c -= D;
              break;
            case "take":
              c = Dn(c, l + D);
              break;
            case "takeRight":
              l = hg(l, c - D);
              break;
          }
        }
        return { start: l, end: c };
      }
      function qv(l) {
        var c = l.match(sn);
        return c ? c[1].split(bg) : [];
      }
      function UC(l, c, b) {
        c = Ks(c, l);
        for (var Z = -1, S = c.length, R = !1; ++Z < S; ) {
          var D = CI(c[Z]);
          if (!(R = l != null && b(l, D)))
            break;
          l = l[D];
        }
        return R || ++Z != S ? R : (S = l == null ? 0 : l.length, !!S && Bb(S) && Tl(D, S) && (li(l) || Ls(l)));
      }
      function eR(l) {
        var c = l.length, b = new l.constructor(c);
        return c && typeof l[0] == "string" && _i.call(l, "index") && (b.index = l.index, b.input = l.input), b;
      }
      function LG(l) {
        return typeof l.constructor == "function" && !td(l) ? Mc(TI(l)) : {};
      }
      function tR(l, c, b) {
        var Z = l.constructor;
        switch (c) {
          case Ut:
            return eb(l);
          case Ze:
          case Ke:
            return new Z(+l);
          case Ge:
            return Tv(l, b);
          case pe:
          case _e:
          case Gt:
          case Jt:
          case Te:
          case Xt:
          case Pe:
          case Oe:
          case kt:
            return Zp(l, b);
          case ze:
            return new Z();
          case tt:
          case Le:
            return new Z(l);
          case Ce:
            return Bp(l);
          case xe:
            return new Z();
          case Ye:
            return wG(l);
        }
      }
      function iR(l, c) {
        var b = c.length;
        if (!b)
          return l;
        var Z = b - 1;
        return c[Z] = (b > 1 ? "& " : "") + c[Z], c = c.join(b > 2 ? ", " : " "), l.replace(Ag, `{
/* [wrapped with ` + c + `] */
`);
      }
      function nR(l) {
        return li(l) || Ls(l) || !!(gG && l && l[gG]);
      }
      function Tl(l, c) {
        var b = typeof l;
        return c = c ?? te, !!c && (b == "number" || b != "symbol" && oi.test(l)) && l > -1 && l % 1 == 0 && l < c;
      }
      function Sr(l, c, b) {
        if (!Nn(b))
          return !1;
        var Z = typeof c;
        return (Z == "number" ? gr(b) && Tl(c, b.length) : Z == "string" && c in b) ? $i(b[c], l) : !1;
      }
      function Rp(l, c) {
        if (li(l))
          return !1;
        var b = typeof l;
        return b == "number" || b == "symbol" || b == "boolean" || l == null || so(l) ? !0 : Ti.test(l) || !ug.test(l) || c != null && l in ji(c);
      }
      function gR(l) {
        var c = typeof l;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? l !== "__proto__" : l === null;
      }
      function Xp(l) {
        var c = gb(l), b = z[c];
        if (typeof b != "function" || !(c in Vi.prototype))
          return !1;
        if (l === b)
          return !0;
        var Z = Vp(b);
        return !!Z && l === Z[0];
      }
      function rR(l) {
        return !!eG && eG in l;
      }
      var oR = WA ? Do : c0;
      function td(l) {
        var c = l && l.constructor, b = typeof c == "function" && c.prototype || Nc;
        return l === b;
      }
      function Hp(l) {
        return l === l && !Nn(l);
      }
      function TG(l, c) {
        return function(b) {
          return b == null ? !1 : b[l] === c && (c !== i || l in ji(b));
        };
      }
      function Ib(l) {
        var c = _C(l, function(Z) {
          return b.size === a && b.clear(), Z;
        }), b = c.cache;
        return c;
      }
      function IR(l, c) {
        var b = l[1], Z = c[1], S = b | Z, R = S < (B | f | v), D = Z == v && b == y || Z == v && b == H && l[7].length <= c[8] || Z == (v | H) && c[7].length <= c[8] && b == y;
        if (!(R || D))
          return l;
        Z & B && (l[2] = c[2], S |= b & B ? 0 : G);
        var K = c[3];
        if (K) {
          var O = l[3];
          l[3] = O ? Ns(O, K, c[4]) : K, l[4] = O ? LI(l[3], d) : c[4];
        }
        return K = c[5], K && (O = l[5], l[5] = O ? vG(O, K, c[6]) : K, l[6] = O ? LI(l[5], d) : c[6]), K = c[7], K && (l[7] = K), Z & v && (l[8] = l[8] == null ? c[8] : Dn(l[8], c[8])), l[9] == null && (l[9] = c[9]), l[0] = c[0], l[1] = S, l;
      }
      function lR(l) {
        var c = [];
        if (l != null)
          for (var b in ji(l))
            c.push(b);
        return c;
      }
      function sR(l) {
        return SA.call(l);
      }
      function MG(l, c, b) {
        return c = hg(c === i ? l.length - 1 : c, 0), function() {
          for (var Z = arguments, S = -1, R = hg(Z.length - c, 0), D = X(R); ++S < R; )
            D[S] = Z[c + S];
          S = -1;
          for (var K = X(c + 1); ++S < c; )
            K[S] = Z[S];
          return K[c] = b(D), Ui(l, this, K);
        };
      }
      function UG(l, c) {
        return c.length < 2 ? l : Ma(l, ko(c, 0, -1));
      }
      function aR(l, c) {
        for (var b = l.length, Z = Dn(c.length, b), S = yr(l); Z--; ) {
          var R = c[Z];
          l[Z] = Tl(R, b) ? S[R] : i;
        }
        return l;
      }
      function kp(l, c) {
        if (!(c === "constructor" && typeof l[c] == "function") && c != "__proto__")
          return l[c];
      }
      var PG = xp(Js), PC = oG || function(l, c) {
        return ut.setTimeout(l, c);
      }, Fp = xp(Ev);
      function Yp(l, c, b) {
        var Z = c + "";
        return Fp(l, iR(Z, lb(qv(Z), b)));
      }
      function xp(l) {
        var c = 0, b = 0;
        return function() {
          var Z = jh(), S = q - (Z - b);
          if (b = Z, S > 0) {
            if (++c >= $)
              return arguments[0];
          } else
            c = 0;
          return l.apply(i, arguments);
        };
      }
      function zC(l, c) {
        var b = -1, Z = l.length, S = Z - 1;
        for (c = c === i ? Z : c; ++b < c; ) {
          var R = NC(b, S), D = l[R];
          l[R] = l[b], l[b] = D;
        }
        return l.length = c, l;
      }
      var Dp = Ib(function(l) {
        var c = [];
        return l.charCodeAt(0) === 46 && c.push(""), l.replace(vi, function(b, Z, S, R) {
          c.push(S ? R.replace(Br, "$1") : Z || b);
        }), c;
      });
      function CI(l) {
        if (typeof l == "string" || so(l))
          return l;
        var c = l + "";
        return c == "0" && 1 / l == -Q ? "-0" : c;
      }
      function Oa(l) {
        if (l != null) {
          try {
            return Xo.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function lb(l, c) {
        return Eg(ve, function(b) {
          var Z = "_." + b[0];
          c & b[1] && !VC(l, Z) && l.push(Z);
        }), l.sort();
      }
      function OC(l) {
        if (l instanceof Vi)
          return l.clone();
        var c = new Ho(l.__wrapped__, l.__chain__);
        return c.__actions__ = yr(l.__actions__), c.__index__ = l.__index__, c.__values__ = l.__values__, c;
      }
      function cR(l, c, b) {
        (b ? Sr(l, c, b) : c === i) ? c = 1 : c = hg(Qt(c), 0);
        var Z = l == null ? 0 : l.length;
        if (!Z || c < 1)
          return [];
        for (var S = 0, R = 0, D = X(RA(Z / c)); S < Z; )
          D[R++] = ko(l, S, S += c);
        return D;
      }
      function dR(l) {
        for (var c = -1, b = l == null ? 0 : l.length, Z = 0, S = []; ++c < b; ) {
          var R = l[c];
          R && (S[Z++] = R);
        }
        return S;
      }
      function CR() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var c = X(l - 1), b = arguments[0], Z = l; Z--; )
          c[Z - 1] = arguments[Z];
        return go(li(b) ? yr(b) : [b], pg(c, 1));
      }
      var uR = bi(function(l, c) {
        return eg(l) ? Ta(l, pg(c, 1, eg, !0)) : [];
      }), AR = bi(function(l, c) {
        var b = wr(c);
        return eg(b) && (b = i), eg(l) ? Ta(l, pg(c, 1, eg, !0), ri(b, 2)) : [];
      }), bR = bi(function(l, c) {
        var b = wr(c);
        return eg(b) && (b = i), eg(l) ? Ta(l, pg(c, 1, eg, !0), i, b) : [];
      });
      function mR(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (c = b || c === i ? 1 : Qt(c), ko(l, c < 0 ? 0 : c, Z)) : [];
      }
      function hR(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (c = b || c === i ? 1 : Qt(c), c = Z - c, ko(l, 0, c < 0 ? 0 : c)) : [];
      }
      function pR(l, c) {
        return l && l.length ? jA(l, ri(c, 3), !0, !0) : [];
      }
      function BR(l, c) {
        return l && l.length ? jA(l, ri(c, 3), !0) : [];
      }
      function ZR(l, c, b, Z) {
        var S = l == null ? 0 : l.length;
        return S ? (b && typeof b != "number" && Sr(l, c, b) && (b = 0, Z = S), Ds(l, c, b, Z)) : [];
      }
      function zG(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = b == null ? 0 : Qt(b);
        return S < 0 && (S = hg(Z + S, 0)), GA(l, ri(c, 3), S);
      }
      function Fo(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = Z - 1;
        return b !== i && (S = Qt(b), S = b < 0 ? hg(Z + S, 0) : Dn(S, Z - 1)), GA(l, ri(c, 3), S, !0);
      }
      function Vr(l) {
        var c = l == null ? 0 : l.length;
        return c ? pg(l, 1) : [];
      }
      function qn(l) {
        var c = l == null ? 0 : l.length;
        return c ? pg(l, Q) : [];
      }
      function fR(l, c) {
        var b = l == null ? 0 : l.length;
        return b ? (c = c === i ? 1 : Qt(c), pg(l, c)) : [];
      }
      function GR(l) {
        for (var c = -1, b = l == null ? 0 : l.length, Z = {}; ++c < b; ) {
          var S = l[c];
          Z[S[0]] = S[1];
        }
        return Z;
      }
      function OG(l) {
        return l && l.length ? l[0] : i;
      }
      function yR(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = b == null ? 0 : Qt(b);
        return S < 0 && (S = hg(Z + S, 0)), Kc(l, c, S);
      }
      function WR(l) {
        var c = l == null ? 0 : l.length;
        return c ? ko(l, 0, -1) : [];
      }
      var Jp = bi(function(l) {
        var c = Wn(l, $A);
        return c.length && c[0] === l[0] ? Pc(c) : [];
      }), SR = bi(function(l) {
        var c = wr(l), b = Wn(l, $A);
        return c === wr(b) ? c = i : b.pop(), b.length && b[0] === l[0] ? Pc(b, ri(c, 2)) : [];
      }), Ml = bi(function(l) {
        var c = wr(l), b = Wn(l, $A);
        return c = typeof c == "function" ? c : i, c && b.pop(), b.length && b[0] === l[0] ? Pc(b, i, c) : [];
      });
      function QG(l, c) {
        return l == null ? "" : Bv.call(l, c);
      }
      function wr(l) {
        var c = l == null ? 0 : l.length;
        return c ? l[c - 1] : i;
      }
      function En(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = Z;
        return b !== i && (S = Qt(b), S = S < 0 ? hg(Z + S, 0) : Dn(S, Z - 1)), c === c ? qf(l, c, S) : GA(l, Eh, S, !0);
      }
      function zn(l, c) {
        return l && l.length ? Cp(l, Qt(c)) : i;
      }
      var VR = bi(jG);
      function jG(l, c) {
        return l && l.length && c && c.length ? bp(l, c) : l;
      }
      function wR(l, c, b) {
        return l && l.length && c && c.length ? bp(l, c, ri(b, 2)) : l;
      }
      function vR(l, c, b) {
        return l && l.length && c && c.length ? bp(l, c, i, b) : l;
      }
      var RR = Ll(function(l, c) {
        var b = l == null ? 0 : l.length, Z = Gr(l, c);
        return jI(l, Wn(c, function(S) {
          return Tl(S, b) ? +S : S;
        }).sort(LC)), Z;
      });
      function XR(l, c) {
        var b = [];
        if (!(l && l.length))
          return b;
        var Z = -1, S = [], R = l.length;
        for (c = ri(c, 3); ++Z < R; ) {
          var D = l[Z];
          c(D, Z, l) && (b.push(D), S.push(Z));
        }
        return jI(l, S), b;
      }
      function sb(l) {
        return l == null ? l : Zv.call(l);
      }
      function QC(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (b && typeof b != "number" && Sr(l, c, b) ? (c = 0, b = Z) : (c = c == null ? 0 : Qt(c), b = b === i ? Z : Qt(b)), ko(l, c, b)) : [];
      }
      function HR(l, c) {
        return zA(l, c);
      }
      function ab(l, c, b) {
        return OA(l, c, ri(b, 2));
      }
      function lo(l, c) {
        var b = l == null ? 0 : l.length;
        if (b) {
          var Z = zA(l, c);
          if (Z < b && $i(l[Z], c))
            return Z;
        }
        return -1;
      }
      function kR(l, c) {
        return zA(l, c, !0);
      }
      function FR(l, c, b) {
        return OA(l, c, ri(b, 2), !0);
      }
      function YR(l, c) {
        var b = l == null ? 0 : l.length;
        if (b) {
          var Z = zA(l, c, !0) - 1;
          if ($i(l[Z], c))
            return Z;
        }
        return -1;
      }
      function _G(l) {
        return l && l.length ? WG(l) : [];
      }
      function Ul(l, c) {
        return l && l.length ? WG(l, ri(c, 2)) : [];
      }
      function Wi(l) {
        var c = l == null ? 0 : l.length;
        return c ? ko(l, 1, c) : [];
      }
      function $G(l, c, b) {
        return l && l.length ? (c = b || c === i ? 1 : Qt(c), ko(l, 0, c < 0 ? 0 : c)) : [];
      }
      function Yo(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (c = b || c === i ? 1 : Qt(c), c = Z - c, ko(l, c < 0 ? 0 : c, Z)) : [];
      }
      function qG(l, c) {
        return l && l.length ? jA(l, ri(c, 3), !1, !0) : [];
      }
      function xR(l, c) {
        return l && l.length ? jA(l, ri(c, 3)) : [];
      }
      var zi = bi(function(l) {
        return tr(pg(l, 1, eg, !0));
      }), DR = bi(function(l) {
        var c = wr(l);
        return eg(c) && (c = i), tr(pg(l, 1, eg, !0), ri(c, 2));
      }), JR = bi(function(l) {
        var c = wr(l);
        return c = typeof c == "function" ? c : i, tr(pg(l, 1, eg, !0), i, c);
      });
      function KR(l) {
        return l && l.length ? tr(l) : [];
      }
      function ER(l, c) {
        return l && l.length ? tr(l, ri(c, 2)) : [];
      }
      function NR(l, c) {
        return c = typeof c == "function" ? c : i, l && l.length ? tr(l, i, c) : [];
      }
      function Kp(l) {
        if (!(l && l.length))
          return [];
        var c = 0;
        return l = ks(l, function(b) {
          if (eg(b))
            return c = hg(b.length, c), !0;
        }), Uh(c, function(b) {
          return Wn(l, Nh(b));
        });
      }
      function ey(l, c) {
        if (!(l && l.length))
          return [];
        var b = Kp(l);
        return c == null ? b : Wn(b, function(Z) {
          return Ui(c, i, Z);
        });
      }
      var LR = bi(function(l, c) {
        return eg(l) ? Ta(l, c) : [];
      }), TR = bi(function(l) {
        return hp(ks(l, eg));
      }), Ep = bi(function(l) {
        var c = wr(l);
        return eg(c) && (c = i), hp(ks(l, eg), ri(c, 2));
      }), MR = bi(function(l) {
        var c = wr(l);
        return c = typeof c == "function" ? c : i, hp(ks(l, eg), i, c);
      }), Np = bi(Kp);
      function Xg(l, c) {
        return _c(l || [], c || [], $g);
      }
      function zr(l, c) {
        return _c(l || [], c || [], Ua);
      }
      var UR = bi(function(l) {
        var c = l.length, b = c > 1 ? l[c - 1] : i;
        return b = typeof b == "function" ? (l.pop(), b) : i, ey(l, b);
      });
      function ty(l) {
        var c = z(l);
        return c.__chain__ = !0, c;
      }
      function PR(l, c) {
        return c(l), l;
      }
      function jC(l, c) {
        return c(l);
      }
      var zR = Ll(function(l) {
        var c = l.length, b = c ? l[0] : 0, Z = this.__wrapped__, S = function(R) {
          return Gr(R, l);
        };
        return c > 1 || this.__actions__.length || !(Z instanceof Vi) || !Tl(b) ? this.thru(S) : (Z = Z.slice(b, +b + (c ? 1 : 0)), Z.__actions__.push({
          func: jC,
          args: [S],
          thisArg: i
        }), new Ho(Z, this.__chain__).thru(function(R) {
          return c && !R.length && R.push(i), R;
        }));
      });
      function OR() {
        return ty(this);
      }
      function QR() {
        return new Ho(this.value(), this.__chain__);
      }
      function jR() {
        this.__values__ === i && (this.__values__ = hy(this.value()));
        var l = this.__index__ >= this.__values__.length, c = l ? i : this.__values__[this.__index__++];
        return { done: l, value: c };
      }
      function _R() {
        return this;
      }
      function $R(l) {
        for (var c, b = this; b instanceof Uc; ) {
          var Z = OC(b);
          Z.__index__ = 0, Z.__values__ = i, c ? S.__wrapped__ = Z : c = Z;
          var S = Z;
          b = b.__wrapped__;
        }
        return S.__wrapped__ = l, c;
      }
      function qR() {
        var l = this.__wrapped__;
        if (l instanceof Vi) {
          var c = l;
          return this.__actions__.length && (c = new Vi(this)), c = c.reverse(), c.__actions__.push({
            func: jC,
            args: [sb],
            thisArg: i
          }), new Ho(c, this.__chain__);
        }
        return this.thru(sb);
      }
      function id() {
        return _A(this.__wrapped__, this.__actions__);
      }
      var eX = tb(function(l, c, b) {
        _i.call(l, b) ? ++l[b] : PI(l, b, 1);
      });
      function tX(l, c, b) {
        var Z = li(l) ? ZA : op;
        return b && Sr(l, c, b) && (c = i), Z(l, ri(c, 3));
      }
      function iX(l, c) {
        var b = li(l) ? ks : Ip;
        return b(l, ri(c, 3));
      }
      var nX = HG(zG), iy = HG(Fo);
      function ny(l, c) {
        return pg(cb(l, c), 1);
      }
      function gX(l, c) {
        return pg(cb(l, c), Q);
      }
      function rX(l, c, b) {
        return b = b === i ? 1 : Qt(b), pg(cb(l, c), b);
      }
      function gy(l, c) {
        var b = li(l) ? Eg : Kl;
        return b(l, ri(c, 3));
      }
      function ry(l, c) {
        var b = li(l) ? BA : JA;
        return b(l, ri(c, 3));
      }
      var oX = tb(function(l, c, b) {
        _i.call(l, b) ? l[b].push(c) : PI(l, b, [c]);
      });
      function IX(l, c, b, Z) {
        l = gr(l) ? l : Id(l), b = b && !Z ? Qt(b) : 0;
        var S = l.length;
        return b < 0 && (b = hg(S + b, 0)), Wb(l) ? b <= S && l.indexOf(c, b) > -1 : !!S && Kc(l, c, b) > -1;
      }
      var lX = bi(function(l, c, b) {
        var Z = -1, S = typeof c == "function", R = gr(l) ? X(l.length) : [];
        return Kl(l, function(D) {
          R[++Z] = S ? Ui(c, D, b) : Oc(D, c, b);
        }), R;
      }), sX = tb(function(l, c, b) {
        PI(l, b, c);
      });
      function cb(l, c) {
        var b = li(l) ? Wn : KC;
        return b(l, ri(c, 3));
      }
      function aX(l, c, b, Z) {
        return l == null ? [] : (li(c) || (c = c == null ? [] : [c]), b = Z ? i : b, li(b) || (b = b == null ? [] : [b]), up(l, c, b));
      }
      var cX = tb(function(l, c, b) {
        l[b ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function dX(l, c, b) {
        var Z = li(l) ? fA : Pf, S = arguments.length < 3;
        return Z(l, ri(c, 4), b, S, Kl);
      }
      function CX(l, c, b) {
        var Z = li(l) ? Nf : Pf, S = arguments.length < 3;
        return Z(l, ri(c, 4), b, S, JA);
      }
      function uX(l, c) {
        var b = li(l) ? ks : Ip;
        return b(l, bb(ri(c, 3)));
      }
      function AX(l) {
        var c = li(l) ? hG : gi;
        return c(l);
      }
      function bX(l, c, b) {
        (b ? Sr(l, c, b) : c === i) ? c = 1 : c = Qt(c);
        var Z = li(l) ? Hv : PA;
        return Z(l, c);
      }
      function mX(l) {
        var c = li(l) ? YC : Nv;
        return c(l);
      }
      function hX(l) {
        if (l == null)
          return 0;
        if (gr(l))
          return Wb(l) ? xa(l) : l.length;
        var c = ir(l);
        return c == ze || c == xe ? l.size : Qc(l).length;
      }
      function pX(l, c, b) {
        var Z = li(l) ? Jh : yG;
        return b && Sr(l, c, b) && (c = i), Z(l, ri(c, 3));
      }
      var oy = bi(function(l, c) {
        if (l == null)
          return [];
        var b = c.length;
        return b > 1 && Sr(l, c[0], c[1]) ? c = [] : b > 2 && Sr(c[0], c[1], c[2]) && (c = [c[0]]), up(l, pg(c, 1), []);
      }), db = rG || function() {
        return ut.Date.now();
      };
      function BX(l, c) {
        if (typeof c != "function")
          throw new Ro(o);
        return l = Qt(l), function() {
          if (--l < 1)
            return c.apply(this, arguments);
        };
      }
      function Cb(l, c, b) {
        return c = b ? i : c, c = l && c == null ? l.length : c, Nl(l, v, i, i, i, i, c);
      }
      function Iy(l, c) {
        var b;
        if (typeof c != "function")
          throw new Ro(o);
        return l = Qt(l), function() {
          return --l > 0 && (b = c.apply(this, arguments)), l <= 1 && (c = i), b;
        };
      }
      var nr = bi(function(l, c, b) {
        var Z = B;
        if (b.length) {
          var S = LI(b, ed(nr));
          Z |= V;
        }
        return Nl(l, Z, c, b, S);
      }), ub = bi(function(l, c, b) {
        var Z = B | f;
        if (b.length) {
          var S = LI(b, ed(ub));
          Z |= V;
        }
        return Nl(c, Z, l, b, S);
      });
      function ly(l, c, b) {
        c = b ? i : c;
        var Z = Nl(l, y, i, i, i, i, i, c);
        return Z.placeholder = ly.placeholder, Z;
      }
      function sy(l, c, b) {
        c = b ? i : c;
        var Z = Nl(l, W, i, i, i, i, i, c);
        return Z.placeholder = sy.placeholder, Z;
      }
      function Ab(l, c, b) {
        var Z, S, R, D, K, O, se = 0, oe = !1, de = !1, Fe = !0;
        if (typeof l != "function")
          throw new Ro(o);
        c = Jo(c) || 0, Nn(b) && (oe = !!b.leading, de = "maxWait" in b, R = de ? hg(Jo(b.maxWait) || 0, c) : R, Fe = "trailing" in b ? !!b.trailing : Fe);
        function Me(Bi) {
          var On = Z, ao = S;
          return Z = S = i, se = Bi, D = l.apply(ao, On), D;
        }
        function it(Bi) {
          return se = Bi, K = PC(vt, c), oe ? Me(Bi) : D;
        }
        function Zt(Bi) {
          var On = Bi - O, ao = Bi - se, C0 = c - On;
          return de ? Dn(C0, R - ao) : C0;
        }
        function nt(Bi) {
          var On = Bi - O, ao = Bi - se;
          return O === i || On >= c || On < 0 || de && ao >= R;
        }
        function vt() {
          var Bi = db();
          if (nt(Bi))
            return Rt(Bi);
          K = PC(vt, Zt(Bi));
        }
        function Rt(Bi) {
          return K = i, Fe && Z ? Me(Bi) : (Z = S = i, D);
        }
        function an() {
          K !== i && VG(K), se = 0, Z = O = S = K = i;
        }
        function cn() {
          return K === i ? D : Rt(db());
        }
        function lg() {
          var Bi = db(), On = nt(Bi);
          if (Z = arguments, S = this, O = Bi, On) {
            if (K === i)
              return it(O);
            if (de)
              return VG(K), K = PC(vt, c), Me(O);
          }
          return K === i && (K = PC(vt, c)), D;
        }
        return lg.cancel = an, lg.flush = cn, lg;
      }
      var ZX = bi(function(l, c) {
        return rp(l, 1, c);
      }), Lp = bi(function(l, c, b) {
        return rp(l, Jo(c) || 0, b);
      });
      function fX(l) {
        return Nl(l, x);
      }
      function _C(l, c) {
        if (typeof l != "function" || c != null && typeof c != "function")
          throw new Ro(o);
        var b = function() {
          var Z = arguments, S = c ? c.apply(this, Z) : Z[0], R = b.cache;
          if (R.has(S))
            return R.get(S);
          var D = l.apply(this, Z);
          return b.cache = R.set(S, D) || R, D;
        };
        return b.cache = new (_C.Cache || UI)(), b;
      }
      _C.Cache = UI;
      function bb(l) {
        if (typeof l != "function")
          throw new Ro(o);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, c[0]);
            case 2:
              return !l.call(this, c[0], c[1]);
            case 3:
              return !l.call(this, c[0], c[1], c[2]);
          }
          return !l.apply(this, c);
        };
      }
      function Tp(l) {
        return Iy(2, l);
      }
      var Mp = Lv(function(l, c) {
        c = c.length == 1 && li(c[0]) ? Wn(c[0], ro(ri())) : Wn(pg(c, 1), ro(ri()));
        var b = c.length;
        return bi(function(Z) {
          for (var S = -1, R = Dn(Z.length, b); ++S < R; )
            Z[S] = c[S].call(this, Z[S]);
          return Ui(l, this, Z);
        });
      }), Up = bi(function(l, c) {
        var b = LI(c, ed(Up));
        return Nl(l, V, i, c, b);
      }), ay = bi(function(l, c) {
        var b = LI(c, ed(ay));
        return Nl(l, w, i, c, b);
      }), GX = Ll(function(l, c) {
        return Nl(l, H, i, i, i, c);
      });
      function yX(l, c) {
        if (typeof l != "function")
          throw new Ro(o);
        return c = c === i ? c : Qt(c), bi(l, c);
      }
      function WX(l, c) {
        if (typeof l != "function")
          throw new Ro(o);
        return c = c == null ? 0 : hg(Qt(c), 0), bi(function(b) {
          var Z = b[c], S = Es(b, 0, c);
          return Z && go(S, Z), Ui(l, this, S);
        });
      }
      function SX(l, c, b) {
        var Z = !0, S = !0;
        if (typeof l != "function")
          throw new Ro(o);
        return Nn(b) && (Z = "leading" in b ? !!b.leading : Z, S = "trailing" in b ? !!b.trailing : S), Ab(l, c, {
          leading: Z,
          maxWait: c,
          trailing: S
        });
      }
      function VX(l) {
        return Cb(l, 1);
      }
      function wX(l, c) {
        return Up(qA(c), l);
      }
      function vX() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return li(l) ? l : [l];
      }
      function RX(l) {
        return Pr(l, A);
      }
      function XX(l, c) {
        return c = typeof c == "function" ? c : i, Pr(l, A, c);
      }
      function HX(l) {
        return Pr(l, C | A);
      }
      function kX(l, c) {
        return c = typeof c == "function" ? c : i, Pr(l, C | A, c);
      }
      function FX(l, c) {
        return c == null || xC(l, c, Hg(c));
      }
      function $i(l, c) {
        return l === c || l !== l && c !== c;
      }
      var mb = MC(er), Pp = MC(function(l, c) {
        return l >= c;
      }), Ls = ap(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ap : function(l) {
        return Xn(l) && _i.call(l, "callee") && !nG.call(l, "callee");
      }, li = X.isArray, Rn = vn ? ro(vn) : Yv;
      function gr(l) {
        return l != null && Bb(l.length) && !Do(l);
      }
      function eg(l) {
        return Xn(l) && gr(l);
      }
      function xo(l) {
        return l === !0 || l === !1 || Xn(l) && qg(l) == Ze;
      }
      var uI = XC || c0, YX = Ot ? ro(Ot) : fG;
      function nd(l) {
        return Xn(l) && l.nodeType === 1 && !zl(l);
      }
      function hb(l) {
        if (l == null)
          return !0;
        if (gr(l) && (li(l) || typeof l == "string" || typeof l.splice == "function" || uI(l) || Ql(l) || Ls(l)))
          return !l.length;
        var c = ir(l);
        if (c == ze || c == xe)
          return !l.size;
        if (td(l))
          return !Qc(l).length;
        for (var b in l)
          if (_i.call(l, b))
            return !1;
        return !0;
      }
      function pb(l, c) {
        return QI(l, c);
      }
      function qi(l, c, b) {
        b = typeof b == "function" ? b : i;
        var Z = b ? b(l, c) : i;
        return Z === i ? QI(l, c, i, b) : !!Z;
      }
      function zp(l) {
        if (!Xn(l))
          return !1;
        var c = qg(l);
        return c == rt || c == $e || typeof l.message == "string" && typeof l.name == "string" && !zl(l);
      }
      function cy(l) {
        return typeof l == "number" && HC(l);
      }
      function Do(l) {
        if (!Nn(l))
          return !1;
        var c = qg(l);
        return c == dt || c == ot || c == Xe || c == J;
      }
      function dy(l) {
        return typeof l == "number" && l == Qt(l);
      }
      function Bb(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= te;
      }
      function Nn(l) {
        var c = typeof l;
        return l != null && (c == "object" || c == "function");
      }
      function Xn(l) {
        return l != null && typeof l == "object";
      }
      var Pl = yi ? ro(yi) : xv;
      function Zb(l, c) {
        return l === c || EA(l, c, wp(c));
      }
      function Cy(l, c, b) {
        return b = typeof b == "function" ? b : i, EA(l, c, wp(c), b);
      }
      function fb(l) {
        return Op(l) && l != +l;
      }
      function uy(l) {
        if (oR(l))
          throw new It(r);
        return cp(l);
      }
      function Ay(l) {
        return l === null;
      }
      function Gb(l) {
        return l == null;
      }
      function Op(l) {
        return typeof l == "number" || Xn(l) && qg(l) == tt;
      }
      function zl(l) {
        if (!Xn(l) || qg(l) != Kt)
          return !1;
        var c = TI(l);
        if (c === null)
          return !0;
        var b = _i.call(c, "constructor") && c.constructor;
        return typeof b == "function" && b instanceof b && Xo.call(b) == mv;
      }
      var Ol = og ? ro(og) : NA;
      function yb(l) {
        return dy(l) && l >= -te && l <= te;
      }
      var by = Un ? ro(Un) : GG;
      function Wb(l) {
        return typeof l == "string" || !li(l) && Xn(l) && qg(l) == Le;
      }
      function so(l) {
        return typeof l == "symbol" || Xn(l) && qg(l) == Ye;
      }
      var Ql = Ig ? ro(Ig) : LA;
      function Sb(l) {
        return l === i;
      }
      function Qp(l) {
        return Xn(l) && ir(l) == Yt;
      }
      function xX(l) {
        return Xn(l) && qg(l) == qt;
      }
      var my = MC(MA), DX = MC(function(l, c) {
        return l <= c;
      });
      function hy(l) {
        if (!l)
          return [];
        if (gr(l))
          return Wb(l) ? vo(l) : yr(l);
        if (vC && l[vC])
          return Ph(l[vC]());
        var c = ir(l), b = c == ze ? xl : c == xe ? fr : Id;
        return b(l);
      }
      function hn(l) {
        if (!l)
          return l === 0 ? l : 0;
        if (l = Jo(l), l === Q || l === -Q) {
          var c = l < 0 ? -1 : 1;
          return c * le;
        }
        return l === l ? l : 0;
      }
      function Qt(l) {
        var c = hn(l), b = c % 1;
        return c === c ? b ? c - b : c : 0;
      }
      function py(l) {
        return l ? Ur(Qt(l), 0, we) : 0;
      }
      function Jo(l) {
        if (typeof l == "number")
          return l;
        if (so(l))
          return Ae;
        if (Nn(l)) {
          var c = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = Nn(c) ? c + "" : c;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = zf(l);
        var b = at.test(l);
        return b || Ht.test(l) ? ke(l.slice(2), b ? 2 : 8) : yt.test(l) ? Ae : +l;
      }
      function jp(l) {
        return $I(l, vr(l));
      }
      function JX(l) {
        return l ? Ur(Qt(l), -te, te) : l === 0 ? l : 0;
      }
      function Ki(l) {
        return l == null ? "" : Io(l);
      }
      var $C = $c(function(l, c) {
        if (td(c) || gr(c)) {
          $I(c, Hg(c), l);
          return;
        }
        for (var b in c)
          _i.call(c, b) && $g(l, b, c[b]);
      }), Vb = $c(function(l, c) {
        $I(c, vr(c), l);
      }), jl = $c(function(l, c, b, Z) {
        $I(c, vr(c), l, Z);
      }), qC = $c(function(l, c, b, Z) {
        $I(c, Hg(c), l, Z);
      }), eu = Ll(Gr);
      function wb(l, c) {
        var b = Mc(l);
        return c == null ? b : DA(b, c);
      }
      var gd = bi(function(l, c) {
        l = ji(l);
        var b = -1, Z = c.length, S = Z > 2 ? c[2] : i;
        for (S && Sr(c[0], c[1], S) && (Z = 1); ++b < Z; )
          for (var R = c[b], D = vr(R), K = -1, O = D.length; ++K < O; ) {
            var se = D[K], oe = l[se];
            (oe === i || $i(oe, Nc[se]) && !_i.call(l, se)) && (l[se] = R[se]);
          }
        return l;
      }), KX = bi(function(l) {
        return l.push(i, JG), Ui(qp, i, l);
      });
      function EX(l, c) {
        return Kh(l, ri(c, 3), zI);
      }
      function NX(l, c) {
        return Kh(l, ri(c, 3), KA);
      }
      function LX(l, c) {
        return l == null ? l : lp(l, ri(c, 3), vr);
      }
      function TX(l, c) {
        return l == null ? l : ZG(l, ri(c, 3), vr);
      }
      function vb(l, c) {
        return l && zI(l, ri(c, 3));
      }
      function tu(l, c) {
        return l && KA(l, ri(c, 3));
      }
      function By(l) {
        return l == null ? [] : DC(l, Hg(l));
      }
      function rd(l) {
        return l == null ? [] : DC(l, vr(l));
      }
      function qI(l, c, b) {
        var Z = l == null ? i : Ma(l, c);
        return Z === i ? b : Z;
      }
      function Zy(l, c) {
        return l != null && UC(l, c, OI);
      }
      function iu(l, c) {
        return l != null && UC(l, c, kv);
      }
      var fy = FG(function(l, c, b) {
        c != null && typeof c.toString != "function" && (c = SA.call(c)), l[c] = b;
      }, r0(Tg)), Gy = FG(function(l, c, b) {
        c != null && typeof c.toString != "function" && (c = SA.call(c)), _i.call(l, c) ? l[c].push(b) : l[c] = [b];
      }, ri), MX = bi(Oc);
      function Hg(l) {
        return gr(l) ? wi(l) : Qc(l);
      }
      function vr(l) {
        return gr(l) ? wi(l, !0) : Dv(l);
      }
      function UX(l, c) {
        var b = {};
        return c = ri(c, 3), zI(l, function(Z, S, R) {
          PI(b, c(Z, S, R), Z);
        }), b;
      }
      function _p(l, c) {
        var b = {};
        return c = ri(c, 3), zI(l, function(Z, S, R) {
          PI(b, S, c(Z, S, R));
        }), b;
      }
      var $p = $c(function(l, c, b) {
        EC(l, c, b);
      }), qp = $c(function(l, c, b, Z) {
        EC(l, c, b, Z);
      }), rr = Ll(function(l, c) {
        var b = {};
        if (l == null)
          return b;
        var Z = !1;
        c = Wn(c, function(R) {
          return R = Ks(R, l), Z || (Z = R.length > 1), R;
        }), $I(l, Sp(l), b), Z && (b = Pr(b, C | u | A, jv));
        for (var S = c.length; S--; )
          Lg(b, c[S]);
        return b;
      });
      function PX(l, c) {
        return od(l, bb(ri(c)));
      }
      var yy = Ll(function(l, c) {
        return l == null ? {} : Jv(l, c);
      });
      function od(l, c) {
        if (l == null)
          return {};
        var b = Wn(Sp(l), function(Z) {
          return [Z];
        });
        return c = ri(c), Ap(l, b, function(Z, S) {
          return c(Z, S[0]);
        });
      }
      function e0(l, c, b) {
        c = Ks(c, l);
        var Z = -1, S = c.length;
        for (S || (S = 1, l = i); ++Z < S; ) {
          var R = l == null ? i : l[CI(c[Z])];
          R === i && (Z = S, R = b), l = Do(R) ? R.call(l) : R;
        }
        return l;
      }
      function Wy(l, c, b) {
        return l == null ? l : Ua(l, c, b);
      }
      function zX(l, c, b, Z) {
        return Z = typeof Z == "function" ? Z : i, l == null ? l : Ua(l, c, b, Z);
      }
      var Sy = nb(Hg), Vy = nb(vr);
      function OX(l, c, b) {
        var Z = li(l), S = Z || uI(l) || Ql(l);
        if (c = ri(c, 4), b == null) {
          var R = l && l.constructor;
          S ? b = Z ? new R() : [] : Nn(l) ? b = Do(R) ? Mc(TI(l)) : {} : b = {};
        }
        return (S ? Eg : zI)(l, function(D, K, O) {
          return c(b, D, K, O);
        }), b;
      }
      function QX(l, c) {
        return l == null ? !0 : Lg(l, c);
      }
      function jX(l, c, b) {
        return l == null ? l : QA(l, c, qA(b));
      }
      function _X(l, c, b, Z) {
        return Z = typeof Z == "function" ? Z : i, l == null ? l : QA(l, c, qA(b), Z);
      }
      function Id(l) {
        return l == null ? [] : mn(l, Hg(l));
      }
      function $X(l) {
        return l == null ? [] : mn(l, vr(l));
      }
      function qX(l, c, b) {
        return b === i && (b = c, c = i), b !== i && (b = Jo(b), b = b === b ? b : 0), c !== i && (c = Jo(c), c = c === c ? c : 0), Ur(Jo(l), c, b);
      }
      function eH(l, c, b) {
        return c = hn(c), b === i ? (b = c, c = 0) : b = hn(b), l = Jo(l), Fv(l, c, b);
      }
      function tH(l, c, b) {
        if (b && typeof b != "boolean" && Sr(l, c, b) && (c = b = i), b === i && (typeof c == "boolean" ? (b = c, c = i) : typeof l == "boolean" && (b = l, l = i)), l === i && c === i ? (l = 0, c = 1) : (l = hn(l), c === i ? (c = l, l = 0) : c = hn(c)), l > c) {
          var Z = l;
          l = c, c = Z;
        }
        if (b || l % 1 || c % 1) {
          var S = oo();
          return Dn(l + S * (c - l + be("1e-" + ((S + "").length - 1))), c);
        }
        return NC(l, c);
      }
      var iH = Pa(function(l, c, b) {
        return c = c.toLowerCase(), l + (b ? wy(c) : c);
      });
      function wy(l) {
        return el(Ki(l).toLowerCase());
      }
      function vy(l) {
        return l = Ki(l), l && l.replace(mg, Iv).replace(kh, "");
      }
      function nH(l, c, b) {
        l = Ki(l), c = Io(c);
        var Z = l.length;
        b = b === i ? Z : Ur(Qt(b), 0, Z);
        var S = b;
        return b -= c.length, b >= 0 && l.slice(b, S) == c;
      }
      function gH(l) {
        return l = Ki(l), l && on.test(l) ? l.replace(Zi, lv) : l;
      }
      function rH(l) {
        return l = Ki(l), l && yn.test(l) ? l.replace(ei, "\\$&") : l;
      }
      var oH = Pa(function(l, c, b) {
        return l + (b ? "-" : "") + c.toLowerCase();
      }), IH = Pa(function(l, c, b) {
        return l + (b ? " " : "") + c.toLowerCase();
      }), lH = fp("toLowerCase");
      function sH(l, c, b) {
        l = Ki(l), c = Qt(c);
        var Z = c ? xa(l) : 0;
        if (!c || Z >= c)
          return l;
        var S = (c - Z) / 2;
        return Wr(XA(S), b) + l + Wr(RA(S), b);
      }
      function aH(l, c, b) {
        l = Ki(l), c = Qt(c);
        var Z = c ? xa(l) : 0;
        return c && Z < c ? l + Wr(c - Z, b) : l;
      }
      function cH(l, c, b) {
        l = Ki(l), c = Qt(c);
        var Z = c ? xa(l) : 0;
        return c && Z < c ? Wr(c - Z, b) + l : l;
      }
      function dH(l, c, b) {
        return b || c == null ? c = 0 : c && (c = +c), Ka(Ki(l).replace(Mi, ""), c || 0);
      }
      function CH(l, c, b) {
        return (b ? Sr(l, c, b) : c === i) ? c = 1 : c = Qt(c), jc(Ki(l), c);
      }
      function Rb() {
        var l = arguments, c = Ki(l[0]);
        return l.length < 3 ? c : c.replace(l[1], l[2]);
      }
      var t0 = Pa(function(l, c, b) {
        return l + (b ? "_" : "") + c.toLowerCase();
      });
      function Ry(l, c, b) {
        return b && typeof b != "number" && Sr(l, c, b) && (c = b = i), b = b === i ? we : b >>> 0, b ? (l = Ki(l), l && (typeof c == "string" || c != null && !Ol(c)) && (c = Io(c), !c && Ec(l)) ? Es(vo(l), 0, b) : l.split(c, b)) : [];
      }
      var uH = Pa(function(l, c, b) {
        return l + (b ? " " : "") + el(c);
      });
      function AH(l, c, b) {
        return l = Ki(l), b = b == null ? 0 : Ur(Qt(b), 0, l.length), c = Io(c), l.slice(b, b + c.length) == c;
      }
      function bH(l, c, b) {
        var Z = z.templateSettings;
        b && Sr(l, c, b) && (c = i), l = Ki(l), c = jl({}, c, Z, DG);
        var S = jl({}, c.imports, Z.imports, DG), R = Hg(S), D = mn(S, R), K, O, se = 0, oe = c.interpolate || kl, de = "__p += '", Fe = Qh(
          (c.escape || kl).source + "|" + oe.source + "|" + (oe === ln ? He : kl).source + "|" + (c.evaluate || kl).source + "|$",
          "g"
        ), Me = "//# sourceURL=" + (_i.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Dh + "]") + `
`;
        l.replace(Fe, function(nt, vt, Rt, an, cn, lg) {
          return Rt || (Rt = an), de += l.slice(se, lg).replace(oI, sv), vt && (K = !0, de += `' +
__e(` + vt + `) +
'`), cn && (O = !0, de += `';
` + cn + `;
__p += '`), Rt && (de += `' +
((__t = (` + Rt + `)) == null ? '' : __t) +
'`), se = lg + nt.length, nt;
        }), de += `';
`;
        var it = _i.call(c, "variable") && c.variable;
        if (!it)
          de = `with (obj) {
` + de + `
}
`;
        else if (Mn.test(it))
          throw new It(I);
        de = (O ? de.replace(Nt, "") : de).replace(ni, "$1").replace(si, "$1;"), de = "function(" + (it || "obj") + `) {
` + (it ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (K ? ", __e = _.escape" : "") + (O ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + de + `return __p
}`;
        var Zt = n0(function() {
          return lt(R, Me + "return " + de).apply(i, D);
        });
        if (Zt.source = de, zp(Zt))
          throw Zt;
        return Zt;
      }
      function i0(l) {
        return Ki(l).toLowerCase();
      }
      function Xy(l) {
        return Ki(l).toUpperCase();
      }
      function mH(l, c, b) {
        if (l = Ki(l), l && (b || c === i))
          return zf(l);
        if (!l || !(c = Io(c)))
          return l;
        var Z = vo(l), S = vo(c), R = Of(Z, S), D = Qf(Z, S) + 1;
        return Es(Z, R, D).join("");
      }
      function hH(l, c, b) {
        if (l = Ki(l), l && (b || c === i))
          return l.slice(0, Oh(l) + 1);
        if (!l || !(c = Io(c)))
          return l;
        var Z = vo(l), S = Qf(Z, vo(c)) + 1;
        return Es(Z, 0, S).join("");
      }
      function pH(l, c, b) {
        if (l = Ki(l), l && (b || c === i))
          return l.replace(Mi, "");
        if (!l || !(c = Io(c)))
          return l;
        var Z = vo(l), S = Of(Z, vo(c));
        return Es(Z, S).join("");
      }
      function Qa(l, c) {
        var b = N, Z = M;
        if (Nn(c)) {
          var S = "separator" in c ? c.separator : S;
          b = "length" in c ? Qt(c.length) : b, Z = "omission" in c ? Io(c.omission) : Z;
        }
        l = Ki(l);
        var R = l.length;
        if (Ec(l)) {
          var D = vo(l);
          R = D.length;
        }
        if (b >= R)
          return l;
        var K = b - xa(Z);
        if (K < 1)
          return Z;
        var O = D ? Es(D, 0, K).join("") : l.slice(0, K);
        if (S === i)
          return O + Z;
        if (D && (K += O.length - K), Ol(S)) {
          if (l.slice(K).search(S)) {
            var se, oe = O;
            for (S.global || (S = Qh(S.source, Ki(We.exec(S)) + "g")), S.lastIndex = 0; se = S.exec(oe); )
              var de = se.index;
            O = O.slice(0, de === i ? K : de);
          }
        } else if (l.indexOf(Io(S), K) != K) {
          var Fe = O.lastIndexOf(S);
          Fe > -1 && (O = O.slice(0, Fe));
        }
        return O + Z;
      }
      function pi(l) {
        return l = Ki(l), l && fi.test(l) ? l.replace(jt, av) : l;
      }
      var BH = Pa(function(l, c, b) {
        return l + (b ? " " : "") + c.toUpperCase();
      }), el = fp("toUpperCase");
      function Hy(l, c, b) {
        return l = Ki(l), c = b ? i : c, c === i ? Ng(l) ? Cv(l) : Mf(l) : l.match(c) || [];
      }
      var n0 = bi(function(l, c) {
        try {
          return Ui(l, i, c);
        } catch (b) {
          return zp(b) ? b : new It(b);
        }
      }), g0 = Ll(function(l, c) {
        return Eg(c, function(b) {
          b = CI(b), PI(l, b, nr(l[b], l));
        }), l;
      });
      function ky(l) {
        var c = l == null ? 0 : l.length, b = ri();
        return l = c ? Wn(l, function(Z) {
          if (typeof Z[1] != "function")
            throw new Ro(o);
          return [b(Z[0]), Z[1]];
        }) : [], bi(function(Z) {
          for (var S = -1; ++S < c; ) {
            var R = l[S];
            if (Ui(R[0], this, Z))
              return Ui(R[1], this, Z);
          }
        });
      }
      function ld(l) {
        return BG(Pr(l, C));
      }
      function r0(l) {
        return function() {
          return l;
        };
      }
      function ZH(l, c) {
        return l == null || l !== l ? c : l;
      }
      var fH = kG(), Fy = kG(!0);
      function Tg(l) {
        return l;
      }
      function o0(l) {
        return TA(typeof l == "function" ? l : Pr(l, C));
      }
      function GH(l) {
        return dp(Pr(l, C));
      }
      function yH(l, c) {
        return UA(l, Pr(c, C));
      }
      var WH = bi(function(l, c) {
        return function(b) {
          return Oc(b, l, c);
        };
      }), SH = bi(function(l, c) {
        return function(b) {
          return Oc(l, b, c);
        };
      });
      function I0(l, c, b) {
        var Z = Hg(c), S = DC(c, Z);
        b == null && !(Nn(c) && (S.length || !Z.length)) && (b = c, c = l, l = this, S = DC(c, Hg(c)));
        var R = !(Nn(b) && "chain" in b) || !!b.chain, D = Do(l);
        return Eg(S, function(K) {
          var O = c[K];
          l[K] = O, D && (l.prototype[K] = function() {
            var se = this.__chain__;
            if (R || se) {
              var oe = l(this.__wrapped__), de = oe.__actions__ = yr(this.__actions__);
              return de.push({ func: O, args: arguments, thisArg: l }), oe.__chain__ = se, oe;
            }
            return O.apply(l, go([this.value()], arguments));
          });
        }), l;
      }
      function VH() {
        return ut._ === this && (ut._ = Dl), this;
      }
      function l0() {
      }
      function Yy(l) {
        return l = Qt(l), bi(function(c) {
          return Cp(c, l);
        });
      }
      var wH = Gp(Wn), vH = Gp(ZA), xy = Gp(Jh);
      function s0(l) {
        return Rp(l) ? Nh(CI(l)) : Kv(l);
      }
      function RH(l) {
        return function(c) {
          return l == null ? i : Ma(l, c);
        };
      }
      var XH = YG(), HH = YG(!0);
      function a0() {
        return [];
      }
      function c0() {
        return !1;
      }
      function kH() {
        return {};
      }
      function FH() {
        return "";
      }
      function d0() {
        return !0;
      }
      function Dy(l, c) {
        if (l = Qt(l), l < 1 || l > te)
          return [];
        var b = we, Z = Dn(l, we);
        c = ri(c), l -= we;
        for (var S = Uh(Z, c); ++b < l; )
          c(b);
        return S;
      }
      function YH(l) {
        return li(l) ? Wn(l, CI) : so(l) ? [l] : yr(Dp(Ki(l)));
      }
      function xH(l) {
        var c = ++bv;
        return Ki(l) + c;
      }
      var DH = ib(function(l, c) {
        return l + c;
      }, 0), JH = yp("ceil"), KH = ib(function(l, c) {
        return l / c;
      }, 1), EH = yp("floor");
      function NH(l) {
        return l && l.length ? dI(l, Tg, er) : i;
      }
      function LH(l, c) {
        return l && l.length ? dI(l, ri(c, 2), er) : i;
      }
      function TH(l) {
        return Uf(l, Tg);
      }
      function MH(l, c) {
        return Uf(l, ri(c, 2));
      }
      function UH(l) {
        return l && l.length ? dI(l, Tg, MA) : i;
      }
      function PH(l, c) {
        return l && l.length ? dI(l, ri(c, 2), MA) : i;
      }
      var zH = ib(function(l, c) {
        return l * c;
      }, 1), OH = yp("round"), QH = ib(function(l, c) {
        return l - c;
      }, 0);
      function jH(l) {
        return l && l.length ? Mh(l, Tg) : 0;
      }
      function _H(l, c) {
        return l && l.length ? Mh(l, ri(c, 2)) : 0;
      }
      return z.after = BX, z.ary = Cb, z.assign = $C, z.assignIn = Vb, z.assignInWith = jl, z.assignWith = qC, z.at = eu, z.before = Iy, z.bind = nr, z.bindAll = g0, z.bindKey = ub, z.castArray = vX, z.chain = ty, z.chunk = cR, z.compact = dR, z.concat = CR, z.cond = ky, z.conforms = ld, z.constant = r0, z.countBy = eX, z.create = wb, z.curry = ly, z.curryRight = sy, z.debounce = Ab, z.defaults = gd, z.defaultsDeep = KX, z.defer = ZX, z.delay = Lp, z.difference = uR, z.differenceBy = AR, z.differenceWith = bR, z.drop = mR, z.dropRight = hR, z.dropRightWhile = pR, z.dropWhile = BR, z.fill = ZR, z.filter = iX, z.flatMap = ny, z.flatMapDeep = gX, z.flatMapDepth = rX, z.flatten = Vr, z.flattenDeep = qn, z.flattenDepth = fR, z.flip = fX, z.flow = fH, z.flowRight = Fy, z.fromPairs = GR, z.functions = By, z.functionsIn = rd, z.groupBy = oX, z.initial = WR, z.intersection = Jp, z.intersectionBy = SR, z.intersectionWith = Ml, z.invert = fy, z.invertBy = Gy, z.invokeMap = lX, z.iteratee = o0, z.keyBy = sX, z.keys = Hg, z.keysIn = vr, z.map = cb, z.mapKeys = UX, z.mapValues = _p, z.matches = GH, z.matchesProperty = yH, z.memoize = _C, z.merge = $p, z.mergeWith = qp, z.method = WH, z.methodOf = SH, z.mixin = I0, z.negate = bb, z.nthArg = Yy, z.omit = rr, z.omitBy = PX, z.once = Tp, z.orderBy = aX, z.over = wH, z.overArgs = Mp, z.overEvery = vH, z.overSome = xy, z.partial = Up, z.partialRight = ay, z.partition = cX, z.pick = yy, z.pickBy = od, z.property = s0, z.propertyOf = RH, z.pull = VR, z.pullAll = jG, z.pullAllBy = wR, z.pullAllWith = vR, z.pullAt = RR, z.range = XH, z.rangeRight = HH, z.rearg = GX, z.reject = uX, z.remove = XR, z.rest = yX, z.reverse = sb, z.sampleSize = bX, z.set = Wy, z.setWith = zX, z.shuffle = mX, z.slice = QC, z.sortBy = oy, z.sortedUniq = _G, z.sortedUniqBy = Ul, z.split = Ry, z.spread = WX, z.tail = Wi, z.take = $G, z.takeRight = Yo, z.takeRightWhile = qG, z.takeWhile = xR, z.tap = PR, z.throttle = SX, z.thru = jC, z.toArray = hy, z.toPairs = Sy, z.toPairsIn = Vy, z.toPath = YH, z.toPlainObject = jp, z.transform = OX, z.unary = VX, z.union = zi, z.unionBy = DR, z.unionWith = JR, z.uniq = KR, z.uniqBy = ER, z.uniqWith = NR, z.unset = QX, z.unzip = Kp, z.unzipWith = ey, z.update = jX, z.updateWith = _X, z.values = Id, z.valuesIn = $X, z.without = LR, z.words = Hy, z.wrap = wX, z.xor = TR, z.xorBy = Ep, z.xorWith = MR, z.zip = Np, z.zipObject = Xg, z.zipObjectDeep = zr, z.zipWith = UR, z.entries = Sy, z.entriesIn = Vy, z.extend = Vb, z.extendWith = jl, I0(z, z), z.add = DH, z.attempt = n0, z.camelCase = iH, z.capitalize = wy, z.ceil = JH, z.clamp = qX, z.clone = RX, z.cloneDeep = HX, z.cloneDeepWith = kX, z.cloneWith = XX, z.conformsTo = FX, z.deburr = vy, z.defaultTo = ZH, z.divide = KH, z.endsWith = nH, z.eq = $i, z.escape = gH, z.escapeRegExp = rH, z.every = tX, z.find = nX, z.findIndex = zG, z.findKey = EX, z.findLast = iy, z.findLastIndex = Fo, z.findLastKey = NX, z.floor = EH, z.forEach = gy, z.forEachRight = ry, z.forIn = LX, z.forInRight = TX, z.forOwn = vb, z.forOwnRight = tu, z.get = qI, z.gt = mb, z.gte = Pp, z.has = Zy, z.hasIn = iu, z.head = OG, z.identity = Tg, z.includes = IX, z.indexOf = yR, z.inRange = eH, z.invoke = MX, z.isArguments = Ls, z.isArray = li, z.isArrayBuffer = Rn, z.isArrayLike = gr, z.isArrayLikeObject = eg, z.isBoolean = xo, z.isBuffer = uI, z.isDate = YX, z.isElement = nd, z.isEmpty = hb, z.isEqual = pb, z.isEqualWith = qi, z.isError = zp, z.isFinite = cy, z.isFunction = Do, z.isInteger = dy, z.isLength = Bb, z.isMap = Pl, z.isMatch = Zb, z.isMatchWith = Cy, z.isNaN = fb, z.isNative = uy, z.isNil = Gb, z.isNull = Ay, z.isNumber = Op, z.isObject = Nn, z.isObjectLike = Xn, z.isPlainObject = zl, z.isRegExp = Ol, z.isSafeInteger = yb, z.isSet = by, z.isString = Wb, z.isSymbol = so, z.isTypedArray = Ql, z.isUndefined = Sb, z.isWeakMap = Qp, z.isWeakSet = xX, z.join = QG, z.kebabCase = oH, z.last = wr, z.lastIndexOf = En, z.lowerCase = IH, z.lowerFirst = lH, z.lt = my, z.lte = DX, z.max = NH, z.maxBy = LH, z.mean = TH, z.meanBy = MH, z.min = UH, z.minBy = PH, z.stubArray = a0, z.stubFalse = c0, z.stubObject = kH, z.stubString = FH, z.stubTrue = d0, z.multiply = zH, z.nth = zn, z.noConflict = VH, z.noop = l0, z.now = db, z.pad = sH, z.padEnd = aH, z.padStart = cH, z.parseInt = dH, z.random = tH, z.reduce = dX, z.reduceRight = CX, z.repeat = CH, z.replace = Rb, z.result = e0, z.round = OH, z.runInContext = T, z.sample = AX, z.size = hX, z.snakeCase = t0, z.some = pX, z.sortedIndex = HR, z.sortedIndexBy = ab, z.sortedIndexOf = lo, z.sortedLastIndex = kR, z.sortedLastIndexBy = FR, z.sortedLastIndexOf = YR, z.startCase = uH, z.startsWith = AH, z.subtract = QH, z.sum = jH, z.sumBy = _H, z.template = bH, z.times = Dy, z.toFinite = hn, z.toInteger = Qt, z.toLength = py, z.toLower = i0, z.toNumber = Jo, z.toSafeInteger = JX, z.toString = Ki, z.toUpper = Xy, z.trim = mH, z.trimEnd = hH, z.trimStart = pH, z.truncate = Qa, z.unescape = pi, z.uniqueId = xH, z.upperCase = BH, z.upperFirst = el, z.each = gy, z.eachRight = ry, z.first = OG, I0(z, function() {
        var l = {};
        return zI(z, function(c, b) {
          _i.call(z.prototype, b) || (l[b] = c);
        }), l;
      }(), { chain: !1 }), z.VERSION = n, Eg(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        z[l].placeholder = z;
      }), Eg(["drop", "take"], function(l, c) {
        Vi.prototype[l] = function(b) {
          b = b === i ? 1 : hg(Qt(b), 0);
          var Z = this.__filtered__ && !c ? new Vi(this) : this.clone();
          return Z.__filtered__ ? Z.__takeCount__ = Dn(b, Z.__takeCount__) : Z.__views__.push({
            size: Dn(b, we),
            type: l + (Z.__dir__ < 0 ? "Right" : "")
          }), Z;
        }, Vi.prototype[l + "Right"] = function(b) {
          return this.reverse()[l](b).reverse();
        };
      }), Eg(["filter", "map", "takeWhile"], function(l, c) {
        var b = c + 1, Z = b == E || b == P;
        Vi.prototype[l] = function(S) {
          var R = this.clone();
          return R.__iteratees__.push({
            iteratee: ri(S, 3),
            type: b
          }), R.__filtered__ = R.__filtered__ || Z, R;
        };
      }), Eg(["head", "last"], function(l, c) {
        var b = "take" + (c ? "Right" : "");
        Vi.prototype[l] = function() {
          return this[b](1).value()[0];
        };
      }), Eg(["initial", "tail"], function(l, c) {
        var b = "drop" + (c ? "" : "Right");
        Vi.prototype[l] = function() {
          return this.__filtered__ ? new Vi(this) : this[b](1);
        };
      }), Vi.prototype.compact = function() {
        return this.filter(Tg);
      }, Vi.prototype.find = function(l) {
        return this.filter(l).head();
      }, Vi.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, Vi.prototype.invokeMap = bi(function(l, c) {
        return typeof l == "function" ? new Vi(this) : this.map(function(b) {
          return Oc(b, l, c);
        });
      }), Vi.prototype.reject = function(l) {
        return this.filter(bb(ri(l)));
      }, Vi.prototype.slice = function(l, c) {
        l = Qt(l);
        var b = this;
        return b.__filtered__ && (l > 0 || c < 0) ? new Vi(b) : (l < 0 ? b = b.takeRight(-l) : l && (b = b.drop(l)), c !== i && (c = Qt(c), b = c < 0 ? b.dropRight(-c) : b.take(c - l)), b);
      }, Vi.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, Vi.prototype.toArray = function() {
        return this.take(we);
      }, zI(Vi.prototype, function(l, c) {
        var b = /^(?:filter|find|map|reject)|While$/.test(c), Z = /^(?:head|last)$/.test(c), S = z[Z ? "take" + (c == "last" ? "Right" : "") : c], R = Z || /^find/.test(c);
        S && (z.prototype[c] = function() {
          var D = this.__wrapped__, K = Z ? [1] : arguments, O = D instanceof Vi, se = K[0], oe = O || li(D), de = function(vt) {
            var Rt = S.apply(z, go([vt], K));
            return Z && Fe ? Rt[0] : Rt;
          };
          oe && b && typeof se == "function" && se.length != 1 && (O = oe = !1);
          var Fe = this.__chain__, Me = !!this.__actions__.length, it = R && !Fe, Zt = O && !Me;
          if (!R && oe) {
            D = Zt ? D : new Vi(this);
            var nt = l.apply(D, K);
            return nt.__actions__.push({ func: jC, args: [de], thisArg: i }), new Ho(nt, Fe);
          }
          return it && Zt ? l.apply(this, K) : (nt = this.thru(de), it ? Z ? nt.value()[0] : nt.value() : nt);
        });
      }), Eg(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var c = yA[l], b = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", Z = /^(?:pop|shift)$/.test(l);
        z.prototype[l] = function() {
          var S = arguments;
          if (Z && !this.__chain__) {
            var R = this.value();
            return c.apply(li(R) ? R : [], S);
          }
          return this[b](function(D) {
            return c.apply(li(D) ? D : [], S);
          });
        };
      }), zI(Vi.prototype, function(l, c) {
        var b = z[c];
        if (b) {
          var Z = b.name + "";
          _i.call(Pn, Z) || (Pn[Z] = []), Pn[Z].push({ name: c, func: b });
        }
      }), Pn[TC(i, f).name] = [{
        name: "wrapper",
        func: i
      }], Vi.prototype.clone = aG, Vi.prototype.reverse = fv, Vi.prototype.value = Gv, z.prototype.at = zR, z.prototype.chain = OR, z.prototype.commit = QR, z.prototype.next = jR, z.prototype.plant = $R, z.prototype.reverse = qR, z.prototype.toJSON = z.prototype.valueOf = z.prototype.value = id, z.prototype.first = z.prototype.head, vC && (z.prototype[vC] = _R), z;
    }, sI = uv();
    Et ? ((Et.exports = sI)._ = sI, wt._ = sI) : ut._ = sI;
  }).call(Zn);
})(MS, MS.exports);
var ce = MS.exports;
const uc = /* @__PURE__ */ Tr(ce), dfe = (e) => e !== null && typeof e == "object", pc = (e) => dfe(e) && !Cfe(e), Cfe = (e) => e !== null && Array.isArray(e), km = (e) => e == null, DL = (e) => Math.max(0, km(e) ? 1 : e), ufe = (e) => typeof e == "string";
Array.prototype.OC_reduceBy = function(e, t) {
  return this != null && this.length ? this.reduce((i, n, g) => {
    const r = i.findIndex((o) => e(o, n, g));
    return r >= 0 ? (i[r] = t(i[r], n, g), i) : (i.push({
      ...n
    }), i);
  }, []) : [];
};
String.prototype.OC_isCapitalized = function() {
  return this.length ? new RegExp("^\\p{Lu}", "u").test(this) : !1;
};
String.prototype.OC_addIfGiven = function(e) {
  return this + (e ? ` ${e}` : "");
};
String.prototype.OC_replaceAll = function(e, t) {
  if (!this)
    return "";
  const i = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return this.replace(new RegExp(i, "g"), () => t);
};
String.prototype.OC_removeAll = function(e) {
  return (this == null ? void 0 : this.OC_replaceAll(e, "")) || "";
};
Number.prototype.OC_roundTo = function(e) {
  return +(Math.round(+(this + "e" + e)) + "e" + -e);
};
const US = (e, t, i, n = "hiddenVariablesMap") => {
  const g = e == null ? void 0 : e[n][t], r = g === !0, o = pc(g) && g[i];
  return r || o;
}, Bc = (e, t) => !e || !t ? !1 : (e.left > t.left || e.left === t.left && (t.leftInclude || !e.leftInclude)) && (e.right < t.right || e.right === t.right && (t.rightInclude || !e.rightInclude)), PS = (e) => pc(e) && "left" in e, Afe = (e) => PS(e) && e.left === e.right, Du = (e) => ({
  left: e,
  leftInclude: !0,
  right: e,
  rightInclude: !0
}), JL = (e, t) => ({
  left: e,
  right: t,
  leftInclude: !1,
  rightInclude: !1
}), KL = (e) => e.left === e.right ? e.left.toString() : `${e.leftInclude ? "" : "("}${e.left}-${e.right}${e.rightInclude ? "" : ")"}`, EL = (e) => {
  const t = e[e.length - 1];
  return {
    ...e[0],
    right: t.right,
    rightInclude: t.rightInclude
  };
}, bfe = ({
  left: e,
  leftInclude: t,
  right: i,
  rightInclude: n
}) => ({
  left: e ?? -1 / 0,
  right: i ?? 1 / 0,
  leftInclude: t,
  rightInclude: n
}), mfe = (e, t) => t.find((i) => Bc(Du(e), i.data)), oW = (e, t, i) => e ? e[`${i}Include`] ? e[i] : e[i] + t * (i === "left" ? 1 : -1) : void 0, hfe = (e, t, i) => {
  if (t.length === 0)
    return;
  const n = t.findIndex((g) => {
    var r;
    return (((r = g.data) == null ? void 0 : r.left) ?? -1 / 0) >= e;
  });
  if (n < 0) {
    const g = t[t.length - 1], r = oW(g.data, i, "right");
    return r ? {
      value: g,
      input: r
    } : void 0;
  } else if (n === 0) {
    const g = t[0], r = oW(g.data, i, "left");
    return r ? {
      value: g,
      input: r
    } : void 0;
  } else {
    const g = t[n], r = t[n - 1], o = oW(g.data, i, "left"), I = oW(g.data, i, "right");
    return o === void 0 || I === void 0 ? void 0 : Math.abs(e - o) < Math.abs(e - I) ? {
      value: g,
      input: o
    } : {
      value: r,
      input: I
    };
  }
}, th = (e, t, i) => {
  const n = mfe(e, t);
  return n ? {
    value: n,
    input: e
  } : hfe(e, t, i);
}, pfe = (e) => {
  const t = e.replace(/\s/g, "");
  return t.includes(";") ? t.split(";") : t.includes("-") ? t.split("-") : [];
}, Bfe = (e, t) => {
  if (t === "left")
    return ["]", "("].includes(e[0]) ? [e.slice(1), !1] : [e.slice(e[0] === "[" ? 1 : 0), !0];
  {
    const i = e.length - 1, n = e[i];
    return ["[", ")"].includes(n) ? [e.slice(0, i), !1] : [e.slice(0, n === "]" ? i : i + 1), !0];
  }
}, NL = (e, t) => {
  const [i, n] = Bfe(e, t);
  if (i === "")
    return [t === "left" ? -1 / 0 : 1 / 0, !1];
  const g = Number(i);
  if (isNaN(g))
    throw new Error(`Unable to parse ${e} to number`);
  return [g, n];
}, sDt = (e) => {
  const t = Number(e);
  if (t || t === 0)
    return {
      left: t,
      leftInclude: !0,
      right: t,
      rightInclude: !0
    };
  const i = pfe(e);
  if (i.length !== 2)
    throw new Error(`Unable to parse interval ${e}`);
  const [n, g] = NL(i[0], "left"), [r, o] = NL(i[1], "right");
  return {
    left: n,
    leftInclude: g,
    right: r,
    rightInclude: o
  };
}, fQ = (e) => Afe(e.data), QB = "$noSelection";
var zS = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
zS.exports;
(function(e, t) {
  (function() {
    function i(T, re, X) {
      switch (X.length) {
        case 0:
          return T.call(re);
        case 1:
          return T.call(re, X[0]);
        case 2:
          return T.call(re, X[0], X[1]);
        case 3:
          return T.call(re, X[0], X[1], X[2]);
      }
      return T.apply(re, X);
    }
    function n(T, re, X, De) {
      for (var It = -1, lt = T == null ? 0 : T.length; ++It < lt; ) {
        var Ji = T[It];
        re(De, Ji, X(Ji), T);
      }
      return De;
    }
    function g(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length; ++X < De && re(T[X], X, T) !== !1; )
        ;
      return T;
    }
    function r(T, re) {
      for (var X = T == null ? 0 : T.length; X-- && re(T[X], X, T) !== !1; )
        ;
      return T;
    }
    function o(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length; ++X < De; )
        if (!re(T[X], X, T))
          return !1;
      return !0;
    }
    function I(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length, It = 0, lt = []; ++X < De; ) {
        var Ji = T[X];
        re(Ji, X, T) && (lt[It++] = Ji);
      }
      return lt;
    }
    function s(T, re) {
      return !!(T != null && T.length) && y(T, re, 0) > -1;
    }
    function a(T, re, X) {
      for (var De = -1, It = T == null ? 0 : T.length; ++De < It; )
        if (X(re, T[De]))
          return !0;
      return !1;
    }
    function d(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length, It = Array(De); ++X < De; )
        It[X] = re(T[X], X, T);
      return It;
    }
    function C(T, re) {
      for (var X = -1, De = re.length, It = T.length; ++X < De; )
        T[It + X] = re[X];
      return T;
    }
    function u(T, re, X, De) {
      var It = -1, lt = T == null ? 0 : T.length;
      for (De && lt && (X = T[++It]); ++It < lt; )
        X = re(X, T[It], It, T);
      return X;
    }
    function A(T, re, X, De) {
      var It = T == null ? 0 : T.length;
      for (De && It && (X = T[--It]); It--; )
        X = re(X, T[It], It, T);
      return X;
    }
    function m(T, re) {
      for (var X = -1, De = T == null ? 0 : T.length; ++X < De; )
        if (re(T[X], X, T))
          return !0;
      return !1;
    }
    function h(T) {
      return T.split("");
    }
    function B(T) {
      return T.match(pA) || [];
    }
    function f(T, re, X) {
      var De;
      return X(T, function(It, lt, Ji) {
        if (re(It, lt, Ji))
          return De = lt, !1;
      }), De;
    }
    function G(T, re, X, De) {
      for (var It = T.length, lt = X + (De ? 1 : -1); De ? lt-- : ++lt < It; )
        if (re(T[lt], lt, T))
          return lt;
      return -1;
    }
    function y(T, re, X) {
      return re === re ? rt(T, re, X) : G(T, V, X);
    }
    function W(T, re, X, De) {
      for (var It = X - 1, lt = T.length; ++It < lt; )
        if (De(T[It], re))
          return It;
      return -1;
    }
    function V(T) {
      return T !== T;
    }
    function w(T, re) {
      var X = T == null ? 0 : T.length;
      return X ? M(T, re) / X : Mi;
    }
    function v(T) {
      return function(re) {
        return re == null ? J : re[T];
      };
    }
    function H(T) {
      return function(re) {
        return T == null ? J : T[re];
      };
    }
    function x(T, re, X, De, It) {
      return It(T, function(lt, Ji, ji) {
        X = De ? (De = !1, lt) : re(X, lt, Ji, ji);
      }), X;
    }
    function N(T, re) {
      var X = T.length;
      for (T.sort(re); X--; )
        T[X] = T[X].value;
      return T;
    }
    function M(T, re) {
      for (var X, De = -1, It = T.length; ++De < It; ) {
        var lt = re(T[De]);
        lt !== J && (X = X === J ? lt : X + lt);
      }
      return X;
    }
    function $(T, re) {
      for (var X = -1, De = Array(T); ++X < T; )
        De[X] = re(X);
      return De;
    }
    function q(T, re) {
      return d(re, function(X) {
        return [X, T[X]];
      });
    }
    function E(T) {
      return T && T.slice(0, tt(T) + 1).replace(GC, "");
    }
    function L(T) {
      return function(re) {
        return T(re);
      };
    }
    function P(T, re) {
      return d(re, function(X) {
        return T[X];
      });
    }
    function Q(T, re) {
      return T.has(re);
    }
    function te(T, re) {
      for (var X = -1, De = T.length; ++X < De && y(re, T[X], 0) > -1; )
        ;
      return X;
    }
    function le(T, re) {
      for (var X = T.length; X-- && y(re, T[X], 0) > -1; )
        ;
      return X;
    }
    function Ae(T, re) {
      for (var X = T.length, De = 0; X--; )
        T[X] === re && ++De;
      return De;
    }
    function we(T) {
      return "\\" + Iv[T];
    }
    function Ee(T, re) {
      return T == null ? J : T[re];
    }
    function Je(T) {
      return Uh.test(T);
    }
    function ve(T) {
      return rv.test(T);
    }
    function Be(T) {
      for (var re, X = []; !(re = T.next()).done; )
        X.push(re.value);
      return X;
    }
    function ue(T) {
      var re = -1, X = Array(T.size);
      return T.forEach(function(De, It) {
        X[++re] = [It, De];
      }), X;
    }
    function Xe(T, re) {
      return function(X) {
        return T(re(X));
      };
    }
    function Ze(T, re) {
      for (var X = -1, De = T.length, It = 0, lt = []; ++X < De; ) {
        var Ji = T[X];
        Ji !== re && Ji !== Ut || (T[X] = Ut, lt[It++] = X);
      }
      return lt;
    }
    function Ke(T) {
      var re = -1, X = Array(T.size);
      return T.forEach(function(De) {
        X[++re] = De;
      }), X;
    }
    function $e(T) {
      var re = -1, X = Array(T.size);
      return T.forEach(function(De) {
        X[++re] = [De, De];
      }), X;
    }
    function rt(T, re, X) {
      for (var De = X - 1, It = T.length; ++De < It; )
        if (T[De] === re)
          return De;
      return -1;
    }
    function dt(T, re, X) {
      for (var De = X + 1; De--; )
        if (T[De] === re)
          return De;
      return De;
    }
    function ot(T) {
      return Je(T) ? st(T) : av(T);
    }
    function ze(T) {
      return Je(T) ? Kt(T) : h(T);
    }
    function tt(T) {
      for (var re = T.length; re-- && Xh.test(T.charAt(re)); )
        ;
      return re;
    }
    function st(T) {
      for (var re = Th.lastIndex = 0; Th.test(T); )
        ++re;
      return re;
    }
    function Kt(T) {
      return T.match(Th) || [];
    }
    function ie(T) {
      return T.match(Mh) || [];
    }
    var J, Ce = "4.17.21", xe = 200, Le = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", Ye = "Expected a function", qe = "Invalid `variable` option passed into `_.template`", Yt = "__lodash_hash_undefined__", qt = 500, Ut = "__lodash_placeholder__", Ge = 1, pe = 2, _e = 4, Gt = 1, Jt = 2, Te = 1, Xt = 2, Pe = 4, Oe = 8, kt = 16, Nt = 32, ni = 64, si = 128, jt = 256, Zi = 512, fi = 30, on = "...", In = 800, xn = 16, ln = 1, ug = 2, Ti = 3, vi = 1 / 0, ei = 9007199254740991, yn = 17976931348623157e292, Mi = NaN, bn = 4294967295, Ag = bn - 1, sn = bn >>> 1, bg = [["ary", si], ["bind", Te], ["bindKey", Xt], ["curry", Oe], ["curryRight", kt], ["flip", Zi], ["partial", Nt], ["partialRight", ni], ["rearg", jt]], Kn = "[object Arguments]", Mn = "[object Array]", Br = "[object AsyncFunction]", He = "[object Boolean]", We = "[object Date]", yt = "[object DOMException]", at = "[object Error]", Lt = "[object Function]", Ht = "[object GeneratorFunction]", oi = "[object Map]", mg = "[object Number]", kl = "[object Null]", oI = "[object Object]", wa = "[object Promise]", AA = "[object Proxy]", II = "[object RegExp]", Zr = "[object Set]", lI = "[object String]", Rs = "[object Symbol]", CC = "[object Undefined]", va = "[object WeakMap]", bA = "[object WeakSet]", Ra = "[object ArrayBuffer]", Fl = "[object DataView]", Hc = "[object Float32Array]", kc = "[object Float64Array]", Xa = "[object Int8Array]", Ha = "[object Int16Array]", uC = "[object Int32Array]", Fc = "[object Uint8Array]", Xs = "[object Uint8ClampedArray]", ka = "[object Uint16Array]", AC = "[object Uint32Array]", bC = /\b__p \+= '';/g, mC = /\b(__p \+=) '' \+/g, hC = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Yc = /&(?:amp|lt|gt|quot|#39);/g, xc = /[&<>"']/g, pC = RegExp(Yc.source), BC = RegExp(xc.source), Hs = /<%-([\s\S]+?)%>/g, ZC = /<%([\s\S]+?)%>/g, Dc = /<%=([\s\S]+?)%>/g, Jc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, mA = /^\w*$/, fC = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Fa = /[\\^$.*+?()[\]{}|]/g, Yl = RegExp(Fa.source), GC = /^\s+/, Xh = /\s/, yC = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, hA = /\{\n\/\* \[wrapped with (.+)\] \*/, Hh = /,? & /, pA = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, WC = /[()=,{}\[\]\/\s]/, kh = /\\(\\)?/g, SC = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, NI = /\w*$/, Fh = /^[-+]0x[0-9a-f]+$/i, Yh = /^0b[01]+$/i, xh = /^\[object .+?Constructor\]$/, Dh = /^0o[0-7]+$/i, Gi = /^(?:0|[1-9]\d*)$/, F = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, U = /($^)/, ee = /['\n\r\u2028\u2029\\]/g, j = "\\ud800-\\udfff", ae = "\\u0300-\\u036f", be = "\\ufe20-\\ufe2f", ke = "\\u20d0-\\u20ff", gt = ae + be + ke, Qe = "\\u2700-\\u27bf", ut = "a-z\\xdf-\\xf6\\xf8-\\xff", wt = "\\xac\\xb1\\xd7\\xf7", Et = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ht = "\\u2000-\\u206f", ci = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ai = "A-Z\\xc0-\\xd6\\xd8-\\xde", vn = "\\ufe0e\\ufe0f", Ot = wt + Et + ht + ci, yi = "['’]", og = "[" + j + "]", Un = "[" + Ot + "]", Ig = "[" + gt + "]", Ui = "\\d+", Ya = "[" + Qe + "]", Eg = "[" + ut + "]", BA = "[^" + j + Ot + Ui + Qe + ut + ai + "]", ZA = "\\ud83c[\\udffb-\\udfff]", ks = "(?:" + Ig + "|" + ZA + ")", VC = "[^" + j + "]", wC = "(?:\\ud83c[\\udde6-\\uddff]){2}", Wn = "[\\ud800-\\udbff][\\udc00-\\udfff]", go = "[" + ai + "]", fA = "\\u200d", Nf = "(?:" + Eg + "|" + BA + ")", Jh = "(?:" + go + "|" + BA + ")", Lf = "(?:" + yi + "(?:d|ll|m|re|s|t|ve))?", Tf = "(?:" + yi + "(?:D|LL|M|RE|S|T|VE))?", Mf = ks + "?", Kh = "[" + vn + "]?", GA = "(?:" + fA + "(?:" + [VC, wC, Wn].join("|") + ")" + Kh + Mf + ")*", Kc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gv = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Eh = Kh + Mf + GA, Uf = "(?:" + [Ya, wC, Wn].join("|") + ")" + Eh, Nh = "(?:" + [VC + Ig + "?", Ig, wC, Wn, og].join("|") + ")", Lh = RegExp(yi, "g"), Pf = RegExp(Ig, "g"), Th = RegExp(ZA + "(?=" + ZA + ")|" + Nh + Eh, "g"), Mh = RegExp([go + "?" + Eg + "+" + Lf + "(?=" + [Un, go, "$"].join("|") + ")", Jh + "+" + Tf + "(?=" + [Un, go + Nf, "$"].join("|") + ")", go + "?" + Nf + "+" + Lf, go + "+" + Tf, gv, Kc, Ui, Uf].join("|"), "g"), Uh = RegExp("[" + fA + j + gt + vn + "]"), rv = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, zf = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], ro = -1, mn = {};
    mn[Hc] = mn[kc] = mn[Xa] = mn[Ha] = mn[uC] = mn[Fc] = mn[Xs] = mn[ka] = mn[AC] = !0, mn[Kn] = mn[Mn] = mn[Ra] = mn[He] = mn[Fl] = mn[We] = mn[at] = mn[Lt] = mn[oi] = mn[mg] = mn[oI] = mn[II] = mn[Zr] = mn[lI] = mn[va] = !1;
    var Pi = {};
    Pi[Kn] = Pi[Mn] = Pi[Ra] = Pi[Fl] = Pi[He] = Pi[We] = Pi[Hc] = Pi[kc] = Pi[Xa] = Pi[Ha] = Pi[uC] = Pi[oi] = Pi[mg] = Pi[oI] = Pi[II] = Pi[Zr] = Pi[lI] = Pi[Rs] = Pi[Fc] = Pi[Xs] = Pi[ka] = Pi[AC] = !0, Pi[at] = Pi[Lt] = Pi[va] = !1;
    var Of = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Qf = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, ov = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, Iv = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, lv = parseFloat, sv = parseInt, jf = typeof Zn == "object" && Zn && Zn.Object === Object && Zn, Ec = typeof self == "object" && self && self.Object === Object && self, Ng = jf || Ec || Function("return this")(), Ph = t && !t.nodeType && t, xl = Ph && !0 && e && !e.nodeType && e, zh = xl && xl.exports === Ph, LI = zh && jf.process, fr = function() {
      try {
        var T = xl && xl.require && xl.require("util").types;
        return T || LI && LI.binding && LI.binding("util");
      } catch {
      }
    }(), _f = fr && fr.isArrayBuffer, $f = fr && fr.isDate, qf = fr && fr.isMap, xa = fr && fr.isRegExp, vo = fr && fr.isSet, Oh = fr && fr.isTypedArray, av = v("length"), cv = H(Of), dv = H(Qf), Cv = H(ov), uv = function T(re) {
      function X(l) {
        if (zn(l) && !pi(l) && !(l instanceof lt)) {
          if (l instanceof It)
            return l;
          if (qi.call(l, "__wrapped__"))
            return yr(l);
        }
        return new It(l);
      }
      function De() {
      }
      function It(l, c) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = J;
      }
      function lt(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = bn, this.__views__ = [];
      }
      function Ji() {
        var l = new lt(this.__wrapped__);
        return l.__actions__ = er(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = er(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = er(this.__views__), l;
      }
      function ji() {
        if (this.__filtered__) {
          var l = new lt(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function Qh() {
        var l = this.__wrapped__.value(), c = this.__dir__, b = pi(l), Z = c < 0, S = b ? l.length : 0, R = Nv(0, S, this.__views__), D = R.start, K = R.end, O = K - D, se = Z ? K : D - 1, oe = this.__iteratees__, de = oe.length, Fe = 0, Me = Qt(O, this.__takeCount__);
        if (!b || !Z && S == O && Me == O)
          return rp(l, this.__actions__);
        var it = [];
        e:
          for (; O-- && Fe < Me; ) {
            se += c;
            for (var Zt = -1, nt = l[se]; ++Zt < de; ) {
              var vt = oe[Zt], Rt = vt.iteratee, an = vt.type, cn = Rt(nt);
              if (an == ug)
                nt = cn;
              else if (!cn) {
                if (an == ln)
                  continue e;
                break e;
              }
            }
            it[Fe++] = nt;
          }
        return it;
      }
      function Da(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.clear(); ++c < b; ) {
          var Z = l[c];
          this.set(Z[0], Z[1]);
        }
      }
      function Ro() {
        this.__data__ = eu ? eu(null) : {}, this.size = 0;
      }
      function yA(l) {
        var c = this.has(l) && delete this.__data__[l];
        return this.size -= c ? 1 : 0, c;
      }
      function Av(l) {
        var c = this.__data__;
        if (eu) {
          var b = c[l];
          return b === Yt ? J : b;
        }
        return qi.call(c, l) ? c[l] : J;
      }
      function Nc(l) {
        var c = this.__data__;
        return eu ? c[l] !== J : qi.call(c, l);
      }
      function WA(l, c) {
        var b = this.__data__;
        return this.size += this.has(l) ? 0 : 1, b[l] = eu && c === J ? Yt : c, this;
      }
      function Xo(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.clear(); ++c < b; ) {
          var Z = l[c];
          this.set(Z[0], Z[1]);
        }
      }
      function _i() {
        this.__data__ = [], this.size = 0;
      }
      function bv(l) {
        var c = this.__data__, b = HC(c, l);
        return !(b < 0) && (b == c.length - 1 ? c.pop() : Gb.call(c, b, 1), --this.size, !0);
      }
      function eG(l) {
        var c = this.__data__, b = HC(c, l);
        return b < 0 ? J : c[b][1];
      }
      function SA(l) {
        return HC(this.__data__, l) > -1;
      }
      function mv(l, c) {
        var b = this.__data__, Z = HC(b, l);
        return Z < 0 ? (++this.size, b.push([l, c])) : b[Z][1] = c, this;
      }
      function Dl(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.clear(); ++c < b; ) {
          var Z = l[c];
          this.set(Z[0], Z[1]);
        }
      }
      function hv() {
        this.size = 0, this.__data__ = { hash: new Da(), map: new ($C || Xo)(), string: new Da() };
      }
      function VA(l) {
        var c = PA(this, l).delete(l);
        return this.size -= c ? 1 : 0, c;
      }
      function Fs(l) {
        return PA(this, l).get(l);
      }
      function wA(l) {
        return PA(this, l).has(l);
      }
      function tG(l, c) {
        var b = PA(this, l), Z = b.size;
        return b.set(l, c), this.size += b.size == Z ? 0 : 1, this;
      }
      function TI(l) {
        var c = -1, b = l == null ? 0 : l.length;
        for (this.__data__ = new Dl(); ++c < b; )
          this.add(l[c]);
      }
      function iG(l) {
        return this.__data__.set(l, Yt), this;
      }
      function nG(l) {
        return this.__data__.has(l);
      }
      function Mr(l) {
        this.size = (this.__data__ = new Xo(l)).size;
      }
      function gG() {
        this.__data__ = new Xo(), this.size = 0;
      }
      function vC(l) {
        var c = this.__data__, b = c.delete(l);
        return this.size = c.size, b;
      }
      function Ja(l) {
        return this.__data__.get(l);
      }
      function vA(l) {
        return this.__data__.has(l);
      }
      function pv(l, c) {
        var b = this.__data__;
        if (b instanceof Xo) {
          var Z = b.__data__;
          if (!$C || Z.length < xe - 1)
            return Z.push([l, c]), this.size = ++b.size, this;
          b = this.__data__ = new Dl(Z);
        }
        return b.set(l, c), this.size = b.size, this;
      }
      function rG(l, c) {
        var b = pi(l), Z = !b && Qa(l), S = !b && !Z && el(l), R = !b && !Z && !S && ld(l), D = b || Z || S || R, K = D ? $(l.length, eg) : [], O = K.length;
        for (var se in l)
          !c && !qi.call(l, se) || D && (se == "length" || S && (se == "offset" || se == "parent") || R && (se == "buffer" || se == "byteLength" || se == "byteOffset") || tr(se, O)) || K.push(se);
        return K;
      }
      function oG(l) {
        var c = l.length;
        return c ? l[ip(0, c - 1)] : J;
      }
      function RA(l, c) {
        return LC(er(l), Ka(c, 0, l.length));
      }
      function XA(l) {
        return LC(er(l));
      }
      function RC(l, c, b) {
        (b === J || Fo(l[c], b)) && (b !== J || c in l) || Dn(l, c, b);
      }
      function XC(l, c, b) {
        var Z = l[c];
        qi.call(l, c) && Fo(Z, b) && (b !== J || c in l) || Dn(l, c, b);
      }
      function HC(l, c) {
        for (var b = l.length; b--; )
          if (Fo(l[b][0], c))
            return b;
        return -1;
      }
      function Bv(l, c, b, Z) {
        return qI(l, function(S, R, D) {
          c(Z, S, b(S), D);
        }), Z;
      }
      function IG(l, c) {
        return l && OI(c, Xg(c), l);
      }
      function hg(l, c) {
        return l && OI(c, zr(c), l);
      }
      function Dn(l, c, b) {
        c == "__proto__" && yb ? yb(l, c, { configurable: !0, enumerable: !0, value: b, writable: !0 }) : l[c] = b;
      }
      function jh(l, c) {
        for (var b = -1, Z = c.length, S = $i(Z), R = l == null; ++b < Z; )
          S[b] = R ? J : Ep(l, c[b]);
        return S;
      }
      function Ka(l, c, b) {
        return l === l && (b !== J && (l = l <= b ? l : b), c !== J && (l = l >= c ? l : c)), l;
      }
      function oo(l, c, b, Z, S, R) {
        var D, K = c & Ge, O = c & pe, se = c & _e;
        if (b && (D = S ? b(l, Z, S, R) : b(l)), D !== J)
          return D;
        if (!En(l))
          return l;
        var oe = pi(l);
        if (oe) {
          if (D = zA(l), !K)
            return er(l, D);
        } else {
          var de = rr(l), Fe = de == Lt || de == Ht;
          if (el(l))
            return Ip(l, K);
          if (de == oI || de == Kn || Fe && !S) {
            if (D = O || Fe ? {} : OA(l), !K)
              return O ? Fv(l, hg(D, l)) : kv(l, IG(D, l));
          } else {
            if (!Pi[de])
              return S ? l : {};
            D = WG(l, de, K);
          }
        }
        R || (R = new Mr());
        var Me = R.get(l);
        if (Me)
          return Me;
        R.set(l, D), ky(l) ? l.forEach(function(nt) {
          D.add(oo(nt, c, b, nt, l, R));
        }) : n0(l) && l.forEach(function(nt, vt) {
          D.set(vt, oo(nt, c, b, vt, l, R));
        });
        var it = se ? O ? mp : NC : O ? zr : Xg, Zt = oe ? J : it(l);
        return g(Zt || l, function(nt, vt) {
          Zt && (vt = nt, nt = l[vt]), XC(D, vt, oo(nt, c, b, vt, l, R));
        }), D;
      }
      function Zv(l) {
        var c = Xg(l);
        return function(b) {
          return HA(b, l, c);
        };
      }
      function HA(l, c, b) {
        var Z = b.length;
        if (l == null)
          return !Z;
        for (l = Rn(l); Z--; ) {
          var S = b[Z], R = c[S], D = l[S];
          if (D === J && !(S in l) || !R(D))
            return !1;
        }
        return !0;
      }
      function Lc(l, c, b) {
        if (typeof l != "function")
          throw new xo(Ye);
        return od(function() {
          l.apply(J, b);
        }, c);
      }
      function Ea(l, c, b, Z) {
        var S = -1, R = s, D = !0, K = l.length, O = [], se = c.length;
        if (!K)
          return O;
        b && (c = d(c, L(b))), Z ? (R = a, D = !1) : c.length >= xe && (R = Q, D = !1, c = new TI(c));
        e:
          for (; ++S < K; ) {
            var oe = l[S], de = b == null ? oe : b(oe);
            if (oe = Z || oe !== 0 ? oe : 0, D && de === de) {
              for (var Fe = se; Fe--; )
                if (c[Fe] === de)
                  continue e;
              O.push(oe);
            } else
              R(c, de, Z) || O.push(oe);
          }
        return O;
      }
      function Tc(l, c) {
        var b = !0;
        return qI(l, function(Z, S, R) {
          return b = !!c(Z, S, R);
        }), b;
      }
      function Ys(l, c, b) {
        for (var Z = -1, S = l.length; ++Z < S; ) {
          var R = l[Z], D = c(R);
          if (D != null && (K === J ? D === D && !lo(D) : b(D, K)))
            var K = D, O = R;
        }
        return O;
      }
      function kC(l, c, b, Z) {
        var S = l.length;
        for (b = Wi(b), b < 0 && (b = -b > S ? 0 : S + b), Z = Z === J || Z > S ? S : Wi(Z), Z < 0 && (Z += S), Z = b > Z ? 0 : $G(Z); b < Z; )
          l[b++] = c;
        return l;
      }
      function FC(l, c) {
        var b = [];
        return qI(l, function(Z, S, R) {
          c(Z, S, R) && b.push(Z);
        }), b;
      }
      function Pn(l, c, b, Z, S) {
        var R = -1, D = l.length;
        for (b || (b = Io), S || (S = []); ++R < D; ) {
          var K = l[R];
          c > 0 && b(K) ? c > 1 ? Pn(K, c - 1, b, Z, S) : C(S, K) : Z || (S[S.length] = K);
        }
        return S;
      }
      function MI(l, c) {
        return l && iu(l, c, Xg);
      }
      function _h(l, c) {
        return l && fy(l, c, Xg);
      }
      function kA(l, c) {
        return I(c, function(b) {
          return Ml(l[b]);
        });
      }
      function Na(l, c) {
        c = dI(c, l);
        for (var b = 0, Z = c.length; l != null && b < Z; )
          l = l[_I(c[b++])];
        return b && b == Z ? l : J;
      }
      function lG(l, c, b) {
        var Z = c(l);
        return pi(l) ? Z : C(Z, b(l));
      }
      function Rg(l) {
        return l == null ? l === J ? CC : kl : Ol && Ol in Rn(l) ? Ev(l) : VG(l);
      }
      function La(l, c) {
        return l > c;
      }
      function sG(l, c) {
        return l != null && qi.call(l, c);
      }
      function z(l, c) {
        return l != null && c in Rn(l);
      }
      function Mc(l, c, b) {
        return l >= Qt(c, b) && l < hn(c, b);
      }
      function Uc(l, c, b) {
        for (var Z = b ? a : s, S = l[0].length, R = l.length, D = R, K = $i(R), O = 1 / 0, se = []; D--; ) {
          var oe = l[D];
          D && c && (oe = d(oe, L(c))), O = Qt(oe.length, O), K[D] = !b && (c || S >= 120 && oe.length >= 120) ? new TI(D && oe) : J;
        }
        oe = l[0];
        var de = -1, Fe = K[0];
        e:
          for (; ++de < S && se.length < O; ) {
            var Me = oe[de], it = c ? c(Me) : Me;
            if (Me = b || Me !== 0 ? Me : 0, !(Fe ? Q(Fe, it) : Z(se, it, b))) {
              for (D = R; --D; ) {
                var Zt = K[D];
                if (!(Zt ? Q(Zt, it) : Z(l[D], it, b)))
                  continue e;
              }
              Fe && Fe.push(it), se.push(Me);
            }
          }
        return se;
      }
      function Ho(l, c, b, Z) {
        return MI(l, function(S, R, D) {
          c(Z, b(S), R, D);
        }), Z;
      }
      function Vi(l, c, b) {
        c = dI(c, l), l = eb(l, c);
        var Z = l == null ? l : l[_I(Wr(c))];
        return Z == null ? J : i(Z, l, b);
      }
      function aG(l) {
        return zn(l) && Rg(l) == Kn;
      }
      function fv(l) {
        return zn(l) && Rg(l) == Ra;
      }
      function Gv(l) {
        return zn(l) && Rg(l) == We;
      }
      function aI(l, c, b, Z, S) {
        return l === c || (l == null || c == null || !zn(l) && !zn(c) ? l !== l && c !== c : yv(l, c, b, Z, aI, S));
      }
      function yv(l, c, b, Z, S, R) {
        var D = pi(l), K = pi(c), O = D ? Mn : rr(l), se = K ? Mn : rr(c);
        O = O == Kn ? oI : O, se = se == Kn ? oI : se;
        var oe = O == oI, de = se == oI, Fe = O == se;
        if (Fe && el(l)) {
          if (!el(c))
            return !1;
          D = !0, oe = !1;
        }
        if (Fe && !oe)
          return R || (R = new Mr()), D || ld(l) ? Ap(l, c, b, Z, S, R) : Kv(l, c, O, b, Z, S, R);
        if (!(b & Gt)) {
          var Me = oe && qi.call(l, "__wrapped__"), it = de && qi.call(c, "__wrapped__");
          if (Me || it) {
            var Zt = Me ? l.value() : l, nt = it ? c.value() : c;
            return R || (R = new Mr()), S(Zt, nt, b, Z, R);
          }
        }
        return !!Fe && (R || (R = new Mr()), bp(l, c, b, Z, S, R));
      }
      function Wv(l) {
        return zn(l) && rr(l) == oi;
      }
      function $h(l, c, b, Z) {
        var S = b.length, R = S, D = !Z;
        if (l == null)
          return !R;
        for (l = Rn(l); S--; ) {
          var K = b[S];
          if (D && K[2] ? K[1] !== l[K[0]] : !(K[0] in l))
            return !1;
        }
        for (; ++S < R; ) {
          K = b[S];
          var O = K[0], se = l[O], oe = K[1];
          if (D && K[2]) {
            if (se === J && !(O in l))
              return !1;
          } else {
            var de = new Mr();
            if (Z)
              var Fe = Z(se, oe, O, l, c, de);
            if (!(Fe === J ? aI(oe, se, Gt | Jt, Z, de) : Fe))
              return !1;
          }
        }
        return !0;
      }
      function cG(l) {
        return !(!En(l) || hp(l)) && (Ml(l) ? Nn : xh).test(Ns(l));
      }
      function Sv(l) {
        return zn(l) && Rg(l) == II;
      }
      function Jl(l) {
        return zn(l) && rr(l) == Zr;
      }
      function Vv(l) {
        return zn(l) && wr(l.length) && !!mn[Rg(l)];
      }
      function dG(l) {
        return typeof l == "function" ? l : l == null ? nr : typeof l == "object" ? pi(l) ? uG(l[0], l[1]) : CG(l) : _C(l);
      }
      function qh(l) {
        if (!_c(l))
          return hy(l);
        var c = [];
        for (var b in Rn(l))
          qi.call(l, b) && b != "constructor" && c.push(b);
        return c;
      }
      function wv(l) {
        if (!En(l))
          return Es(l);
        var c = _c(l), b = [];
        for (var Z in l)
          (Z != "constructor" || !c && qi.call(l, Z)) && b.push(Z);
        return b;
      }
      function ep(l, c) {
        return l < c;
      }
      function UI(l, c) {
        var b = -1, Z = Vr(l) ? $i(l.length) : [];
        return qI(l, function(S, R, D) {
          Z[++b] = c(S, R, D);
        }), Z;
      }
      function CG(l) {
        var c = Ua(l);
        return c.length == 1 && c[0][2] ? qA(c[0][0], c[0][1]) : function(b) {
          return b === l || $h(b, l, c);
        };
      }
      function uG(l, c) {
        return QA(l) && $A(c) ? qA(_I(l), c) : function(b) {
          var Z = Ep(b, l);
          return Z === J && Z === c ? Np(b, l) : aI(c, Z, Gt | Jt);
        };
      }
      function FA(l, c, b, Z, S) {
        l !== c && iu(c, function(R, D) {
          if (S || (S = new Mr()), En(R))
            vv(l, c, D, b, FA, Z, S);
          else {
            var K = Z ? Z(Bp(l, D), R, D + "", l, c, S) : J;
            K === J && (K = R), RC(l, D, K);
          }
        }, zr);
      }
      function vv(l, c, b, Z, S, R, D) {
        var K = Bp(l, b), O = Bp(c, b), se = D.get(O);
        if (se)
          return RC(l, b, se), J;
        var oe = R ? R(K, O, b + "", l, c, D) : J, de = oe === J;
        if (de) {
          var Fe = pi(O), Me = !Fe && el(O), it = !Fe && !Me && ld(O);
          oe = O, Fe || Me || it ? pi(K) ? oe = K : qn(K) ? oe = er(K) : Me ? (de = !1, oe = Ip(O, !0)) : it ? (de = !1, oe = KA(O, !0)) : oe = [] : QC(O) || Qa(O) ? (oe = K, Qa(K) ? oe = qG(K) : En(K) && !Ml(K) || (oe = OA(O))) : de = !1;
        }
        de && (D.set(O, oe), S(oe, O, Z, R, D), D.delete(O)), RC(l, b, oe);
      }
      function AG(l, c) {
        var b = l.length;
        if (b)
          return c += c < 0 ? b : 0, tr(c, b) ? l[c] : J;
      }
      function xs(l, c, b) {
        c = c.length ? d(c, function(S) {
          return pi(S) ? function(R) {
            return Na(R, S.length === 1 ? S[0] : S);
          } : S;
        }) : [nr];
        var Z = -1;
        return c = d(c, L(gi())), N(UI(l, function(S, R, D) {
          return { criteria: d(c, function(K) {
            return K(S);
          }), index: ++Z, value: S };
        }), function(S, R) {
          return Ma(S, R, b);
        });
      }
      function Rv(l, c) {
        return bG(l, c, function(b, Z) {
          return Np(l, Z);
        });
      }
      function bG(l, c, b) {
        for (var Z = -1, S = c.length, R = {}; ++Z < S; ) {
          var D = c[Z], K = Na(l, D);
          b(K, D) && YC(R, dI(D, l), K);
        }
        return R;
      }
      function cI(l) {
        return function(c) {
          return Na(c, l);
        };
      }
      function tp(l, c, b, Z) {
        var S = Z ? W : y, R = -1, D = c.length, K = l;
        for (l === c && (c = er(c)), b && (K = d(l, L(b))); ++R < D; )
          for (var O = 0, se = c[R], oe = b ? b(se) : se; (O = S(K, oe, O, Z)) > -1; )
            K !== l && Gb.call(K, O, 1), Gb.call(l, O, 1);
        return l;
      }
      function mG(l, c) {
        for (var b = l ? c.length : 0, Z = b - 1; b--; ) {
          var S = c[b];
          if (b == Z || S !== R) {
            var R = S;
            tr(S) ? Gb.call(l, S, 1) : Pr(l, S);
          }
        }
        return l;
      }
      function ip(l, c) {
        return l + Sb(jp() * (c - l + 1));
      }
      function Xv(l, c, b, Z) {
        for (var S = -1, R = hn(Ql((c - l) / (b || 1)), 0), D = $i(R); R--; )
          D[Z ? R : ++S] = l, l += b;
        return D;
      }
      function np(l, c) {
        var b = "";
        if (!l || c < 1 || c > ei)
          return b;
        do
          c % 2 && (b += l), c = Sb(c / 2), c && (l += l);
        while (c);
        return b;
      }
      function wi(l, c) {
        return e0(pp(l, c, nr), l + "");
      }
      function hG(l) {
        return oG(id(l));
      }
      function Hv(l, c) {
        var b = id(l);
        return LC(b, Ka(c, 0, b.length));
      }
      function YC(l, c, b, Z) {
        if (!En(l))
          return l;
        c = dI(c, l);
        for (var S = -1, R = c.length, D = R - 1, K = l; K != null && ++S < R; ) {
          var O = _I(c[S]), se = b;
          if (O === "__proto__" || O === "constructor" || O === "prototype")
            return l;
          if (S != D) {
            var oe = K[O];
            se = Z ? Z(oe, O, K) : J, se === J && (se = En(oe) ? oe : tr(c[S + 1]) ? [] : {});
          }
          XC(K, O, se), K = K[O];
        }
        return l;
      }
      function gp(l) {
        return LC(id(l));
      }
      function $g(l, c, b) {
        var Z = -1, S = l.length;
        c < 0 && (c = -c > S ? 0 : S + c), b = b > S ? S : b, b < 0 && (b += S), S = c > b ? 0 : b - c >>> 0, c >>>= 0;
        for (var R = $i(S); ++Z < S; )
          R[Z] = l[Z + c];
        return R;
      }
      function YA(l, c) {
        var b;
        return qI(l, function(Z, S, R) {
          return b = c(Z, S, R), !b;
        }), !!b;
      }
      function xA(l, c, b) {
        var Z = 0, S = l == null ? Z : l.length;
        if (typeof c == "number" && c === c && S <= sn) {
          for (; Z < S; ) {
            var R = Z + S >>> 1, D = l[R];
            D !== null && !lo(D) && (b ? D <= c : D < c) ? Z = R + 1 : S = R;
          }
          return S;
        }
        return DA(l, c, nr, b);
      }
      function DA(l, c, b, Z) {
        var S = 0, R = l == null ? 0 : l.length;
        if (R === 0)
          return 0;
        c = b(c);
        for (var D = c !== c, K = c === null, O = lo(c), se = c === J; S < R; ) {
          var oe = Sb((S + R) / 2), de = b(l[oe]), Fe = de !== J, Me = de === null, it = de === de, Zt = lo(de);
          if (D)
            var nt = Z || it;
          else
            nt = se ? it && (Z || Fe) : K ? it && Fe && (Z || !Me) : O ? it && Fe && !Me && (Z || !Zt) : !Me && !Zt && (Z ? de <= c : de < c);
          nt ? S = oe + 1 : R = oe;
        }
        return Qt(R, Ag);
      }
      function pG(l, c) {
        for (var b = -1, Z = l.length, S = 0, R = []; ++b < Z; ) {
          var D = l[b], K = c ? c(D) : D;
          if (!b || !Fo(K, O)) {
            var O = K;
            R[S++] = D === 0 ? 0 : D;
          }
        }
        return R;
      }
      function PI(l) {
        return typeof l == "number" ? l : lo(l) ? Mi : +l;
      }
      function Gr(l) {
        if (typeof l == "string")
          return l;
        if (pi(l))
          return d(l, Gr) + "";
        if (lo(l))
          return By ? By.call(l) : "";
        var c = l + "";
        return c == "0" && 1 / l == -vi ? "-0" : c;
      }
      function Ur(l, c, b) {
        var Z = -1, S = s, R = l.length, D = !0, K = [], O = K;
        if (b)
          D = !1, S = a;
        else if (R >= xe) {
          var se = c ? null : UX(l);
          if (se)
            return Ke(se);
          D = !1, S = Q, O = new TI();
        } else
          O = c ? [] : K;
        e:
          for (; ++Z < R; ) {
            var oe = l[Z], de = c ? c(oe) : oe;
            if (oe = b || oe !== 0 ? oe : 0, D && de === de) {
              for (var Fe = O.length; Fe--; )
                if (O[Fe] === de)
                  continue e;
              c && O.push(de), K.push(oe);
            } else
              S(O, de, b) || (O !== K && O.push(de), K.push(oe));
          }
        return K;
      }
      function Pr(l, c) {
        return c = dI(c, l), l = eb(l, c), l == null || delete l[_I(Wr(c))];
      }
      function BG(l, c, b, Z) {
        return YC(l, c, b(Na(l, c)), Z);
      }
      function xC(l, c, b, Z) {
        for (var S = l.length, R = Z ? S : -1; (Z ? R-- : ++R < S) && c(l[R], R, l); )
          ;
        return b ? $g(l, Z ? 0 : R, Z ? R + 1 : S) : $g(l, Z ? R + 1 : 0, Z ? S : R);
      }
      function rp(l, c) {
        var b = l;
        return b instanceof lt && (b = b.value()), u(c, function(Z, S) {
          return S.func.apply(S.thisArg, C([Z], S.args));
        }, b);
      }
      function Ta(l, c, b) {
        var Z = l.length;
        if (Z < 2)
          return Z ? Ur(l[0]) : [];
        for (var S = -1, R = $i(Z); ++S < Z; )
          for (var D = l[S], K = -1; ++K < Z; )
            K != S && (R[S] = Ea(R[S] || D, l[K], c, b));
        return Ur(Pn(R, 1), c, b);
      }
      function Kl(l, c, b) {
        for (var Z = -1, S = l.length, R = c.length, D = {}; ++Z < S; )
          b(D, l[Z], Z < R ? c[Z] : J);
        return D;
      }
      function JA(l) {
        return qn(l) ? l : [];
      }
      function op(l) {
        return typeof l == "function" ? l : nr;
      }
      function dI(l, c) {
        return pi(l) ? l : QA(l, c) ? [l] : Wy(zi(l));
      }
      function Ds(l, c, b) {
        var Z = l.length;
        return b = b === J ? Z : b, !c && b >= Z ? l : $g(l, c, b);
      }
      function Ip(l, c) {
        if (c)
          return l.slice();
        var b = l.length, Z = Cy ? Cy(b) : new l.constructor(b);
        return l.copy(Z), Z;
      }
      function pg(l) {
        var c = new l.constructor(l.byteLength);
        return new Zb(c).set(new Zb(l)), c;
      }
      function lp(l, c) {
        return new l.constructor(c ? pg(l.buffer) : l.buffer, l.byteOffset, l.byteLength);
      }
      function ZG(l) {
        var c = new l.constructor(l.source, NI.exec(l));
        return c.lastIndex = l.lastIndex, c;
      }
      function zI(l) {
        return tu ? Rn(tu.call(l)) : {};
      }
      function KA(l, c) {
        return new l.constructor(c ? pg(l.buffer) : l.buffer, l.byteOffset, l.length);
      }
      function DC(l, c) {
        if (l !== c) {
          var b = l !== J, Z = l === null, S = l === l, R = lo(l), D = c !== J, K = c === null, O = c === c, se = lo(c);
          if (!K && !se && !R && l > c || R && D && O && !K && !se || Z && D && O || !b && O || !S)
            return 1;
          if (!Z && !R && !se && l < c || se && b && S && !Z && !R || K && b && S || !D && S || !O)
            return -1;
        }
        return 0;
      }
      function Ma(l, c, b) {
        for (var Z = -1, S = l.criteria, R = c.criteria, D = S.length, K = b.length; ++Z < D; ) {
          var O = DC(S[Z], R[Z]);
          if (O)
            return Z >= K ? O : O * (b[Z] == "desc" ? -1 : 1);
        }
        return l.index - c.index;
      }
      function sp(l, c, b, Z) {
        for (var S = -1, R = l.length, D = b.length, K = -1, O = c.length, se = hn(R - D, 0), oe = $i(O + se), de = !Z; ++K < O; )
          oe[K] = c[K];
        for (; ++S < D; )
          (de || S < R) && (oe[b[S]] = l[S]);
        for (; se--; )
          oe[K++] = l[S++];
        return oe;
      }
      function qg(l, c, b, Z) {
        for (var S = -1, R = l.length, D = -1, K = b.length, O = -1, se = c.length, oe = hn(R - K, 0), de = $i(oe + se), Fe = !Z; ++S < oe; )
          de[S] = l[S];
        for (var Me = S; ++O < se; )
          de[Me + O] = c[O];
        for (; ++D < K; )
          (Fe || S < R) && (de[Me + b[D]] = l[S++]);
        return de;
      }
      function er(l, c) {
        var b = -1, Z = l.length;
        for (c || (c = $i(Z)); ++b < Z; )
          c[b] = l[b];
        return c;
      }
      function OI(l, c, b, Z) {
        var S = !b;
        b || (b = {});
        for (var R = -1, D = c.length; ++R < D; ) {
          var K = c[R], O = Z ? Z(b[K], l[K], K, b, l) : J;
          O === J && (O = l[K]), S ? Dn(b, K, O) : XC(b, K, O);
        }
        return b;
      }
      function kv(l, c) {
        return OI(l, $p(l), c);
      }
      function Fv(l, c) {
        return OI(l, qp(l), c);
      }
      function Pc(l, c) {
        return function(b, Z) {
          var S = pi(b) ? n : Bv, R = c ? c() : {};
          return S(b, l, gi(Z, 2), R);
        };
      }
      function zc(l) {
        return wi(function(c, b) {
          var Z = -1, S = b.length, R = S > 1 ? b[S - 1] : J, D = S > 2 ? b[2] : J;
          for (R = l.length > 3 && typeof R == "function" ? (S--, R) : J, D && Lg(b[0], b[1], D) && (R = S < 3 ? J : R, S = 1), c = Rn(c); ++Z < S; ) {
            var K = b[Z];
            K && l(c, K, Z, R);
          }
          return c;
        });
      }
      function Oc(l, c) {
        return function(b, Z) {
          if (b == null)
            return b;
          if (!Vr(b))
            return l(b, Z);
          for (var S = b.length, R = c ? S : -1, D = Rn(b); (c ? R-- : ++R < S) && Z(D[R], R, D) !== !1; )
            ;
          return b;
        };
      }
      function ap(l) {
        return function(c, b, Z) {
          for (var S = -1, R = Rn(c), D = Z(c), K = D.length; K--; ) {
            var O = D[l ? K : ++S];
            if (b(R[O], O, R) === !1)
              break;
          }
          return c;
        };
      }
      function Yv(l, c, b) {
        function Z() {
          return (this && this !== Ng && this instanceof Z ? R : l).apply(S ? b : this, arguments);
        }
        var S = c & Te, R = JC(l);
        return Z;
      }
      function fG(l) {
        return function(c) {
          c = zi(c);
          var b = Je(c) ? ze(c) : J, Z = b ? b[0] : c.charAt(0), S = b ? Ds(b, 1).join("") : c.slice(1);
          return Z[l]() + S;
        };
      }
      function QI(l) {
        return function(c) {
          return u(oy(ny(c).replace(Lh, "")), l, "");
        };
      }
      function JC(l) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new l();
            case 1:
              return new l(c[0]);
            case 2:
              return new l(c[0], c[1]);
            case 3:
              return new l(c[0], c[1], c[2]);
            case 4:
              return new l(c[0], c[1], c[2], c[3]);
            case 5:
              return new l(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var b = rd(l.prototype), Z = l.apply(b, c);
          return En(Z) ? Z : b;
        };
      }
      function xv(l, c, b) {
        function Z() {
          for (var R = arguments.length, D = $i(R), K = R, O = bi(Z); K--; )
            D[K] = arguments[K];
          var se = R < 3 && D[0] !== O && D[R - 1] !== O ? [] : Ze(D, O);
          return R -= se.length, R < b ? dp(l, c, NA, Z.placeholder, J, D, se, J, J, b - R) : i(this && this !== Ng && this instanceof Z ? S : l, this, D);
        }
        var S = JC(l);
        return Z;
      }
      function EA(l) {
        return function(c, b, Z) {
          var S = Rn(c);
          if (!Vr(c)) {
            var R = gi(b, 3);
            c = Xg(c), b = function(K) {
              return R(S[K], K, S);
            };
          }
          var D = l(c, b, Z);
          return D > -1 ? S[R ? c[D] : D] : J;
        };
      }
      function cp(l) {
        return jI(function(c) {
          var b = c.length, Z = b, S = It.prototype.thru;
          for (l && c.reverse(); Z--; ) {
            var R = c[Z];
            if (typeof R != "function")
              throw new xo(Ye);
            if (S && !D && jc(R) == "wrapper")
              var D = new It([], !0);
          }
          for (Z = D ? Z : b; ++Z < b; ) {
            R = c[Z];
            var K = jc(R), O = K == "wrapper" ? _p(R) : J;
            D = O && _A(O[0]) && O[1] == (si | Oe | Nt | jt) && !O[4].length && O[9] == 1 ? D[jc(O[0])].apply(D, O[3]) : R.length == 1 && _A(R) ? D[K]() : D.thru(R);
          }
          return function() {
            var se = arguments, oe = se[0];
            if (D && se.length == 1 && pi(oe))
              return D.plant(oe).value();
            for (var de = 0, Fe = b ? c[de].apply(this, se) : oe; ++de < b; )
              Fe = c[de].call(this, Fe);
            return Fe;
          };
        });
      }
      function NA(l, c, b, Z, S, R, D, K, O, se) {
        function oe() {
          for (var vt = arguments.length, Rt = $i(vt), an = vt; an--; )
            Rt[an] = arguments[an];
          if (it)
            var cn = bi(oe), lg = Ae(Rt, cn);
          if (Z && (Rt = sp(Rt, Z, S, it)), R && (Rt = qg(Rt, R, D, it)), vt -= lg, it && vt < se)
            return dp(l, c, NA, oe.placeholder, b, Rt, Ze(Rt, cn), K, O, se - vt);
          var Bi = Fe ? b : this, On = Me ? Bi[l] : l;
          return vt = Rt.length, K ? Rt = Tv(Rt, K) : Zt && vt > 1 && Rt.reverse(), de && O < vt && (Rt.length = O), this && this !== Ng && this instanceof oe && (On = nt || JC(On)), On.apply(Bi, Rt);
        }
        var de = c & si, Fe = c & Te, Me = c & Xt, it = c & (Oe | kt), Zt = c & Zi, nt = Me ? J : JC(l);
        return oe;
      }
      function GG(l, c) {
        return function(b, Z) {
          return Ho(b, l, c(Z), {});
        };
      }
      function LA(l, c) {
        return function(b, Z) {
          var S;
          if (b === J && Z === J)
            return c;
          if (b !== J && (S = b), Z !== J) {
            if (S === J)
              return Z;
            typeof b == "string" || typeof Z == "string" ? (b = Gr(b), Z = Gr(Z)) : (b = PI(b), Z = PI(Z)), S = l(b, Z);
          }
          return S;
        };
      }
      function TA(l) {
        return jI(function(c) {
          return c = d(c, L(gi())), wi(function(b) {
            var Z = this;
            return l(c, function(S) {
              return i(S, Z, b);
            });
          });
        });
      }
      function Qc(l, c) {
        c = c === J ? " " : Gr(c);
        var b = c.length;
        if (b < 2)
          return b ? np(c, l) : c;
        var Z = np(c, Ql(l / ot(c)));
        return Je(c) ? Ds(ze(Z), 0, l).join("") : Z.slice(0, l);
      }
      function Dv(l, c, b, Z) {
        function S() {
          for (var K = -1, O = arguments.length, se = -1, oe = Z.length, de = $i(oe + O), Fe = this && this !== Ng && this instanceof S ? D : l; ++se < oe; )
            de[se] = Z[se];
          for (; O--; )
            de[se++] = arguments[++K];
          return i(Fe, R ? b : this, de);
        }
        var R = c & Te, D = JC(l);
        return S;
      }
      function MA(l) {
        return function(c, b, Z) {
          return Z && typeof Z != "number" && Lg(c, b, Z) && (b = Z = J), c = Ul(c), b === J ? (b = c, c = 0) : b = Ul(b), Z = Z === J ? c < b ? 1 : -1 : Ul(Z), Xv(c, b, Z, l);
        };
      }
      function KC(l) {
        return function(c, b) {
          return typeof c == "string" && typeof b == "string" || (c = Yo(c), b = Yo(b)), l(c, b);
        };
      }
      function dp(l, c, b, Z, S, R, D, K, O, se) {
        var oe = c & Oe, de = oe ? D : J, Fe = oe ? J : D, Me = oe ? R : J, it = oe ? J : R;
        c |= oe ? Nt : ni, c &= ~(oe ? ni : Nt), c & Pe || (c &= ~(Te | Xt));
        var Zt = [l, c, S, Me, de, it, Fe, K, O, se], nt = b.apply(J, Zt);
        return _A(l) && yy(nt, Zt), nt.placeholder = Z, wG(nt, l, c);
      }
      function UA(l) {
        var c = li[l];
        return function(b, Z) {
          if (b = Yo(b), Z = Z == null ? 0 : Qt(Wi(Z), 292), Z && my(b)) {
            var S = (zi(b) + "e").split("e");
            return S = (zi(c(S[0] + "e" + (+S[1] + Z))) + "e").split("e"), +(S[0] + "e" + (+S[1] - Z));
          }
          return c(b);
        };
      }
      function EC(l) {
        return function(c) {
          var b = rr(c);
          return b == oi ? ue(c) : b == Zr ? $e(c) : q(c, l(c));
        };
      }
      function El(l, c, b, Z, S, R, D, K) {
        var O = c & Xt;
        if (!O && typeof l != "function")
          throw new xo(Ye);
        var se = Z ? Z.length : 0;
        if (se || (c &= ~(Nt | ni), Z = S = J), D = D === J ? D : hn(Wi(D), 0), K = K === J ? K : Wi(K), se -= S ? S.length : 0, c & ni) {
          var oe = Z, de = S;
          Z = S = J;
        }
        var Fe = O ? J : _p(l), Me = [l, c, b, Z, S, oe, de, R, D, K];
        if (Fe && Lv(Me, Fe), l = Me[0], c = Me[1], b = Me[2], Z = Me[3], S = Me[4], K = Me[9] = Me[9] === J ? O ? 0 : l.length : hn(Me[9] - se, 0), !K && c & (Oe | kt) && (c &= ~(Oe | kt)), c && c != Te)
          it = c == Oe || c == kt ? xv(l, c, K) : c != Nt && c != (Te | Nt) || S.length ? NA.apply(J, Me) : Dv(l, c, b, Z);
        else
          var it = Yv(l, c, b);
        return wG((Fe ? Gy : yy)(it, Me), l, c);
      }
      function Cp(l, c, b, Z) {
        return l === J || Fo(l, nd[b]) && !qi.call(Z, b) ? c : l;
      }
      function up(l, c, b, Z, S, R) {
        return En(l) && En(c) && (R.set(c, l), FA(l, c, J, up, R), R.delete(c)), l;
      }
      function Jv(l) {
        return QC(l) ? J : l;
      }
      function Ap(l, c, b, Z, S, R) {
        var D = b & Gt, K = l.length, O = c.length;
        if (K != O && !(D && O > K))
          return !1;
        var se = R.get(l), oe = R.get(c);
        if (se && oe)
          return se == c && oe == l;
        var de = -1, Fe = !0, Me = b & Jt ? new TI() : J;
        for (R.set(l, c), R.set(c, l); ++de < K; ) {
          var it = l[de], Zt = c[de];
          if (Z)
            var nt = D ? Z(Zt, it, de, c, l, R) : Z(it, Zt, de, l, c, R);
          if (nt !== J) {
            if (nt)
              continue;
            Fe = !1;
            break;
          }
          if (Me) {
            if (!m(c, function(vt, Rt) {
              if (!Q(Me, Rt) && (it === vt || S(it, vt, b, Z, R)))
                return Me.push(Rt);
            })) {
              Fe = !1;
              break;
            }
          } else if (it !== Zt && !S(it, Zt, b, Z, R)) {
            Fe = !1;
            break;
          }
        }
        return R.delete(l), R.delete(c), Fe;
      }
      function Kv(l, c, b, Z, S, R, D) {
        switch (b) {
          case Fl:
            if (l.byteLength != c.byteLength || l.byteOffset != c.byteOffset)
              return !1;
            l = l.buffer, c = c.buffer;
          case Ra:
            return !(l.byteLength != c.byteLength || !R(new Zb(l), new Zb(c)));
          case He:
          case We:
          case mg:
            return Fo(+l, +c);
          case at:
            return l.name == c.name && l.message == c.message;
          case II:
          case lI:
            return l == c + "";
          case oi:
            var K = ue;
          case Zr:
            var O = Z & Gt;
            if (K || (K = Ke), l.size != c.size && !O)
              return !1;
            var se = D.get(l);
            if (se)
              return se == c;
            Z |= Jt, D.set(l, c);
            var oe = Ap(K(l), K(c), Z, S, R, D);
            return D.delete(l), oe;
          case Rs:
            if (tu)
              return tu.call(l) == tu.call(c);
        }
        return !1;
      }
      function bp(l, c, b, Z, S, R) {
        var D = b & Gt, K = NC(l), O = K.length;
        if (O != NC(c).length && !D)
          return !1;
        for (var se = O; se--; ) {
          var oe = K[se];
          if (!(D ? oe in c : qi.call(c, oe)))
            return !1;
        }
        var de = R.get(l), Fe = R.get(c);
        if (de && Fe)
          return de == c && Fe == l;
        var Me = !0;
        R.set(l, c), R.set(c, l);
        for (var it = D; ++se < O; ) {
          oe = K[se];
          var Zt = l[oe], nt = c[oe];
          if (Z)
            var vt = D ? Z(nt, Zt, oe, c, l, R) : Z(Zt, nt, oe, l, c, R);
          if (!(vt === J ? Zt === nt || S(Zt, nt, b, Z, R) : vt)) {
            Me = !1;
            break;
          }
          it || (it = oe == "constructor");
        }
        if (Me && !it) {
          var Rt = l.constructor, an = c.constructor;
          Rt != an && "constructor" in l && "constructor" in c && !(typeof Rt == "function" && Rt instanceof Rt && typeof an == "function" && an instanceof an) && (Me = !1);
        }
        return R.delete(l), R.delete(c), Me;
      }
      function jI(l) {
        return e0(pp(l, J, qc), l + "");
      }
      function NC(l) {
        return lG(l, Xg, $p);
      }
      function mp(l) {
        return lG(l, zr, qp);
      }
      function jc(l) {
        for (var c = l.name + "", b = gd[c], Z = qi.call(gd, c) ? b.length : 0; Z--; ) {
          var S = b[Z], R = S.func;
          if (R == null || R == l)
            return S.name;
        }
        return c;
      }
      function bi(l) {
        return (qi.call(X, "placeholder") ? X : l).placeholder;
      }
      function gi() {
        var l = X.iteratee || ub;
        return l = l === ub ? dG : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function PA(l, c) {
        var b = l.__data__;
        return jA(c) ? b[typeof c == "string" ? "string" : "hash"] : b.map;
      }
      function Ua(l) {
        for (var c = Xg(l), b = c.length; b--; ) {
          var Z = c[b], S = l[Z];
          c[b] = [Z, S, $A(S)];
        }
        return c;
      }
      function Js(l, c) {
        var b = Ee(l, c);
        return cG(b) ? b : J;
      }
      function Ev(l) {
        var c = qi.call(l, Ol), b = l[Ol];
        try {
          l[Ol] = J;
          var Z = !0;
        } catch {
        }
        var S = Do.call(l);
        return Z && (c ? l[Ol] = b : delete l[Ol]), S;
      }
      function Nv(l, c, b) {
        for (var Z = -1, S = b.length; ++Z < S; ) {
          var R = b[Z], D = R.size;
          switch (R.type) {
            case "drop":
              l += D;
              break;
            case "dropRight":
              c -= D;
              break;
            case "take":
              c = Qt(c, l + D);
              break;
            case "takeRight":
              l = hn(l, c - D);
          }
        }
        return { start: l, end: c };
      }
      function ko(l) {
        var c = l.match(hA);
        return c ? c[1].split(Hh) : [];
      }
      function yG(l, c, b) {
        c = dI(c, l);
        for (var Z = -1, S = c.length, R = !1; ++Z < S; ) {
          var D = _I(c[Z]);
          if (!(R = l != null && b(l, D)))
            break;
          l = l[D];
        }
        return R || ++Z != S ? R : (S = l == null ? 0 : l.length, !!S && wr(S) && tr(D, S) && (pi(l) || Qa(l)));
      }
      function zA(l) {
        var c = l.length, b = new l.constructor(c);
        return c && typeof l[0] == "string" && qi.call(l, "index") && (b.index = l.index, b.input = l.input), b;
      }
      function OA(l) {
        return typeof l.constructor != "function" || _c(l) ? {} : rd(fb(l));
      }
      function WG(l, c, b) {
        var Z = l.constructor;
        switch (c) {
          case Ra:
            return pg(l);
          case He:
          case We:
            return new Z(+l);
          case Fl:
            return lp(l, b);
          case Hc:
          case kc:
          case Xa:
          case Ha:
          case uC:
          case Fc:
          case Xs:
          case ka:
          case AC:
            return KA(l, b);
          case oi:
            return new Z();
          case mg:
          case lI:
            return new Z(l);
          case II:
            return ZG(l);
          case Zr:
            return new Z();
          case Rs:
            return zI(l);
        }
      }
      function SG(l, c) {
        var b = c.length;
        if (!b)
          return l;
        var Z = b - 1;
        return c[Z] = (b > 1 ? "& " : "") + c[Z], c = c.join(b > 2 ? ", " : " "), l.replace(yC, `{
/* [wrapped with ` + c + `] */
`);
      }
      function Io(l) {
        return pi(l) || Qa(l) || !!(Op && l && l[Op]);
      }
      function tr(l, c) {
        var b = typeof l;
        return c = c ?? ei, !!c && (b == "number" || b != "symbol" && Gi.test(l)) && l > -1 && l % 1 == 0 && l < c;
      }
      function Lg(l, c, b) {
        if (!En(b))
          return !1;
        var Z = typeof c;
        return !!(Z == "number" ? Vr(b) && tr(c, b.length) : Z == "string" && c in b) && Fo(b[c], l);
      }
      function QA(l, c) {
        if (pi(l))
          return !1;
        var b = typeof l;
        return !(b != "number" && b != "symbol" && b != "boolean" && l != null && !lo(l)) || mA.test(l) || !Jc.test(l) || c != null && l in Rn(c);
      }
      function jA(l) {
        var c = typeof l;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? l !== "__proto__" : l === null;
      }
      function _A(l) {
        var c = jc(l), b = X[c];
        if (typeof b != "function" || !(c in lt.prototype))
          return !1;
        if (l === b)
          return !0;
        var Z = _p(b);
        return !!Z && l === Z[0];
      }
      function hp(l) {
        return !!cy && cy in l;
      }
      function _c(l) {
        var c = l && l.constructor;
        return l === (typeof c == "function" && c.prototype || nd);
      }
      function $A(l) {
        return l === l && !En(l);
      }
      function qA(l, c) {
        return function(b) {
          return b != null && b[l] === c && (c !== J || l in Rn(b));
        };
      }
      function Ks(l) {
        var c = lb(l, function(Z) {
          return b.size === qt && b.clear(), Z;
        }), b = c.cache;
        return c;
      }
      function Lv(l, c) {
        var b = l[1], Z = c[1], S = b | Z, R = S < (Te | Xt | si), D = Z == si && b == Oe || Z == si && b == jt && l[7].length <= c[8] || Z == (si | jt) && c[7].length <= c[8] && b == Oe;
        if (!R && !D)
          return l;
        Z & Te && (l[2] = c[2], S |= b & Te ? 0 : Pe);
        var K = c[3];
        if (K) {
          var O = l[3];
          l[3] = O ? sp(O, K, c[4]) : K, l[4] = O ? Ze(l[3], Ut) : c[4];
        }
        return K = c[5], K && (O = l[5], l[5] = O ? qg(O, K, c[6]) : K, l[6] = O ? Ze(l[5], Ut) : c[6]), K = c[7], K && (l[7] = K), Z & si && (l[8] = l[8] == null ? c[8] : Qt(l[8], c[8])), l[9] == null && (l[9] = c[9]), l[0] = c[0], l[1] = S, l;
      }
      function Es(l) {
        var c = [];
        if (l != null)
          for (var b in Rn(l))
            c.push(b);
        return c;
      }
      function VG(l) {
        return Do.call(l);
      }
      function pp(l, c, b) {
        return c = hn(c === J ? l.length - 1 : c, 0), function() {
          for (var Z = arguments, S = -1, R = hn(Z.length - c, 0), D = $i(R); ++S < R; )
            D[S] = Z[c + S];
          S = -1;
          for (var K = $i(c + 1); ++S < c; )
            K[S] = Z[S];
          return K[c] = b(D), i(l, this, K);
        };
      }
      function eb(l, c) {
        return c.length < 2 ? l : Na(l, $g(c, 0, -1));
      }
      function Tv(l, c) {
        for (var b = l.length, Z = Qt(c.length, b), S = er(l); Z--; ) {
          var R = c[Z];
          l[Z] = tr(R, b) ? S[R] : J;
        }
        return l;
      }
      function Bp(l, c) {
        if ((c !== "constructor" || typeof l[c] != "function") && c != "__proto__")
          return l[c];
      }
      function wG(l, c, b) {
        var Z = c + "";
        return e0(l, SG(Z, vG(ko(Z), b)));
      }
      function Zp(l) {
        var c = 0, b = 0;
        return function() {
          var Z = py(), S = xn - (Z - b);
          if (b = Z, S > 0) {
            if (++c >= In)
              return arguments[0];
          } else
            c = 0;
          return l.apply(J, arguments);
        };
      }
      function LC(l, c) {
        var b = -1, Z = l.length, S = Z - 1;
        for (c = c === J ? Z : c; ++b < c; ) {
          var R = ip(b, S), D = l[R];
          l[R] = l[b], l[b] = D;
        }
        return l.length = c, l;
      }
      function _I(l) {
        if (typeof l == "string" || lo(l))
          return l;
        var c = l + "";
        return c == "0" && 1 / l == -vi ? "-0" : c;
      }
      function Ns(l) {
        if (l != null) {
          try {
            return pb.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function vG(l, c) {
        return g(bg, function(b) {
          var Z = "_." + b[0];
          c & b[1] && !s(l, Z) && l.push(Z);
        }), l.sort();
      }
      function yr(l) {
        if (l instanceof lt)
          return l.clone();
        var c = new It(l.__wrapped__, l.__chain__);
        return c.__actions__ = er(l.__actions__), c.__index__ = l.__index__, c.__values__ = l.__values__, c;
      }
      function $I(l, c, b) {
        c = (b ? Lg(l, c, b) : c === J) ? 1 : hn(Wi(c), 0);
        var Z = l == null ? 0 : l.length;
        if (!Z || c < 1)
          return [];
        for (var S = 0, R = 0, D = $i(Ql(Z / c)); S < Z; )
          D[R++] = $g(l, S, S += c);
        return D;
      }
      function Mv(l) {
        for (var c = -1, b = l == null ? 0 : l.length, Z = 0, S = []; ++c < b; ) {
          var R = l[c];
          R && (S[Z++] = R);
        }
        return S;
      }
      function Uv() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var c = $i(l - 1), b = arguments[0], Z = l; Z--; )
          c[Z - 1] = arguments[Z];
        return C(pi(b) ? er(b) : [b], Pn(c, 1));
      }
      function tb(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (c = b || c === J ? 1 : Wi(c), $g(l, c < 0 ? 0 : c, Z)) : [];
      }
      function $c(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (c = b || c === J ? 1 : Wi(c), c = Z - c, $g(l, 0, c < 0 ? 0 : c)) : [];
      }
      function RG(l, c) {
        return l && l.length ? xC(l, gi(c, 3), !0, !0) : [];
      }
      function XG(l, c) {
        return l && l.length ? xC(l, gi(c, 3), !0) : [];
      }
      function Pv(l, c, b, Z) {
        var S = l == null ? 0 : l.length;
        return S ? (b && typeof b != "number" && Lg(l, c, b) && (b = 0, Z = S), kC(l, c, b, Z)) : [];
      }
      function fp(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = b == null ? 0 : Wi(b);
        return S < 0 && (S = hn(Z + S, 0)), G(l, gi(c, 3), S);
      }
      function Pa(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = Z - 1;
        return b !== J && (S = Wi(b), S = b < 0 ? hn(Z + S, 0) : Qt(S, Z - 1)), G(l, gi(c, 3), S, !0);
      }
      function qc(l) {
        return l != null && l.length ? Pn(l, 1) : [];
      }
      function zv(l) {
        return l != null && l.length ? Pn(l, vi) : [];
      }
      function HG(l, c) {
        return l != null && l.length ? (c = c === J ? 1 : Wi(c), Pn(l, c)) : [];
      }
      function kG(l) {
        for (var c = -1, b = l == null ? 0 : l.length, Z = {}; ++c < b; ) {
          var S = l[c];
          Z[S[0]] = S[1];
        }
        return Z;
      }
      function TC(l) {
        return l && l.length ? l[0] : J;
      }
      function FG(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = b == null ? 0 : Wi(b);
        return S < 0 && (S = hn(Z + S, 0)), y(l, c, S);
      }
      function ib(l) {
        return l != null && l.length ? $g(l, 0, -1) : [];
      }
      function Gp(l, c) {
        return l == null ? "" : DX.call(l, c);
      }
      function Wr(l) {
        var c = l == null ? 0 : l.length;
        return c ? l[c - 1] : J;
      }
      function Ov(l, c, b) {
        var Z = l == null ? 0 : l.length;
        if (!Z)
          return -1;
        var S = Z;
        return b !== J && (S = Wi(b), S = S < 0 ? hn(Z + S, 0) : Qt(S, Z - 1)), c === c ? dt(l, c, S) : G(l, V, S, !0);
      }
      function YG(l, c) {
        return l && l.length ? AG(l, Wi(c)) : J;
      }
      function MC(l, c) {
        return l && l.length && c && c.length ? tp(l, c) : l;
      }
      function xG(l, c, b) {
        return l && l.length && c && c.length ? tp(l, c, gi(b, 2)) : l;
      }
      function yp(l, c, b) {
        return l && l.length && c && c.length ? tp(l, c, J, b) : l;
      }
      function Qv(l, c) {
        var b = [];
        if (!l || !l.length)
          return b;
        var Z = -1, S = [], R = l.length;
        for (c = gi(c, 3); ++Z < R; ) {
          var D = l[Z];
          c(D, Z, l) && (b.push(D), S.push(Z));
        }
        return mG(l, S), b;
      }
      function nb(l) {
        return l == null ? l : JX.call(l);
      }
      function Nl(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (b && typeof b != "number" && Lg(l, c, b) ? (c = 0, b = Z) : (c = c == null ? 0 : Wi(c), b = b === J ? Z : Wi(b)), $g(l, c, b)) : [];
      }
      function DG(l, c) {
        return xA(l, c);
      }
      function JG(l, c, b) {
        return DA(l, c, gi(b, 2));
      }
      function jv(l, c) {
        var b = l == null ? 0 : l.length;
        if (b) {
          var Z = xA(l, c);
          if (Z < b && Fo(l[Z], c))
            return Z;
        }
        return -1;
      }
      function KG(l, c) {
        return xA(l, c, !0);
      }
      function _v(l, c, b) {
        return DA(l, c, gi(b, 2), !0);
      }
      function $v(l, c) {
        if (l != null && l.length) {
          var b = xA(l, c, !0) - 1;
          if (Fo(l[b], c))
            return b;
        }
        return -1;
      }
      function Ll(l) {
        return l && l.length ? pG(l) : [];
      }
      function Wp(l, c) {
        return l && l.length ? pG(l, gi(c, 2)) : [];
      }
      function Sp(l) {
        var c = l == null ? 0 : l.length;
        return c ? $g(l, 1, c) : [];
      }
      function Vp(l, c, b) {
        return l && l.length ? (c = b || c === J ? 1 : Wi(c), $g(l, 0, c < 0 ? 0 : c)) : [];
      }
      function gb(l, c, b) {
        var Z = l == null ? 0 : l.length;
        return Z ? (c = b || c === J ? 1 : Wi(c), c = Z - c, $g(l, c < 0 ? 0 : c, Z)) : [];
      }
      function ed(l, c) {
        return l && l.length ? xC(l, gi(c, 3), !1, !0) : [];
      }
      function ri(l, c) {
        return l && l.length ? xC(l, gi(c, 3)) : [];
      }
      function rb(l) {
        return l && l.length ? Ur(l) : [];
      }
      function wp(l, c) {
        return l && l.length ? Ur(l, gi(c, 2)) : [];
      }
      function za(l, c) {
        return c = typeof c == "function" ? c : J, l && l.length ? Ur(l, J, c) : [];
      }
      function vp(l) {
        if (!l || !l.length)
          return [];
        var c = 0;
        return l = I(l, function(b) {
          if (qn(b))
            return c = hn(b.length, c), !0;
        }), $(c, function(b) {
          return d(l, v(b));
        });
      }
      function ob(l, c) {
        if (!l || !l.length)
          return [];
        var b = vp(l);
        return c == null ? b : d(b, function(Z) {
          return i(c, J, Z);
        });
      }
      function EG(l, c) {
        return Kl(l || [], c || [], XC);
      }
      function ir(l, c) {
        return Kl(l || [], c || [], YC);
      }
      function NG(l) {
        var c = X(l);
        return c.__chain__ = !0, c;
      }
      function qv(l, c) {
        return c(l), l;
      }
      function UC(l, c) {
        return c(l);
      }
      function eR() {
        return NG(this);
      }
      function LG() {
        return new It(this.value(), this.__chain__);
      }
      function tR() {
        this.__values__ === J && (this.__values__ = _G(this.value()));
        var l = this.__index__ >= this.__values__.length;
        return { done: l, value: l ? J : this.__values__[this.__index__++] };
      }
      function iR() {
        return this;
      }
      function nR(l) {
        for (var c, b = this; b instanceof De; ) {
          var Z = yr(b);
          Z.__index__ = 0, Z.__values__ = J, c ? S.__wrapped__ = Z : c = Z;
          var S = Z;
          b = b.__wrapped__;
        }
        return S.__wrapped__ = l, c;
      }
      function Tl() {
        var l = this.__wrapped__;
        if (l instanceof lt) {
          var c = l;
          return this.__actions__.length && (c = new lt(this)), c = c.reverse(), c.__actions__.push({ func: UC, args: [nb], thisArg: J }), new It(c, this.__chain__);
        }
        return this.thru(nb);
      }
      function Sr() {
        return rp(this.__wrapped__, this.__actions__);
      }
      function Rp(l, c, b) {
        var Z = pi(l) ? o : Tc;
        return b && Lg(l, c, b) && (c = J), Z(l, gi(c, 3));
      }
      function gR(l, c) {
        return (pi(l) ? I : FC)(l, gi(c, 3));
      }
      function Xp(l, c) {
        return Pn(Ib(l, c), 1);
      }
      function rR(l, c) {
        return Pn(Ib(l, c), vi);
      }
      function oR(l, c, b) {
        return b = b === J ? 1 : Wi(b), Pn(Ib(l, c), b);
      }
      function td(l, c) {
        return (pi(l) ? g : qI)(l, gi(c, 3));
      }
      function Hp(l, c) {
        return (pi(l) ? r : Zy)(l, gi(c, 3));
      }
      function TG(l, c, b, Z) {
        l = Vr(l) ? l : id(l), b = b && !Z ? Wi(b) : 0;
        var S = l.length;
        return b < 0 && (b = hn(S + b, 0)), ab(l) ? b <= S && l.indexOf(c, b) > -1 : !!S && y(l, c, b) > -1;
      }
      function Ib(l, c) {
        return (pi(l) ? d : UI)(l, gi(c, 3));
      }
      function IR(l, c, b, Z) {
        return l == null ? [] : (pi(c) || (c = c == null ? [] : [c]), b = Z ? J : b, pi(b) || (b = b == null ? [] : [b]), xs(l, c, b));
      }
      function lR(l, c, b) {
        var Z = pi(l) ? u : x, S = arguments.length < 3;
        return Z(l, gi(c, 4), b, S, qI);
      }
      function sR(l, c, b) {
        var Z = pi(l) ? A : x, S = arguments.length < 3;
        return Z(l, gi(c, 4), b, S, Zy);
      }
      function MG(l, c) {
        return (pi(l) ? I : FC)(l, OC(gi(c, 3)));
      }
      function UG(l) {
        return (pi(l) ? oG : hG)(l);
      }
      function aR(l, c, b) {
        return c = (b ? Lg(l, c, b) : c === J) ? 1 : Wi(c), (pi(l) ? RA : Hv)(l, c);
      }
      function kp(l) {
        return (pi(l) ? XA : gp)(l);
      }
      function PG(l) {
        if (l == null)
          return 0;
        if (Vr(l))
          return ab(l) ? ot(l) : l.length;
        var c = rr(l);
        return c == oi || c == Zr ? l.size : qh(l).length;
      }
      function PC(l, c, b) {
        var Z = pi(l) ? m : YA;
        return b && Lg(l, c, b) && (c = J), Z(l, gi(c, 3));
      }
      function Fp(l, c) {
        if (typeof c != "function")
          throw new xo(Ye);
        return l = Wi(l), function() {
          if (--l < 1)
            return c.apply(this, arguments);
        };
      }
      function Yp(l, c, b) {
        return c = b ? J : c, c = l && c == null ? l.length : c, El(l, si, J, J, J, J, c);
      }
      function xp(l, c) {
        var b;
        if (typeof c != "function")
          throw new xo(Ye);
        return l = Wi(l), function() {
          return --l > 0 && (b = c.apply(this, arguments)), l <= 1 && (c = J), b;
        };
      }
      function zC(l, c, b) {
        c = b ? J : c;
        var Z = El(l, Oe, J, J, J, J, J, c);
        return Z.placeholder = zC.placeholder, Z;
      }
      function Dp(l, c, b) {
        c = b ? J : c;
        var Z = El(l, kt, J, J, J, J, J, c);
        return Z.placeholder = Dp.placeholder, Z;
      }
      function CI(l, c, b) {
        function Z(Bi) {
          var On = Fe, ao = Me;
          return Fe = Me = J, Rt = Bi, Zt = l.apply(ao, On);
        }
        function S(Bi) {
          return Rt = Bi, nt = od(K, c), an ? Z(Bi) : Zt;
        }
        function R(Bi) {
          var On = Bi - vt, ao = Bi - Rt, C0 = c - On;
          return cn ? Qt(C0, it - ao) : C0;
        }
        function D(Bi) {
          var On = Bi - vt, ao = Bi - Rt;
          return vt === J || On >= c || On < 0 || cn && ao >= it;
        }
        function K() {
          var Bi = Rb();
          return D(Bi) ? O(Bi) : (nt = od(K, R(Bi)), J);
        }
        function O(Bi) {
          return nt = J, lg && Fe ? Z(Bi) : (Fe = Me = J, Zt);
        }
        function se() {
          nt !== J && vr(nt), Rt = 0, Fe = vt = Me = nt = J;
        }
        function oe() {
          return nt === J ? Zt : O(Rb());
        }
        function de() {
          var Bi = Rb(), On = D(Bi);
          if (Fe = arguments, Me = this, vt = Bi, On) {
            if (nt === J)
              return S(vt);
            if (cn)
              return vr(nt), nt = od(K, c), Z(vt);
          }
          return nt === J && (nt = od(K, c)), Zt;
        }
        var Fe, Me, it, Zt, nt, vt, Rt = 0, an = !1, cn = !1, lg = !0;
        if (typeof l != "function")
          throw new xo(Ye);
        return c = Yo(c) || 0, En(b) && (an = !!b.leading, cn = "maxWait" in b, it = cn ? hn(Yo(b.maxWait) || 0, c) : it, lg = "trailing" in b ? !!b.trailing : lg), de.cancel = se, de.flush = oe, de;
      }
      function Oa(l) {
        return El(l, Zi);
      }
      function lb(l, c) {
        if (typeof l != "function" || c != null && typeof c != "function")
          throw new xo(Ye);
        var b = function() {
          var Z = arguments, S = c ? c.apply(this, Z) : Z[0], R = b.cache;
          if (R.has(S))
            return R.get(S);
          var D = l.apply(this, Z);
          return b.cache = R.set(S, D) || R, D;
        };
        return b.cache = new (lb.Cache || Dl)(), b;
      }
      function OC(l) {
        if (typeof l != "function")
          throw new xo(Ye);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, c[0]);
            case 2:
              return !l.call(this, c[0], c[1]);
            case 3:
              return !l.call(this, c[0], c[1], c[2]);
          }
          return !l.apply(this, c);
        };
      }
      function cR(l) {
        return xp(2, l);
      }
      function dR(l, c) {
        if (typeof l != "function")
          throw new xo(Ye);
        return c = c === J ? c : Wi(c), wi(l, c);
      }
      function CR(l, c) {
        if (typeof l != "function")
          throw new xo(Ye);
        return c = c == null ? 0 : hn(Wi(c), 0), wi(function(b) {
          var Z = b[c], S = Ds(b, 0, c);
          return Z && C(S, Z), i(l, this, S);
        });
      }
      function uR(l, c, b) {
        var Z = !0, S = !0;
        if (typeof l != "function")
          throw new xo(Ye);
        return En(b) && (Z = "leading" in b ? !!b.leading : Z, S = "trailing" in b ? !!b.trailing : S), CI(l, c, { leading: Z, maxWait: c, trailing: S });
      }
      function AR(l) {
        return Yp(l, 1);
      }
      function bR(l, c) {
        return i0(op(c), l);
      }
      function mR() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return pi(l) ? l : [l];
      }
      function hR(l) {
        return oo(l, _e);
      }
      function pR(l, c) {
        return c = typeof c == "function" ? c : J, oo(l, _e, c);
      }
      function BR(l) {
        return oo(l, Ge | _e);
      }
      function ZR(l, c) {
        return c = typeof c == "function" ? c : J, oo(l, Ge | _e, c);
      }
      function zG(l, c) {
        return c == null || HA(l, c, Xg(c));
      }
      function Fo(l, c) {
        return l === c || l !== l && c !== c;
      }
      function Vr(l) {
        return l != null && wr(l.length) && !Ml(l);
      }
      function qn(l) {
        return zn(l) && Vr(l);
      }
      function fR(l) {
        return l === !0 || l === !1 || zn(l) && Rg(l) == He;
      }
      function GR(l) {
        return zn(l) && l.nodeType === 1 && !QC(l);
      }
      function OG(l) {
        if (l == null)
          return !0;
        if (Vr(l) && (pi(l) || typeof l == "string" || typeof l.splice == "function" || el(l) || ld(l) || Qa(l)))
          return !l.length;
        var c = rr(l);
        if (c == oi || c == Zr)
          return !l.size;
        if (_c(l))
          return !qh(l).length;
        for (var b in l)
          if (qi.call(l, b))
            return !1;
        return !0;
      }
      function yR(l, c) {
        return aI(l, c);
      }
      function WR(l, c, b) {
        b = typeof b == "function" ? b : J;
        var Z = b ? b(l, c) : J;
        return Z === J ? aI(l, c, J, b) : !!Z;
      }
      function Jp(l) {
        if (!zn(l))
          return !1;
        var c = Rg(l);
        return c == at || c == yt || typeof l.message == "string" && typeof l.name == "string" && !QC(l);
      }
      function SR(l) {
        return typeof l == "number" && my(l);
      }
      function Ml(l) {
        if (!En(l))
          return !1;
        var c = Rg(l);
        return c == Lt || c == Ht || c == Br || c == AA;
      }
      function QG(l) {
        return typeof l == "number" && l == Wi(l);
      }
      function wr(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= ei;
      }
      function En(l) {
        var c = typeof l;
        return l != null && (c == "object" || c == "function");
      }
      function zn(l) {
        return l != null && typeof l == "object";
      }
      function VR(l, c) {
        return l === c || $h(l, c, Ua(c));
      }
      function jG(l, c, b) {
        return b = typeof b == "function" ? b : J, $h(l, c, Ua(c), b);
      }
      function wR(l) {
        return sb(l) && l != +l;
      }
      function vR(l) {
        if (PX(l))
          throw new Pp(Le);
        return cG(l);
      }
      function RR(l) {
        return l === null;
      }
      function XR(l) {
        return l == null;
      }
      function sb(l) {
        return typeof l == "number" || zn(l) && Rg(l) == mg;
      }
      function QC(l) {
        if (!zn(l) || Rg(l) != oI)
          return !1;
        var c = fb(l);
        if (c === null)
          return !0;
        var b = qi.call(c, "constructor") && c.constructor;
        return typeof b == "function" && b instanceof b && pb.call(b) == dy;
      }
      function HR(l) {
        return QG(l) && l >= -ei && l <= ei;
      }
      function ab(l) {
        return typeof l == "string" || !pi(l) && zn(l) && Rg(l) == lI;
      }
      function lo(l) {
        return typeof l == "symbol" || zn(l) && Rg(l) == Rs;
      }
      function kR(l) {
        return l === J;
      }
      function FR(l) {
        return zn(l) && rr(l) == va;
      }
      function YR(l) {
        return zn(l) && Rg(l) == bA;
      }
      function _G(l) {
        if (!l)
          return [];
        if (Vr(l))
          return ab(l) ? ze(l) : er(l);
        if (zl && l[zl])
          return Be(l[zl]());
        var c = rr(l);
        return (c == oi ? ue : c == Zr ? Ke : id)(l);
      }
      function Ul(l) {
        return l ? (l = Yo(l), l === vi || l === -vi ? (l < 0 ? -1 : 1) * yn : l === l ? l : 0) : l === 0 ? l : 0;
      }
      function Wi(l) {
        var c = Ul(l), b = c % 1;
        return c === c ? b ? c - b : c : 0;
      }
      function $G(l) {
        return l ? Ka(Wi(l), 0, bn) : 0;
      }
      function Yo(l) {
        if (typeof l == "number")
          return l;
        if (lo(l))
          return Mi;
        if (En(l)) {
          var c = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = En(c) ? c + "" : c;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = E(l);
        var b = Yh.test(l);
        return b || Dh.test(l) ? sv(l.slice(2), b ? 2 : 8) : Fh.test(l) ? Mi : +l;
      }
      function qG(l) {
        return OI(l, zr(l));
      }
      function xR(l) {
        return l ? Ka(Wi(l), -ei, ei) : l === 0 ? l : 0;
      }
      function zi(l) {
        return l == null ? "" : Gr(l);
      }
      function DR(l, c) {
        var b = rd(l);
        return c == null ? b : IG(b, c);
      }
      function JR(l, c) {
        return f(l, gi(c, 3), MI);
      }
      function KR(l, c) {
        return f(l, gi(c, 3), _h);
      }
      function ER(l, c) {
        return l == null ? l : iu(l, gi(c, 3), zr);
      }
      function NR(l, c) {
        return l == null ? l : fy(l, gi(c, 3), zr);
      }
      function Kp(l, c) {
        return l && MI(l, gi(c, 3));
      }
      function ey(l, c) {
        return l && _h(l, gi(c, 3));
      }
      function LR(l) {
        return l == null ? [] : kA(l, Xg(l));
      }
      function TR(l) {
        return l == null ? [] : kA(l, zr(l));
      }
      function Ep(l, c, b) {
        var Z = l == null ? J : Na(l, c);
        return Z === J ? b : Z;
      }
      function MR(l, c) {
        return l != null && yG(l, c, sG);
      }
      function Np(l, c) {
        return l != null && yG(l, c, z);
      }
      function Xg(l) {
        return Vr(l) ? rG(l) : qh(l);
      }
      function zr(l) {
        return Vr(l) ? rG(l, !0) : wv(l);
      }
      function UR(l, c) {
        var b = {};
        return c = gi(c, 3), MI(l, function(Z, S, R) {
          Dn(b, c(Z, S, R), Z);
        }), b;
      }
      function ty(l, c) {
        var b = {};
        return c = gi(c, 3), MI(l, function(Z, S, R) {
          Dn(b, S, c(Z, S, R));
        }), b;
      }
      function PR(l, c) {
        return jC(l, OC(gi(c)));
      }
      function jC(l, c) {
        if (l == null)
          return {};
        var b = d(mp(l), function(Z) {
          return [Z];
        });
        return c = gi(c), bG(l, b, function(Z, S) {
          return c(Z, S[0]);
        });
      }
      function zR(l, c, b) {
        c = dI(c, l);
        var Z = -1, S = c.length;
        for (S || (S = 1, l = J); ++Z < S; ) {
          var R = l == null ? J : l[_I(c[Z])];
          R === J && (Z = S, R = b), l = Ml(R) ? R.call(l) : R;
        }
        return l;
      }
      function OR(l, c, b) {
        return l == null ? l : YC(l, c, b);
      }
      function QR(l, c, b, Z) {
        return Z = typeof Z == "function" ? Z : J, l == null ? l : YC(l, c, b, Z);
      }
      function jR(l, c, b) {
        var Z = pi(l), S = Z || el(l) || ld(l);
        if (c = gi(c, 4), b == null) {
          var R = l && l.constructor;
          b = S ? Z ? new R() : [] : En(l) && Ml(R) ? rd(fb(l)) : {};
        }
        return (S ? g : MI)(l, function(D, K, O) {
          return c(b, D, K, O);
        }), b;
      }
      function _R(l, c) {
        return l == null || Pr(l, c);
      }
      function $R(l, c, b) {
        return l == null ? l : BG(l, c, op(b));
      }
      function qR(l, c, b, Z) {
        return Z = typeof Z == "function" ? Z : J, l == null ? l : BG(l, c, op(b), Z);
      }
      function id(l) {
        return l == null ? [] : P(l, Xg(l));
      }
      function eX(l) {
        return l == null ? [] : P(l, zr(l));
      }
      function tX(l, c, b) {
        return b === J && (b = c, c = J), b !== J && (b = Yo(b), b = b === b ? b : 0), c !== J && (c = Yo(c), c = c === c ? c : 0), Ka(Yo(l), c, b);
      }
      function iX(l, c, b) {
        return c = Ul(c), b === J ? (b = c, c = 0) : b = Ul(b), l = Yo(l), Mc(l, c, b);
      }
      function nX(l, c, b) {
        if (b && typeof b != "boolean" && Lg(l, c, b) && (c = b = J), b === J && (typeof c == "boolean" ? (b = c, c = J) : typeof l == "boolean" && (b = l, l = J)), l === J && c === J ? (l = 0, c = 1) : (l = Ul(l), c === J ? (c = l, l = 0) : c = Ul(c)), l > c) {
          var Z = l;
          l = c, c = Z;
        }
        if (b || l % 1 || c % 1) {
          var S = jp();
          return Qt(l + S * (c - l + lv("1e-" + ((S + "").length - 1))), c);
        }
        return ip(l, c);
      }
      function iy(l) {
        return d0(zi(l).toLowerCase());
      }
      function ny(l) {
        return l = zi(l), l && l.replace(F, cv).replace(Pf, "");
      }
      function gX(l, c, b) {
        l = zi(l), c = Gr(c);
        var Z = l.length;
        b = b === J ? Z : Ka(Wi(b), 0, Z);
        var S = b;
        return b -= c.length, b >= 0 && l.slice(b, S) == c;
      }
      function rX(l) {
        return l = zi(l), l && BC.test(l) ? l.replace(xc, dv) : l;
      }
      function gy(l) {
        return l = zi(l), l && Yl.test(l) ? l.replace(Fa, "\\$&") : l;
      }
      function ry(l, c, b) {
        l = zi(l), c = Wi(c);
        var Z = c ? ot(l) : 0;
        if (!c || Z >= c)
          return l;
        var S = (c - Z) / 2;
        return Qc(Sb(S), b) + l + Qc(Ql(S), b);
      }
      function oX(l, c, b) {
        l = zi(l), c = Wi(c);
        var Z = c ? ot(l) : 0;
        return c && Z < c ? l + Qc(c - Z, b) : l;
      }
      function IX(l, c, b) {
        l = zi(l), c = Wi(c);
        var Z = c ? ot(l) : 0;
        return c && Z < c ? Qc(c - Z, b) + l : l;
      }
      function lX(l, c, b) {
        return b || c == null ? c = 0 : c && (c = +c), Jo(zi(l).replace(GC, ""), c || 0);
      }
      function sX(l, c, b) {
        return c = (b ? Lg(l, c, b) : c === J) ? 1 : Wi(c), np(zi(l), c);
      }
      function cb() {
        var l = arguments, c = zi(l[0]);
        return l.length < 3 ? c : c.replace(l[1], l[2]);
      }
      function aX(l, c, b) {
        return b && typeof b != "number" && Lg(l, c, b) && (c = b = J), (b = b === J ? bn : b >>> 0) ? (l = zi(l), l && (typeof c == "string" || c != null && !g0(c)) && (c = Gr(c), !c && Je(l)) ? Ds(ze(l), 0, b) : l.split(c, b)) : [];
      }
      function cX(l, c, b) {
        return l = zi(l), b = b == null ? 0 : Ka(Wi(b), 0, l.length), c = Gr(c), l.slice(b, b + c.length) == c;
      }
      function dX(l, c, b) {
        var Z = X.templateSettings;
        b && Lg(l, c, b) && (c = J), l = zi(l), c = Tg({}, c, Z, Cp);
        var S, R, D = Tg({}, c.imports, Z.imports, Cp), K = Xg(D), O = P(D, K), se = 0, oe = c.interpolate || U, de = "__p += '", Fe = gr((c.escape || U).source + "|" + oe.source + "|" + (oe === Dc ? SC : U).source + "|" + (c.evaluate || U).source + "|$", "g"), Me = "//# sourceURL=" + (qi.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ro + "]") + `
`;
        l.replace(Fe, function(nt, vt, Rt, an, cn, lg) {
          return Rt || (Rt = an), de += l.slice(se, lg).replace(ee, we), vt && (S = !0, de += `' +
__e(` + vt + `) +
'`), cn && (R = !0, de += `';
` + cn + `;
__p += '`), Rt && (de += `' +
((__t = (` + Rt + `)) == null ? '' : __t) +
'`), se = lg + nt.length, nt;
        }), de += `';
`;
        var it = qi.call(c, "variable") && c.variable;
        if (it) {
          if (WC.test(it))
            throw new Pp(qe);
        } else
          de = `with (obj) {
` + de + `
}
`;
        de = (R ? de.replace(bC, "") : de).replace(mC, "$1").replace(hC, "$1;"), de = "function(" + (it || "obj") + `) {
` + (it ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (S ? ", __e = _.escape" : "") + (R ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + de + `return __p
}`;
        var Zt = Dy(function() {
          return Ls(K, Me + "return " + de).apply(J, O);
        });
        if (Zt.source = de, Jp(Zt))
          throw Zt;
        return Zt;
      }
      function CX(l) {
        return zi(l).toLowerCase();
      }
      function uX(l) {
        return zi(l).toUpperCase();
      }
      function AX(l, c, b) {
        if (l = zi(l), l && (b || c === J))
          return E(l);
        if (!l || !(c = Gr(c)))
          return l;
        var Z = ze(l), S = ze(c);
        return Ds(Z, te(Z, S), le(Z, S) + 1).join("");
      }
      function bX(l, c, b) {
        if (l = zi(l), l && (b || c === J))
          return l.slice(0, tt(l) + 1);
        if (!l || !(c = Gr(c)))
          return l;
        var Z = ze(l);
        return Ds(Z, 0, le(Z, ze(c)) + 1).join("");
      }
      function mX(l, c, b) {
        if (l = zi(l), l && (b || c === J))
          return l.replace(GC, "");
        if (!l || !(c = Gr(c)))
          return l;
        var Z = ze(l);
        return Ds(Z, te(Z, ze(c))).join("");
      }
      function hX(l, c) {
        var b = fi, Z = on;
        if (En(c)) {
          var S = "separator" in c ? c.separator : S;
          b = "length" in c ? Wi(c.length) : b, Z = "omission" in c ? Gr(c.omission) : Z;
        }
        l = zi(l);
        var R = l.length;
        if (Je(l)) {
          var D = ze(l);
          R = D.length;
        }
        if (b >= R)
          return l;
        var K = b - ot(Z);
        if (K < 1)
          return Z;
        var O = D ? Ds(D, 0, K).join("") : l.slice(0, K);
        if (S === J)
          return O + Z;
        if (D && (K += O.length - K), g0(S)) {
          if (l.slice(K).search(S)) {
            var se, oe = O;
            for (S.global || (S = gr(S.source, zi(NI.exec(S)) + "g")), S.lastIndex = 0; se = S.exec(oe); )
              var de = se.index;
            O = O.slice(0, de === J ? K : de);
          }
        } else if (l.indexOf(Gr(S), K) != K) {
          var Fe = O.lastIndexOf(S);
          Fe > -1 && (O = O.slice(0, Fe));
        }
        return O + Z;
      }
      function pX(l) {
        return l = zi(l), l && pC.test(l) ? l.replace(Yc, Cv) : l;
      }
      function oy(l, c, b) {
        return l = zi(l), c = b ? J : c, c === J ? ve(l) ? ie(l) : B(l) : l.match(c) || [];
      }
      function db(l) {
        var c = l == null ? 0 : l.length, b = gi();
        return l = c ? d(l, function(Z) {
          if (typeof Z[1] != "function")
            throw new xo(Ye);
          return [b(Z[0]), Z[1]];
        }) : [], wi(function(Z) {
          for (var S = -1; ++S < c; ) {
            var R = l[S];
            if (i(R[0], this, Z))
              return i(R[1], this, Z);
          }
        });
      }
      function BX(l) {
        return Zv(oo(l, Ge));
      }
      function Cb(l) {
        return function() {
          return l;
        };
      }
      function Iy(l, c) {
        return l == null || l !== l ? c : l;
      }
      function nr(l) {
        return l;
      }
      function ub(l) {
        return dG(typeof l == "function" ? l : oo(l, Ge));
      }
      function ly(l) {
        return CG(oo(l, Ge));
      }
      function sy(l, c) {
        return uG(l, oo(c, Ge));
      }
      function Ab(l, c, b) {
        var Z = Xg(c), S = kA(c, Z);
        b != null || En(c) && (S.length || !Z.length) || (b = c, c = l, l = this, S = kA(c, Xg(c)));
        var R = !(En(b) && "chain" in b && !b.chain), D = Ml(l);
        return g(S, function(K) {
          var O = c[K];
          l[K] = O, D && (l.prototype[K] = function() {
            var se = this.__chain__;
            if (R || se) {
              var oe = l(this.__wrapped__);
              return (oe.__actions__ = er(this.__actions__)).push({ func: O, args: arguments, thisArg: l }), oe.__chain__ = se, oe;
            }
            return O.apply(l, C([this.value()], arguments));
          });
        }), l;
      }
      function ZX() {
        return Ng._ === this && (Ng._ = Bb), this;
      }
      function Lp() {
      }
      function fX(l) {
        return l = Wi(l), wi(function(c) {
          return AG(c, l);
        });
      }
      function _C(l) {
        return QA(l) ? v(_I(l)) : cI(l);
      }
      function bb(l) {
        return function(c) {
          return l == null ? J : Na(l, c);
        };
      }
      function Tp() {
        return [];
      }
      function Mp() {
        return !1;
      }
      function Up() {
        return {};
      }
      function ay() {
        return "";
      }
      function GX() {
        return !0;
      }
      function yX(l, c) {
        if (l = Wi(l), l < 1 || l > ei)
          return [];
        var b = bn, Z = Qt(l, bn);
        c = gi(c), l -= bn;
        for (var S = $(Z, c); ++b < l; )
          c(b);
        return S;
      }
      function WX(l) {
        return pi(l) ? d(l, _I) : lo(l) ? [l] : er(Wy(zi(l)));
      }
      function SX(l) {
        var c = ++zp;
        return zi(l) + c;
      }
      function VX(l) {
        return l && l.length ? Ys(l, nr, La) : J;
      }
      function wX(l, c) {
        return l && l.length ? Ys(l, gi(c, 2), La) : J;
      }
      function vX(l) {
        return w(l, nr);
      }
      function RX(l, c) {
        return w(l, gi(c, 2));
      }
      function XX(l) {
        return l && l.length ? Ys(l, nr, ep) : J;
      }
      function HX(l, c) {
        return l && l.length ? Ys(l, gi(c, 2), ep) : J;
      }
      function kX(l) {
        return l && l.length ? M(l, nr) : 0;
      }
      function FX(l, c) {
        return l && l.length ? M(l, gi(c, 2)) : 0;
      }
      re = re == null ? Ng : sI.defaults(Ng.Object(), re, sI.pick(Ng, zf));
      var $i = re.Array, mb = re.Date, Pp = re.Error, Ls = re.Function, li = re.Math, Rn = re.Object, gr = re.RegExp, eg = re.String, xo = re.TypeError, uI = $i.prototype, YX = Ls.prototype, nd = Rn.prototype, hb = re["__core-js_shared__"], pb = YX.toString, qi = nd.hasOwnProperty, zp = 0, cy = function() {
        var l = /[^.]+$/.exec(hb && hb.keys && hb.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), Do = nd.toString, dy = pb.call(Rn), Bb = Ng._, Nn = gr("^" + pb.call(qi).replace(Fa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Xn = zh ? re.Buffer : J, Pl = re.Symbol, Zb = re.Uint8Array, Cy = Xn ? Xn.allocUnsafe : J, fb = Xe(Rn.getPrototypeOf, Rn), uy = Rn.create, Ay = nd.propertyIsEnumerable, Gb = uI.splice, Op = Pl ? Pl.isConcatSpreadable : J, zl = Pl ? Pl.iterator : J, Ol = Pl ? Pl.toStringTag : J, yb = function() {
        try {
          var l = Js(Rn, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), by = re.clearTimeout !== Ng.clearTimeout && re.clearTimeout, Wb = mb && mb.now !== Ng.Date.now && mb.now, so = re.setTimeout !== Ng.setTimeout && re.setTimeout, Ql = li.ceil, Sb = li.floor, Qp = Rn.getOwnPropertySymbols, xX = Xn ? Xn.isBuffer : J, my = re.isFinite, DX = uI.join, hy = Xe(Rn.keys, Rn), hn = li.max, Qt = li.min, py = mb.now, Jo = re.parseInt, jp = li.random, JX = uI.reverse, Ki = Js(re, "DataView"), $C = Js(re, "Map"), Vb = Js(re, "Promise"), jl = Js(re, "Set"), qC = Js(re, "WeakMap"), eu = Js(Rn, "create"), wb = qC && new qC(), gd = {}, KX = Ns(Ki), EX = Ns($C), NX = Ns(Vb), LX = Ns(jl), TX = Ns(qC), vb = Pl ? Pl.prototype : J, tu = vb ? vb.valueOf : J, By = vb ? vb.toString : J, rd = /* @__PURE__ */ function() {
        function l() {
        }
        return function(c) {
          if (!En(c))
            return {};
          if (uy)
            return uy(c);
          l.prototype = c;
          var b = new l();
          return l.prototype = J, b;
        };
      }();
      X.templateSettings = { escape: Hs, evaluate: ZC, interpolate: Dc, variable: "", imports: { _: X } }, X.prototype = De.prototype, X.prototype.constructor = X, It.prototype = rd(De.prototype), It.prototype.constructor = It, lt.prototype = rd(De.prototype), lt.prototype.constructor = lt, Da.prototype.clear = Ro, Da.prototype.delete = yA, Da.prototype.get = Av, Da.prototype.has = Nc, Da.prototype.set = WA, Xo.prototype.clear = _i, Xo.prototype.delete = bv, Xo.prototype.get = eG, Xo.prototype.has = SA, Xo.prototype.set = mv, Dl.prototype.clear = hv, Dl.prototype.delete = VA, Dl.prototype.get = Fs, Dl.prototype.has = wA, Dl.prototype.set = tG, TI.prototype.add = TI.prototype.push = iG, TI.prototype.has = nG, Mr.prototype.clear = gG, Mr.prototype.delete = vC, Mr.prototype.get = Ja, Mr.prototype.has = vA, Mr.prototype.set = pv;
      var qI = Oc(MI), Zy = Oc(_h, !0), iu = ap(), fy = ap(!0), Gy = wb ? function(l, c) {
        return wb.set(l, c), l;
      } : nr, MX = yb ? function(l, c) {
        return yb(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Cb(c),
          writable: !0
        });
      } : nr, Hg = wi, vr = by || function(l) {
        return Ng.clearTimeout(l);
      }, UX = jl && 1 / Ke(new jl([, -0]))[1] == vi ? function(l) {
        return new jl(l);
      } : Lp, _p = wb ? function(l) {
        return wb.get(l);
      } : Lp, $p = Qp ? function(l) {
        return l == null ? [] : (l = Rn(l), I(Qp(l), function(c) {
          return Ay.call(l, c);
        }));
      } : Tp, qp = Qp ? function(l) {
        for (var c = []; l; )
          C(c, $p(l)), l = fb(l);
        return c;
      } : Tp, rr = Rg;
      (Ki && rr(new Ki(new ArrayBuffer(1))) != Fl || $C && rr(new $C()) != oi || Vb && rr(Vb.resolve()) != wa || jl && rr(new jl()) != Zr || qC && rr(new qC()) != va) && (rr = function(l) {
        var c = Rg(l), b = c == oI ? l.constructor : J, Z = b ? Ns(b) : "";
        if (Z)
          switch (Z) {
            case KX:
              return Fl;
            case EX:
              return oi;
            case NX:
              return wa;
            case LX:
              return Zr;
            case TX:
              return va;
          }
        return c;
      });
      var PX = hb ? Ml : Mp, yy = Zp(Gy), od = so || function(l, c) {
        return Ng.setTimeout(l, c);
      }, e0 = Zp(MX), Wy = Ks(function(l) {
        var c = [];
        return l.charCodeAt(0) === 46 && c.push(""), l.replace(fC, function(b, Z, S, R) {
          c.push(S ? R.replace(kh, "$1") : Z || b);
        }), c;
      }), zX = wi(function(l, c) {
        return qn(l) ? Ea(l, Pn(c, 1, qn, !0)) : [];
      }), Sy = wi(function(l, c) {
        var b = Wr(c);
        return qn(b) && (b = J), qn(l) ? Ea(l, Pn(c, 1, qn, !0), gi(b, 2)) : [];
      }), Vy = wi(function(l, c) {
        var b = Wr(c);
        return qn(b) && (b = J), qn(l) ? Ea(l, Pn(c, 1, qn, !0), J, b) : [];
      }), OX = wi(function(l) {
        var c = d(l, JA);
        return c.length && c[0] === l[0] ? Uc(c) : [];
      }), QX = wi(function(l) {
        var c = Wr(l), b = d(l, JA);
        return c === Wr(b) ? c = J : b.pop(), b.length && b[0] === l[0] ? Uc(b, gi(c, 2)) : [];
      }), jX = wi(function(l) {
        var c = Wr(l), b = d(l, JA);
        return c = typeof c == "function" ? c : J, c && b.pop(), b.length && b[0] === l[0] ? Uc(b, J, c) : [];
      }), _X = wi(MC), Id = jI(function(l, c) {
        var b = l == null ? 0 : l.length, Z = jh(l, c);
        return mG(l, d(c, function(S) {
          return tr(S, b) ? +S : S;
        }).sort(DC)), Z;
      }), $X = wi(function(l) {
        return Ur(Pn(l, 1, qn, !0));
      }), qX = wi(function(l) {
        var c = Wr(l);
        return qn(c) && (c = J), Ur(Pn(l, 1, qn, !0), gi(c, 2));
      }), eH = wi(function(l) {
        var c = Wr(l);
        return c = typeof c == "function" ? c : J, Ur(Pn(l, 1, qn, !0), J, c);
      }), tH = wi(function(l, c) {
        return qn(l) ? Ea(l, c) : [];
      }), iH = wi(function(l) {
        return Ta(I(l, qn));
      }), wy = wi(function(l) {
        var c = Wr(l);
        return qn(c) && (c = J), Ta(I(l, qn), gi(c, 2));
      }), vy = wi(function(l) {
        var c = Wr(l);
        return c = typeof c == "function" ? c : J, Ta(I(l, qn), J, c);
      }), nH = wi(vp), gH = wi(function(l) {
        var c = l.length, b = c > 1 ? l[c - 1] : J;
        return b = typeof b == "function" ? (l.pop(), b) : J, ob(l, b);
      }), rH = jI(function(l) {
        var c = l.length, b = c ? l[0] : 0, Z = this.__wrapped__, S = function(R) {
          return jh(R, l);
        };
        return !(c > 1 || this.__actions__.length) && Z instanceof lt && tr(b) ? (Z = Z.slice(b, +b + (c ? 1 : 0)), Z.__actions__.push({ func: UC, args: [S], thisArg: J }), new It(Z, this.__chain__).thru(function(R) {
          return c && !R.length && R.push(J), R;
        })) : this.thru(S);
      }), oH = Pc(function(l, c, b) {
        qi.call(l, b) ? ++l[b] : Dn(l, b, 1);
      }), IH = EA(fp), lH = EA(Pa), sH = Pc(function(l, c, b) {
        qi.call(l, b) ? l[b].push(c) : Dn(l, b, [c]);
      }), aH = wi(function(l, c, b) {
        var Z = -1, S = typeof c == "function", R = Vr(l) ? $i(l.length) : [];
        return qI(l, function(D) {
          R[++Z] = S ? i(c, D, b) : Vi(D, c, b);
        }), R;
      }), cH = Pc(function(l, c, b) {
        Dn(l, b, c);
      }), dH = Pc(function(l, c, b) {
        l[b ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      }), CH = wi(function(l, c) {
        if (l == null)
          return [];
        var b = c.length;
        return b > 1 && Lg(l, c[0], c[1]) ? c = [] : b > 2 && Lg(c[0], c[1], c[2]) && (c = [c[0]]), xs(l, Pn(c, 1), []);
      }), Rb = Wb || function() {
        return Ng.Date.now();
      }, t0 = wi(function(l, c, b) {
        var Z = Te;
        if (b.length) {
          var S = Ze(b, bi(t0));
          Z |= Nt;
        }
        return El(l, Z, c, b, S);
      }), Ry = wi(function(l, c, b) {
        var Z = Te | Xt;
        if (b.length) {
          var S = Ze(b, bi(Ry));
          Z |= Nt;
        }
        return El(c, Z, l, b, S);
      }), uH = wi(function(l, c) {
        return Lc(l, 1, c);
      }), AH = wi(function(l, c, b) {
        return Lc(l, Yo(c) || 0, b);
      });
      lb.Cache = Dl;
      var bH = Hg(function(l, c) {
        c = c.length == 1 && pi(c[0]) ? d(c[0], L(gi())) : d(Pn(c, 1), L(gi()));
        var b = c.length;
        return wi(function(Z) {
          for (var S = -1, R = Qt(Z.length, b); ++S < R; )
            Z[S] = c[S].call(this, Z[S]);
          return i(l, this, Z);
        });
      }), i0 = wi(function(l, c) {
        return El(l, Nt, J, c, Ze(c, bi(i0)));
      }), Xy = wi(function(l, c) {
        return El(l, ni, J, c, Ze(c, bi(Xy)));
      }), mH = jI(function(l, c) {
        return El(l, jt, J, J, J, c);
      }), hH = KC(La), pH = KC(function(l, c) {
        return l >= c;
      }), Qa = aG(/* @__PURE__ */ function() {
        return arguments;
      }()) ? aG : function(l) {
        return zn(l) && qi.call(l, "callee") && !Ay.call(l, "callee");
      }, pi = $i.isArray, BH = _f ? L(_f) : fv, el = xX || Mp, Hy = $f ? L($f) : Gv, n0 = qf ? L(qf) : Wv, g0 = xa ? L(xa) : Sv, ky = vo ? L(vo) : Jl, ld = Oh ? L(Oh) : Vv, r0 = KC(ep), ZH = KC(function(l, c) {
        return l <= c;
      }), fH = zc(function(l, c) {
        if (_c(c) || Vr(c))
          return OI(c, Xg(c), l), J;
        for (var b in c)
          qi.call(c, b) && XC(l, b, c[b]);
      }), Fy = zc(function(l, c) {
        OI(c, zr(c), l);
      }), Tg = zc(function(l, c, b, Z) {
        OI(c, zr(c), l, Z);
      }), o0 = zc(function(l, c, b, Z) {
        OI(c, Xg(c), l, Z);
      }), GH = jI(jh), yH = wi(function(l, c) {
        l = Rn(l);
        var b = -1, Z = c.length, S = Z > 2 ? c[2] : J;
        for (S && Lg(c[0], c[1], S) && (Z = 1); ++b < Z; )
          for (var R = c[b], D = zr(R), K = -1, O = D.length; ++K < O; ) {
            var se = D[K], oe = l[se];
            (oe === J || Fo(oe, nd[se]) && !qi.call(l, se)) && (l[se] = R[se]);
          }
        return l;
      }), WH = wi(function(l) {
        return l.push(J, up), i(Yy, J, l);
      }), SH = GG(function(l, c, b) {
        c != null && typeof c.toString != "function" && (c = Do.call(c)), l[c] = b;
      }, Cb(nr)), I0 = GG(function(l, c, b) {
        c != null && typeof c.toString != "function" && (c = Do.call(c)), qi.call(l, c) ? l[c].push(b) : l[c] = [b];
      }, gi), VH = wi(Vi), l0 = zc(function(l, c, b) {
        FA(l, c, b);
      }), Yy = zc(function(l, c, b, Z) {
        FA(l, c, b, Z);
      }), wH = jI(function(l, c) {
        var b = {};
        if (l == null)
          return b;
        var Z = !1;
        c = d(c, function(R) {
          return R = dI(R, l), Z || (Z = R.length > 1), R;
        }), OI(l, mp(l), b), Z && (b = oo(b, Ge | pe | _e, Jv));
        for (var S = c.length; S--; )
          Pr(b, c[S]);
        return b;
      }), vH = jI(function(l, c) {
        return l == null ? {} : Rv(l, c);
      }), xy = EC(Xg), s0 = EC(zr), RH = QI(function(l, c, b) {
        return c = c.toLowerCase(), l + (b ? iy(c) : c);
      }), XH = QI(function(l, c, b) {
        return l + (b ? "-" : "") + c.toLowerCase();
      }), HH = QI(function(l, c, b) {
        return l + (b ? " " : "") + c.toLowerCase();
      }), a0 = fG("toLowerCase"), c0 = QI(function(l, c, b) {
        return l + (b ? "_" : "") + c.toLowerCase();
      }), kH = QI(function(l, c, b) {
        return l + (b ? " " : "") + d0(c);
      }), FH = QI(function(l, c, b) {
        return l + (b ? " " : "") + c.toUpperCase();
      }), d0 = fG("toUpperCase"), Dy = wi(function(l, c) {
        try {
          return i(l, J, c);
        } catch (b) {
          return Jp(b) ? b : new Pp(b);
        }
      }), YH = jI(function(l, c) {
        return g(c, function(b) {
          b = _I(b), Dn(l, b, t0(l[b], l));
        }), l;
      }), xH = cp(), DH = cp(!0), JH = wi(function(l, c) {
        return function(b) {
          return Vi(b, l, c);
        };
      }), KH = wi(function(l, c) {
        return function(b) {
          return Vi(l, b, c);
        };
      }), EH = TA(d), NH = TA(o), LH = TA(m), TH = MA(), MH = MA(!0), UH = LA(function(l, c) {
        return l + c;
      }, 0), PH = UA("ceil"), zH = LA(function(l, c) {
        return l / c;
      }, 1), OH = UA("floor"), QH = LA(function(l, c) {
        return l * c;
      }, 1), jH = UA("round"), _H = LA(function(l, c) {
        return l - c;
      }, 0);
      return X.after = Fp, X.ary = Yp, X.assign = fH, X.assignIn = Fy, X.assignInWith = Tg, X.assignWith = o0, X.at = GH, X.before = xp, X.bind = t0, X.bindAll = YH, X.bindKey = Ry, X.castArray = mR, X.chain = NG, X.chunk = $I, X.compact = Mv, X.concat = Uv, X.cond = db, X.conforms = BX, X.constant = Cb, X.countBy = oH, X.create = DR, X.curry = zC, X.curryRight = Dp, X.debounce = CI, X.defaults = yH, X.defaultsDeep = WH, X.defer = uH, X.delay = AH, X.difference = zX, X.differenceBy = Sy, X.differenceWith = Vy, X.drop = tb, X.dropRight = $c, X.dropRightWhile = RG, X.dropWhile = XG, X.fill = Pv, X.filter = gR, X.flatMap = Xp, X.flatMapDeep = rR, X.flatMapDepth = oR, X.flatten = qc, X.flattenDeep = zv, X.flattenDepth = HG, X.flip = Oa, X.flow = xH, X.flowRight = DH, X.fromPairs = kG, X.functions = LR, X.functionsIn = TR, X.groupBy = sH, X.initial = ib, X.intersection = OX, X.intersectionBy = QX, X.intersectionWith = jX, X.invert = SH, X.invertBy = I0, X.invokeMap = aH, X.iteratee = ub, X.keyBy = cH, X.keys = Xg, X.keysIn = zr, X.map = Ib, X.mapKeys = UR, X.mapValues = ty, X.matches = ly, X.matchesProperty = sy, X.memoize = lb, X.merge = l0, X.mergeWith = Yy, X.method = JH, X.methodOf = KH, X.mixin = Ab, X.negate = OC, X.nthArg = fX, X.omit = wH, X.omitBy = PR, X.once = cR, X.orderBy = IR, X.over = EH, X.overArgs = bH, X.overEvery = NH, X.overSome = LH, X.partial = i0, X.partialRight = Xy, X.partition = dH, X.pick = vH, X.pickBy = jC, X.property = _C, X.propertyOf = bb, X.pull = _X, X.pullAll = MC, X.pullAllBy = xG, X.pullAllWith = yp, X.pullAt = Id, X.range = TH, X.rangeRight = MH, X.rearg = mH, X.reject = MG, X.remove = Qv, X.rest = dR, X.reverse = nb, X.sampleSize = aR, X.set = OR, X.setWith = QR, X.shuffle = kp, X.slice = Nl, X.sortBy = CH, X.sortedUniq = Ll, X.sortedUniqBy = Wp, X.split = aX, X.spread = CR, X.tail = Sp, X.take = Vp, X.takeRight = gb, X.takeRightWhile = ed, X.takeWhile = ri, X.tap = qv, X.throttle = uR, X.thru = UC, X.toArray = _G, X.toPairs = xy, X.toPairsIn = s0, X.toPath = WX, X.toPlainObject = qG, X.transform = jR, X.unary = AR, X.union = $X, X.unionBy = qX, X.unionWith = eH, X.uniq = rb, X.uniqBy = wp, X.uniqWith = za, X.unset = _R, X.unzip = vp, X.unzipWith = ob, X.update = $R, X.updateWith = qR, X.values = id, X.valuesIn = eX, X.without = tH, X.words = oy, X.wrap = bR, X.xor = iH, X.xorBy = wy, X.xorWith = vy, X.zip = nH, X.zipObject = EG, X.zipObjectDeep = ir, X.zipWith = gH, X.entries = xy, X.entriesIn = s0, X.extend = Fy, X.extendWith = Tg, Ab(X, X), X.add = UH, X.attempt = Dy, X.camelCase = RH, X.capitalize = iy, X.ceil = PH, X.clamp = tX, X.clone = hR, X.cloneDeep = BR, X.cloneDeepWith = ZR, X.cloneWith = pR, X.conformsTo = zG, X.deburr = ny, X.defaultTo = Iy, X.divide = zH, X.endsWith = gX, X.eq = Fo, X.escape = rX, X.escapeRegExp = gy, X.every = Rp, X.find = IH, X.findIndex = fp, X.findKey = JR, X.findLast = lH, X.findLastIndex = Pa, X.findLastKey = KR, X.floor = OH, X.forEach = td, X.forEachRight = Hp, X.forIn = ER, X.forInRight = NR, X.forOwn = Kp, X.forOwnRight = ey, X.get = Ep, X.gt = hH, X.gte = pH, X.has = MR, X.hasIn = Np, X.head = TC, X.identity = nr, X.includes = TG, X.indexOf = FG, X.inRange = iX, X.invoke = VH, X.isArguments = Qa, X.isArray = pi, X.isArrayBuffer = BH, X.isArrayLike = Vr, X.isArrayLikeObject = qn, X.isBoolean = fR, X.isBuffer = el, X.isDate = Hy, X.isElement = GR, X.isEmpty = OG, X.isEqual = yR, X.isEqualWith = WR, X.isError = Jp, X.isFinite = SR, X.isFunction = Ml, X.isInteger = QG, X.isLength = wr, X.isMap = n0, X.isMatch = VR, X.isMatchWith = jG, X.isNaN = wR, X.isNative = vR, X.isNil = XR, X.isNull = RR, X.isNumber = sb, X.isObject = En, X.isObjectLike = zn, X.isPlainObject = QC, X.isRegExp = g0, X.isSafeInteger = HR, X.isSet = ky, X.isString = ab, X.isSymbol = lo, X.isTypedArray = ld, X.isUndefined = kR, X.isWeakMap = FR, X.isWeakSet = YR, X.join = Gp, X.kebabCase = XH, X.last = Wr, X.lastIndexOf = Ov, X.lowerCase = HH, X.lowerFirst = a0, X.lt = r0, X.lte = ZH, X.max = VX, X.maxBy = wX, X.mean = vX, X.meanBy = RX, X.min = XX, X.minBy = HX, X.stubArray = Tp, X.stubFalse = Mp, X.stubObject = Up, X.stubString = ay, X.stubTrue = GX, X.multiply = QH, X.nth = YG, X.noConflict = ZX, X.noop = Lp, X.now = Rb, X.pad = ry, X.padEnd = oX, X.padStart = IX, X.parseInt = lX, X.random = nX, X.reduce = lR, X.reduceRight = sR, X.repeat = sX, X.replace = cb, X.result = zR, X.round = jH, X.runInContext = T, X.sample = UG, X.size = PG, X.snakeCase = c0, X.some = PC, X.sortedIndex = DG, X.sortedIndexBy = JG, X.sortedIndexOf = jv, X.sortedLastIndex = KG, X.sortedLastIndexBy = _v, X.sortedLastIndexOf = $v, X.startCase = kH, X.startsWith = cX, X.subtract = _H, X.sum = kX, X.sumBy = FX, X.template = dX, X.times = yX, X.toFinite = Ul, X.toInteger = Wi, X.toLength = $G, X.toLower = CX, X.toNumber = Yo, X.toSafeInteger = xR, X.toString = zi, X.toUpper = uX, X.trim = AX, X.trimEnd = bX, X.trimStart = mX, X.truncate = hX, X.unescape = pX, X.uniqueId = SX, X.upperCase = FH, X.upperFirst = d0, X.each = td, X.eachRight = Hp, X.first = TC, Ab(X, function() {
        var l = {};
        return MI(X, function(c, b) {
          qi.call(X.prototype, b) || (l[b] = c);
        }), l;
      }(), { chain: !1 }), X.VERSION = Ce, g(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        X[l].placeholder = X;
      }), g(["drop", "take"], function(l, c) {
        lt.prototype[l] = function(b) {
          b = b === J ? 1 : hn(Wi(b), 0);
          var Z = this.__filtered__ && !c ? new lt(this) : this.clone();
          return Z.__filtered__ ? Z.__takeCount__ = Qt(b, Z.__takeCount__) : Z.__views__.push({ size: Qt(b, bn), type: l + (Z.__dir__ < 0 ? "Right" : "") }), Z;
        }, lt.prototype[l + "Right"] = function(b) {
          return this.reverse()[l](b).reverse();
        };
      }), g(["filter", "map", "takeWhile"], function(l, c) {
        var b = c + 1, Z = b == ln || b == Ti;
        lt.prototype[l] = function(S) {
          var R = this.clone();
          return R.__iteratees__.push({ iteratee: gi(S, 3), type: b }), R.__filtered__ = R.__filtered__ || Z, R;
        };
      }), g(["head", "last"], function(l, c) {
        var b = "take" + (c ? "Right" : "");
        lt.prototype[l] = function() {
          return this[b](1).value()[0];
        };
      }), g(["initial", "tail"], function(l, c) {
        var b = "drop" + (c ? "" : "Right");
        lt.prototype[l] = function() {
          return this.__filtered__ ? new lt(this) : this[b](1);
        };
      }), lt.prototype.compact = function() {
        return this.filter(nr);
      }, lt.prototype.find = function(l) {
        return this.filter(l).head();
      }, lt.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, lt.prototype.invokeMap = wi(function(l, c) {
        return typeof l == "function" ? new lt(this) : this.map(function(b) {
          return Vi(b, l, c);
        });
      }), lt.prototype.reject = function(l) {
        return this.filter(OC(gi(l)));
      }, lt.prototype.slice = function(l, c) {
        l = Wi(l);
        var b = this;
        return b.__filtered__ && (l > 0 || c < 0) ? new lt(b) : (l < 0 ? b = b.takeRight(-l) : l && (b = b.drop(l)), c !== J && (c = Wi(c), b = c < 0 ? b.dropRight(-c) : b.take(c - l)), b);
      }, lt.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, lt.prototype.toArray = function() {
        return this.take(bn);
      }, MI(lt.prototype, function(l, c) {
        var b = /^(?:filter|find|map|reject)|While$/.test(c), Z = /^(?:head|last)$/.test(c), S = X[Z ? "take" + (c == "last" ? "Right" : "") : c], R = Z || /^find/.test(c);
        S && (X.prototype[c] = function() {
          var D = this.__wrapped__, K = Z ? [1] : arguments, O = D instanceof lt, se = K[0], oe = O || pi(D), de = function(vt) {
            var Rt = S.apply(X, C([vt], K));
            return Z && Fe ? Rt[0] : Rt;
          };
          oe && b && typeof se == "function" && se.length != 1 && (O = oe = !1);
          var Fe = this.__chain__, Me = !!this.__actions__.length, it = R && !Fe, Zt = O && !Me;
          if (!R && oe) {
            D = Zt ? D : new lt(this);
            var nt = l.apply(D, K);
            return nt.__actions__.push({ func: UC, args: [de], thisArg: J }), new It(nt, Fe);
          }
          return it && Zt ? l.apply(this, K) : (nt = this.thru(de), it ? Z ? nt.value()[0] : nt.value() : nt);
        });
      }), g(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var c = uI[l], b = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", Z = /^(?:pop|shift)$/.test(l);
        X.prototype[l] = function() {
          var S = arguments;
          if (Z && !this.__chain__) {
            var R = this.value();
            return c.apply(pi(R) ? R : [], S);
          }
          return this[b](function(D) {
            return c.apply(pi(D) ? D : [], S);
          });
        };
      }), MI(lt.prototype, function(l, c) {
        var b = X[c];
        if (b) {
          var Z = b.name + "";
          qi.call(gd, Z) || (gd[Z] = []), gd[Z].push({ name: c, func: b });
        }
      }), gd[NA(J, Xt).name] = [{ name: "wrapper", func: J }], lt.prototype.clone = Ji, lt.prototype.reverse = ji, lt.prototype.value = Qh, X.prototype.at = rH, X.prototype.chain = eR, X.prototype.commit = LG, X.prototype.next = tR, X.prototype.plant = nR, X.prototype.reverse = Tl, X.prototype.toJSON = X.prototype.valueOf = X.prototype.value = Sr, X.prototype.first = X.prototype.head, zl && (X.prototype[zl] = iR), X;
    }, sI = uv();
    xl ? ((xl.exports = sI)._ = sI, Ph._ = sI) : Ng._ = sI;
  }).call(Zn);
})(zS, zS.exports);
var Zfe = zS.exports, GQ = {};
(function(e) {
  e.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, e.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, e.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, e.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, e.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, e.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, e.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, e.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, e.realToAlias = function() {
    var t = Object.prototype.hasOwnProperty, i = e.aliasToReal, n = {};
    for (var g in i) {
      var r = i[g];
      t.call(n, r) ? n[r].push(g) : n[r] = [g];
    }
    return n;
  }(), e.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, e.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, e.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(GQ);
var ffe = {}, Mg = GQ, Gfe = ffe, LL = Array.prototype.push;
function yfe(e, t) {
  return t == 2 ? function(i, n) {
    return e.apply(void 0, arguments);
  } : function(i) {
    return e.apply(void 0, arguments);
  };
}
function Bk(e, t) {
  return t == 2 ? function(i, n) {
    return e(i, n);
  } : function(i) {
    return e(i);
  };
}
function TL(e) {
  for (var t = e ? e.length : 0, i = Array(t); t--; )
    i[t] = e[t];
  return i;
}
function Wfe(e) {
  return function(t) {
    return e({}, t);
  };
}
function Sfe(e, t) {
  return function() {
    for (var i = arguments.length, n = i - 1, g = Array(i); i--; )
      g[i] = arguments[i];
    var r = g[t], o = g.slice(0, t);
    return r && LL.apply(o, r), t != n && LL.apply(o, g.slice(t + 1)), e.apply(this, o);
  };
}
function Zk(e, t) {
  return function() {
    var i = arguments.length;
    if (i) {
      for (var n = Array(i); i--; )
        n[i] = arguments[i];
      var g = n[0] = t.apply(void 0, n);
      return e.apply(void 0, n), g;
    }
  };
}
function VY(e, t, i, n) {
  var g = typeof t == "function", r = t === Object(t);
  if (r && (n = i, i = t, t = void 0), i == null)
    throw new TypeError();
  n || (n = {});
  var o = {
    cap: "cap" in n ? n.cap : !0,
    curry: "curry" in n ? n.curry : !0,
    fixed: "fixed" in n ? n.fixed : !0,
    immutable: "immutable" in n ? n.immutable : !0,
    rearg: "rearg" in n ? n.rearg : !0
  }, I = g ? i : Gfe, s = "curry" in n && n.curry, a = "fixed" in n && n.fixed, d = "rearg" in n && n.rearg, C = g ? i.runInContext() : void 0, u = g ? i : {
    ary: e.ary,
    assign: e.assign,
    clone: e.clone,
    curry: e.curry,
    forEach: e.forEach,
    isArray: e.isArray,
    isError: e.isError,
    isFunction: e.isFunction,
    isWeakMap: e.isWeakMap,
    iteratee: e.iteratee,
    keys: e.keys,
    rearg: e.rearg,
    toInteger: e.toInteger,
    toPath: e.toPath
  }, A = u.ary, m = u.assign, h = u.clone, B = u.curry, f = u.forEach, G = u.isArray, y = u.isError, W = u.isFunction, V = u.isWeakMap, w = u.keys, v = u.rearg, H = u.toInteger, x = u.toPath, N = w(Mg.aryMethod), M = {
    castArray: function(Be) {
      return function() {
        var ue = arguments[0];
        return G(ue) ? Be(TL(ue)) : Be.apply(void 0, arguments);
      };
    },
    iteratee: function(Be) {
      return function() {
        var ue = arguments[0], Xe = arguments[1], Ze = Be(ue, Xe), Ke = Ze.length;
        return o.cap && typeof Xe == "number" ? (Xe = Xe > 2 ? Xe - 2 : 1, Ke && Ke <= Xe ? Ze : Bk(Ze, Xe)) : Ze;
      };
    },
    mixin: function(Be) {
      return function(ue) {
        var Xe = this;
        if (!W(Xe))
          return Be(Xe, Object(ue));
        var Ze = [];
        return f(w(ue), function(Ke) {
          W(ue[Ke]) && Ze.push([Ke, Xe.prototype[Ke]]);
        }), Be(Xe, Object(ue)), f(Ze, function(Ke) {
          var $e = Ke[1];
          W($e) ? Xe.prototype[Ke[0]] = $e : delete Xe.prototype[Ke[0]];
        }), Xe;
      };
    },
    nthArg: function(Be) {
      return function(ue) {
        var Xe = ue < 0 ? 1 : H(ue) + 1;
        return B(Be(ue), Xe);
      };
    },
    rearg: function(Be) {
      return function(ue, Xe) {
        var Ze = Xe ? Xe.length : 0;
        return B(Be(ue, Xe), Ze);
      };
    },
    runInContext: function(Be) {
      return function(ue) {
        return VY(e, Be(ue), n);
      };
    }
  };
  function $(Be, ue) {
    if (o.cap) {
      var Xe = Mg.iterateeRearg[Be];
      if (Xe)
        return Ae(ue, Xe);
      var Ze = !g && Mg.iterateeAry[Be];
      if (Ze)
        return le(ue, Ze);
    }
    return ue;
  }
  function q(Be, ue, Xe) {
    return s || o.curry && Xe > 1 ? B(ue, Xe) : ue;
  }
  function E(Be, ue, Xe) {
    if (o.fixed && (a || !Mg.skipFixed[Be])) {
      var Ze = Mg.methodSpread[Be], Ke = Ze && Ze.start;
      return Ke === void 0 ? A(ue, Xe) : Sfe(ue, Ke);
    }
    return ue;
  }
  function L(Be, ue, Xe) {
    return o.rearg && Xe > 1 && (d || !Mg.skipRearg[Be]) ? v(ue, Mg.methodRearg[Be] || Mg.aryRearg[Xe]) : ue;
  }
  function P(Be, ue) {
    ue = x(ue);
    for (var Xe = -1, Ze = ue.length, Ke = Ze - 1, $e = h(Object(Be)), rt = $e; rt != null && ++Xe < Ze; ) {
      var dt = ue[Xe], ot = rt[dt];
      ot != null && !(W(ot) || y(ot) || V(ot)) && (rt[dt] = h(Xe == Ke ? ot : Object(ot))), rt = rt[dt];
    }
    return $e;
  }
  function Q(Be) {
    return Je.runInContext.convert(Be)(void 0);
  }
  function te(Be, ue) {
    var Xe = Mg.aliasToReal[Be] || Be, Ze = Mg.remap[Xe] || Xe, Ke = n;
    return function($e) {
      var rt = g ? C : u, dt = g ? C[Ze] : ue, ot = m(m({}, Ke), $e);
      return VY(rt, Xe, dt, ot);
    };
  }
  function le(Be, ue) {
    return we(Be, function(Xe) {
      return typeof Xe == "function" ? Bk(Xe, ue) : Xe;
    });
  }
  function Ae(Be, ue) {
    return we(Be, function(Xe) {
      var Ze = ue.length;
      return yfe(v(Bk(Xe, Ze), ue), Ze);
    });
  }
  function we(Be, ue) {
    return function() {
      var Xe = arguments.length;
      if (!Xe)
        return Be();
      for (var Ze = Array(Xe); Xe--; )
        Ze[Xe] = arguments[Xe];
      var Ke = o.rearg ? 0 : Xe - 1;
      return Ze[Ke] = ue(Ze[Ke]), Be.apply(void 0, Ze);
    };
  }
  function Ee(Be, ue, Xe) {
    var Ze, Ke = Mg.aliasToReal[Be] || Be, $e = ue, rt = M[Ke];
    return rt ? $e = rt(ue) : o.immutable && (Mg.mutate.array[Ke] ? $e = Zk(ue, TL) : Mg.mutate.object[Ke] ? $e = Zk(ue, Wfe(ue)) : Mg.mutate.set[Ke] && ($e = Zk(ue, P))), f(N, function(dt) {
      return f(Mg.aryMethod[dt], function(ot) {
        if (Ke == ot) {
          var ze = Mg.methodSpread[Ke], tt = ze && ze.afterRearg;
          return Ze = tt ? E(Ke, L(Ke, $e, dt), dt) : L(Ke, E(Ke, $e, dt), dt), Ze = $(Ke, Ze), Ze = q(Ke, Ze, dt), !1;
        }
      }), !Ze;
    }), Ze || (Ze = $e), Ze == ue && (Ze = s ? B(Ze, 1) : function() {
      return ue.apply(this, arguments);
    }), Ze.convert = te(Ke, ue), Ze.placeholder = ue.placeholder = Xe, Ze;
  }
  if (!r)
    return Ee(t, i, I);
  var Je = i, ve = [];
  return f(N, function(Be) {
    f(Mg.aryMethod[Be], function(ue) {
      var Xe = Je[Mg.remap[ue] || ue];
      Xe && ve.push([ue, Ee(ue, Xe, Je)]);
    });
  }), f(w(Je), function(Be) {
    var ue = Je[Be];
    if (typeof ue == "function") {
      for (var Xe = ve.length; Xe--; )
        if (ve[Xe][0] == Be)
          return;
      ue.convert = te(Be, ue), ve.push([Be, ue]);
    }
  }), f(ve, function(Be) {
    Je[Be[0]] = Be[1];
  }), Je.convert = Q, Je.placeholder = Je, f(w(Je), function(Be) {
    f(Mg.realToAlias[Be] || [], function(ue) {
      Je[ue] = Je[Be];
    });
  }), Je;
}
var Vfe = VY, ML = Zfe.runInContext(), me = Vfe(ML, ML);
function aDt(e) {
  return ce.isObject(e) && me.has("id", e);
}
const Ni = (e) => ce.keyBy(e, "id"), cDt = me.mapValues.convert({
  cap: !1
}), wfe = me.map.convert({
  cap: !1
}), ZD = me.reduce.convert({
  cap: !1
}), dDt = me.pickBy.convert({
  cap: !1
}), CDt = me.forEach.convert({
  cap: !1
}), UL = me.curry((e, t, i) => e ? t(i) : i);
me.curry((e, t, i) => e(i) ? t(i) : i);
const da = (e) => (t) => me.mergeWith((i, n) => {
  if (n === void 0)
    return i;
  if (ce.isFunction(n))
    return n(i);
  if (me.isArray(i)) {
    if (ce.isFunction(n))
      return me.map(n, i);
    if (me.flow(me.first, me.has("id"))(i)) {
      const g = Ni(n);
      return me.map((r) => g[r.id] ? me.assign(r, g[r.id]) : r, i);
    }
    return n;
  }
}, t, e);
function uDt(e, t) {
  return me.mergeWith((i, n) => {
    if (me.isArray(i))
      return n;
  }, t, e);
}
const vfe = (e) => ce.isString(e) ? e.includes("Infinity") ? parseFloat(e) : parseInt(e) : e, ADt = (e, t) => ZD((i, n, g, r) => g === e ? i : g === t ? e < t ? [...i, n, r[e]] : [...i, r[e], n] : [...i, n], []), bDt = (e, t) => (t % e + e) % e, Bn = {
  List: "list",
  Color: "color",
  Number: "number",
  Text: "text",
  MultiSelect: "multiSelect",
  Boolean: "boolean",
  Image: "image",
  Components: "components",
  Information: "information"
}, yQ = ce.values(Bn), Jn = {
  Checkbox: "checkbox",
  Hidden: "hidden",
  Information: "information",
  RadioCard: "radioCard",
  Radio: "radio",
  Select: "select",
  SelectThumbs: "selectThumbs",
  Text: "text",
  Textarea: "textarea",
  Number: "number",
  Switch: "switch",
  SwitchCard: "switchCard",
  ColorSelect: "colorSelect",
  ColorDropdown: "colorDropdown",
  ColorRadio: "colorRadio",
  ColorRadioCard: "colorRadioCard",
  RALColorSelect: "ralColorSelect",
  ImageUpload: "imageUpload",
  ComponentList: "componentList",
  ComponentListPopup: "componentListPopup",
  ComponentValueCards: "componentValueCards"
}, mDt = ["always", "never", "auto"];
var Rfe = /* @__PURE__ */ ((e) => (e.PNG = "PNG", e.JPG = "JPG", e))(Rfe || {});
function Xfe(e) {
  const t = e, i = (t == null ? void 0 : t.id) !== void 0, n = yQ.includes(t == null ? void 0 : t.type);
  return i && n;
}
function hDt(e) {
  const t = e, i = (t == null ? void 0 : t.id) === void 0, n = yQ.includes(t == null ? void 0 : t.type);
  return i && n;
}
const pDt = (e) => e.type === Bn.Color, BDt = (e) => e.type === Bn.Image, eI = (e) => (e == null ? void 0 : e.type) === Bn.Number, ZDt = (e) => !(eI(e) || ih(e)), Hfe = (e) => (e == null ? void 0 : e.type) === Bn.Boolean, C1 = (e) => (e == null ? void 0 : e.type) === Bn.Information, ih = (e) => (e == null ? void 0 : e.type) === Bn.Text || C1(e), ju = (e) => e == null ? void 0 : e.settings.template, hi = (e) => e == null ? void 0 : e.settings.templateOptions, Od = (e) => {
  const {
    step: t,
    roundToStep: i,
    digits: n
  } = hi(e), g = Number(t || 0);
  return g && i ? g : n ? 1 / 10 ** n : 1;
}, kfe = (e) => {
  var t, i;
  return {
    min: ((t = hi(e)) == null ? void 0 : t.min) || -1 / 0,
    max: ((i = hi(e)) == null ? void 0 : i.max) || 1 / 0
  };
}, Ffe = (e) => (e == null ? void 0 : e.attrs) || [], Yfe = (e, t) => (
  // @ts-ignore
  Ffe(t).find((i) => i.key === e)
), fDt = me.flow(ju, me.equals(Jn.RALColorSelect)), xfe = (e) => {
  var t;
  return ((t = hi(e)) == null ? void 0 : t.hideAlways) || ju(e) === Jn.Hidden;
}, Dfe = (e) => !xfe(e), Jfe = (e) => ju(e) === "textarea";
me.curry((e, t) => da({
  label: e
})(t));
me.curry((e, t) => da({
  description: e
})(t));
const GDt = me.curry((e, t) => da({
  settings: {
    template: e
  }
})(t)), yDt = me.curry((e, t) => da({
  settings: {
    templateOptions: e
  }
})(t)), WDt = me.curry((e, t) => da({
  type: e
})(t));
var OS = /* @__PURE__ */ ((e) => (e[e.HideAction = 0] = "HideAction", e[e.ConcealAction = 1] = "ConcealAction", e[e.OneValidValue = 2] = "OneValidValue", e[e.NoValidValue = 3] = "NoValidValue", e[e.AlwaysHidden = 4] = "AlwaysHidden", e))(OS || {});
const u1 = (e, t, i, n) => {
  var o, I, s, a, d;
  const g = hi(e);
  if (g.hideAlways)
    return {
      reason: 4,
      text: "Dieses Merkmal ist versteckt."
    };
  if (US(t, e.id, n, "concealedVariablesMap"))
    return {
      reason: 1,
      text: "Dieses Merkmal ist nur im Admin-Panel sichtbar, da es per Regel versteckt wurde."
    };
  if (US(t, e.id, n))
    return {
      reason: 0,
      text: `Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: 
 1. Es wurde per Regel entfernt. 
 2. Der zugehörige Schritt wurde entfernt.`
    };
  if (C1(e))
    return null;
  if (!((I = (o = t == null ? void 0 : t.values) == null ? void 0 : o.byVarId) != null && I.all[e.id]))
    return {
      reason: 0,
      text: "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen."
    };
  const r = (a = (s = i == null ? void 0 : i.all) == null ? void 0 : s.validOptions[n]) == null ? void 0 : a[e.id];
  if (g != null && g.hideIfNoOptions && (r == null ? void 0 : r.length) === 0)
    return {
      reason: 3,
      text: "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!"
    };
  if (g != null && g.hideIfSingleOption && (r == null ? void 0 : r.length) === 1) {
    if (eI(e)) {
      const C = (d = r[0]) == null ? void 0 : d.value;
      if (!fQ(C))
        return null;
    }
    return {
      reason: 2,
      text: "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!"
    };
  }
  return null;
}, WQ = (e, t, i, n) => {
  var o, I;
  const {
    showSelection: g,
    hideIfNoSelection: r
  } = hi(e);
  if (g == "always")
    return !0;
  if (g == "never")
    return !1;
  if (r) {
    const s = n.valueId;
    if (Hfe(e)) {
      const a = SQ(e, i, n, s);
      if (!(a != null && a.value) || (a == null ? void 0 : a.value) == "0")
        return !1;
    } else if (e.type == Bn.Text) {
      if (!((o = n == null ? void 0 : n.data) != null && o.inputText))
        return !1;
    } else if (eI(e)) {
      if (!((I = n.data) != null && I.inputValue))
        return !1;
    } else if (Kfe(e, i, n, s) || e.type === Bn.Image && !Efe(e, t, s))
      return !1;
  }
  switch (g) {
    case "auto":
    default:
      return !u1(e, t, i, n.instance.id);
  }
}, SQ = (e, t, i, n) => {
  var g, r;
  return (r = (g = t.all.validOptions[i.instance.id][e.id]) == null ? void 0 : g.find((o) => o.value.id === n)) == null ? void 0 : r.value;
}, Kfe = (e, t, i, n) => {
  var g;
  return ((g = SQ(e, t, i, n)) == null ? void 0 : g.key) === QB;
}, Efe = (e, t, i) => {
  var n;
  return ((n = t.values.byVarId.all[e.id].find((g) => g.id === i)) == null ? void 0 : n.value) === "1";
}, A1 = (e) => e.instance.isInstanceLauncher === !1 && e.id !== e.instance.id, _r = (e) => e.instance.isInstanceLauncher === !0 && e.id === e.instance.id, Nfe = (e) => e.instance.belongsToVariableId === null, VQ = (e, t) => A1(t) ? e.id === t.instance.id : _r(t) ? e.id === t.instance.belongsToInstanceId : !1, vl = (e) => {
  if (e)
    return A1(e) ? e.instance.id : _r(e) ? e.instance.belongsToInstanceId : void 0;
}, jB = (e, t) => A1(t) ? e.find((i) => i.id === t.instance.id) : _r(t) ? e.find((i) => i.id === t.instance.belongsToInstanceId) : void 0, fD = (e) => [Dt, ...Zc(e)], HZ = (e, t, i) => {
  const n = [];
  let g = t;
  for (; g; )
    g = (i || e).find((r) => r.instance.isInstanceLauncher && r.instance.id === (g == null ? void 0 : g.instance.belongsToInstanceId) && r.id !== (g == null ? void 0 : g.id)), g && n.push(g);
  return t.id && n.push(Dt), n;
}, Zc = (e, t, i) => {
  const n = i || e.filter((I) => I.instance.isInstanceLauncher), [g, r] = ce.partition(n, (I) => I.instance.belongsToInstanceId === ((t == null ? void 0 : t.instance.id) || Dt.id) && I.id !== (t == null ? void 0 : t.id));
  let o = g;
  for (const I of o)
    o = [...o, ...Zc(r, I)];
  return o;
}, b1 = (e, t, i) => {
  const n = (t.instance.isInstanceLauncher ? t : (i || e).find((o) => o.instance.isInstanceLauncher && o.instance.id === t.instance.id)) || Dt, g = Zc(e, n, i);
  return [...HZ(e, n, i), n, ...g];
};
function GD(e) {
  return /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/.test(e);
}
const kZ = (e) => (e == null ? void 0 : e.type) === "components", Ca = (e, t) => e.variableId === t.variableId && e.instance.id === t.instance.id && e.instance.belongsToInstanceId === t.instance.belongsToInstanceId, Lfe = (e, t) => (i) => i.variableId === e && i.instance.id === t.id, Tfe = (e, t) => [...t, ...e.filter((i) => !t.some((n) => (n == null ? void 0 : n.value.id) === i.value.id))], Mfe = (e, t, i) => {
  if (!i.instance.belongsToInstanceId)
    return null;
  const n = t.locked.selections.find((s) => s.id === i.instance.belongsToInstanceId);
  if (!n)
    return null;
  const r = t.locked.selections.filter((s) => s.variableId === n.variableId && s.valueId === n.valueId).findIndex((s) => s.id === n.id), o = e.values.byVarId.locked[n.variableId].find((s) => s.id === n.valueId);
  return {
    variable: e.variables.byVarId.locked[n.variableId].label,
    value: (o == null ? void 0 : o.label) || "",
    index: r
  };
}, nh = (e) => e.interval, O0 = (e, t, i) => {
  var o, I, s;
  const n = e.variables.byVarId.all[i.variableId], g = nh(i) ? RQ(i, n) || "" : ((o = e.values.byVarId.all[i.variableId].find((a) => a.id === i.valueId)) == null ? void 0 : o.label) ?? "", r = Mfe(e, t, i);
  return {
    value: g,
    variable: n.label,
    instance: r,
    error: (I = i.data) == null ? void 0 : I.error,
    unsolvable: !!((s = i.data) != null && s.error)
  };
}, SDt = (e) => Number.isInteger(parseInt(e)) && !GD(e), wQ = (e, t) => {
  const [i, n] = ce.partition(t, (g) => e.variables.byVarId.locked[g.variableId]);
  return {
    locked: i,
    free: n
  };
}, Ufe = (e, t) => t.map((i) => ({
  selection: i,
  variable: e.variables.byVarId.all[i.variableId]
})).sort((i, n) => i.variable.sort - n.variable.sort || (i.selection.sort || 0) - (n.selection.sort || 0)).map((i) => i.selection), Pfe = me.curry((e, t, i) => i.variableId === e && i.instance.belongsToInstanceId === t), zfe = (e, t, i) => Math.max(0, ...i.filter(Pfe(e, t)).map((n) => n.sort || 0));
function Ofe(e, t) {
  const i = e.filter((r) => r.parentId === Dt.variableId), n = ce.groupBy(e, (r) => r.parentId);
  let g = [...i];
  for (; g.length > 0; ) {
    const r = g.pop(), o = n[r.id] || [];
    g = t(r, o, g);
  }
}
const vQ = (e) => {
  const t = {}, i = Dt.instance.hierarchyLevel + 1;
  return Ofe(e, (n, g, r) => (t[n.id] = n.parentId ? t[n.parentId] + 1 : i, [...r, ...g])), t;
}, Fm = (e, t) => e.instance.hierarchyLevel - t.instance.hierarchyLevel, Ju = (e, t, i, n, g) => {
  if (Nfe(i))
    return t;
  const r = g || t.filter(_r), o = ce.uniqBy(b1(r, i, g), (C) => C.id), I = n || ce.groupBy(t, (C) => vl(C)), s = o.map((C) => C.variableId), a = /* @__PURE__ */ new Set();
  a.add(Dt);
  for (const C of o) {
    C.id !== Dt.id && a.add(C);
    const u = I[C.id];
    if (u)
      for (let A = 0; A < u.length; A++) {
        const m = u[A];
        s.includes(m.variableId) || a.add(m);
      }
  }
  const d = e[i.variableId];
  for (let C = 0; C < r.length; C++) {
    const u = r[C];
    if (!d.includes(u.variableId) && !d.includes(u.instance.belongsToVariableId)) {
      const A = I[u.id];
      A == null || A.forEach((m) => a.add(m)), a.add(u);
    }
  }
  return Array.from(a);
}, Ed = (e, t) => (e.sort ?? 0) - (t.sort ?? 0), RQ = (e, t, i = !0) => {
  var g;
  if (!e || !nh(e))
    return;
  const n = ((g = e == null ? void 0 : e.data) == null ? void 0 : g.inputValue) ?? 0;
  return t ? XQ(n, t, i) : n.toFixed(0);
}, XQ = (e, t, i = !0) => {
  if (!t)
    return e == null ? void 0 : e.toString();
  const n = hi(t);
  return (e ? e.OC_roundTo(n.digits || 0) : 0).toString().OC_addIfGiven(i ? n.unit : void 0);
}, Qfe = (e) => {
  if (me.isArray(e))
    return !1;
  const t = Number(e);
  return !isNaN(t);
}, jfe = (e) => Array.isArray(e), _B = (e) => pc(e) && "interval" in e && "originalString" in e, _fe = (e) => (e == null ? void 0 : e.id) !== void 0, Og = {
  SetArticle: "setArticle",
  SetInstance: "setInstance",
  SetColor: "setColorByVariable",
  SetImage2D: "setImage2D",
  SetLabel: "setLabel",
  SetPopup: "setPopup",
  SetMaterial: "setMaterial",
  SetMaterialTexture: "setMaterialTexture",
  SetModel: "setModel",
  SetConcealVariable: "setConcealVariable",
  SetConcealGroup: "setConcealGroup",
  SetHideVariable: "setHideVariable",
  SetHideGroup: "setHideGroup",
  SetHideValues: "setHideValues",
  setFocusGroup: "setFocusGroup"
}, QS = (e) => (e == null ? void 0 : e.id) == Og.SetModel && (e == null ? void 0 : e.modelId) !== void 0, $fe = (e) => (e == null ? void 0 : e.id) == Og.SetLabel && (e == null ? void 0 : e.label) !== void 0, qfe = (e) => (e == null ? void 0 : e.id) == Og.SetPopup, eGe = (e) => (e == null ? void 0 : e.id) == Og.SetConcealGroup, tGe = (e) => (e == null ? void 0 : e.id) == Og.SetConcealVariable, iGe = (e) => (e == null ? void 0 : e.id) == Og.SetHideVariable, nGe = (e) => (e == null ? void 0 : e.id) == Og.SetHideGroup, gGe = (e) => pc(e) && e.id === Og.SetHideValues, rGe = (e) => (e == null ? void 0 : e.id) === Og.SetArticle && (e == null ? void 0 : e.articleId) !== void 0, HQ = (e) => (e == null ? void 0 : e.id) === Og.SetInstance && (e == null ? void 0 : e.valueId) !== void 0, oGe = (e) => (e == null ? void 0 : e.id) === Og.SetColor && (e == null ? void 0 : e.variableId) !== void 0, IGe = (e) => (e == null ? void 0 : e.id) === Og.SetMaterial && (e == null ? void 0 : e.materialId) !== void 0, lGe = (e) => (e == null ? void 0 : e.id) === Og.SetImage2D && (e == null ? void 0 : e.path) !== void 0, yD = (e) => (e == null ? void 0 : e.id) === Og.SetMaterialTexture && (e == null ? void 0 : e.variableId) !== void 0, VDt = (e) => pc(e) && "id" in e, sGe = (e) => typeof e == "number", aGe = (e) => me.isArray(e), wDt = (e) => me.anyPass([sGe, aGe])(e), WD = (e, t) => {
  const i = e.values[t.variableId];
  if (i === !0)
    return !0;
  if (_B(i) && nh(t))
    return Bc(t.interval, i.interval);
  try {
    return i.includes(t.valueId);
  } catch (n) {
    return console.error("Failed to compare selection & value", n, t, i), !1;
  }
};
function cGe(e, t) {
  const i = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const g of n.columns)
      g.type === "variable" && i.add(Number(g.targetId));
  return i.delete(t.variableId), i;
}
const FZ = (e, t, i, n) => {
  if (!t.length)
    return {
      isValid: !0
    };
  t.sort(Fm);
  const g = e.ruleItems.rulesByTargetIdMap[i.variableId] || [], r = /* @__PURE__ */ new Set();
  b1(t, i).forEach((d) => r.add(d.id));
  const o = cGe(g, i), I = t.filter(
    (d) => o.has(d.variableId) && r.has(d.instance.id) && d.variableId !== i.variableId
    //siblings should be filtered out
  ), s = ce.groupBy(I, (d) => d.variableId), a = [];
  for (const d of g) {
    const C = (e.ruleItems.byRuleId[d.id] || []).filter((A) => WD(A, i));
    if (!C.length)
      continue;
    if (!I.every((A) => {
      const m = s[A.variableId] || [];
      s[A.variableId] = [A];
      const h = C.some((B) => dGe(o, s, B));
      return s[A.variableId] = m, h;
    })) {
      const A = I.filter((m) => d.columns.some((h) => h.targetId == m.variableId));
      if (a.push(...A), n)
        break;
    }
  }
  return {
    isValid: !a.length,
    conflicts: ce.uniqBy(a, (d) => d.id).map((d) => [i, d])
  };
}, dGe = (e, t, i) => Object.entries(i.values).every(([n, g]) => {
  if (g === !0)
    return !0;
  const r = +n;
  if (!e.has(r))
    return !0;
  const o = t[r];
  return o != null && o.length ? o.some((I) => WD(i, I)) : !0;
}), CGe = (e, t, i) => {
  t.sort(Fm), i.sort(Fm);
  for (let n = 0; n < i.length; n++) {
    const g = n === 0 ? [] : i.slice(0, n), r = FZ(e, [...t, ...g], i[n], !1);
    if (!r.isValid)
      return r;
  }
  return {
    isValid: !0
  };
}, uGe = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let kQ = (e = 21) => {
  let t = "", i = crypto.getRandomValues(new Uint8Array(e));
  for (; e--; )
    t += uGe[i[e] & 63];
  return t;
};
const gh = (e, t, i, n, g, r) => {
  const o = kQ(), I = typeof e == "number" ? e : e.id;
  return {
    id: o,
    variableId: I,
    valueId: (t == null ? void 0 : t.id) || 0,
    instance: n ? {
      id: o,
      belongsToInstanceId: i.id,
      belongsToVariableId: I,
      isInstanceLauncher: !0,
      hierarchyLevel: i.hierarchyLevel + 1
    } : {
      ...i,
      isInstanceLauncher: !1,
      hierarchyLevel: i.hierarchyLevel + 1
    },
    debuggingValue: (t == null ? void 0 : t.label) || `Empty selection for variable ${typeof e == "number" ? e : e.label}`,
    data: g,
    interval: t == null ? void 0 : t.data,
    sort: r
  };
}, wY = (e) => e.settings.templateOptions.suppressConflictDialogVariableIds ?? [], AGe = (e) => {
  var i;
  const t = hi(e);
  return t.suppressConflictDialog && (((i = t == null ? void 0 : t.suppressConflictDialogVariableIds) == null ? void 0 : i.length) ?? 0) > 0;
}, bGe = (e) => {
  const t = e.ruleEngineState, i = e.ruleEngineInput;
  if (t.onlyUntouched || !t.lastManualChange)
    return t.onlyUntouched;
  const n = i.variables.flat.all.filter((I) => AGe(I));
  if (n.length === 0)
    return t.onlyUntouched;
  const g = t.lastManualChange;
  return !t.touchedChanges.some(([I]) => {
    const s = n.find((a) => a.id === I.variableId);
    return !(s && wY(s).includes(g == null ? void 0 : g.variableId));
  });
};
function mGe(e, t) {
  var i;
  return (i = e.conflicts) == null ? void 0 : i.filter(([n, g]) => {
    const r = wY(t.variables.byVarId.all[n.variableId]);
    if (r.length && r.includes(g.variableId))
      return !1;
    const o = wY(t.variables.byVarId.all[g.variableId]);
    return !(o.length && o.includes(n.variableId));
  });
}
const FQ = (e, t, i, n, g) => {
  var C;
  const r = gh(n.variableId, n, g.instance, !1), o = e.filter((u) => !Ca(u, r)), I = t.variables.dependentVariablesById[r.variableId] ?? [], s = Ju(t.variables.variableHierarchies, i.state.all.selections, r).filter((u) => I.includes(u.variableId) && u.variableId !== r.variableId && u.instance.id !== r.instance.id), a = CGe(t, [r], ce.uniqBy([...o, ...s], (u) => u.id));
  if (a.isValid)
    return;
  const d = (C = mGe(a, t)) == null ? void 0 : C.filter((u) => o.some((A) => A.id === u[0].id || A.id === u[1].id));
  if ((d == null ? void 0 : d.length) !== 0)
    return {
      value: n,
      conflicts: (d == null ? void 0 : d.map(([, u]) => u)) ?? []
    };
};
function SD(e) {
  return (e == null ? void 0 : e.type) === "components";
}
function YQ(e, t, i) {
  const n = [...e], g = n.find((I) => I.id == t.id), r = n.indexOf(g);
  return r + i < 0 || r + i > n.length ? e : (n.splice(r, 1), n.splice(r + i, 0, g), n.map((I, s) => ({
    ...I,
    sort: s
  })));
}
const vDt = (e, t) => (e.sort ?? 0) - (t.sort ?? 0) + 1, Ku = (e, t) => (e.sort || 0) - (t.sort || 0), xQ = (e, t) => (e.sort ?? 0) - (t.sort ?? 0) || e.id - t.id, hGe = (e) => e.metadata.groups, to = Pt(hGe, (e) => e.slice().sort(Ku)), RDt = Pt(to, (e) => Ni(e)), DQ = Pt(to, (e) => ce.groupBy(e, (t) => t.appId)), pGe = [];
Pt([(e, t) => t, DQ], (e, t) => t[e] || pGe);
const Ba = (e) => (t) => to(t).find((i) => i.id == e), JQ = (e) => (t) => to(t).find((i) => i.key == e), BGe = (e) => (t) => to(t).find((i) => i.parentId == e), XDt = (e) => (t) => to(t).filter((i) => i.parentId === e), ZGe = (e) => {
  const t = to(e), i = wg(e), n = (g, r) => {
    const o = r != null && r.onlyVars ? [] : [g];
    if (g.parentId) {
      const I = i.find((d) => d.id == g.parentId);
      if (!I)
        return o;
      const s = t.find((d) => d.id == I.groupId);
      if (!s)
        return o;
      const a = n(s, r);
      return r != null && r.onlyGroups || a.push(I), r != null && r.onlyVars || a.push(g), a;
    } else
      return o;
  };
  return n;
}, nn = {
  ArticleAction: "articleAction",
  ColorAction: "colorAction",
  Image2DAction: "image2DAction",
  ImageAction: "imageAction",
  LabelAction: "labelAction",
  PopupAction: "popupAction",
  MaterialAction: "materialAction",
  InstanceAction: "instanceAction",
  ModelAction: "modelAction",
  Variable: "variable",
  ConcealVariableAction: "concealVariableAction",
  ConcealGroupAction: "concealGroupAction",
  HideVariableAction: "hideVariableAction",
  HideGroupAction: "hideGroupAction",
  HideValuesAction: "hideValuesAction",
  FocusedGroup: "focusedGroup"
}, HDt = (e) => (e == null ? void 0 : e.targetModelId) !== void 0 && (e == null ? void 0 : e.targetMaterialName) !== void 0, kDt = (e) => (e == null ? void 0 : e.isGlobalChange) === !0 && (e == null ? void 0 : e.targetMaterialName) !== void 0, FDt = (e) => me.includes(e.type, [nn.FocusedGroup]), fGe = (e) => me.includes(e.type, [nn.ArticleAction, nn.InstanceAction, nn.ColorAction, nn.Image2DAction, nn.ImageAction, nn.LabelAction, nn.PopupAction, nn.MaterialAction, nn.ModelAction, nn.ConcealVariableAction, nn.ConcealGroupAction, nn.HideVariableAction, nn.HideGroupAction, nn.HideValuesAction]), ua = (e) => e.type === nn.Variable, KQ = (e) => e.type === nn.ModelAction, EQ = (e) => e.type === nn.ColorAction, NQ = (e) => e.type === nn.MaterialAction, GGe = (e) => e.type === nn.InstanceAction, LQ = (e) => e.type === nn.LabelAction, TQ = (e) => e.type === nn.PopupAction, MQ = (e) => e.type === nn.ConcealVariableAction, UQ = (e) => e.type === nn.ConcealGroupAction, PQ = (e) => e.type === nn.HideVariableAction, zQ = (e) => e.type === nn.HideGroupAction, OQ = (e) => e.type === nn.HideValuesAction, QQ = (e) => e.type === nn.Image2DAction, m1 = (e) => e.type === nn.ImageAction, yGe = (e) => e.type === nn.ArticleAction, VD = (e) => e.type === nn.FocusedGroup, WGe = [], Qd = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.rules) ?? WGe;
}, jQ = Pt(Qd, (e) => Ni(e)), wD = (e) => (t) => jQ(t)[e], SGe = Pt([Qd, (e, t) => t], (e, t) => e.filter((i) => i.appId == t)), YDt = (e) => (t) => e ? Qd(t).filter((i) => ce.includes(me.map((n) => n.targetId, i.columns), e)) : [], xDt = (e, t) => (i) => {
  var n, g;
  return (
    //@ts-ignore
    (g = (n = wD(e)(i)) == null ? void 0 : n.columns) == null ? void 0 : g.find((r) => r.id == t)
  );
}, VGe = [], wGe = [], _Q = {}, vGe = {}, Dg = (e) => e.ruleEngine.ruleEngineInput, Jg = (e) => e.ruleEngine.ruleEngineState, h1 = (e) => e.ruleEngine.ruleEngineConflict, RGe = [], Wc = (e) => e.ruleEngine.openInstances ?? RGe, $Q = (e, t) => Wc(e).find((i) => i.instance.belongsToInstanceId === t.id && i !== t), rh = (e) => Wc(e).slice().sort(Fm)[0], vD = (e, t) => {
  const i = Ba(t)(e);
  return !i || i.parentId === Dt.variableId ? Dt : Wc(e).find((n) => n.variableId === i.parentId);
}, p1 = (e, t) => {
  const i = Go(t)(e), n = SD(i) ? i.id : i.parentId;
  return Wc(e).find((g) => g.variableId === n);
}, oh = Pt([Dg, Jg, rh], (e, t, i) => ({
  ruleEngineInput: e,
  ruleEngineState: t,
  openInstance: i
})), XGe = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jg(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.validOptions) ?? _Q;
}, qQ = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jg(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.invalidOptions) ?? _Q;
}, ej = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jg(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.touched) ?? vGe;
}, HGe = (e) => (t) => {
  var n;
  const i = p1(t, e);
  return i ? (n = ej(t)[i == null ? void 0 : i.id]) == null ? void 0 : n.includes(e) : !0;
}, kGe = (e) => (t) => {
  var n, g;
  const i = p1(t, e);
  return i ? ((g = (n = XGe(t)[i.id]) == null ? void 0 : n[e]) == null ? void 0 : g.map((r) => r.value)) || [] : [];
}, FGe = (e) => (t) => {
  var n, g;
  const i = p1(t, e.variableId);
  if (i)
    return (g = (n = qQ(t)[i.id]) == null ? void 0 : n[e.variableId]) == null ? void 0 : g.find((r) => r.value.id === e.id);
}, YGe = (e) => (t) => {
  var i, n, g;
  return (((g = (n = (i = Dg(t)) == null ? void 0 : i.values) == null ? void 0 : n.flat) == null ? void 0 : g.all) ?? []).find((r) => r.id === e);
}, tj = (e) => (t) => {
  const i = YGe(e)(t);
  if (!i)
    return;
  const n = FGe(i)(t);
  if (!n)
    return n;
  const g = n.conflicts.filter((s) => HGe(s.variableId)(t)), r = Dg(t), o = Jg(t);
  if (!r || !o)
    return;
  const I = p1(t, i.variableId);
  if (I)
    return FQ(g, r, o, i, I);
}, xGe = (e) => (t) => {
  const i = Dg(t), n = Jg(t);
  return !i || !n ? wGe : e.map((g) => O0(i, n.state, g));
}, DGe = (e) => e.ruleEngine.ruleEngineError, PL = [], RD = Pt([rh, oh, (e, t) => t, (e, t, i) => i, (e, t, i, n) => n, (e, t, i, n, g) => g], (e, {
  ruleEngineInput: t,
  ruleEngineState: i
}, n, g, r, o) => {
  var a, d, C;
  const I = n ?? e;
  if (!g)
    return [];
  const s = (C = (d = (a = i == null ? void 0 : i.state) == null ? void 0 : a.all) == null ? void 0 : d.selections) == null ? void 0 : C.filter((u) => u.variableId === g.id && u.instance.belongsToInstanceId === I.id).sort((u, A) => u.sort - A.sort).reduce((u, A) => {
    const m = t == null ? void 0 : t.values.byVarId.locked[g.id].find((h) => h.id === A.valueId);
    return m && u.push({
      selection: A,
      value: m
    }), u;
  }, []);
  return o && (s == null || s.reverse()), r ? (s == null ? void 0 : s.slice().sort((u, A) => (
    // @ts-ignore
    u.value.sort - A.value.sort || u.selection.sort - A.selection.sort
  ))) ?? PL : s ?? PL;
}), JGe = Pt([Qd], (e) => e.some((t) => t.columns.some(VD))), KGe = [], wg = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.variables) ?? KGe;
}, Za = Pt(wg, (e) => Ni(e)), Go = (e) => (t) => {
  var i;
  return (i = Za(t)) == null ? void 0 : i[e];
}, YZ = (e) => (t) => wg(t).find((i) => i.key === e), ij = (e) => (t) => {
  const i = Ni(wg(t));
  return ce.compact(e == null ? void 0 : e.map((n) => i[n]));
}, DDt = (e) => (t) => wg(t).filter((i) => i.type === e), EGe = Pt([wg, (e, t) => t], (e, t) => e.filter((i) => i.appId === t)), B1 = (e, t) => (i) => {
  var r;
  const n = Dg(i), g = (r = Jg(i)) == null ? void 0 : r.state;
  return !n || !g ? (console.warn("Rule engine not initialized!"), null) : u1(e, n, g, t);
}, NGe = (e, t) => (i) => {
  var r;
  const n = Dg(i), g = (r = Jg(i)) == null ? void 0 : r.state;
  return !n || !g ? (console.warn("Rule engine not initialized!"), null) : WQ(e, n, g, t);
}, JDt = (e) => {
  const t = ZGe(e);
  return (n, g) => {
    const r = Ba(n.groupId)(e);
    return t(r, g);
  };
};
var nj = { exports: {} }, gj = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xZ = Se;
function LGe(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var TGe = typeof Object.is == "function" ? Object.is : LGe, MGe = xZ.useSyncExternalStore, UGe = xZ.useRef, PGe = xZ.useEffect, zGe = xZ.useMemo, OGe = xZ.useDebugValue;
gj.useSyncExternalStoreWithSelector = function(e, t, i, n, g) {
  var r = UGe(null);
  if (r.current === null) {
    var o = { hasValue: !1, value: null };
    r.current = o;
  } else
    o = r.current;
  r = zGe(function() {
    function s(A) {
      if (!a) {
        if (a = !0, d = A, A = n(A), g !== void 0 && o.hasValue) {
          var m = o.value;
          if (g(m, A))
            return C = m;
        }
        return C = A;
      }
      if (m = C, TGe(d, A))
        return m;
      var h = n(A);
      return g !== void 0 && g(m, h) ? m : (d = A, C = h);
    }
    var a = !1, d, C, u = i === void 0 ? null : i;
    return [function() {
      return s(t());
    }, u === null ? void 0 : function() {
      return s(u());
    }];
  }, [t, i, n, g]);
  var I = MGe(e, r[0], r[1]);
  return PGe(function() {
    o.hasValue = !0, o.value = I;
  }, [I]), OGe(I), I;
};
nj.exports = gj;
var QGe = nj.exports, GI = (
  // prettier-ignore
  // @ts-ignore
  "default" in Y ? Y.default : Y
), zL = Symbol.for("react-redux-context"), OL = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function jGe() {
  if (!GI.createContext)
    return {};
  const e = OL[zL] ?? (OL[zL] = /* @__PURE__ */ new Map());
  let t = e.get(GI.createContext);
  return t || (t = GI.createContext(
    null
  ), e.set(GI.createContext, t)), t;
}
var Nd = /* @__PURE__ */ jGe(), _Ge = () => {
  throw new Error("uSES not initialized!");
};
function XD(e = Nd) {
  return function() {
    return GI.useContext(e);
  };
}
var rj = /* @__PURE__ */ XD(), oj = _Ge, $Ge = (e) => {
  oj = e;
}, qGe = (e, t) => e === t;
function eye(e = Nd) {
  const t = e === Nd ? rj : XD(e), i = (n, g = {}) => {
    const { equalityFn: r = qGe, devModeChecks: o = {} } = typeof g == "function" ? { equalityFn: g } : g, {
      store: I,
      subscription: s,
      getServerState: a,
      stabilityCheck: d,
      identityFunctionCheck: C
    } = t();
    GI.useRef(!0);
    const u = GI.useCallback(
      {
        [n.name](m) {
          return n(m);
        }
      }[n.name],
      [n, d, o.stabilityCheck]
    ), A = oj(
      s.addNestedSub,
      I.getState,
      a || I.getState,
      u,
      r
    );
    return GI.useDebugValue(A), A;
  };
  return Object.assign(i, {
    withTypes: () => i
  }), i;
}
function Ij(e) {
  e();
}
function tye() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      Ij(() => {
        let i = e;
        for (; i; )
          i.callback(), i = i.next;
      });
    },
    get() {
      const i = [];
      let n = e;
      for (; n; )
        i.push(n), n = n.next;
      return i;
    },
    subscribe(i) {
      let n = !0;
      const g = t = {
        callback: i,
        next: null,
        prev: t
      };
      return g.prev ? g.prev.next = g : e = g, function() {
        !n || e === null || (n = !1, g.next ? g.next.prev = g.prev : t = g.prev, g.prev ? g.prev.next = g.next : e = g.next);
      };
    }
  };
}
var QL = {
  notify() {
  },
  get: () => []
};
function iye(e, t) {
  let i, n = QL, g = 0, r = !1;
  function o(h) {
    d();
    const B = n.subscribe(h);
    let f = !1;
    return () => {
      f || (f = !0, B(), C());
    };
  }
  function I() {
    n.notify();
  }
  function s() {
    m.onStateChange && m.onStateChange();
  }
  function a() {
    return r;
  }
  function d() {
    g++, i || (i = e.subscribe(s), n = tye());
  }
  function C() {
    g--, i && g === 0 && (i(), i = void 0, n.clear(), n = QL);
  }
  function u() {
    r || (r = !0, d());
  }
  function A() {
    r && (r = !1, C());
  }
  const m = {
    addNestedSub: o,
    notifyNestedSubs: I,
    handleChangeWrapper: s,
    isSubscribed: a,
    trySubscribe: u,
    tryUnsubscribe: A,
    getListeners: () => n
  };
  return m;
}
var nye = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", gye = typeof navigator < "u" && navigator.product === "ReactNative", rye = nye || gye ? GI.useLayoutEffect : GI.useEffect;
function oye({
  store: e,
  context: t,
  children: i,
  serverState: n,
  stabilityCheck: g = "once",
  identityFunctionCheck: r = "once"
}) {
  const o = GI.useMemo(() => {
    const a = iye(e);
    return {
      store: e,
      subscription: a,
      getServerState: n ? () => n : void 0,
      stabilityCheck: g,
      identityFunctionCheck: r
    };
  }, [e, n, g, r]), I = GI.useMemo(() => e.getState(), [e]);
  rye(() => {
    const { subscription: a } = o;
    return a.onStateChange = a.notifyNestedSubs, a.trySubscribe(), I !== e.getState() && a.notifyNestedSubs(), () => {
      a.tryUnsubscribe(), a.onStateChange = void 0;
    };
  }, [o, I]);
  const s = t || Nd;
  return /* @__PURE__ */ GI.createElement(s.Provider, { value: o }, i);
}
var Iye = oye;
function lj(e = Nd) {
  const t = e === Nd ? rj : (
    // @ts-ignore
    XD(e)
  ), i = () => {
    const { store: n } = t();
    return n;
  };
  return Object.assign(i, {
    withTypes: () => i
  }), i;
}
var lye = /* @__PURE__ */ lj();
function sye(e = Nd) {
  const t = e === Nd ? lye : lj(e), i = () => t().dispatch;
  return Object.assign(i, {
    withTypes: () => i
  }), i;
}
var aye = Ij;
$Ge(QGe.useSyncExternalStoreWithSelector);
const HD = Bs({}), zt = sye(HD), cye = eye(HD), _ = (e) => cye(e, jo.enableReduxDevChecks ? void 0 : {
  devModeChecks: {
    stabilityCheck: "never",
    identityFunctionCheck: "never"
  }
});
function dye() {
  const {
    search: e
  } = Ud();
  return je(() => new URLSearchParams(e), [e]);
}
const la = (e) => {
  const t = window.location.search;
  return new URLSearchParams(t).get(e);
}, sj = () => la("app"), Cye = () => la("dealer"), uye = () => {
  const e = window.location.origin, t = jo.originalDomain;
  return !(e.includes("localhost") || e.includes("bs-local") || t && e.includes(t));
}, Aye = () => uye() ? window.location.host : sj(), bye = () => la("k3-code") == null ? la("code") : la("k3-code"), mye = () => la("part"), aj = (e) => {
  const t = mye();
  if (!t)
    return;
  const i = YZ(t)(e);
  return t && (i == null ? void 0 : i.type) === "components" ? i : void 0;
}, kD = () => _(aj), vY = "de", jS = (e) => {
  const t = la("lang");
  if (t)
    return t;
  if (e != null && e.lang)
    return e.lang;
  let i = window.navigator.languages && window.navigator.language.length ? window.navigator.languages[0] : window.navigator.language;
  return i.includes("-") && (i = i.split("-")[0]), i.includes("_") && (i = i.split("_")[0]), i || vY;
}, hye = (e) => {
  const t = new URL(window.location.href);
  t.searchParams.set("code", e), window.history.pushState({}, "", t.toString());
}, pye = () => la("autostartAR"), Bye = () => {
  const e = new URL(window.location.href);
  e.searchParams.delete("autostartAR"), window.history.pushState({}, "", e.toString());
}, Zye = (e, t, i) => (e += (e.includes("?") ? "&" : "?") + `${encodeURIComponent(t)}=`, Array.isArray(i) ? e += i.map((n) => encodeURIComponent(n)).join(",") : e += encodeURIComponent(i), e), fye = (e) => {
  const t = dye().get(encodeURIComponent(e));
  return (t == null ? void 0 : t.split(",").map((i) => decodeURIComponent(i))) || [];
}, Gye = (e) => {
  try {
    return localStorage.getItem(e);
  } catch {
    return null;
  }
};
var hZ;
class yye extends Error {
  constructor(i, n) {
    super(i);
    m9(this, hZ, void 0);
    h9(this, hZ, n);
  }
  get result() {
    return b9(this, hZ);
  }
}
hZ = new WeakMap();
function Wye(e) {
  return me.overEvery([me.has("id")])(e);
}
function Sye(e) {
  return me.overEvery([Wye, me.has("email"), me.has("name"), me.has("role")])(e);
}
function FD() {
  return jo.apiUrl + "$token";
}
function cj() {
  return Gye(FD());
}
function Vye(e) {
  localStorage.setItem(FD(), e);
}
function wye() {
  localStorage.removeItem(FD());
}
function KDt() {
  return cj() != null;
}
async function dj(e, t, i = {}, n = null) {
  const g = {
    method: e,
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: i,
    redirect: "follow",
    referrerPolicy: "no-referrer"
  };
  return n && (g.body = n), await fetch(t, g);
}
async function YD(e, t, i = null, n = {}) {
  const g = jo.apiUrl + "/api/v1.0" + t, r = cj();
  return r && (n.Authorization = "Bearer " + r), await dj(e, g, n, i);
}
async function jd(e, t, i = null, n = {}) {
  const g = await YD(e, t, i, n), r = await g.json();
  if (!g.ok)
    throw new yye(`Response-Error: Status ${g.status}. Message: ${JSON.stringify(r)}`, r);
  return r;
}
async function ui(e, t, i = null, {
  lang: n = ""
} = {}) {
  const g = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  return n && (g["X-language"] = n), i && (i = JSON.stringify(i)), jd(e, t, i, g);
}
async function EDt({
  email: e,
  password: t
}) {
  const i = await ui("POST", "/login", {
    email: e,
    password: t
  });
  if (!Sye(i))
    throw i;
  const n = i;
  try {
    Vye(n.token);
  } catch (g) {
    throw console.error("Login failed: Failed to set user token. Make sure localStorage is accessible", g), g;
  }
  return n;
}
async function NDt() {
  await ui("GET", "/logout"), wye();
}
async function Z1(e) {
  const t = {
    Accept: "application/json"
  }, i = await dj("GET", jo.docUrl + e, t);
  if (i.status != 200 || !i.ok)
    throw new Error(i.status + ": Could not fetch response");
  return await i.json();
}
async function LDt() {
  return await ui("GET", "/client/customers");
}
function f1(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && XS(e, t);
}
function DZ(e, t) {
  if (t && (Cs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return us(e);
}
function Aa(e) {
  return Aa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, Aa(e);
}
function vye(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Rye(e) {
  return nQ(e) || vye(e) || gQ(e) || rQ();
}
function jL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function _L(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jL(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : jL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var Xye = {
  type: "logger",
  log: function(t) {
    this.output("log", t);
  },
  warn: function(t) {
    this.output("warn", t);
  },
  error: function(t) {
    this.output("error", t);
  },
  output: function(t, i) {
    console && console[t] && console[t].apply(console, i);
  }
}, Hye = function() {
  function e(t) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    ys(this, e), this.init(t, i);
  }
  return Ws(e, [{
    key: "init",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = n.prefix || "i18next:", this.logger = i || Xye, this.options = n, this.debug = n.debug;
    }
  }, {
    key: "setDebug",
    value: function(i) {
      this.debug = i;
    }
  }, {
    key: "log",
    value: function() {
      for (var i = arguments.length, n = new Array(i), g = 0; g < i; g++)
        n[g] = arguments[g];
      return this.forward(n, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var i = arguments.length, n = new Array(i), g = 0; g < i; g++)
        n[g] = arguments[g];
      return this.forward(n, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var i = arguments.length, n = new Array(i), g = 0; g < i; g++)
        n[g] = arguments[g];
      return this.forward(n, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var i = arguments.length, n = new Array(i), g = 0; g < i; g++)
        n[g] = arguments[g];
      return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(i, n, g, r) {
      return r && !this.debug ? null : (typeof i[0] == "string" && (i[0] = "".concat(g).concat(this.prefix, " ").concat(i[0])), this.logger[n](i));
    }
  }, {
    key: "create",
    value: function(i) {
      return new e(this.logger, _L(_L({}, {
        prefix: "".concat(this.prefix, ":").concat(i, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(i) {
      return i = i || this.options, i.prefix = i.prefix || this.prefix, new e(this.logger, i);
    }
  }]), e;
}(), $s = new Hye(), Ld = function() {
  function e() {
    ys(this, e), this.observers = {};
  }
  return Ws(e, [{
    key: "on",
    value: function(i, n) {
      var g = this;
      return i.split(" ").forEach(function(r) {
        g.observers[r] = g.observers[r] || [], g.observers[r].push(n);
      }), this;
    }
  }, {
    key: "off",
    value: function(i, n) {
      if (this.observers[i]) {
        if (!n) {
          delete this.observers[i];
          return;
        }
        this.observers[i] = this.observers[i].filter(function(g) {
          return g !== n;
        });
      }
    }
  }, {
    key: "emit",
    value: function(i) {
      for (var n = arguments.length, g = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
        g[r - 1] = arguments[r];
      if (this.observers[i]) {
        var o = [].concat(this.observers[i]);
        o.forEach(function(s) {
          s.apply(void 0, g);
        });
      }
      if (this.observers["*"]) {
        var I = [].concat(this.observers["*"]);
        I.forEach(function(s) {
          s.apply(s, [i].concat(g));
        });
      }
    }
  }]), e;
}();
function Z0() {
  var e, t, i = new Promise(function(n, g) {
    e = n, t = g;
  });
  return i.resolve = e, i.reject = t, i;
}
function $L(e) {
  return e == null ? "" : "" + e;
}
function kye(e, t, i) {
  e.forEach(function(n) {
    t[n] && (i[n] = t[n]);
  });
}
function xD(e, t, i) {
  function n(I) {
    return I && I.indexOf("###") > -1 ? I.replace(/###/g, ".") : I;
  }
  function g() {
    return !e || typeof e == "string";
  }
  for (var r = typeof t != "string" ? [].concat(t) : t.split("."); r.length > 1; ) {
    if (g())
      return {};
    var o = n(r.shift());
    !e[o] && i && (e[o] = new i()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {};
  }
  return g() ? {} : {
    obj: e,
    k: n(r.shift())
  };
}
function qL(e, t, i) {
  var n = xD(e, t, Object), g = n.obj, r = n.k;
  g[r] = i;
}
function Fye(e, t, i, n) {
  var g = xD(e, t, Object), r = g.obj, o = g.k;
  r[o] = r[o] || [], r[o].push(i);
}
function _S(e, t) {
  var i = xD(e, t), n = i.obj, g = i.k;
  if (n)
    return n[g];
}
function e3(e, t, i) {
  var n = _S(e, i);
  return n !== void 0 ? n : _S(t, i);
}
function Cj(e, t, i) {
  for (var n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? typeof e[n] == "string" || e[n] instanceof String || typeof t[n] == "string" || t[n] instanceof String ? i && (e[n] = t[n]) : Cj(e[n], t[n], i) : e[n] = t[n]);
  return e;
}
function Jb(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Yye = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function xye(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, function(t) {
    return Yye[t];
  }) : e;
}
var G1 = typeof window < "u" && window.navigator && typeof window.navigator.userAgentData > "u" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, Dye = [" ", ",", "?", "!", ";"];
function Jye(e, t, i) {
  t = t || "", i = i || "";
  var n = Dye.filter(function(I) {
    return t.indexOf(I) < 0 && i.indexOf(I) < 0;
  });
  if (n.length === 0)
    return !0;
  var g = new RegExp("(".concat(n.map(function(I) {
    return I === "?" ? "\\?" : I;
  }).join("|"), ")")), r = !g.test(e);
  if (!r) {
    var o = e.indexOf(i);
    o > 0 && !g.test(e.substring(0, o)) && (r = !0);
  }
  return r;
}
function t3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function IW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t3(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Kye(e) {
  var t = Eye();
  return function() {
    var n = Aa(e), g;
    if (t) {
      var r = Aa(this).constructor;
      g = Reflect.construct(n, arguments, r);
    } else
      g = n.apply(this, arguments);
    return DZ(this, g);
  };
}
function Eye() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function uj(e, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (e) {
    if (e[t])
      return e[t];
    for (var n = t.split(i), g = e, r = 0; r < n.length; ++r) {
      if (!g || typeof g[n[r]] == "string" && r + 1 < n.length)
        return;
      if (g[n[r]] === void 0) {
        for (var o = 2, I = n.slice(r, r + o).join(i), s = g[I]; s === void 0 && n.length > r + o; )
          o++, I = n.slice(r, r + o).join(i), s = g[I];
        if (s === void 0)
          return;
        if (s === null)
          return null;
        if (t.endsWith(I)) {
          if (typeof s == "string")
            return s;
          if (I && typeof s[I] == "string")
            return s[I];
        }
        var a = n.slice(r + o).join(i);
        return a ? uj(s, a, i) : void 0;
      }
      g = g[n[r]];
    }
    return g;
  }
}
var Nye = function(e) {
  f1(i, e);
  var t = Kye(i);
  function i(n) {
    var g, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return ys(this, i), g = t.call(this), G1 && Ld.call(us(g)), g.data = n || {}, g.options = r, g.options.keySeparator === void 0 && (g.options.keySeparator = "."), g.options.ignoreJSONStructure === void 0 && (g.options.ignoreJSONStructure = !0), g;
  }
  return Ws(i, [{
    key: "addNamespaces",
    value: function(g) {
      this.options.ns.indexOf(g) < 0 && this.options.ns.push(g);
    }
  }, {
    key: "removeNamespaces",
    value: function(g) {
      var r = this.options.ns.indexOf(g);
      r > -1 && this.options.ns.splice(r, 1);
    }
  }, {
    key: "getResource",
    value: function(g, r, o) {
      var I = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = I.keySeparator !== void 0 ? I.keySeparator : this.options.keySeparator, a = I.ignoreJSONStructure !== void 0 ? I.ignoreJSONStructure : this.options.ignoreJSONStructure, d = [g, r];
      o && typeof o != "string" && (d = d.concat(o)), o && typeof o == "string" && (d = d.concat(s ? o.split(s) : o)), g.indexOf(".") > -1 && (d = g.split("."));
      var C = _S(this.data, d);
      return C || !a || typeof o != "string" ? C : uj(this.data && this.data[g] && this.data[g][r], o, s);
    }
  }, {
    key: "addResource",
    value: function(g, r, o, I) {
      var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, a = this.options.keySeparator;
      a === void 0 && (a = ".");
      var d = [g, r];
      o && (d = d.concat(a ? o.split(a) : o)), g.indexOf(".") > -1 && (d = g.split("."), I = r, r = d[1]), this.addNamespaces(r), qL(this.data, d, I), s.silent || this.emit("added", g, r, o, I);
    }
  }, {
    key: "addResources",
    value: function(g, r, o) {
      var I = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var s in o)
        (typeof o[s] == "string" || Object.prototype.toString.apply(o[s]) === "[object Array]") && this.addResource(g, r, s, o[s], {
          silent: !0
        });
      I.silent || this.emit("added", g, r, o);
    }
  }, {
    key: "addResourceBundle",
    value: function(g, r, o, I, s) {
      var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, d = [g, r];
      g.indexOf(".") > -1 && (d = g.split("."), I = o, o = r, r = d[1]), this.addNamespaces(r);
      var C = _S(this.data, d) || {};
      I ? Cj(C, o, s) : C = IW(IW({}, C), o), qL(this.data, d, C), a.silent || this.emit("added", g, r, o);
    }
  }, {
    key: "removeResourceBundle",
    value: function(g, r) {
      this.hasResourceBundle(g, r) && delete this.data[g][r], this.removeNamespaces(r), this.emit("removed", g, r);
    }
  }, {
    key: "hasResourceBundle",
    value: function(g, r) {
      return this.getResource(g, r) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(g, r) {
      return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? IW(IW({}, {}), this.getResource(g, r)) : this.getResource(g, r);
    }
  }, {
    key: "getDataByLanguage",
    value: function(g) {
      return this.data[g];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(g) {
      var r = this.getDataByLanguage(g), o = r && Object.keys(r) || [];
      return !!o.find(function(I) {
        return r[I] && Object.keys(r[I]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), i;
}(Ld), Aj = {
  processors: {},
  addPostProcessor: function(t) {
    this.processors[t.name] = t;
  },
  handle: function(t, i, n, g, r) {
    var o = this;
    return t.forEach(function(I) {
      o.processors[I] && (i = o.processors[I].process(i, n, g, r));
    }), i;
  }
};
function i3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function co(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? i3(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : i3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Lye(e) {
  var t = Tye();
  return function() {
    var n = Aa(e), g;
    if (t) {
      var r = Aa(this).constructor;
      g = Reflect.construct(n, arguments, r);
    } else
      g = n.apply(this, arguments);
    return DZ(this, g);
  };
}
function Tye() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var n3 = {}, g3 = function(e) {
  f1(i, e);
  var t = Lye(i);
  function i(n) {
    var g, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return ys(this, i), g = t.call(this), G1 && Ld.call(us(g)), kye(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, us(g)), g.options = r, g.options.keySeparator === void 0 && (g.options.keySeparator = "."), g.logger = $s.create("translator"), g;
  }
  return Ws(i, [{
    key: "changeLanguage",
    value: function(g) {
      g && (this.language = g);
    }
  }, {
    key: "exists",
    value: function(g) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (g == null)
        return !1;
      var o = this.resolve(g, r);
      return o && o.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(g, r) {
      var o = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
      o === void 0 && (o = ":");
      var I = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, s = r.ns || this.options.defaultNS || [], a = o && g.indexOf(o) > -1, d = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !Jye(g, o, I);
      if (a && !d) {
        var C = g.match(this.interpolator.nestingRegexp);
        if (C && C.length > 0)
          return {
            key: g,
            namespaces: s
          };
        var u = g.split(o);
        (o !== I || o === I && this.options.ns.indexOf(u[0]) > -1) && (s = u.shift()), g = u.join(I);
      }
      return typeof s == "string" && (s = [s]), {
        key: g,
        namespaces: s
      };
    }
  }, {
    key: "translate",
    value: function(g, r, o) {
      var I = this;
      if (Cs(r) !== "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), r || (r = {}), g == null)
        return "";
      Array.isArray(g) || (g = [String(g)]);
      var s = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, d = this.extractFromKey(g[g.length - 1], r), C = d.key, u = d.namespaces, A = u[u.length - 1], m = r.lng || this.language, h = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (m && m.toLowerCase() === "cimode") {
        if (h) {
          var B = r.nsSeparator || this.options.nsSeparator;
          return s ? (f.res = "".concat(A).concat(B).concat(C), f) : "".concat(A).concat(B).concat(C);
        }
        return s ? (f.res = C, f) : C;
      }
      var f = this.resolve(g, r), G = f && f.res, y = f && f.usedKey || C, W = f && f.exactUsedKey || C, V = Object.prototype.toString.apply(G), w = ["[object Number]", "[object Function]", "[object RegExp]"], v = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, H = !this.i18nFormat || this.i18nFormat.handleAsObject, x = typeof G != "string" && typeof G != "boolean" && typeof G != "number";
      if (H && G && x && w.indexOf(V) < 0 && !(typeof v == "string" && V === "[object Array]")) {
        if (!r.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var N = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(y, G, co(co({}, r), {}, {
            ns: u
          })) : "key '".concat(C, " (").concat(this.language, ")' returned an object instead of string.");
          return s ? (f.res = N, f) : N;
        }
        if (a) {
          var M = V === "[object Array]", $ = M ? [] : {}, q = M ? W : y;
          for (var E in G)
            if (Object.prototype.hasOwnProperty.call(G, E)) {
              var L = "".concat(q).concat(a).concat(E);
              $[E] = this.translate(L, co(co({}, r), {
                joinArrays: !1,
                ns: u
              })), $[E] === L && ($[E] = G[E]);
            }
          G = $;
        }
      } else if (H && typeof v == "string" && V === "[object Array]")
        G = G.join(v), G && (G = this.extendTranslation(G, g, r, o));
      else {
        var P = !1, Q = !1, te = r.count !== void 0 && typeof r.count != "string", le = i.hasDefaultValue(r), Ae = te ? this.pluralResolver.getSuffix(m, r.count, r) : "", we = r["defaultValue".concat(Ae)] || r.defaultValue;
        !this.isValidLookup(G) && le && (P = !0, G = we), this.isValidLookup(G) || (Q = !0, G = C);
        var Ee = r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, Je = Ee && Q ? void 0 : G, ve = le && we !== G && this.options.updateMissing;
        if (Q || P || ve) {
          if (this.logger.log(ve ? "updateKey" : "missingKey", m, A, C, ve ? we : G), a) {
            var Be = this.resolve(C, co(co({}, r), {}, {
              keySeparator: !1
            }));
            Be && Be.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var ue = [], Xe = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && Xe && Xe[0])
            for (var Ze = 0; Ze < Xe.length; Ze++)
              ue.push(Xe[Ze]);
          else
            this.options.saveMissingTo === "all" ? ue = this.languageUtils.toResolveHierarchy(r.lng || this.language) : ue.push(r.lng || this.language);
          var Ke = function(rt, dt, ot) {
            var ze = le && ot !== G ? ot : Je;
            I.options.missingKeyHandler ? I.options.missingKeyHandler(rt, A, dt, ze, ve, r) : I.backendConnector && I.backendConnector.saveMissing && I.backendConnector.saveMissing(rt, A, dt, ze, ve, r), I.emit("missingKey", rt, A, dt, G);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && te ? ue.forEach(function($e) {
            I.pluralResolver.getSuffixes($e, r).forEach(function(rt) {
              Ke([$e], C + rt, r["defaultValue".concat(rt)] || we);
            });
          }) : Ke(ue, C, we));
        }
        G = this.extendTranslation(G, g, r, f, o), Q && G === C && this.options.appendNamespaceToMissingKey && (G = "".concat(A, ":").concat(C)), (Q || P) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? G = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(A, ":").concat(C) : C, P ? G : void 0) : G = this.options.parseMissingKeyHandler(G));
      }
      return s ? (f.res = G, f) : G;
    }
  }, {
    key: "extendTranslation",
    value: function(g, r, o, I, s) {
      var a = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        g = this.i18nFormat.parse(g, co(co({}, this.options.interpolation.defaultVariables), o), I.usedLng, I.usedNS, I.usedKey, {
          resolved: I
        });
      else if (!o.skipInterpolation) {
        o.interpolation && this.interpolator.init(co(co({}, o), {
          interpolation: co(co({}, this.options.interpolation), o.interpolation)
        }));
        var d = typeof g == "string" && (o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), C;
        if (d) {
          var u = g.match(this.interpolator.nestingRegexp);
          C = u && u.length;
        }
        var A = o.replace && typeof o.replace != "string" ? o.replace : o;
        if (this.options.interpolation.defaultVariables && (A = co(co({}, this.options.interpolation.defaultVariables), A)), g = this.interpolator.interpolate(g, A, o.lng || this.language, o), d) {
          var m = g.match(this.interpolator.nestingRegexp), h = m && m.length;
          C < h && (o.nest = !1);
        }
        o.nest !== !1 && (g = this.interpolator.nest(g, function() {
          for (var G = arguments.length, y = new Array(G), W = 0; W < G; W++)
            y[W] = arguments[W];
          return s && s[0] === y[0] && !o.context ? (a.logger.warn("It seems you are nesting recursively key: ".concat(y[0], " in key: ").concat(r[0])), null) : a.translate.apply(a, y.concat([r]));
        }, o)), o.interpolation && this.interpolator.reset();
      }
      var B = o.postProcess || this.options.postProcess, f = typeof B == "string" ? [B] : B;
      return g != null && f && f.length && o.applyPostProcessor !== !1 && (g = Aj.handle(f, g, r, this.options && this.options.postProcessPassResolved ? co({
        i18nResolved: I
      }, o) : o, this)), g;
    }
  }, {
    key: "resolve",
    value: function(g) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, I, s, a, d, C;
      return typeof g == "string" && (g = [g]), g.forEach(function(u) {
        if (!r.isValidLookup(I)) {
          var A = r.extractFromKey(u, o), m = A.key;
          s = m;
          var h = A.namespaces;
          r.options.fallbackNS && (h = h.concat(r.options.fallbackNS));
          var B = o.count !== void 0 && typeof o.count != "string", f = B && !o.ordinal && o.count === 0 && r.pluralResolver.shouldUseIntlApi(), G = o.context !== void 0 && (typeof o.context == "string" || typeof o.context == "number") && o.context !== "", y = o.lngs ? o.lngs : r.languageUtils.toResolveHierarchy(o.lng || r.language, o.fallbackLng);
          h.forEach(function(W) {
            r.isValidLookup(I) || (C = W, !n3["".concat(y[0], "-").concat(W)] && r.utils && r.utils.hasLoadedNamespace && !r.utils.hasLoadedNamespace(C) && (n3["".concat(y[0], "-").concat(W)] = !0, r.logger.warn('key "'.concat(s, '" for languages "').concat(y.join(", "), `" won't get resolved as namespace "`).concat(C, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach(function(V) {
              if (!r.isValidLookup(I)) {
                d = V;
                var w = [m];
                if (r.i18nFormat && r.i18nFormat.addLookupKeys)
                  r.i18nFormat.addLookupKeys(w, m, V, W, o);
                else {
                  var v;
                  B && (v = r.pluralResolver.getSuffix(V, o.count, o));
                  var H = "".concat(r.options.pluralSeparator, "zero");
                  if (B && (w.push(m + v), f && w.push(m + H)), G) {
                    var x = "".concat(m).concat(r.options.contextSeparator).concat(o.context);
                    w.push(x), B && (w.push(x + v), f && w.push(x + H));
                  }
                }
                for (var N; N = w.pop(); )
                  r.isValidLookup(I) || (a = N, I = r.getResource(V, W, N, o));
              }
            }));
          });
        }
      }), {
        res: I,
        usedKey: s,
        exactUsedKey: a,
        usedLng: d,
        usedNS: C
      };
    }
  }, {
    key: "isValidLookup",
    value: function(g) {
      return g !== void 0 && !(!this.options.returnNull && g === null) && !(!this.options.returnEmptyString && g === "");
    }
  }, {
    key: "getResource",
    value: function(g, r, o) {
      var I = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(g, r, o, I) : this.resourceStore.getResource(g, r, o, I);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(g) {
      var r = "defaultValue";
      for (var o in g)
        if (Object.prototype.hasOwnProperty.call(g, o) && r === o.substring(0, r.length) && g[o] !== void 0)
          return !0;
      return !1;
    }
  }]), i;
}(Ld);
function fk(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var Mye = function() {
  function e(t) {
    ys(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = $s.create("languageUtils");
  }
  return Ws(e, [{
    key: "getScriptPartFromCode",
    value: function(i) {
      if (!i || i.indexOf("-") < 0)
        return null;
      var n = i.split("-");
      return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(i) {
      if (!i || i.indexOf("-") < 0)
        return i;
      var n = i.split("-");
      return this.formatLanguageCode(n[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(i) {
      if (typeof i == "string" && i.indexOf("-") > -1) {
        var n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], g = i.split("-");
        return this.options.lowerCaseLng ? g = g.map(function(r) {
          return r.toLowerCase();
        }) : g.length === 2 ? (g[0] = g[0].toLowerCase(), g[1] = g[1].toUpperCase(), n.indexOf(g[1].toLowerCase()) > -1 && (g[1] = fk(g[1].toLowerCase()))) : g.length === 3 && (g[0] = g[0].toLowerCase(), g[1].length === 2 && (g[1] = g[1].toUpperCase()), g[0] !== "sgn" && g[2].length === 2 && (g[2] = g[2].toUpperCase()), n.indexOf(g[1].toLowerCase()) > -1 && (g[1] = fk(g[1].toLowerCase())), n.indexOf(g[2].toLowerCase()) > -1 && (g[2] = fk(g[2].toLowerCase()))), g.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? i.toLowerCase() : i;
    }
  }, {
    key: "isSupportedCode",
    value: function(i) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (i = this.getLanguagePartFromCode(i)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(i) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(i) {
      var n = this;
      if (!i)
        return null;
      var g;
      return i.forEach(function(r) {
        if (!g) {
          var o = n.formatLanguageCode(r);
          (!n.options.supportedLngs || n.isSupportedCode(o)) && (g = o);
        }
      }), !g && this.options.supportedLngs && i.forEach(function(r) {
        if (!g) {
          var o = n.getLanguagePartFromCode(r);
          if (n.isSupportedCode(o))
            return g = o;
          g = n.options.supportedLngs.find(function(I) {
            if (I.indexOf(o) === 0)
              return I;
          });
        }
      }), g || (g = this.getFallbackCodes(this.options.fallbackLng)[0]), g;
    }
  }, {
    key: "getFallbackCodes",
    value: function(i, n) {
      if (!i)
        return [];
      if (typeof i == "function" && (i = i(n)), typeof i == "string" && (i = [i]), Object.prototype.toString.apply(i) === "[object Array]")
        return i;
      if (!n)
        return i.default || [];
      var g = i[n];
      return g || (g = i[this.getScriptPartFromCode(n)]), g || (g = i[this.formatLanguageCode(n)]), g || (g = i[this.getLanguagePartFromCode(n)]), g || (g = i.default), g || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(i, n) {
      var g = this, r = this.getFallbackCodes(n || this.options.fallbackLng || [], i), o = [], I = function(a) {
        a && (g.isSupportedCode(a) ? o.push(a) : g.logger.warn("rejecting language code not found in supportedLngs: ".concat(a)));
      };
      return typeof i == "string" && i.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && I(this.formatLanguageCode(i)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && I(this.getScriptPartFromCode(i)), this.options.load !== "currentOnly" && I(this.getLanguagePartFromCode(i))) : typeof i == "string" && I(this.formatLanguageCode(i)), r.forEach(function(s) {
        o.indexOf(s) < 0 && I(g.formatLanguageCode(s));
      }), o;
    }
  }]), e;
}(), Uye = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Pye = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
}, zye = ["v1", "v2", "v3"], r3 = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Oye() {
  var e = {};
  return Uye.forEach(function(t) {
    t.lngs.forEach(function(i) {
      e[i] = {
        numbers: t.nr,
        plurals: Pye[t.fc]
      };
    });
  }), e;
}
var Qye = function() {
  function e(t) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    ys(this, e), this.languageUtils = t, this.options = i, this.logger = $s.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Oye();
  }
  return Ws(e, [{
    key: "addRule",
    value: function(i, n) {
      this.rules[i] = n;
    }
  }, {
    key: "getRule",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(i, {
            type: n.ordinal ? "ordinal" : "cardinal"
          });
        } catch {
          return;
        }
      return this.rules[i] || this.rules[this.languageUtils.getLanguagePartFromCode(i)];
    }
  }, {
    key: "needsPlural",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = this.getRule(i, n);
      return this.shouldUseIntlApi() ? g && g.resolvedOptions().pluralCategories.length > 1 : g && g.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(i, n) {
      var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(i, g).map(function(r) {
        return "".concat(n).concat(r);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(i) {
      var n = this, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.getRule(i, g);
      return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort(function(o, I) {
        return r3[o] - r3[I];
      }).map(function(o) {
        return "".concat(n.options.prepend).concat(o);
      }) : r.numbers.map(function(o) {
        return n.getSuffix(i, o, g);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(i, n) {
      var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = this.getRule(i, g);
      return r ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(r.select(n)) : this.getSuffixRetroCompatible(r, n) : (this.logger.warn("no plural rule found for: ".concat(i)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(i, n) {
      var g = this, r = i.noAbs ? i.plurals(n) : i.plurals(Math.abs(n)), o = i.numbers[r];
      this.options.simplifyPluralSuffix && i.numbers.length === 2 && i.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
      var I = function() {
        return g.options.prepend && o.toString() ? g.options.prepend + o.toString() : o.toString();
      };
      return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? "_plural_".concat(o.toString()) : I() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && i.numbers.length === 2 && i.numbers[0] === 1 ? I() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !zye.includes(this.options.compatibilityJSON);
    }
  }]), e;
}();
function o3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function $l(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o3(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : o3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var jye = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ys(this, e), this.logger = $s.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function(i) {
      return i;
    }, this.init(t);
  }
  return Ws(e, [{
    key: "init",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      i.interpolation || (i.interpolation = {
        escapeValue: !0
      });
      var n = i.interpolation;
      this.escape = n.escape !== void 0 ? n.escape : xye, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? Jb(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? Jb(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? Jb(n.nestingPrefix) : n.nestingPrefixEscaped || Jb("$t("), this.nestingSuffix = n.nestingSuffix ? Jb(n.nestingSuffix) : n.nestingSuffixEscaped || Jb(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var i = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(i, "g");
      var n = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(n, "g");
      var g = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(g, "g");
    }
  }, {
    key: "interpolate",
    value: function(i, n, g, r) {
      var o = this, I, s, a, d = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function C(B) {
        return B.replace(/\$/g, "$$$$");
      }
      var u = function(f) {
        if (f.indexOf(o.formatSeparator) < 0) {
          var G = e3(n, d, f);
          return o.alwaysFormat ? o.format(G, void 0, g, $l($l($l({}, r), n), {}, {
            interpolationkey: f
          })) : G;
        }
        var y = f.split(o.formatSeparator), W = y.shift().trim(), V = y.join(o.formatSeparator).trim();
        return o.format(e3(n, d, W), V, g, $l($l($l({}, r), n), {}, {
          interpolationkey: W
        }));
      };
      this.resetRegExp();
      var A = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler, m = r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, h = [{
        regex: this.regexpUnescape,
        safeValue: function(f) {
          return C(f);
        }
      }, {
        regex: this.regexp,
        safeValue: function(f) {
          return o.escapeValue ? C(o.escape(f)) : C(f);
        }
      }];
      return h.forEach(function(B) {
        for (a = 0; I = B.regex.exec(i); ) {
          var f = I[1].trim();
          if (s = u(f), s === void 0)
            if (typeof A == "function") {
              var G = A(i, I, r);
              s = typeof G == "string" ? G : "";
            } else if (r && r.hasOwnProperty(f))
              s = "";
            else if (m) {
              s = I[0];
              continue;
            } else
              o.logger.warn("missed to pass in variable ".concat(f, " for interpolating ").concat(i)), s = "";
          else
            typeof s != "string" && !o.useRawValueToEscape && (s = $L(s));
          var y = B.safeValue(s);
          if (i = i.replace(I[0], y), m ? (B.regex.lastIndex += s.length, B.regex.lastIndex -= I[0].length) : B.regex.lastIndex = 0, a++, a >= o.maxReplaces)
            break;
        }
      }), i;
    }
  }, {
    key: "nest",
    value: function(i, n) {
      var g = this, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, I, s = $l({}, r);
      s.applyPostProcessor = !1, delete s.defaultValue;
      function a(A, m) {
        var h = this.nestingOptionsSeparator;
        if (A.indexOf(h) < 0)
          return A;
        var B = A.split(new RegExp("".concat(h, "[ ]*{"))), f = "{".concat(B[1]);
        A = B[0], f = this.interpolate(f, s);
        var G = f.match(/'/g), y = f.match(/"/g);
        (G && G.length % 2 === 0 && !y || y.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
        try {
          s = JSON.parse(f), m && (s = $l($l({}, m), s));
        } catch (W) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(A), W), "".concat(A).concat(h).concat(f);
        }
        return delete s.defaultValue, A;
      }
      for (; o = this.nestingRegexp.exec(i); ) {
        var d = [], C = !1;
        if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
          var u = o[1].split(this.formatSeparator).map(function(A) {
            return A.trim();
          });
          o[1] = u.shift(), d = u, C = !0;
        }
        if (I = n(a.call(this, o[1].trim(), s), s), I && o[0] === i && typeof I != "string")
          return I;
        typeof I != "string" && (I = $L(I)), I || (this.logger.warn("missed to resolve ".concat(o[1], " for nesting ").concat(i)), I = ""), C && (I = d.reduce(function(A, m) {
          return g.format(A, m, r.lng, $l($l({}, r), {}, {
            interpolationkey: o[1].trim()
          }));
        }, I.trim())), i = i.replace(o[0], I), this.regexp.lastIndex = 0;
      }
      return i;
    }
  }]), e;
}();
function I3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function ad(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? I3(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : I3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function _ye(e) {
  var t = e.toLowerCase().trim(), i = {};
  if (e.indexOf("(") > -1) {
    var n = e.split("(");
    t = n[0].toLowerCase().trim();
    var g = n[1].substring(0, n[1].length - 1);
    if (t === "currency" && g.indexOf(":") < 0)
      i.currency || (i.currency = g.trim());
    else if (t === "relativetime" && g.indexOf(":") < 0)
      i.range || (i.range = g.trim());
    else {
      var r = g.split(";");
      r.forEach(function(o) {
        if (o) {
          var I = o.split(":"), s = Rye(I), a = s[0], d = s.slice(1), C = d.join(":").trim().replace(/^'+|'+$/g, "");
          i[a.trim()] || (i[a.trim()] = C), C === "false" && (i[a.trim()] = !1), C === "true" && (i[a.trim()] = !0), isNaN(C) || (i[a.trim()] = parseInt(C, 10));
        }
      });
    }
  }
  return {
    formatName: t,
    formatOptions: i
  };
}
function Kb(e) {
  var t = {};
  return function(n, g, r) {
    var o = g + JSON.stringify(r), I = t[o];
    return I || (I = e(g, r), t[o] = I), I(n);
  };
}
var $ye = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ys(this, e), this.logger = $s.create("formatter"), this.options = t, this.formats = {
      number: Kb(function(i, n) {
        var g = new Intl.NumberFormat(i, n);
        return function(r) {
          return g.format(r);
        };
      }),
      currency: Kb(function(i, n) {
        var g = new Intl.NumberFormat(i, ad(ad({}, n), {}, {
          style: "currency"
        }));
        return function(r) {
          return g.format(r);
        };
      }),
      datetime: Kb(function(i, n) {
        var g = new Intl.DateTimeFormat(i, ad({}, n));
        return function(r) {
          return g.format(r);
        };
      }),
      relativetime: Kb(function(i, n) {
        var g = new Intl.RelativeTimeFormat(i, ad({}, n));
        return function(r) {
          return g.format(r, n.range || "day");
        };
      }),
      list: Kb(function(i, n) {
        var g = new Intl.ListFormat(i, ad({}, n));
        return function(r) {
          return g.format(r);
        };
      })
    }, this.init(t);
  }
  return Ws(e, [{
    key: "init",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, g = n.interpolation;
      this.formatSeparator = g.formatSeparator ? g.formatSeparator : g.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(i, n) {
      this.formats[i.toLowerCase().trim()] = n;
    }
  }, {
    key: "addCached",
    value: function(i, n) {
      this.formats[i.toLowerCase().trim()] = Kb(n);
    }
  }, {
    key: "format",
    value: function(i, n, g, r) {
      var o = this, I = n.split(this.formatSeparator), s = I.reduce(function(a, d) {
        var C = _ye(d), u = C.formatName, A = C.formatOptions;
        if (o.formats[u]) {
          var m = a;
          try {
            var h = r && r.formatParams && r.formatParams[r.interpolationkey] || {}, B = h.locale || h.lng || r.locale || r.lng || g;
            m = o.formats[u](a, B, ad(ad(ad({}, A), r), h));
          } catch (f) {
            o.logger.warn(f);
          }
          return m;
        } else
          o.logger.warn("there was no format function for ".concat(u));
        return a;
      }, i);
      return s;
    }
  }]), e;
}();
function l3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function s3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l3(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : l3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function qye(e) {
  var t = eWe();
  return function() {
    var n = Aa(e), g;
    if (t) {
      var r = Aa(this).constructor;
      g = Reflect.construct(n, arguments, r);
    } else
      g = n.apply(this, arguments);
    return DZ(this, g);
  };
}
function eWe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function tWe(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
var iWe = function(e) {
  f1(i, e);
  var t = qye(i);
  function i(n, g, r) {
    var o, I = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return ys(this, i), o = t.call(this), G1 && Ld.call(us(o)), o.backend = n, o.store = g, o.services = r, o.languageUtils = r.languageUtils, o.options = I, o.logger = $s.create("backendConnector"), o.waitingReads = [], o.maxParallelReads = I.maxParallelReads || 10, o.readingCalls = 0, o.maxRetries = I.maxRetries >= 0 ? I.maxRetries : 5, o.retryTimeout = I.retryTimeout >= 1 ? I.retryTimeout : 350, o.state = {}, o.queue = [], o.backend && o.backend.init && o.backend.init(r, I.backend, I), o;
  }
  return Ws(i, [{
    key: "queueLoad",
    value: function(g, r, o, I) {
      var s = this, a = {}, d = {}, C = {}, u = {};
      return g.forEach(function(A) {
        var m = !0;
        r.forEach(function(h) {
          var B = "".concat(A, "|").concat(h);
          !o.reload && s.store.hasResourceBundle(A, h) ? s.state[B] = 2 : s.state[B] < 0 || (s.state[B] === 1 ? d[B] === void 0 && (d[B] = !0) : (s.state[B] = 1, m = !1, d[B] === void 0 && (d[B] = !0), a[B] === void 0 && (a[B] = !0), u[h] === void 0 && (u[h] = !0)));
        }), m || (C[A] = !0);
      }), (Object.keys(a).length || Object.keys(d).length) && this.queue.push({
        pending: d,
        pendingCount: Object.keys(d).length,
        loaded: {},
        errors: [],
        callback: I
      }), {
        toLoad: Object.keys(a),
        pending: Object.keys(d),
        toLoadLanguages: Object.keys(C),
        toLoadNamespaces: Object.keys(u)
      };
    }
  }, {
    key: "loaded",
    value: function(g, r, o) {
      var I = g.split("|"), s = I[0], a = I[1];
      r && this.emit("failedLoading", s, a, r), o && this.store.addResourceBundle(s, a, o), this.state[g] = r ? -1 : 2;
      var d = {};
      this.queue.forEach(function(C) {
        Fye(C.loaded, [s], a), tWe(C, g), r && C.errors.push(r), C.pendingCount === 0 && !C.done && (Object.keys(C.loaded).forEach(function(u) {
          d[u] || (d[u] = {});
          var A = C.loaded[u];
          A.length && A.forEach(function(m) {
            d[u][m] === void 0 && (d[u][m] = !0);
          });
        }), C.done = !0, C.errors.length ? C.callback(C.errors) : C.callback());
      }), this.emit("loaded", d), this.queue = this.queue.filter(function(C) {
        return !C.done;
      });
    }
  }, {
    key: "read",
    value: function(g, r, o) {
      var I = this, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, d = arguments.length > 5 ? arguments[5] : void 0;
      if (!g.length)
        return d(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: g,
          ns: r,
          fcName: o,
          tried: s,
          wait: a,
          callback: d
        });
        return;
      }
      return this.readingCalls++, this.backend[o](g, r, function(C, u) {
        if (I.readingCalls--, I.waitingReads.length > 0) {
          var A = I.waitingReads.shift();
          I.read(A.lng, A.ns, A.fcName, A.tried, A.wait, A.callback);
        }
        if (C && u && s < I.maxRetries) {
          setTimeout(function() {
            I.read.call(I, g, r, o, s + 1, a * 2, d);
          }, a);
          return;
        }
        d(C, u);
      });
    }
  }, {
    key: "prepareLoading",
    value: function(g, r) {
      var o = this, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
      typeof g == "string" && (g = this.languageUtils.toResolveHierarchy(g)), typeof r == "string" && (r = [r]);
      var a = this.queueLoad(g, r, I, s);
      if (!a.toLoad.length)
        return a.pending.length || s(), null;
      a.toLoad.forEach(function(d) {
        o.loadOne(d);
      });
    }
  }, {
    key: "load",
    value: function(g, r, o) {
      this.prepareLoading(g, r, {}, o);
    }
  }, {
    key: "reload",
    value: function(g, r, o) {
      this.prepareLoading(g, r, {
        reload: !0
      }, o);
    }
  }, {
    key: "loadOne",
    value: function(g) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", I = g.split("|"), s = I[0], a = I[1];
      this.read(s, a, "read", void 0, void 0, function(d, C) {
        d && r.logger.warn("".concat(o, "loading namespace ").concat(a, " for language ").concat(s, " failed"), d), !d && C && r.logger.log("".concat(o, "loaded namespace ").concat(a, " for language ").concat(s), C), r.loaded(g, d, C);
      });
    }
  }, {
    key: "saveMissing",
    value: function(g, r, o, I, s) {
      var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
        this.logger.warn('did not save key "'.concat(o, '" as the namespace "').concat(r, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      o == null || o === "" || (this.backend && this.backend.create && this.backend.create(g, r, o, I, null, s3(s3({}, a), {}, {
        isUpdate: s
      })), !(!g || !g[0]) && this.store.addResource(g[0], r, o, I));
    }
  }]), i;
}(Ld);
function nWe() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      var i = {};
      if (Cs(t[1]) === "object" && (i = t[1]), typeof t[1] == "string" && (i.defaultValue = t[1]), typeof t[2] == "string" && (i.tDescription = t[2]), Cs(t[2]) === "object" || Cs(t[3]) === "object") {
        var n = t[3] || t[2];
        Object.keys(n).forEach(function(g) {
          i[g] = n[g];
        });
      }
      return i;
    },
    interpolation: {
      escapeValue: !0,
      format: function(t, i, n, g) {
        return t;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function a3(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function c3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Ts(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c3(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : c3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function gWe(e) {
  var t = rWe();
  return function() {
    var n = Aa(e), g;
    if (t) {
      var r = Aa(this).constructor;
      g = Reflect.construct(n, arguments, r);
    } else
      g = n.apply(this, arguments);
    return DZ(this, g);
  };
}
function rWe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function lW() {
}
function oWe(e) {
  var t = Object.getOwnPropertyNames(Object.getPrototypeOf(e));
  t.forEach(function(i) {
    typeof e[i] == "function" && (e[i] = e[i].bind(e));
  });
}
var $S = function(e) {
  f1(i, e);
  var t = gWe(i);
  function i() {
    var n, g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (ys(this, i), n = t.call(this), G1 && Ld.call(us(n)), n.options = a3(g), n.services = {}, n.logger = $s, n.modules = {
      external: []
    }, oWe(us(n)), r && !n.isInitialized && !g.isClone) {
      if (!n.options.initImmediate)
        return n.init(g, r), DZ(n, us(n));
      setTimeout(function() {
        n.init(g, r);
      }, 0);
    }
    return n;
  }
  return Ws(i, [{
    key: "init",
    value: function() {
      var g = this, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
      typeof r == "function" && (o = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (typeof r.ns == "string" ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
      var I = nWe();
      this.options = Ts(Ts(Ts({}, I), this.options), a3(r)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = Ts(Ts({}, I.interpolation), this.options.interpolation)), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
      function s(f) {
        return f ? typeof f == "function" ? new f() : f : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? $s.init(s(this.modules.logger), this.options) : $s.init(null, this.options);
        var a;
        this.modules.formatter ? a = this.modules.formatter : typeof Intl < "u" && (a = $ye);
        var d = new Mye(this.options);
        this.store = new Nye(this.options.resources, this.options);
        var C = this.services;
        C.logger = $s, C.resourceStore = this.store, C.languageUtils = d, C.pluralResolver = new Qye(d, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), a && (!this.options.interpolation.format || this.options.interpolation.format === I.interpolation.format) && (C.formatter = s(a), C.formatter.init(C, this.options), this.options.interpolation.format = C.formatter.format.bind(C.formatter)), C.interpolator = new jye(this.options), C.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, C.backendConnector = new iWe(s(this.modules.backend), C.resourceStore, C, this.options), C.backendConnector.on("*", function(f) {
          for (var G = arguments.length, y = new Array(G > 1 ? G - 1 : 0), W = 1; W < G; W++)
            y[W - 1] = arguments[W];
          g.emit.apply(g, [f].concat(y));
        }), this.modules.languageDetector && (C.languageDetector = s(this.modules.languageDetector), C.languageDetector.init(C, this.options.detection, this.options)), this.modules.i18nFormat && (C.i18nFormat = s(this.modules.i18nFormat), C.i18nFormat.init && C.i18nFormat.init(this)), this.translator = new g3(this.services, this.options), this.translator.on("*", function(f) {
          for (var G = arguments.length, y = new Array(G > 1 ? G - 1 : 0), W = 1; W < G; W++)
            y[W - 1] = arguments[W];
          g.emit.apply(g, [f].concat(y));
        }), this.modules.external.forEach(function(f) {
          f.init && f.init(g);
        });
      }
      if (this.format = this.options.interpolation.format, o || (o = lW), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var A = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      A.forEach(function(f) {
        g[f] = function() {
          var G;
          return (G = g.store)[f].apply(G, arguments);
        };
      });
      var m = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      m.forEach(function(f) {
        g[f] = function() {
          var G;
          return (G = g.store)[f].apply(G, arguments), g;
        };
      });
      var h = Z0(), B = function() {
        var G = function(W, V) {
          g.isInitialized && !g.initializedStoreOnce && g.logger.warn("init: i18next is already initialized. You should call init just once!"), g.isInitialized = !0, g.options.isClone || g.logger.log("initialized", g.options), g.emit("initialized", g.options), h.resolve(V), o(W, V);
        };
        if (g.languages && g.options.compatibilityAPI !== "v1" && !g.isInitialized)
          return G(null, g.t.bind(g));
        g.changeLanguage(g.options.lng, G);
      };
      return this.options.resources || !this.options.initImmediate ? B() : setTimeout(B, 0), h;
    }
  }, {
    key: "loadResources",
    value: function(g) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : lW, I = o, s = typeof g == "string" ? g : this.language;
      if (typeof g == "function" && (I = g), !this.options.resources || this.options.partialBundledLanguages) {
        if (s && s.toLowerCase() === "cimode")
          return I();
        var a = [], d = function(A) {
          if (A) {
            var m = r.services.languageUtils.toResolveHierarchy(A);
            m.forEach(function(h) {
              a.indexOf(h) < 0 && a.push(h);
            });
          }
        };
        if (s)
          d(s);
        else {
          var C = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          C.forEach(function(u) {
            return d(u);
          });
        }
        this.options.preload && this.options.preload.forEach(function(u) {
          return d(u);
        }), this.services.backendConnector.load(a, this.options.ns, function(u) {
          !u && !r.resolvedLanguage && r.language && r.setResolvedLanguage(r.language), I(u);
        });
      } else
        I(null);
    }
  }, {
    key: "reloadResources",
    value: function(g, r, o) {
      var I = Z0();
      return g || (g = this.languages), r || (r = this.options.ns), o || (o = lW), this.services.backendConnector.reload(g, r, function(s) {
        I.resolve(), o(s);
      }), I;
    }
  }, {
    key: "use",
    value: function(g) {
      if (!g)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!g.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return g.type === "backend" && (this.modules.backend = g), (g.type === "logger" || g.log && g.warn && g.error) && (this.modules.logger = g), g.type === "languageDetector" && (this.modules.languageDetector = g), g.type === "i18nFormat" && (this.modules.i18nFormat = g), g.type === "postProcessor" && Aj.addPostProcessor(g), g.type === "formatter" && (this.modules.formatter = g), g.type === "3rdParty" && this.modules.external.push(g), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(g) {
      if (!(!g || !this.languages) && !(["cimode", "dev"].indexOf(g) > -1))
        for (var r = 0; r < this.languages.length; r++) {
          var o = this.languages[r];
          if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
            this.resolvedLanguage = o;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(g, r) {
      var o = this;
      this.isLanguageChangingTo = g;
      var I = Z0();
      this.emit("languageChanging", g);
      var s = function(u) {
        o.language = u, o.languages = o.services.languageUtils.toResolveHierarchy(u), o.resolvedLanguage = void 0, o.setResolvedLanguage(u);
      }, a = function(u, A) {
        A ? (s(A), o.translator.changeLanguage(A), o.isLanguageChangingTo = void 0, o.emit("languageChanged", A), o.logger.log("languageChanged", A)) : o.isLanguageChangingTo = void 0, I.resolve(function() {
          return o.t.apply(o, arguments);
        }), r && r(u, function() {
          return o.t.apply(o, arguments);
        });
      }, d = function(u) {
        !g && !u && o.services.languageDetector && (u = []);
        var A = typeof u == "string" ? u : o.services.languageUtils.getBestMatchFromCodes(u);
        A && (o.language || s(A), o.translator.language || o.translator.changeLanguage(A), o.services.languageDetector && o.services.languageDetector.cacheUserLanguage(A)), o.loadResources(A, function(m) {
          a(m, A);
        });
      };
      return !g && this.services.languageDetector && !this.services.languageDetector.async ? d(this.services.languageDetector.detect()) : !g && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(d) : d(g), I;
    }
  }, {
    key: "getFixedT",
    value: function(g, r, o) {
      var I = this, s = function a(d, C) {
        var u;
        if (Cs(C) !== "object") {
          for (var A = arguments.length, m = new Array(A > 2 ? A - 2 : 0), h = 2; h < A; h++)
            m[h - 2] = arguments[h];
          u = I.options.overloadTranslationOptionHandler([d, C].concat(m));
        } else
          u = Ts({}, C);
        u.lng = u.lng || a.lng, u.lngs = u.lngs || a.lngs, u.ns = u.ns || a.ns, u.keyPrefix = u.keyPrefix || o || a.keyPrefix;
        var B = I.options.keySeparator || ".", f = u.keyPrefix ? "".concat(u.keyPrefix).concat(B).concat(d) : d;
        return I.t(f, u);
      };
      return typeof g == "string" ? s.lng = g : s.lngs = g, s.ns = r, s.keyPrefix = o, s;
    }
  }, {
    key: "t",
    value: function() {
      var g;
      return this.translator && (g = this.translator).translate.apply(g, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var g;
      return this.translator && (g = this.translator).exists.apply(g, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(g) {
      this.options.defaultNS = g;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(g) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var I = this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
      if (I.toLowerCase() === "cimode")
        return !0;
      var d = function(A, m) {
        var h = r.services.backendConnector.state["".concat(A, "|").concat(m)];
        return h === -1 || h === 2;
      };
      if (o.precheck) {
        var C = o.precheck(this, d);
        if (C !== void 0)
          return C;
      }
      return !!(this.hasResourceBundle(I, g) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || d(I, g) && (!s || d(a, g)));
    }
  }, {
    key: "loadNamespaces",
    value: function(g, r) {
      var o = this, I = Z0();
      return this.options.ns ? (typeof g == "string" && (g = [g]), g.forEach(function(s) {
        o.options.ns.indexOf(s) < 0 && o.options.ns.push(s);
      }), this.loadResources(function(s) {
        I.resolve(), r && r(s);
      }), I) : (r && r(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(g, r) {
      var o = Z0();
      typeof g == "string" && (g = [g]);
      var I = this.options.preload || [], s = g.filter(function(a) {
        return I.indexOf(a) < 0;
      });
      return s.length ? (this.options.preload = I.concat(s), this.loadResources(function(a) {
        o.resolve(), r && r(a);
      }), o) : (r && r(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(g) {
      if (g || (g = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !g)
        return "rtl";
      var r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      return r.indexOf(this.services.languageUtils.getLanguagePartFromCode(g)) > -1 || g.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var g = this, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : lW, I = Ts(Ts(Ts({}, this.options), r), {
        isClone: !0
      }), s = new i(I);
      (r.debug !== void 0 || r.prefix !== void 0) && (s.logger = s.logger.clone(r));
      var a = ["store", "services", "language"];
      return a.forEach(function(d) {
        s[d] = g[d];
      }), s.services = Ts({}, this.services), s.services.utils = {
        hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
      }, s.translator = new g3(s.services, s.options), s.translator.on("*", function(d) {
        for (var C = arguments.length, u = new Array(C > 1 ? C - 1 : 0), A = 1; A < C; A++)
          u[A - 1] = arguments[A];
        s.emit.apply(s, [d].concat(u));
      }), s.init(I, o), s.translator.options = s.options, s.translator.backendConnector.services.utils = {
        hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
      }, s;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), i;
}(Ld);
Gs($S, "createInstance", function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
  return new $S(e, t);
});
var rn = $S.createInstance();
rn.createInstance = $S.createInstance;
rn.createInstance;
rn.init;
rn.loadResources;
rn.reloadResources;
rn.use;
rn.changeLanguage;
rn.getFixedT;
var $r = rn.t;
rn.exists;
rn.setDefaultNamespace;
rn.hasLoadedNamespace;
rn.loadNamespaces;
rn.loadLanguages;
const IWe = "Mandant", lWe = "Produkt", sWe = "Bezahlzustand", aWe = "Mandanten", cWe = "Konfiguratoren", dWe = "Support", CWe = "Händler", uWe = "Benutzer", AWe = "Papierkorb", bWe = "Andere", mWe = "Links", hWe = "Hilfe", pWe = "Beratung", BWe = "Status", ZWe = "Abonnement", fWe = "Profil", GWe = "Abmelden", yWe = "Template", WWe = "Aufrufen", SWe = "PDF", VWe = "Code", wWe = "Preis", vWe = "Inspiration", RWe = "Aktion", XWe = "Sprache", HWe = "Kunde", kWe = "Inhalt", FWe = "Konfiguratorversion", YWe = "Abbrechen", xWe = "Schliessen", DWe = "Bearbeiten", JWe = "Adresse", KWe = "Datenschutz", EWe = "Name", NWe = "Email", LWe = "Telefon", TWe = "Bemerkung", MWe = "Firma", UWe = "Akzeptiert", PWe = "Stadt", zWe = "Postleitzahl", OWe = "Datum", QWe = "Händler", jWe = "json", _We = "Preis", $We = "Optionen", qWe = "Bestellaktion", eSe = "Typ", tSe = "Konfiguration", iSe = "AR", nSe = "Geteilt", gSe = "anzeigen", rSe = "Sortierung", oSe = "Artikelnummer", ISe = "Beschreibung", lSe = "Kategorie", sSe = "Preise", aSe = "Importieren", cSe = "Artikel", dSe = "Upload", CSe = "Keine", uSe = "Alle", ASe = "Bilder", bSe = "Rauheit", mSe = "Metallhaltigkeit", hSe = "Transparenz", pSe = "Deckkraft", BSe = "Farbe", ZSe = "Emission", fSe = "Seite", GSe = "Vorderseite", ySe = "Hinterseite", WSe = "Beidseitig", SSe = "Transmission", VSe = "Reflektivität", wSe = "Klarlack", vSe = "Optionen", RSe = "Bezeichnung", XSe = "Physikalisch basiertes Rendering (PBR)", HSe = "Physikalisch", kSe = "Key", FSe = "Model", YSe = "Erweitert", xSe = "Editieren", DSe = "Kopieren", JSe = "Export", KSe = "Allgemein", ESe = "Sprachen", NSe = "Produktdarstellung", LSe = "Upgrade", TSe = "Hauptmodell", MSe = "Vorlage", USe = "Tutorial", PSe = "Merkmale", zSe = "Abschlag", OSe = "Aufschlag", QSe = "Speichern", jSe = "Einbetten", _Se = "Referenzsprache", $Se = "Schriftart", qSe = "Helvetica", eVe = "Courier", tVe = "Interstate", iVe = "Montserrat", nVe = "Links", gVe = "Rechts", rVe = "Oben", oVe = "Unten", IVe = "Kopfzeile", lVe = "Mail", sVe = "Shop", aVe = "Senden", cVe = "Bestellungen", dVe = "Datum", CVe = "Tage", uVe = "Artikel Name", AVe = "Artikel", bVe = "Konfigurationen", mVe = "Konfigurator", hVe = "Partner", pVe = "Provision", BVe = "Erstellen", ZVe = "Name", fVe = "E-Mail", GVe = "Nutzerkonto", yVe = "Nutzername", WVe = "Kennwort", SVe = "Anmelden", VVe = "Registrierung", wVe = "Datenschutzbestimmungen", vVe = "AGB", RVe = "Passwort", XVe = "Editor", HVe = "Standard", kVe = "Version", FVe = "Buchungen", YVe = "Plattform", xVe = "Intervall", DVe = "Benutzer", JVe = "Subscription", KVe = "CustomerID", EVe = "Aktiv", NVe = "Seit", LVe = "Query", TVe = "Aktionen", MVe = "Type", UVe = "Monat", PVe = "Jahr", zVe = "Buchung", OVe = "Parameter", QVe = "Kunden", jVe = "ID", _Ve = "Rechnungen", $Ve = "Leer", qVe = "Wechseln", ewe = "Nutzer", twe = "Rolle", iwe = "Konfiguratoren", nwe = "Startdatum", gwe = "Enddatum", rwe = "Schritte", owe = "Werte", Iwe = "Regeln", lwe = "Regelzeilen", swe = "Modelle", awe = "Materialien", cwe = "Merkmal", dwe = "Regel", Cwe = "Nummer", uwe = "Status", Awe = "Erstellt", bwe = "Kennwort", mwe = "Neu", hwe = "Eingabe", pwe = "Einladen", Bwe = "Download", Zwe = "Hintergrundmodell", fwe = "Favoriten", Gwe = "Anlegen", ywe = "Preiseinstellungen", Wwe = "Hauptaktion", Swe = "Kontaktformular", Vwe = "Pflichtfeld", wwe = "Aktionsname", vwe = "Anzahl", Rwe = "Anzahlberechnung", Xwe = "Mengenberechnung", Hwe = "Artikelaktion", kwe = "Zahl", Fwe = "Einheit", Ywe = "Fokustyp", xwe = "Kamera", Dwe = "Schritt", Jwe = "Kameraansicht", Kwe = "Duplizieren", Ewe = "Entfernen", Nwe = "Auswahlen", Lwe = "Kameras", Twe = "Kostenfrei", Mwe = "Downgrade", Uwe = "Monatlich", Pwe = "Home", zwe = "Hilfe", Owe = "Abbrechen", Qwe = "Icon", jwe = "Logo", _we = "Farben", $we = "CSS", qwe = "Einstellungen", e1e = "Vorschau", t1e = "Artikel", i1e = "Bestellungen", n1e = "Statistics", g1e = "Fehler", r1e = "Leider ist ein unbekannter Fehler aufgetreten. Falls sich das Problem mit einem Neuladen der Seite nicht beheben lässt, kontaktieren Sie uns bitte.", o1e = "Unbekannter Fehler", I1e = "Fehlernachricht:", l1e = "Bestelloptionen", s1e = "Dieser Schritt ist aktuell nur im Admin-Panel sichtbar, da er keine Merkmale mit wählbaren Werten enthält.", a1e = "Basiseinstellungen", c1e = "Deckkraft", d1e = "Materialaktion", C1e = "Farbaktion", u1e = "Bildaktion", A1e = "Hinweis", b1e = "Achtung", m1e = "Fortfahren", h1e = "Versteckt", p1e = "Artikelnummer", B1e = "Name", Z1e = "Währung", f1e = "Wert", G1e = "Startanzahl", y1e = "Endanzahl", W1e = "Suchen", S1e = "Titel", V1e = "OK", w1e = "Hervorhebung", v1e = "Expression", R1e = "Ergebnis", X1e = "Mindestwert", H1e = "Maximalwert", k1e = "Unendlich", F1e = "Nachkommastellen", Y1e = "Schrittweite", x1e = "Berechnet", D1e = "Farbauswahl", J1e = "Komponentenliste", K1e = "Komponentenkarten", E1e = "Bildauswahl", N1e = "Informationen", L1e = "Zahleneingabe", T1e = "Dropdown", M1e = "Thumbnails", U1e = "Schalter", P1e = "Texteingabe", z1e = "Beispieltext", O1e = "Optional", Q1e = "Labelaktion", j1e = "Fehlermeldung", _1e = "Modelaktion", $1e = "Position", q1e = "Scale", e2e = "Modell", t2e = "Material", i2e = "Komponenten", n2e = "Druck", g2e = "Regelname", r2e = "Merkmalskombinationen", o2e = "Produktstruktur", I2e = "Materialnamen", l2e = "Komponentenmerkmale", s2e = "Herunterladen", a2e = "Verbinden", c2e = "Farbwert", d2e = "Anzeige", C2e = "RAL", u2e = "Ansicht", A2e = "URL", b2e = "Auswahlwerte", m2e = "Info", h2e = "Auswahlpreise", p2e = "Auswahl", B2e = "Gesamtpreis", Z2e = "Weiter", f2e = "Vollbildmodus", G2e = "xl", y2e = "Konfliktmeldung", W2e = "Positionszeile", S2e = "Menge", V2e = "Positionspreis", w2e = "Bild", v2e = "Text", R2e = "Information", X2e = "Mehrfachauswahl", H2e = "Liste", k2e = "Eckenrundung", F2e = "Abmessungen", Y2e = "Breite", x2e = "Tiefe", D2e = "Startpunkt", J2e = "Endpunkt", K2e = "Startanker", E2e = "Ohne", N2e = "Endanker", L2e = "Texttyp", T2e = "Zahlenwert", M2e = "Offsets", U2e = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.",
  Mandant: IWe,
  Produkt: lWe,
  Bezahlzustand: sWe,
  Mandanten: aWe,
  apps: cWe,
  support: dWe,
  "dealer-profile": "Händlerprofil",
  dealers: CWe,
  users: uWe,
  trash: AWe,
  others: bWe,
  links: mWe,
  help: hWe,
  consultation: pWe,
  status: BWe,
  subscription: ZWe,
  profile: fWe,
  logout: GWe,
  "Neuer Konfigurator": "Neuer Konfigurator",
  Template: yWe,
  Zurück: "Zurück",
  Aufrufen: WWe,
  PDF: SWe,
  Code: VWe,
  Preis: wWe,
  Inspiration: vWe,
  Aktion: RWe,
  Sprache: XWe,
  Händler: "Händler",
  "Sie möchten die Daten dieses Kunden einsehen?": "Sie möchten die Daten dieses Kunden einsehen?",
  Kunde: HWe,
  Inhalt: kWe,
  "Shop-API": "Shop-API",
  "Gespeichert am": "Gespeichert am",
  Konfiguratorversion: FWe,
  Abbrechen: YWe,
  "Ergebnis der Shop API": "Ergebnis der Shop API",
  Schliessen: xWe,
  Bearbeiten: DWe,
  Adresse: JWe,
  Datenschutz: KWe,
  Name: EWe,
  Email: NWe,
  Telefon: LWe,
  Bemerkung: TWe,
  Firma: MWe,
  "Steuer-ID": "Steuer-ID",
  Akzeptiert: UWe,
  Stadt: PWe,
  PLZ: zWe,
  Datum: OWe,
  "exit-action": "Bestellaktion",
  dealer: QWe,
  "order-status": "Status",
  json: jWe,
  price: _We,
  options: $We,
  Bestellaktion: qWe,
  Typ: eSe,
  Konfiguration: tSe,
  AR: iSe,
  Geteilt: nSe,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Sie möchten die Daten Ihrer Kunden einsehen?",
  "Preise anlegen": "Preise anlegen",
  anzeigen: gSe,
  "Artikel und Preise erfolgreich importiert.": "Artikel und Preise erfolgreich importiert.",
  Sortierung: rSe,
  Artikelnummer: oSe,
  "Artikelnummer eingeben": "Artikelnummer eingeben",
  "Namen eingeben": "Namen eingeben",
  Beschreibung: ISe,
  "Beschreibung eingeben": "Beschreibung eingeben",
  Kategorie: lSe,
  "Kategorien eingeben": "Kategorien eingeben",
  Preise: sSe,
  "Sortierung erfolgreich angewendet.": "Sortierung erfolgreich angewendet.",
  "Fehler beim Anwenden der Sortierung: ": "Fehler beim Anwenden der Sortierung: ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Artikel und Preise erfolgreich veröffentlicht.",
  "Fehler beim Veröffentlichen: ": "Fehler beim Veröffentlichen: ",
  "Sie möchten Preise anzeigen?": "Sie möchten Preise anzeigen?",
  Importieren: aSe,
  "Neuer Artikel": "Neuer Artikel",
  Löschen: "Löschen",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.",
  "Artikel und Preise veröffentlichen": "Artikel und Preise veröffentlichen",
  Artikel: cSe,
  Upload: dSe,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.",
  "Ordner *": "Ordner *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': 'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".',
  Keine: CSe,
  Alle: uSe,
  Bilder: ASe,
  Roughness: bSe,
  Metalness: mSe,
  Transparent: hSe,
  Opacity: pSe,
  Farbe: BSe,
  Emissive: ZSe,
  "Color Map": "Farbtextur",
  "Normal Map": "Normalentextur",
  "Roughness Map": "Rauheitstextur",
  "Metalness Map": "Metallhaltigkeitstextur",
  "Alpha Map": "Transparenztextur",
  Seite: fSe,
  Vorderseite: GSe,
  Hinterseite: ySe,
  Beidseitig: WSe,
  "Texture repeat": "Texturwiederholung",
  "Depth Write": "Schreibe in den Tiefenpuffer",
  Transmission: SSe,
  Reflectivity: VSe,
  ClearCoat: wSe,
  "Clearcoat Roughness": "Rauheit des Klarlacks",
  "new-material": "Neues Material",
  Optionen: vSe,
  Bezeichnung: RSe,
  Pbr: XSe,
  Physikalisch: HSe,
  Key: kSe,
  "AR Fallback Material": "AR Fallback Material",
  "Nicht ausgewählt": "Nicht ausgewählt",
  Model: FSe,
  Erweitert: YSe,
  "Nur in Regeln verwendete Materialien anzeigen": "Nur in Regeln verwendete Materialien anzeigen",
  "extract-materials": "Materialien aus Modell extrahieren",
  Editieren: xSe,
  Kopieren: DSe,
  "Neues Modell": "Neues Modell",
  "Dynamisches Modell": "Dynamisches Modell",
  Gültigkeit: "Gültigkeit",
  "Neue Regel": "Neue Regel",
  "Neue Regel Erstellen": "Neue Regel Erstellen",
  "Regel erstellen": "Regel erstellen",
  "Erfolgreich importiert": "Erfolgreich importiert",
  "Hier importieren Sie eine vorab exportierte Datei.": "Hier importieren Sie eine vorab exportierte Datei.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "Dadurch werden alle Daten dieses Konfigurators ersetzt.",
  "Auch der Papierkorb wird gelöscht.": "Auch der Papierkorb wird gelöscht.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "Diese Operation kann nicht rückgängig gemacht werden.",
  "Sind Sie sicher?": "Sind Sie sicher?",
  "JSON Export Datei": "JSON Export Datei",
  Export: JSe,
  "app-code-duplicate": "App Code wird schon benutzt",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.",
  Allgemein: KSe,
  Sprachen: ESe,
  "Die erste Sprache gilt als Standard.": "Die erste Sprache gilt als Standard.",
  "Die Beschreibung dieses Konfigurators": "Die Beschreibung dieses Konfigurators",
  "Link zum Konfigurator": "Link zum Konfigurator",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.",
  Produktdarstellung: NSe,
  "3D-Modell": "3D-Modell",
  "Bilder-Konfigurator": "Bilder-Konfigurator",
  "Google Analytics 4 Property ID": "Google Analytics 4 Property ID",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Sie möchten Ihr Analytics-Konto verbinden?",
  Upgrade: LSe,
  Hauptmodell: TSe,
  "Hauptmodell entfernen": "Hauptmodell entfernen",
  Vorlage: MSe,
  "Dieser Konfigurator dient als Vorlage": "Dieser Konfigurator dient als Vorlage",
  Tutorial: USe,
  "Standard übernehmen": "Standard übernehmen",
  "screenshot-quality": "Screenshot Qualität",
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).",
  "Preis & Info Service": "Preis & Info Service",
  "Hilfe dazu finden Sie hier.": "Hilfe dazu finden Sie hier.",
  "URL für den Service, der die Daten verarbeitet": "URL für den Service, der die Daten verarbeitet",
  "Debounce in ms": "Debounce in ms",
  Merkmale: PSe,
  "Merkmale und ihre aktuelle Auswahlen senden": "Merkmale und ihre aktuelle Auswahlen senden",
  "Optionale Merkmalbeschränkung": "Optionale Merkmalbeschränkung",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "Beschränken Sie optional die Merkmale, die gesendet werden.",
  "Artikel & Preis": "Artikel & Preis",
  "Aktuell ausgewählte Artikel senden": "Aktuell ausgewählte Artikel senden",
  "Aktuellen Preis senden": "Aktuellen Preis senden",
  "to dealer app": "Zur Händler-App",
  "Händler hat Zugriff": "Händler hat Zugriff",
  "Händler hat keinen Zugriff": "Händler hat keinen Zugriff",
  "dealer query": "Voreinstellungen",
  "Händler legt Aufschlag fest": "Händler legt Aufschlag fest",
  discount: zSe,
  surcharge: OSe,
  "Sie stornieren nun eine Händlerlizenz.": "Sie stornieren nun eine Händlerlizenz.",
  "Händlerzugriff beenden": "Händlerzugriff beenden",
  "Sie buchen nun eine Händlerlizenz.": "Sie buchen nun eine Händlerlizenz.",
  "Händlerzugriff buchen": "Händlerzugriff buchen",
  Speichern: QSe,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Ihre Händler sollen Ihren Konfigurator nutzen können?",
  "Keine Händler vorhanden": "Keine Händler vorhanden",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.",
  "Jetzt Händler anlegen": "Jetzt Händler anlegen",
  Einbetten: jSe,
  "Als Link": "Als Link",
  "Als IFrame": "Als IFrame",
  "Meldungen beim Laden anpassen": "Meldungen beim Laden anpassen",
  "Bitte Auth0 Zugangsdaten angeben": "Bitte Auth0 Zugangsdaten angeben",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.",
  "Konfigurator-Zugang": "Konfigurator-Zugang",
  "Anmeldung für Konfigurator verlangen.": "Anmeldung für Konfigurator verlangen.",
  "Auth0 Domain": "Auth0 Domain",
  "Auth0 ClientId": "Auth0 ClientId",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.",
  "Importiere XLSX": "Importiere XLSX",
  "Exportiere XLSX": "Exportiere XLSX",
  Referenzsprache: _Se,
  "Werden berücksichtigt:": "Werden berücksichtigt:",
  "Versteckte Merkmale": "Versteckte Merkmale",
  "Unbenutzte Sprachen": "Unbenutzte Sprachen",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?",
  "Mail Texte": "Mail Texte",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.",
  Schriftart: $Se,
  Helvetica: qSe,
  "Times Roman": "Times Roman",
  Courier: eVe,
  Interstate: tVe,
  Montserrat: iVe,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Bold",
  Schriftgröße: "Schriftgröße",
  Links: nVe,
  Rechts: gVe,
  Oben: rVe,
  Unten: oVe,
  Kopfzeile: IVe,
  Fußzeile: "Fußzeile",
  "Neue PDF Vorlage auswählen": "Neue PDF Vorlage auswählen",
  "Vorhandene PDF Vorlage löschen": "Vorhandene PDF Vorlage löschen",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Sie möchten Bestätigungen oder Angebote als PDF senden?",
  "PDF Einstellungen": "PDF Einstellungen",
  Seitenränder: "Seitenränder",
  "Voransicht mit dieser Konfiguration:": "Voransicht mit dieser Konfiguration:",
  "und diesem Template:": "und diesem Template:",
  "Speichern und drucken": "Speichern und drucken",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.",
  Mail: lVe,
  Shop: sVe,
  "Social Sharing": "Social Sharing",
  "Wir helfen gern!": "Wir helfen gern!",
  "Ihre Telefonnummer": "Ihre Telefonnummer",
  "Ihre Nachricht": "Ihre Nachricht",
  Senden: aVe,
  "Nachricht senden": "Nachricht senden",
  "Rückruf erbitten": "Rückruf erbitten",
  orders: cVe,
  date: dVe,
  "Preise wurden in den Einstellungen deaktiviert": "Preise wurden in den Einstellungen deaktiviert",
  "Keine Einnahmen vorliegend": "Keine Einnahmen vorliegend",
  "total-earnings": "Gesamteinnahmen",
  Tage: CVe,
  articlename: uVe,
  articles: AVe,
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.',
  "Leerer Konfigurator": "Leerer Konfigurator",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.",
  "Konfigurator importieren": "Konfigurator importieren",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importieren sie einen Konfigurator anhand einer exportierten Datei.",
  Veröffentlicht: "Veröffentlicht",
  Konfigurationen: bVe,
  "Mandant hat noch keinen Konfigurator": "Mandant hat noch keinen Konfigurator",
  Konfigurator: mVe,
  "Link kopiert": "Link kopiert",
  "E-Mail": "E-Mail",
  "Werben Sie K3 Kunden!": "Werben Sie K3 Kunden!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.",
  Partner: hVe,
  Provision: pVe,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.",
  "Meine Kunden": "Meine Kunden",
  "Vielen Dank für Ihre Bestätigung...": "Vielen Dank für Ihre Bestätigung...",
  "E-Mail Bestätigung": "E-Mail Bestätigung",
  "Zur Anmeldung": "Zur Anmeldung",
  Händlerprofil: "Händlerprofil",
  Erstellen: BVe,
  name: ZVe,
  email: fVe,
  "E-Mail ist ungültig!": "E-Mail ist ungültig!",
  Nutzerkonto: GVe,
  Nutzername: yVe,
  "Mail ist schon vergeben": "Mail ist schon vergeben",
  "code-duplicate": "Dieser Code ist schon vergeben",
  "dealer code helper text": "Zum Aufrufen des Händler-Konfigurators.",
  "default discount": "Standard-Abschlag",
  "Kann pro Konfigurator überschrieben werden.": "Kann pro Konfigurator überschrieben werden.",
  "default surcharge": "Standard-Aufschlag",
  "Pro Abo": "Pro Abo",
  "is pro dealer": "Darf den Konfigurator auf seiner eigenen Webseite einsetzen und das Design anpassen",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ",
  "Fehlendes Produkt": "Fehlendes Produkt",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Bitte buchen Sie dort zunächst ein anderes Produkt.",
  "new dealer": "Neuer Händler",
  "Login screen": "Anmeldung",
  "Bitte am Desktop öffnen": "Bitte am Desktop öffnen",
  Password: WVe,
  Login: SVe,
  "Passwort vergessen?": "Passwort vergessen?",
  "Noch kein Konto?": "Noch kein Konto?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.",
  "Mail senden": "Mail senden",
  Registrierung: VVe,
  "Ihre E-Mail-Adresse": "Ihre E-Mail-Adresse",
  "Bitte wählen Sie ein Kennwort": "Bitte wählen Sie ein Kennwort",
  "Bitte bestätigen Sie unsere ": "Bitte bestätigen Sie unsere ",
  Datenschutzbestimmungen: wVe,
  " und unsere ": " und unsere ",
  AGB: vVe,
  "Jetzt registrieren": "Jetzt registrieren",
  "Die Registrierung war leider nicht möglich.": "Die Registrierung war leider nicht möglich.",
  "Herzlich willkommen!": "Herzlich willkommen!",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:",
  "Wir haben Ihr Kennwort neu gesetzt.": "Wir haben Ihr Kennwort neu gesetzt.",
  "Passwort setzen": "Passwort setzen",
  Passwort: RVe,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen",
  Bestätigung: "Bestätigung",
  "Bestätigung stimmt nicht überein": "Bestätigung stimmt nicht überein",
  "Kennwort setzen": "Kennwort setzen",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - der 3D-Produktkonfigurator für Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:",
  "Registrieren Sie sich am K3.": "Registrieren Sie sich am K3.",
  "Legen Sie einen Konfigurator an.": "Legen Sie einen Konfigurator an.",
  "Jetzt starten": "Jetzt starten",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Gestalten Sie den Konfigurator für Ihr Produkt.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Fügen Sie den Konfigurator in Ihren Shop ein.",
  Editor: XVe,
  "Mandant: ": "Mandant: ",
  "Erstellt am: ": "Erstellt am: ",
  "Veröffentlicht am: ": "Veröffentlicht am: ",
  "Noch nicht veröffentlicht": "Noch nicht veröffentlicht",
  "Version: ": "Version: ",
  "Artikel-Version: ": "Artikel-Version: ",
  "Code: ": "Code: ",
  "Typ: ": "Typ: ",
  Standard: HVe,
  "Shop: ": "Shop: ",
  "Nicht verbunden": "Nicht verbunden",
  "Bestellungen insgesamt": "Bestellungen insgesamt",
  Veröffentlichungen: "Veröffentlichungen",
  Version: kVe,
  "Artikel-Version": "Artikel-Version",
  Buchungen: FVe,
  Plattform: YVe,
  Intervall: xVe,
  Benutzer: DVe,
  Subscription: JVe,
  CustomerID: KVe,
  Aktiv: EVe,
  Seit: NVe,
  "Abschlag [%]": "Abschlag [%]",
  "Aufschlag [%]": "Aufschlag [%]",
  Query: LVe,
  Aktionen: TVe,
  "Mandanten wechseln": "Mandanten wechseln",
  "Konnte nicht gespeichert werden: ": "Konnte nicht gespeichert werden: ",
  Type: MVe,
  "Angelegt am": "Angelegt am",
  "Zum AdminPanel": "Zum AdminPanel",
  "App editieren": "App editieren",
  Monat: UVe,
  Jahr: PVe,
  Buchung: zVe,
  "Stripe Subscription": "Stripe Subscription",
  "Bezahlt?": "Bezahlt?",
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.",
  "Einstiegs-Produkt": "Einstiegs-Produkt",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "Stripe ID",
  Parameter: OVe,
  "Partner?": "Partner?",
  Kunden: QVe,
  ID: jVe,
  Rechnungen: _Ve,
  Leer: $Ve,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?",
  Wechseln: qVe,
  "Mandant unwiderruflich löschen": "Mandant unwiderruflich löschen",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:",
  Nutzer: ewe,
  "Mandant erfolgreich gelöscht": "Mandant erfolgreich gelöscht",
  "Mandanten editieren": "Mandanten editieren",
  Rolle: twe,
  Konfiguratoren: iwe,
  Händleraktivierungen: "Händleraktivierungen",
  Startdatum: nwe,
  Enddatum: gwe,
  Schritte: rwe,
  Werte: owe,
  Regeln: Iwe,
  Regelzeilen: lwe,
  Modelle: swe,
  Materialien: awe,
  Gelöscht: "Gelöscht",
  Merkmal: cwe,
  Regel: dwe,
  Nummer: Cwe,
  Status: uwe,
  Erstellt: Awe,
  Zurücklegen: "Zurücklegen",
  Mindestlänge: "Mindestlänge {{chars}} Zeichen",
  "Email Adresse ist ungültig": "Email Adresse ist ungültig",
  Kennwort: bwe,
  "Test stimmt nicht überein": "Test stimmt nicht überein",
  "Telefonnummer ist ungültig": "Telefonnummer ist ungültig",
  "Entwickler Modus": "Entwickler Modus",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.",
  "API Token": "API Token",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.",
  "Sie können das Token im Shop-Plugin eintragen.": "Sie können das Token im Shop-Plugin eintragen.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.",
  Neu: mwe,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.",
  "Sie möchten über die API auf den K3 zugreifen?": "Sie möchten über die API auf den K3 zugreifen?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.",
  "Neuen Nutzer anlegen": "Neuen Nutzer anlegen",
  Eingabe: hwe,
  "E-Mail nicht valide!": "E-Mail nicht valide!",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.",
  "Nutzer einladen": "Nutzer einladen",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "Der Nutzer erhält Zugang zu Ihrem Mandanten.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Bitte überprüfen Sie die von Ihnen gemachten Angaben:",
  Einladen: pwe,
  "Benutzer einladen": "Benutzer einladen",
  "new user": "Neuer Benutzer",
  "CSS-Datei auswählen": "CSS-Datei auswählen",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.",
  "3D-Modell auswählen": "3D-Modell auswählen",
  Download: Bwe,
  Hintergrundmodell: Zwe,
  "material-upload": "material-upload",
  Favoriten: fwe,
  "main-model": "Hauptmodell",
  "Wirft Schatten": "Wirft Schatten",
  "Wird schattiert": "Wird schattiert",
  "Bilder Galerie": "Bilder Galerie",
  Anlegen: Gwe,
  "Neue Aktion": "Neue Aktion",
  Preiseinstellungen: ywe,
  "Preise im Konfigurator ausblenden?": "Preise im Konfigurator ausblenden?",
  Hauptaktion: Wwe,
  Kontaktformular: Swe,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.",
  Pflichtfeld: Vwe,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.',
  Aktionsname: wwe,
  "Shop verbinden": "Shop verbinden",
  "Überschrift Bestätigung": "Überschrift Bestätigung",
  "Text Bestätigung": "Text Bestätigung",
  "Link zur Konfiguration zeigen?": "Link zur Konfiguration zeigen?",
  "Thumbnail des Konfigurators": "Thumbnail des Konfigurators",
  "Artikel hat keinen Namen und keine Nummer!": "Artikel hat keinen Namen und keine Nummer!",
  "Kein Artikel ausgewählt!": "Kein Artikel ausgewählt!",
  "Artikel auswählen": "Artikel auswählen",
  "Artikelanzahl und Menge": "Artikelanzahl und Menge",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "Wie oft der entsprechende Artikel hinzugefügt werden soll",
  Anzahl: vwe,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens",
  "Menge (optional)": "Menge (optional)",
  Anzahlberechnung: Rwe,
  Mengenberechnung: Xwe,
  Artikelaktion: Hwe,
  "Wert eingeben": "Wert eingeben",
  "Neue Spalte": "Neue Spalte",
  "Wert-Eigenschaft": "Wert-Eigenschaft",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.",
  "Eigenschaft wird dem Nutzer angezeigt": "Eigenschaft wird dem Nutzer angezeigt",
  "mehrsprachiger Text": "mehrsprachiger Text",
  "nicht übersetzter Text": "nicht übersetzter Text",
  Zahl: kwe,
  Einheit: Fwe,
  "Fokus auf Modelle": "Fokus auf Modelle",
  "Alle Modelle": "Alle Modelle",
  "Fokus über Objektnamen": "Fokus über Objektnamen",
  Fokustyp: Ywe,
  "Dynamischer Fokus": "Dynamischer Fokus",
  "Statischer Fokus": "Statischer Fokus",
  "Screenshot Auflösung": "Screenshot Auflösung",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Notwendiger Unterschied zur aktuellen Ansicht",
  "Aktuelle Ansicht übernehmen und Speichern": "Aktuelle Ansicht übernehmen und Speichern",
  "Kamera bearbeiten": "Kamera bearbeiten",
  "Noch keine Kamera gespeichert": "Noch keine Kamera gespeichert",
  Kamera: xwe,
  Schritt: Dwe,
  Kameraansicht: Jwe,
  "Kamera speichern": "Kamera speichern",
  "Bitte auswählen": "Bitte auswählen",
  Ausgewählt: "Ausgewählt",
  "Merkmal setzen: ": "Merkmal setzen: ",
  "Keine Farbe ausgewählt!": "Keine Farbe ausgewählt!",
  "Farbe auswählen": "Farbe auswählen",
  "Farbmerkmal auswählen:": "Farbmerkmal auswählen:",
  "Keine Auswahl": "Keine Auswahl",
  "Hoch schieben": "Hoch schieben",
  "Runter schieben": "Runter schieben",
  Duplizieren: Kwe,
  "Löschen des aktiven Elements nicht möglich": "Löschen des aktiven Elements nicht möglich",
  "Komponente hinzufügen": "Komponente hinzufügen",
  Entfernen: Ewe,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Ihre Konfiguration konnte nicht gespeichert werden.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.",
  "technische Information:": "technische Information:",
  Auswahlen: Nwe,
  "Preis: ": "Preis: ",
  "Kameras für Bestellungsbilder": "Kameras für Bestellungsbilder",
  Kameras: Lwe,
  "Anfrage erhalten": "Anfrage erhalten",
  "Buchung erfolgreich": "Buchung erfolgreich",
  "Für das neue Produkt melden wir uns bei Ihnen.": "Für das neue Produkt melden wir uns bei Ihnen.",
  "Ihre Subskription wurde angepasst.": "Ihre Subskription wurde angepasst.",
  "Ihre Subskription wurde beendet.": "Ihre Subskription wurde beendet.",
  "Das Produkt wurde gebucht.": "Das Produkt wurde gebucht.",
  "Meine Rechnungen": "Meine Rechnungen",
  "Auf Anfrage": "Auf Anfrage",
  Kostenfrei: Twe,
  "{{fee}},- EUR pro {{interval}}": "{{fee}},- EUR pro {{interval}}",
  "Derzeit gebucht.": "Derzeit gebucht.",
  "Änderung Ihrer Buchung": "Änderung Ihrer Buchung",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?",
  Downgrade: Mwe,
  "Zahlungsplan ändern": "Zahlungsplan ändern",
  "Ihre K3 Buchung": "Ihre K3 Buchung",
  Monatlich: Uwe,
  Jährlich: "Jährlich",
  "In neuem Tab öffnen": "In neuem Tab öffnen",
  "Konfigurator anpassen": "Konfigurator anpassen",
  "main drawer": "Sie sehen eine Vorschau Ihres Konfigurators, die Sie wie üblich bedienen können. Klicken Sie auf ein Stift-Symbol, um etwas zu ändern oder:",
  "Ändern Sie die Bestelloptionen": "Ändern Sie die Bestelloptionen",
  "Ändern Sie das Design": "Ändern Sie das Design",
  "Passen sie die 3D Szene an": "Passen sie die 3D Szene an",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Speichern Sie die aktuelle Kamera für Bestellungsbilder",
  "Merkmale verwalten": "Merkmale verwalten",
  "Nutzen Sie die Hilfe": "Nutzen Sie die Hilfe",
  "So richten Sie Ihren Konfigurator ein:": "So richten Sie Ihren Konfigurator ein:",
  Home: Pwe,
  Hilfe: zwe,
  "dealer sidebar": "Hier können sie ihren Händler Konfigurator einstellen",
  "change design": "Ändern Sie das Design",
  "change logo": "Ändern Sie das Logo",
  "change price": "Ändern Sie den Preis",
  "change pdf": "Ändern Sie die PDF Vorlage",
  "PDF Gestaltung": "PDF Gestaltung",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Laden Sie ein PDF als Vorlage für den Druck hoch.",
  cancel: Owe,
  "app surcharge": "Aufschlag festlegen",
  "you can change your surcharge here": "Hier können Sie Ihren Aufpreis ändern",
  "Neuer Schritt": "Neuer Schritt",
  Icon: Qwe,
  "Icon Bilddatei": "Icon Bilddatei",
  "Icon position": "Icon position",
  "Icon Größe": "Icon Größe",
  "Ersetze Weiter mit Aktionsauswahl": "Ersetze Weiter mit Aktionsauswahl",
  "Aktionsnamen überschreiben": "Aktionsnamen überschreiben",
  "Individuelles Design": "Individuelles Design in einem Schritt",
  "Merkmale editieren": "Merkmale editieren",
  "Keine Ergebnisse": "Keine Ergebnisse",
  "Desktop Layout": "Desktop Layout",
  "Mobile Layout": "Mobile Layout",
  "Schritte nacheinander einblenden": "Schritte nacheinander einblenden",
  "Besuchte Schritte abhaken": "Besuchte Schritte abhaken",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.",
  "Dieses Layout selbst anpassen": "Dieses Layout selbst anpassen",
  "Eigenes Layout erstellen": "Eigenes Layout erstellen",
  "Angepasstes Layout anwenden": "Angepasstes Layout anwenden",
  Schließen: "Schließen",
  Logo: jwe,
  "Konfigurator-Abschluss": "Konfigurator-Abschluss",
  "3D Szene": "3D Szene",
  "Manuelle Einstellung erstellen": "Manuelle Einstellung erstellen",
  "Design & Theme": "Design & Theme",
  Farben: _we,
  "Farbanpassungen zurücksetzten": "Farbanpassungen zurücksetzten",
  CSS: $we,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:",
  "Link zur CSS-Datei": "Link zur CSS-Datei",
  "Oder laden Sie eine CSS Datei hoch:": "Oder laden Sie eine CSS Datei hoch:",
  "Neues Merkmal": "Neues Merkmal",
  "Merkmal kopieren": "Merkmal kopieren",
  Zurücksetzen: "Zurücksetzen",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "Sie setzen den Konfigurator auf die gewählte Version zurück.",
  Einstellungen: qwe,
  "Dynamische Texte": "Dynamische Texte",
  "Texte und Einstellungen anpassen": "Texte und Einstellungen anpassen",
  Vorschau: e1e,
  Articles: t1e,
  Bestellungen: i1e,
  Statistics: n1e,
  "Inhalte: ": "Inhalte: ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': 'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.',
  "Live Version": "Live Version",
  Veröffentlichen: "Veröffentlichen",
  "Erstelle Option: ": "Erstelle Option: ",
  Fehler: g1e,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "Beim Rendern des Inhalts ist ein Fehler aufgetreten.",
  Fatal_Error_Text: r1e,
  Fatal_Error: o1e,
  "Fehlermeldung:": "Fehlermeldung:",
  "Zur Startseite": "Zur Startseite",
  "Neu Laden": "Neu Laden",
  "Cleanup und Neu Laden": "Cleanup und Neu Laden",
  "You may need to reload the page": "Neu laden der Seite könnte notwendig sein",
  Error_Message: I1e,
  "(SU) Client wechseln": "(SU) Client wechseln",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?",
  "Elemente löschen": "Elemente löschen",
  "Element löschen": "Element löschen",
  "Selektierte Elemente löschen": "Selektierte Elemente löschen",
  "Alle selektierte Elemente löschen": "Alle selektierte Elemente löschen",
  "Lösch-Konflikte anzeigen": "Lösch-Konflikte anzeigen",
  "Das Element": "Das Element",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Möchten Sie dieses Element wirklich unwiderruflich löschen?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "Die folgenden Gründe sprechen gegen eine Löschung:",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Einige Elemente werden noch an anderen Stellen verwendet:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} wird noch an anderen Stellen verwendet:",
  "{{label}} wird noch verwendet in ": "{{label}} wird noch verwendet in ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.",
  "der Definition der Regel": "der Definition der Regel",
  "einem Eintrag in Regel": "einem Eintrag in Regel",
  "einer berechneten Eigenschaft des Modells": "einer berechneten Eigenschaft des Modells",
  "der Formel von": "der Formel von",
  "der Kamera": "der Kamera",
  "des Merkmals": "des Merkmals",
  "des Schrittes": "des Schrittes",
  "der globalen Kamera": "der globalen Kamera",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Löschen Sie bitte zunächst die anderen Referenzen.",
  "Neuen Schritt hinzufügen": "Neuen Schritt hinzufügen",
  "Bitte legen Sie einen Schritt an!": "Bitte legen Sie einen Schritt an!",
  "Schritt editieren": "Schritt editieren",
  Bestelloptionen: l1e,
  "Merkmal editieren": "Merkmal editieren",
  "Mehr Informationen anzeigen": "Mehr Informationen anzeigen",
  "Nicht Aktiv": "Nicht Aktiv",
  "Keine Angabe": "Keine Angabe",
  "Fokus:": "Fokus:",
  "Fokus: ": "Fokus: ",
  hiddenGroup: s1e,
  "Label eingeben": "Label eingeben",
  "Bilder auswählen": "Bilder auswählen",
  "Ordner auswählen:": "Ordner auswählen:",
  "Bildmerkmal: ": "Bildmerkmal: ",
  "Kein Bild ausgewählt": "Kein Bild ausgewählt",
  "Bild auswählen": "Bild auswählen",
  "Bildmerkmal auswählen:": "Bildmerkmal auswählen:",
  Befüllt: "Befüllt",
  "Zustand auswählen": "Zustand auswählen",
  "Kein Komponente ausgewählt!": "Kein Komponente ausgewählt!",
  "Komponente auswählen": "Komponente auswählen",
  "Intervall eingeben": "Intervall eingeben",
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen": "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen",
  "Zum Dashboard": "Zum Dashboard",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)",
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)",
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)",
  "Setzt die Farbe der Info-Icons": "Setzt die Farbe der Info-Icons",
  "Setzt die Farbe der Warnhinweise": "Setzt die Farbe der Warnhinweise",
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Setzt die Farbe für Fehlermeldungen und -hinweise",
  Basiseinstellungen: a1e,
  "Helles Theme": "Helles Theme",
  "Erweiterte Einstellungen": "Erweiterte Einstellungen",
  "Label hinzufügen: ": "Label hinzufügen: ",
  "Kein Label ausgewählt!": "Kein Label ausgewählt!",
  "Was soll angezeigt werden?": "Was soll angezeigt werden?",
  Maximalgröße: "Maximalgröße",
  Deckkraft: c1e,
  "Kein Material ausgewählt!": "Kein Material ausgewählt!",
  "Material auswählen": "Material auswählen",
  "Material auswählen:": "Material auswählen:",
  Materialaktion: d1e,
  Farbaktion: C1e,
  Bildaktion: u1e,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Beschränkung der Auswirkungen auf bestimmte Modelle",
  Hinzufügen: "Hinzufügen",
  "Welches Teil soll hinzugefügt werden?": "Welches Teil soll hinzugefügt werden?",
  Hinweis: A1e,
  Achtung: b1e,
  Fortfahren: m1e,
  "Kein Modell ausgewählt!": "Kein Modell ausgewählt!",
  "Modell auswählen": "Modell auswählen",
  "Modell hinzufügen:": "Modell hinzufügen:",
  "Globale Änderung": "Globale Änderung",
  Oberflächen: "Oberflächen",
  "Ausgewählte Oberflächen": "Ausgewählte Oberflächen",
  "Eintrag darf nicht leer sein.": "Eintrag darf nicht leer sein.",
  "Alle Werte": "Alle Werte",
  "Werte auswählen": "Werte auswählen",
  "Sortierung anwenden": "Sortierung anwenden",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.",
  "Erlaubte Formate:": "Erlaubte Formate:",
  "Keine Datei gewählt.": "Keine Datei gewählt.",
  "Datei konnte nicht hochgeladen werden.": "Datei konnte nicht hochgeladen werden.",
  "Dieses Merkmal ist nicht erlaubt.": "Dieses Merkmal ist nicht erlaubt.",
  "Merkmal-Optionen": "Merkmal-Optionen",
  "Merkmal Beschreibung editieren": "Beschreibung editieren",
  "Merkmal-Info editieren": "Info editieren",
  Versteckt: h1e,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.",
  "showSelection.label": "showSelection.label",
  "Aus Schritt verstecken": "Aus Schritt verstecken",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.",
  "Kamera-Optionen": "Kamera-Optionen",
  "Vorlage wählen": "Vorlage wählen",
  "Konfigurator erstellen": "Konfigurator erstellen",
  "Willkommen in Ihrem neuen K3 Konto!": "Willkommen in Ihrem neuen K3 Konto!",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Richten Sie gleich Ihren ersten Konfigurator ein:",
  "Sie können alle Daten natürlich später noch ändern.": "Sie können alle Daten natürlich später noch ändern.",
  "Nicht veröffentlicht": "Nicht veröffentlicht",
  "Ladevorgang fehlgeschlagen": "Ladevorgang fehlgeschlagen",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!",
  "Keine Optionen": "Keine Optionen",
  "Neuen Artikel anlegen": "Neuen Artikel anlegen",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Hier können sie einen neuen Artikel mit Preis anlegen.",
  articleNo: p1e,
  articleName: B1e,
  currency: Z1e,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Positionen ändern",
  "Abbrechen durch Klick": "Abbrechen durch Klick",
  Wert: f1e,
  "Preis eingeben": "Preis eingeben",
  Währung: "Währung",
  "Währung eingeben": "Währung eingeben",
  "Einheit eingeben": "Einheit eingeben",
  "Startdatum eingeben": "Startdatum eingeben",
  "Enddatum eingeben": "Enddatum eingeben",
  Startanzahl: G1e,
  "Startanzahl eingeben": "Startanzahl eingeben",
  Endanzahl: y1e,
  "Endanzahl eingeben": "Endanzahl eingeben",
  Priorität: "Priorität",
  "Priorität eingeben": "Priorität eingeben",
  "Aufschlag?": "Aufschlag?",
  "Preistyp eingeben": "Preistyp eingeben",
  "Neuer Preis": "Neuer Preis",
  Suchen: W1e,
  Auswählen: "Auswählen",
  "Wählen Sie eine Vorlage aus:": "Wählen Sie eine Vorlage aus:",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Sollen wir Ihren Konfigurator jetzt anlegen?",
  "Wir bringen Sie danach direkt in den Editor.": "Wir bringen Sie danach direkt in den Editor.",
  "Anlegen & zum Konfigurator": "Anlegen & zum Konfigurator",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: S1e,
  OK: V1e,
  "Farbenanzahl im Fenster": "Farbenanzahl im Fenster",
  "Farbkachel Rundung": "Farbkachel Rundung",
  Opazität: "Opazität",
  Hervorhebung: w1e,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Ungültig gewordene Instanzen entfernen (statt ersetzen)",
  "Drag & Drop erlauben": "Drag & Drop erlauben",
  "Anzeige der Sortierungsschaltflächen": "Anzeige der Sortierungsschaltflächen",
  "Sortierung umkehren": "Sortierung umkehren",
  "Duplizierung erlauben": "Duplizierung erlauben",
  "Zeige Werte aus inneren Merkmalen an": "Zeige Werte aus inneren Merkmalen an",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt",
  "Innere Merkmalsnamen ausblenden": "Innere Merkmalsnamen ausblenden",
  "Als Warenkorb setzen?": "Als Warenkorb setzen?",
  "Gruppieren nach": "Gruppieren nach",
  "Komponenten direkt unter der Liste anzeigen": "Komponenten direkt unter der Liste anzeigen",
  Expression: v1e,
  "Erfolgreich gespeichert": "Erfolgreich gespeichert",
  "Formel Editor": "Formel Editor",
  "Geben Sie Formeln von Merkmalen ein.": "Geben Sie Formeln von Merkmalen ein.",
  " Schreiben Sie z.B. Länge * Breite.": " Schreiben Sie z.B. Länge * Breite.",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.",
  Ergebnis: R1e,
  "Keine Formel eingegeben": "Keine Formel eingegeben",
  "Formel: ": "Formel: ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.",
  "Ergebnis: ": "Ergebnis: ",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "Ausblenden der originalen Textur, wenn bedruckt wird?",
  "Erlaube Bildformate": "Erlaube Bildformate",
  "Minimum Horizontale Positionierung": "Minimum Horizontale Positionierung",
  "Maximum Horizontale Positionierung": "Maximum Horizontale Positionierung",
  "Minimum Vertikale Positionierung": "Minimum Vertikale Positionierung",
  "Maximum Vertikale Positionierung": "Maximum Vertikale Positionierung",
  "Minimale Skalierung": "Minimale Skalierung",
  "Maximale Skalierung": "Maximale Skalierung",
  Mindestwert: X1e,
  "-Unendlich": "-Unendlich",
  Maximalwert: H1e,
  Unendlich: k1e,
  "Optionaler Standardwert": "Optionaler Standardwert",
  Nachkommastellen: F1e,
  Schrittweite: Y1e,
  "Zeige Knöpfe an": "Zeige Knöpfe an",
  "Benutze Vielfaches der Schrittweite": "Benutze Vielfaches der Schrittweite",
  Berechnet: x1e,
  "Zyklus Erkennung deaktivieren": "Zyklus Erkennung deaktivieren",
  Ändern: "Ändern",
  "Beispielhafte Beschreibung eines Wertes.": "Beispielhafte Beschreibung eines Wertes.",
  "Dies ist nur eine Info": "Dies ist nur eine Info",
  "Color Dropdown": "Farbauswahl Dropdown",
  "Color Radio": "Farbauswahl Radio",
  "Color Radio Cards": "Color Radio Cards",
  Farbauswahl: D1e,
  Komponentenliste: J1e,
  "Komponentenliste mit Popup": "Komponentenliste mit Popup",
  Komponentenkarten: K1e,
  Bildauswahl: E1e,
  Informationen: N1e,
  Zahleneingabe: L1e,
  "Radio Buttons": "Radio Buttons",
  "Radio Cards": "Radio Cards",
  "RAL-Farbauswahl": "RAL-Farbauswahl",
  Dropdown: T1e,
  Thumbnails: M1e,
  Schalter: U1e,
  "Schalter Card": "Schalter Card",
  Texteingabe: P1e,
  Beispieltext: z1e,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren",
  "Übergeordnete Merkmale": "Übergeordnete Merkmale",
  "Darstellungs-Optionen": "Darstellungs-Optionen",
  Optional: O1e,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': 'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.',
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Auswahl nur anzeigen, wenn ausgewählt",
  "Konfigurator erfolgreich veröffentlicht.": "Konfigurator erfolgreich veröffentlicht.",
  "Folgende Änderungen werden veröffentlicht:": "Folgende Änderungen werden veröffentlicht:",
  "Konfigurator veröffentlichen": "Konfigurator veröffentlichen",
  "Sie möchten den Konfigurator veröffentlichen?": "Sie möchten den Konfigurator veröffentlichen?",
  "Wertebereich angeben": "Wertebereich angeben",
  "Merkmale: ": "Merkmale: ",
  "Aktionen: ": "Aktionen: ",
  "Diese Regel ist aktuell deaktiviert.": "Diese Regel ist aktuell deaktiviert.",
  "Modell Eigenschaften anpassen": "Modell Eigenschaften anpassen",
  Labelaktion: Q1e,
  Fehlermeldung: j1e,
  "Merkmale entfernen": "Merkmale entfernen (veraltet)",
  "Merkmale ausblenden": "Merkmale ausblenden",
  "Schritt entfernen": "Schritt entfernen",
  "Schritt ausblenden": "Schritt ausblenden",
  "Werte ausblenden": "Werte ausblenden",
  Modelaktion: _1e,
  "Bitte fügen Sie neue Regelzeilen hinzu.": "Bitte fügen Sie neue Regelzeilen hinzu.",
  "Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Andernfalls wird diese Regel bei der Auswertung nicht beachtet.",
  "Keine Warnungen": "Keine Warnungen",
  "Selektions-Bearbeitung": "Selektions-Bearbeitung",
  "Alle Regeln ansehen": "Alle Regeln ansehen",
  Position: $1e,
  "Rotation (in radiant)": "Rotation (in radiant)",
  Scale: q1e,
  "Regel Bearbeitung": "Regel Bearbeitung",
  "Kein Label angegeben!": "Kein Label angegeben!",
  "Regel Validierung": "Regel Validierung",
  "Fehlende Werte": "Fehlende Werte",
  "Aktive Schritte": "Aktive Schritte",
  Modell: e2e,
  Material: t2e,
  Komponenten: i2e,
  Druck: n2e,
  "Kein Modell": "Kein Modell",
  Regelname: g2e,
  "Wird angewendet": "Wird angewendet",
  Gültigkeitsregeln: "Gültigkeitsregeln",
  "Gültigkeit prüfen?": "Gültigkeit prüfen?",
  Merkmalskombinationen: r2e,
  Produktstruktur: o2e,
  "Merkmale entfernen (veraltet)": "Merkmale entfernen (veraltet)",
  "Schritt entfernen (veraltet)": "Schritt entfernen (veraltet)",
  "Anzeige von 3D-Modellen": "Anzeige von 3D-Modellen",
  "Anzeige von Informationen": "Anzeige von Informationen",
  "Anzeige von Fehlermeldungen": "Anzeige von Fehlermeldungen",
  "Austauschen von Oberflächen": "Austauschen von Oberflächen",
  "Bilder auf Oberflächen drucken": "Bilder auf Oberflächen drucken",
  Materialnamen: I2e,
  "Wählen Sie ein Materialnamen aus.": "Wählen Sie ein Materialnamen aus.",
  "Ändern der Farbe": "Ändern der Farbe",
  "Anzeige von Bildern": "Anzeige von Bildern",
  "Preise & Artikel": "Preise & Artikel",
  "Weitere Bedingungen": "Weitere Bedingungen",
  "Artikel zur Stückliste hinzufügen": "Artikel zur Stückliste hinzufügen",
  "Zugeordnete Merkmale": "Zugeordnete Merkmale",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen",
  "Befüllen von Komponentenmerkmalen": "Befüllen von Komponentenmerkmalen",
  Komponentenmerkmale: l2e,
  "Wählen Sie Komponentenmerkmale aus.": "Wählen Sie Komponentenmerkmale aus.",
  "Oberflächenaktion hinzufügen": "Oberflächenaktion hinzufügen",
  "Alle auswählen": "Alle auswählen",
  "Alle abwählen": "Alle abwählen",
  "Auswahl umkehren": "Auswahl umkehren",
  Herunterladen: s2e,
  "Jetzt verbinden": "Jetzt verbinden",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "Das flexible Shopsystem für Ihr E-Commerce-Projekt.",
  "Jetzt Installieren": "Jetzt Installieren",
  "Die globale Commerce-Plattform.": "Die globale Commerce-Plattform.",
  "Die E-Commerce-Plattform für WordPress.": "Die E-Commerce-Plattform für WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Die eine europäische Open-Source-E-Commerce-Plattform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Jetzt Adobe Commerce: E-Commerce leicht gemacht.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.",
  "Individuelle Entwicklung": "Individuelle Entwicklung",
  "Shop mit einer individuellen Entwicklung anbinden.": "Shop mit einer individuellen Entwicklung anbinden.",
  "Bitte nutzen Sie stattdessen unsere Shopify App.": "Bitte nutzen Sie stattdessen unsere Shopify App.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:",
  "Verbinde Shop": "Verbinde Shop",
  " und importiere Artikel": " und importiere Artikel",
  "Fehler beim Verbinden:": "Fehler beim Verbinden:",
  "Shop erfolgreich verbunden.": "Shop erfolgreich verbunden.",
  "Fehler beim Verbinden: ": "Fehler beim Verbinden: ",
  "Shop-Anbindung": "Shop-Anbindung",
  "Web-Adresse des Shops": "Web-Adresse des Shops",
  "Shopify Admin API Key": "Shopify Admin API Key",
  "Sollen die Artikel aus dem Shop importiert werden?": "Sollen die Artikel aus dem Shop importiert werden?",
  "Filter für Artikel": "Filter für Artikel",
  "Sollen die Artikel regelmäßig importiert werden?": "Sollen die Artikel regelmäßig importiert werden?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Soll die Artikelnummer der Shop-SKU entnommen werden?",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Sollen die Artikel bei der Bestellung zusammengefasst werden?",
  "Basis-Name für kombinierte Artikel": "Basis-Name für kombinierte Artikel",
  "Ihre Bestellung {code}": "Ihre Bestellung {code}",
  "Shop-Anbindung aufheben": "Shop-Anbindung aufheben",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Fügen Sie den Konfigurator Ihrem Shop hinzu",
  Verbinden: a2e,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.",
  "Der eingegebe Wert ist nicht gültig: ": "Der eingegebe Wert ist nicht gültig: ",
  "Ungültiges HTML-Format": "Ungültiges HTML-Format",
  "Sie können uns den Vorfall hier melden!": "Sie können uns den Vorfall hier melden!",
  "Das Template konnte nicht geladen werden.": "Das Template konnte nicht geladen werden.",
  "Templat auf Voreinstellung zurücksetzen": "Templat auf Voreinstellung zurücksetzen",
  "Eingaben zurücksetzen": "Eingaben zurücksetzen",
  "Templat bearbeiten": "Templat bearbeiten",
  "Templat Name": "Templat Name",
  "Templat wählen": "Templat wählen",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.",
  "Templat hinzufügen": "Templat hinzufügen",
  "Ansicht auswählen": "Ansicht auswählen",
  "Datei hochladen": "Datei hochladen",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Bitte buchen Sie zunächst ein anderes Produkt:",
  "Bitte wählen": "Bitte wählen",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):",
  "Automatisch angelegt": "Automatisch angelegt",
  "Aktionen verknüpfen": "Aktionen verknüpfen",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Werte von diesem Merkmal sollen folgende Aktionen auslösen:",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.",
  "Zu den Regeln": "Zu den Regeln",
  "Artikel bestellen": "Artikel bestellen",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.",
  "Oberfläche ändern": "Oberfläche ändern",
  "Welche Oberflächen sollen geändert werden? ": "Welche Oberflächen sollen geändert werden? ",
  "3D-Modell anzeigen": "3D-Modell anzeigen",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.",
  "Bild anzeigen": "Bild anzeigen",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.",
  "Farbe ändern": "Farbe ändern",
  "Welche Oberflächen sollen eingefärbt werden? ": "Welche Oberflächen sollen eingefärbt werden? ",
  "Bild aufdrucken": "Bild aufdrucken",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ",
  "Der Wert wird noch in Regeln verwendet:": "Der Wert wird noch in Regeln verwendet:",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde",
  "Dieser Wert ist nicht erlaubt.": "Dieser Wert ist nicht erlaubt.",
  "Maximale Anzahl an Werten ist erreicht.": "Maximale Anzahl an Werten ist erreicht.",
  Farbwert: c2e,
  Anzeige: d2e,
  RAL: C2e,
  "keine RAL Farbe": "keine RAL Farbe",
  Ansicht: u2e,
  "Key eingeben": "Key eingeben",
  URL: A2e,
  "Info-Modal": "Info-Modal",
  "Info-Content": "Info-Content",
  "Dieser Merkmalstyp unterstützt keine Werte.": "Dieser Merkmalstyp unterstützt keine Werte.",
  "Fehlende RAL Farben hinzufügen": "Fehlende RAL Farben hinzufügen",
  Auswahlwerte: b2e,
  Info: m2e,
  "Typ des Merkmals": "Typ des Merkmals",
  "es gibt keine Merkmale mit {{identificator}}": "es gibt keine Merkmale mit {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "es gibt kein Attribut mit {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "es gibt keine Selection mit {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "es gibt mehr als eine Selection mit {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "Wert {{paramName}} der Funktion {{functionName}} ist null",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "Es gibt einen Zyklus in den berechneten Merkmalen.",
  Übersicht: "Übersicht",
  Auswahlpreise: h2e,
  Auswahl: p2e,
  Gesamtpreis: B2e,
  "Preis Information": "Preis Information",
  "Persönliche Daten": "Persönliche Daten",
  Weiter: Z2e,
  "In AR ansehen": "In AR ansehen",
  Vollbildmodus: f2e,
  "Komponenten suchen": "Komponenten suchen",
  "Nicht Gruppiert": "Nicht Gruppiert",
  "Komponenten hinzufügen": "Komponenten hinzufügen",
  xl: G2e,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:",
  "Bei Auswahl wird eine Alternative berechnet!": "Bei Auswahl wird eine Alternative berechnet!",
  Bestätigen: "Bestätigen",
  "Produkt hinzufügen": "Produkt hinzufügen",
  "Produkt erfolgreich konfiguriert": "Produkt erfolgreich konfiguriert",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?",
  "Neues Produkt auswählen": "Neues Produkt auswählen",
  "Neues Produkt hinzufügen": "Neues Produkt hinzufügen",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Meldung bei Zurücksetzen einer ungültigen Auswahl",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Meldung bei Auftreten eines Konflikts",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Meldung bei Auftreten von zwei Konflikten",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Meldung bei Auftreten von drei oder mehr Konflikten",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.',
  Konfliktmeldung: y2e,
  "Anpassung nötig": "Anpassung",
  "Stattdessen werden folgende Auswahlen angepasst:": "Stattdessen werden folgende Auswahlen angepasst:",
  "wird zu": "wird zu",
  "wird entfernt": "wird entfernt",
  "Optionaler weiterer Hinweistext:": "Optionaler weiterer Hinweistext:",
  "Auf Facebook teilen": "Auf Facebook teilen",
  "Auf Twitter teilen": "Auf Twitter teilen",
  "Auf LinkedIn teilen": "Auf LinkedIn teilen",
  "Modal Titel": "Modal Titel",
  "Desktop Gerät erkannt": "Desktop Gerät erkannt",
  "Modal Text": "Modal Text",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:",
  "Mobiles {{device}}-Gerät erkannt": "Mobiles {{device}}-Gerät erkannt",
  "Fortschrittsanzeige 3D-Objekt": "Fortschrittsanzeige 3D-Objekt",
  "Export des 3D-Objekts": "Export des 3D-Objekts",
  "Fortschrittsanzeige AR-Datei": "Fortschrittsanzeige AR-Datei",
  "Bereitstellen der AR-Datei": "Bereitstellen der AR-Datei",
  "Fortschrittsanzeige System": "Fortschrittsanzeige System",
  "{{device}}-AR-System einrichten": "{{device}}-AR-System einrichten",
  Positionszeile: W2e,
  "Pos.": "Pos.",
  "Artikelnummer Spalte": "Artikelnummer Spalte",
  "Artikel Spalte": "Artikel Spalte",
  "Artikelpreis Spalte": "Artikelpreis Spalte",
  "Artikelmenge Spalte": "Artikelmenge Spalte",
  Menge: S2e,
  "Artikelanzahl Spalte": "Artikelanzahl Spalte",
  "Positionspreis Spalte": "Positionspreis Spalte",
  Positionspreis: V2e,
  "Hilfetext Preisdetails": "Hilfetext Preisdetails",
  "Preisdetails anzeigen": "Preisdetails anzeigen",
  "Titel bei Versions-Konflikt": "Titel bei Versions-Konflikt",
  "Konfigurator wurde aktualisiert": "Konfigurator wurde aktualisiert",
  "Text bei Versions-Konflikt": "Text bei Versions-Konflikt",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?",
  "Alte Version": "Alte Version",
  "Aktuelle Version": "Aktuelle Version",
  "Zeige Namen": "Zeige Namen",
  "Zeige Beschreibung": "Zeige Beschreibung",
  "Zeige Thumbnail": "Zeige Thumbnail",
  "Zeige Preis an Merkmal": "Zeige Preis an Merkmal",
  "Zeige Preise an Werten": "Zeige Preise an Werten",
  "Zeige URL": "Zeige URL",
  "Zeige Info-Button für Werte": "Zeige Info-Button für Werte",
  "Zeige HTML Content für Werte": "Zeige HTML Content für Werte",
  "Kamerafahrt beim scrollen": "Kamerafahrt beim scrollen",
  "Alle ungültigen Werte ausblenden": "Alle ungültigen Werte ausblenden",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Ungültige, aktiv geänderte, Werte ausblenden",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Ausblenden wenn nur eine Auswahl möglich ist",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Deaktivieren wenn nur eine Auswahl möglich ist",
  "Komponente hervorheben": "Komponente hervorheben",
  Bild: w2e,
  Text: v2e,
  "Ja/ Nein": "Ja/ Nein",
  Information: R2e,
  Mehrfachauswahl: X2e,
  Liste: H2e,
  Eckenrundung: k2e,
  "Anzahl der Eckenrundungsschritte": "Anzahl der Eckenrundungsschritte",
  "Dieses Material existiert bereits": "Dieses Material existiert bereits",
  "Material hinzufügen": "Material hinzufügen",
  "Materialname eingeben": "Materialname eingeben",
  Abmessungen: F2e,
  Breite: Y2e,
  Höhe: "Höhe",
  Tiefe: x2e,
  Startpunkt: D2e,
  Endpunkt: J2e,
  Linienstärke: "Linienstärke",
  Startanker: K2e,
  Maßkette: "Maßkette",
  Ohne: E2e,
  Endanker: N2e,
  Texttyp: L2e,
  "Kein Text": "Kein Text",
  Zahlenwert: T2e,
  "Statischer Text": "Statischer Text",
  "Automatisches Maß überschreiben": "Automatisches Maß überschreiben",
  "Neues Maß": "Neues Maß",
  "Textgröße als Faktor. 1 ist Standard.": "Textgröße als Faktor. 1 ist Standard.",
  Offsets: M2e,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.",
  "Nicht Befüllt": "Nicht Befüllt",
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden."
}, P2e = "Liste", z2e = "Farben", O2e = "Text", Q2e = "Ja/ Nein", j2e = "Information", _2e = "Bild", $2e = "Komponenten", q2e = "Darstellung", eve = "Aktionen", tve = "Werte", ive = "Regeln", nve = "Optionen", gve = "Bilder", rve = "Konfiguratoren", ove = "Straße", Ive = "Postleitzahl", lve = "Stadt", sve = "Land", ave = "Extrahieren", cve = "Telefon", dve = "Nutzername", Cve = "MATERIAL", uve = "Import", Ave = "Manuell", bve = "Rotation", mve = "Allgemeines", hve = "Beschaffenheit", pve = "Roughness", Bve = "Metallness", Zve = "Bilderstapel", fve = "Szeneneinstellungen", Gve = "Themes", yve = "Anpassung", Wve = "Wertebereich", Sve = "Darstellung", Vve = "Werte", wve = "Anfragen", vve = "Zeitpunkt", Rve = "Anfrage", Xve = "URI", Hve = "Parameter", kve = "Dauer", Fve = "Server", Yve = "Anzahl", xve = "Artikel", Dve = "Vollbildmodus", Jve = {
  always: "Immer",
  never: "Nie",
  auto: "Wie im Konfigurator",
  label: "Anzeige in Bestätigung, PDF und Shop"
}, Kve = "Aktivieren", Eve = "Deaktivieren", Nve = "Merkmale und Artikel", Lve = "Nur Merkmale", Tve = "Nur Artikel", Mve = "Keine Übersicht", Uve = "Allgemein", Pve = "PDF", zve = "Mail", Ove = "Einbetten", Qve = "Shop", jve = "Artikel", _ve = "Vorschau", $ve = "Editor", qve = "Bilder", eRe = "Materialien", tRe = "Modelle", iRe = "Regeln", nRe = "Optionen", gRe = "Admin", rRe = "extract", oRe = "Konfiguratoren", IRe = "Erstellen", lRe = "Importieren", sRe = "Benutzer", aRe = "Support", cRe = "Logs", dRe = "Systemstatus", CRe = "Papierkorb", uRe = "Abonnement", ARe = "Ausgelaufen", bRe = "Profil", mRe = "Editor", hRe = "Konfigurationen", pRe = "Schritte", BRe = "Merkmale", ZRe = "Design", fRe = "Szene", GRe = "Darstellung", yRe = "Optionen", WRe = "Aktionen", SRe = "Werte", VRe = "Primärfarbe", wRe = "Sekundärfarbe", vRe = "Hintergrundfarbe", RRe = "Warnfarbe", XRe = "Standard", HRe = "Heller", kRe = "Dunkler", FRe = "Hervorgehoben", YRe = "Standard", xRe = "Ausgegraut", DRe = "Monat", JRe = "Jahr", KRe = "STRG", ERe = "Ersetzen", NRe = "Bestellen", LRe = {
  list: P2e,
  color: z2e,
  text: O2e,
  boolean: Q2e,
  information: j2e,
  image: _2e,
  components: $2e,
  presentation: q2e,
  usage: eve,
  values: tve,
  rules: ive,
  settings: nve,
  images: gve,
  configurators: rve,
  street: ove,
  zip: Ive,
  city: lve,
  country: sve,
  extract: ave,
  phone: cve,
  username: dve,
  "duplicate-entry": "Es existieren bereits Konten mit diesen Daten",
  "create new dealer": "Neuen Händler anlegen",
  "Artikel Anzahl": "Artikel Anzahl",
  "Farb auswählen": "Farb auswählen",
  "< Zurück": "< Zurück",
  "Merkmal auswählen": "Merkmal auswählen",
  MATERIAL: Cve,
  Import: uve,
  "Materialien für den Import auswählen:": "Materialien für den Import auswählen:",
  "Wie möchten Sie ein Material erstellen?": "Wie möchten Sie ein Material erstellen?",
  "Import einer .glb und export der enthaltenen Materialien": "Import einer .glb und export der enthaltenen Materialien",
  Manuell: Ave,
  "Eigenständiges Anlegen eines PBR-Materials": "Eigenständiges Anlegen eines PBR-Materials",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Löschen Sie bitte zunächst dort die entsprechende Spalte.",
  "Design & Layout": "Design & Layout",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!",
  "Theme wählen": "Theme wählen",
  "Komponente löschen": "Komponente löschen",
  "Mehrfach Regelzeilen Bearbeitung": "Mehrfach Regelzeilen Bearbeitung",
  "Anzahl ausgewählte Regel-Zeilen:": "Anzahl ausgewählte Regel-Zeilen:",
  "Modelaktions-Positionierung": "Modelaktions-Positionierung",
  Rotation: bve,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Keine Aktionen für die Mehrfachbearbeitung vorhanden.",
  Allgemeines: mve,
  "Farben und Lichtinteraktion": "Farben und Lichtinteraktion",
  "Color-Map Upload": "Color-Map Upload",
  "Material interagiert mit Licht in der Szene": "Material interagiert mit Licht in der Szene",
  Beschaffenheit: hve,
  "Roughness-Map Upload": "Roughness-Map Upload",
  Roughness: pve,
  "Metallness-Map Upload": "Metallness-Map Upload",
  Metallness: Bve,
  "Normalen-Map Upload": "Normalen-Map Upload",
  "Normalen-Skalierung": "Normalen-Skalierung",
  "Anwendung auf 3D-Modell": "Anwendung auf 3D-Modell",
  "Displacement-Map Upload": "Displacement-Map Upload",
  "Displacement-Skalierung": "Displacement-Skalierung",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Repeat-Faktor der Textur in X- und Y-Richtung",
  "Alpha-Werte": "Alpha-Werte",
  "Alpha-Map Upload": "Alpha-Map Upload",
  "Ambient Occlusion": "Ambient Occlusion",
  "Ambient-Occlusion-Map Upload": "Ambient-Occlusion-Map Upload",
  "Info editieren": "Info editieren",
  "Zeige Info-Button": "Zeige Info-Button",
  Abhängigkeitsschleifen: "Abhängigkeitsschleifen",
  Bilderstapel: Zve,
  "Google Analytics Property ID": "Google Analytics Property ID",
  "Sans Serif": "Sans Serif",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Die eine europäische Open-Source-E-Commerce-Plattform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Jetzt Adobe Commerce: E-Commerce leicht gemacht.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.",
  "Individuelle Entwicklung": "Individuelle Entwicklung",
  "Shop mit einer individuellen Entwicklung anbinden.": "Shop mit einer individuellen Entwicklung anbinden.",
  Szeneneinstellungen: fve,
  Themes: Gve,
  Anpassung: yve,
  "Gewähltes Theme übernehmen": "Gewähltes Theme übernehmen",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Legen Sie einen neuen Konfigurationsschritt an.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.",
  "Konfigurationsschritt erstellen": "Konfigurationsschritt erstellen",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.",
  "Neuer Konfigurator wählen": "Neuer Konfigurator wählen",
  "Bitte geben Sie einen Namen ein.": "Bitte geben Sie einen Namen ein.",
  "Bitte geben Sie eine Beschreibung ein.": "Bitte geben Sie eine Beschreibung ein.",
  "Bitte klicken Sie hier.": "Bitte klicken Sie hier.",
  "Konfigurator Dialog aufrufen": "Konfigurator Dialog aufrufen",
  "Konfigurationsschritt benennen": "Konfigurationsschritt benennen",
  "Hier können Sie neue Werte hinzufügen.": "Hier können Sie neue Werte hinzufügen.",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Klicken Sie hier um einen neuen Wert zu erstellen.",
  "Wenn Sie fertig sind klicken Sie hier.": "Wenn Sie fertig sind klicken Sie hier.",
  "Werte erstellen": "Werte erstellen",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Bitte geben Sie einen Namen für das neue Merkmal ein.",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.",
  "Präsentation definieren": "Präsentation definieren",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.",
  "Produktmerkmal erstellen": "Produktmerkmal erstellen",
  "Was für ein Merkmal wollen Sie anlegen?": "Was für ein Merkmal wollen Sie anlegen?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.",
  "Produktmerkmaltyp auswählen": "Produktmerkmaltyp auswählen",
  "Wählen sie den eben erstellten Konfigurator.": "Wählen sie den eben erstellten Konfigurator.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Steuerung des Konfigurators durch das neue Merkmal.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.",
  "Merkmal verwenden": "Merkmal verwenden",
  Wertebereich: Wve,
  Darstellung: Sve,
  Werte: Vve,
  Anfragen: wve,
  Zeitpunkt: vve,
  Anfrage: Rve,
  URI: Xve,
  Parameter: Hve,
  Dauer: kve,
  Server: Fve,
  "Modell bearbeiten": "Modell bearbeiten",
  "Korrekte Mail-Adresse": "Korrekte Mail-Adresse",
  "Statistik (30 Tage)": "Statistik (30 Tage)",
  amount: Yve,
  article: xve,
  "Datum eingeben": "Datum eingeben",
  "Nach hause ": "Nach hause ",
  "Mandant anlegen": "Mandant anlegen",
  "Nutzer hinzufügen": "Nutzer hinzufügen",
  Fullscreen: Dve,
  showSelection: Jve,
  "Kamera überschreiben": "Kamera überschreiben",
  Aktivieren: Kve,
  Deaktivieren: Eve,
  Übersichtsseite: "Übersichtsseite",
  variablesAndArticles: Nve,
  variablesOnly: Lve,
  articlesOnly: Tve,
  noOverview: Mve,
  breadcrumb_app: Uve,
  breadcrumb_pdf: Pve,
  breadcrumb_mail: zve,
  breadcrumb_embed: Ove,
  breadcrumb_shop: Qve,
  breadcrumb_articles: jve,
  breadcrumb_preview: _ve,
  breadcrumb_edit: $ve,
  breadcrumb_images: qve,
  breadcrumb_materials: eRe,
  breadcrumb_models: tRe,
  breadcrumb_rules: iRe,
  breadcrumb_settings: nRe,
  breadcrumb_admin: gRe,
  breadcrumb_extract: rRe,
  breadcrumb_apps: oRe,
  breadcrumb_create: IRe,
  breadcrumb_import: lRe,
  breadcrumb_users: sRe,
  breadcrumb_support: aRe,
  breadcrumb_logs: cRe,
  breadcrumb_systemStatus: dRe,
  breadcrumb_trash: CRe,
  breadcrumb_abonnement: uRe,
  breadcrumb_expired: ARe,
  breadcrumb_profile: bRe,
  breadcrumb_configurator: mRe,
  breadcrumb_configurations: hRe,
  breadcrumb_groups: pRe,
  breadcrumb_variables: BRe,
  breadcrumb_design: ZRe,
  breadcrumb_scene: fRe,
  breadcrumb_presentation: GRe,
  breadcrumb_options: yRe,
  breadcrumb_usage: WRe,
  breadcrumb_values: SRe,
  Primary: VRe,
  Secondary: wRe,
  Background: vRe,
  Warning: RRe,
  Error: "Fehlerfarbe",
  Main: XRe,
  Light: HRe,
  Dark: kRe,
  "Contrast Text": "(Kontast-)Textfarbe",
  Paper: FRe,
  Default: YRe,
  Disabled: xRe,
  "Content Main": "Canvas Hintergrundfarbe",
  "Scrollbar Default": "Scrollbar Farbe",
  "Letzter Schritt kann nicht gelöscht werden.": "Letzter Schritt kann nicht gelöscht werden.",
  "Dieses Merkmal ist versteckt.": "Dieses Merkmal ist versteckt.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: 
 1. Es wurde per Regel ausgeblendet. 
 2. Der zugehörige Schritt wurde entfernt.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!",
  "Vertikale Platzierung zulassen?": "Vertikale Platzierung zulassen?",
  "Suchfeld ausblenden?": "Suchfeld ausblenden?",
  Modalgröße: "Modalgröße",
  "Anzahl an Komponenten pro Zeile": "Anzahl an Komponenten pro Zeile",
  month: DRe,
  year: JRe,
  "Weitere Preisauswirkungen dieser Selektion": "Weitere Preisauswirkungen dieser Selektion",
  "Aktion verstecken": "Aktion verstecken",
  Ctrl: KRe,
  Ersetzen: ERe,
  "Bild hochladen": "Bild hochladen",
  "Das Dateiformat ist nicht erlaubt!": "Das Dateiformat ist nicht erlaubt!",
  Bestellen: NRe,
  "UST-ID": "Umsatzsteuer-Identifikationsnummer"
}, TRe = {
  ...U2e,
  ...LRe
}, MRe = "Client", URe = "Product", PRe = "Payment status", zRe = "Clients", ORe = "Configurators", QRe = "Support", jRe = "Dealers", _Re = "Users", $Re = "Trash", qRe = "Others", eXe = "Links", tXe = "Help", iXe = "Consultation", nXe = "Status", gXe = "Subscription", rXe = "Profile", oXe = "Log out", IXe = "Template", lXe = "Invoke", sXe = "PDF", aXe = "Code", cXe = "Price", dXe = "Inspiration", CXe = "Action", uXe = "Language", AXe = "Customer", bXe = "Content", mXe = "Configurator version", hXe = "Cancel", pXe = "Close", BXe = "Edit", ZXe = "Address", fXe = "Privacy policy", GXe = "Name", yXe = "Email", WXe = "Phone", SXe = "Remark", VXe = "Company", wXe = "Accepted", vXe = "City", RXe = "ZIP Code", XXe = "Date", HXe = "Dealer", kXe = "json", FXe = "Price", YXe = "Options", xXe = "Order Action", DXe = "Type", JXe = "Configuration", KXe = "AR", EXe = "Shared", NXe = "Display", LXe = "Sort", TXe = "Article number", MXe = "Description", UXe = "Category", PXe = "Prices", zXe = "Import", OXe = "Article", QXe = "Upload", jXe = "None", _Xe = "All", $Xe = "Images", qXe = "Roughness", eHe = "Metalness", tHe = "Transparent", iHe = "Opacity", nHe = "Color", gHe = "Emissive", rHe = "Surface", oHe = "Front", IHe = "Back", lHe = "Both sides", sHe = "Transmission", aHe = "Reflectivity", cHe = "Clear Coat", dHe = "Options", CHe = "Designation", uHe = "Physically based rendering (PBR)", AHe = "Physical", bHe = "Key", mHe = "Model", hHe = "Advanced", pHe = "Edit", BHe = "Copy", ZHe = "Export", fHe = "General", GHe = "Languages", yHe = "Product visualization", WHe = "Upgrade", SHe = "Main Model", VHe = "Template", wHe = "Tutorial", vHe = "Characteristics", RHe = "Discount", XHe = "Surcharge", HHe = "Save", kHe = "Embed", FHe = "Reference language", YHe = "Font", xHe = "Helvetica", DHe = "Courier", JHe = "Interstate", KHe = "Montserrat", EHe = "Left", NHe = "Right", LHe = "Top", THe = "Bottom", MHe = "Header", UHe = "Mail", PHe = "Shop", zHe = "Send", OHe = "Orders", QHe = "Date", jHe = "Days", _He = "Article Name", $He = "Articles", qHe = "Configurations", eke = "Configurator", tke = "Partner", ike = "Provision", nke = "Create", gke = "name", rke = "email", oke = "User account", Ike = "Userame", lke = "Password", ske = "Login", ake = "Registration", cke = "Datenschutzbestimmungen", dke = "TERMS AND CONDITIONS", Cke = "Password", uke = "Editor", Ake = "Default", bke = "Version", mke = "Bookings", hke = "Platform", pke = "Interval", Bke = "User", Zke = "Subscription", fke = "CustomerID", Gke = "Active", yke = "Since", Wke = "Query", Ske = "Actions", Vke = "Type", wke = "Month", vke = "Year", Rke = "Booking", Xke = "Parameters", Hke = "Customers", kke = "ID", Fke = "Invoices", Yke = "Blank", xke = "Switch", Dke = "Users", Jke = "Role", Kke = "Configurators", Eke = "Start date", Nke = "End date", Lke = "Steps", Tke = "Values", Mke = "Rules", Uke = "Rule Entries", Pke = "Models", zke = "Materials", Oke = "Characteristics", Qke = "Rule", jke = "Number", _ke = "Status", $ke = "Created", qke = "Password", eFe = "New", tFe = "Input", iFe = "Invite", nFe = "Download", gFe = "Background model", rFe = "Favorites", oFe = "Create", IFe = "Pricing settings", lFe = "Main action", sFe = "Contact form", aFe = "Mandatory field", cFe = "Action name", dFe = "Count", CFe = "Number calculation", uFe = "Quantity calculation", AFe = "Article action", bFe = "Number", mFe = "Unit", hFe = "Focus type", pFe = "Camera", BFe = "Step", ZFe = "Camera view", fFe = "Duplicate", GFe = "Entfernen", yFe = "Selections", WFe = "Cameras", SFe = "free", VFe = "Downgrade", wFe = "Monthly", vFe = "Home", RFe = "Help", XFe = "cancel", HFe = "Icon", kFe = "Logo", FFe = "Colors", YFe = "CSS", xFe = "Settings", DFe = "Preview", JFe = "Articles", KFe = "Orders", EFe = "Statistics", NFe = "Error", LFe = "Unknown Error", TFe = "An unknown error occured. If the error persists after reloading the page, please contact us:", MFe = "An Error occured", UFe = "Order options", PFe = "This step is currently only visible here (in admin-panel), because it contains only characteristics with no selectable options", zFe = "Basic settings", OFe = "Opacity", QFe = "Material action", jFe = "Colour action", _Fe = "Image action", $Fe = "Note", qFe = "Warning", eYe = "Continue", tYe = "Hidden", iYe = "ArticleNo", nYe = "ArticleName", gYe = "Currency", rYe = "Value", oYe = "Start number", IYe = "End count", lYe = "Search", sYe = "Titel", aYe = "OK", cYe = "Highlight", dYe = "Expression", CYe = "Result", uYe = "Minimum value", AYe = "Maximum value", bYe = "Infinity", mYe = "Decimal places", hYe = "Step size", pYe = "Calculate", BYe = "Color Selection", ZYe = "Component List", fYe = "Component cards", GYe = "Image Selection", yYe = "Informationen", WYe = "Number input", SYe = "Dropdown", VYe = "Thumbnails", wYe = "Switch", vYe = "Text input", RYe = "Sample text", XYe = "Optional", HYe = "Label action", kYe = "Fehlermeldung", FYe = "Model action", YYe = "Position", xYe = "Scale", DYe = "Model", JYe = "Material", KYe = "Components", EYe = "Print", NYe = "Rule name", LYe = "Characteristic combinations", TYe = "Product structure", MYe = "Material names", UYe = "Component proper", PYe = "Download", zYe = "Connect", OYe = "Colour value", QYe = "Label", jYe = "RAL", _Ye = "View", $Ye = "URL", qYe = "Values", exe = "Info", txe = "Selection prices", ixe = "Selection", nxe = "Total price", gxe = "Next", rxe = "Fullscreen", oxe = "xl", Ixe = "Conflict Message", lxe = "Item row", sxe = "Quantity", axe = "Item Price", cxe = "Image", dxe = "Text", Cxe = "Information", uxe = "Multiple choice", Axe = "List", bxe = "Bevel", mxe = "Dimensions", hxe = "Width", pxe = "Depth", Bxe = "Start point", Zxe = "End point", fxe = "Starting anchor", Gxe = "Without", yxe = "Ending anchor", Wxe = "Text type", Sxe = "Numberic value", Vxe = "Offsets", wxe = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "You do not pay online. Please contact the employee in your company who has signed the contract with ObjectCode..",
  Mandant: MRe,
  Produkt: URe,
  Bezahlzustand: PRe,
  Mandanten: zRe,
  apps: ORe,
  support: QRe,
  "dealer-profile": "dealer-profile",
  dealers: jRe,
  users: _Re,
  trash: $Re,
  others: qRe,
  links: eXe,
  help: tXe,
  consultation: iXe,
  status: nXe,
  subscription: gXe,
  profile: rXe,
  logout: oXe,
  "Neuer Konfigurator": "New configurator",
  Template: IXe,
  Zurück: "Back",
  Aufrufen: lXe,
  PDF: sXe,
  Code: aXe,
  Preis: cXe,
  Inspiration: dXe,
  Aktion: CXe,
  Sprache: uXe,
  Händler: "Dealers",
  "Sie möchten die Daten dieses Kunden einsehen?": "Would you like to view this customer's data?",
  Kunde: AXe,
  Inhalt: bXe,
  "Shop-API": "Store API",
  "Gespeichert am": "Saved on",
  Konfiguratorversion: mXe,
  Abbrechen: hXe,
  "Ergebnis der Shop API": "Store API result",
  Schliessen: pXe,
  Bearbeiten: BXe,
  Adresse: ZXe,
  Datenschutz: fXe,
  Name: GXe,
  Email: yXe,
  Telefon: WXe,
  Bemerkung: SXe,
  Firma: VXe,
  "Steuer-ID": "Tax ID",
  Akzeptiert: wXe,
  Stadt: vXe,
  PLZ: RXe,
  Datum: XXe,
  "exit-action": "Exit action",
  dealer: HXe,
  "order-status": "Order status",
  json: kXe,
  price: FXe,
  options: YXe,
  Bestellaktion: xXe,
  Typ: DXe,
  Konfiguration: JXe,
  AR: KXe,
  Geteilt: EXe,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Would you like to view your customers' data and requests?",
  "Preise anlegen": "Create prices",
  anzeigen: NXe,
  "Artikel und Preise erfolgreich importiert.": "Items and prices imported successfully.",
  Sortierung: LXe,
  Artikelnummer: TXe,
  "Artikelnummer eingeben": "Enter article number",
  "Namen eingeben": "Enter names",
  Beschreibung: MXe,
  "Beschreibung eingeben": "Enter description",
  Kategorie: UXe,
  "Kategorien eingeben": "Enter categories",
  Preise: PXe,
  "Sortierung erfolgreich angewendet.": "Sorting successfully applied.",
  "Fehler beim Anwenden der Sortierung: ": "Error when applying the sorting: ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Articles and prices successfully published.",
  "Fehler beim Veröffentlichen: ": "Publishing errors: ",
  "Sie möchten Preise anzeigen?": "Would you like to display prices?",
  Importieren: zXe,
  "Neuer Artikel": "New article",
  Löschen: "Delete",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Publish the app in order to publish articles and prices.",
  "Artikel und Preise veröffentlichen": "Publish articles and prices",
  Artikel: OXe,
  Upload: QXe,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Upload one or more images to the specified folder. They can use the slash (/) to create deeper folders...",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Alternatively, you can upload a ZIP archive with a folder structure..",
  "Ordner *": "folder *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': 'Note: All images in a folder are grouped, sorted by name. So use file names like "image_001".',
  Keine: jXe,
  Alle: _Xe,
  Bilder: $Xe,
  Roughness: qXe,
  Metalness: eHe,
  Transparent: tHe,
  Opacity: iHe,
  Farbe: nHe,
  Emissive: gHe,
  "Color Map": "Color Map",
  "Normal Map": "Normal Map",
  "Roughness Map": "Roughness Map",
  "Metalness Map": "Metalness Map",
  "Alpha Map": "Alpha Map",
  Seite: rHe,
  Vorderseite: oHe,
  Hinterseite: IHe,
  Beidseitig: lHe,
  "Texture repeat": "Texture repeat",
  "Depth Write": "Depth Write",
  Transmission: sHe,
  Reflectivity: aHe,
  ClearCoat: cHe,
  "Clearcoat Roughness": "Clear Coat Roughness",
  "new-material": "New Material",
  Optionen: dHe,
  Bezeichnung: CHe,
  Pbr: uHe,
  Physikalisch: AHe,
  Key: bHe,
  "AR Fallback Material": "AR Fallback Material",
  "Nicht ausgewählt": "Not Selected",
  Model: mHe,
  Erweitert: hHe,
  "Nur in Regeln verwendete Materialien anzeigen": "Show only materials used in rules",
  "extract-materials": "extract-materials",
  Editieren: pHe,
  Kopieren: BHe,
  "Neues Modell": "New model",
  "Dynamisches Modell": "Dynamic model",
  Gültigkeit: "Validity",
  "Neue Regel": "New Rule",
  "Neue Regel Erstellen": "Create new rule",
  "Regel erstellen": "Create Rule",
  "Erfolgreich importiert": "Import successful",
  "Hier importieren Sie eine vorab exportierte Datei.": "Here you import a previously exported file.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "This will replace all data of this configurator.",
  "Auch der Papierkorb wird gelöscht.": "The recycle bin will also be cleared.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "This operation cannot be undone.",
  "Sind Sie sicher?": "Are you sure?",
  "JSON Export Datei": "JSON export file",
  Export: ZHe,
  "app-code-duplicate": "App code already in use",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "App settings could not be saved. The code is already in use.",
  Allgemein: fHe,
  Sprachen: GHe,
  "Die erste Sprache gilt als Standard.": "The first language is the default.",
  "Die Beschreibung dieses Konfigurators": "The description of this configurator",
  "Link zum Konfigurator": "Link to the configurator",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "If you use an extension, enter here where your developer provides it...",
  Produktdarstellung: yHe,
  "3D-Modell": "3D-Model",
  "Bilder-Konfigurator": "Image configurator",
  "Google Analytics 4 Property ID": "Google Analytics 4 Property ID",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "You must obtain the user's consent for the Google cookie. This does not happen within the K3!",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Would you like to connect your Analytics-account?",
  Upgrade: WHe,
  Hauptmodell: SHe,
  "Hauptmodell entfernen": "Remove Main Model",
  Vorlage: VHe,
  "Dieser Konfigurator dient als Vorlage": "This configurator is a template",
  Tutorial: wHe,
  "Standard übernehmen": "Apply default",
  "screenshot-quality": "Screenshot quality",
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Here you can specify a URL to which various data is sent as soon as the user makes a selection. This allows you to use the CustomData component in the Layout Designer to display special information (e.g. to indicate shipping costs etc.).",
  "Preis & Info Service": "Price & Info Service",
  "Hilfe dazu finden Sie hier.": "You can find help here.",
  "URL für den Service, der die Daten verarbeitet": "URL for the service that processes the data",
  "Debounce in ms": "Debounce in ms",
  Merkmale: vHe,
  "Merkmale und ihre aktuelle Auswahlen senden": "Send features and their current selections",
  "Optionale Merkmalbeschränkung": "Optional feature restriction",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "Optionally restrict the features that are sent.",
  "Artikel & Preis": "Article & Price",
  "Aktuell ausgewählte Artikel senden": "Send currently selected articles",
  "Aktuellen Preis senden": "Send current price",
  "to dealer app": "to dealer app",
  "Händler hat Zugriff": "Dealer has access",
  "Händler hat keinen Zugriff": "Dealer has no access",
  "dealer query": "Input presets",
  "Händler legt Aufschlag fest": "Dealer defines surcharge",
  discount: RHe,
  surcharge: XHe,
  "Sie stornieren nun eine Händlerlizenz.": "You are now cancelling a dealer licence.",
  "Händlerzugriff beenden": "Händlerzugriff beenden",
  "Sie buchen nun eine Händlerlizenz.": "You are now booking a dealer licence.",
  "Händlerzugriff buchen": "Book dealer access",
  Speichern: HHe,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Would you like your deals to use your configurator?",
  "Keine Händler vorhanden": "No existing dealers",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "First create a dealer - then authorize them to the app here.",
  "Jetzt Händler anlegen": "Create dealer now",
  Einbetten: kHe,
  "Als Link": "As Link",
  "Als IFrame": "As IFrame",
  "Meldungen beim Laden anpassen": "Customize loading messages",
  "Bitte Auth0 Zugangsdaten angeben": "Please enter Auth0 access data",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "You want to release the configurator only for specific users? Then you can use the Auth0 service.",
  "Konfigurator-Zugang": "Configurator access",
  "Anmeldung für Konfigurator verlangen.": "Require login for configurator.",
  "Auth0 Domain": "Auth0 Domain",
  "Auth0 ClientId": "Auth0 ClientId",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Reference language. The entries must match the reference column in the imported file in order to be taken into account.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.",
  "Importiere XLSX": "Import XLSX",
  "Exportiere XLSX": "Export XLSX",
  Referenzsprache: FHe,
  "Werden berücksichtigt:": "Are taken into account:",
  "Versteckte Merkmale": "Hidden characteristics",
  "Unbenutzte Sprachen": "Unused languages",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Would you like to forward requests to the customer or yourself?",
  "Mail Texte": "Mail texts",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Here you can customize the content of the sent mails. Read the section in the documentation beforehand...",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Please note: you must always publish the configurator before using the modified texts.",
  Schriftart: YHe,
  Helvetica: xHe,
  "Times Roman": "Times Roman",
  Courier: DHe,
  Interstate: JHe,
  Montserrat: KHe,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Bold",
  Schriftgröße: "font size",
  Links: EHe,
  Rechts: NHe,
  Oben: LHe,
  Unten: THe,
  Kopfzeile: MHe,
  Fußzeile: "Footer",
  "Neue PDF Vorlage auswählen": "Select new PDF template",
  "Vorhandene PDF Vorlage löschen": "Delete existing PDF template",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Would you like to send a PDF of confirmations or offers?",
  "PDF Einstellungen": "PDF Settings",
  Seitenränder: "Margins",
  "Voransicht mit dieser Konfiguration:": "Preview with this configuration:",
  "und diesem Template:": "and the template:",
  "Speichern und drucken": "Save and print",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "To preview the PDF, an existing configuration is required",
  Mail: UHe,
  Shop: PHe,
  "Social Sharing": "Social Sharing",
  "Wir helfen gern!": "We're here for you!",
  "Ihre Telefonnummer": "Your phone number",
  "Ihre Nachricht": "Your message",
  Senden: zHe,
  "Nachricht senden": "Nachricht senden",
  "Rückruf erbitten": "Rückruf erbitten",
  orders: OHe,
  date: QHe,
  "Preise wurden in den Einstellungen deaktiviert": "Prices have been disabled in the settings",
  "Keine Einnahmen vorliegend": "No revenue present",
  "total-earnings": "Total earnings",
  Tage: jHe,
  articlename: _He,
  articles: $He,
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'You can export a configurator under "Settings". You can import the resulting file back here.',
  "Leerer Konfigurator": "Empty configurator",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Start with an empty configurator and set it up according to your wishes.",
  "Konfigurator importieren": "Import configurator",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Import a configurator based on an exported file.",
  Veröffentlicht: "Published",
  Konfigurationen: qHe,
  "Mandant hat noch keinen Konfigurator": "Client does not have a configurator yet",
  Konfigurator: eke,
  "Link kopiert": "Link copied",
  "E-Mail": "E-Mail",
  "Werben Sie K3 Kunden!": "Refer new K3 customers!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Pass on the link below. You'll receive commission for each configurator booked by your contact.",
  Partner: tke,
  Provision: ike,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Please note that any affiliate links issued will become invalid once you change the code.",
  "Meine Kunden": "My customers",
  "Vielen Dank für Ihre Bestätigung...": "Thank you for your confirmation..",
  "E-Mail Bestätigung": "Email confirmation",
  "Zur Anmeldung": "To login",
  Händlerprofil: "Dealer profile",
  Erstellen: nke,
  name: gke,
  email: rke,
  "E-Mail ist ungültig!": "Email is invalid!",
  Nutzerkonto: oke,
  Nutzername: Ike,
  "Mail ist schon vergeben": "Email is already taken",
  "code-duplicate": "code-duplicate",
  "dealer code helper text": "To open the dealer configurator.",
  "default discount": "Default discount",
  "Kann pro Konfigurator überschrieben werden.": "Can be overwritten per configurator.",
  "default surcharge": "Default surcharge",
  "Pro Abo": "Per Abo",
  "is pro dealer": "is pro dealer",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Please check the information you have provided:",
  "Fehlendes Produkt": "Missing product",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Do you want your dealers to use one of your configurators?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Bitte buchen Sie dort zunächst ein anderes Produkt.",
  "new dealer": "New Dealer",
  "Login screen": "Login",
  "Bitte am Desktop öffnen": "Bitte am Desktop öffnen",
  Password: lke,
  Login: ske,
  "Passwort vergessen?": "Forgot password?",
  "Noch kein Konto?": "Noch kein Konto?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Failed to login. Email and/or password are invalid",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Failed to login. Please enable cookies in your browser settings",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "If the mail does not arrive in the next few minutes, please also check your SPAM folder and check your address...",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "We will send you a mail with instructions on how to set a new password.,",
  "Mail senden": "Send mail",
  Registrierung: ake,
  "Ihre E-Mail-Adresse": "Your e-mail address",
  "Bitte wählen Sie ein Kennwort": "Please choose a password",
  "Bitte bestätigen Sie unsere ": "Please confirm our ",
  Datenschutzbestimmungen: cke,
  " und unsere ": " und unsere ",
  AGB: dke,
  "Jetzt registrieren": "Register now",
  "Die Registrierung war leider nicht möglich.": "Sorry, registration was not possible",
  "Herzlich willkommen!": "Welcome!",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "We have sent you an e-mail - please also check your spam folder..",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "You can also register right now with your data:",
  "Wir haben Ihr Kennwort neu gesetzt.": "We have reset your password",
  "Passwort setzen": "Set password",
  Passwort: Cke,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "At least 8 characters, upper, lower case letters and numbers",
  Bestätigung: "Confirmation",
  "Bestätigung stimmt nicht überein": "Confirmation does not match",
  "Kennwort setzen": "Set password",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - the 3D product configurator for Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "You have successfully installed the Shopify app for the K3 configurator. These are the next steps:",
  "Registrieren Sie sich am K3.": "Register at K3.",
  "Legen Sie einen Konfigurator an.": "Create a configurator.",
  "Jetzt starten": "Start now",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Connect the configurator to your shop and import your Shopify items.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Design the configurator for your product.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Add the configurator to your shop.",
  Editor: uke,
  "Mandant: ": "Mandant: ",
  "Erstellt am: ": "Created at: ",
  "Veröffentlicht am: ": "Published at: ",
  "Noch nicht veröffentlicht": "Not yet published",
  "Version: ": "Version: ",
  "Artikel-Version: ": "Article-Version: ",
  "Code: ": "Code: ",
  "Typ: ": "Type: ",
  Standard: Ake,
  "Shop: ": "Shop: ",
  "Nicht verbunden": "Not connected",
  "Bestellungen insgesamt": "Total orders",
  Veröffentlichungen: "Publications",
  Version: bke,
  "Artikel-Version": "Article-Version",
  Buchungen: mke,
  Plattform: hke,
  Intervall: pke,
  Benutzer: Bke,
  Subscription: Zke,
  CustomerID: fke,
  Aktiv: Gke,
  Seit: yke,
  "Abschlag [%]": "Discount [%]",
  "Aufschlag [%]": "Surcharge [%]",
  Query: Wke,
  Aktionen: Ske,
  "Mandanten wechseln": "Change client",
  "Konnte nicht gespeichert werden: ": "Could not be saved: ",
  Type: Vke,
  "Angelegt am": "Created on",
  "Zum AdminPanel": "To the Admin Panel",
  "App editieren": "Edit app",
  Monat: wke,
  Jahr: vke,
  Buchung: Rke,
  "Stripe Subscription": "Stripe Subscription",
  "Bezahlt?": "Paid?",
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Confirmation failed. The entered names do not match.",
  "Einstiegs-Produkt": "Initial product",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "Stripe ID",
  Parameter: Xke,
  "Partner?": "Partner?",
  Kunden: Hke,
  ID: kke,
  Rechnungen: Fke,
  Leer: Yke,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "The complete client will be exported - including all assets. Continue?",
  Wechseln: xke,
  "Mandant unwiderruflich löschen": "Delete client irrevocably",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "The complete client will be deledted irrevocably - including all assets. Did you export it?. Continue?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Please confirm the name of the client to be deleted:",
  Nutzer: Dke,
  "Mandant erfolgreich gelöscht": "Client deleted successfully",
  "Mandanten editieren": "Edit client",
  Rolle: Jke,
  Konfiguratoren: Kke,
  Händleraktivierungen: "Dealer activations",
  Startdatum: Eke,
  Enddatum: Nke,
  Schritte: Lke,
  Werte: Tke,
  Regeln: Mke,
  Regelzeilen: Uke,
  Modelle: Pke,
  Materialien: zke,
  Gelöscht: "Deleted",
  Merkmal: Oke,
  Regel: Qke,
  Nummer: jke,
  Status: _ke,
  Erstellt: $ke,
  Zurücklegen: "Put back",
  Mindestlänge: "Min {{chars}} chars required",
  "Email Adresse ist ungültig": "Email address is invalid",
  Kennwort: qke,
  "Test stimmt nicht überein": "Test does not match",
  "Telefonnummer ist ungültig": "Phone number is invalid",
  "Entwickler Modus": "Developer Mode",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Gives developers access to advanced capabilities",
  "API Token": "API Token",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "On creation of a new token, all others are deleted.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Thus all shops get disconnected.",
  "Sie können das Token im Shop-Plugin eintragen.": "Put the token into the shop plugin.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Please take a note of the token, it is only displayed once.",
  Neu: eFe,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "The ApiToken gives a store or your custom development access to your configurators data...",
  "Sie möchten über die API auf den K3 zugreifen?": "Would you like to access the K3 via the API?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Then you must book a corresponding product for at least one of your configurators.",
  "Neuen Nutzer anlegen": "Create new user",
  Eingabe: tFe,
  "E-Mail nicht valide!": "Email not valid!",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "We will send the new user an e-mail with a link. There he can set his password and then he will get access to your configurator..",
  "Nutzer einladen": "Invite User",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "This user will gain access to your client.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Please check the information you have provided:",
  Einladen: iFe,
  "Benutzer einladen": "Invite users",
  "new user": "New User",
  "CSS-Datei auswählen": "Choose CSS file",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Do you want to use dynamic models to sell customised products?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "The model with {{curr}} triangles is exceeding the recommended amount of {{max}} triangles. This may lead to problems in AR mode.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "The model's file size of {{curr}}MB is exceeding the recommended file size of {{max}}MB.",
  "3D-Modell auswählen": "Choose 3D-Model",
  Download: nFe,
  Hintergrundmodell: gFe,
  "material-upload": "material-upload",
  Favoriten: rFe,
  "main-model": "main-model",
  "Wirft Schatten": "Casts shadows",
  "Wird schattiert": "Receives shadows",
  "Bilder Galerie": "Image Gallery",
  Anlegen: oFe,
  "Neue Aktion": "New Action",
  Preiseinstellungen: IFe,
  "Preise im Konfigurator ausblenden?": "Hide prices?",
  Hauptaktion: lFe,
  Kontaktformular: sFe,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "You may receive notifications about but not actually view customer orders",
  Pflichtfeld: aFe,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'You may include links as <a href="https://your-domain.com/privacy.html" target="_blank">Privacy</a>.',
  Aktionsname: cFe,
  "Shop verbinden": "Connect shop",
  "Überschrift Bestätigung": "Confirmation title",
  "Text Bestätigung": "Confirmation text",
  "Link zur Konfiguration zeigen?": "Show link to configuration?",
  "Thumbnail des Konfigurators": "Configurator Thumbnail",
  "Artikel hat keinen Namen und keine Nummer!": "Artikel hat keinen Namen und keine Nummer!",
  "Kein Artikel ausgewählt!": "No item selected!",
  "Artikel auswählen": "Select article",
  "Artikelanzahl und Menge": "Number of items and quantity",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "How often the corresponding item should be added",
  Anzahl: dFe,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Bill of materials relevant, for example for the length of a post",
  "Menge (optional)": "Quantity (optional)",
  Anzahlberechnung: CFe,
  Mengenberechnung: uFe,
  Artikelaktion: AFe,
  "Wert eingeben": "Enter value",
  "Neue Spalte": "New column",
  "Wert-Eigenschaft": "Value property",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "You can give properties to the values of this characteristic, for example, weight or grade or power. You can enter these properties separately for each value and then output them to the user. But you can also use these properties to make rules and calculations much simpler..",
  "Eigenschaft wird dem Nutzer angezeigt": "property is displayed to the user",
  "mehrsprachiger Text": "multilingual text",
  "nicht übersetzter Text": "untranslated text",
  Zahl: bFe,
  Einheit: mFe,
  "Fokus auf Modelle": "Focus on models",
  "Alle Modelle": "All models",
  "Fokus über Objektnamen": "Focus on object names",
  Fokustyp: hFe,
  "Dynamischer Fokus": "Dynamic focus",
  "Statischer Fokus": "Static focus",
  "Screenshot Auflösung": "Screenshot resolution",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Necessary difference to the current view",
  "Aktuelle Ansicht übernehmen und Speichern": "Accept current view and save",
  "Kamera bearbeiten": "Edit camera",
  "Noch keine Kamera gespeichert": "No camera saved yet",
  Kamera: pFe,
  Schritt: BFe,
  Kameraansicht: ZFe,
  "Kamera speichern": "Save Camera",
  "Bitte auswählen": "Please select",
  Ausgewählt: "Selected",
  "Merkmal setzen: ": "Set characteristic: ",
  "Keine Farbe ausgewählt!": "No color selected!",
  "Farbe auswählen": "Select colour",
  "Farbmerkmal auswählen:": "Select color feature:",
  "Keine Auswahl": "No selection",
  "Hoch schieben": "Move up",
  "Runter schieben": "Move down",
  Duplizieren: fFe,
  "Löschen des aktiven Elements nicht möglich": "The currently active element cannot be deleted",
  "Komponente hinzufügen": "Add component",
  Entfernen: GFe,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Your configuration could not be saved.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Please excuse. We have saved the configuration in this browser. Please come back later.",
  "technische Information:": "technical information:",
  Auswahlen: yFe,
  "Preis: ": "Price: ",
  "Kameras für Bestellungsbilder": "Cameras for order images",
  Kameras: WFe,
  "Anfrage erhalten": "Request received",
  "Buchung erfolgreich": "Booking successful",
  "Für das neue Produkt melden wir uns bei Ihnen.": "We will contact you regarding the new product.",
  "Ihre Subskription wurde angepasst.": "Your subscription has been updated.",
  "Ihre Subskription wurde beendet.": "Your subscription was cancelled.",
  "Das Produkt wurde gebucht.": "The product has been booked.",
  "Meine Rechnungen": "My invoices",
  "Auf Anfrage": "On request",
  Kostenfrei: SFe,
  "{{fee}},- EUR pro {{interval}}": "{{fee}},- EUR per {{interval}}",
  "Derzeit gebucht.": "Now booked.",
  "Änderung Ihrer Buchung": "Booking update",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "You are booking a new product. Continue?",
  Downgrade: VFe,
  "Zahlungsplan ändern": "Change payment plan",
  "Ihre K3 Buchung": "Your K3 booking",
  Monatlich: wFe,
  Jährlich: "Yearly",
  "In neuem Tab öffnen": "Open in new tab",
  "Konfigurator anpassen": "Customize Configurator",
  "main drawer": "This is a preview of your configurator. Click on an edit icon to change something, or:",
  "Ändern Sie die Bestelloptionen": "Change the order options",
  "Ändern Sie das Design": "Change the design",
  "Passen sie die 3D Szene an": "Customize the 3D scene",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Save the current camera for order images",
  "Merkmale verwalten": "Manage features",
  "Nutzen Sie die Hilfe": "Use the help",
  "So richten Sie Ihren Konfigurator ein:": "This is how you set up the configurator:",
  Home: vFe,
  Hilfe: RFe,
  "dealer sidebar": "Dealer sidebar",
  "change design": "Change design",
  "change logo": "Change logo",
  "change price": "Change price",
  "change pdf": "Change PDF template",
  "PDF Gestaltung": "PDF Design",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Upload a PDF as a template for printing.",
  cancel: XFe,
  "app surcharge": "Set price surcharge",
  "you can change your surcharge here": "you can change your surcharge here",
  "Neuer Schritt": "New step",
  Icon: HFe,
  "Icon Bilddatei": "Icon image file",
  "Icon position": "Icon position",
  "Icon Größe": "Icon size",
  "Ersetze Weiter mit Aktionsauswahl": "Replace Next with Action Selection",
  "Aktionsnamen überschreiben": "Override action name",
  "Individuelles Design": "Custom design",
  "Merkmale editieren": "Edit characteristics",
  "Keine Ergebnisse": "No results",
  "Desktop Layout": "Desktop Layout",
  "Mobile Layout": "Mobile Layout",
  "Schritte nacheinander einblenden": "Show steps sequentially",
  "Besuchte Schritte abhaken": "Check off visited steps",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "You are currently using a no longer supported layout. Please select a new one.",
  "Dieses Layout selbst anpassen": "Customize this layout",
  "Eigenes Layout erstellen": "Customized Layout",
  "Angepasstes Layout anwenden": "Use customized layout",
  Schließen: "Close",
  Logo: kFe,
  "Konfigurator-Abschluss": "Configurator Finalisation",
  "3D Szene": "3D Scene",
  "Manuelle Einstellung erstellen": "Create manual setting",
  "Design & Theme": "Design & Theme",
  Farben: FFe,
  "Farbanpassungen zurücksetzten": "Reset color adjustments",
  CSS: YFe,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "You can also customize the look of your configurator using CSS:",
  "Link zur CSS-Datei": "Link to CSS file",
  "Oder laden Sie eine CSS Datei hoch:": "Or upload a CSS file:",
  "Neues Merkmal": "New Feature",
  "Merkmal kopieren": "Copy feature",
  Zurücksetzen: "Reset",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "You are resetting the configurator to the chosen version.",
  Einstellungen: xFe,
  "Dynamische Texte": "Dynamic texts",
  "Texte und Einstellungen anpassen": "Update labels and settings",
  Vorschau: DFe,
  Articles: JFe,
  Bestellungen: KFe,
  Statistics: EFe,
  "Inhalte: ": "Contents: ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': 'Before the configurator can be used, they must press the button "Publish". If you make changes after that, they will also take effect after the next publication.',
  "Live Version": "Live Version",
  Veröffentlichen: "Publish",
  "Erstelle Option: ": "Create option: ",
  Fehler: NFe,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "An error occured when rendering content.",
  Fatal_Error_Text: LFe,
  Fatal_Error: TFe,
  "Fehlermeldung:": "Error message:",
  "Zur Startseite": "To the home page",
  "Neu Laden": "Reload",
  "Cleanup und Neu Laden": "Cleanup and Reload",
  "You may need to reload the page": "You may need to reload the page",
  Error_Message: MFe,
  "(SU) Client wechseln": "(SU) Change client",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "The app has not been published. Accessing this configuration may lead to errors. Continue?",
  "Elemente löschen": "Elemente löschen",
  "Element löschen": "Delete element",
  "Selektierte Elemente löschen": "Selektierte Elemente löschen",
  "Alle selektierte Elemente löschen": "Alle selektierte Elemente löschen",
  "Lösch-Konflikte anzeigen": "Display deletion conflicts",
  "Das Element": "The item",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Do you really want to delete this item irreversibly?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "The following reasons speak against deletion:",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Einige Elemente werden noch an anderen Stellen verwendet:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} is still used in other places:",
  "{{label}} wird noch verwendet in ": "{{label}} is still used in ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "of an extension. Ask the developer to remove the usage and then delete the key.",
  "der Definition der Regel": "the definition of the rule",
  "einem Eintrag in Regel": "an entry in rule",
  "einer berechneten Eigenschaft des Modells": "a calculated property of the model",
  "der Formel von": "the formula of",
  "der Kamera": "the camera",
  "des Merkmals": "the feature",
  "des Schrittes": "the step",
  "der globalen Kamera": "the global camera",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Please delete the other references first.",
  "Neuen Schritt hinzufügen": "Create a new step",
  "Bitte legen Sie einen Schritt an!": "Please create a step!",
  "Schritt editieren": "Edit step",
  Bestelloptionen: UFe,
  "Merkmal editieren": "Edit feature",
  "Mehr Informationen anzeigen": "Show more information",
  "Nicht Aktiv": "Not active",
  "Keine Angabe": "No information",
  "Fokus:": "Focus:",
  "Fokus: ": "Focus: ",
  hiddenGroup: PFe,
  "Label eingeben": "Enter label",
  "Bilder auswählen": "Select images",
  "Ordner auswählen:": "Select folder:",
  "Bildmerkmal: ": "Image Feature: ",
  "Kein Bild ausgewählt": "No image selected",
  "Bild auswählen": "Select image",
  "Bildmerkmal auswählen:": "Select image feature:",
  Befüllt: "Filled",
  "Zustand auswählen": "Select State",
  "Kein Komponente ausgewählt!": "No component selected!",
  "Komponente auswählen": "Select component",
  "Intervall eingeben": "Enter Interval",
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen": "This selection can undo previous selections",
  "Zum Dashboard": "Go to dashboard",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Sets the primary colour (for tabs, buttons, etc.) and the contrast colour (button text)",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Sets the secondary colour (secondary buttons) and the contrast colour (button text)",
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Sets the regular text colour and the secondary colour (e.g. for descriptions)",
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Sets the regular background colour and that of the slightly highlighted areas (e.g. product properties)",
  "Setzt die Farbe der Info-Icons": "Sets the info icon colour",
  "Setzt die Farbe der Warnhinweise": "Sets the warning alert colour",
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Sets the error message and alert colour",
  Basiseinstellungen: zFe,
  "Helles Theme": "Bright Theme",
  "Erweiterte Einstellungen": "Advanced Settings",
  "Label hinzufügen: ": "Add Label: ",
  "Kein Label ausgewählt!": "No label selected!",
  "Was soll angezeigt werden?": "What should be displayed?",
  Maximalgröße: "Max size",
  Deckkraft: OFe,
  "Kein Material ausgewählt!": "No material selected!",
  "Material auswählen": "Select material",
  "Material auswählen:": "Select material:",
  Materialaktion: QFe,
  Farbaktion: jFe,
  Bildaktion: _Fe,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Restricting the effects to specific models",
  Hinzufügen: "Add",
  "Welches Teil soll hinzugefügt werden?": "Which part should be added?",
  Hinweis: $Fe,
  Achtung: qFe,
  Fortfahren: eYe,
  "Kein Modell ausgewählt!": "No model selected!",
  "Modell auswählen": "Select model",
  "Modell hinzufügen:": "Add Model:",
  "Globale Änderung": "Global Change",
  Oberflächen: "Surfaces",
  "Ausgewählte Oberflächen": "Selected surfaces",
  "Eintrag darf nicht leer sein.": "Entry must not be empty.",
  "Alle Werte": "All values",
  "Werte auswählen": "Select values",
  "Sortierung anwenden": "Apply sorting",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "The file format is not allowed! No file selected.",
  "Erlaubte Formate:": "Allowed formats:",
  "Keine Datei gewählt.": "No file selected.",
  "Datei konnte nicht hochgeladen werden.": "Datei konnte nicht hochgeladen werden.",
  "Dieses Merkmal ist nicht erlaubt.": "This characteristics is not permitted.",
  "Merkmal-Optionen": "Variable options",
  "Merkmal Beschreibung editieren": "Edit description",
  "Merkmal-Info editieren": "Edit Info",
  Versteckt: tYe,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "This characteristics is not displayed. However, its value can be used in rules and calculations.",
  "showSelection.label": "showSelection.label",
  "Aus Schritt verstecken": "Hide from step",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "This option only makes sense if the characteristic is shown or hidden at a different position via a custom layout. Even if it is hidden from the group in this way, it will still be assigned to it in summaries.",
  "Kamera-Optionen": "Camera options",
  "Vorlage wählen": "Choose template",
  "Konfigurator erstellen": "Create configurator",
  "Willkommen in Ihrem neuen K3 Konto!": "Welcome to your new K3 account!",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Set up your first configurator right away:",
  "Sie können alle Daten natürlich später noch ändern.": "You may change all data later again if necessary.",
  "Nicht veröffentlicht": "Not published",
  "Ladevorgang fehlgeschlagen": "Charging process failed",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "The configuration could not be loaded! Please try again later!",
  "Keine Optionen": "No options",
  "Neuen Artikel anlegen": "Create new article",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Create a new article with price",
  articleNo: iYe,
  articleName: nYe,
  currency: gYe,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Change positions",
  "Abbrechen durch Klick": "Click to cancel.",
  Wert: rYe,
  "Preis eingeben": "Enter price",
  Währung: "Currency",
  "Währung eingeben": "Enter currency",
  "Einheit eingeben": "Enter unit",
  "Startdatum eingeben": "Enter start date",
  "Enddatum eingeben": "Enter end date",
  Startanzahl: oYe,
  "Startanzahl eingeben": "Enter start count",
  Endanzahl: IYe,
  "Endanzahl eingeben": "Enter end number",
  Priorität: "Priority",
  "Priorität eingeben": "Enter priority",
  "Aufschlag?": "Markup?",
  "Preistyp eingeben": "Enter price type",
  "Neuer Preis": "New price",
  Suchen: lYe,
  Auswählen: "Auswählen",
  "Wählen Sie eine Vorlage aus:": "Choose a template:",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Or create a new configurator without a template: ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Do you want to create your configurator now?",
  "Wir bringen Sie danach direkt in den Editor.": "We will redirect you to the editor afterwards.",
  "Anlegen & zum Konfigurator": "Create & open Configurator",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: sYe,
  OK: aYe,
  "Farbenanzahl im Fenster": "Visible Colors",
  "Farbkachel Rundung": "Color tile rounding",
  Opazität: "Opacity",
  Hervorhebung: cYe,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Remove invalid instanced (instead of replacing them)",
  "Drag & Drop erlauben": "Allow drag & drop",
  "Anzeige der Sortierungsschaltflächen": "Display of sorting buttons",
  "Sortierung umkehren": "Reverse sorting",
  "Duplizierung erlauben": "Allow duplication",
  "Zeige Werte aus inneren Merkmalen an": "Display values from inner characteristics",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Always hide characteristic name from inner value preview, even if multiple selections exist",
  "Innere Merkmalsnamen ausblenden": "Hide characteristic name from inner value preview",
  "Als Warenkorb setzen?": "Set as shopping cart?",
  "Gruppieren nach": "Group by",
  "Komponenten direkt unter der Liste anzeigen": "Komponenten direkt unter der Liste anzeigen",
  Expression: dYe,
  "Erfolgreich gespeichert": "Saved successfully",
  "Formel Editor": "Formula Editor",
  "Geben Sie Formeln von Merkmalen ein.": "Enter formulas of characteristics",
  " Schreiben Sie z.B. Länge * Breite.": "Write, for example, length * width..",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "For an attribute, use for example Motor.Power, if Motor is its attribute and Power is the corresponding attribute...",
  Ergebnis: CYe,
  "Keine Formel eingegeben": "No formula entered",
  "Formel: ": "Formula: ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "There are not yet enough selections to display a preview.",
  "Ergebnis: ": "Result:",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "Hide original texture when printed?",
  "Erlaube Bildformate": "Allow image formats",
  "Minimum Horizontale Positionierung": "Minimum horizontal positioning",
  "Maximum Horizontale Positionierung": "Maximum horizontal positioning",
  "Minimum Vertikale Positionierung": "Minimum vertical positioning",
  "Maximum Vertikale Positionierung": "Maximum vertical positioning",
  "Minimale Skalierung": "Minimal scaling",
  "Maximale Skalierung": "Maximal scaling",
  Mindestwert: uYe,
  "-Unendlich": "-Infinity",
  Maximalwert: AYe,
  Unendlich: bYe,
  "Optionaler Standardwert": "Optional default value",
  Nachkommastellen: mYe,
  Schrittweite: hYe,
  "Zeige Knöpfe an": "Show buttons",
  "Benutze Vielfaches der Schrittweite": "Use multiples of the step size",
  Berechnet: pYe,
  "Zyklus Erkennung deaktivieren": "Deactivate cycle detection",
  Ändern: "Change",
  "Beispielhafte Beschreibung eines Wertes.": "Exemplary description of a value",
  "Dies ist nur eine Info": "This is just an info",
  "Color Dropdown": "Color Dropdown",
  "Color Radio": "Color Radio",
  "Color Radio Cards": "Color Radio Cards",
  Farbauswahl: BYe,
  Komponentenliste: ZYe,
  "Komponentenliste mit Popup": "Component list with popup",
  Komponentenkarten: fYe,
  Bildauswahl: GYe,
  Informationen: yYe,
  Zahleneingabe: WYe,
  "Radio Buttons": "Radio Buttons",
  "Radio Cards": "Radio Cards",
  "RAL-Farbauswahl": "RAL color selection",
  Dropdown: SYe,
  Thumbnails: VYe,
  Schalter: wYe,
  "Schalter Card": "Switch Card",
  Texteingabe: vYe,
  Beispieltext: RYe,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Automatically accept conflict resolution with individual features",
  "Übergeordnete Merkmale": "Parent features",
  "Darstellungs-Optionen": "Visualisation options",
  Optional: XYe,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': 'Under "Values" you will then find the special entry "no specification". Here you can still customize what should be displayed to the user if they have not selected anything.',
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "The selection will not be displayed in the confirmation, PDF or in the shop if not selected.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Show selection only if selected",
  "Konfigurator erfolgreich veröffentlicht.": "Configurator published successfully",
  "Folgende Änderungen werden veröffentlicht:": "The following changes will be published:",
  "Konfigurator veröffentlichen": "Publish configurator",
  "Sie möchten den Konfigurator veröffentlichen?": "Would you like to publish the configurator?",
  "Wertebereich angeben": "Specify value range",
  "Merkmale: ": "Features: ",
  "Aktionen: ": "Actions: ",
  "Diese Regel ist aktuell deaktiviert.": "This rule is currently deactivated.",
  "Modell Eigenschaften anpassen": "Customise model properties",
  Labelaktion: HYe,
  Fehlermeldung: kYe,
  "Merkmale entfernen": "Remove characteristics",
  "Merkmale ausblenden": "Hide characteristics",
  "Schritt entfernen": "Remove step",
  "Schritt ausblenden": "Hide step",
  "Werte ausblenden": "Hide values",
  Modelaktion: FYe,
  "Bitte fügen Sie neue Regelzeilen hinzu.": "Please add new rule lines.",
  "Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Otherwise this rule will not be considered in the evaluation...",
  "Keine Warnungen": "No warnings",
  "Selektions-Bearbeitung": "Selection editing",
  "Alle Regeln ansehen": "View all rules",
  Position: YYe,
  "Rotation (in radiant)": "Rotation (in radian)",
  Scale: xYe,
  "Regel Bearbeitung": "Rule editing",
  "Kein Label angegeben!": "No label given!",
  "Regel Validierung": "Rule Validation",
  "Fehlende Werte": "Missing values",
  "Aktive Schritte": "Active steps",
  Modell: DYe,
  Material: JYe,
  Komponenten: KYe,
  Druck: EYe,
  "Kein Modell": "No model",
  Regelname: NYe,
  "Wird angewendet": "Is applied",
  Gültigkeitsregeln: "Validity rules",
  "Gültigkeit prüfen?": "Check Validity?",
  Merkmalskombinationen: LYe,
  Produktstruktur: TYe,
  "Merkmale entfernen (veraltet)": "Remove characteristics (deprecated)",
  "Schritt entfernen (veraltet)": "Remove step (deprecated)",
  "Anzeige von 3D-Modellen": "Display 3D models",
  "Anzeige von Informationen": "Display information",
  "Anzeige von Fehlermeldungen": "Anzeige von Fehlermeldungen",
  "Austauschen von Oberflächen": "Replace surfaces",
  "Bilder auf Oberflächen drucken": "Print images on surfaces",
  Materialnamen: MYe,
  "Wählen Sie ein Materialnamen aus.": "Select a material name",
  "Ändern der Farbe": "Change the color",
  "Anzeige von Bildern": "Display images",
  "Preise & Artikel": "Prices & Articles",
  "Weitere Bedingungen": "Further conditions",
  "Artikel zur Stückliste hinzufügen": "Add items to the bill of materials",
  "Zugeordnete Merkmale": "Assigned characteristics",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Select the characteristics to be assigned to the articles",
  "Befüllen von Komponentenmerkmalen": "Fill component characteristics",
  Komponentenmerkmale: UYe,
  "Wählen Sie Komponentenmerkmale aus.": "Select component features.",
  "Oberflächenaktion hinzufügen": "Add surface action",
  "Alle auswählen": "Select all",
  "Alle abwählen": "Select none",
  "Auswahl umkehren": "Reverse selection",
  Herunterladen: PYe,
  "Jetzt verbinden": "Connect Now",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "The flexible shop system for your e-commerce project.",
  "Jetzt Installieren": "Install now",
  "Die globale Commerce-Plattform.": "The global commerce platform.",
  "Die E-Commerce-Plattform für WordPress.": "The e-commerce platform for WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "The one European open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Now Adobe Commerce: E-commerce made easy.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "First class in digital sales with the Oxid esales store.,",
  "Individuelle Entwicklung": "Custom development",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connect shop with custom development...",
  "Bitte nutzen Sie stattdessen unsere Shopify App.": "Please use our Shopify app instead.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "First download one of our plugins and install it in your store:",
  "Verbinde Shop": "Connect Shop",
  " und importiere Artikel": "and import articles",
  "Fehler beim Verbinden:": "Error connecting:",
  "Shop erfolgreich verbunden.": "Store successfully connected.",
  "Fehler beim Verbinden: ": "Error connecting: ",
  "Shop-Anbindung": "Shop connection",
  "Web-Adresse des Shops": "Web address of the store",
  "Shopify Admin API Key": "Shopify Admin API Key",
  "Sollen die Artikel aus dem Shop importiert werden?": "Should the items be imported from the store?",
  "Filter für Artikel": "Filter for articles",
  "Sollen die Artikel regelmäßig importiert werden?": "Should the items be imported regularly?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Should the item number be taken from the shop SKU?",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Should the items be grouped together when ordering?",
  "Basis-Name für kombinierte Artikel": "Base name for combined articles",
  "Ihre Bestellung {code}": "Your order {code}",
  "Shop-Anbindung aufheben": "Unlink the store",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Add the configurator to your store",
  Verbinden: zYe,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "The HTML Content could not be rendered. Please check your entered input.",
  "Der eingegebe Wert ist nicht gültig: ": "The entered value is not valid: ",
  "Ungültiges HTML-Format": "Invalid HTML format",
  "Sie können uns den Vorfall hier melden!": "You can report the incident here!",
  "Das Template konnte nicht geladen werden.": "Unable to load the template.",
  "Templat auf Voreinstellung zurücksetzen": "Reset Template to default",
  "Eingaben zurücksetzen": "Reset changes",
  "Templat bearbeiten": "Edit template",
  "Templat Name": "Template name",
  "Templat wählen": "Choose template",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Choose a template from the list to customize it. Or enter a custom name to create an individual template for later use.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "You have not created an individual template yet. To do so, choose a default template from the list and make your required changes.",
  "Templat hinzufügen": "Add template",
  "Ansicht auswählen": "Select view",
  "Datei hochladen": "Upload file",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Please book another product first:",
  "Bitte wählen": "Please select",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "This action combines several features and therefore cannot be changed here. Change the following rule(s) directly for this:",
  "Automatisch angelegt": "Automatically created",
  "Aktionen verknüpfen": "Link actions",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Values from this characteristic should trigger the following actions:",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "This characteristic cannot be used to control other operations. Please use the rules directly for this",
  "Zu den Regeln": "To the rules",
  "Artikel bestellen": "Order articles",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Depending on the selection, different articles will be added to the parts list.,",
  "Oberfläche ändern": "Change surface",
  "Welche Oberflächen sollen geändert werden? ": "Which surfaces should be changed? ",
  "3D-Modell anzeigen": "Show 3D model",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Depending on the selection, different 3D models will be displayed...",
  "Bild anzeigen": "Show image",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Depending on the selection different images are displayed",
  "Farbe ändern": "Change color",
  "Welche Oberflächen sollen eingefärbt werden? ": "Which surfaces should be colored? ",
  "Bild aufdrucken": "Print image",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "On which surfaces should the uploaded image be printed? ",
  "Der Wert wird noch in Regeln verwendet:": "The value is still used in rules:",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "First, please delete the corresponding line(s) there...",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Here you can set what should be displayed if no value has been selected yet",
  "Dieser Wert ist nicht erlaubt.": "This value is invalid.",
  "Maximale Anzahl an Werten ist erreicht.": "Maximum number of values reached.",
  Farbwert: OYe,
  Anzeige: QYe,
  RAL: jYe,
  "keine RAL Farbe": "no RAL colour",
  Ansicht: _Ye,
  "Key eingeben": "Enter Key",
  URL: $Ye,
  "Info-Modal": "Info-Modal",
  "Info-Content": "Info-Content",
  "Dieser Merkmalstyp unterstützt keine Werte.": "This characteristics type does not support values.",
  "Fehlende RAL Farben hinzufügen": "Add missing RAL colours",
  Auswahlwerte: qYe,
  Info: exe,
  "Typ des Merkmals": "Type of characteristic",
  "es gibt keine Merkmale mit {{identificator}}": "No characteristic {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "No attribute {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "No selection {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "there is more than one selection with {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "There is a cycle in the calculated characteristics: {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "the result of the formula must be a numerical value, instead it is {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "value {{paramName}} of the function {{functionName}} is zero",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "The characteristics {{variableLabel}} is a component list. You must access it with an index such as {{variableLabel2}}[0] for the 1st element or with an array function such as map(), find(), reduce() or first()",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "There is a cycle in the calculated characteristics.",
  Übersicht: "Overview",
  Auswahlpreise: txe,
  Auswahl: ixe,
  Gesamtpreis: nxe,
  "Preis Information": "Price Details",
  "Persönliche Daten": "Personal Data",
  Weiter: gxe,
  "In AR ansehen": "View in AR",
  Vollbildmodus: rxe,
  "Komponenten suchen": "Search for components",
  "Nicht Gruppiert": "Not grouped",
  "Komponenten hinzufügen": "Add components",
  xl: oxe,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Unfortunately, your input was not possible and was reset to the next possible value: ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "This value cannot be combined with the following selections:",
  "Bei Auswahl wird eine Alternative berechnet!": "If selected, an alternative will be calculated!",
  Bestätigen: "Confirm",
  "Produkt hinzufügen": "Add product",
  "Produkt erfolgreich konfiguriert": "Product has been configured successfully",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "The configuration is complete. Which product would you like to add to your shopping cart now?",
  "Neues Produkt auswählen": "Select new product",
  "Neues Produkt hinzufügen": "Add new product",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'The selection "{{value}}" ({{variable}}) leads to the invalid value "{{conflictValue0}}" ({{conflictVariable0}}) and is therefore reset.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Message when resetting an invalid selection",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'The selection "{{value}}" ({{variable}}) does not match the selection "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Message when one conflict occured",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'The selection "{{value}}" ({{variable}}) does not match the selection "{{conflictValue0}}" ({{conflictVariable0}}) and the selection "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Message when two conflicts occured",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Message for occurence of three or more conflicts",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'The selection "{{value}}" ({{variable}}) does not match the selection "{{conflictValue0}}" ({{conflictVariable0}}), the selection "{{conflictValue1}}" ({{conflictVariable1}}) and the selection "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': 'The selection "{{value}}" ({{variable}}) does not match other selections.',
  Konfliktmeldung: Ixe,
  "Anpassung nötig": "Adjustment",
  "Stattdessen werden folgende Auswahlen angepasst:": "Instead the following selections will be adapted:",
  "wird zu": "is becoming",
  "wird entfernt": "will be removed",
  "Optionaler weiterer Hinweistext:": "Optional additional information text:",
  "Auf Facebook teilen": "Share on Facebook",
  "Auf Twitter teilen": "Share on Twitter",
  "Auf LinkedIn teilen": "Share on LinkedIn",
  "Modal Titel": "Modal Title",
  "Desktop Gerät erkannt": "Desktop device detected",
  "Modal Text": "Modal Body",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented reality is currently only available on current iOS or androidOS smartphones. Therefore, simply scan this QR code with the camera app of your smartphone:",
  "Mobiles {{device}}-Gerät erkannt": "Mobile {{device}}-Device detected",
  "Fortschrittsanzeige 3D-Objekt": "Progress info 3D Object",
  "Export des 3D-Objekts": "Exporting the 3D object",
  "Fortschrittsanzeige AR-Datei": "Progress info AR file",
  "Bereitstellen der AR-Datei": "Deploying the AR file",
  "Fortschrittsanzeige System": "Progress info System",
  "{{device}}-AR-System einrichten": "Setting up {{device}} AR system",
  Positionszeile: lxe,
  "Pos.": "Item",
  "Artikelnummer Spalte": "Articlenumber column",
  "Artikel Spalte": "Article column",
  "Artikelpreis Spalte": "Article price column",
  "Artikelmenge Spalte": "Article amount column",
  Menge: sxe,
  "Artikelanzahl Spalte": "Article count column",
  "Positionspreis Spalte": "Item price column",
  Positionspreis: axe,
  "Hilfetext Preisdetails": "Help text for price details",
  "Preisdetails anzeigen": "Display price details",
  "Titel bei Versions-Konflikt": "Title in case of version conflict",
  "Konfigurator wurde aktualisiert": "Configurator has been updated",
  "Text bei Versions-Konflikt": "Text in case of version conflict",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Since you saved this configuration, the configurator has been upgraded. Do you want to use the current version and continue working or open the old version for viewing only?.",
  "Alte Version": "Old version",
  "Aktuelle Version": "Current version",
  "Zeige Namen": "Show Name",
  "Zeige Beschreibung": "Show Description",
  "Zeige Thumbnail": "Show Thumbnail",
  "Zeige Preis an Merkmal": "Show characteristic price",
  "Zeige Preise an Werten": "Show value prices",
  "Zeige URL": "Show URL",
  "Zeige Info-Button für Werte": "Show Info Button for Values",
  "Zeige HTML Content für Werte": "Show HTML Content for all values",
  "Kamerafahrt beim scrollen": "Camera change when scrolling",
  "Alle ungültigen Werte ausblenden": "Hide all invalid values",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Hide invalid, actively changed, values",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Hide if only one selection is possible",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Disable if only one selection is possible",
  "Komponente hervorheben": "Emphasise component",
  Bild: cxe,
  Text: dxe,
  "Ja/ Nein": "Yes/ No",
  Information: Cxe,
  Mehrfachauswahl: uxe,
  Liste: Axe,
  Eckenrundung: bxe,
  "Anzahl der Eckenrundungsschritte": "Anzahl der Eckenrundungsschritte",
  "Dieses Material existiert bereits": "This material already exists",
  "Material hinzufügen": "Add material",
  "Materialname eingeben": "Enter material name",
  Abmessungen: mxe,
  Breite: hxe,
  Höhe: "Height",
  Tiefe: pxe,
  Startpunkt: Bxe,
  Endpunkt: Zxe,
  Linienstärke: "Line thickness",
  Startanker: fxe,
  Maßkette: "Dimensional chain",
  Ohne: Gxe,
  Endanker: yxe,
  Texttyp: Wxe,
  "Kein Text": "No text",
  Zahlenwert: Sxe,
  "Statischer Text": "Static text",
  "Automatisches Maß überschreiben": "Override automatic dimension",
  "Neues Maß": "New dimension",
  "Textgröße als Faktor. 1 ist Standard.": "Text size as a factor. 1 is standard.",
  Offsets: Vxe,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Here, deviations from position and rotation, which normally result from start and end point, can be defined. For this purpose, the 3D positioning tool can be used.",
  "Nicht Befüllt": "Not assigned",
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Maximum number of iterations for the expression engine reached! There are too complex cycles in the calculated features.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximum number of iterations reached! The rule conflicts cannot be resolved."
}, vxe = "List", Rxe = "Colors", Xxe = "Text", Hxe = "Yes/No", kxe = "Information", Fxe = "Image", Yxe = "Components", xxe = "Presentation", Dxe = "Actions", Jxe = "Values", Kxe = "Rules", Exe = "Options", Nxe = "Images", Lxe = "Configurators", Txe = "Article", Mxe = "Front", Uxe = "Clockwise", Pxe = "MATERIAL", zxe = "Import", Oxe = "Manual", Qxe = "Accept", jxe = "Rotation", _xe = "General", $xe = "Texture", qxe = "Roughness", e5e = "Metallness", t5e = "Image stack", i5e = "Scene settings", n5e = "Themes", g5e = "Customization", r5e = "Value range", o5e = "Presentation", I5e = "Values", l5e = "Requests", s5e = "Time", a5e = "Request", c5e = "URI", d5e = "Parameters", C5e = "Duration", u5e = "Server", A5e = "Users", b5e = "Support", m5e = "System Status", h5e = "Others", p5e = "Help", B5e = "Consulting", Z5e = "Subscription", f5e = "Profile", G5e = "Trash", y5e = "Log Out", W5e = "Fullscreen", S5e = {
  always: "Always",
  never: "Never",
  auto: "Like in the configurator",
  label: "Display in confirmation, pdf and shop"
}, V5e = "Activate", w5e = "Deactivate", v5e = "Characteristics and Articles", R5e = "Characteristics only", X5e = "Articles only", H5e = "No Overview", k5e = "Rule Entries", F5e = "General", Y5e = "PDF", x5e = "Mail", D5e = "Embed", J5e = "Shop", K5e = "Articles", E5e = "Preview", N5e = "Editor", L5e = "Images", T5e = "Materials", M5e = "Models", U5e = "Rules", P5e = "Options", z5e = "Admin", O5e = "Extract", Q5e = "Configurators", j5e = "Create", _5e = "Import", $5e = "Users", q5e = "Support", eDe = "Logs", tDe = "System Status", iDe = "Trash", nDe = "Subscription", gDe = "Expired", rDe = "Profile", oDe = "Editor", IDe = "Configurations", lDe = "Tabs", sDe = "Features", aDe = "Design", cDe = "Scene", dDe = "Presentation", CDe = "Options", uDe = "Actions", ADe = "Values", bDe = "Highlighted", mDe = "Ctrl", hDe = "Replace", pDe = "Order", BDe = {
  list: vxe,
  color: Rxe,
  text: Xxe,
  boolean: Hxe,
  information: kxe,
  image: Fxe,
  components: Yxe,
  presentation: xxe,
  usage: Dxe,
  values: Jxe,
  rules: Kxe,
  settings: Exe,
  images: Nxe,
  configurators: Lxe,
  article: Txe,
  "create new dealer": "Create New Dealer",
  Vorne: Mxe,
  Uhrzeiger: Uxe,
  "Artikel Anzahl": "Article Quantity",
  "Farb auswählen": "Select color",
  "< Zurück": "< Back",
  "Reiter - Rechts": "Tabs - Right",
  "Reiter - Links": "Tabs - Left",
  "Flyaway Reiter - Links": "Flyaway Tabs - Left",
  "Einfach - Links": "Simple - Left",
  "Akkordeons - Rechts": "Accordions - Right",
  "Fullscreen Formular": "Fullscreen Form",
  "Merkmal auswählen": "Choose feature",
  MATERIAL: Pxe,
  Import: zxe,
  "Materialien für den Import auswählen:": "Choose materials to import:",
  "Wie möchten Sie ein Material erstellen?": "How do you like to create a material?",
  "Import einer .glb und export der enthaltenen Materialien": "Import of a .glb und export of contained materials",
  Manuell: Oxe,
  "Eigenständiges Anlegen eines PBR-Materials": "Manually create a PBR-Material",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Please delete the corresponding column there first",
  Akzeptieren: Qxe,
  "Design & Layout": "Design & Layout",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Only visible in preview mode or published configurator!",
  "Theme wählen": "Choose Theme",
  "Komponente löschen": "Delete component",
  "Mehrfach Regelzeilen Bearbeitung": "Multiple rule lines editing",
  "Anzahl ausgewählte Regel-Zeilen:": "Number of selected rule lines:",
  "Modelaktions-Positionierung": "Model action positioning",
  Rotation: jxe,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "No actions available for multiple editing",
  Allgemeines: _xe,
  "Farben und Lichtinteraktion": "Colors and light interaction",
  "Color-Map Upload": "Color map upload",
  "Material interagiert mit Licht in der Szene": "Material interacts with light in the scene",
  Beschaffenheit: $xe,
  "Roughness-Map Upload": "Roughness map upload",
  Roughness: qxe,
  "Metallness-Map Upload": "Metallness Map Upload",
  Metallness: e5e,
  "Normalen-Map Upload": "Normality Map Upload",
  "Normalen-Skalierung": "Normality Scaling",
  "Anwendung auf 3D-Modell": "Application to 3D model",
  "Displacement-Map Upload": "Displacement Map Upload",
  "Displacement-Skalierung": "Displacement Scaling",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Repeat factor of texture in X and Y direction",
  "Alpha-Werte": "Alpha values",
  "Alpha-Map Upload": "Alpha map upload",
  "Ambient Occlusion": "Ambient Occlusion",
  "Ambient-Occlusion-Map Upload": "Ambient Occlusion Map Upload",
  "Info editieren": "Edit Info",
  "Zeige Info-Button": "Show Info Button",
  "An Shop senden": "Send to shop",
  "Javascript Event senden": "Send javascript event",
  "PDF herunterladen oder versenden": "Save or send PDF",
  "PDF Dokument (optional)": "PDF document (optional)",
  "Interne E-Mail-Adresse": "Internal email address",
  "Interne E-Mail senden": "Send internal email",
  "PDF an interne E-Mail anhängen": "Attach PDF to internal email",
  "PDF Dokument für interne E-Mail (optional)": "PDF document for internal email (optional)",
  "Kunden-Email senden": "Send Customer Email",
  "PDF an Kunden-Email anhängen": "Attach PDF to customer Email",
  "PDF Dokument für Kunden-Email (optional)": "PDF document for customer email (optional)",
  "UST-ID": "Sales tax identification number",
  "Datenschutz-Hinweis": "Privacy",
  "E-mail": "Email",
  Abhängigkeitsschleifen: "Dependency Loops",
  Bilderstapel: t5e,
  "Google Analytics Property ID": "Google Analytics Property ID",
  "Sans Serif": "Sans Serif",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "The flexible store system for your e-commerce project...",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "The one European open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Now Adobe Commerce: E-commerce made easy",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "First class in digital sales with the Oxid esales store.,",
  "Individuelle Entwicklung": "Custom development",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connect shop with custom development...",
  Szeneneinstellungen: i5e,
  Themes: n5e,
  Anpassung: g5e,
  "Gewähltes Theme übernehmen": "Apply selected theme",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Create a new configuration step.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "A configuration is done in several steps. In each step, several product properties can be specified if necessary. Here you create the first step",
  "Konfigurationsschritt erstellen": "Create configuration step",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Please click here first, to create a new configurator",
  "Neuer Konfigurator wählen": "Select new configurator",
  "Bitte geben Sie einen Namen ein.": "Please enter a name",
  "Bitte geben Sie eine Beschreibung ein.": "Please enter a description",
  "Bitte klicken Sie hier.": "Please click here",
  "Konfigurator Dialog aufrufen": "Call configurator dialog",
  "Konfigurationsschritt benennen": "Name configuration step",
  "Hier können Sie neue Werte hinzufügen.": "Here you can add new values",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Characteristics that are a list (or color, material, model) show several values for selection. You can enter these values here",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Click here to create a new value",
  "Wenn Sie fertig sind klicken Sie hier.": "When you are done click here",
  "Werte erstellen": "Create values",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Please enter a name for the new feature",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Please select a presentation that matches the feature's capabilities.,",
  "Präsentation definieren": "Define presentation",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "In one step your customer can customize several features of his product. Insert the first feature here...",
  "Produktmerkmal erstellen": "Create product feature",
  "Was für ein Merkmal wollen Sie anlegen?": "What kind of feature do you want to create?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "A feature can be a selection (e.g. sizes S, M, L and XL), a text or a number (e.g. for a width or height) or even a color or material of your product or a 3D model representing a part of your product",
  "Produktmerkmaltyp auswählen": "Select product feature type",
  "Wählen sie den eben erstellten Konfigurator.": "Select the configurator you just created.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Control the configurator by the new feature.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Features can e.g. cause 3D models or images to be displayed or surfaces to be changed or colored. You can also create a parts list of items, which then determines the price and can be placed in the shopping cart of your store..",
  "Merkmal verwenden": "Use feature",
  Wertebereich: r5e,
  Darstellung: o5e,
  Werte: I5e,
  Anfragen: l5e,
  Zeitpunkt: s5e,
  Anfrage: a5e,
  URI: c5e,
  Parameter: d5e,
  Dauer: C5e,
  Server: u5e,
  "Modell bearbeiten": "Update model",
  "Korrekte Mail-Adresse": "Correct mail address",
  "Statistik (30 Tage)": "Statistics (30 days)",
  "Datum eingeben": "Enter date",
  "Nach hause ": "Home ",
  "Mandant anlegen": "Create client",
  "Nutzer hinzufügen": "Add user",
  Benutzerkonten: A5e,
  Support: b5e,
  Systemstatus: m5e,
  Andere: h5e,
  Dokumentation: p5e,
  Beratung: B5e,
  Abonnement: Z5e,
  "Jetzt K3 buchen": "Book K3 now",
  Profil: f5e,
  Papierkorb: G5e,
  Logout: y5e,
  "Die globale Commerce-Plattform": "The global ecommerce platform",
  Fullscreen: W5e,
  showSelection: S5e,
  "Kamera überschreiben": "Override camera",
  Aktivieren: V5e,
  Deaktivieren: w5e,
  Übersichtsseite: "Overview Page",
  variablesAndArticles: v5e,
  variablesOnly: R5e,
  articlesOnly: X5e,
  noOverview: H5e,
  Regelzeilen: k5e,
  "Händler: Bestellung weiterleiten": "Dealer: Forward order",
  "Wird nicht im Konfigurator angezeigt": "not shown in frontend",
  "Dateiname des Pdfs (optional)": "Filename of the pdf (optional)",
  "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "I have read and accept the privacy policy.",
  "Die Mail-Adresse muss zum Senden freigeschaltet werden - bitte melden Sie sich bei uns.": "The email address must be activated for sending - please contact us.",
  breadcrumb_app: F5e,
  breadcrumb_pdf: Y5e,
  breadcrumb_mail: x5e,
  breadcrumb_embed: D5e,
  breadcrumb_shop: J5e,
  breadcrumb_articles: K5e,
  breadcrumb_preview: E5e,
  breadcrumb_edit: N5e,
  breadcrumb_images: L5e,
  breadcrumb_materials: T5e,
  breadcrumb_models: M5e,
  breadcrumb_rules: U5e,
  breadcrumb_settings: P5e,
  breadcrumb_admin: z5e,
  breadcrumb_extract: O5e,
  breadcrumb_apps: Q5e,
  breadcrumb_create: j5e,
  breadcrumb_import: _5e,
  breadcrumb_users: $5e,
  breadcrumb_support: q5e,
  breadcrumb_logs: eDe,
  breadcrumb_systemStatus: tDe,
  breadcrumb_trash: iDe,
  breadcrumb_abonnement: nDe,
  breadcrumb_expired: gDe,
  breadcrumb_profile: rDe,
  breadcrumb_configurator: oDe,
  breadcrumb_configurations: IDe,
  breadcrumb_groups: lDe,
  breadcrumb_variables: sDe,
  breadcrumb_design: aDe,
  breadcrumb_scene: cDe,
  breadcrumb_presentation: dDe,
  breadcrumb_options: CDe,
  breadcrumb_usage: uDe,
  breadcrumb_values: ADe,
  "Letzter Schritt kann nicht gelöscht werden.": "Last step cannot be deleted.",
  "Dieses Merkmal ist versteckt.": "This feature is hidden.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `This feature is only visible in the admin panel. This can have several causes: 
 1. It was removed by rule. 
 2. The associated step was removed.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "This feature is only visible in the admin panel: The feature has no selection options.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "This feature is no longer visible because it has no valid selection!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "This feature is no longer visible because it has only one valid selection!",
  "Vertikale Platzierung zulassen?": "Allow vertical placement?",
  Paper: bDe,
  "Content Main": "Canvas Background",
  "Scrollbar Default": "Scrollbar Color",
  "Suchfeld ausblenden?": "Hide searchbar?",
  Modalgröße: "Modal size",
  "Anzahl an Komponenten pro Zeile": "Number of components per row",
  "Weitere Preisauswirkungen dieser Selektion": "Additional price adjustments by this selection",
  "Aktion verstecken": "Hide Action",
  Ctrl: mDe,
  Ersetzen: hDe,
  "Bild hochladen": "Upload image",
  "Das Dateiformat ist nicht erlaubt!": "The file format is not allowed!",
  Bestellen: pDe,
  "Straße und Hausnummer": "Street and number"
}, ZDe = {
  ...wxe,
  ...BDe
}, fDe = "Client", GDe = "Produit", yDe = "Condition de paiement", WDe = "Clients", SDe = "Configurateurs", VDe = "Support", wDe = "Revendeur", vDe = "Utilisateur", RDe = "Corbeille à papier", XDe = "Autres", HDe = "Liens", kDe = "Aide", FDe = "Conseil", YDe = "Statut", xDe = "Abonnement", DDe = "Profil", JDe = "Déconnexion", KDe = "Template", EDe = "Appeler", NDe = "PDF", LDe = "Code", TDe = "Prix", MDe = "Inspiration", UDe = "Action", PDe = "Langue", zDe = "Client", ODe = "Contenu", QDe = "Version du configurateur", jDe = "Annuler", _De = "Fermer", $De = "Éditer", qDe = "Adresse", eJe = "Protection des données", tJe = "Nom", iJe = "Email", nJe = "Téléphone", gJe = "Remarque", rJe = "Société", oJe = "Accepte", IJe = "Ville", lJe = "Code Postal", sJe = "Date", aJe = "Revendeur", cJe = "json", dJe = "Prix", CJe = "Options", uJe = "Action de commande", AJe = "Type", bJe = "Configuration", mJe = "AR", hJe = "Partagé", pJe = "afficher", BJe = "Triage", ZJe = "Numéro d'article", fJe = "Description", GJe = "Catégorie", yJe = "Prix", WJe = "Importer", SJe = "Article", VJe = "Téléchargement", wJe = "Pas de", vJe = "Tous les", RJe = "Images", XJe = "Rugosité", HJe = "Métallique", kJe = "Transparent", FJe = "Opacité", YJe = "Couleur", xJe = "Emissif", DJe = "Page", JJe = "Page d'accueil", KJe = "Face arrière", EJe = "Les deux côtés", NJe = "Transmission", LJe = "Réflectivité", TJe = "Couche claire", MJe = "Options", UJe = "Désignation", PJe = "Rendu basé sur la physique (PBR)", zJe = "Physique", OJe = "Clé", QJe = "Modèle", jJe = "Élargi", _Je = "Éditer", $Je = "Copier", qJe = "Exportation", eKe = "Généralités", tKe = "Langues", iKe = "Présentation du produit", nKe = "Mise à niveau", gKe = "Modèle principal", rKe = "Modèle", oKe = "Tutoriel", IKe = "Caractéristiques", lKe = "Réduction", sKe = "Service", aKe = "Enregistrer", cKe = "Intégrer", dKe = "Langue de référence", CKe = "Police de caractères", uKe = "Helvetica", AKe = "Courrier", bKe = "Interstate", mKe = "Montserrat", hKe = "Liens", pKe = "A droite", BKe = "En haut", ZKe = "En bas", fKe = "En-tête", GKe = "Mail", yKe = "Boutique", WKe = "Envoyer", SKe = "Commandes", VKe = "Date", wKe = "Jours", vKe = "Nom de l'article", RKe = "Article", XKe = "Configurations", HKe = "Configurateur", kKe = "Partner", FKe = "Provision", YKe = "Créer", xKe = "Nom", DKe = "E-mail", JKe = "Compte d'utilisateur", KKe = "Nom d'utilisateur", EKe = "Mot de passe", NKe = "S'inscrire", LKe = "Enregistrement", TKe = "Politique de confidentialité", MKe = "CGV", UKe = "Mot de passe", PKe = "Éditeur", zKe = "Standard", OKe = "Version", QKe = "Réservations", jKe = "Plate-forme", _Ke = "Intervalle", $Ke = "Utilisateur", qKe = "Abonnement", eEe = "ID du client", tEe = "Actif", iEe = "Depuis", nEe = "Question", gEe = "Actions", rEe = "Type", oEe = "Mois", IEe = "Année", lEe = "Réservation", sEe = "Paramètres", aEe = "Clients", cEe = "ID", dEe = "Factures", CEe = "Vide", uEe = "Changer", AEe = "Utilisateur", bEe = "Rôle", mEe = "Configurateurs", hEe = "Date de début", pEe = "Date de fin", BEe = "Étapes", ZEe = "Valeurs", fEe = "Règles", GEe = "Lignes de règles", yEe = "Modèles", WEe = "Matériaux", SEe = "Caractéristique", VEe = "Règle", wEe = "Numéro", vEe = "Statut", REe = "Créé", XEe = "Mot de passe", HEe = "Nouveau", kEe = "Entrée", FEe = "Inviter", YEe = "Télécharger", xEe = "Modèle de fond", DEe = "Favoris", JEe = "Créer", KEe = "Paramètres de prix", EEe = "Action principale", NEe = "Formulaire de contact", LEe = "Champ obligatoire", TEe = "Nom de l'action", MEe = "Nombre", UEe = "Calcul du nombre", PEe = "Calcul de la quantité", zEe = "Action d'articles", OEe = "Nombre", QEe = "Unité", jEe = "Type de mise au point", _Ee = "Caméra", $Ee = "Étape", qEe = "Vue de la caméra", e9e = "Dupliquer", t9e = "Entfernen", i9e = "Sélections", n9e = "Caméras", g9e = "Gratuit", r9e = "Mise à niveau vers le bas", o9e = "Mensuel", I9e = "Accueil", l9e = "Aide", s9e = "Annuler", a9e = "Icône", c9e = "Logo", d9e = "Couleurs", C9e = "CSS", u9e = "Paramètres", A9e = "Aperçu", b9e = "Article", m9e = "Commandes", h9e = "Statistiques", p9e = "Erreur", B9e = "Malheureusement, une erreur inconnue s'est produite. Si un nouveau chargement de la page ne résout pas le problème, contacte-nous.", Z9e = "Erreur inconnue", f9e = "Message d'erreur :", G9e = "Options de commande", y9e = "Cette étape n'est actuellement visible que dans le panneau d'administration, car elle ne contient pas de caractéristiques avec des valeurs sélectionnables.", W9e = "Paramètres de base", S9e = "Opacité", V9e = "Action matérielle", w9e = "Action couleur", v9e = "Action photo", R9e = "Note", X9e = "Attention", H9e = "Continuer", k9e = "Caché", F9e = "Numéro d'article", Y9e = "Nom", x9e = "Monnaie", D9e = "Valeur", J9e = "Nombre de départs", K9e = "Nombre final", E9e = "Rechercher", N9e = "Titel", L9e = "OK", T9e = "Mise en évidence", M9e = "Expression", U9e = "Résultat", P9e = "Valeur minimale", z9e = "Valeur maximale", O9e = "Infini", Q9e = "Chiffres après la virgule", j9e = "Pas à pas", _9e = "Calcule", $9e = "Choix de la couleur", q9e = "Liste des composants", eNe = "Cartes de composants", tNe = "Sélection d'images", iNe = "Informations", nNe = "Saisie de chiffres", gNe = "Dropdown", rNe = "Vignettes", oNe = "Interrupteur", INe = "Saisie de texte", lNe = "Exemple de texte", sNe = "En option", aNe = "Action de labellisation", cNe = "Fehlermeldung", dNe = "Action de modélisation", CNe = "Position", uNe = "Scale", ANe = "Modèle", bNe = "Matériel", mNe = "Composants", hNe = "Impression", pNe = "Nom de la règle", BNe = "Combinaisons de caractéristiques", ZNe = "Structure du produit", fNe = "Noms des matériaux", GNe = "Caractéristiques des composants", yNe = "Télécharger", WNe = "Connecter", SNe = "Valeur de la couleur", VNe = "Annonce", wNe = "RAL", vNe = "Vue", RNe = "URL", XNe = "Valeurs de sélection", HNe = "Info", kNe = "Prix de sélection", FNe = "Sélection", YNe = "Prix total", xNe = "Continue", DNe = "Plein écran", JNe = "xl", KNe = "Déclaration de conflit", ENe = "Ligne de position", NNe = "Quantité", LNe = "Prix par poste", TNe = "Image", MNe = "Texte", UNe = "Information", PNe = "Sélection multiple", zNe = "Liste", ONe = "Arrondissement des angles", QNe = "Dimensions", jNe = "Large", _Ne = "Profondeur", $Ne = "Point de départ", qNe = "Point final", eLe = "Ancre de démarrage", tLe = "Sans", iLe = "Ancrage d'extrémité", nLe = "Type de texte", gLe = "Valeur numérique", rLe = "Offsets", oLe = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Tu ne paies pas en ligne. Contacte la personne de ton entreprise qui a conclu le contrat avec ObjectCode.",
  Mandant: fDe,
  Produkt: GDe,
  Bezahlzustand: yDe,
  Mandanten: WDe,
  apps: SDe,
  support: VDe,
  "dealer-profile": "Profil du revendeur",
  dealers: wDe,
  users: vDe,
  trash: RDe,
  others: XDe,
  links: HDe,
  help: kDe,
  consultation: FDe,
  status: YDe,
  subscription: xDe,
  profile: DDe,
  logout: JDe,
  "Neuer Konfigurator": "Nouveau configurateur",
  Template: KDe,
  Zurück: "Retour",
  Aufrufen: EDe,
  PDF: NDe,
  Code: LDe,
  Preis: TDe,
  Inspiration: MDe,
  Aktion: UDe,
  Sprache: PDe,
  Händler: "Revendeur",
  "Sie möchten die Daten dieses Kunden einsehen?": "Tu souhaites consulter les données de ce client ?",
  Kunde: zDe,
  Inhalt: ODe,
  "Shop-API": "API de la boutique",
  "Gespeichert am": "Sauvé le",
  Konfiguratorversion: QDe,
  Abbrechen: jDe,
  "Ergebnis der Shop API": "Résultat de l'API de la boutique",
  Schliessen: _De,
  Bearbeiten: $De,
  Adresse: qDe,
  Datenschutz: eJe,
  Name: tJe,
  Email: iJe,
  Telefon: nJe,
  Bemerkung: gJe,
  Firma: rJe,
  "Steuer-ID": "Numéro d'identification fiscale",
  Akzeptiert: oJe,
  Stadt: IJe,
  PLZ: lJe,
  Datum: sJe,
  "exit-action": "Action de commande",
  dealer: aJe,
  "order-status": "Statut",
  json: cJe,
  price: dJe,
  options: CJe,
  Bestellaktion: uJe,
  Typ: AJe,
  Konfiguration: bJe,
  AR: mJe,
  Geteilt: hJe,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Tu souhaites consulter les données de tes clients ?",
  "Preise anlegen": "Créer des prix",
  anzeigen: pJe,
  "Artikel und Preise erfolgreich importiert.": "Articles et prix importés avec succès.",
  Sortierung: BJe,
  Artikelnummer: ZJe,
  "Artikelnummer eingeben": "Saisir le numéro de l'article",
  "Namen eingeben": "Saisir le nom",
  Beschreibung: fJe,
  "Beschreibung eingeben": "Entrer la description",
  Kategorie: GJe,
  "Kategorien eingeben": "Saisir les catégories",
  Preise: yJe,
  "Sortierung erfolgreich angewendet.": "Tri appliqué avec succès.",
  "Fehler beim Anwenden der Sortierung: ": "Erreur lors de l'application du tri : ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Article et prix publiés avec succès.",
  "Fehler beim Veröffentlichen: ": "Erreur lors de la publication: ",
  "Sie möchten Preise anzeigen?": "Tu veux afficher les prix ?",
  Importieren: WJe,
  "Neuer Artikel": "Nouvel article",
  Löschen: "Supprimer",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Publie l'application pour pouvoir publier des articles et des prix.",
  "Artikel und Preise veröffentlichen": "Publier des articles et des prix",
  Artikel: SJe,
  Upload: VJe,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Télécharge une ou plusieurs images dans le dossier indiqué. Tu peux utiliser la barre oblique (/) pour créer des dossiers plus profonds.",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Sinon, tu peux télécharger une archive ZIP avec une structure de dossier.",
  "Ordner *": "Dossier *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': `N'oublie pas : toutes les images dans un dossier sont regroupées en tant que galerie, triées par nom. Utilise donc des noms de fichiers comme "image_001".`,
  Keine: wJe,
  Alle: vJe,
  Bilder: RJe,
  Roughness: XJe,
  Metalness: HJe,
  Transparent: kJe,
  Opacity: FJe,
  Farbe: YJe,
  Emissive: xJe,
  "Color Map": "Couleur Texture",
  "Normal Map": "Texture normale",
  "Roughness Map": "Rugosité Texture",
  "Metalness Map": "Texture métallique",
  "Alpha Map": "Texture Alpha",
  Seite: DJe,
  Vorderseite: JJe,
  Hinterseite: KJe,
  Beidseitig: EJe,
  "Texture repeat": "Répétition de la texture",
  "Depth Write": "Depth Write",
  Transmission: NJe,
  Reflectivity: LJe,
  ClearCoat: TJe,
  "Clearcoat Roughness": "Rugosité du vernis",
  "new-material": "Nouveau matériel",
  Optionen: MJe,
  Bezeichnung: UJe,
  Pbr: PJe,
  Physikalisch: zJe,
  Key: OJe,
  "AR Fallback Material": "Matériel de retombée AR",
  "Nicht ausgewählt": "Non sélectionné",
  Model: QJe,
  Erweitert: jJe,
  "Nur in Regeln verwendete Materialien anzeigen": "Afficher uniquement les matériaux utilisés dans les règles",
  "extract-materials": "Extraire les matériaux du modèle",
  Editieren: _Je,
  Kopieren: $Je,
  "Neues Modell": "Nouveau modèle",
  "Dynamisches Modell": "Modèle dynamique",
  Gültigkeit: "Validité",
  "Neue Regel": "Nouvelle règle",
  "Neue Regel Erstellen": "Créer une nouvelle règle",
  "Regel erstellen": "Créer une règle",
  "Erfolgreich importiert": "Importé avec succès",
  "Hier importieren Sie eine vorab exportierte Datei.": "Ici, vous importez un fichier précédemment exporté.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "Cela remplacera toutes les données de ce configurateur.",
  "Auch der Papierkorb wird gelöscht.": "La corbeille sera également vidée.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "Cette opération ne peut pas être annulée.",
  "Sind Sie sicher?": "Tu es sûr ?",
  "JSON Export Datei": "Fichier d'exportation JSON",
  Export: qJe,
  "app-code-duplicate": "Le code de l'application est déjà utilisé",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "Les paramètres de l'application n'ont pas pu être enregistrés. Le code est déjà utilisé.",
  Allgemein: eKe,
  Sprachen: tKe,
  "Die erste Sprache gilt als Standard.": "La première langue est considérée comme standard.",
  "Die Beschreibung dieses Konfigurators": "La description de ce configurateur",
  "Link zum Konfigurator": "Lien vers le configurateur",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Si tu utilises une extension, indique ici où ton développeur la met à disposition.",
  Produktdarstellung: iKe,
  "3D-Modell": "Modèle 3D",
  "Bilder-Konfigurator": "Configurateur d'images",
  "Google Analytics 4 Property ID": "Google Analytics 4 ID de propriété",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Tu dois obtenir l'accord de l'utilisateur pour le cookie Google. Cela ne se passe pas à l'intérieur de K3 !",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Tu veux connecter ton compte Analytics ?",
  Upgrade: nKe,
  Hauptmodell: gKe,
  "Hauptmodell entfernen": "Supprimer le modèle principal",
  Vorlage: rKe,
  "Dieser Konfigurator dient als Vorlage": "Ce configurateur sert de modèle",
  Tutorial: oKe,
  "Standard übernehmen": "Adopter le standard",
  "screenshot-quality": "Capture d'écran Qualité",
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Vous pouvez indiquer ici une URL vers laquelle différentes données sont envoyées dès que l'utilisateur effectue une sélection. Vous avez ainsi la possibilité d'afficher des informations spéciales à l'aide du composant CustomData dans le Layout Designer (par ex. indiquer les frais de livraison, etc.).",
  "Preis & Info Service": "Service Prix & Info",
  "Hilfe dazu finden Sie hier.": "Vous trouverez de l'aide ici.",
  "URL für den Service, der die Daten verarbeitet": "URL du service qui traite les données",
  "Debounce in ms": "Débattement en ms",
  Merkmale: IKe,
  "Merkmale und ihre aktuelle Auswahlen senden": "Envoyer les caractéristiques et leurs sélections actuelles",
  "Optionale Merkmalbeschränkung": "Limitation facultative des caractéristiques",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "En option, limitez les caractéristiques qui seront envoyées.",
  "Artikel & Preis": "Article & prix",
  "Aktuell ausgewählte Artikel senden": "Envoyer les articles actuellement sélectionnés",
  "Aktuellen Preis senden": "Envoyer le prix actuel",
  "to dealer app": "Vers l'application pour les commerçants",
  "Händler hat Zugriff": "Le commerçant a accès",
  "Händler hat keinen Zugriff": "Le commerçant n'a pas accès",
  "dealer query": "Préférences",
  "Händler legt Aufschlag fest": "Le commerçant fixe la majoration",
  discount: lKe,
  surcharge: sKe,
  "Sie stornieren nun eine Händlerlizenz.": "Vous annulez maintenant une licence de revendeur.",
  "Händlerzugriff beenden": "Quitter l'accès revendeur",
  "Sie buchen nun eine Händlerlizenz.": "Vous réservez maintenant une licence de revendeur.",
  "Händlerzugriff buchen": "Réserver l'accès revendeur",
  Speichern: aKe,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Tu veux que tes distributeurs puissent utiliser ton configurateur ?",
  "Keine Händler vorhanden": "Aucun revendeur disponible",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Crée d'abord un revendeur - puis donne-lui accès à l'application ici.",
  "Jetzt Händler anlegen": "Créer des commerçants maintenant",
  Einbetten: cKe,
  "Als Link": "En tant que lien",
  "Als IFrame": "Comme IFrame",
  "Meldungen beim Laden anpassen": "Personnaliser les messages de chargement",
  "Bitte Auth0 Zugangsdaten angeben": "Veuillez indiquer les données d'accès Auth0",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "Vous souhaitez n'autoriser l'accès au configurateur qu'à certains utilisateurs ? Dans ce cas, vous pouvez utiliser le service Auth0.",
  "Konfigurator-Zugang": "Accès au configurateur",
  "Anmeldung für Konfigurator verlangen.": "Demander une connexion pour le configurateur.",
  "Auth0 Domain": "Domaine Auth0",
  "Auth0 ClientId": "ClientId Auth0",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Langue de référence. Les entrées doivent correspondre à la colonne de référence dans le fichier importé pour être prises en compte.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Mauvais format de fichier, assure-toi d'utiliser le format du fichier exporté pour la langue de référence actuellement sélectionnée.",
  "Importiere XLSX": "Importer XLSX",
  "Exportiere XLSX": "Exporter XLSX",
  Referenzsprache: dKe,
  "Werden berücksichtigt:": "Seront pris en compte",
  "Versteckte Merkmale": "Caractéristiques cachées",
  "Unbenutzte Sprachen": "Langues inutilisées",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Tu souhaites envoyer des demandes par e-mail à tes clients et/ou à toi-même ?",
  "Mail Texte": "Textes de mail",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Ici, tu peux adapter le contenu des mails envoyés. Lis au préalable la section dans la documentation.",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Attention : tu dois toujours publier le configurateur avant d'utiliser les textes modifiés.",
  Schriftart: CKe,
  Helvetica: uKe,
  "Times Roman": "Times Roman",
  Courier: AKe,
  Interstate: bKe,
  Montserrat: mKe,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Bold",
  Schriftgröße: "Taille de la police",
  Links: hKe,
  Rechts: pKe,
  Oben: BKe,
  Unten: ZKe,
  Kopfzeile: fKe,
  Fußzeile: "Pied de page",
  "Neue PDF Vorlage auswählen": "Choisir un nouveau modèle PDF",
  "Vorhandene PDF Vorlage löschen": "Supprimer un modèle PDF existant",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Tu souhaites envoyer des confirmations ou des offres au format PDF?",
  "PDF Einstellungen": "Paramètres PDF",
  Seitenränder: "Marges",
  "Voransicht mit dieser Konfiguration:": "Prévisualisation avec cette configuration :",
  "und diesem Template:": "et ce modèle :",
  "Speichern und drucken": "Enregistrer et imprimer",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "Pour pouvoir imprimer un aperçu, il faut disposer d'une configuration enregistrée.",
  Mail: GKe,
  Shop: yKe,
  "Social Sharing": "Partage social",
  "Wir helfen gern!": "Nous sommes heureux de t'aider !",
  "Ihre Telefonnummer": "Ton numéro de téléphone",
  "Ihre Nachricht": "Ton message",
  Senden: WKe,
  "Nachricht senden": "Envoyer un message",
  "Rückruf erbitten": "Demander à être rappelé",
  orders: SKe,
  date: VKe,
  "Preise wurden in den Einstellungen deaktiviert": "Les prix ont été désactivés dans les paramètres",
  "Keine Einnahmen vorliegend": "Pas de recettes en jeu",
  "total-earnings": "Recettes totales",
  Tage: wKe,
  articlename: vKe,
  articles: RKe,
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'Tu peux exporter un configurateur sous "Paramètres". Tu peux réimporter le fichier obtenu ici.',
  "Leerer Konfigurator": "Configurateur vide",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Commence avec un configurateur vide et configure-le comme tu le souhaites.",
  "Konfigurator importieren": "Importer le configurateur",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importe un configurateur à partir d'un fichier exporté.",
  Veröffentlicht: "Publié",
  Konfigurationen: XKe,
  "Mandant hat noch keinen Konfigurator": "Le client n'a pas encore de configurateur",
  Konfigurator: HKe,
  "Link kopiert": "lien copié",
  "E-Mail": "E-mail",
  "Werben Sie K3 Kunden!": "Parrainez des clients K3!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Transmettez le lien ci-dessous. Si votre contact réserve un configurateur, vous recevrez une commission.",
  Partner: kKe,
  Provision: FKe,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Veuillez noter que tout lien d'affiliation émis deviendra invalide une fois que vous aurez modifié le code.",
  "Meine Kunden": "Mes clients",
  "Vielen Dank für Ihre Bestätigung...": "Merci beaucoup pour ta confirmation...",
  "E-Mail Bestätigung": "Confirmation par e-mail",
  "Zur Anmeldung": "Vers l'inscription",
  Händlerprofil: "Profil du revendeur",
  Erstellen: YKe,
  name: xKe,
  email: DKe,
  "E-Mail ist ungültig!": "L'e-mail n'est pas valide !",
  Nutzerkonto: JKe,
  Nutzername: KKe,
  "Mail ist schon vergeben": "Mail est déjà pris",
  "code-duplicate": "Ce code est déjà pris",
  "dealer code helper text": "Pour accéder au configurateur du revendeur.",
  "default discount": "remise par défaut",
  "Kann pro Konfigurator überschrieben werden.": "Peut être écrasé par configurateur.",
  "default surcharge": "surcharge par défaut",
  "Pro Abo": "Par abonnement",
  "is pro dealer": "Peut utiliser le configurateur sur son propre site web et adapter le design",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Merci de vérifier les informations que tu as fournies : ",
  "Fehlendes Produkt": "Produit manquant",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Tu veux que tes distributeurs puissent utiliser un de tes configurateurs ?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Réserve d'abord un autre produit.",
  "new dealer": "Nouveau distributeur",
  "Login screen": "Inscription",
  "Bitte am Desktop öffnen": "Ouvrir sur le bureau",
  Password: EKe,
  Login: NKe,
  "Passwort vergessen?": "Mot de passe oublié ?",
  "Noch kein Konto?": "Pas encore de compte ?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Une connexion n'a malheureusement pas été possible. La combinaison de l'e-mail et du mot de passe n'est pas valide.",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Une connexion n'a malheureusement pas été possible. Veuillez autoriser les cookies du site web dans les paramètres de votre navigateur.",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Si le mail n'arrive pas dans les minutes qui suivent, regarde aussi dans ton dossier SPAM et vérifie ton adresse.",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "Nous t'enverrons un e-mail avec des instructions pour mettre en place un nouveau mot de passe.",
  "Mail senden": "Envoyer un mail",
  Registrierung: LKe,
  "Ihre E-Mail-Adresse": "Ton adresse e-mail",
  "Bitte wählen Sie ein Kennwort": "Choisis un mot de passe",
  "Bitte bestätigen Sie unsere ": "Merci de confirmer notre ",
  Datenschutzbestimmungen: TKe,
  " und unsere ": " et nos ",
  AGB: MKe,
  "Jetzt registrieren": "S'inscrire maintenant",
  "Die Registrierung war leider nicht möglich.": "Malheureusement, l'inscription n'a pas été possible.",
  "Herzlich willkommen!": "Bienvenue à toi !",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "Nous t'avons envoyé un e-mail - regarde aussi dans ton dossier spam.",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Mais tu peux aussi t'inscrire dès maintenant avec tes données :",
  "Wir haben Ihr Kennwort neu gesetzt.": "Nous avons réinitialisé ton mot de passe.",
  "Passwort setzen": "Définir un mot de passe",
  Passwort: UKe,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Au moins 8 caractères, majuscules, minuscules et chiffres",
  Bestätigung: "Confirmation",
  "Bestätigung stimmt nicht überein": "La confirmation ne correspond pas",
  "Kennwort setzen": "Définir un mot de passe",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - le configurateur de produits 3D pour Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "Vous avez installé avec succès l'application Shopify pour le configurateur K3. Voici les prochaines étapes:",
  "Registrieren Sie sich am K3.": "Enregistrez-vous sur K3.",
  "Legen Sie einen Konfigurator an.": "Créez un configurateur.",
  "Jetzt starten": "Commencez maintenant",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Connectez le configurateur à votre boutique et importez vos articles Shopify.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Concevez le configurateur pour votre produit.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Ajoutez le configurateur à votre boutique.",
  Editor: PKe,
  "Mandant: ": "Client ",
  "Erstellt am: ": "Créé le ",
  "Veröffentlicht am: ": "Publié le ",
  "Noch nicht veröffentlicht": "Pas encore publié",
  "Version: ": "version : ",
  "Artikel-Version: ": "Version de l'article : ",
  "Code: ": "Code : ",
  "Typ: ": "Type : ",
  Standard: zKe,
  "Shop: ": "Boutique : ",
  "Nicht verbunden": "Non connecté",
  "Bestellungen insgesamt": "Total des commandes",
  Veröffentlichungen: "Publications",
  Version: OKe,
  "Artikel-Version": "Version de l'article",
  Buchungen: QKe,
  Plattform: jKe,
  Intervall: _Ke,
  Benutzer: $Ke,
  Subscription: qKe,
  CustomerID: eEe,
  Aktiv: tEe,
  Seit: iEe,
  "Abschlag [%]": "Réduction [%]",
  "Aufschlag [%]": "Supplément [%]",
  Query: nEe,
  Aktionen: gEe,
  "Mandanten wechseln": "Changer de client",
  "Konnte nicht gespeichert werden: ": "N'a pas pu être enregistré : ",
  Type: rEe,
  "Angelegt am": "Créé le",
  "Zum AdminPanel": "Vers l'AdminPanel",
  "App editieren": "Éditer l'app",
  Monat: oEe,
  Jahr: IEe,
  Buchung: lEe,
  "Stripe Subscription": "Abonnement Stripe",
  "Bezahlt?": "Payé ?",
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Échec de la confirmation. Les noms ne correspondent pas.",
  "Einstiegs-Produkt": "Produit d'entrée de gamme",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "ID de bande",
  Parameter: sEe,
  "Partner?": "Partenaire?",
  Kunden: aEe,
  ID: cEe,
  Rechnungen: dEe,
  Leer: CEe,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "Le mandant complet est exporté - y compris tous les actifs. Continuer?",
  Wechseln: uEe,
  "Mandant unwiderruflich löschen": "Supprimer le mandant de manière irrévocable",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "Le mandant complet est irrévocablement supprimé - y compris tous les actifs. Avez-vous réalisé une exportation? Continuer?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Veuillez confirmer le nom du mandant à supprimer:",
  Nutzer: AEe,
  "Mandant erfolgreich gelöscht": "Mandant supprimé avec succès",
  "Mandanten editieren": "Éditer des mandants",
  Rolle: bEe,
  Konfiguratoren: mEe,
  Händleraktivierungen: "Activations des commerçants",
  Startdatum: hEe,
  Enddatum: pEe,
  Schritte: BEe,
  Werte: ZEe,
  Regeln: fEe,
  Regelzeilen: GEe,
  Modelle: yEe,
  Materialien: WEe,
  Gelöscht: "Supprimé",
  Merkmal: SEe,
  Regel: VEe,
  Nummer: wEe,
  Status: vEe,
  Erstellt: REe,
  Zurücklegen: "Remettre",
  Mindestlänge: "Longueur minimale {{chars}} Caractères",
  "Email Adresse ist ungültig": "L'adresse e-mail n'est pas valide",
  Kennwort: XEe,
  "Test stimmt nicht überein": "Le test ne correspond pas",
  "Telefonnummer ist ungültig": "Le numéro de téléphone n'est pas valide",
  "Entwickler Modus": "Mode développeur",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Donne aux développeurs l'accès à des possibilités avancées.",
  "API Token": "Jeton API",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Si tu crées un nouveau jeton API, tous les précédents seront supprimés.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Ainsi, toutes les boutiques que tu as connectées perdent également l'accès au configurateur.",
  "Sie können das Token im Shop-Plugin eintragen.": "Tu peux inscrire le jeton dans le plugin de la boutique.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Note le nouveau jeton, il ne sera affiché ici qu'une seule fois.",
  Neu: HEe,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Grâce à l'ApiToken, une boutique ou ton développement individuel a accès aux données de tes configurateurs.",
  "Sie möchten über die API auf den K3 zugreifen?": "Vous souhaitez accéder au K3 via l'API ?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Dans ce cas, vous devez réserver un produit correspondant pour au moins un de vos configurateurs.",
  "Neuen Nutzer anlegen": "Créer un nouvel utilisateur",
  Eingabe: kEe,
  "E-Mail nicht valide!": "E-mail non valide !",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "Nous envoyons un e-mail au nouvel utilisateur avec un lien. Il pourra y définir son mot de passe et aura alors accès à ton configurateur.",
  "Nutzer einladen": "Inviter un utilisateur",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "L'utilisateur a accès à votre client.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Merci de vérifier les informations que tu as fournies :",
  Einladen: FEe,
  "Benutzer einladen": "Inviter des utilisateurs",
  "new user": "Nouvel utilisateur",
  "CSS-Datei auswählen": "Sélectionner le fichier CSS",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Tu souhaites utiliser des modèles dynamiques et les utiliser pour vendre des produits sur mesure, par exemple ?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Le modèle dépasse avec {{curr}} le nombre recommandé de {{max}} Triangles. Il se peut que tu aies des problèmes en mode AR.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Le modèle dépasse avec {{curr}}MB la taille de fichier recommandée de {{max}}MB",
  "3D-Modell auswählen": "Sélectionner un modèle 3D",
  Download: YEe,
  Hintergrundmodell: xEe,
  "material-upload": "material-upload",
  Favoriten: DEe,
  "main-model": "Modèle principal",
  "Wirft Schatten": "Jette des ombres",
  "Wird schattiert": "Est ombragé",
  "Bilder Galerie": "Galerie d'images",
  Anlegen: JEe,
  "Neue Aktion": "Nouvelle action",
  Preiseinstellungen: KEe,
  "Preise im Konfigurator ausblenden?": "Masquer les prix dans le configurateur ?",
  Hauptaktion: EEe,
  Kontaktformular: NEe,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Tu peux certes saisir ces données clients, mais tu ne peux pas les consulter.",
  Pflichtfeld: LEe,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'Tu peux inclure des liens vers tes propres documents avec <a href=N https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Informations sur la protection des données</a>.',
  Aktionsname: TEe,
  "Shop verbinden": "Connecter la boutique",
  "Überschrift Bestätigung": "Titre confirmation",
  "Text Bestätigung": "Texte confirmation",
  "Link zur Konfiguration zeigen?": "Montrer le lien vers la configuration ?",
  "Thumbnail des Konfigurators": "Vignette du configurateur",
  "Artikel hat keinen Namen und keine Nummer!": "Artikel hat keinen Namen und keine Nummer!",
  "Kein Artikel ausgewählt!": "Pas d'article sélectionné !",
  "Artikel auswählen": "Choisir un article",
  "Artikelanzahl und Menge": "Nombre et quantité d'articles",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "Combien de fois l'article correspondant doit être ajouté",
  Anzahl: MEe,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Pertinent pour la nomenclature, par exemple pour la longueur d'un poteau",
  "Menge (optional)": "Quantité (optionnel)",
  Anzahlberechnung: UEe,
  Mengenberechnung: PEe,
  Artikelaktion: zEe,
  "Wert eingeben": "Entrer la valeur",
  "Neue Spalte": "Nouvelle colonne",
  "Wert-Eigenschaft": "Propriété de la valeur",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Tu peux donner des propriétés aux valeurs de cette caractéristique, par exemple le poids ou la classe de qualité ou la performance. Tu peux saisir ces propriétés séparément pour chaque valeur et les afficher ensuite à l'utilisateur. Mais tu peux aussi utiliser ces propriétés pour rendre les règles et les calculs beaucoup plus simples.",
  "Eigenschaft wird dem Nutzer angezeigt": "La propriété est affichée à l'utilisateur",
  "mehrsprachiger Text": "Texte multilingue",
  "nicht übersetzter Text": "Texte non traduit",
  Zahl: OEe,
  Einheit: QEe,
  "Fokus auf Modelle": "Focus sur les modèles",
  "Alle Modelle": "Tous les modèles",
  "Fokus über Objektnamen": "Focus sur les noms d'objets",
  Fokustyp: jEe,
  "Dynamischer Fokus": "Mise au point dynamique",
  "Statischer Fokus": "Mise au point statique",
  "Screenshot Auflösung": "Capture d'écran Résolution",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Différence nécessaire par rapport à la vue actuelle",
  "Aktuelle Ansicht übernehmen und Speichern": "Reprendre la vue actuelle et enregistrer",
  "Kamera bearbeiten": "Modifier la caméra",
  "Noch keine Kamera gespeichert": "Pas encore de caméra enregistrée",
  Kamera: _Ee,
  Schritt: $Ee,
  Kameraansicht: qEe,
  "Kamera speichern": "Enregistrer la caméra",
  "Bitte auswählen": "Choisir s'il te plaît",
  Ausgewählt: "Choisi",
  "Merkmal setzen: ": "Mettre une caractéristique : ",
  "Keine Farbe ausgewählt!": "Pas de couleur choisie !",
  "Farbe auswählen": "Choisir la couleur",
  "Farbmerkmal auswählen:": "Sélectionner une caractéristique de couleur :",
  "Keine Auswahl": "Pas de sélection",
  "Hoch schieben": "Pousser vers le haut",
  "Runter schieben": "Pousser vers le bas",
  Duplizieren: e9e,
  "Löschen des aktiven Elements nicht möglich": "Impossible de supprimer l'élément actif",
  "Komponente hinzufügen": "Ajouter un composant",
  Entfernen: t9e,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Ta configuration n'a pas pu être enregistrée.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Veuillez nous excuser. Nous avons sauvegardé la configuration dans ce navigateur. Merci de revenir plus tard.",
  "technische Information:": "information technique :",
  Auswahlen: i9e,
  "Preis: ": "Le prix : ",
  "Kameras für Bestellungsbilder": "Caméras pour les photos de commande",
  Kameras: n9e,
  "Anfrage erhalten": "Recevoir une demande",
  "Buchung erfolgreich": "Réservation réussie",
  "Für das neue Produkt melden wir uns bei Ihnen.": "Pour le nouveau produit, nous te contacterons.",
  "Ihre Subskription wurde angepasst.": "Ta souscription a été adaptée.",
  "Ihre Subskription wurde beendet.": "Ta souscription est terminée.",
  "Das Produkt wurde gebucht.": "Le produit a été réservé.",
  "Meine Rechnungen": "Mes factures",
  "Auf Anfrage": "Sur demande",
  Kostenfrei: g9e,
  "{{fee}},- EUR pro {{interval}}": "{{fee}},- EUR par {{interval}}",
  "Derzeit gebucht.": "Actuellement réservé.",
  "Änderung Ihrer Buchung": "Modification de votre réservation",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "Tu vas maintenant réserver un nouveau produit. Tu veux continuer?",
  Downgrade: r9e,
  "Zahlungsplan ändern": "Modifier le plan de paiement",
  "Ihre K3 Buchung": "Ta réservation K3",
  Monatlich: o9e,
  Jährlich: "Annuellement",
  "In neuem Tab öffnen": "Ouvrir dans un nouvel onglet",
  "Konfigurator anpassen": "Personnaliser le configurateur",
  "main drawer": "Tu vois un aperçu de ton configurateur que tu peux utiliser comme d'habitude. Clique sur une icône de crayon pour modifier quelque chose ou :",
  "Ändern Sie die Bestelloptionen": "Modifie les options de commande",
  "Ändern Sie das Design": "Modifie le design",
  "Passen sie die 3D Szene an": "Ajuste la scène 3D",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Enregistre la caméra actuelle pour les images de commande",
  "Merkmale verwalten": "Gérer les caractéristiques",
  "Nutzen Sie die Hilfe": "Utilise l'aide",
  "So richten Sie Ihren Konfigurator ein:": "Voici comment configurer ton configurateur :",
  Home: I9e,
  Hilfe: l9e,
  "dealer sidebar": "Ici, tu peux configurer ton distributeur",
  "change design": "Modifie le design",
  "change logo": "Change le logo",
  "change price": "Change le prix",
  "change pdf": "Modifie le modèle PDF",
  "PDF Gestaltung": "Conception du PDF",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Télécharge un PDF comme modèle pour l'impression.",
  cancel: s9e,
  "app surcharge": "Définir la majoration",
  "you can change your surcharge here": "Ici, tu peux modifier ton supplément",
  "Neuer Schritt": "Nouvelle étape",
  Icon: a9e,
  "Icon Bilddatei": "Icône fichier image",
  "Icon position": "Position de l'icône",
  "Icon Größe": "Taille de l'icône",
  "Ersetze Weiter mit Aktionsauswahl": "Remplace Continue par Sélection d'action",
  "Aktionsnamen überschreiben": "Remplacer le nom de l'action",
  "Individuelles Design": "Design personnalisé en une seule étape",
  "Merkmale editieren": "Éditer les caractéristiques",
  "Keine Ergebnisse": "Aucun résultat",
  "Desktop Layout": "Mise en page du bureau",
  "Mobile Layout": "Mise en page mobile",
  "Schritte nacheinander einblenden": "Afficher les étapes une par une",
  "Besuchte Schritte abhaken": "Cocher les étapes visitées",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "Vous utilisez actuellement une mise en page qui n'est plus prise en charge. Veuillez en choisir une nouvelle.",
  "Dieses Layout selbst anpassen": "Adapter cette mise en page soi-même",
  "Eigenes Layout erstellen": "Créer sa propre mise en page",
  "Angepasstes Layout anwenden": "Appliquer une mise en page adaptée",
  Schließen: "Fermer",
  Logo: c9e,
  "Konfigurator-Abschluss": "Finalisation du configurateur",
  "3D Szene": "Scène 3D",
  "Manuelle Einstellung erstellen": "Créer un réglage manuel",
  "Design & Theme": "Design & thème",
  Farben: d9e,
  "Farbanpassungen zurücksetzten": "Réinitialiser les ajustements de couleurs",
  CSS: C9e,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Tu peux également personnaliser l'apparence de ton configurateur à l'aide de CSS :",
  "Link zur CSS-Datei": "Lien vers le fichier CSS",
  "Oder laden Sie eine CSS Datei hoch:": "Ou télécharge un fichier CSS :",
  "Neues Merkmal": "Nouvelle caractéristique",
  "Merkmal kopieren": "Copier la caractéristique",
  Zurücksetzen: "Réinitialiser",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "Vous réinitialisez le configurateur à la version choisie.",
  Einstellungen: u9e,
  "Dynamische Texte": "Textes dynamiques",
  "Texte und Einstellungen anpassen": "Adapter les textes et les paramètres",
  Vorschau: A9e,
  Articles: b9e,
  Bestellungen: m9e,
  Statistics: h9e,
  "Inhalte: ": "Contenu : ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': `Avant de pouvoir utiliser le configurateur, tu dois cliquer sur le bouton "Publier". Si tu fais des modifications après cela, elles ne prendront effet qu'après la prochaine publication.`,
  "Live Version": "Version live",
  Veröffentlichen: "Publier",
  "Erstelle Option: ": "Créer une option : ",
  Fehler: p9e,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "Une erreur est survenue lors du rendu du contenu.",
  Fatal_Error_Text: B9e,
  Fatal_Error: Z9e,
  "Fehlermeldung:": "Message d'erreur :",
  "Zur Startseite": "Vers la page d'accueil",
  "Neu Laden": "Nouveau magasin",
  "Cleanup und Neu Laden": "Nettoyer et recharger",
  "You may need to reload the page": "Recharger la page peut être nécessaire",
  Error_Message: f9e,
  "(SU) Client wechseln": "(SU) Changer de client",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "L'application n'a pas encore été publiée. Des erreurs peuvent donc se produire en ouvrant cette configuration. Continuer ?",
  "Elemente löschen": "Elemente löschen",
  "Element löschen": "Supprimer un élément",
  "Selektierte Elemente löschen": "Selektierte Elemente löschen",
  "Alle selektierte Elemente löschen": "Alle selektierte Elemente löschen",
  "Lösch-Konflikte anzeigen": "Afficher les conflits de suppression",
  "Das Element": "L'élément",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Tu veux vraiment supprimer cet élément de manière irréversible ?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "Les raisons suivantes s'opposent à la suppression :",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Einige Elemente werden noch an anderen Stellen verwendet:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} est utilisé à d'autres endroits :",
  "{{label}} wird noch verwendet in ": "{{label}} est encore utilisé dans ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "d'une extension. Demande au développeur de supprimer l'utilisation et supprime ensuite la clé.",
  "der Definition der Regel": "la définition de la règle",
  "einem Eintrag in Regel": "une entrée dans Règle",
  "einer berechneten Eigenschaft des Modells": "une propriété calculée du modèle",
  "der Formel von": "de la formule de",
  "der Kamera": "La caméra",
  "des Merkmals": "de la caractéristique",
  "des Schrittes": "du pas",
  "der globalen Kamera": "La caméra globale",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Supprime d'abord les autres références, s'il te plaît.",
  "Neuen Schritt hinzufügen": "Ajouter une nouvelle étape",
  "Bitte legen Sie einen Schritt an!": "Crée une étape, s'il te plaît !",
  "Schritt editieren": "Éditer l'étape",
  Bestelloptionen: G9e,
  "Merkmal editieren": "Éditer la caractéristique",
  "Mehr Informationen anzeigen": "Voir plus d'informations",
  "Nicht Aktiv": "Non actif",
  "Keine Angabe": "Aucune indication",
  "Fokus:": "Focus:",
  "Fokus: ": "Focus: ",
  hiddenGroup: y9e,
  "Label eingeben": "Entrer l'étiquette",
  "Bilder auswählen": "Choisir des images",
  "Ordner auswählen:": "Sélectionner un dossier :",
  "Bildmerkmal: ": "Caractéristique de l'image : ",
  "Kein Bild ausgewählt": "Pas d'image sélectionnée",
  "Bild auswählen": "Choisir une image",
  "Bildmerkmal auswählen:": "Sélectionner une caractéristique de l'image :",
  Befüllt: "Rempli",
  "Zustand auswählen": "Sélectionner l'état",
  "Kein Komponente ausgewählt!": "Aucun composant sélectionné !",
  "Komponente auswählen": "Sélectionner un composant",
  "Intervall eingeben": "Entrer l'intervalle",
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen": "Ce choix peut annuler des sélections déjà effectuées",
  "Zum Dashboard": "Vers le tableau de bord",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Définit la couleur primaire (pour les onglets, les boutons...) ainsi que la couleur de contraste (texte des boutons)",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Définit la couleur secondaire (boutons secondaires) ainsi que la couleur de contraste (texte du bouton)",
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Définit la couleur régulière du texte ainsi que la deuxième couleur (par exemple pour les descriptions).",
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Définit la couleur de fond régulière ainsi que celle des zones légèrement mises en évidence (par exemple les caractéristiques)",
  "Setzt die Farbe der Info-Icons": "Définit la couleur des icônes d'information",
  "Setzt die Farbe der Warnhinweise": "Définit la couleur des avertissements",
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Définit la couleur des messages et des indications d'erreur",
  Basiseinstellungen: W9e,
  "Helles Theme": "Thème clair",
  "Erweiterte Einstellungen": "Paramètres avancés",
  "Label hinzufügen: ": "Ajouter une étiquette : ",
  "Kein Label ausgewählt!": "Pas de label sélectionné !",
  "Was soll angezeigt werden?": "Qu'est-ce qui doit être affiché ?",
  Maximalgröße: "Taille maximale",
  Deckkraft: S9e,
  "Kein Material ausgewählt!": "Pas de matériel sélectionné !",
  "Material auswählen": "Choisir le matériel",
  "Material auswählen:": "Choisir le matériel",
  Materialaktion: V9e,
  Farbaktion: w9e,
  Bildaktion: v9e,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Limiter l'impact à certains modèles",
  Hinzufügen: "Ajouter",
  "Welches Teil soll hinzugefügt werden?": "Quelle partie ajouter ?",
  Hinweis: R9e,
  Achtung: X9e,
  Fortfahren: H9e,
  "Kein Modell ausgewählt!": "Pas de modèle sélectionné !",
  "Modell auswählen": "Choisir un modèle",
  "Modell hinzufügen:": "Ajouter un modèle :",
  "Globale Änderung": "Changement global",
  Oberflächen: "Surfaces",
  "Ausgewählte Oberflächen": "Finitions sélectionnées",
  "Eintrag darf nicht leer sein.": "L'entrée ne doit pas être vide.",
  "Alle Werte": "Toutes les valeurs",
  "Werte auswählen": "Sélectionner des valeurs",
  "Sortierung anwenden": "Appliquer le tri",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Le format de fichier n'est pas autorisé ! Aucun fichier sélectionné.",
  "Erlaubte Formate:": "Formats autorisés:",
  "Keine Datei gewählt.": "Aucun fichier sélectionné.",
  "Datei konnte nicht hochgeladen werden.": "Datei konnte nicht hochgeladen werden.",
  "Dieses Merkmal ist nicht erlaubt.": "Cette caractéristique n'est pas autorisée.",
  "Merkmal-Optionen": "Options des fonctionnalités",
  "Merkmal Beschreibung editieren": "Éditer la description",
  "Merkmal-Info editieren": "Éditer les infos",
  Versteckt: k9e,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Cette caractéristique n'est pas affichée. Mais la valeur peut être utilisée dans les règles et les calculs.",
  "showSelection.label": "showSelection.label",
  "Aus Schritt verstecken": "Cacher de l'étape",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "Cette option n'a de sens que si la caractéristique est affichée ou masquée à un autre endroit via un custom layout. Même si elle est cachée de l'étape, elle sera toujours associée à celle-ci dans les résumés.",
  "Kamera-Optionen": "Options de la caméra",
  "Vorlage wählen": "Choisir un modèle",
  "Konfigurator erstellen": "Créer un configurateur",
  "Willkommen in Ihrem neuen K3 Konto!": "Bienvenue dans ton nouveau compte K3 !",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Configure tout de suite ton premier configurateur :",
  "Sie können alle Daten natürlich später noch ändern.": "Tu peux bien sûr modifier toutes les données plus tard.",
  "Nicht veröffentlicht": "Non publié",
  "Ladevorgang fehlgeschlagen": "Échec du chargement",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "La configuration n'a pas pu être chargée ! Merci de réessayer plus tard !",
  "Keine Optionen": "Pas d'options",
  "Neuen Artikel anlegen": "Créer un nouvel article",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Ici, vous pouvez créer un nouvel article avec un prix.",
  articleNo: F9e,
  articleName: Y9e,
  currency: x9e,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Changer les positions",
  "Abbrechen durch Klick": "Cliquer pour annuler.",
  Wert: D9e,
  "Preis eingeben": "Saisir le prix",
  Währung: "Monnaie",
  "Währung eingeben": "Saisir la monnaie",
  "Einheit eingeben": "Entrer l'unité",
  "Startdatum eingeben": "Entrer la date de début",
  "Enddatum eingeben": "Entrer la date de fin",
  Startanzahl: J9e,
  "Startanzahl eingeben": "Saisir le nombre de départs",
  Endanzahl: K9e,
  "Endanzahl eingeben": "Entrer le nombre final",
  Priorität: "Priorité",
  "Priorität eingeben": "Entrer la priorité",
  "Aufschlag?": "Le service ?",
  "Preistyp eingeben": "Saisir le type de prix",
  "Neuer Preis": "Nouveau prix",
  Suchen: E9e,
  Auswählen: "Sélectionner",
  "Wählen Sie eine Vorlage aus:": "Choisis un modèle :",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Ou crée un nouveau configurateur sans modèle : ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Devons-nous créer ton configurateur maintenant ?",
  "Wir bringen Sie danach direkt in den Editor.": "Nous t'emmènerons ensuite directement dans l'éditeur.",
  "Anlegen & zum Konfigurator": "Créer & vers le configurateur",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: N9e,
  OK: L9e,
  "Farbenanzahl im Fenster": "Nombre de couleurs dans la fenêtre",
  "Farbkachel Rundung": "Carreau de couleur arrondi",
  Opazität: "Opacité",
  Hervorhebung: T9e,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Supprimer les instances devenues invalides (au lieu de les remplacer)",
  "Drag & Drop erlauben": "Autoriser le glisser-déposer",
  "Anzeige der Sortierungsschaltflächen": "Affichage des boutons de tri",
  "Sortierung umkehren": "Inverser le tri",
  "Duplizierung erlauben": "Autoriser la duplication",
  "Zeige Werte aus inneren Merkmalen an": "Affiche les valeurs des caractéristiques internes",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Toujours masquer le nom de la caractéristique des valeurs internes, même s'il y a plusieurs valeurs.",
  "Innere Merkmalsnamen ausblenden": "Masquer les noms de caractéristiques internes",
  "Als Warenkorb setzen?": "Mettre dans le panier ?",
  "Gruppieren nach": "Regrouper par",
  "Komponenten direkt unter der Liste anzeigen": "Afficher les composants directement sous la liste",
  Expression: M9e,
  "Erfolgreich gespeichert": "Enregistré avec succès",
  "Formel Editor": "Éditeur de la formule",
  "Geben Sie Formeln von Merkmalen ein.": "Saisis des formules de caractéristiques.",
  " Schreiben Sie z.B. Länge * Breite.": " Écris par exemple longueur * largeur.",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Par exemple, pour un attribut, utilise Moteur.Puissance si Moteur est sa caractéristique et Puissance l'attribut correspondant.",
  Ergebnis: U9e,
  "Keine Formel eingegeben": "Aucune formule saisie",
  "Formel: ": "Formule : ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Il n'y a pas encore assez de sélections pour afficher un aperçu.",
  "Ergebnis: ": "Résultat : ",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "Masquer la texture originale lors de l'impression ?",
  "Erlaube Bildformate": "Autoriser les formats d'image",
  "Minimum Horizontale Positionierung": "Positionnement horizontal minimum",
  "Maximum Horizontale Positionierung": "Positionnement horizontal maximal",
  "Minimum Vertikale Positionierung": "Positionnement vertical minimum",
  "Maximum Vertikale Positionierung": "Positionnement vertical maximal",
  "Minimale Skalierung": "Mise à l'échelle minimale",
  "Maximale Skalierung": "Mise à l'échelle maximale",
  Mindestwert: P9e,
  "-Unendlich": "-Infini",
  Maximalwert: z9e,
  Unendlich: O9e,
  "Optionaler Standardwert": "Valeur par défaut optionnelle",
  Nachkommastellen: Q9e,
  Schrittweite: j9e,
  "Zeige Knöpfe an": "Affiche les boutons",
  "Benutze Vielfaches der Schrittweite": "Utilise des multiples de pas",
  Berechnet: _9e,
  "Zyklus Erkennung deaktivieren": "Désactiver la détection de cycle",
  Ändern: "Changer",
  "Beispielhafte Beschreibung eines Wertes.": "Exemple de description d'une valeur.",
  "Dies ist nur eine Info": "Ceci n'est qu'une information",
  "Color Dropdown": "Sélection de couleur Dropdown",
  "Color Radio": "Choix de la couleur radio",
  "Color Radio Cards": "Cartes radio couleur",
  Farbauswahl: $9e,
  Komponentenliste: q9e,
  "Komponentenliste mit Popup": "Liste de composants avec popup",
  Komponentenkarten: eNe,
  Bildauswahl: tNe,
  Informationen: iNe,
  Zahleneingabe: nNe,
  "Radio Buttons": "Boutons radio",
  "Radio Cards": "Cartes radio",
  "RAL-Farbauswahl": "Choix de la couleur RAL",
  Dropdown: gNe,
  Thumbnails: rNe,
  Schalter: oNe,
  "Schalter Card": "Interrupteur Card",
  Texteingabe: INe,
  Beispieltext: lNe,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Accepter automatiquement la résolution des conflits avec des caractéristiques individuelles",
  "Übergeordnete Merkmale": "Caractéristiques parentales",
  "Darstellungs-Optionen": "Options d'affichage",
  Optional: sNe,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': `Sous Nvaleurs", tu trouveras l'entrée spéciale Npas d'indication". Ici, tu peux encore adapter ce que l'utilisateur doit voir s'il n'a rien sélectionné.`,
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "La sélection ne sera pas affichée dans la confirmation, le PDF ou la boutique si rien n'a été sélectionné.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Afficher la sélection uniquement si elle est sélectionnée",
  "Konfigurator erfolgreich veröffentlicht.": "Configurateur publié avec succès.",
  "Folgende Änderungen werden veröffentlicht:": "Les changements suivants sont publiés :",
  "Konfigurator veröffentlichen": "Publier le configurateur",
  "Sie möchten den Konfigurator veröffentlichen?": "Tu veux publier le configurateur ?",
  "Wertebereich angeben": "Indiquer la plage de valeurs",
  "Merkmale: ": "Caractéristiques : ",
  "Aktionen: ": "Actions : ",
  "Diese Regel ist aktuell deaktiviert.": "Cette règle est actuellement désactivée.",
  "Modell Eigenschaften anpassen": "Adapter les caractéristiques du modèle",
  Labelaktion: aNe,
  Fehlermeldung: cNe,
  "Merkmale entfernen": "Supprimer les caractéristiques",
  "Merkmale ausblenden": "Masquer les caractéristiques",
  "Schritt entfernen": "Supprimer l'étape",
  "Schritt ausblenden": "Masquer l'étape",
  "Werte ausblenden": "Masquer les valeurs",
  Modelaktion: dNe,
  "Bitte fügen Sie neue Regelzeilen hinzu.": "S'il te plaît, ajoute de nouvelles lignes de règles.",
  "Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Dans le cas contraire, cette règle ne sera pas prise en compte lors de l'évaluation.",
  "Keine Warnungen": "Pas d'avertissements",
  "Selektions-Bearbeitung": "Édition de la sélection",
  "Alle Regeln ansehen": "Voir toutes les règles",
  Position: CNe,
  "Rotation (in radiant)": "Rotation (en radian)",
  Scale: uNe,
  "Regel Bearbeitung": "Édition de la règle",
  "Kein Label angegeben!": "Pas de label indiqué !",
  "Regel Validierung": "Règle Validation",
  "Fehlende Werte": "Valeurs manquantes",
  "Aktive Schritte": "Démarches actives",
  Modell: ANe,
  Material: bNe,
  Komponenten: mNe,
  Druck: hNe,
  "Kein Modell": "Pas de modèle",
  Regelname: pNe,
  "Wird angewendet": "S'applique",
  Gültigkeitsregeln: "Règles de validité",
  "Gültigkeit prüfen?": "Vérifier la validité ?",
  Merkmalskombinationen: BNe,
  Produktstruktur: ZNe,
  "Merkmale entfernen (veraltet)": "Supprimer les caractéristiques (obsolète)",
  "Schritt entfernen (veraltet)": "Supprimer l'étape (obsolète)",
  "Anzeige von 3D-Modellen": "Affichage de modèles 3D",
  "Anzeige von Informationen": "Affichage d'informations",
  "Anzeige von Fehlermeldungen": "Anzeige von Fehlermeldungen",
  "Austauschen von Oberflächen": "Remplacer les surfaces",
  "Bilder auf Oberflächen drucken": "Imprimer des images sur des surfaces",
  Materialnamen: fNe,
  "Wählen Sie ein Materialnamen aus.": "Choisis un nom de matériau.",
  "Ändern der Farbe": "Changer la couleur",
  "Anzeige von Bildern": "Affichage d'images",
  "Preise & Artikel": "Prix et articles",
  "Weitere Bedingungen": "Autres conditions",
  "Artikel zur Stückliste hinzufügen": "Ajouter un article à la liste de pièces",
  "Zugeordnete Merkmale": "Caractéristiques attribuées",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Sélectionne les caractéristiques auxquelles les articles doivent être attribués",
  "Befüllen von Komponentenmerkmalen": "Remplir les caractéristiques des composants",
  Komponentenmerkmale: GNe,
  "Wählen Sie Komponentenmerkmale aus.": "Sélectionne les caractéristiques du composant.",
  "Oberflächenaktion hinzufügen": "Ajouter une action de surface",
  "Alle auswählen": "Sélectionner tout",
  "Alle abwählen": "Tout désélectionner",
  "Auswahl umkehren": "Inverser la sélection",
  Herunterladen: yNe,
  "Jetzt verbinden": "Connecte-toi maintenant",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "Le système de boutique flexible pour votre projet de commerce électronique.",
  "Jetzt Installieren": "Installer maintenant",
  "Die globale Commerce-Plattform.": "La plateforme de commerce mondiale.",
  "Die E-Commerce-Plattform für WordPress.": "La plateforme de commerce électronique pour WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "L'une des plateformes européennes de commerce électronique open source. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Maintenant Adobe Commerce : le e-commerce en toute simplicité.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Première classe dans la vente numérique avec la boutique Oxid esales.",
  "Individuelle Entwicklung": "Développement individuel",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connecter la boutique avec un développement personnalisé.",
  "Bitte nutzen Sie stattdessen unsere Shopify App.": "Veuillez utiliser notre application Shopify à la place.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Télécharge d'abord l'un de nos plugins et installe-le dans ta boutique :",
  "Verbinde Shop": "Relie la boutique",
  " und importiere Artikel": " et importer des articles",
  "Fehler beim Verbinden:": "Erreur de connexion :",
  "Shop erfolgreich verbunden.": "Boutique connectée avec succès.",
  "Fehler beim Verbinden: ": "Erreur de connexion : ",
  "Shop-Anbindung": "Connexion à la boutique",
  "Web-Adresse des Shops": "Adresse web de la boutique",
  "Shopify Admin API Key": "Shopify Admin API Key",
  "Sollen die Artikel aus dem Shop importiert werden?": "Les articles doivent-ils être importés de la boutique ?",
  "Filter für Artikel": "Filtre pour les articles",
  "Sollen die Artikel regelmäßig importiert werden?": "Les articles doivent-ils être importés régulièrement?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Le numéro d'article doit-il être pris à partir du SKU du magasin?",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Les articles doivent-ils être regroupés lors de la commande ?",
  "Basis-Name für kombinierte Artikel": "Nom de base pour les articles combinés",
  "Ihre Bestellung {code}": "Votre commande {code}",
  "Shop-Anbindung aufheben": "Supprimer le lien avec la boutique",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Ajoute le configurateur à ta boutique",
  Verbinden: WNe,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "Le contenu HTML n'a pas pu être rendu. Veuillez nettoyer votre saisie.",
  "Der eingegebe Wert ist nicht gültig: ": "La valeur saisie n'est pas valable: ",
  "Ungültiges HTML-Format": "Format HTML non valide",
  "Sie können uns den Vorfall hier melden!": "Tu peux nous signaler l'incident ici !",
  "Das Template konnte nicht geladen werden.": "Le modèle n'a pas pu être chargé.",
  "Templat auf Voreinstellung zurücksetzen": "Rétablir le modèle par défaut",
  "Eingaben zurücksetzen": "Réinitialiser les entrées",
  "Templat bearbeiten": "Modifier le modèle",
  "Templat Name": "Nom du modèle",
  "Templat wählen": "Choisir un modèle",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Choisissez un modèle standard pour le personnaliser. Ou attribuez votre propre nom pour préparer un modèle personnalisé.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "Vous n'avez pas encore créé de template personnalisé. Ajoutez-en un en sélectionnant un modèle standard dans la liste et en l'adaptant à vos besoins.",
  "Templat hinzufügen": "Ajouter un template",
  "Ansicht auswählen": "Sélectionner une vue",
  "Datei hochladen": "Télécharger le fichier",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Réserve d'abord un autre produit, s'il te plaît :",
  "Bitte wählen": "Choisir s'il te plaît",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Cette action combine plusieurs caractéristiques et ne peut donc pas être modifiée ici. Pour cela, modifie directement la ou les règles suivantes :",
  "Automatisch angelegt": "Créé automatiquement",
  "Aktionen verknüpfen": "Lier les actions",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Les valeurs de cette caractéristique doivent déclencher les actions suivantes :",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Cette caractéristique ne peut pas être utilisée pour contrôler d'autres processus. Pour cela, utilise directement les règles.",
  "Zu den Regeln": "Vers les règles",
  "Artikel bestellen": "Commander l'article",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "En fonction de la sélection, différents articles seront ajoutés à la liste de pièces.",
  "Oberfläche ändern": "Modifier la surface",
  "Welche Oberflächen sollen geändert werden? ": "Quelles sont les surfaces qui doivent être modifiées ? ",
  "3D-Modell anzeigen": "Afficher le modèle 3D",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "En fonction de la sélection, différents modèles 3D s'affichent.",
  "Bild anzeigen": "Afficher l'image",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "En fonction de la sélection, différentes images s'affichent.",
  "Farbe ändern": "Changer de couleur",
  "Welche Oberflächen sollen eingefärbt werden? ": "Quelles surfaces doivent être colorées ? ",
  "Bild aufdrucken": "Imprimer l'image",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Sur quelles surfaces l'image téléchargée doit-elle être imprimée ? ",
  "Der Wert wird noch in Regeln verwendet:": "Cette valeur est encore utilisée dans les règles :",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Commence par supprimer la ou les lignes correspondantes.",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Ici, tu peux définir ce qui doit être affiché lorsqu'aucune valeur n'a encore été sélectionnée.",
  "Dieser Wert ist nicht erlaubt.": "Cette valeur n'est pas autorisée.",
  "Maximale Anzahl an Werten ist erreicht.": "Le nombre maximal de valeurs est atteint",
  Farbwert: SNe,
  Anzeige: VNe,
  RAL: wNe,
  "keine RAL Farbe": "pas de couleur RAL",
  Ansicht: vNe,
  "Key eingeben": "Saisir la clé",
  URL: RNe,
  "Info-Modal": "Info-Modal",
  "Info-Content": "Contenu d'information",
  "Dieser Merkmalstyp unterstützt keine Werte.": "Ce type de caractéristique ne prend pas en charge les valeurs.",
  "Fehlende RAL Farben hinzufügen": "Ajouter des couleurs RAL manquantes",
  Auswahlwerte: XNe,
  Info: HNe,
  "Typ des Merkmals": "Type de caractéristique",
  "es gibt keine Merkmale mit {{identificator}}": "il n'y a pas de caractéristiques avec {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "il n'y a pas d'attribut avec {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "il n'y a pas de sélection avec {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "il y a plus d'une sélection avec {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "Il y a un cycle dans les caractéristiques calculées : {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "le résultat de la formule doit être une valeur numérique, au lieu de cela, c'est {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "Valeur {{paramName}} de la fonction {{functionName}} est égal à zéro",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "La caractéristique {{variableLabel}} est une liste de composants. Tu dois utiliser un index comme {{variableLabel2}}[0] pour le 1er élément ou avec une fonction de tableau comme map(), find(), reduce() ou first() pour y accéder.",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "Il y a un cycle dans les caractéristiques calculées.",
  Übersicht: "Aperçu",
  Auswahlpreise: kNe,
  Auswahl: FNe,
  Gesamtpreis: YNe,
  "Preis Information": "Information sur le prix",
  "Persönliche Daten": "Données personnelles",
  Weiter: xNe,
  "In AR ansehen": "Voir en AR",
  Vollbildmodus: DNe,
  "Komponenten suchen": "Chercher des composants",
  "Nicht Gruppiert": "Non groupé",
  "Komponenten hinzufügen": "Ajouter des composants",
  xl: JNe,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Ta saisie n'a malheureusement pas été possible et a été réinitialisée à la valeur la plus proche possible : ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Cette valeur ne peut pas être combinée avec les sélections suivantes :",
  "Bei Auswahl wird eine Alternative berechnet!": "En cas de sélection, une alternative sera facturée !",
  Bestätigen: "Confirmer",
  "Produkt hinzufügen": "Ajouter un produit",
  "Produkt erfolgreich konfiguriert": "Produit configuré avec succès",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "La configuration est terminée. Quel est le prochain produit que tu souhaites ajouter à ton panier ?",
  "Neues Produkt auswählen": "Choisir un nouveau produit",
  "Neues Produkt hinzufügen": "Ajouter un nouveau produit",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'La sélection "{{value}}" ({{variable}}) donne la valeur invalide "{{conflictValue0}}" ({{conflictVariable0}}) et est donc réinitialisée.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Message en cas de réinitialisation d'une sélection non valide",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'La sélection "{{value}}" ({{variable}}) ne correspond pas à la sélection "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Signaler l'apparition d'un conflit",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'La sélection "{{value}}" ({{variable}}) ne correspond pas à la sélection "{{conflictValue0}}" ({{conflictVariable0}}) et la sélection "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Déclaration en cas d'apparition de deux conflits",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Déclaration en cas d'apparition de trois conflits ou plus",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'La sélection "{{value}}" ({{variable}}) ne correspond pas à la sélection "{{conflictValue0}}" ({{conflictVariable0}}), la sélection "{{conflictValue1}}" ({{conflictVariable1}}) et la sélection "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': `La sélection "{{value}}" ({{variable}}) ne correspond pas à d'autres sélections.`,
  Konfliktmeldung: KNe,
  "Anpassung nötig": "Adaptation",
  "Stattdessen werden folgende Auswahlen angepasst:": "Au lieu de cela, les sélections suivantes sont adaptées :",
  "wird zu": "devient",
  "wird entfernt": "est supprimé",
  "Optionaler weiterer Hinweistext:": "Texte d'information supplémentaire en option:",
  "Auf Facebook teilen": "Partager sur Facebook",
  "Auf Twitter teilen": "Partager sur Twitter",
  "Auf LinkedIn teilen": "Partager sur LinkedIn",
  "Modal Titel": "Titre modal",
  "Desktop Gerät erkannt": "Appareil de bureau détecté",
  "Modal Text": "Texte modal",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "La réalité augmentée n'est actuellement disponible que sur les smartphones iOS ou androidOS actuels. Il te suffit donc de scanner ce code QR avec l'application caméra de ton smartphone :",
  "Mobiles {{device}}-Gerät erkannt": "Dispositif mobile {{device}} détecté",
  "Fortschrittsanzeige 3D-Objekt": "Fortschrittsanzeige 3D-Objekt",
  "Export des 3D-Objekts": "Exportation de l'objet 3D",
  "Fortschrittsanzeige AR-Datei": "Indicateur de progression du fichier AR",
  "Bereitstellen der AR-Datei": "Mise à disposition du fichier AR",
  "Fortschrittsanzeige System": "Indicateur de progression du système",
  "{{device}}-AR-System einrichten": "Configurer le système AR de {{device}}.",
  Positionszeile: ENe,
  "Pos.": "Pos.",
  "Artikelnummer Spalte": "Numéro d'article Colonne",
  "Artikel Spalte": "Article Colonne",
  "Artikelpreis Spalte": "Prix de l'article Colonne",
  "Artikelmenge Spalte": "Quantité d'articles Colonne",
  Menge: NNe,
  "Artikelanzahl Spalte": "Nombre d'articles Colonne",
  "Positionspreis Spalte": "Prix par poste Colonne",
  Positionspreis: LNe,
  "Hilfetext Preisdetails": "Texte d'aide pour les détails des prix",
  "Preisdetails anzeigen": "Afficher le détail des prix",
  "Titel bei Versions-Konflikt": "Titre en cas de conflit de version",
  "Konfigurator wurde aktualisiert": "Le configurateur a été mis à jour",
  "Text bei Versions-Konflikt": "Texte en cas de conflit de version",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Depuis que tu as enregistré cette configuration, le configurateur a été développé. Tu veux utiliser la version actuelle et continuer à travailler ou ouvrir l'ancienne version uniquement pour la consulter ?",
  "Alte Version": "Ancienne version",
  "Aktuelle Version": "Version actuelle",
  "Zeige Namen": "Afficher les noms",
  "Zeige Beschreibung": "Afficher la description",
  "Zeige Thumbnail": "Afficher la vignette",
  "Zeige Preis an Merkmal": "Afficher le prix Caractéristique",
  "Zeige Preise an Werten": "Afficher les prix aux valeurs",
  "Zeige URL": "Afficher l'URL",
  "Zeige Info-Button für Werte": "Afficher le bouton d'information pour les valeurs",
  "Zeige HTML Content für Werte": "Afficher le contenu HTML pour les valeurs",
  "Kamerafahrt beim scrollen": "Déplacement de la caméra pendant le défilement",
  "Alle ungültigen Werte ausblenden": "Masquer toutes les valeurs non valides",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Masquer les valeurs non valides, modifiées activement",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Masquer si seulement une sélection est possible",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Désactiver si une seule sélection est possible",
  "Komponente hervorheben": "Mettre en valeur le composant",
  Bild: TNe,
  Text: MNe,
  "Ja/ Nein": "Oui/Non",
  Information: UNe,
  Mehrfachauswahl: PNe,
  Liste: zNe,
  Eckenrundung: ONe,
  "Anzahl der Eckenrundungsschritte": "Nombre d'étapes d'arrondissement des angles",
  "Dieses Material existiert bereits": "Ce matériel existe déjà",
  "Material hinzufügen": "Ajouter du matériel",
  "Materialname eingeben": "Saisir le nom du matériau",
  Abmessungen: QNe,
  Breite: jNe,
  Höhe: "Hauteur",
  Tiefe: _Ne,
  Startpunkt: $Ne,
  Endpunkt: qNe,
  Linienstärke: "Épaisseur de la ligne",
  Startanker: eLe,
  Maßkette: "Chaîne de mesure",
  Ohne: tLe,
  Endanker: iLe,
  Texttyp: nLe,
  "Kein Text": "Pas de texte",
  Zahlenwert: gLe,
  "Statischer Text": "Texte statique",
  "Automatisches Maß überschreiben": "Écraser la mesure automatique",
  "Neues Maß": "Nouvelle mesure",
  "Textgröße als Faktor. 1 ist Standard.": "Taille du texte comme facteur. 1 est la valeur par défaut.",
  Offsets: rLe,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Ici, il est possible de définir les écarts de position et de rotation qui résultent normalement du point de départ et du point final. Pour cela, tu peux utiliser l'outil de positionnement 3D.",
  "Nicht Befüllt": "Non rempli",
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Le nombre maximal d'itérations pour le moteur d'expression est atteint ! Il y a trop de cycles complexes dans les caractéristiques calculées.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Nombre maximum d'itérations atteint ! Les conflits de règles ne peuvent pas être résolus."
}, ILe = "Liste", lLe = "Couleurs", sLe = "Texte", aLe = "Oui/ Non", cLe = "Information", dLe = "Image", CLe = "Composants", uLe = "Présentation", ALe = "Actions", bLe = "Valeurs", mLe = "Règles", hLe = "Options", pLe = "Images", BLe = "Configurateurs", ZLe = "Rue", fLe = "Code Postal", GLe = "Ville", yLe = "Pays", WLe = "Extraire", SLe = "Téléphone", VLe = "Nom d'utilisateur", wLe = "MATÉRIEL", vLe = "Importation", RLe = "Manuel", XLe = "Rotation", HLe = "Généralités", kLe = "Caractéristiques", FLe = "Roughness", YLe = "Métallicité", xLe = "Pile d'images", DLe = "Paramètres de scène", JLe = "Thèmes", KLe = "Adaptation", ELe = "Plage de valeurs", NLe = "Présentation", LLe = "Valeurs", TLe = "Demandes", MLe = "Moment", ULe = "Demande", PLe = "URI", zLe = "Paramètres", OLe = "Durée", QLe = "Serveur", jLe = "Nombre", _Le = "Article", $Le = "Mode plein écran", qLe = {
  always: "Toujours",
  never: "Jamais",
  auto: "Comme dans le configurateur",
  label: "Affichage dans la confirmation, le PDF et la boutique"
}, e3e = "Activer", t3e = "Désactiver", i3e = "Caractéristiques et articles", n3e = "Seulement des caractéristiques", g3e = "Seulement des articles", r3e = "Pas d'aperçu", o3e = "Généralités", I3e = "PDF", l3e = "Mail", s3e = "Intégrer", a3e = "Boutique", c3e = "Article", d3e = "Aperçu", C3e = "Éditeur", u3e = "Images", A3e = "Matériaux", b3e = "Modèles", m3e = "Règles", h3e = "Options", p3e = "Admin", B3e = "extract", Z3e = "Configurateurs", f3e = "Créer", G3e = "Importer", y3e = "Utilisateur", W3e = "Support", S3e = "Logs", V3e = "État du système", w3e = "Corbeille à papier", v3e = "Abonnement", R3e = "Expiré", X3e = "Profil", H3e = "Éditeur", k3e = "Configurations", F3e = "Cavalier", Y3e = "Caractéristiques", x3e = "Design", D3e = "Scène", J3e = "Présentation", K3e = "Options", E3e = "Actions", N3e = "Valeurs", L3e = "couleur primaire", T3e = "Couleur secondaire", M3e = "Couleur de fond", U3e = "Couleur d'avertissement", P3e = "Standard", z3e = "Plus clair", O3e = "Sombre", Q3e = "Souligné", j3e = "Standard", _3e = "Grisé", $3e = "CTRL", q3e = "Remplacer", eTe = "Commander", tTe = {
  list: ILe,
  color: lLe,
  text: sLe,
  boolean: aLe,
  information: cLe,
  image: dLe,
  components: CLe,
  presentation: uLe,
  usage: ALe,
  values: bLe,
  rules: mLe,
  settings: hLe,
  images: pLe,
  configurators: BLe,
  street: ZLe,
  zip: fLe,
  city: GLe,
  country: yLe,
  extract: WLe,
  phone: SLe,
  username: VLe,
  "duplicate-entry": "Il existe déjà des comptes avec ces données",
  "create new dealer": "Créer un nouveau commerçant",
  "Artikel Anzahl": "Article Nombre",
  "Farb auswählen": "Choisir une couleur",
  "< Zurück": "< Retour",
  "Merkmal auswählen": "Sélectionner une caractéristique",
  MATERIAL: wLe,
  Import: vLe,
  "Materialien für den Import auswählen:": "Sélectionner les matériaux pour l'importation :",
  "Wie möchten Sie ein Material erstellen?": "Comment souhaites-tu créer un matériel ?",
  "Import einer .glb und export der enthaltenen Materialien": "Importer un .glb et exporter les matériaux qu'il contient",
  Manuell: RLe,
  "Eigenständiges Anlegen eines PBR-Materials": "Création autonome d'un matériau PBR",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Commence par supprimer la colonne correspondante.",
  "Design & Layout": "Design & mise en page",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Visible uniquement en mode prévisualisation ou configurateur publié !",
  "Theme wählen": "Choisir un thème",
  "Komponente löschen": "Supprimer un composant",
  "Mehrfach Regelzeilen Bearbeitung": "Edition de lignes de règles multiples",
  "Anzahl ausgewählte Regel-Zeilen:": "Nombre de lignes de règles sélectionnées :",
  "Modelaktions-Positionierung": "Positionnement de la modélisation",
  Rotation: XLe,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Aucune action disponible pour le traitement multiple",
  Allgemeines: HLe,
  "Farben und Lichtinteraktion": "Couleurs et interaction avec la lumière",
  "Color-Map Upload": "Téléchargement de la carte des couleurs",
  "Material interagiert mit Licht in der Szene": "La matière interagit avec la lumière dans la scène",
  Beschaffenheit: kLe,
  "Roughness-Map Upload": "Télécharger la carte de la rugosité",
  Roughness: FLe,
  "Metallness-Map Upload": "Télécharger la carte de Metallness",
  Metallness: YLe,
  "Normalen-Map Upload": "Téléchargement de la carte normale",
  "Normalen-Skalierung": "Échelle normale",
  "Anwendung auf 3D-Modell": "Application sur modèle 3D",
  "Displacement-Map Upload": "Téléchargement de la carte de déplacement",
  "Displacement-Skalierung": "Échelle de déplacement",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Facteur de répétition de la texture dans les directions X et Y",
  "Alpha-Werte": "Valeurs alpha",
  "Alpha-Map Upload": "Téléchargement de la carte alpha",
  "Ambient Occlusion": "Occlusion d'ambiance",
  "Ambient-Occlusion-Map Upload": "Téléchargement de la carte d'occlusion d'ambiance",
  "Info editieren": "Éditer l'info",
  "Zeige Info-Button": "Afficher le bouton d'information",
  Abhängigkeitsschleifen: "Boucles de dépendance",
  Bilderstapel: xLe,
  "Google Analytics Property ID": "ID de propriété Google Analytics",
  "Sans Serif": "Sans Serif",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Le système de boutique flexible pour ton projet de commerce électronique.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "L'une des plateformes européennes de commerce électronique open source. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Maintenant Adobe Commerce : le e-commerce en toute simplicité.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Première classe dans la vente numérique avec la boutique Oxid esales.",
  "Individuelle Entwicklung": "Développement individuel",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connecter la boutique avec un développement personnalisé.",
  Szeneneinstellungen: DLe,
  Themes: JLe,
  Anpassung: KLe,
  "Gewähltes Theme übernehmen": "Reprendre le thème choisi",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Crée une nouvelle étape de configuration.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Une configuration se fait en plusieurs étapes. Dans chaque étape, il est possible d'indiquer plusieurs propriétés du produit, le cas échéant. Ici, tu crées la première étape.",
  "Konfigurationsschritt erstellen": "Créer une étape de configuration",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Commence par cliquer ici pour créer un nouveau configurateur.",
  "Neuer Konfigurator wählen": "Choisir le nouveau configurateur",
  "Bitte geben Sie einen Namen ein.": "Saisis un nom, s'il te plaît.",
  "Bitte geben Sie eine Beschreibung ein.": "Saisis une description.",
  "Bitte klicken Sie hier.": "Clique ici s'il te plaît.",
  "Konfigurator Dialog aufrufen": "Ouvrir la boîte de dialogue du configurateur",
  "Konfigurationsschritt benennen": "Nommer l'étape de configuration",
  "Hier können Sie neue Werte hinzufügen.": "Ici, tu peux ajouter de nouvelles valeurs.",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Les caractéristiques qui sont une liste (ou couleur, matériau, modèle) affichent plusieurs valeurs à choisir. Tu peux saisir ces valeurs ici.",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Clique ici pour créer une nouvelle valeur.",
  "Wenn Sie fertig sind klicken Sie hier.": "Quand tu as terminé, clique ici.",
  "Werte erstellen": "Créer des valeurs",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Saisis un nom pour la nouvelle caractéristique.",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Choisis une présentation qui correspond aux possibilités de la caractéristique.",
  "Präsentation definieren": "Définir la présentation",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "En une seule étape, ton client peut personnaliser plusieurs caractéristiques de son produit. Insère ici la première caractéristique.",
  "Produktmerkmal erstellen": "Créer une caractéristique de produit",
  "Was für ein Merkmal wollen Sie anlegen?": "Quel type de caractéristique veux-tu créer ?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Une caractéristique peut être une sélection (par exemple les tailles S, M, L et XL), un texte ou un chiffre (par exemple pour une largeur ou une hauteur) ou encore une couleur ou une matière de ton produit ou un modèle 3D qui représente une partie de ton produit.",
  "Produktmerkmaltyp auswählen": "Sélectionner le type de caractéristique du produit",
  "Wählen sie den eben erstellten Konfigurator.": "Choisis le configurateur que tu viens de créer.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Contrôle du configurateur par la nouvelle caractéristique.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Les caractéristiques peuvent, par exemple, faire en sorte que les modèles 3D ou les images soient affichés ou que les surfaces soient modifiées ou colorées. Tu peux aussi créer une nomenclature d'articles qui détermine ensuite le prix et qui peut être placée dans le panier de ta boutique.",
  "Merkmal verwenden": "Utiliser la caractéristique",
  Wertebereich: ELe,
  Darstellung: NLe,
  Werte: LLe,
  Anfragen: TLe,
  Zeitpunkt: MLe,
  Anfrage: ULe,
  URI: PLe,
  Parameter: zLe,
  Dauer: OLe,
  Server: QLe,
  "Modell bearbeiten": "Modifier le modèle",
  "Korrekte Mail-Adresse": "Adresse e-mail correcte",
  "Statistik (30 Tage)": "Statistiques (30 jours)",
  amount: jLe,
  article: _Le,
  "Datum eingeben": "Entrer la date",
  "Nach hause ": "A la maison ",
  "Mandant anlegen": "Créer un client",
  "Nutzer hinzufügen": "Ajouter des utilisateurs",
  Fullscreen: $Le,
  showSelection: qLe,
  "Kamera überschreiben": "Écraser la caméra",
  Aktivieren: e3e,
  Deaktivieren: t3e,
  Übersichtsseite: "Page d'accueil",
  variablesAndArticles: i3e,
  variablesOnly: n3e,
  articlesOnly: g3e,
  noOverview: r3e,
  breadcrumb_app: o3e,
  breadcrumb_pdf: I3e,
  breadcrumb_mail: l3e,
  breadcrumb_embed: s3e,
  breadcrumb_shop: a3e,
  breadcrumb_articles: c3e,
  breadcrumb_preview: d3e,
  breadcrumb_edit: C3e,
  breadcrumb_images: u3e,
  breadcrumb_materials: A3e,
  breadcrumb_models: b3e,
  breadcrumb_rules: m3e,
  breadcrumb_settings: h3e,
  breadcrumb_admin: p3e,
  breadcrumb_extract: B3e,
  breadcrumb_apps: Z3e,
  breadcrumb_create: f3e,
  breadcrumb_import: G3e,
  breadcrumb_users: y3e,
  breadcrumb_support: W3e,
  breadcrumb_logs: S3e,
  breadcrumb_systemStatus: V3e,
  breadcrumb_trash: w3e,
  breadcrumb_abonnement: v3e,
  breadcrumb_expired: R3e,
  breadcrumb_profile: X3e,
  breadcrumb_configurator: H3e,
  breadcrumb_configurations: k3e,
  breadcrumb_groups: F3e,
  breadcrumb_variables: Y3e,
  breadcrumb_design: x3e,
  breadcrumb_scene: D3e,
  breadcrumb_presentation: J3e,
  breadcrumb_options: K3e,
  breadcrumb_usage: E3e,
  breadcrumb_values: N3e,
  Primary: L3e,
  Secondary: T3e,
  Background: M3e,
  Warning: U3e,
  Error: "Couleur de l'erreur",
  Main: P3e,
  Light: z3e,
  Dark: O3e,
  "Contrast Text": "Couleur du texte (de contour)",
  Paper: Q3e,
  Default: j3e,
  Disabled: _3e,
  "Content Main": "Couleur de fond Canvas",
  "Scrollbar Default": "Couleur de la barre de défilement",
  "Letzter Schritt kann nicht gelöscht werden.": "Le dernier groupe ne peut pas être supprimé.",
  "Dieses Merkmal ist versteckt.": "Cette caractéristique est cachée.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `Cette caractéristique n'est visible que dans le panneau d'administration. Il peut y avoir plusieurs raisons à cela : 
 1. elle a été masquée par une règle. 
 2. l'étape associée a été supprimée.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "Cette caractéristique n'est visible que dans le panneau d'administration : La caractéristique n'a pas d'options de sélection.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "Cette caractéristique n'est plus visible, car elle n'a pas de sélection valide!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "Cette caractéristique n'est plus visible, car elle n'a qu'une seule sélection valide!",
  "Vertikale Platzierung zulassen?": "Autoriser le placement vertical?",
  "Suchfeld ausblenden?": "Masquer le champ de recherche?",
  Modalgröße: "Taille modale",
  "Anzahl an Komponenten pro Zeile": "Nombre de composants par ligne",
  "Weitere Preisauswirkungen dieser Selektion": "Autres conséquences de cette sélection sur les prix",
  "Aktion verstecken": "Cacher l'action",
  Ctrl: $3e,
  Ersetzen: q3e,
  "Bild hochladen": "Télécharger l'image",
  "Das Dateiformat ist nicht erlaubt!": "Le format de fichier n'est pas autorisé!",
  Bestellen: eTe,
  "Straße und Hausnummer": "Rue et numéro",
  "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "J'ai pris connaissance des informations sur la protection des données et je les accepte.",
  "UST-ID": "Numéro d'identification de la taxe sur le chiffre d'affaires"
}, iTe = {
  ...oLe,
  ...tTe
}, nTe = "Klant", gTe = "Product", rTe = "Betalingsstatus", oTe = "Klanten", ITe = "Configurators", lTe = "Ondersteuning", sTe = "Verkoper", aTe = "Gebruikers", cTe = "Prullenmand", dTe = "Andere", CTe = "Links", uTe = "Help", ATe = "Begeleiding", bTe = "Status", mTe = "Abonnement", hTe = "Profiel", pTe = "Afmelden", BTe = "Sjabloon", ZTe = "Oproepen", fTe = "PDF", GTe = "Code", yTe = "Prijs", WTe = "Inspiratie", STe = "Profiel dealer", VTe = "Taal", wTe = "Klant", vTe = "Inhoud", RTe = "Configurator-versie", XTe = "Annuleren", HTe = "Sluit", kTe = "Bewerk", FTe = "Adres", YTe = "Gegevensbescherming", xTe = "Naam", DTe = "e-mail", JTe = "Telefoon", KTe = "Opmerking", ETe = "Bedrijf", NTe = "Geaccepteerd", LTe = "Stad", TTe = "Postcode", MTe = "datum", UTe = "Verkoper", PTe = "json", zTe = "Prijs", OTe = "Opties", QTe = "Bestel campagne", jTe = "Type", _Te = "Configuratie", $Te = "AR", qTe = "Gedeelde", eMe = "Toon", tMe = "Sorteren", iMe = "Artikelnummer", nMe = "Beschrijving van de", gMe = "Categorie", rMe = "Prijzen", oMe = "Importeren", IMe = "Artikel", lMe = "uploaden", sMe = "Geen", aMe = "Alle", cMe = "Foto's", dMe = "Ruwheid", CMe = "Metaalachtigheid", uMe = "Transparant", AMe = "Opaciteit", bMe = "Kleur", mMe = "Emissive", hMe = "Pagina", pMe = "Voorpagina", BMe = "Achterkant", ZMe = "Dubbelzijdig", fMe = "Transmissie", GMe = "Reflectie", yMe = "Blanke lak", WMe = "Opties", SMe = "Aanwijzing", VMe = "Pbr", wMe = "Fysiek", vMe = "Sleutel", RMe = "Model", XMe = "Uitgebreid", HMe = "Bewerk", kMe = "Kopie", FMe = "Exporteer", YMe = "Algemeen", xMe = "Talen", DMe = "Productpresentatie", JMe = "Upgrade", KMe = "Hoofdmodel", EMe = "Sjabloon", NMe = "Les", LMe = "Kenmerken", TMe = "Korting", MMe = "Impact", UMe = "Sla", PMe = "inbedden", zMe = "Referentietaal", OMe = "Lettertype", QMe = "Helvetica", jMe = "Koerier", _Me = "Interstate", $Me = "Montserrat", qMe = "Links", eUe = "Rechts", tUe = "Top", iUe = "Onder", nUe = "Kop", gUe = "Mail", rUe = "Winkel op", oUe = "Stuur", IUe = "Bestellingen", lUe = "datum", sUe = "Dagen", aUe = "Naam artikel", cUe = "Artikel", dUe = "Configuraties", CUe = "Configurator", uUe = "Partner", AUe = "Provision", bUe = "Maak", mUe = "Naam", hUe = "e-mail", pUe = "Gebruikersaccount", BUe = "Gebruikersnaam", ZUe = "Wachtwoord", fUe = "Inloggen", GUe = "Registratie", yUe = "Regelgeving gegevensbescherming", WUe = "GTC", SUe = "wachtwoord", VUe = "Redacteur", wUe = "Standaard", vUe = "Versie", RUe = "Boekingen", XUe = "Platform", HUe = "Interval", kUe = "Gebruikers", FUe = "Abonnement", YUe = "KlantID", xUe = "Actief", DUe = "Sinds", JUe = "Vraag", KUe = "Acties", EUe = "Type", NUe = "Maand", LUe = "Jaar", TUe = "Boek", MUe = "Parameters", UUe = "Klanten", PUe = "ID", zUe = "rekeningen", OUe = "Leeg", QUe = "Verander", jUe = "Gebruikers", _Ue = "Rol", $Ue = "Configurators", qUe = "Begindatum", ePe = "Einddatum", tPe = "Staps", iPe = "Waarden", nPe = "Regels", gPe = "Regelregels", rPe = "Modellen", oPe = "Materialen", IPe = "Functie", lPe = "Regel", sPe = "Aantal", aPe = "Status", cPe = "Gemaakt", dPe = "Wachtwoord", CPe = "Nieuw", uPe = "Ingang", APe = "Uitnodigen", bPe = "download", mPe = "Achtergrondmodel", hPe = "Favorieten", pPe = "Maak", BPe = "Prijsinstellingen", ZPe = "Hoofdactie", fPe = "Contactformulier", GPe = "Verplicht veld", yPe = "Actie naam", WPe = "Hoeveelheid", SPe = "Aantalberekening", VPe = "Hoeveelheidsberekening", wPe = "Artikel promotie", vPe = "Aantal", RPe = "Eenheid", XPe = "Type focus", HPe = "Camera", kPe = "Stap", FPe = "Cameraweergave", YPe = "Dubbele", xPe = "Entfernen", DPe = "Selecties", JPe = "Camera's", KPe = "Gratis", EPe = "Downgrade", NPe = "Maandelijks", LPe = "Home", TPe = "Help", MPe = "Annuleren", UPe = "Icoon", PPe = "Logo", zPe = "Kleuren", OPe = "CSS", QPe = "Instellingen", jPe = "Voorbeeld", _Pe = "Artikel", $Pe = "Bestellingen", qPe = "Statistieken", eze = "Fout", tze = "Helaas is er een onbekende fout opgetreden. Als het probleem niet kan worden opgelost door de pagina opnieuw te laden, neem dan contact met ons op.", ize = "Onbekende fout", nze = "Foutmelding:", gze = "Bestelopties", rze = "Deze stap is momenteel alleen zichtbaar in het beheerderspaneel, omdat het geen functies bevat met selecteerbare waarden.", oze = "Basisinstellingen", Ize = "Opaciteit", lze = "Materiële actie", sze = "Kleuren actie", aze = "Afbeelding actie", cze = "Tip", dze = "Attentie", Cze = "Ga verder", uze = "Verborgen", Aze = "Artikelnummer", bze = "Naam", mze = "Valuta", hze = "Waarde", pze = "Aantal starts", Bze = "Uiteindelijk aantal", Zze = "Zoek op", fze = "Titel", Gze = "OK", yze = "Nadruk", Wze = "Expressie", Sze = "Resultaat", Vze = "Minimumwaarde", wze = "Maximale waarde", vze = "Oneindig", Rze = "Decimale plaatsen", Xze = "Stapgrootte", Hze = "Berekend", kze = "Kleurselectie", Fze = "Onderdelenlijst", Yze = "Component kaarten", xze = "Afbeelding selecteren", Dze = "Informatie over", Jze = "Aantal invoer", Kze = "Dropdown", Eze = "Miniaturen", Nze = "Schakelaars", Lze = "Tekstinvoer", Tze = "Voorbeeldtekst", Mze = "Optioneel", Uze = "Label actie", Pze = "Fehlermeldung", zze = "Modellen actie", Oze = "Positie", Qze = "Schaal", jze = "Model", _ze = "Materiaal", $ze = "Onderdelen", qze = "Druk", e4e = "Naam regel", t4e = "Karakteristieke combinaties", i4e = "Productstructuur", n4e = "Namen van materialen", g4e = "Componenten", r4e = "Download", o4e = "Maak verbinding met", I4e = "Kleurwaarde", l4e = "Weergave", s4e = "RAL", a4e = "Bekijk", c4e = "URL", d4e = "Selectiewaarden", C4e = "Info", u4e = "Selectie prijzen", A4e = "Sélection", b4e = "Totale prijs", m4e = "Verder", h4e = "Volledig scherm", p4e = "xl", B4e = "Conflictrapport", Z4e = "Positielijn", f4e = "Hoeveelheid", G4e = "Prijs artikel", y4e = "Afbeelding", W4e = "Tekst", S4e = "Informatie", V4e = "Meervoudige selectie", w4e = "Lijst", v4e = "Hoekafronding", R4e = "Afmetingen", X4e = "Breedte", H4e = "Diepte", k4e = "Startpunt", F4e = "Eindpunt", Y4e = "Begin anker", x4e = "Zonder", D4e = "Eindanker", J4e = "Type tekst", K4e = "Numerieke waarde", E4e = "Offsets", N4e = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Je betaalt niet online. Neem contact op met de medewerker in uw bedrijf die het contract met ObjectCode heeft afgesloten.",
  Mandant: nTe,
  Produkt: gTe,
  Bezahlzustand: rTe,
  Mandanten: oTe,
  apps: ITe,
  support: lTe,
  "dealer-profile": "Profiel dealer",
  dealers: sTe,
  users: aTe,
  trash: cTe,
  others: dTe,
  links: CTe,
  help: uTe,
  consultation: ATe,
  status: bTe,
  subscription: mTe,
  profile: hTe,
  logout: pTe,
  "Neuer Konfigurator": "Nieuwe configurator",
  Template: BTe,
  Zurück: "Terug",
  Aufrufen: ZTe,
  PDF: fTe,
  Code: GTe,
  Preis: yTe,
  Inspiration: WTe,
  Aktion: STe,
  Sprache: VTe,
  Händler: "Verkoper",
  "Sie möchten die Daten dieses Kunden einsehen?": "Wil je de gegevens van deze klant bekijken?",
  Kunde: wTe,
  Inhalt: vTe,
  "Shop-API": "API winkel",
  "Gespeichert am": "Opgeslagen op",
  Konfiguratorversion: RTe,
  Abbrechen: XTe,
  "Ergebnis der Shop API": "Resultaat van de Shop API",
  Schliessen: HTe,
  Bearbeiten: kTe,
  Adresse: FTe,
  Datenschutz: YTe,
  Name: xTe,
  Email: DTe,
  Telefon: JTe,
  Bemerkung: KTe,
  Firma: ETe,
  "Steuer-ID": "Belasting ID",
  Akzeptiert: NTe,
  Stadt: LTe,
  PLZ: TTe,
  Datum: MTe,
  "exit-action": "Bestel campagne",
  dealer: UTe,
  "order-status": "Status",
  json: PTe,
  price: zTe,
  options: OTe,
  Bestellaktion: QTe,
  Typ: jTe,
  Konfiguration: _Te,
  AR: $Te,
  Geteilt: qTe,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Wil je de gegevens van je klanten bekijken?",
  "Preise anlegen": "Prijzen maken",
  anzeigen: eMe,
  "Artikel und Preise erfolgreich importiert.": "Artikelen en prijzen zijn succesvol geïmporteerd.",
  Sortierung: tMe,
  Artikelnummer: iMe,
  "Artikelnummer eingeben": "Voer artikelnummer in",
  "Namen eingeben": "Naam invoeren",
  Beschreibung: nMe,
  "Beschreibung eingeben": "Beschrijving invoeren",
  Kategorie: gMe,
  "Kategorien eingeben": "Categorieën invoeren",
  Preise: rMe,
  "Sortierung erfolgreich angewendet.": "Sortierung erfolgreich angewendet.",
  "Fehler beim Anwenden der Sortierung: ": "Fout bij het toepassen van de sortering: ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Artikelen en prijzen succesvol gepubliceerd.",
  "Fehler beim Veröffentlichen: ": "Fout bij publicatie: ",
  "Sie möchten Preise anzeigen?": "Wil je prijzen weergeven?",
  Importieren: oMe,
  "Neuer Artikel": "Nieuw artikel",
  Löschen: "Verwijder",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Publiceer de app om artikelen en prijzen te kunnen publiceren.",
  "Artikel und Preise veröffentlichen": "Artikelen en prijzen publiceren",
  Artikel: IMe,
  Upload: lMe,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Upload een of meer afbeeldingen naar de opgegeven map. Je kunt de forward slash (/) gebruiken om diepere mappen te maken.",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Je kunt ook een ZIP-archief met een mappenstructuur uploaden.",
  "Ordner *": "Map *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': 'Let op: Alle afbeeldingen in een map worden gegroepeerd als een galerij, gesorteerd op naam. Gebruik dus bestandsnamen zoals "Image_001".',
  Keine: sMe,
  Alle: aMe,
  Bilder: cMe,
  Roughness: dMe,
  Metalness: CMe,
  Transparent: uMe,
  Opacity: AMe,
  Farbe: bMe,
  Emissive: mMe,
  "Color Map": "Kleur Textuur",
  "Normal Map": "Normale textuur",
  "Roughness Map": "Ruwheid Textur",
  "Metalness Map": "Metaalstructuur",
  "Alpha Map": "Alpha Textur",
  Seite: hMe,
  Vorderseite: pMe,
  Hinterseite: BMe,
  Beidseitig: ZMe,
  "Texture repeat": "Texture repeat",
  "Depth Write": "Schrijf in de dieptebuffer",
  Transmission: fMe,
  Reflectivity: GMe,
  ClearCoat: yMe,
  "Clearcoat Roughness": "Ruwheid blanke lak",
  "new-material": "Nieuw materiaal",
  Optionen: WMe,
  Bezeichnung: SMe,
  Pbr: VMe,
  Physikalisch: wMe,
  Key: vMe,
  "AR Fallback Material": "AR terugvalmateriaal",
  "Nicht ausgewählt": "Niet geselecteerd",
  Model: RMe,
  Erweitert: XMe,
  "Nur in Regeln verwendete Materialien anzeigen": "Toon alleen materialen die in de regels worden gebruikt",
  "extract-materials": "Materialen uit het model halen",
  Editieren: HMe,
  Kopieren: kMe,
  "Neues Modell": "Nieuw model",
  "Dynamisches Modell": "Dynamisch model",
  Gültigkeit: "Geldigheid",
  "Neue Regel": "Nieuwe regel",
  "Neue Regel Erstellen": "Nieuwe regel maken",
  "Regel erstellen": "Regel aanmaken",
  "Erfolgreich importiert": "Succesvol geïmporteerd",
  "Hier importieren Sie eine vorab exportierte Datei.": "Hier importeert u een eerder geëxporteerd bestand.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "Hierdoor worden alle gegevens van deze configurator vervangen.",
  "Auch der Papierkorb wird gelöscht.": "Ook de prullenbak wordt geleegd.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "Deze bewerking kan niet ongedaan gemaakt worden.",
  "Sind Sie sicher?": "Tu es sûr ?",
  "JSON Export Datei": "JSON exportbestand",
  Export: FMe,
  "app-code-duplicate": "App-code is al in gebruik",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "App-instellingen konden niet worden opgeslagen. De code is al in gebruik.",
  Allgemein: YMe,
  Sprachen: xMe,
  "Die erste Sprache gilt als Standard.": "De eerste taal is de standaardtaal.",
  "Die Beschreibung dieses Konfigurators": "De beschrijving van deze configurator",
  "Link zum Konfigurator": "Link naar de configurator",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Als je een extensie gebruikt, voer dan hier in waar je ontwikkelaar deze beschikbaar maakt.",
  Produktdarstellung: DMe,
  "3D-Modell": "3D model",
  "Bilder-Konfigurator": "Afbeeldingsconfigurator",
  "Google Analytics 4 Property ID": "Google Analytics 4 Eigendom-ID",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Je moet toestemming van de gebruiker krijgen voor de Google-cookie. Dit gebeurt niet binnen de K3!",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Wil je je Analytics-account koppelen?",
  Upgrade: JMe,
  Hauptmodell: KMe,
  "Hauptmodell entfernen": "Hoofdmodel verwijderen",
  Vorlage: EMe,
  "Dieser Konfigurator dient als Vorlage": "Deze configurator dient als sjabloon",
  Tutorial: NMe,
  "Standard übernehmen": "Standaard aannemen",
  "screenshot-quality": "Screenshot kwaliteit",
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Prijs & Info ServiceHier kun je een URL opgeven waar verschillende gegevens naartoe worden gestuurd zodra de gebruiker een selectie maakt. Hierdoor kun je de component CustomData in de Layout Designer gebruiken om speciale informatie weer te geven (bijvoorbeeld verzendkosten etc.).",
  "Preis & Info Service": "Prijs & Info Service",
  "Hilfe dazu finden Sie hier.": "Hulp is hier te vinden.",
  "URL für den Service, der die Daten verarbeitet": "URL voor de service die de gegevens verwerkt",
  "Debounce in ms": "Debounce in ms",
  Merkmale: LMe,
  "Merkmale und ihre aktuelle Auswahlen senden": "Functies verzenden en hun huidige selecties",
  "Optionale Merkmalbeschränkung": "Optionele functiebeperking",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "Beperk optioneel de kenmerken die worden verzonden.",
  "Artikel & Preis": "Artikel & prijs",
  "Aktuell ausgewählte Artikel senden": "Momenteel geselecteerde artikelen verzenden",
  "Aktuellen Preis senden": "Huidige prijs verzenden",
  "to dealer app": "Naar de dealer app",
  "Händler hat Zugriff": "Winkelier heeft toegang",
  "Händler hat keinen Zugriff": "Dealer heeft geen toegang",
  "dealer query": "Standaardinstellingen",
  "Händler legt Aufschlag fest": "Winkelier bepaalt winstmarge",
  discount: TMe,
  surcharge: MMe,
  "Sie stornieren nun eine Händlerlizenz.": "Je annuleert nu een dealerlicentie.",
  "Händlerzugriff beenden": "Toegang dealer beëindigen",
  "Sie buchen nun eine Händlerlizenz.": "Je boekt nu een dealerlicentie.",
  "Händlerzugriff buchen": "Toegang boeken dealer",
  Speichern: UMe,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Wil je dat je dealers je configurator kunnen gebruiken?",
  "Keine Händler vorhanden": "Geen dealers beschikbaar",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Maak eerst een winkelier aan en geef deze hier toegang tot de app.",
  "Jetzt Händler anlegen": "Nu dealer aanmaken",
  Einbetten: PMe,
  "Als Link": "Als link",
  "Als IFrame": "Als IFrame",
  "Meldungen beim Laden anpassen": "Berichten bij het laden aanpassen",
  "Bitte Auth0 Zugangsdaten angeben": "Voer Auth0 toegangsgegevens in",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "Wilt u de configurator alleen voor specifieke gebruikers vrijgeven? Dan kunt u de Auth0-service gebruiken.",
  "Konfigurator-Zugang": "Toegang configurator",
  "Anmeldung für Konfigurator verlangen.": "Aanmelding voor configurator vereisen.",
  "Auth0 Domain": "Auth0 Domein",
  "Auth0 ClientId": "Auth0 ClientId",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Referentietaal. De invoer moet overeenkomen met de referentiekolom in het geïmporteerde bestand om in aanmerking te worden genomen.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Verkeerd bestandsformaat, gebruik het formaat van het geëxporteerde bestand voor de huidige geselecteerde referentietaal.",
  "Importiere XLSX": "XLSX importeren",
  "Exportiere XLSX": "XLSX exporteren",
  Referenzsprache: zMe,
  "Werden berücksichtigt:": "Wordt rekening mee gehouden:",
  "Versteckte Merkmale": "Verborgen functies",
  "Unbenutzte Sprachen": "Ongebruikte talen",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Wil je je klanten en/of jezelf vragen per e-mail sturen?",
  "Mail Texte": "Mail teksten",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Je kunt hier de inhoud van de verzonden e-mails aanpassen. Lees vooraf het gedeelte in de documentatie.",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Let op: Je moet de configurator altijd publiceren voordat de gewijzigde teksten worden gebruikt.",
  Schriftart: OMe,
  Helvetica: QMe,
  "Times Roman": "Times Roman",
  Courier: jMe,
  Interstate: _Me,
  Montserrat: $Me,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Vet",
  Schriftgröße: "Lettergrootte",
  Links: qMe,
  Rechts: eUe,
  Oben: tUe,
  Unten: iUe,
  Kopfzeile: nUe,
  Fußzeile: "Voettekst",
  "Neue PDF Vorlage auswählen": "Selecteer een nieuwe PDF-sjabloon",
  "Vorhandene PDF Vorlage löschen": "Bestaande PDF-sjabloon verwijderen",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Wil je bevestigingen of aanbiedingen als PDF versturen?",
  "PDF Einstellungen": "PDF-instellingen",
  Seitenränder: "Marges",
  "Voransicht mit dieser Konfiguration:": "Voorbeeld met deze configuratie:",
  "und diesem Template:": "en deze sjabloon:",
  "Speichern und drucken": "Opslaan en afdrukken",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "Om een afdrukvoorbeeld te kunnen afdrukken, moet er een opgeslagen configuratie beschikbaar zijn.",
  Mail: gUe,
  Shop: rUe,
  "Social Sharing": "Sociaal delen",
  "Wir helfen gern!": "We helpen je graag!",
  "Ihre Telefonnummer": "Je telefoonnummer",
  "Ihre Nachricht": "Jouw bericht",
  Senden: oUe,
  "Nachricht senden": "Verstuur bericht",
  "Rückruf erbitten": "Terugbellen",
  orders: IUe,
  date: lUe,
  "Preise wurden in den Einstellungen deaktiviert": "Prijzen zijn gedeactiveerd in de instellingen",
  "Keine Einnahmen vorliegend": "Geen inkomsten beschikbaar",
  "total-earnings": "Totale inkomsten",
  Tage: sUe,
  articlename: aUe,
  articles: cUe,
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'Je kunt een configurator exporteren onder "Instellingen". Je kunt het resulterende bestand hier importeren.',
  "Leerer Konfigurator": "Lege configurator",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Begin met een lege configurator en stel deze in volgens jouw wensen.",
  "Konfigurator importieren": "Configurator importeren",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importeer een configurator met behulp van een geëxporteerd bestand.",
  Veröffentlicht: "Gepubliceerd",
  Konfigurationen: dUe,
  "Mandant hat noch keinen Konfigurator": "De klant heeft nog geen configurator",
  Konfigurator: CUe,
  "Link kopiert": "link gekopieerd",
  "E-Mail": "e-mail",
  "Werben Sie K3 Kunden!": "K3-klanten werven!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Deel de link hieronder. Als uw contactpersoon een configurator boekt, ontvangt u een commissie.",
  Partner: uUe,
  Provision: AUe,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Houd er rekening mee dat eventuele uitgegeven affiliate-links ongeldig worden zodra u de code wijzigt.",
  "Meine Kunden": "Mijn klanten",
  "Vielen Dank für Ihre Bestätigung...": "Bedankt voor je bevestiging...",
  "E-Mail Bestätigung": "Bevestiging per e-mail",
  "Zur Anmeldung": "Naar de registratie",
  Händlerprofil: "Profiel dealer",
  Erstellen: bUe,
  name: mUe,
  email: hUe,
  "E-Mail ist ungültig!": "E-mail is ongeldig!",
  Nutzerkonto: pUe,
  Nutzername: BUe,
  "Mail ist schon vergeben": "Mail is al bezet",
  "code-duplicate": "Deze code is al bezet",
  "dealer code helper text": "Om de dealerconfigurator op te roepen.",
  "default discount": "standaard korting",
  "Kann pro Konfigurator überschrieben werden.": "Kan worden overschreven per configurator.",
  "default surcharge": "standaardtoeslag",
  "Pro Abo": "Per abonnement",
  "is pro dealer": "Kunnen de configurator op hun eigen website gebruiken en het ontwerp aanpassen",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Controleer de informatie die je hebt verstrekt: ",
  "Fehlendes Produkt": "Ontbrekend product",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Wil je dat je dealers een van je configurators kunnen gebruiken?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Boek daar eerst een ander product.",
  "new dealer": "Nieuwe dealer",
  "Login screen": "Registratie",
  "Bitte am Desktop öffnen": "Openen op bureaublad",
  Password: ZUe,
  Login: fUe,
  "Passwort vergessen?": "Wachtwoord vergeten?",
  "Noch kein Konto?": "Nog geen account?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Helaas was het niet mogelijk om in te loggen. De combinatie van e-mail en wachtwoord is ongeldig.",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Helaas was het niet mogelijk om in te loggen. Sta websitecookies toe in uw browserinstellingen",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Als de mail niet binnen een paar minuten aankomt, controleer dan je SPAM-map en controleer je adres.",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "We sturen je een e-mail met instructies voor het instellen van een nieuw wachtwoord.",
  "Mail senden": "Mail sturen",
  Registrierung: GUe,
  "Ihre E-Mail-Adresse": "Je e-mailadres",
  "Bitte wählen Sie ein Kennwort": "Kies een wachtwoord",
  "Bitte bestätigen Sie unsere ": "Bevestig onze ",
  Datenschutzbestimmungen: yUe,
  " und unsere ": " en onze ",
  AGB: WUe,
  "Jetzt registrieren": "Nu registreren",
  "Die Registrierung war leider nicht möglich.": "Helaas was registratie niet mogelijk.",
  "Herzlich willkommen!": "Een warm welkom!",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "We hebben je een e-mail gestuurd - controleer ook je spamfolder.",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Je kunt je nu ook registreren met je gegevens:",
  "Wir haben Ihr Kennwort neu gesetzt.": "We hebben je wachtwoord opnieuw ingesteld.",
  "Passwort setzen": "Wachtwoord instellen",
  Passwort: SUe,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Minimaal 8 tekens, hoofdletters, kleine letters en cijfers",
  Bestätigung: "Bevestiging",
  "Bestätigung stimmt nicht überein": "Bevestiging komt niet overeen",
  "Kennwort setzen": "Wachtwoord instellen",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - de 3D-productconfigurator voor Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "U heeft de Shopify-app voor de K3-configurator succesvol geïnstalleerd. Dit zijn de volgende stappen:",
  "Registrieren Sie sich am K3.": "Registreer bij K3.",
  "Legen Sie einen Konfigurator an.": "Maak een configurator.",
  "Jetzt starten": "Nu starten",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Verbind de configurator met uw winkel en importeer uw Shopify-artikelen.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Ontwerp de configurator voor uw product.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Voeg de configurator toe aan uw winkel.",
  Editor: VUe,
  "Mandant: ": "Klant: ",
  "Erstellt am: ": "Gemaakt op: ",
  "Veröffentlicht am: ": "Gepubliceerd op: ",
  "Noch nicht veröffentlicht": "Nog niet gepubliceerd",
  "Version: ": "Versie: ",
  "Artikel-Version: ": "Artikelversie: ",
  "Code: ": "Code: ",
  "Typ: ": "Type: ",
  Standard: wUe,
  "Shop: ": "Winkelen: ",
  "Nicht verbunden": "Niet aangesloten",
  "Bestellungen insgesamt": "Totaal bestellingen",
  Veröffentlichungen: "Publicaties",
  Version: vUe,
  "Artikel-Version": "Artikel versie",
  Buchungen: RUe,
  Plattform: XUe,
  Intervall: HUe,
  Benutzer: kUe,
  Subscription: FUe,
  CustomerID: YUe,
  Aktiv: xUe,
  Seit: DUe,
  "Abschlag [%]": "Korting [%]",
  "Aufschlag [%]": "Toeslag [%]",
  Query: JUe,
  Aktionen: KUe,
  "Mandanten wechseln": "Klanten veranderen",
  "Konnte nicht gespeichert werden: ": "Kon niet worden opgeslagen: ",
  Type: EUe,
  "Angelegt am": "Gemaakt op",
  "Zum AdminPanel": "Naar het beheerpaneel",
  "App editieren": "Bewerk app",
  Monat: NUe,
  Jahr: LUe,
  Buchung: TUe,
  "Stripe Subscription": "Stripe Abonnement",
  "Bezahlt?": "Betaald?",
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Bevestiging mislukt. De namen komen niet overeen.",
  "Einstiegs-Produkt": "Instapproduct",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "Streep ID",
  Parameter: MUe,
  "Partner?": "Partner?",
  Kunden: UUe,
  ID: PUe,
  Rechnungen: zUe,
  Leer: OUe,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "De volledige client wordt geëxporteerd, inclusief alle onderdelen. Ga verder?",
  Wechseln: QUe,
  "Mandant unwiderruflich löschen": "Klant onherroepelijk verwijderen",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "De hele client wordt onherroepelijk verwijderd - inclusief alle activa. Heeft u een export gemaakt? Doorgaan?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Bevestig de naam van de klant die verwijderd moet worden:",
  Nutzer: jUe,
  "Mandant erfolgreich gelöscht": "Client succesvol verwijderd",
  "Mandanten editieren": "Klanten bewerken",
  Rolle: _Ue,
  Konfiguratoren: $Ue,
  Händleraktivierungen: "Dealer activeringen",
  Startdatum: qUe,
  Enddatum: ePe,
  Schritte: tPe,
  Werte: iPe,
  Regeln: nPe,
  Regelzeilen: gPe,
  Modelle: rPe,
  Materialien: oPe,
  Gelöscht: "Verwijderd",
  Merkmal: IPe,
  Regel: lPe,
  Nummer: sPe,
  Status: aPe,
  Erstellt: cPe,
  Zurücklegen: "Terugzetten",
  Mindestlänge: "Minimale lengte {{chars}} tekens",
  "Email Adresse ist ungültig": "E-mailadres is ongeldig",
  Kennwort: dPe,
  "Test stimmt nicht überein": "Test komt niet overeen",
  "Telefonnummer ist ungültig": "Telefoonnummer is ongeldig",
  "Entwickler Modus": "Ontwikkelaarsmodus",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Geeft ontwikkelaars toegang tot uitgebreide mogelijkheden.",
  "API Token": "API Token",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Als je een nieuw API token aanmaakt, worden alle vorige token verwijderd.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Dit betekent dat al je aangesloten winkels ook geen toegang meer hebben tot de configurator.",
  "Sie können das Token im Shop-Plugin eintragen.": "Je kunt het token invoeren in de winkelplugin.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Noteer het nieuwe token, het wordt hier maar één keer weergegeven.",
  Neu: CPe,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "De ApiToken geeft een winkel of je eigen ontwikkeling toegang tot je configuratorgegevens.",
  "Sie möchten über die API auf den K3 zugreifen?": "Wilt u toegang tot de K3 via de API?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Dan moet u een overeenkomstig product boeken voor ten minste één van uw configurators.",
  "Neuen Nutzer anlegen": "Nieuwe gebruiker aanmaken",
  Eingabe: uPe,
  "E-Mail nicht valide!": "E-mail niet geldig!",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "We sturen de nieuwe gebruiker een e-mail met een link. Daar kunnen ze hun wachtwoord instellen en vervolgens toegang krijgen tot je configurator.",
  "Nutzer einladen": "Nodig gebruiker uit",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "De gebruiker krijgt toegang tot je klant.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Controleer de informatie die je hebt verstrekt:",
  Einladen: APe,
  "Benutzer einladen": "Nodig gebruikers uit",
  "new user": "Nieuwe gebruiker",
  "CSS-Datei auswählen": "Selecteer CSS-bestand",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Wil je dynamische modellen gebruiken om bijvoorbeeld producten op maat te verkopen?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Het model overschrijdt met {{curr}} het aanbevolen aantal {{max}} driehoeken. Er kunnen problemen zijn in de AR-modus.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Het model overschrijdt de aanbevolen bestandsgrootte van {{curr}}MB, het model overschrijdt de aanbevolen bestandsgrootte van {{max}}MB.",
  "3D-Modell auswählen": "Selecteer 3D-model",
  Download: bPe,
  Hintergrundmodell: mPe,
  "material-upload": "materiaal-upload",
  Favoriten: hPe,
  "main-model": "Hoofdmodel",
  "Wirft Schatten": "Werpt schaduwen",
  "Wird schattiert": "Wordt gearceerd",
  "Bilder Galerie": "Afbeeldingen galerij",
  Anlegen: pPe,
  "Neue Aktion": "Nieuwe actie",
  Preiseinstellungen: BPe,
  "Preise im Konfigurator ausblenden?": "Prijzen verbergen in de configurator?",
  Hauptaktion: ZPe,
  Kontaktformular: fPe,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Je kunt deze klantgegevens wel vastleggen, maar niet bekijken.",
  Pflichtfeld: GPe,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'Je kunt links naar je eigen documenten opnemen met <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">privacyverklaringen</a>.',
  Aktionsname: yPe,
  "Shop verbinden": "Winkel aansluiten",
  "Überschrift Bestätigung": "Rubriek Bevestiging",
  "Text Bestätigung": "Tekstbevestiging",
  "Link zur Konfiguration zeigen?": "Link naar configuratie weergeven?",
  "Thumbnail des Konfigurators": "Miniatuurafbeelding van de configurator",
  "Artikel hat keinen Namen und keine Nummer!": "Artikel hat keinen Namen und keine Nummer!",
  "Kein Artikel ausgewählt!": "Geen item geselecteerd!",
  "Artikel auswählen": "Selecteer artikel",
  "Artikelanzahl und Menge": "Aantal artikelen en hoeveelheid",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "Hoe vaak het overeenkomstige artikel moet worden toegevoegd",
  Anzahl: WPe,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Relevant voor de stuklijst, bijvoorbeeld voor de lengte van een paal",
  "Menge (optional)": "Hoeveelheid (optioneel)",
  Anzahlberechnung: SPe,
  Mengenberechnung: VPe,
  Artikelaktion: wPe,
  "Wert eingeben": "Waarde invoeren",
  "Neue Spalte": "Nieuwe column",
  "Wert-Eigenschaft": "Waarde eigenschap",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Je kunt eigenschappen toekennen aan de waarden van dit kenmerk, bijvoorbeeld gewicht of kwaliteitsklasse of prestatie. Je kunt deze eigenschappen voor elke waarde apart invoeren en ze vervolgens uitvoeren naar de gebruiker. Je kunt deze eigenschappen ook gebruiken om regels en berekeningen veel eenvoudiger te maken.",
  "Eigenschaft wird dem Nutzer angezeigt": "Eigenschap wordt weergegeven aan de gebruiker",
  "mehrsprachiger Text": "meertalige tekst",
  "nicht übersetzter Text": "onvertaalde tekst",
  Zahl: vPe,
  Einheit: RPe,
  "Fokus auf Modelle": "Focus op modellen",
  "Alle Modelle": "Alle modellen",
  "Fokus über Objektnamen": "Focus via objectnamen",
  Fokustyp: XPe,
  "Dynamischer Fokus": "Dynamische focus",
  "Statischer Fokus": "Statische focus",
  "Screenshot Auflösung": "Resolutie schermafbeelding",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Noodzakelijk verschil met de huidige weergave",
  "Aktuelle Ansicht übernehmen und Speichern": "Huidige weergave accepteren en opslaan",
  "Kamera bearbeiten": "Camera bewerken",
  "Noch keine Kamera gespeichert": "Nog geen camera opgeslagen",
  Kamera: HPe,
  Schritt: kPe,
  Kameraansicht: FPe,
  "Kamera speichern": "Camera opslaan",
  "Bitte auswählen": "Selecteer",
  Ausgewählt: "Geselecteerd",
  "Merkmal setzen: ": "Functie instellen: ",
  "Keine Farbe ausgewählt!": "Geen kleur geselecteerd!",
  "Farbe auswählen": "Selecteer kleur",
  "Farbmerkmal auswählen:": "Selecteer kleurkenmerk:",
  "Keine Auswahl": "Geen selectie",
  "Hoch schieben": "Opdrukken",
  "Runter schieben": "Druk omlaag",
  Duplizieren: YPe,
  "Löschen des aktiven Elements nicht möglich": "Verwijderen van het actieve element niet mogelijk",
  "Komponente hinzufügen": "Component toevoegen",
  Entfernen: xPe,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Je configuratie kon niet worden opgeslagen.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Neem het ons niet kwalijk. We hebben de configuratie opgeslagen in deze browser. Kom later nog eens terug.",
  "technische Information:": "technische informatie:",
  Auswahlen: DPe,
  "Preis: ": "Prijs: ",
  "Kameras für Bestellungsbilder": "Camera's voor bestelbeelden",
  Kameras: JPe,
  "Anfrage erhalten": "Verzoek ontvangen",
  "Buchung erfolgreich": "Succesvol boeken",
  "Für das neue Produkt melden wir uns bei Ihnen.": "We nemen contact met je op voor het nieuwe product.",
  "Ihre Subskription wurde angepasst.": "Je abonnement is aangepast.",
  "Ihre Subskription wurde beendet.": "Je abonnement is geannuleerd.",
  "Das Produkt wurde gebucht.": "Het product is geboekt.",
  "Meine Rechnungen": "Mijn facturen",
  "Auf Anfrage": "Op aanvraag",
  Kostenfrei: KPe,
  "{{fee}},- EUR pro {{interval}}": "{{fee}},- EUR per {{interval}}",
  "Derzeit gebucht.": "Momenteel geboekt.",
  "Änderung Ihrer Buchung": "Je boeking wijzigen",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "Je bent nu een nieuw product aan het boeken. Wil je doorgaan?",
  Downgrade: EPe,
  "Zahlungsplan ändern": "Betalingsplan wijzigen",
  "Ihre K3 Buchung": "Je K3 boeking",
  Monatlich: NPe,
  Jährlich: "Jaarlijks",
  "In neuem Tab öffnen": "In nieuw tabblad openen",
  "Konfigurator anpassen": "Configurator aanpassen",
  "main drawer": "Je ziet een voorbeeld van je configurator, die je zoals gewoonlijk kunt bedienen. Klik op een potloodpictogram om iets te wijzigen of:",
  "Ändern Sie die Bestelloptionen": "De bestelopties wijzigen",
  "Ändern Sie das Design": "Verander het ontwerp",
  "Passen sie die 3D Szene an": "De 3D-scène aanpassen",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "De huidige camera opslaan voor bestelafbeeldingen",
  "Merkmale verwalten": "Functies beheren",
  "Nutzen Sie die Hilfe": "Gebruik de helpfunctie",
  "So richten Sie Ihren Konfigurator ein:": "Hoe je je configurator instelt:",
  Home: LPe,
  Hilfe: TPe,
  "dealer sidebar": "Je kunt je dealerconfigurator hier instellen",
  "change design": "Verander het ontwerp",
  "change logo": "Wijzig het logo",
  "change price": "Wijzig de prijs",
  "change pdf": "De PDF-sjabloon wijzigen",
  "PDF Gestaltung": "PDF Ontwerp",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Upload een PDF als sjabloon om af te drukken.",
  cancel: MPe,
  "app surcharge": "Winst instellen",
  "you can change your surcharge here": "Je kunt je toeslag hier wijzigen",
  "Neuer Schritt": "Nieuwe stap",
  Icon: UPe,
  "Icon Bilddatei": "Pictogram afbeeldingsbestand",
  "Icon position": "Positie pictogram",
  "Icon Größe": "Pictogramgrootte",
  "Ersetze Weiter mit Aktionsauswahl": "Vervang Volgende door Actieselectie",
  "Aktionsnamen überschreiben": "Actienamen overschrijven",
  "Individuelles Design": "Ontwerp op maat in één stap",
  "Merkmale editieren": "Functies bewerken",
  "Keine Ergebnisse": "Geen resultaten",
  "Desktop Layout": "Bureaubladindeling",
  "Mobile Layout": "Mobiele lay-out",
  "Schritte nacheinander einblenden": "Laat de stappen na elkaar zien",
  "Besuchte Schritte abhaken": "Bezochte stappen afvinken",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "U gebruikt momenteel een niet langer ondersteund layout. Kies alstublieft een nieuw layout.",
  "Dieses Layout selbst anpassen": "Pas deze lay-out zelf aan",
  "Eigenes Layout erstellen": "Maak je eigen lay-out",
  "Angepasstes Layout anwenden": "Aangepaste lay-out toepassen",
  Schließen: "Sluit",
  Logo: PPe,
  "Konfigurator-Abschluss": "Configurator voltooien",
  "3D Szene": "3D Scène",
  "Manuelle Einstellung erstellen": "Handmatige instelling maken",
  "Design & Theme": "Ontwerp en thema",
  Farben: zPe,
  "Farbanpassungen zurücksetzten": "Kleuraanpassingen resetten",
  CSS: OPe,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Je kunt het uiterlijk van je configurator ook aanpassen met CSS:",
  "Link zur CSS-Datei": "Link naar het CSS-bestand",
  "Oder laden Sie eine CSS Datei hoch:": "Of upload een CSS-bestand:",
  "Neues Merkmal": "Nieuwe functie",
  "Merkmal kopieren": "Kenmerk kopiëren",
  Zurücksetzen: "Resetten",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "U reset de configurator naar de gekozen versie.",
  Einstellungen: QPe,
  "Dynamische Texte": "Dynamische teksten",
  "Texte und Einstellungen anpassen": "Teksten en instellingen aanpassen",
  Vorschau: jPe,
  Articles: _Pe,
  Bestellungen: $Pe,
  Statistics: qPe,
  "Inhalte: ": "Inhoud: ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': 'Voordat de configurator gebruikt kan worden, moet je op de knop "Publish" drukken. Als je dan wijzigingen aanbrengt, worden deze pas van kracht na de volgende publicatie.',
  "Live Version": "Live versie",
  Veröffentlichen: "Publiceer",
  "Erstelle Option: ": "Maak optie: ",
  Fehler: eze,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "Er is een fout opgetreden tijdens het renderen van de inhoud.",
  Fatal_Error_Text: tze,
  Fatal_Error: ize,
  "Fehlermeldung:": "Foutmelding:",
  "Zur Startseite": "Naar de homepage",
  "Neu Laden": "Nieuwe winkel",
  "Cleanup und Neu Laden": "Opruimen en opnieuw laden",
  "You may need to reload the page": "Het opnieuw laden van de pagina kan nodig zijn",
  Error_Message: nze,
  "(SU) Client wechseln": "(SU) Klant wijzigen",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "De app is nog niet gepubliceerd. Daarom kunnen er fouten optreden bij het openen van deze configuratie. Hoe nu verder?",
  "Elemente löschen": "Elemente löschen",
  "Element löschen": "Element verwijderen",
  "Selektierte Elemente löschen": "Selektierte Elemente löschen",
  "Alle selektierte Elemente löschen": "Alle selektierte Elemente löschen",
  "Lösch-Konflikte anzeigen": "Verwijderingsconflicten weergeven",
  "Das Element": "Het element",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Wil je dit element echt permanent verwijderen?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "De volgende redenen spreken tegen annulering:",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Einige Elemente werden noch an anderen Stellen verwendet:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} wordt ook op andere plaatsen gebruikt:",
  "{{label}} wird noch verwendet in ": "{{label}} wordt nog steeds gebruikt in ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "van een extensie. Vraag de ontwikkelaar om het gebruik te verwijderen en verwijder vervolgens de sleutel.",
  "der Definition der Regel": "de definitie van de regel",
  "einem Eintrag in Regel": "een vermelding in regel",
  "einer berechneten Eigenschaft des Modells": "een berekende eigenschap van het model",
  "der Formel von": "de formule uit",
  "der Kamera": "de camera",
  "des Merkmals": "van de karakteristieke",
  "des Schrittes": "van de stap",
  "der globalen Kamera": "de wereldwijde camera",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Verwijder eerst de andere verwijzingen.",
  "Neuen Schritt hinzufügen": "Nieuwe stap toevoegen",
  "Bitte legen Sie einen Schritt an!": "Maak alsjeblieft een stap!",
  "Schritt editieren": "Bewerk stap",
  Bestelloptionen: gze,
  "Merkmal editieren": "Functie bewerken",
  "Mehr Informationen anzeigen": "Meer informatie tonen",
  "Nicht Aktiv": "Niet actief",
  "Keine Angabe": "Niet gespecificeerd",
  "Fokus:": "Focus:",
  "Fokus: ": "Focus: ",
  hiddenGroup: rze,
  "Label eingeben": "Label invoeren",
  "Bilder auswählen": "Afbeeldingen selecteren",
  "Ordner auswählen:": "Selecteer map:",
  "Bildmerkmal: ": "Afbeelding: ",
  "Kein Bild ausgewählt": "Geen afbeelding geselecteerd",
  "Bild auswählen": "Afbeelding selecteren",
  "Bildmerkmal auswählen:": "Selecteer afbeeldingsfunctie:",
  Befüllt: "Gevuld",
  "Zustand auswählen": "Selecteer status",
  "Kein Komponente ausgewählt!": "Geen component geselecteerd!",
  "Komponente auswählen": "Selecteer component",
  "Intervall eingeben": "Interval invoeren",
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen": "Deze selectie kan reeds gemaakte selecties ongedaan maken",
  "Zum Dashboard": "Naar het dashboard",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Stelt de primaire kleur (voor tabbladen, knoppen enz.) en de contrastkleur (voor knoptekst) in.",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Stelt de secundaire kleur (secundaire knoppen) en de contrastkleur (knop tekst) in.",
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Stelt de gewone tekstkleur en de secundaire kleur in (bijvoorbeeld voor beschrijvingen)",
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Stelt de gewone achtergrondkleur in en die van de licht gemarkeerde gebieden (bijv. kenmerken)",
  "Setzt die Farbe der Info-Icons": "Stelt de kleur van de info-pictogrammen in",
  "Setzt die Farbe der Warnhinweise": "Stelt de kleur van de waarschuwingsberichten in",
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Stelt de kleur in voor foutmeldingen en notities",
  Basiseinstellungen: oze,
  "Helles Theme": "Licht thema",
  "Erweiterte Einstellungen": "Geavanceerde instellingen",
  "Label hinzufügen: ": "Label toevoegen: ",
  "Kein Label ausgewählt!": "Geen label geselecteerd!",
  "Was soll angezeigt werden?": "Wat moet er worden weergegeven?",
  Maximalgröße: "Maximale grootte",
  Deckkraft: Ize,
  "Kein Material ausgewählt!": "Geen materiaal geselecteerd!",
  "Material auswählen": "Materiaal kiezen",
  "Material auswählen:": "Selecteer materiaal:",
  Materialaktion: lze,
  Farbaktion: sze,
  Bildaktion: aze,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Beperking van effecten tot bepaalde modellen",
  Hinzufügen: "Voeg  toe",
  "Welches Teil soll hinzugefügt werden?": "Welk deel moet worden toegevoegd?",
  Hinweis: cze,
  Achtung: dze,
  Fortfahren: Cze,
  "Kein Modell ausgewählt!": "Geen model geselecteerd!",
  "Modell auswählen": "Model kiezen",
  "Modell hinzufügen:": "Model toevoegen:",
  "Globale Änderung": "Wereldwijde verandering",
  Oberflächen: "Oppervlakken",
  "Ausgewählte Oberflächen": "Geselecteerde oppervlakken",
  "Eintrag darf nicht leer sein.": "De invoer mag niet leeg zijn.",
  "Alle Werte": "Alle waarden",
  "Werte auswählen": "Selecteer waarden",
  "Sortierung anwenden": "Sorteren toepassen",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Het bestandsformaat is niet toegestaan! Geen bestand geselecteerd.",
  "Erlaubte Formate:": "Toegestane formaten:",
  "Keine Datei gewählt.": "Geen bestand geselecteerd.",
  "Datei konnte nicht hochgeladen werden.": "Datei konnte nicht hochgeladen werden.",
  "Dieses Merkmal ist nicht erlaubt.": "Deze functie is niet toegestaan.",
  "Merkmal-Optionen": "Functieopties",
  "Merkmal Beschreibung editieren": "Bewerken Beschrijving",
  "Merkmal-Info editieren": "Info bewerken",
  Versteckt: uze,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Dit kenmerk wordt niet weergegeven. De waarde kan echter wel worden gebruikt in regels en berekeningen.",
  "showSelection.label": "showSelectie.label",
  "Aus Schritt verstecken": "Verstop je in je kruis",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "Deze optie heeft alleen zin als het kenmerk op een andere locatie wordt getoond of verborgen via een aangepaste lay-out. Zelfs als het verborgen is voor de stap, wordt het er nog steeds aan toegewezen in samenvattingen.",
  "Kamera-Optionen": "Camera-opties",
  "Vorlage wählen": "Selecteer sjabloon",
  "Konfigurator erstellen": "Configurator maken",
  "Willkommen in Ihrem neuen K3 Konto!": "Welkom op je nieuwe K3 account!",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Stel meteen je eerste configurator in:",
  "Sie können alle Daten natürlich später noch ändern.": "Je kunt natuurlijk alle gegevens later wijzigen.",
  "Nicht veröffentlicht": "Niet gepubliceerd",
  "Ladevorgang fehlgeschlagen": "Oplaadproces mislukt",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "De configuratie kon niet worden geladen! Probeer het later nog eens!",
  "Keine Optionen": "Geen opties",
  "Neuen Artikel anlegen": "Nieuw artikel maken",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Hier kun je een nieuw artikel maken met prijs.",
  articleNo: Aze,
  articleName: bze,
  currency: mze,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Posities veranderen",
  "Abbrechen durch Klick": "Klik om te annuleren.",
  Wert: hze,
  "Preis eingeben": "Prijs invoeren",
  Währung: "Valuta",
  "Währung eingeben": "Valuta invoeren",
  "Einheit eingeben": "Eenheid invoeren",
  "Startdatum eingeben": "Startdatum invoeren",
  "Enddatum eingeben": "Einddatum invoeren",
  Startanzahl: pze,
  "Startanzahl eingeben": "Aantal starts invoeren",
  Endanzahl: Bze,
  "Endanzahl eingeben": "Voer het uiteindelijke nummer in",
  Priorität: "Prioriteit",
  "Priorität eingeben": "Prioriteit invoeren",
  "Aufschlag?": "Serveren?",
  "Preistyp eingeben": "Prijstype invoeren",
  "Neuer Preis": "Nieuwe prijs",
  Suchen: Zze,
  Auswählen: "Selecteer",
  "Wählen Sie eine Vorlage aus:": "Selecteer een sjabloon:",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Of maak een nieuwe configurator zonder sjabloon: ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Moeten we nu je configurator maken?",
  "Wir bringen Sie danach direkt in den Editor.": "We brengen je dan rechtstreeks naar de redacteur.",
  "Anlegen & zum Konfigurator": "Maken & naar de configurator",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: fze,
  OK: Gze,
  "Farbenanzahl im Fenster": "Aantal kleuren in het venster",
  "Farbkachel Rundung": "Kleur tegelafronding",
  Opazität: "Opaciteit",
  Hervorhebung: yze,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Ongeldig geworden instanties verwijderen (in plaats van ze te vervangen)",
  "Drag & Drop erlauben": "Slepen en neerzetten toestaan",
  "Anzeige der Sortierungsschaltflächen": "Weergave van de sorteerknoppen",
  "Sortierung umkehren": "Omgekeerd sorteren",
  "Duplizierung erlauben": "Duplicatie toestaan",
  "Zeige Werte aus inneren Merkmalen an": "Waarden van interne kenmerken weergeven",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Verberg altijd de karakteristieke naam van de binnenste waarden, zelfs als er meerdere waarden zijn",
  "Innere Merkmalsnamen ausblenden": "Namen van interne kenmerken verbergen",
  "Als Warenkorb setzen?": "Instellen als winkelmand?",
  "Gruppieren nach": "Groep door",
  "Komponenten direkt unter der Liste anzeigen": "Komponenten direkt unter der Liste anzeigen",
  Expression: Wze,
  "Erfolgreich gespeichert": "Succesvol opgeslagen",
  "Formel Editor": "Formule-editor",
  "Geben Sie Formeln von Merkmalen ein.": "Formules invoeren voor kenmerken.",
  " Schreiben Sie z.B. Länge * Breite.": " Schrijf bijvoorbeeld lengte * breedte.",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Gebruik voor een attribuut bijvoorbeeld Motor.power als Motor je kenmerk is en Power het bijbehorende attribuut.",
  Ergebnis: Sze,
  "Keine Formel eingegeben": "Geen formule ingevoerd",
  "Formel: ": "Formule: ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Er zijn nog niet genoeg selecties om een voorbeeld weer te geven.",
  "Ergebnis: ": "Resultaat: ",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "De originele textuur vervagen bij het afdrukken?",
  "Erlaube Bildformate": "Afbeeldingsformaten toestaan",
  "Minimum Horizontale Positionierung": "Minimale horizontale positionering",
  "Maximum Horizontale Positionierung": "Maximale horizontale positionering",
  "Minimum Vertikale Positionierung": "Minimale verticale positionering",
  "Maximum Vertikale Positionierung": "Maximale verticale positionering",
  "Minimale Skalierung": "Minimale schaling",
  "Maximale Skalierung": "Maximaal schalen",
  Mindestwert: Vze,
  "-Unendlich": "-Oneindig",
  Maximalwert: wze,
  Unendlich: vze,
  "Optionaler Standardwert": "Optionele standaardwaarde",
  Nachkommastellen: Rze,
  Schrittweite: Xze,
  "Zeige Knöpfe an": "Knoppen weergeven",
  "Benutze Vielfaches der Schrittweite": "Gebruik veelvouden van de increment",
  Berechnet: Hze,
  "Zyklus Erkennung deaktivieren": "Cyclusdetectie uitschakelen",
  Ändern: "Verander",
  "Beispielhafte Beschreibung eines Wertes.": "Voorbeeldbeschrijving van een waarde.",
  "Dies ist nur eine Info": "Dit is slechts een info",
  "Color Dropdown": "Kleur selectie dropdown",
  "Color Radio": "Kleurselectie radio",
  "Color Radio Cards": "Radio kleurenkaarten",
  Farbauswahl: kze,
  Komponentenliste: Fze,
  "Komponentenliste mit Popup": "Onderdelenlijst met popup",
  Komponentenkarten: Yze,
  Bildauswahl: xze,
  Informationen: Dze,
  Zahleneingabe: Jze,
  "Radio Buttons": "Radioknoppen",
  "Radio Cards": "Radiokaarten",
  "RAL-Farbauswahl": "RAL-kleurselectie",
  Dropdown: Kze,
  Thumbnails: Eze,
  Schalter: Nze,
  "Schalter Card": "Schakelkaart",
  Texteingabe: Lze,
  Beispieltext: Tze,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Conflictoplossing met individuele kenmerken automatisch accepteren",
  "Übergeordnete Merkmale": "Bovenliggende kenmerken",
  "Darstellungs-Optionen": "Weergaveopties",
  Optional: Mze,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': 'Onder "Waarden" vind je dan het speciale item "Geen specificatie". Hier kun je nog aanpassen wat de gebruiker te zien krijgt als hij niets heeft geselecteerd.',
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "De selectie wordt niet weergegeven in de bevestiging, PDF of in de winkel als er niets is geselecteerd.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Selectie alleen tonen als geselecteerd",
  "Konfigurator erfolgreich veröffentlicht.": "Configurator succesvol gepubliceerd.",
  "Folgende Änderungen werden veröffentlicht:": "De volgende wijzigingen worden gepubliceerd:",
  "Konfigurator veröffentlichen": "Configurator publiceren",
  "Sie möchten den Konfigurator veröffentlichen?": "Wil je de configurator publiceren?",
  "Wertebereich angeben": "Geef waardebereik op",
  "Merkmale: ": "Kenmerken: ",
  "Aktionen: ": "Acties: ",
  "Diese Regel ist aktuell deaktiviert.": "Deze regel is momenteel gedeactiveerd.",
  "Modell Eigenschaften anpassen": "Modeleigenschappen aanpassen",
  Labelaktion: Uze,
  Fehlermeldung: Pze,
  "Merkmale entfernen": "Functies verwijderen",
  "Merkmale ausblenden": "Functies verbergen",
  "Schritt entfernen": "Stap verwijderen",
  "Schritt ausblenden": "Stap verbergen",
  "Werte ausblenden": "Waarden verbergen",
  Modelaktion: zze,
  "Bitte fügen Sie neue Regelzeilen hinzu.": "Voeg nieuwe regels toe.",
  "Andernfalls wird diese Regel bei der Auswertung nicht beachtet.": "Anders wordt deze regel niet nageleefd tijdens de evaluatie.",
  "Keine Warnungen": "Geen waarschuwingen",
  "Selektions-Bearbeitung": "Selectie bewerken",
  "Alle Regeln ansehen": "Bekijk alle regels",
  Position: Oze,
  "Rotation (in radiant)": "Rotatie (in radialen)",
  Scale: Qze,
  "Regel Bearbeitung": "Regel bewerken",
  "Kein Label angegeben!": "Geen label gespecificeerd!",
  "Regel Validierung": "Regelvalidatie",
  "Fehlende Werte": "Ontbrekende waarden",
  "Aktive Schritte": "Actieve stappen",
  Modell: jze,
  Material: _ze,
  Komponenten: $ze,
  Druck: qze,
  "Kein Modell": "Geen model",
  Regelname: e4e,
  "Wird angewendet": "Wordt toegepast",
  Gültigkeitsregeln: "Geldigheidsregels",
  "Gültigkeit prüfen?": "Geldigheid controleren?",
  Merkmalskombinationen: t4e,
  Produktstruktur: i4e,
  "Merkmale entfernen (veraltet)": "Functies verwijderen (verouderd)",
  "Schritt entfernen (veraltet)": "Verwijder stap (verouderd)",
  "Anzeige von 3D-Modellen": "3D-modellen weergeven",
  "Anzeige von Informationen": "Informatie weergeven",
  "Anzeige von Fehlermeldungen": "Anzeige von Fehlermeldungen",
  "Austauschen von Oberflächen": "Oppervlakken vervangen",
  "Bilder auf Oberflächen drucken": "Afbeeldingen afdrukken op oppervlakken",
  Materialnamen: n4e,
  "Wählen Sie ein Materialnamen aus.": "Selecteer een materiaalnaam.",
  "Ändern der Farbe": "De kleur veranderen",
  "Anzeige von Bildern": "Afbeeldingen weergeven",
  "Preise & Artikel": "Prijzen & Artikelen",
  "Weitere Bedingungen": "Verdere voorwaarden",
  "Artikel zur Stückliste hinzufügen": "Item toevoegen aan stuklijst",
  "Zugeordnete Merkmale": "Toegewezen kenmerken",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Selecteer de kenmerken waaraan de artikelen moeten worden toegewezen",
  "Befüllen von Komponentenmerkmalen": "Kenmerken vulcomponent",
  Komponentenmerkmale: g4e,
  "Wählen Sie Komponentenmerkmale aus.": "Selecteer componentfuncties.",
  "Oberflächenaktion hinzufügen": "Oppervlakte-actie toevoegen",
  "Alle auswählen": "Alles selecteren",
  "Alle abwählen": "Alles deselecteren",
  "Auswahl umkehren": "Selectie omkeren",
  Herunterladen: r4e,
  "Jetzt verbinden": "Nu aansluiten",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "Het flexibele winkelsysteem voor uw e-commerceproject.",
  "Jetzt Installieren": "Nu installeren",
  "Die globale Commerce-Plattform.": "Het wereldwijde e-commerceplatform.",
  "Die E-Commerce-Plattform für WordPress.": "Het e-commerceplatform voor WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Het enige Europese open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Nu Adobe Commerce: E-commerce gemakkelijk gemaakt.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Eersteklas digitale verkoop met de Oxid esales shop.",
  "Individuelle Entwicklung": "Individuele ontwikkeling",
  "Shop mit einer individuellen Entwicklung anbinden.": "Winkel met ontwikkeling op maat.",
  "Bitte nutzen Sie stattdessen unsere Shopify App.": "Gebruik in plaats daarvan onze Shopify-app.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Download eerst een van onze plugins en installeer deze in je shop:",
  "Verbinde Shop": "Winkel aansluiten",
  " und importiere Artikel": " en importartikelen",
  "Fehler beim Verbinden:": "Fout bij verbinden:",
  "Shop erfolgreich verbunden.": "Winkel succesvol aangesloten.",
  "Fehler beim Verbinden: ": "Fout bij verbinden: ",
  "Shop-Anbindung": "Winkelaansluiting",
  "Web-Adresse des Shops": "Webadres van de winkel",
  "Shopify Admin API Key": "Shopify Admin API sleutel",
  "Sollen die Artikel aus dem Shop importiert werden?": "Moeten de artikelen uit de winkel worden geïmporteerd?",
  "Filter für Artikel": "Filteren op artikelen",
  "Sollen die Artikel regelmäßig importiert werden?": "Moeten de artikelen regelmatig worden geïmporteerd?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Moet het artikelnummer worden overgenomen van de winkel-SKU?",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Moeten de artikelen bij het bestellen worden gegroepeerd?",
  "Basis-Name für kombinierte Artikel": "Basisnaam voor gecombineerde artikelen",
  "Ihre Bestellung {code}": "Jouw bestelling {code}",
  "Shop-Anbindung aufheben": "Winkelverbinding annuleren",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Voeg de configurator toe aan je winkel",
  Verbinden: o4e,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "De HTML-inhoud kon niet worden weergegeven. Maak uw invoer schoon.",
  "Der eingegebe Wert ist nicht gültig: ": "De ingevoerde waarde is ongeldig: ",
  "Ungültiges HTML-Format": "Ongeldig HTML-formaat",
  "Sie können uns den Vorfall hier melden!": "Je kunt het incident hier aan ons melden!",
  "Das Template konnte nicht geladen werden.": "De sjabloon kon niet worden geladen.",
  "Templat auf Voreinstellung zurücksetzen": "Sjabloon terugzetten naar standaardinstelling",
  "Eingaben zurücksetzen": "Invoer opnieuw instellen",
  "Templat bearbeiten": "Sjabloon bewerken",
  "Templat Name": "Naam sjabloon",
  "Templat wählen": "Selecteer sjabloon",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Selecteer een standaardsjabloon om deze aan te passen. Of wijs je eigen naam toe om een aangepaste sjabloon te maken.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "Je hebt nog geen aangepaste sjabloon gemaakt. Voeg er een toe door een standaardsjabloon uit de lijst te selecteren en deze naar wens aan te passen.",
  "Templat hinzufügen": "Sjabloon toevoegen",
  "Ansicht auswählen": "Weergave selecteren",
  "Datei hochladen": "Bestand uploaden",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Reserveer eerst een ander product:",
  "Bitte wählen": "Selecteer",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Deze actie combineert verschillende kenmerken en kan daarom hier niet worden gewijzigd. Wijzig hiervoor direct de volgende regel(s):",
  "Automatisch angelegt": "Automatisch aangemaakt",
  "Aktionen verknüpfen": "Link acties",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Waarden van dit kenmerk moeten de volgende acties triggeren:",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Deze functie kan niet worden gebruikt om andere processen te besturen. Gebruik hiervoor rechtstreeks de regels.",
  "Zu den Regeln": "Naar de regels",
  "Artikel bestellen": "Bestel artikel",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Afhankelijk van de selectie worden er verschillende items toegevoegd aan de stuklijst.",
  "Oberfläche ändern": "Verander oppervlak",
  "Welche Oberflächen sollen geändert werden? ": "Welke oppervlakken moeten worden vervangen? ",
  "3D-Modell anzeigen": "3D-model weergeven",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Afhankelijk van de selectie worden verschillende 3D-modellen weergegeven.",
  "Bild anzeigen": "Afbeelding tonen",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Afhankelijk van de selectie worden verschillende afbeeldingen weergegeven.",
  "Farbe ändern": "Kleur veranderen",
  "Welche Oberflächen sollen eingefärbt werden? ": "Welke oppervlakken moeten worden gekleurd? ",
  "Bild aufdrucken": "Afbeelding afdrukken",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Op welke oppervlakken moet de geüploade afbeelding worden afgedrukt? ",
  "Der Wert wird noch in Regeln verwendet:": "De waarde wordt nog steeds gebruikt in regels:",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Verwijder daar eerst de bijbehorende regel(s).",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Hier kun je instellen wat er moet worden weergegeven als er nog geen waarde is geselecteerd",
  "Dieser Wert ist nicht erlaubt.": "Deze waarde is niet toegestaan.",
  "Maximale Anzahl an Werten ist erreicht.": "Het maximum aantal waarden is bereikt.",
  Farbwert: I4e,
  Anzeige: l4e,
  RAL: s4e,
  "keine RAL Farbe": "Geen RAL-kleur",
  Ansicht: a4e,
  "Key eingeben": "Enter toets",
  URL: c4e,
  "Info-Modal": "Info-Modaal",
  "Info-Content": "Info-inhoud",
  "Dieser Merkmalstyp unterstützt keine Werte.": "Dit kenmerktype ondersteunt geen waarden.",
  "Fehlende RAL Farben hinzufügen": "Ontbrekende RAL-kleuren toevoegen",
  Auswahlwerte: d4e,
  Info: C4e,
  "Typ des Merkmals": "Type kenmerk",
  "es gibt keine Merkmale mit {{identificator}}": "er zijn geen functies met {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "Er is geen attribuut met {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "er is geen selectie met {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "Er is meer dan één selectie met {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "Er zit een cyclus in de berekende karakteristieken: {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "het resultaat van de formule een numerieke waarde moet zijn, is het in plaats daarvan {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "waarde {{paramName}} van de functie {{functionName}} nul is",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "De eigenschap {{variableLabel}} is een componentenlijst. Je moet het benaderen met een index zoals {{variableLabel2}}[0] voor het 1e element of met een arrayfunctie zoals map(), find(), reduce() of first()",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "Er zit een cyclus in de berekende kenmerken.",
  Übersicht: "Rekening-courant",
  Auswahlpreise: u4e,
  Auswahl: A4e,
  Gesamtpreis: b4e,
  "Preis Information": "Prijsinformatie",
  "Persönliche Daten": "Persoonlijke gegevens",
  Weiter: m4e,
  "In AR ansehen": "Bekijk in AR",
  Vollbildmodus: h4e,
  "Komponenten suchen": "Zoeken naar onderdelen",
  "Nicht Gruppiert": "Niet gegroepeerd",
  "Komponenten hinzufügen": "Componenten toevoegen",
  xl: p4e,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "De factuur was echter niet mogelijk en is teruggezet naar de eerst beschikbare optie: ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Deze waarde kan niet worden gecombineerd met de volgende selecties:",
  "Bei Auswahl wird eine Alternative berechnet!": "Indien geselecteerd, wordt een alternatief berekend!",
  Bestätigen: "Bevestig",
  "Produkt hinzufügen": "Product toevoegen",
  "Produkt erfolgreich konfiguriert": "Product succesvol geconfigureerd",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "De configuratie is voltooid. Welk product wil je als volgt toevoegen aan het winkelmandje?",
  "Neues Produkt auswählen": "Een nieuw product kiezen",
  "Neues Produkt hinzufügen": "Een nieuw product toevoegen",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'De selectie "{{value}}" ({{variable}}) leidt tot de ongeldige waarde "{{conflictValue0}}" ({{conflictVariable0}}) en wordt daarom gereset.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Bericht bij het resetten van een ongeldige selectie",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'De selectie "{{value}}" ({{variable}}) komt niet overeen met de selectie "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Kennisgeving in geval van een conflict",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'De selectie "{{value}}" ({{variable}}) komt niet overeen met de selectie "{{conflictValue0}}" ({{conflictVariable0}}) en de selectie "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Bericht wanneer twee conflicten voorkomen",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Kennisgeving bij drie of meer conflicten",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'De selectie "{{value}}" ({{variable}}) komt niet overeen met de selectie "{{conflictValue0}}" ({{conflictVariable0}}), de selectie "{{conflictValue1}}" ({{conflictVariable1}}) en de selectie "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': 'De selectie "{{value}}" ({{variable}}) interfereert niet met andere selecties.',
  Konfliktmeldung: B4e,
  "Anpassung nötig": "Aanpassing",
  "Stattdessen werden folgende Auswahlen angepasst:": "In plaats daarvan worden de volgende selecties aangepast:",
  "wird zu": "wordt",
  "wird entfernt": "zal worden verwijderd",
  "Optionaler weiterer Hinweistext:": "Optionele tekst voor extra informatie:",
  "Auf Facebook teilen": "Deel op Facebook",
  "Auf Twitter teilen": "Deel op Twitter",
  "Auf LinkedIn teilen": "Deel op LinkedIn",
  "Modal Titel": "Modale titel",
  "Desktop Gerät erkannt": "Desktopapparaat herkend",
  "Modal Text": "Modale tekst",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented reality is momenteel alleen beschikbaar op de nieuwste iOS- of AndroidOS-smartphones. Scan gewoon deze QR-code met de camera-app op je smartphone:",
  "Mobiles {{device}}-Gerät erkannt": "Mobiel {{device}} apparaat herkend",
  "Fortschrittsanzeige 3D-Objekt": "Voortgangsindicator 3D-object",
  "Export des 3D-Objekts": "Exporteren van het 3D-object",
  "Fortschrittsanzeige AR-Datei": "Fortschrittsanzeige AR-Datei",
  "Bereitstellen der AR-Datei": "Het AR-bestand aanleveren",
  "Fortschrittsanzeige System": "Systeem voor voortgangsindicatoren",
  "{{device}}-AR-System einrichten": "{{apparaat}}-AR systeem instellen",
  Positionszeile: Z4e,
  "Pos.": "Pos.",
  "Artikelnummer Spalte": "Artikelnummer Kolom",
  "Artikel Spalte": "Artikel Kolom",
  "Artikelpreis Spalte": "Artikel prijs kolom",
  "Artikelmenge Spalte": "Kolom aantal items",
  Menge: f4e,
  "Artikelanzahl Spalte": "Aantal items Kolom",
  "Positionspreis Spalte": "Item prijs kolom",
  Positionspreis: G4e,
  "Hilfetext Preisdetails": "Help-tekst Prijsinformatie",
  "Preisdetails anzeigen": "Toon prijsdetails",
  "Titel bei Versions-Konflikt": "Titel bij versieconflict",
  "Konfigurator wurde aktualisiert": "Configurator is bijgewerkt",
  "Text bei Versions-Konflikt": "Tekst bij versieconflict",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "De configurator is verder ontwikkeld sinds je deze configuratie hebt opgeslagen. Wil je de huidige versie gebruiken en verder werken of alleen de oude versie openen om te bekijken?",
  "Alte Version": "Oude versie",
  "Aktuelle Version": "Huidige versie",
  "Zeige Namen": "Namen tonen",
  "Zeige Beschreibung": "Beschrijving tonen",
  "Zeige Thumbnail": "Toon miniatuur",
  "Zeige Preis an Merkmal": "Toon prijs op functie",
  "Zeige Preise an Werten": "Toon prijzen bij waarden",
  "Zeige URL": "URL tonen",
  "Zeige Info-Button für Werte": "Infoknop tonen voor waarden",
  "Zeige HTML Content für Werte": "Toon HTML-inhoud voor waarden",
  "Kamerafahrt beim scrollen": "Camerabeweging tijdens scrollen",
  "Alle ungültigen Werte ausblenden": "Alle ongeldige waarden verbergen",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Verberg ongeldige, actief gewijzigde waarden",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Verberg als er maar één selectie mogelijk is",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Deactiveren als slechts één selectie mogelijk is",
  "Komponente hervorheben": "Component benadrukken",
  Bild: y4e,
  Text: W4e,
  "Ja/ Nein": "Ja/ Nee",
  Information: S4e,
  Mehrfachauswahl: V4e,
  Liste: w4e,
  Eckenrundung: v4e,
  "Anzahl der Eckenrundungsschritte": "Anzahl der Eckenrundungsschritte",
  "Dieses Material existiert bereits": "Dit materiaal bestaat al",
  "Material hinzufügen": "Materiaal toevoegen",
  "Materialname eingeben": "Voer materiaalnaam in",
  Abmessungen: R4e,
  Breite: X4e,
  Höhe: "Hoogte",
  Tiefe: H4e,
  Startpunkt: k4e,
  Endpunkt: F4e,
  Linienstärke: "Lijndikte",
  Startanker: Y4e,
  Maßkette: "Maatketen",
  Ohne: x4e,
  Endanker: D4e,
  Texttyp: J4e,
  "Kein Text": "Geen tekst",
  Zahlenwert: K4e,
  "Statischer Text": "Statische tekst",
  "Automatisches Maß überschreiben": "Automatische dimensie overschrijven",
  "Neues Maß": "Nieuwe dimensie",
  "Textgröße als Faktor. 1 ist Standard.": "Tekstgrootte als factor. 1 is standaard.",
  Offsets: E4e,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Afwijkingen in positie en rotatie, die normaal gesproken het gevolg zijn van het begin- en eindpunt, kunnen hier worden gedefinieerd. Hiervoor kan het 3D positioneringsgereedschap worden gebruikt.",
  "Nicht Befüllt": "Niet gevuld",
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Maximum aantal iteraties voor de expressie engine bereikt! Er zijn te complexe cycli in de berekende kenmerken.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximum aantal iteraties bereikt! De regelconflicten kunnen niet worden opgelost."
}, L4e = "Lijst", T4e = "Kleuren", M4e = "Tekst", U4e = "Ja/ Nee", P4e = "Informatie", z4e = "Afbeelding", O4e = "Onderdelen", Q4e = "Vertegenwoordiging", j4e = "Acties", _4e = "Waarden", $4e = "Regels", q4e = "Opties", eOe = "Foto's", tOe = "Configurators", iOe = "Straat", nOe = "Postcode", gOe = "Stad", rOe = "Land", oOe = "Uittreksel", IOe = "Telefoon", lOe = "Gebruikersnaam", sOe = "MATERIAAL", aOe = "Importeren", cOe = "Handmatig", dOe = "Rotatie", COe = "Algemene informatie", uOe = "Kenmerken", AOe = "Ruwheid", bOe = "Metallness", mOe = "Stapel foto's", hOe = "Scène-instellingen", pOe = "Thema's", BOe = "Aanpassing", ZOe = "Waardebereik", fOe = "Vertegenwoordiging", GOe = "Waarden", yOe = "Vragen", WOe = "Timing", SOe = "Aanvraag", VOe = "URI", wOe = "Parameters", vOe = "Duur", ROe = "Server", XOe = "Hoeveelheid", HOe = "Artikel", kOe = "Modus Volledig scherm", FOe = {
  always: "Altijd",
  never: "Nooit",
  auto: "Zoals in de configurator",
  label: "Weergave in bevestiging, PDF en winkel"
}, YOe = "Activeer", xOe = "Deactiveer", DOe = "Artikelen", JOe = "Alleen functies", KOe = "Alleen artikel", EOe = "Geen overzicht", NOe = "Algemeen", LOe = "PDF", TOe = "Mail", MOe = "inbedden", UOe = "Winkel op", POe = "Artikel", zOe = "Voorbeeld", OOe = "Redacteur", QOe = "Foto's", jOe = "Materialen", _Oe = "Modellen", $Oe = "Regels", qOe = "Opties", eQe = "Admin", tQe = "extract", iQe = "Configurators", nQe = "Maak", gQe = "Importeren", rQe = "Gebruikers", oQe = "Ondersteuning", IQe = "Logboeken", lQe = "Systeemstatus", sQe = "Prullenmand", aQe = "Abonnement", cQe = "Verlopen", dQe = "Profiel", CQe = "Redacteur", uQe = "Configuraties", AQe = "Ruiter", bQe = "Kenmerken", mQe = "Ontwerp", hQe = "Scène", pQe = "Vertegenwoordiging", BQe = "Opties", ZQe = "Acties", fQe = "Waarden", GQe = "hoofdkleur", yQe = "Secundaire kleur", WQe = "Achtergrondkleur", SQe = "Waarschuwingskleur", VQe = "Standaard", wQe = "Heller", vQe = "Donkerder", RQe = "Uitgelicht", XQe = "Standaard", HQe = "Grijs", kQe = "CTRL", FQe = "Vervangen", YQe = "Bestel", xQe = {
  list: L4e,
  color: T4e,
  text: M4e,
  boolean: U4e,
  information: P4e,
  image: z4e,
  components: O4e,
  presentation: Q4e,
  usage: j4e,
  values: _4e,
  rules: $4e,
  settings: q4e,
  images: eOe,
  configurators: tOe,
  street: iOe,
  zip: nOe,
  city: gOe,
  country: rOe,
  extract: oOe,
  phone: IOe,
  username: lOe,
  "duplicate-entry": "Accounts met deze gegevens bestaan al",
  "create new dealer": "Nieuwe verkoper maken",
  "Artikel Anzahl": "Artikel Aantal",
  "Farb auswählen": "Selecteer kleur",
  "< Zurück": "< Terug",
  "Merkmal auswählen": "Functie selecteren",
  MATERIAL: sOe,
  Import: aOe,
  "Materialien für den Import auswählen:": "Selecteer materialen om te importeren:",
  "Wie möchten Sie ein Material erstellen?": "Hoe wil je materiaal maken?",
  "Import einer .glb und export der enthaltenen Materialien": "Een .glb importeren en de materialen exporteren",
  Manuell: cOe,
  "Eigenständiges Anlegen eines PBR-Materials": "Onafhankelijk aanmaken van een PBR-materiaal",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Verwijder daar eerst de bijbehorende kolom.",
  "Design & Layout": "Ontwerp en lay-out",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Alleen zichtbaar in voorbeeldmodus of gepubliceerde configurator!",
  "Theme wählen": "Selecteer thema",
  "Komponente löschen": "Component verwijderen",
  "Mehrfach Regelzeilen Bearbeitung": "Meerdere regels bewerken",
  "Anzahl ausgewählte Regel-Zeilen:": "Aantal geselecteerde regels:",
  "Modelaktions-Positionierung": "Actie positioneren modelleren",
  Rotation: dOe,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Geen acties beschikbaar voor meervoudige verwerking.",
  Allgemeines: COe,
  "Farben und Lichtinteraktion": "Kleuren en lichtinteractie",
  "Color-Map Upload": "Kleurkaart uploaden",
  "Material interagiert mit Licht in der Szene": "Materiaal interageert met licht in de scène",
  Beschaffenheit: uOe,
  "Roughness-Map Upload": "Ruwheidskaart uploaden",
  Roughness: AOe,
  "Metallness-Map Upload": "Metallness-kaart uploaden",
  Metallness: bOe,
  "Normalen-Map Upload": "Normale kaart uploaden",
  "Normalen-Skalierung": "Normaal schalen",
  "Anwendung auf 3D-Modell": "Toepassing op 3D-model",
  "Displacement-Map Upload": "Verplaatsingskaart uploaden",
  "Displacement-Skalierung": "Verplaatsingsschaal",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Herhalingsfactor van de textuur in X- en Y-richting",
  "Alpha-Werte": "Alfa-waarden",
  "Alpha-Map Upload": "Alpha-kaart uploaden",
  "Ambient Occlusion": "Omgevingsverloop",
  "Ambient-Occlusion-Map Upload": "Omgeving-Occlusie-Kaart uploaden",
  "Info editieren": "Info bewerken",
  "Zeige Info-Button": "Toon info knop",
  Abhängigkeitsschleifen: "Lussen van afhankelijkheid",
  Bilderstapel: mOe,
  "Google Analytics Property ID": "Google Analytics-eigendom-ID",
  "Sans Serif": "schreefloos",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Het flexibele shopsysteem voor je e-commerce project.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Het enige Europese open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Nu Adobe Commerce: E-commerce gemakkelijk gemaakt.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Eersteklas digitale verkoop met de Oxid esales shop.",
  "Individuelle Entwicklung": "Individuele ontwikkeling",
  "Shop mit einer individuellen Entwicklung anbinden.": "Winkel met ontwikkeling op maat.",
  Szeneneinstellungen: hOe,
  Themes: pOe,
  Anpassung: BOe,
  "Gewähltes Theme übernehmen": "Kies een thema",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Maak een nieuwe configuratiestap.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Configuratie vindt plaats in verschillende stappen. In elke stap kunnen verschillende producteigenschappen worden opgegeven. Maak hier de eerste stap.",
  "Konfigurationsschritt erstellen": "Configuratiestap maken",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Klik eerst hier om een nieuwe configurator te maken.",
  "Neuer Konfigurator wählen": "Selecteer nieuwe configurator",
  "Bitte geben Sie einen Namen ein.": "Voer een naam in.",
  "Bitte geben Sie eine Beschreibung ein.": "Voer een beschrijving in.",
  "Bitte klicken Sie hier.": "Klik hier.",
  "Konfigurator Dialog aufrufen": "Dialoog configurator oproepen",
  "Konfigurationsschritt benennen": "Naam configuratiestap",
  "Hier können Sie neue Werte hinzufügen.": "Je kunt hier nieuwe waarden toevoegen.",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Kenmerken die een lijst zijn (of kleur, materiaal, model) geven verschillende waarden weer voor selectie. Je kunt deze waarden hier invoeren.",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Klik hier om een nieuwe waarde te creëren.",
  "Wenn Sie fertig sind klicken Sie hier.": "Klik hier als je klaar bent.",
  "Werte erstellen": "Waarden creëren",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Voer een naam in voor de nieuwe functie.",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Selecteer een weergave die overeenkomt met de mogelijkheden van de functie.",
  "Präsentation definieren": "Presentatie definiëren",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "Je klant kan in één stap verschillende functies van zijn product aanpassen. Voer hier de eerste functie in.",
  "Produktmerkmal erstellen": "Productkenmerk maken",
  "Was für ein Merkmal wollen Sie anlegen?": "Welk kenmerk wil je creëren?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Een kenmerk kan een selectie zijn (bijvoorbeeld de maten S, M, L en XL), een tekst of een getal (bijvoorbeeld voor een breedte of hoogte) of zelfs een kleur of materiaal van je product of een 3D-model dat een onderdeel van je product voorstelt.",
  "Produktmerkmaltyp auswählen": "Selecteer type productkenmerk",
  "Wählen sie den eben erstellten Konfigurator.": "Selecteer de configurator die je zojuist hebt gemaakt.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Bediening van de configurator met de nieuwe functie.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Functies kunnen er bijvoorbeeld voor zorgen dat 3D-modellen of afbeeldingen worden weergegeven of dat oppervlakken worden veranderd of gekleurd. Je kunt ook een onderdelenlijst van artikelen maken, die vervolgens de prijs bepaalt en in het winkelmandje van je winkel geplaatst kan worden.",
  "Merkmal verwenden": "Functie gebruiken",
  Wertebereich: ZOe,
  Darstellung: fOe,
  Werte: GOe,
  Anfragen: yOe,
  Zeitpunkt: WOe,
  Anfrage: SOe,
  URI: VOe,
  Parameter: wOe,
  Dauer: vOe,
  Server: ROe,
  "Modell bearbeiten": "Model bewerken",
  "Korrekte Mail-Adresse": "Juist e-mailadres",
  "Statistik (30 Tage)": "Statistieken (30 dagen)",
  amount: XOe,
  article: HOe,
  "Datum eingeben": "Datum invoeren",
  "Nach hause ": "Home ",
  "Mandant anlegen": "Klant maken",
  "Nutzer hinzufügen": "Gebruiker toevoegen",
  Fullscreen: kOe,
  showSelection: FOe,
  "Kamera überschreiben": "Camera overschrijven",
  Aktivieren: YOe,
  Deaktivieren: xOe,
  Übersichtsseite: "Overzichtspagina",
  variablesAndArticles: DOe,
  variablesOnly: JOe,
  articlesOnly: KOe,
  noOverview: EOe,
  breadcrumb_app: NOe,
  breadcrumb_pdf: LOe,
  breadcrumb_mail: TOe,
  breadcrumb_embed: MOe,
  breadcrumb_shop: UOe,
  breadcrumb_articles: POe,
  breadcrumb_preview: zOe,
  breadcrumb_edit: OOe,
  breadcrumb_images: QOe,
  breadcrumb_materials: jOe,
  breadcrumb_models: _Oe,
  breadcrumb_rules: $Oe,
  breadcrumb_settings: qOe,
  breadcrumb_admin: eQe,
  breadcrumb_extract: tQe,
  breadcrumb_apps: iQe,
  breadcrumb_create: nQe,
  breadcrumb_import: gQe,
  breadcrumb_users: rQe,
  breadcrumb_support: oQe,
  breadcrumb_logs: IQe,
  breadcrumb_systemStatus: lQe,
  breadcrumb_trash: sQe,
  breadcrumb_abonnement: aQe,
  breadcrumb_expired: cQe,
  breadcrumb_profile: dQe,
  breadcrumb_configurator: CQe,
  breadcrumb_configurations: uQe,
  breadcrumb_groups: AQe,
  breadcrumb_variables: bQe,
  breadcrumb_design: mQe,
  breadcrumb_scene: hQe,
  breadcrumb_presentation: pQe,
  breadcrumb_options: BQe,
  breadcrumb_usage: ZQe,
  breadcrumb_values: fQe,
  Primary: GQe,
  Secondary: yQe,
  Background: WQe,
  Warning: SQe,
  Error: "Foutkleur",
  Main: VQe,
  Light: wQe,
  Dark: vQe,
  "Contrast Text": "(Contast) tekstkleur",
  Paper: RQe,
  Default: XQe,
  Disabled: HQe,
  "Content Main": "Achtergrondkleur canvas",
  "Scrollbar Default": "Kleur schuifbalk",
  "Letzter Schritt kann nicht gelöscht werden.": "Laatste groep kan niet worden verwijderd.",
  "Dieses Merkmal ist versteckt.": "Deze functie is verborgen.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `Deze functie is alleen zichtbaar in het beheerpaneel. Dit kan verschillende oorzaken hebben: 
 1. het was verborgen door een regel. 
 2. de bijbehorende stap is verwijderd.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "Deze functie is alleen zichtbaar in het beheerderspaneel: De functie heeft geen selectieopties.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "Dit kenmerk is niet langer zichtbaar omdat het geen geldige selectie heeft!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "Dit kenmerk is niet langer zichtbaar omdat het slechts één geldige selectie heeft!",
  "Vertikale Platzierung zulassen?": "Verticale plaatsing toestaan?",
  "Suchfeld ausblenden?": "Zoekveld verbergen?",
  Modalgröße: "Modale grootte",
  "Anzahl an Komponenten pro Zeile": "Aantal componenten per regel",
  "Weitere Preisauswirkungen dieser Selektion": "Verdere prijseffecten van deze selectie",
  "Aktion verstecken": "Actie verbergen",
  Ctrl: kQe,
  Ersetzen: FQe,
  "Bild hochladen": "Afbeelding uploaden",
  "Das Dateiformat ist nicht erlaubt!": "Het bestandsformaat is niet toegestaan!",
  Bestellen: YQe,
  "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "Ik heb de informatie over gegevensbescherming gelezen en accepteer deze.",
  "Straße und Hausnummer": "Straat en huisnummer",
  "UST-ID": "Omzetbelasting identificatienummer"
}, DQe = {
  ...N4e,
  ...xQe
}, JQe = {
  de: {
    translation: TRe
  },
  en: {
    translation: ZDe
  },
  nl: {
    translation: DQe
  },
  fr: {
    translation: iTe
  }
};
rn.use(oZe).init({
  resources: JQe,
  lng: "de",
  // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  fallbackLng: "de",
  interpolation: {
    escapeValue: !1
    // react already safes from xss
  }
});
const KQe = {
  language: "de",
  contentLanguage: null,
  dark: null,
  callIds: [],
  appLoadCounter: 0,
  selectedVariableId: void 0,
  focusGroupIdByInstanceId: {},
  fullScreen3DView: !1,
  dealerData: {
    discount: 0,
    surcharge: 0,
    apps: []
  }
}, bj = Vg({
  name: "common",
  initialState: KQe,
  reducers: {
    setLanguage: (e, t) => {
      rn.changeLanguage(t.payload, () => e.language = t.payload);
    },
    setContentLanguage: (e, t) => {
      e.contentLanguage = t.payload;
    },
    setDarkMode: (e, t) => {
      e.dark = t.payload;
    },
    setDealerData: (e, {
      payload: t
    }) => {
      e.dealerData = {
        ...t,
        discount: t != null && t.discount ? t.discount : 0,
        surcharge: t != null && t.surcharge ? t.surcharge : 0
      };
    },
    overwriteDealerApp: (e, {
      payload: t
    }) => {
      const i = [...(e.dealerData.apps ?? []).filter((n) => n.id !== t.id), t];
      e.dealerData = da({
        apps: i
      })(e.dealerData);
    },
    incAppLoadCounter: (e) => {
      e.appLoadCounter++;
    },
    setSelectedVariableId: (e, t) => {
      e.selectedVariableId = t.payload;
    },
    setFocusGroupId: (e, t) => {
      if (!t.payload.focusGroupId || e.focusGroupIdByInstanceId[t.payload.instanceId] === t.payload.focusGroupId)
        return e;
      e.focusGroupIdByInstanceId[t.payload.instanceId] = t.payload.focusGroupId;
    },
    setFocusGroupIds: (e, t) => {
      e.focusGroupIdByInstanceId = t.payload;
    },
    startLoading: (e, t) => {
      e.callIds.push(t.payload);
    },
    finishLoading: (e, t) => {
      e.callIds = e.callIds.filter((i) => i !== t.payload);
    },
    toggleFullScreen3DView: (e) => {
      e.fullScreen3DView = !e.fullScreen3DView;
    },
    mergeUrlQuery: (e, t) => {
      e.urlQuery = {
        ...e.urlQuery,
        ...t.payload
      };
    }
  }
}), {
  finishLoading: DD,
  incAppLoadCounter: TDt,
  setDealerData: EQe,
  overwriteDealerApp: MDt,
  setDarkMode: UDt,
  setFocusGroupId: NQe,
  setFocusGroupIds: LQe,
  setLanguage: PDt,
  setContentLanguage: TQe,
  setSelectedVariableId: JD,
  startLoading: MQe,
  toggleFullScreen3DView: d3,
  mergeUrlQuery: zDt
} = bj.actions, UQe = bj.reducer, mj = {
  Right: "right",
  Left: "left"
}, PQe = ["de", "en", "nl", "fr"], qS = (e) => {
  var t;
  return (t = e.settings.langs) != null && t.length ? e.settings.langs : PQe;
}, Gk = {
  topmenu: "topmenu",
  accordion: "accordion",
  onlysidebar: "onlysidebar",
  backgroungGroup: "backgroungGroup",
  individuell: "individuell"
}, ODt = {
  Configurator: "configurator",
  ArticleList: "articleList"
}, $B = {
  NONE: "NONE",
  STACK: "STACK",
  GALLERY: "TURNTABLE",
  _3D: "3D",
  PLANER: "PLANER"
}, zQe = {
  DE: "de",
  EN: "en",
  NL: "nl",
  FR: "fr"
}, QDt = Object.values(zQe), jDt = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Slavonic, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  fy: "Western Frisian",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  el: "Greek, Modern (1453–)",
  kl: "Kalaallisut, Greenlandic",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue, Occidental",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  km: "Central Khmer",
  ki: "Kikuyu, Gikuyu",
  rw: "Kinyarwanda",
  ky: "Kirghiz, Kyrgyz",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kuanyama, Kwanyama",
  ku: "Kurdish",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  li: "Limburgan, Limburger, Limburgish",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lb: "Luxembourgish, Letzeburgesch",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "North Ndebele",
  nr: "South Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Sichuan Yi, Nuosu",
  oc: "Occitan",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  pa: "Punjabi, Panjabi",
  qu: "Quechua",
  ro: "Romanian, Moldavian, Moldovan",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  se: "Northern Sami",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Southern Sotho",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  cy: "Welsh",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu"
}, _Dt = ["variablesAndArticles", "variablesOnly", "articlesOnly", "noOverview"], OQe = (e) => !e || !("type" in e);
async function $Dt(e, t, i) {
  return await ui("POST", `/app/${e}/shop`, t, {
    lang: i
  });
}
async function QQe(e, t) {
  return await ui("GET", `/app/${encodeURIComponent(t)}/full`, null, {
    lang: e
  });
}
async function RY(e, t, i, n) {
  async function g(o, I, s) {
    try {
      const a = await jQe(s, o, I), d = s || qS(a.app)[0];
      return n == null || n(TQe(d)), a;
    } catch {
      return console.error(`Failed to load app with: Code: ${o} Version: ${I} Language: ${s}`), null;
    }
  }
  let r = await g(t, i, e);
  if (r || (r = await g(t, i), r) || (console.error("Fallback language did not work, because JSON is not published yet."), e != vY && (r = await g(t, i, vY), r)))
    return r;
  throw console.error("Could not load any JSON for the given app."), new Error("Die App wurde noch nicht veröffentlicht. Laden der Konfiguration schlägt fehl.");
}
async function jQe(e, t, i) {
  const n = e ? `.${e}` : "";
  return await Z1(`/data/${i === "current" ? "current" : "versions"}/${encodeURIComponent(t)}${n}.json`);
}
async function XY(e, t, i) {
  try {
    const n = e ? `.${e}` : "", g = i || "current";
    return await Z1(`/data/articles/${encodeURIComponent(t)}/${g}${n}.json`);
  } catch {
    return;
  }
}
async function qDt(e, t) {
  return await ui("GET", `/app/${e}/import/articles`, null, {
    lang: t
  });
}
async function eJt(e, t) {
  return await ui("GET", `/app/${e}/publish`, null, {
    lang: t
  });
}
async function tJt(e, t) {
  return await ui("GET", `/app/${e}/publish/log`, null, {
    lang: t
  });
}
async function iJt(e, t) {
  return await ui("GET", `/app/${e}/publish/articles`, null, {
    lang: t
  });
}
async function nJt(e, t, i) {
  return await ui("POST", `/app/${e}/copy`, t, {
    lang: i
  });
}
async function gJt(e) {
  return await ui("GET", `/app/${e}/export`, null, {});
}
async function rJt(e, t) {
  const i = "/app/import" + (t ? `/${t}` : "");
  return await ui("POST", i, e);
}
async function oJt(e, t) {
  return await ui("GET", `/app/${e}/version/${t}`);
}
async function IJt(e, t, i) {
  return await ui("POST", `/app/${e}/book/${t}?interval=${i ?? "month"}`);
}
async function lJt(e) {
  return await ui("GET", `/app/${e}/products`, null, {});
}
async function sJt() {
  return await ui("GET", "/app/products/all");
}
const HY = {
  Draft: "draft",
  Basket: "basket",
  Quoted: "quoted",
  Ordered: "ordered"
};
async function _Qe(e, t, i, n, g, r = !1, o) {
  if (!t)
    throw new Error("Missing App Code for uploadContent!");
  const I = new FormData();
  return o && I.append("dealerId", String(o)), o ? I.append("state", HY.Draft) : I.append("state", HY.Ordered), I.append("price", JSON.stringify(e.price)), I.append("preview", String(r)), I.append("json", JSON.stringify(e.json)), I.append("customer", JSON.stringify(e.customer)), I.append("files", JSON.stringify(e.files)), g.forEach((a) => {
    I.append(a.key, a.file);
  }), await jd("POST", `/app/${t}/cfg/${i.id}`, I, {
    "X-language": n,
    Accept: "application/json"
  });
}
async function $Qe(e) {
  return await Z1(`/data/cfgs/${encodeURIComponent(e)}.json`);
}
async function qQe(e) {
  return await ui("GET", `/app/cfg/${encodeURIComponent(e)}`, null);
}
async function aJt(e, t, i) {
  return await ui("GET", `/cfg/${e}/pdf${i ? "/" + i : ""}`, null, {
    lang: t
  });
}
async function cJt(e, t) {
  return await ui("GET", `/cfg/${e}/shop`, null, {
    lang: t
  });
}
var hj = {}, pj = {}, Bj = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = function() {
    for (var g = arguments.length, r = new Array(g), o = 0; o < g; o++)
      r[o] = arguments[o];
    if (typeof window < "u") {
      var I;
      typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
        window.dataLayer.push(arguments);
      }), (I = window).gtag.apply(I, r);
    }
  }, i = t;
  e.default = i;
})(Bj);
var Zj = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var t = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  function i(I) {
    return I.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(s, a, d) {
      return a > 0 && a + s.length !== d.length && s.search(t) > -1 && d.charAt(a - 2) !== ":" && (d.charAt(a + s.length) !== "-" || d.charAt(a - 1) === "-") && d.charAt(a - 1).search(/[^\s-]/) < 0 ? s.toLowerCase() : s.substr(1).search(/[A-Z]|\../) > -1 ? s : s.charAt(0).toUpperCase() + s.substr(1);
    });
  }
  function n(I) {
    return typeof I == "string" && I.indexOf("@") !== -1;
  }
  var g = "REDACTED (Potential Email Address)";
  function r(I) {
    return n(I) ? (console.warn("This arg looks like an email address, redacting."), g) : I;
  }
  function o() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, d = I || "";
    return s && (d = i(I)), a && (d = r(d)), d;
  }
})(Zj);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.GA4 = void 0;
  var t = o(Bj), i = o(Zj), n = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], g = ["title", "location"], r = ["page", "hitType"];
  function o(E) {
    return E && E.__esModule ? E : { default: E };
  }
  function I(E, L) {
    if (E == null)
      return {};
    var P = s(E, L), Q, te;
    if (Object.getOwnPropertySymbols) {
      var le = Object.getOwnPropertySymbols(E);
      for (te = 0; te < le.length; te++)
        Q = le[te], !(L.indexOf(Q) >= 0) && Object.prototype.propertyIsEnumerable.call(E, Q) && (P[Q] = E[Q]);
    }
    return P;
  }
  function s(E, L) {
    if (E == null)
      return {};
    var P = {}, Q = Object.keys(E), te, le;
    for (le = 0; le < Q.length; le++)
      te = Q[le], !(L.indexOf(te) >= 0) && (P[te] = E[te]);
    return P;
  }
  function a(E) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(L) {
      return typeof L;
    } : function(L) {
      return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
    }, a(E);
  }
  function d(E) {
    return A(E) || u(E) || G(E) || C();
  }
  function C() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function u(E) {
    if (typeof Symbol < "u" && E[Symbol.iterator] != null || E["@@iterator"] != null)
      return Array.from(E);
  }
  function A(E) {
    if (Array.isArray(E))
      return y(E);
  }
  function m(E, L) {
    var P = Object.keys(E);
    if (Object.getOwnPropertySymbols) {
      var Q = Object.getOwnPropertySymbols(E);
      L && (Q = Q.filter(function(te) {
        return Object.getOwnPropertyDescriptor(E, te).enumerable;
      })), P.push.apply(P, Q);
    }
    return P;
  }
  function h(E) {
    for (var L = 1; L < arguments.length; L++) {
      var P = arguments[L] != null ? arguments[L] : {};
      L % 2 ? m(Object(P), !0).forEach(function(Q) {
        x(E, Q, P[Q]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(P)) : m(Object(P)).forEach(function(Q) {
        Object.defineProperty(E, Q, Object.getOwnPropertyDescriptor(P, Q));
      });
    }
    return E;
  }
  function B(E, L) {
    return V(E) || W(E, L) || G(E, L) || f();
  }
  function f() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function G(E, L) {
    if (E) {
      if (typeof E == "string")
        return y(E, L);
      var P = Object.prototype.toString.call(E).slice(8, -1);
      if (P === "Object" && E.constructor && (P = E.constructor.name), P === "Map" || P === "Set")
        return Array.from(E);
      if (P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P))
        return y(E, L);
    }
  }
  function y(E, L) {
    (L == null || L > E.length) && (L = E.length);
    for (var P = 0, Q = new Array(L); P < L; P++)
      Q[P] = E[P];
    return Q;
  }
  function W(E, L) {
    var P = E == null ? null : typeof Symbol < "u" && E[Symbol.iterator] || E["@@iterator"];
    if (P != null) {
      var Q, te, le, Ae, we = [], Ee = !0, Je = !1;
      try {
        if (le = (P = P.call(E)).next, L !== 0)
          for (; !(Ee = (Q = le.call(P)).done) && (we.push(Q.value), we.length !== L); Ee = !0)
            ;
      } catch (ve) {
        Je = !0, te = ve;
      } finally {
        try {
          if (!Ee && P.return != null && (Ae = P.return(), Object(Ae) !== Ae))
            return;
        } finally {
          if (Je)
            throw te;
        }
      }
      return we;
    }
  }
  function V(E) {
    if (Array.isArray(E))
      return E;
  }
  function w(E, L) {
    if (!(E instanceof L))
      throw new TypeError("Cannot call a class as a function");
  }
  function v(E, L) {
    for (var P = 0; P < L.length; P++) {
      var Q = L[P];
      Q.enumerable = Q.enumerable || !1, Q.configurable = !0, "value" in Q && (Q.writable = !0), Object.defineProperty(E, N(Q.key), Q);
    }
  }
  function H(E, L, P) {
    return L && v(E.prototype, L), Object.defineProperty(E, "prototype", { writable: !1 }), E;
  }
  function x(E, L, P) {
    return L = N(L), L in E ? Object.defineProperty(E, L, { value: P, enumerable: !0, configurable: !0, writable: !0 }) : E[L] = P, E;
  }
  function N(E) {
    var L = M(E, "string");
    return a(L) === "symbol" ? L : String(L);
  }
  function M(E, L) {
    if (a(E) !== "object" || E === null)
      return E;
    var P = E[Symbol.toPrimitive];
    if (P !== void 0) {
      var Q = P.call(E, L || "default");
      if (a(Q) !== "object")
        return Q;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (L === "string" ? String : Number)(E);
  }
  var $ = /* @__PURE__ */ function() {
    function E() {
      var L = this;
      w(this, E), x(this, "reset", function() {
        L.isInitialized = !1, L._testMode = !1, L._currentMeasurementId, L._hasLoadedGA = !1, L._isQueuing = !1, L._queueGtag = [];
      }), x(this, "_gtag", function() {
        for (var P = arguments.length, Q = new Array(P), te = 0; te < P; te++)
          Q[te] = arguments[te];
        L._testMode || L._isQueuing ? L._queueGtag.push(Q) : t.default.apply(void 0, Q);
      }), x(this, "_loadGA", function(P, Q) {
        var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
        if (!(typeof window > "u" || typeof document > "u") && !L._hasLoadedGA) {
          var le = document.createElement("script");
          le.async = !0, le.src = "".concat(te, "?id=").concat(P), Q && le.setAttribute("nonce", Q), document.body.appendChild(le), window.dataLayer = window.dataLayer || [], window.gtag = function() {
            window.dataLayer.push(arguments);
          }, L._hasLoadedGA = !0;
        }
      }), x(this, "_toGtagOptions", function(P) {
        if (P) {
          var Q = {
            // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
            // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            // must be in set method?
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            // https://support.google.com/analytics/answer/9050852?hl=en
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
          }, te = Object.entries(P).reduce(function(le, Ae) {
            var we = B(Ae, 2), Ee = we[0], Je = we[1];
            return Q[Ee] ? le[Q[Ee]] = Je : le[Ee] = Je, le;
          }, {});
          return te;
        }
      }), x(this, "initialize", function(P) {
        var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!P)
          throw new Error("Require GA_MEASUREMENT_ID");
        var te = typeof P == "string" ? [{
          trackingId: P
        }] : P;
        L._currentMeasurementId = te[0].trackingId;
        var le = Q.gaOptions, Ae = Q.gtagOptions, we = Q.nonce, Ee = Q.testMode, Je = Ee === void 0 ? !1 : Ee, ve = Q.gtagUrl;
        if (L._testMode = Je, Je || L._loadGA(L._currentMeasurementId, we, ve), L.isInitialized || (L._gtag("js", /* @__PURE__ */ new Date()), te.forEach(function(Xe) {
          var Ze = h(h(h({}, L._toGtagOptions(h(h({}, le), Xe.gaOptions))), Ae), Xe.gtagOptions);
          Object.keys(Ze).length ? L._gtag("config", Xe.trackingId, Ze) : L._gtag("config", Xe.trackingId);
        })), L.isInitialized = !0, !Je) {
          var Be = d(L._queueGtag);
          for (L._queueGtag = [], L._isQueuing = !1; Be.length; ) {
            var ue = Be.shift();
            L._gtag.apply(L, d(ue)), ue[0] === "get" && (L._isQueuing = !0);
          }
        }
      }), x(this, "set", function(P) {
        if (!P) {
          console.warn("`fieldsObject` is required in .set()");
          return;
        }
        if (a(P) !== "object") {
          console.warn("Expected `fieldsObject` arg to be an Object");
          return;
        }
        Object.keys(P).length === 0 && console.warn("empty `fieldsObject` given to .set()"), L._gaCommand("set", P);
      }), x(this, "_gaCommandSendEvent", function(P, Q, te, le, Ae) {
        L._gtag("event", Q, h(h({
          event_category: P,
          event_label: te,
          value: le
        }, Ae && {
          non_interaction: Ae.nonInteraction
        }), L._toGtagOptions(Ae)));
      }), x(this, "_gaCommandSendEventParameters", function() {
        for (var P = arguments.length, Q = new Array(P), te = 0; te < P; te++)
          Q[te] = arguments[te];
        if (typeof Q[0] == "string")
          L._gaCommandSendEvent.apply(L, d(Q.slice(1)));
        else {
          var le = Q[0], Ae = le.eventCategory, we = le.eventAction, Ee = le.eventLabel, Je = le.eventValue;
          le.hitType;
          var ve = I(le, n);
          L._gaCommandSendEvent(Ae, we, Ee, Je, ve);
        }
      }), x(this, "_gaCommandSendTiming", function(P, Q, te, le) {
        L._gtag("event", "timing_complete", {
          name: Q,
          value: te,
          event_category: P,
          event_label: le
        });
      }), x(this, "_gaCommandSendPageview", function(P, Q) {
        if (Q && Object.keys(Q).length) {
          var te = L._toGtagOptions(Q), le = te.title, Ae = te.location, we = I(te, g);
          L._gtag("event", "page_view", h(h(h(h({}, P && {
            page_path: P
          }), le && {
            page_title: le
          }), Ae && {
            page_location: Ae
          }), we));
        } else
          P ? L._gtag("event", "page_view", {
            page_path: P
          }) : L._gtag("event", "page_view");
      }), x(this, "_gaCommandSendPageviewParameters", function() {
        for (var P = arguments.length, Q = new Array(P), te = 0; te < P; te++)
          Q[te] = arguments[te];
        if (typeof Q[0] == "string")
          L._gaCommandSendPageview.apply(L, d(Q.slice(1)));
        else {
          var le = Q[0], Ae = le.page;
          le.hitType;
          var we = I(le, r);
          L._gaCommandSendPageview(Ae, we);
        }
      }), x(this, "_gaCommandSend", function() {
        for (var P = arguments.length, Q = new Array(P), te = 0; te < P; te++)
          Q[te] = arguments[te];
        var le = typeof Q[0] == "string" ? Q[0] : Q[0].hitType;
        switch (le) {
          case "event":
            L._gaCommandSendEventParameters.apply(L, Q);
            break;
          case "pageview":
            L._gaCommandSendPageviewParameters.apply(L, Q);
            break;
          case "timing":
            L._gaCommandSendTiming.apply(L, d(Q.slice(1)));
            break;
          case "screenview":
          case "transaction":
          case "item":
          case "social":
          case "exception":
            console.warn("Unsupported send command: ".concat(le));
            break;
          default:
            console.warn("Send command doesn't exist: ".concat(le));
        }
      }), x(this, "_gaCommandSet", function() {
        for (var P = arguments.length, Q = new Array(P), te = 0; te < P; te++)
          Q[te] = arguments[te];
        typeof Q[0] == "string" && (Q[0] = x({}, Q[0], Q[1])), L._gtag("set", L._toGtagOptions(Q[0]));
      }), x(this, "_gaCommand", function(P) {
        for (var Q = arguments.length, te = new Array(Q > 1 ? Q - 1 : 0), le = 1; le < Q; le++)
          te[le - 1] = arguments[le];
        switch (P) {
          case "send":
            L._gaCommandSend.apply(L, te);
            break;
          case "set":
            L._gaCommandSet.apply(L, te);
            break;
          default:
            console.warn("Command doesn't exist: ".concat(P));
        }
      }), x(this, "ga", function() {
        for (var P = arguments.length, Q = new Array(P), te = 0; te < P; te++)
          Q[te] = arguments[te];
        if (typeof Q[0] == "string")
          L._gaCommand.apply(L, Q);
        else {
          var le = Q[0];
          L._gtag("get", L._currentMeasurementId, "client_id", function(Ae) {
            L._isQueuing = !1;
            var we = L._queueGtag;
            for (le({
              get: function(ve) {
                return ve === "clientId" ? Ae : ve === "trackingId" ? L._currentMeasurementId : ve === "apiVersion" ? "1" : void 0;
              }
            }); we.length; ) {
              var Ee = we.shift();
              L._gtag.apply(L, d(Ee));
            }
          }), L._isQueuing = !0;
        }
        return L.ga;
      }), x(this, "event", function(P, Q) {
        if (typeof P == "string")
          L._gtag("event", P, L._toGtagOptions(Q));
        else {
          var te = P.action, le = P.category, Ae = P.label, we = P.value, Ee = P.nonInteraction, Je = P.transport;
          if (!le || !te) {
            console.warn("args.category AND args.action are required in event()");
            return;
          }
          var ve = {
            hitType: "event",
            eventCategory: (0, i.default)(le),
            eventAction: (0, i.default)(te)
          };
          Ae && (ve.eventLabel = (0, i.default)(Ae)), typeof we < "u" && (typeof we != "number" ? console.warn("Expected `args.value` arg to be a Number.") : ve.eventValue = we), typeof Ee < "u" && (typeof Ee != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : ve.nonInteraction = Ee), typeof Je < "u" && (typeof Je != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(Je) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), ve.transport = Je)), L._gaCommand("send", ve);
        }
      }), x(this, "send", function(P) {
        L._gaCommand("send", P);
      }), this.reset();
    }
    return H(E, [{
      key: "gtag",
      value: function() {
        this._gtag.apply(this, arguments);
      }
    }]), E;
  }();
  e.GA4 = $;
  var q = new $();
  e.default = q;
})(pj);
(function(e) {
  function t(I) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, t(I);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ReactGAImplementation = void 0;
  var i = g(pj);
  function n(I) {
    if (typeof WeakMap != "function")
      return null;
    var s = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
    return (n = function(C) {
      return C ? a : s;
    })(I);
  }
  function g(I, s) {
    if (I && I.__esModule)
      return I;
    if (I === null || t(I) !== "object" && typeof I != "function")
      return { default: I };
    var a = n(s);
    if (a && a.has(I))
      return a.get(I);
    var d = {}, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var u in I)
      if (u !== "default" && Object.prototype.hasOwnProperty.call(I, u)) {
        var A = C ? Object.getOwnPropertyDescriptor(I, u) : null;
        A && (A.get || A.set) ? Object.defineProperty(d, u, A) : d[u] = I[u];
      }
    return d.default = I, a && a.set(I, d), d;
  }
  var r = i.GA4;
  e.ReactGAImplementation = r;
  var o = i.default;
  e.default = o;
})(hj);
const kY = /* @__PURE__ */ Tr(hj), eje = (e, t, i, n, g = !0) => {
  const r = uc.groupBy(t, (I) => I.ruleId), o = e.map((I) => tje(I, r[I.id] || [], i, n, g));
  return {
    nested: o,
    flat: {
      rules: o.map((I) => I.rule),
      ruleItems: o.flatMap((I) => I.items)
    }
  };
};
function tje(e, t, i, n, g = !0) {
  const [r, o] = ce.partition(e.columns, (a) => !ua(a) || n.find((d) => d.id == a.targetId)), I = r.filter((a) => ua(a)), s = t.map((a) => {
    const d = {};
    return I.forEach((C) => {
      const u = C.targetId;
      d[u] = a.values[u] || !0;
    }), g || Object.keys(a.values).forEach((C) => {
      GD(C) && (d[C] = a.values[C]);
    }), {
      ...a,
      values: d
    };
  });
  return {
    rule: {
      ...e,
      columns: g ? I : r
    },
    items: s
  };
}
const y1 = (e, t = []) => t.filter((i) => !US(e, i.variableId, i.instance.id, "hiddenVariablesMap")), ije = (e) => {
  var t;
  return !((t = e.settings.priceOptions) != null && t.hidePrice);
}, KD = {};
function dJt(e) {
  ce.forEach(e, (t, i) => KD[i] = t);
}
function ED(e) {
  return !!KD[e];
}
const CJt = (e) => (
  // @ts-ignore
  e.forEach((t) => e[t] = void 0)
), ms = (e, t) => {
  const i = KD[e];
  return i ? i(t) : t;
};
me.curry(ms);
const nje = (e) => e.actionEngine.actionEngineInput, qB = (e) => e.actionEngine.actionEngineState, gje = Pt(qB, (e) => Object.values(e ?? {}).flat()), _d = [], rje = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.articles) ?? _d;
}, fj = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.colors) ?? _d;
}, Ih = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.models) ?? _d;
};
Pt(Ih, (e) => e.map((t) => t.modelId));
const ND = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.prints) ?? _d;
}, oje = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.images) ?? _d;
}, Ije = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.labels) ?? _d;
}, Gj = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.materials) ?? _d;
}, lje = (e) => (t) => {
  var i;
  return ((i = t.actionEngine.actionEngineState) == null ? void 0 : i[e]) ?? _d;
}, sje = [], tI = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.values) ?? sje;
}, LD = Pt(tI, (e) => Ni(e)), JZ = Pt([tI], (e) => ce.groupBy(e, (t) => t.variableId)), lh = me.curry((e, t) => e ? tI(t).filter((i) => i.variableId == e).slice().sort(xQ) : []), $d = (e) => (t) => e ? tI(t).find((i) => i.id == e) : void 0, aje = (e) => (t) => tI(t).find((i) => i.key == e), uJt = Pt([tI, (e, t) => t], (e, t) => e.filter((i) => i.appId == t)), vg = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jg(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.selections) || [];
}, yj = Pt([vg], (e) => ({
  [Dt.id]: Dt,
  ...ce.keyBy(e, (t) => t.id)
})), TD = (e) => (t) => yj(t)[e], cje = (e, t) => (i) => {
  const n = Go(e)(i);
  return vg(i).find((o) => o.variableId === (n == null ? void 0 : n.id) && o.instance.id === t);
}, dje = Pt([vg, Za], (e, t) => e.filter((n) => n.instance.isInstanceLauncher).map((n) => ({
  selection: n,
  variable: t[n.variableId]
}))), Cje = (e) => {
  const t = Dg(e), i = vg(e);
  return t ? y1(t, i) : VGe;
}, uje = (e) => (t) => me.flow(vg, me.filter((i) => i.variableId == e))(t), Aje = (e) => (t) => uje(e)(t).map((n) => ({
  value: t.metadata.values.find((g) => g.id == +n.valueId),
  selection: n
})), _u = (e) => (t) => vg(t).find((i) => i.variableId == e), $u = Pt([vg, (e, t) => t, (e, t, i) => i], (e, t, i) => {
  if (!t)
    return [];
  let n = t;
  const g = [];
  for (i && t.instance.isInstanceLauncher && g.push(t); n; ) {
    const r = e.find((o) => o.id == vl(n));
    r ? (g.push(r), n = r) : n = void 0;
  }
  return g;
}), sh = (e) => ije(Ai(e)), Ai = (e) => {
  var t, i;
  return ((t = e == null ? void 0 : e.frontend) == null ? void 0 : t.app) || ((i = e == null ? void 0 : e.configurator) == null ? void 0 : i.app) || void 0;
}, Wj = (e) => {
  var t, i, n;
  return (n = (i = (t = Ai(e)) == null ? void 0 : t.settings) == null ? void 0 : i.themeMobile) == null ? void 0 : n.selected;
}, Sj = Pt([Ai, DQ], (e, t) => t[e == null ? void 0 : e.id] ?? []), bje = (e) => {
  var t;
  return (t = Ai(e)) == null ? void 0 : t.productDetails;
}, mje = (e) => {
  var t;
  return ((t = bje(e)) == null ? void 0 : t.branding) ?? !0;
}, AJt = (e) => (t) => {
  const i = e || Ai(t);
  return (i == null ? void 0 : i.stage) == $B._3D;
}, hje = (e) => (t) => {
  const i = e || Ai(t);
  return (i == null ? void 0 : i.stage) == $B.GALLERY || (i == null ? void 0 : i.stage) == $B.STACK;
}, Vj = (e) => {
  var t, i;
  return ((i = (t = Ai(e)) == null ? void 0 : t.settings) == null ? void 0 : i.dynamicSettings) || {};
}, pje = [], Bje = (e) => {
  var t, i;
  return ((i = (t = Ai(e)) == null ? void 0 : t.settings) == null ? void 0 : i.dynamicTranslationKeys) || pje;
}, MD = Pt([Ai], (e) => ms("setCameraList", (e == null ? void 0 : e.settings.cameras) || [])), bJt = Pt([MD, (e, t) => t], (e, t) => UD(t, e)), Zje = Pt([MD], (e) => {
  const t = UD({
    type: "general"
  }, e);
  return ms("setScreenshotCameras", t);
}), UD = (e, t) => t.filter((i) => {
  var n, g;
  return e.type === "general" && (!i.scope || i.scope.type === "general") || e.type === ((n = i.scope) == null ? void 0 : n.type) && e.id === ((g = i.scope) == null ? void 0 : g.id);
}), fje = (e) => e.frontend.configurationInitialization, Gje = (e) => e.frontend.configuration, KZ = (e, t) => (i) => {
  let n = [Dt];
  const g = Ih(i);
  if (e) {
    const r = g.filter((o) => {
      var I, s;
      return ((I = o == null ? void 0 : o.ruleItem) == null ? void 0 : I.id) === e && ((s = o.ruleColumn) == null ? void 0 : s.id) === t;
    });
    r && (n = r.map((o) => o.anchoringSelection));
  }
  return n;
}, yje = (e) => e.frontend.arDialog, wj = (e) => OQe(e.frontend.currentAction) ? e.frontend.currentAction : null, vj = (e) => e.frontend.currentAction, Wje = (e, t = !1) => {
  const i = t ? jo.adminAnalytics : e.settings.gaTrackingId, n = la("ga");
  i && n != "false" && (kY.initialize(
    i
    /*, { debug: true }*/
  ), kY.set({
    anonymizeIp: !0
  }));
}, Rj = (e) => {
  kY.event(e);
}, Sje = (e) => {
  const t = la("ga");
  return e.settings.gaTrackingId && t != "false";
}, Ym = (e, t, i, n) => {
  if (!i)
    return;
  const g = {
    category: "K3:" + i.label + (n ? ":" + n : ""),
    action: e,
    label: t
  };
  Sje(i) && Rj(g);
}, Vje = (e, t, i) => (n, g) => {
  var a;
  const r = g(), o = (a = Dg(r)) == null ? void 0 : a.variables.byVarId.all[e];
  if (!o) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const I = o.key || o.label, s = (i == null ? void 0 : i.inputValue) || t.key || t.label;
  Ym(I, "" + s, Ai(r), "action");
}, Xj = (e, t) => (i, n) => {
  if (!e)
    return;
  const g = n(), r = $d(e)(g);
  if (!r)
    return;
  const o = Go(r.variableId)(g), I = o.key || o.label, s = (t ? "+" : "-") + ((r == null ? void 0 : r.key) || (r == null ? void 0 : r.label));
  Ym(I, "" + s, Ai(g), "action");
}, mJt = (e, t) => {
  const i = {
    category: "k3",
    action: e,
    label: t
  };
  jo.adminAnalytics && Rj(i);
}, wje = (e, t, i) => {
  const n = t ? Number(t) : -1 / 0, g = i ? Number(i) : 1 / 0;
  let r = [...e.flatMap((I) => [I.left, I.right]), g, n];
  r = ce.uniq(r).sort((I, s) => I - s), r = r.filter((I) => I <= g && I >= n);
  const o = r.slice(0, r.length - 1).flatMap((I, s) => {
    const a = r[s + 1];
    return I === -1 / 0 ? [JL(I, a)] : [Du(I), JL(I, a)];
  });
  return g !== 1 / 0 && o.push(Du(g)), o;
}, Hj = (e) => e.common.language, ng = (e) => e.common.contentLanguage, EZ = (e) => e.common.dealerData, kj = (e) => e.common.selectedVariableId, Fj = (e) => e.common.focusGroupIdByInstanceId, fa = (e, t) => e.common.focusGroupIdByInstanceId[t.id], vje = (e, t) => {
  var g;
  if (t.id === Dt.id) {
    const r = fa(e, t);
    if (r)
      return r;
  }
  const i = vg(e), n = Wc(e);
  for (const r of n) {
    const I = [...HZ(i, r), r].find((s) => s.id !== Dt.id && s.instance.belongsToInstanceId === Dt.id);
    if (I)
      return (g = Go(I == null ? void 0 : I.variableId)(e)) == null ? void 0 : g.groupId;
  }
}, Rje = (e) => e.common.callIds, Xje = (e) => Rje(e).length > 0, Yj = (e) => e.common.fullScreen3DView, hJt = (e) => e.common.urlQuery, xj = (e, t, i) => (n) => {
  const g = i ? Fj(i) : {};
  Dje(e);
  let {
    values: r,
    ruleItems: o,
    rules: I
  } = n;
  I = I.filter((C) => C.isActive), o = o.filter((C) => C.isActive), o = o.filter((C) => !Object.values(C.values).some((u) => ce.isArray(u) && !u.length)), o = Jje(o, I, g), o = o.map((C) => ({
    ...C,
    values: Object.fromEntries(Object.entries(C.values).map(([u, A]) => [u, ce.isNumber(A) ? [A] : _B(A) ? {
      ...A,
      interval: bfe(A.interval)
    } : A]))
  })), r = r.slice().sort(xQ), r = Hje(r, e, o).newValues;
  const a = Ni(r);
  o = o.filter((C) => Object.values(C.values).every((u) => ce.isArray(u) ? u.some((A) => a[A]) : !0)), t ? I = I.filter((C) => C.checkValidity) : I = I.filter((C) => C.columns.some((u) => !ua(u))), o = o.filter((C) => I.some((u) => C.ruleId === u.id));
  const d = eje(I, o, r, e, t);
  return I = d.flat.rules, o = d.flat.ruleItems, {
    newRules: I,
    newRuleItems: o,
    newValues: r
  };
}, Hje = (e, t, i) => {
  const n = kje(), g = e.filter((I) => !eI(t.find((s) => s.id === I.variableId))), r = Fje(i, g, t, n);
  g.push(...r.additionalValues);
  const o = t.filter((I) => ih(I)).map((I) => n(I));
  return g.push(...o), {
    newValues: g
  };
}, kje = () => {
  let e = -1;
  return (t, i) => ({
    id: e--,
    appId: 0,
    variableId: t.id,
    value: PS(i) ? KL(i) : "",
    sort: 0,
    label: PS(i) ? KL(i) : "",
    data: i
  });
}, lS = (e, t) => {
  const i = {};
  return e.forEach((n) => {
    i[n.id.toString()] = t.filter((g) => g.variableId === n.id);
  }), i;
}, Fje = (e, t, i, n) => {
  const g = ce.filter(e, (o) => Object.values(o.values).some((I) => _B(I)));
  return {
    additionalValues: i.filter((o) => eI(o)).flatMap((o) => {
      const {
        min: I,
        max: s
      } = kfe(o), a = g.filter((C) => !!C.values[o.id]);
      let d = a.flatMap((C) => Object.keys(C.values).map((u) => {
        if (Number(u) !== o.id)
          return !1;
        const A = C.values[u];
        return _B(A) ? A.interval : !1;
      })).filter(Boolean);
      return d = wje(d, I, s), d = Yje(o, d, a), d = xje(o, d), d.map((C) => n(o, C));
    })
  };
}, Yje = (e, t, i) => {
  if (!i.length)
    return t;
  const n = t.map((o) => ({
    interval: o,
    items: i.filter((I) => Bc(o, I.values[e.id].interval)).map((I) => I.id)
  }));
  let g = [];
  const r = [];
  for (const o of n)
    g.length ? ce.isEqual(g[0].items, o.items) ? g.push(o) : (r.push(EL(g.map((I) => I.interval))), g = [o]) : g.push(o);
  return r.push(EL(g.map((o) => o.interval))), r;
}, xje = (e, t) => {
  const i = Od(e);
  return i && !(i % 1) ? t.filter((n) => !(!n.leftInclude && !n.rightInclude && n.right === n.left + 1)) : t;
}, Dje = (e) => e.forEach((t) => {
  if (!t.key)
    return;
  const i = e.find((n) => n.key === t.key && n.id !== t.id);
  i && console.error(`${t.label} and ${i.label} have the same key.`, t, i);
});
function Jje(e, t, i) {
  return e = e.filter((n) => !!Object.entries(n.values).every(([g, r]) => {
    var o, I;
    if (ce.isObject(r) && "id" in r && r.id == "setFocusGroup") {
      const s = r;
      if (s.mode) {
        const a = (I = (o = t.find((C) => C.id === n.ruleId)) == null ? void 0 : o.columns.find((C) => C.id == g)) == null ? void 0 : I.targetId;
        if (!a)
          return !0;
        const d = Object.values(i).find((C) => C === a);
        return s.mode == "focused" ? !!d : !d;
      }
      return !0;
    }
    return !0;
  })), e;
}
const Kje = (e, t, i, n, g) => {
  const r = xj(n, !1, g)({
    rules: e,
    ruleItems: t,
    values: i
  }), o = lS(n, r.newValues);
  return {
    variables: n,
    ruleItems: {
      byRuleId: ce.groupBy(r.newRuleItems, "ruleId"),
      flat: r.newRuleItems
    },
    values: {
      byVarId: o,
      flat: r.newValues
    },
    rules: r.newRules
  };
}, W1 = (e) => e.reduce((t, i) => i.instance.hierarchyLevel === t.instance.hierarchyLevel && _r(i) && !_r(t) || i.instance.hierarchyLevel > t.instance.hierarchyLevel ? i : t, Dt), Eje = (e, {
  column: t,
  validSelectionCombinations: i,
  ruleItem: n,
  rule: g
}) => (i[n.id] || []).map((o) => {
  var s, a;
  const I = Number((t == null ? void 0 : t.targetId) || ((s = g == null ? void 0 : g.columns.find(ua)) == null ? void 0 : s.targetId)) || void 0;
  return {
    ...e,
    variableId: I,
    selectionId: (a = o == null ? void 0 : o.find((d) => d.variableId === I)) == null ? void 0 : a.id,
    anchoringSelection: W1(o),
    ruleItem: n,
    ruleColumn: t
  };
}), Nje = {
  type: "articles",
  isOfType: rGe,
  createActions: Eje
};
function Lje(e, t, i) {
  const n = VQ(e, i);
  if (!n)
    return !1;
  const g = !t.some((r) => r.variableId === i.variableId);
  return n && g;
}
function FY(e, t, i, n) {
  const g = b1(t, e), r = {};
  return g.forEach((o) => {
    const I = i[o.variableId];
    r[o.variableId] || (r[o.variableId] = []), (r[o.variableId] ?? []).push(o), (I ?? []).forEach((s) => {
      var d;
      const a = (d = n[s.id]) == null ? void 0 : d.filter((C) => Lje(o, g, C));
      if (!a)
        r[s.id] = null;
      else {
        const C = r[s.id] ?? [];
        C.push(...a), r[s.id] = C;
      }
    });
  }), r;
}
function Dj(e, t) {
  if (ce.isArray(e))
    return ce.intersectionBy(e, t, "id");
}
function Tje(e, t, i, n, g) {
  const r = FY(e, t, i, n);
  return ce.assignWith({}, g, r, Dj);
}
const PD = (e, t) => e.reduce((i, n) => {
  const g = t[n.id];
  return ce.assignWith(i, g, Dj);
}, {});
function Mje(e) {
  return e.reduce((t, i) => !t || t.instance.hierarchyLevel < i.instance.hierarchyLevel ? i : t, void 0);
}
function zD(e, t, i) {
  const {
    selections: n,
    validSelectionCombinations: g,
    ruleItem: r,
    selectionScopes: o,
    variablesByParentId: I,
    selectionsByVariableId: s
  } = e, a = n;
  return (g[r.id] ?? []).reduce((u, A) => {
    var f;
    const m = PD(A, o[r.id]), h = t ?? ((f = Mje(A)) == null ? void 0 : f.variableId);
    return h === void 0 ? (console.error(`Variable ID: ${h} not found! It is referenced in rule item ${JSON.stringify(e.ruleItem, null, 2)}
 of rule "${e.rule.label}" with id ${e.rule.id}!`), u) : ((m[h] ?? [Dt]).forEach((G) => {
      const y = Tje(G, a, I, s, m), W = i(G, A, y);
      W && u.push(W);
    }), u);
  }, []);
}
const Uje = (e, t) => zD(t, e.variableId, (i, n, g) => {
  var o;
  const r = (o = t.actionEngineInput.values.byVarId[i.variableId]) == null ? void 0 : o.find((I) => I.id === i.valueId);
  if (r)
    return {
      targetMaterial: t.column.targetId,
      hex: r == null ? void 0 : r.value,
      ruleItem: t.ruleItem,
      ruleColumn: t.column,
      selections: n,
      selectionScope: g,
      anchoringSelection: i
    };
}), Pje = {
  type: "colors",
  isOfType: oGe,
  createActions: Uje
}, NZ = (e, t) => ((t == null ? void 0 : t.validSelectionCombinations[t == null ? void 0 : t.ruleItem.id]) ?? []).map((i) => ({
  ...e,
  ruleItem: t.ruleItem,
  ruleColumn: t.column,
  anchoringSelection: W1(i)
})), zje = {
  type: "concealGroups",
  isOfType: eGe,
  createActions: NZ
}, Jj = (e, t, i, n, g, r) => g.flatMap((o) => {
  const I = PD(o, n[i.id]);
  return e.reduce((a, d) => {
    const C = t[d], u = C != null && C.parentId ? C.parentId : Dt.variableId, A = I[u];
    return A && a.push(r(d, A.map((m) => m.id).sort(), o)), a;
  }, []);
}, []), Kj = () => (e, {
  column: t,
  ruleItem: i,
  ruleEngineInput: n,
  selectionScopes: g,
  validSelectionCombinations: r
}) => {
  const o = e.variables, I = n.variables.byVarId.all, s = (r == null ? void 0 : r[i.id]) ?? [];
  return Jj(o, I, i, g, s, (a, d) => ({
    variableId: a,
    instanceIds: d,
    ruleItem: i,
    ruleColumn: t
  }));
}, Oje = Kj(), Qje = {
  type: "concealVariables",
  isOfType: tGe,
  createActions: Oje
}, jje = (e, t, i, n, g, r, o, I) => {
  const s = {
    articles: [],
    colors: [],
    hideGroups: [],
    hideValues: [],
    hideVariables: [],
    concealVariables: [],
    concealGroups: [],
    images: [],
    instances: [],
    labels: [],
    popups: [],
    models: [],
    materials: [],
    prints: []
  }, a = y1(r, o.state.all.selections), d = ce.groupBy(g.variables, (u) => u.parentId), C = ce.groupBy(a, (u) => u.variableId);
  return t.forEach((u) => {
    const A = g.rules.find((h) => h.id === u.ruleId);
    if (!A) {
      console.warn(`RuleItem ${u.id} does not have a corresponding rule`);
      return;
    }
    const m = A.columns.filter(fGe);
    Object.keys(u.values).forEach((h) => {
      if (!GD(h))
        return;
      const B = u.values[h], f = e.find((y) => y.isOfType(B)), G = f == null ? void 0 : f.type;
      if (G && s[G]) {
        const y = m.find((V) => V.id === h), W = f.createActions(B, {
          column: y,
          ruleItem: u,
          rule: A,
          actionEngineInput: g,
          selections: a,
          validSelectionCombinations: i,
          selectionScopes: n,
          ruleEngineInput: r,
          metadata: I,
          variablesByParentId: d,
          selectionsByVariableId: C
        });
        ce.isArray(W) ? s[G].push(...W ?? []) : W ? s[G].push(W) : console.warn("Action defined for non accessible variable: Might be hidden?");
      }
    });
  }), s;
}, _je = (e) => e.rule.columns.reduce((t, i) => (ua(i) && t.push(i.targetId), t), []), $je = (e, t, i) => i.every((n) => {
  var r, o;
  const g = (r = t.scopes) == null ? void 0 : r[n.id];
  return ce.has(g, e.variableId) ? (
    // If the variable is in the scope, check if the selection fits to the
    // previous scopes
    (o = g == null ? void 0 : g[e.variableId]) == null ? void 0 : o.find((I) => I.id === e.id)
  ) : (
    // If the variable is not in the scope, it means that previous
    // selections have not excLuded it yet. So continue.
    !0
  );
}), qje = (e) => {
  let t = _je(e);
  t.length === 0 && (t = [Dt.variableId]);
  const i = [], n = t.length, g = (r, o) => {
    if (o.length === n)
      i.push([...o]);
    else
      for (let I = r; I < t.length; I++) {
        const s = e.selectionsByVariableId[t[I]];
        for (let a = 0; a < s.length; a++)
          $je(s[a], e, o) && (o.push(s[a]), g(I + 1, o), o.pop());
      }
  };
  return g(0, []), i;
}, e6e = (e) => e.reduce((i, n) => {
  const g = qje(n);
  return g.length > 0 && i.push({
    ...n,
    validSelectionCombinations: g
  }), i;
}, []), t6e = (e) => e.reduce((t, i) => (t.activeRuleItems.push(i.ruleItem), t.validSelectionCombinations[i.ruleItem.id] = i.validSelectionCombinations, i.scopes && (t.selectionScopes[i.ruleItem.id] = i.scopes), t), {
  activeRuleItems: [],
  validSelectionCombinations: {},
  selectionScopes: {}
});
function i6e(e, t, i) {
  const n = Ni(e), g = ce.groupBy(e, (I) => I.parentId), r = ce.groupBy(t, (I) => I.variableId), o = FY(Dt, t, g, r);
  return i.map((I) => {
    const s = I.rule.columns.reduce((a, d) => {
      if (!ua(d))
        return a;
      const C = I.selectionsByVariableId[d.targetId], u = n[d.targetId];
      return u.parentId === Dt.variableId && !SD(u) ? {
        ...a,
        ...C.reduce((A, m) => ({
          ...A,
          [m.id]: o
        }), {})
      } : {
        ...a,
        ...C.reduce((A, m) => {
          const h = FY(m, t, g, r);
          return A[m.id] = h, A;
        }, {})
      };
    }, {
      // If the rule has just action columns and no variable columns we need
      // to provide the global scope as the default.
      [Dt.id]: o
    });
    return {
      ...I,
      scopes: s
    };
  });
}
const n6e = (e, t, i) => {
  const n = Ni(e), g = ce.groupBy(i, (r) => r.variableId);
  return Object.entries(t).flatMap(([r, o]) => {
    const I = n[parseInt(r)], s = I.columns.filter(ua);
    return o.reduce((a, d) => {
      const C = {
        selectionsByVariableId: {},
        rule: I,
        ruleItem: d
      };
      for (let u = 0; u < s.length; u++) {
        const A = s[u], m = g[A.targetId];
        if (!m || m.length === 0)
          return a;
        const h = m.filter((B) => WD(d, B));
        if (h.length === 0)
          return a;
        C.selectionsByVariableId[A.targetId] = h;
      }
      return s.length === 0 && (C.selectionsByVariableId = {
        [Dt.variableId]: [Dt]
      }), a.push(C), a;
    }, []);
  });
}, g6e = (e, t, i) => {
  if (!i || !e)
    return {
      activeRuleItems: [],
      validSelectionCombinations: {},
      selectionScopes: {}
    };
  const n = e.ruleItems, g = y1(t, i.state.all.selections), r = n6e(e.rules, n.byRuleId, g), o = i6e(e.variables, g, r);
  return t6e(e6e(o));
}, r6e = (e) => (t, i, n, g, r) => {
  const {
    activeRuleItems: o,
    validSelectionCombinations: I,
    selectionScopes: s
  } = g6e(t, i, n);
  return jje(e, o, I, s, t, i, n, r);
}, o6e = ti(/* @__PURE__ */ ne("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add"), YY = ti(/* @__PURE__ */ ne("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), "AddCircle"), I6e = ti(/* @__PURE__ */ ne("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "AddCircleOutline"), Ej = ti(/* @__PURE__ */ ne("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBack"), l6e = ti(/* @__PURE__ */ ne("path", {
  d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12m10-1h4v2h-4v3l-4-4 4-4z"
}), "ArrowCircleLeft"), s6e = ti(/* @__PURE__ */ ne("path", {
  d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10m-10 1H8v-2h4V8l4 4-4 4z"
}), "ArrowCircleRight"), a6e = ti(/* @__PURE__ */ ne("path", {
  d: "m7 10 5 5 5-5z"
}), "ArrowDropDown"), c6e = ti(/* @__PURE__ */ ne("path", {
  d: "m7 14 5-5 5 5z"
}), "ArrowDropUp"), d6e = ti(/* @__PURE__ */ ne("path", {
  d: "M19 12h-2v3h-3v2h5zM7 9h3V7H5v5h2zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16.01H3V4.99h18z"
}), "AspectRatioOutlined"), Nj = ti(/* @__PURE__ */ ne("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-5.97 4.06L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.4-1.41 1.41-1.06-1.06 1.41-1.41zm-6.78.66h5v1.5h-5zM11.5 16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2zm6.5 1.25h-5v-1.5h5zm0-2.5h-5v-1.5h5z"
}), "Calculate"), C6e = ti(/* @__PURE__ */ ne("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), "Cancel"), C3 = ti(/* @__PURE__ */ ne("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), LZ = ti(/* @__PURE__ */ ne("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear"), Lj = ti(/* @__PURE__ */ ne("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), u6e = ti(/* @__PURE__ */ ne("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), "CloudUpload"), A6e = ti(/* @__PURE__ */ ne("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy"), b6e = ti(/* @__PURE__ */ ne("path", {
  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11M16 14h2V8c0-1.11-.9-2-2-2h-6v2h6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2z"
}), "CropRotate"), TZ = ti(/* @__PURE__ */ ne("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete"), m6e = ti(/* @__PURE__ */ ne("path", {
  d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), "Done"), S1 = ti(/* @__PURE__ */ ne("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit"), Tj = ti(/* @__PURE__ */ ne("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline"), h6e = ti(/* @__PURE__ */ ne("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess"), OD = ti(/* @__PURE__ */ ne("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), p6e = ti(/* @__PURE__ */ ne("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), "Facebook"), B6e = ti(/* @__PURE__ */ ne("path", {
  d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
}), "FileUpload"), V1 = ti(/* @__PURE__ */ ne("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined"), Z6e = ti(/* @__PURE__ */ ne("path", {
  d: "M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7"
}), "Lightbulb"), f6e = ti(/* @__PURE__ */ ne("path", {
  d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), "LinkedIn"), G6e = ti(/* @__PURE__ */ ne("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), y6e = ti(/* @__PURE__ */ ne("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), "Refresh"), W6e = ti(/* @__PURE__ */ ne("path", {
  d: "M19 13H5v-2h14z"
}), "Remove"), S6e = ti(/* @__PURE__ */ ne("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "ReportProblem"), V6e = ti(/* @__PURE__ */ ne("path", {
  d: "M21 12.4V7l-4-4H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h7.4zM15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3M6 6h9v4H6zm13.99 10.25 1.77 1.77L16.77 23H15v-1.77zm3.26.26-.85.85-1.77-1.77.85-.85c.2-.2.51-.2.71 0l1.06 1.06c.2.2.2.52 0 .71"
}), "SaveAs"), Mj = ti(/* @__PURE__ */ ne("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search"), w6e = ti(/* @__PURE__ */ ne("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2M1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2"
}), "ShoppingCart"), u3 = ti(/* @__PURE__ */ ne("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), "SwapVert"), v6e = ti(/* @__PURE__ */ ne("path", {
  d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
}), "Twitter"), Uj = ti(/* @__PURE__ */ ne("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff"), Pj = ti([/* @__PURE__ */ ne("path", {
  d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
}, "0"), /* @__PURE__ */ ne("path", {
  d: "M13 16h-2v2h2zm0-6h-2v5h2z"
}, "1")], "WarningAmber");
var w1 = { exports: {} };
function R6e(e) {
  return e === "description" || e === "string" || e === "code";
}
function yo(e, t, i) {
  if (!R6e(i))
    throw new Error("invalid Failure type: " + i);
  this.pexpr = e, this.text = t, this.type = i, this.fluffy = !1;
}
yo.prototype.getPExpr = function() {
  return this.pexpr;
};
yo.prototype.getText = function() {
  return this.text;
};
yo.prototype.getType = function() {
  return this.type;
};
yo.prototype.isDescription = function() {
  return this.type === "description";
};
yo.prototype.isStringTerminal = function() {
  return this.type === "string";
};
yo.prototype.isCode = function() {
  return this.type === "code";
};
yo.prototype.isFluffy = function() {
  return this.fluffy;
};
yo.prototype.makeFluffy = function() {
  this.fluffy = !0;
};
yo.prototype.clearFluffy = function() {
  this.fluffy = !1;
};
yo.prototype.subsumes = function(e) {
  return this.getText() === e.getText() && this.type === e.type && (!this.isFluffy() || this.isFluffy() && e.isFluffy());
};
yo.prototype.toString = function() {
  return this.type === "string" ? JSON.stringify(this.getText()) : this.getText();
};
yo.prototype.clone = function() {
  const e = new yo(this.pexpr, this.text, this.type);
  return this.isFluffy() && e.makeFluffy(), e;
};
yo.prototype.toKey = function() {
  return this.toString() + "#" + this.type;
};
var zj = yo, kn = {};
(function(e) {
  e.abstract = function(i) {
    const n = i || "";
    return function() {
      throw new Error(
        "this method " + n + " is abstract! (it has no implementation in class " + this.constructor.name + ")"
      );
    };
  }, e.assert = function(i, n) {
    if (!i)
      throw new Error(n || "Assertion failed");
  }, e.defineLazyProperty = function(i, n, g) {
    let r;
    Object.defineProperty(i, n, {
      get() {
        return r || (r = g.call(this)), r;
      }
    });
  }, e.clone = function(i) {
    return i && Object.assign({}, i);
  }, e.repeatFn = function(i, n) {
    const g = [];
    for (; n-- > 0; )
      g.push(i());
    return g;
  }, e.repeatStr = function(i, n) {
    return new Array(n + 1).join(i);
  }, e.repeat = function(i, n) {
    return e.repeatFn(() => i, n);
  }, e.getDuplicates = function(i) {
    const n = [];
    for (let g = 0; g < i.length; g++) {
      const r = i[g];
      i.lastIndexOf(r) !== g && n.indexOf(r) < 0 && n.push(r);
    }
    return n;
  }, e.copyWithoutDuplicates = function(i) {
    const n = [];
    return i.forEach((g) => {
      n.indexOf(g) < 0 && n.push(g);
    }), n;
  }, e.isSyntactic = function(i) {
    const n = i[0];
    return n === n.toUpperCase();
  }, e.isLexical = function(i) {
    return !e.isSyntactic(i);
  }, e.padLeft = function(i, n, g) {
    const r = g || " ";
    return i.length < n ? e.repeatStr(r, n - i.length) + i : i;
  }, e.StringBuffer = function() {
    this.strings = [];
  }, e.StringBuffer.prototype.append = function(i) {
    this.strings.push(i);
  }, e.StringBuffer.prototype.contents = function() {
    return this.strings.join("");
  };
  const t = (i) => String.fromCodePoint(parseInt(i, 16));
  e.unescapeCodePoint = function(i) {
    if (i.charAt(0) === "\\")
      switch (i.charAt(1)) {
        case "b":
          return "\b";
        case "f":
          return "\f";
        case "n":
          return `
`;
        case "r":
          return "\r";
        case "t":
          return "	";
        case "v":
          return "\v";
        case "x":
          return t(i.slice(2, 4));
        case "u":
          return i.charAt(2) === "{" ? t(i.slice(3, -1)) : t(i.slice(2, 6));
        default:
          return i.charAt(1);
      }
    else
      return i;
  }, e.unexpectedObjToString = function(i) {
    if (i == null)
      return String(i);
    const n = Object.prototype.toString.call(i);
    try {
      let g;
      return i.constructor && i.constructor.name ? g = i.constructor.name : n.indexOf("[object ") === 0 ? g = n.slice(8, -1) : g = typeof i, g + ": " + JSON.stringify(String(i));
    } catch {
      return n;
    }
  };
})(kn);
const A3 = kn;
let v1 = class {
  constructor(t) {
    this.matchLength = t;
  }
  get ctorName() {
    throw new Error("subclass responsibility");
  }
  numChildren() {
    return this.children ? this.children.length : 0;
  }
  childAt(t) {
    if (this.children)
      return this.children[t];
  }
  indexOfChild(t) {
    return this.children.indexOf(t);
  }
  hasChildren() {
    return this.numChildren() > 0;
  }
  hasNoChildren() {
    return !this.hasChildren();
  }
  onlyChild() {
    if (this.numChildren() !== 1)
      throw new Error(
        "cannot get only child of a node of type " + this.ctorName + " (it has " + this.numChildren() + " children)"
      );
    return this.firstChild();
  }
  firstChild() {
    if (this.hasNoChildren())
      throw new Error(
        "cannot get first child of a " + this.ctorName + " node, which has no children"
      );
    return this.childAt(0);
  }
  lastChild() {
    if (this.hasNoChildren())
      throw new Error(
        "cannot get last child of a " + this.ctorName + " node, which has no children"
      );
    return this.childAt(this.numChildren() - 1);
  }
  childBefore(t) {
    const i = this.indexOfChild(t);
    if (i < 0)
      throw new Error("Node.childBefore() called w/ an argument that is not a child");
    if (i === 0)
      throw new Error("cannot get child before first child");
    return this.childAt(i - 1);
  }
  childAfter(t) {
    const i = this.indexOfChild(t);
    if (i < 0)
      throw new Error("Node.childAfter() called w/ an argument that is not a child");
    if (i === this.numChildren() - 1)
      throw new Error("cannot get child after last child");
    return this.childAt(i + 1);
  }
  isTerminal() {
    return !1;
  }
  isNonterminal() {
    return !1;
  }
  isIteration() {
    return !1;
  }
  isOptional() {
    return !1;
  }
};
class X6e extends v1 {
  get ctorName() {
    return "_terminal";
  }
  isTerminal() {
    return !0;
  }
  get primitiveValue() {
    throw new Error("The `primitiveValue` property was removed in Ohm v17.");
  }
}
class H6e extends v1 {
  constructor(t, i, n, g) {
    super(g), this.ruleName = t, this.children = i, this.childOffsets = n;
  }
  get ctorName() {
    return this.ruleName;
  }
  isNonterminal() {
    return !0;
  }
  isLexical() {
    return A3.isLexical(this.ctorName);
  }
  isSyntactic() {
    return A3.isSyntactic(this.ctorName);
  }
}
class k6e extends v1 {
  constructor(t, i, n, g) {
    super(n), this.children = t, this.childOffsets = i, this.optional = g;
  }
  get ctorName() {
    return "_iter";
  }
  isIteration() {
    return !0;
  }
  isOptional() {
    return this.optional;
  }
}
var QD = {
  Node: v1,
  TerminalNode: X6e,
  NonterminalNode: H6e,
  IterationNode: k6e
}, Di = {}, F6e = {
  // Letters
  Lu: /[A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]/,
  Ll: /[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A]|\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]/,
  Lt: /[\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC]/,
  Lm: /[\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]/,
  Lo: /[\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
  // Numbers
  Nl: /[\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF]|\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]/,
  Nd: /[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD801[\uDCA0-\uDCA9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|[\uD805\uD807][\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDD50-\uDD59]/,
  // Marks
  Mn: /[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]/,
  Mc: /[\u0903-\u0903]|[\u093E-\u0940]|[\u0949-\u094C]|[\u0982-\u0983]|[\u09BE-\u09C0]|[\u09C7-\u09C8]|[\u09CB-\u09CC]|[\u09D7-\u09D7]|[\u0A3E-\u0A40]|[\u0A83-\u0A83]|[\u0ABE-\u0AC0]|[\u0AC9-\u0AC9]|[\u0ACB-\u0ACC]|[\u0B02-\u0B03]|[\u0B3E-\u0B3E]|[\u0B40-\u0B40]|[\u0B47-\u0B48]|[\u0B4B-\u0B4C]|[\u0B57-\u0B57]|[\u0B83-\u0B83]|[\u0BBE-\u0BBF]|[\u0BC1-\u0BC2]|[\u0BC6-\u0BC8]|[\u0BCA-\u0BCC]|[\u0BD7-\u0BD7]|[\u0C01-\u0C03]|[\u0C41-\u0C44]|[\u0C82-\u0C83]|[\u0CBE-\u0CBE]|[\u0CC0-\u0CC4]|[\u0CC7-\u0CC8]|[\u0CCA-\u0CCB]|[\u0CD5-\u0CD6]|[\u0D02-\u0D03]|[\u0D3E-\u0D40]|[\u0D46-\u0D48]|[\u0D4A-\u0D4C]|[\u0D57-\u0D57]|[\u0F3E-\u0F3F]|[\u0F7F-\u0F7F]/,
  // Punctuation, Connector
  Pc: /[_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F]/,
  // Separator, Space
  Zs: /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
  // These two are not real Unicode categories, but our useful for Ohm.
  // L is a combination of all the letter categories.
  // Ltmo is a combination of Lt, Lm, and Lo.
  L: /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
  Ltmo: /[\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC]|[\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]|[\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/
};
const Y6e = F6e, x6e = kn;
class io {
  constructor() {
    if (this.constructor === io)
      throw new Error("PExpr cannot be instantiated -- it's abstract");
  }
  // Set the `source` property to the interval containing the source for this expression.
  withSource(t) {
    return t && (this.source = t.trimmed()), this;
  }
}
const D6e = Object.create(io.prototype), J6e = Object.create(io.prototype);
class K6e extends io {
  constructor(t) {
    super(), this.obj = t;
  }
}
class E6e extends io {
  constructor(t, i) {
    super(), this.from = t, this.to = i, this.matchCodePoint = t.length > 1 || i.length > 1;
  }
}
class N6e extends io {
  constructor(t) {
    super(), this.index = t;
  }
}
class jD extends io {
  constructor(t) {
    super(), this.terms = t;
  }
}
class L6e extends jD {
  constructor(t, i, n) {
    const g = t.rules[i].body;
    super([n, g]), this.superGrammar = t, this.name = i, this.body = n;
  }
}
class T6e extends jD {
  constructor(t, i, n, g) {
    const r = t.rules[i].body;
    super([...n, r, ...g]), this.superGrammar = t, this.ruleName = i, this.expansionPos = n.length;
  }
}
class M6e extends io {
  constructor(t) {
    super(), this.factors = t;
  }
}
class R1 extends io {
  constructor(t) {
    super(), this.expr = t;
  }
}
let X1 = class extends R1 {
};
class H1 extends R1 {
}
class k1 extends R1 {
}
X1.prototype.operator = "*";
H1.prototype.operator = "+";
k1.prototype.operator = "?";
X1.prototype.minNumMatches = 0;
H1.prototype.minNumMatches = 1;
k1.prototype.minNumMatches = 0;
X1.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
H1.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
k1.prototype.maxNumMatches = 1;
class U6e extends io {
  constructor(t) {
    super(), this.expr = t;
  }
}
class P6e extends io {
  constructor(t) {
    super(), this.expr = t;
  }
}
class z6e extends io {
  constructor(t) {
    super(), this.expr = t;
  }
}
class O6e extends io {
  constructor(t, i = []) {
    super(), this.ruleName = t, this.args = i;
  }
  isSyntactic() {
    return x6e.isSyntactic(this.ruleName);
  }
  // This method just caches the result of `this.toString()` in a non-enumerable property.
  toMemoKey() {
    return this._memoKey || Object.defineProperty(this, "_memoKey", { value: this.toString() }), this._memoKey;
  }
}
class Q6e extends io {
  constructor(t) {
    super(), this.category = t, this.pattern = Y6e[t];
  }
}
Di.PExpr = io;
Di.any = D6e;
Di.end = J6e;
Di.Terminal = K6e;
Di.Range = E6e;
Di.Param = N6e;
Di.Alt = jD;
Di.Extend = L6e;
Di.Splice = T6e;
Di.Seq = M6e;
Di.Iter = R1;
Di.Star = X1;
Di.Plus = H1;
Di.Opt = k1;
Di.Not = U6e;
Di.Lookahead = P6e;
Di.Lex = z6e;
Di.Apply = O6e;
Di.UnicodeChar = Q6e;
const j6e = kn, Lo = Di;
Lo.PExpr.prototype.allowsSkippingPrecedingSpace = j6e.abstract(
  "allowsSkippingPrecedingSpace"
);
Lo.any.allowsSkippingPrecedingSpace = Lo.end.allowsSkippingPrecedingSpace = Lo.Apply.prototype.allowsSkippingPrecedingSpace = Lo.Terminal.prototype.allowsSkippingPrecedingSpace = Lo.Range.prototype.allowsSkippingPrecedingSpace = Lo.UnicodeChar.prototype.allowsSkippingPrecedingSpace = function() {
  return !0;
};
Lo.Alt.prototype.allowsSkippingPrecedingSpace = Lo.Iter.prototype.allowsSkippingPrecedingSpace = Lo.Lex.prototype.allowsSkippingPrecedingSpace = Lo.Lookahead.prototype.allowsSkippingPrecedingSpace = Lo.Not.prototype.allowsSkippingPrecedingSpace = Lo.Param.prototype.allowsSkippingPrecedingSpace = Lo.Seq.prototype.allowsSkippingPrecedingSpace = function() {
  return !1;
};
function yI() {
}
yI.prototype = /* @__PURE__ */ Object.create(null);
yI.asNamespace = function(e) {
  return e instanceof yI ? e : yI.createNamespace(e);
};
yI.createNamespace = function(e) {
  return yI.extend(yI.prototype, e);
};
yI.extend = function(e, t) {
  if (e !== yI.prototype && !(e instanceof yI))
    throw new TypeError("not a Namespace object: " + e);
  const i = Object.create(e, {
    constructor: {
      value: yI,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
  return Object.assign(i, t);
};
yI.toString = function(e) {
  return Object.prototype.toString.call(e);
};
var Oj = yI;
const { assert: _6e } = kn, $6e = Oj, q6e = Di;
function gg(e, t) {
  let i;
  return t ? (i = new Error(t.getLineAndColumnMessage() + e), i.shortMessage = e, i.interval = t) : i = new Error(e), i;
}
function e7e() {
  return gg("Interval sources don't match");
}
function t7e(e) {
  const t = new Error();
  return Object.defineProperty(t, "message", {
    enumerable: !0,
    get() {
      return e.message;
    }
  }), Object.defineProperty(t, "shortMessage", {
    enumerable: !0,
    get() {
      return "Expected " + e.getExpectedText();
    }
  }), t.interval = e.getInterval(), t;
}
function i7e(e, t, i) {
  const n = t ? "Grammar " + e + " is not declared in namespace " + $6e.toString(t) : "Undeclared grammar " + e;
  return gg(n, i);
}
function n7e(e, t) {
  return gg("Grammar " + e.name + " is already declared in this namespace");
}
function g7e(e, t, i) {
  return gg(
    "Rule " + e + " is not declared in grammar " + t,
    i
  );
}
function r7e(e, t, i) {
  return gg(
    "Cannot override rule " + e + " because it is not declared in " + t,
    i
  );
}
function o7e(e, t, i) {
  return gg(
    "Cannot extend rule " + e + " because it is not declared in " + t,
    i
  );
}
function I7e(e, t, i, n) {
  let g = "Duplicate declaration for rule '" + e + "' in grammar '" + t + "'";
  return t !== i && (g += " (originally declared in '" + i + "')"), gg(g, n);
}
function l7e(e, t, i, n) {
  return gg(
    "Wrong number of parameters for rule " + e + " (expected " + t + ", got " + i + ")",
    n
  );
}
function s7e(e, t, i, n) {
  return gg(
    "Wrong number of arguments for rule " + e + " (expected " + t + ", got " + i + ")",
    n
  );
}
function a7e(e, t, i) {
  return gg(
    "Duplicate parameter names in rule " + e + ": " + t.join(", "),
    i
  );
}
function c7e(e, t) {
  return gg(
    "Invalid parameter to rule " + e + ": " + t + " has arity " + t.getArity() + ", but parameter expressions must have arity 1",
    t.source
  );
}
const d7e = "NOTE: A _syntactic rule_ is a rule whose name begins with a capital letter. See https://ohmjs.org/d/svl for more details.";
function C7e(e, t) {
  return gg(
    "Cannot apply syntactic rule " + e + " from here (inside a lexical context)",
    t.source
  );
}
function u7e(e) {
  const { ruleName: t } = e;
  return gg(
    `applySyntactic is for syntactic rules, but '${t}' is a lexical rule. ` + d7e,
    e.source
  );
}
function A7e(e) {
  return gg(
    "applySyntactic is not required here (in a syntactic context)",
    e.source
  );
}
function b7e(e, t) {
  return gg("Incorrect argument type: expected " + e, t.source);
}
function m7e(e) {
  return gg("'...' can appear at most once in a rule body", e.source);
}
function h7e(e) {
  const t = e._node;
  _6e(t && t.isNonterminal() && t.ctorName === "escapeChar_unicodeCodePoint");
  const i = e.children.slice(1, -1).map((g) => g.source), n = i[0].coverageWith(...i.slice(1));
  return gg(
    `U+${n.contents} is not a valid Unicode code point`,
    n
  );
}
function p7e(e, t) {
  const i = t.length > 0 ? t[t.length - 1].args : [];
  let g = "Nullable expression " + e.expr.substituteParams(i) + " is not allowed inside '" + e.operator + "' (possible infinite loop)";
  if (t.length > 0) {
    const r = t.map((o) => new q6e.Apply(o.ruleName, o.args)).join(`
`);
    g += `
Application stack (most recent application last):
` + r;
  }
  return gg(g, e.expr.source);
}
function B7e(e, t, i, n) {
  return gg(
    "Rule " + e + " involves an alternation which has inconsistent arity (expected " + t + ", got " + i + ")",
    n.source
  );
}
function Z7e(e) {
  return gg("Object pattern has duplicate property names: " + e.join(", "));
}
function f7e(e, t, i) {
  return gg(
    "Attempt to invoke constructor " + t + " with invalid or unexpected arguments"
  );
}
function G7e(e) {
  const t = e.map((i) => i.message);
  return gg(["Errors:"].concat(t).join(`
- `), e[0].interval);
}
function y7e(e, t, i, n) {
  let g = n.slice(0, -1).map((s) => {
    const a = "  " + s[0].name + " > " + s[1];
    return s.length === 3 ? a + " for '" + s[2] + "'" : a;
  }).join(`
`);
  g += `
  ` + t + " > " + e;
  let r = "";
  e === "_iter" && (r = [
    `
NOTE: as of Ohm v16, there is no default action for iteration nodes — see `,
    "  https://ohmjs.org/d/dsa for details."
  ].join(`
`));
  const o = [
    `Missing semantic action for '${e}' in ${i} '${t}'.${r}`,
    "Action stack (most recent call last):",
    g
  ].join(`
`), I = gg(o);
  return I.name = "missingSemanticAction", I;
}
var Sc = {
  applicationOfSyntacticRuleFromLexicalContext: C7e,
  applySyntacticWithLexicalRuleApplication: u7e,
  cannotExtendUndeclaredRule: o7e,
  cannotOverrideUndeclaredRule: r7e,
  duplicateGrammarDeclaration: n7e,
  duplicateParameterNames: a7e,
  duplicatePropertyNames: Z7e,
  duplicateRuleDeclaration: I7e,
  inconsistentArity: B7e,
  incorrectArgumentType: b7e,
  intervalSourcesDontMatch: e7e,
  invalidCodePoint: h7e,
  invalidConstructorCall: f7e,
  invalidParameter: c7e,
  grammarSyntaxError: t7e,
  kleeneExprHasNullableOperand: p7e,
  missingSemanticAction: y7e,
  multipleSuperSplices: m7e,
  undeclaredGrammar: i7e,
  undeclaredRule: g7e,
  unnecessaryExperimentalApplySyntactic: A7e,
  wrongNumberOfArguments: s7e,
  wrongNumberOfParameters: l7e,
  throwErrors(e) {
    if (e.length === 1)
      throw e[0];
    if (e.length > 1)
      throw G7e(e);
  }
}, qd = {};
(function(e) {
  const t = kn;
  function i(o) {
    let I = 0;
    return o.map((a) => {
      const d = a.toString();
      return I = Math.max(I, d.length), d;
    }).map((a) => t.padLeft(a, I));
  }
  function n(o, I, s) {
    const a = o.length, d = o.slice(0, s), C = o.slice(s + I.length);
    return (d + I + C).substr(0, a);
  }
  function g(...o) {
    const I = this, { offset: s } = I, { repeatStr: a } = t, d = new t.StringBuffer();
    d.append("Line " + I.lineNum + ", col " + I.colNum + `:
`);
    const C = i([
      I.prevLine == null ? 0 : I.lineNum - 1,
      I.lineNum,
      I.nextLine == null ? 0 : I.lineNum + 1
    ]), u = (B, f, G) => {
      d.append(G + C[B] + " | " + f + `
`);
    };
    I.prevLine != null && u(0, I.prevLine, "  "), u(1, I.line, "> ");
    const A = I.line.length;
    let m = a(" ", A + 1);
    for (let B = 0; B < o.length; ++B) {
      let f = o[B][0], G = o[B][1];
      t.assert(f >= 0 && f <= G, "range start must be >= 0 and <= end");
      const y = s - I.colNum + 1;
      f = Math.max(0, f - y), G = Math.min(G - y, A), m = n(m, a("~", G - f), f);
    }
    const h = 2 + C[1].length + 3;
    return d.append(a(" ", h)), m = n(m, "^", I.colNum - 1), d.append(m.replace(/ +$/, "") + `
`), I.nextLine != null && u(2, I.nextLine, "  "), d.contents();
  }
  let r = [];
  e.awaitBuiltInRules = (o) => {
    r.push(o);
  }, e.announceBuiltInRules = (o) => {
    r.forEach((I) => {
      I(o);
    }), r = null;
  }, e.getLineAndColumn = (o, I) => {
    let s = 1, a = 1, d = 0, C = 0, u = null, A = null, m = -1;
    for (; d < I; ) {
      const f = o.charAt(d++);
      f === `
` ? (s++, a = 1, m = C, C = d) : f !== "\r" && a++;
    }
    let h = o.indexOf(`
`, C);
    if (h === -1)
      h = o.length;
    else {
      const f = o.indexOf(`
`, h + 1);
      u = f === -1 ? o.slice(h) : o.slice(h, f), u = u.replace(/^\r?\n/, "").replace(/\r$/, "");
    }
    m >= 0 && (A = o.slice(m, C).replace(/\r?\n$/, ""));
    const B = o.slice(C, h).replace(/\r$/, "");
    return {
      offset: I,
      lineNum: s,
      colNum: a,
      line: B,
      prevLine: A,
      nextLine: u,
      toString: g
    };
  }, e.getLineAndColumnMessage = function(o, I, ...s) {
    return e.getLineAndColumn(o, I).toString(...s);
  }, e.uniqueId = /* @__PURE__ */ (() => {
    let o = 0;
    return (I) => "" + I + o++;
  })();
})(qd);
const { abstract: W7e, isSyntactic: yk } = kn, cd = Sc, Jr = Di, S7e = qd;
let Q0;
S7e.awaitBuiltInRules((e) => {
  Q0 = e;
});
let eV;
Jr.PExpr.prototype.assertAllApplicationsAreValid = function(e, t) {
  eV = 0, this._assertAllApplicationsAreValid(e, t);
};
Jr.PExpr.prototype._assertAllApplicationsAreValid = W7e(
  "_assertAllApplicationsAreValid"
);
Jr.any._assertAllApplicationsAreValid = Jr.end._assertAllApplicationsAreValid = Jr.Terminal.prototype._assertAllApplicationsAreValid = Jr.Range.prototype._assertAllApplicationsAreValid = Jr.Param.prototype._assertAllApplicationsAreValid = Jr.UnicodeChar.prototype._assertAllApplicationsAreValid = function(e, t) {
};
Jr.Lex.prototype._assertAllApplicationsAreValid = function(e, t) {
  eV++, this.expr._assertAllApplicationsAreValid(e, t), eV--;
};
Jr.Alt.prototype._assertAllApplicationsAreValid = function(e, t) {
  for (let i = 0; i < this.terms.length; i++)
    this.terms[i]._assertAllApplicationsAreValid(e, t);
};
Jr.Seq.prototype._assertAllApplicationsAreValid = function(e, t) {
  for (let i = 0; i < this.factors.length; i++)
    this.factors[i]._assertAllApplicationsAreValid(e, t);
};
Jr.Iter.prototype._assertAllApplicationsAreValid = Jr.Not.prototype._assertAllApplicationsAreValid = Jr.Lookahead.prototype._assertAllApplicationsAreValid = function(e, t) {
  this.expr._assertAllApplicationsAreValid(e, t);
};
Jr.Apply.prototype._assertAllApplicationsAreValid = function(e, t, i = !1) {
  const n = t.rules[this.ruleName], g = yk(e) && eV === 0;
  if (!n)
    throw cd.undeclaredRule(this.ruleName, t.name, this.source);
  if (!i && yk(this.ruleName) && !g)
    throw cd.applicationOfSyntacticRuleFromLexicalContext(this.ruleName, this);
  const r = this.args.length, o = n.formals.length;
  if (r !== o)
    throw cd.wrongNumberOfArguments(this.ruleName, o, r, this.source);
  const I = Q0 && n === Q0.rules.applySyntactic;
  if (Q0 && n === Q0.rules.caseInsensitive && !(this.args[0] instanceof Jr.Terminal))
    throw cd.incorrectArgumentType('a Terminal (e.g. "abc")', this.args[0]);
  if (I) {
    const a = this.args[0];
    if (!(a instanceof Jr.Apply))
      throw cd.incorrectArgumentType("a syntactic rule application", a);
    if (!yk(a.ruleName))
      throw cd.applySyntacticWithLexicalRuleApplication(a);
    if (g)
      throw cd.unnecessaryExperimentalApplySyntactic(this);
  }
  this.args.forEach((a) => {
    if (a._assertAllApplicationsAreValid(e, t, I), a.getArity() !== 1)
      throw cd.invalidParameter(this.ruleName, a);
  });
};
const V7e = kn, Qj = Sc, ho = Di;
ho.PExpr.prototype.assertChoicesHaveUniformArity = V7e.abstract(
  "assertChoicesHaveUniformArity"
);
ho.any.assertChoicesHaveUniformArity = ho.end.assertChoicesHaveUniformArity = ho.Terminal.prototype.assertChoicesHaveUniformArity = ho.Range.prototype.assertChoicesHaveUniformArity = ho.Param.prototype.assertChoicesHaveUniformArity = ho.Lex.prototype.assertChoicesHaveUniformArity = ho.UnicodeChar.prototype.assertChoicesHaveUniformArity = function(e) {
};
ho.Alt.prototype.assertChoicesHaveUniformArity = function(e) {
  if (this.terms.length === 0)
    return;
  const t = this.terms[0].getArity();
  for (let i = 0; i < this.terms.length; i++) {
    const n = this.terms[i];
    n.assertChoicesHaveUniformArity();
    const g = n.getArity();
    if (t !== g)
      throw Qj.inconsistentArity(e, t, g, n);
  }
};
ho.Extend.prototype.assertChoicesHaveUniformArity = function(e) {
  const t = this.terms[0].getArity(), i = this.terms[1].getArity();
  if (t !== i)
    throw Qj.inconsistentArity(e, i, t, this.terms[0]);
};
ho.Seq.prototype.assertChoicesHaveUniformArity = function(e) {
  for (let t = 0; t < this.factors.length; t++)
    this.factors[t].assertChoicesHaveUniformArity(e);
};
ho.Iter.prototype.assertChoicesHaveUniformArity = function(e) {
  this.expr.assertChoicesHaveUniformArity(e);
};
ho.Not.prototype.assertChoicesHaveUniformArity = function(e) {
};
ho.Lookahead.prototype.assertChoicesHaveUniformArity = function(e) {
  this.expr.assertChoicesHaveUniformArity(e);
};
ho.Apply.prototype.assertChoicesHaveUniformArity = function(e) {
};
const w7e = kn, v7e = Sc, po = Di;
po.PExpr.prototype.assertIteratedExprsAreNotNullable = w7e.abstract(
  "assertIteratedExprsAreNotNullable"
);
po.any.assertIteratedExprsAreNotNullable = po.end.assertIteratedExprsAreNotNullable = po.Terminal.prototype.assertIteratedExprsAreNotNullable = po.Range.prototype.assertIteratedExprsAreNotNullable = po.Param.prototype.assertIteratedExprsAreNotNullable = po.UnicodeChar.prototype.assertIteratedExprsAreNotNullable = function(e) {
};
po.Alt.prototype.assertIteratedExprsAreNotNullable = function(e) {
  for (let t = 0; t < this.terms.length; t++)
    this.terms[t].assertIteratedExprsAreNotNullable(e);
};
po.Seq.prototype.assertIteratedExprsAreNotNullable = function(e) {
  for (let t = 0; t < this.factors.length; t++)
    this.factors[t].assertIteratedExprsAreNotNullable(e);
};
po.Iter.prototype.assertIteratedExprsAreNotNullable = function(e) {
  if (this.expr.assertIteratedExprsAreNotNullable(e), this.expr.isNullable(e))
    throw v7e.kleeneExprHasNullableOperand(this, []);
};
po.Opt.prototype.assertIteratedExprsAreNotNullable = po.Not.prototype.assertIteratedExprsAreNotNullable = po.Lookahead.prototype.assertIteratedExprsAreNotNullable = po.Lex.prototype.assertIteratedExprsAreNotNullable = function(e) {
  this.expr.assertIteratedExprsAreNotNullable(e);
};
po.Apply.prototype.assertIteratedExprsAreNotNullable = function(e) {
  this.args.forEach((t) => {
    t.assertIteratedExprsAreNotNullable(e);
  });
};
const { assert: R7e } = kn, xY = Sc, b3 = qd;
function bo(e, t, i) {
  this.sourceString = e, this.startIdx = t, this.endIdx = i;
}
bo.coverage = function(e, ...t) {
  let { startIdx: i, endIdx: n } = e;
  for (const g of t) {
    if (g.sourceString !== e.sourceString)
      throw xY.intervalSourcesDontMatch();
    i = Math.min(i, g.startIdx), n = Math.max(n, g.endIdx);
  }
  return new bo(e.sourceString, i, n);
};
bo.prototype = {
  coverageWith(...e) {
    return bo.coverage(...e, this);
  },
  collapsedLeft() {
    return new bo(this.sourceString, this.startIdx, this.startIdx);
  },
  collapsedRight() {
    return new bo(this.sourceString, this.endIdx, this.endIdx);
  },
  getLineAndColumn() {
    return b3.getLineAndColumn(this.sourceString, this.startIdx);
  },
  getLineAndColumnMessage() {
    const e = [this.startIdx, this.endIdx];
    return b3.getLineAndColumnMessage(this.sourceString, this.startIdx, e);
  },
  // Returns an array of 0, 1, or 2 intervals that represents the result of the
  // interval difference operation.
  minus(e) {
    if (this.sourceString !== e.sourceString)
      throw xY.intervalSourcesDontMatch();
    return this.startIdx === e.startIdx && this.endIdx === e.endIdx ? [] : this.startIdx < e.startIdx && e.endIdx < this.endIdx ? [
      new bo(this.sourceString, this.startIdx, e.startIdx),
      new bo(this.sourceString, e.endIdx, this.endIdx)
    ] : this.startIdx < e.endIdx && e.endIdx < this.endIdx ? [new bo(this.sourceString, e.endIdx, this.endIdx)] : this.startIdx < e.startIdx && e.startIdx < this.endIdx ? [new bo(this.sourceString, this.startIdx, e.startIdx)] : [this];
  },
  // Returns a new Interval that has the same extent as this one, but which is relative
  // to `that`, an Interval that fully covers this one.
  relativeTo(e) {
    if (this.sourceString !== e.sourceString)
      throw xY.intervalSourcesDontMatch();
    return R7e(
      this.startIdx >= e.startIdx && this.endIdx <= e.endIdx,
      "other interval does not cover this one"
    ), new bo(
      this.sourceString,
      this.startIdx - e.startIdx,
      this.endIdx - e.startIdx
    );
  },
  // Returns a new Interval which contains the same contents as this one,
  // but with whitespace trimmed from both ends.
  trimmed() {
    const { contents: e } = this, t = this.startIdx + e.match(/^\s*/)[0].length, i = this.endIdx - e.match(/\s*$/)[0].length;
    return new bo(this.sourceString, t, i);
  },
  subInterval(e, t) {
    const i = this.startIdx + e;
    return new bo(this.sourceString, i, i + t);
  }
};
Object.defineProperties(bo.prototype, {
  contents: {
    get() {
      return this._contents === void 0 && (this._contents = this.sourceString.slice(this.startIdx, this.endIdx)), this._contents;
    },
    enumerable: !0
  },
  length: {
    get() {
      return this.endIdx - this.startIdx;
    },
    enumerable: !0
  }
});
var _D = bo;
const X7e = _D, $D = kn, H7e = "✗", k7e = "✓", F7e = "⋅", Y7e = "⇒", x7e = "␉", D7e = "␊", J7e = "␍", DY = {
  succeeded: 1,
  isRootNode: 2,
  isImplicitSpaces: 4,
  isMemoized: 8,
  isHeadOfLeftRecursion: 16,
  terminatesLR: 32
};
function K7e(e) {
  return $D.repeat(" ", e).join("");
}
function E7e(e, t, i) {
  const n = jj(e.slice(t, t + i));
  return n.length < i ? n + $D.repeat(" ", i - n.length).join("") : n;
}
function jj(e) {
  return typeof e == "string" ? e.replace(/ /g, F7e).replace(/\t/g, x7e).replace(/\n/g, D7e).replace(/\r/g, J7e) : String(e);
}
function Gl(e, t, i, n, g, r, o) {
  this.input = e, this.pos = this.pos1 = t, this.pos2 = i, this.source = new X7e(e, t, i), this.expr = n, this.bindings = r, this.children = o || [], this.terminatingLREntry = null, this._flags = g ? DY.succeeded : 0;
}
Gl.prototype.SKIP = {};
Object.defineProperty(Gl.prototype, "displayString", {
  get() {
    return this.expr.toDisplayString();
  }
});
Object.keys(DY).forEach((e) => {
  const t = DY[e];
  Object.defineProperty(Gl.prototype, e, {
    get() {
      return (this._flags & t) !== 0;
    },
    set(i) {
      i ? this._flags |= t : this._flags &= ~t;
    }
  });
});
Gl.prototype.clone = function() {
  return this.cloneWithExpr(this.expr);
};
Gl.prototype.cloneWithExpr = function(e) {
  const t = new Gl(
    this.input,
    this.pos,
    this.pos2,
    e,
    this.succeeded,
    this.bindings,
    this.children
  );
  return t.isHeadOfLeftRecursion = this.isHeadOfLeftRecursion, t.isImplicitSpaces = this.isImplicitSpaces, t.isMemoized = this.isMemoized, t.isRootNode = this.isRootNode, t.terminatesLR = this.terminatesLR, t.terminatingLREntry = this.terminatingLREntry, t;
};
Gl.prototype.recordLRTermination = function(e, t) {
  this.terminatingLREntry = new Gl(
    this.input,
    this.pos,
    this.pos2,
    this.expr,
    !1,
    [t],
    [e]
  ), this.terminatingLREntry.terminatesLR = !0;
};
Gl.prototype.walk = function(e, t) {
  let i = e;
  typeof i == "function" && (i = { enter: i });
  function n(g, r, o) {
    let I = !0;
    i.enter && i.enter.call(t, g, r, o) === Gl.prototype.SKIP && (I = !1), I && (g.children.forEach((s) => {
      n(s, g, o + 1);
    }), i.exit && i.exit.call(t, g, r, o));
  }
  this.isRootNode ? this.children.forEach((g) => {
    n(g, null, 0);
  }) : n(this, null, 0);
};
Gl.prototype.toString = function() {
  const e = new $D.StringBuffer();
  return this.walk((t, i, n) => {
    if (!t)
      return this.SKIP;
    if (t.expr.constructor.name !== "Alt") {
      if (e.append(E7e(t.input, t.pos, 10) + K7e(n * 2 + 1)), e.append((t.succeeded ? k7e : H7e) + " " + t.displayString), t.isHeadOfLeftRecursion && e.append(" (LR)"), t.succeeded) {
        const r = jj(t.source.contents);
        e.append(" " + Y7e + "  "), e.append(typeof r == "string" ? '"' + r + '"' : r);
      }
      e.append(`
`);
    }
  }), e.contents();
};
var _j = Gl;
const N7e = _j, $j = kn, L7e = Sc, qD = QD, Qg = Di, { TerminalNode: MZ } = qD, { NonterminalNode: T7e } = qD, { IterationNode: M7e } = qD;
Qg.PExpr.prototype.eval = $j.abstract("eval");
Qg.any.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = t.next();
  return n ? (e.pushBinding(new MZ(n.length), i), !0) : (e.processFailure(i, this), !1);
};
Qg.end.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  return t.atEnd() ? (e.pushBinding(new MZ(0), i), !0) : (e.processFailure(i, this), !1);
};
Qg.Terminal.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  return t.matchString(this.obj) ? (e.pushBinding(new MZ(this.obj.length), i), !0) : (e.processFailure(i, this), !1);
};
Qg.Range.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = this.matchCodePoint ? t.nextCodePoint() : t.nextCharCode();
  return n !== void 0 && this.from.codePointAt(0) <= n && n <= this.to.codePointAt(0) ? (e.pushBinding(new MZ(String.fromCodePoint(n).length), i), !0) : (e.processFailure(i, this), !1);
};
Qg.Param.prototype.eval = function(e) {
  return e.eval(e.currentApplication().args[this.index]);
};
Qg.Lex.prototype.eval = function(e) {
  e.enterLexifiedContext();
  const t = e.eval(this.expr);
  return e.exitLexifiedContext(), t;
};
Qg.Alt.prototype.eval = function(e) {
  for (let t = 0; t < this.terms.length; t++)
    if (e.eval(this.terms[t]))
      return !0;
  return !1;
};
Qg.Seq.prototype.eval = function(e) {
  for (let t = 0; t < this.factors.length; t++) {
    const i = this.factors[t];
    if (!e.eval(i))
      return !1;
  }
  return !0;
};
Qg.Iter.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = this.getArity(), g = [], r = [];
  for (; g.length < n; )
    g.push([]), r.push([]);
  let o = 0, I = i, s;
  for (; o < this.maxNumMatches && e.eval(this.expr); ) {
    if (t.pos === I)
      throw L7e.kleeneExprHasNullableOperand(this, e._applicationStack);
    I = t.pos, o++;
    const u = e._bindings.splice(e._bindings.length - n, n), A = e._bindingOffsets.splice(
      e._bindingOffsets.length - n,
      n
    );
    for (s = 0; s < u.length; s++)
      g[s].push(u[s]), r[s].push(A[s]);
  }
  if (o < this.minNumMatches)
    return !1;
  let a = e.posToOffset(i), d = 0;
  if (o > 0) {
    const u = g[n - 1], A = r[n - 1], m = A[A.length - 1] + u[u.length - 1].matchLength;
    a = r[0][0], d = m - a;
  }
  const C = this instanceof Qg.Opt;
  for (s = 0; s < g.length; s++)
    e._bindings.push(
      new M7e(g[s], r[s], d, C)
    ), e._bindingOffsets.push(a);
  return !0;
};
Qg.Not.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  e.pushFailuresInfo();
  const n = e.eval(this.expr);
  return e.popFailuresInfo(), n ? (e.processFailure(i, this), !1) : (t.pos = i, !0);
};
Qg.Lookahead.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  return e.eval(this.expr) ? (t.pos = i, !0) : !1;
};
Qg.Apply.prototype.eval = function(e) {
  const t = e.currentApplication(), i = t ? t.args : [], n = this.substituteParams(i), g = e.getCurrentPosInfo();
  if (g.isActive(n))
    return n.handleCycle(e);
  const r = n.toMemoKey(), o = g.memo[r];
  if (o && g.shouldUseMemoizedResult(o)) {
    if (e.hasNecessaryInfo(o))
      return e.useMemoizedResult(e.inputStream.pos, o);
    delete g.memo[r];
  }
  return n.reallyEval(e);
};
Qg.Apply.prototype.handleCycle = function(e) {
  const t = e.getCurrentPosInfo(), { currentLeftRecursion: i } = t, n = this.toMemoKey();
  let g = t.memo[n];
  return i && i.headApplication.toMemoKey() === n ? g.updateInvolvedApplicationMemoKeys() : g || (g = t.memoize(n, {
    matchLength: 0,
    examinedLength: 0,
    value: !1,
    rightmostFailureOffset: -1
  }), t.startLeftRecursion(this, g)), e.useMemoizedResult(e.inputStream.pos, g);
};
Qg.Apply.prototype.reallyEval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = e.getCurrentPosInfo(), g = e.grammar.rules[this.ruleName], { body: r } = g, { description: o } = g;
  e.enterApplication(n, this), o && e.pushFailuresInfo();
  const I = t.examinedLength;
  t.examinedLength = 0;
  let s = this.evalOnce(r, e);
  const a = n.currentLeftRecursion, d = this.toMemoKey(), C = a && a.headApplication.toMemoKey() === d;
  let u;
  C ? (s = this.growSeedResult(r, e, i, a, s), n.endLeftRecursion(), u = a, u.examinedLength = t.examinedLength - i, u.rightmostFailureOffset = e._getRightmostFailureOffset(), n.memoize(d, u)) : (!a || !a.isInvolved(d)) && (u = n.memoize(d, {
    matchLength: t.pos - i,
    examinedLength: t.examinedLength - i,
    value: s,
    failuresAtRightmostPosition: e.cloneRecordedFailures(),
    rightmostFailureOffset: e._getRightmostFailureOffset()
  }));
  const A = !!s;
  if (o && (e.popFailuresInfo(), A || e.processFailure(i, this), u && (u.failuresAtRightmostPosition = e.cloneRecordedFailures())), e.isTracing() && u) {
    const m = e.getTraceEntry(i, this, A, A ? [s] : []);
    C && ($j.assert(m.terminatingLREntry != null || !A), m.isHeadOfLeftRecursion = !0), u.traceEntry = m;
  }
  return t.examinedLength = Math.max(
    t.examinedLength,
    I
  ), e.exitApplication(n, s), A;
};
Qg.Apply.prototype.evalOnce = function(e, t) {
  const { inputStream: i } = t, n = i.pos;
  if (t.eval(e)) {
    const g = e.getArity(), r = t._bindings.splice(t._bindings.length - g, g), o = t._bindingOffsets.splice(t._bindingOffsets.length - g, g), I = i.pos - n;
    return new T7e(this.ruleName, r, o, I);
  } else
    return !1;
};
Qg.Apply.prototype.growSeedResult = function(e, t, i, n, g) {
  if (!g)
    return !1;
  const { inputStream: r } = t;
  for (; ; ) {
    if (n.matchLength = r.pos - i, n.value = g, n.failuresAtRightmostPosition = t.cloneRecordedFailures(), t.isTracing()) {
      const o = t.trace[t.trace.length - 1];
      n.traceEntry = new N7e(
        t.input,
        i,
        r.pos,
        this,
        !0,
        [g],
        [o.clone()]
      );
    }
    if (r.pos = i, g = this.evalOnce(e, t), r.pos - i <= n.matchLength)
      break;
    t.isTracing() && t.trace.splice(-2, 1);
  }
  return t.isTracing() && n.traceEntry.recordLRTermination(t.trace.pop(), g), r.pos = i + n.matchLength, n.value;
};
Qg.UnicodeChar.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = t.next();
  return n && this.pattern.test(n) ? (e.pushBinding(new MZ(n.length), i), !0) : (e.processFailure(i, this), !1);
};
const U7e = kn, To = Di;
To.PExpr.prototype.getArity = U7e.abstract("getArity");
To.any.getArity = To.end.getArity = To.Terminal.prototype.getArity = To.Range.prototype.getArity = To.Param.prototype.getArity = To.Apply.prototype.getArity = To.UnicodeChar.prototype.getArity = function() {
  return 1;
};
To.Alt.prototype.getArity = function() {
  return this.terms.length === 0 ? 0 : this.terms[0].getArity();
};
To.Seq.prototype.getArity = function() {
  let e = 0;
  for (let t = 0; t < this.factors.length; t++)
    e += this.factors[t].getArity();
  return e;
};
To.Iter.prototype.getArity = function() {
  return this.expr.getArity();
};
To.Not.prototype.getArity = function() {
  return 0;
};
To.Lookahead.prototype.getArity = To.Lex.prototype.getArity = function() {
  return this.expr.getArity();
};
const P7e = kn, cr = Di;
function Ss(e, t) {
  const i = {};
  if (e.source && t) {
    const n = e.source.relativeTo(t);
    i.sourceInterval = [n.startIdx, n.endIdx];
  }
  return i;
}
cr.PExpr.prototype.outputRecipe = P7e.abstract("outputRecipe");
cr.any.outputRecipe = function(e, t) {
  return ["any", Ss(this, t)];
};
cr.end.outputRecipe = function(e, t) {
  return ["end", Ss(this, t)];
};
cr.Terminal.prototype.outputRecipe = function(e, t) {
  return ["terminal", Ss(this, t), this.obj];
};
cr.Range.prototype.outputRecipe = function(e, t) {
  return ["range", Ss(this, t), this.from, this.to];
};
cr.Param.prototype.outputRecipe = function(e, t) {
  return ["param", Ss(this, t), this.index];
};
cr.Alt.prototype.outputRecipe = function(e, t) {
  return ["alt", Ss(this, t)].concat(
    this.terms.map((i) => i.outputRecipe(e, t))
  );
};
cr.Extend.prototype.outputRecipe = function(e, t) {
  return this.terms[0].outputRecipe(e, t);
};
cr.Splice.prototype.outputRecipe = function(e, t) {
  const i = this.terms.slice(0, this.expansionPos), n = this.terms.slice(this.expansionPos + 1);
  return [
    "splice",
    Ss(this, t),
    i.map((g) => g.outputRecipe(e, t)),
    n.map((g) => g.outputRecipe(e, t))
  ];
};
cr.Seq.prototype.outputRecipe = function(e, t) {
  return ["seq", Ss(this, t)].concat(
    this.factors.map((i) => i.outputRecipe(e, t))
  );
};
cr.Star.prototype.outputRecipe = cr.Plus.prototype.outputRecipe = cr.Opt.prototype.outputRecipe = cr.Not.prototype.outputRecipe = cr.Lookahead.prototype.outputRecipe = cr.Lex.prototype.outputRecipe = function(e, t) {
  return [
    this.constructor.name.toLowerCase(),
    Ss(this, t),
    this.expr.outputRecipe(e, t)
  ];
};
cr.Apply.prototype.outputRecipe = function(e, t) {
  return [
    "app",
    Ss(this, t),
    this.ruleName,
    this.args.map((i) => i.outputRecipe(e, t))
  ];
};
cr.UnicodeChar.prototype.outputRecipe = function(e, t) {
  return ["unicodeChar", Ss(this, t), this.category];
};
const z7e = kn, Bo = Di;
Bo.PExpr.prototype.introduceParams = z7e.abstract("introduceParams");
Bo.any.introduceParams = Bo.end.introduceParams = Bo.Terminal.prototype.introduceParams = Bo.Range.prototype.introduceParams = Bo.Param.prototype.introduceParams = Bo.UnicodeChar.prototype.introduceParams = function(e) {
  return this;
};
Bo.Alt.prototype.introduceParams = function(e) {
  return this.terms.forEach((t, i, n) => {
    n[i] = t.introduceParams(e);
  }), this;
};
Bo.Seq.prototype.introduceParams = function(e) {
  return this.factors.forEach((t, i, n) => {
    n[i] = t.introduceParams(e);
  }), this;
};
Bo.Iter.prototype.introduceParams = Bo.Not.prototype.introduceParams = Bo.Lookahead.prototype.introduceParams = Bo.Lex.prototype.introduceParams = function(e) {
  return this.expr = this.expr.introduceParams(e), this;
};
Bo.Apply.prototype.introduceParams = function(e) {
  const t = e.indexOf(this.ruleName);
  if (t >= 0) {
    if (this.args.length > 0)
      throw new Error("Parameterized rules cannot be passed as arguments to another rule.");
    return new Bo.Param(t).withSource(this.source);
  } else
    return this.args.forEach((i, n, g) => {
      g[n] = i.introduceParams(e);
    }), this;
};
const O7e = kn, Kr = Di;
Kr.PExpr.prototype.isNullable = function(e) {
  return this._isNullable(e, /* @__PURE__ */ Object.create(null));
};
Kr.PExpr.prototype._isNullable = O7e.abstract("_isNullable");
Kr.any._isNullable = Kr.Range.prototype._isNullable = Kr.Param.prototype._isNullable = Kr.Plus.prototype._isNullable = Kr.UnicodeChar.prototype._isNullable = function(e, t) {
  return !1;
};
Kr.end._isNullable = function(e, t) {
  return !0;
};
Kr.Terminal.prototype._isNullable = function(e, t) {
  return typeof this.obj == "string" ? this.obj === "" : !1;
};
Kr.Alt.prototype._isNullable = function(e, t) {
  return this.terms.length === 0 || this.terms.some((i) => i._isNullable(e, t));
};
Kr.Seq.prototype._isNullable = function(e, t) {
  return this.factors.every((i) => i._isNullable(e, t));
};
Kr.Star.prototype._isNullable = Kr.Opt.prototype._isNullable = Kr.Not.prototype._isNullable = Kr.Lookahead.prototype._isNullable = function(e, t) {
  return !0;
};
Kr.Lex.prototype._isNullable = function(e, t) {
  return this.expr._isNullable(e, t);
};
Kr.Apply.prototype._isNullable = function(e, t) {
  const i = this.toMemoKey();
  if (!Object.prototype.hasOwnProperty.call(t, i)) {
    const { body: n } = e.rules[this.ruleName], g = n.substituteParams(this.args);
    t[i] = !1, t[i] = g._isNullable(e, t);
  }
  return t[i];
};
const Q7e = kn, Er = Di;
Er.PExpr.prototype.substituteParams = Q7e.abstract("substituteParams");
Er.any.substituteParams = Er.end.substituteParams = Er.Terminal.prototype.substituteParams = Er.Range.prototype.substituteParams = Er.UnicodeChar.prototype.substituteParams = function(e) {
  return this;
};
Er.Param.prototype.substituteParams = function(e) {
  return e[this.index];
};
Er.Alt.prototype.substituteParams = function(e) {
  return new Er.Alt(this.terms.map((t) => t.substituteParams(e)));
};
Er.Seq.prototype.substituteParams = function(e) {
  return new Er.Seq(this.factors.map((t) => t.substituteParams(e)));
};
Er.Iter.prototype.substituteParams = Er.Not.prototype.substituteParams = Er.Lookahead.prototype.substituteParams = Er.Lex.prototype.substituteParams = function(e) {
  return new this.constructor(this.expr.substituteParams(e));
};
Er.Apply.prototype.substituteParams = function(e) {
  if (this.args.length === 0)
    return this;
  {
    const t = this.args.map((i) => i.substituteParams(e));
    return new Er.Apply(this.ruleName, t);
  }
};
const qj = kn, Wo = Di, { copyWithoutDuplicates: j7e } = qj;
function m3(e) {
  return /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
}
function eJ(e) {
  const t = /* @__PURE__ */ Object.create(null);
  e.forEach((i) => {
    t[i] = (t[i] || 0) + 1;
  }), Object.keys(t).forEach((i) => {
    if (t[i] <= 1)
      return;
    let n = 1;
    e.forEach((g, r) => {
      g === i && (e[r] = g + "_" + n++);
    });
  });
}
Wo.PExpr.prototype.toArgumentNameList = qj.abstract("toArgumentNameList");
Wo.any.toArgumentNameList = function(e, t) {
  return ["any"];
};
Wo.end.toArgumentNameList = function(e, t) {
  return ["end"];
};
Wo.Terminal.prototype.toArgumentNameList = function(e, t) {
  return typeof this.obj == "string" && /^[_a-zA-Z0-9]+$/.test(this.obj) ? ["_" + this.obj] : ["$" + e];
};
Wo.Range.prototype.toArgumentNameList = function(e, t) {
  let i = this.from + "_to_" + this.to;
  return m3(i) || (i = "_" + i), m3(i) || (i = "$" + e), [i];
};
Wo.Alt.prototype.toArgumentNameList = function(e, t) {
  const i = this.terms.map(
    (r) => r.toArgumentNameList(e, !0)
  ), n = [], g = i[0].length;
  for (let r = 0; r < g; r++) {
    const o = [];
    for (let s = 0; s < this.terms.length; s++)
      o.push(i[s][r]);
    const I = j7e(o);
    n.push(I.join("_or_"));
  }
  return t || eJ(n), n;
};
Wo.Seq.prototype.toArgumentNameList = function(e, t) {
  let i = [];
  return this.factors.forEach((n) => {
    const g = n.toArgumentNameList(e, !0);
    i = i.concat(g), e += g.length;
  }), t || eJ(i), i;
};
Wo.Iter.prototype.toArgumentNameList = function(e, t) {
  const i = this.expr.toArgumentNameList(e, t).map(
    (n) => n[n.length - 1] === "s" ? n + "es" : n + "s"
  );
  return t || eJ(i), i;
};
Wo.Opt.prototype.toArgumentNameList = function(e, t) {
  return this.expr.toArgumentNameList(e, t).map((i) => "opt" + i[0].toUpperCase() + i.slice(1));
};
Wo.Not.prototype.toArgumentNameList = function(e, t) {
  return [];
};
Wo.Lookahead.prototype.toArgumentNameList = Wo.Lex.prototype.toArgumentNameList = function(e, t) {
  return this.expr.toArgumentNameList(e, t);
};
Wo.Apply.prototype.toArgumentNameList = function(e, t) {
  return [this.ruleName];
};
Wo.UnicodeChar.prototype.toArgumentNameList = function(e, t) {
  return ["$" + e];
};
Wo.Param.prototype.toArgumentNameList = function(e, t) {
  return ["param" + this.index];
};
const _7e = kn, No = Di;
No.PExpr.prototype.toDisplayString = _7e.abstract("toDisplayString");
No.Alt.prototype.toDisplayString = No.Seq.prototype.toDisplayString = function() {
  return this.source ? this.source.trimmed().contents : "[" + this.constructor.name + "]";
};
No.any.toDisplayString = No.end.toDisplayString = No.Iter.prototype.toDisplayString = No.Not.prototype.toDisplayString = No.Lookahead.prototype.toDisplayString = No.Lex.prototype.toDisplayString = No.Terminal.prototype.toDisplayString = No.Range.prototype.toDisplayString = No.Param.prototype.toDisplayString = function() {
  return this.toString();
};
No.Apply.prototype.toDisplayString = function() {
  if (this.args.length > 0) {
    const e = this.args.map((t) => t.toDisplayString());
    return this.ruleName + "<" + e.join(",") + ">";
  } else
    return this.ruleName;
};
No.UnicodeChar.prototype.toDisplayString = function() {
  return "Unicode [" + this.category + "] character";
};
const Ga = zj, $7e = kn, xI = Di;
xI.PExpr.prototype.toFailure = $7e.abstract("toFailure");
xI.any.toFailure = function(e) {
  return new Ga(this, "any object", "description");
};
xI.end.toFailure = function(e) {
  return new Ga(this, "end of input", "description");
};
xI.Terminal.prototype.toFailure = function(e) {
  return new Ga(this, this.obj, "string");
};
xI.Range.prototype.toFailure = function(e) {
  return new Ga(this, JSON.stringify(this.from) + ".." + JSON.stringify(this.to), "code");
};
xI.Not.prototype.toFailure = function(e) {
  const t = this.expr === xI.any ? "nothing" : "not " + this.expr.toFailure(e);
  return new Ga(this, t, "description");
};
xI.Lookahead.prototype.toFailure = function(e) {
  return this.expr.toFailure(e);
};
xI.Apply.prototype.toFailure = function(e) {
  let { description: t } = e.rules[this.ruleName];
  return t || (t = (/^[aeiouAEIOU]/.test(this.ruleName) ? "an" : "a") + " " + this.ruleName), new Ga(this, t, "description");
};
xI.UnicodeChar.prototype.toFailure = function(e) {
  return new Ga(this, "a Unicode [" + this.category + "] character", "description");
};
xI.Alt.prototype.toFailure = function(e) {
  const i = "(" + this.terms.map((n) => n.toFailure(e)).join(" or ") + ")";
  return new Ga(this, i, "description");
};
xI.Seq.prototype.toFailure = function(e) {
  const i = "(" + this.factors.map((n) => n.toFailure(e)).join(" ") + ")";
  return new Ga(this, i, "description");
};
xI.Iter.prototype.toFailure = function(e) {
  const t = "(" + this.expr.toFailure(e) + this.operator + ")";
  return new Ga(this, t, "description");
};
const q7e = kn, iI = Di;
iI.PExpr.prototype.toString = q7e.abstract("toString");
iI.any.toString = function() {
  return "any";
};
iI.end.toString = function() {
  return "end";
};
iI.Terminal.prototype.toString = function() {
  return JSON.stringify(this.obj);
};
iI.Range.prototype.toString = function() {
  return JSON.stringify(this.from) + ".." + JSON.stringify(this.to);
};
iI.Param.prototype.toString = function() {
  return "$" + this.index;
};
iI.Lex.prototype.toString = function() {
  return "#(" + this.expr.toString() + ")";
};
iI.Alt.prototype.toString = function() {
  return this.terms.length === 1 ? this.terms[0].toString() : "(" + this.terms.map((e) => e.toString()).join(" | ") + ")";
};
iI.Seq.prototype.toString = function() {
  return this.factors.length === 1 ? this.factors[0].toString() : "(" + this.factors.map((e) => e.toString()).join(" ") + ")";
};
iI.Iter.prototype.toString = function() {
  return this.expr + this.operator;
};
iI.Not.prototype.toString = function() {
  return "~" + this.expr;
};
iI.Lookahead.prototype.toString = function() {
  return "&" + this.expr;
};
iI.Apply.prototype.toString = function() {
  if (this.args.length > 0) {
    const e = this.args.map((t) => t.toString());
    return this.ruleName + "<" + e.join(",") + ">";
  } else
    return this.ruleName;
};
iI.UnicodeChar.prototype.toString = function() {
  return "\\p{" + this.category + "}";
};
var qu = Di;
const e8e = zj, { TerminalNode: t8e } = QD, { assert: i8e } = kn, { PExpr: n8e, Terminal: g8e } = qu;
class tJ extends n8e {
  constructor(t) {
    super(), this.obj = t;
  }
  _getString(t) {
    const i = t.currentApplication().args[this.obj.index];
    return i8e(i instanceof g8e, "expected a Terminal expression"), i.obj;
  }
  // Implementation of the PExpr API
  allowsSkippingPrecedingSpace() {
    return !0;
  }
  eval(t) {
    const { inputStream: i } = t, n = i.pos, g = this._getString(t);
    return i.matchString(g, !0) ? (t.pushBinding(new t8e(g.length), n), !0) : (t.processFailure(n, this), !1);
  }
  getArity() {
    return 1;
  }
  substituteParams(t) {
    return new tJ(this.obj.substituteParams(t));
  }
  toDisplayString() {
    return this.obj.toDisplayString() + " (case-insensitive)";
  }
  toFailure(t) {
    return new e8e(
      this,
      this.obj.toFailure(t) + " (case-insensitive)",
      "description"
    );
  }
  _isNullable(t, i) {
    return this.obj._isNullable(t, i);
  }
}
var r8e = tJ;
const o8e = _D;
function e6(e) {
  this.source = e, this.pos = 0, this.examinedLength = 0;
}
e6.prototype = {
  atEnd() {
    const e = this.pos === this.source.length;
    return this.examinedLength = Math.max(this.examinedLength, this.pos + 1), e;
  },
  next() {
    const e = this.source[this.pos++];
    return this.examinedLength = Math.max(this.examinedLength, this.pos), e;
  },
  nextCharCode() {
    const e = this.next();
    return e && e.charCodeAt(0);
  },
  nextCodePoint() {
    const e = this.source.slice(this.pos++).codePointAt(0);
    return e > 65535 && (this.pos += 1), this.examinedLength = Math.max(this.examinedLength, this.pos), e;
  },
  matchString(e, t) {
    let i;
    if (t) {
      for (i = 0; i < e.length; i++) {
        const n = this.next(), g = e[i];
        if (n == null || n.toUpperCase() !== g.toUpperCase())
          return !1;
      }
      return !0;
    }
    for (i = 0; i < e.length; i++)
      if (this.next() !== e[i])
        return !1;
    return !0;
  },
  sourceSlice(e, t) {
    return this.source.slice(e, t);
  },
  interval(e, t) {
    return new o8e(this.source, e, t || this.pos);
  }
};
var iJ = e6;
const JY = kn, h3 = qd, I8e = _D;
function eC(e, t, i, n, g, r, o) {
  this.matcher = e, this.input = t, this.startExpr = i, this._cst = n, this._cstOffset = g, this._rightmostFailurePosition = r, this._rightmostFailures = o, this.failed() && (JY.defineLazyProperty(this, "message", function() {
    const I = "Expected " + this.getExpectedText();
    return h3.getLineAndColumnMessage(this.input, this.getRightmostFailurePosition()) + I;
  }), JY.defineLazyProperty(this, "shortMessage", function() {
    const I = "expected " + this.getExpectedText(), s = h3.getLineAndColumn(this.input, this.getRightmostFailurePosition());
    return "Line " + s.lineNum + ", col " + s.colNum + ": " + I;
  }));
}
eC.prototype.succeeded = function() {
  return !!this._cst;
};
eC.prototype.failed = function() {
  return !this.succeeded();
};
eC.prototype.getRightmostFailurePosition = function() {
  return this._rightmostFailurePosition;
};
eC.prototype.getRightmostFailures = function() {
  if (!this._rightmostFailures) {
    this.matcher.setInput(this.input);
    const e = this.matcher._match(
      this.startExpr,
      !1,
      this.getRightmostFailurePosition()
    );
    this._rightmostFailures = e.getRightmostFailures();
  }
  return this._rightmostFailures;
};
eC.prototype.toString = function() {
  return this.succeeded() ? "[match succeeded]" : "[match failed at position " + this.getRightmostFailurePosition() + "]";
};
eC.prototype.getExpectedText = function() {
  if (this.succeeded())
    throw new Error("cannot get expected text of a successful MatchResult");
  const e = new JY.StringBuffer();
  let t = this.getRightmostFailures();
  t = t.filter((i) => !i.isFluffy());
  for (let i = 0; i < t.length; i++)
    i > 0 && (i === t.length - 1 ? e.append(t.length > 2 ? ", or " : " or ") : e.append(", ")), e.append(t[i].toString());
  return e.contents();
};
eC.prototype.getInterval = function() {
  const e = this.getRightmostFailurePosition();
  return new I8e(this.input, e, e);
};
var t6 = eC;
function i6() {
  this.applicationMemoKeyStack = [], this.memo = {}, this.maxExaminedLength = 0, this.maxRightmostFailureOffset = -1, this.currentLeftRecursion = void 0;
}
i6.prototype = {
  isActive(e) {
    return this.applicationMemoKeyStack.indexOf(e.toMemoKey()) >= 0;
  },
  enter(e) {
    this.applicationMemoKeyStack.push(e.toMemoKey());
  },
  exit() {
    this.applicationMemoKeyStack.pop();
  },
  startLeftRecursion(e, t) {
    t.isLeftRecursion = !0, t.headApplication = e, t.nextLeftRecursion = this.currentLeftRecursion, this.currentLeftRecursion = t;
    const { applicationMemoKeyStack: i } = this, n = i.indexOf(e.toMemoKey()) + 1, g = i.slice(
      n
    );
    t.isInvolved = function(r) {
      return g.indexOf(r) >= 0;
    }, t.updateInvolvedApplicationMemoKeys = function() {
      for (let r = n; r < i.length; r++) {
        const o = i[r];
        this.isInvolved(o) || g.push(o);
      }
    };
  },
  endLeftRecursion() {
    this.currentLeftRecursion = this.currentLeftRecursion.nextLeftRecursion;
  },
  // Note: this method doesn't get called for the "head" of a left recursion -- for LR heads,
  // the memoized result (which starts out being a failure) is always used.
  shouldUseMemoizedResult(e) {
    if (!e.isLeftRecursion)
      return !0;
    const { applicationMemoKeyStack: t } = this;
    for (let i = 0; i < t.length; i++) {
      const n = t[i];
      if (e.isInvolved(n))
        return !1;
    }
    return !0;
  },
  memoize(e, t) {
    return this.memo[e] = t, this.maxExaminedLength = Math.max(this.maxExaminedLength, t.examinedLength), this.maxRightmostFailureOffset = Math.max(
      this.maxRightmostFailureOffset,
      t.rightmostFailureOffset
    ), t;
  },
  clearObsoleteEntries(e, t) {
    if (e + this.maxExaminedLength <= t)
      return;
    const { memo: i } = this;
    this.maxExaminedLength = 0, this.maxRightmostFailureOffset = -1, Object.keys(i).forEach((n) => {
      const g = i[n];
      e + g.examinedLength > t ? delete i[n] : (this.maxExaminedLength = Math.max(this.maxExaminedLength, g.examinedLength), this.maxRightmostFailureOffset = Math.max(
        this.maxRightmostFailureOffset,
        g.rightmostFailureOffset
      ));
    });
  }
};
var l8e = i6;
const s8e = iJ, a8e = t6, c8e = l8e, d8e = _j, KY = qu, C8e = qd;
let n6;
C8e.awaitBuiltInRules((e) => {
  n6 = e.rules.applySyntactic.body;
});
const Wk = new KY.Apply("spaces");
function g6(e, t, i) {
  this.matcher = e, this.startExpr = t, this.grammar = e.grammar, this.input = e.input, this.inputStream = new s8e(e.input), this.memoTable = e.memoTable, this._bindings = [], this._bindingOffsets = [], this._applicationStack = [], this._posStack = [0], this.inLexifiedContextStack = [!1], this.rightmostFailurePosition = -1, this._rightmostFailurePositionStack = [], this._recordedFailuresStack = [], i !== void 0 && (this.positionToRecordFailures = i, this.recordedFailures = /* @__PURE__ */ Object.create(null));
}
g6.prototype = {
  posToOffset(e) {
    return e - this._posStack[this._posStack.length - 1];
  },
  enterApplication(e, t) {
    this._posStack.push(this.inputStream.pos), this._applicationStack.push(t), this.inLexifiedContextStack.push(!1), e.enter(t), this._rightmostFailurePositionStack.push(this.rightmostFailurePosition), this.rightmostFailurePosition = -1;
  },
  exitApplication(e, t) {
    const i = this._posStack.pop();
    this._applicationStack.pop(), this.inLexifiedContextStack.pop(), e.exit(), this.rightmostFailurePosition = Math.max(
      this.rightmostFailurePosition,
      this._rightmostFailurePositionStack.pop()
    ), t && this.pushBinding(t, i);
  },
  enterLexifiedContext() {
    this.inLexifiedContextStack.push(!0);
  },
  exitLexifiedContext() {
    this.inLexifiedContextStack.pop();
  },
  currentApplication() {
    return this._applicationStack[this._applicationStack.length - 1];
  },
  inSyntacticContext() {
    const e = this.currentApplication();
    return e ? e.isSyntactic() && !this.inLexifiedContext() : this.startExpr.factors[0].isSyntactic();
  },
  inLexifiedContext() {
    return this.inLexifiedContextStack[this.inLexifiedContextStack.length - 1];
  },
  skipSpaces() {
    return this.pushFailuresInfo(), this.eval(Wk), this.popBinding(), this.popFailuresInfo(), this.inputStream.pos;
  },
  skipSpacesIfInSyntacticContext() {
    return this.inSyntacticContext() ? this.skipSpaces() : this.inputStream.pos;
  },
  maybeSkipSpacesBefore(e) {
    return e.allowsSkippingPrecedingSpace() && e !== Wk ? this.skipSpacesIfInSyntacticContext() : this.inputStream.pos;
  },
  pushBinding(e, t) {
    this._bindings.push(e), this._bindingOffsets.push(this.posToOffset(t));
  },
  popBinding() {
    this._bindings.pop(), this._bindingOffsets.pop();
  },
  numBindings() {
    return this._bindings.length;
  },
  truncateBindings(e) {
    for (; this._bindings.length > e; )
      this.popBinding();
  },
  getCurrentPosInfo() {
    return this.getPosInfo(this.inputStream.pos);
  },
  getPosInfo(e) {
    let t = this.memoTable[e];
    return t || (t = this.memoTable[e] = new c8e()), t;
  },
  processFailure(e, t) {
    if (this.rightmostFailurePosition = Math.max(this.rightmostFailurePosition, e), this.recordedFailures && e === this.positionToRecordFailures) {
      const i = this.currentApplication();
      i && (t = t.substituteParams(i.args)), this.recordFailure(t.toFailure(this.grammar), !1);
    }
  },
  recordFailure(e, t) {
    const i = e.toKey();
    this.recordedFailures[i] ? this.recordedFailures[i].isFluffy() && !e.isFluffy() && this.recordedFailures[i].clearFluffy() : this.recordedFailures[i] = t ? e.clone() : e;
  },
  recordFailures(e, t) {
    Object.keys(e).forEach((i) => {
      this.recordFailure(e[i], t);
    });
  },
  cloneRecordedFailures() {
    if (!this.recordedFailures)
      return;
    const e = /* @__PURE__ */ Object.create(null);
    return Object.keys(this.recordedFailures).forEach((t) => {
      e[t] = this.recordedFailures[t].clone();
    }), e;
  },
  getRightmostFailurePosition() {
    return this.rightmostFailurePosition;
  },
  _getRightmostFailureOffset() {
    return this.rightmostFailurePosition >= 0 ? this.posToOffset(this.rightmostFailurePosition) : -1;
  },
  // Returns the memoized trace entry for `expr` at `pos`, if one exists, `null` otherwise.
  getMemoizedTraceEntry(e, t) {
    const i = this.memoTable[e];
    if (i && t instanceof KY.Apply) {
      const n = i.memo[t.toMemoKey()];
      if (n && n.traceEntry) {
        const g = n.traceEntry.cloneWithExpr(t);
        return g.isMemoized = !0, g;
      }
    }
    return null;
  },
  // Returns a new trace entry, with the currently active trace array as its children.
  getTraceEntry(e, t, i, n) {
    if (t instanceof KY.Apply) {
      const g = this.currentApplication(), r = g ? g.args : [];
      t = t.substituteParams(r);
    }
    return this.getMemoizedTraceEntry(e, t) || new d8e(this.input, e, this.inputStream.pos, t, i, n, this.trace);
  },
  isTracing() {
    return !!this.trace;
  },
  hasNecessaryInfo(e) {
    return this.trace && !e.traceEntry ? !1 : this.recordedFailures && this.inputStream.pos + e.rightmostFailureOffset === this.positionToRecordFailures ? !!e.failuresAtRightmostPosition : !0;
  },
  useMemoizedResult(e, t) {
    this.trace && this.trace.push(t.traceEntry);
    const i = this.inputStream.pos + t.rightmostFailureOffset;
    return this.rightmostFailurePosition = Math.max(
      this.rightmostFailurePosition,
      i
    ), this.recordedFailures && this.positionToRecordFailures === i && t.failuresAtRightmostPosition && this.recordFailures(t.failuresAtRightmostPosition, !0), this.inputStream.examinedLength = Math.max(
      this.inputStream.examinedLength,
      t.examinedLength + e
    ), t.value ? (this.inputStream.pos += t.matchLength, this.pushBinding(t.value, e), !0) : !1;
  },
  // Evaluate `expr` and return `true` if it succeeded, `false` otherwise. On success, `bindings`
  // will have `expr.getArity()` more elements than before, and the input stream's position may
  // have increased. On failure, `bindings` and position will be unchanged.
  eval(e) {
    const { inputStream: t } = this, i = this._bindings.length;
    let n;
    this.recordedFailures && (n = this.recordedFailures, this.recordedFailures = /* @__PURE__ */ Object.create(null));
    const g = t.pos, r = this.maybeSkipSpacesBefore(e);
    let o;
    this.trace && (o = this.trace, this.trace = []);
    const I = e.eval(this);
    if (this.trace) {
      const s = this._bindings.slice(i), a = this.getTraceEntry(r, e, I, s);
      a.isImplicitSpaces = e === Wk, a.isRootNode = e === this.startExpr, o.push(a), this.trace = o;
    }
    return I ? this.recordedFailures && t.pos === this.positionToRecordFailures && Object.keys(this.recordedFailures).forEach((s) => {
      this.recordedFailures[s].makeFluffy();
    }) : (t.pos = g, this.truncateBindings(i)), this.recordedFailures && this.recordFailures(n, !1), e === n6 && this.skipSpaces(), I;
  },
  getMatchResult() {
    this.eval(this.startExpr);
    let e;
    this.recordedFailures && (e = Object.keys(this.recordedFailures).map(
      (i) => this.recordedFailures[i]
    ));
    const t = this._bindings[0];
    return t && (t.grammar = this.grammar), new a8e(
      this.matcher,
      this.input,
      this.startExpr,
      t,
      this._bindingOffsets[0],
      this.rightmostFailurePosition,
      e
    );
  },
  getTrace() {
    this.trace = [];
    const e = this.getMatchResult(), t = this.trace[this.trace.length - 1];
    return t.result = e, t;
  },
  pushFailuresInfo() {
    this._rightmostFailurePositionStack.push(this.rightmostFailurePosition), this._recordedFailuresStack.push(this.recordedFailures);
  },
  popFailuresInfo() {
    this.rightmostFailurePosition = this._rightmostFailurePositionStack.pop(), this.recordedFailures = this._recordedFailuresStack.pop();
  }
};
var u8e = g6;
const A8e = u8e, p3 = qu;
function tC(e) {
  this.grammar = e, this.memoTable = [], this.input = "";
}
tC.prototype.getInput = function() {
  return this.input;
};
tC.prototype.setInput = function(e) {
  return this.input !== e && this.replaceInputRange(0, this.input.length, e), this;
};
tC.prototype.replaceInputRange = function(e, t, i) {
  const n = this.input;
  if (e < 0 || e > n.length || t < 0 || t > n.length || e > t)
    throw new Error("Invalid indices: " + e + " and " + t);
  this.input = n.slice(0, e) + i + n.slice(t);
  const g = this.memoTable.slice(t);
  this.memoTable.length = e;
  for (let r = 0; r < i.length; r++)
    this.memoTable.push(void 0);
  g.forEach(function(r) {
    this.memoTable.push(r);
  }, this);
  for (let r = 0; r < e; r++) {
    const o = this.memoTable[r];
    o && o.clearObsoleteEntries(r, e);
  }
  return this;
};
tC.prototype.match = function(e) {
  return this._match(this._getStartExpr(e), !1);
};
tC.prototype.trace = function(e) {
  return this._match(this._getStartExpr(e), !0);
};
tC.prototype._match = function(e, t, i) {
  const n = new A8e(this, e, i);
  return t ? n.getTrace() : n.getMatchResult();
};
tC.prototype._getStartExpr = function(e) {
  const t = e || this.grammar.defaultStartRule;
  if (!t)
    throw new Error("Missing start rule argument -- the grammar has no default start rule.");
  const i = this.grammar.parseApplication(t);
  return new p3.Seq([i, p3.end]);
};
var b8e = tC;
const m8e = iJ, { IterationNode: h8e } = QD, p8e = t6, nJ = kn, B8e = Sc, r6 = qd, j0 = [], gJ = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
class o6 {
  constructor(t, i, n) {
    this._node = t, this.source = i, this._baseInterval = n, t.isNonterminal() && nJ.assert(i === n), this._childWrappers = [];
  }
  toString() {
    return "[semantics wrapper for " + this._node.grammar.name + "]";
  }
  _forgetMemoizedResultFor(t) {
    delete this._node[this._semantics.attributeKeys[t]], this.children.forEach((i) => {
      i._forgetMemoizedResultFor(t);
    });
  }
  // Returns the wrapper of the specified child node. Child wrappers are created lazily and
  // cached in the parent wrapper's `_childWrappers` instance variable.
  child(t) {
    if (!(0 <= t && t < this._node.numChildren()))
      return;
    let i = this._childWrappers[t];
    if (!i) {
      const n = this._node.childAt(t), g = this._node.childOffsets[t], r = this._baseInterval.subInterval(g, n.matchLength), o = n.isNonterminal() ? r : this._baseInterval;
      i = this._childWrappers[t] = this._semantics.wrap(n, r, o);
    }
    return i;
  }
  // Returns an array containing the wrappers of all of the children of the node associated
  // with this wrapper.
  _children() {
    for (let t = 0; t < this._node.numChildren(); t++)
      this.child(t);
    return this._childWrappers;
  }
  // Returns `true` if the CST node associated with this wrapper corresponds to an iteration
  // expression, i.e., a Kleene-*, Kleene-+, or an optional. Returns `false` otherwise.
  isIteration() {
    return this._node.isIteration();
  }
  // Returns `true` if the CST node associated with this wrapper is a terminal node, `false`
  // otherwise.
  isTerminal() {
    return this._node.isTerminal();
  }
  // Returns `true` if the CST node associated with this wrapper is a nonterminal node, `false`
  // otherwise.
  isNonterminal() {
    return this._node.isNonterminal();
  }
  // Returns `true` if the CST node associated with this wrapper is a nonterminal node
  // corresponding to a syntactic rule, `false` otherwise.
  isSyntactic() {
    return this.isNonterminal() && this._node.isSyntactic();
  }
  // Returns `true` if the CST node associated with this wrapper is a nonterminal node
  // corresponding to a lexical rule, `false` otherwise.
  isLexical() {
    return this.isNonterminal() && this._node.isLexical();
  }
  // Returns `true` if the CST node associated with this wrapper is an iterator node
  // having either one or no child (? operator), `false` otherwise.
  // Otherwise, throws an exception.
  isOptional() {
    return this._node.isOptional();
  }
  // Create a new _iter wrapper in the same semantics as this wrapper.
  iteration(t) {
    const i = t || [], n = i.map((o) => o._node), g = new h8e(n, [], -1, !1), r = this._semantics.wrap(g, null, null);
    return r._childWrappers = i, r;
  }
  // Returns an array containing the children of this CST node.
  get children() {
    return this._children();
  }
  // Returns the name of grammar rule that created this CST node.
  get ctorName() {
    return this._node.ctorName;
  }
  // TODO: Remove this eventually (deprecated in v0.12).
  get interval() {
    throw new Error("The `interval` property is deprecated -- use `source` instead");
  }
  // Returns the number of children of this CST node.
  get numChildren() {
    return this._node.numChildren();
  }
  // Returns the contents of the input stream consumed by this CST node.
  get sourceString() {
    return this.source.contents;
  }
}
function qr(e, t) {
  const i = this;
  if (this.grammar = e, this.checkedActionDicts = !1, this.Wrapper = class extends (t ? t.Wrapper : o6) {
    constructor(n, g, r) {
      super(n, g, r), i.checkActionDictsIfHaventAlready(), this._semantics = i;
    }
  }, this.super = t, t) {
    if (!(e.equals(this.super.grammar) || e._inheritsFrom(this.super.grammar)))
      throw new Error(
        "Cannot extend a semantics for grammar '" + this.super.grammar.name + "' for use with grammar '" + e.name + "' (not a sub-grammar)"
      );
    this.operations = Object.create(this.super.operations), this.attributes = Object.create(this.super.attributes), this.attributeKeys = /* @__PURE__ */ Object.create(null);
    for (const n in this.attributes)
      Object.defineProperty(this.attributeKeys, n, {
        value: r6.uniqueId(n)
      });
  } else
    this.operations = /* @__PURE__ */ Object.create(null), this.attributes = /* @__PURE__ */ Object.create(null), this.attributeKeys = /* @__PURE__ */ Object.create(null);
}
qr.prototype.toString = function() {
  return "[semantics for " + this.grammar.name + "]";
};
qr.prototype.checkActionDictsIfHaventAlready = function() {
  this.checkedActionDicts || (this.checkActionDicts(), this.checkedActionDicts = !0);
};
qr.prototype.checkActionDicts = function() {
  let e;
  for (e in this.operations)
    this.operations[e].checkActionDict(this.grammar);
  for (e in this.attributes)
    this.attributes[e].checkActionDict(this.grammar);
};
qr.prototype.toRecipe = function(e) {
  function t(n) {
    return n.super !== qr.BuiltInSemantics._getSemantics();
  }
  let i = `(function(g) {
`;
  if (t(this)) {
    i += "  var semantics = " + this.super.toRecipe(!0) + "(g";
    const n = this.super.grammar;
    let g = this.grammar;
    for (; g !== n; )
      i += ".superGrammar", g = g.superGrammar;
    i += `);
`, i += "  return g.extendSemantics(semantics)";
  } else
    i += "  return g.createSemantics()";
  return ["Operation", "Attribute"].forEach((n) => {
    const g = this[n.toLowerCase() + "s"];
    Object.keys(g).forEach((r) => {
      const { actionDict: o, formals: I, builtInDefault: s } = g[r];
      let a = r;
      I.length > 0 && (a += "(" + I.join(", ") + ")");
      let d;
      t(this) && this.super[n.toLowerCase() + "s"][r] ? d = "extend" + n : d = "add" + n, i += `
    .` + d + "(" + JSON.stringify(a) + ", {";
      const C = [];
      Object.keys(o).forEach((u) => {
        if (o[u] !== s) {
          let A = o[u].toString().trim();
          A = A.replace(/^.*\(/, "function("), C.push(`
      ` + JSON.stringify(u) + ": " + A);
        }
      }), i += C.join(",") + `
    })`;
    });
  }), i += `;
  })`, e || (i = `(function() {
  var grammar = this.fromRecipe(` + this.grammar.toRecipe() + `);
  var semantics = ` + i + `(grammar);
  return semantics;
});
`), i;
};
function I6(e, t) {
  if (!qr.prototypeGrammar)
    return nJ.assert(e.indexOf("(") === -1), {
      name: e,
      formals: []
    };
  const i = qr.prototypeGrammar.match(
    e,
    t === "operation" ? "OperationSignature" : "AttributeSignature"
  );
  if (i.failed())
    throw new Error(i.message);
  return qr.prototypeGrammarSemantics(i).parse();
}
function Z8e(e, t, i) {
  return function(...n) {
    const r = (this._semantics.operations[t] || this._semantics.attributes[t]).formals.map((o) => this.args[o]);
    if (!this.isIteration() && n.length === 1)
      return i.apply(n[0], r);
    throw B8e.missingSemanticAction(this.ctorName, t, e, j0);
  };
}
qr.prototype.addOperationOrAttribute = function(e, t, i) {
  const n = e + "s", g = I6(t, e), { name: r } = g, { formals: o } = g;
  this.assertNewName(r, e);
  const I = Z8e(e, r, d), s = { _default: I };
  Object.keys(i).forEach((C) => {
    s[C] = i[C];
  });
  const a = e === "operation" ? new eZ(r, o, s, I) : new rJ(r, s, I);
  a.checkActionDict(this.grammar), this[n][r] = a;
  function d(...C) {
    const u = this._semantics[n][r];
    if (arguments.length !== u.formals.length)
      throw new Error(
        "Invalid number of arguments passed to " + r + " " + e + " (expected " + u.formals.length + ", got " + arguments.length + ")"
      );
    const A = /* @__PURE__ */ Object.create(null);
    for (const [B, f] of Object.entries(C)) {
      const G = u.formals[B];
      A[G] = f;
    }
    const m = this.args;
    this.args = A;
    const h = u.execute(this._semantics, this);
    return this.args = m, h;
  }
  e === "operation" ? (this.Wrapper.prototype[r] = d, this.Wrapper.prototype[r].toString = function() {
    return "[" + r + " operation]";
  }) : (Object.defineProperty(this.Wrapper.prototype, r, {
    get: d,
    configurable: !0
    // So the property can be deleted.
  }), Object.defineProperty(this.attributeKeys, r, {
    value: r6.uniqueId(r)
  }));
};
qr.prototype.extendOperationOrAttribute = function(e, t, i) {
  const n = e + "s";
  if (I6(t, "attribute"), !(this.super && t in this.super[n]))
    throw new Error(
      "Cannot extend " + e + " '" + t + "': did not inherit an " + e + " with that name"
    );
  if (gJ(this[n], t))
    throw new Error("Cannot extend " + e + " '" + t + "' again");
  const g = this[n][t].formals, r = this[n][t].actionDict, o = Object.create(r);
  Object.keys(i).forEach((I) => {
    o[I] = i[I];
  }), this[n][t] = e === "operation" ? new eZ(t, g, o) : new rJ(t, o), this[n][t].checkActionDict(this.grammar);
};
qr.prototype.assertNewName = function(e, t) {
  if (gJ(o6.prototype, e))
    throw new Error("Cannot add " + t + " '" + e + "': that's a reserved name");
  if (e in this.operations)
    throw new Error(
      "Cannot add " + t + " '" + e + "': an operation with that name already exists"
    );
  if (e in this.attributes)
    throw new Error(
      "Cannot add " + t + " '" + e + "': an attribute with that name already exists"
    );
};
qr.prototype.wrap = function(e, t, i) {
  const n = i || t;
  return e instanceof this.Wrapper ? e : new this.Wrapper(e, t, n);
};
qr.createSemantics = function(e, t) {
  const i = new qr(
    e,
    t !== void 0 ? t : qr.BuiltInSemantics._getSemantics()
  ), n = function(r) {
    if (!(r instanceof p8e))
      throw new TypeError(
        "Semantics expected a MatchResult, but got " + nJ.unexpectedObjToString(r)
      );
    if (r.failed())
      throw new TypeError("cannot apply Semantics to " + r.toString());
    const o = r._cst;
    if (o.grammar !== e)
      throw new Error(
        "Cannot use a MatchResult from grammar '" + o.grammar.name + "' with a semantics for '" + e.name + "'"
      );
    const I = new m8e(r.input);
    return i.wrap(o, I.interval(r._cstOffset, r.input.length));
  };
  return n.addOperation = function(g, r) {
    return i.addOperationOrAttribute("operation", g, r), n;
  }, n.extendOperation = function(g, r) {
    return i.extendOperationOrAttribute("operation", g, r), n;
  }, n.addAttribute = function(g, r) {
    return i.addOperationOrAttribute("attribute", g, r), n;
  }, n.extendAttribute = function(g, r) {
    return i.extendOperationOrAttribute("attribute", g, r), n;
  }, n._getActionDict = function(g) {
    const r = i.operations[g] || i.attributes[g];
    if (!r)
      throw new Error(
        '"' + g + '" is not a valid operation or attribute name in this semantics for "' + e.name + '"'
      );
    return r.actionDict;
  }, n._remove = function(g) {
    let r;
    return g in i.operations ? (r = i.operations[g], delete i.operations[g]) : g in i.attributes && (r = i.attributes[g], delete i.attributes[g]), delete i.Wrapper.prototype[g], r;
  }, n.getOperationNames = function() {
    return Object.keys(i.operations);
  }, n.getAttributeNames = function() {
    return Object.keys(i.attributes);
  }, n.getGrammar = function() {
    return i.grammar;
  }, n.toRecipe = function(g) {
    return i.toRecipe(g);
  }, n.toString = i.toString.bind(i), n._getSemantics = function() {
    return i;
  }, n;
};
class eZ {
  constructor(t, i, n, g) {
    this.name = t, this.formals = i, this.actionDict = n, this.builtInDefault = g;
  }
  checkActionDict(t) {
    t._checkTopDownActionDict(this.typeName, this.name, this.actionDict);
  }
  // Execute this operation on the CST node associated with `nodeWrapper` in the context of the
  // given Semantics instance.
  execute(t, i) {
    try {
      const { ctorName: n } = i._node;
      let g = this.actionDict[n];
      return g ? (j0.push([this, n]), g.apply(i, i._children())) : i.isNonterminal() && (g = this.actionDict._nonterminal, g) ? (j0.push([this, "_nonterminal", n]), g.apply(i, i._children())) : (j0.push([this, "default action", n]), this.actionDict._default.apply(i, i._children()));
    } finally {
      j0.pop();
    }
  }
}
eZ.prototype.typeName = "operation";
class rJ extends eZ {
  constructor(t, i, n) {
    super(t, [], i, n);
  }
  execute(t, i) {
    const n = i._node, g = t.attributeKeys[this.name];
    return gJ(n, g) || (n[g] = eZ.prototype.execute.call(this, t, i)), n[g];
  }
}
rJ.prototype.typeName = "attribute";
var l6 = qr;
const f8e = r8e, G8e = b8e, B3 = l6, Z3 = kn, f3 = Sc, ns = qu, G3 = ["_iter", "_terminal", "_nonterminal", "_default"];
function y3(e) {
  return Object.keys(e.rules).sort().map((t) => e.rules[t]);
}
const y8e = (e) => e.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
function Ru(e, t, i, n) {
  if (this.name = e, this.superGrammar = t, this.rules = i, n) {
    if (!(n in i))
      throw new Error(
        "Invalid start rule: '" + n + "' is not a rule in grammar '" + e + "'"
      );
    this.defaultStartRule = n;
  }
}
let s6, a6;
Ru.initApplicationParser = function(e, t) {
  s6 = e, a6 = t;
};
Ru.prototype = {
  matcher() {
    return new G8e(this);
  },
  // Return true if the grammar is a built-in grammar, otherwise false.
  // NOTE: This might give an unexpected result if called before BuiltInRules is defined!
  isBuiltIn() {
    return this === Ru.ProtoBuiltInRules || this === Ru.BuiltInRules;
  },
  equals(e) {
    if (this === e)
      return !0;
    if (e == null || this.name !== e.name || this.defaultStartRule !== e.defaultStartRule || !(this.superGrammar === e.superGrammar || this.superGrammar.equals(e.superGrammar)))
      return !1;
    const t = y3(this), i = y3(e);
    return t.length === i.length && t.every((n, g) => n.description === i[g].description && n.formals.join(",") === i[g].formals.join(",") && n.body.toString() === i[g].body.toString());
  },
  match(e, t) {
    const i = this.matcher();
    return i.replaceInputRange(0, 0, e), i.match(t);
  },
  trace(e, t) {
    const i = this.matcher();
    return i.replaceInputRange(0, 0, e), i.trace(t);
  },
  createSemantics() {
    return B3.createSemantics(this);
  },
  extendSemantics(e) {
    return B3.createSemantics(this, e._getSemantics());
  },
  // Check that every key in `actionDict` corresponds to a semantic action, and that it maps to
  // a function of the correct arity. If not, throw an exception.
  _checkTopDownActionDict(e, t, i) {
    const n = [];
    for (const g in i) {
      const r = i[g];
      if (!G3.includes(g) && !(g in this.rules)) {
        n.push(`'${g}' is not a valid semantic action for '${this.name}'`);
        continue;
      }
      if (typeof r != "function") {
        n.push(`'${g}' must be a function in an action dictionary for '${this.name}'`);
        continue;
      }
      const I = r.length, s = this._topDownActionArity(g);
      if (I !== s) {
        let a;
        g === "_iter" || g === "_nonterminal" ? a = `it should use a rest parameter, e.g. \`${g}(...children) {}\`. NOTE: this is new in Ohm v16 — see https://ohmjs.org/d/ati for details.` : a = `expected ${s}, got ${I}`, n.push(`Semantic action '${g}' has the wrong arity: ${a}`);
      }
    }
    if (n.length > 0) {
      const g = n.map((o) => "- " + o), r = new Error(
        [
          `Found errors in the action dictionary of the '${t}' ${e}:`,
          ...g
        ].join(`
`)
      );
      throw r.problems = n, r;
    }
  },
  // Return the expected arity for a semantic action named `actionName`, which
  // is either a rule name or a special action name like '_nonterminal'.
  _topDownActionArity(e) {
    return G3.includes(e) ? 0 : this.rules[e].body.getArity();
  },
  _inheritsFrom(e) {
    let t = this.superGrammar;
    for (; t; ) {
      if (t.equals(e, !0))
        return !0;
      t = t.superGrammar;
    }
    return !1;
  },
  toRecipe(e = void 0) {
    const t = {};
    this.source && (t.source = this.source.contents);
    let i = null;
    this.defaultStartRule && (i = this.defaultStartRule);
    const n = {};
    Object.keys(this.rules).forEach((o) => {
      const I = this.rules[o], { body: s } = I, a = !this.superGrammar || !this.superGrammar.rules[o];
      let d;
      a ? d = "define" : d = s instanceof ns.Extend ? "extend" : "override";
      const C = {};
      if (I.source && this.source) {
        const m = I.source.relativeTo(this.source);
        C.sourceInterval = [m.startIdx, m.endIdx];
      }
      const u = a ? I.description : null, A = s.outputRecipe(I.formals, this.source);
      n[o] = [
        d,
        // "define"/"extend"/"override"
        C,
        u,
        I.formals,
        A
      ];
    });
    let g = "null";
    e ? g = e : this.superGrammar && !this.superGrammar.isBuiltIn() && (g = this.superGrammar.toRecipe());
    const r = [
      ...["grammar", t, this.name].map(JSON.stringify),
      g,
      ...[i, n].map(JSON.stringify)
    ];
    return y8e(`[${r.join(",")}]`);
  },
  // TODO: Come up with better names for these methods.
  // TODO: Write the analog of these methods for inherited attributes.
  toOperationActionDictionaryTemplate() {
    return this._toOperationOrAttributeActionDictionaryTemplate();
  },
  toAttributeActionDictionaryTemplate() {
    return this._toOperationOrAttributeActionDictionaryTemplate();
  },
  _toOperationOrAttributeActionDictionaryTemplate() {
    const e = new Z3.StringBuffer();
    e.append("{");
    let t = !0;
    for (const i in this.rules) {
      const { body: n } = this.rules[i];
      t ? t = !1 : e.append(","), e.append(`
`), e.append("  "), this.addSemanticActionTemplate(i, n, e);
    }
    return e.append(`
}`), e.contents();
  },
  addSemanticActionTemplate(e, t, i) {
    i.append(e), i.append(": function(");
    const n = this._topDownActionArity(e);
    i.append(Z3.repeat("_", n).join(", ")), i.append(`) {
`), i.append("  }");
  },
  // Parse a string which expresses a rule application in this grammar, and return the
  // resulting Apply node.
  parseApplication(e) {
    let t;
    if (e.indexOf("<") === -1)
      t = new ns.Apply(e);
    else {
      const n = s6.match(e, "Base_application");
      t = a6(n, {});
    }
    if (!(t.ruleName in this.rules))
      throw f3.undeclaredRule(t.ruleName, this.name);
    const { formals: i } = this.rules[t.ruleName];
    if (i.length !== t.args.length) {
      const { source: n } = this.rules[t.ruleName];
      throw f3.wrongNumberOfParameters(
        t.ruleName,
        i.length,
        t.args.length,
        n
      );
    }
    return t;
  }
};
Ru.ProtoBuiltInRules = new Ru(
  "ProtoBuiltInRules",
  // name
  void 0,
  // supergrammar
  {
    any: {
      body: ns.any,
      formals: [],
      description: "any character",
      primitive: !0
    },
    end: {
      body: ns.end,
      formals: [],
      description: "end of input",
      primitive: !0
    },
    caseInsensitive: {
      body: new f8e(new ns.Param(0)),
      formals: ["str"],
      primitive: !0
    },
    lower: {
      body: new ns.UnicodeChar("Ll"),
      formals: [],
      description: "a lowercase letter",
      primitive: !0
    },
    upper: {
      body: new ns.UnicodeChar("Lu"),
      formals: [],
      description: "an uppercase letter",
      primitive: !0
    },
    // Union of Lt (titlecase), Lm (modifier), and Lo (other), i.e. any letter not in Ll or Lu.
    unicodeLtmo: {
      body: new ns.UnicodeChar("Ltmo"),
      formals: [],
      description: "a Unicode character in Lt, Lm, or Lo",
      primitive: !0
    },
    // These rules are not truly primitive (they could be written in userland) but are defined
    // here for bootstrapping purposes.
    spaces: {
      body: new ns.Star(new ns.Apply("space")),
      formals: []
    },
    space: {
      body: new ns.Range("\0", " "),
      formals: [],
      description: "a space"
    }
  }
);
var F1 = Ru;
const EY = F1, W8e = iJ, c6 = kn, wd = Sc, S8e = qu;
function KI(e) {
  this.name = e;
}
KI.prototype.sourceInterval = function(e, t) {
  return this.source.subInterval(e, t - e);
};
KI.prototype.ensureSuperGrammar = function() {
  return this.superGrammar || this.withSuperGrammar(
    // TODO: The conditional expression below is an ugly hack. It's kind of ok because
    // I doubt anyone will ever try to declare a grammar called `BuiltInRules`. Still,
    // we should try to find a better way to do this.
    this.name === "BuiltInRules" ? EY.ProtoBuiltInRules : EY.BuiltInRules
  ), this.superGrammar;
};
KI.prototype.ensureSuperGrammarRuleForOverriding = function(e, t) {
  const i = this.ensureSuperGrammar().rules[e];
  if (!i)
    throw wd.cannotOverrideUndeclaredRule(e, this.superGrammar.name, t);
  return i;
};
KI.prototype.installOverriddenOrExtendedRule = function(e, t, i, n) {
  const g = c6.getDuplicates(t);
  if (g.length > 0)
    throw wd.duplicateParameterNames(e, g, n);
  const r = this.ensureSuperGrammar().rules[e], o = r.formals, I = o ? o.length : 0;
  if (t.length !== I)
    throw wd.wrongNumberOfParameters(e, I, t.length, n);
  return this.install(e, t, i, r.description, n);
};
KI.prototype.install = function(e, t, i, n, g) {
  return this.rules[e] = {
    body: i.introduceParams(t),
    formals: t,
    description: n,
    source: g
  }, this;
};
KI.prototype.withSuperGrammar = function(e) {
  if (this.superGrammar)
    throw new Error("the super grammar of a GrammarDecl cannot be set more than once");
  return this.superGrammar = e, this.rules = Object.create(e.rules), e.isBuiltIn() || (this.defaultStartRule = e.defaultStartRule), this;
};
KI.prototype.withDefaultStartRule = function(e) {
  return this.defaultStartRule = e, this;
};
KI.prototype.withSource = function(e) {
  return this.source = new W8e(e).interval(0, e.length), this;
};
KI.prototype.build = function() {
  const e = new EY(
    this.name,
    this.ensureSuperGrammar(),
    this.rules,
    this.defaultStartRule
  ), t = [];
  let i = !1;
  return Object.keys(e.rules).forEach((n) => {
    const { body: g } = e.rules[n];
    try {
      g.assertChoicesHaveUniformArity(n);
    } catch (r) {
      t.push(r);
    }
    try {
      g.assertAllApplicationsAreValid(n, e);
    } catch (r) {
      t.push(r), i = !0;
    }
  }), i || Object.keys(e.rules).forEach((n) => {
    const { body: g } = e.rules[n];
    try {
      g.assertIteratedExprsAreNotNullable(e, []);
    } catch (r) {
      t.push(r);
    }
  }), t.length > 0 && wd.throwErrors(t), this.source && (e.source = this.source), e;
};
KI.prototype.define = function(e, t, i, n, g) {
  if (this.ensureSuperGrammar(), this.superGrammar.rules[e])
    throw wd.duplicateRuleDeclaration(e, this.name, this.superGrammar.name, g);
  if (this.rules[e])
    throw wd.duplicateRuleDeclaration(e, this.name, this.name, g);
  const r = c6.getDuplicates(t);
  if (r.length > 0)
    throw wd.duplicateParameterNames(e, r, g);
  return this.install(e, t, i, n, g);
};
KI.prototype.override = function(e, t, i, n, g) {
  return this.ensureSuperGrammarRuleForOverriding(e, g), this.installOverriddenOrExtendedRule(e, t, i, g), this;
};
KI.prototype.extend = function(e, t, i, n, g) {
  if (!this.ensureSuperGrammar().rules[e])
    throw wd.cannotExtendUndeclaredRule(e, this.superGrammar.name, g);
  const o = new S8e.Extend(this.superGrammar, e, i);
  return o.source = i.source, this.installOverriddenOrExtendedRule(e, t, o, g), this;
};
var V8e = KI;
const w8e = F1, W3 = V8e, _n = qu;
function d6() {
}
d6.prototype = {
  currentDecl: null,
  currentRuleName: null,
  newGrammar(e) {
    return new W3(e);
  },
  grammar(e, t, i, n, g) {
    const r = new W3(t);
    return i && r.withSuperGrammar(
      i instanceof w8e ? i : this.fromRecipe(i)
    ), n && r.withDefaultStartRule(n), e && e.source && r.withSource(e.source), this.currentDecl = r, Object.keys(g).forEach((o) => {
      this.currentRuleName = o;
      const I = g[o], s = I[0], a = I[1], d = I[2], C = I[3], u = this.fromRecipe(I[4]);
      let A;
      r.source && a && a.sourceInterval && (A = r.source.subInterval(
        a.sourceInterval[0],
        a.sourceInterval[1] - a.sourceInterval[0]
      )), r[s](o, C, u, d, A);
    }), this.currentRuleName = this.currentDecl = null, r.build();
  },
  terminal(e) {
    return new _n.Terminal(e);
  },
  range(e, t) {
    return new _n.Range(e, t);
  },
  param(e) {
    return new _n.Param(e);
  },
  alt(...e) {
    let t = [];
    for (let i of e)
      i instanceof _n.PExpr || (i = this.fromRecipe(i)), i instanceof _n.Alt ? t = t.concat(i.terms) : t.push(i);
    return t.length === 1 ? t[0] : new _n.Alt(t);
  },
  seq(...e) {
    let t = [];
    for (let i of e)
      i instanceof _n.PExpr || (i = this.fromRecipe(i)), i instanceof _n.Seq ? t = t.concat(i.factors) : t.push(i);
    return t.length === 1 ? t[0] : new _n.Seq(t);
  },
  star(e) {
    return e instanceof _n.PExpr || (e = this.fromRecipe(e)), new _n.Star(e);
  },
  plus(e) {
    return e instanceof _n.PExpr || (e = this.fromRecipe(e)), new _n.Plus(e);
  },
  opt(e) {
    return e instanceof _n.PExpr || (e = this.fromRecipe(e)), new _n.Opt(e);
  },
  not(e) {
    return e instanceof _n.PExpr || (e = this.fromRecipe(e)), new _n.Not(e);
  },
  la(e) {
    return this.lookahead(e);
  },
  lookahead(e) {
    return e instanceof _n.PExpr || (e = this.fromRecipe(e)), new _n.Lookahead(e);
  },
  lex(e) {
    return e instanceof _n.PExpr || (e = this.fromRecipe(e)), new _n.Lex(e);
  },
  app(e, t) {
    return t && t.length > 0 && (t = t.map(function(i) {
      return i instanceof _n.PExpr ? i : this.fromRecipe(i);
    }, this)), new _n.Apply(e, t);
  },
  // Note that unlike other methods in this class, this method cannot be used as a
  // convenience constructor. It only works with recipes, because it relies on
  // `this.currentDecl` and `this.currentRuleName` being set.
  splice(e, t) {
    return new _n.Splice(
      this.currentDecl.superGrammar,
      this.currentRuleName,
      e.map((i) => this.fromRecipe(i)),
      t.map((i) => this.fromRecipe(i))
    );
  },
  fromRecipe(e) {
    const t = e[0] === "grammar" ? e.slice(1) : e.slice(2), i = this[e[0]](...t), n = e[1];
    return n && n.sourceInterval && this.currentDecl && i.withSource(this.currentDecl.sourceInterval(...n.sourceInterval)), i;
  }
};
var C6 = d6, v8e = "ohm-js", R8e = "16.6.0", X8e = "An object-oriented language for parsing and pattern matching", H8e = "https://github.com/harc/ohm", k8e = [
  "parser",
  "compiler",
  "pattern matching",
  "pattern-matching",
  "ometa",
  "ometa/js",
  "ometa-js",
  "ometajs",
  "rapid",
  "prototyping"
], F8e = "https://ohmjs.org", Y8e = "https://github.com/harc/ohm/issues", x8e = "index.js", D8e = "dist/ohm.esm.js", J8e = [
  "src",
  "dist",
  "extras",
  "third_party",
  "index.d.ts"
], K8e = "index.d.ts", E8e = {
  prebootstrap: "bash scripts/prebootstrap",
  bootstrap: "bash scripts/bootstrap --test || (echo 'Bootstrap failed.' && mv -v dist/ohm-grammar.js.old dist/ohm-grammar.js && mv -v dist/built-in-rules.js.old dist/built-in-rules.js && mv -v dist/operations-and-attributes.js.old dist/operations-and-attributes.js)",
  build: "yarn build-debug && webpack --mode=production",
  "build-debug": "webpack --mode=development && yarn build-esm && node scripts/generate-types.mjs",
  "build-esm": "rollup -c rollup.config.mjs",
  clean: "rm -f dist/ohm.js dist/ohm.min.js",
  lint: "eslint . --ignore-path ../.eslintignore",
  format: "prettier . --write --ignore-path ../.prettierignore --config ../.prettierrc && eslint . --ignore-path ../.eslintignore --fix",
  test: "ava && ava --config ava-ts.config.js test/test-typings.ts",
  "test-watch": "ava --watch",
  "pre-commit": "yarn run lint && yarn run build && yarn run test",
  prepublishOnly: "bash scripts/prepublishOnly",
  prepack: "cp ../../README.md . && yarn build",
  postpack: "rm README.md",
  postpublish: "echo '👉  Now go to https://github.com/harc/ohm/releases and create a release.'",
  "unsafe-bootstrap": "bash scripts/bootstrap",
  "update-contributors": "bash scripts/update-contributors",
  watch: "webpack --mode=development --watch"
}, N8e = "MIT", L8e = "Alex Warth <alexwarth@gmail.com> (http://tinlizzie.org/~awarth)", T8e = [
  "Patrick Dubroy <pdubroy@gmail.com>",
  "Meixian Li <lmeixian@gmail.com>",
  "Marko Röder <m.roeder@photon-software.de>",
  "Tony Garnock-Jones <tonygarnockjones@gmail.com>",
  "Saketh Kasibatla <sake.kasi@gmail.com>",
  "Lionel Landwerlin <llandwerlin@gmail.com>",
  "Jason Merrill <jwmerrill@gmail.com>",
  "Ray Toal <rtoal@lmu.edu>",
  "Yoshiki Ohshima <Yoshiki.Ohshima@acm.org>",
  "megabuz <3299889+megabuz@users.noreply.github.com>",
  "Jonathan Edwards <JonathanMEdwards@gmail.com>",
  "Milan Lajtoš <milan.lajtos@me.com>",
  "Neil Jewers <njjewers@uwaterloo.ca>",
  "stagas <gstagas@gmail.com>",
  "AngryPowman <angrypowman@qq.com>",
  "Arthur Carabott <arthurc@gmail.com>",
  "Casey Olson <casey.m.olson@gmail.com>",
  "Daniel Tomlinson <DanielTomlinson@me.com>",
  "Ian Harris <ian@fofgof.xyz>",
  "Justin Chase <justin.m.chase@gmail.com>",
  "Leslie Ying <acetophore@users.noreply.github.com>",
  "Luca Guzzon <luca.guzzon@gmail.com>",
  "Mike Niebling <(none)>",
  "Patrick Dubroy <patrick@sourcegraph.com>",
  "Pierre Donias <pierre.donias@gmail.com>",
  "Stan Rozenraukh <stan@stanistan.com>",
  "Stephan Seidt <stephan.seidt@gmail.com>",
  "Steve Phillips <steve@tryingtobeawesome.com>",
  "Szymon Kaliski <kaliskiszymon@gmail.com>",
  "Thomas Nyberg <tomnyberg@gmail.com>",
  "Vse Mozhet Byt <vsemozhetbyt@gmail.com>",
  "Wil Chung <10446+iamwilhelm@users.noreply.github.com>",
  "Zachary Sakowitz <zsakowitz@gmail.com>",
  "abego <ub@abego-software.de>",
  "acslk <d_vd415@hotmail.com>",
  "codeZeilen <codeZeilen@users.noreply.github.com>",
  "kassadin <kassadin@foxmail.com>",
  "owch <bowenrainyday@gmail.com>",
  "sfinnie <scott.finnie@gmail.com>"
], M8e = {}, U8e = {
  "@ohm-js/cli": "^1.0.0",
  "@rollup/plugin-commonjs": "^21.0.1",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-node-resolve": "^13.1.3",
  ava: "^3.15.0",
  "ava-spec": "^1.1.1",
  dedent: "^0.7.0",
  eslint: "^7.9.0",
  "eslint-config-google": "^0.14.0",
  "eslint-plugin-ava": "^11.0.0",
  "eslint-plugin-camelcase-ohm": "^0.2.1",
  "eslint-plugin-no-extension-in-require": "^0.2.0",
  husky: "^4.2.5",
  jsdom: "^9.9.1",
  json: "^9.0.6",
  markscript: "^0.5.0",
  "node-static": "^0.7.11",
  "ohm-grammar-ecmascript": "^1.0.0",
  rollup: "^2.63.0",
  "ts-loader": "^8.0.4",
  "ts-node": "^9.0.0",
  typescript: "^4.0.3",
  "walk-sync": "^2.2.0",
  webpack: "^4.44.2",
  "webpack-cli": "^3.3.12"
}, P8e = {
  node: ">=0.12.1"
}, z8e = {
  name: v8e,
  version: R8e,
  description: X8e,
  repository: H8e,
  keywords: k8e,
  homepage: F8e,
  bugs: Y8e,
  main: x8e,
  module: D8e,
  files: J8e,
  types: K8e,
  scripts: E8e,
  license: N8e,
  author: L8e,
  contributors: T8e,
  dependencies: M8e,
  devDependencies: U8e,
  engines: P8e
}, O8e = typeof __GLOBAL_OHM_VERSION__ == "string" ? __GLOBAL_OHM_VERSION__ : z8e.version, UZ = {};
const S3 = C6;
function Q8e(e) {
  return typeof e == "function" ? e.call(new S3()) : (typeof e == "string" && (e = JSON.parse(e)), new S3().fromRecipe(e));
}
UZ.makeRecipe = Q8e;
var { makeRecipe: j8e } = UZ, _8e = j8e(["grammar", { source: `BuiltInRules {

  alnum  (an alpha-numeric character)
    = letter
    | digit

  letter  (a letter)
    = lower
    | upper
    | unicodeLtmo

  digit  (a digit)
    = "0".."9"

  hexDigit  (a hexadecimal digit)
    = digit
    | "a".."f"
    | "A".."F"

  ListOf<elem, sep>
    = NonemptyListOf<elem, sep>
    | EmptyListOf<elem, sep>

  NonemptyListOf<elem, sep>
    = elem (sep elem)*

  EmptyListOf<elem, sep>
    = /* nothing */

  listOf<elem, sep>
    = nonemptyListOf<elem, sep>
    | emptyListOf<elem, sep>

  nonemptyListOf<elem, sep>
    = elem (sep elem)*

  emptyListOf<elem, sep>
    = /* nothing */

  // Allows a syntactic rule application within a lexical context.
  applySyntactic<app> = app
}` }, "BuiltInRules", null, null, { alnum: ["define", { sourceInterval: [18, 78] }, "an alpha-numeric character", [], ["alt", { sourceInterval: [60, 78] }, ["app", { sourceInterval: [60, 66] }, "letter", []], ["app", { sourceInterval: [73, 78] }, "digit", []]]], letter: ["define", { sourceInterval: [82, 142] }, "a letter", [], ["alt", { sourceInterval: [107, 142] }, ["app", { sourceInterval: [107, 112] }, "lower", []], ["app", { sourceInterval: [119, 124] }, "upper", []], ["app", { sourceInterval: [131, 142] }, "unicodeLtmo", []]]], digit: ["define", { sourceInterval: [146, 177] }, "a digit", [], ["range", { sourceInterval: [169, 177] }, "0", "9"]], hexDigit: ["define", { sourceInterval: [181, 254] }, "a hexadecimal digit", [], ["alt", { sourceInterval: [219, 254] }, ["app", { sourceInterval: [219, 224] }, "digit", []], ["range", { sourceInterval: [231, 239] }, "a", "f"], ["range", { sourceInterval: [246, 254] }, "A", "F"]]], ListOf: ["define", { sourceInterval: [258, 336] }, null, ["elem", "sep"], ["alt", { sourceInterval: [282, 336] }, ["app", { sourceInterval: [282, 307] }, "NonemptyListOf", [["param", { sourceInterval: [297, 301] }, 0], ["param", { sourceInterval: [303, 306] }, 1]]], ["app", { sourceInterval: [314, 336] }, "EmptyListOf", [["param", { sourceInterval: [326, 330] }, 0], ["param", { sourceInterval: [332, 335] }, 1]]]]], NonemptyListOf: ["define", { sourceInterval: [340, 388] }, null, ["elem", "sep"], ["seq", { sourceInterval: [372, 388] }, ["param", { sourceInterval: [372, 376] }, 0], ["star", { sourceInterval: [377, 388] }, ["seq", { sourceInterval: [378, 386] }, ["param", { sourceInterval: [378, 381] }, 1], ["param", { sourceInterval: [382, 386] }, 0]]]]], EmptyListOf: ["define", { sourceInterval: [392, 434] }, null, ["elem", "sep"], ["seq", { sourceInterval: [438, 438] }]], listOf: ["define", { sourceInterval: [438, 516] }, null, ["elem", "sep"], ["alt", { sourceInterval: [462, 516] }, ["app", { sourceInterval: [462, 487] }, "nonemptyListOf", [["param", { sourceInterval: [477, 481] }, 0], ["param", { sourceInterval: [483, 486] }, 1]]], ["app", { sourceInterval: [494, 516] }, "emptyListOf", [["param", { sourceInterval: [506, 510] }, 0], ["param", { sourceInterval: [512, 515] }, 1]]]]], nonemptyListOf: ["define", { sourceInterval: [520, 568] }, null, ["elem", "sep"], ["seq", { sourceInterval: [552, 568] }, ["param", { sourceInterval: [552, 556] }, 0], ["star", { sourceInterval: [557, 568] }, ["seq", { sourceInterval: [558, 566] }, ["param", { sourceInterval: [558, 561] }, 1], ["param", { sourceInterval: [562, 566] }, 0]]]]], emptyListOf: ["define", { sourceInterval: [572, 682] }, null, ["elem", "sep"], ["seq", { sourceInterval: [685, 685] }]], applySyntactic: ["define", { sourceInterval: [685, 710] }, null, ["app"], ["param", { sourceInterval: [707, 710] }, 0]] }]);
const $8e = F1;
$8e.BuiltInRules = _8e;
var { makeRecipe: q8e } = UZ, e_e = q8e(["grammar", { source: `OperationsAndAttributes {

  AttributeSignature =
    name

  OperationSignature =
    name Formals?

  Formals
    = "(" ListOf<name, ","> ")"

  name  (a name)
    = nameFirst nameRest*

  nameFirst
    = "_"
    | letter

  nameRest
    = "_"
    | alnum

}` }, "OperationsAndAttributes", null, "AttributeSignature", { AttributeSignature: ["define", { sourceInterval: [29, 58] }, null, [], ["app", { sourceInterval: [54, 58] }, "name", []]], OperationSignature: ["define", { sourceInterval: [62, 100] }, null, [], ["seq", { sourceInterval: [87, 100] }, ["app", { sourceInterval: [87, 91] }, "name", []], ["opt", { sourceInterval: [92, 100] }, ["app", { sourceInterval: [92, 99] }, "Formals", []]]]], Formals: ["define", { sourceInterval: [104, 143] }, null, [], ["seq", { sourceInterval: [118, 143] }, ["terminal", { sourceInterval: [118, 121] }, "("], ["app", { sourceInterval: [122, 139] }, "ListOf", [["app", { sourceInterval: [129, 133] }, "name", []], ["terminal", { sourceInterval: [135, 138] }, ","]]], ["terminal", { sourceInterval: [140, 143] }, ")"]]], name: ["define", { sourceInterval: [147, 187] }, "a name", [], ["seq", { sourceInterval: [168, 187] }, ["app", { sourceInterval: [168, 177] }, "nameFirst", []], ["star", { sourceInterval: [178, 187] }, ["app", { sourceInterval: [178, 186] }, "nameRest", []]]]], nameFirst: ["define", { sourceInterval: [191, 223] }, null, [], ["alt", { sourceInterval: [207, 223] }, ["terminal", { sourceInterval: [207, 210] }, "_"], ["app", { sourceInterval: [217, 223] }, "letter", []]]], nameRest: ["define", { sourceInterval: [227, 257] }, null, [], ["alt", { sourceInterval: [242, 257] }, ["terminal", { sourceInterval: [242, 245] }, "_"], ["app", { sourceInterval: [252, 257] }, "alnum", []]]] }]);
const tV = l6, t_e = qd;
t_e.awaitBuiltInRules((e) => {
  const t = e_e;
  i_e(e), n_e(t);
});
function i_e(e) {
  const t = {
    empty() {
      return this.iteration();
    },
    nonEmpty(i, n, g) {
      return this.iteration([i].concat(g.children));
    }
  };
  tV.BuiltInSemantics = tV.createSemantics(e, null).addOperation(
    "asIteration",
    {
      emptyListOf: t.empty,
      nonemptyListOf: t.nonEmpty,
      EmptyListOf: t.empty,
      NonemptyListOf: t.nonEmpty
    }
  );
}
function n_e(e) {
  tV.prototypeGrammarSemantics = e.createSemantics().addOperation("parse", {
    AttributeSignature(t) {
      return {
        name: t.parse(),
        formals: []
      };
    },
    OperationSignature(t, i) {
      return {
        name: t.parse(),
        formals: i.children.map((n) => n.parse())[0] || []
      };
    },
    Formals(t, i, n) {
      return i.asIteration().children.map((g) => g.parse());
    },
    name(t, i) {
      return this.sourceString;
    }
  }), tV.prototypeGrammar = e;
}
var { makeRecipe: g_e } = UZ, r_e = g_e(["grammar", { source: `Ohm {

  Grammars
    = Grammar*

  Grammar
    = ident SuperGrammar? "{" Rule* "}"

  SuperGrammar
    = "<:" ident

  Rule
    = ident Formals? ruleDescr? "="  RuleBody  -- define
    | ident Formals?            ":=" OverrideRuleBody  -- override
    | ident Formals?            "+=" RuleBody  -- extend

  RuleBody
    = "|"? NonemptyListOf<TopLevelTerm, "|">

  TopLevelTerm
    = Seq caseName  -- inline
    | Seq

  OverrideRuleBody
    = "|"? NonemptyListOf<OverrideTopLevelTerm, "|">

  OverrideTopLevelTerm
    = "..."  -- superSplice
    | TopLevelTerm

  Formals
    = "<" ListOf<ident, ","> ">"

  Params
    = "<" ListOf<Seq, ","> ">"

  Alt
    = NonemptyListOf<Seq, "|">

  Seq
    = Iter*

  Iter
    = Pred "*"  -- star
    | Pred "+"  -- plus
    | Pred "?"  -- opt
    | Pred

  Pred
    = "~" Lex  -- not
    | "&" Lex  -- lookahead
    | Lex

  Lex
    = "#" Base  -- lex
    | Base

  Base
    = ident Params? ~(ruleDescr? "=" | ":=" | "+=")  -- application
    | oneCharTerminal ".." oneCharTerminal           -- range
    | terminal                                       -- terminal
    | "(" Alt ")"                                    -- paren

  ruleDescr  (a rule description)
    = "(" ruleDescrText ")"

  ruleDescrText
    = (~")" any)*

  caseName
    = "--" (~"\\n" space)* name (~"\\n" space)* ("\\n" | &"}")

  name  (a name)
    = nameFirst nameRest*

  nameFirst
    = "_"
    | letter

  nameRest
    = "_"
    | alnum

  ident  (an identifier)
    = name

  terminal
    = "\\"" terminalChar* "\\""

  oneCharTerminal
    = "\\"" terminalChar "\\""

  terminalChar
    = escapeChar
      | ~"\\\\" ~"\\"" ~"\\n" "\\u{0}".."\\u{10FFFF}"

  escapeChar  (an escape sequence)
    = "\\\\\\\\"                                     -- backslash
    | "\\\\\\""                                     -- doubleQuote
    | "\\\\\\'"                                     -- singleQuote
    | "\\\\b"                                      -- backspace
    | "\\\\n"                                      -- lineFeed
    | "\\\\r"                                      -- carriageReturn
    | "\\\\t"                                      -- tab
    | "\\\\u{" hexDigit hexDigit? hexDigit?
             hexDigit? hexDigit? hexDigit? "}"   -- unicodeCodePoint
    | "\\\\u" hexDigit hexDigit hexDigit hexDigit  -- unicodeEscape
    | "\\\\x" hexDigit hexDigit                    -- hexEscape

  space
   += comment

  comment
    = "//" (~"\\n" any)* &("\\n" | end)  -- singleLine
    | "/*" (~"*/" any)* "*/"  -- multiLine

  tokens = token*

  token = caseName | comment | ident | operator | punctuation | terminal | any

  operator = "<:" | "=" | ":=" | "+=" | "*" | "+" | "?" | "~" | "&"

  punctuation = "<" | ">" | "," | "--"
}` }, "Ohm", null, "Grammars", { Grammars: ["define", { sourceInterval: [9, 32] }, null, [], ["star", { sourceInterval: [24, 32] }, ["app", { sourceInterval: [24, 31] }, "Grammar", []]]], Grammar: ["define", { sourceInterval: [36, 83] }, null, [], ["seq", { sourceInterval: [50, 83] }, ["app", { sourceInterval: [50, 55] }, "ident", []], ["opt", { sourceInterval: [56, 69] }, ["app", { sourceInterval: [56, 68] }, "SuperGrammar", []]], ["terminal", { sourceInterval: [70, 73] }, "{"], ["star", { sourceInterval: [74, 79] }, ["app", { sourceInterval: [74, 78] }, "Rule", []]], ["terminal", { sourceInterval: [80, 83] }, "}"]]], SuperGrammar: ["define", { sourceInterval: [87, 116] }, null, [], ["seq", { sourceInterval: [106, 116] }, ["terminal", { sourceInterval: [106, 110] }, "<:"], ["app", { sourceInterval: [111, 116] }, "ident", []]]], Rule_define: ["define", { sourceInterval: [131, 181] }, null, [], ["seq", { sourceInterval: [131, 170] }, ["app", { sourceInterval: [131, 136] }, "ident", []], ["opt", { sourceInterval: [137, 145] }, ["app", { sourceInterval: [137, 144] }, "Formals", []]], ["opt", { sourceInterval: [146, 156] }, ["app", { sourceInterval: [146, 155] }, "ruleDescr", []]], ["terminal", { sourceInterval: [157, 160] }, "="], ["app", { sourceInterval: [162, 170] }, "RuleBody", []]]], Rule_override: ["define", { sourceInterval: [188, 248] }, null, [], ["seq", { sourceInterval: [188, 235] }, ["app", { sourceInterval: [188, 193] }, "ident", []], ["opt", { sourceInterval: [194, 202] }, ["app", { sourceInterval: [194, 201] }, "Formals", []]], ["terminal", { sourceInterval: [214, 218] }, ":="], ["app", { sourceInterval: [219, 235] }, "OverrideRuleBody", []]]], Rule_extend: ["define", { sourceInterval: [255, 305] }, null, [], ["seq", { sourceInterval: [255, 294] }, ["app", { sourceInterval: [255, 260] }, "ident", []], ["opt", { sourceInterval: [261, 269] }, ["app", { sourceInterval: [261, 268] }, "Formals", []]], ["terminal", { sourceInterval: [281, 285] }, "+="], ["app", { sourceInterval: [286, 294] }, "RuleBody", []]]], Rule: ["define", { sourceInterval: [120, 305] }, null, [], ["alt", { sourceInterval: [131, 305] }, ["app", { sourceInterval: [131, 170] }, "Rule_define", []], ["app", { sourceInterval: [188, 235] }, "Rule_override", []], ["app", { sourceInterval: [255, 294] }, "Rule_extend", []]]], RuleBody: ["define", { sourceInterval: [309, 362] }, null, [], ["seq", { sourceInterval: [324, 362] }, ["opt", { sourceInterval: [324, 328] }, ["terminal", { sourceInterval: [324, 327] }, "|"]], ["app", { sourceInterval: [329, 362] }, "NonemptyListOf", [["app", { sourceInterval: [344, 356] }, "TopLevelTerm", []], ["terminal", { sourceInterval: [358, 361] }, "|"]]]]], TopLevelTerm_inline: ["define", { sourceInterval: [385, 408] }, null, [], ["seq", { sourceInterval: [385, 397] }, ["app", { sourceInterval: [385, 388] }, "Seq", []], ["app", { sourceInterval: [389, 397] }, "caseName", []]]], TopLevelTerm: ["define", { sourceInterval: [366, 418] }, null, [], ["alt", { sourceInterval: [385, 418] }, ["app", { sourceInterval: [385, 397] }, "TopLevelTerm_inline", []], ["app", { sourceInterval: [415, 418] }, "Seq", []]]], OverrideRuleBody: ["define", { sourceInterval: [422, 491] }, null, [], ["seq", { sourceInterval: [445, 491] }, ["opt", { sourceInterval: [445, 449] }, ["terminal", { sourceInterval: [445, 448] }, "|"]], ["app", { sourceInterval: [450, 491] }, "NonemptyListOf", [["app", { sourceInterval: [465, 485] }, "OverrideTopLevelTerm", []], ["terminal", { sourceInterval: [487, 490] }, "|"]]]]], OverrideTopLevelTerm_superSplice: ["define", { sourceInterval: [522, 543] }, null, [], ["terminal", { sourceInterval: [522, 527] }, "..."]], OverrideTopLevelTerm: ["define", { sourceInterval: [495, 562] }, null, [], ["alt", { sourceInterval: [522, 562] }, ["app", { sourceInterval: [522, 527] }, "OverrideTopLevelTerm_superSplice", []], ["app", { sourceInterval: [550, 562] }, "TopLevelTerm", []]]], Formals: ["define", { sourceInterval: [566, 606] }, null, [], ["seq", { sourceInterval: [580, 606] }, ["terminal", { sourceInterval: [580, 583] }, "<"], ["app", { sourceInterval: [584, 602] }, "ListOf", [["app", { sourceInterval: [591, 596] }, "ident", []], ["terminal", { sourceInterval: [598, 601] }, ","]]], ["terminal", { sourceInterval: [603, 606] }, ">"]]], Params: ["define", { sourceInterval: [610, 647] }, null, [], ["seq", { sourceInterval: [623, 647] }, ["terminal", { sourceInterval: [623, 626] }, "<"], ["app", { sourceInterval: [627, 643] }, "ListOf", [["app", { sourceInterval: [634, 637] }, "Seq", []], ["terminal", { sourceInterval: [639, 642] }, ","]]], ["terminal", { sourceInterval: [644, 647] }, ">"]]], Alt: ["define", { sourceInterval: [651, 685] }, null, [], ["app", { sourceInterval: [661, 685] }, "NonemptyListOf", [["app", { sourceInterval: [676, 679] }, "Seq", []], ["terminal", { sourceInterval: [681, 684] }, "|"]]]], Seq: ["define", { sourceInterval: [689, 704] }, null, [], ["star", { sourceInterval: [699, 704] }, ["app", { sourceInterval: [699, 703] }, "Iter", []]]], Iter_star: ["define", { sourceInterval: [719, 736] }, null, [], ["seq", { sourceInterval: [719, 727] }, ["app", { sourceInterval: [719, 723] }, "Pred", []], ["terminal", { sourceInterval: [724, 727] }, "*"]]], Iter_plus: ["define", { sourceInterval: [743, 760] }, null, [], ["seq", { sourceInterval: [743, 751] }, ["app", { sourceInterval: [743, 747] }, "Pred", []], ["terminal", { sourceInterval: [748, 751] }, "+"]]], Iter_opt: ["define", { sourceInterval: [767, 783] }, null, [], ["seq", { sourceInterval: [767, 775] }, ["app", { sourceInterval: [767, 771] }, "Pred", []], ["terminal", { sourceInterval: [772, 775] }, "?"]]], Iter: ["define", { sourceInterval: [708, 794] }, null, [], ["alt", { sourceInterval: [719, 794] }, ["app", { sourceInterval: [719, 727] }, "Iter_star", []], ["app", { sourceInterval: [743, 751] }, "Iter_plus", []], ["app", { sourceInterval: [767, 775] }, "Iter_opt", []], ["app", { sourceInterval: [790, 794] }, "Pred", []]]], Pred_not: ["define", { sourceInterval: [809, 824] }, null, [], ["seq", { sourceInterval: [809, 816] }, ["terminal", { sourceInterval: [809, 812] }, "~"], ["app", { sourceInterval: [813, 816] }, "Lex", []]]], Pred_lookahead: ["define", { sourceInterval: [831, 852] }, null, [], ["seq", { sourceInterval: [831, 838] }, ["terminal", { sourceInterval: [831, 834] }, "&"], ["app", { sourceInterval: [835, 838] }, "Lex", []]]], Pred: ["define", { sourceInterval: [798, 862] }, null, [], ["alt", { sourceInterval: [809, 862] }, ["app", { sourceInterval: [809, 816] }, "Pred_not", []], ["app", { sourceInterval: [831, 838] }, "Pred_lookahead", []], ["app", { sourceInterval: [859, 862] }, "Lex", []]]], Lex_lex: ["define", { sourceInterval: [876, 892] }, null, [], ["seq", { sourceInterval: [876, 884] }, ["terminal", { sourceInterval: [876, 879] }, "#"], ["app", { sourceInterval: [880, 884] }, "Base", []]]], Lex: ["define", { sourceInterval: [866, 903] }, null, [], ["alt", { sourceInterval: [876, 903] }, ["app", { sourceInterval: [876, 884] }, "Lex_lex", []], ["app", { sourceInterval: [899, 903] }, "Base", []]]], Base_application: ["define", { sourceInterval: [918, 979] }, null, [], ["seq", { sourceInterval: [918, 963] }, ["app", { sourceInterval: [918, 923] }, "ident", []], ["opt", { sourceInterval: [924, 931] }, ["app", { sourceInterval: [924, 930] }, "Params", []]], ["not", { sourceInterval: [932, 963] }, ["alt", { sourceInterval: [934, 962] }, ["seq", { sourceInterval: [934, 948] }, ["opt", { sourceInterval: [934, 944] }, ["app", { sourceInterval: [934, 943] }, "ruleDescr", []]], ["terminal", { sourceInterval: [945, 948] }, "="]], ["terminal", { sourceInterval: [951, 955] }, ":="], ["terminal", { sourceInterval: [958, 962] }, "+="]]]]], Base_range: ["define", { sourceInterval: [986, 1041] }, null, [], ["seq", { sourceInterval: [986, 1022] }, ["app", { sourceInterval: [986, 1001] }, "oneCharTerminal", []], ["terminal", { sourceInterval: [1002, 1006] }, ".."], ["app", { sourceInterval: [1007, 1022] }, "oneCharTerminal", []]]], Base_terminal: ["define", { sourceInterval: [1048, 1106] }, null, [], ["app", { sourceInterval: [1048, 1056] }, "terminal", []]], Base_paren: ["define", { sourceInterval: [1113, 1168] }, null, [], ["seq", { sourceInterval: [1113, 1124] }, ["terminal", { sourceInterval: [1113, 1116] }, "("], ["app", { sourceInterval: [1117, 1120] }, "Alt", []], ["terminal", { sourceInterval: [1121, 1124] }, ")"]]], Base: ["define", { sourceInterval: [907, 1168] }, null, [], ["alt", { sourceInterval: [918, 1168] }, ["app", { sourceInterval: [918, 963] }, "Base_application", []], ["app", { sourceInterval: [986, 1022] }, "Base_range", []], ["app", { sourceInterval: [1048, 1056] }, "Base_terminal", []], ["app", { sourceInterval: [1113, 1124] }, "Base_paren", []]]], ruleDescr: ["define", { sourceInterval: [1172, 1231] }, "a rule description", [], ["seq", { sourceInterval: [1210, 1231] }, ["terminal", { sourceInterval: [1210, 1213] }, "("], ["app", { sourceInterval: [1214, 1227] }, "ruleDescrText", []], ["terminal", { sourceInterval: [1228, 1231] }, ")"]]], ruleDescrText: ["define", { sourceInterval: [1235, 1266] }, null, [], ["star", { sourceInterval: [1255, 1266] }, ["seq", { sourceInterval: [1256, 1264] }, ["not", { sourceInterval: [1256, 1260] }, ["terminal", { sourceInterval: [1257, 1260] }, ")"]], ["app", { sourceInterval: [1261, 1264] }, "any", []]]]], caseName: ["define", { sourceInterval: [1270, 1338] }, null, [], ["seq", { sourceInterval: [1285, 1338] }, ["terminal", { sourceInterval: [1285, 1289] }, "--"], ["star", { sourceInterval: [1290, 1304] }, ["seq", { sourceInterval: [1291, 1302] }, ["not", { sourceInterval: [1291, 1296] }, ["terminal", { sourceInterval: [1292, 1296] }, `
`]], ["app", { sourceInterval: [1297, 1302] }, "space", []]]], ["app", { sourceInterval: [1305, 1309] }, "name", []], ["star", { sourceInterval: [1310, 1324] }, ["seq", { sourceInterval: [1311, 1322] }, ["not", { sourceInterval: [1311, 1316] }, ["terminal", { sourceInterval: [1312, 1316] }, `
`]], ["app", { sourceInterval: [1317, 1322] }, "space", []]]], ["alt", { sourceInterval: [1326, 1337] }, ["terminal", { sourceInterval: [1326, 1330] }, `
`], ["lookahead", { sourceInterval: [1333, 1337] }, ["terminal", { sourceInterval: [1334, 1337] }, "}"]]]]], name: ["define", { sourceInterval: [1342, 1382] }, "a name", [], ["seq", { sourceInterval: [1363, 1382] }, ["app", { sourceInterval: [1363, 1372] }, "nameFirst", []], ["star", { sourceInterval: [1373, 1382] }, ["app", { sourceInterval: [1373, 1381] }, "nameRest", []]]]], nameFirst: ["define", { sourceInterval: [1386, 1418] }, null, [], ["alt", { sourceInterval: [1402, 1418] }, ["terminal", { sourceInterval: [1402, 1405] }, "_"], ["app", { sourceInterval: [1412, 1418] }, "letter", []]]], nameRest: ["define", { sourceInterval: [1422, 1452] }, null, [], ["alt", { sourceInterval: [1437, 1452] }, ["terminal", { sourceInterval: [1437, 1440] }, "_"], ["app", { sourceInterval: [1447, 1452] }, "alnum", []]]], ident: ["define", { sourceInterval: [1456, 1489] }, "an identifier", [], ["app", { sourceInterval: [1485, 1489] }, "name", []]], terminal: ["define", { sourceInterval: [1493, 1531] }, null, [], ["seq", { sourceInterval: [1508, 1531] }, ["terminal", { sourceInterval: [1508, 1512] }, '"'], ["star", { sourceInterval: [1513, 1526] }, ["app", { sourceInterval: [1513, 1525] }, "terminalChar", []]], ["terminal", { sourceInterval: [1527, 1531] }, '"']]], oneCharTerminal: ["define", { sourceInterval: [1535, 1579] }, null, [], ["seq", { sourceInterval: [1557, 1579] }, ["terminal", { sourceInterval: [1557, 1561] }, '"'], ["app", { sourceInterval: [1562, 1574] }, "terminalChar", []], ["terminal", { sourceInterval: [1575, 1579] }, '"']]], terminalChar: ["define", { sourceInterval: [1583, 1660] }, null, [], ["alt", { sourceInterval: [1602, 1660] }, ["app", { sourceInterval: [1602, 1612] }, "escapeChar", []], ["seq", { sourceInterval: [1621, 1660] }, ["not", { sourceInterval: [1621, 1626] }, ["terminal", { sourceInterval: [1622, 1626] }, "\\"]], ["not", { sourceInterval: [1627, 1632] }, ["terminal", { sourceInterval: [1628, 1632] }, '"']], ["not", { sourceInterval: [1633, 1638] }, ["terminal", { sourceInterval: [1634, 1638] }, `
`]], ["range", { sourceInterval: [1639, 1660] }, "\0", "􏿿"]]]], escapeChar_backslash: ["define", { sourceInterval: [1703, 1758] }, null, [], ["terminal", { sourceInterval: [1703, 1709] }, "\\\\"]], escapeChar_doubleQuote: ["define", { sourceInterval: [1765, 1822] }, null, [], ["terminal", { sourceInterval: [1765, 1771] }, '\\"']], escapeChar_singleQuote: ["define", { sourceInterval: [1829, 1886] }, null, [], ["terminal", { sourceInterval: [1829, 1835] }, "\\'"]], escapeChar_backspace: ["define", { sourceInterval: [1893, 1948] }, null, [], ["terminal", { sourceInterval: [1893, 1898] }, "\\b"]], escapeChar_lineFeed: ["define", { sourceInterval: [1955, 2009] }, null, [], ["terminal", { sourceInterval: [1955, 1960] }, "\\n"]], escapeChar_carriageReturn: ["define", { sourceInterval: [2016, 2076] }, null, [], ["terminal", { sourceInterval: [2016, 2021] }, "\\r"]], escapeChar_tab: ["define", { sourceInterval: [2083, 2132] }, null, [], ["terminal", { sourceInterval: [2083, 2088] }, "\\t"]], escapeChar_unicodeCodePoint: ["define", { sourceInterval: [2139, 2243] }, null, [], ["seq", { sourceInterval: [2139, 2221] }, ["terminal", { sourceInterval: [2139, 2145] }, "\\u{"], ["app", { sourceInterval: [2146, 2154] }, "hexDigit", []], ["opt", { sourceInterval: [2155, 2164] }, ["app", { sourceInterval: [2155, 2163] }, "hexDigit", []]], ["opt", { sourceInterval: [2165, 2174] }, ["app", { sourceInterval: [2165, 2173] }, "hexDigit", []]], ["opt", { sourceInterval: [2188, 2197] }, ["app", { sourceInterval: [2188, 2196] }, "hexDigit", []]], ["opt", { sourceInterval: [2198, 2207] }, ["app", { sourceInterval: [2198, 2206] }, "hexDigit", []]], ["opt", { sourceInterval: [2208, 2217] }, ["app", { sourceInterval: [2208, 2216] }, "hexDigit", []]], ["terminal", { sourceInterval: [2218, 2221] }, "}"]]], escapeChar_unicodeEscape: ["define", { sourceInterval: [2250, 2309] }, null, [], ["seq", { sourceInterval: [2250, 2291] }, ["terminal", { sourceInterval: [2250, 2255] }, "\\u"], ["app", { sourceInterval: [2256, 2264] }, "hexDigit", []], ["app", { sourceInterval: [2265, 2273] }, "hexDigit", []], ["app", { sourceInterval: [2274, 2282] }, "hexDigit", []], ["app", { sourceInterval: [2283, 2291] }, "hexDigit", []]]], escapeChar_hexEscape: ["define", { sourceInterval: [2316, 2371] }, null, [], ["seq", { sourceInterval: [2316, 2339] }, ["terminal", { sourceInterval: [2316, 2321] }, "\\x"], ["app", { sourceInterval: [2322, 2330] }, "hexDigit", []], ["app", { sourceInterval: [2331, 2339] }, "hexDigit", []]]], escapeChar: ["define", { sourceInterval: [1664, 2371] }, "an escape sequence", [], ["alt", { sourceInterval: [1703, 2371] }, ["app", { sourceInterval: [1703, 1709] }, "escapeChar_backslash", []], ["app", { sourceInterval: [1765, 1771] }, "escapeChar_doubleQuote", []], ["app", { sourceInterval: [1829, 1835] }, "escapeChar_singleQuote", []], ["app", { sourceInterval: [1893, 1898] }, "escapeChar_backspace", []], ["app", { sourceInterval: [1955, 1960] }, "escapeChar_lineFeed", []], ["app", { sourceInterval: [2016, 2021] }, "escapeChar_carriageReturn", []], ["app", { sourceInterval: [2083, 2088] }, "escapeChar_tab", []], ["app", { sourceInterval: [2139, 2221] }, "escapeChar_unicodeCodePoint", []], ["app", { sourceInterval: [2250, 2291] }, "escapeChar_unicodeEscape", []], ["app", { sourceInterval: [2316, 2339] }, "escapeChar_hexEscape", []]]], space: ["extend", { sourceInterval: [2375, 2394] }, null, [], ["app", { sourceInterval: [2387, 2394] }, "comment", []]], comment_singleLine: ["define", { sourceInterval: [2412, 2458] }, null, [], ["seq", { sourceInterval: [2412, 2443] }, ["terminal", { sourceInterval: [2412, 2416] }, "//"], ["star", { sourceInterval: [2417, 2429] }, ["seq", { sourceInterval: [2418, 2427] }, ["not", { sourceInterval: [2418, 2423] }, ["terminal", { sourceInterval: [2419, 2423] }, `
`]], ["app", { sourceInterval: [2424, 2427] }, "any", []]]], ["lookahead", { sourceInterval: [2430, 2443] }, ["alt", { sourceInterval: [2432, 2442] }, ["terminal", { sourceInterval: [2432, 2436] }, `
`], ["app", { sourceInterval: [2439, 2442] }, "end", []]]]]], comment_multiLine: ["define", { sourceInterval: [2465, 2501] }, null, [], ["seq", { sourceInterval: [2465, 2487] }, ["terminal", { sourceInterval: [2465, 2469] }, "/*"], ["star", { sourceInterval: [2470, 2482] }, ["seq", { sourceInterval: [2471, 2480] }, ["not", { sourceInterval: [2471, 2476] }, ["terminal", { sourceInterval: [2472, 2476] }, "*/"]], ["app", { sourceInterval: [2477, 2480] }, "any", []]]], ["terminal", { sourceInterval: [2483, 2487] }, "*/"]]], comment: ["define", { sourceInterval: [2398, 2501] }, null, [], ["alt", { sourceInterval: [2412, 2501] }, ["app", { sourceInterval: [2412, 2443] }, "comment_singleLine", []], ["app", { sourceInterval: [2465, 2487] }, "comment_multiLine", []]]], tokens: ["define", { sourceInterval: [2505, 2520] }, null, [], ["star", { sourceInterval: [2514, 2520] }, ["app", { sourceInterval: [2514, 2519] }, "token", []]]], token: ["define", { sourceInterval: [2524, 2600] }, null, [], ["alt", { sourceInterval: [2532, 2600] }, ["app", { sourceInterval: [2532, 2540] }, "caseName", []], ["app", { sourceInterval: [2543, 2550] }, "comment", []], ["app", { sourceInterval: [2553, 2558] }, "ident", []], ["app", { sourceInterval: [2561, 2569] }, "operator", []], ["app", { sourceInterval: [2572, 2583] }, "punctuation", []], ["app", { sourceInterval: [2586, 2594] }, "terminal", []], ["app", { sourceInterval: [2597, 2600] }, "any", []]]], operator: ["define", { sourceInterval: [2604, 2669] }, null, [], ["alt", { sourceInterval: [2615, 2669] }, ["terminal", { sourceInterval: [2615, 2619] }, "<:"], ["terminal", { sourceInterval: [2622, 2625] }, "="], ["terminal", { sourceInterval: [2628, 2632] }, ":="], ["terminal", { sourceInterval: [2635, 2639] }, "+="], ["terminal", { sourceInterval: [2642, 2645] }, "*"], ["terminal", { sourceInterval: [2648, 2651] }, "+"], ["terminal", { sourceInterval: [2654, 2657] }, "?"], ["terminal", { sourceInterval: [2660, 2663] }, "~"], ["terminal", { sourceInterval: [2666, 2669] }, "&"]]], punctuation: ["define", { sourceInterval: [2673, 2709] }, null, [], ["alt", { sourceInterval: [2687, 2709] }, ["terminal", { sourceInterval: [2687, 2690] }, "<"], ["terminal", { sourceInterval: [2693, 2696] }, ">"], ["terminal", { sourceInterval: [2699, 2702] }, ","], ["terminal", { sourceInterval: [2705, 2709] }, "--"]]] }]);
const o_e = C6, oJ = F1, NY = Oj, u6 = kn, _0 = Sc, IJ = qu, lJ = qd, I_e = O8e, { makeRecipe: l_e } = UZ;
let Y1;
const Sk = Object.create(IJ.PExpr.prototype), s_e = (e) => !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
function sJ(e, t, i) {
  const n = new o_e();
  let g, r, o, I = !1;
  return (i || Y1).createSemantics().addOperation("visit", {
    Grammars(d) {
      return d.children.map((C) => C.visit());
    },
    Grammar(d, C, u, A, m) {
      const h = d.visit();
      g = n.newGrammar(h, t), C.child(0) && C.child(0).visit(), A.children.map((f) => f.visit());
      const B = g.build();
      if (B.source = this.source.trimmed(), h in t)
        throw _0.duplicateGrammarDeclaration(B, t);
      return t[h] = B, B;
    },
    SuperGrammar(d, C) {
      const u = C.visit();
      if (u === "null")
        g.withSuperGrammar(null);
      else {
        if (!t || !(u in t))
          throw _0.undeclaredGrammar(u, t, C.source);
        g.withSuperGrammar(t[u]);
      }
    },
    Rule_define(d, C, u, A, m) {
      r = d.visit(), o = C.children.map((G) => G.visit())[0] || [], !g.defaultStartRule && g.ensureSuperGrammar() !== oJ.ProtoBuiltInRules && g.withDefaultStartRule(r);
      const h = m.visit(), B = u.children.map((G) => G.visit())[0], f = this.source.trimmed();
      return g.define(r, o, h, B, f);
    },
    Rule_override(d, C, u, A) {
      r = d.visit(), o = C.children.map((B) => B.visit())[0] || [];
      const m = this.source.trimmed();
      g.ensureSuperGrammarRuleForOverriding(r, m), I = !0;
      const h = A.visit();
      return I = !1, g.override(r, o, h, null, m);
    },
    Rule_extend(d, C, u, A) {
      r = d.visit(), o = C.children.map((B) => B.visit())[0] || [];
      const m = A.visit(), h = this.source.trimmed();
      return g.extend(r, o, m, null, h);
    },
    RuleBody(d, C) {
      return n.alt(...C.visit()).withSource(this.source);
    },
    OverrideRuleBody(d, C) {
      const u = C.visit(), A = u.indexOf(Sk);
      if (A >= 0) {
        const m = u.slice(0, A), h = u.slice(A + 1);
        return h.forEach((B) => {
          if (B === Sk)
            throw _0.multipleSuperSplices(B);
        }), new IJ.Splice(
          g.superGrammar,
          r,
          m,
          h
        ).withSource(this.source);
      } else
        return n.alt(...u).withSource(this.source);
    },
    Formals(d, C, u) {
      return C.visit();
    },
    Params(d, C, u) {
      return C.visit();
    },
    Alt(d) {
      return n.alt(...d.visit()).withSource(this.source);
    },
    TopLevelTerm_inline(d, C) {
      const u = r + "_" + C.visit(), A = d.visit(), m = this.source.trimmed(), h = !(g.superGrammar && g.superGrammar.rules[u]);
      I && !h ? g.override(u, o, A, null, m) : g.define(u, o, A, null, m);
      const B = o.map((f) => n.app(f));
      return n.app(u, B).withSource(A.source);
    },
    OverrideTopLevelTerm_superSplice(d) {
      return Sk;
    },
    Seq(d) {
      return n.seq(...d.children.map((C) => C.visit())).withSource(this.source);
    },
    Iter_star(d, C) {
      return n.star(d.visit()).withSource(this.source);
    },
    Iter_plus(d, C) {
      return n.plus(d.visit()).withSource(this.source);
    },
    Iter_opt(d, C) {
      return n.opt(d.visit()).withSource(this.source);
    },
    Pred_not(d, C) {
      return n.not(C.visit()).withSource(this.source);
    },
    Pred_lookahead(d, C) {
      return n.lookahead(C.visit()).withSource(this.source);
    },
    Lex_lex(d, C) {
      return n.lex(C.visit()).withSource(this.source);
    },
    Base_application(d, C) {
      const u = C.children.map((A) => A.visit())[0] || [];
      return n.app(d.visit(), u).withSource(this.source);
    },
    Base_range(d, C, u) {
      return n.range(d.visit(), u.visit()).withSource(this.source);
    },
    Base_terminal(d) {
      return n.terminal(d.visit()).withSource(this.source);
    },
    Base_paren(d, C, u) {
      return C.visit();
    },
    ruleDescr(d, C, u) {
      return C.visit();
    },
    ruleDescrText(d) {
      return this.sourceString.trim();
    },
    caseName(d, C, u, A, m) {
      return u.visit();
    },
    name(d, C) {
      return this.sourceString;
    },
    nameFirst(d) {
    },
    nameRest(d) {
    },
    terminal(d, C, u) {
      return C.children.map((A) => A.visit()).join("");
    },
    oneCharTerminal(d, C, u) {
      return C.visit();
    },
    escapeChar(d) {
      try {
        return u6.unescapeCodePoint(this.sourceString);
      } catch (C) {
        throw C instanceof RangeError && C.message.startsWith("Invalid code point ") ? _0.invalidCodePoint(d) : C;
      }
    },
    NonemptyListOf(d, C, u) {
      return [d.visit()].concat(u.children.map((A) => A.visit()));
    },
    EmptyListOf() {
      return [];
    },
    _terminal() {
      return this.sourceString;
    }
  })(e).visit();
}
function a_e(e, t) {
  const i = Y1.match(e, "Grammars");
  if (i.failed())
    throw _0.grammarSyntaxError(i);
  return sJ(i, t);
}
function c_e(e, t) {
  const i = A6(e, t), n = Object.keys(i);
  if (n.length === 0)
    throw new Error("Missing grammar definition");
  if (n.length > 1) {
    const r = i[n[1]].source;
    throw new Error(
      lJ.getLineAndColumnMessage(r.sourceString, r.startIdx) + "Found more than one grammar definition -- use ohm.grammars() instead."
    );
  }
  return i[n[0]];
}
function A6(e, t) {
  const i = NY.extend(NY.asNamespace(t));
  if (typeof e != "string")
    if (s_e(e))
      e = e.toString();
    else
      throw new TypeError(
        "Expected string as first argument, got " + u6.unexpectedObjToString(e)
      );
  return a_e(e, i), i;
}
function d_e(e) {
  throw new Error(
    "grammarFromScriptElement was removed in Ohm v16.0. See https://ohmjs.org/d/gfs for more info."
  );
}
function C_e(e) {
  throw new Error(
    "grammarsFromScriptElements was removed in Ohm v16.0. See https://ohmjs.org/d/gfs for more info."
  );
}
w1.exports = {
  createNamespace: NY.createNamespace,
  grammar: c_e,
  grammars: A6,
  grammarFromScriptElement: d_e,
  grammarsFromScriptElements: C_e,
  makeRecipe: l_e,
  ohmGrammar: null,
  // Initialized below, after Grammar.BuiltInRules.
  pexprs: IJ,
  util: lJ,
  version: I_e
};
w1.exports._buildGrammar = sJ;
lJ.announceBuiltInRules(oJ.BuiltInRules);
w1.exports.ohmGrammar = Y1 = r_e;
oJ.initApplicationParser(Y1, sJ);
var u_e = w1.exports;
const A_e = (e) => new Error(rn.t("es gibt keine Merkmale mit {{identificator}}", {
  identificator: e
})), V3 = (e) => new Error(rn.t("es gibt kein Attribut mit {{identificator}}", {
  identificator: e
})), LY = (e) => new Error(rn.t("es gibt keine Selection mit {{identificator}}", {
  identificator: e
})), b_e = (e) => new Error(rn.t("es gibt mehr als eine Selection mit {{identificator}}", {
  identificator: e
})), m_e = (e) => new Error(rn.t("Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}", {
  cycleText: e
})), h_e = (e) => {
  const t = typeof e;
  if (!(e == null || t === "number"))
    throw new Error(rn.t("das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}", {
      type: t
    }));
  return e;
}, ja = (e, t, i) => {
  if (e == null)
    throw new Error(rn.t("Wert {{paramName}} der Funktion {{functionName}} ist null", {
      functionName: t,
      paramName: i
    }));
  return e;
}, p_e = (e) => new Error(rn.t("Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen", {
  variableLabel: e,
  variableLabel2: e
})), B_e = atob("LyoKIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjCkFDSFRVTkchIMOEbmRlcnVuZ2VuIGhpZXIgc2luZCBuaWNodCBkaXJla3Qgd2lya3NhbSEgTXVzcyBCYXNlNjQgLSBlbmNvZGVkIGluIGpzRXhwcmVzc2lvbi50cyBrb3BpZXJ0IHdlcmRlbiEKIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjCgp0aGlzIGlzIGEgc3RyaXBwZWQtZG93biB2ZXJzaW9uIG9mIGh0dHBzOi8vZ2l0aHViLmNvbS9oYXJjL29obS9ibG9iL21hc3Rlci9leGFtcGxlcy9lY21hc2NyaXB0L2dlbi9lczIwMTUuZ3JhbW1hci5vaG0KanVzdCBmb3IgSzMgZXhwcmVzc2lvbiBsYW5ndWFnZQplcnJvciBoYW5kbGluZyBjb3VsZCBiZSBiZXR0ZXIuLgoqLwoKanNFeHByZXNzaW9uIHsKCiAgU3RhcnQgPSBTY3JpcHQKCiAgLy8gT3ZlcnJpZGUgT2htJ3MgYnVpbHQtaW4gZGVmaW5pdGlvbiBvZiBzcGFjZS4KICBzcGFjZSA6PSB3aGl0ZVNwYWNlIHwgbGluZVRlcm1pbmF0b3IgfCBjb21tZW50CgogIHVuaWNvZGVacyA9ICJceEEwIiB8ICJcdTE2ODAiIHwgIlx1MjAwMCIuLiJcdTIwMEEiIHwgIlx1MjAyRiIgfCAiXHUyMDVGIiB8ICJcdTMwMDAiCgogIG11bHRpTGluZUNvbW1lbnROb05MID0gIi8qIiAofigiKi8iIHwgbGluZVRlcm1pbmF0b3IpIHNvdXJjZUNoYXJhY3RlcikqICIqLyIKCiAgLy8gZG9lcyBub3QgYWNjZXB0IGxpbmVUZXJtaW5hdG9ycywgbm90IGV2ZW4gaW1wbGljaXQgb25lcyBpbiBhIG11bHRpTGluZUNvbW1lbnQgKGNmLiBzZWN0aW9uIDcuNCkKICBzcGFjZXNOb05MID0gKHdoaXRlU3BhY2UgfCBzaW5nbGVMaW5lQ29tbWVudCB8IG11bHRpTGluZUNvbW1lbnROb05MKSoKCiAgLy8gQSBzZW1pY29sb24gaXMgImF1dG9tYXRpY2FsbHkgaW5zZXJ0ZWQiIGlmIGEgbmV3bGluZSBvciB0aGUgZW5kIG9mIHRoZSBpbnB1dCBzdHJlYW0gaXMKICAvLyByZWFjaGVkLCBvciB0aGUgb2ZmZW5kaW5nIHRva2VuIGlzICJ9Ii4KICAvLyBTZWUgaHR0cHM6Ly9lczUuZ2l0aHViLmlvLyN4Ny45IGZvciBtb3JlIGluZm9ybWF0aW9uLgogIC8vIE5PVEU6IEFwcGxpY2F0aW9ucyBvZiB0aGlzIHJ1bGUgKm11c3QqIGFwcGVhciBpbiBhIGxleGljYWwgY29udGV4dCAtLSBlaXRoZXIgaW4gdGhlIGJvZHkgb2YgYQogIC8vIGxleGljYWwgcnVsZSwgb3IgaW5zaWRlICcjKCknLgogIHNjID0gc3BhY2UqICgiOyIgfCBlbmQpCiAgICAgfCBzcGFjZXNOb05MIChsaW5lVGVybWluYXRvciB8IH5tdWx0aUxpbmVDb21tZW50Tm9OTCBtdWx0aUxpbmVDb21tZW50IHwgJiJ9IikKCiAgc291cmNlQ2hhcmFjdGVyID0gYW55CgogIGlucHV0RWxlbWVudERpdiA9CiAgICB8IHdoaXRlU3BhY2UKICAgIHwgbGluZVRlcm1pbmF0b3IKICAgIHwgY29tbWVudAogICAgfCBjb21tb25Ub2tlbgogICAgfCBkaXZQdW5jdHVhdG9yCiAgICB8IHJpZ2h0QnJhY2VQdW5jdHVhdG9yCgogIGlucHV0RWxlbWVudFJlZ0V4cCA9CiAgICB8IHdoaXRlU3BhY2UKICAgIHwgbGluZVRlcm1pbmF0b3IKICAgIHwgY29tbWVudAogICAgfCBjb21tb25Ub2tlbgogICAgfCByaWdodEJyYWNlUHVuY3R1YXRvcgogICAgfCByZWd1bGFyRXhwcmVzc2lvbkxpdGVyYWwKCiAgaW5wdXRFbGVtZW50UmVnRXhwT3JUZW1wbGF0ZVRhaWwgPQogICAgfCB3aGl0ZVNwYWNlCiAgICB8IGxpbmVUZXJtaW5hdG9yCiAgICB8IGNvbW1lbnQKICAgIHwgY29tbW9uVG9rZW4KICAgIHwgcmVndWxhckV4cHJlc3Npb25MaXRlcmFsCiAgICB8IHRlbXBsYXRlU3Vic3RpdHV0aW9uVGFpbAoKICBpbnB1dEVsZW1lbnRUZW1wbGF0ZVRhaWwgPQogICAgfCB3aGl0ZVNwYWNlCiAgICB8IGxpbmVUZXJtaW5hdG9yCiAgICB8IGNvbW1lbnQKICAgIHwgY29tbW9uVG9rZW4KICAgIHwgZGl2UHVuY3R1YXRvcgogICAgfCB0ZW1wbGF0ZVN1YnN0aXR1dGlvblRhaWwKCiAgd2hpdGVTcGFjZSA9CiAgICB8ICJcdCIKICAgIHwgIlx4MEIiCiAgICB8ICJceDBDIgogICAgfCAiICIKICAgIHwgIlx4QTAiCiAgICB8ICJcdUZFRkYiCiAgICB8IHVuaWNvZGVacwoKICBsaW5lVGVybWluYXRvciA9CiAgICB8ICJcbiIKICAgIHwgIlxyIgogICAgfCAiXHUyMDI4IgogICAgfCAiXHUyMDI5IgoKICBsaW5lVGVybWluYXRvclNlcXVlbmNlID0KICAgIHwgIlxuIiAtLSBhbHQxCiAgICB8ICJcciIgfiJcbiIgLS0gYWx0MgogICAgfCAiXHUyMDI4IiAtLSBhbHQzCiAgICB8ICJcdTIwMjkiIC0tIGFsdDQKICAgIHwgIlxyIiAiXG4iIC0tIGFsdDUKCiAgY29tbWVudCA9CiAgICB8IG11bHRpTGluZUNvbW1lbnQKICAgIHwgc2luZ2xlTGluZUNvbW1lbnQKCiAgbXVsdGlMaW5lQ29tbWVudCA9CiAgICB8ICIvKiIgbXVsdGlMaW5lQ29tbWVudENoYXJzPyAiKi8iIC0tIGFsdDEKCiAgbXVsdGlMaW5lQ29tbWVudENoYXJzID0KICAgICh+IiovIiBzb3VyY2VDaGFyYWN0ZXIpKgoKICBwb3N0QXN0ZXJpc2tDb21tZW50Q2hhcnMgPQogICAgfCBtdWx0aUxpbmVOb3RGb3J3YXJkU2xhc2hPckFzdGVyaXNrQ2hhciBtdWx0aUxpbmVDb21tZW50Q2hhcnM/IC0tIGFsdDEKICAgIHwgIioiIH4iLyIgcG9zdEFzdGVyaXNrQ29tbWVudENoYXJzPyAtLSBhbHQyCgogIG11bHRpTGluZU5vdEFzdGVyaXNrQ2hhciA9CiAgICB8IH4iKiIgc291cmNlQ2hhcmFjdGVyCgogIG11bHRpTGluZU5vdEZvcndhcmRTbGFzaE9yQXN0ZXJpc2tDaGFyID0KICAgIHwgfigiLyIgfCAiKiIpIHNvdXJjZUNoYXJhY3RlcgoKICBzaW5nbGVMaW5lQ29tbWVudCA9CiAgICB8ICIvLyIgc2luZ2xlTGluZUNvbW1lbnRDaGFycz8gLS0gYWx0MQoKICBzaW5nbGVMaW5lQ29tbWVudENoYXJzID0KICAgIHwgc2luZ2xlTGluZUNvbW1lbnRDaGFyKwoKICBzaW5nbGVMaW5lQ29tbWVudENoYXIgPQogICAgfCB+bGluZVRlcm1pbmF0b3Igc291cmNlQ2hhcmFjdGVyCgogIGNvbW1vblRva2VuID0KICAgIHwgaWRlbnRpZmllck5hbWUKICAgIHwgcHVuY3R1YXRvcgogICAgfCBudW1lcmljTGl0ZXJhbAogICAgfCBzdHJpbmdMaXRlcmFsCiAgICB8IHRlbXBsYXRlCgogIGlkZW50aWZpZXJOYW1lID0KICAgIHwgaWRlbnRpZmllck5hbWUgaWRlbnRpZmllclBhcnQgLS0gYWx0MgogICAgfCBpZGVudGlmaWVyU3RhcnQgLS0gYWx0MQoKICBpZGVudGlmaWVyU3RhcnQgPQogICAgfCB1bmljb2RlSURTdGFydCAtLSBhbHQxCiAgICB8ICIkIiAtLSBhbHQyCiAgICB8ICJfIiAtLSBhbHQzCiAgICB8ICJcXCIgdW5pY29kZUVzY2FwZVNlcXVlbmNlIC0tIGFsdDQKCiAgaWRlbnRpZmllclBhcnQgPQogICAgfCB1bmljb2RlSURDb250aW51ZSAtLSBhbHQxCiAgICB8ICIkIiAtLSBhbHQyCiAgICB8ICJfIiAtLSBhbHQzCiAgICB8ICJcXCIgdW5pY29kZUVzY2FwZVNlcXVlbmNlIC0tIGFsdDQKCgogIHVuaWNvZGVJRFN0YXJ0ID0gbGV0dGVyIC8qIGZpeG1lICovCgogIHVuaWNvZGVJRENvbnRpbnVlID0gbGV0dGVyIHwgZGlnaXQgLyogZml4bWUgKi8KCiAgcmVzZXJ2ZWRXb3JkID0KICAgIHwga2V5d29yZAogICAgfCBmb3JiaWRkZW5Xb3JkCiAgICB8IG51bGxMaXRlcmFsCiAgICB8IGJvb2xlYW5MaXRlcmFsCgogIGtleXdvcmQgPSBhdHRyaWJ1dGUgfCBhdHRySWQgfCB2YXJpYWJsZSB8IHZhcklkCgogIGZvcmJpZGRlbldvcmQgPSBpbXBsZW1lbnRzIHwgcHJvdGVjdGVkIHwgaW50ZXJmYWNlIHwgcGFja2FnZSB8IHByaXZhdGUgfCBwdWJsaWMgfCBhc3luYyB8IGF3YWl0IHwgZW51bSB8IGluc3RhbmNlb2YgfCBjb250aW51ZSB8IGRlYnVnZ2VyIHwgZnVuY3Rpb24gfCBleHRlbmRzIHwgZmluYWxseSB8IGRlZmF1bHQgfCB0eXBlb2YgfCBleHBvcnQgfCByZXR1cm4gfCBzd2l0Y2ggfCBkZWxldGUgfCBpbXBvcnQgfCBicmVhayB8IGNhdGNoIHwgY2xhc3MgfCB3aGlsZSB8IGNvbnN0IHwgc3VwZXIgfCB5aWVsZCB8IHRocm93IHwgY2FzZSB8IGVsc2UgfCB2b2lkIHwgd2l0aCB8IHRoaXMgfCB2YXIgfCBuZXcgfCBmb3IgfCB0cnkgfCBkbyB8IGluIHwgaWYgfCB3aW5kb3cgfCBkb2N1bWVudCB8IHNlbGYgfCBjb25zb2xlIHwgbGV0CgogIHB1bmN0dWF0b3IgPSAiPj4+PSIgfCAiPT09IiB8ICIhPT0iIHwgIj4+PiIgfCAiIDo6IiB8ICI8PD0iIHwgIj4+PSIgfCAiPD0iIHwgIj49IiB8ICI9PSIgfCAiIT0iIHwgIisrIiB8ICItLSIgfCAiPDwiIHwgIj4+IiB8ICImJiIgfCAifHwiIHwgIis9IiB8ICItPSIgfCAiKj0iIHwgIiU9IiB8ICImPSIgfCAifD0iIHwgIl49IiB8ICI9PiIgfCAieyIgfCAifSIgfCAiKCIgfCAiKSIgfCAiWyIgfCAiXSIgfCAiLiIgfCAjc2MgfCAiLCIgfCAiPCIgfCAiPiIgfCAiKyIgfCAiLSIgfCAiKiIgfCAiJSIgfCAiJiIgfCAifCIgfCAiXiIgfCAiISIgfCAifiIgfCAiPyIgfCAiPSIKCiAgZGl2UHVuY3R1YXRvciA9ICIvPSIgfCAiLyIKCiAgcmlnaHRCcmFjZVB1bmN0dWF0b3IgPSAiKSIKCiAgbnVsbExpdGVyYWwgPQogICAgfCBudWxsCgogIGJvb2xlYW5MaXRlcmFsID0KICAgIHwgdHJ1ZQogICAgfCBmYWxzZQoKICBudW1lcmljTGl0ZXJhbCA9CiAgICB8IGJpbmFyeUludGVnZXJMaXRlcmFsCiAgICB8IG9jdGFsSW50ZWdlckxpdGVyYWwKICAgIHwgaGV4SW50ZWdlckxpdGVyYWwKICAgIHwgZGVjaW1hbExpdGVyYWwKCiAgZGVjaW1hbExpdGVyYWwgPQogICAgfCBkZWNpbWFsSW50ZWdlckxpdGVyYWwgIi4iIGRlY2ltYWxEaWdpdHM/IGV4cG9uZW50UGFydD8gLS0gYWx0MQogICAgfCAiLiIgZGVjaW1hbERpZ2l0cyBleHBvbmVudFBhcnQ/IC0tIGFsdDIKICAgIHwgZGVjaW1hbEludGVnZXJMaXRlcmFsIGV4cG9uZW50UGFydD8gLS0gYWx0MwoKICBkZWNpbWFsSW50ZWdlckxpdGVyYWwgPQogICAgfCAiMCIgLS0gYWx0MQogICAgfCBub25aZXJvRGlnaXQgZGVjaW1hbERpZ2l0cz8gLS0gYWx0MgoKICBkZWNpbWFsRGlnaXRzID0KICAgIHwgZGVjaW1hbERpZ2l0cyBkZWNpbWFsRGlnaXQgLS0gYWx0MgogICAgfCBkZWNpbWFsRGlnaXQgLS0gYWx0MQoKICBkZWNpbWFsRGlnaXQgPSAiMCIgfCAiMSIgfCAiMiIgfCAiMyIgfCAiNCIgfCAiNSIgfCAiNiIgfCAiNyIgfCAiOCIgfCAiOSIKCiAgbm9uWmVyb0RpZ2l0ID0gIjEiIHwgIjIiIHwgIjMiIHwgIjQiIHwgIjUiIHwgIjYiIHwgIjciIHwgIjgiIHwgIjkiCgogIGV4cG9uZW50UGFydCA9CiAgICB8IGV4cG9uZW50SW5kaWNhdG9yIHNpZ25lZEludGVnZXIgLS0gYWx0MQoKICBleHBvbmVudEluZGljYXRvciA9ICJlIiB8ICJFIgoKICBzaWduZWRJbnRlZ2VyID0KICAgIHwgZGVjaW1hbERpZ2l0cyAtLSBhbHQxCiAgICB8ICIrIiBkZWNpbWFsRGlnaXRzIC0tIGFsdDIKICAgIHwgIi0iIGRlY2ltYWxEaWdpdHMgLS0gYWx0MwoKICBiaW5hcnlJbnRlZ2VyTGl0ZXJhbCA9CiAgICB8ICIwYiIgYmluYXJ5RGlnaXRzIC0tIGFsdDEKICAgIHwgIjBCIiBiaW5hcnlEaWdpdHMgLS0gYWx0MgoKICBiaW5hcnlEaWdpdHMgPQogICAgfCBiaW5hcnlEaWdpdHMgYmluYXJ5RGlnaXQgLS0gYWx0MgogICAgfCBiaW5hcnlEaWdpdCAtLSBhbHQxCgogIGJpbmFyeURpZ2l0ID0gIjAiIHwgIjEiCgogIG9jdGFsSW50ZWdlckxpdGVyYWwgPQogICAgfCAiMG8iIG9jdGFsRGlnaXRzIC0tIGFsdDEKICAgIHwgIjBPIiBvY3RhbERpZ2l0cyAtLSBhbHQyCgogIG9jdGFsRGlnaXRzID0KICAgIHwgb2N0YWxEaWdpdHMgb2N0YWxEaWdpdCAtLSBhbHQyCiAgICB8IG9jdGFsRGlnaXQgLS0gYWx0MQoKICBvY3RhbERpZ2l0ID0gIjAiIHwgIjEiIHwgIjIiIHwgIjMiIHwgIjQiIHwgIjUiIHwgIjYiIHwgIjciCgogIGhleEludGVnZXJMaXRlcmFsID0KICAgIHwgIjB4IiBoZXhEaWdpdHMgLS0gYWx0MQogICAgfCAiMFgiIGhleERpZ2l0cyAtLSBhbHQyCgogIGhleERpZ2l0cyA9CiAgICB8IGhleERpZ2l0cyBoZXhEaWdpdCAtLSBhbHQyCiAgICB8IGhleERpZ2l0IC0tIGFsdDEKCiAgaGV4RGlnaXQgOj0gIjAiIHwgIjEiIHwgIjIiIHwgIjMiIHwgIjQiIHwgIjUiIHwgIjYiIHwgIjciIHwgIjgiIHwgIjkiIHwgImEiIHwgImIiIHwgImMiIHwgImQiIHwgImUiIHwgImYiIHwgIkEiIHwgIkIiIHwgIkMiIHwgIkQiIHwgIkUiIHwgIkYiCgogIHN0cmluZ0xpdGVyYWwgPQogICAgfCAiXCIiIGRvdWJsZVN0cmluZ0NoYXJhY3RlcnM/ICJcIiIgLS0gYWx0MQogICAgfCAiJyIgc2luZ2xlU3RyaW5nQ2hhcmFjdGVycz8gIiciIC0tIGFsdDIKCiAgZG91YmxlU3RyaW5nQ2hhcmFjdGVycyA9CiAgICB8IGRvdWJsZVN0cmluZ0NoYXJhY3RlcisKCiAgc2luZ2xlU3RyaW5nQ2hhcmFjdGVycyA9CiAgICB8IHNpbmdsZVN0cmluZ0NoYXJhY3RlcisKCiAgZG91YmxlU3RyaW5nQ2hhcmFjdGVyID0KICAgIHwgfigiXCIiIHwgIlxcIiB8IGxpbmVUZXJtaW5hdG9yKSBzb3VyY2VDaGFyYWN0ZXIgLS0gYWx0MQogICAgfCAiXFwiIGVzY2FwZVNlcXVlbmNlIC0tIGFsdDIKICAgIHwgbGluZUNvbnRpbnVhdGlvbiAtLSBhbHQzCgogIHNpbmdsZVN0cmluZ0NoYXJhY3RlciA9CiAgICB8IH4oIiciIHwgIlxcIiB8IGxpbmVUZXJtaW5hdG9yKSBzb3VyY2VDaGFyYWN0ZXIgLS0gYWx0MQogICAgfCAiXFwiIGVzY2FwZVNlcXVlbmNlIC0tIGFsdDIKICAgIHwgbGluZUNvbnRpbnVhdGlvbiAtLSBhbHQzCgogIGxpbmVDb250aW51YXRpb24gPQogICAgfCAiXFwiIGxpbmVUZXJtaW5hdG9yU2VxdWVuY2UgLS0gYWx0MQoKICBlc2NhcGVTZXF1ZW5jZSA9CiAgICB8IGNoYXJhY3RlckVzY2FwZVNlcXVlbmNlIC0tIGFsdDEKICAgIHwgIjAiIH5kZWNpbWFsRGlnaXQgLS0gYWx0MgogICAgfCBoZXhFc2NhcGVTZXF1ZW5jZSAtLSBhbHQzCiAgICB8IHVuaWNvZGVFc2NhcGVTZXF1ZW5jZSAtLSBhbHQ0CgogIGNoYXJhY3RlckVzY2FwZVNlcXVlbmNlID0KICAgIHwgc2luZ2xlRXNjYXBlQ2hhcmFjdGVyCiAgICB8IG5vbkVzY2FwZUNoYXJhY3RlcgoKICBzaW5nbGVFc2NhcGVDaGFyYWN0ZXIgPSAiXCIiIHwgIlxcIiB8ICInIiB8ICJiIiB8ICJmIiB8ICJuIiB8ICJyIiB8ICJ0IiB8ICJ2IgoKICBub25Fc2NhcGVDaGFyYWN0ZXIgPQogICAgfCB+KGVzY2FwZUNoYXJhY3RlciB8IGxpbmVUZXJtaW5hdG9yKSBzb3VyY2VDaGFyYWN0ZXIKCiAgZXNjYXBlQ2hhcmFjdGVyID0KICAgIHwgc2luZ2xlRXNjYXBlQ2hhcmFjdGVyCiAgICB8IGRlY2ltYWxEaWdpdAogICAgfCAieCIKICAgIHwgInUiCgogIGhleEVzY2FwZVNlcXVlbmNlID0KICAgIHwgIngiIGhleERpZ2l0IGhleERpZ2l0IC0tIGFsdDEKCiAgdW5pY29kZUVzY2FwZVNlcXVlbmNlID0KICAgIHwgInUiIGhleDREaWdpdHMgLS0gYWx0MQogICAgfCAidXsiIGhleERpZ2l0cyAifSIgLS0gYWx0MgoKICBoZXg0RGlnaXRzID0KICAgIHwgaGV4RGlnaXQgaGV4RGlnaXQgaGV4RGlnaXQgaGV4RGlnaXQgLS0gYWx0MQoKICByZWd1bGFyRXhwcmVzc2lvbkxpdGVyYWwgPQogICAgfCAiLyIgcmVndWxhckV4cHJlc3Npb25Cb2R5ICIvIiByZWd1bGFyRXhwcmVzc2lvbkZsYWdzIC0tIGFsdDEKCiAgcmVndWxhckV4cHJlc3Npb25Cb2R5ID0KICAgIHwgcmVndWxhckV4cHJlc3Npb25GaXJzdENoYXIgcmVndWxhckV4cHJlc3Npb25DaGFycyAtLSBhbHQxCgogIHJlZ3VsYXJFeHByZXNzaW9uQ2hhcnMgPQogICAgfCByZWd1bGFyRXhwcmVzc2lvbkNoYXJzIHJlZ3VsYXJFeHByZXNzaW9uQ2hhciAtLSBhbHQyCiAgICB8IC8qIGVtcHR5ICovIC0tIGFsdDEKCiAgcmVndWxhckV4cHJlc3Npb25GaXJzdENoYXIgPQogICAgfCB+KCIqIiB8ICJcXCIgfCAiLyIgfCAiWyIpIHJlZ3VsYXJFeHByZXNzaW9uTm9uVGVybWluYXRvcgogICAgfCByZWd1bGFyRXhwcmVzc2lvbkJhY2tzbGFzaFNlcXVlbmNlCiAgICB8IHJlZ3VsYXJFeHByZXNzaW9uQ2xhc3MKCiAgcmVndWxhckV4cHJlc3Npb25DaGFyID0KICAgIHwgfigiXFwiIHwgIi8iIHwgIlsiKSByZWd1bGFyRXhwcmVzc2lvbk5vblRlcm1pbmF0b3IKICAgIHwgcmVndWxhckV4cHJlc3Npb25CYWNrc2xhc2hTZXF1ZW5jZQogICAgfCByZWd1bGFyRXhwcmVzc2lvbkNsYXNzCgogIHJlZ3VsYXJFeHByZXNzaW9uQmFja3NsYXNoU2VxdWVuY2UgPQogICAgfCAiXFwiIHJlZ3VsYXJFeHByZXNzaW9uTm9uVGVybWluYXRvciAtLSBhbHQxCgogIHJlZ3VsYXJFeHByZXNzaW9uTm9uVGVybWluYXRvciA9CiAgICB8IH5saW5lVGVybWluYXRvciBzb3VyY2VDaGFyYWN0ZXIKCiAgcmVndWxhckV4cHJlc3Npb25DbGFzcyA9CiAgICB8ICJbIiByZWd1bGFyRXhwcmVzc2lvbkNsYXNzQ2hhcnMgIl0iIC0tIGFsdDEKCiAgcmVndWxhckV4cHJlc3Npb25DbGFzc0NoYXJzID0KICAgIHwgcmVndWxhckV4cHJlc3Npb25DbGFzc0NoYXJzIHJlZ3VsYXJFeHByZXNzaW9uQ2xhc3NDaGFyIC0tIGFsdDIKICAgIHwgLyogZW1wdHkgKi8gLS0gYWx0MQoKICByZWd1bGFyRXhwcmVzc2lvbkNsYXNzQ2hhciA9CiAgICB8IH4oIl0iIHwgIlxcIikgcmVndWxhckV4cHJlc3Npb25Ob25UZXJtaW5hdG9yCiAgICB8IHJlZ3VsYXJFeHByZXNzaW9uQmFja3NsYXNoU2VxdWVuY2UKCiAgcmVndWxhckV4cHJlc3Npb25GbGFncyA9CiAgICB8IHJlZ3VsYXJFeHByZXNzaW9uRmxhZ3MgaWRlbnRpZmllclBhcnQgLS0gYWx0MgogICAgfCAvKiBlbXB0eSAqLyAtLSBhbHQxCgogIHRlbXBsYXRlID0KICAgIHwgbm9TdWJzdGl0dXRpb25UZW1wbGF0ZQogICAgfCB0ZW1wbGF0ZUhlYWQKCiAgbm9TdWJzdGl0dXRpb25UZW1wbGF0ZSA9CiAgICB8ICJgIiB0ZW1wbGF0ZUNoYXJhY3RlcnM/ICJgIiAtLSBhbHQxCgogIHRlbXBsYXRlSGVhZCA9CiAgICB8ICJgIiB0ZW1wbGF0ZUNoYXJhY3RlcnM/ICIkeyIgLS0gYWx0MQoKICB0ZW1wbGF0ZVN1YnN0aXR1dGlvblRhaWwgPQogICAgfCB0ZW1wbGF0ZU1pZGRsZQogICAgfCB0ZW1wbGF0ZVRhaWwKCiAgdGVtcGxhdGVNaWRkbGUgPQogICAgfCAifSIgdGVtcGxhdGVDaGFyYWN0ZXJzPyAiJHsiIC0tIGFsdDEKCiAgdGVtcGxhdGVUYWlsID0KICAgIHwgIn0iIHRlbXBsYXRlQ2hhcmFjdGVycz8gImAiIC0tIGFsdDEKCiAgdGVtcGxhdGVDaGFyYWN0ZXJzID0KICAgIHwgdGVtcGxhdGVDaGFyYWN0ZXIrCgogIHRlbXBsYXRlQ2hhcmFjdGVyID0KICAgIHwgIiQiIH4ieyIgLS0gYWx0MQogICAgfCAiXFwiIGVzY2FwZVNlcXVlbmNlIC0tIGFsdDIKICAgIHwgbGluZUNvbnRpbnVhdGlvbiAtLSBhbHQzCiAgICB8IGxpbmVUZXJtaW5hdG9yU2VxdWVuY2UgLS0gYWx0NAogICAgfCB+KCJgIiB8ICJcXCIgfCAiJCIgfCBsaW5lVGVybWluYXRvcikgc291cmNlQ2hhcmFjdGVyIC0tIGFsdDUKCiAgSWRlbnRpZmllclJlZmVyZW5jZTxndWFyZFlpZWxkPiA9CiAgICB8IElkZW50aWZpZXIgLS0gYWx0MQoKICBCaW5kaW5nSWRlbnRpZmllcjxndWFyZFlpZWxkPiA9CiAgICB8IElkZW50aWZpZXIgLS0gYWx0MQoKICBMYWJlbElkZW50aWZpZXI8Z3VhcmRZaWVsZD4gPQogICAgfCBJZGVudGlmaWVyIC0tIGFsdDEKCiAgSWRlbnRpZmllciA9CiAgICB8IHZhcmlhYmxlICIoIiBzdHJpbmdMaXRlcmFsICIpIiAtLSB2YXJpYWJsZQogICAgfCBhdHRyaWJ1dGUgIigiIHN0cmluZ0xpdGVyYWwgIikiIC0tIGF0dHJpYnV0ZQogICAgfCB2YXJJZCAiKCIgZGVjaW1hbEludGVnZXJMaXRlcmFsICIpIiAtLSB2YXJJZAogICAgfCBhdHRySWQgIigiIHN0cmluZ0xpdGVyYWwgIikiIC0tIGF0dHJJZAogICAgfCB+cmVzZXJ2ZWRXb3JkIGlkZW50aWZpZXJOYW1lIC0tIGFsdDEKCiAgUHJpbWFyeUV4cHJlc3Npb248Z3VhcmRZaWVsZD4gPQogICAgfCBJZGVudGlmaWVyUmVmZXJlbmNlPGd1YXJkWWllbGQ+CiAgICB8IExpdGVyYWwKICAgIHwgQXJyYXlMaXRlcmFsPGd1YXJkWWllbGQ+CiAgICB8IE9iamVjdExpdGVyYWw8Z3VhcmRZaWVsZD4KICAgIHwgcmVndWxhckV4cHJlc3Npb25MaXRlcmFsCiAgICB8IFRlbXBsYXRlTGl0ZXJhbDxndWFyZFlpZWxkPgogICAgfCBDb3ZlclBhcmVudGhlc2l6ZWRFeHByZXNzaW9uQW5kQXJyb3dQYXJhbWV0ZXJMaXN0PGd1YXJkWWllbGQ+CgogIENvdmVyUGFyZW50aGVzaXplZEV4cHJlc3Npb25BbmRBcnJvd1BhcmFtZXRlckxpc3Q8Z3VhcmRZaWVsZD4gPQogICAgfCAiKCIgRXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+ICIpIiAtLSBhbHQxCiAgICB8ICIoIiAiKSIgLS0gYWx0MgogICAgfCAiKCIgIi4uLiIgQmluZGluZ0lkZW50aWZpZXI8Z3VhcmRZaWVsZD4gIikiIC0tIGFsdDMKICAgIHwgIigiIEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiAiLCIgIi4uLiIgQmluZGluZ0lkZW50aWZpZXI8Z3VhcmRZaWVsZD4gIikiIC0tIGFsdDQKCiAgTGl0ZXJhbCA9CiAgICB8IG51bGxMaXRlcmFsCiAgICB8IGJvb2xlYW5MaXRlcmFsCiAgICB8IG51bWVyaWNMaXRlcmFsCiAgICB8IHN0cmluZ0xpdGVyYWwKCiAgQXJyYXlMaXRlcmFsPGd1YXJkWWllbGQ+ID0KICAgIHwgIlsiIEVsaXNpb24/ICJdIiAtLSBhbHQxCiAgICB8ICJbIiBFbGVtZW50TGlzdDxndWFyZFlpZWxkPiAiXSIgLS0gYWx0MgogICAgfCAiWyIgRWxlbWVudExpc3Q8Z3VhcmRZaWVsZD4gIiwiIEVsaXNpb24/ICJdIiAtLSBhbHQzCgogIEVsZW1lbnRMaXN0PGd1YXJkWWllbGQ+ID0KICAgIHwgRWxlbWVudExpc3Q8Z3VhcmRZaWVsZD4gIiwiIEVsaXNpb24/IEFzc2lnbm1lbnRFeHByZXNzaW9uPHdpdGhJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MwogICAgfCBFbGVtZW50TGlzdDxndWFyZFlpZWxkPiAiLCIgRWxpc2lvbj8gU3ByZWFkRWxlbWVudDxndWFyZFlpZWxkPiAtLSBhbHQ0CiAgICB8IEVsaXNpb24/IEFzc2lnbm1lbnRFeHByZXNzaW9uPHdpdGhJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MQogICAgfCBFbGlzaW9uPyBTcHJlYWRFbGVtZW50PGd1YXJkWWllbGQ+IC0tIGFsdDIKCiAgRWxpc2lvbiA9CiAgICB8IEVsaXNpb24gIiwiIC0tIGFsdDIKICAgIHwgIiwiIC0tIGFsdDEKCiAgU3ByZWFkRWxlbWVudDxndWFyZFlpZWxkPiA9CiAgICB8ICIuLi4iIEFzc2lnbm1lbnRFeHByZXNzaW9uPHdpdGhJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MQoKICBPYmplY3RMaXRlcmFsPGd1YXJkWWllbGQ+ID0KICAgIHwgInsiICJ9IiAtLSBhbHQxCiAgICB8ICJ7IiBQcm9wZXJ0eURlZmluaXRpb25MaXN0PGd1YXJkWWllbGQ+ICJ9IiAtLSBhbHQyCiAgICB8ICJ7IiBQcm9wZXJ0eURlZmluaXRpb25MaXN0PGd1YXJkWWllbGQ+ICIsIiAifSIgLS0gYWx0MwoKICBQcm9wZXJ0eURlZmluaXRpb25MaXN0PGd1YXJkWWllbGQ+ID0KICAgIHwgUHJvcGVydHlEZWZpbml0aW9uTGlzdDxndWFyZFlpZWxkPiAiLCIgUHJvcGVydHlEZWZpbml0aW9uPGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgUHJvcGVydHlEZWZpbml0aW9uPGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgUHJvcGVydHlEZWZpbml0aW9uPGd1YXJkWWllbGQ+ID0KICAgIHwgUHJvcGVydHlOYW1lPGd1YXJkWWllbGQ+ICI6IiBBc3NpZ25tZW50RXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDMKICAgIHwgSWRlbnRpZmllclJlZmVyZW5jZTxndWFyZFlpZWxkPiAtLSBhbHQxCiAgICB8IENvdmVySW5pdGlhbGl6ZWROYW1lPGd1YXJkWWllbGQ+IC0tIGFsdDIKCiAgUHJvcGVydHlOYW1lPGd1YXJkWWllbGQ+ID0KICAgIHwgTGl0ZXJhbFByb3BlcnR5TmFtZQogICAgfCBDb21wdXRlZFByb3BlcnR5TmFtZTxndWFyZFlpZWxkPgoKICBMaXRlcmFsUHJvcGVydHlOYW1lID0KICAgIHwgaWRlbnRpZmllck5hbWUKICAgIHwgc3RyaW5nTGl0ZXJhbAogICAgfCBudW1lcmljTGl0ZXJhbAoKICBDb21wdXRlZFByb3BlcnR5TmFtZTxndWFyZFlpZWxkPiA9CiAgICB8ICJbIiBBc3NpZ25tZW50RXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+ICJdIiAtLSBhbHQxCgogIENvdmVySW5pdGlhbGl6ZWROYW1lPGd1YXJkWWllbGQ+ID0KICAgIHwgSWRlbnRpZmllclJlZmVyZW5jZTxndWFyZFlpZWxkPiBJbml0aWFsaXplcjx3aXRoSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgSW5pdGlhbGl6ZXI8Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCAiPSIgQXNzaWdubWVudEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MQoKICBUZW1wbGF0ZUxpdGVyYWw8Z3VhcmRZaWVsZD4gPQogICAgfCBub1N1YnN0aXR1dGlvblRlbXBsYXRlIC0tIGFsdDEKICAgIHwgdGVtcGxhdGVIZWFkIEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiBUZW1wbGF0ZVNwYW5zPGd1YXJkWWllbGQ+IC0tIGFsdDIKCiAgVGVtcGxhdGVTcGFuczxndWFyZFlpZWxkPiA9CiAgICB8IHRlbXBsYXRlVGFpbCAtLSBhbHQxCiAgICB8IFRlbXBsYXRlTWlkZGxlTGlzdDxndWFyZFlpZWxkPiB0ZW1wbGF0ZVRhaWwgLS0gYWx0MgoKICBUZW1wbGF0ZU1pZGRsZUxpc3Q8Z3VhcmRZaWVsZD4gPQogICAgfCBUZW1wbGF0ZU1pZGRsZUxpc3Q8Z3VhcmRZaWVsZD4gdGVtcGxhdGVNaWRkbGUgRXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgdGVtcGxhdGVNaWRkbGUgRXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgTm9ybWFsSWRlbnRpZmllciA9IH4oYXR0cklkIHwgdmFySWQpIElkZW50aWZpZXIKCiAgTWVtYmVyRXhwcmVzc2lvbjxndWFyZFlpZWxkPiA9CiAgICB8IE1lbWJlckV4cHJlc3Npb248Z3VhcmRZaWVsZD4gIlsiIEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiAiXSIgLS0gYWx0MgogICAgfCBNZW1iZXJFeHByZXNzaW9uPGd1YXJkWWllbGQ+ICIuIiBJZGVudGlmaWVyIC0tIGFsdDMKICAgIHwgTWVtYmVyRXhwcmVzc2lvbjxndWFyZFlpZWxkPiBUZW1wbGF0ZUxpdGVyYWw8Z3VhcmRZaWVsZD4gLS0gYWx0NAogICAgfCBQcmltYXJ5RXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQxCgogIENhbGxFeHByZXNzaW9uPGd1YXJkWWllbGQ+ID0KICAgIHwgQ2FsbEV4cHJlc3Npb248Z3VhcmRZaWVsZD4gQXJndW1lbnRzPGd1YXJkWWllbGQ+IC0tIGFsdDMKICAgIHwgQ2FsbEV4cHJlc3Npb248Z3VhcmRZaWVsZD4gIlsiIEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiAiXSIgLS0gYWx0NAogICAgfCBDYWxsRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAiLiIgSWRlbnRpZmllciAtLSBhbHQ1CiAgICB8IENhbGxFeHByZXNzaW9uPGd1YXJkWWllbGQ+IFRlbXBsYXRlTGl0ZXJhbDxndWFyZFlpZWxkPiAtLSBhbHQ2CiAgICB8IE1lbWJlckV4cHJlc3Npb248Z3VhcmRZaWVsZD4gQXJndW1lbnRzPGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgQXJndW1lbnRzPGd1YXJkWWllbGQ+ID0KICAgIHwgIigiICIpIiAtLSBhbHQxCiAgICB8ICIoIiBBcmd1bWVudExpc3Q8Z3VhcmRZaWVsZD4gIikiIC0tIGFsdDIKCiAgQXJndW1lbnRMaXN0PGd1YXJkWWllbGQ+ID0KICAgIHwgQXJndW1lbnRMaXN0PGd1YXJkWWllbGQ+ICIsIiBBc3NpZ25tZW50RXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDMKICAgIHwgQXJndW1lbnRMaXN0PGd1YXJkWWllbGQ+ICIsIiAiLi4uIiBBc3NpZ25tZW50RXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDQKICAgIHwgQXNzaWdubWVudEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiAtLSBhbHQxCiAgICB8ICIuLi4iIEFzc2lnbm1lbnRFeHByZXNzaW9uPHdpdGhJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgoKICBMZWZ0SGFuZFNpZGVFeHByZXNzaW9uPGd1YXJkWWllbGQ+ID0KICAgIHwgQ2FsbEV4cHJlc3Npb248Z3VhcmRZaWVsZD4KICAgIHwgTWVtYmVyRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQxCgogIFBvc3RmaXhFeHByZXNzaW9uPGd1YXJkWWllbGQ+ID0KICAgIHwgTGVmdEhhbmRTaWRlRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQxCgogIFVuYXJ5RXhwcmVzc2lvbjxndWFyZFlpZWxkPiA9CiAgICB8IHR5cGVvZiBVbmFyeUV4cHJlc3Npb248Z3VhcmRZaWVsZD4gLS0gYWx0NAogICAgfCAiKyIgVW5hcnlFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDcKICAgIHwgIi0iIFVuYXJ5RXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQ4CiAgICB8ICJ+IiBVbmFyeUV4cHJlc3Npb248Z3VhcmRZaWVsZD4gLS0gYWx0OQogICAgfCAiISIgVW5hcnlFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDEwCiAgICB8IFBvc3RmaXhFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgTXVsdGlwbGljYXRpdmVFeHByZXNzaW9uPGd1YXJkWWllbGQ+ID0KICAgIHwgTXVsdGlwbGljYXRpdmVFeHByZXNzaW9uPGd1YXJkWWllbGQ+IE11bHRpcGxpY2F0aXZlT3BlcmF0b3IgVW5hcnlFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgVW5hcnlFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgTXVsdGlwbGljYXRpdmVPcGVyYXRvciA9ICIqIiB8ICIvIiB8ICIlIgoKICBBZGRpdGl2ZUV4cHJlc3Npb248Z3VhcmRZaWVsZD4gPQogICAgfCBBZGRpdGl2ZUV4cHJlc3Npb248Z3VhcmRZaWVsZD4gIisiIE11bHRpcGxpY2F0aXZlRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IEFkZGl0aXZlRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAiLSIgTXVsdGlwbGljYXRpdmVFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDMKICAgIHwgTXVsdGlwbGljYXRpdmVFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+ID0KICAgIHwgU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+ICI8PCIgQWRkaXRpdmVFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+ICI+PiIgQWRkaXRpdmVFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDMKICAgIHwgU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+ICI+Pj4iIEFkZGl0aXZlRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQ0CiAgICB8IEFkZGl0aXZlRXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQxCgogIFJlbGF0aW9uYWxFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ID0KICAgIHwgUmVsYXRpb25hbEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gIjwiIFNoaWZ0RXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IFJlbGF0aW9uYWxFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ICI+IiBTaGlmdEV4cHJlc3Npb248Z3VhcmRZaWVsZD4gLS0gYWx0MwogICAgfCBSZWxhdGlvbmFsRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiPD0iIFNoaWZ0RXhwcmVzc2lvbjxndWFyZFlpZWxkPiAtLSBhbHQ0CiAgICB8IFJlbGF0aW9uYWxFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ICI+PSIgU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDUKICAgIHwgUmVsYXRpb25hbEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gaW5zdGFuY2VvZiBTaGlmdEV4cHJlc3Npb248Z3VhcmRZaWVsZD4gLS0gYWx0NgogICAgfCBSZWxhdGlvbmFsRXhwcmVzc2lvbjx3aXRoSW4sIGd1YXJkWWllbGQ+IGd1YXJkSW4gaW4gU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDcKICAgIHwgU2hpZnRFeHByZXNzaW9uPGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgRXF1YWxpdHlFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ID0KICAgIHwgRXF1YWxpdHlFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ICI9PSIgUmVsYXRpb25hbEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgogICAgfCBFcXVhbGl0eUV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gIiE9IiBSZWxhdGlvbmFsRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQzCiAgICB8IEVxdWFsaXR5RXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiPT09IiBSZWxhdGlvbmFsRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQ0CiAgICB8IEVxdWFsaXR5RXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiIT09IiBSZWxhdGlvbmFsRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQ1CiAgICB8IFJlbGF0aW9uYWxFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgQml0d2lzZUFOREV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCBCaXR3aXNlQU5ERXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiJiIgRXF1YWxpdHlFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgRXF1YWxpdHlFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgQml0d2lzZVhPUkV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCBCaXR3aXNlWE9SRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiXiIgQml0d2lzZUFOREV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgogICAgfCBCaXR3aXNlQU5ERXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQxCgogIEJpdHdpc2VPUkV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCBCaXR3aXNlT1JFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ICJ8IiBCaXR3aXNlWE9SRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IEJpdHdpc2VYT1JFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgTG9naWNhbEFOREV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCBMb2dpY2FsQU5ERXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiJiYiIEJpdHdpc2VPUkV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgogICAgfCBCaXR3aXNlT1JFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgTG9naWNhbE9SRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiA9CiAgICB8IExvZ2ljYWxPUkV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gInx8IiBMb2dpY2FsQU5ERXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IExvZ2ljYWxBTkRFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgQ29uZGl0aW9uYWxFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+ID0KICAgIHwgTG9naWNhbE9SRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiAiPyIgQXNzaWdubWVudEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiAiOiIgQXNzaWdubWVudEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgogICAgfCBMb2dpY2FsT1JFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgQXNzaWdubWVudEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCBBcnJvd0Z1bmN0aW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDMKICAgIHwgQ29uZGl0aW9uYWxFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgRXhwcmVzc2lvbjxndWFyZEluLCBndWFyZFlpZWxkPiA9CiAgICB8IEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gIiwiIEFzc2lnbm1lbnRFeHByZXNzaW9uPGd1YXJkSW4sIGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgQXNzaWdubWVudEV4cHJlc3Npb248Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MQoKICBTdGF0ZW1lbnQ8Z3VhcmRZaWVsZCwgZ3VhcmRSZXR1cm4+ID0KICAgIHwgQmxvY2tTdGF0ZW1lbnQ8Z3VhcmRZaWVsZCwgZ3VhcmRSZXR1cm4+IC0tIGFsdDEKICAgIHwgRW1wdHlTdGF0ZW1lbnQgLS0gYWx0MwogICAgfCBFeHByZXNzaW9uU3RhdGVtZW50PGd1YXJkWWllbGQ+IC0tIGFsdDQKCiAgQmxvY2tTdGF0ZW1lbnQ8Z3VhcmRZaWVsZCwgZ3VhcmRSZXR1cm4+ID0KICAgIHwgQmxvY2s8Z3VhcmRZaWVsZCwgZ3VhcmRSZXR1cm4+CgogIEJsb2NrPGd1YXJkWWllbGQsIGd1YXJkUmV0dXJuPiA9CiAgICB8ICJ7IiBTdGF0ZW1lbnRMaXN0PGd1YXJkWWllbGQsIGd1YXJkUmV0dXJuPj8gIn0iIC0tIGFsdDEKCiAgU3RhdGVtZW50TGlzdDxndWFyZFlpZWxkLCBndWFyZFJldHVybj4gPQogICAgfCBTdGF0ZW1lbnRMaXN0SXRlbTxndWFyZFlpZWxkLCBndWFyZFJldHVybj4rCgogIFN0YXRlbWVudExpc3RJdGVtPGd1YXJkWWllbGQsIGd1YXJkUmV0dXJuPiA9CiAgICB8IFN0YXRlbWVudDxndWFyZFlpZWxkLCBndWFyZFJldHVybj4KCiAgQmluZGluZ0xpc3Q8Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gPQogICAgfCBCaW5kaW5nTGlzdDxndWFyZEluLCBndWFyZFlpZWxkPiAiLCIgTGV4aWNhbEJpbmRpbmc8Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgogICAgfCBMZXhpY2FsQmluZGluZzxndWFyZEluLCBndWFyZFlpZWxkPiAtLSBhbHQxCgogIExleGljYWxCaW5kaW5nPGd1YXJkSW4sIGd1YXJkWWllbGQ+ID0KICAgIHwgQmluZGluZ0lkZW50aWZpZXI8Z3VhcmRZaWVsZD4gSW5pdGlhbGl6ZXI8Z3VhcmRJbiwgZ3VhcmRZaWVsZD4/IC0tIGFsdDEKICAgIHwgQmluZGluZ1BhdHRlcm48Z3VhcmRZaWVsZD4gSW5pdGlhbGl6ZXI8Z3VhcmRJbiwgZ3VhcmRZaWVsZD4gLS0gYWx0MgoKICBCaW5kaW5nUGF0dGVybjxndWFyZFlpZWxkPiA9CiAgICB8IE9iamVjdEJpbmRpbmdQYXR0ZXJuPGd1YXJkWWllbGQ+CiAgICB8IEFycmF5QmluZGluZ1BhdHRlcm48Z3VhcmRZaWVsZD4KCiAgT2JqZWN0QmluZGluZ1BhdHRlcm48Z3VhcmRZaWVsZD4gPQogICAgfCAieyIgIn0iIC0tIGFsdDEKICAgIHwgInsiIEJpbmRpbmdQcm9wZXJ0eUxpc3Q8Z3VhcmRZaWVsZD4gIn0iIC0tIGFsdDIKICAgIHwgInsiIEJpbmRpbmdQcm9wZXJ0eUxpc3Q8Z3VhcmRZaWVsZD4gIiwiICJ9IiAtLSBhbHQzCgogIEFycmF5QmluZGluZ1BhdHRlcm48Z3VhcmRZaWVsZD4gPQogICAgfCAiWyIgRWxpc2lvbj8gQmluZGluZ1Jlc3RFbGVtZW50PGd1YXJkWWllbGQ+PyAiXSIgLS0gYWx0MQogICAgfCAiWyIgQmluZGluZ0VsZW1lbnRMaXN0PGd1YXJkWWllbGQ+ICJdIiAtLSBhbHQyCiAgICB8ICJbIiBCaW5kaW5nRWxlbWVudExpc3Q8Z3VhcmRZaWVsZD4gIiwiIEVsaXNpb24/IEJpbmRpbmdSZXN0RWxlbWVudDxndWFyZFlpZWxkPj8gIl0iIC0tIGFsdDMKCiAgQmluZGluZ1Byb3BlcnR5TGlzdDxndWFyZFlpZWxkPiA9CiAgICB8IEJpbmRpbmdQcm9wZXJ0eUxpc3Q8Z3VhcmRZaWVsZD4gIiwiIEJpbmRpbmdQcm9wZXJ0eTxndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IEJpbmRpbmdQcm9wZXJ0eTxndWFyZFlpZWxkPiAtLSBhbHQxCgogIEJpbmRpbmdFbGVtZW50TGlzdDxndWFyZFlpZWxkPiA9CiAgICB8IEJpbmRpbmdFbGVtZW50TGlzdDxndWFyZFlpZWxkPiAiLCIgQmluZGluZ0VsaXNpb25FbGVtZW50PGd1YXJkWWllbGQ+IC0tIGFsdDIKICAgIHwgQmluZGluZ0VsaXNpb25FbGVtZW50PGd1YXJkWWllbGQ+IC0tIGFsdDEKCiAgQmluZGluZ0VsaXNpb25FbGVtZW50PGd1YXJkWWllbGQ+ID0KICAgIHwgRWxpc2lvbj8gQmluZGluZ0VsZW1lbnQ8Z3VhcmRZaWVsZD4gLS0gYWx0MQoKICBCaW5kaW5nUHJvcGVydHk8Z3VhcmRZaWVsZD4gPQogICAgfCBTaW5nbGVOYW1lQmluZGluZzxndWFyZFlpZWxkPiAtLSBhbHQxCiAgICB8IFByb3BlcnR5TmFtZTxndWFyZFlpZWxkPiAiOiIgQmluZGluZ0VsZW1lbnQ8Z3VhcmRZaWVsZD4gLS0gYWx0MgoKICBCaW5kaW5nRWxlbWVudDxndWFyZFlpZWxkPiA9CiAgICB8IFNpbmdsZU5hbWVCaW5kaW5nPGd1YXJkWWllbGQ+IC0tIGFsdDEKICAgIHwgQmluZGluZ1BhdHRlcm48Z3VhcmRZaWVsZD4gSW5pdGlhbGl6ZXI8d2l0aEluLCBndWFyZFlpZWxkPj8gLS0gYWx0MgoKICBTaW5nbGVOYW1lQmluZGluZzxndWFyZFlpZWxkPiA9CiAgICB8IEJpbmRpbmdJZGVudGlmaWVyPGd1YXJkWWllbGQ+IEluaXRpYWxpemVyPHdpdGhJbiwgZ3VhcmRZaWVsZD4/IC0tIGFsdDEKCiAgQmluZGluZ1Jlc3RFbGVtZW50PGd1YXJkWWllbGQ+ID0KICAgIHwgIi4uLiIgQmluZGluZ0lkZW50aWZpZXI8Z3VhcmRZaWVsZD4gLS0gYWx0MQoKICBFbXB0eVN0YXRlbWVudCA9ICI7IiAvLyBub3RlOiB0aGlzIHNlbWljb2xvbiBlYXRzIG5ld2xpbmVzCgogIEV4cHJlc3Npb25TdGF0ZW1lbnQ8Z3VhcmRZaWVsZD4gPQogICAgfCB+KCJ7IiApIEV4cHJlc3Npb248d2l0aEluLCBndWFyZFlpZWxkPiAjc2MgLS0gYWx0MQoKICBTdHJpY3RGb3JtYWxQYXJhbWV0ZXJzPGd1YXJkWWllbGQ+ID0KICAgIHwgRm9ybWFsUGFyYW1ldGVyczxndWFyZFlpZWxkPgoKICBGb3JtYWxQYXJhbWV0ZXJzPGd1YXJkWWllbGQ+ID0KICAgIHwgRm9ybWFsUGFyYW1ldGVyTGlzdDxndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IC8qIGVtcHR5ICovIC0tIGFsdDEKCiAgRm9ybWFsUGFyYW1ldGVyTGlzdDxndWFyZFlpZWxkPiA9CiAgICB8IEZ1bmN0aW9uUmVzdFBhcmFtZXRlcjxndWFyZFlpZWxkPiAtLSBhbHQxCiAgICB8IEZvcm1hbHNMaXN0PGd1YXJkWWllbGQ+ICIsIiBGdW5jdGlvblJlc3RQYXJhbWV0ZXI8Z3VhcmRZaWVsZD4gLS0gYWx0MwogICAgfCBGb3JtYWxzTGlzdDxndWFyZFlpZWxkPiAtLSBhbHQyCgogIEZvcm1hbHNMaXN0PGd1YXJkWWllbGQ+ID0KICAgIHwgRm9ybWFsc0xpc3Q8Z3VhcmRZaWVsZD4gIiwiIEZvcm1hbFBhcmFtZXRlcjxndWFyZFlpZWxkPiAtLSBhbHQyCiAgICB8IEZvcm1hbFBhcmFtZXRlcjxndWFyZFlpZWxkPiAtLSBhbHQxCgogIEZ1bmN0aW9uUmVzdFBhcmFtZXRlcjxndWFyZFlpZWxkPiA9CiAgICB8IEJpbmRpbmdSZXN0RWxlbWVudDxndWFyZFlpZWxkPgoKICBGb3JtYWxQYXJhbWV0ZXI8Z3VhcmRZaWVsZD4gPQogICAgfCBCaW5kaW5nRWxlbWVudDxndWFyZFlpZWxkPgoKICBGdW5jdGlvbkJvZHk8Z3VhcmRZaWVsZD4gPQogICAgfCBGdW5jdGlvblN0YXRlbWVudExpc3Q8Z3VhcmRZaWVsZD4KCiAgRnVuY3Rpb25TdGF0ZW1lbnRMaXN0PGd1YXJkWWllbGQ+ID0KICAgIHwgU3RhdGVtZW50TGlzdDxndWFyZFlpZWxkLCB3aXRoUmV0dXJuPj8KCiAgQXJyb3dGdW5jdGlvbjxndWFyZEluLCBndWFyZFlpZWxkPiA9CiAgICB8IEFycm93UGFyYW1ldGVyczxndWFyZFlpZWxkPiB+bGluZVRlcm1pbmF0b3IgIj0+IiBDb25jaXNlQm9keTxndWFyZEluPiAtLSBhbHQxCgogIEFycm93UGFyYW1ldGVyczxndWFyZFlpZWxkPiA9CiAgICB8IEJpbmRpbmdJZGVudGlmaWVyPGd1YXJkWWllbGQ+CiAgICB8IENvdmVyUGFyZW50aGVzaXplZEV4cHJlc3Npb25BbmRBcnJvd1BhcmFtZXRlckxpc3Q8Z3VhcmRZaWVsZD4KCiAgQ29uY2lzZUJvZHk8Z3VhcmRJbj4gPQogICAgfCB+InsiIEFzc2lnbm1lbnRFeHByZXNzaW9uPGd1YXJkSW4sIG5vWWllbGQ+IC0tIGFsdDEKICAgIHwgInsiIEZ1bmN0aW9uQm9keTxub1lpZWxkPiAifSIgLS0gYWx0MgoKICBTY3JpcHQgPQogICAgfCBTY3JpcHRCb2R5PwoKICBTY3JpcHRCb2R5ID0KICAgIHwgU3RhdGVtZW50TGlzdDxub1lpZWxkLCBub1JldHVybj4KCiAgd2l0aFlpZWxkID0gLyogZml4bWUgKi8KCiAgbm9ZaWVsZCA9IC8qIGZpeG1lICovCgogIHdpdGhJbiA9IC8qIGZpeG1lICovCgogIG5vSW4gPSAvKiBmaXhtZSAqLwoKICB3aXRoUmV0dXJuID0gLyogZml4bWUgKi8KCiAgbm9SZXR1cm4gPSAvKiBmaXhtZSAqLwoKICB3aXRoRGVmYXVsdCA9IC8qIGZpeG1lICovCgogIG5vRGVmYXVsdCA9IC8qIGZpeG1lICovCgogIG51bGwgPSAibnVsbCIgfmlkZW50aWZpZXJQYXJ0CiAgdHJ1ZSA9ICJ0cnVlIiB+aWRlbnRpZmllclBhcnQKICBmYWxzZSA9ICJmYWxzZSIgfmlkZW50aWZpZXJQYXJ0CiAgdmFySWQgPSAoInZhcklkIiB8ICJpZCIpIH5pZGVudGlmaWVyUGFydAogIHZhcmlhYmxlID0gInZhcmlhYmxlIiB+aWRlbnRpZmllclBhcnQKICBhdHRySWQgPSAiYXR0cklkIiB+aWRlbnRpZmllclBhcnQKICBhdHRyaWJ1dGUgPSAiYXR0cmlidXRlIiB+aWRlbnRpZmllclBhcnQKICBpbXBsZW1lbnRzID0gImltcGxlbWVudHMiIH5pZGVudGlmaWVyUGFydAogIHByb3RlY3RlZCA9ICJwcm90ZWN0ZWQiIH5pZGVudGlmaWVyUGFydAogIGludGVyZmFjZSA9ICJpbnRlcmZhY2UiIH5pZGVudGlmaWVyUGFydAogIHBhY2thZ2UgPSAicGFja2FnZSIgfmlkZW50aWZpZXJQYXJ0CiAgcHJpdmF0ZSA9ICJwcml2YXRlIiB+aWRlbnRpZmllclBhcnQKICBwdWJsaWMgPSAicHVibGljIiB+aWRlbnRpZmllclBhcnQKICBhd2FpdCA9ICJhd2FpdCIgfmlkZW50aWZpZXJQYXJ0CiAgZW51bSA9ICJlbnVtIiB+aWRlbnRpZmllclBhcnQKICBpbnN0YW5jZW9mID0gImluc3RhbmNlb2YiIH5pZGVudGlmaWVyUGFydAogIGNvbnRpbnVlID0gImNvbnRpbnVlIiB+aWRlbnRpZmllclBhcnQKICBkZWJ1Z2dlciA9ICJkZWJ1Z2dlciIgfmlkZW50aWZpZXJQYXJ0CiAgZnVuY3Rpb24gPSAiZnVuY3Rpb24iIH5pZGVudGlmaWVyUGFydAogIGV4dGVuZHMgPSAiZXh0ZW5kcyIgfmlkZW50aWZpZXJQYXJ0CiAgZmluYWxseSA9ICJmaW5hbGx5IiB+aWRlbnRpZmllclBhcnQKICBkZWZhdWx0ID0gImRlZmF1bHQiIH5pZGVudGlmaWVyUGFydAogIHR5cGVvZiA9ICJ0eXBlb2YiIH5pZGVudGlmaWVyUGFydAogIGV4cG9ydCA9ICJleHBvcnQiIH5pZGVudGlmaWVyUGFydAogIHJldHVybiA9ICJyZXR1cm4iIH5pZGVudGlmaWVyUGFydAogIHN3aXRjaCA9ICJzd2l0Y2giIH5pZGVudGlmaWVyUGFydAogIGRlbGV0ZSA9ICJkZWxldGUiIH5pZGVudGlmaWVyUGFydAogIGltcG9ydCA9ICJpbXBvcnQiIH5pZGVudGlmaWVyUGFydAogIGJyZWFrID0gImJyZWFrIiB+aWRlbnRpZmllclBhcnQKICBjYXRjaCA9ICJjYXRjaCIgfmlkZW50aWZpZXJQYXJ0CiAgY2xhc3MgPSAiY2xhc3MiIH5pZGVudGlmaWVyUGFydAogIHdoaWxlID0gIndoaWxlIiB+aWRlbnRpZmllclBhcnQKICBjb25zdCA9ICJjb25zdCIgfmlkZW50aWZpZXJQYXJ0CiAgc3VwZXIgPSAic3VwZXIiIH5pZGVudGlmaWVyUGFydAogIHlpZWxkID0gInlpZWxkIiB+aWRlbnRpZmllclBhcnQKICB0aHJvdyA9ICJ0aHJvdyIgfmlkZW50aWZpZXJQYXJ0CiAgY2FzZSA9ICJjYXNlIiB+aWRlbnRpZmllclBhcnQKICBlbHNlID0gImVsc2UiIH5pZGVudGlmaWVyUGFydAogIHZvaWQgPSAidm9pZCIgfmlkZW50aWZpZXJQYXJ0CiAgd2l0aCA9ICJ3aXRoIiB+aWRlbnRpZmllclBhcnQKICB0aGlzID0gInRoaXMiIH5pZGVudGlmaWVyUGFydAogIHZhciA9ICJ2YXIiIH5pZGVudGlmaWVyUGFydAogIG5ldyA9ICJuZXciIH5pZGVudGlmaWVyUGFydAogIGZvciA9ICJmb3IiIH5pZGVudGlmaWVyUGFydAogIHRyeSA9ICJ0cnkiIH5pZGVudGlmaWVyUGFydAogIGRvID0gImRvIiB+aWRlbnRpZmllclBhcnQKICBpbiA9ICJpbiIgfmlkZW50aWZpZXJQYXJ0CiAgaWYgPSAiaWYiIH5pZGVudGlmaWVyUGFydAogIHdpbmRvdyA9ICJ3aW5kb3ciIH5pZGVudGlmaWVyUGFydAogIGRvY3VtZW50ID0gImRvY3VtZW50IiB+aWRlbnRpZmllclBhcnQKICBzZWxmID0gInNlbGYiIH5pZGVudGlmaWVyUGFydAogIGNvbnNvbGUgPSAiY29uc29sZSIgfmlkZW50aWZpZXJQYXJ0CiAgYXN5bmMgPSAiYXN5bmMiIH5pZGVudGlmaWVyUGFydAogIGxldCA9ICJsZXQiIH5pZGVudGlmaWVyUGFydAoKfQo="), Z_e = me.toPairs({
  count: (e) => e.length,
  product: (e) => e.reduce((t, i) => t * i, 1)
}), f_e = [["capitalize", ce.capitalize], ["clamp", ce.clamp], ["compact", ce.compact], ["first", ce.first], ["last", ce.last], ["lowerFirst", ce.lowerFirst], ["max", ce.max], ["min", ce.min], ["mean", ce.mean], ["pad", ce.pad], ["range", ce.range], ["snakeCase", ce.snakeCase], ["orderBy", ce.orderBy], ["startCase", ce.startCase], ["sum", ce.sum], ["tail", ce.tail], ["take", ce.take], ["toLower", ce.toLower], ["toUpper", ce.toUpper], ["union", ce.union], ["uniq", ce.uniq], ["upperFirst", ce.upperFirst], ["without", ce.without]], G_e = ["EPSILON", "MAX_SAFE_INTEGER", "MAX_VALUE", "MIN_SAFE_INTEGER", "MIN_VALUE", "NaN", "NEGATIVE_INFINITY", "POSITIVE_INFINITY", "isFinite", "isInteger", "isNaN", "isSafeInteger", "parseFloat", "parseInt"].map((e) => [e, Number[e]]), y_e = [
  "E",
  "PI",
  "abs",
  "acos",
  "acosh",
  "asin",
  "asinh",
  "atan",
  "atan2",
  "atanh",
  "ceil",
  "cos",
  "cosh",
  "exp",
  "floor",
  "fround",
  "hypot",
  "imul",
  "log",
  "log10",
  "log1p",
  "log2",
  "pow",
  "round",
  "sign",
  "sin",
  "sinh",
  "sqrt",
  "tan",
  "tanh",
  "trunc"
  // this seems to be necessary here
].map((e) => [e, Math[e]]), W_e = ["toExponential", "toFixed", "toPrecision", "toLocaleString"], S_e = W_e.map((e) => [
  e,
  // (x, ...args) => (isNumber(x) ? x[name](...args) : null),
  (t, ...i) => ce.isNumber(t) ? t[e](...i) : x1(e, "number", t)
]), V_e = ["endsWith", "includes", "indexOf", "lastIndexOf", "localeCompare", "match", "matchAll", "normalize", "padEnd", "padStart", "repeat", "replace", "replaceAll", "search", "slice", "split", "startsWith", "substring", "toLocaleLowerCase", "toLocaleUpperCase", "toLowerCase", "toSource", "toString", "toUpperCase", "trim", "trimEnd", "trimStart"], w_e = V_e.map((e) => [e, (t, ...i) => ce.isString(t) ? (
  // @ts-ignore
  t[e](...i)
) : x1(e, "string", t)]), v_e = ["test"], R_e = v_e.map((e) => [
  e,
  // (x, ...args) => (isRegExp(x) ? x[name](...args) : null),
  (t, ...i) => ce.isRegExp(t) ? (
    // @ts-ignore Should it be that way?
    t[e](...i)
  ) : x1(e, "RegExp", t)
]), X_e = ["at", "concat", "every", "filter", "find", "findIndex", "flat", "flatMap", "includes", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some"], H_e = X_e.map((e) => [e, (t, ...i) => (
  // @ts-ignore Needed here because we access the array
  ce.isArray(t) ? t[e](...i) : x1(e, "Array", t)
)]), k_e = [...S_e, ...w_e, ...R_e, ...H_e];
function x1(e, t, i) {
  throw new Error(`function ${e}(...) is only defined for type ${t} but got type ${typeof i}`);
}
const PZ = me.fromPairs([].concat(k_e, G_e, y_e, f_e, Z_e));
var sS = /* @__PURE__ */ ((e) => (e[e.Boolean = 0] = "Boolean", e[e.Number = 1] = "Number", e[e.Array = 2] = "Array", e[e.ElementCallback = 3] = "ElementCallback", e[e.ArrayElement = 4] = "ArrayElement", e[e.CallbackReturn = 5] = "CallbackReturn", e[e.Any = 6] = "Any", e))(sS || {});
const F_e = [{
  name: "first",
  arguments: [
    2
    /* Array */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "last",
  arguments: [
    2
    /* Array */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "every",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 0
  /* Boolean */
}, {
  name: "filter",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "find",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "findIndex",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 1
  /* Number */
}, {
  name: "includes",
  arguments: [
    2,
    4
    /* ArrayElement */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "indexOf",
  arguments: [
    2,
    4
    /* ArrayElement */
  ],
  type: 1
  /* Number */
}, {
  name: "lastIndexOf",
  arguments: [
    2,
    4
    /* ArrayElement */
  ],
  type: 1
  /* Number */
}, {
  name: "map",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 5
  /* CallbackReturn */
}, {
  name: "reduce",
  arguments: [
    2,
    3,
    6
    /* Any */
  ],
  type: 5
  /* CallbackReturn */
}, {
  name: "reduceRight",
  arguments: [
    2,
    3,
    6
    /* Any */
  ],
  type: 5
  /* CallbackReturn */
}, {
  name: "some",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 0
  /* Boolean */
}, {
  name: "orderBy",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 2
  /* Array */
}];
function Y_e(e, t = (n) => [], i) {
  const n = [], g = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), o = (I) => {
    if (!g.has(I)) {
      if (r.has(I)) {
        if (r.add(I), i(I))
          throw r;
        return;
      }
      r.add(I), t(I).forEach(o), r.delete(I), g.add(I), n.push(I);
    }
  };
  return e.forEach(o), n;
}
function x_e(e, t = (i) => []) {
  const i = /* @__PURE__ */ new Map(), n = [], g = [];
  for (const r of e)
    i.set(r, 0);
  for (const r of e)
    for (const o of t(r))
      i.set(o, i.get(o) + 1);
  for (const r of e)
    i.get(r) === 0 && n.push(r);
  for (; n.length > 0; ) {
    const r = n.shift();
    g.push(r);
    for (const o of t(r))
      i.set(o, i.get(o) - 1), i.get(o) === 0 && n.unshift(o);
  }
  if (g.length !== e.length)
    throw new Error(rn.t("Es gibt einen Zyklus in den berechneten Merkmalen."));
  return g;
}
const yl = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.templateOptions) == null ? void 0 : i.calculated) ?? !1;
}, ah = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.templateOptions) == null ? void 0 : i.expression) ?? "";
}, b6 = (e) => pc(e) && "expression" in e && ce.isString(e.expression), D_e = (e) => {
  const t = b6(e) ? e.expression : e;
  try {
    const i = +t;
    return !i && i !== 0;
  } catch {
    return !0;
  }
}, m6 = (e, t) => {
  const i = [];
  let n = e[t];
  for (; n && n.parentId != null; ) {
    const g = e[n.parentId];
    g && i.push(g.id), n = g;
  }
  return i.push(Dt.variableId), i;
}, J_e = (e, t) => {
  const i = ce.groupBy(e, "parentId"), n = [], g = [t];
  do {
    const r = g.pop(), o = i[r];
    if (o) {
      const I = o.map((s) => s.id);
      n.push(...I), g.push(...I);
    }
  } while (g.length > 0);
  return n;
}, or = (e, t, i, n) => t.resolve(e.args.resolver, e.args.nodeToRefMap, i ?? e.args.localContext, n ?? e.args.globalContext), aJ = u_e.grammar(B_e), K_e = (e) => e.args.nodeToRefMap, E_e = (e) => e.args.mapper, Ms = (e) => e.args.resolver, f0 = (e, t) => (t && e.args.nodeToRefMap.set(e._node, t), [t]), N_e = aJ.createSemantics().addOperation("replace(replacer,resolver,nodeToRefMap,mapper)", {
  _nonterminal(...e) {
    const t = K_e(this).get(this._node);
    if (t && !t.binding) {
      const i = E_e(this)(t);
      if (i != null) {
        this.args.replacer.replace(this, i);
        return;
      }
    }
    return e.map((i) => i.replace(this.args.replacer, this.args.resolver, this.args.nodeToRefMap, this.args.mapper)).flat();
  },
  _iter(...e) {
    return e.map((t) => t.replace(this.args.replacer, this.args.resolver, this.args.nodeToRefMap, this.args.mapper)).flat();
  },
  _terminal() {
    return [];
  }
}).addOperation("resolve(resolver,nodeToRefMap,localContext,globalContext)", {
  CallExpression_alt1(e, t) {
    const i = e.plain[0], n = F_e.find(({
      name: g
    }) => g === i);
    if (n) {
      const g = n.arguments.findIndex((s) => s === sS.Array), r = t.arguments[g], o = or(this, r)[0];
      let I;
      return t.arguments.forEach((s, a) => {
        if (n.arguments[a] === sS.ElementCallback) {
          const {
            parameter: C,
            body: u
          } = s.arrowFunction[0], A = C.plain[0], m = Ms(this).subContextWithBinding(this.args.globalContext, A, o);
          I = or(this, u, m, m)[0];
        } else
          or(this, s);
      }), n.type === sS.ArrayElement ? [o] : [I];
    }
    return or(this, t.arguments[0])[0];
  },
  CallExpression_alt5(e, t, i) {
    var r, o, I;
    const n = (r = or(this, e)) == null ? void 0 : r[0], g = (I = (o = Ms(this)).subContextFromRef) == null ? void 0 : I.call(o, this.args.localContext, n);
    return or(this, i, g);
  },
  CallExpression_alt4(e, t, i, n) {
    var o, I, s;
    const g = (o = or(this, e)) == null ? void 0 : o[0], r = (s = (I = Ms(this)).subContextFromRef) == null ? void 0 : s.call(I, this.args.localContext, g);
    return or(this, i, r), g;
  },
  LeftHandSideExpression(e) {
    return or(this, e, this.args.globalContext);
  },
  MemberExpression_alt3(e, t, i) {
    var r, o, I;
    const n = (r = or(this, e)) == null ? void 0 : r[0], g = (I = (o = Ms(this)).subContextFromRef) == null ? void 0 : I.call(o, this.args.localContext, n);
    return or(this, i, g);
  },
  MemberExpression_alt2(e, t, i, n) {
    var o, I, s;
    const g = (o = or(this, e)) == null ? void 0 : o[0], r = (s = (I = Ms(this)).subContextFromRef) == null ? void 0 : s.call(I, this.args.localContext, g);
    return or(this, i, r), g;
  },
  ConditionalExpression_alt2(e, t, i, n, g) {
    var o;
    or(this, e);
    const r = (o = or(this, i)) == null ? void 0 : o[0];
    return or(this, g), r;
  },
  // TODO: here contextRef will be undefined for instance nodes!
  Identifier_alt1(e) {
    const t = this.plain[0], i = Ms(this);
    if (t === "instances") {
      const g = this.args.localContext;
      return [i.instances(g)];
    }
    const n = i.binding(this.args.localContext, t) ?? i.attribute(this.args.localContext, t) ?? i.variable(this.args.localContext, t);
    return f0(this, n);
  },
  Identifier_variable(e, t, i, n) {
    const g = i.plain[0], r = Ms(this).variable(this.args.localContext, g);
    return f0(this, r);
  },
  Identifier_attribute(e, t, i, n) {
    const g = i.plain[0], r = Ms(this).attribute(this.args.localContext, g);
    return f0(this, r);
  },
  Identifier_varId(e, t, i, n) {
    const g = i.plain[0], r = Ms(this).varId(this.args.localContext, g);
    return f0(this, r);
  },
  Identifier_attrId(e, t, i, n) {
    const g = i.plain[0], r = Ms(this).attrId(this.args.localContext, g);
    return f0(this, r);
  },
  _iter(...e) {
    return e.map((t) => or(this, t)).flat();
  },
  _nonterminal(...e) {
    return e.map((t) => or(this, t)).flat();
  },
  _terminal() {
    return [];
  }
}).addAttribute("plain", {
  stringLiteral(e) {
    return [this.sourceString.substring(1, this.sourceString.length - 1)];
  },
  decimalIntegerLiteral(e) {
    return [parseInt(this.sourceString, 10)];
  },
  Identifier_alt1(e) {
    return [this.sourceString];
  },
  _iter(...e) {
    return e.map((t) => t.plain).flat();
  },
  _nonterminal(...e) {
    return e.map((t) => t.plain).flat();
  },
  _terminal() {
    return [];
  }
}).addAttribute("arguments", {
  CallExpression(e) {
    return [];
  },
  _iter(...e) {
    return e.map((t) => t.arguments).flat();
  },
  _nonterminal(...e) {
    return /ArgumentList_.*/.test(this._node.ruleName) ? e.filter((t) => t._node.ruleName !== void 0) : e.map((t) => t.arguments).flat();
  },
  _terminal() {
    return [];
  }
}).addAttribute("arrowFunction", {
  ArrowFunction_alt1(e, t, i) {
    return [{
      parameter: e,
      body: i
    }];
  },
  BindingIdentifier_alt1(e) {
    return e.plain;
  },
  _iter(...e) {
    return e.map((t) => t.arrowFunction).flat();
  },
  _nonterminal(...e) {
    return e.map((t) => t.arrowFunction).flat();
  },
  _terminal() {
    return [];
  }
});
function L_e(e) {
  const t = aJ.match(e);
  if (t.failed())
    throw new Error(t.message);
}
function T_e(e) {
  let t = 0, i = "";
  const n = (a) => {
    i += e.substring(t, a), t = a;
  }, g = () => n(e.length), r = (a) => i += a, o = (a) => t = a;
  return {
    replace: (a, d) => {
      n(a.source.startIdx), r(d), o(a.source.endIdx);
    },
    end: () => (g(), i)
  };
}
function h6(e) {
  return {
    bindings: {},
    localVariables: e.filter((t) => t.parentId == null),
    contextVariable: null,
    allVariables: e
  };
}
const p6 = {
  // TODO: Searching by label might become a problem real fast if we have
  // multiple variables with the same label...
  variable(e, t) {
    return w3(e, (i) => i.label === t);
  },
  // TODO: Same as above
  attribute(e, t) {
    return v3(e, (i) => i.label[rn.language ?? "de"] === t);
  },
  instances(e) {
    return P_e(e);
  },
  varId(e, t) {
    return w3(e, (i) => i.id == t);
  },
  attrId(e, t) {
    return v3(e, (i) => i.id == t);
  },
  binding(e, t) {
    return e.bindings[t];
  },
  subContextWithBinding(e, t, i) {
    return {
      ...e,
      bindings: {
        ...e.bindings,
        [t]: {
          ...i,
          binding: !0
        }
      }
    };
  },
  subContextFromRef(e, t) {
    if ((t == null ? void 0 : t.type) === 0)
      return {
        ...e,
        contextVariable: t.variable,
        localVariables: e == null ? void 0 : e.allVariables.filter((i) => i.parentId == t.variable.id)
      };
    if ((t == null ? void 0 : t.type) === 1)
      return {
        ...e,
        contextVariable: null,
        localVariables: []
      };
  }
};
function B6(e, t, i, n) {
  const g = aJ.match(e);
  if (g.failed())
    return e;
  const r = /* @__PURE__ */ new Map(), o = N_e(g);
  o.resolve(t, r, n, n);
  const I = T_e(e);
  return o.replace(I, t, r, i), I.end();
}
function iV(e, t) {
  return (t == null ? void 0 : t.indexOf(" ")) === -1 && !Q_e.has(t) ? t : `${e}('${t}')`;
}
const M_e = (e) => {
  var t;
  switch (e == null ? void 0 : e.type) {
    case 0:
      return `varId(${e.variable.id})`;
    case 1:
      return `attrId('${(t = e == null ? void 0 : e.attr) == null ? void 0 : t.id}')`;
  }
}, U_e = (e) => {
  var t;
  switch (e == null ? void 0 : e.type) {
    case 0:
      return iV("variable", e.variable.label);
    case 1:
      return iV("attribute", ((t = e == null ? void 0 : e.attr) == null ? void 0 : t.label[rn.language ?? "de"]) ?? "");
  }
};
function w3(e, t) {
  const n = (e.contextVariable ? e.localVariables.filter((g) => {
    var r;
    return g.parentId == ((r = e == null ? void 0 : e.contextVariable) == null ? void 0 : r.id);
  }) : e.localVariables).find(t);
  return n == null ? void 0 : {
    binding: !1,
    type: 0,
    variable: n
  };
}
function v3(e, t) {
  var g;
  const i = e.contextVariable;
  if (i == null)
    return;
  const n = (g = i == null ? void 0 : i.attrs) == null ? void 0 : g.find(t);
  return n == null ? void 0 : {
    binding: !1,
    type: 1,
    variable: i,
    attr: n
  };
}
function P_e(e) {
  const t = e.contextVariable;
  return t == null ? void 0 : {
    binding: !1,
    type: 0,
    variable: t
  };
}
function z_e(e = "", t) {
  return B6(e, p6, M_e, h6(t));
}
function Z6(e = "", t) {
  return B6(e, p6, U_e, h6(t));
}
function O_e(e) {
  const t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  e.forEach((g) => i.set(g.id, g));
  const n = (g) => zZ(ah(g)).map((r) => i.get(r)).filter((r) => r != null);
  e.forEach((g) => t.set(g, n(g)));
  try {
    return Y_e(e, (g) => t.get(g), (g) => !hi(g).suppressCycleDetection);
  } catch (g) {
    if (g instanceof Set) {
      const r = Array.from(g), o = (s) => s == null ? void 0 : s.label, I = r.concat(ce.first(r)).map(o).join(" -> ");
      throw m_e(I);
    }
  }
}
function zZ(e) {
  const t = /\bvarId\s*\((\s*[0-9]+\s*)\)/g;
  return [...e.matchAll(t)].map((i) => parseInt(i[1], 0));
}
const Q_e = /* @__PURE__ */ new Set(["attribute", "attrId", "variable", "async", "await", "break", "case", "catch", "class", "console", "const", "continue", "debugger", "default", "delete", "do", "document", "else", "enum", "export", "extends", "finally", "for", "function", "if", "implements", "import", "in", "interface", "let", "new", "package", "private", "protected", "public", "return", "self", "super", "switch", "this", "throw", "try", "var", "varId", "void", "while", "window", "with", "yield"]);
function j_e(e, t) {
  const i = {
    wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\@\#\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
    comments: {
      lineComment: "//",
      blockComment: ["/*", "*/"]
    },
    brackets: [["{", "}"], ["[", "]"], ["(", ")"]],
    onEnterRules: [{
      // e.g. /** | */
      beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
      afterText: /^\s*\*\/$/,
      action: {
        indentAction: e.IndentAction.IndentOutdent,
        appendText: " * "
      }
    }, {
      // e.g. /** ...|
      beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
      action: {
        indentAction: e.IndentAction.None,
        appendText: " * "
      }
    }, {
      // e.g.  * ...|
      beforeText: /^(\t|(\ \ ))*\ \*(\ ([^\*]|\*(?!\/))*)?$/,
      action: {
        indentAction: e.IndentAction.None,
        appendText: "* "
      }
    }, {
      // e.g.  */|
      beforeText: /^(\t|(\ \ ))*\ \*\/\s*$/,
      action: {
        indentAction: e.IndentAction.None,
        removeText: 1
      }
    }],
    autoClosingPairs: [{
      open: "{",
      close: "}"
    }, {
      open: "[",
      close: "]"
    }, {
      open: "(",
      close: ")"
    }, {
      open: '"',
      close: '"',
      notIn: ["string"]
    }, {
      open: "'",
      close: "'",
      notIn: ["string", "comment"]
    }, {
      open: "`",
      close: "`",
      notIn: ["string", "comment"]
    }, {
      open: "/**",
      close: " */",
      notIn: ["string"]
    }],
    folding: {
      markers: {
        start: new RegExp("^\\s*//\\s*#?region\\b"),
        end: new RegExp("^\\s*//\\s*#?endregion\\b")
      }
    }
  }, n = {
    // Set defaultToken to invalid to see what you do not tokenize yet
    defaultToken: "invalid",
    tokenPostfix: ".ts",
    // Lets make sure that all keywords are truthy otherwise the Monaco editor
    // will throw an error.
    keywords: t.filter((g) => !!g),
    operators: ["<=", ">=", "==", "!=", "===", "!==", "=>", "+", "-", "**", "*", "/", "%", "<<", "</", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "??", "?", ":", "="],
    // we include these common regular expressions
    symbols: /[=><!~?:&|+\-*\/\^%]+/,
    escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
    digits: /\d+(_+\d+)*/,
    octaldigits: /[0-7]+(_+[0-7]+)*/,
    binarydigits: /[0-1]+(_+[0-1]+)*/,
    hexdigits: /[[0-9a-fA-F]+(_+[0-9a-fA-F]+)*/,
    regexpctl: /[(){}\[\]\$\^|\-*+?\.]/,
    regexpesc: /\\(?:[bBdDfnrstvwWn0\\\/]|@regexpctl|c[A-Z]|x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4})/,
    // The main tokenizer for our languages
    tokenizer: {
      root: [[/[{}]/, "delimiter.bracket"], {
        include: "common"
      }],
      common: [
        // identifiers and keywords
        [/[a-z_$][\w$]*/, {
          cases: {
            "@keywords": "keyword",
            "@default": "identifier"
          }
        }],
        [/[A-Z][\w\$]*/, "type.identifier"],
        // to show class names nicely
        // [/[A-Z][\w\$]*/, 'identifier'],
        // whitespace
        {
          include: "@whitespace"
        },
        // regular expression: ensure it is terminated before beginning (otherwise it is an opeator)
        [/\/(?=([^\\\/]|\\.)+\/([dgimsuy]*)(\s*)(\.|;|,|\)|\]|\}|$))/, {
          token: "regexp",
          bracket: "@open",
          next: "@regexp"
        }],
        // delimiters and operators
        [/[()\[\]]/, "@brackets"],
        [/[<>](?!@symbols)/, "@brackets"],
        [/!(?=([^=]|$))/, "delimiter"],
        [/@symbols/, {
          cases: {
            "@operators": "delimiter",
            "@default": ""
          }
        }],
        // numbers
        [/(@digits)[eE]([\-+]?(@digits))?/, "number.float"],
        [/(@digits)\.(@digits)([eE][\-+]?(@digits))?/, "number.float"],
        [/0[xX](@hexdigits)n?/, "number.hex"],
        [/0[oO]?(@octaldigits)n?/, "number.octal"],
        [/0[bB](@binarydigits)n?/, "number.binary"],
        [/(@digits)n?/, "number"],
        // delimiter: after number because of .\d floats
        [/[;,.]/, "delimiter"],
        // strings
        [/"([^"\\]|\\.)*$/, "string.invalid"],
        // non-teminated string
        [/'([^'\\]|\\.)*$/, "string.invalid"],
        // non-teminated string
        [/"/, "string", "@string_double"],
        [/'/, "string", "@string_single"],
        [/`/, "string", "@string_backtick"]
      ],
      whitespace: [[/[ \t\r\n]+/, ""], [/\/\*\*(?!\/)/, "comment.doc", "@jsdoc"], [/\/\*/, "comment", "@comment"], [/\/\/.*$/, "comment"]],
      comment: [[/[^\/*]+/, "comment"], [/\*\//, "comment", "@pop"], [/[\/*]/, "comment"]],
      jsdoc: [[/[^\/*]+/, "comment.doc"], [/\*\//, "comment.doc", "@pop"], [/[\/*]/, "comment.doc"]],
      // We match regular expression quite precisely
      regexp: [[/(\{)(\d+(?:,\d*)?)(\})/, ["regexp.escape.control", "regexp.escape.control", "regexp.escape.control"]], [/(\[)(\^?)(?=(?:[^\]\\\/]|\\.)+)/, ["regexp.escape.control", {
        token: "regexp.escape.control",
        next: "@regexrange"
      }]], [/(\()(\?:|\?=|\?!)/, ["regexp.escape.control", "regexp.escape.control"]], [/[()]/, "regexp.escape.control"], [/@regexpctl/, "regexp.escape.control"], [/[^\\\/]/, "regexp"], [/@regexpesc/, "regexp.escape"], [/\\\./, "regexp.invalid"], [/(\/)([dgimsuy]*)/, [{
        token: "regexp",
        bracket: "@close",
        next: "@pop"
      }, "keyword.other"]]],
      regexrange: [[/-/, "regexp.escape.control"], [/\^/, "regexp.invalid"], [/@regexpesc/, "regexp.escape"], [/[^\]]/, "regexp"], [/\]/, {
        token: "regexp.escape.control",
        next: "@pop",
        bracket: "@close"
      }]],
      string_double: [[/[^\\"]+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/"/, "string", "@pop"]],
      string_single: [[/[^\\']+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/'/, "string", "@pop"]],
      string_backtick: [[/\$\{/, {
        token: "delimiter.bracket",
        next: "@bracketCounting"
      }], [/[^\\`$]+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/`/, "string", "@pop"]],
      bracketCounting: [[/\{/, "delimiter.bracket", "@bracketCounting"], [/\}/, "delimiter.bracket", "@pop"], {
        include: "common"
      }]
    }
  };
  return {
    configuration: i,
    language: n
  };
}
const TY = {
  codeLens: !1,
  lineNumbers: "off",
  glyphMargin: !1,
  folding: !1,
  lineDecorationsWidth: 0,
  lineNumbersMinChars: 0,
  overviewRulerLanes: 0,
  hideCursorInOverviewRuler: !0,
  overviewRulerBorder: !1,
  renderLineHighlight: "none",
  fontFamily: "Nunito Sans, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
  fontSize: 14,
  minimap: {
    enabled: !1
  }
}, __e = async () => ({
  default: (await import("./InternalMonacoEditor-JSOwVFHi.js").then((e) => e.I)).default
}), $_e = AI(__e), MY = (e) => /* @__PURE__ */ p($V, { fallback: null, children: /* @__PURE__ */ p($_e, { ...e }) }), gm = "expressionK3";
function f6(e) {
  const {
    t
  } = ii(), i = _(wg), n = (I) => {
    const s = z_e(I, i);
    e.onChange(s);
  }, g = Z6(e.expression ?? "", i), r = (I, s) => {
    var a;
    q_e(s, i), e.inline ? (a = I.getAction("editor.action.toggleTabFocusMode")) == null || a.run() : I.focus();
  }, o = je(() => ce.merge({}, TY, e.inline ? {
    scrollbar: {
      vertical: "hidden",
      horizontal: "hidden",
      handleMouseWheel: !1
    }
  } : {}, e.options), [e.inline, e.options]);
  return /* @__PURE__ */ ge("div", { style: {
    position: "relative",
    minWidth: "60px",
    width: "100%"
  }, children: [
    /* @__PURE__ */ p(MY, { height: e.height ?? "10em", theme: "light", defaultLanguage: gm, onChange: n, value: g, onMount: r, options: o, loading: /* @__PURE__ */ ge(fs, { variant: "standard", children: [
      /* @__PURE__ */ p(DO, { htmlFor: "input-component", children: t("Expression") }),
      /* @__PURE__ */ p(t1, { id: "input-component", onChange: (I) => n(I.target.value), value: g, multiline: !0, fullWidth: !0 })
    ] }) }),
    !e.inline && /* @__PURE__ */ p(mi, { "data-cy": "clear-expression", size: "small", onClick: () => {
      n(void 0);
    }, style: {
      position: "absolute",
      top: 0,
      right: 0
    }, children: /* @__PURE__ */ p(LZ, {}) })
  ] });
}
let G0 = null;
function q_e(e, t) {
  const i = e.languages;
  i.getEncodedLanguageId(gm) == 0 && i.register({
    id: gm
  });
  const n = t.map(({
    label: o
  }) => o).concat(Object.keys(PZ)), {
    configuration: g,
    language: r
  } = j_e(i, n);
  i.setLanguageConfiguration(gm, g), i.setMonarchTokensProvider(gm, r), G0 !== null && (G0 == null || G0.dispose()), G0 = i.registerCompletionItemProvider(gm, e$e(i, t));
}
function e$e(e, t) {
  return {
    provideCompletionItems: (i, n) => {
      i.getValueInRange({
        startLineNumber: 1,
        startColumn: 1,
        endLineNumber: n.lineNumber,
        endColumn: n.column
      });
      const g = i.getWordUntilPosition(n), r = {
        startLineNumber: n.lineNumber,
        endLineNumber: n.lineNumber,
        startColumn: g.startColumn,
        endColumn: g.endColumn
      };
      return {
        suggestions: t$e(e, t, r)
      };
    }
  };
}
function t$e(e, t, i) {
  const {
    Function: n,
    Variable: g,
    Constant: r,
    Property: o
  } = e.CompletionItemKind;
  return t.map((I) => I.label).map((I) => ({
    label: `${I}`,
    kind: g,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "reference to Variable " + I,
    insertText: iV("variable", I),
    range: i
  })).concat(t.flatMap((I) => {
    var s;
    return ((s = I.attrs) == null ? void 0 : s.map((a) => a.label[rn.language]).map((a) => ({
      label: `${a}`,
      kind: o,
      // documentation klappt nicht.. keine Ahnung warum
      documentation: "reference to attribut " + a,
      insertText: iV("attribut", a),
      range: i
    }))) ?? [];
  }), [{
    label: "instanceIndex",
    kind: o,
    documentation: "instance index",
    insertText: "instanceIndex",
    range: i
  }]).concat(ce.map(PZ, (I, s) => typeof I == "function" ? {
    label: `${s}`,
    kind: n,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "the function " + s,
    insertText: `${s}()`,
    range: i
  } : {
    label: `${s}`,
    kind: r,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "the constant " + s,
    insertText: s,
    range: i
  }));
}
function G6(e, t, i, n) {
  const g = ce.keyBy(e, (a) => a.id), r = ce.groupBy(t, (a) => a.variableId), o = l$e(g, n), I = ce.groupBy(o, (a) => vl(a)), s = o.filter((a) => _r(a));
  return {
    variables: e,
    variablesById: g,
    values: t,
    valuesByVariableId: r,
    selections: o,
    variable: null,
    selectionsOfVariable: [],
    allSelections: [Dt, ...o],
    anchoringSelection: Dt,
    variableHierarchies: i,
    selectionsByParentSelectionId: I,
    inInstances: s
  };
}
function y6(e) {
  return {
    varId(t) {
      return PY(e, t);
    },
    id(t) {
      return PY(e, t);
    },
    attrId(t) {
      return js.attrId(e, t);
    }
  };
}
function i$e(e, t) {
  return e.selections.filter(n$e(e, t)).sort(Ed);
}
const js = {
  varId(e, t) {
    var r, o, I;
    ja(e, "varId", "context"), ja(t, "varId", "id");
    const i = e.variablesById[t];
    if (i == null)
      throw A_e("variableId " + t);
    const n = i$e(e, t);
    if (n == null || n.length === 0) {
      if (i.type !== Bn.Components)
        throw LY("variable " + i.label + " expression variable: " + ((o = e.variablesById[(r = e.anchoringSelection) == null ? void 0 : r.variableId]) == null ? void 0 : o.label));
      return {
        ...e,
        variable: i,
        selectionsOfVariable: n
      };
    }
    if (!((I = e.variableHierarchies[e.anchoringSelection.variableId]) != null && I.includes(t))) {
      const s = jB(e.allSelections, n[0]);
      if (!s)
        throw new Error("Parent selection not found for variable " + i.label);
      return {
        ...e,
        variable: i,
        anchoringSelection: s,
        selections: Ju(e.variableHierarchies, e.allSelections, s, e.selectionsByParentSelectionId, e.inInstances),
        selectionsOfVariable: n
      };
    }
    return {
      ...e,
      variable: i,
      selectionsOfVariable: n
    };
  },
  attrId(e, t) {
    var a, d, C, u, A;
    {
      if (ja(e, "attrId", "context"), ja(t, "attrId", "id"), e.selectionsOfVariable == null || e.selectionsOfVariable.length === 0)
        throw LY("variable " + ((a = e.variable) == null ? void 0 : a.label));
      if (e.selectionsOfVariable.length > 1)
        throw b_e("variable " + ((d = e.variable) == null ? void 0 : d.label));
    }
    const i = e.selectionsOfVariable[0];
    ja(i, "attrId", "context.selectionsOfVariable[0]");
    const n = i.valueId;
    if (n == null)
      throw V3("variable " + ((C = e.variable) == null ? void 0 : C.label) + " attributeId " + t);
    const g = e.values.find((m) => m.id == n);
    ja(n, "attrId", "value is null for context.selectionsOfVariable[0].valueId");
    const r = (u = g == null ? void 0 : g.attrs) == null ? void 0 : u.find((m) => m.attrId == t);
    if (r == null)
      throw V3("variable " + ((A = e.variable) == null ? void 0 : A.label) + " attributeId " + t);
    const o = r == null ? void 0 : r.value;
    if (o == null)
      return null;
    const I = e.variablesById[i.variableId];
    ja(e, "attrId", "contextVariable");
    const s = I.attrs.find((m) => m.id == t);
    if (ja(e, "attrId", "attr"), s.type === "symbol")
      throw new Error("type symbol is not implemented yet in expression engine for attribute " + s.label[rn.language]);
    if (typeof o !== s.type)
      throw new Error("internal type mismatch: attribute definition for " + s.label[rn.language] + " is of type " + s.type + " but primitive value is of type " + typeof o);
    return o;
  },
  instances(e) {
    const t = e.variable, i = e.selectionsOfVariable;
    if (t == null)
      throw new Error("Variable is null");
    if (i.length === 0)
      throw new Error(`No selections for variable ${t == null ? void 0 : t.label}`);
    if (!V6(e, t.id))
      throw new Error(`Variable ${t == null ? void 0 : t.label} is not a parent of the anchoring selection.`);
    const n = i[0], g = e.allSelections.filter((r) => r.variableId === (n == null ? void 0 : n.variableId) && r.instance.belongsToInstanceId === (n == null ? void 0 : n.instance.belongsToInstanceId)).sort(Ed);
    return W6({
      ...e,
      selections: e.allSelections,
      selectionsOfVariable: g
    });
  },
  instanceIndex(e) {
    const t = e.variable, i = e.selectionsOfVariable;
    if (t == null)
      throw new Error("Variable is null");
    if (i.length === 0)
      throw new Error(`No selections for variable ${t == null ? void 0 : t.label}`);
    if (i.length > 1)
      throw new Error(`More than one selection for variable ${t == null ? void 0 : t.label}, cant determine instance index.`);
    const n = i[0];
    let g;
    if (A1(n)) {
      if (n.instance.id === Dt.id)
        return 0;
      g = jB(e.selections, n);
    } else
      g = n;
    return e.allSelections.filter((I) => I.variableId === (g == null ? void 0 : g.variableId) && I.instance.belongsToInstanceId === (g == null ? void 0 : g.instance.belongsToInstanceId)).sort(Ed).findIndex((I) => I.id === n.instance.id);
  },
  getInputValue(e) {
    var t, i;
    return ja(e, "value", "context"), e.selectionsOfVariable == null || e.selectionsOfVariable.length === 0 ? null : (i = (t = e.selectionsOfVariable[0]) == null ? void 0 : t.data) == null ? void 0 : i.inputValue;
  },
  isContextVariableAComponentVariable(e) {
    var t;
    return ((t = e.variable) == null ? void 0 : t.type) === Bn.Components;
  },
  splitContextIntoMultipleSubContexts(e) {
    return e.selectionsOfVariable.map((i) => ({
      variables: e.variables,
      variablesById: e.variablesById,
      values: e.values,
      valuesByVariableId: e.valuesByVariableId,
      allSelections: e.allSelections,
      variable: e.variable,
      variableHierarchies: e.variableHierarchies,
      selectionsByParentSelectionId: e.selectionsByParentSelectionId,
      inInstances: e.inInstances,
      selections: Ju(e.variableHierarchies, e.allSelections, i, e.selectionsByParentSelectionId, e.inInstances),
      selectionsOfVariable: [i],
      anchoringSelection: i
    }));
  }
};
function n$e(e, t) {
  if (e.selectionsOfVariable.length > 0) {
    const i = new Set(e.selectionsOfVariable.map((n) => n.id));
    return (n) => n.variableId == t && i.has(vl(n));
  }
  return (i) => i.variableId == t;
}
function UY(e) {
  return new Proxy(e, g$e);
}
const g$e = {
  get(e, t) {
    if (t === Symbol.toPrimitive || t === "valueOf")
      return (i) => js.getInputValue(e);
    if (t === "varId")
      return (i) => PY(e, i);
    if (t === "attrId")
      return (i) => js.attrId(e, i);
    if (t === "instances")
      return js.instances(e);
    if (t === "instanceIndex")
      return js.instanceIndex(e);
    if (t === Symbol.toStringTag)
      return Object.prototype.toString.call(js.getInputValue(e));
    throw typeof t == "symbol" ? new Error("unknown property of type symbol") : new Error(`unknown property ${t} context: ${e}`);
  }
}, W6 = (e) => {
  const t = js.splitContextIntoMultipleSubContexts(e).map((n) => UY(n)), i = () => {
    var n;
    throw p_e((n = e.variable) == null ? void 0 : n.label);
  };
  return new Proxy(t, {
    get(n, g, r) {
      var o;
      if (typeof g == "string") {
        if (/^(varId|attrId)$/g.test(g))
          return i;
        if (g === "instanceIndex")
          return i();
        const I = parseInt(g, 10);
        if (I < 0 || I >= t.length)
          throw LY("variable " + ((o = e.variable) == null ? void 0 : o.label) + ", index=" + I);
      }
      return Reflect.get(n, g, r);
    }
  });
};
function PY(e, t) {
  const i = js.varId(e, t);
  return js.isContextVariableAComponentVariable(i) ? i.selectionsOfVariable.length === 1 && V6(i, t) ? UY(i) : W6(i) : UY(i);
}
const r$e = [...Object.keys(PZ)], o$e = [
  // TODO this might be deprecated but I am not sure - CL
  "id",
  ...Object.keys(js)
], S6 = ce.memoize((e) => {
  L_e(e);
  const t = ce.isEmpty(e) ? "undefined" : e, i = `
      const { ${r$e.filter((g) => e.match(new RegExp(`\\b${g}\\b`))).join(", ")} } = staticFunctions;

      const { ${o$e.filter((g) => e.match(new RegExp(`\\b${g}\\b`))).join(", ")} } = contextFunctions;

      const result = ${t};
      return result?.valueOf();
  `, n = new Function("staticFunctions", "contextFunctions", i);
  return (g, r) => h_e(n(g, r));
});
function V6(e, t) {
  const i = m6(e.variablesById, e == null ? void 0 : e.anchoringSelection.variableId);
  return e != null && e.anchoringSelection.instance.isInstanceLauncher && i.push(e == null ? void 0 : e.anchoringSelection.variableId), i.find((g) => g === t);
}
function w6(e, t, i, n, g, r) {
  var o, I, s;
  try {
    const d = v6(e, t, i, n, [g]).find((C) => C.id === r.id);
    return {
      result: ((o = d == null ? void 0 : d.data) == null ? void 0 : o.inputValue) ?? 0,
      resultString: RQ(d, g),
      errorMessage: (s = (I = d == null ? void 0 : d.data) == null ? void 0 : I.error) == null ? void 0 : s.message
    };
  } catch (a) {
    return {
      result: 0,
      errorMessage: a.message
    };
  }
}
function v6(e, t, i, n, g) {
  var o;
  const r = G6(e, t, i, n);
  return (o = O_e((g ?? e).filter(yl))) == null || o.forEach((I) => I$e(r, I)), r.selections;
}
function I$e(e, t) {
  const i = ah(t), n = e.selections.filter((r) => r.variableId == t.id);
  if (n.length == 0)
    return;
  const g = e.valuesByVariableId[t.id];
  n.forEach((r) => {
    r.data = r.data ?? {};
    const o = Ju(e.variableHierarchies, e.allSelections, r, e.selectionsByParentSelectionId, e.inInstances), I = y6({
      ...e,
      selections: o,
      anchoringSelection: r
    });
    if (i)
      try {
        const a = S6(i)(PZ, I);
        if (r.data.inputValue = a ?? 0, ce.isNumber(a) === !1 || isNaN(a))
          return;
        const d = th(a, g, Od(t));
        (d == null ? void 0 : d.input) === a ? (r.valueId = d.value.id, r.interval = d.value.data, r.data.error = void 0) : d ? r.data.error = {
          name: "Invalid Value",
          message: i,
          expression: i,
          value: a,
          nearestValue: d.input
        } : r.data.error = {
          name: "No matching value found",
          message: i,
          expression: i,
          value: a
        };
      } catch (s) {
        r.data.error = {
          name: "Expression Error",
          message: s,
          expression: i
        }, console.error(s);
      }
  });
}
function D1(e, t, i, n, g, r = Dt) {
  const o = G6(e, t, i, n), I = {
    ...o,
    selections: Ju(o.variableHierarchies, o.allSelections, r, o.selectionsByParentSelectionId, o.inInstances),
    anchoringSelection: r
  }, s = y6(I);
  try {
    const d = S6(g)(PZ, s) || 0;
    return {
      result: d,
      resultString: XQ(d, o.variablesById[r == null ? void 0 : r.variableId])
    };
  } catch (a) {
    return {
      result: 0,
      errorMessage: a.message
    };
  }
}
function l$e(e, t) {
  return t.map((i) => yl(e[i.variableId]) ? {
    ...i,
    data: {
      ...i.data
    }
  } : i);
}
const R3 = (e, t) => {
  const i = ce.cloneDeep(e);
  return i.settings.templateOptions.expression = t, i;
};
function s$e(e) {
  const t = _(vg), i = _(wg), n = _(tI), g = _(Dg);
  if (!e.variable)
    return D1(i, n, g.variables.variableHierarchies, t, e.expression, e.anchoringSelection);
  const r = [...i], o = r.findIndex((s) => {
    var a;
    return s.id == ((a = e.variable) == null ? void 0 : a.id);
  });
  o >= 0 && (r[o] = R3(i[o], e.expression));
  const I = R3(e.variable, e.expression);
  return w6(r, n, g.variables.variableHierarchies, t, I, e.anchoringSelection);
}
function a$e(e) {
  const {
    t
  } = ii(), {
    resultString: i,
    errorMessage: n
  } = s$e(e);
  e.onError && e.onError(n);
  const g = _((I) => $u(I, e.anchoringSelection)), r = _(LD), o = " " + g.map((I) => {
    var s;
    return I.valueId ? (s = r[I == null ? void 0 : I.valueId]) == null ? void 0 : s.label : "";
  }).join(" > ");
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(UB, { "data-cy": "expressionEngineResult", children: t("Ergebnis") + (o.trim() && o) + ": " + i }),
    (e.showError ?? !0) && n && /* @__PURE__ */ p(UB, { "data-cy": "expressionEngineError", sx: {
      color: "red"
    }, children: "" + n })
  ] });
}
function R6({
  expression: e,
  anchoringSelections: t,
  showExpression: i,
  onError: n,
  gutterBottom: g
}) {
  const r = _(wg), o = ce.isEmpty(e), I = je(() => o ? "" : Z6(e, r), [e, r]);
  return /* @__PURE__ */ ge(fe, { component: "div", "data-cy": "expressionEditorPreview", sx: {
    display: "grid",
    gridTemplateColumns: "auto",
    gridAutoFlow: "row",
    gap: 2
  }, children: [
    !!i && /* @__PURE__ */ p(c$e, { emptyExpression: o, formula: I }),
    !o && /* @__PURE__ */ p(d$e, { selections: t, expression: e, onError: n, marginBottom: g })
  ] });
}
const c$e = (e) => {
  const {
    t
  } = ii();
  return e.emptyExpression ? /* @__PURE__ */ p(UB, { "data-cy": "noExpresionMessage", children: t("Keine Formel eingegeben") }) : /* @__PURE__ */ p(fe, { "data-cy": "expression", component: "div", sx: {
    wordBreak: "break-word"
  }, children: /* @__PURE__ */ p(Ne, { children: t("Formel: ") + e.formula }) });
}, d$e = (e) => {
  var t;
  return (t = e.selections) != null && t.length ? /* @__PURE__ */ p(fe, { component: "div", sx: {
    display: "grid",
    gridTemplateColumns: "auto",
    gridAutoFlow: "row",
    gap: 1,
    marginBottom: e.marginBottom ? 2 : 0,
    overflowY: "auto",
    maxHeight: "200px"
  }, children: e.selections.map((i, n, g) => /* @__PURE__ */ p(a$e, { expression: e.expression, anchoringSelection: i, showError: n === g.length - 1, onError: e.onError }, i.id)) }) : /* @__PURE__ */ p(C$e, {});
}, C$e = () => {
  const {
    t: e
  } = ii();
  return /* @__PURE__ */ p(UB, { "data-cy": "notEnoughSelectionsToEvaluateExpressionMessage", children: e("Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.") });
}, cJ = "app", X6 = () => {
  const t = window.location.href.split("://")[1].split("/"), i = t[1] === "test" || t[1] === "demo", n = t.slice(0, i ? 2 : 1).join("/"), g = t.slice(i ? 2 : 1), r = g[0] && g[0] !== "#" && !g[0].includes("?") ? g[0] : "", o = g.slice(r ? 1 : 0), I = o.slice(o[0] === "#" ? 1 : 0).join("/");
  return {
    /** The base host, including /test if we are on test */
    host: n,
    /** The current type of the app/bundle loaded. E.g. veranda or defaultApp.
     * This hook also already supports root mounted default app. Just set defaultApp to ''.
     * */
    currentAppType: r || cJ,
    /** The internal path we are currently on */
    path: I,
    /** Are we on test? */
    test: i
  };
}, H6 = () => window.location.hash.includes("/edit/"), u$e = () => window.location.hash.includes("/edit/preview"), dJ = Se.createContext({
  extensions: {},
  contexts: []
}), OZ = () => Hn(dJ), ZJt = (e) => /* @__PURE__ */ p(dJ.Provider, { value: {
  extensions: e.extensions,
  additionalDynamicSettings: e.additionalDynamicSettings,
  contexts: e.contexts || []
}, children: e.children });
var lc = /* @__PURE__ */ ((e) => (e.STRING = "string", e.NUMBER = "number", e.TRANSLATION = "translation", e.BOOLEAN = "boolean", e.IMAGE = "image", e.ARRAY = "array", e))(lc || {}), Ii = /* @__PURE__ */ ((e) => (e.COMPONENT_BREADCRUMBS_BACK = "translation_componentBreadcrumbsBack", e.ORDER_DIALOG_OVERVIEW = "translation_orderDialogOverview", e.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE = "translation_selectionPrice", e.ORDER_DIALOG_OVERVIEW_STEP = "translation_step", e.ORDER_DIALOG_OVERVIEW_VARIABLE = "translation_variable", e.ORDER_DIALOG_OVERVIEW_SELECTION = "translation_selection", e.ORDER_DIALOG_OVERVIEW_TOTALPRICE = "translation_totalPrice", e.ORDER_DIALOG_OVERVIEW_PRICE = "translation_price", e.ORDER_DIALOG_OVERVIEW_PRICEINFO = "translation_priceInformation", e.ORDER_DIALOG_DATA = "translation_orderDialogData", e.ORDER_DIALOG_CONFIRMATION = "translation_orderDialogConfirmation", e.NAVBAR_BACK = "translation_navbarBack", e.NAVBAR_NEXT = "translation_navbarNext", e.AR_BUTTON = "translation_ar_button", e.AR_PLACEMENT = "ar_object_placement", e.FULLSCREEN_BUTTON = "translation_fullscreen_button", e.CANCEL = "translation_cancel", e.OK = "translation_ok", e.CLOSE = "translation_close", e))(Ii || {});
const A$e = (e) => [
  {
    key: "translation_componentBreadcrumbsBack",
    valueType: "translation",
    defaultValue: e("Zurück")
  },
  {
    key: "translation_orderDialogOverview",
    valueType: "translation",
    defaultValue: e("Übersicht")
  },
  {
    key: "translation_selectionPrice",
    valueType: "translation",
    defaultValue: e("Auswahlpreise")
  },
  {
    key: "translation_step",
    valueType: "translation",
    defaultValue: e("Schritt")
  },
  {
    key: "translation_variable",
    valueType: "translation",
    defaultValue: e("Merkmal")
  },
  {
    key: "translation_selection",
    valueType: "translation",
    defaultValue: e("Auswahl")
  },
  {
    key: "translation_totalPrice",
    valueType: "translation",
    defaultValue: e("Gesamtpreis")
  },
  {
    key: "translation_price",
    valueType: "translation",
    defaultValue: e("Preis")
  },
  {
    key: "translation_priceInformation",
    valueType: "translation",
    defaultValue: e("Preis Information")
  },
  {
    key: "translation_orderDialogData",
    valueType: "translation",
    defaultValue: e("Persönliche Daten")
  },
  {
    key: "translation_orderDialogConfirmation",
    valueType: "translation",
    defaultValue: e("Bestätigung")
  },
  {
    key: "translation_navbarBack",
    valueType: "translation",
    defaultValue: e("Zurück")
  },
  {
    key: "translation_navbarNext",
    valueType: "translation",
    defaultValue: e("Weiter")
  },
  {
    key: "translation_ar_button",
    valueType: "translation",
    defaultValue: e("In AR ansehen"),
    label: "AR Button Text"
  },
  {
    key: "ar_object_placement",
    valueType: "boolean",
    defaultValue: !1,
    label: "Vertikale Platzierung zulassen?"
  },
  {
    key: "translation_fullscreen_button",
    valueType: "translation",
    defaultValue: e("Vollbildmodus")
  },
  {
    key: "translation_cancel",
    valueType: "translation",
    defaultValue: e("Abbrechen")
  },
  {
    key: "translation_ok",
    valueType: "translation",
    defaultValue: e("OK")
  },
  {
    key: "translation_close",
    valueType: "translation",
    defaultValue: e("Schliessen")
  },
  // MP Popup texts
  {
    key: "translation_mp_popup_add",
    valueType: "translation",
    defaultValue: e("Hinzufügen"),
    label: "Hinzufügen"
  },
  {
    key: "translation_mp_popup_search",
    valueType: "translation",
    defaultValue: e("Komponenten suchen"),
    label: "Suche"
  },
  {
    key: "translation_mp_popup_not_grouped",
    valueType: "translation",
    defaultValue: e("Nicht Gruppiert"),
    label: "Nicht gruppiert"
  },
  {
    key: "translation_mp_popup_description",
    valueType: "translation",
    defaultValue: e("Komponenten"),
    label: "Beschreibung"
  },
  {
    key: "translation_mp_popup_title",
    valueType: "translation",
    defaultValue: e("Komponenten hinzufügen"),
    label: "Titel"
  },
  {
    key: "toggle_mp_dialog_component_cols",
    valueType: "number",
    label: "Anzahl an Komponenten pro Zeile",
    defaultValue: 4,
    min: 1
  },
  {
    key: "toggle_mp_dialog_component_display",
    valueType: "boolean",
    label: "Werte vertikal ausrichten",
    defaultValue: !0
  },
  {
    key: "toggle_mp_dialog_hide_searchbar",
    valueType: "boolean",
    label: "Suchfeld ausblenden?",
    defaultValue: !1
  },
  {
    key: "string_mp_dialog_size",
    valueType: "string",
    label: "Modalgröße",
    defaultValue: e("xl")
  },
  // warning texts
  {
    key: "translation_warning_number",
    valueType: "translation",
    defaultValue: e("Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ")
  },
  {
    key: "translation_warning_invalid_selection",
    valueType: "translation",
    defaultValue: e("Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:")
  },
  {
    key: "translation_warning_invalid_selection_alternative",
    valueType: "translation",
    defaultValue: e("Bei Auswahl wird eine Alternative berechnet!")
  },
  // Group Actions
  {
    key: "translation_group_multiple_actions",
    valueType: "translation",
    defaultValue: e("Bestätigen")
  },
  {
    key: "translation_group_actions_add_item",
    valueType: "translation",
    defaultValue: e("Produkt hinzufügen")
  },
  {
    key: "translation_group_actions_continue",
    valueType: "translation",
    defaultValue: e("Weiter")
  },
  {
    key: "translation_group_actions_dialog_title",
    valueType: "translation",
    defaultValue: e("Produkt erfolgreich konfiguriert")
  },
  {
    key: "translation_group_actions_dialog_description",
    valueType: "translation",
    textarea: !0,
    defaultValue: e("Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?")
  },
  {
    key: "string_group_actions_dialog_size",
    valueType: "string",
    label: "Modalgröße",
    defaultValue: e("xl")
  },
  {
    key: "translation_group_actions_dialog_pick_item",
    valueType: "translation",
    defaultValue: e("Neues Produkt auswählen")
  },
  {
    key: "translation_group_actions_dialog_add_item",
    valueType: "translation",
    defaultValue: e("Neues Produkt hinzufügen")
  },
  //invalid rule modal
  {
    key: "translation_invalid_rule_modale_custom_error",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.'),
    label: e("Meldung bei Zurücksetzen einer ungültigen Auswahl") + " (Placeholder: value, variable, conflictValue0, conflictVariable0)"
  },
  {
    key: "translation_invalid_rule_modal_1_conflict",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).'),
    label: e("Meldung bei Auftreten eines Konflikts") + " (Placeholder: value, variable, conflictValue0, conflictVariable0)"
  },
  {
    key: "translation_invalid_rule_modal_2_conflict",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).'),
    label: e("Meldung bei Auftreten von zwei Konflikten") + " (Placeholder: value, variable, conflictValue[0,1], conflictVariable[0,1])"
  },
  {
    key: "translation_invalid_rule_modal_3_conflict",
    valueType: "translation",
    textarea: !0,
    label: e("Meldung bei Auftreten von drei oder mehr Konflikten") + " (Placeholder: value, variable, conflictValue[0,1,2], conflictVariable[0,1,2])",
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).')
  },
  {
    key: "translation_invalid_rule_modal_other_conflict",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.'),
    label: e("Konfliktmeldung") + " (Placeholder: value, variable)"
  },
  {
    key: "translation_invalid_rule_modal_changes_needed",
    valueType: "translation",
    defaultValue: e("Anpassung nötig")
  },
  {
    key: "translation_invalid_rule_modal_changes_will_be_made",
    valueType: "translation",
    defaultValue: e("Stattdessen werden folgende Auswahlen angepasst:")
  },
  {
    key: "translation_invalid_rule_modal_changes_will_become",
    valueType: "translation",
    defaultValue: e("wird zu")
  },
  {
    key: "translation_invalid_rule_modal_will_be_deleted",
    valueType: "translation",
    defaultValue: e("wird entfernt")
  },
  {
    key: "translation_invalid_rule_modal_custom_text",
    valueType: "translation",
    label: e("Optionaler weiterer Hinweistext:"),
    defaultValue: ""
  },
  {
    key: "translation_SocialShare_Facebook",
    valueType: "translation",
    defaultValue: e("Auf Facebook teilen")
  },
  {
    key: "translation_SocialShare_Twitter",
    valueType: "translation",
    defaultValue: e("Auf Twitter teilen")
  },
  {
    key: "translation_SocialShare_LinkedIn",
    valueType: "translation",
    defaultValue: e("Auf LinkedIn teilen")
  },
  {
    key: "translation_AR_Title",
    valueType: "translation",
    label: e("Modal Titel") + " (Desktop)",
    defaultValue: e("Desktop Gerät erkannt")
  },
  {
    key: "translation_AR_Body",
    valueType: "translation",
    textarea: !0,
    label: e("Modal Text") + " (Desktop)",
    defaultValue: e("Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:")
  },
  {
    key: "translation_AR_Mobile_Title",
    valueType: "translation",
    label: e("Modal Titel") + " (Mobile, Placeholder: device)",
    defaultValue: e("Mobiles {{device}}-Gerät erkannt")
  },
  {
    key: "translation_AR_Mobile_Progress_Export",
    valueType: "translation",
    label: e("Fortschrittsanzeige 3D-Objekt"),
    defaultValue: e("Export des 3D-Objekts")
  },
  {
    key: "translation_AR_Mobile_Progress_File",
    valueType: "translation",
    label: e("Fortschrittsanzeige AR-Datei"),
    defaultValue: e("Bereitstellen der AR-Datei")
  },
  {
    key: "translation_AR_Mobile_Progress_Device",
    valueType: "translation",
    label: e("Fortschrittsanzeige System") + " (Placeholder: device)",
    defaultValue: e("{{device}}-AR-System einrichten")
  },
  {
    key: "order_modal_pos",
    valueType: "translation",
    label: e("Positionszeile"),
    defaultValue: e("Pos.")
  },
  {
    key: "order_modal_articleNo",
    valueType: "translation",
    label: e("Artikelnummer Spalte"),
    defaultValue: e("Nummer")
  },
  {
    key: "order_modal_article",
    valueType: "translation",
    label: e("Artikel Spalte"),
    defaultValue: e("Artikel")
  },
  {
    key: "order_modal_articlePrice",
    valueType: "translation",
    label: e("Artikelpreis Spalte"),
    defaultValue: e("Preis")
  },
  {
    key: "order_modal_articleAmount",
    valueType: "translation",
    label: e("Artikelmenge Spalte"),
    defaultValue: e("Menge")
  },
  {
    key: "order_modal_articleCount",
    valueType: "translation",
    label: e("Artikelanzahl Spalte"),
    defaultValue: e("Anzahl")
  },
  {
    key: "order_modal_positionPrice",
    valueType: "translation",
    label: e("Positionspreis Spalte"),
    defaultValue: e("Positionspreis")
  },
  {
    key: "order_modal_priceDetails",
    valueType: "translation",
    label: e("Hilfetext Preisdetails"),
    defaultValue: e("Preisdetails anzeigen")
  },
  {
    key: "appload_versionmismatch_title",
    valueType: "translation",
    label: e("Titel bei Versions-Konflikt"),
    defaultValue: e("Konfigurator wurde aktualisiert")
  },
  {
    key: "appload_versionmismatch_text",
    valueType: "translation",
    label: e("Text bei Versions-Konflikt"),
    defaultValue: e("Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?")
  },
  {
    key: "appload_versionmismatch_old",
    valueType: "translation",
    label: e("Alte Version"),
    defaultValue: e("Alte Version")
  },
  {
    key: "appload_versionmismatch_new",
    valueType: "translation",
    label: e("Aktuelle Version"),
    defaultValue: e("Aktuelle Version")
  }
], J1 = () => {
  const {
    t: e
  } = ii(), t = _(Bje), i = OZ().additionalDynamicSettings;
  return je(() => [...i || [], ...A$e(e), ...t.map((n) => ({
    key: n.key,
    valueType: "translation",
    defaultValue: n.defaultValue
  }))], [t, i, e]);
}, fJt = (e) => (t) => {
  if (typeof t != "string")
    return [!1, "Please make sure the type is set to array."];
  const i = t.split(", ");
  return i.length !== e || !i.every((n) => n && isFinite(Number(n))) ? [!1, `Not a vector of length ${e}. Please enter your vector like this: ${new Array(e).fill(0).map((g, r) => r + 1).join(", ")}`] : [!0, ""];
}, b$e = (e) => {
  if (typeof e != "string")
    return [!1, "Not a string"];
  const i = e.split(", ").every((g) => g !== "");
  return [i, i ? "" : "Please enter your vector like this: 1, 2, true, test"];
}, CJ = Pt([(e) => e.metadata.articles], (e) => (e ?? []).slice().sort(Ed)), m$e = Pt(CJ, (e) => Ni(e)), k6 = Pt([CJ, (e, t) => t], (e, t) => e.filter((i) => i.appId === t)), QZ = (e) => ce.get(e, ["metadata", ce.lowerCase("materials")]), GJt = (e) => (t) => QZ(t).find((i) => i.id == e), h$e = me.curry((e, t) => me.flow(QZ, me.filter((i) => i.appId == e))(t)), ch = (e) => e.metadata.models || [], p$e = (e) => (t) => ch(t).find((i) => i.id == e), B$e = me.curry((e, t) => me.flow(ch, me.filter((i) => i.appId == e))(t)), Z$e = (e) => ch(e).filter((t) => t.type === "dynamic"), f$e = (e) => Z$e(e).filter((t) => rZ().find((i) => i.type === t.dynamicModelKey && i.disabledForAR)), uJ = (e) => ce.get(e, ["metadata", ce.lowerCase("prices")]), F6 = Pt([uJ], (e) => ce.groupBy(e, (t) => t.appId));
Pt([F6, (e, t) => t], (e, t) => e[t] || []);
const G$e = Pt([uJ], (e) => ce.groupBy(e, (t) => t.articleId)), Y6 = Pt([G$e, (e, t) => t], (e, t) => e[t] || []), x6 = (e) => {
  var t;
  return (t = e == null ? void 0 : e.layout) == null ? void 0 : t.sidebarPosition;
}, K1 = (e, t) => !!t.find((i) => i.id === e.id), mr = (e) => (e == null ? void 0 : e.columns) || [], yJt = (e, t) => mr(e).find((i) => i.id == t), WJt = (e) => me.flow(mr, me.filter(KQ))(e), SJt = (e) => me.flow(mr, me.filter(LQ))(e), VJt = (e) => me.flow(mr, me.filter(TQ))(e), wJt = (e) => me.flow(mr, me.filter(MQ))(e), vJt = (e) => me.flow(mr, me.filter(UQ))(e), RJt = (e) => me.flow(mr, me.filter(PQ))(e), XJt = (e) => me.flow(mr, me.filter(zQ))(e), HJt = (e) => me.flow(mr, me.filter(OQ))(e), kJt = (e) => me.flow(mr, me.filter(yGe))(e), FJt = (e) => me.flow(mr, me.filter(EQ))(e), YJt = (e) => me.flow(mr, me.filter(VD))(e), xJt = (e) => me.flow(mr, me.filter(NQ))(e), DJt = (e) => me.flow(mr, me.filter(GGe))(e), JJt = (e) => me.flow(mr, me.filter(m1))(e), KJt = (e) => me.flow(mr, me.filter(QQ))(e), y$e = (e) => me.flow(mr, me.filter(ua))(e), nI = (e) => (t) => me.flow(mr, me.any(e))(t), EJt = nI(KQ), NJt = nI(EQ), LJt = nI(VD), TJt = nI(NQ), MJt = nI(LQ), UJt = nI(TQ), PJt = nI(MQ), zJt = nI(UQ), OJt = nI(PQ), QJt = nI(zQ), jJt = nI(OQ), _Jt = nI(QQ), $Jt = nI(m1), qJt = nI(ua), D6 = (e) => me.flow(y$e, me.map((t) => t.targetId))(e), AJ = (e, t) => wg(e).filter((i) => i.groupId == t).sort(Ku), W$e = (e, t) => (i) => AJ(i, e).filter(Dfe).filter((n) => B1(n, t)(i) === null), bJ = Pt([wg], (e) => ce.groupBy(e, (t) => t.groupId)), J6 = Pt([bJ, (e, t) => t], (e, t) => e[t] || []), K6 = [], ya = (e) => e.metadata.ruleItems ?? K6;
Pt(ya, (e) => Ni(e));
const S$e = Pt([ya], (e) => ce.mapValues(ce.groupBy(e, (t) => t.ruleId), (t) => t.sort(Ku))), eKt = (e) => (t) => {
  var i;
  return ((i = S$e(t)) == null ? void 0 : i[e]) ?? K6;
}, V$e = (e) => (t) => ya(t).filter((i) => ce.some(i.values, (n) => Qfe(n) ? n === e : jfe(n) ? n.includes(e) : QS(n) ? n.modelId == e : (_fe(n), !1))), w$e = Pt(ya, (e) => e.filter((t) => Object.values(t.values).find(yD)));
Pt(w$e, jQ, (e, t) => e.map((i) => t[i.ruleId].columns.filter((g) => m1(g)).map((g) => g.targetId)).flat());
const v$e = (e) => (t) => V$e(e)(t).flatMap((i) => {
  if (Object.values(i.values).find(yD))
    return wD(i.ruleId)(t).columns.filter(m1).map((o) => o.targetId);
}).filter(Boolean), E6 = Pt(ya, (e) => e.flatMap((t) => Object.values(t.values).filter(HQ))), tKt = {
  USD: "USD",
  CAD: "CAD",
  AUD: "AUD",
  EUR: "EUR",
  GBP: "GBP",
  JPY: "JPY",
  NZD: "NZD",
  HKD: "HKD",
  SGD: "SGD",
  DKK: "DKK"
}, Ac = {
  fixed: "fixed",
  surcharge: "surcharge",
  surchargeHidden: "surchargeHidden",
  surchargeHiddenMult: "surchargeHiddenMult"
}, E1 = (e) => e.bom.bom, eA = Pt([E1, (e, t) => t], (e, t) => {
  const i = e.filter((A, m, h) => !t || t(A, m, h)), n = i.filter((A) => A.price.type == Ac.fixed), g = i.filter((A) => A.price.type == Ac.surcharge), r = i.filter((A) => A.price.type == Ac.surchargeHidden), o = i.filter((A) => A.price.type == Ac.surchargeHiddenMult), I = sW(n, (A) => gs(A.price.price * A.qty * DL(A.amount))), s = sW(r, (A) => A.price.price * A.qty) / 100, a = (A) => {
    let m = gs(gs(A) * (1 + s));
    return o.forEach((h) => {
      m = gs(m * (1 + h.price.price * h.qty / 100));
    }), m;
  }, d = n.map((A) => ({
    ...A,
    priceUnit: a(A.price.price),
    priceTotal: gs(a(A.price.price) * A.qty * DL(A.amount))
  })), C = g.map((A) => ({
    ...A,
    priceUnit: gs(A.price.price * A.qty / 100 * I),
    priceTotal: gs(A.price.price * A.qty / 100 * I * A.qty)
  })), u = gs(sW(d, (A) => A.priceTotal) + sW(C, (A) => A.priceTotal));
  return {
    articleLines: d,
    surchargeLines: C,
    priceTotal: u
  };
}), N1 = (e, t) => (i) => {
  if (!t)
    return;
  const n = me.flow(vg, me.find(Lfe(e, t)))(i);
  if (n)
    return me.flow(tI, me.find(
      (g) => (
        // JVI 27.5.: Bei Dropdowns ist nun Value.value==null. Bei Zahlenvariablen ohne Intervalle ist selection.valueId null.
        // Dann wird hier ein Dropdown-Wert für eine Zahlenvariable geliefert, wenn nicht auf value.value!=null geprüft wird.
        g.id == (n == null ? void 0 : n.valueId)
      )
      // ||
      // (value.value != null && value.value == selection?.valueId)
    ))(i);
}, nV = (e, t) => (i) => {
  const n = t;
  return eA(i, (g) => g.price.type !== Ac.fixed || g.articleAction.variableId === e && (!n.instance.id || g.articleAction.anchoringSelection.instance.id == n.instance.id));
}, R$e = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR"
}), Wa = (e) => R$e, iKt = (e, t) => (i) => {
  var m;
  const n = /* @__PURE__ */ new Date(), g = Ai(i), r = i.common.dealerData, o = (m = r.apps) == null ? void 0 : m.find((h) => h.appId == (g == null ? void 0 : g.id)), I = (r == null ? void 0 : r.discount) || 0, s = (r == null ? void 0 : r.surcharge) || 0, a = (o == null ? void 0 : o.discount) != 0 ? o == null ? void 0 : o.discount : null, d = (o == null ? void 0 : o.surcharge) != 0 ? o == null ? void 0 : o.surcharge : null, C = a ?? I, u = d ?? s, A = Y6(i, e).filter((h) => !h.displayOnly && (h.fromDate == null || new Date(h.fromDate) <= n) && (h.toDate == null || new Date(h.toDate) >= n) && (h.fromQty == null || h.fromQty == 0 || h.fromQty <= t) && (h.toQty == null || h.toQty == 0 || h.toQty >= t)).sort((h, B) => h.sort - B.sort).map((h) => ({
    ...h,
    price: h.price * (1 - C / 100) * (1 + u / 100)
  }));
  return A.length == 0 ? {
    price: 0,
    type: Ac.fixed
  } : A[0];
}, X$e = (e, t) => (i) => {
  var r;
  const n = eA(i, (o, I, s) => e(o, I, s) || (t ? !1 : o.price.type != Ac.fixed));
  return ce.sum((r = n == null ? void 0 : n.articleLines) == null ? void 0 : r.map((o) => t ? o.price.price : o.priceTotal));
}, iC = (e) => {
  let t = eA(e).priceTotal;
  return t = ms("setPrice", t), t;
}, N6 = (e) => (t) => {
  if (!e.id)
    return iC(t);
  const i = L6(e)(t);
  return (i == null ? void 0 : i.priceTotal) || 0;
}, H$e = (e, t, i) => (n) => {
  var o;
  const g = L6(t, e, i)(n);
  return ce.sum((o = g == null ? void 0 : g.articleLines) == null ? void 0 : o.map((I) => I.priceTotal));
}, L6 = (e, t, i) => (n) => {
  const g = e;
  return g.id ? eA(n, (o, I, s) => o.articleAction.anchoringSelection.instance.belongsToInstanceId == g.id || o.articleAction.anchoringSelection.instance.id == g.id && (!t || t(o, I, s)) || !i && o.price.type != Ac.fixed) : null;
}, sW = (e, t) => ce.reduce(e, (i, n) => i + t(n), 0), gs = (e) => Math.round(e * 100) / 100, T6 = (e) => (t, i) => {
  const n = to(e).slice().sort(Ku), g = wg(e), r = Cje(e);
  return n.filter((I) => I.parentId == t).flatMap((I) => g.filter((s) => !!s && s.groupId == I.id).sort(Ku).flatMap((s) => r.filter((a) => s.id == a.variableId && (a.instance.id == i || a.instance.id == a.id)).map((a) => ({
    v: s,
    s: a
  }))).filter(({
    s
  }) => s != null).map(({
    v: s,
    s: a
  }, d) => k$e(e)(I, d, s, a)));
}, k$e = (e) => (t, i, n, g) => {
  const {
    priceTotal: r,
    articleLines: o,
    surchargeLines: I
  } = nV(n.id, g)(e), s = kZ(n) ? T6(e)(n.id, g.id) : null, a = N6(g)(e), d = s != null && s.length ? a : r;
  return {
    group: t,
    index: i,
    variable: n,
    selectionLabel: String(D$e(g)(e)),
    selection: g,
    bom: {
      articleLines: o,
      surchargeLines: I,
      priceTotal: d
    },
    subVariables: s
  };
}, M6 = (e) => T6(e)(null, "");
function F$e(e, t) {
  return e.filter((i) => NGe(i.variable, i.selection)(t));
}
function U6(e, t) {
  return F$e(e, t).map((i) => i.subVariables ? {
    ...i,
    subVariables: U6(i.subVariables, t)
  } : i);
}
function Y$e(e) {
  const t = M6(e);
  return U6(t, e);
}
const nKt = (e) => (t) => me.flow(
  //
  wD(e),
  D6,
  (i) => ij(i)(t)
)(t), x$e = (e) => {
  const t = Wa(), i = iC(e);
  return t.format(i);
}, D$e = (e) => (t) => {
  var r, o, I, s;
  if (!e)
    return null;
  if (nh(e)) {
    const a = Go(e.variableId)(t);
    return Number((r = e.data) == null ? void 0 : r.inputValue).toFixed(hi(a).digits || 0);
  }
  const i = Go(e.variableId)(t);
  if (ih(i))
    return ((o = e == null ? void 0 : e.data) == null ? void 0 : o.inputText) || "";
  const g = tI(t).find((a) => a.id == e.valueId);
  return (g == null ? void 0 : g.label) || ((I = e.data) == null ? void 0 : I.inputText) || ((s = e.data) == null ? void 0 : s.inputValue) || "";
}, P6 = (e) => me.flow(lh(e), me.find((t) => t.key === QB)), gKt = (e) => to(e).filter((i) => i.parentId == null), nC = Pt([to, (e, t) => t], (e, t) => {
  const i = t.instance.belongsToVariableId;
  return e.filter((n) => n.parentId == i);
}), z6 = Pt([bJ, (e, t) => nC(e, t), (e, t) => t], (e, t) => t.flatMap((i) => e[i.id] || [])), O6 = Pt([Dg, Jg, (e, t) => t, (e, t) => z6(e, t)], (e, t, i, n) => !e || !t ? (console.warn("Rule engine not initialized!"), {}) : n.reduce((g, r) => {
  const o = u1(r, e, t.state, i.id);
  return g[r.id] = o, g;
}, {})), J$e = (e, t, i) => e.filter((n) => J6(t, n.id).some((r) => B1(r, i.id)(t) === null)), jZ = (e, t) => {
  const i = nC(e, t);
  return J$e(i, e, t);
}, L1 = Pt([(e, t) => nC(e, t), O6, bJ], (e, t, i) => e.filter((n) => (i[n.id] || []).every((r) => t[r.id] !== null))), Q6 = Pt([ej, Za, (e, t) => t, vg], (e, t, i, n) => {
  const g = Zc(n, i);
  return ce.uniqBy([i, ...g].flatMap((o) => (e[o.id] ?? []).map((s) => t[s])), (o) => o.id);
}), X3 = [], mJ = Pt([(e, t) => t ? Q6(e, t) : X3, (e, t) => t ? jZ(e, t) : X3], (e, t) => Object.values(e.reduce((n, g) => {
  const r = t.find((o) => !!g && o.id === g.groupId);
  return r && !n[r.id] && (n[r.id] = r), n;
}, {}))), j6 = (e) => (t) => !!jZ(t, e).find((g) => g.parentId === e.variableId), _6 = (e) => (t) => {
  const i = $6(t), n = hr(t);
  if (!i || n)
    return !0;
  const g = vD(t, e.id);
  if (!g)
    return !0;
  const r = jZ(t, g), o = mJ(t, g), I = ce.maxBy(o, (A) => A.sort), s = I ? r.findIndex((A) => A.id === I.id) : 0, a = fa(t, g), d = Math.max(r.findIndex((A) => A.id === a), 0), C = ce.clamp(Math.max(s, d) + 1, 0, r.length);
  return r.findIndex((A) => A.id === e.id) <= C;
}, rKt = (e) => (t) => {
  if (!e)
    return [];
  const i = to(t), n = Ni(i), g = me.find((a) => a.parentId == e, i), r = wg(t), o = Ni(r);
  let I, s = [g];
  for (; e; ) {
    I = o[e];
    const a = n[I.groupId];
    s = [a, ...s], e = a.parentId;
  }
  return s;
}, K$e = Pt([Za, (e, t) => t], (e, t) => {
  if (!t)
    return [];
  let i = [];
  for (; t; ) {
    const n = e[t];
    i = [n, ...i], t = n == null ? void 0 : n.parentId;
  }
  return i;
}), E$e = (e) => {
  const t = Ai(e);
  return x6(t);
}, $6 = (e) => {
  var i, n;
  const t = Ai(e);
  return ((n = (i = t == null ? void 0 : t.settings) == null ? void 0 : i.design) == null ? void 0 : n.revealGroups) || !1;
}, q6 = (e) => {
  var i, n;
  const t = Ai(e);
  return ((n = (i = t == null ? void 0 : t.settings) == null ? void 0 : i.design) == null ? void 0 : n.addCheckMarkToVisitedTabs) || !1;
}, oKt = (e) => (t) => {
  const i = e.reduce(
    // @ts-ignore
    (n, g) => [...n, ...D6(g)],
    []
  );
  return ij(i)(t);
}, dh = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.configurator) != null && t.app);
}, N$e = Pt([rh, JZ, E6], (e, t, i) => {
  const n = t[e.variableId], g = Ni(n);
  return i.some((r) => g[r.valueId]);
}), L$e = (e) => (t) => {
  const i = Go(e)(t);
  return i ? Ba(i.groupId)(t) : void 0;
}, T1 = Pt([rh, vg, JZ, N$e], (e, t, i, n) => {
  const g = t.filter((r) => r.variableId === e.variableId);
  if (n) {
    const r = i[e.variableId], o = Ni(r);
    g.sort((I, s) => {
      if (I.valueId && s.valueId) {
        const a = o[I.valueId], d = o[s.valueId];
        return ((a == null ? void 0 : a.sort) ?? 0) - ((d == null ? void 0 : d.sort) ?? 0) || (I.sort ?? 0) - (s.sort ?? 0);
      }
      return (I.sort ?? 0) - (s.sort ?? 0);
    });
  } else
    g.sort((r, o) => (r.sort ?? 0) - (o.sort ?? 0));
  return g;
}), e7 = Pt([(e, t) => t, qQ, (e, t) => z6(e, t)], (e, t, i) => i.reduce((n, g) => {
  var o;
  const r = (o = t[e.id]) == null ? void 0 : o[g.id];
  return r && r.forEach((I) => {
    n[I.value.id] = I;
  }), n;
}, {})), IKt = Pt([Dg], (e) => {
  var t, i;
  return Ni(((i = (t = e == null ? void 0 : e.values) == null ? void 0 : t.flat) == null ? void 0 : i.all) ?? []);
}), t7 = Pt([(e, t) => t, (e, t) => e7(e, t), (e, t) => Q6(e, t), Dg, Jg], (e, t, i, n, g) => {
  if (!n)
    return {};
  const r = Ni(i);
  return ce.mapValues(t, (o) => {
    const I = o.conflicts.filter((s) => r[s.variableId]);
    if (!(!n || !g))
      return FQ(I, n, g, o.value, e);
  });
}), lKt = (e, t) => (i) => gje(i).filter((g) => {
  var r, o;
  return ((r = g.ruleColumn) == null ? void 0 : r.id) === e && ((o = g.ruleItem) == null ? void 0 : o.id) === t;
}), T$e = Pt([(e, t, i) => e7(e, i), (e, t, i) => t7(e, i), (e, t) => t], (e, t, i) => (n) => i.hideInvalidUntouchedOptions ? !e[n.id] : i.hideInvalidOptions ? !t[n.id] : !0), hJ = (e) => (t) => {
  const i = _u(e)(t), n = $u(t, i);
  return n.length > 0 ? n[0] : Dt;
}, M$e = Pt([(e, t, i) => t7(e, i), JZ, (e, t) => t], (e, t, i) => {
  const n = t[i];
  return n == null ? void 0 : n.filter((r) => e[r.id]).map((r) => r.id);
}), _Z = (e, t) => {
  const i = L1(e, t), n = nC(e, t);
  return n.filter((r) => r.parentId === (t == null ? void 0 : t.variableId)).find((r) => !K1(r, i)) ?? n[0];
}, Vs = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.app;
}, sKt = (e) => e.configurator.searchString, aKt = (e) => {
  var t;
  return (t = Vs(e)) == null ? void 0 : t.id;
}, hr = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.showEditorUi;
}, U$e = (e) => e.configurator.device, cKt = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.devmode;
}, dKt = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.helpTopic;
}, M1 = (e, t) => {
  var g;
  let i = fa(e, t);
  return i || (i = (g = _Z(e, t)) == null ? void 0 : g.id), Ba(i)(e);
}, P$e = (e, t) => (i) => {
  var g, r, o;
  let n = M1(i, t);
  for (let I = 0; I < 20; I++) {
    if (!n)
      return null;
    if (((o = (r = (g = n.settings) == null ? void 0 : g.theme) == null ? void 0 : r[e]) == null ? void 0 : o.selected) === "custom")
      return n;
    if (!n.parentId)
      return null;
    n = BGe(n.parentId)(i);
  }
  return null;
}, CKt = (e) => {
  const t = Vs(e);
  return EGe(e, t == null ? void 0 : t.id);
}, uKt = (e) => {
  const t = Vs(e);
  return B$e(t == null ? void 0 : t.id, e);
}, AKt = (e) => {
  const t = Vs(e);
  return h$e(t == null ? void 0 : t.id, e);
}, bKt = (e) => {
  const t = Vs(e);
  return k6(e, t == null ? void 0 : t.id);
}, mKt = (e) => {
  const t = Vs(e);
  return SGe(e, t == null ? void 0 : t.id);
}, hKt = (e) => {
  const t = Vs(e), i = k6(e, t == null ? void 0 : t.id);
  return me.flow(me.map((n) => n.category), me.compact, me.uniq)(i);
}, z$e = [], O$e = Pt([Vs, F6], (e, t) => t[e == null ? void 0 : e.id] ?? z$e), pKt = Pt([O$e], (e) => e.reduce((t, i) => {
  const n = t[i.articleId];
  return n && n.sort < i.sort || (t[i.articleId] = i), t;
}, {})), pJ = () => {
  const e = _(Vj);
  return ft((t) => e[t], [e]);
}, un = () => {
  const e = pJ(), t = J1(), i = _(ng), n = BJ(), g = _(hr);
  return ft((r, o, I) => {
    var d, C;
    const s = ((d = t.find((u) => u.key === r)) == null ? void 0 : d.defaultValue) ?? o ?? "", a = i === "de" || !g || !s ? s : `[${s}]`;
    return (((C = e(r)) == null ? void 0 : C[i]) || n(s) || a).replace(/\{\{(\w+)\}\}/g, (u, A) => (I == null ? void 0 : I[A]) || "{{" + A + "}}");
  }, [t, i, g, e, n]);
}, U1 = () => {
  const e = pJ(), t = J1();
  return ft((i, n) => {
    var g;
    return e(i) ?? (n || ((g = t.find((r) => r.key === i)) == null ? void 0 : g.defaultValue));
  }, [e, t]);
}, Q$e = (e) => e.split(", ").map((t) => {
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}), BKt = () => {
  const e = pJ(), t = J1();
  return ft((i, n, g) => {
    const r = e(i), o = t.find((s) => s.key === i), I = n || o.parser || Q$e;
    return r ? I(r) : g || (o == null ? void 0 : o.defaultValue) || [];
  }, [e, t]);
}, xm = ({
  value: e
}) => {
  const t = _(ng), i = un();
  return typeof e == "string" ? /* @__PURE__ */ p(Bt, { children: i(e) }) : /* @__PURE__ */ p(Bt, { children: Eu(e, t) });
}, Eu = (e, t, i, n = !0) => {
  const g = e == null ? void 0 : e[t];
  if (g)
    return g;
  {
    const r = H6() && !u$e(), o = n === !0 && (e != null && e.de) ? e.de : i;
    return n === !0 && o ? i7(o, t, r ? `[${o}]` : o, !1) || o : "";
  }
}, i7 = (e, t, i, n = !0) => $r(e, {
  lng: t,
  fallback: n,
  defaultValue: i
}) || i, j$e = (e, t) => typeof e == "string" ? {
  de: (e == null ? void 0 : e.toString()) || t
} : e, _$e = (e, t, i) => {
  const n = j$e(e, i);
  return n ? Eu(n, t, i, !0) : "";
}, BJ = () => {
  const e = _(ng);
  return (t) => i7(t, e, t);
};
async function $$e(e, t, i) {
  const n = new FormData();
  return n.append("app", e.code), n.append("path", t), i.forEach((g) => {
    n.append("file[]", g);
  }), jd("POST", "/doc", n);
}
async function ZKt(e) {
  return jd("GET", `/tmpl/${e}`);
}
function n7(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (i = n7(e[t])) && (n && (n += " "), n += i);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function tA() {
  for (var e, t, i = 0, n = ""; i < arguments.length; )
    (e = arguments[i++]) && (t = n7(e)) && (n && (n += " "), n += t);
  return n;
}
let q$e = { data: "" }, eqe = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || q$e, tqe = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, iqe = /\/\*[^]*?\*\/|  +/g, H3 = /\n+/g, mu = (e, t) => {
  let i = "", n = "", g = "";
  for (let r in e) {
    let o = e[r];
    r[0] == "@" ? r[1] == "i" ? i = r + " " + o + ";" : n += r[1] == "f" ? mu(o, r) : r + "{" + mu(o, r[1] == "k" ? "" : t) + "}" : typeof o == "object" ? n += mu(o, t ? t.replace(/([^,])+/g, (I) => r.replace(/(^:.*)|([^,])+/g, (s) => /&/.test(s) ? s.replace(/&/g, I) : I ? I + " " + s : s)) : r) : o != null && (r = /^--/.test(r) ? r : r.replace(/[A-Z]/g, "-$&").toLowerCase(), g += mu.p ? mu.p(r, o) : r + ":" + o + ";");
  }
  return i + (t && g ? t + "{" + g + "}" : g) + n;
}, _a = {}, g7 = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let i in e)
      t += i + g7(e[i]);
    return t;
  }
  return e;
}, nqe = (e, t, i, n, g) => {
  let r = g7(e), o = _a[r] || (_a[r] = ((s) => {
    let a = 0, d = 11;
    for (; a < s.length; )
      d = 101 * d + s.charCodeAt(a++) >>> 0;
    return "go" + d;
  })(r));
  if (!_a[o]) {
    let s = r !== e ? e : ((a) => {
      let d, C, u = [{}];
      for (; d = tqe.exec(a.replace(iqe, "")); )
        d[4] ? u.shift() : d[3] ? (C = d[3].replace(H3, " ").trim(), u.unshift(u[0][C] = u[0][C] || {})) : u[0][d[1]] = d[2].replace(H3, " ").trim();
      return u[0];
    })(e);
    _a[o] = mu(g ? { ["@keyframes " + o]: s } : s, i ? "" : "." + o);
  }
  let I = i && _a.g ? _a.g : null;
  return i && (_a.g = _a[o]), ((s, a, d, C) => {
    C ? a.data = a.data.replace(C, s) : a.data.indexOf(s) === -1 && (a.data = d ? s + a.data : a.data + s);
  })(_a[o], t, n, I), o;
}, gqe = (e, t, i) => e.reduce((n, g, r) => {
  let o = t[r];
  if (o && o.call) {
    let I = o(i), s = I && I.props && I.props.className || /^go/.test(I) && I;
    o = s ? "." + s : I && typeof I == "object" ? I.props ? "" : mu(I, "") : I === !1 ? "" : I;
  }
  return n + g + (o ?? "");
}, "");
function ZJ(e) {
  let t = this || {}, i = e.call ? e(t.p) : e;
  return nqe(i.unshift ? i.raw ? gqe(i, [].slice.call(arguments, 1), t.p) : i.reduce((n, g) => Object.assign(n, g && g.call ? g(t.p) : g), {}) : i, eqe(t.target), t.g, t.o, t.k);
}
ZJ.bind({ g: 1 });
ZJ.bind({ k: 1 });
function rqe(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function r7(e, t, i) {
  return t && rqe(e.prototype, t), e;
}
function Vn() {
  return Vn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Vn.apply(this, arguments);
}
function o7(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function $Z(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), g, r;
  for (r = 0; r < n.length; r++)
    g = n[r], !(t.indexOf(g) >= 0) && (i[g] = e[g]);
  return i;
}
function k3(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var F3 = function() {
  return "";
}, I7 = /* @__PURE__ */ Se.createContext({
  enqueueSnackbar: F3,
  closeSnackbar: F3
}), cu = {
  downXs: "@media (max-width:599.95px)",
  upSm: "@media (min-width:600px)"
}, Y3 = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, fJ = function(t) {
  return "" + Y3(t.vertical) + Y3(t.horizontal);
}, aW = function(t) {
  return !!t || t === 0;
}, cW = "unmounted", Eb = "exited", Nb = "entering", y0 = "entered", x3 = "exiting", GJ = /* @__PURE__ */ function(e) {
  o7(t, e);
  function t(n) {
    var g;
    g = e.call(this, n) || this;
    var r = n.appear, o;
    return g.appearStatus = null, n.in ? r ? (o = Eb, g.appearStatus = Nb) : o = y0 : n.unmountOnExit || n.mountOnEnter ? o = cW : o = Eb, g.state = {
      status: o
    }, g.nextCallback = null, g;
  }
  t.getDerivedStateFromProps = function(g, r) {
    var o = g.in;
    return o && r.status === cW ? {
      status: Eb
    } : null;
  };
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, i.componentDidUpdate = function(g) {
    var r = null;
    if (g !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== Nb && o !== y0 && (r = Nb) : (o === Nb || o === y0) && (r = x3);
    }
    this.updateStatus(!1, r);
  }, i.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, i.getTimeouts = function() {
    var g = this.props.timeout, r = g, o = g;
    return g != null && typeof g != "number" && typeof g != "string" && (o = g.exit, r = g.enter), {
      exit: o,
      enter: r
    };
  }, i.updateStatus = function(g, r) {
    g === void 0 && (g = !1), r !== null ? (this.cancelNextCallback(), r === Nb ? this.performEnter(g) : this.performExit()) : this.props.unmountOnExit && this.state.status === Eb && this.setState({
      status: cW
    });
  }, i.performEnter = function(g) {
    var r = this, o = this.props.enter, I = g, s = this.getTimeouts();
    if (!g && !o) {
      this.safeSetState({
        status: y0
      }, function() {
        r.props.onEntered && r.props.onEntered(r.node, I);
      });
      return;
    }
    this.props.onEnter && this.props.onEnter(this.node, I), this.safeSetState({
      status: Nb
    }, function() {
      r.props.onEntering && r.props.onEntering(r.node, I), r.onTransitionEnd(s.enter, function() {
        r.safeSetState({
          status: y0
        }, function() {
          r.props.onEntered && r.props.onEntered(r.node, I);
        });
      });
    });
  }, i.performExit = function() {
    var g = this, r = this.props.exit, o = this.getTimeouts();
    if (!r) {
      this.safeSetState({
        status: Eb
      }, function() {
        g.props.onExited && g.props.onExited(g.node);
      });
      return;
    }
    this.props.onExit && this.props.onExit(this.node), this.safeSetState({
      status: x3
    }, function() {
      g.props.onExiting && g.props.onExiting(g.node), g.onTransitionEnd(o.exit, function() {
        g.safeSetState({
          status: Eb
        }, function() {
          g.props.onExited && g.props.onExited(g.node);
        });
      });
    });
  }, i.cancelNextCallback = function() {
    this.nextCallback !== null && this.nextCallback.cancel && (this.nextCallback.cancel(), this.nextCallback = null);
  }, i.safeSetState = function(g, r) {
    r = this.setNextCallback(r), this.setState(g, r);
  }, i.setNextCallback = function(g) {
    var r = this, o = !0;
    return this.nextCallback = function() {
      o && (o = !1, r.nextCallback = null, g());
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, i.onTransitionEnd = function(g, r) {
    this.setNextCallback(r);
    var o = g == null && !this.props.addEndListener;
    if (!this.node || o) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    this.props.addEndListener && this.props.addEndListener(this.node, this.nextCallback), g != null && setTimeout(this.nextCallback, g);
  }, i.render = function() {
    var g = this.state.status;
    if (g === cW)
      return null;
    var r = this.props, o = r.children, I = $Z(r, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return o(g, I);
  }, r7(t, [{
    key: "node",
    get: function() {
      var g, r = (g = this.props.nodeRef) === null || g === void 0 ? void 0 : g.current;
      if (!r)
        throw new Error("notistack - Custom snackbar is not refForwarding");
      return r;
    }
  }]), t;
}(Se.Component);
function Lb() {
}
GJ.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Lb,
  onEntering: Lb,
  onEntered: Lb,
  onExit: Lb,
  onExiting: Lb,
  onExited: Lb
};
function D3(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function zY(e, t) {
  return je(function() {
    return e == null && t == null ? null : function(i) {
      D3(e, i), D3(t, i);
    };
  }, [e, t]);
}
function gV(e) {
  var t = e.timeout, i = e.style, n = i === void 0 ? {} : i, g = e.mode;
  return {
    duration: typeof t == "object" ? t[g] || 0 : t,
    easing: n.transitionTimingFunction,
    delay: n.transitionDelay
  };
}
var OY = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, l7 = function(t) {
  t.scrollTop = t.scrollTop;
}, J3 = function(t) {
  return Math.round(t) + "ms";
};
function cm(e, t) {
  e === void 0 && (e = ["all"]);
  var i = t || {}, n = i.duration, g = n === void 0 ? 300 : n, r = i.easing, o = r === void 0 ? OY.easeInOut : r, I = i.delay, s = I === void 0 ? 0 : I, a = Array.isArray(e) ? e : [e];
  return a.map(function(d) {
    var C = typeof g == "string" ? g : J3(g), u = typeof s == "string" ? s : J3(s);
    return d + " " + C + " " + o + " " + u;
  }).join(",");
}
function oqe(e) {
  return e && e.ownerDocument || document;
}
function s7(e) {
  var t = oqe(e);
  return t.defaultView || window;
}
function Iqe(e, t) {
  t === void 0 && (t = 166);
  var i;
  function n() {
    for (var g = this, r = arguments.length, o = new Array(r), I = 0; I < r; I++)
      o[I] = arguments[I];
    var s = function() {
      e.apply(g, o);
    };
    clearTimeout(i), i = setTimeout(s, t);
  }
  return n.clear = function() {
    clearTimeout(i);
  }, n;
}
function lqe(e, t) {
  var i = t.getBoundingClientRect(), n = s7(t), g;
  if (t.fakeTransform)
    g = t.fakeTransform;
  else {
    var r = n.getComputedStyle(t);
    g = r.getPropertyValue("-webkit-transform") || r.getPropertyValue("transform");
  }
  var o = 0, I = 0;
  if (g && g !== "none" && typeof g == "string") {
    var s = g.split("(")[1].split(")")[0].split(",");
    o = parseInt(s[4], 10), I = parseInt(s[5], 10);
  }
  switch (e) {
    case "left":
      return "translateX(" + (n.innerWidth + o - i.left) + "px)";
    case "right":
      return "translateX(-" + (i.left + i.width - o) + "px)";
    case "up":
      return "translateY(" + (n.innerHeight + I - i.top) + "px)";
    default:
      return "translateY(-" + (i.top + i.height - I) + "px)";
  }
}
function dW(e, t) {
  if (t) {
    var i = lqe(e, t);
    i && (t.style.webkitTransform = i, t.style.transform = i);
  }
}
var a7 = /* @__PURE__ */ Sl(function(e, t) {
  var i = e.children, n = e.direction, g = n === void 0 ? "down" : n, r = e.in, o = e.style, I = e.timeout, s = I === void 0 ? 0 : I, a = e.onEnter, d = e.onEntered, C = e.onExit, u = e.onExited, A = $Z(e, ["children", "direction", "in", "style", "timeout", "onEnter", "onEntered", "onExit", "onExited"]), m = Ct(null), h = zY(i.ref, m), B = zY(h, t), f = function(v, H) {
    dW(g, v), l7(v), a && a(v, H);
  }, G = function(v) {
    var H = (o == null ? void 0 : o.transitionTimingFunction) || OY.easeOut, x = gV({
      timeout: s,
      mode: "enter",
      style: Vn({}, o, {
        transitionTimingFunction: H
      })
    });
    v.style.webkitTransition = cm("-webkit-transform", x), v.style.transition = cm("transform", x), v.style.webkitTransform = "none", v.style.transform = "none";
  }, y = function(v) {
    var H = (o == null ? void 0 : o.transitionTimingFunction) || OY.sharp, x = gV({
      timeout: s,
      mode: "exit",
      style: Vn({}, o, {
        transitionTimingFunction: H
      })
    });
    v.style.webkitTransition = cm("-webkit-transform", x), v.style.transition = cm("transform", x), dW(g, v), C && C(v);
  }, W = function(v) {
    v.style.webkitTransition = "", v.style.transition = "", u && u(v);
  }, V = ft(function() {
    m.current && dW(g, m.current);
  }, [g]);
  return et(function() {
    if (!(r || g === "down" || g === "right")) {
      var w = Iqe(function() {
        m.current && dW(g, m.current);
      }), v = s7(m.current);
      return v.addEventListener("resize", w), function() {
        w.clear(), v.removeEventListener("resize", w);
      };
    }
  }, [g, r]), et(function() {
    r || V();
  }, [r, V]), ga(GJ, Object.assign({
    appear: !0,
    nodeRef: m,
    onEnter: f,
    onEntered: d,
    onEntering: G,
    onExit: y,
    onExited: W,
    in: r,
    timeout: s
  }, A), function(w, v) {
    return wu(i, Vn({
      ref: B,
      style: Vn({
        visibility: w === "exited" && !r ? "hidden" : void 0
      }, o, {}, i.props.style)
    }, v));
  });
});
a7.displayName = "Slide";
var P1 = function(t) {
  return Se.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    focusable: "false",
    style: {
      fontSize: 20,
      marginInlineEnd: 8,
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0
    }
  }, t));
}, sqe = function() {
  return Se.createElement(P1, null, Se.createElement("path", {
    d: `M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41
        10.59L10 14.17L17.59 6.58L19 8L10 17Z`
  }));
}, aqe = function() {
  return Se.createElement(P1, null, Se.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
}, cqe = function() {
  return Se.createElement(P1, null, Se.createElement("path", {
    d: `M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,
        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,
        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z`
  }));
}, dqe = function() {
  return Se.createElement(P1, null, Se.createElement("path", {
    d: `M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,
        0 22,12A10,10 0 0,0 12,2Z`
  }));
}, Cqe = {
  default: void 0,
  success: /* @__PURE__ */ Se.createElement(sqe, null),
  warning: /* @__PURE__ */ Se.createElement(aqe, null),
  error: /* @__PURE__ */ Se.createElement(cqe, null),
  info: /* @__PURE__ */ Se.createElement(dqe, null)
}, Xu = {
  maxSnack: 3,
  persist: !1,
  hideIconVariant: !1,
  disableWindowBlurListener: !1,
  variant: "default",
  autoHideDuration: 5e3,
  iconVariant: Cqe,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  TransitionComponent: a7,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
}, uqe = function(t, i) {
  var n = function(r) {
    return typeof r == "number" || r === null;
  };
  return n(t) ? t : n(i) ? i : Xu.autoHideDuration;
}, Aqe = function(t, i) {
  var n = function(r, o) {
    return o.some(function(I) {
      return typeof r === I;
    });
  };
  return n(t, ["string", "number"]) ? t : n(t, ["object"]) ? Vn({}, Xu.transitionDuration, {}, n(i, ["object"]) && i, {}, t) : n(i, ["string", "number"]) ? i : n(i, ["object"]) ? Vn({}, Xu.transitionDuration, {}, i) : Xu.transitionDuration;
}, bqe = function(t, i) {
  return function(n, g) {
    return g === void 0 && (g = !1), g ? Vn({}, Xu[n], {}, i[n], {}, t[n]) : n === "autoHideDuration" ? uqe(t.autoHideDuration, i.autoHideDuration) : n === "transitionDuration" ? Aqe(t.transitionDuration, i.transitionDuration) : t[n] || i[n] || Xu[n];
  };
};
function qZ(e) {
  return Object.entries(e).reduce(function(t, i) {
    var n, g = i[0], r = i[1];
    return Vn({}, t, (n = {}, n[g] = ZJ(r), n));
  }, {});
}
var Dm = {
  SnackbarContainer: "notistack-SnackbarContainer",
  Snackbar: "notistack-Snackbar",
  CollapseWrapper: "notistack-CollapseWrapper",
  MuiContent: "notistack-MuiContent",
  MuiContentVariant: function(t) {
    return "notistack-MuiContent-" + t;
  }
}, K3 = /* @__PURE__ */ qZ({
  root: {
    height: 0
  },
  entered: {
    height: "auto"
  }
}), Vk = "0px", wk = 175, c7 = /* @__PURE__ */ Sl(function(e, t) {
  var i = e.children, n = e.in, g = e.onExited, r = Ct(null), o = Ct(null), I = zY(t, o), s = function() {
    return r.current ? r.current.clientHeight : 0;
  }, a = function(h) {
    h.style.height = Vk;
  }, d = function(h) {
    var B = s(), f = gV({
      timeout: wk,
      mode: "enter"
    }), G = f.duration, y = f.easing;
    h.style.transitionDuration = typeof G == "string" ? G : G + "ms", h.style.height = B + "px", h.style.transitionTimingFunction = y || "";
  }, C = function(h) {
    h.style.height = "auto";
  }, u = function(h) {
    h.style.height = s() + "px";
  }, A = function(h) {
    l7(h);
    var B = gV({
      timeout: wk,
      mode: "exit"
    }), f = B.duration, G = B.easing;
    h.style.transitionDuration = typeof f == "string" ? f : f + "ms", h.style.height = Vk, h.style.transitionTimingFunction = G || "";
  };
  return ga(GJ, {
    in: n,
    unmountOnExit: !0,
    onEnter: a,
    onEntered: C,
    onEntering: d,
    onExit: u,
    onExited: g,
    onExiting: A,
    nodeRef: o,
    timeout: wk
  }, function(m, h) {
    return ga("div", Object.assign({
      ref: I,
      className: tA(K3.root, m === "entered" && K3.entered),
      style: Vn({
        pointerEvents: "all",
        overflow: "hidden",
        minHeight: Vk,
        transition: cm("height")
      }, m === "entered" && {
        overflow: "visible"
      }, {}, m === "exited" && !n && {
        visibility: "hidden"
      })
    }, h), ga("div", {
      ref: r,
      className: Dm.CollapseWrapper,
      // Hack to get children with a negative margin to not falsify the height computation.
      style: {
        display: "flex",
        width: "100%"
      }
    }, i));
  });
});
c7.displayName = "Collapse";
var E3 = {
  right: "left",
  left: "right",
  bottom: "up",
  top: "down"
}, mqe = function(t) {
  return t.horizontal !== "center" ? E3[t.horizontal] : E3[t.vertical];
}, hqe = function(t) {
  return "anchorOrigin" + fJ(t);
}, pqe = function(t) {
  t === void 0 && (t = {});
  var i = {
    containerRoot: !0,
    containerAnchorOriginTopCenter: !0,
    containerAnchorOriginBottomCenter: !0,
    containerAnchorOriginTopRight: !0,
    containerAnchorOriginBottomRight: !0,
    containerAnchorOriginTopLeft: !0,
    containerAnchorOriginBottomLeft: !0
  };
  return Object.keys(t).filter(function(n) {
    return !i[n];
  }).reduce(function(n, g) {
    var r;
    return Vn({}, n, (r = {}, r[g] = t[g], r));
  }, {});
}, Bqe = function() {
};
function AB(e, t) {
  return e.reduce(function(i, n) {
    return n == null ? i : function() {
      for (var r = arguments.length, o = new Array(r), I = 0; I < r; I++)
        o[I] = arguments[I];
      var s = [].concat(o);
      t && s.indexOf(t) === -1 && s.push(t), i.apply(this, s), n.apply(this, s);
    };
  }, Bqe);
}
var Zqe = typeof window < "u" ? Um : et;
function N3(e) {
  var t = Ct(e);
  return Zqe(function() {
    t.current = e;
  }), ft(function() {
    return (
      // @ts-expect-error hide `this`
      t.current.apply(void 0, arguments)
    );
  }, []);
}
var d7 = /* @__PURE__ */ Sl(function(e, t) {
  var i = e.children, n = e.className, g = e.autoHideDuration, r = e.disableWindowBlurListener, o = r === void 0 ? !1 : r, I = e.onClose, s = e.id, a = e.open, d = e.SnackbarProps, C = d === void 0 ? {} : d, u = Ct(), A = N3(function() {
    I && I.apply(void 0, arguments);
  }), m = N3(function(y) {
    !I || y == null || (u.current && clearTimeout(u.current), u.current = setTimeout(function() {
      A(null, "timeout", s);
    }, y));
  });
  et(function() {
    return a && m(g), function() {
      u.current && clearTimeout(u.current);
    };
  }, [a, g, m]);
  var h = function() {
    u.current && clearTimeout(u.current);
  }, B = ft(function() {
    g != null && m(g * 0.5);
  }, [g, m]), f = function(W) {
    C.onMouseEnter && C.onMouseEnter(W), h();
  }, G = function(W) {
    C.onMouseLeave && C.onMouseLeave(W), B();
  };
  return et(function() {
    if (!o && a)
      return window.addEventListener("focus", B), window.addEventListener("blur", h), function() {
        window.removeEventListener("focus", B), window.removeEventListener("blur", h);
      };
  }, [o, B, a]), ga("div", Object.assign({
    ref: t
  }, C, {
    className: tA(Dm.Snackbar, n),
    onMouseEnter: f,
    onMouseLeave: G
  }), i);
});
d7.displayName = "Snackbar";
var vk, fqe = /* @__PURE__ */ qZ({
  root: (vk = {
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1
  }, vk[cu.upSm] = {
    flexGrow: "initial",
    minWidth: "288px"
  }, vk)
}), C7 = /* @__PURE__ */ Sl(function(e, t) {
  var i = e.className, n = $Z(e, ["className"]);
  return Se.createElement("div", Object.assign({
    ref: t,
    className: tA(fqe.root, i)
  }, n));
});
C7.displayName = "SnackbarContent";
var W0 = /* @__PURE__ */ qZ({
  root: {
    backgroundColor: "#313131",
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    color: "#fff",
    alignItems: "center",
    padding: "6px 16px",
    borderRadius: "4px",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  },
  lessPadding: {
    paddingLeft: 8 * 2.5 + "px"
  },
  default: {
    backgroundColor: "#313131"
  },
  success: {
    backgroundColor: "#43a047"
  },
  error: {
    backgroundColor: "#d32f2f"
  },
  warning: {
    backgroundColor: "#ff9800"
  },
  info: {
    backgroundColor: "#2196f3"
  },
  message: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0"
  },
  action: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: "16px",
    marginRight: "-8px"
  }
}), L3 = "notistack-snackbar", u7 = /* @__PURE__ */ Sl(function(e, t) {
  var i = e.id, n = e.message, g = e.action, r = e.iconVariant, o = e.variant, I = e.hideIconVariant, s = e.style, a = e.className, d = r[o], C = g;
  return typeof C == "function" && (C = C(i)), Se.createElement(C7, {
    ref: t,
    role: "alert",
    "aria-describedby": L3,
    style: s,
    className: tA(Dm.MuiContent, Dm.MuiContentVariant(o), W0.root, W0[o], a, !I && d && W0.lessPadding)
  }, Se.createElement("div", {
    id: L3,
    className: W0.message
  }, I ? null : d, n), C && Se.createElement("div", {
    className: W0.action
  }, C));
});
u7.displayName = "MaterialDesignContent";
var Gqe = /* @__PURE__ */ pZ(u7), yqe = /* @__PURE__ */ qZ({
  wrappedRoot: {
    width: "100%",
    position: "relative",
    transform: "translateX(0)",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    minWidth: "288px"
  }
}), Wqe = function(t) {
  var i = Ct(), n = At(!0), g = n[0], r = n[1], o = AB([t.snack.onClose, t.onClose]), I = function() {
    t.snack.requestClose && o(null, "instructed", t.snack.id);
  }, s = ft(function() {
    i.current = setTimeout(function() {
      r(function(x) {
        return !x;
      });
    }, 125);
  }, []);
  et(function() {
    return function() {
      i.current && clearTimeout(i.current);
    };
  }, []);
  var a = t.snack, d = t.classes, C = t.Component, u = C === void 0 ? Gqe : C, A = je(function() {
    return pqe(d);
  }, [d]), m = a.open, h = a.SnackbarProps, B = a.TransitionComponent, f = a.TransitionProps, G = a.transitionDuration, y = a.disableWindowBlurListener, W = a.content, V = $Z(a, ["open", "SnackbarProps", "TransitionComponent", "TransitionProps", "transitionDuration", "disableWindowBlurListener", "content", "entered", "requestClose", "onEnter", "onEntered", "onExit", "onExited"]), w = Vn({
    direction: mqe(V.anchorOrigin),
    timeout: G
  }, f), v = W;
  typeof v == "function" && (v = v(V.id, V.message));
  var H = ["onEnter", "onEntered", "onExit", "onExited"].reduce(function(x, N) {
    var M;
    return Vn({}, x, (M = {}, M[N] = AB([t.snack[N], t[N]], V.id), M));
  }, {});
  return Se.createElement(c7, {
    in: g,
    onExited: H.onExited
  }, Se.createElement(d7, {
    open: m,
    id: V.id,
    disableWindowBlurListener: y,
    autoHideDuration: V.autoHideDuration,
    className: tA(yqe.wrappedRoot, A.root, A[hqe(V.anchorOrigin)]),
    SnackbarProps: h,
    onClose: o
  }, Se.createElement(B, Object.assign({}, w, {
    appear: !0,
    in: m,
    onExit: H.onExit,
    onExited: s,
    onEnter: H.onEnter,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: AB([H.onEntered, I], V.id)
  }), v || Se.createElement(u, Object.assign({}, V)))));
}, S0, Rk, CW, uW, Xk, $a = {
  view: {
    default: 20,
    dense: 4
  },
  snackbar: {
    default: 6,
    dense: 2
  }
}, T3 = "." + Dm.CollapseWrapper, Hk = 16, AW = /* @__PURE__ */ qZ({
  root: (S0 = {
    boxSizing: "border-box",
    display: "flex",
    maxHeight: "100%",
    position: "fixed",
    zIndex: 1400,
    height: "auto",
    width: "auto",
    transition: /* @__PURE__ */ cm(["top", "right", "bottom", "left", "max-width"], {
      duration: 300,
      easing: "ease"
    }),
    // container itself is invisible and should not block clicks, clicks should be passed to its children
    // a pointerEvents: all is applied in the collapse component
    pointerEvents: "none"
  }, S0[T3] = {
    padding: $a.snackbar.default + "px 0px",
    transition: "padding 300ms ease 0ms"
  }, S0.maxWidth = "calc(100% - " + $a.view.default * 2 + "px)", S0[cu.downXs] = {
    width: "100%",
    maxWidth: "calc(100% - " + Hk * 2 + "px)"
  }, S0),
  rootDense: (Rk = {}, Rk[T3] = {
    padding: $a.snackbar.dense + "px 0px"
  }, Rk),
  top: {
    top: $a.view.default - $a.snackbar.default + "px",
    flexDirection: "column"
  },
  bottom: {
    bottom: $a.view.default - $a.snackbar.default + "px",
    flexDirection: "column-reverse"
  },
  left: (CW = {
    left: $a.view.default + "px"
  }, CW[cu.upSm] = {
    alignItems: "flex-start"
  }, CW[cu.downXs] = {
    left: Hk + "px"
  }, CW),
  right: (uW = {
    right: $a.view.default + "px"
  }, uW[cu.upSm] = {
    alignItems: "flex-end"
  }, uW[cu.downXs] = {
    right: Hk + "px"
  }, uW),
  center: (Xk = {
    left: "50%",
    transform: "translateX(-50%)"
  }, Xk[cu.upSm] = {
    alignItems: "center"
  }, Xk)
}), Sqe = function(t) {
  var i = t.classes, n = i === void 0 ? {} : i, g = t.anchorOrigin, r = t.dense, o = t.children, I = tA(
    Dm.SnackbarContainer,
    AW[g.vertical],
    AW[g.horizontal],
    AW.root,
    // root should come after others to override maxWidth
    n.containerRoot,
    n["containerAnchorOrigin" + fJ(g)],
    r && AW.rootDense
  );
  return Se.createElement("div", {
    className: I
  }, o);
}, Vqe = /* @__PURE__ */ pZ(Sqe), M3 = function(t) {
  var i = typeof t == "string" || IB(t);
  return !i;
}, ef, yJ, wqe = /* @__PURE__ */ function(e) {
  o7(t, e);
  function t(n) {
    var g;
    return g = e.call(this, n) || this, g.enqueueSnackbar = function(r, o) {
      if (o === void 0 && (o = {}), r == null)
        throw new Error("enqueueSnackbar called with invalid argument");
      var I = M3(r) ? r : o, s = M3(r) ? r.message : r, a = I.key, d = I.preventDuplicate, C = $Z(I, ["key", "preventDuplicate"]), u = aW(a), A = u ? a : (/* @__PURE__ */ new Date()).getTime() + Math.random(), m = bqe(C, g.props), h = Vn({
        id: A
      }, C, {
        message: s,
        open: !0,
        entered: !1,
        requestClose: !1,
        persist: m("persist"),
        action: m("action"),
        content: m("content"),
        variant: m("variant"),
        anchorOrigin: m("anchorOrigin"),
        disableWindowBlurListener: m("disableWindowBlurListener"),
        autoHideDuration: m("autoHideDuration"),
        hideIconVariant: m("hideIconVariant"),
        TransitionComponent: m("TransitionComponent"),
        transitionDuration: m("transitionDuration"),
        TransitionProps: m("TransitionProps", !0),
        iconVariant: m("iconVariant", !0),
        style: m("style", !0),
        SnackbarProps: m("SnackbarProps", !0),
        className: tA(g.props.className, C.className)
      });
      return h.persist && (h.autoHideDuration = void 0), g.setState(function(B) {
        if (d === void 0 && g.props.preventDuplicate || d) {
          var f = function(V) {
            return u ? V.id === A : V.message === s;
          }, G = B.queue.findIndex(f) > -1, y = B.snacks.findIndex(f) > -1;
          if (G || y)
            return B;
        }
        return g.handleDisplaySnack(Vn({}, B, {
          queue: [].concat(B.queue, [h])
        }));
      }), A;
    }, g.handleDisplaySnack = function(r) {
      var o = r.snacks;
      return o.length >= g.maxSnack ? g.handleDismissOldest(r) : g.processQueue(r);
    }, g.processQueue = function(r) {
      var o = r.queue, I = r.snacks;
      return o.length > 0 ? Vn({}, r, {
        snacks: [].concat(I, [o[0]]),
        queue: o.slice(1, o.length)
      }) : r;
    }, g.handleDismissOldest = function(r) {
      if (r.snacks.some(function(d) {
        return !d.open || d.requestClose;
      }))
        return r;
      var o = !1, I = !1, s = r.snacks.reduce(function(d, C) {
        return d + (C.open && C.persist ? 1 : 0);
      }, 0);
      s === g.maxSnack && (I = !0);
      var a = r.snacks.map(function(d) {
        return !o && (!d.persist || I) ? (o = !0, d.entered ? (d.onClose && d.onClose(null, "maxsnack", d.id), g.props.onClose && g.props.onClose(null, "maxsnack", d.id), Vn({}, d, {
          open: !1
        })) : Vn({}, d, {
          requestClose: !0
        })) : Vn({}, d);
      });
      return Vn({}, r, {
        snacks: a
      });
    }, g.handleEnteredSnack = function(r, o, I) {
      if (!aW(I))
        throw new Error("handleEnteredSnack Cannot be called with undefined key");
      g.setState(function(s) {
        var a = s.snacks;
        return {
          snacks: a.map(function(d) {
            return d.id === I ? Vn({}, d, {
              entered: !0
            }) : Vn({}, d);
          })
        };
      });
    }, g.handleCloseSnack = function(r, o, I) {
      g.props.onClose && g.props.onClose(r, o, I);
      var s = I === void 0;
      g.setState(function(a) {
        var d = a.snacks, C = a.queue;
        return {
          snacks: d.map(function(u) {
            return !s && u.id !== I ? Vn({}, u) : u.entered ? Vn({}, u, {
              open: !1
            }) : Vn({}, u, {
              requestClose: !0
            });
          }),
          queue: C.filter(function(u) {
            return u.id !== I;
          })
        };
      });
    }, g.closeSnackbar = function(r) {
      var o = g.state.snacks.find(function(I) {
        return I.id === r;
      });
      aW(r) && o && o.onClose && o.onClose(null, "instructed", r), g.handleCloseSnack(null, "instructed", r);
    }, g.handleExitedSnack = function(r, o) {
      if (!aW(o))
        throw new Error("handleExitedSnack Cannot be called with undefined key");
      g.setState(function(I) {
        var s = g.processQueue(Vn({}, I, {
          snacks: I.snacks.filter(function(a) {
            return a.id !== o;
          })
        }));
        return s.queue.length === 0 ? s : g.handleDismissOldest(s);
      });
    }, ef = g.enqueueSnackbar, yJ = g.closeSnackbar, g.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: g.enqueueSnackbar.bind(k3(g)),
        closeSnackbar: g.closeSnackbar.bind(k3(g))
      }
    }, g;
  }
  var i = t.prototype;
  return i.render = function() {
    var g = this, r = this.state.contextValue, o = this.props, I = o.domRoot, s = o.children, a = o.dense, d = a === void 0 ? !1 : a, C = o.Components, u = C === void 0 ? {} : C, A = o.classes, m = this.state.snacks.reduce(function(B, f) {
      var G, y = fJ(f.anchorOrigin), W = B[y] || [];
      return Vn({}, B, (G = {}, G[y] = [].concat(W, [f]), G));
    }, {}), h = Object.keys(m).map(function(B) {
      var f = m[B], G = f[0];
      return Se.createElement(Vqe, {
        key: B,
        dense: d,
        anchorOrigin: G.anchorOrigin,
        classes: A
      }, f.map(function(y) {
        return Se.createElement(Wqe, {
          key: y.id,
          snack: y,
          classes: A,
          Component: u[y.variant],
          onClose: g.handleCloseSnack,
          onEnter: g.props.onEnter,
          onExit: g.props.onExit,
          onExited: AB([g.handleExitedSnack, g.props.onExited], y.id),
          onEntered: AB([g.handleEnteredSnack, g.props.onEntered], y.id)
        });
      }));
    });
    return Se.createElement(I7.Provider, {
      value: r
    }, s, I ? Dz(h, I) : h);
  }, r7(t, [{
    key: "maxSnack",
    get: function() {
      return this.props.maxSnack || Xu.maxSnack;
    }
  }]), t;
}(Qne), vqe = function() {
  return Hn(I7);
};
const Rqe = (e) => e ? e.map((t) => t.toLowerCase() === "jpg" ? "jpeg" : t).map((t) => t.toLowerCase() === "svg" ? "svg+xml" : t).map((t) => `image/${t}`).join(",") : "image/*", U3 = ({
  acceptedImageFormats: e,
  translate: t
}) => /* @__PURE__ */ ge(Bt, { children: [
  /* @__PURE__ */ p(Ne, { component: "b", variant: "body1", children: t("Das Dateiformat ist nicht erlaubt!") }),
  /* @__PURE__ */ p(Ne, { component: "small", variant: "caption", children: `${t("Erlaubte Formate:")} ${e.join(", ")}` })
] }), WJ = Se.memo(({
  acceptedImageFormats: e = ["png", "jpg"],
  ...t
}) => {
  const i = BJ(), {
    t: n
  } = ii(), g = (w) => (t.target != "frontend" ? n(w) : i(w)) || "", r = Ct(null), [o, I] = At(!1), [s, a] = At(null), [d, C] = At(void 0), u = 250, [A, m] = At(u), [h, B] = At(!1);
  et(() => {
    t.onUploading && t.onUploading(h);
  }, [h]), et(() => {
    t.url != d && C(t.url);
  }, [t.url]);
  const f = ft((w) => {
    let v = w == null ? void 0 : w.split(".").pop().toLowerCase();
    return v = v === "jpeg" ? "jpg" : v, e == null ? void 0 : e.includes(v);
  }, [e]), G = (w) => {
    var v;
    w.stopPropagation(), (v = r.current) == null || v.click();
  }, y = (w) => new Promise((v) => {
    const H = document.createElement("img");
    H.src = w, H.onload = () => {
      H.height < A ? v(H.height) : A != u ? v(u) : v(0);
    };
  }), W = ft((w) => {
    const v = async (H) => {
      B(!0);
      try {
        let x = "";
        t.storeLocally ? x = window.URL.createObjectURL(H) : x = (await $$e(t.app, "image", [H]))[H.name], y(x).then((N) => {
          a(H), C(x), t.onUrlChange && t.onUrlChange(x), N > 0 && m(N);
        });
      } catch {
        ef(/* @__PURE__ */ p(Ne, { children: n("Datei konnte nicht hochgeladen werden.") }));
      }
      B(!1);
    };
    e ? w == null || f(w.name) ? (I(!1), v(w)) : I(!0) : v(w);
  }, [t, f, e]), V = (w) => {
    w == null || w.stopPropagation(), I(!1), C(void 0), a(null), t.onDelete();
  };
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    width: 1,
    height: 1
  }, display: "flex", alignItems: "center", flexWrap: "wrap", "data-cy": t["data-cy"], children: /* @__PURE__ */ p(Cn, { disableInteractive: !1, disableHoverListener: t.disabled, disableFocusListener: t.disabled, leaveDelay: 500, title: /* @__PURE__ */ ge(fe, { component: "div", display: "flex", flexDirection: "column", children: [
    o && /* @__PURE__ */ p(U3, { acceptedImageFormats: e, translate: g }),
    !o && !s && !d && e && /* @__PURE__ */ p(Ne, { component: "small", variant: "caption", children: `${g("Bild hochladen")}. ${g("Erlaubte Formate:")} ${e.join(", ")}` }),
    d && /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "grid",
      gap: 1,
      gridAutoFlow: "column"
    }, children: [
      /* @__PURE__ */ p(Si, { "data-cy": "replace", variant: "outlined", size: "small", color: "inherit", onClick: G, startIcon: /* @__PURE__ */ p(u6e, { color: "inherit" }), children: g("Ersetzen") }),
      /* @__PURE__ */ p(Si, { "data-cy": "delete", variant: "outlined", size: "small", color: "inherit", onClick: V, startIcon: /* @__PURE__ */ p(LZ, { color: "inherit" }), children: g("Löschen") })
    ] })
  ] }), children: /* @__PURE__ */ p(fe, { component: "div", sx: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, children: /* @__PURE__ */ ge(fo, { "data-cy": "imageUpload", disabled: t.disabled, sx: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0 20px"
  }, onClick: G, children: [
    o && /* @__PURE__ */ p(U3, { acceptedImageFormats: e, translate: g }),
    h ? /* @__PURE__ */ p(Ime, { sx: {
      width: "100%"
    } }) : /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p("input", { "data-cy": "imageInput", ref: r, onChange: (w) => {
        var v, H;
        if ((H = (v = w == null ? void 0 : w.target) == null ? void 0 : v.files) != null && H[0]) {
          const x = w.target.files[0];
          W(x), w.target.value = "";
        }
      }, type: "file", accept: Rqe(e), hidden: !0 }),
      d ? /* @__PURE__ */ p("img", { style: {
        objectFit: "contain",
        flex: 1,
        overflow: "hidden",
        height: d ? A : "45px",
        padding: 1,
        maxHeight: "100%"
      }, alt: "", src: d }) : /* @__PURE__ */ p(B6e, {})
    ] })
  ] }) }) }) });
});
var SJ = {}, kk = {};
const Xqe = /* @__PURE__ */ yc(iae);
var P3;
function Kg() {
  return P3 || (P3 = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = Xqe;
  }(kk)), kk;
}
var Hqe = Cg;
Object.defineProperty(SJ, "__esModule", {
  value: !0
});
var A7 = SJ.default = void 0, kqe = Hqe(Kg()), Fqe = xg;
A7 = SJ.default = (0, kqe.default)(/* @__PURE__ */ (0, Fqe.jsx)("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings");
const Yqe = (e) => (et(() => {
  const t = e.targetRef.current, i = (o) => {
    const I = t.getBoundingClientRect();
    (o.touches[0].clientX < I.left || o.touches[0].clientX > I.right || o.touches[0].clientY < I.top || o.touches[0].clientY > I.bottom) && e.onClickAway(o);
  }, n = (o) => {
    const I = t.getBoundingClientRect();
    (o.clientX < I.left || o.clientX > I.right || o.clientY < I.top || o.clientY > I.bottom) && e.onClickAway(o);
  }, g = (o) => {
    const I = t.getBoundingClientRect();
    o.clientX > I.left && o.clientX < I.right && o.clientY > I.top && o.clientY < I.bottom && e.onClickInside(o);
  }, r = (o) => {
    const I = t.getBoundingClientRect();
    o.touches[0].clientX > I.left && o.touches[0].clientX < I.right && o.touches[0].clientY > I.top && o.touches[0].clientY < I.bottom && e.onClickInside(o);
  };
  return t && (e.onClickAway && window.addEventListener("click", n), e.onClickAway && window.addEventListener("touchstart", i), e.onClickInside && t.addEventListener("click", g), e.onClickInside && t.addEventListener("touchstart", r)), () => {
    window.removeEventListener("click", n), window.removeEventListener("touchstart", i), t.removeEventListener("click", g), t.removeEventListener("touchstart", r);
  };
}, [e.onClickAway, e.onClickInside, e.targetRef]), /* @__PURE__ */ p(Bt, { children: e.children })), xqe = (e) => /* @__PURE__ */ ge(Bt, { children: [
  e.children,
  /* @__PURE__ */ p(vZ, { in: e.showUnfoldContent, children: /* @__PURE__ */ ge(Bt, { children: [
    e.divider && /* @__PURE__ */ p(bs, {}),
    e.unfoldContent
  ] }) })
] }), Dqe = (e) => {
  const t = Ct(null);
  return /* @__PURE__ */ ge(Bt, { children: [
    (e.showUnfoldContent || e.alwaysShowContour) && /* @__PURE__ */ p(Yqe, { targetRef: t, onClickAway: e.onClickAway, onClickInside: e.onClickInside, children: /* @__PURE__ */ p(_t, { sx: {
      ml: -2
    }, children: /* @__PURE__ */ p(So, { "data-cy": "variableContainer_", elevation: e.showUnfoldContent || e.alwaysShowContour ? 4 : 0, sx: {
      pt: 0,
      pb: 2,
      pl: 2,
      pr: 2,
      transition: "all 0.3s"
    }, ref: t, children: /* @__PURE__ */ p(xqe, { ...e }) }) }) }),
    !e.showUnfoldContent && !e.alwaysShowContour && e.children
  ] });
}, Jqe = (e) => {
  var n;
  const [t, i] = At(!1);
  return et(() => {
    e.hideAdvancedSettings && i(!1);
  }, [e.hideAdvancedSettings]), /* @__PURE__ */ p(Dqe, { unfoldContent: e.advancedSettings, onClickAway: () => i(!1), showUnfoldContent: !e.hideAdvancedSettings && t, children: /* @__PURE__ */ p(Gu, { ...e, InputProps: {
    ...e.InputProps,
    ...!e.hideAdvancedSettings && {
      endAdornment: /* @__PURE__ */ ge(Bt, { children: [
        (n = e.InputProps) == null ? void 0 : n.endAdornment,
        /* @__PURE__ */ p(pm, { position: "end", children: /* @__PURE__ */ p(mi, { "data-cy": "advanceedSettingsButton", size: "small", onClick: () => {
          i(!t);
        }, children: /* @__PURE__ */ p(A7, {}) }) })
      ] })
    }
  } }) });
}, Kqe = (e, t, i, n, g = 500) => {
  const [r, o] = At({
    value: t,
    preDebounceValue: t
  });
  et(() => {
    e && r.preDebounceValue !== t && o({
      value: t,
      preDebounceValue: t
    });
  }, [e, t, r.preDebounceValue]);
  const I = ft(ce.debounce((d) => {
    o((C) => ({
      ...C,
      value: d
    })), i && i(d);
  }, g), [i]), s = ft((d) => {
    o((C) => ({
      ...C,
      value: d
    })), I(d);
  }, [I]), a = (d) => {
    e && I.flush(), n && n(d);
  };
  return {
    debouncedValue: r.value,
    handleDebouncedChange: s,
    handleDebouncedBlur: a
  };
}, b7 = Se.memo((e) => /* @__PURE__ */ p(Ne, { component: "div", color: "textSecondary", className: Ve("k3-form-label", e.className), children: e.children })), $n = Sl(({
  TextFieldProps: {
    defaultValue: e,
    error: t,
    helperText: i,
    inputProps: n,
    ...g
  } = {},
  advancedSettings: r,
  "data-cy": o,
  ...I
}, s) => {
  const {
    t: a
  } = ii(), {
    minRows: d,
    maxRows: C,
    name: u,
    type: A,
    autoComplete: m,
    disabled: h,
    required: B,
    multiline: f,
    placeholder: G,
    autoFocus: y
  } = I;
  Object.assign(g, {
    minRows: d,
    maxRows: C,
    name: u,
    type: A,
    autoComplete: m,
    disabled: h,
    required: B,
    multiline: f,
    placeholder: G,
    autoFocus: y
  });
  const W = ($) => {
    var E, L;
    const q = $.target.value;
    (E = g.onChange) == null || E.call(g, $), (L = I.onChange) == null || L.call(I, q);
  }, V = ($) => {
    var L;
    $.stopPropagation();
    const q = $.key === "Enter", {
      value: E
    } = $.target;
    q && ((L = I.onConfirm) == null || L.call(I, E));
  }, w = ($) => {
    var q, E;
    (q = g.onBlur) == null || q.call(g, $), (E = I.onBlur) == null || E.call(I, $);
  }, {
    debouncedValue: v,
    handleDebouncedChange: H,
    handleDebouncedBlur: x
  } = Kqe(I.debounced, I.value || "", I.onChange, w, I.debounceTimeMs), N = ft(($) => H($.target.value), [H]), M = je(() => r ? (g.advancedSettings = r, Jqe) : Gu, [r]);
  return /* @__PURE__ */ ge(fs, { fullWidth: I.fullWidth, className: Ve("k3-text-input-container", I.className), children: [
    /* @__PURE__ */ p(b7, { children: ufe(I.label) ? a(I.label) : I.label }),
    /* @__PURE__ */ p(M, { variant: "outlined", onKeyDown: V, InputLabelProps: {
      shrink: !I.label
    }, defaultValue: e, inputRef: s, error: t, helperText: i ? /* @__PURE__ */ p(Bt, { children: i }) : void 0, inputProps: ce.merge({}, n, {
      "data-cy": o
    }), ...g, onChange: I.debounced ? N : W, onBlur: I.debounced ? x : w, value: I.debounced ? v : I.value })
  ] });
}), Eqe = (e) => ce.isNumber(e) ? (t) => t.toFixed(e) : me.identity, Nqe = (e) => (t) => Math.round(t / e) * e, z1 = ({
  TextFieldProps: e = {},
  min: t = -1 / 0,
  max: i = 1 / 0,
  digits: n,
  step: g = 1,
  unit: r,
  onChange: o,
  onConfirm: I,
  debounced: s,
  debounceTimeMs: a,
  onChangeByStep: d,
  onBlur: C,
  onClear: u,
  value: A,
  allowEmpty: m,
  roundToStep: h = !1,
  buttons: B = !1,
  calculated: f = !1,
  label: G,
  useRaw: y,
  forceLimit: W,
  fullWidth: V,
  disabled: w,
  placeholder: v,
  "data-cy": H
}) => {
  const x = t ?? -1 / 0, N = i ?? 1 / 0, M = Ct(), $ = ft((le) => UL(!!le, me.flow(parseFloat, UL(h, Nqe(g)), me.clamp(x, N), Eqe(n)))(le), [n, N, x, h, g]), q = ft((le) => {
    const Ae = le.target.value;
    if (y) {
      const we = W ? $(Ae) : Ae;
      o(we);
    } else
      C ? C($(Ae)) : o(!Ae && !m ? me.toString(x) : me.toString($(Ae)));
  }, [o, $, x, C, y]), E = ft((le) => {
    var we;
    const Ae = Number(A) + g * (le ? 1 : -1);
    (we = d || o) == null || we(Ae);
  }, [o, d, g, A]), L = ft(() => E(!0), [E]), P = ft(() => E(!1), [E]), Q = je(() => ({
    sx: {
      "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0
      },
      "input[type=number]": {
        MozAppearance: "textfield"
      }
    },
    ...B ? {
      startAdornment: /* @__PURE__ */ ge(pm, { position: "start", children: [
        /* @__PURE__ */ p(mi, { "data-cy": "plus", className: "k3-number-icon k3-number-icon-plus", sx: {
          p: 0.5
        }, onClick: L, tabIndex: -1, disabled: w, children: /* @__PURE__ */ p(o6e, {}) }, "add-button"),
        /* @__PURE__ */ p(mi, { "data-cy": "minus", className: "k3-number-icon k3-number-icon-minus", sx: {
          p: 0.5
        }, onClick: P, tabIndex: -1, disabled: w, children: /* @__PURE__ */ p(W6e, {}) }, "remove-button")
      ] }, "adornment")
    } : {},
    ...r || u ? {
      endAdornment: /* @__PURE__ */ ge(pm, { position: "end", children: [
        r,
        u && /* @__PURE__ */ p(mi, { "data-cy": "clear", size: "small", onMouseDown: (le) => {
          le.preventDefault(), le.stopPropagation(), u();
        }, tabIndex: -1, children: /* @__PURE__ */ p(LZ, {}) }, "clear")
      ] })
    } : {},
    ...f ? {
      startAdornment: /* @__PURE__ */ p(pm, { position: "start", children: "=" })
    } : {}
  }), [B, f, w, P, L, u, r]), te = je(() => {
    var le;
    return me.merge(e, {
      type: "number",
      inputProps: {
        readOnly: f,
        step: g,
        style: {
          textAlign: ((le = e == null ? void 0 : e.style) == null ? void 0 : le.textAlign) || "right"
        }
      }
    });
  }, [e, f, g]);
  return /* @__PURE__ */ p($n, { "data-cy": H, ref: M, value: !m || A ? A : "", onChange: o, onBlur: q, TextFieldProps: {
    ...te,
    InputProps: Q
  }, type: "number", label: G, fullWidth: V, debounced: s, onConfirm: I, debounceTimeMs: a, disabled: w, placeholder: v, className: "k3-number-input" });
}, Lqe = {
  formControlLabel: {
    width: 1,
    margin: 0,
    "& .MuiTypography-root": {
      width: 1
    }
  }
};
function m7(e) {
  const {
    checked: t,
    onChange: i,
    ...n
  } = e.SwitchProps || {}, g = t === void 0 ? e.checked : t, r = (o) => {
    i && i(o, !!o.target), e.onChange && e.onChange(o.target.checked);
  };
  return /* @__PURE__ */ ge(fs, { fullWidth: !0, variant: "outlined", children: [
    /* @__PURE__ */ p(Ne, { color: "textSecondary", children: e.label }),
    /* @__PURE__ */ p(e1, { sx: Lqe.formControlLabel, componentsProps: {
      typography: {
        color: "text.primary"
      }
    }, control: /* @__PURE__ */ p(QO, { "data-cy": e["data-cy"], checked: g || !1, onChange: r, ...n }), label: e.description || "" })
  ] });
}
const Tqe = (e) => {
  const [t, i] = At(""), n = (g) => {
    const r = e.setting.isValid || e.setting.valueType === lc.ARRAY ? b$e : void 0;
    if (r) {
      const [o, I] = r(g);
      i(I), o && e.setValue(g);
    } else
      e.setValue(g);
  };
  return /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ p(Mqe, { setting: e.setting, value: e.value, setValue: n }),
    t && /* @__PURE__ */ p(Ne, { pt: 1, color: "error", children: t })
  ] });
}, Mqe = ({
  setting: e,
  value: t,
  setValue: i
}) => {
  var s;
  const {
    t: n
  } = ii(), g = un(), r = n(e.label || (typeof e.defaultValue == "string" ? e.defaultValue : e.key)), o = _(ng), I = _(Vs);
  if ([lc.STRING, lc.ARRAY].includes(e.valueType))
    return /* @__PURE__ */ p($n, { "data-cy": `dynamic-${t}`, value: t || "", onChange: i, label: r, fullWidth: !0, placeholder: e.defaultValue });
  if (e.valueType === lc.NUMBER)
    return /* @__PURE__ */ p(z1, { onChange: i, value: t, label: r, fullWidth: !0, "data-cy": "dynamicNumberInput", min: e.min || 0, max: e.max || void 0, placeholder: ((s = e.defaultValue) == null ? void 0 : s.toString()) || void 0 });
  if (e.valueType === lc.TRANSLATION) {
    const a = t, d = g("", e.defaultValue);
    return /* @__PURE__ */ p($n, { "data-cy": "dynamicTranslation", value: (a == null ? void 0 : a[o]) || "", onChange: (C) => i({
      ...a,
      [o]: C
    }), label: n(r), multiline: e.textarea, fullWidth: !0, placeholder: d != null && d.startsWith("[") ? d.replace(/\[|\]/g, "") : d });
  }
  if (e.valueType === lc.BOOLEAN) {
    const a = t ?? e.defaultValue;
    return /* @__PURE__ */ p(m7, { checked: a, onChange: i, label: r, "data-cy": "dynamicBoolean" });
  }
  return e.valueType === lc.IMAGE ? /* @__PURE__ */ p(WJ, { url: t, app: I, onDelete: () => i(void 0), onUrlChange: i, "data-cy": "imageUpload" }) : /* @__PURE__ */ p(Ne, { children: "This type of setting is not implemented yet." });
}, Uqe = ({
  values: e,
  setValues: t
}) => {
  const i = fye("keys"), {
    keys: n,
    settings: g
  } = _((a) => a.configurator.dynamicSettingsEditing) || {}, r = J1(), o = _(Vj), I = (a) => (d) => t({
    ...e,
    [a]: d
  }), s = je(() => {
    var a;
    return !(i != null && i.length) && (g != null && g.length) ? g : (a = n != null && n.length ? n : i) == null ? void 0 : a.map((d) => r.find((u) => u.key === d)).filter((d) => !!d);
  }, [i, r]);
  return s != null && s.length ? /* @__PURE__ */ p(fe, { component: "div", children: s.map((a) => /* @__PURE__ */ p(fe, { component: "div", mb: 2, children: /* @__PURE__ */ p(Tqe, { setting: a, value: e[a.key] ?? o[a.key], setValue: I(a.key) }) }, a.key)) }) : (console.error("DynamicSettingsForm: Could not find dynamic settings to display."), null);
};
class Ch {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    const i = {
      listener: t
    };
    return this.listeners.add(i), this.onSubscribe(), () => {
      this.listeners.delete(i), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const tZ = typeof window > "u" || "Deno" in window;
function ll() {
}
function Pqe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function QY(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function fKt(e, t) {
  return e.filter((i) => !t.includes(i));
}
function GKt(e, t, i) {
  const n = e.slice(0);
  return n[t] = i, n;
}
function h7(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function $0(e, t, i) {
  return uh(e) ? typeof t == "function" ? {
    ...i,
    queryKey: e,
    queryFn: t
  } : {
    ...t,
    queryKey: e
  } : e;
}
function zqe(e, t, i) {
  return uh(e) ? typeof t == "function" ? {
    ...i,
    mutationKey: e,
    mutationFn: t
  } : {
    ...t,
    mutationKey: e
  } : typeof e == "function" ? {
    ...t,
    mutationFn: e
  } : {
    ...e
  };
}
function hd(e, t, i) {
  return uh(e) ? [{
    ...t,
    queryKey: e
  }, i] : [e || {}, t];
}
function yKt(e, t, i) {
  return uh(e) ? [{
    ...t,
    mutationKey: e
  }, i] : [{}, t];
}
function z3(e, t) {
  const {
    type: i = "all",
    exact: n,
    fetchStatus: g,
    predicate: r,
    queryKey: o,
    stale: I
  } = e;
  if (uh(o)) {
    if (n) {
      if (t.queryHash !== VJ(o, t.options))
        return !1;
    } else if (!rV(t.queryKey, o))
      return !1;
  }
  if (i !== "all") {
    const s = t.isActive();
    if (i === "active" && !s || i === "inactive" && s)
      return !1;
  }
  return !(typeof I == "boolean" && t.isStale() !== I || typeof g < "u" && g !== t.state.fetchStatus || r && !r(t));
}
function O3(e, t) {
  const {
    exact: i,
    fetching: n,
    predicate: g,
    mutationKey: r
  } = e;
  if (uh(r)) {
    if (!t.options.mutationKey)
      return !1;
    if (i) {
      if (yu(t.options.mutationKey) !== yu(r))
        return !1;
    } else if (!rV(t.options.mutationKey, r))
      return !1;
  }
  return !(typeof n == "boolean" && t.state.status === "loading" !== n || g && !g(t));
}
function VJ(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || yu)(e);
}
function yu(e) {
  return JSON.stringify(e, (t, i) => jY(i) ? Object.keys(i).sort().reduce((n, g) => (n[g] = i[g], n), {}) : i);
}
function rV(e, t) {
  return p7(e, t);
}
function p7(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((i) => !p7(e[i], t[i])) : !1;
}
function B7(e, t) {
  if (e === t)
    return e;
  const i = Q3(e) && Q3(t);
  if (i || jY(e) && jY(t)) {
    const n = i ? e.length : Object.keys(e).length, g = i ? t : Object.keys(t), r = g.length, o = i ? [] : {};
    let I = 0;
    for (let s = 0; s < r; s++) {
      const a = i ? s : g[s];
      o[a] = B7(e[a], t[a]), o[a] === e[a] && I++;
    }
    return n === r && I === n ? e : o;
  }
  return t;
}
function oV(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const i in e)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function Q3(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function jY(e) {
  if (!j3(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const i = t.prototype;
  return !(!j3(i) || !i.hasOwnProperty("isPrototypeOf"));
}
function j3(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function uh(e) {
  return Array.isArray(e);
}
function Z7(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function _3(e) {
  Z7(0).then(e);
}
function Oqe() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function _Y(e, t, i) {
  return i.isDataEqual != null && i.isDataEqual(e, t) ? e : typeof i.structuralSharing == "function" ? i.structuralSharing(e, t) : i.structuralSharing !== !1 ? B7(e, t) : t;
}
class Qqe extends Ch {
  constructor() {
    super(), this.setup = (t) => {
      if (!tZ && window.addEventListener) {
        const i = () => t();
        return window.addEventListener("visibilitychange", i, !1), window.addEventListener("focus", i, !1), () => {
          window.removeEventListener("visibilitychange", i), window.removeEventListener("focus", i);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var i;
    this.setup = t, (i = this.cleanup) == null || i.call(this), this.cleanup = t((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(t) {
    this.focused !== t && (this.focused = t, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const IV = new Qqe(), $3 = ["online", "offline"];
class jqe extends Ch {
  constructor() {
    super(), this.setup = (t) => {
      if (!tZ && window.addEventListener) {
        const i = () => t();
        return $3.forEach((n) => {
          window.addEventListener(n, i, !1);
        }), () => {
          $3.forEach((n) => {
            window.removeEventListener(n, i);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var i;
    this.setup = t, (i = this.cleanup) == null || i.call(this), this.cleanup = t((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(t) {
    this.online !== t && (this.online = t, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const lV = new jqe();
function _qe(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function O1(e) {
  return (e ?? "online") === "online" ? lV.isOnline() : !0;
}
class f7 {
  constructor(t) {
    this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}
function aS(e) {
  return e instanceof f7;
}
function G7(e) {
  let t = !1, i = 0, n = !1, g, r, o;
  const I = new Promise((B, f) => {
    r = B, o = f;
  }), s = (B) => {
    n || (A(new f7(B)), e.abort == null || e.abort());
  }, a = () => {
    t = !0;
  }, d = () => {
    t = !1;
  }, C = () => !IV.isFocused() || e.networkMode !== "always" && !lV.isOnline(), u = (B) => {
    n || (n = !0, e.onSuccess == null || e.onSuccess(B), g == null || g(), r(B));
  }, A = (B) => {
    n || (n = !0, e.onError == null || e.onError(B), g == null || g(), o(B));
  }, m = () => new Promise((B) => {
    g = (f) => {
      const G = n || !C();
      return G && B(f), G;
    }, e.onPause == null || e.onPause();
  }).then(() => {
    g = void 0, n || e.onContinue == null || e.onContinue();
  }), h = () => {
    if (n)
      return;
    let B;
    try {
      B = e.fn();
    } catch (f) {
      B = Promise.reject(f);
    }
    Promise.resolve(B).then(u).catch((f) => {
      var G, y;
      if (n)
        return;
      const W = (G = e.retry) != null ? G : 3, V = (y = e.retryDelay) != null ? y : _qe, w = typeof V == "function" ? V(i, f) : V, v = W === !0 || typeof W == "number" && i < W || typeof W == "function" && W(i, f);
      if (t || !v) {
        A(f);
        return;
      }
      i++, e.onFail == null || e.onFail(i, f), Z7(w).then(() => {
        if (C())
          return m();
      }).then(() => {
        t ? A(f) : h();
      });
    });
  };
  return O1(e.networkMode) ? h() : m().then(h), {
    promise: I,
    cancel: s,
    continue: () => (g == null ? void 0 : g()) ? I : Promise.resolve(),
    cancelRetry: a,
    continueRetry: d
  };
}
const wJ = console;
function $qe() {
  let e = [], t = 0, i = (d) => {
    d();
  }, n = (d) => {
    d();
  };
  const g = (d) => {
    let C;
    t++;
    try {
      C = d();
    } finally {
      t--, t || I();
    }
    return C;
  }, r = (d) => {
    t ? e.push(d) : _3(() => {
      i(d);
    });
  }, o = (d) => (...C) => {
    r(() => {
      d(...C);
    });
  }, I = () => {
    const d = e;
    e = [], d.length && _3(() => {
      n(() => {
        d.forEach((C) => {
          i(C);
        });
      });
    });
  };
  return {
    batch: g,
    batchCalls: o,
    schedule: r,
    setNotifyFunction: (d) => {
      i = d;
    },
    setBatchNotifyFunction: (d) => {
      n = d;
    }
  };
}
const dg = $qe();
class y7 {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), QY(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(t) {
    this.cacheTime = Math.max(this.cacheTime || 0, t ?? (tZ ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class qqe extends y7 {
  constructor(t) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.cache = t.cache, this.logger = t.logger || wJ, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.initialState = t.state || eet(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(t, i) {
    const n = _Y(this.state.data, t, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: i == null ? void 0 : i.updatedAt,
      manual: i == null ? void 0 : i.manual
    }), n;
  }
  setState(t, i) {
    this.dispatch({
      type: "setState",
      state: t,
      setStateOptions: i
    });
  }
  cancel(t) {
    var i;
    const n = this.promise;
    return (i = this.retryer) == null || i.cancel(t), n ? n.then(ll).catch(ll) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !h7(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const i = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    i && i.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  onOnline() {
    var t;
    const i = this.observers.find((n) => n.shouldFetchOnReconnect());
    i && i.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((i) => i !== t), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: t
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(t, i) {
    var n, g;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && i != null && i.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var r;
        return (r = this.retryer) == null || r.continueRetry(), this.promise;
      }
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const A = this.observers.find((m) => m.options.queryFn);
      A && this.setOptions(A.options);
    }
    const o = Oqe(), I = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, s = (A) => {
      Object.defineProperty(A, "signal", {
        enumerable: !0,
        get: () => {
          if (o)
            return this.abortSignalConsumed = !0, o.signal;
        }
      });
    };
    s(I);
    const a = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(I)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), d = {
      fetchOptions: i,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: a
    };
    if (s(d), (n = this.options.behavior) == null || n.onFetch(d), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((g = d.fetchOptions) == null ? void 0 : g.meta)) {
      var C;
      this.dispatch({
        type: "fetch",
        meta: (C = d.fetchOptions) == null ? void 0 : C.meta
      });
    }
    const u = (A) => {
      if (aS(A) && A.silent || this.dispatch({
        type: "error",
        error: A
      }), !aS(A)) {
        var m, h, B, f;
        (m = (h = this.cache.config).onError) == null || m.call(h, A, this), (B = (f = this.cache.config).onSettled) == null || B.call(f, this.state.data, A, this);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = G7({
      fn: d.fetchFn,
      abort: o == null ? void 0 : o.abort.bind(o),
      onSuccess: (A) => {
        var m, h, B, f;
        if (typeof A > "u") {
          u(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(A), (m = (h = this.cache.config).onSuccess) == null || m.call(h, A, this), (B = (f = this.cache.config).onSettled) == null || B.call(f, A, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: u,
      onFail: (A, m) => {
        this.dispatch({
          type: "failed",
          failureCount: A,
          error: m
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: d.options.retry,
      retryDelay: d.options.retryDelay,
      networkMode: d.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(t) {
    const i = (n) => {
      var g, r;
      switch (t.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (g = t.meta) != null ? g : null,
            fetchStatus: O1(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: t.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (r = t.dataUpdatedAt) != null ? r : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const o = t.error;
          return aS(o) && o.revert && this.revertState ? {
            ...this.revertState,
            fetchStatus: "idle"
          } : {
            ...n,
            error: o,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: o,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = i(this.state), dg.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(t);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }
}
function eet(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, i = typeof t < "u", n = i ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: i ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: i ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class tet extends Ch {
  constructor(t) {
    super(), this.config = t || {}, this.queries = [], this.queriesMap = {};
  }
  build(t, i, n) {
    var g;
    const r = i.queryKey, o = (g = i.queryHash) != null ? g : VJ(r, i);
    let I = this.get(o);
    return I || (I = new qqe({
      cache: this,
      logger: t.getLogger(),
      queryKey: r,
      queryHash: o,
      options: t.defaultQueryOptions(i),
      state: n,
      defaultOptions: t.getQueryDefaults(r)
    }), this.add(I)), I;
  }
  add(t) {
    this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const i = this.queriesMap[t.queryHash];
    i && (t.destroy(), this.queries = this.queries.filter((n) => n !== t), i === t && delete this.queriesMap[t.queryHash], this.notify({
      type: "removed",
      query: t
    }));
  }
  clear() {
    dg.batch(() => {
      this.queries.forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.queriesMap[t];
  }
  getAll() {
    return this.queries;
  }
  find(t, i) {
    const [n] = hd(t, i);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((g) => z3(n, g));
  }
  findAll(t, i) {
    const [n] = hd(t, i);
    return Object.keys(n).length > 0 ? this.queries.filter((g) => z3(n, g)) : this.queries;
  }
  notify(t) {
    dg.batch(() => {
      this.listeners.forEach(({
        listener: i
      }) => {
        i(t);
      });
    });
  }
  onFocus() {
    dg.batch(() => {
      this.queries.forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    dg.batch(() => {
      this.queries.forEach((t) => {
        t.onOnline();
      });
    });
  }
}
class iet extends y7 {
  constructor(t) {
    super(), this.defaultOptions = t.defaultOptions, this.mutationId = t.mutationId, this.mutationCache = t.mutationCache, this.logger = t.logger || wJ, this.observers = [], this.state = t.state || W7(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(t) {
    this.dispatch({
      type: "setState",
      state: t
    });
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers = this.observers.filter((i) => i !== t), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var t, i;
    return (t = (i = this.retryer) == null ? void 0 : i.continue()) != null ? t : this.execute();
  }
  async execute() {
    const t = () => {
      var v;
      return this.retryer = G7({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (H, x) => {
          this.dispatch({
            type: "failed",
            failureCount: H,
            error: x
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (v = this.options.retry) != null ? v : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, i = this.state.status === "loading";
    try {
      var n, g, r, o, I, s, a, d;
      if (!i) {
        var C, u, A, m;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((C = (u = this.mutationCache.config).onMutate) == null ? void 0 : C.call(u, this.state.variables, this));
        const H = await ((A = (m = this.options).onMutate) == null ? void 0 : A.call(m, this.state.variables));
        H !== this.state.context && this.dispatch({
          type: "loading",
          context: H,
          variables: this.state.variables
        });
      }
      const v = await t();
      return await ((n = (g = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(g, v, this.state.variables, this.state.context, this)), await ((r = (o = this.options).onSuccess) == null ? void 0 : r.call(o, v, this.state.variables, this.state.context)), await ((I = (s = this.mutationCache.config).onSettled) == null ? void 0 : I.call(s, v, null, this.state.variables, this.state.context, this)), await ((a = (d = this.options).onSettled) == null ? void 0 : a.call(d, v, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: v
      }), v;
    } catch (v) {
      try {
        var h, B, f, G, y, W, V, w;
        throw await ((h = (B = this.mutationCache.config).onError) == null ? void 0 : h.call(B, v, this.state.variables, this.state.context, this)), await ((f = (G = this.options).onError) == null ? void 0 : f.call(G, v, this.state.variables, this.state.context)), await ((y = (W = this.mutationCache.config).onSettled) == null ? void 0 : y.call(W, void 0, v, this.state.variables, this.state.context, this)), await ((V = (w = this.options).onSettled) == null ? void 0 : V.call(w, void 0, v, this.state.variables, this.state.context)), v;
      } finally {
        this.dispatch({
          type: "error",
          error: v
        });
      }
    }
  }
  dispatch(t) {
    const i = (n) => {
      switch (t.type) {
        case "failed":
          return {
            ...n,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !O1(this.options.networkMode),
            status: "loading",
            variables: t.variables
          };
        case "success":
          return {
            ...n,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: t.error,
            failureCount: n.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = i(this.state), dg.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(t);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
}
function W7() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class net extends Ch {
  constructor(t) {
    super(), this.config = t || {}, this.mutations = [], this.mutationId = 0;
  }
  build(t, i, n) {
    const g = new iet({
      mutationCache: this,
      logger: t.getLogger(),
      mutationId: ++this.mutationId,
      options: t.defaultMutationOptions(i),
      state: n,
      defaultOptions: i.mutationKey ? t.getMutationDefaults(i.mutationKey) : void 0
    });
    return this.add(g), g;
  }
  add(t) {
    this.mutations.push(t), this.notify({
      type: "added",
      mutation: t
    });
  }
  remove(t) {
    this.mutations = this.mutations.filter((i) => i !== t), this.notify({
      type: "removed",
      mutation: t
    });
  }
  clear() {
    dg.batch(() => {
      this.mutations.forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(t) {
    return typeof t.exact > "u" && (t.exact = !0), this.mutations.find((i) => O3(t, i));
  }
  findAll(t) {
    return this.mutations.filter((i) => O3(t, i));
  }
  notify(t) {
    dg.batch(() => {
      this.listeners.forEach(({
        listener: i
      }) => {
        i(t);
      });
    });
  }
  resumePausedMutations() {
    var t;
    return this.resuming = ((t = this.resuming) != null ? t : Promise.resolve()).then(() => {
      const i = this.mutations.filter((n) => n.state.isPaused);
      return dg.batch(() => i.reduce((n, g) => n.then(() => g.continue().catch(ll)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function get() {
  return {
    onFetch: (e) => {
      e.fetchFn = () => {
        var t, i, n, g, r, o;
        const I = (t = e.fetchOptions) == null || (i = t.meta) == null ? void 0 : i.refetchPage, s = (n = e.fetchOptions) == null || (g = n.meta) == null ? void 0 : g.fetchMore, a = s == null ? void 0 : s.pageParam, d = (s == null ? void 0 : s.direction) === "forward", C = (s == null ? void 0 : s.direction) === "backward", u = ((r = e.state.data) == null ? void 0 : r.pages) || [], A = ((o = e.state.data) == null ? void 0 : o.pageParams) || [];
        let m = A, h = !1;
        const B = (w) => {
          Object.defineProperty(w, "signal", {
            enumerable: !0,
            get: () => {
              var v;
              if ((v = e.signal) != null && v.aborted)
                h = !0;
              else {
                var H;
                (H = e.signal) == null || H.addEventListener("abort", () => {
                  h = !0;
                });
              }
              return e.signal;
            }
          });
        }, f = e.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + e.options.queryHash + "'")), G = (w, v, H, x) => (m = x ? [v, ...m] : [...m, v], x ? [H, ...w] : [...w, H]), y = (w, v, H, x) => {
          if (h)
            return Promise.reject("Cancelled");
          if (typeof H > "u" && !v && w.length)
            return Promise.resolve(w);
          const N = {
            queryKey: e.queryKey,
            pageParam: H,
            meta: e.options.meta
          };
          B(N);
          const M = f(N);
          return Promise.resolve(M).then((q) => G(w, H, q, x));
        };
        let W;
        if (!u.length)
          W = y([]);
        else if (d) {
          const w = typeof a < "u", v = w ? a : q3(e.options, u);
          W = y(u, w, v);
        } else if (C) {
          const w = typeof a < "u", v = w ? a : ret(e.options, u);
          W = y(u, w, v, !0);
        } else {
          m = [];
          const w = typeof e.options.getNextPageParam > "u";
          W = (I && u[0] ? I(u[0], 0, u) : !0) ? y([], w, A[0]) : Promise.resolve(G([], A[0], u[0]));
          for (let H = 1; H < u.length; H++)
            W = W.then((x) => {
              if (I && u[H] ? I(u[H], H, u) : !0) {
                const M = w ? A[H] : q3(e.options, x);
                return y(x, w, M);
              }
              return Promise.resolve(G(x, A[H], u[H]));
            });
        }
        return W.then((w) => ({
          pages: w,
          pageParams: m
        }));
      };
    }
  };
}
function q3(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function ret(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
class oet {
  constructor(t = {}) {
    this.queryCache = t.queryCache || new tet(), this.mutationCache = t.mutationCache || new net(), this.logger = t.logger || wJ, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0;
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = IV.subscribe(() => {
      IV.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = lV.subscribe(() => {
      lV.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var t, i;
    this.mountCount--, this.mountCount === 0 && ((t = this.unsubscribeFocus) == null || t.call(this), this.unsubscribeFocus = void 0, (i = this.unsubscribeOnline) == null || i.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(t, i) {
    const [n] = hd(t, i);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(t) {
    return this.mutationCache.findAll({
      ...t,
      fetching: !0
    }).length;
  }
  getQueryData(t, i) {
    var n;
    return (n = this.queryCache.find(t, i)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(t, i, n) {
    const g = $0(t, i, n), r = this.getQueryData(g.queryKey);
    return r ? Promise.resolve(r) : this.fetchQuery(g);
  }
  getQueriesData(t) {
    return this.getQueryCache().findAll(t).map(({
      queryKey: i,
      state: n
    }) => {
      const g = n.data;
      return [i, g];
    });
  }
  setQueryData(t, i, n) {
    const g = this.queryCache.find(t), r = g == null ? void 0 : g.state.data, o = Pqe(i, r);
    if (typeof o > "u")
      return;
    const I = $0(t), s = this.defaultQueryOptions(I);
    return this.queryCache.build(this, s).setData(o, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(t, i, n) {
    return dg.batch(() => this.getQueryCache().findAll(t).map(({
      queryKey: g
    }) => [g, this.setQueryData(g, i, n)]));
  }
  getQueryState(t, i) {
    var n;
    return (n = this.queryCache.find(t, i)) == null ? void 0 : n.state;
  }
  removeQueries(t, i) {
    const [n] = hd(t, i), g = this.queryCache;
    dg.batch(() => {
      g.findAll(n).forEach((r) => {
        g.remove(r);
      });
    });
  }
  resetQueries(t, i, n) {
    const [g, r] = hd(t, i, n), o = this.queryCache, I = {
      type: "active",
      ...g
    };
    return dg.batch(() => (o.findAll(g).forEach((s) => {
      s.reset();
    }), this.refetchQueries(I, r)));
  }
  cancelQueries(t, i, n) {
    const [g, r = {}] = hd(t, i, n);
    typeof r.revert > "u" && (r.revert = !0);
    const o = dg.batch(() => this.queryCache.findAll(g).map((I) => I.cancel(r)));
    return Promise.all(o).then(ll).catch(ll);
  }
  invalidateQueries(t, i, n) {
    const [g, r] = hd(t, i, n);
    return dg.batch(() => {
      var o, I;
      if (this.queryCache.findAll(g).forEach((a) => {
        a.invalidate();
      }), g.refetchType === "none")
        return Promise.resolve();
      const s = {
        ...g,
        type: (o = (I = g.refetchType) != null ? I : g.type) != null ? o : "active"
      };
      return this.refetchQueries(s, r);
    });
  }
  refetchQueries(t, i, n) {
    const [g, r] = hd(t, i, n), o = dg.batch(() => this.queryCache.findAll(g).filter((s) => !s.isDisabled()).map((s) => {
      var a;
      return s.fetch(void 0, {
        ...r,
        cancelRefetch: (a = r == null ? void 0 : r.cancelRefetch) != null ? a : !0,
        meta: {
          refetchPage: g.refetchPage
        }
      });
    }));
    let I = Promise.all(o).then(ll);
    return r != null && r.throwOnError || (I = I.catch(ll)), I;
  }
  fetchQuery(t, i, n) {
    const g = $0(t, i, n), r = this.defaultQueryOptions(g);
    typeof r.retry > "u" && (r.retry = !1);
    const o = this.queryCache.build(this, r);
    return o.isStaleByTime(r.staleTime) ? o.fetch(r) : Promise.resolve(o.state.data);
  }
  prefetchQuery(t, i, n) {
    return this.fetchQuery(t, i, n).then(ll).catch(ll);
  }
  fetchInfiniteQuery(t, i, n) {
    const g = $0(t, i, n);
    return g.behavior = get(), this.fetchQuery(g);
  }
  prefetchInfiniteQuery(t, i, n) {
    return this.fetchInfiniteQuery(t, i, n).then(ll).catch(ll);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(t) {
    this.defaultOptions = t;
  }
  setQueryDefaults(t, i) {
    const n = this.queryDefaults.find((g) => yu(t) === yu(g.queryKey));
    n ? n.defaultOptions = i : this.queryDefaults.push({
      queryKey: t,
      defaultOptions: i
    });
  }
  getQueryDefaults(t) {
    if (!t)
      return;
    const i = this.queryDefaults.find((n) => rV(t, n.queryKey));
    return i == null ? void 0 : i.defaultOptions;
  }
  setMutationDefaults(t, i) {
    const n = this.mutationDefaults.find((g) => yu(t) === yu(g.mutationKey));
    n ? n.defaultOptions = i : this.mutationDefaults.push({
      mutationKey: t,
      defaultOptions: i
    });
  }
  getMutationDefaults(t) {
    if (!t)
      return;
    const i = this.mutationDefaults.find((n) => rV(t, n.mutationKey));
    return i == null ? void 0 : i.defaultOptions;
  }
  defaultQueryOptions(t) {
    if (t != null && t._defaulted)
      return t;
    const i = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(t == null ? void 0 : t.queryKey),
      ...t,
      _defaulted: !0
    };
    return !i.queryHash && i.queryKey && (i.queryHash = VJ(i.queryKey, i)), typeof i.refetchOnReconnect > "u" && (i.refetchOnReconnect = i.networkMode !== "always"), typeof i.useErrorBoundary > "u" && (i.useErrorBoundary = !!i.suspense), i;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(t == null ? void 0 : t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class Iet extends Ch {
  constructor(t, i) {
    super(), this.client = t, this.options = i, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(i);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), eT(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return $Y(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return $Y(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(t, i) {
    const n = this.options, g = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(t), oV(n, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = n.queryKey), this.updateQuery();
    const r = this.hasListeners();
    r && tT(this.currentQuery, g, this.options, n) && this.executeFetch(), this.updateResult(i), r && (this.currentQuery !== g || this.options.enabled !== n.enabled || this.options.staleTime !== n.staleTime) && this.updateStaleTimeout();
    const o = this.computeRefetchInterval();
    r && (this.currentQuery !== g || this.options.enabled !== n.enabled || o !== this.currentRefetchInterval) && this.updateRefetchInterval(o);
  }
  getOptimisticResult(t) {
    const i = this.client.getQueryCache().build(this.client, t), n = this.createResult(i, t);
    return aet(this, n, t) && (this.currentResult = n, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), n;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(t) {
    const i = {};
    return Object.keys(t).forEach((n) => {
      Object.defineProperty(i, n, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(n), t[n])
      });
    }), i;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: t,
    ...i
  } = {}) {
    return this.fetch({
      ...i,
      meta: {
        refetchPage: t
      }
    });
  }
  fetchOptimistic(t) {
    const i = this.client.defaultQueryOptions(t), n = this.client.getQueryCache().build(this.client, i);
    return n.isFetchingOptimistic = !0, n.fetch().then(() => this.createResult(n, i));
  }
  fetch(t) {
    var i;
    return this.executeFetch({
      ...t,
      cancelRefetch: (i = t.cancelRefetch) != null ? i : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(t) {
    this.updateQuery();
    let i = this.currentQuery.fetch(this.options, t);
    return t != null && t.throwOnError || (i = i.catch(ll)), i;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), tZ || this.currentResult.isStale || !QY(this.options.staleTime))
      return;
    const i = h7(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, i);
  }
  computeRefetchInterval() {
    var t;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (t = this.options.refetchInterval) != null ? t : !1;
  }
  updateRefetchInterval(t) {
    this.clearRefetchInterval(), this.currentRefetchInterval = t, !(tZ || this.options.enabled === !1 || !QY(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || IV.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(t, i) {
    const n = this.currentQuery, g = this.options, r = this.currentResult, o = this.currentResultState, I = this.currentResultOptions, s = t !== n, a = s ? t.state : this.currentQueryInitialState, d = s ? this.currentResult : this.previousQueryResult, {
      state: C
    } = t;
    let {
      dataUpdatedAt: u,
      error: A,
      errorUpdatedAt: m,
      fetchStatus: h,
      status: B
    } = C, f = !1, G = !1, y;
    if (i._optimisticResults) {
      const H = this.hasListeners(), x = !H && eT(t, i), N = H && tT(t, n, i, g);
      (x || N) && (h = O1(t.options.networkMode) ? "fetching" : "paused", u || (B = "loading")), i._optimisticResults === "isRestoring" && (h = "idle");
    }
    if (i.keepPreviousData && !C.dataUpdatedAt && d != null && d.isSuccess && B !== "error")
      y = d.data, u = d.dataUpdatedAt, B = d.status, f = !0;
    else if (i.select && typeof C.data < "u")
      if (r && C.data === (o == null ? void 0 : o.data) && i.select === this.selectFn)
        y = this.selectResult;
      else
        try {
          this.selectFn = i.select, y = i.select(C.data), y = _Y(r == null ? void 0 : r.data, y, i), this.selectResult = y, this.selectError = null;
        } catch (H) {
          this.selectError = H;
        }
    else
      y = C.data;
    if (typeof i.placeholderData < "u" && typeof y > "u" && B === "loading") {
      let H;
      if (r != null && r.isPlaceholderData && i.placeholderData === (I == null ? void 0 : I.placeholderData))
        H = r.data;
      else if (H = typeof i.placeholderData == "function" ? i.placeholderData() : i.placeholderData, i.select && typeof H < "u")
        try {
          H = i.select(H), this.selectError = null;
        } catch (x) {
          this.selectError = x;
        }
      typeof H < "u" && (B = "success", y = _Y(r == null ? void 0 : r.data, H, i), G = !0);
    }
    this.selectError && (A = this.selectError, y = this.selectResult, m = Date.now(), B = "error");
    const W = h === "fetching", V = B === "loading", w = B === "error";
    return {
      status: B,
      fetchStatus: h,
      isLoading: V,
      isSuccess: B === "success",
      isError: w,
      isInitialLoading: V && W,
      data: y,
      dataUpdatedAt: u,
      error: A,
      errorUpdatedAt: m,
      failureCount: C.fetchFailureCount,
      failureReason: C.fetchFailureReason,
      errorUpdateCount: C.errorUpdateCount,
      isFetched: C.dataUpdateCount > 0 || C.errorUpdateCount > 0,
      isFetchedAfterMount: C.dataUpdateCount > a.dataUpdateCount || C.errorUpdateCount > a.errorUpdateCount,
      isFetching: W,
      isRefetching: W && !V,
      isLoadingError: w && C.dataUpdatedAt === 0,
      isPaused: h === "paused",
      isPlaceholderData: G,
      isPreviousData: f,
      isRefetchError: w && C.dataUpdatedAt !== 0,
      isStale: vJ(t, i),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(t) {
    const i = this.currentResult, n = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, oV(n, i))
      return;
    this.currentResult = n;
    const g = {
      cache: !0
    }, r = () => {
      if (!i)
        return !0;
      const {
        notifyOnChangeProps: o
      } = this.options, I = typeof o == "function" ? o() : o;
      if (I === "all" || !I && !this.trackedProps.size)
        return !0;
      const s = new Set(I ?? this.trackedProps);
      return this.options.useErrorBoundary && s.add("error"), Object.keys(this.currentResult).some((a) => {
        const d = a;
        return this.currentResult[d] !== i[d] && s.has(d);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && r() && (g.listeners = !0), this.notify({
      ...g,
      ...t
    });
  }
  updateQuery() {
    const t = this.client.getQueryCache().build(this.client, this.options);
    if (t === this.currentQuery)
      return;
    const i = this.currentQuery;
    this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (i == null || i.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate(t) {
    const i = {};
    t.type === "success" ? i.onSuccess = !t.manual : t.type === "error" && !aS(t.error) && (i.onError = !0), this.updateResult(i), this.hasListeners() && this.updateTimers();
  }
  notify(t) {
    dg.batch(() => {
      if (t.onSuccess) {
        var i, n, g, r;
        (i = (n = this.options).onSuccess) == null || i.call(n, this.currentResult.data), (g = (r = this.options).onSettled) == null || g.call(r, this.currentResult.data, null);
      } else if (t.onError) {
        var o, I, s, a;
        (o = (I = this.options).onError) == null || o.call(I, this.currentResult.error), (s = (a = this.options).onSettled) == null || s.call(a, void 0, this.currentResult.error);
      }
      t.listeners && this.listeners.forEach(({
        listener: d
      }) => {
        d(this.currentResult);
      }), t.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function set(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function eT(e, t) {
  return set(e, t) || e.state.dataUpdatedAt > 0 && $Y(e, t, t.refetchOnMount);
}
function $Y(e, t, i) {
  if (t.enabled !== !1) {
    const n = typeof i == "function" ? i(e) : i;
    return n === "always" || n !== !1 && vJ(e, t);
  }
  return !1;
}
function tT(e, t, i, n) {
  return i.enabled !== !1 && (e !== t || n.enabled === !1) && (!i.suspense || e.state.status !== "error") && vJ(e, i);
}
function vJ(e, t) {
  return e.isStaleByTime(t.staleTime);
}
function aet(e, t, i) {
  return i.keepPreviousData ? !1 : i.placeholderData !== void 0 ? t.isPlaceholderData : !oV(e.getCurrentResult(), t);
}
let cet = class extends Ch {
  constructor(t, i) {
    super(), this.client = t, this.setOptions(i), this.bindMethods(), this.updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    var i;
    const n = this.options;
    this.options = this.client.defaultMutationOptions(t), oV(n, this.options) || this.client.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.currentMutation,
      observer: this
    }), (i = this.currentMutation) == null || i.setOptions(this.options);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.currentMutation) == null || t.removeObserver(this);
    }
  }
  onMutationUpdate(t) {
    this.updateResult();
    const i = {
      listeners: !0
    };
    t.type === "success" ? i.onSuccess = !0 : t.type === "error" && (i.onError = !0), this.notify(i);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  reset() {
    this.currentMutation = void 0, this.updateResult(), this.notify({
      listeners: !0
    });
  }
  mutate(t, i) {
    return this.mutateOptions = i, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, {
      ...this.options,
      variables: typeof t < "u" ? t : this.options.variables
    }), this.currentMutation.addObserver(this), this.currentMutation.execute();
  }
  updateResult() {
    const t = this.currentMutation ? this.currentMutation.state : W7(), i = {
      ...t,
      isLoading: t.status === "loading",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = i;
  }
  notify(t) {
    dg.batch(() => {
      if (this.mutateOptions && this.hasListeners()) {
        if (t.onSuccess) {
          var i, n, g, r;
          (i = (n = this.mutateOptions).onSuccess) == null || i.call(n, this.currentResult.data, this.currentResult.variables, this.currentResult.context), (g = (r = this.mutateOptions).onSettled) == null || g.call(r, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (t.onError) {
          var o, I, s, a;
          (o = (I = this.mutateOptions).onError) == null || o.call(I, this.currentResult.error, this.currentResult.variables, this.currentResult.context), (s = (a = this.mutateOptions).onSettled) == null || s.call(a, void 0, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      }
      t.listeners && this.listeners.forEach(({
        listener: d
      }) => {
        d(this.currentResult);
      });
    });
  }
};
var S7 = { exports: {} }, V7 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jm = Se;
function det(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Cet = typeof Object.is == "function" ? Object.is : det, uet = Jm.useState, Aet = Jm.useEffect, bet = Jm.useLayoutEffect, met = Jm.useDebugValue;
function het(e, t) {
  var i = t(), n = uet({ inst: { value: i, getSnapshot: t } }), g = n[0].inst, r = n[1];
  return bet(function() {
    g.value = i, g.getSnapshot = t, Fk(g) && r({ inst: g });
  }, [e, i, t]), Aet(function() {
    return Fk(g) && r({ inst: g }), e(function() {
      Fk(g) && r({ inst: g });
    });
  }, [e]), met(i), i;
}
function Fk(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var i = t();
    return !Cet(e, i);
  } catch {
    return !0;
  }
}
function pet(e, t) {
  return t();
}
var Bet = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? pet : het;
V7.useSyncExternalStore = Jm.useSyncExternalStore !== void 0 ? Jm.useSyncExternalStore : Bet;
S7.exports = V7;
var Zet = S7.exports;
const w7 = Zet.useSyncExternalStore, iT = /* @__PURE__ */ Y.createContext(void 0), v7 = /* @__PURE__ */ Y.createContext(!1);
function R7(e, t) {
  return e || (t && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = iT), window.ReactQueryClientContext) : iT);
}
const Ah = ({
  context: e
} = {}) => {
  const t = Y.useContext(R7(e, Y.useContext(v7)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, fet = ({
  client: e,
  children: t,
  context: i,
  contextSharing: n = !1
}) => {
  Y.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]);
  const g = R7(i, n);
  return /* @__PURE__ */ Y.createElement(v7.Provider, {
    value: !i && n
  }, /* @__PURE__ */ Y.createElement(g.Provider, {
    value: e
  }, t));
}, X7 = /* @__PURE__ */ Y.createContext(!1), Get = () => Y.useContext(X7);
X7.Provider;
function yet() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
const Wet = /* @__PURE__ */ Y.createContext(yet()), Vet = () => Y.useContext(Wet);
function H7(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
const wet = (e, t) => {
  (e.suspense || e.useErrorBoundary) && (t.isReset() || (e.retryOnMount = !1));
}, vet = (e) => {
  Y.useEffect(() => {
    e.clearReset();
  }, [e]);
}, Ret = ({
  result: e,
  errorResetBoundary: t,
  useErrorBoundary: i,
  query: n
}) => e.isError && !t.isReset() && !e.isFetching && H7(i, [e.error, n]), Xet = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, Het = (e, t) => e.isLoading && e.isFetching && !t, ket = (e, t, i) => (e == null ? void 0 : e.suspense) && Het(t, i), Fet = (e, t, i) => t.fetchOptimistic(e).then(({
  data: n
}) => {
  e.onSuccess == null || e.onSuccess(n), e.onSettled == null || e.onSettled(n, null);
}).catch((n) => {
  i.clearReset(), e.onError == null || e.onError(n), e.onSettled == null || e.onSettled(void 0, n);
});
function Yet(e, t) {
  const i = Ah({
    context: e.context
  }), n = Get(), g = Vet(), r = i.defaultQueryOptions(e);
  r._optimisticResults = n ? "isRestoring" : "optimistic", r.onError && (r.onError = dg.batchCalls(r.onError)), r.onSuccess && (r.onSuccess = dg.batchCalls(r.onSuccess)), r.onSettled && (r.onSettled = dg.batchCalls(r.onSettled)), Xet(r), wet(r, g), vet(g);
  const [o] = Y.useState(() => new t(i, r)), I = o.getOptimisticResult(r);
  if (w7(Y.useCallback((s) => {
    const a = n ? () => {
    } : o.subscribe(dg.batchCalls(s));
    return o.updateResult(), a;
  }, [o, n]), () => o.getCurrentResult(), () => o.getCurrentResult()), Y.useEffect(() => {
    o.setOptions(r, {
      listeners: !1
    });
  }, [r, o]), ket(r, I, n))
    throw Fet(r, o, g);
  if (Ret({
    result: I,
    errorResetBoundary: g,
    useErrorBoundary: r.useErrorBoundary,
    query: o.getCurrentQuery()
  }))
    throw I.error;
  return r.notifyOnChangeProps ? I : o.trackResult(I);
}
function k7(e, t, i) {
  const n = $0(e, t, i);
  return Yet(n, Iet);
}
function RJ(e, t, i) {
  const n = zqe(e, t, i), g = Ah({
    context: n.context
  }), [r] = Y.useState(() => new cet(g, n));
  Y.useEffect(() => {
    r.setOptions(n);
  }, [r, n]);
  const o = w7(Y.useCallback((s) => r.subscribe(dg.batchCalls(s)), [r]), () => r.getCurrentResult(), () => r.getCurrentResult()), I = Y.useCallback((s, a) => {
    r.mutate(s, a).catch(xet);
  }, [r]);
  if (o.error && H7(r.options.useErrorBoundary, [o.error]))
    throw o.error;
  return {
    ...o,
    mutate: I,
    mutateAsync: o.mutate
  };
}
function xet() {
}
const Rl = (e) => {
  console.error("FETCH-ERROR", e);
};
async function F7(e, t, i = {}) {
  try {
    return await ui("POST", `/${e}`, t, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function Det(e, t, i = {}) {
  try {
    return await ui("POST", `/${e}/bulk`, t, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function Jet(e, t, i = {}) {
  try {
    return await ui("GET", `/${e}/${t}`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function SKt(e, t, i = {}) {
  try {
    const n = new URLSearchParams(t);
    return await ui("GET", `/${e}?${n}`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function Q1(e, t, i = {}) {
  try {
    const n = t.id, g = ce.omit(t, "id");
    return await ui("PUT", `/${e}/${n}`, g, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function Ket(e, t, i = {}) {
  try {
    return await ui("PUT", `/${e}`, t, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function Y7(e, t) {
  try {
    await ui("DELETE", `/${e}/${t}`);
  } catch (i) {
    throw Rl(i), i;
  }
}
async function VKt(e, t) {
  try {
    await ui("PUT", `/${e}/delete`, t);
  } catch (i) {
    throw Rl(i), i;
  }
}
async function wKt(e, t, i, n = {}) {
  try {
    if (!n.appCode)
      throw new Error("Missing App Code for uploadContent!");
    const g = new FormData();
    return g.append("app", n.appCode), e && g.append("path", e + i), (Array.isArray(t) ? t : [t]).forEach((r) => {
      r instanceof File ? g.append("file[]", r, r.name) : g.append("file[]", r.blob, r.fileName);
    }), await jd("POST", "/doc", g);
  } catch (g) {
    throw Rl(g), g;
  }
}
async function Eet(e, t, i, n = {}) {
  try {
    if (!n.appCode)
      throw new Error("Missing App Code for uploadTmpContent!");
    const g = new FormData();
    return g.append("app", n.appCode), e && g.append("path", e + i), (Array.isArray(t) ? t : [t]).forEach((r) => {
      r instanceof File ? g.append("file[]", r, r.name) : g.append("file[]", r.blob, r.fileName);
    }), await jd("POST", "/doc/tmp", g);
  } catch (g) {
    throw alert(g), Rl(g), g;
  }
}
async function vKt(e, t, i = {}) {
  try {
    const n = new URLSearchParams(t);
    return await ui("GET", `/${e}/trash?${n}`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
async function RKt(e, t, i = {}) {
  try {
    return await ui("GET", `/${e}/${t}/undelete`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw Rl(n), n;
  }
}
function XKt(e) {
  const t = Ah(), i = _(ng);
  return RJ((n) => F7(e, n, {
    lang: i
  }), {
    onSuccess: () => {
      t.invalidateQueries([e]), t.invalidateQueries(["metadata"]);
    }
  });
}
function x7(e, t) {
  const i = Ah(), n = _(ng);
  return RJ((g) => Q1(e, g, {
    lang: n
  }), {
    onSuccess: () => {
      i.invalidateQueries([e]), t != null && t.keepMetadata || i.invalidateQueries(["metadata"]);
    }
  });
}
function HKt(e) {
  const t = Ah();
  return RJ(({
    id: i
  }) => Y7(e, i), {
    onSuccess: () => t.invalidateQueries([e])
  });
}
const Net = {
  Presentation: "presentation",
  Options: "options",
  Usage: "usage",
  Values: "values",
  Rules: "rules"
}, Let = {
  app: void 0,
  group: void 0,
  variable: void 0,
  variableStep: Net.Options,
  showEditorUi: !1,
  devmode: 0,
  helpTopic: void 0,
  device: "desktop",
  showThemeDialog: !1,
  showMobileThemeDialog: !1,
  searchString: "",
  dynamicSettingsEditing: void 0,
  popupAction: void 0
}, D7 = Vg({
  name: "configurator",
  initialState: Let,
  reducers: {
    setConfiguratorApp: (e, t) => {
      e.app = t.payload;
    },
    setDynamicSettings: (e, t) => {
      e.dynamicSettingsEditing = t.payload;
    },
    setConfiguratorGroup: (e, t) => {
      e.group = t.payload;
    },
    setConfiguratorVariable: (e, t) => {
      e.variable = t.payload;
    },
    setPreviewDevice: (e, t) => {
      e.device = t.payload;
    },
    setShowEditorUi: (e, t) => {
      e.showEditorUi = t.payload;
    },
    setSearchString: (e, t) => {
      e.searchString = t.payload;
    },
    setShowThemeDialog: (e, t) => {
      e.showThemeDialog = t.payload;
    },
    setShowMobileThemeDialog: (e, t) => {
      e.showMobileThemeDialog = t.payload;
    },
    setDevmode: (e, t) => {
      e.devmode = t.payload;
    },
    setHelpTopic: (e, t) => {
      e.helpTopic = t.payload;
    },
    setPopupAction: (e, t) => {
      e.popupAction = t.payload;
    }
  }
}), {
  setConfiguratorApp: J7,
  setConfiguratorGroup: Tet,
  setConfiguratorVariable: kKt,
  setShowEditorUi: FKt,
  setSearchString: YKt,
  setDynamicSettings: Met,
  setDevmode: xKt,
  setHelpTopic: DKt,
  setPreviewDevice: Uet,
  setShowThemeDialog: JKt,
  setShowMobileThemeDialog: KKt,
  setPopupAction: K7
} = D7.actions, Pet = D7.reducer, EKt = () => {
  const e = _(Ai), t = zt(), {
    mutateAsync: i
  } = x7("app", {
    keepMetadata: !0
  });
  return ft(async (n) => {
    var r;
    const g = {
      ...e,
      settings: {
        ...e.settings,
        dynamicTranslationKeys: [...((r = e.settings) == null ? void 0 : r.dynamicTranslationKeys) || [], ...n]
      }
    };
    await i(g, {
      onSuccess: () => {
        t(J7(g));
      }
    });
  }, [i, e, t]);
}, E7 = () => {
  const e = _(Ai), t = zt(), {
    mutateAsync: i
  } = x7("app", {
    keepMetadata: !0
  });
  return ft(async (n) => {
    const g = {
      ...e,
      settings: {
        ...e.settings,
        dynamicSettings: {
          ...e.settings.dynamicSettings,
          ...n
        }
      }
    };
    await i(g, {
      onSuccess: () => {
        t(J7(g));
      }
    });
  }, [i, e, t]);
}, NKt = () => {
  const e = E7();
  return ft(async (t, i) => await e({
    [t]: i
  }), [e]);
};
function j1(e) {
  return /* @__PURE__ */ p($1, { maxWidth: 450, ...e, className: Ve("k3-alert-modal", e.className), confirm: !1, children: e.children });
}
const zet = ({
  setOpen: e,
  open: t
}) => {
  const {
    t: i
  } = ii(), [n, g] = At({}), r = E7();
  return /* @__PURE__ */ p(j1, { show: t, onClose: async () => {
    await r(n), e(!1);
  }, title: i("Einstellungen"), icon: null, children: /* @__PURE__ */ p(Uqe, { values: n, setValues: g }) });
}, Oet = (e) => {
  const {
    component: t,
    display: i,
    ...n
  } = e, g = zt(), [r, o] = At(!1), I = ha(), s = _(hr), a = _(dh);
  if (!s || !a)
    return null;
  const d = (C) => {
    C.preventDefault(), C.stopPropagation(), g(Met(n)), i === "dialog" ? o(!0) : I(Zye("dynamic", "keys", n.keys));
  };
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(e.component, { "data-cy": "edit", onClick: d }),
    /* @__PURE__ */ p(zet, { setOpen: o, open: r, ...n })
  ] });
};
function tf({
  "data-cy": e,
  onClick: t,
  tooltip: i,
  colorVariant: n
}) {
  return /* @__PURE__ */ p(Cn, { title: i, children: /* @__PURE__ */ p(mi, { size: "small", sx: {
    color: `editor.${n ?? "main"}`
  }, "data-cy": e, onClick: t, children: /* @__PURE__ */ p(S1, {}) }) });
}
const Xl = ({
  boxProps: e,
  ...t
}) => {
  const i = _(hr), n = _(dh), {
    t: g
  } = ii();
  return !i || !n ? null : /* @__PURE__ */ p(fe, { component: "div", sx: {
    display: "flex",
    pointerEvents: "all",
    justifyContent: "center",
    alignItems: "center",
    ...e
  }, children: /* @__PURE__ */ p(Cn, { title: g("Texte und Einstellungen anpassen"), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(Oet, { ...t, component: tf }) }) }) });
}, Qet = pZ((e) => /* @__PURE__ */ p(Pj, { className: Ve("k3-warning-icon", e.className), fontSize: "large", sx: {
  verticalAlign: "middle",
  marginLeft: e.margin == "left" ? "8px" : void 0,
  marginRight: e.margin == "right" ? "8px" : void 0,
  ...e.sx
}, color: "warning" }));
function _1(e) {
  const t = je(() => {
    var n;
    return /* @__PURE__ */ p(
      Dd,
      {
        id: "dialog-title",
        className: "k3-modal-title",
        component: "div",
        sx: {
          paddingBottom: 0,
          marginRight: "40px"
        },
        children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }, children: [
          typeof e.title == "string" ? /* @__PURE__ */ p(XJ, { children: e.title }) : e.title,
          !!((n = e.settingKeys) != null && n.length) && /* @__PURE__ */ p(Xl, { keys: e.settingKeys, display: "dialog" })
        ] })
      }
    );
  }, [e.title]), i = !!e.maxWidth && typeof e.maxWidth != "number";
  return /* @__PURE__ */ ge(Yd, { open: e.show, keepMounted: e.keepMounted, onClose: (n) => e.onClose(n), "aria-labelledby": "k3-modal-dialog", "aria-describedby": "k3-modal", classes: {
    root: Ve("k3-modal-root", e.className),
    container: "k3-modal"
  }, onClick: e.stopPropagation ? (n) => n.stopPropagation() : void 0, "data-cy": e.dataCy ?? "k3-modal", fullWidth: !!i, maxWidth: i ? e.maxWidth : void 0, children: [
    t,
    /* @__PURE__ */ p(jet, { onClick: (n) => e.onClose(n) }),
    /* @__PURE__ */ p(xd, { sx: {
      maxWidth: e.maxWidth ?? 600,
      minWidth: e.minWidth ?? 250,
      paddingTop: "0px",
      marginTop: "16px",
      paddingBottom: "0px"
    }, classes: {
      root: "k3-modal-body"
    }, children: typeof e.children == "string" ? /* @__PURE__ */ p(Cr, { id: "k3-modal-content", className: "k3-modal-content", component: "div", children: /* @__PURE__ */ p(Ne, { children: e.children }) }) : /* @__PURE__ */ p(Ne, { component: "div", children: e.children }) }),
    /* @__PURE__ */ p(Yu, { sx: {
      paddingBottom: "16px",
      paddingTop: e.buttons ? "16px" : "0px"
    }, children: !!e.buttons && /* @__PURE__ */ p(_t, { direction: "row", gap: "4px", justifyContent: e.buttonSpacing || "right", width: "100%", sx: {
      paddingX: "16px"
    }, children: e.buttons }) })
  ] });
}
const XJ = (e) => /* @__PURE__ */ p(Ne, { variant: "h5", sx: {
  margin: 0,
  paddingLeft: e.afterIcon ? "10px" : "0px",
  paddingBottom: 0
}, noWrap: !0, paragraph: !0, children: e.children }), jet = (e) => /* @__PURE__ */ p(mi, { "aria-label": "Close Button", classes: {
  root: "k3-close-btn"
}, onClick: e.onClick, sx: {
  position: "absolute",
  right: 8,
  top: 8,
  color: (t) => t.palette.grey[500]
}, "data-cy": "modal-close", children: /* @__PURE__ */ p(Lj, {}) });
function $1(e) {
  const {
    t
  } = ii(), i = e.type ?? "info", n = je(() => {
    let o = e.icon;
    if (typeof o > "u") {
      if (e.type == "form" || e.type == "none")
        return;
      o = i == "info" ? /* @__PURE__ */ p(Z6e, { fontSize: "large", color: "info" }) : i == "warning" ? /* @__PURE__ */ p(Qet, {}) : i == "delete" && e.confirm ? /* @__PURE__ */ p(TZ, { fontSize: "large", color: "error" }) : i == "success" ? /* @__PURE__ */ p(m6e, { fontSize: "large", color: "success" }) : /* @__PURE__ */ p(S6e, { fontSize: "large", color: "error" });
    }
    return o;
  }, [e.icon, e.type, e.confirm]), g = je(() => {
    const o = e.title || (i == "info" ? t("Hinweis") : i == "warning" ? t("Achtung") : i == "delete" && e.confirm ? t("Element löschen") : t("Fehler"));
    return /* @__PURE__ */ ge(Bt, { children: [
      n,
      /* @__PURE__ */ p(XJ, { afterIcon: !!n, children: o })
    ] });
  }, [e.title, e.icon, e.type, e.confirm]), r = je(() => {
    if (!e.confirm)
      return;
    const o = !i || i == "form" || i == "none" ? "primary" : i == "info" ? "info" : i == "warning" ? "warning" : "error";
    return [/* @__PURE__ */ p(Si, { "data-cy": "cancelButton", variant: "outlined", color: o, className: "k3-btn k3-secondary-btn k3-modal-btn k3-btn-cancel", onClick: (I) => e.onClose(!1, I), children: e.cancelButtonText ?? t("Abbrechen") }, "cancel"), /* @__PURE__ */ p(Si, { "data-cy": "confirmButton", className: "k3-btn k3-btn-confirm k3-btn-submit k3-modal-btn", variant: "contained", color: o, disabled: e.disableConfirmButton, onClick: (I) => e.onClose(!0, I), children: e.confirmButtonText ?? (e.confirm && e.type == "delete" ? t("Löschen") : t("Fortfahren")) }, "confirm")];
  }, [e.confirm, e.cancelButtonText, e.confirmButtonText, e.onClose]);
  return /* @__PURE__ */ p(_1, { ...e, show: e.show ?? !1, title: g, onClose: (o) => e.confirm ? e.onClose(!1, o) : e.onClose(o), className: Ve("k3-modal-" + (e.type ?? "info"), e.className), buttons: r, children: e.children ?? (e.confirm && e.type == "delete" ? t("Möchten Sie dieses Element wirklich unwiderruflich löschen?") : "") });
}
function HJ(e) {
  const {
    t
  } = ii(), i = e.type == "form" ? t("Speichern") : void 0;
  return /* @__PURE__ */ p($1, { minWidth: 400, ...e, type: e.type || "none", className: Ve("k3-confirm-modal", e.className), confirm: !0, confirmButtonText: e.confirmButtonText || i, disableConfirmButton: e.disableConfirmButton, title: e.title || (e.type == "form" ? t("Eingabe") : void 0), onClose: (n) => e.onClose(!!n), children: e.children });
}
function _et(e) {
  const {
    t
  } = ii(), [i, n] = At(e.expression), [g, r] = At(), o = (I) => {
    I && !g ? (e.onChange(i), ef(/* @__PURE__ */ p(Ne, { children: t("Erfolgreich gespeichert") }), {
      variant: "success"
    })) : i != e.expression && n(e.expression), e.onClose();
  };
  return /* @__PURE__ */ ge(HJ, { show: e.open, onClose: o, maxWidth: "xl", title: t("Formel Editor"), icon: /* @__PURE__ */ p(Nj, {}), type: "form", disableConfirmButton: !!g, children: [
    /* @__PURE__ */ ge(Cr, { children: [
      /* @__PURE__ */ p(Ne, { children: t("Geben Sie Formeln von Merkmalen ein.") }),
      /* @__PURE__ */ p(Ne, { children: t(" Schreiben Sie z.B. Länge * Breite.") }),
      /* @__PURE__ */ p(Ne, { children: t("Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.") })
    ] }),
    /* @__PURE__ */ p("br", {}),
    /* @__PURE__ */ p(fe, { component: "div", sx: {
      padding: "1em",
      border: "1px solid #c4c4c4",
      borderRadius: 1
    }, children: /* @__PURE__ */ p(f6, { onChange: n, expression: i }) }),
    /* @__PURE__ */ p(R6, { expression: i, anchoringSelections: e.anchoringSelections, onError: r, gutterBottom: !1 })
  ] });
}
const $et = (e) => {
  const [t, i] = At(!1);
  return et(() => {
    const n = (r) => {
      var o;
      (o = e.current) != null && o.contains(r.target) && i(!0);
    }, g = (r) => {
      var o;
      (o = e.current) != null && o.contains(r.target) && i(!1);
    };
    return document.addEventListener("focusin", n), document.addEventListener("focusout", g), () => {
      document.removeEventListener("focusin", n), document.removeEventListener("focusout", g);
    };
  }, []), t;
}, BI = ({
  value: e,
  onChange: t,
  sx: i,
  label: n,
  anchoringSelections: g = [Dt]
}) => {
  const [r, o] = At(!1), [I, s] = At(void 0), a = Ct(null), d = $et(a);
  return et(() => {
    d || s(void 0);
  }, [d]), /* @__PURE__ */ ge(fe, { component: "fieldset", sx: {
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderWidth: 1,
    borderRadius: 1,
    margin: 0,
    ...i
  }, ref: a, "data-cy": `expressionInput-${n}`, children: [
    /* @__PURE__ */ p(lD, { open: d, anchorEl: a.current, anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    }, sx: {
      display: I ? "block" : "none",
      pointerEvents: "none"
    }, children: /* @__PURE__ */ p(fe, { sx: {
      p: 2
    }, component: "div", children: /* @__PURE__ */ p(R6, { expression: e, showExpression: !1, anchoringSelections: g, onError: s }) }) }),
    /* @__PURE__ */ p(Ne, { component: "legend", color: "textSecondary", sx: {
      fontSize: 12
    }, children: n }),
    /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "flex",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ p(mi, { onClick: () => o(!0), "data-cy": "", size: "small", sx: {
        ml: -1.5
      }, tabIndex: -1, children: /* @__PURE__ */ p(Nj, {}) }),
      /* @__PURE__ */ p(f6, { expression: e, inline: !0, onChange: t, height: "1.1rem" })
    ] }),
    /* @__PURE__ */ p(_et, { open: r, onClose: () => o(!1), expression: e, onChange: t, anchoringSelections: g })
  ] });
}, qet = (e) => {
  const t = new URL(e);
  return t.protocol === "data:" && t.origin === "null" || t.protocol === "blob:" && t.origin === location.origin;
}, kJ = (e) => (
  // If the url is a local blob url or a data url, we cant add a query
  // parameter otherwise the url is invalid.
  qet(e) ? e : e + "?x-request=html"
);
var ett = Math.PI / 180;
function ttt() {
  return typeof window < "u" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
}
const Bm = typeof global < "u" ? global : typeof window < "u" ? window : typeof WorkerGlobalScope < "u" ? self : {}, Mt = {
  _global: Bm,
  version: "8.4.3",
  isBrowser: ttt(),
  isUnminified: /param/.test((function(e) {
  }).toString()),
  dblClickWindow: 400,
  getAngle(e) {
    return Mt.angleDeg ? e * ett : e;
  },
  enableTrace: !1,
  pointerEventsEnabled: !0,
  autoDrawEnabled: !0,
  hitOnDragEnabled: !1,
  capturePointerEventsEnabled: !1,
  _mouseListenClick: !1,
  _touchListenClick: !1,
  _pointerListenClick: !1,
  _mouseInDblClickWindow: !1,
  _touchInDblClickWindow: !1,
  _pointerInDblClickWindow: !1,
  _mouseDblClickPointerId: null,
  _touchDblClickPointerId: null,
  _pointerDblClickPointerId: null,
  pixelRatio: typeof window < "u" && window.devicePixelRatio || 1,
  dragDistance: 3,
  angleDeg: !0,
  showWarnings: !0,
  dragButtons: [0, 1],
  isDragging() {
    return Mt.DD.isDragging;
  },
  isDragReady() {
    return !!Mt.DD.node;
  },
  releaseCanvasOnDestroy: !0,
  document: Bm.document,
  _injectGlobal(e) {
    Bm.Konva = e;
  }
}, rg = (e) => {
  Mt[e.prototype.getClassName()] = e;
};
Mt._injectGlobal(Mt);
class ZI {
  constructor(t = [1, 0, 0, 1, 0, 0]) {
    this.dirty = !1, this.m = t && t.slice() || [1, 0, 0, 1, 0, 0];
  }
  reset() {
    this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
  }
  copy() {
    return new ZI(this.m);
  }
  copyInto(t) {
    t.m[0] = this.m[0], t.m[1] = this.m[1], t.m[2] = this.m[2], t.m[3] = this.m[3], t.m[4] = this.m[4], t.m[5] = this.m[5];
  }
  point(t) {
    var i = this.m;
    return {
      x: i[0] * t.x + i[2] * t.y + i[4],
      y: i[1] * t.x + i[3] * t.y + i[5]
    };
  }
  translate(t, i) {
    return this.m[4] += this.m[0] * t + this.m[2] * i, this.m[5] += this.m[1] * t + this.m[3] * i, this;
  }
  scale(t, i) {
    return this.m[0] *= t, this.m[1] *= t, this.m[2] *= i, this.m[3] *= i, this;
  }
  rotate(t) {
    var i = Math.cos(t), n = Math.sin(t), g = this.m[0] * i + this.m[2] * n, r = this.m[1] * i + this.m[3] * n, o = this.m[0] * -n + this.m[2] * i, I = this.m[1] * -n + this.m[3] * i;
    return this.m[0] = g, this.m[1] = r, this.m[2] = o, this.m[3] = I, this;
  }
  getTranslation() {
    return {
      x: this.m[4],
      y: this.m[5]
    };
  }
  skew(t, i) {
    var n = this.m[0] + this.m[2] * i, g = this.m[1] + this.m[3] * i, r = this.m[2] + this.m[0] * t, o = this.m[3] + this.m[1] * t;
    return this.m[0] = n, this.m[1] = g, this.m[2] = r, this.m[3] = o, this;
  }
  multiply(t) {
    var i = this.m[0] * t.m[0] + this.m[2] * t.m[1], n = this.m[1] * t.m[0] + this.m[3] * t.m[1], g = this.m[0] * t.m[2] + this.m[2] * t.m[3], r = this.m[1] * t.m[2] + this.m[3] * t.m[3], o = this.m[0] * t.m[4] + this.m[2] * t.m[5] + this.m[4], I = this.m[1] * t.m[4] + this.m[3] * t.m[5] + this.m[5];
    return this.m[0] = i, this.m[1] = n, this.m[2] = g, this.m[3] = r, this.m[4] = o, this.m[5] = I, this;
  }
  invert() {
    var t = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), i = this.m[3] * t, n = -this.m[1] * t, g = -this.m[2] * t, r = this.m[0] * t, o = t * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), I = t * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
    return this.m[0] = i, this.m[1] = n, this.m[2] = g, this.m[3] = r, this.m[4] = o, this.m[5] = I, this;
  }
  getMatrix() {
    return this.m;
  }
  decompose() {
    var t = this.m[0], i = this.m[1], n = this.m[2], g = this.m[3], r = this.m[4], o = this.m[5], I = t * g - i * n;
    let s = {
      x: r,
      y: o,
      rotation: 0,
      scaleX: 0,
      scaleY: 0,
      skewX: 0,
      skewY: 0
    };
    if (t != 0 || i != 0) {
      var a = Math.sqrt(t * t + i * i);
      s.rotation = i > 0 ? Math.acos(t / a) : -Math.acos(t / a), s.scaleX = a, s.scaleY = I / a, s.skewX = (t * n + i * g) / I, s.skewY = 0;
    } else if (n != 0 || g != 0) {
      var d = Math.sqrt(n * n + g * g);
      s.rotation = Math.PI / 2 - (g > 0 ? Math.acos(-n / d) : -Math.acos(n / d)), s.scaleX = I / d, s.scaleY = d, s.skewX = 0, s.skewY = (t * n + i * g) / I;
    }
    return s.rotation = he._getRotation(s.rotation), s;
  }
}
var itt = "[object Array]", ntt = "[object Number]", gtt = "[object String]", rtt = "[object Boolean]", ott = Math.PI / 180, Itt = 180 / Math.PI, Yk = "#", ltt = "", stt = "0", att = "Konva warning: ", nT = "Konva error: ", ctt = "rgb(", xk = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 132, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 255, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 203],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [119, 128, 144],
  slategrey: [119, 128, 144],
  snow: [255, 255, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  transparent: [255, 255, 255, 0],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 5]
}, dtt = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, bW = [];
const Ctt = typeof requestAnimationFrame < "u" && requestAnimationFrame || function(e) {
  setTimeout(e, 60);
}, he = {
  _isElement(e) {
    return !!(e && e.nodeType == 1);
  },
  _isFunction(e) {
    return !!(e && e.constructor && e.call && e.apply);
  },
  _isPlainObject(e) {
    return !!e && e.constructor === Object;
  },
  _isArray(e) {
    return Object.prototype.toString.call(e) === itt;
  },
  _isNumber(e) {
    return Object.prototype.toString.call(e) === ntt && !isNaN(e) && isFinite(e);
  },
  _isString(e) {
    return Object.prototype.toString.call(e) === gtt;
  },
  _isBoolean(e) {
    return Object.prototype.toString.call(e) === rtt;
  },
  isObject(e) {
    return e instanceof Object;
  },
  isValidSelector(e) {
    if (typeof e != "string")
      return !1;
    var t = e[0];
    return t === "#" || t === "." || t === t.toUpperCase();
  },
  _sign(e) {
    return e === 0 || e > 0 ? 1 : -1;
  },
  requestAnimFrame(e) {
    bW.push(e), bW.length === 1 && Ctt(function() {
      const t = bW;
      bW = [], t.forEach(function(i) {
        i();
      });
    });
  },
  createCanvasElement() {
    var e = document.createElement("canvas");
    try {
      e.style = e.style || {};
    } catch {
    }
    return e;
  },
  createImageElement() {
    return document.createElement("img");
  },
  _isInDocument(e) {
    for (; e = e.parentNode; )
      if (e == document)
        return !0;
    return !1;
  },
  _urlToImage(e, t) {
    var i = he.createImageElement();
    i.onload = function() {
      t(i);
    }, i.src = e;
  },
  _rgbToHex(e, t, i) {
    return ((1 << 24) + (e << 16) + (t << 8) + i).toString(16).slice(1);
  },
  _hexToRgb(e) {
    e = e.replace(Yk, ltt);
    var t = parseInt(e, 16);
    return {
      r: t >> 16 & 255,
      g: t >> 8 & 255,
      b: t & 255
    };
  },
  getRandomColor() {
    for (var e = (Math.random() * 16777215 << 0).toString(16); e.length < 6; )
      e = stt + e;
    return Yk + e;
  },
  getRGB(e) {
    var t;
    return e in xk ? (t = xk[e], {
      r: t[0],
      g: t[1],
      b: t[2]
    }) : e[0] === Yk ? this._hexToRgb(e.substring(1)) : e.substr(0, 4) === ctt ? (t = dtt.exec(e.replace(/ /g, "")), {
      r: parseInt(t[1], 10),
      g: parseInt(t[2], 10),
      b: parseInt(t[3], 10)
    }) : {
      r: 0,
      g: 0,
      b: 0
    };
  },
  colorToRGBA(e) {
    return e = e || "black", he._namedColorToRBA(e) || he._hex3ColorToRGBA(e) || he._hex4ColorToRGBA(e) || he._hex6ColorToRGBA(e) || he._hex8ColorToRGBA(e) || he._rgbColorToRGBA(e) || he._rgbaColorToRGBA(e) || he._hslColorToRGBA(e);
  },
  _namedColorToRBA(e) {
    var t = xk[e.toLowerCase()];
    return t ? {
      r: t[0],
      g: t[1],
      b: t[2],
      a: 1
    } : null;
  },
  _rgbColorToRGBA(e) {
    if (e.indexOf("rgb(") === 0) {
      e = e.match(/rgb\(([^)]+)\)/)[1];
      var t = e.split(/ *, */).map(Number);
      return {
        r: t[0],
        g: t[1],
        b: t[2],
        a: 1
      };
    }
  },
  _rgbaColorToRGBA(e) {
    if (e.indexOf("rgba(") === 0) {
      e = e.match(/rgba\(([^)]+)\)/)[1];
      var t = e.split(/ *, */).map((i, n) => i.slice(-1) === "%" ? n === 3 ? parseInt(i) / 100 : parseInt(i) / 100 * 255 : Number(i));
      return {
        r: t[0],
        g: t[1],
        b: t[2],
        a: t[3]
      };
    }
  },
  _hex8ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 9)
      return {
        r: parseInt(e.slice(1, 3), 16),
        g: parseInt(e.slice(3, 5), 16),
        b: parseInt(e.slice(5, 7), 16),
        a: parseInt(e.slice(7, 9), 16) / 255
      };
  },
  _hex6ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 7)
      return {
        r: parseInt(e.slice(1, 3), 16),
        g: parseInt(e.slice(3, 5), 16),
        b: parseInt(e.slice(5, 7), 16),
        a: 1
      };
  },
  _hex4ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 5)
      return {
        r: parseInt(e[1] + e[1], 16),
        g: parseInt(e[2] + e[2], 16),
        b: parseInt(e[3] + e[3], 16),
        a: parseInt(e[4] + e[4], 16) / 255
      };
  },
  _hex3ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 4)
      return {
        r: parseInt(e[1] + e[1], 16),
        g: parseInt(e[2] + e[2], 16),
        b: parseInt(e[3] + e[3], 16),
        a: 1
      };
  },
  _hslColorToRGBA(e) {
    if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(e)) {
      const [t, ...i] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e), n = Number(i[0]) / 360, g = Number(i[1]) / 100, r = Number(i[2]) / 100;
      let o, I, s;
      if (g === 0)
        return s = r * 255, {
          r: Math.round(s),
          g: Math.round(s),
          b: Math.round(s),
          a: 1
        };
      r < 0.5 ? o = r * (1 + g) : o = r + g - r * g;
      const a = 2 * r - o, d = [0, 0, 0];
      for (let C = 0; C < 3; C++)
        I = n + 1 / 3 * -(C - 1), I < 0 && I++, I > 1 && I--, 6 * I < 1 ? s = a + (o - a) * 6 * I : 2 * I < 1 ? s = o : 3 * I < 2 ? s = a + (o - a) * (2 / 3 - I) * 6 : s = a, d[C] = s * 255;
      return {
        r: Math.round(d[0]),
        g: Math.round(d[1]),
        b: Math.round(d[2]),
        a: 1
      };
    }
  },
  haveIntersection(e, t) {
    return !(t.x > e.x + e.width || t.x + t.width < e.x || t.y > e.y + e.height || t.y + t.height < e.y);
  },
  cloneObject(e) {
    var t = {};
    for (var i in e)
      this._isPlainObject(e[i]) ? t[i] = this.cloneObject(e[i]) : this._isArray(e[i]) ? t[i] = this.cloneArray(e[i]) : t[i] = e[i];
    return t;
  },
  cloneArray(e) {
    return e.slice(0);
  },
  degToRad(e) {
    return e * ott;
  },
  radToDeg(e) {
    return e * Itt;
  },
  _degToRad(e) {
    return he.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), he.degToRad(e);
  },
  _radToDeg(e) {
    return he.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), he.radToDeg(e);
  },
  _getRotation(e) {
    return Mt.angleDeg ? he.radToDeg(e) : e;
  },
  _capitalize(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  },
  throw(e) {
    throw new Error(nT + e);
  },
  error(e) {
    console.error(nT + e);
  },
  warn(e) {
    Mt.showWarnings && console.warn(att + e);
  },
  each(e, t) {
    for (var i in e)
      t(i, e[i]);
  },
  _inRange(e, t, i) {
    return t <= e && e < i;
  },
  _getProjectionToSegment(e, t, i, n, g, r) {
    var o, I, s, a = (e - i) * (e - i) + (t - n) * (t - n);
    if (a == 0)
      o = e, I = t, s = (g - i) * (g - i) + (r - n) * (r - n);
    else {
      var d = ((g - e) * (i - e) + (r - t) * (n - t)) / a;
      d < 0 ? (o = e, I = t, s = (e - g) * (e - g) + (t - r) * (t - r)) : d > 1 ? (o = i, I = n, s = (i - g) * (i - g) + (n - r) * (n - r)) : (o = e + d * (i - e), I = t + d * (n - t), s = (o - g) * (o - g) + (I - r) * (I - r));
    }
    return [o, I, s];
  },
  _getProjectionToLine(e, t, i) {
    var n = he.cloneObject(e), g = Number.MAX_VALUE;
    return t.forEach(function(r, o) {
      if (!(!i && o === t.length - 1)) {
        var I = t[(o + 1) % t.length], s = he._getProjectionToSegment(r.x, r.y, I.x, I.y, e.x, e.y), a = s[0], d = s[1], C = s[2];
        C < g && (n.x = a, n.y = d, g = C);
      }
    }), n;
  },
  _prepareArrayForTween(e, t, i) {
    var n, g = [], r = [];
    if (e.length > t.length) {
      var o = t;
      t = e, e = o;
    }
    for (n = 0; n < e.length; n += 2)
      g.push({
        x: e[n],
        y: e[n + 1]
      });
    for (n = 0; n < t.length; n += 2)
      r.push({
        x: t[n],
        y: t[n + 1]
      });
    var I = [];
    return r.forEach(function(s) {
      var a = he._getProjectionToLine(s, g, i);
      I.push(a.x), I.push(a.y);
    }), I;
  },
  _prepareToStringify(e) {
    var t;
    e.visitedByCircularReferenceRemoval = !0;
    for (var i in e)
      if (e.hasOwnProperty(i) && e[i] && typeof e[i] == "object") {
        if (t = Object.getOwnPropertyDescriptor(e, i), e[i].visitedByCircularReferenceRemoval || he._isElement(e[i]))
          if (t.configurable)
            delete e[i];
          else
            return null;
        else if (he._prepareToStringify(e[i]) === null)
          if (t.configurable)
            delete e[i];
          else
            return null;
      }
    return delete e.visitedByCircularReferenceRemoval, e;
  },
  _assign(e, t) {
    for (var i in t)
      e[i] = t[i];
    return e;
  },
  _getFirstPointerId(e) {
    return e.touches ? e.changedTouches[0].identifier : e.pointerId || 999;
  },
  releaseCanvas(...e) {
    Mt.releaseCanvasOnDestroy && e.forEach((t) => {
      t.width = 0, t.height = 0;
    });
  },
  drawRoundedRectPath(e, t, i, n) {
    let g = 0, r = 0, o = 0, I = 0;
    typeof n == "number" ? g = r = o = I = Math.min(n, t / 2, i / 2) : (g = Math.min(n[0] || 0, t / 2, i / 2), r = Math.min(n[1] || 0, t / 2, i / 2), I = Math.min(n[2] || 0, t / 2, i / 2), o = Math.min(n[3] || 0, t / 2, i / 2)), e.moveTo(g, 0), e.lineTo(t - r, 0), e.arc(t - r, r, r, Math.PI * 3 / 2, 0, !1), e.lineTo(t, i - I), e.arc(t - I, i - I, I, 0, Math.PI / 2, !1), e.lineTo(o, i), e.arc(o, i - o, o, Math.PI / 2, Math.PI, !1), e.lineTo(0, g), e.arc(g, g, g, Math.PI, Math.PI * 3 / 2, !1);
  }
};
function gC(e) {
  return he._isString(e) ? '"' + e + '"' : Object.prototype.toString.call(e) === "[object Number]" || he._isBoolean(e) ? e : Object.prototype.toString.call(e);
}
function N7(e) {
  return e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
}
function bt() {
  if (Mt.isUnminified)
    return function(e, t) {
      return he._isNumber(e) || he.warn(gC(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number.'), e;
    };
}
function FJ(e) {
  if (Mt.isUnminified)
    return function(t, i) {
      let n = he._isNumber(t), g = he._isArray(t) && t.length == e;
      return !n && !g && he.warn(gC(t) + ' is a not valid value for "' + i + '" attribute. The value should be a number or Array<number>(' + e + ")"), t;
    };
}
function YJ() {
  if (Mt.isUnminified)
    return function(e, t) {
      var i = he._isNumber(e), n = e === "auto";
      return i || n || he.warn(gC(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number or "auto".'), e;
    };
}
function bh() {
  if (Mt.isUnminified)
    return function(e, t) {
      return he._isString(e) || he.warn(gC(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string.'), e;
    };
}
function L7() {
  if (Mt.isUnminified)
    return function(e, t) {
      const i = he._isString(e), n = Object.prototype.toString.call(e) === "[object CanvasGradient]" || e && e.addColorStop;
      return i || n || he.warn(gC(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string or a native gradient.'), e;
    };
}
function utt() {
  if (Mt.isUnminified)
    return function(e, t) {
      const i = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
      return i && e instanceof i || (he._isArray(e) ? e.forEach(function(n) {
        he._isNumber(n) || he.warn('"' + t + '" attribute has non numeric element ' + n + ". Make sure that all elements are numbers.");
      }) : he.warn(gC(e) + ' is a not valid value for "' + t + '" attribute. The value should be a array of numbers.')), e;
    };
}
function ws() {
  if (Mt.isUnminified)
    return function(e, t) {
      var i = e === !0 || e === !1;
      return i || he.warn(gC(e) + ' is a not valid value for "' + t + '" attribute. The value should be a boolean.'), e;
    };
}
function Att(e) {
  if (Mt.isUnminified)
    return function(t, i) {
      return t == null || he.isObject(t) || he.warn(gC(t) + ' is a not valid value for "' + i + '" attribute. The value should be an object with properties ' + e), t;
    };
}
var V0 = "get", w0 = "set";
const Ie = {
  addGetterSetter(e, t, i, n, g) {
    Ie.addGetter(e, t, i), Ie.addSetter(e, t, n, g), Ie.addOverloadedGetterSetter(e, t);
  },
  addGetter(e, t, i) {
    var n = V0 + he._capitalize(t);
    e.prototype[n] = e.prototype[n] || function() {
      var g = this.attrs[t];
      return g === void 0 ? i : g;
    };
  },
  addSetter(e, t, i, n) {
    var g = w0 + he._capitalize(t);
    e.prototype[g] || Ie.overWriteSetter(e, t, i, n);
  },
  overWriteSetter(e, t, i, n) {
    var g = w0 + he._capitalize(t);
    e.prototype[g] = function(r) {
      return i && r !== void 0 && r !== null && (r = i.call(this, r, t)), this._setAttr(t, r), n && n.call(this), this;
    };
  },
  addComponentsGetterSetter(e, t, i, n, g) {
    var r = i.length, o = he._capitalize, I = V0 + o(t), s = w0 + o(t), a, d;
    e.prototype[I] = function() {
      var u = {};
      for (a = 0; a < r; a++)
        d = i[a], u[d] = this.getAttr(t + o(d));
      return u;
    };
    var C = Att(i);
    e.prototype[s] = function(u) {
      var A = this.attrs[t], m;
      n && (u = n.call(this, u)), C && C.call(this, u, t);
      for (m in u)
        u.hasOwnProperty(m) && this._setAttr(t + o(m), u[m]);
      return u || i.forEach((h) => {
        this._setAttr(t + o(h), void 0);
      }), this._fireChangeEvent(t, A, u), g && g.call(this), this;
    }, Ie.addOverloadedGetterSetter(e, t);
  },
  addOverloadedGetterSetter(e, t) {
    var i = he._capitalize(t), n = w0 + i, g = V0 + i;
    e.prototype[t] = function() {
      return arguments.length ? (this[n](arguments[0]), this) : this[g]();
    };
  },
  addDeprecatedGetterSetter(e, t, i, n) {
    he.error("Adding deprecated " + t);
    var g = V0 + he._capitalize(t), r = t + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
    e.prototype[g] = function() {
      he.error(r);
      var o = this.attrs[t];
      return o === void 0 ? i : o;
    }, Ie.addSetter(e, t, n, function() {
      he.error(r);
    }), Ie.addOverloadedGetterSetter(e, t);
  },
  backCompat(e, t) {
    he.each(t, function(i, n) {
      var g = e.prototype[n], r = V0 + he._capitalize(i), o = w0 + he._capitalize(i);
      function I() {
        g.apply(this, arguments), he.error('"' + i + '" method is deprecated and will be removed soon. Use ""' + n + '" instead.');
      }
      e.prototype[i] = I, e.prototype[r] = I, e.prototype[o] = I;
    });
  },
  afterSetFilter() {
    this._filterUpToDate = !1;
  }
};
function btt(e) {
  var t = [], i = e.length, n = he, g, r;
  for (g = 0; g < i; g++)
    r = e[g], n._isNumber(r) ? r = Math.round(r * 1e3) / 1e3 : n._isString(r) || (r = r + ""), t.push(r);
  return t;
}
var gT = ",", mtt = "(", htt = ")", ptt = "([", Btt = "])", Ztt = ";", ftt = "()", Gtt = "=", rT = [
  "arc",
  "arcTo",
  "beginPath",
  "bezierCurveTo",
  "clearRect",
  "clip",
  "closePath",
  "createLinearGradient",
  "createPattern",
  "createRadialGradient",
  "drawImage",
  "ellipse",
  "fill",
  "fillText",
  "getImageData",
  "createImageData",
  "lineTo",
  "moveTo",
  "putImageData",
  "quadraticCurveTo",
  "rect",
  "restore",
  "rotate",
  "save",
  "scale",
  "setLineDash",
  "setTransform",
  "stroke",
  "strokeText",
  "transform",
  "translate"
], ytt = [
  "fillStyle",
  "strokeStyle",
  "shadowColor",
  "shadowBlur",
  "shadowOffsetX",
  "shadowOffsetY",
  "lineCap",
  "lineDashOffset",
  "lineJoin",
  "lineWidth",
  "miterLimit",
  "font",
  "textAlign",
  "textBaseline",
  "globalAlpha",
  "globalCompositeOperation",
  "imageSmoothingEnabled"
];
const Wtt = 100;
let q1 = class {
  constructor(t) {
    this.canvas = t, Mt.enableTrace && (this.traceArr = [], this._enableTrace());
  }
  fillShape(t) {
    t.fillEnabled() && this._fill(t);
  }
  _fill(t) {
  }
  strokeShape(t) {
    t.hasStroke() && this._stroke(t);
  }
  _stroke(t) {
  }
  fillStrokeShape(t) {
    t.attrs.fillAfterStrokeEnabled ? (this.strokeShape(t), this.fillShape(t)) : (this.fillShape(t), this.strokeShape(t));
  }
  getTrace(t, i) {
    var n = this.traceArr, g = n.length, r = "", o, I, s, a;
    for (o = 0; o < g; o++)
      I = n[o], s = I.method, s ? (a = I.args, r += s, t ? r += ftt : he._isArray(a[0]) ? r += ptt + a.join(gT) + Btt : (i && (a = a.map((d) => typeof d == "number" ? Math.floor(d) : d)), r += mtt + a.join(gT) + htt)) : (r += I.property, t || (r += Gtt + I.val)), r += Ztt;
    return r;
  }
  clearTrace() {
    this.traceArr = [];
  }
  _trace(t) {
    var i = this.traceArr, n;
    i.push(t), n = i.length, n >= Wtt && i.shift();
  }
  reset() {
    var t = this.getCanvas().getPixelRatio();
    this.setTransform(1 * t, 0, 0, 1 * t, 0, 0);
  }
  getCanvas() {
    return this.canvas;
  }
  clear(t) {
    var i = this.getCanvas();
    t ? this.clearRect(t.x || 0, t.y || 0, t.width || 0, t.height || 0) : this.clearRect(0, 0, i.getWidth() / i.pixelRatio, i.getHeight() / i.pixelRatio);
  }
  _applyLineCap(t) {
    const i = t.attrs.lineCap;
    i && this.setAttr("lineCap", i);
  }
  _applyOpacity(t) {
    var i = t.getAbsoluteOpacity();
    i !== 1 && this.setAttr("globalAlpha", i);
  }
  _applyLineJoin(t) {
    const i = t.attrs.lineJoin;
    i && this.setAttr("lineJoin", i);
  }
  setAttr(t, i) {
    this._context[t] = i;
  }
  arc(t, i, n, g, r, o) {
    this._context.arc(t, i, n, g, r, o);
  }
  arcTo(t, i, n, g, r) {
    this._context.arcTo(t, i, n, g, r);
  }
  beginPath() {
    this._context.beginPath();
  }
  bezierCurveTo(t, i, n, g, r, o) {
    this._context.bezierCurveTo(t, i, n, g, r, o);
  }
  clearRect(t, i, n, g) {
    this._context.clearRect(t, i, n, g);
  }
  clip() {
    this._context.clip();
  }
  closePath() {
    this._context.closePath();
  }
  createImageData(t, i) {
    var n = arguments;
    if (n.length === 2)
      return this._context.createImageData(t, i);
    if (n.length === 1)
      return this._context.createImageData(t);
  }
  createLinearGradient(t, i, n, g) {
    return this._context.createLinearGradient(t, i, n, g);
  }
  createPattern(t, i) {
    return this._context.createPattern(t, i);
  }
  createRadialGradient(t, i, n, g, r, o) {
    return this._context.createRadialGradient(t, i, n, g, r, o);
  }
  drawImage(t, i, n, g, r, o, I, s, a) {
    var d = arguments, C = this._context;
    d.length === 3 ? C.drawImage(t, i, n) : d.length === 5 ? C.drawImage(t, i, n, g, r) : d.length === 9 && C.drawImage(t, i, n, g, r, o, I, s, a);
  }
  ellipse(t, i, n, g, r, o, I, s) {
    this._context.ellipse(t, i, n, g, r, o, I, s);
  }
  isPointInPath(t, i, n, g) {
    return n ? this._context.isPointInPath(n, t, i, g) : this._context.isPointInPath(t, i, g);
  }
  fill(t) {
    t ? this._context.fill(t) : this._context.fill();
  }
  fillRect(t, i, n, g) {
    this._context.fillRect(t, i, n, g);
  }
  strokeRect(t, i, n, g) {
    this._context.strokeRect(t, i, n, g);
  }
  fillText(t, i, n, g) {
    g ? this._context.fillText(t, i, n, g) : this._context.fillText(t, i, n);
  }
  measureText(t) {
    return this._context.measureText(t);
  }
  getImageData(t, i, n, g) {
    return this._context.getImageData(t, i, n, g);
  }
  lineTo(t, i) {
    this._context.lineTo(t, i);
  }
  moveTo(t, i) {
    this._context.moveTo(t, i);
  }
  rect(t, i, n, g) {
    this._context.rect(t, i, n, g);
  }
  putImageData(t, i, n) {
    this._context.putImageData(t, i, n);
  }
  quadraticCurveTo(t, i, n, g) {
    this._context.quadraticCurveTo(t, i, n, g);
  }
  restore() {
    this._context.restore();
  }
  rotate(t) {
    this._context.rotate(t);
  }
  save() {
    this._context.save();
  }
  scale(t, i) {
    this._context.scale(t, i);
  }
  setLineDash(t) {
    this._context.setLineDash ? this._context.setLineDash(t) : "mozDash" in this._context ? this._context.mozDash = t : "webkitLineDash" in this._context && (this._context.webkitLineDash = t);
  }
  getLineDash() {
    return this._context.getLineDash();
  }
  setTransform(t, i, n, g, r, o) {
    this._context.setTransform(t, i, n, g, r, o);
  }
  stroke(t) {
    t ? this._context.stroke(t) : this._context.stroke();
  }
  strokeText(t, i, n, g) {
    this._context.strokeText(t, i, n, g);
  }
  transform(t, i, n, g, r, o) {
    this._context.transform(t, i, n, g, r, o);
  }
  translate(t, i) {
    this._context.translate(t, i);
  }
  _enableTrace() {
    var t = this, i = rT.length, n = this.setAttr, g, r, o = function(I) {
      var s = t[I], a;
      t[I] = function() {
        return r = btt(Array.prototype.slice.call(arguments, 0)), a = s.apply(t, arguments), t._trace({
          method: I,
          args: r
        }), a;
      };
    };
    for (g = 0; g < i; g++)
      o(rT[g]);
    t.setAttr = function() {
      n.apply(t, arguments);
      var I = arguments[0], s = arguments[1];
      (I === "shadowOffsetX" || I === "shadowOffsetY" || I === "shadowBlur") && (s = s / this.canvas.getPixelRatio()), t._trace({
        property: I,
        val: s
      });
    };
  }
  _applyGlobalCompositeOperation(t) {
    const i = t.attrs.globalCompositeOperation;
    var n = !i || i === "source-over";
    n || this.setAttr("globalCompositeOperation", i);
  }
};
ytt.forEach(function(e) {
  Object.defineProperty(q1.prototype, e, {
    get() {
      return this._context[e];
    },
    set(t) {
      this._context[e] = t;
    }
  });
});
class Stt extends q1 {
  constructor(t) {
    super(t), this._context = t._canvas.getContext("2d");
  }
  _fillColor(t) {
    var i = t.fill();
    this.setAttr("fillStyle", i), t._fillFunc(this);
  }
  _fillPattern(t) {
    this.setAttr("fillStyle", t._getFillPattern()), t._fillFunc(this);
  }
  _fillLinearGradient(t) {
    var i = t._getLinearGradient();
    i && (this.setAttr("fillStyle", i), t._fillFunc(this));
  }
  _fillRadialGradient(t) {
    const i = t._getRadialGradient();
    i && (this.setAttr("fillStyle", i), t._fillFunc(this));
  }
  _fill(t) {
    const i = t.fill(), n = t.getFillPriority();
    if (i && n === "color") {
      this._fillColor(t);
      return;
    }
    const g = t.getFillPatternImage();
    if (g && n === "pattern") {
      this._fillPattern(t);
      return;
    }
    const r = t.getFillLinearGradientColorStops();
    if (r && n === "linear-gradient") {
      this._fillLinearGradient(t);
      return;
    }
    const o = t.getFillRadialGradientColorStops();
    if (o && n === "radial-gradient") {
      this._fillRadialGradient(t);
      return;
    }
    i ? this._fillColor(t) : g ? this._fillPattern(t) : r ? this._fillLinearGradient(t) : o && this._fillRadialGradient(t);
  }
  _strokeLinearGradient(t) {
    const i = t.getStrokeLinearGradientStartPoint(), n = t.getStrokeLinearGradientEndPoint(), g = t.getStrokeLinearGradientColorStops(), r = this.createLinearGradient(i.x, i.y, n.x, n.y);
    if (g) {
      for (var o = 0; o < g.length; o += 2)
        r.addColorStop(g[o], g[o + 1]);
      this.setAttr("strokeStyle", r);
    }
  }
  _stroke(t) {
    var i = t.dash(), n = t.getStrokeScaleEnabled();
    if (t.hasStroke()) {
      if (!n) {
        this.save();
        var g = this.getCanvas().getPixelRatio();
        this.setTransform(g, 0, 0, g, 0, 0);
      }
      this._applyLineCap(t), i && t.dashEnabled() && (this.setLineDash(i), this.setAttr("lineDashOffset", t.dashOffset())), this.setAttr("lineWidth", t.strokeWidth()), t.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)");
      var r = t.getStrokeLinearGradientColorStops();
      r ? this._strokeLinearGradient(t) : this.setAttr("strokeStyle", t.stroke()), t._strokeFunc(this), n || this.restore();
    }
  }
  _applyShadow(t) {
    var i, n, g, r = (i = t.getShadowRGBA()) !== null && i !== void 0 ? i : "black", o = (n = t.getShadowBlur()) !== null && n !== void 0 ? n : 5, I = (g = t.getShadowOffset()) !== null && g !== void 0 ? g : {
      x: 0,
      y: 0
    }, s = t.getAbsoluteScale(), a = this.canvas.getPixelRatio(), d = s.x * a, C = s.y * a;
    this.setAttr("shadowColor", r), this.setAttr("shadowBlur", o * Math.min(Math.abs(d), Math.abs(C))), this.setAttr("shadowOffsetX", I.x * d), this.setAttr("shadowOffsetY", I.y * C);
  }
}
class Vtt extends q1 {
  constructor(t) {
    super(t), this._context = t._canvas.getContext("2d", {
      willReadFrequently: !0
    });
  }
  _fill(t) {
    this.save(), this.setAttr("fillStyle", t.colorKey), t._fillFuncHit(this), this.restore();
  }
  strokeShape(t) {
    t.hasHitStroke() && this._stroke(t);
  }
  _stroke(t) {
    if (t.hasHitStroke()) {
      const r = t.getStrokeScaleEnabled();
      if (!r) {
        this.save();
        var i = this.getCanvas().getPixelRatio();
        this.setTransform(i, 0, 0, i, 0, 0);
      }
      this._applyLineCap(t);
      var n = t.hitStrokeWidth(), g = n === "auto" ? t.strokeWidth() : n;
      this.setAttr("lineWidth", g), this.setAttr("strokeStyle", t.colorKey), t._strokeFuncHit(this), r || this.restore();
    }
  }
}
var mW;
function wtt() {
  if (mW)
    return mW;
  var e = he.createCanvasElement(), t = e.getContext("2d");
  return mW = function() {
    var i = Mt._global.devicePixelRatio || 1, n = t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
    return i / n;
  }(), he.releaseCanvas(e), mW;
}
class e2 {
  constructor(t) {
    this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
    var i = t || {}, n = i.pixelRatio || Mt.pixelRatio || wtt();
    this.pixelRatio = n, this._canvas = he.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
  }
  getContext() {
    return this.context;
  }
  getPixelRatio() {
    return this.pixelRatio;
  }
  setPixelRatio(t) {
    var i = this.pixelRatio;
    this.pixelRatio = t, this.setSize(this.getWidth() / i, this.getHeight() / i);
  }
  setWidth(t) {
    this.width = this._canvas.width = t * this.pixelRatio, this._canvas.style.width = t + "px";
    var i = this.pixelRatio, n = this.getContext()._context;
    n.scale(i, i);
  }
  setHeight(t) {
    this.height = this._canvas.height = t * this.pixelRatio, this._canvas.style.height = t + "px";
    var i = this.pixelRatio, n = this.getContext()._context;
    n.scale(i, i);
  }
  getWidth() {
    return this.width;
  }
  getHeight() {
    return this.height;
  }
  setSize(t, i) {
    this.setWidth(t || 0), this.setHeight(i || 0);
  }
  toDataURL(t, i) {
    try {
      return this._canvas.toDataURL(t, i);
    } catch {
      try {
        return this._canvas.toDataURL();
      } catch (g) {
        return he.error("Unable to get data URL. " + g.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
      }
    }
  }
}
Ie.addGetterSetter(e2, "pixelRatio", void 0, bt());
class Zm extends e2 {
  constructor(t = { width: 0, height: 0 }) {
    super(t), this.context = new Stt(this), this.setSize(t.width, t.height);
  }
}
class xJ extends e2 {
  constructor(t = { width: 0, height: 0 }) {
    super(t), this.hitCanvas = !0, this.context = new Vtt(this), this.setSize(t.width, t.height);
  }
}
const Qi = {
  get isDragging() {
    var e = !1;
    return Qi._dragElements.forEach((t) => {
      t.dragStatus === "dragging" && (e = !0);
    }), e;
  },
  justDragged: !1,
  get node() {
    var e;
    return Qi._dragElements.forEach((t) => {
      e = t.node;
    }), e;
  },
  _dragElements: /* @__PURE__ */ new Map(),
  _drag(e) {
    const t = [];
    Qi._dragElements.forEach((i, n) => {
      const { node: g } = i, r = g.getStage();
      r.setPointersPositions(e), i.pointerId === void 0 && (i.pointerId = he._getFirstPointerId(e));
      const o = r._changedPointerPositions.find((a) => a.id === i.pointerId);
      if (o) {
        if (i.dragStatus !== "dragging") {
          var I = g.dragDistance(), s = Math.max(Math.abs(o.x - i.startPointerPos.x), Math.abs(o.y - i.startPointerPos.y));
          if (s < I || (g.startDrag({ evt: e }), !g.isDragging()))
            return;
        }
        g._setDragPosition(e, i), t.push(g);
      }
    }), t.forEach((i) => {
      i.fire("dragmove", {
        type: "dragmove",
        target: i,
        evt: e
      }, !0);
    });
  },
  _endDragBefore(e) {
    const t = [];
    Qi._dragElements.forEach((i) => {
      const { node: n } = i, g = n.getStage();
      if (e && g.setPointersPositions(e), !g._changedPointerPositions.find((I) => I.id === i.pointerId))
        return;
      (i.dragStatus === "dragging" || i.dragStatus === "stopped") && (Qi.justDragged = !0, Mt._mouseListenClick = !1, Mt._touchListenClick = !1, Mt._pointerListenClick = !1, i.dragStatus = "stopped");
      const o = i.node.getLayer() || i.node instanceof Mt.Stage && i.node;
      o && t.indexOf(o) === -1 && t.push(o);
    }), t.forEach((i) => {
      i.draw();
    });
  },
  _endDragAfter(e) {
    Qi._dragElements.forEach((t, i) => {
      t.dragStatus === "stopped" && t.node.fire("dragend", {
        type: "dragend",
        target: t.node,
        evt: e
      }, !0), t.dragStatus !== "dragging" && Qi._dragElements.delete(i);
    });
  }
};
Mt.isBrowser && (window.addEventListener("mouseup", Qi._endDragBefore, !0), window.addEventListener("touchend", Qi._endDragBefore, !0), window.addEventListener("mousemove", Qi._drag), window.addEventListener("touchmove", Qi._drag), window.addEventListener("mouseup", Qi._endDragAfter, !1), window.addEventListener("touchend", Qi._endDragAfter, !1));
var cS = "absoluteOpacity", hW = "allEventListeners", rc = "absoluteTransform", oT = "absoluteScale", gu = "canvas", vtt = "Change", Rtt = "children", Xtt = "konva", qY = "listening", IT = "mouseenter", lT = "mouseleave", sT = "set", aT = "Shape", dS = " ", cT = "stage", md = "transform", Htt = "Stage", ex = "visible", ktt = [
  "xChange.konva",
  "yChange.konva",
  "scaleXChange.konva",
  "scaleYChange.konva",
  "skewXChange.konva",
  "skewYChange.konva",
  "rotationChange.konva",
  "offsetXChange.konva",
  "offsetYChange.konva",
  "transformsEnabledChange.konva"
].join(dS);
let Ftt = 1, mt = class tx {
  constructor(t) {
    this._id = Ftt++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(t), this._shouldFireChangeEvents = !0;
  }
  hasChildren() {
    return !1;
  }
  _clearCache(t) {
    (t === md || t === rc) && this._cache.get(t) ? this._cache.get(t).dirty = !0 : t ? this._cache.delete(t) : this._cache.clear();
  }
  _getCache(t, i) {
    var n = this._cache.get(t), g = t === md || t === rc, r = n === void 0 || g && n.dirty === !0;
    return r && (n = i.call(this), this._cache.set(t, n)), n;
  }
  _calculate(t, i, n) {
    if (!this._attachedDepsListeners.get(t)) {
      const g = i.map((r) => r + "Change.konva").join(dS);
      this.on(g, () => {
        this._clearCache(t);
      }), this._attachedDepsListeners.set(t, !0);
    }
    return this._getCache(t, n);
  }
  _getCanvasCache() {
    return this._cache.get(gu);
  }
  _clearSelfAndDescendantCache(t) {
    this._clearCache(t), t === rc && this.fire("absoluteTransformChange");
  }
  clearCache() {
    if (this._cache.has(gu)) {
      const { scene: t, filter: i, hit: n } = this._cache.get(gu);
      he.releaseCanvas(t, i, n), this._cache.delete(gu);
    }
    return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
  }
  cache(t) {
    var i = t || {}, n = {};
    (i.x === void 0 || i.y === void 0 || i.width === void 0 || i.height === void 0) && (n = this.getClientRect({
      skipTransform: !0,
      relativeTo: this.getParent()
    }));
    var g = Math.ceil(i.width || n.width), r = Math.ceil(i.height || n.height), o = i.pixelRatio, I = i.x === void 0 ? Math.floor(n.x) : i.x, s = i.y === void 0 ? Math.floor(n.y) : i.y, a = i.offset || 0, d = i.drawBorder || !1, C = i.hitCanvasPixelRatio || 1;
    if (!g || !r) {
      he.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
      return;
    }
    g += a * 2 + 1, r += a * 2 + 1, I -= a, s -= a;
    var u = new Zm({
      pixelRatio: o,
      width: g,
      height: r
    }), A = new Zm({
      pixelRatio: o,
      width: 0,
      height: 0
    }), m = new xJ({
      pixelRatio: C,
      width: g,
      height: r
    }), h = u.getContext(), B = m.getContext();
    return m.isCache = !0, u.isCache = !0, this._cache.delete(gu), this._filterUpToDate = !1, i.imageSmoothingEnabled === !1 && (u.getContext()._context.imageSmoothingEnabled = !1, A.getContext()._context.imageSmoothingEnabled = !1), h.save(), B.save(), h.translate(-I, -s), B.translate(-I, -s), this._isUnderCache = !0, this._clearSelfAndDescendantCache(cS), this._clearSelfAndDescendantCache(oT), this.drawScene(u, this), this.drawHit(m, this), this._isUnderCache = !1, h.restore(), B.restore(), d && (h.save(), h.beginPath(), h.rect(0, 0, g, r), h.closePath(), h.setAttr("strokeStyle", "red"), h.setAttr("lineWidth", 5), h.stroke(), h.restore()), this._cache.set(gu, {
      scene: u,
      filter: A,
      hit: m,
      x: I,
      y: s
    }), this._requestDraw(), this;
  }
  isCached() {
    return this._cache.has(gu);
  }
  getClientRect(t) {
    throw new Error('abstract "getClientRect" method call');
  }
  _transformedRect(t, i) {
    var n = [
      { x: t.x, y: t.y },
      { x: t.x + t.width, y: t.y },
      { x: t.x + t.width, y: t.y + t.height },
      { x: t.x, y: t.y + t.height }
    ], g, r, o, I, s = this.getAbsoluteTransform(i);
    return n.forEach(function(a) {
      var d = s.point(a);
      g === void 0 && (g = o = d.x, r = I = d.y), g = Math.min(g, d.x), r = Math.min(r, d.y), o = Math.max(o, d.x), I = Math.max(I, d.y);
    }), {
      x: g,
      y: r,
      width: o - g,
      height: I - r
    };
  }
  _drawCachedSceneCanvas(t) {
    t.save(), t._applyOpacity(this), t._applyGlobalCompositeOperation(this);
    const i = this._getCanvasCache();
    t.translate(i.x, i.y);
    var n = this._getCachedSceneCanvas(), g = n.pixelRatio;
    t.drawImage(n._canvas, 0, 0, n.width / g, n.height / g), t.restore();
  }
  _drawCachedHitCanvas(t) {
    var i = this._getCanvasCache(), n = i.hit;
    t.save(), t.translate(i.x, i.y), t.drawImage(n._canvas, 0, 0, n.width / n.pixelRatio, n.height / n.pixelRatio), t.restore();
  }
  _getCachedSceneCanvas() {
    var t = this.filters(), i = this._getCanvasCache(), n = i.scene, g = i.filter, r = g.getContext(), o, I, s, a;
    if (t) {
      if (!this._filterUpToDate) {
        var d = n.pixelRatio;
        g.setSize(n.width / n.pixelRatio, n.height / n.pixelRatio);
        try {
          for (o = t.length, r.clear(), r.drawImage(n._canvas, 0, 0, n.getWidth() / d, n.getHeight() / d), I = r.getImageData(0, 0, g.getWidth(), g.getHeight()), s = 0; s < o; s++) {
            if (a = t[s], typeof a != "function") {
              he.error("Filter should be type of function, but got " + typeof a + " instead. Please check correct filters");
              continue;
            }
            a.call(this, I), r.putImageData(I, 0, 0);
          }
        } catch (C) {
          he.error("Unable to apply filter. " + C.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
        }
        this._filterUpToDate = !0;
      }
      return g;
    }
    return n;
  }
  on(t, i) {
    if (this._cache && this._cache.delete(hW), arguments.length === 3)
      return this._delegate.apply(this, arguments);
    var n = t.split(dS), g = n.length, r, o, I, s, a;
    for (r = 0; r < g; r++)
      o = n[r], I = o.split("."), s = I[0], a = I[1] || "", this.eventListeners[s] || (this.eventListeners[s] = []), this.eventListeners[s].push({
        name: a,
        handler: i
      });
    return this;
  }
  off(t, i) {
    var n = (t || "").split(dS), g = n.length, r, o, I, s, a, d;
    if (this._cache && this._cache.delete(hW), !t)
      for (o in this.eventListeners)
        this._off(o);
    for (r = 0; r < g; r++)
      if (I = n[r], s = I.split("."), a = s[0], d = s[1], a)
        this.eventListeners[a] && this._off(a, d, i);
      else
        for (o in this.eventListeners)
          this._off(o, d, i);
    return this;
  }
  dispatchEvent(t) {
    var i = {
      target: this,
      type: t.type,
      evt: t
    };
    return this.fire(t.type, i), this;
  }
  addEventListener(t, i) {
    return this.on(t, function(n) {
      i.call(this, n.evt);
    }), this;
  }
  removeEventListener(t) {
    return this.off(t), this;
  }
  _delegate(t, i, n) {
    var g = this;
    this.on(t, function(r) {
      for (var o = r.target.findAncestors(i, !0, g), I = 0; I < o.length; I++)
        r = he.cloneObject(r), r.currentTarget = o[I], n.call(o[I], r);
    });
  }
  remove() {
    return this.isDragging() && this.stopDrag(), Qi._dragElements.delete(this._id), this._remove(), this;
  }
  _clearCaches() {
    this._clearSelfAndDescendantCache(rc), this._clearSelfAndDescendantCache(cS), this._clearSelfAndDescendantCache(oT), this._clearSelfAndDescendantCache(cT), this._clearSelfAndDescendantCache(ex), this._clearSelfAndDescendantCache(qY);
  }
  _remove() {
    this._clearCaches();
    var t = this.getParent();
    t && t.children && (t.children.splice(this.index, 1), t._setChildrenIndices(), this.parent = null);
  }
  destroy() {
    return this.remove(), this.clearCache(), this;
  }
  getAttr(t) {
    var i = "get" + he._capitalize(t);
    return he._isFunction(this[i]) ? this[i]() : this.attrs[t];
  }
  getAncestors() {
    for (var t = this.getParent(), i = []; t; )
      i.push(t), t = t.getParent();
    return i;
  }
  getAttrs() {
    return this.attrs || {};
  }
  setAttrs(t) {
    return this._batchTransformChanges(() => {
      var i, n;
      if (!t)
        return this;
      for (i in t)
        i !== Rtt && (n = sT + he._capitalize(i), he._isFunction(this[n]) ? this[n](t[i]) : this._setAttr(i, t[i]));
    }), this;
  }
  isListening() {
    return this._getCache(qY, this._isListening);
  }
  _isListening(t) {
    if (!this.listening())
      return !1;
    const n = this.getParent();
    return n && n !== t && this !== t ? n._isListening(t) : !0;
  }
  isVisible() {
    return this._getCache(ex, this._isVisible);
  }
  _isVisible(t) {
    if (!this.visible())
      return !1;
    const n = this.getParent();
    return n && n !== t && this !== t ? n._isVisible(t) : !0;
  }
  shouldDrawHit(t, i = !1) {
    if (t)
      return this._isVisible(t) && this._isListening(t);
    var n = this.getLayer(), g = !1;
    Qi._dragElements.forEach((o) => {
      o.dragStatus === "dragging" && (o.node.nodeType === "Stage" || o.node.getLayer() === n) && (g = !0);
    });
    var r = !i && !Mt.hitOnDragEnabled && g;
    return this.isListening() && this.isVisible() && !r;
  }
  show() {
    return this.visible(!0), this;
  }
  hide() {
    return this.visible(!1), this;
  }
  getZIndex() {
    return this.index || 0;
  }
  getAbsoluteZIndex() {
    var t = this.getDepth(), i = this, n = 0, g, r, o, I;
    function s(a) {
      for (g = [], r = a.length, o = 0; o < r; o++)
        I = a[o], n++, I.nodeType !== aT && (g = g.concat(I.getChildren().slice())), I._id === i._id && (o = r);
      g.length > 0 && g[0].getDepth() <= t && s(g);
    }
    return i.nodeType !== Htt && s(i.getStage().getChildren()), n;
  }
  getDepth() {
    for (var t = 0, i = this.parent; i; )
      t++, i = i.parent;
    return t;
  }
  _batchTransformChanges(t) {
    this._batchingTransformChange = !0, t(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(md), this._clearSelfAndDescendantCache(rc)), this._needClearTransformCache = !1;
  }
  setPosition(t) {
    return this._batchTransformChanges(() => {
      this.x(t.x), this.y(t.y);
    }), this;
  }
  getPosition() {
    return {
      x: this.x(),
      y: this.y()
    };
  }
  getRelativePointerPosition() {
    if (!this.getStage())
      return null;
    var t = this.getStage().getPointerPosition();
    if (!t)
      return null;
    var i = this.getAbsoluteTransform().copy();
    return i.invert(), i.point(t);
  }
  getAbsolutePosition(t) {
    let i = !1, n = this.parent;
    for (; n; ) {
      if (n.isCached()) {
        i = !0;
        break;
      }
      n = n.parent;
    }
    i && !t && (t = !0);
    var g = this.getAbsoluteTransform(t).getMatrix(), r = new ZI(), o = this.offset();
    return r.m = g.slice(), r.translate(o.x, o.y), r.getTranslation();
  }
  setAbsolutePosition(t) {
    var i = this._clearTransform();
    this.attrs.x = i.x, this.attrs.y = i.y, delete i.x, delete i.y, this._clearCache(md);
    var n = this._getAbsoluteTransform().copy();
    return n.invert(), n.translate(t.x, t.y), t = {
      x: this.attrs.x + n.getTranslation().x,
      y: this.attrs.y + n.getTranslation().y
    }, this._setTransform(i), this.setPosition({ x: t.x, y: t.y }), this._clearCache(md), this._clearSelfAndDescendantCache(rc), this;
  }
  _setTransform(t) {
    var i;
    for (i in t)
      this.attrs[i] = t[i];
  }
  _clearTransform() {
    var t = {
      x: this.x(),
      y: this.y(),
      rotation: this.rotation(),
      scaleX: this.scaleX(),
      scaleY: this.scaleY(),
      offsetX: this.offsetX(),
      offsetY: this.offsetY(),
      skewX: this.skewX(),
      skewY: this.skewY()
    };
    return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, t;
  }
  move(t) {
    var i = t.x, n = t.y, g = this.x(), r = this.y();
    return i !== void 0 && (g += i), n !== void 0 && (r += n), this.setPosition({ x: g, y: r }), this;
  }
  _eachAncestorReverse(t, i) {
    var n = [], g = this.getParent(), r, o;
    if (!(i && i._id === this._id)) {
      for (n.unshift(this); g && (!i || g._id !== i._id); )
        n.unshift(g), g = g.parent;
      for (r = n.length, o = 0; o < r; o++)
        t(n[o]);
    }
  }
  rotate(t) {
    return this.rotation(this.rotation() + t), this;
  }
  moveToTop() {
    if (!this.parent)
      return he.warn("Node has no parent. moveToTop function is ignored."), !1;
    var t = this.index, i = this.parent.getChildren().length;
    return t < i - 1 ? (this.parent.children.splice(t, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveUp() {
    if (!this.parent)
      return he.warn("Node has no parent. moveUp function is ignored."), !1;
    var t = this.index, i = this.parent.getChildren().length;
    return t < i - 1 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveDown() {
    if (!this.parent)
      return he.warn("Node has no parent. moveDown function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveToBottom() {
    if (!this.parent)
      return he.warn("Node has no parent. moveToBottom function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  setZIndex(t) {
    if (!this.parent)
      return he.warn("Node has no parent. zIndex parameter is ignored."), this;
    (t < 0 || t >= this.parent.children.length) && he.warn("Unexpected value " + t + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
    var i = this.index;
    return this.parent.children.splice(i, 1), this.parent.children.splice(t, 0, this), this.parent._setChildrenIndices(), this;
  }
  getAbsoluteOpacity() {
    return this._getCache(cS, this._getAbsoluteOpacity);
  }
  _getAbsoluteOpacity() {
    var t = this.opacity(), i = this.getParent();
    return i && !i._isUnderCache && (t *= i.getAbsoluteOpacity()), t;
  }
  moveTo(t) {
    return this.getParent() !== t && (this._remove(), t.add(this)), this;
  }
  toObject() {
    var t = {}, i = this.getAttrs(), n, g, r, o, I;
    t.attrs = {};
    for (n in i)
      g = i[n], I = he.isObject(g) && !he._isPlainObject(g) && !he._isArray(g), !I && (r = typeof this[n] == "function" && this[n], delete i[n], o = r ? r.call(this) : null, i[n] = g, o !== g && (t.attrs[n] = g));
    return t.className = this.getClassName(), he._prepareToStringify(t);
  }
  toJSON() {
    return JSON.stringify(this.toObject());
  }
  getParent() {
    return this.parent;
  }
  findAncestors(t, i, n) {
    var g = [];
    i && this._isMatch(t) && g.push(this);
    for (var r = this.parent; r; ) {
      if (r === n)
        return g;
      r._isMatch(t) && g.push(r), r = r.parent;
    }
    return g;
  }
  isAncestorOf(t) {
    return !1;
  }
  findAncestor(t, i, n) {
    return this.findAncestors(t, i, n)[0];
  }
  _isMatch(t) {
    if (!t)
      return !1;
    if (typeof t == "function")
      return t(this);
    var i = t.replace(/ /g, "").split(","), n = i.length, g, r;
    for (g = 0; g < n; g++)
      if (r = i[g], he.isValidSelector(r) || (he.warn('Selector "' + r + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), he.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), he.warn("Konva is awesome, right?")), r.charAt(0) === "#") {
        if (this.id() === r.slice(1))
          return !0;
      } else if (r.charAt(0) === ".") {
        if (this.hasName(r.slice(1)))
          return !0;
      } else if (this.className === r || this.nodeType === r)
        return !0;
    return !1;
  }
  getLayer() {
    var t = this.getParent();
    return t ? t.getLayer() : null;
  }
  getStage() {
    return this._getCache(cT, this._getStage);
  }
  _getStage() {
    var t = this.getParent();
    if (t)
      return t.getStage();
  }
  fire(t, i = {}, n) {
    return i.target = i.target || this, n ? this._fireAndBubble(t, i) : this._fire(t, i), this;
  }
  getAbsoluteTransform(t) {
    return t ? this._getAbsoluteTransform(t) : this._getCache(rc, this._getAbsoluteTransform);
  }
  _getAbsoluteTransform(t) {
    var i;
    if (t)
      return i = new ZI(), this._eachAncestorReverse(function(g) {
        var r = g.transformsEnabled();
        r === "all" ? i.multiply(g.getTransform()) : r === "position" && i.translate(g.x() - g.offsetX(), g.y() - g.offsetY());
      }, t), i;
    i = this._cache.get(rc) || new ZI(), this.parent ? this.parent.getAbsoluteTransform().copyInto(i) : i.reset();
    var n = this.transformsEnabled();
    if (n === "all")
      i.multiply(this.getTransform());
    else if (n === "position") {
      const g = this.attrs.x || 0, r = this.attrs.y || 0, o = this.attrs.offsetX || 0, I = this.attrs.offsetY || 0;
      i.translate(g - o, r - I);
    }
    return i.dirty = !1, i;
  }
  getAbsoluteScale(t) {
    for (var i = this; i; )
      i._isUnderCache && (t = i), i = i.getParent();
    const g = this.getAbsoluteTransform(t).decompose();
    return {
      x: g.scaleX,
      y: g.scaleY
    };
  }
  getAbsoluteRotation() {
    return this.getAbsoluteTransform().decompose().rotation;
  }
  getTransform() {
    return this._getCache(md, this._getTransform);
  }
  _getTransform() {
    var t, i, n = this._cache.get(md) || new ZI();
    n.reset();
    var g = this.x(), r = this.y(), o = Mt.getAngle(this.rotation()), I = (t = this.attrs.scaleX) !== null && t !== void 0 ? t : 1, s = (i = this.attrs.scaleY) !== null && i !== void 0 ? i : 1, a = this.attrs.skewX || 0, d = this.attrs.skewY || 0, C = this.attrs.offsetX || 0, u = this.attrs.offsetY || 0;
    return (g !== 0 || r !== 0) && n.translate(g, r), o !== 0 && n.rotate(o), (a !== 0 || d !== 0) && n.skew(a, d), (I !== 1 || s !== 1) && n.scale(I, s), (C !== 0 || u !== 0) && n.translate(-1 * C, -1 * u), n.dirty = !1, n;
  }
  clone(t) {
    var i = he.cloneObject(this.attrs), n, g, r, o, I;
    for (n in t)
      i[n] = t[n];
    var s = new this.constructor(i);
    for (n in this.eventListeners)
      for (g = this.eventListeners[n], r = g.length, o = 0; o < r; o++)
        I = g[o], I.name.indexOf(Xtt) < 0 && (s.eventListeners[n] || (s.eventListeners[n] = []), s.eventListeners[n].push(I));
    return s;
  }
  _toKonvaCanvas(t) {
    t = t || {};
    var i = this.getClientRect(), n = this.getStage(), g = t.x !== void 0 ? t.x : Math.floor(i.x), r = t.y !== void 0 ? t.y : Math.floor(i.y), o = t.pixelRatio || 1, I = new Zm({
      width: t.width || Math.ceil(i.width) || (n ? n.width() : 0),
      height: t.height || Math.ceil(i.height) || (n ? n.height() : 0),
      pixelRatio: o
    }), s = I.getContext();
    return t.imageSmoothingEnabled === !1 && (s._context.imageSmoothingEnabled = !1), s.save(), (g || r) && s.translate(-1 * g, -1 * r), this.drawScene(I), s.restore(), I;
  }
  toCanvas(t) {
    return this._toKonvaCanvas(t)._canvas;
  }
  toDataURL(t) {
    t = t || {};
    var i = t.mimeType || null, n = t.quality || null, g = this._toKonvaCanvas(t).toDataURL(i, n);
    return t.callback && t.callback(g), g;
  }
  toImage(t) {
    return new Promise((i, n) => {
      try {
        const g = t == null ? void 0 : t.callback;
        g && delete t.callback, he._urlToImage(this.toDataURL(t), function(r) {
          i(r), g == null || g(r);
        });
      } catch (g) {
        n(g);
      }
    });
  }
  toBlob(t) {
    return new Promise((i, n) => {
      try {
        const g = t == null ? void 0 : t.callback;
        g && delete t.callback, this.toCanvas(t).toBlob((r) => {
          i(r), g == null || g(r);
        });
      } catch (g) {
        n(g);
      }
    });
  }
  setSize(t) {
    return this.width(t.width), this.height(t.height), this;
  }
  getSize() {
    return {
      width: this.width(),
      height: this.height()
    };
  }
  getClassName() {
    return this.className || this.nodeType;
  }
  getType() {
    return this.nodeType;
  }
  getDragDistance() {
    return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : Mt.dragDistance;
  }
  _off(t, i, n) {
    var g = this.eventListeners[t], r, o, I;
    for (r = 0; r < g.length; r++)
      if (o = g[r].name, I = g[r].handler, (o !== "konva" || i === "konva") && (!i || o === i) && (!n || n === I)) {
        if (g.splice(r, 1), g.length === 0) {
          delete this.eventListeners[t];
          break;
        }
        r--;
      }
  }
  _fireChangeEvent(t, i, n) {
    this._fire(t + vtt, {
      oldVal: i,
      newVal: n
    });
  }
  addName(t) {
    if (!this.hasName(t)) {
      var i = this.name(), n = i ? i + " " + t : t;
      this.name(n);
    }
    return this;
  }
  hasName(t) {
    if (!t)
      return !1;
    const i = this.name();
    if (!i)
      return !1;
    var n = (i || "").split(/\s/g);
    return n.indexOf(t) !== -1;
  }
  removeName(t) {
    var i = (this.name() || "").split(/\s/g), n = i.indexOf(t);
    return n !== -1 && (i.splice(n, 1), this.name(i.join(" "))), this;
  }
  setAttr(t, i) {
    var n = this[sT + he._capitalize(t)];
    return he._isFunction(n) ? n.call(this, i) : this._setAttr(t, i), this;
  }
  _requestDraw() {
    if (Mt.autoDrawEnabled) {
      const t = this.getLayer() || this.getStage();
      t == null || t.batchDraw();
    }
  }
  _setAttr(t, i) {
    var n = this.attrs[t];
    n === i && !he.isObject(i) || (i == null ? delete this.attrs[t] : this.attrs[t] = i, this._shouldFireChangeEvents && this._fireChangeEvent(t, n, i), this._requestDraw());
  }
  _setComponentAttr(t, i, n) {
    var g;
    n !== void 0 && (g = this.attrs[t], g || (this.attrs[t] = this.getAttr(t)), this.attrs[t][i] = n, this._fireChangeEvent(t, g, n));
  }
  _fireAndBubble(t, i, n) {
    i && this.nodeType === aT && (i.target = this);
    var g = (t === IT || t === lT) && (n && (this === n || this.isAncestorOf && this.isAncestorOf(n)) || this.nodeType === "Stage" && !n);
    if (!g) {
      this._fire(t, i);
      var r = (t === IT || t === lT) && n && n.isAncestorOf && n.isAncestorOf(this) && !n.isAncestorOf(this.parent);
      (i && !i.cancelBubble || !i) && this.parent && this.parent.isListening() && !r && (n && n.parent ? this._fireAndBubble.call(this.parent, t, i, n) : this._fireAndBubble.call(this.parent, t, i));
    }
  }
  _getProtoListeners(t) {
    let i = this._cache.get(hW);
    if (!i) {
      i = {};
      let g = Object.getPrototypeOf(this);
      for (; g; ) {
        if (!g.eventListeners) {
          g = Object.getPrototypeOf(g);
          continue;
        }
        for (var n in g.eventListeners) {
          const r = g.eventListeners[n], o = i[n] || [];
          i[n] = r.concat(o);
        }
        g = Object.getPrototypeOf(g);
      }
      this._cache.set(hW, i);
    }
    return i[t];
  }
  _fire(t, i) {
    i = i || {}, i.currentTarget = this, i.type = t;
    const n = this._getProtoListeners(t);
    if (n)
      for (var g = 0; g < n.length; g++)
        n[g].handler.call(this, i);
    const r = this.eventListeners[t];
    if (r)
      for (var g = 0; g < r.length; g++)
        r[g].handler.call(this, i);
  }
  draw() {
    return this.drawScene(), this.drawHit(), this;
  }
  _createDragElement(t) {
    var i = t ? t.pointerId : void 0, n = this.getStage(), g = this.getAbsolutePosition(), r = n._getPointerById(i) || n._changedPointerPositions[0] || g;
    Qi._dragElements.set(this._id, {
      node: this,
      startPointerPos: r,
      offset: {
        x: r.x - g.x,
        y: r.y - g.y
      },
      dragStatus: "ready",
      pointerId: i
    });
  }
  startDrag(t, i = !0) {
    Qi._dragElements.has(this._id) || this._createDragElement(t);
    const n = Qi._dragElements.get(this._id);
    n.dragStatus = "dragging", this.fire("dragstart", {
      type: "dragstart",
      target: this,
      evt: t && t.evt
    }, i);
  }
  _setDragPosition(t, i) {
    const n = this.getStage()._getPointerById(i.pointerId);
    if (n) {
      var g = {
        x: n.x - i.offset.x,
        y: n.y - i.offset.y
      }, r = this.dragBoundFunc();
      if (r !== void 0) {
        const o = r.call(this, g, t);
        o ? g = o : he.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== g.x || this._lastPos.y !== g.y) && (this.setAbsolutePosition(g), this._requestDraw()), this._lastPos = g;
    }
  }
  stopDrag(t) {
    const i = Qi._dragElements.get(this._id);
    i && (i.dragStatus = "stopped"), Qi._endDragBefore(t), Qi._endDragAfter(t);
  }
  setDraggable(t) {
    this._setAttr("draggable", t), this._dragChange();
  }
  isDragging() {
    const t = Qi._dragElements.get(this._id);
    return t ? t.dragStatus === "dragging" : !1;
  }
  _listenDrag() {
    this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(t) {
      var i = t.evt.button !== void 0, n = !i || Mt.dragButtons.indexOf(t.evt.button) >= 0;
      if (n && !this.isDragging()) {
        var g = !1;
        Qi._dragElements.forEach((r) => {
          this.isAncestorOf(r.node) && (g = !0);
        }), g || this._createDragElement(t);
      }
    });
  }
  _dragChange() {
    if (this.attrs.draggable)
      this._listenDrag();
    else {
      this._dragCleanup();
      var t = this.getStage();
      if (!t)
        return;
      const i = Qi._dragElements.get(this._id), n = i && i.dragStatus === "dragging", g = i && i.dragStatus === "ready";
      n ? this.stopDrag() : g && Qi._dragElements.delete(this._id);
    }
  }
  _dragCleanup() {
    this.off("mousedown.konva"), this.off("touchstart.konva");
  }
  isClientRectOnScreen(t = { x: 0, y: 0 }) {
    const i = this.getStage();
    if (!i)
      return !1;
    const n = {
      x: -t.x,
      y: -t.y,
      width: i.width() + 2 * t.x,
      height: i.height() + 2 * t.y
    };
    return he.haveIntersection(n, this.getClientRect());
  }
  static create(t, i) {
    return he._isString(t) && (t = JSON.parse(t)), this._createNode(t, i);
  }
  static _createNode(t, i) {
    var n = tx.prototype.getClassName.call(t), g = t.children, r, o, I;
    i && (t.attrs.container = i), Mt[n] || (he.warn('Can not find a node with class name "' + n + '". Fallback to "Shape".'), n = "Shape");
    const s = Mt[n];
    if (r = new s(t.attrs), g)
      for (o = g.length, I = 0; I < o; I++)
        r.add(tx._createNode(g[I]));
    return r;
  }
};
mt.prototype.nodeType = "Node";
mt.prototype._attrsAffectingSize = [];
mt.prototype.eventListeners = {};
mt.prototype.on.call(mt.prototype, ktt, function() {
  if (this._batchingTransformChange) {
    this._needClearTransformCache = !0;
    return;
  }
  this._clearCache(md), this._clearSelfAndDescendantCache(rc);
});
mt.prototype.on.call(mt.prototype, "visibleChange.konva", function() {
  this._clearSelfAndDescendantCache(ex);
});
mt.prototype.on.call(mt.prototype, "listeningChange.konva", function() {
  this._clearSelfAndDescendantCache(qY);
});
mt.prototype.on.call(mt.prototype, "opacityChange.konva", function() {
  this._clearSelfAndDescendantCache(cS);
});
const Fn = Ie.addGetterSetter;
Fn(mt, "zIndex");
Fn(mt, "absolutePosition");
Fn(mt, "position");
Fn(mt, "x", 0, bt());
Fn(mt, "y", 0, bt());
Fn(mt, "globalCompositeOperation", "source-over", bh());
Fn(mt, "opacity", 1, bt());
Fn(mt, "name", "", bh());
Fn(mt, "id", "", bh());
Fn(mt, "rotation", 0, bt());
Ie.addComponentsGetterSetter(mt, "scale", ["x", "y"]);
Fn(mt, "scaleX", 1, bt());
Fn(mt, "scaleY", 1, bt());
Ie.addComponentsGetterSetter(mt, "skew", ["x", "y"]);
Fn(mt, "skewX", 0, bt());
Fn(mt, "skewY", 0, bt());
Ie.addComponentsGetterSetter(mt, "offset", ["x", "y"]);
Fn(mt, "offsetX", 0, bt());
Fn(mt, "offsetY", 0, bt());
Fn(mt, "dragDistance", null, bt());
Fn(mt, "width", 0, bt());
Fn(mt, "height", 0, bt());
Fn(mt, "listening", !0, ws());
Fn(mt, "preventDefault", !0, ws());
Fn(mt, "filters", null, function(e) {
  return this._filterUpToDate = !1, e;
});
Fn(mt, "visible", !0, ws());
Fn(mt, "transformsEnabled", "all", bh());
Fn(mt, "size");
Fn(mt, "dragBoundFunc");
Fn(mt, "draggable", !1, ws());
Ie.backCompat(mt, {
  rotateDeg: "rotate",
  setRotationDeg: "setRotation",
  getRotationDeg: "getRotation"
});
class vI extends mt {
  constructor() {
    super(...arguments), this.children = [];
  }
  getChildren(t) {
    if (!t)
      return this.children || [];
    const i = this.children || [];
    var n = [];
    return i.forEach(function(g) {
      t(g) && n.push(g);
    }), n;
  }
  hasChildren() {
    return this.getChildren().length > 0;
  }
  removeChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.remove();
    }), this.children = [], this._requestDraw(), this;
  }
  destroyChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.destroy();
    }), this.children = [], this._requestDraw(), this;
  }
  add(...t) {
    if (t.length === 0)
      return this;
    if (t.length > 1) {
      for (var i = 0; i < t.length; i++)
        this.add(t[i]);
      return this;
    }
    const n = t[0];
    return n.getParent() ? (n.moveTo(this), this) : (this._validateAdd(n), n.index = this.getChildren().length, n.parent = this, n._clearCaches(), this.getChildren().push(n), this._fire("add", {
      child: n
    }), this._requestDraw(), this);
  }
  destroy() {
    return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
  }
  find(t) {
    return this._generalFind(t, !1);
  }
  findOne(t) {
    var i = this._generalFind(t, !0);
    return i.length > 0 ? i[0] : void 0;
  }
  _generalFind(t, i) {
    var n = [];
    return this._descendants((g) => {
      const r = g._isMatch(t);
      return r && n.push(g), !!(r && i);
    }), n;
  }
  _descendants(t) {
    let i = !1;
    const n = this.getChildren();
    for (const g of n) {
      if (i = t(g), i)
        return !0;
      if (g.hasChildren() && (i = g._descendants(t), i))
        return !0;
    }
    return !1;
  }
  toObject() {
    var t = mt.prototype.toObject.call(this);
    return t.children = [], this.getChildren().forEach((i) => {
      t.children.push(i.toObject());
    }), t;
  }
  isAncestorOf(t) {
    for (var i = t.getParent(); i; ) {
      if (i._id === this._id)
        return !0;
      i = i.getParent();
    }
    return !1;
  }
  clone(t) {
    var i = mt.prototype.clone.call(this, t);
    return this.getChildren().forEach(function(n) {
      i.add(n.clone());
    }), i;
  }
  getAllIntersections(t) {
    var i = [];
    return this.find("Shape").forEach(function(n) {
      n.isVisible() && n.intersects(t) && i.push(n);
    }), i;
  }
  _clearSelfAndDescendantCache(t) {
    var i;
    super._clearSelfAndDescendantCache(t), !this.isCached() && ((i = this.children) === null || i === void 0 || i.forEach(function(n) {
      n._clearSelfAndDescendantCache(t);
    }));
  }
  _setChildrenIndices() {
    var t;
    (t = this.children) === null || t === void 0 || t.forEach(function(i, n) {
      i.index = n;
    }), this._requestDraw();
  }
  drawScene(t, i) {
    var n = this.getLayer(), g = t || n && n.getCanvas(), r = g && g.getContext(), o = this._getCanvasCache(), I = o && o.scene, s = g && g.isCache;
    if (!this.isVisible() && !s)
      return this;
    if (I) {
      r.save();
      var a = this.getAbsoluteTransform(i).getMatrix();
      r.transform(a[0], a[1], a[2], a[3], a[4], a[5]), this._drawCachedSceneCanvas(r), r.restore();
    } else
      this._drawChildren("drawScene", g, i);
    return this;
  }
  drawHit(t, i) {
    if (!this.shouldDrawHit(i))
      return this;
    var n = this.getLayer(), g = t || n && n.hitCanvas, r = g && g.getContext(), o = this._getCanvasCache(), I = o && o.hit;
    if (I) {
      r.save();
      var s = this.getAbsoluteTransform(i).getMatrix();
      r.transform(s[0], s[1], s[2], s[3], s[4], s[5]), this._drawCachedHitCanvas(r), r.restore();
    } else
      this._drawChildren("drawHit", g, i);
    return this;
  }
  _drawChildren(t, i, n) {
    var g, r = i && i.getContext(), o = this.clipWidth(), I = this.clipHeight(), s = this.clipFunc(), a = o && I || s;
    const d = n === this;
    if (a) {
      r.save();
      var C = this.getAbsoluteTransform(n), u = C.getMatrix();
      if (r.transform(u[0], u[1], u[2], u[3], u[4], u[5]), r.beginPath(), s)
        s.call(this, r, this);
      else {
        var A = this.clipX(), m = this.clipY();
        r.rect(A, m, o, I);
      }
      r.clip(), u = C.copy().invert().getMatrix(), r.transform(u[0], u[1], u[2], u[3], u[4], u[5]);
    }
    var h = !d && this.globalCompositeOperation() !== "source-over" && t === "drawScene";
    h && (r.save(), r._applyGlobalCompositeOperation(this)), (g = this.children) === null || g === void 0 || g.forEach(function(B) {
      B[t](i, n);
    }), h && r.restore(), a && r.restore();
  }
  getClientRect(t) {
    var i;
    t = t || {};
    var n = t.skipTransform, g = t.relativeTo, r, o, I, s, a = {
      x: 1 / 0,
      y: 1 / 0,
      width: 0,
      height: 0
    }, d = this;
    (i = this.children) === null || i === void 0 || i.forEach(function(h) {
      if (h.visible()) {
        var B = h.getClientRect({
          relativeTo: d,
          skipShadow: t.skipShadow,
          skipStroke: t.skipStroke
        });
        B.width === 0 && B.height === 0 || (r === void 0 ? (r = B.x, o = B.y, I = B.x + B.width, s = B.y + B.height) : (r = Math.min(r, B.x), o = Math.min(o, B.y), I = Math.max(I, B.x + B.width), s = Math.max(s, B.y + B.height)));
      }
    });
    for (var C = this.find("Shape"), u = !1, A = 0; A < C.length; A++) {
      var m = C[A];
      if (m._isVisible(this)) {
        u = !0;
        break;
      }
    }
    return u && r !== void 0 ? a = {
      x: r,
      y: o,
      width: I - r,
      height: s - o
    } : a = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, n ? a : this._transformedRect(a, g);
  }
}
Ie.addComponentsGetterSetter(vI, "clip", [
  "x",
  "y",
  "width",
  "height"
]);
Ie.addGetterSetter(vI, "clipX", void 0, bt());
Ie.addGetterSetter(vI, "clipY", void 0, bt());
Ie.addGetterSetter(vI, "clipWidth", void 0, bt());
Ie.addGetterSetter(vI, "clipHeight", void 0, bt());
Ie.addGetterSetter(vI, "clipFunc");
const iZ = /* @__PURE__ */ new Map(), T7 = Mt._global.PointerEvent !== void 0;
function Dk(e) {
  return iZ.get(e);
}
function DJ(e) {
  return {
    evt: e,
    pointerId: e.pointerId
  };
}
function M7(e, t) {
  return iZ.get(e) === t;
}
function U7(e, t) {
  bB(e), t.getStage() && (iZ.set(e, t), T7 && t._fire("gotpointercapture", DJ(new PointerEvent("gotpointercapture"))));
}
function bB(e, t) {
  const i = iZ.get(e);
  if (!i)
    return;
  const n = i.getStage();
  n && n.content, iZ.delete(e), T7 && i._fire("lostpointercapture", DJ(new PointerEvent("lostpointercapture")));
}
var Ytt = "Stage", xtt = "string", dT = "px", Dtt = "mouseout", P7 = "mouseleave", z7 = "mouseover", O7 = "mouseenter", Q7 = "mousemove", j7 = "mousedown", _7 = "mouseup", q0 = "pointermove", eB = "pointerdown", dm = "pointerup", tB = "pointercancel", Jtt = "lostpointercapture", pW = "pointerout", BW = "pointerleave", ZW = "pointerover", fW = "pointerenter", ix = "contextmenu", $7 = "touchstart", q7 = "touchend", e8 = "touchmove", t8 = "touchcancel", nx = "wheel", Ktt = 5, Ett = [
  [O7, "_pointerenter"],
  [j7, "_pointerdown"],
  [Q7, "_pointermove"],
  [_7, "_pointerup"],
  [P7, "_pointerleave"],
  [$7, "_pointerdown"],
  [e8, "_pointermove"],
  [q7, "_pointerup"],
  [t8, "_pointercancel"],
  [z7, "_pointerover"],
  [nx, "_wheel"],
  [ix, "_contextmenu"],
  [eB, "_pointerdown"],
  [q0, "_pointermove"],
  [dm, "_pointerup"],
  [tB, "_pointercancel"],
  [Jtt, "_lostpointercapture"]
];
const Jk = {
  mouse: {
    [pW]: Dtt,
    [BW]: P7,
    [ZW]: z7,
    [fW]: O7,
    [q0]: Q7,
    [eB]: j7,
    [dm]: _7,
    [tB]: "mousecancel",
    pointerclick: "click",
    pointerdblclick: "dblclick"
  },
  touch: {
    [pW]: "touchout",
    [BW]: "touchleave",
    [ZW]: "touchover",
    [fW]: "touchenter",
    [q0]: e8,
    [eB]: $7,
    [dm]: q7,
    [tB]: t8,
    pointerclick: "tap",
    pointerdblclick: "dbltap"
  },
  pointer: {
    [pW]: pW,
    [BW]: BW,
    [ZW]: ZW,
    [fW]: fW,
    [q0]: q0,
    [eB]: eB,
    [dm]: dm,
    [tB]: tB,
    pointerclick: "pointerclick",
    pointerdblclick: "pointerdblclick"
  }
}, iB = (e) => e.indexOf("pointer") >= 0 ? "pointer" : e.indexOf("touch") >= 0 ? "touch" : "mouse", Tb = (e) => {
  const t = iB(e);
  if (t === "pointer")
    return Mt.pointerEventsEnabled && Jk.pointer;
  if (t === "touch")
    return Jk.touch;
  if (t === "mouse")
    return Jk.mouse;
};
function CT(e = {}) {
  return (e.clipFunc || e.clipWidth || e.clipHeight) && he.warn("Stage does not support clipping. Please use clip for Layers or Groups."), e;
}
const Ntt = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);", CS = [];
let t2 = class extends vI {
  constructor(t) {
    super(CT(t)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), CS.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
      CT(this.attrs);
    }), this._checkVisibility();
  }
  _validateAdd(t) {
    const i = t.getType() === "Layer", n = t.getType() === "FastLayer";
    i || n || he.throw("You may only add layers to the stage.");
  }
  _checkVisibility() {
    if (!this.content)
      return;
    const t = this.visible() ? "" : "none";
    this.content.style.display = t;
  }
  setContainer(t) {
    if (typeof t === xtt) {
      if (t.charAt(0) === ".") {
        var i = t.slice(1);
        t = document.getElementsByClassName(i)[0];
      } else {
        var n;
        t.charAt(0) !== "#" ? n = t : n = t.slice(1), t = document.getElementById(n);
      }
      if (!t)
        throw "Can not find container in document with id " + n;
    }
    return this._setAttr("container", t), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), t.appendChild(this.content)), this;
  }
  shouldDrawHit() {
    return !0;
  }
  clear() {
    var t = this.children, i = t.length, n;
    for (n = 0; n < i; n++)
      t[n].clear();
    return this;
  }
  clone(t) {
    return t || (t = {}), t.container = typeof document < "u" && document.createElement("div"), vI.prototype.clone.call(this, t);
  }
  destroy() {
    super.destroy();
    var t = this.content;
    t && he._isInDocument(t) && this.container().removeChild(t);
    var i = CS.indexOf(this);
    return i > -1 && CS.splice(i, 1), he.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
  }
  getPointerPosition() {
    const t = this._pointerPositions[0] || this._changedPointerPositions[0];
    return t ? {
      x: t.x,
      y: t.y
    } : (he.warn(Ntt), null);
  }
  _getPointerById(t) {
    return this._pointerPositions.find((i) => i.id === t);
  }
  getPointersPositions() {
    return this._pointerPositions;
  }
  getStage() {
    return this;
  }
  getContent() {
    return this.content;
  }
  _toKonvaCanvas(t) {
    t = t || {}, t.x = t.x || 0, t.y = t.y || 0, t.width = t.width || this.width(), t.height = t.height || this.height();
    var i = new Zm({
      width: t.width,
      height: t.height,
      pixelRatio: t.pixelRatio || 1
    }), n = i.getContext()._context, g = this.children;
    return (t.x || t.y) && n.translate(-1 * t.x, -1 * t.y), g.forEach(function(r) {
      if (r.isVisible()) {
        var o = r._toKonvaCanvas(t);
        n.drawImage(o._canvas, t.x, t.y, o.getWidth() / o.getPixelRatio(), o.getHeight() / o.getPixelRatio());
      }
    }), i;
  }
  getIntersection(t) {
    if (!t)
      return null;
    var i = this.children, n = i.length, g = n - 1, r;
    for (r = g; r >= 0; r--) {
      const o = i[r].getIntersection(t);
      if (o)
        return o;
    }
    return null;
  }
  _resizeDOM() {
    var t = this.width(), i = this.height();
    this.content && (this.content.style.width = t + dT, this.content.style.height = i + dT), this.bufferCanvas.setSize(t, i), this.bufferHitCanvas.setSize(t, i), this.children.forEach((n) => {
      n.setSize({ width: t, height: i }), n.draw();
    });
  }
  add(t, ...i) {
    if (arguments.length > 1) {
      for (var n = 0; n < arguments.length; n++)
        this.add(arguments[n]);
      return this;
    }
    super.add(t);
    var g = this.children.length;
    return g > Ktt && he.warn("The stage has " + g + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), t.setSize({ width: this.width(), height: this.height() }), t.draw(), Mt.isBrowser && this.content.appendChild(t.canvas._canvas), this;
  }
  getParent() {
    return null;
  }
  getLayer() {
    return null;
  }
  hasPointerCapture(t) {
    return M7(t, this);
  }
  setPointerCapture(t) {
    U7(t, this);
  }
  releaseCapture(t) {
    bB(t);
  }
  getLayers() {
    return this.children;
  }
  _bindContentEvents() {
    Mt.isBrowser && Ett.forEach(([t, i]) => {
      this.content.addEventListener(t, (n) => {
        this[i](n);
      }, { passive: !1 });
    });
  }
  _pointerenter(t) {
    this.setPointersPositions(t);
    const i = Tb(t.type);
    this._fire(i.pointerenter, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _pointerover(t) {
    this.setPointersPositions(t);
    const i = Tb(t.type);
    this._fire(i.pointerover, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _getTargetShape(t) {
    let i = this[t + "targetShape"];
    return i && !i.getStage() && (i = null), i;
  }
  _pointerleave(t) {
    const i = Tb(t.type), n = iB(t.type);
    if (i) {
      this.setPointersPositions(t);
      var g = this._getTargetShape(n), r = !Qi.isDragging || Mt.hitOnDragEnabled;
      g && r ? (g._fireAndBubble(i.pointerout, { evt: t }), g._fireAndBubble(i.pointerleave, { evt: t }), this._fire(i.pointerleave, {
        evt: t,
        target: this,
        currentTarget: this
      }), this[n + "targetShape"] = null) : r && (this._fire(i.pointerleave, {
        evt: t,
        target: this,
        currentTarget: this
      }), this._fire(i.pointerout, {
        evt: t,
        target: this,
        currentTarget: this
      })), this.pointerPos = void 0, this._pointerPositions = [];
    }
  }
  _pointerdown(t) {
    const i = Tb(t.type), n = iB(t.type);
    if (i) {
      this.setPointersPositions(t);
      var g = !1;
      this._changedPointerPositions.forEach((r) => {
        var o = this.getIntersection(r);
        if (Qi.justDragged = !1, Mt["_" + n + "ListenClick"] = !0, !(o && o.isListening()))
          return;
        Mt.capturePointerEventsEnabled && o.setPointerCapture(r.id), this[n + "ClickStartShape"] = o, o._fireAndBubble(i.pointerdown, {
          evt: t,
          pointerId: r.id
        }), g = !0;
        const s = t.type.indexOf("touch") >= 0;
        o.preventDefault() && t.cancelable && s && t.preventDefault();
      }), g || this._fire(i.pointerdown, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: this._pointerPositions[0].id
      });
    }
  }
  _pointermove(t) {
    const i = Tb(t.type), n = iB(t.type);
    if (!i)
      return;
    Qi.isDragging && Qi.node.preventDefault() && t.cancelable && t.preventDefault(), this.setPointersPositions(t);
    var g = !Qi.isDragging || Mt.hitOnDragEnabled;
    if (!g)
      return;
    var r = {};
    let o = !1;
    var I = this._getTargetShape(n);
    this._changedPointerPositions.forEach((s) => {
      const a = Dk(s.id) || this.getIntersection(s), d = s.id, C = { evt: t, pointerId: d };
      var u = I !== a;
      if (u && I && (I._fireAndBubble(i.pointerout, Object.assign({}, C), a), I._fireAndBubble(i.pointerleave, Object.assign({}, C), a)), a) {
        if (r[a._id])
          return;
        r[a._id] = !0;
      }
      a && a.isListening() ? (o = !0, u && (a._fireAndBubble(i.pointerover, Object.assign({}, C), I), a._fireAndBubble(i.pointerenter, Object.assign({}, C), I), this[n + "targetShape"] = a), a._fireAndBubble(i.pointermove, Object.assign({}, C))) : I && (this._fire(i.pointerover, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: d
      }), this[n + "targetShape"] = null);
    }), o || this._fire(i.pointermove, {
      evt: t,
      target: this,
      currentTarget: this,
      pointerId: this._changedPointerPositions[0].id
    });
  }
  _pointerup(t) {
    const i = Tb(t.type), n = iB(t.type);
    if (!i)
      return;
    this.setPointersPositions(t);
    const g = this[n + "ClickStartShape"], r = this[n + "ClickEndShape"];
    var o = {};
    let I = !1;
    this._changedPointerPositions.forEach((s) => {
      const a = Dk(s.id) || this.getIntersection(s);
      if (a) {
        if (a.releaseCapture(s.id), o[a._id])
          return;
        o[a._id] = !0;
      }
      const d = s.id, C = { evt: t, pointerId: d };
      let u = !1;
      Mt["_" + n + "InDblClickWindow"] ? (u = !0, clearTimeout(this[n + "DblTimeout"])) : Qi.justDragged || (Mt["_" + n + "InDblClickWindow"] = !0, clearTimeout(this[n + "DblTimeout"])), this[n + "DblTimeout"] = setTimeout(function() {
        Mt["_" + n + "InDblClickWindow"] = !1;
      }, Mt.dblClickWindow), a && a.isListening() ? (I = !0, this[n + "ClickEndShape"] = a, a._fireAndBubble(i.pointerup, Object.assign({}, C)), Mt["_" + n + "ListenClick"] && g && g === a && (a._fireAndBubble(i.pointerclick, Object.assign({}, C)), u && r && r === a && a._fireAndBubble(i.pointerdblclick, Object.assign({}, C)))) : (this[n + "ClickEndShape"] = null, Mt["_" + n + "ListenClick"] && this._fire(i.pointerclick, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: d
      }), u && this._fire(i.pointerdblclick, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: d
      }));
    }), I || this._fire(i.pointerup, {
      evt: t,
      target: this,
      currentTarget: this,
      pointerId: this._changedPointerPositions[0].id
    }), Mt["_" + n + "ListenClick"] = !1, t.cancelable && n !== "touch" && t.preventDefault();
  }
  _contextmenu(t) {
    this.setPointersPositions(t);
    var i = this.getIntersection(this.getPointerPosition());
    i && i.isListening() ? i._fireAndBubble(ix, { evt: t }) : this._fire(ix, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _wheel(t) {
    this.setPointersPositions(t);
    var i = this.getIntersection(this.getPointerPosition());
    i && i.isListening() ? i._fireAndBubble(nx, { evt: t }) : this._fire(nx, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _pointercancel(t) {
    this.setPointersPositions(t);
    const i = Dk(t.pointerId) || this.getIntersection(this.getPointerPosition());
    i && i._fireAndBubble(dm, DJ(t)), bB(t.pointerId);
  }
  _lostpointercapture(t) {
    bB(t.pointerId);
  }
  setPointersPositions(t) {
    var i = this._getContentPosition(), n = null, g = null;
    t = t || window.event, t.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(t.touches, (r) => {
      this._pointerPositions.push({
        id: r.identifier,
        x: (r.clientX - i.left) / i.scaleX,
        y: (r.clientY - i.top) / i.scaleY
      });
    }), Array.prototype.forEach.call(t.changedTouches || t.touches, (r) => {
      this._changedPointerPositions.push({
        id: r.identifier,
        x: (r.clientX - i.left) / i.scaleX,
        y: (r.clientY - i.top) / i.scaleY
      });
    })) : (n = (t.clientX - i.left) / i.scaleX, g = (t.clientY - i.top) / i.scaleY, this.pointerPos = {
      x: n,
      y: g
    }, this._pointerPositions = [{ x: n, y: g, id: he._getFirstPointerId(t) }], this._changedPointerPositions = [
      { x: n, y: g, id: he._getFirstPointerId(t) }
    ]);
  }
  _setPointerPosition(t) {
    he.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(t);
  }
  _getContentPosition() {
    if (!this.content || !this.content.getBoundingClientRect)
      return {
        top: 0,
        left: 0,
        scaleX: 1,
        scaleY: 1
      };
    var t = this.content.getBoundingClientRect();
    return {
      top: t.top,
      left: t.left,
      scaleX: t.width / this.content.clientWidth || 1,
      scaleY: t.height / this.content.clientHeight || 1
    };
  }
  _buildDOM() {
    if (this.bufferCanvas = new Zm({
      width: this.width(),
      height: this.height()
    }), this.bufferHitCanvas = new xJ({
      pixelRatio: 1,
      width: this.width(),
      height: this.height()
    }), !!Mt.isBrowser) {
      var t = this.container();
      if (!t)
        throw "Stage has no container. A container is required.";
      t.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), t.appendChild(this.content), this._resizeDOM();
    }
  }
  cache() {
    return he.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
  }
  clearCache() {
    return this;
  }
  batchDraw() {
    return this.getChildren().forEach(function(t) {
      t.batchDraw();
    }), this;
  }
};
t2.prototype.nodeType = Ytt;
rg(t2);
Ie.addGetterSetter(t2, "container");
var i8 = "hasShadow", n8 = "shadowRGBA", g8 = "patternImage", r8 = "linearGradient", o8 = "radialGradient";
let GW;
function Kk() {
  return GW || (GW = he.createCanvasElement().getContext("2d"), GW);
}
const mB = {};
function Ltt(e) {
  e.fill();
}
function Ttt(e) {
  e.stroke();
}
function Mtt(e) {
  e.fill();
}
function Utt(e) {
  e.stroke();
}
function Ptt() {
  this._clearCache(i8);
}
function ztt() {
  this._clearCache(n8);
}
function Ott() {
  this._clearCache(g8);
}
function Qtt() {
  this._clearCache(r8);
}
function jtt() {
  this._clearCache(o8);
}
class ct extends mt {
  constructor(t) {
    super(t);
    let i;
    for (; i = he.getRandomColor(), !(i && !(i in mB)); )
      ;
    this.colorKey = i, mB[i] = this;
  }
  getContext() {
    return he.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
  }
  getCanvas() {
    return he.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
  }
  getSceneFunc() {
    return this.attrs.sceneFunc || this._sceneFunc;
  }
  getHitFunc() {
    return this.attrs.hitFunc || this._hitFunc;
  }
  hasShadow() {
    return this._getCache(i8, this._hasShadow);
  }
  _hasShadow() {
    return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
  }
  _getFillPattern() {
    return this._getCache(g8, this.__getFillPattern);
  }
  __getFillPattern() {
    if (this.fillPatternImage()) {
      var t = Kk();
      const i = t.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
      if (i && i.setTransform) {
        const n = new ZI();
        n.translate(this.fillPatternX(), this.fillPatternY()), n.rotate(Mt.getAngle(this.fillPatternRotation())), n.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), n.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
        const g = n.getMatrix(), r = typeof DOMMatrix > "u" ? {
          a: g[0],
          b: g[1],
          c: g[2],
          d: g[3],
          e: g[4],
          f: g[5]
        } : new DOMMatrix(g);
        i.setTransform(r);
      }
      return i;
    }
  }
  _getLinearGradient() {
    return this._getCache(r8, this.__getLinearGradient);
  }
  __getLinearGradient() {
    var t = this.fillLinearGradientColorStops();
    if (t) {
      for (var i = Kk(), n = this.fillLinearGradientStartPoint(), g = this.fillLinearGradientEndPoint(), r = i.createLinearGradient(n.x, n.y, g.x, g.y), o = 0; o < t.length; o += 2)
        r.addColorStop(t[o], t[o + 1]);
      return r;
    }
  }
  _getRadialGradient() {
    return this._getCache(o8, this.__getRadialGradient);
  }
  __getRadialGradient() {
    var t = this.fillRadialGradientColorStops();
    if (t) {
      for (var i = Kk(), n = this.fillRadialGradientStartPoint(), g = this.fillRadialGradientEndPoint(), r = i.createRadialGradient(n.x, n.y, this.fillRadialGradientStartRadius(), g.x, g.y, this.fillRadialGradientEndRadius()), o = 0; o < t.length; o += 2)
        r.addColorStop(t[o], t[o + 1]);
      return r;
    }
  }
  getShadowRGBA() {
    return this._getCache(n8, this._getShadowRGBA);
  }
  _getShadowRGBA() {
    if (this.hasShadow()) {
      var t = he.colorToRGBA(this.shadowColor());
      if (t)
        return "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a * (this.shadowOpacity() || 1) + ")";
    }
  }
  hasFill() {
    return this._calculate("hasFill", [
      "fillEnabled",
      "fill",
      "fillPatternImage",
      "fillLinearGradientColorStops",
      "fillRadialGradientColorStops"
    ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
  }
  hasStroke() {
    return this._calculate("hasStroke", [
      "strokeEnabled",
      "strokeWidth",
      "stroke",
      "strokeLinearGradientColorStops"
    ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
  }
  hasHitStroke() {
    const t = this.hitStrokeWidth();
    return t === "auto" ? this.hasStroke() : this.strokeEnabled() && !!t;
  }
  intersects(t) {
    var i = this.getStage(), n = i.bufferHitCanvas, g;
    return n.getContext().clear(), this.drawHit(n, null, !0), g = n.context.getImageData(Math.round(t.x), Math.round(t.y), 1, 1).data, g[3] > 0;
  }
  destroy() {
    return mt.prototype.destroy.call(this), delete mB[this.colorKey], delete this.colorKey, this;
  }
  _useBufferCanvas(t) {
    var i;
    if (!this.getStage() || !((i = this.attrs.perfectDrawEnabled) !== null && i !== void 0 ? i : !0))
      return !1;
    const g = t || this.hasFill(), r = this.hasStroke(), o = this.getAbsoluteOpacity() !== 1;
    if (g && r && o)
      return !0;
    const I = this.hasShadow(), s = this.shadowForStrokeEnabled();
    return !!(g && r && I && s);
  }
  setStrokeHitEnabled(t) {
    he.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), t ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
  }
  getStrokeHitEnabled() {
    return this.hitStrokeWidth() !== 0;
  }
  getSelfRect() {
    var t = this.size();
    return {
      x: this._centroid ? -t.width / 2 : 0,
      y: this._centroid ? -t.height / 2 : 0,
      width: t.width,
      height: t.height
    };
  }
  getClientRect(t = {}) {
    const i = t.skipTransform, n = t.relativeTo, g = this.getSelfRect(), o = !t.skipStroke && this.hasStroke() && this.strokeWidth() || 0, I = g.width + o, s = g.height + o, a = !t.skipShadow && this.hasShadow(), d = a ? this.shadowOffsetX() : 0, C = a ? this.shadowOffsetY() : 0, u = I + Math.abs(d), A = s + Math.abs(C), m = a && this.shadowBlur() || 0, h = u + m * 2, B = A + m * 2, f = {
      width: h,
      height: B,
      x: -(o / 2 + m) + Math.min(d, 0) + g.x,
      y: -(o / 2 + m) + Math.min(C, 0) + g.y
    };
    return i ? f : this._transformedRect(f, n);
  }
  drawScene(t, i) {
    var n = this.getLayer(), g = t || n.getCanvas(), r = g.getContext(), o = this._getCanvasCache(), I = this.getSceneFunc(), s = this.hasShadow(), a, d, C, u = g.isCache, A = i === this;
    if (!this.isVisible() && !A)
      return this;
    if (o) {
      r.save();
      var m = this.getAbsoluteTransform(i).getMatrix();
      return r.transform(m[0], m[1], m[2], m[3], m[4], m[5]), this._drawCachedSceneCanvas(r), r.restore(), this;
    }
    if (!I)
      return this;
    if (r.save(), this._useBufferCanvas() && !u) {
      a = this.getStage(), d = a.bufferCanvas, C = d.getContext(), C.clear(), C.save(), C._applyLineJoin(this);
      var h = this.getAbsoluteTransform(i).getMatrix();
      C.transform(h[0], h[1], h[2], h[3], h[4], h[5]), I.call(this, C, this), C.restore();
      var B = d.pixelRatio;
      s && r._applyShadow(this), r._applyOpacity(this), r._applyGlobalCompositeOperation(this), r.drawImage(d._canvas, 0, 0, d.width / B, d.height / B);
    } else {
      if (r._applyLineJoin(this), !A) {
        var h = this.getAbsoluteTransform(i).getMatrix();
        r.transform(h[0], h[1], h[2], h[3], h[4], h[5]), r._applyOpacity(this), r._applyGlobalCompositeOperation(this);
      }
      s && r._applyShadow(this), I.call(this, r, this);
    }
    return r.restore(), this;
  }
  drawHit(t, i, n = !1) {
    if (!this.shouldDrawHit(i, n))
      return this;
    var g = this.getLayer(), r = t || g.hitCanvas, o = r && r.getContext(), I = this.hitFunc() || this.sceneFunc(), s = this._getCanvasCache(), a = s && s.hit;
    if (this.colorKey || he.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), a) {
      o.save();
      var d = this.getAbsoluteTransform(i).getMatrix();
      return o.transform(d[0], d[1], d[2], d[3], d[4], d[5]), this._drawCachedHitCanvas(o), o.restore(), this;
    }
    if (!I)
      return this;
    if (o.save(), o._applyLineJoin(this), !(this === i)) {
      var u = this.getAbsoluteTransform(i).getMatrix();
      o.transform(u[0], u[1], u[2], u[3], u[4], u[5]);
    }
    return I.call(this, o, this), o.restore(), this;
  }
  drawHitFromCache(t = 0) {
    var i = this._getCanvasCache(), n = this._getCachedSceneCanvas(), g = i.hit, r = g.getContext(), o = g.getWidth(), I = g.getHeight(), s, a, d, C, u, A;
    r.clear(), r.drawImage(n._canvas, 0, 0, o, I);
    try {
      for (s = r.getImageData(0, 0, o, I), a = s.data, d = a.length, C = he._hexToRgb(this.colorKey), u = 0; u < d; u += 4)
        A = a[u + 3], A > t ? (a[u] = C.r, a[u + 1] = C.g, a[u + 2] = C.b, a[u + 3] = 255) : a[u + 3] = 0;
      r.putImageData(s, 0, 0);
    } catch (m) {
      he.error("Unable to draw hit graph from cached scene canvas. " + m.message);
    }
    return this;
  }
  hasPointerCapture(t) {
    return M7(t, this);
  }
  setPointerCapture(t) {
    U7(t, this);
  }
  releaseCapture(t) {
    bB(t);
  }
}
ct.prototype._fillFunc = Ltt;
ct.prototype._strokeFunc = Ttt;
ct.prototype._fillFuncHit = Mtt;
ct.prototype._strokeFuncHit = Utt;
ct.prototype._centroid = !1;
ct.prototype.nodeType = "Shape";
rg(ct);
ct.prototype.eventListeners = {};
ct.prototype.on.call(ct.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", Ptt);
ct.prototype.on.call(ct.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", ztt);
ct.prototype.on.call(ct.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", Ott);
ct.prototype.on.call(ct.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", Qtt);
ct.prototype.on.call(ct.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", jtt);
Ie.addGetterSetter(ct, "stroke", void 0, L7());
Ie.addGetterSetter(ct, "strokeWidth", 2, bt());
Ie.addGetterSetter(ct, "fillAfterStrokeEnabled", !1);
Ie.addGetterSetter(ct, "hitStrokeWidth", "auto", YJ());
Ie.addGetterSetter(ct, "strokeHitEnabled", !0, ws());
Ie.addGetterSetter(ct, "perfectDrawEnabled", !0, ws());
Ie.addGetterSetter(ct, "shadowForStrokeEnabled", !0, ws());
Ie.addGetterSetter(ct, "lineJoin");
Ie.addGetterSetter(ct, "lineCap");
Ie.addGetterSetter(ct, "sceneFunc");
Ie.addGetterSetter(ct, "hitFunc");
Ie.addGetterSetter(ct, "dash");
Ie.addGetterSetter(ct, "dashOffset", 0, bt());
Ie.addGetterSetter(ct, "shadowColor", void 0, bh());
Ie.addGetterSetter(ct, "shadowBlur", 0, bt());
Ie.addGetterSetter(ct, "shadowOpacity", 1, bt());
Ie.addComponentsGetterSetter(ct, "shadowOffset", ["x", "y"]);
Ie.addGetterSetter(ct, "shadowOffsetX", 0, bt());
Ie.addGetterSetter(ct, "shadowOffsetY", 0, bt());
Ie.addGetterSetter(ct, "fillPatternImage");
Ie.addGetterSetter(ct, "fill", void 0, L7());
Ie.addGetterSetter(ct, "fillPatternX", 0, bt());
Ie.addGetterSetter(ct, "fillPatternY", 0, bt());
Ie.addGetterSetter(ct, "fillLinearGradientColorStops");
Ie.addGetterSetter(ct, "strokeLinearGradientColorStops");
Ie.addGetterSetter(ct, "fillRadialGradientStartRadius", 0);
Ie.addGetterSetter(ct, "fillRadialGradientEndRadius", 0);
Ie.addGetterSetter(ct, "fillRadialGradientColorStops");
Ie.addGetterSetter(ct, "fillPatternRepeat", "repeat");
Ie.addGetterSetter(ct, "fillEnabled", !0);
Ie.addGetterSetter(ct, "strokeEnabled", !0);
Ie.addGetterSetter(ct, "shadowEnabled", !0);
Ie.addGetterSetter(ct, "dashEnabled", !0);
Ie.addGetterSetter(ct, "strokeScaleEnabled", !0);
Ie.addGetterSetter(ct, "fillPriority", "color");
Ie.addComponentsGetterSetter(ct, "fillPatternOffset", ["x", "y"]);
Ie.addGetterSetter(ct, "fillPatternOffsetX", 0, bt());
Ie.addGetterSetter(ct, "fillPatternOffsetY", 0, bt());
Ie.addComponentsGetterSetter(ct, "fillPatternScale", ["x", "y"]);
Ie.addGetterSetter(ct, "fillPatternScaleX", 1, bt());
Ie.addGetterSetter(ct, "fillPatternScaleY", 1, bt());
Ie.addComponentsGetterSetter(ct, "fillLinearGradientStartPoint", [
  "x",
  "y"
]);
Ie.addComponentsGetterSetter(ct, "strokeLinearGradientStartPoint", [
  "x",
  "y"
]);
Ie.addGetterSetter(ct, "fillLinearGradientStartPointX", 0);
Ie.addGetterSetter(ct, "strokeLinearGradientStartPointX", 0);
Ie.addGetterSetter(ct, "fillLinearGradientStartPointY", 0);
Ie.addGetterSetter(ct, "strokeLinearGradientStartPointY", 0);
Ie.addComponentsGetterSetter(ct, "fillLinearGradientEndPoint", [
  "x",
  "y"
]);
Ie.addComponentsGetterSetter(ct, "strokeLinearGradientEndPoint", [
  "x",
  "y"
]);
Ie.addGetterSetter(ct, "fillLinearGradientEndPointX", 0);
Ie.addGetterSetter(ct, "strokeLinearGradientEndPointX", 0);
Ie.addGetterSetter(ct, "fillLinearGradientEndPointY", 0);
Ie.addGetterSetter(ct, "strokeLinearGradientEndPointY", 0);
Ie.addComponentsGetterSetter(ct, "fillRadialGradientStartPoint", [
  "x",
  "y"
]);
Ie.addGetterSetter(ct, "fillRadialGradientStartPointX", 0);
Ie.addGetterSetter(ct, "fillRadialGradientStartPointY", 0);
Ie.addComponentsGetterSetter(ct, "fillRadialGradientEndPoint", [
  "x",
  "y"
]);
Ie.addGetterSetter(ct, "fillRadialGradientEndPointX", 0);
Ie.addGetterSetter(ct, "fillRadialGradientEndPointY", 0);
Ie.addGetterSetter(ct, "fillPatternRotation", 0);
Ie.backCompat(ct, {
  dashArray: "dash",
  getDashArray: "getDash",
  setDashArray: "getDash",
  drawFunc: "sceneFunc",
  getDrawFunc: "getSceneFunc",
  setDrawFunc: "setSceneFunc",
  drawHitFunc: "hitFunc",
  getDrawHitFunc: "getHitFunc",
  setDrawHitFunc: "setHitFunc"
});
var _tt = "#", $tt = "beforeDraw", qtt = "draw", I8 = [
  { x: 0, y: 0 },
  { x: -1, y: -1 },
  { x: 1, y: -1 },
  { x: 1, y: 1 },
  { x: -1, y: 1 }
], eit = I8.length;
class iA extends vI {
  constructor(t) {
    super(t), this.canvas = new Zm(), this.hitCanvas = new xJ({
      pixelRatio: 1
    }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
  }
  createPNGStream() {
    return this.canvas._canvas.createPNGStream();
  }
  getCanvas() {
    return this.canvas;
  }
  getNativeCanvasElement() {
    return this.canvas._canvas;
  }
  getHitCanvas() {
    return this.hitCanvas;
  }
  getContext() {
    return this.getCanvas().getContext();
  }
  clear(t) {
    return this.getContext().clear(t), this.getHitCanvas().getContext().clear(t), this;
  }
  setZIndex(t) {
    super.setZIndex(t);
    var i = this.getStage();
    return i && i.content && (i.content.removeChild(this.getNativeCanvasElement()), t < i.children.length - 1 ? i.content.insertBefore(this.getNativeCanvasElement(), i.children[t + 1].getCanvas()._canvas) : i.content.appendChild(this.getNativeCanvasElement())), this;
  }
  moveToTop() {
    mt.prototype.moveToTop.call(this);
    var t = this.getStage();
    return t && t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.appendChild(this.getNativeCanvasElement())), !0;
  }
  moveUp() {
    var t = mt.prototype.moveUp.call(this);
    if (!t)
      return !1;
    var i = this.getStage();
    return !i || !i.content ? !1 : (i.content.removeChild(this.getNativeCanvasElement()), this.index < i.children.length - 1 ? i.content.insertBefore(this.getNativeCanvasElement(), i.children[this.index + 1].getCanvas()._canvas) : i.content.appendChild(this.getNativeCanvasElement()), !0);
  }
  moveDown() {
    if (mt.prototype.moveDown.call(this)) {
      var t = this.getStage();
      if (t) {
        var i = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), i[this.index + 1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  moveToBottom() {
    if (mt.prototype.moveToBottom.call(this)) {
      var t = this.getStage();
      if (t) {
        var i = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), i[1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  getLayer() {
    return this;
  }
  remove() {
    var t = this.getNativeCanvasElement();
    return mt.prototype.remove.call(this), t && t.parentNode && he._isInDocument(t) && t.parentNode.removeChild(t), this;
  }
  getStage() {
    return this.parent;
  }
  setSize({ width: t, height: i }) {
    return this.canvas.setSize(t, i), this.hitCanvas.setSize(t, i), this._setSmoothEnabled(), this;
  }
  _validateAdd(t) {
    var i = t.getType();
    i !== "Group" && i !== "Shape" && he.throw("You may only add groups and shapes to a layer.");
  }
  _toKonvaCanvas(t) {
    return t = t || {}, t.width = t.width || this.getWidth(), t.height = t.height || this.getHeight(), t.x = t.x !== void 0 ? t.x : this.x(), t.y = t.y !== void 0 ? t.y : this.y(), mt.prototype._toKonvaCanvas.call(this, t);
  }
  _checkVisibility() {
    this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
  }
  _setSmoothEnabled() {
    this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
  }
  getWidth() {
    if (this.parent)
      return this.parent.width();
  }
  setWidth() {
    he.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
  }
  getHeight() {
    if (this.parent)
      return this.parent.height();
  }
  setHeight() {
    he.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
  }
  batchDraw() {
    return this._waitingForDraw || (this._waitingForDraw = !0, he.requestAnimFrame(() => {
      this.draw(), this._waitingForDraw = !1;
    })), this;
  }
  getIntersection(t) {
    if (!this.isListening() || !this.isVisible())
      return null;
    for (var i = 1, n = !1; ; ) {
      for (let g = 0; g < eit; g++) {
        const r = I8[g], o = this._getIntersection({
          x: t.x + r.x * i,
          y: t.y + r.y * i
        }), I = o.shape;
        if (I)
          return I;
        if (n = !!o.antialiased, !o.antialiased)
          break;
      }
      if (n)
        i += 1;
      else
        return null;
    }
  }
  _getIntersection(t) {
    const i = this.hitCanvas.pixelRatio, n = this.hitCanvas.context.getImageData(Math.round(t.x * i), Math.round(t.y * i), 1, 1).data, g = n[3];
    if (g === 255) {
      const r = he._rgbToHex(n[0], n[1], n[2]), o = mB[_tt + r];
      return o ? {
        shape: o
      } : {
        antialiased: !0
      };
    } else if (g > 0)
      return {
        antialiased: !0
      };
    return {};
  }
  drawScene(t, i) {
    var n = this.getLayer(), g = t || n && n.getCanvas();
    return this._fire($tt, {
      node: this
    }), this.clearBeforeDraw() && g.getContext().clear(), vI.prototype.drawScene.call(this, g, i), this._fire(qtt, {
      node: this
    }), this;
  }
  drawHit(t, i) {
    var n = this.getLayer(), g = t || n && n.hitCanvas;
    return n && n.clearBeforeDraw() && n.getHitCanvas().getContext().clear(), vI.prototype.drawHit.call(this, g, i), this;
  }
  enableHitGraph() {
    return this.hitGraphEnabled(!0), this;
  }
  disableHitGraph() {
    return this.hitGraphEnabled(!1), this;
  }
  setHitGraphEnabled(t) {
    he.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(t);
  }
  getHitGraphEnabled(t) {
    return he.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
  }
  toggleHitCanvas() {
    if (!(!this.parent || !this.parent.content)) {
      var t = this.parent, i = !!this.hitCanvas._canvas.parentNode;
      i ? t.content.removeChild(this.hitCanvas._canvas) : t.content.appendChild(this.hitCanvas._canvas);
    }
  }
  destroy() {
    return he.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
  }
}
iA.prototype.nodeType = "Layer";
rg(iA);
Ie.addGetterSetter(iA, "imageSmoothingEnabled", !0);
Ie.addGetterSetter(iA, "clearBeforeDraw", !0);
Ie.addGetterSetter(iA, "hitGraphEnabled", !0, ws());
class JJ extends iA {
  constructor(t) {
    super(t), this.listening(!1), he.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
  }
}
JJ.prototype.nodeType = "FastLayer";
rg(JJ);
class Km extends vI {
  _validateAdd(t) {
    var i = t.getType();
    i !== "Group" && i !== "Shape" && he.throw("You may only add groups and shapes to groups.");
  }
}
Km.prototype.nodeType = "Group";
rg(Km);
var Ek = function() {
  return Bm.performance && Bm.performance.now ? function() {
    return Bm.performance.now();
  } : function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}();
class dl {
  constructor(t, i) {
    this.id = dl.animIdCounter++, this.frame = {
      time: 0,
      timeDiff: 0,
      lastTime: Ek(),
      frameRate: 0
    }, this.func = t, this.setLayers(i);
  }
  setLayers(t) {
    var i = [];
    return t ? t.length > 0 ? i = t : i = [t] : i = [], this.layers = i, this;
  }
  getLayers() {
    return this.layers;
  }
  addLayer(t) {
    var i = this.layers, n = i.length, g;
    for (g = 0; g < n; g++)
      if (i[g]._id === t._id)
        return !1;
    return this.layers.push(t), !0;
  }
  isRunning() {
    var t = dl, i = t.animations, n = i.length, g;
    for (g = 0; g < n; g++)
      if (i[g].id === this.id)
        return !0;
    return !1;
  }
  start() {
    return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = Ek(), dl._addAnimation(this), this;
  }
  stop() {
    return dl._removeAnimation(this), this;
  }
  _updateFrameObject(t) {
    this.frame.timeDiff = t - this.frame.lastTime, this.frame.lastTime = t, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
  }
  static _addAnimation(t) {
    this.animations.push(t), this._handleAnimation();
  }
  static _removeAnimation(t) {
    var i = t.id, n = this.animations, g = n.length, r;
    for (r = 0; r < g; r++)
      if (n[r].id === i) {
        this.animations.splice(r, 1);
        break;
      }
  }
  static _runFrames() {
    var t = {}, i = this.animations, n, g, r, o, I, s, a, d, C;
    for (o = 0; o < i.length; o++)
      if (n = i[o], g = n.layers, r = n.func, n._updateFrameObject(Ek()), s = g.length, r ? C = r.call(n, n.frame) !== !1 : C = !0, !!C)
        for (I = 0; I < s; I++)
          a = g[I], a._id !== void 0 && (t[a._id] = a);
    for (d in t)
      t.hasOwnProperty(d) && t[d].batchDraw();
  }
  static _animationLoop() {
    var t = dl;
    t.animations.length ? (t._runFrames(), he.requestAnimFrame(t._animationLoop)) : t.animRunning = !1;
  }
  static _handleAnimation() {
    this.animRunning || (this.animRunning = !0, he.requestAnimFrame(this._animationLoop));
  }
}
dl.animations = [];
dl.animIdCounter = 0;
dl.animRunning = !1;
var tit = {
  node: 1,
  duration: 1,
  easing: 1,
  onFinish: 1,
  yoyo: 1
}, iit = 1, uT = 2, AT = 3, nit = 0, bT = ["fill", "stroke", "shadowColor"];
class git {
  constructor(t, i, n, g, r, o, I) {
    this.prop = t, this.propFunc = i, this.begin = g, this._pos = g, this.duration = o, this._change = 0, this.prevPos = 0, this.yoyo = I, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = n, this._change = r - this.begin, this.pause();
  }
  fire(t) {
    var i = this[t];
    i && i();
  }
  setTime(t) {
    t > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : t < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = t, this.update());
  }
  getTime() {
    return this._time;
  }
  setPosition(t) {
    this.prevPos = this._pos, this.propFunc(t), this._pos = t;
  }
  getPosition(t) {
    return t === void 0 && (t = this._time), this.func(t, this.begin, this._change, this.duration);
  }
  play() {
    this.state = uT, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
  }
  reverse() {
    this.state = AT, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
  }
  seek(t) {
    this.pause(), this._time = t, this.update(), this.fire("onSeek");
  }
  reset() {
    this.pause(), this._time = 0, this.update(), this.fire("onReset");
  }
  finish() {
    this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
  }
  update() {
    this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
  }
  onEnterFrame() {
    var t = this.getTimer() - this._startTime;
    this.state === uT ? this.setTime(t) : this.state === AT && this.setTime(this.duration - t);
  }
  pause() {
    this.state = iit, this.fire("onPause");
  }
  getTimer() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
}
class Zg {
  constructor(t) {
    var i = this, n = t.node, g = n._id, r, o = t.easing || hB.Linear, I = !!t.yoyo, s;
    typeof t.duration > "u" ? r = 0.3 : t.duration === 0 ? r = 1e-3 : r = t.duration, this.node = n, this._id = nit++;
    var a = n.getLayer() || (n instanceof Mt.Stage ? n.getLayers() : null);
    a || he.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new dl(function() {
      i.tween.onEnterFrame();
    }, a), this.tween = new git(s, function(d) {
      i._tweenFunc(d);
    }, o, 0, 1, r * 1e3, I), this._addListeners(), Zg.attrs[g] || (Zg.attrs[g] = {}), Zg.attrs[g][this._id] || (Zg.attrs[g][this._id] = {}), Zg.tweens[g] || (Zg.tweens[g] = {});
    for (s in t)
      tit[s] === void 0 && this._addAttr(s, t[s]);
    this.reset(), this.onFinish = t.onFinish, this.onReset = t.onReset, this.onUpdate = t.onUpdate;
  }
  _addAttr(t, i) {
    var n = this.node, g = n._id, r, o, I, s, a, d, C, u;
    if (I = Zg.tweens[g][t], I && delete Zg.attrs[g][I][t], r = n.getAttr(t), he._isArray(i))
      if (o = [], a = Math.max(i.length, r.length), t === "points" && i.length !== r.length && (i.length > r.length ? (C = r, r = he._prepareArrayForTween(r, i, n.closed())) : (d = i, i = he._prepareArrayForTween(i, r, n.closed()))), t.indexOf("fill") === 0)
        for (s = 0; s < a; s++)
          if (s % 2 === 0)
            o.push(i[s] - r[s]);
          else {
            var A = he.colorToRGBA(r[s]);
            u = he.colorToRGBA(i[s]), r[s] = A, o.push({
              r: u.r - A.r,
              g: u.g - A.g,
              b: u.b - A.b,
              a: u.a - A.a
            });
          }
      else
        for (s = 0; s < a; s++)
          o.push(i[s] - r[s]);
    else
      bT.indexOf(t) !== -1 ? (r = he.colorToRGBA(r), u = he.colorToRGBA(i), o = {
        r: u.r - r.r,
        g: u.g - r.g,
        b: u.b - r.b,
        a: u.a - r.a
      }) : o = i - r;
    Zg.attrs[g][this._id][t] = {
      start: r,
      diff: o,
      end: i,
      trueEnd: d,
      trueStart: C
    }, Zg.tweens[g][t] = this._id;
  }
  _tweenFunc(t) {
    var i = this.node, n = Zg.attrs[i._id][this._id], g, r, o, I, s, a, d, C;
    for (g in n) {
      if (r = n[g], o = r.start, I = r.diff, C = r.end, he._isArray(o))
        if (s = [], d = Math.max(o.length, C.length), g.indexOf("fill") === 0)
          for (a = 0; a < d; a++)
            a % 2 === 0 ? s.push((o[a] || 0) + I[a] * t) : s.push("rgba(" + Math.round(o[a].r + I[a].r * t) + "," + Math.round(o[a].g + I[a].g * t) + "," + Math.round(o[a].b + I[a].b * t) + "," + (o[a].a + I[a].a * t) + ")");
        else
          for (a = 0; a < d; a++)
            s.push((o[a] || 0) + I[a] * t);
      else
        bT.indexOf(g) !== -1 ? s = "rgba(" + Math.round(o.r + I.r * t) + "," + Math.round(o.g + I.g * t) + "," + Math.round(o.b + I.b * t) + "," + (o.a + I.a * t) + ")" : s = o + I * t;
      i.setAttr(g, s);
    }
  }
  _addListeners() {
    this.tween.onPlay = () => {
      this.anim.start();
    }, this.tween.onReverse = () => {
      this.anim.start();
    }, this.tween.onPause = () => {
      this.anim.stop();
    }, this.tween.onFinish = () => {
      var t = this.node, i = Zg.attrs[t._id][this._id];
      i.points && i.points.trueEnd && t.setAttr("points", i.points.trueEnd), this.onFinish && this.onFinish.call(this);
    }, this.tween.onReset = () => {
      var t = this.node, i = Zg.attrs[t._id][this._id];
      i.points && i.points.trueStart && t.points(i.points.trueStart), this.onReset && this.onReset();
    }, this.tween.onUpdate = () => {
      this.onUpdate && this.onUpdate.call(this);
    };
  }
  play() {
    return this.tween.play(), this;
  }
  reverse() {
    return this.tween.reverse(), this;
  }
  reset() {
    return this.tween.reset(), this;
  }
  seek(t) {
    return this.tween.seek(t * 1e3), this;
  }
  pause() {
    return this.tween.pause(), this;
  }
  finish() {
    return this.tween.finish(), this;
  }
  destroy() {
    var t = this.node._id, i = this._id, n = Zg.tweens[t], g;
    this.pause();
    for (g in n)
      delete Zg.tweens[t][g];
    delete Zg.attrs[t][i];
  }
}
Zg.attrs = {};
Zg.tweens = {};
mt.prototype.to = function(e) {
  var t = e.onFinish;
  e.node = this, e.onFinish = function() {
    this.destroy(), t && t();
  };
  var i = new Zg(e);
  i.play();
};
const hB = {
  BackEaseIn(e, t, i, n) {
    var g = 1.70158;
    return i * (e /= n) * e * ((g + 1) * e - g) + t;
  },
  BackEaseOut(e, t, i, n) {
    var g = 1.70158;
    return i * ((e = e / n - 1) * e * ((g + 1) * e + g) + 1) + t;
  },
  BackEaseInOut(e, t, i, n) {
    var g = 1.70158;
    return (e /= n / 2) < 1 ? i / 2 * (e * e * (((g *= 1.525) + 1) * e - g)) + t : i / 2 * ((e -= 2) * e * (((g *= 1.525) + 1) * e + g) + 2) + t;
  },
  ElasticEaseIn(e, t, i, n, g, r) {
    var o = 0;
    return e === 0 ? t : (e /= n) === 1 ? t + i : (r || (r = n * 0.3), !g || g < Math.abs(i) ? (g = i, o = r / 4) : o = r / (2 * Math.PI) * Math.asin(i / g), -(g * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - o) * (2 * Math.PI) / r)) + t);
  },
  ElasticEaseOut(e, t, i, n, g, r) {
    var o = 0;
    return e === 0 ? t : (e /= n) === 1 ? t + i : (r || (r = n * 0.3), !g || g < Math.abs(i) ? (g = i, o = r / 4) : o = r / (2 * Math.PI) * Math.asin(i / g), g * Math.pow(2, -10 * e) * Math.sin((e * n - o) * (2 * Math.PI) / r) + i + t);
  },
  ElasticEaseInOut(e, t, i, n, g, r) {
    var o = 0;
    return e === 0 ? t : (e /= n / 2) === 2 ? t + i : (r || (r = n * (0.3 * 1.5)), !g || g < Math.abs(i) ? (g = i, o = r / 4) : o = r / (2 * Math.PI) * Math.asin(i / g), e < 1 ? -0.5 * (g * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - o) * (2 * Math.PI) / r)) + t : g * Math.pow(2, -10 * (e -= 1)) * Math.sin((e * n - o) * (2 * Math.PI) / r) * 0.5 + i + t);
  },
  BounceEaseOut(e, t, i, n) {
    return (e /= n) < 1 / 2.75 ? i * (7.5625 * e * e) + t : e < 2 / 2.75 ? i * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + t : e < 2.5 / 2.75 ? i * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + t : i * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + t;
  },
  BounceEaseIn(e, t, i, n) {
    return i - hB.BounceEaseOut(n - e, 0, i, n) + t;
  },
  BounceEaseInOut(e, t, i, n) {
    return e < n / 2 ? hB.BounceEaseIn(e * 2, 0, i, n) * 0.5 + t : hB.BounceEaseOut(e * 2 - n, 0, i, n) * 0.5 + i * 0.5 + t;
  },
  EaseIn(e, t, i, n) {
    return i * (e /= n) * e + t;
  },
  EaseOut(e, t, i, n) {
    return -i * (e /= n) * (e - 2) + t;
  },
  EaseInOut(e, t, i, n) {
    return (e /= n / 2) < 1 ? i / 2 * e * e + t : -i / 2 * (--e * (e - 2) - 1) + t;
  },
  StrongEaseIn(e, t, i, n) {
    return i * (e /= n) * e * e * e * e + t;
  },
  StrongEaseOut(e, t, i, n) {
    return i * ((e = e / n - 1) * e * e * e * e + 1) + t;
  },
  StrongEaseInOut(e, t, i, n) {
    return (e /= n / 2) < 1 ? i / 2 * e * e * e * e * e + t : i / 2 * ((e -= 2) * e * e * e * e + 2) + t;
  },
  Linear(e, t, i, n) {
    return i * e / n + t;
  }
}, mT = he._assign(Mt, {
  Util: he,
  Transform: ZI,
  Node: mt,
  Container: vI,
  Stage: t2,
  stages: CS,
  Layer: iA,
  FastLayer: JJ,
  Group: Km,
  DD: Qi,
  Shape: ct,
  shapes: mB,
  Animation: dl,
  Tween: Zg,
  Easings: hB,
  Context: q1,
  Canvas: e2
});
class Vc extends ct {
  _sceneFunc(t) {
    var i = Mt.getAngle(this.angle()), n = this.clockwise();
    t.beginPath(), t.arc(0, 0, this.outerRadius(), 0, i, n), t.arc(0, 0, this.innerRadius(), i, 0, !n), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
  getSelfRect() {
    const t = this.innerRadius(), i = this.outerRadius(), n = this.clockwise(), g = Mt.getAngle(n ? 360 - this.angle() : this.angle()), r = Math.cos(Math.min(g, Math.PI)), o = 1, I = Math.sin(Math.min(Math.max(Math.PI, g), 3 * Math.PI / 2)), s = Math.sin(Math.min(g, Math.PI / 2)), a = r * (r > 0 ? t : i), d = o * i, C = I * (I > 0 ? t : i), u = s * (s > 0 ? i : t);
    return {
      x: a,
      y: n ? -1 * u : C,
      width: d - a,
      height: u - C
    };
  }
}
Vc.prototype._centroid = !0;
Vc.prototype.className = "Arc";
Vc.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
rg(Vc);
Ie.addGetterSetter(Vc, "innerRadius", 0, bt());
Ie.addGetterSetter(Vc, "outerRadius", 0, bt());
Ie.addGetterSetter(Vc, "angle", 0, bt());
Ie.addGetterSetter(Vc, "clockwise", !1, ws());
function gx(e, t, i, n, g, r, o) {
  var I = Math.sqrt(Math.pow(i - e, 2) + Math.pow(n - t, 2)), s = Math.sqrt(Math.pow(g - i, 2) + Math.pow(r - n, 2)), a = o * I / (I + s), d = o * s / (I + s), C = i - a * (g - e), u = n - a * (r - t), A = i + d * (g - e), m = n + d * (r - t);
  return [C, u, A, m];
}
function hT(e, t) {
  var i = e.length, n = [], g, r;
  for (g = 2; g < i - 2; g += 2)
    r = gx(e[g - 2], e[g - 1], e[g], e[g + 1], e[g + 2], e[g + 3], t), !isNaN(r[0]) && (n.push(r[0]), n.push(r[1]), n.push(e[g]), n.push(e[g + 1]), n.push(r[2]), n.push(r[3]));
  return n;
}
class wc extends ct {
  constructor(t) {
    super(t), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
      this._clearCache("tensionPoints");
    });
  }
  _sceneFunc(t) {
    var i = this.points(), n = i.length, g = this.tension(), r = this.closed(), o = this.bezier(), I, s, a;
    if (n) {
      if (t.beginPath(), t.moveTo(i[0], i[1]), g !== 0 && n > 4) {
        for (I = this.getTensionPoints(), s = I.length, a = r ? 0 : 4, r || t.quadraticCurveTo(I[0], I[1], I[2], I[3]); a < s - 2; )
          t.bezierCurveTo(I[a++], I[a++], I[a++], I[a++], I[a++], I[a++]);
        r || t.quadraticCurveTo(I[s - 2], I[s - 1], i[n - 2], i[n - 1]);
      } else if (o)
        for (a = 2; a < n; )
          t.bezierCurveTo(i[a++], i[a++], i[a++], i[a++], i[a++], i[a++]);
      else
        for (a = 2; a < n; a += 2)
          t.lineTo(i[a], i[a + 1]);
      r ? (t.closePath(), t.fillStrokeShape(this)) : t.strokeShape(this);
    }
  }
  getTensionPoints() {
    return this._getCache("tensionPoints", this._getTensionPoints);
  }
  _getTensionPoints() {
    return this.closed() ? this._getTensionPointsClosed() : hT(this.points(), this.tension());
  }
  _getTensionPointsClosed() {
    var t = this.points(), i = t.length, n = this.tension(), g = gx(t[i - 2], t[i - 1], t[0], t[1], t[2], t[3], n), r = gx(t[i - 4], t[i - 3], t[i - 2], t[i - 1], t[0], t[1], n), o = hT(t, n), I = [g[2], g[3]].concat(o).concat([
      r[0],
      r[1],
      t[i - 2],
      t[i - 1],
      r[2],
      r[3],
      g[0],
      g[1],
      t[0],
      t[1]
    ]);
    return I;
  }
  getWidth() {
    return this.getSelfRect().width;
  }
  getHeight() {
    return this.getSelfRect().height;
  }
  getSelfRect() {
    var t = this.points();
    if (t.length < 4)
      return {
        x: t[0] || 0,
        y: t[1] || 0,
        width: 0,
        height: 0
      };
    this.tension() !== 0 ? t = [
      t[0],
      t[1],
      ...this._getTensionPoints(),
      t[t.length - 2],
      t[t.length - 1]
    ] : t = this.points();
    for (var i = t[0], n = t[0], g = t[1], r = t[1], o, I, s = 0; s < t.length / 2; s++)
      o = t[s * 2], I = t[s * 2 + 1], i = Math.min(i, o), n = Math.max(n, o), g = Math.min(g, I), r = Math.max(r, I);
    return {
      x: i,
      y: g,
      width: n - i,
      height: r - g
    };
  }
}
wc.prototype.className = "Line";
wc.prototype._attrsAffectingSize = ["points", "bezier", "tension"];
rg(wc);
Ie.addGetterSetter(wc, "closed", !1);
Ie.addGetterSetter(wc, "bezier", !1);
Ie.addGetterSetter(wc, "tension", 0, bt());
Ie.addGetterSetter(wc, "points", [], utt());
class wn extends ct {
  constructor(t) {
    super(t), this.dataArray = [], this.pathLength = 0, this.dataArray = wn.parsePathData(this.data()), this.pathLength = 0;
    for (var i = 0; i < this.dataArray.length; ++i)
      this.pathLength += this.dataArray[i].pathLength;
    this.on("dataChange.konva", function() {
      this.dataArray = wn.parsePathData(this.data()), this.pathLength = 0;
      for (var n = 0; n < this.dataArray.length; ++n)
        this.pathLength += this.dataArray[n].pathLength;
    });
  }
  _sceneFunc(t) {
    var i = this.dataArray;
    t.beginPath();
    for (var n = !1, g = 0; g < i.length; g++) {
      var r = i[g].command, o = i[g].points;
      switch (r) {
        case "L":
          t.lineTo(o[0], o[1]);
          break;
        case "M":
          t.moveTo(o[0], o[1]);
          break;
        case "C":
          t.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5]);
          break;
        case "Q":
          t.quadraticCurveTo(o[0], o[1], o[2], o[3]);
          break;
        case "A":
          var I = o[0], s = o[1], a = o[2], d = o[3], C = o[4], u = o[5], A = o[6], m = o[7], h = a > d ? a : d, B = a > d ? 1 : a / d, f = a > d ? d / a : 1;
          t.translate(I, s), t.rotate(A), t.scale(B, f), t.arc(0, 0, h, C, C + u, 1 - m), t.scale(1 / B, 1 / f), t.rotate(-A), t.translate(-I, -s);
          break;
        case "z":
          n = !0, t.closePath();
          break;
      }
    }
    !n && !this.hasFill() ? t.strokeShape(this) : t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = [];
    this.dataArray.forEach(function(a) {
      if (a.command === "A") {
        var d = a.points[4], C = a.points[5], u = a.points[4] + C, A = Math.PI / 180;
        if (Math.abs(d - u) < A && (A = Math.abs(d - u)), C < 0)
          for (let m = d - A; m > u; m -= A) {
            const h = wn.getPointOnEllipticalArc(a.points[0], a.points[1], a.points[2], a.points[3], m, 0);
            t.push(h.x, h.y);
          }
        else
          for (let m = d + A; m < u; m += A) {
            const h = wn.getPointOnEllipticalArc(a.points[0], a.points[1], a.points[2], a.points[3], m, 0);
            t.push(h.x, h.y);
          }
      } else if (a.command === "C")
        for (let m = 0; m <= 1; m += 0.01) {
          const h = wn.getPointOnCubicBezier(m, a.start.x, a.start.y, a.points[0], a.points[1], a.points[2], a.points[3], a.points[4], a.points[5]);
          t.push(h.x, h.y);
        }
      else
        t = t.concat(a.points);
    });
    for (var i = t[0], n = t[0], g = t[1], r = t[1], o, I, s = 0; s < t.length / 2; s++)
      o = t[s * 2], I = t[s * 2 + 1], isNaN(o) || (i = Math.min(i, o), n = Math.max(n, o)), isNaN(I) || (g = Math.min(g, I), r = Math.max(r, I));
    return {
      x: i,
      y: g,
      width: n - i,
      height: r - g
    };
  }
  getLength() {
    return this.pathLength;
  }
  getPointAtLength(t) {
    var i, n = 0, g = this.dataArray.length;
    if (!g)
      return null;
    for (; n < g && t > this.dataArray[n].pathLength; )
      t -= this.dataArray[n].pathLength, ++n;
    if (n === g)
      return i = this.dataArray[n - 1].points.slice(-2), {
        x: i[0],
        y: i[1]
      };
    if (t < 0.01)
      return i = this.dataArray[n].points.slice(0, 2), {
        x: i[0],
        y: i[1]
      };
    var r = this.dataArray[n], o = r.points;
    switch (r.command) {
      case "L":
        return wn.getPointOnLine(t, r.start.x, r.start.y, o[0], o[1]);
      case "C":
        return wn.getPointOnCubicBezier(t / r.pathLength, r.start.x, r.start.y, o[0], o[1], o[2], o[3], o[4], o[5]);
      case "Q":
        return wn.getPointOnQuadraticBezier(t / r.pathLength, r.start.x, r.start.y, o[0], o[1], o[2], o[3]);
      case "A":
        var I = o[0], s = o[1], a = o[2], d = o[3], C = o[4], u = o[5], A = o[6];
        return C += u * t / r.pathLength, wn.getPointOnEllipticalArc(I, s, a, d, C, A);
    }
    return null;
  }
  static getLineLength(t, i, n, g) {
    return Math.sqrt((n - t) * (n - t) + (g - i) * (g - i));
  }
  static getPointOnLine(t, i, n, g, r, o, I) {
    o === void 0 && (o = i), I === void 0 && (I = n);
    var s = (r - n) / (g - i + 1e-8), a = Math.sqrt(t * t / (1 + s * s));
    g < i && (a *= -1);
    var d = s * a, C;
    if (g === i)
      C = {
        x: o,
        y: I + d
      };
    else if ((I - n) / (o - i + 1e-8) === s)
      C = {
        x: o + a,
        y: I + d
      };
    else {
      var u, A, m = this.getLineLength(i, n, g, r), h = (o - i) * (g - i) + (I - n) * (r - n);
      h = h / (m * m), u = i + h * (g - i), A = n + h * (r - n);
      var B = this.getLineLength(o, I, u, A), f = Math.sqrt(t * t - B * B);
      a = Math.sqrt(f * f / (1 + s * s)), g < i && (a *= -1), d = s * a, C = {
        x: u + a,
        y: A + d
      };
    }
    return C;
  }
  static getPointOnCubicBezier(t, i, n, g, r, o, I, s, a) {
    function d(B) {
      return B * B * B;
    }
    function C(B) {
      return 3 * B * B * (1 - B);
    }
    function u(B) {
      return 3 * B * (1 - B) * (1 - B);
    }
    function A(B) {
      return (1 - B) * (1 - B) * (1 - B);
    }
    var m = s * d(t) + o * C(t) + g * u(t) + i * A(t), h = a * d(t) + I * C(t) + r * u(t) + n * A(t);
    return {
      x: m,
      y: h
    };
  }
  static getPointOnQuadraticBezier(t, i, n, g, r, o, I) {
    function s(A) {
      return A * A;
    }
    function a(A) {
      return 2 * A * (1 - A);
    }
    function d(A) {
      return (1 - A) * (1 - A);
    }
    var C = o * s(t) + g * a(t) + i * d(t), u = I * s(t) + r * a(t) + n * d(t);
    return {
      x: C,
      y: u
    };
  }
  static getPointOnEllipticalArc(t, i, n, g, r, o) {
    var I = Math.cos(o), s = Math.sin(o), a = {
      x: n * Math.cos(r),
      y: g * Math.sin(r)
    };
    return {
      x: t + (a.x * I - a.y * s),
      y: i + (a.x * s + a.y * I)
    };
  }
  static parsePathData(t) {
    if (!t)
      return [];
    var i = t, n = [
      "m",
      "M",
      "l",
      "L",
      "v",
      "V",
      "h",
      "H",
      "z",
      "Z",
      "c",
      "C",
      "q",
      "Q",
      "t",
      "T",
      "s",
      "S",
      "a",
      "A"
    ];
    i = i.replace(new RegExp(" ", "g"), ",");
    for (var g = 0; g < n.length; g++)
      i = i.replace(new RegExp(n[g], "g"), "|" + n[g]);
    var r = i.split("|"), o = [], I = [], s = 0, a = 0, d = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi, C;
    for (g = 1; g < r.length; g++) {
      var u = r[g], A = u.charAt(0);
      for (u = u.slice(1), I.length = 0; C = d.exec(u); )
        I.push(C[0]);
      for (var m = [], h = 0, B = I.length; h < B; h++) {
        if (I[h] === "00") {
          m.push(0, 0);
          continue;
        }
        var f = parseFloat(I[h]);
        isNaN(f) ? m.push(0) : m.push(f);
      }
      for (; m.length > 0 && !isNaN(m[0]); ) {
        var G = null, y = [], W = s, V = a, w, v, H, x, N, M, $, q, E, L;
        switch (A) {
          case "l":
            s += m.shift(), a += m.shift(), G = "L", y.push(s, a);
            break;
          case "L":
            s = m.shift(), a = m.shift(), y.push(s, a);
            break;
          case "m":
            var P = m.shift(), Q = m.shift();
            if (s += P, a += Q, G = "M", o.length > 2 && o[o.length - 1].command === "z") {
              for (var te = o.length - 2; te >= 0; te--)
                if (o[te].command === "M") {
                  s = o[te].points[0] + P, a = o[te].points[1] + Q;
                  break;
                }
            }
            y.push(s, a), A = "l";
            break;
          case "M":
            s = m.shift(), a = m.shift(), G = "M", y.push(s, a), A = "L";
            break;
          case "h":
            s += m.shift(), G = "L", y.push(s, a);
            break;
          case "H":
            s = m.shift(), G = "L", y.push(s, a);
            break;
          case "v":
            a += m.shift(), G = "L", y.push(s, a);
            break;
          case "V":
            a = m.shift(), G = "L", y.push(s, a);
            break;
          case "C":
            y.push(m.shift(), m.shift(), m.shift(), m.shift()), s = m.shift(), a = m.shift(), y.push(s, a);
            break;
          case "c":
            y.push(s + m.shift(), a + m.shift(), s + m.shift(), a + m.shift()), s += m.shift(), a += m.shift(), G = "C", y.push(s, a);
            break;
          case "S":
            v = s, H = a, w = o[o.length - 1], w.command === "C" && (v = s + (s - w.points[2]), H = a + (a - w.points[3])), y.push(v, H, m.shift(), m.shift()), s = m.shift(), a = m.shift(), G = "C", y.push(s, a);
            break;
          case "s":
            v = s, H = a, w = o[o.length - 1], w.command === "C" && (v = s + (s - w.points[2]), H = a + (a - w.points[3])), y.push(v, H, s + m.shift(), a + m.shift()), s += m.shift(), a += m.shift(), G = "C", y.push(s, a);
            break;
          case "Q":
            y.push(m.shift(), m.shift()), s = m.shift(), a = m.shift(), y.push(s, a);
            break;
          case "q":
            y.push(s + m.shift(), a + m.shift()), s += m.shift(), a += m.shift(), G = "Q", y.push(s, a);
            break;
          case "T":
            v = s, H = a, w = o[o.length - 1], w.command === "Q" && (v = s + (s - w.points[0]), H = a + (a - w.points[1])), s = m.shift(), a = m.shift(), G = "Q", y.push(v, H, s, a);
            break;
          case "t":
            v = s, H = a, w = o[o.length - 1], w.command === "Q" && (v = s + (s - w.points[0]), H = a + (a - w.points[1])), s += m.shift(), a += m.shift(), G = "Q", y.push(v, H, s, a);
            break;
          case "A":
            x = m.shift(), N = m.shift(), M = m.shift(), $ = m.shift(), q = m.shift(), E = s, L = a, s = m.shift(), a = m.shift(), G = "A", y = this.convertEndpointToCenterParameterization(E, L, s, a, $, q, x, N, M);
            break;
          case "a":
            x = m.shift(), N = m.shift(), M = m.shift(), $ = m.shift(), q = m.shift(), E = s, L = a, s += m.shift(), a += m.shift(), G = "A", y = this.convertEndpointToCenterParameterization(E, L, s, a, $, q, x, N, M);
            break;
        }
        o.push({
          command: G || A,
          points: y,
          start: {
            x: W,
            y: V
          },
          pathLength: this.calcLength(W, V, G || A, y)
        });
      }
      (A === "z" || A === "Z") && o.push({
        command: "z",
        points: [],
        start: void 0,
        pathLength: 0
      });
    }
    return o;
  }
  static calcLength(t, i, n, g) {
    var r, o, I, s, a = wn;
    switch (n) {
      case "L":
        return a.getLineLength(t, i, g[0], g[1]);
      case "C":
        for (r = 0, o = a.getPointOnCubicBezier(0, t, i, g[0], g[1], g[2], g[3], g[4], g[5]), s = 0.01; s <= 1; s += 0.01)
          I = a.getPointOnCubicBezier(s, t, i, g[0], g[1], g[2], g[3], g[4], g[5]), r += a.getLineLength(o.x, o.y, I.x, I.y), o = I;
        return r;
      case "Q":
        for (r = 0, o = a.getPointOnQuadraticBezier(0, t, i, g[0], g[1], g[2], g[3]), s = 0.01; s <= 1; s += 0.01)
          I = a.getPointOnQuadraticBezier(s, t, i, g[0], g[1], g[2], g[3]), r += a.getLineLength(o.x, o.y, I.x, I.y), o = I;
        return r;
      case "A":
        r = 0;
        var d = g[4], C = g[5], u = g[4] + C, A = Math.PI / 180;
        if (Math.abs(d - u) < A && (A = Math.abs(d - u)), o = a.getPointOnEllipticalArc(g[0], g[1], g[2], g[3], d, 0), C < 0)
          for (s = d - A; s > u; s -= A)
            I = a.getPointOnEllipticalArc(g[0], g[1], g[2], g[3], s, 0), r += a.getLineLength(o.x, o.y, I.x, I.y), o = I;
        else
          for (s = d + A; s < u; s += A)
            I = a.getPointOnEllipticalArc(g[0], g[1], g[2], g[3], s, 0), r += a.getLineLength(o.x, o.y, I.x, I.y), o = I;
        return I = a.getPointOnEllipticalArc(g[0], g[1], g[2], g[3], u, 0), r += a.getLineLength(o.x, o.y, I.x, I.y), r;
    }
    return 0;
  }
  static convertEndpointToCenterParameterization(t, i, n, g, r, o, I, s, a) {
    var d = a * (Math.PI / 180), C = Math.cos(d) * (t - n) / 2 + Math.sin(d) * (i - g) / 2, u = -1 * Math.sin(d) * (t - n) / 2 + Math.cos(d) * (i - g) / 2, A = C * C / (I * I) + u * u / (s * s);
    A > 1 && (I *= Math.sqrt(A), s *= Math.sqrt(A));
    var m = Math.sqrt((I * I * (s * s) - I * I * (u * u) - s * s * (C * C)) / (I * I * (u * u) + s * s * (C * C)));
    r === o && (m *= -1), isNaN(m) && (m = 0);
    var h = m * I * u / s, B = m * -s * C / I, f = (t + n) / 2 + Math.cos(d) * h - Math.sin(d) * B, G = (i + g) / 2 + Math.sin(d) * h + Math.cos(d) * B, y = function(N) {
      return Math.sqrt(N[0] * N[0] + N[1] * N[1]);
    }, W = function(N, M) {
      return (N[0] * M[0] + N[1] * M[1]) / (y(N) * y(M));
    }, V = function(N, M) {
      return (N[0] * M[1] < N[1] * M[0] ? -1 : 1) * Math.acos(W(N, M));
    }, w = V([1, 0], [(C - h) / I, (u - B) / s]), v = [(C - h) / I, (u - B) / s], H = [(-1 * C - h) / I, (-1 * u - B) / s], x = V(v, H);
    return W(v, H) <= -1 && (x = Math.PI), W(v, H) >= 1 && (x = 0), o === 0 && x > 0 && (x = x - 2 * Math.PI), o === 1 && x < 0 && (x = x + 2 * Math.PI), [f, G, I, s, w, x, d, o];
  }
}
wn.prototype.className = "Path";
wn.prototype._attrsAffectingSize = ["data"];
rg(wn);
Ie.addGetterSetter(wn, "data");
class nA extends wc {
  _sceneFunc(t) {
    super._sceneFunc(t);
    var i = Math.PI * 2, n = this.points(), g = n, r = this.tension() !== 0 && n.length > 4;
    r && (g = this.getTensionPoints());
    var o = this.pointerLength(), I = n.length, s, a;
    if (r) {
      const u = [
        g[g.length - 4],
        g[g.length - 3],
        g[g.length - 2],
        g[g.length - 1],
        n[I - 2],
        n[I - 1]
      ], A = wn.calcLength(g[g.length - 4], g[g.length - 3], "C", u), m = wn.getPointOnQuadraticBezier(Math.min(1, 1 - o / A), u[0], u[1], u[2], u[3], u[4], u[5]);
      s = n[I - 2] - m.x, a = n[I - 1] - m.y;
    } else
      s = n[I - 2] - n[I - 4], a = n[I - 1] - n[I - 3];
    var d = (Math.atan2(a, s) + i) % i, C = this.pointerWidth();
    this.pointerAtEnding() && (t.save(), t.beginPath(), t.translate(n[I - 2], n[I - 1]), t.rotate(d), t.moveTo(0, 0), t.lineTo(-o, C / 2), t.lineTo(-o, -C / 2), t.closePath(), t.restore(), this.__fillStroke(t)), this.pointerAtBeginning() && (t.save(), t.beginPath(), t.translate(n[0], n[1]), r ? (s = (g[0] + g[2]) / 2 - n[0], a = (g[1] + g[3]) / 2 - n[1]) : (s = n[2] - n[0], a = n[3] - n[1]), t.rotate((Math.atan2(-a, -s) + i) % i), t.moveTo(0, 0), t.lineTo(-o, C / 2), t.lineTo(-o, -C / 2), t.closePath(), t.restore(), this.__fillStroke(t));
  }
  __fillStroke(t) {
    var i = this.dashEnabled();
    i && (this.attrs.dashEnabled = !1, t.setLineDash([])), t.fillStrokeShape(this), i && (this.attrs.dashEnabled = !0);
  }
  getSelfRect() {
    const t = super.getSelfRect(), i = this.pointerWidth() / 2;
    return {
      x: t.x - i,
      y: t.y - i,
      width: t.width + i * 2,
      height: t.height + i * 2
    };
  }
}
nA.prototype.className = "Arrow";
rg(nA);
Ie.addGetterSetter(nA, "pointerLength", 10, bt());
Ie.addGetterSetter(nA, "pointerWidth", 10, bt());
Ie.addGetterSetter(nA, "pointerAtBeginning", !1);
Ie.addGetterSetter(nA, "pointerAtEnding", !0);
class mh extends ct {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
  setHeight(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
}
mh.prototype._centroid = !0;
mh.prototype.className = "Circle";
mh.prototype._attrsAffectingSize = ["radius"];
rg(mh);
Ie.addGetterSetter(mh, "radius", 0, bt());
class rC extends ct {
  _sceneFunc(t) {
    var i = this.radiusX(), n = this.radiusY();
    t.beginPath(), t.save(), i !== n && t.scale(1, n / i), t.arc(0, 0, i, 0, Math.PI * 2, !1), t.restore(), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radiusX() * 2;
  }
  getHeight() {
    return this.radiusY() * 2;
  }
  setWidth(t) {
    this.radiusX(t / 2);
  }
  setHeight(t) {
    this.radiusY(t / 2);
  }
}
rC.prototype.className = "Ellipse";
rC.prototype._centroid = !0;
rC.prototype._attrsAffectingSize = ["radiusX", "radiusY"];
rg(rC);
Ie.addComponentsGetterSetter(rC, "radius", ["x", "y"]);
Ie.addGetterSetter(rC, "radiusX", 0, bt());
Ie.addGetterSetter(rC, "radiusY", 0, bt());
let Sa = class l8 extends ct {
  constructor(t) {
    super(t), this.on("imageChange.konva", () => {
      this._setImageLoad();
    }), this._setImageLoad();
  }
  _setImageLoad() {
    const t = this.image();
    t && t.complete || t && t.readyState === 4 || t && t.addEventListener && t.addEventListener("load", () => {
      this._requestDraw();
    });
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _sceneFunc(t) {
    const i = this.getWidth(), n = this.getHeight(), g = this.cornerRadius(), r = this.attrs.image;
    let o;
    if (r) {
      const I = this.attrs.cropWidth, s = this.attrs.cropHeight;
      I && s ? o = [
        r,
        this.cropX(),
        this.cropY(),
        I,
        s,
        0,
        0,
        i,
        n
      ] : o = [r, 0, 0, i, n];
    }
    (this.hasFill() || this.hasStroke() || g) && (t.beginPath(), g ? he.drawRoundedRectPath(t, i, n, g) : t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this)), r && (g && t.clip(), t.drawImage.apply(t, o));
  }
  _hitFunc(t) {
    var i = this.width(), n = this.height(), g = this.cornerRadius();
    t.beginPath(), g ? he.drawRoundedRectPath(t, i, n, g) : t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    var t, i;
    return (t = this.attrs.width) !== null && t !== void 0 ? t : (i = this.image()) === null || i === void 0 ? void 0 : i.width;
  }
  getHeight() {
    var t, i;
    return (t = this.attrs.height) !== null && t !== void 0 ? t : (i = this.image()) === null || i === void 0 ? void 0 : i.height;
  }
  static fromURL(t, i, n = null) {
    var g = he.createImageElement();
    g.onload = function() {
      var r = new l8({
        image: g
      });
      i(r);
    }, g.onerror = n, g.crossOrigin = "Anonymous", g.src = t;
  }
};
Sa.prototype.className = "Image";
rg(Sa);
Ie.addGetterSetter(Sa, "cornerRadius", 0, FJ(4));
Ie.addGetterSetter(Sa, "image");
Ie.addComponentsGetterSetter(Sa, "crop", ["x", "y", "width", "height"]);
Ie.addGetterSetter(Sa, "cropX", 0, bt());
Ie.addGetterSetter(Sa, "cropY", 0, bt());
Ie.addGetterSetter(Sa, "cropWidth", 0, bt());
Ie.addGetterSetter(Sa, "cropHeight", 0, bt());
var s8 = [
  "fontFamily",
  "fontSize",
  "fontStyle",
  "padding",
  "lineHeight",
  "text",
  "width",
  "height",
  "pointerDirection",
  "pointerWidth",
  "pointerHeight"
], rit = "Change.konva", oit = "none", rx = "up", ox = "right", Ix = "down", lx = "left", Iit = s8.length;
class KJ extends Km {
  constructor(t) {
    super(t), this.on("add.konva", function(i) {
      this._addListeners(i.child), this._sync();
    });
  }
  getText() {
    return this.find("Text")[0];
  }
  getTag() {
    return this.find("Tag")[0];
  }
  _addListeners(t) {
    var i = this, n, g = function() {
      i._sync();
    };
    for (n = 0; n < Iit; n++)
      t.on(s8[n] + rit, g);
  }
  getWidth() {
    return this.getText().width();
  }
  getHeight() {
    return this.getText().height();
  }
  _sync() {
    var t = this.getText(), i = this.getTag(), n, g, r, o, I, s, a;
    if (t && i) {
      switch (n = t.width(), g = t.height(), r = i.pointerDirection(), o = i.pointerWidth(), a = i.pointerHeight(), I = 0, s = 0, r) {
        case rx:
          I = n / 2, s = -1 * a;
          break;
        case ox:
          I = n + o, s = g / 2;
          break;
        case Ix:
          I = n / 2, s = g + a;
          break;
        case lx:
          I = -1 * o, s = g / 2;
          break;
      }
      i.setAttrs({
        x: -1 * I,
        y: -1 * s,
        width: n,
        height: g
      }), t.setAttrs({
        x: -1 * I,
        y: -1 * s
      });
    }
  }
}
KJ.prototype.className = "Label";
rg(KJ);
class gA extends ct {
  _sceneFunc(t) {
    var i = this.width(), n = this.height(), g = this.pointerDirection(), r = this.pointerWidth(), o = this.pointerHeight(), I = this.cornerRadius();
    let s = 0, a = 0, d = 0, C = 0;
    typeof I == "number" ? s = a = d = C = Math.min(I, i / 2, n / 2) : (s = Math.min(I[0] || 0, i / 2, n / 2), a = Math.min(I[1] || 0, i / 2, n / 2), C = Math.min(I[2] || 0, i / 2, n / 2), d = Math.min(I[3] || 0, i / 2, n / 2)), t.beginPath(), t.moveTo(s, 0), g === rx && (t.lineTo((i - r) / 2, 0), t.lineTo(i / 2, -1 * o), t.lineTo((i + r) / 2, 0)), t.lineTo(i - a, 0), t.arc(i - a, a, a, Math.PI * 3 / 2, 0, !1), g === ox && (t.lineTo(i, (n - o) / 2), t.lineTo(i + r, n / 2), t.lineTo(i, (n + o) / 2)), t.lineTo(i, n - C), t.arc(i - C, n - C, C, 0, Math.PI / 2, !1), g === Ix && (t.lineTo((i + r) / 2, n), t.lineTo(i / 2, n + o), t.lineTo((i - r) / 2, n)), t.lineTo(d, n), t.arc(d, n - d, d, Math.PI / 2, Math.PI, !1), g === lx && (t.lineTo(0, (n + o) / 2), t.lineTo(-1 * r, n / 2), t.lineTo(0, (n - o) / 2)), t.lineTo(0, s), t.arc(s, s, s, Math.PI, Math.PI * 3 / 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = 0, i = 0, n = this.pointerWidth(), g = this.pointerHeight(), r = this.pointerDirection(), o = this.width(), I = this.height();
    return r === rx ? (i -= g, I += g) : r === Ix ? I += g : r === lx ? (t -= n * 1.5, o += n) : r === ox && (o += n * 1.5), {
      x: t,
      y: i,
      width: o,
      height: I
    };
  }
}
gA.prototype.className = "Tag";
rg(gA);
Ie.addGetterSetter(gA, "pointerDirection", oit);
Ie.addGetterSetter(gA, "pointerWidth", 0, bt());
Ie.addGetterSetter(gA, "pointerHeight", 0, bt());
Ie.addGetterSetter(gA, "cornerRadius", 0, FJ(4));
let nf = class extends ct {
  _sceneFunc(t) {
    var i = this.cornerRadius(), n = this.width(), g = this.height();
    t.beginPath(), i ? he.drawRoundedRectPath(t, n, g, i) : t.rect(0, 0, n, g), t.closePath(), t.fillStrokeShape(this);
  }
};
nf.prototype.className = "Rect";
rg(nf);
Ie.addGetterSetter(nf, "cornerRadius", 0, FJ(4));
class rA extends ct {
  _sceneFunc(t) {
    const i = this._getPoints();
    t.beginPath(), t.moveTo(i[0].x, i[0].y);
    for (var n = 1; n < i.length; n++)
      t.lineTo(i[n].x, i[n].y);
    t.closePath(), t.fillStrokeShape(this);
  }
  _getPoints() {
    const t = this.attrs.sides, i = this.attrs.radius || 0, n = [];
    for (var g = 0; g < t; g++)
      n.push({
        x: i * Math.sin(g * 2 * Math.PI / t),
        y: -1 * i * Math.cos(g * 2 * Math.PI / t)
      });
    return n;
  }
  getSelfRect() {
    const t = this._getPoints();
    var i = t[0].x, n = t[0].y, g = t[0].x, r = t[0].y;
    return t.forEach((o) => {
      i = Math.min(i, o.x), n = Math.max(n, o.x), g = Math.min(g, o.y), r = Math.max(r, o.y);
    }), {
      x: i,
      y: g,
      width: n - i,
      height: r - g
    };
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
rA.prototype.className = "RegularPolygon";
rA.prototype._centroid = !0;
rA.prototype._attrsAffectingSize = ["radius"];
rg(rA);
Ie.addGetterSetter(rA, "radius", 0, bt());
Ie.addGetterSetter(rA, "sides", 0, bt());
var pT = Math.PI * 2;
class oA extends ct {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.innerRadius(), 0, pT, !1), t.moveTo(this.outerRadius(), 0), t.arc(0, 0, this.outerRadius(), pT, 0, !0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
oA.prototype.className = "Ring";
oA.prototype._centroid = !0;
oA.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
rg(oA);
Ie.addGetterSetter(oA, "innerRadius", 0, bt());
Ie.addGetterSetter(oA, "outerRadius", 0, bt());
class Va extends ct {
  constructor(t) {
    super(t), this._updated = !0, this.anim = new dl(() => {
      var i = this._updated;
      return this._updated = !1, i;
    }), this.on("animationChange.konva", function() {
      this.frameIndex(0);
    }), this.on("frameIndexChange.konva", function() {
      this._updated = !0;
    }), this.on("frameRateChange.konva", function() {
      this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
    });
  }
  _sceneFunc(t) {
    var i = this.animation(), n = this.frameIndex(), g = n * 4, r = this.animations()[i], o = this.frameOffsets(), I = r[g + 0], s = r[g + 1], a = r[g + 2], d = r[g + 3], C = this.image();
    if ((this.hasFill() || this.hasStroke()) && (t.beginPath(), t.rect(0, 0, a, d), t.closePath(), t.fillStrokeShape(this)), C)
      if (o) {
        var u = o[i], A = n * 2;
        t.drawImage(C, I, s, a, d, u[A + 0], u[A + 1], a, d);
      } else
        t.drawImage(C, I, s, a, d, 0, 0, a, d);
  }
  _hitFunc(t) {
    var i = this.animation(), n = this.frameIndex(), g = n * 4, r = this.animations()[i], o = this.frameOffsets(), I = r[g + 2], s = r[g + 3];
    if (t.beginPath(), o) {
      var a = o[i], d = n * 2;
      t.rect(a[d + 0], a[d + 1], I, s);
    } else
      t.rect(0, 0, I, s);
    t.closePath(), t.fillShape(this);
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _setInterval() {
    var t = this;
    this.interval = setInterval(function() {
      t._updateIndex();
    }, 1e3 / this.frameRate());
  }
  start() {
    if (!this.isRunning()) {
      var t = this.getLayer();
      this.anim.setLayers(t), this._setInterval(), this.anim.start();
    }
  }
  stop() {
    this.anim.stop(), clearInterval(this.interval);
  }
  isRunning() {
    return this.anim.isRunning();
  }
  _updateIndex() {
    var t = this.frameIndex(), i = this.animation(), n = this.animations(), g = n[i], r = g.length / 4;
    t < r - 1 ? this.frameIndex(t + 1) : this.frameIndex(0);
  }
}
Va.prototype.className = "Sprite";
rg(Va);
Ie.addGetterSetter(Va, "animation");
Ie.addGetterSetter(Va, "animations");
Ie.addGetterSetter(Va, "frameOffsets");
Ie.addGetterSetter(Va, "image");
Ie.addGetterSetter(Va, "frameIndex", 0, bt());
Ie.addGetterSetter(Va, "frameRate", 17, bt());
Ie.backCompat(Va, {
  index: "frameIndex",
  getIndex: "getFrameIndex",
  setIndex: "setFrameIndex"
});
class oC extends ct {
  _sceneFunc(t) {
    var i = this.innerRadius(), n = this.outerRadius(), g = this.numPoints();
    t.beginPath(), t.moveTo(0, 0 - n);
    for (var r = 1; r < g * 2; r++) {
      var o = r % 2 === 0 ? n : i, I = o * Math.sin(r * Math.PI / g), s = -1 * o * Math.cos(r * Math.PI / g);
      t.lineTo(I, s);
    }
    t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
oC.prototype.className = "Star";
oC.prototype._centroid = !0;
oC.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
rg(oC);
Ie.addGetterSetter(oC, "numPoints", 5, bt());
Ie.addGetterSetter(oC, "innerRadius", 0, bt());
Ie.addGetterSetter(oC, "outerRadius", 0, bt());
function a8(e) {
  return Array.from(e);
}
var Mb = "auto", lit = "center", v0 = "justify", sit = "Change.konva", ait = "2d", BT = "-", c8 = "left", cit = "text", dit = "Text", Cit = "top", uit = "bottom", ZT = "middle", d8 = "normal", Ait = "px ", yW = " ", bit = "right", mit = "word", hit = "char", fT = "none", Nk = "…", C8 = [
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontVariant",
  "padding",
  "align",
  "verticalAlign",
  "lineHeight",
  "text",
  "width",
  "height",
  "wrap",
  "ellipsis",
  "letterSpacing"
], pit = C8.length;
function Bit(e) {
  return e.split(",").map((t) => {
    t = t.trim();
    const i = t.indexOf(" ") >= 0, n = t.indexOf('"') >= 0 || t.indexOf("'") >= 0;
    return i && !n && (t = `"${t}"`), t;
  }).join(", ");
}
var WW;
function Lk() {
  return WW || (WW = he.createCanvasElement().getContext(ait), WW);
}
function Zit(e) {
  e.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function fit(e) {
  e.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function Git(e) {
  return e = e || {}, !e.fillLinearGradientColorStops && !e.fillRadialGradientColorStops && !e.fillPatternImage && (e.fill = e.fill || "black"), e;
}
let tg = class extends ct {
  constructor(t) {
    super(Git(t)), this._partialTextX = 0, this._partialTextY = 0;
    for (var i = 0; i < pit; i++)
      this.on(C8[i] + sit, this._setTextData);
    this._setTextData();
  }
  _sceneFunc(t) {
    var i = this.textArr, n = i.length;
    if (this.text()) {
      var g = this.padding(), r = this.fontSize(), o = this.lineHeight() * r, I = this.verticalAlign(), s = 0, a = this.align(), d = this.getWidth(), C = this.letterSpacing(), u = this.fill(), A = this.textDecoration(), m = A.indexOf("underline") !== -1, h = A.indexOf("line-through") !== -1, B, f = 0, f = o / 2, G = 0, y = 0;
      for (t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", ZT), t.setAttr("textAlign", c8), I === ZT ? s = (this.getHeight() - n * o - g * 2) / 2 : I === uit && (s = this.getHeight() - n * o - g * 2), t.translate(g, s + g), B = 0; B < n; B++) {
        var G = 0, y = 0, W = i[B], V = W.text, w = W.width, v = W.lastInParagraph, H, x, N;
        if (t.save(), a === bit ? G += d - w - g * 2 : a === lit && (G += (d - w - g * 2) / 2), m) {
          t.save(), t.beginPath(), t.moveTo(G, f + y + Math.round(r / 2)), H = V.split(" ").length - 1, x = H === 0, N = a === v0 && !v ? d - g * 2 : w, t.lineTo(G + Math.round(N), f + y + Math.round(r / 2)), t.lineWidth = r / 15;
          const P = this._getLinearGradient();
          t.strokeStyle = P || u, t.stroke(), t.restore();
        }
        if (h) {
          t.save(), t.beginPath(), t.moveTo(G, f + y), H = V.split(" ").length - 1, x = H === 0, N = a === v0 && v && !x ? d - g * 2 : w, t.lineTo(G + Math.round(N), f + y), t.lineWidth = r / 15;
          const P = this._getLinearGradient();
          t.strokeStyle = P || u, t.stroke(), t.restore();
        }
        if (C !== 0 || a === v0) {
          H = V.split(" ").length - 1;
          for (var M = a8(V), $ = 0; $ < M.length; $++) {
            var q = M[$];
            q === " " && !v && a === v0 && (G += (d - g * 2 - w) / H), this._partialTextX = G, this._partialTextY = f + y, this._partialText = q, t.fillStrokeShape(this), G += this.measureSize(q).width + C;
          }
        } else
          this._partialTextX = G, this._partialTextY = f + y, this._partialText = V, t.fillStrokeShape(this);
        t.restore(), n > 1 && (f += o);
      }
    }
  }
  _hitFunc(t) {
    var i = this.getWidth(), n = this.getHeight();
    t.beginPath(), t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this);
  }
  setText(t) {
    var i = he._isString(t) ? t : t == null ? "" : t + "";
    return this._setAttr(cit, i), this;
  }
  getWidth() {
    var t = this.attrs.width === Mb || this.attrs.width === void 0;
    return t ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
  }
  getHeight() {
    var t = this.attrs.height === Mb || this.attrs.height === void 0;
    return t ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return he.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  measureSize(t) {
    var i = Lk(), n = this.fontSize(), g;
    return i.save(), i.font = this._getContextFont(), g = i.measureText(t), i.restore(), {
      width: g.width,
      height: n
    };
  }
  _getContextFont() {
    return this.fontStyle() + yW + this.fontVariant() + yW + (this.fontSize() + Ait) + Bit(this.fontFamily());
  }
  _addTextLine(t) {
    this.align() === v0 && (t = t.trim());
    var n = this._getTextWidth(t);
    return this.textArr.push({
      text: t,
      width: n,
      lastInParagraph: !1
    });
  }
  _getTextWidth(t) {
    var i = this.letterSpacing(), n = t.length;
    return Lk().measureText(t).width + (n ? i * (n - 1) : 0);
  }
  _setTextData() {
    var t = this.text().split(`
`), i = +this.fontSize(), n = 0, g = this.lineHeight() * i, r = this.attrs.width, o = this.attrs.height, I = r !== Mb && r !== void 0, s = o !== Mb && o !== void 0, a = this.padding(), d = r - a * 2, C = o - a * 2, u = 0, A = this.wrap(), m = A !== fT, h = A !== hit && m, B = this.ellipsis();
    this.textArr = [], Lk().font = this._getContextFont();
    for (var f = B ? this._getTextWidth(Nk) : 0, G = 0, y = t.length; G < y; ++G) {
      var W = t[G], V = this._getTextWidth(W);
      if (I && V > d)
        for (; W.length > 0; ) {
          for (var w = 0, v = W.length, H = "", x = 0; w < v; ) {
            var N = w + v >>> 1, M = W.slice(0, N + 1), $ = this._getTextWidth(M) + f;
            $ <= d ? (w = N + 1, H = M, x = $) : v = N;
          }
          if (H) {
            if (h) {
              var q, E = W[H.length], L = E === yW || E === BT;
              L && x <= d ? q = H.length : q = Math.max(H.lastIndexOf(yW), H.lastIndexOf(BT)) + 1, q > 0 && (w = q, H = H.slice(0, w), x = this._getTextWidth(H));
            }
            H = H.trimRight(), this._addTextLine(H), n = Math.max(n, x), u += g;
            var P = this._shouldHandleEllipsis(u);
            if (P) {
              this._tryToAddEllipsisToLastLine();
              break;
            }
            if (W = W.slice(w), W = W.trimLeft(), W.length > 0 && (V = this._getTextWidth(W), V <= d)) {
              this._addTextLine(W), u += g, n = Math.max(n, V);
              break;
            }
          } else
            break;
        }
      else
        this._addTextLine(W), u += g, n = Math.max(n, V), this._shouldHandleEllipsis(u) && G < y - 1 && this._tryToAddEllipsisToLastLine();
      if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), s && u + g > C)
        break;
    }
    this.textHeight = i, this.textWidth = n;
  }
  _shouldHandleEllipsis(t) {
    var i = +this.fontSize(), n = this.lineHeight() * i, g = this.attrs.height, r = g !== Mb && g !== void 0, o = this.padding(), I = g - o * 2, s = this.wrap(), a = s !== fT;
    return !a || r && t + n > I;
  }
  _tryToAddEllipsisToLastLine() {
    var t = this.attrs.width, i = t !== Mb && t !== void 0, n = this.padding(), g = t - n * 2, r = this.ellipsis(), o = this.textArr[this.textArr.length - 1];
    if (!(!o || !r)) {
      if (i) {
        var I = this._getTextWidth(o.text + Nk) < g;
        I || (o.text = o.text.slice(0, o.text.length - 3));
      }
      this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(o.text + Nk);
    }
  }
  getStrokeScaleEnabled() {
    return !0;
  }
};
tg.prototype._fillFunc = Zit;
tg.prototype._strokeFunc = fit;
tg.prototype.className = dit;
tg.prototype._attrsAffectingSize = [
  "text",
  "fontSize",
  "padding",
  "wrap",
  "lineHeight",
  "letterSpacing"
];
rg(tg);
Ie.overWriteSetter(tg, "width", YJ());
Ie.overWriteSetter(tg, "height", YJ());
Ie.addGetterSetter(tg, "fontFamily", "Arial");
Ie.addGetterSetter(tg, "fontSize", 12, bt());
Ie.addGetterSetter(tg, "fontStyle", d8);
Ie.addGetterSetter(tg, "fontVariant", d8);
Ie.addGetterSetter(tg, "padding", 0, bt());
Ie.addGetterSetter(tg, "align", c8);
Ie.addGetterSetter(tg, "verticalAlign", Cit);
Ie.addGetterSetter(tg, "lineHeight", 1, bt());
Ie.addGetterSetter(tg, "wrap", mit);
Ie.addGetterSetter(tg, "ellipsis", !1, ws());
Ie.addGetterSetter(tg, "letterSpacing", 0, bt());
Ie.addGetterSetter(tg, "text", "", bh());
Ie.addGetterSetter(tg, "textDecoration", "");
var yit = "", u8 = "normal";
function A8(e) {
  e.fillText(this.partialText, 0, 0);
}
function b8(e) {
  e.strokeText(this.partialText, 0, 0);
}
class _g extends ct {
  constructor(t) {
    super(t), this.dummyCanvas = he.createCanvasElement(), this.dataArray = [], this.dataArray = wn.parsePathData(this.attrs.data), this.on("dataChange.konva", function() {
      this.dataArray = wn.parsePathData(this.attrs.data), this._setTextData();
    }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
  }
  _sceneFunc(t) {
    t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", this.textBaseline()), t.setAttr("textAlign", "left"), t.save();
    var i = this.textDecoration(), n = this.fill(), g = this.fontSize(), r = this.glyphInfo;
    i === "underline" && t.beginPath();
    for (var o = 0; o < r.length; o++) {
      t.save();
      var I = r[o].p0;
      t.translate(I.x, I.y), t.rotate(r[o].rotation), this.partialText = r[o].text, t.fillStrokeShape(this), i === "underline" && (o === 0 && t.moveTo(0, g / 2 + 1), t.lineTo(g, g / 2 + 1)), t.restore();
    }
    i === "underline" && (t.strokeStyle = n, t.lineWidth = g / 20, t.stroke()), t.restore();
  }
  _hitFunc(t) {
    t.beginPath();
    var i = this.glyphInfo;
    if (i.length >= 1) {
      var n = i[0].p0;
      t.moveTo(n.x, n.y);
    }
    for (var g = 0; g < i.length; g++) {
      var r = i[g].p1;
      t.lineTo(r.x, r.y);
    }
    t.setAttr("lineWidth", this.fontSize()), t.setAttr("strokeStyle", this.colorKey), t.stroke();
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return he.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  setText(t) {
    return tg.prototype.setText.call(this, t);
  }
  _getContextFont() {
    return tg.prototype._getContextFont.call(this);
  }
  _getTextSize(t) {
    var i = this.dummyCanvas, n = i.getContext("2d");
    n.save(), n.font = this._getContextFont();
    var g = n.measureText(t);
    return n.restore(), {
      width: g.width,
      height: parseInt(this.attrs.fontSize, 10)
    };
  }
  _setTextData() {
    var t = this, i = this._getTextSize(this.attrs.text), n = this.letterSpacing(), g = this.align(), r = this.kerningFunc();
    this.textWidth = i.width, this.textHeight = i.height;
    var o = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * n, 0);
    this.glyphInfo = [];
    for (var I = 0, s = 0; s < t.dataArray.length; s++)
      t.dataArray[s].pathLength > 0 && (I += t.dataArray[s].pathLength);
    var a = 0;
    g === "center" && (a = Math.max(0, I / 2 - o / 2)), g === "right" && (a = Math.max(0, I - o));
    for (var d = a8(this.text()), C = this.text().split(" ").length - 1, u, A, m, h = -1, B = 0, f = function() {
      B = 0;
      for (var $ = t.dataArray, q = h + 1; q < $.length; q++) {
        if ($[q].pathLength > 0)
          return h = q, $[q];
        $[q].command === "M" && (u = {
          x: $[q].points[0],
          y: $[q].points[1]
        });
      }
      return {};
    }, G = function($) {
      var q = t._getTextSize($).width + n;
      $ === " " && g === "justify" && (q += (I - o) / C);
      var E = 0, L = 0;
      for (A = void 0; Math.abs(q - E) / q > 0.01 && L < 20; ) {
        L++;
        for (var P = E; m === void 0; )
          m = f(), m && P + m.pathLength < q && (P += m.pathLength, m = void 0);
        if (Object.keys(m).length === 0 || u === void 0)
          return;
        var Q = !1;
        switch (m.command) {
          case "L":
            wn.getLineLength(u.x, u.y, m.points[0], m.points[1]) > q ? A = wn.getPointOnLine(q, u.x, u.y, m.points[0], m.points[1], u.x, u.y) : m = void 0;
            break;
          case "A":
            var te = m.points[4], le = m.points[5], Ae = m.points[4] + le;
            B === 0 ? B = te + 1e-8 : q > E ? B += Math.PI / 180 * le / Math.abs(le) : B -= Math.PI / 360 * le / Math.abs(le), (le < 0 && B < Ae || le >= 0 && B > Ae) && (B = Ae, Q = !0), A = wn.getPointOnEllipticalArc(m.points[0], m.points[1], m.points[2], m.points[3], B, m.points[6]);
            break;
          case "C":
            B === 0 ? q > m.pathLength ? B = 1e-8 : B = q / m.pathLength : q > E ? B += (q - E) / m.pathLength / 2 : B = Math.max(B - (E - q) / m.pathLength / 2, 0), B > 1 && (B = 1, Q = !0), A = wn.getPointOnCubicBezier(B, m.start.x, m.start.y, m.points[0], m.points[1], m.points[2], m.points[3], m.points[4], m.points[5]);
            break;
          case "Q":
            B === 0 ? B = q / m.pathLength : q > E ? B += (q - E) / m.pathLength : B -= (E - q) / m.pathLength, B > 1 && (B = 1, Q = !0), A = wn.getPointOnQuadraticBezier(B, m.start.x, m.start.y, m.points[0], m.points[1], m.points[2], m.points[3]);
            break;
        }
        A !== void 0 && (E = wn.getLineLength(u.x, u.y, A.x, A.y)), Q && (Q = !1, m = void 0);
      }
    }, y = "C", W = t._getTextSize(y).width + n, V = a / W - 1, w = 0; w < V && (G(y), !(u === void 0 || A === void 0)); w++)
      u = A;
    for (var v = 0; v < d.length && (G(d[v]), !(u === void 0 || A === void 0)); v++) {
      var H = wn.getLineLength(u.x, u.y, A.x, A.y), x = 0;
      if (r)
        try {
          x = r(d[v - 1], d[v]) * this.fontSize();
        } catch {
          x = 0;
        }
      u.x += x, A.x += x, this.textWidth += x;
      var N = wn.getPointOnLine(x + H / 2, u.x, u.y, A.x, A.y), M = Math.atan2(A.y - u.y, A.x - u.x);
      this.glyphInfo.push({
        transposeX: N.x,
        transposeY: N.y,
        text: d[v],
        rotation: M,
        p0: u,
        p1: A
      }), u = A;
    }
  }
  getSelfRect() {
    if (!this.glyphInfo.length)
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    var t = [];
    this.glyphInfo.forEach(function(d) {
      t.push(d.p0.x), t.push(d.p0.y), t.push(d.p1.x), t.push(d.p1.y);
    });
    for (var i = t[0] || 0, n = t[0] || 0, g = t[1] || 0, r = t[1] || 0, o, I, s = 0; s < t.length / 2; s++)
      o = t[s * 2], I = t[s * 2 + 1], i = Math.min(i, o), n = Math.max(n, o), g = Math.min(g, I), r = Math.max(r, I);
    var a = this.fontSize();
    return {
      x: i - a / 2,
      y: g - a / 2,
      width: n - i + a,
      height: r - g + a
    };
  }
  destroy() {
    return he.releaseCanvas(this.dummyCanvas), super.destroy();
  }
}
_g.prototype._fillFunc = A8;
_g.prototype._strokeFunc = b8;
_g.prototype._fillFuncHit = A8;
_g.prototype._strokeFuncHit = b8;
_g.prototype.className = "TextPath";
_g.prototype._attrsAffectingSize = ["text", "fontSize", "data"];
rg(_g);
Ie.addGetterSetter(_g, "data");
Ie.addGetterSetter(_g, "fontFamily", "Arial");
Ie.addGetterSetter(_g, "fontSize", 12, bt());
Ie.addGetterSetter(_g, "fontStyle", u8);
Ie.addGetterSetter(_g, "align", "left");
Ie.addGetterSetter(_g, "letterSpacing", 0, bt());
Ie.addGetterSetter(_g, "textBaseline", "middle");
Ie.addGetterSetter(_g, "fontVariant", u8);
Ie.addGetterSetter(_g, "text", yit);
Ie.addGetterSetter(_g, "textDecoration", null);
Ie.addGetterSetter(_g, "kerningFunc", null);
var m8 = "tr-konva", Wit = [
  "resizeEnabledChange",
  "rotateAnchorOffsetChange",
  "rotateEnabledChange",
  "enabledAnchorsChange",
  "anchorSizeChange",
  "borderEnabledChange",
  "borderStrokeChange",
  "borderStrokeWidthChange",
  "borderDashChange",
  "anchorStrokeChange",
  "anchorStrokeWidthChange",
  "anchorFillChange",
  "anchorCornerRadiusChange",
  "ignoreStrokeChange"
].map((e) => e + `.${m8}`).join(" "), GT = "nodesRect", Sit = [
  "widthChange",
  "heightChange",
  "scaleXChange",
  "scaleYChange",
  "skewXChange",
  "skewYChange",
  "rotationChange",
  "offsetXChange",
  "offsetYChange",
  "transformsEnabledChange",
  "strokeWidthChange"
], Vit = {
  "top-left": -45,
  "top-center": 0,
  "top-right": 45,
  "middle-right": -90,
  "middle-left": 90,
  "bottom-left": -135,
  "bottom-center": 180,
  "bottom-right": 135
};
const wit = "ontouchstart" in Mt._global;
function vit(e, t) {
  if (e === "rotater")
    return "crosshair";
  t += he.degToRad(Vit[e] || 0);
  var i = (he.radToDeg(t) % 360 + 360) % 360;
  return he._inRange(i, 315 + 22.5, 360) || he._inRange(i, 0, 22.5) ? "ns-resize" : he._inRange(i, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : he._inRange(i, 90 - 22.5, 90 + 22.5) ? "ew-resize" : he._inRange(i, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : he._inRange(i, 180 - 22.5, 180 + 22.5) ? "ns-resize" : he._inRange(i, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : he._inRange(i, 270 - 22.5, 270 + 22.5) ? "ew-resize" : he._inRange(i, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (he.error("Transformer has unknown angle for cursor detection: " + i), "pointer");
}
var sV = [
  "top-left",
  "top-center",
  "top-right",
  "middle-right",
  "middle-left",
  "bottom-left",
  "bottom-center",
  "bottom-right"
], yT = 1e8;
function Rit(e) {
  return {
    x: e.x + e.width / 2 * Math.cos(e.rotation) + e.height / 2 * Math.sin(-e.rotation),
    y: e.y + e.height / 2 * Math.cos(e.rotation) + e.width / 2 * Math.sin(e.rotation)
  };
}
function h8(e, t, i) {
  const n = i.x + (e.x - i.x) * Math.cos(t) - (e.y - i.y) * Math.sin(t), g = i.y + (e.x - i.x) * Math.sin(t) + (e.y - i.y) * Math.cos(t);
  return Object.assign(Object.assign({}, e), {
    rotation: e.rotation + t,
    x: n,
    y: g
  });
}
function Xit(e, t) {
  const i = Rit(e);
  return h8(e, t, i);
}
function Hit(e, t, i) {
  let n = t;
  for (let g = 0; g < e.length; g++) {
    const r = Mt.getAngle(e[g]), o = Math.abs(r - t) % (Math.PI * 2);
    Math.min(o, Math.PI * 2 - o) < i && (n = r);
  }
  return n;
}
class An extends Km {
  constructor(t) {
    super(t), this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(Wit, this.update), this.getNode() && this.update();
  }
  attachTo(t) {
    return this.setNode(t), this;
  }
  setNode(t) {
    return he.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([t]);
  }
  getNode() {
    return this._nodes && this._nodes[0];
  }
  _getEventNamespace() {
    return m8 + this._id;
  }
  setNodes(t = []) {
    this._nodes && this._nodes.length && this.detach();
    const i = t.filter((g) => g.isAncestorOf(this) ? (he.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
    this._nodes = t = i, t.length === 1 && this.useSingleNodeRotation() ? this.rotation(t[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((g) => {
      const r = () => {
        this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
      }, o = g._attrsAffectingSize.map((I) => I + "Change." + this._getEventNamespace()).join(" ");
      g.on(o, r), g.on(Sit.map((I) => I + `.${this._getEventNamespace()}`).join(" "), r), g.on(`absoluteTransformChange.${this._getEventNamespace()}`, r), this._proxyDrag(g);
    }), this._resetTransformCache();
    var n = !!this.findOne(".top-left");
    return n && this.update(), this;
  }
  _proxyDrag(t) {
    let i;
    t.on(`dragstart.${this._getEventNamespace()}`, (n) => {
      i = t.getAbsolutePosition(), !this.isDragging() && t !== this.findOne(".back") && this.startDrag(n, !1);
    }), t.on(`dragmove.${this._getEventNamespace()}`, (n) => {
      if (!i)
        return;
      const g = t.getAbsolutePosition(), r = g.x - i.x, o = g.y - i.y;
      this.nodes().forEach((I) => {
        if (I === t || I.isDragging())
          return;
        const s = I.getAbsolutePosition();
        I.setAbsolutePosition({
          x: s.x + r,
          y: s.y + o
        }), I.startDrag(n);
      }), i = null;
    });
  }
  getNodes() {
    return this._nodes || [];
  }
  getActiveAnchor() {
    return this._movingAnchorName;
  }
  detach() {
    this._nodes && this._nodes.forEach((t) => {
      t.off("." + this._getEventNamespace());
    }), this._nodes = [], this._resetTransformCache();
  }
  _resetTransformCache() {
    this._clearCache(GT), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
  }
  _getNodeRect() {
    return this._getCache(GT, this.__getNodeRect);
  }
  __getNodeShape(t, i = this.rotation(), n) {
    var g = t.getClientRect({
      skipTransform: !0,
      skipShadow: !0,
      skipStroke: this.ignoreStroke()
    }), r = t.getAbsoluteScale(n), o = t.getAbsolutePosition(n), I = g.x * r.x - t.offsetX() * r.x, s = g.y * r.y - t.offsetY() * r.y;
    const a = (Mt.getAngle(t.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), d = {
      x: o.x + I * Math.cos(a) + s * Math.sin(-a),
      y: o.y + s * Math.cos(a) + I * Math.sin(a),
      width: g.width * r.x,
      height: g.height * r.y,
      rotation: a
    };
    return h8(d, -Mt.getAngle(i), {
      x: 0,
      y: 0
    });
  }
  __getNodeRect() {
    var t = this.getNode();
    if (!t)
      return {
        x: -yT,
        y: -yT,
        width: 0,
        height: 0,
        rotation: 0
      };
    const i = [];
    this.nodes().map((a) => {
      const d = a.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      });
      var C = [
        { x: d.x, y: d.y },
        { x: d.x + d.width, y: d.y },
        { x: d.x + d.width, y: d.y + d.height },
        { x: d.x, y: d.y + d.height }
      ], u = a.getAbsoluteTransform();
      C.forEach(function(A) {
        var m = u.point(A);
        i.push(m);
      });
    });
    const n = new ZI();
    n.rotate(-Mt.getAngle(this.rotation()));
    var g, r, o, I;
    i.forEach(function(a) {
      var d = n.point(a);
      g === void 0 && (g = o = d.x, r = I = d.y), g = Math.min(g, d.x), r = Math.min(r, d.y), o = Math.max(o, d.x), I = Math.max(I, d.y);
    }), n.invert();
    const s = n.point({ x: g, y: r });
    return {
      x: s.x,
      y: s.y,
      width: o - g,
      height: I - r,
      rotation: Mt.getAngle(this.rotation())
    };
  }
  getX() {
    return this._getNodeRect().x;
  }
  getY() {
    return this._getNodeRect().y;
  }
  getWidth() {
    return this._getNodeRect().width;
  }
  getHeight() {
    return this._getNodeRect().height;
  }
  _createElements() {
    this._createBack(), sV.forEach((function(t) {
      this._createAnchor(t);
    }).bind(this)), this._createAnchor("rotater");
  }
  _createAnchor(t) {
    var i = new nf({
      stroke: "rgb(0, 161, 255)",
      fill: "white",
      strokeWidth: 1,
      name: t + " _anchor",
      dragDistance: 0,
      draggable: !0,
      hitStrokeWidth: wit ? 10 : "auto"
    }), n = this;
    i.on("mousedown touchstart", function(g) {
      n._handleMouseDown(g);
    }), i.on("dragstart", (g) => {
      i.stopDrag(), g.cancelBubble = !0;
    }), i.on("dragend", (g) => {
      g.cancelBubble = !0;
    }), i.on("mouseenter", () => {
      var g = Mt.getAngle(this.rotation()), r = vit(t, g);
      i.getStage().content && (i.getStage().content.style.cursor = r), this._cursorChange = !0;
    }), i.on("mouseout", () => {
      i.getStage().content && (i.getStage().content.style.cursor = ""), this._cursorChange = !1;
    }), this.add(i);
  }
  _createBack() {
    var t = new ct({
      name: "back",
      width: 0,
      height: 0,
      draggable: !0,
      sceneFunc(i) {
        var n = this.getParent(), g = n.padding();
        i.beginPath(), i.rect(-g, -g, this.width() + g * 2, this.height() + g * 2), i.moveTo(this.width() / 2, -g), n.rotateEnabled() && i.lineTo(this.width() / 2, -n.rotateAnchorOffset() * he._sign(this.height()) - g), i.fillStrokeShape(this);
      },
      hitFunc: (i, n) => {
        if (this.shouldOverdrawWholeArea()) {
          var g = this.padding();
          i.beginPath(), i.rect(-g, -g, n.width() + g * 2, n.height() + g * 2), i.fillStrokeShape(n);
        }
      }
    });
    this.add(t), this._proxyDrag(t), t.on("dragstart", (i) => {
      i.cancelBubble = !0;
    }), t.on("dragmove", (i) => {
      i.cancelBubble = !0;
    }), t.on("dragend", (i) => {
      i.cancelBubble = !0;
    }), this.on("dragmove", (i) => {
      this.update();
    });
  }
  _handleMouseDown(t) {
    this._movingAnchorName = t.target.name().split(" ")[0];
    var i = this._getNodeRect(), n = i.width, g = i.height, r = Math.sqrt(Math.pow(n, 2) + Math.pow(g, 2));
    this.sin = Math.abs(g / r), this.cos = Math.abs(n / r), typeof window < "u" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
    var o = t.target.getAbsolutePosition(), I = t.target.getStage().getPointerPosition();
    this._anchorDragOffset = {
      x: I.x - o.x,
      y: I.y - o.y
    }, this._fire("transformstart", { evt: t.evt, target: this.getNode() }), this._nodes.forEach((s) => {
      s._fire("transformstart", { evt: t.evt, target: s });
    });
  }
  _handleMouseMove(t) {
    var i, n, g, r = this.findOne("." + this._movingAnchorName), o = r.getStage();
    o.setPointersPositions(t);
    const I = o.getPointerPosition();
    let s = {
      x: I.x - this._anchorDragOffset.x,
      y: I.y - this._anchorDragOffset.y
    };
    const a = r.getAbsolutePosition();
    this.anchorDragBoundFunc() && (s = this.anchorDragBoundFunc()(a, s, t)), r.setAbsolutePosition(s);
    const d = r.getAbsolutePosition();
    if (!(a.x === d.x && a.y === d.y)) {
      if (this._movingAnchorName === "rotater") {
        var C = this._getNodeRect();
        i = r.x() - C.width / 2, n = -r.y() + C.height / 2;
        let $ = Math.atan2(-n, i) + Math.PI / 2;
        C.height < 0 && ($ -= Math.PI);
        var u = Mt.getAngle(this.rotation());
        const q = u + $, E = Mt.getAngle(this.rotationSnapTolerance()), P = Hit(this.rotationSnaps(), q, E) - C.rotation, Q = Xit(C, P);
        this._fitNodesInto(Q, t);
        return;
      }
      var A = this.keepRatio() || t.shiftKey, G = this.centeredScaling() || t.altKey;
      if (this._movingAnchorName === "top-left") {
        if (A) {
          var m = G ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          g = Math.sqrt(Math.pow(m.x - r.x(), 2) + Math.pow(m.y - r.y(), 2));
          var h = this.findOne(".top-left").x() > m.x ? -1 : 1, B = this.findOne(".top-left").y() > m.y ? -1 : 1;
          i = g * this.cos * h, n = g * this.sin * B, this.findOne(".top-left").x(m.x - i), this.findOne(".top-left").y(m.y - n);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(r.y());
      else if (this._movingAnchorName === "top-right") {
        if (A) {
          var m = G ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          g = Math.sqrt(Math.pow(r.x() - m.x, 2) + Math.pow(m.y - r.y(), 2));
          var h = this.findOne(".top-right").x() < m.x ? -1 : 1, B = this.findOne(".top-right").y() > m.y ? -1 : 1;
          i = g * this.cos * h, n = g * this.sin * B, this.findOne(".top-right").x(m.x + i), this.findOne(".top-right").y(m.y - n);
        }
        var f = r.position();
        this.findOne(".top-left").y(f.y), this.findOne(".bottom-right").x(f.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(r.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(r.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (A) {
          var m = G ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          g = Math.sqrt(Math.pow(m.x - r.x(), 2) + Math.pow(r.y() - m.y, 2));
          var h = m.x < r.x() ? -1 : 1, B = r.y() < m.y ? -1 : 1;
          i = g * this.cos * h, n = g * this.sin * B, r.x(m.x - i), r.y(m.y + n);
        }
        f = r.position(), this.findOne(".top-left").x(f.x), this.findOne(".bottom-right").y(f.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(r.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (A) {
          var m = G ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          g = Math.sqrt(Math.pow(r.x() - m.x, 2) + Math.pow(r.y() - m.y, 2));
          var h = this.findOne(".bottom-right").x() < m.x ? -1 : 1, B = this.findOne(".bottom-right").y() < m.y ? -1 : 1;
          i = g * this.cos * h, n = g * this.sin * B, this.findOne(".bottom-right").x(m.x + i), this.findOne(".bottom-right").y(m.y + n);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var G = this.centeredScaling() || t.altKey;
      if (G) {
        var y = this.findOne(".top-left"), W = this.findOne(".bottom-right"), V = y.x(), w = y.y(), v = this.getWidth() - W.x(), H = this.getHeight() - W.y();
        W.move({
          x: -V,
          y: -w
        }), y.move({
          x: v,
          y: H
        });
      }
      var x = this.findOne(".top-left").getAbsolutePosition();
      i = x.x, n = x.y;
      var N = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), M = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: i,
        y: n,
        width: N,
        height: M,
        rotation: Mt.getAngle(this.rotation())
      }, t);
    }
  }
  _handleMouseUp(t) {
    this._removeEvents(t);
  }
  getAbsoluteTransform() {
    return this.getTransform();
  }
  _removeEvents(t) {
    if (this._transforming) {
      this._transforming = !1, typeof window < "u" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
      var i = this.getNode();
      this._fire("transformend", { evt: t, target: i }), i && this._nodes.forEach((n) => {
        n._fire("transformend", { evt: t, target: n });
      }), this._movingAnchorName = null;
    }
  }
  _fitNodesInto(t, i) {
    var n = this._getNodeRect();
    const g = 1;
    if (he._inRange(t.width, -this.padding() * 2 - g, g)) {
      this.update();
      return;
    }
    if (he._inRange(t.height, -this.padding() * 2 - g, g)) {
      this.update();
      return;
    }
    const r = this.flipEnabled();
    var o = new ZI();
    if (o.rotate(Mt.getAngle(this.rotation())), this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
      const C = o.point({
        x: -this.padding() * 2,
        y: 0
      });
      if (t.x += C.x, t.y += C.y, t.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= C.x, this._anchorDragOffset.y -= C.y, !r) {
        this.update();
        return;
      }
    } else if (this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
      const C = o.point({
        x: this.padding() * 2,
        y: 0
      });
      if (this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= C.x, this._anchorDragOffset.y -= C.y, t.width += this.padding() * 2, !r) {
        this.update();
        return;
      }
    }
    if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
      const C = o.point({
        x: 0,
        y: -this.padding() * 2
      });
      if (t.x += C.x, t.y += C.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= C.x, this._anchorDragOffset.y -= C.y, t.height += this.padding() * 2, !r) {
        this.update();
        return;
      }
    } else if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
      const C = o.point({
        x: 0,
        y: this.padding() * 2
      });
      if (this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= C.x, this._anchorDragOffset.y -= C.y, t.height += this.padding() * 2, !r) {
        this.update();
        return;
      }
    }
    if (this.boundBoxFunc()) {
      const C = this.boundBoxFunc()(n, t);
      C ? t = C : he.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
    }
    const I = 1e7, s = new ZI();
    s.translate(n.x, n.y), s.rotate(n.rotation), s.scale(n.width / I, n.height / I);
    const a = new ZI();
    a.translate(t.x, t.y), a.rotate(t.rotation), a.scale(t.width / I, t.height / I);
    const d = a.multiply(s.invert());
    this._nodes.forEach((C) => {
      var u;
      const A = C.getParent().getAbsoluteTransform(), m = C.getTransform().copy();
      m.translate(C.offsetX(), C.offsetY());
      const h = new ZI();
      h.multiply(A.copy().invert()).multiply(d).multiply(A).multiply(m);
      const B = h.decompose();
      C.setAttrs(B), this._fire("transform", { evt: i, target: C }), C._fire("transform", { evt: i, target: C }), (u = C.getLayer()) === null || u === void 0 || u.batchDraw();
    }), this.rotation(he._getRotation(t.rotation)), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
  }
  forceUpdate() {
    this._resetTransformCache(), this.update();
  }
  _batchChangeChild(t, i) {
    this.findOne(t).setAttrs(i);
  }
  update() {
    var t, i = this._getNodeRect();
    this.rotation(he._getRotation(i.rotation));
    var n = i.width, g = i.height, r = this.enabledAnchors(), o = this.resizeEnabled(), I = this.padding(), s = this.anchorSize();
    this.find("._anchor").forEach((a) => {
      a.setAttrs({
        width: s,
        height: s,
        offsetX: s / 2,
        offsetY: s / 2,
        stroke: this.anchorStroke(),
        strokeWidth: this.anchorStrokeWidth(),
        fill: this.anchorFill(),
        cornerRadius: this.anchorCornerRadius()
      });
    }), this._batchChangeChild(".top-left", {
      x: 0,
      y: 0,
      offsetX: s / 2 + I,
      offsetY: s / 2 + I,
      visible: o && r.indexOf("top-left") >= 0
    }), this._batchChangeChild(".top-center", {
      x: n / 2,
      y: 0,
      offsetY: s / 2 + I,
      visible: o && r.indexOf("top-center") >= 0
    }), this._batchChangeChild(".top-right", {
      x: n,
      y: 0,
      offsetX: s / 2 - I,
      offsetY: s / 2 + I,
      visible: o && r.indexOf("top-right") >= 0
    }), this._batchChangeChild(".middle-left", {
      x: 0,
      y: g / 2,
      offsetX: s / 2 + I,
      visible: o && r.indexOf("middle-left") >= 0
    }), this._batchChangeChild(".middle-right", {
      x: n,
      y: g / 2,
      offsetX: s / 2 - I,
      visible: o && r.indexOf("middle-right") >= 0
    }), this._batchChangeChild(".bottom-left", {
      x: 0,
      y: g,
      offsetX: s / 2 + I,
      offsetY: s / 2 - I,
      visible: o && r.indexOf("bottom-left") >= 0
    }), this._batchChangeChild(".bottom-center", {
      x: n / 2,
      y: g,
      offsetY: s / 2 - I,
      visible: o && r.indexOf("bottom-center") >= 0
    }), this._batchChangeChild(".bottom-right", {
      x: n,
      y: g,
      offsetX: s / 2 - I,
      offsetY: s / 2 - I,
      visible: o && r.indexOf("bottom-right") >= 0
    }), this._batchChangeChild(".rotater", {
      x: n / 2,
      y: -this.rotateAnchorOffset() * he._sign(g) - I,
      visible: this.rotateEnabled()
    }), this._batchChangeChild(".back", {
      width: n,
      height: g,
      visible: this.borderEnabled(),
      stroke: this.borderStroke(),
      strokeWidth: this.borderStrokeWidth(),
      dash: this.borderDash(),
      x: 0,
      y: 0
    }), (t = this.getLayer()) === null || t === void 0 || t.batchDraw();
  }
  isTransforming() {
    return this._transforming;
  }
  stopTransform() {
    if (this._transforming) {
      this._removeEvents();
      var t = this.findOne("." + this._movingAnchorName);
      t && t.stopDrag();
    }
  }
  destroy() {
    return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), Km.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
  }
  toObject() {
    return mt.prototype.toObject.call(this);
  }
  clone(t) {
    var i = mt.prototype.clone.call(this, t);
    return i;
  }
  getClientRect() {
    return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
  }
}
function kit(e) {
  return e instanceof Array || he.warn("enabledAnchors value should be an array"), e instanceof Array && e.forEach(function(t) {
    sV.indexOf(t) === -1 && he.warn("Unknown anchor name: " + t + ". Available names are: " + sV.join(", "));
  }), e || [];
}
An.prototype.className = "Transformer";
rg(An);
Ie.addGetterSetter(An, "enabledAnchors", sV, kit);
Ie.addGetterSetter(An, "flipEnabled", !0, ws());
Ie.addGetterSetter(An, "resizeEnabled", !0);
Ie.addGetterSetter(An, "anchorSize", 10, bt());
Ie.addGetterSetter(An, "rotateEnabled", !0);
Ie.addGetterSetter(An, "rotationSnaps", []);
Ie.addGetterSetter(An, "rotateAnchorOffset", 50, bt());
Ie.addGetterSetter(An, "rotationSnapTolerance", 5, bt());
Ie.addGetterSetter(An, "borderEnabled", !0);
Ie.addGetterSetter(An, "anchorStroke", "rgb(0, 161, 255)");
Ie.addGetterSetter(An, "anchorStrokeWidth", 1, bt());
Ie.addGetterSetter(An, "anchorFill", "white");
Ie.addGetterSetter(An, "anchorCornerRadius", 0, bt());
Ie.addGetterSetter(An, "borderStroke", "rgb(0, 161, 255)");
Ie.addGetterSetter(An, "borderStrokeWidth", 1, bt());
Ie.addGetterSetter(An, "borderDash");
Ie.addGetterSetter(An, "keepRatio", !0);
Ie.addGetterSetter(An, "centeredScaling", !1);
Ie.addGetterSetter(An, "ignoreStroke", !1);
Ie.addGetterSetter(An, "padding", 0, bt());
Ie.addGetterSetter(An, "node");
Ie.addGetterSetter(An, "nodes");
Ie.addGetterSetter(An, "boundBoxFunc");
Ie.addGetterSetter(An, "anchorDragBoundFunc");
Ie.addGetterSetter(An, "shouldOverdrawWholeArea", !1);
Ie.addGetterSetter(An, "useSingleNodeRotation", !0);
Ie.backCompat(An, {
  lineEnabled: "borderEnabled",
  rotateHandlerOffset: "rotateAnchorOffset",
  enabledHandlers: "enabledAnchors"
});
class vc extends ct {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.radius(), 0, Mt.getAngle(this.angle()), this.clockwise()), t.lineTo(0, 0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
vc.prototype.className = "Wedge";
vc.prototype._centroid = !0;
vc.prototype._attrsAffectingSize = ["radius"];
rg(vc);
Ie.addGetterSetter(vc, "radius", 0, bt());
Ie.addGetterSetter(vc, "angle", 0, bt());
Ie.addGetterSetter(vc, "clockwise", !1);
Ie.backCompat(vc, {
  angleDeg: "angle",
  getAngleDeg: "getAngle",
  setAngleDeg: "setAngle"
});
function WT() {
  this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
}
var Fit = [
  512,
  512,
  456,
  512,
  328,
  456,
  335,
  512,
  405,
  328,
  271,
  456,
  388,
  335,
  292,
  512,
  454,
  405,
  364,
  328,
  298,
  271,
  496,
  456,
  420,
  388,
  360,
  335,
  312,
  292,
  273,
  512,
  482,
  454,
  428,
  405,
  383,
  364,
  345,
  328,
  312,
  298,
  284,
  271,
  259,
  496,
  475,
  456,
  437,
  420,
  404,
  388,
  374,
  360,
  347,
  335,
  323,
  312,
  302,
  292,
  282,
  273,
  265,
  512,
  497,
  482,
  468,
  454,
  441,
  428,
  417,
  405,
  394,
  383,
  373,
  364,
  354,
  345,
  337,
  328,
  320,
  312,
  305,
  298,
  291,
  284,
  278,
  271,
  265,
  259,
  507,
  496,
  485,
  475,
  465,
  456,
  446,
  437,
  428,
  420,
  412,
  404,
  396,
  388,
  381,
  374,
  367,
  360,
  354,
  347,
  341,
  335,
  329,
  323,
  318,
  312,
  307,
  302,
  297,
  292,
  287,
  282,
  278,
  273,
  269,
  265,
  261,
  512,
  505,
  497,
  489,
  482,
  475,
  468,
  461,
  454,
  447,
  441,
  435,
  428,
  422,
  417,
  411,
  405,
  399,
  394,
  389,
  383,
  378,
  373,
  368,
  364,
  359,
  354,
  350,
  345,
  341,
  337,
  332,
  328,
  324,
  320,
  316,
  312,
  309,
  305,
  301,
  298,
  294,
  291,
  287,
  284,
  281,
  278,
  274,
  271,
  268,
  265,
  262,
  259,
  257,
  507,
  501,
  496,
  491,
  485,
  480,
  475,
  470,
  465,
  460,
  456,
  451,
  446,
  442,
  437,
  433,
  428,
  424,
  420,
  416,
  412,
  408,
  404,
  400,
  396,
  392,
  388,
  385,
  381,
  377,
  374,
  370,
  367,
  363,
  360,
  357,
  354,
  350,
  347,
  344,
  341,
  338,
  335,
  332,
  329,
  326,
  323,
  320,
  318,
  315,
  312,
  310,
  307,
  304,
  302,
  299,
  297,
  294,
  292,
  289,
  287,
  285,
  282,
  280,
  278,
  275,
  273,
  271,
  269,
  267,
  265,
  263,
  261,
  259
], Yit = [
  9,
  11,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24
];
function xit(e, t) {
  var i = e.data, n = e.width, g = e.height, r, o, I, s, a, d, C, u, A, m, h, B, f, G, y, W, V, w, v, H, x, N, M, $, q = t + t + 1, E = n - 1, L = g - 1, P = t + 1, Q = P * (P + 1) / 2, te = new WT(), le = null, Ae = te, we = null, Ee = null, Je = Fit[t], ve = Yit[t];
  for (I = 1; I < q; I++)
    Ae = Ae.next = new WT(), I === P && (le = Ae);
  for (Ae.next = te, C = d = 0, o = 0; o < g; o++) {
    for (W = V = w = v = u = A = m = h = 0, B = P * (H = i[d]), f = P * (x = i[d + 1]), G = P * (N = i[d + 2]), y = P * (M = i[d + 3]), u += Q * H, A += Q * x, m += Q * N, h += Q * M, Ae = te, I = 0; I < P; I++)
      Ae.r = H, Ae.g = x, Ae.b = N, Ae.a = M, Ae = Ae.next;
    for (I = 1; I < P; I++)
      s = d + ((E < I ? E : I) << 2), u += (Ae.r = H = i[s]) * ($ = P - I), A += (Ae.g = x = i[s + 1]) * $, m += (Ae.b = N = i[s + 2]) * $, h += (Ae.a = M = i[s + 3]) * $, W += H, V += x, w += N, v += M, Ae = Ae.next;
    for (we = te, Ee = le, r = 0; r < n; r++)
      i[d + 3] = M = h * Je >> ve, M !== 0 ? (M = 255 / M, i[d] = (u * Je >> ve) * M, i[d + 1] = (A * Je >> ve) * M, i[d + 2] = (m * Je >> ve) * M) : i[d] = i[d + 1] = i[d + 2] = 0, u -= B, A -= f, m -= G, h -= y, B -= we.r, f -= we.g, G -= we.b, y -= we.a, s = C + ((s = r + t + 1) < E ? s : E) << 2, W += we.r = i[s], V += we.g = i[s + 1], w += we.b = i[s + 2], v += we.a = i[s + 3], u += W, A += V, m += w, h += v, we = we.next, B += H = Ee.r, f += x = Ee.g, G += N = Ee.b, y += M = Ee.a, W -= H, V -= x, w -= N, v -= M, Ee = Ee.next, d += 4;
    C += n;
  }
  for (r = 0; r < n; r++) {
    for (V = w = v = W = A = m = h = u = 0, d = r << 2, B = P * (H = i[d]), f = P * (x = i[d + 1]), G = P * (N = i[d + 2]), y = P * (M = i[d + 3]), u += Q * H, A += Q * x, m += Q * N, h += Q * M, Ae = te, I = 0; I < P; I++)
      Ae.r = H, Ae.g = x, Ae.b = N, Ae.a = M, Ae = Ae.next;
    for (a = n, I = 1; I <= t; I++)
      d = a + r << 2, u += (Ae.r = H = i[d]) * ($ = P - I), A += (Ae.g = x = i[d + 1]) * $, m += (Ae.b = N = i[d + 2]) * $, h += (Ae.a = M = i[d + 3]) * $, W += H, V += x, w += N, v += M, Ae = Ae.next, I < L && (a += n);
    for (d = r, we = te, Ee = le, o = 0; o < g; o++)
      s = d << 2, i[s + 3] = M = h * Je >> ve, M > 0 ? (M = 255 / M, i[s] = (u * Je >> ve) * M, i[s + 1] = (A * Je >> ve) * M, i[s + 2] = (m * Je >> ve) * M) : i[s] = i[s + 1] = i[s + 2] = 0, u -= B, A -= f, m -= G, h -= y, B -= we.r, f -= we.g, G -= we.b, y -= we.a, s = r + ((s = o + P) < L ? s : L) * n << 2, u += W += we.r = i[s], A += V += we.g = i[s + 1], m += w += we.b = i[s + 2], h += v += we.a = i[s + 3], we = we.next, B += H = Ee.r, f += x = Ee.g, G += N = Ee.b, y += M = Ee.a, W -= H, V -= x, w -= N, v -= M, Ee = Ee.next, d += n;
  }
}
const Dit = function(t) {
  var i = Math.round(this.blurRadius());
  i > 0 && xit(t, i);
};
Ie.addGetterSetter(mt, "blurRadius", 0, bt(), Ie.afterSetFilter);
const Jit = function(e) {
  var t = this.brightness() * 255, i = e.data, n = i.length, g;
  for (g = 0; g < n; g += 4)
    i[g] += t, i[g + 1] += t, i[g + 2] += t;
};
Ie.addGetterSetter(mt, "brightness", 0, bt(), Ie.afterSetFilter);
const Kit = function(e) {
  var t = Math.pow((this.contrast() + 100) / 100, 2), i = e.data, n = i.length, g = 150, r = 150, o = 150, I;
  for (I = 0; I < n; I += 4)
    g = i[I], r = i[I + 1], o = i[I + 2], g /= 255, g -= 0.5, g *= t, g += 0.5, g *= 255, r /= 255, r -= 0.5, r *= t, r += 0.5, r *= 255, o /= 255, o -= 0.5, o *= t, o += 0.5, o *= 255, g = g < 0 ? 0 : g > 255 ? 255 : g, r = r < 0 ? 0 : r > 255 ? 255 : r, o = o < 0 ? 0 : o > 255 ? 255 : o, i[I] = g, i[I + 1] = r, i[I + 2] = o;
};
Ie.addGetterSetter(mt, "contrast", 0, bt(), Ie.afterSetFilter);
const Eit = function(e) {
  var t = this.embossStrength() * 10, i = this.embossWhiteLevel() * 255, n = this.embossDirection(), g = this.embossBlend(), r = 0, o = 0, I = e.data, s = e.width, a = e.height, d = s * 4, C = a;
  switch (n) {
    case "top-left":
      r = -1, o = -1;
      break;
    case "top":
      r = -1, o = 0;
      break;
    case "top-right":
      r = -1, o = 1;
      break;
    case "right":
      r = 0, o = 1;
      break;
    case "bottom-right":
      r = 1, o = 1;
      break;
    case "bottom":
      r = 1, o = 0;
      break;
    case "bottom-left":
      r = 1, o = -1;
      break;
    case "left":
      r = 0, o = -1;
      break;
    default:
      he.error("Unknown emboss direction: " + n);
  }
  do {
    var u = (C - 1) * d, A = r;
    C + A < 1 && (A = 0), C + A > a && (A = 0);
    var m = (C - 1 + A) * s * 4, h = s;
    do {
      var B = u + (h - 1) * 4, f = o;
      h + f < 1 && (f = 0), h + f > s && (f = 0);
      var G = m + (h - 1 + f) * 4, y = I[B] - I[G], W = I[B + 1] - I[G + 1], V = I[B + 2] - I[G + 2], w = y, v = w > 0 ? w : -w, H = W > 0 ? W : -W, x = V > 0 ? V : -V;
      if (H > v && (w = W), x > v && (w = V), w *= t, g) {
        var N = I[B] + w, M = I[B + 1] + w, $ = I[B + 2] + w;
        I[B] = N > 255 ? 255 : N < 0 ? 0 : N, I[B + 1] = M > 255 ? 255 : M < 0 ? 0 : M, I[B + 2] = $ > 255 ? 255 : $ < 0 ? 0 : $;
      } else {
        var q = i - w;
        q < 0 ? q = 0 : q > 255 && (q = 255), I[B] = I[B + 1] = I[B + 2] = q;
      }
    } while (--h);
  } while (--C);
};
Ie.addGetterSetter(mt, "embossStrength", 0.5, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "embossWhiteLevel", 0.5, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "embossDirection", "top-left", null, Ie.afterSetFilter);
Ie.addGetterSetter(mt, "embossBlend", !1, null, Ie.afterSetFilter);
function Tk(e, t, i, n, g) {
  var r = i - t, o = g - n, I;
  return r === 0 ? n + o / 2 : o === 0 ? n : (I = (e - t) / r, I = o * I + n, I);
}
const Nit = function(e) {
  var t = e.data, i = t.length, n = t[0], g = n, r, o = t[1], I = o, s, a = t[2], d = a, C, u, A = this.enhance();
  if (A !== 0) {
    for (u = 0; u < i; u += 4)
      r = t[u + 0], r < n ? n = r : r > g && (g = r), s = t[u + 1], s < o ? o = s : s > I && (I = s), C = t[u + 2], C < a ? a = C : C > d && (d = C);
    g === n && (g = 255, n = 0), I === o && (I = 255, o = 0), d === a && (d = 255, a = 0);
    var m, h, B, f, G, y, W, V, w;
    for (A > 0 ? (h = g + A * (255 - g), B = n - A * (n - 0), G = I + A * (255 - I), y = o - A * (o - 0), V = d + A * (255 - d), w = a - A * (a - 0)) : (m = (g + n) * 0.5, h = g + A * (g - m), B = n + A * (n - m), f = (I + o) * 0.5, G = I + A * (I - f), y = o + A * (o - f), W = (d + a) * 0.5, V = d + A * (d - W), w = a + A * (a - W)), u = 0; u < i; u += 4)
      t[u + 0] = Tk(t[u + 0], n, g, B, h), t[u + 1] = Tk(t[u + 1], o, I, y, G), t[u + 2] = Tk(t[u + 2], a, d, w, V);
  }
};
Ie.addGetterSetter(mt, "enhance", 0, bt(), Ie.afterSetFilter);
const Lit = function(e) {
  var t = e.data, i = t.length, n, g;
  for (n = 0; n < i; n += 4)
    g = 0.34 * t[n] + 0.5 * t[n + 1] + 0.16 * t[n + 2], t[n] = g, t[n + 1] = g, t[n + 2] = g;
};
Ie.addGetterSetter(mt, "hue", 0, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "saturation", 0, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "luminance", 0, bt(), Ie.afterSetFilter);
const Tit = function(e) {
  var t = e.data, i = t.length, n = 1, g = Math.pow(2, this.saturation()), r = Math.abs(this.hue() + 360) % 360, o = this.luminance() * 127, I, s = n * g * Math.cos(r * Math.PI / 180), a = n * g * Math.sin(r * Math.PI / 180), d = 0.299 * n + 0.701 * s + 0.167 * a, C = 0.587 * n - 0.587 * s + 0.33 * a, u = 0.114 * n - 0.114 * s - 0.497 * a, A = 0.299 * n - 0.299 * s - 0.328 * a, m = 0.587 * n + 0.413 * s + 0.035 * a, h = 0.114 * n - 0.114 * s + 0.293 * a, B = 0.299 * n - 0.3 * s + 1.25 * a, f = 0.587 * n - 0.586 * s - 1.05 * a, G = 0.114 * n + 0.886 * s - 0.2 * a, y, W, V, w;
  for (I = 0; I < i; I += 4)
    y = t[I + 0], W = t[I + 1], V = t[I + 2], w = t[I + 3], t[I + 0] = d * y + C * W + u * V + o, t[I + 1] = A * y + m * W + h * V + o, t[I + 2] = B * y + f * W + G * V + o, t[I + 3] = w;
}, Mit = function(e) {
  var t = e.data, i = t.length, n = Math.pow(2, this.value()), g = Math.pow(2, this.saturation()), r = Math.abs(this.hue() + 360) % 360, o, I = n * g * Math.cos(r * Math.PI / 180), s = n * g * Math.sin(r * Math.PI / 180), a = 0.299 * n + 0.701 * I + 0.167 * s, d = 0.587 * n - 0.587 * I + 0.33 * s, C = 0.114 * n - 0.114 * I - 0.497 * s, u = 0.299 * n - 0.299 * I - 0.328 * s, A = 0.587 * n + 0.413 * I + 0.035 * s, m = 0.114 * n - 0.114 * I + 0.293 * s, h = 0.299 * n - 0.3 * I + 1.25 * s, B = 0.587 * n - 0.586 * I - 1.05 * s, f = 0.114 * n + 0.886 * I - 0.2 * s, G, y, W, V;
  for (o = 0; o < i; o += 4)
    G = t[o + 0], y = t[o + 1], W = t[o + 2], V = t[o + 3], t[o + 0] = a * G + d * y + C * W, t[o + 1] = u * G + A * y + m * W, t[o + 2] = h * G + B * y + f * W, t[o + 3] = V;
};
Ie.addGetterSetter(mt, "hue", 0, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "saturation", 0, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "value", 0, bt(), Ie.afterSetFilter);
const Uit = function(e) {
  var t = e.data, i = t.length, n;
  for (n = 0; n < i; n += 4)
    t[n] = 255 - t[n], t[n + 1] = 255 - t[n + 1], t[n + 2] = 255 - t[n + 2];
};
var Pit = function(e, t, i) {
  var n = e.data, g = t.data, r = e.width, o = e.height, I = i.polarCenterX || r / 2, s = i.polarCenterY || o / 2, a, d, C, u = 0, A = 0, m = 0, h = 0, B, f = Math.sqrt(I * I + s * s);
  d = r - I, C = o - s, B = Math.sqrt(d * d + C * C), f = B > f ? B : f;
  var G = o, y = r, W, V, w = 360 / y * Math.PI / 180, v, H;
  for (V = 0; V < y; V += 1)
    for (v = Math.sin(V * w), H = Math.cos(V * w), W = 0; W < G; W += 1)
      d = Math.floor(I + f * W / G * H), C = Math.floor(s + f * W / G * v), a = (C * r + d) * 4, u = n[a + 0], A = n[a + 1], m = n[a + 2], h = n[a + 3], a = (V + W * r) * 4, g[a + 0] = u, g[a + 1] = A, g[a + 2] = m, g[a + 3] = h;
}, zit = function(e, t, i) {
  var n = e.data, g = t.data, r = e.width, o = e.height, I = i.polarCenterX || r / 2, s = i.polarCenterY || o / 2, a, d, C, u, A, m = 0, h = 0, B = 0, f = 0, G, y = Math.sqrt(I * I + s * s);
  d = r - I, C = o - s, G = Math.sqrt(d * d + C * C), y = G > y ? G : y;
  var W = o, V = r, w, v, H = 0, x, N;
  for (d = 0; d < r; d += 1)
    for (C = 0; C < o; C += 1)
      u = d - I, A = C - s, w = Math.sqrt(u * u + A * A) * W / y, v = (Math.atan2(A, u) * 180 / Math.PI + 360 + H) % 360, v = v * V / 360, x = Math.floor(v), N = Math.floor(w), a = (N * r + x) * 4, m = n[a + 0], h = n[a + 1], B = n[a + 2], f = n[a + 3], a = (C * r + d) * 4, g[a + 0] = m, g[a + 1] = h, g[a + 2] = B, g[a + 3] = f;
};
const Oit = function(e) {
  var t = e.width, i = e.height, n, g, r, o, I, s, a, d, C, u, A = Math.round(this.kaleidoscopePower()), m = Math.round(this.kaleidoscopeAngle()), h = Math.floor(t * (m % 360) / 360);
  if (!(A < 1)) {
    var B = he.createCanvasElement();
    B.width = t, B.height = i;
    var f = B.getContext("2d").getImageData(0, 0, t, i);
    he.releaseCanvas(B), Pit(e, f, {
      polarCenterX: t / 2,
      polarCenterY: i / 2
    });
    for (var G = t / Math.pow(2, A); G <= 8; )
      G = G * 2, A -= 1;
    G = Math.ceil(G);
    var y = G, W = 0, V = y, w = 1;
    for (h + G > t && (W = y, V = 0, w = -1), g = 0; g < i; g += 1)
      for (n = W; n !== V; n += w)
        r = Math.round(n + h) % t, C = (t * g + r) * 4, I = f.data[C + 0], s = f.data[C + 1], a = f.data[C + 2], d = f.data[C + 3], u = (t * g + n) * 4, f.data[u + 0] = I, f.data[u + 1] = s, f.data[u + 2] = a, f.data[u + 3] = d;
    for (g = 0; g < i; g += 1)
      for (y = Math.floor(G), o = 0; o < A; o += 1) {
        for (n = 0; n < y + 1; n += 1)
          C = (t * g + n) * 4, I = f.data[C + 0], s = f.data[C + 1], a = f.data[C + 2], d = f.data[C + 3], u = (t * g + y * 2 - n - 1) * 4, f.data[u + 0] = I, f.data[u + 1] = s, f.data[u + 2] = a, f.data[u + 3] = d;
        y *= 2;
      }
    zit(f, e, { polarRotation: 0 });
  }
};
Ie.addGetterSetter(mt, "kaleidoscopePower", 2, bt(), Ie.afterSetFilter);
Ie.addGetterSetter(mt, "kaleidoscopeAngle", 0, bt(), Ie.afterSetFilter);
function SW(e, t, i) {
  var n = (i * e.width + t) * 4, g = [];
  return g.push(e.data[n++], e.data[n++], e.data[n++], e.data[n++]), g;
}
function R0(e, t) {
  return Math.sqrt(Math.pow(e[0] - t[0], 2) + Math.pow(e[1] - t[1], 2) + Math.pow(e[2] - t[2], 2));
}
function Qit(e) {
  for (var t = [0, 0, 0], i = 0; i < e.length; i++)
    t[0] += e[i][0], t[1] += e[i][1], t[2] += e[i][2];
  return t[0] /= e.length, t[1] /= e.length, t[2] /= e.length, t;
}
function jit(e, t) {
  var i = SW(e, 0, 0), n = SW(e, e.width - 1, 0), g = SW(e, 0, e.height - 1), r = SW(e, e.width - 1, e.height - 1), o = t || 10;
  if (R0(i, n) < o && R0(n, r) < o && R0(r, g) < o && R0(g, i) < o) {
    for (var I = Qit([n, i, r, g]), s = [], a = 0; a < e.width * e.height; a++) {
      var d = R0(I, [
        e.data[a * 4],
        e.data[a * 4 + 1],
        e.data[a * 4 + 2]
      ]);
      s[a] = d < o ? 0 : 255;
    }
    return s;
  }
}
function _it(e, t) {
  for (var i = 0; i < e.width * e.height; i++)
    e.data[4 * i + 3] = t[i];
}
function $it(e, t, i) {
  for (var n = [1, 1, 1, 1, 0, 1, 1, 1, 1], g = Math.round(Math.sqrt(n.length)), r = Math.floor(g / 2), o = [], I = 0; I < i; I++)
    for (var s = 0; s < t; s++) {
      for (var a = I * t + s, d = 0, C = 0; C < g; C++)
        for (var u = 0; u < g; u++) {
          var A = I + C - r, m = s + u - r;
          if (A >= 0 && A < i && m >= 0 && m < t) {
            var h = A * t + m, B = n[C * g + u];
            d += e[h] * B;
          }
        }
      o[a] = d === 255 * 8 ? 255 : 0;
    }
  return o;
}
function qit(e, t, i) {
  for (var n = [1, 1, 1, 1, 1, 1, 1, 1, 1], g = Math.round(Math.sqrt(n.length)), r = Math.floor(g / 2), o = [], I = 0; I < i; I++)
    for (var s = 0; s < t; s++) {
      for (var a = I * t + s, d = 0, C = 0; C < g; C++)
        for (var u = 0; u < g; u++) {
          var A = I + C - r, m = s + u - r;
          if (A >= 0 && A < i && m >= 0 && m < t) {
            var h = A * t + m, B = n[C * g + u];
            d += e[h] * B;
          }
        }
      o[a] = d >= 255 * 4 ? 255 : 0;
    }
  return o;
}
function ent(e, t, i) {
  for (var n = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], g = Math.round(Math.sqrt(n.length)), r = Math.floor(g / 2), o = [], I = 0; I < i; I++)
    for (var s = 0; s < t; s++) {
      for (var a = I * t + s, d = 0, C = 0; C < g; C++)
        for (var u = 0; u < g; u++) {
          var A = I + C - r, m = s + u - r;
          if (A >= 0 && A < i && m >= 0 && m < t) {
            var h = A * t + m, B = n[C * g + u];
            d += e[h] * B;
          }
        }
      o[a] = d;
    }
  return o;
}
const tnt = function(e) {
  var t = this.threshold(), i = jit(e, t);
  return i && (i = $it(i, e.width, e.height), i = qit(i, e.width, e.height), i = ent(i, e.width, e.height), _it(e, i)), e;
};
Ie.addGetterSetter(mt, "threshold", 0, bt(), Ie.afterSetFilter);
const int = function(e) {
  var t = this.noise() * 255, i = e.data, n = i.length, g = t / 2, r;
  for (r = 0; r < n; r += 4)
    i[r + 0] += g - 2 * g * Math.random(), i[r + 1] += g - 2 * g * Math.random(), i[r + 2] += g - 2 * g * Math.random();
};
Ie.addGetterSetter(mt, "noise", 0.2, bt(), Ie.afterSetFilter);
const nnt = function(e) {
  var t = Math.ceil(this.pixelSize()), i = e.width, n = e.height, g, r, o, I, s, a, d, C = Math.ceil(i / t), u = Math.ceil(n / t), A, m, h, B, f, G, y, W = e.data;
  if (t <= 0) {
    he.error("pixelSize value can not be <= 0");
    return;
  }
  for (f = 0; f < C; f += 1)
    for (G = 0; G < u; G += 1) {
      for (I = 0, s = 0, a = 0, d = 0, A = f * t, m = A + t, h = G * t, B = h + t, y = 0, g = A; g < m; g += 1)
        if (!(g >= i))
          for (r = h; r < B; r += 1)
            r >= n || (o = (i * r + g) * 4, I += W[o + 0], s += W[o + 1], a += W[o + 2], d += W[o + 3], y += 1);
      for (I = I / y, s = s / y, a = a / y, d = d / y, g = A; g < m; g += 1)
        if (!(g >= i))
          for (r = h; r < B; r += 1)
            r >= n || (o = (i * r + g) * 4, W[o + 0] = I, W[o + 1] = s, W[o + 2] = a, W[o + 3] = d);
    }
};
Ie.addGetterSetter(mt, "pixelSize", 8, bt(), Ie.afterSetFilter);
const gnt = function(e) {
  var t = Math.round(this.levels() * 254) + 1, i = e.data, n = i.length, g = 255 / t, r;
  for (r = 0; r < n; r += 1)
    i[r] = Math.floor(i[r] / g) * g;
};
Ie.addGetterSetter(mt, "levels", 0.5, bt(), Ie.afterSetFilter);
const rnt = function(e) {
  var t = e.data, i = t.length, n = this.red(), g = this.green(), r = this.blue(), o, I;
  for (o = 0; o < i; o += 4)
    I = (0.34 * t[o] + 0.5 * t[o + 1] + 0.16 * t[o + 2]) / 255, t[o] = I * n, t[o + 1] = I * g, t[o + 2] = I * r, t[o + 3] = t[o + 3];
};
Ie.addGetterSetter(mt, "red", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
Ie.addGetterSetter(mt, "green", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
Ie.addGetterSetter(mt, "blue", 0, N7, Ie.afterSetFilter);
const ont = function(e) {
  var t = e.data, i = t.length, n = this.red(), g = this.green(), r = this.blue(), o = this.alpha(), I, s;
  for (I = 0; I < i; I += 4)
    s = 1 - o, t[I] = n * o + t[I] * s, t[I + 1] = g * o + t[I + 1] * s, t[I + 2] = r * o + t[I + 2] * s;
};
Ie.addGetterSetter(mt, "red", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
Ie.addGetterSetter(mt, "green", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
Ie.addGetterSetter(mt, "blue", 0, N7, Ie.afterSetFilter);
Ie.addGetterSetter(mt, "alpha", 1, function(e) {
  return this._filterUpToDate = !1, e > 1 ? 1 : e < 0 ? 0 : e;
});
const Int = function(e) {
  var t = e.data, i = t.length, n, g, r, o;
  for (n = 0; n < i; n += 4)
    g = t[n + 0], r = t[n + 1], o = t[n + 2], t[n + 0] = Math.min(255, g * 0.393 + r * 0.769 + o * 0.189), t[n + 1] = Math.min(255, g * 0.349 + r * 0.686 + o * 0.168), t[n + 2] = Math.min(255, g * 0.272 + r * 0.534 + o * 0.131);
}, lnt = function(e) {
  var t = e.data, i = e.width, n = e.height, g = i * 4, r = n;
  do {
    var o = (r - 1) * g, I = i;
    do {
      var s = o + (I - 1) * 4, a = t[s], d = t[s + 1], C = t[s + 2];
      a > 127 && (a = 255 - a), d > 127 && (d = 255 - d), C > 127 && (C = 255 - C), t[s] = a, t[s + 1] = d, t[s + 2] = C;
    } while (--I);
  } while (--r);
}, snt = function(e) {
  var t = this.threshold() * 255, i = e.data, n = i.length, g;
  for (g = 0; g < n; g += 1)
    i[g] = i[g] < t ? 0 : 255;
};
Ie.addGetterSetter(mt, "threshold", 0.5, bt(), Ie.afterSetFilter);
const gf = mT.Util._assign(mT, {
  Arc: Vc,
  Arrow: nA,
  Circle: mh,
  Ellipse: rC,
  Image: Sa,
  Label: KJ,
  Tag: gA,
  Line: wc,
  Path: wn,
  Rect: nf,
  RegularPolygon: rA,
  Ring: oA,
  Sprite: Va,
  Star: oC,
  Text: tg,
  TextPath: _g,
  Transformer: An,
  Wedge: vc,
  Filters: {
    Blur: Dit,
    Brighten: Jit,
    Contrast: Kit,
    Emboss: Eit,
    Enhance: Nit,
    Grayscale: Lit,
    HSL: Tit,
    HSV: Mit,
    Invert: Uit,
    Kaleidoscope: Oit,
    Mask: tnt,
    Noise: int,
    Pixelate: nnt,
    Posterize: gnt,
    RGB: rnt,
    RGBA: ont,
    Sepia: Int,
    Solarize: lnt,
    Threshold: snt
  }
});
var p8 = { exports: {} };
(function(e) {
  /*!mobile-detect v1.4.5 2021-03-13*/
  /*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
  (function(t, i) {
    t(function() {
      var n = {};
      n.mobileDetectRules = {
        phones: {
          iPhone: "\\biPhone\\b|\\biPod\\b",
          BlackBerry: "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
          Pixel: "; \\bPixel\\b",
          HTC: "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
          Nexus: "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
          Dell: "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
          Motorola: "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
          Samsung: "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
          LG: "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
          Sony: "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
          Asus: "Asus.*Galaxy|PadFone.*Mobile",
          Xiaomi: "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
          NokiaLumia: "Lumia [0-9]{3,4}",
          Micromax: "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
          Palm: "PalmSource|Palm",
          Vertu: "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
          Pantech: "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
          Fly: "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
          Wiko: "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
          iMobile: "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
          SimValley: "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
          Wolfgang: "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
          Alcatel: "Alcatel",
          Nintendo: "Nintendo (3DS|Switch)",
          Amoi: "Amoi",
          INQ: "INQ",
          OnePlus: "ONEPLUS",
          GenericPhone: "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
        },
        tablets: {
          iPad: "iPad|iPad.*Mobile",
          NexusTablet: "Android.*Nexus[\\s]+(7|9|10)",
          GoogleTablet: "Android.*Pixel C",
          SamsungTablet: "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
          Kindle: "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk/[0-9.]+ like Chrome/[0-9.]+ (?!Mobile)",
          SurfaceTablet: "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
          HPTablet: "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
          AsusTablet: "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
          BlackBerryTablet: "PlayBook|RIM Tablet",
          HTCtablet: "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
          MotorolaTablet: "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
          NookTablet: "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
          AcerTablet: "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
          ToshibaTablet: "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
          LGTablet: "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
          FujitsuTablet: "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
          PrestigioTablet: "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
          LenovoTablet: "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
          DellTablet: "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
          YarvikTablet: "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
          MedionTablet: "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
          ArnovaTablet: "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
          IntensoTablet: "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
          IRUTablet: "M702pro",
          MegafonTablet: "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
          EbodaTablet: "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
          AllViewTablet: "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
          ArchosTablet: "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
          AinolTablet: "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
          NokiaLumiaTablet: "Lumia 2520",
          SonyTablet: "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
          PhilipsTablet: "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
          CubeTablet: "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
          CobyTablet: "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
          MIDTablet: "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
          MSITablet: "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
          SMiTTablet: "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
          RockChipTablet: "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
          FlyTablet: "IQ310|Fly Vision",
          bqTablet: "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
          HuaweiTablet: "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
          NecTablet: "\\bN-06D|\\bN-08D",
          PantechTablet: "Pantech.*P4100",
          BronchoTablet: "Broncho.*(N701|N708|N802|a710)",
          VersusTablet: "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
          ZyncTablet: "z1000|Z99 2G|z930|z990|z909|Z919|z900",
          PositivoTablet: "TB07STA|TB10STA|TB07FTA|TB10FTA",
          NabiTablet: "Android.*\\bNabi",
          KoboTablet: "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
          DanewTablet: "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
          TexetTablet: "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
          PlaystationTablet: "Playstation.*(Portable|Vita)",
          TrekstorTablet: "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
          PyleAudioTablet: "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
          AdvanTablet: "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
          DanyTechTablet: "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
          GalapadTablet: "Android [0-9.]+; [a-z-]+; \\bG1\\b",
          MicromaxTablet: "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
          KarbonnTablet: "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
          AllFineTablet: "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
          PROSCANTablet: "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
          YONESTablet: "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
          ChangJiaTablet: "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
          GUTablet: "TX-A1301|TX-M9002|Q702|kf026",
          PointOfViewTablet: "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
          OvermaxTablet: "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
          HCLTablet: "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
          DPSTablet: "DPS Dream 9|DPS Dual 7",
          VistureTablet: "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
          CrestaTablet: "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
          MediatekTablet: "\\bMT8125|MT8389|MT8135|MT8377\\b",
          ConcordeTablet: "Concorde([ ]+)?Tab|ConCorde ReadMan",
          GoCleverTablet: "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
          ModecomTablet: "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
          VoninoTablet: "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
          ECSTablet: "V07OT2|TM105A|S10OT1|TR10CS1",
          StorexTablet: "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
          VodafoneTablet: "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
          EssentielBTablet: "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
          RossMoorTablet: "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
          iMobileTablet: "i-mobile i-note",
          TolinoTablet: "tolino tab [0-9.]+|tolino shine",
          AudioSonicTablet: "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
          AMPETablet: "Android.* A78 ",
          SkkTablet: "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
          TecnoTablet: "TECNO P9|TECNO DP8D",
          JXDTablet: "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
          iJoyTablet: "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
          FX2Tablet: "FX2 PAD7|FX2 PAD10",
          XoroTablet: "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
          ViewsonicTablet: "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
          VerizonTablet: "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
          OdysTablet: "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
          CaptivaTablet: "CAPTIVA PAD",
          IconbitTablet: "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
          TeclastTablet: "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
          OndaTablet: "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
          JaytechTablet: "TPC-PA762",
          BlaupunktTablet: "Endeavour 800NG|Endeavour 1010",
          DigmaTablet: "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
          EvolioTablet: "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
          LavaTablet: "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
          AocTablet: "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
          MpmanTablet: "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
          CelkonTablet: "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
          WolderTablet: "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
          MediacomTablet: "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
          MiTablet: "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
          NibiruTablet: "Nibiru M1|Nibiru Jupiter One",
          NexoTablet: "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
          LeaderTablet: "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
          UbislateTablet: "UbiSlate[\\s]?7C",
          PocketBookTablet: "Pocketbook",
          KocasoTablet: "\\b(TB-1207)\\b",
          HisenseTablet: "\\b(F5281|E2371)\\b",
          Hudl: "Hudl HT7S3|Hudl 2",
          TelstraTablet: "T-Hub2",
          GenericTablet: "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
        },
        oss: {
          AndroidOS: "Android",
          BlackBerryOS: "blackberry|\\bBB10\\b|rim tablet os",
          PalmOS: "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
          SymbianOS: "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
          WindowsMobileOS: "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
          WindowsPhoneOS: "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
          iOS: "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
          iPadOS: "CPU OS 13",
          SailfishOS: "Sailfish",
          MeeGoOS: "MeeGo",
          MaemoOS: "Maemo",
          JavaOS: "J2ME/|\\bMIDP\\b|\\bCLDC\\b",
          webOS: "webOS|hpwOS",
          badaOS: "\\bBada\\b",
          BREWOS: "BREW"
        },
        uas: {
          Chrome: "\\bCrMo\\b|CriOS|Android.*Chrome/[.0-9]* (Mobile)?",
          Dolfin: "\\bDolfin\\b",
          Opera: "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR/[0-9.]+$|Coast/[0-9.]+",
          Skyfire: "Skyfire",
          Edge: "\\bEdgiOS\\b|Mobile Safari/[.0-9]* Edge",
          IE: "IEMobile|MSIEMobile",
          Firefox: "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
          Bolt: "bolt",
          TeaShark: "teashark",
          Blazer: "Blazer",
          Safari: "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
          WeChat: "\\bMicroMessenger\\b",
          UCBrowser: "UC.*Browser|UCWEB",
          baiduboxapp: "baiduboxapp",
          baidubrowser: "baidubrowser",
          DiigoBrowser: "DiigoBrowser",
          Mercury: "\\bMercury\\b",
          ObigoBrowser: "Obigo",
          NetFront: "NF-Browser",
          GenericBrowser: "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
          PaleMoon: "Android.*PaleMoon|Mobile.*PaleMoon"
        },
        props: {
          Mobile: "Mobile/[VER]",
          Build: "Build/[VER]",
          Version: "Version/[VER]",
          VendorID: "VendorID/[VER]",
          iPad: "iPad.*CPU[a-z ]+[VER]",
          iPhone: "iPhone.*CPU[a-z ]+[VER]",
          iPod: "iPod.*CPU[a-z ]+[VER]",
          Kindle: "Kindle/[VER]",
          Chrome: [
            "Chrome/[VER]",
            "CriOS/[VER]",
            "CrMo/[VER]"
          ],
          Coast: [
            "Coast/[VER]"
          ],
          Dolfin: "Dolfin/[VER]",
          Firefox: [
            "Firefox/[VER]",
            "FxiOS/[VER]"
          ],
          Fennec: "Fennec/[VER]",
          Edge: "Edge/[VER]",
          IE: [
            "IEMobile/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident/[0-9.]+;.*rv:[VER]"
          ],
          NetFront: "NetFront/[VER]",
          NokiaBrowser: "NokiaBrowser/[VER]",
          Opera: [
            " OPR/[VER]",
            "Opera Mini/[VER]",
            "Version/[VER]"
          ],
          "Opera Mini": "Opera Mini/[VER]",
          "Opera Mobi": "Version/[VER]",
          UCBrowser: [
            "UCWEB[VER]",
            "UC.*Browser/[VER]"
          ],
          MQQBrowser: "MQQBrowser/[VER]",
          MicroMessenger: "MicroMessenger/[VER]",
          baiduboxapp: "baiduboxapp/[VER]",
          baidubrowser: "baidubrowser/[VER]",
          SamsungBrowser: "SamsungBrowser/[VER]",
          Iron: "Iron/[VER]",
          Safari: [
            "Version/[VER]",
            "Safari/[VER]"
          ],
          Skyfire: "Skyfire/[VER]",
          Tizen: "Tizen/[VER]",
          Webkit: "webkit[ /][VER]",
          PaleMoon: "PaleMoon/[VER]",
          SailfishBrowser: "SailfishBrowser/[VER]",
          Gecko: "Gecko/[VER]",
          Trident: "Trident/[VER]",
          Presto: "Presto/[VER]",
          Goanna: "Goanna/[VER]",
          iOS: " \\bi?OS\\b [VER][ ;]{1}",
          Android: "Android [VER]",
          Sailfish: "Sailfish [VER]",
          BlackBerry: [
            "BlackBerry[\\w]+/[VER]",
            "BlackBerry.*Version/[VER]",
            "Version/[VER]"
          ],
          BREW: "BREW [VER]",
          Java: "Java/[VER]",
          "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
          ],
          "Windows Phone": "Windows Phone [VER]",
          "Windows CE": "Windows CE/[VER]",
          "Windows NT": "Windows NT [VER]",
          Symbian: [
            "SymbianOS/[VER]",
            "Symbian/[VER]"
          ],
          webOS: [
            "webOS/[VER]",
            "hpwOS/[VER];"
          ]
        },
        utils: {
          Bot: "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
          MobileBot: "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker/M1A1-R2D2",
          DesktopMode: "WPDesktop",
          TV: "SonyDTV|HbbTV",
          WebKit: "(webkit)[ /]([\\w.]+)",
          Console: "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
          Watch: "SM-V700"
        }
      }, n.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
      };
      var g = Object.prototype.hasOwnProperty, r;
      n.FALLBACK_PHONE = "UnknownPhone", n.FALLBACK_TABLET = "UnknownTablet", n.FALLBACK_MOBILE = "UnknownMobile", r = "isArray" in Array ? Array.isArray : function(C) {
        return Object.prototype.toString.call(C) === "[object Array]";
      };
      function o(C, u) {
        return C != null && u != null && C.toLowerCase() === u.toLowerCase();
      }
      function I(C, u) {
        var A, m, h = C.length;
        if (!h || !u)
          return !1;
        for (A = u.toLowerCase(), m = 0; m < h; ++m)
          if (A === C[m].toLowerCase())
            return !0;
        return !1;
      }
      function s(C) {
        for (var u in C)
          g.call(C, u) && (C[u] = new RegExp(C[u], "i"));
      }
      function a(C) {
        return (C || "").substr(0, 500);
      }
      (function() {
        var u, A, m, h, B, f, G = n.mobileDetectRules;
        for (u in G.props)
          if (g.call(G.props, u)) {
            for (A = G.props[u], r(A) || (A = [A]), B = A.length, h = 0; h < B; ++h)
              m = A[h], f = m.indexOf("[VER]"), f >= 0 && (m = m.substring(0, f) + "([\\w._\\+]+)" + m.substring(f + 5)), A[h] = new RegExp(m, "i");
            G.props[u] = A;
          }
        s(G.oss), s(G.phones), s(G.tablets), s(G.uas), s(G.utils), G.oss0 = {
          WindowsPhoneOS: G.oss.WindowsPhoneOS,
          WindowsMobileOS: G.oss.WindowsMobileOS
        };
      })(), n.findMatch = function(C, u) {
        for (var A in C)
          if (g.call(C, A) && C[A].test(u))
            return A;
        return null;
      }, n.findMatches = function(C, u) {
        var A = [];
        for (var m in C)
          g.call(C, m) && C[m].test(u) && A.push(m);
        return A;
      }, n.getVersionStr = function(C, u) {
        var A = n.mobileDetectRules.props, m, h, B, f;
        if (g.call(A, C)) {
          for (m = A[C], B = m.length, h = 0; h < B; ++h)
            if (f = m[h].exec(u), f !== null)
              return f[1];
        }
        return null;
      }, n.getVersion = function(C, u) {
        var A = n.getVersionStr(C, u);
        return A ? n.prepareVersionNo(A) : NaN;
      }, n.prepareVersionNo = function(C) {
        var u;
        return u = C.split(/[a-z._ \/\-]/i), u.length === 1 && (C = u[0]), u.length > 1 && (C = u[0] + ".", u.shift(), C += u.join("")), Number(C);
      }, n.isMobileFallback = function(C) {
        return n.detectMobileBrowsers.fullPattern.test(C) || n.detectMobileBrowsers.shortPattern.test(C.substr(0, 4));
      }, n.isTabletFallback = function(C) {
        return n.detectMobileBrowsers.tabletPattern.test(C);
      }, n.prepareDetectionCache = function(C, u, A) {
        if (C.mobile === i) {
          var m, h, B;
          if (h = n.findMatch(n.mobileDetectRules.tablets, u), h) {
            C.mobile = C.tablet = h, C.phone = null;
            return;
          }
          if (m = n.findMatch(n.mobileDetectRules.phones, u), m) {
            C.mobile = C.phone = m, C.tablet = null;
            return;
          }
          n.isMobileFallback(u) ? (B = d.isPhoneSized(A), B === i ? (C.mobile = n.FALLBACK_MOBILE, C.tablet = C.phone = null) : B ? (C.mobile = C.phone = n.FALLBACK_PHONE, C.tablet = null) : (C.mobile = C.tablet = n.FALLBACK_TABLET, C.phone = null)) : n.isTabletFallback(u) ? (C.mobile = C.tablet = n.FALLBACK_TABLET, C.phone = null) : C.mobile = C.tablet = C.phone = null;
        }
      }, n.mobileGrade = function(C) {
        var u = C.mobile() !== null;
        return (
          // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
          C.os("iOS") && C.version("iPad") >= 4.3 || C.os("iOS") && C.version("iPhone") >= 3.1 || C.os("iOS") && C.version("iPod") >= 3.1 || // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
          // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
          // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
          // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
          C.version("Android") > 2.1 && C.is("Webkit") || // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
          C.version("Windows Phone OS") >= 7 || // Blackberry 7 - Tested on BlackBerry Torch 9810
          // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
          C.is("BlackBerry") && C.version("BlackBerry") >= 6 || // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
          C.match("Playbook.*Tablet") || // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
          C.version("webOS") >= 1.4 && C.match("Palm|Pre|Pixi") || // Palm WebOS 3.0  - Tested on HP TouchPad
          C.match("hp.*TouchPad") || // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
          C.is("Firefox") && C.version("Firefox") >= 12 || // Chrome for Android - Tested on Android 4.0, 4.1 device
          C.is("Chrome") && C.is("AndroidOS") && C.version("Android") >= 4 || // Skyfire 4.1 - Tested on Android 2.3 device
          C.is("Skyfire") && C.version("Skyfire") >= 4.1 && C.is("AndroidOS") && C.version("Android") >= 2.3 || // Opera Mobile 11.5-12: Tested on Android 2.3
          C.is("Opera") && C.version("Opera Mobi") > 11 && C.is("AndroidOS") || // Meego 1.2 - Tested on Nokia 950 and N9
          C.is("MeeGoOS") || // Tizen (pre-release) - Tested on early hardware
          C.is("Tizen") || // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
          // @todo: more tests here!
          C.is("Dolfin") && C.version("Bada") >= 2 || // UC Browser - Tested on Android 2.3 device
          (C.is("UC Browser") || C.is("Dolfin")) && C.version("Android") >= 2.3 || // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
          C.match("Kindle Fire") || C.is("Kindle") && C.version("Kindle") >= 3 || // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
          C.is("AndroidOS") && C.is("NookTablet") || // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
          C.version("Chrome") >= 11 && !u || // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
          C.version("Safari") >= 5 && !u || // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
          C.version("Firefox") >= 4 && !u || // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
          C.version("MSIE") >= 7 && !u || // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
          // @reference: http://my.opera.com/community/openweb/idopera/
          C.version("Opera") >= 10 && !u ? "A" : C.os("iOS") && C.version("iPad") < 4.3 || C.os("iOS") && C.version("iPhone") < 3.1 || C.os("iOS") && C.version("iPod") < 3.1 || // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
          C.is("Blackberry") && C.version("BlackBerry") >= 5 && C.version("BlackBerry") < 6 || //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
          C.version("Opera Mini") >= 5 && C.version("Opera Mini") <= 6.5 && (C.version("Android") >= 2.3 || C.is("iOS")) || // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
          C.match("NokiaN8|NokiaC7|N97.*Series60|Symbian/3") || // @todo: report this (tested on Nokia N71)
          C.version("Opera Mobi") >= 11 && C.is("SymbianOS") ? "B" : (
            // Blackberry 4.x - Tested on the Curve 8330
            (C.version("BlackBerry") < 5 || // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            C.match("MSIEMobile|Windows CE.*Mobile") || C.version("Windows Mobile") <= 5.2, "C")
          )
        );
      }, n.detectOS = function(C) {
        return n.findMatch(n.mobileDetectRules.oss0, C) || n.findMatch(n.mobileDetectRules.oss, C);
      }, n.getDeviceSmallerSide = function() {
        return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
      };
      function d(C, u) {
        this.ua = a(C), this._cache = {}, this.maxPhoneWidth = u || 600;
      }
      return d.prototype = {
        constructor: d,
        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function() {
          return n.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.mobile;
        },
        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function() {
          return n.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.phone;
        },
        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function() {
          return n.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.tablet;
        },
        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function() {
          return this._cache.userAgent === i && (this._cache.userAgent = n.findMatch(n.mobileDetectRules.uas, this.ua)), this._cache.userAgent;
        },
        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function() {
          return this._cache.userAgents === i && (this._cache.userAgents = n.findMatches(n.mobileDetectRules.uas, this.ua)), this._cache.userAgents;
        },
        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function() {
          return this._cache.os === i && (this._cache.os = n.detectOS(this.ua)), this._cache.os;
        },
        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function(C) {
          return n.getVersion(C, this.ua);
        },
        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function(C) {
          return n.getVersionStr(C, this.ua);
        },
        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function(C) {
          return I(this.userAgents(), C) || o(C, this.os()) || o(C, this.phone()) || o(C, this.tablet()) || I(n.findMatches(n.mobileDetectRules.utils, this.ua), C);
        },
        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function(C) {
          return C instanceof RegExp || (C = new RegExp(C, "i")), C.test(this.ua);
        },
        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function(C) {
          return d.isPhoneSized(C || this.maxPhoneWidth);
        },
        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function() {
          return this._cache.grade === i && (this._cache.grade = n.mobileGrade(this)), this._cache.grade;
        }
      }, typeof window < "u" && window.screen ? d.isPhoneSized = function(C) {
        return C < 0 ? i : n.getDeviceSmallerSide() <= C;
      } : d.isPhoneSized = function() {
      }, d._impl = n, d.version = "1.4.5 2021-03-13", d;
    });
  })(function(t) {
    if (e.exports)
      return function(i) {
        e.exports = i();
      };
    if (typeof window < "u")
      return function(i) {
        window.MobileDetect = i();
      };
    throw new Error("unknown environment");
  }());
})(p8);
var ant = p8.exports;
const B8 = /* @__PURE__ */ Tr(ant), cnt = () => {
  const e = _(U$e), t = N4("(min-width: 0) and (max-width: 480px)");
  return e === "phone" || t;
}, EJ = () => {
  var e;
  return !!((e = new B8(window.navigator.userAgent).mobile()) != null && e.length);
}, IA = () => cnt() || EJ();
function NJ(e, t) {
  return t.findOne((i) => i.attrs.name === e);
}
const dnt = (e, t, i) => {
  const n = EJ();
  let g = e ?? (n ? 256 : 1024), r = t ?? (n ? 256 : 1024);
  const o = Math.min(g, r);
  if (o < 200) {
    const a = Math.ceil(200 / o);
    g *= a, r *= a;
  }
  const I = 2048, s = Math.max(g, r);
  if (s > I) {
    const a = s / I;
    g /= a, r /= a;
  }
  try {
    const a = new gf.Stage({
      container: i,
      width: g,
      height: r,
      scale: {
        x: 1,
        y: 1
      }
    });
    return a.listening(!1), a;
  } catch {
    throw new Error("Print-Designer Error: Out-of-memory in Safari?");
  }
}, ST = "print-layer", VT = "print-image", wT = "original-image", vT = "background";
function Cnt(e) {
  var i;
  let t = (i = e == null ? void 0 : e.getLayers()) == null ? void 0 : i.find((n) => n.attrs.name === ST);
  if (!t) {
    t = new gf.Layer({
      name: ST,
      imageSmoothingEnabled: !0
    });
    {
      const n = t.getCanvas(), g = Math.min(1.5, n.getPixelRatio());
      n.setPixelRatio(g);
    }
    e.add(t);
  }
  return t.listening(!1), t;
}
function RT(e, t, i) {
  return i < 0 ? t * (i / 100) : i > 100 ? Math.abs(e - t) + t * (i - 100) / 100 : Math.abs(e - t) * (i / 100);
}
function unt(e, t, i, n, g, r, o) {
  const I = i / e, s = n / t, a = Math.min(I, s), d = Math.abs(Math.round(e * a * (o || 1) / 100)), C = Math.abs(Math.round(d * t / e)), u = Math.round(RT(i, d, g)), A = Math.round(RT(n, C, r));
  return {
    stageWidth: i,
    stageHeight: n,
    x: u,
    y: A,
    newImageWidth: d,
    newImageHeight: C
  };
}
function Ant(e, t, i, n) {
  const g = i.width(), r = i.height();
  return unt(e, t, g, r, n.leftright, n.topbottom, n.scale);
}
function bnt(e, t, i, n) {
  if (t != null && t.color) {
    const g = NJ(vT, e);
    if (g)
      g.fill("#" + t.color.getHexString());
    else {
      const r = new gf.Rect({
        name: vT,
        x: 0,
        y: 0,
        width: i,
        height: n,
        fill: "#" + t.color.getHexString(),
        listening: !1
      });
      e.add(r);
    }
  }
}
function mnt(e, t, i, n) {
  if (!t.map)
    return;
  const g = NJ(wT, e);
  if (g)
    g.attrs.uuid !== t.map.image.uuid && g.image(t.map.image), g.width(i), g.height(n);
  else {
    const r = new gf.Image({
      name: wT,
      image: t.map.image,
      uuid: t.map.image.uuid,
      x: 0,
      y: 0,
      width: i,
      height: n
    });
    e.add(r);
  }
}
function hnt(e, t, i, n, g, r, o) {
  const I = NJ(VT, e), s = i / o.width, a = n / o.height;
  if (I && I.attrs.url === t.materialUrl)
    I.scaleX(s), I.scaleY(a), I.x(g), I.y(r);
  else {
    I && I.destroy();
    const d = new gf.Image({
      name: VT,
      url: t.materialUrl,
      image: o,
      x: g,
      y: r,
      width: o.width,
      height: o.height,
      scaleX: s,
      scaleY: a,
      draggable: !1,
      perfectDrawEnabled: !1
    });
    e.add(d);
  }
}
const pnt = (e, t, i, n) => {
  var C;
  const g = Cnt(e), {
    stageWidth: r,
    stageHeight: o,
    x: I,
    y: s,
    newImageWidth: a,
    newImageHeight: d
  } = Ant(t.width, t.height, e, i);
  bnt(g, n, r, o), (C = n == null ? void 0 : n.map) != null && C.image && !i.hideOriginalMapWhenPrinting && mnt(g, n, r, o), hnt(g, i, a, d, I, s, t), g.draw(), e.draw();
};
function Bnt(e, t) {
  return (e.selections ?? []).every((i) => (t.selectionScope[i.variableId] ?? []).find((n) => n.id === i.id));
}
function Znt(e, t) {
  return e.reduce((n, g) => {
    const r = ce.intersection(t.selections, g.selections).length;
    return r > n.maxIntersectionCount ? {
      maxIntersectionCount: r,
      action: g
    } : n;
  }, {
    maxIntersectionCount: -1,
    action: e[0]
  }).action;
}
function LJ(e, t, i) {
  let n = e.filter((o) => Bnt(t, o));
  const g = Object.values(ce.groupBy(n, i));
  return g.some((o) => o.length > 1) && (n = g.map((o) => o.length === 1 ? o[0] : Znt(o, t))), n;
}
function fnt(e, t, i, n, g, r) {
  et(() => {
    (async () => {
      const I = r ? await Gnt(t, i, n, g) : i;
      e(I);
    })();
  }, [t, i, g, r, n, e]);
}
async function Gnt(e, t, i, n) {
  if (!n)
    return Promise.resolve(t);
  const g = LJ(i, n, (I) => I.targetMaterial), r = Object.values(t);
  return await Promise.all(g.map(async (I) => {
    const s = r.find((d) => d.name === I.targetMaterial);
    return s ? await Wnt(n, e[I.targetMaterial], s, I) : Promise.resolve(void 0);
  }, [])).then((I) => I.reduce((s, a) => ({
    ...s,
    ...a ?? {}
  }), {}) ?? {});
}
const Wu = /* @__PURE__ */ new Map(), sx = "konvaRoot", ynt = () => {
  const e = document.getElementById(sx);
  return e == null ? void 0 : e.childNodes;
};
async function Wnt(e, t, i, n) {
  var r, o, I, s;
  const g = i;
  if (n && n.materialUrl && g) {
    const a = new Image();
    a.crossOrigin = "anonymous", a.src = kJ(n.materialUrl), await a.decode();
    const d = `imageAction:${e.unique}-${i.name}`;
    let C = document.getElementById(sx);
    C || (C = document.createElement("div"), C.id = sx, document.body.appendChild(C));
    let u = document.getElementById(d);
    if (!u) {
      u = document.createElement("div"), u.id = d, u.style.display = "none", u.dataset.materialName = i.name, u.dataset.modelId = e.modelId.toString(), C.appendChild(u);
      const G = Wu.get(d);
      G && (Wu.delete(d), G.destroy());
    }
    let A = Wu.get(d);
    A || (A = dnt(((r = t.map) == null ? void 0 : r.image.width) ?? a.width, ((o = t.map) == null ? void 0 : o.image.height) ?? a.height, u), Wu.set(d, A)), pnt(A, a, n, g);
    const m = new dc.MeshStandardMaterial({}).copy(i), h = (I = u.firstElementChild) == null ? void 0 : I.firstElementChild, B = new dc.CanvasTexture(h, dc.UVMapping);
    return B.flipY = !1, B.colorSpace = (s = i.map) != null && s.colorSpace ? i.map.colorSpace : "srgb", m.color = new dc.Color(1, 1, 1), m.map = B, B.needsUpdate = !0, m.needsUpdate = !0, {
      [i.name]: m
    };
  }
}
const Snt = (e) => (e == null ? void 0 : e.isGlobalChange) === !0 && (e == null ? void 0 : e.replacementMaterialId) !== void 0 && (e == null ? void 0 : e.targetMaterialName) !== void 0, Mk = (e) => (e == null ? void 0 : e.targetModelId) !== void 0 && (e == null ? void 0 : e.replacementMaterialId) !== void 0 && (e == null ? void 0 : e.targetMaterialName) !== void 0;
function Vnt(e, t) {
  var g, r;
  const i = (g = e.props.textures) == null ? void 0 : g.find((o) => o.uuid === t), n = (r = e.props.images) == null ? void 0 : r.find((o) => o.uuid === i.image);
  return {
    texture: i,
    image: n
  };
}
async function ax(e) {
  const t = new dc.MaterialLoader(), i = new dc.TextureLoader(), n = new dc.ObjectLoader(), g = uc.pick(e.props, ["alphaMap", "aoMap", "bumpMap", "clearcoatMap", "clearcoatNormalMap", "clearcoatRoughnessMap", "sheenRoughnessMap", "sheenColorMap", "displacementMap", "emissiveMap", "envMap", "lightMap", "map", "metalnessMap", "normalMap", "specularIntensityMap", "specularColorMap", "roughnessMap", "thicknessMap", "transmissionMap"]), r = uc.omit(e.props, Object.keys(g));
  r.userData = {
    ...r.userData,
    arFallbackId: e.arFallbackId
  };
  const o = t.parse(r);
  return uc.isEmpty(g) || await Promise.all(uc.map(g, async (I, s) => {
    const {
      texture: a,
      image: d
    } = Vnt(e, I);
    return d.url ? i.loadAsync(kJ(d.url)).then((C) => {
      o[s] = n.parseTextures([a], {
        [a.image]: C.source
        // @ts-ignore
      })[a.uuid];
    }).catch(() => {
      console.warn(`Could not load texture: ${s} for material ${e.name} with id ${e.id}!`);
    }) : Promise.resolve();
  })), o;
}
function wnt(e, t, i, n, g) {
  const r = Ni(Object.values(i)), o = me.indexBy((a) => a.name, Object.values(g)), s = (t ? LJ(
    // We have to prefilter the materialActions to only include the ones that
    // actually refer to the current model or are global anyway. Color- and
    // PrintActions do not work like that currently.
    n.filter((a) => Mk(a) ? a.targetModelId === e : !0),
    t,
    (a) => a.targetMaterialName
  ) : n).reduce((a, d) => {
    var m, h;
    const C = d.targetMaterialName && o[d.targetMaterialName];
    if (!C || !d.replacementMaterialId)
      return a;
    let u = !1;
    if (Mk(d) && d.targetModelId === e) {
      const B = (m = a[C.name]) == null ? void 0 : m.materialAction;
      Mk(B) || (u = !0);
    }
    Snt(d) && ((h = a[C.name]) != null && h.materialAction || (u = !0));
    const A = r[d.replacementMaterialId];
    return A ? u ? {
      ...a,
      [C.name]: {
        materialAction: d,
        targetMeshMaterial: C,
        replacementMaterial: A
      }
    } : a : (console.warn(`Replacement material with id ${d.replacementMaterialId} not found!`), a);
  }, {});
  return Object.values(s);
}
async function vnt(e, t, i = {}, n, g = []) {
  const r = wnt(e, t, n, g, i);
  return (await Promise.all(r.map(async (I) => {
    const s = I.targetMeshMaterial, a = da({
      props: {
        name: s.name
      }
    })(I.replacementMaterial), d = await ax(a);
    return {
      [s.name]: d
    };
  }))).reduce((I, s) => ({
    ...I,
    ...s
  }), {});
}
function Rnt(e, t, i, n, g, r) {
  et(() => {
    (async () => {
      const o = t ? await vnt(t, i, e, n, g) : e;
      r({
        ...e,
        ...o
      });
    })();
  }, [i, e, g, n, r, t]);
}
function Xnt(e, t, i) {
  const n = {}, g = i ? LJ(t, i, (r) => r.targetMaterial) : t;
  return t && g.reduce((r, o) => {
    const I = e[o.targetMaterial];
    if (!I)
      return r;
    const s = new dc.Color(o.hex), a = I.clone();
    return a.color = s, a.needsUpdate = !0, r[I.name] = a, r;
  }, n), n;
}
function Hnt(e, t, i) {
  return je(() => Xnt(e, t, i), [t, i, e]);
}
const knt = [];
function Z8(e, t, i) {
  const n = je(() => e.reduce((B, f) => (B[f.name] = f, B), {}), [e]), g = _(QZ), r = _(Gj), o = _(fj), I = _(ND), [s, a] = At({}), [d, C] = At({});
  Rnt(n, t, i, g, r, a);
  const u = je(() => ({
    ...n,
    ...s
  }), [n, s]), A = Hnt(u, o, i), m = je(() => ({
    ...n,
    ...s,
    ...A
  }), [n, s, A]);
  return fnt(C, n, m, I, i, t), {
    materials: {
      ...n,
      ...s,
      ...A,
      ...d
    },
    printAreas: knt
  };
}
function Fnt(e, t, i, n) {
  const {
    materials: g
  } = Z8(t, e, n);
  return Object.values(g).forEach((r) => {
    r.needsUpdate = !0;
  }), g;
}
const Ynt = "data:image/png;base64,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", f8 = ({
  children: e,
  ...t
}) => /* @__PURE__ */ p(Ne, { ...t, color: "text.secondary", sx: {
  mb: 0
}, children: e });
var TJ = {}, xnt = Cg;
Object.defineProperty(TJ, "__esModule", {
  value: !0
});
var G8 = TJ.default = void 0, Dnt = xnt(Kg()), Jnt = xg;
G8 = TJ.default = (0, Dnt.default)(/* @__PURE__ */ (0, Jnt.jsx)("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");
var MJ = {}, Knt = Cg;
Object.defineProperty(MJ, "__esModule", {
  value: !0
});
var y8 = MJ.default = void 0, Ent = Knt(Kg()), Nnt = xg;
y8 = MJ.default = (0, Ent.default)(/* @__PURE__ */ (0, Nnt.jsx)("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"
}), "Folder");
const Lnt = ({
  label: e,
  onDelete: t,
  Icon: i
}) => /* @__PURE__ */ ge(oD, { secondaryAction: t && /* @__PURE__ */ p(mi, { "data-cy": "deleteListItem", edge: "end", onClick: t, children: /* @__PURE__ */ p(G8, {}) }), children: [
  /* @__PURE__ */ p(Nme, { children: /* @__PURE__ */ p(bue, { children: i || /* @__PURE__ */ p(y8, {}) }) }),
  /* @__PURE__ */ p(ID, { primary: e })
] }), Tnt = ({
  entities: e,
  name: t,
  editable: i = !0,
  onChange: n,
  onCreate: g,
  onDelete: r,
  getLabel: o,
  buttonLabel: I,
  placeholder: s,
  errors: a,
  Icon: d
}) => /* @__PURE__ */ ge(_t, { direction: "column", spacing: 1, children: [
  i && /* @__PURE__ */ ge(_t, { direction: "row", spacing: 2, sx: {
    width: 1,
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ p($n, { "data-cy": "addListItem", fullWidth: !0, value: t, onChange: n, placeholder: s, TextFieldProps: {
      error: a !== void 0 && a.length > 0,
      helperText: a == null ? void 0 : a.join(", ")
    } }),
    /* @__PURE__ */ p(Si, { "data-cy": "addListItemButton", sx: {
      maxHeight: "56px"
    }, onClick: () => g(), disabled: t === "" || a !== void 0, variant: "contained", children: I })
  ] }),
  /* @__PURE__ */ p(PB, { children: e.map((C) => {
    const u = o(C);
    return /* @__PURE__ */ p(Lnt, { label: u, onDelete: i ? () => r(C) : void 0, Icon: d }, u);
  }) })
] }), W8 = Vg({
  name: "models",
  initialState: [],
  reducers: {
    createModel: (e, t) => [...e, t.payload],
    deleteModel: (e, t) => e.filter((i) => i.id !== t.payload),
    setModels: (e, t) => t.payload,
    updateModel: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i)
  }
}), {
  createModel: PKt,
  deleteModel: zKt,
  setModels: S8,
  updateModel: Mnt
} = W8.actions, Unt = W8.reducer, cx = (e) => async (t, i) => (t(Mnt(e)), Q1("model", e, {
  lang: ng(i())
})), Pnt = ({
  model: e,
  editable: t = !0
}) => {
  const {
    t: i
  } = ii(), n = zt(), [g, r] = At(""), [o, I] = At(void 0), s = ft((C) => {
    var u;
    r(C), (u = e == null ? void 0 : e.materials) != null && u.find((A) => A.toLowerCase() === C.toLowerCase()) ? I([i("Dieses Material existiert bereits")]) : I(void 0);
  }, [e, i]), a = ft(() => {
    e && n(cx({
      ...e,
      materials: [...e.materials ?? [], g]
    })), r("");
  }, [g, e, n]), d = ft((C) => {
    e && n(cx({
      ...e,
      materials: (e.materials ?? []).filter((u) => u !== C)
    }));
  }, [e, n]);
  return /* @__PURE__ */ ge(_t, { direction: "column", spacing: 2, children: [
    /* @__PURE__ */ p(f8, { children: i("Materialien") }),
    /* @__PURE__ */ p(Tnt, { name: g, editable: t, entities: (e == null ? void 0 : e.materials) ?? [], onChange: s, onCreate: a, onDelete: d, getLabel: ce.identity, buttonLabel: i("Material hinzufügen"), placeholder: i("Materialname eingeben"), errors: o, Icon: /* @__PURE__ */ p(d6e, {}) })
  ] });
}, tl = {
  input: {
    width: "33%"
  },
  x: {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px"
  },
  y: {
    borderRadius: 0
  },
  z: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px"
  }
}, Ub = (e) => pc(e) && "expression" in e ? e.expression ?? "" : String(e);
function pB({
  label: e,
  inputLabels: t = ["X", "Y", "Z"],
  placeholders: i = ["X", "Y", "Z"],
  defaultValues: n,
  onChange: g,
  sx: r,
  debounced: o = !1,
  expression: I = !1,
  anchoringSelections: s = [Dt]
}) {
  const [a, d] = At([n ? n[0] : "0", n ? n[1] : "0", n ? n[2] : "0"]), C = ft((...h) => {
    d((B) => {
      const f = B.map((G, y) => h[y] || G || "0");
      return g && g(f), f;
    });
  }, [g]), u = (h) => C({
    expression: h
  }, a[1], a[2]), A = (h) => C(a[0], {
    expression: h
  }, a[2]), m = (h) => C(a[0], a[1], {
    expression: h
  });
  return /* @__PURE__ */ ge(fe, { component: "div", sx: r, children: [
    /* @__PURE__ */ p(Ne, { color: "text.secondary", sx: {
      mb: 0
    }, children: e }),
    /* @__PURE__ */ p(fe, { component: "div", display: "flex", children: I ? /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p(BI, { label: "X", sx: {
        ...tl.input,
        ...tl.x
      }, value: Ub(a[0]), onChange: u, anchoringSelections: s }),
      /* @__PURE__ */ p(BI, { label: "Y", sx: {
        ...tl.input,
        ...tl.y
      }, value: Ub(a[1]), onChange: A, anchoringSelections: s }),
      /* @__PURE__ */ p(BI, { label: "Z", sx: {
        ...tl.input,
        ...tl.z
      }, value: Ub(a[2]), onChange: m, anchoringSelections: s })
    ] }) : /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p(fe, { component: "div", sx: tl.input, children: /* @__PURE__ */ p($n, { "data-cy": "vectorX", debounced: o, value: Ub(a[0]), onChange: u, type: "number", placeholder: i[0], label: t[0], TextFieldProps: {
        InputProps: {
          sx: tl.x
        },
        inputProps: {
          step: "0.1"
        }
      } }) }),
      /* @__PURE__ */ p(fe, { component: "div", sx: tl.input, children: /* @__PURE__ */ p($n, { "data-cy": "vectorY", debounced: o, value: Ub(a[1]), onChange: A, type: "number", placeholder: i[1], label: t[1], TextFieldProps: {
        InputProps: {
          sx: tl.y
        },
        inputProps: {
          step: "0.1"
        }
      } }) }),
      /* @__PURE__ */ p(fe, { component: "div", sx: tl.input, children: /* @__PURE__ */ p($n, { "data-cy": "vectorZ", debounced: o, value: Ub(a[2]), onChange: m, type: "number", placeholder: i[2], label: t[2], TextFieldProps: {
        InputProps: {
          sx: tl.z
        },
        inputProps: {
          step: "0.1"
        }
      } }) })
    ] }) })
  ] });
}
const V8 = ({
  modelActionRuleItemValue: e,
  model: t,
  onChange: i,
  ruleItem: n,
  ruleColumnId: g
}) => {
  const {
    t: r
  } = ii(), o = (C, u) => {
    var A, m, h;
    return (A = e == null ? void 0 : e.props) != null && A[C] ? (m = e.props) == null ? void 0 : m[C] : t && "props" in t && ((h = t.props) != null && h[C]) ? t.props[C] : u || [0, 0, 0];
  }, I = o("position"), s = o("rotation"), a = o("scale", [1, 1, 1]), d = _(KZ(n == null ? void 0 : n.id, g));
  return /* @__PURE__ */ ge(_t, { direction: "column", spacing: 2, children: [
    /* @__PURE__ */ p(pB, { debounced: !0, defaultValues: I, label: r("Position"), onChange: i("position"), expression: !0, anchoringSelections: d }),
    /* @__PURE__ */ p(pB, { debounced: !0, defaultValues: s, label: r("Rotation (in radiant)"), onChange: i("rotation"), expression: !0, anchoringSelections: d }),
    /* @__PURE__ */ p(pB, { debounced: !0, defaultValues: a, label: r("Scale"), onChange: i("scale"), expression: !0, anchoringSelections: d })
  ] });
}, znt = ({
  widthExpression: e,
  heightExpression: t,
  depthExpression: i,
  expressionChange: n,
  ruleItem: g,
  ruleColumnId: r
}) => {
  const {
    t: o
  } = ii(), I = _(KZ(g == null ? void 0 : g.id, r));
  return /* @__PURE__ */ ge(_t, { direction: "column", spacing: 2, children: [
    /* @__PURE__ */ p(f8, { children: o("Abmessungen") }),
    /* @__PURE__ */ p(BI, { value: e.expression, onChange: n("width"), label: o("Breite"), anchoringSelections: I }),
    /* @__PURE__ */ p(BI, { value: t.expression, onChange: n("height"), label: o("Höhe"), anchoringSelections: I }),
    /* @__PURE__ */ p(BI, { value: i.expression, onChange: n("depth"), label: o("Tiefe"), anchoringSelections: I })
  ] });
}, Ont = ({
  modelActionRuleItemValue: e,
  model: t,
  onChange: i,
  widthExpression: n,
  heightExpression: g,
  depthExpression: r,
  expressionChange: o,
  ruleItem: I,
  ruleColumnId: s
}) => /* @__PURE__ */ ge(_t, { direction: "column", spacing: 4, children: [
  /* @__PURE__ */ p(V8, { modelActionRuleItemValue: e, model: t, onChange: i, ruleItem: I, ruleColumnId: s }),
  /* @__PURE__ */ p(znt, { widthExpression: n, heightExpression: g, depthExpression: r, expressionChange: o, ruleItem: I, ruleColumnId: s })
] }), w8 = ({
  dynamicModelProps: e,
  expressionChange: t,
  model: i,
  modelActionRuleItemValue: n,
  onChange: g,
  ruleItem: r,
  ruleColumnId: o,
  materialsAreEditable: I = !1,
  extraFields: s
}) => /* @__PURE__ */ ge(_t, { direction: "column", spacing: 4, children: [
  /* @__PURE__ */ p(Ont, { modelActionRuleItemValue: n, model: i, onChange: g, widthExpression: e.width, heightExpression: e.height, depthExpression: e.depth, expressionChange: t, ruleItem: r, ruleColumnId: o }),
  s,
  /* @__PURE__ */ p(Pnt, { model: i, editable: I })
] }), Qnt = (e, t, i) => {
  const n = e.clone().sub(t), g = [];
  return Math.abs(n.x) > i && g.push("x"), Math.abs(n.y) > i && g.push("y"), Math.abs(n.z) > i && g.push("z"), g;
}, jnt = (e) => (t, i) => (n, g, r) => {
  const o = r || (n === "rotation" ? 0.05 : 1e-4), I = Qnt(new xt(...t[n] || [0, 0, 0]), new xt(...g), o);
  if (!I.length)
    return e === "expression" ? i[n] : t[n];
  const s = e === "expression" ? [{
    expression: "0"
  }, {
    expression: "0"
  }, {
    expression: "0"
  }] : [0, 0, 0], a = e === "expression" ? [...i[n] || s] : [...t[n] || s];
  return "xyz".split("").forEach((d, C) => {
    I.includes(d) && (a[C] = e === "expression" ? {
      expression: g[C].toString()
    } : g[C]);
  }), a;
}, nZ = (e) => (t, i) => (n, g) => {
  const r = jnt(e)(t, i);
  return {
    ...e === "number" ? t : i,
    position: r("position", n),
    rotation: r("rotation", g)
  };
}, _nt = (e) => {
  var n;
  const {
    t
  } = ii(), i = _(KZ((n = e.ruleItem) == null ? void 0 : n.id, e.ruleColumnId));
  return /* @__PURE__ */ p(w8, { ...e, materialsAreEditable: !0, extraFields: /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(BI, { value: e.dynamicModelProps.radius.expression, onChange: e.expressionChange("radius"), label: t("Eckenrundung"), anchoringSelections: i }),
    /* @__PURE__ */ p(BI, { value: e.dynamicModelProps.segmentCount.expression, onChange: e.expressionChange("segmentCount"), label: t("Anzahl der Eckenrundungsschritte"), anchoringSelections: i })
  ] }) });
}, $nt = (e) => {
  var r;
  const t = e.id, i = _(p$e(t)), n = je(() => {
    var o;
    return ((o = i.materials) == null ? void 0 : o.map((I) => new Jz({
      name: I,
      color: "grey"
    }))) ?? [];
  }, [i.materials]), g = Fnt(t, n, [], e.modelAction);
  return /* @__PURE__ */ p(Sge, { args: [e.width, e.height, e.depth], rotation: e.rotation, scale: e.scale, position: e.position, name: e.name, matrixWorldAutoUpdate: void 0, getObjectsByProperty: void 0, getVertexPosition: void 0, userData: {
    modelId: t
  }, material: (r = Object.values(g)) == null ? void 0 : r[0], radius: e.radius, smoothness: e.segmentCount || 1, steps: e.segmentCount || 1 });
}, qnt = {
  type: "box",
  label: "Box",
  disabledForAR: !1,
  component: $nt,
  propsDialog: _nt,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    },
    radius: {
      expression: "0"
    },
    segmentCount: {
      expression: "1"
    }
  },
  materials: ["surface"],
  repositionApplicator: nZ,
  screenshot: Ynt
};
function egt(e) {
  const t = (n) => n;
  return {
    ...{
      extendAdditionalGroups: t,
      extendAdditionalVars: t,
      extendGroupLabel: t,
      extendGroupPanel: t,
      extendHeader: t,
      extendVariableLabel: t,
      components: {
        select: (n) => (g) => /* @__PURE__ */ p(n, { ...g })
      }
    },
    ...e
  };
}
const tgt = ce.memoize(egt), UJ = (e, t = "") => Object.keys(e).reduce((i, n) => {
  const g = t.length ? `${t}.` : "";
  return typeof e[n] == "object" && e[n] !== null && Object.keys(e[n]).length > 0 ? Object.assign(i, UJ(e[n], g + n)) : i[g + n] = e[n], i;
}, {}), hs = Se.createContext({}), igt = (e) => ({
  extensions: t,
  ...i
}) => {
  const n = tgt(t);
  return /* @__PURE__ */ p(hs.Provider, { value: n, children: /* @__PURE__ */ p(e, { ...i, extensions: t }) });
}, ngt = (e, t) => me.flow(UJ, ZD((i, n, g) => {
  const r = me.flow(me.split("."), me.last)(g);
  return me.set(["components", r], n, i);
}, {}), me.merge(e))(t), ki = (e) => {
  const t = me.flow(UJ, me.keys)(e), i = me.filter(me.endsWith("root"), t);
  if (i.length > 1)
    throw new Error("There should only be one root HOC!");
  const n = me.first(i), g = me.reject(me.endsWith("root"), t);
  return v8(n, g);
}, no = (e) => v8(`components.${e}`, []), v8 = (e, t) => (i) => Se.forwardRef((n, g) => {
  const r = Hn(hs), o = me.get(e, r), I = je(() => o ? o(i) : i, [o]), s = je(() => me.pick(t, r), [r]), a = je(() => {
    let d;
    return me.isEmpty(s) ? Se.forwardRef((C, u) => /* @__PURE__ */ p(I, { ...C, ref: u })) : (d = ngt(r, s), Se.forwardRef((C, u) => /* @__PURE__ */ p(hs.Provider, { value: d, children: /* @__PURE__ */ p(I, { ...C, ref: u }) })));
  }, [I, s, r]);
  return /* @__PURE__ */ p(a, { ...n, ref: g });
}), ggt = (e) => (t) => (i) => {
  const n = Hn(hs), g = je(() => {
    var o;
    const r = (o = n == null ? void 0 : n.dynamicModels) == null ? void 0 : o[e];
    return r ? r(t) : t;
  }, [n]);
  return /* @__PURE__ */ p(g, { ...i });
}, rgt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfUAAAFCCAYAAADoh0TcAAABHmVYSWZJSSoACAAAAAsAAAEEAAEAAAD1AQAAAQEEAAEAAABCAQAAAgEDAAMAAACSAAAADgECAAsAAACYAAAAEgEDAAEAAAABAAAAGgEFAAEAAACkAAAAGwEFAAEAAACsAAAAKAEDAAEAAAACAAAAMQECAA0AAAC0AAAAMgECABQAAADCAAAAaYcEAAEAAADWAAAAAAAAAAgACAAIAFNjcmVlbnNob3QAAEgAAAABAAAASAAAAAEAAABHSU1QIDIuMTAuMzQAADIwMjM6MDc6MjYgMDg6NDQ6MjgABACGkgcAEgAAAAwBAAABoAMAAQAAAAEAAAACoAQAAQAAAPUBAAADoAQAAQAAAEIBAAAAAAAAAAAAAAAAAABTY3JlZW5zaG90ytQ2sAAAAYRpQ0NQSUNDIHByb2ZpbGUAAHicfZE9SMNAHMVfU7UiFQc7SHHIUMXBgqiIo1ahCBVCrdCqg8mlH0KThiTFxVFwLTj4sVh1cHHW1cFVEAQ/QFxdnBRdpMT/JYUWMR4c9+PdvcfdO0Col5lmdYwBmm6b6WRCzOZWxNArQoiiCyMQZWYZs5KUgu/4ukeAr3dxnuV/7s/Rq+YtBgRE4hlmmDbxOvHUpm1w3ieOsJKsEp8Tj5p0QeJHrisev3EuuizwzIiZSc8RR4jFYhsrbcxKpkY8SRxTNZ3yhazHKuctzlq5ypr35C8M5/XlJa7THEQSC1iEBBEKqthAGTbitOqkWEjTfsLHH3X9ErkUcm2AkWMeFWiQXT/4H/zu1ipMjHtJ4QTQ+eI4H0NAaBdo1Bzn+9hxGidA8Bm40lv+Sh2Y/iS91tJiR0DfNnBx3dKUPeByBxh4MmRTdqUgTaFQAN7P6JtyQP8t0LPq9dbcx+kDkKGuUjfAwSEwXKTsNZ93d7f39u+ZZn8/hyNyr9x4A+4AAA5jaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pgo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA0LjQuMC1FeGl2MiI+CiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiCiAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyIKICAgIHhtbG5zOkdJTVA9Imh0dHA6Ly93d3cuZ2ltcC5vcmcveG1wLyIKICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICB4bXBNTTpEb2N1bWVudElEPSJnaW1wOmRvY2lkOmdpbXA6MTc0YjUzNmItNzZmMi00NjJmLWFkNmYtYWE5MmZiZDdlODNiIgogICB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNkM2M5MGFhLTY5Y2YtNDk3OS04MzYwLWE1MTM5MWRiYzRiMSIKICAgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjllZTJlYzJkLTRiMjktNDc2Ny04NTRmLWIxODVjZGU5NmUwOSIKICAgZGM6Rm9ybWF0PSJpbWFnZS9wbmciCiAgIGV4aWY6UGl4ZWxYRGltZW5zaW9uPSI1MDEiCiAgIGV4aWY6UGl4ZWxZRGltZW5zaW9uPSIzMjIiCiAgIEdJTVA6QVBJPSIyLjAiCiAgIEdJTVA6UGxhdGZvcm09IkxpbnV4IgogICBHSU1QOlRpbWVTdGFtcD0iMTY5MDM1Mzg2OTMxMjY4NCIKICAgR0lNUDpWZXJzaW9uPSIyLjEwLjM0IgogICB0aWZmOk9yaWVudGF0aW9uPSIxIgogICB4bXA6Q3JlYXRvclRvb2w9IkdJTVAgMi4xMCIKICAgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMzowNzoyNlQwODo0NDoyOCswMjowMCIKICAgeG1wOk1vZGlmeURhdGU9IjIwMjM6MDc6MjZUMDg6NDQ6MjgrMDI6MDAiPgogICA8eG1wTU06SGlzdG9yeT4KICAgIDxyZGY6U2VxPgogICAgIDxyZGY6bGkKICAgICAgc3RFdnQ6YWN0aW9uPSJzYXZlZCIKICAgICAgc3RFdnQ6Y2hhbmdlZD0iLyIKICAgICAgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpjZDFiNzFhYS1mMzUxLTRjYTMtODZjMS0xZTZiYzk2MmI5NzYiCiAgICAgIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkdpbXAgMi4xMCAoTGludXgpIgogICAgICBzdEV2dDp3aGVuPSIyMDIzLTA3LTI2VDA4OjQ0OjI5KzAyOjAwIi8+CiAgICA8L3JkZjpTZXE+CiAgIDwveG1wTU06SGlzdG9yeT4KICAgPGV4aWY6VXNlckNvbW1lbnQ+CiAgICA8cmRmOkFsdD4KICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPlNjcmVlbnNob3Q8L3JkZjpsaT4KICAgIDwvcmRmOkFsdD4KICAgPC9leGlmOlVzZXJDb21tZW50PgogIDwvcmRmOkRlc2NyaXB0aW9uPgogPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgIAo8P3hwYWNrZXQgZW5kPSJ3Ij8+3188XgAAAAZiS0dEAPwA/wD/5x3dQwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cHGgYsHRSrkbQAAAASdEVYdENvbW1lbnQAU2NyZWVuc2hvdPsRqwoAACAASURBVHja7L1Xkxw5l6b5AHAZMjWTLPH1dPeM7dj+/1+yu2a9FzP7iRIkU4UOVwD2Ah6ZyaJKMkMmz2MWVSRThAccjhfn4Aj17nbsEQRBEATh4NEyBIIgCIIgoi4IgiAIgoi6IAiCIAgi6oIgCIIgiKgLgiAIgoi6IAiCIAgi6oIgCIIgiKgLgiAIgiCiLgiCIAgi6oIgCIIgHCiRUkpGQRAEQRBehqjLIAiCIAjCS0Dc74IgCIIgoi4IgiAIgoi6IAiCIAgi6oIgCIIgfJpIhkAQNoiXIdhrJFBYEFEXBBFCQeaabFAEEXVBFjhBEF728yubCxF1efAEQRBkjZMNh4i6iKUgCILw8nTiOzcgkYikIAiCILyMDUgk4i0IgiAILwPJUxcEQRAEEXVBEARBEETUBUEQBEEQURcEQRAEQURdEARBEETUBUEQBEEQURcEQRAEQURdEARBEAQRdUEQBEEQURcEQRAEQURdEARBEAQRdUEQBEEQRNQFQRAEQRBRFwRBEAQRdUEQBEEQRNQFQRAEQRBRFwRBEAThi0QyBIJwKHgZgnuUDIEgiKgLIlqCzBXZ9Agi6oIsloIgyHMsGwoRdUHEWBAEWYtkgyCiLg+BIAiCrI2yKRBRFzEVBEGQTcF+sL3NRSQ3TxAEQRD2UZ++fTMQvawBEARBEIQfdTOgiERABdnCCcLLQ0LMfszVVALlBBFYQZBnWTYSLwQRdXmQBUEQ9mb9kY2BiLqIqSAIgqyla+VQNxci6iLQgiAIwhp0YB82ApHcHEEQBEHYrtZsagMQHcKHFwRBEAQxNncg6iLWgiAIgrAbIhFmQRCehXpwJXoPdQW2Aec94PF4jFEYo4gihdZ/WW9kwRGE9Ym6PE+CIHyzjrcq7iyUJZQFNKXCKw8uCPXNXUPV1BwfG6JYYS0kMVgHSimSRJEkmiwLgv9Y7EXoBWGNlrogCMJfrWlPsMCLBSzm0FQKPJjYk6SgI4/WECVgDNyMLeOx46efEvKOpq493nnqJih2VXnm8wbnPE0NJvKAIs81ea7JMk0cf+gSUJLELAgi6oIgPB3noKnBWvAuWOFVqSiXoDQkiSftQLfnMQZMFF4rS3slvP2+ZjoNQpxlmjz/cJPgnMda376Px3koS4/3nvHYcnVV45zHOUWWKdJU0+mEN9Gae3d+FKkP3lcQRNQFQfhhLfC6hrqEcgl1rfDO4wkucqUgTjyDY485DWKq2tdfz8b/iokU/YGhqj1N40mSB9VVCrR+EOQVvR5473HuQfjDNXqKwjGfW4oieASUCteoFdSNJ47D78tzTRyr+78Lgoi6IAgvRLUfAl9XQllXsJzDYqpomiDOWccTJ9AdeLSCKA7ucNUGwSnFdyXWDoeGuvYsl444Nl+1pu+F+n7DEH4gTaHbNYTAu/C5Vla+tWETYK2nqjyzmWU6ddgmBOppoxkMgju/09EYo9r3edi4PH5/QRBRFwRh5+Lt/MP/vQfX0IodNA1M76AsFCaGwdBzeumJI1CGRyK33ssyRtHraW5vGzqdYEF/Dw/Xpj743Y89Do///OqVby39IPZF4RiPLW//rClLT5YpkjSc3Xc6QdijSN1vKLRW994AHnktRPQFEXVBEDYi4sFKDcLl7EMqmbXBPW5r8D6IUZLD+RtPmgXX9baiy733dLsRf/xeM51ajo+jjQjjx9b24zcJLvmTk+j+czsHi4WjKIJV71wYF+cUxoTviSPVHkNAkoQI/dWmRCnaNL2wAVj9m0TtCyLqgiB8Fdda200dzsDxqz8rbANR7IliiGNIsuA+j6LgQl+5sleCs23h0RouX0fc3FgGA7Ozc+7Hn1tr6PU0/f5DYMDKqm8aT9OE4L2mde1Xlaeug/jXtW/z7RV5Hqx7CGOvtSKJ2xQ9I9H6goi6IPyQKNVa3K3VDcHyrusg3s4+nIk7q4gSSFNP/yhEoCv9eff5rqzH6NF19XqG+dxRln6vgtcej83KBf+p6/M+eB18e7RhrWdZeOrSsSiC2K/GPo4V3j+47+MYoki3v/vDuIGVm3/X90oQURcE4TvFe4VtXebBba5w9wFfoI3C+1awFcRpEIc0C1b56vfsswgE1/Tqz4puRzMeN2RZ/MF5+KHcN/Xo5kWRIssAzP2/NQ00jaOuPWXp25S9sBlbLh2+vVnecx+spzXgFUqH35lnhjiRs3tBRF0Q9lgRwglvXcFyAcu5ai3u4B43ESgVhDrNQBvQ2qNNcKM/DtjalQt9HXS6hj/fNgyHro1kP2z+eg+iKFjkWQaDQfh6U0NVhvz7soRi4anK1tXvPMXSc/s2eGT6x56jsyX/439mH6T/CYKIuiDsaJH3PhRs8S6UQy0WMB1BUytMBGnuSVJPnAahNxEfuc/3yYW+1sUmUpyeGv78o+Y///sei/qjNMC2fP39vX18n1d/LuahQI91IUWwXgZXfZS299UHt3ucQa+vsFn4/ulYYbznl3+D7tBzc7NgPKmxNmU/OnMLIuqC8EOod1hzvQ8u17oM/7d1sMCqApxXeAdZ13N8Hlzmui3Ysirg8sM5LBQcH0eMx5bl0pHnehu36eEvrdfEubbhjHv0Z/vwbc62f29z85sKbKVAe1Dhz85BlLaeFOWJIui2uf6rjYDS4SilXHps/RDY6H0IZvzbRfh+Y2Ayqbmb1JycpfJ8CSLqgrBJ63tluXkXxHsxhWKpsG29chO3FrcOi3VvCHHk4YM8ZxlLCGfJ5+cx19cNP/+cPH1c/IfdI/1joW7vzYqmCRurpl6dcyuawuNRRK1mehs2WXHW/qwPxx6mDWTTJryiCFQHTHscEtLd/P0G4T57bjVHCJu72RQWs/CFOAnxEHkXhlmok7/6OaWgLC1XV0suXmWMxxxcvIEgoi4Ieyne9znM9kMrbrmAYqEo5iFgrTfwHJ2FymurxV+rvyzywqc3SIQ68JOJZTqx9AfmA/f24zxy7x48Iqs69BD+vGwbyjjnsU61Lu82oDALAYZxBJ1+aDjjHSg8anWv2o2W0h8K7Ke8C1+aL/ZRjYDlAqZ3wRIfHHtOL4IFrz9RF3+Fc56r9wW9Xky/FzOb1V8tvysIIuqC8JcFeZU6thIM24SX9yGwKTQ0CelGeddz8cZLVPIj69T/xWx2q1iCR16NqgwpW1X14OIOsQaKutD8MXZcvjZo096DMvweFYVz6aZWKONROqTxacI5dZIq8q4nGnqSBOLUPzLfN7OpWgU2Wvuo0E/7/7IIRy3dgefn/xbiJZ7KfF5TN45XFzkmUiSxWOqCiLogfFp/1MMZadO0Z6MrIa8VTc19xTCtgxgYEyzxJIUo8vdn3y8+f1h9qIWrgD/n/lJ21j6qJW/D17R66Ozm24Ns5+Duqi3AwsPv0gpM3Frro4b5zNPta7T2mDy4v+ME9EnIALhvHKMe+9/9R+73dYu5Um153Ue1App24wdtl7hI0el5TlqL/FvnSVU5xuOa4TAhyw1l6alq2TgKIuqC8CBErRhVFZSLh9rnqCDkSgfhjhNPr9PmUrdnpcrwocX3AsT8cUzAXz/bqkLd6qhhVeRGK0A/BIxpHaznpmz/bkBHCteENzBtsFcUha/FSRjvsvLEMQyPH4RyJdLOKeJMERnL8an64jivPsNmB+rBnV4WoWPd6vN7FEp58g4kfe5TDZXy3z1PvPOMRxVKwWAQo3XojldX4XeJsAsi6sIPYXmvdMnZBxFauUSrMhRxQT0UZ9EqiEyaBSFfBUJ9bmHfV8t5xaqq3L0l3VrLK2Fx7RGCMu0YVe3PoML3NsHqNXH4vK6tE29i8Kuo73bjE8VA3JacjUEPVjXPQZtHLu9PXKi1Hh0FV3SSfix6xig6HcPdXUOn68gyvbUN1Or+WxsyF1YWeVmGAkCr9MI4gbQPaRbO4teps/N5Q1laTs9Sokjf+x9EzAURdeGHEPKmDsFRZalaV66/j1L2bmV9hzxwrR8Jkd7DRhufEWzvH9y9oVmLoi7bIC/94BLGhbNmbR7iAlablZV7OFiSbenTOASLrdzgrAL8dNj0KB1+/nGA1mNx8V/a8KgneAo+Q5YFC/3uzvLqUm80vnD1eaoKFjOoihCZ7n07DibMnShqy7ombKzxTVVZJtOaTjciz6NH16hIJG5DEFEXXgr3BT1al/l8AvO5oiqCMKVZ22XMPJzNmkdtQ/WjP/ttutD/km71V3e3e1TApK5CsZKqaouVVMFaNHGwnjUhuCxKfBCZuPU4rEqutgq7irpfRW7fb174MJr7r6+PHBP+28V4XRijGAwMt7cNxQby1lcejaaG2RimE4XC0+lBkvr7pjer6PTVa5NV+7zzzGcNtnEMBvkHX2saT5KKogsi6sIBCjc8RJyvzr3LBSyX6t7azLue45Mgdiu3r3pC7vd3Lcb+88bo40j5VcDXykr17Vm0dQ8ehWoZjgGUBuc9TRnEIu2qEBBmIM0h77TtPldnqCqIutL+/vz5U5bzl/7te63mXdHtauZzTVV5suz7rdTVZ7PNQ1BkWYRccaWgO4BXP/k2wO1RCqLa7hgtC8v7q4I3rzsfNY4pCnffxlUQRNSF/bW8H1lMxRLKZWhWskqBwgfLNEngbNCWUF1Zl/B9h5lfsZ79oyPhpgyWs2tLu9pq1VQlCICtHwLElA5R8/jWwjMeXBDrKIVOF7r9UKzEtIFj92+k/AefR9ysoXRsr6dZLh2djr7vV/6kudV6QZoK5rM2JdGFHvLahE3h8Nijo8+X390mTeP4848lg35MfxB/9PWy9FLzXRBRF/ZMvN1D4ZCqCrXPl/NVz++w0OYd33alas+9jf+s9f25yOf7GuutYDr3YQDUygOwcnmXi1Da0ysfOqLVwRJO8hDFbNpOaFkOPuX+HPuxS38VIHbv3r4XaP/d1rMAnVwznVrK0hFF5rO171c1BZwN0enzWShAs5pXaS+ch5u2JO8+FQLy3jMeV5gILl7ln/yeuvb0+0YmhCCiLmxXwFcW9sotvWoved+RaqmwNgSudfuei5/8feDWSvjuq4etNgL+A6M65ES7D6u8eR7OPKsyWGgehfNQznyw0Nr38S7kmad5CHrqHwe3d5K21rX/8Px5dV0iytsnTkKRn8nEkucaY9T9xtC5h7r6dQ3zSZhbSRqqtmUd/8VGOPtCWVom45pXl/lni8t4v1+95gURdeGloO7LWePaM8pVzq5bWUvNw9+9V/f5zFnH0z8KJVQfp16t8n4B0A8u7VXxl9XvVzq4tVcu8JDXrLCNx1kVguPaJhppHoLnohjU62Bxf9CmFPYrTU34LGdnMf/vf5V0ck8cqftCL/ceF6dIUs/5m7Z2uj6ce+us5/amotf/MNr9r5vlpvFkmYi6IKIurMsKJ+QqL5cPncf8fQCYoi7bXNpWOF3rUs+6YaG1bSONuv05W4XfGSXASvjNQ4600qEJShQ/bADum2n0Wpd3BObePe8/uRg+5d+E3Xh1vuT/XsVZLOfQNBrtI377h+P8XBMn7dzKg1Uex/6+DjwHtlkbjSqc8xwfZ1/0JiwWMnEFEXXhmYtuWVjmM1jONYuZoikVZRGEdSXa3WHoAb7KhY6ScB6+qpW+emkDJgln06Y9GrxPNWtLeyoeIr2/5cxThPrw5pZz6t7zg3tofrIKmKzKEDAZItI9b36OuLmp6A4cna7+IG/+UL0ui0XDaFxxeZnfF5n5HE0j80YQUReeQV1b/vnPGf/1/zT0uglZaogjzcmZ4fQ8Jo7D2ab6Sx/wKGpFWzyFwmcIhW48y4VicrtqkBMas6BCE5ZON3ht0uxhE+iVZjJt6HSTgx+DpnHc3hQcHSXk2ZcD4O77DwiCiLrw3daUC2lk/+N/JkzGlixznJ5FeF9zfTsjjhX9QUqvk5AkEpUrfB1ngxV+d614+0/N8FjRzYNoJ1nbJGdVJ/4T1f46Hc3NdUNRhBS3Q/ZU3N2VeKDXi1FPyD/vdCRQUxBRF55jTWmFNprXr1N+/lnz9l3FcgmXl1lbktQxnpS8e7sAD8PjhF4vJcsMWiuMDiHHshD9gBtC/2EGxGIOkxtF4yBNPHnPc/LK0x8ojk4frNGvFXuJY03eCSluea4Pdm4VRcN00nBymhLHX9+cVJUnMvIsCSLqwjMwRoeFRHu6PcO/dXJGdzXv3tUMjyIGg5heP8F7T107FvOam+slZWXJc0OWRkSxJk0NaRph7hclWZxerIi3jXOqMuT/V0WIVM+7ntNLT5Y/1KifLiCKQyrhU2MitIbz85jffqtoGv/kYjT7hLWe66uCNNUM+vGTnoW69jgvD40goi485+ZHIVDJtjVOI6M4PU3odgxXVzWLRcXpaUyea7IsIssijk+yhwC7eUVVWubzmqb2ofNWN3xfmhi0Ua3Qy2J1kCL+qCVrsYRiodqAyDbnP4Hhib9vnPMY94ygtjhWDAea25uGV5fxwY3bdFJhLVy8ytDm63NfKe6fH0EQUReeRd08yh9vF5i8Y/jpZ81k0vDubUW3qzk+jokTjWrd7XknIu9EbZUvh7WepnbMFzXv3i6oa0u3G9HrJcSJIYo0UaQxWrUpcbKA7ZUYPSooVNchs2HZVgNUQHfgGZyE/uh/rcG/bpSCXt/w979XHB0Z0uxwztbL0jKb1ZyepqTp0+NQGuva4wZ5LgQRdeEZJDGftCaMURwfx+S54f27kqurin4/otM1H1S9UopWsCFNDd1ezMVFB2sd83nN6K6gqjxJaohjTRwporgVeBOqh8WxaRtZeEld2zRtKuHKAne2rdhmH4q9VGX4xm7fc3z60Clu216k4cBwfd3w08+HEQlvrWc6rYljQ7cXffPPHnJgoCCiLuwJcaJpGo9zD2lFj8lzzc+/ZEzGlum0YTqzDIcRvd6XrRBjNMNhynCY4b1nuawplg3WesrSspg3eDxGK7RRaK3p5MF1b9pNgwj8eoXc2tC5rFw+dMYLAx2i0ZVRoTPeeYhSf849CIWE/HdbnsYo+gPDzU1NWTrSdL8Fz3tYLhsWi4bLy/ybu62VJaSpTFVBRF14JloblosG7+8roX+0WGmtODqOyDua8ajh5rqmKBxHR9EXa1X7RxVDOp2YTidu3fUe2zisddS1Y1k0lEXDchn6TIcI6JhOJ2qteHHXf7PItP9ZudGLuaKu/b3rPDRB4d6dbiLQ2t//3Do2VKvaBt9LmiryPHRw23dRbxrH+/fFN7vdIXi7yjL0LhAEEXXhWaSpZrlwT1rE01Rzfp6wWFru7hr+9a+C8/OEbtd89Xz18e83RmGMAQw50B+kOOepKktZNFgXrPnppMT54NbPsyi47xNDkpj7xi7CA86GznhNHSLTl4twU6LIEyeerBOq/SXp09LL1uIkeIZORZEiTTWzmaXb3d9IeOc8794uSRPNYJB8972Tjasgoi48z5rzkKYRZelwTwxXVhq6XUMcK6ZTy+1NzXxuOTmJv3vRDW1NFXke0WmD75rGtS9PU1uKomE2D9dorSdJNN1OTKcbrPkfjVXRlroKOeLlUuGdv69MFiUwPArn4SZaWeKHtxHKshAFP53YtjDS/l3jZFyzXFp+/Vv3uzcx2vhwBCK6LoioC89BaygK980pSEmiOT7WdDqG0V3N//5fS16/Sej3o2ctTKtFexUtH/4tom8TnPetyDsa65jNKt6+XeCcp9+POTnNSFPTRui/vFz5Va54VcBsArNJaFnaHXjyrn/oT9+W89Vtjf1NWuKbJkkUnW4oRtMfmL2z1uvacXW15Pw8++6qi96HgFUjRRsFEXXh+aIeItfVd3TL0DoE0iVJSqfbcHUVgpqGw+AqX5eoKqUwkcIQzoB9BuAZDFKcc9S1p1jW/PavGWXZMBgkdHsJWfaQSqe1al3O+6/0933meWh929SwmAUhj2IYHHle/+LbNrRtihm8yHr8JycRb6ua5dLtlVfG+9CBLe9E9AfJd89356Co5DhJEFEX1iLqisgorP3+FcUYGA4j8lzz/n3NH7+XDI9iBgOzkYIaq6p1xoAxhjiGTh4K4zgH83nNZFyymNegwmfUWpGlhiwPG47Vv+2LyK+qtXkfUsqK5UOKmfehpG+35zl95dHm8Tj8AItUpOj1NGXhaDr6i8GZ20IpmE4rppOKn37uPmuer+69IIioC+uQE2oLVeWe3VAiSTRv3qRMpw2jUcNyaTk6irdTw1uBaoV+MEgYDBO8C53oqspRV5a6drz9c4F1jjyPyPOINDXEkSGKV60+t+O2X1Vsa1pLvC5DX/GqUiQJpLmn0wUTh8pt2vzYZlynY3g7qckLT7e7+6OVqnLc3lScnmXPbnbknEfLYbogoi6siyzVeOeAT6e1fZvlH6z2TsdwfV3x+28FZ2cxvX603fNQHzYoSRstDzHee07P8vvCOLc3Bc55ssyQtLXrkzbC3phgyRujnxdgFmrq3Dc+ca2Q11Vb6KWAulZEkWdwAmnmn50K9hKJY0UcwWxmyXO105Kqznnubks63Sh0YHvmpYSAVb45t10QRNSFT9Lvx1SlbQuGrG8RvrxMmfWC1V4Ujk7X0O+bnS1eSj247JPEcNK665fLmtmsoSotdWXxs7rtIa/CmbxRpGlEmj1c+5dEfhWZbptQVMS2FdvcypWuQp96E3mGp5Dl/kWm6H0qbe5Zm8WjiHfvaqzdbZ30+bymqh2np+larsNaT5Iq2cgJIurCGgxaD3EScXe35GLNoqIU9PsRWWaYTBpGdw2LueXsLNSR34fPrhR0uzHdbuhG1zSOqrI0TSiM0zSOqvTM5w3OeZRWdHJDt5uQ/KXIyP15+EK1pVbbFDMT4g7Stq94nHjMo/Ql719mkFQchSZB67pXnY4mzzTTiePkdDdtWavKMRpVdDqh+uE6qGv/UN1PEETUheeSZRFKWTalK3GsODmJ6XQMk3HD77+XHJ/EO7Xa/yoYq8p3H6bSBVerd56qtpSlpWk8RWEZjWZ4H2raZ2mGrWLqKlhbWdeTZiE3PE64zz9W+lPv+2K3i2jDfVDfujg5jfjnP0r6A0OSbHfuOOe5vS1oas9wmKxtU9E0EvkuiKgLaxbdqnKfLRW7Lqs9zzVpEjOdaa6uKmYzw+lpTLanXbhWRXEwoQnNQ5lbR11bbON5+27Ov/4+4j/+45iT84goCsFtknO8mZmUJIos11xd1fz00/YavXgPs1nNbNrw+nV+v/FbxxxzzrctimXOCCLqwpoWrKLcjrWgjWIwiMgyzXRi+fOPkk7XcHGefGTJ7qvQr6z5ELWsQTV0ByFa/QuG6w82qT7xWpe1fhzxr39VFIUj+96a8N8ooE3jmIxrBsOYTne9besUvg2Uk7VIEFEX1kS3o7amPEqFOvLxaagW9vZtxT+LgsvLhCTZ0lnpGj7qfFoTR4aTkwS9veH74ckyzfGRYT57hqh/w73y3rOYhQC9k+M07Ae+9V6rz1+Hp/UIIaa6sAbDSYZAgJD6VVduu5NPKzodw9/+ltHtaP74veT2pqaq3NMWTf+M1zOx1rMsGjodQy59sLfqnNAaen0TitE0m99JlaXj9q7i7DT9frf7F+ZhVYaKgZuaq4KIuvCDESK0IxaLZjMu+K8IrNGK07OE8/OE2czy7s+K+czirN+oMD+Homioa0enG9M0z6vIt+Hh3dmLNf2OT1vrIS1wOt1s2Li1nqurgl4vptuLN3P/vpb9sOmbJLwoxP0uAIpeL6KuGj5ZgMZv4wqg1zPkuWYysVxdVeQdzdFRvD2X/BOtTuc883mN854si6jrUFRG1sjtWftKKfpDw59/1PT6ZiOlY72Hu1GJ856T0/Sja1Fr/IA7iyfxz3xoBbHUhT1bMX14NpNEU1X24bxwR7t5YxTHxxGvXqWUpefqqmY8boKbVT37o67FoKkqy3RWMujHKA3O+m/ucvfip9amc+9Vm7fe0YzHdiObvuWyYTqpubjIPpl6uS5PRhQdaLaEeATEUhc2vHN+zttaKAv/3VXl1n3ZeUfz8y8Z43HDfG6ZTBtOjmN6PbPTNcJ7z2xaY7SmP0jvBUbJyvUB1kJdb7YrnjGKkxPDaGSpKr/WMsTWet6/W9Ltxc+u7f5FTWwdY1qH/+/TLFLr/rAHeeFiqQvP3d3uCGNCRPoH/bd3uBH3hM3F0VHE6VloCnN9U/P+qt7p+XVdO2bTivPzDkopvGenJUv3Feegbja8dqsQCR/Hivl8vWfrV1dLPDAcJhstkOQcVBV4rw5uqdpbI/wH9xyIqG9z9vv9vUR0sDWt3b95n6aak5OY8/OYorD8/lvJbGa3XoVrZaVneUTeeXByRXFojSo8HqttbUYVSaKYz9cXCT+fN0wnDWdnGcmGyxk757HWH7RxeZDxeS/42EBE/YBm6CaDXJVS1E2ofb6XE7VNf7u8TOl0NTc3Ne/fVdT19q63rh2zWUV/kHzgVs4yjZEnaSesrHVrPcvF8+dC03jG45KTk4Rud/Onk96v+gP8WJvCgwnaP8Adi5aZtLsbsk9zxRhNmmicc3t9C+NYcXqacHmZ0FjP//5fBfO5ZdOX7T0s5jXWhl7sf5EW6sZL/e4dkWWaJNHM5+5Z98B7mE1rQNEfxFvrS5AkEMdImdgDXTv3TWf0D3W35XK+aAlrrXAHEMa9qkj35k3K69cxv/9WcnNdU5ZuY8LqnOP6esnxySciob1q31tUfTdzF46ODM57lsvv391VlWW+aOh2o40Fx31qI7Hn+2iRhQO7IC136McR7q8vatup0LVOcR8MY/7bv2dUtePPP6uH9Lc1M5/VeOcZrCLeH1+H1tjGiaW+q+XAB2s9ilTrtfn2G2GtZzSqMEbR78dbu3bnoCzFyyNy8oQLOhhR34MzCynKFCz1OFYcYrxXHGtev045OY6YTRvev69YzC1+TV6HUFVsyeufep90yWq18nDIyrxLBgPDbOq+2VoPbveKYtlwcpJsPZthHyPfhedrw64uRu98dA5nW+BZxQAAIABJREFUA/TiMdFhuN8/vSmBwTDi8nVKFCnevau4vWvWEkg3HpXkeUQn/7QFF0UKLzNp56SpJk4U85n7pnlclpa7UcXxSUqSmK1bzZFUCxEPwDrXwo2bsc/4FFLmeLs4qzZ6Lr2dBVJxfp5wehZTFo7372vu7r6/pn1dW2azisEw+WzaWpIaJKPtr9anx7lwRLKt+RTqGhiqytM8MUfeWs/dXUkUaXq9eOvjpFQIkpO2qyL469I1vcsthYjwnlk6mUbpwx99pWA4jDi/SOh0NJNJze+/ldT1t3+u2bRGG0Wams9GJyexQmuZsR9sEB2ttbzd3U6nY9AGiuJpm9P5vGY8rjg7y7YW7f7XTUW4TNkVCuvRUb2N9VtE+zCEMI41Tf0yAr68D+lvR0cxr16lJKnin/8oGI/rJ7tmnfNMZyW9XvyVlpuKuvYS/f6ZebVNVpHw19fNVysP2sbz9o8lry87ZNluiq9XFTgr6WzC+lj7aY4sa4eL1jqU2/Tbt7A2KSqhlGhMlhqubyrmM8fpWRzK4n6BxbzGO8iz6Is1zD2rUp8yh/aBPDfUdc1kYjk+jj4pmN7D23cL+oOY/iDe2bVa6zFaiagL61vHv8fCFpf5yySODUq9zJAvYxT9geHnn1OSRPH77wXX1/Vn09+894xGJb1+QpKar3oFGitpSfu0kfvpp4Q//6w/6z2ZTmuc9Zyd78bt/niemUgsdWHNoi4CLUAbxe1frjgpFVrMnpwGl/zdXc3btxVF8XFu82RSgVL0eslGO40Jm6HT0RwfG6bTjxu9VJVjMq44Ok6/cqyyjTnpSRK1042F8MJEXcRbeExR+INNa3vypNeKbtfw7/+eE0UqRMjfNlRlSH9rGsdiUZPn5kmVxRRgtIQ67dc9Dh3+plP3wdm6czAalRgDnU60UwvZ+/ZMXSrKCeu21AVhRZKotRVt2XeMUVxeJhwfx8wXluvrism4CTXeG0e3Gz9p0Vc6BOWJqu/fXHaOB2tdBQ/MYt5wfJLuvGWuUqHn/Cr1TxDWgZQ9ED6wOLPcsFxa0uzHmRr9vqHT0UwnluubiuWiot/XT67/rRQkqQQ77eOmrdtR3N5aBoOIurbc3hQMjxLSdD/m96pLmyCIpS5sRNUjEzGf1z+kAAyPIk5PI6bTmqKEycR+NS1qhbXhJezRdFbQHxgUMJ9b7m5LksQwHCR7I6RRJIVnBBF1YYOq3u1GNM2PqU7ee2zjuLxMefUqZz63/P5byWJuvxI5qrANOCsRKisxhYfOf7skjjXHJ4bffisoSsfRcUIU78eyF9zuaufHAIKIuvCCF+MkNcznzQ/pEmwax91dweVlh+Ew5uwsptczvH1bcTeqP2u1r0qhWied2j4n8Lt8/yxTWNuglKLbjfdmbJzzNE3INhEXvCCiLmyMovjxwnGd84xHJZ1ufB9PkKaao+OI129SxqOGv/9/Bcul/aRwe6T4zD7ivWexaFguHFpFe1X1z7m2mpzcJkFEXdjYhFCQpT/eMlPXlsmk5Ogo/cBq0lqR55pffs0YHkW8e1dzfV3R1I/z+RWRUVImdg9ZLi2Tcc2//0cXpdQ3t2Xd9EZSaYWSVVgQURc2hdKKJNFU1Y9jrXsPs1lNlkekn6keZ4zi9DTm8jKhqjx//3vBdNrgnEdriBP1yGYX9oGm8dzdlgyGMUdHMVmuqKo9Kq7kQ4c2Y5R4eQQRdWFDoq4UKENZND/MZ7bWMZ1U9LrxFwO7VnXkX79OOT2Lub6uubmuKUtHHCmUCPpebdSmkwrvYTBIMEaRZZqicN/VrW8z884TGTBG7pcgoi5sTNRDQ4zGuh8meGc+q1Fa0R+kT3toNBwfR/z0U0pZed6/q7i7a6gbEfV9YblsuLkuOT5OiKIwkbtdg7UhVXHXlrFSUFWeqkbKEAsi6sIGJ4RWZJmhKCw/QgiPtZ7r64LT029v7JFlmjdvEo6OY2Yzx5+/V8xmkqy++3vq+POPBf1+TOdRtLvW0OsZxmNLWe7+eMm6B4EXBBF1YWM4HyLgX/pioxTc3S7JMkOn8+2pTt6HTdBwGHFyEuOAt28rrq6qz3Z/+xFYWcG7mj/XVwXaKE7PPwx6DK54Q2TC/N61te69R6sQxyIIIurCxoQuihTmB2j1U5aWUdut67lFUqJYc3ERc3GR0DSet39WjMfNDxsRr/Akid/6efFy2bBcWi4usk92YNMaTs8ilgu3842XUhDFCtF0QURd2OhybEwI+Xrp3dom45Is05+NeP+mB0l7jFb0+4azs4RuT3N3V/P77+UPlUnwaBqh9Xatdec8t7cl/X5Mnn++tnuno/HAcrlba71pwgGXlIkVRNSFja/ItnnZot40juWyoddL1lKmU+uHLm1xrBgOY16/Tklizb/+VTIeNy9+k7RrxuMKPPT7X85i0FqRpprx+Om1/deN9yGew0rbVUFEXdionCuIjCJN1YsWoaJo0FqT5/Faoo+TRBHHj+ueh4p05xcJJycxV+8r3r+rKAspJbsJlsuGybhmOExInuB5GQ4Ni4XbacCcc5KfLoioC9uYFEahtHqxwV7Oecbjiiw3JMl6HgHvwTYfl4pVKqS//fq3DK3hjz9K7m7rHzqQbt3UtePurqTbM3R7T2upGkWK01PD7W2zM2E1kqMuiKgLW7LXaZrgon6JTCcVznn6vWRtOcLOQVV93gpPkmC1v3qVcH1d8+5dyXLpxCW/hs3UbFZjG0+//2338/g4pqo8xQ5Kx3oPSQxpIlFygoi6sGkLQiuSWOH9yxP1pnHMZhV5Hj3JTfstG6Gvnc8qpeh0Df/53zvEseb9u4rbm5qykIPV76UsLeNRRacbkSTfdj+NgYuLmPfva9yWb4G1nsb6+w5/giCiLmzOTtfhTNg5/+Jy1ZfLGmsd/X6y3jFTIb//KbXftYbz84TT05iicFxdVxJI9x0457m5KTFGfdSI56lkWYiE33bRIGuhrpHKM4KIurB5vA/pNta+LCvCWs9y2ZCmEUm83qmvlfomq0sp6PUNl69T+v2I0ajmzz/Lvah0dihzdDarKZYNF6/y+1Kw34oxim5XM5tur3SsUmFD4j1rybwQBBF14auLThSpZxdk2Tfq2lJVjl4/WXsVL2O+r2BPFIWKdBcXIbXu7dtQR35XqVbrommgqjZ7L+9uK87PM9LUfLcgax2qzFkXarFvb1MSCvPEkaw3goi6sHFRV2ijcPblpF8551ksmnCu3Vn/ShrF6rutRQhNdM7PE05OIubzhn/+s2C5tAc83sHTs4n2Ad6H7IU0M/T68bN/XxxrOh3NeNxszRvuPUQmzBtBEFEXNm6pe68oS/diypyGtKfQuGUTXbGUUtTN83p1G6Po9SIuLlKGw4jffyu5ua7krP0vLBaW2bTh5CRdizdJa8hzzXTqWCy2c/wRztS9HKkLIurCFiaFCtHvSvkXIerOecajkjQxZNlm/J1KtU1CninASoVCNsfHET//krJYOP75j4L53Lbi/mO/6trx9s8FZ2cp8RrjIrJM0ekorq62k7fuHDRWIt8FEXVhK6Y6mEjhvX8Ri07TOK6vFpyf5xv0bijsJy317xMvpUJk9us3Cb2+4eqq4va2/mIu/EvHe8/V+wXdnqHXj1BqfZsFrRWDgQY8haQYCiLqwovSdBXcg2V56KLu8d4xGhX0BwlJqjdmQd5HNH/0tecRKp/FXF4mFIXlj99LptNm63nV+8BoVFEUjpOTdANHKJ4s0+S5oihs66Ha3Etr/0FZYUEQURc2OzF0COLZz0XnqYsnNI1nMa85OdnMWfpjSx21qd8drPY3b8JZ+91tw81NvfMuY9ukLC2ju4rjk2StbvfHGKPIMk1Z+o1GwnsfakHE8bd6cgRBRF34zkXHGIUx7CC1ar2L22xWE8eGLN9s7tAqPWmTeyCtFSenMZevE6rKcX1dc9vWkX/JFp/3MLqriBNNrxdvdHOWZZq6ciyXm8tb9x7qCqxVfNuMEfEXRNSFZwhI0wQL6dsXlee81oe1nrvbguFRuvEiH0op4oT2nHezApemmsvLhH7fUJWOt39WjEbNi5yHSsFsVlEUlpOTdGNW+oo4VqSZZjKxG2u6s2q7ujkviz+4Z1UQURc2vAgYo4ljhXP20fcclhjc3CyI4s3kpX9K1G3j2Vb2WSiNGnF2npBliuurmvfvq73p/uZ9iPB+7laqLB2TccNgGJPn26nUcnISYa3fWHW/VQBqFKkD97CI8IuoC3v68H1KNEAraGp3kA9n0zjubkNe+rYq41U1W88pj+Pgkn/9OqFpPH/8Ue5FHfl1ZE4455lOa4xRDAbJ1gQwjkNK4XRqN3b8pLUn+SE6tIngbxspUnhwD8i2LF1F3YA6wIdPKbi9XdLrJ6Tp9qa4s+wkKl3r0P0tSTWzmeX6qmK5MJyeJcQ7rFj23JlTFJblouHkNN1qjXTvod833N1ZFgtHr2fWuqHwfhW38qNHv3/vDJGUAbHUX8zudss7vugwF566clRl6MRmzPamuN+xAbKqI//LrznOwz//sWQ+twdZR75pHKNRRZLqrRyf/JVQ3U9zd2dxax4/76Gp+SHTEl/S+iiiLnzDBN0Ha1cRRxrU4S0+80WN1posi7e6IQnWpN/xfQsV6V6/Tjk7T/j9t5Krq5qicAdTbtb7kJM+m9acnWU7u45+P6JpPFW9flG3TqrJidiLqB/wpDrEc6VwJloWDmsPR9Wt9SzmDVlutux69sTJ/gQ+KQXDYcS//bcMBbx7W3JzXe9NIN2XWCwarq9Kfvqpu9NOgVkW2rIuFuuvB6B1eAn7uC6LqMtEeaE7wjjRmIiDaigym1ZY6+h0NpvP/CnybP+imZNEc/Eq4fQsYT53vH1bsVjYvfW+NI3n6v2Sk9OUbnf3IT8nJxGjO7vWYjShtXE42hLE4hdR35vd3Qv/9B6SxKAVB2OpW+uYTEvSVJOm218xlVY01u/d9FAKej3Dz7+kpKni5rrm5rraWMrWc5hOKoxRnJwkexEPFceKXl9zdVWv9dkK90UCvkTsRdQ3IM5yDvPZyaEVZekPpkXkYlFjG89gmO5oqimWC7u3syeKFGdnCccnMXXjef++Yjxu9qYTX1FYRqOKk9OUKNqfpenoKGI2a9uyruE5cA6qSs7URWM2ozX65Q+u8L0YE9zv+P231K11LOYN3W5MkuzGbauNYbm0ez3vVlb7xUUS6sjfNfzjH+VGrHb9DTtB5z1v3y4ZDpOdRLt/zVo/OzNMJnYtt9Z7HwrziKEufFK3flhRFwHfvKirkH7T7H+3trK01LWnv8UiJR+Nl9YHc1QRRYrBIOLyMiFNFb//HkrNriuQTiuF1k+3Rm+uS9LUMBwme+eW1jpshJxbT6OXkKPuJVBO+EbL/6BFXdzj+2LVWQuN3e/rdM6zXDTEsd5qsZm/LtRRrHDOHdT0zDLNxUXCxUXMZNLwr3+Vwc387Mnz9G9dzBuKZcNwGGOi/TRf41gRRYrp9PmNXpSCJJZAOWEzuqj380KFvZhCPkRPG7Pf539VZRmPSwbDZKcuzVWe+qHNYGMU3a7h9euU4cDw/l3JzU294aYjAWs9o1FFpxORZWavxyjLNKPR8xq9hGYu0Fi103Q94eUKv97Fm4qAH5All2qc9Xub1ua9ZzKpUIqdn8XmuUEbd5BnpUq1Nc9PYi5eJUwmDb//Xrbpb5vrVjYahQ5s3W609yKX56HJ0XM74jnnQ7tcWV6EDbBBURe3+UtAaU1ZurWXylwXde25vlpy+bq3c29C6NR22FHNYXNk+PXXjDTVbc/2hqJYf6zActlwd1dyfJKQdfa/DUUcKwYDw3Lpn2WtOxvmiBJLXdg/UZcz75dOkhiU3k+nsvcwuivoD2KybPei4IH57GUU9DZG8epVwqtXCWVhefu2YjxaX/c3az3jcUW3EzEcJgezZPR6mjRVzGbfH2iiVBhfiX4XdiTqItw/tqhrvNtP93tdW+bzmouLzl4skIqQf/ySyDLN6zcZR0cRo3HD1VXNYvG8YDHvQ3BcU3tOttgadx1EkSLPNcXSfXckvNKeOPIi6sKmRF2izIUvL8BV5fcuVd17mE5qOp2ION6fACv7AjtvaR0KsFxeJngPV1c1t7c1zZcanXzhS03jmExqBsOYND28vK4s09QNLJffVxPeWnCytAq7s9SFH5lVAJXas5lirWM8KekPkr2y9KIdngL4Db+SVHN2HnN8ElFVjj/fVszn9tOmwKOGJY//3TnP7U2J1opePz5IUyKOFUmiqKpv73wX6j6ElyCIqAvbnyBtEZF968l9d1cQGbUXZ+mPRTWKdye+28AYRb8fcXaW0Oka/vWvgqv31UeBY1EEafrxdc3mDZNJzel5+sXN2D6PT+iAZyjL7y9GI+lsgoi6sCNLXeGcoq7d3tQIt9Zxe7Pk7CzfyuL4LaLR7+uv/sxLIIoVR0cRv/4tp6o9v/9WMhk3j5qV8JF3pyotb98ueP0mJ463v/Ssc4OQZZooVszm326tayWFZwQRdWFXoq4hTsB7txepWkrB3W1Jt5eQfKYT2y4tPKXU3nk1NrZ46JC7fXmZ0B8Yrq9rfv+9pK4/LlrjnOfqqiDPI/IDSF97ygbh5CTi+rphWfpvmk/KtM8UEr0kiKgLW1+4FVGkd95/e7XwVbVjvqgZDFO00XtnCVunKEr7Q80RYxTHxzE//5IRx4p//H3JeFxhG+7nzWzWMF80nJ9lL8b1HMeKfk9zd9s8+flwzrNY+Lb64PM2o4Igoi58F85uvqnLUxew6aQizQxZFu1lSpBWmqZxP9wcUQqiyDMcgtIL/u//6y3jScVoZEN1ut8WnJ5mn/WuHCqnZxFlEdoTP03UoarcWjY2IvrCp4hkCISvL9YK9xVF38YiUteO5TK0V92nftsfjpcOJUDVj9Mv23vPclkym86pm4a6mnF5WXN8ZFjMLdfXRah33mgmE0uea5LkZVjrSaLo9zWLhSVJvr7R9B5sE56pTc+P5/x6CeMTURde7IIN2iiayu/cApjPKqx1ZHm0p4U7FHGs8e7HsNSdcxRFyWK+ZLEoUUrR7eU0teX16wuGRzmju4qq0vR6CVUFN/MGrRVpquj1NHmuD7q6WkjNM7x7V9PrGeL4ax/Eo7V/wvft+LkX0RdRFw5UtJ+2dFFWDdZ++ixwG1jrmM0qksSQ7rELN8t1aL/6QlFK0TQNy0XBdLqgrmuyLOXs/Ig0TRmNJiil6PW7VJVjsWg4OUkYDJPW2+KZTixF6RiPLOORJU0VaabJsmDBH5qXI8tCzMlo1HB+Hn91k+zcdiz1ffECyAZARF3Y8EP2rcSJJjKbfpcvs1w0NI3n7DzdY8ELzVDms5cZKGet5fZmzGK5JMtSkjRmOOyRdzKUUiyXJXc3Y978dIHWmtFdgdaKbi++t8STRHF2HuEclKVrc70ds5llNrMoFHmuGAwNxhyG8CkFFxcx//xHyelpfF9053OiXpSyNslGQERd2KKIfyTqcchT31X998Y6ZvOabjfeq2Izn/Rp6DBWL2aeeY+zjvF4xt3dmDzPODoakOcZcRyhWrX2zvP7b+84OR3S6eRMZzWzWc3FRU4UqY+ETalg4WYZWKvbM/fQ/Wwxd1xfl+QdzelpRJLoLwrlPtDpaI6PDaO7htOz6LObkVBRTsLYvmd9E6EXURfRXptQaYpid01dysJSlY7Xb7p7f9+cUxRLD15xyDHIzjnqumE+X/L+3Q1ZlvLmpwuSOEYbfS/mK25vxyRJzPCoT1Vb7m5LOt34STnpxiiMCVa899DtBoFcLB2//14TRartjqbJUoWJ9u8MXmsYHkVcX9cMhuajjcxjq95INbm1r4kyoiLqezMxD2HpN0YRx7t5b2sd81lFpxvtbcT7X+9wY/1h3NhPirmnLEpubkY01pHnKb/++posT9GfMZeLomI0mnJ5eQZoRqMC5z3Hx99+VLJqS2qMIkk1g0EoxzqdWuazGu/BRJqjo3AGv09BdmmqSGLN3Z3l/PzzS2uayTq4CyPoRxF+EfUdW9qHsO4r1QYvOd+WxNree1eVZbFoeHXZOZAIaYU9sCP1ELxlKYqa2WzOYr6k2805G/RI0i83zPHeM7qb0O3lZHlKWVqmk5pXr/LPWqvfKvCdTmh3am2otV4Ujj//rKkqz8lJxGBgSBJ1L/C7midah4C/8bjh6OjjSHjvoak9aSp25T6uyS/lroiob1HADxWlQlepuvFb1XTvPYtFjYkUeR4fzFhpdRgzwjlP0zTUdcN0Mmc0mnJ83OeXX19jjHmSOM5mSxaLgp9/eQUoJpOKbi+i14/XPq5RpIgiRaejOToKFvzNTcM//1HS7Rq6PU2ahrTCKGLrmRohUFIxnSqKwn2yJXBZSh/1Q1nHD/U2iaiLiD/JkktTjXqoXr2V920az91tyeXr7sGkOWmt0Hv8VCml8N5TFCXz+ZLlssBoTRRH/Md//kIcP/3iq6rm5vqOk5MBcRxxd1uxXFp+/bW3lXHOc8XPPyc4B/O5ZTpxLBYOre29KzxOFGmqMWY78ydJNIO+ZrFwdLvmowC/qvYHcowkHGqwnoj6DyzW3zIyeW4oS3cfubwN7m5DA5BeLzmYnF6t2dtqad57ZrMF8/kCax0K6HY79HodkiT+pi583nvubsfEcUSv36UoHJNJzeVlZ+sWstYwGBj6A0Pduufr2jNfOFh4tFbEkaLX1yTJZgVVKeh0NbN5zWzaMDx6iIT33mNteJaEl60Ru1wBIrkhwpMmSmwYjQtOz/KtvF9VWiaTil9+7R/UOKm2/7zfo12ItZayqJjNF8xmS7I05uh4QJY9BL996/UuFgVNYzk6HgCa6+s5w6OYLNuNYK0uP44VcWzaOIFQk30xD/nwy2WoZpd3NFmmiGO1kQ1IkmjiWDMeOzpd/2FsgffkufphSgiL+G9f9KMfdVCFb1sw8yzCO9uunmrjN+/2tmAwTDZuWW1irKoqCMouu5EppXDOMR5Nmc4WQUw6GZevTr8Yyf7UTcJkPCOOI/I85e62QmtFvx/vzXnx4yj6LAtBdmXhKArPYuGYTn2b1aHodjWdjl7rEc9waHj3rmG5dPT75n5uFKV/MXXvhfXq07pmRfRSBkTYLHHaut+38F5F2bBY1Lx+0/soH/oQsA1Yy84KpjjnuLkeMZ0t6HYyer0OWZaSpvGzxHzFbLakrGpevz6jLB03NwVvfurs9VmxMYpuz5B3HorcVJWnLB3v39cUS8fxccTJabSWuuxJoul0FFXlce5hLpSlrCXC9+vaU2Zm9FI+rLBhywdYLPxW3IbzeR3ylBN9sKPl/XZz/7z3NI1luSx4/+6GKIq4uDghy5I2kn0911KWFaO7CcNhjziO+d//a8rRUUKns/9LySoeJLjoFVkGzmmGQ6hKx+1tw3/9V0G/bzg9MaSZJoq+L01O61AyeDq11I/S2KyV1UxYnxaqQxF1mfb7Sb6F4/QQ8V7w6rK7FqtyF5sfY9haqL5znqauGY9njMcz0jTmzU+vyLJk7ePnnGM6nRPFhqOjPlfvC+JYc3Sc7vSo4bvvlXpczS6kxNkG5nPH9XWD85DnIUe+2zUYE6LunyrwnY5mNGo+aMsax6Al+F3YoMhHu74I4XDodAxN7Yjjza1K43FJnsd0OtFB5vMqrdoOXJud6au2p3e3E6y1pFnK6zfndNrmKpuwcheLgsl4zpufLiiWlqK0nJymG50P2xR4pRQ6gaPEMDwyVJVjPncsl57ptEIpxWBg2naxXxd4raHfN7x/39DrGkwEWYbkqQsb1ddoW28kHD5RFDOb1U+q5/19VrpjOqk4O88x5jCFQinIOxq/gVm/crFXVc18tuDubsJw2Ofi1QlRFG00/sA5y3Qyoz/oEkURt7cleWYOdvP1lPuYpqHevHPBbV6WjtHIcnPd3AfXxUnYxH2qXK33rai/q5lOLZ2eoWlE0YUNr9Mi4sJT6fViiqJmUwVoRncFWWZ2lha1LrRWrLOluveeqqpDwZjZkrpuyDsZ//nff8WY7YzVbLpguSz59eKExcJSVY6zs2zrOem7uZ/hnsaxodczNI1nNLLcjZr23xVJotpUNkUSK5R+OMN/81PM+3cNUbKaFyLswh6Lugj4j0PeMYzHBd6vv4lGVVnK0tIfpAddcUsRSuo29XqejGJZMhpP8d6hlSFJY07PjsmyZGu58GVZcXMz5uz8BGs1o7sFw2Fy8Juv7140I8X5eYT3EYu5ZVl4ytKzWNj7TUCeK3q9UP+90zFkuWUystKhTdiNqItQC58WLM1y6TZiZywXdevyNIc+SHgXjhK+F+c8ZVkyHs+oypooMvQHXfI8I4ranOcttcH13vP2z2s6nYxOnnN9U5KlhsEg2c1isSeauNpPdbqGTje455sGiiKcw49GlutrS7erGQ4NeW74//4sGQyNnKkL2xN1EXPhi+upDtG7615YrQ3VvuLYHHAa28ND5P1n3O9feMCUUtRNQ7EsmU7nLBYF/X6X09MheZ6FSPYdtHOdTObg4fh4yGLeUBWW12/ajnl+N+O7j5uCVRR9mhoGgxBkt1iESnbX1w117bm6Kjg+zmUhETYr6iLkwlPROixc666WVhRh0Ts6TndTbGatD4FqU5b8k3+3c47RaMp4NCXNYjp5znDY/zgtbcsPa9M0jO4mHJ+EUrDv3885PTvwaPctjKHicZBdCLD77V83DIclw6OuWOrC9ix1Qfj6Qq+pKre281RrHdNpRZJuMEBuy2JodFtv9AvvG5p7hLzv8d2EOIk5OT2i00k3Hsn+VO7upiRJTJ5nvH9fEieK4TCRh+CJc857z2K+5OrqljwzvPk/z8nz5GFeiLgLIurCLlEqtLG01gLrEeDlsmG5aJ7XuGWP3E1aQ5Yp7GfOvJ1zNI1jsVhyczPCO8frNxfkefBS7EVZXAWL2ZK72zE//fyKovD13aniAAAZ7UlEQVSMbkv+x/8xPMgiM1vXc++pqobxeMpkPOP84pher/txmuYhtPwSRNSFl4vWwa1YVw6667D6HeNRxWCQfDri/VDPhtTHxWecc1RVzd3dhKaxGKO5uDih2833rnJeU1tub8ecnh0RRwl//LHg13/rvYgiM5umqmqm0zmz6YI4jvjl10vS9JnejXUVBRdE1AXhY0tTUVXfEdn9iYWpLi1l0XB2lr2oKE3bhJaf0LY9LSvmswWz+ZIsTTk5GW6s8ts6rMzJZIbWml6vy91dRZ5HdDuyVHz5uXDM50tGoynee87Ojuh08+3d4299fmQTIKIuCEqFQht+tYio719UnPPM5jVpZkiSl5TvHHplLxcV0yks5ksmkzn9fpeff361N+fln7U0y5rloqDX71BVUNWOi/MMbUQFPjePy7JkOl0wny3o9TucnR3vf3fBXTb8FkTUhT2aMJEKLVj985572zhms5pXF52DbK/68YYnxMaVRcnd3YTRaEmadUiSmF//9vr5LtgtWZvT6RwUxHHKzU1Fvx+TpEYm/ifu93JZMpnMqesapRRvfrpoiwK9gA/oRexF1IXDfVC/4ee9U61r+ftLxXoPd3claRqRd+IXMbSLRcHt7Rh8iOjv93NOT///9u60uY0jzRbwyaqsFbVgIcFFstzumYhZbt+IO///n8xy59otWdxQAGpfM++HojQttyyTFBcAPE+EvzgcpFmoylNvIvPNKRzH/hz4u66uGxRFiflihjQdYEmBMJTcgvXbF9JBYbNJURQVpJSIowD+7doIrTmG/PEbEe8hhjq93AP4m+rElONe9e/RtQPWmwZ/+lO014ExDApd12GzyVBVNVzHQRhN4LhA16nP1fk+DPRd1+P6KsEkmGAYJNq2xXK5vwfrPMnjpDWqqkaSpFBKIY5DTCbe5y5/9B3jEoOeoU54kcVlUgpopTEMgHzg3XN5WWA6tff2u3StNfKswHqTYegHRHGAOD6GY1sQhoDWLYT4vtmM5/57xml3Ac/zsVq18D25/y17H/mlJ0k2qOsWvu8hjgNYljyIr452fizjJWaoM7ifjhAGmkZDqYcFVl33aJoex0t/76p0pRTSbY5kvYXrOojCCVzXge1Yn7elfTqZS6vxH7EHhW7TdEjTHIv5DEWhoAaNeGpz2h23CzrzAh9/vcZsHuFkufji86YdGAN5nzLUGeLfU6kbYxvUB84pp2mLyWR/qvRPZ5h3bYeLi2u07YC3b0/geg5M0/hqpaYhUDcaSj9Wi56nDa10m41Vp2Ehz2ssl+6r35P+qa/A1eUKSin88O4UruswzPdlzHzFQc9QZ3DfM9QFhNBQDwj1rlNomgHzubPz05ZKKXRdjyKvsE0zCAAnp8d33l+ulL5tQLPbf2eeF9hsMrx79warpEUQSASB9Xofzduz69NtgbKs4E88zOfRs51bTwx6hjpD+9nVtbqdfr+fLGshTQHH2d0V1UopVFWNLCvRdz0sS+JoMcMk8O/cIlWI8eS5XV8g1/c9Li8THC/nKCsFrYDFwn21j23f98iyAllWQEqJk9MFXNfhePZaxuUDCX2GOgP8/jfNAwq5rlNIty2Ojt2vt4R90epsHNDrqkFV1yjyCo5j4+h4drsl7R5Puxib9IhPP3hnb1uN66s1gsCHbXtY3TQ4PnZhvsImM+OLXIPNJsUwKEynEYLA51Q7x/K9DHqGOkP8XoQAPFei6+7XKjZJKti2Ac+TO/J3jKv4m7ZFXbcoihJd28PzHZy/WT64WYzAeLa2Ye72rVKVNbqux+JoNraC9U243usbDsqyQp6XaJsOlm3h5CSGZVl/17ufON7vS9Az1BnU979ppIk86xHHd5uabJoeTd1jOtuNfc9CCFRVg/Vqi0ErWJaE57qYzRx43vdPt5qmePB2v+eqTG9uNvAnHtLtgKHXmJ85r2q1e9/3uLleo+8HWLbEfBHD971xOGCg02PmxTM/V5IfCt33DvV9ifW6uns1VHSQ0nzxKl1rjaZpsV6n6NoetmMj9n24ngPLerz/N8MQ4w6BHb3RNuvsdpyxsN32+OHd5NU0mdFaoyhKXF8lcF0Xs1kM17O5EI6eJ2+eIeDlq7qg9AhVLiAtA3U93LEiUmhbBc+TL/ZdulIadV0jywqkaYEonOB4OYdtWzAN49EfNK016lpDqV377ATKskaeFwjDEOuNwvGxA887/EAbX+g6rG7W6Pse8/kUk8BnNzh6+Tx65PFHHuyFoiet1qvqbhe9rnv0vcZ0Zj379O54jGiBZLUZp9h9F2/fnsJ54uYhWgNDv3vr5Pp+QJrmcBwHw2DCtjTCyL7zqv591fcD1skWWVYgjCY4Op7Bti12g6Pdzq8H3p7yoC4CPQtDAO4ddj4Ng0KRd7As49lajmqtMQwKddXg+iaBgMBsHsH3fViW+WwDuRp273MrihJ11SCeTrHdKCyOnINuMvPpjPOLiwSea+H8zRK2zW5wdNhVvdzbP45erk43BKQ00Pfqm1PqZdkjy1r86af4GUJUoet7tE2L1WqLpmlx/maJie9BGOL5qzKxWzdt3/coihqu5yDLFCaBhO8f5glsn7rBbTYZyqLCcjlDGHKLGh1g0It9CXWG+B4MnOP36kFg/G6VvlnXCEMLlvV0R1IqpdDcbkkrihrSMjGbxy8+iI+d93bkcdIaeV6iaVr4XgzTEIgOdNp97AaXo6pqSGni7Q9nsG1u8qFXEPJiF0Kd4b2XDAPwJyaGYYAQ1lcDu2kGNM2Ak9PJkwS6Ugp5Pk4nt20HaY3bkia351q/6EyGEHCc3Qn1tu2QJCl8P0TfC0SxBds+rKq17weURYXNJoOUJhaLKfyJx4eVXl3Ay+f+hbT/xtAyUNf97wSuRpa2iOLH/8626zrUdYuqrJHnJTzfxXI5h7VDC5+EGPeq78I9PwwKq5sNbNuGEDakBHz/cCpXpfTYQCYr0HY9ojhAGE54Djy9Wo/3dDO0X9dLoRYoS4Vxzkf/JngV6rrHyenkUYJWCIGmaZGlOaqqgWmasB2J8zfLne3NPSigaRWcF26lXlU1mqZDGM2Qbjucn08OZtq9qmqkaYGmaeF5Dk4XU9i2xYeTGOoMcbpvyNq2AdPQXwl7IN02cF353SvetR4r8+vrNYa+h+d7CMMJXM95cBvX53vrMdA2L7tRve96XF0mCMIQN9cdTk5cuAewJ10phc0mxXaTIYwCLBZTeB6PRSW6f6gzyAm308uG+Orxq107YHVT4c//OH1wlf7p2NM0zbFZp/B87/ZwFQfGS6xkv/8VGqv14eVCXWtgs8kBCJSFQBCYiKf2Xt93SinUdYub6wRKa5ycHI1nnHOqneiOoc4Qp2+ERtuMwfW307mXlwWmcweWZT7gZ2oURYV1kqJtW0RRgHc/nkNKc+/aeBqGeLEe4kIAZVEhSTaYzY9QFBrLE2+vp92bpsU6SVEUJRaLKYLQh5Rc1U709VBneNN9Q8sUcF3xxcr2tu2RFx3+fDK988pvrQGlxpXL63UKwzDg+Q6WyxmsPW0UMrbSFejal6nU+37A1VWC6WyKotCYzZy9Xe0+DAM2mwzJaosoCvD2h1N2gyP6Zqgz0OmBlai0DPT9ANMc3w2TVY3jI+9OK96V0hiGHk3TYZ1sUZQ1Tk7miKIAhmHs9aD9aXdA33cv8vvXSQrbsTAMFqQEwnD/Fo+pQaGuG6xWGyil8PbtCRzXOfiWtkSPU6kTPSC4hkGgaRRcF6jrAV0PRPG3m5oMw4Cu7VHfrmYfz/Se4s3bk4NZ6CTE7fT7CxTqdd0iLypI6aKqevz0U7hXQai1RlU1KMsKaZojigLMZjG3qBEx1OkpmaaAYwuo26PI8ryFbRuwbfN3KnOFsqiQZQWGQcG2LQShjygKIKU8uDOstQLqRj/z79TYblIIIdE0Js5O/b0Kw7btkKYFiryE6zk4PT36fMY5ETHU6QkZt/3fh2E8WjVLWxwde5Dyy6qw7weUZY2qrNC2HUxpYr6I4boOTHNsH3togQ4ASgNd+7x/V5YXKMsG/eAhimx4e9LbfRgUiqJElubQWuDoeAbPcznVTsRQp+fU9RpaA+ukgmkKuO7/3E5d26GsahR5ha7r4fsuTk6PvmgOog98PcfwjCe1tU2HzTrDMFgwDQthaI1d7XZ5NkNrlEWFNCswDAN830UcR5xqJ2Ko04vcPFKgqnp03YDZzIVlmWOzmKsEbdvD8x34Ew+ObcP17Fe3Yvm5lggopZDlBfpeQ2sb8dSGt+NNZtp2XCDZth08z8V8HsN2bLA2J2Ko0wsQAEwDyNIWQWDBtgWuLlfIixKu42BxFMNxHEhpvsrtR4YBGMbzTEW0TYeyqKG0Dc+3EMe7+wI1HsRTYXWzhuc6t02FbHaDI2Ko00unettpJKsKWlfI8xbxNMDZ6fHt/nLxqvcSj19HPH1QKaWQZjnyvMdkMsFi4f7duobdCHONum6wTrao6g7L5RRBwDPOiRjqtBuZfrsX25QDtJb48U/n8DxWXH97fYQY1w081buN1kCelbi62CCeHiMIbbju7k27d22H9SZFnpYI4wAnpwuYpskGMkRPgCMwPVgYOvjLX84QBAGurxoURY9h0Ae/AO6ugdt1wDA83cXo+x5XVwkmwRSGIRGG9k6tdh8GhSzN8fPPv0INCudvlzg6mkJKyUAnYqVOO/dGaAgEoQ1/YiFLG1xdFJiEFqLQge2YkPI1vzNqKDVOO+MJln8ppZAkWwAWAAvx1NqZaffhthvceFRujeXJAkEw4RY1IoY67Uu4T2cuPN9CsqqwXteQ0oDnSwSBDdMUr7B6F1Dq00ltj/9yU1cNkiQDdIA4Hrew7cI1rqoxzOumhW1LvP3hDJbFYYaIoU77VZdqwLZNnJ4FqOseedYiWdXI8w6zmQvX3Y9GKI8W6QJP9jKjlMbVVYKht+H5NuYL98UDve+Hz6frGYaBo6MZPM/hNDsRQ532netKOI5EEPRYr2vcXFdwXBNRaMN5JeEuhIBp/k8b3cecAdhstsiyDlLGOD31XrTJzLhFrUSWFlBKYTaPMZl4DHMihjodWqXqehInzgRV1SNNG1xeFfA8idnMg20bBz0lbxiA7Qg85rnGQgB5XiJZpRDwMV+48LyXe4SrqsZmk6Hvx25wURRwqp2IoU6HzDAEJhMLjmOirnsUeYf3v2QIo3Ha+FAXTwkhYFuP+7cNg8Jmk6KuDISRh/n8ZY4iHQaF9XqLoqgw8T3MZhFs2+ZCOCKGOr2aG00amExseJ6FNh5wdVVitSrx5m0Ez5M736f8IVV13wOoFcLwcfrc51mJPOsgDBfL5d3OrX9MSmlUZY2bmwTCMLBcLuA4FnsTEDHU6TX6tHjM8yTevg2Q5x0uLwt43rh62/etAwr3cfV73z/Od+pd12O9zlBXBn54Fz5rkxmtNdq2Q7LaoK5bzOcxwmjCMCdiqBONTNNAFDnwfQtZ1uLmuoRlmVgsPDiueRBTuRpA339/ia61xjpJkaxbLBZzhKEF8QzXR2tgGHqsky2KoobnOXjz9uSLk/aIiKFO9LlytywD87mLMLRxc13i48cc8dTBZGLBtvc33IUYW848xjK5sqxxeZnCMNzxNDz76Svkvh9QVTXW6xTQGqdnR3Acm6vaiRjqRH/MsgycnQeoqh6rVYWi6OD7EpOJDdeVMIz9O3/dlAKq+77p974fkKwylKXAD+8iTCZP+8gqpVCWNYq8QlXXCAIf83nMqXYihjrR/Xm+xBs3QJ63yLMWN1UFz5UIo/Gwkn0JdiEELCmghof/DK01irzCxUWOKJpiPneetDtf07TYrFN0XQ/btnB2dgzXdaDZzJ+IoU70sCQbAzEKHfiehaoekGUtfv2QIQxtzObeXiymE2Ks1EX38J/RdT1+/biGMGycnQdP9lKjBoU0zbHZZHBdG/N5DM93IYRgoBMx1IkeJdthSgNBYMDzTBS5xHbboPqQIYocBKEF09ztKWE1aHStftAX61prrNcZ1kmDH388RRTZj/7SoZRGkZfYbHIAGrNZxFXtRAx1oqdlmgai2IHnSxRFj6LokCQ15nMXUezsbNtZpYGu0w9aLFeWNS4+bhBFUxwf+7hPzv7R7xMAmqbD1VUCpTR830UYTeDYFjQeswfePV80eKsTMdTp9bAsE3FsYjKxUJYdbq5LpGmL5YkPyzKxawWm1oDS43fgv/fiob9a4Su8f3+Nqrbxr/8rhuUYjxa0Smls1inWyRZRHCCKx9auhmHgpSfan+r382WBGOpEO+rTNrgoGre9JUmNX35OEccOotiG45g7se1qrHgFxG2k3CewblZbrFYd3r07QRA8zp5wpcYzztfJFm3X4/TsCL7vPct+9134LPgCQAx1oh0PdykNLJc+plNn3OP+a44wHMPdsownCff7BIRhCJgS0LfxfhdN0+GXn1fwvADLpf/dXy1ordG1HbZpgSzLEccBTk+PYUqTN9EDP18GPzHUiZ6QbZuf97hv1g1+/ZAjjGxEkQ0pzc/B+NzTy6YJWDa+Of3+2wD+8P4adWXiL/97Bvkdvd21Boa+H091S7bwJx7Oz5dwXYc3zDO+2PHFgBjqRA+q3AV834LnWciLFtfXJcqyQxg58D0Jy37+ytQ0xzPV7xoC63WG//yPNX766RxhZD+4Sh+GAWVZI90W6PseR8dzhKHPbnB78GLAT4gY6sSB8TejYhDY8H0LSTJ2piuLHrZjII4cWM98jnvfawy9gvkHLxVt2+G//vMa8XSKH96FD9qLr7VGVdXI0gJdP8CyJE5OF5CcamfYE0Od6CUGr8diGALHxz6aRqEsOmR5gyxtMJt7iKLn2gYnMPTAMGgI8fttbrXWuLxYo64F/uVfZnDc+z+Wfd8jWW1R1w1830U8DTnVzueFLwUMdaL9Ce4/rlwB2zZgWQ78iUSWNthuGuR5h+nUgefJJz4wRkDpcRvZtxRFhYuPOc7PY0xn7r1eOIZBobj93ty2JRZHM3iewwYydK9nkaHPUCfaqQD/5oAlxsV084WHMFRIsxaXFwVsx8TRkQfXfZrHwDBwW6Hrb4byh/cbaG3i9CyClMadL3hZVbi52QAamM5CBMGEU+30KM8vQ56hTgzsnSeEgO2YmFsuJhMLed7iw/sck8DGYuFCSuNRp+UNQ8Awvt0/fbVK8fHXDP/0z2/g+3fbkz4MA1Y3G2RZgdk8RhD4sCzJhXD07M887ziGOjHEX5xhCHiehOOYiGMHN9cV/uPf1zg7nyAMbZjm44S7lAKu8/unqldVg5//+wZHxzFOTid/+DuHYUBdt3j/148IwwA/vDtjmNPOjRW8GxnqxAB/sXAf97hPEMU2Li9KlEWPILTg+/KLPe4PnRkwjK9f5GFQuLrYousE/vIPi29+tz92gxuPRW2aBufnS0wCn9+b086PKQx4hjoxtJ+dEGLcBvdnC2naItu22KwbTKffeRrc7YEuwvj7T6Esarz/sMa7d0u43ten3T91g0vTAkVRwfddHB3PYNsWPzQ6iPGHoc9QJ4b4k1bu06mDMLCw2TRYrSqUVY8wtOG5Jkxp3PuzGAZADV/++74f8OuHBJ7n4/Qs/upsQN/3KPIK220Gy7JwcrqA49icaqeDHq94dzPU+UDQozOlgaNjD1HsYL2usU4qpKZAENoIAnvsEnfHi6/U3+9PT1YZLi9L/J9/+xHW37SCFUJAKYU8K5EXBYZBIQwniKfRE2+9I9rtMY13P0OdYU3f9xno8TS45dJHVXZI0xbptkGR94in9p1Xqv9WWdb4f/+d4B/+8QRR7HwR6GVRId1m6AcF13UQLiZwHPubq+eJOCYy/BnqDHG6B9+34LgSTTOgLDpcfCxhOwLL5QT2H7R/NUxAGJ+qdoUPHzaYzgKcnIaf/5thGLBep8jSAkHgYz6N4LrjVDsDnejhY+lrDHmGOkOc7vB5/e02OM+X2Kwb/PWXDNPpp6Neza9WDdIUMI2x8t9uSzT1gJ/+PIeUBpRSKIoK6ySFhsbxcg7fd7mqnegJxtrXEvAMdYY33YNhjKfBOY5EVXXIsw5//SVDFNmYzdwvF9MJQFqAYQoM/YAP7zc4XsbwPImmabG62aDtOkynIYLAhyklpw+JXmA8PqTnTlysNsweBjk95LO+7ete1z0uLnJAC5ydB3Ac83MnuSSpYAiBomjQtD3evInQNjUuLxPE0xDzeQQp2UCGaGdCkaFOvICkBo00bXB5VSEKbYSRBduW2G5qbLYN0m2F83MPbVejbVq8e3cG27EY5kQMeIY6A5x21TAo3NxUyLMOni9RFj3+739tMJsDR0c24tjHdBbxe3MiBv2T4HfqDHB6RKZp4ORkgjjukW5b5FkD31c4P49wdBzBcWxeJKIDy4VdCnpW6gxxeqr7SY/d4wDcngDHqXYiVvOs1BnatJ8PtsBXt7oR0evOmqcMffnaLy4REdFL5dJjB7w85ItFRET0mgJeHtpFISIieq0BL/f5jyYiIjr0gMc9wl7u8x9HRETEan4PQp1BTkRE9Mc5KXYt1BngRERE35+hchf+J4iIiOj7PUuoM8CJiIj2NNQZ4kRERHsc6gxyIiKiPQ11hjgREdGehjpDnIiIaI9DnUFORES0x6HOICciItrzUGeYExER7XmoM8yJiIgOg8FLQERExFAnIiIihjoREREx1ImIiIihTkREdMgkLwHRLuA+lMcneAmIoU5EDOzXcd0Z+sRQJyKG9iv63Bj8xFAnYjAT7wu+EBBDnYgBTa/5PuSLAH0frn4nDqREvH/pYCp13kN0UFjpEBErdSIiImKoExEREUOdiIiIGOpERETEUCciImKoExEREUOdiIiIGOpERETEUCciInpF/j8gLtmCc5T8DAAAAABJRU5ErkJggg==", ogt = (e) => /* @__PURE__ */ p(w8, { ...e, materialsAreEditable: !0 }), Igt = (e) => {
  const t = e.id, i = je(() => new Jz({
    name: "surface",
    color: "blue",
    wireframe: !0
  }), []);
  return /* @__PURE__ */ p(Vge, { args: [e.width, e.height, e.depth], rotation: e.rotation, scale: e.scale, position: e.position, userData: {
    modelId: t
  }, material: i, name: e.name });
}, R8 = "dummy", lgt = ggt(R8)(Igt), sgt = {
  type: R8,
  label: "Dummy",
  disabledForAR: !1,
  component: lgt,
  propsDialog: ogt,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    }
  },
  materials: ["surface"],
  repositionApplicator: nZ,
  screenshot: rgt
};
var agt = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, qa = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, sr = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = Math.pow(10, t)), Math.round(i * e) / i + 0;
}, ul = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = 1), e > i ? i : e > t ? e : t;
}, X8 = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, XT = function(e) {
  return { r: ul(e.r, 0, 255), g: ul(e.g, 0, 255), b: ul(e.b, 0, 255), a: ul(e.a) };
}, Uk = function(e) {
  return { r: sr(e.r), g: sr(e.g), b: sr(e.b), a: sr(e.a, 3) };
}, cgt = /^#([0-9a-f]{3,8})$/i, VW = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, H8 = function(e) {
  var t = e.r, i = e.g, n = e.b, g = e.a, r = Math.max(t, i, n), o = r - Math.min(t, i, n), I = o ? r === t ? (i - n) / o : r === i ? 2 + (n - t) / o : 4 + (t - i) / o : 0;
  return { h: 60 * (I < 0 ? I + 6 : I), s: r ? o / r * 100 : 0, v: r / 255 * 100, a: g };
}, k8 = function(e) {
  var t = e.h, i = e.s, n = e.v, g = e.a;
  t = t / 360 * 6, i /= 100, n /= 100;
  var r = Math.floor(t), o = n * (1 - i), I = n * (1 - (t - r) * i), s = n * (1 - (1 - t + r) * i), a = r % 6;
  return { r: 255 * [n, I, o, o, s, n][a], g: 255 * [s, n, n, I, o, o][a], b: 255 * [o, o, s, n, n, I][a], a: g };
}, HT = function(e) {
  return { h: X8(e.h), s: ul(e.s, 0, 100), l: ul(e.l, 0, 100), a: ul(e.a) };
}, kT = function(e) {
  return { h: sr(e.h), s: sr(e.s), l: sr(e.l), a: sr(e.a, 3) };
}, FT = function(e) {
  return k8((i = (t = e).s, { h: t.h, s: (i *= ((n = t.l) < 50 ? n : 100 - n) / 100) > 0 ? 2 * i / (n + i) * 100 : 0, v: n + i, a: t.a }));
  var t, i, n;
}, BB = function(e) {
  return { h: (t = H8(e)).h, s: (g = (200 - (i = t.s)) * (n = t.v) / 100) > 0 && g < 200 ? i * n / 100 / (g <= 100 ? g : 200 - g) * 100 : 0, l: g / 2, a: t.a };
  var t, i, n, g;
}, dgt = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Cgt = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, ugt = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Agt = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, dx = { string: [[function(e) {
  var t = cgt.exec(e);
  return t ? (e = t[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? sr(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? sr(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var t = ugt.exec(e) || Agt.exec(e);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : XT({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var t = dgt.exec(e) || Cgt.exec(e);
  if (!t)
    return null;
  var i, n, g = HT({ h: (i = t[1], n = t[2], n === void 0 && (n = "deg"), Number(i) * (agt[n] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return FT(g);
}, "hsl"]], object: [[function(e) {
  var t = e.r, i = e.g, n = e.b, g = e.a, r = g === void 0 ? 1 : g;
  return qa(t) && qa(i) && qa(n) ? XT({ r: Number(t), g: Number(i), b: Number(n), a: Number(r) }) : null;
}, "rgb"], [function(e) {
  var t = e.h, i = e.s, n = e.l, g = e.a, r = g === void 0 ? 1 : g;
  if (!qa(t) || !qa(i) || !qa(n))
    return null;
  var o = HT({ h: Number(t), s: Number(i), l: Number(n), a: Number(r) });
  return FT(o);
}, "hsl"], [function(e) {
  var t = e.h, i = e.s, n = e.v, g = e.a, r = g === void 0 ? 1 : g;
  if (!qa(t) || !qa(i) || !qa(n))
    return null;
  var o = function(I) {
    return { h: X8(I.h), s: ul(I.s, 0, 100), v: ul(I.v, 0, 100), a: ul(I.a) };
  }({ h: Number(t), s: Number(i), v: Number(n), a: Number(r) });
  return k8(o);
}, "hsv"]] }, YT = function(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i][0](e);
    if (n)
      return [n, t[i][1]];
  }
  return [null, void 0];
}, bgt = function(e) {
  return typeof e == "string" ? YT(e.trim(), dx.string) : typeof e == "object" && e !== null ? YT(e, dx.object) : [null, void 0];
}, Pk = function(e, t) {
  var i = BB(e);
  return { h: i.h, s: ul(i.s + 100 * t, 0, 100), l: i.l, a: i.a };
}, zk = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, xT = function(e, t) {
  var i = BB(e);
  return { h: i.h, s: i.s, l: ul(i.l + 100 * t, 0, 100), a: i.a };
}, aV = function() {
  function e(t) {
    this.parsed = bgt(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return sr(zk(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return zk(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return zk(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return t = Uk(this.rgba), i = t.r, n = t.g, g = t.b, o = (r = t.a) < 1 ? VW(sr(255 * r)) : "", "#" + VW(i) + VW(n) + VW(g) + o;
    var t, i, n, g, r, o;
  }, e.prototype.toRgb = function() {
    return Uk(this.rgba);
  }, e.prototype.toRgbString = function() {
    return t = Uk(this.rgba), i = t.r, n = t.g, g = t.b, (r = t.a) < 1 ? "rgba(" + i + ", " + n + ", " + g + ", " + r + ")" : "rgb(" + i + ", " + n + ", " + g + ")";
    var t, i, n, g, r;
  }, e.prototype.toHsl = function() {
    return kT(BB(this.rgba));
  }, e.prototype.toHslString = function() {
    return t = kT(BB(this.rgba)), i = t.h, n = t.s, g = t.l, (r = t.a) < 1 ? "hsla(" + i + ", " + n + "%, " + g + "%, " + r + ")" : "hsl(" + i + ", " + n + "%, " + g + "%)";
    var t, i, n, g, r;
  }, e.prototype.toHsv = function() {
    return t = H8(this.rgba), { h: sr(t.h), s: sr(t.s), v: sr(t.v), a: sr(t.a, 3) };
    var t;
  }, e.prototype.invert = function() {
    return lr({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, e.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), lr(Pk(this.rgba, t));
  }, e.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), lr(Pk(this.rgba, -t));
  }, e.prototype.grayscale = function() {
    return lr(Pk(this.rgba, -1));
  }, e.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), lr(xT(this.rgba, t));
  }, e.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), lr(xT(this.rgba, -t));
  }, e.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, e.prototype.alpha = function(t) {
    return typeof t == "number" ? lr({ r: (i = this.rgba).r, g: i.g, b: i.b, a: t }) : sr(this.rgba.a, 3);
    var i;
  }, e.prototype.hue = function(t) {
    var i = BB(this.rgba);
    return typeof t == "number" ? lr({ h: t, s: i.s, l: i.l, a: i.a }) : sr(i.h);
  }, e.prototype.isEqual = function(t) {
    return this.toHex() === lr(t).toHex();
  }, e;
}(), lr = function(e) {
  return e instanceof aV ? e : new aV(e);
}, DT = [], F8 = function(e) {
  e.forEach(function(t) {
    DT.indexOf(t) < 0 && (t(aV, dx), DT.push(t));
  });
}, OKt = function() {
  return new aV({ r: 255 * Math.random(), g: 255 * Math.random(), b: 255 * Math.random() });
};
function i2() {
  return (i2 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }).apply(this, arguments);
}
function Y8(e, t) {
  if (e == null)
    return {};
  var i, n, g = {}, r = Object.keys(e);
  for (n = 0; n < r.length; n++)
    t.indexOf(i = r[n]) >= 0 || (g[i] = e[i]);
  return g;
}
function Cx(e) {
  var t = Ct(e), i = Ct(function(n) {
    t.current && t.current(n);
  });
  return t.current = e, i.current;
}
var gZ = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = 1), e > i ? i : e < t ? t : e;
}, ZB = function(e) {
  return "touches" in e;
}, ux = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, JT = function(e, t, i) {
  var n = e.getBoundingClientRect(), g = ZB(t) ? function(r, o) {
    for (var I = 0; I < r.length; I++)
      if (r[I].identifier === o)
        return r[I];
    return r[0];
  }(t.touches, i) : t;
  return { left: gZ((g.pageX - (n.left + ux(e).pageXOffset)) / n.width), top: gZ((g.pageY - (n.top + ux(e).pageYOffset)) / n.height) };
}, KT = function(e) {
  !ZB(e) && e.preventDefault();
}, x8 = Se.memo(function(e) {
  var t = e.onMove, i = e.onKey, n = Y8(e, ["onMove", "onKey"]), g = Ct(null), r = Cx(t), o = Cx(i), I = Ct(null), s = Ct(!1), a = je(function() {
    var A = function(B) {
      KT(B), (ZB(B) ? B.touches.length > 0 : B.buttons > 0) && g.current ? r(JT(g.current, B, I.current)) : h(!1);
    }, m = function() {
      return h(!1);
    };
    function h(B) {
      var f = s.current, G = ux(g.current), y = B ? G.addEventListener : G.removeEventListener;
      y(f ? "touchmove" : "mousemove", A), y(f ? "touchend" : "mouseup", m);
    }
    return [function(B) {
      var f = B.nativeEvent, G = g.current;
      if (G && (KT(f), !function(W, V) {
        return V && !ZB(W);
      }(f, s.current) && G)) {
        if (ZB(f)) {
          s.current = !0;
          var y = f.changedTouches || [];
          y.length && (I.current = y[0].identifier);
        }
        G.focus(), r(JT(G, f, I.current)), h(!0);
      }
    }, function(B) {
      var f = B.which || B.keyCode;
      f < 37 || f > 40 || (B.preventDefault(), o({ left: f === 39 ? 0.05 : f === 37 ? -0.05 : 0, top: f === 40 ? 0.05 : f === 38 ? -0.05 : 0 }));
    }, h];
  }, [o, r]), d = a[0], C = a[1], u = a[2];
  return et(function() {
    return u;
  }, [u]), Se.createElement("div", i2({}, n, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: g, onKeyDown: C, tabIndex: 0, role: "slider" }));
}), PJ = function(e) {
  return e.filter(Boolean).join(" ");
}, D8 = function(e) {
  var t = e.color, i = e.left, n = e.top, g = n === void 0 ? 0.5 : n, r = PJ(["react-colorful__pointer", e.className]);
  return Se.createElement("div", { className: r, style: { top: 100 * g + "%", left: 100 * i + "%" } }, Se.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, Mo = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = Math.pow(10, t)), Math.round(i * e) / i;
}, mgt = function(e) {
  var t = e.s, i = e.v, n = e.a, g = (200 - t) * i / 100;
  return { h: Mo(e.h), s: Mo(g > 0 && g < 200 ? t * i / 100 / (g <= 100 ? g : 200 - g) * 100 : 0), l: Mo(g / 2), a: Mo(n, 2) };
}, Ax = function(e) {
  var t = mgt(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, hgt = function(e) {
  var t = e.h, i = e.s, n = e.v, g = e.a;
  t = t / 360 * 6, i /= 100, n /= 100;
  var r = Math.floor(t), o = n * (1 - i), I = n * (1 - (t - r) * i), s = n * (1 - (1 - t + r) * i), a = r % 6;
  return { r: Mo(255 * [n, I, o, o, s, n][a]), g: Mo(255 * [s, n, n, I, o, o][a]), b: Mo(255 * [o, o, s, n, n, I][a]), a: Mo(g, 2) };
}, pgt = function(e) {
  var t = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
  return t ? Zgt({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : { h: 0, s: 0, v: 0, a: 1 };
}, Bgt = pgt, Zgt = function(e) {
  var t = e.r, i = e.g, n = e.b, g = e.a, r = Math.max(t, i, n), o = r - Math.min(t, i, n), I = o ? r === t ? (i - n) / o : r === i ? 2 + (n - t) / o : 4 + (t - i) / o : 0;
  return { h: Mo(60 * (I < 0 ? I + 6 : I)), s: Mo(r ? o / r * 100 : 0), v: Mo(r / 255 * 100), a: g };
}, fgt = Se.memo(function(e) {
  var t = e.hue, i = e.onChange, n = PJ(["react-colorful__hue", e.className]);
  return Se.createElement("div", { className: n }, Se.createElement(x8, { onMove: function(g) {
    i({ h: 360 * g.left });
  }, onKey: function(g) {
    i({ h: gZ(t + 360 * g.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": Mo(t), "aria-valuemax": "360", "aria-valuemin": "0" }, Se.createElement(D8, { className: "react-colorful__hue-pointer", left: t / 360, color: Ax({ h: t, s: 100, v: 100, a: 1 }) })));
}), Ggt = Se.memo(function(e) {
  var t = e.hsva, i = e.onChange, n = { backgroundColor: Ax({ h: t.h, s: 100, v: 100, a: 1 }) };
  return Se.createElement("div", { className: "react-colorful__saturation", style: n }, Se.createElement(x8, { onMove: function(g) {
    i({ s: 100 * g.left, v: 100 - 100 * g.top });
  }, onKey: function(g) {
    i({ s: gZ(t.s + 100 * g.left, 0, 100), v: gZ(t.v - 100 * g.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + Mo(t.s) + "%, Brightness " + Mo(t.v) + "%" }, Se.createElement(D8, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Ax(t) })));
}), ygt = function(e, t) {
  if (e === t)
    return !0;
  for (var i in e)
    if (e[i] !== t[i])
      return !1;
  return !0;
}, Wgt = function(e, t) {
  return e.replace(/\s/g, "") === t.replace(/\s/g, "");
};
function Sgt(e, t, i) {
  var n = Cx(i), g = At(function() {
    return e.toHsva(t);
  }), r = g[0], o = g[1], I = Ct({ color: t, hsva: r });
  et(function() {
    if (!e.equal(t, I.current.color)) {
      var a = e.toHsva(t);
      I.current = { hsva: a, color: t }, o(a);
    }
  }, [t, e]), et(function() {
    var a;
    ygt(r, I.current.hsva) || e.equal(a = e.fromHsva(r), I.current.color) || (I.current = { hsva: r, color: a }, n(a));
  }, [r, e, n]);
  var s = ft(function(a) {
    o(function(d) {
      return Object.assign({}, d, a);
    });
  }, []);
  return [r, s];
}
var Vgt = typeof window < "u" ? Um : et, wgt = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, ET = /* @__PURE__ */ new Map(), vgt = function(e) {
  Vgt(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !ET.has(t)) {
      var i = t.createElement("style");
      i.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, ET.set(t, i);
      var n = wgt();
      n && i.setAttribute("nonce", n), t.head.appendChild(i);
    }
  }, []);
}, Rgt = function(e) {
  var t = e.className, i = e.colorModel, n = e.color, g = n === void 0 ? i.defaultColor : n, r = e.onChange, o = Y8(e, ["className", "colorModel", "color", "onChange"]), I = Ct(null);
  vgt(I);
  var s = Sgt(i, g, r), a = s[0], d = s[1], C = PJ(["react-colorful", t]);
  return Se.createElement("div", i2({}, o, { ref: I, className: C }), Se.createElement(Ggt, { hsva: a, onChange: d }), Se.createElement(fgt, { hue: a.h, onChange: d, className: "react-colorful__last-control" }));
}, Xgt = { defaultColor: "rgb(0, 0, 0)", toHsva: Bgt, fromHsva: function(e) {
  var t = hgt(e);
  return "rgb(" + t.r + ", " + t.g + ", " + t.b + ")";
}, equal: Wgt }, Hgt = function(e) {
  return Se.createElement(Rgt, i2({}, e, { colorModel: Xgt }));
};
const kgt = (e, t) => ce.mapValues(t, (i, n) => ({
  ...i,
  label: e + "-" + n
})), Ok = (e) => (e || "").replace("#", "").trim(), X0 = kgt("OCColorPicker", {
  rgbContainer: {
    display: "grid",
    gridTemplateColumns: "auto auto auto",
    gridGap: (e) => e.spacing(1)
  },
  rgbInput: {
    width: "100%"
  },
  container: {
    display: "grid",
    gridGap: (e) => e.spacing(1),
    gridTemplateRows: "auto auto auto",
    justifyItems: "center",
    margin: 1,
    marginBottom: 2,
    width: 200
  }
}), Fgt = ({
  onChange: e,
  value: t,
  mode: i = "hex"
}) => {
  const n = je(() => {
    if (t) {
      if (t.startsWith("rgba"))
        return t;
    } else
      return "rgba(0,0,0,1)";
    return lr(t).toRgbString();
  }, [t]), [g, r] = At(Ok(lr(t).toHex())), [o, I] = At(lr(t).toRgb()), s = (m, h = !0) => {
    if (lr(m).isValid()) {
      const B = i === "hex" ? lr(m).toHex() : m;
      h && r(Ok(lr(m).toHex())), I(lr(m).toRgb()), e(B);
    }
  }, a = (m) => {
    const h = Ok(m.target.value);
    m.nativeEvent.inputType === "insertFromPaste" ? r(h) : h.length <= 6 && r(m.target.value), s("#" + h, !1);
  }, d = (m) => (h) => {
    const B = {
      ...o,
      [m]: h.target.value
    };
    lr(B).isValid() ? s(B) : I(B);
  }, C = d("r"), u = d("g"), A = d("b");
  return /* @__PURE__ */ ge(fe, { component: "div", sx: X0.container, "data-cy": "colorPickerContainer", children: [
    /* @__PURE__ */ p(Hgt, { "data-cy": "colorPickerColorGradient", onChange: s, color: n }),
    /* @__PURE__ */ p(Gu, { variant: "standard", label: "HEX", onChange: a, value: g, error: !lr("#" + g).isValid(), InputProps: {
      startAdornment: /* @__PURE__ */ p(pm, { position: "start", children: "#" })
    }, inputProps: {
      "data-cy": "hex"
    } }),
    /* @__PURE__ */ ge(fe, { component: "div", sx: X0.rgbContainer, children: [
      /* @__PURE__ */ p(Gu, { sx: X0.rgbInput, type: "number", variant: "standard", label: "R", onChange: C, value: o.r, inputProps: {
        "data-cy": "colorR"
      } }),
      /* @__PURE__ */ p(Gu, { sx: X0.rgbInput, type: "number", variant: "standard", label: "G", onChange: u, value: o.g, inputProps: {
        "data-cy": "colorG"
      } }),
      /* @__PURE__ */ p(Gu, { sx: X0.rgbInput, type: "number", variant: "standard", label: "B", onChange: A, value: o.b, inputProps: {
        "data-cy": "colorB"
      } })
    ] })
  ] });
};
function uS(e) {
  const {
    value: t,
    onChange: i,
    ...n
  } = e.SelectProps || {}, g = ce.merge({
    fullWidth: !0,
    variant: "outlined"
  }, e.FormControllProps ?? {}), r = t || e.value, o = (I) => {
    i && i(I, I.target), e.onChange && e.onChange(I.target.value);
  };
  return /* @__PURE__ */ ge(fs, { ...g, children: [
    e.label && /* @__PURE__ */ p(Ne, { component: "label", htmlFor: n.id, color: "textSecondary", children: e.label }),
    /* @__PURE__ */ p(i1, { value: r, onChange: o, "data-cy": e["data-cy"], ...n, disabled: e.disabled, multiple: e.multiple, MenuProps: {
      MenuListProps: {
        sx: {
          maxHeight: "35vh"
        }
      }
    }, children: e.children })
  ] });
}
const zJ = (e) => e.k3d.screenshotting, Ygt = (e) => e.k3d.isScreenshottingPossible, xgt = (e) => e.k3d.modelRuleData, n2 = (e) => e.k3d.editMode, J8 = (e) => e.k3d.nextCameraPosition, Dgt = (e) => e.k3d.forceNextCameraPosition, rf = (e) => e.k3d.isSceneLoading, Jgt = [], K8 = (e) => e.k3d.loadedModelIds || Jgt, Kgt = (e, t, i) => {
  const n = e.clone().sub(i).normalize();
  let g = t.clone().cross(n).normalize();
  if (g.lengthSq() === 0) {
    const r = n.clone();
    r.x += 1e-4, r.y += 1e-4, r.z += 1e-4, g = t.clone().cross(r).normalize();
  }
  return g;
}, NT = (e) => {
  var I, s, a, d;
  const {
    scene: t
  } = Mu(), i = ((I = e.parameters) == null ? void 0 : I.length) ?? 0.05, n = (((s = e.parameters) == null ? void 0 : s.offset) ?? 0.5) * -i, g = n + i;
  let r = (a = e.parameters) != null && a.direction ? new xt(...((d = e.parameters) == null ? void 0 : d.direction) ?? []).normalize() : void 0;
  if (!r) {
    const C = t == null ? void 0 : t.getObjectByName("k3d");
    let u = new xt();
    try {
      u = new qV().setFromObject(C).getCenter(new xt()) ?? new xt();
    } catch {
      u = new xt();
    }
    const A = Kgt(e.center, e.direction, u);
    r = e.direction.clone().cross(L8(A, N8).clone()).normalize();
  }
  const o = [new xt(...e.endpoint).add(new xt().copy(r).multiplyScalar(n)).toArray(), new xt(...e.endpoint).add(new xt().copy(r).multiplyScalar(g)).toArray()];
  return /* @__PURE__ */ p(
    eS,
    {
      color: e.color,
      lineWidth: e.lineWidth,
      points: o
    }
  );
}, E8 = new xt(0, 1, 0), N8 = [new xt(1, 0, 0), E8, new xt(0, 0, 1)];
function L8(e, t) {
  let i = t[0], n = Math.abs(e.clone().dot(t[0]));
  for (let g = 1; g < t.length; g++) {
    const r = Math.abs(e.clone().dot(t[g]));
    r > n && (i = t[g], n = r);
  }
  return i;
}
const LT = (e, t) => Math.abs(e - t) / e > 25e-4;
function Egt(e) {
  const t = Ct(null), i = Ct(null), n = new Kz().setFromEuler(new d5(...e.rotation ?? [0, 0, 0])), [g, r] = At(0), [o, I] = At(0);
  tw((d) => {
    var A, m;
    const C = n.rotateTowards(d.camera.quaternion, 99999);
    (A = t.current) == null || A.quaternion.copy(C), (m = t.current) == null || m.updateMatrixWorld();
    const u = d.camera.position.distanceTo(e.textWorldPosition);
    LT(g, u) && r(u), i.current && e.sprite && i.current.quaternion.copy(d.camera.quaternion);
  });
  const s = (e.size ?? 1) * g / 100, a = s;
  return et(() => {
    e.onMaxTextDimensionChange && (L8(e.direction, N8).equals(E8) ? e.onMaxTextDimensionChange(s + a) : e.onMaxTextDimensionChange(o + a));
  }, [e, o, s, a, e.onMaxTextDimensionChange]), /* @__PURE__ */ p("group", { ref: t, position: e.position, castShadow: !1, receiveShadow: !1, children: /* @__PURE__ */ ge(wge, { anchorX: "center", anchorY: "middle", ref: i, fontSize: s, lineHeight: 1, color: e.color, outlineWidth: 0.1, outlineColor: "white", clipRect: [-(o + a) / 2, -(s + a) / 2.5, (o + a) / 2, (s + a) / 2], onSync: (d) => {
    const C = d.geometry.boundingBox.max.x - d.geometry.boundingBox.min.x;
    LT(C, o) && I(C);
  }, children: [
    e.text,
    " ",
    e.unit || "",
    /* @__PURE__ */ p(Lgt, {})
  ] }) });
}
const Ngt = (e) => {
  const t = Ct(null), i = _(n2), n = e.formatter ?? ((v) => v.toFixed(e.digits ?? 2)), [g, r] = At(new xt()), o = new xt(...e.startPoint).sub(new xt(...e.endPoint)), [I, s] = At(new xt()), a = e.length ?? o.length(), d = (e.textPosition ? new xt(...e.textPosition) : new xt(...e.startPoint).add(new xt().copy(o).multiplyScalar(-0.5))).toArray(), C = e.color ?? "black", u = e.thickness ?? 1, [A, m] = At(0), h = ft((v) => {
    v !== A && m(v);
  }, [A]), B = e.lineClamp ?? Math.max(0, 0.5 - A / 1.5 / a), f = new xt(...e.startPoint).add(new xt().copy(o).multiplyScalar(-B)).toArray(), G = new xt(...e.endPoint).add(new xt().copy(o).multiplyScalar(B)).toArray(), y = new xt(...e.endPoint).sub(new xt(...e.startPoint)).normalize(), W = ft((v) => {
    const H = (v == null ? void 0 : v.localToWorld(new xt(...d))) || new xt();
    g.equals(H) || r(H);
  }, [d, g]), V = ft((v) => {
    let H = new xt(...e.startPoint).add(new xt(...e.endPoint).sub(new xt(...e.startPoint)).multiplyScalar(0.5));
    H = v.localToWorld(H), !I.equals(H) && s(H);
  }, [e.startPoint, e.endPoint, I]), w = ft((v) => {
    W(v), V(v);
  }, [W, V]);
  return /* @__PURE__ */ ge("group", { ref: t, position: e.position, userData: {
    modelId: e.id
  }, onUpdate: w, name: e.name, children: [
    !i && e.textType !== "none" && /* @__PURE__ */ p(Egt, { color: e.textColor ?? "black", size: e.textSize ?? 1, sprite: e.textSprite ?? !1, position: d, text: e.textType === "number" ? n(e.textStatic ?? a) : e.textStaticString, rotation: e.textRotation, textWorldPosition: g, unit: e.unit, direction: y, onMaxTextDimensionChange: h }),
    /* @__PURE__ */ ge("group", { rotation: e.rotation, children: [
      e.startAnchor == "ruler" && /* @__PURE__ */ p(NT, { center: I, direction: y, color: C, lineWidth: u, parameters: e.endLines, endpoint: e.startPoint }),
      e.endAnchor == "ruler" && /* @__PURE__ */ p(NT, { center: I, direction: y, color: C, lineWidth: u, parameters: e.endLines, endpoint: e.endPoint }),
      e.textType == "number" || e.textType == "string" && e.textStaticString.trim() != "" ? /* @__PURE__ */ ge(Bt, { children: [
        /* @__PURE__ */ p(
          eS,
          {
            color: C,
            lineWidth: u,
            points: [e.startPoint, f]
          }
        ),
        /* @__PURE__ */ p(
          eS,
          {
            color: C,
            lineWidth: u,
            points: [e.endPoint, G]
          }
        )
      ] }) : /* @__PURE__ */ p(
        eS,
        {
          color: C,
          lineWidth: u,
          points: [e.startPoint, e.endPoint]
        }
      )
    ] })
  ] });
}, Lgt = (e) => /* @__PURE__ */ p("meshBasicMaterial", { attach: "material", color: e.color, toneMapped: !1, reflectivity: 0, fog: !1, map: e.map }), Tgt = "data:image/png;base64,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", rm = {
  expression: "0"
}, Mgt = {
  color: "#000",
  startPoint: [rm, rm, rm],
  endPoint: [rm, {
    expression: "1"
  }, rm],
  thickness: {
    expression: "1"
  },
  digits: {
    expression: "2"
  },
  textType: "number",
  startAnchor: "ruler",
  endAnchor: "ruler",
  textStaticString: ""
}, Ugt = {
  textStatic: rm
}, Pgt = ({
  dynamicModelProps: e,
  expressionChange: t,
  toggleVisibility: i,
  isVisible: n,
  onChange: g,
  ruleItem: r,
  ruleColumnId: o,
  model: I,
  modelActionRuleItemValue: s
}) => {
  var u, A, m, h, B;
  const {
    t: a
  } = ii(), d = i(Ugt), C = _(KZ(r == null ? void 0 : r.id, o));
  return /* @__PURE__ */ ge(_t, { maxWidth: 800, children: [
    /* @__PURE__ */ p(Ne, { variant: "h5", children: a("Allgemein") }),
    /* @__PURE__ */ ge(_t, { mt: 3, children: [
      /* @__PURE__ */ p(Ne, { children: a("Farbe") }),
      /* @__PURE__ */ p(Fgt, { value: e.color, onChange: g("color") })
    ] }),
    /* @__PURE__ */ p(_t, { mt: 3, children: /* @__PURE__ */ p(pB, { debounced: !0, defaultValues: e.startPoint, sx: {
      maxWidth: "400px"
    }, label: a("Startpunkt"), onChange: g("startPoint"), expression: !0, anchoringSelections: C }) }),
    /* @__PURE__ */ p(_t, { mt: 3, children: /* @__PURE__ */ p(pB, { debounced: !0, defaultValues: e.endPoint, sx: {
      maxWidth: "400px"
    }, label: a("Endpunkt"), onChange: g("endPoint"), expression: !0, anchoringSelections: C }) }),
    /* @__PURE__ */ p(_t, { mt: 3, children: /* @__PURE__ */ p(BI, { value: (u = e.thickness) == null ? void 0 : u.expression, onChange: t("thickness"), label: a("Linienstärke"), sx: {
      maxWidth: 300
    }, anchoringSelections: C }) }),
    /* @__PURE__ */ ge(_t, { mt: 3, children: [
      /* @__PURE__ */ ge(uS, { "data-cy": "startAnchor", label: a("Startanker"), value: e.startAnchor, onChange: g("startAnchor"), children: [
        /* @__PURE__ */ p(bd, { value: "ruler", children: a("Maßkette") }),
        /* @__PURE__ */ p(bd, { value: "none", children: a("Ohne") })
      ] }),
      /* @__PURE__ */ ge(uS, { "data-cy": "endAnchor", label: a("Endanker"), value: e.endAnchor, onChange: g("endAnchor"), children: [
        /* @__PURE__ */ p(bd, { value: "ruler", children: a("Maßkette") }),
        /* @__PURE__ */ p(bd, { value: "none", children: a("Ohne") })
      ] })
    ] }),
    /* @__PURE__ */ p(Ne, { variant: "h5", sx: {
      mt: 5
    }, children: a("Text") }),
    /* @__PURE__ */ ge(uS, { "data-cy": "textType", label: a("Texttyp"), value: e.textType, onChange: (f) => {
      g("textType")(f);
    }, children: [
      /* @__PURE__ */ p(bd, { value: "none", children: a("Kein Text") }),
      /* @__PURE__ */ p(bd, { value: "number", children: a("Zahlenwert") }),
      /* @__PURE__ */ p(bd, { value: "string", children: a("Statischer Text") })
    ] }),
    e.textType === "number" && /* @__PURE__ */ ge(_t, { mt: 3, children: [
      /* @__PURE__ */ p(m7, { "data-cy": "overrideStandardText", checked: n("textStatic"), onChange: d("textStatic"), label: a("Automatisches Maß überschreiben") }),
      n("textStatic") && e.textStatic && /* @__PURE__ */ p(BI, { value: (A = e.textStatic) == null ? void 0 : A.expression, onChange: t("textStatic"), label: a("Neues Maß"), sx: {
        maxWidth: 300
      }, anchoringSelections: C }),
      /* @__PURE__ */ p(BI, { value: ((m = e.textSize) == null ? void 0 : m.expression) ?? "1", onChange: t("textSize"), label: a("Textgröße als Faktor. 1 ist Standard."), sx: {
        maxWidth: 300
      }, anchoringSelections: C }),
      /* @__PURE__ */ p(BI, { value: (h = e.digits) == null ? void 0 : h.expression, onChange: t("digits"), label: a("Nachkommastellen"), sx: {
        maxWidth: 300
      }, anchoringSelections: C }),
      /* @__PURE__ */ p($n, { "data-cy": "unit", label: a("Einheit"), value: e.unit, onChange: g("unit") })
    ] }),
    e.textType === "string" && /* @__PURE__ */ ge(_t, { mt: 3, children: [
      /* @__PURE__ */ p($n, { "data-cy": "textStatic", label: a("Statischer Text"), value: e.textStaticString, onChange: (f) => {
        g("textStaticString")(f);
      } }),
      /* @__PURE__ */ p(BI, { value: ((B = e.textSize) == null ? void 0 : B.expression) ?? "1", onChange: t("textSize"), label: a("Textgröße als Faktor. 1 ist Standard."), sx: {
        maxWidth: 300
      }, anchoringSelections: C })
    ] }),
    /* @__PURE__ */ p(_t, { mt: 3, children: /* @__PURE__ */ ge(M5, { children: [
      /* @__PURE__ */ p(P5, { expandIcon: /* @__PURE__ */ p(OD, {}), children: /* @__PURE__ */ p(Ne, { variant: "h5", children: a("Offsets") }) }),
      /* @__PURE__ */ ge(U5, { children: [
        /* @__PURE__ */ p(Ne, { variant: "body1", children: a("Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.") }),
        /* @__PURE__ */ p(V8, { modelActionRuleItemValue: s, model: I, ruleItem: r, onChange: g })
      ] })
    ] }) }),
    /* @__PURE__ */ p(_t, { mt: 3 })
  ] });
}, zgt = {
  type: "ruler",
  label: "Maßkette",
  disabledForAR: !0,
  component: Ngt,
  defaultProps: Mgt,
  propsDialog: Pgt,
  repositionApplicator: nZ,
  materials: [],
  screenshot: Tgt
}, rZ = () => ms("getDynamicModels", [qnt, zgt, sgt]), Ogt = (e, t) => {
  const i = rZ().find((g) => g.type === e.dynamicModelKey);
  let n;
  return i ? n = i.component : console.error("Dynamic model not found", t.modelId), n;
}, Qgt = (e, t, i) => ZD((n, g, r) => {
  const o = ce.isArray(g), s = (o ? g : [g]).map((a) => {
    let d = 0;
    if (b6(a)) {
      const C = D1(e.variables.flat.all, e.values.flat.all, e.variables.variableHierarchies, t, a.expression, i);
      C.errorMessage && console.error(C.errorMessage), C.result && (d = C.result);
    } else
      d = a;
    return d;
  });
  return {
    ...n,
    [r]: o ? s : s[0]
  };
}, {}), T8 = (e, t, i, n, g = Dt) => {
  const r = rZ().find((s) => s.type === (i == null ? void 0 : i.dynamicModelKey)), o = {
    ...r == null ? void 0 : r.defaultProps,
    ...i == null ? void 0 : i.props,
    ...n == null ? void 0 : n.props
  };
  return [Qgt(e, t, g)(o), o];
}, jgt = {
  type: "hideGroups",
  isOfType: nGe,
  createActions: NZ
}, _gt = (e, {
  column: t,
  ruleItem: i,
  ruleEngineInput: n,
  selectionScopes: g,
  validSelectionCombinations: r
}) => {
  const o = Ni(n.values.flat.all), I = ce.uniq(e.values.map((C) => {
    var u;
    return (u = o[C]) == null ? void 0 : u.variableId;
  }).filter(Boolean)), s = n.variables.byVarId.all, a = (r == null ? void 0 : r[i.id]) ?? [];
  return Jj(I, s, i, g, a, (C, u) => ({
    variableId: C,
    valueIds: e.values.filter((A) => o[A].variableId === C),
    instanceIds: u,
    ruleItem: i,
    ruleColumn: t
  }));
}, $gt = {
  type: "hideValues",
  isOfType: gGe,
  createActions: _gt
}, qgt = Kj(), ert = {
  type: "hideVariables",
  isOfType: iGe,
  createActions: qgt
}, trt = {
  type: "images",
  isOfType: lGe,
  createActions: NZ
}, irt = (e, t) => {
  var g;
  const i = (g = t.column) == null ? void 0 : g.targetId, n = t.actionEngineInput.variables.find((r) => r.id === e.variableId);
  return zD(t, n == null ? void 0 : n.id, (r, o, I) => {
    var s, a, d, C, u;
    return {
      targetMaterial: i,
      materialUrl: ((s = r == null ? void 0 : r.data) == null ? void 0 : s.url) ?? "",
      scale: ((a = r == null ? void 0 : r.data) == null ? void 0 : a.scale) ?? 1,
      topbottom: ((d = r == null ? void 0 : r.data) == null ? void 0 : d.topbottom) ?? 1,
      leftright: ((C = r == null ? void 0 : r.data) == null ? void 0 : C.leftright) ?? 1,
      hideOriginalMapWhenPrinting: (u = n == null ? void 0 : n.settings.templateOptions) == null ? void 0 : u.hideOriginalMapWhenPrinting,
      selections: o,
      selectionScope: I,
      ruleItem: t.ruleItem,
      ruleColumn: t.column,
      anchoringSelection: r
    };
  });
}, nrt = {
  type: "prints",
  isOfType: yD,
  createActions: irt
}, grt = (e, {
  column: t,
  ruleItem: i,
  validSelectionCombinations: n,
  selectionScopes: g,
  ruleEngineInput: r
}) => {
  const o = n[i.id], I = r.variables.byVarId.all, s = r.values.flat.all, a = Ni(s);
  return (o ?? []).reduce((C, u) => {
    const A = PD(u, g[i.id]), m = a[e.valueId];
    if (!m)
      return console.warn(`Could not find value with id ${e.valueId} for actionEntry ${JSON.stringify(e, null, 2)} of ruleItem ${JSON.stringify(i, null, 2)}!`), C;
    const h = I[m.variableId];
    if (!h)
      return console.warn(`Could not find variable with id ${m.variableId} for value ${JSON.stringify(m, null, 2)}!`), C;
    const B = h.parentId ? h.parentId : Dt.variableId, f = A[B];
    return f && f.forEach((G) => {
      C.push({
        ...e,
        selectionScope: A,
        parentSelection: G,
        anchoringSelection: W1(u),
        ruleItem: i,
        ruleColumn: t
      });
    }), C;
  }, []);
}, rrt = {
  type: "instances",
  isOfType: HQ,
  createActions: grt
}, ort = {
  type: "labels",
  isOfType: $fe,
  createActions: NZ
}, Irt = (e, t) => (t.column.targets || []).flatMap((n) => zD(t, void 0, (g, r, o) => ({
  ...n,
  replacementMaterialId: e.materialId,
  ruleItem: t.ruleItem,
  ruleColumn: t.column,
  selections: r,
  selectionScope: o,
  anchoringSelection: g
}))) || [], lrt = {
  type: "materials",
  isOfType: IGe,
  createActions: Irt
}, srt = (e, {
  validSelectionCombinations: t,
  ruleItem: i,
  column: n,
  rule: g,
  selections: r,
  ruleEngineInput: o,
  metadata: I
}) => (t[i.id] ?? []).map((d) => {
  const C = I.models.find((h) => h.id === e.modelId);
  if (!C)
    return null;
  const u = W1(d), [A, m] = T8(o, r, C, e, u);
  return {
    ...e,
    expressionProps: m,
    unique: `ruleItem_${i.id}_ruleId_${g == null ? void 0 : g.id}_modelId_${e.modelId}_anchoringSelectionId_${u.instance.id}`,
    ruleItem: i,
    ruleColumn: n,
    selections: d,
    props: A,
    model: C,
    anchoringSelection: u
  };
}).filter(Boolean), art = {
  type: "models",
  isOfType: QS,
  createActions: srt
}, crt = {
  type: "popups",
  isOfType: qfe,
  createActions: NZ
};
function drt(e, t, i, n, g) {
  if (e != null && e.modelId) {
    const r = y1(t, i.state.all.selections), o = n.models.find((I) => I.id === e.modelId);
    if (o) {
      const [I, s] = T8(t, r, o);
      g.models.push({
        id: Og.SetModel,
        modelId: e.modelId,
        model: o,
        props: I,
        expressionProps: s,
        anchoringSelection: Dt,
        ruleItem: null,
        ruleColumn: null,
        unique: `ruleItem_-1_ruleId_${Og.SetModel}_modelId_${e.modelId}_anchoringSelectionId_${Dt.id}`
      });
    }
  }
}
const M8 = (e, t, i, n, g) => {
  const r = r6e([Nje, Pje, zje, Qje, jgt, $gt, ert, rrt, ort, crt, lrt, art, nrt, trt])(e, t, i, n, g);
  return drt(n, t, i, g, r), r;
};
function Crt(e, t, i, n, g) {
  const r = /* @__PURE__ */ new Set(), o = Array.from(i[n] ?? []).map((d) => ({
    variable: t[d],
    depth: 1
  })), s = e.filter(yl).reduce((d, C) => (d.push([C.id, i[C.id]]), d), []), a = /* @__PURE__ */ new Set();
  for (; o.length; ) {
    const d = o.pop();
    if (!d || g !== void 0 && d.depth > g || r.has(d.variable.id))
      continue;
    const C = t[d.variable.id];
    r.add(d.variable.id);
    const u = Array.from(i[d.variable.id]) ?? [];
    yl(C) && (a.add(C.id), u.forEach((A) => {
      a.add(A);
    })), s.forEach(([A, m]) => {
      m != null && m.includes(C.id) && !r.has(+A) && o.push({
        variable: t[+A],
        depth: 0
      });
    }), u.forEach((A) => {
      r.has(A) || o.push({
        variable: t[A],
        depth: a.has(A) ? 0 : d.depth + 1
      });
    }), o.sort((A, m) => m.depth - A.depth);
  }
  return r;
}
function urt(e) {
  const t = Ni(e);
  return e.reduce((i, n) => {
    const g = m6(t, n.id), r = J_e(e, n.id), o = /* @__PURE__ */ new Set();
    return o.add(n.id), g.forEach((I) => {
      o.add(I);
    }), r.forEach((I) => {
      o.add(I);
    }), i[n.id] = Array.from(o), i;
  }, {});
}
const Qk = (e) => e ? e.hideValues.reduce((i, n) => ce.merge(i, (n.instanceIds ?? []).reduce((g, r) => (g[r] = n.valueIds.reduce((o, I) => (o[I] = !0, o), {}), g), {})), {}) : {}, U8 = (e) => e.reduce((t, i) => {
  var g;
  return t[i.variableId] === !0 ? t : ce.merge(t, {
    [i.variableId]: ((g = i.instanceIds) == null ? void 0 : g.reduce((r, o) => ({
      ...r,
      [o]: !0
    }), {})) || !0
  });
}, {}), Art = (e, t) => {
  if (!t)
    return {};
  const i = [...t.concealVariables, ...t.concealGroups.flatMap((n) => e.filter((g) => n.groups.some((r) => r === g.groupId)).map((g) => ({
    variableId: g.id,
    ruleItem: n.ruleItem,
    ruleColumn: n.ruleColumn
  })))];
  return U8(i);
}, TT = (e, t) => {
  if (!t)
    return {};
  const i = [...t.hideVariables, ...t.hideGroups.flatMap((n) => e.filter((g) => n.groups.some((r) => r === g.groupId)).map((g) => ({
    variableId: g.id,
    ruleItem: n.ruleItem,
    ruleColumn: n.ruleColumn
  })))];
  return U8(i);
};
function brt(e, t) {
  const i = e.reduce((r, o) => {
    if (!yl(o))
      return r;
    const I = zZ(ah(o));
    I.forEach((a) => {
      const d = r[a] || /* @__PURE__ */ new Set();
      d.add(o.id), r[a] = d;
    });
    const s = r[o.id] || /* @__PURE__ */ new Set();
    return I.forEach((a) => {
      s.add(a);
    }), r[o.id] = s, r;
  }, {}), n = t.reduce((r, o) => {
    const I = o.columns.filter(ua).reduce((s, a) => {
      const d = +(a == null ? void 0 : a.targetId);
      return d && s.push(d), s;
    }, []);
    return I.forEach((s) => {
      const a = r[s] || /* @__PURE__ */ new Set();
      I.forEach((d) => {
        d !== s && a.add(d);
      }), r[s] = a;
    }), r;
  }, {}), g = ce.mergeWith(i, n, (r, o) => {
    if (r instanceof Set && o instanceof Set)
      return /* @__PURE__ */ new Set([...r, ...o]);
  });
  return ce.mapValues(g, (r) => Array.from(r));
}
const P8 = (e, t, i, n, g, r, o, I) => {
  if (o)
    return {
      ...o,
      hiddenValuesMap: Qk(r),
      concealedVariablesMap: Art(g, r),
      hiddenVariablesMap: TT(g, r)
    };
  const {
    newRules: s,
    newRuleItems: a,
    newItemsById: d,
    newValues: C,
    newVariables: u
  } = me.flow(xj(g, !0, I), prt(g))({
    rules: t,
    ruleItems: i,
    values: n
  }), A = (q) => kZ(q) || yl(q) || s.some((E) => E.columns.some((L) => L.targetId === q.id)), m = /* @__PURE__ */ new Set(), h = g.reduce((q, E) => (!A(E) || (m.add(E.id), !yl(E)) || zZ(ah(E)).forEach((P) => q.add(P)), q), /* @__PURE__ */ new Set()), [B, f] = ce.partition(u, (q) => m.has(q.id) || h.has(q.id)), G = (q) => B.some((E) => E.id === q.variableId), [y, W] = ce.partition(C, G), V = lS(B, y), w = lS(f, W), v = lS(u, C), H = jk(f, s), x = jk(B, s), N = jk(u, s), M = hrt(s), $ = brt(g, s);
  return {
    groups: e.slice().sort(Ed),
    rules: s,
    ruleItems: {
      flat: a,
      byRuleId: d,
      rulesByTargetIdMap: M
    },
    variables: {
      variableHierarchies: urt(u),
      dependentVariablesById: $,
      flat: {
        free: H,
        locked: x,
        all: N
      },
      byVarId: {
        free: Ni(H),
        locked: Ni(x),
        all: Ni(N)
      }
    },
    values: {
      byVarId: {
        free: w,
        locked: V,
        all: v
      },
      flat: {
        free: W,
        locked: y,
        all: C
      }
    },
    hiddenVariablesMap: TT(g, r),
    hiddenValuesMap: Qk(r),
    concealedVariablesMap: Qk(r)
  };
}, jk = (e, t) => {
  const i = e.map((n) => ({
    variable: n,
    count: t.filter((g) => g.columns.some((r) => r.targetId === n.id)).length
  }));
  return i.sort((n, g) => g.count - n.count), i.map((n) => n.variable);
}, mrt = (e) => (t, i) => ce.uniq(e[+i].filter((n) => (
  // Both is possible. A value spans a larger interval then the rule item,
  // because it was merged or the rule items spans a larger interval because it was split further by other rule items
  Bc(n.data, t.interval) || Bc(t.interval, n.data)
)).map((n) => n.id));
function hrt(e) {
  return e.reduce((t, i) => (i.isActive && i.columns.forEach((n) => {
    const g = +((n == null ? void 0 : n.targetId) ?? "a");
    if (!g)
      return t;
    const r = t[g];
    return r ? r.push(i) : t[g] = [i], t;
  }), t), {});
}
const prt = (e) => (t) => {
  const {
    newRules: i,
    newValues: n,
    newRuleItems: g
  } = t, r = ce.groupBy(n, (G) => G.variableId), o = mrt(r), I = ce.groupBy(g, (G) => G.ruleId), s = {};
  i.forEach((G) => {
    const y = G.columns.map((V) => V.targetId), W = I[G.id];
    y.forEach((V) => {
      if (!W)
        return;
      const w = W.flatMap((v) => {
        const H = v.values[V];
        return _B(H) ? o(H, V) : H;
      });
      w.includes(!0) || (s[V] = s[V] ? ce.intersection(w, s[V]) : w);
    });
  });
  const [a, d] = ce.partition(n, (G) => {
    const y = s[G.variableId];
    return y ? y.some((W) => W === G.id) : !0;
  }), C = ce.groupBy(a, (G) => G.variableId), [u, A] = ce.partition(e, (G) => a.some((y) => y.variableId === G.id)), m = A.filter((G) => d.some((y) => y.variableId === G.id));
  if ((m == null ? void 0 : m.length) > 0)
    throw new Error("Folgende Merkmale haben keine gültigen Werte mehr: " + m.map((G) => G.label).join(", "));
  const h = {}, B = [];
  i.forEach((G) => {
    const y = G.columns.filter((V) => !A.some((w) => w.id === V.targetId));
    if (y.length <= 1)
      return;
    const W = (I[G.id] || []).map((V) => {
      if (y.length === G.columns.length)
        return V;
      {
        const w = {}, v = Object.entries(V.values);
        return v.forEach(([H, x]) => {
          if (ce.isArray(x)) {
            const N = C[H] || [], M = x.filter(($) => N.some((q) => q.id === $));
            M.length && (w[H] = M);
          } else
            w[H] = x;
        }), Object.entries(w).length !== v.length ? !1 : {
          ...V,
          values: w
        };
      }
    }).filter(Boolean);
    W.length && (B.push({
      ...G,
      columns: y
    }), h[G.id] = W);
  });
  const f = Object.values(h).flat();
  return {
    newValues: a,
    newRules: B,
    newItemsById: h,
    newRuleItems: f,
    newVariables: u
  };
}, cV = (e, t, i) => ({
  ...i,
  valueId: t.id,
  debuggingValue: `${e.variables.byVarId.all[t.variableId].label}: ${t.label}`,
  data: Brt(e, t, i) || i.data,
  interval: t.data
}), Brt = (e, t, i) => {
  var g;
  if (!PS(t.data) && t.id > 0)
    return i.data;
  const n = e.variables.byVarId.all[i.variableId];
  return C1(n) ? {
    inputText: n.description || void 0
  } : eI(n) ? {
    inputValue: th(((g = i.data) == null ? void 0 : g.inputValue) || 0, [t], Od(n)).input
  } : i.data;
}, z8 = (e, t, i, n, g) => {
  const r = [];
  return e.variables.flat[g].filter((I) => I.parentId === n.variableId || I.id === n.variableId).forEach((I) => {
    var d;
    const s = kZ(I), a = I.id === n.variableId;
    if (s && !a) {
      const C = i.filter((u) => u.variableId === I.id && u.instance.belongsToInstanceId === n.instance.id);
      r.push(...C.flatMap((u) => z8(e, t, i, u, g)));
    } else if (!((d = t[n.id || ""]) == null ? void 0 : d.some((u) => u.variableId === I.id)) && e.values.byVarId.all[I.id].length) {
      const u = a ? n : gh(I, null, n.instance, !1);
      r.push(u);
    }
  }), r;
}, O8 = (e, t, i, n) => {
  const g = t.length ? ce.groupBy(t, (r) => {
    var o;
    return ((o = r.instance) == null ? void 0 : o.id) || "";
  }) : {
    "": []
  };
  return z8(e, g, i, Dt, n);
}, bx = (e) => e.instance.isInstanceLauncher ? e.instance.belongsToInstanceId : e.instance.id, Ic = (e) => e.id;
function Zrt(e, t) {
  const i = /* @__PURE__ */ new Map();
  for (let n = 0; n < e.length; n++) {
    const g = e[n];
    if (g.id === t.id)
      continue;
    const r = g.variableId, o = i.get(r) ?? [];
    o.push(g), i.set(r, o);
  }
  return i;
}
function frt(e, t) {
  const i = ce.keyBy(e, (r) => r.id), n = ce.memoize(Ju, (r, o, I) => I == null ? void 0 : I.id);
  return (r) => {
    const o = _r(r) ? r : i[r.instance.id];
    return n(t, e, o);
  };
}
function Grt(e, t, i, n) {
  if (n.id === Dt.id)
    return [];
  const g = [], r = e.get(n.variableId);
  if (!r)
    throw new Error("Variable not found");
  const o = vl(n), I = o === Dt.id ? Dt : t.find((s) => s.id === o);
  if (I && g.push(I), yl(r)) {
    const s = i(n), a = Zrt(s, n), d = zZ(ah(r)).reduce((C, u) => (C.push(...a.get(u) ?? []), C), []);
    g.push(...d);
  }
  return ce.uniqBy(g, (s) => s.id);
}
function yrt(e, t, i, n) {
  const g = e.get(i.variableId), r = e.get(n.variableId), o = t.indexOf(g);
  return t.indexOf(r) - o;
}
function Wrt(e, t, i, n) {
  const g = frt(n, e.variables.variableHierarchies);
  let r = n.reduce((o, I) => (Grt(i, n, g, I).forEach((a) => {
    const d = Ic(a), C = o[d] ?? [];
    C.push(I), o[d] = C;
  }), o), {});
  return r = ce.mapValues(r, (o) => (o.sort((I, s) => _r(I) && !_r(s) ? -1 : _r(s) && !_r(I) ? 1 : yrt(i, t, I, s)), o)), r;
}
function Srt(e, t, i, n) {
  const g = (I, s) => {
    const a = {}, d = [s];
    for (; d.length > 0; ) {
      const C = d.pop(), u = I[Ic(C)];
      if (!(!u || u.length === 0)) {
        a[Ic(C)] = !0;
        for (const A of u)
          if (a[Ic(A)]) {
            const m = e.get(A.variableId);
            if (hi(m).suppressCycleDetection) {
              I[Ic(C)] = [...I[Ic(C)] ?? []].filter((B) => B.id !== A.id);
              const h = I[Ic(A)] ?? [];
              h.push(C), I[Ic(A)] = h;
            }
          } else
            d.push(A);
      }
    }
  }, r = ce.groupBy(t, (I) => I.variableId);
  i.reduce((I, s) => {
    if (hi(s).suppressCycleDetection) {
      const a = r[s.id] ?? [];
      I.push(...a);
    }
    return I;
  }, []).forEach((I) => {
    g(n, I);
  });
}
function Vrt(e, t) {
  const i = vQ(e.variables.flat.all), n = ce.keyBy(e.groups, (g) => g.id);
  t.sort((g, r) => {
    const o = i[g.id], I = i[r.id];
    if (o === I) {
      const s = n[g.groupId], a = n[r.groupId];
      if (s && a) {
        const d = s.sort - a.sort;
        if (d !== 0)
          return d;
      }
      return g.sort - r.sort;
    }
    return o - I;
  });
}
function wrt(e, t) {
  const i = [...e.variables.flat.all];
  Vrt(e, i);
  const n = /* @__PURE__ */ new Map();
  i.forEach((I) => n.set(I.id, I));
  const g = [Dt, ...t], r = Wrt(e, i, n, g);
  return Srt(n, g, i, r), x_e(g, (I) => r[Ic(I)] ?? []);
}
const vrt = 2e5, dV = 0, Rrt = 1, mx = 2;
function _k(e, t) {
  const {
    ruleEngineInput: i,
    filledSelections: n,
    iteration: g
  } = e, r = i.variables.dependentVariablesById[t.variableId], o = n.filter((s) => {
    var a;
    return (
      // Dont backtrack to selections that have no options left.
      !((a = g == null ? void 0 : g.isLastOption) != null && a[s.id]) && (r == null ? void 0 : r.includes(s.variableId))
    );
  }), I = {
    status: mx,
    backtrackToSelections: new Set(o),
    stuckSelection: t
  };
  return g.stuckSelection = I.stuckSelection, g.backtrackToSelections = I.backtrackToSelections, I;
}
const g2 = (e) => {
  const {
    ruleEngineInput: t,
    filledSelections: i,
    emptySelections: n,
    depth: g,
    iteration: r,
    skipExpressionEvaluation: o
  } = e;
  if (!n.length)
    return {
      status: dV,
      selections: i
    };
  const I = n[0];
  if (g == 0 && (r.count = 0), r.count++, r.count > vrt)
    throw new Error("The configurator is too complex and/or unsolvable. Please simplify or correct dependencies between variables.");
  const s = t.variables.byVarId.all[I.variableId];
  return yl(s) && !o ? Xrt(e, s, I) : Frt(e, I);
};
function Q8(e, t) {
  var o;
  const {
    ruleEngineInput: i,
    validOptionsByInstanceAndVariable: n
  } = e, g = t.instance.id;
  return ((o = n[g]) == null ? void 0 : o[t.variableId]) || i.values.byVarId.locked[t.variableId].map((I) => ({
    value: I,
    conflicts: []
  }));
}
function Xrt(e, t, i) {
  const {
    emptySelections: n
  } = e, r = zZ(ah(t)).find((o) => n.find((I) => I.variableId === o && I.id !== i.id));
  if (r) {
    const o = Hrt(e, t, r, i);
    if (o)
      return o;
  }
  return krt(e, t, i);
}
function Hrt(e, t, i, n) {
  var C, u;
  const {
    filledSelections: g,
    emptySelections: r,
    cycleDetectionMap: o,
    ruleEngineInput: I
  } = e, s = I.variables.byVarId.all[i], a = (C = o[n.variableId]) == null ? void 0 : C.includes(i), d = (u = o[i]) == null ? void 0 : u.includes(n.variableId);
  if ((!a || t.settings.templateOptions.suppressCycleDetection) && !d) {
    const [A, m] = ce.partition(r.slice(1), (B) => B.variableId === i), h = g2({
      ...e,
      filledSelections: [...g],
      emptySelections: [...A, n, ...m],
      cycleDetectionMap: {
        ...o,
        [i]: [...o[i] ?? [], n.variableId]
      }
    });
    if (h)
      return h;
  } else if (!s.settings.templateOptions.suppressCycleDetection)
    throw new Error(rn.t("Es gibt einen Zyklus in den berechneten Merkmalen."));
}
function krt(e, t, i) {
  var m;
  const {
    ruleEngineInput: n,
    filledSelections: g,
    emptySelections: r,
    depth: o,
    iteration: I
  } = e, s = w6(n.variables.flat.locked, n.values.flat.locked, n.variables.variableHierarchies, [...g, i], t, i);
  if (s.errorMessage)
    return _k(e, i);
  const d = Q8(e, i).map((h) => h.value), C = th(s.result, d, Od(t));
  if (!C)
    return _k(e, i);
  const u = cV(n, C.value, {
    ...i,
    data: {
      inputValue: C.input
    }
  }), {
    isValid: A
  } = FZ(n, g, u, !0);
  return A ? (((m = I == null ? void 0 : I.stuckSelection) == null ? void 0 : m.id) === u.id && (I.stuckSelection = void 0, I.backtrackToSelections = void 0), I.isLastOption || (I.isLastOption = {}), I.isLastOption[i.id] = !0, g2({
    ...e,
    depth: o + 1,
    filledSelections: [...g, u],
    emptySelections: r.slice(1)
  })) : _k(e, i);
}
function Frt(e, t) {
  var s;
  const {
    ruleEngineInput: i,
    filledSelections: n,
    emptySelections: g,
    depth: r,
    iteration: o
  } = e, I = Q8(e, t);
  for (const a of I) {
    const d = cV(i, a.value, {
      ...t,
      data: {
        inputValue: a.defaultValue ?? ((s = t.data) == null ? void 0 : s.inputValue)
      }
    }), {
      isValid: C
    } = FZ(i, n, d, !0);
    if (C) {
      const u = [...n, d];
      o.isLastOption = {
        ...o.isLastOption,
        [t.id]: I.findIndex((m) => m.value.id === a.value.id) === I.length - 1
      };
      const A = g2({
        ...e,
        depth: r + 1,
        filledSelections: u,
        emptySelections: g.slice(1)
      });
      if (A.status === mx) {
        if (A.backtrackToSelections.has(d))
          continue;
        if (r === 0)
          continue;
        return A;
      } else if (A.status === dV)
        return A;
    }
  }
  return o.backtrackToSelections ? {
    status: mx,
    backtrackToSelections: o.backtrackToSelections
  } : {
    status: Rrt
  };
}
function Yrt(e, t) {
  return e.variableId === (t == null ? void 0 : t.variableId) && e.instance.id === (t == null ? void 0 : t.instance.id);
}
function xrt(e, t, i, n) {
  return [...e, ...(t ?? []).filter((r) => !n.some((o) => o.instance.id === r.instance.id && o.variableId === r.variableId) && !e.some((o) => o.instance.id === r.instance.id && o.variableId === r.variableId))];
}
function Drt(e, t, i) {
  e.forEach((n) => {
    const g = t.variables.byVarId.all[n.variableId];
    if (eI(g) && g.settings.templateOptions.defaultValue) {
      const r = th(Number(g.settings.templateOptions.defaultValue), t.values.byVarId.all[g.id].map((o) => o), Od(g));
      r && (i[n.instance.id] || (i[n.instance.id] = {}), i[n.instance.id][g.id] || (i[n.instance.id][g.id] = []), i[n.instance.id][g.id] = [{
        value: r.value,
        conflicts: [],
        defaultValue: r.input
      }, ...i[n.instance.id] ? i[n.instance.id][g.id] : []]);
    }
  });
}
const oZ = (e, t, i, n, g = 1, r, o = !1, I = !1) => {
  const s = ce.uniqBy(fD(t), (W) => W.id), a = t.filter((W) => s.some((V) => V.id === W.instance.id));
  a.length !== t.length && console.warn("Filled selections contain selections that are not instances or not in the instance hierarchy."), s.push(Dt);
  let d = [], C = [], u = s;
  if (n) {
    const W = Crt(e.variables.flat.all, e.variables.byVarId.all, e.variables.dependentVariablesById, n.variableId, g);
    let V = n.instance.isInstanceLauncher ? n : jB(a, n) ?? Dt;
    for (let w = 1; w < g; w++) {
      if (!V) {
        V = Dt;
        break;
      }
      V = jB(a, V);
    }
    u = Zc(a, V), u.push(V ?? Dt), C = a.filter((w) => !u.some((v) => v.id === w.instance.id) && !yl(e.variables.byVarId.all[w.variableId])), d = a.filter((w) => !W.has(w.variableId) || Yrt(w, n) || C.some((v) => v.id === w.id));
  } else
    I || (d = a);
  const A = O8(e, d, s, "locked");
  if (!A || A.length === 0)
    return C.length === 0 ? a : oZ(e, a, i, n, g + 1, 0);
  let m = (
    // We only sort topologically at the initial fill. Otherwise we reuse the
    // optimised sort from the previous fill.
    I ? wrt(e, ce.uniqWith([...A, ...d], (W, V) => Ca(W, V))) ?? [] : A
  );
  m = m.filter((W) => A.find((V) => V.id === W.id));
  const h = {
    ...i
  }, B = xrt(d, a, n, m);
  Drt(m, e, h);
  const y = g2({
    ruleEngineInput: e,
    filledSelections: B,
    emptySelections: m,
    validOptionsByInstanceAndVariable: h,
    depth: 0,
    iteration: {
      count: 0
    },
    cycleDetectionMap: {},
    skipExpressionEvaluation: o
  });
  return y.status !== dV && (r == null || r < m.length) ? oZ(e, a, h, n, g + 1, m.length) : y.status === dV ? y.selections : !1;
}, OJ = (e, t) => {
  const i = {};
  return e.variables.flat.locked.filter((g) => g.parentId === t.variableId || g.id === t.variableId).forEach((g) => {
    i[g.id.toString()] = e.values.byVarId.locked[g.id].map((r) => ({
      value: r,
      conflicts: []
    }));
  }), {
    [t.id]: i
  };
}, Em = (e, t, i, n) => {
  e[t] || (e[t] = {}), e[t][i] || (e[t][i] = []), e[t][i].push(...n);
}, j8 = (e, t) => {
  const i = e;
  HL(!1);
  const n = hD(i, (g) => Object.keys(t).forEach((r) => Object.keys(t[r]).forEach((o) => Em(g, r, o, t[r][o]))));
  return HL(!0), n;
}, Jrt = (e, t, i, n, g) => e.values.byVarId.locked[t.id].map((o) => {
  var a, d, C;
  const I = gh(t, o, i.instance, !0), s = FZ(e, n, I, !1);
  if (s.isValid) {
    const u = j8(g, OJ(e, I));
    if (oZ(e, [...n, I], u, I, void 0, void 0, !0))
      return {
        value: o,
        conflicts: []
      };
    {
      const m = (I == null ? void 0 : I.variableId) + " - " + ((d = (a = e == null ? void 0 : e.variables) == null ? void 0 : a.byVarId.all[I == null ? void 0 : I.variableId]) == null ? void 0 : d.label);
      return console.warn("Ooops? Fill did find no solution but calcFirstConflict found no conflict. This should not happen. Please check your validity rules regarding variable " + m), {
        value: o,
        conflicts: [I]
      };
    }
  }
  return {
    value: o,
    conflicts: ((C = s.conflicts) == null ? void 0 : C.map((u) => u[1])) ?? []
  };
}), lA = (e, t) => ({
  locked: e,
  free: t,
  all: {
    selections: [...t.selections, ...e.selections],
    validOptions: j8(t.validOptions, e.validOptions),
    invalidOptions: e.invalidOptions,
    touched: e.touched
  }
}), Krt = (e, t, i, n, g, r) => {
  e.variables.flat.locked.filter((I) => kZ(I) && I.parentId === i.variableId).forEach((I) => {
    const s = Jrt(e, I, i, t, n), [a, d] = ce.partition(s, (C) => !C.conflicts.length);
    Em(g, i.id, I.id, a), Em(r, i.id, I.id, d);
  });
}, MT = (e, t) => {
  const i = {}, n = {};
  return t.forEach((g) => {
    const r = e.values.byVarId.all[g.variableId] ?? [], o = t.filter((C) => C.id !== g.id), I = q8(r.map((C) => {
      var m;
      const u = gh(g.variableId, C, g.instance, g.instance.isInstanceLauncher), A = ((m = FZ(e, o, u, !1).conflicts) == null ? void 0 : m.map((h) => h[1])) ?? [];
      return {
        value: C,
        conflicts: A
      };
    }), g), [s, a] = ce.partition(I, (C) => !C.conflicts.length), d = g.instance.id;
    Em(i, d, g.variableId, s), Em(n, d, g.variableId, a);
  }), [Dt, ...t.filter((g) => g.instance.isInstanceLauncher)].forEach((g) => Krt(e, t, g, r2(e, t, []), i, n)), {
    valid: i,
    invalid: n
  };
}, _8 = (e) => OJ(e, Dt), Ert = (e, t) => Object.assign({}, ...t.map((i) => OJ(e, i))), $8 = (e, t, i) => {
  const n = fD(t.selections), g = O8(e, t.selections, n, "all"), r = {}, o = g.map((I) => {
    const s = e.values.byVarId.all[I.variableId].map((C) => ({
      value: C,
      conflicts: []
    }));
    Em(r, I.instance.id, I.variableId, s);
    const a = e.variables.byVarId.all[I.variableId];
    if (eI(a)) {
      const C = Number(a.settings.templateOptions.defaultValue);
      if (C) {
        const u = th(C, s.map((A) => A.value), Od(a));
        if (u)
          return i.find((A) => Ca(A, I)) || cV(e, u.value, {
            ...I,
            data: {
              inputValue: u.input
            }
          });
      }
    }
    return i.find((C) => Ca(C, I)) || cV(e, s[0].value, I);
  });
  return lA(t, {
    selections: o,
    validOptions: r
  });
}, r2 = (e, t, i) => {
  const n = fD(t), g = Ert(e, n);
  return Object.keys(g).forEach((r) => Object.keys(g[r]).forEach((o) => {
    const I = t.find((s) => s.variableId == Number(o) && s.instance.id === r);
    I && (i.find((s) => s.variableId === Number(o) && s.instance.id === I.instance.id) ? g[r][o] = g[r][o].filter((s) => s.value.id === I.valueId) : g[r][o] = q8(g[r][o], I));
  })), g;
}, Nrt = (e, t) => {
  var s;
  const i = e.slice().sort((a, d) => d.value.id - a.value.id), n = i.findIndex((a) => a.value.id === t.valueId);
  if (n === -1)
    return i;
  const g = ((s = t.data) == null ? void 0 : s.inputValue) ?? 0, r = [i[n]];
  let o = n + 1, I = n - 1;
  for (; r.length !== i.length; ) {
    const a = i[o], d = i[I], C = a ? a.value.data.left - g : 1 / 0, u = d ? g - d.value.data.right : 1 / 0;
    !d || // including interval is (if contested) always closer or equal to any
    // other interval
    (C === u ? a.value.data.leftInclude : C < u) ? (o++, r.push(a)) : (I--, r.push(d));
  }
  return r;
}, q8 = (e, t) => {
  if (nh(t))
    return Nrt(e, t);
  {
    const i = e.find((n) => n.value.id === t.valueId);
    return i ? Tfe(e, [i]) : e;
  }
}, e_ = (e, t, i, n, g = !1) => {
  const r = i ? [i, ...t.selections.filter((s) => !Ca(s, i))] : t.selections, o = r2(e, r, []), I = oZ(e, n ?? [], o, i, void 0, void 0, void 0, g);
  return I ? {
    selections: I,
    validOptions: {},
    invalidOptions: {},
    touched: t.touched
  } : !1;
}, Lrt = (e, t, i, n, g = !1) => {
  const r = {
    selections: [],
    validOptions: _8(e),
    touched: {},
    invalidOptions: {}
  }, o = e_(e, r, i, n, g);
  return o ? $8(
    e,
    o,
    // Since we are passing all selections here, we are assuming that all
    // selections in the new state are locked and filled.
    []
  ) : !1;
}, Trt = (e, t, i, n) => {
  let g = t_(e, t, i, n);
  return g = lA(g.locked, g.free), QJ(g);
}, t_ = (e, t, i, n) => ({
  ...t,
  locked: {
    ...t.locked,
    selections: i,
    validOptions: n ? _8(e) : t.locked.validOptions
  }
});
function Mrt(e, t, i) {
  const n = !!e.variables.byVarId.free[i.variableId], g = t[n ? "free" : "locked"].selections.filter((a) => !Ca(a, i)), r = [i, ...g], o = n ? t.locked : {
    selections: r,
    validOptions: t.all.validOptions,
    invalidOptions: t.all.invalidOptions,
    touched: t.locked.touched
  }, I = n ? {
    ...t.free,
    selections: r
  } : t.free;
  return lA(o, I);
}
const Urt = (e, t, i) => {
  if (!e)
    return {
      state: t,
      changes: [],
      touchedChanges: [],
      onlyUntouched: !0,
      lastManualChange: i
    };
  const n = e.locked.selections.reduce((r, o) => {
    if (i && Ca(o, i))
      return r;
    const I = t.locked.selections.find((a) => Ca(o, a));
    if (!I && !i || o.valueId === (I == null ? void 0 : I.valueId))
      return r;
    const s = [o, I];
    return r.push(s), r;
  }, []), g = n.filter((r) => {
    var I;
    const o = r[0];
    return (I = e.locked.touched[o.instance.id]) == null ? void 0 : I.includes(o.variableId);
  });
  return {
    state: t,
    changes: n,
    touchedChanges: g,
    onlyUntouched: !g.length,
    lastManualChange: i
  };
}, hx = (e, t, i, n, g) => {
  const r = t.filter((A) => {
    var m;
    return (m = e.values.byVarId.all[A.variableId]) == null ? void 0 : m.some((h) => h.id === A.valueId);
  });
  r.sort(Fm);
  const {
    locked: o,
    free: I
  } = wQ(e, r), s = r2(e, t, n ? [n] : []), d = e_(e, {
    selections: o,
    validOptions: s,
    invalidOptions: {},
    touched: i
  }, n, g);
  if (!d)
    throw new Error("Unable to calc state");
  return {
    state: $8(e, d, I),
    changes: [],
    touchedChanges: [],
    onlyUntouched: !0
  };
}, of = Pt([(e, t) => t, JZ, E6], (e, t, i) => {
  const n = t[e], g = Ni(n);
  return i.some((r) => g[r.valueId]);
}), Prt = (e) => ({
  free: e.free,
  locked: {
    ...e.locked,
    touched: {}
  },
  all: {
    ...e.all,
    touched: {}
  }
}), o2 = (e, t, i, n = !1) => {
  const g = ce.cloneDeep(t.all.touched);
  return i.forEach((r) => {
    const o = e.variables.byVarId.all[r.variableId];
    o && (!n && u1(o, e, t, r.instanceId) || (g[r.instanceId] || (g[r.instanceId] = []), g[r.instanceId].includes(r.variableId) || g[r.instanceId].push(r.variableId)));
  }), {
    free: t.free,
    locked: {
      ...t.locked,
      touched: g
    },
    all: {
      ...t.all,
      touched: g
    }
  };
}, zrt = (e, t, i) => {
  const n = t.state.locked.selections.filter((g) => g.instance.isInstanceLauncher && !of(i, g.variableId)).map((g) => ({
    instanceId: g.instance.id,
    variableId: g.variableId
  }));
  return {
    ...t,
    state: o2(e, t.state, n)
  };
}, i_ = (e, t) => {
  try {
    if (!performance.measure)
      return;
    performance.mark(`${e}-end`);
    const i = performance.measure(`${e}-total`, `${e}-start`, `${e}-end`);
    if (!i)
      return;
    i.duration > (t || 250) && performance.getEntries().forEach((g) => {
      g.entryType === "mark" && console.warn(`Critical ${e} Performance:`, g.name, performance.measure(`${g.name}-measure`, `${e}-start`, g.name).duration);
    }), performance.clearMarks(), performance.clearMeasures();
  } catch (i) {
    console.warn("No performance measured because of", i);
  }
}, I2 = (e, t, i, n, g, r, o = !0) => {
  g || (g = zfe(n.variableId, i.id, t.locked.selections) + 1);
  const I = gh(n.variableId, n, i.instance, !0, r, g), s = r2(e, [...t.locked.selections, I], [I]), a = oZ(
    e,
    [...t.locked.selections, I],
    s,
    I,
    void 0,
    void 0,
    // we need to skip expression evaluation here as we only want to fill
    // children selections. Everything else will be filled in engineThunk later.
    !0
  );
  if (a === !1)
    throw new Error("Selections are false");
  let d = t_(e, t, a, !1);
  return d = lA(d.locked, d.free), o && (d = o2(e, d, [{
    instanceId: I.instance.id,
    variableId: I.variableId
  }])), QJ(d, I);
}, If = (e, t) => {
  const i = Zc(e.all.selections, t), n = [t.id, ...i.map((I) => I.id)], g = (I) => !n.includes(I.id) && !n.includes(vl(I));
  return {
    state: {
      ...e,
      locked: {
        ...e.locked,
        selections: e.locked.selections.filter(g),
        validOptions: ce.omit(e.locked.validOptions, n),
        invalidOptions: ce.omit(e.locked.invalidOptions, n),
        touched: ce.omit(e.locked.touched, n)
      },
      free: {
        ...e.free,
        selections: e.free.selections.filter(g),
        validOptions: ce.omit(e.free.validOptions, n)
      },
      all: {
        ...e.all,
        selections: e.all.selections.filter(g),
        validOptions: ce.omit(e.all.validOptions, n),
        invalidOptions: ce.omit(e.all.invalidOptions, n),
        touched: ce.omit(e.all.touched, n)
      }
    },
    changes: [],
    onlyUntouched: !0,
    touchedChanges: [],
    lastManualChange: t
  };
}, QJ = (e, t) => ({
  state: e,
  changes: [],
  touchedChanges: [],
  onlyUntouched: !1,
  lastManualChange: t
}), jJ = (e, t, i, n, g, r = !1, o = !0) => {
  performance.mark("change-var-start");
  const I = gh(n.variableId, n, i.instance, !1, g);
  let s = Mrt(e, t, I);
  performance.mark("change-var-valid"), o && (s = o2(e, s, [{
    instanceId: I.instance.id,
    variableId: I.variableId
  }], r));
  const a = QJ(s, I);
  return i_("change-var"), a;
}, Ort = (e, t) => (i) => {
  let n = t;
  return Object.entries(i).forEach(([g, r]) => {
    const o = e.variables.flat.all.find((m) => m.key === g);
    if (!o)
      return;
    const I = eI(o), s = ih(o), a = e.values.byVarId.all[o.id].find((m) => I ? Bc(Du(+r), m.data) : s ? !0 : m.key === r);
    if (!a)
      return;
    const d = n.state.all.selections.find((m) => m.variableId === o.id);
    if (!d)
      return;
    const C = n.state.all.selections.find((m) => m.id === d.instance.id) || Dt, u = s ? {
      inputText: C1(o) ? o.description || void 0 : r.toString()
    } : void 0, A = jJ(e, n.state, C, a, I ? {
      inputValue: +r
    } : u, !0);
    A && (n = A);
  }), n;
}, Qrt = (e) => {
  const t = Lrt(e, void 0, void 0, void 0, !0);
  return t ? {
    state: t,
    changes: [],
    touchedChanges: [],
    onlyUntouched: !0
  } : !1;
}, wW = "fillLater", jrt = (e, t) => {
  const i = t.json.variables.filter((o) => e.variables.byVarId.all[o.variableId]), n = vQ(e.variables.flat.all);
  let g = i.map((o) => {
    var h, B, f, G, y, W, V;
    const I = e.variables.byVarId.all[o.variableId], s = e.variables.flat.all.some((w) => w.parentId === o.variableId), a = o.id || ZQ(), d = s ? {
      id: a,
      isInstanceLauncher: !0,
      belongsToVariableId: o.variableId,
      belongsToInstanceId: ((h = o.parent) == null ? void 0 : h.selectionId) || "",
      hierarchyLevel: n[o.variableId]
    } : {
      id: ((B = o.parent) == null ? void 0 : B.selectionId) || "",
      isInstanceLauncher: !1,
      belongsToVariableId: ((f = o.parent) == null ? void 0 : f.variableId) || null,
      belongsToInstanceId: (G = o.parent) != null && G.selectionId ? wW : "",
      hierarchyLevel: n[o.variableId]
    };
    let C = o.value;
    const u = {
      ...o.additionalData
    }, A = {};
    if (eI(I)) {
      const w = Number(((y = o.additionalData) == null ? void 0 : y.inputValue) ?? 0), v = e.values.byVarId.all[I.id].find((H) => Bc(Du(w), H.data));
      if (u.inputValue = w, !v)
        return null;
      C = v.id, A.interval = v.data;
    } else if (I.type === Bn.Text) {
      const w = (W = e.values.byVarId.all[I.id]) == null ? void 0 : W[0];
      w && (C = w.id);
    }
    const m = {
      id: a,
      sort: o.sort,
      variableId: o.variableId,
      valueId: C,
      data: u,
      instance: d,
      debuggingValue: o.debuggingValue,
      ...A
    };
    if ((V = m == null ? void 0 : m.data) != null && V.url) {
      const w = m.data.url.replace(/ /g, "_");
      m.data.url = uc.first(Object.values(t.files[w]));
    }
    return m;
  }).filter(Boolean), r = 0;
  for (; g.some((o) => o.instance.belongsToInstanceId === wW) && r < 20; )
    g = g.map((o, I, s) => {
      if (o.instance.belongsToInstanceId !== wW)
        return o;
      const a = s.find((C) => C.id === o.instance.id), d = a == null ? void 0 : a.instance.belongsToInstanceId;
      return a && d !== wW ? da({
        instance: {
          belongsToInstanceId: d
        }
      })(o) : o;
    }), r++;
  return r === 20 && console.error("Too many iterations needed to resolve selection tree", g, t), g;
}, _rt = (e, t, i) => Ufe(e, t).reduce((n, g) => {
  if (!g.valueId)
    return n;
  const r = e.variables.byVarId.all[g.variableId], o = t.find((a) => a.id === bx(g)) || Dt, I = !WQ(r, e, i.state, g), s = {
    sort: g.sort,
    hidden: I,
    variableId: g.variableId,
    value: g.valueId,
    additionalData: g.data,
    debuggingValue: g.debuggingValue,
    parent: {
      selectionId: o.id,
      variableId: o.variableId,
      valueId: (o == null ? void 0 : o.valueId) || null
    },
    id: g.id
  };
  return [...n, s];
}, []), $rt = (e, t) => {
  const i = t.all.selections.slice().sort(Ed), n = ms("setExpressionEngineSelections", i), g = v6(e.variables.flat.all, e.values.flat.all, e.variables.variableHierarchies, n), {
    free: r,
    locked: o
  } = wQ(e, g);
  return {
    state: lA({
      ...t.locked,
      selections: o
    }, {
      selections: r,
      validOptions: t.free.validOptions
    })
  };
}, qrt = (e, t, i, n) => {
  if (!i)
    return t;
  const g = t.state.locked.selections.map((r) => {
    var o, I, s, a;
    if (nh(r) && // Calculated Variables should not be clamped because in their
    // evaluation they get the correct value anyway!
    !yl(e.variables.byVarId.all[r.variableId])) {
      if (n && (r == null ? void 0 : r.valueId) === n.valueId && (r == null ? void 0 : r.id) === n.id)
        return da({
          data: {
            inputValue: (o = n.data) == null ? void 0 : o.inputValue
          }
        })(r);
      const d = i.state.locked.selections.find((f) => Ca(f, r));
      if (!d)
        return r;
      const C = e.variables.byVarId.all[r.variableId], u = Od(C), A = e.values.byVarId.all[r.variableId].find((f) => f.id === r.valueId), m = ((I = d.data) == null ? void 0 : I.inputValue) ?? 0, h = ((s = r.data) == null ? void 0 : s.inputValue) ?? 0;
      let B;
      return Bc(Du(m), A.data) ? B = m : (m < h ? B = A.data.left + (A.data.leftInclude ? 0 : u) : B = A.data.right - (A.data.rightInclude ? 0 : u), Bc(Du(B), A.data) || (B = (a = r.data) == null ? void 0 : a.inputValue)), da({
        data: {
          inputValue: B
        }
      })(r);
    } else
      return r;
  });
  return {
    ...t,
    state: lA({
      ...t.state.locked,
      selections: g
    }, t.state.free)
  };
};
function eot(e, t, i, n, g) {
  const r = ce.groupBy(e || [], (o) => o.valueId);
  return ce.map(r, (o) => {
    const I = o.reduce((s, a) => {
      if (a.expression) {
        const {
          result: d
        } = D1(t, i, n, g, a.expression, a.anchoringSelection);
        return s + d;
      } else
        s += a.count ?? 0;
      return s;
    }, 0);
    return {
      valueId: o[0].valueId,
      // it is possible that expressions add a negative amount.
      // This prevents everything from crashing.
      count: Math.max(I, 0)
    };
  });
}
const tot = (e, t, i, n, g) => t.reduce((r, o) => {
  var d, C;
  const s = g.state.all.selections.filter((u) => u.valueId === o.valueId && u.instance.belongsToInstanceId === e.instance.id), a = o.count - s.length;
  if (a > 0) {
    let u = r;
    for (let A = 0; A < a; A++) {
      const m = I2(i, u.state, e, n[o.valueId], void 0, void 0, !1);
      if (m)
        u = m;
      else {
        const h = n[o.valueId].variableId, B = o.valueId + ` - Variable ${h} (${(C = (d = i == null ? void 0 : i.variables) == null ? void 0 : d.byVarId.all[h]) == null ? void 0 : C.label})`;
        throw console.error(`Could not create instance for value.id: ${B}`), new Error("Gültiger Wert konnte nicht ermittelt werden: " + B);
      }
    }
    return u;
  } else if (a < 0) {
    let u = r;
    const A = a * -1;
    for (let m = 0; m < A; m++) {
      const h = If(u.state, s[m]);
      if (h)
        u = h;
      else
        throw new Error(`Could not delete instance for value.id: ${o.valueId}`);
    }
    return u;
  }
  return r;
}, g);
function iot(e, t, i) {
  const n = i.state.all.selections, g = Ni(n), r = t.variables.flat.all, o = t.values.flat.all, I = Ni(o), s = ce.groupBy(e.instances, (d) => d.parentSelection.id);
  return ce.reduce(s, (d, C, u) => {
    const A = g[u] ?? Dt, m = ce.isEmpty(C) ? [] : eot(C, r, o, t.variables.variableHierarchies, n);
    return d = tot(A, m, t, I, d), d;
  }, i);
}
function not(e) {
  const t = e.state.all.selections, i = Ni(t), n = b1(t, Dt), g = Ni(n);
  return t.reduce((r, o) => {
    if (_r(o) && // If the selection is not part of the tree starting at the root
    // selection and
    !g[o.instance.id] && // if the parent selection does not exist anymore
    !i[o.instance.belongsToInstanceId]) {
      const I = If(r.state, o);
      if (I)
        return I;
      throw new Error(`Could not delete orphaned instance: ${o}`);
    }
    return r;
  }, e);
}
function got(e, t, i) {
  let n = iot(i, e, t);
  return n = not(n), n;
}
const n_ = {
  articles: [],
  colors: [],
  hideGroups: [],
  hideValues: [],
  hideVariables: [],
  concealVariables: [],
  concealGroups: [],
  images: [],
  instances: [],
  labels: [],
  popups: [],
  materials: [],
  models: [],
  prints: []
}, rot = (e, t) => {
  const i = e.hideVariables, n = t.hideVariables;
  if (!(i.length === n.length))
    return !1;
  const r = e.hideGroups, o = t.hideGroups;
  return !(!(r.length === o.length) || !me.equals(ce.sortBy(i, ["variableId", "instanceIds"]), ce.sortBy(n, ["variableId", "instanceIds"])) || !me.equals(ce.sortBy(r, ["groups"]), ce.sortBy(o, ["groups"])));
}, oot = (e, t) => {
  const i = Zc(e.state.all.selections, Dt);
  i.sort(Ed);
  const n = Zc(t.state.all.selections, Dt);
  return n.sort(Ed), ce.isEqual(i, n);
}, g_ = (e, t, i, n) => {
  const g = n || /* @__PURE__ */ new Set(), r = i.conflicts.find((o) => {
    const I = e.variables.byVarId.all[o.variableId];
    return yl(I) && !g.has(o);
  });
  if (r) {
    const o = e.variables.dependentVariablesById[r.variableId], I = Ju(e.variables.variableHierarchies, t, r);
    i.conflicts.push(...I.filter((s) => o.includes(s.variableId))), i.conflicts = ce.uniqBy(i.conflicts, (s) => s.id), g.add(r), i = g_(e, t, i, g);
  }
  return i;
};
function Iot(e, t) {
  return e.state.locked.invalidOptions = ce.mapValues(e.state.locked.invalidOptions, (i) => ce.mapValues(i, (n) => n.map((g) => g_(t, e.state.all.selections, g)))), e.state.all.invalidOptions = e.state.locked.invalidOptions, e;
}
function lot(e, t) {
  const i = new Set(t.state.all.selections.filter((g) => US(e, g.variableId, g.instance.id)));
  return {
    ...t,
    state: {
      ...t.state,
      all: {
        ...t.state.all,
        selections: t.state.all.selections.filter((g) => !i.has(g))
      },
      locked: {
        ...t.state.locked,
        selections: t.state.locked.selections.filter((g) => !i.has(g))
      },
      free: {
        ...t.state.free,
        selections: t.state.free.selections.filter((g) => !i.has(g))
      }
    }
  };
}
const sot = {
  openInstances: [Dt],
  ruleEngineInput: null,
  ruleEngineState: null,
  ruleEngineConflict: null,
  ruleEngineError: void 0
}, r_ = Vg({
  name: "common",
  initialState: sot,
  reducers: {
    setRuleEngineInput: (e, t) => {
      e.ruleEngineInput = t.payload;
    },
    setRuleEngineState: (e, t) => {
      e.ruleEngineState = t.payload;
    },
    setRuleEngineConflict: (e, t) => {
      e.ruleEngineConflict = t.payload;
    },
    addOpenInstance: (e, t) => {
      e.openInstances = ce.uniqBy([...e.openInstances.filter((i) => i.id === Dt.id || i.instance.belongsToInstanceId !== t.payload.instance.belongsToInstanceId), t.payload], (i) => i.id);
    },
    setOpenInstance: (e, t) => {
      e.openInstances = ce.uniqBy([t.payload], (i) => i.id);
    },
    setOpenInstances: (e, t) => {
      e.openInstances = ce.uniqBy(t.payload, (i) => i.id);
    },
    removeOpenInstance: (e, t) => {
      e.openInstances = e.openInstances.filter((i) => i.id !== t.payload.id);
    },
    resetTouched: (e) => {
      e.ruleEngineState && (e.ruleEngineState.state = Prt(e.ruleEngineState.state));
    },
    setRuleEngineError: (e, t) => {
      e.ruleEngineError = t.payload;
    }
  }
}), {
  setRuleEngineInput: aot,
  setRuleEngineState: o_,
  setRuleEngineConflict: CV,
  addOpenInstance: QKt,
  setOpenInstance: cot,
  setOpenInstances: dot,
  removeOpenInstance: jKt,
  resetTouched: Cot,
  setRuleEngineError: UT
} = r_.actions, uot = r_.reducer, Aot = {
  actionEngineInput: null,
  actionEngineState: n_
}, I_ = Vg({
  name: "common",
  initialState: Aot,
  reducers: {
    setActionEngineInput: (e, t) => {
      e.actionEngineInput = t.payload;
    },
    setActionEngineState: (e, t) => {
      e.actionEngineState = t.payload;
    }
  }
}), {
  setActionEngineInput: bot,
  setActionEngineState: l_
} = I_.actions, mot = I_.reducer, PT = (e, t, i, n, g) => {
  let r = e;
  if (t) {
    const o = vg(n), I = wg(n), s = tI(n), {
      result: a,
      errorMessage: d
    } = D1(I, s, g, o, t, i);
    r = a, d != null && console.warn(d);
  }
  return r;
}, hot = (e) => (t) => m$e(t)[e], pot = (e, t) => (i) => {
  var m;
  const n = /* @__PURE__ */ new Date(), g = Ai(i), r = i.common.dealerData, o = (m = r.apps) == null ? void 0 : m.find((h) => h.appId == (g == null ? void 0 : g.id)), I = (r == null ? void 0 : r.discount) || 0, s = (r == null ? void 0 : r.surcharge) || 0, a = (o == null ? void 0 : o.discount) != 0 ? o == null ? void 0 : o.discount : null, d = (o == null ? void 0 : o.surcharge) != 0 ? o == null ? void 0 : o.surcharge : null, C = a ?? I, u = d ?? s, A = Y6(i, e).filter((h) => !h.displayOnly && (h.fromDate == null || new Date(h.fromDate) <= n) && (h.toDate == null || new Date(h.toDate) >= n) && (h.fromQty == null || h.fromQty == 0 || h.fromQty <= t) && (h.toQty == null || h.toQty == 0 || h.toQty >= t)).sort((h, B) => h.sort - B.sort).map((h) => ({
    ...h,
    price: h.price * (1 - C / 100) * (1 + u / 100)
  }));
  return A.length == 0 ? {
    price: 0,
    type: Ac.fixed
  } : A[0];
}, Bot = (e, t) => {
  const i = Dg(e), n = PT(t.count, t.expression, t.anchoringSelection, e, i.variables.variableHierarchies) ?? 1, g = !km(t.amount) || !km(t.amountExpression) ? PT(t.amount, t.amountExpression, t.anchoringSelection, e, i.variables.variableHierarchies) : void 0, r = hot(t.articleId)(e);
  if (!r) {
    console.warn(`Article not found: ${t.articleId} for article action: ${JSON.stringify(t, null, 2)}`);
    return;
  }
  const o = pot(t.articleId, n)(e);
  return {
    articleAction: t,
    qty: n,
    amount: g,
    article: r,
    price: o,
    main: t.main
  };
}, Zot = {
  bom: []
}, s_ = Vg({
  name: "bom",
  initialState: Zot,
  reducers: {
    setBom: (e, t) => {
      e.bom = t.payload;
    }
  }
}), {
  setBom: fot
} = s_.actions, Got = s_.reducer, a_ = () => (e, t) => {
  const i = t(), n = rje(i).reduce((g, r) => {
    const o = Bot(i, r);
    return o && o.qty > 0 && (km(o.amount) || o.amount > 0) && g.push(o), g;
  }, []);
  return e(fot(n)), n;
}, px = (e) => (t, i) => {
  t(bot((e == null ? void 0 : e.actionEngineInput) || null)), t(l_((e == null ? void 0 : e.actionEngineState) || null)), t(aot((e == null ? void 0 : e.ruleEngineInput) || null)), t(o_((e == null ? void 0 : e.ruleEngineState) || null)), t(a_());
}, zT = 16;
function yot(e, t) {
  var i;
  return (
    // TODO: We should simply check the variable settings in
    // removeConflictingInstanceSelections instead of checking them for the
    // selection every time.
    ((i = e.variables.byVarId.all[t.variableId]) == null ? void 0 : i.settings.templateOptions.deleteInvalidInstances) ?? !1
  );
}
function Wot(e, t, i) {
  return e ? (e == null ? void 0 : e.state.locked.selections).reduce((r, o) => {
    var a;
    if (!_r(o) || !yot(t, o))
      return r;
    const I = i == null ? void 0 : i.state.all.invalidOptions, s = (a = I == null ? void 0 : I[o.instance.id]) == null ? void 0 : a[o.variableId];
    return s != null && s.find((d) => d.value.id === o.valueId) && r.push(o), r;
  }, []) : [];
}
function Sot(e, t, i) {
  if (e === null)
    return t;
  const n = Wot(e, i, t);
  if (n.length === 0)
    return t;
  let g = t;
  return n.sort((r, o) => o.instance.hierarchyLevel - r.instance.hierarchyLevel).forEach((r) => {
    const o = If(g.state, r);
    if (o)
      g = o;
    else
      throw new Error(`Could not delete instance: ${r}`);
  }), g;
}
function Vot(e, t) {
  const i = (r, o) => r.all.selections.every((I, s) => {
    var a, d;
    return (a = I.data) != null && a.inputValue ? I.data.inputValue === ((d = o.all.selections[s].data) == null ? void 0 : d.inputValue) : !0;
  });
  let n = 0, g;
  for (; !g || !i(g, e.state); ) {
    if (n > 20)
      throw new Error($r("Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen."));
    g = e.state, e = {
      ...e,
      state: $rt(t, e.state).state
    }, n++;
  }
  return e;
}
const c_ = (e, t, i, n, g) => (r, o) => {
  var H, x;
  performance.mark("engine-start");
  const I = o(), s = Ai(I), a = I.metadata, d = Qd(I), C = wg(I), u = tI(I), A = ya(I), m = Sj(I), h = i || Dg(I), B = n || nje(I), f = Jg(I);
  let G = qB(I) || n_;
  const y = qB(I);
  let W = h, V = t;
  performance.mark("engine-selectors");
  let w = 0;
  for (; w < zT; ) {
    performance.mark(`engine-fixing-numbers-${w}`);
    const N = V;
    W = P8(m, d, A, u, C, G, W, I), performance.mark(`engine-rule-input-${w}`), V = hx(W, V.state.all.selections, V.state.all.touched, t == null ? void 0 : t.lastManualChange, (x = (H = V == null ? void 0 : V.state) == null ? void 0 : H.locked) == null ? void 0 : x.selections), performance.mark(`engine-expression-${w}`), V = qrt(W, V, f ?? void 0, t == null ? void 0 : t.lastManualChange), V = Vot(V, W);
    const M = G;
    if (G = e(B, W, V, s, a), performance.mark(`engine-action-state-${w}`), V = got(W, V, G), performance.mark(`engine-instance-actions-${w}`), performance.mark(`engine-rule-state-${w}`), w > 0 && rot(M, G) && oot(N, V))
      break;
    w++;
  }
  if (w >= zT)
    throw new Error($r("Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden."));
  if (wot(W, V), f && (V = Urt(f.state, V.state, t == null ? void 0 : t.lastManualChange)), V = lot(W, V), V = zrt(W, V, I), V = Sot(f, V, W), V = Iot(V, W), i_("engine"), !V)
    return {
      status: "error"
    };
  const v = {
    ruleEngineInput: W,
    ruleEngineState: V,
    actionEngineInput: B,
    actionEngineState: G
  };
  if (v.actionEngineState.popups.length > 0) {
    const N = v.actionEngineState.popups.find((M) => M.invalid || !(y != null && y.popups.find(($) => $.ruleItemId === M.ruleItemId)));
    if (N)
      return r(K7({
        action: N,
        newState: v
      })), {
        status: "popup-action",
        newState: v
      };
  }
  return g ? (r(px(v)), {
    status: "no-conflict",
    newState: v
  }) : V.state.all.selections.some((N) => {
    var M;
    return (M = N.data) == null ? void 0 : M.error;
  }) ? (r(CV(v)), {
    status: "expression-conflict"
  }) : bGe(v) ? (r(px(v)), {
    status: "no-conflict",
    newState: v
  }) : (r(CV(v)), {
    status: "conflict",
    newState: v
  });
};
function wot(e, t) {
  const {
    valid: i,
    invalid: n
  } = MT(e, t.state.locked.selections);
  t.state.locked.validOptions = i, t.state.locked.invalidOptions = n;
  const g = MT(e, t.state.free.selections).valid;
  t.state.free.validOptions = g, t.state = lA(t.state.locked, t.state.free);
}
const vot = {
  app: void 0,
  arDialog: !1,
  currentAction: null,
  configurationInitialization: null,
  configuration: null
}, d_ = Vg({
  name: "frontend",
  initialState: vot,
  reducers: {
    setFrontendApp: (e, t) => {
      e.app = t.payload;
    },
    setConfigurationInitialization: (e, t) => {
      e.configurationInitialization = t.payload;
    },
    setConfiguration: (e, t) => {
      e.configuration = t.payload;
    },
    setArDialog: (e, t) => {
      e.arDialog = t.payload;
    },
    setCurrentAction: (e, t) => {
      e.currentAction = t.payload;
    }
  }
}), {
  setFrontendApp: Rot,
  setConfigurationInitialization: C_,
  setConfiguration: Xot,
  setArDialog: _J,
  setCurrentAction: ba
} = d_.actions, Hot = d_.reducer, kot = (e, t, i) => me.flow(() => new URLSearchParams(window.location.search + `&${i}`), Object.fromEntries, me.omit(["app", "code", "dealer"]), Ort(e, t))(), $J = () => (e, t) => {
  var m;
  const i = t(), n = Qd(i), g = wg(i), r = tI(i), o = ya(i), I = fje(i), s = Sj(i), a = Ai(i), C = (m = EZ(i).apps) == null ? void 0 : m.find((h) => h.appId == a.id), u = (C == null ? void 0 : C.query) ?? "", A = Jg(i);
  try {
    const h = P8(s, n, o, r, g, void 0, void 0, i);
    let B;
    if (I) {
      const G = jrt(h, I.configuration);
      B = hx(h, G, !I.configuration.inspiration && I.configuration.json.touched || {}, void 0, G);
    } else
      B = A != null && // this checks if the existing state belongs to our app.
      A.state.all.selections.some((y) => h.values.byVarId.all[y.variableId]) ? hx(h, A.state.all.selections, A.state.all.touched, void 0, A.state.locked.selections) : Qrt(h);
    if (!B)
      throw new Error("Unable to calculate initial rule engine state");
    B = kot(h, B, u);
    const f = Kje(n, o, r, g, i);
    e(C_(null)), e(c_(M8, B, h, f, !0)), e(UT());
  } catch (h) {
    e(UT(h.message)), console.error(h);
  }
}, Fot = {
  isSceneLoading: !0,
  loadedModelIds: void 0,
  screenshotting: null,
  isScreenshottingPossible: !1,
  nextCameraPosition: null,
  forceNextCameraPosition: void 0,
  modelRuleData: {},
  editMode: !1,
  loadingStatus: {},
  sceneContext: {}
}, u_ = Vg({
  name: "k3d",
  initialState: Fot,
  reducers: {
    setModelRuleData: (e, t) => {
      e.modelRuleData[t.payload.ruleItemId] = t.payload;
    },
    clearModelRuleData: (e) => {
      e.modelRuleData = {};
    },
    setEditMode: (e, {
      payload: t
    }) => {
      e.editMode = t;
    },
    setSceneContext: (e, t) => {
      e.sceneContext = t.payload;
    },
    setIsRenderingScreenshot: (e, t) => {
      e.sceneContext = {
        ...e.sceneContext,
        isRenderingScreenshot: t.payload
      };
    },
    setIsAR: (e, t) => {
      e.sceneContext = {
        ...e.sceneContext,
        isAR: t.payload
      };
    },
    setIsVR: (e, t) => {
      e.sceneContext = {
        ...e.sceneContext,
        isVR: t.payload
      };
    },
    setScreenshotting: (e, t) => {
      t.payload === "creating" && (e.sceneContext.isRenderingScreenshot = !0), e.screenshotting = t.payload;
    },
    setIsScreenshottingPossible: (e, t) => {
      e.isScreenshottingPossible = t.payload;
    },
    resetScreenshotting: (e) => {
      const {
        screenshotting: t
      } = e;
      ce.isArray(t) && t.forEach((i) => URL.revokeObjectURL(i.file)), e.screenshotting = null, e.sceneContext.isRenderingScreenshot = !1;
    },
    setNextCameraPosition: (e, t) => {
      e.nextCameraPosition = t.payload;
    },
    forceNextCameraPosition: (e) => {
      e.forceNextCameraPosition = ce.uniqueId("forceNextCameraPosition_");
    },
    setIsSceneLoading: (e, t) => {
      e.isSceneLoading = t.payload;
    },
    setLoadedModelIds: (e, t) => {
      e.loadedModelIds = t.payload;
    }
  }
}), {
  setModelRuleData: Yot,
  clearModelRuleData: OT,
  setEditMode: $k,
  setScreenshotting: Bx,
  setIsScreenshottingPossible: QT,
  resetScreenshotting: xot,
  setNextCameraPosition: A_,
  forceNextCameraPosition: _Kt,
  setSceneContext: $Kt,
  setIsRenderingScreenshot: qKt,
  setIsAR: eEt,
  setIsVR: tEt,
  setIsSceneLoading: b_,
  setLoadedModelIds: Dot
} = u_.actions, Jot = u_.reducer, qJ = (e) => (t, i) => {
  const n = i(), g = MD(n), r = UD(e, g)[0];
  t(A_(r || null));
}, m_ = Vg({
  name: "articles",
  initialState: [],
  reducers: {
    createArticle: (e, t) => [...e, t.payload],
    deleteArticle: (e, t) => e.filter((i) => i.id !== t.payload),
    deleteArticles: (e, t) => e.filter((i) => !t.payload.includes(i.id)),
    setArticles: (e, t) => t.payload,
    updateArticle: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateArticles: (e, t) => {
      const i = ce.keyBy(t.payload, (n) => n.id);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createArticle: iEt,
  deleteArticle: nEt,
  deleteArticles: gEt,
  setArticles: h_,
  updateArticle: rEt,
  updateArticles: oEt
} = m_.actions, Kot = m_.reducer, Eot = {
  client: null
}, p_ = Vg({
  name: "client",
  initialState: Eot,
  reducers: {
    setClient: (e, t) => {
      e.client = t.payload;
    }
  }
}), {
  setClient: Not
} = p_.actions, Lot = p_.reducer, B_ = Vg({
  name: "groups",
  initialState: [],
  reducers: {
    setGroups: (e, t) => t.payload || [],
    createGroup: (e, t) => [...e, t.payload],
    deleteGroup: (e, t) => e.filter((i) => i.id !== t.payload.id),
    updateGroup: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateGroups: (e, t) => {
      const i = Ni(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createGroup: IEt,
  deleteGroup: lEt,
  updateGroup: Tot,
  updateGroups: Mot,
  setGroups: Z_
} = B_.actions, Uot = B_.reducer, f_ = Vg({
  name: "images",
  initialState: [],
  reducers: {
    createImage: (e, t) => [...e, t.payload],
    deleteImage: (e, t) => e.filter((i) => i.id !== t.payload),
    setImages: (e, t) => t.payload,
    updateImage: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i)
  }
}), {
  createImage: sEt,
  deleteImage: aEt,
  setImages: G_,
  updateImage: cEt
} = f_.actions, Pot = f_.reducer, y_ = Vg({
  name: "materials",
  initialState: [],
  reducers: {
    createMaterial: (e, t) => [...e, t.payload],
    deleteMaterial: (e, t) => e.filter((i) => i.id !== t.payload),
    setMaterials: (e, t) => t.payload,
    updateMaterial: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i)
  }
}), {
  createMaterial: dEt,
  deleteMaterial: CEt,
  setMaterials: W_,
  updateMaterial: uEt
} = y_.actions, zot = y_.reducer, S_ = Vg({
  name: "prices",
  initialState: [],
  reducers: {
    createPrice: (e, t) => [...e, t.payload],
    deletePrice: (e, t) => e.filter((i) => i.id !== t.payload),
    setPrices: (e, t) => t.payload,
    updatePrice: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    setBOM: (e, t) => t.payload
  }
}), {
  createPrice: AEt,
  deletePrice: bEt,
  setPrices: V_,
  updatePrice: mEt
} = S_.actions, Oot = S_.reducer, w_ = Vg({
  name: "ruleItems",
  initialState: [],
  reducers: {
    setRuleItems: (e, t) => t.payload,
    createRuleItem: (e, t) => [...e, t.payload],
    deleteRuleItem: (e, t) => e.filter((i) => i.id !== t.payload),
    updateRuleItem: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateRuleItems: (e, t) => {
      const i = Ni(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createRuleItem: hEt,
  deleteRuleItem: pEt,
  updateRuleItem: Qot,
  updateRuleItems: BEt,
  setRuleItems: v_
} = w_.actions, jot = w_.reducer, R_ = Vg({
  name: "rules",
  initialState: [],
  reducers: {
    setRules: (e, t) => t.payload,
    createRule: (e, t) => [...e, t.payload],
    deleteRule: (e, t) => e.filter((i) => i.id !== t.payload),
    updateRule: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateRules: (e, t) => {
      const i = Ni(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createRule: ZEt,
  updateRule: fEt,
  deleteRule: GEt,
  setRules: X_
} = R_.actions, _ot = R_.reducer, H_ = ({
  appId: e,
  attrs: t = null,
  description: i = null,
  disabled: n = !1,
  isDefault: g = !1,
  key: r = null,
  label: o,
  price: I = 0,
  sort: s,
  thumbnail: a = null,
  url: d = null,
  info: C = null,
  value: u,
  variableId: A
}) => ({
  appId: e,
  attrs: t,
  description: i,
  disabled: n,
  isDefault: g,
  key: r,
  label: o,
  price: I,
  sort: s,
  thumbnail: a,
  url: d,
  value: u,
  info: C,
  variableId: A
}), k_ = Vg({
  name: "values",
  initialState: [],
  reducers: {
    setValues: (e, t) => t.payload,
    createValue: (e, t) => [...e, t.payload],
    deleteValue: (e, t) => e.filter((i) => i.id !== t.payload),
    updateValue: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateValues: (e, t) => {
      const i = t.payload;
      return e.map((n) => i.find((g) => g.id == n.id) || n);
    }
  }
}), {
  createValue: F_,
  deleteValue: $ot,
  updateValue: yEt,
  updateValues: WEt,
  setValues: Y_
} = k_.actions, qot = k_.reducer, IZ = (e, t) => async (i, n) => {
  const g = n(), r = ng(g), o = lh(t.id)(g), I = H_({
    ...e,
    sort: (e == null ? void 0 : e.sort) === void 0 ? 1 + Math.max(...o.map((a) => a.sort), 0) : e.sort,
    appId: t.appId,
    variableId: t.id
  }), s = await F7("value", I, {
    lang: r
  });
  return i(F_(s)), s;
}, SEt = (e, t) => async (i, n) => {
  const g = n(), r = ng(g), o = lh(t.id)(g), I = e.map((a, d) => H_({
    ...a,
    sort: 1 + Math.max(...o.map((C) => C.sort), 0) + d,
    appId: t.appId,
    variableId: t.id
  })), s = await Det("value", I, {
    lang: r
  });
  return s.forEach((a) => i(F_(a))), s;
}, eIt = (e) => async (t) => {
  t($ot(e)), await Y7("value", e);
}, tIt = (e) => (t, i) => {
  const n = i(), g = Dg(n);
  if (!g) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const r = Object.entries(e).flatMap(([s, a]) => g.variables.flat.all.filter((u) => u.groupId == +a).map((u) => ({
    instanceId: s,
    variableId: u.id
  }))), o = Jg(n);
  if (!o) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const I = o2(g, o.state, r);
  t(o_({
    ...o,
    state: I
  }));
}, x_ = Vg({
  name: "variables",
  initialState: [],
  reducers: {
    setVariables: (e, t) => t.payload,
    createVariable: (e, t) => [...e, t.payload],
    deleteVariable: (e, t) => e.filter((i) => i.id !== t.payload),
    updateVariable: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateVariables: (e, t) => {
      const i = Ni(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createVariable: VEt,
  deleteVariable: wEt,
  updateVariable: vEt,
  updateVariables: iIt,
  setVariables: D_
} = x_.actions, nIt = x_.reducer, l2 = (e) => (t, i) => {
  const n = i(), g = _Z(n, e);
  t(lf(g == null ? void 0 : g.id));
}, J_ = () => (e, t) => {
  const i = t(), n = h1(i);
  e(px(n)), e(CV(null));
}, K_ = () => (e) => {
  e(CV(null));
};
function gIt(e, t) {
  const i = Wc(e), n = Fj(e), g = i.find((u) => u.variableId === t.parentId);
  if (!g)
    return {
      openingGroupMap: n,
      closingGroupMap: {}
    };
  const r = vg(e), I = [...(g ? HZ(r, g) : []).filter((u) => i.includes(u)), g], s = to(e), a = Za(e), d = I.reduce((u, A) => {
    var h, B;
    const m = I.find((f) => f.id !== A.id && f.instance.belongsToInstanceId === A.id);
    if (m) {
      const f = a[m == null ? void 0 : m.variableId];
      u[A.id] = ((h = s.find((G) => G.id === (f == null ? void 0 : f.groupId))) == null ? void 0 : h.id) || n[A.id];
    } else
      u[A.id] = g.id === A.id && t.id || n[A.id] || ((B = _Z(e, A)) == null ? void 0 : B.id);
    return u;
  }, {}), C = ce.omitBy(ce.mapValues(n, (u, A) => n[A] && d[A] !== n[A] ? u : -1), (u) => u === -1);
  return {
    openingGroupMap: d,
    closingGroupMap: C
  };
}
const lf = (e) => (t, i) => {
  const n = i(), g = vD(n, e);
  if (!g) {
    console.error("setGroup contextInstance not found", e);
    return;
  }
  const r = Ba(e)(n);
  if (!r) {
    console.error("setGroup group not found", e);
    return;
  }
  const {
    openingGroupMap: o,
    closingGroupMap: I
  } = gIt(n, r);
  t(LQe(o)), t(qJ({
    type: "group",
    id: e
  })), t(NQe({
    focusGroupId: e,
    instanceId: g.id
  })), t(tIt(I)), JGe(n) && t($J());
  const s = Ai(i());
  Ym("step", (r == null ? void 0 : r.key) || (r == null ? void 0 : r.label) || "none", s, "step");
}, E_ = (e) => (t, i) => {
  const n = i(), g = L$e(e == null ? void 0 : e.variableId)(n), r = vl(e) || Dt.id;
  t(ig(r, g == null ? void 0 : g.id));
}, N_ = (e) => (t) => {
  ED("preprocessFullApp") && (e = ms("preprocessFullApp", e)), t(Not(e == null ? void 0 : e.client)), t(Z_(e == null ? void 0 : e.groups)), t(D_(e == null ? void 0 : e.variables)), t(Y_(e == null ? void 0 : e.values)), t(h_(e == null ? void 0 : e.articles)), t(V_(e == null ? void 0 : e.prices)), t(W_(e == null ? void 0 : e.materials)), t(S8(e == null ? void 0 : e.models)), t(G_((e == null ? void 0 : e.images) || [])), t(X_(e == null ? void 0 : e.rules)), t(v_(e == null ? void 0 : e.ruleItems)), Wje(e.app);
}, REt = (e, t) => async (i) => {
  const n = await QQe(t, e);
  return i(N_(n)), n;
}, XEt = async (e) => {
  e(Z_([])), e(D_([])), e(Y_([])), e(h_([])), e(V_([])), e(W_([])), e(S8([])), e(G_([])), e(X_([])), e(v_([]));
}, rIt = () => async (e, t) => {
  const i = t(), n = aj(i), g = _u(n == null ? void 0 : n.id)(i);
  let r = Dt;
  Dt && g && (r = g), e(ig(r.id));
  const o = location.href.includes("edit/configurator/mobile") ? "phone" : "desktop";
  e(Uet(o));
}, oIt = (e, t) => {
  var g, r;
  const i = {
    articles: [],
    prices: []
  }, n = (g = t == null ? void 0 : t.prices) != null && g.length || (r = t == null ? void 0 : t.articles) != null && r.length ? {
    ...e,
    ...t
  } : e;
  return {
    ...i,
    ...n
  };
}, fB = (e, t, i, n = !1) => async (g) => {
  i ? (g(C_({
    checkSelections: n,
    configuration: i
  })), g(Xot(i)), Ym("loaded", i.code, e.app, "loaded")) : Ym("loaded", "app", e.app, "loaded"), g(N_(oIt(e, t))), g(Rot(e.app)), g($J()), g(rIt());
}, HEt = (e) => async (t) => {
  await t(IZ({
    appId: e.appId,
    label: $r("Nicht Befüllt"),
    sort: 0,
    // Das muss so bleiben für die automatische Generierung im UsageStep
    value: !1,
    variableId: e.id
  }, e)), await t(IZ({
    appId: e.appId,
    label: $r("Befüllt"),
    sort: 1,
    // Das muss so bleiben für die automatische Generierung im UsageStep
    value: !0,
    variableId: e.id
  }, e));
}, kEt = (e) => async (t) => {
  await t(IZ({
    appId: e.appId,
    label: $r("Ausgewählt"),
    sort: 0,
    value: !0,
    variableId: e.id
  }, e)), await t(IZ({
    appId: e.appId,
    label: $r("Nicht ausgewählt"),
    sort: 1,
    value: !1,
    variableId: e.id
  }, e));
}, FEt = (e) => (t, i) => {
  const n = i();
  if (!P6(e.id)(n)) {
    const r = {
      label: $r("Keine Angabe"),
      key: QB,
      appId: e.appId,
      variableId: e.id,
      sort: 0,
      value: null
    };
    t(IZ(r, e));
  }
}, YEt = (e) => (t, i) => {
  const n = i(), g = P6(e.id)(n);
  g && t(eIt(g.id));
};
function IIt(e, t) {
  const i = Za(e), n = i[t.variableId], g = vg(e), r = [...HZ(g, t), t], o = r.sort(Fm).slice().reverse().find((s) => {
    const a = i[s.variableId], d = hi(a);
    return !(d != null && d.showComponentEditorsInline) || ju(a) === Jn.ComponentValueCards;
  }) || Dt, I = r.slice(r.indexOf(o));
  return {
    variable: n,
    newOpenInstances: I
  };
}
const ig = (e, t) => (i, n) => {
  const g = n(), r = e ? TD(e)(g) : Dt;
  if (r) {
    const {
      variable: o,
      newOpenInstances: I
    } = IIt(g, r);
    !o || hr(g) || j6(r)(g) || // We need to make empty instances selectable for the
    // ComponentValueCards template otherwise the user can't delete or sort
    // the instance.
    ju(o) === Jn.ComponentValueCards ? (i(dot(I)), i(t ? lf(t) : l2(r))) : (i(ig(r.instance.belongsToInstanceId, o.groupId)), i(JD(o.id)));
  }
};
var AS = /* @__PURE__ */ ((e) => (e[e.initial = 0] = "initial", e[e.localSavedWithSavedAction = 1] = "localSavedWithSavedAction", e[e.localSavedWithoutSavedAction = 2] = "localSavedWithoutSavedAction", e[e.versionMissmatch = 3] = "versionMissmatch", e[e.noAppAndCfgCode = 4] = "noAppAndCfgCode", e[e.errorWhileLoading = 5] = "errorWhileLoading", e))(AS || {});
function lIt(e) {
  const t = zt(), [i, n] = At(
    0
    /* initial */
  ), [g, r] = At(void 0), [o, I] = At(void 0);
  return et(() => {
    (async () => {
      const a = Aye(), d = bye(), C = Cye();
      async function u(m, h) {
        var G;
        let B;
        try {
          m && (B = await Z1(`/data/dealer/${m}.json`));
        } catch {
          n(
            4
            /* noAppAndCfgCode */
          );
        }
        if (!B)
          return;
        if ((G = B == null ? void 0 : B.apps) == null ? void 0 : G.find((y) => y.appId == h.app.id))
          t(EQe(B));
        else
          throw new Error("no dealer app access");
      }
      async function A(m, h) {
        return XY(qS(m.app)[0], m.app.code, h == null ? void 0 : h.articleVersionId);
      }
      if (d) {
        let m;
        try {
          m = await $Qe(d);
        } catch {
          console.error("No Inspiration for this configuration found. Instead asking Backend. No Problem :-)");
          try {
            if (m = await qQe(d), !m.versionId)
              throw new Error("Konfiguration nicht gefunden. Ist der Konfigurator veröffentlicht?");
          } catch {
            n(
              4
              /* noAppAndCfgCode */
            );
          }
        }
        if (!m)
          return;
        m.articleVersionId = "current", m.versionId || console.error("Configuration was created with unpublished version.");
        const h = await RY(jS(m), m.appCode, "current", t);
        if (await u(
          // queryDealerCode is required for inspirations
          m.dealerCode ?? C,
          h
        ), m.inspiration) {
          const B = await A(h, m);
          await t(fB(h, B, m, !0));
        } else if (m.versionId !== h.app.versionId)
          n(
            3
            /* versionMissmatch */
          ), r(h), I(m);
        else {
          const B = await A(h, m);
          t(fB(h, B, m));
        }
      } else if (a)
        try {
          const m = await RY(jS(), a, "current", t);
          await u(C, m);
          const h = await A(m);
          t(fB(m, h));
        } catch {
          n(
            4
            /* noAppAndCfgCode */
          );
        }
      else
        n(
          4
          /* noAppAndCfgCode */
        );
    })();
  }, [e]), {
    situation: i,
    versionMissmatchedApp: g,
    versionMissmatchedConfiguration: o
  };
}
var uV, qk = typeof Zn < "u" && (Zn.crypto || Zn.msCrypto);
if (qk && qk.getRandomValues) {
  var jT = new Uint8Array(16);
  uV = function() {
    return qk.getRandomValues(jT), jT;
  };
}
if (!uV) {
  var _T = new Array(16);
  uV = function() {
    for (var e = 0, t; e < 16; e++)
      e & 3 || (t = Math.random() * 4294967296), _T[e] = t >>> ((e & 3) << 3) & 255;
    return _T;
  };
}
var L_ = uV, T_ = [];
for (var vW = 0; vW < 256; ++vW)
  T_[vW] = (vW + 256).toString(16).substr(1);
function sIt(e, t) {
  var i = t || 0, n = T_;
  return n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]];
}
var M_ = sIt, aIt = L_, cIt = M_, pd = aIt(), dIt = [
  pd[0] | 1,
  pd[1],
  pd[2],
  pd[3],
  pd[4],
  pd[5]
], $T = (pd[6] << 8 | pd[7]) & 16383, eF = 0, tF = 0;
function CIt(e, t, i) {
  var n = t && i || 0, g = t || [];
  e = e || {};
  var r = e.clockseq !== void 0 ? e.clockseq : $T, o = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), I = e.nsecs !== void 0 ? e.nsecs : tF + 1, s = o - eF + (I - tF) / 1e4;
  if (s < 0 && e.clockseq === void 0 && (r = r + 1 & 16383), (s < 0 || o > eF) && e.nsecs === void 0 && (I = 0), I >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  eF = o, tF = I, $T = r, o += 122192928e5;
  var a = ((o & 268435455) * 1e4 + I) % 4294967296;
  g[n++] = a >>> 24 & 255, g[n++] = a >>> 16 & 255, g[n++] = a >>> 8 & 255, g[n++] = a & 255;
  var d = o / 4294967296 * 1e4 & 268435455;
  g[n++] = d >>> 8 & 255, g[n++] = d & 255, g[n++] = d >>> 24 & 15 | 16, g[n++] = d >>> 16 & 255, g[n++] = r >>> 8 | 128, g[n++] = r & 255;
  for (var C = e.node || dIt, u = 0; u < 6; ++u)
    g[n + u] = C[u];
  return t || cIt(g);
}
var uIt = CIt, AIt = L_, bIt = M_;
function mIt(e, t, i) {
  var n = t && i || 0;
  typeof e == "string" && (t = e == "binary" ? new Array(16) : null, e = null), e = e || {};
  var g = e.random || (e.rng || AIt)();
  if (g[6] = g[6] & 15 | 64, g[8] = g[8] & 63 | 128, t)
    for (var r = 0; r < 16; ++r)
      t[n + r] = g[r];
  return t || bIt(g);
}
var hIt = mIt, pIt = uIt, U_ = hIt, eK = U_;
eK.v1 = pIt;
eK.v4 = U_;
var BIt = eK;
const ZIt = /* @__PURE__ */ Tr(BIt), tK = (e) => (t) => (e || (e = ZIt()), t(MQe(e)), e), fIt = () => {
  const {
    t: e
  } = ii(), t = zt(), {
    situation: i,
    versionMissmatchedApp: n,
    versionMissmatchedConfiguration: g
  } = lIt(
    0
    /* none */
  ), r = ha(), o = un(), I = jS(), s = (C) => {
    var u, A, m, h;
    return ((h = (m = (A = (u = n == null ? void 0 : n.app) == null ? void 0 : u.settings) == null ? void 0 : A.dynamicSettings) == null ? void 0 : m[C]) == null ? void 0 : h[I]) || o(C);
  }, a = async () => {
    const C = await XY(qS(n.app)[0], n.app.code, g == null ? void 0 : g.articleVersionId);
    t(fB(n, C, g));
  }, d = async () => {
    const C = t(tK);
    if (!g)
      return;
    const u = await RY(jS(g), g.versionId, "old", null), A = await XY(qS(u.app)[0], u.app.code, g == null ? void 0 : g.articleVersionId);
    await t(fB(u, A, g)), t(DD(C));
  };
  switch (i) {
    case AS.initial:
      return /* @__PURE__ */ p(oQ, { loading: !0 });
    case AS.versionMissmatch:
      return /* @__PURE__ */ ge(Yd, { open: !0, children: [
        /* @__PURE__ */ p(Dd, { children: s("appload_versionmismatch_title") }),
        /* @__PURE__ */ ge(xd, { children: [
          /* @__PURE__ */ p(Cr, { children: s("appload_versionmismatch_text") }),
          /* @__PURE__ */ ge(Yu, { children: [
            /* @__PURE__ */ p(Si, { onClick: d, "data-cy": "oldVersion", children: s("appload_versionmismatch_old") }),
            /* @__PURE__ */ p(Si, { "data-cy": "newVersion", variant: "contained", onClick: a, children: s("appload_versionmismatch_new") })
          ] })
        ] })
      ] });
    case AS.noAppAndCfgCode:
      return /* @__PURE__ */ ge(Yd, { open: !0, children: [
        /* @__PURE__ */ p(Dd, { children: e("Ladevorgang fehlgeschlagen") }),
        /* @__PURE__ */ ge(xd, { children: [
          /* @__PURE__ */ p(Cr, { children: e("Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!") }),
          /* @__PURE__ */ ge(Yu, { children: [
            /* @__PURE__ */ p(Si, { "data-cy": "goHome", onClick: () => {
              r("/admin"), r(0);
            }, children: e("Zur Startseite") }),
            /* @__PURE__ */ p(Si, { onClick: () => window.location.reload(), "data-cy": "reload", children: e("Neu Laden") }),
            /* @__PURE__ */ p(Si, { "data-cy": "restart", onClick: () => {
              window.localStorage.clear(), window.location.reload();
            }, children: e("Cleanup und Neu Laden") })
          ] })
        ] })
      ] });
    default:
      return /* @__PURE__ */ p(Bt, {});
  }
}, GIt = (e) => {
  var t;
  return (t = e.customData) == null ? void 0 : t.customData;
}, iK = (e) => {
  var t;
  return (t = Ai(e)) == null ? void 0 : t.settings.customData;
}, yIt = (e) => {
  var t;
  return (t = iK(e)) == null ? void 0 : t.url;
}, WIt = (e) => {
  var t;
  return ((t = iK(e)) == null ? void 0 : t.debounceMs) || 1e3;
}, nK = (e) => {
  var t;
  return (t = iK(e)) == null ? void 0 : t.selectedData;
}, SIt = (e) => {
  var t;
  return (t = nK(e)) == null ? void 0 : t.variables;
}, iF = [], gK = Pt([SIt, wg, Za], (e, t, i) => e === void 0 ? iF : ce.isBoolean(e) ? e ? t : iF : ce.isArray(e) ? e.map((n) => i[n]) : iF), P_ = Pt([vg, gK], (e, t) => {
  const i = new Set(t.map((n) => n.id));
  return e.filter((n) => i.has(n.variableId));
}), VIt = Pt([JZ, gK, P_], (e, t, i) => {
  const n = new Set(i.map((g) => g.valueId));
  return t.reduce((g, r) => {
    var I;
    const o = (I = e[r.id]) == null ? void 0 : I.filter((s) => n.has(s.id));
    return o && (g[r.id] = o), g;
  }, {});
}), wIt = Pt([nK, E1], (e, t) => e != null && e.bom ? t : void 0), vIt = Pt([nK, iC], (e, t) => e != null && e.price ? t : void 0), RIt = {
  customData: null
}, z_ = Vg({
  name: "customData",
  initialState: RIt,
  reducers: {
    setCustomData: (e, t) => {
      e.customData = t.payload;
    }
  }
}), {
  setCustomData: XIt
} = z_.actions, HIt = z_.reducer, kIt = () => {
  const e = zt(), t = _(Ai), i = _(yIt), n = _(WIt), g = _(gK), r = _(VIt), o = _(P_), I = _(wIt), s = _(vIt), a = je(() => ce.debounce((d, C, u, A, m, h, B) => {
    var f;
    !d || !C || !((f = C.productDetails) != null && f.infoservice) || ce.isEmpty(u) && ce.isEmpty(A) && ce.isEmpty(m) && !h && B === void 0 || fetch(d, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        app: C,
        variables: u,
        values: A,
        selections: m,
        bom: h,
        price: B
      })
    }).then((G) => G.json()).then((G) => {
      e(XIt(G.json));
    }).catch((G) => {
      console.error("Error posting data to", d, ":", G);
    });
  }, n), [e, n]);
  return et(() => {
    a(i, t, g, r, o, I, s);
  }, [g, r, o, I, s, a, i, t]), null;
};
class Td extends Se.Component {
  constructor(i) {
    super(i);
    // E.g. API Calls that fail
    Bg(this, "onUnhandledRejection", (i) => {
      i.promise.catch((n) => {
        console.error(this.name + ": Unhandled Rejection occured:", n), this.setState(Td.getDerivedStateFromError(n, "unhandledRejection"));
      }), i.stopImmediatePropagation(), i.stopPropagation();
    });
    this.state = {
      error: null,
      errorType: void 0
    }, this.handleCloseError = this.handleCloseError.bind(this);
  }
  // Can be automatically called by React without a default Error Type
  static getDerivedStateFromError(i, n = "childComponent") {
    return {
      error: i,
      errorType: n
    };
  }
  get name() {
    return this.constructor.name || Td.name;
  }
  componentDidMount() {
    this.catchUnhandledRejectionErrors && window.addEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentWillUnmount() {
    this.catchUnhandledRejectionErrors && window.removeEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentDidCatch(i, n) {
    console.error(this.name + ": Unexpected component error occurred:", i, n);
  }
  handleCloseError() {
    this.setState({
      error: null,
      errorType: void 0
    });
  }
  render() {
    return this.state.error ? this.renderError(this.state.error, this.state.errorType) : this.props.children;
  }
}
class AV extends Td {
  constructor() {
    super(...arguments);
    Bg(this, "catchUnhandledRejectionErrors", !1);
  }
  renderError() {
    return /* @__PURE__ */ p(Cc, { component: "div", className: "k3-area-error-boundary", sx: {
      padding: this.props.addPadding ? "16px" : "0px"
    }, children: /* @__PURE__ */ ge(_t, { gap: 0.5, direction: "column", children: [
      /* @__PURE__ */ p(Ne, { variant: "h6", color: "error", children: $r("Fehler") }),
      " ",
      /* @__PURE__ */ p("br", {}),
      /* @__PURE__ */ p(Ne, { variant: "subtitle1", children: $r("Beim Rendern des Inhalts ist ein Fehler aufgetreten.") })
    ] }) });
  }
}
const FIt = () => {
  const e = zt(), t = _(h1);
  if (t) {
    const i = t.ruleEngineState.lastManualChange;
    if (!i)
      return console.error("No change detected, but a conflict. This should not happen.", t), null;
    const n = O0(t.ruleEngineInput, t.ruleEngineState.state, i), g = [...t.ruleEngineState.touchedChanges.map((I) => ({
      current: I[0] ? O0(t.ruleEngineInput, t.ruleEngineState.state, I[0]) : null,
      new: I[1] ? O0(t.ruleEngineInput, t.ruleEngineState.state, I[1]) : null
    })), ...t.ruleEngineState.state.all.selections.filter((I) => {
      var s;
      return (s = I.data) == null ? void 0 : s.error;
    }).map((I) => ({
      current: O0(t.ruleEngineInput, t.ruleEngineState.state, I),
      new: null
    }))];
    return /* @__PURE__ */ p(DIt, { variableCausingConflict: n, conflicts: g, rejectAlternative: () => {
      e(K_());
    }, acceptAlternative: () => {
      e(J_());
    } });
  } else
    return null;
}, H0 = (e) => {
  var t;
  return (t = e == null ? void 0 : e.instance) != null && t.value ? `${e.variable}, ${e.instance.index + 1}. ${e.instance.value}` : e == null ? void 0 : e.variable;
}, YIt = (e) => {
  const t = un(), i = e.conflicts.every((o) => {
    var I;
    return !((I = o.current) != null && I.unsolvable);
  }), n = je(() => {
    var a, d, C, u, A, m;
    const o = {
      value: (a = e.variableCausingConflict) == null ? void 0 : a.value,
      variable: H0(e.variableCausingConflict),
      conflictValue0: (C = (d = e.conflicts[0]) == null ? void 0 : d.current) == null ? void 0 : C.value,
      conflictVariable0: H0(e.conflicts[0].current)
    };
    if ((u = e.conflicts[0].current) != null && u.error)
      return t("translation_invalid_rule_modale_custom_error", 'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}). Und wird deshalb zurückgesetzt.', {
        ...o
      });
    if (e.conflicts.length === 1)
      return t("translation_invalid_rule_modal_1_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).', o);
    const I = {
      ...o,
      conflictValue1: (A = e.conflicts[1].current) == null ? void 0 : A.value,
      conflictVariable1: H0(e.conflicts[1].current)
    };
    if (e.conflicts.length === 2)
      return t("translation_invalid_rule_modal_2_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).', I);
    const s = {
      ...I,
      conflictValue2: (m = e.conflicts[2].current) == null ? void 0 : m.value,
      conflictVariable2: H0(e.conflicts[2].current)
    };
    return e.conflicts.length === 3 ? t("translation_invalid_rule_modal_3_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).', s) : t("translation_invalid_rule_modal_other_conflict", 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.', o);
  }, [e, t]), g = (o) => {
    o ? e.acceptAlternative() : e.rejectAlternative();
  }, r = t("translation_invalid_rule_modal_custom_text");
  return /* @__PURE__ */ ge(HJ, { maxWidth: 800, show: !0, className: "invalidRuleModal", dataCy: "invalidRuleModal", title: t("translation_invalid_rule_modal_changes_needed"), settingKeys: xIt, cancelButtonText: t(Ii.CANCEL), confirmButtonText: t(i ? Ii.OK : Ii.CLOSE), onClose: i ? g : e.rejectAlternative, type: "warning", children: [
    /* @__PURE__ */ p(Cr, { id: "alert-dialog-slide-description", className: "invalidRuleModalHeading1", children: n }),
    /* @__PURE__ */ p("br", {}),
    i && /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p(Cr, { className: "invalidRuleModalHeading2", children: t("translation_invalid_rule_modal_changes_will_be_made") }),
      /* @__PURE__ */ p(fe, { component: "div", className: "invalidRuleModalAlternatives", children: e.conflicts.map((o, I) => {
        const [s, a] = [o.current, o.new];
        return /* @__PURE__ */ ge(Ne, { children: [
          H0(s),
          ": ",
          /* @__PURE__ */ p("b", { children: s == null ? void 0 : s.value }),
          " ",
          a != null && a.value ? /* @__PURE__ */ ge(Bt, { children: [
            t("translation_invalid_rule_modal_changes_will_become"),
            " ",
            /* @__PURE__ */ p("b", { children: a == null ? void 0 : a.value })
          ] }) : t("translation_invalid_rule_modal_will_be_deleted")
        ] }, I);
      }) })
    ] }),
    !!r && /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p("br", {}),
      /* @__PURE__ */ p(Cr, { className: "invalidRuleModalinfo", children: r })
    ] })
  ] });
}, xIt = ["translation_invalid_rule_modal_changes_needed", "translation_invalid_rule_modal_changes_will_be_made", "translation_invalid_rule_modal_changes_will_become", "translation_invalid_rule_modal_will_be_deleted", "translation_invalid_rule_modal_custom_text", "translation_invalid_rule_modale_custom_error", "translation_invalid_rule_modal_1_conflict", "translation_invalid_rule_modal_2_conflict", "translation_invalid_rule_modal_3_conflict", "translation_invalid_rule_modal_other_conflict", Ii.CANCEL, Ii.OK], DIt = ki({
  app: {
    invalidRuleModal: {
      root: !0
    }
  }
})(YIt);
function O_() {
  const e = _(Xje);
  return /* @__PURE__ */ p(oQ, { loading: e });
}
const JIt = () => null, KIt = ki({
  app: {
    mountedWhenLoaded: {
      root: !0
    }
  }
})(JIt);
var rK = {}, EIt = Cg;
Object.defineProperty(rK, "__esModule", {
  value: !0
});
var Q_ = rK.default = void 0, NIt = EIt(Kg()), LIt = xg;
Q_ = rK.default = (0, NIt.default)(/* @__PURE__ */ (0, LIt.jsx)("path", {
  d: "m18.25 7.6-5.5-3.18c-.46-.27-1.04-.27-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3M7 14.96v-4.62l4 2.32v4.61zm5-4.03L8 8.61l4-2.31 4 2.31zm1 6.34v-4.61l4-2.32v4.62zM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3zM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3z"
}), "ViewInAr");
const TIt = (e) => (e == null ? void 0 : e.attrs) || [], MIt = (e, t) => (
  // @ts-ignore
  TIt(t).find((i) => i.attrId == e)
), oK = () => {
  const [e, t] = Se.useState();
  return Se.useCallback((i) => {
    t(() => {
      throw i;
    });
  }, [t]);
}, gI = (e) => {
  const t = zt();
  return ft((...i) => (
    // @ts-ignore
    t(e(...i))
  ), [t, e]);
}, s2 = (e) => ce.get(e, ["metadata", ce.lowerCase("images")]);
me.curry((e, t) => me.flow(s2, me.filter((i) => i.appId == e))(t));
const xEt = (e) => {
  const t = s2(e);
  return uc.uniq(t.map((i) => i.path)).sort();
}, j_ = (e) => {
  const t = s2(e), i = oje(e);
  return t.filter((n) => i.some((g) => g.path === n.path));
}, IK = {
  status: "error"
}, sf = (e) => (t, i) => {
  const n = i(), {
    ruleEngineInput: g,
    ruleEngineState: r
  } = oh(n);
  if (!g || !r)
    return console.warn("Rule engine not initialized!"), IK;
  const o = If(r.state, e);
  return t(Xj(e.valueId, !1)), t(af(o));
}, sA = (e, t) => (i, n) => {
  const {
    ruleEngineInput: g,
    ruleEngineState: r,
    openInstance: o
  } = oh(n());
  if (!g || !r)
    return console.warn("Rule engine not initialized!"), IK;
  const I = I2(g, r.state, t || o, e);
  return i(Xj(e.id, !0)), i(af(I));
}, UIt = (e, t) => (i, n) => {
  const g = n(), r = $d(e)(g);
  if (!r) {
    console.error("Value not found");
    return;
  }
  i(sA(r, t));
}, lK = (e, t, i, n) => (g, r) => {
  const {
    ruleEngineInput: o,
    ruleEngineState: I,
    openInstance: s
  } = oh(r());
  if (!o || !I) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const d = o.values.flat.all.find((A) => A.id === e) || o.values.byVarId.all[t][0], C = jJ(o, I.state, n || s, d, i), u = g(af(C));
  return g(Vje(t, d, i)), u;
}, af = (e) => (t) => e ? t(c_(M8, e)) : (console.error("Rule engine failed"), IK), qT = 512, PIt = "application/pdf", zIt = (e) => {
  const t = e, i = [];
  for (let n = 0; n < t.length; n += qT) {
    const g = t.slice(n, n + qT), r = new Array(g.length);
    for (let I = 0; I < g.length; I++)
      r[I] = g.charCodeAt(I);
    const o = new Uint8Array(r);
    i.push(o);
  }
  return new Blob(i, {
    type: PIt
  });
}, OIt = (e) => URL.createObjectURL(zIt(e)), QIt = (e, t = "Konfiguration.pdf") => {
  jIt(OIt(e), t);
}, jIt = (e, t) => {
  const i = document.createElement("a");
  i.download = t, i.href = e, i.click();
}, sK = () => (e, t) => {
  const i = t(), n = Ygt(i);
  e(Bx(n ? "creating" : []));
}, _It = (e, t, i, n) => async (g, r) => {
  var C, u;
  const o = g(tK()), I = r(), s = ng(I), a = (C = EZ(I)) == null ? void 0 : C.id, d = ms("saveConfiguration", e);
  try {
    const A = await _Qe(d, d.appCode, t, s, i ?? [], n, a);
    if (A.error || !A || !A.code)
      throw new Error("Error while saving configuration");
    if (window.onbeforeunload = null, t.sendJavascriptEvent && ((u = window.top) == null || u.postMessage({
      type: "K3ConfigurationSaved",
      actionKey: t.actionKey,
      code: A.code
    }, "*")), dh(I) || hye(A.code), g(Cot()), A.pdf && (ED("openPdf") ? ms("openPdf", A) : QIt(A.pdf, A.pdfName)), t.sendToShop) {
      const m = Ai(I), h = A.shopLink || __(m, A);
      h && ((window.top || window).location = h);
    }
    return A;
  } catch (A) {
    if (A instanceof Error)
      return {
        error: !0,
        message: A.message
      };
  } finally {
    g(DD(o));
  }
}, __ = (e, t) => {
  const i = e.settings.shopURL;
  if (i && t.code) {
    const n = new URL(i);
    return n.searchParams.append("cfg", t.code), n.toString();
  } else
    return i || console.error("No shop URL found in app settings"), t.code || console.error("No code found in save result"), null;
}, aK = Bs(Dt), DEt = () => gI(b_), JEt = () => _(to), $_ = () => {
  const e = Li();
  return _((i) => {
    var g;
    let n = fa(i, e);
    return n || (n = (g = _Z(i, e)) == null ? void 0 : g.id), n;
  });
}, $It = () => {
  const e = $_();
  return _(Ba(e ?? -1));
}, KEt = () => gI(lf), EEt = (e) => _(Ba(e)), NEt = (e) => _(JQ(e)), qIt = () => _(wg), q_ = (e) => _(YZ(e)), LEt = (e) => _((t) => AJ(t, e)), elt = (e) => _(Go(e)), tlt = () => _(tI), ilt = (e) => _(aje(e)), nlt = (e) => _($d(e)), TEt = (e) => _(lh(e)), MEt = () => _(Qd), UEt = () => _(ya), PEt = () => _(CJ), zEt = () => _(eA), OEt = () => _(Wa), QEt = () => _(uJ), jEt = () => _(sh), glt = () => _(ch), _Et = () => _(QZ), $Et = () => _(s2), qEt = () => _(qB), Li = () => Hn(aK) ?? {}, e$ = () => {
  const e = Li();
  return _(T1).indexOf(e) === 0;
}, cK = () => _(vg), rlt = (e) => _(_u(e)), dK = (e) => {
  const t = t$(e);
  return nlt(t == null ? void 0 : t.valueId);
}, e9t = (e) => {
  var i;
  const t = t$(e);
  return (i = t == null ? void 0 : t.data) == null ? void 0 : i.inputValue;
}, t$ = (e) => {
  const t = q_(e);
  return rlt(t == null ? void 0 : t.id);
}, t9t = (e) => {
  var a;
  const t = ilt(e), i = cK(), g = i.filter((d) => d.valueId === (t == null ? void 0 : t.id)).filter((d) => d.valueId === (t == null ? void 0 : t.id)), r = _(LD), o = _(Za), I = (a = ce.last(g)) == null ? void 0 : a.id;
  if (!t || !g.length || !I)
    return {};
  const s = {};
  return g.forEach((d) => {
    var m;
    if (!d)
      return;
    const C = _r(d) ? d.id : vl(d);
    if (!C)
      return;
    const u = i.filter((h) => VQ(d, h));
    let A = s[C];
    if (!A) {
      const h = (m = o[d.variableId]) == null ? void 0 : m.key, B = d.valueId ? r[d.valueId] : void 0;
      A = h && B ? {
        [h]: B
      } : {};
    }
    s[C] = {
      ...A,
      ...u.reduce((h, B) => {
        var w;
        const f = o[B == null ? void 0 : B.variableId], G = f == null ? void 0 : f.key;
        if (!B.valueId || !G)
          return h;
        let y = r[B.valueId];
        if (eI(f) && (y = ((w = B.data) == null ? void 0 : w.inputValue) ?? 0), !f)
          return h;
        let W = y;
        const V = h[G];
        return !ce.isNumber(y) && !ce.isNumber(V) && SD(f) && (W = Array.isArray(V) ? [...V, y] : V ? [V, y] : [y]), h[G] = W, h;
      }, {})
    };
  }), s;
}, i9t = (e, t) => i$(e, [t])[0], i$ = (e, t) => {
  const i = q_(e), n = dK(e), g = Array.from(t).map(() => {
  });
  if (n && i)
    for (let r = 0; r < t.length; r++) {
      const o = Yfe(t[r], i);
      o && (g[r] = MIt(o == null ? void 0 : o.id, n));
    }
  return g;
}, n9t = () => gI(A_), n$ = () => _(Dg), g9t = () => _(Jg), r9t = () => {
  var e, t, i;
  return ((i = (t = (e = n$()) == null ? void 0 : e.values) == null ? void 0 : t.flat) == null ? void 0 : i.all) || [];
}, o9t = () => _(qB), I9t = () => gI(l_), l9t = (e) => {
  var t, i, n;
  return ((n = (i = (t = n$()) == null ? void 0 : t.values) == null ? void 0 : i.byVarId) == null ? void 0 : n.all[e]) || [];
}, s9t = () => gI(lK), a9t = () => gI(sA), c9t = () => gI(sf), d9t = () => _(h1), C9t = () => gI(J_), u9t = () => gI(K_), A9t = () => _(Hj), b9t = () => _(ng), m9t = () => _(Ai), h9t = () => _(iC), olt = () => gI(() => _J(!0)), p9t = () => gI(ba), B9t = () => gI(sK), Z9t = () => gI(ig), f9t = () => _(dh), G9t = () => _(hr), g$ = (e) => {
  const t = zt(), i = _(_u(e == null ? void 0 : e.id)), n = _((g) => $u(g, i)).reverse();
  return (g) => {
    const r = n.length > 0 ? n[0] : Dt, o = t(sA(g, r));
    if (o && "newState" in o && o.newState) {
      const I = o.newState.ruleEngineState.lastManualChange.instance, s = {
        id: I.id,
        instance: I,
        variableId: I.belongsToVariableId,
        valueId: i == null ? void 0 : i.valueId,
        sort: ((i == null ? void 0 : i.sort) || 0) + 1,
        debuggingValue: g.label
      };
      t(ba(null)), t(ig(s.id)), t(l2(s));
    }
  };
}, Ilt = () => {
  const e = Li(), t = _(T1).filter((g) => g.id !== (e == null ? void 0 : e.id)), i = zt(), n = _((g) => $u(g, e)).reverse();
  return (g) => {
    if (g.id === (e == null ? void 0 : e.id)) {
      const r = n.length > 0 ? n[0] : Dt;
      t.length > 0 ? i(ig(t[0].id)) : i(ig(r.id));
    }
    i(sf(g));
  };
}, y9t = (e, t) => _(KZ(e, t)), W9t = () => _(Gje), S9t = () => gI(a_), r$ = ye(Si)(({
  theme: e
}) => ({
  color: e.palette.secondary.contrastText,
  borderColor: e.palette.secondary.main,
  backgroundColor: e.palette.secondary.main,
  "&:hover": {
    backgroundColor: e.palette.secondary.dark
  }
}));
var oc = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.DESKTOP = 1] = "DESKTOP", e[e.IOS = 2] = "IOS", e[e.ANDROID = 3] = "ANDROID", e))(oc || {});
const o$ = () => {
  var g;
  const e = un(), t = olt(), i = _(Ai), n = e(Ii.AR_BUTTON);
  return /* @__PURE__ */ p(Bt, { children: i.stage === "3D" && /* @__PURE__ */ ge(_t, { direction: "row", children: [
    /* @__PURE__ */ p(Cn, { title: n, children: /* @__PURE__ */ p(r$, { "data-cy": "dynAR", onClick: t, className: "ar-button k3-btn k3-mode-button", variant: "contained", fullWidth: !0, startIcon: /* @__PURE__ */ p(Q_, {}), disabled: !((g = i.productDetails) != null && g.ar), children: e(Ii.AR_BUTTON) }) }),
    /* @__PURE__ */ p(Xl, { keys: [Ii.AR_BUTTON, Ii.AR_PLACEMENT, "translation_AR_Title", "translation_AR_Body", "translation_AR_Mobile_Title", "translation_AR_Mobile_Progress_Export", "translation_AR_Mobile_Progress_File", "translation_AR_Mobile_Progress_Device"] })
  ] }) });
};
var a2 = {}, I$ = {
  MODE_NUMBER: 1,
  MODE_ALPHA_NUM: 2,
  MODE_8BIT_BYTE: 4,
  MODE_KANJI: 8
}, llt = I$;
function l$(e) {
  this.mode = llt.MODE_8BIT_BYTE, this.data = e;
}
l$.prototype = {
  getLength: function(e) {
    return this.data.length;
  },
  write: function(e) {
    for (var t = 0; t < this.data.length; t++)
      e.put(this.data.charCodeAt(t), 8);
  }
};
var slt = l$, s$ = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}, RW = s$;
function _s(e, t) {
  this.totalCount = e, this.dataCount = t;
}
_s.RS_BLOCK_TABLE = [
  // L
  // M
  // Q
  // H
  // 1
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  // 2
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  // 3
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  // 4		
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  // 5
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  // 6
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  // 7		
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  // 8
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  // 9
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  // 10		
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  // 11
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  // 12
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  // 13
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  // 14
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  // 15
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  // 16
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  // 17
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  // 18
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  // 19
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  // 20
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  // 21
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  // 22
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  // 23
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  // 24
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  // 25
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  // 26
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  // 27
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  // 28
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  // 29
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  // 30
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  // 31
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  // 32
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  // 33
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  // 34
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  // 35
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  // 36
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  // 37
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  // 38
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  // 39
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  // 40
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
_s.getRSBlocks = function(e, t) {
  var i = _s.getRsBlockTable(e, t);
  if (i == null)
    throw new Error("bad rs block @ typeNumber:" + e + "/errorCorrectLevel:" + t);
  for (var n = i.length / 3, g = new Array(), r = 0; r < n; r++)
    for (var o = i[r * 3 + 0], I = i[r * 3 + 1], s = i[r * 3 + 2], a = 0; a < o; a++)
      g.push(new _s(I, s));
  return g;
};
_s.getRsBlockTable = function(e, t) {
  switch (t) {
    case RW.L:
      return _s.RS_BLOCK_TABLE[(e - 1) * 4 + 0];
    case RW.M:
      return _s.RS_BLOCK_TABLE[(e - 1) * 4 + 1];
    case RW.Q:
      return _s.RS_BLOCK_TABLE[(e - 1) * 4 + 2];
    case RW.H:
      return _s.RS_BLOCK_TABLE[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var alt = _s;
function a$() {
  this.buffer = new Array(), this.length = 0;
}
a$.prototype = {
  get: function(e) {
    var t = Math.floor(e / 8);
    return (this.buffer[t] >>> 7 - e % 8 & 1) == 1;
  },
  put: function(e, t) {
    for (var i = 0; i < t; i++)
      this.putBit((e >>> t - i - 1 & 1) == 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(e) {
    var t = Math.floor(this.length / 8);
    this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
  }
};
var clt = a$, ls = {
  glog: function(e) {
    if (e < 1)
      throw new Error("glog(" + e + ")");
    return ls.LOG_TABLE[e];
  },
  gexp: function(e) {
    for (; e < 0; )
      e += 255;
    for (; e >= 256; )
      e -= 255;
    return ls.EXP_TABLE[e];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var xr = 0; xr < 8; xr++)
  ls.EXP_TABLE[xr] = 1 << xr;
for (var xr = 8; xr < 256; xr++)
  ls.EXP_TABLE[xr] = ls.EXP_TABLE[xr - 4] ^ ls.EXP_TABLE[xr - 5] ^ ls.EXP_TABLE[xr - 6] ^ ls.EXP_TABLE[xr - 8];
for (var xr = 0; xr < 255; xr++)
  ls.LOG_TABLE[ls.EXP_TABLE[xr]] = xr;
var c$ = ls, ru = c$;
function bS(e, t) {
  if (e.length == null)
    throw new Error(e.length + "/" + t);
  for (var i = 0; i < e.length && e[i] == 0; )
    i++;
  this.num = new Array(e.length - i + t);
  for (var n = 0; n < e.length - i; n++)
    this.num[n] = e[n + i];
}
bS.prototype = {
  get: function(e) {
    return this.num[e];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(e) {
    for (var t = new Array(this.getLength() + e.getLength() - 1), i = 0; i < this.getLength(); i++)
      for (var n = 0; n < e.getLength(); n++)
        t[i + n] ^= ru.gexp(ru.glog(this.get(i)) + ru.glog(e.get(n)));
    return new bS(t, 0);
  },
  mod: function(e) {
    if (this.getLength() - e.getLength() < 0)
      return this;
    for (var t = ru.glog(this.get(0)) - ru.glog(e.get(0)), i = new Array(this.getLength()), n = 0; n < this.getLength(); n++)
      i[n] = this.get(n);
    for (var n = 0; n < e.getLength(); n++)
      i[n] ^= ru.gexp(ru.glog(e.get(n)) + t);
    return new bS(i, 0).mod(e);
  }
};
var d$ = bS, il = I$, eM = d$, dlt = c$, dd = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}, Xr = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1335,
  G18: 7973,
  G15_MASK: 21522,
  getBCHTypeInfo: function(e) {
    for (var t = e << 10; Xr.getBCHDigit(t) - Xr.getBCHDigit(Xr.G15) >= 0; )
      t ^= Xr.G15 << Xr.getBCHDigit(t) - Xr.getBCHDigit(Xr.G15);
    return (e << 10 | t) ^ Xr.G15_MASK;
  },
  getBCHTypeNumber: function(e) {
    for (var t = e << 12; Xr.getBCHDigit(t) - Xr.getBCHDigit(Xr.G18) >= 0; )
      t ^= Xr.G18 << Xr.getBCHDigit(t) - Xr.getBCHDigit(Xr.G18);
    return e << 12 | t;
  },
  getBCHDigit: function(e) {
    for (var t = 0; e != 0; )
      t++, e >>>= 1;
    return t;
  },
  getPatternPosition: function(e) {
    return Xr.PATTERN_POSITION_TABLE[e - 1];
  },
  getMask: function(e, t, i) {
    switch (e) {
      case dd.PATTERN000:
        return (t + i) % 2 == 0;
      case dd.PATTERN001:
        return t % 2 == 0;
      case dd.PATTERN010:
        return i % 3 == 0;
      case dd.PATTERN011:
        return (t + i) % 3 == 0;
      case dd.PATTERN100:
        return (Math.floor(t / 2) + Math.floor(i / 3)) % 2 == 0;
      case dd.PATTERN101:
        return t * i % 2 + t * i % 3 == 0;
      case dd.PATTERN110:
        return (t * i % 2 + t * i % 3) % 2 == 0;
      case dd.PATTERN111:
        return (t * i % 3 + (t + i) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + e);
    }
  },
  getErrorCorrectPolynomial: function(e) {
    for (var t = new eM([1], 0), i = 0; i < e; i++)
      t = t.multiply(new eM([1, dlt.gexp(i)], 0));
    return t;
  },
  getLengthInBits: function(e, t) {
    if (1 <= t && t < 10)
      switch (e) {
        case il.MODE_NUMBER:
          return 10;
        case il.MODE_ALPHA_NUM:
          return 9;
        case il.MODE_8BIT_BYTE:
          return 8;
        case il.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + e);
      }
    else if (t < 27)
      switch (e) {
        case il.MODE_NUMBER:
          return 12;
        case il.MODE_ALPHA_NUM:
          return 11;
        case il.MODE_8BIT_BYTE:
          return 16;
        case il.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + e);
      }
    else if (t < 41)
      switch (e) {
        case il.MODE_NUMBER:
          return 14;
        case il.MODE_ALPHA_NUM:
          return 13;
        case il.MODE_8BIT_BYTE:
          return 16;
        case il.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + e);
      }
    else
      throw new Error("type:" + t);
  },
  getLostPoint: function(e) {
    for (var t = e.getModuleCount(), i = 0, n = 0; n < t; n++)
      for (var g = 0; g < t; g++) {
        for (var r = 0, o = e.isDark(n, g), I = -1; I <= 1; I++)
          if (!(n + I < 0 || t <= n + I))
            for (var s = -1; s <= 1; s++)
              g + s < 0 || t <= g + s || I == 0 && s == 0 || o == e.isDark(n + I, g + s) && r++;
        r > 5 && (i += 3 + r - 5);
      }
    for (var n = 0; n < t - 1; n++)
      for (var g = 0; g < t - 1; g++) {
        var a = 0;
        e.isDark(n, g) && a++, e.isDark(n + 1, g) && a++, e.isDark(n, g + 1) && a++, e.isDark(n + 1, g + 1) && a++, (a == 0 || a == 4) && (i += 3);
      }
    for (var n = 0; n < t; n++)
      for (var g = 0; g < t - 6; g++)
        e.isDark(n, g) && !e.isDark(n, g + 1) && e.isDark(n, g + 2) && e.isDark(n, g + 3) && e.isDark(n, g + 4) && !e.isDark(n, g + 5) && e.isDark(n, g + 6) && (i += 40);
    for (var g = 0; g < t; g++)
      for (var n = 0; n < t - 6; n++)
        e.isDark(n, g) && !e.isDark(n + 1, g) && e.isDark(n + 2, g) && e.isDark(n + 3, g) && e.isDark(n + 4, g) && !e.isDark(n + 5, g) && e.isDark(n + 6, g) && (i += 40);
    for (var d = 0, g = 0; g < t; g++)
      for (var n = 0; n < t; n++)
        e.isDark(n, g) && d++;
    var C = Math.abs(100 * d / t / t - 50) / 5;
    return i += C * 10, i;
  }
}, Clt = Xr, ult = slt, C$ = alt, u$ = clt, IC = Clt, Alt = d$;
function qs(e, t) {
  this.typeNumber = e, this.errorCorrectLevel = t, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
}
var EI = qs.prototype;
EI.addData = function(e) {
  var t = new ult(e);
  this.dataList.push(t), this.dataCache = null;
};
EI.isDark = function(e, t) {
  if (e < 0 || this.moduleCount <= e || t < 0 || this.moduleCount <= t)
    throw new Error(e + "," + t);
  return this.modules[e][t];
};
EI.getModuleCount = function() {
  return this.moduleCount;
};
EI.make = function() {
  if (this.typeNumber < 1) {
    var e = 1;
    for (e = 1; e < 40; e++) {
      for (var t = C$.getRSBlocks(e, this.errorCorrectLevel), i = new u$(), n = 0, g = 0; g < t.length; g++)
        n += t[g].dataCount;
      for (var g = 0; g < this.dataList.length; g++) {
        var r = this.dataList[g];
        i.put(r.mode, 4), i.put(r.getLength(), IC.getLengthInBits(r.mode, e)), r.write(i);
      }
      if (i.getLengthInBits() <= n * 8)
        break;
    }
    this.typeNumber = e;
  }
  this.makeImpl(!1, this.getBestMaskPattern());
};
EI.makeImpl = function(e, t) {
  this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
  for (var i = 0; i < this.moduleCount; i++) {
    this.modules[i] = new Array(this.moduleCount);
    for (var n = 0; n < this.moduleCount; n++)
      this.modules[i][n] = null;
  }
  this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(e, t), this.typeNumber >= 7 && this.setupTypeNumber(e), this.dataCache == null && (this.dataCache = qs.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, t);
};
EI.setupPositionProbePattern = function(e, t) {
  for (var i = -1; i <= 7; i++)
    if (!(e + i <= -1 || this.moduleCount <= e + i))
      for (var n = -1; n <= 7; n++)
        t + n <= -1 || this.moduleCount <= t + n || (0 <= i && i <= 6 && (n == 0 || n == 6) || 0 <= n && n <= 6 && (i == 0 || i == 6) || 2 <= i && i <= 4 && 2 <= n && n <= 4 ? this.modules[e + i][t + n] = !0 : this.modules[e + i][t + n] = !1);
};
EI.getBestMaskPattern = function() {
  for (var e = 0, t = 0, i = 0; i < 8; i++) {
    this.makeImpl(!0, i);
    var n = IC.getLostPoint(this);
    (i == 0 || e > n) && (e = n, t = i);
  }
  return t;
};
EI.createMovieClip = function(e, t, i) {
  var n = e.createEmptyMovieClip(t, i), g = 1;
  this.make();
  for (var r = 0; r < this.modules.length; r++)
    for (var o = r * g, I = 0; I < this.modules[r].length; I++) {
      var s = I * g, a = this.modules[r][I];
      a && (n.beginFill(0, 100), n.moveTo(s, o), n.lineTo(s + g, o), n.lineTo(s + g, o + g), n.lineTo(s, o + g), n.endFill());
    }
  return n;
};
EI.setupTimingPattern = function() {
  for (var e = 8; e < this.moduleCount - 8; e++)
    this.modules[e][6] == null && (this.modules[e][6] = e % 2 == 0);
  for (var t = 8; t < this.moduleCount - 8; t++)
    this.modules[6][t] == null && (this.modules[6][t] = t % 2 == 0);
};
EI.setupPositionAdjustPattern = function() {
  for (var e = IC.getPatternPosition(this.typeNumber), t = 0; t < e.length; t++)
    for (var i = 0; i < e.length; i++) {
      var n = e[t], g = e[i];
      if (this.modules[n][g] == null)
        for (var r = -2; r <= 2; r++)
          for (var o = -2; o <= 2; o++)
            r == -2 || r == 2 || o == -2 || o == 2 || r == 0 && o == 0 ? this.modules[n + r][g + o] = !0 : this.modules[n + r][g + o] = !1;
    }
};
EI.setupTypeNumber = function(e) {
  for (var t = IC.getBCHTypeNumber(this.typeNumber), i = 0; i < 18; i++) {
    var n = !e && (t >> i & 1) == 1;
    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = n;
  }
  for (var i = 0; i < 18; i++) {
    var n = !e && (t >> i & 1) == 1;
    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = n;
  }
};
EI.setupTypeInfo = function(e, t) {
  for (var i = this.errorCorrectLevel << 3 | t, n = IC.getBCHTypeInfo(i), g = 0; g < 15; g++) {
    var r = !e && (n >> g & 1) == 1;
    g < 6 ? this.modules[g][8] = r : g < 8 ? this.modules[g + 1][8] = r : this.modules[this.moduleCount - 15 + g][8] = r;
  }
  for (var g = 0; g < 15; g++) {
    var r = !e && (n >> g & 1) == 1;
    g < 8 ? this.modules[8][this.moduleCount - g - 1] = r : g < 9 ? this.modules[8][15 - g - 1 + 1] = r : this.modules[8][15 - g - 1] = r;
  }
  this.modules[this.moduleCount - 8][8] = !e;
};
EI.mapData = function(e, t) {
  for (var i = -1, n = this.moduleCount - 1, g = 7, r = 0, o = this.moduleCount - 1; o > 0; o -= 2)
    for (o == 6 && o--; ; ) {
      for (var I = 0; I < 2; I++)
        if (this.modules[n][o - I] == null) {
          var s = !1;
          r < e.length && (s = (e[r] >>> g & 1) == 1);
          var a = IC.getMask(t, n, o - I);
          a && (s = !s), this.modules[n][o - I] = s, g--, g == -1 && (r++, g = 7);
        }
      if (n += i, n < 0 || this.moduleCount <= n) {
        n -= i, i = -i;
        break;
      }
    }
};
qs.PAD0 = 236;
qs.PAD1 = 17;
qs.createData = function(e, t, i) {
  for (var n = C$.getRSBlocks(e, t), g = new u$(), r = 0; r < i.length; r++) {
    var o = i[r];
    g.put(o.mode, 4), g.put(o.getLength(), IC.getLengthInBits(o.mode, e)), o.write(g);
  }
  for (var I = 0, r = 0; r < n.length; r++)
    I += n[r].dataCount;
  if (g.getLengthInBits() > I * 8)
    throw new Error("code length overflow. (" + g.getLengthInBits() + ">" + I * 8 + ")");
  for (g.getLengthInBits() + 4 <= I * 8 && g.put(0, 4); g.getLengthInBits() % 8 != 0; )
    g.putBit(!1);
  for (; !(g.getLengthInBits() >= I * 8 || (g.put(qs.PAD0, 8), g.getLengthInBits() >= I * 8)); )
    g.put(qs.PAD1, 8);
  return qs.createBytes(g, n);
};
qs.createBytes = function(e, t) {
  for (var i = 0, n = 0, g = 0, r = new Array(t.length), o = new Array(t.length), I = 0; I < t.length; I++) {
    var s = t[I].dataCount, a = t[I].totalCount - s;
    n = Math.max(n, s), g = Math.max(g, a), r[I] = new Array(s);
    for (var d = 0; d < r[I].length; d++)
      r[I][d] = 255 & e.buffer[d + i];
    i += s;
    var C = IC.getErrorCorrectPolynomial(a), u = new Alt(r[I], C.getLength() - 1), A = u.mod(C);
    o[I] = new Array(C.getLength() - 1);
    for (var d = 0; d < o[I].length; d++) {
      var m = d + A.getLength() - o[I].length;
      o[I][d] = m >= 0 ? A.get(m) : 0;
    }
  }
  for (var h = 0, d = 0; d < t.length; d++)
    h += t[d].totalCount;
  for (var B = new Array(h), f = 0, d = 0; d < n; d++)
    for (var I = 0; I < t.length; I++)
      d < r[I].length && (B[f++] = r[I][d]);
  for (var d = 0; d < g; d++)
    for (var I = 0; I < t.length; I++)
      d < o[I].length && (B[f++] = o[I][d]);
  return B;
};
var blt = qs, CK = {};
Object.defineProperty(CK, "__esModule", {
  value: !0
});
var mlt = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t];
    for (var n in i)
      Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
  }
  return e;
}, hlt = hw, nl = b$(hlt), A$ = Se, XW = b$(A$);
function b$(e) {
  return e && e.__esModule ? e : { default: e };
}
function plt(e, t) {
  var i = {};
  for (var n in e)
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (i[n] = e[n]);
  return i;
}
var Blt = {
  bgColor: nl.default.oneOfType([nl.default.object, nl.default.string]).isRequired,
  bgD: nl.default.string.isRequired,
  fgColor: nl.default.oneOfType([nl.default.object, nl.default.string]).isRequired,
  fgD: nl.default.string.isRequired,
  size: nl.default.number.isRequired,
  title: nl.default.string,
  viewBoxSize: nl.default.number.isRequired,
  xmlns: nl.default.string
}, Zlt = {
  title: void 0,
  xmlns: "http://www.w3.org/2000/svg"
}, c2 = (0, A$.forwardRef)(function(e, t) {
  var i = e.bgColor, n = e.bgD, g = e.fgD, r = e.fgColor, o = e.size, I = e.title, s = e.viewBoxSize, a = plt(e, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize"]);
  return XW.default.createElement(
    "svg",
    mlt({}, a, { height: o, ref: t, viewBox: "0 0 " + s + " " + s, width: o }),
    I ? XW.default.createElement(
      "title",
      null,
      I
    ) : null,
    XW.default.createElement("path", { d: n, fill: i }),
    XW.default.createElement("path", { d: g, fill: r })
  );
});
c2.displayName = "QRCodeSvg";
c2.propTypes = Blt;
c2.defaultProps = Zlt;
CK.default = c2;
Object.defineProperty(a2, "__esModule", {
  value: !0
});
a2.QRCode = void 0;
var flt = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t];
    for (var n in i)
      Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
  }
  return e;
}, Glt = blt, ylt = cf(Glt), Wlt = s$, Slt = cf(Wlt), Vlt = hw, ec = cf(Vlt), m$ = Se, wlt = cf(m$), vlt = CK, Rlt = cf(vlt);
function cf(e) {
  return e && e.__esModule ? e : { default: e };
}
function Xlt(e, t) {
  var i = {};
  for (var n in e)
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (i[n] = e[n]);
  return i;
}
var Hlt = {
  bgColor: ec.default.oneOfType([ec.default.object, ec.default.string]),
  fgColor: ec.default.oneOfType([ec.default.object, ec.default.string]),
  level: ec.default.string,
  size: ec.default.number,
  value: ec.default.string.isRequired
}, klt = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
}, df = (0, m$.forwardRef)(function(e, t) {
  var i = e.bgColor, n = e.fgColor, g = e.level, r = e.size, o = e.value, I = Xlt(e, ["bgColor", "fgColor", "level", "size", "value"]), s = new ylt.default(-1, Slt.default[g]);
  s.addData(o), s.make();
  var a = s.modules;
  return wlt.default.createElement(Rlt.default, flt({}, I, {
    bgColor: i,
    bgD: a.map(function(d, C) {
      return d.map(function(u, A) {
        return u ? "" : "M " + A + " " + C + " l 1 0 0 1 -1 0 Z";
      }).join(" ");
    }).join(" "),
    fgColor: n,
    fgD: a.map(function(d, C) {
      return d.map(function(u, A) {
        return u ? "M " + A + " " + C + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: t,
    size: r,
    viewBoxSize: a.length
  }));
});
a2.QRCode = df;
df.displayName = "QRCode";
df.propTypes = Hlt;
df.defaultProps = klt;
var Flt = a2.default = df;
const h$ = async (e) => await (await fetch(e)).blob(), Ylt = async (e) => {
  const t = zJ(e);
  return Array.isArray(t) ? await Promise.all(t.map(async (i) => ({
    ...i,
    file: await h$(i.file)
  }))) : [];
}, xlt = async (e) => {
  const t = await Promise.all(vg(e).map(async (I) => {
    var s;
    if ((s = I.data) != null && s.url) {
      const a = I.id;
      return {
        selection: {
          ...I,
          data: {
            ...I.data,
            url: a
          }
        },
        uploadFileInformation: {
          key: a,
          file: await h$(I.data.url)
        }
      };
    } else
      return {
        selection: I,
        uploadFileInformation: void 0
      };
  })), i = t.map((I) => I.selection), n = await Ylt(e), g = [];
  Wu.forEach((I, s) => {
    g.push({
      key: s,
      stage: I
    });
  });
  const r = await Promise.all(g.map(async ({
    key: I,
    stage: s
  }) => ({
    key: I,
    file: await s.toBlob({
      mimeType: "image/jpeg",
      quality: 1,
      pixelRatio: 1,
      x: 0,
      y: 0,
      width: s.width(),
      height: s.height()
    })
  }))), o = [...t.map((I) => I.uploadFileInformation).filter(Boolean), ...n, ...r];
  return {
    updatedSelections: i,
    filesAndInformation: o
  };
}, Dlt = async (e) => j_(e).reduce((i, n, g) => ({
  ...i,
  ["camera_" + g]: {
    [n.label]: kJ(n.url)
  }
}), {}), Jlt = async (e, t, i) => {
  const n = Ai(e), g = ng(e), r = Dg(e), o = Jg(e);
  if (!r || !o)
    return console.warn("Rule engine not initialized!"), {};
  if (n) {
    const I = iC(e), {
      updatedSelections: s,
      filesAndInformation: a
    } = await xlt(e), d = _rt(r, s, o), C = (f) => ({
      articleNo: f.article.no,
      articleName: f.article.name,
      priceUnit: f.priceUnit,
      qty: f.qty,
      amount: f.amount || 1,
      // TODO Soll das hier rein?
      priceTotal: f.priceTotal
    }), u = (f) => f.map((G) => ({
      group: G.group.label,
      groupId: G.group.id,
      index: G.index,
      variableLabel: G.variable.label,
      variableId: G.variable.id,
      selectionLabel: G.selectionLabel,
      selectionId: G.selection.id,
      selectionValueId: eI(G.variable) ? null : G.selection.valueId,
      bom: {
        articleLines: G.bom.articleLines.map(C),
        surchargeLines: G.bom.surchargeLines.map(C),
        priceTotal: G.bom.priceTotal
      },
      subVariables: G.subVariables ? u(G.subVariables) : null
    })), A = (f) => f.OC_reduceBy(
      // If article number and amount match
      (G, y) => G.articleId == y.articleId && G.amount == y.amount,
      // Merge Items by updating count/qty
      (G, y) => (G.qty += y.qty, G)
    ), m = E1(e).map((f) => {
      var G;
      return {
        articleId: f.article.id,
        amount: f.amount,
        qty: f.qty,
        main: f.main,
        unit: (G = f.price) == null ? void 0 : G.unit
      };
    }), h = A(m);
    return {
      newConfiguration: {
        state: HY.Ordered,
        // TODO
        thumbnail: null,
        files: await Dlt(e),
        appId: n.id,
        appCode: n.code,
        versionId: n.versionId,
        // TODO
        userId: null,
        price: I,
        inspiration: !1,
        //sort: (maxBy((g) => g.sort, configurations)?.sort || -1) + 1,
        json: {
          variables: d,
          bom: h,
          summary: u(M6(e)),
          touched: o.state.all.touched
        },
        customer: i,
        lang: g,
        label: t
      },
      filesAndInformation: a
    };
  } else
    return {};
}, uK = (e, t, i) => async (n, g) => {
  const r = g(), o = Ai(r), I = dh(r), s = ng(r), {
    newConfiguration: a,
    filesAndInformation: d
  } = await Jlt(r, e, i ?? void 0) || {};
  if (!a) {
    console.error("Could not create new configuration!");
    return;
  }
  return Ym("saved", t.actionKey || t.label[s] || t.id, o, "saved"), await n(_It(a, t, d, I));
}, Klt = ["translation_AR_Title", "translation_AR_Body"], Elt = (e) => {
  const t = un(), [i, n] = At(""), g = zt(), r = oK();
  return et(() => {
    (async () => {
      try {
        await g(uK("Configuration", {
          id: "ar",
          label: {}
        }, {}));
        const I = new window.URL(window.location.href);
        I.searchParams.append("autostartAR", "true"), n(I.toString());
      } catch (I) {
        r(I);
      }
    })();
  }, []), /* @__PURE__ */ ge(j1, { settingKeys: Klt, onClose: e.onClose, show: !0, title: t("translation_AR_Title"), type: "none", children: [
    /* @__PURE__ */ p(Cr, { children: t("translation_AR_Body") }),
    /* @__PURE__ */ p(fe, { component: "div", sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: 3
    }, children: i ? /* @__PURE__ */ p(fe, { component: "div", sx: {
      display: "inline-block",
      border: "10px solid white"
    }, children: /* @__PURE__ */ p(Flt, { value: i.toString() }) }) : /* @__PURE__ */ p(hm, { size: 30 }) })
  ] });
};
var AK = {}, Nlt = Cg;
Object.defineProperty(AK, "__esModule", {
  value: !0
});
var mS = AK.default = void 0, Llt = Nlt(Kg()), Tlt = xg;
mS = AK.default = (0, Llt.default)(/* @__PURE__ */ (0, Tlt.jsx)("path", {
  d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), "Done");
const Mlt = (e, t) => {
  e === "iOS" ? Plt(t) : Ult(t);
}, Ult = (e) => {
  const t = document.createElement("a");
  t.setAttribute("href", e), t.click();
}, Plt = (e) => {
  const t = document.createElement("a");
  t.setAttribute("rel", "ar"), t.appendChild(document.createElement("img")), t.setAttribute("href", e), t.click();
}, p$ = (e) => {
  const t = e;
  return t == null ? void 0 : t.isMesh;
}, B$ = (e) => `${jo.libsUrl}3d/environments/${e}.hdr`, V9t = (e) => {
  const {
    scene: t
  } = e;
  let i = 0, n = 0, g = 0;
  const r = /* @__PURE__ */ new Set();
  for (let o = 0, I = t.children.length; o < I; o++)
    t.children[o].traverseVisible(function(a) {
      if (i++, "isMesh" in a && a.isMesh) {
        const d = a;
        if (d.geometry === void 0)
          return;
        if (!r.has(d.geometry.uuid)) {
          r.add(d.geometry.uuid);
          const C = d.geometry;
          n += C.attributes.position.count, C.index !== null ? g += C.index.count / 3 : g += C.attributes.position.count / 3;
        }
      }
    });
  return {
    objects: i,
    vertices: n,
    triangles: g
  };
}, zlt = parseInt(nge.replace(/\D+/g, ""));
var Olt = Object.defineProperty, Qlt = (e, t, i) => t in e ? Olt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, jlt = (e, t, i) => (Qlt(e, t + "", i), i);
async function tM(e) {
  const t = await e.arrayBuffer(), i = btoa(String.fromCharCode(...new Uint8Array(t)));
  return `data:${e.type || ""};base64,${i}`;
}
let HW, nF, Pb, kW;
function gF(e, t = 1 / 0, i = null) {
  nF || (nF = new Ige(2, 2, 1, 1)), Pb || (Pb = new lge({
    uniforms: { blitTexture: new sge(e) },
    vertexShader: (
      /* glsl */
      `
        varying vec2 vUv;
        void main(){
            vUv = uv;
            gl_Position = vec4(position.xy * 1.0,0.,.999999);
        }
      `
    ),
    fragmentShader: (
      /* glsl */
      `
          uniform sampler2D blitTexture; 
          varying vec2 vUv;

          void main(){ 
              gl_FragColor = vec4(vUv.xy, 0, 1);
              
              #ifdef IS_SRGB
              gl_FragColor = LinearTosRGB( texture2D( blitTexture, vUv) );
              #else
              gl_FragColor = texture2D( blitTexture, vUv);
              #endif
          }
      `
    )
  })), Pb.uniforms.blitTexture.value = e, Pb.defines.IS_SRGB = "colorSpace" in e ? e.colorSpace === "srgb" : e.encoding === 3001, Pb.needsUpdate = !0, kW || (kW = new Tz(nF, Pb), kW.frustrumCulled = !1);
  const n = new Mz(), g = new qF();
  g.add(kW), i || (i = HW = new age({ antialias: !1 })), i.setSize(Math.min(e.image.width, t), Math.min(e.image.height, t)), i.clear(), i.render(g, n);
  const r = new Nz(i.domElement);
  return r.minFilter = e.minFilter, r.magFilter = e.magFilter, r.wrapS = e.wrapS, r.wrapT = e.wrapT, r.name = e.name, HW && (HW.dispose(), HW = null), r;
}
const iM = {
  POSITION: [
    "byte",
    "byte normalized",
    "unsigned byte",
    "unsigned byte normalized",
    "short",
    "short normalized",
    "unsigned short",
    "unsigned short normalized"
  ],
  NORMAL: ["byte normalized", "short normalized"],
  TANGENT: ["byte normalized", "short normalized"],
  TEXCOORD: ["byte", "byte normalized", "unsigned byte", "short", "short normalized", "unsigned short"]
};
class bK {
  constructor() {
    this.pluginCallbacks = [], this.register(function(t) {
      return new ost(t);
    }), this.register(function(t) {
      return new Ist(t);
    }), this.register(function(t) {
      return new ast(t);
    }), this.register(function(t) {
      return new cst(t);
    }), this.register(function(t) {
      return new dst(t);
    }), this.register(function(t) {
      return new Cst(t);
    }), this.register(function(t) {
      return new lst(t);
    }), this.register(function(t) {
      return new sst(t);
    }), this.register(function(t) {
      return new ust(t);
    }), this.register(function(t) {
      return new Ast(t);
    }), this.register(function(t) {
      return new bst(t);
    });
  }
  register(t) {
    return this.pluginCallbacks.indexOf(t) === -1 && this.pluginCallbacks.push(t), this;
  }
  unregister(t) {
    return this.pluginCallbacks.indexOf(t) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t), 1), this;
  }
  /**
   * Parse scenes and generate GLTF output
   * @param  {Scene or [THREE.Scenes]} input   Scene or Array of THREE.Scenes
   * @param  {Function} onDone  Callback on completed
   * @param  {Function} onError  Callback on errors
   * @param  {Object} options options
   */
  parse(t, i, n, g) {
    const r = new rst(), o = [];
    for (let I = 0, s = this.pluginCallbacks.length; I < s; I++)
      o.push(this.pluginCallbacks[I](r));
    r.setPlugins(o), r.write(t, i, g).catch(n);
  }
  parseAsync(t, i) {
    const n = this;
    return new Promise(function(g, r) {
      n.parse(t, g, r, i);
    });
  }
}
jlt(bK, "Utils", {
  insertKeyframe: function(e, t) {
    const n = e.getValueSize(), g = new e.TimeBufferType(e.times.length + 1), r = new e.ValueBufferType(e.values.length + n), o = e.createInterpolant(new e.ValueBufferType(n));
    let I;
    if (e.times.length === 0) {
      g[0] = t;
      for (let s = 0; s < n; s++)
        r[s] = 0;
      I = 0;
    } else if (t < e.times[0]) {
      if (Math.abs(e.times[0] - t) < 1e-3)
        return 0;
      g[0] = t, g.set(e.times, 1), r.set(o.evaluate(t), 0), r.set(e.values, n), I = 0;
    } else if (t > e.times[e.times.length - 1]) {
      if (Math.abs(e.times[e.times.length - 1] - t) < 1e-3)
        return e.times.length - 1;
      g[g.length - 1] = t, g.set(e.times, 0), r.set(e.values, 0), r.set(o.evaluate(t), e.values.length), I = g.length - 1;
    } else
      for (let s = 0; s < e.times.length; s++) {
        if (Math.abs(e.times[s] - t) < 1e-3)
          return s;
        if (e.times[s] < t && e.times[s + 1] > t) {
          g.set(e.times.slice(0, s + 1), 0), g[s + 1] = t, g.set(e.times.slice(s + 1), s + 2), r.set(e.values.slice(0, (s + 1) * n), 0), r.set(o.evaluate(t), (s + 1) * n), r.set(e.values.slice((s + 1) * n), (s + 2) * n), I = s + 1;
          break;
        }
      }
    return e.times = g, e.values = r, I;
  },
  mergeMorphTargetTracks: function(e, t) {
    const i = [], n = {}, g = e.tracks;
    for (let r = 0; r < g.length; ++r) {
      let o = g[r];
      const I = yS.parseTrackName(o.name), s = yS.findNode(t, I.nodeName);
      if (I.propertyName !== "morphTargetInfluences" || I.propertyIndex === void 0) {
        i.push(o);
        continue;
      }
      if (o.createInterpolant !== o.InterpolantFactoryMethodDiscrete && o.createInterpolant !== o.InterpolantFactoryMethodLinear) {
        if (o.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline)
          throw new Error("THREE.GLTFExporter: Cannot merge tracks with glTF CUBICSPLINE interpolation.");
        console.warn("THREE.GLTFExporter: Morph target interpolation mode not yet supported. Using LINEAR instead."), o = o.clone(), o.setInterpolation(cge);
      }
      const a = s.morphTargetInfluences.length, d = s.morphTargetDictionary[I.propertyIndex];
      if (d === void 0)
        throw new Error("THREE.GLTFExporter: Morph target name not found: " + I.propertyIndex);
      let C;
      if (n[s.uuid] === void 0) {
        C = o.clone();
        const A = new C.ValueBufferType(a * C.times.length);
        for (let m = 0; m < C.times.length; m++)
          A[m * a + d] = C.values[m];
        C.name = (I.nodeName || "") + ".morphTargetInfluences", C.values = A, n[s.uuid] = C, i.push(C);
        continue;
      }
      const u = o.createInterpolant(new o.ValueBufferType(1));
      C = n[s.uuid];
      for (let A = 0; A < C.times.length; A++)
        C.values[A * a + d] = u.evaluate(C.times[A]);
      for (let A = 0; A < o.times.length; A++) {
        const m = this.insertKeyframe(C, o.times[A]);
        C.values[m * a + d] = o.values[A];
      }
    }
    return e.tracks = i, e;
  }
});
const Yi = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  INT: 5124,
  UNSIGNED_INT: 5125,
  FLOAT: 5126,
  ARRAY_BUFFER: 34962,
  ELEMENT_ARRAY_BUFFER: 34963,
  NEAREST: 9728,
  LINEAR: 9729,
  NEAREST_MIPMAP_NEAREST: 9984,
  LINEAR_MIPMAP_NEAREST: 9985,
  NEAREST_MIPMAP_LINEAR: 9986,
  LINEAR_MIPMAP_LINEAR: 9987,
  CLAMP_TO_EDGE: 33071,
  MIRRORED_REPEAT: 33648,
  REPEAT: 10497
}, rF = "KHR_mesh_quantization", WI = {};
WI[dge] = Yi.NEAREST;
WI[Cge] = Yi.NEAREST_MIPMAP_NEAREST;
WI[uge] = Yi.NEAREST_MIPMAP_LINEAR;
WI[Age] = Yi.LINEAR;
WI[bge] = Yi.LINEAR_MIPMAP_NEAREST;
WI[mge] = Yi.LINEAR_MIPMAP_LINEAR;
WI[hge] = Yi.CLAMP_TO_EDGE;
WI[pge] = Yi.REPEAT;
WI[Bge] = Yi.MIRRORED_REPEAT;
const nM = {
  scale: "scale",
  position: "translation",
  quaternion: "rotation",
  morphTargetInfluences: "weights"
}, _lt = new Ez(), gM = 12, $lt = 1179937895, qlt = 2, rM = 8, est = 1313821514, tst = 5130562;
function nB(e, t) {
  return e.length === t.length && e.every(function(i, n) {
    return i === t[n];
  });
}
function ist(e) {
  return new TextEncoder().encode(e).buffer;
}
function nst(e) {
  return nB(e.elements, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
}
function gst(e, t, i) {
  const n = {
    min: new Array(e.itemSize).fill(Number.POSITIVE_INFINITY),
    max: new Array(e.itemSize).fill(Number.NEGATIVE_INFINITY)
  };
  for (let g = t; g < t + i; g++)
    for (let r = 0; r < e.itemSize; r++) {
      let o;
      e.itemSize > 4 ? o = e.array[g * e.itemSize + r] : (r === 0 ? o = e.getX(g) : r === 1 ? o = e.getY(g) : r === 2 ? o = e.getZ(g) : r === 3 && (o = e.getW(g)), e.normalized === !0 && (o = GS.normalize(o, e.array))), n.min[r] = Math.min(n.min[r], o), n.max[r] = Math.max(n.max[r], o);
    }
  return n;
}
function Z$(e) {
  return Math.ceil(e / 4) * 4;
}
function oF(e, t = 0) {
  const i = Z$(e.byteLength);
  if (i !== e.byteLength) {
    const n = new Uint8Array(i);
    if (n.set(new Uint8Array(e)), t !== 0)
      for (let g = e.byteLength; g < i; g++)
        n[g] = t;
    return n.buffer;
  }
  return e;
}
function oM() {
  return typeof document > "u" && typeof OffscreenCanvas < "u" ? new OffscreenCanvas(1, 1) : document.createElement("canvas");
}
function IM(e, t) {
  if (e.toBlob !== void 0)
    return new Promise((n) => e.toBlob(n, t));
  let i;
  return t === "image/jpeg" ? i = 0.92 : t === "image/webp" && (i = 0.8), e.convertToBlob({
    type: t,
    quality: i
  });
}
class rst {
  constructor() {
    this.plugins = [], this.options = {}, this.pending = [], this.buffers = [], this.byteOffset = 0, this.buffers = [], this.nodeMap = /* @__PURE__ */ new Map(), this.skins = [], this.extensionsUsed = {}, this.extensionsRequired = {}, this.uids = /* @__PURE__ */ new Map(), this.uid = 0, this.json = {
      asset: {
        version: "2.0",
        generator: "THREE.GLTFExporter"
      }
    }, this.cache = {
      meshes: /* @__PURE__ */ new Map(),
      attributes: /* @__PURE__ */ new Map(),
      attributesNormalized: /* @__PURE__ */ new Map(),
      materials: /* @__PURE__ */ new Map(),
      textures: /* @__PURE__ */ new Map(),
      images: /* @__PURE__ */ new Map()
    };
  }
  setPlugins(t) {
    this.plugins = t;
  }
  /**
   * Parse scenes and generate GLTF output
   * @param  {Scene or [THREE.Scenes]} input   Scene or Array of THREE.Scenes
   * @param  {Function} onDone  Callback on completed
   * @param  {Object} options options
   */
  async write(t, i, n = {}) {
    this.options = Object.assign(
      {
        // default options
        binary: !1,
        trs: !1,
        onlyVisible: !0,
        maxTextureSize: 1 / 0,
        animations: [],
        includeCustomExtensions: !1
      },
      n
    ), this.options.animations.length > 0 && (this.options.trs = !0), this.processInput(t), await Promise.all(this.pending);
    const g = this, r = g.buffers, o = g.json;
    n = g.options;
    const I = g.extensionsUsed, s = g.extensionsRequired, a = new Blob(r, { type: "application/octet-stream" }), d = Object.keys(I), C = Object.keys(s);
    d.length > 0 && (o.extensionsUsed = d), C.length > 0 && (o.extensionsRequired = C), o.buffers && o.buffers.length > 0 && (o.buffers[0].byteLength = a.size), n.binary === !0 ? a.arrayBuffer().then((u) => {
      const A = oF(u), m = new DataView(new ArrayBuffer(rM));
      m.setUint32(0, A.byteLength, !0), m.setUint32(4, tst, !0);
      const h = oF(ist(JSON.stringify(o)), 32), B = new DataView(new ArrayBuffer(rM));
      B.setUint32(0, h.byteLength, !0), B.setUint32(4, est, !0);
      const f = new ArrayBuffer(gM), G = new DataView(f);
      G.setUint32(0, $lt, !0), G.setUint32(4, qlt, !0);
      const y = gM + B.byteLength + h.byteLength + m.byteLength + A.byteLength;
      G.setUint32(8, y, !0), new Blob([f, B, h, m, A], {
        type: "application/octet-stream"
      }).arrayBuffer().then(i);
    }) : o.buffers && o.buffers.length > 0 ? tM(a).then((u) => {
      o.buffers[0].uri = u, i(o);
    }) : i(o);
  }
  /**
   * Serializes a userData.
   *
   * @param {THREE.Object3D|THREE.Material} object
   * @param {Object} objectDef
   */
  serializeUserData(t, i) {
    if (Object.keys(t.userData).length === 0)
      return;
    const n = this.options, g = this.extensionsUsed;
    try {
      const r = JSON.parse(JSON.stringify(t.userData));
      if (n.includeCustomExtensions && r.gltfExtensions) {
        i.extensions === void 0 && (i.extensions = {});
        for (const o in r.gltfExtensions)
          i.extensions[o] = r.gltfExtensions[o], g[o] = !0;
        delete r.gltfExtensions;
      }
      Object.keys(r).length > 0 && (i.extras = r);
    } catch (r) {
      console.warn(
        "THREE.GLTFExporter: userData of '" + t.name + "' won't be serialized because of JSON.stringify error - " + r.message
      );
    }
  }
  /**
   * Returns ids for buffer attributes.
   * @param  {Object} object
   * @return {Integer}
   */
  getUID(t, i = !1) {
    if (this.uids.has(t) === !1) {
      const g = /* @__PURE__ */ new Map();
      g.set(!0, this.uid++), g.set(!1, this.uid++), this.uids.set(t, g);
    }
    return this.uids.get(t).get(i);
  }
  /**
   * Checks if normal attribute values are normalized.
   *
   * @param {BufferAttribute} normal
   * @returns {Boolean}
   */
  isNormalizedNormalAttribute(t) {
    if (this.cache.attributesNormalized.has(t))
      return !1;
    const n = new xt();
    for (let g = 0, r = t.count; g < r; g++)
      if (Math.abs(n.fromBufferAttribute(t, g).length() - 1) > 5e-4)
        return !1;
    return !0;
  }
  /**
   * Creates normalized normal buffer attribute.
   *
   * @param {BufferAttribute} normal
   * @returns {BufferAttribute}
   *
   */
  createNormalizedNormalAttribute(t) {
    const i = this.cache;
    if (i.attributesNormalized.has(t))
      return i.attributesNormalized.get(t);
    const n = t.clone(), g = new xt();
    for (let r = 0, o = n.count; r < o; r++)
      g.fromBufferAttribute(n, r), g.x === 0 && g.y === 0 && g.z === 0 ? g.setX(1) : g.normalize(), n.setXYZ(r, g.x, g.y, g.z);
    return i.attributesNormalized.set(t, n), n;
  }
  /**
   * Applies a texture transform, if present, to the map definition. Requires
   * the KHR_texture_transform extension.
   *
   * @param {Object} mapDef
   * @param {THREE.Texture} texture
   */
  applyTextureTransform(t, i) {
    let n = !1;
    const g = {};
    (i.offset.x !== 0 || i.offset.y !== 0) && (g.offset = i.offset.toArray(), n = !0), i.rotation !== 0 && (g.rotation = i.rotation, n = !0), (i.repeat.x !== 1 || i.repeat.y !== 1) && (g.scale = i.repeat.toArray(), n = !0), n && (t.extensions = t.extensions || {}, t.extensions.KHR_texture_transform = g, this.extensionsUsed.KHR_texture_transform = !0);
  }
  buildMetalRoughTexture(t, i) {
    if (t === i)
      return t;
    function n(A) {
      return ("colorSpace" in A ? A.colorSpace === "srgb" : A.encoding === 3001) ? function(h) {
        return h < 0.04045 ? h * 0.0773993808 : Math.pow(h * 0.9478672986 + 0.0521327014, 2.4);
      } : function(h) {
        return h;
      };
    }
    console.warn("THREE.GLTFExporter: Merged metalnessMap and roughnessMap textures."), t instanceof $H && (t = gF(t)), i instanceof $H && (i = gF(i));
    const g = t ? t.image : null, r = i ? i.image : null, o = Math.max(g ? g.width : 0, r ? r.width : 0), I = Math.max(g ? g.height : 0, r ? r.height : 0), s = oM();
    s.width = o, s.height = I;
    const a = s.getContext("2d");
    a.fillStyle = "#00ffff", a.fillRect(0, 0, o, I);
    const d = a.getImageData(0, 0, o, I);
    if (g) {
      a.drawImage(g, 0, 0, o, I);
      const A = n(t), m = a.getImageData(0, 0, o, I).data;
      for (let h = 2; h < m.length; h += 4)
        d.data[h] = A(m[h] / 256) * 256;
    }
    if (r) {
      a.drawImage(r, 0, 0, o, I);
      const A = n(i), m = a.getImageData(0, 0, o, I).data;
      for (let h = 1; h < m.length; h += 4)
        d.data[h] = A(m[h] / 256) * 256;
    }
    a.putImageData(d, 0, 0);
    const u = (t || i).clone();
    return u.source = new Nz(s).source, "colorSpace" in u ? u.colorSpace = "" : u.encoding = 3e3, u.channel = (t || i).channel, t && i && t.channel !== i.channel && console.warn("THREE.GLTFExporter: UV channels for metalnessMap and roughnessMap textures must match."), u;
  }
  /**
   * Process a buffer to append to the default one.
   * @param  {ArrayBuffer} buffer
   * @return {Integer}
   */
  processBuffer(t) {
    const i = this.json, n = this.buffers;
    return i.buffers || (i.buffers = [{ byteLength: 0 }]), n.push(t), 0;
  }
  /**
   * Process and generate a BufferView
   * @param  {BufferAttribute} attribute
   * @param  {number} componentType
   * @param  {number} start
   * @param  {number} count
   * @param  {number} target (Optional) Target usage of the BufferView
   * @return {Object}
   */
  processBufferView(t, i, n, g, r) {
    const o = this.json;
    o.bufferViews || (o.bufferViews = []);
    let I;
    switch (i) {
      case Yi.BYTE:
      case Yi.UNSIGNED_BYTE:
        I = 1;
        break;
      case Yi.SHORT:
      case Yi.UNSIGNED_SHORT:
        I = 2;
        break;
      default:
        I = 4;
    }
    const s = Z$(g * t.itemSize * I), a = new DataView(new ArrayBuffer(s));
    let d = 0;
    for (let A = n; A < n + g; A++)
      for (let m = 0; m < t.itemSize; m++) {
        let h;
        t.itemSize > 4 ? h = t.array[A * t.itemSize + m] : (m === 0 ? h = t.getX(A) : m === 1 ? h = t.getY(A) : m === 2 ? h = t.getZ(A) : m === 3 && (h = t.getW(A)), t.normalized === !0 && (h = GS.normalize(h, t.array))), i === Yi.FLOAT ? a.setFloat32(d, h, !0) : i === Yi.INT ? a.setInt32(d, h, !0) : i === Yi.UNSIGNED_INT ? a.setUint32(d, h, !0) : i === Yi.SHORT ? a.setInt16(d, h, !0) : i === Yi.UNSIGNED_SHORT ? a.setUint16(d, h, !0) : i === Yi.BYTE ? a.setInt8(d, h) : i === Yi.UNSIGNED_BYTE && a.setUint8(d, h), d += I;
      }
    const C = {
      buffer: this.processBuffer(a.buffer),
      byteOffset: this.byteOffset,
      byteLength: s
    };
    return r !== void 0 && (C.target = r), r === Yi.ARRAY_BUFFER && (C.byteStride = t.itemSize * I), this.byteOffset += s, o.bufferViews.push(C), {
      id: o.bufferViews.length - 1,
      byteLength: 0
    };
  }
  /**
   * Process and generate a BufferView from an image Blob.
   * @param {Blob} blob
   * @return {Promise<Integer>}
   */
  processBufferViewImage(t) {
    const i = this, n = i.json;
    return n.bufferViews || (n.bufferViews = []), t.arrayBuffer().then((g) => {
      const r = oF(g), o = {
        buffer: i.processBuffer(r),
        byteOffset: i.byteOffset,
        byteLength: r.byteLength
      };
      return i.byteOffset += r.byteLength, n.bufferViews.push(o) - 1;
    });
  }
  /**
   * Process attribute to generate an accessor
   * @param  {BufferAttribute} attribute Attribute to process
   * @param  {THREE.BufferGeometry} geometry (Optional) Geometry used for truncated draw range
   * @param  {Integer} start (Optional)
   * @param  {Integer} count (Optional)
   * @return {Integer|null} Index of the processed accessor on the "accessors" array
   */
  processAccessor(t, i, n, g) {
    const r = this.json, o = {
      1: "SCALAR",
      2: "VEC2",
      3: "VEC3",
      4: "VEC4",
      9: "MAT3",
      16: "MAT4"
    };
    let I;
    if (t.array.constructor === Float32Array)
      I = Yi.FLOAT;
    else if (t.array.constructor === Int32Array)
      I = Yi.INT;
    else if (t.array.constructor === Uint32Array)
      I = Yi.UNSIGNED_INT;
    else if (t.array.constructor === Int16Array)
      I = Yi.SHORT;
    else if (t.array.constructor === Uint16Array)
      I = Yi.UNSIGNED_SHORT;
    else if (t.array.constructor === Int8Array)
      I = Yi.BYTE;
    else if (t.array.constructor === Uint8Array)
      I = Yi.UNSIGNED_BYTE;
    else
      throw new Error(
        "THREE.GLTFExporter: Unsupported bufferAttribute component type: " + t.array.constructor.name
      );
    if (n === void 0 && (n = 0), g === void 0 && (g = t.count), g === 0)
      return null;
    const s = gst(t, n, g);
    let a;
    i !== void 0 && (a = t === i.index ? Yi.ELEMENT_ARRAY_BUFFER : Yi.ARRAY_BUFFER);
    const d = this.processBufferView(t, I, n, g, a), C = {
      bufferView: d.id,
      byteOffset: d.byteOffset,
      componentType: I,
      count: g,
      max: s.max,
      min: s.min,
      type: o[t.itemSize]
    };
    return t.normalized === !0 && (C.normalized = !0), r.accessors || (r.accessors = []), r.accessors.push(C) - 1;
  }
  /**
   * Process image
   * @param  {Image} image to process
   * @param  {Integer} format of the image (RGBAFormat)
   * @param  {Boolean} flipY before writing out the image
   * @param  {String} mimeType export format
   * @return {Integer}     Index of the processed texture in the "images" array
   */
  processImage(t, i, n, g = "image/png") {
    if (t !== null) {
      const r = this, o = r.cache, I = r.json, s = r.options, a = r.pending;
      o.images.has(t) || o.images.set(t, {});
      const d = o.images.get(t), C = g + ":flipY/" + n.toString();
      if (d[C] !== void 0)
        return d[C];
      I.images || (I.images = []);
      const u = { mimeType: g }, A = oM();
      A.width = Math.min(t.width, s.maxTextureSize), A.height = Math.min(t.height, s.maxTextureSize);
      const m = A.getContext("2d");
      if (n === !0 && (m.translate(0, A.height), m.scale(1, -1)), t.data !== void 0) {
        i !== gge && console.error("GLTFExporter: Only RGBAFormat is supported.", i), (t.width > s.maxTextureSize || t.height > s.maxTextureSize) && console.warn("GLTFExporter: Image size is bigger than maxTextureSize", t);
        const B = new Uint8ClampedArray(t.height * t.width * 4);
        for (let f = 0; f < B.length; f += 4)
          B[f + 0] = t.data[f + 0], B[f + 1] = t.data[f + 1], B[f + 2] = t.data[f + 2], B[f + 3] = t.data[f + 3];
        m.putImageData(new ImageData(B, t.width, t.height), 0, 0);
      } else
        m.drawImage(t, 0, 0, A.width, A.height);
      s.binary === !0 ? a.push(
        IM(A, g).then((B) => r.processBufferViewImage(B)).then((B) => {
          u.bufferView = B;
        })
      ) : A.toDataURL !== void 0 ? u.uri = A.toDataURL(g) : a.push(
        IM(A, g).then(tM).then((B) => {
          u.uri = B;
        })
      );
      const h = I.images.push(u) - 1;
      return d[C] = h, h;
    } else
      throw new Error("THREE.GLTFExporter: No valid image data found. Unable to process texture.");
  }
  /**
   * Process sampler
   * @param  {Texture} map Texture to process
   * @return {Integer}     Index of the processed texture in the "samplers" array
   */
  processSampler(t) {
    const i = this.json;
    i.samplers || (i.samplers = []);
    const n = {
      magFilter: WI[t.magFilter],
      minFilter: WI[t.minFilter],
      wrapS: WI[t.wrapS],
      wrapT: WI[t.wrapT]
    };
    return i.samplers.push(n) - 1;
  }
  /**
   * Process texture
   * @param  {Texture} map Map to process
   * @return {Integer} Index of the processed texture in the "textures" array
   */
  processTexture(t) {
    const n = this.options, g = this.cache, r = this.json;
    if (g.textures.has(t))
      return g.textures.get(t);
    r.textures || (r.textures = []), t instanceof $H && (t = gF(t, n.maxTextureSize));
    let o = t.userData.mimeType;
    o === "image/webp" && (o = "image/png");
    const I = {
      sampler: this.processSampler(t),
      source: this.processImage(t.image, t.format, t.flipY, o)
    };
    t.name && (I.name = t.name), this._invokeAll(function(a) {
      a.writeTexture && a.writeTexture(t, I);
    });
    const s = r.textures.push(I) - 1;
    return g.textures.set(t, s), s;
  }
  /**
   * Process material
   * @param  {THREE.Material} material Material to process
   * @return {Integer|null} Index of the processed material in the "materials" array
   */
  processMaterial(t) {
    const i = this.cache, n = this.json;
    if (i.materials.has(t))
      return i.materials.get(t);
    if (t.isShaderMaterial)
      return console.warn("GLTFExporter: THREE.ShaderMaterial not supported."), null;
    n.materials || (n.materials = []);
    const g = { pbrMetallicRoughness: {} };
    t.isMeshStandardMaterial !== !0 && t.isMeshBasicMaterial !== !0 && console.warn("GLTFExporter: Use MeshStandardMaterial or MeshBasicMaterial for best results.");
    const r = t.color.toArray().concat([t.opacity]);
    if (nB(r, [1, 1, 1, 1]) || (g.pbrMetallicRoughness.baseColorFactor = r), t.isMeshStandardMaterial ? (g.pbrMetallicRoughness.metallicFactor = t.metalness, g.pbrMetallicRoughness.roughnessFactor = t.roughness) : (g.pbrMetallicRoughness.metallicFactor = 0.5, g.pbrMetallicRoughness.roughnessFactor = 0.5), t.metalnessMap || t.roughnessMap) {
      const I = this.buildMetalRoughTexture(t.metalnessMap, t.roughnessMap), s = {
        index: this.processTexture(I),
        channel: I.channel
      };
      this.applyTextureTransform(s, I), g.pbrMetallicRoughness.metallicRoughnessTexture = s;
    }
    if (t.map) {
      const I = {
        index: this.processTexture(t.map),
        texCoord: t.map.channel
      };
      this.applyTextureTransform(I, t.map), g.pbrMetallicRoughness.baseColorTexture = I;
    }
    if (t.emissive) {
      const I = t.emissive;
      if (Math.max(I.r, I.g, I.b) > 0 && (g.emissiveFactor = t.emissive.toArray()), t.emissiveMap) {
        const a = {
          index: this.processTexture(t.emissiveMap),
          texCoord: t.emissiveMap.channel
        };
        this.applyTextureTransform(a, t.emissiveMap), g.emissiveTexture = a;
      }
    }
    if (t.normalMap) {
      const I = {
        index: this.processTexture(t.normalMap),
        texCoord: t.normalMap.channel
      };
      t.normalScale && t.normalScale.x !== 1 && (I.scale = t.normalScale.x), this.applyTextureTransform(I, t.normalMap), g.normalTexture = I;
    }
    if (t.aoMap) {
      const I = {
        index: this.processTexture(t.aoMap),
        texCoord: t.aoMap.channel
      };
      t.aoMapIntensity !== 1 && (I.strength = t.aoMapIntensity), this.applyTextureTransform(I, t.aoMap), g.occlusionTexture = I;
    }
    t.transparent ? g.alphaMode = "BLEND" : t.alphaTest > 0 && (g.alphaMode = "MASK", g.alphaCutoff = t.alphaTest), t.side === rge && (g.doubleSided = !0), t.name !== "" && (g.name = t.name), this.serializeUserData(t, g), this._invokeAll(function(I) {
      I.writeMaterial && I.writeMaterial(t, g);
    });
    const o = n.materials.push(g) - 1;
    return i.materials.set(t, o), o;
  }
  /**
   * Process mesh
   * @param  {THREE.Mesh} mesh Mesh to process
   * @return {Integer|null} Index of the processed mesh in the "meshes" array
   */
  processMesh(t) {
    const i = this.cache, n = this.json, g = [t.geometry.uuid];
    if (Array.isArray(t.material))
      for (let y = 0, W = t.material.length; y < W; y++)
        g.push(t.material[y].uuid);
    else
      g.push(t.material.uuid);
    const r = g.join(":");
    if (i.meshes.has(r))
      return i.meshes.get(r);
    const o = t.geometry;
    let I;
    t.isLineSegments ? I = Yi.LINES : t.isLineLoop ? I = Yi.LINE_LOOP : t.isLine ? I = Yi.LINE_STRIP : t.isPoints ? I = Yi.POINTS : I = t.material.wireframe ? Yi.LINES : Yi.TRIANGLES;
    const s = {}, a = {}, d = [], C = [], u = {
      ...zlt >= 152 ? {
        uv: "TEXCOORD_0",
        uv1: "TEXCOORD_1",
        uv2: "TEXCOORD_2",
        uv3: "TEXCOORD_3"
      } : {
        uv: "TEXCOORD_0",
        uv2: "TEXCOORD_1"
      },
      color: "COLOR_0",
      skinWeight: "WEIGHTS_0",
      skinIndex: "JOINTS_0"
    }, A = o.getAttribute("normal");
    A !== void 0 && !this.isNormalizedNormalAttribute(A) && (console.warn("THREE.GLTFExporter: Creating normalized normal attribute from the non-normalized one."), o.setAttribute("normal", this.createNormalizedNormalAttribute(A)));
    let m = null;
    for (let y in o.attributes) {
      if (y.slice(0, 5) === "morph")
        continue;
      const W = o.attributes[y];
      if (y = u[y] || y.toUpperCase(), /^(POSITION|NORMAL|TANGENT|TEXCOORD_\d+|COLOR_\d+|JOINTS_\d+|WEIGHTS_\d+)$/.test(y) || (y = "_" + y), i.attributes.has(this.getUID(W))) {
        a[y] = i.attributes.get(this.getUID(W));
        continue;
      }
      m = null;
      const w = W.array;
      y === "JOINTS_0" && !(w instanceof Uint16Array) && !(w instanceof Uint8Array) && (console.warn('GLTFExporter: Attribute "skinIndex" converted to type UNSIGNED_SHORT.'), m = new Jy(new Uint16Array(w), W.itemSize, W.normalized));
      const v = this.processAccessor(m || W, o);
      v !== null && (y.startsWith("_") || this.detectMeshQuantization(y, W), a[y] = v, i.attributes.set(this.getUID(W), v));
    }
    if (A !== void 0 && o.setAttribute("normal", A), Object.keys(a).length === 0)
      return null;
    if (t.morphTargetInfluences !== void 0 && t.morphTargetInfluences.length > 0) {
      const y = [], W = [], V = {};
      if (t.morphTargetDictionary !== void 0)
        for (const w in t.morphTargetDictionary)
          V[t.morphTargetDictionary[w]] = w;
      for (let w = 0; w < t.morphTargetInfluences.length; ++w) {
        const v = {};
        let H = !1;
        for (const x in o.morphAttributes) {
          if (x !== "position" && x !== "normal") {
            H || (console.warn("GLTFExporter: Only POSITION and NORMAL morph are supported."), H = !0);
            continue;
          }
          const N = o.morphAttributes[x][w], M = x.toUpperCase(), $ = o.attributes[x];
          if (i.attributes.has(this.getUID(N, !0))) {
            v[M] = i.attributes.get(this.getUID(N, !0));
            continue;
          }
          const q = N.clone();
          if (!o.morphTargetsRelative)
            for (let E = 0, L = N.count; E < L; E++)
              for (let P = 0; P < N.itemSize; P++)
                P === 0 && q.setX(E, N.getX(E) - $.getX(E)), P === 1 && q.setY(E, N.getY(E) - $.getY(E)), P === 2 && q.setZ(E, N.getZ(E) - $.getZ(E)), P === 3 && q.setW(E, N.getW(E) - $.getW(E));
          v[M] = this.processAccessor(q, o), i.attributes.set(this.getUID($, !0), v[M]);
        }
        C.push(v), y.push(t.morphTargetInfluences[w]), t.morphTargetDictionary !== void 0 && W.push(V[w]);
      }
      s.weights = y, W.length > 0 && (s.extras = {}, s.extras.targetNames = W);
    }
    const h = Array.isArray(t.material);
    if (h && o.groups.length === 0)
      return null;
    const B = h ? t.material : [t.material], f = h ? o.groups : [{ materialIndex: 0, start: void 0, count: void 0 }];
    for (let y = 0, W = f.length; y < W; y++) {
      const V = {
        mode: I,
        attributes: a
      };
      if (this.serializeUserData(o, V), C.length > 0 && (V.targets = C), o.index !== null) {
        let v = this.getUID(o.index);
        (f[y].start !== void 0 || f[y].count !== void 0) && (v += ":" + f[y].start + ":" + f[y].count), i.attributes.has(v) ? V.indices = i.attributes.get(v) : (V.indices = this.processAccessor(o.index, o, f[y].start, f[y].count), i.attributes.set(v, V.indices)), V.indices === null && delete V.indices;
      }
      const w = this.processMaterial(B[f[y].materialIndex]);
      w !== null && (V.material = w), d.push(V);
    }
    s.primitives = d, n.meshes || (n.meshes = []), this._invokeAll(function(y) {
      y.writeMesh && y.writeMesh(t, s);
    });
    const G = n.meshes.push(s) - 1;
    return i.meshes.set(r, G), G;
  }
  /**
   * If a vertex attribute with a
   * [non-standard data type](https://registry.khronos.org/glTF/specs/2.0/glTF-2.0.html#meshes-overview)
   * is used, it is checked whether it is a valid data type according to the
   * [KHR_mesh_quantization](https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_mesh_quantization/README.md)
   * extension.
   * In this case the extension is automatically added to the list of used extensions.
   *
   * @param {string} attributeName
   * @param {THREE.BufferAttribute} attribute
   */
  detectMeshQuantization(t, i) {
    if (this.extensionsUsed[rF])
      return;
    let n;
    switch (i.array.constructor) {
      case Int8Array:
        n = "byte";
        break;
      case Uint8Array:
        n = "unsigned byte";
        break;
      case Int16Array:
        n = "short";
        break;
      case Uint16Array:
        n = "unsigned short";
        break;
      default:
        return;
    }
    i.normalized && (n += " normalized");
    const g = t.split("_", 1)[0];
    iM[g] && iM[g].includes(n) && (this.extensionsUsed[rF] = !0, this.extensionsRequired[rF] = !0);
  }
  /**
   * Process camera
   * @param  {THREE.Camera} camera Camera to process
   * @return {Integer}      Index of the processed mesh in the "camera" array
   */
  processCamera(t) {
    const i = this.json;
    i.cameras || (i.cameras = []);
    const n = t.isOrthographicCamera, g = {
      type: n ? "orthographic" : "perspective"
    };
    return n ? g.orthographic = {
      xmag: t.right * 2,
      ymag: t.top * 2,
      zfar: t.far <= 0 ? 1e-3 : t.far,
      znear: t.near < 0 ? 0 : t.near
    } : g.perspective = {
      aspectRatio: t.aspect,
      yfov: GS.degToRad(t.fov),
      zfar: t.far <= 0 ? 1e-3 : t.far,
      znear: t.near < 0 ? 0 : t.near
    }, t.name !== "" && (g.name = t.type), i.cameras.push(g) - 1;
  }
  /**
   * Creates glTF animation entry from AnimationClip object.
   *
   * Status:
   * - Only properties listed in PATH_PROPERTIES may be animated.
   *
   * @param {THREE.AnimationClip} clip
   * @param {THREE.Object3D} root
   * @return {number|null}
   */
  processAnimation(t, i) {
    const n = this.json, g = this.nodeMap;
    n.animations || (n.animations = []), t = bK.Utils.mergeMorphTargetTracks(t.clone(), i);
    const r = t.tracks, o = [], I = [];
    for (let s = 0; s < r.length; ++s) {
      const a = r[s], d = yS.parseTrackName(a.name);
      let C = yS.findNode(i, d.nodeName);
      const u = nM[d.propertyName];
      if (d.objectName === "bones" && (C.isSkinnedMesh === !0 ? C = C.skeleton.getBoneByName(d.objectIndex) : C = void 0), !C || !u)
        return console.warn('THREE.GLTFExporter: Could not export animation track "%s".', a.name), null;
      const A = 1;
      let m = a.values.length / a.times.length;
      u === nM.morphTargetInfluences && (m /= C.morphTargetInfluences.length);
      let h;
      a.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline === !0 ? (h = "CUBICSPLINE", m /= 3) : a.getInterpolation() === oge ? h = "STEP" : h = "LINEAR", I.push({
        input: this.processAccessor(new Jy(a.times, A)),
        output: this.processAccessor(new Jy(a.values, m)),
        interpolation: h
      }), o.push({
        sampler: I.length - 1,
        target: {
          node: g.get(C),
          path: u
        }
      });
    }
    return n.animations.push({
      name: t.name || "clip_" + n.animations.length,
      samplers: I,
      channels: o
    }), n.animations.length - 1;
  }
  /**
   * @param {THREE.Object3D} object
   * @return {number|null}
   */
  processSkin(t) {
    const i = this.json, n = this.nodeMap, g = i.nodes[n.get(t)], r = t.skeleton;
    if (r === void 0)
      return null;
    const o = t.skeleton.bones[0];
    if (o === void 0)
      return null;
    const I = [], s = new Float32Array(r.bones.length * 16), a = new Lz();
    for (let C = 0; C < r.bones.length; ++C)
      I.push(n.get(r.bones[C])), a.copy(r.boneInverses[C]), a.multiply(t.bindMatrix).toArray(s, C * 16);
    return i.skins === void 0 && (i.skins = []), i.skins.push({
      inverseBindMatrices: this.processAccessor(new Jy(s, 16)),
      joints: I,
      skeleton: n.get(o)
    }), g.skin = i.skins.length - 1;
  }
  /**
   * Process Object3D node
   * @param  {THREE.Object3D} node Object3D to processNode
   * @return {Integer} Index of the node in the nodes list
   */
  processNode(t) {
    const i = this.json, n = this.options, g = this.nodeMap;
    i.nodes || (i.nodes = []);
    const r = {};
    if (n.trs) {
      const I = t.quaternion.toArray(), s = t.position.toArray(), a = t.scale.toArray();
      nB(I, [0, 0, 0, 1]) || (r.rotation = I), nB(s, [0, 0, 0]) || (r.translation = s), nB(a, [1, 1, 1]) || (r.scale = a);
    } else
      t.matrixAutoUpdate && t.updateMatrix(), nst(t.matrix) === !1 && (r.matrix = t.matrix.elements);
    if (t.name !== "" && (r.name = String(t.name)), this.serializeUserData(t, r), t.isMesh || t.isLine || t.isPoints) {
      const I = this.processMesh(t);
      I !== null && (r.mesh = I);
    } else
      t.isCamera && (r.camera = this.processCamera(t));
    if (t.isSkinnedMesh && this.skins.push(t), t.children.length > 0) {
      const I = [];
      for (let s = 0, a = t.children.length; s < a; s++) {
        const d = t.children[s];
        if (d.visible || n.onlyVisible === !1) {
          const C = this.processNode(d);
          C !== null && I.push(C);
        }
      }
      I.length > 0 && (r.children = I);
    }
    this._invokeAll(function(I) {
      I.writeNode && I.writeNode(t, r);
    });
    const o = i.nodes.push(r) - 1;
    return g.set(t, o), o;
  }
  /**
   * Process Scene
   * @param  {Scene} node Scene to process
   */
  processScene(t) {
    const i = this.json, n = this.options;
    i.scenes || (i.scenes = [], i.scene = 0);
    const g = {};
    t.name !== "" && (g.name = t.name), i.scenes.push(g);
    const r = [];
    for (let o = 0, I = t.children.length; o < I; o++) {
      const s = t.children[o];
      if (s.visible || n.onlyVisible === !1) {
        const a = this.processNode(s);
        a !== null && r.push(a);
      }
    }
    r.length > 0 && (g.nodes = r), this.serializeUserData(t, g);
  }
  /**
   * Creates a Scene to hold a list of objects and parse it
   * @param  {Array} objects List of objects to process
   */
  processObjects(t) {
    const i = new qF();
    i.name = "AuxScene";
    for (let n = 0; n < t.length; n++)
      i.children.push(t[n]);
    this.processScene(i);
  }
  /**
   * @param {THREE.Object3D|Array<THREE.Object3D>} input
   */
  processInput(t) {
    const i = this.options;
    t = t instanceof Array ? t : [t], this._invokeAll(function(g) {
      g.beforeParse && g.beforeParse(t);
    });
    const n = [];
    for (let g = 0; g < t.length; g++)
      t[g] instanceof qF ? this.processScene(t[g]) : n.push(t[g]);
    n.length > 0 && this.processObjects(n);
    for (let g = 0; g < this.skins.length; ++g)
      this.processSkin(this.skins[g]);
    for (let g = 0; g < i.animations.length; ++g)
      this.processAnimation(i.animations[g], t[0]);
    this._invokeAll(function(g) {
      g.afterParse && g.afterParse(t);
    });
  }
  _invokeAll(t) {
    for (let i = 0, n = this.plugins.length; i < n; i++)
      t(this.plugins[i]);
  }
}
class ost {
  constructor(t) {
    this.writer = t, this.name = "KHR_lights_punctual";
  }
  writeNode(t, i) {
    if (!t.isLight)
      return;
    if (!t.isDirectionalLight && !t.isPointLight && !t.isSpotLight) {
      console.warn("THREE.GLTFExporter: Only directional, point, and spot lights are supported.", t);
      return;
    }
    const n = this.writer, g = n.json, r = n.extensionsUsed, o = {};
    t.name && (o.name = t.name), o.color = t.color.toArray(), o.intensity = t.intensity, t.isDirectionalLight ? o.type = "directional" : t.isPointLight ? (o.type = "point", t.distance > 0 && (o.range = t.distance)) : t.isSpotLight && (o.type = "spot", t.distance > 0 && (o.range = t.distance), o.spot = {}, o.spot.innerConeAngle = (t.penumbra - 1) * t.angle * -1, o.spot.outerConeAngle = t.angle), t.decay !== void 0 && t.decay !== 2 && console.warn(
      "THREE.GLTFExporter: Light decay may be lost. glTF is physically-based, and expects light.decay=2."
    ), t.target && (t.target.parent !== t || t.target.position.x !== 0 || t.target.position.y !== 0 || t.target.position.z !== -1) && console.warn(
      "THREE.GLTFExporter: Light direction may be lost. For best results, make light.target a child of the light with position 0,0,-1."
    ), r[this.name] || (g.extensions = g.extensions || {}, g.extensions[this.name] = { lights: [] }, r[this.name] = !0);
    const I = g.extensions[this.name].lights;
    I.push(o), i.extensions = i.extensions || {}, i.extensions[this.name] = { light: I.length - 1 };
  }
}
class Ist {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_unlit";
  }
  writeMaterial(t, i) {
    if (!t.isMeshBasicMaterial)
      return;
    const g = this.writer.extensionsUsed;
    i.extensions = i.extensions || {}, i.extensions[this.name] = {}, g[this.name] = !0, i.pbrMetallicRoughness.metallicFactor = 0, i.pbrMetallicRoughness.roughnessFactor = 0.9;
  }
}
class lst {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_clearcoat";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.clearcoat === 0)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (r.clearcoatFactor = t.clearcoat, t.clearcoatMap) {
      const o = {
        index: n.processTexture(t.clearcoatMap),
        texCoord: t.clearcoatMap.channel
      };
      n.applyTextureTransform(o, t.clearcoatMap), r.clearcoatTexture = o;
    }
    if (r.clearcoatRoughnessFactor = t.clearcoatRoughness, t.clearcoatRoughnessMap) {
      const o = {
        index: n.processTexture(t.clearcoatRoughnessMap),
        texCoord: t.clearcoatRoughnessMap.channel
      };
      n.applyTextureTransform(o, t.clearcoatRoughnessMap), r.clearcoatRoughnessTexture = o;
    }
    if (t.clearcoatNormalMap) {
      const o = {
        index: n.processTexture(t.clearcoatNormalMap),
        texCoord: t.clearcoatNormalMap.channel
      };
      n.applyTextureTransform(o, t.clearcoatNormalMap), r.clearcoatNormalTexture = o;
    }
    i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class sst {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_iridescence";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.iridescence === 0)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (r.iridescenceFactor = t.iridescence, t.iridescenceMap) {
      const o = {
        index: n.processTexture(t.iridescenceMap),
        texCoord: t.iridescenceMap.channel
      };
      n.applyTextureTransform(o, t.iridescenceMap), r.iridescenceTexture = o;
    }
    if (r.iridescenceIor = t.iridescenceIOR, r.iridescenceThicknessMinimum = t.iridescenceThicknessRange[0], r.iridescenceThicknessMaximum = t.iridescenceThicknessRange[1], t.iridescenceThicknessMap) {
      const o = {
        index: n.processTexture(t.iridescenceThicknessMap),
        texCoord: t.iridescenceThicknessMap.channel
      };
      n.applyTextureTransform(o, t.iridescenceThicknessMap), r.iridescenceThicknessTexture = o;
    }
    i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class ast {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_transmission";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.transmission === 0)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (r.transmissionFactor = t.transmission, t.transmissionMap) {
      const o = {
        index: n.processTexture(t.transmissionMap),
        texCoord: t.transmissionMap.channel
      };
      n.applyTextureTransform(o, t.transmissionMap), r.transmissionTexture = o;
    }
    i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class cst {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_volume";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.transmission === 0)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (r.thicknessFactor = t.thickness, t.thicknessMap) {
      const o = {
        index: n.processTexture(t.thicknessMap),
        texCoord: t.thicknessMap.channel
      };
      n.applyTextureTransform(o, t.thicknessMap), r.thicknessTexture = o;
    }
    r.attenuationDistance = t.attenuationDistance, r.attenuationColor = t.attenuationColor.toArray(), i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class dst {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_ior";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.ior === 1.5)
      return;
    const g = this.writer.extensionsUsed, r = {};
    r.ior = t.ior, i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class Cst {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_specular";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.specularIntensity === 1 && t.specularColor.equals(_lt) && !t.specularIntensityMap && !t.specularColorTexture)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (t.specularIntensityMap) {
      const o = {
        index: n.processTexture(t.specularIntensityMap),
        texCoord: t.specularIntensityMap.channel
      };
      n.applyTextureTransform(o, t.specularIntensityMap), r.specularTexture = o;
    }
    if (t.specularColorMap) {
      const o = {
        index: n.processTexture(t.specularColorMap),
        texCoord: t.specularColorMap.channel
      };
      n.applyTextureTransform(o, t.specularColorMap), r.specularColorTexture = o;
    }
    r.specularFactor = t.specularIntensity, r.specularColorFactor = t.specularColor.toArray(), i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class ust {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_sheen";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.sheen == 0)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (t.sheenRoughnessMap) {
      const o = {
        index: n.processTexture(t.sheenRoughnessMap),
        texCoord: t.sheenRoughnessMap.channel
      };
      n.applyTextureTransform(o, t.sheenRoughnessMap), r.sheenRoughnessTexture = o;
    }
    if (t.sheenColorMap) {
      const o = {
        index: n.processTexture(t.sheenColorMap),
        texCoord: t.sheenColorMap.channel
      };
      n.applyTextureTransform(o, t.sheenColorMap), r.sheenColorTexture = o;
    }
    r.sheenRoughnessFactor = t.sheenRoughness, r.sheenColorFactor = t.sheenColor.toArray(), i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class Ast {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_anisotropy";
  }
  writeMaterial(t, i) {
    if (!t.isMeshPhysicalMaterial || t.anisotropy == 0)
      return;
    const n = this.writer, g = n.extensionsUsed, r = {};
    if (t.anisotropyMap) {
      const o = { index: n.processTexture(t.anisotropyMap) };
      n.applyTextureTransform(o, t.anisotropyMap), r.anisotropyTexture = o;
    }
    r.anisotropyStrength = t.anisotropy, r.anisotropyRotation = t.anisotropyRotation, i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
class bst {
  constructor(t) {
    this.writer = t, this.name = "KHR_materials_emissive_strength";
  }
  writeMaterial(t, i) {
    if (!t.isMeshStandardMaterial || t.emissiveIntensity === 1)
      return;
    const g = this.writer.extensionsUsed, r = {};
    r.emissiveStrength = t.emissiveIntensity, i.extensions = i.extensions || {}, i.extensions[this.name] = r, g[this.name] = !0;
  }
}
var $o = Uint8Array, Zo = Uint16Array, lZ = Uint32Array, mK = new $o([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), hK = new $o([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), lM = new $o([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), f$ = function(e, t) {
  for (var i = new Zo(31), n = 0; n < 31; ++n)
    i[n] = t += 1 << e[n - 1];
  for (var g = new lZ(i[30]), n = 1; n < 30; ++n)
    for (var r = i[n]; r < i[n + 1]; ++r)
      g[r] = r - i[n] << 5 | n;
  return [i, g];
}, G$ = f$(mK, 2), mst = G$[0], Zx = G$[1];
mst[28] = 258, Zx[258] = 28;
var hst = f$(hK, 0), sM = hst[1], fx = new Zo(32768);
for (var Tn = 0; Tn < 32768; ++Tn) {
  var Cd = (Tn & 43690) >>> 1 | (Tn & 21845) << 1;
  Cd = (Cd & 52428) >>> 2 | (Cd & 13107) << 2, Cd = (Cd & 61680) >>> 4 | (Cd & 3855) << 4, fx[Tn] = ((Cd & 65280) >>> 8 | (Cd & 255) << 8) >>> 1;
}
var GB = function(e, t, i) {
  for (var n = e.length, g = 0, r = new Zo(t); g < n; ++g)
    ++r[e[g] - 1];
  var o = new Zo(t);
  for (g = 0; g < t; ++g)
    o[g] = o[g - 1] + r[g - 1] << 1;
  var I;
  if (i) {
    I = new Zo(1 << t);
    var s = 15 - t;
    for (g = 0; g < n; ++g)
      if (e[g])
        for (var a = g << 4 | e[g], d = t - e[g], C = o[e[g] - 1]++ << d, u = C | (1 << d) - 1; C <= u; ++C)
          I[fx[C] >>> s] = a;
  } else
    for (I = new Zo(n), g = 0; g < n; ++g)
      e[g] && (I[g] = fx[o[e[g] - 1]++] >>> 15 - e[g]);
  return I;
}, Nu = new $o(288);
for (var Tn = 0; Tn < 144; ++Tn)
  Nu[Tn] = 8;
for (var Tn = 144; Tn < 256; ++Tn)
  Nu[Tn] = 9;
for (var Tn = 256; Tn < 280; ++Tn)
  Nu[Tn] = 7;
for (var Tn = 280; Tn < 288; ++Tn)
  Nu[Tn] = 8;
var bV = new $o(32);
for (var Tn = 0; Tn < 32; ++Tn)
  bV[Tn] = 5;
var pst = /* @__PURE__ */ GB(Nu, 9, 0), Bst = /* @__PURE__ */ GB(bV, 5, 0), y$ = function(e) {
  return (e / 8 | 0) + (e & 7 && 1);
}, W$ = function(e, t, i) {
  (i == null || i > e.length) && (i = e.length);
  var n = new (e instanceof Zo ? Zo : e instanceof lZ ? lZ : $o)(i - t);
  return n.set(e.subarray(t, i)), n;
}, tc = function(e, t, i) {
  i <<= t & 7;
  var n = t / 8 | 0;
  e[n] |= i, e[n + 1] |= i >>> 8;
}, k0 = function(e, t, i) {
  i <<= t & 7;
  var n = t / 8 | 0;
  e[n] |= i, e[n + 1] |= i >>> 8, e[n + 2] |= i >>> 16;
}, IF = function(e, t) {
  for (var i = [], n = 0; n < e.length; ++n)
    e[n] && i.push({ s: n, f: e[n] });
  var g = i.length, r = i.slice();
  if (!g)
    return [S$, 0];
  if (g == 1) {
    var o = new $o(i[0].s + 1);
    return o[i[0].s] = 1, [o, 1];
  }
  i.sort(function(V, w) {
    return V.f - w.f;
  }), i.push({ s: -1, f: 25001 });
  var I = i[0], s = i[1], a = 0, d = 1, C = 2;
  for (i[0] = { s: -1, f: I.f + s.f, l: I, r: s }; d != g - 1; )
    I = i[i[a].f < i[C].f ? a++ : C++], s = i[a != d && i[a].f < i[C].f ? a++ : C++], i[d++] = { s: -1, f: I.f + s.f, l: I, r: s };
  for (var u = r[0].s, n = 1; n < g; ++n)
    r[n].s > u && (u = r[n].s);
  var A = new Zo(u + 1), m = Gx(i[d - 1], A, 0);
  if (m > t) {
    var n = 0, h = 0, B = m - t, f = 1 << B;
    for (r.sort(function(w, v) {
      return A[v.s] - A[w.s] || w.f - v.f;
    }); n < g; ++n) {
      var G = r[n].s;
      if (A[G] > t)
        h += f - (1 << m - A[G]), A[G] = t;
      else
        break;
    }
    for (h >>>= B; h > 0; ) {
      var y = r[n].s;
      A[y] < t ? h -= 1 << t - A[y]++ - 1 : ++n;
    }
    for (; n >= 0 && h; --n) {
      var W = r[n].s;
      A[W] == t && (--A[W], ++h);
    }
    m = t;
  }
  return [new $o(A), m];
}, Gx = function(e, t, i) {
  return e.s == -1 ? Math.max(Gx(e.l, t, i + 1), Gx(e.r, t, i + 1)) : t[e.s] = i;
}, aM = function(e) {
  for (var t = e.length; t && !e[--t]; )
    ;
  for (var i = new Zo(++t), n = 0, g = e[0], r = 1, o = function(s) {
    i[n++] = s;
  }, I = 1; I <= t; ++I)
    if (e[I] == g && I != t)
      ++r;
    else {
      if (!g && r > 2) {
        for (; r > 138; r -= 138)
          o(32754);
        r > 2 && (o(r > 10 ? r - 11 << 5 | 28690 : r - 3 << 5 | 12305), r = 0);
      } else if (r > 3) {
        for (o(g), --r; r > 6; r -= 6)
          o(8304);
        r > 2 && (o(r - 3 << 5 | 8208), r = 0);
      }
      for (; r--; )
        o(g);
      r = 1, g = e[I];
    }
  return [i.subarray(0, n), t];
}, F0 = function(e, t) {
  for (var i = 0, n = 0; n < t.length; ++n)
    i += e[n] * t[n];
  return i;
}, yx = function(e, t, i) {
  var n = i.length, g = y$(t + 2);
  e[g] = n & 255, e[g + 1] = n >>> 8, e[g + 2] = e[g] ^ 255, e[g + 3] = e[g + 1] ^ 255;
  for (var r = 0; r < n; ++r)
    e[g + r + 4] = i[r];
  return (g + 4 + n) * 8;
}, cM = function(e, t, i, n, g, r, o, I, s, a, d) {
  tc(t, d++, i), ++g[256];
  for (var C = IF(g, 15), u = C[0], A = C[1], m = IF(r, 15), h = m[0], B = m[1], f = aM(u), G = f[0], y = f[1], W = aM(h), V = W[0], w = W[1], v = new Zo(19), H = 0; H < G.length; ++H)
    v[G[H] & 31]++;
  for (var H = 0; H < V.length; ++H)
    v[V[H] & 31]++;
  for (var x = IF(v, 7), N = x[0], M = x[1], $ = 19; $ > 4 && !N[lM[$ - 1]]; --$)
    ;
  var q = a + 5 << 3, E = F0(g, Nu) + F0(r, bV) + o, L = F0(g, u) + F0(r, h) + o + 14 + 3 * $ + F0(v, N) + (2 * v[16] + 3 * v[17] + 7 * v[18]);
  if (q <= E && q <= L)
    return yx(t, d, e.subarray(s, s + a));
  var P, Q, te, le;
  if (tc(t, d, 1 + (L < E)), d += 2, L < E) {
    P = GB(u, A, 0), Q = u, te = GB(h, B, 0), le = h;
    var Ae = GB(N, M, 0);
    tc(t, d, y - 257), tc(t, d + 5, w - 1), tc(t, d + 10, $ - 4), d += 14;
    for (var H = 0; H < $; ++H)
      tc(t, d + 3 * H, N[lM[H]]);
    d += 3 * $;
    for (var we = [G, V], Ee = 0; Ee < 2; ++Ee)
      for (var Je = we[Ee], H = 0; H < Je.length; ++H) {
        var ve = Je[H] & 31;
        tc(t, d, Ae[ve]), d += N[ve], ve > 15 && (tc(t, d, Je[H] >>> 5 & 127), d += Je[H] >>> 12);
      }
  } else
    P = pst, Q = Nu, te = Bst, le = bV;
  for (var H = 0; H < I; ++H)
    if (n[H] > 255) {
      var ve = n[H] >>> 18 & 31;
      k0(t, d, P[ve + 257]), d += Q[ve + 257], ve > 7 && (tc(t, d, n[H] >>> 23 & 31), d += mK[ve]);
      var Be = n[H] & 31;
      k0(t, d, te[Be]), d += le[Be], Be > 3 && (k0(t, d, n[H] >>> 5 & 8191), d += hK[Be]);
    } else
      k0(t, d, P[n[H]]), d += Q[n[H]];
  return k0(t, d, P[256]), d + Q[256];
}, Zst = /* @__PURE__ */ new lZ([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), S$ = /* @__PURE__ */ new $o(0), fst = function(e, t, i, n, g, r) {
  var o = e.length, I = new $o(n + o + 5 * (1 + Math.ceil(o / 7e3)) + g), s = I.subarray(n, I.length - g), a = 0;
  if (!t || o < 8)
    for (var d = 0; d <= o; d += 65535) {
      var C = d + 65535;
      C < o ? a = yx(s, a, e.subarray(d, C)) : (s[d] = r, a = yx(s, a, e.subarray(d, o)));
    }
  else {
    for (var u = Zst[t - 1], A = u >>> 13, m = u & 8191, h = (1 << i) - 1, B = new Zo(32768), f = new Zo(h + 1), G = Math.ceil(i / 3), y = 2 * G, W = function(ze) {
      return (e[ze] ^ e[ze + 1] << G ^ e[ze + 2] << y) & h;
    }, V = new lZ(25e3), w = new Zo(288), v = new Zo(32), H = 0, x = 0, d = 0, N = 0, M = 0, $ = 0; d < o; ++d) {
      var q = W(d), E = d & 32767, L = f[q];
      if (B[E] = L, f[q] = E, M <= d) {
        var P = o - d;
        if ((H > 7e3 || N > 24576) && P > 423) {
          a = cM(e, s, 0, V, w, v, x, N, $, d - $, a), N = H = x = 0, $ = d;
          for (var Q = 0; Q < 286; ++Q)
            w[Q] = 0;
          for (var Q = 0; Q < 30; ++Q)
            v[Q] = 0;
        }
        var te = 2, le = 0, Ae = m, we = E - L & 32767;
        if (P > 2 && q == W(d - we))
          for (var Ee = Math.min(A, P) - 1, Je = Math.min(32767, d), ve = Math.min(258, P); we <= Je && --Ae && E != L; ) {
            if (e[d + te] == e[d + te - we]) {
              for (var Be = 0; Be < ve && e[d + Be] == e[d + Be - we]; ++Be)
                ;
              if (Be > te) {
                if (te = Be, le = we, Be > Ee)
                  break;
                for (var ue = Math.min(we, Be - 2), Xe = 0, Q = 0; Q < ue; ++Q) {
                  var Ze = d - we + Q + 32768 & 32767, Ke = B[Ze], $e = Ze - Ke + 32768 & 32767;
                  $e > Xe && (Xe = $e, L = Ze);
                }
              }
            }
            E = L, L = B[E], we += E - L + 32768 & 32767;
          }
        if (le) {
          V[N++] = 268435456 | Zx[te] << 18 | sM[le];
          var rt = Zx[te] & 31, dt = sM[le] & 31;
          x += mK[rt] + hK[dt], ++w[257 + rt], ++v[dt], M = d + te, ++H;
        } else
          V[N++] = e[d], ++w[e[d]];
      }
    }
    a = cM(e, s, r, V, w, v, x, N, $, d - $, a);
  }
  return W$(I, 0, n + y$(a) + g);
}, Gst = /* @__PURE__ */ function() {
  for (var e = new Int32Array(256), t = 0; t < 256; ++t) {
    for (var i = t, n = 9; --n; )
      i = (i & 1 && -306674912) ^ i >>> 1;
    e[t] = i;
  }
  return e;
}(), yst = function() {
  var e = -1;
  return {
    p: function(t) {
      for (var i = e, n = 0; n < t.length; ++n)
        i = Gst[i & 255 ^ t[n]] ^ i >>> 8;
      e = i;
    },
    d: function() {
      return ~e;
    }
  };
}, Wst = function(e, t, i, n, g) {
  return fst(e, t.level == null ? 6 : t.level, t.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 12 + t.mem, i, n, !g);
}, V$ = function(e, t) {
  var i = {};
  for (var n in e)
    i[n] = e[n];
  for (var n in t)
    i[n] = t[n];
  return i;
}, kr = function(e, t, i) {
  for (; i; ++t)
    e[t] = i, i >>>= 8;
};
function Sst(e, t) {
  return Wst(e, t || {}, 0, 0);
}
var w$ = function(e, t, i, n) {
  for (var g in e) {
    var r = e[g], o = t + g;
    r instanceof $o ? i[o] = [r, n] : Array.isArray(r) ? i[o] = [r[0], V$(n, r[1])] : w$(r, o + "/", i, n);
  }
}, dM = typeof TextEncoder < "u" && /* @__PURE__ */ new TextEncoder(), Vst = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), wst = 0;
try {
  Vst.decode(S$, { stream: !0 }), wst = 1;
} catch {
}
function mV(e, t) {
  var i;
  if (dM)
    return dM.encode(e);
  for (var n = e.length, g = new $o(e.length + (e.length >> 1)), r = 0, o = function(a) {
    g[r++] = a;
  }, i = 0; i < n; ++i) {
    if (r + 5 > g.length) {
      var I = new $o(r + 8 + (n - i << 1));
      I.set(g), g = I;
    }
    var s = e.charCodeAt(i);
    s < 128 || t ? o(s) : s < 2048 ? (o(192 | s >> 6), o(128 | s & 63)) : s > 55295 && s < 57344 ? (s = 65536 + (s & 1047552) | e.charCodeAt(++i) & 1023, o(240 | s >> 18), o(128 | s >> 12 & 63), o(128 | s >> 6 & 63), o(128 | s & 63)) : (o(224 | s >> 12), o(128 | s >> 6 & 63), o(128 | s & 63));
  }
  return W$(g, 0, r);
}
var Wx = function(e) {
  var t = 0;
  if (e)
    for (var i in e) {
      var n = e[i].length;
      if (n > 65535)
        throw "extra field too long";
      t += n + 4;
    }
  return t;
}, CM = function(e, t, i, n, g, r, o, I) {
  var s = n.length, a = i.extra, d = I && I.length, C = Wx(a);
  kr(e, t, o != null ? 33639248 : 67324752), t += 4, o != null && (e[t++] = 20, e[t++] = i.os), e[t] = 20, t += 2, e[t++] = i.flag << 1 | (r == null && 8), e[t++] = g && 8, e[t++] = i.compression & 255, e[t++] = i.compression >> 8;
  var u = new Date(i.mtime == null ? Date.now() : i.mtime), A = u.getFullYear() - 1980;
  if (A < 0 || A > 119)
    throw "date not in range 1980-2099";
  if (kr(e, t, A << 25 | u.getMonth() + 1 << 21 | u.getDate() << 16 | u.getHours() << 11 | u.getMinutes() << 5 | u.getSeconds() >>> 1), t += 4, r != null && (kr(e, t, i.crc), kr(e, t + 4, r), kr(e, t + 8, i.size)), kr(e, t + 12, s), kr(e, t + 14, C), t += 16, o != null && (kr(e, t, d), kr(e, t + 6, i.attrs), kr(e, t + 10, o), t += 14), e.set(n, t), t += s, C)
    for (var m in a) {
      var h = a[m], B = h.length;
      kr(e, t, +m), kr(e, t + 2, B), e.set(h, t + 4), t += 4 + B;
    }
  return d && (e.set(I, t), t += d), t;
}, vst = function(e, t, i, n, g) {
  kr(e, t, 101010256), kr(e, t + 8, i), kr(e, t + 10, i), kr(e, t + 12, n), kr(e, t + 16, g);
};
function Rst(e, t) {
  t || (t = {});
  var i = {}, n = [];
  w$(e, "", i, t);
  var g = 0, r = 0;
  for (var o in i) {
    var I = i[o], s = I[0], a = I[1], d = a.level == 0 ? 0 : 8, C = mV(o), u = C.length, A = a.comment, m = A && mV(A), h = m && m.length, B = Wx(a.extra);
    if (u > 65535)
      throw "filename too long";
    var f = d ? Sst(s, a) : s, G = f.length, y = yst();
    y.p(s), n.push(V$(a, {
      size: s.length,
      crc: y.d(),
      c: f,
      f: C,
      m,
      u: u != o.length || m && A.length != h,
      o: g,
      compression: d
    })), g += 30 + u + B + G, r += 76 + 2 * (u + B) + (h || 0) + G;
  }
  for (var W = new $o(r + 22), V = g, w = r - g, v = 0; v < n.length; ++v) {
    var C = n[v];
    CM(W, C.o, C, C.f, C.u, C.c.length);
    var H = 30 + C.f.length + Wx(C.extra);
    W.set(C.c, C.o + H), CM(W, g, C, C.f, C.u, C.c.length, C.o, C.m), g += 16 + H + (C.m ? C.m.length : 0);
  }
  return vst(W, g, n.length, w, V), W;
}
var Xst = Object.defineProperty, Hst = (e, t, i) => t in e ? Xst(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, FW = (e, t, i) => (Hst(e, typeof t != "symbol" ? t + "" : t, i), i);
class kst {
  constructor() {
    FW(this, "PRECISION", 7), FW(this, "materials"), FW(this, "textures"), FW(this, "files"), this.materials = {}, this.textures = {}, this.files = {};
  }
  async parse(t) {
    const i = "model.usda";
    this.files[i] = null;
    let n = this.buildHeader();
    t.traverseVisible((r) => {
      if (r instanceof Tz && r.isMesh && r.material.isMeshStandardMaterial) {
        const o = r.geometry, I = r.material, s = "geometries/Geometry_" + o.id + ".usd";
        if (!(s in this.files)) {
          const a = this.buildMeshObject(o);
          this.files[s] = this.buildUSDFileAsString(a);
        }
        I.uuid in this.materials || (this.materials[I.uuid] = I), n += this.buildXform(r, o, I);
      }
    }), n += this.buildMaterials(this.materials), this.files[i] = mV(n), n = null;
    for (const r in this.textures) {
      const o = this.textures[r], I = r.split("_")[1], s = o.format === 1023, a = this.imageToCanvas(o.image, I), d = await new Promise(
        (C) => a == null ? void 0 : a.toBlob(C, s ? "image/png" : "image/jpeg", 1)
      );
      d && (this.files[`textures/Texture_${r}.${s ? "png" : "jpg"}`] = new Uint8Array(await d.arrayBuffer()));
    }
    let g = 0;
    for (const r in this.files) {
      const o = this.files[r], I = 34 + r.length;
      g += I;
      const s = g & 63;
      if (s !== 4 && o !== null && o instanceof Uint8Array) {
        const a = 64 - s, d = new Uint8Array(a);
        this.files[r] = [o, { extra: { 12345: d } }];
      }
      o && typeof o.length == "number" && (g = o.length);
    }
    return Rst(this.files, { level: 0 });
  }
  imageToCanvas(t, i) {
    if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
      const n = 1024 / Math.max(t.width, t.height), g = document.createElement("canvas");
      g.width = t.width * Math.min(1, n), g.height = t.height * Math.min(1, n);
      const r = g.getContext("2d");
      if (r == null || r.drawImage(t, 0, 0, g.width, g.height), i !== void 0) {
        const o = parseInt(i, 16), I = (o >> 16 & 255) / 255, s = (o >> 8 & 255) / 255, a = (o & 255) / 255, d = r == null ? void 0 : r.getImageData(0, 0, g.width, g.height);
        if (d) {
          const C = d == null ? void 0 : d.data;
          for (let u = 0; u < C.length; u += 4)
            C[u + 0] = C[u + 0] * I, C[u + 1] = C[u + 1] * s, C[u + 2] = C[u + 2] * a;
          r == null || r.putImageData(d, 0, 0);
        }
      }
      return g;
    }
  }
  buildHeader() {
    return `#usda 1.0
(
    customLayerData = {
        string creator = "Three.js USDZExporter"
    }
    metersPerUnit = 1
    upAxis = "Y"
)
`;
  }
  buildUSDFileAsString(t) {
    let i = this.buildHeader();
    return i += t, mV(i);
  }
  // Xform
  buildXform(t, i, n) {
    const g = "Object_" + t.id, r = this.buildMatrix(t.matrixWorld);
    return t.matrixWorld.determinant() < 0 && console.warn("THREE.USDZExporter: USDZ does not support negative scales", t), `def Xform "${g}" (
    prepend references = @./geometries/Geometry_${i.id}.usd@</Geometry>
)
{
    matrix4d xformOp:transform = ${r}
    uniform token[] xformOpOrder = ["xformOp:transform"]
    rel material:binding = </Materials/Material_${n.id}>
}
`;
  }
  buildMatrix(t) {
    const i = t.elements;
    return `( ${this.buildMatrixRow(i, 0)}, ${this.buildMatrixRow(i, 4)}, ${this.buildMatrixRow(
      i,
      8
    )}, ${this.buildMatrixRow(i, 12)} )`;
  }
  buildMatrixRow(t, i) {
    return `(${t[i + 0]}, ${t[i + 1]}, ${t[i + 2]}, ${t[i + 3]})`;
  }
  // Mesh
  buildMeshObject(t) {
    return `
def "Geometry"
{
  ${this.buildMesh(t)}
}
`;
  }
  buildMesh(t) {
    const i = "Geometry", n = t.attributes, g = n.position.count;
    return `
    def Mesh "${i}"
    {
        int[] faceVertexCounts = [${this.buildMeshVertexCount(t)}]
        int[] faceVertexIndices = [${this.buildMeshVertexIndices(t)}]
        normal3f[] normals = [${this.buildVector3Array(n.normal, g)}] (
            interpolation = "vertex"
        )
        point3f[] points = [${this.buildVector3Array(n.position, g)}]
        float2[] primvars:st = [${this.buildVector2Array(n.uv, g)}] (
            interpolation = "vertex"
        )
        uniform token subdivisionScheme = "none"
    }
`;
  }
  buildMeshVertexCount(t) {
    const i = t.index !== null ? t.index.array.length : t.attributes.position.count;
    return Array(i / 3).fill(3).join(", ");
  }
  buildMeshVertexIndices(t) {
    if (t.index !== null)
      return t.index.array.join(", ");
    const i = [], n = t.attributes.position.count;
    for (let g = 0; g < n; g++)
      i.push(g);
    return i.join(", ");
  }
  buildVector3Array(t, i) {
    if (t === void 0)
      return console.warn("USDZExporter: Normals missing."), Array(i).fill("(0, 0, 0)").join(", ");
    const n = [], g = t.array;
    for (let r = 0; r < g.length; r += 3)
      n.push(
        `(${g[r + 0].toPrecision(this.PRECISION)}, ${g[r + 1].toPrecision(this.PRECISION)}, ${g[r + 2].toPrecision(this.PRECISION)})`
      );
    return n.join(", ");
  }
  buildVector2Array(t, i) {
    if (t === void 0)
      return console.warn("USDZExporter: UVs missing."), Array(i).fill("(0, 0)").join(", ");
    const n = [], g = t.array;
    for (let r = 0; r < g.length; r += 2)
      n.push(`(${g[r + 0].toPrecision(this.PRECISION)}, ${1 - g[r + 1].toPrecision(this.PRECISION)})`);
    return n.join(", ");
  }
  // Materials
  buildMaterials(t) {
    const i = [];
    for (const n in t) {
      const g = t[n];
      i.push(this.buildMaterial(g));
    }
    return `def "Materials"
{
${i.join("")}
}
`;
  }
  buildMaterial(t) {
    const i = "            ", n = [], g = [];
    return t.map !== null ? (n.push(
      `${i}color3f inputs:diffuseColor.connect = </Materials/Material_${t.id}/Texture_${t.map.id}_diffuse.outputs:rgb>`
    ), (t.transparent || t.alphaTest > 0) && n.push(`${i}float inputs:opacity.connect = </Materials/Material_${t.id}/Texture_${t.map.id}_diffuse.outputs:a>`), t.alphaTest > 0.01 ? n.push(`${i}float inputs:opacityThreshold = ${t.alphaTest}`) : (t.transparent || t.alphaTest > 0) && n.push(`${i}float inputs:opacityThreshold = 0.01`), g.push(this.buildTexture(t, t.map, "diffuse", t.color))) : n.push(`${i}color3f inputs:diffuseColor = ${this.buildColor(t.color)}`), t.emissiveMap !== null ? (n.push(
      `${i}color3f inputs:emissiveColor.connect = </Materials/Material_${t.id}/Texture_${t.emissiveMap.id}_emissive.outputs:rgb>`
    ), g.push(this.buildTexture(t, t.emissiveMap, "emissive"))) : t.emissive.getHex() > 0 && n.push(`${i}color3f inputs:emissiveColor = ${this.buildColor(t.emissive)}`), t.normalMap !== null && (n.push(
      `${i}normal3f inputs:normal.connect = </Materials/Material_${t.id}/Texture_${t.normalMap.id}_normal.outputs:rgb>`
    ), g.push(this.buildTexture(t, t.normalMap, "normal"))), t.aoMap !== null && (n.push(
      `${i}float inputs:occlusion.connect = </Materials/Material_${t.id}/Texture_${t.aoMap.id}_occlusion.outputs:r>`
    ), g.push(this.buildTexture(t, t.aoMap, "occlusion"))), t.roughnessMap !== null && t.roughness === 1 ? (n.push(
      `${i}float inputs:roughness.connect = </Materials/Material_${t.id}/Texture_${t.roughnessMap.id}_roughness.outputs:g>`
    ), g.push(this.buildTexture(t, t.roughnessMap, "roughness"))) : n.push(`${i}float inputs:roughness = ${t.roughness}`), t.metalnessMap !== null && t.metalness === 1 ? (n.push(
      `${i}float inputs:metallic.connect = </Materials/Material_${t.id}/Texture_${t.metalnessMap.id}_metallic.outputs:b>`
    ), g.push(this.buildTexture(t, t.metalnessMap, "metallic"))) : n.push(`${i}float inputs:metallic = ${t.metalness}`), n.push(`${i}float inputs:opacity = ${t.opacity}`), t instanceof Zge && (n.push(`${i}float inputs:clearcoat = ${t.clearcoat}`), n.push(`${i}float inputs:clearcoatRoughness = ${t.clearcoatRoughness}`), n.push(`${i}float inputs:ior = ${t.ior}`)), `
    def Material "Material_${t.id}"
    {
        def Shader "PreviewSurface"
        {
            uniform token info:id = "UsdPreviewSurface"
${n.join(`
`)}
            int inputs:useSpecularWorkflow = 0
            token outputs:surface
        }
        token outputs:surface.connect = </Materials/Material_${t.id}/PreviewSurface.outputs:surface>
        token inputs:frame:stPrimvarName = "st"
        def Shader "uvReader_st"
        {
            uniform token info:id = "UsdPrimvarReader_float2"
            token inputs:varname.connect = </Materials/Material_${t.id}.inputs:frame:stPrimvarName>
            float2 inputs:fallback = (0.0, 0.0)
            float2 outputs:result
        }
${g.join(`
`)}
    }
`;
  }
  buildTexture(t, i, n, g) {
    const r = i.id + (g ? "_" + g.getHexString() : ""), o = i.format === 1023;
    return this.textures[r] = i, `
      def Shader "Transform2d_${n}" (
          sdrMetadata = {
              string role = "math"
          }
      )
      {
          uniform token info:id = "UsdTransform2d"
          float2 inputs:in.connect = </Materials/Material_${t.id}/uvReader_st.outputs:result>
          float2 inputs:scale = ${this.buildVector2(i.repeat)}
          float2 inputs:translation = ${this.buildVector2(i.offset)}
          float2 outputs:result
      }
      def Shader "Texture_${i.id}_${n}"
      {
          uniform token info:id = "UsdUVTexture"
          asset inputs:file = @textures/Texture_${r}.${o ? "png" : "jpg"}@
          float2 inputs:st.connect = </Materials/Material_${t.id}/Transform2d_${n}.outputs:result>
          token inputs:wrapS = "repeat"
          token inputs:wrapT = "repeat"
          float outputs:r
          float outputs:g
          float outputs:b
          float3 outputs:rgb
          ${t.transparent || t.alphaTest > 0 ? "float outputs:a" : ""}
      }`;
  }
  buildColor(t) {
    return `(${t.r}, ${t.g}, ${t.b})`;
  }
  buildVector2(t) {
    return `(${t.x}, ${t.y})`;
  }
}
const Fst = "1.1", Yst = (e) => {
  const t = [], i = {};
  e.traverseVisible((n) => {
    const g = n;
    g.isMesh && (t.push(g), g.material instanceof Array ? g.material.forEach((r) => {
      i[r.uuid] = (i[r.uuid] ?? 0) + 1;
    }) : i[g.material.uuid] = (i[g.material.uuid] ?? 0) + 1);
  }), t.forEach((n) => {
    n.material instanceof Array ? n.material = n.material.map((g) => i[g.uuid] > 1 ? g.clone() : g) : i[n.material.uuid] > 1 && (n.material = n.material.clone());
  });
}, xst = (e) => {
  const t = new kst(), i = new bK(), n = _(ND), r = U1()(Ii.AR_PLACEMENT) ?? !1, [o, I] = At(), [s, a] = At(), [d, C] = At(), [u, A] = At(0), m = _(Ai), h = _(QZ), B = _(f$e), f = _(rf);
  return et(() => {
    u === 0 && setTimeout(() => A(u + 1), n.length ? 3e3 : 0);
  }, []), et(() => {
    const G = async () => {
      var V;
      if (!u)
        return;
      let y;
      const W = window.oc3;
      if ((V = W == null ? void 0 : W.scene) == null || V.traverse((w) => {
        w.name === "k3d" && (y = w);
      }), W && y && !f) {
        let w;
        const v = y.clone(!0);
        if (Dst(B, v), ED("setARExport"))
          w = await ms("setARExport", {
            platform: e,
            scene: v
          });
        else {
          await Jst(v, h), e === "iOS" && Yst(v);
          const H = e === "iOS" ? await t.parse(v) : await i.parseAsync(v, {
            binary: !0
          });
          w = new Blob([H], {
            type: "application/octet-stream"
          });
        }
        I(w);
      } else
        setTimeout(() => A(u + 1), f ? 200 : 1500);
    };
    window.oc3 && G();
  }, [u, f]), et(() => {
    o && (async () => {
      const y = await Eet("app", [new File([o], `${m.code}_ar_${e}.${e === "iOS" ? "usdz" : "glb"}`)], e, {
        appCode: m.code
      });
      a(ce.first(Object.values(y)));
    })();
  }, [o]), et(() => {
    if (s)
      if (e === "iOS")
        C(s);
      else {
        const G = window.location.toString(), y = new URL(G), W = "#model-viewer-no-ar-fallback";
        y.hash = W;
        const V = `?file=${s}&mode=ar_preferred&enable_vertical_placement=${r.toString()}`, w = `intent://arvr.google.com/scene-viewer/${Fst}${V}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;end;`;
        C(w);
      }
  }, [s]), [o, s, d];
};
function Dst(e, t) {
  const i = new Set(e.map((n) => n.id));
  return i.size > 0 && t.traverse((n) => {
    i.has(n.userData.modelId) && (n.visible = !1);
  }), i;
}
async function Jst(e, t) {
  const i = new Map(t.map((o) => [o.id, o])), n = [];
  e.traverseVisible((o) => {
    p$(o) && (Array.isArray(o.material) ? o.material : [o.material]).some((s) => s.userData.arFallbackId && i.has(s.userData.arFallbackId)) && n.push(o);
  });
  const g = await Promise.all(n.map(async (o) => Array.isArray(o.material) ? await Promise.all(o.material.map(async (s) => s.userData.arFallbackId && i.has(s.userData.arFallbackId) ? ax(i.get(s.userData.arFallbackId)) : s)) : await ax(i.get(o.material.userData.arFallbackId)))), r = [];
  for (let o = 0; o < n.length; o++)
    r.push([n[o], n[o].material]), n[o].material = g[o];
  return r;
}
const Kst = ["translation_AR_Mobile_Title", "translation_AR_Mobile_Progress_Export", "translation_AR_Mobile_Progress_File", "translation_AR_Mobile_Progress_Device"], Est = (e) => {
  const t = un(), [i, n, g] = xst(e.device);
  et(() => {
    g && (Mlt(e.device, g), setTimeout(e.onClose, 500));
  }, [g]);
  const r = {
    device: e.device
  };
  return /* @__PURE__ */ ge(j1, { settingKeys: Kst, onClose: e.onClose, show: !0, title: t("translation_AR_Mobile_Title", "Mobiles {{device}}-Gerät erkannt", r), type: "none", children: [
    /* @__PURE__ */ p(Cr, { children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "flex",
      alignItems: "center",
      marginTop: 3
    }, children: [
      /* @__PURE__ */ p(fe, { component: "div", sx: {
        marginRight: 1,
        display: "flex",
        alignItems: "center"
      }, children: i ? /* @__PURE__ */ p(mS, {}) : /* @__PURE__ */ p(hm, { size: 20 }) }),
      t("translation_AR_Mobile_Progress_Export")
    ] }) }),
    /* @__PURE__ */ p(Cr, { children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "flex",
      alignItems: "center",
      marginTop: 3
    }, children: [
      /* @__PURE__ */ p(fe, { component: "div", sx: {
        marginRight: 1,
        display: "flex",
        alignItems: "center"
      }, children: n ? /* @__PURE__ */ p(mS, {}) : /* @__PURE__ */ p(hm, { size: 20 }) }),
      t("translation_AR_Mobile_Progress_File")
    ] }) }),
    /* @__PURE__ */ p(Cr, { children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "flex",
      alignItems: "center",
      marginTop: 3
    }, children: [
      /* @__PURE__ */ p(fe, { component: "div", sx: {
        marginRight: 1,
        display: "flex",
        alignItems: "center"
      }, children: g ? /* @__PURE__ */ p(mS, {}) : /* @__PURE__ */ p(hm, { size: 20 }) }),
      t("translation_AR_Mobile_Progress_Device", "{{device}}-AR-System einrichten", r)
    ] }) })
  ] });
}, Nst = () => {
  const e = _(yje), t = zt(), i = C5();
  return et(() => {
    pye() && i.progress >= 100 && (Bye(), t(_J(!0)));
  }, [i.progress]), e ? /* @__PURE__ */ p(Lst, {}) : null;
}, Lst = () => {
  const e = zt(), [t, i] = At(oc.NONE);
  _(Ai);
  const n = je(() => new B8(window.navigator.userAgent), []);
  et(() => {
    const o = n.mobile(), I = n.os() == "iOS" || n.os() == "iPadOS", s = n.os() == "AndroidOS";
    i(o ? I ? oc.IOS : s ? oc.ANDROID : oc.DESKTOP : oc.DESKTOP);
  }, []);
  const g = () => {
    e(_J(!1));
  };
  if (t == oc.NONE)
    return /* @__PURE__ */ p("div", {});
  if (t == oc.DESKTOP)
    return /* @__PURE__ */ p(Elt, { onClose: g });
  const r = t == oc.ANDROID ? "AndroidOS" : "iOS";
  return /* @__PURE__ */ p(Est, { onClose: g, device: r });
}, v$ = {
  opacity: ".6",
  width: "-webkit-fill-available"
}, aA = (e) => {
  const {
    t
  } = ii();
  if (!e.invalid)
    return e.children;
  const i = e.optionTitle ? `${e.optionTitle}: ` : "";
  return /* @__PURE__ */ p(Cn, { sx: {
    width: "-webkit-fill-available"
  }, title: i + t("Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen"), className: "k3-invalid-option", children: /* @__PURE__ */ p("div", { style: v$, children: e.children }) });
}, Tst = (e) => e.invalid ? /* @__PURE__ */ p(aA, { invalid: !0, optionTitle: e.optionTitle, children: e.children }) : /* @__PURE__ */ p(Cn, { title: e.optionTitle, children: /* @__PURE__ */ p("div", { children: e.children }) });
function Mst(e) {
  return /* @__PURE__ */ p(fe, { component: "img", sx: e.sx, width: e.width, src: "data:image/png;base64,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" });
}
const uM = {
  image: {
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    boxSizing: "border-box",
    objectFit: "contain",
    borderRadius: "8px"
  }
}, R$ = ({
  url: e,
  sx: t
}) => e ? /* @__PURE__ */ p(fe, { component: "img", sx: {
  ...uM.image,
  ...t
}, alt: "", src: e }) : /* @__PURE__ */ p(Mst, { sx: uM.image });
function Ust({
  sx: e,
  priceFormatter: t = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  }),
  price: i
}) {
  return /* @__PURE__ */ p(Ne, { sx: {
    display: "grid",
    placeItems: "center",
    backgroundColor: (n) => n.palette.background.default,
    color: (n) => n.palette.text.primary,
    borderRadius: 1,
    px: 2,
    ...e
  }, "data-cy": "price", className: "k3-price k3-price-total", children: t.format(i) });
}
const Pst = () => {
  const e = _(sh), t = _(iC), i = _(Wa);
  return e ? /* @__PURE__ */ p(_st, { price: t, priceFormatter: i }) : null;
}, zst = (e) => {
  var r;
  const t = dK(e.currencyVariableKey || "currency"), i = i$(e.currencyVariableKey, [e.currencyAttributeKey])[0], n = _(ng), g = ((r = i == null ? void 0 : i.value) == null ? void 0 : r.toString()) || (t == null ? void 0 : t.label.replace(/\[|\]/g, "")) || "EUR";
  return /* @__PURE__ */ p(pK, { currency: g, type: "overall", language: n });
}, pK = (e) => {
  const t = _(sh), i = Qst(e), n = _(Wa), g = je(() => Ost(e.language, e.currency) || n, [e.currency, e.language, n]), r = je(() => {
    if (!e.type || e.type == "overall")
      return g.format(i);
    const o = e.mwst ? i / (1 + (e.mwst || 0)) : i;
    return e.type == "netto" ? o : i - o;
  }, [e.type, e.mwst, i, g]);
  return t ? /* @__PURE__ */ p(Bt, { children: r }) : null;
}, Ost = (e, t) => !e || !t ? null : new Intl.NumberFormat(e, {
  style: "currency",
  currency: t
}), AM = (e) => e.category ? (t) => {
  var i;
  return !e.category || ((i = t.article) == null ? void 0 : i.category) == e.category;
} : () => !0, Qst = (e) => {
  const t = Li();
  return _(e.instanciated ? e.category || e.excludeSurcharges ? X$e(AM(e), e.excludeSurcharges) : iC : e.category || e.excludeSurcharges ? H$e(AM(e), t, !!e.excludeSurcharges) : N6(t));
}, jst = (e) => {
  var r;
  const {
    price: t,
    priceFormatter: i,
    sx: n
  } = e;
  return (r = _(Ai).productDetails) != null && r.price ? /* @__PURE__ */ p(Ust, { sx: n, price: t, priceFormatter: i }) : null;
}, _st = ki({
  app: {
    price: {
      root: !0
    }
  }
})(jst), X$ = ({
  value: e
}) => {
  const t = _(ng);
  return e && /* @__PURE__ */ p(Rc, { htmlString: e[t], renderTarget: "localized-html" });
}, bM = {
  root: {
    overflow: "hidden"
  },
  labelContainer: {
    maxHeight: 24 * 6,
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden"
  }
}, H$ = () => {
  const e = _(Ije);
  return /* @__PURE__ */ p(qst, { labelActions: e });
}, $st = ({
  labelActions: e
}) => (e == null ? void 0 : e.length) === 0 ? null : /* @__PURE__ */ p(fe, { component: "div", sx: bM.root, children: /* @__PURE__ */ p(fe, { component: "div", sx: {
  p: (e == null ? void 0 : e.length) && 0,
  ...bM.labelContainer
}, children: me.map((t) => /* @__PURE__ */ p(Ne, { color: "text.primary", gutterBottom: !0, children: /* @__PURE__ */ p(X$, { value: t.label }) }, t.ruleItemId), e) }) }), qst = ki({
  app: {
    labelActionDisplay: {
      root: !0
    }
  }
})($st), k$ = {
  // mui components
  Typography: AI(() => import("./index-DnrkzOo1.js")),
  Switch: AI(() => import("./index-DBXSmj8n.js")),
  Box: AI(() => import("./index-Diaf_VGY.js")),
  Link: AI(() => import("./index-C4irtrMJ.js")),
  Stack: AI(() => import("./index-BsgFqeEl.js")),
  Button: AI(() => import("./index-DQG3IRlR.js")),
  Divider: AI(() => import("./index-Dezb77-h.js")),
  PriceData: pK,
  LabelActionsDisplay: H$,
  // mui icons
  ExpandCircleDownIcon: AI(() => import("./ExpandCircleDown-hXfeRNch.js").then((e) => e.E)),
  KeyboardArrowDownIcon: AI(() => Promise.resolve().then(() => F0t)),
  CloseIcon: AI(() => Promise.resolve().then(() => jpt)),
  MoreVertIcon: AI(() => import("./MoreVert-CK2YH_V-.js").then((e) => e.M))
}, eat = (e) => e.split(";").filter((t) => t.split(":")[0] && t.split(":")[1]).map((t) => [t.split(":")[0].trim().replace(/-./g, (i) => i.substr(1).toUpperCase()), t.split(":")[1].trim()]).reduce((t, i) => ({
  ...t,
  [i[0]]: i[1]
}), {}), tat = (e) => {
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  const t = +e;
  return t || t === 0 ? t : e;
}, F$ = (e, t, i = 0) => {
  if (t.nodeType == Node.TEXT_NODE)
    return t.textContent;
  const n = [];
  t.childNodes.forEach((o) => n.push(o));
  const g = {
    key: `${t.nodeName}_${i}`
  };
  for (let o = 0; o < t.attributes.length; o++) {
    const I = t.attributes.item(o);
    switch (I.name) {
      case "style":
        g[I.name] = eat(I.value);
        break;
      default:
        g[I.name] = tat(I.value);
        break;
    }
  }
  const r = n != null && n.length ? n.filter((o) => o.nodeType == Node.ELEMENT_NODE || o.nodeType == Node.TEXT_NODE).map((o, I) => F$(e, o, I)) : void 0;
  return ga(e[t.nodeName] || t.nodeName, g, r);
};
class Rc extends Se.Component {
  get value() {
    return this.props.xmlString || `<div>${this.props.htmlString}</div>`;
  }
  get components() {
    return this.props.components || k$;
  }
  constructor(t) {
    super(t), this.state = {
      errorMessage: void 0
    };
  }
  // React Error was caught
  static getDerivedStateFromError(t) {
    return {
      errorMessage: (t == null ? void 0 : t.message) || (t == null ? void 0 : t.toString())
    };
  }
  // If string value has changed and error is displayed, reset error
  componentDidUpdate(t) {
    (t.xmlString || `<div>${t.htmlString}</div>`) != this.value && this.state.errorMessage && this.setState({
      errorMessage: void 0
    });
  }
  // React Error was caught. E.g. br Tags with children
  componentDidCatch(t, i) {
    console.error("StringToReact: Unexpected error occurred:", t, i);
  }
  // Checks whether the created document contains parse errors
  hasParseErrors(t) {
    const i = t == null ? void 0 : t.getRootNode().firstChild;
    return !!i && i.innerHTML.includes("parsererror");
  }
  getLayout() {
    if (!this.value)
      return null;
    const i = new DOMParser().parseFromString(this.value, "application/xhtml+xml");
    return this.hasParseErrors(i) ? (console.error("StringToReact: HTML could not be parsed for " + this.props.renderTarget), /* @__PURE__ */ p(mM, {})) : F$(this.components, i.getRootNode().firstChild);
  }
  render() {
    return this.state.errorMessage ? /* @__PURE__ */ p(mM, { message: this.state.errorMessage }) : /* @__PURE__ */ p($V, { fallback: /* @__PURE__ */ p(Bt, {}), children: this.getLayout() });
  }
}
const mM = ({
  message: e
}) => {
  const t = _(hr), {
    t: i
  } = ii();
  if (t) {
    const n = i("Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.");
    return /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p(Ne, { color: "error", children: n }),
      !!e && /* @__PURE__ */ p(Ne, { color: "error", children: e })
    ] });
  }
  return null;
}, hM = () => {
  const {
    t: e
  } = ii(), t = `${e("Der eingegebe Wert ist nicht gültig: ")} ${e("Ungültiges HTML-Format")}`;
  return /* @__PURE__ */ p(Ne, { color: "error", children: t });
}, pM = (e) => !new DOMParser().parseFromString(`<div>${e}</div>`, "application/xhtml+xml").querySelector("parsererror"), BM = (e) => {
  const {
    t
  } = ii(), i = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  });
  return /* @__PURE__ */ p(fe, { component: "div", className: "k3-value-price", sx: {
    ...e.sx,
    paddingRight: e.verticalDisplay ? 0 : "8px"
  }, children: /* @__PURE__ */ p(Ne, { variant: "overline", sx: {
    fontWeight: "bold"
  }, children: e.isPriceLoading ? /* @__PURE__ */ p(PO, { animation: "pulse", variant: "text", width: 40 }) : /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p("span", { className: "k3-value-price-inner", children: i.format(e.price || 0) }),
    !!e.surCharges && e.surCharges != 0 && /* @__PURE__ */ p(Cn, { title: t("Weitere Preisauswirkungen dieser Selektion"), children: /* @__PURE__ */ p("div", { className: "k3-value-price-surcharges", children: /* @__PURE__ */ p(Ne, { variant: "subtitle2", children: /* @__PURE__ */ ge("small", { style: {
      display: "block",
      fontWeight: "lighter",
      marginTop: "-10px",
      textAlign: "right",
      textWrap: "nowrap"
    }, children: [
      e.surCharges > 0 ? "+ " : "- ",
      i.format(e.surCharges > 0 ? e.surCharges : e.surCharges * -1)
    ] }) }) }) })
  ] }) }) });
}, Y$ = pZ((e) => {
  const {
    t
  } = ii();
  return /* @__PURE__ */ p(fe, { component: "div", className: Ve("k3-info-btn", e.className), "data-cy": e.dataCy ?? "info-icon-btn", "aria-label": "Details", title: t("Mehr Informationen anzeigen"), sx: [{
    padding: "0",
    fontSize: e.iconSize ? void 0 : "1.5rem",
    cursor: "pointer"
  }, ...Array.isArray(e.sx) ? e.sx : [e.sx]], onClick: (i) => (i.preventDefault(), e.onClick(i), !1), children: /* @__PURE__ */ p(V1, { fontSize: e.iconSize ?? "inherit", color: "info", className: "info-selection info-details" }) });
}), iat = (e) => {
  const t = _(ng), i = (n, g) => {
    const r = (g.attrs || []).find((o) => o.attrId == n.id);
    if (!r)
      return null;
    switch (n.type) {
      case "string":
        const o = (r == null ? void 0 : r.value) || {};
        return Eu(o, t);
      case "number":
        return (r == null ? void 0 : r.value) + " " + (n.unit || "");
      case "symbol":
      default:
        return JSON.stringify(r == null ? void 0 : r.value);
    }
  };
  return /* @__PURE__ */ p(g1, { size: "small", sx: {
    [`& .${_O.root}`]: {
      borderBottom: "none"
    }
  }, children: /* @__PURE__ */ p(o1, { children: e.attrs.map((n) => /* @__PURE__ */ ge(Jd, { children: [
    /* @__PURE__ */ p(xi, { component: "th", scope: "row", children: /* @__PURE__ */ p(xm, { value: n.label }) }),
    /* @__PURE__ */ p(xi, { children: i(n, e.value) })
  ] }, n.id)) }) });
}, nat = (e) => {
  var o, I, s, a;
  const [t, i] = At(!1), n = !!((o = e.value) != null && o.info) && ((I = e.value) == null ? void 0 : I.info) != "", g = !!((s = e.attrs) != null && s.length) && e.attrs.some((d) => {
    var C;
    return d.displayed && ((C = e.value.attrs) == null ? void 0 : C.find((u) => u.attrId == d.id && !!u.value));
  });
  if (!n && !g)
    return;
  const r = (d, C) => (d.preventDefault(), d.stopPropagation(), i(C), !1);
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(Y$, { "data-cy": "value-info-btn", sx: e.sx || {
      height: "24px",
      lineHeight: "24px"
    }, onClick: (d) => r(d, !0), className: "k3-value-info" }),
    /* @__PURE__ */ p($1, { className: "k3-value-info-modal", show: t, onClose: (d) => r(d, !1), type: "info", title: e.value.label, stopPropagation: !0, children: /* @__PURE__ */ ge(Ne, { component: "div", children: [
      n && /* @__PURE__ */ p(Rc, { htmlString: ((a = e.value) == null ? void 0 : a.info) ?? void 0, renderTarget: "value-info-modal" }),
      g && /* @__PURE__ */ p(iat, { attrs: e.attrs, value: e.value })
    ] }) })
  ] });
}, os = {
  thumbnail: {
    gridArea: "Thumbnail",
    width: "100px",
    height: "100px",
    placeSelf: "start",
    overflow: "hidden"
    // AlignContent will be set based on showDescription and resulting centered or top down view
  },
  thumbnailVertical: {
    placeSelf: "start",
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "200px",
    overflow: "hidden"
  },
  gridAreaPrice: {
    gridArea: "Price",
    justifySelf: "end"
  },
  gridAreaInfo: {
    gridArea: "InfoIcon",
    justifySelf: "end"
    // AlignSelf will be set whether or not it should be centered next to label
  },
  gridAreaLabel: {
    gridArea: "Label",
    maxHeight: 100,
    overflow: "hidden"
  },
  gridAreaDescription: {
    gridArea: "Description",
    whiteSpace: "break-spaces",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
    // Styles for clamp, text align and place self will be added based on vertical or horizontal card style
  },
  gridAreaSpacer: {
    gridArea: "Spacer",
    // Grid Gap will be applied doubly here, bc it's a full width element technically.
    // Remove extra bottom margin to have url and price appear centered
    marginBottom: "-8px"
  },
  gridAreaUrl: {
    gridArea: "Url"
    // // Appear vertically centered with proper space to bottom or card.
    // minHeight: "32px",
  },
  gridUrlLink: {
    lineHeight: "32px;"
  },
  gridLabelText: {}
}, gat = (e, t) => {
  var a, d, C, u, A, m, h, B, f, G, y, W;
  if (typeof e.variableValue != typeof t.variableValue || e.verticalDisplay != t.verticalDisplay)
    return !1;
  const i = ((a = e.variableValue) == null ? void 0 : a.label) === ((d = t.variableValue) == null ? void 0 : d.label), n = Y0(e, t, "showDescription", "description"), g = Y0(e, t, "showUrl", "url"), r = Y0(e, t, "showValuePrice", "price") && e.price == t.price && e.isPriceCalculated == t.isPriceCalculated, o = ((C = e.variable) == null ? void 0 : C.attrs) == ((u = t.variable) == null ? void 0 : u.attrs) && ((A = e.variableValue) == null ? void 0 : A.attrs) == ((m = t.variableValue) == null ? void 0 : m.attrs) && Y0(e, t, "showInfo", "info"), I = Y0(e, t, "showThumbnail", "thumbnail"), s = typeof ((h = e.variableValue) == null ? void 0 : h.attrs) == typeof ((B = t.variableValue) == null ? void 0 : B.attrs) && ((G = (f = e.variableValue) == null ? void 0 : f.attrs) == null ? void 0 : G.map((V) => V.value).sort().join()) == ((W = (y = t.variableValue) == null ? void 0 : y.attrs) == null ? void 0 : W.map((V) => V.value).sort().join());
  return i && n && g && o && I && s && r;
}, x$ = Se.memo(({
  templateOptions: e,
  variableValue: t,
  variable: i,
  disableThumb: n,
  verticalDisplay: g,
  price: r,
  isPriceCalculated: o,
  children: I,
  ...s
}) => {
  var M, $, q, E;
  const a = ["colorDropdown", "colorRadio", "colorRadioCard", "colorSelect"].includes((M = i == null ? void 0 : i.settings) == null ? void 0 : M.template), {
    showLabel: d,
    showDescription: C,
    showInfo: u,
    showInfoContent: A,
    showValuePrice: m,
    showThumbnail: h,
    showUrl: B
  } = e || {}, f = !n && !["colorSelect", "selectThumbs"].includes(($ = i == null ? void 0 : i.settings) == null ? void 0 : $.template) && (a || h), G = (t == null ? void 0 : t.infoContent) && A, y = u || !!((E = (q = i == null ? void 0 : i.attrs) == null ? void 0 : q.filter((L) => !!L.displayed)) != null && E.length), W = m && (B || C), V = !g && sat(e, !!f);
  function w() {
    const L = f ? "Thumbnail" : "Label", P = y ? "InfoIcon" : "Label";
    let Q = V ? '"Label' : `"${L} Label ${P}"`, te = "auto", le = V ? "1fr" : "auto 1fr auto";
    if (V && (y && m ? (Q += ' Price InfoIcon"', le += " auto auto") : m || y ? (Q += ` ${m ? "Price" : "InfoIcon"}"`, le += " auto") : Q += '"'), C && (Q += `"${f ? "Thumbnail" : "Description"} Description Description"`, te += " minmax(10px, 1fr)"), G && (Q += `"div1 div1 div1"
                 "infoContent infoContent infoContent"`, te += " auto"), (B || W) && (Q += `"Spacer Spacer Spacer"
    "Url Url Price"`, te += " auto"), m && !W && !V) {
      const Ae = P == "Label" ? "Price" : "Label";
      Q += `"${L} ${Ae} Price"`, te += " auto";
    }
    return {
      template: Q,
      rows: te,
      cols: le
    };
  }
  function v() {
    let P = `"Thumbnail Thumbnail" 2fr
    "Label ${y ? "InfoIcon" : "Label"}" minmax(0, max-content)
    "Description Description"minmax(0, max-content)`, Q = "auto 1fr auto";
    return (m || B) && (P += `"Spacer Spacer" minmax(0, min-content)
        "Url Price" minmax(0, min-content)`, Q += " auto auto"), {
      template: P,
      rows: Q,
      cols: "1fr 0px"
    };
  }
  const H = g ? {
    ...os.thumbnail,
    ...os.thumbnailVertical
  } : {
    ...os.thumbnail,
    alignContent: C ? "start" : "center"
  }, x = g ? v() : w(), N = y ? /* @__PURE__ */ p(nat, { attrs: (i == null ? void 0 : i.attrs) || void 0, value: t }) : null;
  return /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ ge(fe, { component: "div", className: Ve(
      "k3-value-grid",
      s.className
      //ToDO variableValue?.hasTouchedConflicts && "invalid-value",
    ), sx: {
      minHeight: "40px",
      height: "100%",
      width: "100%",
      display: "grid",
      gap: g ? "8px" : "8px 16px",
      gridTemplate: x.template,
      gridTemplateRows: x.rows,
      gridTemplateColumns: x.cols,
      alignItems: g ? "start" : "center"
    }, children: [
      f && a && (t != null && t.value) ? /* @__PURE__ */ p(fe, { component: "div", className: "k3-value-thumbnail k3-value-color", sx: {
        ...H,
        bgcolor: t == null ? void 0 : t.value,
        borderRadius: "8px"
      } }) : f && h && /* @__PURE__ */ p(fe, { component: "div", className: "k3-value-thumbnail k3-value-image", sx: {
        ...H,
        bgcolor: t == null ? void 0 : t.value
      }, children: !a && /* @__PURE__ */ p(R$, { sx: g ? {
        maxHeight: "200px"
      } : {
        // Align to top of parent container if it's not a centered view
        objectPosition: C ? "50% 0" : void 0,
        height: "min-content",
        // Needed for Safari...
        maxHeight: "100px"
      }, url: (t == null ? void 0 : t.thumbnail) ?? "https://placehold.co/200x200/" }) }),
      d && /* @__PURE__ */ p(lat, { value: t == null ? void 0 : t.label, verticalDisplay: g }),
      m && !W && /* @__PURE__ */ p(BM, { sx: os.gridAreaPrice, price: (t == null ? void 0 : t.price) || (r == null ? void 0 : r.valuePrice), surCharges: t != null && t.price ? null : r == null ? void 0 : r.surCharges, isPriceLoading: o == !1, verticalDisplay: g }),
      C && /* @__PURE__ */ p(Iat, { value: t == null ? void 0 : t.description, verticalDisplay: g }),
      (t == null ? void 0 : t.infoContent) != null && (i == null ? void 0 : i.settings.templateOptions.showInfoContent) && /* @__PURE__ */ p(rat, { value: t.infoContent }),
      (m && W || B) && /* @__PURE__ */ p(bs, { sx: os.gridAreaSpacer, className: "k3-value-footer" }),
      B && /* @__PURE__ */ p(oat, { value: t == null ? void 0 : t.url }),
      m && W && /* @__PURE__ */ p(BM, { sx: os.gridAreaPrice, price: (t == null ? void 0 : t.price) || (r == null ? void 0 : r.valuePrice), surCharges: t != null && t.price ? null : r == null ? void 0 : r.surCharges, isPriceLoading: o == !1, verticalDisplay: g }),
      y && /* @__PURE__ */ p(fe, { component: "div", className: "k3-value-info", sx: {
        ...os.gridAreaInfo,
        paddingRight: g ? 0 : "8px",
        alignSelf: V ? "center" : "start"
      }, children: N && /* @__PURE__ */ p(fe, { component: "div", children: N }) })
    ] }),
    I
  ] });
}, gat), rat = (e) => /* @__PURE__ */ ge(Bt, { children: [
  /* @__PURE__ */ p(bs, { sx: {
    gridArea: "div1"
  } }),
  /* @__PURE__ */ p(Ne, { component: "div", variant: "caption", gridArea: "infoContent", children: /* @__PURE__ */ p(Rc, { htmlString: e.value || "", renderTarget: "value-card-content" }) })
] }), oat = (e) => /* @__PURE__ */ p(fe, { component: "div", className: "k3-value-url", sx: os.gridAreaUrl, children: !!e.value && /* @__PURE__ */ p(as, { "data-cy": `valueDetails-${e.value}`, align: "left", variant: "caption", href: e.value, target: "_blank", onClick: (t) => {
  t.stopPropagation;
}, sx: os.gridUrlLink, children: e.value }) }), Iat = (e) => /* @__PURE__ */ p(fe, { component: "div", className: "k3-value-description", sx: {
  ...os.gridAreaDescription,
  textAlign: e.verticalDisplay ? "center" : "left",
  // In vertical view, do not crop description
  WebkitLineClamp: e.verticalDisplay ? "initial" : "3",
  placeSelf: e.verticalDisplay ? "start center" : "start"
}, children: /* @__PURE__ */ p(Ne, { variant: "caption", children: e.value }) }), lat = (e) => /* @__PURE__ */ p(fe, { component: "div", sx: {
  ...os.gridAreaLabel,
  textAlign: e.verticalDisplay ? "center" : "left",
  padding: e.verticalDisplay ? "0 12px" : void 0
}, className: "k3-value-label", "data-cy": "valueDetail-" + e.value, children: /* @__PURE__ */ p(
  Ne,
  {
    variant: "subtitle1",
    fontWeight: 500,
    noWrap: !e.verticalDisplay,
    children: e.value
  }
) }), Y0 = (e, t, i, n) => {
  var o, I, s;
  const g = e.templateOptions[i] == t.templateOptions[i], r = ((o = e.variableValue) == null ? void 0 : o[n]) == ((I = t.variableValue) == null ? void 0 : I[n]);
  return g && r || !g && !((s = t.variableValue) != null && s[n]);
}, sat = (e, t) => e.showLabel && !e.showDescription && !e.showInfoContent && // showThumbnail can be false but still a thumbnail is displayed in grid when it's a color template.
!t && !e.showUrl, D$ = "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", aat = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), ZM = typeof window < "u" && window.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", aat(D$)], { type: "text/javascript;charset=utf-8" });
function cat(e) {
  let t;
  try {
    if (t = ZM && (window.URL || window.webkitURL).createObjectURL(ZM), !t)
      throw "";
    const i = new Worker(t, {
      type: "module",
      name: e == null ? void 0 : e.name
    });
    return i.addEventListener("error", () => {
      (window.URL || window.webkitURL).revokeObjectURL(t);
    }), i;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + D$,
      {
        type: "module",
        name: e == null ? void 0 : e.name
      }
    );
  }
}
const gB = new cat(), dat = () => {
  const e = _(E1), t = _((i) => i);
  return et(() => {
    gB.postMessage({
      type: "initiate",
      state: t
    });
  }, [e]), null;
}, Cat = (e) => {
  const t = Li(), i = _($d(e == null ? void 0 : e.id)), n = elt(e == null ? void 0 : e.variableId), {
    priceTotal: g
  } = _((A) => i ? nV(i == null ? void 0 : i.variableId, t)(A) : {
    priceTotal: 0
  }), [r, o] = Se.useState(!1), [I, s] = Se.useState(null), a = _(iC), [d, C] = Se.useState(null), u = () => {
    if (d == null)
      return null;
    const A = eA(d).priceTotal, m = nV(e == null ? void 0 : e.variableId, t)(d).priceTotal;
    let h = 0, B = 0;
    return (n == null ? void 0 : n.type) === Bn.Components || (n == null ? void 0 : n.type) === Bn.MultiSelect ? (h = gs(+(A - a)), B = gs(m - g)) : (h = gs(+(A - a + (g ?? 0))), B = m), g == 0 && m == 0 ? {
      valuePrice: h,
      surCharges: 0,
      totalValuePrice: h
    } : {
      valuePrice: B,
      surCharges: h - B,
      totalValuePrice: h
    };
  };
  return et(() => {
    d != null && (s(u()), o(!0));
  }, [d]), et(() => {
    const A = kQ(), m = (h) => {
      if (i) {
        if (h.data.type, h.data.type == `update#${i == null ? void 0 : i.id}_${t.id}`)
          if (h.data.state === "reset")
            o(!1), s(null);
          else if (h.data.state === "done") {
            const B = h.data.newState;
            C(B);
          } else
            console.warn("Unknown state in price worker:" + h.data);
      } else
        C(null);
    };
    return gB.addEventListener("message", m), gB.postMessage({
      type: "register",
      value: i,
      referenceId: A,
      openInstance: t
    }), () => {
      gB.removeEventListener("message", m), gB.postMessage({
        type: "unregister",
        referenceId: A,
        value: i,
        openInstance: t
      });
    };
  }, [i, t]), {
    price: I,
    isPriceCalculated: r
  };
};
var Sx = /* @__PURE__ */ new Map(), YW = /* @__PURE__ */ new WeakMap(), fM = 0, uat = void 0;
function Aat(e) {
  return e ? (YW.has(e) || (fM += 1, YW.set(e, fM.toString())), YW.get(e)) : "0";
}
function bat(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? Aat(e.root) : e[t]}`).toString();
}
function mat(e) {
  const t = bat(e);
  let i = Sx.get(t);
  if (!i) {
    const n = /* @__PURE__ */ new Map();
    let g;
    const r = new IntersectionObserver((o) => {
      o.forEach((I) => {
        var s;
        const a = I.isIntersecting && g.some((d) => I.intersectionRatio >= d);
        e.trackVisibility && typeof I.isVisible > "u" && (I.isVisible = a), (s = n.get(I.target)) == null || s.forEach((d) => {
          d(a, I);
        });
      });
    }, e);
    g = r.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), i = {
      id: t,
      observer: r,
      elements: n
    }, Sx.set(t, i);
  }
  return i;
}
function hat(e, t, i = {}, n = uat) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const s = e.getBoundingClientRect();
    return t(n, {
      isIntersecting: n,
      target: e,
      intersectionRatio: typeof i.threshold == "number" ? i.threshold : 0,
      time: 0,
      boundingClientRect: s,
      intersectionRect: s,
      rootBounds: s
    }), () => {
    };
  }
  const { id: g, observer: r, elements: o } = mat(i), I = o.get(e) || [];
  return o.has(e) || o.set(e, I), I.push(t), r.observe(e), function() {
    I.splice(I.indexOf(t), 1), I.length === 0 && (o.delete(e), r.unobserve(e)), o.size === 0 && (r.disconnect(), Sx.delete(g));
  };
}
function pat({
  threshold: e,
  delay: t,
  trackVisibility: i,
  rootMargin: n,
  root: g,
  triggerOnce: r,
  skip: o,
  initialInView: I,
  fallbackInView: s,
  onChange: a
} = {}) {
  var d;
  const [C, u] = Y.useState(null), A = Y.useRef(), [m, h] = Y.useState({
    inView: !!I,
    entry: void 0
  });
  A.current = a, Y.useEffect(
    () => {
      if (o || !C)
        return;
      let y;
      return y = hat(
        C,
        (W, V) => {
          h({
            inView: W,
            entry: V
          }), A.current && A.current(W, V), V.isIntersecting && r && y && (y(), y = void 0);
        },
        {
          root: g,
          rootMargin: n,
          threshold: e,
          // @ts-ignore
          trackVisibility: i,
          // @ts-ignore
          delay: t
        },
        s
      ), () => {
        y && y();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      C,
      g,
      n,
      r,
      o,
      i,
      s,
      t
    ]
  );
  const B = (d = m.entry) == null ? void 0 : d.target, f = Y.useRef();
  !C && B && !r && !o && f.current !== B && (f.current = B, h({
    inView: !!I,
    entry: void 0
  }));
  const G = [u, m.inView, m.entry];
  return G.ref = G[0], G.inView = G[1], G.entry = G[2], G;
}
const fc = (e) => {
  var g;
  const t = (g = hi(e.variable)) == null ? void 0 : g.showValuePrice, {
    ref: i,
    inView: n
  } = pat({
    threshold: 0,
    triggerOnce: !0
  });
  return /* @__PURE__ */ p("div", { ref: i, style: {
    width: "100%",
    height: "100%",
    ...e.style
  }, children: t && n && !e.variableValue.price ? /* @__PURE__ */ p(Bat, { ...e }) : /* @__PURE__ */ p(x$, { ...e }) });
}, Bat = (e) => {
  const {
    price: t,
    isPriceCalculated: i
  } = Cat(e.variableValue);
  return /* @__PURE__ */ p(x$, { ...e, price: t, isPriceCalculated: i && t != null });
}, GM = {
  root: {},
  rootDense: {
    p: 0
  }
}, yB = ({
  templateOptions: e,
  variable: t,
  variableValue: i,
  dense: n = !1,
  value: g,
  itemInvalid: r,
  ...o
}) => /* @__PURE__ */ ge(bd, { sx: {
  ...n ? GM.rootDense : GM.root,
  "&:hover": {
    background: "unset"
  },
  textWrap: "wrap",
  ...r ? v$ : void 0
}, value: g, selected: o.selected, className: Ve("k3-select-menu-item", r && "invalid-option"), ...o, children: [
  o.children,
  /* @__PURE__ */ p(aA, { invalid: r, children: /* @__PURE__ */ p(fc, { variable: t, variableValue: i, templateOptions: e }) })
] }), Zat = (e) => {
  const {
    palette: t
  } = qo(), i = (g, r) => {
    var o;
    return r ? e.onSelectionChanged(r, (o = e.options) == null ? void 0 : o.find((I) => I.id == r)) : e.onSelectionChanged();
  }, n = e.orientation == "horizontal" && e.colCount && e.colCount > 1 ? 100 / e.colCount - 1 : 100;
  return /* @__PURE__ */ p(fe, { component: "div", className: Ve("k3-selection-cards-container", e.className), children: /* @__PURE__ */ p(uD, { value: e.currentValue, exclusive: !0, sx: {
    gap: 1,
    flexWrap: "wrap"
  }, orientation: e.orientation ?? "vertical", onChange: i, "aria-label": "Selection Group", className: "k3-selection-group", fullWidth: e.fullWidth, "data-cy": e.dataCy ?? "k3-selection-group", children: e.options.map((g) => /* @__PURE__ */ p(l1, { "data-cy": g.dataCy ?? `k3-selection-option-${g.label}`, fullWidth: n == 100, value: g == null ? void 0 : g.id, disabled: g.disabled, color: "primary", className: Ve("k3-selection-button", g.className, e.currentValue !== g.id && "selected"), sx: {
    "&.MuiToggleButton-root": {
      background: "unset"
    },
    "&.MuiToggleButton-root:hover": {
      background: "unset",
      borderColor: `${t.action.active} !important`
    },
    "&.MuiToggleButton-root:active": {
      background: "unset"
    },
    "&.MuiToggleButton-root.Mui-selected": {
      background: "unset",
      color: "text.primary",
      outline: "2px solid",
      outlineOffset: "-2px",
      outlineColor: `${t.primary.main} !important`,
      borderColor: `${t.primary.main} !important`
    },
    border: `1px solid ${t.action.disabled} !important`,
    borderRadius: "8px  !important",
    justifyContent: "flex-start",
    padding: 2,
    textAlign: "left",
    width: `${n}%`
  }, children: g.renderCardDetails(g) }, g == null ? void 0 : g.id)) }) });
};
var BK = {}, fat = Cg;
Object.defineProperty(BK, "__esModule", {
  value: !0
});
var J$ = BK.default = void 0, Gat = fat(Kg()), yat = xg;
J$ = BK.default = (0, Gat.default)(/* @__PURE__ */ (0, yat.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const ZK = ({
  onSelected: e,
  variable: t,
  addItemLabel: i,
  value: n,
  values: g,
  touchedInvalidOptionsIds: r
}) => {
  const o = un(), I = {
    id: 0,
    label: i || o("translation_mp_popup_add"),
    appId: t.appId,
    variableId: t.id,
    value: "0",
    sort: 0
  };
  return /* @__PURE__ */ ge(
    uS,
    {
      "data-cy": "componentList",
      label: "",
      value: (n == null ? void 0 : n.id.toString()) || "0",
      onChange: (s) => {
        const a = g.find((d) => d.id == +s);
        a && (e == null || e(a));
      },
      SelectProps: {
        inputProps: {
          sx: {
            p: 1
          }
        },
        renderValue: (s) => {
          const a = s == 0 ? I : g.find((d) => d.id == s);
          return a ? /* @__PURE__ */ p(yB, { dense: !0, value: s, variableValue: a, templateOptions: {
            showLabel: !0
          } }) : null;
        }
      },
      children: [
        /* @__PURE__ */ p(yB, { value: 0, variableValue: I, templateOptions: {
          showLabel: !0
        } }),
        g.map((s) => /* @__PURE__ */ p(yB, { value: s.id, variable: t, variableValue: s, templateOptions: t == null ? void 0 : t.settings.templateOptions, itemInvalid: (r == null ? void 0 : r.includes(s.id)) || !1 }, s.id))
      ]
    }
  );
}, hV = ({
  onSelected: e,
  variable: t,
  addItemLabel: i,
  value: n,
  fullWidth: g,
  colCount: r,
  verticalValueDisplay: o,
  values: I,
  touchedInvalidOptionsIds: s
}) => {
  const a = (d) => d ? I == null ? void 0 : I.find((C) => C.id.toString() == d) : null;
  return /* @__PURE__ */ p(Zat, { "data-cy": "add-item-cards", className: "add-item-selection", orientation: "horizontal", currentValue: (n == null ? void 0 : n.id.toString()) || "0", onSelectionChanged: (d) => {
    const C = a(d);
    C && (e == null || e(C));
  }, fullWidth: g, colCount: r, options: I == null ? void 0 : I.map((d) => ({
    id: d.id.toString(),
    label: d.label || "",
    renderCardDetails: (C) => /* @__PURE__ */ p(aA, { invalid: (s == null ? void 0 : s.includes(d == null ? void 0 : d.id)) || !1, children: /* @__PURE__ */ p(fc, { verticalDisplay: o, value: C.id, variable: t, variableValue: a(C.id), templateOptions: t == null ? void 0 : t.settings.templateOptions }, C.id) })
  })) });
}, K$ = (e) => {
  const t = hi(e.variable), i = _(ng), n = je(() => (o) => {
    if (o) {
      const I = typeof o == "object" ? Eu(o, i) : o.toString();
      if (I)
        return I;
    }
    return e.defaultGroupLabel;
  }, [i]), g = (o) => {
    var s;
    const I = (s = o.attrs) == null ? void 0 : s.find((a) => a.attrId == t.groupBy);
    return n(I == null ? void 0 : I.value);
  }, r = je(() => {
    const o = {};
    return e.values.map((I) => {
      const s = g(I);
      o[s] ? o[s].push(I) : o[s] = [I];
    }), o;
  }, [i, e.values, t.groupBy]);
  return Object.keys(r).length ? /* @__PURE__ */ p(fe, { component: "div", "data-cy": "groupsWrapper", children: Object.keys(r).map((o) => /* @__PURE__ */ ge(M5, { "data-cy": "group-" + o, children: [
    /* @__PURE__ */ p(P5, { expandIcon: /* @__PURE__ */ p(J$, {}), "aria-controls": "panel1bh-content", id: "panel1bh-header", children: /* @__PURE__ */ p(Ne, { variant: "subtitle1", children: o }) }),
    /* @__PURE__ */ p(U5, { children: /* @__PURE__ */ p(hV, { variable: e.variable, onSelected: e.onSelected, fullWidth: !0, value: void 0, colCount: e.colCount, verticalValueDisplay: e.verticalValueDisplay, values: r[o], touchedInvalidOptionsIds: e.touchedInvalidOptionsIds }) })
  ] }, o)) }) : /* @__PURE__ */ p(hV, { variable: e.variable, onSelected: e.onSelected, fullWidth: !0, value: void 0, colCount: e.colCount, verticalValueDisplay: e.verticalValueDisplay, values: e.values, touchedInvalidOptionsIds: e.touchedInvalidOptionsIds });
};
var fK = {}, Wat = Cg;
Object.defineProperty(fK, "__esModule", {
  value: !0
});
var E$ = fK.default = void 0, Sat = Wat(Kg()), Vat = xg;
E$ = fK.default = (0, Sat.default)(/* @__PURE__ */ (0, Vat.jsx)("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");
const wat = /* @__PURE__ */ p(PO, { animation: "wave", variant: "rounded", width: 400, height: 300 });
function vat({
  label: e,
  description: t,
  view: i = wat
}) {
  return /* @__PURE__ */ ge(_t, { gap: 0.5, direction: "column", children: [
    /* @__PURE__ */ p(Ne, { variant: "h6", className: "k3-variable-header", children: e }),
    !!t && /* @__PURE__ */ p(Ne, { variant: "subtitle1", className: "k3-variable-description", children: /* @__PURE__ */ p(Rc, { htmlString: t || "", renderTarget: "Variable-desc" }) }),
    /* @__PURE__ */ p(_t, { className: "k3-variable-content", children: i })
  ] });
}
const N$ = ({
  variable: e,
  sx: t
}) => {
  const [i, n] = At(!1);
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(Y$, { onClick: () => n(!i), className: "k3-variable-info-button", "data-cy": `varInfo-${e == null ? void 0 : e.id}`, sx: t || {
      height: "24px",
      lineHeight: "24px"
    } }),
    /* @__PURE__ */ p($1, { className: "variableInfoDialog k3-variable-info-modal", show: i, onClose: () => n(!1), type: "info", title: e == null ? void 0 : e.label, children: /* @__PURE__ */ p(Ne, { children: /* @__PURE__ */ p(Rc, { htmlString: e == null ? void 0 : e.info, renderTarget: "variable-info" }) }) })
  ] });
}, Rat = ({
  variable: e
}) => {
  const t = Li(), i = _(Wa), {
    priceTotal: n
  } = _(nV(e.id || 0, t)), g = i.format(n);
  return /* @__PURE__ */ p(Ne, { variant: "inherit", className: "k3-variable-price", "data-cy": "simpleVariablePrice", children: g });
}, Xat = ({
  variable: e,
  fullWidth: t = !1,
  showLabel: i
}) => {
  const n = hi(e);
  return /* @__PURE__ */ ge("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  }, children: [
    i && /* @__PURE__ */ p(Ne, { variant: "inherit", "data-cy": "simpleVariableLabel", className: "k3-variable-label", sx: {
      alignSelf: "center",
      whiteSpace: "wrap",
      ...t ? {
        width: 1
      } : {}
    }, children: e == null ? void 0 : e.label }),
    Xfe(e) && (e == null ? void 0 : e.info) && /* @__PURE__ */ p(N$, { variable: e }),
    n.showPrice && /* @__PURE__ */ p(Rat, { variable: e })
  ] });
}, pr = ({
  variable: e,
  fullWidth: t,
  showLabel: i = !0,
  className: n,
  view: g
}) => {
  const r = Hn(hs), o = je(() => (r.extendVariableLabel || ce.identity)((s) => /* @__PURE__ */ ge(_t, { direction: "row", alignItems: "center", "data-cy": "simpleVariableLabelBox", className: Ve("k3-variable-label-container", n), children: [
    /* @__PURE__ */ p(Xat, { variable: s.variable, fullWidth: t, showLabel: i }),
    s.children
  ] })), [n, r.extendVariableLabel, t, i]);
  return /* @__PURE__ */ p(vat, { label: o && /* @__PURE__ */ p(o, { variable: e }), description: e.description, view: g });
}, rI = (e) => (t) => {
  var g, r, o, I;
  const i = hi(t.variable);
  if (!t.dontHide) {
    if (i != null && i.hideAlways || i != null && i.hideIfNoOptions && (((g = t.validOptions) == null ? void 0 : g.length) || 0) === 0)
      return null;
    if (i != null && i.hideIfSingleOption && (((r = t.validOptions) == null ? void 0 : r.length) || 0) <= 1)
      if (eI(t.variable)) {
        const s = (o = t.validOptions[0]) == null ? void 0 : o.value;
        if (fQ(s))
          return null;
      } else
        return null;
  }
  const n = t.disabled || (i == null ? void 0 : i.disableIfSingleOption) && (((I = t.validOptions) == null ? void 0 : I.length) || 0) <= 1;
  return /* @__PURE__ */ p(e, { ...t, disabled: n });
};
var Hat = { VITE_API_URL: "https://k3-api.objectcode.de", VITE_DOC_URL: "https://oc-k3.s3.amazonaws.com/assets", VITE_HELP_URL: "https://k3.objectcode.de/help", VITE_LIBS_URL: "https://oc-k3.s3.eu-central-1.amazonaws.com/libs/", VITE_ADMIN_ANALYTICS: "", VITE_BUGSNAG_KEY: "eb59c05f71245a5aab4cf185a21eca08", VITE_SHOPIFY_K3_LINK_ID: "d60dd7c1-6a43-459f-8d58-84ab6998b18f", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const yM = (e) => {
  let t;
  const i = /* @__PURE__ */ new Set(), n = (d, C) => {
    const u = typeof d == "function" ? d(t) : d;
    if (!Object.is(u, t)) {
      const A = t;
      t = C ?? (typeof u != "object" || u === null) ? u : Object.assign({}, t, u), i.forEach((m) => m(t, A));
    }
  }, g = () => t, s = { setState: n, getState: g, getInitialState: () => a, subscribe: (d) => (i.add(d), () => i.delete(d)), destroy: () => {
    (Hat ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), i.clear();
  } }, a = t = e(n, g, s);
  return s;
}, kat = (e) => e ? yM(e) : yM;
var L$ = { exports: {} }, T$ = {}, M$ = { exports: {} }, U$ = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nm = Se;
function Fat(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Yat = typeof Object.is == "function" ? Object.is : Fat, xat = Nm.useState, Dat = Nm.useEffect, Jat = Nm.useLayoutEffect, Kat = Nm.useDebugValue;
function Eat(e, t) {
  var i = t(), n = xat({ inst: { value: i, getSnapshot: t } }), g = n[0].inst, r = n[1];
  return Jat(function() {
    g.value = i, g.getSnapshot = t, lF(g) && r({ inst: g });
  }, [e, i, t]), Dat(function() {
    return lF(g) && r({ inst: g }), e(function() {
      lF(g) && r({ inst: g });
    });
  }, [e]), Kat(i), i;
}
function lF(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var i = t();
    return !Yat(e, i);
  } catch {
    return !0;
  }
}
function Nat(e, t) {
  return t();
}
var Lat = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Nat : Eat;
U$.useSyncExternalStore = Nm.useSyncExternalStore !== void 0 ? Nm.useSyncExternalStore : Lat;
M$.exports = U$;
var Tat = M$.exports;
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d2 = Se, Mat = Tat;
function Uat(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Pat = typeof Object.is == "function" ? Object.is : Uat, zat = Mat.useSyncExternalStore, Oat = d2.useRef, Qat = d2.useEffect, jat = d2.useMemo, _at = d2.useDebugValue;
T$.useSyncExternalStoreWithSelector = function(e, t, i, n, g) {
  var r = Oat(null);
  if (r.current === null) {
    var o = { hasValue: !1, value: null };
    r.current = o;
  } else
    o = r.current;
  r = jat(function() {
    function s(A) {
      if (!a) {
        if (a = !0, d = A, A = n(A), g !== void 0 && o.hasValue) {
          var m = o.value;
          if (g(m, A))
            return C = m;
        }
        return C = A;
      }
      if (m = C, Pat(d, A))
        return m;
      var h = n(A);
      return g !== void 0 && g(m, h) ? m : (d = A, C = h);
    }
    var a = !1, d, C, u = i === void 0 ? null : i;
    return [function() {
      return s(t());
    }, u === null ? void 0 : function() {
      return s(u());
    }];
  }, [t, i, n, g]);
  var I = zat(e, r[0], r[1]);
  return Qat(function() {
    o.hasValue = !0, o.value = I;
  }, [I]), _at(I), I;
};
L$.exports = T$;
var $at = L$.exports;
const qat = /* @__PURE__ */ Tr($at);
var P$ = { VITE_API_URL: "https://k3-api.objectcode.de", VITE_DOC_URL: "https://oc-k3.s3.amazonaws.com/assets", VITE_HELP_URL: "https://k3.objectcode.de/help", VITE_LIBS_URL: "https://oc-k3.s3.eu-central-1.amazonaws.com/libs/", VITE_ADMIN_ANALYTICS: "", VITE_BUGSNAG_KEY: "eb59c05f71245a5aab4cf185a21eca08", VITE_SHOPIFY_K3_LINK_ID: "d60dd7c1-6a43-459f-8d58-84ab6998b18f", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue: ect } = Se, { useSyncExternalStoreWithSelector: tct } = qat;
let WM = !1;
const ict = (e) => e;
function nct(e, t = ict, i) {
  (P$ ? "production" : void 0) !== "production" && i && !WM && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), WM = !0);
  const n = tct(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    i
  );
  return ect(n), n;
}
const gct = (e) => {
  (P$ ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? kat(e) : e, i = (n, g) => nct(t, n, g);
  return Object.assign(i, t), i;
}, rct = (e) => gct, RI = rct()((e, t) => ({
  hoveredSelections: [],
  hasHoveredSelection: (i) => t().hoveredSelections.includes(i),
  setHoveredSelection: (i) => {
    e({
      hoveredSelections: [i]
    });
  },
  addHoveredSelection: (i) => {
    e((n) => ({
      hoveredSelections: ce.uniq([...n.hoveredSelections, i])
    }));
  },
  removeHoveredSelection: (i) => {
    e((n) => ({
      hoveredSelections: n.hoveredSelections.filter((g) => g !== i)
    }));
  },
  removeAllHoveredSelections: () => {
    e({
      hoveredSelections: []
    });
  }
})), oct = function({
  group: e,
  variables: t
}) {
  var g;
  const i = Hn(hs), n = (g = i.extendAdditionalVars) == null ? void 0 : g.call(i, () => null);
  return n ? /* @__PURE__ */ p(n, { group: e, variables: t }) : null;
}, SM = {
  hiddenContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 1,
    opacity: 0.5,
    filter: "grayscale(1)",
    border: "2px black solid",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none"
  },
  hiddenBackground: {
    background: (e) => `repeating-linear-gradient(
45deg,
${e.palette.warning.main},
${e.palette.warning.main} 10px,
${e.palette.warning.dark} 10px,
${e.palette.warning.dark} 20px
)`
  }
}, z$ = (e) => (t) => {
  const {
    t: i
  } = ii(), n = _(B1(t.variable, t.contextInstance.id));
  return n !== null ? /* @__PURE__ */ ge(fe, { component: "div", className: "k3-variable-hidden-container", sx: {
    position: "relative",
    ...n.reason === OS.NoValidValue ? {
      height: 100
    } : {},
    minHeight: 50,
    whiteSpace: "pre-line"
  }, children: [
    /* @__PURE__ */ p(e, { ...t, dontHide: !0 }),
    /* @__PURE__ */ p(Cn, { title: /* @__PURE__ */ p(fe, { component: "div", style: {
      whiteSpace: "pre-line"
    }, children: i(n.text) }), children: /* @__PURE__ */ p(fe, { component: "div", className: "k3-variable-hidden-background", sx: [SM.hiddenBackground, SM.hiddenContainer], children: /* @__PURE__ */ p(Uj, {}) }) })
  ] }) : /* @__PURE__ */ p(e, { ...t });
}, Ict = {
  fullWidth: {
    width: 1,
    marginLeft: 0,
    "& .MuiFormControlLabel-label": {
      width: 1
    }
  }
}, GK = (e) => {
  const {
    fullWidth: t,
    "data-cy": i,
    label: n,
    onChange: g,
    ...r
  } = e, o = (I) => {
    g(I.target.checked);
  };
  return /* @__PURE__ */ p(e1, { "data-cy": i + "label", sx: t ? Ict.fullWidth : {}, label: n, control: /* @__PURE__ */ p(
    qm,
    {
      "data-cy": i + "check",
      inputProps: {
        "data-cy": i + "checkInput"
      },
      ...r,
      onChange: o
    }
  ) });
}, VM = (e) => {
  switch (e == null ? void 0 : e.value) {
    case "0":
      return !1;
    case "1":
      return !0;
    default:
      return !!(e != null && e.value);
  }
}, Cf = (e, t, i) => ({
  onBooleanChange: ft((g) => {
    me.flow(me.find((r) => VM(r) === g), (r) => r == null ? void 0 : r.id, e)(i);
  }, [e, i]),
  checked: VM(t)
}), lct = ({
  variable: e,
  value: t,
  onChange: i,
  values: n
}) => {
  const {
    checked: g,
    onBooleanChange: r
  } = Cf(i, t, n);
  return /* @__PURE__ */ p(pr, { variable: e, view: /* @__PURE__ */ p(GK, { "data-cy": `varCheck-${e.id}`, fullWidth: !0, value: g, onChange: r }) });
}, sct = no("checkbox")(lct);
function O$(e) {
  var t = { analogous: [-30, 0, 30], complementary: [0, 180], "double-split-complementary": [-30, 0, 30, 150, 210], rectangle: [0, 60, 180, 240], tetradic: [0, 90, 180, 270], triadic: [0, 120, 240], "split-complementary": [0, 150, 210] };
  e.prototype.harmonies = function(i) {
    var n = this;
    return i === void 0 && (i = "complementary"), t[i].map(function(g) {
      return n.rotate(g);
    });
  };
}
const Q$ = Sl(({
  disabled: e,
  hexColor: t,
  isActive: i,
  onClick: n = me.noop,
  children: g,
  borderRadius: r = 2,
  thumbnail: o,
  width: I = "100%",
  height: s = "100%",
  className: a,
  columnCount: d = 4,
  label: C,
  invalid: u
}, A) => {
  const {
    palette: m
  } = qo(), h = je(() => d < 4 ? "12px" : d < 8 ? "8px" : "6px", []);
  return /* @__PURE__ */ p(Tst, { optionTitle: C ?? "", invalid: u, children: /* @__PURE__ */ p(fo, { "data-cy": "colorButton", ref: A, disabled: e, onClick: n, className: Ve("k3-color-button", !!e && "disabled", !!i && "selected", u && "invalid-option", a), sx: {
    width: I,
    height: s,
    padding: h,
    outline: i ? "2px solid" : "1px solid",
    outlineColor: i ? m.primary.main + "!important" : m.action.disabled,
    "&.MuiButtonBase-root:hover": {
      outlineColor: m.action.active
    },
    backgroundImage: o ? `url(${o})` : "",
    backgroundColor: o ? "" : t,
    backgroundOrigin: "content-box",
    backgroundClip: "content-box",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    borderRadius: r
  }, children: g }) });
});
F8([O$]);
const act = ({
  variable: e,
  values: t,
  value: i,
  onChange: n,
  columnCount: g = 4,
  borderRadius: r = 1,
  disabled: o = !1,
  invalidIds: I
}) => {
  const s = Ct(null), a = hi(e), {
    showLabel: d,
    showDescription: C,
    showInfo: u,
    showPrice: A,
    showUrl: m,
    showValue: h,
    showSelection: B,
    showInfoContent: f
  } = a || {};
  return /* @__PURE__ */ ge(_t, { direction: "column", gap: 2, className: "k3-thumbnail-container", children: [
    /* @__PURE__ */ p(fe, { component: "div", className: "k3-thumbnail-values", ref: s, sx: {
      display: "grid",
      width: "100%",
      padding: "2px 0",
      gridTemplateColumns: `repeat(${g}, 1fr)`,
      gridAutoRows: "1fr",
      gap: 2,
      // places a hidden element to make grid items square
      "&::before": {
        content: '""',
        width: "0",
        paddingBottom: "100%",
        gridRow: "1 / 1",
        gridColumn: "1 / 1"
      },
      // set first item to grid start
      "& > div:first-of-type": {
        gridRow: "1 / 1",
        gridColumn: "1 / 1"
      }
    }, children: t.map((G) => /* @__PURE__ */ p(Q$, { disabled: o, onClick: () => n == null ? void 0 : n(G.id || 0), isActive: (i == null ? void 0 : i.id) == G.id, hexColor: G.value, thumbnail: G == null ? void 0 : G.thumbnail, borderRadius: r, columnCount: g, className: "k3-thumbnail-color", label: G == null ? void 0 : G.label, invalid: (I == null ? void 0 : I.includes(G == null ? void 0 : G.id)) || !1 }, G.id)) }),
    (d || C || u || A || m || f || h || B) && /* @__PURE__ */ p(So, { elevation: 0, sx: {
      border: "2px solid ",
      borderColor: "primary.main",
      p: 2
    }, children: /* @__PURE__ */ p(fc, { variable: e, templateOptions: a, variableValue: i, disableThumb: !0 }) })
  ] });
}, uf = (e) => ({
  disabled: e.disabled,
  variable: e.variable,
  values: e.values || [],
  onChange: e.onChange,
  invalidIds: e.touchedInvalidOptionsIds
}), cct = ({
  value: e,
  ...t
}) => {
  const i = hi(t.variable), n = me.isNumber(i == null ? void 0 : i.borderRadius) ? i == null ? void 0 : i.borderRadius : 1;
  return /* @__PURE__ */ p(pr, { variable: t.variable, view: /* @__PURE__ */ p(act, { value: e, columnCount: i == null ? void 0 : i.numberOfColorsShown, borderRadius: n, ...uf(t) }) });
}, wM = me.flow(rI, no("colorSelect"))(cct), dct = ({
  variable: e,
  values: t,
  ...i
}) => _((g) => of(g, e.id)) ? /* @__PURE__ */ p(tte, { ...i, variable: e, values: t }) : /* @__PURE__ */ p(pr, { variable: e, className: "k3-component-list-variable k3-component-list-dropdown", view: /* @__PURE__ */ p(bE, { variable: e, values: t, ...i }) }), Cct = me.flow(rI, no("componentList"))(dct);
function j$({
  justifySelf: e,
  currentValue: t,
  onChange: i,
  placeholder: n
}) {
  const {
    t: g
  } = ii(), r = BJ();
  return /* @__PURE__ */ ge(So, { sx: {
    display: "flex",
    width: 300,
    justifySelf: e ?? "unset",
    justifyContent: "space-between",
    alignItems: "center"
  }, "data-cy": "searchField", children: [
    /* @__PURE__ */ p(mi, { type: "button", "aria-label": "Search", disabled: !0, "data-cy": "search", children: /* @__PURE__ */ p(Mj, {}) }),
    /* @__PURE__ */ p(_w, { value: t, id: "search-field", sx: {
      width: 170
    }, onChange: (o) => i(o.target.value), onKeyDown: (o) => {
      o.key === "Escape" && (i(""), o.currentTarget.blur());
    }, placeholder: n || g("Suchen") }),
    t ? /* @__PURE__ */ p(mi, { "data-cy": "clear", type: "button", "aria-label": "Search", onClick: () => i(""), sx: {
      ml: "auto"
    }, children: /* @__PURE__ */ p(LZ, {}) }) : /* @__PURE__ */ p(_t, { pr: 2, sx: {
      color: "action.active"
    }, children: /* @__PURE__ */ ge("kbd", { children: [
      r("Ctrl"),
      " + K"
    ] }) })
  ] });
}
const uct = ({
  variable: e,
  values: t,
  touchedInvalidOptionsIds: i,
  ...n
}) => {
  const g = un(), r = zt(), o = U1(), I = hi(e), s = _((x) => of(x, e.id)), [a, d] = At(!1), [C, u] = At(""), A = IA();
  if (s)
    return /* @__PURE__ */ p(tte, { ...n, variable: e, values: t });
  const m = (x) => {
    x && n.contextInstance && (r(sA(x, n.contextInstance)), d(!1), u(""));
  }, h = o("toggle_mp_dialog_hide_searchbar"), B = A ? "xl" : o("string_mp_dialog_size"), f = o("toggle_mp_dialog_component_cols"), G = A ? 1 : f > 0 ? f : 4, y = o("toggle_mp_dialog_component_display"), W = g("translation_mp_popup_description"), V = C ? t.filter((x) => {
    var N;
    return (N = x.label) == null ? void 0 : N.toLocaleLowerCase().includes(C.toLocaleLowerCase());
  }) : t;
  function w() {
    return /* @__PURE__ */ p(K$, { variable: e, onSelected: m, fullWidth: !0, value: void 0, colCount: G, verticalValueDisplay: y, values: V, defaultGroupLabel: g("translation_mp_popup_not_grouped"), touchedInvalidOptionsIds: i });
  }
  function v() {
    return /* @__PURE__ */ p(hV, { variable: e, onSelected: m, fullWidth: !0, value: void 0, colCount: G, verticalValueDisplay: y, values: V, touchedInvalidOptionsIds: i });
  }
  const H = ["translation_mp_popup_add", "translation_mp_popup_search", "translation_mp_popup_description", "translation_mp_popup_title", "translation_mp_popup_not_grouped", "toggle_mp_dialog_component_cols", "toggle_mp_dialog_hide_searchbar", "string_mp_dialog_size", "toggle_mp_dialog_component_display"];
  return /* @__PURE__ */ p(pr, { variable: e, className: "k3-component-list-variable k3-component-list-popup", view: /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(bE, { variable: e, values: t, addItemType: "popup", ...n, onAddItemClicked: () => d(!0), touchedInvalidOptionsIds: i }),
    /* @__PURE__ */ ge(_1, { show: a, onClose: () => d(!1), dataCy: "componentListPopup", maxWidth: B, title: g("translation_mp_popup_title"), settingKeys: H, className: "k3-add-items-popup", children: [
      /* @__PURE__ */ ge(fe, { sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "1rem",
        width: "100%",
        marginBottom: h ? "0" : "8px"
      }, component: "div", "data-cy": "header", children: [
        !!W && /* @__PURE__ */ p(Ne, { variant: "subtitle1", children: W }),
        !h && /* @__PURE__ */ p(j$, { currentValue: C, onChange: (x) => {
          u(x);
        }, placeholder: g("translation_mp_popup_search") })
      ] }),
      I.groupBy ? w() : v()
    ] })
  ] }) });
}, Act = ce.flow(rI, ki({
  app: {
    sidebar: {
      componentListPopup: {
        root: !0
      }
    }
  }
}))(uct), _$ = (e) => (t, i) => {
  const n = i(), g = Dg(n), r = Jg(n);
  if (!g || !r)
    return console.warn("Rule engine not initialized!"), r;
  const o = e.map((I, s) => ({
    ...I,
    sort: s
  }));
  return t(af(Trt(g, r.state, r.state.locked.selections.map((I) => o.find((a) => a.id === I.id) || I), !0)));
}, bct = (e, t, i) => (n, g) => {
  const r = g(), o = Dg(r), I = Jg(r);
  if (!o || !I) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const s = I2(o, I.state, i, o.values.byVarId.all[e.variableId].find((d) => d.id === e.valueId), t, e.data);
  if (!(!s || !n($$(e, s.lastManualChange, s, !0))))
    return s.lastManualChange;
}, $$ = (e, t, i, n = !0) => (g, r) => {
  const o = r(), I = Dg(o), s = Jg(o);
  if (!I || !s)
    return console.warn("Rule engine not initialized!"), s;
  const a = q$(I, I.variables.flat.all)(e, t, i || s);
  return a.lastManualChange = t, n && g(af(a)), a;
}, w9t = () => {
  const e = zt();
  return (t, i, n, g) => e($$(t, i, n, g));
}, q$ = (e, t) => (i, n, g) => {
  let r = g;
  const o = t.filter((s) => s.parentId === i.variableId), I = (s) => e.values.byVarId.all[s.variableId].find((a) => a.id === s.valueId);
  return o.forEach((s) => {
    const a = r.state.all.selections, d = a.filter((u) => u.variableId === s.id && bx(u) === i.id), C = a.filter((u) => u.variableId === s.id && bx(u) === n.id);
    if (kZ(s)) {
      const u = [];
      C.forEach((A) => {
        const m = If(r.state, A);
        m && (r = m);
      }), d.forEach((A) => {
        const m = I2(e, r.state, n, I(A), A.sort, A.data, !1);
        m && (r = m, u.push([A, m.lastManualChange]));
      }), u.forEach(([A, m]) => {
        r = q$(e, t)(A, m, r);
      });
    } else {
      const u = d[0], A = jJ(e, r.state, n, I(u), u.data, !1, !1);
      A && (r = A);
    }
  }), r;
};
function eq({
  onChange: e,
  values: t,
  disabled: i,
  variable: n,
  ExtraContent: g,
  ...r
}) {
  return /* @__PURE__ */ p(fs, { sx: {
    width: 1
  }, className: "k3-radio-cards-wrapper", children: /* @__PURE__ */ p(uD, { value: r.currentValueId, exclusive: !0, sx: {
    gap: 1
  }, orientation: "vertical", onChange: (o, I) => e == null ? void 0 : e(I || 0), "aria-label": "Text alignment", className: "k3-radio-cards", children: t.map((o) => {
    var I;
    return /* @__PURE__ */ p(tq, { value: o, disabled: i, variable: n, invalidItem: ((I = r.invalidIds) == null ? void 0 : I.includes(o == null ? void 0 : o.id)) || !1, isActive: r.currentValueId == o.id, children: g && /* @__PURE__ */ p(g, { value: o, variable: n }) }, o.id);
  }) }) });
}
const mct = (e) => ({
  "&.MuiToggleButton-root": {
    background: "unset"
  },
  "&.MuiToggleButton-root:hover": {
    background: "unset",
    borderColor: `${e.action.active} !important`
  },
  "&.MuiToggleButton-root:active": {
    background: "unset"
  },
  "&.MuiToggleButton-root.Mui-selected": {
    background: "unset",
    color: "text.primary",
    outline: "2px solid",
    outlineOffset: "-2px",
    outlineColor: `${e.primary.main} !important`,
    borderColor: `${e.primary.main} !important`
  },
  border: `1px solid ${e.action.disabled} !important`,
  borderRadius: "8px  !important",
  justifyContent: "flex-start",
  padding: 2,
  textAlign: "left"
});
function tq({
  value: e,
  variable: t,
  children: i,
  ...n
}) {
  const {
    palette: g
  } = qo(), r = je(() => mct(g), [g]), o = n.invalidItem;
  return /* @__PURE__ */ p(l1, { "data-cy": `card-${e.label}`, fullWidth: !0, value: e == null ? void 0 : e.id, disabled: n.disabled, sx: r, className: Ve("k3-radio-card", o && "invalid-option", n.isActive && "active selected"), children: /* @__PURE__ */ p(aA, { invalid: o, children: /* @__PURE__ */ p(fc, { value: e.id, variable: t, variableValue: e, templateOptions: t == null ? void 0 : t.settings.templateOptions, children: i }) }) });
}
function hct() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return je(
    () => (n) => {
      t.forEach((g) => g(n));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const C2 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function hh(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function yK(e) {
  return "nodeType" in e;
}
function Vo(e) {
  var t, i;
  return e ? hh(e) ? e : yK(e) && (t = (i = e.ownerDocument) == null ? void 0 : i.defaultView) != null ? t : window : window;
}
function WK(e) {
  const {
    Document: t
  } = Vo(e);
  return e instanceof t;
}
function Af(e) {
  return hh(e) ? !1 : e instanceof Vo(e).HTMLElement;
}
function iq(e) {
  return e instanceof Vo(e).SVGElement;
}
function ph(e) {
  return e ? hh(e) ? e.document : yK(e) ? WK(e) ? e : Af(e) || iq(e) ? e.ownerDocument : document : document : document;
}
const Wl = C2 ? Um : et;
function u2(e) {
  const t = Ct(e);
  return Wl(() => {
    t.current = e;
  }), ft(function() {
    for (var i = arguments.length, n = new Array(i), g = 0; g < i; g++)
      n[g] = arguments[g];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
function pct() {
  const e = Ct(null), t = ft((n, g) => {
    e.current = setInterval(n, g);
  }, []), i = ft(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, i];
}
function sZ(e, t) {
  t === void 0 && (t = [e]);
  const i = Ct(e);
  return Wl(() => {
    i.current !== e && (i.current = e);
  }, t), i;
}
function bf(e, t) {
  const i = Ct();
  return je(
    () => {
      const n = e(i.current);
      return i.current = n, n;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function pV(e) {
  const t = u2(e), i = Ct(null), n = ft(
    (g) => {
      g !== i.current && (t == null || t(g, i.current)), i.current = g;
    },
    //eslint-disable-next-line
    []
  );
  return [i, n];
}
function BV(e) {
  const t = Ct();
  return et(() => {
    t.current = e;
  }, [e]), t.current;
}
let sF = {};
function mf(e, t) {
  return je(() => {
    if (t)
      return t;
    const i = sF[e] == null ? 0 : sF[e] + 1;
    return sF[e] = i, e + "-" + i;
  }, [e, t]);
}
function nq(e) {
  return function(t) {
    for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), g = 1; g < i; g++)
      n[g - 1] = arguments[g];
    return n.reduce((r, o) => {
      const I = Object.entries(o);
      for (const [s, a] of I) {
        const d = r[s];
        d != null && (r[s] = d + e * a);
      }
      return r;
    }, {
      ...t
    });
  };
}
const fm = /* @__PURE__ */ nq(1), ZV = /* @__PURE__ */ nq(-1);
function Bct(e) {
  return "clientX" in e && "clientY" in e;
}
function A2(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Vo(e.target);
  return t && e instanceof t;
}
function Zct(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Vo(e.target);
  return t && e instanceof t;
}
function fV(e) {
  if (Zct(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: i
      } = e.touches[0];
      return {
        x: t,
        y: i
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: i
      } = e.changedTouches[0];
      return {
        x: t,
        y: i
      };
    }
  }
  return Bct(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const Lu = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: i
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (i ? Math.round(i) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: i
      } = e;
      return "scaleX(" + t + ") scaleY(" + i + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Lu.Translate.toString(e), Lu.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: i,
        easing: n
      } = e;
      return t + " " + i + "ms " + n;
    }
  }
}), vM = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function fct(e) {
  return e.matches(vM) ? e : e.querySelector(vM);
}
const Gct = {
  display: "none"
};
function yct(e) {
  let {
    id: t,
    value: i
  } = e;
  return Se.createElement("div", {
    id: t,
    style: Gct
  }, i);
}
function Wct(e) {
  let {
    id: t,
    announcement: i,
    ariaLiveType: n = "assertive"
  } = e;
  const g = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return Se.createElement("div", {
    id: t,
    style: g,
    role: "status",
    "aria-live": n,
    "aria-atomic": !0
  }, i);
}
function Sct() {
  const [e, t] = At("");
  return {
    announce: ft((n) => {
      n != null && t(n);
    }, []),
    announcement: e
  };
}
const gq = /* @__PURE__ */ Bs(null);
function Vct(e) {
  const t = Hn(gq);
  et(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function wct() {
  const [e] = At(() => /* @__PURE__ */ new Set()), t = ft((n) => (e.add(n), () => e.delete(n)), [e]);
  return [ft((n) => {
    let {
      type: g,
      event: r
    } = n;
    e.forEach((o) => {
      var I;
      return (I = o[g]) == null ? void 0 : I.call(o, r);
    });
  }, [e]), t];
}
const vct = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, Rct = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: i
    } = e;
    return i ? "Draggable item " + t.id + " was moved over droppable area " + i.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: i
    } = e;
    return i ? "Draggable item " + t.id + " was dropped over droppable area " + i.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function Xct(e) {
  let {
    announcements: t = Rct,
    container: i,
    hiddenTextDescribedById: n,
    screenReaderInstructions: g = vct
  } = e;
  const {
    announce: r,
    announcement: o
  } = Sct(), I = mf("DndLiveRegion"), [s, a] = At(!1);
  if (et(() => {
    a(!0);
  }, []), Vct(je(() => ({
    onDragStart(C) {
      let {
        active: u
      } = C;
      r(t.onDragStart({
        active: u
      }));
    },
    onDragMove(C) {
      let {
        active: u,
        over: A
      } = C;
      t.onDragMove && r(t.onDragMove({
        active: u,
        over: A
      }));
    },
    onDragOver(C) {
      let {
        active: u,
        over: A
      } = C;
      r(t.onDragOver({
        active: u,
        over: A
      }));
    },
    onDragEnd(C) {
      let {
        active: u,
        over: A
      } = C;
      r(t.onDragEnd({
        active: u,
        over: A
      }));
    },
    onDragCancel(C) {
      let {
        active: u,
        over: A
      } = C;
      r(t.onDragCancel({
        active: u,
        over: A
      }));
    }
  }), [r, t])), !s)
    return null;
  const d = Se.createElement(Se.Fragment, null, Se.createElement(yct, {
    id: n,
    value: g.draggable
  }), Se.createElement(Wct, {
    id: I,
    announcement: o
  }));
  return i ? Dz(d, i) : d;
}
var Pg;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Pg || (Pg = {}));
function GV() {
}
function RM(e, t) {
  return je(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function Hct() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return je(
    () => [...t].filter((n) => n != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const ps = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function kct(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Fct(e, t) {
  const i = fV(e);
  if (!i)
    return "0 0";
  const n = {
    x: (i.x - t.left) / t.width * 100,
    y: (i.y - t.top) / t.height * 100
  };
  return n.x + "% " + n.y + "%";
}
function Yct(e, t) {
  let {
    data: {
      value: i
    }
  } = e, {
    data: {
      value: n
    }
  } = t;
  return i - n;
}
function xct(e, t) {
  let {
    data: {
      value: i
    }
  } = e, {
    data: {
      value: n
    }
  } = t;
  return n - i;
}
function Dct(e, t) {
  if (!e || e.length === 0)
    return null;
  const [i] = e;
  return i[t];
}
function XM(e, t, i) {
  return t === void 0 && (t = e.left), i === void 0 && (i = e.top), {
    x: t + e.width * 0.5,
    y: i + e.height * 0.5
  };
}
const Jct = (e) => {
  let {
    collisionRect: t,
    droppableRects: i,
    droppableContainers: n
  } = e;
  const g = XM(t, t.left, t.top), r = [];
  for (const o of n) {
    const {
      id: I
    } = o, s = i.get(I);
    if (s) {
      const a = kct(XM(s), g);
      r.push({
        id: I,
        data: {
          droppableContainer: o,
          value: a
        }
      });
    }
  }
  return r.sort(Yct);
};
function Kct(e, t) {
  const i = Math.max(t.top, e.top), n = Math.max(t.left, e.left), g = Math.min(t.left + t.width, e.left + e.width), r = Math.min(t.top + t.height, e.top + e.height), o = g - n, I = r - i;
  if (n < g && i < r) {
    const s = t.width * t.height, a = e.width * e.height, d = o * I, C = d / (s + a - d);
    return Number(C.toFixed(4));
  }
  return 0;
}
const Ect = (e) => {
  let {
    collisionRect: t,
    droppableRects: i,
    droppableContainers: n
  } = e;
  const g = [];
  for (const r of n) {
    const {
      id: o
    } = r, I = i.get(o);
    if (I) {
      const s = Kct(I, t);
      s > 0 && g.push({
        id: o,
        data: {
          droppableContainer: r,
          value: s
        }
      });
    }
  }
  return g.sort(xct);
};
function Nct(e, t, i) {
  return {
    ...e,
    scaleX: t && i ? t.width / i.width : 1,
    scaleY: t && i ? t.height / i.height : 1
  };
}
function rq(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : ps;
}
function Lct(e) {
  return function(i) {
    for (var n = arguments.length, g = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
      g[r - 1] = arguments[r];
    return g.reduce((o, I) => ({
      ...o,
      top: o.top + e * I.y,
      bottom: o.bottom + e * I.y,
      left: o.left + e * I.x,
      right: o.right + e * I.x
    }), {
      ...i
    });
  };
}
const Tct = /* @__PURE__ */ Lct(1);
function oq(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function Mct(e, t, i) {
  const n = oq(t);
  if (!n)
    return e;
  const {
    scaleX: g,
    scaleY: r,
    x: o,
    y: I
  } = n, s = e.left - o - (1 - g) * parseFloat(i), a = e.top - I - (1 - r) * parseFloat(i.slice(i.indexOf(" ") + 1)), d = g ? e.width / g : e.width, C = r ? e.height / r : e.height;
  return {
    width: d,
    height: C,
    top: a,
    right: s + d,
    bottom: a + C,
    left: s
  };
}
const Uct = {
  ignoreTransform: !1
};
function Bh(e, t) {
  t === void 0 && (t = Uct);
  let i = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: a,
      transformOrigin: d
    } = Vo(e).getComputedStyle(e);
    a && (i = Mct(i, a, d));
  }
  const {
    top: n,
    left: g,
    width: r,
    height: o,
    bottom: I,
    right: s
  } = i;
  return {
    top: n,
    left: g,
    width: r,
    height: o,
    bottom: I,
    right: s
  };
}
function HM(e) {
  return Bh(e, {
    ignoreTransform: !0
  });
}
function Pct(e) {
  const t = e.innerWidth, i = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: i,
    width: t,
    height: i
  };
}
function zct(e, t) {
  return t === void 0 && (t = Vo(e).getComputedStyle(e)), t.position === "fixed";
}
function Oct(e, t) {
  t === void 0 && (t = Vo(e).getComputedStyle(e));
  const i = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((g) => {
    const r = t[g];
    return typeof r == "string" ? i.test(r) : !1;
  });
}
function SK(e, t) {
  const i = [];
  function n(g) {
    if (t != null && i.length >= t || !g)
      return i;
    if (WK(g) && g.scrollingElement != null && !i.includes(g.scrollingElement))
      return i.push(g.scrollingElement), i;
    if (!Af(g) || iq(g) || i.includes(g))
      return i;
    const r = Vo(e).getComputedStyle(g);
    return g !== e && Oct(g, r) && i.push(g), zct(g, r) ? i : n(g.parentNode);
  }
  return e ? n(e) : i;
}
function Iq(e) {
  const [t] = SK(e, 1);
  return t ?? null;
}
function aF(e) {
  return !C2 || !e ? null : hh(e) ? e : yK(e) ? WK(e) || e === ph(e).scrollingElement ? window : Af(e) ? e : null : null;
}
function lq(e) {
  return hh(e) ? e.scrollX : e.scrollLeft;
}
function sq(e) {
  return hh(e) ? e.scrollY : e.scrollTop;
}
function Vx(e) {
  return {
    x: lq(e),
    y: sq(e)
  };
}
var ar;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(ar || (ar = {}));
function aq(e) {
  return !C2 || !e ? !1 : e === document.scrollingElement;
}
function cq(e) {
  const t = {
    x: 0,
    y: 0
  }, i = aq(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, n = {
    x: e.scrollWidth - i.width,
    y: e.scrollHeight - i.height
  }, g = e.scrollTop <= t.y, r = e.scrollLeft <= t.x, o = e.scrollTop >= n.y, I = e.scrollLeft >= n.x;
  return {
    isTop: g,
    isLeft: r,
    isBottom: o,
    isRight: I,
    maxScroll: n,
    minScroll: t
  };
}
const Qct = {
  x: 0.2,
  y: 0.2
};
function jct(e, t, i, n, g) {
  let {
    top: r,
    left: o,
    right: I,
    bottom: s
  } = i;
  n === void 0 && (n = 10), g === void 0 && (g = Qct);
  const {
    isTop: a,
    isBottom: d,
    isLeft: C,
    isRight: u
  } = cq(e), A = {
    x: 0,
    y: 0
  }, m = {
    x: 0,
    y: 0
  }, h = {
    height: t.height * g.y,
    width: t.width * g.x
  };
  return !a && r <= t.top + h.height ? (A.y = ar.Backward, m.y = n * Math.abs((t.top + h.height - r) / h.height)) : !d && s >= t.bottom - h.height && (A.y = ar.Forward, m.y = n * Math.abs((t.bottom - h.height - s) / h.height)), !u && I >= t.right - h.width ? (A.x = ar.Forward, m.x = n * Math.abs((t.right - h.width - I) / h.width)) : !C && o <= t.left + h.width && (A.x = ar.Backward, m.x = n * Math.abs((t.left + h.width - o) / h.width)), {
    direction: A,
    speed: m
  };
}
function _ct(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: r,
      innerHeight: o
    } = window;
    return {
      top: 0,
      left: 0,
      right: r,
      bottom: o,
      width: r,
      height: o
    };
  }
  const {
    top: t,
    left: i,
    right: n,
    bottom: g
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: i,
    right: n,
    bottom: g,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function dq(e) {
  return e.reduce((t, i) => fm(t, Vx(i)), ps);
}
function $ct(e) {
  return e.reduce((t, i) => t + lq(i), 0);
}
function qct(e) {
  return e.reduce((t, i) => t + sq(i), 0);
}
function Cq(e, t) {
  if (t === void 0 && (t = Bh), !e)
    return;
  const {
    top: i,
    left: n,
    bottom: g,
    right: r
  } = t(e);
  Iq(e) && (g <= 0 || r <= 0 || i >= window.innerHeight || n >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const edt = [["x", ["left", "right"], $ct], ["y", ["top", "bottom"], qct]];
class VK {
  constructor(t, i) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const n = SK(i), g = dq(n);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [r, o, I] of edt)
      for (const s of o)
        Object.defineProperty(this, s, {
          get: () => {
            const a = I(n), d = g[r] - a;
            return this.rect[s] + d;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class WB {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((i) => {
        var n;
        return (n = this.target) == null ? void 0 : n.removeEventListener(...i);
      });
    }, this.target = t;
  }
  add(t, i, n) {
    var g;
    (g = this.target) == null || g.addEventListener(t, i, n), this.listeners.push([t, i, n]);
  }
}
function tdt(e) {
  const {
    EventTarget: t
  } = Vo(e);
  return e instanceof t ? e : ph(e);
}
function cF(e, t) {
  const i = Math.abs(e.x), n = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(i ** 2 + n ** 2) > t : "x" in t && "y" in t ? i > t.x && n > t.y : "x" in t ? i > t.x : "y" in t ? n > t.y : !1;
}
var al;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(al || (al = {}));
function kM(e) {
  e.preventDefault();
}
function idt(e) {
  e.stopPropagation();
}
var dn;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter";
})(dn || (dn = {}));
const uq = {
  start: [dn.Space, dn.Enter],
  cancel: [dn.Esc],
  end: [dn.Space, dn.Enter]
}, ndt = (e, t) => {
  let {
    currentCoordinates: i
  } = t;
  switch (e.code) {
    case dn.Right:
      return {
        ...i,
        x: i.x + 25
      };
    case dn.Left:
      return {
        ...i,
        x: i.x - 25
      };
    case dn.Down:
      return {
        ...i,
        y: i.y + 25
      };
    case dn.Up:
      return {
        ...i,
        y: i.y - 25
      };
  }
};
class Aq {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: i
      }
    } = t;
    this.props = t, this.listeners = new WB(ph(i)), this.windowListeners = new WB(Vo(i)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(al.Resize, this.handleCancel), this.windowListeners.add(al.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(al.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: i
    } = this.props, n = t.node.current;
    n && Cq(n), i(ps);
  }
  handleKeyDown(t) {
    if (A2(t)) {
      const {
        active: i,
        context: n,
        options: g
      } = this.props, {
        keyboardCodes: r = uq,
        coordinateGetter: o = ndt,
        scrollBehavior: I = "smooth"
      } = g, {
        code: s
      } = t;
      if (r.end.includes(s)) {
        this.handleEnd(t);
        return;
      }
      if (r.cancel.includes(s)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: a
      } = n.current, d = a ? {
        x: a.left,
        y: a.top
      } : ps;
      this.referenceCoordinates || (this.referenceCoordinates = d);
      const C = o(t, {
        active: i,
        context: n.current,
        currentCoordinates: d
      });
      if (C) {
        const u = ZV(C, d), A = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: m
        } = n.current;
        for (const h of m) {
          const B = t.code, {
            isTop: f,
            isRight: G,
            isLeft: y,
            isBottom: W,
            maxScroll: V,
            minScroll: w
          } = cq(h), v = _ct(h), H = {
            x: Math.min(B === dn.Right ? v.right - v.width / 2 : v.right, Math.max(B === dn.Right ? v.left : v.left + v.width / 2, C.x)),
            y: Math.min(B === dn.Down ? v.bottom - v.height / 2 : v.bottom, Math.max(B === dn.Down ? v.top : v.top + v.height / 2, C.y))
          }, x = B === dn.Right && !G || B === dn.Left && !y, N = B === dn.Down && !W || B === dn.Up && !f;
          if (x && H.x !== C.x) {
            const M = h.scrollLeft + u.x, $ = B === dn.Right && M <= V.x || B === dn.Left && M >= w.x;
            if ($ && !u.y) {
              h.scrollTo({
                left: M,
                behavior: I
              });
              return;
            }
            $ ? A.x = h.scrollLeft - M : A.x = B === dn.Right ? h.scrollLeft - V.x : h.scrollLeft - w.x, A.x && h.scrollBy({
              left: -A.x,
              behavior: I
            });
            break;
          } else if (N && H.y !== C.y) {
            const M = h.scrollTop + u.y, $ = B === dn.Down && M <= V.y || B === dn.Up && M >= w.y;
            if ($ && !u.x) {
              h.scrollTo({
                top: M,
                behavior: I
              });
              return;
            }
            $ ? A.y = h.scrollTop - M : A.y = B === dn.Down ? h.scrollTop - V.y : h.scrollTop - w.y, A.y && h.scrollBy({
              top: -A.y,
              behavior: I
            });
            break;
          }
        }
        this.handleMove(t, fm(ZV(C, this.referenceCoordinates), A));
      }
    }
  }
  handleMove(t, i) {
    const {
      onMove: n
    } = this.props;
    t.preventDefault(), n(i);
  }
  handleEnd(t) {
    const {
      onEnd: i
    } = this.props;
    t.preventDefault(), this.detach(), i();
  }
  handleCancel(t) {
    const {
      onCancel: i
    } = this.props;
    t.preventDefault(), this.detach(), i();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
Aq.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, i) => {
    let {
      keyboardCodes: n = uq,
      onActivation: g
    } = t, {
      active: r
    } = i;
    const {
      code: o
    } = e.nativeEvent;
    if (n.start.includes(o)) {
      const I = r.activatorNode.current;
      return I && e.target !== I ? !1 : (e.preventDefault(), g == null || g({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function FM(e) {
  return !!(e && "distance" in e);
}
function YM(e) {
  return !!(e && "delay" in e);
}
class wK {
  constructor(t, i, n) {
    var g;
    n === void 0 && (n = tdt(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = i;
    const {
      event: r
    } = t, {
      target: o
    } = r;
    this.props = t, this.events = i, this.document = ph(o), this.documentListeners = new WB(this.document), this.listeners = new WB(n), this.windowListeners = new WB(Vo(o)), this.initialCoordinates = (g = fV(r)) != null ? g : ps, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: i,
          bypassActivationConstraint: n
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), this.windowListeners.add(al.Resize, this.handleCancel), this.windowListeners.add(al.DragStart, kM), this.windowListeners.add(al.VisibilityChange, this.handleCancel), this.windowListeners.add(al.ContextMenu, kM), this.documentListeners.add(al.Keydown, this.handleKeydown), i) {
      if (n != null && n({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (YM(i)) {
        this.timeoutId = setTimeout(this.handleStart, i.delay);
        return;
      }
      if (FM(i))
        return;
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: i
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(al.Click, idt, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(al.SelectionChange, this.removeTextSelection), i(t));
  }
  handleMove(t) {
    var i;
    const {
      activated: n,
      initialCoordinates: g,
      props: r
    } = this, {
      onMove: o,
      options: {
        activationConstraint: I
      }
    } = r;
    if (!g)
      return;
    const s = (i = fV(t)) != null ? i : ps, a = ZV(g, s);
    if (!n && I) {
      if (FM(I)) {
        if (I.tolerance != null && cF(a, I.tolerance))
          return this.handleCancel();
        if (cF(a, I.distance))
          return this.handleStart();
      }
      return YM(I) && cF(a, I.tolerance) ? this.handleCancel() : void 0;
    }
    t.cancelable && t.preventDefault(), o(s);
  }
  handleEnd() {
    const {
      onEnd: t
    } = this.props;
    this.detach(), t();
  }
  handleCancel() {
    const {
      onCancel: t
    } = this.props;
    this.detach(), t();
  }
  handleKeydown(t) {
    t.code === dn.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const gdt = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class bq extends wK {
  constructor(t) {
    const {
      event: i
    } = t, n = ph(i.target);
    super(t, gdt, n);
  }
}
bq.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: i
    } = e, {
      onActivation: n
    } = t;
    return !i.isPrimary || i.button !== 0 ? !1 : (n == null || n({
      event: i
    }), !0);
  }
}];
const rdt = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var wx;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(wx || (wx = {}));
class mq extends wK {
  constructor(t) {
    super(t, rdt, ph(t.event.target));
  }
}
mq.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: i
    } = e, {
      onActivation: n
    } = t;
    return i.button === wx.RightClick ? !1 : (n == null || n({
      event: i
    }), !0);
  }
}];
const dF = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class hq extends wK {
  constructor(t) {
    super(t, dF);
  }
  static setup() {
    return window.addEventListener(dF.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(dF.move.name, t);
    };
    function t() {
    }
  }
}
hq.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: i
    } = e, {
      onActivation: n
    } = t;
    const {
      touches: g
    } = i;
    return g.length > 1 ? !1 : (n == null || n({
      event: i
    }), !0);
  }
}];
var SB;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(SB || (SB = {}));
var yV;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(yV || (yV = {}));
function odt(e) {
  let {
    acceleration: t,
    activator: i = SB.Pointer,
    canScroll: n,
    draggingRect: g,
    enabled: r,
    interval: o = 5,
    order: I = yV.TreeOrder,
    pointerCoordinates: s,
    scrollableAncestors: a,
    scrollableAncestorRects: d,
    delta: C,
    threshold: u
  } = e;
  const A = ldt({
    delta: C,
    disabled: !r
  }), [m, h] = pct(), B = Ct({
    x: 0,
    y: 0
  }), f = Ct({
    x: 0,
    y: 0
  }), G = je(() => {
    switch (i) {
      case SB.Pointer:
        return s ? {
          top: s.y,
          bottom: s.y,
          left: s.x,
          right: s.x
        } : null;
      case SB.DraggableRect:
        return g;
    }
  }, [i, g, s]), y = Ct(null), W = ft(() => {
    const w = y.current;
    if (!w)
      return;
    const v = B.current.x * f.current.x, H = B.current.y * f.current.y;
    w.scrollBy(v, H);
  }, []), V = je(() => I === yV.TreeOrder ? [...a].reverse() : a, [I, a]);
  et(
    () => {
      if (!r || !a.length || !G) {
        h();
        return;
      }
      for (const w of V) {
        if ((n == null ? void 0 : n(w)) === !1)
          continue;
        const v = a.indexOf(w), H = d[v];
        if (!H)
          continue;
        const {
          direction: x,
          speed: N
        } = jct(w, H, G, t, u);
        for (const M of ["x", "y"])
          A[M][x[M]] || (N[M] = 0, x[M] = 0);
        if (N.x > 0 || N.y > 0) {
          h(), y.current = w, m(W, o), B.current = N, f.current = x;
          return;
        }
      }
      B.current = {
        x: 0,
        y: 0
      }, f.current = {
        x: 0,
        y: 0
      }, h();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      W,
      n,
      h,
      r,
      o,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(G),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(A),
      m,
      a,
      V,
      d,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(u)
    ]
  );
}
const Idt = {
  x: {
    [ar.Backward]: !1,
    [ar.Forward]: !1
  },
  y: {
    [ar.Backward]: !1,
    [ar.Forward]: !1
  }
};
function ldt(e) {
  let {
    delta: t,
    disabled: i
  } = e;
  const n = BV(t);
  return bf((g) => {
    if (i || !n || !g)
      return Idt;
    const r = {
      x: Math.sign(t.x - n.x),
      y: Math.sign(t.y - n.y)
    };
    return {
      x: {
        [ar.Backward]: g.x[ar.Backward] || r.x === -1,
        [ar.Forward]: g.x[ar.Forward] || r.x === 1
      },
      y: {
        [ar.Backward]: g.y[ar.Backward] || r.y === -1,
        [ar.Forward]: g.y[ar.Forward] || r.y === 1
      }
    };
  }, [i, t, n]);
}
function sdt(e, t) {
  const i = t !== null ? e.get(t) : void 0, n = i ? i.node.current : null;
  return bf((g) => {
    var r;
    return t === null ? null : (r = n ?? g) != null ? r : null;
  }, [n, t]);
}
function adt(e, t) {
  return je(() => e.reduce((i, n) => {
    const {
      sensor: g
    } = n, r = g.activators.map((o) => ({
      eventName: o.eventName,
      handler: t(o.handler, n)
    }));
    return [...i, ...r];
  }, []), [e, t]);
}
var aZ;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(aZ || (aZ = {}));
var vx;
(function(e) {
  e.Optimized = "optimized";
})(vx || (vx = {}));
const xM = /* @__PURE__ */ new Map();
function cdt(e, t) {
  let {
    dragging: i,
    dependencies: n,
    config: g
  } = t;
  const [r, o] = At(null), {
    frequency: I,
    measure: s,
    strategy: a
  } = g, d = Ct(e), C = B(), u = sZ(C), A = ft(function(f) {
    f === void 0 && (f = []), !u.current && o((G) => G === null ? f : G.concat(f.filter((y) => !G.includes(y))));
  }, [u]), m = Ct(null), h = bf((f) => {
    if (C && !i)
      return xM;
    if (!f || f === xM || d.current !== e || r != null) {
      const G = /* @__PURE__ */ new Map();
      for (let y of e) {
        if (!y)
          continue;
        if (r && r.length > 0 && !r.includes(y.id) && y.rect.current) {
          G.set(y.id, y.rect.current);
          continue;
        }
        const W = y.node.current, V = W ? new VK(s(W), W) : null;
        y.rect.current = V, V && G.set(y.id, V);
      }
      return G;
    }
    return f;
  }, [e, r, i, C, s]);
  return et(() => {
    d.current = e;
  }, [e]), et(
    () => {
      C || A();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i, C]
  ), et(
    () => {
      r && r.length > 0 && o(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(r)]
  ), et(
    () => {
      C || typeof I != "number" || m.current !== null || (m.current = setTimeout(() => {
        A(), m.current = null;
      }, I));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [I, C, A, ...n]
  ), {
    droppableRects: h,
    measureDroppableContainers: A,
    measuringScheduled: r != null
  };
  function B() {
    switch (a) {
      case aZ.Always:
        return !1;
      case aZ.BeforeDragging:
        return i;
      default:
        return !i;
    }
  }
}
function vK(e, t) {
  return bf((i) => e ? i || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function ddt(e, t) {
  return vK(e, t);
}
function Cdt(e) {
  let {
    callback: t,
    disabled: i
  } = e;
  const n = u2(t), g = je(() => {
    if (i || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: r
    } = window;
    return new r(n);
  }, [n, i]);
  return et(() => () => g == null ? void 0 : g.disconnect(), [g]), g;
}
function b2(e) {
  let {
    callback: t,
    disabled: i
  } = e;
  const n = u2(t), g = je(
    () => {
      if (i || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: r
      } = window;
      return new r(n);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i]
  );
  return et(() => () => g == null ? void 0 : g.disconnect(), [g]), g;
}
function udt(e) {
  return new VK(Bh(e), e);
}
function DM(e, t, i) {
  t === void 0 && (t = udt);
  const [n, g] = BZ(I, null), r = Cdt({
    callback(s) {
      if (e)
        for (const a of s) {
          const {
            type: d,
            target: C
          } = a;
          if (d === "childList" && C instanceof HTMLElement && C.contains(e)) {
            g();
            break;
          }
        }
    }
  }), o = b2({
    callback: g
  });
  return Wl(() => {
    g(), e ? (o == null || o.observe(e), r == null || r.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (o == null || o.disconnect(), r == null || r.disconnect());
  }, [e]), n;
  function I(s) {
    if (!e)
      return null;
    if (e.isConnected === !1) {
      var a;
      return (a = s ?? i) != null ? a : null;
    }
    const d = t(e);
    return JSON.stringify(s) === JSON.stringify(d) ? s : d;
  }
}
function Adt(e) {
  const t = vK(e);
  return rq(e, t);
}
const JM = [];
function bdt(e) {
  const t = Ct(e), i = bf((n) => e ? n && n !== JM && e && t.current && e.parentNode === t.current.parentNode ? n : SK(e) : JM, [e]);
  return et(() => {
    t.current = e;
  }, [e]), i;
}
function mdt(e) {
  const [t, i] = At(null), n = Ct(e), g = ft((r) => {
    const o = aF(r.target);
    o && i((I) => I ? (I.set(o, Vx(o)), new Map(I)) : null);
  }, []);
  return et(() => {
    const r = n.current;
    if (e !== r) {
      o(r);
      const I = e.map((s) => {
        const a = aF(s);
        return a ? (a.addEventListener("scroll", g, {
          passive: !0
        }), [a, Vx(a)]) : null;
      }).filter((s) => s != null);
      i(I.length ? new Map(I) : null), n.current = e;
    }
    return () => {
      o(e), o(r);
    };
    function o(I) {
      I.forEach((s) => {
        const a = aF(s);
        a == null || a.removeEventListener("scroll", g);
      });
    }
  }, [g, e]), je(() => e.length ? t ? Array.from(t.values()).reduce((r, o) => fm(r, o), ps) : dq(e) : ps, [e, t]);
}
function KM(e, t) {
  t === void 0 && (t = []);
  const i = Ct(null);
  return et(
    () => {
      i.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), et(() => {
    const n = e !== ps;
    n && !i.current && (i.current = e), !n && i.current && (i.current = null);
  }, [e]), i.current ? ZV(e, i.current) : ps;
}
function hdt(e) {
  et(
    () => {
      if (!C2)
        return;
      const t = e.map((i) => {
        let {
          sensor: n
        } = i;
        return n.setup == null ? void 0 : n.setup();
      });
      return () => {
        for (const i of t)
          i == null || i();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: i
      } = t;
      return i;
    })
  );
}
function pdt(e, t) {
  return je(() => e.reduce((i, n) => {
    let {
      eventName: g,
      handler: r
    } = n;
    return i[g] = (o) => {
      r(o, t);
    }, i;
  }, {}), [e, t]);
}
function pq(e) {
  return je(() => e ? Pct(e) : null, [e]);
}
const CF = [];
function Bdt(e, t) {
  t === void 0 && (t = Bh);
  const [i] = e, n = pq(i ? Vo(i) : null), [g, r] = BZ(I, CF), o = b2({
    callback: r
  });
  return e.length > 0 && g === CF && r(), Wl(() => {
    e.length ? e.forEach((s) => o == null ? void 0 : o.observe(s)) : (o == null || o.disconnect(), r());
  }, [e]), g;
  function I() {
    return e.length ? e.map((s) => aq(s) ? n : new VK(t(s), s)) : CF;
  }
}
function Bq(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return Af(t) ? t : e;
}
function Zdt(e) {
  let {
    measure: t
  } = e;
  const [i, n] = At(null), g = ft((a) => {
    for (const {
      target: d
    } of a)
      if (Af(d)) {
        n((C) => {
          const u = t(d);
          return C ? {
            ...C,
            width: u.width,
            height: u.height
          } : u;
        });
        break;
      }
  }, [t]), r = b2({
    callback: g
  }), o = ft((a) => {
    const d = Bq(a);
    r == null || r.disconnect(), d && (r == null || r.observe(d)), n(d ? t(d) : null);
  }, [t, r]), [I, s] = pV(o);
  return je(() => ({
    nodeRef: I,
    rect: i,
    setRef: s
  }), [i, I, s]);
}
const fdt = [{
  sensor: bq,
  options: {}
}, {
  sensor: Aq,
  options: {}
}], Gdt = {
  current: {}
}, hS = {
  draggable: {
    measure: HM
  },
  droppable: {
    measure: HM,
    strategy: aZ.WhileDragging,
    frequency: vx.Optimized
  },
  dragOverlay: {
    measure: Bh
  }
};
class VB extends Map {
  get(t) {
    var i;
    return t != null && (i = super.get(t)) != null ? i : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: i
      } = t;
      return !i;
    });
  }
  getNodeFor(t) {
    var i, n;
    return (i = (n = this.get(t)) == null ? void 0 : n.node.current) != null ? i : void 0;
  }
}
const ydt = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new VB(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: GV
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: hS,
  measureDroppableContainers: GV,
  windowRect: null,
  measuringScheduled: !1
}, Zq = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: GV,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: GV
}, hf = /* @__PURE__ */ Bs(Zq), fq = /* @__PURE__ */ Bs(ydt);
function Wdt() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new VB()
    }
  };
}
function Sdt(e, t) {
  switch (t.type) {
    case Pg.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case Pg.DragMove:
      return e.draggable.active ? {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      } : e;
    case Pg.DragEnd:
    case Pg.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Pg.RegisterDroppable: {
      const {
        element: i
      } = t, {
        id: n
      } = i, g = new VB(e.droppable.containers);
      return g.set(n, i), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: g
        }
      };
    }
    case Pg.SetDroppableDisabled: {
      const {
        id: i,
        key: n,
        disabled: g
      } = t, r = e.droppable.containers.get(i);
      if (!r || n !== r.key)
        return e;
      const o = new VB(e.droppable.containers);
      return o.set(i, {
        ...r,
        disabled: g
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case Pg.UnregisterDroppable: {
      const {
        id: i,
        key: n
      } = t, g = e.droppable.containers.get(i);
      if (!g || n !== g.key)
        return e;
      const r = new VB(e.droppable.containers);
      return r.delete(i), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: r
        }
      };
    }
    default:
      return e;
  }
}
function Vdt(e) {
  let {
    disabled: t
  } = e;
  const {
    active: i,
    activatorEvent: n,
    draggableNodes: g
  } = Hn(hf), r = BV(n), o = BV(i == null ? void 0 : i.id);
  return et(() => {
    if (!t && !n && r && o != null) {
      if (!A2(r) || document.activeElement === r.target)
        return;
      const I = g.get(o);
      if (!I)
        return;
      const {
        activatorNode: s,
        node: a
      } = I;
      if (!s.current && !a.current)
        return;
      requestAnimationFrame(() => {
        for (const d of [s.current, a.current]) {
          if (!d)
            continue;
          const C = fct(d);
          if (C) {
            C.focus();
            break;
          }
        }
      });
    }
  }, [n, t, g, o, r]), null;
}
function Gq(e, t) {
  let {
    transform: i,
    ...n
  } = t;
  return e != null && e.length ? e.reduce((g, r) => r({
    transform: g,
    ...n
  }), i) : i;
}
function wdt(e) {
  return je(
    () => ({
      draggable: {
        ...hS.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...hS.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...hS.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function vdt(e) {
  let {
    activeNode: t,
    measure: i,
    initialRect: n,
    config: g = !0
  } = e;
  const r = Ct(!1), {
    x: o,
    y: I
  } = typeof g == "boolean" ? {
    x: g,
    y: g
  } : g;
  Wl(() => {
    if (!o && !I || !t) {
      r.current = !1;
      return;
    }
    if (r.current || !n)
      return;
    const a = t == null ? void 0 : t.node.current;
    if (!a || a.isConnected === !1)
      return;
    const d = i(a), C = rq(d, n);
    if (o || (C.x = 0), I || (C.y = 0), r.current = !0, Math.abs(C.x) > 0 || Math.abs(C.y) > 0) {
      const u = Iq(a);
      u && u.scrollBy({
        top: C.y,
        left: C.x
      });
    }
  }, [t, o, I, n, i]);
}
const m2 = /* @__PURE__ */ Bs({
  ...ps,
  scaleX: 1,
  scaleY: 1
});
var Bd;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Bd || (Bd = {}));
const Rdt = /* @__PURE__ */ pZ(function(t) {
  var i, n, g, r;
  let {
    id: o,
    accessibility: I,
    autoScroll: s = !0,
    children: a,
    sensors: d = fdt,
    collisionDetection: C = Ect,
    measuring: u,
    modifiers: A,
    ...m
  } = t;
  const h = BZ(Sdt, void 0, Wdt), [B, f] = h, [G, y] = wct(), [W, V] = At(Bd.Uninitialized), w = W === Bd.Initialized, {
    draggable: {
      active: v,
      nodes: H,
      translate: x
    },
    droppable: {
      containers: N
    }
  } = B, M = v ? H.get(v) : null, $ = Ct({
    initial: null,
    translated: null
  }), q = je(() => {
    var jt;
    return v != null ? {
      id: v,
      // It's possible for the active node to unmount while dragging
      data: (jt = M == null ? void 0 : M.data) != null ? jt : Gdt,
      rect: $
    } : null;
  }, [v, M]), E = Ct(null), [L, P] = At(null), [Q, te] = At(null), le = sZ(m, Object.values(m)), Ae = mf("DndDescribedBy", o), we = je(() => N.getEnabled(), [N]), Ee = wdt(u), {
    droppableRects: Je,
    measureDroppableContainers: ve,
    measuringScheduled: Be
  } = cdt(we, {
    dragging: w,
    dependencies: [x.x, x.y],
    config: Ee.droppable
  }), ue = sdt(H, v), Xe = je(() => Q ? fV(Q) : null, [Q]), Ze = si(), Ke = ddt(ue, Ee.draggable.measure);
  vdt({
    activeNode: v ? H.get(v) : null,
    config: Ze.layoutShiftCompensation,
    initialRect: Ke,
    measure: Ee.draggable.measure
  });
  const $e = DM(ue, Ee.draggable.measure, Ke), rt = DM(ue ? ue.parentElement : null), dt = Ct({
    activatorEvent: null,
    active: null,
    activeNode: ue,
    collisionRect: null,
    collisions: null,
    droppableRects: Je,
    draggableNodes: H,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: N,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), ot = N.getNodeFor((i = dt.current.over) == null ? void 0 : i.id), ze = Zdt({
    measure: Ee.dragOverlay.measure
  }), tt = (n = ze.nodeRef.current) != null ? n : ue, st = w ? (g = ze.rect) != null ? g : $e : null, Kt = !!(ze.nodeRef.current && ze.rect), ie = Adt(Kt ? null : $e), J = pq(tt ? Vo(tt) : null), Ce = bdt(w ? ot ?? ue : null), xe = Bdt(Ce), Le = Gq(A, {
    transform: {
      x: x.x - ie.x,
      y: x.y - ie.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: Q,
    active: q,
    activeNodeRect: $e,
    containerNodeRect: rt,
    draggingNodeRect: st,
    over: dt.current.over,
    overlayNodeRect: ze.rect,
    scrollableAncestors: Ce,
    scrollableAncestorRects: xe,
    windowRect: J
  }), Ye = Xe ? fm(Xe, x) : null, qe = mdt(Ce), Yt = KM(qe), qt = KM(qe, [$e]), Ut = fm(Le, Yt), Ge = st ? Tct(st, Le) : null, pe = q && Ge ? C({
    active: q,
    collisionRect: Ge,
    droppableRects: Je,
    droppableContainers: we,
    pointerCoordinates: Ye
  }) : null, _e = Dct(pe, "id"), [Gt, Jt] = At(null), Te = Kt ? Le : fm(Le, qt), Xt = Nct(Te, (r = Gt == null ? void 0 : Gt.rect) != null ? r : null, $e), Pe = ft(
    (jt, Zi) => {
      let {
        sensor: fi,
        options: on
      } = Zi;
      if (E.current == null)
        return;
      const In = H.get(E.current);
      if (!In)
        return;
      const xn = jt.nativeEvent, ln = new fi({
        active: E.current,
        activeNode: In,
        event: xn,
        options: on,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: dt,
        onStart(Ti) {
          const vi = E.current;
          if (vi == null)
            return;
          const ei = H.get(vi);
          if (!ei)
            return;
          const {
            onDragStart: yn
          } = le.current, Mi = {
            active: {
              id: vi,
              data: ei.data,
              rect: $
            }
          };
          em(() => {
            yn == null || yn(Mi), V(Bd.Initializing), f({
              type: Pg.DragStart,
              initialCoordinates: Ti,
              active: vi
            }), G({
              type: "onDragStart",
              event: Mi
            });
          });
        },
        onMove(Ti) {
          f({
            type: Pg.DragMove,
            coordinates: Ti
          });
        },
        onEnd: ug(Pg.DragEnd),
        onCancel: ug(Pg.DragCancel)
      });
      em(() => {
        P(ln), te(jt.nativeEvent);
      });
      function ug(Ti) {
        return async function() {
          const {
            active: ei,
            collisions: yn,
            over: Mi,
            scrollAdjustedTranslate: bn
          } = dt.current;
          let Ag = null;
          if (ei && bn) {
            const {
              cancelDrop: sn
            } = le.current;
            Ag = {
              activatorEvent: xn,
              active: ei,
              collisions: yn,
              delta: bn,
              over: Mi
            }, Ti === Pg.DragEnd && typeof sn == "function" && await Promise.resolve(sn(Ag)) && (Ti = Pg.DragCancel);
          }
          E.current = null, em(() => {
            f({
              type: Ti
            }), V(Bd.Uninitialized), Jt(null), P(null), te(null);
            const sn = Ti === Pg.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Ag) {
              const bg = le.current[sn];
              bg == null || bg(Ag), G({
                type: sn,
                event: Ag
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [H]
  ), Oe = ft((jt, Zi) => (fi, on) => {
    const In = fi.nativeEvent, xn = H.get(on);
    if (
      // Another sensor is already instantiating
      E.current !== null || // No active draggable
      !xn || // Event has already been captured
      In.dndKit || In.defaultPrevented
    )
      return;
    const ln = {
      active: xn
    };
    jt(fi, Zi.options, ln) === !0 && (In.dndKit = {
      capturedBy: Zi.sensor
    }, E.current = on, Pe(fi, Zi));
  }, [H, Pe]), kt = adt(d, Oe);
  hdt(d), Wl(() => {
    $e && W === Bd.Initializing && V(Bd.Initialized);
  }, [$e, W]), et(
    () => {
      const {
        onDragMove: jt
      } = le.current, {
        active: Zi,
        activatorEvent: fi,
        collisions: on,
        over: In
      } = dt.current;
      if (!Zi || !fi)
        return;
      const xn = {
        active: Zi,
        activatorEvent: fi,
        collisions: on,
        delta: {
          x: Ut.x,
          y: Ut.y
        },
        over: In
      };
      em(() => {
        jt == null || jt(xn), G({
          type: "onDragMove",
          event: xn
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ut.x, Ut.y]
  ), et(
    () => {
      const {
        active: jt,
        activatorEvent: Zi,
        collisions: fi,
        droppableContainers: on,
        scrollAdjustedTranslate: In
      } = dt.current;
      if (!jt || E.current == null || !Zi || !In)
        return;
      const {
        onDragOver: xn
      } = le.current, ln = on.get(_e), ug = ln && ln.rect.current ? {
        id: ln.id,
        rect: ln.rect.current,
        data: ln.data,
        disabled: ln.disabled
      } : null, Ti = {
        active: jt,
        activatorEvent: Zi,
        collisions: fi,
        delta: {
          x: In.x,
          y: In.y
        },
        over: ug
      };
      em(() => {
        Jt(ug), xn == null || xn(Ti), G({
          type: "onDragOver",
          event: Ti
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [_e]
  ), Wl(() => {
    dt.current = {
      activatorEvent: Q,
      active: q,
      activeNode: ue,
      collisionRect: Ge,
      collisions: pe,
      droppableRects: Je,
      draggableNodes: H,
      draggingNode: tt,
      draggingNodeRect: st,
      droppableContainers: N,
      over: Gt,
      scrollableAncestors: Ce,
      scrollAdjustedTranslate: Ut
    }, $.current = {
      initial: st,
      translated: Ge
    };
  }, [q, ue, pe, Ge, H, tt, st, Je, N, Gt, Ce, Ut]), odt({
    ...Ze,
    delta: x,
    draggingRect: Ge,
    pointerCoordinates: Ye,
    scrollableAncestors: Ce,
    scrollableAncestorRects: xe
  });
  const Nt = je(() => ({
    active: q,
    activeNode: ue,
    activeNodeRect: $e,
    activatorEvent: Q,
    collisions: pe,
    containerNodeRect: rt,
    dragOverlay: ze,
    draggableNodes: H,
    droppableContainers: N,
    droppableRects: Je,
    over: Gt,
    measureDroppableContainers: ve,
    scrollableAncestors: Ce,
    scrollableAncestorRects: xe,
    measuringConfiguration: Ee,
    measuringScheduled: Be,
    windowRect: J
  }), [q, ue, $e, Q, pe, rt, ze, H, N, Je, Gt, ve, Ce, xe, Ee, Be, J]), ni = je(() => ({
    activatorEvent: Q,
    activators: kt,
    active: q,
    activeNodeRect: $e,
    ariaDescribedById: {
      draggable: Ae
    },
    dispatch: f,
    draggableNodes: H,
    over: Gt,
    measureDroppableContainers: ve
  }), [Q, kt, q, $e, f, Ae, H, Gt, ve]);
  return Se.createElement(gq.Provider, {
    value: y
  }, Se.createElement(hf.Provider, {
    value: ni
  }, Se.createElement(fq.Provider, {
    value: Nt
  }, Se.createElement(m2.Provider, {
    value: Xt
  }, a)), Se.createElement(Vdt, {
    disabled: (I == null ? void 0 : I.restoreFocus) === !1
  })), Se.createElement(Xct, {
    ...I,
    hiddenTextDescribedById: Ae
  }));
  function si() {
    const jt = (L == null ? void 0 : L.autoScrollEnabled) === !1, Zi = typeof s == "object" ? s.enabled === !1 : s === !1, fi = w && !jt && !Zi;
    return typeof s == "object" ? {
      ...s,
      enabled: fi
    } : {
      enabled: fi
    };
  }
}), Xdt = /* @__PURE__ */ Bs(null), EM = "button", Hdt = "Droppable";
function kdt(e) {
  let {
    id: t,
    data: i,
    disabled: n = !1,
    attributes: g
  } = e;
  const r = mf(Hdt), {
    activators: o,
    activatorEvent: I,
    active: s,
    activeNodeRect: a,
    ariaDescribedById: d,
    draggableNodes: C,
    over: u
  } = Hn(hf), {
    role: A = EM,
    roleDescription: m = "draggable",
    tabIndex: h = 0
  } = g ?? {}, B = (s == null ? void 0 : s.id) === t, f = Hn(B ? m2 : Xdt), [G, y] = pV(), [W, V] = pV(), w = pdt(o, t), v = sZ(i);
  Wl(
    () => (C.set(t, {
      id: t,
      key: r,
      node: G,
      activatorNode: W,
      data: v
    }), () => {
      const x = C.get(t);
      x && x.key === r && C.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [C, t]
  );
  const H = je(() => ({
    role: A,
    tabIndex: h,
    "aria-disabled": n,
    "aria-pressed": B && A === EM ? !0 : void 0,
    "aria-roledescription": m,
    "aria-describedby": d.draggable
  }), [n, A, h, B, m, d.draggable]);
  return {
    active: s,
    activatorEvent: I,
    activeNodeRect: a,
    attributes: H,
    isDragging: B,
    listeners: n ? void 0 : w,
    node: G,
    over: u,
    setNodeRef: y,
    setActivatorNodeRef: V,
    transform: f
  };
}
function yq() {
  return Hn(fq);
}
const Fdt = "Droppable", Ydt = {
  timeout: 25
};
function xdt(e) {
  let {
    data: t,
    disabled: i = !1,
    id: n,
    resizeObserverConfig: g
  } = e;
  const r = mf(Fdt), {
    active: o,
    dispatch: I,
    over: s,
    measureDroppableContainers: a
  } = Hn(hf), d = Ct({
    disabled: i
  }), C = Ct(!1), u = Ct(null), A = Ct(null), {
    disabled: m,
    updateMeasurementsFor: h,
    timeout: B
  } = {
    ...Ydt,
    ...g
  }, f = sZ(h ?? n), G = ft(
    () => {
      if (!C.current) {
        C.current = !0;
        return;
      }
      A.current != null && clearTimeout(A.current), A.current = setTimeout(() => {
        a(Array.isArray(f.current) ? f.current : [f.current]), A.current = null;
      }, B);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [B]
  ), y = b2({
    callback: G,
    disabled: m || !o
  }), W = ft((H, x) => {
    y && (x && (y.unobserve(x), C.current = !1), H && y.observe(H));
  }, [y]), [V, w] = pV(W), v = sZ(t);
  return et(() => {
    !y || !V.current || (y.disconnect(), C.current = !1, y.observe(V.current));
  }, [V, y]), Wl(
    () => (I({
      type: Pg.RegisterDroppable,
      element: {
        id: n,
        key: r,
        disabled: i,
        node: V,
        rect: u,
        data: v
      }
    }), () => I({
      type: Pg.UnregisterDroppable,
      key: r,
      id: n
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  ), et(() => {
    i !== d.current.disabled && (I({
      type: Pg.SetDroppableDisabled,
      id: n,
      key: r,
      disabled: i
    }), d.current.disabled = i);
  }, [n, r, i, I]), {
    active: o,
    rect: u,
    isOver: (s == null ? void 0 : s.id) === n,
    node: V,
    over: s,
    setNodeRef: w
  };
}
function Ddt(e) {
  let {
    animation: t,
    children: i
  } = e;
  const [n, g] = At(null), [r, o] = At(null), I = BV(i);
  return !i && !n && I && g(I), Wl(() => {
    if (!r)
      return;
    const s = n == null ? void 0 : n.key, a = n == null ? void 0 : n.props.id;
    if (s == null || a == null) {
      g(null);
      return;
    }
    Promise.resolve(t(a, r)).then(() => {
      g(null);
    });
  }, [t, n, r]), Se.createElement(Se.Fragment, null, i, n ? wu(n, {
    ref: o
  }) : null);
}
const Jdt = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function Kdt(e) {
  let {
    children: t
  } = e;
  return Se.createElement(hf.Provider, {
    value: Zq
  }, Se.createElement(m2.Provider, {
    value: Jdt
  }, t));
}
const Edt = {
  position: "fixed",
  touchAction: "none"
}, Ndt = (e) => A2(e) ? "transform 250ms ease" : void 0, Ldt = /* @__PURE__ */ Sl((e, t) => {
  let {
    as: i,
    activatorEvent: n,
    adjustScale: g,
    children: r,
    className: o,
    rect: I,
    style: s,
    transform: a,
    transition: d = Ndt
  } = e;
  if (!I)
    return null;
  const C = g ? a : {
    ...a,
    scaleX: 1,
    scaleY: 1
  }, u = {
    ...Edt,
    width: I.width,
    height: I.height,
    top: I.top,
    left: I.left,
    transform: Lu.Transform.toString(C),
    transformOrigin: g && n ? Fct(n, I) : void 0,
    transition: typeof d == "function" ? d(n) : d,
    ...s
  };
  return Se.createElement(i, {
    className: o,
    style: u,
    ref: t
  }, r);
}), Tdt = (e) => (t) => {
  let {
    active: i,
    dragOverlay: n
  } = t;
  const g = {}, {
    styles: r,
    className: o
  } = e;
  if (r != null && r.active)
    for (const [I, s] of Object.entries(r.active))
      s !== void 0 && (g[I] = i.node.style.getPropertyValue(I), i.node.style.setProperty(I, s));
  if (r != null && r.dragOverlay)
    for (const [I, s] of Object.entries(r.dragOverlay))
      s !== void 0 && n.node.style.setProperty(I, s);
  return o != null && o.active && i.node.classList.add(o.active), o != null && o.dragOverlay && n.node.classList.add(o.dragOverlay), function() {
    for (const [s, a] of Object.entries(g))
      i.node.style.setProperty(s, a);
    o != null && o.active && i.node.classList.remove(o.active);
  };
}, Mdt = (e) => {
  let {
    transform: {
      initial: t,
      final: i
    }
  } = e;
  return [{
    transform: Lu.Transform.toString(t)
  }, {
    transform: Lu.Transform.toString(i)
  }];
}, Udt = {
  duration: 250,
  easing: "ease",
  keyframes: Mdt,
  sideEffects: /* @__PURE__ */ Tdt({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function Pdt(e) {
  let {
    config: t,
    draggableNodes: i,
    droppableContainers: n,
    measuringConfiguration: g
  } = e;
  return u2((r, o) => {
    if (t === null)
      return;
    const I = i.get(r);
    if (!I)
      return;
    const s = I.node.current;
    if (!s)
      return;
    const a = Bq(o);
    if (!a)
      return;
    const {
      transform: d
    } = Vo(o).getComputedStyle(o), C = oq(d);
    if (!C)
      return;
    const u = typeof t == "function" ? t : zdt(t);
    return Cq(s, g.draggable.measure), u({
      active: {
        id: r,
        data: I.data,
        node: s,
        rect: g.draggable.measure(s)
      },
      draggableNodes: i,
      dragOverlay: {
        node: o,
        rect: g.dragOverlay.measure(a)
      },
      droppableContainers: n,
      measuringConfiguration: g,
      transform: C
    });
  });
}
function zdt(e) {
  const {
    duration: t,
    easing: i,
    sideEffects: n,
    keyframes: g
  } = {
    ...Udt,
    ...e
  };
  return (r) => {
    let {
      active: o,
      dragOverlay: I,
      transform: s,
      ...a
    } = r;
    if (!t)
      return;
    const d = {
      x: I.rect.left - o.rect.left,
      y: I.rect.top - o.rect.top
    }, C = {
      scaleX: s.scaleX !== 1 ? o.rect.width * s.scaleX / I.rect.width : 1,
      scaleY: s.scaleY !== 1 ? o.rect.height * s.scaleY / I.rect.height : 1
    }, u = {
      x: s.x - d.x,
      y: s.y - d.y,
      ...C
    }, A = g({
      ...a,
      active: o,
      dragOverlay: I,
      transform: {
        initial: s,
        final: u
      }
    }), [m] = A, h = A[A.length - 1];
    if (JSON.stringify(m) === JSON.stringify(h))
      return;
    const B = n == null ? void 0 : n({
      active: o,
      dragOverlay: I,
      ...a
    }), f = I.node.animate(A, {
      duration: t,
      easing: i,
      fill: "forwards"
    });
    return new Promise((G) => {
      f.onfinish = () => {
        B == null || B(), G();
      };
    });
  };
}
let NM = 0;
function Odt(e) {
  return je(() => {
    if (e != null)
      return NM++, NM;
  }, [e]);
}
const Qdt = /* @__PURE__ */ Se.memo((e) => {
  let {
    adjustScale: t = !1,
    children: i,
    dropAnimation: n,
    style: g,
    transition: r,
    modifiers: o,
    wrapperElement: I = "div",
    className: s,
    zIndex: a = 999
  } = e;
  const {
    activatorEvent: d,
    active: C,
    activeNodeRect: u,
    containerNodeRect: A,
    draggableNodes: m,
    droppableContainers: h,
    dragOverlay: B,
    over: f,
    measuringConfiguration: G,
    scrollableAncestors: y,
    scrollableAncestorRects: W,
    windowRect: V
  } = yq(), w = Hn(m2), v = Odt(C == null ? void 0 : C.id), H = Gq(o, {
    activatorEvent: d,
    active: C,
    activeNodeRect: u,
    containerNodeRect: A,
    draggingNodeRect: B.rect,
    over: f,
    overlayNodeRect: B.rect,
    scrollableAncestors: y,
    scrollableAncestorRects: W,
    transform: w,
    windowRect: V
  }), x = vK(u), N = Pdt({
    config: n,
    draggableNodes: m,
    droppableContainers: h,
    measuringConfiguration: G
  }), M = x ? B.setRef : void 0;
  return Se.createElement(Kdt, null, Se.createElement(Ddt, {
    animation: N
  }, C && v ? Se.createElement(Ldt, {
    key: v,
    id: C.id,
    ref: M,
    as: I,
    activatorEvent: d,
    adjustScale: t,
    className: s,
    transition: r,
    rect: x,
    style: {
      zIndex: a,
      ...g
    },
    transform: H
  }, i) : null));
});
function Wq(e, t, i) {
  const n = e.slice();
  return n.splice(i < 0 ? n.length + i : i, 0, n.splice(t, 1)[0]), n;
}
function jdt(e, t) {
  return e.reduce((i, n, g) => {
    const r = t.get(n);
    return r && (i[g] = r), i;
  }, Array(e.length));
}
function xW(e) {
  return e !== null && e >= 0;
}
function _dt(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let i = 0; i < e.length; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function $dt(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const RK = (e) => {
  let {
    rects: t,
    activeIndex: i,
    overIndex: n,
    index: g
  } = e;
  const r = Wq(t, n, i), o = t[g], I = r[g];
  return !I || !o ? null : {
    x: I.left - o.left,
    y: I.top - o.top,
    scaleX: I.width / o.width,
    scaleY: I.height / o.height
  };
}, Sq = "Sortable", Vq = /* @__PURE__ */ Se.createContext({
  activeIndex: -1,
  containerId: Sq,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: RK,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function qdt(e) {
  let {
    children: t,
    id: i,
    items: n,
    strategy: g = RK,
    disabled: r = !1
  } = e;
  const {
    active: o,
    dragOverlay: I,
    droppableRects: s,
    over: a,
    measureDroppableContainers: d
  } = yq(), C = mf(Sq, i), u = I.rect !== null, A = je(() => n.map((w) => typeof w == "object" && "id" in w ? w.id : w), [n]), m = o != null, h = o ? A.indexOf(o.id) : -1, B = a ? A.indexOf(a.id) : -1, f = Ct(A), G = !_dt(A, f.current), y = B !== -1 && h === -1 || G, W = $dt(r);
  Wl(() => {
    G && m && d(A);
  }, [G, A, m, d]), et(() => {
    f.current = A;
  }, [A]);
  const V = je(
    () => ({
      activeIndex: h,
      containerId: C,
      disabled: W,
      disableTransforms: y,
      items: A,
      overIndex: B,
      useDragOverlay: u,
      sortedRects: jdt(A, s),
      strategy: g
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [h, C, W.draggable, W.droppable, y, A, B, s, u, g]
  );
  return Se.createElement(Vq.Provider, {
    value: V
  }, t);
}
const eCt = (e) => {
  let {
    id: t,
    items: i,
    activeIndex: n,
    overIndex: g
  } = e;
  return Wq(i, n, g).indexOf(t);
}, tCt = (e) => {
  let {
    containerId: t,
    isSorting: i,
    wasDragging: n,
    index: g,
    items: r,
    newIndex: o,
    previousItems: I,
    previousContainerId: s,
    transition: a
  } = e;
  return !a || !n || I !== r && g === o ? !1 : i ? !0 : o !== g && t === s;
}, iCt = {
  duration: 200,
  easing: "ease"
}, wq = "transform", nCt = /* @__PURE__ */ Lu.Transition.toString({
  property: wq,
  duration: 0,
  easing: "linear"
}), gCt = {
  roleDescription: "sortable"
};
function rCt(e) {
  let {
    disabled: t,
    index: i,
    node: n,
    rect: g
  } = e;
  const [r, o] = At(null), I = Ct(i);
  return Wl(() => {
    if (!t && i !== I.current && n.current) {
      const s = g.current;
      if (s) {
        const a = Bh(n.current, {
          ignoreTransform: !0
        }), d = {
          x: s.left - a.left,
          y: s.top - a.top,
          scaleX: s.width / a.width,
          scaleY: s.height / a.height
        };
        (d.x || d.y) && o(d);
      }
    }
    i !== I.current && (I.current = i);
  }, [t, i, n, g]), et(() => {
    r && o(null);
  }, [r]), r;
}
function oCt(e) {
  let {
    animateLayoutChanges: t = tCt,
    attributes: i,
    disabled: n,
    data: g,
    getNewIndex: r = eCt,
    id: o,
    strategy: I,
    resizeObserverConfig: s,
    transition: a = iCt
  } = e;
  const {
    items: d,
    containerId: C,
    activeIndex: u,
    disabled: A,
    disableTransforms: m,
    sortedRects: h,
    overIndex: B,
    useDragOverlay: f,
    strategy: G
  } = Hn(Vq), y = ICt(n, A), W = d.indexOf(o), V = je(() => ({
    sortable: {
      containerId: C,
      index: W,
      items: d
    },
    ...g
  }), [C, g, W, d]), w = je(() => d.slice(d.indexOf(o)), [d, o]), {
    rect: v,
    node: H,
    isOver: x,
    setNodeRef: N
  } = xdt({
    id: o,
    data: V,
    disabled: y.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: w,
      ...s
    }
  }), {
    active: M,
    activatorEvent: $,
    activeNodeRect: q,
    attributes: E,
    setNodeRef: L,
    listeners: P,
    isDragging: Q,
    over: te,
    setActivatorNodeRef: le,
    transform: Ae
  } = kdt({
    id: o,
    data: V,
    attributes: {
      ...gCt,
      ...i
    },
    disabled: y.draggable
  }), we = hct(N, L), Ee = !!M, Je = Ee && !m && xW(u) && xW(B), ve = !f && Q, Be = ve && Je ? Ae : null, Xe = Je ? Be ?? (I ?? G)({
    rects: h,
    activeNodeRect: q,
    activeIndex: u,
    overIndex: B,
    index: W
  }) : null, Ze = xW(u) && xW(B) ? r({
    id: o,
    items: d,
    activeIndex: u,
    overIndex: B
  }) : W, Ke = M == null ? void 0 : M.id, $e = Ct({
    activeId: Ke,
    items: d,
    newIndex: Ze,
    containerId: C
  }), rt = d !== $e.current.items, dt = t({
    active: M,
    containerId: C,
    isDragging: Q,
    isSorting: Ee,
    id: o,
    index: W,
    items: d,
    newIndex: $e.current.newIndex,
    previousItems: $e.current.items,
    previousContainerId: $e.current.containerId,
    transition: a,
    wasDragging: $e.current.activeId != null
  }), ot = rCt({
    disabled: !dt,
    index: W,
    node: H,
    rect: v
  });
  return et(() => {
    Ee && $e.current.newIndex !== Ze && ($e.current.newIndex = Ze), C !== $e.current.containerId && ($e.current.containerId = C), d !== $e.current.items && ($e.current.items = d);
  }, [Ee, Ze, C, d]), et(() => {
    if (Ke === $e.current.activeId)
      return;
    if (Ke && !$e.current.activeId) {
      $e.current.activeId = Ke;
      return;
    }
    const tt = setTimeout(() => {
      $e.current.activeId = Ke;
    }, 50);
    return () => clearTimeout(tt);
  }, [Ke]), {
    active: M,
    activeIndex: u,
    attributes: E,
    data: V,
    rect: v,
    index: W,
    newIndex: Ze,
    items: d,
    isOver: x,
    isSorting: Ee,
    isDragging: Q,
    listeners: P,
    node: H,
    overIndex: B,
    over: te,
    setNodeRef: we,
    setActivatorNodeRef: le,
    setDroppableNodeRef: N,
    setDraggableNodeRef: L,
    transform: ot ?? Xe,
    transition: ze()
  };
  function ze() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      ot || // Or to prevent items jumping to back to their "new" position when items change
      rt && $e.current.newIndex === W
    )
      return nCt;
    if (!(ve && !A2($) || !a) && (Ee || dt))
      return Lu.Transition.toString({
        ...a,
        property: wq
      });
  }
}
function ICt(e, t) {
  var i, n;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (i = e == null ? void 0 : e.draggable) != null ? i : t.draggable,
    droppable: (n = e == null ? void 0 : e.droppable) != null ? n : t.droppable
  };
}
dn.Down, dn.Right, dn.Up, dn.Left;
const lCt = (e) => {
  const {
    t
  } = ii();
  return /* @__PURE__ */ p(Cn, { title: t("Komponente hinzufügen"), disableInteractive: !0, children: /* @__PURE__ */ p(mi, { className: "k3-component-cards-add-button", sx: {
    position: "absolute",
    bottom: 1,
    right: 1
  }, color: "primary", "data-cy": "addComponentButton", children: /* @__PURE__ */ p(I6e, {}) }) });
}, vq = ({
  variable: e,
  contextInstance: t
}) => {
  const i = zt(), n = cA(t, e, !1), [g, r] = At([]);
  et(() => {
    r(n.map((m) => ({
      id: m.selection.id,
      selection: m
    })));
  }, [n]);
  const o = Hct(RM(mq, {
    activationConstraint: {
      distance: 20
    }
  }), RM(hq, {
    activationConstraint: {
      distance: 20
    }
  })), [I, s] = At(null), a = je(() => n.find((m) => m.selection.id === I), [I, n]), d = (m) => {
    s(m.active.id.toString());
  }, C = (m) => {
    s(null), i(_$(e.settings.templateOptions.reverseSorting ? g.map((h) => h.selection.selection).reverse() : g.map((h) => h.selection.selection)));
  }, u = () => {
    s(null);
  }, A = ft((m) => {
    const {
      active: h,
      over: B
    } = m;
    if (h.data.current && (B != null && B.data.current) && h.id !== B.id) {
      const f = h.data.current.sortable.index, G = B.data.current.sortable.index;
      r((y) => {
        const W = [...y], [V] = W.splice(f, 1);
        return W.splice(G, 0, V), W;
      });
    }
  }, []);
  return /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ ge(Rdt, { sensors: o, collisionDetection: Jct, onDragStart: d, onDragEnd: C, onDragCancel: u, onDragMove: A, children: [
    /* @__PURE__ */ p(qdt, { items: g, strategy: RK, children: /* @__PURE__ */ p(Cc, { component: "div", sx: {
      overflowX: "auto",
      display: "grid",
      // grid left ro right, top to bottom 50px x 50px
      gridTemplateColumns: "repeat(auto-fill, 65px)",
      gridAutoRows: "65px"
    }, children: g.map(({
      id: m,
      selection: h
    }) => /* @__PURE__ */ p(LM, { selection: h, contextInstance: t, variable: e }, m)) }) }),
    /* @__PURE__ */ p(Qdt, { adjustScale: !0, style: {
      transformOrigin: "0 0 ",
      background: "white"
    }, children: a ? /* @__PURE__ */ p(LM, { selection: a, variable: e, contextInstance: t, tooltip: !1 }) : null })
  ] }) });
}, LM = ({
  selection: e,
  contextInstance: t,
  variable: i,
  tooltip: n = !0
}) => {
  const {
    isDragging: g,
    attributes: r,
    listeners: o,
    setNodeRef: I
  } = oCt({
    id: e.selection.id
  }), s = zt(), {
    palette: a
  } = qo(), d = _(Wc), C = RI((f) => f.hoveredSelections), u = RI((f) => f.setHoveredSelection), A = RI((f) => f.removeHoveredSelection), {
    t: m
  } = ii(), h = Li(), B = C.includes(e.selection.id) || d.some((f) => f.id === e.selection.id);
  return /* @__PURE__ */ p(Cn, { open: g || !n ? !1 : void 0, title: /* @__PURE__ */ p(fc, { variable: i, variableValue: e.value, templateOptions: hi(i), style: {
    marginTop: 2,
    marginBottom: 2
  } }, e.selection.id), children: /* @__PURE__ */ p(fs, { children: /* @__PURE__ */ ge(
    "div",
    {
      "data-cy": "selection-" + e.selection.id,
      ref: I,
      className: "k3-component-card-list-item",
      style: {
        position: "relative",
        padding: 1,
        border: B ? `solid 1px ${a.divider}` : "none",
        borderRadius: "8px",
        opacity: g ? 0.5 : 1,
        width: "60px",
        height: "60px"
      },
      onMouseDown: () => A(e.selection.id),
      onMouseEnter: () => u(e.selection.id),
      onMouseLeave: () => A(e.selection.id),
      ...r,
      ...o,
      onClick: (f) => {
        s(ig(e.selection.id));
      },
      children: [
        /* @__PURE__ */ p(fc, { variable: i, variableValue: e.value, templateOptions: hi(i), verticalDisplay: !0, style: {
          overflow: "hidden"
        } }, e.selection.id),
        B && // remove instance button
        /* @__PURE__ */ p(Cn, { title: m("Entfernen"), children: /* @__PURE__ */ p(mi, { "data-cy": "removeInstanceButton", sx: {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "15px",
          height: "15px",
          // force visible despite overflow hidden
          overflow: "visible",
          zIndex: 1e3
        }, onMouseDown: (f) => {
          f.stopPropagation();
        }, onClick: (f) => {
          f.stopPropagation(), s(sf(e.selection)), h.id === e.selection.id && s(ig(t.id));
        }, children: /* @__PURE__ */ p(TZ, { sx: {
          width: "15px",
          height: "15px"
        } }) }) })
      ]
    }
  ) }) }, e.selection.id);
}, sCt = ({
  variable: e,
  values: t,
  contextInstance: i,
  ...n
}) => {
  const g = zt(), r = (I) => {
    g(UIt(I, i));
  }, o = cA(i, e, !1);
  return /* @__PURE__ */ p(pr, { variable: e, view: /* @__PURE__ */ ge(Bt, { children: [
    (o == null ? void 0 : o.length) > 0 && /* @__PURE__ */ ge("div", { className: "k3-component-card-list", children: [
      /* @__PURE__ */ p(vq, { variable: e, contextInstance: i }),
      /* @__PURE__ */ p(bs, { sx: {
        marginY: 1
      } })
    ] }),
    /* @__PURE__ */ p(eq, { ...uf(n), variable: e, values: t, onChange: r, ExtraContent: lCt })
  ] }) });
}, aCt = ce.flow(rI, ki({
  app: {
    sidebar: {
      componentValueCards: {
        root: !0
      }
    }
  }
}))(sCt), pf = (e) => {
  var g;
  const {
    selection: t,
    onChange: i,
    value: n
  } = e;
  return {
    text: (g = t == null ? void 0 : t.data) == null ? void 0 : g.inputText,
    onChange: ft((r) => !!(n != null && n.id) && i(n.id, {
      inputText: r
    }), [i, n == null ? void 0 : n.id])
  };
}, cCt = (e) => {
  const {
    onChange: t
  } = pf(e);
  return /* @__PURE__ */ p(pr, { variable: e.variable, view: /* @__PURE__ */ p($n, { "data-cy": "hidden", disabled: !0, fullWidth: !0, value: "Versteckt", onChange: t }) });
}, dCt = no("hidden")(cCt);
var XK = {}, CCt = Cg;
Object.defineProperty(XK, "__esModule", {
  value: !0
});
var Rq = XK.default = void 0, uCt = CCt(Kg()), ACt = xg;
Rq = XK.default = (0, uCt.default)(/* @__PURE__ */ (0, ACt.jsx)("path", {
  d: "M19 12h-2v3h-3v2h5zM7 9h3V7H5v5h2zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16.01H3V4.99h18z"
}), "AspectRatio");
var HK = {}, bCt = Cg;
Object.defineProperty(HK, "__esModule", {
  value: !0
});
var Xq = HK.default = void 0, mCt = bCt(Kg()), hCt = xg;
Xq = HK.default = (0, mCt.default)(/* @__PURE__ */ (0, hCt.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");
const uF = Se.forwardRef(({
  debounced: e,
  throttle: t,
  label: i,
  onChange: n,
  value: g,
  sliderProps: r,
  sx: o,
  "data-cy": I
}, s) => {
  const a = je(() => !!e || !!t, [e, t]), [d, C] = At(g), u = ft(ce.debounce((B) => n(B), 16), [n]), A = ft(ce.throttle((B) => n(B), t), [n, t]), m = ft((B, f) => {
    C(f), t ? A(f) : e && u(f);
  }, [A, u, t, e]), h = ft((B, f) => n(f), [n]);
  return et(() => {
    a && C(g);
  }, [g, a]), /* @__PURE__ */ ge(fe, { component: "div", ref: s, sx: o, "data-cy": I, children: [
    /* @__PURE__ */ p(Ne, { color: "text.secondary", children: i }),
    /* @__PURE__ */ p(fe, { component: "div", sx: {
      height: 56,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }, children: /* @__PURE__ */ p(Dpe, { ...r, value: a ? d : g, onChange: a ? m : h, "data-cy": "slider" }) })
  ] });
});
function pCt({
  selection: e,
  app: t,
  handleImageChange: i,
  variable: n,
  printAreasAffectedByThisVariable: g,
  handleSliderChange: r,
  handleReset: o
}) {
  var s, a, d, C, u, A;
  const I = hi(n);
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(WJ, { storeLocally: !0, url: ((s = e == null ? void 0 : e.data) == null ? void 0 : s.url) || "", app: t, onDelete: () => i(""), onUrlChange: i, acceptedImageFormats: (a = n.settings.templateOptions.fileFormat) == null ? void 0 : a.split(",").map((m) => m.toLowerCase()), "data-cy": "imageUpload", target: "frontend" }),
    (g == null ? void 0 : g.length) > 0 && ((d = e == null ? void 0 : e.data) == null ? void 0 : d.url) && /* @__PURE__ */ ge(fe, { component: "div", sx: {
      mb: "30px"
    }, "data-cy": "imageUploadSliders", children: [
      /* @__PURE__ */ ge(fe, { component: "div", sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ p(u3, { sx: {
          height: "20px",
          marginRight: "16px",
          transform: "rotate(90deg)"
        } }),
        /* @__PURE__ */ p(uF, { sx: {
          width: "100%"
        }, sliderProps: {
          min: Number(I.minHorizontal ?? 0),
          max: Number(I.maxHorizontal ?? 100),
          size: "small",
          valueLabelDisplay: "auto"
        }, throttle: 33, value: (C = e.data) == null ? void 0 : C.leftright, "data-cy": "leftRight", onChange: (m) => r("leftright", m) })
      ] }),
      /* @__PURE__ */ ge(fe, { component: "div", sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ p(u3, { sx: {
          height: "20px",
          marginRight: "16px"
        } }),
        /* @__PURE__ */ p(uF, { sx: {
          width: "100%"
        }, sliderProps: {
          min: Number(I.minHorizontal ?? 0),
          max: Number(I.maxHorizontal ?? 100),
          size: "small",
          valueLabelDisplay: "auto"
        }, throttle: 33, "data-cy": "topBottom", value: (u = e.data) == null ? void 0 : u.topbottom, onChange: (m) => r("topbottom", m) })
      ] }),
      /* @__PURE__ */ ge(fe, { component: "div", sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ p(Xq, { sx: {
          height: "20px",
          marginRight: "16px"
        } }),
        /* @__PURE__ */ p(uF, { throttle: 33, sx: {
          width: "100%"
        }, sliderProps: {
          min: Number(I.minHorizontal ?? 0),
          max: Number(I.maxHorizontal ?? 100),
          size: "small",
          valueLabelDisplay: "auto"
        }, value: (A = e.data) == null ? void 0 : A.scale, "data-cy": "scale", onChange: (m) => r("scale", m) }),
        /* @__PURE__ */ p(mi, { sx: {
          marginLeft: "16px"
        }, "aria-label": "Upload picture", component: "span", onClick: o, "data-cy": "resetScale", children: /* @__PURE__ */ p(Rq, {}) })
      ] })
    ] })
  ] });
}
const DW = {
  topbottom: 50,
  leftright: 50,
  scale: 75
}, BCt = ({
  variable: e,
  value: t,
  selection: i,
  values: n,
  onChange: g
}) => {
  const r = n.find((A) => A.value == "1"), o = _(Vs);
  hi(e);
  const I = _(v$e(r == null ? void 0 : r.id)), a = _(lje("prints")).filter((A) => I.some((m) => m == A.targetMaterial)), d = ft((A) => {
    const m = n.find((h) => h.variableId == e.id && h.value == (A != null && A.length ? "1" : "0"));
    g(m.id || 0, {
      url: A,
      leftright: DW.leftright,
      topbottom: DW.topbottom,
      scale: DW.scale
    });
  }, [g, n, e.id]), C = ft((A, m) => {
    var h;
    ((h = i.data) == null ? void 0 : h[A]) !== m && g(t.id, {
      ...i.data,
      [A]: m
    });
  }, [g, i, t]), u = ft(() => {
    g(t.id, {
      ...i.data,
      ...DW
    });
  }, [g, i, t]);
  return /* @__PURE__ */ p(pr, { variable: e, view: /* @__PURE__ */ p(pCt, { selection: i, app: o, handleImageChange: d, variable: e, printAreasAffectedByThisVariable: a, handleSliderChange: C, handleReset: u }) });
}, ZCt = no("imageUpload")(BCt), fCt = (e) => {
  const {
    text: t,
    onChange: i
  } = pf(e);
  return et(() => {
    e.variable.description != t && i(e.variable.description || "");
  }, [e.variable.description, t, i]), /* @__PURE__ */ p(pr, { variable: e.variable, view: /* @__PURE__ */ p(Bt, {}) });
}, GCt = me.flow(rI, no("information"))(fCt), yCt = ye(Cn)(({
  theme: e
}) => ({
  tooltip: {
    backgroundColor: e.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: e.shadows[1],
    fontSize: 16,
    border: "solid 1px rgba(0, 0, 0, 0.87)"
  },
  arrow: {
    "&:before": {
      boxSizing: "border-box",
      border: "solid 1px rgba(0, 0, 0, 0.87)"
    },
    color: e.palette.common.white
  }
})), kK = ({
  isInRange: e,
  resetNumber: t,
  children: i,
  placement: n = "left-end",
  variable: g,
  ...r
}) => /* @__PURE__ */ p(yCt, { ...r, arrow: !0, placement: n, open: !e, title: !e && /* @__PURE__ */ p(SCt, { isInRange: e, resetNumber: t, placement: n, variable: g, children: /* @__PURE__ */ p(Bt, {}), ...r }), children: /* @__PURE__ */ p(fe, { component: "div", children: i }) }), WCt = ({
  resetNumber: e,
  ...t
}) => {
  const i = un();
  return /* @__PURE__ */ ge(fe, { component: "div", sx: {
    display: "grid",
    gridTemplateColumns: "min-content auto",
    gap: 1,
    alignItems: "center"
  }, children: [
    /* @__PURE__ */ p(Tj, { color: "error" }),
    i("translation_warning_number") + e,
    /* @__PURE__ */ p(Xl, { keys: ["translation_warning_number"], display: "dialog" })
  ] });
}, SCt = ki({
  app: {
    sidebar: {
      numberWarningTooltipContent: {
        root: !0
      }
    }
  }
})(WCt), TM = (e) => {
  var t;
  return me.toNumber(((t = e == null ? void 0 : e.data) == null ? void 0 : t.inputValue) || 0);
}, MM = {
  resetNumber: void 0,
  isInRange: !0
}, FK = (e, t, i, n) => {
  var C, u, A, m;
  const g = _(h1), r = ((u = (C = i == null ? void 0 : i.settings) == null ? void 0 : C.templateOptions) == null ? void 0 : u.digits) || 0, [o, I] = At(((m = (A = i == null ? void 0 : i.settings) == null ? void 0 : A.templateOptions) == null ? void 0 : m.min) || 0), [s, a] = At(MM);
  et(() => {
    var h;
    I((h = TM(t)) == null ? void 0 : h.OC_roundTo(r));
  }, [t, r]), et(() => {
    var h;
    g || I((h = TM(t)) == null ? void 0 : h.OC_roundTo(r));
  }, [g, r, t]), et(() => {
    let h;
    return s.isInRange || (h = setTimeout(() => a(MM), 5e3)), () => {
      h && clearTimeout(h);
    };
  }, [s]);
  const d = ft(
    // WHAT THE FUCK JS.
    // when used as onBlur function n is a number. onConfirm n is a string.
    (h) => {
      const B = +h, f = th(B, n, Od(i));
      f && (e(f.value.id, {
        inputValue: f.input.OC_roundTo(r)
      }), +B != +f.input && a({
        isInRange: !1,
        resetNumber: f.input
      }));
    },
    [r, e, n, i]
  );
  return {
    onNumberChange: I,
    onInputBlur: d,
    onImmediateChange: d,
    isInRange: s.isInRange,
    resetNumber: s.resetNumber,
    pureNumber: o
  };
}, VCt = ({
  variable: e,
  onChange: t,
  selection: i,
  values: n,
  disabled: g
}) => {
  const r = _(E$e), {
    onNumberChange: o,
    onInputBlur: I,
    isInRange: s,
    resetNumber: a,
    pureNumber: d
  } = FK(t, i, e, n);
  return /* @__PURE__ */ p(pr, { variable: e, view: /* @__PURE__ */ p(kK, { placement: r === mj.Left ? "left-end" : "right-end", variable: e, isInRange: s, resetNumber: a, children: /* @__PURE__ */ p(
    z1,
    {
      fullWidth: !0,
      disabled: g,
      value: d,
      onChange: o,
      onChangeByStep: I,
      onBlur: I,
      onConfirm: I,
      TextFieldProps: {
        error: !s
      },
      ...me.flow(hi, me.omit(["min", "max"]))(e),
      "data-cy": "numberInput"
    }
  ) }) });
}, wCt = me.flow(rI, no("number"))(VCt);
var UM = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function vCt(e, t) {
  return !!(e === t || UM(e) && UM(t));
}
function RCt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (!vCt(e[i], t[i]))
      return !1;
  return !0;
}
function yg(e, t) {
  t === void 0 && (t = RCt);
  var i, n = [], g, r = !1;
  function o() {
    for (var I = [], s = 0; s < arguments.length; s++)
      I[s] = arguments[s];
    return r && i === this && t(I, n) || (g = e.apply(this, I), r = !0, i = this, n = I), g;
  }
  return o;
}
var XCt = typeof performance == "object" && typeof performance.now == "function", PM = XCt ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function zM(e) {
  cancelAnimationFrame(e.id);
}
function HCt(e, t) {
  var i = PM();
  function n() {
    PM() - i >= t ? e.call(null) : g.id = requestAnimationFrame(n);
  }
  var g = {
    id: requestAnimationFrame(n)
  };
  return g;
}
var AF = -1;
function OM(e) {
  if (e === void 0 && (e = !1), AF === -1 || e) {
    var t = document.createElement("div"), i = t.style;
    i.width = "50px", i.height = "50px", i.overflow = "scroll", document.body.appendChild(t), AF = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return AF;
}
var zb = null;
function QM(e) {
  if (e === void 0 && (e = !1), zb === null || e) {
    var t = document.createElement("div"), i = t.style;
    i.width = "50px", i.height = "50px", i.overflow = "scroll", i.direction = "rtl";
    var n = document.createElement("div"), g = n.style;
    return g.width = "100px", g.height = "100px", t.appendChild(n), document.body.appendChild(t), t.scrollLeft > 0 ? zb = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? zb = "negative" : zb = "positive-ascending"), document.body.removeChild(t), zb;
  }
  return zb;
}
var kCt = 150, FCt = function(t, i) {
  return t;
};
function YCt(e) {
  var t, i = e.getItemOffset, n = e.getEstimatedTotalSize, g = e.getItemSize, r = e.getOffsetForIndexAndAlignment, o = e.getStartIndexForOffset, I = e.getStopIndexForStartIndex, s = e.initInstanceProps, a = e.shouldResetStyleCacheOnItemSizeChange, d = e.validateProps;
  return t = /* @__PURE__ */ function(C) {
    wZ(u, C);
    function u(m) {
      var h;
      return h = C.call(this, m) || this, h._instanceProps = s(h.props, us(h)), h._outerRef = void 0, h._resetIsScrollingTimeoutId = null, h.state = {
        instance: us(h),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof h.props.initialScrollOffset == "number" ? h.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, h._callOnItemsRendered = void 0, h._callOnItemsRendered = yg(function(B, f, G, y) {
        return h.props.onItemsRendered({
          overscanStartIndex: B,
          overscanStopIndex: f,
          visibleStartIndex: G,
          visibleStopIndex: y
        });
      }), h._callOnScroll = void 0, h._callOnScroll = yg(function(B, f, G) {
        return h.props.onScroll({
          scrollDirection: B,
          scrollOffset: f,
          scrollUpdateWasRequested: G
        });
      }), h._getItemStyle = void 0, h._getItemStyle = function(B) {
        var f = h.props, G = f.direction, y = f.itemSize, W = f.layout, V = h._getItemStyleCache(a && y, a && W, a && G), w;
        if (V.hasOwnProperty(B))
          w = V[B];
        else {
          var v = i(h.props, B, h._instanceProps), H = g(h.props, B, h._instanceProps), x = G === "horizontal" || W === "horizontal", N = G === "rtl", M = x ? v : 0;
          V[B] = w = {
            position: "absolute",
            left: N ? void 0 : M,
            right: N ? M : void 0,
            top: x ? 0 : v,
            height: x ? "100%" : H,
            width: x ? H : "100%"
          };
        }
        return w;
      }, h._getItemStyleCache = void 0, h._getItemStyleCache = yg(function(B, f, G) {
        return {};
      }), h._onScrollHorizontal = function(B) {
        var f = B.currentTarget, G = f.clientWidth, y = f.scrollLeft, W = f.scrollWidth;
        h.setState(function(V) {
          if (V.scrollOffset === y)
            return null;
          var w = h.props.direction, v = y;
          if (w === "rtl")
            switch (QM()) {
              case "negative":
                v = -y;
                break;
              case "positive-descending":
                v = W - G - y;
                break;
            }
          return v = Math.max(0, Math.min(v, W - G)), {
            isScrolling: !0,
            scrollDirection: V.scrollOffset < v ? "forward" : "backward",
            scrollOffset: v,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._onScrollVertical = function(B) {
        var f = B.currentTarget, G = f.clientHeight, y = f.scrollHeight, W = f.scrollTop;
        h.setState(function(V) {
          if (V.scrollOffset === W)
            return null;
          var w = Math.max(0, Math.min(W, y - G));
          return {
            isScrolling: !0,
            scrollDirection: V.scrollOffset < w ? "forward" : "backward",
            scrollOffset: w,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._outerRefSetter = function(B) {
        var f = h.props.outerRef;
        h._outerRef = B, typeof f == "function" ? f(B) : f != null && typeof f == "object" && f.hasOwnProperty("current") && (f.current = B);
      }, h._resetIsScrollingDebounced = function() {
        h._resetIsScrollingTimeoutId !== null && zM(h._resetIsScrollingTimeoutId), h._resetIsScrollingTimeoutId = HCt(h._resetIsScrolling, kCt);
      }, h._resetIsScrolling = function() {
        h._resetIsScrollingTimeoutId = null, h.setState({
          isScrolling: !1
        }, function() {
          h._getItemStyleCache(-1, null);
        });
      }, h;
    }
    u.getDerivedStateFromProps = function(h, B) {
      return xCt(h, B), d(h), null;
    };
    var A = u.prototype;
    return A.scrollTo = function(h) {
      h = Math.max(0, h), this.setState(function(B) {
        return B.scrollOffset === h ? null : {
          scrollDirection: B.scrollOffset < h ? "forward" : "backward",
          scrollOffset: h,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, A.scrollToItem = function(h, B) {
      B === void 0 && (B = "auto");
      var f = this.props, G = f.itemCount, y = f.layout, W = this.state.scrollOffset;
      h = Math.max(0, Math.min(h, G - 1));
      var V = 0;
      if (this._outerRef) {
        var w = this._outerRef;
        y === "vertical" ? V = w.scrollWidth > w.clientWidth ? OM() : 0 : V = w.scrollHeight > w.clientHeight ? OM() : 0;
      }
      this.scrollTo(r(this.props, h, B, W, this._instanceProps, V));
    }, A.componentDidMount = function() {
      var h = this.props, B = h.direction, f = h.initialScrollOffset, G = h.layout;
      if (typeof f == "number" && this._outerRef != null) {
        var y = this._outerRef;
        B === "horizontal" || G === "horizontal" ? y.scrollLeft = f : y.scrollTop = f;
      }
      this._callPropsCallbacks();
    }, A.componentDidUpdate = function() {
      var h = this.props, B = h.direction, f = h.layout, G = this.state, y = G.scrollOffset, W = G.scrollUpdateWasRequested;
      if (W && this._outerRef != null) {
        var V = this._outerRef;
        if (B === "horizontal" || f === "horizontal")
          if (B === "rtl")
            switch (QM()) {
              case "negative":
                V.scrollLeft = -y;
                break;
              case "positive-ascending":
                V.scrollLeft = y;
                break;
              default:
                var w = V.clientWidth, v = V.scrollWidth;
                V.scrollLeft = v - w - y;
                break;
            }
          else
            V.scrollLeft = y;
        else
          V.scrollTop = y;
      }
      this._callPropsCallbacks();
    }, A.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && zM(this._resetIsScrollingTimeoutId);
    }, A.render = function() {
      var h = this.props, B = h.children, f = h.className, G = h.direction, y = h.height, W = h.innerRef, V = h.innerElementType, w = h.innerTagName, v = h.itemCount, H = h.itemData, x = h.itemKey, N = x === void 0 ? FCt : x, M = h.layout, $ = h.outerElementType, q = h.outerTagName, E = h.style, L = h.useIsScrolling, P = h.width, Q = this.state.isScrolling, te = G === "horizontal" || M === "horizontal", le = te ? this._onScrollHorizontal : this._onScrollVertical, Ae = this._getRangeToRender(), we = Ae[0], Ee = Ae[1], Je = [];
      if (v > 0)
        for (var ve = we; ve <= Ee; ve++)
          Je.push(ga(B, {
            data: H,
            key: N(ve, H),
            index: ve,
            isScrolling: L ? Q : void 0,
            style: this._getItemStyle(ve)
          }));
      var Be = n(this.props, this._instanceProps);
      return ga($ || q || "div", {
        className: f,
        onScroll: le,
        ref: this._outerRefSetter,
        style: k({
          position: "relative",
          height: y,
          width: P,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: G
        }, E)
      }, ga(V || w || "div", {
        children: Je,
        ref: W,
        style: {
          height: te ? "100%" : Be,
          pointerEvents: Q ? "none" : void 0,
          width: te ? Be : "100%"
        }
      }));
    }, A._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var h = this.props.itemCount;
        if (h > 0) {
          var B = this._getRangeToRender(), f = B[0], G = B[1], y = B[2], W = B[3];
          this._callOnItemsRendered(f, G, y, W);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var V = this.state, w = V.scrollDirection, v = V.scrollOffset, H = V.scrollUpdateWasRequested;
        this._callOnScroll(w, v, H);
      }
    }, A._getRangeToRender = function() {
      var h = this.props, B = h.itemCount, f = h.overscanCount, G = this.state, y = G.isScrolling, W = G.scrollDirection, V = G.scrollOffset;
      if (B === 0)
        return [0, 0, 0, 0];
      var w = o(this.props, V, this._instanceProps), v = I(this.props, w, V, this._instanceProps), H = !y || W === "backward" ? Math.max(1, f) : 1, x = !y || W === "forward" ? Math.max(1, f) : 1;
      return [Math.max(0, w - H), Math.max(0, Math.min(B - 1, v + x)), w, v];
    }, u;
  }(jne), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var xCt = function(t, i) {
  t.children, t.direction, t.height, t.layout, t.innerTagName, t.outerTagName, t.width, i.instance;
}, DCt = /* @__PURE__ */ YCt({
  getItemOffset: function(t, i) {
    var n = t.itemSize;
    return i * n;
  },
  getItemSize: function(t, i) {
    var n = t.itemSize;
    return n;
  },
  getEstimatedTotalSize: function(t) {
    var i = t.itemCount, n = t.itemSize;
    return n * i;
  },
  getOffsetForIndexAndAlignment: function(t, i, n, g, r, o) {
    var I = t.direction, s = t.height, a = t.itemCount, d = t.itemSize, C = t.layout, u = t.width, A = I === "horizontal" || C === "horizontal", m = A ? u : s, h = Math.max(0, a * d - m), B = Math.min(h, i * d), f = Math.max(0, i * d - m + d + o);
    switch (n === "smart" && (g >= f - m && g <= B + m ? n = "auto" : n = "center"), n) {
      case "start":
        return B;
      case "end":
        return f;
      case "center": {
        var G = Math.round(f + (B - f) / 2);
        return G < Math.ceil(m / 2) ? 0 : G > h + Math.floor(m / 2) ? h : G;
      }
      case "auto":
      default:
        return g >= f && g <= B ? g : g < f ? f : B;
    }
  },
  getStartIndexForOffset: function(t, i) {
    var n = t.itemCount, g = t.itemSize;
    return Math.max(0, Math.min(n - 1, Math.floor(i / g)));
  },
  getStopIndexForStartIndex: function(t, i, n) {
    var g = t.direction, r = t.height, o = t.itemCount, I = t.itemSize, s = t.layout, a = t.width, d = g === "horizontal" || s === "horizontal", C = i * I, u = d ? a : r, A = Math.ceil((u + n - C) / I);
    return Math.max(0, Math.min(
      o - 1,
      i + A - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(t) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(t) {
    t.itemSize;
  }
});
F8([O$]);
const Rx = 86, JCt = 16, jM = Rx - JCt, KCt = ({
  style: e,
  data: t,
  color: i
}) => {
  const {
    t: n
  } = ii();
  if (!i)
    return null;
  const g = i.mainLabel || n(i.de || "");
  return /* @__PURE__ */ p("div", { style: e, className: "k3-ral-item-container", children: /* @__PURE__ */ p(aA, { invalid: i == null ? void 0 : i.hasTouchedConflicts, children: /* @__PURE__ */ ge(rD, { disabled: t.disabled || !i.hex, onClick: () => t.onClick(i), sx: {
    px: 1,
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: (r) => r.spacing(1),
    alignItems: "center",
    boxSizing: "border-box"
  }, className: Ve("k3-ral-item", t.selectedHex === i.hex ? "MuiChecked selected" : "", i.hasTouchedConflicts && "invalid-option"), children: [
    /* @__PURE__ */ p(Q$, { disabled: t.disabled, isActive: t.selectedHex === i.hex, hexColor: i.hex, width: jM, height: jM, borderRadius: t.borderRadius, className: "k3-ral-item-color" }),
    /* @__PURE__ */ p(fe, { component: "div", sx: {
      display: "flex",
      flexDirection: "column"
    }, className: "k3-ral-item-value", children: i.hex ? /* @__PURE__ */ ge(Bt, { children: [
      /* @__PURE__ */ p(Ne, { color: "text.primary", className: "k3-ral-item-value", children: i != null && i.dontAddPrefix ? i.code : `RAL ${i.code}` }),
      !!g && /* @__PURE__ */ p(Ne, { color: "text.primary", className: "k3-ral-item-label", children: g }),
      /* @__PURE__ */ ge(Ne, { variant: "subtitle2", color: "text.secondary", className: "k3-ral-item-description", children: [
        i.scope,
        " "
      ] })
    ] }) : /* @__PURE__ */ p(Ne, { color: "error", children: "Invalid RAL value" }) })
  ] }) }) });
}, ECt = ({
  disabled: e = !1,
  label: t,
  onChange: i,
  ralColors: n,
  value: g,
  visibleColorCount: r = 4,
  borderRadius: o = 1
}) => {
  const {
    t: I
  } = ii(), [s, a] = At(""), [d, C] = At(), u = Se.createRef();
  et(() => {
    if (!d) {
      const f = me.findIndex((G) => G.hex === g, n);
      if (f >= 0) {
        const G = u.current;
        G == null || G.scrollToItem(f, "center"), C(n[f].hex);
      }
    }
  }, [u, d, n, g]);
  const A = je(() => {
    if (!s)
      return n;
    const f = new RegExp(me.replace(/\s+/g, ".*", s), "i"), G = new RegExp(me.replace(/\s+/g, "\\s*", s), "i");
    return me.filter((y) => f.test(y.mainLabel || y.de || I(y.de || "")) || G.test(`RAL${me.replace(/\s+/g, "", y.code)}`), n);
  }, [s, n]), m = ft((f) => {
    C(f.hex), i(f.hex, f.mainLabel || "");
  }, [i]), h = je(() => ({
    onClick: m,
    selectedHex: d,
    disabled: e,
    borderRadius: o
  }), [m, d, e, o]), B = ({
    index: f,
    style: G
  }) => /* @__PURE__ */ p(KCt, { index: f, color: A[f], data: h, style: G });
  return /* @__PURE__ */ ge(fe, { component: "div", className: "k3-ral-container", sx: {
    display: "grid",
    gridTemplateRows: "max-content max-content max-content",
    gridGap: (f) => f.spacing(1)
  }, children: [
    !!t && /* @__PURE__ */ p(Ne, { color: "textSecondary", className: "k3-ral-label", children: t }),
    /* @__PURE__ */ p($n, { "data-cy": "ralText", disabled: e, className: "k3-ral-search-bar", onChange: a, fullWidth: !0, debounced: !0, TextFieldProps: {
      InputProps: {
        endAdornment: /* @__PURE__ */ p(pm, { position: "end", children: /* @__PURE__ */ p(Mj, {}) })
      }
    } }),
    /* @__PURE__ */ p(DCt, { ref: u, height: Math.min(r, n.length || 1) * Rx, itemCount: A.length, itemSize: Rx, className: "k3-ral-list", width: "100%", children: B })
  ] });
}, NCt = [{
  hex: "#CDBA88",
  code: "1000",
  scope: "Classic",
  de: "Grünbeige",
  en: "Green beige",
  nl: "Groen-beige",
  fr: "Beige vert"
}, {
  hex: "#D0B084",
  code: "1001",
  scope: "Classic",
  de: "Beige",
  en: "Beige",
  nl: "Beige",
  fr: "Beige"
}, {
  hex: "#D2AA6D",
  code: "1002",
  scope: "Classic",
  de: "Sandgelb",
  en: "Sand yellow",
  nl: "Zandgeel",
  fr: "Jaune sable"
}, {
  hex: "#F9A900",
  code: "1003",
  scope: "Classic",
  de: "Signalgelb",
  en: "Signal yellow",
  nl: "Signaal geel",
  fr: "Jaune de signalisation"
}, {
  hex: "#E49E00",
  code: "1004",
  scope: "Classic",
  de: "Goldgelb",
  en: "Golden yellow",
  nl: "Goudgeel",
  fr: "Jaune d'or"
}, {
  hex: "#CB8F00",
  code: "1005",
  scope: "Classic",
  de: "Honiggelb",
  en: "Honey yellow",
  nl: "Honinggeel",
  fr: "Jaune miel"
}, {
  hex: "#E19000",
  code: "1006",
  scope: "Classic",
  de: "Maisgelb",
  en: "Maize yellow",
  nl: "Maïs geel",
  fr: "Jaune maïs"
}, {
  hex: "#E88C00",
  code: "1007",
  scope: "Classic",
  de: "Narzissengelb",
  en: "Daffodil yellow",
  nl: "Narcisgeel",
  fr: "Jaune jonquille"
}, {
  hex: "#AF8050",
  code: "1011",
  scope: "Classic",
  de: "Braunbeige",
  en: "Brown beige",
  nl: "Bruin-beige",
  fr: "Beige marron"
}, {
  hex: "#DDAF28",
  code: "1012",
  scope: "Classic",
  de: "Zitronengelb",
  en: "Lemon yellow",
  nl: "Citroengeel",
  fr: "Jaune citron"
}, {
  hex: "#E3D9C7",
  code: "1013",
  scope: "Classic",
  de: "Perlweiß",
  en: "Oyster white",
  nl: "Parelwit",
  fr: "Blanc perle"
}, {
  hex: "#DDC49B",
  code: "1014",
  scope: "Classic",
  de: "Elfenbein",
  en: "Ivory",
  nl: "Ivoor",
  fr: "Ivoire"
}, {
  hex: "#E6D2B5",
  code: "1015",
  scope: "Classic",
  de: "Hellelfenbein",
  en: "Light ivory",
  nl: "Licht ivoor",
  fr: "Ivoire clair"
}, {
  hex: "#F1DD39",
  code: "1016",
  scope: "Classic",
  de: "Schwefelgelb",
  en: "Sulfur yellow",
  nl: "Zwavelgeel",
  fr: "Jaune soufre"
}, {
  hex: "#F6A951",
  code: "1017",
  scope: "Classic",
  de: "Safrangelb",
  en: "Saffron yellow",
  nl: "Saffraangeel",
  fr: "Jaune safran"
}, {
  hex: "#FACA31",
  code: "1018",
  scope: "Classic",
  de: "Zinkgelb",
  en: "Zinc yellow",
  nl: "Zinkgeel",
  fr: "Jaune de zinc"
}, {
  hex: "#A48F7A",
  code: "1019",
  scope: "Classic",
  de: "Graubeige",
  en: "Grey beige",
  nl: "Grijs-beige",
  fr: "Beige gris"
}, {
  hex: "#A08F65",
  code: "1020",
  scope: "Classic",
  de: "Olivgelb",
  en: "Olive yellow",
  nl: "Olijfgeel",
  fr: "Jaune olive"
}, {
  hex: "#F6B600",
  code: "1021",
  scope: "Classic",
  de: "Rapsgelb",
  en: "Colza yellow",
  nl: "Koolzaad geel",
  fr: "Jaune colza"
}, {
  hex: "#F7B500",
  code: "1023",
  scope: "Classic",
  de: "Verkehrsgelb",
  en: "Traffic yellow",
  nl: "Verkeer geel",
  fr: "Jaune trafic"
}, {
  hex: "#BA8F4C",
  code: "1024",
  scope: "Classic",
  de: "Ockergelb",
  en: "Ochre yellow",
  nl: "Okergeel",
  fr: "Jaune ocre"
}, {
  hex: "#FFFF00",
  code: "1026",
  scope: "Classic",
  de: "Leuchtgelb",
  en: "Luminous yellow",
  nl: "Fluorescerend geel",
  fr: "Jaune vif"
}, {
  hex: "#A77F0F",
  code: "1027",
  scope: "Classic",
  de: "Currygelb",
  en: "Curry",
  nl: "Kerrie geel",
  fr: "Jaune curry"
}, {
  hex: "#FF9C00",
  code: "1028",
  scope: "Classic",
  de: "Melonengelb",
  en: "Melon yellow",
  nl: "Meloengeel",
  fr: "Jaune melon"
}, {
  hex: "#E2A300",
  code: "1032",
  scope: "Classic",
  de: "Ginstergelb",
  en: "Broom yellow",
  nl: "Bezem geel",
  fr: "Jaune genêt"
}, {
  hex: "#F99A1D",
  code: "1033",
  scope: "Classic",
  de: "Dahliengelb",
  en: "Dahlia yellow",
  nl: "Dahlia geel",
  fr: "Jaune dahlia"
}, {
  hex: "#EB9C52",
  code: "1034",
  scope: "Classic",
  de: "Pastellgelb",
  en: "Pastel yellow",
  nl: "Pastelgeel",
  fr: "Jaune pastel"
}, {
  hex: "#8F8370",
  code: "1035",
  scope: "Classic",
  de: "Perlbeige",
  en: "Pearl beige",
  nl: "Parel beige",
  fr: "Beige perle"
}, {
  hex: "#806440",
  code: "1036",
  scope: "Classic",
  de: "Perlgold",
  en: "Pearl gold",
  nl: "Parel goud",
  fr: "Or perlé"
}, {
  hex: "#F09200",
  code: "1037",
  scope: "Classic",
  de: "Sonnengelb",
  en: "Sun yellow",
  nl: "Zonnegeel",
  fr: "Jaune soleil"
}, {
  hex: "#DA6E00",
  code: "2000",
  scope: "Classic",
  de: "Gelborange",
  en: "Yellow orange",
  nl: "Geeloranje",
  fr: "Jaune-orange"
}, {
  hex: "#BA481C",
  code: "2001",
  scope: "Classic",
  de: "Rotorange",
  en: "Red orange",
  nl: "Rood oranje",
  fr: "Orange rouge"
}, {
  hex: "#BF3922",
  code: "2002",
  scope: "Classic",
  de: "Blutorange",
  en: "Vermilion",
  nl: "Bloedsinaasappel",
  fr: "Orange sanguine"
}, {
  hex: "#F67829",
  code: "2003",
  scope: "Classic",
  de: "Pastellorange",
  en: "Pastel orange",
  nl: "Pastel oranje",
  fr: "Orange pastel"
}, {
  hex: "#E25304",
  code: "2004",
  scope: "Classic",
  de: "Reinorange",
  en: "Pure orange",
  nl: "Puur oranje",
  fr: "Orange pure"
}, {
  hex: "#FF4D08",
  code: "2005",
  scope: "Classic",
  de: "Leuchtorange",
  en: "Luminous orange",
  nl: "Fluorescerend oranje",
  fr: "Orange vif"
}, {
  hex: "#FFB200",
  code: "2007",
  scope: "Classic",
  de: "Leuchthellorange",
  en: "Luminous bright orange",
  nl: "Fluorescerend licht oranje",
  fr: "Orange clair lumineux"
}, {
  hex: "#EC6B22",
  code: "2008",
  scope: "Classic",
  de: "Hellrotorange",
  en: "Bright red orange",
  nl: "Licht rood-oranje",
  fr: "Orange clair"
}, {
  hex: "#DE5308",
  code: "2009",
  scope: "Classic",
  de: "Verkehrsorange",
  en: "Traffic orange",
  nl: "Verkeer oranje",
  fr: "Orange trafic"
}, {
  hex: "#D05D29",
  code: "2010",
  scope: "Classic",
  de: "Signalorange",
  en: "Signal orange",
  nl: "Signaal oranje",
  fr: "Orange de signalisation"
}, {
  hex: "#E26E0F",
  code: "2011",
  scope: "Classic",
  de: "Tieforange",
  en: "Deep orange",
  nl: "Diep oranje",
  fr: "Orange profond"
}, {
  hex: "#D5654E",
  code: "2012",
  scope: "Classic",
  de: "Lachsorange",
  en: "Salmon orange",
  nl: "Zalm oranje",
  fr: "Orange saumon"
}, {
  hex: "#923E25",
  code: "2013",
  scope: "Classic",
  de: "Perlorange",
  en: "Pearl orange",
  nl: "Parel oranje",
  fr: "Orange perle"
}, {
  hex: "#FC5500",
  code: "2017",
  scope: "Classic",
  de: "RAL Orange",
  en: "RAL orange",
  nl: "RAL Oranje",
  fr: "RAL orange"
}, {
  hex: "#A72920",
  code: "3000",
  scope: "Classic",
  de: "Feuerrot",
  en: "Flame red",
  nl: "Vuurrood",
  fr: "Rouge feu"
}, {
  hex: "#9B2423",
  code: "3001",
  scope: "Classic",
  de: "Signalrot",
  en: "Signal red",
  nl: "Signaal rood",
  fr: "Rouge de signalisation"
}, {
  hex: "#9B2321",
  code: "3002",
  scope: "Classic",
  de: "Karminrot",
  en: "Carmine red",
  nl: "Karmijnrood",
  fr: "Rouge carmin"
}, {
  hex: "#861A22",
  code: "3003",
  scope: "Classic",
  de: "Rubinrot",
  en: "Ruby red",
  nl: "Robijnrood",
  fr: "Rouge rubis"
}, {
  hex: "#6B1C23",
  code: "3004",
  scope: "Classic",
  de: "Purpurrot",
  en: "Purple red",
  nl: "Paars rood",
  fr: "Rouge pourpre"
}, {
  hex: "#59191F",
  code: "3005",
  scope: "Classic",
  de: "Weinrot",
  en: "Wine red",
  nl: "Wijn rood",
  fr: "Rouge vin"
}, {
  hex: "#3E2022",
  code: "3007",
  scope: "Classic",
  de: "Schwarzrot",
  en: "Black red",
  nl: "Zwart rood",
  fr: "Rouge noir"
}, {
  hex: "#6D342D",
  code: "3009",
  scope: "Classic",
  de: "Oxidrot",
  en: "Oxide red",
  nl: "Oxydrood",
  fr: "Rouge oxyde"
}, {
  hex: "#782423",
  code: "3011",
  scope: "Classic",
  de: "Braunrot",
  en: "Brown red",
  nl: "Bruin rood",
  fr: "Marron rouge"
}, {
  hex: "#C5856D",
  code: "3012",
  scope: "Classic",
  de: "Beigerot",
  en: "Beige red",
  nl: "Beige rood",
  fr: "Beigerot"
}, {
  hex: "#972E25",
  code: "3013",
  scope: "Classic",
  de: "Tomatenrot",
  en: "Tomato red",
  nl: "Tomaat rood",
  fr: "Rouge tomate"
}, {
  hex: "#CB7375",
  code: "3014",
  scope: "Classic",
  de: "Altrosa",
  en: "Antique pink",
  nl: "Donkerroze",
  fr: "Vieux rose"
}, {
  hex: "#D8A0A6",
  code: "3015",
  scope: "Classic",
  de: "Hellrosa",
  en: "Light pink",
  nl: "Lichtroze",
  fr: "Rose clair"
}, {
  hex: "#A63D30",
  code: "3016",
  scope: "Classic",
  de: "Korallenrot",
  en: "Coral red",
  nl: "Koraalrood",
  fr: "Rouge corail"
}, {
  hex: "#CA555D",
  code: "3017",
  scope: "Classic",
  de: "Rosé",
  en: "Rose",
  nl: "Rosé",
  fr: "Rosé"
}, {
  hex: "#C63F4A",
  code: "3018",
  scope: "Classic",
  de: "Erdbeerrot",
  en: "Strawberry red",
  nl: "Aardbeirood",
  fr: "Rouge fraise"
}, {
  hex: "#BB1F11",
  code: "3020",
  scope: "Classic",
  de: "Verkehrsrot",
  en: "Traffic red",
  nl: "Verkeer rood",
  fr: "Rouge trafic"
}, {
  hex: "#CF6955",
  code: "3022",
  scope: "Classic",
  de: "Lachsrot",
  en: "Salmon pink",
  nl: "Zalmrood",
  fr: "Rouge saumon"
}, {
  hex: "#FF2D21",
  code: "3024",
  scope: "Classic",
  de: "Leuchtrot",
  en: "Luminous red",
  nl: "Fluorescerend rood",
  fr: "Rouge vif"
}, {
  hex: "#FF2A1C",
  code: "3026",
  scope: "Classic",
  de: "Leuchthellrot",
  en: "Luminous bright red",
  nl: "Helder rood",
  fr: "Rouge clair lumineux"
}, {
  hex: "#AB273C",
  code: "3027",
  scope: "Classic",
  de: "Himbeerrot",
  en: "Raspberry red",
  nl: "Framboos rood",
  fr: "Rouge framboise"
}, {
  hex: "#CC2C24",
  code: "3028",
  scope: "Classic",
  de: "Reinrot",
  en: "Pure red",
  nl: "Puur rood",
  fr: "Rouge pur"
}, {
  hex: "#A63437",
  code: "3031",
  scope: "Classic",
  de: "Orientrot",
  en: "Orient red",
  nl: "Oriënt rood",
  fr: "Rouge d'Orient"
}, {
  hex: "#701D24",
  code: "3032",
  scope: "Classic",
  de: "Perlrubinrot",
  en: "Pearl ruby red",
  nl: "Parel robijnrood",
  fr: "Rouge rubis perle"
}, {
  hex: "#A53A2E",
  code: "3033",
  scope: "Classic",
  de: "Perlrosa",
  en: "Pearl pink",
  nl: "Parelmoer roze",
  fr: "Rose perle"
}, {
  hex: "#816183",
  code: "4001",
  scope: "Classic",
  de: "Rotlila",
  en: "Red lilac",
  nl: "Roodpaars",
  fr: "Violet rouge"
}, {
  hex: "#8D3C4B",
  code: "4002",
  scope: "Classic",
  de: "Rotviolett",
  en: "Red violet",
  nl: "Roodviolet",
  fr: "Rouge-violet"
}, {
  hex: "#C4618C",
  code: "4003",
  scope: "Classic",
  de: "Erikaviolett",
  en: "Heather violet",
  nl: "Erika violet",
  fr: "Violet d'Erika"
}, {
  hex: "#651E38",
  code: "4004",
  scope: "Classic",
  de: "Bordeauxviolett",
  en: "Claret violet",
  nl: "Bordeaux viooltje",
  fr: "Violet bordeaux"
}, {
  hex: "#76689A",
  code: "4005",
  scope: "Classic",
  de: "Blaulila",
  en: "Blue lilac",
  nl: "Blauwpaars",
  fr: "Blaulila"
}, {
  hex: "#903373",
  code: "4006",
  scope: "Classic",
  de: "Verkehrspurpur",
  en: "Traffic purple",
  nl: "Rijbaan",
  fr: "Voie de circulation"
}, {
  hex: "#47243C",
  code: "4007",
  scope: "Classic",
  de: "Purpurviolett",
  en: "Purple violet",
  nl: "Paars viooltje",
  fr: "Violet pourpre"
}, {
  hex: "#844C82",
  code: "4008",
  scope: "Classic",
  de: "Signalviolett",
  en: "Signal violet",
  nl: "Signaal violet",
  fr: "Violet de signalisation"
}, {
  hex: "#9D8692",
  code: "4009",
  scope: "Classic",
  de: "Pastellviolett",
  en: "Pastel violet",
  nl: "Pastelviolet",
  fr: "Violet pastel"
}, {
  hex: "#BB4077",
  code: "4010",
  scope: "Classic",
  de: "Telemagenta",
  en: "Telemagenta",
  nl: "Telemagenta",
  fr: "Telemagenta"
}, {
  hex: "#6E6387",
  code: "4011",
  scope: "Classic",
  de: "Perlviolett",
  en: "Pearl violet",
  nl: "Parelviolet",
  fr: "Violet perlé"
}, {
  hex: "#6A6B7F",
  code: "4012",
  scope: "Classic",
  de: "Perlbrombeer",
  en: "Pearl blackberry",
  nl: "Parel braam",
  fr: "Mûre perlée"
}, {
  hex: "#304F6E",
  code: "5000",
  scope: "Classic",
  de: "Violettblau",
  en: "Violet blue",
  nl: "Violetblauw",
  fr: "Bleu violet"
}, {
  hex: "#0E4C64",
  code: "5001",
  scope: "Classic",
  de: "Grünblau",
  en: "Green blue",
  nl: "Groenblauw",
  fr: "Bleu vert"
}, {
  hex: "#00387A",
  code: "5002",
  scope: "Classic",
  de: "Ultramarinblau",
  en: "Ultramarine blue",
  nl: "Ultramarijnblauw",
  fr: "Bleu outremer"
}, {
  hex: "#1F3855",
  code: "5003",
  scope: "Classic",
  de: "Saphirblau",
  en: "Sapphire blue",
  nl: "Saffierblauw",
  fr: "Bleu saphir"
}, {
  hex: "#191E28",
  code: "5004",
  scope: "Classic",
  de: "Schwarzblau",
  en: "Black blue",
  nl: "Zwartblauw",
  fr: "Bleu noir"
}, {
  hex: "#005387",
  code: "5005",
  scope: "Classic",
  de: "Signalblau",
  en: "Signal blue",
  nl: "Signaal blauw",
  fr: "Bleu signal"
}, {
  hex: "#376B8C",
  code: "5007",
  scope: "Classic",
  de: "Brillantblau",
  en: "Brillant blue",
  nl: "Schitterend blauw",
  fr: "Bleu brillant"
}, {
  hex: "#2B3A44",
  code: "5008",
  scope: "Classic",
  de: "Graublau",
  en: "Grey blue",
  nl: "Grijsblauw",
  fr: "Bleu gris"
}, {
  hex: "#215F78",
  code: "5009",
  scope: "Classic",
  de: "Azurblau",
  en: "Azure blue",
  nl: "Azuurblauw",
  fr: "Bleu azur"
}, {
  hex: "#004F7C",
  code: "5010",
  scope: "Classic",
  de: "Enzianblau",
  en: "Gentian blue",
  nl: "Gentiaanblauw",
  fr: "Bleu gentiane"
}, {
  hex: "#1A2B3C",
  code: "5011",
  scope: "Classic",
  de: "Stahlblau",
  en: "Steel blue",
  nl: "Staalblauw",
  fr: "Bleu acier"
}, {
  hex: "#0089B6",
  code: "5012",
  scope: "Classic",
  de: "Lichtblau",
  en: "Light blue",
  nl: "Lichtblauw",
  fr: "Bleu clair"
}, {
  hex: "#193153",
  code: "5013",
  scope: "Classic",
  de: "Kobaltblau",
  en: "Cobalt blue",
  nl: "Kobaltblauw",
  fr: "Bleu cobalt"
}, {
  hex: "#637D96",
  code: "5014",
  scope: "Classic",
  de: "Taubenblau",
  en: "Pigeon blue",
  nl: "Duif blauw",
  fr: "Bleu pigeon"
}, {
  hex: "#007CAF",
  code: "5015",
  scope: "Classic",
  de: "Himmelblau",
  en: "Sky blue",
  nl: "Hemelsblauw",
  fr: "Bleu ciel"
}, {
  hex: "#005B8C",
  code: "5017",
  scope: "Classic",
  de: "Verkehrsblau",
  en: "Traffic blue",
  nl: "Verkeersblauw",
  fr: "Bleu trafic"
}, {
  hex: "#048B8C",
  code: "5018",
  scope: "Classic",
  de: "Türkisblau",
  en: "Turquoise blue",
  nl: "Turquoise blauw",
  fr: "Bleu turquoise"
}, {
  hex: "#005E83",
  code: "5019",
  scope: "Classic",
  de: "Capriblau",
  en: "Capri blue",
  nl: "Capri blauw",
  fr: "Bleu capri"
}, {
  hex: "#00414B",
  code: "5020",
  scope: "Classic",
  de: "Ozeanblau",
  en: "Ocean blue",
  nl: "Oceaanblauw",
  fr: "Bleu océan"
}, {
  hex: "#007577",
  code: "5021",
  scope: "Classic",
  de: "Wasserblau",
  en: "Water blue",
  nl: "Waterblauw",
  fr: "Bleu d'eau"
}, {
  hex: "#222D5A",
  code: "5022",
  scope: "Classic",
  de: "Nachtblau",
  en: "Night blue",
  nl: "Nachtblauw",
  fr: "Bleu nuit"
}, {
  hex: "#41698C",
  code: "5023",
  scope: "Classic",
  de: "Fernblau",
  en: "Distant blue",
  nl: "Ver blauw",
  fr: "Bleu lointain"
}, {
  hex: "#6093AC",
  code: "5024",
  scope: "Classic",
  de: "Pastellblau",
  en: "Pastel blue",
  nl: "Pastelblauw",
  fr: "Bleu pastel"
}, {
  hex: "#20697C",
  code: "5025",
  scope: "Classic",
  de: "Perlenzian",
  en: "Pearl gentian blue",
  nl: "Parelgentiaan",
  fr: "Gentiane perlée"
}, {
  hex: "#0F3052",
  code: "5026",
  scope: "Classic",
  de: "Perlnachtblau",
  en: "Pearl night blue",
  nl: "Parel nachtblauw",
  fr: "Bleu nuit perle"
}, {
  hex: "#3C7460",
  code: "6000",
  scope: "Classic",
  de: "Patinagrün",
  en: "Patina green",
  nl: "Patinagroen",
  fr: "Vert patine"
}, {
  hex: "#366735",
  code: "6001",
  scope: "Classic",
  de: "Smaragdgrün",
  en: "Emerald green",
  nl: "Smaragdgroen",
  fr: "Vert émeraude"
}, {
  hex: "#325928",
  code: "6002",
  scope: "Classic",
  de: "Laubgrün",
  en: "Leaf green",
  nl: "Bladgroen",
  fr: "Vert feuillage"
}, {
  hex: "#50533C",
  code: "6003",
  scope: "Classic",
  de: "Olivgrün",
  en: "Olive green",
  nl: "Olijfgroen",
  fr: "Vert olive"
}, {
  hex: "#024442",
  code: "6004",
  scope: "Classic",
  de: "Blaugrün",
  en: "Blue green",
  nl: "Blauwgroen",
  fr: "Bleu-vert"
}, {
  hex: "#114232",
  code: "6005",
  scope: "Classic",
  de: "Moosgrün",
  en: "Moss green",
  nl: "Mosgroen",
  fr: "Vert mousse"
}, {
  hex: "#3C392E",
  code: "6006",
  scope: "Classic",
  de: "Grauoliv",
  en: "Grey olive",
  nl: "Grijze olijf",
  fr: "Gris olive"
}, {
  hex: "#2C3222",
  code: "6007",
  scope: "Classic",
  de: "Flaschengrün",
  en: "Bottle green",
  nl: "Fles groen",
  fr: "Vert bouteille"
}, {
  hex: "#36342A",
  code: "6008",
  scope: "Classic",
  de: "Braungrün",
  en: "Brown green",
  nl: "Bruin-groen",
  fr: "Vert marron"
}, {
  hex: "#27352A",
  code: "6009",
  scope: "Classic",
  de: "Tannengrün",
  en: "Fir green",
  nl: "Dennengroen",
  fr: "Vert sapin"
}, {
  hex: "#4D6F39",
  code: "6010",
  scope: "Classic",
  de: "Grasgrün",
  en: "Grass green",
  nl: "Grasgroen",
  fr: "Vert herbe"
}, {
  hex: "#6B7C59",
  code: "6011",
  scope: "Classic",
  de: "Resedagrün",
  en: "Reseda green",
  nl: "Reseda groen",
  fr: "Vert réséda"
}, {
  hex: "#2F3D3A",
  code: "6012",
  scope: "Classic",
  de: "Schwarzgrün",
  en: "Black green",
  nl: "Zwartgroen",
  fr: "Vert noir"
}, {
  hex: "#7C765A",
  code: "6013",
  scope: "Classic",
  de: "Schilfgrün",
  en: "Reed green",
  nl: "Rietgroen",
  fr: "Le vert des roseaux"
}, {
  hex: "#474135",
  code: "6014",
  scope: "Classic",
  de: "Gelboliv",
  en: "Yellow olive",
  nl: "Gele olijf",
  fr: "Jaune bolivien"
}, {
  hex: "#3D3D36",
  code: "6015",
  scope: "Classic",
  de: "Schwarzoliv",
  en: "Black olive",
  nl: "Zwarte olijf",
  fr: "olive noir"
}, {
  hex: "#00694C",
  code: "6016",
  scope: "Classic",
  de: "Türkisgrün",
  en: "Turquoise green",
  nl: "Turquoise groen",
  fr: "Vert turquoise"
}, {
  hex: "#587F40",
  code: "6017",
  scope: "Classic",
  de: "Maigrün",
  en: "May green",
  nl: "Mei groen",
  fr: "Vert mai"
}, {
  hex: "#60993B",
  code: "6018",
  scope: "Classic",
  de: "Gelbgrün",
  en: "Yellow green",
  nl: "Geelgroen",
  fr: "Vert jaune"
}, {
  hex: "#B9CEAC",
  code: "6019",
  scope: "Classic",
  de: "Weißgrün",
  en: "Pastel green",
  nl: "Witgroen",
  fr: "Vert blanc"
}, {
  hex: "#37422F",
  code: "6020",
  scope: "Classic",
  de: "Chromoxidgrün",
  en: "Chrome green",
  nl: "Chroomoxidegroen",
  fr: "Vert oxyde de chrome"
}, {
  hex: "#8A9977",
  code: "6021",
  scope: "Classic",
  de: "Blaßgrün",
  en: "Pale green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#3A3327",
  code: "6022",
  scope: "Classic",
  de: "Braunoliv",
  en: "Olive drab",
  nl: "Bruine olijf",
  fr: "Marron olive"
}, {
  hex: "#008351",
  code: "6024",
  scope: "Classic",
  de: "Verkehrsgrün",
  en: "Traffic green",
  nl: "Verkeer groen",
  fr: "Espaces verts de circulation"
}, {
  hex: "#5E6E3B",
  code: "6025",
  scope: "Classic",
  de: "Farngrün",
  en: "Fern green",
  nl: "Varen groen",
  fr: "Vert fougère"
}, {
  hex: "#005F4E",
  code: "6026",
  scope: "Classic",
  de: "Opalgrün",
  en: "Opal green",
  nl: "Opaalgroen",
  fr: "Vert opale"
}, {
  hex: "#7EBAB5",
  code: "6027",
  scope: "Classic",
  de: "Lichtgrün",
  en: "Light green",
  nl: "Lichtgroen",
  fr: "Vert clair"
}, {
  hex: "#315442",
  code: "6028",
  scope: "Classic",
  de: "Kieferngrün",
  en: "Pine green",
  nl: "Dennengroen",
  fr: "Vert pin"
}, {
  hex: "#006F3D",
  code: "6029",
  scope: "Classic",
  de: "Minzgrün",
  en: "Mint green",
  nl: "Mintgroen",
  fr: "Vert menthe"
}, {
  hex: "#237F52",
  code: "6032",
  scope: "Classic",
  de: "Signalgrün",
  en: "Signal green",
  nl: "Signaal groen",
  fr: "Vert signal"
}, {
  hex: "#45877F",
  code: "6033",
  scope: "Classic",
  de: "Minttürkis",
  en: "Mint turquoise",
  nl: "Mint turkoois",
  fr: "Turquoise menthe"
}, {
  hex: "#7AADAC",
  code: "6034",
  scope: "Classic",
  de: "Pastelltürkis",
  en: "Pastel turquoise",
  nl: "Pastelturquoise",
  fr: "Turquoise pastel"
}, {
  hex: "#194D25",
  code: "6035",
  scope: "Classic",
  de: "Perlgrün",
  en: "Pearl green",
  nl: "Parelgroen",
  fr: "Vert perle"
}, {
  hex: "#04574B",
  code: "6036",
  scope: "Classic",
  de: "Perlopalgrün",
  en: "Pearl opal green",
  nl: "Parel opaalgroen",
  fr: "Vert perlopal"
}, {
  hex: "#008B29",
  code: "6037",
  scope: "Classic",
  de: "Reingrün",
  en: "Pure green",
  nl: "Puur groen",
  fr: "Vert pur"
}, {
  hex: "#00B51B",
  code: "6038",
  scope: "Classic",
  de: "Leuchtgrün",
  en: "Luminous green ",
  nl: "Fluorescerend groen",
  fr: "Vert fluo"
}, {
  hex: "#B3C43E",
  code: "6039",
  scope: "Classic",
  de: "Fasergrün",
  en: "Fibrous green",
  nl: "Vezel groen",
  fr: "Fibre verte"
}, {
  hex: "#7A888E",
  code: "7000",
  scope: "Classic",
  de: "Fehgrau",
  en: "Squirrel grey",
  nl: "Feh grijs",
  fr: "Fehgrau"
}, {
  hex: "#8C979C",
  code: "7001",
  scope: "Classic",
  de: "Silbergrau",
  en: "Silver grey",
  nl: "Zilvergrijs",
  fr: "Gris argenté"
}, {
  hex: "#817863",
  code: "7002",
  scope: "Classic",
  de: "Olivgrau",
  en: "Olive grey",
  nl: "Olijfgrijs",
  fr: "Gris olive"
}, {
  hex: "#797669",
  code: "7003",
  scope: "Classic",
  de: "Moosgrau",
  en: "Moss grey",
  nl: "Mosgrijs",
  fr: "Gris mousse"
}, {
  hex: "#9A9B9B",
  code: "7004",
  scope: "Classic",
  de: "Signalgrau",
  en: "Signal grey",
  nl: "Signaal grijs",
  fr: "Gris signal"
}, {
  hex: "#6B6E6B",
  code: "7005",
  scope: "Classic",
  de: "Mausgrau",
  en: "Mouse grey",
  nl: "Muis grijs",
  fr: "Gris souris"
}, {
  hex: "#766A5E",
  code: "7006",
  scope: "Classic",
  de: "Beigegrau",
  en: "Beige grey",
  nl: "Beige grijs",
  fr: "Gris beige"
}, {
  hex: "#745F3D",
  code: "7008",
  scope: "Classic",
  de: "Khakigrau",
  en: "Khaki grey",
  nl: "Kaki grijs",
  fr: "Gris kaki"
}, {
  hex: "#5D6058",
  code: "7009",
  scope: "Classic",
  de: "Grüngrau",
  en: "Green grey",
  nl: "Groen-grijs",
  fr: "Gris vert"
}, {
  hex: "#585C56",
  code: "7010",
  scope: "Classic",
  de: "Zeltgrau",
  en: "Tarpaulin grey",
  nl: "Tent grijs",
  fr: "Gris tente"
}, {
  hex: "#52595D",
  code: "7011",
  scope: "Classic",
  de: "Eisengrau",
  en: "Iron grey",
  nl: "IJzergrijs",
  fr: "Gris fer"
}, {
  hex: "#575D5E",
  code: "7012",
  scope: "Classic",
  de: "Basaltgrau",
  en: "Basalt grey",
  nl: "Basalt grijs",
  fr: "Gris basalte"
}, {
  hex: "#575044",
  code: "7013",
  scope: "Classic",
  de: "Braungrau",
  en: "Brown grey",
  nl: "Bruin-grijs",
  fr: "Gris marron"
}, {
  hex: "#4F5358",
  code: "7015",
  scope: "Classic",
  de: "Schiefergrau",
  en: "Slate grey",
  nl: "Leigrijs",
  fr: "Gris ardoise"
}, {
  hex: "#383E42",
  code: "7016",
  scope: "Classic",
  de: "Anthrazitgrau",
  en: "Anthracite grey",
  nl: "Antraciet grijs",
  fr: "Gris anthracite"
}, {
  hex: "#2F3234",
  code: "7021",
  scope: "Classic",
  de: "Schwarzgrau",
  en: "Black grey",
  nl: "Zwart grijs",
  fr: "Gris noir"
}, {
  hex: "#4C4A44",
  code: "7022",
  scope: "Classic",
  de: "Umbragrau",
  en: "Umbra grey",
  nl: "Umbra grijs",
  fr: "Gris terre d'ombre"
}, {
  hex: "#808076",
  code: "7023",
  scope: "Classic",
  de: "Betongrau",
  en: "Concrete grey",
  nl: "Beton grijs",
  fr: "Gris béton"
}, {
  hex: "#45494E",
  code: "7024",
  scope: "Classic",
  de: "Graphitgrau",
  en: "Graphite grey",
  nl: "Grafietgrijs",
  fr: "Gris graphite"
}, {
  hex: "#374345",
  code: "7026",
  scope: "Classic",
  de: "Granitgrau",
  en: "Granite grey",
  nl: "Granietgrijs",
  fr: "Gris granit"
}, {
  hex: "#928E85",
  code: "7030",
  scope: "Classic",
  de: "Steingrau",
  en: "Stone grey",
  nl: "Steengrijs",
  fr: "Gris pierre"
}, {
  hex: "#5B686D",
  code: "7031",
  scope: "Classic",
  de: "Blaugrau",
  en: "Blue grey",
  nl: "Blauwgrijs",
  fr: "Bleu-gris"
}, {
  hex: "#B5B0A1",
  code: "7032",
  scope: "Classic",
  de: "Kieselgrau",
  en: "Pebble grey",
  nl: "Kiezelgrijs",
  fr: "Gris silex"
}, {
  hex: "#7F8274",
  code: "7033",
  scope: "Classic",
  de: "Zementgrau",
  en: "Cement grey",
  nl: "Cementgrijs",
  fr: "Gris ciment"
}, {
  hex: "#92886F",
  code: "7034",
  scope: "Classic",
  de: "Gelbgrau",
  en: "Yellow grey",
  nl: "Geelgrijs",
  fr: "Gris jaune"
}, {
  hex: "#C5C7C4",
  code: "7035",
  scope: "Classic",
  de: "Lichtgrau",
  en: "Light grey",
  nl: "Lichtgrijs",
  fr: "Gris clair"
}, {
  hex: "#979392",
  code: "7036",
  scope: "Classic",
  de: "Platingrau",
  en: "Platinum grey",
  nl: "Platina grijs",
  fr: "Gris platine"
}, {
  hex: "#7A7B7A",
  code: "7037",
  scope: "Classic",
  de: "Staubgrau",
  en: "Dusty grey",
  nl: "Stof grijs",
  fr: "Gris poussière"
}, {
  hex: "#B0B0A9",
  code: "7038",
  scope: "Classic",
  de: "Achatgrau",
  en: "Agate grey",
  nl: "Agaat grijs",
  fr: "Gris agate"
}, {
  hex: "#6B665E",
  code: "7039",
  scope: "Classic",
  de: "Quarzgrau",
  en: "Quartz grey",
  nl: "Kwartsgrijs",
  fr: "Gris quartz"
}, {
  hex: "#989EA1",
  code: "7040",
  scope: "Classic",
  de: "Fenstergrau",
  en: "Window grey",
  nl: "Raam grijs",
  fr: "Gris fenêtre"
}, {
  hex: "#8E9291",
  code: "7042",
  scope: "Classic",
  de: "Verkehrsgrau A",
  en: "Traffic grey A",
  nl: "Verkeer grijs A",
  fr: "Gris trafic A"
}, {
  hex: "#4F5250",
  code: "7043",
  scope: "Classic",
  de: "Verkehrsgrau B",
  en: "Traffic grey B",
  nl: "Verkeer grijs B",
  fr: "Gris trafic B"
}, {
  hex: "#B7B3A8",
  code: "7044",
  scope: "Classic",
  de: "Seidengrau",
  en: "Silk grey",
  nl: "Zijde grijs",
  fr: "Gris soie"
}, {
  hex: "#8D9295",
  code: "7045",
  scope: "Classic",
  de: "Telegrau 1",
  en: "Telegrey 1",
  nl: "Telegrafeer 1",
  fr: "Telegrau 1"
}, {
  hex: "#7E868A",
  code: "7046",
  scope: "Classic",
  de: "Telegrau 2",
  en: "Telegrey 2",
  nl: "Telegrey 2",
  fr: "Telegrau 2"
}, {
  hex: "#C8C8C7",
  code: "7047",
  scope: "Classic",
  de: "Telegrau 4",
  en: "Telegrey 4",
  nl: "Telegrey 4",
  fr: "Telegrau 4"
}, {
  hex: "#817B73",
  code: "7048",
  scope: "Classic",
  de: "Perlmausgrau",
  en: "Pearl mouse grey",
  nl: "Parel muisgrijs",
  fr: "Gris perle"
}, {
  hex: "#89693F",
  code: "8000",
  scope: "Classic",
  de: "Grünbraun",
  en: "Green brown",
  nl: "Groen-bruin",
  fr: "Marron vert"
}, {
  hex: "#9D622B",
  code: "8001",
  scope: "Classic",
  de: "Ockerbraun",
  en: "Ochre brown",
  nl: "Okerbruin",
  fr: "Marron ocre"
}, {
  hex: "#794D3E",
  code: "8002",
  scope: "Classic",
  de: "Signalbraun",
  en: "Signal brown",
  nl: "Signaal bruin",
  fr: "Marron de signalisation"
}, {
  hex: "#7E4B27",
  code: "8003",
  scope: "Classic",
  de: "Lehmbraun",
  en: "Clay brown",
  nl: "Klei bruin",
  fr: "Marron argile"
}, {
  hex: "#8D4931",
  code: "8004",
  scope: "Classic",
  de: "Kupferbraun",
  en: "Copper brown",
  nl: "Koperbruin",
  fr: "Marron cuivré"
}, {
  hex: "#70462B",
  code: "8007",
  scope: "Classic",
  de: "Rehbraun",
  en: "Fawn brown",
  nl: "Fawn",
  fr: "Marron chevreuil"
}, {
  hex: "#724A25",
  code: "8008",
  scope: "Classic",
  de: "Olivbraun",
  en: "Olive brown",
  nl: "Olijfbruin",
  fr: "Marron olive"
}, {
  hex: "#5A3827",
  code: "8011",
  scope: "Classic",
  de: "Nußbraun",
  en: "Nut brown",
  nl: "Notenbruin",
  fr: "Marron noisette"
}, {
  hex: "#66332B",
  code: "8012",
  scope: "Classic",
  de: "Rotbraun",
  en: "Red brown",
  nl: "Roodbruin",
  fr: "Marron rouge"
}, {
  hex: "#4A3526",
  code: "8014",
  scope: "Classic",
  de: "Sepiabraun",
  en: "Sepia brown",
  nl: "Sepia bruin",
  fr: "Brun sépia"
}, {
  hex: "#5E2F26",
  code: "8015",
  scope: "Classic",
  de: "Kastanienbraun",
  en: "Chestnut brown",
  nl: "Kastanjebruin",
  fr: "Châtaigne"
}, {
  hex: "#4C2B20",
  code: "8016",
  scope: "Classic",
  de: "Mahagonibraun",
  en: "Mahogany brown",
  nl: "Mahoniebruin",
  fr: "Brun acajou"
}, {
  hex: "#442F29",
  code: "8017",
  scope: "Classic",
  de: "Schokoladenbraun",
  en: "Chocolate brown",
  nl: "Chocoladebruin",
  fr: "Marron chocolat"
}, {
  hex: "#3D3635",
  code: "8019",
  scope: "Classic",
  de: "Graubraun",
  en: "Grey brown",
  nl: "Grijsbruin",
  fr: "Marron gris"
}, {
  hex: "#1A1719",
  code: "8022",
  scope: "Classic",
  de: "Schwarzbraun",
  en: "Black brown",
  nl: "Zwartbruin",
  fr: "Marron noir"
}, {
  hex: "#A45729",
  code: "8023",
  scope: "Classic",
  de: "Orangebraun",
  en: "Orange brown",
  nl: "Oranjebruin",
  fr: "Marron orange"
}, {
  hex: "#795038",
  code: "8024",
  scope: "Classic",
  de: "Beigebraun",
  en: "Beige brown",
  nl: "Beige bruin",
  fr: "Beige-brun"
}, {
  hex: "#755847",
  code: "8025",
  scope: "Classic",
  de: "Blaßbraun",
  en: "Pale brown",
  nl: "Lichtbruin",
  fr: "Marron pâle"
}, {
  hex: "#513A2A",
  code: "8028",
  scope: "Classic",
  de: "Terrabraun",
  en: "Terra brown",
  nl: "Terra bruin",
  fr: "Brun terra"
}, {
  hex: "#7F4031",
  code: "8029",
  scope: "Classic",
  de: "Perlkupfer",
  en: "Pearl copper",
  nl: "Parel koper",
  fr: "Cuivre nacré"
}, {
  hex: "#E9E0D2",
  code: "9001",
  scope: "Classic",
  de: "Cremeweiß",
  en: "Cream",
  nl: "Crème wit",
  fr: "Blanc crème"
}, {
  hex: "#D6D5CB",
  code: "9002",
  scope: "Classic",
  de: "Grauweiß",
  en: "Grey white",
  nl: "Grijs wit",
  fr: "Blanc gris"
}, {
  hex: "#ECECE7",
  code: "9003",
  scope: "Classic",
  de: "Signalweiß",
  en: "Signal white",
  nl: "Signaal wit",
  fr: "Blanc de signalisation"
}, {
  hex: "#2B2B2C",
  code: "9004",
  scope: "Classic",
  de: "Signalschwarz",
  en: "Signal black",
  nl: "Signaal zwart",
  fr: "Noir de signalisation"
}, {
  hex: "#0E0E10",
  code: "9005",
  scope: "Classic",
  de: "Tiefschwarz",
  en: "Jet black",
  nl: "Diepzwart",
  fr: "Noir profond"
}, {
  hex: "#A1A1A0",
  code: "9006",
  scope: "Classic",
  de: "Weißaluminium",
  en: "White aluminium",
  nl: "Wit aluminium",
  fr: "Aluminium blanc"
}, {
  hex: "#868581",
  code: "9007",
  scope: "Classic",
  de: "Graualuminium",
  en: "Grey aluminium",
  nl: "Grijs aluminium",
  fr: "Aluminium gris"
}, {
  hex: "#F1EDE1",
  code: "9010",
  scope: "Classic",
  de: "Reinweiß",
  en: "Pure white",
  nl: "Puur wit",
  fr: "Blanc pur"
}, {
  hex: "#27292B",
  code: "9011",
  scope: "Classic",
  de: "Graphitschwarz",
  en: "Graphite black",
  nl: "Grafiet zwart",
  fr: "Noir graphite"
}, {
  hex: "#F8F2E1",
  code: "9012",
  scope: "Classic",
  de: "Reinraumweiß",
  en: "Cleanroom White",
  nl: "Cleanroom wit",
  fr: "Blanc salle blanche"
}, {
  hex: "#F1F1EA",
  code: "9016",
  scope: "Classic",
  de: "Verkehrsweiß",
  en: "Traffic white",
  nl: "Verkeerswit",
  fr: "Blanc trafic"
}, {
  hex: "#29292A",
  code: "9017",
  scope: "Classic",
  de: "Verkehrsschwarz",
  en: "Traffic black",
  nl: "Verkeer zwart",
  fr: "Noir trafic"
}, {
  hex: "#C8CBC4",
  code: "9018",
  scope: "Classic",
  de: "Papyrusweiß",
  en: "Papyrus white",
  nl: "Papyrus wit",
  fr: "Blanc papyrus"
}, {
  hex: "#858583",
  code: "9022",
  scope: "Classic",
  de: "Perlhellgrau",
  en: "Pearl light grey",
  nl: "Parel lichtgrijs",
  fr: "Gris clair perle"
}, {
  hex: "#787B7A",
  code: "9023",
  scope: "Classic",
  de: "Perldunkelgrau",
  en: "Pearl dark grey",
  nl: "Parel donkergrijs",
  fr: "Gris perle foncé"
}], LCt = [{
  hex: "#E6E7E6",
  code: "110-1",
  scope: "Effect"
}, {
  hex: "#DEDDD5",
  code: "110-2",
  scope: "Effect"
}, {
  hex: "#C8C6BE",
  code: "110-3",
  scope: "Effect"
}, {
  hex: "#C6C7C4",
  code: "110-4",
  scope: "Effect"
}, {
  hex: "#C9CCC6",
  code: "110-5",
  scope: "Effect"
}, {
  hex: "#C8C8C7",
  code: "110-6",
  scope: "Effect"
}, {
  hex: "#A0A2A4",
  code: "110-M",
  scope: "Effect"
}, {
  hex: "#EDEDEA",
  code: "120-1",
  scope: "Effect"
}, {
  hex: "#F2F1EC",
  code: "120-2",
  scope: "Effect"
}, {
  hex: "#F0EEE5",
  code: "120-3",
  scope: "Effect"
}, {
  hex: "#E9E1D4",
  code: "120-4",
  scope: "Effect"
}, {
  hex: "#E2D9C6",
  code: "120-5",
  scope: "Effect"
}, {
  hex: "#EAE1CE",
  code: "120-6",
  scope: "Effect"
}, {
  hex: "#8F8D87",
  code: "120-M",
  scope: "Effect"
}, {
  hex: "#F2EDBB",
  code: "130-1",
  scope: "Effect"
}, {
  hex: "#F1EEC3",
  code: "130-2",
  scope: "Effect"
}, {
  hex: "#F0EECD",
  code: "130-3",
  scope: "Effect"
}, {
  hex: "#F8F0CF",
  code: "130-4",
  scope: "Effect"
}, {
  hex: "#EDE4BC",
  code: "130-5",
  scope: "Effect"
}, {
  hex: "#FBE5B0",
  code: "130-6",
  scope: "Effect"
}, {
  hex: "#ABAB90",
  code: "130-M",
  scope: "Effect"
}, {
  hex: "#FAD3A9",
  code: "140-1",
  scope: "Effect"
}, {
  hex: "#FEDAA6",
  code: "140-2",
  scope: "Effect"
}, {
  hex: "#FEE3C1",
  code: "140-3",
  scope: "Effect"
}, {
  hex: "#FDDFBE",
  code: "140-4",
  scope: "Effect"
}, {
  hex: "#F8E4C8",
  code: "140-5",
  scope: "Effect"
}, {
  hex: "#E5D2B6",
  code: "140-6",
  scope: "Effect"
}, {
  hex: "#B09E7E",
  code: "140-M",
  scope: "Effect"
}, {
  hex: "#F7EFE9",
  code: "150-1",
  scope: "Effect"
}, {
  hex: "#F9EBE3",
  code: "150-2",
  scope: "Effect"
}, {
  hex: "#EEE1D7",
  code: "150-3",
  scope: "Effect"
}, {
  hex: "#FBE3D4",
  code: "150-4",
  scope: "Effect"
}, {
  hex: "#FAE8DC",
  code: "150-5",
  scope: "Effect"
}, {
  hex: "#F8DFD7",
  code: "150-6",
  scope: "Effect"
}, {
  hex: "#AB978A",
  code: "150-M",
  scope: "Effect"
}, {
  hex: "#E3E1EC",
  code: "160-1",
  scope: "Effect"
}, {
  hex: "#E7E2E8",
  code: "160-2",
  scope: "Effect"
}, {
  hex: "#EDE8E8",
  code: "160-3",
  scope: "Effect"
}, {
  hex: "#EEE1E2",
  code: "160-4",
  scope: "Effect"
}, {
  hex: "#EFE4E0",
  code: "160-5",
  scope: "Effect"
}, {
  hex: "#ECE4E9",
  code: "160-6",
  scope: "Effect"
}, {
  hex: "#ADA6B5",
  code: "160-M",
  scope: "Effect"
}, {
  hex: "#C7C9D0",
  code: "170-1",
  scope: "Effect"
}, {
  hex: "#A6ADBD",
  code: "170-2",
  scope: "Effect"
}, {
  hex: "#BAC8DA",
  code: "170-3",
  scope: "Effect"
}, {
  hex: "#CEDBEC",
  code: "170-4",
  scope: "Effect"
}, {
  hex: "#C3C6D6",
  code: "170-5",
  scope: "Effect"
}, {
  hex: "#C6C5D6",
  code: "170-6",
  scope: "Effect"
}, {
  hex: "#A7A8B9",
  code: "170-M",
  scope: "Effect"
}, {
  hex: "#AEBCC6",
  code: "180-1",
  scope: "Effect"
}, {
  hex: "#B9CDDD",
  code: "180-2",
  scope: "Effect"
}, {
  hex: "#C7DBEB",
  code: "180-3",
  scope: "Effect"
}, {
  hex: "#C9E1EC",
  code: "180-4",
  scope: "Effect"
}, {
  hex: "#C7DDE1",
  code: "180-5",
  scope: "Effect"
}, {
  hex: "#DBE9EB",
  code: "180-6",
  scope: "Effect"
}, {
  hex: "#96A4A9",
  code: "180-M",
  scope: "Effect"
}, {
  hex: "#A5DADF",
  code: "190-1",
  scope: "Effect"
}, {
  hex: "#B9E6F2",
  code: "190-2",
  scope: "Effect"
}, {
  hex: "#C0DEE1",
  code: "190-3",
  scope: "Effect"
}, {
  hex: "#BDDAD7",
  code: "190-4",
  scope: "Effect"
}, {
  hex: "#D4E5E7",
  code: "190-5",
  scope: "Effect"
}, {
  hex: "#A3C1BF",
  code: "190-6",
  scope: "Effect"
}, {
  hex: "#92B4B2",
  code: "190-M",
  scope: "Effect"
}, {
  hex: "#CFC6B2",
  code: "210-1",
  scope: "Effect"
}, {
  hex: "#ECE7D2",
  code: "210-2",
  scope: "Effect"
}, {
  hex: "#E3E4D9",
  code: "210-3",
  scope: "Effect"
}, {
  hex: "#D6E6E3",
  code: "210-4",
  scope: "Effect"
}, {
  hex: "#D8E8E0",
  code: "210-5",
  scope: "Effect"
}, {
  hex: "#D8E9D6",
  code: "210-6",
  scope: "Effect"
}, {
  hex: "#A5A99B",
  code: "210-M",
  scope: "Effect"
}, {
  hex: "#66B872",
  code: "220-1",
  scope: "Effect"
}, {
  hex: "#339A51",
  code: "220-2",
  scope: "Effect"
}, {
  hex: "#006F3C",
  code: "220-3",
  scope: "Effect"
}, {
  hex: "#088554",
  code: "220-4",
  scope: "Effect"
}, {
  hex: "#267E51",
  code: "220-5",
  scope: "Effect"
}, {
  hex: "#006A4D",
  code: "220-6",
  scope: "Effect"
}, {
  hex: "#007F3E",
  code: "220-M",
  scope: "Effect"
}, {
  hex: "#BBDB9A",
  code: "230-1",
  scope: "Effect"
}, {
  hex: "#96C86C",
  code: "230-2",
  scope: "Effect"
}, {
  hex: "#7DB344",
  code: "230-3",
  scope: "Effect"
}, {
  hex: "#5F973A",
  code: "230-4",
  scope: "Effect"
}, {
  hex: "#396938",
  code: "230-5",
  scope: "Effect"
}, {
  hex: "#365C30",
  code: "230-6",
  scope: "Effect"
}, {
  hex: "#62A74E",
  code: "230-M",
  scope: "Effect"
}, {
  hex: "#DCD691",
  code: "240-1",
  scope: "Effect"
}, {
  hex: "#AAAF66",
  code: "240-2",
  scope: "Effect"
}, {
  hex: "#939755",
  code: "240-3",
  scope: "Effect"
}, {
  hex: "#7E7E42",
  code: "240-4",
  scope: "Effect"
}, {
  hex: "#5D6D3C",
  code: "240-5",
  scope: "Effect"
}, {
  hex: "#4F6D35",
  code: "240-6",
  scope: "Effect"
}, {
  hex: "#627439",
  code: "240-M",
  scope: "Effect"
}, {
  hex: "#EEE6A5",
  code: "250-1",
  scope: "Effect"
}, {
  hex: "#E8DE6F",
  code: "250-2",
  scope: "Effect"
}, {
  hex: "#BFB700",
  code: "250-3",
  scope: "Effect"
}, {
  hex: "#A4A541",
  code: "250-4",
  scope: "Effect"
}, {
  hex: "#919138",
  code: "250-5",
  scope: "Effect"
}, {
  hex: "#69652C",
  code: "250-6",
  scope: "Effect"
}, {
  hex: "#AEA73B",
  code: "250-M",
  scope: "Effect"
}, {
  hex: "#F3E9B4",
  code: "260-1",
  scope: "Effect"
}, {
  hex: "#F1E483",
  code: "260-2",
  scope: "Effect"
}, {
  hex: "#F3D446",
  code: "260-3",
  scope: "Effect"
}, {
  hex: "#E8C01F",
  code: "260-4",
  scope: "Effect"
}, {
  hex: "#DEB02D",
  code: "260-5",
  scope: "Effect"
}, {
  hex: "#EFB416",
  code: "260-6",
  scope: "Effect"
}, {
  hex: "#B8944F",
  code: "260-M",
  scope: "Effect"
}, {
  hex: "#FFDE83",
  code: "270-1",
  scope: "Effect"
}, {
  hex: "#FACC39",
  code: "270-2",
  scope: "Effect"
}, {
  hex: "#F4BD16",
  code: "270-3",
  scope: "Effect"
}, {
  hex: "#EBB100",
  code: "270-4",
  scope: "Effect"
}, {
  hex: "#F6B600",
  code: "270-5",
  scope: "Effect"
}, {
  hex: "#FEC43F",
  code: "270-6",
  scope: "Effect"
}, {
  hex: "#CB9437",
  code: "270-M",
  scope: "Effect"
}, {
  hex: "#FDE193",
  code: "280-1",
  scope: "Effect"
}, {
  hex: "#F0D391",
  code: "280-2",
  scope: "Effect"
}, {
  hex: "#E1BE78",
  code: "280-3",
  scope: "Effect"
}, {
  hex: "#D6AE5F",
  code: "280-4",
  scope: "Effect"
}, {
  hex: "#DCA140",
  code: "280-5",
  scope: "Effect"
}, {
  hex: "#D0973C",
  code: "280-6",
  scope: "Effect"
}, {
  hex: "#B28740",
  code: "280-M",
  scope: "Effect"
}, {
  hex: "#D89B50",
  code: "290-1",
  scope: "Effect"
}, {
  hex: "#BF853B",
  code: "290-2",
  scope: "Effect"
}, {
  hex: "#D8A960",
  code: "290-3",
  scope: "Effect"
}, {
  hex: "#CC921B",
  code: "290-4",
  scope: "Effect"
}, {
  hex: "#E6B03E",
  code: "290-5",
  scope: "Effect"
}, {
  hex: "#FCAB04",
  code: "290-6",
  scope: "Effect"
}, {
  hex: "#B87E32",
  code: "290-M",
  scope: "Effect"
}, {
  hex: "#F5D6B4",
  code: "310-1",
  scope: "Effect"
}, {
  hex: "#EBC297",
  code: "310-2",
  scope: "Effect"
}, {
  hex: "#DFAB73",
  code: "310-3",
  scope: "Effect"
}, {
  hex: "#D09355",
  code: "310-4",
  scope: "Effect"
}, {
  hex: "#BA7C43",
  code: "310-5",
  scope: "Effect"
}, {
  hex: "#8E5B2D",
  code: "310-6",
  scope: "Effect"
}, {
  hex: "#B87D4F",
  code: "310-M",
  scope: "Effect"
}, {
  hex: "#D2A96C",
  code: "320-1",
  scope: "Effect"
}, {
  hex: "#AE8151",
  code: "320-2",
  scope: "Effect"
}, {
  hex: "#B9864C",
  code: "320-3",
  scope: "Effect"
}, {
  hex: "#A06735",
  code: "320-4",
  scope: "Effect"
}, {
  hex: "#7F4E2E",
  code: "320-5",
  scope: "Effect"
}, {
  hex: "#6E4428",
  code: "320-6",
  scope: "Effect"
}, {
  hex: "#B9731E",
  code: "320-M",
  scope: "Effect"
}, {
  hex: "#A86859",
  code: "330-1",
  scope: "Effect"
}, {
  hex: "#8E4B35",
  code: "330-2",
  scope: "Effect"
}, {
  hex: "#794E3E",
  code: "330-3",
  scope: "Effect"
}, {
  hex: "#5C3B2D",
  code: "330-4",
  scope: "Effect"
}, {
  hex: "#50312A",
  code: "330-5",
  scope: "Effect"
}, {
  hex: "#46322E",
  code: "330-6",
  scope: "Effect"
}, {
  hex: "#8B5943",
  code: "330-M",
  scope: "Effect"
}, {
  hex: "#BEA4A9",
  code: "340-1",
  scope: "Effect"
}, {
  hex: "#A48C92",
  code: "340-2",
  scope: "Effect"
}, {
  hex: "#7F5452",
  code: "340-3",
  scope: "Effect"
}, {
  hex: "#683D40",
  code: "340-4",
  scope: "Effect"
}, {
  hex: "#4F2A2D",
  code: "340-5",
  scope: "Effect"
}, {
  hex: "#4F2B31",
  code: "340-6",
  scope: "Effect"
}, {
  hex: "#53353B",
  code: "340-M",
  scope: "Effect"
}, {
  hex: "#9D311F",
  code: "350-1",
  scope: "Effect"
}, {
  hex: "#A73F32",
  code: "350-2",
  scope: "Effect"
}, {
  hex: "#A24733",
  code: "350-3",
  scope: "Effect"
}, {
  hex: "#813021",
  code: "350-4",
  scope: "Effect"
}, {
  hex: "#783122",
  code: "350-5",
  scope: "Effect"
}, {
  hex: "#66322B",
  code: "350-6",
  scope: "Effect"
}, {
  hex: "#582F2A",
  code: "350-M",
  scope: "Effect"
}, {
  hex: "#E07D29",
  code: "360-1",
  scope: "Effect"
}, {
  hex: "#D9751E",
  code: "360-2",
  scope: "Effect"
}, {
  hex: "#C66217",
  code: "360-3",
  scope: "Effect"
}, {
  hex: "#B75629",
  code: "360-4",
  scope: "Effect"
}, {
  hex: "#9A4F2C",
  code: "360-5",
  scope: "Effect"
}, {
  hex: "#915033",
  code: "360-6",
  scope: "Effect"
}, {
  hex: "#A45633",
  code: "360-M",
  scope: "Effect"
}, {
  hex: "#FFAE47",
  code: "370-1",
  scope: "Effect"
}, {
  hex: "#FF9B38",
  code: "370-2",
  scope: "Effect"
}, {
  hex: "#FF901D",
  code: "370-3",
  scope: "Effect"
}, {
  hex: "#E68316",
  code: "370-4",
  scope: "Effect"
}, {
  hex: "#D4781F",
  code: "370-5",
  scope: "Effect"
}, {
  hex: "#CD6C10",
  code: "370-6",
  scope: "Effect"
}, {
  hex: "#B47A3C",
  code: "370-M",
  scope: "Effect"
}, {
  hex: "#FF9B29",
  code: "380-1",
  scope: "Effect"
}, {
  hex: "#FF9204",
  code: "380-2",
  scope: "Effect"
}, {
  hex: "#FA841A",
  code: "380-3",
  scope: "Effect"
}, {
  hex: "#E27121",
  code: "380-4",
  scope: "Effect"
}, {
  hex: "#F2782F",
  code: "380-5",
  scope: "Effect"
}, {
  hex: "#EA6A24",
  code: "380-6",
  scope: "Effect"
}, {
  hex: "#A7552A",
  code: "380-M",
  scope: "Effect"
}, {
  hex: "#EB773F",
  code: "390-1",
  scope: "Effect"
}, {
  hex: "#E36125",
  code: "390-2",
  scope: "Effect"
}, {
  hex: "#DE5411",
  code: "390-3",
  scope: "Effect"
}, {
  hex: "#D8511C",
  code: "390-4",
  scope: "Effect"
}, {
  hex: "#D8480F",
  code: "390-5",
  scope: "Effect"
}, {
  hex: "#CD5E2A",
  code: "390-6",
  scope: "Effect"
}, {
  hex: "#BF633B",
  code: "390-M",
  scope: "Effect"
}, {
  hex: "#ED8165",
  code: "410-1",
  scope: "Effect"
}, {
  hex: "#EA734F",
  code: "410-2",
  scope: "Effect"
}, {
  hex: "#E46440",
  code: "410-3",
  scope: "Effect"
}, {
  hex: "#DC5D38",
  code: "410-4",
  scope: "Effect"
}, {
  hex: "#D25535",
  code: "410-5",
  scope: "Effect"
}, {
  hex: "#D05D42",
  code: "410-6",
  scope: "Effect"
}, {
  hex: "#AB4924",
  code: "410-M",
  scope: "Effect"
}, {
  hex: "#EDAE9A",
  code: "420-1",
  scope: "Effect"
}, {
  hex: "#F29D86",
  code: "420-2",
  scope: "Effect"
}, {
  hex: "#E98A6C",
  code: "420-3",
  scope: "Effect"
}, {
  hex: "#E46443",
  code: "420-4",
  scope: "Effect"
}, {
  hex: "#CC5738",
  code: "420-5",
  scope: "Effect"
}, {
  hex: "#BF502E",
  code: "420-6",
  scope: "Effect"
}, {
  hex: "#9D4B32",
  code: "420-M",
  scope: "Effect"
}, {
  hex: "#F2C2B6",
  code: "430-1",
  scope: "Effect"
}, {
  hex: "#EC998B",
  code: "430-2",
  scope: "Effect"
}, {
  hex: "#E48074",
  code: "430-3",
  scope: "Effect"
}, {
  hex: "#DD5A4C",
  code: "430-4",
  scope: "Effect"
}, {
  hex: "#D5433C",
  code: "430-5",
  scope: "Effect"
}, {
  hex: "#BE3A24",
  code: "430-6",
  scope: "Effect"
}, {
  hex: "#A84C45",
  code: "430-M",
  scope: "Effect"
}, {
  hex: "#CA383C",
  code: "440-1",
  scope: "Effect"
}, {
  hex: "#D34C49",
  code: "440-2",
  scope: "Effect"
}, {
  hex: "#BA3C3E",
  code: "440-3",
  scope: "Effect"
}, {
  hex: "#9B2929",
  code: "440-4",
  scope: "Effect"
}, {
  hex: "#A63129",
  code: "440-5",
  scope: "Effect"
}, {
  hex: "#B93525",
  code: "440-6",
  scope: "Effect"
}, {
  hex: "#9B252C",
  code: "440-M",
  scope: "Effect"
}, {
  hex: "#F4C7CA",
  code: "450-1",
  scope: "Effect"
}, {
  hex: "#EDA5AA",
  code: "450-2",
  scope: "Effect"
}, {
  hex: "#E07A81",
  code: "450-3",
  scope: "Effect"
}, {
  hex: "#C85862",
  code: "450-4",
  scope: "Effect"
}, {
  hex: "#B2312F",
  code: "450-5",
  scope: "Effect"
}, {
  hex: "#BB201D",
  code: "450-6",
  scope: "Effect"
}, {
  hex: "#A71616",
  code: "450-M",
  scope: "Effect"
}, {
  hex: "#EFA3A7",
  code: "460-1",
  scope: "Effect"
}, {
  hex: "#E37F89",
  code: "460-2",
  scope: "Effect"
}, {
  hex: "#DF6368",
  code: "460-3",
  scope: "Effect"
}, {
  hex: "#D35254",
  code: "460-4",
  scope: "Effect"
}, {
  hex: "#A8373B",
  code: "460-5",
  scope: "Effect"
}, {
  hex: "#8B1B28",
  code: "460-6",
  scope: "Effect"
}, {
  hex: "#AE363B",
  code: "460-M",
  scope: "Effect"
}, {
  hex: "#F0B3C1",
  code: "470-1",
  scope: "Effect"
}, {
  hex: "#E68B9D",
  code: "470-2",
  scope: "Effect"
}, {
  hex: "#DE7383",
  code: "470-3",
  scope: "Effect"
}, {
  hex: "#CA4D67",
  code: "470-4",
  scope: "Effect"
}, {
  hex: "#AC2D4C",
  code: "470-5",
  scope: "Effect"
}, {
  hex: "#9C223F",
  code: "470-6",
  scope: "Effect"
}, {
  hex: "#B14F5D",
  code: "470-M",
  scope: "Effect"
}, {
  hex: "#F5CAC9",
  code: "480-1",
  scope: "Effect"
}, {
  hex: "#F5C0BE",
  code: "480-2",
  scope: "Effect"
}, {
  hex: "#EEBABC",
  code: "480-3",
  scope: "Effect"
}, {
  hex: "#EEA5B1",
  code: "480-4",
  scope: "Effect"
}, {
  hex: "#E9909E",
  code: "480-5",
  scope: "Effect"
}, {
  hex: "#DA6C82",
  code: "480-6",
  scope: "Effect"
}, {
  hex: "#A87579",
  code: "480-M",
  scope: "Effect"
}, {
  hex: "#F3CFD0",
  code: "490-1",
  scope: "Effect"
}, {
  hex: "#F7CAC3",
  code: "490-2",
  scope: "Effect"
}, {
  hex: "#E89A92",
  code: "490-3",
  scope: "Effect"
}, {
  hex: "#C37B77",
  code: "490-4",
  scope: "Effect"
}, {
  hex: "#BE7F8C",
  code: "490-5",
  scope: "Effect"
}, {
  hex: "#D29EA8",
  code: "490-6",
  scope: "Effect"
}, {
  hex: "#A77D88",
  code: "490-M",
  scope: "Effect"
}, {
  hex: "#ECC8DC",
  code: "510-1",
  scope: "Effect"
}, {
  hex: "#E0A5CB",
  code: "510-2",
  scope: "Effect"
}, {
  hex: "#D584B1",
  code: "510-3",
  scope: "Effect"
}, {
  hex: "#C4638D",
  code: "510-4",
  scope: "Effect"
}, {
  hex: "#BA4877",
  code: "510-5",
  scope: "Effect"
}, {
  hex: "#9A3B6A",
  code: "510-6",
  scope: "Effect"
}, {
  hex: "#8C3D71",
  code: "510-M",
  scope: "Effect"
}, {
  hex: "#EFD2DF",
  code: "520-1",
  scope: "Effect"
}, {
  hex: "#E8BAD2",
  code: "520-2",
  scope: "Effect"
}, {
  hex: "#DCA5C0",
  code: "520-3",
  scope: "Effect"
}, {
  hex: "#BA7293",
  code: "520-4",
  scope: "Effect"
}, {
  hex: "#A04E6F",
  code: "520-5",
  scope: "Effect"
}, {
  hex: "#92526E",
  code: "520-6",
  scope: "Effect"
}, {
  hex: "#9E588B",
  code: "520-M",
  scope: "Effect"
}, {
  hex: "#98444D",
  code: "530-1",
  scope: "Effect"
}, {
  hex: "#8F3F4E",
  code: "530-2",
  scope: "Effect"
}, {
  hex: "#793644",
  code: "530-3",
  scope: "Effect"
}, {
  hex: "#7C2F4B",
  code: "530-4",
  scope: "Effect"
}, {
  hex: "#66253D",
  code: "530-5",
  scope: "Effect"
}, {
  hex: "#61294A",
  code: "530-6",
  scope: "Effect"
}, {
  hex: "#5C2D3A",
  code: "530-M",
  scope: "Effect"
}, {
  hex: "#D4C1D7",
  code: "540-1",
  scope: "Effect"
}, {
  hex: "#BEA1C1",
  code: "540-2",
  scope: "Effect"
}, {
  hex: "#805F83",
  code: "540-3",
  scope: "Effect"
}, {
  hex: "#966B98",
  code: "540-4",
  scope: "Effect"
}, {
  hex: "#81537A",
  code: "540-5",
  scope: "Effect"
}, {
  hex: "#562C51",
  code: "540-6",
  scope: "Effect"
}, {
  hex: "#562F4E",
  code: "540-M",
  scope: "Effect"
}, {
  hex: "#E0D1D9",
  code: "550-1",
  scope: "Effect"
}, {
  hex: "#D0BBC9",
  code: "550-2",
  scope: "Effect"
}, {
  hex: "#B292A8",
  code: "550-3",
  scope: "Effect"
}, {
  hex: "#9C7488",
  code: "550-4",
  scope: "Effect"
}, {
  hex: "#8D6177",
  code: "550-5",
  scope: "Effect"
}, {
  hex: "#784C5E",
  code: "550-6",
  scope: "Effect"
}, {
  hex: "#A78890",
  code: "550-M",
  scope: "Effect"
}, {
  hex: "#CCBCC7",
  code: "560-1",
  scope: "Effect"
}, {
  hex: "#B09CAD",
  code: "560-2",
  scope: "Effect"
}, {
  hex: "#8C6F80",
  code: "560-3",
  scope: "Effect"
}, {
  hex: "#775460",
  code: "560-4",
  scope: "Effect"
}, {
  hex: "#85727F",
  code: "560-5",
  scope: "Effect"
}, {
  hex: "#7D6E7F",
  code: "560-6",
  scope: "Effect"
}, {
  hex: "#A592A4",
  code: "560-M",
  scope: "Effect"
}, {
  hex: "#D1CEE8",
  code: "570-1",
  scope: "Effect"
}, {
  hex: "#C3BFE1",
  code: "570-2",
  scope: "Effect"
}, {
  hex: "#ADADDD",
  code: "570-3",
  scope: "Effect"
}, {
  hex: "#9B9ACF",
  code: "570-4",
  scope: "Effect"
}, {
  hex: "#8078B3",
  code: "570-5",
  scope: "Effect"
}, {
  hex: "#79689B",
  code: "570-6",
  scope: "Effect"
}, {
  hex: "#6B589A",
  code: "570-M",
  scope: "Effect"
}, {
  hex: "#C2CFE6",
  code: "580-1",
  scope: "Effect"
}, {
  hex: "#BCC7E0",
  code: "580-2",
  scope: "Effect"
}, {
  hex: "#A7B2D1",
  code: "580-3",
  scope: "Effect"
}, {
  hex: "#69749A",
  code: "580-4",
  scope: "Effect"
}, {
  hex: "#41506E",
  code: "580-5",
  scope: "Effect"
}, {
  hex: "#243154",
  code: "580-6",
  scope: "Effect"
}, {
  hex: "#636C86",
  code: "580-M",
  scope: "Effect"
}, {
  hex: "#666D9B",
  code: "590-1",
  scope: "Effect"
}, {
  hex: "#424276",
  code: "590-2",
  scope: "Effect"
}, {
  hex: "#2A366B",
  code: "590-3",
  scope: "Effect"
}, {
  hex: "#272F5B",
  code: "590-4",
  scope: "Effect"
}, {
  hex: "#142D58",
  code: "590-5",
  scope: "Effect"
}, {
  hex: "#093B7A",
  code: "590-6",
  scope: "Effect"
}, {
  hex: "#293862",
  code: "590-M",
  scope: "Effect"
}, {
  hex: "#6E8FAB",
  code: "610-1",
  scope: "Effect"
}, {
  hex: "#617A94",
  code: "610-2",
  scope: "Effect"
}, {
  hex: "#6D95B9",
  code: "610-3",
  scope: "Effect"
}, {
  hex: "#89B2D8",
  code: "610-4",
  scope: "Effect"
}, {
  hex: "#4777AE",
  code: "610-5",
  scope: "Effect"
}, {
  hex: "#436999",
  code: "610-6",
  scope: "Effect"
}, {
  hex: "#7897B5",
  code: "610-M",
  scope: "Effect"
}, {
  hex: "#34688A",
  code: "620-1",
  scope: "Effect"
}, {
  hex: "#6092AC",
  code: "620-2",
  scope: "Effect"
}, {
  hex: "#64818F",
  code: "620-3",
  scope: "Effect"
}, {
  hex: "#3A5A6A",
  code: "620-4",
  scope: "Effect"
}, {
  hex: "#14354B",
  code: "620-5",
  scope: "Effect"
}, {
  hex: "#1E2D3F",
  code: "620-6",
  scope: "Effect"
}, {
  hex: "#093246",
  code: "620-M",
  scope: "Effect"
}, {
  hex: "#51A3D3",
  code: "630-1",
  scope: "Effect"
}, {
  hex: "#446B8E",
  code: "630-2",
  scope: "Effect"
}, {
  hex: "#2E4E6F",
  code: "630-3",
  scope: "Effect"
}, {
  hex: "#2D4A6E",
  code: "630-4",
  scope: "Effect"
}, {
  hex: "#1F3454",
  code: "630-5",
  scope: "Effect"
}, {
  hex: "#193654",
  code: "630-6",
  scope: "Effect"
}, {
  hex: "#16304C",
  code: "630-M",
  scope: "Effect"
}, {
  hex: "#49A0C5",
  code: "640-1",
  scope: "Effect"
}, {
  hex: "#0087B5",
  code: "640-2",
  scope: "Effect"
}, {
  hex: "#007BAE",
  code: "640-3",
  scope: "Effect"
}, {
  hex: "#005C8C",
  code: "640-4",
  scope: "Effect"
}, {
  hex: "#00548A",
  code: "640-5",
  scope: "Effect"
}, {
  hex: "#004F7D",
  code: "640-6",
  scope: "Effect"
}, {
  hex: "#004E87",
  code: "640-M",
  scope: "Effect"
}, {
  hex: "#64B5D6",
  code: "650-1",
  scope: "Effect"
}, {
  hex: "#0077A0",
  code: "650-2",
  scope: "Effect"
}, {
  hex: "#006C97",
  code: "650-3",
  scope: "Effect"
}, {
  hex: "#005577",
  code: "650-4",
  scope: "Effect"
}, {
  hex: "#1D5B78",
  code: "650-5",
  scope: "Effect"
}, {
  hex: "#0A4962",
  code: "650-6",
  scope: "Effect"
}, {
  hex: "#00719D",
  code: "650-M",
  scope: "Effect"
}, {
  hex: "#0094B0",
  code: "660-1",
  scope: "Effect"
}, {
  hex: "#0B8DA8",
  code: "660-2",
  scope: "Effect"
}, {
  hex: "#51A5B8",
  code: "660-3",
  scope: "Effect"
}, {
  hex: "#3FB8CF",
  code: "660-4",
  scope: "Effect"
}, {
  hex: "#6CC3D4",
  code: "660-5",
  scope: "Effect"
}, {
  hex: "#8AC8D5",
  code: "660-6",
  scope: "Effect"
}, {
  hex: "#5597A9",
  code: "660-M",
  scope: "Effect"
}, {
  hex: "#8AD3EA",
  code: "670-1",
  scope: "Effect"
}, {
  hex: "#97DAEF",
  code: "670-2",
  scope: "Effect"
}, {
  hex: "#8FC5D6",
  code: "670-3",
  scope: "Effect"
}, {
  hex: "#69BBD3",
  code: "670-4",
  scope: "Effect"
}, {
  hex: "#5BB9D5",
  code: "670-5",
  scope: "Effect"
}, {
  hex: "#4EC2E6",
  code: "670-6",
  scope: "Effect"
}, {
  hex: "#74A7B8",
  code: "670-M",
  scope: "Effect"
}, {
  hex: "#72AABA",
  code: "680-1",
  scope: "Effect"
}, {
  hex: "#338FA4",
  code: "680-2",
  scope: "Effect"
}, {
  hex: "#177185",
  code: "680-3",
  scope: "Effect"
}, {
  hex: "#26768D",
  code: "680-4",
  scope: "Effect"
}, {
  hex: "#006A85",
  code: "680-5",
  scope: "Effect"
}, {
  hex: "#005B74",
  code: "680-6",
  scope: "Effect"
}, {
  hex: "#0E455C",
  code: "680-M",
  scope: "Effect"
}, {
  hex: "#3FBFCB",
  code: "690-1",
  scope: "Effect"
}, {
  hex: "#00A2AD",
  code: "690-2",
  scope: "Effect"
}, {
  hex: "#00838E",
  code: "690-3",
  scope: "Effect"
}, {
  hex: "#006C7B",
  code: "690-4",
  scope: "Effect"
}, {
  hex: "#00535F",
  code: "690-5",
  scope: "Effect"
}, {
  hex: "#005160",
  code: "690-6",
  scope: "Effect"
}, {
  hex: "#006773",
  code: "690-M",
  scope: "Effect"
}, {
  hex: "#78D1CD",
  code: "710-1",
  scope: "Effect"
}, {
  hex: "#00AAA7",
  code: "710-2",
  scope: "Effect"
}, {
  hex: "#058A8B",
  code: "710-3",
  scope: "Effect"
}, {
  hex: "#007476",
  code: "710-4",
  scope: "Effect"
}, {
  hex: "#005C60",
  code: "710-5",
  scope: "Effect"
}, {
  hex: "#0C4746",
  code: "710-6",
  scope: "Effect"
}, {
  hex: "#00686B",
  code: "710-M",
  scope: "Effect"
}, {
  hex: "#C2E3DE",
  code: "720-1",
  scope: "Effect"
}, {
  hex: "#A4E2DB",
  code: "720-2",
  scope: "Effect"
}, {
  hex: "#86D3D4",
  code: "720-3",
  scope: "Effect"
}, {
  hex: "#58BEC1",
  code: "720-4",
  scope: "Effect"
}, {
  hex: "#3393A0",
  code: "720-5",
  scope: "Effect"
}, {
  hex: "#197C86",
  code: "720-6",
  scope: "Effect"
}, {
  hex: "#1A949A",
  code: "720-M",
  scope: "Effect"
}, {
  hex: "#CBE7E2",
  code: "730-1",
  scope: "Effect"
}, {
  hex: "#98D3D3",
  code: "730-2",
  scope: "Effect"
}, {
  hex: "#7DB8BA",
  code: "730-3",
  scope: "Effect"
}, {
  hex: "#7BB9B4",
  code: "730-4",
  scope: "Effect"
}, {
  hex: "#79ACAC",
  code: "730-5",
  scope: "Effect"
}, {
  hex: "#46877F",
  code: "730-6",
  scope: "Effect"
}, {
  hex: "#62A293",
  code: "730-M",
  scope: "Effect"
}, {
  hex: "#C5DCCE",
  code: "740-1",
  scope: "Effect"
}, {
  hex: "#B3D6C9",
  code: "740-2",
  scope: "Effect"
}, {
  hex: "#95C3B2",
  code: "740-3",
  scope: "Effect"
}, {
  hex: "#498574",
  code: "740-4",
  scope: "Effect"
}, {
  hex: "#006F5B",
  code: "740-5",
  scope: "Effect"
}, {
  hex: "#005D4E",
  code: "740-6",
  scope: "Effect"
}, {
  hex: "#3A6F5F",
  code: "740-M",
  scope: "Effect"
}, {
  hex: "#BFD7C9",
  code: "750-1",
  scope: "Effect"
}, {
  hex: "#8FB4A0",
  code: "750-2",
  scope: "Effect"
}, {
  hex: "#3D7461",
  code: "750-3",
  scope: "Effect"
}, {
  hex: "#164234",
  code: "750-4",
  scope: "Effect"
}, {
  hex: "#335449",
  code: "750-5",
  scope: "Effect"
}, {
  hex: "#2E3C3B",
  code: "750-6",
  scope: "Effect"
}, {
  hex: "#17372D",
  code: "750-M",
  scope: "Effect"
}, {
  hex: "#D5E3CA",
  code: "760-1",
  scope: "Effect"
}, {
  hex: "#B8CDAA",
  code: "760-2",
  scope: "Effect"
}, {
  hex: "#B0BE9B",
  code: "760-3",
  scope: "Effect"
}, {
  hex: "#8B9B7A",
  code: "760-4",
  scope: "Effect"
}, {
  hex: "#6D7E5C",
  code: "760-5",
  scope: "Effect"
}, {
  hex: "#4A6448",
  code: "760-6",
  scope: "Effect"
}, {
  hex: "#334B2E",
  code: "760-M",
  scope: "Effect"
}, {
  hex: "#989D84",
  code: "770-1",
  scope: "Effect"
}, {
  hex: "#A9A88F",
  code: "770-2",
  scope: "Effect"
}, {
  hex: "#7A755A",
  code: "770-3",
  scope: "Effect"
}, {
  hex: "#817A66",
  code: "770-4",
  scope: "Effect"
}, {
  hex: "#B4AF9F",
  code: "770-5",
  scope: "Effect"
}, {
  hex: "#7E8273",
  code: "770-6",
  scope: "Effect"
}, {
  hex: "#8D8864",
  code: "770-M",
  scope: "Effect"
}, {
  hex: "#E9DECC",
  code: "780-1",
  scope: "Effect"
}, {
  hex: "#E7D6B9",
  code: "780-2",
  scope: "Effect"
}, {
  hex: "#DDC49A",
  code: "780-3",
  scope: "Effect"
}, {
  hex: "#D1B186",
  code: "780-4",
  scope: "Effect"
}, {
  hex: "#A38E79",
  code: "780-5",
  scope: "Effect"
}, {
  hex: "#74695C",
  code: "780-6",
  scope: "Effect"
}, {
  hex: "#B2A074",
  code: "780-M",
  scope: "Effect"
}, {
  hex: "#3E4849",
  code: "790-1",
  scope: "Effect"
}, {
  hex: "#3B4147",
  code: "790-2",
  scope: "Effect"
}, {
  hex: "#313538",
  code: "790-3",
  scope: "Effect"
}, {
  hex: "#302F32",
  code: "790-4",
  scope: "Effect"
}, {
  hex: "#212224",
  code: "790-5",
  scope: "Effect"
}, {
  hex: "#21232D",
  code: "790-6",
  scope: "Effect"
}, {
  hex: "#221F1D",
  code: "790-M",
  scope: "Effect"
}, {
  hex: "#979DA2",
  code: "810-1",
  scope: "Effect"
}, {
  hex: "#8A9499",
  code: "810-2",
  scope: "Effect"
}, {
  hex: "#79888E",
  code: "810-3",
  scope: "Effect"
}, {
  hex: "#5E6B73",
  code: "810-4",
  scope: "Effect"
}, {
  hex: "#51595D",
  code: "810-5",
  scope: "Effect"
}, {
  hex: "#394146",
  code: "810-6",
  scope: "Effect"
}, {
  hex: "#404649",
  code: "810-M",
  scope: "Effect"
}, {
  hex: "#C5C8CA",
  code: "820-1",
  scope: "Effect"
}, {
  hex: "#A9AEB2",
  code: "820-2",
  scope: "Effect"
}, {
  hex: "#8D9395",
  code: "820-3",
  scope: "Effect"
}, {
  hex: "#7D8589",
  code: "820-4",
  scope: "Effect"
}, {
  hex: "#50555C",
  code: "820-5",
  scope: "Effect"
}, {
  hex: "#444951",
  code: "820-6",
  scope: "Effect"
}, {
  hex: "#929191",
  code: "820-M",
  scope: "Effect"
}, {
  hex: "#BABCBA",
  code: "830-1",
  scope: "Effect"
}, {
  hex: "#A4A7A5",
  code: "830-2",
  scope: "Effect"
}, {
  hex: "#8D9291",
  code: "830-3",
  scope: "Effect"
}, {
  hex: "#6C706D",
  code: "830-4",
  scope: "Effect"
}, {
  hex: "#515554",
  code: "830-5",
  scope: "Effect"
}, {
  hex: "#575E60",
  code: "830-6",
  scope: "Effect"
}, {
  hex: "#82817F",
  code: "830-M",
  scope: "Effect"
}, {
  hex: "#E7E3D8",
  code: "840-1",
  scope: "Effect"
}, {
  hex: "#D7D5CC",
  code: "840-2",
  scope: "Effect"
}, {
  hex: "#B8B4A8",
  code: "840-3",
  scope: "Effect"
}, {
  hex: "#808077",
  code: "840-4",
  scope: "Effect"
}, {
  hex: "#5A5D54",
  code: "840-5",
  scope: "Effect"
}, {
  hex: "#474135",
  code: "840-6",
  scope: "Effect"
}, {
  hex: "#494440",
  code: "840-M",
  scope: "Effect"
}, {
  hex: "#C3C2B9",
  code: "850-1",
  scope: "Effect"
}, {
  hex: "#B1B1AA",
  code: "850-2",
  scope: "Effect"
}, {
  hex: "#A6A6A0",
  code: "850-3",
  scope: "Effect"
}, {
  hex: "#918D85",
  code: "850-4",
  scope: "Effect"
}, {
  hex: "#6B6760",
  code: "850-5",
  scope: "Effect"
}, {
  hex: "#4C4B46",
  code: "850-6",
  scope: "Effect"
}, {
  hex: "#625E59",
  code: "850-M",
  scope: "Effect"
}, {
  hex: "#D8DADB",
  code: "860-1",
  scope: "Effect"
}, {
  hex: "#CFD2D5",
  code: "860-2",
  scope: "Effect"
}, {
  hex: "#C1C2C4",
  code: "860-3",
  scope: "Effect"
}, {
  hex: "#9A9A9B",
  code: "860-4",
  scope: "Effect"
}, {
  hex: "#7A7A79",
  code: "860-5",
  scope: "Effect"
}, {
  hex: "#5B5F5F",
  code: "860-6",
  scope: "Effect"
}, {
  hex: "#A4A09F",
  code: "860-M",
  scope: "Effect"
}, {
  hex: "#D3D0D0",
  code: "870-1",
  scope: "Effect"
}, {
  hex: "#969392",
  code: "870-2",
  scope: "Effect"
}, {
  hex: "#636164",
  code: "870-3",
  scope: "Effect"
}, {
  hex: "#514D4E",
  code: "870-4",
  scope: "Effect"
}, {
  hex: "#4A4747",
  code: "870-5",
  scope: "Effect"
}, {
  hex: "#3D3737",
  code: "870-6",
  scope: "Effect"
}, {
  hex: "#4D4747",
  code: "870-M",
  scope: "Effect"
}], TCt = [{
  hex: "#69473e",
  code: "DB301",
  scope: "DB",
  de: "DB 301",
  en: "DB 301",
  dontAddPrefix: !0,
  nl: "DB 301",
  fr: "DB 301"
}, {
  hex: "#52251f",
  code: "DB310",
  scope: "DB",
  de: "DB 310",
  en: "DB 310",
  dontAddPrefix: !0,
  nl: "DB 310",
  fr: "DB 310"
}, {
  hex: "#638a89",
  code: "DB501",
  scope: "DB",
  de: "DB 501",
  en: "DB 501",
  dontAddPrefix: !0,
  nl: "DB 501",
  fr: "DB 501"
}, {
  hex: "#294b4c",
  code: "DB502",
  scope: "DB",
  de: "DB 502",
  en: "DB 502",
  dontAddPrefix: !0,
  nl: "DB 502",
  fr: "DB 502"
}, {
  hex: "#203d45",
  code: "DB503",
  scope: "DB",
  de: "DB 503",
  en: "DB 503",
  dontAddPrefix: !0,
  nl: "DB 503",
  fr: "DB 503"
}, {
  hex: "#2f5063",
  code: "DB510",
  scope: "DB",
  de: "DB 510",
  en: "DB 510",
  dontAddPrefix: !0,
  nl: "DB 510",
  fr: "DB 510"
}, {
  hex: "#537250",
  code: "DB601",
  scope: "DB",
  de: "DB 601",
  en: "DB 601",
  dontAddPrefix: !0,
  nl: "DB 601",
  fr: "DB 601"
}, {
  hex: "#41624d",
  code: "DB603",
  scope: "DB",
  de: "DB 603",
  en: "DB 603",
  dontAddPrefix: !0,
  nl: "DB 603",
  fr: "DB 603"
}, {
  hex: "#2b6954",
  code: "DB610",
  scope: "DB",
  de: "DB 610",
  en: "DB 610",
  dontAddPrefix: !0,
  nl: "DB 610",
  fr: "DB 610"
}, {
  hex: "#8b9e9a",
  code: "DB701",
  scope: "DB",
  de: "DB 701",
  en: "DB 701",
  dontAddPrefix: !0,
  nl: "DB 701",
  fr: "DB 701"
}, {
  hex: "#5f7165",
  code: "DB702",
  scope: "DB",
  de: "DB 702",
  en: "DB 702",
  dontAddPrefix: !0,
  nl: "DB 702",
  fr: "DB 702"
}, {
  hex: "#2d3e34",
  code: "DB703",
  scope: "DB",
  de: "DB 703",
  en: "DB 703",
  dontAddPrefix: !0,
  nl: "DB 703",
  fr: "DB 703"
}], MCt = [{
  hex: "#414141",
  code: "000 15 00",
  scope: "Design System Plus",
  de: "Tintenschwarz",
  en: "Ink black",
  nl: "Inkt zwart",
  fr: "Noir d'encre"
}, {
  hex: "#474646",
  code: "000 20 00",
  scope: "Design System Plus",
  de: "Schieferschwarz",
  en: "Slate black",
  nl: "Leisteen zwart",
  fr: "Noir ardoise"
}, {
  hex: "#504f4f",
  code: "000 25 00",
  scope: "Design System Plus",
  de: "Onyxschwarz",
  en: "Onyx black",
  nl: "Onyx zwart",
  fr: "Noir onyx"
}, {
  hex: "#565656",
  code: "000 30 00",
  scope: "Design System Plus",
  de: "Mittelschwarz",
  en: "Medium black",
  nl: "Medium zwart",
  fr: "Noir moyen"
}, {
  hex: "#5f5f5f",
  code: "000 35 00",
  scope: "Design System Plus",
  de: "Brikettgrau",
  en: "Briquette grey",
  nl: "Briket grijs",
  fr: "Gris briquette"
}, {
  hex: "#696968",
  code: "000 40 00",
  scope: "Design System Plus",
  de: "Dunkelgrau",
  en: "Dark grey",
  nl: "Donkergrijs",
  fr: "Gris foncé"
}, {
  hex: "#757473",
  code: "000 45 00",
  scope: "Design System Plus",
  de: "Architekturgrau",
  en: "Architecture grey",
  nl: "Architectonisch grijs",
  fr: "Gris architecture"
}, {
  hex: "#7e7f7e",
  code: "000 50 00",
  scope: "Design System Plus",
  de: "Stahlgrau",
  en: "Steel grey",
  nl: "Staalgrijs",
  fr: "Gris acier"
}, {
  hex: "#898989",
  code: "000 55 00",
  scope: "Design System Plus",
  de: "Mittelgrau",
  en: "Medium grey",
  nl: "Medium grijs",
  fr: "Gris moyen"
}, {
  hex: "#959595",
  code: "000 60 00",
  scope: "Design System Plus",
  de: "Aschgrau",
  en: "Ash grey",
  nl: "Asgrijs",
  fr: "Gris cendré"
}, {
  hex: "#a3a3a3",
  code: "000 65 00",
  scope: "Design System Plus",
  de: "Mörtelgrau",
  en: "Mortar grey",
  nl: "Mortel grijs",
  fr: "Gris mortier"
}, {
  hex: "#b0b0b0",
  code: "000 70 00",
  scope: "Design System Plus",
  de: "Leichtgrau",
  en: "Light grey",
  nl: "Lichtgrijs",
  fr: "Gris léger"
}, {
  hex: "#bdbdbd",
  code: "000 75 00",
  scope: "Design System Plus",
  de: "Marmorgrau",
  en: "Marble grey",
  nl: "Marmer grijs",
  fr: "Gris marbre"
}, {
  hex: "#cacac9",
  code: "000 80 00",
  scope: "Design System Plus",
  de: "Nebelgrau",
  en: "Foggy grey",
  nl: "Mist grijs",
  fr: "Gris brume"
}, {
  hex: "#d7d7d5",
  code: "000 85 00",
  scope: "Design System Plus",
  de: "Schattenweiß",
  en: "Shadow white",
  nl: "Schaduw wit",
  fr: "Blanc d'ombre"
}, {
  hex: "#e2e3e1",
  code: "000 90 00",
  scope: "Design System Plus",
  de: "Winterweiß",
  en: "Winter white",
  nl: "Winterwit",
  fr: "Blanc d'hiver"
}, {
  hex: "#524446",
  code: "010 20 10",
  scope: "Design System Plus",
  de: "Wengeschwarz",
  en: "Wenge black",
  nl: "Wengeschwarz",
  fr: "Noir de wengé"
}, {
  hex: "#564144",
  code: "010 20 15",
  scope: "Design System Plus",
  de: "Kirschenschwarz",
  en: "Cherry black",
  nl: "Kersen zwart",
  fr: "Noir cerise"
}, {
  hex: "#5b3f43",
  code: "010 20 20",
  scope: "Design System Plus",
  de: "Dunkelmahagoni",
  en: "Dark mahogany",
  nl: "Donker mahonie",
  fr: "Acajou foncé"
}, {
  hex: "#5e3e43",
  code: "010 20 25",
  scope: "Design System Plus",
  de: "Rostrot",
  en: "Rusty red",
  nl: "Roest rood",
  fr: "Rouge rouille"
}, {
  hex: "#665255",
  code: "010 30 10",
  scope: "Design System Plus",
  de: "Holzschwarzrot",
  en: "Laurel nut rusty brown",
  nl: "Hout zwart rood",
  fr: "Rouge bois noir"
}, {
  hex: "#6a5054",
  code: "010 30 15",
  scope: "Design System Plus",
  de: "Nachtmauve",
  en: "Night mauve",
  nl: "Nacht mauve",
  fr: "Mauve nuit"
}, {
  hex: "#714e53",
  code: "010 30 20",
  scope: "Design System Plus",
  de: "Rosigbraun",
  en: "Pinkish brown",
  nl: "Rozig bruin",
  fr: "Marron rose"
}, {
  hex: "#774a52",
  code: "010 30 25",
  scope: "Design System Plus",
  de: "Kastanienrot",
  en: "Chestnut red",
  nl: "Kastanje rood",
  fr: "Rouge châtaigne"
}, {
  hex: "#7c4851",
  code: "010 30 30",
  scope: "Design System Plus",
  de: "Lederrot",
  en: "Leather red",
  nl: "Leder rood",
  fr: "Rouge cuir"
}, {
  hex: "#7e454f",
  code: "010 30 35",
  scope: "Design System Plus",
  de: "Anthrazitrot",
  en: "Anthracite red",
  nl: "Antraciet rood",
  fr: "Rouge anthracite"
}, {
  hex: "#86404f",
  code: "010 30 40",
  scope: "Design System Plus",
  de: "Braunmagenta",
  en: "Brown magenta",
  nl: "Bruin magenta",
  fr: "Magenta brun"
}, {
  hex: "#8b3d4f",
  code: "010 30 44",
  scope: "Design System Plus",
  de: "Atlasrot",
  en: "Atlas red",
  nl: "Atlas rood",
  fr: "Rouge atlas"
}, {
  hex: "#796567",
  code: "010 40 10",
  scope: "Design System Plus",
  de: "Caputmortuumgraurot",
  en: "Caput mortuum grey red",
  nl: "Caputmortuum grijs rood",
  fr: "Caputmortuumgraurot"
}, {
  hex: "#806165",
  code: "010 40 15",
  scope: "Design System Plus",
  de: "Rostbraun",
  en: "Rust brown",
  nl: "Roestbruin",
  fr: "Marron rouille"
}, {
  hex: "#875f64",
  code: "010 40 20",
  scope: "Design System Plus",
  de: "Abendrot",
  en: "Sunset red",
  nl: "Zonsondergang",
  fr: "Coucher de soleil"
}, {
  hex: "#8d5c65",
  code: "010 40 25",
  scope: "Design System Plus",
  de: "Mineralrot",
  en: "Mineral red",
  nl: "Mineraal rood",
  fr: "Rouge minéral"
}, {
  hex: "#945963",
  code: "010 40 30",
  scope: "Design System Plus",
  de: "Trübmagenta",
  en: "Dull magenta",
  nl: "Bewolkt magenta",
  fr: "Magenta trouble"
}, {
  hex: "#975460",
  code: "010 40 35",
  scope: "Design System Plus",
  de: "Samtrot",
  en: "Velvet red",
  nl: "Fluweelrood",
  fr: "Rouge velours"
}, {
  hex: "#9f5161",
  code: "010 40 40",
  scope: "Design System Plus",
  de: "Algenrot",
  en: "Algae red",
  nl: "Algen rood",
  fr: "Rouge algue"
}, {
  hex: "#a54d61",
  code: "010 40 45",
  scope: "Design System Plus",
  de: "Himbeereisrot",
  en: "Raspberry ice cream red",
  nl: "Framboos ijs rood",
  fr: "Rouge framboise"
}, {
  hex: "#ab4960",
  code: "010 40 50",
  scope: "Design System Plus",
  de: "Fuchsiarot",
  en: "Fuchsia red",
  nl: "Fuchsiarood",
  fr: "Rouge fuchsia"
}, {
  hex: "#ae465e",
  code: "010 40 53",
  scope: "Design System Plus",
  de: "Urrot",
  en: "Primal red",
  nl: "Oerrood",
  fr: "Urrot"
}, {
  hex: "#8f797d",
  code: "010 50 10",
  scope: "Design System Plus",
  de: "Altmahagoni",
  en: "Old mahogany",
  nl: "Oud mahonie",
  fr: "Acajou ancien"
}, {
  hex: "#96757a",
  code: "010 50 15",
  scope: "Design System Plus",
  de: "Trübaltrosa",
  en: "Dull dusky pink",
  nl: "Bewolkt roze",
  fr: "Rose pâle trouble"
}, {
  hex: "#9d737a",
  code: "010 50 20",
  scope: "Design System Plus",
  de: "Backsteinrot",
  en: "Brickwork red",
  nl: "Baksteen rood",
  fr: "Rouge brique"
}, {
  hex: "#a67079",
  code: "010 50 25",
  scope: "Design System Plus",
  de: "Mattkarmin",
  en: "Matte carmine",
  nl: "Mat karmijn",
  fr: "Carmin mat"
}, {
  hex: "#ae6c78",
  code: "010 50 30",
  scope: "Design System Plus",
  de: "Marmorrot",
  en: "Marble red",
  nl: "Marmerrood",
  fr: "Rouge marbré"
}, {
  hex: "#b36876",
  code: "010 50 35",
  scope: "Design System Plus",
  de: "Geranienrot",
  en: "Geranium red",
  nl: "Geranium rood",
  fr: "Rouge géranium"
}, {
  hex: "#b86576",
  code: "010 50 40",
  scope: "Design System Plus",
  de: "Schieferrosa",
  en: "Slate pink",
  nl: "Leisteen roze",
  fr: "Rose ardoise"
}, {
  hex: "#bd5f74",
  code: "010 50 45",
  scope: "Design System Plus",
  de: "Tulipanrot",
  en: "Tulip red",
  nl: "Tulpenrood",
  fr: "Rouge tulipe"
}, {
  hex: "#c65c74",
  code: "010 50 50",
  scope: "Design System Plus",
  de: "Lichtrot",
  en: "Vibrant red",
  nl: "Licht rood",
  fr: "Rouge lumière"
}, {
  hex: "#a89093",
  code: "010 60 10",
  scope: "Design System Plus",
  de: "Fliedergrau",
  en: "Lilac grey",
  nl: "Lila grijs",
  fr: "Gris lilas"
}, {
  hex: "#b18e93",
  code: "010 60 15",
  scope: "Design System Plus",
  de: "Eisorchideenrot",
  en: "Ice orchid red",
  nl: "Ijsorchidee rood",
  fr: "Rouge orchidée glacée"
}, {
  hex: "#ba8b92",
  code: "010 60 20",
  scope: "Design System Plus",
  de: "Kalkrosa",
  en: "Lime pink",
  nl: "Limoenroze",
  fr: "Rose calcaire"
}, {
  hex: "#c08690",
  code: "010 60 25",
  scope: "Design System Plus",
  de: "Lippenstiftrosa",
  en: "Lipstick pink",
  nl: "Lippenstift roze",
  fr: "Rose à lèvres"
}, {
  hex: "#c7828f",
  code: "010 60 30",
  scope: "Design System Plus",
  de: "Japankoralle",
  en: "Japanese coral",
  nl: "Japans koraal",
  fr: "Corail du Japon"
}, {
  hex: "#d07f8d",
  code: "010 60 35",
  scope: "Design System Plus",
  de: "Rosenrot",
  en: "Rose red",
  nl: "Rozerood",
  fr: "Rose rouge"
}, {
  hex: "#d67b8c",
  code: "010 60 40",
  scope: "Design System Plus",
  de: "Erdbeershakerot",
  en: "Strawberry milkshake red",
  nl: "Aardbeienshaker rood",
  fr: "Shakerot à la fraise"
}, {
  hex: "#df768b",
  code: "010 60 45",
  scope: "Design System Plus",
  de: "Leuchtendrosa",
  en: "Luminous pink",
  nl: "Helder roze",
  fr: "Rose vif"
}, {
  hex: "#c3aaae",
  code: "010 70 10",
  scope: "Design System Plus",
  de: "Blassmauve",
  en: "Pale mauve",
  nl: "Licht mauve",
  fr: "Mauve pâle"
}, {
  hex: "#caa7ab",
  code: "010 70 15",
  scope: "Design System Plus",
  de: "Puderrosé",
  en: "Powder rose",
  nl: "Poederroze",
  fr: "Rose poudré"
}, {
  hex: "#d4a3ab",
  code: "010 70 20",
  scope: "Design System Plus",
  de: "Silberrosé",
  en: "Silver rose",
  nl: "Zilveren roos",
  fr: "Rose argenté"
}, {
  hex: "#dc9fa9",
  code: "010 70 25",
  scope: "Design System Plus",
  de: "Flamingorosa",
  en: "Flamingo pink",
  nl: "Flamingo roze",
  fr: "Flamingorosa"
}, {
  hex: "#e39ca8",
  code: "010 70 30",
  scope: "Design System Plus",
  de: "Kirschblütenrosa",
  en: "Cherry blossom pink",
  nl: "Kersenbloesem roze",
  fr: "Rose cerise"
}, {
  hex: "#eb96a5",
  code: "010 70 35",
  scope: "Design System Plus",
  de: "Babyrosa",
  en: "Baby pink",
  nl: "Baby roze",
  fr: "Rose bébé"
}, {
  hex: "#dec3c5",
  code: "010 80 10",
  scope: "Design System Plus",
  de: "Schlammpink",
  en: "Mud pink",
  nl: "Modderroze",
  fr: "Rose boue"
}, {
  hex: "#e5c0c4",
  code: "010 80 15",
  scope: "Design System Plus",
  de: "Eispink",
  en: "Ice hot pink",
  nl: "IJsroze",
  fr: "Rose glacé"
}, {
  hex: "#efbcc3",
  code: "010 80 20",
  scope: "Design System Plus",
  de: "Pastellrosa",
  en: "Pastel pink",
  nl: "Pastelroze",
  fr: "Rose pastel"
}, {
  hex: "#ded1d3",
  code: "010 85 05",
  scope: "Design System Plus",
  de: "Perlrosé",
  en: "Pearl rose",
  nl: "Parel rosé",
  fr: "Perlrosé"
}, {
  hex: "#e4cdd1",
  code: "010 85 10",
  scope: "Design System Plus",
  de: "Lachsrosé",
  en: "Salmon rose",
  nl: "Zalmroze",
  fr: "Rose saumon"
}, {
  hex: "#efccd2",
  code: "010 85 15",
  scope: "Design System Plus",
  de: "Milchshakerosa",
  en: "Milkshake pink",
  nl: "Melkshakerosa",
  fr: "Shakerosa de lait"
}, {
  hex: "#f8cbd2",
  code: "010 85 20",
  scope: "Design System Plus",
  de: "Inkarnatrosé",
  en: "Carnation pink",
  nl: "Menselijke roos",
  fr: "Rose incarnat"
}, {
  hex: "#efe0df",
  code: "010 90 05",
  scope: "Design System Plus",
  de: "Rosécreme",
  en: "Rose cream",
  nl: "Rosé crème",
  fr: "Crème rose"
}, {
  hex: "#f2dbd8",
  code: "010 90 10",
  scope: "Design System Plus",
  de: "Hellapricot",
  en: "Light apricot",
  nl: "Hellapricot",
  fr: "Hellapricot"
}, {
  hex: "#f1e6e8",
  code: "010 93 05",
  scope: "Design System Plus",
  de: "Weißrötlich",
  en: "White-red",
  nl: "Wit-roodachtig",
  fr: "Blanc rougeâtre"
}, {
  hex: "#4c4545",
  code: "020 20 05",
  scope: "Design System Plus",
  de: "Tiefbraun",
  en: "Deep brown",
  nl: "Diep bruin",
  fr: "Marron profond"
}, {
  hex: "#524343",
  code: "020 20 10",
  scope: "Design System Plus",
  de: "Nachtröte",
  en: "Night red",
  nl: "Nachtzanger",
  fr: "Nocturne"
}, {
  hex: "#5b4041",
  code: "020 20 20",
  scope: "Design System Plus",
  de: "Dunkelrotbraun",
  en: "Dark red brown",
  nl: "Donker roodbruin",
  fr: "Marron rouge foncé"
}, {
  hex: "#633c40",
  code: "020 20 29",
  scope: "Design System Plus",
  de: "Burgunderrot",
  en: "Burgundy",
  nl: "Bourgondisch rood",
  fr: "Rouge bordeaux"
}, {
  hex: "#5d5454",
  code: "020 30 05",
  scope: "Design System Plus",
  de: "Rhodonitbraun",
  en: "Rhodonite brown",
  nl: "Rhodoniet bruin",
  fr: "Brun rhodonite"
}, {
  hex: "#645151",
  code: "020 30 10",
  scope: "Design System Plus",
  de: "Budapesterbraun",
  en: "Budapest brown",
  nl: "Boedapest bruin",
  fr: "Marron budapest"
}, {
  hex: "#6f4b4c",
  code: "020 30 20",
  scope: "Design System Plus",
  de: "Kremlrot",
  en: "Kremlin red",
  nl: "Kremlin rood",
  fr: "Rouge du Kremlin"
}, {
  hex: "#78464a",
  code: "020 30 30",
  scope: "Design System Plus",
  de: "Kristalldunkelrot",
  en: "Crystal dark red",
  nl: "Kristal donkerrood",
  fr: "Rouge foncé cristal"
}, {
  hex: "#844048",
  code: "020 30 40",
  scope: "Design System Plus",
  de: "Amaranthblüte",
  en: "Amaranth blossom",
  nl: "Amarant bloesem",
  fr: "Fleur d'amarante"
}, {
  hex: "#8c3c46",
  code: "020 30 48",
  scope: "Design System Plus",
  de: "Vogelkirschenrot",
  en: "Sweet cherry red",
  nl: "Vogel kersenrood",
  fr: "Rouge cerise d'oiseau"
}, {
  hex: "#726868",
  code: "020 40 05",
  scope: "Design System Plus",
  de: "Graubräunlich",
  en: "Greyish brown",
  nl: "Grijsbruin",
  fr: "Gris-brunâtre"
}, {
  hex: "#786464",
  code: "020 40 10",
  scope: "Design System Plus",
  de: "Nussbaumbraun",
  en: "Nut brown",
  nl: "Walnootbruin",
  fr: "Marron noyer"
}, {
  hex: "#855e60",
  code: "020 40 20",
  scope: "Design System Plus",
  de: "Antikrot",
  en: "Antique red",
  nl: "Antiek rood",
  fr: "Rouge antique"
}, {
  hex: "#92585c",
  code: "020 40 30",
  scope: "Design System Plus",
  de: "Hermosarosa",
  en: "Hermosa pink",
  nl: "Hermosarosa",
  fr: "Hermosarosa"
}, {
  hex: "#9b5157",
  code: "020 40 40",
  scope: "Design System Plus",
  de: "Oktoberrot",
  en: "October red",
  nl: "Oktober rood",
  fr: "Rouge octobre"
}, {
  hex: "#a74751",
  code: "020 40 50",
  scope: "Design System Plus",
  de: "Knallrot",
  en: "Bright red",
  nl: "Helder rood",
  fr: "Rouge vif"
}, {
  hex: "#897d7c",
  code: "020 50 05",
  scope: "Design System Plus",
  de: "Zirkongrau",
  en: "Zircon grey",
  nl: "Zirkoon grijs",
  fr: "Gris zircon"
}, {
  hex: "#907879",
  code: "020 50 10",
  scope: "Design System Plus",
  de: "Sandsteinrotgrau",
  en: "Sandstone red grey",
  nl: "Zandsteen rood-grijs",
  fr: "Gris grès rouge"
}, {
  hex: "#9f7274",
  code: "020 50 20",
  scope: "Design System Plus",
  de: "Rotgrau",
  en: "Red grey",
  nl: "Roodgrijs",
  fr: "Gris rouge"
}, {
  hex: "#ac6c70",
  code: "020 50 30",
  scope: "Design System Plus",
  de: "Venezianerrot",
  en: "Venetian red",
  nl: "Venetiaans rood",
  fr: "Rouge vénitien"
}, {
  hex: "#b6646b",
  code: "020 50 40",
  scope: "Design System Plus",
  de: "Schwedenkleerot",
  en: "Alsike clover red",
  nl: "Zweeds klavertje rood",
  fr: "Rouge de trèfle suédois"
}, {
  hex: "#c25c67",
  code: "020 50 50",
  scope: "Design System Plus",
  de: "Flammenrot",
  en: "Flame red",
  nl: "Vuurrood",
  fr: "Rouge flamme"
}, {
  hex: "#d25766",
  code: "020 50 58",
  scope: "Design System Plus",
  de: "Preiselbeerenrot",
  en: "Lingonberry red",
  nl: "Veenbessenrood",
  fr: "Rouge canneberge"
}, {
  hex: "#9f9493",
  code: "020 60 05",
  scope: "Design System Plus",
  de: "Kugeldistelgraurosé",
  en: "Globe thistle grey rose",
  nl: "Bal distel grijs rosé",
  fr: "Chardon sphérique grisâtre"
}, {
  hex: "#a78e8f",
  code: "020 60 10",
  scope: "Design System Plus",
  de: "Blechrosa",
  en: "Tin pink",
  nl: "Tin roze",
  fr: "Rose de tôle"
}, {
  hex: "#b88a8c",
  code: "020 60 20",
  scope: "Design System Plus",
  de: "Retrorosa",
  en: "Retro pink",
  nl: "Retrorosa",
  fr: "Retrorosa"
}, {
  hex: "#c68186",
  code: "020 60 30",
  scope: "Design System Plus",
  de: "Begonienrostrosé",
  en: "Begonia rusty rose",
  nl: "Begonia roestroze",
  fr: "Rose bégonia"
}, {
  hex: "#d37a82",
  code: "020 60 40",
  scope: "Design System Plus",
  de: "Lotusrot",
  en: "Lotus red",
  nl: "Lotusrood",
  fr: "Rouge lotus"
}, {
  hex: "#b9adac",
  code: "020 70 05",
  scope: "Design System Plus",
  de: "Fashionmauve",
  en: "Fashion mauve",
  nl: "Mode mauve",
  fr: "Fashionmauve"
}, {
  hex: "#c0a7a8",
  code: "020 70 10",
  scope: "Design System Plus",
  de: "Turmalinmauve",
  en: "Tourmaline mauve",
  nl: "Toermalijn mauve",
  fr: "Mauve tourmaline"
}, {
  hex: "#d4a2a5",
  code: "020 70 20",
  scope: "Design System Plus",
  de: "Rosenholzapricot",
  en: "Rosewood apricot",
  nl: "Rozenhout abrikoos",
  fr: "Abricot bois de rose"
}, {
  hex: "#e49ba0",
  code: "020 70 30",
  scope: "Design System Plus",
  de: "Markerrosa",
  en: "Marker pink",
  nl: "Marker roze",
  fr: "Rose marqueur"
}, {
  hex: "#d5c7c6",
  code: "020 80 05",
  scope: "Design System Plus",
  de: "Auroragrau",
  en: "Aurora grey",
  nl: "Aurora grijs",
  fr: "Gris aurore"
}, {
  hex: "#dcc1c2",
  code: "020 80 10",
  scope: "Design System Plus",
  de: "Quarzrosé",
  en: "Quartz rose",
  nl: "Kwarts rosé",
  fr: "Rose quartz"
}, {
  hex: "#eebcbe",
  code: "020 80 20",
  scope: "Design System Plus",
  de: "Marzipanrosa",
  en: "Marzipan pink",
  nl: "Marsepein roze",
  fr: "Rose massepain"
}, {
  hex: "#dfd1d1",
  code: "020 85 05",
  scope: "Design System Plus",
  de: "Mandelblütenrosa",
  en: "Almond blossom pink",
  nl: "Amandelbloesem roze",
  fr: "Rose fleur d'amandier"
}, {
  hex: "#e7cece",
  code: "020 85 10",
  scope: "Design System Plus",
  de: "Lachscreme",
  en: "Salmon cream",
  nl: "Zalmcrème",
  fr: "Crème de saumon"
}, {
  hex: "#fbc9ca",
  code: "020 85 20",
  scope: "Design System Plus",
  de: "Elegantlichtrosé",
  en: "Elegant light rose",
  nl: "Elegant lichtroze",
  fr: "Elégant trosé"
}, {
  hex: "#f0e2de",
  code: "020 90 05",
  scope: "Design System Plus",
  de: "Muschelweiß",
  en: "Mussel white",
  nl: "Schelp wit",
  fr: "Blanc de coquillage"
}, {
  hex: "#f3ddd9",
  code: "020 90 10",
  scope: "Design System Plus",
  de: "Pfirsichcreme",
  en: "Peach cream",
  nl: "Perzikcrème",
  fr: "Crème de pêche"
}, {
  hex: "#f6e6e3",
  code: "020 93 05",
  scope: "Design System Plus",
  de: "Blütenweiß",
  en: "Blossom white",
  nl: "Bloesem wit",
  fr: "Blanc de fleur"
}, {
  hex: "#635351",
  code: "030 30 10",
  scope: "Design System Plus",
  de: "Laurelnussrostbraun",
  en: "Laurel nut rusty brown",
  nl: "Lauriernoot roestbruin",
  fr: "Brun rouille de noix de laurier"
}, {
  hex: "#6e4d4b",
  code: "030 30 20",
  scope: "Design System Plus",
  de: "Herbstlaubrot",
  en: "Autumn leaf red",
  nl: "Herfstblad rood",
  fr: "Rouge feuille d'automne"
}, {
  hex: "#784845",
  code: "030 30 30",
  scope: "Design System Plus",
  de: "Macorefurnierrot",
  en: "Macore veneer red",
  nl: "Maco fineer rood",
  fr: "Rouge plaqué macore"
}, {
  hex: "#854343",
  code: "030 30 40",
  scope: "Design System Plus",
  de: "Karmesinrot",
  en: "Crimson red",
  nl: "Crimson rood",
  fr: "Rouge cramoisi"
}, {
  hex: "#863e3f",
  code: "030 30 45",
  scope: "Design System Plus",
  de: "Blutrot",
  en: "Blood red",
  nl: "Bloedrood",
  fr: "Rouge sang"
}, {
  hex: "#766361",
  code: "030 40 10",
  scope: "Design System Plus",
  de: "Torfrotbraun",
  en: "Peat red brown",
  nl: "Veen roodbruin",
  fr: "Marron tourbe"
}, {
  hex: "#86605c",
  code: "030 40 20",
  scope: "Design System Plus",
  de: "Moosbeerenrot",
  en: "Cranberry red",
  nl: "Veenbessenrood",
  fr: "Rouge canneberge"
}, {
  hex: "#925955",
  code: "030 40 30",
  scope: "Design System Plus",
  de: "Backsteinbraun",
  en: "Brick brown",
  nl: "Baksteen bruin",
  fr: "Marron brique"
}, {
  hex: "#9d5351",
  code: "030 40 40",
  scope: "Design System Plus",
  de: "Scharfrot",
  en: "Spicy red",
  nl: "Scherp rood",
  fr: "Rouge vif"
}, {
  hex: "#a84c4c",
  code: "030 40 50",
  scope: "Design System Plus",
  de: "Hibiskusrot",
  en: "Hibiscus red",
  nl: "Hibiscus rood",
  fr: "Rouge hibiscus"
}, {
  hex: "#b14548",
  code: "030 40 60",
  scope: "Design System Plus",
  de: "Kaiserkirschenrot",
  en: "Emperor cherry red",
  nl: "Keizer kersenrood",
  fr: "Rouge cerise impériale"
}, {
  hex: "#8f7875",
  code: "030 50 10",
  scope: "Design System Plus",
  de: "Erdrot",
  en: "Earth red",
  nl: "Aarde rood",
  fr: "Rouge terre"
}, {
  hex: "#9d736f",
  code: "030 50 20",
  scope: "Design System Plus",
  de: "Terracottarotbraun",
  en: "Terracotta red brown",
  nl: "Terracotta roodbruin",
  fr: "Brun rouge terracotta"
}, {
  hex: "#ab6d68",
  code: "030 50 30",
  scope: "Design System Plus",
  de: "Lehmrot",
  en: "Clay red",
  nl: "Klei rood",
  fr: "Rouge argile"
}, {
  hex: "#b86762",
  code: "030 50 40",
  scope: "Design System Plus",
  de: "Zinnoberrot",
  en: "Vermilion red",
  nl: "Vermiljoen",
  fr: "Rouge vermillon"
}, {
  hex: "#c25f5c",
  code: "030 50 50",
  scope: "Design System Plus",
  de: "Ahornrot",
  en: "Maple red",
  nl: "Esdoorn rood",
  fr: "Rouge érable"
}, {
  hex: "#cf5654",
  code: "030 50 60",
  scope: "Design System Plus",
  de: "Hollandrot",
  en: "Holland red",
  nl: "Nederland rood",
  fr: "Rouge hollandais"
}, {
  hex: "#a6908e",
  code: "030 60 10",
  scope: "Design System Plus",
  de: "Sturmröte",
  en: "Storm red",
  nl: "Stormrood",
  fr: "Rouge de la tempête"
}, {
  hex: "#b78a86",
  code: "030 60 20",
  scope: "Design System Plus",
  de: "Wüstenrot",
  en: "Desert red",
  nl: "Wüstenrot",
  fr: "Wüstenrot"
}, {
  hex: "#c5827c",
  code: "030 60 30",
  scope: "Design System Plus",
  de: "Antikrosa",
  en: "Antique pink",
  nl: "Antiek roze",
  fr: "Rose antique"
}, {
  hex: "#d37d77",
  code: "030 60 40",
  scope: "Design System Plus",
  de: "Helltomate",
  en: "Light tomato",
  nl: "Lichtgekleurde tomaat",
  fr: "Tomate claire"
}, {
  hex: "#e0746e",
  code: "030 60 50",
  scope: "Design System Plus",
  de: "Kalypsorot",
  en: "Calypso red",
  nl: "Calypsorot",
  fr: "Calypsorote"
}, {
  hex: "#c0a8a6",
  code: "030 70 10",
  scope: "Design System Plus",
  de: "Floridagrau",
  en: "Florida grey",
  nl: "Grijs Florida",
  fr: "Gris florida"
}, {
  hex: "#d2a19c",
  code: "030 70 20",
  scope: "Design System Plus",
  de: "Trübapricot",
  en: "Dull apricot",
  nl: "Bewolkt abrikoos",
  fr: "Pricot de turbidité"
}, {
  hex: "#e29a94",
  code: "030 70 30",
  scope: "Design System Plus",
  de: "Lachsrosarot",
  en: "Salmon pink red",
  nl: "Zalmroze",
  fr: "Rouge saumon"
}, {
  hex: "#f0938c",
  code: "030 70 40",
  scope: "Design System Plus",
  de: "Flamingorot",
  en: "Flamingo red",
  nl: "Flamingo rood",
  fr: "Rouge flamant"
}, {
  hex: "#dbc2bf",
  code: "030 80 10",
  scope: "Design System Plus",
  de: "Salzrosa",
  en: "Salt pink",
  nl: "Roze zout",
  fr: "Rose salé"
}, {
  hex: "#ecbbb6",
  code: "030 80 20",
  scope: "Design System Plus",
  de: "Magnolienrosa",
  en: "Magnolia pink",
  nl: "Magnolia roze",
  fr: "Rose magnolia"
}, {
  hex: "#dfd0cb",
  code: "030 85 05",
  scope: "Design System Plus",
  de: "Mandelcreme",
  en: "Almond cream",
  nl: "Amandelcrème",
  fr: "Crème d'amande"
}, {
  hex: "#e5cec9",
  code: "030 85 10",
  scope: "Design System Plus",
  de: "Softeisrosé",
  en: "Soft ice rose",
  nl: "Zacht ijs rosé",
  fr: "Rose soft glacé"
}, {
  hex: "#f6cbc3",
  code: "030 85 20",
  scope: "Design System Plus",
  de: "Pfirsichrot",
  en: "Peach red",
  nl: "Perzikrood",
  fr: "Rouge pêche"
}, {
  hex: "#efe1dc",
  code: "030 90 05",
  scope: "Design System Plus",
  de: "Antikweiß",
  en: "Antique white",
  nl: "Antiek wit",
  fr: "Blanc antique"
}, {
  hex: "#f5dfd9",
  code: "030 90 10",
  scope: "Design System Plus",
  de: "Hochzeitsrosa",
  en: "Wedding pink",
  nl: "Roze bruiloft",
  fr: "Rose de mariage"
}, {
  hex: "#f7e7e3",
  code: "030 93 05",
  scope: "Design System Plus",
  de: "Pergamentweiß",
  en: "Parchment white",
  nl: "Perkament wit",
  fr: "Blanc parchemin"
}, {
  hex: "#5a433f",
  code: "040 20 19",
  scope: "Design System Plus",
  de: "Wildbraun",
  en: "Wild brown",
  nl: "Wildbruin",
  fr: "Marron sauvage"
}, {
  hex: "#5d5552",
  code: "040 30 05",
  scope: "Design System Plus",
  de: "Basaltschwarz",
  en: "Basalt black",
  nl: "Basalt zwart",
  fr: "Noir basalte"
}, {
  hex: "#62524e",
  code: "040 30 10",
  scope: "Design System Plus",
  de: "Kaviarschwarz",
  en: "Caviar black",
  nl: "Kaviaar zwart",
  fr: "Noir caviar"
}, {
  hex: "#6d4e47",
  code: "040 30 20",
  scope: "Design System Plus",
  de: "Kaffeebraun",
  en: "Coffee brown",
  nl: "Koffiebruin",
  fr: "Marron café"
}, {
  hex: "#774b43",
  code: "040 30 30",
  scope: "Design System Plus",
  de: "Wurzelbraun",
  en: "Root brown",
  nl: "Wortel bruin",
  fr: "Marron racine"
}, {
  hex: "#80463e",
  code: "040 30 40",
  scope: "Design System Plus",
  de: "Korrosionsrot",
  en: "Corrosion red",
  nl: "Corrosie rood",
  fr: "Rouge de corrosion"
}, {
  hex: "#726865",
  code: "040 40 05",
  scope: "Design System Plus",
  de: "Aschbraun",
  en: "Ash brown",
  nl: "Asbruin",
  fr: "Marron cendré"
}, {
  hex: "#776560",
  code: "040 40 10",
  scope: "Design System Plus",
  de: "Somalibraun",
  en: "Somali brown",
  nl: "Somalisch bruin",
  fr: "Marron somali"
}, {
  hex: "#84625a",
  code: "040 40 20",
  scope: "Design System Plus",
  de: "Vandyckbraun",
  en: "Vandyck brown",
  nl: "Vandyck bruin",
  fr: "Marron vandyck"
}, {
  hex: "#8d5a4e",
  code: "040 40 30",
  scope: "Design System Plus",
  de: "Maronenbraun",
  en: "Chestnut brown",
  nl: "Kastanjebruin",
  fr: "Brun marron"
}, {
  hex: "#985447",
  code: "040 40 40",
  scope: "Design System Plus",
  de: "Ziegelrot",
  en: "Brick red",
  nl: "Baksteen rood",
  fr: "Rouge brique"
}, {
  hex: "#a35041",
  code: "040 40 50",
  scope: "Design System Plus",
  de: "Hennarot",
  en: "Henna red",
  nl: "Henna rood",
  fr: "Rouge henné"
}, {
  hex: "#aa473b",
  code: "040 40 60",
  scope: "Design System Plus",
  de: "Kupferrot",
  en: "Copper red",
  nl: "Koperrood",
  fr: "Rouge cuivré"
}, {
  hex: "#b24539",
  code: "040 40 67",
  scope: "Design System Plus",
  de: "Chinarot",
  en: "China red",
  nl: "Chinees rood",
  fr: "Chinarot"
}, {
  hex: "#877c79",
  code: "040 50 05",
  scope: "Design System Plus",
  de: "Nomadengrau",
  en: "Nomad grey",
  nl: "Nomad grijs",
  fr: "Gris nomade"
}, {
  hex: "#8e7a74",
  code: "040 50 10",
  scope: "Design System Plus",
  de: "Umbrasand",
  en: "Umbra sand",
  nl: "Umbra zand",
  fr: "Sable d'Ombrage"
}, {
  hex: "#9c746a",
  code: "040 50 20",
  scope: "Design System Plus",
  de: "Achatbraun",
  en: "Agate brown",
  nl: "Agaat bruin",
  fr: "Marron agate"
}, {
  hex: "#aa6f61",
  code: "040 50 30",
  scope: "Design System Plus",
  de: "Rostfarben",
  en: "Rust coloured",
  nl: "Roestkleuren",
  fr: "Couleur rouille"
}, {
  hex: "#b36857",
  code: "040 50 40",
  scope: "Design System Plus",
  de: "Ameisenrot",
  en: "Ant red",
  nl: "Mier rood",
  fr: "Rouge fourmi"
}, {
  hex: "#c0624f",
  code: "040 50 50",
  scope: "Design System Plus",
  de: "Englischrot",
  en: "English red",
  nl: "Engels rood",
  fr: "Rouge anglais"
}, {
  hex: "#ce5e4a",
  code: "040 50 60",
  scope: "Design System Plus",
  de: "Fuchsrot",
  en: "Fox red",
  nl: "Vos rood",
  fr: "Rouge renard"
}, {
  hex: "#d55845",
  code: "040 50 70",
  scope: "Design System Plus",
  de: "Pompejirot",
  en: "Pompeii red",
  nl: "Pompeii rood",
  fr: "Pompejirot"
}, {
  hex: "#9f9491",
  code: "040 60 05",
  scope: "Design System Plus",
  de: "Warmgrau",
  en: "Warm grey",
  nl: "Warm grijs",
  fr: "Gris chaud"
}, {
  hex: "#a8918b",
  code: "040 60 10",
  scope: "Design System Plus",
  de: "Hellkaramell",
  en: "Light caramel",
  nl: "Lichte karamel",
  fr: "Caramel clair"
}, {
  hex: "#b4897e",
  code: "040 60 20",
  scope: "Design System Plus",
  de: "Sienagelblich",
  en: "Sienna yellow",
  nl: "Sienna geel",
  fr: "Siennois"
}, {
  hex: "#c48677",
  code: "040 60 30",
  scope: "Design System Plus",
  de: "Zedernrot",
  en: "Cedar red",
  nl: "Cederrood",
  fr: "Rouge cèdre"
}, {
  hex: "#cf806e",
  code: "040 60 40",
  scope: "Design System Plus",
  de: "Terraorange",
  en: "Terra orange",
  nl: "Terra oranje",
  fr: "Terraorange"
}, {
  hex: "#dc7b64",
  code: "040 60 50",
  scope: "Design System Plus",
  de: "Mandarinorange",
  en: "Mandarin orange",
  nl: "Mandarijn",
  fr: "Orange mandarine"
}, {
  hex: "#e67359",
  code: "040 60 60",
  scope: "Design System Plus",
  de: "Korallenorange",
  en: "Coral orange",
  nl: "Koraaloranje",
  fr: "Orange corail"
}, {
  hex: "#b7aca9",
  code: "040 70 05",
  scope: "Design System Plus",
  de: "Passepartoutgrau",
  en: "Passepartout grey",
  nl: "Passepartout grijs",
  fr: "Gris passe-partout"
}, {
  hex: "#c2a9a3",
  code: "040 70 10",
  scope: "Design System Plus",
  de: "Mohairmauve",
  en: "Mohair mauve",
  nl: "Mohair mauve",
  fr: "Mauve mohair"
}, {
  hex: "#d2a499",
  code: "040 70 20",
  scope: "Design System Plus",
  de: "Sanftsiena",
  en: "Soft sienna",
  nl: "Sanftsiena",
  fr: "Sanftsiena"
}, {
  hex: "#e09d8d",
  code: "040 70 30",
  scope: "Design System Plus",
  de: "Industrierosé",
  en: "Industrial rose",
  nl: "Industriële rosé",
  fr: "Rosé industriel"
}, {
  hex: "#e99885",
  code: "040 70 40",
  scope: "Design System Plus",
  de: "Aprikosenrot",
  en: "Apricot red",
  nl: "Abrikoosrood",
  fr: "Rouge abricot"
}, {
  hex: "#fa9079",
  code: "040 70 50",
  scope: "Design System Plus",
  de: "Fruchtrot",
  en: "Fruit red",
  nl: "Vrucht rood",
  fr: "Rouge fruit"
}, {
  hex: "#d4c7c3",
  code: "040 80 05",
  scope: "Design System Plus",
  de: "Naturseidegrau",
  en: "Natural silk grey",
  nl: "Natuurlijke zijde grijs",
  fr: "Gris soie naturelle"
}, {
  hex: "#dec4bc",
  code: "040 80 10",
  scope: "Design System Plus",
  de: "Thulitrosé",
  en: "Thulite rose",
  nl: "Thulitrosé",
  fr: "Thulitrosé"
}, {
  hex: "#f1c1b4",
  code: "040 80 20",
  scope: "Design System Plus",
  de: "Krapporange",
  en: "Madder orange",
  nl: "Meekrap oranje",
  fr: "Orange crapaud"
}, {
  hex: "#febaa9",
  code: "040 80 30",
  scope: "Design System Plus",
  de: "Naturapricot",
  en: "Nature apricot",
  nl: "Natuurlijk abrikoos",
  fr: "Apricot naturel"
}, {
  hex: "#e1d2ce",
  code: "040 85 05",
  scope: "Design System Plus",
  de: "Pandoragrau",
  en: "Pandora grey",
  nl: "Pandora grijs",
  fr: "Gris pandora"
}, {
  hex: "#ead2ca",
  code: "040 85 10",
  scope: "Design System Plus",
  de: "Feinalabaster",
  en: "Fine alabaster",
  nl: "Fijn albast",
  fr: "Albâtre fin"
}, {
  hex: "#faccbd",
  code: "040 85 20",
  scope: "Design System Plus",
  de: "Zartsüßapricot",
  en: "Delicate sweet apricot",
  nl: "Verfijnd zoete abrikoos",
  fr: "Aricot doux"
}, {
  hex: "#f1e2dc",
  code: "040 90 05",
  scope: "Design System Plus",
  de: "Saharalichtrot",
  en: "Sahara light red",
  nl: "Sahara lichtrood",
  fr: "Rouge lumière saharienne"
}, {
  hex: "#f7e0d7",
  code: "040 90 10",
  scope: "Design System Plus",
  de: "Zartrosé",
  en: "Delicate rose",
  nl: "Lichtroze",
  fr: "Rose tendre"
}, {
  hex: "#f9eae4",
  code: "040 93 05",
  scope: "Design System Plus",
  de: "Naturweiß",
  en: "Natural white",
  nl: "Natuurlijk wit",
  fr: "Blanc naturel"
}, {
  hex: "#504541",
  code: "050 20 10",
  scope: "Design System Plus",
  de: "Granitbraun",
  en: "Granite brown",
  nl: "Granietbruin",
  fr: "Brun granite"
}, {
  hex: "#56443e",
  code: "050 20 16",
  scope: "Design System Plus",
  de: "Nachtbraun",
  en: "Night brown",
  nl: "Nacht bruin",
  fr: "Marron nuit"
}, {
  hex: "#5f504a",
  code: "050 30 10",
  scope: "Design System Plus",
  de: "Obsidianbraun",
  en: "Obsidian brown",
  nl: "Obsidiaanbruin",
  fr: "Marron obsidienne"
}, {
  hex: "#6a4f44",
  code: "050 30 20",
  scope: "Design System Plus",
  de: "Tropenholzbraun",
  en: "Tropical wood brown",
  nl: "Tropisch hout bruin",
  fr: "Marron bois tropical"
}, {
  hex: "#744c3e",
  code: "050 30 30",
  scope: "Design System Plus",
  de: "Tabakbraun",
  en: "Tobacco brown",
  nl: "Tabakbruin",
  fr: "Marron tabac"
}, {
  hex: "#7a4b3c",
  code: "050 30 36",
  scope: "Design System Plus",
  de: "Palisanderbraun",
  en: "Rosewood brown",
  nl: "Rozenhout bruin",
  fr: "Marron palissandre"
}, {
  hex: "#76645d",
  code: "050 40 10",
  scope: "Design System Plus",
  de: "Mokkaschwarz",
  en: "Mocha black",
  nl: "Mokka zwart",
  fr: "Noir moka"
}, {
  hex: "#806153",
  code: "050 40 20",
  scope: "Design System Plus",
  de: "Florentinerbraun",
  en: "Florentine brown",
  nl: "Florentijns bruin",
  fr: "Marron florentin"
}, {
  hex: "#895e4d",
  code: "050 40 30",
  scope: "Design System Plus",
  de: "Currybraun",
  en: "Curry brown",
  nl: "Kerrie bruin",
  fr: "Marron curry"
}, {
  hex: "#945943",
  code: "050 40 40",
  scope: "Design System Plus",
  de: "Madeirabraun",
  en: "Madeira brown",
  nl: "Madeira bruin",
  fr: "Marron de Madère"
}, {
  hex: "#9d5640",
  code: "050 40 50",
  scope: "Design System Plus",
  de: "Herbstrot",
  en: "Autumn red",
  nl: "Herfstrood",
  fr: "Rouge d'automne"
}, {
  hex: "#8d7b73",
  code: "050 50 10",
  scope: "Design System Plus",
  de: "Teakholzbraun",
  en: "Teakwood brown",
  nl: "Teak bruin",
  fr: "Marron teck"
}, {
  hex: "#997767",
  code: "050 50 20",
  scope: "Design System Plus",
  de: "Milchkaffeebraun",
  en: "Milk coffee brown",
  nl: "Melk koffie bruin",
  fr: "Marron café au lait"
}, {
  hex: "#a5725c",
  code: "050 50 30",
  scope: "Design System Plus",
  de: "Goldbraun",
  en: "Golden brown",
  nl: "Goudbruin",
  fr: "Marron doré"
}, {
  hex: "#ae6c50",
  code: "050 50 40",
  scope: "Design System Plus",
  de: "Kupfermetallrot",
  en: "Copper-metal red",
  nl: "Koperen metaal rood",
  fr: "Rouge cuivre métallique"
}, {
  hex: "#b96746",
  code: "050 50 50",
  scope: "Design System Plus",
  de: "Goldlackbraun",
  en: "Gold varnish brown",
  nl: "Goudlak bruin",
  fr: "Marron laqué or"
}, {
  hex: "#bd623d",
  code: "050 50 60",
  scope: "Design System Plus",
  de: "Tizianrot",
  en: "Titian red",
  nl: "Titiaan rood",
  fr: "Rouge tiziane"
}, {
  hex: "#cc5c36",
  code: "050 50 70",
  scope: "Design System Plus",
  de: "Mohnrot",
  en: "Poppy red",
  nl: "Klaproos rood",
  fr: "Rouge coquelicot"
}, {
  hex: "#d16032",
  code: "050 50 78",
  scope: "Design System Plus",
  de: "Persischorange",
  en: "Persian orange",
  nl: "Perzische sinaasappel",
  fr: "Orange persane"
}, {
  hex: "#a59188",
  code: "050 60 10",
  scope: "Design System Plus",
  de: "Ecruocker",
  en: "Ecru ochre",
  nl: "Ecruocker",
  fr: "Ecruocker"
}, {
  hex: "#b18c7b",
  code: "050 60 20",
  scope: "Design System Plus",
  de: "Karamellbraun",
  en: "Caramel brown",
  nl: "Karamelbruin",
  fr: "Marron caramel"
}, {
  hex: "#c28971",
  code: "050 60 30",
  scope: "Design System Plus",
  de: "Mittelbraun",
  en: "Medium brown",
  nl: "Medium bruin",
  fr: "Marron moyen"
}, {
  hex: "#c98365",
  code: "050 60 40",
  scope: "Design System Plus",
  de: "Apricotbraun",
  en: "Apricot brown",
  nl: "Abrikoosbruin",
  fr: "Marron abricot"
}, {
  hex: "#d67f59",
  code: "050 60 50",
  scope: "Design System Plus",
  de: "Orangegelb",
  en: "Orange yellow",
  nl: "Oranje geel",
  fr: "Jaune orangé"
}, {
  hex: "#e17b4e",
  code: "050 60 60",
  scope: "Design System Plus",
  de: "Kamelrot",
  en: "Camel red",
  nl: "Kameelrood",
  fr: "Rouge chameau"
}, {
  hex: "#e67045",
  code: "050 60 70",
  scope: "Design System Plus",
  de: "Karottenorange",
  en: "Carrot orange",
  nl: "Wortel oranje",
  fr: "Orange carotte"
}, {
  hex: "#f26d3f",
  code: "050 60 80",
  scope: "Design System Plus",
  de: "Gerberarot",
  en: "Gerbera red",
  nl: "Tanner rood",
  fr: "Rouge de Gerber"
}, {
  hex: "#c0aca2",
  code: "050 70 10",
  scope: "Design System Plus",
  de: "Bambusbeige",
  en: "Bamboo beige",
  nl: "Bamboe beige",
  fr: "Beige bambou"
}, {
  hex: "#cea796",
  code: "050 70 20",
  scope: "Design System Plus",
  de: "Bernsteingrau",
  en: "Amber grey",
  nl: "Ambergrijs",
  fr: "Gris ambré"
}, {
  hex: "#dba188",
  code: "050 70 30",
  scope: "Design System Plus",
  de: "Sienaocker",
  en: "Sienna ochre",
  nl: "Siena oker",
  fr: "Tabouret de Sienne"
}, {
  hex: "#e99b7b",
  code: "050 70 40",
  scope: "Design System Plus",
  de: "Amberhellorange",
  en: "Light amber orange",
  nl: "Amber lichtoranje",
  fr: "Orange clair ambré"
}, {
  hex: "#f39670",
  code: "050 70 50",
  scope: "Design System Plus",
  de: "Melonenrot",
  en: "Melon red",
  nl: "Meloenrood",
  fr: "Rouge melon"
}, {
  hex: "#fe9063",
  code: "050 70 60",
  scope: "Design System Plus",
  de: "Mangoorange",
  en: "Mango orange",
  nl: "Mangosinaasappel",
  fr: "Orange mangue"
}, {
  hex: "#dbc5bb",
  code: "050 80 10",
  scope: "Design System Plus",
  de: "Blasssiena",
  en: "Pale sienna",
  nl: "Bleke sienna",
  fr: "Blasssiena"
}, {
  hex: "#e9bfac",
  code: "050 80 20",
  scope: "Design System Plus",
  de: "Sanftorange",
  en: "Soft orange",
  nl: "Zacht oranje",
  fr: "Orange douce"
}, {
  hex: "#f6b99f",
  code: "050 80 30",
  scope: "Design System Plus",
  de: "Fahlorange",
  en: "Pallid orange",
  nl: "Lichtoranje",
  fr: "Orange pâle"
}, {
  hex: "#e2d3cc",
  code: "050 85 05",
  scope: "Design System Plus",
  de: "Meersand",
  en: "Ocean sand",
  nl: "Zeezand",
  fr: "Sable de mer"
}, {
  hex: "#e6cfc3",
  code: "050 85 10",
  scope: "Design System Plus",
  de: "Reinbeige",
  en: "Pure beige",
  nl: "Puur beige",
  fr: "Beige pur"
}, {
  hex: "#f6cbb7",
  code: "050 85 20",
  scope: "Design System Plus",
  de: "Biscuitcreme",
  en: "Biscuit cream",
  nl: "Koekjescrème",
  fr: "Crème de biscuit"
}, {
  hex: "#ede0d8",
  code: "050 90 05",
  scope: "Design System Plus",
  de: "Eierschalenweiß",
  en: "Eggshell white",
  nl: "Eischaal wit",
  fr: "Blanc coquille d'œuf"
}, {
  hex: "#fbe2d6",
  code: "050 90 10",
  scope: "Design System Plus",
  de: "Hellpfirsichrosé",
  en: "Light peach rose",
  nl: "Lichte perzikrosé",
  fr: "Rose pêche clair"
}, {
  hex: "#f9ebe4",
  code: "050 93 05",
  scope: "Design System Plus",
  de: "Tüllweiß",
  en: "Tulle white",
  nl: "Tule wit",
  fr: "Tulle blanc"
}, {
  hex: "#4a4643",
  code: "060 20 05",
  scope: "Design System Plus",
  de: "Industrieschwarz",
  en: "Industrial black",
  nl: "Industrieel zwart",
  fr: "Noir industriel"
}, {
  hex: "#5c5551",
  code: "060 30 05",
  scope: "Design System Plus",
  de: "Karosseriegrau",
  en: "Vehicle body grey",
  nl: "Lichaam grijs",
  fr: "Gris carrosserie"
}, {
  hex: "#60534b",
  code: "060 30 10",
  scope: "Design System Plus",
  de: "Nutriafellbraun",
  en: "Nutria fur brown",
  nl: "Nutria bont bruin",
  fr: "Marron nutraceutique"
}, {
  hex: "#665042",
  code: "060 30 20",
  scope: "Design System Plus",
  de: "Torfbraun",
  en: "Peat brown",
  nl: "Turfbruin",
  fr: "Marron tourbe"
}, {
  hex: "#6f5141",
  code: "060 30 27",
  scope: "Design System Plus",
  de: "Zinnsteinbraun",
  en: "Cassiterite brown",
  nl: "Tinnen bruin",
  fr: "Brun ambré"
}, {
  hex: "#716863",
  code: "060 40 05",
  scope: "Design System Plus",
  de: "Zinkgrau",
  en: "Zinc grey",
  nl: "Zinkgrijs",
  fr: "Gris zinc"
}, {
  hex: "#75655c",
  code: "060 40 10",
  scope: "Design System Plus",
  de: "Mooreichengrau",
  en: "Moor oak grey",
  nl: "Eiken moeras grijs",
  fr: "Gris chêne des marais"
}, {
  hex: "#7f6351",
  code: "060 40 20",
  scope: "Design System Plus",
  de: "Kaffeebohnenbraun",
  en: "Coffee bean brown",
  nl: "Koffieboon bruin",
  fr: "Marron grain de café"
}, {
  hex: "#876048",
  code: "060 40 30",
  scope: "Design System Plus",
  de: "Brasilbraun",
  en: "Brazilian brown",
  nl: "Braziliaans bruin",
  fr: "Marron brésilien"
}, {
  hex: "#915f41",
  code: "060 40 40",
  scope: "Design System Plus",
  de: "Platanenbraun",
  en: "Plane brown",
  nl: "Plataan bruin",
  fr: "Marron platane"
}, {
  hex: "#877d77",
  code: "060 50 05",
  scope: "Design System Plus",
  de: "Chinchillagrau",
  en: "Chinchilla grey",
  nl: "Chinchilla grijs",
  fr: "Gris chinchilla"
}, {
  hex: "#8c7c71",
  code: "060 50 10",
  scope: "Design System Plus",
  de: "Sandsteingrau",
  en: "Sandstone grey",
  nl: "Zandsteengrijs",
  fr: "Gris grès"
}, {
  hex: "#967965",
  code: "060 50 20",
  scope: "Design System Plus",
  de: "Champignonbraun",
  en: "Mushroom brown",
  nl: "Paddenstoel bruin",
  fr: "Marron champignon"
}, {
  hex: "#a2775a",
  code: "060 50 30",
  scope: "Design System Plus",
  de: "Senfbraun",
  en: "Mustard brown",
  nl: "Mosterdbruin",
  fr: "Marron moutarde"
}, {
  hex: "#aa714d",
  code: "060 50 40",
  scope: "Design System Plus",
  de: "Kamelbraun",
  en: "Camel brown",
  nl: "Camelbruin",
  fr: "Brun chameau"
}, {
  hex: "#b37045",
  code: "060 50 50",
  scope: "Design System Plus",
  de: "Dattelfruchtbraun",
  en: "Date fruit brown",
  nl: "Dadelvrucht bruin",
  fr: "Marron fruit de la datte"
}, {
  hex: "#b66838",
  code: "060 50 60",
  scope: "Design System Plus",
  de: "Rüsterbraunrot",
  en: "Elm brown red",
  nl: "Iep bruin rood",
  fr: "Rouge brun d'orme"
}, {
  hex: "#c16933",
  code: "060 50 70",
  scope: "Design System Plus",
  de: "Trockenlehm",
  en: "Dry clay",
  nl: "Droge klei",
  fr: "Argile sèche"
}, {
  hex: "#a09790",
  code: "060 60 05",
  scope: "Design System Plus",
  de: "Estrichgrau",
  en: "Screed grey",
  nl: "Screed grijs",
  fr: "Gris chape"
}, {
  hex: "#a59387",
  code: "060 60 10",
  scope: "Design System Plus",
  de: "Eichenbraun",
  en: "Oak brown",
  nl: "Eiken bruin",
  fr: "Chêne brun"
}, {
  hex: "#b4907b",
  code: "060 60 20",
  scope: "Design System Plus",
  de: "Topashellocker",
  en: "Light topaz ochre",
  nl: "Topashellocker",
  fr: "Topashellocker"
}, {
  hex: "#bc8d6d",
  code: "060 60 30",
  scope: "Design System Plus",
  de: "Cognacbraun",
  en: "Cognac brown",
  nl: "Cognacbruin",
  fr: "Marron cognac"
}, {
  hex: "#cb8c5e",
  code: "060 60 40",
  scope: "Design System Plus",
  de: "Ahornsirupbraun",
  en: "Maple syrup brown",
  nl: "Ahornsiroop bruin",
  fr: "Brun sirop d'érable"
}, {
  hex: "#cc814e",
  code: "060 60 50",
  scope: "Design System Plus",
  de: "Kurkumarot",
  en: "Turmeric red",
  nl: "Kurkuma rood",
  fr: "Rouge de curcuma"
}, {
  hex: "#d77f43",
  code: "060 60 60",
  scope: "Design System Plus",
  de: "Bitterorange",
  en: "Bitter orange",
  nl: "Bittere sinaasappel",
  fr: "Orange amère"
}, {
  hex: "#dc7c37",
  code: "060 60 70",
  scope: "Design System Plus",
  de: "Goldorange",
  en: "Gold orange",
  nl: "Goudoranje",
  fr: "Orange doré"
}, {
  hex: "#e6752a",
  code: "060 60 80",
  scope: "Design System Plus",
  de: "Akzentorange",
  en: "Accent orange",
  nl: "Accent oranje",
  fr: "Orange d'accent"
}, {
  hex: "#b9afa9",
  code: "060 70 05",
  scope: "Design System Plus",
  de: "Zementgreige",
  en: "Cement greige",
  nl: "Cementdeeg",
  fr: "Pâte à ciment"
}, {
  hex: "#c0ada1",
  code: "060 70 10",
  scope: "Design System Plus",
  de: "Kittgrau",
  en: "Putty grey",
  nl: "Putty grijs",
  fr: "Gris mastic"
}, {
  hex: "#cba891",
  code: "060 70 20",
  scope: "Design System Plus",
  de: "Erdnusscreme",
  en: "Peanut butter",
  nl: "Pindacrème",
  fr: "Crème de cacahuètes"
}, {
  hex: "#d3a281",
  code: "060 70 30",
  scope: "Design System Plus",
  de: "Pfirsichgelb",
  en: "Peach yellow",
  nl: "Perzikgeel",
  fr: "Jaune pêche"
}, {
  hex: "#e1a074",
  code: "060 70 40",
  scope: "Design System Plus",
  de: "Kerzengelb",
  en: "Candle yellow",
  nl: "Kaars geel",
  fr: "Jaune bougie"
}, {
  hex: "#eb9c67",
  code: "060 70 50",
  scope: "Design System Plus",
  de: "Topasgelb",
  en: "Topaz yellow",
  nl: "Topaas geel",
  fr: "Jaune topaze"
}, {
  hex: "#f19758",
  code: "060 70 60",
  scope: "Design System Plus",
  de: "Melonenorange",
  en: "Melon orange",
  nl: "Meloen oranje",
  fr: "Orange melon"
}, {
  hex: "#fc9348",
  code: "060 70 70",
  scope: "Design System Plus",
  de: "Indischgelb",
  en: "Indian yellow",
  nl: "Indiaas geel",
  fr: "Jaune indien"
}, {
  hex: "#d3c9c1",
  code: "060 80 05",
  scope: "Design System Plus",
  de: "Chamoishellbeige",
  en: "Light chamois beige",
  nl: "Zeem licht beige",
  fr: "Beige clair chamois"
}, {
  hex: "#d8c6b9",
  code: "060 80 10",
  scope: "Design System Plus",
  de: "Sanftgreige",
  en: "Soft greige",
  nl: "Zacht grijs",
  fr: "Grains doux"
}, {
  hex: "#e7c2aa",
  code: "060 80 20",
  scope: "Design System Plus",
  de: "Keksbeige",
  en: "Biscuit beige",
  nl: "Koekjesbeige",
  fr: "Beige biscuit"
}, {
  hex: "#f4be9a",
  code: "060 80 30",
  scope: "Design System Plus",
  de: "Mildorange",
  en: "Mild orange",
  nl: "Mild oranje",
  fr: "Orange douce"
}, {
  hex: "#fdb889",
  code: "060 80 40",
  scope: "Design System Plus",
  de: "Apricotorange",
  en: "Apricot orange",
  nl: "Abrikoos sinaasappel",
  fr: "Orange abricot"
}, {
  hex: "#e0d4cc",
  code: "060 85 05",
  scope: "Design System Plus",
  de: "Champagnerrosé",
  en: "Champagne rose",
  nl: "Champagne rosé",
  fr: "Rose champagne"
}, {
  hex: "#e8d3c5",
  code: "060 85 10",
  scope: "Design System Plus",
  de: "Maismehlbeige",
  en: "Cornmeal beige",
  nl: "Korenbloem beige",
  fr: "Beige de farine de maïs"
}, {
  hex: "#f3cfb6",
  code: "060 85 20",
  scope: "Design System Plus",
  de: "Teiggelb",
  en: "Dough yellow",
  nl: "Deeg geel",
  fr: "Jaune de pâte"
}, {
  hex: "#ffcca5",
  code: "060 85 30",
  scope: "Design System Plus",
  de: "Safranhellorange",
  en: "Light saffron orange",
  nl: "Saffraan licht oranje",
  fr: "Orange safran clair"
}, {
  hex: "#efe3d9",
  code: "060 90 05",
  scope: "Design System Plus",
  de: "Kornweiß",
  en: "Grain white",
  nl: "Korrel wit",
  fr: "Blanc grain"
}, {
  hex: "#f7e0d2",
  code: "060 90 10",
  scope: "Design System Plus",
  de: "Vanillecreme",
  en: "Vanilla cream",
  nl: "Vanillecrème",
  fr: "Crème à la vanille"
}, {
  hex: "#fcdcc9",
  code: "060 90 15",
  scope: "Design System Plus",
  de: "Aprikosencreme",
  en: "Apricot cream",
  nl: "Abrikozencrème",
  fr: "Crème à l'abricot"
}, {
  hex: "#f7ebe2",
  code: "060 93 05",
  scope: "Design System Plus",
  de: "Wollweiß",
  en: "Wool white",
  nl: "Wol wit",
  fr: "Blanc laine"
}, {
  hex: "#5c5148",
  code: "070 30 10",
  scope: "Design System Plus",
  de: "Mineralbraun",
  en: "Mineral brown",
  nl: "Mineraal bruin",
  fr: "Marron minéral"
}, {
  hex: "#655444",
  code: "070 30 20",
  scope: "Design System Plus",
  de: "Buchenbraun",
  en: "Beech brown",
  nl: "Beukenbruin",
  fr: "Brun hêtre"
}, {
  hex: "#71655a",
  code: "070 40 10",
  scope: "Design System Plus",
  de: "Nerzfellbraun",
  en: "Mink brown",
  nl: "Nertsbont bruin",
  fr: "Brun en peau de vison"
}, {
  hex: "#7a634e",
  code: "070 40 20",
  scope: "Design System Plus",
  de: "Elsbeerenbraun",
  en: "Huckleberry brown",
  nl: "Wilde dienstboom bruin",
  fr: "Brun d'alisier"
}, {
  hex: "#826448",
  code: "070 40 30",
  scope: "Design System Plus",
  de: "Ackerbraun",
  en: "Arable brown",
  nl: "Veld bruin",
  fr: "Marron des champs"
}, {
  hex: "#88613d",
  code: "070 40 40",
  scope: "Design System Plus",
  de: "Herbstgold",
  en: "Autumn gold",
  nl: "Herfst goud",
  fr: "Or d'automne"
}, {
  hex: "#887b6e",
  code: "070 50 10",
  scope: "Design System Plus",
  de: "Sarukgrau",
  en: "Saruk grey",
  nl: "Saruk grijs",
  fr: "Gris sarouk"
}, {
  hex: "#927961",
  code: "070 50 20",
  scope: "Design System Plus",
  de: "Aschgold",
  en: "Ash gold",
  nl: "Asgoud",
  fr: "Or cendré"
}, {
  hex: "#997552",
  code: "070 50 30",
  scope: "Design System Plus",
  de: "Löwenmähnenblond",
  en: "Lion's mane blonde",
  nl: "Leeuwenmanen blond",
  fr: "Blond crinière de lion"
}, {
  hex: "#a17344",
  code: "070 50 40",
  scope: "Design System Plus",
  de: "Altgold",
  en: "Antique gold",
  nl: "Oud goud",
  fr: "Vieil or"
}, {
  hex: "#a2723d",
  code: "070 50 50",
  scope: "Design System Plus",
  de: "Bühnengold",
  en: "Stage gold",
  nl: "Podium goud",
  fr: "Or de scène"
}, {
  hex: "#aa7034",
  code: "070 50 55",
  scope: "Design System Plus",
  de: "Theatergold",
  en: "Theatre gold",
  nl: "Theater goud",
  fr: "L'or du théâtre"
}, {
  hex: "#a19285",
  code: "070 60 10",
  scope: "Design System Plus",
  de: "Hellmahagoni",
  en: "Light mahogany",
  nl: "Licht mahonie",
  fr: "Acajou clair"
}, {
  hex: "#ab9178",
  code: "070 60 20",
  scope: "Design System Plus",
  de: "Dunkelblond",
  en: "Dark blond",
  nl: "Donkerblond",
  fr: "Blond foncé"
}, {
  hex: "#b38c67",
  code: "070 60 30",
  scope: "Design System Plus",
  de: "Eichenhellbraun",
  en: "Light oak brown",
  nl: "Licht eikenbruin",
  fr: "Chêne brun clair"
}, {
  hex: "#bb8b58",
  code: "070 60 40",
  scope: "Design System Plus",
  de: "Kornbraun",
  en: "Grain brown",
  nl: "Korrel bruin",
  fr: "Marron grain"
}, {
  hex: "#c48949",
  code: "070 60 50",
  scope: "Design System Plus",
  de: "Schlammgelb",
  en: "Mud yellow",
  nl: "Moddergeel",
  fr: "Jaune boue"
}, {
  hex: "#cc863b",
  code: "070 60 60",
  scope: "Design System Plus",
  de: "Senfgelb",
  en: "Mustard yellow",
  nl: "Mosterdgeel",
  fr: "Jaune moutarde"
}, {
  hex: "#cf8432",
  code: "070 60 70",
  scope: "Design System Plus",
  de: "Sanddorngelbbraun",
  en: "Sea buckthorn yellow brown",
  nl: "Duindoorn geelbruin",
  fr: "Brun jaune d'argousier"
}, {
  hex: "#d1812a",
  code: "070 60 75",
  scope: "Design System Plus",
  de: "Herbstlauborange",
  en: "Autumn leaf orange",
  nl: "Herfstblad oranje",
  fr: "Orange feuille d'automne"
}, {
  hex: "#baac9d",
  code: "070 70 10",
  scope: "Design System Plus",
  de: "Ingwergraugelb",
  en: "Ginger grey yellow",
  nl: "Gembergrijs geel",
  fr: "Jaune gingembre"
}, {
  hex: "#c5a98d",
  code: "070 70 20",
  scope: "Design System Plus",
  de: "Eschehellbraun",
  en: "Light ash brown",
  nl: "As lichtbruin",
  fr: "Frêne brun clair"
}, {
  hex: "#d0a77e",
  code: "070 70 30",
  scope: "Design System Plus",
  de: "Goldbeige",
  en: "Golden beige",
  nl: "Goudbeige",
  fr: "Beige doré"
}, {
  hex: "#d19f6a",
  code: "070 70 40",
  scope: "Design System Plus",
  de: "Dechantsbirnengelb",
  en: "Dechant pear yellow",
  nl: "Dean's peer geel",
  fr: "Jaune poire de Dechants"
}, {
  hex: "#dfa15f",
  code: "070 70 50",
  scope: "Design System Plus",
  de: "Honigwabengelb",
  en: "Honeycomb yellow",
  nl: "Honingraat geel",
  fr: "Jaune nid d'abeille"
}, {
  hex: "#e9a04f",
  code: "070 70 60",
  scope: "Design System Plus",
  de: "Ginstergelborange",
  en: "Gorse yellow orange",
  nl: "Bezem geel oranje",
  fr: "Jaune genêt orange"
}, {
  hex: "#eb9a3f",
  code: "070 70 70",
  scope: "Design System Plus",
  de: "Neapelgelb",
  en: "Naples yellow",
  nl: "Napels geel",
  fr: "Jaune de Naples"
}, {
  hex: "#f09630",
  code: "070 70 80",
  scope: "Design System Plus",
  de: "Safrangold",
  en: "Saffron gold",
  nl: "Saffraan goud",
  fr: "Or safrané"
}, {
  hex: "#d5c5b6",
  code: "070 80 10",
  scope: "Design System Plus",
  de: "Flachsbeige",
  en: "Flax beige",
  nl: "Vlassig beige",
  fr: "Beige plat"
}, {
  hex: "#e4c5a8",
  code: "070 80 20",
  scope: "Design System Plus",
  de: "Butterblumengelb",
  en: "Buttercup yellow",
  nl: "Boterbloem geel",
  fr: "Jaune bouton d'or"
}, {
  hex: "#ecc196",
  code: "070 80 30",
  scope: "Design System Plus",
  de: "Goldhaferfarben",
  en: "Golden oat coloured",
  nl: "Goudkleurige haver",
  fr: "Couleur avoine dorée"
}, {
  hex: "#f6c088",
  code: "070 80 40",
  scope: "Design System Plus",
  de: "Aprikosengelb",
  en: "Apricot yellow",
  nl: "Abrikoosgeel",
  fr: "Jaune abricot"
}, {
  hex: "#febc75",
  code: "070 80 50",
  scope: "Design System Plus",
  de: "Warmapricot",
  en: "Warm apricot",
  nl: "Warmeprik",
  fr: "Warmapricot"
}, {
  hex: "#ffba65",
  code: "070 80 60",
  scope: "Design System Plus",
  de: "Goldregengelb",
  en: "Golden rain yellow",
  nl: "Gouden regen geel",
  fr: "Jaune pluie d'or"
}, {
  hex: "#ded4ca",
  code: "070 85 05",
  scope: "Design System Plus",
  de: "Mandelkernbeige",
  en: "Almond beige",
  nl: "Amandelkern beige",
  fr: "Beige cœur d'amande"
}, {
  hex: "#e5d3c5",
  code: "070 85 10",
  scope: "Design System Plus",
  de: "Silberdistelbeige",
  en: "Silver thistle beige",
  nl: "Zilveren distel beige",
  fr: "Beige chardon argenté"
}, {
  hex: "#efd0b2",
  code: "070 85 20",
  scope: "Design System Plus",
  de: "Sandelholzbeige",
  en: "Sandalwood beige",
  nl: "Sandelhout beige",
  fr: "Beige santal"
}, {
  hex: "#facfa2",
  code: "070 85 30",
  scope: "Design System Plus",
  de: "Haarblond",
  en: "Hair blonde",
  nl: "Haar blond",
  fr: "Blond des cheveux"
}, {
  hex: "#ede3da",
  code: "070 90 05",
  scope: "Design System Plus",
  de: "Offwhite",
  en: "Off white",
  nl: "Offwhite",
  fr: "Blanc cassé"
}, {
  hex: "#f3e2d2",
  code: "070 90 10",
  scope: "Design System Plus",
  de: "Hellmais",
  en: "Light corn",
  nl: "Hellmais",
  fr: "Hellmais"
}, {
  hex: "#fedec0",
  code: "070 90 20",
  scope: "Design System Plus",
  de: "Kreidegelb",
  en: "Chalk yellow",
  nl: "Krijt geel",
  fr: "Jaune craie"
}, {
  hex: "#f7ece2",
  code: "070 93 05",
  scope: "Design System Plus",
  de: "Anemonenweiß",
  en: "Anemone white",
  nl: "Anemoon wit",
  fr: "Blanc anémone"
}, {
  hex: "#71685d",
  code: "075 40 10",
  scope: "Design System Plus",
  de: "Baumrindenbraun",
  en: "Tree bark brown",
  nl: "Boomschors bruin",
  fr: "Brun écorce d'arbre"
}, {
  hex: "#786551",
  code: "075 40 20",
  scope: "Design System Plus",
  de: "Kümmelfruchtbraun",
  en: "Caraway brown",
  nl: "Karwijvruchten bruin",
  fr: "Marron fruit de carvi"
}, {
  hex: "#7d6346",
  code: "075 40 30",
  scope: "Design System Plus",
  de: "Borkenbraun",
  en: "Bark brown",
  nl: "Schors bruin",
  fr: "Marron bordeaux"
}, {
  hex: "#81633e",
  code: "075 40 38",
  scope: "Design System Plus",
  de: "Eidechsenbraun",
  en: "Lizard brown",
  nl: "Hagedis bruin",
  fr: "Marron lézard"
}, {
  hex: "#887d71",
  code: "075 50 10",
  scope: "Design System Plus",
  de: "Roggenteigbraun",
  en: "Rye dough brown",
  nl: "Rogge deeg bruin",
  fr: "Marron pâte de seigle"
}, {
  hex: "#907a62",
  code: "075 50 20",
  scope: "Design System Plus",
  de: "Chinazimt",
  en: "China cinnamon",
  nl: "Chinese kaneel",
  fr: "Cannelle de Chine"
}, {
  hex: "#987954",
  code: "075 50 30",
  scope: "Design System Plus",
  de: "Chamottegelb",
  en: "Grog yellow",
  nl: "Chamotte geel",
  fr: "Jaune chamotte"
}, {
  hex: "#9e7749",
  code: "075 50 40",
  scope: "Design System Plus",
  de: "Bernsteinbraun",
  en: "Amber brown",
  nl: "Amberbruin",
  fr: "Marron ambré"
}, {
  hex: "#a3753c",
  code: "075 50 50",
  scope: "Design System Plus",
  de: "Zimtbraun",
  en: "Cinnamon brown",
  nl: "Kaneelbruin",
  fr: "Marron cannelle"
}, {
  hex: "#a47232",
  code: "075 50 58",
  scope: "Design System Plus",
  de: "Kreuzkümmelocker",
  en: "Cumin ochre",
  nl: "Komijn oker",
  fr: "Gingembre au cumin"
}, {
  hex: "#a29487",
  code: "075 60 10",
  scope: "Design System Plus",
  de: "Kittgelb",
  en: "Putty yellow",
  nl: "Putty geel",
  fr: "Jaune mastic"
}, {
  hex: "#aa9278",
  code: "075 60 20",
  scope: "Design System Plus",
  de: "Walnussschalenbraun",
  en: "Walnut shell brown",
  nl: "Walnoot schelp bruin",
  fr: "Brun écorce de noix"
}, {
  hex: "#b29069",
  code: "075 60 30",
  scope: "Design System Plus",
  de: "Lehmocker",
  en: "Clay ochre",
  nl: "Kleikrukje",
  fr: "Lehmocker"
}, {
  hex: "#b98e5a",
  code: "075 60 40",
  scope: "Design System Plus",
  de: "Funchalgelb",
  en: "Funchal yellow",
  nl: "Funchal geel",
  fr: "Jaune Funchal"
}, {
  hex: "#be8c49",
  code: "075 60 50",
  scope: "Design System Plus",
  de: "Mangobraun",
  en: "Mango brown",
  nl: "Mangobruin",
  fr: "Marron mangue"
}, {
  hex: "#c3893a",
  code: "075 60 60",
  scope: "Design System Plus",
  de: "Kurkumabraun",
  en: "Turmeric brown",
  nl: "Kurkuma bruin",
  fr: "Marron curcuma"
}, {
  hex: "#ca872a",
  code: "075 60 70",
  scope: "Design System Plus",
  de: "Bambusbraun",
  en: "Bamboo brown",
  nl: "Bamboe bruin",
  fr: "Marron bambou"
}, {
  hex: "#baad9f",
  code: "075 70 10",
  scope: "Design System Plus",
  de: "Flachsfasergrau",
  en: "Flax fibre grey",
  nl: "Vlasvezel grijs",
  fr: "Gris fibre de lin"
}, {
  hex: "#c4aa8c",
  code: "075 70 20",
  scope: "Design System Plus",
  de: "Kürbishellbraun",
  en: "Light pumpkin brown",
  nl: "Pompoen lichtbruin",
  fr: "Marron clair citrouille"
}, {
  hex: "#cca87e",
  code: "075 70 30",
  scope: "Design System Plus",
  de: "Golddistelgelb",
  en: "Golden thistle yellow",
  nl: "Gouden distel geel",
  fr: "Jaune chardon doré"
}, {
  hex: "#d3a56c",
  code: "075 70 40",
  scope: "Design System Plus",
  de: "Backsteingelb",
  en: "Brick yellow",
  nl: "Baksteen geel",
  fr: "Jaune brique"
}, {
  hex: "#daa45e",
  code: "075 70 50",
  scope: "Design System Plus",
  de: "Bambustiefgelb",
  en: "Deep bamboo yellow",
  nl: "Bamboe diepgeel",
  fr: "Jaune profond de bambou"
}, {
  hex: "#e2a14b",
  code: "075 70 60",
  scope: "Design System Plus",
  de: "Intensivgelb",
  en: "Intense yellow",
  nl: "Intens geel",
  fr: "Jaune intense"
}, {
  hex: "#eaa139",
  code: "075 70 70",
  scope: "Design System Plus",
  de: "Kürbisgelb",
  en: "Pumpkin yellow",
  nl: "Pompoen geel",
  fr: "Jaune citrouille"
}, {
  hex: "#eb9f2b",
  code: "075 70 80",
  scope: "Design System Plus",
  de: "Herbstgelb",
  en: "Autumn yellow",
  nl: "Herfstgeel",
  fr: "Jaune d'automne"
}, {
  hex: "#d7c8b8",
  code: "075 80 10",
  scope: "Design System Plus",
  de: "Kalkbeige",
  en: "Chalk beige",
  nl: "Kalkbeige",
  fr: "Beige calcaire"
}, {
  hex: "#e1c6a7",
  code: "075 80 20",
  scope: "Design System Plus",
  de: "Hellweizengelb",
  en: "Light corn yellow",
  nl: "Licht tarwegeel",
  fr: "Jaune blé clair"
}, {
  hex: "#e8c295",
  code: "075 80 30",
  scope: "Design System Plus",
  de: "Dunkelgelb",
  en: "Dark yellow",
  nl: "Donkergeel",
  fr: "Jaune foncé"
}, {
  hex: "#f0c186",
  code: "075 80 40",
  scope: "Design System Plus",
  de: "Eschengelb",
  en: "Ash yellow",
  nl: "Asgeel",
  fr: "Jaune frêne"
}, {
  hex: "#f6bd73",
  code: "075 80 50",
  scope: "Design System Plus",
  de: "Orientgelb",
  en: "Orient yellow",
  nl: "Oosters geel",
  fr: "Jaune d'Orient"
}, {
  hex: "#ffbb63",
  code: "075 80 60",
  scope: "Design System Plus",
  de: "Kutschengelb",
  en: "Carriage yellow",
  nl: "Rijtuig geel",
  fr: "Jaune calèche"
}, {
  hex: "#e4d4c3",
  code: "075 85 10",
  scope: "Design System Plus",
  de: "Seerosenweiß",
  en: "Water lily white",
  nl: "Waterlelie wit",
  fr: "Blanc nénuphar"
}, {
  hex: "#eed2b2",
  code: "075 85 20",
  scope: "Design System Plus",
  de: "Bananeneiscreme",
  en: "Banana ice cream",
  nl: "Bananenijs",
  fr: "Crème glacée à la banane"
}, {
  hex: "#f7d0a2",
  code: "075 85 30",
  scope: "Design System Plus",
  de: "Ahornbeige",
  en: "Maple beige",
  nl: "Esdoorn beige",
  fr: "Beige érable"
}, {
  hex: "#fecd90",
  code: "075 85 40",
  scope: "Design System Plus",
  de: "Goldrutengelb",
  en: "Goldenrod yellow",
  nl: "Guldenroede geel",
  fr: "Jaune verge d'or"
}, {
  hex: "#f5e5d2",
  code: "075 90 10",
  scope: "Design System Plus",
  de: "Süßspeisecreme",
  en: "Dessert cream",
  nl: "Dessertcrème",
  fr: "Crème dessert"
}, {
  hex: "#fce0c0",
  code: "075 90 20",
  scope: "Design System Plus",
  de: "Butterweiß",
  en: "Butter white",
  nl: "Boter wit",
  fr: "Blanc beurre"
}, {
  hex: "#f4ece3",
  code: "075 93 05",
  scope: "Design System Plus",
  de: "Vanilleweiß",
  en: "Vanilla white",
  nl: "Vanille wit",
  fr: "Blanc vanille"
}, {
  hex: "#4a4743",
  code: "080 20 05",
  scope: "Design System Plus",
  de: "Nachtbraunschwarz",
  en: "Night brown black",
  nl: "Nacht bruin zwart",
  fr: "Noir brun nuit"
}, {
  hex: "#4d4740",
  code: "080 20 10",
  scope: "Design System Plus",
  de: "Vanilleschotenbraun",
  en: "Vanilla bean brown",
  nl: "Vanilleboon bruin",
  fr: "Gousse de vanille brune"
}, {
  hex: "#5a5550",
  code: "080 30 05",
  scope: "Design System Plus",
  de: "Erdschwarz",
  en: "Earth black",
  nl: "Aarde zwart",
  fr: "Noir de terre"
}, {
  hex: "#5c544a",
  code: "080 30 10",
  scope: "Design System Plus",
  de: "Olivschwarz",
  en: "Olive black",
  nl: "Olijf zwart",
  fr: "Noir olive"
}, {
  hex: "#615341",
  code: "080 30 20",
  scope: "Design System Plus",
  de: "Nelkengelbbraun",
  en: "Clove yellow brown",
  nl: "Anjer geelbruin",
  fr: "Marron jaune œillet"
}, {
  hex: "#64533c",
  code: "080 30 26",
  scope: "Design System Plus",
  de: "Raucheichenbraun",
  en: "Smoked oak brown",
  nl: "Rokerig eikenbruin",
  fr: "Marron chêne fumé"
}, {
  hex: "#6e6962",
  code: "080 40 05",
  scope: "Design System Plus",
  de: "Bürograu",
  en: "Office grey",
  nl: "Kantoor grijs",
  fr: "Gris bureau"
}, {
  hex: "#71685b",
  code: "080 40 10",
  scope: "Design System Plus",
  de: "Steinbraun",
  en: "Stone brown",
  nl: "Steenbruin",
  fr: "Marron pierre"
}, {
  hex: "#76654d",
  code: "080 40 20",
  scope: "Design System Plus",
  de: "Pimentkornbraun",
  en: "Pimento grain brown",
  nl: "Pimentkorrel bruin",
  fr: "Brun grain de piment"
}, {
  hex: "#7b6442",
  code: "080 40 30",
  scope: "Design System Plus",
  de: "Ockergrün",
  en: "Ochre green",
  nl: "Okergroen",
  fr: "Vert ocre"
}, {
  hex: "#82653a",
  code: "080 40 40",
  scope: "Design System Plus",
  de: "Herbstlaubbraun",
  en: "Autumn leaf brown",
  nl: "Herfstblad bruin",
  fr: "Marron feuilles d'automne"
}, {
  hex: "#837e76",
  code: "080 50 05",
  scope: "Design System Plus",
  de: "Dämmergrau",
  en: "Dusk grey",
  nl: "Schemer grijs",
  fr: "Gris crépuscule"
}, {
  hex: "#877c6f",
  code: "080 50 10",
  scope: "Design System Plus",
  de: "Roggenbraun",
  en: "Rye brown",
  nl: "Roggebruin",
  fr: "Marron seigle"
}, {
  hex: "#8e7b60",
  code: "080 50 20",
  scope: "Design System Plus",
  de: "Graugelb",
  en: "Greyish yellow",
  nl: "Grijsgeel",
  fr: "Jaune gris"
}, {
  hex: "#937a53",
  code: "080 50 30",
  scope: "Design System Plus",
  de: "Chiligrün",
  en: "Chili green",
  nl: "Chilipeper groen",
  fr: "Vert piment"
}, {
  hex: "#977845",
  code: "080 50 40",
  scope: "Design System Plus",
  de: "Schmutzgelb",
  en: "Dirt yellow",
  nl: "Vies geel",
  fr: "Jaune sale"
}, {
  hex: "#9c7839",
  code: "080 50 50",
  scope: "Design System Plus",
  de: "Gamsgelb",
  en: "Chamois yellow",
  nl: "Gemsgeel",
  fr: "Jaune chamois"
}, {
  hex: "#9b958e",
  code: "080 60 05",
  scope: "Design System Plus",
  de: "Flanellgrau",
  en: "Flannel grey",
  nl: "Flanel grijs",
  fr: "Gris flanelle"
}, {
  hex: "#9e9384",
  code: "080 60 10",
  scope: "Design System Plus",
  de: "Hellkhaki",
  en: "Light khaki",
  nl: "Licht kaki",
  fr: "Kaki clair"
}, {
  hex: "#a79375",
  code: "080 60 20",
  scope: "Design System Plus",
  de: "Dinkelkornbraun",
  en: "Spelt grain brown",
  nl: "Speltkorrel bruin",
  fr: "Brun grain d'épeautre"
}, {
  hex: "#ad9165",
  code: "080 60 30",
  scope: "Design System Plus",
  de: "Goldquarzocker",
  en: "Golden quartz ochre",
  nl: "Goudkwarts gokker",
  fr: "Le quartz d'or"
}, {
  hex: "#b18e58",
  code: "080 60 40",
  scope: "Design System Plus",
  de: "Bambusgelb",
  en: "Bamboo yellow",
  nl: "Bamboe geel",
  fr: "Jaune bambou"
}, {
  hex: "#b78e49",
  code: "080 60 50",
  scope: "Design System Plus",
  de: "Messinggelb",
  en: "Brass yellow",
  nl: "Messing geel",
  fr: "jaune laiton"
}, {
  hex: "#bd8e39",
  code: "080 60 60",
  scope: "Design System Plus",
  de: "Feigensenfgelb",
  en: "Fig mustard yellow",
  nl: "Vijgenmosterd geel",
  fr: "Jaune figue de barbarie"
}, {
  hex: "#c08d2d",
  code: "080 60 70",
  scope: "Design System Plus",
  de: "Gelbgold",
  en: "Yellow gold",
  nl: "Geel goud",
  fr: "Or jaune"
}, {
  hex: "#b3aea6",
  code: "080 70 05",
  scope: "Design System Plus",
  de: "Knoblauchbeige",
  en: "Garlic beige",
  nl: "Knoflook beige",
  fr: "Beige à l'ail"
}, {
  hex: "#b8ac9c",
  code: "080 70 10",
  scope: "Design System Plus",
  de: "Feingreige",
  en: "Fine greige",
  nl: "Feingreige",
  fr: "Feingreige"
}, {
  hex: "#c1ab8b",
  code: "080 70 20",
  scope: "Design System Plus",
  de: "Gelbbraun",
  en: "Yellow brown",
  nl: "Geelbruin",
  fr: "Marron jaune"
}, {
  hex: "#c7a97b",
  code: "080 70 30",
  scope: "Design System Plus",
  de: "Senfkornbeige",
  en: "Mustard seed beige",
  nl: "Mosterdkorrel beige",
  fr: "Beige moutarde"
}, {
  hex: "#cfa86a",
  code: "080 70 40",
  scope: "Design System Plus",
  de: "Diamantgelb",
  en: "Diamond yellow",
  nl: "Diamantgeel",
  fr: "Jaune diamant"
}, {
  hex: "#d4a75a",
  code: "080 70 50",
  scope: "Design System Plus",
  de: "Antikmessing",
  en: "Antique brass",
  nl: "Antiek messing",
  fr: "Laiton antique"
}, {
  hex: "#dba74b",
  code: "080 70 60",
  scope: "Design System Plus",
  de: "Zucchinigelb",
  en: "Courgette yellow",
  nl: "Courgette dooier",
  fr: "Jaune de courgette"
}, {
  hex: "#dfa639",
  code: "080 70 70",
  scope: "Design System Plus",
  de: "Grapefruitgelb",
  en: "Grapefruit yellow",
  nl: "Grapefruit geel",
  fr: "Jaune pamplemousse"
}, {
  hex: "#e0a226",
  code: "080 70 80",
  scope: "Design System Plus",
  de: "Sonnenblumengelb",
  en: "Sunflower yellow",
  nl: "Zonnebloem geel",
  fr: "Jaune tournesol"
}, {
  hex: "#e5a10e",
  code: "080 70 88",
  scope: "Design System Plus",
  de: "Arnikagelb",
  en: "Arnica yellow",
  nl: "Arnica geel",
  fr: "Jaune d'arnica"
}, {
  hex: "#cfc9c0",
  code: "080 80 05",
  scope: "Design System Plus",
  de: "Glimmerhellgrau",
  en: "Micaceous light grey",
  nl: "Mica lichtgrijs",
  fr: "Gris clair micacé"
}, {
  hex: "#d6c8b7",
  code: "080 80 10",
  scope: "Design System Plus",
  de: "Pastellsand",
  en: "Pastel sand",
  nl: "Pastelzand",
  fr: "Sable pastel"
}, {
  hex: "#ddc5a4",
  code: "080 80 20",
  scope: "Design System Plus",
  de: "Naturreisbeige",
  en: "Natural rice beige",
  nl: "Natuurlijk rijstbeige",
  fr: "Beige riz naturel"
}, {
  hex: "#e3c393",
  code: "080 80 30",
  scope: "Design System Plus",
  de: "Gelbbeige",
  en: "Yellow beige",
  nl: "Geel beige",
  fr: "Beige jaune"
}, {
  hex: "#ebc281",
  code: "080 80 40",
  scope: "Design System Plus",
  de: "Strohgelb",
  en: "Straw yellow",
  nl: "Strogeel",
  fr: "Jaune paille"
}, {
  hex: "#f2c172",
  code: "080 80 50",
  scope: "Design System Plus",
  de: "Mirabellengelb",
  en: "Mirabelle yellow",
  nl: "Mirabelle geel",
  fr: "Jaune mirabelle"
}, {
  hex: "#f8c05f",
  code: "080 80 60",
  scope: "Design System Plus",
  de: "Vollgelb",
  en: "Full yellow",
  nl: "Stevig geel",
  fr: "Jaune plein"
}, {
  hex: "#fbbd4e",
  code: "080 80 70",
  scope: "Design System Plus",
  de: "Birnengelb",
  en: "Pear yellow",
  nl: "Peer geel",
  fr: "Jaune poire"
}, {
  hex: "#ffba36",
  code: "080 80 80",
  scope: "Design System Plus",
  de: "Brandgelb",
  en: "Fire yellow",
  nl: "Brandgeel",
  fr: "Jaune vif"
}, {
  hex: "#ffba1f",
  code: "080 80 90",
  scope: "Design System Plus",
  de: "Sommergelb",
  en: "Summer yellow",
  nl: "Zomer geel",
  fr: "Jaune d'été"
}, {
  hex: "#dbd4ca",
  code: "080 85 05",
  scope: "Design System Plus",
  de: "Weizenmehlweiß",
  en: "Wheat flour white",
  nl: "Tarwebloem wit",
  fr: "Blanc de farine de blé"
}, {
  hex: "#e0d4c2",
  code: "080 85 10",
  scope: "Design System Plus",
  de: "Zwiebelweiß",
  en: "Onion white",
  nl: "Ui wit",
  fr: "Blanc d'oignon"
}, {
  hex: "#ead3b2",
  code: "080 85 20",
  scope: "Design System Plus",
  de: "Nashibirnenbeige",
  en: "Nashi pear beige",
  nl: "Nashi peer beige",
  fr: "Beige poire à rhinocéros"
}, {
  hex: "#f1d0a0",
  code: "080 85 30",
  scope: "Design System Plus",
  de: "Vespagelb",
  en: "Vespa yellow",
  nl: "Vespagelb",
  fr: "Vespagelb"
}, {
  hex: "#f9cf8d",
  code: "080 85 40",
  scope: "Design System Plus",
  de: "Blätterteiggelb",
  en: "Puff pastry yellow",
  nl: "Bladerdeeg geel",
  fr: "Pâte feuilletée jaune"
}, {
  hex: "#ede5da",
  code: "080 90 05",
  scope: "Design System Plus",
  de: "Japanweiß",
  en: "Japanese white",
  nl: "Japan wit",
  fr: "Blanc Japon"
}, {
  hex: "#efe1cf",
  code: "080 90 10",
  scope: "Design System Plus",
  de: "Champignonweiß",
  en: "Mushroom white",
  nl: "Champignon wit",
  fr: "Blanc de champignon"
}, {
  hex: "#ecd6b6",
  code: "080 90 20",
  scope: "Design System Plus",
  de: "Macadamiabeige",
  en: "Macadamia beige",
  nl: "Macadamia beige",
  fr: "Beige macadamia"
}, {
  hex: "#ffdfae",
  code: "080 90 30",
  scope: "Design System Plus",
  de: "Meerrettichgelb",
  en: "Horseradish yellow",
  nl: "Mierikswortel geel",
  fr: "Jaune raifort"
}, {
  hex: "#f3eae1",
  code: "080 93 05",
  scope: "Design System Plus",
  de: "Milchsternweiß",
  en: "Milk star white",
  nl: "Melkster wit",
  fr: "Blanc étoile de lait"
}, {
  hex: "#716a5e",
  code: "085 40 10",
  scope: "Design System Plus",
  de: "Mineralgrün",
  en: "Mineral green",
  nl: "Mineraalgroen",
  fr: "Vert minéral"
}, {
  hex: "#74674f",
  code: "085 40 20",
  scope: "Design System Plus",
  de: "Khakigrün",
  en: "Khaki green",
  nl: "Kaki groen",
  fr: "Vert kaki"
}, {
  hex: "#7a6847",
  code: "085 40 30",
  scope: "Design System Plus",
  de: "Moosbraun",
  en: "Moss brown",
  nl: "Mosbruin",
  fr: "Marron mousse"
}, {
  hex: "#867e6f",
  code: "085 50 10",
  scope: "Design System Plus",
  de: "Korianderocker",
  en: "Coriander ochre",
  nl: "Koriander oker",
  fr: "Tabouret de coriandre"
}, {
  hex: "#8c7d61",
  code: "085 50 20",
  scope: "Design System Plus",
  de: "Pyritschiefergrün",
  en: "Pyrite slate green",
  nl: "Pyriet leigroen",
  fr: "Vert ardoise pyrite"
}, {
  hex: "#927d54",
  code: "085 50 30",
  scope: "Design System Plus",
  de: "Sepiagelb",
  en: "Sepia yellow",
  nl: "Sepia geel",
  fr: "Jaune sépia"
}, {
  hex: "#947b48",
  code: "085 50 40",
  scope: "Design System Plus",
  de: "Sumpfgrün",
  en: "Marshy green",
  nl: "Moerasgroen",
  fr: "Vert marais"
}, {
  hex: "#987b3d",
  code: "085 50 50",
  scope: "Design System Plus",
  de: "Honiggelbgrün",
  en: "Honey yellow green",
  nl: "Honing geel groen",
  fr: "Vert jaune miel"
}, {
  hex: "#9e9587",
  code: "085 60 10",
  scope: "Design System Plus",
  de: "Mattoliv",
  en: "Matte olive",
  nl: "Mattolive",
  fr: "Mattoliv"
}, {
  hex: "#a59476",
  code: "085 60 20",
  scope: "Design System Plus",
  de: "Teichgrün",
  en: "Pond green",
  nl: "Vijver groen",
  fr: "Vert de l'étang"
}, {
  hex: "#ab9367",
  code: "085 60 30",
  scope: "Design System Plus",
  de: "Holzgrün",
  en: "Wood green",
  nl: "Houtgroen",
  fr: "Vert bois"
}, {
  hex: "#af9358",
  code: "085 60 40",
  scope: "Design System Plus",
  de: "Flechtengrün",
  en: "Lichen green",
  nl: "Groen korstmos",
  fr: "Vert lichen"
}, {
  hex: "#b4934a",
  code: "085 60 50",
  scope: "Design System Plus",
  de: "Mineralumbra",
  en: "Mineral umber",
  nl: "Mineralumbra",
  fr: "Mineralumbra"
}, {
  hex: "#b9923b",
  code: "085 60 60",
  scope: "Design System Plus",
  de: "Lodengelb",
  en: "Loden yellow",
  nl: "Loden geel",
  fr: "Jaune loden"
}, {
  hex: "#b6ad9c",
  code: "085 70 10",
  scope: "Design System Plus",
  de: "Naturbastgreige",
  en: "Raffia greige",
  nl: "Natuurlijk bastgrauw",
  fr: "Pâte à modeler naturelle"
}, {
  hex: "#bfac8c",
  code: "085 70 20",
  scope: "Design System Plus",
  de: "Feldspatgrau",
  en: "Feldspar grey",
  nl: "Veldspaat grijs",
  fr: "Gris feldspath"
}, {
  hex: "#c5ac7a",
  code: "085 70 30",
  scope: "Design System Plus",
  de: "Heugelb",
  en: "Hay yellow",
  nl: "Hooi geel",
  fr: "Jaune foin"
}, {
  hex: "#c9aa6b",
  code: "085 70 40",
  scope: "Design System Plus",
  de: "Winterbirnenbeige",
  en: "Winter pear beige",
  nl: "Winterpeer beige",
  fr: "Beige poire d'hiver"
}, {
  hex: "#cea95a",
  code: "085 70 50",
  scope: "Design System Plus",
  de: "Herbstapfelgelb",
  en: "Autumn apple yellow",
  nl: "Herfst appel geel",
  fr: "Jaune pomme d'automne"
}, {
  hex: "#d0a848",
  code: "085 70 60",
  scope: "Design System Plus",
  de: "Pitmastonbirnengelb",
  en: "Pitmaston pear yellow",
  nl: "Pitmaston peer geel",
  fr: "Jaune pitmaston poire"
}, {
  hex: "#d4a738",
  code: "085 70 70",
  scope: "Design System Plus",
  de: "Strohblumengelb",
  en: "Immortelle yellow",
  nl: "Strobloem geel",
  fr: "Jaune fleur de paille"
}, {
  hex: "#daa92d",
  code: "085 70 75",
  scope: "Design System Plus",
  de: "Goldberyllgelb",
  en: "Golden beryl yellow",
  nl: "Gouden beryl geel",
  fr: "Jaune béryl doré"
}, {
  hex: "#d1c7b5",
  code: "085 80 10",
  scope: "Design System Plus",
  de: "Samtbeige",
  en: "Velvet beige",
  nl: "Fluweelbeige",
  fr: "Beige velouté"
}, {
  hex: "#d8c6a4",
  code: "085 80 20",
  scope: "Design System Plus",
  de: "Mineralbeige",
  en: "Mineral beige",
  nl: "Mineraal beige",
  fr: "Beige minéral"
}, {
  hex: "#e1c692",
  code: "085 80 30",
  scope: "Design System Plus",
  de: "Mondscheingelb",
  en: "Moonlight yellow",
  nl: "Maanlicht geel",
  fr: "Jaune clair de lune"
}, {
  hex: "#e6c582",
  code: "085 80 40",
  scope: "Design System Plus",
  de: "Tafelbirnengelb",
  en: "Table pear yellow",
  nl: "Tafelpeer geel",
  fr: "Jaune poire de table"
}, {
  hex: "#e9c370",
  code: "085 80 50",
  scope: "Design System Plus",
  de: "Fruchtgelb",
  en: "Fruit yellow",
  nl: "Vrucht geel",
  fr: "Jaune fruit"
}, {
  hex: "#eec25d",
  code: "085 80 60",
  scope: "Design System Plus",
  de: "Adonisröschengelb",
  en: "Adonis rose yellow",
  nl: "Adonis bloesem geel",
  fr: "Jaune adonis"
}, {
  hex: "#f2c14b",
  code: "085 80 70",
  scope: "Design System Plus",
  de: "Berberitzengelb",
  en: "Barberry yellow",
  nl: "Bosbes geel",
  fr: "Jaune berbère"
}, {
  hex: "#f4bf36",
  code: "085 80 80",
  scope: "Design System Plus",
  de: "Löwenzahngelb",
  en: "Dandelion yellow",
  nl: "Paardenbloem geel",
  fr: "Jaune pissenlit"
}, {
  hex: "#f5bf2c",
  code: "085 80 85",
  scope: "Design System Plus",
  de: "Dekorgelb",
  en: "Decor yellow",
  nl: "Decoratief geel",
  fr: "Jaune décoratif"
}, {
  hex: "#ddd2bf",
  code: "085 85 10",
  scope: "Design System Plus",
  de: "Alabasterweiß",
  en: "Alabaster white",
  nl: "Albast wit",
  fr: "Blanc albâtre"
}, {
  hex: "#e5d2b0",
  code: "085 85 20",
  scope: "Design System Plus",
  de: "Hellblond",
  en: "Light blond",
  nl: "Licht blond",
  fr: "Blond clair"
}, {
  hex: "#edd19e",
  code: "085 85 30",
  scope: "Design System Plus",
  de: "Weidenblütengelb",
  en: "Willow-flower yellow",
  nl: "Wilgenbloesem geel",
  fr: "Jaune fleur de saule"
}, {
  hex: "#f4d28e",
  code: "085 85 40",
  scope: "Design System Plus",
  de: "Ingwerhellgelb",
  en: "Light ginger yellow",
  nl: "Gember lichtgeel",
  fr: "Jaune gingembre clair"
}, {
  hex: "#f0e5d3",
  code: "085 90 10",
  scope: "Design System Plus",
  de: "Tulpenweiß",
  en: "Tulip white",
  nl: "Tulp wit",
  fr: "Blanc tulipe"
}, {
  hex: "#f6e1be",
  code: "085 90 20",
  scope: "Design System Plus",
  de: "Alpenbeerengelb",
  en: "Alpine berry yellow",
  nl: "Alpine bessengeel",
  fr: "Jaune baie des Alpes"
}, {
  hex: "#fbdeab",
  code: "085 90 30",
  scope: "Design System Plus",
  de: "Porzellanerdengelb",
  en: "China clay yellow",
  nl: "Porseleinklei geel",
  fr: "Jaune terre de porcelaine"
}, {
  hex: "#f2ece3",
  code: "085 93 05",
  scope: "Design System Plus",
  de: "Altweiß",
  en: "Vintage white",
  nl: "Oud wit",
  fr: "Blanc cassé"
}, {
  hex: "#5b554a",
  code: "090 30 10",
  scope: "Design System Plus",
  de: "Limonitbraun",
  en: "Limonite brown",
  nl: "Limoniet bruin",
  fr: "Marron limonite"
}, {
  hex: "#5f5641",
  code: "090 30 20",
  scope: "Design System Plus",
  de: "Borkengrün",
  en: "Bark green",
  nl: "Schors groen",
  fr: "Vert bordeaux"
}, {
  hex: "#706a5d",
  code: "090 40 10",
  scope: "Design System Plus",
  de: "Wackersteinbraun",
  en: "Boulder brown",
  nl: "Bruin Wackerstein",
  fr: "Marron pierre de taille"
}, {
  hex: "#73684d",
  code: "090 40 20",
  scope: "Design System Plus",
  de: "Pflaumengrün",
  en: "Plum green",
  nl: "Pruimgroen",
  fr: "Vert prune"
}, {
  hex: "#766843",
  code: "090 40 30",
  scope: "Design System Plus",
  de: "Weinblättergrün",
  en: "Vine leaf green",
  nl: "Wijnblad groen",
  fr: "Vert feuille de vigne"
}, {
  hex: "#847e70",
  code: "090 50 10",
  scope: "Design System Plus",
  de: "Graphitgraugrün",
  en: "Graphite grey green",
  nl: "Grafiet grijsgroen",
  fr: "Vert gris graphite"
}, {
  hex: "#887d61",
  code: "090 50 20",
  scope: "Design System Plus",
  de: "Pestogrün",
  en: "Pesto green",
  nl: "Pesto groen",
  fr: "Vert pesto"
}, {
  hex: "#8e7e51",
  code: "090 50 30",
  scope: "Design System Plus",
  de: "Riesenkaktusgrün",
  en: "Giant cactus green",
  nl: "Reuzencactus groen",
  fr: "Vert cactus géant"
}, {
  hex: "#917e45",
  code: "090 50 40",
  scope: "Design System Plus",
  de: "Auberginengrün",
  en: "Aubergine green",
  nl: "Aubergine groen",
  fr: "Vert d'aubergine"
}, {
  hex: "#9b9485",
  code: "090 60 10",
  scope: "Design System Plus",
  de: "Austerngrau",
  en: "Oyster grey",
  nl: "Oestergrijs",
  fr: "Gris huître"
}, {
  hex: "#a29474",
  code: "090 60 20",
  scope: "Design System Plus",
  de: "Manzanillaoliv",
  en: "Manzanilla olive",
  nl: "Manzanilla olijf",
  fr: "Manzanillaoliv"
}, {
  hex: "#a59467",
  code: "090 60 30",
  scope: "Design System Plus",
  de: "Tarnoliv",
  en: "Camouflage olive",
  nl: "Tarnoliv",
  fr: "Tarnoliv"
}, {
  hex: "#a89356",
  code: "090 60 40",
  scope: "Design System Plus",
  de: "Lorbeergrün",
  en: "Laurel green",
  nl: "Lauriergroen",
  fr: "Vert de laurier"
}, {
  hex: "#a89043",
  code: "090 60 50",
  scope: "Design System Plus",
  de: "Fahlgrün",
  en: "Faint green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#af9538",
  code: "090 60 60",
  scope: "Design System Plus",
  de: "Titanitgelb",
  en: "Titanite yellow",
  nl: "Titaniet geel",
  fr: "Jaune titanite"
}, {
  hex: "#b5ae9d",
  code: "090 70 10",
  scope: "Design System Plus",
  de: "Staubgelb",
  en: "Dusty yellow",
  nl: "Stof geel",
  fr: "Jaune poussière"
}, {
  hex: "#bbad8a",
  code: "090 70 20",
  scope: "Design System Plus",
  de: "Barbadosbeige",
  en: "Barbados beige",
  nl: "Barbados beige",
  fr: "Barbadosbeige"
}, {
  hex: "#beab7b",
  code: "090 70 30",
  scope: "Design System Plus",
  de: "Rhabarberblattgrün",
  en: "Rhubarb leaf green",
  nl: "Rabarberblad groen",
  fr: "Vert feuille de rhubarbe"
}, {
  hex: "#c5ae6a",
  code: "090 70 40",
  scope: "Design System Plus",
  de: "Igelkaktusgelbgrün",
  en: "Hedgehog cactus yellow green",
  nl: "Egelcactus geelgroen",
  fr: "Vert hérisson-cactus"
}, {
  hex: "#c8ad5a",
  code: "090 70 50",
  scope: "Design System Plus",
  de: "Stachelbeergelb",
  en: "Gooseberry yellow",
  nl: "Kruisbes geel",
  fr: "Jaune groseille"
}, {
  hex: "#caac47",
  code: "090 70 60",
  scope: "Design System Plus",
  de: "Knospengrün",
  en: "Bud green",
  nl: "Groen",
  fr: "Vert bourgeon"
}, {
  hex: "#cdac33",
  code: "090 70 70",
  scope: "Design System Plus",
  de: "Birkenkätzchengelb",
  en: "Catkin yellow",
  nl: "Berkenkatoen geel",
  fr: "Jaune poussin bouleau"
}, {
  hex: "#cfab22",
  code: "090 70 80",
  scope: "Design System Plus",
  de: "Prehnitgelb",
  en: "Prehnite yellow",
  nl: "Prehniet geel",
  fr: "Jaune prehnite"
}, {
  hex: "#d0c7b3",
  code: "090 80 10",
  scope: "Design System Plus",
  de: "Hellbeige",
  en: "Light beige",
  nl: "Licht beige",
  fr: "Beige clair"
}, {
  hex: "#d5c6a3",
  code: "090 80 20",
  scope: "Design System Plus",
  de: "Champagnerbeige",
  en: "Champagne beige",
  nl: "Champagne-beige",
  fr: "Beige champagne"
}, {
  hex: "#dcc894",
  code: "090 80 30",
  scope: "Design System Plus",
  de: "Zitronensorbetgelb",
  en: "Lemon sorbet yellow",
  nl: "Citroensorbet geel",
  fr: "Jaune sorbet citron"
}, {
  hex: "#e0c984",
  code: "090 80 40",
  scope: "Design System Plus",
  de: "Blütengelb",
  en: "Blossom yellow",
  nl: "Bloem geel",
  fr: "Jaune fleur"
}, {
  hex: "#e5c76d",
  code: "090 80 50",
  scope: "Design System Plus",
  de: "Tasmanhoniggelb",
  en: "Tasman honey yellow",
  nl: "Tasmaanse honing geel",
  fr: "Jaune miel de Tasmanie"
}, {
  hex: "#e7c558",
  code: "090 80 60",
  scope: "Design System Plus",
  de: "Neugelb",
  en: "New yellow",
  nl: "Nieuw geel",
  fr: "Jaune neuf"
}, {
  hex: "#ebc648",
  code: "090 80 70",
  scope: "Design System Plus",
  de: "Fashiongelb",
  en: "Fashion yellow",
  nl: "Mode geel",
  fr: "Jaune fashion"
}, {
  hex: "#eac42c",
  code: "090 80 80",
  scope: "Design System Plus",
  de: "Plakatgelb",
  en: "Poster yellow",
  nl: "Poster geel",
  fr: "Jaune d'affiche"
}, {
  hex: "#f0c503",
  code: "090 80 90",
  scope: "Design System Plus",
  de: "Kontrastgelb",
  en: "Contrasting yellow",
  nl: "Contrast geel",
  fr: "Jaune de contraste"
}, {
  hex: "#dad4ca",
  code: "090 85 05",
  scope: "Design System Plus",
  de: "Pfefferweiß",
  en: "Pepper white",
  nl: "Peper wit",
  fr: "Blanc poivré"
}, {
  hex: "#dfd5c2",
  code: "090 85 10",
  scope: "Design System Plus",
  de: "Paellanaturweiß",
  en: "Paella natural white",
  nl: "Paella wit",
  fr: "Blanc naturel Paellan"
}, {
  hex: "#e4d5b0",
  code: "090 85 20",
  scope: "Design System Plus",
  de: "Cidregelb",
  en: "Cider yellow",
  nl: "Cidregelb",
  fr: "Cidregelb"
}, {
  hex: "#ead59f",
  code: "090 85 30",
  scope: "Design System Plus",
  de: "Palmzuckergelb",
  en: "Palm sugar yellow",
  nl: "Palmsuiker geel",
  fr: "Jaune sucre de palme"
}, {
  hex: "#edd38c",
  code: "090 85 40",
  scope: "Design System Plus",
  de: "Märzgelb",
  en: "March yellow",
  nl: "Maart geel",
  fr: "Jaune de mars"
}, {
  hex: "#f2d479",
  code: "090 85 50",
  scope: "Design System Plus",
  de: "Pirolgelb",
  en: "Oriole yellow",
  nl: "Oriole geel",
  fr: "Jaune loriot"
}, {
  hex: "#eae4d9",
  code: "090 90 05",
  scope: "Design System Plus",
  de: "Marzipanweiß",
  en: "Marzipan white",
  nl: "Marsepein wit",
  fr: "Blanc massepain"
}, {
  hex: "#ebe4d1",
  code: "090 90 10",
  scope: "Design System Plus",
  de: "Primelweiß",
  en: "Primrose white",
  nl: "Primula wit",
  fr: "Blanc primevère"
}, {
  hex: "#f2e3bd",
  code: "090 90 20",
  scope: "Design System Plus",
  de: "Cremegelb",
  en: "Cream yellow",
  nl: "Crème geel",
  fr: "Jaune crème"
}, {
  hex: "#f6e2ac",
  code: "090 90 30",
  scope: "Design System Plus",
  de: "Wachsgelb",
  en: "Wax yellow",
  nl: "Was geel",
  fr: "Jaune cire"
}, {
  hex: "#fce299",
  code: "090 90 40",
  scope: "Design System Plus",
  de: "Zitronencreme",
  en: "Lemon cream",
  nl: "Citroencrème",
  fr: "Crème au citron"
}, {
  hex: "#fdde82",
  code: "090 90 50",
  scope: "Design System Plus",
  de: "Tigergelb",
  en: "Tiger yellow",
  nl: "Tijger geel",
  fr: "Jaune tigre"
}, {
  hex: "#fedc70",
  code: "090 90 60",
  scope: "Design System Plus",
  de: "Sonnenröschengelb",
  en: "Sunrose yellow",
  nl: "Zonnebloem geel",
  fr: "Jaune tournesol"
}, {
  hex: "#f0ebe0",
  code: "090 93 05",
  scope: "Design System Plus",
  de: "Sahneweiß",
  en: "Cream white",
  nl: "Romig wit",
  fr: "Blanc crème"
}, {
  hex: "#6e6a5d",
  code: "095 40 10",
  scope: "Design System Plus",
  de: "Schattengrün",
  en: "Shady green",
  nl: "Schaduwgroen",
  fr: "Vert ombre"
}, {
  hex: "#71684e",
  code: "095 40 20",
  scope: "Design System Plus",
  de: "Waldgrün",
  en: "Forest green",
  nl: "Bosgroen",
  fr: "Vert forêt"
}, {
  hex: "#726843",
  code: "095 40 30",
  scope: "Design System Plus",
  de: "Bohnengrün",
  en: "Bean green",
  nl: "Bonengroen",
  fr: "Vert de haricot"
}, {
  hex: "#837e70",
  code: "095 50 10",
  scope: "Design System Plus",
  de: "Stumpfoliv",
  en: "Dull olive",
  nl: "Stompfolie",
  fr: "olive à moignon"
}, {
  hex: "#877e62",
  code: "095 50 20",
  scope: "Design System Plus",
  de: "Kohlgrün",
  en: "Cabbage green",
  nl: "Kool groen",
  fr: "Vert choux"
}, {
  hex: "#8b7f54",
  code: "095 50 30",
  scope: "Design System Plus",
  de: "Kaperngrün",
  en: "Caper green",
  nl: "Kappertjesgroen",
  fr: "Vert câpre"
}, {
  hex: "#8d7e45",
  code: "095 50 40",
  scope: "Design System Plus",
  de: "Gartensalatgrün",
  en: "Garden lettuce green",
  nl: "Tuin sla",
  fr: "Vert de salade de jardin"
}, {
  hex: "#8f813c",
  code: "095 50 50",
  scope: "Design System Plus",
  de: "Artischockengrün",
  en: "Artichoke green",
  nl: "Artisjok groen",
  fr: "Vert artichaut"
}, {
  hex: "#9c9686",
  code: "095 60 10",
  scope: "Design System Plus",
  de: "Bleichgrüngrau",
  en: "Pale green grey",
  nl: "Lichtgroen-grijs",
  fr: "Gris vert pâle"
}, {
  hex: "#9f9676",
  code: "095 60 20",
  scope: "Design System Plus",
  de: "Blassgrün",
  en: "Pale green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#a39565",
  code: "095 60 30",
  scope: "Design System Plus",
  de: "Zypressengrün",
  en: "Cypress green",
  nl: "Cypresgroen",
  fr: "Vert cyprès"
}, {
  hex: "#a59556",
  code: "095 60 40",
  scope: "Design System Plus",
  de: "Traubengrün",
  en: "Grape green",
  nl: "Druifgroen",
  fr: "Vert raisin"
}, {
  hex: "#a69746",
  code: "095 60 50",
  scope: "Design System Plus",
  de: "Stachelbeergrün",
  en: "Gooseberry green",
  nl: "Kruisbessengroen",
  fr: "Vert groseille"
}, {
  hex: "#a59439",
  code: "095 60 60",
  scope: "Design System Plus",
  de: "Guavenfruchtgrün",
  en: "Guava green",
  nl: "Guave groen",
  fr: "Vert goyave"
}, {
  hex: "#a7962a",
  code: "095 60 70",
  scope: "Design System Plus",
  de: "Romanescogrün",
  en: "Romaine green",
  nl: "Romanesco groen",
  fr: "Vert romanesco"
}, {
  hex: "#b6b09e",
  code: "095 70 10",
  scope: "Design System Plus",
  de: "Sandgrau",
  en: "Sand grey",
  nl: "Zandgrijs",
  fr: "Gris sable"
}, {
  hex: "#bab08f",
  code: "095 70 20",
  scope: "Design System Plus",
  de: "Krokodilgrün",
  en: "Crocodile green",
  nl: "Krokodil groen",
  fr: "Vert crocodile"
}, {
  hex: "#beb07e",
  code: "095 70 30",
  scope: "Design System Plus",
  de: "Chicoréegrün",
  en: "Chicory green",
  nl: "Witlof",
  fr: "Vert de chicorée"
}, {
  hex: "#c0af6a",
  code: "095 70 40",
  scope: "Design System Plus",
  de: "Bananengrün",
  en: "Banana green",
  nl: "Bananengroen",
  fr: "Vert banane"
}, {
  hex: "#c0af5c",
  code: "095 70 50",
  scope: "Design System Plus",
  de: "Sternfruchtgelbgrün",
  en: "Star fruit yellow green",
  nl: "Sterfruit geelgroen",
  fr: "Vert fruit de l'étoile"
}, {
  hex: "#c0ae4c",
  code: "095 70 60",
  scope: "Design System Plus",
  de: "Papayagelbgrün",
  en: "Papaya yellow green",
  nl: "Papaja geelgroen",
  fr: "Vert papaye"
}, {
  hex: "#c5b037",
  code: "095 70 70",
  scope: "Design System Plus",
  de: "Bronzegrün",
  en: "Bronze green",
  nl: "Bronsgroen",
  fr: "Vert bronze"
}, {
  hex: "#cfc9b8",
  code: "095 80 10",
  scope: "Design System Plus",
  de: "Saphirlichtgelb",
  en: "Sapphire light yellow",
  nl: "Saffier lichtgeel",
  fr: "Jaune saphir clair"
}, {
  hex: "#d5caa7",
  code: "095 80 20",
  scope: "Design System Plus",
  de: "Blassoliv",
  en: "Pale olive",
  nl: "Blassoliv",
  fr: "Blassoliv"
}, {
  hex: "#dbcc96",
  code: "095 80 30",
  scope: "Design System Plus",
  de: "Spargelgelb",
  en: "Asparagus yellow",
  nl: "Asperge geel",
  fr: "Jaune asperge"
}, {
  hex: "#decb83",
  code: "095 80 40",
  scope: "Design System Plus",
  de: "Erbsengrün",
  en: "Pea green",
  nl: "Erwtgroen",
  fr: "Vert pois"
}, {
  hex: "#deca72",
  code: "095 80 50",
  scope: "Design System Plus",
  de: "Williamsbirnengelb",
  en: "Williams pear yellow",
  nl: "Williams peergeel",
  fr: "Jaune poire williams"
}, {
  hex: "#dcc75f",
  code: "095 80 60",
  scope: "Design System Plus",
  de: "Grünlichgelb",
  en: "Greenish yellow",
  nl: "Groenachtig geel",
  fr: "Jaune verdâtre"
}, {
  hex: "#dfc94b",
  code: "095 80 70",
  scope: "Design System Plus",
  de: "Mimosengelb",
  en: "Mimosa yellow",
  nl: "Mimosa geel",
  fr: "Jaune mimosa"
}, {
  hex: "#dac438",
  code: "095 80 80",
  scope: "Design System Plus",
  de: "Sorbetgelb",
  en: "Sorbet yellow",
  nl: "Sorbetgeel",
  fr: "Jaune sorbet"
}, {
  hex: "#dcd6c4",
  code: "095 85 10",
  scope: "Design System Plus",
  de: "Schwarzwurzelweiß",
  en: "Salsify white",
  nl: "Schorseneren wit",
  fr: "Blanc de scorsonère"
}, {
  hex: "#e2d7b4",
  code: "095 85 20",
  scope: "Design System Plus",
  de: "Trübhellgelb",
  en: "Dull light yellow",
  nl: "Lichtgeel bewolkt",
  fr: "Jaune pâle trouble"
}, {
  hex: "#e6d6a0",
  code: "095 85 30",
  scope: "Design System Plus",
  de: "Blattgelb",
  en: "Leaf yellow",
  nl: "Blad geel",
  fr: "Jaune feuille"
}, {
  hex: "#ebd78d",
  code: "095 85 40",
  scope: "Design System Plus",
  de: "Naturgelb",
  en: "Natural yellow",
  nl: "Natuurlijk geel",
  fr: "Jaune naturel"
}, {
  hex: "#ecd67c",
  code: "095 85 50",
  scope: "Design System Plus",
  de: "Sportgelb",
  en: "Sport yellow",
  nl: "Sport geel",
  fr: "Jaune sport"
}, {
  hex: "#ece5d0",
  code: "095 90 10",
  scope: "Design System Plus",
  de: "Atlasweiß",
  en: "Atlas white",
  nl: "Atlas wit",
  fr: "Blanc atlas"
}, {
  hex: "#f1e4c0",
  code: "095 90 20",
  scope: "Design System Plus",
  de: "Perlgelb",
  en: "Pearl yellow",
  nl: "Parel geel",
  fr: "Jaune perle"
}, {
  hex: "#f6e3ac",
  code: "095 90 30",
  scope: "Design System Plus",
  de: "Zitroneneisgelb",
  en: "Lemon ice cream yellow",
  nl: "Citroen ijsgeel",
  fr: "Jaune citron glacé"
}, {
  hex: "#f7e297",
  code: "095 90 40",
  scope: "Design System Plus",
  de: "Frischgelb",
  en: "Fresh yellow",
  nl: "Fris geel",
  fr: "Jaune frais"
}, {
  hex: "#fde588",
  code: "095 90 50",
  scope: "Design System Plus",
  de: "Leuchtendgelb",
  en: "Luminescent yellow",
  nl: "Lichtgevend geel",
  fr: "Jaune vif"
}, {
  hex: "#ffe479",
  code: "095 90 59",
  scope: "Design System Plus",
  de: "Dynamischgelb",
  en: "Dynamic yellow",
  nl: "Dynamisch geel",
  fr: "Jaune dynamique"
}, {
  hex: "#eeebe2",
  code: "095 93 05",
  scope: "Design System Plus",
  de: "Kreppseidenweiß",
  en: "Crepe silk white",
  nl: "Crepe zijde wit",
  fr: "Blanc crêpe de soie"
}, {
  hex: "#4a4945",
  code: "100 20 05",
  scope: "Design System Plus",
  de: "Nachtgrün",
  en: "Night green",
  nl: "Nachtgroen",
  fr: "Vert nuit"
}, {
  hex: "#56554f",
  code: "100 30 05",
  scope: "Design System Plus",
  de: "Vulkansteingrün",
  en: "Volcanic stone green",
  nl: "Vulkaansteen groen",
  fr: "Vert pierre volcanique"
}, {
  hex: "#585449",
  code: "100 30 10",
  scope: "Design System Plus",
  de: "Zinnobergrün",
  en: "Vermilion green",
  nl: "Vermiljoen groen",
  fr: "Vert vermillon"
}, {
  hex: "#5a5741",
  code: "100 30 20",
  scope: "Design System Plus",
  de: "Uniformgrün",
  en: "Uniform green",
  nl: "Uniform groen",
  fr: "Vert uniforme"
}, {
  hex: "#6a6962",
  code: "100 40 05",
  scope: "Design System Plus",
  de: "Taubengrau",
  en: "Doves grey",
  nl: "Duifgrijs",
  fr: "Gris pigeon"
}, {
  hex: "#6c695b",
  code: "100 40 10",
  scope: "Design System Plus",
  de: "Schlickgrün",
  en: "Slick green",
  nl: "Slibgroen",
  fr: "Vert barbotine"
}, {
  hex: "#6d694f",
  code: "100 40 20",
  scope: "Design System Plus",
  de: "Brokkoligrün",
  en: "Broccoli green",
  nl: "Broccoli groen",
  fr: "Vert de brocoli"
}, {
  hex: "#706a43",
  code: "100 40 30",
  scope: "Design System Plus",
  de: "Hochwaldgrün",
  en: "High forest green",
  nl: "Hoog bosgroen",
  fr: "Vert forêt"
}, {
  hex: "#716b3b",
  code: "100 40 40",
  scope: "Design System Plus",
  de: "Rosenkohlgrün",
  en: "Brussels sprout green",
  nl: "Spruitjes",
  fr: "Choux de Bruxelles verts"
}, {
  hex: "#817f77",
  code: "100 50 05",
  scope: "Design System Plus",
  de: "Waldbodenkhaki",
  en: "Forest floor khaki",
  nl: "Bosbodem kaki",
  fr: "Kaki des sols forestiers"
}, {
  hex: "#827e6e",
  code: "100 50 10",
  scope: "Design System Plus",
  de: "Kiebitzgraugrün",
  en: "Lapwing grey green",
  nl: "Kievit grijsgroen",
  fr: "Vert gris vanneau"
}, {
  hex: "#848060",
  code: "100 50 20",
  scope: "Design System Plus",
  de: "Grünspechtoliv",
  en: "Green woodpecker olive",
  nl: "Groene specht olijf",
  fr: "Olive du pic vert"
}, {
  hex: "#847e52",
  code: "100 50 30",
  scope: "Design System Plus",
  de: "Steppengrün",
  en: "Steppe green",
  nl: "Gewatteerd groen",
  fr: "Vert steppe"
}, {
  hex: "#888045",
  code: "100 50 40",
  scope: "Design System Plus",
  de: "Faiencegrün",
  en: "Faience green",
  nl: "Faience groen",
  fr: "Vert faïence"
}, {
  hex: "#868039",
  code: "100 50 50",
  scope: "Design System Plus",
  de: "Werkzeuggrün",
  en: "Tool green",
  nl: "Gereedschap groen",
  fr: "Vert outil"
}, {
  hex: "#99978e",
  code: "100 60 05",
  scope: "Design System Plus",
  de: "Rauchgraugrün",
  en: "Smoky grey green",
  nl: "Rokerig grijsgroen",
  fr: "Vert fumé"
}, {
  hex: "#979483",
  code: "100 60 10",
  scope: "Design System Plus",
  de: "Olivingrau",
  en: "Olivine grey",
  nl: "Olijfgrijs",
  fr: "Gris olivine"
}, {
  hex: "#9d9776",
  code: "100 60 20",
  scope: "Design System Plus",
  de: "Grauspechtgrün",
  en: "Grey-headed woodpecker green",
  nl: "Grijs espengroen",
  fr: "Vert pitch gris"
}, {
  hex: "#9d9664",
  code: "100 60 30",
  scope: "Design System Plus",
  de: "Kardamomgrün",
  en: "Cardamom green",
  nl: "Kardemom groen",
  fr: "Vert cardamome"
}, {
  hex: "#9f9857",
  code: "100 60 40",
  scope: "Design System Plus",
  de: "Salatgrün",
  en: "Lettuce green",
  nl: "Saladegroenten",
  fr: "Vert de laitue"
}, {
  hex: "#9f9946",
  code: "100 60 50",
  scope: "Design System Plus",
  de: "Artnouveaugrün",
  en: "Art Nouveau green",
  nl: "Artnouveau groen",
  fr: "Artnouveauvert"
}, {
  hex: "#9b9532",
  code: "100 60 60",
  scope: "Design System Plus",
  de: "Smoothiegrün",
  en: "Smoothie green",
  nl: "Smoothie groen",
  fr: "Vert smoothie"
}, {
  hex: "#b3b1a8",
  code: "100 70 05",
  scope: "Design System Plus",
  de: "Rauchweiß",
  en: "Smoky white",
  nl: "Rookwit",
  fr: "Blanc fumé"
}, {
  hex: "#b4b09e",
  code: "100 70 10",
  scope: "Design System Plus",
  de: "Anisgraugelb",
  en: "Anise grey yellow",
  nl: "Anijs grijs geel",
  fr: "Jaune anis"
}, {
  hex: "#b6b08d",
  code: "100 70 20",
  scope: "Design System Plus",
  de: "Sandbraun",
  en: "Sand brown",
  nl: "Zandbruin",
  fr: "Marron sable"
}, {
  hex: "#b6b07b",
  code: "100 70 30",
  scope: "Design System Plus",
  de: "Hippiegrün",
  en: "Hippie green",
  nl: "Hippie groen",
  fr: "Vert hippie"
}, {
  hex: "#bab26c",
  code: "100 70 40",
  scope: "Design System Plus",
  de: "Lindgrün",
  en: "Linden green",
  nl: "Limoengroen",
  fr: "Vert tilleul"
}, {
  hex: "#b8af57",
  code: "100 70 50",
  scope: "Design System Plus",
  de: "Dillgrün",
  en: "Dill green",
  nl: "Dille groen",
  fr: "Vert aneth"
}, {
  hex: "#b6af44",
  code: "100 70 60",
  scope: "Design System Plus",
  de: "Neugrün",
  en: "New green",
  nl: "Nieuw groen",
  fr: "Vert nouveau"
}, {
  hex: "#cac9bf",
  code: "100 80 05",
  scope: "Design System Plus",
  de: "Naturgrau",
  en: "Natural grey",
  nl: "Natuurlijk grijs",
  fr: "Gris naturel"
}, {
  hex: "#cecab5",
  code: "100 80 10",
  scope: "Design System Plus",
  de: "Blassbeige",
  en: "Pale beige",
  nl: "Licht beige",
  fr: "Beige pâle"
}, {
  hex: "#d4cca7",
  code: "100 80 20",
  scope: "Design System Plus",
  de: "Weichgrün",
  en: "Soft green",
  nl: "Zacht groen",
  fr: "Vert tendre"
}, {
  hex: "#d3ca93",
  code: "100 80 30",
  scope: "Design System Plus",
  de: "Silbergrün",
  en: "Silver green",
  nl: "Zilvergroen",
  fr: "Vert argenté"
}, {
  hex: "#d4cb81",
  code: "100 80 40",
  scope: "Design System Plus",
  de: "Märztulpengrün",
  en: "March tulip green",
  nl: "Maart tulp groen",
  fr: "Vert tulipe de mars"
}, {
  hex: "#d4cb6e",
  code: "100 80 50",
  scope: "Design System Plus",
  de: "Leichtoliv",
  en: "Light olive",
  nl: "Licht olijf",
  fr: "Olive légère"
}, {
  hex: "#d9cd5b",
  code: "100 80 60",
  scope: "Design System Plus",
  de: "Reklamegrün",
  en: "Advertisement green",
  nl: "Groen adverteren",
  fr: "Vert de la publicité"
}, {
  hex: "#d8cd48",
  code: "100 80 70",
  scope: "Design System Plus",
  de: "LEDgrün",
  en: "LED green",
  nl: "LED groen",
  fr: "LED verte"
}, {
  hex: "#d5ce33",
  code: "100 80 80",
  scope: "Design System Plus",
  de: "Märzgrün",
  en: "March green",
  nl: "Maart groen",
  fr: "Vert mars"
}, {
  hex: "#d9d7cd",
  code: "100 85 05",
  scope: "Design System Plus",
  de: "Sellerieweiß",
  en: "Celery white",
  nl: "Selderij wit",
  fr: "Blanc de céleri"
}, {
  hex: "#dbd6c2",
  code: "100 85 10",
  scope: "Design System Plus",
  de: "Palmherzencreme",
  en: "Palm heart cream",
  nl: "Palmhartcrème",
  fr: "Crème de cœur de palmier"
}, {
  hex: "#ddd6b0",
  code: "100 85 20",
  scope: "Design System Plus",
  de: "Beigegrün",
  en: "Beige green",
  nl: "Beige groen",
  fr: "Vert beige"
}, {
  hex: "#e1d7a0",
  code: "100 85 30",
  scope: "Design System Plus",
  de: "Kristallgelb",
  en: "Crystal yellow",
  nl: "Kristalgeel",
  fr: "Jaune cristal"
}, {
  hex: "#e8e5d9",
  code: "100 90 05",
  scope: "Design System Plus",
  de: "Brillantgelb",
  en: "Brilliant yellow",
  nl: "Briljant geel",
  fr: "Jaune brillant"
}, {
  hex: "#eae5d1",
  code: "100 90 10",
  scope: "Design System Plus",
  de: "Holunderweiß",
  en: "Elderberry white",
  nl: "Vlierbes wit",
  fr: "Blanc sureau"
}, {
  hex: "#eee5bf",
  code: "100 90 20",
  scope: "Design System Plus",
  de: "Designercremegelb",
  en: "Designer cream yellow",
  nl: "Designer crème geel",
  fr: "Jaune crème de designer"
}, {
  hex: "#eee4aa",
  code: "100 90 30",
  scope: "Design System Plus",
  de: "Buchsbaumgelb",
  en: "Boxwood yellow",
  nl: "Buxus geel",
  fr: "Jaune buis"
}, {
  hex: "#f3e699",
  code: "100 90 40",
  scope: "Design System Plus",
  de: "Primelgelb",
  en: "Primrose yellow",
  nl: "Primula geel",
  fr: "Jaune primevère"
}, {
  hex: "#f1e586",
  code: "100 90 50",
  scope: "Design System Plus",
  de: "Frühlingsgelb",
  en: "Spring yellow",
  nl: "Lente geel",
  fr: "Jaune printemps"
}, {
  hex: "#efede3",
  code: "100 93 05",
  scope: "Design System Plus",
  de: "Nebelweiß",
  en: "Fog white",
  nl: "Mistig wit",
  fr: "Blanc de brume"
}, {
  hex: "#484840",
  code: "110 20 10",
  scope: "Design System Plus",
  de: "Metallbaugrün",
  en: "Metal construction green",
  nl: "Metalen constructie groen",
  fr: "Vert construction métallique"
}, {
  hex: "#57574c",
  code: "110 30 10",
  scope: "Design System Plus",
  de: "Dunkelolivgrün",
  en: "Dark olive green",
  nl: "Donker olijfgroen",
  fr: "Vert olive foncé"
}, {
  hex: "#585945",
  code: "110 30 20",
  scope: "Design System Plus",
  de: "Norialgenschwarzgrün",
  en: "Nori seaweed green",
  nl: "Norialgen zwart groen",
  fr: "Vert norialgen noir"
}, {
  hex: "#6a6b5d",
  code: "110 40 10",
  scope: "Design System Plus",
  de: "Stumpfgrün",
  en: "Stump green",
  nl: "Stomp groen",
  fr: "Vert terne"
}, {
  hex: "#67694d",
  code: "110 40 20",
  scope: "Design System Plus",
  de: "Antikgrün",
  en: "Antique green",
  nl: "Antiek groen",
  fr: "Vert antique"
}, {
  hex: "#696c46",
  code: "110 40 30",
  scope: "Design System Plus",
  de: "Gärtnergrün",
  en: "Gardener green",
  nl: "Groen van de tuinman",
  fr: "Vert jardinier"
}, {
  hex: "#686e3c",
  code: "110 40 40",
  scope: "Design System Plus",
  de: "Kirchnergrün",
  en: "Kirchner green",
  nl: "Kersengroen",
  fr: "Vert cerise"
}, {
  hex: "#7f7f70",
  code: "110 50 10",
  scope: "Design System Plus",
  de: "Novembergrün",
  en: "November green",
  nl: "November groen",
  fr: "Vert novembre"
}, {
  hex: "#7e8061",
  code: "110 50 20",
  scope: "Design System Plus",
  de: "Alexandritgrün",
  en: "Alexandrite green",
  nl: "Alexandriet groen",
  fr: "Vert alexandrite"
}, {
  hex: "#7d8153",
  code: "110 50 30",
  scope: "Design System Plus",
  de: "Pflanzengrün",
  en: "Plant green",
  nl: "Plant groen",
  fr: "Vert végétal"
}, {
  hex: "#7b8244",
  code: "110 50 40",
  scope: "Design System Plus",
  de: "Reifegrün",
  en: "Ripe green",
  nl: "Rijp groen",
  fr: "Vert mûr"
}, {
  hex: "#79833a",
  code: "110 50 50",
  scope: "Design System Plus",
  de: "Portugalgrün",
  en: "Portuguese green",
  nl: "Portugal groen",
  fr: "Vert Portugal"
}, {
  hex: "#798533",
  code: "110 50 55",
  scope: "Design System Plus",
  de: "Flaggengrün",
  en: "Flag green",
  nl: "Vlag groen",
  fr: "Vert drapeau"
}, {
  hex: "#959685",
  code: "110 60 10",
  scope: "Design System Plus",
  de: "Graugrün",
  en: "Grey green",
  nl: "Grijsgroen",
  fr: "Vert gris"
}, {
  hex: "#939777",
  code: "110 60 20",
  scope: "Design System Plus",
  de: "Erbsenschotengrün",
  en: "Peapod green",
  nl: "Erwtenpeul groen",
  fr: "Vert des cosses de pois"
}, {
  hex: "#969a69",
  code: "110 60 30",
  scope: "Design System Plus",
  de: "Indischgrün",
  en: "Indian green",
  nl: "Indiaas groen",
  fr: "Vert indien"
}, {
  hex: "#929a58",
  code: "110 60 40",
  scope: "Design System Plus",
  de: "Blatterbsengrün",
  en: "Winterpea green",
  nl: "Blad erwtgroen",
  fr: "Vert pois de senteur"
}, {
  hex: "#909c49",
  code: "110 60 50",
  scope: "Design System Plus",
  de: "Airlinegrün",
  en: "Airline green",
  nl: "Groene luchtvaartmaatschappij",
  fr: "Vert Airline"
}, {
  hex: "#909f3b",
  code: "110 60 60",
  scope: "Design System Plus",
  de: "Waldmeistergrün",
  en: "Woodruff green",
  nl: "Bosgroen",
  fr: "Vert sylvestre"
}, {
  hex: "#91a033",
  code: "110 60 65",
  scope: "Design System Plus",
  de: "Ampelgrün",
  en: "Traffic light green",
  nl: "Verkeerslicht groen",
  fr: "Vert feu de signalisation"
}, {
  hex: "#b0b19e",
  code: "110 70 10",
  scope: "Design System Plus",
  de: "Chinateegrün",
  en: "Chinese tea green",
  nl: "China groen",
  fr: "Vert chinois"
}, {
  hex: "#afb28e",
  code: "110 70 20",
  scope: "Design System Plus",
  de: "Wandgrün",
  en: "Wall green",
  nl: "Muur groen",
  fr: "Vert mural"
}, {
  hex: "#acb17d",
  code: "110 70 30",
  scope: "Design System Plus",
  de: "Wasabigrün",
  en: "Wasabi green",
  nl: "Wasabi groen",
  fr: "Vert wasabi"
}, {
  hex: "#acb46e",
  code: "110 70 40",
  scope: "Design System Plus",
  de: "Aprilgrün",
  en: "April green",
  nl: "April groen",
  fr: "Vert d'avril"
}, {
  hex: "#acb65d",
  code: "110 70 50",
  scope: "Design System Plus",
  de: "Delaunaygrün",
  en: "Delaunay green",
  nl: "Delaunay groen",
  fr: "Vert Delaunay"
}, {
  hex: "#a8b64c",
  code: "110 70 60",
  scope: "Design System Plus",
  de: "Limettengrün",
  en: "Lime green",
  nl: "Limoengroen",
  fr: "Vert citron"
}, {
  hex: "#a1b62b",
  code: "110 70 70",
  scope: "Design System Plus",
  de: "Chlorophyllgrün",
  en: "Chlorophyll green",
  nl: "Groen chlorofyl",
  fr: "Vert chlorophylle"
}, {
  hex: "#a0b42d",
  code: "110 70 77",
  scope: "Design System Plus",
  de: "Markergrün",
  en: "Marker green",
  nl: "Markeerstift groen",
  fr: "Vert marqueur"
}, {
  hex: "#c7c9b7",
  code: "110 80 10",
  scope: "Design System Plus",
  de: "Frühlingsgrau",
  en: "Spring grey",
  nl: "Lente grijs",
  fr: "Gris printemps"
}, {
  hex: "#cbcca7",
  code: "110 80 20",
  scope: "Design System Plus",
  de: "Minzeisgrün",
  en: "Mint ice green",
  nl: "Mint ijsgroen",
  fr: "Vert menthe à l'eau"
}, {
  hex: "#c9ce95",
  code: "110 80 30",
  scope: "Design System Plus",
  de: "Lenzgrün",
  en: "Springtide green",
  nl: "Lenzgrün",
  fr: "Vert Lenz"
}, {
  hex: "#c7cf84",
  code: "110 80 40",
  scope: "Design System Plus",
  de: "Limettensorbetgrün",
  en: "Lime sorbet green",
  nl: "Linde sorbetgroen",
  fr: "Vert sorbet citron vert"
}, {
  hex: "#c8d172",
  code: "110 80 50",
  scope: "Design System Plus",
  de: "Ostergrün",
  en: "Easter green",
  nl: "Paasgroen",
  fr: "Vert de Pâques"
}, {
  hex: "#c4d160",
  code: "110 80 60",
  scope: "Design System Plus",
  de: "Clowngrün",
  en: "Clown green",
  nl: "Clown groen",
  fr: "Vert clown"
}, {
  hex: "#c2d24c",
  code: "110 80 70",
  scope: "Design System Plus",
  de: "Saftgrün",
  en: "Juice green",
  nl: "Sap groen",
  fr: "Vert jus"
}, {
  hex: "#d5d6c3",
  code: "110 85 10",
  scope: "Design System Plus",
  de: "Veltlinerweiß",
  en: "Veltliner white",
  nl: "Veltliner wit",
  fr: "Blanc de veltliner"
}, {
  hex: "#d5d7b1",
  code: "110 85 20",
  scope: "Design System Plus",
  de: "Kohlrabigrün",
  en: "Kohlrabi green",
  nl: "Koolrabi groen",
  fr: "Vert chou-rave"
}, {
  hex: "#d7daa1",
  code: "110 85 30",
  scope: "Design System Plus",
  de: "Burgundergrau",
  en: "Burgundy grey",
  nl: "Bourgondisch grijs",
  fr: "Gris bourgogne"
}, {
  hex: "#d5da8e",
  code: "110 85 40",
  scope: "Design System Plus",
  de: "Wachsgrün",
  en: "Wax green",
  nl: "Was groen",
  fr: "Vert cire"
}, {
  hex: "#d2da7a",
  code: "110 85 50",
  scope: "Design System Plus",
  de: "Sprossengrün",
  en: "Sprout green",
  nl: "Kiemgroen",
  fr: "Vert pousses"
}, {
  hex: "#e4e2d7",
  code: "110 90 05",
  scope: "Design System Plus",
  de: "Baumwollweiß",
  en: "Cotton white",
  nl: "Katoen wit",
  fr: "Blanc coton"
}, {
  hex: "#e6e6d2",
  code: "110 90 10",
  scope: "Design System Plus",
  de: "Farnhellgrün",
  en: "Light fern green",
  nl: "Varen lichtgroen",
  fr: "Vert fougère clair"
}, {
  hex: "#e6e7bf",
  code: "110 90 20",
  scope: "Design System Plus",
  de: "Lilienduftgrün",
  en: "Lily scent green",
  nl: "Leliegeurend groen",
  fr: "Vert parfum de lys"
}, {
  hex: "#e5e7ac",
  code: "110 90 30",
  scope: "Design System Plus",
  de: "Kiwieisgrün",
  en: "Kiwi ice cream green",
  nl: "Kiwi ijsgroen",
  fr: "Vert kiwi"
}, {
  hex: "#e4e99b",
  code: "110 90 40",
  scope: "Design System Plus",
  de: "Limettensaftgrün",
  en: "Lime juice green",
  nl: "Limoensap groen",
  fr: "Vert jus de citron vert"
}, {
  hex: "#ebebe1",
  code: "110 93 05",
  scope: "Design System Plus",
  de: "Bastweiß",
  en: "Raffia white",
  nl: "Bast wit",
  fr: "Blanc bâtard"
}, {
  hex: "#f4f3ef",
  code: "110 96 02",
  scope: "Design System Plus",
  de: "Waschweiß",
  en: "Laundry white",
  nl: "Wit wassen",
  fr: "Blanc de lavage"
}, {
  hex: "#545650",
  code: "120 30 05",
  scope: "Design System Plus",
  de: "Racinggrün",
  en: "Racing green",
  nl: "Racegroen",
  fr: "Vert Racing"
}, {
  hex: "#53574b",
  code: "120 30 10",
  scope: "Design System Plus",
  de: "Landhausgrün",
  en: "Country house green",
  nl: "Landhuis groen",
  fr: "Vert campagne"
}, {
  hex: "#515842",
  code: "120 30 20",
  scope: "Design System Plus",
  de: "Avocadodunkelgrün",
  en: "Avocado dark green",
  nl: "Avocado donkergroen",
  fr: "Vert foncé d'avocat"
}, {
  hex: "#686962",
  code: "120 40 05",
  scope: "Design System Plus",
  de: "Englischgrün",
  en: "English green",
  nl: "Engels groen",
  fr: "Vert anglais"
}, {
  hex: "#66695b",
  code: "120 40 10",
  scope: "Design System Plus",
  de: "Mandelgrün",
  en: "Almond green",
  nl: "Amandelgroen",
  fr: "Vert amande"
}, {
  hex: "#636b51",
  code: "120 40 20",
  scope: "Design System Plus",
  de: "Kaktusgrün",
  en: "Cactus green",
  nl: "Cactusgroen",
  fr: "Vert cactus"
}, {
  hex: "#626e48",
  code: "120 40 30",
  scope: "Design System Plus",
  de: "Basilikumgrün",
  en: "Basil green",
  nl: "Basilicumgroen",
  fr: "Vert basilic"
}, {
  hex: "#5c703b",
  code: "120 40 40",
  scope: "Design System Plus",
  de: "Paprikagrün",
  en: "Pepper green",
  nl: "Paprikagroen",
  fr: "Vert de paprika"
}, {
  hex: "#7e7f77",
  code: "120 50 05",
  scope: "Design System Plus",
  de: "Rauchgrün",
  en: "Smoke green",
  nl: "Rookgroen",
  fr: "Vert fumée"
}, {
  hex: "#7b8071",
  code: "120 50 10",
  scope: "Design System Plus",
  de: "Samtgrüngrau",
  en: "Velvet green grey",
  nl: "Fluweelgroen grijs",
  fr: "Gris vert velours"
}, {
  hex: "#788262",
  code: "120 50 20",
  scope: "Design System Plus",
  de: "Papageiengrün",
  en: "Parrot green",
  nl: "Papegaaiengroen",
  fr: "Vert perroquet"
}, {
  hex: "#758254",
  code: "120 50 30",
  scope: "Design System Plus",
  de: "Quarzgrün",
  en: "Quartz green",
  nl: "Kwartsgroen",
  fr: "Vert quartz"
}, {
  hex: "#72864c",
  code: "120 50 40",
  scope: "Design System Plus",
  de: "Heckengrün",
  en: "Hedge green",
  nl: "Heggengroen",
  fr: "Feuillage des haies"
}, {
  hex: "#6c863e",
  code: "120 50 50",
  scope: "Design System Plus",
  de: "Birkenblattgrün",
  en: "Birch leaf green",
  nl: "Berkenblad groen",
  fr: "Vert feuille de bouleau"
}, {
  hex: "#979a90",
  code: "120 60 05",
  scope: "Design System Plus",
  de: "Bläulichgrau",
  en: "Bluish grey",
  nl: "Blauwachtig grijs",
  fr: "Gris bleuté"
}, {
  hex: "#929787",
  code: "120 60 10",
  scope: "Design System Plus",
  de: "Lavendelblattgrün",
  en: "Lavender leaf green",
  nl: "Lavendelblad groen",
  fr: "Vert feuille de lavande"
}, {
  hex: "#909978",
  code: "120 60 20",
  scope: "Design System Plus",
  de: "Mostbirnengrün",
  en: "Cider pear green",
  nl: "Cider peer groen",
  fr: "Vert poire à cidre"
}, {
  hex: "#8c9d6b",
  code: "120 60 30",
  scope: "Design System Plus",
  de: "Vesuviangrün",
  en: "Vesuvian green",
  nl: "Vesuviaans groen",
  fr: "Vert vesuviane"
}, {
  hex: "#899f5d",
  code: "120 60 40",
  scope: "Design System Plus",
  de: "Bambusgrasgrün",
  en: "Bamboo grass green",
  nl: "Bamboegras groen",
  fr: "Vert herbe de bambou"
}, {
  hex: "#83a04d",
  code: "120 60 50",
  scope: "Design System Plus",
  de: "Aloeveragrün",
  en: "Aloe vera green",
  nl: "Aloë vera groen",
  fr: "Vert aloès"
}, {
  hex: "#7da03e",
  code: "120 60 60",
  scope: "Design System Plus",
  de: "Mambagrün",
  en: "Mamba green",
  nl: "Mambagroen",
  fr: "Vert Mamba"
}, {
  hex: "#7ca23d",
  code: "120 60 63",
  scope: "Design System Plus",
  de: "Leuchtendgrün",
  en: "Luminescent green",
  nl: "Lichtgevend groen",
  fr: "Vert vif"
}, {
  hex: "#afb1a7",
  code: "120 70 05",
  scope: "Design System Plus",
  de: "Lorbeergrau",
  en: "Laurel grey",
  nl: "Laurier grijs",
  fr: "Gris laurier"
}, {
  hex: "#acb19e",
  code: "120 70 10",
  scope: "Design System Plus",
  de: "Nilgrün",
  en: "Nile green",
  nl: "Nijlgroen",
  fr: "Vert Nil"
}, {
  hex: "#a8b38f",
  code: "120 70 20",
  scope: "Design System Plus",
  de: "Filigrangrün",
  en: "Filigree green",
  nl: "Filigraan groen",
  fr: "Vert filigrane"
}, {
  hex: "#a6b682",
  code: "120 70 30",
  scope: "Design System Plus",
  de: "Serpentingrün",
  en: "Serpentine green",
  nl: "Serpentijn groen",
  fr: "Vert serpentin"
}, {
  hex: "#a1b872",
  code: "120 70 40",
  scope: "Design System Plus",
  de: "Birkenhellgrün",
  en: "Light birch green",
  nl: "Berk lichtgroen",
  fr: "Bouleau vert clair"
}, {
  hex: "#9cb960",
  code: "120 70 50",
  scope: "Design System Plus",
  de: "Waldrebengrün",
  en: "Clematis green",
  nl: "Clematissen groen",
  fr: "Vert saule des bois"
}, {
  hex: "#95b751",
  code: "120 70 60",
  scope: "Design System Plus",
  de: "Turmalingrün",
  en: "Tourmaline green",
  nl: "Toermalijn groen",
  fr: "Vert tourmaline"
}, {
  hex: "#92bc42",
  code: "120 70 70",
  scope: "Design System Plus",
  de: "Cocktailgrün",
  en: "Cocktail green",
  nl: "Cocktail groen",
  fr: "Vert cocktail"
}, {
  hex: "#8db836",
  code: "120 70 75",
  scope: "Design System Plus",
  de: "Brillantgrün",
  en: "Brilliant green",
  nl: "Briljant groen",
  fr: "Vert brillant"
}, {
  hex: "#c8cbc1",
  code: "120 80 05",
  scope: "Design System Plus",
  de: "Staubgrün",
  en: "Dust green",
  nl: "Stof groen",
  fr: "Vert poussière"
}, {
  hex: "#c5cab6",
  code: "120 80 10",
  scope: "Design System Plus",
  de: "Jugendstilgrün",
  en: "Modern Style green",
  nl: "Art Nouveau groen",
  fr: "Vert art nouveau"
}, {
  hex: "#c4cea9",
  code: "120 80 20",
  scope: "Design System Plus",
  de: "Avocadocreme",
  en: "Avocado cream",
  nl: "Avocadocrème",
  fr: "Crème d'avocat"
}, {
  hex: "#becf97",
  code: "120 80 30",
  scope: "Design System Plus",
  de: "Naturgrün",
  en: "Natural green",
  nl: "Natuurlijk groen",
  fr: "Vert naturel"
}, {
  hex: "#bbd289",
  code: "120 80 40",
  scope: "Design System Plus",
  de: "Sommergrün",
  en: "Summer green",
  nl: "Zomergroen",
  fr: "Vert d'été"
}, {
  hex: "#b6d478",
  code: "120 80 50",
  scope: "Design System Plus",
  de: "Modegrün",
  en: "Fashion green",
  nl: "Groene mode",
  fr: "Vert mode"
}, {
  hex: "#b1d669",
  code: "120 80 60",
  scope: "Design System Plus",
  de: "Neongrün",
  en: "Neon green",
  nl: "Neongroen",
  fr: "Vert fluo"
}, {
  hex: "#d4d6cc",
  code: "120 85 05",
  scope: "Design System Plus",
  de: "Kreidegrün",
  en: "Chalk green",
  nl: "Krijtgroen",
  fr: "Vert craie"
}, {
  hex: "#d1d7c4",
  code: "120 85 10",
  scope: "Design System Plus",
  de: "Federleichtgrün",
  en: "Light feather green",
  nl: "Vederlicht groen",
  fr: "Vert plume"
}, {
  hex: "#d0dab4",
  code: "120 85 20",
  scope: "Design System Plus",
  de: "Seegrün",
  en: "Lake green",
  nl: "Zeegroen",
  fr: "Vert de mer"
}, {
  hex: "#ccdba2",
  code: "120 85 30",
  scope: "Design System Plus",
  de: "Aquagrün",
  en: "Aqua green",
  nl: "Aqua groen",
  fr: "Vert aqua"
}, {
  hex: "#e2e4d9",
  code: "120 90 05",
  scope: "Design System Plus",
  de: "Maiglöckchenweiß",
  en: "Lily of the valley white",
  nl: "Lelietje-van-dalen wit",
  fr: "Blanc muguet"
}, {
  hex: "#e4e7d3",
  code: "120 90 10",
  scope: "Design System Plus",
  de: "Hellpistazie",
  en: "Pale pistachio",
  nl: "Lichte pistache",
  fr: "Pistache claire"
}, {
  hex: "#dee8c2",
  code: "120 90 20",
  scope: "Design System Plus",
  de: "Kiwisorbetgrün",
  en: "Kiwi sorbet green",
  nl: "Kiwisorbet groen",
  fr: "Vert kiwi"
}, {
  hex: "#daebb1",
  code: "120 90 30",
  scope: "Design System Plus",
  de: "Eiskaltgrün",
  en: "Ice-cold green",
  nl: "IJskoud groen",
  fr: "Vert glacé"
}, {
  hex: "#e9ece1",
  code: "120 93 05",
  scope: "Design System Plus",
  de: "Hauchweißgrün",
  en: "Touch of white green",
  nl: "Gebroken wit groen",
  fr: "Vert pâle blanc"
}, {
  hex: "#53584d",
  code: "130 30 10",
  scope: "Design System Plus",
  de: "Aramealgengrün",
  en: "Arame seaweed green",
  nl: "Arameal groen",
  fr: "Vert algue araméenne"
}, {
  hex: "#4e5945",
  code: "130 30 20",
  scope: "Design System Plus",
  de: "Seetanggrün",
  en: "Kelp green",
  nl: "Zeewier groen",
  fr: "Vert algue"
}, {
  hex: "#666c5f",
  code: "130 40 10",
  scope: "Design System Plus",
  de: "Sanftoliv",
  en: "Soft olive",
  nl: "Zachte olijf",
  fr: "Sanftoliv"
}, {
  hex: "#5d6c53",
  code: "130 40 20",
  scope: "Design System Plus",
  de: "Alpenseegrün",
  en: "Alpine lake green",
  nl: "Alpenmeer groen",
  fr: "Vert des Alpes"
}, {
  hex: "#5a6f4b",
  code: "130 40 30",
  scope: "Design System Plus",
  de: "Edelsteingrün",
  en: "Gemstone green",
  nl: "Edelsteen groen",
  fr: "Vert pierre précieuse"
}, {
  hex: "#788072",
  code: "130 50 10",
  scope: "Design System Plus",
  de: "Dubuffetgrün",
  en: "Dubuffet green",
  nl: "Dubuffet groen",
  fr: "Vert Dubuffet"
}, {
  hex: "#758468",
  code: "130 50 20",
  scope: "Design System Plus",
  de: "Spanischgrün",
  en: "Spanish green",
  nl: "Spaans groen",
  fr: "Vert espagnol"
}, {
  hex: "#6c855b",
  code: "130 50 30",
  scope: "Design System Plus",
  de: "Algengrün",
  en: "Algae green",
  nl: "Algen groen",
  fr: "Vert algue"
}, {
  hex: "#65884f",
  code: "130 50 40",
  scope: "Design System Plus",
  de: "Peperonigrün",
  en: "Hot pepper green",
  nl: "Pepperoni groen",
  fr: "Vert poivron"
}, {
  hex: "#5d8947",
  code: "130 50 50",
  scope: "Design System Plus",
  de: "Smaragdklargrün",
  en: "Emerald clear green",
  nl: "Smaragd helder groen",
  fr: "Vert émeraude clair"
}, {
  hex: "#909989",
  code: "130 60 10",
  scope: "Design System Plus",
  de: "Salbeimattgrün",
  en: "Matte sage green",
  nl: "Saliegroen",
  fr: "Vert imitation sauge"
}, {
  hex: "#8a9b7d",
  code: "130 60 20",
  scope: "Design System Plus",
  de: "Altgrün",
  en: "Old green",
  nl: "Oud groen",
  fr: "Vieux vert"
}, {
  hex: "#839d71",
  code: "130 60 30",
  scope: "Design System Plus",
  de: "Erbsauberginengrün",
  en: "Pea aubergine green",
  nl: "Erwt aubergine groen",
  fr: "Vert aubergine de pois"
}, {
  hex: "#7c9f64",
  code: "130 60 40",
  scope: "Design System Plus",
  de: "Grashüpfergrün",
  en: "Grasshopper green",
  nl: "Sprinkhaan groen",
  fr: "Vert sauterelle"
}, {
  hex: "#74a256",
  code: "130 60 50",
  scope: "Design System Plus",
  de: "Parisergrün",
  en: "Parisian green",
  nl: "Parijs groen",
  fr: "Vert parisien"
}, {
  hex: "#69a449",
  code: "130 60 60",
  scope: "Design System Plus",
  de: "Urgrün",
  en: "Primal green",
  nl: "Oergroen",
  fr: "Vert primitif"
}, {
  hex: "#a9b3a3",
  code: "130 70 10",
  scope: "Design System Plus",
  de: "Kalkgrün",
  en: "Limestone green",
  nl: "Limoengroen",
  fr: "Vert chaux"
}, {
  hex: "#a4b695",
  code: "130 70 20",
  scope: "Design System Plus",
  de: "Seifengrün",
  en: "Soap green",
  nl: "Zeep groen",
  fr: "Vert sapin"
}, {
  hex: "#9bb787",
  code: "130 70 30",
  scope: "Design System Plus",
  de: "Aquarellgrün",
  en: "Watercolour green",
  nl: "Aquarel groen",
  fr: "Vert aquarelle"
}, {
  hex: "#94b979",
  code: "130 70 40",
  scope: "Design System Plus",
  de: "Vangoghgrün",
  en: "Vangogh green",
  nl: "Vangogh groen",
  fr: "Vert vangogh"
}, {
  hex: "#8dbc6e",
  code: "130 70 50",
  scope: "Design System Plus",
  de: "Apfelgrün",
  en: "Apple green",
  nl: "Appelgroen",
  fr: "Vert pomme"
}, {
  hex: "#84be5f",
  code: "130 70 60",
  scope: "Design System Plus",
  de: "Ultragrün",
  en: "Ultra green",
  nl: "Ultragroen",
  fr: "Ultra vert"
}, {
  hex: "#c3ccbb",
  code: "130 80 10",
  scope: "Design System Plus",
  de: "Jadehellgrün",
  en: "Jade light green",
  nl: "Jade lichtgroen",
  fr: "Vert jade clair"
}, {
  hex: "#bdcead",
  code: "130 80 20",
  scope: "Design System Plus",
  de: "Emaillegrün",
  en: "Enamel green",
  nl: "Groen email",
  fr: "Vert émail"
}, {
  hex: "#b6d1a0",
  code: "130 80 30",
  scope: "Design System Plus",
  de: "Pastellgrün",
  en: "Pastel green",
  nl: "Pastelgroen",
  fr: "Vert pastel"
}, {
  hex: "#afd592",
  code: "130 80 40",
  scope: "Design System Plus",
  de: "Jasmingrün",
  en: "Jasmine green",
  nl: "Jasmijngroen",
  fr: "Vert jasmin"
}, {
  hex: "#a7d683",
  code: "130 80 50",
  scope: "Design System Plus",
  de: "Kristallgrün",
  en: "Crystal green",
  nl: "Kristalgroen",
  fr: "Vert cristal"
}, {
  hex: "#d1d7cd",
  code: "130 85 05",
  scope: "Design System Plus",
  de: "Traubenölgrün",
  en: "Grape oil green",
  nl: "Druivenolie groen",
  fr: "Vert huile de raisin"
}, {
  hex: "#cfd9c6",
  code: "130 85 10",
  scope: "Design System Plus",
  de: "Duchamplichtgrün",
  en: "Duchamp light green",
  nl: "Duchamp lichtgroen",
  fr: "Vert lumière de Duchamp"
}, {
  hex: "#c9dbb8",
  code: "130 85 20",
  scope: "Design System Plus",
  de: "Bleichhellgrün",
  en: "Pallid light green",
  nl: "Lichtgroen",
  fr: "Vert pâle clair"
}, {
  hex: "#c5deac",
  code: "130 85 30",
  scope: "Design System Plus",
  de: "Viridingrün",
  en: "Viridine green",
  nl: "Viridian groen",
  fr: "Vert viridine"
}, {
  hex: "#e0e4da",
  code: "130 90 05",
  scope: "Design System Plus",
  de: "Silberpappelweiß",
  en: "Silver poplar white",
  nl: "Zilverpopulier wit",
  fr: "Blanc peuplier argenté"
}, {
  hex: "#e0e3d9",
  code: "130 90 10",
  scope: "Design System Plus",
  de: "Mediterrangrün",
  en: "Mediterranean green",
  nl: "Mediterraan groen",
  fr: "Vert Méditerranée"
}, {
  hex: "#d8e9c6",
  code: "130 90 20",
  scope: "Design System Plus",
  de: "Frühlingsgrün",
  en: "Spring green",
  nl: "Lentegroen",
  fr: "Vert printemps"
}, {
  hex: "#e8ece3",
  code: "130 93 05",
  scope: "Design System Plus",
  de: "Bohnenweiß",
  en: "Bean white",
  nl: "Bonen wit",
  fr: "Blanc de haricot"
}, {
  hex: "#454845",
  code: "140 20 05",
  scope: "Design System Plus",
  de: "Melanitschwarzgrün",
  en: "Melanite black green",
  nl: "Melaniet zwart-groen",
  fr: "Vert mélanite noir"
}, {
  hex: "#424941",
  code: "140 20 10",
  scope: "Design System Plus",
  de: "Gebirgsgrün",
  en: "Mountain range green",
  nl: "Berggroen",
  fr: "Vert montagne"
}, {
  hex: "#414b3e",
  code: "140 20 20",
  scope: "Design System Plus",
  de: "Bayrischgrün",
  en: "Bavarian green",
  nl: "Beiers groen",
  fr: "Vert de Bavière"
}, {
  hex: "#555954",
  code: "140 30 05",
  scope: "Design System Plus",
  de: "Schwarzwaldgrün",
  en: "Black Forest green",
  nl: "Zwarte Woud groen",
  fr: "Vert Forêt Noire"
}, {
  hex: "#51594f",
  code: "140 30 10",
  scope: "Design System Plus",
  de: "Kupferkiesgrün",
  en: "Copper pyrite green",
  nl: "Chalcopyriet groen",
  fr: "Vert cuivré"
}, {
  hex: "#4b5c48",
  code: "140 30 20",
  scope: "Design System Plus",
  de: "Brennnesselgrün",
  en: "Nettle green",
  nl: "Brandnetel groen",
  fr: "Vert d'ortie"
}, {
  hex: "#425e3f",
  code: "140 30 30",
  scope: "Design System Plus",
  de: "Edelkastaniengrün",
  en: "Chestnut green",
  nl: "Tamme kastanje groen",
  fr: "Vert châtaigne"
}, {
  hex: "#395e3c",
  code: "140 30 40",
  scope: "Design System Plus",
  de: "Förstergrün",
  en: "Ranger green",
  nl: "Förstergrün",
  fr: "Förstergrün"
}, {
  hex: "#676c66",
  code: "140 40 05",
  scope: "Design System Plus",
  de: "Steingrün",
  en: "Stone green",
  nl: "Steengroen",
  fr: "Vert pierre"
}, {
  hex: "#626c60",
  code: "140 40 10",
  scope: "Design System Plus",
  de: "Lodengrün",
  en: "Loden green",
  nl: "Loden groen",
  fr: "Vert loden"
}, {
  hex: "#586d55",
  code: "140 40 20",
  scope: "Design System Plus",
  de: "Akaziengrün",
  en: "Acacia green",
  nl: "Acaciagroen",
  fr: "Vert acacia"
}, {
  hex: "#51704c",
  code: "140 40 30",
  scope: "Design System Plus",
  de: "Pfaugrün",
  en: "Peacock green",
  nl: "Pauwgroen",
  fr: "Vert paon"
}, {
  hex: "#487547",
  code: "140 40 40",
  scope: "Design System Plus",
  de: "Radikalgrün",
  en: "Radical green",
  nl: "Radicaal groen",
  fr: "Vert radical"
}, {
  hex: "#407740",
  code: "140 40 50",
  scope: "Design System Plus",
  de: "Brasilgrün",
  en: "Brazilian green",
  nl: "Brazilië groen",
  fr: "Vert brésil"
}, {
  hex: "#7a8079",
  code: "140 50 05",
  scope: "Design System Plus",
  de: "Silberahorngrün",
  en: "Silver maple green",
  nl: "Groene zilveresdoorn",
  fr: "Vert érable argenté"
}, {
  hex: "#768174",
  code: "140 50 10",
  scope: "Design System Plus",
  de: "Edeltannengrün",
  en: "Fir spruce green",
  nl: "Zilverspar groen",
  fr: "Vert sapin noble"
}, {
  hex: "#6e8368",
  code: "140 50 20",
  scope: "Design System Plus",
  de: "Silberweidengrün",
  en: "Silver willow green",
  nl: "Zilver wilgengroen",
  fr: "Vert saule argenté"
}, {
  hex: "#65875f",
  code: "140 50 30",
  scope: "Design System Plus",
  de: "Wandergrün",
  en: "Rambling green",
  nl: "Groen wandelen",
  fr: "Vert de marche"
}, {
  hex: "#588853",
  code: "140 50 40",
  scope: "Design System Plus",
  de: "Guineagrün",
  en: "Guinean green",
  nl: "Guinea groen",
  fr: "Vert guinée"
}, {
  hex: "#4f8c4c",
  code: "140 50 50",
  scope: "Design System Plus",
  de: "Bergwiesengrün",
  en: "Mountain meadow green",
  nl: "Bergweide groen",
  fr: "Vert prairie de montagne"
}, {
  hex: "#408e42",
  code: "140 50 60",
  scope: "Design System Plus",
  de: "Temperamentgrün",
  en: "Temperamental green",
  nl: "Temperament groen",
  fr: "Vert de tempérament"
}, {
  hex: "#919791",
  code: "140 60 05",
  scope: "Design System Plus",
  de: "Camouflagegrün",
  en: "Camouflage green",
  nl: "Camouflagegroen",
  fr: "Vert camouflage"
}, {
  hex: "#8b9889",
  code: "140 60 10",
  scope: "Design System Plus",
  de: "Silberlindengrau",
  en: "Silver linden grey",
  nl: "Zilver limoengrijs",
  fr: "Gris tilleul argenté"
}, {
  hex: "#859e80",
  code: "140 60 20",
  scope: "Design System Plus",
  de: "Spinatgrün",
  en: "Spinach green",
  nl: "Spinazie groen",
  fr: "Vert des épinards"
}, {
  hex: "#7ba174",
  code: "140 60 30",
  scope: "Design System Plus",
  de: "Schwarzdorngrün",
  en: "Blackthorn green",
  nl: "Sleedoorn groen",
  fr: "Vert épine noire"
}, {
  hex: "#72a369",
  code: "140 60 40",
  scope: "Design System Plus",
  de: "Frischgrün",
  en: "Fresh green",
  nl: "Frisgroen",
  fr: "Vert frais"
}, {
  hex: "#64a45e",
  code: "140 60 50",
  scope: "Design System Plus",
  de: "Petersiliengrün",
  en: "Parsley green",
  nl: "Peterselie groen",
  fr: "Vert persil"
}, {
  hex: "#59a754",
  code: "140 60 60",
  scope: "Design System Plus",
  de: "Oreganogrün",
  en: "Oregano green",
  nl: "Oregano groen",
  fr: "Vert origan"
}, {
  hex: "#4aa74b",
  code: "140 60 70",
  scope: "Design System Plus",
  de: "Ballongrün",
  en: "Balloon green",
  nl: "Ballon groen",
  fr: "Vert ballon"
}, {
  hex: "#aab0a9",
  code: "140 70 05",
  scope: "Design System Plus",
  de: "Ginkgogrün",
  en: "Ginkgo green",
  nl: "Ginkgo groen",
  fr: "Vert ginkgo"
}, {
  hex: "#a3b1a3",
  code: "140 70 10",
  scope: "Design System Plus",
  de: "Wermutgrün",
  en: "Wormwood green",
  nl: "Alsem groen",
  fr: "Vert absinthe"
}, {
  hex: "#9cb697",
  code: "140 70 20",
  scope: "Design System Plus",
  de: "Taugrün",
  en: "Dew green",
  nl: "Dauwgroen",
  fr: "Vert de rosée"
}, {
  hex: "#91b98c",
  code: "140 70 30",
  scope: "Design System Plus",
  de: "Anisblattgrün",
  en: "Aniseed leaf green",
  nl: "Anijsblad groen",
  fr: "Vert feuille d'anis"
}, {
  hex: "#89bd80",
  code: "140 70 40",
  scope: "Design System Plus",
  de: "Sauergrün",
  en: "Sour green",
  nl: "Zuur groen",
  fr: "Vert acide"
}, {
  hex: "#7cbf74",
  code: "140 70 50",
  scope: "Design System Plus",
  de: "Acidgrün",
  en: "Acid green",
  nl: "Zuurgroen",
  fr: "Vert acide"
}, {
  hex: "#71c067",
  code: "140 70 60",
  scope: "Design System Plus",
  de: "Dropsgrün",
  en: "Drop green",
  nl: "Groen laten vallen",
  fr: "Dropsgrün"
}, {
  hex: "#c5ccc2",
  code: "140 80 05",
  scope: "Design System Plus",
  de: "Weidengrün",
  en: "Willow green",
  nl: "Wilgengroen",
  fr: "Vert saule"
}, {
  hex: "#bfccbc",
  code: "140 80 10",
  scope: "Design System Plus",
  de: "Pastellgraugrün",
  en: "Pastel grey green",
  nl: "Pastel grijsgroen",
  fr: "Vert gris pastel"
}, {
  hex: "#b6d0b0",
  code: "140 80 20",
  scope: "Design System Plus",
  de: "Giopontigrün",
  en: "Gio Ponti green",
  nl: "Gioponti groen",
  fr: "Vert Gioponti"
}, {
  hex: "#abd3a4",
  code: "140 80 30",
  scope: "Design System Plus",
  de: "Entspannungsgrün",
  en: "Relaxation green",
  nl: "Ontspannend groen",
  fr: "Vert de détente"
}, {
  hex: "#9dd697",
  code: "140 80 40",
  scope: "Design System Plus",
  de: "Dentistgrün",
  en: "Dentist green",
  nl: "Tandarts groen",
  fr: "Vert Dentist"
}, {
  hex: "#d0d8cf",
  code: "140 85 05",
  scope: "Design System Plus",
  de: "Taubnesselweiß",
  en: "Deadnettle white",
  nl: "Dode brandnetel wit",
  fr: "Blanc d'ortie"
}, {
  hex: "#ccdaca",
  code: "140 85 10",
  scope: "Design System Plus",
  de: "Lauchweiß",
  en: "Leek white",
  nl: "Prei wit",
  fr: "Blanc poireau"
}, {
  hex: "#c3debd",
  code: "140 85 20",
  scope: "Design System Plus",
  de: "Kalkschiefer",
  en: "Limestone slate",
  nl: "Kalkhoudende schalie",
  fr: "Schiste calcaire"
}, {
  hex: "#b6dfb0",
  code: "140 85 30",
  scope: "Design System Plus",
  de: "Minzcocktailgrün",
  en: "Mint cocktail green",
  nl: "Munt cocktail groen",
  fr: "Vert cocktail à la menthe"
}, {
  hex: "#e0e6db",
  code: "140 90 05",
  scope: "Design System Plus",
  de: "Rosmarinweiß",
  en: "Rosemary white",
  nl: "Rozemarijn wit",
  fr: "Blanc romarin"
}, {
  hex: "#dce8d6",
  code: "140 90 10",
  scope: "Design System Plus",
  de: "Hauchgrün",
  en: "Touch of green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#e8eee4",
  code: "140 93 05",
  scope: "Design System Plus",
  de: "Kastanienweiß",
  en: "Chestnut white",
  nl: "Kastanje wit",
  fr: "Blanc châtaigne"
}, {
  hex: "#515c53",
  code: "150 30 10",
  scope: "Design System Plus",
  de: "Thymiangrün",
  en: "Thyme green",
  nl: "Tijm groen",
  fr: "Vert thym"
}, {
  hex: "#475e4e",
  code: "150 30 20",
  scope: "Design System Plus",
  de: "Moselgrün",
  en: "Moselle green",
  nl: "Moezel groen",
  fr: "Vert Moselle"
}, {
  hex: "#3d5e46",
  code: "150 30 30",
  scope: "Design System Plus",
  de: "Berggrün",
  en: "Mountain green",
  nl: "Berggroen",
  fr: "Vert montagne"
}, {
  hex: "#616d63",
  code: "150 40 10",
  scope: "Design System Plus",
  de: "Filzgrün",
  en: "Felt green",
  nl: "Vilt groen",
  fr: "Vert feutre"
}, {
  hex: "#58715c",
  code: "150 40 20",
  scope: "Design System Plus",
  de: "Prallgrün",
  en: "Firm green",
  nl: "Invloed groen",
  fr: "Vert perle"
}, {
  hex: "#4a7254",
  code: "150 40 30",
  scope: "Design System Plus",
  de: "Genevergrün",
  en: "Genever green",
  nl: "Jenever groen",
  fr: "Vert genièvre"
}, {
  hex: "#3c744c",
  code: "150 40 40",
  scope: "Design System Plus",
  de: "Tintengrün",
  en: "Ink green",
  nl: "Inkt groen",
  fr: "Vert d'encre"
}, {
  hex: "#307649",
  code: "150 40 50",
  scope: "Design System Plus",
  de: "Irlandgrün",
  en: "Ireland green",
  nl: "Ierland groen",
  fr: "Vert Irlande"
}, {
  hex: "#738176",
  code: "150 50 10",
  scope: "Design System Plus",
  de: "Salbeigrüngrau",
  en: "Sage green grey",
  nl: "Saliegroen grijs",
  fr: "Gris vert sauge"
}, {
  hex: "#69866e",
  code: "150 50 20",
  scope: "Design System Plus",
  de: "Koreaminze",
  en: "Korean mint",
  nl: "Koreaanse munt",
  fr: "Menthe coréenne"
}, {
  hex: "#608866",
  code: "150 50 30",
  scope: "Design System Plus",
  de: "Feldgrün",
  en: "Field green",
  nl: "Veld groen",
  fr: "Vert champ"
}, {
  hex: "#518d63",
  code: "150 50 40",
  scope: "Design System Plus",
  de: "Selleriegrün",
  en: "Celery green",
  nl: "Selderij groen",
  fr: "Vert céleri"
}, {
  hex: "#3e8f58",
  code: "150 50 50",
  scope: "Design System Plus",
  de: "Sattgrün",
  en: "Rich green",
  nl: "Weelderig groen",
  fr: "Vert saturé"
}, {
  hex: "#239151",
  code: "150 50 60",
  scope: "Design System Plus",
  de: "Kaltgrün",
  en: "Cold green",
  nl: "Koud groen",
  fr: "Vert froid"
}, {
  hex: "#8c9b8e",
  code: "150 60 10",
  scope: "Design System Plus",
  de: "Spitzkohlgrün",
  en: "Pointed cabbage green",
  nl: "Spitskool groen",
  fr: "Chou pointu vert"
}, {
  hex: "#7f9e86",
  code: "150 60 20",
  scope: "Design System Plus",
  de: "Orientgrün",
  en: "Orient green",
  nl: "Oosters groen",
  fr: "Vert d'Orient"
}, {
  hex: "#73a07d",
  code: "150 60 30",
  scope: "Design System Plus",
  de: "Rosmaringrün",
  en: "Rosemary green",
  nl: "Rozemarijn groen",
  fr: "Vert romarin"
}, {
  hex: "#65a474",
  code: "150 60 40",
  scope: "Design System Plus",
  de: "Mosaikgrün",
  en: "Mosaic green",
  nl: "Mozaïek groen",
  fr: "Vert mosaïque"
}, {
  hex: "#58a96f",
  code: "150 60 50",
  scope: "Design System Plus",
  de: "Flummigrün",
  en: "Bouncy ball green",
  nl: "Flodderig groen",
  fr: "Vert fluo"
}, {
  hex: "#3aa861",
  code: "150 60 60",
  scope: "Design System Plus",
  de: "Energiegrün",
  en: "Energy green",
  nl: "Groene energie",
  fr: "Vert d'énergie"
}, {
  hex: "#a3b3a6",
  code: "150 70 10",
  scope: "Design System Plus",
  de: "Teegrün",
  en: "Tea green",
  nl: "Groene thee",
  fr: "Vert thé"
}, {
  hex: "#98b89f",
  code: "150 70 20",
  scope: "Design System Plus",
  de: "Liebermanngrün",
  en: "Liebermann green",
  nl: "Liebermann groen",
  fr: "Vert Liebermann"
}, {
  hex: "#8abd95",
  code: "150 70 30",
  scope: "Design System Plus",
  de: "Wachstuchgrün",
  en: "Oilcloth green",
  nl: "Tafelzeil groen",
  fr: "Toile cirée verte"
}, {
  hex: "#7cbe8c",
  code: "150 70 40",
  scope: "Design System Plus",
  de: "Jadesteingrün",
  en: "Jade stone green",
  nl: "Jade steen groen",
  fr: "Vert jade"
}, {
  hex: "#6cc181",
  code: "150 70 50",
  scope: "Design System Plus",
  de: "Grünspanfarben",
  en: "Verdigris coloured",
  nl: "verdigris kleuren",
  fr: "Couleurs vert-de-gris"
}, {
  hex: "#bdcec0",
  code: "150 80 10",
  scope: "Design System Plus",
  de: "Organzagrün",
  en: "Organza green",
  nl: "Organza groen",
  fr: "Vert organza"
}, {
  hex: "#b1d2b7",
  code: "150 80 20",
  scope: "Design System Plus",
  de: "Pastellminzgrün",
  en: "Pastel mint green",
  nl: "Pastel mintgroen",
  fr: "Vert menthe pastel"
}, {
  hex: "#a3d6af",
  code: "150 80 30",
  scope: "Design System Plus",
  de: "Knallgrün",
  en: "Bright green",
  nl: "Heldergroen",
  fr: "Vert vif"
}, {
  hex: "#95daa5",
  code: "150 80 40",
  scope: "Design System Plus",
  de: "Perlmuttgrün",
  en: "Mother-of-pearl green",
  nl: "Parelmoer groen",
  fr: "Vert nacré"
}, {
  hex: "#ccd7ce",
  code: "150 85 05",
  scope: "Design System Plus",
  de: "Spargelweiß",
  en: "Asparagus white",
  nl: "Asperges wit",
  fr: "Blanc asperge"
}, {
  hex: "#c9daca",
  code: "150 85 10",
  scope: "Design System Plus",
  de: "Transparentweiß",
  en: "Transparent white",
  nl: "Transparant wit",
  fr: "Blanc transparent"
}, {
  hex: "#bfdec1",
  code: "150 85 20",
  scope: "Design System Plus",
  de: "Bleichgrün",
  en: "Pallid green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#dce5da",
  code: "150 90 05",
  scope: "Design System Plus",
  de: "Mineralweiß",
  en: "Mineral white",
  nl: "Mineraal wit",
  fr: "Blanc minéral"
}, {
  hex: "#d9e9d8",
  code: "150 90 10",
  scope: "Design System Plus",
  de: "Alabastergrün",
  en: "Alabaster green",
  nl: "Albastgroen",
  fr: "Vert albâtre"
}, {
  hex: "#e4ede4",
  code: "150 93 05",
  scope: "Design System Plus",
  de: "Quarkweiß",
  en: "Quark white",
  nl: "Kwark wit",
  fr: "Blancheur de fromage blanc"
}, {
  hex: "#464a48",
  code: "160 20 05",
  scope: "Design System Plus",
  de: "Beryllschwarzgrün",
  en: "Beryl black green",
  nl: "Beryl zwartgroen",
  fr: "Vert béryl noir"
}, {
  hex: "#404b45",
  code: "160 20 10",
  scope: "Design System Plus",
  de: "Schalmuschelgrün",
  en: "Mussel green",
  nl: "Jacobsschelp groen",
  fr: "Vert coquille"
}, {
  hex: "#394a43",
  code: "160 20 15",
  scope: "Design System Plus",
  de: "Kürbisgrünschwarz",
  en: "Pumpkin green black",
  nl: "Pompoen groen-zwart",
  fr: "Vert citrouille noir"
}, {
  hex: "#394942",
  code: "160 20 20",
  scope: "Design System Plus",
  de: "Opulentgrün",
  en: "Opulent green",
  nl: "Weelderig groen",
  fr: "Vert opulent"
}, {
  hex: "#535955",
  code: "160 30 05",
  scope: "Design System Plus",
  de: "Sattoliv",
  en: "Rich olive",
  nl: "Sattoliv",
  fr: "Sattoliv"
}, {
  hex: "#4e5a53",
  code: "160 30 10",
  scope: "Design System Plus",
  de: "Exklusivgrün",
  en: "Exclusive green",
  nl: "Exclusief groen",
  fr: "Vert exclusif"
}, {
  hex: "#485a4f",
  code: "160 30 15",
  scope: "Design System Plus",
  de: "Blattgrün",
  en: "Leaf green",
  nl: "Bladgroen",
  fr: "Vert feuille"
}, {
  hex: "#415a4d",
  code: "160 30 20",
  scope: "Design System Plus",
  de: "Bergminze",
  en: "Mountain mint",
  nl: "Bergmunt",
  fr: "Menthe des montagnes"
}, {
  hex: "#3b5c4a",
  code: "160 30 25",
  scope: "Design System Plus",
  de: "Ordnungsgrün",
  en: "Order green",
  nl: "Groen bestellen",
  fr: "Vert d'ordre"
}, {
  hex: "#345e48",
  code: "160 30 30",
  scope: "Design System Plus",
  de: "Trollgrün",
  en: "Troll green",
  nl: "Trollengroen",
  fr: "Vert troll"
}, {
  hex: "#2c5e45",
  code: "160 30 35",
  scope: "Design System Plus",
  de: "Spieltischgrün",
  en: "Card table green",
  nl: "Speltafel groen",
  fr: "Vert table de jeu"
}, {
  hex: "#235f44",
  code: "160 30 40",
  scope: "Design System Plus",
  de: "Zitronenmelissengrün",
  en: "Lemon balm green",
  nl: "Citroenmelisse groen",
  fr: "Vert mélisse citronnée"
}, {
  hex: "#656c68",
  code: "160 40 05",
  scope: "Design System Plus",
  de: "Jaspisgrün",
  en: "Jasper green",
  nl: "Jaspis groen",
  fr: "Vert jaspe"
}, {
  hex: "#5d6d65",
  code: "160 40 10",
  scope: "Design System Plus",
  de: "Sibirischgrün",
  en: "Siberian green",
  nl: "Siberisch groen",
  fr: "Vert sibérien"
}, {
  hex: "#576e62",
  code: "160 40 15",
  scope: "Design System Plus",
  de: "Gurkengrün",
  en: "Cucumber green",
  nl: "Komkommer groen",
  fr: "Vert concombre"
}, {
  hex: "#506f5f",
  code: "160 40 20",
  scope: "Design System Plus",
  de: "Serbischgrün",
  en: "Serbian green",
  nl: "Servisch groen",
  fr: "Vert serbe"
}, {
  hex: "#49705b",
  code: "160 40 25",
  scope: "Design System Plus",
  de: "Schwarzkiefergrün",
  en: "Black pine green",
  nl: "Zwarte dennengroen",
  fr: "Vert pin noir"
}, {
  hex: "#427259",
  code: "160 40 30",
  scope: "Design System Plus",
  de: "Kürbisgrün",
  en: "Pumpkin green",
  nl: "Pompoen groen",
  fr: "Vert citrouille"
}, {
  hex: "#3a7457",
  code: "160 40 35",
  scope: "Design System Plus",
  de: "Jademuschelgrün",
  en: "Jade mussel green",
  nl: "Jade schelp groen",
  fr: "Vert coquille de jade"
}, {
  hex: "#317656",
  code: "160 40 40",
  scope: "Design System Plus",
  de: "Kleegrün",
  en: "Clover green",
  nl: "Klaver groen",
  fr: "Vert de trèfle"
}, {
  hex: "#287451",
  code: "160 40 45",
  scope: "Design System Plus",
  de: "Froschgrün",
  en: "Frog green",
  nl: "Kikkergroen",
  fr: "Vert grenouille"
}, {
  hex: "#16754e",
  code: "160 40 50",
  scope: "Design System Plus",
  de: "Universalgrün",
  en: "Universal green",
  nl: "Universeel groen",
  fr: "Vert universel"
}, {
  hex: "#05784d",
  code: "160 40 55",
  scope: "Design System Plus",
  de: "Säuleneichengrün",
  en: "Column of oak green",
  nl: "Kolom eik groen",
  fr: "Vert chêne colonnaire"
}, {
  hex: "#79817c",
  code: "160 50 05",
  scope: "Design System Plus",
  de: "Arktisflechtengrün",
  en: "Arctic lichen green",
  nl: "Arctisch korstmos groen",
  fr: "Vert lichen arctique"
}, {
  hex: "#708278",
  code: "160 50 10",
  scope: "Design System Plus",
  de: "Atlaszedergrün",
  en: "Atlas cedar green",
  nl: "Atlas cedergroen",
  fr: "Vert cèdre de l'Atlas"
}, {
  hex: "#6a8476",
  code: "160 50 15",
  scope: "Design System Plus",
  de: "Steinzypressengrün",
  en: "Stone cypress green",
  nl: "Steen cipres groen",
  fr: "Vert cyprès de roche"
}, {
  hex: "#638674",
  code: "160 50 20",
  scope: "Design System Plus",
  de: "Wacholdergrün",
  en: "Juniper green",
  nl: "Juniper groen",
  fr: "Vert de genièvre"
}, {
  hex: "#5b8770",
  code: "160 50 25",
  scope: "Design System Plus",
  de: "Sportplatzgrün",
  en: "Sports field green",
  nl: "Sportveld groen",
  fr: "Espaces verts des terrains de sport"
}, {
  hex: "#54896e",
  code: "160 50 30",
  scope: "Design System Plus",
  de: "Freizeitgrün",
  en: "Leisure green",
  nl: "Vrije tijd groen",
  fr: "Vert de loisirs"
}, {
  hex: "#4e8b6b",
  code: "160 50 35",
  scope: "Design System Plus",
  de: "Adamingrün",
  en: "Adamite green",
  nl: "Adamine groen",
  fr: "Vert adamantin"
}, {
  hex: "#3f8c68",
  code: "160 50 40",
  scope: "Design System Plus",
  de: "Metallgrün",
  en: "Metallic green",
  nl: "Metaal groen",
  fr: "Vert métal"
}, {
  hex: "#398f68",
  code: "160 50 45",
  scope: "Design System Plus",
  de: "Vitalgrün",
  en: "Vital green",
  nl: "Vitaal groen",
  fr: "Vert vital"
}, {
  hex: "#298e62",
  code: "160 50 50",
  scope: "Design System Plus",
  de: "Golfgrün",
  en: "Golf green",
  nl: "Golfbaan",
  fr: "Vert de golf"
}, {
  hex: "#109161",
  code: "160 50 55",
  scope: "Design System Plus",
  de: "Islandgrün",
  en: "Iceland green",
  nl: "IJsland groen",
  fr: "Vert Islande"
}, {
  hex: "#00905c",
  code: "160 50 60",
  scope: "Design System Plus",
  de: "Echttürkis",
  en: "Real turquoise",
  nl: "Echt turkoois",
  fr: "Turquoise véritable"
}, {
  hex: "#8f9893",
  code: "160 60 05",
  scope: "Design System Plus",
  de: "Sandsteingraugrün",
  en: "Sandstone grey green",
  nl: "Zandsteen grijsgroen",
  fr: "Vert grès gris"
}, {
  hex: "#86998f",
  code: "160 60 10",
  scope: "Design System Plus",
  de: "Schiefergrün",
  en: "Slate green",
  nl: "Leigroen",
  fr: "Vert ardoise"
}, {
  hex: "#809d8d",
  code: "160 60 15",
  scope: "Design System Plus",
  de: "Mildgrün",
  en: "Mild green",
  nl: "Mild groen",
  fr: "Vert lait"
}, {
  hex: "#779e89",
  code: "160 60 20",
  scope: "Design System Plus",
  de: "Douglasiengrün",
  en: "Douglas fir green",
  nl: "Douglas groen",
  fr: "Vert douglas"
}, {
  hex: "#709f84",
  code: "160 60 25",
  scope: "Design System Plus",
  de: "Praxisgrün",
  en: "Practice green",
  nl: "Oefengreen",
  fr: "Vert de pratique"
}, {
  hex: "#68a183",
  code: "160 60 30",
  scope: "Design System Plus",
  de: "Memphisgrün",
  en: "Memphis green",
  nl: "Memphis groen",
  fr: "Vert Memphis"
}, {
  hex: "#5fa582",
  code: "160 60 35",
  scope: "Design System Plus",
  de: "Werbegrün",
  en: "Advertising green",
  nl: "Reclame groen",
  fr: "Verdure publicitaire"
}, {
  hex: "#55a47e",
  code: "160 60 40",
  scope: "Design System Plus",
  de: "Jägergrün",
  en: "Hunter green",
  nl: "Jagergroen",
  fr: "Vert chasseur"
}, {
  hex: "#4ca77c",
  code: "160 60 45",
  scope: "Design System Plus",
  de: "Linoleumgrün",
  en: "Linoleum green",
  nl: "Linoleum groen",
  fr: "Vert linoléum"
}, {
  hex: "#3ba878",
  code: "160 60 50",
  scope: "Design System Plus",
  de: "Sittichgrün",
  en: "Parakeet green",
  nl: "Parkiet groen",
  fr: "Vert perruche"
}, {
  hex: "#32a774",
  code: "160 60 55",
  scope: "Design System Plus",
  de: "Smaragdhellgrün",
  en: "Emerald light green",
  nl: "Smaragdgroen lichtgroen",
  fr: "Vert émeraude clair"
}, {
  hex: "#1ca971",
  code: "160 60 58",
  scope: "Design System Plus",
  de: "Alhambragrün",
  en: "Alhambra green",
  nl: "Alhambra groen",
  fr: "Vert alhambra"
}, {
  hex: "#a7b2ac",
  code: "160 70 05",
  scope: "Design System Plus",
  de: "Grünlichgrau",
  en: "Greenish grey",
  nl: "Groenachtig grijs",
  fr: "Gris verdâtre"
}, {
  hex: "#9eb3a7",
  code: "160 70 10",
  scope: "Design System Plus",
  de: "Schwachgrün",
  en: "Weak green",
  nl: "Lichtgroen",
  fr: "Vert faible"
}, {
  hex: "#96b4a3",
  code: "160 70 15",
  scope: "Design System Plus",
  de: "Andeerschiefer",
  en: "Andean slate",
  nl: "Andeer leisteen",
  fr: "Schiste d'Andeer"
}, {
  hex: "#90b7a1",
  code: "160 70 20",
  scope: "Design System Plus",
  de: "Keramikgrün",
  en: "Ceramic green",
  nl: "Groen keramiek",
  fr: "Vert céramique"
}, {
  hex: "#88bb9f",
  code: "160 70 25",
  scope: "Design System Plus",
  de: "Wassergrün",
  en: "Water green",
  nl: "Water groen",
  fr: "Vert d'eau"
}, {
  hex: "#7dbc9c",
  code: "160 70 30",
  scope: "Design System Plus",
  de: "Bergseegrün",
  en: "Mountain lake green",
  nl: "Bergmeer groen",
  fr: "Vert du lac de montagne"
}, {
  hex: "#74bd99",
  code: "160 70 35",
  scope: "Design System Plus",
  de: "Amerikanischgrün",
  en: "American green",
  nl: "Amerikaans groen",
  fr: "Vert américain"
}, {
  hex: "#6ac096",
  code: "160 70 40",
  scope: "Design System Plus",
  de: "Technotürkis",
  en: "Techno turquoise",
  nl: "Technoturquoise",
  fr: "Technotürkis"
}, {
  hex: "#5ec292",
  code: "160 70 45",
  scope: "Design System Plus",
  de: "Grellgrün",
  en: "Garish green",
  nl: "Heldergroen",
  fr: "Vert vif"
}, {
  hex: "#54c391",
  code: "160 70 50",
  scope: "Design System Plus",
  de: "Malachitgrün",
  en: "Malachite green",
  nl: "Malachietgroen",
  fr: "Vert malachite"
}, {
  hex: "#bfcac4",
  code: "160 80 05",
  scope: "Design System Plus",
  de: "Nebelgrün",
  en: "Fog green",
  nl: "Mist groen",
  fr: "Vert brume"
}, {
  hex: "#b8cdc0",
  code: "160 80 10",
  scope: "Design System Plus",
  de: "Jademattgrün",
  en: "Matte jade green",
  nl: "Jadegroen",
  fr: "Vert jade"
}, {
  hex: "#afcfbd",
  code: "160 80 15",
  scope: "Design System Plus",
  de: "Sonnengrün",
  en: "Sun yellow",
  nl: "Zon groen",
  fr: "Vert soleil"
}, {
  hex: "#a7d2ba",
  code: "160 80 20",
  scope: "Design System Plus",
  de: "Federngrün",
  en: "Feather green",
  nl: "Veder groen",
  fr: "Vert plume"
}, {
  hex: "#a1d4b8",
  code: "160 80 25",
  scope: "Design System Plus",
  de: "Mentholgrün",
  en: "Menthol green",
  nl: "Menthol groen",
  fr: "Vert menthol"
}, {
  hex: "#99d7b6",
  code: "160 80 30",
  scope: "Design System Plus",
  de: "Seidengrün",
  en: "Silk green",
  nl: "Zijde groen",
  fr: "Vert soie"
}, {
  hex: "#cad6cf",
  code: "160 85 05",
  scope: "Design System Plus",
  de: "Leichtgrün",
  en: "Light green",
  nl: "Lichtgroen",
  fr: "Vert léger"
}, {
  hex: "#c3d8cc",
  code: "160 85 10",
  scope: "Design System Plus",
  de: "Glimmergrün",
  en: "Micaceous green",
  nl: "Mica groen",
  fr: "Vert mica"
}, {
  hex: "#bbdbc7",
  code: "160 85 15",
  scope: "Design System Plus",
  de: "Mondsteingrün",
  en: "Moonstone green",
  nl: "Maansteen groen",
  fr: "Vert pierre de lune"
}, {
  hex: "#dbe5dc",
  code: "160 90 05",
  scope: "Design System Plus",
  de: "Aquarellweiß",
  en: "Watercolour white",
  nl: "Aquarel wit",
  fr: "Blanc aquarelle"
}, {
  hex: "#d3e8d9",
  code: "160 90 10",
  scope: "Design System Plus",
  de: "Mondscheingrün",
  en: "Moonlight green",
  nl: "Maanlicht groen",
  fr: "Vert clair de lune"
}, {
  hex: "#ccead6",
  code: "160 90 15",
  scope: "Design System Plus",
  de: "Gletscherwassergrün",
  en: "Glacial water green",
  nl: "Gletsjerwater groen",
  fr: "Vert eau de glacier"
}, {
  hex: "#e0ece6",
  code: "160 93 05",
  scope: "Design System Plus",
  de: "Bergkristallsilber",
  en: "Mountain crystal silver",
  nl: "Bergkristal zilver",
  fr: "Argent cristal de roche"
}, {
  hex: "#3e4a46",
  code: "170 20 10",
  scope: "Design System Plus",
  de: "Tiefgrün",
  en: "Deep green",
  nl: "Diepgroen",
  fr: "Vert profond"
}, {
  hex: "#394a45",
  code: "170 20 15",
  scope: "Design System Plus",
  de: "Intensivgrün",
  en: "Intense green",
  nl: "Intens groen",
  fr: "Vert intense"
}, {
  hex: "#334c45",
  code: "170 20 20",
  scope: "Design System Plus",
  de: "Wagengrün",
  en: "Coach green",
  nl: "Auto groen",
  fr: "Vert wagon"
}, {
  hex: "#2f4c42",
  code: "170 20 25",
  scope: "Design System Plus",
  de: "Offroadgrün",
  en: "Off-road green",
  nl: "Off-road groen",
  fr: "Vert offroad"
}, {
  hex: "#4c5b55",
  code: "170 30 10",
  scope: "Design System Plus",
  de: "Granatschwarzgrün",
  en: "Garnet black green",
  nl: "Granaat zwart groen",
  fr: "Vert grenat noir"
}, {
  hex: "#435b52",
  code: "170 30 15",
  scope: "Design System Plus",
  de: "Dunkelgrün",
  en: "Dark green",
  nl: "Donkergroen",
  fr: "Vert foncé"
}, {
  hex: "#3e5b51",
  code: "170 30 20",
  scope: "Design System Plus",
  de: "Distelgrün",
  en: "Thistle green",
  nl: "Distel groen",
  fr: "Vert chardon"
}, {
  hex: "#355e50",
  code: "170 30 25",
  scope: "Design System Plus",
  de: "Himbeerblattgrün",
  en: "Raspberry leaf green",
  nl: "Frambozenblad groen",
  fr: "Vert feuille de framboisier"
}, {
  hex: "#2f5e50",
  code: "170 30 30",
  scope: "Design System Plus",
  de: "Chrysokolldunkelgrün",
  en: "Chrysocolla dark green",
  nl: "Chrysocolla donkergroen",
  fr: "Chrysocolle vert foncé"
}, {
  hex: "#26604f",
  code: "170 30 35",
  scope: "Design System Plus",
  de: "Trappergrün",
  en: "Trapper green",
  nl: "Vallenzetter groen",
  fr: "Vert trappeur"
}, {
  hex: "#16624e",
  code: "170 30 40",
  scope: "Design System Plus",
  de: "Permanentgrün",
  en: "Permanent green",
  nl: "Permanent groen",
  fr: "Vert permanent"
}, {
  hex: "#5b6c65",
  code: "170 40 10",
  scope: "Design System Plus",
  de: "Chalcedongrün",
  en: "Chalcedony green",
  nl: "Chalcedoon groen",
  fr: "Vert calcédoine"
}, {
  hex: "#536d63",
  code: "170 40 15",
  scope: "Design System Plus",
  de: "Schlossgrün",
  en: "Palace green",
  nl: "Kasteelgroen",
  fr: "Vert château"
}, {
  hex: "#4b7063",
  code: "170 40 20",
  scope: "Design System Plus",
  de: "Breitwegerichgrün",
  en: "Plantain green",
  nl: "Groenbladige weegbree",
  fr: "Vert plantain"
}, {
  hex: "#457060",
  code: "170 40 25",
  scope: "Design System Plus",
  de: "Erzgebirgsgrün",
  en: "Ore mountains green",
  nl: "Ertsberg groen",
  fr: "Vert archipel"
}, {
  hex: "#3d7561",
  code: "170 40 30",
  scope: "Design System Plus",
  de: "Traktorgrün",
  en: "Tractor green",
  nl: "Trekker groen",
  fr: "Vert tracteur"
}, {
  hex: "#2f745e",
  code: "170 40 35",
  scope: "Design System Plus",
  de: "Viktoriagrün",
  en: "Victoria green",
  nl: "Victoria groen",
  fr: "Vert victoria"
}, {
  hex: "#20755e",
  code: "170 40 40",
  scope: "Design System Plus",
  de: "Gerätegrün",
  en: "Device green",
  nl: "Apparaat groen",
  fr: "Verdure des appareils"
}, {
  hex: "#08765d",
  code: "170 40 45",
  scope: "Design System Plus",
  de: "Umweltgrün",
  en: "Environmental green",
  nl: "Milieuvriendelijk groen",
  fr: "Vert environnemental"
}, {
  hex: "#00765a",
  code: "170 40 50",
  scope: "Design System Plus",
  de: "Vegangrün",
  en: "Vegan green",
  nl: "Veganistisch groen",
  fr: "Vert végétal"
}, {
  hex: "#6e827b",
  code: "170 50 10",
  scope: "Design System Plus",
  de: "Rödelerzgrün",
  en: "Bournonite green",
  nl: "Rödelerzgrün",
  fr: "Rödelerzgrün"
}, {
  hex: "#67867a",
  code: "170 50 15",
  scope: "Design System Plus",
  de: "Fuchsitgrün",
  en: "Fuchsite green",
  nl: "Fuchsietgroen",
  fr: "Vert fuchsia"
}, {
  hex: "#5f8678",
  code: "170 50 20",
  scope: "Design System Plus",
  de: "Brombeerblattgrün",
  en: "Blackberry leaf green",
  nl: "Bramenblad groen",
  fr: "Vert feuille de ronce"
}, {
  hex: "#568876",
  code: "170 50 25",
  scope: "Design System Plus",
  de: "Turmalinblau",
  en: "Tourmaline blue",
  nl: "Toermalijn blauw",
  fr: "Bleu tourmaline"
}, {
  hex: "#4a8a75",
  code: "170 50 30",
  scope: "Design System Plus",
  de: "Traumgrün",
  en: "Dream green",
  nl: "Droomgroen",
  fr: "Vert de rêve"
}, {
  hex: "#3e8b73",
  code: "170 50 35",
  scope: "Design System Plus",
  de: "Akzentgrünblau",
  en: "Accent green blue",
  nl: "Accent groen-blauw",
  fr: "Bleu vert accentué"
}, {
  hex: "#308d71",
  code: "170 50 40",
  scope: "Design System Plus",
  de: "Spektralgrün",
  en: "Spectral green",
  nl: "Spectraal groen",
  fr: "Vert spectral"
}, {
  hex: "#1e8e71",
  code: "170 50 45",
  scope: "Design System Plus",
  de: "Stockentengrün",
  en: "Mallard green",
  nl: "Wilde eend groen",
  fr: "Vert colvert"
}, {
  hex: "#00916f",
  code: "170 50 50",
  scope: "Design System Plus",
  de: "Chagallgrün",
  en: "Chagall green",
  nl: "Chagall groen",
  fr: "Vert chagall"
}, {
  hex: "#00906d",
  code: "170 50 55",
  scope: "Design System Plus",
  de: "Absinthtürkis",
  en: "Absinthe turquoise",
  nl: "Absint turquoise",
  fr: "Turquoise d'absinthe"
}, {
  hex: "#849a92",
  code: "170 60 10",
  scope: "Design System Plus",
  de: "Quantumgrün",
  en: "Quantum green",
  nl: "Kwantumgroen",
  fr: "Vert quantique"
}, {
  hex: "#7e9d90",
  code: "170 60 15",
  scope: "Design System Plus",
  de: "Bitterkleegrün",
  en: "Bitter clover green",
  nl: "Bittere klaver groen",
  fr: "Vert de trèfle amer"
}, {
  hex: "#739f8f",
  code: "170 60 20",
  scope: "Design System Plus",
  de: "Cyperngrün",
  en: "Cyprus green",
  nl: "Cyprus groen",
  fr: "Vert cyprès"
}, {
  hex: "#6aa08e",
  code: "170 60 25",
  scope: "Design System Plus",
  de: "Saftiggrün",
  en: "Succulent green",
  nl: "Sappig groen",
  fr: "Vert juteux"
}, {
  hex: "#5ea28c",
  code: "170 60 30",
  scope: "Design System Plus",
  de: "Lebendiggrün",
  en: "Vibrant green",
  nl: "Groen leven",
  fr: "Vert vif"
}, {
  hex: "#50a68a",
  code: "170 60 35",
  scope: "Design System Plus",
  de: "Klimtgrün",
  en: "Klimt green",
  nl: "Klimt groen",
  fr: "Vert climat"
}, {
  hex: "#44a689",
  code: "170 60 40",
  scope: "Design System Plus",
  de: "Persischgrün",
  en: "Persian green",
  nl: "Perzisch groen",
  fr: "Vert persan"
}, {
  hex: "#33a685",
  code: "170 60 45",
  scope: "Design System Plus",
  de: "Sportgrün",
  en: "Sport green",
  nl: "Sportief groen",
  fr: "Vert sport"
}, {
  hex: "#1baa87",
  code: "170 60 50",
  scope: "Design System Plus",
  de: "Aktivgrün",
  en: "Active green",
  nl: "Actief groen",
  fr: "Vert actif"
}, {
  hex: "#9db4ab",
  code: "170 70 10",
  scope: "Design System Plus",
  de: "Liebstöckelgrün",
  en: "Lovage green",
  nl: "Lavas groen",
  fr: "Vert de livèche"
}, {
  hex: "#95b6a8",
  code: "170 70 15",
  scope: "Design System Plus",
  de: "Chrysopalhellgrün",
  en: "Chrysopal light green",
  nl: "Chrysopal lichtgroen",
  fr: "Vert chrysopal clair"
}, {
  hex: "#8bb9a7",
  code: "170 70 20",
  scope: "Design System Plus",
  de: "Quellgrün",
  en: "Source green",
  nl: "Lentegroen",
  fr: "Vert source"
}, {
  hex: "#83bba6",
  code: "170 70 25",
  scope: "Design System Plus",
  de: "Orientmosaikgrün",
  en: "Orient mosaic green",
  nl: "Oosters mozaïekgroen",
  fr: "Vert mosaïque d'Orient"
}, {
  hex: "#75bea5",
  code: "170 70 30",
  scope: "Design System Plus",
  de: "Minzkaltgrün",
  en: "Mint cold green",
  nl: "Munt koud groen",
  fr: "Vert menthe froid"
}, {
  hex: "#6abea2",
  code: "170 70 35",
  scope: "Design System Plus",
  de: "Emeraldgrün",
  en: "Emerald green",
  nl: "Smaragdgroen",
  fr: "Vert émeraude"
}, {
  hex: "#5fbfa0",
  code: "170 70 40",
  scope: "Design System Plus",
  de: "Expressionismusgrün",
  en: "Expressionism green",
  nl: "Expressionisme groen",
  fr: "Vert expressionniste"
}, {
  hex: "#b7cec5",
  code: "170 80 10",
  scope: "Design System Plus",
  de: "Fluoritblau",
  en: "Fluorite blue",
  nl: "Fluoriet blauw",
  fr: "Bleu fluorite"
}, {
  hex: "#acd0c3",
  code: "170 80 15",
  scope: "Design System Plus",
  de: "Schwimmbadgrün",
  en: "Swimming pool green",
  nl: "Zwembad groen",
  fr: "Vert de la piscine"
}, {
  hex: "#a4d5c2",
  code: "170 80 20",
  scope: "Design System Plus",
  de: "Himmelgrün",
  en: "Sky green",
  nl: "Hemels groen",
  fr: "Vert ciel"
}, {
  hex: "#99d4bf",
  code: "170 80 25",
  scope: "Design System Plus",
  de: "Larimargrün",
  en: "Larimar green",
  nl: "Larimar groen",
  fr: "Vert larimar"
}, {
  hex: "#cbd7d2",
  code: "170 85 05",
  scope: "Design System Plus",
  de: "Silikathelltürkis",
  en: "Silicate light turquoise",
  nl: "Silicaat licht turkoois",
  fr: "Turquoise clair silicaté"
}, {
  hex: "#c3dad0",
  code: "170 85 10",
  scope: "Design System Plus",
  de: "Topasgrün",
  en: "Topaz green",
  nl: "Topaasgroen",
  fr: "Vert topaze"
}, {
  hex: "#b8ddcd",
  code: "170 85 15",
  scope: "Design System Plus",
  de: "Kühlschrankgrün",
  en: "Refrigerator green",
  nl: "Koelkast groen",
  fr: "Vert frigo"
}, {
  hex: "#b0e0cb",
  code: "170 85 20",
  scope: "Design System Plus",
  de: "Kristallglasgrün",
  en: "Crystal glass green",
  nl: "Kristalglas groen",
  fr: "Vert cristal"
}, {
  hex: "#dae5de",
  code: "170 90 05",
  scope: "Design System Plus",
  de: "Kristallsalzweiß",
  en: "Crystal salt white",
  nl: "Kristalzout wit",
  fr: "Blanc cristal de sel"
}, {
  hex: "#d1e9dd",
  code: "170 90 10",
  scope: "Design System Plus",
  de: "Türkisweiß",
  en: "Turquoise white",
  nl: "Turkoois wit",
  fr: "Blanc turquoise"
}, {
  hex: "#e2ede7",
  code: "170 93 05",
  scope: "Design System Plus",
  de: "Schneekristallgrün",
  en: "Snow crystal green",
  nl: "Sneeuwkristal groen",
  fr: "Vert cristal de neige"
}, {
  hex: "#454c4b",
  code: "180 20 05",
  scope: "Design System Plus",
  de: "Pechgrün",
  en: "Pitch green",
  nl: "Standplaats groen",
  fr: "Vert poix"
}, {
  hex: "#3e4a47",
  code: "180 20 10",
  scope: "Design System Plus",
  de: "Lackgrün",
  en: "Lacquer green",
  nl: "Groen patent",
  fr: "Vert laque"
}, {
  hex: "#374b48",
  code: "180 20 15",
  scope: "Design System Plus",
  de: "Zaungrün",
  en: "Fence green",
  nl: "Hek groen",
  fr: "Vert de clôture"
}, {
  hex: "#304c48",
  code: "180 20 20",
  scope: "Design System Plus",
  de: "Myrtengrün",
  en: "Myrtle green",
  nl: "Myrtle groen",
  fr: "Vert myrte"
}, {
  hex: "#535b59",
  code: "180 30 05",
  scope: "Design System Plus",
  de: "Amazonasgrün",
  en: "Amazon green",
  nl: "Amazonegroen",
  fr: "Vert amazonien"
}, {
  hex: "#4a5a56",
  code: "180 30 10",
  scope: "Design System Plus",
  de: "Sattgrautürkis",
  en: "Rich grey turquoise",
  nl: "Rijk grijs turkoois",
  fr: "Turquoise gris saturé"
}, {
  hex: "#435c57",
  code: "180 30 15",
  scope: "Design System Plus",
  de: "Tafelgrün",
  en: "Blackboard green",
  nl: "Tabel groen",
  fr: "Vert de table"
}, {
  hex: "#3c5d56",
  code: "180 30 20",
  scope: "Design System Plus",
  de: "Schwedengrün",
  en: "Swedish green",
  nl: "Zweeds groen",
  fr: "Vert suédois"
}, {
  hex: "#335e56",
  code: "180 30 25",
  scope: "Design System Plus",
  de: "Fjordgrün",
  en: "Fjord green",
  nl: "Fjordgroen",
  fr: "Vert fjord"
}, {
  hex: "#295f56",
  code: "180 30 30",
  scope: "Design System Plus",
  de: "Stadtgrün",
  en: "Urban green",
  nl: "Stedelijk groen",
  fr: "Espaces verts de la ville"
}, {
  hex: "#196054",
  code: "180 30 35",
  scope: "Design System Plus",
  de: "Dschungelgrün",
  en: "Jungle green",
  nl: "Oerwoudgroen",
  fr: "Vert jungle"
}, {
  hex: "#626c69",
  code: "180 40 05",
  scope: "Design System Plus",
  de: "Erdgrün",
  en: "Earth green",
  nl: "Aarde groen",
  fr: "Vert terre"
}, {
  hex: "#5a6e69",
  code: "180 40 10",
  scope: "Design System Plus",
  de: "Kiefergrün",
  en: "Pine green",
  nl: "Dennengroen",
  fr: "Vert pin"
}, {
  hex: "#516f68",
  code: "180 40 15",
  scope: "Design System Plus",
  de: "Forstgrün",
  en: "Forest greenery",
  nl: "Bosgroen",
  fr: "Verdure forestière"
}, {
  hex: "#477168",
  code: "180 40 20",
  scope: "Design System Plus",
  de: "Meergrün",
  en: "Sea green",
  nl: "Zeegroen",
  fr: "Vert mer"
}, {
  hex: "#3e7268",
  code: "180 40 25",
  scope: "Design System Plus",
  de: "Eukalyptusgrün",
  en: "Eucalyptus green",
  nl: "Eucalyptus groen",
  fr: "Vert eucalyptus"
}, {
  hex: "#2f7469",
  code: "180 40 30",
  scope: "Design System Plus",
  de: "Efeufrischgrün",
  en: "Fresh ivy green",
  nl: "Klimop fris groen",
  fr: "Vert lierre frais"
}, {
  hex: "#1c7566",
  code: "180 40 35",
  scope: "Design System Plus",
  de: "Chrysokollmittelgrün",
  en: "Chrysocolla medium green",
  nl: "Chrysocolla middengroen",
  fr: "Vert chrysocolle"
}, {
  hex: "#007565",
  code: "180 40 40",
  scope: "Design System Plus",
  de: "Plakatgrün",
  en: "Poster green",
  nl: "Poster groen",
  fr: "Vert d'affiche"
}, {
  hex: "#007666",
  code: "180 40 45",
  scope: "Design System Plus",
  de: "Petroldunkelgrün",
  en: "Teal dark green",
  nl: "Petroleum donkergroen",
  fr: "Vert pétrole foncé"
}, {
  hex: "#788280",
  code: "180 50 05",
  scope: "Design System Plus",
  de: "Dämmergrün",
  en: "Dusk green",
  nl: "Schemergroen",
  fr: "Vert crépuscule"
}, {
  hex: "#6d827d",
  code: "180 50 10",
  scope: "Design System Plus",
  de: "Erquickungsgrün",
  en: "Refreshing green",
  nl: "Verfrissend groen",
  fr: "Vert rafraîchissant"
}, {
  hex: "#63857d",
  code: "180 50 15",
  scope: "Design System Plus",
  de: "Stumpftürkis",
  en: "Dull turquoise",
  nl: "Mat turkoois",
  fr: "Turquoise terne"
}, {
  hex: "#59867d",
  code: "180 50 20",
  scope: "Design System Plus",
  de: "Azuritwassergrün",
  en: "Azurite water green",
  nl: "Azuriet watergroen",
  fr: "Vert d'eau azurite"
}, {
  hex: "#4d897e",
  code: "180 50 25",
  scope: "Design System Plus",
  de: "Kupfermineralgrün",
  en: "Copper mineral green",
  nl: "Koper mineraal groen",
  fr: "Vert minéral de cuivre"
}, {
  hex: "#408b7c",
  code: "180 50 30",
  scope: "Design System Plus",
  de: "Glasgrün",
  en: "Glass green",
  nl: "Glas groen",
  fr: "Vert verre"
}, {
  hex: "#318c7d",
  code: "180 50 35",
  scope: "Design System Plus",
  de: "Sommertürkis",
  en: "Summer turquoise",
  nl: "Zomerturquoise",
  fr: "Turquoise d'été"
}, {
  hex: "#1b8c7b",
  code: "180 50 40",
  scope: "Design System Plus",
  de: "Weihnachtsgrün",
  en: "Christmas green",
  nl: "Kerstgroeten",
  fr: "Vert de Noël"
}, {
  hex: "#00907b",
  code: "180 50 45",
  scope: "Design System Plus",
  de: "Industrietürkis",
  en: "Industrial turquoise",
  nl: "Industrieel turkoois",
  fr: "Turquoise industrielle"
}, {
  hex: "#00907a",
  code: "180 50 50",
  scope: "Design System Plus",
  de: "Ozeangrün",
  en: "Ocean green",
  nl: "Oceaangroen",
  fr: "Vert océan"
}, {
  hex: "#8d9996",
  code: "180 60 05",
  scope: "Design System Plus",
  de: "Marmorgrüngrau",
  en: "Marble green-grey",
  nl: "Marmer groen grijs",
  fr: "Gris marbré vert"
}, {
  hex: "#829a95",
  code: "180 60 10",
  scope: "Design System Plus",
  de: "Kachelgrün",
  en: "Tile green",
  nl: "Tegel groen",
  fr: "Vert carreau"
}, {
  hex: "#789d94",
  code: "180 60 15",
  scope: "Design System Plus",
  de: "Kupferdachgrün",
  en: "Copper roof green",
  nl: "Koperen dak groen",
  fr: "Vert toit cuivré"
}, {
  hex: "#6e9f94",
  code: "180 60 20",
  scope: "Design System Plus",
  de: "Salbeigrün",
  en: "Sage green",
  nl: "Saliegroen",
  fr: "Vert sauge"
}, {
  hex: "#61a093",
  code: "180 60 25",
  scope: "Design System Plus",
  de: "Petrolgrün",
  en: "Petrol green",
  nl: "Benzine groen",
  fr: "Vert pétrole"
}, {
  hex: "#54a394",
  code: "180 60 30",
  scope: "Design System Plus",
  de: "Dioptasgrün",
  en: "Dioptase green",
  nl: "Dioptasegroen",
  fr: "Vert dioptas"
}, {
  hex: "#46a593",
  code: "180 60 35",
  scope: "Design System Plus",
  de: "Stempelkissengrün",
  en: "Stamp pad green",
  nl: "Stempelkussen groen",
  fr: "Tampon encreur vert"
}, {
  hex: "#2fa794",
  code: "180 60 40",
  scope: "Design System Plus",
  de: "Leuchttürkis",
  en: "Light turquoise",
  nl: "Lichtgevend turkoois",
  fr: "Turquoise fluo"
}, {
  hex: "#02a994",
  code: "180 60 45",
  scope: "Design System Plus",
  de: "Karibikgrün",
  en: "Caribbean green",
  nl: "Caribisch groen",
  fr: "Vert caraïbe"
}, {
  hex: "#00aa93",
  code: "180 60 50",
  scope: "Design System Plus",
  de: "Brillanttürkis",
  en: "Brilliant turquoise",
  nl: "Schitterend turquoise",
  fr: "Turquoise brillant"
}, {
  hex: "#a6b1ae",
  code: "180 70 05",
  scope: "Design System Plus",
  de: "Feldspatsilber",
  en: "Feldspar silver",
  nl: "Veldspaat zilver",
  fr: "Argent feldspathique"
}, {
  hex: "#98b3ad",
  code: "180 70 10",
  scope: "Design System Plus",
  de: "Grazilgrün",
  en: "Delicate green",
  nl: "Sierlijk groen",
  fr: "Vert gracile"
}, {
  hex: "#8fb6ad",
  code: "180 70 15",
  scope: "Design System Plus",
  de: "Silikatgrün",
  en: "Silicate green",
  nl: "Silicaat groen",
  fr: "Vert silicate"
}, {
  hex: "#85b9ad",
  code: "180 70 20",
  scope: "Design System Plus",
  de: "Mintbonbongrün",
  en: "Mint bonbon green",
  nl: "Mint snoepgroen",
  fr: "Vert menthe bonbon"
}, {
  hex: "#78baac",
  code: "180 70 25",
  scope: "Design System Plus",
  de: "Gletschergrün",
  en: "Glacial green",
  nl: "Gletsjer groen",
  fr: "Vert glacier"
}, {
  hex: "#6dbdad",
  code: "180 70 30",
  scope: "Design System Plus",
  de: "Badtürkis",
  en: "Bath turquoise",
  nl: "Bad turquoise",
  fr: "Turquoise de bain"
}, {
  hex: "#5bbfac",
  code: "180 70 35",
  scope: "Design System Plus",
  de: "Bergseeazur",
  en: "Mountain lake azure",
  nl: "Bergmeer",
  fr: "Lac de montagneavec"
}, {
  hex: "#4ac2ad",
  code: "180 70 40",
  scope: "Design System Plus",
  de: "Reincyan",
  en: "Pure cyan",
  nl: "Reincyanium",
  fr: "Reincyan"
}, {
  hex: "#bfcbc6",
  code: "180 80 05",
  scope: "Design System Plus",
  de: "Aragonitweiß",
  en: "Aragonite white",
  nl: "Aragoniet wit",
  fr: "Blanc aragonite"
}, {
  hex: "#b4cec7",
  code: "180 80 10",
  scope: "Design System Plus",
  de: "Lichtpetrol",
  en: "Light teal",
  nl: "Lichte benzine",
  fr: "Pétrole de lumière"
}, {
  hex: "#abd2c8",
  code: "180 80 15",
  scope: "Design System Plus",
  de: "Whirlpoolgrün",
  en: "Whirlpool green",
  nl: "Whirlpool groen",
  fr: "Vert bouillonnant"
}, {
  hex: "#9cd3c6",
  code: "180 80 20",
  scope: "Design System Plus",
  de: "Opaltürkis",
  en: "Opal turquoise",
  nl: "Opaal turkoois",
  fr: "Turquoise opale"
}, {
  hex: "#91d5c6",
  code: "180 80 25",
  scope: "Design System Plus",
  de: "Caprihellgrün",
  en: "Light Capri green",
  nl: "Capri lichtgroen",
  fr: "Vert caprihell"
}, {
  hex: "#89dac8",
  code: "180 80 30",
  scope: "Design System Plus",
  de: "Zarttürkis",
  en: "Tender turquoise",
  nl: "Licht turkoois",
  fr: "Turquoise tendre"
}, {
  hex: "#cad7d3",
  code: "180 85 05",
  scope: "Design System Plus",
  de: "Meerdunstgrau",
  en: "Sea haze grey",
  nl: "Zeemist grijs",
  fr: "Gris brume de mer"
}, {
  hex: "#c0dad3",
  code: "180 85 10",
  scope: "Design System Plus",
  de: "Feuerlandmeergrün",
  en: "Tierra del Fuego sea green",
  nl: "Vuurland zeegroen",
  fr: "Vert de la mer de la Terre de Feu"
}, {
  hex: "#b8ded2",
  code: "180 85 15",
  scope: "Design System Plus",
  de: "Bergseehelltürkis",
  en: "Pale mountain lake turquoise",
  nl: "Bergmeer licht turquoise",
  fr: "Lac de montagne turquoise"
}, {
  hex: "#aadfcf",
  code: "180 85 20",
  scope: "Design System Plus",
  de: "Korallgrün",
  en: "Coral green",
  nl: "Koraalgroen",
  fr: "Vert corail"
}, {
  hex: "#dbe7e2",
  code: "180 90 05",
  scope: "Design System Plus",
  de: "Transparentgrün",
  en: "Transparent green",
  nl: "Transparant groen",
  fr: "Vert transparent"
}, {
  hex: "#d0ece3",
  code: "180 90 10",
  scope: "Design System Plus",
  de: "Eiswassergrün",
  en: "Ice water green",
  nl: "IJswater groen",
  fr: "Vert eau glacée"
}, {
  hex: "#e2eeea",
  code: "180 93 05",
  scope: "Design System Plus",
  de: "Arktisweiß",
  en: "Arctic white",
  nl: "Arctisch wit",
  fr: "Blanc arctique"
}, {
  hex: "#2f4d4a",
  code: "190 20 20",
  scope: "Design System Plus",
  de: "Nachttürkis",
  en: "Night turquoise",
  nl: "Nacht turquoise",
  fr: "Turquoise nuit"
}, {
  hex: "#415c5a",
  code: "190 30 15",
  scope: "Design System Plus",
  de: "Kutschengrün",
  en: "Carriage green",
  nl: "Rijtuig groen",
  fr: "Kutschengrün"
}, {
  hex: "#375d5b",
  code: "190 30 20",
  scope: "Design System Plus",
  de: "Lattenzaungrün",
  en: "Stockade green",
  nl: "Piketomheining groen",
  fr: "Verdure de clôture en lattes"
}, {
  hex: "#2d5e5b",
  code: "190 30 25",
  scope: "Design System Plus",
  de: "Aktionsgrün",
  en: "Action green",
  nl: "Actie groen",
  fr: "Vert d'action"
}, {
  hex: "#20605d",
  code: "190 30 30",
  scope: "Design System Plus",
  de: "Myrtentiefgrün",
  en: "Myrtle deep green",
  nl: "Mirte diepgroen",
  fr: "Vert myrte"
}, {
  hex: "#0e605d",
  code: "190 30 35",
  scope: "Design System Plus",
  de: "Planktongrün",
  en: "Plankton green",
  nl: "Plankton groen",
  fr: "Vert plancton"
}, {
  hex: "#586c6a",
  code: "190 40 10",
  scope: "Design System Plus",
  de: "Schlammgrün",
  en: "Mud green",
  nl: "Moddergroen",
  fr: "Vert boue"
}, {
  hex: "#4f6f6d",
  code: "190 40 15",
  scope: "Design System Plus",
  de: "Moorteichgrün",
  en: "Moor pond green",
  nl: "Moerasvijver groen",
  fr: "Vert étang de tourbe"
}, {
  hex: "#44716e",
  code: "190 40 20",
  scope: "Design System Plus",
  de: "Üppiggrün",
  en: "Lush green",
  nl: "Weelderig groen",
  fr: "Vert luxuriant"
}, {
  hex: "#37726f",
  code: "190 40 25",
  scope: "Design System Plus",
  de: "Schmetterlingsgrün",
  en: "Butterfly green",
  nl: "Vlinder groen",
  fr: "Vert papillon"
}, {
  hex: "#267470",
  code: "190 40 30",
  scope: "Design System Plus",
  de: "Modeblau",
  en: "Fashion blue",
  nl: "Mode blauw",
  fr: "Bleu mode"
}, {
  hex: "#097671",
  code: "190 40 35",
  scope: "Design System Plus",
  de: "Officeblaugrün",
  en: "Office blue green",
  nl: "Kantoor blauwgroen",
  fr: "Vert bleu office"
}, {
  hex: "#007771",
  code: "190 40 40",
  scope: "Design System Plus",
  de: "Leguangrün",
  en: "Iguana green",
  nl: "Leguaan groen",
  fr: "Vert iguane"
}, {
  hex: "#007a73",
  code: "190 40 45",
  scope: "Design System Plus",
  de: "Dunkelpetrol",
  en: "Dark teal",
  nl: "Donkere benzine",
  fr: "Pétrole foncé"
}, {
  hex: "#6d8481",
  code: "190 50 10",
  scope: "Design System Plus",
  de: "Sturmgrün",
  en: "Storm green",
  nl: "Stormgroen",
  fr: "Vert tempête"
}, {
  hex: "#628682",
  code: "190 50 15",
  scope: "Design System Plus",
  de: "Dunkeltürkis",
  en: "Dark turquoise",
  nl: "Donker turkoois",
  fr: "Turquoise foncé"
}, {
  hex: "#578884",
  code: "190 50 20",
  scope: "Design System Plus",
  de: "Tannenblau",
  en: "Fir blue",
  nl: "Dennenblauw",
  fr: "Bleu sapin"
}, {
  hex: "#488984",
  code: "190 50 25",
  scope: "Design System Plus",
  de: "Apatitblau",
  en: "Apatite blue",
  nl: "Apatiet blauw",
  fr: "Bleu apatite"
}, {
  hex: "#368b86",
  code: "190 50 30",
  scope: "Design System Plus",
  de: "Ägyptischgrün",
  en: "Egyptian green",
  nl: "Egyptisch groen",
  fr: "Vert égyptien"
}, {
  hex: "#208c86",
  code: "190 50 35",
  scope: "Design System Plus",
  de: "Schmucktürkis",
  en: "Ornamental turquoise",
  nl: "Sieraden turkoois",
  fr: "Turquoise à paillettes"
}, {
  hex: "#008f89",
  code: "190 50 40",
  scope: "Design System Plus",
  de: "Lidschattentürkis",
  en: "Eyeshadow turquoise",
  nl: "Oogschaduw turquoise",
  fr: "Turquoise à paupières"
}, {
  hex: "#00908a",
  code: "190 50 45",
  scope: "Design System Plus",
  de: "Klartürkis",
  en: "Clear turquoise",
  nl: "Helder turkoois",
  fr: "Turquoise clair"
}, {
  hex: "#829b98",
  code: "190 60 10",
  scope: "Design System Plus",
  de: "Dezenttürkis",
  en: "Subtle turquoise",
  nl: "Fatsoenlijk turkoois",
  fr: "Turquoise décent"
}, {
  hex: "#779d98",
  code: "190 60 15",
  scope: "Design System Plus",
  de: "Hellgrünspan",
  en: "Pale verdigris",
  nl: "Lichtgroen schaafsel",
  fr: "Span vert clair"
}, {
  hex: "#6ea09b",
  code: "190 60 20",
  scope: "Design System Plus",
  de: "Gänseteichgrün",
  en: "Goose pond green",
  nl: "Ganzenvijver groen",
  fr: "Vert pâquerette"
}, {
  hex: "#5ea39d",
  code: "190 60 25",
  scope: "Design System Plus",
  de: "Turmalintürkis",
  en: "Tourmaline turquoise",
  nl: "Toermalijn turkoois",
  fr: "Turmaline turquoise"
}, {
  hex: "#4da49e",
  code: "190 60 30",
  scope: "Design System Plus",
  de: "Baltikgrün",
  en: "Baltic green",
  nl: "Baltisch groen",
  fr: "Vert baltique"
}, {
  hex: "#39a6a0",
  code: "190 60 35",
  scope: "Design System Plus",
  de: "Keramikbleutürkis",
  en: "Ceramic blue turquoise",
  nl: "Keramische loodturkoois",
  fr: "Turquoise plombé céramique"
}, {
  hex: "#0ca8a1",
  code: "190 60 40",
  scope: "Design System Plus",
  de: "Baltiktürkis",
  en: "Baltic turquoise",
  nl: "Baltisch turkoois",
  fr: "Turquoise baltique"
}, {
  hex: "#00a8a0",
  code: "190 60 45",
  scope: "Design System Plus",
  de: "Tirolitblaugrün",
  en: "Tyrolite blue-green",
  nl: "Tiroliet blauwgroen",
  fr: "Vert bleu tirolite"
}, {
  hex: "#9ab4b1",
  code: "190 70 10",
  scope: "Design System Plus",
  de: "Marmorgrün",
  en: "Marble green",
  nl: "Marmer groen",
  fr: "Vert marbre"
}, {
  hex: "#8fb6b1",
  code: "190 70 15",
  scope: "Design System Plus",
  de: "Jadegrün",
  en: "Jade green",
  nl: "Jadegroen",
  fr: "Vert jade"
}, {
  hex: "#82b8b2",
  code: "190 70 20",
  scope: "Design System Plus",
  de: "Quellwassertürkis",
  en: "Spring water turquoise",
  nl: "Bronwater turquoise",
  fr: "Turquoise d'eau de source"
}, {
  hex: "#75bbb5",
  code: "190 70 25",
  scope: "Design System Plus",
  de: "Floridatürkis",
  en: "Florida turquoise",
  nl: "Florida turquoise",
  fr: "Turquoise de Floride"
}, {
  hex: "#69beb8",
  code: "190 70 30",
  scope: "Design System Plus",
  de: "Hygienegrün",
  en: "Hygiene green",
  nl: "Hygiënisch groen",
  fr: "Vert hygiénique"
}, {
  hex: "#55bfb7",
  code: "190 70 35",
  scope: "Design System Plus",
  de: "Arktisgrün",
  en: "Arctic green",
  nl: "Arctisch groen",
  fr: "Vert arctique"
}, {
  hex: "#b3cfca",
  code: "190 80 10",
  scope: "Design System Plus",
  de: "Andenopalgrün",
  en: "Andean opal green",
  nl: "Andes opaal groen",
  fr: "Vert opale des Andes"
}, {
  hex: "#a9d2cd",
  code: "190 80 15",
  scope: "Design System Plus",
  de: "Kalttürkis",
  en: "Cold turquoise",
  nl: "Koud turkoois",
  fr: "Turquoise froide"
}, {
  hex: "#9bd2cd",
  code: "190 80 20",
  scope: "Design System Plus",
  de: "Petroleumblau",
  en: "Teal blue",
  nl: "Petroleum blauw",
  fr: "Bleu pétrole"
}, {
  hex: "#8fd5cf",
  code: "190 80 25",
  scope: "Design System Plus",
  de: "Poolgrün",
  en: "Pool green",
  nl: "Zwembad groen",
  fr: "Vert de piscine"
}, {
  hex: "#c5d9d6",
  code: "190 85 05",
  scope: "Design System Plus",
  de: "Morgentauweiß",
  en: "Morning dew white",
  nl: "Ochtenddauw wit",
  fr: "Blanc rosée du matin"
}, {
  hex: "#badcd6",
  code: "190 85 10",
  scope: "Design System Plus",
  de: "Badesalzgrün",
  en: "Bath salt green",
  nl: "Badzout groen",
  fr: "Vert de sel de bain"
}, {
  hex: "#aadfd6",
  code: "190 85 15",
  scope: "Design System Plus",
  de: "Capriwasserblau",
  en: "Capri water blue",
  nl: "Capri waterblauw",
  fr: "Bleu eau de capri"
}, {
  hex: "#9ce2d7",
  code: "190 85 20",
  scope: "Design System Plus",
  de: "Horizontblau",
  en: "Horizon blue",
  nl: "Horizon blauw",
  fr: "Bleu horizon"
}, {
  hex: "#dbe6e2",
  code: "190 90 05",
  scope: "Design System Plus",
  de: "Kaltweiß",
  en: "Cool white",
  nl: "Koud wit",
  fr: "Blanc froid"
}, {
  hex: "#cfeae5",
  code: "190 90 10",
  scope: "Design System Plus",
  de: "Quellblau",
  en: "Source blue",
  nl: "Lente blauw",
  fr: "Bleu source"
}, {
  hex: "#e3edeb",
  code: "190 93 05",
  scope: "Design System Plus",
  de: "Ägyptischweiß",
  en: "Egyptian white",
  nl: "Egyptisch wit",
  fr: "Blanc égyptien"
}, {
  hex: "#444a4a",
  code: "200 20 05",
  scope: "Design System Plus",
  de: "Tarngrün",
  en: "Concealed green",
  nl: "Camouflagegroen",
  fr: "Vert camouflage"
}, {
  hex: "#3c4a4b",
  code: "200 20 10",
  scope: "Design System Plus",
  de: "Dunkelkiefergrün",
  en: "Dark pine green",
  nl: "Donker dennengroen",
  fr: "Vert pin foncé"
}, {
  hex: "#374a4b",
  code: "200 20 15",
  scope: "Design System Plus",
  de: "Dachziegelgrün",
  en: "Roof tile green",
  nl: "Dakpan groen",
  fr: "Vert tuile"
}, {
  hex: "#304c4e",
  code: "200 20 20",
  scope: "Design System Plus",
  de: "Buschgrün",
  en: "Shrub green",
  nl: "Struikgroen",
  fr: "Vert buisson"
}, {
  hex: "#264d4f",
  code: "200 20 23",
  scope: "Design System Plus",
  de: "Zollgrün",
  en: "Customs green",
  nl: "Douane groen",
  fr: "Zollgrün"
}, {
  hex: "#4f5858",
  code: "200 30 05",
  scope: "Design System Plus",
  de: "Finsternisgrün",
  en: "Darkness green",
  nl: "Eclips groen",
  fr: "Vert éclipse"
}, {
  hex: "#485b5b",
  code: "200 30 10",
  scope: "Design System Plus",
  de: "Baumrindengrün",
  en: "Tree bark green",
  nl: "Boomschors groen",
  fr: "Vert écorce d'arbre"
}, {
  hex: "#405d5d",
  code: "200 30 15",
  scope: "Design System Plus",
  de: "Hornblendegrün",
  en: "Hornblende green",
  nl: "Hoornblende groen",
  fr: "Vert cornu"
}, {
  hex: "#385e5f",
  code: "200 30 20",
  scope: "Design System Plus",
  de: "Malachitblautürkis",
  en: "Malachite blue turquoise",
  nl: "Malachiet blauw turkoois",
  fr: "Turquoise bleue malachite"
}, {
  hex: "#285d5e",
  code: "200 30 25",
  scope: "Design System Plus",
  de: "Antiktürkis",
  en: "Antique turquoise",
  nl: "Antiek turkoois",
  fr: "Turquoise antique"
}, {
  hex: "#1a5f62",
  code: "200 30 30",
  scope: "Design System Plus",
  de: "Wolltürkis",
  en: "Wool turquoise",
  nl: "Wol turkoois",
  fr: "Turquoise de laine"
}, {
  hex: "#006164",
  code: "200 30 33",
  scope: "Design System Plus",
  de: "Eisdunkeltürkis",
  en: "Ice dark turquoise",
  nl: "Ijs donker turkoois",
  fr: "Turquoise foncé glacé"
}, {
  hex: "#616c6c",
  code: "200 40 05",
  scope: "Design System Plus",
  de: "Kalkspatgraugrün",
  en: "Calcite grey green",
  nl: "Kalk spar grijsgroen",
  fr: "Vert spath calcaire"
}, {
  hex: "#596d6e",
  code: "200 40 10",
  scope: "Design System Plus",
  de: "Brochantitgrün",
  en: "Brochantite green",
  nl: "Brochantiet groen",
  fr: "Vert de brochantite"
}, {
  hex: "#4f6f6f",
  code: "200 40 15",
  scope: "Design System Plus",
  de: "Eisenkiesgrün",
  en: "Pyrite green",
  nl: "IJzerpyriet groen",
  fr: "Vert de fer et de gravier"
}, {
  hex: "#427172",
  code: "200 40 20",
  scope: "Design System Plus",
  de: "Alpendämmerblau",
  en: "Dusky alpine blue",
  nl: "Alpine schemerblauw",
  fr: "Bleu crépuscule des Alpes"
}, {
  hex: "#377374",
  code: "200 40 25",
  scope: "Design System Plus",
  de: "Badgrün",
  en: "Bath green",
  nl: "Badgroen",
  fr: "Vert de bain"
}, {
  hex: "#237477",
  code: "200 40 30",
  scope: "Design System Plus",
  de: "Mayablau",
  en: "Mayan blue",
  nl: "Maya blauw",
  fr: "Bleu maya"
}, {
  hex: "#007579",
  code: "200 40 35",
  scope: "Design System Plus",
  de: "Byzantinischblau",
  en: "Byzantine blue",
  nl: "Byzantijns blauw",
  fr: "Bleu byzantin"
}, {
  hex: "#00787d",
  code: "200 40 40",
  scope: "Design System Plus",
  de: "Aktivtürkis",
  en: "Active turquoise",
  nl: "Actief turkoois",
  fr: "Turquoise active"
}, {
  hex: "#748080",
  code: "200 50 05",
  scope: "Design System Plus",
  de: "Nordgrau",
  en: "North grey",
  nl: "Noordgrijs",
  fr: "Gris nord"
}, {
  hex: "#6c8384",
  code: "200 50 10",
  scope: "Design System Plus",
  de: "Augengrau",
  en: "Eye grey",
  nl: "Oog grijs",
  fr: "Gris des yeux"
}, {
  hex: "#618686",
  code: "200 50 15",
  scope: "Design System Plus",
  de: "Nickelerzgrün",
  en: "Nickel ore green",
  nl: "Nikkelerts groen",
  fr: "Vert nickelé"
}, {
  hex: "#548788",
  code: "200 50 20",
  scope: "Design System Plus",
  de: "Gischtgrün",
  en: "Seafoam green",
  nl: "Spuitgroen",
  fr: "Vert givré"
}, {
  hex: "#46898c",
  code: "200 50 25",
  scope: "Design System Plus",
  de: "Kandinskytürkis",
  en: "Kandinsky turquoise",
  nl: "Kandinsky turkoois",
  fr: "Kandinsky turquoise"
}, {
  hex: "#308b8d",
  code: "200 50 30",
  scope: "Design System Plus",
  de: "Karibiktürkis",
  en: "Caribbean turquoise",
  nl: "Caribisch turkoois",
  fr: "Turquoise des Caraïbes"
}, {
  hex: "#118e92",
  code: "200 50 35",
  scope: "Design System Plus",
  de: "Brunnenblau",
  en: "Well blue",
  nl: "Fontein blauw",
  fr: "Bleu foncé"
}, {
  hex: "#008f93",
  code: "200 50 40",
  scope: "Design System Plus",
  de: "Industrieblau",
  en: "Industrial blue",
  nl: "Industrieel blauw",
  fr: "Bleu industriel"
}, {
  hex: "#009096",
  code: "200 50 45",
  scope: "Design System Plus",
  de: "Indiablau",
  en: "India blue",
  nl: "India blauw",
  fr: "Bleu indien"
}, {
  hex: "#8c9999",
  code: "200 60 05",
  scope: "Design System Plus",
  de: "Schattengrau",
  en: "Shady grey",
  nl: "Schaduwgrijs",
  fr: "Gris ombre"
}, {
  hex: "#829a9b",
  code: "200 60 10",
  scope: "Design System Plus",
  de: "Nordkapgrau",
  en: "North Cape grey",
  nl: "Noordkaap grijs",
  fr: "Gris cap nord"
}, {
  hex: "#769d9e",
  code: "200 60 15",
  scope: "Design System Plus",
  de: "Waidindigo",
  en: "Woad indigo",
  nl: "Waidindigo",
  fr: "Waidindigo"
}, {
  hex: "#6aa0a1",
  code: "200 60 20",
  scope: "Design System Plus",
  de: "Jugendstiltürkis",
  en: "Art nouveau turquoise",
  nl: "Jugendstil turkoois",
  fr: "Turquoise art nouveau"
}, {
  hex: "#59a1a2",
  code: "200 60 25",
  scope: "Design System Plus",
  de: "Kühlboxeistürkis",
  en: "Coolbox ice turquoise",
  nl: "Koelbox turquoise",
  fr: "Boxe réfrigéréeisturquoise"
}, {
  hex: "#48a4a5",
  code: "200 60 30",
  scope: "Design System Plus",
  de: "Aquamarinblau",
  en: "Aquamarine blue",
  nl: "Aquamarijnblauw",
  fr: "Bleu aigue-marine"
}, {
  hex: "#33a5a9",
  code: "200 60 35",
  scope: "Design System Plus",
  de: "Arktisblau",
  en: "Arctic blue",
  nl: "Arctisch blauw",
  fr: "Bleu arctique"
}, {
  hex: "#05a8ac",
  code: "200 60 40",
  scope: "Design System Plus",
  de: "Wachsstiftblau",
  en: "Wax crayon blue",
  nl: "Waskrijt blauw",
  fr: "Bleu crayon de cire"
}, {
  hex: "#a5b1b1",
  code: "200 70 05",
  scope: "Design System Plus",
  de: "Prinzengrau",
  en: "Prince grey",
  nl: "Prins grijs",
  fr: "Gris prince"
}, {
  hex: "#9ab5b5",
  code: "200 70 10",
  scope: "Design System Plus",
  de: "Calcitblau",
  en: "Calcite blue",
  nl: "Calciet blauw",
  fr: "Bleu calcite"
}, {
  hex: "#8cb6b6",
  code: "200 70 15",
  scope: "Design System Plus",
  de: "Kaltfrontgrün",
  en: "Cold front green",
  nl: "Koud front groen",
  fr: "Vert à front froid"
}, {
  hex: "#82b9b9",
  code: "200 70 20",
  scope: "Design System Plus",
  de: "Eisvogeltürkis",
  en: "Kingfisher turquoise",
  nl: "IJsvogel turquoise",
  fr: "Turquoise martin-pêcheur"
}, {
  hex: "#74bcbf",
  code: "200 70 25",
  scope: "Design System Plus",
  de: "Frischbleu",
  en: "Fresh soft blue",
  nl: "Vers lood",
  fr: "Plomb frais"
}, {
  hex: "#bfcbca",
  code: "200 80 05",
  scope: "Design System Plus",
  de: "Chinalichtgrün",
  en: "China light green",
  nl: "Chinees lichtgroen",
  fr: "Vert clair de Chine"
}, {
  hex: "#b2cece",
  code: "200 80 10",
  scope: "Design System Plus",
  de: "Barockkalkbleu",
  en: "Baroque chalk soft blue",
  nl: "Barok kalklood",
  fr: "Bleu de chaux baroque"
}, {
  hex: "#a6cfce",
  code: "200 80 15",
  scope: "Design System Plus",
  de: "Eisboutiquetürkis",
  en: "Ice boutique turquoise",
  nl: "Ijs boetiek turquoise",
  fr: "Boutique de glace turquoise"
}, {
  hex: "#9ad4d3",
  code: "200 80 20",
  scope: "Design System Plus",
  de: "Sommerbleu",
  en: "Summer soft blue",
  nl: "Zomer leiden",
  fr: "Plomb d'été"
}, {
  hex: "#8cd5d6",
  code: "200 80 25",
  scope: "Design System Plus",
  de: "Bergseeblau",
  en: "Mountain lake blue",
  nl: "Bergzee blauw",
  fr: "Bleu lac de montagne"
}, {
  hex: "#cad7d7",
  code: "200 85 05",
  scope: "Design System Plus",
  de: "Bastlichtgrau",
  en: "Raffia light grey",
  nl: "Bast lichtgrijs",
  fr: "Gris raphia"
}, {
  hex: "#c0dada",
  code: "200 85 10",
  scope: "Design System Plus",
  de: "Kaltlufttürkis",
  en: "Cold air turquoise",
  nl: "Koude lucht turquoise",
  fr: "Turquoise froid"
}, {
  hex: "#b3dddd",
  code: "200 85 15",
  scope: "Design System Plus",
  de: "Frosthellbleu",
  en: "Frosty soft blue",
  nl: "Frosthell lood",
  fr: "Frosthellbleu"
}, {
  hex: "#a6e0df",
  code: "200 85 20",
  scope: "Design System Plus",
  de: "Eiskristallblau",
  en: "Ice crystal blue",
  nl: "Ijskristalblauw",
  fr: "Bleu cristal de glace"
}, {
  hex: "#dbe8e5",
  code: "200 90 05",
  scope: "Design System Plus",
  de: "Frostgrün",
  en: "Frosty green",
  nl: "Vorstgroen",
  fr: "Vert givré"
}, {
  hex: "#cee9e5",
  code: "200 90 10",
  scope: "Design System Plus",
  de: "Frostweißblau",
  en: "Frosty white blue",
  nl: "Vorst wit blauw",
  fr: "Bleu blanc givré"
}, {
  hex: "#e2eeeb",
  code: "200 93 05",
  scope: "Design System Plus",
  de: "Klirrendweiß",
  en: "Chilly white",
  nl: "Klinkend wit",
  fr: "Blanc éclatant"
}, {
  hex: "#4a5a5c",
  code: "210 30 10",
  scope: "Design System Plus",
  de: "Graphitschwarzgrün",
  en: "Graphite black green",
  nl: "Grafiet zwart groen",
  fr: "Vert noir graphite"
}, {
  hex: "#415c60",
  code: "210 30 15",
  scope: "Design System Plus",
  de: "Stockentenblau",
  en: "Mallard blue",
  nl: "Wilde eend blauw",
  fr: "Bleu canard colvert"
}, {
  hex: "#365e64",
  code: "210 30 20",
  scope: "Design System Plus",
  de: "Transportergrün",
  en: "Transporter green",
  nl: "Transporteur groen",
  fr: "Vert transporteur"
}, {
  hex: "#2b5e65",
  code: "210 30 25",
  scope: "Design System Plus",
  de: "Tiefatlantikblau",
  en: "Deep Atlantic blue",
  nl: "Diep Atlantisch blauw",
  fr: "Bleu Atlantique profond"
}, {
  hex: "#175f68",
  code: "210 30 30",
  scope: "Design System Plus",
  de: "Kaliblau",
  en: "Kali blue",
  nl: "Kaliber blauw",
  fr: "Bleu de potassium"
}, {
  hex: "#586c6f",
  code: "210 40 10",
  scope: "Design System Plus",
  de: "Leinengrau",
  en: "Linen grey",
  nl: "Linnen grijs",
  fr: "Gris lin"
}, {
  hex: "#4f6f74",
  code: "210 40 15",
  scope: "Design System Plus",
  de: "Chinagrünblau",
  en: "China green blue",
  nl: "Chinees groen blauw",
  fr: "Bleu vert de Chine"
}, {
  hex: "#437177",
  code: "210 40 20",
  scope: "Design System Plus",
  de: "Dämmerblau",
  en: "Dusk blue",
  nl: "Schemerblauw",
  fr: "Bleu crépuscule"
}, {
  hex: "#347178",
  code: "210 40 25",
  scope: "Design System Plus",
  de: "Hosenblau",
  en: "Trouser blue",
  nl: "Broek blauw",
  fr: "Bleu pantalon"
}, {
  hex: "#1e737d",
  code: "210 40 30",
  scope: "Design System Plus",
  de: "Indigoblau",
  en: "Indigo blue",
  nl: "Indigo blauw",
  fr: "Bleu indigo"
}, {
  hex: "#007681",
  code: "210 40 35",
  scope: "Design System Plus",
  de: "Kaltblau",
  en: "Cold blue",
  nl: "Koud blauw",
  fr: "Bleu froid"
}, {
  hex: "#007481",
  code: "210 40 38",
  scope: "Design System Plus",
  de: "Marienblau",
  en: "Mary blue",
  nl: "Maria blauw",
  fr: "Bleu marie"
}, {
  hex: "#6b8386",
  code: "210 50 10",
  scope: "Design System Plus",
  de: "Uniformgrüngrau",
  en: "Uniform green grey",
  nl: "Uniform groen-grijs",
  fr: "Gris vert uniforme"
}, {
  hex: "#628488",
  code: "210 50 15",
  scope: "Design System Plus",
  de: "Labradoritgrün",
  en: "Labradorite green",
  nl: "Labradoriet groen",
  fr: "Vert labradorite"
}, {
  hex: "#54868d",
  code: "210 50 20",
  scope: "Design System Plus",
  de: "Emailleantikgrün",
  en: "Enamel antique green",
  nl: "Email antiek groen",
  fr: "Vert antique émaillé"
}, {
  hex: "#458990",
  code: "210 50 25",
  scope: "Design System Plus",
  de: "Cranachblau",
  en: "Cranach blue",
  nl: "Cranach blauw",
  fr: "Bleu cranach"
}, {
  hex: "#2d8a94",
  code: "210 50 30",
  scope: "Design System Plus",
  de: "Chinablau",
  en: "China blue",
  nl: "China blauw",
  fr: "Bleu chine"
}, {
  hex: "#148c98",
  code: "210 50 35",
  scope: "Design System Plus",
  de: "Gletscherblau",
  en: "Glacier blue",
  nl: "Gletsjerblauw",
  fr: "Bleu glacier"
}, {
  hex: "#008e9b",
  code: "210 50 40",
  scope: "Design System Plus",
  de: "Curaçaoblau",
  en: "Curaçao blue",
  nl: "Curaçao blauw",
  fr: "Bleu curaçao"
}, {
  hex: "#008f9e",
  code: "210 50 45",
  scope: "Design System Plus",
  de: "Atlantikblau",
  en: "Atlantic blue",
  nl: "Atlantisch blauw",
  fr: "Bleu atlantique"
}, {
  hex: "#829a9d",
  code: "210 60 10",
  scope: "Design System Plus",
  de: "Aschblau",
  en: "Ash blue",
  nl: "Asblauw",
  fr: "Bleu cendré"
}, {
  hex: "#769ca0",
  code: "210 60 15",
  scope: "Design System Plus",
  de: "Baltikblau",
  en: "Baltic blue",
  nl: "Baltisch blauw",
  fr: "Bleu baltique"
}, {
  hex: "#6ba1a7",
  code: "210 60 20",
  scope: "Design System Plus",
  de: "Strandblau",
  en: "Beach blue",
  nl: "Strand blauw",
  fr: "Bleu de la plage"
}, {
  hex: "#5aa4ab",
  code: "210 60 25",
  scope: "Design System Plus",
  de: "Basilikablau",
  en: "Basilica blue",
  nl: "Basiliek blauw",
  fr: "Bleu basilic"
}, {
  hex: "#48a5af",
  code: "210 60 30",
  scope: "Design System Plus",
  de: "Donaublau",
  en: "Danube blue",
  nl: "Donau blauw",
  fr: "Bleu du Danube"
}, {
  hex: "#2ca5b1",
  code: "210 60 35",
  scope: "Design System Plus",
  de: "Altdorferhimmelblau",
  en: "Altdorf sky blue",
  nl: "Altdorfer hemelsblauw",
  fr: "Altdorferhimmelblau"
}, {
  hex: "#00a8b5",
  code: "210 60 40",
  scope: "Design System Plus",
  de: "Grellblau",
  en: "Garish blue",
  nl: "Helderblauw",
  fr: "Bleu vif"
}, {
  hex: "#9bb4b7",
  code: "210 70 10",
  scope: "Design System Plus",
  de: "Sturmgrau",
  en: "Storm grey",
  nl: "Stormgrijs",
  fr: "Gris tempête"
}, {
  hex: "#8fb6ba",
  code: "210 70 15",
  scope: "Design System Plus",
  de: "Persischblau",
  en: "Persian blue",
  nl: "Perzisch blauw",
  fr: "Bleu persan"
}, {
  hex: "#81b9bf",
  code: "210 70 20",
  scope: "Design System Plus",
  de: "Aquablau",
  en: "Aqua blue",
  nl: "Aqua blauw",
  fr: "Bleu aqua"
}, {
  hex: "#73bbc3",
  code: "210 70 25",
  scope: "Design System Plus",
  de: "Maritimbleu",
  en: "Maritime soft blue",
  nl: "Maritieme leiding",
  fr: "Bleu marine"
}, {
  hex: "#61bec8",
  code: "210 70 30",
  scope: "Design System Plus",
  de: "Bergblau",
  en: "Mountain blue",
  nl: "Blauw in de bergen",
  fr: "Bleu montagne"
}, {
  hex: "#4cc0cb",
  code: "210 70 35",
  scope: "Design System Plus",
  de: "Weitsichtblau",
  en: "Panorama blue",
  nl: "Verziend blauw",
  fr: "Bleu large"
}, {
  hex: "#b7d0d1",
  code: "210 80 10",
  scope: "Design System Plus",
  de: "Türkisgrau",
  en: "Turquoise grey",
  nl: "Turquoise grijs",
  fr: "Gris turquoise"
}, {
  hex: "#aad2d4",
  code: "210 80 15",
  scope: "Design System Plus",
  de: "Delphinblau",
  en: "Dolphin blue",
  nl: "Dolfijn blauw",
  fr: "Bleu dauphin"
}, {
  hex: "#9cd3d8",
  code: "210 80 20",
  scope: "Design System Plus",
  de: "Duftblau",
  en: "Aroma blue",
  nl: "Blauw geparfumeerd",
  fr: "Bleu parfumé"
}, {
  hex: "#8fd6dd",
  code: "210 80 25",
  scope: "Design System Plus",
  de: "Knallbleu",
  en: "Vibrant soft blue",
  nl: "Helderblauw",
  fr: "Bleu vif"
}, {
  hex: "#c9d8d9",
  code: "210 85 05",
  scope: "Design System Plus",
  de: "Siestaweiß",
  en: "Siesta white",
  nl: "Siestawit",
  fr: "Siestablanc"
}, {
  hex: "#baddde",
  code: "210 85 10",
  scope: "Design System Plus",
  de: "Mintblau",
  en: "Mint blue",
  nl: "Mintblauw",
  fr: "Bleu menthe"
}, {
  hex: "#b5dedf",
  code: "210 85 15",
  scope: "Design System Plus",
  de: "Feinblau",
  en: "Fine blue",
  nl: "Fijn blauw",
  fr: "Bleu fin"
}, {
  hex: "#a7e0e1",
  code: "210 85 20",
  scope: "Design System Plus",
  de: "Blassblau",
  en: "Pale blue",
  nl: "Lichtblauw",
  fr: "Bleu pâle"
}, {
  hex: "#dae7e5",
  code: "210 90 05",
  scope: "Design System Plus",
  de: "Tüllbleu",
  en: "Tulle soft blue",
  nl: "Tule lood",
  fr: "Plomb de tulle"
}, {
  hex: "#cde9e7",
  code: "210 90 10",
  scope: "Design System Plus",
  de: "Antarktisblau",
  en: "Antarctic blue",
  nl: "Antarctisch blauw",
  fr: "Bleu antarctique"
}, {
  hex: "#43494b",
  code: "220 20 05",
  scope: "Design System Plus",
  de: "Navyschwarz",
  en: "Navy black",
  nl: "Marine zwart",
  fr: "Noir navy"
}, {
  hex: "#3c4a4e",
  code: "220 20 10",
  scope: "Design System Plus",
  de: "Indigokarmin",
  en: "Indigo carmine",
  nl: "Indigo karmijn",
  fr: "Carmin d'indigo"
}, {
  hex: "#344a50",
  code: "220 20 15",
  scope: "Design System Plus",
  de: "Künstlerblau",
  en: "Artist blue",
  nl: "Kunstenaar blauw",
  fr: "Bleu artiste"
}, {
  hex: "#2d4b53",
  code: "220 20 20",
  scope: "Design System Plus",
  de: "Naturindigo",
  en: "Natural indigo",
  nl: "Natuurlijk indigo",
  fr: "Indigo naturel"
}, {
  hex: "#51595a",
  code: "220 30 05",
  scope: "Design System Plus",
  de: "Pandaschwarz",
  en: "Panda black",
  nl: "Panda zwart",
  fr: "Noir panda"
}, {
  hex: "#4a5b5e",
  code: "220 30 10",
  scope: "Design System Plus",
  de: "Pallasitblau",
  en: "Pallasite blue",
  nl: "Pallasiet blauw",
  fr: "Bleu pallasite"
}, {
  hex: "#435d64",
  code: "220 30 15",
  scope: "Design System Plus",
  de: "Orkangrünblau",
  en: "Hurricane green blue",
  nl: "Gagelgroen blauw",
  fr: "Bleu vert orcane"
}, {
  hex: "#385e66",
  code: "220 30 20",
  scope: "Design System Plus",
  de: "Aquarellblau",
  en: "Watercolour blue",
  nl: "Aquarel blauw",
  fr: "Bleu aquarelle"
}, {
  hex: "#2e606b",
  code: "220 30 25",
  scope: "Design System Plus",
  de: "Korallenblau",
  en: "Coral blue",
  nl: "Koraalblauw",
  fr: "Bleu corail"
}, {
  hex: "#155f6d",
  code: "220 30 30",
  scope: "Design System Plus",
  de: "Sandelholzblau",
  en: "Sandalwood grey blue",
  nl: "Sandelhout blauw",
  fr: "Bleu santal"
}, {
  hex: "#626c6e",
  code: "220 40 05",
  scope: "Design System Plus",
  de: "Limousinengraublau",
  en: "Limousine grey blue",
  nl: "Limousine grijs blauw",
  fr: "Gris limousine"
}, {
  hex: "#5a6e72",
  code: "220 40 10",
  scope: "Design System Plus",
  de: "Korundblau",
  en: "Corundum blue",
  nl: "Korund blauw",
  fr: "Bleu corail"
}, {
  hex: "#4f6f77",
  code: "220 40 15",
  scope: "Design System Plus",
  de: "Kittelblau",
  en: "Smock blue",
  nl: "Smok blauw",
  fr: "Bleu blouse"
}, {
  hex: "#45717b",
  code: "220 40 20",
  scope: "Design System Plus",
  de: "Beizeblau",
  en: "Mordant blue",
  nl: "Blauwe vlek",
  fr: "Bleu mordoré"
}, {
  hex: "#37737f",
  code: "220 40 25",
  scope: "Design System Plus",
  de: "Baumwollindigo",
  en: "Cotton indigo",
  nl: "Katoen indigo",
  fr: "Indigo en coton"
}, {
  hex: "#1f7586",
  code: "220 40 30",
  scope: "Design System Plus",
  de: "Fjordblau",
  en: "Fjord blue",
  nl: "Fjordblauw",
  fr: "Bleu fjord"
}, {
  hex: "#007689",
  code: "220 40 35",
  scope: "Design System Plus",
  de: "Azurgrünblau",
  en: "Azure green blue",
  nl: "Azuurgroen blauw",
  fr: "Bleu azur"
}, {
  hex: "#00788e",
  code: "220 40 40",
  scope: "Design System Plus",
  de: "Cyanblau",
  en: "Cyan blue",
  nl: "Cyaanblauw",
  fr: "Bleu cyan"
}, {
  hex: "#788284",
  code: "220 50 05",
  scope: "Design System Plus",
  de: "Winterwolkengrau",
  en: "Winter cloud grey",
  nl: "Winterwolk grijs",
  fr: "Gris des nuages d'hiver"
}, {
  hex: "#6f8388",
  code: "220 50 10",
  scope: "Design System Plus",
  de: "Kadettgrau",
  en: "Cadet grey",
  nl: "Cadet grijs",
  fr: "Gris cadet"
}, {
  hex: "#62858d",
  code: "220 50 15",
  scope: "Design System Plus",
  de: "Holbeinblaugrau",
  en: "Holbein blue grey",
  nl: "Holbein blauw-grijs",
  fr: "Gris bleu holbein"
}, {
  hex: "#558791",
  code: "220 50 20",
  scope: "Design System Plus",
  de: "Schattenblau",
  en: "Shady blue",
  nl: "Schaduwblauw",
  fr: "Bleu ombre"
}, {
  hex: "#488895",
  code: "220 50 25",
  scope: "Design System Plus",
  de: "Frescoblau",
  en: "Fresco blue",
  nl: "Fresco blauw",
  fr: "Bleu fresco"
}, {
  hex: "#318899",
  code: "220 50 30",
  scope: "Design System Plus",
  de: "Handwerkerblau",
  en: "Craftsman blue",
  nl: "Ambachtelijk blauw",
  fr: "Bleu artisan"
}, {
  hex: "#198ca0",
  code: "220 50 35",
  scope: "Design System Plus",
  de: "Markerblau",
  en: "Marker blue",
  nl: "Marker blauw",
  fr: "Bleu marqueur"
}, {
  hex: "#008ea5",
  code: "220 50 40",
  scope: "Design System Plus",
  de: "Spielzeugblau",
  en: "Toy blue",
  nl: "Speelgoed blauw",
  fr: "Bleu jouet"
}, {
  hex: "#8e989a",
  code: "220 60 05",
  scope: "Design System Plus",
  de: "Tiefseegrau",
  en: "Deep sea grey",
  nl: "Diep zeegrijs",
  fr: "Gris océan profond"
}, {
  hex: "#839ba0",
  code: "220 60 10",
  scope: "Design System Plus",
  de: "Kachelblau",
  en: "Tile blue",
  nl: "Tegel blauw",
  fr: "Bleu faïence"
}, {
  hex: "#799da5",
  code: "220 60 15",
  scope: "Design System Plus",
  de: "Morgenblau",
  en: "Morning blue",
  nl: "Ochtendblauw",
  fr: "Bleu du matin"
}, {
  hex: "#699fab",
  code: "220 60 20",
  scope: "Design System Plus",
  de: "Frostblau",
  en: "Frost blue",
  nl: "Vorstblauw",
  fr: "Bleu givré"
}, {
  hex: "#5ba1b0",
  code: "220 60 25",
  scope: "Design System Plus",
  de: "Sommertürkisblau",
  en: "Summer turquoise blue",
  nl: "Zomer turquoise blauw",
  fr: "Bleu turquoise d'été"
}, {
  hex: "#4aa4b5",
  code: "220 60 30",
  scope: "Design System Plus",
  de: "Fischerblau",
  en: "Fischer blue",
  nl: "Visser blauw",
  fr: "Bleu pêcheur"
}, {
  hex: "#36a3b8",
  code: "220 60 35",
  scope: "Design System Plus",
  de: "Planetblau",
  en: "Planet blue",
  nl: "Planeet blauw",
  fr: "Bleu planète"
}, {
  hex: "#00a5bd",
  code: "220 60 40",
  scope: "Design System Plus",
  de: "Januarblau",
  en: "January blue",
  nl: "Januari blauw",
  fr: "Bleu de janvier"
}, {
  hex: "#a6b2b5",
  code: "220 70 05",
  scope: "Design System Plus",
  de: "Temperiertgrau",
  en: "Tempered grey",
  nl: "Getemperd grijs",
  fr: "Gris tempéré"
}, {
  hex: "#9db5bb",
  code: "220 70 10",
  scope: "Design System Plus",
  de: "Mohairbleugrau",
  en: "Mohair soft blue grey",
  nl: "Mohair loodgrijs",
  fr: "Gris plomb mohair"
}, {
  hex: "#90b8c0",
  code: "220 70 15",
  scope: "Design System Plus",
  de: "Küchenblau",
  en: "Kitchen blue",
  nl: "Keuken blauw",
  fr: "Bleu cuisine"
}, {
  hex: "#84b9c4",
  code: "220 70 20",
  scope: "Design System Plus",
  de: "Gastronomieblau",
  en: "Culinary blue",
  nl: "Gastronomie blauw",
  fr: "Bleu gastronomique"
}, {
  hex: "#72bac9",
  code: "220 70 25",
  scope: "Design System Plus",
  de: "Blousonblau",
  en: "Blouson blue",
  nl: "Blouson blauw",
  fr: "Blouson bleu"
}, {
  hex: "#61bacc",
  code: "220 70 30",
  scope: "Design System Plus",
  de: "Gebirgsblau",
  en: "Mountain range blue",
  nl: "Blauw in de bergen",
  fr: "Bleu montagne"
}, {
  hex: "#4bbfd4",
  code: "220 70 35",
  scope: "Design System Plus",
  de: "Ferienblau",
  en: "Holiday blue",
  nl: "Vakantie blauw",
  fr: "Bleu de vacances"
}, {
  hex: "#bfcccd",
  code: "220 80 05",
  scope: "Design System Plus",
  de: "Pastellblau",
  en: "Pastel blue",
  nl: "Pastelblauw",
  fr: "Bleu pastel"
}, {
  hex: "#b5d0d5",
  code: "220 80 10",
  scope: "Design System Plus",
  de: "Klinischbleu",
  en: "Clinical soft blue",
  nl: "Klinische leiding",
  fr: "Plomb clinique"
}, {
  hex: "#a6cfd8",
  code: "220 80 15",
  scope: "Design System Plus",
  de: "Kinderbleu",
  en: "Children's soft blue",
  nl: "Lood voor kinderen",
  fr: "Plomb pour enfants"
}, {
  hex: "#9ed4e0",
  code: "220 80 20",
  scope: "Design System Plus",
  de: "Turmalinwasserblau",
  en: "Tourmaline water blue",
  nl: "Toermalijn waterblauw",
  fr: "Bleu d'eau de tourmaline"
}, {
  hex: "#92d7e3",
  code: "220 80 25",
  scope: "Design System Plus",
  de: "Frischblau",
  en: "Fresh blue",
  nl: "Fris blauw",
  fr: "Bleu frais"
}, {
  hex: "#ccd9dc",
  code: "220 85 05",
  scope: "Design System Plus",
  de: "Transparentbleu",
  en: "Transparent blue",
  nl: "Transparant lood",
  fr: "Bleu transparent"
}, {
  hex: "#c0dce1",
  code: "220 85 10",
  scope: "Design System Plus",
  de: "Eisscherbenbleu",
  en: "Ice shard soft blue",
  nl: "Ijsscherf lood",
  fr: "Plomb de glace"
}, {
  hex: "#b3dee6",
  code: "220 85 15",
  scope: "Design System Plus",
  de: "Polarblau",
  en: "Polar blue",
  nl: "Polair blauw",
  fr: "Bleu polaire"
}, {
  hex: "#dae7e6",
  code: "220 90 05",
  scope: "Design System Plus",
  de: "Kaltlichtbleu",
  en: "Cold soft blue",
  nl: "Koud lood",
  fr: "Plomb de lumière froide"
}, {
  hex: "#cde7e7",
  code: "220 90 10",
  scope: "Design System Plus",
  de: "Vollmondgrau",
  en: "Full moon grey",
  nl: "Volle maan grijs",
  fr: "Gris pleine lune"
}, {
  hex: "#3f4b50",
  code: "230 20 10",
  scope: "Design System Plus",
  de: "Erzblauschwarz",
  en: "Ore bluish black",
  nl: "Boog blauw-zwart",
  fr: "Noir bleu archaïque"
}, {
  hex: "#384b53",
  code: "230 20 15",
  scope: "Design System Plus",
  de: "Firmamentblau",
  en: "Firmanent blue",
  nl: "Firmament blauw",
  fr: "Bleu menthe"
}, {
  hex: "#2d4955",
  code: "230 20 20",
  scope: "Design System Plus",
  de: "Preußischblau",
  en: "Prussian blue",
  nl: "Pruisisch blauw",
  fr: "Bleu de Prusse"
}, {
  hex: "#4d5b61",
  code: "230 30 10",
  scope: "Design System Plus",
  de: "Galenitblau",
  en: "Galenite blue",
  nl: "Galena blauw",
  fr: "Bleu de galène"
}, {
  hex: "#435b65",
  code: "230 30 15",
  scope: "Design System Plus",
  de: "Beerenblaugrün",
  en: "Berry blue green",
  nl: "Bessen blauwgroen",
  fr: "Bleu-vert baie"
}, {
  hex: "#3a5d6a",
  code: "230 30 20",
  scope: "Design System Plus",
  de: "Petroldunkelblau",
  en: "Teal dark blue",
  nl: "Petroleum donkerblauw",
  fr: "Bleu pétrole foncé"
}, {
  hex: "#2d5e6f",
  code: "230 30 25",
  scope: "Design System Plus",
  de: "Gewitterblau",
  en: "Thunderstorm blue",
  nl: "Onweer blauw",
  fr: "Bleu orage"
}, {
  hex: "#5b6d74",
  code: "230 40 10",
  scope: "Design System Plus",
  de: "Zapfengrünblau",
  en: "Cone green blue",
  nl: "Kegel groen blauw",
  fr: "Bleu vert pomme de pin"
}, {
  hex: "#536e79",
  code: "230 40 15",
  scope: "Design System Plus",
  de: "Wacholderbeerenblau",
  en: "Juniper berry blue",
  nl: "Jeneverbes blauw",
  fr: "Bleu genévrier"
}, {
  hex: "#48717f",
  code: "230 40 20",
  scope: "Design System Plus",
  de: "Sterntauchertürkis",
  en: "Loon turquoise",
  nl: "Turquoise met ster",
  fr: "Plongeon turquoise étoilé"
}, {
  hex: "#387184",
  code: "230 40 25",
  scope: "Design System Plus",
  de: "Werkstattblau",
  en: "Workshop blue",
  nl: "Workshop blauw",
  fr: "Bleu atelier"
}, {
  hex: "#2c738a",
  code: "230 40 30",
  scope: "Design System Plus",
  de: "Pilotenblau",
  en: "Pilot blue",
  nl: "Piloot blauw",
  fr: "Bleu pilote"
}, {
  hex: "#007590",
  code: "230 40 35",
  scope: "Design System Plus",
  de: "Tintenblau",
  en: "Ink blue",
  nl: "Inkt blauw",
  fr: "Bleu encre"
}, {
  hex: "#007593",
  code: "230 40 40",
  scope: "Design System Plus",
  de: "Technoblau",
  en: "Techno blue",
  nl: "Technoblauw",
  fr: "Bleu techno"
}, {
  hex: "#6f838a",
  code: "230 50 10",
  scope: "Design System Plus",
  de: "Kiesgraublau",
  en: "Gravel grey blue",
  nl: "Grindgrijs blauw",
  fr: "Bleu gris gravier"
}, {
  hex: "#658690",
  code: "230 50 15",
  scope: "Design System Plus",
  de: "Fichtenblau",
  en: "Spruce blue",
  nl: "Vurenblauw",
  fr: "Bleu épicéa"
}, {
  hex: "#5a8797",
  code: "230 50 20",
  scope: "Design System Plus",
  de: "Freizeitblau",
  en: "Casual blue",
  nl: "Vrije tijd blauw",
  fr: "Bleu loisir"
}, {
  hex: "#4d889b",
  code: "230 50 25",
  scope: "Design System Plus",
  de: "Vergissmeinnichtblau",
  en: "Forget-me-not blue",
  nl: "Vergeet-me-nietje blauw",
  fr: "Bleu myosotis"
}, {
  hex: "#378ba3",
  code: "230 50 30",
  scope: "Design System Plus",
  de: "Zirkonblau",
  en: "Zircon blue",
  nl: "Zirkoonblauw",
  fr: "Bleu zircon"
}, {
  hex: "#1f8ba6",
  code: "230 50 35",
  scope: "Design System Plus",
  de: "Lagunenblau",
  en: "Lagoon blue",
  nl: "Lagune blauw",
  fr: "Bleu lagon"
}, {
  hex: "#008cad",
  code: "230 50 40",
  scope: "Design System Plus",
  de: "Azorenblau",
  en: "Azores blue",
  nl: "Azoren blauw",
  fr: "Bleu azur"
}, {
  hex: "#869ca4",
  code: "230 60 10",
  scope: "Design System Plus",
  de: "Eisvogelgrau",
  en: "Kingfisher grey",
  nl: "IJsvogel grijs",
  fr: "Gris martin-pêcheur"
}, {
  hex: "#7b9ca7",
  code: "230 60 15",
  scope: "Design System Plus",
  de: "Silbertannenblau",
  en: "Silver fir blue",
  nl: "Zilverspar blauw",
  fr: "Bleu sapin argenté"
}, {
  hex: "#6e9eae",
  code: "230 60 20",
  scope: "Design System Plus",
  de: "Pyjamablau",
  en: "Pyjama blue",
  nl: "Pyjama blauw",
  fr: "Bleu pyjama"
}, {
  hex: "#5e9fb4",
  code: "230 60 25",
  scope: "Design System Plus",
  de: "Sternblütenblau",
  en: "Starflower blue",
  nl: "Sterrenbloem blauw",
  fr: "Bleu fleur d'étoile"
}, {
  hex: "#4fa0b9",
  code: "230 60 30",
  scope: "Design System Plus",
  de: "Sportblau",
  en: "Sports blue",
  nl: "Sport blauw",
  fr: "Bleu sport"
}, {
  hex: "#37a3c1",
  code: "230 60 35",
  scope: "Design System Plus",
  de: "Griechischblau",
  en: "Greek blue",
  nl: "Grieks blauw",
  fr: "Bleu grec"
}, {
  hex: "#00a4c7",
  code: "230 60 40",
  scope: "Design System Plus",
  de: "Alpenblau",
  en: "Alpine blue",
  nl: "Alpine blauw",
  fr: "Bleu des Alpes"
}, {
  hex: "#a0b6be",
  code: "230 70 10",
  scope: "Design System Plus",
  de: "Eismövengraublau",
  en: "Ice gull grey blue",
  nl: "IJzig grijsblauw",
  fr: "Gris goéland glacé"
}, {
  hex: "#91b6c2",
  code: "230 70 15",
  scope: "Design System Plus",
  de: "Distelblütenbleu",
  en: "Thistleblossom soft blue",
  nl: "Distelbloesem lood",
  fr: "Plomb de la fleur de chardon"
}, {
  hex: "#85b8c9",
  code: "230 70 20",
  scope: "Design System Plus",
  de: "Tennisblau",
  en: "Tennis blue",
  nl: "Tennis blauw",
  fr: "Bleu tennis"
}, {
  hex: "#7abacf",
  code: "230 70 25",
  scope: "Design System Plus",
  de: "Oldtimerblau",
  en: "Vintage blue",
  nl: "Vintage auto blauw",
  fr: "Bleu oldtimer"
}, {
  hex: "#68bbd4",
  code: "230 70 30",
  scope: "Design System Plus",
  de: "Fitnessblau",
  en: "Fitness blue",
  nl: "Fitness blauw",
  fr: "Bleu fitness"
}, {
  hex: "#b7cfd6",
  code: "230 80 10",
  scope: "Design System Plus",
  de: "Bleichblau",
  en: "Pallid blue",
  nl: "Lichtblauw",
  fr: "Bleu pâle"
}, {
  hex: "#abceda",
  code: "230 80 15",
  scope: "Design System Plus",
  de: "Alpenmorgenblau",
  en: "Alpine morning blue",
  nl: "Alpine ochtendblauw",
  fr: "Bleu matin alpin"
}, {
  hex: "#a1d2e2",
  code: "230 80 20",
  scope: "Design System Plus",
  de: "Hellblau",
  en: "Light blue",
  nl: "Lichtblauw",
  fr: "Bleu clair"
}, {
  hex: "#ced9dd",
  code: "230 85 05",
  scope: "Design System Plus",
  de: "Polarkaltbleu",
  en: "Polar soft blue",
  nl: "Poolkoud lood",
  fr: "Plomb froid polaire"
}, {
  hex: "#c1d9e1",
  code: "230 85 10",
  scope: "Design System Plus",
  de: "Waschpulverweiß",
  en: "Washing powder white",
  nl: "Waspoeder wit",
  fr: "Blanc en poudre de lavage"
}, {
  hex: "#b8dce7",
  code: "230 85 15",
  scope: "Design System Plus",
  de: "Himalayaweißblau",
  en: "Himalaya white blue",
  nl: "Himalaya wit blauw",
  fr: "Bleu blanc Himalaya"
}, {
  hex: "#abdeee",
  code: "230 85 20",
  scope: "Design System Plus",
  de: "Atmosphärenbleu",
  en: "Atmospheric soft blue",
  nl: "Atmosferisch lood",
  fr: "Plomb atmosphérique"
}, {
  hex: "#dbe6e6",
  code: "230 90 05",
  scope: "Design System Plus",
  de: "Strahlendweiß",
  en: "Brilliant white",
  nl: "Gitwit",
  fr: "Blanc éclatant"
}, {
  hex: "#454a4d",
  code: "240 20 05",
  scope: "Design System Plus",
  de: "Nachtschattenblau",
  en: "Nightshade blue",
  nl: "Nachtschade blauw",
  fr: "bleu nuit"
}, {
  hex: "#3f4a51",
  code: "240 20 10",
  scope: "Design System Plus",
  de: "Holunderschwarz",
  en: "Elderberry black",
  nl: "Vlierbes zwart",
  fr: "Noir sureau"
}, {
  hex: "#394a55",
  code: "240 20 15",
  scope: "Design System Plus",
  de: "Metallblau",
  en: "Metal blue",
  nl: "Metaal blauw",
  fr: "Bleu métal"
}, {
  hex: "#334b59",
  code: "240 20 20",
  scope: "Design System Plus",
  de: "Krähenbeerenblau",
  en: "Crowberry blue",
  nl: "Kraaihei blauw",
  fr: "Bleu corbeau"
}, {
  hex: "#294a5b",
  code: "240 20 22",
  scope: "Design System Plus",
  de: "Sattblau",
  en: "Rich blue",
  nl: "Verzadigd blauw",
  fr: "Bleu satiné"
}, {
  hex: "#52595c",
  code: "240 30 05",
  scope: "Design System Plus",
  de: "Diamantgrau",
  en: "Diamond grey",
  nl: "Diamant grijs",
  fr: "Gris diamant"
}, {
  hex: "#4c5a62",
  code: "240 30 10",
  scope: "Design System Plus",
  de: "Schmutzblau",
  en: "Dirty blue",
  nl: "Vuilblauw",
  fr: "Bleu sale"
}, {
  hex: "#455b67",
  code: "240 30 15",
  scope: "Design System Plus",
  de: "Tiefseeblau",
  en: "Deep sea blue",
  nl: "Diep zeeblauw",
  fr: "Bleu profond"
}, {
  hex: "#3c5c6c",
  code: "240 30 20",
  scope: "Design System Plus",
  de: "Lasuritblau",
  en: "Lasurite blue",
  nl: "Glazuriet blauw",
  fr: "Bleu lasurite"
}, {
  hex: "#2f5c72",
  code: "240 30 25",
  scope: "Design System Plus",
  de: "Arbeitsblau",
  en: "Work blue",
  nl: "Blauw werken",
  fr: "Bleu de travail"
}, {
  hex: "#215d77",
  code: "240 30 30",
  scope: "Design System Plus",
  de: "Schmucksteinblau",
  en: "Gemstone blue",
  nl: "Sieraden steen blauw",
  fr: "Bleu pierre précieuse"
}, {
  hex: "#065f7c",
  code: "240 30 35",
  scope: "Design System Plus",
  de: "Kapitänsblau",
  en: "Captain blue",
  nl: "Blauw van de kapitein",
  fr: "Bleu capitaine"
}, {
  hex: "#646b70",
  code: "240 40 05",
  scope: "Design System Plus",
  de: "Blauanthrazit",
  en: "Blue anthracite",
  nl: "Blauw antraciet",
  fr: "Bleu anthracite"
}, {
  hex: "#5c6d76",
  code: "240 40 10",
  scope: "Design System Plus",
  de: "Schwarzdornblau",
  en: "Blackthorn blue",
  nl: "Sleedoorn blauw",
  fr: "Bleu épine noire"
}, {
  hex: "#536e7d",
  code: "240 40 15",
  scope: "Design System Plus",
  de: "Celesteblau",
  en: "Celeste blue",
  nl: "Celeste blauw",
  fr: "Bleu Céleste"
}, {
  hex: "#486f82",
  code: "240 40 20",
  scope: "Design System Plus",
  de: "Jeansblau",
  en: "Denim blue",
  nl: "Denimblauw",
  fr: "Bleu jean"
}, {
  hex: "#3c708a",
  code: "240 40 25",
  scope: "Design System Plus",
  de: "Orientblau",
  en: "Orient blue",
  nl: "Oosters blauw",
  fr: "Bleu oriental"
}, {
  hex: "#28718f",
  code: "240 40 30",
  scope: "Design System Plus",
  de: "Matrosenblau",
  en: "Sailor blue",
  nl: "Matroos blauw",
  fr: "Bleu marin"
}, {
  hex: "#007295",
  code: "240 40 35",
  scope: "Design System Plus",
  de: "Steinblau",
  en: "Stone blue",
  nl: "Steenblauw",
  fr: "Bleu pierre"
}, {
  hex: "#00749a",
  code: "240 40 40",
  scope: "Design System Plus",
  de: "Reinbleu",
  en: "Pure light blue",
  nl: "Reinbleu",
  fr: "Reinbleu"
}, {
  hex: "#798186",
  code: "240 50 05",
  scope: "Design System Plus",
  de: "Rauchblau",
  en: "Smoky blue",
  nl: "Rook blauw",
  fr: "Bleu fumée"
}, {
  hex: "#6f828c",
  code: "240 50 10",
  scope: "Design System Plus",
  de: "Werkzeugblau",
  en: "Tool blue",
  nl: "Gereedschap blauw",
  fr: "Bleu outil"
}, {
  hex: "#668494",
  code: "240 50 15",
  scope: "Design System Plus",
  de: "Technikblau",
  en: "Technical blue",
  nl: "Technisch blauw",
  fr: "Bleu technique"
}, {
  hex: "#5a859a",
  code: "240 50 20",
  scope: "Design System Plus",
  de: "Coelinblau",
  en: "Coelin blue",
  nl: "Coelin blauw",
  fr: "Bleu célin"
}, {
  hex: "#4c86a0",
  code: "240 50 25",
  scope: "Design System Plus",
  de: "Grönlandblau",
  en: "Greenland blue",
  nl: "Groenland blauw",
  fr: "Bleu groenland"
}, {
  hex: "#3c87a6",
  code: "240 50 30",
  scope: "Design System Plus",
  de: "Sommerblau",
  en: "Summer blue",
  nl: "Zomerblauw",
  fr: "Bleu d'été"
}, {
  hex: "#1f88ad",
  code: "240 50 35",
  scope: "Design System Plus",
  de: "Werbeblau",
  en: "Advertising blue",
  nl: "Reclame blauw",
  fr: "Bleu publicitaire"
}, {
  hex: "#0088b2",
  code: "240 50 40",
  scope: "Design System Plus",
  de: "Tuschblau",
  en: "Indian inc blue",
  nl: "Inkt blauw",
  fr: "Bleu encre"
}, {
  hex: "#8f999e",
  code: "240 60 05",
  scope: "Design System Plus",
  de: "Brieftaubenblau",
  en: "Carrier pigeon blue",
  nl: "Postduif blauw",
  fr: "Bleu pigeon voyageur"
}, {
  hex: "#8297a2",
  code: "240 60 10",
  scope: "Design System Plus",
  de: "Vogelblau",
  en: "Bird blue",
  nl: "Vogelblauw",
  fr: "Bleu oiseau"
}, {
  hex: "#7a9aaa",
  code: "240 60 15",
  scope: "Design System Plus",
  de: "Architekturblau",
  en: "Architecture blue",
  nl: "Architectonisch blauw",
  fr: "Bleu architectural"
}, {
  hex: "#709db3",
  code: "240 60 20",
  scope: "Design System Plus",
  de: "Hemdblau",
  en: "Shirt blue",
  nl: "Overhemd blauw",
  fr: "Bleu foncé"
}, {
  hex: "#639eba",
  code: "240 60 25",
  scope: "Design System Plus",
  de: "Stahlhellblau",
  en: "Steel light blue",
  nl: "Staal lichtblauw",
  fr: "Bleu clair acier"
}, {
  hex: "#519fc0",
  code: "240 60 30",
  scope: "Design System Plus",
  de: "Märchenblau",
  en: "Fairytale blue",
  nl: "Sprookjesachtig blauw",
  fr: "Bleu de conte de fées"
}, {
  hex: "#3ca0c8",
  code: "240 60 35",
  scope: "Design System Plus",
  de: "Prinzessblau",
  en: "Princess blue",
  nl: "Prinses blauw",
  fr: "Bleu princesse"
}, {
  hex: "#1ba3cb",
  code: "240 60 40",
  scope: "Design System Plus",
  de: "Klarblau",
  en: "Clear blue",
  nl: "Helder blauw",
  fr: "Bleu clair"
}, {
  hex: "#a7b1b7",
  code: "240 70 05",
  scope: "Design System Plus",
  de: "Wäscheblau",
  en: "Laundry blue",
  nl: "Wasserij blauw",
  fr: "Bleu linge"
}, {
  hex: "#9eb2bd",
  code: "240 70 10",
  scope: "Design System Plus",
  de: "Augenblau",
  en: "Eye blue",
  nl: "Oog blauw",
  fr: "Bleu des yeux"
}, {
  hex: "#93b5c5",
  code: "240 70 15",
  scope: "Design System Plus",
  de: "Bermudablau",
  en: "Bermuda blue",
  nl: "Bermuda blauw",
  fr: "Bleu bermuda"
}, {
  hex: "#88b5cb",
  code: "240 70 20",
  scope: "Design System Plus",
  de: "Meerblau",
  en: "Sea blue",
  nl: "Zee blauw",
  fr: "Bleu mer"
}, {
  hex: "#7bb8d3",
  code: "240 70 25",
  scope: "Design System Plus",
  de: "Madonnablau",
  en: "Madonna blue",
  nl: "Madonna blauw",
  fr: "Bleu madonna"
}, {
  hex: "#6bb8d8",
  code: "240 70 30",
  scope: "Design System Plus",
  de: "Karibikblau",
  en: "Caribbean blue",
  nl: "Caribisch blauw",
  fr: "Bleu caraïbe"
}, {
  hex: "#bfcacf",
  code: "240 80 05",
  scope: "Design System Plus",
  de: "Dunstblau",
  en: "Hazy blue",
  nl: "Haze blauw",
  fr: "Bleu brumeux"
}, {
  hex: "#b9cfd9",
  code: "240 80 10",
  scope: "Design System Plus",
  de: "Topashellbleu",
  en: "Light topaz soft blue",
  nl: "Topashell lood",
  fr: "Bleu topaze"
}, {
  hex: "#aecfde",
  code: "240 80 15",
  scope: "Design System Plus",
  de: "Babyblau",
  en: "Baby blue",
  nl: "Baby blauw",
  fr: "Bleu bébé"
}, {
  hex: "#a1d1e6",
  code: "240 80 20",
  scope: "Design System Plus",
  de: "Kristallblau",
  en: "Crystal blue",
  nl: "Kristalblauw",
  fr: "Bleu cristal"
}, {
  hex: "#cdd7dd",
  code: "240 85 05",
  scope: "Design System Plus",
  de: "Eisgrau",
  en: "Ice grey",
  nl: "IJsgrijs",
  fr: "Gris glace"
}, {
  hex: "#c2d8e3",
  code: "240 85 10",
  scope: "Design System Plus",
  de: "Luftblau",
  en: "Air blue",
  nl: "Lucht blauw",
  fr: "Bleu aérien"
}, {
  hex: "#b7dbeb",
  code: "240 85 15",
  scope: "Design System Plus",
  de: "Pariserblau",
  en: "Paris blue",
  nl: "Parijs blauw",
  fr: "Bleu parisien"
}, {
  hex: "#dce7e9",
  code: "240 90 05",
  scope: "Design System Plus",
  de: "Bleuweiß",
  en: "Soft blue white",
  nl: "Loodwit",
  fr: "Blanc de plomb"
}, {
  hex: "#cfe8ef",
  code: "240 90 10",
  scope: "Design System Plus",
  de: "Kalkbleu",
  en: "Chalky blue white",
  nl: "Kalklood",
  fr: "Plomb de chaux"
}, {
  hex: "#334a5b",
  code: "250 20 20",
  scope: "Design System Plus",
  de: "Kosmosblau",
  en: "Cosmos blue",
  nl: "Kosmos blauw",
  fr: "Bleu cosmos"
}, {
  hex: "#2f4a5f",
  code: "250 20 25",
  scope: "Design System Plus",
  de: "Dunkeljeansblau",
  en: "Dark denim blue",
  nl: "Donker denimblauw",
  fr: "Bleu jean foncé"
}, {
  hex: "#455968",
  code: "250 30 15",
  scope: "Design System Plus",
  de: "Schwarzwaldblau",
  en: "Black Forest blue",
  nl: "Zwarte woud blauw",
  fr: "Bleu Forêt Noire"
}, {
  hex: "#3b5a6e",
  code: "250 30 20",
  scope: "Design System Plus",
  de: "Schwalbenblau",
  en: "Swallow blue",
  nl: "Zwaluw blauw",
  fr: "Bleu hirondelle"
}, {
  hex: "#335b74",
  code: "250 30 25",
  scope: "Design System Plus",
  de: "Marinedunkelblau",
  en: "Navy dark blue",
  nl: "Marine donkerblauw",
  fr: "Bleu marine foncé"
}, {
  hex: "#235b7b",
  code: "250 30 30",
  scope: "Design System Plus",
  de: "Pompejiblau",
  en: "Pompeii blue",
  nl: "Pompeii blauw",
  fr: "Bleu pompéi"
}, {
  hex: "#5e6c77",
  code: "250 40 10",
  scope: "Design System Plus",
  de: "Trekkingblau",
  en: "Trekking blue",
  nl: "Trekking blauw",
  fr: "Bleu trekking"
}, {
  hex: "#556c7d",
  code: "250 40 15",
  scope: "Design System Plus",
  de: "Stahlblaugrau",
  en: "Steel blue grey",
  nl: "Staalblauw-grijs",
  fr: "Gris bleu acier"
}, {
  hex: "#4a6c83",
  code: "250 40 20",
  scope: "Design System Plus",
  de: "Beerenblau",
  en: "Berry blue",
  nl: "Bessenblauw",
  fr: "Bleu baie"
}, {
  hex: "#3f6e8b",
  code: "250 40 25",
  scope: "Design System Plus",
  de: "Leinenblau",
  en: "Linen blue",
  nl: "Linnen blauw",
  fr: "Bleu lin"
}, {
  hex: "#336f93",
  code: "250 40 30",
  scope: "Design System Plus",
  de: "Poolblau",
  en: "Pool blue",
  nl: "Blauw zwembad",
  fr: "Bleu piscine"
}, {
  hex: "#1a6f97",
  code: "250 40 35",
  scope: "Design System Plus",
  de: "Eisvogelblau",
  en: "Kingfisher blue",
  nl: "IJsvogel blauw",
  fr: "Bleu martin-pêcheur"
}, {
  hex: "#00719c",
  code: "250 40 40",
  scope: "Design System Plus",
  de: "Europablau",
  en: "Europe blue",
  nl: "Europees blauw",
  fr: "Bleu Europe"
}, {
  hex: "#72818d",
  code: "250 50 10",
  scope: "Design System Plus",
  de: "Metallgrau",
  en: "Metal grey",
  nl: "Metaalgrijs",
  fr: "Gris métal"
}, {
  hex: "#688194",
  code: "250 50 15",
  scope: "Design System Plus",
  de: "Titanblau",
  en: "Titanium blue",
  nl: "Titaanblauw",
  fr: "Bleu titane"
}, {
  hex: "#60839b",
  code: "250 50 20",
  scope: "Design System Plus",
  de: "Mallorcablau",
  en: "Mallorca blue",
  nl: "Mallorca blauw",
  fr: "Mallorcablau"
}, {
  hex: "#5583a3",
  code: "250 50 25",
  scope: "Design System Plus",
  de: "Linoleumblau",
  en: "Linoleum blue",
  nl: "Linoleum blauw",
  fr: "Bleu linoléum"
}, {
  hex: "#4684ab",
  code: "250 50 30",
  scope: "Design System Plus",
  de: "Prominentblau",
  en: "Prominent blue",
  nl: "Prominent blauw",
  fr: "Bleu proéminent"
}, {
  hex: "#3386b2",
  code: "250 50 35",
  scope: "Design System Plus",
  de: "Türkischblau",
  en: "Turkish blue",
  nl: "Turks blauw",
  fr: "Bleu turquoise"
}, {
  hex: "#0487b9",
  code: "250 50 40",
  scope: "Design System Plus",
  de: "Urblau",
  en: "Primal blue",
  nl: "Primair blauw",
  fr: "Urblau"
}, {
  hex: "#8798a5",
  code: "250 60 10",
  scope: "Design System Plus",
  de: "Vogelblaugrau",
  en: "Bird blue grey",
  nl: "Vogel blauw-grijs",
  fr: "Gris bleu oiseau"
}, {
  hex: "#7f99ad",
  code: "250 60 15",
  scope: "Design System Plus",
  de: "Sanftblau",
  en: "Gentle blue",
  nl: "Zacht blauw",
  fr: "Bleu doux"
}, {
  hex: "#749ab4",
  code: "250 60 20",
  scope: "Design System Plus",
  de: "Aragonitblau",
  en: "Aragonite blue",
  nl: "Aragoniet blauw",
  fr: "Bleu aragonite"
}, {
  hex: "#699bbc",
  code: "250 60 25",
  scope: "Design System Plus",
  de: "Perlblau",
  en: "Pearl blue",
  nl: "Parelblauw",
  fr: "Bleu perle"
}, {
  hex: "#5c9dc3",
  code: "250 60 30",
  scope: "Design System Plus",
  de: "Topasblau",
  en: "Topaz blue",
  nl: "Topaas blauw",
  fr: "Bleu topaze"
}, {
  hex: "#4d9dca",
  code: "250 60 35",
  scope: "Design System Plus",
  de: "Stratosblau",
  en: "Stratos blue",
  nl: "Stratos blauw",
  fr: "Bleu stratos"
}, {
  hex: "#3a9fd3",
  code: "250 60 40",
  scope: "Design System Plus",
  de: "Bauwerkblau",
  en: "Structural blue",
  nl: "Blauw gebouw",
  fr: "Bleu de chantier"
}, {
  hex: "#9fb2be",
  code: "250 70 10",
  scope: "Design System Plus",
  de: "Nebelblau",
  en: "Foggy blue",
  nl: "Mistig blauw",
  fr: "Bleu brume"
}, {
  hex: "#97b3c7",
  code: "250 70 15",
  scope: "Design System Plus",
  de: "Kreideblau",
  en: "Chalk blue",
  nl: "Krijtblauw",
  fr: "Bleu craie"
}, {
  hex: "#8cb3ce",
  code: "250 70 20",
  scope: "Design System Plus",
  de: "Mittelblau",
  en: "Medium blue",
  nl: "Medium blauw",
  fr: "Bleu moyen"
}, {
  hex: "#82b5d5",
  code: "250 70 25",
  scope: "Design System Plus",
  de: "Wiesenblütenblau",
  en: "Meadow blossom blue",
  nl: "Weidebloesem blauw",
  fr: "Bleu fleur des champs"
}, {
  hex: "#75b5dc",
  code: "250 70 30",
  scope: "Design System Plus",
  de: "Ginsterfalterblau",
  en: "Broom butterfly blue",
  nl: "Bezem vlinder blauw",
  fr: "Bleu papillon de genêt"
}, {
  hex: "#b9cbd8",
  code: "250 80 10",
  scope: "Design System Plus",
  de: "Hellcyan",
  en: "Light cyan",
  nl: "Hellcyan",
  fr: "Hellcyan"
}, {
  hex: "#b2cee0",
  code: "250 80 15",
  scope: "Design System Plus",
  de: "Himalayablau",
  en: "Himalaya blue",
  nl: "Himalaya blauw",
  fr: "Bleu Himalaya"
}, {
  hex: "#a4cbe5",
  code: "250 80 20",
  scope: "Design System Plus",
  de: "Samtblau",
  en: "Velvet blue",
  nl: "Fluweelblauw",
  fr: "Bleu velours"
}, {
  hex: "#ccd4da",
  code: "250 85 05",
  scope: "Design System Plus",
  de: "Weißblau",
  en: "White blue",
  nl: "Witblauw",
  fr: "Bleu blanc"
}, {
  hex: "#c2d5e2",
  code: "250 85 10",
  scope: "Design System Plus",
  de: "Waschmittelbleu",
  en: "Washing powder soft blue",
  nl: "Wasmiddel lood",
  fr: "Bleu de lessive"
}, {
  hex: "#bcd8ea",
  code: "250 85 15",
  scope: "Design System Plus",
  de: "Diamantbleu",
  en: "Diamond soft blue",
  nl: "Diamantlood",
  fr: "Bleu diamant"
}, {
  hex: "#dbe3e7",
  code: "250 90 05",
  scope: "Design System Plus",
  de: "Eisweiß",
  en: "Ice white",
  nl: "Ijs wit",
  fr: "Blanc glacé"
}, {
  hex: "#474a4e",
  code: "260 20 05",
  scope: "Design System Plus",
  de: "Blauschwarz",
  en: "Blue-black",
  nl: "Blauw-zwart",
  fr: "Bleu-noir"
}, {
  hex: "#424952",
  code: "260 20 10",
  scope: "Design System Plus",
  de: "Natoblau",
  en: "Nato blue",
  nl: "Natuurlijk blauw",
  fr: "Bleu nato"
}, {
  hex: "#3b4856",
  code: "260 20 15",
  scope: "Design System Plus",
  de: "Anzugblau",
  en: "Suit blue",
  nl: "Pak blauw",
  fr: "Bleu de costume"
}, {
  hex: "#384a5c",
  code: "260 20 20",
  scope: "Design System Plus",
  de: "Halitblau",
  en: "Halite blue",
  nl: "Haliet blauw",
  fr: "Bleu halite"
}, {
  hex: "#54595e",
  code: "260 30 05",
  scope: "Design System Plus",
  de: "Bergentengrau",
  en: "Alpine duck grey",
  nl: "Bergeend grijs",
  fr: "Gris canard des montagnes"
}, {
  hex: "#505a65",
  code: "260 30 10",
  scope: "Design System Plus",
  de: "Bronzeblau",
  en: "Bronze blue",
  nl: "Bronsblauw",
  fr: "Bleu bronze"
}, {
  hex: "#4a596a",
  code: "260 30 15",
  scope: "Design System Plus",
  de: "Berlinerblau",
  en: "Berlin blue",
  nl: "Berlijn blauw",
  fr: "Bleu berlinois"
}, {
  hex: "#445a70",
  code: "260 30 20",
  scope: "Design System Plus",
  de: "Frankreichblau",
  en: "French blue",
  nl: "Frankrijk blauw",
  fr: "Bleu France"
}, {
  hex: "#3a5a75",
  code: "260 30 25",
  scope: "Design System Plus",
  de: "Tansanitblau",
  en: "Tanzanite blue",
  nl: "Tanzaniet blauw",
  fr: "Bleu tanzanite"
}, {
  hex: "#345b7d",
  code: "260 30 30",
  scope: "Design System Plus",
  de: "Opalblau",
  en: "Opal blue",
  nl: "Opaalblauw",
  fr: "Bleu opale"
}, {
  hex: "#1e5b85",
  code: "260 30 35",
  scope: "Design System Plus",
  de: "Königsblau",
  en: "Royal blue",
  nl: "Koningsblauw",
  fr: "Bleu roi"
}, {
  hex: "#666a70",
  code: "260 40 05",
  scope: "Design System Plus",
  de: "Schwedenblau",
  en: "Swedish blue",
  nl: "Zweeds blauw",
  fr: "Bleu suédois"
}, {
  hex: "#626d79",
  code: "260 40 10",
  scope: "Design System Plus",
  de: "Schotenblau",
  en: "Sheet blue",
  nl: "Pod blauw",
  fr: "Bleu cosse"
}, {
  hex: "#5c6d80",
  code: "260 40 15",
  scope: "Design System Plus",
  de: "Zwetschgenblau",
  en: "Plum blue",
  nl: "Pruim blauw",
  fr: "Bleu quetsche"
}, {
  hex: "#526c85",
  code: "260 40 20",
  scope: "Design System Plus",
  de: "Kadettblau",
  en: "Cadet blue",
  nl: "Cadet blauw",
  fr: "Bleu cadet"
}, {
  hex: "#4b6e8c",
  code: "260 40 25",
  scope: "Design System Plus",
  de: "Emailleblau",
  en: "Enamel blue",
  nl: "Emaille blauw",
  fr: "Bleu émail"
}, {
  hex: "#426e92",
  code: "260 40 30",
  scope: "Design System Plus",
  de: "Kopenhagenerblau",
  en: "Copenhagen blue",
  nl: "Kopenhagen blauw",
  fr: "Bleu Copenhague"
}, {
  hex: "#356e99",
  code: "260 40 35",
  scope: "Design System Plus",
  de: "Bauhausblau",
  en: "Bauhaus blue",
  nl: "Bauhaus blauw",
  fr: "Bleu Bauhaus"
}, {
  hex: "#1e70a3",
  code: "260 40 40",
  scope: "Design System Plus",
  de: "Marineblau",
  en: "Navy blue",
  nl: "Marineblauw",
  fr: "Bleu marine"
}, {
  hex: "#0070a9",
  code: "260 40 45",
  scope: "Design System Plus",
  de: "LEDblau",
  en: "LED blue",
  nl: "LED blauw",
  fr: "LED bleu"
}, {
  hex: "#797e85",
  code: "260 50 05",
  scope: "Design System Plus",
  de: "Spitzbergenblau",
  en: "Spitsbergen blue",
  nl: "Spitsbergen blauw",
  fr: "Bleu Spitzberg"
}, {
  hex: "#75808d",
  code: "260 50 10",
  scope: "Design System Plus",
  de: "Zypressengraublau",
  en: "Cypress grey blue",
  nl: "Cypres grijs blauw",
  fr: "Bleu gris cyprès"
}, {
  hex: "#6e8194",
  code: "260 50 15",
  scope: "Design System Plus",
  de: "Mahonienbeerenblau",
  en: "Mahonia berry blue",
  nl: "Mahonia bessenblauw",
  fr: "Bleu mahonia"
}, {
  hex: "#6a849d",
  code: "260 50 20",
  scope: "Design System Plus",
  de: "Kröpperblau",
  en: "Doves blue",
  nl: "Kröpper blauw",
  fr: "Bleu kröpper"
}, {
  hex: "#6084a6",
  code: "260 50 25",
  scope: "Design System Plus",
  de: "Biedermeierblau",
  en: "Biedermeier blue",
  nl: "Biedermeier blauw",
  fr: "Bleu Biedermeier"
}, {
  hex: "#5485af",
  code: "260 50 30",
  scope: "Design System Plus",
  de: "Pekingblau",
  en: "Beijing blue",
  nl: "Peking blauw",
  fr: "Bleu pékin"
}, {
  hex: "#4784b3",
  code: "260 50 35",
  scope: "Design System Plus",
  de: "Vermeerblau",
  en: "Vermeer blue",
  nl: "Vermeer blauw",
  fr: "Bleu Vermeer"
}, {
  hex: "#3586bd",
  code: "260 50 40",
  scope: "Design System Plus",
  de: "Porzellanblau",
  en: "Meissen blue",
  nl: "Porseleinblauw",
  fr: "Bleu porcelaine"
}, {
  hex: "#91979e",
  code: "260 60 05",
  scope: "Design System Plus",
  de: "Seehundgrau",
  en: "Seal grey",
  nl: "Seal grijs",
  fr: "Gris phoque"
}, {
  hex: "#8b97a5",
  code: "260 60 10",
  scope: "Design System Plus",
  de: "Diopsidblau",
  en: "Diopside blue",
  nl: "Diopside blauw",
  fr: "Bleu diopside"
}, {
  hex: "#879bb0",
  code: "260 60 15",
  scope: "Design System Plus",
  de: "Nordlandblau",
  en: "Nordland blue",
  nl: "Nordland blauw",
  fr: "Bleu du Nord"
}, {
  hex: "#7e9ab5",
  code: "260 60 20",
  scope: "Design System Plus",
  de: "Moorbeerenblau",
  en: "Cranberry blue",
  nl: "Moorbes blauw",
  fr: "Bleu canneberge"
}, {
  hex: "#759bbe",
  code: "260 60 25",
  scope: "Design System Plus",
  de: "Lupinenblau",
  en: "Lupine blue",
  nl: "Lupine blauw",
  fr: "Bleu lupin"
}, {
  hex: "#6b9cc6",
  code: "260 60 30",
  scope: "Design System Plus",
  de: "Sadebeerenbleu",
  en: "Blueberry soft blue",
  nl: "Sadeberry lood",
  fr: "Plomb aux baies de Sade"
}, {
  hex: "#5f9dcd",
  code: "260 60 35",
  scope: "Design System Plus",
  de: "Leuchtendblau",
  en: "Brilliant blue",
  nl: "Helderblauw",
  fr: "Bleu vif"
}, {
  hex: "#abb1b8",
  code: "260 70 05",
  scope: "Design System Plus",
  de: "Nordlichtgrau",
  en: "Northern light grey",
  nl: "Noorderlicht grijs",
  fr: "Gris lumière du nord"
}, {
  hex: "#a5b2c0",
  code: "260 70 10",
  scope: "Design System Plus",
  de: "Sturmvogelblaugrau",
  en: "Petrel blue grey",
  nl: "Stormvogel blauwgrijs",
  fr: "Gris-bleu tempête"
}, {
  hex: "#9cb2c8",
  code: "260 70 15",
  scope: "Design System Plus",
  de: "Nordlandhellblau",
  en: "Nordland light blue",
  nl: "Nordland lichtblauw",
  fr: "Bleu clair du Nordland"
}, {
  hex: "#96b4d0",
  code: "260 70 20",
  scope: "Design System Plus",
  de: "Mattblau",
  en: "Matte blue",
  nl: "Matblauw",
  fr: "Bleu mat"
}, {
  hex: "#8cb4d8",
  code: "260 70 25",
  scope: "Design System Plus",
  de: "Pazifikblau",
  en: "Pacific blue",
  nl: "Pacifisch blauw",
  fr: "Bleu pacifique"
}, {
  hex: "#c3cad1",
  code: "260 80 05",
  scope: "Design System Plus",
  de: "Lichtblaugrau",
  en: "Light blue grey",
  nl: "Licht blauw-grijs",
  fr: "Gris bleu clair"
}, {
  hex: "#bdcbd9",
  code: "260 80 10",
  scope: "Design System Plus",
  de: "Puderbleu",
  en: "Powder soft blue",
  nl: "Poederlood",
  fr: "Plomb en poudre"
}, {
  hex: "#b5cce0",
  code: "260 80 15",
  scope: "Design System Plus",
  de: "Windblau",
  en: "Wind blue",
  nl: "Wind blauw",
  fr: "Bleu vent"
}, {
  hex: "#cdd3d9",
  code: "260 85 05",
  scope: "Design System Plus",
  de: "Satinweiß",
  en: "Satin white",
  nl: "Satijn wit",
  fr: "Blanc satiné"
}, {
  hex: "#c8d7e5",
  code: "260 85 10",
  scope: "Design System Plus",
  de: "Meeresbrisengrün",
  en: "Sea breeze green",
  nl: "Zeewind groen",
  fr: "Vert cassis de mer"
}, {
  hex: "#dde3e7",
  code: "260 90 05",
  scope: "Design System Plus",
  de: "Milchblau",
  en: "Milk blue",
  nl: "Melkblauw",
  fr: "Bleu lait"
}, {
  hex: "#3a475c",
  code: "270 20 20",
  scope: "Design System Plus",
  de: "Krähenschwarzblau",
  en: "Crow black blue",
  nl: "Kraai zwart blauw",
  fr: "Bleu noir corbeau"
}, {
  hex: "#344660",
  code: "270 20 25",
  scope: "Design System Plus",
  de: "Indigoschwarz",
  en: "Indigo black",
  nl: "Indigo zwart",
  fr: "Noir indigo"
}, {
  hex: "#2e4667",
  code: "270 20 29",
  scope: "Design System Plus",
  de: "Kraftblau",
  en: "Effervescent blue",
  nl: "Blauw vermogen",
  fr: "Bleu kraft"
}, {
  hex: "#4c5768",
  code: "270 30 15",
  scope: "Design System Plus",
  de: "Mitternachtsblau",
  en: "Midnight blue",
  nl: "Middernachtblauw",
  fr: "Bleu minuit"
}, {
  hex: "#47576f",
  code: "270 30 20",
  scope: "Design System Plus",
  de: "Dunkelblau",
  en: "Dark blue",
  nl: "Donkerblauw",
  fr: "Bleu foncé"
}, {
  hex: "#415776",
  code: "270 30 25",
  scope: "Design System Plus",
  de: "Traubenblau",
  en: "Grape blue",
  nl: "Druifblauw",
  fr: "Bleu raisin"
}, {
  hex: "#39567c",
  code: "270 30 30",
  scope: "Design System Plus",
  de: "Mediciblau",
  en: "Medici blue",
  nl: "Medici blauw",
  fr: "Bleu medici"
}, {
  hex: "#2f5682",
  code: "270 30 35",
  scope: "Design System Plus",
  de: "Kolibriblau",
  en: "Kolibri blue",
  nl: "Kolibrie blauw",
  fr: "Bleu colibri"
}, {
  hex: "#1f568a",
  code: "270 30 40",
  scope: "Design System Plus",
  de: "Prinzenblau",
  en: "Prince blue",
  nl: "Prins blauw",
  fr: "Bleu prince"
}, {
  hex: "#5f6b7f",
  code: "270 40 15",
  scope: "Design System Plus",
  de: "Zinngrau",
  en: "Pewter grey",
  nl: "Tinnen grijs",
  fr: "Gris étain"
}, {
  hex: "#576a85",
  code: "270 40 20",
  scope: "Design System Plus",
  de: "Salonblau",
  en: "Parlour blue",
  nl: "Salon blauw",
  fr: "Bleu salon"
}, {
  hex: "#536b8d",
  code: "270 40 25",
  scope: "Design System Plus",
  de: "Funktionsblau",
  en: "Functional blue",
  nl: "Functioneel blauw",
  fr: "Bleu fonctionnel"
}, {
  hex: "#4a6a94",
  code: "270 40 30",
  scope: "Design System Plus",
  de: "Schminkblau",
  en: "Make-up blue",
  nl: "Make-up blauw",
  fr: "Bleu maquillage"
}, {
  hex: "#406a9b",
  code: "270 40 35",
  scope: "Design System Plus",
  de: "Lapislazuliblau",
  en: "Lapis lazuli blue",
  nl: "Lapis lazuli blauw",
  fr: "Bleu lapis-lazuli"
}, {
  hex: "#3469a2",
  code: "270 40 40",
  scope: "Design System Plus",
  de: "Zauberblau",
  en: "Magic blue",
  nl: "Magisch blauw",
  fr: "Bleu magique"
}, {
  hex: "#77808f",
  code: "270 50 10",
  scope: "Design System Plus",
  de: "Brokatblau",
  en: "Brocade blue",
  nl: "Brokaatblauw",
  fr: "Bleu brocart"
}, {
  hex: "#738197",
  code: "270 50 15",
  scope: "Design System Plus",
  de: "Edelblau",
  en: "Noble blue",
  nl: "Edel blauw",
  fr: "Bleu précieux"
}, {
  hex: "#6d819e",
  code: "270 50 20",
  scope: "Design System Plus",
  de: "Delfterblau",
  en: "Delft blue",
  nl: "Delfts blauw",
  fr: "Bleu Delft"
}, {
  hex: "#6780a6",
  code: "270 50 25",
  scope: "Design System Plus",
  de: "Cocktailblau",
  en: "Cocktail blue",
  nl: "Cocktail blauw",
  fr: "Bleu cocktail"
}, {
  hex: "#5e80ad",
  code: "270 50 30",
  scope: "Design System Plus",
  de: "Salbeiblütenblau",
  en: "Sage blossom blue",
  nl: "Saliebloesem blauw",
  fr: "Bleu fleur de sauge"
}, {
  hex: "#557fb2",
  code: "270 50 35",
  scope: "Design System Plus",
  de: "Wienerblau",
  en: "Viennese blue",
  nl: "Wenen blauw",
  fr: "Bleu viennois"
}, {
  hex: "#4a81bd",
  code: "270 50 40",
  scope: "Design System Plus",
  de: "Kornblumenblau",
  en: "Cornflower blue",
  nl: "Korenbloemblauw",
  fr: "Bleu bleuet"
}, {
  hex: "#8c97a7",
  code: "270 60 10",
  scope: "Design System Plus",
  de: "Fantasiegrau",
  en: "Fantasy grey",
  nl: "Fantasie grijs",
  fr: "Gris fantaisie"
}, {
  hex: "#8998b0",
  code: "270 60 15",
  scope: "Design System Plus",
  de: "Fliederblau",
  en: "Lilac blue",
  nl: "Lila blauw",
  fr: "Bleu lilas"
}, {
  hex: "#8398b7",
  code: "270 60 20",
  scope: "Design System Plus",
  de: "Lavendelblau",
  en: "Lavender blue",
  nl: "Lavendelblauw",
  fr: "Bleu lavande"
}, {
  hex: "#7d98bf",
  code: "270 60 25",
  scope: "Design System Plus",
  de: "Ritterspornblau",
  en: "Delphinium blue",
  nl: "Ridderspoor blauw",
  fr: "Bleu éperon d'or"
}, {
  hex: "#7699c8",
  code: "270 60 30",
  scope: "Design System Plus",
  de: "Lidschattenblau",
  en: "Eyeshadow blue",
  nl: "Oogschaduw blauw",
  fr: "Bleu de l'ombre à paupières"
}, {
  hex: "#6b97ce",
  code: "270 60 35",
  scope: "Design System Plus",
  de: "Argusfalterblau",
  en: "Butterfly blue",
  nl: "Argus vlinder blauw",
  fr: "Bleu arguspapillon"
}, {
  hex: "#a7b1c1",
  code: "270 70 10",
  scope: "Design System Plus",
  de: "Federbleu",
  en: "Feather soft blue",
  nl: "Voorjaarslood",
  fr: "Plomb pour ressort"
}, {
  hex: "#a1b1c9",
  code: "270 70 15",
  scope: "Design System Plus",
  de: "Satinbleu",
  en: "Satin soft blue",
  nl: "Satijnlood",
  fr: "Bleu satin"
}, {
  hex: "#9cb2d2",
  code: "270 70 20",
  scope: "Design System Plus",
  de: "Engelblau",
  en: "Angel blue",
  nl: "Engelenblauw",
  fr: "Bleu ange"
}, {
  hex: "#93afd8",
  code: "270 70 25",
  scope: "Design System Plus",
  de: "Knabenblau",
  en: "Boy blue",
  nl: "Blauw voor jongens",
  fr: "Bleu garçon"
}, {
  hex: "#c1cad9",
  code: "270 80 10",
  scope: "Design System Plus",
  de: "Perlhellbleu",
  en: "Light pearl soft blue",
  nl: "Parel lichtsnoer",
  fr: "Bleu perle clair"
}, {
  hex: "#b9c9e1",
  code: "270 80 15",
  scope: "Design System Plus",
  de: "Retinableu",
  en: "Retina soft blue",
  nl: "Retinableu",
  fr: "Retinableu"
}, {
  hex: "#d1d4da",
  code: "270 85 05",
  scope: "Design System Plus",
  de: "Engelshaarsilber",
  en: "Angel hair silver",
  nl: "Engelenhaar zilver",
  fr: "Cheveux d'ange argentés"
}, {
  hex: "#cad4e4",
  code: "270 85 10",
  scope: "Design System Plus",
  de: "Perlmuttsilber",
  en: "Mother-of-pearl silver",
  nl: "Parelmoer zilver",
  fr: "Argent nacré"
}, {
  hex: "#c4d4ec",
  code: "270 85 15",
  scope: "Design System Plus",
  de: "Muranobleu",
  en: "Murano soft blue",
  nl: "Muranobleu",
  fr: "Muranobleu"
}, {
  hex: "#e0e3e8",
  code: "270 90 05",
  scope: "Design System Plus",
  de: "Bleichweiß",
  en: "Bleached white",
  nl: "Licht wit",
  fr: "Blanc pâle"
}, {
  hex: "#4a4a4e",
  code: "280 20 05",
  scope: "Design System Plus",
  de: "Granitschwarz",
  en: "Granite black",
  nl: "Graniet zwart",
  fr: "Noir granit"
}, {
  hex: "#474a53",
  code: "280 20 10",
  scope: "Design System Plus",
  de: "Diamantschwarz",
  en: "Diamond black",
  nl: "Diamant zwart",
  fr: "Noir diamant"
}, {
  hex: "#444958",
  code: "280 20 15",
  scope: "Design System Plus",
  de: "Krähenschwarz",
  en: "Crow black",
  nl: "Kraai zwart",
  fr: "Noir corbeau"
}, {
  hex: "#41485b",
  code: "280 20 20",
  scope: "Design System Plus",
  de: "Manganschwarz",
  en: "Manganese black",
  nl: "Mangaan zwart",
  fr: "Noir de manganèse"
}, {
  hex: "#3f4862",
  code: "280 20 25",
  scope: "Design System Plus",
  de: "Elitenblau",
  en: "Elite blue",
  nl: "Elite blauw",
  fr: "Bleu élite"
}, {
  hex: "#3a4868",
  code: "280 20 30",
  scope: "Design System Plus",
  de: "Ambassadorblau",
  en: "Ambassador blue",
  nl: "Ambassadeur blauw",
  fr: "Bleu ambassador"
}, {
  hex: "#57585d",
  code: "280 30 05",
  scope: "Design System Plus",
  de: "Smokingnachtblau",
  en: "Smoking night blue",
  nl: "Dinerjas nachtblauw",
  fr: "Bleu nuit smoking"
}, {
  hex: "#555965",
  code: "280 30 10",
  scope: "Design System Plus",
  de: "Meteoritschwarzblau",
  en: "Meteorite black blue",
  nl: "Meteoriet zwart blauw",
  fr: "Bleu météorite noir"
}, {
  hex: "#52596b",
  code: "280 30 15",
  scope: "Design System Plus",
  de: "Kohlesteinblau",
  en: "Anthracite blue",
  nl: "Houtskoolblauw",
  fr: "Bleu pierre de charbon"
}, {
  hex: "#4f5972",
  code: "280 30 20",
  scope: "Design System Plus",
  de: "Granatsteinblau",
  en: "Garnet stone blue",
  nl: "Granaatsteen blauw",
  fr: "Bleu pierre de grenat"
}, {
  hex: "#4c5977",
  code: "280 30 25",
  scope: "Design System Plus",
  de: "Wasserstoffblau",
  en: "Hydrogen blue",
  nl: "Waterstof blauw",
  fr: "Bleu hydrogène"
}, {
  hex: "#45577e",
  code: "280 30 30",
  scope: "Design System Plus",
  de: "Tiefblau",
  en: "Deep blue",
  nl: "Diepblauw",
  fr: "Bleu profond"
}, {
  hex: "#425783",
  code: "280 30 35",
  scope: "Design System Plus",
  de: "Theaterblau",
  en: "Theatre blue",
  nl: "Theater blauw",
  fr: "Bleu théâtre"
}, {
  hex: "#3d588a",
  code: "280 30 40",
  scope: "Design System Plus",
  de: "Plakatblau",
  en: "Poster blue",
  nl: "Poster blauw",
  fr: "Bleu affiche"
}, {
  hex: "#696b71",
  code: "280 40 05",
  scope: "Design System Plus",
  de: "Galeriegrau",
  en: "Gallery grey",
  nl: "Galerij grijs",
  fr: "Gris galerie"
}, {
  hex: "#666a78",
  code: "280 40 10",
  scope: "Design System Plus",
  de: "Wildlederindigo",
  en: "Suede indigo",
  nl: "Suède indigo",
  fr: "Indigo en daim"
}, {
  hex: "#636a7f",
  code: "280 40 15",
  scope: "Design System Plus",
  de: "Dunkellavendel",
  en: "Dark lavender",
  nl: "Donker lavendel",
  fr: "Lavande sombre"
}, {
  hex: "#5f6a86",
  code: "280 40 20",
  scope: "Design System Plus",
  de: "Sternenhimmelblau",
  en: "Starry sky blue",
  nl: "Hemelsblauw",
  fr: "Bleu ciel étoilé"
}, {
  hex: "#5d6b8e",
  code: "280 40 25",
  scope: "Design System Plus",
  de: "Indigomarineblau",
  en: "Indigo navy blue",
  nl: "Indigo blauw",
  fr: "Bleu indigo"
}, {
  hex: "#586a94",
  code: "280 40 30",
  scope: "Design System Plus",
  de: "Abendblau",
  en: "Evening blue",
  nl: "Avondblauw",
  fr: "Bleu soir"
}, {
  hex: "#526b9b",
  code: "280 40 35",
  scope: "Design System Plus",
  de: "Portugalblau",
  en: "Portuguese blue",
  nl: "Portugal blauw",
  fr: "Bleu Portugal"
}, {
  hex: "#4a6aa3",
  code: "280 40 40",
  scope: "Design System Plus",
  de: "Neptunblau",
  en: "Neptune blue",
  nl: "Neptunus blauw",
  fr: "Bleu neptune"
}, {
  hex: "#4169aa",
  code: "280 40 45",
  scope: "Design System Plus",
  de: "Hyazinthenblau",
  en: "Hyacinth blue",
  nl: "Hyacint blauw",
  fr: "Bleu jacinthe"
}, {
  hex: "#7d8087",
  code: "280 50 05",
  scope: "Design System Plus",
  de: "Nobelgrau",
  en: "Noble grey",
  nl: "Edel grijs",
  fr: "Gris Nobel"
}, {
  hex: "#7b808f",
  code: "280 50 10",
  scope: "Design System Plus",
  de: "Eisblaugrau",
  en: "Ice blue grey",
  nl: "IJsblauw grijs",
  fr: "Gris bleu glacé"
}, {
  hex: "#788096",
  code: "280 50 15",
  scope: "Design System Plus",
  de: "Granitblau",
  en: "Granite blue",
  nl: "Granietblauw",
  fr: "Bleu granit"
}, {
  hex: "#747f9e",
  code: "280 50 20",
  scope: "Design System Plus",
  de: "Lavendellila",
  en: "Lavender mauve",
  nl: "Lavendelpaars",
  fr: "Violet lavande"
}, {
  hex: "#717fa5",
  code: "280 50 25",
  scope: "Design System Plus",
  de: "Kostümblau",
  en: "Costume blue",
  nl: "Kostuum blauw",
  fr: "Bleu de costume"
}, {
  hex: "#6c7fad",
  code: "280 50 30",
  scope: "Design System Plus",
  de: "Helllila",
  en: "Light mauve",
  nl: "Licht lila",
  fr: "Violet clair"
}, {
  hex: "#667eb3",
  code: "280 50 35",
  scope: "Design System Plus",
  de: "Saphirschimmerblau",
  en: "Sapphire shimmer blue",
  nl: "Saffierglans blauw",
  fr: "Bleu saphir scintillant"
}, {
  hex: "#6180be",
  code: "280 50 40",
  scope: "Design System Plus",
  de: "Divenviolett",
  en: "Diva violet",
  nl: "Diva violet",
  fr: "Violet de diva"
}, {
  hex: "#94979e",
  code: "280 60 05",
  scope: "Design System Plus",
  de: "Tüllgrau",
  en: "Tulle grey",
  nl: "Tule grijs",
  fr: "Gris tulle"
}, {
  hex: "#9196a6",
  code: "280 60 10",
  scope: "Design System Plus",
  de: "Süßlavendel",
  en: "Sweet lavender",
  nl: "Zoete lavendel",
  fr: "Lavande douce"
}, {
  hex: "#8e96ae",
  code: "280 60 15",
  scope: "Design System Plus",
  de: "Marmorblau",
  en: "Marble blue",
  nl: "Marmerblauw",
  fr: "Bleu marbré"
}, {
  hex: "#8b96b7",
  code: "280 60 20",
  scope: "Design System Plus",
  de: "Nebelviolett",
  en: "Misty violet",
  nl: "Mist violet",
  fr: "Violet brumeux"
}, {
  hex: "#8695be",
  code: "280 60 25",
  scope: "Design System Plus",
  de: "Opalviolett",
  en: "Opal violet",
  nl: "Opaal violet",
  fr: "Violet opalin"
}, {
  hex: "#8296c5",
  code: "280 60 30",
  scope: "Design System Plus",
  de: "Persischviolett",
  en: "Persian violet",
  nl: "Perzisch viooltje",
  fr: "Violet persan"
}, {
  hex: "#7e97cf",
  code: "280 60 35",
  scope: "Design System Plus",
  de: "Organzaviolett",
  en: "Organza violet",
  nl: "Organza violet",
  fr: "Violet d'organza"
}, {
  hex: "#acaeb6",
  code: "280 70 05",
  scope: "Design System Plus",
  de: "Taupegrau",
  en: "Taupe grey",
  nl: "Taupegrijs",
  fr: "Gris taupe"
}, {
  hex: "#abb0bf",
  code: "280 70 10",
  scope: "Design System Plus",
  de: "Tüllviolett",
  en: "Tulle violet",
  nl: "Tule violet",
  fr: "Violet de tulle"
}, {
  hex: "#a8b0c8",
  code: "280 70 15",
  scope: "Design System Plus",
  de: "Sandglöckchenviola",
  en: "Foxflower viola",
  nl: "Zandloper altviool",
  fr: "Viola sablonneuse"
}, {
  hex: "#a3afd1",
  code: "280 70 20",
  scope: "Design System Plus",
  de: "Fliederduftbleu",
  en: "Lilac scent soft blue",
  nl: "Lila geparfumeerd lood",
  fr: "Bleu de parfum de lilas"
}, {
  hex: "#a1b0da",
  code: "280 70 25",
  scope: "Design System Plus",
  de: "Asterblütenblau",
  en: "Aster flower blue",
  nl: "Asterbloem blauw",
  fr: "Bleu fleur d'aster"
}, {
  hex: "#c8cad1",
  code: "280 80 05",
  scope: "Design System Plus",
  de: "Violaeisgrau",
  en: "Viola ice grey",
  nl: "Viool ijsgrijs",
  fr: "Gris violet"
}, {
  hex: "#c4c9d9",
  code: "280 80 10",
  scope: "Design System Plus",
  de: "Hyazinthenweißbleu",
  en: "Hyacinth white soft blue",
  nl: "Hyacint wit lood",
  fr: "Bleu blanc jacinthe"
}, {
  hex: "#bfc8e0",
  code: "280 80 15",
  scope: "Design System Plus",
  de: "Veilchenduftbleu",
  en: "Violet scent soft blue",
  nl: "Bleu met viooltjesgeur",
  fr: "Bleu de parfum de violette"
}, {
  hex: "#d2d5db",
  code: "280 85 05",
  scope: "Design System Plus",
  de: "Kieselbleuweiß",
  en: "Pebble soft blue white",
  nl: "Kiezel lood wit",
  fr: "Blanc plomb galet"
}, {
  hex: "#cdd4e4",
  code: "280 85 10",
  scope: "Design System Plus",
  de: "Schmuckweiß",
  en: "Jewellery white",
  nl: "Juwelen wit",
  fr: "Blanc éclatant"
}, {
  hex: "#e0e3e8",
  code: "280 90 05",
  scope: "Design System Plus",
  de: "Lilaweiß",
  en: "Mauve white",
  nl: "Paars wit",
  fr: "Blanc lilas"
}, {
  hex: "#e8eaf0",
  code: "280 93 05",
  scope: "Design System Plus",
  de: "Porzellanweiß",
  en: "Porcelain white",
  nl: "Porselein wit",
  fr: "Blanc porcelaine"
}, {
  hex: "#454650",
  code: "290 20 10",
  scope: "Design System Plus",
  de: "Spinellsteinschwarz",
  en: "Spinel stone black",
  nl: "Spinelsteen zwart",
  fr: "Noir pierre spinelle"
}, {
  hex: "#474655",
  code: "290 20 15",
  scope: "Design System Plus",
  de: "Schwarzviolett",
  en: "Black violet",
  nl: "Zwart viooltje",
  fr: "Noir violet"
}, {
  hex: "#47485d",
  code: "290 20 20",
  scope: "Design System Plus",
  de: "Tropennachtblau",
  en: "Tropical night blue",
  nl: "Tropisch nachtblauw",
  fr: "Bleu nuit tropical"
}, {
  hex: "#434661",
  code: "290 20 25",
  scope: "Design System Plus",
  de: "Indigoviolett",
  en: "Indigo violet",
  nl: "Indigo violet",
  fr: "Violet indigo"
}, {
  hex: "#404465",
  code: "290 20 30",
  scope: "Design System Plus",
  de: "Ultramarinviolett",
  en: "Ultramarine violet",
  nl: "Ultramarijn violet",
  fr: "Violet outremer"
}, {
  hex: "#3e446c",
  code: "290 20 35",
  scope: "Design System Plus",
  de: "Trollingerblau",
  en: "Schiava blue",
  nl: "Trollinger blauw",
  fr: "Bleu trollinger"
}, {
  hex: "#565562",
  code: "290 30 10",
  scope: "Design System Plus",
  de: "Flintsteinblau",
  en: "Flintstone blue",
  nl: "Vuursteenblauw",
  fr: "Bleu silex"
}, {
  hex: "#555669",
  code: "290 30 15",
  scope: "Design System Plus",
  de: "Spinellschwarz",
  en: "Spinel black",
  nl: "Spinel zwart",
  fr: "Noir spinelle"
}, {
  hex: "#52536d",
  code: "290 30 20",
  scope: "Design System Plus",
  de: "Kirchenblau",
  en: "Church blue",
  nl: "Kerk blauw",
  fr: "Bleu église"
}, {
  hex: "#525475",
  code: "290 30 25",
  scope: "Design System Plus",
  de: "Finsternisblau",
  en: "Gloomy blue",
  nl: "Donkerblauw",
  fr: "Bleu éclipse"
}, {
  hex: "#4f537b",
  code: "290 30 30",
  scope: "Design System Plus",
  de: "Lembergerblau",
  en: "Lviv blue",
  nl: "Lemberger blauw",
  fr: "Bleu Lemberger"
}, {
  hex: "#4d5483",
  code: "290 30 35",
  scope: "Design System Plus",
  de: "Britischlila",
  en: "British mauve",
  nl: "Brits paars",
  fr: "Violet britannique"
}, {
  hex: "#495389",
  code: "290 30 40",
  scope: "Design System Plus",
  de: "Amtsviolett",
  en: "Official violet",
  nl: "Officieel violet",
  fr: "Violet officiel"
}, {
  hex: "#696876",
  code: "290 40 10",
  scope: "Design System Plus",
  de: "Sturmtaucherschwarz",
  en: "Shearwater black",
  nl: "Pijlstormvogel zwart",
  fr: "Noir plongeur de tempête"
}, {
  hex: "#68687d",
  code: "290 40 15",
  scope: "Design System Plus",
  de: "Achatviolett",
  en: "Agate violet",
  nl: "Agaat violet",
  fr: "Violet agate"
}, {
  hex: "#656785",
  code: "290 40 20",
  scope: "Design System Plus",
  de: "Tieflavendel",
  en: "Deep lavender",
  nl: "Diep lavendel",
  fr: "Lavande profonde"
}, {
  hex: "#63658b",
  code: "290 40 25",
  scope: "Design System Plus",
  de: "Dämmerungslila",
  en: "Dusk mauve",
  nl: "Schemerpaars",
  fr: "Violet crépusculaire"
}, {
  hex: "#606592",
  code: "290 40 30",
  scope: "Design System Plus",
  de: "Reichviolett",
  en: "Rich violet",
  nl: "Rijk violet",
  fr: "Violet riche"
}, {
  hex: "#5e6498",
  code: "290 40 35",
  scope: "Design System Plus",
  de: "Zwiebelschalenblau",
  en: "Onion skin blue",
  nl: "Uienschil blauw",
  fr: "Bleu pelure d'oignon"
}, {
  hex: "#5b65a1",
  code: "290 40 40",
  scope: "Design System Plus",
  de: "Schwertlilienblau",
  en: "Iris blue",
  nl: "Iris blauw",
  fr: "Bleu iris"
}, {
  hex: "#5664a7",
  code: "290 40 45",
  scope: "Design System Plus",
  de: "Veilchenblau",
  en: "Violet blue",
  nl: "Violetblauw",
  fr: "Bleu violet"
}, {
  hex: "#7c7c8c",
  code: "290 50 10",
  scope: "Design System Plus",
  de: "Aschlila",
  en: "Ash mauve",
  nl: "Ashlila",
  fr: "Aschlila"
}, {
  hex: "#7b7c92",
  code: "290 50 15",
  scope: "Design System Plus",
  de: "Sturmlila",
  en: "Stormy mauve",
  nl: "Stormpaars",
  fr: "Violet de tempête"
}, {
  hex: "#797a9b",
  code: "290 50 20",
  scope: "Design System Plus",
  de: "Seidenkrepplila",
  en: "Silk crepe mauve",
  nl: "Zijde crêpe paars",
  fr: "Crêpe de soie violet"
}, {
  hex: "#797ba4",
  code: "290 50 25",
  scope: "Design System Plus",
  de: "Hyazinthenlila",
  en: "Hyacinth mauve",
  nl: "Hyacint paars",
  fr: "Mauve jacinthe"
}, {
  hex: "#777aaa",
  code: "290 50 30",
  scope: "Design System Plus",
  de: "Bergblumenlila",
  en: "Mountain flower mauve",
  nl: "Bergbloem paars",
  fr: "Fleurs de montagne violettes"
}, {
  hex: "#7379b2",
  code: "290 50 35",
  scope: "Design System Plus",
  de: "Chalcedonviolett",
  en: "Chalcedony violet",
  nl: "Chalcedoon violet",
  fr: "Violet de calcédoine"
}, {
  hex: "#7079ba",
  code: "290 50 40",
  scope: "Design System Plus",
  de: "Gladiolenblau",
  en: "Gladiola blue",
  nl: "Gladiolen blauw",
  fr: "Bleu glaïeul"
}, {
  hex: "#9293a5",
  code: "290 60 10",
  scope: "Design System Plus",
  de: "Lavendelblütengrau",
  en: "Lavender blossom grey",
  nl: "Lavendelbloesem grijs",
  fr: "Gris fleur de lavande"
}, {
  hex: "#9393ac",
  code: "290 60 15",
  scope: "Design System Plus",
  de: "Grazilviolett",
  en: "Delicate violet",
  nl: "Grijsviolet",
  fr: "Violet gracile"
}, {
  hex: "#8f91b5",
  code: "290 60 20",
  scope: "Design System Plus",
  de: "Opernlila",
  en: "Opera mauve",
  nl: "Opera paars",
  fr: "Violet d'opéra"
}, {
  hex: "#9092bd",
  code: "290 60 25",
  scope: "Design System Plus",
  de: "Bleulavendel",
  en: "Soft blue lavender",
  nl: "Lavendel",
  fr: "Lavande de plomb"
}, {
  hex: "#8d91c4",
  code: "290 60 30",
  scope: "Design System Plus",
  de: "Plisseelila",
  en: "Pleated mauve",
  nl: "Geplooide lelie",
  fr: "Plisseelila"
}, {
  hex: "#888fca",
  code: "290 60 35",
  scope: "Design System Plus",
  de: "Echtlavendel",
  en: "True lavender",
  nl: "Echte lavendel",
  fr: "Lavande vraie"
}, {
  hex: "#adadbf",
  code: "290 70 10",
  scope: "Design System Plus",
  de: "Cremeviolett",
  en: "Cream violet",
  nl: "Crème violet",
  fr: "Violet crème"
}, {
  hex: "#ababc7",
  code: "290 70 15",
  scope: "Design System Plus",
  de: "Glyzinienhellbleu",
  en: "Wisteria light soft blue",
  nl: "Wisteria lichtsnoer",
  fr: "Bleu clair glycine"
}, {
  hex: "#a8abce",
  code: "290 70 20",
  scope: "Design System Plus",
  de: "Blütenlila",
  en: "Blossom mauve",
  nl: "Bloesempaars",
  fr: "Violet de fleur"
}, {
  hex: "#a7aad7",
  code: "290 70 25",
  scope: "Design System Plus",
  de: "Sorbeteislila",
  en: "Sorbet ice mauve",
  nl: "Sorbetijs lila",
  fr: "Violet de sorbetière"
}, {
  hex: "#c6c6d7",
  code: "290 80 10",
  scope: "Design System Plus",
  de: "Tulipanbleu",
  en: "Tulip soft blue",
  nl: "Tulpanbleu",
  fr: "Tulipanbleu"
}, {
  hex: "#c6c6de",
  code: "290 80 15",
  scope: "Design System Plus",
  de: "Blasslila",
  en: "Pale lilac",
  nl: "Lichtpaars",
  fr: "Violet pâle"
}, {
  hex: "#d5d5da",
  code: "290 85 05",
  scope: "Design System Plus",
  de: "Kalklila",
  en: "Limestone mauve",
  nl: "Kalklila",
  fr: "Violet de chaux"
}, {
  hex: "#d0d3e9",
  code: "290 85 10",
  scope: "Design System Plus",
  de: "Orchideenweiß",
  en: "Orchid white",
  nl: "Orchidee wit",
  fr: "Blanc orchidée"
}, {
  hex: "#dadbe0",
  code: "290 90 05",
  scope: "Design System Plus",
  de: "Violettweiß",
  en: "Violet white",
  nl: "Paars wit",
  fr: "Blanc violet"
}, {
  hex: "#e8e9ef",
  code: "290 93 05",
  scope: "Design System Plus",
  de: "Fliederweiß",
  en: "Lilac white",
  nl: "Lila wit",
  fr: "Blanc lilas"
}, {
  hex: "#4b494e",
  code: "300 20 05",
  scope: "Design System Plus",
  de: "Nachtschwarz",
  en: "Night black",
  nl: "Nacht zwart",
  fr: "Noir nuit"
}, {
  hex: "#494650",
  code: "300 20 10",
  scope: "Design System Plus",
  de: "Reiherblau",
  en: "Heron blue",
  nl: "Reiger blauw",
  fr: "Bleu héron"
}, {
  hex: "#494655",
  code: "300 20 15",
  scope: "Design System Plus",
  de: "Violaschwarz",
  en: "Viola black",
  nl: "Viola zwart",
  fr: "Noir viola"
}, {
  hex: "#49455a",
  code: "300 20 20",
  scope: "Design System Plus",
  de: "Brombeerschwarz",
  en: "Blackberry black",
  nl: "Bramen zwart",
  fr: "Noir mûre"
}, {
  hex: "#49445c",
  code: "300 20 25",
  scope: "Design System Plus",
  de: "Kardinallila",
  en: "Cardinal mauve",
  nl: "Kardinaal paars",
  fr: "Violet de cardinal"
}, {
  hex: "#474364",
  code: "300 20 30",
  scope: "Design System Plus",
  de: "Zeremonienpurpur",
  en: "Ceremonial purple",
  nl: "Ceremonieel paars",
  fr: "Pourpre de cérémonie"
}, {
  hex: "#59575d",
  code: "300 30 05",
  scope: "Design System Plus",
  de: "Nachtgrau",
  en: "Night grey",
  nl: "Nacht grijs",
  fr: "Gris nuit"
}, {
  hex: "#585562",
  code: "300 30 10",
  scope: "Design System Plus",
  de: "Trauerviolett",
  en: "Mourning violet",
  nl: "Rouwviooltje",
  fr: "Violet funèbre"
}, {
  hex: "#595466",
  code: "300 30 15",
  scope: "Design System Plus",
  de: "Clubgrau",
  en: "Club grey",
  nl: "Club grijs",
  fr: "Gris club"
}, {
  hex: "#59536c",
  code: "300 30 20",
  scope: "Design System Plus",
  de: "Maulbeerlilaschwarz",
  en: "Mulberry mauve black",
  nl: "Moerbei lila zwart",
  fr: "Noir silver mûrier"
}, {
  hex: "#595272",
  code: "300 30 25",
  scope: "Design System Plus",
  de: "Abendlila",
  en: "Evening mauve",
  nl: "Avondlila",
  fr: "Mauve du soir"
}, {
  hex: "#595278",
  code: "300 30 30",
  scope: "Design System Plus",
  de: "Opernblau",
  en: "Opera blue",
  nl: "Opera blauw",
  fr: "Bleu opéra"
}, {
  hex: "#57517e",
  code: "300 30 35",
  scope: "Design System Plus",
  de: "Tiefviolett",
  en: "Deep violet",
  nl: "Diep violet",
  fr: "Violet profond"
}, {
  hex: "#565084",
  code: "300 30 40",
  scope: "Design System Plus",
  de: "Salbeiviolett",
  en: "Sage violet",
  nl: "Salieviolet",
  fr: "Violet sauge"
}, {
  hex: "#6c6a70",
  code: "300 40 05",
  scope: "Design System Plus",
  de: "Barockgrau",
  en: "Baroque grey",
  nl: "Barok grijs",
  fr: "Gris baroque"
}, {
  hex: "#6b6775",
  code: "300 40 10",
  scope: "Design System Plus",
  de: "Gobelinlila",
  en: "Gobelin mauve",
  nl: "Wandtapijt paars",
  fr: "Violet de tapisserie"
}, {
  hex: "#6b657b",
  code: "300 40 15",
  scope: "Design System Plus",
  de: "Orchideengrau",
  en: "Orchid grey",
  nl: "Orchidee grijs",
  fr: "Gris orchidée"
}, {
  hex: "#6c6581",
  code: "300 40 20",
  scope: "Design System Plus",
  de: "Altlila",
  en: "Old mauve",
  nl: "Oud paars",
  fr: "Vieux violet"
}, {
  hex: "#6c6488",
  code: "300 40 25",
  scope: "Design System Plus",
  de: "Parmalila",
  en: "Parma mauve",
  nl: "Parmalila",
  fr: "Parmalila"
}, {
  hex: "#6c638e",
  code: "300 40 30",
  scope: "Design System Plus",
  de: "Wollviolett",
  en: "Wool violet",
  nl: "Wolviolet",
  fr: "Violet de laine"
}, {
  hex: "#6b6293",
  code: "300 40 35",
  scope: "Design System Plus",
  de: "Edelpurpur",
  en: "Fine purple",
  nl: "Edel paars",
  fr: "Pourpre noble"
}, {
  hex: "#696099",
  code: "300 40 40",
  scope: "Design System Plus",
  de: "Clematisblau",
  en: "Clematis blue",
  nl: "Clematis blauw",
  fr: "Bleu clématite"
}, {
  hex: "#6860a1",
  code: "300 40 45",
  scope: "Design System Plus",
  de: "Krönungsblau",
  en: "Coronation blue",
  nl: "Kroningsblauw",
  fr: "Bleu couronnement"
}, {
  hex: "#807e85",
  code: "300 50 05",
  scope: "Design System Plus",
  de: "Falkengrau",
  en: "Hawk grey",
  nl: "Valk grijs",
  fr: "Gris faucon"
}, {
  hex: "#817c8b",
  code: "300 50 10",
  scope: "Design System Plus",
  de: "Veilchengrau",
  en: "Violet grey",
  nl: "Paars grijs",
  fr: "Gris violet"
}, {
  hex: "#817b92",
  code: "300 50 15",
  scope: "Design System Plus",
  de: "Auerhahnlila",
  en: "Capercaillie mauve",
  nl: "Auerhoen paars",
  fr: "Mauve coq de bruyère"
}, {
  hex: "#817999",
  code: "300 50 20",
  scope: "Design System Plus",
  de: "Pariserviolett",
  en: "Parisian violet",
  nl: "Parijs viooltje",
  fr: "Violet de Paris"
}, {
  hex: "#8178a0",
  code: "300 50 25",
  scope: "Design System Plus",
  de: "Tulpenviolett",
  en: "Tulip violet",
  nl: "Tulpviooltje",
  fr: "Violet tulipe"
}, {
  hex: "#8177a7",
  code: "300 50 30",
  scope: "Design System Plus",
  de: "Spielzeuglila",
  en: "Toy mauve",
  nl: "Speelgoed paars",
  fr: "Violet de jouet"
}, {
  hex: "#8277ae",
  code: "300 50 35",
  scope: "Design System Plus",
  de: "Winterzeitlila",
  en: "Wintertime mauve",
  nl: "Winterpaars",
  fr: "Temps d'hiverlila"
}, {
  hex: "#8075b4",
  code: "300 50 40",
  scope: "Design System Plus",
  de: "Klarlila",
  en: "Clear mauve",
  nl: "Helder paars",
  fr: "Violet clair"
}, {
  hex: "#98969e",
  code: "300 60 05",
  scope: "Design System Plus",
  de: "Rebhuhngrau",
  en: "Partridge grey",
  nl: "Patrijs grijs",
  fr: "Gris perdrix"
}, {
  hex: "#9893a3",
  code: "300 60 10",
  scope: "Design System Plus",
  de: "Rosengrau",
  en: "Rose grey",
  nl: "Roze grijs",
  fr: "Gris rose"
}, {
  hex: "#9992ab",
  code: "300 60 15",
  scope: "Design System Plus",
  de: "Antikviola",
  en: "Antique viola",
  nl: "Antieke altviool",
  fr: "Antikviola"
}, {
  hex: "#9990b1",
  code: "300 60 20",
  scope: "Design System Plus",
  de: "Ritterspornviolett",
  en: "Larkspur violet",
  nl: "Ridderspoor paars",
  fr: "Violet d'aconit"
}, {
  hex: "#988eb8",
  code: "300 60 25",
  scope: "Design System Plus",
  de: "Seidenflieder",
  en: "Silk lilac",
  nl: "Lila",
  fr: "Lilas de soie"
}, {
  hex: "#988dc0",
  code: "300 60 30",
  scope: "Design System Plus",
  de: "Heliotroplila",
  en: "Heliotropic mauve",
  nl: "Heliotroop paars",
  fr: "Héliotrope violet"
}, {
  hex: "#978bc6",
  code: "300 60 35",
  scope: "Design System Plus",
  de: "Amethystgrau",
  en: "Amethyst grey",
  nl: "Amethist grijs",
  fr: "Gris améthyste"
}, {
  hex: "#b0aeb7",
  code: "300 70 05",
  scope: "Design System Plus",
  de: "Samtgrau",
  en: "Velvet grey",
  nl: "Fluweel grijs",
  fr: "Gris velours"
}, {
  hex: "#b1abbc",
  code: "300 70 10",
  scope: "Design System Plus",
  de: "Morgendunstgrau",
  en: "Morning mist grey",
  nl: "Ochtendmist grijs",
  fr: "Gris de brume matinale"
}, {
  hex: "#b1aac4",
  code: "300 70 15",
  scope: "Design System Plus",
  de: "Lidschattenviola",
  en: "Eyeshadow viola",
  nl: "Oogschaduw violet",
  fr: "Viola d'ombre à paupières"
}, {
  hex: "#b2a9cb",
  code: "300 70 20",
  scope: "Design System Plus",
  de: "Lavendelviolett",
  en: "Lavender violet",
  nl: "Lavendelviolet",
  fr: "Violet lavande"
}, {
  hex: "#b2a7d2",
  code: "300 70 25",
  scope: "Design System Plus",
  de: "Pinklavendel",
  en: "Pink lavender",
  nl: "Roze lavendel",
  fr: "Lavande rose"
}, {
  hex: "#cac8d0",
  code: "300 80 05",
  scope: "Design System Plus",
  de: "Dunstlila",
  en: "Hazy mauve",
  nl: "Damp paars",
  fr: "Voile de brume"
}, {
  hex: "#c9c5d8",
  code: "300 80 10",
  scope: "Design System Plus",
  de: "Blassviolett",
  en: "Pale violet",
  nl: "Licht violet",
  fr: "Violet pâle"
}, {
  hex: "#cbc4de",
  code: "300 80 15",
  scope: "Design System Plus",
  de: "Eislila",
  en: "Ice mauve",
  nl: "IJspaars",
  fr: "Violet glacé"
}, {
  hex: "#d5d4da",
  code: "300 85 05",
  scope: "Design System Plus",
  de: "Zartviola",
  en: "Delicate viola",
  nl: "Zartviola",
  fr: "Viole de gambe"
}, {
  hex: "#d8d1e4",
  code: "300 85 10",
  scope: "Design System Plus",
  de: "Puderviolaweiß",
  en: "Powder viola white",
  nl: "Poeder violet wit",
  fr: "Blanc poudré violet"
}, {
  hex: "#e4e2e8",
  code: "300 90 05",
  scope: "Design System Plus",
  de: "Lasurweiß",
  en: "Translucent white",
  nl: "Glazuur wit",
  fr: "Blanc lasuré"
}, {
  hex: "#4f4658",
  code: "310 20 20",
  scope: "Design System Plus",
  de: "Obsidianlavaschwarz",
  en: "Obsidian lava black",
  nl: "Obsidiaan lava zwart",
  fr: "Noir lave obsidienne"
}, {
  hex: "#51445d",
  code: "310 20 25",
  scope: "Design System Plus",
  de: "Operettenlila",
  en: "Operetta mauve",
  nl: "Operette paars",
  fr: "Violet d'opérette"
}, {
  hex: "#4f4261",
  code: "310 20 30",
  scope: "Design System Plus",
  de: "Machtviolett",
  en: "Powerful violet",
  nl: "Kracht violet",
  fr: "Violet de puissance"
}, {
  hex: "#5f5667",
  code: "310 30 15",
  scope: "Design System Plus",
  de: "Dunkelgraulila",
  en: "Dark grey mauve",
  nl: "Donkergrijs paars",
  fr: "Violet foncé"
}, {
  hex: "#5e536b",
  code: "310 30 20",
  scope: "Design System Plus",
  de: "Machtlila",
  en: "Powerful mauve",
  nl: "Kracht paars",
  fr: "Violet de puissance"
}, {
  hex: "#615270",
  code: "310 30 25",
  scope: "Design System Plus",
  de: "Englischviolett",
  en: "English violet",
  nl: "Engels viooltje",
  fr: "Violet anglais"
}, {
  hex: "#635176",
  code: "310 30 30",
  scope: "Design System Plus",
  de: "Kristallpurpur",
  en: "Crystal purple",
  nl: "Kristalpaars",
  fr: "Pourpre de cristal"
}, {
  hex: "#625078",
  code: "310 30 35",
  scope: "Design System Plus",
  de: "Prägnantviolett",
  en: "Succinct violet",
  nl: "Beknopt violet",
  fr: "Violet incisif"
}, {
  hex: "#654f7f",
  code: "310 30 40",
  scope: "Design System Plus",
  de: "Lodenpurpur",
  en: "Loden purple",
  nl: "Loden paars",
  fr: "Pourpre de lodge"
}, {
  hex: "#706976",
  code: "310 40 10",
  scope: "Design System Plus",
  de: "Dunkelpink",
  en: "Dark pink",
  nl: "Donkerroze",
  fr: "Rose foncé"
}, {
  hex: "#73687c",
  code: "310 40 15",
  scope: "Design System Plus",
  de: "Schleierviolett",
  en: "Violet haze",
  nl: "Sluier violet",
  fr: "Violet voilé"
}, {
  hex: "#756781",
  code: "310 40 20",
  scope: "Design System Plus",
  de: "Indigorot",
  en: "Indigo red",
  nl: "Indigorood",
  fr: "Indigorot"
}, {
  hex: "#766587",
  code: "310 40 25",
  scope: "Design System Plus",
  de: "Charoitviolett",
  en: "Charoite violet",
  nl: "Charoiet violet",
  fr: "Violet de charoit"
}, {
  hex: "#76628a",
  code: "310 40 30",
  scope: "Design System Plus",
  de: "Königspurpur",
  en: "Royal purple",
  nl: "Koningspaars",
  fr: "Pourpre royale"
}, {
  hex: "#776190",
  code: "310 40 35",
  scope: "Design System Plus",
  de: "Magentaveilchen",
  en: "Magenta violet",
  nl: "Magenta viooltjes",
  fr: "Violette de Magenta"
}, {
  hex: "#7a6196",
  code: "310 40 40",
  scope: "Design System Plus",
  de: "Purlila",
  en: "Pure mauve",
  nl: "Paars",
  fr: "Pourpre"
}, {
  hex: "#857d8c",
  code: "310 50 10",
  scope: "Design System Plus",
  de: "Trüblila",
  en: "Dull mauve",
  nl: "Bewolkt paars",
  fr: "Violet trouble"
}, {
  hex: "#867c92",
  code: "310 50 15",
  scope: "Design System Plus",
  de: "Batikflieder",
  en: "Batik lilac",
  nl: "Batik seringen",
  fr: "Lilas batik"
}, {
  hex: "#8a7b97",
  code: "310 50 20",
  scope: "Design System Plus",
  de: "Provenceviolett",
  en: "Provence violet",
  nl: "Provençaals viooltje",
  fr: "Violet de Provence"
}, {
  hex: "#8c799e",
  code: "310 50 25",
  scope: "Design System Plus",
  de: "Baronesslila",
  en: "Baroness mauve",
  nl: "Barones paars",
  fr: "Baronesslila"
}, {
  hex: "#8d77a4",
  code: "310 50 30",
  scope: "Design System Plus",
  de: "Bitterviolett",
  en: "Bitter violet",
  nl: "Bitter viooltje",
  fr: "Violet amer"
}, {
  hex: "#8d75a8",
  code: "310 50 35",
  scope: "Design System Plus",
  de: "Violettrosé",
  en: "Violet rose",
  nl: "Violette roos",
  fr: "Rose violacé"
}, {
  hex: "#8f74ae",
  code: "310 50 40",
  scope: "Design System Plus",
  de: "Orchideenlila",
  en: "Orchid mauve",
  nl: "Orchidee paars",
  fr: "Violet d'orchidée"
}, {
  hex: "#9b93a3",
  code: "310 60 10",
  scope: "Design System Plus",
  de: "Dezentlila",
  en: "Gentle mauve",
  nl: "Fatsoenlijk paars",
  fr: "Violet discret"
}, {
  hex: "#9f92aa",
  code: "310 60 15",
  scope: "Design System Plus",
  de: "Rauchlila",
  en: "Smoky mauve",
  nl: "Rookpaars",
  fr: "Violet de fumée"
}, {
  hex: "#a291b0",
  code: "310 60 20",
  scope: "Design System Plus",
  de: "Safranblütenlila",
  en: "Saffron blossom mauve",
  nl: "Saffraanbloesem paars",
  fr: "Violet fleur de safran"
}, {
  hex: "#a48fb5",
  code: "310 60 25",
  scope: "Design System Plus",
  de: "Kokettpink",
  en: "Flirty pink",
  nl: "Coquett roze",
  fr: "Rose cocotte"
}, {
  hex: "#a58dba",
  code: "310 60 30",
  scope: "Design System Plus",
  de: "Pfingstrosenlila",
  en: "Peony mauve",
  nl: "Pioen paars",
  fr: "Mauve pivoine"
}, {
  hex: "#a78ac3",
  code: "310 60 35",
  scope: "Design System Plus",
  de: "Lilapurpur",
  en: "Lilac purple",
  nl: "Paars",
  fr: "Lilapurpur"
}, {
  hex: "#b5acbb",
  code: "310 70 10",
  scope: "Design System Plus",
  de: "Amorphrosé",
  en: "Amorphous rose",
  nl: "Amorfrosé",
  fr: "Amorphrosé"
}, {
  hex: "#b8aac2",
  code: "310 70 15",
  scope: "Design System Plus",
  de: "Transparentlila",
  en: "Transparent mauve",
  nl: "Transparant paars",
  fr: "Violet transparent"
}, {
  hex: "#b9a8c7",
  code: "310 70 20",
  scope: "Design System Plus",
  de: "Blaurosa",
  en: "Blue pink",
  nl: "Blauw roze",
  fr: "Rose bleu"
}, {
  hex: "#bba7ce",
  code: "310 70 25",
  scope: "Design System Plus",
  de: "Glasviolett",
  en: "Glass violet",
  nl: "Glasviolet",
  fr: "Violet de verre"
}, {
  hex: "#cdc5d5",
  code: "310 80 10",
  scope: "Design System Plus",
  de: "Puderviola",
  en: "Powder viola",
  nl: "Puderviola",
  fr: "Puderviola"
}, {
  hex: "#d1c4db",
  code: "310 80 15",
  scope: "Design System Plus",
  de: "Orchideenviolett",
  en: "Orchid violet",
  nl: "Orchidee viooltje",
  fr: "Violet d'orchidée"
}, {
  hex: "#d6d3da",
  code: "310 85 05",
  scope: "Design System Plus",
  de: "Feenrosa",
  en: "Fairy pink",
  nl: "Feeënroze",
  fr: "Rose fée"
}, {
  hex: "#dbd1e2",
  code: "310 85 10",
  scope: "Design System Plus",
  de: "Tricotfliederweiß",
  en: "Tricot lilac white",
  nl: "Tricot lila wit",
  fr: "Blanc tricot lilas"
}, {
  hex: "#e8e3e7",
  code: "310 90 05",
  scope: "Design System Plus",
  de: "Mauerblümchenweiß",
  en: "Wallflower white",
  nl: "Muurbloem wit",
  fr: "Fleur de mur blanc"
}, {
  hex: "#4d494e",
  code: "320 20 05",
  scope: "Design System Plus",
  de: "Lavaschwarz",
  en: "Lava black",
  nl: "Lavazwart",
  fr: "Noir lave"
}, {
  hex: "#4e464f",
  code: "320 20 10",
  scope: "Design System Plus",
  de: "Obsidianrot",
  en: "Obsidian red",
  nl: "Obsidiaan rood",
  fr: "Rouge obsidienne"
}, {
  hex: "#4f4451",
  code: "320 20 15",
  scope: "Design System Plus",
  de: "Spinellviolett",
  en: "Spinel violet",
  nl: "Spinel violet",
  fr: "Violet spinelle"
}, {
  hex: "#534455",
  code: "320 20 20",
  scope: "Design System Plus",
  de: "Auberginenlila",
  en: "Aubergine mauve",
  nl: "Aubergine paars",
  fr: "Violet d'aubergine"
}, {
  hex: "#534259",
  code: "320 20 25",
  scope: "Design System Plus",
  de: "Dunkelpurpur",
  en: "Dark purple",
  nl: "Donkerpaars",
  fr: "Pourpre foncé"
}, {
  hex: "#5b565b",
  code: "320 30 05",
  scope: "Design System Plus",
  de: "Violettschwarz",
  en: "Violet black",
  nl: "Paars zwart",
  fr: "Noir violet"
}, {
  hex: "#5d545e",
  code: "320 30 10",
  scope: "Design System Plus",
  de: "Steinviolett",
  en: "Stone violet",
  nl: "Steenviolet",
  fr: "Violet pierre"
}, {
  hex: "#605161",
  code: "320 30 15",
  scope: "Design System Plus",
  de: "Amethystdunkelviolett",
  en: "Amethyst dark violet",
  nl: "Amethist donker violet",
  fr: "Améthyste violet foncé"
}, {
  hex: "#634f66",
  code: "320 30 20",
  scope: "Design System Plus",
  de: "Dunkelbrombeer",
  en: "Dark blackberry",
  nl: "Donkere braam",
  fr: "Mûre foncée"
}, {
  hex: "#664e6a",
  code: "320 30 25",
  scope: "Design System Plus",
  de: "Purpuritviolett",
  en: "Purpurite violet",
  nl: "Purpuriet violet",
  fr: "Violet pourpre"
}, {
  hex: "#674c6e",
  code: "320 30 30",
  scope: "Design System Plus",
  de: "Zwetschgenlila",
  en: "Damson mauve",
  nl: "Pruim paars",
  fr: "Violet prune"
}, {
  hex: "#694b73",
  code: "320 30 35",
  scope: "Design System Plus",
  de: "Traubenpurpur",
  en: "Grape purple",
  nl: "Druif paars",
  fr: "Pourpre de raisin"
}, {
  hex: "#6c4b77",
  code: "320 30 37",
  scope: "Design System Plus",
  de: "Loungeviolett",
  en: "Lounge violet",
  nl: "Lounge violet",
  fr: "Violet lounge"
}, {
  hex: "#6e696f",
  code: "320 40 05",
  scope: "Design System Plus",
  de: "Schieferlila",
  en: "Slate mauve",
  nl: "Leisteen paars",
  fr: "Violet ardoise"
}, {
  hex: "#716672",
  code: "320 40 10",
  scope: "Design System Plus",
  de: "Olivinbasalt",
  en: "Olivine basalt",
  nl: "Olivijn basalt",
  fr: "Basalte d'olivine"
}, {
  hex: "#746477",
  code: "320 40 15",
  scope: "Design System Plus",
  de: "Antikgrau",
  en: "Antique grey",
  nl: "Antiek grijs",
  fr: "Gris antique"
}, {
  hex: "#77627b",
  code: "320 40 20",
  scope: "Design System Plus",
  de: "Basilikumlila",
  en: "Basil mauve",
  nl: "Basilicum paars",
  fr: "Violet de basilic"
}, {
  hex: "#796080",
  code: "320 40 25",
  scope: "Design System Plus",
  de: "Gladiolenviolett",
  en: "Gladiola violet",
  nl: "Gladiolus viooltje",
  fr: "Violet glaïeul"
}, {
  hex: "#7d5d83",
  code: "320 40 30",
  scope: "Design System Plus",
  de: "Krautblütenviolett",
  en: "Cabbage blossom violet",
  nl: "Kruidenbloesem viooltje",
  fr: "Violet de fleur d'herbe"
}, {
  hex: "#7f5a87",
  code: "320 40 35",
  scope: "Design System Plus",
  de: "Fliederviolett",
  en: "Lilac violet",
  nl: "Lila viooltje",
  fr: "Violet lilas"
}, {
  hex: "#82598e",
  code: "320 40 40",
  scope: "Design System Plus",
  de: "Veilchenpurpur",
  en: "Violet purple",
  nl: "Violetpaars",
  fr: "Pourpre violette"
}, {
  hex: "#827c83",
  code: "320 50 05",
  scope: "Design System Plus",
  de: "Grauviolett",
  en: "Grey violet",
  nl: "Grijsviolet",
  fr: "Violet gris"
}, {
  hex: "#867987",
  code: "320 50 10",
  scope: "Design System Plus",
  de: "Britischgrauviolett",
  en: "British grey mauve",
  nl: "Brits grijs viooltje",
  fr: "Violet gris britannique"
}, {
  hex: "#89778c",
  code: "320 50 15",
  scope: "Design System Plus",
  de: "Parmagrau",
  en: "Parma grey",
  nl: "Parma grijs",
  fr: "Gris parme"
}, {
  hex: "#8e7793",
  code: "320 50 20",
  scope: "Design System Plus",
  de: "Alpenveilchen",
  en: "Cyclamen",
  nl: "Cyclamen",
  fr: "Cyclamen"
}, {
  hex: "#907397",
  code: "320 50 25",
  scope: "Design System Plus",
  de: "Poesielila",
  en: "Poetry mauve",
  nl: "Poëzie paars",
  fr: "Poesielila"
}, {
  hex: "#94729d",
  code: "320 50 30",
  scope: "Design System Plus",
  de: "Violagrau",
  en: "Viola grey",
  nl: "Viola grijs",
  fr: "Gris violacé"
}, {
  hex: "#966d9f",
  code: "320 50 35",
  scope: "Design System Plus",
  de: "Astervioletta",
  en: "Aster violetta",
  nl: "Asterviolet",
  fr: "Astervioletta"
}, {
  hex: "#996fa7",
  code: "320 50 40",
  scope: "Design System Plus",
  de: "Empireviolett",
  en: "Empire violet",
  nl: "Empire violet",
  fr: "Violet empire"
}, {
  hex: "#9a949c",
  code: "320 60 05",
  scope: "Design System Plus",
  de: "Aragonitgrau",
  en: "Aragonite grey",
  nl: "Aragoniet grijs",
  fr: "Gris aragonite"
}, {
  hex: "#9e929f",
  code: "320 60 10",
  scope: "Design System Plus",
  de: "Kreideviolett",
  en: "Chalk violet",
  nl: "Krijtviolet",
  fr: "Violet craie"
}, {
  hex: "#a28fa5",
  code: "320 60 15",
  scope: "Design System Plus",
  de: "Amethystgrauviolett",
  en: "Amethyst grey violet",
  nl: "Amethist grijs violet",
  fr: "Violet gris améthyste"
}, {
  hex: "#a58ba9",
  code: "320 60 20",
  scope: "Design System Plus",
  de: "Wunderveilchen",
  en: "Wonder violet",
  nl: "Wonderviooltje",
  fr: "Violette miraculeuse"
}, {
  hex: "#a889af",
  code: "320 60 25",
  scope: "Design System Plus",
  de: "Nachtschattenviolett",
  en: "Nightshade violet",
  nl: "Nachtschadeviooltje",
  fr: "Violet ombre de nuit"
}, {
  hex: "#ac87b5",
  code: "320 60 30",
  scope: "Design System Plus",
  de: "Lobbylila",
  en: "Lobby lilac",
  nl: "Lobby paars",
  fr: "Lobbylila"
}, {
  hex: "#ae85b9",
  code: "320 60 35",
  scope: "Design System Plus",
  de: "Sorbetbrombeer",
  en: "Blackberry sorbet",
  nl: "Sorbet braambes",
  fr: "Mûre sorbet"
}, {
  hex: "#b2acb3",
  code: "320 70 05",
  scope: "Design System Plus",
  de: "Holundergrau",
  en: "Elderberry grey",
  nl: "Vlierbes grijs",
  fr: "Gris sureau"
}, {
  hex: "#b6a9b9",
  code: "320 70 10",
  scope: "Design System Plus",
  de: "Glockenblumenviolett",
  en: "Bellflower violet",
  nl: "Klokjesviooltje",
  fr: "Violet de campanule"
}, {
  hex: "#b9a6be",
  code: "320 70 15",
  scope: "Design System Plus",
  de: "Quarzviolett",
  en: "Quartz violet",
  nl: "Kwarts violet",
  fr: "Violet de quartz"
}, {
  hex: "#c0a5c6",
  code: "320 70 20",
  scope: "Design System Plus",
  de: "Strandflieder",
  en: "Beach lilac",
  nl: "Strand lila",
  fr: "Lilas de plage"
}, {
  hex: "#c3a2ca",
  code: "320 70 25",
  scope: "Design System Plus",
  de: "Fliederpink",
  en: "Lilac pink",
  nl: "Lila roze",
  fr: "Rose lilas"
}, {
  hex: "#cdc7cd",
  code: "320 80 05",
  scope: "Design System Plus",
  de: "Hellviolett",
  en: "Light violet",
  nl: "Licht violet",
  fr: "Violet clair"
}, {
  hex: "#d1c4d3",
  code: "320 80 10",
  scope: "Design System Plus",
  de: "Amethysthellviolett",
  en: "Amethyst light violet",
  nl: "Ametherschaal viooltje",
  fr: "Violet d'améthyste"
}, {
  hex: "#d4c0d6",
  code: "320 80 15",
  scope: "Design System Plus",
  de: "Kosmetiklila",
  en: "Cosmetic mauve",
  nl: "Cosmetisch paars",
  fr: "Violet cosmétique"
}, {
  hex: "#d8d1d9",
  code: "320 85 05",
  scope: "Design System Plus",
  de: "Brombeercreme",
  en: "Blackberry cream",
  nl: "Bramencrème",
  fr: "Crème de mûres"
}, {
  hex: "#ddcfdf",
  code: "320 85 10",
  scope: "Design System Plus",
  de: "Ametrinquarz",
  en: "Ametrine quartz",
  nl: "Ametrien kwarts",
  fr: "Quartz amétrine"
}, {
  hex: "#e8e1e6",
  code: "320 90 05",
  scope: "Design System Plus",
  de: "Apatitrosa",
  en: "Apatite pink",
  nl: "Apatitrosa",
  fr: "Apatitrosa"
}, {
  hex: "#554251",
  code: "330 20 20",
  scope: "Design System Plus",
  de: "Tiefgrundlila",
  en: "Profound mauve",
  nl: "Diep basispaars",
  fr: "Violet profond"
}, {
  hex: "#5a4256",
  code: "330 20 25",
  scope: "Design System Plus",
  de: "Opulentlila",
  en: "Opulent mauve",
  nl: "Weelderig paars",
  fr: "Violet opulent"
}, {
  hex: "#645361",
  code: "330 30 15",
  scope: "Design System Plus",
  de: "Korinthenviolett",
  en: "Currant violet",
  nl: "Korinthisch viooltje",
  fr: "Violet de Corinthe"
}, {
  hex: "#685164",
  code: "330 30 20",
  scope: "Design System Plus",
  de: "Mexikanischpurpur",
  en: "Mexican purple",
  nl: "Mexicaans paars",
  fr: "Pourpre mexicain"
}, {
  hex: "#6b4e66",
  code: "330 30 25",
  scope: "Design System Plus",
  de: "Parmapflaumenrot",
  en: "Parma plum red",
  nl: "Parma pruimenrood",
  fr: "Rouge parme prune"
}, {
  hex: "#704c6a",
  code: "330 30 30",
  scope: "Design System Plus",
  de: "Intensivpurpur",
  en: "Intense purple",
  nl: "Intens paars",
  fr: "Pourpre intense"
}, {
  hex: "#734b6e",
  code: "330 30 35",
  scope: "Design System Plus",
  de: "Opulentpurpur",
  en: "Opulent purple",
  nl: "Weelderig paars",
  fr: "Pourpre opulent"
}, {
  hex: "#75476f",
  code: "330 30 40",
  scope: "Design System Plus",
  de: "Intensivlila",
  en: "Intense mauve",
  nl: "Intens paars",
  fr: "Violet intense"
}, {
  hex: "#746772",
  code: "330 40 10",
  scope: "Design System Plus",
  de: "Patinaviolett",
  en: "Patina violet",
  nl: "Patina violet",
  fr: "Violet patiné"
}, {
  hex: "#786576",
  code: "330 40 15",
  scope: "Design System Plus",
  de: "Dunkelpurpurgrau",
  en: "Dark purple grey",
  nl: "Donkerpaars grijs",
  fr: "Gris pourpre foncé"
}, {
  hex: "#7d647a",
  code: "330 40 20",
  scope: "Design System Plus",
  de: "Amaranthrot",
  en: "Amaranth red",
  nl: "Amarant rood",
  fr: "Rouge amarante"
}, {
  hex: "#81627d",
  code: "330 40 25",
  scope: "Design System Plus",
  de: "Tiefmagenta",
  en: "Deep magenta",
  nl: "Diep magenta",
  fr: "Magenta profond"
}, {
  hex: "#885f81",
  code: "330 40 30",
  scope: "Design System Plus",
  de: "Phloxblumenviolett",
  en: "Phloxflower violet",
  nl: "Phlox bloem viooltje",
  fr: "Violet de fleur de phlox"
}, {
  hex: "#8b5d84",
  code: "330 40 35",
  scope: "Design System Plus",
  de: "Distellila",
  en: "Thistle mauve",
  nl: "Distel paars",
  fr: "Distellila"
}, {
  hex: "#8c5885",
  code: "330 40 40",
  scope: "Design System Plus",
  de: "Visionarot",
  en: "Visiona red",
  nl: "Visionarot",
  fr: "Visionarot"
}, {
  hex: "#8f5788",
  code: "330 40 45",
  scope: "Design System Plus",
  de: "Purpuritrot",
  en: "Purpurite red",
  nl: "Paars rood",
  fr: "Rouge pourpre"
}, {
  hex: "#897a86",
  code: "330 50 10",
  scope: "Design System Plus",
  de: "Jutegrau",
  en: "Burlap grey",
  nl: "Jute grijs",
  fr: "Gris jute"
}, {
  hex: "#8f7a8c",
  code: "330 50 15",
  scope: "Design System Plus",
  de: "Saphirrosa",
  en: "Sapphire pink",
  nl: "Saffierroze",
  fr: "Rose saphir"
}, {
  hex: "#947790",
  code: "330 50 20",
  scope: "Design System Plus",
  de: "Prachtnelkenlila",
  en: "Dianthus mauve",
  nl: "Prachtige anjer paars",
  fr: "Violet magnifique"
}, {
  hex: "#987593",
  code: "330 50 25",
  scope: "Design System Plus",
  de: "Kristallrosa",
  en: "Crystal pink",
  nl: "Kristalroze",
  fr: "Rose cristal"
}, {
  hex: "#9d7399",
  code: "330 50 30",
  scope: "Design System Plus",
  de: "Tulipanviolett",
  en: "Tulipan violet",
  nl: "Tulpenviooltje",
  fr: "Violet de tulipes"
}, {
  hex: "#a0709c",
  code: "330 50 35",
  scope: "Design System Plus",
  de: "Violettrot",
  en: "Violet red",
  nl: "Paarsrood",
  fr: "Rouge violet"
}, {
  hex: "#a56d9e",
  code: "330 50 40",
  scope: "Design System Plus",
  de: "Orchideenpurpur",
  en: "Orchid purple",
  nl: "Orchidee paars",
  fr: "Pourpre d'orchidée"
}, {
  hex: "#a1929f",
  code: "330 60 10",
  scope: "Design System Plus",
  de: "Greigeviolett",
  en: "Greige violet",
  nl: "Grijsviolet",
  fr: "Greige violet"
}, {
  hex: "#a791a4",
  code: "330 60 15",
  scope: "Design System Plus",
  de: "Vesuvianviolett",
  en: "Vesuvian violet",
  nl: "Vesuviaans viooltje",
  fr: "Violet vesuvian"
}, {
  hex: "#ad8ea8",
  code: "330 60 20",
  scope: "Design System Plus",
  de: "Enzianviolett",
  en: "Gentian violet",
  nl: "Gentiaanviooltje",
  fr: "Violet gentiane"
}, {
  hex: "#af8aa9",
  code: "330 60 25",
  scope: "Design System Plus",
  de: "Gründerzeitpink",
  en: "Wilhelminian pink",
  nl: "Wilhelminiaans roze",
  fr: "Rose des fondateurs"
}, {
  hex: "#b588af",
  code: "330 60 30",
  scope: "Design System Plus",
  de: "Bühnenlila",
  en: "Stage mauve",
  nl: "Podium paars",
  fr: "Violet de scène"
}, {
  hex: "#bb85b3",
  code: "330 60 35",
  scope: "Design System Plus",
  de: "Pfingstnelkenlila",
  en: "Cheddar pink mauve",
  nl: "Pinksteranjer paars",
  fr: "Violet de pivoine"
}, {
  hex: "#be82b7",
  code: "330 60 40",
  scope: "Design System Plus",
  de: "Colomborotlila",
  en: "Colombo red mauve",
  nl: "Colomborot paars",
  fr: "Colomborotlila"
}, {
  hex: "#bcabb9",
  code: "330 70 10",
  scope: "Design System Plus",
  de: "Nebelrosa",
  en: "Mist pink",
  nl: "Mistig roze",
  fr: "Rose brumeux"
}, {
  hex: "#bfa7bb",
  code: "330 70 15",
  scope: "Design System Plus",
  de: "Lauchblütenpink",
  en: "Leek blossom pink",
  nl: "Preibloesem roze",
  fr: "Rose fleur de poireau"
}, {
  hex: "#c5a6c0",
  code: "330 70 20",
  scope: "Design System Plus",
  de: "Erdbeerrosa",
  en: "Strawberry pink",
  nl: "Aardbeiroze",
  fr: "Rose fraise"
}, {
  hex: "#cca3c5",
  code: "330 70 25",
  scope: "Design System Plus",
  de: "Purpurrosa",
  en: "Purple pink",
  nl: "Paars roze",
  fr: "Rose pourpre"
}, {
  hex: "#d0a1c7",
  code: "330 70 30",
  scope: "Design System Plus",
  de: "Kleeblütenrosa",
  en: "Clover pink",
  nl: "Klaverbloesem roze",
  fr: "Rose de trèfle"
}, {
  hex: "#d5c4d1",
  code: "330 80 10",
  scope: "Design System Plus",
  de: "Purpurweiß",
  en: "Purple white",
  nl: "Paars wit",
  fr: "Blanc pourpre"
}, {
  hex: "#dac1d5",
  code: "330 80 15",
  scope: "Design System Plus",
  de: "Lieblichrosa",
  en: "Lovely pink",
  nl: "Mooi roze",
  fr: "Rose tendre"
}, {
  hex: "#e2bfd9",
  code: "330 80 20",
  scope: "Design System Plus",
  de: "Designerrosa",
  en: "Designer pink",
  nl: "Ontwerper roze",
  fr: "Rose design"
}, {
  hex: "#d9d3d9",
  code: "330 85 05",
  scope: "Design System Plus",
  de: "Hellmagnolienrosé",
  en: "Light magnolia rose",
  nl: "Lichte magnolia rosé",
  fr: "Rose magnolia clair"
}, {
  hex: "#e2d1de",
  code: "330 85 10",
  scope: "Design System Plus",
  de: "Himbeerrosa",
  en: "Raspberry pink",
  nl: "Framboos roze",
  fr: "Rose framboise"
}, {
  hex: "#e8cee1",
  code: "330 85 15",
  scope: "Design System Plus",
  de: "Himmlischrosa",
  en: "Heavenly pink",
  nl: "Hemels roze",
  fr: "Rose céleste"
}, {
  hex: "#ebe2e5",
  code: "330 90 05",
  scope: "Design System Plus",
  de: "Delikatessweiß",
  en: "Delicacy white",
  nl: "Delicatesse wit",
  fr: "Blanc délicat"
}, {
  hex: "#4d474b",
  code: "340 20 05",
  scope: "Design System Plus",
  de: "Lakritzschwarz",
  en: "Liquorice black",
  nl: "Zoethout zwart",
  fr: "Noir réglisse"
}, {
  hex: "#50444a",
  code: "340 20 10",
  scope: "Design System Plus",
  de: "Mangostanoviolett",
  en: "Mangosteen violet",
  nl: "Mangosteenviooltje",
  fr: "Violet de mangoustan"
}, {
  hex: "#53414b",
  code: "340 20 15",
  scope: "Design System Plus",
  de: "Sitterrot",
  en: "Sitter red",
  nl: "Zitter rood",
  fr: "Rouge de Sitter"
}, {
  hex: "#58414e",
  code: "340 20 20",
  scope: "Design System Plus",
  de: "Saftviolett",
  en: "Juice violet",
  nl: "Sap viooltje",
  fr: "Violet de jus"
}, {
  hex: "#5f4252",
  code: "340 20 25",
  scope: "Design System Plus",
  de: "Prestigelila",
  en: "Prestige mauve",
  nl: "Prestige paars",
  fr: "Prestigelila"
}, {
  hex: "#5c5559",
  code: "340 30 05",
  scope: "Design System Plus",
  de: "Apfelkrautschwarz",
  en: "Apple herb black",
  nl: "Appelkruid zwart",
  fr: "Noir pomme-gris"
}, {
  hex: "#61525a",
  code: "340 30 10",
  scope: "Design System Plus",
  de: "Passionsfruchtlila",
  en: "Passionfruit mauve",
  nl: "Passievrucht paars",
  fr: "Mauve fruit de la passion"
}, {
  hex: "#66505c",
  code: "340 30 15",
  scope: "Design System Plus",
  de: "Dunkelfeigenviolett",
  en: "Dark fig violet",
  nl: "Donker vijgenviolet",
  fr: "Violet figue foncé"
}, {
  hex: "#6a4e5e",
  code: "340 30 20",
  scope: "Design System Plus",
  de: "Rubinviolett",
  en: "Ruby violet",
  nl: "Robijnviolet",
  fr: "Violet rubis"
}, {
  hex: "#6f4c62",
  code: "340 30 25",
  scope: "Design System Plus",
  de: "Brombeertiefrot",
  en: "Blackberry deep red",
  nl: "Framboos dieprood",
  fr: "Mûre profonde"
}, {
  hex: "#714963",
  code: "340 30 30",
  scope: "Design System Plus",
  de: "Tiefrot",
  en: "Deep red",
  nl: "Diep rood",
  fr: "Rouge profond"
}, {
  hex: "#754664",
  code: "340 30 35",
  scope: "Design System Plus",
  de: "Samtlila",
  en: "Velvet mauve",
  nl: "Fluweelpaars",
  fr: "Violet velours"
}, {
  hex: "#7a4366",
  code: "340 30 38",
  scope: "Design System Plus",
  de: "Waldfruchtrot",
  en: "Forest fruit red",
  nl: "Bosvruchten rood",
  fr: "Rouge fruit de forêt"
}, {
  hex: "#6f676b",
  code: "340 40 05",
  scope: "Design System Plus",
  de: "Lilabraun",
  en: "Mauve brown",
  nl: "Paarsbruin",
  fr: "Marron lilas"
}, {
  hex: "#76646d",
  code: "340 40 10",
  scope: "Design System Plus",
  de: "Spinellgrau",
  en: "Spinel grey",
  nl: "Spinel grijs",
  fr: "Gris spinelle"
}, {
  hex: "#7b6270",
  code: "340 40 15",
  scope: "Design System Plus",
  de: "Erdbraunviolett",
  en: "Earth brown violet",
  nl: "Aarde bruin violet",
  fr: "Marron terre violet"
}, {
  hex: "#805f72",
  code: "340 40 20",
  scope: "Design System Plus",
  de: "Dahlienmattrot",
  en: "Dahlia matte red",
  nl: "Dahlia mat rood",
  fr: "Dahlia mat"
}, {
  hex: "#855d76",
  code: "340 40 25",
  scope: "Design System Plus",
  de: "Brokatviolett",
  en: "Brocade violet",
  nl: "Brokaatviolet",
  fr: "Violet de brocart"
}, {
  hex: "#895a78",
  code: "340 40 30",
  scope: "Design System Plus",
  de: "Krappmagenta",
  en: "Madder magenta",
  nl: "Madder magenta",
  fr: "Magenta de garance"
}, {
  hex: "#8b557a",
  code: "340 40 35",
  scope: "Design System Plus",
  de: "Clublila",
  en: "Club mauve",
  nl: "Club paars",
  fr: "Clublila"
}, {
  hex: "#90527b",
  code: "340 40 40",
  scope: "Design System Plus",
  de: "Kirschrot",
  en: "Cherry red",
  nl: "Kersenrood",
  fr: "Rouge cerise"
}, {
  hex: "#994f80",
  code: "340 40 45",
  scope: "Design System Plus",
  de: "Magentarot",
  en: "Magenta red",
  nl: "Magenta rood",
  fr: "Rouge magenta"
}, {
  hex: "#857c81",
  code: "340 50 05",
  scope: "Design System Plus",
  de: "Jubiläumsgrau",
  en: "Jubilee grey",
  nl: "Jubileum grijs",
  fr: "Gris anniversaire"
}, {
  hex: "#8c7984",
  code: "340 50 10",
  scope: "Design System Plus",
  de: "Portweinrot",
  en: "Port wine red",
  nl: "Portwijn rood",
  fr: "Rouge porto"
}, {
  hex: "#927686",
  code: "340 50 15",
  scope: "Design System Plus",
  de: "Rohgranatviola",
  en: "Raw garnet viola",
  nl: "Granaat altviool",
  fr: "Viola brute à la grenade"
}, {
  hex: "#987489",
  code: "340 50 20",
  scope: "Design System Plus",
  de: "Kreuzblumenrot",
  en: "Milkwort red",
  nl: "Kruisbloem rood",
  fr: "Rouge fleur de trèfle"
}, {
  hex: "#9d708b",
  code: "340 50 25",
  scope: "Design System Plus",
  de: "Rostmagenta",
  en: "Rust magenta",
  nl: "Roest magenta",
  fr: "Magenta rouillé"
}, {
  hex: "#a26d8e",
  code: "340 50 30",
  scope: "Design System Plus",
  de: "Himbeergeleerot",
  en: "Raspberry jelly red",
  nl: "Frambozengelei rood",
  fr: "Rouge gélifié à la framboise"
}, {
  hex: "#a56890",
  code: "340 50 35",
  scope: "Design System Plus",
  de: "Fingerhutrot",
  en: "Thimble red",
  nl: "Vingerhoedskruid rood",
  fr: "Rouge dé à coudre"
}, {
  hex: "#ad6693",
  code: "340 50 40",
  scope: "Design System Plus",
  de: "Cyclamonrot",
  en: "Cyclamen red",
  nl: "Cyclamen rood",
  fr: "Rouge cyclamon"
}, {
  hex: "#b26295",
  code: "340 50 45",
  scope: "Design System Plus",
  de: "Brillantkarmin",
  en: "Brilliant carmine",
  nl: "Schitterende karmijn",
  fr: "Carmin brillant"
}, {
  hex: "#9e959a",
  code: "340 60 05",
  scope: "Design System Plus",
  de: "Erikarotgrau",
  en: "Heather red grey",
  nl: "Erika rood grijs",
  fr: "Gris Éricarot"
}, {
  hex: "#a48f9b",
  code: "340 60 10",
  scope: "Design System Plus",
  de: "Pianomauve",
  en: "Piano mauve",
  nl: "Piano mauve",
  fr: "Pianomauve"
}, {
  hex: "#ac8d9f",
  code: "340 60 15",
  scope: "Design System Plus",
  de: "Abendrosa",
  en: "Evening pink",
  nl: "Avondroze",
  fr: "Rose du soir"
}, {
  hex: "#b08aa1",
  code: "340 60 20",
  scope: "Design System Plus",
  de: "Caprimodepink",
  en: "Capri fashion pink",
  nl: "Caprimode roze",
  fr: "Caprimodepink"
}, {
  hex: "#b587a3",
  code: "340 60 25",
  scope: "Design System Plus",
  de: "Antikpink",
  en: "Antique hot pink",
  nl: "Antiek roze",
  fr: "Rose antique"
}, {
  hex: "#ba84a6",
  code: "340 60 30",
  scope: "Design System Plus",
  de: "Wangenrot",
  en: "Cheek red",
  nl: "Wangen rood",
  fr: "Rouge joue"
}, {
  hex: "#c181a9",
  code: "340 60 35",
  scope: "Design System Plus",
  de: "Malvenblütenpink",
  en: "Hollyhock blossom pink",
  nl: "Wilgenbloesem roze",
  fr: "Rose fleur de mauve"
}, {
  hex: "#c87cad",
  code: "340 60 40",
  scope: "Design System Plus",
  de: "Bischofsrot",
  en: "Bishop red",
  nl: "Rood van de bisschop",
  fr: "Bischofsrot"
}, {
  hex: "#b6acb1",
  code: "340 70 05",
  scope: "Design System Plus",
  de: "Lilagrau",
  en: "Mauve grey",
  nl: "Paars grijs",
  fr: "Gris lilas"
}, {
  hex: "#bca8b3",
  code: "340 70 10",
  scope: "Design System Plus",
  de: "Buchweizenlila",
  en: "Buckwheat mauve",
  nl: "Boekweit paars",
  fr: "Violet sarrasin"
}, {
  hex: "#c5a6b8",
  code: "340 70 15",
  scope: "Design System Plus",
  de: "Malvenrosa",
  en: "Hollyhock pink",
  nl: "Mauve roze",
  fr: "Rose mauve"
}, {
  hex: "#cba3bb",
  code: "340 70 20",
  scope: "Design System Plus",
  de: "Idyllenrosa",
  en: "Idyllic pink",
  nl: "Idyllisch roze",
  fr: "Rose idyllique"
}, {
  hex: "#ce9fbb",
  code: "340 70 25",
  scope: "Design System Plus",
  de: "Windenblütenpink",
  en: "Morning glory pink",
  nl: "Lierbloesem roze",
  fr: "Rose fleur de liseron"
}, {
  hex: "#d69cc0",
  code: "340 70 30",
  scope: "Design System Plus",
  de: "Softfuchsia",
  en: "Soft fuschia",
  nl: "Zacht fuchsia",
  fr: "Softfuchsia"
}, {
  hex: "#dd99c4",
  code: "340 70 35",
  scope: "Design System Plus",
  de: "Prallpink",
  en: "Firm pink",
  nl: "Impact roze",
  fr: "Rose vif"
}, {
  hex: "#d1c7ca",
  code: "340 80 05",
  scope: "Design System Plus",
  de: "Pianograurosé",
  en: "Piano grey rose",
  nl: "Pianograurosé",
  fr: "Pianograurosé"
}, {
  hex: "#d9c4d0",
  code: "340 80 10",
  scope: "Design System Plus",
  de: "Minzblütenrosé",
  en: "Mint blossom rose",
  nl: "Rosé met muntbloesem",
  fr: "Rose fleur de menthe"
}, {
  hex: "#e0c0d2",
  code: "340 80 15",
  scope: "Design System Plus",
  de: "Skandalrosé",
  en: "Scandalous rose",
  nl: "Schandalige rosé",
  fr: "Rose scandale"
}, {
  hex: "#e7bdd4",
  code: "340 80 20",
  scope: "Design System Plus",
  de: "Bonbonrosa",
  en: "Bonbon rose",
  nl: "Snoeproze",
  fr: "Rose bonbon"
}, {
  hex: "#ddd2d8",
  code: "340 85 05",
  scope: "Design System Plus",
  de: "Erdbeercreme",
  en: "Strawberry cream",
  nl: "Aardbeiencrème",
  fr: "Crème à la fraise"
}, {
  hex: "#e5cfdb",
  code: "340 85 10",
  scope: "Design System Plus",
  de: "Hellflamingopink",
  en: "Light flamingo pink",
  nl: "Licht flamingo roze",
  fr: "Rose flamant clair"
}, {
  hex: "#eecddf",
  code: "340 85 15",
  scope: "Design System Plus",
  de: "Lacklila",
  en: "Lacquer mauve",
  nl: "Paars octrooi",
  fr: "Violet laqué"
}, {
  hex: "#ebe1e4",
  code: "340 90 05",
  scope: "Design System Plus",
  de: "Rosenweiß",
  en: "Rose white",
  nl: "Roze wit",
  fr: "Blanc de rose"
}, {
  hex: "#f1e8ed",
  code: "340 93 05",
  scope: "Design System Plus",
  de: "Kleiderrosa",
  en: "Dress pink",
  nl: "Jurk roze",
  fr: "Robe rose"
}, {
  hex: "#514449",
  code: "350 20 10",
  scope: "Design System Plus",
  de: "Glühweinrot",
  en: "Mulled wine red",
  nl: "Glühwein rood",
  fr: "Rouge vin chaud"
}, {
  hex: "#57444b",
  code: "350 20 15",
  scope: "Design System Plus",
  de: "Sanftrot",
  en: "Soft red",
  nl: "Zacht rood",
  fr: "Rouge doux"
}, {
  hex: "#5c414b",
  code: "350 20 20",
  scope: "Design System Plus",
  de: "Sternrubin",
  en: "Star ruby",
  nl: "Ster robijn",
  fr: "Rubis étoile"
}, {
  hex: "#5f404c",
  code: "350 20 25",
  scope: "Design System Plus",
  de: "Chilischwarzrot",
  en: "Chilli black red",
  nl: "Chili zwart rood",
  fr: "Rouge chili noir"
}, {
  hex: "#653d4e",
  code: "350 20 30",
  scope: "Design System Plus",
  de: "Tulpenbaumpurpur",
  en: "Tulip poplar purple",
  nl: "Tulpenboom paars",
  fr: "Pourpre de tulipier"
}, {
  hex: "#625158",
  code: "350 30 10",
  scope: "Design System Plus",
  de: "Sperlinggraurot",
  en: "Sparrow grey red",
  nl: "Sperling grijs-rood",
  fr: "Gris éperlan"
}, {
  hex: "#684f59",
  code: "350 30 15",
  scope: "Design System Plus",
  de: "Kieselrot",
  en: "Siliceous red",
  nl: "Kiezelrood",
  fr: "Rouge silex"
}, {
  hex: "#6f4e5b",
  code: "350 30 20",
  scope: "Design System Plus",
  de: "Likörrot",
  en: "Liqueur red",
  nl: "Likeur rood",
  fr: "Rouge liqueur"
}, {
  hex: "#744b5c",
  code: "350 30 25",
  scope: "Design System Plus",
  de: "Weingummirot",
  en: "Wine gummy red",
  nl: "Wijngom rood",
  fr: "Rouge gomme vin"
}, {
  hex: "#7a4a5e",
  code: "350 30 30",
  scope: "Design System Plus",
  de: "Burlatrot",
  en: "Burlat red",
  nl: "Jute rood",
  fr: "Rouge burlat"
}, {
  hex: "#7b465e",
  code: "350 30 35",
  scope: "Design System Plus",
  de: "Bordeauxrot",
  en: "Bordeaux red",
  nl: "Bordeaux rood",
  fr: "Rouge bordeaux"
}, {
  hex: "#804360",
  code: "350 30 40",
  scope: "Design System Plus",
  de: "Trockenblumenpurpur",
  en: "Dried flower purple",
  nl: "Gedroogde bloem paars",
  fr: "Pourpre de fleurs séchées"
}, {
  hex: "#77656c",
  code: "350 40 10",
  scope: "Design System Plus",
  de: "Auberginengrau",
  en: "Aubergine grey",
  nl: "Aubergine grijs",
  fr: "Gris aubergine"
}, {
  hex: "#7d626d",
  code: "350 40 15",
  scope: "Design System Plus",
  de: "Schlafmohnmauve",
  en: "Opium mauve",
  nl: "Opiumpapaver mauve",
  fr: "Mauve coquelicot"
}, {
  hex: "#835f6f",
  code: "350 40 20",
  scope: "Design System Plus",
  de: "Graukarmin",
  en: "Grey carmine",
  nl: "Grijs karmijn",
  fr: "Carmin gris"
}, {
  hex: "#875c6f",
  code: "350 40 25",
  scope: "Design System Plus",
  de: "Nektarrot",
  en: "Nectar red",
  nl: "Nectar rood",
  fr: "Rouge nectar"
}, {
  hex: "#8f5971",
  code: "350 40 30",
  scope: "Design System Plus",
  de: "Dunkelrosé",
  en: "Dark rose",
  nl: "Donkere roos",
  fr: "Rose foncé"
}, {
  hex: "#945573",
  code: "350 40 35",
  scope: "Design System Plus",
  de: "Bonbonrot",
  en: "Bonbon red",
  nl: "Snoeprood",
  fr: "Rouge bonbon"
}, {
  hex: "#985374",
  code: "350 40 40",
  scope: "Design System Plus",
  de: "Zyclamenrot",
  en: "Cyclamen red",
  nl: "Cyclamen rood",
  fr: "Rouge cyclamen"
}, {
  hex: "#9d5075",
  code: "350 40 45",
  scope: "Design System Plus",
  de: "Puderrot",
  en: "Powder red",
  nl: "Poederrood",
  fr: "Rouge poudré"
}, {
  hex: "#a24b76",
  code: "350 40 50",
  scope: "Design System Plus",
  de: "Krapprot",
  en: "Madder red",
  nl: "Madder rood",
  fr: "Rouge garance"
}, {
  hex: "#8d7981",
  code: "350 50 10",
  scope: "Design System Plus",
  de: "Unschuldsrosa",
  en: "Innocent pink",
  nl: "Onschuldig roze",
  fr: "Rose innocent"
}, {
  hex: "#937682",
  code: "350 50 15",
  scope: "Design System Plus",
  de: "Stumpfviolett",
  en: "Blunt violet",
  nl: "Saai paars",
  fr: "Violet terne"
}, {
  hex: "#9b7385",
  code: "350 50 20",
  scope: "Design System Plus",
  de: "Korundrot",
  en: "Corundum red",
  nl: "Korund rood",
  fr: "Rouge corindon"
}, {
  hex: "#a27086",
  code: "350 50 25",
  scope: "Design System Plus",
  de: "Batikpink",
  en: "Batik pink",
  nl: "Batik roze",
  fr: "Rose batik"
}, {
  hex: "#a76e88",
  code: "350 50 30",
  scope: "Design System Plus",
  de: "Beryllrot",
  en: "Beryl red",
  nl: "Beryllrood",
  fr: "Rouge béryl"
}, {
  hex: "#af6888",
  code: "350 50 35",
  scope: "Design System Plus",
  de: "Hochrot",
  en: "Crimson",
  nl: "Hoog rood",
  fr: "Rouge vif"
}, {
  hex: "#b56589",
  code: "350 50 40",
  scope: "Design System Plus",
  de: "Krapprosa",
  en: "Madder rose",
  nl: "Rozer roze",
  fr: "Rose crapaud"
}, {
  hex: "#b6618b",
  code: "350 50 45",
  scope: "Design System Plus",
  de: "Signalpink",
  en: "Signal pink",
  nl: "Signaal roze",
  fr: "Rose de signalisation"
}, {
  hex: "#c25e8b",
  code: "350 50 50",
  scope: "Design System Plus",
  de: "Nagellackpink",
  en: "Nail polish pink",
  nl: "Nagellak roze",
  fr: "Vernis à ongles rose"
}, {
  hex: "#a59099",
  code: "350 60 10",
  scope: "Design System Plus",
  de: "Jugendstilviolett",
  en: "Art Nouveau violet",
  nl: "Art Nouveau violet",
  fr: "Violet art nouveau"
}, {
  hex: "#ac8c9a",
  code: "350 60 15",
  scope: "Design System Plus",
  de: "Mohairrosa",
  en: "Mohair pink",
  nl: "Mohair roze",
  fr: "Rose mohair"
}, {
  hex: "#b58b9d",
  code: "350 60 20",
  scope: "Design System Plus",
  de: "Heideblumenviolett",
  en: "Heather violet",
  nl: "Heidebloem viooltje",
  fr: "Violet de bruyère"
}, {
  hex: "#bc869d",
  code: "350 60 25",
  scope: "Design System Plus",
  de: "Heidekrautrosé",
  en: "Heather rose",
  nl: "Heide rosé",
  fr: "Rose bruyère"
}, {
  hex: "#c4839f",
  code: "350 60 30",
  scope: "Design System Plus",
  de: "Venetianerrosa",
  en: "Venetian pink",
  nl: "Venetiaans roze",
  fr: "Rose vénitien"
}, {
  hex: "#c87fa0",
  code: "350 60 35",
  scope: "Design System Plus",
  de: "Dolomitrot",
  en: "Dolomite red",
  nl: "Dolomiet rood",
  fr: "Rouge dolomite"
}, {
  hex: "#d07ca1",
  code: "350 60 40",
  scope: "Design System Plus",
  de: "Kamelienrosa",
  en: "Camellia pink",
  nl: "Camelia roze",
  fr: "Rose camélia"
}, {
  hex: "#d378a4",
  code: "350 60 45",
  scope: "Design System Plus",
  de: "Persischrosa",
  en: "Persian pink",
  nl: "Perzisch roze",
  fr: "Rose persan"
}, {
  hex: "#bfaab1",
  code: "350 70 10",
  scope: "Design System Plus",
  de: "Kaltrosa",
  en: "Cold pink",
  nl: "Koud roze",
  fr: "Rose froid"
}, {
  hex: "#c7a5b3",
  code: "350 70 15",
  scope: "Design System Plus",
  de: "Schattenrosa",
  en: "Shady pink",
  nl: "Schaduwroze",
  fr: "Rose d'ombre"
}, {
  hex: "#cb9fb3",
  code: "350 70 20",
  scope: "Design System Plus",
  de: "Grasnelkenrosa",
  en: "Lady's cushions pink",
  nl: "Anjer roze",
  fr: "Rose girofle"
}, {
  hex: "#d69fb6",
  code: "350 70 25",
  scope: "Design System Plus",
  de: "Korallenrosa",
  en: "Coral pink",
  nl: "Koraalroze",
  fr: "Rose corail"
}, {
  hex: "#de9bb8",
  code: "350 70 30",
  scope: "Design System Plus",
  de: "Technorosa",
  en: "Techno pink",
  nl: "Technorosa",
  fr: "Technorosa"
}, {
  hex: "#e498b9",
  code: "350 70 35",
  scope: "Design System Plus",
  de: "Kaugummipink",
  en: "Chewing gum pink",
  nl: "Kauwgom roze",
  fr: "Rose chewing-gum"
}, {
  hex: "#d9c1ca",
  code: "350 80 10",
  scope: "Design System Plus",
  de: "Magnolienweiß",
  en: "Magnolia white",
  nl: "Magnolia wit",
  fr: "Blanc magnolia"
}, {
  hex: "#e0bfcb",
  code: "350 80 15",
  scope: "Design System Plus",
  de: "Frühlingsrosa",
  en: "Spring pink",
  nl: "Lente roze",
  fr: "Rose printanier"
}, {
  hex: "#e9bccf",
  code: "350 80 20",
  scope: "Design System Plus",
  de: "Hellpink",
  en: "Light pink",
  nl: "Lichtroze",
  fr: "Rose clair"
}, {
  hex: "#ddd2d7",
  code: "350 85 05",
  scope: "Design System Plus",
  de: "Elfenweiß",
  en: "Fairy white",
  nl: "Feeënwit",
  fr: "Blanc ivoire"
}, {
  hex: "#e7cfd9",
  code: "350 85 10",
  scope: "Design System Plus",
  de: "Orchideenrosé",
  en: "Orchid rose",
  nl: "Rosé orchidee",
  fr: "Rose orchidée"
}, {
  hex: "#eeccd9",
  code: "350 85 15",
  scope: "Design System Plus",
  de: "Blasspink",
  en: "Pale pink",
  nl: "Blasspink",
  fr: "Blasspink"
}, {
  hex: "#eee1e2",
  code: "350 90 05",
  scope: "Design System Plus",
  de: "Lichtrosé",
  en: "Light rose",
  nl: "Lichtroze",
  fr: "Rose lumineuse"
}, {
  hex: "#f4dbe5",
  code: "350 90 10",
  scope: "Design System Plus",
  de: "Windröschenweiß",
  en: "Ranuncula white",
  nl: "Anemoon wit",
  fr: "Blanc anémone"
}, {
  hex: "#f4e8ec",
  code: "350 93 05",
  scope: "Design System Plus",
  de: "Clichyweiß",
  en: "Clichy white",
  nl: "Clichywit",
  fr: "Clichy blanc"
}, {
  hex: "#574247",
  code: "360 20 15",
  scope: "Design System Plus",
  de: "Piermontsteinrot",
  en: "Piermont stone red",
  nl: "Piermont steenrood",
  fr: "Rouge pierre de Piermont"
}, {
  hex: "#5d5456",
  code: "360 30 05",
  scope: "Design System Plus",
  de: "Rußrot",
  en: "Soot red",
  nl: "Roet rood",
  fr: "Rouge suie"
}, {
  hex: "#635156",
  code: "360 30 10",
  scope: "Design System Plus",
  de: "Pfefferkornrot",
  en: "Peppercorn red",
  nl: "Peperkorrel rood",
  fr: "Rouge grain de poivre"
}, {
  hex: "#684e56",
  code: "360 30 15",
  scope: "Design System Plus",
  de: "Primitivoweinrot",
  en: "Zinfandel red",
  nl: "Primitieve wijn rood",
  fr: "Rouge vin primitif"
}, {
  hex: "#704d57",
  code: "360 30 20",
  scope: "Design System Plus",
  de: "Artdecorot",
  en: "Art deco red",
  nl: "Artdecorot",
  fr: "Artdecorot"
}, {
  hex: "#734956",
  code: "360 30 25",
  scope: "Design System Plus",
  de: "Klinkerrot",
  en: "Clinker red",
  nl: "Klinkerrood",
  fr: "Rouge brique"
}, {
  hex: "#784657",
  code: "360 30 30",
  scope: "Design System Plus",
  de: "Kirschsaftrot",
  en: "Cherry juice red",
  nl: "Kersensap rood",
  fr: "Rouge jus de cerise"
}, {
  hex: "#814456",
  code: "360 30 35",
  scope: "Design System Plus",
  de: "Schlossrot",
  en: "Palace red",
  nl: "Kasteel rood",
  fr: "Rouge château"
}, {
  hex: "#834257",
  code: "360 30 40",
  scope: "Design System Plus",
  de: "Glutrot",
  en: "Ember red",
  nl: "Ember rood",
  fr: "Rouge incandescent"
}, {
  hex: "#726769",
  code: "360 40 05",
  scope: "Design System Plus",
  de: "Röstschwarz",
  en: "Roasted black",
  nl: "Geroosterd zwart",
  fr: "Noir torréfié"
}, {
  hex: "#766369",
  code: "360 40 10",
  scope: "Design System Plus",
  de: "Mokkabraun",
  en: "Mocha brown",
  nl: "Mokka bruin",
  fr: "Marron moka"
}, {
  hex: "#7d6069",
  code: "360 40 15",
  scope: "Design System Plus",
  de: "Rubingrau",
  en: "Ruby grey",
  nl: "Robijngrijs",
  fr: "Gris rubis"
}, {
  hex: "#845d69",
  code: "360 40 20",
  scope: "Design System Plus",
  de: "Barockrot",
  en: "Baroque red",
  nl: "Barok rood",
  fr: "Rouge baroque"
}, {
  hex: "#8a5a68",
  code: "360 40 25",
  scope: "Design System Plus",
  de: "Rauschrot",
  en: "Frenzied red",
  nl: "Donkerrood",
  fr: "Rouge brumeux"
}, {
  hex: "#91576a",
  code: "360 40 30",
  scope: "Design System Plus",
  de: "Johannisbeerrot",
  en: "Redcurrant",
  nl: "Zwarte bessen rood",
  fr: "Rouge groseille"
}, {
  hex: "#97546b",
  code: "360 40 35",
  scope: "Design System Plus",
  de: "Orientpink",
  en: "Orient pink",
  nl: "Oosters roze",
  fr: "Rose oriental"
}, {
  hex: "#9e506c",
  code: "360 40 40",
  scope: "Design System Plus",
  de: "Auroramagenta",
  en: "Aurora magenta",
  nl: "Auroramagenta",
  fr: "Auroramagenta"
}, {
  hex: "#a24d6a",
  code: "360 40 45",
  scope: "Design System Plus",
  de: "Kardinalrot",
  en: "Cardinal red",
  nl: "Kardinaalrood",
  fr: "Rouge cardinal"
}, {
  hex: "#a94669",
  code: "360 40 50",
  scope: "Design System Plus",
  de: "Salonrot",
  en: "Parlour red",
  nl: "Salon rood",
  fr: "Rouge salon"
}, {
  hex: "#887c7e",
  code: "360 50 05",
  scope: "Design System Plus",
  de: "Bimssteingrau",
  en: "Pumice grey",
  nl: "Puimsteen grijs",
  fr: "Gris pierre ponce"
}, {
  hex: "#8d787e",
  code: "360 50 10",
  scope: "Design System Plus",
  de: "Tresterrot",
  en: "Pomace red",
  nl: "Pomace rood",
  fr: "Rouge marc"
}, {
  hex: "#95747e",
  code: "360 50 15",
  scope: "Design System Plus",
  de: "Abendpurpur",
  en: "Evening crimson",
  nl: "Avond paars",
  fr: "Pourpre du soir"
}, {
  hex: "#9b727f",
  code: "360 50 20",
  scope: "Design System Plus",
  de: "Kupferrosa",
  en: "Copper pink",
  nl: "Koperroze",
  fr: "Rose cuivré"
}, {
  hex: "#a46e7d",
  code: "360 50 25",
  scope: "Design System Plus",
  de: "Jugendstilrosa",
  en: "Art Nouveau pink",
  nl: "Art Nouveau roze",
  fr: "Rose art nouveau"
}, {
  hex: "#aa6b80",
  code: "360 50 30",
  scope: "Design System Plus",
  de: "Kosmetikrot",
  en: "Cosmetic red",
  nl: "Cosmetisch rood",
  fr: "Rouge cosmétique"
}, {
  hex: "#b26780",
  code: "360 50 35",
  scope: "Design System Plus",
  de: "Indischpink",
  en: "Indian pink",
  nl: "Indisch roze",
  fr: "Rose indien"
}, {
  hex: "#b96680",
  code: "360 50 40",
  scope: "Design System Plus",
  de: "Kirroyalrosé",
  en: "Kir royale rose",
  nl: "Kirroyal rosé",
  fr: "Rose cerise"
}, {
  hex: "#c06281",
  code: "360 50 45",
  scope: "Design System Plus",
  de: "Hahnenkammrot",
  en: "Cockscomb red",
  nl: "Hanenkam rood",
  fr: "Rouge crête de coq"
}, {
  hex: "#c45d80",
  code: "360 50 50",
  scope: "Design System Plus",
  de: "Persischrot",
  en: "Persian red",
  nl: "Perzisch rood",
  fr: "Rouge persan"
}, {
  hex: "#9f9497",
  code: "360 60 05",
  scope: "Design System Plus",
  de: "Aschrosa",
  en: "Ash pink",
  nl: "Asroze",
  fr: "Rose cendré"
}, {
  hex: "#a58f95",
  code: "360 60 10",
  scope: "Design System Plus",
  de: "Majolikamauve",
  en: "Majolica mauve",
  nl: "Majolica mauve",
  fr: "Majolikamauve"
}, {
  hex: "#ae8d96",
  code: "360 60 15",
  scope: "Design System Plus",
  de: "Feigenfruchtlila",
  en: "Fig fruit mauve",
  nl: "Vijgenvrucht paars",
  fr: "Mauve fruit de la figue"
}, {
  hex: "#b78a97",
  code: "360 60 20",
  scope: "Design System Plus",
  de: "Edelflieder",
  en: "Noble lilac",
  nl: "Edele sering",
  fr: "Lilas noble"
}, {
  hex: "#bd8597",
  code: "360 60 25",
  scope: "Design System Plus",
  de: "Hellrot",
  en: "Light red",
  nl: "Licht rood",
  fr: "Rouge clair"
}, {
  hex: "#b9adb0",
  code: "360 70 05",
  scope: "Design System Plus",
  de: "Teeblütenrosa",
  en: "Tea blossom pink",
  nl: "Theebloesem roze",
  fr: "Rose fleur de thé"
}, {
  hex: "#c0a7ae",
  code: "360 70 10",
  scope: "Design System Plus",
  de: "Quarzrosa",
  en: "Quartz pink",
  nl: "Kwartsroze",
  fr: "Rose quartz"
}, {
  hex: "#c9a5af",
  code: "360 70 15",
  scope: "Design System Plus",
  de: "Opalinrosa",
  en: "Opaline pink",
  nl: "Opaline roze",
  fr: "Rose opalin"
}, {
  hex: "#d3c7c9",
  code: "360 80 05",
  scope: "Design System Plus",
  de: "Perlmuttrosa",
  en: "Mother-of-pearl pink",
  nl: "Parelmoer roze",
  fr: "Rose nacré"
}, {
  hex: "#dbc2c8",
  code: "360 80 10",
  scope: "Design System Plus",
  de: "Venezianerrosa",
  en: "Venetian pink",
  nl: "Venetiaans roze",
  fr: "Rose vénitien"
}, {
  hex: "#e4bfc9",
  code: "360 80 15",
  scope: "Design System Plus",
  de: "Seifenrosa",
  en: "Soap pink",
  nl: "Zeep roze",
  fr: "Rose savonnette"
}, {
  hex: "#e0d2d4",
  code: "360 85 05",
  scope: "Design System Plus",
  de: "Theaterpuderrosé",
  en: "Theatre powder rose",
  nl: "Theaterpoeder rosé",
  fr: "Rose théâtral"
}, {
  hex: "#e8cfd5",
  code: "360 85 10",
  scope: "Design System Plus",
  de: "Lotusrosa",
  en: "Lotus pink",
  nl: "Lotus roze",
  fr: "Rose lotus"
}, {
  hex: "#f1e2e1",
  code: "360 90 05",
  scope: "Design System Plus",
  de: "Eisrosa",
  en: "Ice pink",
  nl: "IJsroze",
  fr: "Rose glacé"
}, {
  hex: "#f7dde3",
  code: "360 90 10",
  scope: "Design System Plus",
  de: "Tortencreme",
  en: "Cake frosting",
  nl: "Taartcrème",
  fr: "Crème à tarte"
}, {
  hex: "#f6e8e9",
  code: "360 93 05",
  scope: "Design System Plus",
  de: "Pfeilkrautweiß",
  en: "Arrowhead white",
  nl: "Pijlpunt wit",
  fr: "Arrowbow white"
}], UCt = NCt.concat(MCt, LCt, TCt), PCt = me.indexBy((e) => e.hex, UCt), zCt = ({
  variable: e,
  value: t,
  values: i,
  onChange: n,
  disabled: g = !1,
  touchedInvalidOptionsIds: r
}) => {
  const o = hi(e), I = _(ng), s = (u, A) => (!(u != null && u.label) || u.label.includes("[")) && (A[I] || $r(A.de || "")) || u.label, a = je(() => me.flow(
    me.map((u) => {
      const A = PCt[u.value];
      return {
        ...A,
        valueId: u.id,
        hasTouchedConflicts: (r == null ? void 0 : r.includes(u == null ? void 0 : u.id)) || !1,
        mainLabel: s(u, A)
      };
    }),
    // TODO: Neu erstellte Values haben null als value.value. Daher müssen
    // die undefined Einträge entfernt werden.
    me.compact
  )(i), [i, I, r]), d = ft((u) => {
    const A = i.find((m) => m.value === u);
    n(A.id);
  }, [i, n]), C = me.isNumber(o == null ? void 0 : o.borderRadius) ? o == null ? void 0 : o.borderRadius : 1;
  return /* @__PURE__ */ p(pr, { variable: e, view: /* @__PURE__ */ p(ECt, { disabled: g, ralColors: a, value: (t == null ? void 0 : t.value) || "", onChange: d, visibleColorCount: o == null ? void 0 : o.numberOfColorsShown, borderRadius: C }) });
}, OCt = me.flow(rI, no("ralColorSelect"))(zCt);
function QCt({
  handleClick: e,
  radioValue: t,
  variable: i,
  ...n
}) {
  return /* @__PURE__ */ p(aA, { invalid: n.invalid, children: /* @__PURE__ */ p(e1, { "data-cy": "radioButton", disabled: n.disabled, value: (t == null ? void 0 : t.id) || "", className: Ve("k3-radio-button", n.invalid && "invalid-option"), control: /* @__PURE__ */ p(Phe, { "data-cy": "radio", className: "k3-radio-button-control", onClick: e, sx: n.invalid ? _Ct : void 0 }), disableTypography: !0, sx: {
    color: n.isActiveValue ? "" : "action.active"
  }, label: /* @__PURE__ */ p(_t, { alignItems: "center", justifyContent: "space-between", children: /* @__PURE__ */ p(fc, { variable: i, variableValue: t, templateOptions: hi(i) }, t.id) }), color: "inherit" }, t.id) });
}
const jCt = (e) => {
  const t = (i) => {
    parseInt(i.target.value) === e.currentValueId && e.onChange && e.onChange(parseInt(i.target.value));
  };
  return /* @__PURE__ */ p(fs, { "data-cy": "RadioButtons", sx: {
    width: 1
  }, disabled: e.disabled, component: "fieldset", children: /* @__PURE__ */ p(jhe, { value: e.currentValueId || null, onChange: (i, n) => {
    var g;
    (g = e.onChange) == null || g.call(e, parseInt(n));
  }, sx: {
    gap: 1,
    py: 1
  }, children: e.values.map((i) => {
    var n;
    return /* @__PURE__ */ p(QCt, { radioValue: i, isActiveValue: i.id === e.currentValueId, disabled: e.disabled, handleClick: t, variable: e.variable, invalid: ((n = e.invalidIds) == null ? void 0 : n.includes(i == null ? void 0 : i.id)) || !1 }, i.id);
  }) }) });
}, _Ct = {
  opacity: ".2"
}, $Ct = ({
  value: e,
  ...t
}) => /* @__PURE__ */ p(pr, { variable: t.variable, view: /* @__PURE__ */ p(jCt, { currentValueId: (e == null ? void 0 : e.id) || 0, ...uf(t) }) }), _M = me.flow(rI, no("radio"))($Ct), qCt = ({
  value: e,
  values: t,
  ...i
}) => {
  const n = je(() => t.find((o) => o.key === QB), [t]), g = (o) => {
    o ? i.onChange(o) : n && i.onChange(n.id);
  }, r = t.filter((o) => o.key !== QB);
  return /* @__PURE__ */ p(pr, { variable: i.variable, view: /* @__PURE__ */ p(eq, { currentValueId: e == null ? void 0 : e.id, ...uf(i), values: r, onChange: g }) });
}, $M = me.flow(rI, no("radioCard"))(qCt);
function eut(e) {
  const t = {
    renderValue: (g) => {
      const r = e.values.find((o) => o.id == g);
      return r ? /* @__PURE__ */ p(yB, { dense: !0, "data-cy": "select_" + r.label, value: g, variable: e.variable, variableValue: r, templateOptions: {
        ...hi(e.variable),
        // Don't show Info Icon for current value since MUI overrides click anyway
        showInfo: !1
      } }) : null;
    }
  }, i = ce.merge({
    fullWidth: !0,
    variant: "outlined"
  }, e.FormControllProps ?? {}), n = (g) => {
    e.onChange && e.onChange(g.target.value);
  };
  return /* @__PURE__ */ p(fs, { ...i, children: /* @__PURE__ */ p(i1, { value: e.valueId || "", onChange: n, "data-cy": e["data-cy"], ...t, disabled: e.disabled, sx: {
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "action.active"
    }
  }, className: "k3-select", multiple: e.multiple, MenuProps: {
    MenuListProps: {
      sx: {
        maxHeight: "35vh"
      }
    }
  }, children: e.values.map((g) => {
    var r;
    return /* @__PURE__ */ p(yB, { "data-cy": "selection_" + g.label, value: g.id, variable: e.variable, variableValue: g, templateOptions: hi(e.variable), itemInvalid: ((r = e.invalidIds) == null ? void 0 : r.includes(g == null ? void 0 : g.id)) || !1 }, g.id);
  }) }) });
}
const tut = ({
  value: e,
  ...t
}) => /* @__PURE__ */ p(pr, { variable: t.variable, view: /* @__PURE__ */ p(eut, { "data-cy": "selectOc", valueId: e == null ? void 0 : e.id, ...uf(t) }) }), qM = me.flow(rI, no("select"))(tut);
function iut(e) {
  const t = e.checked, i = (n) => {
    e.onChange && e.onChange(n.target.checked);
  };
  return /* @__PURE__ */ p(fs, { fullWidth: !0, className: Ve("k3-app-switch", t ? "checked" : "unchecked"), children: /* @__PURE__ */ p(aA, { invalid: e.hasInvalidOption, children: /* @__PURE__ */ p(e1, { sx: {
    m: 0
  }, label: /* @__PURE__ */ p(fc, { variable: e.variable, variableValue: e.value, templateOptions: hi(e.variable) }), control: /* @__PURE__ */ p(QO, { "data-cy": e["data-cy"] || "switch", checked: t || !1, onChange: i, disabled: e.disabled }) }) }) });
}
const nut = ({
  variable: e,
  value: t,
  values: i,
  onChange: n,
  disabled: g,
  touchedInvalidOptionsIds: r
}) => {
  const {
    checked: o,
    onBooleanChange: I
  } = Cf(n, t, i), s = i == null ? void 0 : i.find((d) => d.value == !0), a = i == null ? void 0 : i.find((d) => d.id != (t == null ? void 0 : t.id));
  return /* @__PURE__ */ p(pr, { variable: e, className: Ve("k3-app-switch-wrapper", o ? "checked" : "unchecked"), view: /* @__PURE__ */ p(iut, { "data-cy": `switch-${e == null ? void 0 : e.id}`, value: s, checked: o, onChange: I, variable: e, disabled: g, hasInvalidOption: (a == null ? void 0 : a.id) && (r == null ? void 0 : r.includes(a == null ? void 0 : a.id)) || !1 }) });
}, gut = me.flow(rI, no("switch"))(nut);
function rut({
  variable: e,
  value: t,
  checked: i,
  onChange: n,
  disabled: g
}) {
  const {
    palette: r
  } = qo(), {
    showDescription: o,
    showInfo: I,
    showPrice: s,
    showThumbnail: a,
    showUrl: d,
    showValue: C,
    showSelection: u
  } = hi(e) || {}, A = o || a || d || C || u;
  return /* @__PURE__ */ ge(l1, { "data-cy": "toggle", disabled: g, fullWidth: !0, value: t == null ? void 0 : t.id, selected: i, className: Ve("k3-app-switch-card", i ? "checked" : "unchecked"), onChange: () => n(!i), sx: {
    "&.MuiToggleButton-root": {
      background: "unset"
    },
    "&.MuiToggleButton-root:hover": {
      background: "unset",
      borderColor: `${r.action.active} !important`
    },
    "&.MuiToggleButton-root:active": {
      background: "unset"
    },
    "&.MuiToggleButton-root.Mui-selected": {
      background: "unset",
      outline: "2px solid",
      outlineOffset: "-2px",
      outlineColor: `${r.primary.main} !important`
    },
    border: `1px solid ${r.action.disabled} !important`,
    borderRadius: "8px  !important",
    justifyContent: "flex-start",
    padding: 2,
    textAlign: "left"
  }, children: [
    /* @__PURE__ */ p(fc, { value: t == null ? void 0 : t.id, variable: e, variableValue: t, templateOptions: hi(e) }, t == null ? void 0 : t.id),
    /* @__PURE__ */ p(qm, { sx: {
      marginTop: A ? -1.25 : 0,
      marginRight: -1.25,
      alignSelf: A ? "start" : "center",
      "&.MuiCheckbox-root": {
        color: i ? "" : "action.disabled"
      }
    }, size: "medium", checked: i, className: "k3-value-checkbox", "data-cy": "" })
  ] }, t == null ? void 0 : t.id);
}
const out = ({
  variable: e,
  value: t,
  values: i,
  onChange: n,
  disabled: g
}) => {
  const {
    checked: r,
    onBooleanChange: o
  } = Cf(n, t, i), I = i == null ? void 0 : i.find((s) => s.value == !0);
  return /* @__PURE__ */ p(pr, { variable: e, className: Ve("k3-app-switch-card-container", r ? "checked" : "unchecked"), "data-cy": `switch-card-${e == null ? void 0 : e.id}`, view: /* @__PURE__ */ p(rut, { value: I, checked: r, onChange: o, variable: e, disabled: g }) });
}, Iut = me.flow(rI, no("switchCard"))(out), lut = function(e) {
  const {
    variable: t
  } = e, {
    text: i,
    onChange: n
  } = pf(e);
  return /* @__PURE__ */ p(pr, { variable: t, className: "k3-app-text", view: /* @__PURE__ */ p($n, { value: i ?? "", multiline: !0, debounced: !0, onChange: n, "data-cy": `text-${t == null ? void 0 : t.label}` }) });
}, sut = z$(lut), aut = (e) => {
  const {
    variable: t
  } = e, {
    text: i,
    onChange: n
  } = pf(e);
  return /* @__PURE__ */ p(pr, { variable: t, view: /* @__PURE__ */ p($n, { "data-cy": `textArea-${t == null ? void 0 : t.label}`, fullWidth: !0, multiline: !0, minRows: 2, maxRows: 8, value: i, onChange: n }) });
}, cut = no("textArea")(aut), Hq = {
  [Jn.Checkbox]: sct,
  //TODO: not used
  [Jn.Hidden]: dCt,
  //TODO: not used
  [Jn.Information]: GCt,
  //TODO: not used
  [Jn.Radio]: _M,
  [Jn.RadioCard]: $M,
  [Jn.Select]: qM,
  [Jn.SelectThumbs]: wM,
  [Jn.Text]: sut,
  [Jn.Textarea]: cut,
  //TODO: not used
  [Jn.Number]: wCt,
  [Jn.Switch]: gut,
  [Jn.SwitchCard]: Iut,
  [Jn.ColorSelect]: wM,
  [Jn.ColorDropdown]: qM,
  [Jn.ColorRadio]: _M,
  [Jn.ColorRadioCard]: $M,
  [Jn.RALColorSelect]: OCt,
  [Jn.ImageUpload]: ZCt,
  [Jn.ComponentList]: Cct,
  [Jn.ComponentListPopup]: Act,
  [Jn.ComponentValueCards]: aCt
}, Bf = (e, t = Dt) => {
  const i = _((r) => T$e(r, hi(e), t)), n = _((r) => M$e(r, e.id, t)), g = _(oh);
  return je(() => {
    var A, m;
    if (!(e != null && e.id))
      return console.error("Can't get component props for undefined variable"), {};
    const {
      ruleEngineState: r,
      ruleEngineInput: o
    } = g, I = r == null ? void 0 : r.state.all.selections.find((h) => h.variableId === e.id && h.instance.id === t.id), s = ((A = r == null ? void 0 : r.state.all.validOptions[t.id]) == null ? void 0 : A[e.id]) || [], a = ((m = r == null ? void 0 : r.state.all.invalidOptions[t.id]) == null ? void 0 : m[e.id]) || [], d = o == null ? void 0 : o.hiddenValuesMap[t.id], C = ((o == null ? void 0 : o.values.byVarId.all[e.id]) || []).filter((h) => !(d != null && d[h.id])).filter(i).sort(Ku), u = C.find((h) => h.id === (I == null ? void 0 : I.valueId));
    return {
      selection: I,
      contextInstance: t,
      validOptions: s,
      invalidOptions: a,
      touchedInvalidOptionsIds: n,
      value: u,
      variable: e,
      values: C
    };
  }, [g, e, i, t, n]);
}, h2 = (e) => {
  const t = zt();
  return ft((i) => (n, g) => t(lK(n, i.id, g, e)), [e, t]);
}, eU = {
  m: 2,
  mb: 0
}, kq = ({
  variable: e,
  onChange: t,
  withPaperWrapper: i,
  "data-cy": n,
  className: g,
  dense: r,
  contextInstance: o
}) => {
  var m, h;
  const I = _(hr), s = _(B1(e, o.id)), a = zt(), d = ft(() => {
    a(qJ({
      type: "variable",
      id: e.id
    }));
  }, [a, e == null ? void 0 : e.id]), C = Ct(null);
  et(() => {
    var f, G;
    let B;
    if ((G = (f = e == null ? void 0 : e.settings) == null ? void 0 : f.templateOptions) != null && G.focusOnScroll) {
      const y = C.current;
      y && (B = new IntersectionObserver((W) => {
        W[0].isIntersecting && d();
      }, {
        threshold: [0.5]
      }), B.observe(y));
    }
    return () => {
      B && B.disconnect();
    };
  }, [d, C, (h = (m = e == null ? void 0 : e.settings) == null ? void 0 : m.templateOptions) == null ? void 0 : h.focusOnScroll]);
  const u = Bf(e, o), A = je(() => z$(Hq[ju(e)]), [e]);
  return !I && s ? null : i ? /* @__PURE__ */ p(So, { ref: C, onFocus: d, id: "variableContainer_" + e.id, "data-cy": "variableContainer_" + n, className: Ve("k3-variable-container", "k3-variable-container-" + n, e.key ?? void 0, !!r && "dense", I ? "edit-view" : "display-view", g), elevation: 0, sx: r ? null : eU, children: /* @__PURE__ */ p(AV, { children: /* @__PURE__ */ p(A, { onChange: t(e), ...u }, e.id) }) }, `${e.id}_${o.id}`) : /* @__PURE__ */ p(fe, { "data-cy": "variableContainer_" + n, className: Ve("k3-variable-container", "k3-variable-container-" + n, e.key ?? void 0, !!r && "dense", g), component: "div", sx: r ? null : eU, children: /* @__PURE__ */ p(AV, { children: /* @__PURE__ */ p(A, { onChange: t(e), ...u }, e.id) }) }, `${e.id}_${o.id}`);
}, dut = (e) => {
  const t = h2(), i = _(YZ(e.variableKey)), n = Li(), g = _((o) => M1(o, n)), r = _(hJ((i == null ? void 0 : i.id) ?? 0));
  return i ? !e.sticky && i.groupId !== (g == null ? void 0 : g.id) ? null : /* @__PURE__ */ p(kq, { variable: i, contextInstance: r, onChange: t, withPaperWrapper: e.withPaperWrapper, className: Ve("k3-stand-alone-variable", !!e.sticky && "sticky"), "data-cy": `standaloneVariable-${i.label ?? (i == null ? void 0 : i.key)}`, dense: e.dense }) : (console.error(`No variable with key ${e.variableKey} found`, e), null);
};
function tU(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function iU(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tU(Object(i), !0).forEach(function(n) {
      Gs(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : tU(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Eo(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var nU = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), bF = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, gU = {
  INIT: "@@redux/INIT" + bF(),
  REPLACE: "@@redux/REPLACE" + bF(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + bF();
  }
};
function Cut(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Fq(e, t, i) {
  var n;
  if (typeof t == "function" && typeof i == "function" || typeof i == "function" && typeof arguments[3] == "function")
    throw new Error(Eo(0));
  if (typeof t == "function" && typeof i > "u" && (i = t, t = void 0), typeof i < "u") {
    if (typeof i != "function")
      throw new Error(Eo(1));
    return i(Fq)(e, t);
  }
  if (typeof e != "function")
    throw new Error(Eo(2));
  var g = e, r = t, o = [], I = o, s = !1;
  function a() {
    I === o && (I = o.slice());
  }
  function d() {
    if (s)
      throw new Error(Eo(3));
    return r;
  }
  function C(h) {
    if (typeof h != "function")
      throw new Error(Eo(4));
    if (s)
      throw new Error(Eo(5));
    var B = !0;
    return a(), I.push(h), function() {
      if (B) {
        if (s)
          throw new Error(Eo(6));
        B = !1, a();
        var G = I.indexOf(h);
        I.splice(G, 1), o = null;
      }
    };
  }
  function u(h) {
    if (!Cut(h))
      throw new Error(Eo(7));
    if (typeof h.type > "u")
      throw new Error(Eo(8));
    if (s)
      throw new Error(Eo(9));
    try {
      s = !0, r = g(r, h);
    } finally {
      s = !1;
    }
    for (var B = o = I, f = 0; f < B.length; f++) {
      var G = B[f];
      G();
    }
    return h;
  }
  function A(h) {
    if (typeof h != "function")
      throw new Error(Eo(10));
    g = h, u({
      type: gU.REPLACE
    });
  }
  function m() {
    var h, B = C;
    return h = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(G) {
        if (typeof G != "object" || G === null)
          throw new Error(Eo(11));
        function y() {
          G.next && G.next(d());
        }
        y();
        var W = B(y);
        return {
          unsubscribe: W
        };
      }
    }, h[nU] = function() {
      return this;
    }, h;
  }
  return u({
    type: gU.INIT
  }), n = {
    dispatch: u,
    subscribe: C,
    getState: d,
    replaceReducer: A
  }, n[nU] = m, n;
}
function rU(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function oU(e, t) {
  if (typeof e == "function")
    return rU(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(Eo(16));
  var i = {};
  for (var n in e) {
    var g = e[n];
    typeof g == "function" && (i[n] = rU(g, t));
  }
  return i;
}
function Yq() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, g) {
    return function() {
      return n(g.apply(void 0, arguments));
    };
  });
}
function uut() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return function(n) {
    return function() {
      var g = n.apply(void 0, arguments), r = function() {
        throw new Error(Eo(15));
      }, o = {
        getState: g.getState,
        dispatch: function() {
          return r.apply(void 0, arguments);
        }
      }, I = t.map(function(s) {
        return s(o);
      });
      return r = Yq.apply(void 0, I)(g.dispatch), iU(iU({}, g), {}, {
        dispatch: r
      });
    };
  };
}
var xq = /* @__PURE__ */ Se.createContext(null);
function Aut(e) {
  e();
}
var Dq = Aut, but = function(t) {
  return Dq = t;
}, mut = function() {
  return Dq;
};
function hut() {
  var e = mut(), t = null, i = null;
  return {
    clear: function() {
      t = null, i = null;
    },
    notify: function() {
      e(function() {
        for (var g = t; g; )
          g.callback(), g = g.next;
      });
    },
    get: function() {
      for (var g = [], r = t; r; )
        g.push(r), r = r.next;
      return g;
    },
    subscribe: function(g) {
      var r = !0, o = i = {
        callback: g,
        next: null,
        prev: i
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !r || t === null || (r = !1, o.next ? o.next.prev = o.prev : i = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
var IU = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function Jq(e, t) {
  var i, n = IU;
  function g(C) {
    return s(), n.subscribe(C);
  }
  function r() {
    n.notify();
  }
  function o() {
    d.onStateChange && d.onStateChange();
  }
  function I() {
    return !!i;
  }
  function s() {
    i || (i = t ? t.addNestedSub(o) : e.subscribe(o), n = hut());
  }
  function a() {
    i && (i(), i = void 0, n.clear(), n = IU);
  }
  var d = {
    addNestedSub: g,
    notifyNestedSubs: r,
    handleChangeWrapper: o,
    isSubscribed: I,
    trySubscribe: s,
    tryUnsubscribe: a,
    getListeners: function() {
      return n;
    }
  };
  return d;
}
var Kq = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Um : et;
function put(e) {
  var t = e.store, i = e.context, n = e.children, g = je(function() {
    var I = Jq(t);
    return {
      store: t,
      subscription: I
    };
  }, [t]), r = je(function() {
    return t.getState();
  }, [t]);
  Kq(function() {
    var I = g.subscription;
    return I.onStateChange = I.notifyNestedSubs, I.trySubscribe(), r !== t.getState() && I.notifyNestedSubs(), function() {
      I.tryUnsubscribe(), I.onStateChange = null;
    };
  }, [g, r]);
  var o = i || xq;
  return /* @__PURE__ */ Se.createElement(o.Provider, {
    value: g
  }, n);
}
var Eq = { exports: {} }, Yn = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p2 = 60103, B2 = 60106, Zf = 60107, ff = 60108, Gf = 60114, yf = 60109, Wf = 60110, Sf = 60112, Vf = 60113, YK = 60120, wf = 60115, vf = 60116, Nq = 60121, Lq = 60122, Tq = 60117, Mq = 60129, Uq = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var Rr = Symbol.for;
  p2 = Rr("react.element"), B2 = Rr("react.portal"), Zf = Rr("react.fragment"), ff = Rr("react.strict_mode"), Gf = Rr("react.profiler"), yf = Rr("react.provider"), Wf = Rr("react.context"), Sf = Rr("react.forward_ref"), Vf = Rr("react.suspense"), YK = Rr("react.suspense_list"), wf = Rr("react.memo"), vf = Rr("react.lazy"), Nq = Rr("react.block"), Lq = Rr("react.server.block"), Tq = Rr("react.fundamental"), Mq = Rr("react.debug_trace_mode"), Uq = Rr("react.legacy_hidden");
}
function vs(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case p2:
        switch (e = e.type, e) {
          case Zf:
          case Gf:
          case ff:
          case Vf:
          case YK:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Wf:
              case Sf:
              case vf:
              case wf:
              case yf:
                return e;
              default:
                return t;
            }
        }
      case B2:
        return t;
    }
  }
}
var But = yf, Zut = p2, fut = Sf, Gut = Zf, yut = vf, Wut = wf, Sut = B2, Vut = Gf, wut = ff, vut = Vf;
Yn.ContextConsumer = Wf;
Yn.ContextProvider = But;
Yn.Element = Zut;
Yn.ForwardRef = fut;
Yn.Fragment = Gut;
Yn.Lazy = yut;
Yn.Memo = Wut;
Yn.Portal = Sut;
Yn.Profiler = Vut;
Yn.StrictMode = wut;
Yn.Suspense = vut;
Yn.isAsyncMode = function() {
  return !1;
};
Yn.isConcurrentMode = function() {
  return !1;
};
Yn.isContextConsumer = function(e) {
  return vs(e) === Wf;
};
Yn.isContextProvider = function(e) {
  return vs(e) === yf;
};
Yn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === p2;
};
Yn.isForwardRef = function(e) {
  return vs(e) === Sf;
};
Yn.isFragment = function(e) {
  return vs(e) === Zf;
};
Yn.isLazy = function(e) {
  return vs(e) === vf;
};
Yn.isMemo = function(e) {
  return vs(e) === wf;
};
Yn.isPortal = function(e) {
  return vs(e) === B2;
};
Yn.isProfiler = function(e) {
  return vs(e) === Gf;
};
Yn.isStrictMode = function(e) {
  return vs(e) === ff;
};
Yn.isSuspense = function(e) {
  return vs(e) === Vf;
};
Yn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Zf || e === Gf || e === Mq || e === ff || e === Vf || e === YK || e === Uq || typeof e == "object" && e !== null && (e.$$typeof === vf || e.$$typeof === wf || e.$$typeof === yf || e.$$typeof === Wf || e.$$typeof === Sf || e.$$typeof === Tq || e.$$typeof === Nq || e[0] === Lq);
};
Yn.typeOf = vs;
Eq.exports = Yn;
var Rut = Eq.exports, Xut = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], Hut = ["reactReduxForwardedRef"], kut = [], Fut = [null, null];
function Yut(e, t) {
  var i = e[1];
  return [t.payload, i + 1];
}
function lU(e, t, i) {
  Kq(function() {
    return e.apply(void 0, t);
  }, i);
}
function xut(e, t, i, n, g, r, o) {
  e.current = n, t.current = g, i.current = !1, r.current && (r.current = null, o());
}
function Dut(e, t, i, n, g, r, o, I, s, a) {
  if (e) {
    var d = !1, C = null, u = function() {
      if (!d) {
        var h = t.getState(), B, f;
        try {
          B = n(h, g.current);
        } catch (G) {
          f = G, C = G;
        }
        f || (C = null), B === r.current ? o.current || s() : (r.current = B, I.current = B, o.current = !0, a({
          type: "STORE_UPDATED",
          payload: {
            error: f
          }
        }));
      }
    };
    i.onStateChange = u, i.trySubscribe(), u();
    var A = function() {
      if (d = !0, i.tryUnsubscribe(), i.onStateChange = null, C)
        throw C;
    };
    return A;
  }
}
var Jut = function() {
  return [null, 0];
};
function Kut(e, t) {
  t === void 0 && (t = {});
  var i = t, n = i.getDisplayName, g = n === void 0 ? function(y) {
    return "ConnectAdvanced(" + y + ")";
  } : n, r = i.methodName, o = r === void 0 ? "connectAdvanced" : r, I = i.renderCountProp, s = I === void 0 ? void 0 : I, a = i.shouldHandleStateChanges, d = a === void 0 ? !0 : a, C = i.storeKey, u = C === void 0 ? "store" : C;
  i.withRef;
  var A = i.forwardRef, m = A === void 0 ? !1 : A, h = i.context, B = h === void 0 ? xq : h, f = Ue(i, Xut), G = B;
  return function(W) {
    var V = W.displayName || W.name || "Component", w = g(V), v = k({}, f, {
      getDisplayName: g,
      methodName: o,
      renderCountProp: s,
      shouldHandleStateChanges: d,
      storeKey: u,
      displayName: w,
      wrappedComponentName: V,
      WrappedComponent: W
    }), H = f.pure;
    function x(E) {
      return e(E.dispatch, v);
    }
    var N = H ? je : function(E) {
      return E();
    };
    function M(E) {
      var L = je(function() {
        var J = E.reactReduxForwardedRef, Ce = Ue(E, Hut);
        return [E.context, J, Ce];
      }, [E]), P = L[0], Q = L[1], te = L[2], le = je(function() {
        return P && P.Consumer && Rut.isContextConsumer(/* @__PURE__ */ Se.createElement(P.Consumer, null)) ? P : G;
      }, [P, G]), Ae = Hn(le), we = !!E.store && !!E.store.getState && !!E.store.dispatch;
      Ae && Ae.store;
      var Ee = we ? E.store : Ae.store, Je = je(function() {
        return x(Ee);
      }, [Ee]), ve = je(function() {
        if (!d)
          return Fut;
        var J = Jq(Ee, we ? null : Ae.subscription), Ce = J.notifyNestedSubs.bind(J);
        return [J, Ce];
      }, [Ee, we, Ae]), Be = ve[0], ue = ve[1], Xe = je(function() {
        return we ? Ae : k({}, Ae, {
          subscription: Be
        });
      }, [we, Ae, Be]), Ze = BZ(Yut, kut, Jut), Ke = Ze[0], $e = Ke[0], rt = Ze[1];
      if ($e && $e.error)
        throw $e.error;
      var dt = Ct(), ot = Ct(te), ze = Ct(), tt = Ct(!1), st = N(function() {
        return ze.current && te === ot.current ? ze.current : Je(Ee.getState(), te);
      }, [Ee, $e, te]);
      lU(xut, [ot, dt, tt, te, st, ze, ue]), lU(Dut, [d, Ee, Be, Je, ot, dt, tt, ze, ue, rt], [Ee, Be, Je]);
      var Kt = je(function() {
        return /* @__PURE__ */ Se.createElement(W, k({}, st, {
          ref: Q
        }));
      }, [Q, W, st]), ie = je(function() {
        return d ? /* @__PURE__ */ Se.createElement(le.Provider, {
          value: Xe
        }, Kt) : Kt;
      }, [le, Kt, Xe]);
      return ie;
    }
    var $ = H ? Se.memo(M) : M;
    if ($.WrappedComponent = W, $.displayName = M.displayName = w, m) {
      var q = Se.forwardRef(function(L, P) {
        return /* @__PURE__ */ Se.createElement($, k({}, L, {
          reactReduxForwardedRef: P
        }));
      });
      return q.displayName = w, q.WrappedComponent = W, W9(q, W);
    }
    return W9($, W);
  };
}
function sU(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function mF(e, t) {
  if (sU(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var i = Object.keys(e), n = Object.keys(t);
  if (i.length !== n.length)
    return !1;
  for (var g = 0; g < i.length; g++)
    if (!Object.prototype.hasOwnProperty.call(t, i[g]) || !sU(e[i[g]], t[i[g]]))
      return !1;
  return !0;
}
function Eut(e, t) {
  var i = {}, n = function(o) {
    var I = e[o];
    typeof I == "function" && (i[o] = function() {
      return t(I.apply(void 0, arguments));
    });
  };
  for (var g in e)
    n(g);
  return i;
}
function xK(e) {
  return function(i, n) {
    var g = e(i, n);
    function r() {
      return g;
    }
    return r.dependsOnOwnProps = !1, r;
  };
}
function aU(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function Pq(e, t) {
  return function(n, g) {
    g.displayName;
    var r = function(I, s) {
      return r.dependsOnOwnProps ? r.mapToProps(I, s) : r.mapToProps(I);
    };
    return r.dependsOnOwnProps = !0, r.mapToProps = function(I, s) {
      r.mapToProps = e, r.dependsOnOwnProps = aU(e);
      var a = r(I, s);
      return typeof a == "function" && (r.mapToProps = a, r.dependsOnOwnProps = aU(a), a = r(I, s)), a;
    }, r;
  };
}
function Nut(e) {
  return typeof e == "function" ? Pq(e) : void 0;
}
function Lut(e) {
  return e ? void 0 : xK(function(t) {
    return {
      dispatch: t
    };
  });
}
function Tut(e) {
  return e && typeof e == "object" ? xK(function(t) {
    return Eut(e, t);
  }) : void 0;
}
const Mut = [Nut, Lut, Tut];
function Uut(e) {
  return typeof e == "function" ? Pq(e) : void 0;
}
function Put(e) {
  return e ? void 0 : xK(function() {
    return {};
  });
}
const zut = [Uut, Put];
function Out(e, t, i) {
  return k({}, i, e, t);
}
function Qut(e) {
  return function(i, n) {
    n.displayName;
    var g = n.pure, r = n.areMergedPropsEqual, o = !1, I;
    return function(a, d, C) {
      var u = e(a, d, C);
      return o ? (!g || !r(u, I)) && (I = u) : (o = !0, I = u), I;
    };
  };
}
function jut(e) {
  return typeof e == "function" ? Qut(e) : void 0;
}
function _ut(e) {
  return e ? void 0 : function() {
    return Out;
  };
}
const $ut = [jut, _ut];
var qut = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function eAt(e, t, i, n) {
  return function(r, o) {
    return i(e(r, o), t(n, o), o);
  };
}
function tAt(e, t, i, n, g) {
  var r = g.areStatesEqual, o = g.areOwnPropsEqual, I = g.areStatePropsEqual, s = !1, a, d, C, u, A;
  function m(y, W) {
    return a = y, d = W, C = e(a, d), u = t(n, d), A = i(C, u, d), s = !0, A;
  }
  function h() {
    return C = e(a, d), t.dependsOnOwnProps && (u = t(n, d)), A = i(C, u, d), A;
  }
  function B() {
    return e.dependsOnOwnProps && (C = e(a, d)), t.dependsOnOwnProps && (u = t(n, d)), A = i(C, u, d), A;
  }
  function f() {
    var y = e(a, d), W = !I(y, C);
    return C = y, W && (A = i(C, u, d)), A;
  }
  function G(y, W) {
    var V = !o(W, d), w = !r(y, a, W, d);
    return a = y, d = W, V && w ? h() : V ? B() : w ? f() : A;
  }
  return function(W, V) {
    return s ? G(W, V) : m(W, V);
  };
}
function iAt(e, t) {
  var i = t.initMapStateToProps, n = t.initMapDispatchToProps, g = t.initMergeProps, r = Ue(t, qut), o = i(e, r), I = n(e, r), s = g(e, r), a = r.pure ? tAt : eAt;
  return a(o, I, s, e, r);
}
var nAt = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function hF(e, t, i) {
  for (var n = t.length - 1; n >= 0; n--) {
    var g = t[n](e);
    if (g)
      return g;
  }
  return function(r, o) {
    throw new Error("Invalid value of type " + typeof e + " for " + i + " argument when connecting component " + o.wrappedComponentName + ".");
  };
}
function gAt(e, t) {
  return e === t;
}
function rAt(e) {
  var t = {}, i = t.connectHOC, n = i === void 0 ? Kut : i, g = t.mapStateToPropsFactories, r = g === void 0 ? zut : g, o = t.mapDispatchToPropsFactories, I = o === void 0 ? Mut : o, s = t.mergePropsFactories, a = s === void 0 ? $ut : s, d = t.selectorFactory, C = d === void 0 ? iAt : d;
  return function(A, m, h, B) {
    B === void 0 && (B = {});
    var f = B, G = f.pure, y = G === void 0 ? !0 : G, W = f.areStatesEqual, V = W === void 0 ? gAt : W, w = f.areOwnPropsEqual, v = w === void 0 ? mF : w, H = f.areStatePropsEqual, x = H === void 0 ? mF : H, N = f.areMergedPropsEqual, M = N === void 0 ? mF : N, $ = Ue(f, nAt), q = hF(A, r, "mapStateToProps"), E = hF(m, I, "mapDispatchToProps"), L = hF(h, a, "mergeProps");
    return n(C, k({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(Q) {
        return "Connect(" + Q + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!A,
      // passed through to selectorFactory
      initMapStateToProps: q,
      initMapDispatchToProps: E,
      initMergeProps: L,
      pure: y,
      areStatesEqual: V,
      areOwnPropsEqual: v,
      areStatePropsEqual: x,
      areMergedPropsEqual: M
    }, $));
  };
}
const zq = /* @__PURE__ */ rAt();
but(em);
function oAt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function Oq(e, t) {
  var i = At(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = Ct(!0), g = Ct(i), r = n.current || !!(t && g.current.inputs && oAt(t, g.current.inputs)), o = r ? g.current : {
    inputs: t,
    result: e()
  };
  return et(function() {
    n.current = !1, g.current = o;
  }, [o]), o.result;
}
function IAt(e, t) {
  return Oq(function() {
    return e;
  }, t);
}
var Ei = Oq, $t = IAt, lAt = "Invariant failed";
function sAt(e, t) {
  throw new Error(lAt);
}
var cs = function(t) {
  var i = t.top, n = t.right, g = t.bottom, r = t.left, o = n - r, I = g - i, s = {
    top: i,
    right: n,
    bottom: g,
    left: r,
    width: o,
    height: I,
    x: r,
    y: i,
    center: {
      x: (n + r) / 2,
      y: (g + i) / 2
    }
  };
  return s;
}, DK = function(t, i) {
  return {
    top: t.top - i.top,
    left: t.left - i.left,
    bottom: t.bottom + i.bottom,
    right: t.right + i.right
  };
}, cU = function(t, i) {
  return {
    top: t.top + i.top,
    left: t.left + i.left,
    bottom: t.bottom - i.bottom,
    right: t.right - i.right
  };
}, aAt = function(t, i) {
  return {
    top: t.top + i.y,
    left: t.left + i.x,
    bottom: t.bottom + i.y,
    right: t.right + i.x
  };
}, pF = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, JK = function(t) {
  var i = t.borderBox, n = t.margin, g = n === void 0 ? pF : n, r = t.border, o = r === void 0 ? pF : r, I = t.padding, s = I === void 0 ? pF : I, a = cs(DK(i, g)), d = cs(cU(i, o)), C = cs(cU(d, s));
  return {
    marginBox: a,
    borderBox: cs(i),
    paddingBox: d,
    contentBox: C,
    margin: g,
    border: o,
    padding: s
  };
}, gl = function(t) {
  var i = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var g = Number(i);
  return isNaN(g) && sAt(), g;
}, cAt = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, WV = function(t, i) {
  var n = t.borderBox, g = t.border, r = t.margin, o = t.padding, I = aAt(n, i);
  return JK({
    borderBox: I,
    border: g,
    margin: r,
    padding: o
  });
}, SV = function(t, i) {
  return i === void 0 && (i = cAt()), WV(t, i);
}, Qq = function(t, i) {
  var n = {
    top: gl(i.marginTop),
    right: gl(i.marginRight),
    bottom: gl(i.marginBottom),
    left: gl(i.marginLeft)
  }, g = {
    top: gl(i.paddingTop),
    right: gl(i.paddingRight),
    bottom: gl(i.paddingBottom),
    left: gl(i.paddingLeft)
  }, r = {
    top: gl(i.borderTopWidth),
    right: gl(i.borderRightWidth),
    bottom: gl(i.borderBottomWidth),
    left: gl(i.borderLeftWidth)
  };
  return JK({
    borderBox: t,
    margin: n,
    padding: g,
    border: r
  });
}, jq = function(t) {
  var i = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return Qq(i, n);
}, cZ = function(t) {
  var i = [], n = null, g = function() {
    for (var o = arguments.length, I = new Array(o), s = 0; s < o; s++)
      I[s] = arguments[s];
    i = I, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, i);
    }));
  };
  return g.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, g;
};
function _q(e, t) {
}
_q.bind(null, "warn");
_q.bind(null, "error");
function vd() {
}
function dAt(e, t) {
  return k({}, e, {}, t);
}
function Al(e, t, i) {
  var n = t.map(function(g) {
    var r = dAt(i, g.options);
    return e.addEventListener(g.eventName, g.fn, r), function() {
      e.removeEventListener(g.eventName, g.fn, r);
    };
  });
  return function() {
    n.forEach(function(r) {
      r();
    });
  };
}
var CAt = "Invariant failed";
function VV(e) {
  this.message = e;
}
VV.prototype.toString = function() {
  return this.message;
};
function pt(e, t) {
  throw new VV(CAt);
}
var uAt = function(e) {
  wZ(t, e);
  function t() {
    for (var n, g = arguments.length, r = new Array(g), o = 0; o < g; o++)
      r[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(r)) || this, n.callbacks = null, n.unbind = vd, n.onWindowError = function(I) {
      var s = n.getCallbacks();
      s.isDragging() && s.tryAbort();
      var a = I.error;
      a instanceof VV && I.preventDefault();
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(I) {
      n.callbacks = I;
    }, n;
  }
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.unbind = Al(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, i.componentDidCatch = function(g) {
    if (g instanceof VV) {
      this.setState({});
      return;
    }
    throw g;
  }, i.componentWillUnmount = function() {
    this.unbind();
  }, i.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(Se.Component), AAt = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, wV = function(t) {
  return t + 1;
}, bAt = function(t) {
  return `
  You have lifted an item in position ` + wV(t.source.index) + `
`;
}, $q = function(t, i) {
  var n = t.droppableId === i.droppableId, g = wV(t.index), r = wV(i.index);
  return n ? `
      You have moved the item from position ` + g + `
      to position ` + r + `
    ` : `
    You have moved the item from position ` + g + `
    in list ` + t.droppableId + `
    to list ` + i.droppableId + `
    in position ` + r + `
  `;
}, qq = function(t, i, n) {
  var g = i.droppableId === n.droppableId;
  return g ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + i.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, mAt = function(t) {
  var i = t.destination;
  if (i)
    return $q(t.source, i);
  var n = t.combine;
  return n ? qq(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, dU = function(t) {
  return `
  The item has returned to its starting position
  of ` + wV(t.index) + `
`;
}, hAt = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + dU(t.source) + `
    `;
  var i = t.destination, n = t.combine;
  return i ? `
      You have dropped the item.
      ` + $q(t.source, i) + `
    ` : n ? `
      You have dropped the item.
      ` + qq(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + dU(t.source) + `
  `;
}, pS = {
  dragHandleUsageInstructions: AAt,
  onDragStart: bAt,
  onDragUpdate: mAt,
  onDragEnd: hAt
}, ur = {
  x: 0,
  y: 0
}, Nr = function(t, i) {
  return {
    x: t.x + i.x,
    y: t.y + i.y
  };
}, SI = function(t, i) {
  return {
    x: t.x - i.x,
    y: t.y - i.y
  };
}, Rd = function(t, i) {
  return t.x === i.x && t.y === i.y;
}, Zh = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, Tu = function(t, i, n) {
  var g;
  return n === void 0 && (n = 0), g = {}, g[t] = i, g[t === "x" ? "y" : "x"] = n, g;
}, dZ = function(t, i) {
  return Math.sqrt(Math.pow(i.x - t.x, 2) + Math.pow(i.y - t.y, 2));
}, CU = function(t, i) {
  return Math.min.apply(Math, i.map(function(n) {
    return dZ(t, n);
  }));
}, eee = function(t) {
  return function(i) {
    return {
      x: t(i.x),
      y: t(i.y)
    };
  };
}, pAt = function(e, t) {
  var i = cs({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return i.width <= 0 || i.height <= 0 ? null : i;
}, Rf = function(t, i) {
  return {
    top: t.top + i.y,
    left: t.left + i.x,
    bottom: t.bottom + i.y,
    right: t.right + i.x
  };
}, uU = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, BAt = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, ZAt = function(t, i) {
  return i ? Rf(t, i.scroll.diff.displacement) : t;
}, fAt = function(t, i, n) {
  if (n && n.increasedBy) {
    var g;
    return k({}, t, (g = {}, g[i.end] = t[i.end] + n.increasedBy[i.line], g));
  }
  return t;
}, GAt = function(t, i) {
  return i && i.shouldClipSubject ? pAt(i.pageMarginBox, t) : cs(t);
}, Lm = function(e) {
  var t = e.page, i = e.withPlaceholder, n = e.axis, g = e.frame, r = ZAt(t.marginBox, g), o = fAt(r, n, i), I = GAt(o, g);
  return {
    page: t,
    withPlaceholder: i,
    active: I
  };
}, KK = function(e, t) {
  e.frame || pt();
  var i = e.frame, n = SI(t, i.scroll.initial), g = Zh(n), r = k({}, i, {
    scroll: {
      initial: i.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: g
      },
      max: i.scroll.max
    }
  }), o = Lm({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: r
  }), I = k({}, e, {
    frame: r,
    subject: o
  });
  return I;
};
function vV(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function EK(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var i = 0; i < e.length; i++)
    if (t(e[i]))
      return i;
  return -1;
}
function lC(e, t) {
  if (e.find)
    return e.find(t);
  var i = EK(e, t);
  if (i !== -1)
    return e[i];
}
function tee(e) {
  return Array.prototype.slice.call(e);
}
var iee = yg(function(e) {
  return e.reduce(function(t, i) {
    return t[i.descriptor.id] = i, t;
  }, {});
}), nee = yg(function(e) {
  return e.reduce(function(t, i) {
    return t[i.descriptor.id] = i, t;
  }, {});
}), Z2 = yg(function(e) {
  return vV(e);
}), yAt = yg(function(e) {
  return vV(e);
}), fh = yg(function(e, t) {
  var i = yAt(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, g) {
    return n.descriptor.index - g.descriptor.index;
  });
  return i;
});
function NK(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function f2(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var G2 = yg(function(e, t) {
  return t.filter(function(i) {
    return i.descriptor.id !== e.descriptor.id;
  });
}), WAt = function(e) {
  var t = e.isMovingForward, i = e.draggable, n = e.destination, g = e.insideDestination, r = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var o = NK(r);
  if (!o)
    return null;
  function I(h) {
    var B = {
      type: "COMBINE",
      combine: {
        draggableId: h,
        droppableId: n.descriptor.id
      }
    };
    return k({}, r, {
      at: B
    });
  }
  var s = r.displaced.all, a = s.length ? s[0] : null;
  if (t)
    return a ? I(a) : null;
  var d = G2(i, g);
  if (!a) {
    if (!d.length)
      return null;
    var C = d[d.length - 1];
    return I(C.descriptor.id);
  }
  var u = EK(d, function(h) {
    return h.descriptor.id === a;
  });
  u === -1 && pt();
  var A = u - 1;
  if (A < 0)
    return null;
  var m = d[A];
  return I(m.descriptor.id);
}, Gh = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, gee = {
  point: ur,
  value: 0
}, CZ = {
  invisible: {},
  visible: {},
  all: []
}, SAt = {
  displaced: CZ,
  displacedBy: gee,
  at: null
}, hl = function(e, t) {
  return function(i) {
    return e <= i && i <= t;
  };
}, ree = function(e) {
  var t = hl(e.top, e.bottom), i = hl(e.left, e.right);
  return function(n) {
    var g = t(n.top) && t(n.bottom) && i(n.left) && i(n.right);
    if (g)
      return !0;
    var r = t(n.top) || t(n.bottom), o = i(n.left) || i(n.right), I = r && o;
    if (I)
      return !0;
    var s = n.top < e.top && n.bottom > e.bottom, a = n.left < e.left && n.right > e.right, d = s && a;
    if (d)
      return !0;
    var C = s && o || a && r;
    return C;
  };
}, VAt = function(e) {
  var t = hl(e.top, e.bottom), i = hl(e.left, e.right);
  return function(n) {
    var g = t(n.top) && t(n.bottom) && i(n.left) && i(n.right);
    return g;
  };
}, LK = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, oee = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, wAt = function(e) {
  return function(t) {
    var i = hl(t.top, t.bottom), n = hl(t.left, t.right);
    return function(g) {
      return e === LK ? i(g.top) && i(g.bottom) : n(g.left) && n(g.right);
    };
  };
}, vAt = function(t, i) {
  var n = i.frame ? i.frame.scroll.diff.displacement : ur;
  return Rf(t, n);
}, RAt = function(t, i, n) {
  return i.subject.active ? n(i.subject.active)(t) : !1;
}, XAt = function(t, i, n) {
  return n(i)(t);
}, TK = function(t) {
  var i = t.target, n = t.destination, g = t.viewport, r = t.withDroppableDisplacement, o = t.isVisibleThroughFrameFn, I = r ? vAt(i, n) : i;
  return RAt(I, n, o) && XAt(I, g, o);
}, HAt = function(t) {
  return TK(k({}, t, {
    isVisibleThroughFrameFn: ree
  }));
}, Iee = function(t) {
  return TK(k({}, t, {
    isVisibleThroughFrameFn: VAt
  }));
}, kAt = function(t) {
  return TK(k({}, t, {
    isVisibleThroughFrameFn: wAt(t.destination.axis)
  }));
}, FAt = function(t, i, n) {
  if (typeof n == "boolean")
    return n;
  if (!i)
    return !0;
  var g = i.invisible, r = i.visible;
  if (g[t])
    return !1;
  var o = r[t];
  return o ? o.shouldAnimate : !0;
};
function YAt(e, t) {
  var i = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return cs(DK(i, n));
}
function uZ(e) {
  var t = e.afterDragging, i = e.destination, n = e.displacedBy, g = e.viewport, r = e.forceShouldAnimate, o = e.last;
  return t.reduce(function(s, a) {
    var d = YAt(a, n), C = a.descriptor.id;
    s.all.push(C);
    var u = HAt({
      target: d,
      destination: i,
      viewport: g,
      withDroppableDisplacement: !0
    });
    if (!u)
      return s.invisible[a.descriptor.id] = !0, s;
    var A = FAt(C, o, r), m = {
      draggableId: C,
      shouldAnimate: A
    };
    return s.visible[C] = m, s;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function xAt(e, t) {
  if (!e.length)
    return 0;
  var i = e[e.length - 1].descriptor.index;
  return t.inHomeList ? i : i + 1;
}
function AU(e) {
  var t = e.insideDestination, i = e.inHomeList, n = e.displacedBy, g = e.destination, r = xAt(t, {
    inHomeList: i
  });
  return {
    displaced: CZ,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: g.descriptor.id,
        index: r
      }
    }
  };
}
function RV(e) {
  var t = e.draggable, i = e.insideDestination, n = e.destination, g = e.viewport, r = e.displacedBy, o = e.last, I = e.index, s = e.forceShouldAnimate, a = Gh(t, n);
  if (I == null)
    return AU({
      insideDestination: i,
      inHomeList: a,
      displacedBy: r,
      destination: n
    });
  var d = lC(i, function(h) {
    return h.descriptor.index === I;
  });
  if (!d)
    return AU({
      insideDestination: i,
      inHomeList: a,
      displacedBy: r,
      destination: n
    });
  var C = G2(t, i), u = i.indexOf(d), A = C.slice(u), m = uZ({
    afterDragging: A,
    destination: n,
    displacedBy: r,
    last: o,
    viewport: g.frame,
    forceShouldAnimate: s
  });
  return {
    displaced: m,
    displacedBy: r,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: I
      }
    }
  };
}
function Md(e, t) {
  return !!t.effected[e];
}
var DAt = function(e) {
  var t = e.isMovingForward, i = e.destination, n = e.draggables, g = e.combine, r = e.afterCritical;
  if (!i.isCombineEnabled)
    return null;
  var o = g.draggableId, I = n[o], s = I.descriptor.index, a = Md(o, r);
  return a ? t ? s : s - 1 : t ? s + 1 : s;
}, JAt = function(e) {
  var t = e.isMovingForward, i = e.isInHomeList, n = e.insideDestination, g = e.location;
  if (!n.length)
    return null;
  var r = g.index, o = t ? r + 1 : r - 1, I = n[0].descriptor.index, s = n[n.length - 1].descriptor.index, a = i ? s : s + 1;
  return o < I || o > a ? null : o;
}, KAt = function(e) {
  var t = e.isMovingForward, i = e.isInHomeList, n = e.draggable, g = e.draggables, r = e.destination, o = e.insideDestination, I = e.previousImpact, s = e.viewport, a = e.afterCritical, d = I.at;
  if (d || pt(), d.type === "REORDER") {
    var C = JAt({
      isMovingForward: t,
      isInHomeList: i,
      location: d.destination,
      insideDestination: o
    });
    return C == null ? null : RV({
      draggable: n,
      insideDestination: o,
      destination: r,
      viewport: s,
      last: I.displaced,
      displacedBy: I.displacedBy,
      index: C
    });
  }
  var u = DAt({
    isMovingForward: t,
    destination: r,
    displaced: I.displaced,
    draggables: g,
    combine: d.combine,
    afterCritical: a
  });
  return u == null ? null : RV({
    draggable: n,
    insideDestination: o,
    destination: r,
    viewport: s,
    last: I.displaced,
    displacedBy: I.displacedBy,
    index: u
  });
}, EAt = function(e) {
  var t = e.displaced, i = e.afterCritical, n = e.combineWith, g = e.displacedBy, r = !!(t.visible[n] || t.invisible[n]);
  return Md(n, i) ? r ? ur : Zh(g.point) : r ? g.point : ur;
}, NAt = function(e) {
  var t = e.afterCritical, i = e.impact, n = e.draggables, g = f2(i);
  g || pt();
  var r = g.draggableId, o = n[r].page.borderBox.center, I = EAt({
    displaced: i.displaced,
    afterCritical: t,
    combineWith: r,
    displacedBy: i.displacedBy
  });
  return Nr(o, I);
}, lee = function(t, i) {
  return i.margin[t.start] + i.borderBox[t.size] / 2;
}, LAt = function(t, i) {
  return i.margin[t.end] + i.borderBox[t.size] / 2;
}, MK = function(t, i, n) {
  return i[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, bU = function(t) {
  var i = t.axis, n = t.moveRelativeTo, g = t.isMoving;
  return Tu(i.line, n.marginBox[i.end] + lee(i, g), MK(i, n.marginBox, g));
}, mU = function(t) {
  var i = t.axis, n = t.moveRelativeTo, g = t.isMoving;
  return Tu(i.line, n.marginBox[i.start] - LAt(i, g), MK(i, n.marginBox, g));
}, TAt = function(t) {
  var i = t.axis, n = t.moveInto, g = t.isMoving;
  return Tu(i.line, n.contentBox[i.start] + lee(i, g), MK(i, n.contentBox, g));
}, MAt = function(e) {
  var t = e.impact, i = e.draggable, n = e.draggables, g = e.droppable, r = e.afterCritical, o = fh(g.descriptor.id, n), I = i.page, s = g.axis;
  if (!o.length)
    return TAt({
      axis: s,
      moveInto: g.page,
      isMoving: I
    });
  var a = t.displaced, d = t.displacedBy, C = a.all[0];
  if (C) {
    var u = n[C];
    if (Md(C, r))
      return mU({
        axis: s,
        moveRelativeTo: u.page,
        isMoving: I
      });
    var A = WV(u.page, d.point);
    return mU({
      axis: s,
      moveRelativeTo: A,
      isMoving: I
    });
  }
  var m = o[o.length - 1];
  if (m.descriptor.id === i.descriptor.id)
    return I.borderBox.center;
  if (Md(m.descriptor.id, r)) {
    var h = WV(m.page, Zh(r.displacedBy.point));
    return bU({
      axis: s,
      moveRelativeTo: h,
      isMoving: I
    });
  }
  return bU({
    axis: s,
    moveRelativeTo: m.page,
    isMoving: I
  });
}, Xx = function(e, t) {
  var i = e.frame;
  return i ? Nr(t, i.scroll.diff.displacement) : t;
}, UAt = function(t) {
  var i = t.impact, n = t.draggable, g = t.droppable, r = t.draggables, o = t.afterCritical, I = n.page.borderBox.center, s = i.at;
  return !g || !s ? I : s.type === "REORDER" ? MAt({
    impact: i,
    draggable: n,
    draggables: r,
    droppable: g,
    afterCritical: o
  }) : NAt({
    impact: i,
    draggables: r,
    afterCritical: o
  });
}, y2 = function(e) {
  var t = UAt(e), i = e.droppable, n = i ? Xx(i, t) : t;
  return n;
}, see = function(e, t) {
  var i = SI(t, e.scroll.initial), n = Zh(i), g = cs({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), r = {
    frame: g,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: i,
        displacement: n
      }
    }
  };
  return r;
};
function hU(e, t) {
  return e.map(function(i) {
    return t[i];
  });
}
function PAt(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i].visible[e];
    if (n)
      return n;
  }
  return null;
}
var zAt = function(e) {
  var t = e.impact, i = e.viewport, n = e.destination, g = e.draggables, r = e.maxScrollChange, o = see(i, Nr(i.scroll.current, r)), I = n.frame ? KK(n, Nr(n.frame.scroll.current, r)) : n, s = t.displaced, a = uZ({
    afterDragging: hU(s.all, g),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: o.frame,
    last: s,
    forceShouldAnimate: !1
  }), d = uZ({
    afterDragging: hU(s.all, g),
    destination: I,
    displacedBy: t.displacedBy,
    viewport: i.frame,
    last: s,
    forceShouldAnimate: !1
  }), C = {}, u = {}, A = [s, a, d];
  s.all.forEach(function(h) {
    var B = PAt(h, A);
    if (B) {
      u[h] = B;
      return;
    }
    C[h] = !0;
  });
  var m = k({}, t, {
    displaced: {
      all: s.all,
      invisible: C,
      visible: u
    }
  });
  return m;
}, OAt = function(e, t) {
  return Nr(e.scroll.diff.displacement, t);
}, UK = function(e) {
  var t = e.pageBorderBoxCenter, i = e.draggable, n = e.viewport, g = OAt(n, t), r = SI(g, i.page.borderBox.center);
  return Nr(i.client.borderBox.center, r);
}, aee = function(e) {
  var t = e.draggable, i = e.destination, n = e.newPageBorderBoxCenter, g = e.viewport, r = e.withDroppableDisplacement, o = e.onlyOnMainAxis, I = o === void 0 ? !1 : o, s = SI(n, t.page.borderBox.center), a = Rf(t.page.borderBox, s), d = {
    target: a,
    destination: i,
    withDroppableDisplacement: r,
    viewport: g
  };
  return I ? kAt(d) : Iee(d);
}, QAt = function(e) {
  var t = e.isMovingForward, i = e.draggable, n = e.destination, g = e.draggables, r = e.previousImpact, o = e.viewport, I = e.previousPageBorderBoxCenter, s = e.previousClientSelection, a = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var d = fh(n.descriptor.id, g), C = Gh(i, n), u = WAt({
    isMovingForward: t,
    draggable: i,
    destination: n,
    insideDestination: d,
    previousImpact: r
  }) || KAt({
    isMovingForward: t,
    isInHomeList: C,
    draggable: i,
    draggables: g,
    destination: n,
    insideDestination: d,
    previousImpact: r,
    viewport: o,
    afterCritical: a
  });
  if (!u)
    return null;
  var A = y2({
    impact: u,
    draggable: i,
    droppable: n,
    draggables: g,
    afterCritical: a
  }), m = aee({
    draggable: i,
    destination: n,
    newPageBorderBoxCenter: A,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (m) {
    var h = UK({
      pageBorderBoxCenter: A,
      draggable: i,
      viewport: o
    });
    return {
      clientSelection: h,
      impact: u,
      scrollJumpRequest: null
    };
  }
  var B = SI(A, I), f = zAt({
    impact: u,
    viewport: o,
    destination: n,
    draggables: g,
    maxScrollChange: B
  });
  return {
    clientSelection: s,
    impact: f,
    scrollJumpRequest: B
  };
}, Co = function(t) {
  var i = t.subject.active;
  return i || pt(), i;
}, jAt = function(e) {
  var t = e.isMovingForward, i = e.pageBorderBoxCenter, n = e.source, g = e.droppables, r = e.viewport, o = n.subject.active;
  if (!o)
    return null;
  var I = n.axis, s = hl(o[I.start], o[I.end]), a = Z2(g).filter(function(C) {
    return C !== n;
  }).filter(function(C) {
    return C.isEnabled;
  }).filter(function(C) {
    return !!C.subject.active;
  }).filter(function(C) {
    return ree(r.frame)(Co(C));
  }).filter(function(C) {
    var u = Co(C);
    return t ? o[I.crossAxisEnd] < u[I.crossAxisEnd] : u[I.crossAxisStart] < o[I.crossAxisStart];
  }).filter(function(C) {
    var u = Co(C), A = hl(u[I.start], u[I.end]);
    return s(u[I.start]) || s(u[I.end]) || A(o[I.start]) || A(o[I.end]);
  }).sort(function(C, u) {
    var A = Co(C)[I.crossAxisStart], m = Co(u)[I.crossAxisStart];
    return t ? A - m : m - A;
  }).filter(function(C, u, A) {
    return Co(C)[I.crossAxisStart] === Co(A[0])[I.crossAxisStart];
  });
  if (!a.length)
    return null;
  if (a.length === 1)
    return a[0];
  var d = a.filter(function(C) {
    var u = hl(Co(C)[I.start], Co(C)[I.end]);
    return u(i[I.line]);
  });
  return d.length === 1 ? d[0] : d.length > 1 ? d.sort(function(C, u) {
    return Co(C)[I.start] - Co(u)[I.start];
  })[0] : a.sort(function(C, u) {
    var A = CU(i, uU(Co(C))), m = CU(i, uU(Co(u)));
    return A !== m ? A - m : Co(C)[I.start] - Co(u)[I.start];
  })[0];
}, pU = function(t, i) {
  var n = t.page.borderBox.center;
  return Md(t.descriptor.id, i) ? SI(n, i.displacedBy.point) : n;
}, _At = function(t, i) {
  var n = t.page.borderBox;
  return Md(t.descriptor.id, i) ? Rf(n, Zh(i.displacedBy.point)) : n;
}, $At = function(e) {
  var t = e.pageBorderBoxCenter, i = e.viewport, n = e.destination, g = e.insideDestination, r = e.afterCritical, o = g.filter(function(I) {
    return Iee({
      target: _At(I, r),
      destination: n,
      viewport: i.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(I, s) {
    var a = dZ(t, Xx(n, pU(I, r))), d = dZ(t, Xx(n, pU(s, r)));
    return a < d ? -1 : d < a ? 1 : I.descriptor.index - s.descriptor.index;
  });
  return o[0] || null;
}, Xf = yg(function(t, i) {
  var n = i[t.line];
  return {
    value: n,
    point: Tu(t.line, n)
  };
}), qAt = function(t, i, n) {
  var g = t.axis;
  if (t.descriptor.mode === "virtual")
    return Tu(g.line, i[g.line]);
  var r = t.subject.page.contentBox[g.size], o = fh(t.descriptor.id, n), I = o.reduce(function(d, C) {
    return d + C.client.marginBox[g.size];
  }, 0), s = I + i[g.line], a = s - r;
  return a <= 0 ? null : Tu(g.line, a);
}, cee = function(t, i) {
  return k({}, t, {
    scroll: k({}, t.scroll, {
      max: i
    })
  });
}, dee = function(t, i, n) {
  var g = t.frame;
  Gh(i, t) && pt(), t.subject.withPlaceholder && pt();
  var r = Xf(t.axis, i.displaceBy).point, o = qAt(t, r, n), I = {
    placeholderSize: r,
    increasedBy: o,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!g) {
    var s = Lm({
      page: t.subject.page,
      withPlaceholder: I,
      axis: t.axis,
      frame: t.frame
    });
    return k({}, t, {
      subject: s
    });
  }
  var a = o ? Nr(g.scroll.max, o) : g.scroll.max, d = cee(g, a), C = Lm({
    page: t.subject.page,
    withPlaceholder: I,
    axis: t.axis,
    frame: d
  });
  return k({}, t, {
    subject: C,
    frame: d
  });
}, ebt = function(t) {
  var i = t.subject.withPlaceholder;
  i || pt();
  var n = t.frame;
  if (!n) {
    var g = Lm({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return k({}, t, {
      subject: g
    });
  }
  var r = i.oldFrameMaxScroll;
  r || pt();
  var o = cee(n, r), I = Lm({
    page: t.subject.page,
    axis: t.axis,
    frame: o,
    withPlaceholder: null
  });
  return k({}, t, {
    subject: I,
    frame: o
  });
}, tbt = function(e) {
  var t = e.previousPageBorderBoxCenter, i = e.moveRelativeTo, n = e.insideDestination, g = e.draggable, r = e.draggables, o = e.destination, I = e.viewport, s = e.afterCritical;
  if (!i) {
    if (n.length)
      return null;
    var a = {
      displaced: CZ,
      displacedBy: gee,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, d = y2({
      impact: a,
      draggable: g,
      droppable: o,
      draggables: r,
      afterCritical: s
    }), C = Gh(g, o) ? o : dee(o, g, r), u = aee({
      draggable: g,
      destination: C,
      newPageBorderBoxCenter: d,
      viewport: I.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return u ? a : null;
  }
  var A = t[o.axis.line] <= i.page.borderBox.center[o.axis.line], m = function() {
    var B = i.descriptor.index;
    return i.descriptor.id === g.descriptor.id || A ? B : B + 1;
  }(), h = Xf(o.axis, g.displaceBy);
  return RV({
    draggable: g,
    insideDestination: n,
    destination: o,
    viewport: I,
    displacedBy: h,
    last: CZ,
    index: m
  });
}, ibt = function(e) {
  var t = e.isMovingForward, i = e.previousPageBorderBoxCenter, n = e.draggable, g = e.isOver, r = e.draggables, o = e.droppables, I = e.viewport, s = e.afterCritical, a = jAt({
    isMovingForward: t,
    pageBorderBoxCenter: i,
    source: g,
    droppables: o,
    viewport: I
  });
  if (!a)
    return null;
  var d = fh(a.descriptor.id, r), C = $At({
    pageBorderBoxCenter: i,
    viewport: I,
    destination: a,
    insideDestination: d,
    afterCritical: s
  }), u = tbt({
    previousPageBorderBoxCenter: i,
    destination: a,
    draggable: n,
    draggables: r,
    moveRelativeTo: C,
    insideDestination: d,
    viewport: I,
    afterCritical: s
  });
  if (!u)
    return null;
  var A = y2({
    impact: u,
    draggable: n,
    droppable: a,
    draggables: r,
    afterCritical: s
  }), m = UK({
    pageBorderBoxCenter: A,
    draggable: n,
    viewport: I
  });
  return {
    clientSelection: m,
    impact: u,
    scrollJumpRequest: null
  };
}, XI = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, nbt = function(t, i) {
  var n = XI(t);
  return n ? i[n] : null;
}, gbt = function(e) {
  var t = e.state, i = e.type, n = nbt(t.impact, t.dimensions.droppables), g = !!n, r = t.dimensions.droppables[t.critical.droppable.id], o = n || r, I = o.axis.direction, s = I === "vertical" && (i === "MOVE_UP" || i === "MOVE_DOWN") || I === "horizontal" && (i === "MOVE_LEFT" || i === "MOVE_RIGHT");
  if (s && !g)
    return null;
  var a = i === "MOVE_DOWN" || i === "MOVE_RIGHT", d = t.dimensions.draggables[t.critical.draggable.id], C = t.current.page.borderBoxCenter, u = t.dimensions, A = u.draggables, m = u.droppables;
  return s ? QAt({
    isMovingForward: a,
    previousPageBorderBoxCenter: C,
    draggable: d,
    destination: o,
    draggables: A,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : ibt({
    isMovingForward: a,
    previousPageBorderBoxCenter: C,
    draggable: d,
    isOver: o,
    draggables: A,
    droppables: m,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function du(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function Cee(e) {
  var t = hl(e.top, e.bottom), i = hl(e.left, e.right);
  return function(g) {
    return t(g.y) && i(g.x);
  };
}
function rbt(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function obt(e) {
  var t = e.pageBorderBox, i = e.draggable, n = e.candidates, g = i.page.borderBox.center, r = n.map(function(o) {
    var I = o.axis, s = Tu(o.axis.line, t.center[I.line], o.page.borderBox.center[I.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: dZ(g, s)
    };
  }).sort(function(o, I) {
    return I.distance - o.distance;
  });
  return r[0] ? r[0].id : null;
}
function Ibt(e) {
  var t = e.pageBorderBox, i = e.draggable, n = e.droppables, g = Z2(n).filter(function(r) {
    if (!r.isEnabled)
      return !1;
    var o = r.subject.active;
    if (!o || !rbt(t, o))
      return !1;
    if (Cee(o)(t.center))
      return !0;
    var I = r.axis, s = o.center[I.crossAxisLine], a = t[I.crossAxisStart], d = t[I.crossAxisEnd], C = hl(o[I.crossAxisStart], o[I.crossAxisEnd]), u = C(a), A = C(d);
    return !u && !A ? !0 : u ? a < s : d > s;
  });
  return g.length ? g.length === 1 ? g[0].descriptor.id : obt({
    pageBorderBox: t,
    draggable: i,
    candidates: g
  }) : null;
}
var uee = function(t, i) {
  return cs(Rf(t, i));
}, lbt = function(e, t) {
  var i = e.frame;
  return i ? uee(t, i.scroll.diff.value) : t;
};
function Aee(e) {
  var t = e.displaced, i = e.id;
  return !!(t.visible[i] || t.invisible[i]);
}
function sbt(e) {
  var t = e.draggable, i = e.closest, n = e.inHomeList;
  return i ? n && i.descriptor.index > t.descriptor.index ? i.descriptor.index - 1 : i.descriptor.index : null;
}
var abt = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, i = e.draggable, n = e.destination, g = e.insideDestination, r = e.last, o = e.viewport, I = e.afterCritical, s = n.axis, a = Xf(n.axis, i.displaceBy), d = a.value, C = t[s.start], u = t[s.end], A = G2(i, g), m = lC(A, function(B) {
    var f = B.descriptor.id, G = B.page.borderBox.center[s.line], y = Md(f, I), W = Aee({
      displaced: r,
      id: f
    });
    return y ? W ? u <= G : C < G - d : W ? u <= G + d : C < G;
  }), h = sbt({
    draggable: i,
    closest: m,
    inHomeList: Gh(i, n)
  });
  return RV({
    draggable: i,
    insideDestination: g,
    destination: n,
    viewport: o,
    last: r,
    displacedBy: a,
    index: h
  });
}, cbt = 4, dbt = function(e) {
  var t = e.draggable, i = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, g = e.destination, r = e.insideDestination, o = e.afterCritical;
  if (!g.isCombineEnabled)
    return null;
  var I = g.axis, s = Xf(g.axis, t.displaceBy), a = s.value, d = i[I.start], C = i[I.end], u = G2(t, r), A = lC(u, function(h) {
    var B = h.descriptor.id, f = h.page.borderBox, G = f[I.size], y = G / cbt, W = Md(B, o), V = Aee({
      displaced: n.displaced,
      id: B
    });
    return W ? V ? C > f[I.start] + y && C < f[I.end] - y : d > f[I.start] - a + y && d < f[I.end] - a - y : V ? C > f[I.start] + a + y && C < f[I.end] + a - y : d > f[I.start] + y && d < f[I.end] - y;
  });
  if (!A)
    return null;
  var m = {
    displacedBy: s,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: A.descriptor.id,
        droppableId: g.descriptor.id
      }
    }
  };
  return m;
}, bee = function(e) {
  var t = e.pageOffset, i = e.draggable, n = e.draggables, g = e.droppables, r = e.previousImpact, o = e.viewport, I = e.afterCritical, s = uee(i.page.borderBox, t), a = Ibt({
    pageBorderBox: s,
    draggable: i,
    droppables: g
  });
  if (!a)
    return SAt;
  var d = g[a], C = fh(d.descriptor.id, n), u = lbt(d, s);
  return dbt({
    pageBorderBoxWithDroppableScroll: u,
    draggable: i,
    previousImpact: r,
    destination: d,
    insideDestination: C,
    afterCritical: I
  }) || abt({
    pageBorderBoxWithDroppableScroll: u,
    draggable: i,
    destination: d,
    insideDestination: C,
    last: r.displaced,
    viewport: o,
    afterCritical: I
  });
}, PK = function(e, t) {
  var i;
  return k({}, e, (i = {}, i[t.descriptor.id] = t, i));
}, Cbt = function(t) {
  var i = t.previousImpact, n = t.impact, g = t.droppables, r = XI(i), o = XI(n);
  if (!r || r === o)
    return g;
  var I = g[r];
  if (!I.subject.withPlaceholder)
    return g;
  var s = ebt(I);
  return PK(g, s);
}, ubt = function(e) {
  var t = e.draggable, i = e.draggables, n = e.droppables, g = e.previousImpact, r = e.impact, o = Cbt({
    previousImpact: g,
    impact: r,
    droppables: n
  }), I = XI(r);
  if (!I)
    return o;
  var s = n[I];
  if (Gh(t, s) || s.subject.withPlaceholder)
    return o;
  var a = dee(s, t, i);
  return PK(o, a);
}, wB = function(e) {
  var t = e.state, i = e.clientSelection, n = e.dimensions, g = e.viewport, r = e.impact, o = e.scrollJumpRequest, I = g || t.viewport, s = n || t.dimensions, a = i || t.current.client.selection, d = SI(a, t.initial.client.selection), C = {
    offset: d,
    selection: a,
    borderBoxCenter: Nr(t.initial.client.borderBoxCenter, d)
  }, u = {
    selection: Nr(C.selection, I.scroll.current),
    borderBoxCenter: Nr(C.borderBoxCenter, I.scroll.current),
    offset: Nr(C.offset, I.scroll.diff.value)
  }, A = {
    client: C,
    page: u
  };
  if (t.phase === "COLLECTING")
    return k({
      phase: "COLLECTING"
    }, t, {
      dimensions: s,
      viewport: I,
      current: A
    });
  var m = s.draggables[t.critical.draggable.id], h = r || bee({
    pageOffset: u.offset,
    draggable: m,
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: t.impact,
    viewport: I,
    afterCritical: t.afterCritical
  }), B = ubt({
    draggable: m,
    impact: h,
    previousImpact: t.impact,
    draggables: s.draggables,
    droppables: s.droppables
  }), f = k({}, t, {
    current: A,
    dimensions: {
      draggables: s.draggables,
      droppables: B
    },
    impact: h,
    viewport: I,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
  return f;
};
function Abt(e, t) {
  return e.map(function(i) {
    return t[i];
  });
}
var mee = function(e) {
  var t = e.impact, i = e.viewport, n = e.draggables, g = e.destination, r = e.forceShouldAnimate, o = t.displaced, I = Abt(o.all, n), s = uZ({
    afterDragging: I,
    destination: g,
    displacedBy: t.displacedBy,
    viewport: i.frame,
    forceShouldAnimate: r,
    last: o
  });
  return k({}, t, {
    displaced: s
  });
}, hee = function(e) {
  var t = e.impact, i = e.draggable, n = e.droppable, g = e.draggables, r = e.viewport, o = e.afterCritical, I = y2({
    impact: t,
    draggable: i,
    draggables: g,
    droppable: n,
    afterCritical: o
  });
  return UK({
    pageBorderBoxCenter: I,
    draggable: i,
    viewport: r
  });
}, pee = function(e) {
  var t = e.state, i = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && pt();
  var g = t.impact, r = n || t.viewport, o = i || t.dimensions, I = o.draggables, s = o.droppables, a = I[t.critical.draggable.id], d = XI(g);
  d || pt();
  var C = s[d], u = mee({
    impact: g,
    viewport: r,
    destination: C,
    draggables: I
  }), A = hee({
    impact: u,
    draggable: a,
    droppable: C,
    draggables: I,
    viewport: r,
    afterCritical: t.afterCritical
  });
  return wB({
    impact: u,
    clientSelection: A,
    state: t,
    dimensions: o,
    viewport: r
  });
}, bbt = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, Bee = function(e) {
  var t = e.draggable, i = e.home, n = e.draggables, g = e.viewport, r = Xf(i.axis, t.displaceBy), o = fh(i.descriptor.id, n), I = o.indexOf(t);
  I === -1 && pt();
  var s = o.slice(I + 1), a = s.reduce(function(A, m) {
    return A[m.descriptor.id] = !0, A;
  }, {}), d = {
    inVirtualList: i.descriptor.mode === "virtual",
    displacedBy: r,
    effected: a
  }, C = uZ({
    afterDragging: s,
    destination: i,
    displacedBy: r,
    last: null,
    viewport: g.frame,
    forceShouldAnimate: !1
  }), u = {
    displaced: C,
    displacedBy: r,
    at: {
      type: "REORDER",
      destination: bbt(t.descriptor)
    }
  };
  return {
    impact: u,
    afterCritical: d
  };
}, mbt = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: PK(e.droppables, t)
  };
}, hbt = function(e) {
  var t = e.draggable, i = e.offset, n = e.initialWindowScroll, g = WV(t.client, i), r = SV(g, n), o = k({}, t, {
    placeholder: k({}, t.placeholder, {
      client: g
    }),
    client: g,
    page: r
  });
  return o;
}, pbt = function(e) {
  var t = e.frame;
  return t || pt(), t;
}, Bbt = function(e) {
  var t = e.additions, i = e.updatedDroppables, n = e.viewport, g = n.scroll.diff.value;
  return t.map(function(r) {
    var o = r.descriptor.droppableId, I = i[o], s = pbt(I), a = s.scroll.diff.value, d = Nr(g, a), C = hbt({
      draggable: r,
      offset: d,
      initialWindowScroll: n.scroll.initial
    });
    return C;
  });
}, Zbt = function(e) {
  var t = e.state, i = e.published, n = i.modified.map(function(y) {
    var W = t.dimensions.droppables[y.droppableId], V = KK(W, y.scroll);
    return V;
  }), g = k({}, t.dimensions.droppables, {}, iee(n)), r = nee(Bbt({
    additions: i.additions,
    updatedDroppables: g,
    viewport: t.viewport
  })), o = k({}, t.dimensions.draggables, {}, r);
  i.removals.forEach(function(y) {
    delete o[y];
  });
  var I = {
    droppables: g,
    draggables: o
  }, s = XI(t.impact), a = s ? I.droppables[s] : null, d = I.draggables[t.critical.draggable.id], C = I.droppables[t.critical.droppable.id], u = Bee({
    draggable: d,
    home: C,
    draggables: o,
    viewport: t.viewport
  }), A = u.impact, m = u.afterCritical, h = a && a.isCombineEnabled ? t.impact : A, B = bee({
    pageOffset: t.current.page.offset,
    draggable: I.draggables[t.critical.draggable.id],
    draggables: I.draggables,
    droppables: I.droppables,
    previousImpact: h,
    viewport: t.viewport,
    afterCritical: m
  }), f = k({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: B,
    onLiftImpact: A,
    dimensions: I,
    afterCritical: m,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return f;
  var G = k({
    phase: "DROP_PENDING"
  }, f, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return G;
}, Hx = function(t) {
  return t.movementMode === "SNAP";
}, BF = function(t, i, n) {
  var g = mbt(t.dimensions, i);
  return !Hx(t) || n ? wB({
    state: t,
    dimensions: g
  }) : pee({
    state: t,
    dimensions: g
  });
};
function ZF(e) {
  return e.isDragging && e.movementMode === "SNAP" ? k({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var BU = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, fbt = function(e, t) {
  if (e === void 0 && (e = BU), t.type === "FLUSH")
    return k({}, BU, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && pt();
    var i = t.payload, n = i.critical, g = i.clientSelection, r = i.viewport, o = i.dimensions, I = i.movementMode, s = o.draggables[n.draggable.id], a = o.droppables[n.droppable.id], d = {
      selection: g,
      borderBoxCenter: s.client.borderBox.center,
      offset: ur
    }, C = {
      client: d,
      page: {
        selection: Nr(d.selection, r.scroll.initial),
        borderBoxCenter: Nr(d.selection, r.scroll.initial),
        offset: Nr(d.selection, r.scroll.diff.value)
      }
    }, u = Z2(o.droppables).every(function(rt) {
      return !rt.isFixedOnPage;
    }), A = Bee({
      draggable: s,
      home: a,
      draggables: o.draggables,
      viewport: r
    }), m = A.impact, h = A.afterCritical, B = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: I,
      dimensions: o,
      initial: C,
      current: C,
      isWindowScrollAllowed: u,
      impact: m,
      afterCritical: h,
      onLiftImpact: m,
      viewport: r,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return B;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && pt();
    var f = k({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return f;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || pt(), Zbt({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    du(e) || pt();
    var G = t.payload.client;
    return Rd(G, e.current.client.selection) ? e : wB({
      state: e,
      clientSelection: G,
      impact: Hx(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return ZF(e);
    du(e) || pt();
    var y = t.payload, W = y.id, V = y.newScroll, w = e.dimensions.droppables[W];
    if (!w)
      return e;
    var v = KK(w, V);
    return BF(e, v, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    du(e) || pt();
    var H = t.payload, x = H.id, N = H.isEnabled, M = e.dimensions.droppables[x];
    M || pt(), M.isEnabled === N && pt();
    var $ = k({}, M, {
      isEnabled: N
    });
    return BF(e, $, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    du(e) || pt();
    var q = t.payload, E = q.id, L = q.isCombineEnabled, P = e.dimensions.droppables[E];
    P || pt(), P.isCombineEnabled === L && pt();
    var Q = k({}, P, {
      isCombineEnabled: L
    });
    return BF(e, Q, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    du(e) || pt(), e.isWindowScrollAllowed || pt();
    var te = t.payload.newScroll;
    if (Rd(e.viewport.scroll.current, te))
      return ZF(e);
    var le = see(e.viewport, te);
    return Hx(e) ? pee({
      state: e,
      viewport: le
    }) : wB({
      state: e,
      viewport: le
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!du(e))
      return e;
    var Ae = t.payload.maxScroll;
    if (Rd(Ae, e.viewport.scroll.max))
      return e;
    var we = k({}, e.viewport, {
      scroll: k({}, e.viewport.scroll, {
        max: Ae
      })
    });
    return k({
      phase: "DRAGGING"
    }, e, {
      viewport: we
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && pt();
    var Ee = gbt({
      state: e,
      type: t.type
    });
    return Ee ? wB({
      state: e,
      impact: Ee.impact,
      clientSelection: Ee.clientSelection,
      scrollJumpRequest: Ee.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var Je = t.payload.reason;
    e.phase !== "COLLECTING" && pt();
    var ve = k({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: Je
    });
    return ve;
  }
  if (t.type === "DROP_ANIMATE") {
    var Be = t.payload, ue = Be.completed, Xe = Be.dropDuration, Ze = Be.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || pt();
    var Ke = {
      phase: "DROP_ANIMATING",
      completed: ue,
      dropDuration: Xe,
      newHomeClientOffset: Ze,
      dimensions: e.dimensions
    };
    return Ke;
  }
  if (t.type === "DROP_COMPLETE") {
    var $e = t.payload.completed;
    return {
      phase: "IDLE",
      completed: $e,
      shouldFlush: !1
    };
  }
  return e;
}, Gbt = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, ybt = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, Wbt = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, Sbt = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, Vbt = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, wbt = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, vbt = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, Rbt = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, Zee = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, Xbt = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, Hbt = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, kbt = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, Fbt = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, Ybt = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, xbt = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, zK = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, Dbt = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, OK = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, fee = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, Jbt = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, Gee = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
}, Kbt = function(e) {
  return function(t) {
    var i = t.getState, n = t.dispatch;
    return function(g) {
      return function(r) {
        if (r.type !== "LIFT") {
          g(r);
          return;
        }
        var o = r.payload, I = o.id, s = o.clientSelection, a = o.movementMode, d = i();
        d.phase === "DROP_ANIMATING" && n(OK({
          completed: d.completed
        })), i().phase !== "IDLE" && pt(), n(zK()), n(Gbt({
          draggableId: I,
          movementMode: a
        }));
        var C = {
          shouldPublishImmediately: a === "SNAP"
        }, u = {
          draggableId: I,
          scrollOptions: C
        }, A = e.startPublishing(u), m = A.critical, h = A.dimensions, B = A.viewport;
        n(Wbt({
          critical: m,
          dimensions: h,
          clientSelection: s,
          movementMode: a,
          viewport: B
        }));
      };
    };
  };
}, Ebt = function(e) {
  return function() {
    return function(t) {
      return function(i) {
        i.type === "INITIAL_PUBLISH" && e.dragging(), i.type === "DROP_ANIMATE" && e.dropping(i.payload.completed.result.reason), (i.type === "FLUSH" || i.type === "DROP_COMPLETE") && e.resting(), t(i);
      };
    };
  };
}, QK = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, AZ = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, jK = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, ou = jK.outOfTheWay + "s " + QK.outOfTheWay, vB = {
  fluid: "opacity " + ou,
  snap: "transform " + ou + ", opacity " + ou,
  drop: function(t) {
    var i = t + "s " + QK.drop;
    return "transform " + i + ", opacity " + i;
  },
  outOfTheWay: "transform " + ou,
  placeholder: "height " + ou + ", width " + ou + ", margin " + ou
}, ZU = function(t) {
  return Rd(t, ur) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, kx = {
  moveTo: ZU,
  drop: function(t, i) {
    var n = ZU(t);
    return n ? i ? n + " scale(" + AZ.scale.drop + ")" : n : null;
  }
}, Fx = jK.minDropTime, yee = jK.maxDropTime, Nbt = yee - Fx, fU = 1500, Lbt = 0.6, Tbt = function(e) {
  var t = e.current, i = e.destination, n = e.reason, g = dZ(t, i);
  if (g <= 0)
    return Fx;
  if (g >= fU)
    return yee;
  var r = g / fU, o = Fx + Nbt * r, I = n === "CANCEL" ? o * Lbt : o;
  return Number(I.toFixed(2));
}, Mbt = function(e) {
  var t = e.impact, i = e.draggable, n = e.dimensions, g = e.viewport, r = e.afterCritical, o = n.draggables, I = n.droppables, s = XI(t), a = s ? I[s] : null, d = I[i.descriptor.droppableId], C = hee({
    impact: t,
    draggable: i,
    draggables: o,
    afterCritical: r,
    droppable: a || d,
    viewport: g
  }), u = SI(C, i.client.borderBox.center);
  return u;
}, Ubt = function(e) {
  var t = e.draggables, i = e.reason, n = e.lastImpact, g = e.home, r = e.viewport, o = e.onLiftImpact;
  if (!n.at || i !== "DROP") {
    var I = mee({
      draggables: t,
      impact: o,
      destination: g,
      viewport: r,
      forceShouldAnimate: !0
    });
    return {
      impact: I,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var s = k({}, n, {
    displaced: CZ
  });
  return {
    impact: s,
    didDropInsideDroppable: !0
  };
}, Pbt = function(e) {
  var t = e.getState, i = e.dispatch;
  return function(n) {
    return function(g) {
      if (g.type !== "DROP") {
        n(g);
        return;
      }
      var r = t(), o = g.payload.reason;
      if (r.phase === "COLLECTING") {
        i(Jbt({
          reason: o
        }));
        return;
      }
      if (r.phase !== "IDLE") {
        var I = r.phase === "DROP_PENDING" && r.isWaiting;
        I && pt(), r.phase === "DRAGGING" || r.phase === "DROP_PENDING" || pt();
        var s = r.critical, a = r.dimensions, d = a.draggables[r.critical.draggable.id], C = Ubt({
          reason: o,
          lastImpact: r.impact,
          afterCritical: r.afterCritical,
          onLiftImpact: r.onLiftImpact,
          home: r.dimensions.droppables[r.critical.droppable.id],
          viewport: r.viewport,
          draggables: r.dimensions.draggables
        }), u = C.impact, A = C.didDropInsideDroppable, m = A ? NK(u) : null, h = A ? f2(u) : null, B = {
          index: s.draggable.index,
          droppableId: s.droppable.id
        }, f = {
          draggableId: d.descriptor.id,
          type: d.descriptor.type,
          source: B,
          reason: o,
          mode: r.movementMode,
          destination: m,
          combine: h
        }, G = Mbt({
          impact: u,
          draggable: d,
          dimensions: a,
          viewport: r.viewport,
          afterCritical: r.afterCritical
        }), y = {
          critical: r.critical,
          afterCritical: r.afterCritical,
          result: f,
          impact: u
        }, W = !Rd(r.current.client.offset, G) || !!f.combine;
        if (!W) {
          i(OK({
            completed: y
          }));
          return;
        }
        var V = Tbt({
          current: r.current.client.offset,
          destination: G,
          reason: o
        }), w = {
          newHomeClientOffset: G,
          dropDuration: V,
          completed: y
        };
        i(Dbt(w));
      }
    };
  };
}, Wee = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function zbt(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(i) {
      i.target !== window && i.target !== window.document || e();
    }
  };
}
function Obt(e) {
  var t = e.onWindowScroll;
  function i() {
    t(Wee());
  }
  var n = cZ(i), g = zbt(n), r = vd;
  function o() {
    return r !== vd;
  }
  function I() {
    o() && pt(), r = Al(window, [g]);
  }
  function s() {
    o() || pt(), n.cancel(), r(), r = vd;
  }
  return {
    start: I,
    stop: s,
    isActive: o
  };
}
var Qbt = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, jbt = function(e) {
  var t = Obt({
    onWindowScroll: function(n) {
      e.dispatch(Xbt({
        newScroll: n
      }));
    }
  });
  return function(i) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && Qbt(n) && t.stop(), i(n);
    };
  };
}, _bt = function(e) {
  var t = !1, i = !1, n = setTimeout(function() {
    i = !0;
  }), g = function(o) {
    t || i || (t = !0, e(o), clearTimeout(n));
  };
  return g.wasCalled = function() {
    return t;
  }, g;
}, $bt = function() {
  var e = [], t = function(r) {
    var o = EK(e, function(a) {
      return a.timerId === r;
    });
    o === -1 && pt();
    var I = e.splice(o, 1), s = I[0];
    s.callback();
  }, i = function(r) {
    var o = setTimeout(function() {
      return t(o);
    }), I = {
      timerId: o,
      callback: r
    };
    e.push(I);
  }, n = function() {
    if (e.length) {
      var r = [].concat(e);
      e.length = 0, r.forEach(function(o) {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
  return {
    add: i,
    flush: n
  };
}, qbt = function(t, i) {
  return t == null && i == null ? !0 : t == null || i == null ? !1 : t.droppableId === i.droppableId && t.index === i.index;
}, emt = function(t, i) {
  return t == null && i == null ? !0 : t == null || i == null ? !1 : t.draggableId === i.draggableId && t.droppableId === i.droppableId;
}, tmt = function(t, i) {
  if (t === i)
    return !0;
  var n = t.draggable.id === i.draggable.id && t.draggable.droppableId === i.draggable.droppableId && t.draggable.type === i.draggable.type && t.draggable.index === i.draggable.index, g = t.droppable.id === i.droppable.id && t.droppable.type === i.droppable.type;
  return n && g;
}, x0 = function(t, i) {
  i();
}, JW = function(t, i) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: i
  };
}, fF = function(t, i, n, g) {
  if (!t) {
    n(g(i));
    return;
  }
  var r = _bt(n), o = {
    announce: r
  };
  t(i, o), r.wasCalled() || n(g(i));
}, imt = function(e, t) {
  var i = $bt(), n = null, g = function(u, A) {
    n && pt(), x0("onBeforeCapture", function() {
      var m = e().onBeforeCapture;
      if (m) {
        var h = {
          draggableId: u,
          mode: A
        };
        m(h);
      }
    });
  }, r = function(u, A) {
    n && pt(), x0("onBeforeDragStart", function() {
      var m = e().onBeforeDragStart;
      m && m(JW(u, A));
    });
  }, o = function(u, A) {
    n && pt();
    var m = JW(u, A);
    n = {
      mode: A,
      lastCritical: u,
      lastLocation: m.source,
      lastCombine: null
    }, i.add(function() {
      x0("onDragStart", function() {
        return fF(e().onDragStart, m, t, pS.onDragStart);
      });
    });
  }, I = function(u, A) {
    var m = NK(A), h = f2(A);
    n || pt();
    var B = !tmt(u, n.lastCritical);
    B && (n.lastCritical = u);
    var f = !qbt(n.lastLocation, m);
    f && (n.lastLocation = m);
    var G = !emt(n.lastCombine, h);
    if (G && (n.lastCombine = h), !(!B && !f && !G)) {
      var y = k({}, JW(u, n.mode), {
        combine: h,
        destination: m
      });
      i.add(function() {
        x0("onDragUpdate", function() {
          return fF(e().onDragUpdate, y, t, pS.onDragUpdate);
        });
      });
    }
  }, s = function() {
    n || pt(), i.flush();
  }, a = function(u) {
    n || pt(), n = null, x0("onDragEnd", function() {
      return fF(e().onDragEnd, u, t, pS.onDragEnd);
    });
  }, d = function() {
    if (n) {
      var u = k({}, JW(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      a(u);
    }
  };
  return {
    beforeCapture: g,
    beforeStart: r,
    start: o,
    update: I,
    flush: s,
    drop: a,
    abort: d
  };
}, nmt = function(e, t) {
  var i = imt(e, t);
  return function(n) {
    return function(g) {
      return function(r) {
        if (r.type === "BEFORE_INITIAL_CAPTURE") {
          i.beforeCapture(r.payload.draggableId, r.payload.movementMode);
          return;
        }
        if (r.type === "INITIAL_PUBLISH") {
          var o = r.payload.critical;
          i.beforeStart(o, r.payload.movementMode), g(r), i.start(o, r.payload.movementMode);
          return;
        }
        if (r.type === "DROP_COMPLETE") {
          var I = r.payload.completed.result;
          i.flush(), g(r), i.drop(I);
          return;
        }
        if (g(r), r.type === "FLUSH") {
          i.abort();
          return;
        }
        var s = n.getState();
        s.phase === "DRAGGING" && i.update(s.critical, s.impact);
      };
    };
  };
}, gmt = function(e) {
  return function(t) {
    return function(i) {
      if (i.type !== "DROP_ANIMATION_FINISHED") {
        t(i);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && pt(), e.dispatch(OK({
        completed: n.completed
      }));
    };
  };
}, rmt = function(e) {
  var t = null, i = null;
  function n() {
    i && (cancelAnimationFrame(i), i = null), t && (t(), t = null);
  }
  return function(g) {
    return function(r) {
      if ((r.type === "FLUSH" || r.type === "DROP_COMPLETE" || r.type === "DROP_ANIMATION_FINISHED") && n(), g(r), r.type === "DROP_ANIMATE") {
        var o = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var s = e.getState();
            s.phase === "DROP_ANIMATING" && e.dispatch(Gee());
          }
        };
        i = requestAnimationFrame(function() {
          i = null, t = Al(window, [o]);
        });
      }
    };
  };
}, omt = function(e) {
  return function() {
    return function(t) {
      return function(i) {
        (i.type === "DROP_COMPLETE" || i.type === "FLUSH" || i.type === "DROP_ANIMATE") && e.stopPublishing(), t(i);
      };
    };
  };
}, Imt = function(e) {
  var t = !1;
  return function() {
    return function(i) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), i(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (i(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var g = n.payload.completed.result;
            g.combine && e.tryShiftRecord(g.draggableId, g.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, lmt = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, smt = function(e) {
  return function(t) {
    return function(i) {
      return function(n) {
        if (lmt(n)) {
          e.stop(), i(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          i(n);
          var g = t.getState();
          g.phase !== "DRAGGING" && pt(), e.start(g);
          return;
        }
        i(n), e.scroll(t.getState());
      };
    };
  };
}, amt = function(e) {
  return function(t) {
    return function(i) {
      if (t(i), i.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(fee({
          reason: n.reason
        })));
      }
    };
  };
}, cmt = Yq, dmt = function(e) {
  var t = e.dimensionMarshal, i = e.focusMarshal, n = e.styleMarshal, g = e.getResponders, r = e.announce, o = e.autoScroller;
  return Fq(fbt, cmt(uut(Ebt(n), omt(t), Kbt(t), Pbt, gmt, rmt, amt, smt(o), jbt, Imt(i), nmt(g, r))));
}, GF = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function Cmt(e) {
  var t = e.registry, i = e.callbacks, n = GF(), g = null, r = function() {
    g || (i.collectionStarting(), g = requestAnimationFrame(function() {
      g = null;
      var d = n, C = d.additions, u = d.removals, A = d.modified, m = Object.keys(C).map(function(f) {
        return t.draggable.getById(f).getDimension(ur);
      }).sort(function(f, G) {
        return f.descriptor.index - G.descriptor.index;
      }), h = Object.keys(A).map(function(f) {
        var G = t.droppable.getById(f), y = G.callbacks.getScrollWhileDragging();
        return {
          droppableId: f,
          scroll: y
        };
      }), B = {
        additions: m,
        removals: Object.keys(u),
        modified: h
      };
      n = GF(), i.publish(B);
    }));
  }, o = function(d) {
    var C = d.descriptor.id;
    n.additions[C] = d, n.modified[d.descriptor.droppableId] = !0, n.removals[C] && delete n.removals[C], r();
  }, I = function(d) {
    var C = d.descriptor;
    n.removals[C.id] = !0, n.modified[C.droppableId] = !0, n.additions[C.id] && delete n.additions[C.id], r();
  }, s = function() {
    g && (cancelAnimationFrame(g), g = null, n = GF());
  };
  return {
    add: o,
    remove: I,
    stop: s
  };
}
var See = function(e) {
  var t = e.scrollHeight, i = e.scrollWidth, n = e.height, g = e.width, r = SI({
    x: i,
    y: t
  }, {
    x: g,
    y: n
  }), o = {
    x: Math.max(0, r.x),
    y: Math.max(0, r.y)
  };
  return o;
}, Vee = function() {
  var e = document.documentElement;
  return e || pt(), e;
}, wee = function() {
  var e = Vee(), t = See({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, umt = function() {
  var e = Wee(), t = wee(), i = e.y, n = e.x, g = Vee(), r = g.clientWidth, o = g.clientHeight, I = n + r, s = i + o, a = cs({
    top: i,
    left: n,
    right: I,
    bottom: s
  }), d = {
    frame: a,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: ur,
        displacement: ur
      }
    }
  };
  return d;
}, Amt = function(e) {
  var t = e.critical, i = e.scrollOptions, n = e.registry, g = umt(), r = g.scroll.current, o = t.droppable, I = n.droppable.getAllByType(o.type).map(function(C) {
    return C.callbacks.getDimensionAndWatchScroll(r, i);
  }), s = n.draggable.getAllByType(t.draggable.type).map(function(C) {
    return C.getDimension(r);
  }), a = {
    draggables: nee(s),
    droppables: iee(I)
  }, d = {
    dimensions: a,
    critical: t,
    viewport: g
  };
  return d;
};
function GU(e, t, i) {
  if (i.descriptor.id === t.id || i.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(i.descriptor.droppableId);
  return n.descriptor.mode === "virtual";
}
var bmt = function(e, t) {
  var i = null, n = Cmt({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), g = function(A, m) {
    e.droppable.exists(A) || pt(), i && t.updateDroppableIsEnabled({
      id: A,
      isEnabled: m
    });
  }, r = function(A, m) {
    i && (e.droppable.exists(A) || pt(), t.updateDroppableIsCombineEnabled({
      id: A,
      isCombineEnabled: m
    }));
  }, o = function(A, m) {
    i && (e.droppable.exists(A) || pt(), t.updateDroppableScroll({
      id: A,
      newScroll: m
    }));
  }, I = function(A, m) {
    i && e.droppable.getById(A).callbacks.scroll(m);
  }, s = function() {
    if (i) {
      n.stop();
      var A = i.critical.droppable;
      e.droppable.getAllByType(A.type).forEach(function(m) {
        return m.callbacks.dragStopped();
      }), i.unsubscribe(), i = null;
    }
  }, a = function(A) {
    i || pt();
    var m = i.critical.draggable;
    A.type === "ADDITION" && GU(e, m, A.value) && n.add(A.value), A.type === "REMOVAL" && GU(e, m, A.value) && n.remove(A.value);
  }, d = function(A) {
    i && pt();
    var m = e.draggable.getById(A.draggableId), h = e.droppable.getById(m.descriptor.droppableId), B = {
      draggable: m.descriptor,
      droppable: h.descriptor
    }, f = e.subscribe(a);
    return i = {
      critical: B,
      unsubscribe: f
    }, Amt({
      critical: B,
      registry: e,
      scrollOptions: A.scrollOptions
    });
  }, C = {
    updateDroppableIsEnabled: g,
    updateDroppableIsCombineEnabled: r,
    scrollDroppable: I,
    updateDroppableScroll: o,
    startPublishing: d,
    stopPublishing: s
  };
  return C;
}, vee = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, mmt = function(e) {
  window.scrollBy(e.x, e.y);
}, hmt = yg(function(e) {
  return Z2(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), pmt = function(t, i) {
  var n = lC(hmt(i), function(g) {
    return g.frame || pt(), Cee(g.frame.pageMarginBox)(t);
  });
  return n;
}, Bmt = function(e) {
  var t = e.center, i = e.destination, n = e.droppables;
  if (i) {
    var g = n[i];
    return g.frame ? g : null;
  }
  var r = pmt(t, n);
  return r;
}, Xd = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, Zmt = function(e, t) {
  var i = e[t.size] * Xd.startFromPercentage, n = e[t.size] * Xd.maxScrollAtPercentage, g = {
    startScrollingFrom: i,
    maxScrollValueAt: n
  };
  return g;
}, Ree = function(e) {
  var t = e.startOfRange, i = e.endOfRange, n = e.current, g = i - t;
  if (g === 0)
    return 0;
  var r = n - t, o = r / g;
  return o;
}, _K = 1, fmt = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return Xd.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return _K;
  var i = Ree({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - i, g = Xd.maxPixelScroll * Xd.ease(n);
  return Math.ceil(g);
}, yU = Xd.durationDampening.accelerateAt, WU = Xd.durationDampening.stopDampeningAt, Gmt = function(e, t) {
  var i = t, n = WU, g = Date.now(), r = g - i;
  if (r >= WU)
    return e;
  if (r < yU)
    return _K;
  var o = Ree({
    startOfRange: yU,
    endOfRange: n,
    current: r
  }), I = e * Xd.ease(o);
  return Math.ceil(I);
}, SU = function(e) {
  var t = e.distanceToEdge, i = e.thresholds, n = e.dragStartTime, g = e.shouldUseTimeDampening, r = fmt(t, i);
  return r === 0 ? 0 : g ? Math.max(Gmt(r, n), _K) : r;
}, VU = function(e) {
  var t = e.container, i = e.distanceToEdges, n = e.dragStartTime, g = e.axis, r = e.shouldUseTimeDampening, o = Zmt(t, g), I = i[g.end] < i[g.start];
  return I ? SU({
    distanceToEdge: i[g.end],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: r
  }) : -1 * SU({
    distanceToEdge: i[g.start],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: r
  });
}, ymt = function(e) {
  var t = e.container, i = e.subject, n = e.proposedScroll, g = i.height > t.height, r = i.width > t.width;
  return !r && !g ? n : r && g ? null : {
    x: r ? 0 : n.x,
    y: g ? 0 : n.y
  };
}, Wmt = eee(function(e) {
  return e === 0 ? 0 : e;
}), Xee = function(e) {
  var t = e.dragStartTime, i = e.container, n = e.subject, g = e.center, r = e.shouldUseTimeDampening, o = {
    top: g.y - i.top,
    right: i.right - g.x,
    bottom: i.bottom - g.y,
    left: g.x - i.left
  }, I = VU({
    container: i,
    distanceToEdges: o,
    dragStartTime: t,
    axis: LK,
    shouldUseTimeDampening: r
  }), s = VU({
    container: i,
    distanceToEdges: o,
    dragStartTime: t,
    axis: oee,
    shouldUseTimeDampening: r
  }), a = Wmt({
    x: s,
    y: I
  });
  if (Rd(a, ur))
    return null;
  var d = ymt({
    container: i,
    subject: n,
    proposedScroll: a
  });
  return d ? Rd(d, ur) ? null : d : null;
}, Smt = eee(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), $K = /* @__PURE__ */ function() {
  var e = function(i, n) {
    return i < 0 ? i : i > n ? i - n : 0;
  };
  return function(t) {
    var i = t.current, n = t.max, g = t.change, r = Nr(i, g), o = {
      x: e(r.x, n.x),
      y: e(r.y, n.y)
    };
    return Rd(o, ur) ? null : o;
  };
}(), Hee = function(t) {
  var i = t.max, n = t.current, g = t.change, r = {
    x: Math.max(n.x, i.x),
    y: Math.max(n.y, i.y)
  }, o = Smt(g), I = $K({
    max: r,
    current: n,
    change: o
  });
  return !I || o.x !== 0 && I.x === 0 || o.y !== 0 && I.y === 0;
}, qK = function(t, i) {
  return Hee({
    current: t.scroll.current,
    max: t.scroll.max,
    change: i
  });
}, Vmt = function(t, i) {
  if (!qK(t, i))
    return null;
  var n = t.scroll.max, g = t.scroll.current;
  return $K({
    current: g,
    max: n,
    change: i
  });
}, eE = function(t, i) {
  var n = t.frame;
  return n ? Hee({
    current: n.scroll.current,
    max: n.scroll.max,
    change: i
  }) : !1;
}, wmt = function(t, i) {
  var n = t.frame;
  return !n || !eE(t, i) ? null : $K({
    current: n.scroll.current,
    max: n.scroll.max,
    change: i
  });
}, vmt = function(e) {
  var t = e.viewport, i = e.subject, n = e.center, g = e.dragStartTime, r = e.shouldUseTimeDampening, o = Xee({
    dragStartTime: g,
    container: t.frame,
    subject: i,
    center: n,
    shouldUseTimeDampening: r
  });
  return o && qK(t, o) ? o : null;
}, Rmt = function(e) {
  var t = e.droppable, i = e.subject, n = e.center, g = e.dragStartTime, r = e.shouldUseTimeDampening, o = t.frame;
  if (!o)
    return null;
  var I = Xee({
    dragStartTime: g,
    container: o.pageMarginBox,
    subject: i,
    center: n,
    shouldUseTimeDampening: r
  });
  return I && eE(t, I) ? I : null;
}, wU = function(e) {
  var t = e.state, i = e.dragStartTime, n = e.shouldUseTimeDampening, g = e.scrollWindow, r = e.scrollDroppable, o = t.current.page.borderBoxCenter, I = t.dimensions.draggables[t.critical.draggable.id], s = I.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var a = t.viewport, d = vmt({
      dragStartTime: i,
      viewport: a,
      subject: s,
      center: o,
      shouldUseTimeDampening: n
    });
    if (d) {
      g(d);
      return;
    }
  }
  var C = Bmt({
    center: o,
    destination: XI(t.impact),
    droppables: t.dimensions.droppables
  });
  if (C) {
    var u = Rmt({
      dragStartTime: i,
      droppable: C,
      subject: s,
      center: o,
      shouldUseTimeDampening: n
    });
    u && r(C.descriptor.id, u);
  }
}, Xmt = function(e) {
  var t = e.scrollWindow, i = e.scrollDroppable, n = cZ(t), g = cZ(i), r = null, o = function(d) {
    r || pt();
    var C = r, u = C.shouldUseTimeDampening, A = C.dragStartTime;
    wU({
      state: d,
      scrollWindow: n,
      scrollDroppable: g,
      dragStartTime: A,
      shouldUseTimeDampening: u
    });
  }, I = function(d) {
    r && pt();
    var C = Date.now(), u = !1, A = function() {
      u = !0;
    };
    wU({
      state: d,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: A,
      scrollDroppable: A
    }), r = {
      dragStartTime: C,
      shouldUseTimeDampening: u
    }, u && o(d);
  }, s = function() {
    r && (n.cancel(), g.cancel(), r = null);
  };
  return {
    start: I,
    stop: s,
    scroll: o
  };
}, Hmt = function(e) {
  var t = e.move, i = e.scrollDroppable, n = e.scrollWindow, g = function(a, d) {
    var C = Nr(a.current.client.selection, d);
    t({
      client: C
    });
  }, r = function(a, d) {
    if (!eE(a, d))
      return d;
    var C = wmt(a, d);
    if (!C)
      return i(a.descriptor.id, d), null;
    var u = SI(d, C);
    i(a.descriptor.id, u);
    var A = SI(d, u);
    return A;
  }, o = function(a, d, C) {
    if (!a || !qK(d, C))
      return C;
    var u = Vmt(d, C);
    if (!u)
      return n(C), null;
    var A = SI(C, u);
    n(A);
    var m = SI(C, A);
    return m;
  }, I = function(a) {
    var d = a.scrollJumpRequest;
    if (d) {
      var C = XI(a.impact);
      C || pt();
      var u = r(a.dimensions.droppables[C], d);
      if (u) {
        var A = a.viewport, m = o(a.isWindowScrollAllowed, A, u);
        m && g(a, m);
      }
    }
  };
  return I;
}, kmt = function(e) {
  var t = e.scrollDroppable, i = e.scrollWindow, n = e.move, g = Xmt({
    scrollWindow: i,
    scrollDroppable: t
  }), r = Hmt({
    move: n,
    scrollWindow: i,
    scrollDroppable: t
  }), o = function(a) {
    if (a.phase === "DRAGGING") {
      if (a.movementMode === "FLUID") {
        g.scroll(a);
        return;
      }
      a.scrollJumpRequest && r(a);
    }
  }, I = {
    scroll: o,
    start: g.start,
    stop: g.stop
  };
  return I;
}, Tm = "data-rbd", Mm = function() {
  var e = Tm + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), Yx = function() {
  var e = Tm + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), Fmt = function() {
  var e = Tm + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), vU = {
  contextId: Tm + "-scroll-container-context-id"
}, Ymt = function(t) {
  return function(i) {
    return "[" + i + '="' + t + '"]';
  };
}, D0 = function(t, i) {
  return t.map(function(n) {
    var g = n.styles[i];
    return g ? n.selector + " { " + g + " }" : "";
  }).join(" ");
}, xmt = "pointer-events: none;", Dmt = function(e) {
  var t = Ymt(e), i = function() {
    var I = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(Mm.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: I,
        dragging: xmt,
        dropAnimating: I
      }
    };
  }(), n = function() {
    var I = `
      transition: ` + vB.outOfTheWay + `;
    `;
    return {
      selector: t(Yx.contextId),
      styles: {
        dragging: I,
        dropAnimating: I,
        userCancel: I
      }
    };
  }(), g = {
    selector: t(Fmt.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, r = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, o = [n, i, g, r];
  return {
    always: D0(o, "always"),
    resting: D0(o, "resting"),
    dragging: D0(o, "dragging"),
    dropAnimating: D0(o, "dropAnimating"),
    userCancel: D0(o, "userCancel")
  };
}, HI = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Um : et, yF = function() {
  var t = document.querySelector("head");
  return t || pt(), t;
}, RU = function(t) {
  var i = document.createElement("style");
  return t && i.setAttribute("nonce", t), i.type = "text/css", i;
};
function Jmt(e, t) {
  var i = Ei(function() {
    return Dmt(e);
  }, [e]), n = Ct(null), g = Ct(null), r = $t(yg(function(C) {
    var u = g.current;
    u || pt(), u.textContent = C;
  }), []), o = $t(function(C) {
    var u = n.current;
    u || pt(), u.textContent = C;
  }, []);
  HI(function() {
    !n.current && !g.current || pt();
    var C = RU(t), u = RU(t);
    return n.current = C, g.current = u, C.setAttribute(Tm + "-always", e), u.setAttribute(Tm + "-dynamic", e), yF().appendChild(C), yF().appendChild(u), o(i.always), r(i.resting), function() {
      var A = function(h) {
        var B = h.current;
        B || pt(), yF().removeChild(B), h.current = null;
      };
      A(n), A(g);
    };
  }, [t, o, r, i.always, i.resting, e]);
  var I = $t(function() {
    return r(i.dragging);
  }, [r, i.dragging]), s = $t(function(C) {
    if (C === "DROP") {
      r(i.dropAnimating);
      return;
    }
    r(i.userCancel);
  }, [r, i.dropAnimating, i.userCancel]), a = $t(function() {
    g.current && r(i.resting);
  }, [r, i.resting]), d = Ei(function() {
    return {
      dragging: I,
      dropping: s,
      resting: a
    };
  }, [I, s, a]);
  return d;
}
var kee = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function W2(e) {
  return e instanceof kee(e).HTMLElement;
}
function Kmt(e, t) {
  var i = "[" + Mm.contextId + '="' + e + '"]', n = tee(document.querySelectorAll(i));
  if (!n.length)
    return null;
  var g = lC(n, function(r) {
    return r.getAttribute(Mm.draggableId) === t;
  });
  return !g || !W2(g) ? null : g;
}
function Emt(e) {
  var t = Ct({}), i = Ct(null), n = Ct(null), g = Ct(!1), r = $t(function(u, A) {
    var m = {
      id: u,
      focus: A
    };
    return t.current[u] = m, function() {
      var B = t.current, f = B[u];
      f !== m && delete B[u];
    };
  }, []), o = $t(function(u) {
    var A = Kmt(e, u);
    A && A !== document.activeElement && A.focus();
  }, [e]), I = $t(function(u, A) {
    i.current === u && (i.current = A);
  }, []), s = $t(function() {
    n.current || g.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var u = i.current;
      u && o(u);
    }));
  }, [o]), a = $t(function(u) {
    i.current = null;
    var A = document.activeElement;
    A && A.getAttribute(Mm.draggableId) === u && (i.current = u);
  }, []);
  HI(function() {
    return g.current = !0, function() {
      g.current = !1;
      var u = n.current;
      u && cancelAnimationFrame(u);
    };
  }, []);
  var d = Ei(function() {
    return {
      register: r,
      tryRecordFocus: a,
      tryRestoreFocusRecorded: s,
      tryShiftRecord: I
    };
  }, [r, a, s, I]);
  return d;
}
function Nmt() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function i(C) {
    return t.push(C), function() {
      var A = t.indexOf(C);
      A !== -1 && t.splice(A, 1);
    };
  }
  function n(C) {
    t.length && t.forEach(function(u) {
      return u(C);
    });
  }
  function g(C) {
    return e.draggables[C] || null;
  }
  function r(C) {
    var u = g(C);
    return u || pt(), u;
  }
  var o = {
    register: function(u) {
      e.draggables[u.descriptor.id] = u, n({
        type: "ADDITION",
        value: u
      });
    },
    update: function(u, A) {
      var m = e.draggables[A.descriptor.id];
      m && m.uniqueId === u.uniqueId && (delete e.draggables[A.descriptor.id], e.draggables[u.descriptor.id] = u);
    },
    unregister: function(u) {
      var A = u.descriptor.id, m = g(A);
      m && u.uniqueId === m.uniqueId && (delete e.draggables[A], n({
        type: "REMOVAL",
        value: u
      }));
    },
    getById: r,
    findById: g,
    exists: function(u) {
      return !!g(u);
    },
    getAllByType: function(u) {
      return vV(e.draggables).filter(function(A) {
        return A.descriptor.type === u;
      });
    }
  };
  function I(C) {
    return e.droppables[C] || null;
  }
  function s(C) {
    var u = I(C);
    return u || pt(), u;
  }
  var a = {
    register: function(u) {
      e.droppables[u.descriptor.id] = u;
    },
    unregister: function(u) {
      var A = I(u.descriptor.id);
      A && u.uniqueId === A.uniqueId && delete e.droppables[u.descriptor.id];
    },
    getById: s,
    findById: I,
    exists: function(u) {
      return !!I(u);
    },
    getAllByType: function(u) {
      return vV(e.droppables).filter(function(A) {
        return A.descriptor.type === u;
      });
    }
  };
  function d() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: o,
    droppable: a,
    subscribe: i,
    clean: d
  };
}
function Lmt() {
  var e = Ei(Nmt, []);
  return et(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var tE = Se.createContext(null), XV = function() {
  var e = document.body;
  return e || pt(), e;
}, Tmt = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, Mmt = function(t) {
  return "rbd-announcement-" + t;
};
function Umt(e) {
  var t = Ei(function() {
    return Mmt(e);
  }, [e]), i = Ct(null);
  et(function() {
    var r = document.createElement("div");
    return i.current = r, r.id = t, r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true"), k(r.style, Tmt), XV().appendChild(r), function() {
      setTimeout(function() {
        var s = XV();
        s.contains(r) && s.removeChild(r), r === i.current && (i.current = null);
      });
    };
  }, [t]);
  var n = $t(function(g) {
    var r = i.current;
    if (r) {
      r.textContent = g;
      return;
    }
  }, []);
  return n;
}
var Pmt = 0, zmt = {
  separator: "::"
};
function iE(e, t) {
  return t === void 0 && (t = zmt), Ei(function() {
    return "" + e + t.separator + Pmt++;
  }, [t.separator, e]);
}
function Omt(e) {
  var t = e.contextId, i = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + i;
}
function Qmt(e) {
  var t = e.contextId, i = e.text, n = iE("hidden-text", {
    separator: "-"
  }), g = Ei(function() {
    return Omt({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return et(function() {
    var o = document.createElement("div");
    return o.id = g, o.textContent = i, o.style.display = "none", XV().appendChild(o), function() {
      var s = XV();
      s.contains(o) && s.removeChild(o);
    };
  }, [g, i]), g;
}
var S2 = Se.createContext(null);
function Fee(e) {
  var t = Ct(e);
  return et(function() {
    t.current = e;
  }), t;
}
function jmt() {
  var e = null;
  function t() {
    return !!e;
  }
  function i(o) {
    return o === e;
  }
  function n(o) {
    e && pt();
    var I = {
      abandon: o
    };
    return e = I, I;
  }
  function g() {
    e || pt(), e = null;
  }
  function r() {
    e && (e.abandon(), g());
  }
  return {
    isClaimed: t,
    isActive: i,
    claim: n,
    release: g,
    tryAbandon: r
  };
}
var _mt = 9, $mt = 13, nE = 27, Yee = 32, qmt = 33, eht = 34, tht = 35, iht = 36, nht = 37, ght = 38, rht = 39, oht = 40, KW, Iht = (KW = {}, KW[$mt] = !0, KW[_mt] = !0, KW), xee = function(e) {
  Iht[e.keyCode] && e.preventDefault();
}, V2 = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], i = lC(t, function(n) {
    return "on" + n in document;
  });
  return i || e;
}(), Dee = 0, XU = 5;
function lht(e, t) {
  return Math.abs(t.x - e.x) >= XU || Math.abs(t.y - e.y) >= XU;
}
var HU = {
  type: "IDLE"
};
function sht(e) {
  var t = e.cancel, i = e.completed, n = e.getPhase, g = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(o) {
      var I = o.button, s = o.clientX, a = o.clientY;
      if (I === Dee) {
        var d = {
          x: s,
          y: a
        }, C = n();
        if (C.type === "DRAGGING") {
          o.preventDefault(), C.actions.move(d);
          return;
        }
        C.type !== "PENDING" && pt();
        var u = C.point;
        if (lht(u, d)) {
          o.preventDefault();
          var A = C.actions.fluidLift(d);
          g({
            type: "DRAGGING",
            actions: A
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(o) {
      var I = n();
      if (I.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), I.actions.drop({
        shouldBlockNextClick: !0
      }), i();
    }
  }, {
    eventName: "mousedown",
    fn: function(o) {
      n().type === "DRAGGING" && o.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      var I = n();
      if (I.type === "PENDING") {
        t();
        return;
      }
      if (o.keyCode === nE) {
        o.preventDefault(), t();
        return;
      }
      xee(o);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(o) {
      var I = n();
      if (I.type === "IDLE" && pt(), I.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: V2,
    fn: t
  }];
}
function aht(e) {
  var t = Ct(HU), i = Ct(vd), n = Ei(function() {
    return {
      eventName: "mousedown",
      fn: function(C) {
        if (!C.defaultPrevented && C.button === Dee && !(C.ctrlKey || C.metaKey || C.shiftKey || C.altKey)) {
          var u = e.findClosestDraggableId(C);
          if (u) {
            var A = e.tryGetLock(u, o, {
              sourceEvent: C
            });
            if (A) {
              C.preventDefault();
              var m = {
                x: C.clientX,
                y: C.clientY
              };
              i.current(), a(A, m);
            }
          }
        }
      }
    };
  }, [e]), g = Ei(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(C) {
        if (!C.defaultPrevented) {
          var u = e.findClosestDraggableId(C);
          if (u) {
            var A = e.findOptionsForDraggable(u);
            A && (A.shouldRespectForcePress || e.canGetLock(u) && C.preventDefault());
          }
        }
      }
    };
  }, [e]), r = $t(function() {
    var C = {
      passive: !1,
      capture: !0
    };
    i.current = Al(window, [g, n], C);
  }, [g, n]), o = $t(function() {
    var d = t.current;
    d.type !== "IDLE" && (t.current = HU, i.current(), r());
  }, [r]), I = $t(function() {
    var d = t.current;
    o(), d.type === "DRAGGING" && d.actions.cancel({
      shouldBlockNextClick: !0
    }), d.type === "PENDING" && d.actions.abort();
  }, [o]), s = $t(function() {
    var C = {
      capture: !0,
      passive: !1
    }, u = sht({
      cancel: I,
      completed: o,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(m) {
        t.current = m;
      }
    });
    i.current = Al(window, u, C);
  }, [I, o]), a = $t(function(C, u) {
    t.current.type !== "IDLE" && pt(), t.current = {
      type: "PENDING",
      point: u,
      actions: C
    }, s();
  }, [s]);
  HI(function() {
    return r(), function() {
      i.current();
    };
  }, [r]);
}
var Ob;
function cht() {
}
var dht = (Ob = {}, Ob[eht] = !0, Ob[qmt] = !0, Ob[iht] = !0, Ob[tht] = !0, Ob);
function Cht(e, t) {
  function i() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(r) {
      if (r.keyCode === nE) {
        r.preventDefault(), i();
        return;
      }
      if (r.keyCode === Yee) {
        r.preventDefault(), n();
        return;
      }
      if (r.keyCode === oht) {
        r.preventDefault(), e.moveDown();
        return;
      }
      if (r.keyCode === ght) {
        r.preventDefault(), e.moveUp();
        return;
      }
      if (r.keyCode === rht) {
        r.preventDefault(), e.moveRight();
        return;
      }
      if (r.keyCode === nht) {
        r.preventDefault(), e.moveLeft();
        return;
      }
      if (dht[r.keyCode]) {
        r.preventDefault();
        return;
      }
      xee(r);
    }
  }, {
    eventName: "mousedown",
    fn: i
  }, {
    eventName: "mouseup",
    fn: i
  }, {
    eventName: "click",
    fn: i
  }, {
    eventName: "touchstart",
    fn: i
  }, {
    eventName: "resize",
    fn: i
  }, {
    eventName: "wheel",
    fn: i,
    options: {
      passive: !0
    }
  }, {
    eventName: V2,
    fn: i
  }];
}
function uht(e) {
  var t = Ct(cht), i = Ei(function() {
    return {
      eventName: "keydown",
      fn: function(r) {
        if (r.defaultPrevented || r.keyCode !== Yee)
          return;
        var o = e.findClosestDraggableId(r);
        if (!o)
          return;
        var I = e.tryGetLock(o, d, {
          sourceEvent: r
        });
        if (!I)
          return;
        r.preventDefault();
        var s = !0, a = I.snapLift();
        t.current();
        function d() {
          s || pt(), s = !1, t.current(), n();
        }
        t.current = Al(window, Cht(a, d), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = $t(function() {
    var r = {
      passive: !1,
      capture: !0
    };
    t.current = Al(window, [i], r);
  }, [i]);
  HI(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var WF = {
  type: "IDLE"
}, Aht = 120, bht = 0.15;
function mht(e) {
  var t = e.cancel, i = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(g) {
      g.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(g) {
      if (i().type !== "DRAGGING") {
        t();
        return;
      }
      g.keyCode === nE && g.preventDefault(), t();
    }
  }, {
    eventName: V2,
    fn: t
  }];
}
function hht(e) {
  var t = e.cancel, i = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(r) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      o.hasMoved = !0;
      var I = r.touches[0], s = I.clientX, a = I.clientY, d = {
        x: s,
        y: a
      };
      r.preventDefault(), o.actions.move(d);
    }
  }, {
    eventName: "touchend",
    fn: function(r) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      r.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), i();
    }
  }, {
    eventName: "touchcancel",
    fn: function(r) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      r.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(r) {
      var o = n();
      o.type === "IDLE" && pt();
      var I = r.touches[0];
      if (I) {
        var s = I.force >= bht;
        if (s) {
          var a = o.actions.shouldRespectForcePress();
          if (o.type === "PENDING") {
            a && t();
            return;
          }
          if (a) {
            if (o.hasMoved) {
              r.preventDefault();
              return;
            }
            t();
            return;
          }
          r.preventDefault();
        }
      }
    }
  }, {
    eventName: V2,
    fn: t
  }];
}
function pht(e) {
  var t = Ct(WF), i = Ct(vd), n = $t(function() {
    return t.current;
  }, []), g = $t(function(A) {
    t.current = A;
  }, []), r = Ei(function() {
    return {
      eventName: "touchstart",
      fn: function(A) {
        if (!A.defaultPrevented) {
          var m = e.findClosestDraggableId(A);
          if (m) {
            var h = e.tryGetLock(m, I, {
              sourceEvent: A
            });
            if (h) {
              var B = A.touches[0], f = B.clientX, G = B.clientY, y = {
                x: f,
                y: G
              };
              i.current(), C(h, y);
            }
          }
        }
      }
    };
  }, [e]), o = $t(function() {
    var A = {
      capture: !0,
      passive: !1
    };
    i.current = Al(window, [r], A);
  }, [r]), I = $t(function() {
    var u = t.current;
    u.type !== "IDLE" && (u.type === "PENDING" && clearTimeout(u.longPressTimerId), g(WF), i.current(), o());
  }, [o, g]), s = $t(function() {
    var u = t.current;
    I(), u.type === "DRAGGING" && u.actions.cancel({
      shouldBlockNextClick: !0
    }), u.type === "PENDING" && u.actions.abort();
  }, [I]), a = $t(function() {
    var A = {
      capture: !0,
      passive: !1
    }, m = {
      cancel: s,
      completed: I,
      getPhase: n
    }, h = Al(window, hht(m), A), B = Al(window, mht(m), A);
    i.current = function() {
      h(), B();
    };
  }, [s, n, I]), d = $t(function() {
    var A = n();
    A.type !== "PENDING" && pt();
    var m = A.actions.fluidLift(A.point);
    g({
      type: "DRAGGING",
      actions: m,
      hasMoved: !1
    });
  }, [n, g]), C = $t(function(A, m) {
    n().type !== "IDLE" && pt();
    var h = setTimeout(d, Aht);
    g({
      type: "PENDING",
      point: m,
      actions: A,
      longPressTimerId: h
    }), a();
  }, [a, n, g, d]);
  HI(function() {
    return o(), function() {
      i.current();
      var m = n();
      m.type === "PENDING" && (clearTimeout(m.longPressTimerId), g(WF));
    };
  }, [n, o, g]), HI(function() {
    var A = Al(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return A;
  }, []);
}
var Bht = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function Jee(e, t) {
  if (t == null)
    return !1;
  var i = !!Bht[t.tagName.toLowerCase()];
  if (i)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : Jee(e, t.parentElement);
}
function Zht(e, t) {
  var i = t.target;
  return W2(i) ? Jee(e, i) : !1;
}
var fht = function(e) {
  return cs(e.getBoundingClientRect()).center;
};
function Ght(e) {
  return e instanceof kee(e).Element;
}
var yht = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], i = lC(t, function(n) {
    return n in Element.prototype;
  });
  return i || e;
}();
function Kee(e, t) {
  return e == null ? null : e[yht](t) ? e : Kee(e.parentElement, t);
}
function Wht(e, t) {
  return e.closest ? e.closest(t) : Kee(e, t);
}
function Sht(e) {
  return "[" + Mm.contextId + '="' + e + '"]';
}
function Vht(e, t) {
  var i = t.target;
  if (!Ght(i))
    return null;
  var n = Sht(e), g = Wht(i, n);
  return !g || !W2(g) ? null : g;
}
function wht(e, t) {
  var i = Vht(e, t);
  return i ? i.getAttribute(Mm.draggableId) : null;
}
function vht(e, t) {
  var i = "[" + Yx.contextId + '="' + e + '"]', n = tee(document.querySelectorAll(i)), g = lC(n, function(r) {
    return r.getAttribute(Yx.id) === t;
  });
  return !g || !W2(g) ? null : g;
}
function Rht(e) {
  e.preventDefault();
}
function EW(e) {
  var t = e.expected, i = e.phase, n = e.isLockActive;
  return e.shouldWarn, !(!n() || t !== i);
}
function Eee(e) {
  var t = e.lockAPI, i = e.store, n = e.registry, g = e.draggableId;
  if (t.isClaimed())
    return !1;
  var r = n.draggable.findById(g);
  return !(!r || !r.options.isEnabled || !vee(i.getState(), g));
}
function Xht(e) {
  var t = e.lockAPI, i = e.contextId, n = e.store, g = e.registry, r = e.draggableId, o = e.forceSensorStop, I = e.sourceEvent, s = Eee({
    lockAPI: t,
    store: n,
    registry: g,
    draggableId: r
  });
  if (!s)
    return null;
  var a = g.draggable.getById(r), d = vht(i, a.descriptor.id);
  if (!d || I && !a.options.canDragInteractiveElements && Zht(d, I))
    return null;
  var C = t.claim(o || vd), u = "PRE_DRAG";
  function A() {
    return a.options.shouldRespectForcePress;
  }
  function m() {
    return t.isActive(C);
  }
  function h(w, v) {
    EW({
      expected: w,
      phase: u,
      isLockActive: m,
      shouldWarn: !0
    }) && n.dispatch(v());
  }
  var B = h.bind(null, "DRAGGING");
  function f(w) {
    function v() {
      t.release(), u = "COMPLETED";
    }
    u !== "PRE_DRAG" && (v(), u !== "PRE_DRAG" && pt()), n.dispatch(ybt(w.liftActionArgs)), u = "DRAGGING";
    function H(x, N) {
      if (N === void 0 && (N = {
        shouldBlockNextClick: !1
      }), w.cleanup(), N.shouldBlockNextClick) {
        var M = Al(window, [{
          eventName: "click",
          fn: Rht,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(M);
      }
      v(), n.dispatch(fee({
        reason: x
      }));
    }
    return k({
      isActive: function() {
        return EW({
          expected: "DRAGGING",
          phase: u,
          isLockActive: m,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: A,
      drop: function(N) {
        return H("DROP", N);
      },
      cancel: function(N) {
        return H("CANCEL", N);
      }
    }, w.actions);
  }
  function G(w) {
    var v = cZ(function(x) {
      B(function() {
        return Zee({
          client: x
        });
      });
    }), H = f({
      liftActionArgs: {
        id: r,
        clientSelection: w,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return v.cancel();
      },
      actions: {
        move: v
      }
    });
    return k({}, H, {
      move: v
    });
  }
  function y() {
    var w = {
      moveUp: function() {
        return B(kbt);
      },
      moveRight: function() {
        return B(Ybt);
      },
      moveDown: function() {
        return B(Fbt);
      },
      moveLeft: function() {
        return B(xbt);
      }
    };
    return f({
      liftActionArgs: {
        id: r,
        clientSelection: fht(d),
        movementMode: "SNAP"
      },
      cleanup: vd,
      actions: w
    });
  }
  function W() {
    var w = EW({
      expected: "PRE_DRAG",
      phase: u,
      isLockActive: m,
      shouldWarn: !0
    });
    w && t.release();
  }
  var V = {
    isActive: function() {
      return EW({
        expected: "PRE_DRAG",
        phase: u,
        isLockActive: m,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: A,
    fluidLift: G,
    snapLift: y,
    abort: W
  };
  return V;
}
var Hht = [aht, uht, pht];
function kht(e) {
  var t = e.contextId, i = e.store, n = e.registry, g = e.customSensors, r = e.enableDefaultSensors, o = [].concat(r ? Hht : [], g || []), I = At(function() {
    return jmt();
  })[0], s = $t(function(G, y) {
    G.isDragging && !y.isDragging && I.tryAbandon();
  }, [I]);
  HI(function() {
    var G = i.getState(), y = i.subscribe(function() {
      var W = i.getState();
      s(G, W), G = W;
    });
    return y;
  }, [I, i, s]), HI(function() {
    return I.tryAbandon;
  }, [I.tryAbandon]);
  for (var a = $t(function(f) {
    return Eee({
      lockAPI: I,
      registry: n,
      store: i,
      draggableId: f
    });
  }, [I, n, i]), d = $t(function(f, G, y) {
    return Xht({
      lockAPI: I,
      registry: n,
      contextId: t,
      store: i,
      draggableId: f,
      forceSensorStop: G,
      sourceEvent: y && y.sourceEvent ? y.sourceEvent : null
    });
  }, [t, I, n, i]), C = $t(function(f) {
    return wht(t, f);
  }, [t]), u = $t(function(f) {
    var G = n.draggable.findById(f);
    return G ? G.options : null;
  }, [n.draggable]), A = $t(function() {
    I.isClaimed() && (I.tryAbandon(), i.getState().phase !== "IDLE" && i.dispatch(zK()));
  }, [I, i]), m = $t(I.isClaimed, [I]), h = Ei(function() {
    return {
      canGetLock: a,
      tryGetLock: d,
      findClosestDraggableId: C,
      findOptionsForDraggable: u,
      tryReleaseLock: A,
      isLockClaimed: m
    };
  }, [a, d, C, u, A, m]), B = 0; B < o.length; B++)
    o[B](h);
}
var Fht = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function J0(e) {
  return e.current || pt(), e.current;
}
function Yht(e) {
  var t = e.contextId, i = e.setCallbacks, n = e.sensors, g = e.nonce, r = e.dragHandleUsageInstructions, o = Ct(null), I = Fee(e), s = $t(function() {
    return Fht(I.current);
  }, [I]), a = Umt(t), d = Qmt({
    contextId: t,
    text: r
  }), C = Jmt(t, g), u = $t(function(x) {
    J0(o).dispatch(x);
  }, []), A = Ei(function() {
    return oU({
      publishWhileDragging: Sbt,
      updateDroppableScroll: wbt,
      updateDroppableIsEnabled: vbt,
      updateDroppableIsCombineEnabled: Rbt,
      collectionStarting: Vbt
    }, u);
  }, [u]), m = Lmt(), h = Ei(function() {
    return bmt(m, A);
  }, [m, A]), B = Ei(function() {
    return kmt(k({
      scrollWindow: mmt,
      scrollDroppable: h.scrollDroppable
    }, oU({
      move: Zee
    }, u)));
  }, [h.scrollDroppable, u]), f = Emt(t), G = Ei(function() {
    return dmt({
      announce: a,
      autoScroller: B,
      dimensionMarshal: h,
      focusMarshal: f,
      getResponders: s,
      styleMarshal: C
    });
  }, [a, B, h, f, s, C]);
  o.current = G;
  var y = $t(function() {
    var x = J0(o), N = x.getState();
    N.phase !== "IDLE" && x.dispatch(zK());
  }, []), W = $t(function() {
    var x = J0(o).getState();
    return x.isDragging || x.phase === "DROP_ANIMATING";
  }, []), V = Ei(function() {
    return {
      isDragging: W,
      tryAbort: y
    };
  }, [W, y]);
  i(V);
  var w = $t(function(x) {
    return vee(J0(o).getState(), x);
  }, []), v = $t(function() {
    return du(J0(o).getState());
  }, []), H = Ei(function() {
    return {
      marshal: h,
      focus: f,
      contextId: t,
      canLift: w,
      isMovementAllowed: v,
      dragHandleUsageInstructionsId: d,
      registry: m
    };
  }, [t, h, d, f, w, v, m]);
  return kht({
    contextId: t,
    store: G,
    registry: m,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), et(function() {
    return y;
  }, [y]), Se.createElement(S2.Provider, {
    value: H
  }, Se.createElement(put, {
    context: tE,
    store: G
  }, e.children));
}
var xht = 0;
function Dht() {
  return Ei(function() {
    return "" + xht++;
  }, []);
}
function gE(e) {
  var t = Dht(), i = e.dragHandleUsageInstructions || pS.dragHandleUsageInstructions;
  return Se.createElement(uAt, null, function(n) {
    return Se.createElement(Yht, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: i,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var Nee = function(t) {
  return function(i) {
    return t === i;
  };
}, Jht = Nee("scroll"), Kht = Nee("auto"), kU = function(t, i) {
  return i(t.overflowX) || i(t.overflowY);
}, Eht = function(t) {
  var i = window.getComputedStyle(t), n = {
    overflowX: i.overflowX,
    overflowY: i.overflowY
  };
  return kU(n, Jht) || kU(n, Kht);
}, Nht = function() {
  return !1;
}, Lht = function e(t) {
  return t == null ? null : t === document.body ? Nht() ? t : null : t === document.documentElement ? null : Eht(t) ? t : e(t.parentElement);
}, xx = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, Tht = function e(t) {
  if (!t)
    return !1;
  var i = window.getComputedStyle(t);
  return i.position === "fixed" ? !0 : e(t.parentElement);
}, Mht = function(e) {
  var t = Lht(e), i = Tht(e);
  return {
    closestScrollable: t,
    isFixedOnPage: i
  };
}, Uht = function(e) {
  var t = e.descriptor, i = e.isEnabled, n = e.isCombineEnabled, g = e.isFixedOnPage, r = e.direction, o = e.client, I = e.page, s = e.closest, a = function() {
    if (!s)
      return null;
    var A = s.scrollSize, m = s.client, h = See({
      scrollHeight: A.scrollHeight,
      scrollWidth: A.scrollWidth,
      height: m.paddingBox.height,
      width: m.paddingBox.width
    });
    return {
      pageMarginBox: s.page.marginBox,
      frameClient: m,
      scrollSize: A,
      shouldClipSubject: s.shouldClipSubject,
      scroll: {
        initial: s.scroll,
        current: s.scroll,
        max: h,
        diff: {
          value: ur,
          displacement: ur
        }
      }
    };
  }(), d = r === "vertical" ? LK : oee, C = Lm({
    page: I,
    withPlaceholder: null,
    axis: d,
    frame: a
  }), u = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: g,
    axis: d,
    isEnabled: i,
    client: o,
    page: I,
    frame: a,
    subject: C
  };
  return u;
}, Pht = function(t, i) {
  var n = jq(t);
  if (!i || t !== i)
    return n;
  var g = n.paddingBox.top - i.scrollTop, r = n.paddingBox.left - i.scrollLeft, o = g + i.scrollHeight, I = r + i.scrollWidth, s = {
    top: g,
    right: I,
    bottom: o,
    left: r
  }, a = DK(s, n.border), d = JK({
    borderBox: a,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return d;
}, zht = function(e) {
  var t = e.ref, i = e.descriptor, n = e.env, g = e.windowScroll, r = e.direction, o = e.isDropDisabled, I = e.isCombineEnabled, s = e.shouldClipSubject, a = n.closestScrollable, d = Pht(t, a), C = SV(d, g), u = function() {
    if (!a)
      return null;
    var m = jq(a), h = {
      scrollHeight: a.scrollHeight,
      scrollWidth: a.scrollWidth
    };
    return {
      client: m,
      page: SV(m, g),
      scroll: xx(a),
      scrollSize: h,
      shouldClipSubject: s
    };
  }(), A = Uht({
    descriptor: i,
    isEnabled: !o,
    isCombineEnabled: I,
    isFixedOnPage: n.isFixedOnPage,
    direction: r,
    client: d,
    page: C,
    closest: u
  });
  return A;
}, Oht = {
  passive: !1
}, Qht = {
  passive: !0
}, FU = function(e) {
  return e.shouldPublishImmediately ? Oht : Qht;
};
function HV(e) {
  var t = Hn(e);
  return t || pt(), t;
}
var NW = function(t) {
  return t && t.env.closestScrollable || null;
};
function jht(e) {
  var t = Ct(null), i = HV(S2), n = iE("droppable"), g = i.registry, r = i.marshal, o = Fee(e), I = Ei(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), s = Ct(I), a = Ei(function() {
    return yg(function(W, V) {
      t.current || pt();
      var w = {
        x: W,
        y: V
      };
      r.updateDroppableScroll(I.id, w);
    });
  }, [I.id, r]), d = $t(function() {
    var W = t.current;
    return !W || !W.env.closestScrollable ? ur : xx(W.env.closestScrollable);
  }, []), C = $t(function() {
    var W = d();
    a(W.x, W.y);
  }, [d, a]), u = Ei(function() {
    return cZ(C);
  }, [C]), A = $t(function() {
    var W = t.current, V = NW(W);
    W && V || pt();
    var w = W.scrollOptions;
    if (w.shouldPublishImmediately) {
      C();
      return;
    }
    u();
  }, [u, C]), m = $t(function(W, V) {
    t.current && pt();
    var w = o.current, v = w.getDroppableRef();
    v || pt();
    var H = Mht(v), x = {
      ref: v,
      descriptor: I,
      env: H,
      scrollOptions: V
    };
    t.current = x;
    var N = zht({
      ref: v,
      descriptor: I,
      env: H,
      windowScroll: W,
      direction: w.direction,
      isDropDisabled: w.isDropDisabled,
      isCombineEnabled: w.isCombineEnabled,
      shouldClipSubject: !w.ignoreContainerClipping
    }), M = H.closestScrollable;
    return M && (M.setAttribute(vU.contextId, i.contextId), M.addEventListener("scroll", A, FU(x.scrollOptions))), N;
  }, [i.contextId, I, A, o]), h = $t(function() {
    var W = t.current, V = NW(W);
    return W && V || pt(), xx(V);
  }, []), B = $t(function() {
    var W = t.current;
    W || pt();
    var V = NW(W);
    t.current = null, V && (u.cancel(), V.removeAttribute(vU.contextId), V.removeEventListener("scroll", A, FU(W.scrollOptions)));
  }, [A, u]), f = $t(function(W) {
    var V = t.current;
    V || pt();
    var w = NW(V);
    w || pt(), w.scrollTop += W.y, w.scrollLeft += W.x;
  }, []), G = Ei(function() {
    return {
      getDimensionAndWatchScroll: m,
      getScrollWhileDragging: h,
      dragStopped: B,
      scroll: f
    };
  }, [B, m, h, f]), y = Ei(function() {
    return {
      uniqueId: n,
      descriptor: I,
      callbacks: G
    };
  }, [G, I, n]);
  HI(function() {
    return s.current = y.descriptor, g.droppable.register(y), function() {
      t.current && B(), g.droppable.unregister(y);
    };
  }, [G, I, B, y, r, g.droppable]), HI(function() {
    t.current && r.updateDroppableIsEnabled(s.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, r]), HI(function() {
    t.current && r.updateDroppableIsCombineEnabled(s.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, r]);
}
function SF() {
}
var YU = {
  width: 0,
  height: 0,
  margin: BAt
}, _ht = function(t) {
  var i = t.isAnimatingOpenOnMount, n = t.placeholder, g = t.animate;
  return i || g === "close" ? YU : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, $ht = function(t) {
  var i = t.isAnimatingOpenOnMount, n = t.placeholder, g = t.animate, r = _ht({
    isAnimatingOpenOnMount: i,
    placeholder: n,
    animate: g
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: r.width,
    height: r.height,
    marginTop: r.margin.top,
    marginRight: r.margin.right,
    marginBottom: r.margin.bottom,
    marginLeft: r.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: g !== "none" ? vB.placeholder : null
  };
};
function qht(e) {
  var t = Ct(null), i = $t(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, g = e.onTransitionEnd, r = e.onClose, o = e.contextId, I = At(e.animate === "open"), s = I[0], a = I[1];
  et(function() {
    return s ? n !== "open" ? (i(), a(!1), SF) : t.current ? SF : (t.current = setTimeout(function() {
      t.current = null, a(!1);
    }), i) : SF;
  }, [n, s, i]);
  var d = $t(function(u) {
    u.propertyName === "height" && (g(), n === "close" && r());
  }, [n, r, g]), C = $ht({
    isAnimatingOpenOnMount: s,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return Se.createElement(e.placeholder.tagName, {
    style: C,
    "data-rbd-placeholder-context-id": o,
    onTransitionEnd: d,
    ref: e.innerRef
  });
}
var ept = Se.memo(qht), rE = Se.createContext(null), tpt = function(e) {
  wZ(t, e);
  function t() {
    for (var n, g = arguments.length, r = new Array(g), o = 0; o < g; o++)
      r[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(r)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(g, r) {
    return g.shouldAnimate ? g.on ? {
      isVisible: !0,
      data: g.on,
      animate: "open"
    } : r.isVisible ? {
      isVisible: !0,
      data: r.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!g.on,
      data: g.on,
      animate: "none"
    };
  };
  var i = t.prototype;
  return i.render = function() {
    if (!this.state.isVisible)
      return null;
    var g = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(g);
  }, t;
}(Se.PureComponent), xU = {
  dragging: 5e3,
  dropAnimating: 4500
}, ipt = function(t, i) {
  return i ? vB.drop(i.duration) : t ? vB.snap : vB.fluid;
}, npt = function(t, i) {
  return t ? i ? AZ.opacity.drop : AZ.opacity.combining : null;
}, gpt = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function rpt(e) {
  var t = e.dimension, i = t.client, n = e.offset, g = e.combineWith, r = e.dropping, o = !!g, I = gpt(e), s = !!r, a = s ? kx.drop(n, o) : kx.moveTo(n), d = {
    position: "fixed",
    top: i.marginBox.top,
    left: i.marginBox.left,
    boxSizing: "border-box",
    width: i.borderBox.width,
    height: i.borderBox.height,
    transition: ipt(I, r),
    transform: a,
    opacity: npt(o, s),
    zIndex: s ? xU.dropAnimating : xU.dragging,
    pointerEvents: "none"
  };
  return d;
}
function opt(e) {
  return {
    transform: kx.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function Ipt(e) {
  return e.type === "DRAGGING" ? rpt(e) : opt(e);
}
function lpt(e, t, i) {
  i === void 0 && (i = ur);
  var n = window.getComputedStyle(t), g = t.getBoundingClientRect(), r = Qq(g, n), o = SV(r, i), I = {
    client: r,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, s = {
    x: r.marginBox.width,
    y: r.marginBox.height
  }, a = {
    descriptor: e,
    placeholder: I,
    displaceBy: s,
    client: r,
    page: o
  };
  return a;
}
function spt(e) {
  var t = iE("draggable"), i = e.descriptor, n = e.registry, g = e.getDraggableRef, r = e.canDragInteractiveElements, o = e.shouldRespectForcePress, I = e.isEnabled, s = Ei(function() {
    return {
      canDragInteractiveElements: r,
      shouldRespectForcePress: o,
      isEnabled: I
    };
  }, [r, I, o]), a = $t(function(A) {
    var m = g();
    return m || pt(), lpt(i, m, A);
  }, [i, g]), d = Ei(function() {
    return {
      uniqueId: t,
      descriptor: i,
      options: s,
      getDimension: a
    };
  }, [i, a, s, t]), C = Ct(d), u = Ct(!0);
  HI(function() {
    return n.draggable.register(C.current), function() {
      return n.draggable.unregister(C.current);
    };
  }, [n.draggable]), HI(function() {
    if (u.current) {
      u.current = !1;
      return;
    }
    var A = C.current;
    C.current = d, n.draggable.update(d, A);
  }, [d, n.draggable]);
}
function apt(e) {
  e.preventDefault();
}
function cpt(e) {
  var t = Ct(null), i = $t(function(x) {
    t.current = x;
  }, []), n = $t(function() {
    return t.current;
  }, []), g = HV(S2), r = g.contextId, o = g.dragHandleUsageInstructionsId, I = g.registry, s = HV(rE), a = s.type, d = s.droppableId, C = Ei(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: a,
      droppableId: d
    };
  }, [e.draggableId, e.index, a, d]), u = e.children, A = e.draggableId, m = e.isEnabled, h = e.shouldRespectForcePress, B = e.canDragInteractiveElements, f = e.isClone, G = e.mapped, y = e.dropAnimationFinished;
  if (!f) {
    var W = Ei(function() {
      return {
        descriptor: C,
        registry: I,
        getDraggableRef: n,
        canDragInteractiveElements: B,
        shouldRespectForcePress: h,
        isEnabled: m
      };
    }, [C, I, n, B, h, m]);
    spt(W);
  }
  var V = Ei(function() {
    return m ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": o,
      "data-rbd-drag-handle-draggable-id": A,
      "data-rbd-drag-handle-context-id": r,
      draggable: !1,
      onDragStart: apt
    } : null;
  }, [r, o, A, m]), w = $t(function(x) {
    G.type === "DRAGGING" && G.dropping && x.propertyName === "transform" && y();
  }, [y, G]), v = Ei(function() {
    var x = Ipt(G), N = G.type === "DRAGGING" && G.dropping ? w : null, M = {
      innerRef: i,
      draggableProps: {
        "data-rbd-draggable-context-id": r,
        "data-rbd-draggable-id": A,
        style: x,
        onTransitionEnd: N
      },
      dragHandleProps: V
    };
    return M;
  }, [r, V, A, G, w, i]), H = Ei(function() {
    return {
      draggableId: C.id,
      type: C.type,
      source: {
        index: C.index,
        droppableId: C.droppableId
      }
    };
  }, [C.droppableId, C.id, C.index, C.type]);
  return u(v, G.snapshot, H);
}
var Lee = function(e, t) {
  return e === t;
}, Tee = function(e) {
  var t = e.combine, i = e.destination;
  return i ? i.droppableId : t ? t.droppableId : null;
}, dpt = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, Cpt = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function upt() {
  var e = yg(function(g, r) {
    return {
      x: g,
      y: r
    };
  }), t = yg(function(g, r, o, I, s) {
    return {
      isDragging: !0,
      isClone: r,
      isDropAnimating: !!s,
      dropAnimation: s,
      mode: g,
      draggingOver: o,
      combineWith: I,
      combineTargetFor: null
    };
  }), i = yg(function(g, r, o, I, s, a, d) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: s,
        combineWith: a,
        mode: r,
        offset: g,
        dimension: o,
        forceShouldAnimate: d,
        snapshot: t(r, I, s, a, null)
      }
    };
  }), n = function(r, o) {
    if (r.isDragging) {
      if (r.critical.draggable.id !== o.draggableId)
        return null;
      var I = r.current.client.offset, s = r.dimensions.draggables[o.draggableId], a = XI(r.impact), d = Cpt(r.impact), C = r.forceShouldAnimate;
      return i(e(I.x, I.y), r.movementMode, s, o.isClone, a, d, C);
    }
    if (r.phase === "DROP_ANIMATING") {
      var u = r.completed;
      if (u.result.draggableId !== o.draggableId)
        return null;
      var A = o.isClone, m = r.dimensions.draggables[o.draggableId], h = u.result, B = h.mode, f = Tee(h), G = dpt(h), y = r.dropDuration, W = {
        duration: y,
        curve: QK.drop,
        moveTo: r.newHomeClientOffset,
        opacity: G ? AZ.opacity.drop : null,
        scale: G ? AZ.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: r.newHomeClientOffset,
          dimension: m,
          dropping: W,
          draggingOver: f,
          combineWith: G,
          mode: B,
          forceShouldAnimate: null,
          snapshot: t(B, A, f, G, W)
        }
      };
    }
    return null;
  };
  return n;
}
function Mee(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var Apt = {
  mapped: {
    type: "SECONDARY",
    offset: ur,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: Mee(null)
  }
};
function bpt() {
  var e = yg(function(o, I) {
    return {
      x: o,
      y: I
    };
  }), t = yg(Mee), i = yg(function(o, I, s) {
    return I === void 0 && (I = null), {
      mapped: {
        type: "SECONDARY",
        offset: o,
        combineTargetFor: I,
        shouldAnimateDisplacement: s,
        snapshot: t(I)
      }
    };
  }), n = function(I) {
    return I ? i(ur, I, !0) : null;
  }, g = function(I, s, a, d) {
    var C = a.displaced.visible[I], u = !!(d.inVirtualList && d.effected[I]), A = f2(a), m = A && A.draggableId === I ? s : null;
    if (!C) {
      if (!u)
        return n(m);
      if (a.displaced.invisible[I])
        return null;
      var h = Zh(d.displacedBy.point), B = e(h.x, h.y);
      return i(B, m, !0);
    }
    if (u)
      return n(m);
    var f = a.displacedBy.point, G = e(f.x, f.y);
    return i(G, m, C.shouldAnimate);
  }, r = function(I, s) {
    if (I.isDragging)
      return I.critical.draggable.id === s.draggableId ? null : g(s.draggableId, I.critical.draggable.id, I.impact, I.afterCritical);
    if (I.phase === "DROP_ANIMATING") {
      var a = I.completed;
      return a.result.draggableId === s.draggableId ? null : g(s.draggableId, a.result.draggableId, a.impact, a.afterCritical);
    }
    return null;
  };
  return r;
}
var mpt = function() {
  var t = upt(), i = bpt(), n = function(r, o) {
    return t(r, o) || i(r, o) || Apt;
  };
  return n;
}, hpt = {
  dropAnimationFinished: Gee
}, ppt = zq(mpt, hpt, null, {
  context: tE,
  pure: !0,
  areStatePropsEqual: Lee
})(cpt);
function Uee(e) {
  var t = HV(rE), i = t.isUsingCloneFor;
  return i === e.draggableId && !e.isClone ? null : Se.createElement(ppt, e);
}
function oE(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, i = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return Se.createElement(Uee, k({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: i,
    shouldRespectForcePress: n
  }));
}
function Bpt(e) {
  var t = Hn(S2);
  t || pt();
  var i = t.contextId, n = t.isMovementAllowed, g = Ct(null), r = Ct(null), o = e.children, I = e.droppableId, s = e.type, a = e.mode, d = e.direction, C = e.ignoreContainerClipping, u = e.isDropDisabled, A = e.isCombineEnabled, m = e.snapshot, h = e.useClone, B = e.updateViewportMaxScroll, f = e.getContainerForClone, G = $t(function() {
    return g.current;
  }, []), y = $t(function(M) {
    g.current = M;
  }, []);
  $t(function() {
    return r.current;
  }, []);
  var W = $t(function(M) {
    r.current = M;
  }, []), V = $t(function() {
    n() && B({
      maxScroll: wee()
    });
  }, [n, B]);
  jht({
    droppableId: I,
    type: s,
    mode: a,
    direction: d,
    isDropDisabled: u,
    isCombineEnabled: A,
    ignoreContainerClipping: C,
    getDroppableRef: G
  });
  var w = Se.createElement(tpt, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(M) {
    var $ = M.onClose, q = M.data, E = M.animate;
    return Se.createElement(ept, {
      placeholder: q,
      onClose: $,
      innerRef: W,
      animate: E,
      contextId: i,
      onTransitionEnd: V
    });
  }), v = Ei(function() {
    return {
      innerRef: y,
      placeholder: w,
      droppableProps: {
        "data-rbd-droppable-id": I,
        "data-rbd-droppable-context-id": i
      }
    };
  }, [i, I, w, y]), H = h ? h.dragging.draggableId : null, x = Ei(function() {
    return {
      droppableId: I,
      type: s,
      isUsingCloneFor: H
    };
  }, [I, H, s]);
  function N() {
    if (!h)
      return null;
    var M = h.dragging, $ = h.render, q = Se.createElement(Uee, {
      draggableId: M.draggableId,
      index: M.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(E, L) {
      return $(E, L, M);
    });
    return T0.createPortal(q, f());
  }
  return Se.createElement(rE.Provider, {
    value: x
  }, o(v, m), N());
}
var VF = function(t, i) {
  return t === i.droppable.type;
}, DU = function(t, i) {
  return i.draggables[t.draggable.id];
}, Zpt = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, i = k({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = yg(function(o) {
    return {
      draggableId: o.id,
      type: o.type,
      source: {
        index: o.index,
        droppableId: o.droppableId
      }
    };
  }), g = yg(function(o, I, s, a, d, C) {
    var u = d.descriptor.id, A = d.descriptor.droppableId === o;
    if (A) {
      var m = C ? {
        render: C,
        dragging: n(d.descriptor)
      } : null, h = {
        isDraggingOver: s,
        draggingOverWith: s ? u : null,
        draggingFromThisWith: u,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: d.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: h,
        useClone: m
      };
    }
    if (!I)
      return i;
    if (!a)
      return t;
    var B = {
      isDraggingOver: s,
      draggingOverWith: u,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: d.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: B,
      useClone: null
    };
  }), r = function(I, s) {
    var a = s.droppableId, d = s.type, C = !s.isDropDisabled, u = s.renderClone;
    if (I.isDragging) {
      var A = I.critical;
      if (!VF(d, A))
        return i;
      var m = DU(A, I.dimensions), h = XI(I.impact) === a;
      return g(a, C, h, h, m, u);
    }
    if (I.phase === "DROP_ANIMATING") {
      var B = I.completed;
      if (!VF(d, B.critical))
        return i;
      var f = DU(B.critical, I.dimensions);
      return g(a, C, Tee(B.result) === a, XI(B.impact) === a, f, u);
    }
    if (I.phase === "IDLE" && I.completed && !I.shouldFlush) {
      var G = I.completed;
      if (!VF(d, G.critical))
        return i;
      var y = XI(G.impact) === a, W = !!(G.impact.at && G.impact.at.type === "COMBINE"), V = G.critical.droppable.id === a;
      return y ? W ? t : i : V ? t : i;
    }
    return i;
  };
  return r;
}, fpt = {
  updateViewportMaxScroll: Hbt
};
function Gpt() {
  return document.body || pt(), document.body;
}
var ypt = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: Gpt
}, w2 = zq(Zpt, fpt, null, {
  context: tE,
  pure: !0,
  areStatePropsEqual: Lee
})(Bpt);
w2.defaultProps = ypt;
var IE = {}, Wpt = Cg;
Object.defineProperty(IE, "__esModule", {
  value: !0
});
var lE = IE.default = void 0, Spt = Wpt(Kg()), Vpt = xg;
lE = IE.default = (0, Spt.default)(/* @__PURE__ */ (0, Vpt.jsx)("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "DragIndicator");
const Pee = ({
  disabled: e,
  provided: t
}) => /* @__PURE__ */ p(fe, { component: "div", sx: {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  visibility: e ? "hidden" : "visible"
}, children: /* @__PURE__ */ p(mi, { "data-cy": "dragHandle", color: "editor", size: "small", ...t.dragHandleProps, children: /* @__PURE__ */ p(lE, { sx: {
  cursor: "grabbing"
} }) }) }), zee = Bs(null), wpt = ({
  id: e,
  child: t,
  isDisabled: i
}) => {
  var I;
  const n = wu(t), g = ((I = n.key) == null ? void 0 : I.toString()) || "", r = n.props["data-cy"] || "DnDListChildren", o = _(hr);
  return /* @__PURE__ */ p(oE, { draggableId: g, index: e, isDragDisabled: i, children: (s) => /* @__PURE__ */ p(_t, { "data-cy": `draggable-${r}`, sx: {
    overflow: "hidden"
  }, className: Ve("k3-draggable-container", o ? "edit-mode" : "display-mode"), ref: s.innerRef, ...s.draggableProps, children: /* @__PURE__ */ p(zee.Provider, { value: /* @__PURE__ */ p(Pee, { provided: s, disabled: i }), children: n }) }, g) });
};
function vpt({
  className: e,
  children: t,
  isDragDisabled: i = !1,
  onDragEnd: n,
  columns: g,
  rows: r,
  row: o,
  sx: I,
  "data-cy": s
}) {
  const a = (C) => {
    if (!C.destination)
      return;
    const u = C.source.index, A = C.destination.index;
    u !== A && n && n(C);
  }, d = !n || i;
  return /* @__PURE__ */ p(gE, { onDragEnd: a, children: /* @__PURE__ */ p(w2, { droppableId: "droppable", children: (C, u) => /* @__PURE__ */ ge(_t, { "data-cy": s, className: e, sx: {
    display: "grid",
    gridAutoFlow: o ? "column" : "row",
    ...g ? {
      gridTemplateRows: `repeat(${r ?? 1}, 1fr)`
    } : {},
    ...g ? {
      gridTemplateColumns: `repeat(${g ?? 1}, 1fr)`
    } : {},
    pb: 3,
    ...I
  }, ref: C.innerRef, ...C.droppableProps, children: [
    xz.map(t, (A, m) => /* @__PURE__ */ p(wpt, { id: m, isDisabled: d, child: A }, m)),
    C.placeholder
  ] }) }) });
}
const Rpt = (e) => (t) => {
  const i = Hn(hs), n = je(() => i != null && i.extendGroupPanel ? i == null ? void 0 : i.extendGroupPanel(e) : e, [i]);
  return /* @__PURE__ */ p(n, { ...t });
}, Xpt = ({
  onDragEnd: e,
  group: t,
  columns: i,
  rows: n,
  row: g,
  contextInstance: r,
  dense: o = !1
}) => {
  const I = h2(r), s = _(hr), a = Li(), d = _((C) => J6(C, t == null ? void 0 : t.id));
  return /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ p(vpt, { columns: i, rows: n, row: g, className: Ve("variablesList", "k3-group-panel", s ? "edit-mode" : "display-mode"), onDragEnd: e, "data-cy": "groupPanel-" + (t == null ? void 0 : t.label), children: d == null ? void 0 : d.filter((C) => Hq[ju(C)] && !hi(C).hideFromGroup).sort(Ku).map((C) => /* @__PURE__ */ p(kq, { contextInstance: a, variable: C, onChange: I, dense: o, withPaperWrapper: !0, "data-cy": `variable-${C.label}` }, C.id)) }),
    /* @__PURE__ */ p(oct, { group: t, variables: d })
  ] });
}, v2 = Rpt(Xpt), Oee = (e) => {
  var n;
  const t = Hn(hs), i = (n = t.extendAdditionalGroups) == null ? void 0 : n.call(t, () => null);
  return i ? /* @__PURE__ */ p(i, { design: e.design, placement: e.placement, isRootHeader: e.isRootHeader }) : null;
}, R2 = (e) => e, kV = (...e) => Object.assign(e), Hpt = {
  "html, body, #root": {
    margin: 0,
    height: "100%"
  }
}, wF = R2({
  parentItem: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "0.5rem"
  },
  root: {
    minWidth: "auto",
    overflow: "hidden",
    padding: 1,
    whiteSpace: "nowrap",
    alignItems: "center"
  },
  breadcrumbs: {
    paddingLeft: 2,
    boxSizing: "border-box"
  }
}), Qee = ({
  useDivider: e,
  useDelete: t
}) => {
  const i = un(), n = Li(), g = _(Go(n.variableId)), r = _((h) => $u(h, n)).reverse(), o = _((h) => K$e(h, n.variableId)), I = _(Go(n.variableId)), s = _($d(n.valueId)), a = zt(), d = (h) => () => {
    a(ig(h.id));
  }, [C, u] = Y.useState(), A = () => {
    a(sf(n)), m();
  }, m = ft(() => {
    u(void 0), a(ig(Dt.id, g == null ? void 0 : g.groupId));
  }, [a, g]);
  return !I || n.variableId === Dt.variableId ? null : /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(
      Ibe,
      {
        in: C !== void 0 ? !C : !!I,
        direction: "right",
        timeout: 300,
        onExited: m,
        children: /* @__PURE__ */ ge(_t, { direction: "row", sx: wF.root, children: [
          /* @__PURE__ */ ge(RO, { "aria-label": "Breadcrumb", separator: /* @__PURE__ */ p(G6e, { fontSize: "small" }), maxItems: 3, itemsAfterCollapse: 2, itemsBeforeCollapse: 1, children: [
            /* @__PURE__ */ ge(_t, { direction: "row", children: [
              /* @__PURE__ */ p(as, { component: Si, "data-cy": "parent", color: "inherit", noWrap: !0, sx: wF.parentItem, underline: "none", variant: "subtitle1", startIcon: /* @__PURE__ */ p(Ej, {}), onClick: () => u(!0), children: /* @__PURE__ */ p(Ne, { variant: "subtitle1", "data-cy": "buttonLabel", children: i(Ii.COMPONENT_BREADCRUMBS_BACK) }) }),
              /* @__PURE__ */ p(Xl, { keys: [Ii.COMPONENT_BREADCRUMBS_BACK], display: "dialog" })
            ] }),
            wfe((h) => {
              const B = o.find((f) => f.id == h.variableId);
              return /* @__PURE__ */ ge(as, { "data-cy": `crumb-${h.variableId}`, color: "inherit", onClick: d(h), sx: wF.parentItem, underline: "hover", variant: "subtitle1", noWrap: !0, children: [
                (B == null ? void 0 : B.label) && /* @__PURE__ */ p(Ne, { variant: "subtitle1", "data-cy": "variableLabel", children: `${B == null ? void 0 : B.label} ` }),
                /* @__PURE__ */ p(Ne, { variant: "subtitle1", "data-cy": "selectionSort", children: `(${h.sort}): ` }),
                /* @__PURE__ */ p(Ne, { variant: "subtitle1", "data-cy": "selectionValue", children: `${h.debuggingValue}` })
              ] }, h.id);
            }, r.filter((h) => h.id !== Dt.id)),
            s && /* @__PURE__ */ ge(fe, { component: "div", sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem"
            }, "data-cy": "currentCrumb", children: [
              (I == null ? void 0 : I.label) && /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ p(Ne, { noWrap: !0, variant: "subtitle1", "data-cy": "variableLabel", children: `${I == null ? void 0 : I.label}` }) }),
              /* @__PURE__ */ p(Ne, { noWrap: !0, variant: "subtitle1", "data-cy": "selectionSort", children: `(${n.sort}):` }),
              /* @__PURE__ */ p(Ne, { noWrap: !0, variant: "subtitle1", "data-cy": "selectionValue", children: `${n.debuggingValue}` })
            ] })
          ] }),
          t && /* @__PURE__ */ p(mi, { onClick: A, "data-cy": "delete", children: /* @__PURE__ */ p(TZ, {}) })
        ] })
      }
    ),
    e && /* @__PURE__ */ p(bs, {})
  ] });
}, LW = R2({
  listItemContainer: {
    position: "relative"
  },
  dragHandleContainer: {
    position: "absolute",
    width: "20px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    visibility: "visible",
    top: "-2px",
    left: "-4px",
    bottom: "0",
    fontSize: "1.25em"
  },
  visible: {
    visibility: "visible"
  },
  hidden: {
    visibility: "hidden"
  },
  dragHandle: {
    cursor: "grabbing"
  }
}), kpt = ({
  disabled: e = !1,
  provided: t
}) => /* @__PURE__ */ p(fe, { component: "div", sx: kV(LW.dragHandleContainer, e ? LW.hidden : LW.visible), children: /* @__PURE__ */ p(mi, { "data-cy": "dragHandle", color: "editor", size: "small", ...t.dragHandleProps, children: /* @__PURE__ */ p(lE, { color: "inherit", sx: LW.dragHandle }) }) });
function Fpt({
  children: e,
  onDragEnd: t,
  isDragDisabled: i = !1,
  ...n
}) {
  const g = ft((I) => {
    I.destination && t && t(I);
  }, [t]), r = !t || i, o = je(() => Se.Children.map(e, (I, s) => {
    const a = I.key;
    return Se.cloneElement(I, {
      component: Se.forwardRef(({
        children: d,
        ...C
      }, u) => /* @__PURE__ */ p(oE, { draggableId: a, index: s, isDragDisabled: r, children: (A) => /* @__PURE__ */ p(fe, { component: "div", ...A.draggableProps, ref: A.innerRef, children: /* @__PURE__ */ ge(_t, { component: "div", direction: "row", spacing: 1, ...C, ref: u, children: [
        d,
        /* @__PURE__ */ p(kpt, { provided: A, disabled: r })
      ] }) }) }, a))
    });
  }), [e, r]);
  return /* @__PURE__ */ p(gE, { onDragEnd: g, children: /* @__PURE__ */ p(w2, { droppableId: "droppableADF", direction: "horizontal", children: (I, s) => /* @__PURE__ */ ge(I1, { id: "VFOTEST", ...n, ...I.droppableProps, ref: I.innerRef, value: s.isDraggingOver ? !1 : n.value, sx: {
    ".MuiTabs-flexContainer": {
      alignItems: "center"
    },
    ".MuiTabs-scroller": {
      display: "flex",
      alignItems: "center"
    }
  }, children: [
    o,
    I.placeholder
  ] }) }) });
}
var sE = {}, Ypt = Cg;
Object.defineProperty(sE, "__esModule", {
  value: !0
});
var aE = sE.default = void 0, xpt = Ypt(Kg()), Dpt = xg;
aE = sE.default = (0, xpt.default)(/* @__PURE__ */ (0, Dpt.jsx)("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff");
const JU = {
  label: {
    whiteSpace: "nowrap"
  },
  useContrastTextColor: {
    color: (e) => e.palette.primary.contrastText
  }
};
function cE({
  group: e,
  onClick: t,
  useContrastTextColor: i,
  useDefaultEditorUi: n,
  className: g
}) {
  const r = Hn(hs), o = je(() => {
    var I;
    return (I = r.extendGroupLabel) == null ? void 0 : I.call(r, ({
      group: s,
      useContrastTextColor: a
    }) => /* @__PURE__ */ p(fe, { component: "span", sx: kV(
      JU.label,
      // @ts-ignore
      a && JU.useContrastTextColor
    ), onClick: t, "data-cy": "group_" + (s == null ? void 0 : s.id), className: Ve("group-label k3-group-label", g), children: /* @__PURE__ */ p(Ne, { children: s == null ? void 0 : s.label }) }));
  }, [g, r, t]);
  return o ? /* @__PURE__ */ p(o, { group: e, useContrastTextColor: i, useDefaultEditorUi: n }) : null;
}
const dE = ({
  children: e
}) => {
  const {
    t
  } = ii();
  return /* @__PURE__ */ p(Cn, { title: t("hiddenGroup"), children: e });
}, Jpt = ({
  group: e,
  isHiddenGroup: t,
  iconPosition: i,
  isActive: n,
  ...g
}) => {
  var u, A, m, h, B;
  const r = _((f) => vD(f, e.id)), o = _((f) => mJ(f, r)), I = _(q6), s = Ud(), a = _($6), d = _(_6(e)), C = je(() => ({
    ...g.sx,
    ...a && !d ? {
      opacity: 0,
      pointerEvents: "none"
    } : {},
    minHeight: "unset"
  }), [d, a, g.sx]);
  return /* @__PURE__ */ p(mc, { className: Ve("k3-main-nav-item k3-tab-nav-item", d ? "groupHeaderTab" : "invisibleGroupHeaderTab", n && "k3-main-nav-selected selected active"), ...g, sx: C, value: e.id, icon: (u = e == null ? void 0 : e.settings) != null && u.icon ? /* @__PURE__ */ p("img", { alt: "", width: ((A = e == null ? void 0 : e.settings) == null ? void 0 : A.iconSize) ?? 24, height: ((m = e == null ? void 0 : e.settings) == null ? void 0 : m.iconSize) ?? 24, src: (h = e == null ? void 0 : e.settings) == null ? void 0 : h.icon, className: "k3-main-nav-item-icon" }) : null, iconPosition: i || (((B = e == null ? void 0 : e.settings) == null ? void 0 : B.iconPosition) ?? "top"), label: /* @__PURE__ */ ge(_t, { component: So, elevation: s != null && s.pathname.includes(`groups/${e.id}`) ? 4 : 0, direction: "row", spacing: 2, alignItems: "center", className: "k3-main-nav-item-content", sx: {
    transition: "all 0.3s",
    color: s != null && s.pathname.includes(`groups/${e.id}`) ? "common.black" : "inherit",
    bgcolor: s != null && s.pathname.includes(`groups/${e.id}`) ? "common.white" : "transparent",
    pl: s != null && s.pathname.includes("edit/conf") ? 2 : 0
  }, children: [
    t && /* @__PURE__ */ p(dE, { children: /* @__PURE__ */ p(aE, { color: "editor" }) }),
    I && /* @__PURE__ */ p(qm, { "data-cy": "visited", color: "secondary", size: "small", sx: {
      p: 0,
      pr: "2px"
    }, disableRipple: !0, disableFocusRipple: !0, checkedIcon: /* @__PURE__ */ p(C3, {}), icon: /* @__PURE__ */ p(C3, { style: {
      visibility: "hidden"
    } }), checked: !!o.find((f) => f.id === e.id) }),
    /* @__PURE__ */ p(cE, { group: e, useDefaultEditorUi: g.useDefaultEditorUi, className: "k3-tabs-nav-item-text k3-nav-item-text" })
  ] }) });
}, Kpt = (e) => (t) => {
  const i = Hn(hs), n = je(() => i.extendHeader(e), [i]);
  return /* @__PURE__ */ p(n, { ...t });
};
var CE = {}, Ept = Cg;
Object.defineProperty(CE, "__esModule", {
  value: !0
});
var jee = CE.default = void 0, Npt = Ept(Kg()), Lpt = xg;
jee = CE.default = (0, Npt.default)(/* @__PURE__ */ (0, Lpt.jsx)("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
const Dx = ({
  children: e
}) => {
  const t = IA(), i = _(Wj), n = Li(), g = t && i === "mobileDefault" ? n : Dt, r = _((I) => nC(I, g)), o = _((I) => vje(I, g));
  return !r || !o ? null : /* @__PURE__ */ p(qee, { groups: r, contextInstance: g, focusGroupId: o, children: e });
}, _ee = ({
  activeGroupId: e,
  groups: t,
  handleTabChange: i,
  onDragEnd: n,
  showEditorUi: g,
  invisibleGroups: r,
  ...o
}) => {
  const I = Li(), s = IA(), a = _(Wj);
  return /* @__PURE__ */ ge(Bt, { children: [
    s && (a === "mobileDefault" || a === void 0) && (I == null ? void 0 : I.variableId) && /* @__PURE__ */ p(Qee, { useDelete: !0 }),
    /* @__PURE__ */ p(Fpt, { "data-cy": "GroupsNavigationTabs", className: "k3-main-nav-tabs", variant: "scrollable", scrollButtons: "auto", textColor: "inherit", value: (e == null ? void 0 : e.toString()) || !1, onClick: (d) => {
      d.stopPropagation(), e && i(d, e.toString());
    }, onChange: (d, C) => {
      d.stopPropagation(), i(d, C);
    }, sx: {
      flexGrow: 1,
      color: "white"
    }, onDragEnd: n, children: t.reduce((d, C) => {
      var A, m;
      const u = K1(C, r);
      return !g && u ? d : [...d, /* @__PURE__ */ p(Jpt, { "data-cy": `group-${C.label}`, value: (A = C.id) == null ? void 0 : A.toString(), group: C, isHiddenGroup: u, isActive: C.id == e, useDefaultEditorUi: o.isSidebarHeader }, (m = C.id) == null ? void 0 : m.toString())];
    }, []) }),
    /* @__PURE__ */ p(Oee, { design: "topmenu", placement: "topmenu", isRootHeader: o.isSidebarHeader })
  ] });
}, Tpt = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  textWrap: "nowrap",
  lineHeight: "36px"
}, vF = ({
  children: e,
  maxWidth: t,
  className: i,
  onClick: n
}) => /* @__PURE__ */ p(Ne, { variant: "h6", title: e, sx: Tpt, maxWidth: t, className: i, onClick: n, children: /* @__PURE__ */ p("span", { children: e }) });
function KU(e, t, i) {
  var g;
  const n = e.valueId && ((g = t[e.valueId]) == null ? void 0 : g.label);
  return n || i("Wert");
}
const $ee = ({
  showBreadcrumbs: e = !0,
  ...t
}) => {
  var m;
  const {
    t: i
  } = ii(), n = un(), g = Ct(null), r = Li(), o = zt(), I = _(vg), s = HZ(I, r).reverse(), a = s.length > 1 ? s[1] : r, d = _(Go(a.variableId)), C = _(Za), u = _(LD), A = (h, B) => () => {
    const f = C[B];
    o(ig(h, f.groupId));
  };
  return et(() => {
    g != null && g.current && (g == null || g.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "end"
    }));
  }, [(m = t.openInstance) == null ? void 0 : m.id]), /* @__PURE__ */ ge(
    _t,
    {
      direction: "column",
      className: "k3-sub-header",
      "data-cy": "subGroupHeader",
      sx: {
        position: "sticky",
        top: 0,
        //zIndex gets smaller the deeper we are in the hierarchy
        zIndex: 1e3 - s.length,
        backgroundColor: "white"
      },
      children: [
        /* @__PURE__ */ ge(_t, { direction: "row", alignItems: "center", children: [
          e && /* @__PURE__ */ ge(Bt, { children: [
            /* @__PURE__ */ p(Cn, { title: n(Ii.COMPONENT_BREADCRUMBS_BACK), children: /* @__PURE__ */ p(as, { underline: "hover", component: Si, "data-cy": "sublevelRoot", className: "k3-sub-header-back", sx: {
              // sticky to the left
              position: "absolute",
              left: "0px",
              top: "0px",
              zIndex: 1e3,
              width: "34px"
            }, onClick: () => {
              o(ig(s[s.length - 1].id, d.groupId));
            }, children: /* @__PURE__ */ p(mi, { component: "div", "data-cy": "sublevelBackButton", className: "k3-sub-header-back-button", sx: {
              lineHeight: "36px",
              // remove hover effects from mui Button
              "&:hover": {
                backgroundColor: "transparent"
              }
            }, children: /* @__PURE__ */ p(Ej, { fontSize: "small" }) }) }) }),
            /* @__PURE__ */ ge(RO, { "aria-label": "Breadcrumb", className: "k3-sub-header-breadcrumb", classes: {
              separator: "k3-sub-header-separator",
              ol: "k3-sub-header-ol",
              li: "k3-sub-header-li"
            }, separator: /* @__PURE__ */ p(jee, { fontSize: "small" }), sx: {
              width: 1,
              position: "relative",
              overflow: "hidden",
              ".MuiBreadcrumbs-separator": {
                margin: 0
              },
              ".MuiBreadcrumbs-ol": {
                flexWrap: "nowrap",
                overflow: "auto",
                marginLeft: "34px"
              }
            }, children: [
              /* @__PURE__ */ p(as, { underline: "hover", component: Si, "data-cy": "sublevelRoot", className: "k3-sub-header-link", children: /* @__PURE__ */ p(vF, { className: "k3-sub-header-root-label", onClick: A(a.instance.belongsToInstanceId, a.variableId), children: d == null ? void 0 : d.label }) }),
              s.map((h, B) => B === 0 ? null : /* @__PURE__ */ p(as, { sx: {
                overflow: "hidden"
              }, component: Si, underline: "hover", onClick: A(h.id, h.variableId), "data-cy": "sublevelLink" + B, className: "k3-sub-header-link", children: /* @__PURE__ */ p(vF, { children: KU(h, u, i) }) }, h.id)),
              /* @__PURE__ */ p(as, { ref: g, component: Si, "data-cy": "sublevelLinkLast", className: "k3-sub-header-link", sx: {
                width: 1,
                pointerEvents: "none",
                textDecoration: "underline"
              }, children: /* @__PURE__ */ p(vF, { children: KU(r, u, i) }) })
            ] })
          ] }),
          /* @__PURE__ */ p(Xl, { keys: [Ii.COMPONENT_BREADCRUMBS_BACK], display: "dialog" })
        ] }),
        (t.groups.length > 1 || t.showEditorUi) && /* @__PURE__ */ p(qO, { disableGutters: !0, className: "k3-sub-nav", children: /* @__PURE__ */ p(_ee, { ...t, isSidebarHeader: !0 }) }),
        t.children,
        /* @__PURE__ */ p(bs, {})
      ]
    }
  );
}, Mpt = (e) => e.subHeader ? /* @__PURE__ */ p($ee, { ...e }) : /* @__PURE__ */ ge(Zce, { sx: {
  display: "grid",
  gridTemplateColumns: "max-content 1fr max-content",
  overflow: "auto"
}, position: "static", className: "k3-main-nav k3-header", "data-cy": "groupHeader", children: [
  /* @__PURE__ */ p(qO, { disableGutters: !0, children: /* @__PURE__ */ p(_ee, { ...e }) }),
  e.children
] }), Upt = ki({
  app: {
    header: {
      root: !0
    }
  }
})(Mpt), Ppt = function(e) {
  const {
    groups: t = [],
    focusGroupId: i
  } = e, n = _(hr), g = zt(), r = t.find((d) => d.id == i), o = Li(), I = e.contextInstance || o, s = _((d) => L1(d, I)), a = ft((d, C) => {
    const u = vfe(C);
    g(ig(I.id, u));
  }, [g, I]);
  return /* @__PURE__ */ p(Upt, { ...e, showEditorUi: n, activeGroupId: r == null ? void 0 : r.id, invisibleGroups: s, openInstance: I, handleTabChange: a });
}, qee = Kpt(Ppt);
var X2 = {}, zpt = Cg;
Object.defineProperty(X2, "__esModule", {
  value: !0
});
var yh = X2.default = void 0, Opt = zpt(Kg()), Qpt = xg;
yh = X2.default = (0, Opt.default)(/* @__PURE__ */ (0, Qpt.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const jpt = /* @__PURE__ */ zz({
  __proto__: null,
  get default() {
    return yh;
  }
}, [X2]), EU = {
  container: {
    border: "solid 1px rgba(0, 0, 0, 0.38)",
    borderRadius: 1,
    padding: 1,
    overflowY: "auto"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }
}, ete = ({
  contextInstance: e
}) => {
  const t = _((C) => _Z(C, e)), i = _((C) => fa(C, e)) || (t == null ? void 0 : t.id), n = _(Ba(i)), g = _((C) => L1(C, e)), r = _(hr), o = _((C) => nC(C, e)), I = zt(), s = (C, u) => {
    I(lf(+u));
  }, a = _($d(e.valueId)), d = ft(() => {
    I(E_(e));
  }, [I, e]);
  return /* @__PURE__ */ p(aK.Provider, { value: e, children: /* @__PURE__ */ ge(Cc, { component: "div", sx: EU.container, children: [
    /* @__PURE__ */ ge(Cc, { component: "div", sx: EU.header, children: [
      /* @__PURE__ */ p(Cc, { component: "div", children: /* @__PURE__ */ p(Ne, { variant: "h6", component: "h6", children: a == null ? void 0 : a.label }) }),
      /* @__PURE__ */ p(mi, { onClick: d, href: "", "data-cy": "", children: /* @__PURE__ */ p(yh, {}) })
    ] }),
    (o.length > 1 || r) && /* @__PURE__ */ p($ee, { activeGroupId: i, showBreadcrumbs: !1, handleTabChange: s, invisibleGroups: g, showEditorUi: r, groups: o, focusGroupId: i }),
    /* @__PURE__ */ p(bs, {}),
    /* @__PURE__ */ p(v2, { group: n, contextInstance: e })
  ] }) });
}, Qb = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    mt: 2,
    overflowY: "auto"
  },
  button: {
    display: "grid",
    gridTemplateColumns: "min-content 1fr min-content",
    gridTemplateAreas: `
          "Thumbnail Title Icons"
          "Thumbnail Extra Extra"`,
    width: "100%"
  },
  buttonThumbnail: {
    gridArea: "Thumbnail",
    justifySelf: "start"
  },
  buttonTitle: {
    gridArea: "Title"
  },
  buttonIcons: {
    gridArea: "Icons",
    justifySelf: "end"
  },
  buttonExtra: {
    gridArea: "Extra"
  }
}, cA = (e, t, i = !1) => _((n) => RD(n, e, t, i, t == null ? void 0 : t.settings.templateOptions.reverseSorting)), _pt = ({
  variable: e,
  onRenderThumbnail: t,
  onRenderExtra: i,
  hideSelection: n,
  tailingContent: g,
  contextInstance: r
}) => {
  var B;
  const o = ((B = cA(r, e, !0)) == null ? void 0 : B.filter((f) => n ? n(f.selection, f.value) : !0)) ?? [], I = zt(), s = (f, G) => {
    I(ig(G));
  }, a = RI((f) => f.hoveredSelections), d = RI((f) => f.addHoveredSelection), C = RI((f) => f.removeHoveredSelection), u = hi(e), A = Li(), m = r || A, h = _((f) => $Q(f, m));
  return /* @__PURE__ */ p(pr, { variable: e, view: /* @__PURE__ */ ge(fe, { component: "div", className: "k3-component-buttons-wrapper", children: [
    /* @__PURE__ */ p(uD, { sx: Qb.wrapper, orientation: "vertical", exclusive: !0, onChange: s, children: o.map((f) => /* @__PURE__ */ p(l1, { selected: a.includes(f.selection.id) || f.selection.id === (h == null ? void 0 : h.id), color: f.selection.id === (h == null ? void 0 : h.id) ? "standard" : "primary", onMouseEnter: () => d(f.selection.id), onMouseLeave: () => C(f.selection.id), onMouseDown: () => C(f.selection.id), "data-cy": `selection-${f == null ? void 0 : f.value}`, fullWidth: !0, value: f.selection.id, sx: {
      textAlign: "left"
    }, children: /* @__PURE__ */ ge(fe, { component: "div", sx: Qb.button, children: [
      /* @__PURE__ */ p(fe, { component: "div", sx: Qb.buttonThumbnail, children: t ? t(f.selection, f.value) : null }),
      /* @__PURE__ */ p(Ne, { sx: Qb.buttonTitle, variant: "body1", color: "textPrimary", children: f.value.label }),
      g ? g(f.selection, f.value) : /* @__PURE__ */ p(fe, { component: "div", sx: Qb.buttonIcons, children: /* @__PURE__ */ p(E$, { fontSize: "small", color: "action" }) }),
      /* @__PURE__ */ p(fe, { component: "div", sx: Qb.buttonExtra, children: i ? i(f.selection, f.value) : null })
    ] }) }, f.selection.id)) }),
    u.showComponentEditorsInline && h && /* @__PURE__ */ p(fe, { component: "div", sx: {
      pt: 1
    }, children: /* @__PURE__ */ p(ete, { contextInstance: h }) })
  ] }, `${m.id}_${e.id}`) });
}, tte = me.flow(rI, no("componentButtons"))(_pt), ite = (e, t, i, n) => (g, r) => {
  const o = r(), I = RD(o, i, n, !1), s = n != null && n.settings.templateOptions.reverseSorting ? I.length - 1 - e : e, a = n != null && n.settings.templateOptions.reverseSorting ? I.length - 1 - t : t;
  if (s === a)
    return;
  const d = I.map((u) => u.selection), C = d[s];
  d.splice(s, 1), d.splice(a, 0, C), g(_$(d));
}, $pt = (e, t, i, n) => (g, r) => ite(e, e + t, i, n)(g, r), qpt = (e, t, i) => (n, g) => {
  const r = g(), o = RD(r, t, i, !1);
  return n(bct(e, 1 + (ce.max(o.map((I) => I.selection.sort)) || 0), t));
}, nte = ({
  index: e,
  onEdit: t,
  instance: i,
  dense: n = !0,
  leftToRight: g = !1
}) => {
  const {
    t: r
  } = ii(), o = zt(), I = Li(), s = _(Go(i.variableId)), a = hi(s), d = _(TD(vl(i) ?? "")), C = cA(d, s, !1), u = _(hr), A = _(j6(i)) || u, m = (w) => {
    w.stopPropagation(), w.preventDefault(), t == null || t(i);
  }, h = (w) => {
    w.stopPropagation(), w.preventDefault(), o(sf(i)), d && i.id === I.id && o(ig(d.id));
  }, B = (w) => {
    w.stopPropagation(), w.preventDefault();
    const v = o(qpt(i, d, s));
    v && i === I && o(ig(v.id));
  }, f = (w, v) => {
    o($pt(w, v, d, s));
  };
  let G = e <= 0, y = (w) => {
    w.stopPropagation(), w.preventDefault(), f == null || f(e, -1);
  }, W = e >= C.length - 1, V = (w) => {
    w.stopPropagation(), w.preventDefault(), f == null || f(e, 1);
  };
  if (g && !a.reverseSorting) {
    const w = G, v = y;
    G = W, y = V, W = w, V = v;
  }
  return /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ ge(fe, { component: "div", className: "k3-select-item-actions", sx: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center"
  }, children: [
    t && A && /* @__PURE__ */ p(Cn, { title: r("Bearbeiten"), disableInteractive: !0, children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(mi, { edge: "end", "data-cy": "edit", className: "mp-inner-edit", onClick: m, children: /* @__PURE__ */ p(S1, { fontSize: n ? "small" : "large" }) }) }) }),
    /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "inline-flex",
      flexDirection: n ? "column" : "row",
      padding: "4px 0"
    }, children: [
      a.enableSorting && (!G || !n ? /* @__PURE__ */ p(Cn, { title: r("Hoch schieben"), disableInteractive: !0, children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(mi, { edge: "end", "data-cy": "up", className: "mp-inner-up", sx: n ? {
        padding: "0px 8px"
      } : void 0, onClick: y, disabled: G, children: n ? /* @__PURE__ */ p(c6e, { fontSize: "small" }) : /* @__PURE__ */ p(h6e, { fontSize: "large" }) }) }) }) : (
        // Placeholder div
        /* @__PURE__ */ p("div", { style: {
          height: "20px"
        } })
      )),
      a.enableSorting && (!W || !n ? /* @__PURE__ */ p(Cn, { title: r("Runter schieben"), disableInteractive: !0, children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(mi, { edge: "end", "data-cy": "down", className: "mp-inner-down", sx: n ? {
        padding: "0px 8px"
      } : void 0, onClick: V, disabled: W, children: n ? /* @__PURE__ */ p(a6e, { fontSize: "small" }) : /* @__PURE__ */ p(OD, { fontSize: "large" }) }) }) }) : (
        // Placeholder div
        /* @__PURE__ */ p("div", { style: {
          height: "20px"
        } })
      ))
    ] }),
    a.enableDuplication && /* @__PURE__ */ p(Cn, { title: r("Duplizieren"), disableInteractive: !0, children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(mi, { edge: "end", "data-cy": "copy", className: "mp-inner-copy", onClick: B, children: /* @__PURE__ */ p(A6e, { fontSize: n ? "small" : "medium", color: "action" }) }) }) }),
    /* @__PURE__ */ p(Cn, { title: (d == null ? void 0 : d.id) != i.id ? r("Löschen") : r("Löschen des aktiven Elements nicht möglich"), disableInteractive: !0, children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(mi, { disabled: (d == null ? void 0 : d.id) == i.id, onClick: h, edge: "end", "data-cy": "del", className: "mp-inner-remove", children: /* @__PURE__ */ p(TZ, { fontSize: n ? "small" : "medium" }) }) }) })
  ] }) });
}, gte = () => {
  const e = _(YZ("k3_cart_count"));
  return (t) => t == (e == null ? void 0 : e.parentId);
}, e0t = (e) => {
  const t = zt(), i = _(YZ("k3_cart_count")), n = _(cje(i.id, e)), g = _(Go(n.variableId)), r = Bf(g, n);
  return FK((o, I) => t(lK(o, g.id, I, n)), n, g, r.values);
}, rte = ({
  instanceId: e,
  variable: t
}) => {
  const i = e0t(e);
  return i ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ p("div", { onClick: (n) => n.stopPropagation(), onMouseDown: (n) => n.stopPropagation(), style: {
      width: "120px",
      marginRight: "10px",
      flexShrink: 0
    }, className: "k3-instance-count", children: /* @__PURE__ */ p(kK, { placement: "top", isInRange: i.isInRange, resetNumber: i.resetNumber, variable: t, children: /* @__PURE__ */ p(z1, { buttons: !0, "data-cy": "count", onChange: i.onNumberChange, onChangeByStep: i.onInputBlur, onBlur: i.onInputBlur, value: i.pureNumber, TextFieldProps: {
      error: !i.isInRange
    } }) }) })
  ) : null;
}, t0t = () => {
  const e = cK(), t = tlt(), i = (n, g, r) => {
    if (n == "components") {
      const I = e.filter((s) => s.instance.belongsToVariableId == (r == null ? void 0 : r.id));
      return I.length > 0 ? I.map((s) => {
        var a;
        return (a = t.find((d) => d.id == s.valueId)) == null ? void 0 : a.label;
      }).join(", ") : void 0;
    }
    const o = t.find((I) => I.id == (g == null ? void 0 : g.valueId));
    return n === "boolean" || n === "color" || n === "list" ? o == null ? void 0 : o.label : void 0;
  };
  return (n, g, r) => {
    var s, a, d, C, u;
    if (!(g != null && g.type))
      return;
    const o = r ? (g == null ? void 0 : g.label) + ": " : "";
    let I;
    if (ih(g))
      I = (s = n == null ? void 0 : n.data) == null ? void 0 : s.inputText;
    else if (eI(g)) {
      const A = ((a = g == null ? void 0 : g.settings.templateOptions) == null ? void 0 : a.unit) || "", m = ((d = g == null ? void 0 : g.settings) == null ? void 0 : d.templateOptions.digits) || 0;
      I = ((u = (C = n == null ? void 0 : n.data) == null ? void 0 : C.inputValue) == null ? void 0 : u.OC_roundTo(m).toString()) + A;
    } else
      n != null && n.valueId && (I = i(g == null ? void 0 : g.type, n, g));
    return I != null ? o + I : void 0;
  };
}, i0t = (e, t) => e ? t ? t.reason == OS.AlwaysHidden || t.reason == OS.OneValidValue : !0 : !1, n0t = (e, t, i) => {
  const n = qIt(), g = cK(), r = t0t(), o = _((I) => O6(I, i));
  return je(() => {
    const I = t.map((a) => n.find((d) => d.id == a)).filter((a) => a && i0t(a, o[a == null ? void 0 : a.id])).map((a) => {
      const d = g.find((C) => (C.instance.id == i.id || C.instance.belongsToVariableId == (a == null ? void 0 : a.id)) && C.variableId == (a == null ? void 0 : a.id));
      return {
        variable: a,
        selection: d
      };
    }), s = (a) => e.settings.templateOptions.hidePreviewVariableName || ih(a);
    return I == null ? void 0 : I.map((a) => r(a.selection, a.variable, !s(a.variable))).filter((a) => a).join(", ");
  }, [t, n, o, g, i.id, e.settings.templateOptions.hidePreviewVariableName, r]);
}, g0t = ({
  checked: e,
  disabled: t,
  hideCheckbox: i,
  label: n,
  value: g,
  chip: r,
  onEdit: o,
  contextInstance: I,
  variable: s,
  showCount: a,
  isEditable: d,
  secondaryActionChildren: C
}) => {
  const u = RI((y) => y.hoveredSelections), A = RI((y) => y.setHoveredSelection), m = RI((y) => y.removeHoveredSelection), h = g.toString(), B = hi(s), f = n0t(s, B.variablesAsPreview ?? [], I), G = _(Wc);
  return /* @__PURE__ */ p(oD, { disabled: t, value: g, disablePadding: !0, dense: !0, selected: u.includes(h) || G.some((y) => y.id === h), color: G.some((y) => y.id === h) ? "standard" : "primary", onMouseEnter: () => A(h), onMouseLeave: () => m(h), onMouseDown: () => m(h), onClick: () => {
    o && d && o();
  }, children: /* @__PURE__ */ ge(rD, { className: "k3-select-list-item", sx: {
    paddingLeft: 1,
    minHeight: "30px"
  }, children: [
    !i && /* @__PURE__ */ p(Pme, { children: /* @__PURE__ */ p(qm, { checked: e, "data-cy": "ls" }) }),
    !!a && I.id && /* @__PURE__ */ p(rte, { instanceId: I.id, variable: s }),
    /* @__PURE__ */ p(ID, { className: "k3-select-list-text", children: /* @__PURE__ */ ge(fe, { component: "div", "data-cy": "listItemContent_" + n, sx: {
      display: "flex",
      flexDirection: "column",
      maxWidth: "95%",
      overflow: "hidden",
      whiteSpace: "break-spaces"
    }, children: [
      /* @__PURE__ */ p(fe, { component: "div", "data-cy": "listItemBox_" + n, sx: {
        display: "flex",
        flexDirection: "row"
      }, children: /* @__PURE__ */ ge(Ne, { children: [
        r !== void 0 && `${r}. `,
        n
      ] }) }),
      f && /* @__PURE__ */ p(Cn, { title: f, children: /* @__PURE__ */ p(Ne, { variant: "subtitle2", color: "GrayText", noWrap: !0, children: f }) })
    ] }) }),
    C
  ] }) });
}, r0t = ({
  index: e,
  onEdit: t,
  selection: i,
  value: n,
  variable: g
}) => {
  const r = gte();
  return /* @__PURE__ */ p(g0t, { onEdit: () => t(i), hideCheckbox: !0, label: n.label, value: i.id, showCount: r(i.variableId), contextInstance: i, variable: g, isEditable: !0, secondaryActionChildren: /* @__PURE__ */ p(nte, { index: e, instance: i, onEdit: t }) });
}, NU = {
  list: {
    border: "solid 1px rgba(0, 0, 0, 0.38)",
    borderRadius: 1,
    padding: 1,
    overflowY: "auto"
  }
};
function o0t(e) {
  return /* @__PURE__ */ ge(fs, { fullWidth: !0, variant: "outlined", children: [
    !!e.label && /* @__PURE__ */ p(Ne, { color: "textSecondary", children: e.label }),
    e.canDrag && e.onDragEnd && /* @__PURE__ */ p(gE, { onDragEnd: e.onDragEnd, children: /* @__PURE__ */ p(w2, { droppableId: "droppable", children: (t, i) => /* @__PURE__ */ p("div", { ref: t.innerRef, ...t.droppableProps, children: /* @__PURE__ */ ge(PB, { component: "nav", style: e.style, sx: e.listStyles || NU.list, "data-cy": e["data-cy"], children: [
      !!e.headerContent && /* @__PURE__ */ ge(fe, { component: "div", sx: {
        //sticky header
        position: "sticky",
        width: "100%",
        top: 0,
        background: "white"
      }, children: [
        e.headerContent,
        /* @__PURE__ */ p(bs, { "data-cy": "footerDivider" })
      ] }),
      Se.Children.map(e.children || null, (n, g) => /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ p(oE, { draggableId: n.key, index: g, children: (r) => /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ ge(fe, { component: "div", className: "k3-select-list-item-container", ref: r.innerRef, sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        ...r.draggableProps.style || {
          cursor: "grab"
        },
        // ToDo fix, bc component edit buttons can have different widths
        width: "100%"
      }, ...r.draggableProps, ...r.dragHandleProps, children: [
        /* @__PURE__ */ p(Pee, { provided: r, disabled: !1 }),
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /* @__PURE__ */ p("div", { style: {
          flexGrow: 1,
          paddingLeft: 1,
          paddingRight: 1,
          cursor: "pointer",
          width: "100%",
          overflow: "hidden"
        }, children: n })
      ] }) }) }, n.key) })),
      t.placeholder,
      !!e.footerContent && /* @__PURE__ */ ge(fe, { component: "div", sx: {
        //sticky footer
        position: "sticky",
        width: "100%",
        bottom: "-8px",
        background: "white"
      }, children: [
        /* @__PURE__ */ p(bs, { "data-cy": "footerDivider" }),
        e.footerContent
      ] })
    ] }) }) }) }),
    !e.canDrag && /* @__PURE__ */ ge(PB, { component: "nav", style: e.style, sx: e.listStyles || NU.list, "data-cy": e["data-cy"], children: [
      !!e.headerContent && /* @__PURE__ */ p(fe, { component: "div", sx: {
        //sticky header
        position: "sticky",
        width: "100%",
        top: 0,
        background: "white"
      }, children: e.headerContent }),
      Se.Children.map(e.children || null, (t, i) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /* @__PURE__ */ p("div", { children: t })
      )),
      !!e.footerContent && /* @__PURE__ */ p(fe, { component: "div", sx: {
        //sticky footer
        position: "sticky",
        width: "100%",
        bottom: "-8px",
        background: "white"
      }, children: e.footerContent })
    ] })
  ] });
}
var uE = {}, I0t = Cg;
Object.defineProperty(uE, "__esModule", {
  value: !0
});
var AE = uE.default = void 0, l0t = I0t(Kg()), s0t = xg;
AE = uE.default = (0, l0t.default)(/* @__PURE__ */ (0, s0t.jsx)("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");
const LU = R2({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
  select: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    marginBottom: (e) => e.spacing(1)
  }
}), bE = ({
  variable: e,
  values: t,
  addItemType: i,
  contextInstance: n,
  ...g
}) => {
  var B;
  const r = zt(), o = hi(e), I = i ?? (((B = e == null ? void 0 : e.settings) == null ? void 0 : B.template) == "componentListPopup" ? "popup" : "dropdown"), s = Li(), a = n || s, d = cA(a, e, !1), C = (f) => {
    const G = t.find((y) => y.id == f);
    G && r(sA(G, a));
  }, u = _((f) => $Q(f, a)), A = _(vj), m = (f) => {
    r(ig(f.id)), (A == null ? void 0 : A.type) == "group" && r(ba(null));
  }, h = (f) => {
    f.destination && r(ite(f.source.index, f.destination.index, a, e));
  };
  return /* @__PURE__ */ ge(fe, { component: "div", sx: LU.wrapper, className: "k3-component-list-wrapper", children: [
    I == "dropdown" && /* @__PURE__ */ p(fe, { component: "div", sx: LU.select, children: /* @__PURE__ */ p(ZK, { onSelected: (f) => C(f.id), variable: e, addItemLabel: g.addItemLabel, values: t, touchedInvalidOptionsIds: g.touchedInvalidOptionsIds }) }),
    /* @__PURE__ */ p(o0t, { "data-cy": "ocSelectList", defaultValue: -1, style: {
      minHeight: "100px"
    }, canDrag: o.enableDragAndDrop, onDragEnd: h, headerContent: o.reverseSorting ? /* @__PURE__ */ p(TU, { values: t, addType: I, parentInstance: a, onAddItemClicked: g.onAddItemClicked }) : void 0, footerContent: o.reverseSorting ? void 0 : /* @__PURE__ */ p(TU, { values: t, addType: I, parentInstance: a, onAddItemClicked: g.onAddItemClicked }), children: d == null ? void 0 : d.map((f, G) => /* @__PURE__ */ p(r0t, { index: G, onEdit: m, contextInstance: a, selection: f.selection, value: f.value, variable: e }, f.selection.id)) }),
    o.showComponentEditorsInline && u && /* @__PURE__ */ p(fe, { component: "div", sx: {
      pt: 1
    }, children: /* @__PURE__ */ p(ete, { contextInstance: u }) })
  ] }, `${a.id}_${e.id}`);
}, TU = ({
  values: e,
  addType: t,
  parentInstance: i,
  onAddItemClicked: n
}) => {
  const g = zt();
  return t == "dropdown" ? void 0 : /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ p("div", { style: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem"
  }, "data-cy": "footerContent", children: /* @__PURE__ */ p(c0t, { onClick: () => {
    e.length <= 1 ? e.length == 1 && g(sA(e[0], i)) : n == null || n();
  }, disabled: e.length == 0 }) }) });
}, a0t = ({
  onClick: e,
  disabled: t
}) => {
  const i = un();
  return /* @__PURE__ */ ge(Si, { "data-cy": "addComponentButton", variant: "text", color: "inherit", onClick: e, disabled: t, children: [
    /* @__PURE__ */ p(Ne, { variant: "body1", "data-cy": "addComponentButtonText", children: i("translation_mp_popup_add") }),
    /* @__PURE__ */ p(AE, {})
  ] });
}, c0t = ki({
  app: {
    sidebar: {
      componentListPopup: {
        addComponentButton: {
          root: !0
        }
      }
    }
  }
})(a0t), v9t = {
  SelectionTemplate: "Auswahlen",
  OverviewTemplate: "Stückliste"
}, ote = {
  dynamicTranslatedLabelKey: "translation_group_actions_continue",
  id: "continueAction",
  label: "Weiter",
  type: "group"
}, FV = {
  dynamicTranslatedLabelKey: "translation_group_actions_add_item",
  label: "Produkt hinzufügen",
  id: "addItemAction",
  type: "group"
}, d0t = [ote, FV], Ite = {
  dynamicTranslatedLabelKey: "translation_group_multiple_actions",
  label: "Bestätigen",
  id: "multipleActions",
  type: "group"
};
function R9t(e) {
  return e.id !== void 0;
}
function X9t(e) {
  return !ce.has(e, "id");
}
const lte = (e, t, i, n) => {
  if (n != null && n.parentId)
    return !1;
  const g = t.map((o) => o.id);
  e === "backward" && g.reverse();
  const r = g.indexOf(i);
  return t.length - 1 === r;
}, ste = async (e, t, i, n, g, r) => {
  const o = t.map((a) => a.id);
  e === "backward" && o.reverse();
  let I = o.indexOf(i);
  const s = o[++I];
  if (s)
    r(ig(n.id, +s));
  else {
    const a = t.find((d) => d.id === i);
    if (a != null && a.parentId) {
      const d = g.findIndex((u) => u.id === (n == null ? void 0 : n.id)), C = g[d + (e === "forward" ? 1 : -1)];
      r(C ? ig(C.id) : E_(n));
    }
  }
}, C0t = () => {
  var h, B, f, G, y;
  const e = zt(), t = Li(), i = _((W) => jZ(W, t)), n = _((W) => fa(W, t)), g = i.find((W) => W.id === n), r = _(Ai), o = Li(), I = _(T1), s = kD(), a = e$(), d = (W) => W === "backward" && s && a && ((g == null ? void 0 : g.sort) ?? 1) < 2 ? !0 : lte(W, i, n, g), C = async (W) => ste(W, i, n, o, I, e), u = n == ((h = i[i.length - 1]) == null ? void 0 : h.id) && !(g != null && g.parentId), A = !!((B = g == null ? void 0 : g.settings) != null && B.actionIds) && ((f = g == null ? void 0 : g.settings) == null ? void 0 : f.actionIds.length) > 0 || !!((G = r == null ? void 0 : r.settings) != null && G.defaultAction) && u, m = je(() => {
    var V;
    const W = r.settings.actions.find((w) => {
      var v;
      return w.id === ((v = r == null ? void 0 : r.settings) == null ? void 0 : v.defaultAction);
    });
    if ((V = g == null ? void 0 : g.settings) != null && V.actionIds) {
      if (g.settings.actionIds.length === 1)
        return r.settings.actions.find((w) => {
          var v, H;
          return w.id === ((H = (v = g.settings) == null ? void 0 : v.actionIds) == null ? void 0 : H[0]);
        });
      if (g.settings.actionIds.length > 1)
        return Ite;
    } else
      return W;
    return W;
  }, [r, g]);
  return /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ p(A0t, { handleDisabled: d, selectNextGroup: C, showActionButton: A, customActionLabel: (y = g == null ? void 0 : g.settings) == null ? void 0 : y.actionLabel, defaultAction: m || ote }) });
}, u0t = (e) => {
  const {
    handleDisabled: t,
    selectNextGroup: i,
    customActionLabel: n,
    showActionButton: g,
    defaultAction: r,
    onlyShow: o
  } = e, I = un();
  return /* @__PURE__ */ ge(_t, { sx: {
    display: "grid",
    gridAutoFlow: "column",
    gap: 3
  }, children: [
    (!o || o === "backward") && /* @__PURE__ */ p(Si, { "data-cy": "dynBack", variant: "outlined", className: "k3-btn k3-nav-btn k3-secondary-btn k3-btn-back", disabled: t("backward"), onClick: () => i("backward"), children: I(Ii.NAVBAR_BACK) }),
    /* @__PURE__ */ p(Xl, { keys: [Ii.NAVBAR_BACK, Ii.NAVBAR_NEXT] }),
    (!o || o === "forward") && /* @__PURE__ */ p(Jx, { handleDisabled: t, selectNextGroup: i, customActionLabel: n, defaultAction: r, showActionButton: g })
  ] });
}, Jx = (e) => {
  const {
    handleDisabled: t,
    selectNextGroup: i,
    customActionLabel: n,
    defaultAction: g,
    showActionButton: r,
    variant: o
  } = e, I = un(), s = zt();
  return r && g.id !== "continueAction" ? /* @__PURE__ */ p(Si, { "data-cy": "dynLabel", variant: o || "contained", className: "k3-btn k3-nav-btn k3-btn-forward", onClick: () => s(ba(g)), children: n || ("dynamicTranslatedLabelKey" in g ? I(g.dynamicTranslatedLabelKey) : /* @__PURE__ */ p(xm, { value: g.label })) }) : /* @__PURE__ */ p(
    Si,
    {
      "data-cy": "dynNext",
      variant: "contained",
      disabled: t("forward"),
      className: "nextBtn k3-btn k3-nav-btn k3-btn-next",
      onClick: () => {
        i("forward"), s(ba(null));
      },
      children: n || I(Ii.NAVBAR_NEXT)
    }
  );
}, A0t = ki({
  app: {
    navigationButtons: {
      root: !0
    }
  }
})(u0t), b0t = (e) => e == null ? void 0 : e.settings, mE = (e, t) => {
  var i;
  return ((i = b0t(e)) == null ? void 0 : i.actions.filter((n) => !n.hidden || t)) || [];
}, m0t = (e) => [...mE(e, !0), ...d0t], h0t = () => {
  const e = _(vj);
  return !e || !(e.id === Ite.id || e.id === FV.id) ? null : /* @__PURE__ */ p(p0t, {});
}, p0t = () => {
  var x, N;
  const [e, t] = At(void 0), i = zt(), n = () => {
    i(ba(null));
  }, g = Li(), r = un(), o = _(Ai), I = _((M) => jZ(M, g)), s = _((M) => fa(M, g)), a = _((M) => M1(M, g)), d = m0t(o).filter((M) => {
    var $, q;
    return (q = ($ = a == null ? void 0 : a.settings) == null ? void 0 : $.actionIds) == null ? void 0 : q.includes(M.id);
  }), C = _(T1), u = _(Go((g == null ? void 0 : g.variableId) ?? "")), A = d.find((M) => M.id === FV.id), m = d.filter((M) => M.id !== FV.id), h = kD(), B = e$(), f = (M) => h && B ? !0 : lte(M, I, s, a), G = async (M) => ste(M, I, s, g, C, i), y = g$(u), W = U1(), V = IA(), w = V ? "xl" : W("string_group_actions_dialog_size"), v = ((N = (x = u == null ? void 0 : u.settings) == null ? void 0 : x.templateOptions) == null ? void 0 : N.showShoppingCartOnConfirm) ?? !1, H = () => {
    const M = A && m.length > 0 ? [/* @__PURE__ */ p(_t, { direction: "row", gap: "4px", sx: {
      width: "100%"
    }, children: m.map(($) => /* @__PURE__ */ p(Jx, { handleDisabled: f, selectNextGroup: G, defaultAction: d.find((q) => q.id === $.id), showActionButton: !0 }, $.id)) }, "actionButtons")] : [];
    return M.push(/* @__PURE__ */ ge(_t, { direction: "row", gap: "4px", children: [
      /* @__PURE__ */ p(Si, { "data-cy": "cancel", variant: "outlined", className: "k3-btn k3-modal-btn k3-btn-cancel k3-secondary-btn", onClick: () => {
        i(ba(null));
      }, children: r(Ii.NAVBAR_BACK) }),
      A ? v ? void 0 : /* @__PURE__ */ p(Si, { "data-cy": "close", variant: "contained", disabled: !e, className: "k3-btn k3-modal-btn k3-btn-confirm", onClick: () => {
        y(e);
      }, children: r("translation_group_actions_dialog_add_item") }) : /* @__PURE__ */ p(Bt, { children: m.map(($) => /* @__PURE__ */ p(Jx, { handleDisabled: f, selectNextGroup: G, defaultAction: d.find((q) => q.id === $.id), showActionButton: !0 }, $.id)) })
    ] }, "defaultButtons")), M;
  };
  return /* @__PURE__ */ p(_1, { show: !0, maxWidth: w, onClose: n, dataCy: "multipleActionsDialog", className: "k3-multiple-actions-modal", title: v ? /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(w6e, { fontSize: "large" }),
    /* @__PURE__ */ p(XJ, { afterIcon: !0, children: r("translation_group_actions_dialog_title") })
  ] }) : r("translation_group_actions_dialog_title"), settingKeys: B0t, buttons: H(), children: /* @__PURE__ */ p(_t, { sx: {
    gap: 2
  }, children: !!A && u && /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(Z0t, { variable: u, isMobile: V, showShoppingCart: v, currentValue: e, onValueSelected: (M) => t(M) }) }) }) });
}, B0t = ["translation_group_multiple_actions", "translation_group_actions_add_item", "translation_group_actions_continue", "translation_group_actions_dialog_title", "translation_group_actions_dialog_description", "translation_group_actions_dialog_pick_item", "translation_group_actions_dialog_add_item", "string_group_actions_dialog_size", "toggle_mp_dialog_component_display", "translation_mp_popup_not_grouped", "translation_mp_popup_search", "toggle_mp_dialog_hide_searchbar", Ii.NAVBAR_BACK], Z0t = (e) => {
  var G;
  const {
    variable: t,
    showShoppingCart: i
  } = e, [n, g] = At(""), r = _(hJ(t.id)), {
    values: o,
    touchedInvalidOptionsIds: I
  } = Bf(t, r), s = U1(), a = s("toggle_mp_dialog_component_cols"), d = un(), C = e.isMobile ? 1 : a > 0 ? a : 4, u = s("toggle_mp_dialog_component_display"), A = !!i || s("toggle_mp_dialog_hide_searchbar"), m = ((G = t == null ? void 0 : t.settings) == null ? void 0 : G.template) == "componentListPopup", h = n ? o.filter((y) => {
    var W;
    return (W = y.label) == null ? void 0 : W.toLocaleLowerCase().includes(n.toLocaleLowerCase());
  }) : o;
  function B() {
    return /* @__PURE__ */ p(K$, { variable: t, onSelected: e.onValueSelected, fullWidth: !0, value: e.currentValue, colCount: C, verticalValueDisplay: u, values: h, defaultGroupLabel: d("translation_mp_popup_not_grouped"), touchedInvalidOptionsIds: I });
  }
  function f() {
    return /* @__PURE__ */ p(hV, { variable: t, onSelected: e.onValueSelected, fullWidth: !0, value: e.currentValue, colCount: C, verticalValueDisplay: u, values: h, touchedInvalidOptionsIds: I });
  }
  return /* @__PURE__ */ p(Bt, { children: /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ ge(fe, { sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "1rem",
      width: "100%",
      marginBottom: A ? "0" : "8px"
    }, component: "div", "data-cy": "header", children: [
      /* @__PURE__ */ p(Ne, { variant: "body1", sx: {
        paddingBottom: "8px"
      }, children: d("translation_group_actions_dialog_description") }),
      !A && /* @__PURE__ */ p(j$, { currentValue: n, onChange: (y) => {
        g(y);
      }, placeholder: d("translation_mp_popup_search") })
    ] }),
    i ? /* @__PURE__ */ p(bE, { variable: t, onChange: () => {
    }, validOptions: [], invalidOptions: [], contextInstance: r, value: o == null ? void 0 : o[0], values: o, addItemLabel: d("translation_mp_popup_add"), addItemType: "dropdown", touchedInvalidOptionsIds: I }) : m ? t != null && t.settings.templateOptions.groupBy ? B() : f() : /* @__PURE__ */ p(ZK, { addItemLabel: d("translation_group_actions_dialog_pick_item"), variable: t, onSelected: e.onValueSelected, value: e.currentValue, values: o, touchedInvalidOptionsIds: I })
  ] }) });
}, Gc = ({
  text: e,
  multiline: t
}) => {
  const i = un(), n = e;
  return /* @__PURE__ */ ge(Bt, { children: [
    i(n, e),
    /* @__PURE__ */ p(Xl, { keys: [n], display: "dialog", boxProps: {
      width: 0,
      height: 0,
      display: "inline"
    }, settings: [{
      key: n,
      defaultValue: e,
      textarea: t,
      valueType: lc.TRANSLATION
    }] })
  ] });
}, ate = (e, t) => {
  var g;
  const i = X6(), n = ((g = e == null ? void 0 : e.settings) == null ? void 0 : g.url) || `${window.location.protocol}//${i.host}/${(e == null ? void 0 : e.type) || cJ}/`;
  return t ? `${n}?code=${t}` : `${n}?app=${e == null ? void 0 : e.code}`;
}, f0t = (e) => /* @__PURE__ */ ge(Bt, { children: [
  /* @__PURE__ */ p(Ne, { gutterBottom: !0, variant: "h5", component: "h2", children: e.action.confirmationHeader ? /* @__PURE__ */ p(xm, { value: e.action.confirmationHeader }) : /* @__PURE__ */ p(Gc, { text: "Ihre Konfiguration wurde gespeichert" }) }),
  /* @__PURE__ */ p(Ne, { gutterBottom: !0, whiteSpace: "pre-line", children: e.action.confirmationText ? /* @__PURE__ */ p(xm, { value: e.action.confirmationText }) : /* @__PURE__ */ p(Gc, { text: "Mit diesem Link können Sie Ihre Konfiguration wieder aufrufen: " }) }),
  !e.action.confirmationHideLink && /* @__PURE__ */ p(Ne, { gutterBottom: !0, children: /* @__PURE__ */ p(as, { target: "_parent", href: e.savedConfigurationUrl, "data-cy": "cfgUrl", children: e.savedConfigurationUrl }) }),
  /* @__PURE__ */ p(G0t, { ...e })
] }), G0t = (e) => {
  const t = _(Ai), i = e.result.shopLink || __(t, e.result);
  return !e.action.sendToShop || !i ? null : /* @__PURE__ */ ge(fe, { component: "div", sx: {
    mt: 4
  }, children: [
    /* @__PURE__ */ p(Ne, { gutterBottom: !0, children: /* @__PURE__ */ p(Gc, { text: "Sie sollten zum Shop weitergeleitet worden sein. Wenn Sie nicht weitergeleitet wurden klicken Sie bitte hier, um Ihre Bestellung abzuschließen: " }) }),
    /* @__PURE__ */ p(Si, { href: i, target: "_blank", "data-cy": "shopUrl", children: /* @__PURE__ */ p(Gc, { text: "Zum Shop" }) })
  ] });
}, y0t = ki({
  app: {
    orderDialog: {
      confirmation: {
        success: {
          root: !0
        }
      }
    }
  }
})(f0t), W0t = (e) => {
  var i;
  const {
    t
  } = ii();
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(Ne, { gutterBottom: !0, variant: "h5", component: "h2", children: t("Ihre Konfiguration konnte nicht gespeichert werden.") }),
    /* @__PURE__ */ p(Ne, { children: t("Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.") }),
    /* @__PURE__ */ ge(Ne, { children: [
      t("technische Information:"),
      " ",
      (i = e.result) == null ? void 0 : i.message
    ] })
  ] });
}, S0t = ki({
  app: {
    orderDialog: {
      confirmation: {
        error: {
          root: !0
        }
      }
    }
  }
})(W0t), V0t = (e) => {
  var n, g;
  const t = _(Ai), i = ate(t, (n = e.result) == null ? void 0 : n.code);
  return /* @__PURE__ */ p(fe, { component: "div", children: (g = e.result) != null && g.error ? /* @__PURE__ */ p(S0t, { action: e.action, result: e.result }) : /* @__PURE__ */ p(y0t, { savedConfigurationUrl: i, action: e.action, result: e.result }) });
}, hE = ({
  children: e
}) => /* @__PURE__ */ p(fe, { component: "div", my: 2, children: e }), MU = (e) => {
  const {
    i18n: t
  } = ii(), i = _(Wa), n = _(sh), g = new Intl.NumberFormat(t.language, {
    maximumFractionDigits: 3
  }), r = new Intl.NumberFormat(t.language, {
    maximumFractionDigits: 4
  }), o = e.pos;
  let I = o.amount ? r.format(o.amount) : "";
  if (e.showAmount && I && o.price.unit) {
    const s = o.price.unit || "";
    I += s.OC_isCapitalized() ? ` ${s}` : s;
  }
  return /* @__PURE__ */ ge(Jd, { sx: {
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }, children: [
    /* @__PURE__ */ p(xi, { component: "th", scope: "row", children: e.posNo }),
    /* @__PURE__ */ p(xi, { component: "th", scope: "row", children: o.article.no }),
    /* @__PURE__ */ p(xi, { scope: "row", children: o.article.name }),
    n && /* @__PURE__ */ p(xi, { children: i.format(o.priceUnit) }),
    e.showAmount && /* @__PURE__ */ p(xi, { scope: "row", children: I }),
    /* @__PURE__ */ p(xi, { children: g.format(o.qty) }),
    n && /* @__PURE__ */ p(xi, { align: "right", children: o.priceTotal ? i.format(o.priceTotal) : "" })
  ] });
}, w0t = (e, t) => (e.article.sort ?? 0) - (t.article.sort ?? 0), v0t = ({
  dense: e,
  bom: t,
  showPrice: i,
  sortCompareFn: n = w0t
}) => {
  const g = un(), r = _(Wa), o = je(() => {
    var d;
    const a = (d = t.articleLines) == null ? void 0 : d.OC_reduceBy(
      // If number and amount match
      (C, u) => C.article.no == u.article.no && C.amount == u.amount,
      // Merge Items by updating price and count/qty
      (C, u) => (C.qty += u.qty, C.priceTotal += u.priceTotal, C)
    );
    return n ? a.sort(n) : a;
  }, [n, t.articleLines]), I = je(() => n ? (t.surchargeLines ?? []).sort(n) : t.surchargeLines, [n, t.surchargeLines]);
  if (!(o != null && o.length))
    return null;
  const s = o.some((a) => {
    var d;
    return !km(a.amount) || !km((d = a.articleAction) == null ? void 0 : d.amount);
  });
  return /* @__PURE__ */ p(hE, { children: /* @__PURE__ */ p(CD, { component: So, children: /* @__PURE__ */ ge(g1, { sx: e ? {
    width: 1
  } : {
    minWidth: 400
  }, size: e ? "small" : "medium", children: [
    /* @__PURE__ */ p($O, { children: /* @__PURE__ */ ge(Jd, { children: [
      /* @__PURE__ */ p(xi, { align: "left", children: g("order_modal_pos") }),
      /* @__PURE__ */ p(xi, { align: "left", children: g("order_modal_articleNo") }),
      /* @__PURE__ */ p(xi, { align: "left", children: g("order_modal_article") }),
      i && /* @__PURE__ */ p(xi, { align: "left", children: g("order_modal_articlePrice") }),
      s && /* @__PURE__ */ p(xi, { align: "left", children: g("order_modal_articleAmount") }),
      /* @__PURE__ */ p(xi, { align: "left", children: g("order_modal_articleCount") }),
      i && /* @__PURE__ */ p(xi, { align: "right", children: g("order_modal_positionPrice") })
    ] }) }),
    /* @__PURE__ */ ge(o1, { children: [
      o.map((a, d) => /* @__PURE__ */ p(MU, { posNo: d + 1, pos: a, showAmount: s }, d)),
      I.map((a, d) => /* @__PURE__ */ p(MU, { posNo: d + 1, pos: a, showAmount: s }, d)),
      i && /* @__PURE__ */ ge(Jd, { children: [
        /* @__PURE__ */ p(xi, {}),
        /* @__PURE__ */ p(xi, { align: "left", colSpan: s ? 5 : 4, children: g("translation_totalPrice") }),
        /* @__PURE__ */ p(xi, { align: "right", children: t.priceTotal > 0 ? r.format(t.priceTotal) : "" })
      ] })
    ] })
  ] }) }) });
}, cte = ki({
  app: {
    orderDialog: {
      priceTable: {
        articleList: {
          root: !0
        }
      }
    }
  }
})(v0t), R0t = (e) => {
  const t = un(), i = !!e.bom;
  return /* @__PURE__ */ p(_1, { className: "priceInfoDialog", show: i, maxWidth: "md", onClose: e.onClose, title: t(Ii.ORDER_DIALOG_OVERVIEW_PRICEINFO), children: i && /* @__PURE__ */ p(cte, { dense: !0, bom: e.bom, showPrice: e.showPrice }) });
};
var H2 = {}, X0t = Cg;
Object.defineProperty(H2, "__esModule", {
  value: !0
});
var k2 = H2.default = void 0, H0t = X0t(Kg()), k0t = xg;
k2 = H2.default = (0, H0t.default)(/* @__PURE__ */ (0, k0t.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown");
const F0t = /* @__PURE__ */ zz({
  __proto__: null,
  get default() {
    return k2;
  }
}, [H2]);
var pE = {}, Y0t = Cg;
Object.defineProperty(pE, "__esModule", {
  value: !0
});
var BE = pE.default = void 0, x0t = Y0t(Kg()), D0t = xg;
BE = pE.default = (0, x0t.default)(/* @__PURE__ */ (0, D0t.jsx)("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), "KeyboardArrowUp");
const J0t = ({
  row: e,
  hasSubVariables: t = !1,
  showPrice: i,
  onClose: n,
  onShowPriceInfo: g,
  position: r,
  open: o,
  setOpen: I,
  hideArticles: s,
  showGroup: a
}) => {
  var u, A, m;
  const {
    t: d
  } = ii(), C = _(Wa);
  return /* @__PURE__ */ ge(_t, { children: [
    a && /* @__PURE__ */ ge(Bt, { children: [
      r !== "first" && /* @__PURE__ */ p(bs, { sx: {
        my: 1
      } }),
      /* @__PURE__ */ p(Ne, { variant: "h6", children: (u = e.group) == null ? void 0 : u.label })
    ] }),
    /* @__PURE__ */ ge(_t, { sx: {
      display: "flex",
      flexDirection: "row",
      pt: 1
    }, children: [
      t && /* @__PURE__ */ ge(_t, { sx: {
        width: "24px"
      }, children: [
        !!((A = e.subVariables) != null && A.length) && /* @__PURE__ */ p(mi, { "data-cy": "priceSmh", size: "small", sx: {
          p: 0
        }, onClick: () => I(!o), children: o ? /* @__PURE__ */ p(BE, {}) : /* @__PURE__ */ p(k2, {}) }),
        o && /* @__PURE__ */ p(_t, { sx: {
          display: "flex",
          flexGrow: 1,
          borderRight: "1px solid rgba(0, 0, 0, 0.54)",
          mr: 1.5
        } })
      ] }),
      /* @__PURE__ */ ge(_t, { sx: {
        display: "flex",
        flexDirection: "column"
      }, children: [
        /* @__PURE__ */ p(Ne, { variant: "body1", children: e.variable.label }),
        /* @__PURE__ */ ge(_t, { sx: {
          display: "flex",
          flexDirection: "row"
        }, children: [
          /* @__PURE__ */ p(Ne, { variant: "body2", children: e.selectionLabel }),
          e.bom.priceTotal > 0 && !s && /* @__PURE__ */ ge(Ne, { variant: "body2", children: [
            i && /* @__PURE__ */ ge(Bt, { children: [
              ", ",
              d("Preis: "),
              C.format(e.bom.priceTotal)
            ] }),
            /* @__PURE__ */ p(mi, { size: "small", onClick: g, sx: {
              p: 0,
              ml: 1
            }, "data-cy": `info-${(m = e.variable) == null ? void 0 : m.id}`, children: /* @__PURE__ */ p(V1, { fontSize: "inherit" }) })
          ] })
        ] }),
        /* @__PURE__ */ p(vZ, { in: o, timeout: "auto", unmountOnExit: !0, children: /* @__PURE__ */ p(ZE, { className: "k3-subvariable-prices", dense: !1, rows: e.subVariables, onClose: n, onShowPriceInfo: g, hideArticles: s }) })
      ] })
    ] })
  ] });
}, K0t = (e) => {
  var V, w, v, H, x, N;
  const t = IA(), {
    row: i,
    showPrice: n = !0,
    hasSubVariables: g = !1,
    onClose: r,
    onShowPriceInfo: o,
    rowCount: I,
    hideArticles: s,
    showGroup: a
  } = e, d = un(), [C, u] = Se.useState(!1), A = _(Wa), m = zt(), h = _((M) => of(M, i.variable.id)), B = gte(), f = _((M) => $u(M, i.selection)).find((M) => M.id !== i.selection.instance.belongsToInstanceId), G = () => {
    f && m(ig(f.id, i.group.id)), r == null || r();
  }, y = Ilt(), W = e.variable.type == "number" && e.variable.settings.templateOptions.unit || "";
  return t ? /* @__PURE__ */ p(J0t, { ...e, open: C, setOpen: u }) : /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ ge(Jd, { className: "k3-price-table-value-row", id: `k3-price-table-value-row-${((V = i.variable) == null ? void 0 : V.key) || ((w = i.variable) == null ? void 0 : w.label.OC_replaceAll(" ", "-")) || i.index}`, sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }, children: [
      /* @__PURE__ */ p(xi, { className: "k3-price-table-group", children: a && ((v = i.group) == null ? void 0 : v.label) }),
      g && /* @__PURE__ */ p(xi, { className: "k3-price-table-expand", children: !!((H = i.subVariables) != null && H.length) && /* @__PURE__ */ p(mi, { "data-cy": "priceSmh", "aria-label": "Expand row", size: "small", onClick: () => u(!C), children: C ? /* @__PURE__ */ p(BE, {}) : /* @__PURE__ */ p(k2, {}) }) }),
      /* @__PURE__ */ p(xi, { scope: "row", className: "k3-price-table-label", children: i.variable.label }),
      /* @__PURE__ */ p(xi, { className: "k3-price-table-value", children: i.selectionLabel + " " + W }),
      n && /* @__PURE__ */ p(xi, { align: "right", className: "k3-price-table-price", children: i.bom.priceTotal > 0 && A.format(i.bom.priceTotal) }),
      /* @__PURE__ */ p(xi, { align: "right", width: "60px", className: "k3-price-table-count", children: /* @__PURE__ */ ge("div", { style: {
        display: "flex",
        flexDirection: "row"
      }, children: [
        B(i.selection.variableId) && !!i.selection.id && /* @__PURE__ */ p(rte, { instanceId: i.selection.id, variable: e.variable }),
        I > 1 && i.variable.type === "components" && !h && /* @__PURE__ */ p(Cn, { title: "Instanz löschen", children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(mi, { size: "small", onClick: () => y(i.selection), "data-cy": "deleteInstances", children: /* @__PURE__ */ p(TZ, { fontSize: "inherit" }) }) }) }),
        i.variable.type !== "components" && /* @__PURE__ */ p(Cn, { title: "Zum Merkmal-Editor", children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(mi, { size: "small", onClick: G, "data-cy": `edit-${(x = i.variable) == null ? void 0 : x.id}`, children: /* @__PURE__ */ p(S1, { fontSize: "inherit" }) }) }) }),
        i.bom.priceTotal > 0 && !s && /* @__PURE__ */ p(Cn, { title: d("order_modal_priceDetails"), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(mi, { size: "small", onClick: o, "data-cy": `info-${(N = i.variable) == null ? void 0 : N.id}`, children: /* @__PURE__ */ p(V1, { fontSize: "inherit" }) }) }) })
      ] }) })
    ] }),
    /* @__PURE__ */ p(Jd, { children: /* @__PURE__ */ p(xi, { style: {
      paddingBottom: 0,
      paddingTop: 0
    }, colSpan: 6, className: "k3-price-table-sub-prices", children: /* @__PURE__ */ p(vZ, { in: C, timeout: "auto", unmountOnExit: !0, children: /* @__PURE__ */ p(ZE, { dense: !1, rows: i.subVariables, onClose: r, onShowPriceInfo: o, hideArticles: s }) }) }) })
  ] });
}, E0t = (e) => {
  const t = _(Y$e);
  return /* @__PURE__ */ p(ZE, { className: "k3-variable-prices", dense: e.dense, rows: t, onClose: e.onClose, onShowPriceInfo: e.onShowPriceInfo, hideArticles: e.hideArticles });
};
function ZE({
  rows: e,
  onClose: t,
  onShowPriceInfo: i,
  ...n
}) {
  const g = e == null ? void 0 : e.some((C) => {
    var u;
    return ((u = C.variable) == null ? void 0 : u.type) == "components";
  }), r = _(sh), o = un(), I = IA(), s = (C, u) => e.findIndex((A) => {
    var m;
    return ((m = A.group) == null ? void 0 : m.id) == u;
  }) == C, a = (C) => C ? C === e.length - 1 ? "last" : "mid" : "first", d = () => e.map((C, u) => {
    var A;
    return /* @__PURE__ */ p(K0t, { hasSubVariables: g, showPrice: r, row: C, onClose: t, onShowPriceInfo: () => i(C.bom), position: a(u), rowCount: e.length, hideArticles: n.hideArticles, variable: C.variable, showGroup: s(u, (A = C == null ? void 0 : C.group) == null ? void 0 : A.id) }, C.selection.id);
  });
  return I ? /* @__PURE__ */ p(_t, { className: Ve("k3-price-table k3-price-table-mobile", n.className), children: d() }) : /* @__PURE__ */ p(hE, { children: /* @__PURE__ */ p(CD, { component: So, children: /* @__PURE__ */ ge(g1, { sx: n.dense ? {
    width: 1
  } : {
    minWidth: 400
  }, size: n.dense ? "small" : "medium", className: Ve("k3-price-table k3-price-table-desktop", n.className), children: [
    /* @__PURE__ */ p($O, { children: /* @__PURE__ */ ge(Jd, { children: [
      /* @__PURE__ */ p(xi, { align: "left", children: o(Ii.ORDER_DIALOG_OVERVIEW_STEP) }),
      g && /* @__PURE__ */ p(xi, {}),
      /* @__PURE__ */ p(xi, { align: "left", children: o(Ii.ORDER_DIALOG_OVERVIEW_VARIABLE) }),
      /* @__PURE__ */ p(xi, { align: "left", children: o(Ii.ORDER_DIALOG_OVERVIEW_SELECTION) }),
      r && /* @__PURE__ */ p(xi, { align: "right", children: o(Ii.ORDER_DIALOG_OVERVIEW_PRICE) }),
      /* @__PURE__ */ p(xi, { align: "right" })
    ] }) }),
    /* @__PURE__ */ p(o1, { children: d() })
  ] }) }) });
}
const N0t = ki({
  app: {
    orderDialog: {
      priceTable: {
        selectionList: {
          root: !0
        }
      }
    }
  }
})(E0t), L0t = ({
  dense: e,
  onShowPriceInfo: t,
  hideArticles: i
}) => {
  const n = un(), g = _(x$e);
  return /* @__PURE__ */ p(hE, { children: /* @__PURE__ */ p(CD, { component: So, children: /* @__PURE__ */ p(g1, { sx: e ? {
    width: 1
  } : {
    minWidth: 400
  }, size: e ? "small" : "medium", className: "oc-price-table-total", children: /* @__PURE__ */ p(o1, { children: /* @__PURE__ */ ge(Jd, { sx: {
    padding: 0
  }, children: [
    /* @__PURE__ */ p(xi, { align: "left", sx: {
      fontWeight: "600"
    }, children: n(Ii.ORDER_DIALOG_OVERVIEW_TOTALPRICE) }),
    /* @__PURE__ */ p(xi, { align: "right", children: g }),
    /* @__PURE__ */ p(xi, { align: "right", width: "60px", children: !i && /* @__PURE__ */ p(Cn, { title: n("order_modal_priceDetails"), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(mi, { size: "small", "data-cy": "infoPrice", onClick: t, children: /* @__PURE__ */ p(V1, { fontSize: "inherit" }) }) }) }) })
  ] }, "overall-price") }) }) }) });
}, T0t = ki({
  app: {
    orderDialog: {
      priceTable: {
        total: {
          root: !0
        }
      }
    }
  }
})(L0t);
function M0t({
  dense: e = !1,
  onClose: t,
  action: i
}) {
  const n = _(eA), g = _(sh), [r, o] = At(null), {
    t: I
  } = ii(), s = un();
  return i.overviewType === "articlesOnly" ? /* @__PURE__ */ p(fe, { component: "div", className: "orderDialogArticleTable", children: /* @__PURE__ */ p(cte, { showPrice: g, bom: n, dense: e }) }) : /* @__PURE__ */ ge(fe, { component: "div", className: "orderDialogPriceTable", children: [
    /* @__PURE__ */ p(Ne, { color: "primary", variant: "h6", children: g ? s(Ii.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE) : I("Auswahlen") }),
    /* @__PURE__ */ p(N0t, { dense: e, onShowPriceInfo: o, onClose: t, hideArticles: i.overviewType === "variablesOnly" }),
    g && /* @__PURE__ */ p(T0t, { dense: e, onShowPriceInfo: () => o(n), hideArticles: i.overviewType === "variablesOnly" }),
    /* @__PURE__ */ p(R0t, { bom: r, showPrice: g, onClose: () => o(null) })
  ] });
}
const U0t = ki({
  app: {
    orderDialog: {
      priceTable: {
        root: !0
      }
    }
  }
})(M0t);
var Hf = (e) => e.type === "checkbox", Cm = (e) => e instanceof Date, mo = (e) => e == null;
const dte = (e) => typeof e == "object";
var jg = (e) => !mo(e) && !Array.isArray(e) && dte(e) && !Cm(e), P0t = (e) => jg(e) && e.target ? Hf(e.target) ? e.target.checked : e.target.value : e, z0t = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, O0t = (e, t) => e.has(z0t(t)), Q0t = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return jg(t) && t.hasOwnProperty("isPrototypeOf");
}, fE = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function rl(e) {
  let t;
  const i = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(fE && (e instanceof Blob || e instanceof FileList)) && (i || jg(e)))
    if (t = i ? [] : {}, !i && !Q0t(e))
      t = e;
    else
      for (const n in e)
        e.hasOwnProperty(n) && (t[n] = rl(e[n]));
  else
    return e;
  return t;
}
var kf = (e) => Array.isArray(e) ? e.filter(Boolean) : [], fg = (e) => e === void 0, Tt = (e, t, i) => {
  if (!t || !jg(e))
    return i;
  const n = kf(t.split(/[,[\].]+?/)).reduce((g, r) => mo(g) ? g : g[r], e);
  return fg(n) || n === e ? fg(e[t]) ? i : e[t] : n;
}, sc = (e) => typeof e == "boolean";
const UU = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ss = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ic = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
Se.createContext(null);
var j0t = (e, t, i, n = !0) => {
  const g = {
    defaultValues: t._defaultValues
  };
  for (const r in e)
    Object.defineProperty(g, r, {
      get: () => {
        const o = r;
        return t._proxyFormState[o] !== ss.all && (t._proxyFormState[o] = !n || ss.all), e[o];
      }
    });
  return g;
}, bI = (e) => jg(e) && !Object.keys(e).length, _0t = (e, t, i, n) => {
  i(e);
  const { name: g, ...r } = e;
  return bI(r) || Object.keys(r).length >= Object.keys(t).length || Object.keys(r).find((o) => t[o] === ss.all);
}, RF = (e) => Array.isArray(e) ? e : [e];
function $0t(e) {
  const t = Se.useRef(e);
  t.current = e, Se.useEffect(() => {
    const i = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      i && i.unsubscribe();
    };
  }, [e.disabled]);
}
var ea = (e) => typeof e == "string", q0t = (e, t, i, n, g) => ea(e) ? (n && t.watch.add(e), Tt(i, e, g)) : Array.isArray(e) ? e.map((r) => (n && t.watch.add(r), Tt(i, r))) : (n && (t.watchAll = !0), i), GE = (e) => /^\w*$/.test(e), Cte = (e) => kf(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Sn = (e, t, i) => {
  let n = -1;
  const g = GE(t) ? [t] : Cte(t), r = g.length, o = r - 1;
  for (; ++n < r; ) {
    const I = g[n];
    let s = i;
    if (n !== o) {
      const a = e[I];
      s = jg(a) || Array.isArray(a) ? a : isNaN(+g[n + 1]) ? {} : [];
    }
    e[I] = s, e = e[I];
  }
  return e;
}, ute = (e, t, i, n, g) => t ? {
  ...i[e],
  types: {
    ...i[e] && i[e].types ? i[e].types : {},
    [n]: g || !0
  }
} : {}, PU = (e) => ({
  isOnSubmit: !e || e === ss.onSubmit,
  isOnBlur: e === ss.onBlur,
  isOnChange: e === ss.onChange,
  isOnAll: e === ss.all,
  isOnTouch: e === ss.onTouched
}), zU = (e, t, i) => !i && (t.watchAll || t.watch.has(e) || [...t.watch].some((n) => e.startsWith(n) && /^\.\w+/.test(e.slice(n.length))));
const RB = (e, t, i, n) => {
  for (const g of i || Object.keys(e)) {
    const r = Tt(e, g);
    if (r) {
      const { _f: o, ...I } = r;
      if (o) {
        if (o.refs && o.refs[0] && t(o.refs[0], g) && !n)
          break;
        if (o.ref && t(o.ref, o.name) && !n)
          break;
        RB(I, t);
      } else
        jg(I) && RB(I, t);
    }
  }
};
var eBt = (e, t, i) => {
  const n = kf(Tt(e, i));
  return Sn(n, "root", t[i]), Sn(e, i, n), e;
}, yE = (e) => e.type === "file", Sd = (e) => typeof e == "function", YV = (e) => {
  if (!fE)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, BS = (e) => ea(e), WE = (e) => e.type === "radio", xV = (e) => e instanceof RegExp;
const OU = {
  value: !1,
  isValid: !1
}, QU = { value: !0, isValid: !0 };
var Ate = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((i) => i && i.checked && !i.disabled).map((i) => i.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !fg(e[0].attributes.value) ? fg(e[0].value) || e[0].value === "" ? QU : { value: e[0].value, isValid: !0 } : QU
    ) : OU;
  }
  return OU;
};
const jU = {
  isValid: !1,
  value: null
};
var bte = (e) => Array.isArray(e) ? e.reduce((t, i) => i && i.checked && !i.disabled ? {
  isValid: !0,
  value: i.value
} : t, jU) : jU;
function _U(e, t, i = "validate") {
  if (BS(e) || Array.isArray(e) && e.every(BS) || sc(e) && !e)
    return {
      type: i,
      message: BS(e) ? e : "",
      ref: t
    };
}
var jb = (e) => jg(e) && !xV(e) ? e : {
  value: e,
  message: ""
}, $U = async (e, t, i, n, g) => {
  const { ref: r, refs: o, required: I, maxLength: s, minLength: a, min: d, max: C, pattern: u, validate: A, name: m, valueAsNumber: h, mount: B, disabled: f } = e._f, G = Tt(t, m);
  if (!B || f)
    return {};
  const y = o ? o[0] : r, W = ($) => {
    n && y.reportValidity && (y.setCustomValidity(sc($) ? "" : $ || ""), y.reportValidity());
  }, V = {}, w = WE(r), v = Hf(r), H = w || v, x = (h || yE(r)) && fg(r.value) && fg(G) || YV(r) && r.value === "" || G === "" || Array.isArray(G) && !G.length, N = ute.bind(null, m, i, V), M = ($, q, E, L = ic.maxLength, P = ic.minLength) => {
    const Q = $ ? q : E;
    V[m] = {
      type: $ ? L : P,
      message: Q,
      ref: r,
      ...N($ ? L : P, Q)
    };
  };
  if (g ? !Array.isArray(G) || !G.length : I && (!H && (x || mo(G)) || sc(G) && !G || v && !Ate(o).isValid || w && !bte(o).isValid)) {
    const { value: $, message: q } = BS(I) ? { value: !!I, message: I } : jb(I);
    if ($ && (V[m] = {
      type: ic.required,
      message: q,
      ref: y,
      ...N(ic.required, q)
    }, !i))
      return W(q), V;
  }
  if (!x && (!mo(d) || !mo(C))) {
    let $, q;
    const E = jb(C), L = jb(d);
    if (!mo(G) && !isNaN(G)) {
      const P = r.valueAsNumber || G && +G;
      mo(E.value) || ($ = P > E.value), mo(L.value) || (q = P < L.value);
    } else {
      const P = r.valueAsDate || new Date(G), Q = (Ae) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Ae), te = r.type == "time", le = r.type == "week";
      ea(E.value) && G && ($ = te ? Q(G) > Q(E.value) : le ? G > E.value : P > new Date(E.value)), ea(L.value) && G && (q = te ? Q(G) < Q(L.value) : le ? G < L.value : P < new Date(L.value));
    }
    if (($ || q) && (M(!!$, E.message, L.message, ic.max, ic.min), !i))
      return W(V[m].message), V;
  }
  if ((s || a) && !x && (ea(G) || g && Array.isArray(G))) {
    const $ = jb(s), q = jb(a), E = !mo($.value) && G.length > +$.value, L = !mo(q.value) && G.length < +q.value;
    if ((E || L) && (M(E, $.message, q.message), !i))
      return W(V[m].message), V;
  }
  if (u && !x && ea(G)) {
    const { value: $, message: q } = jb(u);
    if (xV($) && !G.match($) && (V[m] = {
      type: ic.pattern,
      message: q,
      ref: r,
      ...N(ic.pattern, q)
    }, !i))
      return W(q), V;
  }
  if (A) {
    if (Sd(A)) {
      const $ = await A(G, t), q = _U($, y);
      if (q && (V[m] = {
        ...q,
        ...N(ic.validate, q.message)
      }, !i))
        return W(q.message), V;
    } else if (jg(A)) {
      let $ = {};
      for (const q in A) {
        if (!bI($) && !i)
          break;
        const E = _U(await A[q](G, t), y, q);
        E && ($ = {
          ...E,
          ...N(q, E.message)
        }, W(E.message), i && (V[m] = $));
      }
      if (!bI($) && (V[m] = {
        ref: y,
        ...$
      }, !i))
        return V;
    }
  }
  return W(!0), V;
};
function tBt(e, t) {
  const i = t.slice(0, -1).length;
  let n = 0;
  for (; n < i; )
    e = fg(e) ? n++ : e[t[n++]];
  return e;
}
function iBt(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !fg(e[t]))
      return !1;
  return !0;
}
function Ug(e, t) {
  const i = Array.isArray(t) ? t : GE(t) ? [t] : Cte(t), n = i.length === 1 ? e : tBt(e, i), g = i.length - 1, r = i[g];
  return n && delete n[r], g !== 0 && (jg(n) && bI(n) || Array.isArray(n) && iBt(n)) && Ug(e, i.slice(0, -1)), e;
}
var XF = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (g) => {
      for (const r of e)
        r.next && r.next(g);
    },
    subscribe: (g) => (e.push(g), {
      unsubscribe: () => {
        e = e.filter((r) => r !== g);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, DV = (e) => mo(e) || !dte(e);
function Su(e, t) {
  if (DV(e) || DV(t))
    return e === t;
  if (Cm(e) && Cm(t))
    return e.getTime() === t.getTime();
  const i = Object.keys(e), n = Object.keys(t);
  if (i.length !== n.length)
    return !1;
  for (const g of i) {
    const r = e[g];
    if (!n.includes(g))
      return !1;
    if (g !== "ref") {
      const o = t[g];
      if (Cm(r) && Cm(o) || jg(r) && jg(o) || Array.isArray(r) && Array.isArray(o) ? !Su(r, o) : r !== o)
        return !1;
    }
  }
  return !0;
}
var mte = (e) => e.type === "select-multiple", nBt = (e) => WE(e) || Hf(e), HF = (e) => YV(e) && e.isConnected, hte = (e) => {
  for (const t in e)
    if (Sd(e[t]))
      return !0;
  return !1;
};
function JV(e, t = {}) {
  const i = Array.isArray(e);
  if (jg(e) || i)
    for (const n in e)
      Array.isArray(e[n]) || jg(e[n]) && !hte(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, JV(e[n], t[n])) : mo(e[n]) || (t[n] = !0);
  return t;
}
function pte(e, t, i) {
  const n = Array.isArray(e);
  if (jg(e) || n)
    for (const g in e)
      Array.isArray(e[g]) || jg(e[g]) && !hte(e[g]) ? fg(t) || DV(i[g]) ? i[g] = Array.isArray(e[g]) ? JV(e[g], []) : { ...JV(e[g]) } : pte(e[g], mo(t) ? {} : t[g], i[g]) : i[g] = !Su(e[g], t[g]);
  return i;
}
var TW = (e, t) => pte(e, t, JV(t)), Bte = (e, { valueAsNumber: t, valueAsDate: i, setValueAs: n }) => fg(e) ? e : t ? e === "" ? NaN : e && +e : i && ea(e) ? new Date(e) : n ? n(e) : e;
function kF(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((i) => i.disabled) : t.disabled))
    return yE(t) ? t.files : WE(t) ? bte(e.refs).value : mte(t) ? [...t.selectedOptions].map(({ value: i }) => i) : Hf(t) ? Ate(e.refs).value : Bte(fg(t.value) ? e.ref.value : t.value, e);
}
var gBt = (e, t, i, n) => {
  const g = {};
  for (const r of e) {
    const o = Tt(t, r);
    o && Sn(g, r, o._f);
  }
  return {
    criteriaMode: i,
    names: [...e],
    fields: g,
    shouldUseNativeValidation: n
  };
}, K0 = (e) => fg(e) ? e : xV(e) ? e.source : jg(e) ? xV(e.value) ? e.value.source : e.value : e, rBt = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function qU(e, t, i) {
  const n = Tt(e, i);
  if (n || GE(i))
    return {
      error: n,
      name: i
    };
  const g = i.split(".");
  for (; g.length; ) {
    const r = g.join("."), o = Tt(t, r), I = Tt(e, r);
    if (o && !Array.isArray(o) && i !== r)
      return { name: i };
    if (I && I.type)
      return {
        name: r,
        error: I
      };
    g.pop();
  }
  return {
    name: i
  };
}
var oBt = (e, t, i, n, g) => g.isOnAll ? !1 : !i && g.isOnTouch ? !(t || e) : (i ? n.isOnBlur : g.isOnBlur) ? !e : (i ? n.isOnChange : g.isOnChange) ? e : !0, IBt = (e, t) => !kf(Tt(e, t)).length && Ug(e, t);
const lBt = {
  mode: ss.onSubmit,
  reValidateMode: ss.onChange,
  shouldFocusError: !0
};
function sBt(e = {}) {
  let t = {
    ...lBt,
    ...e
  }, i = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Sd(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, n = {}, g = jg(t.defaultValues) || jg(t.values) ? rl(t.defaultValues || t.values) || {} : {}, r = t.shouldUnregister ? {} : rl(g), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, I = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, s, a = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, C = {
    values: XF(),
    array: XF(),
    state: XF()
  }, u = PU(t.mode), A = PU(t.reValidateMode), m = t.criteriaMode === ss.all, h = (ie) => (J) => {
    clearTimeout(a), a = setTimeout(ie, J);
  }, B = async (ie) => {
    if (d.isValid || ie) {
      const J = t.resolver ? bI((await H()).errors) : await N(n, !0);
      J !== i.isValid && C.state.next({
        isValid: J
      });
    }
  }, f = (ie, J) => {
    (d.isValidating || d.validatingFields) && ((ie || Array.from(I.mount)).forEach((Ce) => {
      Ce && (J ? Sn(i.validatingFields, Ce, J) : Ug(i.validatingFields, Ce));
    }), C.state.next({
      validatingFields: i.validatingFields,
      isValidating: !bI(i.validatingFields)
    }));
  }, G = (ie, J = [], Ce, xe, Le = !0, Ye = !0) => {
    if (xe && Ce) {
      if (o.action = !0, Ye && Array.isArray(Tt(n, ie))) {
        const qe = Ce(Tt(n, ie), xe.argA, xe.argB);
        Le && Sn(n, ie, qe);
      }
      if (Ye && Array.isArray(Tt(i.errors, ie))) {
        const qe = Ce(Tt(i.errors, ie), xe.argA, xe.argB);
        Le && Sn(i.errors, ie, qe), IBt(i.errors, ie);
      }
      if (d.touchedFields && Ye && Array.isArray(Tt(i.touchedFields, ie))) {
        const qe = Ce(Tt(i.touchedFields, ie), xe.argA, xe.argB);
        Le && Sn(i.touchedFields, ie, qe);
      }
      d.dirtyFields && (i.dirtyFields = TW(g, r)), C.state.next({
        name: ie,
        isDirty: $(ie, J),
        dirtyFields: i.dirtyFields,
        errors: i.errors,
        isValid: i.isValid
      });
    } else
      Sn(r, ie, J);
  }, y = (ie, J) => {
    Sn(i.errors, ie, J), C.state.next({
      errors: i.errors
    });
  }, W = (ie) => {
    i.errors = ie, C.state.next({
      errors: i.errors,
      isValid: !1
    });
  }, V = (ie, J, Ce, xe) => {
    const Le = Tt(n, ie);
    if (Le) {
      const Ye = Tt(r, ie, fg(Ce) ? Tt(g, ie) : Ce);
      fg(Ye) || xe && xe.defaultChecked || J ? Sn(r, ie, J ? Ye : kF(Le._f)) : L(ie, Ye), o.mount && B();
    }
  }, w = (ie, J, Ce, xe, Le) => {
    let Ye = !1, qe = !1;
    const Yt = {
      name: ie
    }, qt = !!(Tt(n, ie) && Tt(n, ie)._f.disabled);
    if (!Ce || xe) {
      d.isDirty && (qe = i.isDirty, i.isDirty = Yt.isDirty = $(), Ye = qe !== Yt.isDirty);
      const Ut = qt || Su(Tt(g, ie), J);
      qe = !!(!qt && Tt(i.dirtyFields, ie)), Ut || qt ? Ug(i.dirtyFields, ie) : Sn(i.dirtyFields, ie, !0), Yt.dirtyFields = i.dirtyFields, Ye = Ye || d.dirtyFields && qe !== !Ut;
    }
    if (Ce) {
      const Ut = Tt(i.touchedFields, ie);
      Ut || (Sn(i.touchedFields, ie, Ce), Yt.touchedFields = i.touchedFields, Ye = Ye || d.touchedFields && Ut !== Ce);
    }
    return Ye && Le && C.state.next(Yt), Ye ? Yt : {};
  }, v = (ie, J, Ce, xe) => {
    const Le = Tt(i.errors, ie), Ye = d.isValid && sc(J) && i.isValid !== J;
    if (e.delayError && Ce ? (s = h(() => y(ie, Ce)), s(e.delayError)) : (clearTimeout(a), s = null, Ce ? Sn(i.errors, ie, Ce) : Ug(i.errors, ie)), (Ce ? !Su(Le, Ce) : Le) || !bI(xe) || Ye) {
      const qe = {
        ...xe,
        ...Ye && sc(J) ? { isValid: J } : {},
        errors: i.errors,
        name: ie
      };
      i = {
        ...i,
        ...qe
      }, C.state.next(qe);
    }
  }, H = async (ie) => {
    f(ie, !0);
    const J = await t.resolver(r, t.context, gBt(ie || I.mount, n, t.criteriaMode, t.shouldUseNativeValidation));
    return f(ie), J;
  }, x = async (ie) => {
    const { errors: J } = await H(ie);
    if (ie)
      for (const Ce of ie) {
        const xe = Tt(J, Ce);
        xe ? Sn(i.errors, Ce, xe) : Ug(i.errors, Ce);
      }
    else
      i.errors = J;
    return J;
  }, N = async (ie, J, Ce = {
    valid: !0
  }) => {
    for (const xe in ie) {
      const Le = ie[xe];
      if (Le) {
        const { _f: Ye, ...qe } = Le;
        if (Ye) {
          const Yt = I.array.has(Ye.name);
          f([xe], !0);
          const qt = await $U(Le, r, m, t.shouldUseNativeValidation && !J, Yt);
          if (f([xe]), qt[Ye.name] && (Ce.valid = !1, J))
            break;
          !J && (Tt(qt, Ye.name) ? Yt ? eBt(i.errors, qt, Ye.name) : Sn(i.errors, Ye.name, qt[Ye.name]) : Ug(i.errors, Ye.name));
        }
        qe && await N(qe, J, Ce);
      }
    }
    return Ce.valid;
  }, M = () => {
    for (const ie of I.unMount) {
      const J = Tt(n, ie);
      J && (J._f.refs ? J._f.refs.every((Ce) => !HF(Ce)) : !HF(J._f.ref)) && ue(ie);
    }
    I.unMount = /* @__PURE__ */ new Set();
  }, $ = (ie, J) => (ie && J && Sn(r, ie, J), !Su(we(), g)), q = (ie, J, Ce) => q0t(ie, I, {
    ...o.mount ? r : fg(J) ? g : ea(ie) ? { [ie]: J } : J
  }, Ce, J), E = (ie) => kf(Tt(o.mount ? r : g, ie, e.shouldUnregister ? Tt(g, ie, []) : [])), L = (ie, J, Ce = {}) => {
    const xe = Tt(n, ie);
    let Le = J;
    if (xe) {
      const Ye = xe._f;
      Ye && (!Ye.disabled && Sn(r, ie, Bte(J, Ye)), Le = YV(Ye.ref) && mo(J) ? "" : J, mte(Ye.ref) ? [...Ye.ref.options].forEach((qe) => qe.selected = Le.includes(qe.value)) : Ye.refs ? Hf(Ye.ref) ? Ye.refs.length > 1 ? Ye.refs.forEach((qe) => (!qe.defaultChecked || !qe.disabled) && (qe.checked = Array.isArray(Le) ? !!Le.find((Yt) => Yt === qe.value) : Le === qe.value)) : Ye.refs[0] && (Ye.refs[0].checked = !!Le) : Ye.refs.forEach((qe) => qe.checked = qe.value === Le) : yE(Ye.ref) ? Ye.ref.value = "" : (Ye.ref.value = Le, Ye.ref.type || C.values.next({
        name: ie,
        values: { ...r }
      })));
    }
    (Ce.shouldDirty || Ce.shouldTouch) && w(ie, Le, Ce.shouldTouch, Ce.shouldDirty, !0), Ce.shouldValidate && Ae(ie);
  }, P = (ie, J, Ce) => {
    for (const xe in J) {
      const Le = J[xe], Ye = `${ie}.${xe}`, qe = Tt(n, Ye);
      (I.array.has(ie) || !DV(Le) || qe && !qe._f) && !Cm(Le) ? P(Ye, Le, Ce) : L(Ye, Le, Ce);
    }
  }, Q = (ie, J, Ce = {}) => {
    const xe = Tt(n, ie), Le = I.array.has(ie), Ye = rl(J);
    Sn(r, ie, Ye), Le ? (C.array.next({
      name: ie,
      values: { ...r }
    }), (d.isDirty || d.dirtyFields) && Ce.shouldDirty && C.state.next({
      name: ie,
      dirtyFields: TW(g, r),
      isDirty: $(ie, Ye)
    })) : xe && !xe._f && !mo(Ye) ? P(ie, Ye, Ce) : L(ie, Ye, Ce), zU(ie, I) && C.state.next({ ...i }), C.values.next({
      name: o.mount ? ie : void 0,
      values: { ...r }
    });
  }, te = async (ie) => {
    o.mount = !0;
    const J = ie.target;
    let Ce = J.name, xe = !0;
    const Le = Tt(n, Ce), Ye = () => J.type ? kF(Le._f) : P0t(ie), qe = (Yt) => {
      xe = Number.isNaN(Yt) || Yt === Tt(r, Ce, Yt);
    };
    if (Le) {
      let Yt, qt;
      const Ut = Ye(), Ge = ie.type === UU.BLUR || ie.type === UU.FOCUS_OUT, pe = !rBt(Le._f) && !t.resolver && !Tt(i.errors, Ce) && !Le._f.deps || oBt(Ge, Tt(i.touchedFields, Ce), i.isSubmitted, A, u), _e = zU(Ce, I, Ge);
      Sn(r, Ce, Ut), Ge ? (Le._f.onBlur && Le._f.onBlur(ie), s && s(0)) : Le._f.onChange && Le._f.onChange(ie);
      const Gt = w(Ce, Ut, Ge, !1), Jt = !bI(Gt) || _e;
      if (!Ge && C.values.next({
        name: Ce,
        type: ie.type,
        values: { ...r }
      }), pe)
        return d.isValid && B(), Jt && C.state.next({ name: Ce, ..._e ? {} : Gt });
      if (!Ge && _e && C.state.next({ ...i }), t.resolver) {
        const { errors: Te } = await H([Ce]);
        if (qe(Ut), xe) {
          const Xt = qU(i.errors, n, Ce), Pe = qU(Te, n, Xt.name || Ce);
          Yt = Pe.error, Ce = Pe.name, qt = bI(Te);
        }
      } else
        f([Ce], !0), Yt = (await $U(Le, r, m, t.shouldUseNativeValidation))[Ce], f([Ce]), qe(Ut), xe && (Yt ? qt = !1 : d.isValid && (qt = await N(n, !0)));
      xe && (Le._f.deps && Ae(Le._f.deps), v(Ce, qt, Yt, Gt));
    }
  }, le = (ie, J) => {
    if (Tt(i.errors, J) && ie.focus)
      return ie.focus(), 1;
  }, Ae = async (ie, J = {}) => {
    let Ce, xe;
    const Le = RF(ie);
    if (t.resolver) {
      const Ye = await x(fg(ie) ? ie : Le);
      Ce = bI(Ye), xe = ie ? !Le.some((qe) => Tt(Ye, qe)) : Ce;
    } else
      ie ? (xe = (await Promise.all(Le.map(async (Ye) => {
        const qe = Tt(n, Ye);
        return await N(qe && qe._f ? { [Ye]: qe } : qe);
      }))).every(Boolean), !(!xe && !i.isValid) && B()) : xe = Ce = await N(n);
    return C.state.next({
      ...!ea(ie) || d.isValid && Ce !== i.isValid ? {} : { name: ie },
      ...t.resolver || !ie ? { isValid: Ce } : {},
      errors: i.errors
    }), J.shouldFocus && !xe && RB(n, le, ie ? Le : I.mount), xe;
  }, we = (ie) => {
    const J = {
      ...o.mount ? r : g
    };
    return fg(ie) ? J : ea(ie) ? Tt(J, ie) : ie.map((Ce) => Tt(J, Ce));
  }, Ee = (ie, J) => ({
    invalid: !!Tt((J || i).errors, ie),
    isDirty: !!Tt((J || i).dirtyFields, ie),
    isTouched: !!Tt((J || i).touchedFields, ie),
    isValidating: !!Tt((J || i).validatingFields, ie),
    error: Tt((J || i).errors, ie)
  }), Je = (ie) => {
    ie && RF(ie).forEach((J) => Ug(i.errors, J)), C.state.next({
      errors: ie ? i.errors : {}
    });
  }, ve = (ie, J, Ce) => {
    const xe = (Tt(n, ie, { _f: {} })._f || {}).ref;
    Sn(i.errors, ie, {
      ...J,
      ref: xe
    }), C.state.next({
      name: ie,
      errors: i.errors,
      isValid: !1
    }), Ce && Ce.shouldFocus && xe && xe.focus && xe.focus();
  }, Be = (ie, J) => Sd(ie) ? C.values.subscribe({
    next: (Ce) => ie(q(void 0, J), Ce)
  }) : q(ie, J, !0), ue = (ie, J = {}) => {
    for (const Ce of ie ? RF(ie) : I.mount)
      I.mount.delete(Ce), I.array.delete(Ce), J.keepValue || (Ug(n, Ce), Ug(r, Ce)), !J.keepError && Ug(i.errors, Ce), !J.keepDirty && Ug(i.dirtyFields, Ce), !J.keepTouched && Ug(i.touchedFields, Ce), !J.keepIsValidating && Ug(i.validatingFields, Ce), !t.shouldUnregister && !J.keepDefaultValue && Ug(g, Ce);
    C.values.next({
      values: { ...r }
    }), C.state.next({
      ...i,
      ...J.keepDirty ? { isDirty: $() } : {}
    }), !J.keepIsValid && B();
  }, Xe = ({ disabled: ie, name: J, field: Ce, fields: xe, value: Le }) => {
    if (sc(ie)) {
      const Ye = ie ? void 0 : fg(Le) ? kF(Ce ? Ce._f : Tt(xe, J)._f) : Le;
      Sn(r, J, Ye), w(J, Ye, !1, !1, !0);
    }
  }, Ze = (ie, J = {}) => {
    let Ce = Tt(n, ie);
    const xe = sc(J.disabled);
    return Sn(n, ie, {
      ...Ce || {},
      _f: {
        ...Ce && Ce._f ? Ce._f : { ref: { name: ie } },
        name: ie,
        mount: !0,
        ...J
      }
    }), I.mount.add(ie), Ce ? Xe({
      field: Ce,
      disabled: J.disabled,
      name: ie,
      value: J.value
    }) : V(ie, !0, J.value), {
      ...xe ? { disabled: J.disabled } : {},
      ...t.progressive ? {
        required: !!J.required,
        min: K0(J.min),
        max: K0(J.max),
        minLength: K0(J.minLength),
        maxLength: K0(J.maxLength),
        pattern: K0(J.pattern)
      } : {},
      name: ie,
      onChange: te,
      onBlur: te,
      ref: (Le) => {
        if (Le) {
          Ze(ie, J), Ce = Tt(n, ie);
          const Ye = fg(Le.value) && Le.querySelectorAll && Le.querySelectorAll("input,select,textarea")[0] || Le, qe = nBt(Ye), Yt = Ce._f.refs || [];
          if (qe ? Yt.find((qt) => qt === Ye) : Ye === Ce._f.ref)
            return;
          Sn(n, ie, {
            _f: {
              ...Ce._f,
              ...qe ? {
                refs: [
                  ...Yt.filter(HF),
                  Ye,
                  ...Array.isArray(Tt(g, ie)) ? [{}] : []
                ],
                ref: { type: Ye.type, name: ie }
              } : { ref: Ye }
            }
          }), V(ie, !1, void 0, Ye);
        } else
          Ce = Tt(n, ie, {}), Ce._f && (Ce._f.mount = !1), (t.shouldUnregister || J.shouldUnregister) && !(O0t(I.array, ie) && o.action) && I.unMount.add(ie);
      }
    };
  }, Ke = () => t.shouldFocusError && RB(n, le, I.mount), $e = (ie) => {
    sc(ie) && (C.state.next({ disabled: ie }), RB(n, (J, Ce) => {
      let xe = ie;
      const Le = Tt(n, Ce);
      Le && sc(Le._f.disabled) && (xe || (xe = Le._f.disabled)), J.disabled = xe;
    }, 0, !1));
  }, rt = (ie, J) => async (Ce) => {
    let xe;
    Ce && (Ce.preventDefault && Ce.preventDefault(), Ce.persist && Ce.persist());
    let Le = rl(r);
    if (C.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: Ye, values: qe } = await H();
      i.errors = Ye, Le = qe;
    } else
      await N(n);
    if (Ug(i.errors, "root"), bI(i.errors)) {
      C.state.next({
        errors: {}
      });
      try {
        await ie(Le, Ce);
      } catch (Ye) {
        xe = Ye;
      }
    } else
      J && await J({ ...i.errors }, Ce), Ke(), setTimeout(Ke);
    if (C.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: bI(i.errors) && !xe,
      submitCount: i.submitCount + 1,
      errors: i.errors
    }), xe)
      throw xe;
  }, dt = (ie, J = {}) => {
    Tt(n, ie) && (fg(J.defaultValue) ? Q(ie, rl(Tt(g, ie))) : (Q(ie, J.defaultValue), Sn(g, ie, rl(J.defaultValue))), J.keepTouched || Ug(i.touchedFields, ie), J.keepDirty || (Ug(i.dirtyFields, ie), i.isDirty = J.defaultValue ? $(ie, rl(Tt(g, ie))) : $()), J.keepError || (Ug(i.errors, ie), d.isValid && B()), C.state.next({ ...i }));
  }, ot = (ie, J = {}) => {
    const Ce = ie ? rl(ie) : g, xe = rl(Ce), Le = bI(ie), Ye = Le ? g : xe;
    if (J.keepDefaultValues || (g = Ce), !J.keepValues) {
      if (J.keepDirtyValues)
        for (const qe of I.mount)
          Tt(i.dirtyFields, qe) ? Sn(Ye, qe, Tt(r, qe)) : Q(qe, Tt(Ye, qe));
      else {
        if (fE && fg(ie))
          for (const qe of I.mount) {
            const Yt = Tt(n, qe);
            if (Yt && Yt._f) {
              const qt = Array.isArray(Yt._f.refs) ? Yt._f.refs[0] : Yt._f.ref;
              if (YV(qt)) {
                const Ut = qt.closest("form");
                if (Ut) {
                  Ut.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      r = e.shouldUnregister ? J.keepDefaultValues ? rl(g) : {} : rl(Ye), C.array.next({
        values: { ...Ye }
      }), C.values.next({
        values: { ...Ye }
      });
    }
    I = {
      mount: J.keepDirtyValues ? I.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !d.isValid || !!J.keepIsValid || !!J.keepDirtyValues, o.watch = !!e.shouldUnregister, C.state.next({
      submitCount: J.keepSubmitCount ? i.submitCount : 0,
      isDirty: Le ? !1 : J.keepDirty ? i.isDirty : !!(J.keepDefaultValues && !Su(ie, g)),
      isSubmitted: J.keepIsSubmitted ? i.isSubmitted : !1,
      dirtyFields: Le ? [] : J.keepDirtyValues ? J.keepDefaultValues && r ? TW(g, r) : i.dirtyFields : J.keepDefaultValues && ie ? TW(g, ie) : {},
      touchedFields: J.keepTouched ? i.touchedFields : {},
      errors: J.keepErrors ? i.errors : {},
      isSubmitSuccessful: J.keepIsSubmitSuccessful ? i.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, ze = (ie, J) => ot(Sd(ie) ? ie(r) : ie, J);
  return {
    control: {
      register: Ze,
      unregister: ue,
      getFieldState: Ee,
      handleSubmit: rt,
      setError: ve,
      _executeSchema: H,
      _getWatch: q,
      _getDirty: $,
      _updateValid: B,
      _removeUnmounted: M,
      _updateFieldArray: G,
      _updateDisabledField: Xe,
      _getFieldArray: E,
      _reset: ot,
      _resetDefaultValues: () => Sd(t.defaultValues) && t.defaultValues().then((ie) => {
        ze(ie, t.resetOptions), C.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (ie) => {
        i = {
          ...i,
          ...ie
        };
      },
      _disableForm: $e,
      _subjects: C,
      _proxyFormState: d,
      _setErrors: W,
      get _fields() {
        return n;
      },
      get _formValues() {
        return r;
      },
      get _state() {
        return o;
      },
      set _state(ie) {
        o = ie;
      },
      get _defaultValues() {
        return g;
      },
      get _names() {
        return I;
      },
      set _names(ie) {
        I = ie;
      },
      get _formState() {
        return i;
      },
      set _formState(ie) {
        i = ie;
      },
      get _options() {
        return t;
      },
      set _options(ie) {
        t = {
          ...t,
          ...ie
        };
      }
    },
    trigger: Ae,
    register: Ze,
    handleSubmit: rt,
    watch: Be,
    setValue: Q,
    getValues: we,
    reset: ze,
    resetField: dt,
    clearErrors: Je,
    unregister: ue,
    setError: ve,
    setFocus: (ie, J = {}) => {
      const Ce = Tt(n, ie), xe = Ce && Ce._f;
      if (xe) {
        const Le = xe.refs ? xe.refs[0] : xe.ref;
        Le.focus && (Le.focus(), J.shouldSelect && Le.select());
      }
    },
    getFieldState: Ee
  };
}
function aBt(e = {}) {
  const t = Se.useRef(), i = Se.useRef(), [n, g] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Sd(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Sd(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...sBt(e),
    formState: n
  });
  const r = t.current.control;
  return r._options = e, $0t({
    subject: r._subjects.state,
    next: (o) => {
      _0t(o, r._proxyFormState, r._updateFormState) && g({ ...r._formState });
    }
  }), Se.useEffect(() => r._disableForm(e.disabled), [r, e.disabled]), Se.useEffect(() => {
    if (r._proxyFormState.isDirty) {
      const o = r._getDirty();
      o !== n.isDirty && r._subjects.state.next({
        isDirty: o
      });
    }
  }, [r, n.isDirty]), Se.useEffect(() => {
    e.values && !Su(e.values, i.current) ? (r._reset(e.values, r._options.resetOptions), i.current = e.values, g((o) => ({ ...o }))) : r._resetDefaultValues();
  }, [e.values, r]), Se.useEffect(() => {
    e.errors && r._setErrors(e.errors);
  }, [e.errors, r]), Se.useEffect(() => {
    r._state.mount || (r._updateValid(), r._state.mount = !0), r._state.watch && (r._state.watch = !1, r._subjects.state.next({ ...r._formState })), r._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && r._subjects.values.next({
      values: r._getWatch()
    });
  }, [e.shouldUnregister, r]), t.current.formState = j0t(n, r), t.current;
}
var eP = function(e, t, i) {
  if (e && "reportValidity" in e) {
    var n = Tt(i, t);
    e.setCustomValidity(n && n.message || ""), e.reportValidity();
  }
}, Zte = function(e, t) {
  var i = function(g) {
    var r = t.fields[g];
    r && r.ref && "reportValidity" in r.ref ? eP(r.ref, g, e) : r.refs && r.refs.forEach(function(o) {
      return eP(o, g, e);
    });
  };
  for (var n in t.fields)
    i(n);
}, cBt = function(e, t) {
  t.shouldUseNativeValidation && Zte(e, t);
  var i = {};
  for (var n in e) {
    var g = Tt(t.fields, n), r = Object.assign(e[n] || {}, { ref: g && g.ref });
    if (dBt(t.names || Object.keys(e), n)) {
      var o = Object.assign({}, Tt(i, n));
      Sn(o, "root", r), Sn(i, n, o);
    } else
      Sn(i, n, r);
  }
  return i;
}, dBt = function(e, t) {
  return e.some(function(i) {
    return i.startsWith(t + ".");
  });
};
function CBt(e, t, i) {
  return t === void 0 && (t = {}), i === void 0 && (i = {}), function(n, g, r) {
    try {
      return Promise.resolve(function(o, I) {
        try {
          var s = (t.context, Promise.resolve(e[i.mode === "sync" ? "validateSync" : "validate"](n, Object.assign({ abortEarly: !1 }, t, { context: g }))).then(function(a) {
            return r.shouldUseNativeValidation && Zte({}, r), { values: i.raw ? n : a, errors: {} };
          }));
        } catch (a) {
          return I(a);
        }
        return s && s.then ? s.then(void 0, I) : s;
      }(0, function(o) {
        if (!o.inner)
          throw o;
        return { values: {}, errors: cBt((I = o, s = !r.shouldUseNativeValidation && r.criteriaMode === "all", (I.inner || []).reduce(function(a, d) {
          if (a[d.path] || (a[d.path] = { message: d.message, type: d.type }), s) {
            var C = a[d.path].types, u = C && C[d.type];
            a[d.path] = ute(d.path, s, a, d.type, u ? [].concat(u, d.message) : d.message);
          }
          return a;
        }, {})), r) };
        var I, s;
      }));
    } catch (o) {
      return Promise.reject(o);
    }
  };
}
var SE = {}, VE = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(n) {
    n.Root = "root", n.Text = "text", n.Directive = "directive", n.Comment = "comment", n.Script = "script", n.Style = "style", n.Tag = "tag", n.CDATA = "cdata", n.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function i(n) {
    return n.type === t.Tag || n.type === t.Script || n.type === t.Style;
  }
  e.isTag = i, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(VE);
var Fi = {}, sC = Zn && Zn.__extends || /* @__PURE__ */ function() {
  var e = function(t, i) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, g) {
      n.__proto__ = g;
    } || function(n, g) {
      for (var r in g)
        Object.prototype.hasOwnProperty.call(g, r) && (n[r] = g[r]);
    }, e(t, i);
  };
  return function(t, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    e(t, i);
    function n() {
      this.constructor = t;
    }
    t.prototype = i === null ? Object.create(i) : (n.prototype = i.prototype, new n());
  };
}(), XB = Zn && Zn.__assign || function() {
  return XB = Object.assign || function(e) {
    for (var t, i = 1, n = arguments.length; i < n; i++) {
      t = arguments[i];
      for (var g in t)
        Object.prototype.hasOwnProperty.call(t, g) && (e[g] = t[g]);
    }
    return e;
  }, XB.apply(this, arguments);
};
Object.defineProperty(Fi, "__esModule", { value: !0 });
Fi.cloneNode = Fi.hasChildren = Fi.isDocument = Fi.isDirective = Fi.isComment = Fi.isText = Fi.isCDATA = Fi.isTag = Fi.Element = Fi.Document = Fi.CDATA = Fi.NodeWithChildren = Fi.ProcessingInstruction = Fi.Comment = Fi.Text = Fi.DataNode = Fi.Node = void 0;
var Oo = VE, wE = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), vE(this, t);
    }, e;
  }()
);
Fi.Node = wE;
var F2 = (
  /** @class */
  function(e) {
    sC(t, e);
    function t(i) {
      var n = e.call(this) || this;
      return n.data = i, n;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(i) {
        this.data = i;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(wE)
);
Fi.DataNode = F2;
var fte = (
  /** @class */
  function(e) {
    sC(t, e);
    function t() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Oo.ElementType.Text, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(F2)
);
Fi.Text = fte;
var Gte = (
  /** @class */
  function(e) {
    sC(t, e);
    function t() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Oo.ElementType.Comment, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(F2)
);
Fi.Comment = Gte;
var yte = (
  /** @class */
  function(e) {
    sC(t, e);
    function t(i, n) {
      var g = e.call(this, n) || this;
      return g.name = i, g.type = Oo.ElementType.Directive, g;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(F2)
);
Fi.ProcessingInstruction = yte;
var Y2 = (
  /** @class */
  function(e) {
    sC(t, e);
    function t(i) {
      var n = e.call(this) || this;
      return n.children = i, n;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var i;
        return (i = this.children[0]) !== null && i !== void 0 ? i : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(i) {
        this.children = i;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(wE)
);
Fi.NodeWithChildren = Y2;
var Wte = (
  /** @class */
  function(e) {
    sC(t, e);
    function t() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Oo.ElementType.CDATA, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Y2)
);
Fi.CDATA = Wte;
var Ste = (
  /** @class */
  function(e) {
    sC(t, e);
    function t() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Oo.ElementType.Root, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Y2)
);
Fi.Document = Ste;
var Vte = (
  /** @class */
  function(e) {
    sC(t, e);
    function t(i, n, g, r) {
      g === void 0 && (g = []), r === void 0 && (r = i === "script" ? Oo.ElementType.Script : i === "style" ? Oo.ElementType.Style : Oo.ElementType.Tag);
      var o = e.call(this, g) || this;
      return o.name = i, o.attribs = n, o.type = r, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(i) {
        this.name = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var i = this;
        return Object.keys(this.attribs).map(function(n) {
          var g, r;
          return {
            name: n,
            value: i.attribs[n],
            namespace: (g = i["x-attribsNamespace"]) === null || g === void 0 ? void 0 : g[n],
            prefix: (r = i["x-attribsPrefix"]) === null || r === void 0 ? void 0 : r[n]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Y2)
);
Fi.Element = Vte;
function wte(e) {
  return (0, Oo.isTag)(e);
}
Fi.isTag = wte;
function vte(e) {
  return e.type === Oo.ElementType.CDATA;
}
Fi.isCDATA = vte;
function Rte(e) {
  return e.type === Oo.ElementType.Text;
}
Fi.isText = Rte;
function Xte(e) {
  return e.type === Oo.ElementType.Comment;
}
Fi.isComment = Xte;
function Hte(e) {
  return e.type === Oo.ElementType.Directive;
}
Fi.isDirective = Hte;
function kte(e) {
  return e.type === Oo.ElementType.Root;
}
Fi.isDocument = kte;
function uBt(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
Fi.hasChildren = uBt;
function vE(e, t) {
  t === void 0 && (t = !1);
  var i;
  if (Rte(e))
    i = new fte(e.data);
  else if (Xte(e))
    i = new Gte(e.data);
  else if (wte(e)) {
    var n = t ? FF(e.children) : [], g = new Vte(e.name, XB({}, e.attribs), n);
    n.forEach(function(s) {
      return s.parent = g;
    }), e.namespace != null && (g.namespace = e.namespace), e["x-attribsNamespace"] && (g["x-attribsNamespace"] = XB({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (g["x-attribsPrefix"] = XB({}, e["x-attribsPrefix"])), i = g;
  } else if (vte(e)) {
    var n = t ? FF(e.children) : [], r = new Wte(n);
    n.forEach(function(a) {
      return a.parent = r;
    }), i = r;
  } else if (kte(e)) {
    var n = t ? FF(e.children) : [], o = new Ste(n);
    n.forEach(function(a) {
      return a.parent = o;
    }), e["x-mode"] && (o["x-mode"] = e["x-mode"]), i = o;
  } else if (Hte(e)) {
    var I = new yte(e.name, e.data);
    e["x-name"] != null && (I["x-name"] = e["x-name"], I["x-publicId"] = e["x-publicId"], I["x-systemId"] = e["x-systemId"]), i = I;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return i.startIndex = e.startIndex, i.endIndex = e.endIndex, e.sourceCodeLocation != null && (i.sourceCodeLocation = e.sourceCodeLocation), i;
}
Fi.cloneNode = vE;
function FF(e) {
  for (var t = e.map(function(n) {
    return vE(n, !0);
  }), i = 1; i < t.length; i++)
    t[i].prev = t[i - 1], t[i - 1].next = t[i];
  return t;
}
(function(e) {
  var t = Zn && Zn.__createBinding || (Object.create ? function(I, s, a, d) {
    d === void 0 && (d = a);
    var C = Object.getOwnPropertyDescriptor(s, a);
    (!C || ("get" in C ? !s.__esModule : C.writable || C.configurable)) && (C = { enumerable: !0, get: function() {
      return s[a];
    } }), Object.defineProperty(I, d, C);
  } : function(I, s, a, d) {
    d === void 0 && (d = a), I[d] = s[a];
  }), i = Zn && Zn.__exportStar || function(I, s) {
    for (var a in I)
      a !== "default" && !Object.prototype.hasOwnProperty.call(s, a) && t(s, I, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var n = VE, g = Fi;
  i(Fi, e);
  var r = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, o = (
    /** @class */
    function() {
      function I(s, a, d) {
        this.dom = [], this.root = new g.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof a == "function" && (d = a, a = r), typeof s == "object" && (a = s, s = void 0), this.callback = s ?? null, this.options = a ?? r, this.elementCB = d ?? null;
      }
      return I.prototype.onparserinit = function(s) {
        this.parser = s;
      }, I.prototype.onreset = function() {
        this.dom = [], this.root = new g.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, I.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, I.prototype.onerror = function(s) {
        this.handleCallback(s);
      }, I.prototype.onclosetag = function() {
        this.lastNode = null;
        var s = this.tagStack.pop();
        this.options.withEndIndices && (s.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s);
      }, I.prototype.onopentag = function(s, a) {
        var d = this.options.xmlMode ? n.ElementType.Tag : void 0, C = new g.Element(s, a, void 0, d);
        this.addNode(C), this.tagStack.push(C);
      }, I.prototype.ontext = function(s) {
        var a = this.lastNode;
        if (a && a.type === n.ElementType.Text)
          a.data += s, this.options.withEndIndices && (a.endIndex = this.parser.endIndex);
        else {
          var d = new g.Text(s);
          this.addNode(d), this.lastNode = d;
        }
      }, I.prototype.oncomment = function(s) {
        if (this.lastNode && this.lastNode.type === n.ElementType.Comment) {
          this.lastNode.data += s;
          return;
        }
        var a = new g.Comment(s);
        this.addNode(a), this.lastNode = a;
      }, I.prototype.oncommentend = function() {
        this.lastNode = null;
      }, I.prototype.oncdatastart = function() {
        var s = new g.Text(""), a = new g.CDATA([s]);
        this.addNode(a), s.parent = a, this.lastNode = s;
      }, I.prototype.oncdataend = function() {
        this.lastNode = null;
      }, I.prototype.onprocessinginstruction = function(s, a) {
        var d = new g.ProcessingInstruction(s, a);
        this.addNode(d);
      }, I.prototype.handleCallback = function(s) {
        if (typeof this.callback == "function")
          this.callback(s, this.dom);
        else if (s)
          throw s;
      }, I.prototype.addNode = function(s) {
        var a = this.tagStack[this.tagStack.length - 1], d = a.children[a.children.length - 1];
        this.options.withStartIndices && (s.startIndex = this.parser.startIndex), this.options.withEndIndices && (s.endIndex = this.parser.endIndex), a.children.push(s), d && (s.prev = d, d.next = s), s.parent = a, this.lastNode = null;
      }, I;
    }()
  );
  e.DomHandler = o, e.default = o;
})(SE);
var tP = "html", iP = "head", MW = "body", ABt = /<([a-zA-Z]+[0-9]?)/, nP = /<head[^]*>/i, gP = /<body[^]*>/i, KV = function() {
  throw new Error(
    "This browser does not support `document.implementation.createHTMLDocument`"
  );
}, Kx = function() {
  throw new Error(
    "This browser does not support `DOMParser.prototype.parseFromString`"
  );
}, rP = typeof window == "object" && window.DOMParser;
if (typeof rP == "function") {
  var bBt = new rP(), mBt = "text/html";
  Kx = function(e, t) {
    return t && (e = "<" + t + ">" + e + "</" + t + ">"), bBt.parseFromString(e, mBt);
  }, KV = Kx;
}
if (typeof document == "object" && document.implementation) {
  var UW = document.implementation.createHTMLDocument();
  KV = function(e, t) {
    if (t) {
      var i = UW.documentElement.querySelector(t);
      return i.innerHTML = e, UW;
    }
    return UW.documentElement.innerHTML = e, UW;
  };
}
var YF = typeof document == "object" ? document.createElement("template") : {}, Ex;
YF.content && (Ex = function(e) {
  return YF.innerHTML = e, YF.content.childNodes;
});
function hBt(e) {
  var t, i = e.match(ABt);
  i && i[1] && (t = i[1].toLowerCase());
  var n, g, r;
  switch (t) {
    case tP:
      return n = Kx(e), nP.test(e) || (g = n.querySelector(iP), g && g.parentNode.removeChild(g)), gP.test(e) || (g = n.querySelector(MW), g && g.parentNode.removeChild(g)), n.querySelectorAll(tP);
    case iP:
    case MW:
      return n = KV(e), r = n.querySelectorAll(t), gP.test(e) && nP.test(e) ? r[0].parentNode.childNodes : r;
    default:
      return Ex ? Ex(e) : (g = KV(e, MW).querySelector(MW), g.childNodes);
  }
}
var pBt = hBt, RE = {}, Fte = {};
Fte.CASE_SENSITIVE_TAG_NAMES = [
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "linearGradient",
  "radialGradient",
  "textPath"
];
var x2 = SE, BBt = Fte, oP = BBt.CASE_SENSITIVE_TAG_NAMES, ZBt = x2.Comment, fBt = x2.Element, GBt = x2.ProcessingInstruction, yBt = x2.Text, Yte = {}, xF;
for (var DF = 0, WBt = oP.length; DF < WBt; DF++)
  xF = oP[DF], Yte[xF.toLowerCase()] = xF;
function SBt(e) {
  return Yte[e];
}
function xte(e) {
  for (var t = {}, i, n = 0, g = e.length; n < g; n++)
    i = e[n], t[i.name] = i.value;
  return t;
}
function VBt(e) {
  e = e.toLowerCase();
  var t = SBt(e);
  return t || e;
}
function Dte(e, t, i) {
  t = t || null;
  for (var n = [], g, r = 0, o = e.length; r < o; r++) {
    var I = e[r], s;
    switch (I.nodeType) {
      case 1:
        g = VBt(I.nodeName), s = new fBt(g, xte(I.attributes)), s.children = Dte(
          // template children are on content
          g === "template" ? I.content.childNodes : I.childNodes,
          s
        );
        break;
      case 3:
        s = new yBt(I.nodeValue);
        break;
      case 8:
        s = new ZBt(I.nodeValue);
        break;
      default:
        continue;
    }
    var a = n[r - 1] || null;
    a && (a.next = s), s.parent = t, s.prev = a, s.next = null, n.push(s);
  }
  return i && (s = new GBt(
    i.substring(0, i.indexOf(" ")).toLowerCase(),
    i
  ), s.next = n[0] || null, s.parent = t, n.unshift(s), n[1] && (n[1].prev = n[0])), n;
}
RE.formatAttributes = xte;
RE.formatDOM = Dte;
var wBt = pBt, vBt = RE, RBt = vBt.formatDOM, XBt = /<(![a-zA-Z\s]+)>/;
function HBt(e) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (e === "")
    return [];
  var t = e.match(XBt), i;
  return t && t[1] && (i = t[1]), RBt(wBt(e), null, i);
}
var kBt = HBt, Hl = {}, D2 = {}, FBt = 0;
D2.SAME = FBt;
var YBt = 1;
D2.CAMELCASE = YBt;
D2.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  "accept-charset": "acceptCharset",
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: "className",
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: "htmlFor",
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  "http-equiv": "httpEquiv",
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  "accent-height": "accentHeight",
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  "alignment-baseline": "alignmentBaseline",
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  "arabic-form": "arabicForm",
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  "baseline-shift": "baselineShift",
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  "cap-height": "capHeight",
  clip: 0,
  clipPath: 1,
  "clip-path": "clipPath",
  clipPathUnits: 1,
  clipRule: 1,
  "clip-rule": "clipRule",
  color: 0,
  colorInterpolation: 1,
  "color-interpolation": "colorInterpolation",
  colorInterpolationFilters: 1,
  "color-interpolation-filters": "colorInterpolationFilters",
  colorProfile: 1,
  "color-profile": "colorProfile",
  colorRendering: 1,
  "color-rendering": "colorRendering",
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  "dominant-baseline": "dominantBaseline",
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  "enable-background": "enableBackground",
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  "fill-opacity": "fillOpacity",
  fillRule: 1,
  "fill-rule": "fillRule",
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  "flood-opacity": "floodOpacity",
  floodColor: 1,
  "flood-color": "floodColor",
  focusable: 0,
  fontFamily: 1,
  "font-family": "fontFamily",
  fontSize: 1,
  "font-size": "fontSize",
  fontSizeAdjust: 1,
  "font-size-adjust": "fontSizeAdjust",
  fontStretch: 1,
  "font-stretch": "fontStretch",
  fontStyle: 1,
  "font-style": "fontStyle",
  fontVariant: 1,
  "font-variant": "fontVariant",
  fontWeight: 1,
  "font-weight": "fontWeight",
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  "glyph-name": "glyphName",
  glyphOrientationHorizontal: 1,
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphOrientationVertical: 1,
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  "horiz-adv-x": "horizAdvX",
  horizOriginX: 1,
  "horiz-origin-x": "horizOriginX",
  ideographic: 0,
  imageRendering: 1,
  "image-rendering": "imageRendering",
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  "letter-spacing": "letterSpacing",
  lightingColor: 1,
  "lighting-color": "lightingColor",
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  "marker-end": "markerEnd",
  markerHeight: 1,
  markerMid: 1,
  "marker-mid": "markerMid",
  markerStart: 1,
  "marker-start": "markerStart",
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  "overline-position": "overlinePosition",
  overlineThickness: 1,
  "overline-thickness": "overlineThickness",
  paintOrder: 1,
  "paint-order": "paintOrder",
  panose1: 0,
  "panose-1": "panose1",
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  "pointer-events": "pointerEvents",
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  "rendering-intent": "renderingIntent",
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  "shape-rendering": "shapeRendering",
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  "stop-color": "stopColor",
  stopOpacity: 1,
  "stop-opacity": "stopOpacity",
  strikethroughPosition: 1,
  "strikethrough-position": "strikethroughPosition",
  strikethroughThickness: 1,
  "strikethrough-thickness": "strikethroughThickness",
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  "stroke-dasharray": "strokeDasharray",
  strokeDashoffset: 1,
  "stroke-dashoffset": "strokeDashoffset",
  strokeLinecap: 1,
  "stroke-linecap": "strokeLinecap",
  strokeLinejoin: 1,
  "stroke-linejoin": "strokeLinejoin",
  strokeMiterlimit: 1,
  "stroke-miterlimit": "strokeMiterlimit",
  strokeWidth: 1,
  "stroke-width": "strokeWidth",
  strokeOpacity: 1,
  "stroke-opacity": "strokeOpacity",
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  "text-anchor": "textAnchor",
  textDecoration: 1,
  "text-decoration": "textDecoration",
  textLength: 1,
  textRendering: 1,
  "text-rendering": "textRendering",
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  "underline-position": "underlinePosition",
  underlineThickness: 1,
  "underline-thickness": "underlineThickness",
  unicode: 0,
  unicodeBidi: 1,
  "unicode-bidi": "unicodeBidi",
  unicodeRange: 1,
  "unicode-range": "unicodeRange",
  unitsPerEm: 1,
  "units-per-em": "unitsPerEm",
  unselectable: 0,
  vAlphabetic: 1,
  "v-alphabetic": "vAlphabetic",
  values: 0,
  vectorEffect: 1,
  "vector-effect": "vectorEffect",
  version: 0,
  vertAdvY: 1,
  "vert-adv-y": "vertAdvY",
  vertOriginX: 1,
  "vert-origin-x": "vertOriginX",
  vertOriginY: 1,
  "vert-origin-y": "vertOriginY",
  vHanging: 1,
  "v-hanging": "vHanging",
  vIdeographic: 1,
  "v-ideographic": "vIdeographic",
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  "v-mathematical": "vMathematical",
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  "word-spacing": "wordSpacing",
  writingMode: 1,
  "writing-mode": "writingMode",
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  "x-height": "xHeight",
  xlinkActuate: 1,
  "xlink:actuate": "xlinkActuate",
  xlinkArcrole: 1,
  "xlink:arcrole": "xlinkArcrole",
  xlinkHref: 1,
  "xlink:href": "xlinkHref",
  xlinkRole: 1,
  "xlink:role": "xlinkRole",
  xlinkShow: 1,
  "xlink:show": "xlinkShow",
  xlinkTitle: 1,
  "xlink:title": "xlinkTitle",
  xlinkType: 1,
  "xlink:type": "xlinkType",
  xmlBase: 1,
  "xml:base": "xmlBase",
  xmlLang: 1,
  "xml:lang": "xmlLang",
  xmlns: 0,
  "xml:space": "xmlSpace",
  xmlnsXlink: 1,
  "xmlns:xlink": "xmlnsXlink",
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};
Object.defineProperty(Hl, "__esModule", { value: !0 });
function xBt(e, t) {
  return DBt(e) || JBt(e, t) || KBt(e, t) || EBt();
}
function DBt(e) {
  if (Array.isArray(e))
    return e;
}
function JBt(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n = [], g = !0, r = !1, o, I;
    try {
      for (i = i.call(e); !(g = (o = i.next()).done) && (n.push(o.value), !(t && n.length === t)); g = !0)
        ;
    } catch (s) {
      r = !0, I = s;
    } finally {
      try {
        !g && i.return != null && i.return();
      } finally {
        if (r)
          throw I;
      }
    }
    return n;
  }
}
function KBt(e, t) {
  if (e) {
    if (typeof e == "string")
      return IP(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
      return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
      return IP(e, t);
  }
}
function IP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = new Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function EBt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Jte = 0, aC = 1, J2 = 2, K2 = 3, XE = 4, Kte = 5, Ete = 6;
function NBt(e) {
  return Lr.hasOwnProperty(e) ? Lr[e] : null;
}
function wo(e, t, i, n, g, r, o) {
  this.acceptsBooleans = t === J2 || t === K2 || t === XE, this.attributeName = n, this.attributeNamespace = g, this.mustUseProperty = i, this.propertyName = e, this.type = t, this.sanitizeURL = r, this.removeEmptyString = o;
}
var Lr = {}, LBt = [
  "children",
  "dangerouslySetInnerHTML",
  // TODO: This prevents the assignment of defaultValue to regular
  // elements (not just inputs). Now that ReactDOMInput assigns to the
  // defaultValue property -- do we need this?
  "defaultValue",
  "defaultChecked",
  "innerHTML",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "style"
];
LBt.forEach(function(e) {
  Lr[e] = new wo(
    e,
    Jte,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = xBt(e, 2), i = t[0], n = t[1];
  Lr[i] = new wo(
    i,
    aC,
    !1,
    // mustUseProperty
    n,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  Lr[e] = new wo(
    e,
    J2,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  Lr[e] = new wo(
    e,
    J2,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "allowFullScreen",
  "async",
  // Note: there is a special case that prevents it from being written to the DOM
  // on the client side because the browsers are inconsistent. Instead we call focus().
  "autoFocus",
  "autoPlay",
  "controls",
  "default",
  "defer",
  "disabled",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "formNoValidate",
  "hidden",
  "loop",
  "noModule",
  "noValidate",
  "open",
  "playsInline",
  "readOnly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  // Microdata
  "itemScope"
].forEach(function(e) {
  Lr[e] = new wo(
    e,
    K2,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "checked",
  // Note: `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`. We have special logic for handling this.
  "multiple",
  "muted",
  "selected"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  Lr[e] = new wo(
    e,
    K2,
    !0,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "capture",
  "download"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  Lr[e] = new wo(
    e,
    XE,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "cols",
  "rows",
  "size",
  "span"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  Lr[e] = new wo(
    e,
    Ete,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
["rowSpan", "start"].forEach(function(e) {
  Lr[e] = new wo(
    e,
    Kte,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
var HE = /[\-\:]([a-z])/g, kE = function(t) {
  return t[1].toUpperCase();
};
[
  "accent-height",
  "alignment-baseline",
  "arabic-form",
  "baseline-shift",
  "cap-height",
  "clip-path",
  "clip-rule",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "dominant-baseline",
  "enable-background",
  "fill-opacity",
  "fill-rule",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "glyph-name",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "horiz-adv-x",
  "horiz-origin-x",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "overline-position",
  "overline-thickness",
  "paint-order",
  "panose-1",
  "pointer-events",
  "rendering-intent",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "strikethrough-position",
  "strikethrough-thickness",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-rendering",
  "underline-position",
  "underline-thickness",
  "unicode-bidi",
  "unicode-range",
  "units-per-em",
  "v-alphabetic",
  "v-hanging",
  "v-ideographic",
  "v-mathematical",
  "vector-effect",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "word-spacing",
  "writing-mode",
  "xmlns:xlink",
  "x-height"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  var t = e.replace(HE, kE);
  Lr[t] = new wo(
    t,
    aC,
    !1,
    // mustUseProperty
    e,
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "xlink:actuate",
  "xlink:arcrole",
  "xlink:role",
  "xlink:show",
  "xlink:title",
  "xlink:type"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  var t = e.replace(HE, kE);
  Lr[t] = new wo(
    t,
    aC,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/1999/xlink",
    !1,
    // sanitizeURL
    !1
  );
});
[
  "xml:base",
  "xml:lang",
  "xml:space"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  var t = e.replace(HE, kE);
  Lr[t] = new wo(
    t,
    aC,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/XML/1998/namespace",
    !1,
    // sanitizeURL
    !1
  );
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  Lr[e] = new wo(
    e,
    aC,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
var TBt = "xlinkHref";
Lr[TBt] = new wo(
  "xlinkHref",
  aC,
  !1,
  // mustUseProperty
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  // sanitizeURL
  !1
);
["src", "href", "action", "formAction"].forEach(function(e) {
  Lr[e] = new wo(
    e,
    aC,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !0,
    // sanitizeURL
    !0
  );
});
var FE = D2, MBt = FE.CAMELCASE, UBt = FE.SAME, lP = FE.possibleStandardNames, PBt = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", zBt = PBt + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", OBt = RegExp.prototype.test.bind(
  // eslint-disable-next-line no-misleading-character-class
  new RegExp("^(data|aria)-[" + zBt + "]*$")
), QBt = Object.keys(lP).reduce(function(e, t) {
  var i = lP[t];
  return i === UBt ? e[t] = t : i === MBt ? e[t.toLowerCase()] = t : e[t] = i, e;
}, {});
Hl.BOOLEAN = K2;
Hl.BOOLEANISH_STRING = J2;
Hl.NUMERIC = Kte;
Hl.OVERLOADED_BOOLEAN = XE;
Hl.POSITIVE_NUMERIC = Ete;
Hl.RESERVED = Jte;
Hl.STRING = aC;
Hl.getPropertyInfo = NBt;
Hl.isCustomAttribute = OBt;
Hl.possibleStandardNames = QBt;
var Nte = {}, YE = { exports: {} }, sP = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, jBt = /\n/g, _Bt = /^\s*/, $Bt = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, qBt = /^:\s*/, eZt = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, tZt = /^[;\s]*/, iZt = /^\s+|\s+$/g, nZt = `
`, aP = "/", cP = "*", hu = "", gZt = "comment", rZt = "declaration", oZt = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var i = 1, n = 1;
  function g(m) {
    var h = m.match(jBt);
    h && (i += h.length);
    var B = m.lastIndexOf(nZt);
    n = ~B ? m.length - B : n + m.length;
  }
  function r() {
    var m = { line: i, column: n };
    return function(h) {
      return h.position = new o(m), a(), h;
    };
  }
  function o(m) {
    this.start = m, this.end = { line: i, column: n }, this.source = t.source;
  }
  o.prototype.content = e;
  function I(m) {
    var h = new Error(
      t.source + ":" + i + ":" + n + ": " + m
    );
    if (h.reason = m, h.filename = t.source, h.line = i, h.column = n, h.source = e, !t.silent)
      throw h;
  }
  function s(m) {
    var h = m.exec(e);
    if (h) {
      var B = h[0];
      return g(B), e = e.slice(B.length), h;
    }
  }
  function a() {
    s(_Bt);
  }
  function d(m) {
    var h;
    for (m = m || []; h = C(); )
      h !== !1 && m.push(h);
    return m;
  }
  function C() {
    var m = r();
    if (!(aP != e.charAt(0) || cP != e.charAt(1))) {
      for (var h = 2; hu != e.charAt(h) && (cP != e.charAt(h) || aP != e.charAt(h + 1)); )
        ++h;
      if (h += 2, hu === e.charAt(h - 1))
        return I("End of comment missing");
      var B = e.slice(2, h - 2);
      return n += 2, g(B), e = e.slice(h), n += 2, m({
        type: gZt,
        comment: B
      });
    }
  }
  function u() {
    var m = r(), h = s($Bt);
    if (h) {
      if (C(), !s(qBt))
        return I("property missing ':'");
      var B = s(eZt), f = m({
        type: rZt,
        property: dP(h[0].replace(sP, hu)),
        value: B ? dP(B[0].replace(sP, hu)) : hu
      });
      return s(tZt), f;
    }
  }
  function A() {
    var m = [];
    d(m);
    for (var h; h = u(); )
      h !== !1 && (m.push(h), d(m));
    return m;
  }
  return a(), A();
};
function dP(e) {
  return e ? e.replace(iZt, hu) : hu;
}
var IZt = oZt;
function Lte(e, t) {
  var i = null;
  if (!e || typeof e != "string")
    return i;
  for (var n, g = IZt(e), r = typeof t == "function", o, I, s = 0, a = g.length; s < a; s++)
    n = g[s], o = n.property, I = n.value, r ? t(o, I, n) : I && (i || (i = {}), i[o] = I);
  return i;
}
YE.exports = Lte;
YE.exports.default = Lte;
var lZt = YE.exports, E2 = {};
E2.__esModule = !0;
E2.camelCase = void 0;
var sZt = /^--[a-zA-Z0-9-]+$/, aZt = /-([a-z])/g, cZt = /^[^-]+$/, dZt = /^-(webkit|moz|ms|o|khtml)-/, CZt = /^-(ms)-/, uZt = function(e) {
  return !e || cZt.test(e) || sZt.test(e);
}, AZt = function(e, t) {
  return t.toUpperCase();
}, CP = function(e, t) {
  return "".concat(t, "-");
}, bZt = function(e, t) {
  return t === void 0 && (t = {}), uZt(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(CZt, CP) : e = e.replace(dZt, CP), e.replace(aZt, AZt));
};
E2.camelCase = bZt;
(function(e) {
  var t = Zn && Zn.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  e.__esModule = !0;
  var i = t(lZt), n = E2;
  function g(r, o) {
    var I = {};
    return !r || typeof r != "string" || (0, i.default)(r, function(s, a) {
      s && a && (I[(0, n.camelCase)(s, o)] = a);
    }), I;
  }
  e.default = g;
})(Nte);
var mZt = Se, hZt = Nte.default;
function pZt(e, t) {
  if (!e || typeof e != "object")
    throw new TypeError("First argument must be an object");
  var i, n, g = typeof t == "function", r = {}, o = {};
  for (i in e) {
    if (n = e[i], g && (r = t(i, n), r && r.length === 2)) {
      o[r[0]] = r[1];
      continue;
    }
    typeof n == "string" && (o[n] = i);
  }
  return o;
}
function BZt(e, t) {
  if (e.indexOf("-") === -1)
    return t && typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var ZZt = { reactCompat: !0 };
function fZt(e, t) {
  if (e != null)
    try {
      t.style = hZt(e, ZZt);
    } catch {
      t.style = {};
    }
}
var GZt = mZt.version.split(".")[0] >= 16, Tte = /* @__PURE__ */ new Set([
  "tr",
  "tbody",
  "thead",
  "tfoot",
  "colgroup",
  "table",
  "head",
  "html",
  "frameset"
]);
function yZt(e) {
  return !Tte.has(e.name);
}
var Mte = {
  PRESERVE_CUSTOM_ATTRIBUTES: GZt,
  invertObject: pZt,
  isCustomComponent: BZt,
  setStyleProp: fZt,
  canTextBeChildOfNode: yZt,
  elementsWithNoTextChildren: Tte
}, rB = Hl, uP = Mte, WZt = ["checked", "value"], SZt = ["input", "select", "textarea"], VZt = {
  reset: !0,
  submit: !0
}, Ute = function(t, i) {
  t = t || {};
  var n, g, r, o, I, s = {}, a = t.type && VZt[t.type];
  for (n in t) {
    if (r = t[n], rB.isCustomAttribute(n)) {
      s[n] = r;
      continue;
    }
    if (g = n.toLowerCase(), o = AP(g), o) {
      switch (I = rB.getPropertyInfo(o), WZt.indexOf(o) !== -1 && SZt.indexOf(i) !== -1 && !a && (o = AP("default" + g)), s[o] = r, I && I.type) {
        case rB.BOOLEAN:
          s[o] = !0;
          break;
        case rB.OVERLOADED_BOOLEAN:
          r === "" && (s[o] = !0);
          break;
      }
      continue;
    }
    uP.PRESERVE_CUSTOM_ATTRIBUTES && (s[n] = r);
  }
  return uP.setStyleProp(t.style, s), s;
};
function AP(e) {
  return rB.possibleStandardNames[e];
}
var wZt = Se, vZt = Ute, EV = Mte, RZt = EV.setStyleProp, XZt = EV.canTextBeChildOfNode;
function Pte(e, t) {
  t = t || {};
  for (var i = t.library || wZt, n = i.cloneElement, g = i.createElement, r = i.isValidElement, o = [], I, s, a = typeof t.replace == "function", d, C, u, A = t.trim, m = 0, h = e.length; m < h; m++) {
    if (I = e[m], a && (d = t.replace(I), r(d))) {
      h > 1 && (d = n(d, {
        key: d.key || m
      })), o.push(d);
      continue;
    }
    if (I.type === "text") {
      if (s = !I.data.trim().length, s && I.parent && !XZt(I.parent) || A && s)
        continue;
      o.push(I.data);
      continue;
    }
    switch (C = I.attribs, HZt(I) ? RZt(C.style, C) : C && (C = vZt(C, I.name)), u = null, I.type) {
      case "script":
      case "style":
        I.children[0] && (C.dangerouslySetInnerHTML = {
          __html: I.children[0].data
        });
        break;
      case "tag":
        I.name === "textarea" && I.children[0] ? C.defaultValue = I.children[0].data : I.children && I.children.length && (u = Pte(I.children, t));
        break;
      default:
        continue;
    }
    h > 1 && (C.key = m), o.push(g(I.name, C, u));
  }
  return o.length === 1 ? o[0] : o;
}
function HZt(e) {
  return EV.PRESERVE_CUSTOM_ATTRIBUTES && e.type === "tag" && EV.isCustomComponent(e.name, e.attribs);
}
var kZt = Pte, N2 = SE, um = kBt, FZt = Ute, zte = kZt;
um = /* istanbul ignore next */
typeof um.default == "function" ? um.default : um;
var YZt = { lowerCaseAttributeNames: !1 };
function ma(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  return e === "" ? [] : (t = t || {}, zte(
    um(e, t.htmlparser2 || YZt),
    t
  ));
}
ma.domToReact = zte;
ma.htmlToDOM = um;
ma.attributesToProps = FZt;
ma.Comment = N2.Comment;
ma.Element = N2.Element;
ma.ProcessingInstruction = N2.ProcessingInstruction;
ma.Text = N2.Text;
var xZt = ma;
ma.default = ma;
const cC = /* @__PURE__ */ Tr(xZt);
cC.domToReact;
cC.htmlToDOM;
cC.attributesToProps;
cC.Comment;
cC.Element;
cC.ProcessingInstruction;
cC.Text;
const L2 = (e) => e.order.privateData, Ote = (e) => e.order.privateDataText, DZt = ({
  action: e
}) => {
  const t = _(Ote), i = _(ng), n = () => {
    var o;
    const g = ((o = e == null ? void 0 : e.formular) == null ? void 0 : o.dataPrivacy) || "";
    let r = _$e(g, i, t);
    return r ? (r = r.replace("<a", '<a style="text-decoration: underline"'), cC(r)) : null;
  };
  return n(), /* @__PURE__ */ p(fe, { component: "div", display: "flex", width: 1, children: /* @__PURE__ */ p(Ne, { children: n() ?? t }) });
};
var Nx;
try {
  Nx = Map;
} catch {
}
var Lx;
try {
  Lx = Set;
} catch {
}
function Qte(e, t, i) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(Tx);
  if (Nx && e instanceof Nx)
    return new Map(Array.from(e.entries()));
  if (Lx && e instanceof Lx)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var n = Object.create(e);
    i.push(n);
    for (var g in e) {
      var r = t.findIndex(function(o) {
        return o === e[g];
      });
      n[g] = r > -1 ? i[r] : Qte(e[g], t, i);
    }
    return n;
  }
  return e;
}
function Tx(e) {
  return Qte(e, [], []);
}
const JZt = Object.prototype.toString, KZt = Error.prototype.toString, EZt = RegExp.prototype.toString, NZt = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", LZt = /^Symbol\((.*)\)(.*)$/;
function TZt(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function bP(e, t = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const i = typeof e;
  if (i === "number")
    return TZt(e);
  if (i === "string")
    return t ? `"${e}"` : e;
  if (i === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (i === "symbol")
    return NZt.call(e).replace(LZt, "Symbol($1)");
  const n = JZt.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + KZt.call(e) + "]" : n === "RegExp" ? EZt.call(e) : null;
}
function bZ(e, t) {
  let i = bP(e, t);
  return i !== null ? i : JSON.stringify(e, function(n, g) {
    let r = bP(this[n], t);
    return r !== null ? r : g;
  }, 2);
}
let Cu = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: i,
    originalValue: n
  }) => {
    let g = n != null && n !== i, r = `${e} must be a \`${t}\` type, but the final value was: \`${bZ(i, !0)}\`` + (g ? ` (cast from the value \`${bZ(n, !0)}\`).` : ".");
    return i === null && (r += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), r;
  },
  defined: "${path} must be defined"
}, is = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, MZt = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Mx = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, UZt = {
  isValue: "${path} field must be ${value}"
}, Ux = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, PZt = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Cu,
  string: is,
  number: MZt,
  date: Mx,
  object: Ux,
  array: PZt,
  boolean: UZt
});
var zZt = Object.prototype, OZt = zZt.hasOwnProperty;
function QZt(e, t) {
  return e != null && OZt.call(e, t);
}
var jZt = QZt, _Zt = Array.isArray, dC = _Zt, $Zt = typeof Zn == "object" && Zn && Zn.Object === Object && Zn, jte = $Zt, qZt = jte, eft = typeof self == "object" && self && self.Object === Object && self, tft = qZt || eft || Function("return this")(), Xc = tft, ift = Xc, nft = ift.Symbol, T2 = nft, mP = T2, _te = Object.prototype, gft = _te.hasOwnProperty, rft = _te.toString, E0 = mP ? mP.toStringTag : void 0;
function oft(e) {
  var t = gft.call(e, E0), i = e[E0];
  try {
    e[E0] = void 0;
    var n = !0;
  } catch {
  }
  var g = rft.call(e);
  return n && (t ? e[E0] = i : delete e[E0]), g;
}
var Ift = oft, lft = Object.prototype, sft = lft.toString;
function aft(e) {
  return sft.call(e);
}
var cft = aft, hP = T2, dft = Ift, Cft = cft, uft = "[object Null]", Aft = "[object Undefined]", pP = hP ? hP.toStringTag : void 0;
function bft(e) {
  return e == null ? e === void 0 ? Aft : uft : pP && pP in Object(e) ? dft(e) : Cft(e);
}
var Ff = bft;
function mft(e) {
  return e != null && typeof e == "object";
}
var Yf = mft, hft = Ff, pft = Yf, Bft = "[object Symbol]";
function Zft(e) {
  return typeof e == "symbol" || pft(e) && hft(e) == Bft;
}
var xE = Zft, fft = dC, Gft = xE, yft = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Wft = /^\w*$/;
function Sft(e, t) {
  if (fft(e))
    return !1;
  var i = typeof e;
  return i == "number" || i == "symbol" || i == "boolean" || e == null || Gft(e) ? !0 : Wft.test(e) || !yft.test(e) || t != null && e in Object(t);
}
var DE = Sft;
function Vft(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var JE = Vft, wft = Ff, vft = JE, Rft = "[object AsyncFunction]", Xft = "[object Function]", Hft = "[object GeneratorFunction]", kft = "[object Proxy]";
function Fft(e) {
  if (!vft(e))
    return !1;
  var t = wft(e);
  return t == Xft || t == Hft || t == Rft || t == kft;
}
var $te = Fft, Yft = Xc, xft = Yft["__core-js_shared__"], Dft = xft, JF = Dft, BP = function() {
  var e = /[^.]+$/.exec(JF && JF.keys && JF.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Jft(e) {
  return !!BP && BP in e;
}
var Kft = Jft, Eft = Function.prototype, Nft = Eft.toString;
function Lft(e) {
  if (e != null) {
    try {
      return Nft.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var qte = Lft, Tft = $te, Mft = Kft, Uft = JE, Pft = qte, zft = /[\\^$.*+?()[\]{}|]/g, Oft = /^\[object .+?Constructor\]$/, Qft = Function.prototype, jft = Object.prototype, _ft = Qft.toString, $ft = jft.hasOwnProperty, qft = RegExp(
  "^" + _ft.call($ft).replace(zft, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function eGt(e) {
  if (!Uft(e) || Mft(e))
    return !1;
  var t = Tft(e) ? qft : Oft;
  return t.test(Pft(e));
}
var tGt = eGt;
function iGt(e, t) {
  return e == null ? void 0 : e[t];
}
var nGt = iGt, gGt = tGt, rGt = nGt;
function oGt(e, t) {
  var i = rGt(e, t);
  return gGt(i) ? i : void 0;
}
var dA = oGt, IGt = dA, lGt = IGt(Object, "create"), M2 = lGt, ZP = M2;
function sGt() {
  this.__data__ = ZP ? ZP(null) : {}, this.size = 0;
}
var aGt = sGt;
function cGt(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var dGt = cGt, CGt = M2, uGt = "__lodash_hash_undefined__", AGt = Object.prototype, bGt = AGt.hasOwnProperty;
function mGt(e) {
  var t = this.__data__;
  if (CGt) {
    var i = t[e];
    return i === uGt ? void 0 : i;
  }
  return bGt.call(t, e) ? t[e] : void 0;
}
var hGt = mGt, pGt = M2, BGt = Object.prototype, ZGt = BGt.hasOwnProperty;
function fGt(e) {
  var t = this.__data__;
  return pGt ? t[e] !== void 0 : ZGt.call(t, e);
}
var GGt = fGt, yGt = M2, WGt = "__lodash_hash_undefined__";
function SGt(e, t) {
  var i = this.__data__;
  return this.size += this.has(e) ? 0 : 1, i[e] = yGt && t === void 0 ? WGt : t, this;
}
var VGt = SGt, wGt = aGt, vGt = dGt, RGt = hGt, XGt = GGt, HGt = VGt;
function Wh(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Wh.prototype.clear = wGt;
Wh.prototype.delete = vGt;
Wh.prototype.get = RGt;
Wh.prototype.has = XGt;
Wh.prototype.set = HGt;
var kGt = Wh;
function FGt() {
  this.__data__ = [], this.size = 0;
}
var YGt = FGt;
function xGt(e, t) {
  return e === t || e !== e && t !== t;
}
var eie = xGt, DGt = eie;
function JGt(e, t) {
  for (var i = e.length; i--; )
    if (DGt(e[i][0], t))
      return i;
  return -1;
}
var U2 = JGt, KGt = U2, EGt = Array.prototype, NGt = EGt.splice;
function LGt(e) {
  var t = this.__data__, i = KGt(t, e);
  if (i < 0)
    return !1;
  var n = t.length - 1;
  return i == n ? t.pop() : NGt.call(t, i, 1), --this.size, !0;
}
var TGt = LGt, MGt = U2;
function UGt(e) {
  var t = this.__data__, i = MGt(t, e);
  return i < 0 ? void 0 : t[i][1];
}
var PGt = UGt, zGt = U2;
function OGt(e) {
  return zGt(this.__data__, e) > -1;
}
var QGt = OGt, jGt = U2;
function _Gt(e, t) {
  var i = this.__data__, n = jGt(i, e);
  return n < 0 ? (++this.size, i.push([e, t])) : i[n][1] = t, this;
}
var $Gt = _Gt, qGt = YGt, eyt = TGt, tyt = PGt, iyt = QGt, nyt = $Gt;
function Sh(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Sh.prototype.clear = qGt;
Sh.prototype.delete = eyt;
Sh.prototype.get = tyt;
Sh.prototype.has = iyt;
Sh.prototype.set = nyt;
var P2 = Sh, gyt = dA, ryt = Xc, oyt = gyt(ryt, "Map"), KE = oyt, fP = kGt, Iyt = P2, lyt = KE;
function syt() {
  this.size = 0, this.__data__ = {
    hash: new fP(),
    map: new (lyt || Iyt)(),
    string: new fP()
  };
}
var ayt = syt;
function cyt(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var dyt = cyt, Cyt = dyt;
function uyt(e, t) {
  var i = e.__data__;
  return Cyt(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
}
var z2 = uyt, Ayt = z2;
function byt(e) {
  var t = Ayt(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var myt = byt, hyt = z2;
function pyt(e) {
  return hyt(this, e).get(e);
}
var Byt = pyt, Zyt = z2;
function fyt(e) {
  return Zyt(this, e).has(e);
}
var Gyt = fyt, yyt = z2;
function Wyt(e, t) {
  var i = yyt(this, e), n = i.size;
  return i.set(e, t), this.size += i.size == n ? 0 : 1, this;
}
var Syt = Wyt, Vyt = ayt, wyt = myt, vyt = Byt, Ryt = Gyt, Xyt = Syt;
function Vh(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Vh.prototype.clear = Vyt;
Vh.prototype.delete = wyt;
Vh.prototype.get = vyt;
Vh.prototype.has = Ryt;
Vh.prototype.set = Xyt;
var EE = Vh, tie = EE, Hyt = "Expected a function";
function NE(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Hyt);
  var i = function() {
    var n = arguments, g = t ? t.apply(this, n) : n[0], r = i.cache;
    if (r.has(g))
      return r.get(g);
    var o = e.apply(this, n);
    return i.cache = r.set(g, o) || r, o;
  };
  return i.cache = new (NE.Cache || tie)(), i;
}
NE.Cache = tie;
var kyt = NE, Fyt = kyt, Yyt = 500;
function xyt(e) {
  var t = Fyt(e, function(n) {
    return i.size === Yyt && i.clear(), n;
  }), i = t.cache;
  return t;
}
var Dyt = xyt, Jyt = Dyt, Kyt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Eyt = /\\(\\)?/g, Nyt = Jyt(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Kyt, function(i, n, g, r) {
    t.push(g ? r.replace(Eyt, "$1") : n || i);
  }), t;
}), Lyt = Nyt;
function Tyt(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length, g = Array(n); ++i < n; )
    g[i] = t(e[i], i, e);
  return g;
}
var Myt = Tyt, GP = T2, Uyt = Myt, Pyt = dC, zyt = xE, Oyt = 1 / 0, yP = GP ? GP.prototype : void 0, WP = yP ? yP.toString : void 0;
function iie(e) {
  if (typeof e == "string")
    return e;
  if (Pyt(e))
    return Uyt(e, iie) + "";
  if (zyt(e))
    return WP ? WP.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Oyt ? "-0" : t;
}
var Qyt = iie, jyt = Qyt;
function _yt(e) {
  return e == null ? "" : jyt(e);
}
var xf = _yt, $yt = dC, qyt = DE, eWt = Lyt, tWt = xf;
function iWt(e, t) {
  return $yt(e) ? e : qyt(e, t) ? [e] : eWt(tWt(e));
}
var nie = iWt, nWt = Ff, gWt = Yf, rWt = "[object Arguments]";
function oWt(e) {
  return gWt(e) && nWt(e) == rWt;
}
var IWt = oWt, SP = IWt, lWt = Yf, gie = Object.prototype, sWt = gie.hasOwnProperty, aWt = gie.propertyIsEnumerable, cWt = SP(/* @__PURE__ */ function() {
  return arguments;
}()) ? SP : function(e) {
  return lWt(e) && sWt.call(e, "callee") && !aWt.call(e, "callee");
}, rie = cWt, dWt = 9007199254740991, CWt = /^(?:0|[1-9]\d*)$/;
function uWt(e, t) {
  var i = typeof e;
  return t = t ?? dWt, !!t && (i == "number" || i != "symbol" && CWt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var oie = uWt, AWt = 9007199254740991;
function bWt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= AWt;
}
var LE = bWt, mWt = xE, hWt = 1 / 0;
function pWt(e) {
  if (typeof e == "string" || mWt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -hWt ? "-0" : t;
}
var O2 = pWt, BWt = nie, ZWt = rie, fWt = dC, GWt = oie, yWt = LE, WWt = O2;
function SWt(e, t, i) {
  t = BWt(t, e);
  for (var n = -1, g = t.length, r = !1; ++n < g; ) {
    var o = WWt(t[n]);
    if (!(r = e != null && i(e, o)))
      break;
    e = e[o];
  }
  return r || ++n != g ? r : (g = e == null ? 0 : e.length, !!g && yWt(g) && GWt(o, g) && (fWt(e) || ZWt(e)));
}
var Iie = SWt, VWt = jZt, wWt = Iie;
function vWt(e, t) {
  return e != null && wWt(e, t, VWt);
}
var RWt = vWt;
const NV = /* @__PURE__ */ Tr(RWt), lie = (e) => e && e.__isYupSchema__;
class XWt {
  constructor(t, i) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof i == "function") {
      this.fn = i;
      return;
    }
    if (!NV(i, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!i.then && !i.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: g,
      otherwise: r
    } = i, o = typeof n == "function" ? n : (...I) => I.every((s) => s === n);
    this.fn = function(...I) {
      let s = I.pop(), a = I.pop(), d = o(...I) ? g : r;
      if (d)
        return typeof d == "function" ? d(a) : a.concat(d.resolve(s));
    };
  }
  resolve(t, i) {
    let n = this.refs.map((r) => r.getValue(i == null ? void 0 : i.value, i == null ? void 0 : i.parent, i == null ? void 0 : i.context)), g = this.fn.apply(t, n.concat(t, i));
    if (g === void 0 || g === t)
      return t;
    if (!lie(g))
      throw new TypeError("conditions must return a schema object");
    return g.resolve(i);
  }
}
function sie(e) {
  return e == null ? [] : [].concat(e);
}
function Px() {
  return Px = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Px.apply(this, arguments);
}
let HWt = /\$\{\s*(\w+)\s*\}/g;
class VI extends Error {
  static formatError(t, i) {
    const n = i.label || i.path || "this";
    return n !== i.path && (i = Px({}, i, {
      path: n
    })), typeof t == "string" ? t.replace(HWt, (g, r) => bZ(i[r])) : typeof t == "function" ? t(i) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, i, n, g) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = i, this.path = n, this.type = g, this.errors = [], this.inner = [], sie(t).forEach((r) => {
      VI.isError(r) ? (this.errors.push(...r.errors), this.inner = this.inner.concat(r.inner.length ? r.inner : r)) : this.errors.push(r);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, VI);
  }
}
const kWt = (e) => {
  let t = !1;
  return (...i) => {
    t || (t = !0, e(...i));
  };
};
function zx(e, t) {
  let {
    endEarly: i,
    tests: n,
    args: g,
    value: r,
    errors: o,
    sort: I,
    path: s
  } = e, a = kWt(t), d = n.length;
  const C = [];
  if (o = o || [], !d)
    return o.length ? a(new VI(o, r, s)) : a(null, r);
  for (let u = 0; u < n.length; u++) {
    const A = n[u];
    A(g, function(h) {
      if (h) {
        if (!VI.isError(h))
          return a(h, r);
        if (i)
          return h.value = r, a(h, r);
        C.push(h);
      }
      if (--d <= 0) {
        if (C.length && (I && C.sort(I), o.length && C.push(...o), o = C), o.length) {
          a(new VI(o, r, s), r);
          return;
        }
        a(null, r);
      }
    });
  }
}
var FWt = dA, YWt = function() {
  try {
    var e = FWt(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), xWt = YWt, VP = xWt;
function DWt(e, t, i) {
  t == "__proto__" && VP ? VP(e, t, {
    configurable: !0,
    enumerable: !0,
    value: i,
    writable: !0
  }) : e[t] = i;
}
var aie = DWt;
function JWt(e) {
  return function(t, i, n) {
    for (var g = -1, r = Object(t), o = n(t), I = o.length; I--; ) {
      var s = o[e ? I : ++g];
      if (i(r[s], s, r) === !1)
        break;
    }
    return t;
  };
}
var KWt = JWt, EWt = KWt, NWt = EWt(), LWt = NWt;
function TWt(e, t) {
  for (var i = -1, n = Array(e); ++i < e; )
    n[i] = t(i);
  return n;
}
var MWt = TWt, LV = { exports: {} };
function UWt() {
  return !1;
}
var PWt = UWt;
LV.exports;
(function(e, t) {
  var i = Xc, n = PWt, g = t && !t.nodeType && t, r = g && !0 && e && !e.nodeType && e, o = r && r.exports === g, I = o ? i.Buffer : void 0, s = I ? I.isBuffer : void 0, a = s || n;
  e.exports = a;
})(LV, LV.exports);
var cie = LV.exports, zWt = Ff, OWt = LE, QWt = Yf, jWt = "[object Arguments]", _Wt = "[object Array]", $Wt = "[object Boolean]", qWt = "[object Date]", eSt = "[object Error]", tSt = "[object Function]", iSt = "[object Map]", nSt = "[object Number]", gSt = "[object Object]", rSt = "[object RegExp]", oSt = "[object Set]", ISt = "[object String]", lSt = "[object WeakMap]", sSt = "[object ArrayBuffer]", aSt = "[object DataView]", cSt = "[object Float32Array]", dSt = "[object Float64Array]", CSt = "[object Int8Array]", uSt = "[object Int16Array]", ASt = "[object Int32Array]", bSt = "[object Uint8Array]", mSt = "[object Uint8ClampedArray]", hSt = "[object Uint16Array]", pSt = "[object Uint32Array]", Ln = {};
Ln[cSt] = Ln[dSt] = Ln[CSt] = Ln[uSt] = Ln[ASt] = Ln[bSt] = Ln[mSt] = Ln[hSt] = Ln[pSt] = !0;
Ln[jWt] = Ln[_Wt] = Ln[sSt] = Ln[$Wt] = Ln[aSt] = Ln[qWt] = Ln[eSt] = Ln[tSt] = Ln[iSt] = Ln[nSt] = Ln[gSt] = Ln[rSt] = Ln[oSt] = Ln[ISt] = Ln[lSt] = !1;
function BSt(e) {
  return QWt(e) && OWt(e.length) && !!Ln[zWt(e)];
}
var ZSt = BSt;
function fSt(e) {
  return function(t) {
    return e(t);
  };
}
var GSt = fSt, TV = { exports: {} };
TV.exports;
(function(e, t) {
  var i = jte, n = t && !t.nodeType && t, g = n && !0 && e && !e.nodeType && e, r = g && g.exports === n, o = r && i.process, I = function() {
    try {
      var s = g && g.require && g.require("util").types;
      return s || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = I;
})(TV, TV.exports);
var ySt = TV.exports, WSt = ZSt, SSt = GSt, wP = ySt, vP = wP && wP.isTypedArray, VSt = vP ? SSt(vP) : WSt, die = VSt, wSt = MWt, vSt = rie, RSt = dC, XSt = cie, HSt = oie, kSt = die, FSt = Object.prototype, YSt = FSt.hasOwnProperty;
function xSt(e, t) {
  var i = RSt(e), n = !i && vSt(e), g = !i && !n && XSt(e), r = !i && !n && !g && kSt(e), o = i || n || g || r, I = o ? wSt(e.length, String) : [], s = I.length;
  for (var a in e)
    (t || YSt.call(e, a)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (a == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    g && (a == "offset" || a == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (a == "buffer" || a == "byteLength" || a == "byteOffset") || // Skip index properties.
    HSt(a, s))) && I.push(a);
  return I;
}
var DSt = xSt, JSt = Object.prototype;
function KSt(e) {
  var t = e && e.constructor, i = typeof t == "function" && t.prototype || JSt;
  return e === i;
}
var ESt = KSt;
function NSt(e, t) {
  return function(i) {
    return e(t(i));
  };
}
var LSt = NSt, TSt = LSt, MSt = TSt(Object.keys, Object), USt = MSt, PSt = ESt, zSt = USt, OSt = Object.prototype, QSt = OSt.hasOwnProperty;
function jSt(e) {
  if (!PSt(e))
    return zSt(e);
  var t = [];
  for (var i in Object(e))
    QSt.call(e, i) && i != "constructor" && t.push(i);
  return t;
}
var _St = jSt, $St = $te, qSt = LE;
function eVt(e) {
  return e != null && qSt(e.length) && !$St(e);
}
var tVt = eVt, iVt = DSt, nVt = _St, gVt = tVt;
function rVt(e) {
  return gVt(e) ? iVt(e) : nVt(e);
}
var TE = rVt, oVt = LWt, IVt = TE;
function lVt(e, t) {
  return e && oVt(e, t, IVt);
}
var Cie = lVt, sVt = P2;
function aVt() {
  this.__data__ = new sVt(), this.size = 0;
}
var cVt = aVt;
function dVt(e) {
  var t = this.__data__, i = t.delete(e);
  return this.size = t.size, i;
}
var CVt = dVt;
function uVt(e) {
  return this.__data__.get(e);
}
var AVt = uVt;
function bVt(e) {
  return this.__data__.has(e);
}
var mVt = bVt, hVt = P2, pVt = KE, BVt = EE, ZVt = 200;
function fVt(e, t) {
  var i = this.__data__;
  if (i instanceof hVt) {
    var n = i.__data__;
    if (!pVt || n.length < ZVt - 1)
      return n.push([e, t]), this.size = ++i.size, this;
    i = this.__data__ = new BVt(n);
  }
  return i.set(e, t), this.size = i.size, this;
}
var GVt = fVt, yVt = P2, WVt = cVt, SVt = CVt, VVt = AVt, wVt = mVt, vVt = GVt;
function wh(e) {
  var t = this.__data__ = new yVt(e);
  this.size = t.size;
}
wh.prototype.clear = WVt;
wh.prototype.delete = SVt;
wh.prototype.get = VVt;
wh.prototype.has = wVt;
wh.prototype.set = vVt;
var uie = wh, RVt = "__lodash_hash_undefined__";
function XVt(e) {
  return this.__data__.set(e, RVt), this;
}
var HVt = XVt;
function kVt(e) {
  return this.__data__.has(e);
}
var FVt = kVt, YVt = EE, xVt = HVt, DVt = FVt;
function MV(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.__data__ = new YVt(); ++t < i; )
    this.add(e[t]);
}
MV.prototype.add = MV.prototype.push = xVt;
MV.prototype.has = DVt;
var JVt = MV;
function KVt(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length; ++i < n; )
    if (t(e[i], i, e))
      return !0;
  return !1;
}
var EVt = KVt;
function NVt(e, t) {
  return e.has(t);
}
var LVt = NVt, TVt = JVt, MVt = EVt, UVt = LVt, PVt = 1, zVt = 2;
function OVt(e, t, i, n, g, r) {
  var o = i & PVt, I = e.length, s = t.length;
  if (I != s && !(o && s > I))
    return !1;
  var a = r.get(e), d = r.get(t);
  if (a && d)
    return a == t && d == e;
  var C = -1, u = !0, A = i & zVt ? new TVt() : void 0;
  for (r.set(e, t), r.set(t, e); ++C < I; ) {
    var m = e[C], h = t[C];
    if (n)
      var B = o ? n(h, m, C, t, e, r) : n(m, h, C, e, t, r);
    if (B !== void 0) {
      if (B)
        continue;
      u = !1;
      break;
    }
    if (A) {
      if (!MVt(t, function(f, G) {
        if (!UVt(A, G) && (m === f || g(m, f, i, n, r)))
          return A.push(G);
      })) {
        u = !1;
        break;
      }
    } else if (!(m === h || g(m, h, i, n, r))) {
      u = !1;
      break;
    }
  }
  return r.delete(e), r.delete(t), u;
}
var Aie = OVt, QVt = Xc, jVt = QVt.Uint8Array, _Vt = jVt;
function $Vt(e) {
  var t = -1, i = Array(e.size);
  return e.forEach(function(n, g) {
    i[++t] = [g, n];
  }), i;
}
var qVt = $Vt;
function ewt(e) {
  var t = -1, i = Array(e.size);
  return e.forEach(function(n) {
    i[++t] = n;
  }), i;
}
var twt = ewt, RP = T2, XP = _Vt, iwt = eie, nwt = Aie, gwt = qVt, rwt = twt, owt = 1, Iwt = 2, lwt = "[object Boolean]", swt = "[object Date]", awt = "[object Error]", cwt = "[object Map]", dwt = "[object Number]", Cwt = "[object RegExp]", uwt = "[object Set]", Awt = "[object String]", bwt = "[object Symbol]", mwt = "[object ArrayBuffer]", hwt = "[object DataView]", HP = RP ? RP.prototype : void 0, KF = HP ? HP.valueOf : void 0;
function pwt(e, t, i, n, g, r, o) {
  switch (i) {
    case hwt:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case mwt:
      return !(e.byteLength != t.byteLength || !r(new XP(e), new XP(t)));
    case lwt:
    case swt:
    case dwt:
      return iwt(+e, +t);
    case awt:
      return e.name == t.name && e.message == t.message;
    case Cwt:
    case Awt:
      return e == t + "";
    case cwt:
      var I = gwt;
    case uwt:
      var s = n & owt;
      if (I || (I = rwt), e.size != t.size && !s)
        return !1;
      var a = o.get(e);
      if (a)
        return a == t;
      n |= Iwt, o.set(e, t);
      var d = nwt(I(e), I(t), n, g, r, o);
      return o.delete(e), d;
    case bwt:
      if (KF)
        return KF.call(e) == KF.call(t);
  }
  return !1;
}
var Bwt = pwt;
function Zwt(e, t) {
  for (var i = -1, n = t.length, g = e.length; ++i < n; )
    e[g + i] = t[i];
  return e;
}
var fwt = Zwt, Gwt = fwt, ywt = dC;
function Wwt(e, t, i) {
  var n = t(e);
  return ywt(e) ? n : Gwt(n, i(e));
}
var Swt = Wwt;
function Vwt(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length, g = 0, r = []; ++i < n; ) {
    var o = e[i];
    t(o, i, e) && (r[g++] = o);
  }
  return r;
}
var wwt = Vwt;
function vwt() {
  return [];
}
var Rwt = vwt, Xwt = wwt, Hwt = Rwt, kwt = Object.prototype, Fwt = kwt.propertyIsEnumerable, kP = Object.getOwnPropertySymbols, Ywt = kP ? function(e) {
  return e == null ? [] : (e = Object(e), Xwt(kP(e), function(t) {
    return Fwt.call(e, t);
  }));
} : Hwt, xwt = Ywt, Dwt = Swt, Jwt = xwt, Kwt = TE;
function Ewt(e) {
  return Dwt(e, Kwt, Jwt);
}
var Nwt = Ewt, FP = Nwt, Lwt = 1, Twt = Object.prototype, Mwt = Twt.hasOwnProperty;
function Uwt(e, t, i, n, g, r) {
  var o = i & Lwt, I = FP(e), s = I.length, a = FP(t), d = a.length;
  if (s != d && !o)
    return !1;
  for (var C = s; C--; ) {
    var u = I[C];
    if (!(o ? u in t : Mwt.call(t, u)))
      return !1;
  }
  var A = r.get(e), m = r.get(t);
  if (A && m)
    return A == t && m == e;
  var h = !0;
  r.set(e, t), r.set(t, e);
  for (var B = o; ++C < s; ) {
    u = I[C];
    var f = e[u], G = t[u];
    if (n)
      var y = o ? n(G, f, u, t, e, r) : n(f, G, u, e, t, r);
    if (!(y === void 0 ? f === G || g(f, G, i, n, r) : y)) {
      h = !1;
      break;
    }
    B || (B = u == "constructor");
  }
  if (h && !B) {
    var W = e.constructor, V = t.constructor;
    W != V && "constructor" in e && "constructor" in t && !(typeof W == "function" && W instanceof W && typeof V == "function" && V instanceof V) && (h = !1);
  }
  return r.delete(e), r.delete(t), h;
}
var Pwt = Uwt, zwt = dA, Owt = Xc, Qwt = zwt(Owt, "DataView"), jwt = Qwt, _wt = dA, $wt = Xc, qwt = _wt($wt, "Promise"), e1t = qwt, t1t = dA, i1t = Xc, n1t = t1t(i1t, "Set"), g1t = n1t, r1t = dA, o1t = Xc, I1t = r1t(o1t, "WeakMap"), l1t = I1t, Ox = jwt, Qx = KE, jx = e1t, _x = g1t, $x = l1t, bie = Ff, vh = qte, YP = "[object Map]", s1t = "[object Object]", xP = "[object Promise]", DP = "[object Set]", JP = "[object WeakMap]", KP = "[object DataView]", a1t = vh(Ox), c1t = vh(Qx), d1t = vh(jx), C1t = vh(_x), u1t = vh($x), uu = bie;
(Ox && uu(new Ox(new ArrayBuffer(1))) != KP || Qx && uu(new Qx()) != YP || jx && uu(jx.resolve()) != xP || _x && uu(new _x()) != DP || $x && uu(new $x()) != JP) && (uu = function(e) {
  var t = bie(e), i = t == s1t ? e.constructor : void 0, n = i ? vh(i) : "";
  if (n)
    switch (n) {
      case a1t:
        return KP;
      case c1t:
        return YP;
      case d1t:
        return xP;
      case C1t:
        return DP;
      case u1t:
        return JP;
    }
  return t;
});
var A1t = uu, EF = uie, b1t = Aie, m1t = Bwt, h1t = Pwt, EP = A1t, NP = dC, LP = cie, p1t = die, B1t = 1, TP = "[object Arguments]", MP = "[object Array]", PW = "[object Object]", Z1t = Object.prototype, UP = Z1t.hasOwnProperty;
function f1t(e, t, i, n, g, r) {
  var o = NP(e), I = NP(t), s = o ? MP : EP(e), a = I ? MP : EP(t);
  s = s == TP ? PW : s, a = a == TP ? PW : a;
  var d = s == PW, C = a == PW, u = s == a;
  if (u && LP(e)) {
    if (!LP(t))
      return !1;
    o = !0, d = !1;
  }
  if (u && !d)
    return r || (r = new EF()), o || p1t(e) ? b1t(e, t, i, n, g, r) : m1t(e, t, s, i, n, g, r);
  if (!(i & B1t)) {
    var A = d && UP.call(e, "__wrapped__"), m = C && UP.call(t, "__wrapped__");
    if (A || m) {
      var h = A ? e.value() : e, B = m ? t.value() : t;
      return r || (r = new EF()), g(h, B, i, n, r);
    }
  }
  return u ? (r || (r = new EF()), h1t(e, t, i, n, g, r)) : !1;
}
var G1t = f1t, y1t = G1t, PP = Yf;
function mie(e, t, i, n, g) {
  return e === t ? !0 : e == null || t == null || !PP(e) && !PP(t) ? e !== e && t !== t : y1t(e, t, i, n, mie, g);
}
var hie = mie, W1t = uie, S1t = hie, V1t = 1, w1t = 2;
function v1t(e, t, i, n) {
  var g = i.length, r = g, o = !n;
  if (e == null)
    return !r;
  for (e = Object(e); g--; ) {
    var I = i[g];
    if (o && I[2] ? I[1] !== e[I[0]] : !(I[0] in e))
      return !1;
  }
  for (; ++g < r; ) {
    I = i[g];
    var s = I[0], a = e[s], d = I[1];
    if (o && I[2]) {
      if (a === void 0 && !(s in e))
        return !1;
    } else {
      var C = new W1t();
      if (n)
        var u = n(a, d, s, e, t, C);
      if (!(u === void 0 ? S1t(d, a, V1t | w1t, n, C) : u))
        return !1;
    }
  }
  return !0;
}
var R1t = v1t, X1t = JE;
function H1t(e) {
  return e === e && !X1t(e);
}
var pie = H1t, k1t = pie, F1t = TE;
function Y1t(e) {
  for (var t = F1t(e), i = t.length; i--; ) {
    var n = t[i], g = e[n];
    t[i] = [n, g, k1t(g)];
  }
  return t;
}
var x1t = Y1t;
function D1t(e, t) {
  return function(i) {
    return i == null ? !1 : i[e] === t && (t !== void 0 || e in Object(i));
  };
}
var Bie = D1t, J1t = R1t, K1t = x1t, E1t = Bie;
function N1t(e) {
  var t = K1t(e);
  return t.length == 1 && t[0][2] ? E1t(t[0][0], t[0][1]) : function(i) {
    return i === e || J1t(i, e, t);
  };
}
var L1t = N1t, T1t = nie, M1t = O2;
function U1t(e, t) {
  t = T1t(t, e);
  for (var i = 0, n = t.length; e != null && i < n; )
    e = e[M1t(t[i++])];
  return i && i == n ? e : void 0;
}
var Zie = U1t, P1t = Zie;
function z1t(e, t, i) {
  var n = e == null ? void 0 : P1t(e, t);
  return n === void 0 ? i : n;
}
var O1t = z1t;
function Q1t(e, t) {
  return e != null && t in Object(e);
}
var j1t = Q1t, _1t = j1t, $1t = Iie;
function q1t(e, t) {
  return e != null && $1t(e, t, _1t);
}
var e2t = q1t, t2t = hie, i2t = O1t, n2t = e2t, g2t = DE, r2t = pie, o2t = Bie, I2t = O2, l2t = 1, s2t = 2;
function a2t(e, t) {
  return g2t(e) && r2t(t) ? o2t(I2t(e), t) : function(i) {
    var n = i2t(i, e);
    return n === void 0 && n === t ? n2t(i, e) : t2t(t, n, l2t | s2t);
  };
}
var c2t = a2t;
function d2t(e) {
  return e;
}
var C2t = d2t;
function u2t(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var A2t = u2t, b2t = Zie;
function m2t(e) {
  return function(t) {
    return b2t(t, e);
  };
}
var h2t = m2t, p2t = A2t, B2t = h2t, Z2t = DE, f2t = O2;
function G2t(e) {
  return Z2t(e) ? p2t(f2t(e)) : B2t(e);
}
var y2t = G2t, W2t = L1t, S2t = c2t, V2t = C2t, w2t = dC, v2t = y2t;
function R2t(e) {
  return typeof e == "function" ? e : e == null ? V2t : typeof e == "object" ? w2t(e) ? S2t(e[0], e[1]) : W2t(e) : v2t(e);
}
var fie = R2t, X2t = aie, H2t = Cie, k2t = fie;
function F2t(e, t) {
  var i = {};
  return t = k2t(t), H2t(e, function(n, g, r) {
    X2t(i, g, t(n, g, r));
  }), i;
}
var Y2t = F2t;
const Gie = /* @__PURE__ */ Tr(Y2t);
function CA(e) {
  this._maxSize = e, this.clear();
}
CA.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
CA.prototype.get = function(e) {
  return this._values[e];
};
CA.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var x2t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, yie = /^\d+$/, D2t = /^\d/, J2t = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, K2t = /^\s*(['"]?)(.*?)(\1)\s*$/, ME = 512, zP = new CA(ME), OP = new CA(ME), QP = new CA(ME), Q2 = {
  Cache: CA,
  split: qx,
  normalizePath: NF,
  setter: function(e) {
    var t = NF(e);
    return OP.get(e) || OP.set(e, function(n, g) {
      for (var r = 0, o = t.length, I = n; r < o - 1; ) {
        var s = t[r];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return n;
        I = I[t[r++]];
      }
      I[t[r]] = g;
    });
  },
  getter: function(e, t) {
    var i = NF(e);
    return QP.get(e) || QP.set(e, function(g) {
      for (var r = 0, o = i.length; r < o; )
        if (g != null || !t)
          g = g[i[r++]];
        else
          return;
      return g;
    });
  },
  join: function(e) {
    return e.reduce(function(t, i) {
      return t + (UE(i) || yie.test(i) ? "[" + i + "]" : (t ? "." : "") + i);
    }, "");
  },
  forEach: function(e, t, i) {
    E2t(Array.isArray(e) ? e : qx(e), t, i);
  }
};
function NF(e) {
  return zP.get(e) || zP.set(
    e,
    qx(e).map(function(t) {
      return t.replace(K2t, "$2");
    })
  );
}
function qx(e) {
  return e.match(x2t) || [""];
}
function E2t(e, t, i) {
  var n = e.length, g, r, o, I;
  for (r = 0; r < n; r++)
    g = e[r], g && (T2t(g) && (g = '"' + g + '"'), I = UE(g), o = !I && /^\d+$/.test(g), t.call(i, g, I, o, r, e));
}
function UE(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function N2t(e) {
  return e.match(D2t) && !e.match(yie);
}
function L2t(e) {
  return J2t.test(e);
}
function T2t(e) {
  return !UE(e) && (N2t(e) || L2t(e));
}
const zW = {
  context: "$",
  value: "."
};
class Hd {
  constructor(t, i = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === zW.context, this.isValue = this.key[0] === zW.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? zW.context : this.isValue ? zW.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && Q2.getter(this.path, !0), this.map = i.map;
  }
  getValue(t, i, n) {
    let g = this.isContext ? n : this.isValue ? t : i;
    return this.getter && (g = this.getter(g || {})), this.map && (g = this.map(g)), g;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, i) {
    return this.getValue(t, i == null ? void 0 : i.parent, i == null ? void 0 : i.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Hd.prototype.__isYupRef = !0;
function UV() {
  return UV = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, UV.apply(this, arguments);
}
function M2t(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), g, r;
  for (r = 0; r < n.length; r++)
    g = n[r], !(t.indexOf(g) >= 0) && (i[g] = e[g]);
  return i;
}
function OW(e) {
  function t(i, n) {
    let {
      value: g,
      path: r = "",
      label: o,
      options: I,
      originalValue: s,
      sync: a
    } = i, d = M2t(i, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: C,
      test: u,
      params: A,
      message: m
    } = e;
    let {
      parent: h,
      context: B
    } = I;
    function f(w) {
      return Hd.isRef(w) ? w.getValue(g, h, B) : w;
    }
    function G(w = {}) {
      const v = Gie(UV({
        value: g,
        originalValue: s,
        label: o,
        path: w.path || r
      }, A, w.params), f), H = new VI(VI.formatError(w.message || m, v), g, v.path, w.type || C);
      return H.params = v, H;
    }
    let y = UV({
      path: r,
      parent: h,
      type: C,
      createError: G,
      resolve: f,
      options: I,
      originalValue: s
    }, d);
    if (!a) {
      try {
        Promise.resolve(u.call(y, g, y)).then((w) => {
          VI.isError(w) ? n(w) : w ? n(null, w) : n(G());
        }).catch(n);
      } catch (w) {
        n(w);
      }
      return;
    }
    let W;
    try {
      var V;
      if (W = u.call(y, g, y), typeof ((V = W) == null ? void 0 : V.then) == "function")
        throw new Error(`Validation test of type: "${y.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (w) {
      n(w);
      return;
    }
    VI.isError(W) ? n(W) : W ? n(null, W) : n(G());
  }
  return t.OPTIONS = e, t;
}
let U2t = (e) => e.substr(0, e.length - 1).substr(1);
function P2t(e, t, i, n = i) {
  let g, r, o;
  return t ? (Q2.forEach(t, (I, s, a) => {
    let d = s ? U2t(I) : I;
    if (e = e.resolve({
      context: n,
      parent: g,
      value: i
    }), e.innerType) {
      let C = a ? parseInt(d, 10) : 0;
      if (i && C >= i.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${I}, in the path: ${t}. because there is no value at that index. `);
      g = i, i = i && i[C], e = e.innerType;
    }
    if (!a) {
      if (!e.fields || !e.fields[d])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${o} which is a type: "${e._type}")`);
      g = i, i = i && i[d], e = e.fields[d];
    }
    r = d, o = s ? "[" + I + "]" : "." + I;
  }), {
    schema: e,
    parent: g,
    parentPath: r
  }) : {
    parent: g,
    parentPath: t,
    schema: e
  };
}
class PV {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const i of this.list)
      t.push(i);
    for (const [, i] of this.refs)
      t.push(i.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((i, n) => i.concat(Hd.isRef(n) ? t(n) : n), []);
  }
  add(t) {
    Hd.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Hd.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new PV();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, i) {
    const n = this.clone();
    return t.list.forEach((g) => n.add(g)), t.refs.forEach((g) => n.add(g)), i.list.forEach((g) => n.delete(g)), i.refs.forEach((g) => n.delete(g)), n;
  }
}
function ol() {
  return ol = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, ol.apply(this, arguments);
}
class Qo {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new PV(), this._blacklist = new PV(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Cu.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = ol({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const i = Object.create(Object.getPrototypeOf(this));
    return i.type = this.type, i._typeError = this._typeError, i._whitelistError = this._whitelistError, i._blacklistError = this._blacklistError, i._whitelist = this._whitelist.clone(), i._blacklist = this._blacklist.clone(), i.exclusiveTests = ol({}, this.exclusiveTests), i.deps = [...this.deps], i.conditions = [...this.conditions], i.tests = [...this.tests], i.transforms = [...this.transforms], i.spec = Tx(ol({}, this.spec, t)), i;
  }
  label(t) {
    let i = this.clone();
    return i.spec.label = t, i;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let i = this.clone();
    return i.spec.meta = Object.assign(i.spec.meta || {}, t[0]), i;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let i = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = i, n;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let i = this, n = t.clone();
    const g = ol({}, i.spec, n.spec);
    return n.spec = g, n._typeError || (n._typeError = i._typeError), n._whitelistError || (n._whitelistError = i._whitelistError), n._blacklistError || (n._blacklistError = i._blacklistError), n._whitelist = i._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = i._blacklist.merge(t._blacklist, t._whitelist), n.tests = i.tests, n.exclusiveTests = i.exclusiveTests, n.withMutation((r) => {
      t.tests.forEach((o) => {
        r.test(o.OPTIONS);
      });
    }), n.transforms = [...i.transforms, ...n.transforms], n;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let i = this;
    if (i.conditions.length) {
      let n = i.conditions;
      i = i.clone(), i.conditions = [], i = n.reduce((g, r) => r.resolve(g, t), i), i = i.resolve(t);
    }
    return i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, i = {}) {
    let n = this.resolve(ol({
      value: t
    }, i)), g = n._cast(t, i);
    if (t !== void 0 && i.assert !== !1 && n.isType(g) !== !0) {
      let r = bZ(t), o = bZ(g);
      throw new TypeError(`The value of ${i.path || "field"} could not be cast to a value that satisfies the schema type: "${n._type}". 

attempted value: ${r} 
` + (o !== r ? `result of cast: ${o}` : ""));
    }
    return g;
  }
  _cast(t, i) {
    let n = t === void 0 ? t : this.transforms.reduce((g, r) => r.call(this, g, t, this), t);
    return n === void 0 && (n = this.getDefault()), n;
  }
  _validate(t, i = {}, n) {
    let {
      sync: g,
      path: r,
      from: o = [],
      originalValue: I = t,
      strict: s = this.spec.strict,
      abortEarly: a = this.spec.abortEarly
    } = i, d = t;
    s || (d = this._cast(d, ol({
      assert: !1
    }, i)));
    let C = {
      value: d,
      path: r,
      options: i,
      originalValue: I,
      schema: this,
      label: this.spec.label,
      sync: g,
      from: o
    }, u = [];
    this._typeError && u.push(this._typeError);
    let A = [];
    this._whitelistError && A.push(this._whitelistError), this._blacklistError && A.push(this._blacklistError), zx({
      args: C,
      value: d,
      path: r,
      sync: g,
      tests: u,
      endEarly: a
    }, (m) => {
      if (m)
        return void n(m, d);
      zx({
        tests: this.tests.concat(A),
        args: C,
        path: r,
        sync: g,
        value: d,
        endEarly: a
      }, n);
    });
  }
  validate(t, i, n) {
    let g = this.resolve(ol({}, i, {
      value: t
    }));
    return typeof n == "function" ? g._validate(t, i, n) : new Promise((r, o) => g._validate(t, i, (I, s) => {
      I ? o(I) : r(s);
    }));
  }
  validateSync(t, i) {
    let n = this.resolve(ol({}, i, {
      value: t
    })), g;
    return n._validate(t, ol({}, i, {
      sync: !0
    }), (r, o) => {
      if (r)
        throw r;
      g = o;
    }), g;
  }
  isValid(t, i) {
    return this.validate(t, i).then(() => !0, (n) => {
      if (VI.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(t, i) {
    try {
      return this.validateSync(t, i), !0;
    } catch (n) {
      if (VI.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : Tx(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let i = this.clone();
    return i.spec.strict = t, i;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Cu.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(i) {
        return i !== void 0;
      }
    });
  }
  required(t = Cu.required) {
    return this.clone({
      presence: "required"
    }).withMutation((i) => i.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(n) {
        return this.schema._isPresent(n);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((i) => i.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let i = this.clone();
    return i.transforms.push(t), i;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let i;
    if (t.length === 1 ? typeof t[0] == "function" ? i = {
      test: t[0]
    } : i = t[0] : t.length === 2 ? i = {
      name: t[0],
      test: t[1]
    } : i = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, i.message === void 0 && (i.message = Cu.default), typeof i.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), g = OW(i), r = i.exclusive || i.name && n.exclusiveTests[i.name] === !0;
    if (i.exclusive && !i.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return i.name && (n.exclusiveTests[i.name] = !!i.exclusive), n.tests = n.tests.filter((o) => !(o.OPTIONS.name === i.name && (r || o.OPTIONS.test === g.OPTIONS.test))), n.tests.push(g), n;
  }
  when(t, i) {
    !Array.isArray(t) && typeof t != "string" && (i = t, t = ".");
    let n = this.clone(), g = sie(t).map((r) => new Hd(r));
    return g.forEach((r) => {
      r.isSibling && n.deps.push(r.key);
    }), n.conditions.push(new XWt(g, i)), n;
  }
  typeError(t) {
    let i = this.clone();
    return i._typeError = OW({
      message: t,
      name: "typeError",
      test(n) {
        return n !== void 0 && !this.schema.isType(n) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), i;
  }
  oneOf(t, i = Cu.oneOf) {
    let n = this.clone();
    return t.forEach((g) => {
      n._whitelist.add(g), n._blacklist.delete(g);
    }), n._whitelistError = OW({
      message: i,
      name: "oneOf",
      test(g) {
        if (g === void 0)
          return !0;
        let r = this.schema._whitelist, o = r.resolveAll(this.resolve);
        return o.includes(g) ? !0 : this.createError({
          params: {
            values: r.toArray().join(", "),
            resolved: o
          }
        });
      }
    }), n;
  }
  notOneOf(t, i = Cu.notOneOf) {
    let n = this.clone();
    return t.forEach((g) => {
      n._blacklist.add(g), n._whitelist.delete(g);
    }), n._blacklistError = OW({
      message: i,
      name: "notOneOf",
      test(g) {
        let r = this.schema._blacklist, o = r.resolveAll(this.resolve);
        return o.includes(g) ? this.createError({
          params: {
            values: r.toArray().join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let i = this.clone();
    return i.spec.strip = t, i;
  }
  describe() {
    const t = this.clone(), {
      label: i,
      meta: n
    } = t.spec;
    return {
      meta: n,
      label: i,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((r) => ({
        name: r.OPTIONS.name,
        params: r.OPTIONS.params
      })).filter((r, o, I) => I.findIndex((s) => s.name === r.name) === o)
    };
  }
}
Qo.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  Qo.prototype[`${e}At`] = function(t, i, n = {}) {
    const {
      parent: g,
      parentPath: r,
      schema: o
    } = P2t(this, t, i, n.context);
    return o[e](g && g[r], ol({}, n, {
      parent: g,
      path: t
    }));
  };
for (const e of ["equals", "is"])
  Qo.prototype[e] = Qo.prototype.oneOf;
for (const e of ["not", "nope"])
  Qo.prototype[e] = Qo.prototype.notOneOf;
Qo.prototype.optional = Qo.prototype.notRequired;
const z2t = Qo;
z2t.prototype;
const rs = (e) => e == null;
let O2t = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, Q2t = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, j2t = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, _2t = (e) => rs(e) || e === e.trim(), $2t = {}.toString();
function Us() {
  return new Wie();
}
class Wie extends Qo {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t))
          return t;
        const i = t != null && t.toString ? t.toString() : t;
        return i === $2t ? t : i;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, i = is.length) {
    return this.test({
      message: i,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(n) {
        return rs(n) || n.length === this.resolve(t);
      }
    });
  }
  min(t, i = is.min) {
    return this.test({
      message: i,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(n) {
        return rs(n) || n.length >= this.resolve(t);
      }
    });
  }
  max(t, i = is.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: i,
      params: {
        max: t
      },
      test(n) {
        return rs(n) || n.length <= this.resolve(t);
      }
    });
  }
  matches(t, i) {
    let n = !1, g, r;
    return i && (typeof i == "object" ? {
      excludeEmptyString: n = !1,
      message: g,
      name: r
    } = i : g = i), this.test({
      name: r || "matches",
      message: g || is.matches,
      params: {
        regex: t
      },
      test: (o) => rs(o) || o === "" && n || o.search(t) !== -1
    });
  }
  email(t = is.email) {
    return this.matches(O2t, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = is.url) {
    return this.matches(Q2t, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = is.uuid) {
    return this.matches(j2t, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = is.trim) {
    return this.transform((i) => i != null ? i.trim() : i).test({
      message: t,
      name: "trim",
      test: _2t
    });
  }
  lowercase(t = is.lowercase) {
    return this.transform((i) => rs(i) ? i : i.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (i) => rs(i) || i === i.toLowerCase()
    });
  }
  uppercase(t = is.uppercase) {
    return this.transform((i) => rs(i) ? i : i.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (i) => rs(i) || i === i.toUpperCase()
    });
  }
}
Us.prototype = Wie.prototype;
var q2t = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function evt(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], i = 0, n, g;
  if (g = q2t.exec(e)) {
    for (var r = 0, o; o = t[r]; ++r)
      g[o] = +g[o] || 0;
    g[2] = (+g[2] || 1) - 1, g[3] = +g[3] || 1, g[7] = g[7] ? String(g[7]).substr(0, 3) : 0, (g[8] === void 0 || g[8] === "") && (g[9] === void 0 || g[9] === "") ? n = +new Date(g[1], g[2], g[3], g[4], g[5], g[6], g[7]) : (g[8] !== "Z" && g[9] !== void 0 && (i = g[10] * 60 + g[11], g[9] === "+" && (i = 0 - i)), n = Date.UTC(g[1], g[2], g[3], g[4], g[5] + i, g[6], g[7]));
  } else
    n = Date.parse ? Date.parse(e) : NaN;
  return n;
}
let Sie = /* @__PURE__ */ new Date(""), tvt = (e) => Object.prototype.toString.call(e) === "[object Date]";
class Vie extends Qo {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = evt(t), isNaN(t) ? Sie : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return tvt(t) && !isNaN(t.getTime());
  }
  prepareParam(t, i) {
    let n;
    if (Hd.isRef(t))
      n = t;
    else {
      let g = this.cast(t);
      if (!this._typeCheck(g))
        throw new TypeError(`\`${i}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = g;
    }
    return n;
  }
  min(t, i = Mx.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: i,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(g) {
        return rs(g) || g >= this.resolve(n);
      }
    });
  }
  max(t, i = Mx.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: i,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(g) {
        return rs(g) || g <= this.resolve(n);
      }
    });
  }
}
Vie.INVALID_DATE = Sie;
Vie.prototype;
function ivt(e, t, i, n) {
  var g = -1, r = e == null ? 0 : e.length;
  for (n && r && (i = e[++g]); ++g < r; )
    i = t(i, e[g], g, e);
  return i;
}
var nvt = ivt;
function gvt(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var rvt = gvt, ovt = rvt, Ivt = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, lvt = ovt(Ivt), svt = lvt, avt = svt, cvt = xf, dvt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Cvt = "\\u0300-\\u036f", uvt = "\\ufe20-\\ufe2f", Avt = "\\u20d0-\\u20ff", bvt = Cvt + uvt + Avt, mvt = "[" + bvt + "]", hvt = RegExp(mvt, "g");
function pvt(e) {
  return e = cvt(e), e && e.replace(dvt, avt).replace(hvt, "");
}
var Bvt = pvt, Zvt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function fvt(e) {
  return e.match(Zvt) || [];
}
var Gvt = fvt, yvt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Wvt(e) {
  return yvt.test(e);
}
var Svt = Wvt, wie = "\\ud800-\\udfff", Vvt = "\\u0300-\\u036f", wvt = "\\ufe20-\\ufe2f", vvt = "\\u20d0-\\u20ff", Rvt = Vvt + wvt + vvt, vie = "\\u2700-\\u27bf", Rie = "a-z\\xdf-\\xf6\\xf8-\\xff", Xvt = "\\xac\\xb1\\xd7\\xf7", Hvt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", kvt = "\\u2000-\\u206f", Fvt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Xie = "A-Z\\xc0-\\xd6\\xd8-\\xde", Yvt = "\\ufe0e\\ufe0f", Hie = Xvt + Hvt + kvt + Fvt, kie = "['’]", jP = "[" + Hie + "]", xvt = "[" + Rvt + "]", Fie = "\\d+", Dvt = "[" + vie + "]", Yie = "[" + Rie + "]", xie = "[^" + wie + Hie + Fie + vie + Rie + Xie + "]", Jvt = "\\ud83c[\\udffb-\\udfff]", Kvt = "(?:" + xvt + "|" + Jvt + ")", Evt = "[^" + wie + "]", Die = "(?:\\ud83c[\\udde6-\\uddff]){2}", Jie = "[\\ud800-\\udbff][\\udc00-\\udfff]", om = "[" + Xie + "]", Nvt = "\\u200d", _P = "(?:" + Yie + "|" + xie + ")", Lvt = "(?:" + om + "|" + xie + ")", $P = "(?:" + kie + "(?:d|ll|m|re|s|t|ve))?", qP = "(?:" + kie + "(?:D|LL|M|RE|S|T|VE))?", Kie = Kvt + "?", Eie = "[" + Yvt + "]?", Tvt = "(?:" + Nvt + "(?:" + [Evt, Die, Jie].join("|") + ")" + Eie + Kie + ")*", Mvt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Uvt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Pvt = Eie + Kie + Tvt, zvt = "(?:" + [Dvt, Die, Jie].join("|") + ")" + Pvt, Ovt = RegExp([
  om + "?" + Yie + "+" + $P + "(?=" + [jP, om, "$"].join("|") + ")",
  Lvt + "+" + qP + "(?=" + [jP, om + _P, "$"].join("|") + ")",
  om + "?" + _P + "+" + $P,
  om + "+" + qP,
  Uvt,
  Mvt,
  Fie,
  zvt
].join("|"), "g");
function Qvt(e) {
  return e.match(Ovt) || [];
}
var jvt = Qvt, _vt = Gvt, $vt = Svt, qvt = xf, eRt = jvt;
function tRt(e, t, i) {
  return e = qvt(e), t = i ? void 0 : t, t === void 0 ? $vt(e) ? eRt(e) : _vt(e) : e.match(t) || [];
}
var iRt = tRt, nRt = nvt, gRt = Bvt, rRt = iRt, oRt = "['’]", IRt = RegExp(oRt, "g");
function lRt(e) {
  return function(t) {
    return nRt(rRt(gRt(t).replace(IRt, "")), e, "");
  };
}
var Nie = lRt, sRt = Nie, aRt = sRt(function(e, t, i) {
  return e + (i ? "_" : "") + t.toLowerCase();
}), cRt = aRt;
const ez = /* @__PURE__ */ Tr(cRt);
function dRt(e, t, i) {
  var n = -1, g = e.length;
  t < 0 && (t = -t > g ? 0 : g + t), i = i > g ? g : i, i < 0 && (i += g), g = t > i ? 0 : i - t >>> 0, t >>>= 0;
  for (var r = Array(g); ++n < g; )
    r[n] = e[n + t];
  return r;
}
var CRt = dRt, uRt = CRt;
function ARt(e, t, i) {
  var n = e.length;
  return i = i === void 0 ? n : i, !t && i >= n ? e : uRt(e, t, i);
}
var bRt = ARt, mRt = "\\ud800-\\udfff", hRt = "\\u0300-\\u036f", pRt = "\\ufe20-\\ufe2f", BRt = "\\u20d0-\\u20ff", ZRt = hRt + pRt + BRt, fRt = "\\ufe0e\\ufe0f", GRt = "\\u200d", yRt = RegExp("[" + GRt + mRt + ZRt + fRt + "]");
function WRt(e) {
  return yRt.test(e);
}
var Lie = WRt;
function SRt(e) {
  return e.split("");
}
var VRt = SRt, Tie = "\\ud800-\\udfff", wRt = "\\u0300-\\u036f", vRt = "\\ufe20-\\ufe2f", RRt = "\\u20d0-\\u20ff", XRt = wRt + vRt + RRt, HRt = "\\ufe0e\\ufe0f", kRt = "[" + Tie + "]", e5 = "[" + XRt + "]", t5 = "\\ud83c[\\udffb-\\udfff]", FRt = "(?:" + e5 + "|" + t5 + ")", Mie = "[^" + Tie + "]", Uie = "(?:\\ud83c[\\udde6-\\uddff]){2}", Pie = "[\\ud800-\\udbff][\\udc00-\\udfff]", YRt = "\\u200d", zie = FRt + "?", Oie = "[" + HRt + "]?", xRt = "(?:" + YRt + "(?:" + [Mie, Uie, Pie].join("|") + ")" + Oie + zie + ")*", DRt = Oie + zie + xRt, JRt = "(?:" + [Mie + e5 + "?", e5, Uie, Pie, kRt].join("|") + ")", KRt = RegExp(t5 + "(?=" + t5 + ")|" + JRt + DRt, "g");
function ERt(e) {
  return e.match(KRt) || [];
}
var NRt = ERt, LRt = VRt, TRt = Lie, MRt = NRt;
function URt(e) {
  return TRt(e) ? MRt(e) : LRt(e);
}
var PRt = URt, zRt = bRt, ORt = Lie, QRt = PRt, jRt = xf;
function _Rt(e) {
  return function(t) {
    t = jRt(t);
    var i = ORt(t) ? QRt(t) : void 0, n = i ? i[0] : t.charAt(0), g = i ? zRt(i, 1).join("") : t.slice(1);
    return n[e]() + g;
  };
}
var $Rt = _Rt, qRt = $Rt, eXt = qRt("toUpperCase"), tXt = eXt, iXt = xf, nXt = tXt;
function gXt(e) {
  return nXt(iXt(e).toLowerCase());
}
var rXt = gXt, oXt = rXt, IXt = Nie, lXt = IXt(function(e, t, i) {
  return t = t.toLowerCase(), e + (i ? oXt(t) : t);
}), sXt = lXt;
const aXt = /* @__PURE__ */ Tr(sXt);
var cXt = aie, dXt = Cie, CXt = fie;
function uXt(e, t) {
  var i = {};
  return t = CXt(t), dXt(e, function(n, g, r) {
    cXt(i, t(n, g, r), n);
  }), i;
}
var AXt = uXt;
const bXt = /* @__PURE__ */ Tr(AXt);
var PE = { exports: {} };
PE.exports = function(e) {
  return Qie(mXt(e), e);
};
PE.exports.array = Qie;
function Qie(e, t) {
  var i = e.length, n = new Array(i), g = {}, r = i, o = hXt(t), I = pXt(e);
  for (t.forEach(function(a) {
    if (!I.has(a[0]) || !I.has(a[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); r--; )
    g[r] || s(e[r], r, /* @__PURE__ */ new Set());
  return n;
  function s(a, d, C) {
    if (C.has(a)) {
      var u;
      try {
        u = ", node was:" + JSON.stringify(a);
      } catch {
        u = "";
      }
      throw new Error("Cyclic dependency" + u);
    }
    if (!I.has(a))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(a));
    if (!g[d]) {
      g[d] = !0;
      var A = o.get(a) || /* @__PURE__ */ new Set();
      if (A = Array.from(A), d = A.length) {
        C.add(a);
        do {
          var m = A[--d];
          s(m, I.get(m), C);
        } while (d);
        C.delete(a);
      }
      n[--i] = a;
    }
  }
}
function mXt(e) {
  for (var t = /* @__PURE__ */ new Set(), i = 0, n = e.length; i < n; i++) {
    var g = e[i];
    t.add(g[0]), t.add(g[1]);
  }
  return Array.from(t);
}
function hXt(e) {
  for (var t = /* @__PURE__ */ new Map(), i = 0, n = e.length; i < n; i++) {
    var g = e[i];
    t.has(g[0]) || t.set(g[0], /* @__PURE__ */ new Set()), t.has(g[1]) || t.set(g[1], /* @__PURE__ */ new Set()), t.get(g[0]).add(g[1]);
  }
  return t;
}
function pXt(e) {
  for (var t = /* @__PURE__ */ new Map(), i = 0, n = e.length; i < n; i++)
    t.set(e[i], i);
  return t;
}
var BXt = PE.exports;
const ZXt = /* @__PURE__ */ Tr(BXt);
function fXt(e, t = []) {
  let i = [], n = /* @__PURE__ */ new Set(), g = new Set(t.map(([o, I]) => `${o}-${I}`));
  function r(o, I) {
    let s = Q2.split(o)[0];
    n.add(s), g.has(`${I}-${s}`) || i.push([I, s]);
  }
  for (const o in e)
    if (NV(e, o)) {
      let I = e[o];
      n.add(o), Hd.isRef(I) && I.isSibling ? r(I.path, o) : lie(I) && "deps" in I && I.deps.forEach((s) => r(s, o));
    }
  return ZXt.array(Array.from(n), i).reverse();
}
function tz(e, t) {
  let i = 1 / 0;
  return e.some((n, g) => {
    var r;
    if (((r = t.path) == null ? void 0 : r.indexOf(n)) !== -1)
      return i = g, !0;
  }), i;
}
function jie(e) {
  return (t, i) => tz(e, t) - tz(e, i);
}
function Am() {
  return Am = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Am.apply(this, arguments);
}
let iz = (e) => Object.prototype.toString.call(e) === "[object Object]";
function GXt(e, t) {
  let i = Object.keys(e.fields);
  return Object.keys(t).filter((n) => i.indexOf(n) === -1);
}
const yXt = jie([]);
class _ie extends Qo {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = yXt, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(n) {
        if (typeof n == "string")
          try {
            n = JSON.parse(n);
          } catch {
            n = null;
          }
        return this.isType(n) ? n : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return iz(t) || typeof t == "function";
  }
  _cast(t, i = {}) {
    var n;
    let g = super._cast(t, i);
    if (g === void 0)
      return this.getDefault();
    if (!this._typeCheck(g))
      return g;
    let r = this.fields, o = (n = i.stripUnknown) != null ? n : this.spec.noUnknown, I = this._nodes.concat(Object.keys(g).filter((C) => this._nodes.indexOf(C) === -1)), s = {}, a = Am({}, i, {
      parent: s,
      __validating: i.__validating || !1
    }), d = !1;
    for (const C of I) {
      let u = r[C], A = NV(g, C);
      if (u) {
        let m, h = g[C];
        a.path = (i.path ? `${i.path}.` : "") + C, u = u.resolve({
          value: h,
          context: i.context,
          parent: s
        });
        let B = "spec" in u ? u.spec : void 0, f = B == null ? void 0 : B.strict;
        if (B != null && B.strip) {
          d = d || C in g;
          continue;
        }
        m = !i.__validating || !f ? (
          // TODO: use _cast, this is double resolving
          u.cast(g[C], a)
        ) : g[C], m !== void 0 && (s[C] = m);
      } else
        A && !o && (s[C] = g[C]);
      s[C] !== g[C] && (d = !0);
    }
    return d ? s : g;
  }
  _validate(t, i = {}, n) {
    let g = [], {
      sync: r,
      from: o = [],
      originalValue: I = t,
      abortEarly: s = this.spec.abortEarly,
      recursive: a = this.spec.recursive
    } = i;
    o = [{
      schema: this,
      value: I
    }, ...o], i.__validating = !0, i.originalValue = I, i.from = o, super._validate(t, i, (d, C) => {
      if (d) {
        if (!VI.isError(d) || s)
          return void n(d, C);
        g.push(d);
      }
      if (!a || !iz(C)) {
        n(g[0] || null, C);
        return;
      }
      I = I || C;
      let u = this._nodes.map((A) => (m, h) => {
        let B = A.indexOf(".") === -1 ? (i.path ? `${i.path}.` : "") + A : `${i.path || ""}["${A}"]`, f = this.fields[A];
        if (f && "validate" in f) {
          f.validate(C[A], Am({}, i, {
            // @ts-ignore
            path: B,
            from: o,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: C,
            originalValue: I[A]
          }), h);
          return;
        }
        h(null);
      });
      zx({
        sync: r,
        tests: u,
        value: C,
        errors: g,
        endEarly: s,
        sort: this._sortErrors,
        path: i.path
      }, n);
    });
  }
  clone(t) {
    const i = super.clone(t);
    return i.fields = Am({}, this.fields), i._nodes = this._nodes, i._excludedEdges = this._excludedEdges, i._sortErrors = this._sortErrors, i;
  }
  concat(t) {
    let i = super.concat(t), n = i.fields;
    for (let [g, r] of Object.entries(this.fields)) {
      const o = n[g];
      o === void 0 ? n[g] = r : o instanceof Qo && r instanceof Qo && (n[g] = r.concat(o));
    }
    return i.withMutation(() => i.shape(n, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((i) => {
      const n = this.fields[i];
      t[i] = "default" in n ? n.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, i = []) {
    let n = this.clone(), g = Object.assign(n.fields, t);
    return n.fields = g, n._sortErrors = jie(Object.keys(g)), i.length && (Array.isArray(i[0]) || (i = [i]), n._excludedEdges = [...n._excludedEdges, ...i]), n._nodes = fXt(g, n._excludedEdges), n;
  }
  pick(t) {
    const i = {};
    for (const n of t)
      this.fields[n] && (i[n] = this.fields[n]);
    return this.clone().withMutation((n) => (n.fields = {}, n.shape(i)));
  }
  omit(t) {
    const i = this.clone(), n = i.fields;
    i.fields = {};
    for (const g of t)
      delete n[g];
    return i.withMutation(() => i.shape(n));
  }
  from(t, i, n) {
    let g = Q2.getter(t, !0);
    return this.transform((r) => {
      if (r == null)
        return r;
      let o = r;
      return NV(r, t) && (o = Am({}, r), n || delete o[t], o[i] = g(r)), o;
    });
  }
  noUnknown(t = !0, i = Ux.noUnknown) {
    typeof t == "string" && (i = t, t = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: i,
      test(g) {
        if (g == null)
          return !0;
        const r = GXt(this.schema, g);
        return !t || r.length === 0 || this.createError({
          params: {
            unknown: r.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = t, n;
  }
  unknown(t = !0, i = Ux.noUnknown) {
    return this.noUnknown(!t, i);
  }
  transformKeys(t) {
    return this.transform((i) => i && bXt(i, (n, g) => t(g)));
  }
  camelCase() {
    return this.transformKeys(aXt);
  }
  snakeCase() {
    return this.transformKeys(ez);
  }
  constantCase() {
    return this.transformKeys((t) => ez(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = Gie(this.fields, (i) => i.describe()), t;
  }
}
function zE(e) {
  return new _ie(e);
}
zE.prototype = _ie.prototype;
const ql = {
  nameNumber: "Namen dürfen keine Zahlen enthalten",
  nameRequired: "Bitte geben Sie Ihren Namen ein",
  emailValid: "Bitte geben Sie eine korrekte E-Mail ein",
  emailRequired: "Bitte geben Sie Ihre E-Mail ein",
  addressRequired: "Bitte geben Sie Ihre Adresse ein",
  cityRequired: "Bitte geben Sie den Namen Ihrer Stadt ein",
  zipRequired: "Bitte geben Sie Ihre Postleitzahl an",
  zipError: "Eine Postleitzahl darf nur aus 4 oder 5 Ziffern bestehen",
  taxIDRequired: "Bitte geben Sie Ihre UST-ID ein",
  companyRequired: "Bitte geben Sie Ihren Firmennamen an",
  cityError: "Geben Sie bitte einen gültigen Städtenamen an",
  phoneError: "Bitte geben Sie eine gültige Telefonnummer ein"
}, $ie = {
  name: Us().matches(/^([^0-9]*)$/, ql.nameNumber).required(ql.nameRequired),
  email: Us().email(ql.emailValid).required(ql.emailRequired),
  address: Us().required(ql.addressRequired),
  city: Us().matches(/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/, ql.cityError).required(ql.cityRequired),
  zip: Us().required(ql.zipRequired),
  remark: Us(),
  taxID: Us().required(ql.taxIDRequired),
  company: Us().required(ql.companyRequired),
  phone: Us().matches(/^(\(?([\d \-)–+/(]+){6,}\)?([ .-–/]?)([\d]+)$)/g, ql.phoneError)
}, WXt = zE($ie), SXt = {
  privateData: {
    name: "",
    email: "",
    phone: "",
    address: "",
    remark: "",
    company: "",
    taxID: "",
    checkbox: !1,
    city: "",
    zip: ""
  },
  privateDataText: "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie."
}, qie = Vg({
  name: "order",
  initialState: SXt,
  reducers: {
    updatePrivateData: (e, t) => {
      e.privateData = t.payload;
    }
  }
}), {
  updatePrivateData: VXt
} = qie.actions, wXt = qie.reducer, vXt = (e) => (t, i) => {
  const n = L2(i());
  t(VXt({
    ...n,
    ...e
  }));
}, RXt = ({
  action: e,
  handleChange: t,
  errors: i,
  register: n,
  getHelperText: g,
  privateData: r
}) => {
  if (!e || !e.formular)
    return null;
  const {
    name: o,
    sendCustomerEmail: I,
    phone: s,
    address: a,
    remark: d,
    company: C,
    taxID: u,
    optionalFields: A
  } = e.formular, m = (B, f) => /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(Gc, { text: B }),
    h(f) && "*"
  ] }), h = (B) => !(A != null && A[B]);
  return /* @__PURE__ */ ge(Bt, { children: [
    o && /* @__PURE__ */ p($n, { "data-cy": "name", value: r.name, label: m("Name", "name"), debounced: !0, required: h("name"), autoFocus: !0, TextFieldProps: {
      error: h("name") && !!i.name,
      helperText: g("name"),
      sx: {
        marginBottom: 0.5
      },
      ...n("name")
    }, onChange: t("name"), name: "name" }),
    I && /* @__PURE__ */ p($n, { "data-cy": "email", value: r.email, label: m("E-Mail", "sendCustomerEmail"), debounced: !0, autoComplete: "email", required: h("sendCustomerEmail"), TextFieldProps: {
      error: h("sendCustomerEmail") && !!i.email,
      helperText: g("email"),
      sx: {
        marginBottom: 0.5
      },
      ...n("email")
    }, type: "email", name: "email", onChange: t("email") }),
    s && /* @__PURE__ */ p($n, { value: r.phone, "data-cy": "Telefon*", label: m("Telefon", "phone"), debounced: !0, required: h("phone"), TextFieldProps: {
      error: h("phone") && !!i.phone,
      helperText: g("phone"),
      sx: {
        marginBottom: 0.5
      },
      ...n("phone")
    }, onChange: t("phone"), name: "phone" }),
    a && /* @__PURE__ */ p($n, { value: r.address, "data-cy": "Straße", label: m("Straße und Hausnummer", "address"), debounced: !0, required: h("address"), TextFieldProps: {
      error: !!i.address,
      helperText: g("address"),
      sx: {
        marginBottom: 0.5
      },
      ...n("address")
    }, onChange: t("address"), name: "address" }),
    a && /* @__PURE__ */ p($n, { value: r.zip, "data-cy": "PLZ*", label: m("PLZ", "address"), debounced: !0, required: h("address"), TextFieldProps: {
      error: h("address") && !!i.zip,
      helperText: g("zip"),
      sx: {
        marginBottom: 0.5
      },
      ...n("zip")
    }, onChange: t("zip"), name: "zip" }),
    a && /* @__PURE__ */ p($n, { value: r.city, "data-cy": "Stadt*", label: m("Stadt", "address"), debounced: !0, required: h("address"), TextFieldProps: {
      error: h("address") && !!i.city,
      helperText: g("city"),
      sx: {
        marginBottom: 0.5
      },
      ...n("city")
    }, onChange: t("city"), name: "city" }),
    d && /* @__PURE__ */ p($n, { value: r.remark, "data-cy": "Bemerkung", label: m("Bemerkung", "remark"), debounced: !0, multiline: !0, required: h("remark"), TextFieldProps: {
      error: h("remark") && !!i.remark,
      helperText: g("remark"),
      sx: {
        marginBottom: 0.5
      },
      ...n("remark")
    }, onChange: t("remark"), name: "remark" }),
    C && /* @__PURE__ */ p($n, { value: r.company, "data-cy": "Firma*", label: m("Firma", "company"), debounced: !0, required: h("company"), TextFieldProps: {
      error: h("company") && !!i.company,
      helperText: g("company"),
      sx: {
        marginBottom: 0.5
      },
      ...n("company")
    }, onChange: t("company"), name: "company" }),
    u && /* @__PURE__ */ p($n, { value: r.taxID, "data-cy": "UST", label: m("UST-ID", "taxID"), debounced: !0, required: h("taxID"), TextFieldProps: {
      error: h("taxID") && !!i.taxID,
      helperText: g("taxID"),
      sx: {
        marginBottom: 0.5
      },
      ...n("taxID")
    }, onChange: t("taxID"), name: "taxID" })
  ] });
}, XXt = ki({
  app: {
    orderDialog: {
      contact: {
        fields: {
          root: !0
        }
      }
    }
  }
})(RXt), HXt = ({
  action: e
}) => {
  const t = zt(), i = _(L2), n = (I) => (s) => {
    t(vXt({
      [I]: s
    }));
  }, {
    register: g,
    formState: {
      errors: r
    }
  } = aBt({
    mode: "onBlur",
    resolver: CBt(WXt)
  });
  return /* @__PURE__ */ ge(fe, { component: "div", display: "flex", flexDirection: "column", className: "orderDialogPrivateData k3-form-container k3-contact-form", children: [
    /* @__PURE__ */ p(XXt, { action: e, handleChange: n, errors: r, register: g, getHelperText: (I) => {
      var s, a;
      return typeof ((s = r == null ? void 0 : r[I]) == null ? void 0 : s.message) == "string" ? /* @__PURE__ */ p(Gc, { text: (a = r == null ? void 0 : r[I]) == null ? void 0 : a.message }) : "";
    }, privateData: i }),
    /* @__PURE__ */ p(fe, { component: "div", display: "flex", sx: {
      alignItems: "center"
    }, children: /* @__PURE__ */ p(GK, { "data-cy": "privData", label: /* @__PURE__ */ p(DZt, { action: e }), checked: i.checkbox ?? !1, onChange: n("checkbox") }) })
  ] });
}, kXt = ({
  variable: e
}) => {
  const t = _(hJ(e.id)), {
    values: i,
    touchedInvalidOptionsIds: n
  } = Bf(e, t), g = g$(e), r = un(), [o, I] = At(void 0);
  return /* @__PURE__ */ ge(fe, { component: "div", sx: {
    width: "500px",
    display: "flex",
    float: "right",
    gap: "8px"
  }, children: [
    /* @__PURE__ */ p(Xl, { keys: ["Neues Produkt auswählen"], boxProps: {
      width: 0,
      height: 0,
      display: "inline"
    } }),
    /* @__PURE__ */ p(ZK, { addItemLabel: r("Neues Produkt auswählen", "Neues Produkt auswählen"), variable: e, onSelected: I, value: o, values: i, touchedInvalidOptionsIds: n }),
    /* @__PURE__ */ p(Si, { "data-cy": "addNewProduct", variant: "contained", disabled: !o, onClick: () => {
      o && (g(o), I(void 0));
    }, children: /* @__PURE__ */ p(Gc, { text: "Neues Produkt hinzufügen" }) })
  ] });
}, FXt = ({
  action: e,
  onClose: t
}) => {
  const i = kD();
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(U0t, { dense: !0, onClose: t, action: e }),
    i && /* @__PURE__ */ p(kXt, { variable: i })
  ] });
}, i5 = ({
  action: e,
  step: t,
  onClose: i,
  result: n
}) => /* @__PURE__ */ ge(Bt, { children: [
  t === "overview" && /* @__PURE__ */ p(FXt, { action: e, onClose: i }),
  t === "contact" && /* @__PURE__ */ p(HXt, { action: e }),
  t === "confirmation" && n && /* @__PURE__ */ p(V0t, { action: e, result: n })
] }), YXt = (e) => /* @__PURE__ */ p(xd, { className: "orderDialogContent", sx: {
  height: 615,
  zIndex: "tooltip"
}, children: /* @__PURE__ */ p(i5, { ...e }) }), LF = ["overview", "contact", "confirmation"], cg = class cg {
};
Bg(cg, "proceedDisabled", (t, i, n) => {
  const {
    checkbox: g,
    ...r
  } = i, o = !!(t != null && t.formular);
  return (!g || !cg.inputsVerify(t, r)) && n === "contact" && o;
}), Bg(cg, "stepTriggersSave", (t, i) => {
  const n = cg.availableSteps(t);
  return n.length - n.indexOf(i) === 2;
}), Bg(cg, "buttonBack", (t, i) => cg.availableSteps(t).indexOf(i) === 0 ? Ii.CANCEL : Ii.NAVBAR_BACK), Bg(cg, "dynamicSettingsKeyForFooter", () => [Ii.CANCEL, Ii.NAVBAR_BACK, Ii.NAVBAR_NEXT, Ii.CLOSE]), Bg(cg, "forwardButton", (t, i) => cg.stepTriggersSave(t, i) ? t == null ? void 0 : t.label : i === "confirmation" ? Ii.CLOSE : Ii.NAVBAR_NEXT), Bg(cg, "stepTitleKeys", [Ii.ORDER_DIALOG_OVERVIEW, Ii.ORDER_DIALOG_DATA, Ii.ORDER_DIALOG_CONFIRMATION]), Bg(cg, "titleKeyForStep", (t) => cg.stepTitleKeys[LF.indexOf(t)]), Bg(cg, "keysForStep", (t) => {
  switch (t) {
    case "overview":
      return [Ii.ORDER_DIALOG_OVERVIEW, Ii.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE, Ii.ORDER_DIALOG_OVERVIEW_STEP, Ii.ORDER_DIALOG_OVERVIEW_VARIABLE, Ii.ORDER_DIALOG_OVERVIEW_SELECTION, Ii.ORDER_DIALOG_OVERVIEW_TOTALPRICE, Ii.ORDER_DIALOG_OVERVIEW_PRICE, Ii.ORDER_DIALOG_OVERVIEW_PRICEINFO, "order_modal_priceDetails", "order_modal_pos", "order_modal_articleNo", "order_modal_article", "order_modal_articlePrice", "order_modal_articleAmount", "order_modal_articleCount", "order_modal_positionPrice"];
    case "contact":
      return [Ii.ORDER_DIALOG_DATA];
    case "confirmation":
      return [Ii.ORDER_DIALOG_CONFIRMATION];
    default:
      return [];
  }
}), Bg(cg, "availableSteps", (t) => LF.filter(cg.isStepAvailable(t))), Bg(cg, "handleStep", (t, i, n) => {
  const g = cg.availableSteps(t), r = LF.indexOf(i);
  return n === "add" ? g[r + 1] : g[r - 1];
}), Bg(cg, "isStepAvailable", (t) => (i) => {
  switch (i) {
    case "overview":
      return (t == null ? void 0 : t.overviewType) !== "noOverview";
    case "contact":
      return t == null ? void 0 : t.formular;
    default:
      return !0;
  }
}), Bg(cg, "customer", (t, i, n) => {
  var g, r, o, I, s, a, d, C, u, A;
  return t != null && t.formular ? {
    address: (g = t == null ? void 0 : t.formular) != null && g.address ? i.address : null,
    dataPrivacy: ((r = t == null ? void 0 : t.formular) == null ? void 0 : r.dataPrivacy) ?? n,
    name: (o = t == null ? void 0 : t.formular) != null && o.name ? i.name : null,
    email: (I = t == null ? void 0 : t.formular) != null && I.sendCustomerEmail ? i.email : null,
    phone: (s = t == null ? void 0 : t.formular) != null && s.phone ? i.phone : null,
    remark: (a = t == null ? void 0 : t.formular) != null && a.remark ? i.remark : null,
    company: (d = t == null ? void 0 : t.formular) != null && d.company ? i.company : null,
    taxID: (C = t == null ? void 0 : t.formular) != null && C.taxID ? i.taxID : null,
    checkboxAccepted: i.checkbox,
    city: (u = t == null ? void 0 : t.formular) != null && u.address ? i.city : null,
    zip: (A = t == null ? void 0 : t.formular) != null && A.address ? i.zip : null
  } : null;
}), // Helper
Bg(cg, "inputsVerify", (t, i) => {
  var o, I, s, a, d, C, u, A, m, h, B, f, G, y, W, V, w, v, H, x, N;
  const n = {
    name: ((o = t == null ? void 0 : t.formular) == null ? void 0 : o.name) && !((s = (I = t == null ? void 0 : t.formular) == null ? void 0 : I.optionalFields) != null && s.name),
    email: ((a = t == null ? void 0 : t.formular) == null ? void 0 : a.sendCustomerEmail) && !((C = (d = t == null ? void 0 : t.formular) == null ? void 0 : d.optionalFields) != null && C.sendCustomerEmail),
    address: ((u = t == null ? void 0 : t.formular) == null ? void 0 : u.address) && !((m = (A = t == null ? void 0 : t.formular) == null ? void 0 : A.optionalFields) != null && m.address),
    city: ((h = t == null ? void 0 : t.formular) == null ? void 0 : h.address) && !((f = (B = t == null ? void 0 : t.formular) == null ? void 0 : B.optionalFields) != null && f.address),
    zip: ((G = t == null ? void 0 : t.formular) == null ? void 0 : G.address) && !((W = (y = t == null ? void 0 : t.formular) == null ? void 0 : y.optionalFields) != null && W.address),
    taxID: ((V = t == null ? void 0 : t.formular) == null ? void 0 : V.taxID) && !((v = (w = t == null ? void 0 : t.formular) == null ? void 0 : w.optionalFields) != null && v.taxID),
    company: ((H = t == null ? void 0 : t.formular) == null ? void 0 : H.company) && !((N = (x = t == null ? void 0 : t.formular) == null ? void 0 : x.optionalFields) != null && N.company)
  }, g = uc.pick(
    $ie,
    // @ts-ignore
    Object.keys(n).filter((M) => n[M] === !0)
  );
  return zE(g).isValidSync(i);
});
let Dr = cg;
const ene = ({
  step: e,
  action: t,
  onSave: i,
  onClose: n,
  onStep: g
}) => {
  t != null && t.formular;
  const r = _(L2), {
    checkbox: o,
    ...I
  } = r, s = un(), a = () => {
    if (Dr.stepTriggersSave(t, e) && Dr.inputsVerify(t, I)) {
      i();
      return;
    }
    if (e === "confirmation") {
      n();
      return;
    }
    g("add");
  }, d = () => {
    Dr.availableSteps(t)[0] === e ? n() : g("sub");
  }, C = Dr.proceedDisabled(t, r, e), u = Dr.buttonBack(t, e), A = Dr.forwardButton(t, e);
  return /* @__PURE__ */ p(fe, { component: "div", px: 3, py: 2, className: "orderDialogFooter", children: /* @__PURE__ */ ge(Yu, { children: [
    e !== "confirmation" && /* @__PURE__ */ p(Si, { "data-cy": "orderDialogBack", className: "orderDialogBack k3-btn k3-secondary-btn k3-modal-btn k3-btn-cancel", variant: "outlined", onClick: d, sx: {
      minWidth: 118
    }, children: s(u) }),
    /* @__PURE__ */ p(Xl, { keys: Dr.dynamicSettingsKeyForFooter(), boxProps: {
      ml: 1
    }, display: "dialog" }),
    /* @__PURE__ */ p(Si, { "data-cy": "orderDialogForward", className: "orderDialogForward k3-btn k3-modal-btn k3-btn-confirm", variant: "contained", disabled: C, sx: {
      minWidth: 118
    }, onClick: a, children: /* @__PURE__ */ p(xm, { value: A }) })
  ] }) });
}, xXt = ({
  headlines: e,
  step: t
}) => /* @__PURE__ */ p(G0e, { activeStep: t, alternativeLabel: !1, children: e.map((i) => /* @__PURE__ */ p(_pe, { children: /* @__PURE__ */ p(OO, {}) }, i)) }), DXt = ({
  children: e
}) => /* @__PURE__ */ p(fe, { component: "div", position: "absolute", width: 0.8, sx: {
  left: "50%",
  transform: "translate(-50%, 32px)"
}, children: e }), JXt = (e) => /* @__PURE__ */ p(Ne, { variant: "h5", component: "div", children: e.title }), KXt = ki({
  app: {
    orderDialog: {
      headline: {
        root: !0
      }
    }
  }
})(JXt), tne = ({
  step: e,
  action: t,
  onClose: i
}) => {
  const [n, g] = EXt()(t, e);
  return /* @__PURE__ */ ge(Bt, { children: [
    t && /* @__PURE__ */ p(fe, { component: "div", className: "orderDialogStepperContainer", children: /* @__PURE__ */ p(DXt, { children: /* @__PURE__ */ p(xXt, { headlines: n, step: g }) }) }),
    /* @__PURE__ */ ge(Dd, { className: "orderDialogTitle", children: [
      /* @__PURE__ */ ge(fe, { component: "div", display: "flex", justifyContent: "space-between", alignItems: "center", width: 1, pt: 8, textAlign: "right", children: [
        /* @__PURE__ */ ge(fe, { component: "div", display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ p(KXt, { title: n[g], allHeadlines: n, step: g }),
          /* @__PURE__ */ p(Xl, { keys: Dr.keysForStep(e), boxProps: {
            ml: 1
          }, display: "dialog" })
        ] }),
        !!i && /* @__PURE__ */ p(mi, { "data-cy": "close", edge: "start", color: "inherit", onClick: i, "aria-label": "Close", size: "large", children: /* @__PURE__ */ p(yh, {}) })
      ] }),
      /* @__PURE__ */ ge(Ne, { variant: "body2", color: "GrayText", sx: {
        opacity: e === "contact" ? 1 : 0
      }, children: [
        "* ",
        /* @__PURE__ */ p(Gc, { text: "Pflichtfeld" })
      ] })
    ] })
  ] });
}, EXt = () => {
  const e = un();
  return ft((t, i) => {
    const n = Dr.availableSteps(t);
    return [n.map((g, r) => {
      const o = Dr.titleKeyForStep(g);
      return `${r + 1}. ${e(o)}`;
    }), n.indexOf(i)];
  }, [e]);
}, NXt = (e, t) => async (i, n) => {
  const g = n(), r = t || wj(g);
  if (!r || !e || e === "creating")
    return null;
  console.debug("Starting save");
  const o = Dr.customer(r, L2(g), Ote(g)), I = await i(uK("Configuration", r, o));
  return console.debug("Ending save"), i(xot()), I;
}, ine = (e, t, i) => {
  const n = zt(), g = _(zJ);
  et(() => {
    t && (async () => {
      const o = await n(NXt(g, i));
      o && e(o);
    })();
  }, [g, t]);
}, LXt = () => {
  const e = _(wj);
  return e ? /* @__PURE__ */ p(TXt, { action: e }) : null;
}, TXt = ({
  action: e
}) => {
  const [t, i] = At(void 0), [n, g] = At(Dr.availableSteps(e)[0]), r = zt();
  et(() => {
    const C = Dr.availableSteps(e);
    g(C[0]), C.length <= 1 && s();
  }, [e]);
  const [o, I] = At(!1);
  ine((C) => {
    I(!1), i(C), g("confirmation");
  }, o);
  const s = async () => {
    I(!0), r(sK());
  };
  return /* @__PURE__ */ p(UXt, { action: e, handleClose: () => {
    r(ba(null)), i(void 0);
  }, step: n, saveResult: t, handleSave: s, handleStep: (C) => {
    const u = Dr.handleStep(e, n, C);
    g(u);
  } });
}, MXt = ({
  action: e,
  handleClose: t,
  step: i,
  saveResult: n,
  handleSave: g,
  handleStep: r
}) => /* @__PURE__ */ ge(Yd, { className: "orderDialog", open: !!e, fullWidth: !0, maxWidth: "md", onClose: t, children: [
  /* @__PURE__ */ p(tne, { step: i, action: e, onClose: t }),
  /* @__PURE__ */ p(YXt, { step: i, action: e, result: n, onClose: t }),
  /* @__PURE__ */ p(ene, { step: i, action: e, onSave: g, onStep: r, onClose: t })
] }), UXt = ki({
  app: {
    orderDialog: {
      root: !0
    }
  }
})(MXt);
function PXt() {
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(FIt, {}),
    /* @__PURE__ */ p(O_, {}),
    /* @__PURE__ */ p(Nst, {}),
    /* @__PURE__ */ p(LXt, {}),
    /* @__PURE__ */ p(h0t, {}),
    /* @__PURE__ */ p(KIt, {})
  ] });
}
const zXt = ({
  onChange: e,
  value: t,
  hidePreview: i
}) => {
  const {
    t: n
  } = ii(), [g, r] = Se.useState(0), [o, I] = Se.useState(!pM(t)), s = qo(), a = (C, u) => r(u), d = (C) => {
    const u = C ? !pM(C) : !1;
    e(C || ""), I(u);
  };
  return i ? /* @__PURE__ */ ge(fe, { component: "div", sx: {
    // Errorborder if error
    border: `1px solid ${o ? s.palette.error.main : "#888888"}`
  }, children: [
    /* @__PURE__ */ p(MY, { wrapperProps: {
      "data-cy": "htmlEditorWrapper"
    }, height: "200px", theme: "light", defaultLanguage: "html", onChange: d, value: t, options: TY }),
    /* @__PURE__ */ ge(fe, { component: "div", sx: {
      minHeight: "25px"
    }, children: [
      " ",
      !!o && /* @__PURE__ */ p(hM, {})
    ] })
  ] }) : /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ ge(I1, { "data-cy": "htmlTabs", variant: "fullWidth", value: g, onChange: a, children: [
      /* @__PURE__ */ p(mc, { label: n("Bearbeiten"), "data-cy": "editHTML" }),
      /* @__PURE__ */ p(mc, { label: n("Vorschau"), "data-cy": "previewHTML" })
    ] }),
    g === 0 && /* @__PURE__ */ ge("div", { children: [
      /* @__PURE__ */ p(fe, { component: "div", sx: {
        // Errorborder if error
        border: `1px solid ${o ? s.palette.error.main : "#888888"}`
      }, children: /* @__PURE__ */ p(MY, { wrapperProps: {
        "data-cy": "htmlEditorWrapper"
      }, height: "200px", theme: "light", defaultLanguage: "html", onChange: d, value: t, options: TY }) }),
      /* @__PURE__ */ ge(fe, { component: "div", sx: {
        minHeight: "25px"
      }, children: [
        " ",
        !!o && /* @__PURE__ */ p(hM, {})
      ] })
    ] }),
    g === 1 && /* @__PURE__ */ p(fe, { component: "div", sx: {
      minHeight: "200px"
    }, children: /* @__PURE__ */ p(Rc, { htmlString: t, renderTarget: "preview" }) })
  ] });
}, H9t = ({
  params: e
}) => {
  const {
    t
  } = ii(), i = () => {
    e.api.setCellMode(e.id, e.field, "edit");
  }, n = () => {
    e.api.setCellMode(e.id, e.field, "view"), e.api.setEditCellValue({
      id: e.id,
      field: e.field,
      value: null
    });
  }, g = () => {
    e.api.setEditCellValue({
      id: e.id,
      field: e.field,
      value: {
        id: Og.SetPopup,
        title: void 0,
        body: void 0,
        invalid: !0
      }
    }), e.api.setCellMode(e.id, e.field, "edit");
  };
  return e.value ? /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ p(mi, { onClick: i, "data-cy": "edit", children: /* @__PURE__ */ p(S1, {}) }),
    /* @__PURE__ */ p(mi, { onClick: n, "data-cy": "remove", children: /* @__PURE__ */ p(LZ, {}) })
  ] }) : /* @__PURE__ */ p(fe, { component: "div", children: /* @__PURE__ */ p(Si, { onClick: g, "data-cy": "add", variant: "outlined", color: "primary", children: t("Meldung hinzufügen") }) });
}, k9t = ({
  params: e
}) => {
  var I, s;
  const {
    t
  } = ii(), i = _(ng), [n, g] = At(e.value !== null), [r, o] = At(!1);
  return r ? /* @__PURE__ */ p(nne, { open: r, onClose: () => o(!1), params: e.value }) : /* @__PURE__ */ ge(Yd, { open: n, onClose: () => g(!1), maxWidth: "md", fullWidth: !0, children: [
    /* @__PURE__ */ p(Dd, { children: /* @__PURE__ */ p($n, { fullWidth: !0, "data-cy": "popup-action-title", label: t("Titel"), value: Eu((I = e.value) == null ? void 0 : I.title, i), onChange: (a) => {
      var d;
      e.api.setEditCellValue({
        id: e.id,
        field: e.field,
        value: {
          id: Og.SetPopup,
          ...e.value,
          title: {
            ...(d = e.value) == null ? void 0 : d.title,
            [i]: a
          }
        }
      });
    } }) }),
    /* @__PURE__ */ ge(xd, { children: [
      /* @__PURE__ */ p(b7, { children: t("Inhalt") }),
      /* @__PURE__ */ p(zXt, { hidePreview: !0, value: Eu((s = e.value) == null ? void 0 : s.body, i), onChange: (a) => {
        var d;
        e.api.setEditCellValue({
          id: e.id,
          field: e.field,
          value: {
            id: Og.SetPopup,
            ...e.value,
            body: {
              ...(d = e.value) == null ? void 0 : d.body,
              [i]: a
            }
          }
        });
      } }),
      /* @__PURE__ */ p("br", {})
    ] }),
    /* @__PURE__ */ ge(Yu, { children: [
      /* @__PURE__ */ p(Si, { "data-cy": "open-preview", onClick: () => o(!0), children: t("Vorschau") }),
      /* @__PURE__ */ p(Si, { "data-cy": "close", onClick: () => g(!1), children: t("OK") })
    ] })
  ] });
}, nne = ({
  open: e,
  onClose: t,
  params: i
}) => {
  const n = _(ng);
  return /* @__PURE__ */ p(j1, { type: "error", show: e, onClose: t, title: Eu(i.title || {}, n), className: "k3-popup-action", children: /* @__PURE__ */ p(Cr, { children: /* @__PURE__ */ p(X$, { value: i.body || {} }) }) });
}, N0 = {
  root: {
    display: "grid",
    width: 1,
    height: 1,
    overflow: "hidden",
    gap: "0px 0px",
    gridAutoFlow: "row",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "1fr max-content"
  },
  layoutSidebarLeft: {
    gridTemplateAreas: `
          "Sidebar Preview"`
  },
  layoutSidebarRight: {
    gridTemplateAreas: `
          "Preview Sidebar"`
  },
  gridAreaPreview: {
    gridArea: "Preview"
  },
  gridAreaSidebar: {
    gridArea: "Sidebar",
    height: "100%",
    overflow: "hidden"
  }
}, OXt = ({
  sidebar: e,
  content: t,
  sidebarRight: i
}) => /* @__PURE__ */ ge(fe, { component: "div", sx: {
  ...N0.root,
  ...i ? N0.layoutSidebarRight : N0.layoutSidebarLeft
}, children: [
  /* @__PURE__ */ p(fe, { component: "div", sx: N0.gridAreaPreview, children: t }),
  /* @__PURE__ */ p(fe, { component: "div", sx: N0.gridAreaSidebar, children: e })
] }), _b = {
  root: {
    display: "grid",
    width: 1,
    height: 1,
    overflow: "hidden",
    gap: "0px 0px",
    gridAutoFlow: "row",
    gridTemplateRows: "min-content 1fr"
  },
  layoutSidebarRight: {
    gridTemplateColumns: "minmax(0, 1fr) max-content",
    gridTemplateAreas: `
          "AppBar AppBar"
          "Preview Sidebar"`
  },
  layoutSidebarLeft: {
    gridTemplateColumns: "max-content 1fr",
    gridTemplateAreas: `
          "AppBar AppBar"
          "Sidebar Preview"`
  },
  gridAreaAppBar: {
    gridArea: "AppBar"
  },
  gridAreaPreview: {
    gridArea: "Preview"
  },
  gridAreaSidebar: {
    zIndex: 1,
    gridArea: "Sidebar",
    overflow: "hidden",
    boxShadow: (e) => e.shadows[3]
  }
}, nz = ({
  header: e,
  sidebar: t,
  content: i,
  sidebarRight: n
}) => /* @__PURE__ */ ge(fe, { component: "div", sx: {
  ..._b.root,
  ...n ? _b.layoutSidebarRight : _b.layoutSidebarLeft
}, children: [
  e && /* @__PURE__ */ p(fe, { component: "div", sx: _b.gridAreaAppBar, children: e }),
  /* @__PURE__ */ p(fe, { component: "div", sx: _b.gridAreaPreview, children: i }),
  /* @__PURE__ */ p(fe, { component: "div", sx: _b.gridAreaSidebar, children: t })
] }), QXt = (e) => {
  const t = zt(), i = e.step || "navigate", n = _(Ai), g = mE(n, !0), r = je(() => g.find((A) => A.actionKey == e.actionKey), [g, e]), [o, I] = At("overview"), [s, a] = At(void 0), [d, C] = At(!1), u = () => {
    I("overview");
  };
  return ine((A) => {
    C(!1), a(A), I("confirmation");
  }, d, r), r ? i === "navigate" ? /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(tne, { step: o, action: r }),
    /* @__PURE__ */ p(i5, { action: r, step: o, result: s, onClose: u }),
    /* @__PURE__ */ p(ene, { step: o, action: r, onSave: async () => {
      C(!0), t(sK());
    }, onStep: (m) => {
      const h = Dr.handleStep(r, o, m);
      I(h);
    }, onClose: u })
  ] }) : /* @__PURE__ */ p(i5, { action: r, step: i, onClose: () => {
  } }) : null;
}, jXt = {
  branding: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    textAlign: "center"
  }
}, _Xt = ({
  extensionName: e,
  extensionVersion: t,
  customName: i,
  customVersion: n,
  customUrl: g
}) => {
  const r = _(mje), o = new URLSearchParams({
    utm_source: "k3-powered-by-link",
    utm_medium: "referral",
    utm_content: window.location.href
  }), I = g || "https://www.objectcode.de", s = (I.indexOf("?") == -1 ? "?" : "&") + o.toString();
  return r ? /* @__PURE__ */ p(fe, { component: "div", sx: jXt.branding, children: /* @__PURE__ */ p(as, { "data-cy": "brand", href: I + s, target: "_blank", children: /* @__PURE__ */ ge(Ne, { variant: "caption", display: "block", children: [
    "Powered by ",
    i || "ObjectCode K3®",
    " ",
    n || xge,
    e && t ? ` (${e} ${t})` : ""
  ] }) }) }) : null;
}, $Xt = ki({
  app: {
    branding: {
      root: !0
    }
  }
})(_Xt);
var OE = {}, qXt = Cg;
Object.defineProperty(OE, "__esModule", {
  value: !0
});
var gne = OE.default = void 0, eHt = qXt(Kg()), tHt = xg;
gne = OE.default = (0, eHt.default)(/* @__PURE__ */ (0, tHt.jsx)("path", {
  d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "Fullscreen");
var QE = {}, iHt = Cg;
Object.defineProperty(QE, "__esModule", {
  value: !0
});
var rne = QE.default = void 0, nHt = iHt(Kg()), gHt = xg;
rne = QE.default = (0, nHt.default)(/* @__PURE__ */ (0, gHt.jsx)("path", {
  d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), "FullscreenExit");
const rHt = (e, t) => {
  const i = ft((n) => {
    t.some((r) => n.key === r) && e({
      key: n.key,
      ctrl: n.ctrlKey
    });
  }, [e, t]);
  et(() => (document.addEventListener("keydown", i), () => {
    document.removeEventListener("keydown", i);
  }), [i]);
}, one = () => {
  const e = zt(), t = _(Yj), i = _(hr), n = un();
  return rHt(({
    key: r
  }) => {
    t && (r === "Escape" || r === " ") && e(d3());
  }, ["Escape", " "]), /* @__PURE__ */ ge(_t, { direction: "row", children: [
    /* @__PURE__ */ p(r$, { "data-cy": "fullscreenButton", onClick: () => {
      e(d3());
    }, className: "fullscreenButton k3-btn k3-mode-button", variant: "contained", fullWidth: !0, startIcon: t ? /* @__PURE__ */ p(rne, {}) : /* @__PURE__ */ p(gne, {}), children: n(Ii.FULLSCREEN_BUTTON) }),
    !!i && /* @__PURE__ */ p(Xl, { keys: [Ii.FULLSCREEN_BUTTON] })
  ] });
};
var Ine = {}, j2 = {}, jE = {}, TF = {}, gz;
function oHt() {
  return gz || (gz = 1, function(e) {
    (function(t, i) {
      i(e, Se, hw);
    })(Zn, function(t, i, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.setHasSupportToCaptureOption = m;
      var g = o(i), r = o(n);
      function o(G) {
        return G && G.__esModule ? G : {
          default: G
        };
      }
      var I = Object.assign || function(G) {
        for (var y = 1; y < arguments.length; y++) {
          var W = arguments[y];
          for (var V in W)
            Object.prototype.hasOwnProperty.call(W, V) && (G[V] = W[V]);
        }
        return G;
      };
      function s(G, y) {
        var W = {};
        for (var V in G)
          y.indexOf(V) >= 0 || Object.prototype.hasOwnProperty.call(G, V) && (W[V] = G[V]);
        return W;
      }
      function a(G, y) {
        if (!(G instanceof y))
          throw new TypeError("Cannot call a class as a function");
      }
      var d = /* @__PURE__ */ function() {
        function G(y, W) {
          for (var V = 0; V < W.length; V++) {
            var w = W[V];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(y, w.key, w);
          }
        }
        return function(y, W, V) {
          return W && G(y.prototype, W), V && G(y, V), y;
        };
      }();
      function C(G, y) {
        if (!G)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return y && (typeof y == "object" || typeof y == "function") ? y : G;
      }
      function u(G, y) {
        if (typeof y != "function" && y !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof y);
        G.prototype = Object.create(y && y.prototype, {
          constructor: {
            value: G,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(G, y) : G.__proto__ = y);
      }
      var A = !1;
      function m(G) {
        A = G;
      }
      try {
        addEventListener("test", null, Object.defineProperty({}, "capture", { get: function() {
          m(!0);
        } }));
      } catch {
      }
      function h() {
        var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { capture: !0 };
        return A ? G : G.capture;
      }
      function B(G) {
        if ("touches" in G) {
          var y = G.touches[0], W = y.pageX, V = y.pageY;
          return { x: W, y: V };
        }
        var w = G.screenX, v = G.screenY;
        return { x: w, y: v };
      }
      var f = function(G) {
        u(y, G);
        function y() {
          var W;
          a(this, y);
          for (var V = arguments.length, w = Array(V), v = 0; v < V; v++)
            w[v] = arguments[v];
          var H = C(this, (W = y.__proto__ || Object.getPrototypeOf(y)).call.apply(W, [this].concat(w)));
          return H._handleSwipeStart = H._handleSwipeStart.bind(H), H._handleSwipeMove = H._handleSwipeMove.bind(H), H._handleSwipeEnd = H._handleSwipeEnd.bind(H), H._onMouseDown = H._onMouseDown.bind(H), H._onMouseMove = H._onMouseMove.bind(H), H._onMouseUp = H._onMouseUp.bind(H), H._setSwiperRef = H._setSwiperRef.bind(H), H;
        }
        return d(y, [{
          key: "componentDidMount",
          value: function() {
            this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, h({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, h({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "_onMouseDown",
          value: function(V) {
            this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(V));
          }
        }, {
          key: "_onMouseMove",
          value: function(V) {
            this.mouseDown && this._handleSwipeMove(V);
          }
        }, {
          key: "_onMouseUp",
          value: function(V) {
            this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(V);
          }
        }, {
          key: "_handleSwipeStart",
          value: function(V) {
            var w = B(V), v = w.x, H = w.y;
            this.moveStart = { x: v, y: H }, this.props.onSwipeStart(V);
          }
        }, {
          key: "_handleSwipeMove",
          value: function(V) {
            if (this.moveStart) {
              var w = B(V), v = w.x, H = w.y, x = v - this.moveStart.x, N = H - this.moveStart.y;
              this.moving = !0;
              var M = this.props.onSwipeMove({
                x,
                y: N
              }, V);
              M && V.cancelable && V.preventDefault(), this.movePosition = { deltaX: x, deltaY: N };
            }
          }
        }, {
          key: "_handleSwipeEnd",
          value: function(V) {
            this.props.onSwipeEnd(V);
            var w = this.props.tolerance;
            this.moving && this.movePosition && (this.movePosition.deltaX < -w ? this.props.onSwipeLeft(1, V) : this.movePosition.deltaX > w && this.props.onSwipeRight(1, V), this.movePosition.deltaY < -w ? this.props.onSwipeUp(1, V) : this.movePosition.deltaY > w && this.props.onSwipeDown(1, V)), this.moveStart = null, this.moving = !1, this.movePosition = null;
          }
        }, {
          key: "_setSwiperRef",
          value: function(V) {
            this.swiper = V, this.props.innerRef(V);
          }
        }, {
          key: "render",
          value: function() {
            var V = this.props;
            V.tagName;
            var w = V.className, v = V.style, H = V.children;
            V.allowMouseEvents, V.onSwipeUp, V.onSwipeDown, V.onSwipeLeft, V.onSwipeRight, V.onSwipeStart, V.onSwipeMove, V.onSwipeEnd, V.innerRef, V.tolerance;
            var x = s(V, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]);
            return g.default.createElement(
              this.props.tagName,
              I({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: w,
                style: v
              }, x),
              H
            );
          }
        }]), y;
      }(i.Component);
      f.displayName = "ReactSwipe", f.propTypes = {
        tagName: r.default.string,
        className: r.default.string,
        style: r.default.object,
        children: r.default.node,
        allowMouseEvents: r.default.bool,
        onSwipeUp: r.default.func,
        onSwipeDown: r.default.func,
        onSwipeLeft: r.default.func,
        onSwipeRight: r.default.func,
        onSwipeStart: r.default.func,
        onSwipeMove: r.default.func,
        onSwipeEnd: r.default.func,
        innerRef: r.default.func,
        tolerance: r.default.number.isRequired
      }, f.defaultProps = {
        tagName: "div",
        allowMouseEvents: !1,
        onSwipeUp: function() {
        },
        onSwipeDown: function() {
        },
        onSwipeLeft: function() {
        },
        onSwipeRight: function() {
        },
        onSwipeStart: function() {
        },
        onSwipeMove: function() {
        },
        onSwipeEnd: function() {
        },
        innerRef: function() {
        },
        tolerance: 0
      }, t.default = f;
    });
  }(TF)), TF;
}
(function(e) {
  (function(t, i) {
    i(e, oHt());
  })(Zn, function(t, i) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = g(i);
    function g(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    t.default = n.default;
  });
})(jE);
var Df = {}, lne = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function i() {
      for (var r = "", o = 0; o < arguments.length; o++) {
        var I = arguments[o];
        I && (r = g(r, n(I)));
      }
      return r;
    }
    function n(r) {
      if (typeof r == "string" || typeof r == "number")
        return r;
      if (typeof r != "object")
        return "";
      if (Array.isArray(r))
        return i.apply(null, r);
      if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
        return r.toString();
      var o = "";
      for (var I in r)
        t.call(r, I) && r[I] && (o = g(o, I));
      return o;
    }
    function g(r, o) {
      return o ? r ? r + " " + o : r + o : r;
    }
    e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
  })();
})(lne);
var IHt = lne.exports;
Object.defineProperty(Df, "__esModule", {
  value: !0
});
Df.default = void 0;
var ud = lHt(IHt);
function lHt(e) {
  return e && e.__esModule ? e : { default: e };
}
function sHt(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var aHt = {
  ROOT: function(t) {
    return (0, ud.default)(sHt({
      "carousel-root": !0
    }, t || "", !!t));
  },
  CAROUSEL: function(t) {
    return (0, ud.default)({
      carousel: !0,
      "carousel-slider": t
    });
  },
  WRAPPER: function(t, i) {
    return (0, ud.default)({
      "thumbs-wrapper": !t,
      "slider-wrapper": t,
      "axis-horizontal": i === "horizontal",
      "axis-vertical": i !== "horizontal"
    });
  },
  SLIDER: function(t, i) {
    return (0, ud.default)({
      thumbs: !t,
      slider: t,
      animated: !i
    });
  },
  ITEM: function(t, i, n) {
    return (0, ud.default)({
      thumb: !t,
      slide: t,
      selected: i,
      previous: n
    });
  },
  ARROW_PREV: function(t) {
    return (0, ud.default)({
      "control-arrow control-prev": !0,
      "control-disabled": t
    });
  },
  ARROW_NEXT: function(t) {
    return (0, ud.default)({
      "control-arrow control-next": !0,
      "control-disabled": t
    });
  },
  DOT: function(t) {
    return (0, ud.default)({
      dot: !0,
      selected: t
    });
  }
};
Df.default = aHt;
var Jf = {}, _2 = {};
Object.defineProperty(_2, "__esModule", {
  value: !0
});
_2.outerWidth = void 0;
var cHt = function(t) {
  var i = t.offsetWidth, n = getComputedStyle(t);
  return i += parseInt(n.marginLeft) + parseInt(n.marginRight), i;
};
_2.outerWidth = cHt;
var Rh = {};
Object.defineProperty(Rh, "__esModule", {
  value: !0
});
Rh.default = void 0;
var dHt = function(t, i, n) {
  var g = t === 0 ? t : t + i, r = n === "horizontal" ? [g, 0, 0] : [0, g, 0], o = "translate3d", I = "(" + r.join(",") + ")";
  return o + I;
};
Rh.default = dHt;
var Kf = {};
Object.defineProperty(Kf, "__esModule", {
  value: !0
});
Kf.default = void 0;
var CHt = function() {
  return window;
};
Kf.default = CHt;
Object.defineProperty(Jf, "__esModule", {
  value: !0
});
Jf.default = void 0;
var es = bHt(Se), Iu = $2(Df), uHt = _2, rz = $2(Rh), AHt = $2(jE), QW = $2(Kf);
function $2(e) {
  return e && e.__esModule ? e : { default: e };
}
function sne() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return sne = function() {
    return e;
  }, e;
}
function bHt(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || HB(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = sne();
  if (t && t.has(e))
    return t.get(e);
  var i = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var g in e)
    if (Object.prototype.hasOwnProperty.call(e, g)) {
      var r = n ? Object.getOwnPropertyDescriptor(e, g) : null;
      r && (r.get || r.set) ? Object.defineProperty(i, g, r) : i[g] = e[g];
    }
  return i.default = e, t && t.set(e, i), i;
}
function HB(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? HB = function(i) {
    return typeof i;
  } : HB = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, HB(e);
}
function n5() {
  return n5 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, n5.apply(this, arguments);
}
function mHt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hHt(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function pHt(e, t, i) {
  return t && hHt(e.prototype, t), e;
}
function BHt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && g5(e, t);
}
function g5(e, t) {
  return g5 = Object.setPrototypeOf || function(n, g) {
    return n.__proto__ = g, n;
  }, g5(e, t);
}
function ZHt(e) {
  var t = GHt();
  return function() {
    var n = zV(e), g;
    if (t) {
      var r = zV(this).constructor;
      g = Reflect.construct(n, arguments, r);
    } else
      g = n.apply(this, arguments);
    return fHt(this, g);
  };
}
function fHt(e, t) {
  return t && (HB(t) === "object" || typeof t == "function") ? t : uo(e);
}
function uo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function GHt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zV(e) {
  return zV = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, zV(e);
}
function Qr(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var yHt = function(t) {
  return t.hasOwnProperty("key");
}, _E = /* @__PURE__ */ function(e) {
  BHt(i, e);
  var t = ZHt(i);
  function i(n) {
    var g;
    return mHt(this, i), g = t.call(this, n), Qr(uo(g), "itemsWrapperRef", void 0), Qr(uo(g), "itemsListRef", void 0), Qr(uo(g), "thumbsRef", void 0), Qr(uo(g), "setItemsWrapperRef", function(r) {
      g.itemsWrapperRef = r;
    }), Qr(uo(g), "setItemsListRef", function(r) {
      g.itemsListRef = r;
    }), Qr(uo(g), "setThumbsRef", function(r, o) {
      g.thumbsRef || (g.thumbsRef = []), g.thumbsRef[o] = r;
    }), Qr(uo(g), "updateSizes", function() {
      if (!(!g.props.children || !g.itemsWrapperRef || !g.thumbsRef)) {
        var r = es.Children.count(g.props.children), o = g.itemsWrapperRef.clientWidth, I = g.props.thumbWidth ? g.props.thumbWidth : (0, uHt.outerWidth)(g.thumbsRef[0]), s = Math.floor(o / I), a = s < r, d = a ? r - s : 0;
        g.setState(function(C, u) {
          return {
            itemSize: I,
            visibleItems: s,
            firstItem: a ? g.getFirstItem(u.selectedItem) : 0,
            lastPosition: d,
            showArrows: a
          };
        });
      }
    }), Qr(uo(g), "handleClickItem", function(r, o, I) {
      if (!yHt(I) || I.key === "Enter") {
        var s = g.props.onSelectItem;
        typeof s == "function" && s(r, o);
      }
    }), Qr(uo(g), "onSwipeStart", function() {
      g.setState({
        swiping: !0
      });
    }), Qr(uo(g), "onSwipeEnd", function() {
      g.setState({
        swiping: !1
      });
    }), Qr(uo(g), "onSwipeMove", function(r) {
      var o = r.x;
      if (!g.state.itemSize || !g.itemsWrapperRef || !g.state.visibleItems)
        return !1;
      var I = 0, s = es.Children.count(g.props.children), a = -(g.state.firstItem * 100) / g.state.visibleItems, d = Math.max(s - g.state.visibleItems, 0), C = -d * 100 / g.state.visibleItems;
      a === I && o > 0 && (o = 0), a === C && o < 0 && (o = 0);
      var u = g.itemsWrapperRef.clientWidth, A = a + 100 / (u / o);
      return g.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(m) {
        g.itemsListRef.style[m] = (0, rz.default)(A, "%", g.props.axis);
      }), !0;
    }), Qr(uo(g), "slideRight", function(r) {
      g.moveTo(g.state.firstItem - (typeof r == "number" ? r : 1));
    }), Qr(uo(g), "slideLeft", function(r) {
      g.moveTo(g.state.firstItem + (typeof r == "number" ? r : 1));
    }), Qr(uo(g), "moveTo", function(r) {
      r = r < 0 ? 0 : r, r = r >= g.state.lastPosition ? g.state.lastPosition : r, g.setState({
        firstItem: r
      });
    }), g.state = {
      selectedItem: n.selectedItem,
      swiping: !1,
      showArrows: !1,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    }, g;
  }
  return pHt(i, [{
    key: "componentDidMount",
    value: function() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function(g) {
      this.props.selectedItem !== this.state.selectedItem && this.setState({
        selectedItem: this.props.selectedItem,
        firstItem: this.getFirstItem(this.props.selectedItem)
      }), this.props.children !== g.children && this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function() {
      (0, QW.default)().addEventListener("resize", this.updateSizes), (0, QW.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function() {
      (0, QW.default)().removeEventListener("resize", this.updateSizes), (0, QW.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function(g) {
      var r = g;
      return g >= this.state.lastPosition && (r = this.state.lastPosition), g < this.state.firstItem + this.state.visibleItems && (r = this.state.firstItem), g < this.state.firstItem && (r = g), r;
    }
  }, {
    key: "renderItems",
    value: function() {
      var g = this;
      return this.props.children.map(function(r, o) {
        var I = Iu.default.ITEM(!1, o === g.state.selectedItem), s = {
          key: o,
          ref: function(d) {
            return g.setThumbsRef(d, o);
          },
          className: I,
          onClick: g.handleClickItem.bind(g, o, g.props.children[o]),
          onKeyDown: g.handleClickItem.bind(g, o, g.props.children[o]),
          "aria-label": "".concat(g.props.labels.item, " ").concat(o + 1),
          style: {
            width: g.props.thumbWidth
          }
        };
        return /* @__PURE__ */ es.default.createElement("li", n5({}, s, {
          role: "button",
          tabIndex: 0
        }), r);
      });
    }
  }, {
    key: "render",
    value: function() {
      var g = this;
      if (!this.props.children)
        return null;
      var r = es.Children.count(this.props.children) > 1, o = this.state.showArrows && this.state.firstItem > 0, I = this.state.showArrows && this.state.firstItem < this.state.lastPosition, s = {}, a = -this.state.firstItem * (this.state.itemSize || 0), d = (0, rz.default)(a, "px", this.props.axis), C = this.props.transitionTime + "ms";
      return s = {
        WebkitTransform: d,
        MozTransform: d,
        MsTransform: d,
        OTransform: d,
        transform: d,
        msTransform: d,
        WebkitTransitionDuration: C,
        MozTransitionDuration: C,
        MsTransitionDuration: C,
        OTransitionDuration: C,
        transitionDuration: C,
        msTransitionDuration: C
      }, /* @__PURE__ */ es.default.createElement("div", {
        className: Iu.default.CAROUSEL(!1)
      }, /* @__PURE__ */ es.default.createElement("div", {
        className: Iu.default.WRAPPER(!1),
        ref: this.setItemsWrapperRef
      }, /* @__PURE__ */ es.default.createElement("button", {
        type: "button",
        className: Iu.default.ARROW_PREV(!o),
        onClick: function() {
          return g.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), r ? /* @__PURE__ */ es.default.createElement(AHt.default, {
        tagName: "ul",
        className: Iu.default.SLIDER(!1, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: s,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /* @__PURE__ */ es.default.createElement("ul", {
        className: Iu.default.SLIDER(!1, this.state.swiping),
        ref: function(A) {
          return g.setItemsListRef(A);
        },
        style: s
      }, this.renderItems()), /* @__PURE__ */ es.default.createElement("button", {
        type: "button",
        className: Iu.default.ARROW_NEXT(!I),
        onClick: function() {
          return g.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]), i;
}(es.Component);
Jf.default = _E;
Qr(_E, "displayName", "Thumbs");
Qr(_E, "defaultProps", {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var q2 = {};
Object.defineProperty(q2, "__esModule", {
  value: !0
});
q2.default = void 0;
var WHt = function() {
  return document;
};
q2.default = WHt;
var fI = {};
Object.defineProperty(fI, "__esModule", {
  value: !0
});
fI.setPosition = fI.getPosition = fI.isKeyboardEvent = fI.defaultStatusFormatter = fI.noop = void 0;
var SHt = Se, VHt = wHt(Rh);
function wHt(e) {
  return e && e.__esModule ? e : { default: e };
}
var vHt = function() {
};
fI.noop = vHt;
var RHt = function(t, i) {
  return "".concat(t, " of ").concat(i);
};
fI.defaultStatusFormatter = RHt;
var XHt = function(t) {
  return t ? t.hasOwnProperty("key") : !1;
};
fI.isKeyboardEvent = XHt;
var HHt = function(t, i) {
  if (i.infiniteLoop && ++t, t === 0)
    return 0;
  var n = SHt.Children.count(i.children);
  if (i.centerMode && i.axis === "horizontal") {
    var g = -t * i.centerSlidePercentage, r = n - 1;
    return t && (t !== r || i.infiniteLoop) ? g += (100 - i.centerSlidePercentage) / 2 : t === r && (g += 100 - i.centerSlidePercentage), g;
  }
  return -t * 100;
};
fI.getPosition = HHt;
var kHt = function(t, i) {
  var n = {};
  return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(g) {
    n[g] = (0, VHt.default)(t, "%", i);
  }), n;
};
fI.setPosition = kHt;
var ta = {};
Object.defineProperty(ta, "__esModule", {
  value: !0
});
ta.fadeAnimationHandler = ta.slideStopSwipingHandler = ta.slideSwipeAnimationHandler = ta.slideAnimationHandler = void 0;
var ane = Se, FHt = YHt(Rh), ia = fI;
function YHt(e) {
  return e && e.__esModule ? e : { default: e };
}
function oz(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function pu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oz(Object(i), !0).forEach(function(n) {
      xHt(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : oz(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function xHt(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var DHt = function(t, i) {
  var n = {}, g = i.selectedItem, r = g, o = ane.Children.count(t.children) - 1, I = t.infiniteLoop && (g < 0 || g > o);
  if (I)
    return r < 0 ? t.centerMode && t.centerSlidePercentage && t.axis === "horizontal" ? n.itemListStyle = (0, ia.setPosition)(-(o + 2) * t.centerSlidePercentage - (100 - t.centerSlidePercentage) / 2, t.axis) : n.itemListStyle = (0, ia.setPosition)(-(o + 2) * 100, t.axis) : r > o && (n.itemListStyle = (0, ia.setPosition)(0, t.axis)), n;
  var s = (0, ia.getPosition)(g, t), a = (0, FHt.default)(s, "%", t.axis), d = t.transitionTime + "ms";
  return n.itemListStyle = {
    WebkitTransform: a,
    msTransform: a,
    OTransform: a,
    transform: a
  }, i.swiping || (n.itemListStyle = pu(pu({}, n.itemListStyle), {}, {
    WebkitTransitionDuration: d,
    MozTransitionDuration: d,
    OTransitionDuration: d,
    transitionDuration: d,
    msTransitionDuration: d
  })), n;
};
ta.slideAnimationHandler = DHt;
var JHt = function(t, i, n, g) {
  var r = {}, o = i.axis === "horizontal", I = ane.Children.count(i.children), s = 0, a = (0, ia.getPosition)(n.selectedItem, i), d = i.infiniteLoop ? (0, ia.getPosition)(I - 1, i) - 100 : (0, ia.getPosition)(I - 1, i), C = o ? t.x : t.y, u = C;
  a === s && C > 0 && (u = 0), a === d && C < 0 && (u = 0);
  var A = a + 100 / (n.itemSize / u), m = Math.abs(C) > i.swipeScrollTolerance;
  return i.infiniteLoop && m && (n.selectedItem === 0 && A > -100 ? A -= I * 100 : n.selectedItem === I - 1 && A < -I * 100 && (A += I * 100)), (!i.preventMovementUntilSwipeScrollTolerance || m || n.swipeMovementStarted) && (n.swipeMovementStarted || g({
    swipeMovementStarted: !0
  }), r.itemListStyle = (0, ia.setPosition)(A, i.axis)), m && !n.cancelClick && g({
    cancelClick: !0
  }), r;
};
ta.slideSwipeAnimationHandler = JHt;
var KHt = function(t, i) {
  var n = (0, ia.getPosition)(i.selectedItem, t), g = (0, ia.setPosition)(n, t.axis);
  return {
    itemListStyle: g
  };
};
ta.slideStopSwipingHandler = KHt;
var EHt = function(t, i) {
  var n = t.transitionTime + "ms", g = "ease-in-out", r = {
    position: "absolute",
    display: "block",
    zIndex: -2,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: g,
    msTransitionTimingFunction: g,
    MozTransitionTimingFunction: g,
    WebkitTransitionTimingFunction: g,
    OTransitionTimingFunction: g
  };
  return i.swiping || (r = pu(pu({}, r), {}, {
    WebkitTransitionDuration: n,
    MozTransitionDuration: n,
    OTransitionDuration: n,
    transitionDuration: n,
    msTransitionDuration: n
  })), {
    slideStyle: r,
    selectedStyle: pu(pu({}, r), {}, {
      opacity: 1,
      position: "relative"
    }),
    prevStyle: pu({}, r)
  };
};
ta.fadeAnimationHandler = EHt;
Object.defineProperty(j2, "__esModule", {
  value: !0
});
j2.default = void 0;
var pn = THt(Se), NHt = Ef(jE), ac = Ef(Df), LHt = Ef(Jf), jW = Ef(q2), _W = Ef(Kf), oB = fI, OV = ta;
function Ef(e) {
  return e && e.__esModule ? e : { default: e };
}
function cne() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return cne = function() {
    return e;
  }, e;
}
function THt(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || kB(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = cne();
  if (t && t.has(e))
    return t.get(e);
  var i = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var g in e)
    if (Object.prototype.hasOwnProperty.call(e, g)) {
      var r = n ? Object.getOwnPropertyDescriptor(e, g) : null;
      r && (r.get || r.set) ? Object.defineProperty(i, g, r) : i[g] = e[g];
    }
  return i.default = e, t && t.set(e, i), i;
}
function kB(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? kB = function(i) {
    return typeof i;
  } : kB = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, kB(e);
}
function r5() {
  return r5 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, r5.apply(this, arguments);
}
function Iz(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function ts(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Iz(Object(i), !0).forEach(function(n) {
      Ri(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Iz(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function MHt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function UHt(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function PHt(e, t, i) {
  return t && UHt(e.prototype, t), e;
}
function zHt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && o5(e, t);
}
function o5(e, t) {
  return o5 = Object.setPrototypeOf || function(n, g) {
    return n.__proto__ = g, n;
  }, o5(e, t);
}
function OHt(e) {
  var t = jHt();
  return function() {
    var n = QV(e), g;
    if (t) {
      var r = QV(this).constructor;
      g = Reflect.construct(n, arguments, r);
    } else
      g = n.apply(this, arguments);
    return QHt(this, g);
  };
}
function QHt(e, t) {
  return t && (kB(t) === "object" || typeof t == "function") ? t : Hi(e);
}
function Hi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jHt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function QV(e) {
  return QV = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, QV(e);
}
function Ri(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var $E = /* @__PURE__ */ function(e) {
  zHt(i, e);
  var t = OHt(i);
  function i(n) {
    var g;
    MHt(this, i), g = t.call(this, n), Ri(Hi(g), "thumbsRef", void 0), Ri(Hi(g), "carouselWrapperRef", void 0), Ri(Hi(g), "listRef", void 0), Ri(Hi(g), "itemsRef", void 0), Ri(Hi(g), "timer", void 0), Ri(Hi(g), "animationHandler", void 0), Ri(Hi(g), "setThumbsRef", function(o) {
      g.thumbsRef = o;
    }), Ri(Hi(g), "setCarouselWrapperRef", function(o) {
      g.carouselWrapperRef = o;
    }), Ri(Hi(g), "setListRef", function(o) {
      g.listRef = o;
    }), Ri(Hi(g), "setItemsRef", function(o, I) {
      g.itemsRef || (g.itemsRef = []), g.itemsRef[I] = o;
    }), Ri(Hi(g), "autoPlay", function() {
      pn.Children.count(g.props.children) <= 1 || (g.clearAutoPlay(), g.props.autoPlay && (g.timer = setTimeout(function() {
        g.increment();
      }, g.props.interval)));
    }), Ri(Hi(g), "clearAutoPlay", function() {
      g.timer && clearTimeout(g.timer);
    }), Ri(Hi(g), "resetAutoPlay", function() {
      g.clearAutoPlay(), g.autoPlay();
    }), Ri(Hi(g), "stopOnHover", function() {
      g.setState({
        isMouseEntered: !0
      }, g.clearAutoPlay);
    }), Ri(Hi(g), "startOnLeave", function() {
      g.setState({
        isMouseEntered: !1
      }, g.autoPlay);
    }), Ri(Hi(g), "isFocusWithinTheCarousel", function() {
      return g.carouselWrapperRef ? !!((0, jW.default)().activeElement === g.carouselWrapperRef || g.carouselWrapperRef.contains((0, jW.default)().activeElement)) : !1;
    }), Ri(Hi(g), "navigateWithKeyboard", function(o) {
      if (g.isFocusWithinTheCarousel()) {
        var I = g.props.axis, s = I === "horizontal", a = {
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          ArrowLeft: 37
        }, d = s ? a.ArrowRight : a.ArrowDown, C = s ? a.ArrowLeft : a.ArrowUp;
        d === o.keyCode ? g.increment() : C === o.keyCode && g.decrement();
      }
    }), Ri(Hi(g), "updateSizes", function() {
      if (!(!g.state.initialized || !g.itemsRef || g.itemsRef.length === 0)) {
        var o = g.props.axis === "horizontal", I = g.itemsRef[0];
        if (I) {
          var s = o ? I.clientWidth : I.clientHeight;
          g.setState({
            itemSize: s
          }), g.thumbsRef && g.thumbsRef.updateSizes();
        }
      }
    }), Ri(Hi(g), "setMountState", function() {
      g.setState({
        hasMount: !0
      }), g.updateSizes();
    }), Ri(Hi(g), "handleClickItem", function(o, I) {
      if (pn.Children.count(g.props.children) !== 0) {
        if (g.state.cancelClick) {
          g.setState({
            cancelClick: !1
          });
          return;
        }
        g.props.onClickItem(o, I), o !== g.state.selectedItem && g.setState({
          selectedItem: o
        });
      }
    }), Ri(Hi(g), "handleOnChange", function(o, I) {
      pn.Children.count(g.props.children) <= 1 || g.props.onChange(o, I);
    }), Ri(Hi(g), "handleClickThumb", function(o, I) {
      g.props.onClickThumb(o, I), g.moveTo(o);
    }), Ri(Hi(g), "onSwipeStart", function(o) {
      g.setState({
        swiping: !0
      }), g.props.onSwipeStart(o);
    }), Ri(Hi(g), "onSwipeEnd", function(o) {
      g.setState({
        swiping: !1,
        cancelClick: !1,
        swipeMovementStarted: !1
      }), g.props.onSwipeEnd(o), g.clearAutoPlay(), g.state.autoPlay && g.autoPlay();
    }), Ri(Hi(g), "onSwipeMove", function(o, I) {
      g.props.onSwipeMove(I);
      var s = g.props.swipeAnimationHandler(o, g.props, g.state, g.setState.bind(Hi(g)));
      return g.setState(ts({}, s)), !!Object.keys(s).length;
    }), Ri(Hi(g), "decrement", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      g.moveTo(g.state.selectedItem - (typeof o == "number" ? o : 1));
    }), Ri(Hi(g), "increment", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      g.moveTo(g.state.selectedItem + (typeof o == "number" ? o : 1));
    }), Ri(Hi(g), "moveTo", function(o) {
      if (typeof o == "number") {
        var I = pn.Children.count(g.props.children) - 1;
        o < 0 && (o = g.props.infiniteLoop ? I : 0), o > I && (o = g.props.infiniteLoop ? 0 : I), g.selectItem({
          // if it's not a slider, we don't need to set position here
          selectedItem: o
        }), g.state.autoPlay && g.state.isMouseEntered === !1 && g.resetAutoPlay();
      }
    }), Ri(Hi(g), "onClickNext", function() {
      g.increment(1);
    }), Ri(Hi(g), "onClickPrev", function() {
      g.decrement(1);
    }), Ri(Hi(g), "onSwipeForward", function() {
      g.increment(1), g.props.emulateTouch && g.setState({
        cancelClick: !0
      });
    }), Ri(Hi(g), "onSwipeBackwards", function() {
      g.decrement(1), g.props.emulateTouch && g.setState({
        cancelClick: !0
      });
    }), Ri(Hi(g), "changeItem", function(o) {
      return function(I) {
        (!(0, oB.isKeyboardEvent)(I) || I.key === "Enter") && g.moveTo(o);
      };
    }), Ri(Hi(g), "selectItem", function(o) {
      g.setState(ts({
        previousItem: g.state.selectedItem
      }, o), function() {
        g.setState(g.animationHandler(g.props, g.state));
      }), g.handleOnChange(o.selectedItem, pn.Children.toArray(g.props.children)[o.selectedItem]);
    }), Ri(Hi(g), "getInitialImage", function() {
      var o = g.props.selectedItem, I = g.itemsRef && g.itemsRef[o], s = I && I.getElementsByTagName("img") || [];
      return s[0];
    }), Ri(Hi(g), "getVariableItemHeight", function(o) {
      var I = g.itemsRef && g.itemsRef[o];
      if (g.state.hasMount && I && I.children.length) {
        var s = I.children[0].getElementsByTagName("img") || [];
        if (s.length > 0) {
          var a = s[0];
          if (!a.complete) {
            var d = function A() {
              g.forceUpdate(), a.removeEventListener("load", A);
            };
            a.addEventListener("load", d);
          }
        }
        var C = s[0] || I.children[0], u = C.clientHeight;
        return u > 0 ? u : null;
      }
      return null;
    });
    var r = {
      initialized: !1,
      previousItem: n.selectedItem,
      selectedItem: n.selectedItem,
      hasMount: !1,
      isMouseEntered: !1,
      autoPlay: n.autoPlay,
      swiping: !1,
      swipeMovementStarted: !1,
      cancelClick: !1,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    return g.animationHandler = typeof n.animationHandler == "function" && n.animationHandler || n.animationHandler === "fade" && OV.fadeAnimationHandler || OV.slideAnimationHandler, g.state = ts(ts({}, r), g.animationHandler(n, r)), g;
  }
  return PHt(i, [{
    key: "componentDidMount",
    value: function() {
      this.props.children && this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function(g, r) {
      !g.children && this.props.children && !this.state.initialized && this.setupCarousel(), !g.autoFocus && this.props.autoFocus && this.forceFocus(), r.swiping && !this.state.swiping && this.setState(ts({}, this.props.stopSwipingHandler(this.props, this.state))), (g.selectedItem !== this.props.selectedItem || g.centerMode !== this.props.centerMode) && (this.updateSizes(), this.moveTo(this.props.selectedItem)), g.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
        autoPlay: this.props.autoPlay
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function() {
      var g = this;
      this.bindEvents(), this.state.autoPlay && pn.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
        initialized: !0
      }, function() {
        var r = g.getInitialImage();
        r && !r.complete ? r.addEventListener("load", g.setMountState) : g.setMountState();
      });
    }
  }, {
    key: "destroyCarousel",
    value: function() {
      this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
    }
  }, {
    key: "setupAutoPlay",
    value: function() {
      this.autoPlay();
      var g = this.carouselWrapperRef;
      this.props.stopOnHover && g && (g.addEventListener("mouseenter", this.stopOnHover), g.addEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "destroyAutoPlay",
    value: function() {
      this.clearAutoPlay();
      var g = this.carouselWrapperRef;
      this.props.stopOnHover && g && (g.removeEventListener("mouseenter", this.stopOnHover), g.removeEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "bindEvents",
    value: function() {
      (0, _W.default)().addEventListener("resize", this.updateSizes), (0, _W.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, jW.default)().addEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "unbindEvents",
    value: function() {
      (0, _W.default)().removeEventListener("resize", this.updateSizes), (0, _W.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      var g = this.getInitialImage();
      g && g.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, jW.default)().removeEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "forceFocus",
    value: function() {
      var g;
      (g = this.carouselWrapperRef) === null || g === void 0 || g.focus();
    }
  }, {
    key: "renderItems",
    value: function(g) {
      var r = this;
      return this.props.children ? pn.Children.map(this.props.children, function(o, I) {
        var s = I === r.state.selectedItem, a = I === r.state.previousItem, d = s && r.state.selectedStyle || a && r.state.prevStyle || r.state.slideStyle || {};
        r.props.centerMode && r.props.axis === "horizontal" && (d = ts(ts({}, d), {}, {
          minWidth: r.props.centerSlidePercentage + "%"
        })), r.state.swiping && r.state.swipeMovementStarted && (d = ts(ts({}, d), {}, {
          pointerEvents: "none"
        }));
        var C = {
          ref: function(A) {
            return r.setItemsRef(A, I);
          },
          key: "itemKey" + I + (g ? "clone" : ""),
          className: ac.default.ITEM(!0, I === r.state.selectedItem, I === r.state.previousItem),
          onClick: r.handleClickItem.bind(r, I, o),
          style: d
        };
        return /* @__PURE__ */ pn.default.createElement("li", C, r.props.renderItem(o, {
          isSelected: I === r.state.selectedItem,
          isPrevious: I === r.state.previousItem
        }));
      }) : [];
    }
  }, {
    key: "renderControls",
    value: function() {
      var g = this, r = this.props, o = r.showIndicators, I = r.labels, s = r.renderIndicator, a = r.children;
      return o ? /* @__PURE__ */ pn.default.createElement("ul", {
        className: "control-dots"
      }, pn.Children.map(a, function(d, C) {
        return s && s(g.changeItem(C), C === g.state.selectedItem, C, I.item);
      })) : null;
    }
  }, {
    key: "renderStatus",
    value: function() {
      return this.props.showStatus ? /* @__PURE__ */ pn.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, pn.Children.count(this.props.children))) : null;
    }
  }, {
    key: "renderThumbs",
    value: function() {
      return !this.props.showThumbs || !this.props.children || pn.Children.count(this.props.children) === 0 ? null : /* @__PURE__ */ pn.default.createElement(LHt.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var g = this;
      if (!this.props.children || pn.Children.count(this.props.children) === 0)
        return null;
      var r = this.props.swipeable && pn.Children.count(this.props.children) > 1, o = this.props.axis === "horizontal", I = this.props.showArrows && pn.Children.count(this.props.children) > 1, s = I && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1, a = I && (this.state.selectedItem < pn.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1, d = this.renderItems(!0), C = d.shift(), u = d.pop(), A = {
        className: ac.default.SLIDER(!0, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      }, m = {};
      if (o) {
        if (A.onSwipeLeft = this.onSwipeForward, A.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
          var h = this.getVariableItemHeight(this.state.selectedItem);
          m.height = h || "auto";
        }
      } else
        A.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward, A.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards, A.style = ts(ts({}, A.style), {}, {
          height: this.state.itemSize
        }), m.height = this.state.itemSize;
      return /* @__PURE__ */ pn.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: ac.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : void 0
      }, /* @__PURE__ */ pn.default.createElement("div", {
        className: ac.default.CAROUSEL(!0),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, s, this.props.labels.leftArrow), /* @__PURE__ */ pn.default.createElement("div", {
        className: ac.default.WRAPPER(!0, this.props.axis),
        style: m
      }, r ? /* @__PURE__ */ pn.default.createElement(NHt.default, r5({
        tagName: "ul",
        innerRef: this.setListRef
      }, A, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && u, this.renderItems(), this.props.infiniteLoop && C) : /* @__PURE__ */ pn.default.createElement("ul", {
        className: ac.default.SLIDER(!0, this.state.swiping),
        ref: function(f) {
          return g.setListRef(f);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && u, this.renderItems(), this.props.infiniteLoop && C)), this.props.renderArrowNext(this.onClickNext, a, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]), i;
}(pn.default.Component);
j2.default = $E;
Ri($E, "displayName", "Carousel");
Ri($E, "defaultProps", {
  ariaLabel: void 0,
  axis: "horizontal",
  centerSlidePercentage: 80,
  interval: 3e3,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onClickItem: oB.noop,
  onClickThumb: oB.noop,
  onChange: oB.noop,
  onSwipeStart: function() {
  },
  onSwipeEnd: function() {
  },
  onSwipeMove: function() {
    return !1;
  },
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: function(t, i, n) {
    return /* @__PURE__ */ pn.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: ac.default.ARROW_PREV(!i),
      onClick: t
    });
  },
  renderArrowNext: function(t, i, n) {
    return /* @__PURE__ */ pn.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: ac.default.ARROW_NEXT(!i),
      onClick: t
    });
  },
  renderIndicator: function(t, i, n, g) {
    return /* @__PURE__ */ pn.default.createElement("li", {
      className: ac.default.DOT(i),
      onClick: t,
      onKeyDown: t,
      value: n,
      key: n,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(g, " ").concat(n + 1)
    });
  },
  renderItem: function(t) {
    return t;
  },
  renderThumbs: function(t) {
    var i = pn.Children.map(t, function(n) {
      var g = n;
      if (n.type !== "img" && (g = pn.Children.toArray(n.props.children).find(function(r) {
        return r.type === "img";
      })), !!g)
        return g;
    });
    return i.filter(function(n) {
      return n;
    }).length === 0 ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : i;
  },
  statusFormatter: oB.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !0,
  showThumbs: !0,
  stopOnHover: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 350,
  verticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  swipeAnimationHandler: OV.slideSwipeAnimationHandler,
  stopSwipingHandler: OV.slideStopSwipingHandler
});
var _Ht = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Carousel", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "CarouselProps", {
    enumerable: !0,
    get: function() {
      return i.CarouselProps;
    }
  }), Object.defineProperty(e, "Thumbs", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  });
  var t = g(j2), i = _Ht, n = g(Jf);
  function g(r) {
    return r && r.__esModule ? r : { default: r };
  }
})(Ine);
function I5(e, t, i) {
  var n, g, r, o, I;
  t == null && (t = 100);
  function s() {
    var d = Date.now() - o;
    d < t && d >= 0 ? n = setTimeout(s, t - d) : (n = null, i || (I = e.apply(r, g), r = g = null));
  }
  var a = function() {
    r = this, g = arguments, o = Date.now();
    var d = i && !n;
    return n || (n = setTimeout(s, t)), d && (I = e.apply(r, g), r = g = null), I;
  };
  return a.clear = function() {
    n && (clearTimeout(n), n = null);
  }, a.flush = function() {
    n && (I = e.apply(r, g), r = g = null, clearTimeout(n), n = null);
  }, a;
}
I5.debounce = I5;
var $Ht = I5;
const lz = /* @__PURE__ */ Tr($Ht);
function qHt(e) {
  let {
    debounce: t,
    scroll: i,
    polyfill: n,
    offsetSize: g
  } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
  };
  const r = n || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!r)
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [o, I] = At({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  }), s = Ct({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: o
  }), a = t ? typeof t == "number" ? t : t.scroll : null, d = t ? typeof t == "number" ? t : t.resize : null, C = Ct(!1);
  et(() => (C.current = !0, () => void (C.current = !1)));
  const [u, A, m] = je(() => {
    const G = () => {
      if (!s.current.element)
        return;
      const {
        left: y,
        top: W,
        width: V,
        height: w,
        bottom: v,
        right: H,
        x,
        y: N
      } = s.current.element.getBoundingClientRect(), M = {
        left: y,
        top: W,
        width: V,
        height: w,
        bottom: v,
        right: H,
        x,
        y: N
      };
      s.current.element instanceof HTMLElement && g && (M.height = s.current.element.offsetHeight, M.width = s.current.element.offsetWidth), Object.freeze(M), C.current && !nkt(s.current.lastBounds, M) && I(s.current.lastBounds = M);
    };
    return [G, d ? lz(G, d) : G, a ? lz(G, a) : G];
  }, [I, g, a, d]);
  function h() {
    s.current.scrollContainers && (s.current.scrollContainers.forEach((G) => G.removeEventListener("scroll", m, !0)), s.current.scrollContainers = null), s.current.resizeObserver && (s.current.resizeObserver.disconnect(), s.current.resizeObserver = null);
  }
  function B() {
    s.current.element && (s.current.resizeObserver = new r(m), s.current.resizeObserver.observe(s.current.element), i && s.current.scrollContainers && s.current.scrollContainers.forEach((G) => G.addEventListener("scroll", m, {
      capture: !0,
      passive: !0
    })));
  }
  const f = (G) => {
    !G || G === s.current.element || (h(), s.current.element = G, s.current.scrollContainers = dne(G), B());
  };
  return tkt(m, !!i), ekt(A), et(() => {
    h(), B();
  }, [i, m, A]), et(() => h, []), [f, o, u];
}
function ekt(e) {
  et(() => {
    const t = e;
    return window.addEventListener("resize", t), () => void window.removeEventListener("resize", t);
  }, [e]);
}
function tkt(e, t) {
  et(() => {
    if (t) {
      const i = e;
      return window.addEventListener("scroll", i, {
        capture: !0,
        passive: !0
      }), () => void window.removeEventListener("scroll", i, !0);
    }
  }, [e, t]);
}
function dne(e) {
  const t = [];
  if (!e || e === document.body)
    return t;
  const {
    overflow: i,
    overflowX: n,
    overflowY: g
  } = window.getComputedStyle(e);
  return [i, n, g].some((r) => r === "auto" || r === "scroll") && t.push(e), [...t, ...dne(e.parentElement)];
}
const ikt = ["x", "y", "top", "bottom", "left", "right", "width", "height"], nkt = (e, t) => ikt.every((i) => e[i] === t[i]);
sY.__MUI_LICENSE_INFO__ = sY.__MUI_LICENSE_INFO__ || {
  key: void 0
};
class jV {
  static getLicenseInfo() {
    return sY.__MUI_LICENSE_INFO__;
  }
  static getLicenseKey() {
    return jV.getLicenseInfo().key;
  }
  static setLicenseKey(t) {
    const i = jV.getLicenseInfo();
    i.key = t;
  }
}
const gkt = {
  components: {
    MuiBreadcrumbs: {
      defaultProps: {
        expandText: "Pfad anzeigen"
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (e) => e === "first" ? "Zur ersten Seite" : e === "last" ? "Zur letzten Seite" : e === "next" ? "Zur nächsten Seite" : "Zur vorherigen Seite",
        labelRowsPerPage: "Zeilen pro Seite:",
        labelDisplayedRows: ({
          from: e,
          to: t,
          count: i
        }) => `${e}–${t} von ${i !== -1 ? i : `mehr als ${t}`}`
      }
    },
    MuiRating: {
      defaultProps: {
        getLabelText: (e) => `${e} ${e !== 1 ? "Sterne" : "Stern"}`,
        emptyLabelText: "Keine Wertung"
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        clearText: "Leeren",
        closeText: "Schließen",
        loadingText: "Wird geladen…",
        noOptionsText: "Keine Optionen",
        openText: "Öffnen"
      }
    },
    MuiAlert: {
      defaultProps: {
        closeText: "Schließen"
      }
    },
    MuiPagination: {
      defaultProps: {
        "aria-label": "Navigation via Seitennummerierung",
        getItemAriaLabel: (e, t, i) => e === "page" ? `${i ? "" : "Gehe zu "}Seite ${t}` : e === "first" ? "Zur ersten Seite" : e === "last" ? "Zur letzten Seite" : e === "next" ? "Zur nächsten Seite" : "Zur vorherigen Seite"
      }
    }
  }
}, Y9t = {
  /*
  components: {
    MuiBreadcrumbs: { defaultProps: {
      expandText: 'Show path',
    }},
    MuiTablePagination: { defaultProps: {
      getItemAriaLabel: (type) => {
        if (type === 'first') {
          return 'Go to first page';
        }
        if (type === 'last') {
          return 'Go to last page';
        }
        if (type === 'next') {
          return 'Go to next page';
        }
        // if (type === 'previous') {
        return 'Go to previous page';
      },
      labelRowsPerPage: 'Rows per page:',
      labelDisplayedRows: ({ from, to, count }) =>
  `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
    }},
    MuiRating: { defaultProps: {
      getLabelText: value => `${value} Star${value !== 1 ? 's' : ''}`,
      emptyLabelText: 'Empty',
    }},
    MuiAutocomplete: { defaultProps: {
      clearText: 'Clear',
      closeText: 'Close',
      loadingText: 'Loading…',
      noOptionsText: 'No options',
      openText: 'Open',
    }},
    MuiAlert: { defaultProps: {
      closeText: 'Close',
    }},
    MuiPagination: {  defaultProps: {
      'aria-label': 'Pagination navigation',
      getItemAriaLabel: (type, page, selected) => {
        if (type === 'page') {
          return `${selected ? '' : 'Go to '}page ${page}`;
        }
        if (type === 'first') {
          return 'Go to first page';
        }
        if (type === 'last') {
          return 'Go to last page';
        }
        if (type === 'next') {
          return 'Go to next page';
        }
        // if (type === 'previous') {
        return 'Go to previous page';
      },
    }},
  },
  */
}, rkt = (e, t) => {
  var i, n;
  return {
    components: {
      MuiDataGrid: {
        defaultProps: {
          localeText: k({}, e, {
            MuiTablePagination: (t == null || (i = t.components) == null || (n = i.MuiTablePagination) == null ? void 0 : n.defaultProps) || {}
          })
        }
      }
    }
  };
}, okt = {
  // Root
  noRowsLabel: "Keine Einträge",
  noResultsOverlayLabel: "Keine Ergebnisse gefunden.",
  errorOverlayDefaultLabel: "Ein unerwarteter Fehler ist aufgetreten.",
  // Density selector toolbar button text
  toolbarDensity: "Zeilenhöhe",
  toolbarDensityLabel: "Zeilenhöhe",
  toolbarDensityCompact: "Kompakt",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Breit",
  // Columns selector toolbar button text
  toolbarColumns: "Spalten",
  toolbarColumnsLabel: "Zeige Spaltenauswahl",
  // Filters toolbar button text
  toolbarFilters: "Filter",
  toolbarFiltersLabel: "Zeige Filter",
  toolbarFiltersTooltipHide: "Verberge Filter",
  toolbarFiltersTooltipShow: "Zeige Filter",
  toolbarFiltersTooltipActive: (e) => e !== 1 ? `${e} aktive Filter` : `${e} aktiver Filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Suchen…",
  toolbarQuickFilterLabel: "Suchen",
  toolbarQuickFilterDeleteIconLabel: "Löschen",
  // Export selector toolbar button text
  toolbarExport: "Exportieren",
  toolbarExportLabel: "Exportieren",
  toolbarExportCSV: "Download als CSV",
  toolbarExportPrint: "Drucken",
  toolbarExportExcel: "Download als Excel",
  // Columns panel text
  columnsPanelTextFieldLabel: "Finde Spalte",
  columnsPanelTextFieldPlaceholder: "Spaltenüberschrift",
  columnsPanelDragIconLabel: "Spalte umsortieren",
  columnsPanelShowAllButton: "Zeige alle",
  columnsPanelHideAllButton: "Verberge alle",
  // Filter panel text
  filterPanelAddFilter: "Filter hinzufügen",
  filterPanelDeleteIconLabel: "Löschen",
  filterPanelLinkOperator: "Logische Operatoren",
  filterPanelOperators: "Operatoren",
  // TODO v6: rename to filterPanelOperator
  filterPanelOperatorAnd: "Und",
  filterPanelOperatorOr: "Oder",
  filterPanelColumns: "Spalten",
  filterPanelInputLabel: "Wert",
  filterPanelInputPlaceholder: "Wert filtern",
  // Filter operators text
  filterOperatorContains: "enthält",
  filterOperatorEquals: "ist gleich",
  filterOperatorStartsWith: "beginnt mit",
  filterOperatorEndsWith: "endet mit",
  filterOperatorIs: "ist",
  filterOperatorNot: "ist nicht",
  filterOperatorAfter: "ist nach",
  filterOperatorOnOrAfter: "ist am oder nach",
  filterOperatorBefore: "ist vor",
  filterOperatorOnOrBefore: "ist am oder vor",
  filterOperatorIsEmpty: "ist leer",
  filterOperatorIsNotEmpty: "ist nicht leer",
  filterOperatorIsAnyOf: "ist einer der Werte",
  // Filter values text
  filterValueAny: "Beliebig",
  filterValueTrue: "Ja",
  filterValueFalse: "Nein",
  // Column menu text
  columnMenuLabel: "Menü",
  columnMenuShowColumns: "Zeige alle Spalten",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Verbergen",
  columnMenuUnsort: "Sortierung deaktivieren",
  columnMenuSortAsc: "Sortiere aufsteigend",
  columnMenuSortDesc: "Sortiere absteigend",
  // Column header text
  columnHeaderFiltersTooltipActive: (e) => e !== 1 ? `${e} aktive Filter` : `${e} aktiver Filter`,
  columnHeaderFiltersLabel: "Zeige Filter",
  columnHeaderSortIconLabel: "Sortieren",
  // Rows selected footer text
  footerRowSelected: (e) => e !== 1 ? `${e.toLocaleString()} Einträge ausgewählt` : `${e.toLocaleString()} Eintrag ausgewählt`,
  // Total row amount footer text
  footerTotalRows: "Gesamt:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (e, t) => `${e.toLocaleString()} von ${t.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox Auswahl",
  checkboxSelectionSelectAllRows: "Alle Zeilen auswählen",
  checkboxSelectionUnselectAllRows: "Alle Zeilen abwählen",
  checkboxSelectionSelectRow: "Zeile auswählen",
  checkboxSelectionUnselectRow: "Zeile abwählen",
  // Boolean cell text
  booleanCellTrueLabel: "Ja",
  booleanCellFalseLabel: "Nein",
  // Actions cell more text
  actionsCellMore: "Mehr",
  // Column pinning text
  pinToLeft: "Links anheften",
  pinToRight: "Rechts anheften",
  unpin: "Loslösen",
  // Tree Data
  treeDataGroupingHeaderName: "Gruppe",
  treeDataExpand: "Kinder einblenden",
  treeDataCollapse: "Kinder ausblenden",
  // Grouping columns
  groupingColumnHeaderName: "Gruppierung",
  groupColumn: (e) => `Gruppieren nach ${e}`,
  unGroupColumn: (e) => `Gruppierung nach ${e} aufheben`,
  // Master/detail
  detailPanelToggle: "Detailansicht Kippschalter",
  expandDetailPanel: "Aufklappen",
  collapseDetailPanel: "Zuklappen",
  // Row reordering text
  rowReorderingHeaderName: "Reihen neu ordnen",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "Summe",
  aggregationFunctionLabelAvg: "Mittelwert",
  aggregationFunctionLabelMin: "Minimum",
  aggregationFunctionLabelMax: "Maximum",
  aggregationFunctionLabelSize: "Anzahl"
}, qE = rkt(okt, gkt), {
  palette: Ikt,
  shape: {
    borderRadius: sz
  }
} = _m(), e9 = {
  // all corners are softer
  shape: {
    borderRadius: sz * 2
  },
  // Darkblue #041F4E, yellow #F3FA0A, purple #A800DD
  palette: {
    primary: {
      main: "#00A4DD",
      contrastText: "#FFF"
    },
    secondary: {
      main: "#EE7373",
      contrastText: "#FFF"
    },
    warning: {
      main: "#FFC113",
      contrastText: "#FFF"
    },
    error: {
      main: "#DD3900",
      contrastText: "#FFF"
    },
    info: {
      main: "#1CDFDF",
      contrastText: "#FFF"
    },
    //73EEEE
    text: {
      primary: "#000",
      secondary: "#555"
    },
    success: {
      main: "#36DD00",
      contrastText: "#FFF"
    },
    mode: "light",
    editor: {
      main: h4[800],
      contrastText: "#fff"
    },
    // background: {default: "#FFF", paper: "#00A4DD"},
    content: {
      main: "#ffffff"
    },
    scrollbar: {
      default: "lightgrey"
    }
    // contrastThreshold: 2.7, <= This causes MUI contrast console errors. But fixed contrast Text removes Auto Update Options on Custom Theme Col Change
  },
  components: {
    MuiTooltip: {
      defaultProps: {
        disableInteractive: !0
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
        // disable ripple in entire app 💣!
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          whiteSpace: "nowrap",
          minWidth: "auto",
          borderRadius: sz
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: "none"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          height: "100%",
          alignItems: "start"
        },
        content: {
          width: "100%"
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          justifyContent: "space-between"
        }
      }
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          color: Ikt.primary.main
        }
      }
    },
    MuiCard: {
      defaultProps: {
        raised: !0
      }
    }
  },
  typography: {
    fontFamily: ["Nunito Sans", "Arial", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"].join(",")
  }
}, lkt = _m(dr(e9, {
  palette: {
    primary: {
      main: "#00A4DD"
    }
  }
}), qE), skt = _m(dr(e9, {
  palette: {
    mode: "dark"
  },
  text: {
    primary: "#FFF",
    secondary: "#AFAFAF"
  }
}), qE), Cne = N5(lkt);
N5(skt);
const ev = () => {
  var g, r, o, I, s;
  const {
    themeOptionsCreator: e
  } = OZ(), t = _(Ai), i = (r = (g = _(EZ)) == null ? void 0 : g.apps) == null ? void 0 : r.find((a) => a.appId == (t == null ? void 0 : t.id)), n = (s = (I = (o = i == null ? void 0 : i.settings) == null ? void 0 : o.ext) == null ? void 0 : I.theme) != null && s.palette ? i : t;
  return je(() => {
    var A, m;
    const a = ((m = (A = n == null ? void 0 : n.settings) == null ? void 0 : A.ext) == null ? void 0 : m.theme) ?? {}, d = dr(e9, a), C = (e == null ? void 0 : e(ce.cloneDeep(d))) ?? d;
    let u = _m(C, qE);
    return u = N5(u), u;
  }, [n, e]);
}, az = {
  position: "absolute",
  color: "primary.main",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 1,
  padding: 0
}, cz = {
  width: "48px",
  height: "48px"
}, akt = Se.forwardRef((e, t) => {
  const i = _(j_), [n, g] = At(0), r = je(() => i.slice().sort((d, C) => d.label > C.label ? 1 : -1).map((d) => d.url), [i]), o = je(() => JSON.stringify(r), [r]);
  et(() => {
    g(0);
  }, [o]);
  const [I, s] = qHt(), a = ev();
  return /* @__PURE__ */ p("div", { ref: I, style: {
    height: "100%",
    width: "auto"
  }, children: /* @__PURE__ */ p(Ine.Carousel, { swipeable: !0, showStatus: !1, infiniteLoop: !0, emulateTouch: !0, showThumbs: !1, selectedItem: n, onChange: (d) => g(d), renderArrowNext: (d, C, u) => C ? /* @__PURE__ */ p(mi, { onClick: d, "data-cy": "showNext", sx: {
    ...az,
    right: "16px"
  }, children: /* @__PURE__ */ p(s6e, { sx: cz }) }) : null, renderArrowPrev: (d, C, u) => C ? /* @__PURE__ */ p(mi, { onClick: d, "data-cy": "showPrevious", sx: {
    ...az,
    left: "16px"
  }, children: /* @__PURE__ */ p(l6e, { sx: cz }) }) : null, renderIndicator: (d, C) => /* @__PURE__ */ p(_t, { component: "li", className: Ve("dot", C && "selected"), onClick: d, sx: {
    backgroundColor: a.palette.primary.main + "!important"
  } }), children: r.map((d, C) => /* @__PURE__ */ p("div", { style: {
    height: s.height,
    width: "100%",
    margin: "auto",
    // no interactions so swipe can occur instead of dragging the image
    pointerEvents: "none",
    backgroundImage: `url(${d})`,
    backgroundSize: "contain",
    objectFit: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  } }, C)) }) });
}), ckt = ki({
  app: {
    gallery: {
      root: !0
    }
  }
})(akt);
class dkt extends Td {
  constructor() {
    super(...arguments);
    Bg(this, "catchUnhandledRejectionErrors", !1);
  }
  componentDidUpdate(i) {
    this.state.error && JSON.stringify(i.template) !== JSON.stringify(this.props.template) && this.handleCloseError();
  }
  renderError(i) {
    return /* @__PURE__ */ p(fe, { component: "div", sx: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, children: /* @__PURE__ */ ge(Ne, { children: [
      "3D-Parsing-Error: Maybe something wrong with Custom-Scene-Setting?",
      " ",
      /* @__PURE__ */ p("br", {}),
      i.message
    ] }) });
  }
}
const Ckt = (e, t) => e.size <= t.size && [...e].every((i) => t.has(i)), ukt = () => {
  const e = C5(), {
    scene: t
  } = Mu(), i = _(Ih), n = Ct(), g = Ct(-1), r = Ct(), [, o] = At(0);
  me.equals(i, n.current) || (g.current = 1), tw(() => {
    if (!e.active && i !== n.current) {
      const d = new Set(i.map((A) => A.modelId)), C = /* @__PURE__ */ new Set();
      t.traverse((A) => {
        var h;
        const m = (h = A == null ? void 0 : A.userData) == null ? void 0 : h.modelId;
        m && C.add(m);
      });
      const u = !Ckt(d, C);
      u ? r.current = void 0 : (n.current = i, r.current = [...C]), o(Math.random()), g.current = u ? 1 : 0;
    }
  });
  const I = e.active || g.current === 1, s = _(rf), a = zt();
  return et(() => {
    I !== s && (a(b_(I)), a(Dot(I ? void 0 : r.current)));
  }, [I, s]), I;
}, Akt = () => {
  const e = _(K8), t = _(rf);
  je(() => {
    if (t)
      return;
    const i = ynt(), n = [];
    i == null || i.forEach((g) => {
      const r = parseInt((g == null ? void 0 : g.dataset.modelId) ?? "");
      if (!e.includes(r)) {
        const o = g.id, I = Wu.get(o);
        I && n.push({
          konvaStage: I,
          canvasDiv: g
        });
      }
    }), n.forEach((g) => {
      const {
        konvaStage: r,
        canvasDiv: o
      } = g;
      Wu.delete(o.id), r.destroy(), o.remove();
    });
  }, [e, t]);
}, bkt = () => (ukt(), Akt(), null), mkt = Pt([wg], (e) => e.some((t) => {
  const i = hi(t);
  return (i == null ? void 0 : i.highlightHovered) ?? !1;
})), dz = (e, t, i, n, g, r) => {
  const o = new Uz(e.offsetX / t.domElement.clientWidth * 2 - 1, -(e.offsetY / t.domElement.clientHeight) * 2 + 1);
  g.setFromCamera(o, i);
  const I = n.getObjectByName("k3d");
  if (!I)
    return {};
  const s = g.intersectObjects(I.children, !0) ?? [];
  let a;
  for (const u of s) {
    let A = u.object;
    for (; A && !A.userData.modelActionUniqueId; )
      A = A.parent;
    if (A) {
      a = A;
      break;
    }
  }
  const d = r.find((u) => {
    var A;
    return u.unique === ((A = a == null ? void 0 : a.userData) == null ? void 0 : A.modelActionUniqueId);
  });
  if (!d)
    return {};
  const C = _r(d.anchoringSelection) ? d.anchoringSelection.id : vl(d.anchoringSelection);
  return C ? {
    instanceId: C,
    modelAction: d
  } : {};
};
function hkt() {
  const e = EJ(), t = zt(), {
    invalidate: i,
    raycaster: n,
    scene: g,
    camera: r,
    gl: o
  } = Mu((G) => G), I = _(mkt), s = _(Ih), a = RI((G) => G.hasHoveredSelection), d = RI((G) => G.setHoveredSelection), C = RI((G) => G.removeAllHoveredSelections), u = _(yj), A = _(Za), m = ft((G) => {
    if (G.buttons !== 0) {
      C(), i();
      return;
    }
    o.domElement.style.cursor = "unset";
    const {
      instanceId: y,
      modelAction: W
    } = dz(G, o, r, g, n, s);
    if (!W || !y) {
      C(), i();
      return;
    }
    const V = u[y], w = A[V.variableId];
    hi(w).highlightHovered && y && W && (o.domElement.style.cursor = "pointer", a(y) || (d(y), i()));
  }, [r, o, a, i, s, n, C, g, u, d, A]), h = je(() => ce.throttle(m, 50, {
    trailing: !1,
    leading: !0
  }), [m]), B = () => {
    h.cancel(), C();
  };
  et(() => {
    const G = o.domElement;
    return e || G == null || G.addEventListener("mouseleave", B, {
      passive: !0
    }), () => G == null ? void 0 : G.removeEventListener("mouseleave", B);
  }), et(() => {
    const G = o.domElement;
    return !e && I && (G == null || G.addEventListener("pointermove", h, {
      passive: !0
    })), () => G == null ? void 0 : G.removeEventListener("pointermove", h);
  });
  const f = ft((G) => {
    const {
      instanceId: y
    } = dz(G, o, r, g, n, s);
    y && t(ig(y));
  }, [r, t, o, s, n, g]);
  return et(() => {
    if (!I)
      return;
    let G = 0;
    const y = (w) => {
      G = w.timeStamp;
    }, W = (w) => {
      w.timeStamp - G < 500 && f(w);
    }, V = o.domElement;
    return V == null || V.addEventListener("mousedown", y, {
      passive: !0
    }), V == null || V.addEventListener("mouseup", W, {
      passive: !0
    }), () => {
      V == null || V.removeEventListener("mousedown", y), V == null || V.removeEventListener("mouseup", W);
    };
  }), null;
}
const pkt = () => ({
  canvasProps: {
    gl: {
      preserveDrawingBuffer: !0
    },
    camera: {
      near: 1e-3,
      fov: 35,
      position: [3, 2, 3]
    }
  },
  children: [
    {
      component: "OrbitControls",
      props: {
        maxPolarAngle: Math.PI / 2.1,
        makeDefault: !0
      }
    },
    {
      component: "ContactShadows",
      props: {
        resolution: 1024,
        position: [0, 0, 0],
        scale: 10,
        blur: 3,
        opacity: 1,
        far: 10
      }
    },
    {
      component: "Environment",
      props: {
        background: !1,
        files: B$("city")
      }
    },
    {
      component: "Sky",
      props: {
        distance: 45e3,
        sunPosition: [0, 1, 0],
        inclination: 1,
        azimuth: 0.1
      }
    },
    // TODO: Cam: We might be forced to remove the bounds
    {
      component: "Bounds",
      props: {
        margin: 1.3,
        damping: 10
      },
      children: [{
        component: "K3BoundsFocus",
        props: {
          animateOnMissed: !0,
          animate: !1
        },
        children: [{
          component: "K3D",
          props: {}
        }]
      }]
    }
  ]
}), Bkt = () => ({
  canvasProps: {
    gl: {
      preserveDrawingBuffer: !0
    },
    camera: {
      near: 1e-3,
      fov: 35,
      position: [3, 2, 3]
    },
    style: {
      backgroundColor: "black"
    }
  },
  children: [{
    component: "OrbitControls",
    props: {
      maxPolarAngle: Math.PI / 2.1,
      makeDefault: !0
    }
  }, {
    component: "ContactShadows",
    props: {
      resolution: 1024,
      frames: 1,
      position: [0, 0, 0],
      scale: 10,
      blur: 3,
      opacity: 1,
      far: 10
    }
  }, {
    component: "Environment",
    props: {
      background: !1,
      files: B$("night")
    }
  }, {
    component: "Stars",
    props: {}
  }, {
    component: "K3BoundsFocus",
    props: {
      animateOnMissed: !0,
      animate: !1
    },
    children: [{
      component: "K3D",
      props: {}
    }]
  }]
}), Zkt = [{
  name: "Default",
  template: pkt()
}, {
  name: "Night",
  template: Bkt()
}], fkt = () => {
  const t = _(dje).filter(({
    variable: i
  }) => hi(i).highlightHovered).map(({
    selection: i,
    variable: n
  }) => {
    const g = hi(n);
    return {
      selection: i,
      color: g.highlightColor ?? "white",
      targetOpacity: g.highlightOpacity ?? 0.5
    };
  });
  return /* @__PURE__ */ p(Bt, { children: t.map((i) => /* @__PURE__ */ qne(ykt, { ...i, key: i.selection.id })) });
};
function Gkt(e, t, i) {
  const n = [], g = e.getObjectByName("k3d");
  g == null || g.traverse((r) => {
    var s, a, d;
    const o = (a = (s = r.userData) == null ? void 0 : s.anchoringSelection) == null ? void 0 : a.id, I = vl((d = r == null ? void 0 : r.userData) == null ? void 0 : d.anchoringSelection);
    t.some((C) => C.id === o || I === C.id) && n.push(r);
  }), i.current.makeEmpty();
  for (const r of n)
    r.traverse((o) => {
      i.current.expandByObject(o);
    });
}
const Cz = 0.01, ykt = (e) => {
  var f, G, y;
  const t = RI((W) => W.hoveredSelections), i = Ct(), {
    scene: n,
    invalidate: g
  } = Mu(), r = _(vg), o = t.some((W) => W === e.selection.id), s = _(Wc).find((W) => W.id === e.selection.id), a = je(() => [e.selection, ...Zc(r, e.selection)], [r, e.selection]), d = Ct(new qV(new xt(), new xt())), C = Ct(new fge(d.current, new Ez(e.color)));
  et(() => {
    C.current.material = new Gge({
      color: e.color,
      linewidth: 2
    });
  }, [e.color]);
  const u = d.current.getCenter(new xt()), A = d.current.getSize(new xt());
  et(() => {
    i.current && (i.current.opacity = 0);
  }, [i.current]);
  const m = o ? e.targetOpacity : 0, [, h] = At(0);
  tw((W, V) => {
    var v, H;
    if (V > 0.1) {
      g();
      return;
    }
    const w = d.current.clone();
    Gkt(n, a, d), w.equals(d.current) || h((x) => (x + 1) % 100), i.current && (i.current.opacity = GS.damp(((v = i.current) == null ? void 0 : v.opacity) ?? 0, m, 15, V), Math.abs(m - ((H = i.current) == null ? void 0 : H.opacity)) >= Cz ? g() : i.current.opacity = m);
  });
  const B = (i == null ? void 0 : i.current) && (Math.abs(m - ((f = i.current) == null ? void 0 : f.opacity)) >= Cz || m > 0);
  return /* @__PURE__ */ ge(Bt, { children: [
    C.current && !((G = d.current) != null && G.isEmpty()) && (s == null ? void 0 : s.id) === e.selection.id && /* @__PURE__ */ p("primitive", { object: C.current }),
    /* @__PURE__ */ ge("mesh", { name: `highlighter-${e.selection.id}`, visible: B, position: u.toArray(), scale: A.toArray(), castShadow: !1, children: [
      /* @__PURE__ */ p("boxGeometry", { args: [1, 1, 1] }),
      /* @__PURE__ */ p("meshBasicMaterial", { ref: i, color: e.color, transparent: !0, depthTest: !1, opacity: ((y = i == null ? void 0 : i.current) == null ? void 0 : y.opacity) ?? 0 })
    ] })
  ] });
};
function Wkt() {
  const e = ew(), t = e == null ? void 0 : e.getSize(), {
    progress: i
  } = C5();
  return /* @__PURE__ */ p(vge, { position: t == null ? void 0 : t.center, children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
    position: "absolute"
  }, children: [
    /* @__PURE__ */ p(hm, { sx: {
      position: "absolute"
    }, size: 60, disableShrink: !0 }),
    /* @__PURE__ */ p(Ne, { sx: {
      position: "absolute",
      left: 15,
      top: 20
    }, variant: "caption", component: "div", color: "text.secondary", children: `${Math.round(i)}%` })
  ] }) });
}
function Skt(e, t) {
  return Rge(e, jo.libsUrl, t);
}
function Vkt(e, t) {
  var n;
  let i = !1;
  e.scene.traverse((g) => {
    var r, o, I;
    p$(g) && (g.userData.modelId = (r = t == null ? void 0 : t.model) == null ? void 0 : r.id, g.receiveShadow = !!((o = t.meshProps) != null && o.receiveShadow), g.castShadow = !!((I = t.meshProps) != null && I.castShadow), i = !0);
  }), i || (e.scene.userData.modelId = (n = t == null ? void 0 : t.model) == null ? void 0 : n.id);
}
function wkt(e, t) {
  var g, r;
  const i = Skt(e, !0);
  Vkt(i, t);
  const n = t.onMaterialsLoaded;
  return et(() => {
    n && n(i.materials);
  }, [i.materials, n]), i && t.onUpdate && t.onUpdate(i), (g = t.model) != null && g.key && (i.scene.name = (r = t.model) == null ? void 0 : r.key), i;
}
const uz = [0, 0, 0], vkt = [1, 1, 1];
function Rkt(e, t) {
  const {
    rotation: i = uz,
    position: n = uz,
    scale: g = vkt
  } = e.meshProps ?? {};
  t.rotation.set(i[0], i[1], i[2]), t.position.set(n[0], n[1], n[2]), t.scale.set(g[0], g[1], g[2]), t.updateWorldMatrix(!0, !0);
}
function une(e) {
  var r;
  const t = wkt(e.fileURL || "", e), i = je(() => Object.values(t.materials), [t.materials]), {
    materials: n
  } = Z8(i, (r = e.model) == null ? void 0 : r.id, e.modelAction), g = je(() => t.scene.clone(), [t.scene]);
  return ce.isEmpty(n) || g.traverse((o) => {
    o.material && n[o.material.name] && (o.material = n[o.material.name], o.material.needsUpdate = !0);
  }), Rkt(e, g), t.scene = g, t;
}
const x9t = une, Xkt = Sl((e, t) => _(n2) ? /* @__PURE__ */ p(Fkt, { ...e, children: /* @__PURE__ */ p(Az, { ref: t, ...e }) }) : /* @__PURE__ */ p(Az, { ref: t, ...e })), Ane = ki({
  app: {
    k3d: {
      sceneComponents: {
        K3Model: {
          root: !0
        }
      }
    }
  }
})(Xkt), Hkt = (e) => {
  const t = new xt(), i = new xt(), n = new Kz(), g = new xt();
  return e.decompose(t, n, g), i.setFromEuler(new d5().setFromQuaternion(n)), {
    newPosition: t,
    newRotation: i
  };
}, kkt = (e, t) => {
  const i = new Lz().makeRotationFromEuler(new d5().setFromVector3(t, "XYZ"));
  return e.clone().applyMatrix4(i).sub(e);
}, Fkt = (e) => {
  var r, o;
  const {
    meshProps: t,
    modelAction: i
  } = e, n = zt(), g = Ct(null);
  return /* @__PURE__ */ p(Xge, { scale: 0.5, anchor: [0, 0, 0], rotation: t == null ? void 0 : t.rotation, depthTest: !1, ref: g, annotations: !0, autoTransform: !0, onDragEnd: () => {
    var h;
    const I = ((h = i == null ? void 0 : i.ruleItem) == null ? void 0 : h.id) ?? "main", {
      newPosition: s,
      newRotation: a
    } = Hkt(g.current.matrix), d = new xt(...(t == null ? void 0 : t.position) || []), C = new xt(...(t == null ? void 0 : t.rotation) || []), u = kkt(d, a), A = d.clone().add(s).add(u).toArray(), m = C.clone().add(a).toArray();
    n(Yot({
      ruleItemId: I,
      modelId: e.model.id,
      position: A,
      rotation: m
    }));
  }, children: e.children }, ((o = (r = t == null ? void 0 : t.position) == null ? void 0 : r.toString) == null ? void 0 : o.call(r)) || 0);
}, Az = Sl((e, t) => {
  var i, n, g, r;
  return /* @__PURE__ */ p("group", { userData: {
    anchoringSelection: (i = e.modelAction) == null ? void 0 : i.anchoringSelection,
    modelActionUniqueId: (n = e.modelAction) == null ? void 0 : n.unique
  }, children: e.component ? /* @__PURE__ */ p(e.component, { ref: t, modelAction: e.modelAction, name: (g = e.modelAction) == null ? void 0 : g.unique, ...e.meshProps, id: ((r = e.model) == null ? void 0 : r.id) ?? -1 }) : /* @__PURE__ */ p(Ykt, { ref: t, ...e }) });
}), Ykt = Sl((e, t) => {
  const i = une(e);
  return /* @__PURE__ */ p("mesh", { ref: t, children: /* @__PURE__ */ p("primitive", { object: i.scene }) });
}), xkt = {
  id: "background"
}, bz = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.tags) == null ? void 0 : i.includes(xkt.id)) ?? !1;
};
function mz({
  data: e,
  colorActions: t,
  materialActions: i,
  printActions: n
}) {
  return /* @__PURE__ */ p($V, { fallback: /* @__PURE__ */ p(Wkt, {}), children: /* @__PURE__ */ p(Ane, { model: e.model, meshProps: e.modelAction.props, fileURL: e.model.path, colorActions: t, materialActions: i, printActions: n, modelAction: e.modelAction, component: e.component }, "k3model" + e.modelAction.unique) });
}
function Dkt({
  children: e,
  backgroundChildren: t
}) {
  var s;
  const i = Ct(), n = _(Ih), g = _(Gj), r = _(fj), o = _(ND), I = n.map((a) => {
    const d = a.model;
    let C;
    return d.type === "dynamic" && (C = Ogt(d, a)), {
      model: d,
      component: C,
      modelAction: a
    };
  }).filter(Boolean);
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ ge("group", { name: "k3d", ref: i, children: [
      /* @__PURE__ */ p(fkt, {}),
      (s = I == null ? void 0 : I.filter((a) => (a.model.path || a.component) && !bz(a.model))) == null ? void 0 : s.map((a, d) => /* @__PURE__ */ p(mz, { data: a, colorActions: r, materialActions: g, printActions: o }, a.modelAction.unique ?? d)),
      e
    ] }, "k3d"),
    /* @__PURE__ */ ge("group", { name: "k3d-background", children: [
      I.filter((a) => (a.model.path || a.component) && bz(a.model)).map((a, d) => /* @__PURE__ */ p(mz, { data: a, colorActions: r, materialActions: g, printActions: o }, a.modelAction.unique ?? d)),
      t
    ] }, "k3d-background")
  ] });
}
const Jkt = (e) => new Promise((t) => {
  setTimeout(t, e);
}), Kkt = (e) => !e.focusType || e.focusType === "dynamic", Ekt = (e) => ce.isEmpty(e == null ? void 0 : e.modelIds) && ce.isEmpty(e == null ? void 0 : e.objectNames), bne = (e, t) => {
  if (e.focusType === "static")
    return !1;
  const i = !Ekt(e), n = t.isEmpty();
  return i && n;
}, Nkt = (e) => {
  const t = /anchoringSelectionId_(.+)/, i = e.match(t);
  return i ? i[1] : "";
}, mne = (e, t, i) => {
  const n = i ? rh(i) : void 0, g = i ? $u(i, n, !0) : [], r = ((e == null ? void 0 : e.modelIds) || []).reduce((s, a) => ({
    ...s,
    [a]: !0
  }), {}), o = ((e == null ? void 0 : e.objectNames) || []).reduce((s, a) => ({
    ...s,
    [a]: !0
  }), {}), I = new qV();
  if (!ce.isEmpty(e == null ? void 0 : e.modelIds) || !ce.isEmpty(e == null ? void 0 : e.objectNames))
    t.traverse((s) => {
      var d;
      if (!s.visible)
        return;
      const a = (d = s == null ? void 0 : s.userData) == null ? void 0 : d.modelId;
      if (a && r[a] || o[s.name]) {
        const C = Nkt(s.name);
        if (i && C) {
          const u = TD(C)(i);
          if (u && // if the openSelection is "deep enough" our anchoring Selection could be part in its parents
          g.some((A) => A.variableId === u.variableId) && // but it actually is not
          !g.some((A) => Ca(A, u)))
            return;
        }
        I.expandByObject(s);
      }
    });
  else {
    const s = t.getObjectByName("k3d");
    s && I.setFromObject(s);
  }
  return I;
};
function hne(e) {
  return [e.min, e.max, new xt(e.min.x, e.min.y, e.max.z), new xt(e.min.x, e.max.y, e.min.z), new xt(e.min.x, e.max.y, e.max.z), new xt(e.max.x, e.min.y, e.min.z), new xt(e.max.x, e.min.y, e.max.z), new xt(e.max.x, e.max.y, e.min.z)];
}
function hz(e, t, i, n) {
  const g = Tkt(t[0], e, t), r = g.maxPlane.clone().translate(g.maxPlane.normal.clone().multiplyScalar(g.maxDistance)), o = new xt();
  return r.intersectLine(i, o), {
    length: new xt().subVectors(o, n).lengthSq(),
    point: o
  };
}
function Lkt(e, t, i, n, g, r) {
  if (g.isEmpty())
    return console.warn("Focus bounding box was empty! Returning original camera position."), e;
  const o = new xt().subVectors(t, e).normalize(), I = new xt().crossVectors(o, new xt(0, 1, 0)).normalize(), s = new xt().crossVectors(I, o).normalize(), a = Math.tan(i * Math.PI / 180 / 2), d = a * n, C = s.clone().multiplyScalar(a), u = I.clone().multiplyScalar(d), A = new xt().addVectors(o, C).sub(u), m = new xt().addVectors(o, C).add(u), h = new xt().subVectors(o, C).sub(u), B = new xt().subVectors(o, C).add(u), f = new xt().crossVectors(A, h).normalize(), G = new xt().crossVectors(B, m).normalize(), y = new xt().crossVectors(m, A).normalize(), W = new xt().crossVectors(h, B).normalize(), V = new Ky().setFromNormalAndCoplanarPoint(f, e), w = new Ky().setFromNormalAndCoplanarPoint(G, e), v = new Ky().setFromNormalAndCoplanarPoint(y, e), H = new Ky().setFromNormalAndCoplanarPoint(W, e), x = hne(g), N = new yge(new xt(...e).add(o.clone().multiplyScalar(-1e3)), new xt(...t)), M = [V, w], {
    length: $,
    point: q
  } = hz(x, M, N, t), E = [v, H], {
    length: L,
    point: P
  } = hz(x, E, N, t), Q = $ > L ? q : P;
  return r !== 0 && Q.add(o.clone().multiplyScalar(-r)), Q;
}
function Tkt(e, t, i) {
  let n = -1 / 0, g = e;
  for (const r of t)
    for (const o of i) {
      const I = o.distanceToPoint(r);
      I > n && (n = I, g = o);
    }
  return {
    maxPlane: g,
    maxDistance: n
  };
}
function pne(e, t, i, n, g) {
  var u;
  const [r, o, I] = e.position, s = new xt(r, o, I);
  let a;
  if (e.focusType === "dynamic" || !e.focusType)
    try {
      a = (u = n.refresh(i)) == null ? void 0 : u.getSize();
    } catch {
      console.warn("BoundsApi not ready yet.");
    }
  if (e.focusType === "static" || !a)
    return {
      newPosition: s.toArray(),
      newTarget: e.lookAt
    };
  const {
    position: d,
    lookAt: C
  } = Bne(s, new xt(...e.lookAt), t.fov, t.aspect, a, i, g);
  return {
    newPosition: d.toArray(),
    newTarget: C.toArray()
  };
}
function Bne(e, t, i, n, g, r, o) {
  const s = new xt().subVectors(e, new xt(...t)).normalize().multiplyScalar(g.distance).add(g.center), a = g == null ? void 0 : g.center;
  return {
    position: Lkt(s.clone(), new xt(...a), i, n, r, o),
    lookAt: a
  };
}
function _V(e, t, i, n, g = 0.1) {
  const r = new qV().setFromObject(t), o = e.refresh(t).getSize(), {
    position: I,
    lookAt: s
  } = Bne(i.position.clone(), o.center, i.fov, i.aspect, o, r, n), a = I.toArray(), d = s.toArray();
  Zne(i, r, a, d, g) && e.to({
    position: a,
    target: d
  });
}
function Mkt(e, t, i, n, g) {
  const r = mne(e, n), o = {
    position: e.position,
    lookAt: e.lookAt
  };
  if (i && e && !bne(e, r)) {
    const {
      newPosition: I,
      newTarget: s
    } = pne(e, t, r, i, g);
    o.position = I, o.lookAt = s;
  }
  return o;
}
const Ukt = ["x", "y", "z"], pz = (e) => Ukt.some((t) => e[t] < -1 || e[t] > 1);
function Zne(e, t, i, n, g, r = !0) {
  if (!g)
    return !0;
  const o = hne(t), I = e.clone(!0);
  return I.position.fromArray(i), I.lookAt(new xt(...n)), I.updateMatrixWorld(), I.updateProjectionMatrix(), o.some((a) => {
    const d = a.clone().project(e), C = a.project(I);
    return r && (pz(d) || pz(C)) ? !0 : d.distanceTo(C) > g;
  });
}
const t9 = (e) => {
  var g, r, o;
  const t = (o = (r = (g = e == null ? void 0 : e.env) == null ? void 0 : g.template) == null ? void 0 : r.children) == null ? void 0 : o.find((I) => I.component === "Bounds"), i = t == null ? void 0 : t.props;
  return (i == null ? void 0 : i.margin) ?? 0;
}, kd = {
  quality: 0.8,
  width: 1280,
  height: 720,
  aspect: 1280 / 720
}, Pkt = (e, t, i, n, g) => {
  var s, a;
  const r = new Mz(t.fov, (((s = e.resolution) == null ? void 0 : s.width) ?? kd.width) / (((a = e.resolution) == null ? void 0 : a.height) ?? kd.height), t.near, t.far), {
    position: o,
    lookAt: I
  } = Mkt(e, r, i, n, g);
  return r.position.set(...o), r.lookAt(...I), r.updateProjectionMatrix(), r;
}, fne = async (e, t, i = kd.quality, n = kd.width, g = kd.height) => {
  const r = e.camera.clone(), o = new Uz();
  return e.gl.getSize(o), e.gl.setSize(n, g), e.camera.copy(t), e.camera.updateProjectionMatrix(), e.invalidate(5), await Jkt(100), await new Promise((I) => {
    e.gl.domElement.toBlob(I, "image/jpeg", i);
  }).finally(() => {
    e.camera.copy(r), e.camera.updateProjectionMatrix(), e.gl.setSize(o.x, o.y);
  });
}, zkt = async (e, t, i, n, g) => {
  var d, C, u;
  const r = t9(e), o = Pkt(n, t.camera, i, t.scene, r), {
    width: I,
    height: s
  } = ms("getScreenshotDimensions", {
    width: ((d = n.resolution) == null ? void 0 : d.width) ?? kd.width,
    height: ((C = n.resolution) == null ? void 0 : C.height) ?? kd.height
  }), a = await fne(t, o, (u = e == null ? void 0 : e.settings) == null ? void 0 : u.screenshotQuality, I, s);
  return {
    key: `camera_${g}`,
    file: URL.createObjectURL(a)
  };
}, Okt = (e) => {
  console.debug("Executing useCreateScreenshotsOfCanvas");
  const t = zt(), i = _(Ai), n = _(Zje), g = Mu(), r = ew(), o = ft(async () => {
    var a;
    console.debug("Begin to take pictures"), g.gl.setPixelRatio(1);
    const s = [];
    if (n.length)
      for (let d = 0; d < n.length; d++) {
        const C = n[d];
        s.push(await zkt(i, g, r, C, d));
      }
    else {
      const d = g.camera.clone(!0);
      d.aspect = kd.aspect, d.updateProjectionMatrix();
      const C = await fne(g, d, (a = i == null ? void 0 : i.settings) == null ? void 0 : a.screenshotQuality);
      s.push({
        key: "camera_0",
        file: URL.createObjectURL(C)
      });
    }
    console.debug("Finish taking pictures"), t(Bx(s)), console.debug("Finish committing pictures to redux");
  }, [g, n, t, i, r]), I = ft(async () => {
    var a;
    if (!((a = window.oc3) == null ? void 0 : a.get())) {
      console.warn("Not screenshotting due to missing state"), t(Bx([]));
      return;
    }
    e == null || e(), o();
  }, [o, e, t]);
  et(() => {
    I();
  }, []);
};
function Qkt(e) {
  const {
    scene: t,
    camera: i
  } = Mu(), n = i, g = t.getObjectByName("k3d"), r = ew(), o = _(J8), I = _(rf), s = _(Ai), a = t9(s);
  je(() => {
    if (r)
      return !o && !I && r && g && _V(r, g, n, a, e), () => {
        !o && !I && g && _V(r, g, n, a, e);
      };
  }, [a, I, r, o, g, e]);
}
const Bz = 2;
function jkt({
  animateOnMissed: e = !1,
  animate: t = !1,
  threshold: i,
  ...n
}) {
  const g = ew(), r = n.boundsApi || g, o = _(Ai), I = t9(o), {
    scene: s,
    invalidate: a,
    camera: d
  } = Mu(), C = d, u = _(J8), A = _(Dgt), m = _(rf), h = n.isLoadingSceneOverride === void 0 ? m : n.isLoadingSceneOverride, [B, f] = At([]), G = _(K8);
  if (!h && u && Kkt(u)) {
    const H = u.modelIds ? ce.intersection(G, u == null ? void 0 : u.modelIds).sort() : G;
    me.equals(H, B) || f(H);
  }
  Qkt(i);
  const y = (H) => {
    H.stopPropagation(), r && t && H.delta <= 2 && _V(r, H.object, C, I);
  }, W = s.getObjectByName("k3d"), V = (H) => {
    r && e && W && H.button === 0 && _V(r, W, C, I);
  }, w = Ct(), v = _((H) => h ? null : mne(u, s, H));
  return je(
    () => {
      if (!v || h)
        return;
      const H = u && bne(u, v);
      if (!r || !u || H)
        return;
      const {
        newPosition: x,
        newTarget: N
      } = pne(u, C, v, r, I);
      if (Zne(C, v, x, N, u.threshold ?? i, u.focusType === "dynamic"))
        return w.current = {
          position: x,
          target: N,
          frameCount: 0
        }, a(), w;
    },
    // If we are adding focusBoundingBox to the deps, we will update too often.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [I, r, u, a, h, B, A]
  ), tw(() => {
    var H, x;
    w != null && w.current && (((H = w == null ? void 0 : w.current) == null ? void 0 : H.frameCount) < Bz ? (w.current.frameCount += 1, a()) : ((x = w == null ? void 0 : w.current) == null ? void 0 : x.frameCount) >= Bz && (r.to(w.current), w.current = void 0, a()));
  }), /* @__PURE__ */ p(
    "group",
    {
      onClick: y,
      onPointerMissed: V,
      children: n.children
    }
  );
}
const Gne = Bs(() => {
}), _kt = (e) => {
  const t = zt();
  et(() => (t(QT(!0)), () => {
    t(QT(!1));
  }), []);
  const i = _(zJ) == "creating", n = Hn(Gne);
  return /* @__PURE__ */ ge(Bt, { children: [
    i && /* @__PURE__ */ p($kt, { beforeScreenshot: n }),
    /* @__PURE__ */ p(jkt, { ...e })
  ] });
};
function $kt({
  beforeScreenshot: e
}) {
  return Okt(e), null;
}
const qkt = {
  K3D: Dkt,
  K3BoundsFocus: _kt,
  K3Model: Ane
}, eFt = new Set(Object.keys(dc)), tFt = (e) => eFt.has(e) ? (t) => /* @__PURE__ */ p(e, { ...t }) : null, iFt = (e) => (console.error("unknown 3D component", e), () => /* @__PURE__ */ p("group", {})), nFt = (e) => (
  // @ts-ignore
  kge[e] || // @ts-ignore
  Wge[e] || // @ts-ignore
  qkt[e] || // @ts-ignore
  Fge[e] || // @ts-ignore
  Se[e] || tFt(e) || iFt(e)
), gFt = (e) => ki({
  app: {
    k3d: {
      sceneComponents: {
        [e]: {
          root: !0
        }
      }
    }
  }
})(nFt(e)), rFt = Se.forwardRef((e, t) => /* @__PURE__ */ p(Pz, { ...e, ref: t, frameloop: "demand", children: e.children })), oFt = ({
  canvas: e,
  canvasProps: t,
  beforeScreenshot: i,
  children: n
}) => {
  var I;
  const {
    contexts: g
  } = OZ(), r = e || Pz, o = Hge(hs, ...g);
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    height: "100%",
    width: "100%",
    bgcolor: "background.default"
  }, children: /* @__PURE__ */ p(fe, { component: "div", sx: {
    height: "100%"
  }, children: /* @__PURE__ */ p(r, { ...t, gl: {
    ...t == null ? void 0 : t.gl,
    logarithmicDepthBuffer: (
      // We are using a logarithmic depth buffer for better depth
      // precision. If it for the rare case should be a performance
      // problem, you can disable it in the scene settings of the specific
      // configurator.
      // Here is a nice demo of this problem:
      // https://threejs.org/examples/#webgl_camera_logarithmicdepthbuffer
      ((I = t == null ? void 0 : t.gl) == null ? void 0 : I.logarithmicDepthBuffer) ?? !0
    )
  }, onCreated: (s) => {
    var a;
    window.oc3 = s, (a = t == null ? void 0 : t.onCreated) == null || a.call(t, s);
  }, children: /* @__PURE__ */ p(Gne.Provider, { value: i, children: /* @__PURE__ */ p(o, { children: n }) }) }) }) });
}, IFt = ki({
  app: {
    k3d: {
      canvas: {
        root: !0
      }
    }
  }
})(oFt), lFt = ({
  child: e
}) => {
  const t = je(() => gFt(e.component), [e.component]);
  return /* @__PURE__ */ p(t, { ...e.props, children: /* @__PURE__ */ p(yne, { sceneChildren: e.children }) });
}, yne = (e) => {
  const t = e.sceneChildren || [];
  return /* @__PURE__ */ p(Bt, { children: t.map((i, n) => /* @__PURE__ */ p(lFt, { child: i }, `${i.component}_${n}`)) });
}, Wne = (e = [], t = "", i) => e.map((n) => n.component == t ? i : {
  ...n,
  children: Wne(n.children, t, i)
}).filter((n) => n), sFt = Se.forwardRef((e, t) => {
  const i = _(Ai), n = _(n2), g = je(() => i != null && i.env ? i.env.template : Zkt[0].template, [i]), r = je(() => e.K3DReplace ? Wne(g.children, "K3D", e.K3DReplace) : g.children, [e.K3DReplace, g.children]);
  return /* @__PURE__ */ p(dkt, { template: g, children: /* @__PURE__ */ ge(
    IFt,
    {
      canvas: rFt,
      canvasProps: {
        ...g.canvasProps,
        ref: t
      },
      children: [
        n && /* @__PURE__ */ p("axesHelper", { args: [5] }),
        !jo.disable3D && /* @__PURE__ */ ge(Bt, { children: [
          /* @__PURE__ */ p(yne, { sceneChildren: r }),
          /* @__PURE__ */ p(bkt, {}),
          /* @__PURE__ */ p(hkt, {})
        ] }),
        e.children
      ]
    }
  ) });
}), aFt = ki({
  app: {
    k3d: {
      root: !0
    }
  }
})(sFt), cFt = ({
  app: e
}) => {
  switch (e == null ? void 0 : e.stage) {
    case $B._3D:
      return /* @__PURE__ */ p(aFt, {});
    case $B.GALLERY:
      return /* @__PURE__ */ p(ckt, {});
    default:
      return null;
  }
}, dFt = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.palette) == null ? void 0 : t.content) == null ? void 0 : i.main) || "white";
}, CFt = ({
  app: e,
  children: t
}) => {
  const i = ev(), n = _(hje(e)), g = _(Yj);
  return /* @__PURE__ */ ge(fe, { component: "div", sx: {
    ...MF.content,
    ...n ? MF.content2d : MF.content3d,
    backgroundColor: dFt(i),
    ...g ? AFt : {}
  }, children: [
    g ? /* @__PURE__ */ p(fe, { component: "div", sx: bFt, "data-cy": "fullscreenOverlays", children: /* @__PURE__ */ p(one, {}) }) : null,
    /* @__PURE__ */ p(cFt, { app: e }),
    t
  ] });
}, uFt = ki({
  app: {
    contentView: {
      root: !0
    }
  }
})(CFt), AFt = {
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 5
}, bFt = {
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 1001
}, MF = {
  content: {
    position: "relative",
    width: 1,
    height: 1
  },
  content3d: {},
  content2d: {
    backgroundColor: "#BBBBBB"
  }
};
function mFt({
  isMobile: e,
  actions: t,
  setSelectedAction: i
}) {
  return /* @__PURE__ */ p(_ue, { variant: "contained", className: "k3-exit-button-group", "data-cy": "actionButtons", orientation: e ? "vertical" : "horizontal", children: t.filter((n) => !n.isDealerExit).map((n) => /* @__PURE__ */ p(Si, { "data-cy": `exit-${n.label.de}`, className: "k3-exit-button k3-btn", onClick: () => i(n), children: /* @__PURE__ */ p(Ne, { noWrap: !0, sx: {
    maxWidth: 150
  }, children: /* @__PURE__ */ p(xm, { value: n.label }) }) }, n.id)) });
}
const hFt = () => {
  const e = zt(), t = _(Ai), i = mE(t, !1), {
    t: n
  } = ii(), [g, r] = At();
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(BFt, { actions: i, setSelectedAction: (s) => {
      t.versionId ? e(ba(s)) : r(s);
    } }),
    /* @__PURE__ */ p(HJ, { show: !!g, type: "warning", onClose: (s) => {
      s && g && e(ba(g)), r(void 0);
    }, children: n("Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?") })
  ] });
}, pFt = ({
  setSelectedAction: e,
  actions: t
}) => {
  const i = IA();
  return /* @__PURE__ */ p(mFt, { isMobile: i, actions: t, setSelectedAction: e });
}, BFt = ki({
  app: {
    exitButtons: {
      root: !0
    }
  }
})(pFt), ZFt = ({
  elementId: e,
  children: t
}) => {
  const [i, n] = At(!1), [g, r] = At(!1), o = _(Ai);
  return Um(() => {
    const I = document.getElementById(e), s = () => {
      n(!0);
    }, a = () => {
      n(!1);
    };
    return I && (I.addEventListener("mouseenter", s), I.addEventListener("mouseout", a)), () => {
      I && (I.removeEventListener("mouseenter", s), I.removeEventListener("mouseout", a));
    };
  }, [e, o]), et(() => {
    const I = setTimeout(() => {
      r(i);
    }, 500);
    return () => {
      clearTimeout(I);
    };
  }, [i]), /* @__PURE__ */ p(lD, { open: g, anchorEl: document.getElementById(e), onClose: () => r(!1), anchorOrigin: {
    vertical: "top",
    horizontal: "center"
  }, sx: {
    pointerEvents: "none"
  }, PaperProps: {
    onMouseEnter: () => n(!0),
    onMouseLeave: () => n(!1),
    sx: {
      pointerEvents: "auto",
      p: 2
    }
  }, children: t });
}, Sne = (e) => (t) => t.layoutDesigner.switchVariables[e], fFt = {
  switchVariables: {}
}, Vne = Vg({
  name: "layoutDesigner",
  initialState: fFt,
  reducers: {
    setSwitchVariable: (e, t) => {
      e.switchVariables[t.payload.key] = t.payload.value;
    }
  }
}), {
  setSwitchVariable: GFt
} = Vne.actions, yFt = Vne.reducer, WFt = ({
  name: e,
  children: t
}) => {
  const i = zt(), n = _(Sne(e));
  return /* @__PURE__ */ p(Si, { onClick: () => {
    i(GFt({
      key: e,
      value: !n
    }));
  }, "data-cy": "customButton_" + e, children: t });
}, i9 = ({
  enabled: e = !1,
  name: t,
  variableKey: i,
  children: n
}) => {
  const g = _(Sne(t || "")), r = dK(i || ""), o = !!(r != null && r.value) && (r == null ? void 0 : r.value) !== "false" && (r == null ? void 0 : r.value) !== "0";
  return (t && g || i && o ? e : !e) ? /* @__PURE__ */ p(Bt, { children: n }) : null;
}, SFt = ({
  name: e,
  variableKey: t,
  children: i
}) => /* @__PURE__ */ p(i9, { name: e, variableKey: t, enabled: !0, children: i }), VFt = ({
  name: e,
  variableKey: t,
  children: i
}) => /* @__PURE__ */ p(i9, { name: e, variableKey: t, enabled: !1, children: i });
function wFt({
  showEditor: e,
  isAdmin: t,
  nav: i,
  openLink: n,
  logoUrl: g,
  logoSize: r,
  logoOpacity: o,
  link: I
}) {
  return /* @__PURE__ */ ge(_t, { direction: "row", spacing: 2, sx: {
    alignItems: "center",
    cursor: I ? "pointer" : "default"
  }, children: [
    g && /* @__PURE__ */ p(fe, { component: "div", sx: {
      width: r
    }, onClick: n, children: /* @__PURE__ */ p("img", { style: {
      height: "auto",
      width: r,
      boxSizing: "border-box",
      opacity: o
    }, alt: "logo", src: g, "data-cy": "logoImage" }) }),
    e && t && /* @__PURE__ */ p(tf, { "data-cy": "editLogoButton", tooltip: $r("change logo"), onClick: () => i("logo") })
  ] });
}
const tv = (e) => {
  var t, i, n;
  return (n = (i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.ext) == null ? void 0 : i.theme) == null ? void 0 : n.logo;
}, D9t = (e) => {
  var t;
  return ((t = tv(e)) == null ? void 0 : t.link) || "";
}, vFt = (e) => {
  var i;
  const t = ((i = tv(e)) == null ? void 0 : i.link) || "";
  return !t || t.startsWith("http") ? t : `https://${t}`;
}, RFt = (e) => {
  var t;
  return ((t = tv(e)) == null ? void 0 : t.opacity) || 0.75;
}, XFt = (e) => {
  var i;
  const t = (i = tv(e)) == null ? void 0 : i.size;
  return t ? +t : 200;
}, Zz = (e) => {
  var t;
  return (t = e == null ? void 0 : e.settings) == null ? void 0 : t.logo;
}, HFt = ({
  app: e
}) => {
  var I, s;
  const t = (s = (I = _(EZ)) == null ? void 0 : I.apps) == null ? void 0 : s.find((a) => a.appId == e.id), i = t && Zz(t) ? t : e, n = Zz(i) || "", g = XFt(i), r = RFt(i), o = vFt(i);
  return /* @__PURE__ */ p(FFt, { logoUrl: n, logoSize: g, logoOpacity: r, link: o });
}, kFt = ({
  logoUrl: e,
  logoSize: t,
  logoOpacity: i,
  link: n
}) => {
  const {
    t: g
  } = ii(), r = _(hr), o = _(dh), I = ha();
  return /* @__PURE__ */ p(wFt, { logoUrl: e, logoSize: t, logoOpacity: i, link: n, t: g, showEditor: r, isAdmin: o, nav: I, openLink: () => {
    n && window.open(n, "_blank");
  } });
}, FFt = ki({
  app: {
    logo: {
      root: !0
    }
  }
})(kFt), YFt = ({
  children: e
}) => /* @__PURE__ */ ge(_t, { spacing: 1, children: [
  /* @__PURE__ */ p(o$, {}),
  e
] }), xFt = ki({
  app: {
    sceneButtons: {
      root: !0
    }
  }
})(YFt), DFt = [{
  key: "facebook",
  label: "Facebook",
  href: "https://www.facebook.com/sharer/sharer.php?u=",
  Icon: /* @__PURE__ */ p(p6e, { fontSize: "inherit" }),
  translationKey: "translation_SocialShare_Facebook"
}, {
  key: "twitter",
  label: "Twitter",
  href: "https://twitter.com/intent/tweet?text=&url=",
  Icon: /* @__PURE__ */ p(v6e, { fontSize: "inherit" }),
  translationKey: "translation_SocialShare_Twitter"
}, {
  key: "linkedin",
  label: "LinkedIn",
  href: "https://www.linkedin.com/shareArticle?mini=true&url=",
  Icon: /* @__PURE__ */ p(f6e, { fontSize: "inherit" }),
  translationKey: "translation_SocialShare_LinkedIn"
}];
function JFt({
  app: e,
  handleClick: t,
  translation: i
}) {
  return /* @__PURE__ */ p(_t, { direction: "row", spacing: 1, justifyContent: "end", children: DFt.map(({
    key: n,
    label: g,
    href: r,
    Icon: o,
    translationKey: I
  }) => {
    var s, a;
    return ((a = (s = e == null ? void 0 : e.settings) == null ? void 0 : s.share) == null ? void 0 : a[n]) && /* @__PURE__ */ p(Cn, { title: i(I), children: /* @__PURE__ */ p(mi, { "data-cy": `social-${n}`, size: "large", color: "primary", onClick: () => t(r), children: o }, n) }, n);
  }) });
}
function KFt() {
  const e = zt(), t = un(), i = _(Ai);
  return /* @__PURE__ */ p(JFt, { app: i, handleClick: async (g) => {
    const r = e(tK("social")), o = await e(uK("Configuration", {
      id: "social-share",
      label: {}
    }, {})), I = ate(i, o == null ? void 0 : o.code);
    window.open(g + I, "_blank"), e(DD(r));
  }, translation: t });
}
const EFt = (e) => {
  const t = Li(), i = _(JQ(e.groupKey)), n = zt();
  return /* @__PURE__ */ p("div", { onClick: () => n(ig(t.id, i.id)), style: {
    cursor: "pointer",
    ...e.style
  }, children: e.children });
}, nc = ({
  p: e,
  spacing: t,
  children: i,
  direction: n = "column",
  gridArea: g,
  placeSelf: r,
  gap: o
}) => /* @__PURE__ */ p(fe, { component: "div", className: Ve("k3-aligned-box", g), sx: {
  zIndex: 0,
  p: +(e ?? t ?? 0),
  gridArea: g,
  placeSelf: r,
  pointerEvents: "none"
}, children: /* @__PURE__ */ p(_t, { sx: {
  pointerEvents: "all",
  gap: o
}, direction: n, className: "k3-aligned-box-content", children: i }) }), NFt = (e) => ({
  TopLeft: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "top-left", placeSelf: "start start", children: i }),
  TopCenter: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "top-center", placeSelf: "start center", children: i }),
  TopRight: ({
    p: t,
    children: i,
    direction: n = "column"
  }) => /* @__PURE__ */ p(nc, { p: t, spacing: e, direction: n, gridArea: "top-right", placeSelf: "start end", children: i }),
  MidLeft: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "mid-left", placeSelf: "center start", children: i }),
  MidCenter: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "mid-center", placeSelf: "center center", children: i }),
  MidRight: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "mid-right", placeSelf: "center end", children: i }),
  BotLeft: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "bot-left", placeSelf: "end start", children: i }),
  BotCenter: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "bot-center", placeSelf: "end center", children: i }),
  BotRight: ({
    p: t,
    children: i,
    direction: n = "row",
    gap: g
  }) => /* @__PURE__ */ p(nc, { p: t, gap: g, spacing: e, direction: n, gridArea: "bot-right", placeSelf: "end end", children: i })
}), LFt = ({
  type: e,
  path: t,
  silentErrors: i = !0
}) => {
  const {
    t: n
  } = ii(), g = _(GIt);
  if (!t)
    return console.warn("CustomData: No path provided!"), /* @__PURE__ */ p("pre", { children: n("CustomData: No path provided!") });
  const r = ce.get(g, t);
  if (!r) {
    const o = JSON.stringify(g, null, 2), I = `CustomData: No data found behind path "${t}"!:
${o}`;
    return console.warn(), i ? null : /* @__PURE__ */ p("pre", { children: I });
  }
  if (e === "html")
    return /* @__PURE__ */ p(Rc, { htmlString: r });
  if (!ce.isString(r)) {
    const o = JSON.stringify(r, null, 2), I = `CustomData: Data behind path "${t}" is not a string!:
${o}`;
    return console.warn(I), i ? null : /* @__PURE__ */ p("pre", { children: I });
  }
  return (r == null ? void 0 : r.toString()) || "";
}, TFt = () => null, MFt = (e) => ki({
  app: {
    customLayoutComponents: {
      [e]: {
        root: !0
      }
    }
  }
})(TFt), UFt = (e) => {
  const t = je(() => MFt(e.name), [e.name]);
  return /* @__PURE__ */ p(t, { ...e });
};
var n9 = {}, PFt = Cg;
Object.defineProperty(n9, "__esModule", {
  value: !0
});
var wne = n9.default = void 0, zFt = PFt(Kg()), OFt = xg;
wne = n9.default = (0, zFt.default)(/* @__PURE__ */ (0, OFt.jsx)("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning");
const QFt = (e) => async (t) => (t(Qot(e)), Q1("ruleitem", e));
function jFt() {
  const e = _(xgt), t = _(ya), i = _(n2), n = _(ch), g = _(hr), r = _(Ai), o = zt(), I = ii().t, s = Ah(), a = _(Ih), d = () => {
    s.resetQueries(["metadata"]), o(OT()), o($k(!1));
  }, C = (h) => t.find((B) => {
    var f, G;
    return Number(h.ruleItemId) == (B == null ? void 0 : B.id) && (h == null ? void 0 : h.modelId) == ((G = (f = Object.values((B == null ? void 0 : B.values) ?? [])) == null ? void 0 : f.find((y) => QS(y) && (y == null ? void 0 : y.modelId))) == null ? void 0 : G.modelId);
  }), u = (h) => a.find((B) => {
    var f;
    return (h.ruleItemId === "main" ? !B.ruleItem : ((f = B.ruleItem) == null ? void 0 : f.id) === +h.ruleItemId) && B.model.id === h.modelId;
  }), A = je(() => Object.entries(e).flatMap(([h, B]) => {
    const f = u(B);
    if (!f)
      return [];
    const G = f.model.dynamicModelKey ? rZ().find((w) => w.type === f.model.dynamicModelKey) : void 0, W = ((G == null ? void 0 : G.repositionApplicator) || nZ)("number")(f.props, f.expressionProps)(B.position, B.rotation) ?? {};
    return Object.entries(f.props).flatMap(([w, v]) => {
      const H = ce.isArray(v), x = H ? v : [v], N = ce.isArray(W[w]) ? W[w] : [W[w]], M = ce.isArray(f.expressionProps[w]) ? f.expressionProps[w] : [f.expressionProps[w]];
      return x.map(($, q) => ce.isNumber($) && $ !== N[q] && D_e(M[q]) ? H && v.length === 3 ? `${"XYZ"[q]}-${w}` : w : null).filter(Boolean);
    }).map((w) => ({
      message: `Derzeit wird eine Expression genutzt, um die ${w} des Modells ${f.model.label} zu setzen. Diese wird überschrieben.`
    }));
  }), [e]);
  function m() {
    return async () => {
      const h = Object.entries(e).map(async ([B, f]) => {
        const G = u(f);
        if (!G)
          return;
        const y = G.model.dynamicModelKey ? rZ().find((w) => w.type === G.model.dynamicModelKey) : void 0, V = ((y == null ? void 0 : y.repositionApplicator) || nZ)("expression")(G.props, G.expressionProps)(f.position, f.rotation);
        if (B == "main") {
          const w = ce.cloneDeep(n.find((v) => v.id == f.modelId));
          if (!w)
            return;
          w.props = {
            ...w.props,
            ...V
          }, await o(cx(w));
        } else {
          const w = ce.cloneDeep(C(f));
          if (!w)
            return;
          const v = Object.values(w.values).find((H) => QS(H) && H.modelId);
          if (!v)
            return;
          v.props = {
            ...v.props,
            ...V
          }, await o(QFt(w));
        }
      });
      await Promise.all(h), o($k(!1)), o(OT());
    };
  }
  return !g || r.stage !== "3D" ? null : /* @__PURE__ */ ge(_t, { spacing: 1, sx: {
    zIndex: 500
  }, children: [
    /* @__PURE__ */ p(Si, { "data-cy": "edit-positions", onClick: () => o($k(!i)), startIcon: /* @__PURE__ */ p(b6e, {}), variant: "outlined", className: "edit-positions-btn k3-btn k3-mode-button k3-secondary-btn", children: I("Positionen ändern") }),
    i && /* @__PURE__ */ ge(_t, { direction: "row", sx: {
      justifyContent: "space-around"
    }, children: [
      !!A.length && /* @__PURE__ */ p(Cn, { title: /* @__PURE__ */ ge(_t, { children: [
        A.map((h) => /* @__PURE__ */ p(Ne, { mb: 2, children: h.message }, h.message)),
        /* @__PURE__ */ p(Ne, { children: I("Abbrechen durch Klick") })
      ] }), children: /* @__PURE__ */ p(mi, { "data-cy": "cancel-scene-positions", color: "error", onClick: () => d(), children: /* @__PURE__ */ p(wne, { className: "changeWarning", color: "error" }) }) }),
      /* @__PURE__ */ p(Cn, { title: I("cancel"), children: /* @__PURE__ */ p(mi, { "data-cy": "cancel-scene-positions", color: "error", onClick: () => d(), children: /* @__PURE__ */ p(C6e, {}) }) }),
      /* @__PURE__ */ p(Cn, { title: I("Speichern"), children: /* @__PURE__ */ p(mi, { "data-cy": "save-scene-positions", color: "primary", onClick: m(), children: /* @__PURE__ */ p(V6e, {}) }) })
    ] })
  ] });
}
const _Ft = ({
  group: e,
  isHiddenGroup: t,
  columns: i,
  rows: n,
  row: g
}) => {
  const r = zt(), o = $_(), I = (C, u) => () => {
    r(lf(C === u ? null : C));
  }, s = _(mJ), a = _(q6), d = _(_6(e));
  return /* @__PURE__ */ ge(M5, { expanded: o === e.id, onChange: I(e.id, o), className: Ve("k3-main-nav-item k3-accordion-nav-item", d ? "groupAccordion" : "invisibleGroupAccordion"), sx: d ? {} : {
    visibility: "hidden"
  }, children: [
    /* @__PURE__ */ p(P5, { expandIcon: /* @__PURE__ */ p(OD, {}), className: "groupAccordionSummary k3-accordion-nav-inner", children: /* @__PURE__ */ p(Ne, { component: "div", children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "flex",
      alignItems: "center"
    }, children: [
      a && /* @__PURE__ */ p(qm, { "data-cy": "visitedTabs", color: "secondary", disableRipple: !0, disableFocusRipple: !0, checked: !!s.find((C) => C.id === e.id) }),
      /* @__PURE__ */ p(cE, { group: e, className: "k3-accordion-nav-item-text k3-nav-item-text" }),
      t && /* @__PURE__ */ p(dE, { children: /* @__PURE__ */ p(aE, { sx: {
        color: (C) => C.palette.secondary.main,
        marginLeft: 1,
        marginRight: 1
      } }) })
    ] }) }) }),
    /* @__PURE__ */ p(U5, { sx: {
      backgroundColor: (C) => C.palette.background.default
    }, children: /* @__PURE__ */ p(v2, { group: e, columns: i, rows: n, row: g }) })
  ] });
}, $Ft = (e) => /* @__PURE__ */ p(Bt, { children: e.groups.map((t) => {
  const i = K1(t, e.invisibleGroups);
  return !e.showEditorUi && i ? null : /* @__PURE__ */ p(_Ft, { columns: e.columns, rows: e.rows, row: e.row, group: t, isHiddenGroup: i }, t.id);
}).filter((t) => !!t) }), qFt = (e) => e.group && /* @__PURE__ */ p(v2, { columns: e.columns, rows: e.rows, row: e.row, invisibleGroups: e.invisibleGroups, group: e.group }), eYt = (e) => /* @__PURE__ */ p(Bt, { children: e.groups.map((t) => {
  const i = K1(t, e.invisibleGroups);
  return !e.showEditorUi && i ? null : /* @__PURE__ */ ge(fe, { component: "div", className: "k3-main-nav-item k3-scrollable-nav-item", children: [
    /* @__PURE__ */ ge(Ne, { variant: "h6", sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }, children: [
      i && /* @__PURE__ */ p(dE, { children: /* @__PURE__ */ p(Uj, { sx: {
        color: (n) => n.palette.secondary.main,
        marginLeft: 1,
        marginRight: 1
      } }) }),
      /* @__PURE__ */ p(cE, { group: t, className: "k3-scrollable-nav-item-text k3-nav-item-text" })
    ] }),
    /* @__PURE__ */ p(v2, { columns: e.columns, rows: e.rows, row: e.row, group: t, invisibleGroups: e.invisibleGroups })
  ] }, t.id);
}).filter((t) => !!t) }), tYt = (e) => null, iYt = ki({
  app: {
    sidebar: {
      footer: {
        root: !0
      }
    }
  }
})(tYt), nYt = () => {
  const e = Li(), t = _(Go(e == null ? void 0 : e.variableId)), i = _(vg), n = vl(e) === Dt.id ? Dt : jB(i, e), g = cA(n, t, !1), r = _($d(e == null ? void 0 : e.valueId));
  if ((t == null ? void 0 : t.settings.template) !== Jn.ComponentValueCards || !r || !n)
    return null;
  const o = g.findIndex((I) => I.selection.id === e.id);
  return /* @__PURE__ */ ge(Cc, { component: "div", sx: {
    width: 1,
    p: 1,
    boxSizing: "border-box",
    position: "relative"
  }, children: [
    /* @__PURE__ */ ge(Cc, { component: "div", sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      width: 1,
      boxSizing: "border-box",
      px: 1,
      p: 1
    }, children: [
      /* @__PURE__ */ p(Cc, { component: "div", sx: {
        width: "100%"
      }, children: /* @__PURE__ */ p(vq, { variable: t, contextInstance: n }) }),
      /* @__PURE__ */ p(nte, { index: o, instance: e, leftToRight: !0, dense: !1 })
    ] }),
    /* @__PURE__ */ p(Cc, { component: "div", children: r && /* @__PURE__ */ p(tq, { value: r, variable: t }) }),
    /* @__PURE__ */ p(bs, {})
  ] });
}, gYt = (e) => /* @__PURE__ */ p(nYt, {}), rYt = ki({
  app: {
    sidebar: {
      header: {
        root: !0
      }
    }
  }
})(gYt), oYt = (e) => {
  const t = Ct(null), i = Li(), n = _((I) => nC(I, i)), g = _((I) => fa(I, i)), r = zt();
  g || r(l2(i));
  const o = _(Ba(g));
  return et(() => {
    var I;
    (I = t.current) == null || I.scrollTo({
      top: 0,
      left: 0
    });
  }, [e.group]), /* @__PURE__ */ p(fe, { component: "div", sx: {
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column"
  }, "data-cy": "sidebarWrapper", children: /* @__PURE__ */ ge(AV, { addPadding: !0, children: [
    !e.hideBreadcrumb && (o == null ? void 0 : o.parentId) && /* @__PURE__ */ p(qee, { groups: n, focusGroupId: g, subHeader: !0 }),
    /* @__PURE__ */ p(rYt, { ...e }),
    /* @__PURE__ */ ge(fe, { component: "div", sx: {
      width: "100%",
      overflowY: "auto",
      flexGrow: 1
    }, ref: t, "data-cy": "sidebarContent", children: [
      e.design == "topmenu" && /* @__PURE__ */ p(qFt, { ...e }),
      e.design == "accordion" && /* @__PURE__ */ p($Ft, { ...e }),
      e.design == "onlysidebar" && /* @__PURE__ */ p(eYt, { ...e }),
      /* @__PURE__ */ p(Oee, { design: e.design, placement: "sidebar" })
    ] }),
    /* @__PURE__ */ p(iYt, { ...e })
  ] }) });
}, IYt = ki({
  app: {
    sidebar: {
      root: !0,
      components: {
        checkbox: !0,
        colorSelect: !0,
        colorDropdown: !0,
        colorRadio: !0,
        colorRadioCard: !0,
        ralColorSelect: !0,
        information: !0,
        hidden: !0,
        number: !0,
        radio: !0,
        radioCard: !0,
        select: !0,
        selectThumbs: !0,
        switch: !0,
        switchCard: !0,
        text: !0,
        textArea: !0
      }
    }
  }
})(oYt), FB = ({
  design: e,
  scrollable: t,
  hideBreadcrumb: i,
  columns: n = 1,
  rows: g,
  row: r = !1
}) => {
  const o = Li(), I = _((C) => nC(C, o)), s = _((C) => L1(C, o)), a = _((C) => M1(C, o)), d = _(hr);
  return /* @__PURE__ */ p(IYt, { invisibleGroups: s, showEditorUi: d, groups: I, group: a, design: e, columns: n, rows: g, row: r, scrollable: t, hideBreadcrumb: i });
}, lYt = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    color: "text.primary"
  }
}, sYt = ({
  variable: e,
  value: t,
  values: i,
  onChange: n
}) => {
  const {
    checked: g,
    onBooleanChange: r
  } = Cf(n, t, i);
  return /* @__PURE__ */ p(fe, { component: "div", sx: lYt.container, children: /* @__PURE__ */ p(GK, { "data-cy": `variableCheck-${e == null ? void 0 : e.label}`, checked: g, onChange: r, label: e == null ? void 0 : e.label }) });
}, aYt = ({
  invalidOption: e
}) => {
  const t = un(), i = _(xGe(e.conflicts));
  return /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(Ne, { children: t("translation_warning_invalid_selection") }),
    /* @__PURE__ */ p(fe, { component: "div", sx: {
      margin: 2
    }, children: i.map((n) => /* @__PURE__ */ ge(Ne, { children: [
      /* @__PURE__ */ ge("b", { children: [
        n == null ? void 0 : n.variable,
        ":"
      ] }),
      " ",
      n == null ? void 0 : n.value
    ] }, n == null ? void 0 : n.variable)) }),
    /* @__PURE__ */ p(Ne, { children: t("translation_warning_invalid_selection_alternative") }),
    /* @__PURE__ */ p(Xl, { keys: ["translation_warning_invalid_selection", "translation_warning_invalid_selection_alternative"], display: "dialog" })
  ] });
}, cYt = ki({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        tooltipContent: {
          root: !0
        }
      }
    }
  }
})(aYt), dYt = ({
  iconSx: e,
  iconSize: t
}) => /* @__PURE__ */ p(Pj, { className: "invalidSelectionIcon", sx: e, fontSize: t ?? "medium", color: "warning" }), CYt = ki({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        icon: {
          root: !0
        }
      }
    }
  }
})(dYt), uYt = ({
  valueId: e,
  alwaysDisplay: t,
  iconSx: i,
  invalidOption: n
}) => {
  const g = _((r) => n ?? tj(e)(r));
  return g ? /* @__PURE__ */ p(Cn, { className: "invalidSelectionIconTooltip", title: /* @__PURE__ */ p(cYt, { invalidOption: g }), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(CYt, { iconSx: i }) }) }) : /* @__PURE__ */ p(Bt, { children: t });
}, AYt = ki({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        root: !0
      }
    }
  }
})(uYt), g9 = (e) => {
  const t = _(tj(e.valueId));
  return /* @__PURE__ */ p(AYt, { ...e, invalidOption: t });
}, UF = {
  tab: {
    display: "grid",
    gridTemplateRows: "min-content 1fr repeat(min-content)",
    justifyItems: "center",
    minWidth: 100,
    height: 74,
    py: 1
  },
  label: {
    maxWidth: 150
  }
}, uA = ({
  labelPosition: e = "top",
  label: t,
  icon: i = null,
  subLabel: n = null,
  price: g = null,
  showPrice: r = !1,
  variable: o,
  sx: I = {},
  ...s
}) => /* @__PURE__ */ p(mc, { ...s, "data-cy": "mobileLabelTab", sx: {
  ...UF.tab,
  ...I
}, icon: /* @__PURE__ */ ge(Bt, { children: [
  /* @__PURE__ */ ge("div", { children: [
    e === "top" ? t || " " : null,
    (o == null ? void 0 : o.info) && /* @__PURE__ */ p(N$, { variable: o, sx: {
      p: 0,
      ml: 1
    } })
  ] }),
  i || " ",
  n ? /* @__PURE__ */ p(Ne, { noWrap: !0, sx: UF.label, variant: "body1", gutterBottom: !1, children: n }) : " ",
  r && /* @__PURE__ */ p(Ne, { noWrap: !0, sx: {
    ...UF.label,
    ...g ? {} : {
      visibility: "hidden"
    }
  }, variant: "body2", gutterBottom: !1, children: g ? /* @__PURE__ */ p("i", { children: `${g}€` }) : "M" }),
  /* @__PURE__ */ p(zO, { in: s.selected, children: /* @__PURE__ */ p(fe, { component: "div", sx: {
    backgroundColor: (a) => a.palette.secondary.main,
    position: "absolute",
    bottom: 3,
    width: 30,
    height: 3
  } }) })
] }), label: e === "bottom" ? t : void 0 }), bYt = {
  colorPreview: {
    width: 22,
    height: 22,
    borderRadius: "100%"
  }
}, vne = ({
  color: e,
  label: t,
  value: i,
  ...n
}) => /* @__PURE__ */ p(uA, { ...n, value: i, icon: /* @__PURE__ */ ge(fe, { component: "div", sx: {
  display: "flex",
  flexDirection: "row"
}, children: [
  /* @__PURE__ */ p(fe, { component: "div", sx: {
    ...bYt.colorPreview,
    backgroundColor: e,
    border: "1px solid black"
  } }),
  /* @__PURE__ */ p(g9, { iconSx: {
    marginLeft: 1
  }, valueId: i })
] }), label: t }), mYt = ({
  variableValue: e,
  showPrice: t,
  ...i
}) => /* @__PURE__ */ p(vne, { ...i, value: e.id, color: e.value, label: e == null ? void 0 : e.label, price: e == null ? void 0 : e.price, showPrice: t }), PF = {
  tabRoot: {
    height: 1,
    alignItems: "center",
    position: "relative"
  },
  coloredTabRoot: {
    backgroundColor: "primary.main",
    color: "primary.contrastText"
  },
  selectedTab: {
    backgroundColor: "background.default",
    color: "primary.main"
  }
}, hYt = ye((e) => /* @__PURE__ */ p(I1, { ...e, TabIndicatorProps: {
  children: /* @__PURE__ */ p("span", { className: "MuiTabs-indicatorSpan" })
} }))(({
  theme: e
}) => ({
  "& .MuiTabs-indicator": {
    // display: 'flex',
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 10
  },
  "& .MuiTabs-indicatorSpan": {
    height: 3,
    maxWidth: 40,
    width: "100%",
    backgroundColor: e.palette.secondary.main
  },
  "& .MuiTabs-scrollButtons": {
    height: "100%"
  }
})), r9 = function({
  value: e = 0,
  values: t = [],
  onChange: i,
  onRenderTab: n,
  variant: g = "scrollable",
  color: r,
  height: o = 74,
  children: I = null
}) {
  const s = (a, d) => {
    i(d);
  };
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    height: o,
    ...r ? PF.coloredTabRoot : {}
  }, children: /* @__PURE__ */ ge(hYt, { "data-cy": "mobileSelectTabs", sx: PF.tabRoot, value: e, onChange: s, variant: g, scrollButtons: !0, allowScrollButtonsMobile: !0, textColor: r ? "inherit" : void 0, children: [
    n ? me.flow(me.map(n), me.compact)(t) : t.map((a) => /* @__PURE__ */ p(mc, { sx: {
      ...e === a.id ? PF.selectedTab : {},
      height: o
    }, label: /* @__PURE__ */ p(Ne, { variant: "body1", children: a == null ? void 0 : a.label }), value: a.id, "data-cy": "mobileSelectTab-" + (a == null ? void 0 : a.label) }, a.id)),
    I || null
  ] }) });
}, pYt = me.some(me.get("Price")), BYt = ({
  variable: e,
  value: t,
  values: i,
  onChange: n
}) => /* @__PURE__ */ p(r9, { value: t == null ? void 0 : t.id, values: i, onChange: (g) => n(+g), onRenderTab: (g) => /* @__PURE__ */ p(mYt, { variable: e, "data-cy": `color-${g.label}`, value: g.id, variableValue: g, showPrice: pYt(i) }, g.id), variant: (i == null ? void 0 : i.length) < 5 ? "fullWidth" : "scrollable" }, e.id), zF = {
  tabRoot: {
    height: 1,
    alignItems: "center"
  },
  coloredTabRoot: {
    backgroundColor: "primary.main",
    color: "primary.contrastText"
  },
  selectedTab: {
    backgroundColor: "background.default",
    color: "black"
  }
}, ZYt = ye((e) => /* @__PURE__ */ p(I1, { ...e, TabIndicatorProps: {
  children: /* @__PURE__ */ p("span", { className: "MuiTabs-indicatorSpan" })
} }))(({
  theme: e
}) => ({
  "& .MuiTabs-indicator": {
    // display: 'flex',
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 10
  },
  "& .MuiTabs-indicatorSpan": {
    height: 3,
    maxWidth: 40,
    width: "100%",
    backgroundColor: e.palette.secondary.main
  }
})), fYt = function({
  value: e = 0,
  valuesAndSelections: t = [],
  onChange: i,
  onRenderTab: n,
  variant: g = "scrollable",
  color: r,
  height: o = 74,
  children: I = null
}) {
  const s = (a, d) => {
    i(d);
  };
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    height: o,
    ...r ? zF.coloredTabRoot : {}
  }, children: /* @__PURE__ */ ge(ZYt, { "data-cy": "mobileComponentTabs", sx: zF.tabRoot, value: e, onChange: s, variant: g, scrollButtons: !1, allowScrollButtonsMobile: !0, textColor: r ? "inherit" : void 0, children: [
    n ? me.flow(me.map(n), me.compact)(t) : t.map((a) => {
      var d;
      return /* @__PURE__ */ p(mc, { sx: {
        ...e === a.selection.id ? zF.selectedTab : {},
        height: o
      }, label: /* @__PURE__ */ ge(Ne, { variant: "body1", children: [
        (d = a.value) == null ? void 0 : d.label,
        " "
      ] }), value: a.selection.id }, a.selection.id);
    }),
    I || null
  ] }) });
}, GYt = (e) => {
  var t;
  return /* @__PURE__ */ p(mc, { label: /* @__PURE__ */ ge(Ne, { variant: "body1", children: [
    (t = e.value) == null ? void 0 : t.label,
    " "
  ] }), value: e.selection.id }, e.selection.id);
}, yYt = (e) => {
  const {
    t
  } = ii(), i = zt(), [n, g] = Se.useState(!1), r = e.values, o = cA(e.contextInstance, e.variable, !0), I = (u) => {
    var A;
    if (u !== "ADD") {
      const m = (A = o.find((h) => h.selection.id === u)) == null ? void 0 : A.selection;
      m && (i(cot(m)), i(JD(void 0)), i(l2(m)));
    }
  }, s = () => {
    g(!0);
  }, a = () => {
    g(!1);
  }, d = _((u) => of(u, e.variable.id)), C = (u) => {
    const A = r.find((m) => m.id === u.id);
    A && e.contextInstance && (i(sA(A, e.contextInstance)), a());
  };
  return /* @__PURE__ */ ge(fe, { component: "div", children: [
    /* @__PURE__ */ p(fYt, { value: !1, valuesAndSelections: o, onChange: I, onRenderTab: GYt, children: !d && /* @__PURE__ */ p(mc, { label: /* @__PURE__ */ p(Si, { "data-cy": "addComponent", onClick: s, variant: "outlined", endIcon: /* @__PURE__ */ p(AE, {}), children: t("Hinzufügen") }), value: "ADD" }, "ADD") }),
    /* @__PURE__ */ ge(Yd, { disableEscapeKeyDown: !0, open: n, onClose: a, children: [
      /* @__PURE__ */ p(Dd, { children: t("Welches Teil soll hinzugefügt werden?") }),
      /* @__PURE__ */ p(xd, { children: /* @__PURE__ */ p(PB, { children: r.map((u, A) => /* @__PURE__ */ p(oD, { disablePadding: !0, onClick: () => C(u), children: /* @__PURE__ */ p(rD, { children: /* @__PURE__ */ p(ID, { primary: u.label }) }) }, A)) }) })
    ] })
  ] });
}, WYt = ({
  variable: e,
  onChange: t,
  selection: i,
  values: n
}) => {
  var I, s;
  const g = _(Vs), r = ft(() => {
    t(null);
  }, [t]), o = ft((a) => {
    const d = n.find((C) => C.variableId == e.id && C.value == (a.length ? "1" : "0"));
    t(d.id, {
      url: a,
      leftright: 50,
      topbottom: 50,
      scale: 75
    });
  }, [t, n, e]);
  return /* @__PURE__ */ p(WJ, { storeLocally: !0, url: ((I = i == null ? void 0 : i.data) == null ? void 0 : I.url) || "", app: g, onDelete: r, onUrlChange: o, acceptedImageFormats: (s = e.settings.templateOptions.fileFormat) == null ? void 0 : s.split(",").map((a) => a.toLowerCase()), mobile: !0, "data-cy": "mobileImageUpload" });
}, Ko = {
  tab: {
    height: 74,
    py: 1
  },
  layoutAll: {
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content) minmax(0, 1fr) minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    gridTemplateAreas: `
          "Thumbnail Label Price"
          "Thumbnail Description Description"
          "Thumbnail Url Url"
    `
  },
  layoutThumbOnly: {
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    gridTemplateAreas: `
          "Thumbnail"
          "Label"
    `
  },
  layoutLabelPrice: {
    display: "grid",
    gridTemplateColumns: "minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    justifyItems: "center",
    gridTemplateAreas: `
          "Label"
          "Price"
          "Url"
    `
  },
  layoutLabelPriceDescription: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, max-content)",
    gridTemplateRows: "minmax(0, min-content) minmax(0, min-content)",
    gridColumnGap: "2px",
    gridTemplateAreas: `
          "Label Price"
          "Description Description"
          "Url Url"
    `
  },
  label: {
    maxWidth: 150
  },
  tabIndicator: {
    backgroundColor: (e) => e.palette.secondary.main,
    position: "absolute",
    bottom: 3,
    width: 30,
    height: 3
  },
  gridAreaThumbnail: {
    gridArea: "Thumbnail",
    width: "75px",
    height: "75px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  gridAreaThumbnailOnly: {
    gridArea: "Thumbnail",
    width: "75px",
    height: "50px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  gridAreaLabel: {
    gridArea: "Label",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    height: "100%"
  },
  gridAreaDescription: {
    gridArea: "Description",
    whiteSpace: "break-spaces",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  },
  gridAreaUrl: {
    gridArea: "Url",
    display: "flex",
    justifyContent: "center"
  },
  gridAreaPrice: {
    gridArea: "Price",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  gridAreaInfo: {
    gridArea: "Info",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }
}, SYt = ({
  label: e,
  sx: t = {},
  templateOptions: i,
  variableValue: n,
  ...g
}) => {
  const r = _(Wa), {
    showLabel: o,
    showPrice: I,
    showDescription: s,
    showUrl: a,
    showThumbnail: d
  } = i, C = o && d && !s && !I;
  let u = Ko.layoutAll;
  return o && I && s && d ? u = Ko.layoutAll : C ? u = Ko.layoutThumbOnly : o && I && s ? u = Ko.layoutLabelPriceDescription : o && I && (u = Ko.layoutLabelPrice), /* @__PURE__ */ p(mc, { ...g, sx: kV(Ko.tab, t), icon: /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ ge(fe, { component: "div", sx: u, children: [
      (i == null ? void 0 : i.showThumbnail) && /* @__PURE__ */ p(fe, { component: "div", sx: C ? Ko.gridAreaThumbnailOnly : Ko.gridAreaThumbnail, children: /* @__PURE__ */ p(R$, { url: n.thumbnail }) }),
      (i == null ? void 0 : i.showLabel) && /* @__PURE__ */ ge(fe, { component: "div", sx: Ko.gridAreaLabel, children: [
        /* @__PURE__ */ p(Ne, { variant: "body1", noWrap: !0, children: n.label }),
        /* @__PURE__ */ p(g9, { valueId: n.id, alwaysDisplay: g.icon, iconSx: {
          marginLeft: 1
        } })
      ] }),
      (i == null ? void 0 : i.showDescription) && /* @__PURE__ */ p(fe, { component: "div", sx: a ? kV(Ko.gridAreaDescription, {
        WebkitLineClamp: "1"
      }) : Ko.gridAreaDescription, children: /* @__PURE__ */ p(Ne, { variant: "body2", children: n.description }) }),
      (i == null ? void 0 : i.showUrl) && /* @__PURE__ */ p(fe, { component: "div", sx: Ko.gridAreaUrl, children: /* @__PURE__ */ p(as, { "data-cy": "mobileLink", align: "center", variant: "caption", href: n.url, target: "_blank", children: n.url }) }),
      (i == null ? void 0 : i.showPrice) && /* @__PURE__ */ p(fe, { component: "div", sx: Ko.gridAreaPrice, children: /* @__PURE__ */ p(Ne, { variant: "body2", children: r.format(n.price) }) })
    ] }),
    /* @__PURE__ */ p(zO, { in: g.selected, children: /* @__PURE__ */ p(fe, { component: "div", sx: Ko.tabIndicator }) })
  ] }) });
}, VYt = ({
  variable: e,
  variableValue: t,
  ...i
}) => /* @__PURE__ */ p(SYt, { ...i, templateOptions: hi(e), variableValue: t, label: /* @__PURE__ */ p(Bt, { children: t == null ? void 0 : t.label }), icon: /* @__PURE__ */ p(g9, { valueId: t.id, alwaysDisplay: i.icon }) }), wYt = ({
  variable: e,
  onChange: t,
  values: i
}) => {
  const n = Li(), g = _(N1(e == null ? void 0 : e.id, n));
  if (!g)
    return null;
  const r = (o) => (I) => /* @__PURE__ */ p(VYt, { value: I.id, variable: o, variableValue: I }, I.id);
  return /* @__PURE__ */ p(r9, { value: g == null ? void 0 : g.id, values: i, onChange: (o) => t(+o), onRenderTab: r(e) }, e.id);
}, fz = {
  root: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    width: 1,
    height: 1
  },
  checkBoxContainer: {
    minWidth: 100,
    display: "grid",
    gridTemplateColumns: "min-content 1fr",
    justifyItems: "stretch",
    alignItems: "center",
    padding: 1
  }
}, vYt = ({
  variable: e
}) => {
  zt();
  const t = _(lh(e == null ? void 0 : e.id));
  return _(_u(e == null ? void 0 : e.id)), /* @__PURE__ */ p(fe, { component: "div", sx: fz.root, children: ce.map(t, (i) => (
    // TODO: Check auch hier!
    /* @__PURE__ */ ge(fe, { component: "div", sx: fz.checkBoxContainer, children: [
      /* @__PURE__ */ p(qm, { checked: (
        /* includes(selectedValues, v.id) */
        !0
      ), "data-cy": "mobileMulti" }),
      /* @__PURE__ */ p(Ne, { variant: "body1", children: i.label })
    ] }, i.id)
  )) });
}, RYt = {
  root: {
    p: 1
  }
}, XYt = ({
  variable: e,
  values: t,
  onChange: i,
  selection: n
}) => {
  const {
    onNumberChange: g,
    onInputBlur: r,
    isInRange: o,
    resetNumber: I,
    pureNumber: s
  } = FK(i, n, e, t);
  return /* @__PURE__ */ p(fe, { component: "div", sx: RYt.root, children: /* @__PURE__ */ p(kK, { placement: "top", isInRange: o, resetNumber: I, variable: e, children: /* @__PURE__ */ p(
    z1,
    {
      "data-cy": "numberInput",
      fullWidth: !0,
      value: s,
      onChange: g,
      onChangeByStep: r,
      debounced: !0,
      debounceTimeMs: 100,
      TextFieldProps: {
        error: !o
      },
      onBlur: r,
      ...me.flow(hi, me.omit(["min", "max"]))(e)
    }
  ) }) });
}, HYt = no("number")(XYt), kYt = {
  root: {
    padding: 1
  }
}, FYt = ({
  type: e = "text",
  ...t
}) => {
  const {
    text: i,
    onChange: n
  } = pf(t), {
    selection: g,
    variable: r
  } = t;
  return /* @__PURE__ */ p(fe, { component: "div", sx: kYt.root, children: /* @__PURE__ */ p($n, { "data-cy": `mobileText-${r == null ? void 0 : r.label}`, multiline: Jfe(r), TextFieldProps: {
    InputLabelProps: {
      shrink: !!g
    }
  }, label: r == null ? void 0 : r.label, minRows: 2, value: i, type: e, onChange: n, fullWidth: !0 }) });
};
function YYt(e) {
  switch (e == null ? void 0 : e.type) {
    case Bn.Color:
      return BYt;
    case Bn.Boolean:
      return sYt;
    case Bn.Text:
      return FYt;
    case Bn.Number:
      return HYt;
    case Bn.Components:
      return yYt;
    case Bn.List:
      return wYt;
    case Bn.MultiSelect:
      return vYt;
    case Bn.Image:
      return WYt;
    default:
      return () => null;
  }
}
const xYt = () => {
  const e = _(oh), {
    ruleEngineInput: t
  } = e, i = _(kj), n = Li(), g = t == null ? void 0 : t.variables.byVarId.all[i];
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    transition: "all 0.3s",
    height: g ? 74 : 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, "data-cy": "valuesView", children: g && /* @__PURE__ */ p(DYt, { variable: g, contextInstance: n }) });
}, DYt = ({
  variable: e,
  contextInstance: t
}) => {
  const i = h2(t), n = YYt(e), g = Bf(e, t);
  return /* @__PURE__ */ p(n, { onChange: i(e), ...g }, e == null ? void 0 : e.id);
};
var o9 = {}, JYt = Cg;
Object.defineProperty(o9, "__esModule", {
  value: !0
});
var Rne = o9.default = void 0, KYt = JYt(Kg()), EYt = xg;
Rne = o9.default = (0, KYt.default)(/* @__PURE__ */ (0, EYt.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
const NYt = (e) => {
  const {
    variable: t
  } = e, i = Li(), n = _(N1(t == null ? void 0 : t.id, i)), g = _(lh(t == null ? void 0 : t.id)), r = h2()(t), {
    checked: o
  } = Cf(r, n, g);
  return /* @__PURE__ */ p(uA, { ...e, icon: o ? g.length > 0 && g[0].label ? /* @__PURE__ */ p(Ne, { sx: {
    color: "primary.main"
  }, children: g[0].label }) : /* @__PURE__ */ p(Rne, { sx: {
    color: "primary.main"
  } }) : g.length > 1 && g[1].label ? /* @__PURE__ */ p(Ne, { sx: {
    color: "primary.main"
  }, children: g[1].label }) : /* @__PURE__ */ p(yh, {}), label: t == null ? void 0 : t.label });
}, iv = (e) => {
  const t = hi(e), n = _(kGe(e.id)).length || 0;
  let g = !1;
  (t != null && t.hideIfNoOptions && n === 0 || t != null && t.hideIfSingleOption && n <= 1) && (g = !0);
  const r = (t == null ? void 0 : t.disableIfSingleOption) && n <= 1;
  return {
    hide: g,
    disabled: r
  };
}, LYt = (e) => {
  const {
    variable: t
  } = e, i = Li(), n = _(N1(t == null ? void 0 : t.id, i)), {
    disabled: g,
    hide: r
  } = iv(t);
  return r ? null : /* @__PURE__ */ p(vne, { ...e, disabled: g, color: n == null ? void 0 : n.value, label: t == null ? void 0 : t.label });
}, TYt = (e) => {
  const {
    variable: t
  } = e, i = _(Aje(t.id)), {
    t: n
  } = ii(), g = me.flow(me.map((I) => I.label), me.join(", "))(i.map((I) => I.value)), {
    disabled: r,
    hide: o
  } = iv(t);
  return o ? null : /* @__PURE__ */ p(uA, { ...e, disabled: r, subLabel: /* @__PURE__ */ p(Ne, { component: "span", sx: {
    maxWidth: 150
  }, noWrap: !0, children: g || n("Keine Auswahl") }), label: t == null ? void 0 : t.label });
}, MYt = ({
  variable: e,
  ...t
}) => /* @__PURE__ */ p(uA, { ...t, label: e == null ? void 0 : e.label }), UYt = (e) => {
  const {
    variable: t
  } = e, i = _((r) => {
    const o = _u(t == null ? void 0 : t.id)(r);
    return ce.chain(o).map((I) => {
      var s;
      return (s = $d(I)(r)) == null ? void 0 : s.label;
    }).join(", ").value();
  }), {
    disabled: n,
    hide: g
  } = iv(t);
  return g ? null : /* @__PURE__ */ p(uA, { ...e, disabled: n, subLabel: i, label: t == null ? void 0 : t.label });
}, PYt = rI(UYt), zYt = (e) => {
  const {
    variable: t
  } = e, i = Li(), n = _(N1(t == null ? void 0 : t.id, i)), {
    disabled: g,
    hide: r
  } = iv(t);
  return r ? null : /* @__PURE__ */ p(uA, { ...e, disabled: g, subLabel: n == null ? void 0 : n.label, label: t == null ? void 0 : t.label });
}, OYt = (e) => {
  var t;
  return me.toNumber(((t = e == null ? void 0 : e.data) == null ? void 0 : t.inputValue) || 0);
}, QYt = ({
  variable: e,
  ...t
}) => {
  var g;
  const i = _(_u(e == null ? void 0 : e.id)), n = (g = hi(e)) == null ? void 0 : g.unit;
  return /* @__PURE__ */ p(uA, { ...t, subLabel: OYt(i) + (n ? " " + n : ""), label: e == null ? void 0 : e.label });
}, jYt = (e) => {
  let t;
  switch (e.type) {
    case Bn.Color: {
      t = LYt;
      break;
    }
    case Bn.Components: {
      t = TYt;
      break;
    }
    case Bn.List: {
      t = zYt;
      break;
    }
    case Bn.MultiSelect: {
      t = PYt;
      break;
    }
    case Bn.Boolean: {
      t = NYt;
      break;
    }
    case Bn.Text:
    case Bn.Number:
      t = QYt;
      break;
    default:
      t = MYt;
      break;
  }
  return /* @__PURE__ */ p(t, { value: e.id, variable: e, "data-cy": "variableTab", sx: {
    alignItems: "start"
  } }, e.id);
}, _Yt = function() {
  const e = _(kj), t = Li(), i = _((o) => fa(o, t)), n = _(W$e(i, t.id)), g = zt(), r = ft((o) => {
    g(JD(o)), g(qJ({
      type: "variable",
      id: o
    }));
  }, [g]);
  return et(() => {
    var o;
    (n == null ? void 0 : n.length) > 0 && !n.find((I) => I.id === e) && r((o = n[0]) == null ? void 0 : o.id);
  }, [n]), /* @__PURE__ */ p(r9, { value: e || !1, values: n, onChange: r, onRenderTab: jYt });
}, Xne = (e, t) => {
  const i = t ? 2 : 3, n = je(() => /* @__PURE__ */ p(uFt, { app: e }), [e]);
  return {
    components: je(() => ({
      // reworked
      SceneView: () => n,
      StandaloneGroupWrapper: EFt,
      GroupsNavigation: Dx,
      GroupsView: FB,
      // use mui components
      ...k$,
      ...NFt(i),
      CustomLayoutComponent: UFt,
      CustomData: LFt,
      StandaloneVariable: dut,
      ComponentBreadcrumbs: Qee,
      EditScene: jFt,
      //tools
      SwitchState: i9,
      SwitchStateOn: SFt,
      SwitchStateOff: VFt,
      SwitchButton: WFt,
      TranslatableText: Gc,
      HoverContent: ZFt,
      // has wrapper
      Price: Pst,
      PriceData: pK,
      PriceDataFromVariable: zst,
      ActionOverview: QXt,
      ExitButtons: hFt,
      Logo: () => /* @__PURE__ */ p(HFt, { app: e }),
      SocialShareButtons: KFt,
      SceneButtons: ({
        children: r
      }) => /* @__PURE__ */ p(xFt, { mobile: t, children: r }),
      FullScreenButton: one,
      ARButton: o$,
      NavigationButtons: C0t,
      OcBranding: $Xt,
      LabelActionsDisplay: H$,
      // deprecated
      Header: Dx,
      Sidebar: FB,
      Content: () => n,
      VariablesNavigation: _Yt,
      ValuesView: xYt
    }), [n, e, t, i]),
    Content: n
  };
}, $Yt = (e) => {
  var o, I, s;
  const t = e.isMobile ? "phone" : "desktop", i = Li(), n = _(P$e(t, i)), {
    components: g
  } = Xne(e.app, e.isMobile), r = (s = (I = (o = n == null ? void 0 : n.settings) == null ? void 0 : o.theme) == null ? void 0 : I[t]) == null ? void 0 : s.custom;
  return r ? /* @__PURE__ */ p(Rc, { xmlString: r, components: g, renderTarget: "group-outlet" }) : null;
}, qYt = (e) => {
  var t;
  return (t = e == null ? void 0 : e.layout) == null ? void 0 : t.design;
}, ext = (e) => x6(e) === mj.Right, txt = ({
  muiTheme: e
}) => {
  const t = (g) => e.spacing(g), i = "6px 0 4px -4px #999, -6px 0 4px -4px #999", n = "30rem";
  return [{
    id: "defaultRight",
    label: "Paginated - Rechts",
    content: `
<div style="
  height: 100%;
  display: grid;
  grid:
    'header   header     header    header'    min-content
    'top-left top-center top-right sidebar'   1fr
    'mid-left mid-center mid-right sidebar'   1fr
    'bot-left bot-center bot-right sidebar'   1fr
    / minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${n};
">
  <header style="gridArea: header;">
    <Header/>
  </header>
  <section style="gridArea: 2 / 1 / span 3 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotLeft>
</BotLeft>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: ${e.palette.background.default};
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="topmenu"></Sidebar>
    <footer style="
      position: sticky;
      bottom: 0;
      background: ${e.palette.background.default};
      display: grid;
      gap: ${t(2)};
      padding: ${t(3)}
    ">
      <LabelActionsDisplay></LabelActionsDisplay>
      <NavigationButtons></NavigationButtons>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "defaultLeft",
    label: "Paginated - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header  header   header     header'      min-content
    'sidebar top-left top-center top-right'   1fr
    'sidebar mid-left mid-center mid-right'   1fr
    'sidebar bot-left bot-center bot-right'   1fr
    / ${n} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
">
  <header style="gridArea: header;">
    <Header/>
  </header>
  <section style="gridArea: 2 / 2 / span 3 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
    <SceneButtons>
      <FullScreenButton />
    </SceneButtons>
    <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: ${e.palette.background.default};
    overflowY: scroll;
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="topmenu"></Sidebar>
    <footer style="
      position: sticky;
      bottom: 0;
      background: ${e.palette.background.default};
      display: grid;
      gap: ${t(2)};
      padding: ${t(3)}
    ">
      <LabelActionsDisplay></LabelActionsDisplay>
      <NavigationButtons></NavigationButtons>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "flyawayRight",
    label: "Flyaway - Rechts",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'top-left top-center top-right header space'   min-content
    'top-left top-center top-right sidebar space'   1fr
    'mid-left mid-center mid-right sidebar space'   1fr
    'bot-left bot-center bot-right sidebar space'   1fr
    /  minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${n} 5vw;
">
  <header style="gridArea: header; zIndex: 1;">
    <Header/>
  </header>
  <section style="gridArea: 1 / 1 / span 22 / span 22">
    <SceneView/>
  </section>
  <div style="gridArea: top-left; padding: ${t(3)};">
    <Logo/>
  </div>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    height: 60%;
    overflow: hidden;
    borderRadius: 0 0 16px 16px;
    background: #ffffff75;
    box-shadow: 0 0.28571429rem 0.28571429rem rgb(0 0 0 / 25%);
    zIndex:1;
  ">
    <div style="
      overflowY: scroll;
      position: relative;
      height: 100%;
      display: grid;
      alignContent: space-between;
    ">
      <Sidebar design="topmenu"></Sidebar>
      <footer style=" display: grid; gap: ${t(2)}; padding: ${t(3)}">
        <LabelActionsDisplay></LabelActionsDisplay>
        <NavigationButtons></NavigationButtons>
        <OcBranding></OcBranding>
      </footer>
    </div>
  </div>
</div>`
  }, {
    id: "flyaway",
    label: "Flyaway - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'space header  top-left top-center top-right'   min-content
    'space sidebar top-left top-center top-right'   1fr
    'space sidebar mid-left mid-center mid-right'   1fr
    'space sidebar bot-left bot-center bot-right'   1fr
    / 5vw ${n} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
">
  <header style="gridArea: header; zIndex: 1;">
    <Header/>
  </header>
  <section style="gridArea: 1 / 1 / span 22 / span 22">
    <SceneView/>
  </section>
  <div style="gridArea: top-left; padding: ${t(3)};">
    <Logo/>
  </div>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    height: 60%;
    overflow: hidden;
    borderRadius: 0 0 16px 16px;
    background: #ffffff75;
    box-shadow: 0 0.28571429rem 0.28571429rem rgb(0 0 0 / 25%);
    zIndex:1;
  ">
    <div style="
      height: 100%;
      position: relative;
      display: grid;
      alignContent: space-between;
    ">
      <Sidebar design="topmenu"></Sidebar>
      <footer style="position:relative; display: grid; gap: ${t(2)}; padding: ${t(3)}">
        <LabelActionsDisplay></LabelActionsDisplay>
        <NavigationButtons></NavigationButtons>
        <OcBranding></OcBranding>
      </footer>
    </div>
  </div>
</div>`
  }, {
    id: "noheaderRight",
    label: "Einfach - Rechts",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'top-left top-center top-right sidebar'   1fr
    'mid-left mid-center mid-right sidebar'   1fr
    'bot-left bot-center bot-right sidebar'   1fr
    / minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${n} ;
">
  <section style="gridArea: 1 / 1 / span 11 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: #fff;
    overflow: auto;
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="onlysidebar"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${t(2)}; padding: ${t(3)}">
      <LabelActionsDisplay></LabelActionsDisplay>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "noheaderLeft",
    label: "Einfach - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'sidebar top-left top-center top-right'   1fr
    'sidebar mid-left mid-center mid-right'   1fr
    'sidebar bot-left bot-center bot-right'   1fr
    / ${n} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
">
  <section style="gridArea: 1 / 2 / span 11 / span 11">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: #fff;
    overflow: auto;
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="onlysidebar"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${t(2)}; padding: ${t(3)}">
      <LabelActionsDisplay></LabelActionsDisplay>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "accordionRight",
    label: "Akkordeons - Rechts",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header header header header' min-content
    'top-left top-center top-right sidebar' 1fr
    'mid-left mid-center mid-right sidebar' 1fr
    'bot-left bot-center bot-right sidebar' 1fr
    / minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${n};
">
  <section style="gridArea: 2 / 1 / span 3 / span 3">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: #fff;
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="accordion"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${t(2)}; padding: ${t(3)}">
      <LabelActionsDisplay/>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "accordionLeft",
    label: "Akkordeons - Links",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header header header header' min-content
    'sidebar top-left top-center top-right ' 1fr
    'sidebar mid-left mid-center mid-right ' 1fr
    'sidebar bot-left bot-center bot-right ' 1fr
    / ${n} minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ;
">
  <section style="gridArea: 1 / 2 / span 11 / span 11">
    <SceneView/>
  </section>
  <TopLeft>
    <Logo/>
  </TopLeft>
  <TopCenter>
    <EditScene/>
  </TopCenter>
  <TopRight>
      <SceneButtons>
        <FullScreenButton />
      </SceneButtons>
      <SocialShareButtons/>
  </TopRight>
  <BotRight gap="8px">
    <Price/>
    <ExitButtons/>
  </BotRight>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: #fff;
    overflowY: scroll;
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="accordion"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${t(2)}; padding: ${t(3)}">
      <LabelActionsDisplay/>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }, {
    id: "noviz",
    label: "Fullscreen Formular",
    content: `
<div style="
  height: 100%;
  display:grid;
  grid:
    'header' min-content
    'sidebar' 1fr
    'sidebar' 1fr
    'sidebar' 1fr
    / 1fr;
">
  <header style="gridArea: header;">
    <Header/>
  </header>
  <div style="
    gridArea: sidebar;
    position: relative;
    background: #fff;
    overflow: auto;
    zIndex:1;
    box-shadow: ${i};
    display: grid;
    alignContent: space-between;
  ">
    <Sidebar design="topmenu"/>
    <footer style="position: sticky; bottom: 0; background: #fff; display: grid; gap: ${t(2)}; padding: ${t(3)}">
      <LabelActionsDisplay/>
      <NavigationButtons/>
      <OcBranding></OcBranding>
    </footer>
  </div>
</div>`
  }];
}, ixt = ({
  _muiTheme: e
}) => [{
  id: "mobileDefault",
  label: "Deprecated Mobile UI",
  hidden: !0,
  content: `<div style="
  display: grid;
  height: 100%;
  overflow: hidden;
  pointer-events: all;
  grid:
    'top-left top-center top-right'   2fr
    'mid-left mid-center mid-right'   2fr
    'bot-left bot-center bot-right'   2fr
    'groups groups groups' min-content
    'variables variables variables' min-content
    'values values values' min-content
    / 1fr 1fr 1fr
">
  <section style="gridArea: 1/1/4/4">
    <SceneView/>
  </section>
  <TopRight>
    <SceneButtons  />
  </TopRight>
  <BotRight>
    <ExitButtons />
  </BotRight>
  <BotLeft>
    <Price />
  </BotLeft>
  <div style="gridArea: groups;">
    <GroupsNavigation />
  </div>
  <div style="gridArea: variables;">
    <VariablesNavigation />
  </div>
  <div style="gridArea: values;">
    <ValuesView />
  </div>
</div>`
}, {
  id: "mobileScrollable",
  label: "Default Mobile",
  content: `<div id="content" style="
      display: grid;
      height: 100%;
      width:100%;
      overflow: hidden;
      pointer-events: all;
      grid:
        'top'   2fr
        'mid'   min-content
        'bot'   50%
        / 100%
    ">
      <section style="gridArea: 1 / 1 / 3 / 1;">
        <SceneView/>
      </section>
      <div style="gridArea:top; width: fit-content;
      flex-grow:1;
    height: fit-content;
    margin: 6px;
    margin-right: 6px;
    margin-left: auto;">
        <SceneButtons  />
      </div>
      <div style="gridArea:mid; display: flex; width: min-content;
    flex-flow: wrap;
    background-color: transparent;
    justify-content: space-between;
    gap: 6px;
    margin: 6px;
    z-index: 10;
    flex-wrap: wrap;
    align-items: flex-end;">
        <Price />
        <ExitButtons />
      </div>
      <div style="gridArea: bot; display:flex; flex-direction:column-reverse; position:relative">
        <div style="position: relative;">
          <OcBranding></OcBranding>
        </div>
        <Sidebar design="topmenu" style="margin:0; z-index:2; min-width:unset !important;"></Sidebar>
        <GroupsNavigation style="z-index:100; position:absolute"/>

      </div>
      <style>
        #content .MuiPaper-elevation0 {
        background-color:unset;
        }
        #content *::-webkit-scrollbar {
        height:5px;
        }
        </style>
    </div>`
}], nxt = ({
  app: e,
  isMobile: t
}) => {
  const i = ev(), n = t ? ixt({
    muiTheme: i
  }) : txt({
    muiTheme: i
  }), {
    components: g,
    Content: r
  } = Xne(e, t), o = je(() => ({
    ...g,
    GroupOutlet: $Yt
  }), [g]), I = je(() => {
    if (!e)
      return null;
    const d = t ? e.settings.themeMobile : e.settings.theme, C = d != null && d.selected ? (
      // @ts-ignore
      (n.find((u) => u.id == d.selected) || n[0]).content
    ) : (d == null ? void 0 : d.custom) || n[0].content;
    return /* @__PURE__ */ p(Rc, { xmlString: C, components: o, renderTarget: "layout-editor" });
  }, [e, o, t, n]);
  if (!e)
    return null;
  if (e.settings.theme)
    return I;
  const s = qYt(e), a = ext(e);
  return /* @__PURE__ */ ge(Bt, { children: [
    s === Gk.accordion && /* @__PURE__ */ p(OXt, { content: r, sidebar: /* @__PURE__ */ p(FB, { design: s }), sidebarRight: a }),
    s === Gk.topmenu && /* @__PURE__ */ p(nz, { header: /* @__PURE__ */ p(Dx, {}), content: r, sidebar: /* @__PURE__ */ p(FB, { design: s }), sidebarRight: a }),
    s === Gk.onlysidebar && /* @__PURE__ */ p(nz, { content: r, sidebar: /* @__PURE__ */ p(FB, { design: s }), sidebarRight: a })
  ] });
}, gxt = ki({
  app: {
    root: !0
  }
})(nxt), rxt = () => function(t) {
  const {
    t: i
  } = ii(), n = $It();
  if (t.design == "topmenu" && t.placement != "topmenu")
    return;
  const g = (r) => t.isRootHeader ? /* @__PURE__ */ p(mi, { ...r }) : /* @__PURE__ */ p(Si, { ...r });
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    px: 3,
    my: 1,
    marginY: "auto"
  }, children: /* @__PURE__ */ p(Cn, { title: i("Neuen Schritt hinzufügen"), children: /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
    g,
    {
      component: S5,
      color: "editor",
      to: "groups/create" + (n != null && n.parentId && t.isRootHeader ? `/${n == null ? void 0 : n.parentId}` : ""),
      "data-cy": "newGroup",
      variant: "contained",
      startIcon: !t.isRootHeader && /* @__PURE__ */ p(YY, {}),
      children: t.isRootHeader ? /* @__PURE__ */ p(YY, {}) : /* @__PURE__ */ p("span", { style: {
        lineHeight: "25px"
      }, children: i("Schritt") })
    }
  ) }) }) });
}, oxt = () => function({
  group: t
}) {
  const {
    t: i
  } = ii(), n = _(to), g = Li().variableId;
  return /* @__PURE__ */ p(fe, { component: "div", sx: {
    px: 3,
    my: 1
  }, children: n.length > 0 ? /* @__PURE__ */ p(Si, { color: "editor", "data-cy": "newVariable", component: S5, to: `variables/create/${t.id}/${g}`, variant: "contained", startIcon: /* @__PURE__ */ p(YY, {}), children: /* @__PURE__ */ p("span", { style: {
    lineHeight: "25px"
  }, children: i("Merkmal") }) }) : /* @__PURE__ */ p(Ne, { children: i("Bitte legen Sie einen Schritt an!") }) });
}, Ixt = (e) => (t) => {
  t(Tet(e));
}, lxt = R2({
  container: {
    display: "grid",
    alignItems: "center",
    gridAutoColumns: "min-content",
    gridAutoFlow: "column"
  },
  icon: {
    cursor: "pointer",
    fontSize: "1.25em"
  },
  useContrastTextColor: {
    color: (e) => e.palette.primary.contrastText
  },
  label: {
    whiteSpace: "nowrap"
  }
}), sxt = (e) => function(i) {
  const n = ha(), g = +y5().appId, {
    t: r
  } = ii(), o = zt(), I = ft(() => {
    o(Ixt(i.group)), n(`/admin/apps/${g}/edit/configurator/groups/${i.group.id}`);
  }, [g, o, n, i.group]);
  return /* @__PURE__ */ ge(fe, { component: "span", sx: lxt.container, children: [
    /* @__PURE__ */ p(e, { ...i }),
    /* @__PURE__ */ p(tf, { "data-cy": "editGroup", tooltip: r("Schritt editieren"), onClick: I, colorVariant: i.useDefaultEditorUi ? "main" : "contrastText" })
  ] });
}, axt = (e) => async (t, i) => {
  const n = i(), g = ng(n);
  return t(iIt(e)), await Ket("variable", e, {
    lang: g
  }), e;
}, cxt = (e, t) => async (i, n) => {
  const g = n();
  let r = AJ(g, e.groupId);
  return r = YQ(r, e, t), i(axt(r));
}, dxt = (e) => function(i) {
  const n = zt(), g = oK(), r = _(wg);
  return /* @__PURE__ */ p(e, { ...i, onDragEnd: (I) => {
    const s = parseInt(I.draggableId), a = r.find((d) => d.id == s);
    n(cxt(a, I.destination.index - I.source.index)).catch(g);
  } });
}, Cxt = (e) => async (t, i) => {
  const n = i(), g = ng(n);
  return t(Tot(e)), Q1("group", e, {
    lang: g
  });
}, uxt = (e, t) => async (i, n) => {
  var I;
  const g = n(), r = (I = to(g)) == null ? void 0 : I.filter((s) => s.parentId == (e == null ? void 0 : e.parentId)), o = YQ(r, e, t);
  i(Mot(o)), aye(async () => await Promise.all(o.map((s) => i(Cxt(s)))));
}, Axt = (e) => function(i) {
  const n = zt(), g = oK(), r = _(to);
  return /* @__PURE__ */ p(e, { ...i, onDragEnd: (I) => {
    const s = parseInt(I.draggableId), a = r.find((d) => d.id == s);
    n(uxt(a, I.destination.index - I.source.index)).catch(g);
  } });
}, bxt = (e) => function(i) {
  const {
    t: n
  } = ii(), g = ha();
  return /* @__PURE__ */ ge(fe, { component: "div", sx: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ p(e, { ...i }),
    /* @__PURE__ */ p(fe, { component: "div", sx: {
      marginLeft: 1
    }, children: /* @__PURE__ */ p(tf, { tooltip: n("Bestelloptionen"), onClick: () => g("order"), "data-cy": "editPrice" }) })
  ] });
}, mxt = {
  container: {
    width: 1,
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "1fr min-content",
    gridAutoFlow: "column"
  },
  icon: {
    cursor: "pointer",
    fontSize: "1.25em"
  }
}, hxt = (e) => function({
  variable: i,
  children: n
}) {
  const g = ha(), {
    t: r
  } = ii(), o = +y5().appId, I = Hn(zee);
  return /* @__PURE__ */ ge(fe, { component: "div", sx: mxt.container, children: [
    /* @__PURE__ */ p(e, { variable: i, children: n }),
    /* @__PURE__ */ p(tf, { "data-cy": "editVariable", tooltip: r("Merkmal editieren"), onClick: () => {
      g(`/admin/apps/${o}/edit/configurator/variables/${i.id}/options`);
    } }),
    I
  ] });
}, pxt = {
  extendGroupLabel: sxt,
  extendAdditionalGroups: rxt,
  extendVariableLabel: hxt,
  extendAdditionalVars: oxt,
  extendHeader: Axt,
  extendGroupPanel: dxt,
  app: {
    exitButtons: {
      root: bxt
    }
  }
}, Hne = (e, t) => {
  const i = {
    ...t
  };
  return Object.entries(t).forEach(([n, g]) => {
    if (pc(g)) {
      const r = e == null ? void 0 : e[n];
      if (!pc(r))
        return;
      i[n] = Hne(r, g);
    } else {
      const r = e == null ? void 0 : e[n];
      if (r) {
        const o = g;
        i[n] = Zxt(o, r);
      }
    }
  }), i;
}, Bxt = (e) => Hne(e, pxt), Zxt = (e, t) => (i) => (n) => {
  const g = je(() => e(t(i)), [e, t, i]);
  return /* @__PURE__ */ p(g, { ...n });
}, fxt = () => {
  const e = zt(), t = _(Qd), i = _(wg), n = _(ch), g = _(tI), r = _(ya), o = _(EZ);
  et(() => {
    e($J());
  }, [e, g, i, t, r, o, n]);
}, kne = ({
  messageKey: e,
  onClose: t
}) => /* @__PURE__ */ p(mi, { size: "small", "aria-label": "Close", color: "inherit", "data-cy": "close-snackbar", onClick: () => {
  yJ(e), t == null || t();
}, children: /* @__PURE__ */ p(yh, { fontSize: "small" }) }), Gxt = (e) => {
  const {
    enqueueSnackbar: t,
    closeSnackbar: i
  } = vqe();
  return et(() => {
    e.open ? t(e.message ? /* @__PURE__ */ p(Ne, { children: e.message }) : e.children, {
      variant: e.variant,
      autoHideDuration: e.autoHideDuration || null,
      preventDuplicate: e.preventDuplicate || !0,
      key: e.messageKey,
      action: (n) => /* @__PURE__ */ ge(Bt, { children: [
        e.action,
        e.canClose && /* @__PURE__ */ p(kne, { messageKey: n, onClose: () => {
          var g;
          return (g = e.onClose) == null ? void 0 : g.call(e);
        } })
      ] })
    }) : i(e.messageKey);
  }, [e.open]), /* @__PURE__ */ p(Bt, {});
}, yxt = (e) => {
  fxt();
  const t = _(Jg), i = _(DGe), n = /* @__PURE__ */ ge(Bt, { children: [
    /* @__PURE__ */ p(dat, {}),
    e.children
  ] });
  return !t && !i ? null : i ? /* @__PURE__ */ ge(fe, { component: "div", sx: {
    border: "4px solid red",
    borderColor: "error.main",
    boxSizing: "border-box",
    height: 1,
    width: 1
  }, children: [
    /* @__PURE__ */ p(Gxt, { messageKey: i, open: !!i, variant: "error", canClose: !0, children: /* @__PURE__ */ ge(fe, { component: "div", sx: {
      display: "flex",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ p(Tj, { sx: {
        mr: 1
      }, color: "error" }),
      /* @__PURE__ */ p(Ne, { sx: {
        fontWeight: "bold"
      }, children: i })
    ] }) }),
    n
  ] }) : /* @__PURE__ */ p(Bt, { children: n });
}, Wxt = (e) => {
  const t = document.querySelector('[data-link="custom-css"]'), i = e;
  if (t)
    t.setAttribute("href", i);
  else {
    const n = document.head || document.getElementsByTagName("head")[0], g = document.createElement("link");
    g.setAttribute("data-link", "custom-css"), g.setAttribute("rel", "stylesheet"), g.setAttribute("href", i), n.appendChild(g);
  }
}, Sxt = () => {
  const e = _(Ai);
  et(() => {
    var t, i;
    Wxt(((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.ext) == null ? void 0 : i.css) || "");
  }, [e]);
}, Vxt = ({
  app: e,
  mobile: t
}) => {
  Sxt();
  const i = N4("(min-width: 0) and (max-width: 480px)"), n = zt(), g = Li(), r = _((C) => fa(C, g)), o = _(Ba(r)), I = _(hr), s = je(() => t || i, [t, i]), a = _(rh), d = _((C) => C.configurator.popupAction);
  return /* @__PURE__ */ p(aK.Provider, { value: a, children: /* @__PURE__ */ p(AV, { children: /* @__PURE__ */ ge(fe, { component: "div", className: Ve("configurator", "k3-configurator", o == null ? void 0 : o.key, s ? "mobile" : "desktop", I ? "edit-mode" : "display-mode"), sx: {
    overflow: "hidden",
    height: "100%"
  }, children: [
    /* @__PURE__ */ p(PXt, {}),
    /* @__PURE__ */ p(gxt, { app: e, isMobile: s }),
    d && /* @__PURE__ */ p(nne, { open: !0, onClose: () => {
      n(K7(void 0));
    }, params: {
      title: d.action.title,
      body: d.action.body,
      invalid: d.action.invalid
    } })
  ] }) }) });
}, wxt = igt(ki({
  app: {
    configurator: {
      root: !0
    }
  }
})(Vxt)), vxt = ({
  editorUi: e,
  ...t
}) => {
  const i = OZ().extensions, n = je(() => {
    if (!e)
      return i;
    const g = {};
    return ce.merge(g, i, Bxt(i)), g;
  }, [e, i]);
  return /* @__PURE__ */ ge(yxt, { children: [
    /* @__PURE__ */ p(kIt, {}),
    /* @__PURE__ */ p(wxt, { ...t, extensions: n })
  ] });
};
function Rxt(e, t = !0, i) {
  const g = _(Hj), r = ["app", {
    id: (e == null ? void 0 : e.toString()) ?? "id",
    lang: g
  }];
  return k7(r, async ({
    queryKey: [o, {
      id: I,
      lang: s
    }]
  }) => await Jet(o, String(I), {
    lang: s
  }), {
    enabled: t
  });
}
const J9t = () => {
  const e = +y5().appId, t = Rxt(e).data, i = sj();
  if ((t == null ? void 0 : t.code) === i) {
    console.warn("Not switching bundle because no app could be found. This is most likely a race condition somewhere, but we will be forgiving here, as it is very likely that the user will be redirected correctly eventually.");
    return;
  }
  Fne(t, !1);
}, Fne = (e, t) => {
  if (!e)
    return;
  const i = X6(), n = e.type || cJ;
  if (i.currentAppType === n || // sadly we don't have multiple apps on localhost so we stay here.
  !i.host.includes(jo.originalDomain))
    return;
  const g = `${window.location.protocol}//${i.host}/${n}${t ? "" : "/#"}/${i.path}`;
  window.location.replace(g);
};
function Xxt() {
  Hxt() || document.body.classList.add("force-show-scrollbars");
}
function Hxt() {
  const e = document.createElement("div"), t = document.createElement("div");
  e.style.width = "30px", e.style.height = "30px", e.style.overflow = "scroll", e.style.borderWidth = "0", t.style.width = "30px", t.style.height = "60px", e.appendChild(t), document.body.appendChild(e);
  const i = e.offsetWidth - e.clientWidth;
  return document.body.removeChild(e), i > 0;
}
const kxt = (e) => ({
  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: `${e} transparent`
  },
  "*::-webkit-scrollbar": {
    width: "5px"
  },
  "*::-webkit-scrollbar-track": {
    backgroundColor: "transparent"
  },
  "*::-webkit-scrollbar-thumb": {
    background: `${e}`,
    borderRadius: "2px"
  },
  "*::-webkit-scrollbar-thumb:hover": {
    background: `linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1)) ${e}`
  }
}), Fxt = {
  ".force-show-scrollbars ::-webkit-scrollbar": {
    webkitAppearance: "none"
    // "background-color": "#FAFAFA",
  },
  ".force-show-scrollbars ::-webkit-scrollbar-thumb": {
    backgroundClip: "padding-box",
    borderColor: "transparent",
    borderStyle: "solid",
    borderWidth: "1px 0px 1px 0px"
    /* Workaround because margins aren't supported */
  }
};
var l5 = function(e, t) {
  return l5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, n) {
    i.__proto__ = n;
  } || function(i, n) {
    for (var g in n)
      Object.prototype.hasOwnProperty.call(n, g) && (i[g] = n[g]);
  }, l5(e, t);
};
function Yxt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  l5(e, t);
  function i() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
}
var Ir = function() {
  return Ir = Object.assign || function(t) {
    for (var i, n = 1, g = arguments.length; n < g; n++) {
      i = arguments[n];
      for (var r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r]);
    }
    return t;
  }, Ir.apply(this, arguments);
};
function xxt(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var g = 0, n = Object.getOwnPropertySymbols(e); g < n.length; g++)
      t.indexOf(n[g]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[g]) && (i[n[g]] = e[n[g]]);
  return i;
}
function $b(e, t, i, n) {
  function g(r) {
    return r instanceof i ? r : new i(function(o) {
      o(r);
    });
  }
  return new (i || (i = Promise))(function(r, o) {
    function I(d) {
      try {
        a(n.next(d));
      } catch (C) {
        o(C);
      }
    }
    function s(d) {
      try {
        a(n.throw(d));
      } catch (C) {
        o(C);
      }
    }
    function a(d) {
      d.done ? r(d.value) : g(d.value).then(I, s);
    }
    a((n = n.apply(e, [])).next());
  });
}
function qb(e, t) {
  var i = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, n, g, r, o;
  return o = { next: I(0), throw: I(1), return: I(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function I(a) {
    return function(d) {
      return s([a, d]);
    };
  }
  function s(a) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, a[0] && (i = 0)), i; )
      try {
        if (n = 1, g && (r = a[0] & 2 ? g.return : a[0] ? g.throw || ((r = g.return) && r.call(g), 0) : g.next) && !(r = r.call(g, a[1])).done)
          return r;
        switch (g = 0, r && (a = [a[0] & 2, r.value]), a[0]) {
          case 0:
          case 1:
            r = a;
            break;
          case 4:
            return i.label++, { value: a[1], done: !1 };
          case 5:
            i.label++, g = a[1], a = [0];
            continue;
          case 7:
            a = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (r = i.trys, !(r = r.length > 0 && r[r.length - 1]) && (a[0] === 6 || a[0] === 2)) {
              i = 0;
              continue;
            }
            if (a[0] === 3 && (!r || a[1] > r[0] && a[1] < r[3])) {
              i.label = a[1];
              break;
            }
            if (a[0] === 6 && i.label < r[1]) {
              i.label = r[1], r = a;
              break;
            }
            if (r && i.label < r[2]) {
              i.label = r[2], i.ops.push(a);
              break;
            }
            r[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        a = t.call(e, i);
      } catch (d) {
        a = [6, d], g = 0;
      } finally {
        n = r = 0;
      }
    if (a[0] & 5)
      throw a[1];
    return { value: a[0] ? a[1] : void 0, done: !0 };
  }
}
function Qs(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var g = 0;
    for (n = Object.getOwnPropertySymbols(e); g < n.length; g++)
      t.indexOf(n[g]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[g]) && (i[n[g]] = e[n[g]]);
  }
  return i;
}
var Bu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function I9(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function l9(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
var Au = l9(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var i = function() {
    function n() {
      var g = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(r, o) {
        var I = g.locked.get(r);
        I === void 0 ? o === void 0 ? g.locked.set(r, []) : g.locked.set(r, [o]) : o !== void 0 && (I.unshift(o), g.locked.set(r, I));
      }, this.isLocked = function(r) {
        return g.locked.has(r);
      }, this.lock = function(r) {
        return new Promise(function(o, I) {
          g.isLocked(r) ? g.addToLocked(r, o) : (g.addToLocked(r), o());
        });
      }, this.unlock = function(r) {
        var o = g.locked.get(r);
        if (o !== void 0 && o.length !== 0) {
          var I = o.pop();
          g.locked.set(r, o), I !== void 0 && setTimeout(I, 0);
        } else
          g.locked.delete(r);
      };
    }
    return n.getInstance = function() {
      return n.instance === void 0 && (n.instance = new n()), n.instance;
    }, n;
  }();
  t.default = function() {
    return i.getInstance();
  };
});
I9(Au);
var Dxt = I9(l9(function(e, t) {
  var i = Bu && Bu.__awaiter || function(d, C, u, A) {
    return new (u || (u = Promise))(function(m, h) {
      function B(y) {
        try {
          G(A.next(y));
        } catch (W) {
          h(W);
        }
      }
      function f(y) {
        try {
          G(A.throw(y));
        } catch (W) {
          h(W);
        }
      }
      function G(y) {
        y.done ? m(y.value) : new u(function(W) {
          W(y.value);
        }).then(B, f);
      }
      G((A = A.apply(d, C || [])).next());
    });
  }, n = Bu && Bu.__generator || function(d, C) {
    var u, A, m, h, B = { label: 0, sent: function() {
      if (1 & m[0])
        throw m[1];
      return m[1];
    }, trys: [], ops: [] };
    return h = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
      return this;
    }), h;
    function f(G) {
      return function(y) {
        return function(W) {
          if (u)
            throw new TypeError("Generator is already executing.");
          for (; B; )
            try {
              if (u = 1, A && (m = 2 & W[0] ? A.return : W[0] ? A.throw || ((m = A.return) && m.call(A), 0) : A.next) && !(m = m.call(A, W[1])).done)
                return m;
              switch (A = 0, m && (W = [2 & W[0], m.value]), W[0]) {
                case 0:
                case 1:
                  m = W;
                  break;
                case 4:
                  return B.label++, { value: W[1], done: !1 };
                case 5:
                  B.label++, A = W[1], W = [0];
                  continue;
                case 7:
                  W = B.ops.pop(), B.trys.pop();
                  continue;
                default:
                  if (m = B.trys, !((m = m.length > 0 && m[m.length - 1]) || W[0] !== 6 && W[0] !== 2)) {
                    B = 0;
                    continue;
                  }
                  if (W[0] === 3 && (!m || W[1] > m[0] && W[1] < m[3])) {
                    B.label = W[1];
                    break;
                  }
                  if (W[0] === 6 && B.label < m[1]) {
                    B.label = m[1], m = W;
                    break;
                  }
                  if (m && B.label < m[2]) {
                    B.label = m[2], B.ops.push(W);
                    break;
                  }
                  m[2] && B.ops.pop(), B.trys.pop();
                  continue;
              }
              W = C.call(d, B);
            } catch (V) {
              W = [6, V], A = 0;
            } finally {
              u = m = 0;
            }
          if (5 & W[0])
            throw W[1];
          return { value: W[0] ? W[1] : void 0, done: !0 };
        }([G, y]);
      };
    }
  }, g = Bu;
  Object.defineProperty(t, "__esModule", { value: !0 });
  var r = "browser-tabs-lock-key", o = { key: function(d) {
    return i(g, void 0, void 0, function() {
      return n(this, function(C) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(d) {
    return i(g, void 0, void 0, function() {
      return n(this, function(C) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return i(g, void 0, void 0, function() {
      return n(this, function(d) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(d) {
    return i(g, void 0, void 0, function() {
      return n(this, function(C) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(d, C) {
    return i(g, void 0, void 0, function() {
      return n(this, function(u) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(d) {
    return window.localStorage.key(d);
  }, getItemSync: function(d) {
    return window.localStorage.getItem(d);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(d) {
    return window.localStorage.removeItem(d);
  }, setItemSync: function(d, C) {
    return window.localStorage.setItem(d, C);
  } };
  function I(d) {
    return new Promise(function(C) {
      return setTimeout(C, d);
    });
  }
  function s(d) {
    for (var C = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", u = "", A = 0; A < d; A++)
      u += C[Math.floor(Math.random() * C.length)];
    return u;
  }
  var a = function() {
    function d(C) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + s(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = C, d.waiters === void 0 && (d.waiters = []);
    }
    return d.prototype.acquireLock = function(C, u) {
      return u === void 0 && (u = 5e3), i(this, void 0, void 0, function() {
        var A, m, h, B, f, G, y;
        return n(this, function(W) {
          switch (W.label) {
            case 0:
              A = Date.now() + s(4), m = Date.now() + u, h = r + "-" + C, B = this.storageHandler === void 0 ? o : this.storageHandler, W.label = 1;
            case 1:
              return Date.now() < m ? [4, I(30)] : [3, 8];
            case 2:
              return W.sent(), B.getItemSync(h) !== null ? [3, 5] : (f = this.id + "-" + C + "-" + A, [4, I(Math.floor(25 * Math.random()))]);
            case 3:
              return W.sent(), B.setItemSync(h, JSON.stringify({ id: this.id, iat: A, timeoutKey: f, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, I(30)];
            case 4:
              return W.sent(), (G = B.getItemSync(h)) !== null && (y = JSON.parse(G)).id === this.id && y.iat === A ? (this.acquiredIatSet.add(A), this.refreshLockWhileAcquired(h, A), [2, !0]) : [3, 7];
            case 5:
              return d.lockCorrector(this.storageHandler === void 0 ? o : this.storageHandler), [4, this.waitForSomethingToChange(m)];
            case 6:
              W.sent(), W.label = 7;
            case 7:
              return A = Date.now() + s(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, d.prototype.refreshLockWhileAcquired = function(C, u) {
      return i(this, void 0, void 0, function() {
        var A = this;
        return n(this, function(m) {
          return setTimeout(function() {
            return i(A, void 0, void 0, function() {
              var h, B, f;
              return n(this, function(G) {
                switch (G.label) {
                  case 0:
                    return [4, Au.default().lock(u)];
                  case 1:
                    return G.sent(), this.acquiredIatSet.has(u) ? (h = this.storageHandler === void 0 ? o : this.storageHandler, (B = h.getItemSync(C)) === null ? (Au.default().unlock(u), [2]) : ((f = JSON.parse(B)).timeRefreshed = Date.now(), h.setItemSync(C, JSON.stringify(f)), Au.default().unlock(u), this.refreshLockWhileAcquired(C, u), [2])) : (Au.default().unlock(u), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, d.prototype.waitForSomethingToChange = function(C) {
      return i(this, void 0, void 0, function() {
        return n(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, new Promise(function(A) {
                var m = !1, h = Date.now(), B = !1;
                function f() {
                  if (B || (window.removeEventListener("storage", f), d.removeFromWaiting(f), clearTimeout(G), B = !0), !m) {
                    m = !0;
                    var y = 50 - (Date.now() - h);
                    y > 0 ? setTimeout(A, y) : A(null);
                  }
                }
                window.addEventListener("storage", f), d.addToWaiting(f);
                var G = setTimeout(f, Math.max(0, C - Date.now()));
              })];
            case 1:
              return u.sent(), [2];
          }
        });
      });
    }, d.addToWaiting = function(C) {
      this.removeFromWaiting(C), d.waiters !== void 0 && d.waiters.push(C);
    }, d.removeFromWaiting = function(C) {
      d.waiters !== void 0 && (d.waiters = d.waiters.filter(function(u) {
        return u !== C;
      }));
    }, d.notifyWaiters = function() {
      d.waiters !== void 0 && d.waiters.slice().forEach(function(C) {
        return C();
      });
    }, d.prototype.releaseLock = function(C) {
      return i(this, void 0, void 0, function() {
        return n(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.releaseLock__private__(C)];
            case 1:
              return [2, u.sent()];
          }
        });
      });
    }, d.prototype.releaseLock__private__ = function(C) {
      return i(this, void 0, void 0, function() {
        var u, A, m, h;
        return n(this, function(B) {
          switch (B.label) {
            case 0:
              return u = this.storageHandler === void 0 ? o : this.storageHandler, A = r + "-" + C, (m = u.getItemSync(A)) === null ? [2] : (h = JSON.parse(m)).id !== this.id ? [3, 2] : [4, Au.default().lock(h.iat)];
            case 1:
              B.sent(), this.acquiredIatSet.delete(h.iat), u.removeItemSync(A), Au.default().unlock(h.iat), d.notifyWaiters(), B.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, d.lockCorrector = function(C) {
      for (var u = Date.now() - 5e3, A = C, m = [], h = 0; ; ) {
        var B = A.keySync(h);
        if (B === null)
          break;
        m.push(B), h++;
      }
      for (var f = !1, G = 0; G < m.length; G++) {
        var y = m[G];
        if (y.includes(r)) {
          var W = A.getItemSync(y);
          if (W !== null) {
            var V = JSON.parse(W);
            (V.timeRefreshed === void 0 && V.timeAcquired < u || V.timeRefreshed !== void 0 && V.timeRefreshed < u) && (A.removeItemSync(y), f = !0);
          }
        }
      }
      f && d.notifyWaiters();
    }, d.waiters = void 0, d;
  }();
  t.default = a;
}));
const Jxt = { timeoutInSeconds: 60 }, Yne = { name: "auth0-spa-js", version: "2.1.3" }, xne = () => Date.now();
class jr extends Error {
  constructor(t, i) {
    super(i), this.error = t, this.error_description = i, Object.setPrototypeOf(this, jr.prototype);
  }
  static fromPayload({ error: t, error_description: i }) {
    return new jr(t, i);
  }
}
class s9 extends jr {
  constructor(t, i, n, g = null) {
    super(t, i), this.state = n, this.appState = g, Object.setPrototypeOf(this, s9.prototype);
  }
}
class mZ extends jr {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, mZ.prototype);
  }
}
class a9 extends mZ {
  constructor(t) {
    super(), this.popup = t, Object.setPrototypeOf(this, a9.prototype);
  }
}
class c9 extends jr {
  constructor(t) {
    super("cancelled", "Popup closed"), this.popup = t, Object.setPrototypeOf(this, c9.prototype);
  }
}
class d9 extends jr {
  constructor(t, i, n) {
    super(t, i), this.mfa_token = n, Object.setPrototypeOf(this, d9.prototype);
  }
}
class nv extends jr {
  constructor(t, i) {
    super("missing_refresh_token", `Missing Refresh Token (audience: '${Gz(t, ["default"])}', scope: '${Gz(i)}')`), this.audience = t, this.scope = i, Object.setPrototypeOf(this, nv.prototype);
  }
}
function Gz(e, t = []) {
  return e && !t.includes(e) ? e : "";
}
const ZS = () => window.crypto, OF = () => {
  const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t = "";
  return Array.from(ZS().getRandomValues(new Uint8Array(43))).forEach((i) => t += e[i % e.length]), t;
}, yz = (e) => btoa(e), s5 = (e) => {
  var { clientId: t } = e, i = Qs(e, ["clientId"]);
  return new URLSearchParams(((n) => Object.keys(n).filter((g) => n[g] !== void 0).reduce((g, r) => Object.assign(Object.assign({}, g), { [r]: n[r] }), {}))(Object.assign({ client_id: t }, i))).toString();
}, Wz = (e) => ((t) => decodeURIComponent(atob(t).split("").map((i) => "%" + ("00" + i.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), Kxt = async (e, t) => {
  const i = await fetch(e, t);
  return { ok: i.ok, json: await i.json() };
}, Ext = async (e, t, i) => {
  const n = new AbortController();
  let g;
  return t.signal = n.signal, Promise.race([Kxt(e, t), new Promise((r, o) => {
    g = setTimeout(() => {
      n.abort(), o(new Error("Timeout when executing 'fetch'"));
    }, i);
  })]).finally(() => {
    clearTimeout(g);
  });
}, Nxt = async (e, t, i, n, g, r, o) => {
  return I = { auth: { audience: t, scope: i }, timeout: g, fetchUrl: e, fetchOptions: n, useFormData: o }, s = r, new Promise(function(a, d) {
    const C = new MessageChannel();
    C.port1.onmessage = function(u) {
      u.data.error ? d(new Error(u.data.error)) : a(u.data), C.port1.close();
    }, s.postMessage(I, [C.port2]);
  });
  var I, s;
}, Lxt = async (e, t, i, n, g, r, o = 1e4) => g ? Nxt(e, t, i, n, o, g, r) : Ext(e, n, o);
async function Txt(e, t) {
  var { baseUrl: i, timeout: n, audience: g, scope: r, auth0Client: o, useFormData: I } = e, s = Qs(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
  const a = I ? s5(s) : JSON.stringify(s);
  return await async function(d, C, u, A, m, h, B) {
    let f, G = null;
    for (let H = 0; H < 3; H++)
      try {
        f = await Lxt(d, u, A, m, h, B, C), G = null;
        break;
      } catch (x) {
        G = x;
      }
    if (G)
      throw G;
    const y = f.json, { error: W, error_description: V } = y, w = Qs(y, ["error", "error_description"]), { ok: v } = f;
    if (!v) {
      const H = V || `HTTP error. Unable to fetch ${d}`;
      throw W === "mfa_required" ? new d9(W, H, w.mfa_token) : W === "missing_refresh_token" ? new nv(u, A) : new jr(W || "request_error", H);
    }
    return w;
  }(`${i}/oauth/token`, n, g || "default", r, { method: "POST", body: a, headers: { "Content-Type": I ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(o || Yne)) } }, t, I);
}
const $W = (...e) => {
  return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
  var t;
};
class na {
  constructor(t, i = "@@auth0spajs@@", n) {
    this.prefix = i, this.suffix = n, this.clientId = t.clientId, this.scope = t.scope, this.audience = t.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(t) {
    const [i, n, g, r] = t.split("::");
    return new na({ clientId: n, scope: r, audience: g }, i);
  }
  static fromCacheEntry(t) {
    const { scope: i, audience: n, client_id: g } = t;
    return new na({ scope: i, audience: n, clientId: g });
  }
}
class Mxt {
  set(t, i) {
    localStorage.setItem(t, JSON.stringify(i));
  }
  get(t) {
    const i = window.localStorage.getItem(t);
    if (i)
      try {
        return JSON.parse(i);
      } catch {
        return;
      }
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter((t) => t.startsWith("@@auth0spajs@@"));
  }
}
class Dne {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ function() {
      let t = {};
      return { set(i, n) {
        t[i] = n;
      }, get(i) {
        const n = t[i];
        if (n)
          return n;
      }, remove(i) {
        delete t[i];
      }, allKeys: () => Object.keys(t) };
    }();
  }
}
class Uxt {
  constructor(t, i, n) {
    this.cache = t, this.keyManifest = i, this.nowProvider = n || xne;
  }
  async setIdToken(t, i, n) {
    var g;
    const r = this.getIdTokenCacheKey(t);
    await this.cache.set(r, { id_token: i, decodedToken: n }), await ((g = this.keyManifest) === null || g === void 0 ? void 0 : g.add(r));
  }
  async getIdToken(t) {
    const i = await this.cache.get(this.getIdTokenCacheKey(t.clientId));
    if (!i && t.scope && t.audience) {
      const n = await this.get(t);
      return !n || !n.id_token || !n.decodedToken ? void 0 : { id_token: n.id_token, decodedToken: n.decodedToken };
    }
    if (i)
      return { id_token: i.id_token, decodedToken: i.decodedToken };
  }
  async get(t, i = 0) {
    var n;
    let g = await this.cache.get(t.toKey());
    if (!g) {
      const I = await this.getCacheKeys();
      if (!I)
        return;
      const s = this.matchExistingCacheKey(t, I);
      s && (g = await this.cache.get(s));
    }
    if (!g)
      return;
    const r = await this.nowProvider(), o = Math.floor(r / 1e3);
    return g.expiresAt - i < o ? g.body.refresh_token ? (g.body = { refresh_token: g.body.refresh_token }, await this.cache.set(t.toKey(), g), g.body) : (await this.cache.remove(t.toKey()), void await ((n = this.keyManifest) === null || n === void 0 ? void 0 : n.remove(t.toKey()))) : g.body;
  }
  async set(t) {
    var i;
    const n = new na({ clientId: t.client_id, scope: t.scope, audience: t.audience }), g = await this.wrapCacheEntry(t);
    await this.cache.set(n.toKey(), g), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.add(n.toKey()));
  }
  async clear(t) {
    var i;
    const n = await this.getCacheKeys();
    n && (await n.filter((g) => !t || g.includes(t)).reduce(async (g, r) => {
      await g, await this.cache.remove(r);
    }, Promise.resolve()), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.clear()));
  }
  async wrapCacheEntry(t) {
    const i = await this.nowProvider();
    return { body: t, expiresAt: Math.floor(i / 1e3) + t.expires_in };
  }
  async getCacheKeys() {
    var t;
    return this.keyManifest ? (t = await this.keyManifest.get()) === null || t === void 0 ? void 0 : t.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(t) {
    return new na({ clientId: t }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(t, i) {
    return i.filter((n) => {
      var g;
      const r = na.fromKey(n), o = new Set(r.scope && r.scope.split(" ")), I = ((g = t.scope) === null || g === void 0 ? void 0 : g.split(" ")) || [], s = r.scope && I.reduce((a, d) => a && o.has(d), !0);
      return r.prefix === "@@auth0spajs@@" && r.clientId === t.clientId && r.audience === t.audience && s;
    })[0];
  }
}
class Pxt {
  constructor(t, i, n) {
    this.storage = t, this.clientId = i, this.cookieDomain = n, this.storageKey = `a0.spajs.txs.${this.clientId}`;
  }
  create(t) {
    this.storage.save(this.storageKey, t, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
}
const L0 = (e) => typeof e == "number", zxt = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], Oxt = (e) => {
  if (!e.id_token)
    throw new Error("ID token is required but missing");
  const t = ((r) => {
    const o = r.split("."), [I, s, a] = o;
    if (o.length !== 3 || !I || !s || !a)
      throw new Error("ID token could not be decoded");
    const d = JSON.parse(Wz(s)), C = { __raw: r }, u = {};
    return Object.keys(d).forEach((A) => {
      C[A] = d[A], zxt.includes(A) || (u[A] = d[A]);
    }), { encoded: { header: I, payload: s, signature: a }, header: JSON.parse(Wz(I)), claims: C, user: u };
  })(e.id_token);
  if (!t.claims.iss)
    throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t.claims.iss !== e.iss)
    throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
  if (!t.user.sub)
    throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (t.header.alg !== "RS256")
    throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
  if (!t.claims.aud || typeof t.claims.aud != "string" && !Array.isArray(t.claims.aud))
    throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e.aud))
      throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
    if (t.claims.aud.length > 1) {
      if (!t.claims.azp)
        throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t.claims.azp !== e.aud)
        throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
    }
  } else if (t.claims.aud !== e.aud)
    throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
  if (e.nonce) {
    if (!t.claims.nonce)
      throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t.claims.nonce !== e.nonce)
      throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
  }
  if (e.max_age && !L0(t.claims.auth_time))
    throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (t.claims.exp == null || !L0(t.claims.exp))
    throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!L0(t.claims.iat))
    throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const i = e.leeway || 60, n = new Date(e.now || Date.now()), g = /* @__PURE__ */ new Date(0);
  if (g.setUTCSeconds(t.claims.exp + i), n > g)
    throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${n}) is after expiration time (${g})`);
  if (t.claims.nbf != null && L0(t.claims.nbf)) {
    const r = /* @__PURE__ */ new Date(0);
    if (r.setUTCSeconds(t.claims.nbf - i), n < r)
      throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${n}) is before ${r}`);
  }
  if (t.claims.auth_time != null && L0(t.claims.auth_time)) {
    const r = /* @__PURE__ */ new Date(0);
    if (r.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), n > r)
      throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${n}) is after last auth at ${r}`);
  }
  if (e.organization) {
    const r = e.organization.trim();
    if (r.startsWith("org_")) {
      const o = r;
      if (!t.claims.org_id)
        throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (o !== t.claims.org_id)
        throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${o}", found "${t.claims.org_id}"`);
    } else {
      const o = r.toLowerCase();
      if (!t.claims.org_name)
        throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (o !== t.claims.org_name)
        throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${o}", found "${t.claims.org_name}"`);
    }
  }
  return t;
};
var Vu = l9(function(e, t) {
  var i = Bu && Bu.__assign || function() {
    return i = Object.assign || function(s) {
      for (var a, d = 1, C = arguments.length; d < C; d++)
        for (var u in a = arguments[d])
          Object.prototype.hasOwnProperty.call(a, u) && (s[u] = a[u]);
      return s;
    }, i.apply(this, arguments);
  };
  function n(s, a) {
    if (!a)
      return "";
    var d = "; " + s;
    return a === !0 ? d : d + "=" + a;
  }
  function g(s, a, d) {
    return encodeURIComponent(s).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(a).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(C) {
      if (typeof C.expires == "number") {
        var u = /* @__PURE__ */ new Date();
        u.setMilliseconds(u.getMilliseconds() + 864e5 * C.expires), C.expires = u;
      }
      return n("Expires", C.expires ? C.expires.toUTCString() : "") + n("Domain", C.domain) + n("Path", C.path) + n("Secure", C.secure) + n("SameSite", C.sameSite);
    }(d);
  }
  function r(s) {
    for (var a = {}, d = s ? s.split("; ") : [], C = /(%[\dA-F]{2})+/gi, u = 0; u < d.length; u++) {
      var A = d[u].split("="), m = A.slice(1).join("=");
      m.charAt(0) === '"' && (m = m.slice(1, -1));
      try {
        a[A[0].replace(C, decodeURIComponent)] = m.replace(C, decodeURIComponent);
      } catch {
      }
    }
    return a;
  }
  function o() {
    return r(document.cookie);
  }
  function I(s, a, d) {
    document.cookie = g(s, a, i({ path: "/" }, d));
  }
  t.__esModule = !0, t.encode = g, t.parse = r, t.getAll = o, t.get = function(s) {
    return o()[s];
  }, t.set = I, t.remove = function(s, a) {
    I(s, "", i(i({}, a), { expires: -1 }));
  };
});
I9(Vu), Vu.encode, Vu.parse, Vu.getAll;
var Qxt = Vu.get, Jne = Vu.set, Kne = Vu.remove;
const Im = { get(e) {
  const t = Qxt(e);
  if (t !== void 0)
    return JSON.parse(t);
}, save(e, t, i) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0, sameSite: "none" }), i != null && i.daysUntilExpire && (n.expires = i.daysUntilExpire), i != null && i.cookieDomain && (n.domain = i.cookieDomain), Jne(e, JSON.stringify(t), n);
}, remove(e, t) {
  let i = {};
  t != null && t.cookieDomain && (i.domain = t.cookieDomain), Kne(e, i);
} }, jxt = { get(e) {
  return Im.get(e) || Im.get(`_legacy_${e}`);
}, save(e, t, i) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0 }), i != null && i.daysUntilExpire && (n.expires = i.daysUntilExpire), i != null && i.cookieDomain && (n.domain = i.cookieDomain), Jne(`_legacy_${e}`, JSON.stringify(t), n), Im.save(e, t, i);
}, remove(e, t) {
  let i = {};
  t != null && t.cookieDomain && (i.domain = t.cookieDomain), Kne(e, i), Im.remove(e, t), Im.remove(`_legacy_${e}`, t);
} }, _xt = { get(e) {
  if (typeof sessionStorage > "u")
    return;
  const t = sessionStorage.getItem(e);
  return t != null ? JSON.parse(t) : void 0;
}, save(e, t) {
  sessionStorage.setItem(e, JSON.stringify(t));
}, remove(e) {
  sessionStorage.removeItem(e);
} };
function $xt(e, t, i) {
  var n = t === void 0 ? null : t, g = function(s, a) {
    var d = atob(s);
    if (a) {
      for (var C = new Uint8Array(d.length), u = 0, A = d.length; u < A; ++u)
        C[u] = d.charCodeAt(u);
      return String.fromCharCode.apply(null, new Uint16Array(C.buffer));
    }
    return d;
  }(e, i !== void 0 && i), r = g.indexOf(`
`, 10) + 1, o = g.substring(r) + (n ? "//# sourceMappingURL=" + n : ""), I = new Blob([o], { type: "application/javascript" });
  return URL.createObjectURL(I);
}
var Sz, Vz, wz, QF, qxt = (Sz = "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", Vz = null, wz = !1, function(e) {
  return QF = QF || $xt(Sz, Vz, wz), new Worker(QF, e);
});
const jF = {};
class e5t {
  constructor(t, i) {
    this.cache = t, this.clientId = i, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(t) {
    var i;
    const n = new Set(((i = await this.cache.get(this.manifestKey)) === null || i === void 0 ? void 0 : i.keys) || []);
    n.add(t), await this.cache.set(this.manifestKey, { keys: [...n] });
  }
  async remove(t) {
    const i = await this.cache.get(this.manifestKey);
    if (i) {
      const n = new Set(i.keys);
      return n.delete(t), n.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...n] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(t) {
    return `@@auth0spajs@@::${t}`;
  }
}
const t5t = { memory: () => new Dne().enclosedCache, localstorage: () => new Mxt() }, vz = (e) => t5t[e], Rz = (e) => {
  const { openUrl: t, onRedirect: i } = e, n = Qs(e, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, n), { openUrl: t === !1 || t ? t : i });
}, _F = new Dxt();
class i5t {
  constructor(t) {
    let i, n;
    if (this.userCache = new Dne().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this._releaseLockOnPageHide = async () => {
      await _F.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), t), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), t.authorizationParams) }), typeof window < "u" && (() => {
      if (!ZS())
        throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (ZS().subtle === void 0)
        throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), t.cache && t.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), t.cache)
      n = t.cache;
    else {
      if (i = t.cacheLocation || "memory", !vz(i))
        throw new Error(`Invalid cache location "${i}"`);
      n = vz(i)();
    }
    this.httpTimeoutMs = t.httpTimeoutInSeconds ? 1e3 * t.httpTimeoutInSeconds : 1e4, this.cookieStorage = t.legacySameSiteCookie === !1 ? Im : jxt, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((o) => `auth0.${o}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = t.sessionCheckExpiryDays || 1;
    const g = t.useCookiesForTransactions ? this.cookieStorage : _xt;
    var r;
    this.scope = $W("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new Pxt(g, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || xne, this.cacheManager = new Uxt(n, n.allKeys ? void 0 : new e5t(n, this.options.clientId), this.nowProvider), this.domainUrl = (r = this.options.domain, /^https?:\/\//.test(r) ? r : `https://${r}`), this.tokenIssuer = ((o, I) => o ? o.startsWith("https://") ? o : `https://${o}/` : `${I}/`)(this.options.issuer, this.domainUrl), typeof window < "u" && window.Worker && this.options.useRefreshTokens && i === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new qxt());
  }
  _url(t) {
    const i = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || Yne)));
    return `${this.domainUrl}${t}&auth0Client=${i}`;
  }
  _authorizeUrl(t) {
    return this._url(`/authorize?${s5(t)}`);
  }
  async _verifyIdToken(t, i, n) {
    const g = await this.nowProvider();
    return Oxt({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: t, nonce: i, organization: n, leeway: this.options.leeway, max_age: (r = this.options.authorizationParams.max_age, typeof r != "string" ? r : parseInt(r, 10) || void 0), now: g });
    var r;
  }
  _processOrgHint(t) {
    t ? this.cookieStorage.save(this.orgHintCookieName, t, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(t, i, n) {
    const g = yz(OF()), r = yz(OF()), o = OF(), I = ((d) => {
      const C = new Uint8Array(d);
      return ((u) => {
        const A = { "+": "-", "/": "_", "=": "" };
        return u.replace(/[+/=]/g, (m) => A[m]);
      })(window.btoa(String.fromCharCode(...Array.from(C))));
    })(await (async (d) => await ZS().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(d)))(o)), s = ((d, C, u, A, m, h, B, f) => Object.assign(Object.assign(Object.assign({ client_id: d.clientId }, d.authorizationParams), u), { scope: $W(C, u.scope), response_type: "code", response_mode: f || "query", state: A, nonce: m, redirect_uri: B || d.authorizationParams.redirect_uri, code_challenge: h, code_challenge_method: "S256" }))(this.options, this.scope, t, g, r, I, t.redirect_uri || this.options.authorizationParams.redirect_uri || n, i == null ? void 0 : i.response_mode), a = this._authorizeUrl(s);
    return { nonce: r, code_verifier: o, scope: s.scope, audience: s.audience || "default", redirect_uri: s.redirect_uri, state: g, url: a };
  }
  async loginWithPopup(t, i) {
    var n;
    if (t = t || {}, !(i = i || {}).popup && (i.popup = ((I) => {
      const s = window.screenX + (window.innerWidth - 400) / 2, a = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(I, "auth0:authorize:popup", `left=${s},top=${a},width=400,height=600,resizable,scrollbars=yes,status=1`);
    })(""), !i.popup))
      throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
    const g = await this._prepareAuthorizeUrl(t.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    i.popup.location.href = g.url;
    const r = await ((I) => new Promise((s, a) => {
      let d;
      const C = setInterval(() => {
        I.popup && I.popup.closed && (clearInterval(C), clearTimeout(u), window.removeEventListener("message", d, !1), a(new c9(I.popup)));
      }, 1e3), u = setTimeout(() => {
        clearInterval(C), a(new a9(I.popup)), window.removeEventListener("message", d, !1);
      }, 1e3 * (I.timeoutInSeconds || 60));
      d = function(A) {
        if (A.data && A.data.type === "authorization_response") {
          if (clearTimeout(u), clearInterval(C), window.removeEventListener("message", d, !1), I.popup.close(), A.data.response.error)
            return a(jr.fromPayload(A.data.response));
          s(A.data.response);
        }
      }, window.addEventListener("message", d);
    }))(Object.assign(Object.assign({}, i), { timeoutInSeconds: i.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (g.state !== r.state)
      throw new jr("state_mismatch", "Invalid state");
    const o = ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: g.audience, scope: g.scope, code_verifier: g.code_verifier, grant_type: "authorization_code", code: r.code, redirect_uri: g.redirect_uri }, { nonceIn: g.nonce, organization: o });
  }
  async getUser() {
    var t;
    const i = await this._getIdTokenFromCache();
    return (t = i == null ? void 0 : i.decodedToken) === null || t === void 0 ? void 0 : t.user;
  }
  async getIdTokenClaims() {
    var t;
    const i = await this._getIdTokenFromCache();
    return (t = i == null ? void 0 : i.decodedToken) === null || t === void 0 ? void 0 : t.claims;
  }
  async loginWithRedirect(t = {}) {
    var i;
    const n = Rz(t), { openUrl: g, fragment: r, appState: o } = n, I = Qs(n, ["openUrl", "fragment", "appState"]), s = ((i = I.authorizationParams) === null || i === void 0 ? void 0 : i.organization) || this.options.authorizationParams.organization, a = await this._prepareAuthorizeUrl(I.authorizationParams || {}), { url: d } = a, C = Qs(a, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, C), { appState: o }), s && { organization: s }));
    const u = r ? `${d}#${r}` : d;
    g ? await g(u) : window.location.assign(u);
  }
  async handleRedirectCallback(t = window.location.href) {
    const i = t.split("?").slice(1);
    if (i.length === 0)
      throw new Error("There are no query params available for parsing.");
    const { state: n, code: g, error: r, error_description: o } = ((C) => {
      C.indexOf("#") > -1 && (C = C.substring(0, C.indexOf("#")));
      const u = new URLSearchParams(C);
      return { state: u.get("state"), code: u.get("code") || void 0, error: u.get("error") || void 0, error_description: u.get("error_description") || void 0 };
    })(i.join("")), I = this.transactionManager.get();
    if (!I)
      throw new jr("missing_transaction", "Invalid state");
    if (this.transactionManager.remove(), r)
      throw new s9(r, o || r, n, I.appState);
    if (!I.code_verifier || I.state && I.state !== n)
      throw new jr("state_mismatch", "Invalid state");
    const s = I.organization, a = I.nonce, d = I.redirect_uri;
    return await this._requestToken(Object.assign({ audience: I.audience, scope: I.scope, code_verifier: I.code_verifier, grant_type: "authorization_code", code: g }, d ? { redirect_uri: d } : {}), { nonceIn: a, organization: s }), { appState: I.appState };
  }
  async checkSession(t) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated"))
        return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(t);
    } catch {
    }
  }
  async getTokenSilently(t = {}) {
    var i;
    const n = Object.assign(Object.assign({ cacheMode: "on" }, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: $W(this.scope, (i = t.authorizationParams) === null || i === void 0 ? void 0 : i.scope) }) }), g = await ((r, o) => {
      let I = jF[o];
      return I || (I = r().finally(() => {
        delete jF[o], I = null;
      }), jF[o] = I), I;
    })(() => this._getTokenSilently(n), `${this.options.clientId}::${n.authorizationParams.audience}::${n.authorizationParams.scope}`);
    return t.detailedResponse ? g : g == null ? void 0 : g.access_token;
  }
  async _getTokenSilently(t) {
    const { cacheMode: i } = t, n = Qs(t, ["cacheMode"]);
    if (i !== "off") {
      const g = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (g)
        return g;
    }
    if (i !== "cache-only") {
      if (!await (async (g, r = 3) => {
        for (let o = 0; o < r; o++)
          if (await g())
            return !0;
        return !1;
      })(() => _F.acquireLock("auth0.lock.getTokenSilently", 5e3), 10))
        throw new mZ();
      try {
        if (window.addEventListener("pagehide", this._releaseLockOnPageHide), i !== "off") {
          const a = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (a)
            return a;
        }
        const g = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(n) : await this._getTokenFromIFrame(n), { id_token: r, access_token: o, oauthTokenScope: I, expires_in: s } = g;
        return Object.assign(Object.assign({ id_token: r, access_token: o }, I ? { scope: I } : null), { expires_in: s });
      } finally {
        await _F.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
      }
    }
  }
  async getTokenWithPopup(t = {}, i = {}) {
    var n;
    const g = Object.assign(Object.assign({}, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: $W(this.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.scope) }) });
    return i = Object.assign(Object.assign({}, Jxt), i), await this.loginWithPopup(g, i), (await this.cacheManager.get(new na({ scope: g.authorizationParams.scope, audience: g.authorizationParams.audience || "default", clientId: this.options.clientId }))).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t) {
    t.clientId !== null ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
    const i = t.logoutParams || {}, { federated: n } = i, g = Qs(i, ["federated"]), r = n ? "&federated" : "";
    return this._url(`/v2/logout?${s5(Object.assign({ clientId: t.clientId }, g))}`) + r;
  }
  async logout(t = {}) {
    const i = Rz(t), { openUrl: n } = i, g = Qs(i, ["openUrl"]);
    t.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@");
    const r = this._buildLogoutUrl(g);
    n ? await n(r) : n !== !1 && window.location.assign(r);
  }
  async _getTokenFromIFrame(t) {
    const i = Object.assign(Object.assign({}, t.authorizationParams), { prompt: "none" }), n = this.cookieStorage.get(this.orgHintCookieName);
    n && !i.organization && (i.organization = n);
    const { url: g, state: r, nonce: o, code_verifier: I, redirect_uri: s, scope: a, audience: d } = await this._prepareAuthorizeUrl(i, { response_mode: "web_message" }, window.location.origin);
    try {
      if (window.crossOriginIsolated)
        throw new jr("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
      const C = t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, u = await ((m, h, B = 60) => new Promise((f, G) => {
        const y = window.document.createElement("iframe");
        y.setAttribute("width", "0"), y.setAttribute("height", "0"), y.style.display = "none";
        const W = () => {
          window.document.body.contains(y) && (window.document.body.removeChild(y), window.removeEventListener("message", V, !1));
        };
        let V;
        const w = setTimeout(() => {
          G(new mZ()), W();
        }, 1e3 * B);
        V = function(v) {
          if (v.origin != h || !v.data || v.data.type !== "authorization_response")
            return;
          const H = v.source;
          H && H.close(), v.data.response.error ? G(jr.fromPayload(v.data.response)) : f(v.data.response), clearTimeout(w), window.removeEventListener("message", V, !1), setTimeout(W, 2e3);
        }, window.addEventListener("message", V, !1), window.document.body.appendChild(y), y.setAttribute("src", m);
      }))(g, this.domainUrl, C);
      if (r !== u.state)
        throw new jr("state_mismatch", "Invalid state");
      const A = await this._requestToken(Object.assign(Object.assign({}, t.authorizationParams), { code_verifier: I, code: u.code, grant_type: "authorization_code", redirect_uri: s, timeout: t.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: o, organization: i.organization });
      return Object.assign(Object.assign({}, A), { scope: a, oauthTokenScope: A.scope, audience: d });
    } catch (C) {
      throw C.error === "login_required" && this.logout({ openUrl: !1 }), C;
    }
  }
  async _getTokenUsingRefreshToken(t) {
    const i = await this.cacheManager.get(new na({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId }));
    if (!(i && i.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback)
        return await this._getTokenFromIFrame(t);
      throw new nv(t.authorizationParams.audience || "default", t.authorizationParams.scope);
    }
    const n = t.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, g = typeof t.timeoutInSeconds == "number" ? 1e3 * t.timeoutInSeconds : null;
    try {
      const r = await this._requestToken(Object.assign(Object.assign(Object.assign({}, t.authorizationParams), { grant_type: "refresh_token", refresh_token: i && i.refresh_token, redirect_uri: n }), g && { timeout: g }));
      return Object.assign(Object.assign({}, r), { scope: t.authorizationParams.scope, oauthTokenScope: r.scope, audience: t.authorizationParams.audience || "default" });
    } catch (r) {
      if ((r.message.indexOf("Missing Refresh Token") > -1 || r.message && r.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback)
        return await this._getTokenFromIFrame(t);
      throw r;
    }
  }
  async _saveEntryInCache(t) {
    const { id_token: i, decodedToken: n } = t, g = Qs(t, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: i, decodedToken: n }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(g);
  }
  async _getIdTokenFromCache() {
    const t = this.options.authorizationParams.audience || "default", i = await this.cacheManager.getIdToken(new na({ clientId: this.options.clientId, audience: t, scope: this.scope })), n = this.userCache.get("@@user@@");
    return i && i.id_token === (n == null ? void 0 : n.id_token) ? n : (this.userCache.set("@@user@@", i), i);
  }
  async _getEntryFromCache({ scope: t, audience: i, clientId: n }) {
    const g = await this.cacheManager.get(new na({ scope: t, audience: i, clientId: n }), 60);
    if (g && g.access_token) {
      const { access_token: r, oauthTokenScope: o, expires_in: I } = g, s = await this._getIdTokenFromCache();
      return s && Object.assign(Object.assign({ id_token: s.id_token, access_token: r }, o ? { scope: o } : null), { expires_in: I });
    }
  }
  async _requestToken(t, i) {
    const { nonceIn: n, organization: g } = i || {}, r = await Txt(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs }, t), this.worker), o = await this._verifyIdToken(r.id_token, n, g);
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, r), { decodedToken: o, scope: t.scope, audience: t.audience || "default" }), r.scope ? { oauthTokenScope: r.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(g || o.claims.org_id), Object.assign(Object.assign({}, r), { decodedToken: o });
  }
}
var Ene = {
  isAuthenticated: !1,
  isLoading: !0
}, gc = function() {
  throw new Error("You forgot to wrap your component in <Auth0Provider>.");
}, n5t = Ir(Ir({}, Ene), { buildAuthorizeUrl: gc, buildLogoutUrl: gc, getAccessTokenSilently: gc, getAccessTokenWithPopup: gc, getIdTokenClaims: gc, loginWithRedirect: gc, loginWithPopup: gc, logout: gc, handleRedirectCallback: gc }), Nne = Bs(n5t), Xz = (
  /** @class */
  function(e) {
    Yxt(t, e);
    function t(i, n) {
      var g = e.call(this, n || i) || this;
      return g.error = i, g.error_description = n, Object.setPrototypeOf(g, t.prototype), g;
    }
    return t;
  }(Error)
), g5t = /[?&]code=[^&]+/, r5t = /[?&]state=[^&]+/, o5t = /[?&]error=[^&]+/, I5t = function(e) {
  return e === void 0 && (e = window.location.search), (g5t.test(e) || o5t.test(e)) && r5t.test(e);
}, Lne = function(e) {
  return function(t) {
    return t instanceof Error ? t : t !== null && typeof t == "object" && "error" in t && typeof t.error == "string" ? "error_description" in t && typeof t.error_description == "string" ? new Xz(t.error, t.error_description) : new Xz(t.error) : new Error(e);
  };
}, Hz = Lne("Login failed"), $F = Lne("Get access token failed"), Tne = function(e) {
  var t;
  e != null && e.redirectUri && (console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version"), e.authorizationParams = e.authorizationParams || {}, e.authorizationParams.redirect_uri = e.redirectUri, delete e.redirectUri), !((t = e == null ? void 0 : e.authorizationParams) === null || t === void 0) && t.redirectUri && (console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version"), e.authorizationParams.redirect_uri = e.authorizationParams.redirectUri, delete e.authorizationParams.redirectUri);
}, l5t = function(e, t) {
  switch (t.type) {
    case "LOGIN_POPUP_STARTED":
      return Ir(Ir({}, e), { isLoading: !0 });
    case "LOGIN_POPUP_COMPLETE":
    case "INITIALISED":
      return Ir(Ir({}, e), { isAuthenticated: !!t.user, user: t.user, isLoading: !1, error: void 0 });
    case "HANDLE_REDIRECT_COMPLETE":
    case "GET_ACCESS_TOKEN_COMPLETE":
      return e.user === t.user ? e : Ir(Ir({}, e), { isAuthenticated: !!t.user, user: t.user });
    case "LOGOUT":
      return Ir(Ir({}, e), { isAuthenticated: !1, user: void 0 });
    case "ERROR":
      return Ir(Ir({}, e), { isLoading: !1, error: t.error });
  }
}, s5t = function(e) {
  return Tne(e), Ir(Ir({}, e), { auth0Client: {
    name: "auth0-react",
    version: "2.2.4"
  } });
}, a5t = function(e) {
  window.history.replaceState({}, document.title, (e == null ? void 0 : e.returnTo) || window.location.pathname);
}, c5t = function(e) {
  var t = e.children, i = e.skipRedirectCallback, n = e.onRedirectCallback, g = n === void 0 ? a5t : n, r = e.context, o = r === void 0 ? Nne : r, I = xxt(e, ["children", "skipRedirectCallback", "onRedirectCallback", "context"]), s = At(function() {
    return new i5t(s5t(I));
  })[0], a = BZ(l5t, Ene), d = a[0], C = a[1], u = Ct(!1);
  et(function() {
    u.current || (u.current = !0, function() {
      return $b(void 0, void 0, void 0, function() {
        var V, w, v;
        return qb(this, function(H) {
          switch (H.label) {
            case 0:
              return H.trys.push([0, 7, , 8]), V = void 0, I5t() && !i ? [4, s.handleRedirectCallback()] : [3, 3];
            case 1:
              return w = H.sent().appState, [4, s.getUser()];
            case 2:
              return V = H.sent(), g(w, V), [3, 6];
            case 3:
              return [4, s.checkSession()];
            case 4:
              return H.sent(), [4, s.getUser()];
            case 5:
              V = H.sent(), H.label = 6;
            case 6:
              return C({ type: "INITIALISED", user: V }), [3, 8];
            case 7:
              return v = H.sent(), C({ type: "ERROR", error: Hz(v) }), [3, 8];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }());
  }, [s, g, i]);
  var A = ft(function(V) {
    return Tne(V), s.loginWithRedirect(V);
  }, [s]), m = ft(function(V, w) {
    return $b(void 0, void 0, void 0, function() {
      var v, H;
      return qb(this, function(x) {
        switch (x.label) {
          case 0:
            C({ type: "LOGIN_POPUP_STARTED" }), x.label = 1;
          case 1:
            return x.trys.push([1, 3, , 4]), [4, s.loginWithPopup(V, w)];
          case 2:
            return x.sent(), [3, 4];
          case 3:
            return v = x.sent(), C({ type: "ERROR", error: Hz(v) }), [
              2
              /*return*/
            ];
          case 4:
            return [4, s.getUser()];
          case 5:
            return H = x.sent(), C({ type: "LOGIN_POPUP_COMPLETE", user: H }), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [s]), h = ft(function(V) {
    return V === void 0 && (V = {}), $b(void 0, void 0, void 0, function() {
      return qb(this, function(w) {
        switch (w.label) {
          case 0:
            return [4, s.logout(V)];
          case 1:
            return w.sent(), (V.openUrl || V.openUrl === !1) && C({ type: "LOGOUT" }), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [s]), B = ft(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(V) {
      return $b(void 0, void 0, void 0, function() {
        var w, v, H, x;
        return qb(this, function(N) {
          switch (N.label) {
            case 0:
              return N.trys.push([0, 2, 3, 5]), [4, s.getTokenSilently(V)];
            case 1:
              return w = N.sent(), [3, 5];
            case 2:
              throw v = N.sent(), $F(v);
            case 3:
              return H = C, x = {
                type: "GET_ACCESS_TOKEN_COMPLETE"
              }, [4, s.getUser()];
            case 4:
              return H.apply(void 0, [(x.user = N.sent(), x)]), [
                7
                /*endfinally*/
              ];
            case 5:
              return [2, w];
          }
        });
      });
    },
    [s]
  ), f = ft(function(V, w) {
    return $b(void 0, void 0, void 0, function() {
      var v, H, x, N;
      return qb(this, function(M) {
        switch (M.label) {
          case 0:
            return M.trys.push([0, 2, 3, 5]), [4, s.getTokenWithPopup(V, w)];
          case 1:
            return v = M.sent(), [3, 5];
          case 2:
            throw H = M.sent(), $F(H);
          case 3:
            return x = C, N = {
              type: "GET_ACCESS_TOKEN_COMPLETE"
            }, [4, s.getUser()];
          case 4:
            return x.apply(void 0, [(N.user = M.sent(), N)]), [
              7
              /*endfinally*/
            ];
          case 5:
            return [2, v];
        }
      });
    });
  }, [s]), G = ft(function() {
    return s.getIdTokenClaims();
  }, [s]), y = ft(function(V) {
    return $b(void 0, void 0, void 0, function() {
      var w, v, H;
      return qb(this, function(x) {
        switch (x.label) {
          case 0:
            return x.trys.push([0, 2, 3, 5]), [4, s.handleRedirectCallback(V)];
          case 1:
            return [2, x.sent()];
          case 2:
            throw w = x.sent(), $F(w);
          case 3:
            return v = C, H = {
              type: "HANDLE_REDIRECT_COMPLETE"
            }, [4, s.getUser()];
          case 4:
            return v.apply(void 0, [(H.user = x.sent(), H)]), [
              7
              /*endfinally*/
            ];
          case 5:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, [s]), W = je(function() {
    return Ir(Ir({}, d), { getAccessTokenSilently: B, getAccessTokenWithPopup: f, getIdTokenClaims: G, loginWithRedirect: A, loginWithPopup: m, logout: h, handleRedirectCallback: y });
  }, [
    d,
    B,
    f,
    G,
    A,
    m,
    h,
    y
  ]);
  return Se.createElement(o.Provider, { value: W }, t);
}, d5t = function(e) {
  return e === void 0 && (e = Nne), Hn(e);
};
const C5t = (e) => {
  const {
    isLoading: t,
    isAuthenticated: i,
    loginWithRedirect: n
  } = d5t();
  if (i)
    return e.children;
  t || n();
}, u5t = (e) => {
  var g, r;
  const t = (g = e.app) == null ? void 0 : g.settings.auth0;
  if (!t || !t.enabled || !t.domain || !t.clientId || !((r = e.app.productDetails) != null && r.felogin))
    return e.children;
  const i = window.location.search, n = new URLSearchParams(i);
  return n.set("k3-code", n.get("code") || ""), /* @__PURE__ */ p(
    c5t,
    {
      domain: t.domain,
      clientId: t.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin + window.location.pathname + "?" + n.toString()
      },
      onRedirectCallback: () => {
      },
      children: /* @__PURE__ */ p(C5t, { app: e.app, children: e.children })
    }
  );
};
function A5t() {
  const e = _(Ai);
  et(() => {
    document.title = (e == null ? void 0 : e.label) || "Konfigurator";
  }, [e]), Fne(e, !0);
  const t = ev(), i = je(() => /* @__PURE__ */ p(tD, { styles: kxt(t.palette.scrollbar.default) }), [t.palette.scrollbar.default]);
  return /* @__PURE__ */ ge(ege, { theme: t, children: [
    i,
    /* @__PURE__ */ p(u5t, { app: e, children: e ? /* @__PURE__ */ p(vxt, { app: e, editorUi: !1 }) : /* @__PURE__ */ p(fIt, {}) })
  ] });
}
var b5t = {
  cm: !0,
  mm: !0,
  in: !0,
  px: !0,
  pt: !0,
  pc: !0,
  em: !0,
  ex: !0,
  ch: !0,
  rem: !0,
  vw: !0,
  vh: !0,
  vmin: !0,
  vmax: !0,
  "%": !0
};
function Mne(e) {
  if (typeof e == "number")
    return {
      value: e,
      unit: "px"
    };
  var t, i = (e.match(/^[0-9.]*/) || "").toString();
  i.includes(".") ? t = parseFloat(i) : t = parseInt(i, 10);
  var n = (e.match(/[^0-9]*$/) || "").toString();
  return b5t[n] ? {
    value: t,
    unit: n
  } : (console.warn("React Spinners: ".concat(e, " is not a valid css value. Defaulting to ").concat(t, "px.")), {
    value: t,
    unit: "px"
  });
}
function kz(e) {
  var t = Mne(e);
  return "".concat(t.value).concat(t.unit);
}
var m5t = function(e, t, i) {
  var n = "react-spinners-".concat(e, "-").concat(i);
  if (typeof window > "u" || !window.document)
    return n;
  var g = document.createElement("style");
  document.head.appendChild(g);
  var r = g.sheet, o = `
    @keyframes `.concat(n, ` {
      `).concat(t, `
    }
  `);
  return r && r.insertRule(o, 0), n;
}, Zd = function() {
  return Zd = Object.assign || function(e) {
    for (var t, i = 1, n = arguments.length; i < n; i++) {
      t = arguments[i];
      for (var g in t)
        Object.prototype.hasOwnProperty.call(t, g) && (e[g] = t[g]);
    }
    return e;
  }, Zd.apply(this, arguments);
}, h5t = function(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var g = 0, n = Object.getOwnPropertySymbols(e); g < n.length; g++)
      t.indexOf(n[g]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[g]) && (i[n[g]] = e[n[g]]);
  return i;
}, Fz = m5t("MoonLoader", "100% {transform: rotate(360deg)}", "moon");
function p5t(e) {
  var t = e.loading, i = t === void 0 ? !0 : t, n = e.color, g = n === void 0 ? "#000000" : n, r = e.speedMultiplier, o = r === void 0 ? 1 : r, I = e.cssOverride, s = I === void 0 ? {} : I, a = e.size, d = a === void 0 ? 60 : a, C = h5t(e, ["loading", "color", "speedMultiplier", "cssOverride", "size"]), u = Mne(d), A = u.value, m = u.unit, h = A / 7, B = Zd({ display: "inherit", position: "relative", width: "".concat("".concat(A + h * 2).concat(m)), height: "".concat("".concat(A + h * 2).concat(m)), animation: "".concat(Fz, " ").concat(0.6 / o, "s 0s infinite linear"), animationFillMode: "forwards" }, s), f = function(W) {
    return {
      width: kz(W),
      height: kz(W),
      borderRadius: "100%"
    };
  }, G = Zd(Zd({}, f(h)), { backgroundColor: "".concat(g), opacity: "0.8", position: "absolute", top: "".concat("".concat(A / 2 - h / 2).concat(m)), animation: "".concat(Fz, " ").concat(0.6 / o, "s 0s infinite linear"), animationFillMode: "forwards" }), y = Zd(Zd({}, f(A)), { border: "".concat(h, "px solid ").concat(g), opacity: "0.1", boxSizing: "content-box", position: "absolute" });
  return i ? Y.createElement(
    "span",
    Zd({ style: B }, C),
    Y.createElement("span", { style: G }),
    Y.createElement("span", { style: y })
  ) : null;
}
function B5t() {
  return /* @__PURE__ */ p($w, { open: !0, children: /* @__PURE__ */ p(p5t, { size: 50, color: "white" }) });
}
function C9() {
  const {
    t: e
  } = ii();
  return /* @__PURE__ */ p(as, { "data-cy": "supportForm", href: "https://form.asana.com/?k=jdYe6sK2psLWak-zkUjxnw&d=4828816729443", target: "_blank", children: /* @__PURE__ */ p(Ne, { children: e("Sie können uns den Vorfall hier melden!") }) });
}
function qW(e) {
  const {
    t
  } = ii(), i = ha(), n = e.body ? uc.isString(e.body) ? t(e.body) : e.body : t("Fatal_Error_Text");
  return /* @__PURE__ */ ge(Yd, { open: !0, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [
    /* @__PURE__ */ p(Dd, { id: "alert-dialog-title", children: e.heading ? t(e.heading) : t("Fatal_Error") }),
    /* @__PURE__ */ ge(xd, { children: [
      /* @__PURE__ */ ge(Cr, { id: "alert-dialog-description", children: [
        n,
        /* @__PURE__ */ p(C9, {})
      ] }),
      e.error && /* @__PURE__ */ ge(Bt, { children: [
        /* @__PURE__ */ p("hr", {}),
        /* @__PURE__ */ p(Cr, { children: t("Fehlermeldung:") }),
        /* @__PURE__ */ p(Cr, { children: t(e.error.message) })
      ] })
    ] }),
    /* @__PURE__ */ ge(Yu, { children: [
      /* @__PURE__ */ p(Si, { "data-cy": "goHome", onClick: () => {
        i("/admin"), i(0);
      }, children: t("Zur Startseite") }),
      /* @__PURE__ */ p(Si, { onClick: () => window.location.reload(), "data-cy": "reload", children: t("Neu Laden") }),
      /* @__PURE__ */ p(Si, { "data-cy": "restart", onClick: () => {
        window.localStorage.clear(), window.location.reload();
      }, children: t("Cleanup und Neu Laden") })
    ] })
  ] });
}
var fS = /* @__PURE__ */ ((e) => (e[e.CONFIGURATION_NOT_FOUND = 0] = "CONFIGURATION_NOT_FOUND", e[e.APP_NOT_FOUND = 1] = "APP_NOT_FOUND", e[e.NO_DEALER_ACCESS = 2] = "NO_DEALER_ACCESS", e))(fS || {});
class Z5t extends Error {
  constructor(i) {
    super();
    Bg(this, "type");
    this.type = fS[i], this.name = fS[i], this.message = fS[i];
  }
  isType(i) {
    return this.type === i;
  }
}
class f5t extends Td {
  constructor() {
    super(...arguments);
    Bg(this, "catchUnhandledRejectionErrors", !0);
  }
  renderError(i, n) {
    return i instanceof Z5t ? {
      CONFIGURATION_NOT_FOUND: /* @__PURE__ */ p(qW, { heading: "Ladevorgang fehlgeschlagen", body: "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!" }),
      APP_NOT_FOUND: /* @__PURE__ */ p(qW, { heading: "Ladevorgang fehlgeschlagen", body: "Es liegt keine veröffentlichte Version der App vor." }),
      NO_DEALER_ACCESS: /* @__PURE__ */ p(qW, { heading: "Ladevorgang fehlgeschlagen", body: "Der Händler Konfigurator ist nicht aktiv. Bitte wenden sie sich an ihren Betreiber." })
    }[i.type] : n == "childComponent" ? /* @__PURE__ */ p(qW, { error: i }) : (ef(/* @__PURE__ */ p(Ne, { variant: "body1", children: i.message }), {
      variant: "error",
      persist: !0,
      style: {
        whiteSpace: "pre-line"
      },
      key: "FrontendTopLevelErrorBoundary"
    }), this.props.children);
  }
}
async function K9t(e) {
  return await jd("GET", `/admin/client/${e}`);
}
async function G5t(e) {
  return await jd("GET", `/admin/app/${e}`);
}
async function y5t(e, t) {
  const i = t ? `?dealerId=${t}` : "";
  return await ui("GET", `/admin/to/${e}${i}`);
}
async function E9t(e, t) {
  return await ui("PUT", `/admin/app/${e}`, t);
}
async function N9t(e, t) {
  await await ui("POST", `/admin/client/${e}`, t);
}
async function L9t(e) {
  await await ui("PUT", "/client", e);
}
async function T9t(e) {
  return await YD("GET", `/admin/client/${e}/export`);
}
async function M9t(e) {
  const t = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  return await YD("DELETE", `/admin/client/${e}`, null, t);
}
async function U9t(e, t) {
  return await ui("PUT", `/admin/dealerApp/${e}`, t);
}
async function P9t() {
  return await ui("GET", "/partner/all");
}
async function z9t(e, t, i, n) {
  return await ui("POST", "/support", {
    appId: e,
    mode: t,
    phone: i,
    message: n
  });
}
async function O9t() {
  return await ui("GET", "/legal");
}
async function Q9t(e, t) {
  return await ui("POST", "/register", {
    ...e
  }, {
    lang: t
  });
}
async function j9t(e) {
  return await ui("POST", "/confirm", {
    ...e
  });
}
async function W5t() {
  return await ui("GET", "/me");
}
async function _9t() {
  return await ui("GET", "/user/api-token/renew");
}
async function $9t(e) {
  const {
    message: t
  } = await ui("POST", "/lost", {
    email: e
  });
  return t;
}
async function q9t(e) {
  const {
    message: t
  } = await ui("POST", "/reset", e);
  return t;
}
async function eNt() {
  const {
    url: e
  } = await ui("GET", "/payment/portal");
  return e;
}
async function tNt(e, t) {
  const {
    message: i
  } = await ui("POST", "/user/invite", {
    email: e,
    role: t
  });
  return i;
}
async function iNt(e) {
  const {
    message: t
  } = await ui("DELETE", `/user/invite/${e}`);
  return t;
}
async function nNt() {
  return await ui("GET", "/user/invited");
}
function S5t(e = !0) {
  return k7(["user", "me"], async ({
    queryKey: [i, n]
  }) => W5t(), {
    useErrorBoundary: !1,
    refetchOnWindowFocus: !1,
    enabled: e
  });
}
const V5t = (e) => e == null ? void 0 : e.message.includes("403");
function w5t(e) {
  const {
    t
  } = ii(), i = ha(), n = S5t().data, g = !!(n != null && n.roleDetails["change-client"]), r = H6(), o = V5t(e.error);
  return /* @__PURE__ */ ge(Yd, { open: !0, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [
    /* @__PURE__ */ p(Dd, { id: "alert-dialog-title", children: e.heading ? e.heading : t("Fatal_Error") }),
    /* @__PURE__ */ ge(xd, { children: [
      /* @__PURE__ */ ge(Cr, { component: "div", id: "alert-dialog-description", children: [
        e.body ? e.body : t("Fatal_Error_Text"),
        /* @__PURE__ */ p(C9, {})
      ] }),
      e.error && /* @__PURE__ */ ge(Bt, { children: [
        /* @__PURE__ */ p("hr", {}),
        /* @__PURE__ */ p(Cr, { children: t("Error_Message") }),
        /* @__PURE__ */ p(Cr, { children: e.error.message })
      ] })
    ] }),
    /* @__PURE__ */ ge(Yu, { children: [
      /* @__PURE__ */ p(Si, { "data-cy": "goHome", onClick: () => {
        i("/admin"), i(0);
      }, children: t("Zur Startseite") }),
      /* @__PURE__ */ p(Si, { onClick: () => i(0), "data-cy": "reload", children: t("Neu Laden") }),
      /* @__PURE__ */ p(Si, { "data-cy": "restart", onClick: () => {
        window.localStorage.clear(), i(0);
      }, children: t("Cleanup und Neu Laden") }),
      g && r && o && /* @__PURE__ */ p(Si, { "data-cy": "changeClient", onClick: async () => {
        const I = window.location.hash.split("apps/")[1].split("/")[0], s = await G5t(Number(I));
        await y5t(s.clientId), i(0);
      }, children: t("(SU) Client wechseln") })
    ] })
  ] });
}
class v5t extends Td {
  constructor() {
    super(...arguments);
    Bg(this, "catchUnhandledRejectionErrors", !0);
  }
  renderError(i, n) {
    return n == "childComponent" ? /* @__PURE__ */ p(w5t, { error: i }) : (ef(/* @__PURE__ */ p(Ne, { variant: "body1", children: (i == null ? void 0 : i.message) + `
` + $r("You may need to reload the page") }), {
      variant: "error",
      persist: !0,
      style: {
        whiteSpace: "pre-line"
      },
      action: (g) => /* @__PURE__ */ ge(Bt, { children: [
        /* @__PURE__ */ p(mi, { "data-cy": "error-snackbar-reload", color: "primary", onClick: () => {
          window.location.reload();
        }, children: /* @__PURE__ */ p(y6e, {}) }),
        /* @__PURE__ */ p(mi, { "data-cy": "error-snackbar-close", sx: {
          color: "lightgray"
        }, onClick: () => yJ(g), children: /* @__PURE__ */ p(Lj, {}) })
      ] })
    }), this.props.children);
  }
}
const R5t = AI(() => import("./AdminRoutes-2D7kqpOs.js"));
function X5t() {
  return /* @__PURE__ */ ge(woe, { children: [
    /* @__PURE__ */ p(oY, { path: "admin/*", element: /* @__PURE__ */ p(H5t, {}) }),
    /* @__PURE__ */ p(oY, { path: "*", element: /* @__PURE__ */ p(k5t, {}) })
  ] });
}
function H5t() {
  return /* @__PURE__ */ p(v5t, { children: /* @__PURE__ */ p($V, { fallback: /* @__PURE__ */ p(B5t, {}), children: /* @__PURE__ */ p(R5t, {}) }) });
}
function k5t() {
  return /* @__PURE__ */ p(f5t, { children: /* @__PURE__ */ p(A5t, {}) });
}
class F5t extends Td {
  constructor() {
    super(...arguments);
    // Should be handled by TopLevel and FrontendTopLevel Boundaries. If these fail, it will be a component Type Error
    Bg(this, "catchUnhandledRejectionErrors", !1);
  }
  renderError() {
    const i = document.location.href.includes("/admin/") || document.location.href.endsWith("/admin"), n = i ? document.location.protocol + document.location.hostname + document.location.pathname + "#/admin/apps" : "";
    return /* @__PURE__ */ p("div", { id: "k3-global-error-container", style: {
      width: "100vw",
      height: "100vh"
    }, children: /* @__PURE__ */ p(oO, { theme: Cne, children: /* @__PURE__ */ ge("div", { style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }, children: [
      /* @__PURE__ */ ge("div", { style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ p("a", { "aria-label": "Home-Link", "data-cy": "Error-GoHome", href: "https://www.objectcode.de/", children: /* @__PURE__ */ p("img", { alt: "k3 Logo", style: {
          height: "140px",
          width: "auto"
        }, src: "https://www.objectcode.de/wp-content/uploads/2024/03/logo_blue-1174x1536.png" }) }),
        /* @__PURE__ */ ge("div", { style: {
          paddingLeft: "24px"
        }, children: [
          /* @__PURE__ */ p(Ne, { variant: "h3", color: "error", children: $r("Fatal_Error") }),
          /* @__PURE__ */ ge("div", { children: [
            /* @__PURE__ */ p(Ne, { variant: "subtitle1", children: $r("Fatal_Error_Text") }),
            /* @__PURE__ */ p(C9, {})
          ] })
        ] })
      ] }),
      i && /* @__PURE__ */ p("div", { style: {
        display: "flex",
        justifyContent: "end"
      }, children: /* @__PURE__ */ p(Si, { onClick: () => document.location.href = n, "data-cy": "errorGoStart", variant: "contained", children: $r("Zur Startseite") }) })
    ] }) }) });
  }
}
const Y5t = new oet({
  defaultOptions: {
    queries: {
      // cacheTime,
      // enabled,
      // initialData,
      // initialDataUpdatedAt,
      // isDataEqual,
      // keepPreviousData,
      // meta,
      // networkMode,
      // notifyOnChangeProps,
      // onError,
      // onSettled,
      // onSuccess,
      // placeholderData,
      // queryKeyHashFn,
      // refetchInterval,
      // refetchIntervalInBackground,
      // refetchOnMount,
      // refetchOnReconnect,
      // refetchOnWindowFocus: false,
      retry: !1,
      // retryDelay,
      // retryOnMount,
      // select,
      // staleTime: Infinity,
      // structuralSharing,
      suspense: !0,
      useErrorBoundary: !0
    },
    mutations: {
      // cacheTime,
      // meta,
      // mutationKey,
      // networkMode,
      // onError,
      // onMutate,
      // onSettled,
      // onSuccess,
      // retry,
      // retryDelay,
      // useErrorBoundary: true,
    }
  }
}), x5t = () => OZe({
  reducer: {
    actionEngine: mot,
    bom: Got,
    common: UQe,
    configurator: Pet,
    customData: HIt,
    frontend: Hot,
    k3d: Jot,
    layoutDesigner: yFt,
    metadata: lQ({
      articles: Kot,
      client: Lot,
      groups: Uot,
      images: Pot,
      materials: zot,
      models: Unt,
      prices: Oot,
      ruleItems: jot,
      rules: _ot,
      values: qot,
      variables: nIt
    }),
    order: wXt,
    ruleEngine: uot
  },
  middleware: (e) => {
    const t = jo.enableReduxDevChecks;
    return e({
      immutableCheck: t,
      serializableCheck: t ? {
        ignoredPaths: ["ruleEngine.ruleEngineInput.variables", "ruleEngine.ruleEngineConflict.ruleEngineInput.variables"],
        ignoredActionPaths: ["payload.variables", "payload.ruleEngineInput.variables"]
      } : !1,
      actionCreatorCheck: t,
      thunk: !0
    });
  }
}), u9 = x5t(), D5t = {
  ...Hpt,
  a: {
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.6)"
  },
  canvas: {
    border: "none",
    outline: "none"
  }
};
var Une = { exports: {} };
(function(e, t) {
  (function(i) {
    e.exports = i();
  })(function() {
    var i = ["navigation", "request", "process", "log", "user", "state", "error", "manual"], n = function(F, U, ee) {
      for (var j = ee, ae = 0, be = F.length; ae < be; ae++)
        j = U(j, F[ae], ae, F);
      return j;
    }, g = function(F, U) {
      return n(F, function(ee, j, ae, be) {
        return U(j, ae, be) ? ee.concat(j) : ee;
      }, []);
    }, r = function(F, U) {
      return n(F, function(ee, j, ae, be) {
        return ee === !0 || j === U;
      }, !1);
    }, o = function(F) {
      return Object.prototype.toString.call(F) === "[object Array]";
    }, I = !{
      toString: null
    }.propertyIsEnumerable("toString"), s = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], a = function(F) {
      var U = [], ee;
      for (ee in F)
        Object.prototype.hasOwnProperty.call(F, ee) && U.push(ee);
      if (!I)
        return U;
      for (var j = 0, ae = s.length; j < ae; j++)
        Object.prototype.hasOwnProperty.call(F, s[j]) && U.push(s[j]);
      return U;
    }, d = function(F, U) {
      return F === void 0 && (F = 1), function(ee) {
        return typeof ee == "number" && parseInt("" + ee, 10) === ee && ee >= F && ee <= U;
      };
    }, C = function(F) {
      return typeof F == "function" || o(F) && g(F, function(U) {
        return typeof U == "function";
      }).length === F.length;
    }, u = function(F) {
      return typeof F == "string" && !!F.length;
    }, A = {}, m = function() {
      return {
        unhandledExceptions: !0,
        unhandledRejections: !0
      };
    };
    A.schema = {
      apiKey: {
        defaultValue: function() {
          return null;
        },
        message: "is required",
        validate: u
      },
      appVersion: {
        defaultValue: function() {
        },
        message: "should be a string",
        validate: function(F) {
          return F === void 0 || u(F);
        }
      },
      appType: {
        defaultValue: function() {
        },
        message: "should be a string",
        validate: function(F) {
          return F === void 0 || u(F);
        }
      },
      autoDetectErrors: {
        defaultValue: function() {
          return !0;
        },
        message: "should be true|false",
        validate: function(F) {
          return F === !0 || F === !1;
        }
      },
      enabledErrorTypes: {
        defaultValue: function() {
          return m();
        },
        message: "should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }",
        allowPartialObject: !0,
        validate: function(F) {
          if (typeof F != "object" || !F)
            return !1;
          var U = a(F), ee = a(m());
          return !(g(U, function(j) {
            return r(ee, j);
          }).length < U.length || g(a(F), function(j) {
            return typeof F[j] != "boolean";
          }).length > 0);
        }
      },
      onError: {
        defaultValue: function() {
          return [];
        },
        message: "should be a function or array of functions",
        validate: C
      },
      onSession: {
        defaultValue: function() {
          return [];
        },
        message: "should be a function or array of functions",
        validate: C
      },
      onBreadcrumb: {
        defaultValue: function() {
          return [];
        },
        message: "should be a function or array of functions",
        validate: C
      },
      endpoints: {
        defaultValue: function() {
          return {
            notify: "https://notify.bugsnag.com",
            sessions: "https://sessions.bugsnag.com"
          };
        },
        message: "should be an object containing endpoint URLs { notify, sessions }",
        validate: function(F) {
          return (
            // first, ensure it's an object
            F && typeof F == "object" && // notify and sessions must always be set
            u(F.notify) && u(F.sessions) && // ensure no keys other than notify/session are set on endpoints object
            g(a(F), function(U) {
              return !r(["notify", "sessions"], U);
            }).length === 0
          );
        }
      },
      autoTrackSessions: {
        defaultValue: function(F) {
          return !0;
        },
        message: "should be true|false",
        validate: function(F) {
          return F === !0 || F === !1;
        }
      },
      enabledReleaseStages: {
        defaultValue: function() {
          return null;
        },
        message: "should be an array of strings",
        validate: function(F) {
          return F === null || o(F) && g(F, function(U) {
            return typeof U == "string";
          }).length === F.length;
        }
      },
      releaseStage: {
        defaultValue: function() {
          return "production";
        },
        message: "should be a string",
        validate: function(F) {
          return typeof F == "string" && F.length;
        }
      },
      maxBreadcrumbs: {
        defaultValue: function() {
          return 25;
        },
        message: "should be a number ≤100",
        validate: function(F) {
          return d(0, 100)(F);
        }
      },
      enabledBreadcrumbTypes: {
        defaultValue: function() {
          return i;
        },
        message: "should be null or a list of available breadcrumb types (" + i.join(",") + ")",
        validate: function(F) {
          return F === null || o(F) && n(F, function(U, ee) {
            return U === !1 ? U : r(i, ee);
          }, !0);
        }
      },
      context: {
        defaultValue: function() {
        },
        message: "should be a string",
        validate: function(F) {
          return F === void 0 || typeof F == "string";
        }
      },
      user: {
        defaultValue: function() {
          return {};
        },
        message: "should be an object with { id, email, name } properties",
        validate: function(F) {
          return F === null || F && n(a(F), function(U, ee) {
            return U && r(["id", "email", "name"], ee);
          }, !0);
        }
      },
      metadata: {
        defaultValue: function() {
          return {};
        },
        message: "should be an object",
        validate: function(F) {
          return typeof F == "object" && F !== null;
        }
      },
      logger: {
        defaultValue: function() {
        },
        message: "should be null or an object with methods { debug, info, warn, error }",
        validate: function(F) {
          return !F || F && n(["debug", "info", "warn", "error"], function(U, ee) {
            return U && typeof F[ee] == "function";
          }, !0);
        }
      },
      redactedKeys: {
        defaultValue: function() {
          return ["password"];
        },
        message: "should be an array of strings|regexes",
        validate: function(F) {
          return o(F) && F.length === g(F, function(U) {
            return typeof U == "string" || U && typeof U.test == "function";
          }).length;
        }
      },
      plugins: {
        defaultValue: function() {
          return [];
        },
        message: "should be an array of plugin objects",
        validate: function(F) {
          return o(F) && F.length === g(F, function(U) {
            return U && typeof U == "object" && typeof U.load == "function";
          }).length;
        }
      },
      featureFlags: {
        defaultValue: function() {
          return [];
        },
        message: 'should be an array of objects that have a "name" property',
        validate: function(F) {
          return o(F) && F.length === g(F, function(U) {
            return U && typeof U == "object" && typeof U.name == "string";
          }).length;
        }
      }
    };
    var h = function(F) {
      for (var U = 1; U < arguments.length; U++) {
        var ee = arguments[U];
        for (var j in ee)
          Object.prototype.hasOwnProperty.call(ee, j) && (F[j] = ee[j]);
      }
      return F;
    }, B = function(F, U) {
      return n(F, function(ee, j, ae, be) {
        return ee.concat(U(j, ae, be));
      }, []);
    };
    function f() {
      return f = Object.assign ? Object.assign.bind() : function(F) {
        for (var U = 1; U < arguments.length; U++) {
          var ee = arguments[U];
          for (var j in ee)
            Object.prototype.hasOwnProperty.call(ee, j) && (F[j] = ee[j]);
        }
        return F;
      }, f.apply(this, arguments);
    }
    var G = A.schema, y = {
      releaseStage: h({}, G.releaseStage, {
        defaultValue: function() {
          return /^localhost(:\d+)?$/.test(window.location.host) ? "development" : "production";
        }
      }),
      appType: f({}, G.appType, {
        defaultValue: function() {
          return "browser";
        }
      }),
      logger: h({}, G.logger, {
        defaultValue: function() {
          return (
            // set logger based on browser capability
            typeof console < "u" && typeof console.debug == "function" ? W() : void 0
          );
        }
      })
    }, W = function() {
      var F = {}, U = console.log;
      return B(["debug", "info", "warn", "error"], function(ee) {
        var j = console[ee];
        F[ee] = typeof j == "function" ? j.bind(console, "[bugsnag]") : U.bind(console, "[bugsnag]");
      }), F;
    }, V = /* @__PURE__ */ function() {
      function F(ee, j, ae, be) {
        be === void 0 && (be = /* @__PURE__ */ new Date()), this.type = ae, this.message = ee, this.metadata = j, this.timestamp = be;
      }
      var U = F.prototype;
      return U.toJSON = function() {
        return {
          type: this.type,
          name: this.message,
          timestamp: this.timestamp,
          metaData: this.metadata
        };
      }, F;
    }(), w = V, v = {};
    (function(F, U) {
      typeof v == "object" ? v = U() : F.StackFrame = U();
    })(this, function() {
      function F(ht) {
        return !isNaN(parseFloat(ht)) && isFinite(ht);
      }
      function U(ht) {
        return ht.charAt(0).toUpperCase() + ht.substring(1);
      }
      function ee(ht) {
        return function() {
          return this[ht];
        };
      }
      var j = ["isConstructor", "isEval", "isNative", "isToplevel"], ae = ["columnNumber", "lineNumber"], be = ["fileName", "functionName", "source"], ke = ["args"], gt = j.concat(ae, be, ke);
      function Qe(ht) {
        if (ht instanceof Object)
          for (var ci = 0; ci < gt.length; ci++)
            ht.hasOwnProperty(gt[ci]) && ht[gt[ci]] !== void 0 && this["set" + U(gt[ci])](ht[gt[ci]]);
      }
      Qe.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(ht) {
          if (Object.prototype.toString.call(ht) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = ht;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(ht) {
          if (ht instanceof Qe)
            this.evalOrigin = ht;
          else if (ht instanceof Object)
            this.evalOrigin = new Qe(ht);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var ht = this.getFunctionName() || "{anonymous}", ci = "(" + (this.getArgs() || []).join(",") + ")", ai = this.getFileName() ? "@" + this.getFileName() : "", vn = F(this.getLineNumber()) ? ":" + this.getLineNumber() : "", Ot = F(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
          return ht + ci + ai + vn + Ot;
        }
      };
      for (var ut = 0; ut < j.length; ut++)
        Qe.prototype["get" + U(j[ut])] = ee(j[ut]), Qe.prototype["set" + U(j[ut])] = /* @__PURE__ */ function(ht) {
          return function(ci) {
            this[ht] = !!ci;
          };
        }(j[ut]);
      for (var wt = 0; wt < ae.length; wt++)
        Qe.prototype["get" + U(ae[wt])] = ee(ae[wt]), Qe.prototype["set" + U(ae[wt])] = /* @__PURE__ */ function(ht) {
          return function(ci) {
            if (!F(ci))
              throw new TypeError(ht + " must be a Number");
            this[ht] = Number(ci);
          };
        }(ae[wt]);
      for (var Et = 0; Et < be.length; Et++)
        Qe.prototype["get" + U(be[Et])] = ee(be[Et]), Qe.prototype["set" + U(be[Et])] = /* @__PURE__ */ function(ht) {
          return function(ci) {
            this[ht] = String(ci);
          };
        }(be[Et]);
      return Qe;
    });
    var H = {};
    (function(F, U) {
      typeof H == "object" ? H = U(v) : F.ErrorStackParser = U(F.StackFrame);
    })(this, function(U) {
      var ee = /(^|@)\S+\:\d+/, j = /^\s*at .*(\S+\:\d+|\(native\))/m, ae = /^(eval@)?(\[native code\])?$/;
      return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function(ke) {
          if (typeof ke.stacktrace < "u" || typeof ke["opera#sourceloc"] < "u")
            return this.parseOpera(ke);
          if (ke.stack && ke.stack.match(j))
            return this.parseV8OrIE(ke);
          if (ke.stack)
            return this.parseFFOrSafari(ke);
          throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function(ke) {
          if (ke.indexOf(":") === -1)
            return [ke];
          var gt = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/, Qe = gt.exec(ke.replace(/[\(\)]/g, ""));
          return [Qe[1], Qe[2] || void 0, Qe[3] || void 0];
        },
        parseV8OrIE: function(ke) {
          var gt = ke.stack.split(`
`).filter(function(Qe) {
            return !!Qe.match(j);
          }, this);
          return gt.map(function(Qe) {
            Qe.indexOf("(eval ") > -1 && (Qe = Qe.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, ""));
            var ut = Qe.replace(/^\s+/, "").replace(/\(eval code/g, "("), wt = ut.match(/ (\((.+):(\d+):(\d+)\)$)/);
            ut = wt ? ut.replace(wt[0], "") : ut;
            var Et = ut.split(/\s+/).slice(1), ht = this.extractLocation(wt ? wt[1] : Et.pop()), ci = Et.join(" ") || void 0, ai = ["eval", "<anonymous>"].indexOf(ht[0]) > -1 ? void 0 : ht[0];
            return new U({
              functionName: ci,
              fileName: ai,
              lineNumber: ht[1],
              columnNumber: ht[2],
              source: Qe
            });
          }, this);
        },
        parseFFOrSafari: function(ke) {
          var gt = ke.stack.split(`
`).filter(function(Qe) {
            return !Qe.match(ae);
          }, this);
          return gt.map(function(Qe) {
            if (Qe.indexOf(" > eval") > -1 && (Qe = Qe.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1")), Qe.indexOf("@") === -1 && Qe.indexOf(":") === -1)
              return new U({
                functionName: Qe
              });
            var ut = /((.*".+"[^@]*)?[^@]*)(?:@)/, wt = Qe.match(ut), Et = wt && wt[1] ? wt[1] : void 0, ht = this.extractLocation(Qe.replace(ut, ""));
            return new U({
              functionName: Et,
              fileName: ht[0],
              lineNumber: ht[1],
              columnNumber: ht[2],
              source: Qe
            });
          }, this);
        },
        parseOpera: function(ke) {
          return !ke.stacktrace || ke.message.indexOf(`
`) > -1 && ke.message.split(`
`).length > ke.stacktrace.split(`
`).length ? this.parseOpera9(ke) : ke.stack ? this.parseOpera11(ke) : this.parseOpera10(ke);
        },
        parseOpera9: function(ke) {
          for (var gt = /Line (\d+).*script (?:in )?(\S+)/i, Qe = ke.message.split(`
`), ut = [], wt = 2, Et = Qe.length; wt < Et; wt += 2) {
            var ht = gt.exec(Qe[wt]);
            ht && ut.push(new U({
              fileName: ht[2],
              lineNumber: ht[1],
              source: Qe[wt]
            }));
          }
          return ut;
        },
        parseOpera10: function(ke) {
          for (var gt = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, Qe = ke.stacktrace.split(`
`), ut = [], wt = 0, Et = Qe.length; wt < Et; wt += 2) {
            var ht = gt.exec(Qe[wt]);
            ht && ut.push(new U({
              functionName: ht[3] || void 0,
              fileName: ht[2],
              lineNumber: ht[1],
              source: Qe[wt]
            }));
          }
          return ut;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function(ke) {
          var gt = ke.stack.split(`
`).filter(function(Qe) {
            return !!Qe.match(ee) && !Qe.match(/^Error created at/);
          }, this);
          return gt.map(function(Qe) {
            var ut = Qe.split("@"), wt = this.extractLocation(ut.pop()), Et = ut.shift() || "", ht = Et.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || void 0, ci;
            Et.match(/\(([^\)]*)\)/) && (ci = Et.replace(/^[^\(]+\(([^\)]*)\)$/, "$1"));
            var ai = ci === void 0 || ci === "[arguments not available]" ? void 0 : ci.split(",");
            return new U({
              functionName: ht,
              args: ai,
              fileName: wt[0],
              lineNumber: wt[1],
              columnNumber: wt[2],
              source: Qe
            });
          }, this);
        }
      };
    });
    var x = H, N = function(F, U, ee, j) {
      var ae = j && j.redactedKeys ? j.redactedKeys : [], be = j && j.redactedPaths ? j.redactedPaths : [];
      return JSON.stringify(Ee(F, ae, be), U, ee);
    }, M = 20, $ = 25e3, q = 8, E = "...";
    function L(F) {
      return F instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(F));
    }
    function P(F) {
      return "[Throws: " + (F ? F.message : "?") + "]";
    }
    function Q(F, U) {
      for (var ee = 0, j = F.length; ee < j; ee++)
        if (F[ee] === U)
          return !0;
      return !1;
    }
    function te(F, U) {
      for (var ee = 0, j = F.length; ee < j; ee++)
        if (U.indexOf(F[ee]) === 0)
          return !0;
      return !1;
    }
    function le(F, U) {
      for (var ee = 0, j = F.length; ee < j; ee++)
        if (typeof F[ee] == "string" && F[ee].toLowerCase() === U.toLowerCase() || F[ee] && typeof F[ee].test == "function" && F[ee].test(U))
          return !0;
      return !1;
    }
    function Ae(F) {
      return Object.prototype.toString.call(F) === "[object Array]";
    }
    function we(F, U) {
      try {
        return F[U];
      } catch (ee) {
        return P(ee);
      }
    }
    function Ee(F, U, ee) {
      var j = [], ae = 0;
      function be(ke, gt) {
        function Qe() {
          return gt.length > q && ae > $;
        }
        if (ae++, gt.length > M || Qe())
          return E;
        if (ke === null || typeof ke != "object")
          return ke;
        if (Q(j, ke))
          return "[Circular]";
        if (j.push(ke), typeof ke.toJSON == "function")
          try {
            ae--;
            var ut = be(ke.toJSON(), gt);
            return j.pop(), ut;
          } catch (yi) {
            return P(yi);
          }
        var wt = L(ke);
        if (wt) {
          ae--;
          var Et = be({
            name: ke.name,
            message: ke.message
          }, gt);
          return j.pop(), Et;
        }
        if (Ae(ke)) {
          for (var ht = [], ci = 0, ai = ke.length; ci < ai; ci++) {
            if (Qe()) {
              ht.push(E);
              break;
            }
            ht.push(be(ke[ci], gt.concat("[]")));
          }
          return j.pop(), ht;
        }
        var vn = {};
        try {
          for (var Ot in ke)
            if (Object.prototype.hasOwnProperty.call(ke, Ot)) {
              if (te(ee, gt.join(".")) && le(U, Ot)) {
                vn[Ot] = "[REDACTED]";
                continue;
              }
              if (Qe()) {
                vn[Ot] = E;
                break;
              }
              vn[Ot] = be(we(ke, Ot), gt.concat(Ot));
            }
        } catch {
        }
        return j.pop(), vn;
      }
      return be(F, []);
    }
    function Je(F, U, ee, j) {
      if (typeof ee == "string") {
        j === void 0 ? j = null : j !== null && typeof j != "string" && (j = N(j));
        var ae = U[ee];
        if (typeof ae == "number") {
          F[ae] = {
            name: ee,
            variant: j
          };
          return;
        }
        F.push({
          name: ee,
          variant: j
        }), U[ee] = F.length - 1;
      }
    }
    function ve(F, U, ee) {
      if (o(U)) {
        for (var j = 0; j < U.length; ++j) {
          var ae = U[j];
          ae === null || typeof ae != "object" || Je(F, ee, ae.name, ae.variant);
        }
        return F;
      }
    }
    function Be(F) {
      return B(g(F, Boolean), function(U) {
        var ee = U.name, j = U.variant, ae = {
          featureFlag: ee
        };
        return typeof j == "string" && (ae.variant = j), ae;
      });
    }
    function ue(F, U, ee) {
      var j = U[ee];
      typeof j == "number" && (F[j] = null, delete U[ee]);
    }
    var Xe = {
      add: Je,
      clear: ue,
      merge: ve,
      toEventApi: Be
    }, Ze = function(F) {
      return !!F && (!!F.stack || !!F.stacktrace || !!F["opera#sourceloc"]) && typeof (F.stack || F.stacktrace || F["opera#sourceloc"]) == "string" && F.stack !== F.name + ": " + F.message;
    }, Ke = $e;
    function $e(F) {
      switch (Object.prototype.toString.call(F)) {
        case "[object Error]":
          return !0;
        case "[object Exception]":
          return !0;
        case "[object DOMException]":
          return !0;
        default:
          return F instanceof Error;
      }
    }
    var rt = Ke, dt = function(F, U, ee, j) {
      var ae;
      if (U) {
        var be;
        if (ee === null)
          return ze(F, U);
        typeof ee == "object" && (be = ee), typeof ee == "string" && (be = (ae = {}, ae[ee] = j, ae)), be && (U === "__proto__" || U === "constructor" || U === "prototype" || (F[U] || (F[U] = {}), F[U] = h({}, F[U], be)));
      }
    }, ot = function(F, U, ee) {
      if (typeof U == "string") {
        if (!ee)
          return F[U];
        if (F[U])
          return F[U][ee];
      }
    }, ze = function(F, U, ee) {
      if (typeof U == "string") {
        if (!ee) {
          delete F[U];
          return;
        }
        U === "__proto__" || U === "constructor" || U === "prototype" || F[U] && delete F[U][ee];
      }
    }, tt = {
      add: dt,
      get: ot,
      clear: ze
    }, st = {};
    (function(F, U) {
      typeof st == "object" ? st = U(v) : F.StackGenerator = U(F.StackFrame);
    })(this, function(F) {
      return {
        backtrace: function(ee) {
          var j = [], ae = 10;
          typeof ee == "object" && typeof ee.maxStackSize == "number" && (ae = ee.maxStackSize);
          for (var be = arguments.callee; be && j.length < ae && be.arguments; ) {
            for (var ke = new Array(be.arguments.length), gt = 0; gt < ke.length; ++gt)
              ke[gt] = be.arguments[gt];
            /function(?:\s+([\w$]+))+\s*\(/.test(be.toString()) ? j.push(new F({
              functionName: RegExp.$1 || void 0,
              args: ke
            })) : j.push(new F({
              args: ke
            }));
            try {
              be = be.caller;
            } catch {
              break;
            }
          }
          return j;
        }
      };
    });
    var Kt = /* @__PURE__ */ function() {
      function F(ee, j, ae, be, ke) {
        ae === void 0 && (ae = []), be === void 0 && (be = Ce()), this.apiKey = void 0, this.context = void 0, this.groupingHash = void 0, this.originalError = ke, this._handledState = be, this.severity = this._handledState.severity, this.unhandled = this._handledState.unhandled, this.app = {}, this.device = {}, this.request = {}, this.breadcrumbs = [], this.threads = [], this._metadata = {}, this._features = [], this._featuresIndex = {}, this._user = {}, this._session = void 0, this.errors = [Le(ee, j, F.__type, ae)];
      }
      var U = F.prototype;
      return U.addMetadata = function(j, ae, be) {
        return tt.add(this._metadata, j, ae, be);
      }, U.getMetadata = function(j, ae) {
        return tt.get(this._metadata, j, ae);
      }, U.clearMetadata = function(j, ae) {
        return tt.clear(this._metadata, j, ae);
      }, U.addFeatureFlag = function(j, ae) {
        ae === void 0 && (ae = null), Xe.add(this._features, this._featuresIndex, j, ae);
      }, U.addFeatureFlags = function(j) {
        Xe.merge(this._features, j, this._featuresIndex);
      }, U.getFeatureFlags = function() {
        return Xe.toEventApi(this._features);
      }, U.clearFeatureFlag = function(j) {
        Xe.clear(this._features, this._featuresIndex, j);
      }, U.clearFeatureFlags = function() {
        this._features = [], this._featuresIndex = {};
      }, U.getUser = function() {
        return this._user;
      }, U.setUser = function(j, ae, be) {
        this._user = {
          id: j,
          email: ae,
          name: be
        };
      }, U.toJSON = function() {
        return {
          payloadVersion: "4",
          exceptions: B(this.errors, function(j) {
            return h({}, j, {
              message: j.errorMessage
            });
          }),
          severity: this.severity,
          unhandled: this._handledState.unhandled,
          severityReason: this._handledState.severityReason,
          app: this.app,
          device: this.device,
          request: this.request,
          breadcrumbs: this.breadcrumbs,
          context: this.context,
          groupingHash: this.groupingHash,
          metaData: this._metadata,
          user: this._user,
          session: this._session,
          featureFlags: this.getFeatureFlags()
        };
      }, F;
    }(), ie = function(F) {
      var U = {
        file: F.fileName,
        method: J(F.functionName),
        lineNumber: F.lineNumber,
        columnNumber: F.columnNumber,
        code: void 0,
        inProject: void 0
      };
      return U.lineNumber > -1 && !U.file && !U.method && (U.file = "global code"), U;
    }, J = function(F) {
      return /^global code$/i.test(F) ? "global code" : F;
    }, Ce = function() {
      return {
        unhandled: !1,
        severity: "warning",
        severityReason: {
          type: "handledException"
        }
      };
    }, xe = function(F) {
      return typeof F == "string" ? F : "";
    };
    function Le(F, U, ee, j) {
      return {
        errorClass: xe(F),
        errorMessage: xe(U),
        type: ee,
        stacktrace: n(j, function(ae, be) {
          var ke = ie(be);
          try {
            return JSON.stringify(ke) === "{}" ? ae : ae.concat(ke);
          } catch {
            return ae;
          }
        }, [])
      };
    }
    function Ye(F) {
      return F.cause ? [F].concat(Ye(F.cause)) : [F];
    }
    Kt.getStacktrace = function(F, U, ee) {
      if (Ze(F))
        return x.parse(F).slice(U);
      try {
        return g(st.backtrace(), function(j) {
          return (j.functionName || "").indexOf("StackGenerator$$") === -1;
        }).slice(1 + ee);
      } catch {
        return [];
      }
    }, Kt.create = function(F, U, ee, j, ae, be) {
      ae === void 0 && (ae = 0);
      var ke = Yt(F, U, j, be), gt = ke[0], Qe = ke[1], ut;
      try {
        var wt = Kt.getStacktrace(
          gt,
          // if an error was created/throw in the normaliseError() function, we need to
          // tell the getStacktrace() function to skip the number of frames we know will
          // be from our own functions. This is added to the number of frames deep we
          // were told about
          Qe > 0 ? 1 + Qe + ae : 0,
          // if there's no stacktrace, the callstack may be walked to generated one.
          // this is how many frames should be removed because they come from our library
          1 + ae
        );
        ut = new Kt(gt.name, gt.message, wt, ee, F);
      } catch {
        ut = new Kt(gt.name, gt.message, [], ee, F);
      }
      if (gt.name === "InvalidError" && ut.addMetadata("" + j, "non-error parameter", qe(F)), gt.cause) {
        var Et, ht = Ye(gt).slice(1), ci = B(ht, function(ai) {
          var vn = rt(ai) && Ze(ai) ? x.parse(ai) : [], Ot = Yt(ai, !0, "error cause"), yi = Ot[0];
          return yi.name === "InvalidError" && ut.addMetadata("error cause", qe(ai)), Le(yi.name, yi.message, Kt.__type, vn);
        });
        (Et = ut.errors).push.apply(Et, ci);
      }
      return ut;
    };
    var qe = function(F) {
      return F === null ? "null" : F === void 0 ? "undefined" : F;
    }, Yt = function(F, U, ee, j) {
      var ae, be = 0, ke = function(gt) {
        var Qe = ee === "error cause" ? "was" : "received";
        j && j.warn(ee + " " + Qe + ' a non-error: "' + gt + '"');
        var ut = new Error(ee + " " + Qe + ' a non-error. See "' + ee + '" tab for more detail.');
        return ut.name = "InvalidError", ut;
      };
      if (!U)
        rt(F) ? ae = F : (ae = ke(typeof F), be += 2);
      else
        switch (typeof F) {
          case "string":
          case "number":
          case "boolean":
            ae = new Error(String(F)), be += 1;
            break;
          case "function":
            ae = ke("function"), be += 2;
            break;
          case "object":
            F !== null && rt(F) ? ae = F : F !== null && qt(F) ? (ae = new Error(F.message || F.errorMessage), ae.name = F.name || F.errorClass, be += 1) : (ae = ke(F === null ? "null" : "unsupported object"), be += 2);
            break;
          default:
            ae = ke("nothing"), be += 2;
        }
      if (!Ze(ae))
        try {
          throw ae;
        } catch (gt) {
          Ze(gt) && (ae = gt, be = 1);
        }
      return [ae, be];
    };
    Kt.__type = "browserjs";
    var qt = function(F) {
      return (typeof F.name == "string" || typeof F.errorClass == "string") && (typeof F.message == "string" || typeof F.errorMessage == "string");
    }, Ut = Kt, Ge = function(F, U, ee) {
      var j = 0, ae = function() {
        if (j >= F.length)
          return ee(null, !0);
        U(F[j], function(be, ke) {
          if (be)
            return ee(be);
          if (ke === !1)
            return ee(null, !1);
          j++, ae();
        });
      };
      ae();
    }, pe = function(F, U, ee, j) {
      var ae = function(be, ke) {
        if (typeof be != "function")
          return ke(null);
        try {
          if (be.length !== 2) {
            var gt = be(U);
            return gt && typeof gt.then == "function" ? gt.then(
              // resolve
              function(Qe) {
                return setTimeout(function() {
                  return ke(null, Qe);
                });
              },
              // reject
              function(Qe) {
                setTimeout(function() {
                  return ee(Qe), ke(null, !0);
                });
              }
            ) : ke(null, gt);
          }
          be(U, function(Qe, ut) {
            if (Qe)
              return ee(Qe), ke(null);
            ke(null, ut);
          });
        } catch (Qe) {
          ee(Qe), ke(null);
        }
      };
      Ge(F, ae, j);
    }, _e = function(F, U, ee, j) {
      for (var ae = !1, be = F.slice(); !ae && be.length; )
        try {
          ae = be.pop()(U) === !1;
        } catch (ke) {
          j.error("Error occurred in " + ee + " callback, continuing anyway…"), j.error(ke);
        }
      return ae;
    }, Gt = function(U, ee) {
      var j = "000000000" + U;
      return j.substr(j.length - ee);
    }, Jt = typeof window == "object" ? window : self, Te = 0;
    for (var Xt in Jt)
      Object.hasOwnProperty.call(Jt, Xt) && Te++;
    var Pe = navigator.mimeTypes ? navigator.mimeTypes.length : 0, Oe = Gt((Pe + navigator.userAgent.length).toString(36) + Te.toString(36), 4), kt = function() {
      return Oe;
    }, Nt = 0, ni = 4, si = 36, jt = Math.pow(si, ni);
    function Zi() {
      return Gt((Math.random() * jt << 0).toString(si), ni);
    }
    function fi() {
      return Nt = Nt < jt ? Nt : 0, Nt++, Nt - 1;
    }
    function on() {
      var F = "c", U = (/* @__PURE__ */ new Date()).getTime().toString(si), ee = Gt(fi().toString(si), ni), j = kt(), ae = Zi() + Zi();
      return F + U + ee + j + ae;
    }
    on.fingerprint = kt;
    var In = on, xn = /* @__PURE__ */ function() {
      function F() {
        this.id = In(), this.startedAt = /* @__PURE__ */ new Date(), this._handled = 0, this._unhandled = 0, this._user = {}, this.app = {}, this.device = {};
      }
      var U = F.prototype;
      return U.getUser = function() {
        return this._user;
      }, U.setUser = function(j, ae, be) {
        this._user = {
          id: j,
          email: ae,
          name: be
        };
      }, U.toJSON = function() {
        return {
          id: this.id,
          startedAt: this.startedAt,
          events: {
            handled: this._handled,
            unhandled: this._unhandled
          }
        };
      }, U._track = function(j) {
        this[j._handledState.unhandled ? "_unhandled" : "_handled"] += 1;
      }, F;
    }(), ln = xn, ug = Xe.add, Ti = Xe.clear, vi = Xe.merge, ei = function() {
    }, yn = /* @__PURE__ */ function() {
      function F(ee, j, ae, be) {
        var ke = this;
        j === void 0 && (j = A.schema), ae === void 0 && (ae = []), this._notifier = be, this._config = {}, this._schema = j, this._delivery = {
          sendSession: ei,
          sendEvent: ei
        }, this._logger = {
          debug: ei,
          info: ei,
          warn: ei,
          error: ei
        }, this._plugins = {}, this._breadcrumbs = [], this._session = null, this._metadata = {}, this._featuresIndex = {}, this._features = [], this._context = void 0, this._user = {}, this._cbs = {
          e: [],
          s: [],
          sp: [],
          b: []
        }, this.Client = F, this.Event = Ut, this.Breadcrumb = w, this.Session = ln, this._config = this._configure(ee, ae), B(ae.concat(this._config.plugins), function(ut) {
          ut && ke._loadPlugin(ut);
        }), this._depth = 1;
        var gt = this, Qe = this.notify;
        this.notify = function() {
          return Qe.apply(gt, arguments);
        };
      }
      var U = F.prototype;
      return U.addMetadata = function(j, ae, be) {
        return tt.add(this._metadata, j, ae, be);
      }, U.getMetadata = function(j, ae) {
        return tt.get(this._metadata, j, ae);
      }, U.clearMetadata = function(j, ae) {
        return tt.clear(this._metadata, j, ae);
      }, U.addFeatureFlag = function(j, ae) {
        ae === void 0 && (ae = null), ug(this._features, this._featuresIndex, j, ae);
      }, U.addFeatureFlags = function(j) {
        vi(this._features, j, this._featuresIndex);
      }, U.clearFeatureFlag = function(j) {
        Ti(this._features, this._featuresIndex, j);
      }, U.clearFeatureFlags = function() {
        this._features = [], this._featuresIndex = {};
      }, U.getContext = function() {
        return this._context;
      }, U.setContext = function(j) {
        this._context = j;
      }, U._configure = function(j, ae) {
        var be = n(ae, function(ut, wt) {
          return wt && wt.configSchema ? h({}, ut, wt.configSchema) : ut;
        }, this._schema), ke = n(a(be), function(ut, wt) {
          var Et = be[wt].defaultValue(j[wt]);
          if (j[wt] !== void 0) {
            var ht = be[wt].validate(j[wt]);
            ht ? be[wt].allowPartialObject ? ut.config[wt] = h(Et, j[wt]) : ut.config[wt] = j[wt] : (ut.errors[wt] = be[wt].message, ut.config[wt] = Et);
          } else
            ut.config[wt] = Et;
          return ut;
        }, {
          errors: {},
          config: {}
        }), gt = ke.errors, Qe = ke.config;
        if (be.apiKey) {
          if (!Qe.apiKey)
            throw new Error("No Bugsnag API Key set");
          /^[0-9a-f]{32}$/i.test(Qe.apiKey) || (gt.apiKey = "should be a string of 32 hexadecimal characters");
        }
        return this._metadata = h({}, Qe.metadata), vi(this._features, Qe.featureFlags, this._featuresIndex), this._user = h({}, Qe.user), this._context = Qe.context, Qe.logger && (this._logger = Qe.logger), Qe.onError && (this._cbs.e = this._cbs.e.concat(Qe.onError)), Qe.onBreadcrumb && (this._cbs.b = this._cbs.b.concat(Qe.onBreadcrumb)), Qe.onSession && (this._cbs.s = this._cbs.s.concat(Qe.onSession)), a(gt).length && this._logger.warn(Mi(gt, j)), Qe;
      }, U.getUser = function() {
        return this._user;
      }, U.setUser = function(j, ae, be) {
        this._user = {
          id: j,
          email: ae,
          name: be
        };
      }, U._loadPlugin = function(j) {
        var ae = j.load(this);
        return j.name && (this._plugins["~" + j.name + "~"] = ae), this;
      }, U.getPlugin = function(j) {
        return this._plugins["~" + j + "~"];
      }, U._setDelivery = function(j) {
        this._delivery = j(this);
      }, U.startSession = function() {
        var j = new ln();
        j.app.releaseStage = this._config.releaseStage, j.app.version = this._config.appVersion, j.app.type = this._config.appType, j._user = h({}, this._user);
        var ae = _e(this._cbs.s, j, "onSession", this._logger);
        return ae ? (this._logger.debug("Session not started due to onSession callback"), this) : this._sessionDelegate.startSession(this, j);
      }, U.addOnError = function(j, ae) {
        ae === void 0 && (ae = !1), this._cbs.e[ae ? "unshift" : "push"](j);
      }, U.removeOnError = function(j) {
        this._cbs.e = g(this._cbs.e, function(ae) {
          return ae !== j;
        });
      }, U._addOnSessionPayload = function(j) {
        this._cbs.sp.push(j);
      }, U.addOnSession = function(j) {
        this._cbs.s.push(j);
      }, U.removeOnSession = function(j) {
        this._cbs.s = g(this._cbs.s, function(ae) {
          return ae !== j;
        });
      }, U.addOnBreadcrumb = function(j, ae) {
        ae === void 0 && (ae = !1), this._cbs.b[ae ? "unshift" : "push"](j);
      }, U.removeOnBreadcrumb = function(j) {
        this._cbs.b = g(this._cbs.b, function(ae) {
          return ae !== j;
        });
      }, U.pauseSession = function() {
        return this._sessionDelegate.pauseSession(this);
      }, U.resumeSession = function() {
        return this._sessionDelegate.resumeSession(this);
      }, U.leaveBreadcrumb = function(j, ae, be) {
        if (j = typeof j == "string" ? j : "", be = typeof be == "string" && r(i, be) ? be : "manual", ae = typeof ae == "object" && ae !== null ? ae : {}, !!j) {
          var ke = new w(j, ae, be), gt = _e(this._cbs.b, ke, "onBreadcrumb", this._logger);
          if (gt) {
            this._logger.debug("Breadcrumb not attached due to onBreadcrumb callback");
            return;
          }
          this._breadcrumbs.push(ke), this._breadcrumbs.length > this._config.maxBreadcrumbs && (this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs));
        }
      }, U._isBreadcrumbTypeEnabled = function(j) {
        var ae = this._config.enabledBreadcrumbTypes;
        return ae === null || r(ae, j);
      }, U.notify = function(j, ae, be) {
        be === void 0 && (be = ei);
        var ke = Ut.create(j, !0, void 0, "notify()", this._depth + 1, this._logger);
        this._notify(ke, ae, be);
      }, U._notify = function(j, ae, be) {
        var ke = this;
        if (be === void 0 && (be = ei), j.app = h({}, j.app, {
          releaseStage: this._config.releaseStage,
          version: this._config.appVersion,
          type: this._config.appType
        }), j.context = j.context || this._context, j._metadata = h({}, j._metadata, this._metadata), j._user = h({}, j._user, this._user), j.breadcrumbs = this._breadcrumbs.slice(), vi(j._features, this._features, j._featuresIndex), this._config.enabledReleaseStages !== null && !r(this._config.enabledReleaseStages, this._config.releaseStage))
          return this._logger.warn("Event not sent due to releaseStage/enabledReleaseStages configuration"), be(null, j);
        var gt = j.severity, Qe = function(wt) {
          ke._logger.error("Error occurred in onError callback, continuing anyway…"), ke._logger.error(wt);
        }, ut = [].concat(this._cbs.e).concat(ae);
        pe(ut, j, Qe, function(wt, Et) {
          if (wt && Qe(wt), !Et)
            return ke._logger.debug("Event not sent due to onError callback"), be(null, j);
          ke._isBreadcrumbTypeEnabled("error") && F.prototype.leaveBreadcrumb.call(ke, j.errors[0].errorClass, {
            errorClass: j.errors[0].errorClass,
            errorMessage: j.errors[0].errorMessage,
            severity: j.severity
          }, "error"), gt !== j.severity && (j._handledState.severityReason = {
            type: "userCallbackSetSeverity"
          }), j.unhandled !== j._handledState.unhandled && (j._handledState.severityReason.unhandledOverridden = !0, j._handledState.unhandled = j.unhandled), ke._session && (ke._session._track(j), j._session = ke._session), ke._delivery.sendEvent({
            apiKey: j.apiKey || ke._config.apiKey,
            notifier: ke._notifier,
            events: [j]
          }, function(ht) {
            return be(ht, j);
          });
        });
      }, F;
    }(), Mi = function(F, U) {
      var ee = new Error(`Invalid configuration
` + B(a(F), function(j) {
        return "  - " + j + " " + F[j] + ", got " + bn(U[j]);
      }).join(`

`));
      return ee;
    }, bn = function(F) {
      switch (typeof F) {
        case "string":
        case "number":
        case "object":
          return JSON.stringify(F);
        default:
          return String(F);
      }
    }, Ag = yn, sn = {}, bg = ["events.[].metaData", "events.[].breadcrumbs.[].metaData", "events.[].request"];
    sn.event = function(F, U) {
      var ee = N(F, null, null, {
        redactedPaths: bg,
        redactedKeys: U
      });
      return ee.length > 1e6 && (F.events[0]._metadata = {
        notifier: `WARNING!
Serialized payload was ` + ee.length / 1e6 + `MB (limit = 1MB)
metadata was removed`
      }, ee = N(F, null, null, {
        redactedPaths: bg,
        redactedKeys: U
      })), ee;
    }, sn.session = function(F, U) {
      var ee = N(F, null, null);
      return ee;
    };
    var Kn = {};
    Kn = function(F, U) {
      return U === void 0 && (U = window), {
        sendEvent: function(ee, j) {
          j === void 0 && (j = function() {
          });
          var ae = Mn(F._config, "notify", "4", U), be = sn.event(ee, F._config.redactedKeys), ke = new U.XDomainRequest();
          ke.onload = function() {
            j(null);
          }, ke.onerror = function() {
            var gt = new Error("Event failed to send");
            F._logger.error("Event failed to send…", gt), be.length > 1e6 && F._logger.warn("Event oversized (" + (be.length / 1e6).toFixed(2) + " MB)"), j(gt);
          }, ke.open("POST", ae), setTimeout(function() {
            try {
              ke.send(be);
            } catch (gt) {
              F._logger.error(gt), j(gt);
            }
          }, 0);
        },
        sendSession: function(ee, j) {
          j === void 0 && (j = function() {
          });
          var ae = Mn(F._config, "sessions", "1", U), be = new U.XDomainRequest();
          be.onload = function() {
            j(null);
          }, be.open("POST", ae), setTimeout(function() {
            try {
              be.send(sn.session(ee, F._config.redactedKeys));
            } catch (ke) {
              F._logger.error(ke), j(ke);
            }
          }, 0);
        }
      };
    };
    var Mn = function(F, U, ee, j) {
      var ae = JSON.parse(JSON.stringify(/* @__PURE__ */ new Date())), be = Br(F.endpoints[U], j.location.protocol);
      return be + "?apiKey=" + encodeURIComponent(F.apiKey) + "&payloadVersion=" + ee + "&sentAt=" + encodeURIComponent(ae);
    }, Br = Kn._matchPageProtocol = function(F, U) {
      return U === "http:" ? F.replace(/^https:/, "http:") : F;
    }, He = function(F, U) {
      return U === void 0 && (U = window), {
        sendEvent: function(ee, j) {
          j === void 0 && (j = function() {
          });
          try {
            var ae = F._config.endpoints.notify, be = new U.XMLHttpRequest(), ke = sn.event(ee, F._config.redactedKeys);
            be.onreadystatechange = function() {
              if (be.readyState === U.XMLHttpRequest.DONE) {
                var gt = be.status;
                if (gt === 0 || gt >= 400) {
                  var Qe = new Error("Request failed with status " + gt);
                  F._logger.error("Event failed to send…", Qe), ke.length > 1e6 && F._logger.warn("Event oversized (" + (ke.length / 1e6).toFixed(2) + " MB)"), j(Qe);
                } else
                  j(null);
              }
            }, be.open("POST", ae), be.setRequestHeader("Content-Type", "application/json"), be.setRequestHeader("Bugsnag-Api-Key", ee.apiKey || F._config.apiKey), be.setRequestHeader("Bugsnag-Payload-Version", "4"), be.setRequestHeader("Bugsnag-Sent-At", (/* @__PURE__ */ new Date()).toISOString()), be.send(ke);
          } catch (gt) {
            F._logger.error(gt);
          }
        },
        sendSession: function(ee, j) {
          j === void 0 && (j = function() {
          });
          try {
            var ae = F._config.endpoints.sessions, be = new U.XMLHttpRequest();
            be.onreadystatechange = function() {
              if (be.readyState === U.XMLHttpRequest.DONE) {
                var ke = be.status;
                if (ke === 0 || ke >= 400) {
                  var gt = new Error("Request failed with status " + ke);
                  F._logger.error("Session failed to send…", gt), j(gt);
                } else
                  j(null);
              }
            }, be.open("POST", ae), be.setRequestHeader("Content-Type", "application/json"), be.setRequestHeader("Bugsnag-Api-Key", F._config.apiKey), be.setRequestHeader("Bugsnag-Payload-Version", "1"), be.setRequestHeader("Bugsnag-Sent-At", (/* @__PURE__ */ new Date()).toISOString()), be.send(sn.session(ee, F._config.redactedKeys));
          } catch (ke) {
            F._logger.error(ke);
          }
        }
      };
    }, We = /* @__PURE__ */ new Date(), yt = function() {
      We = /* @__PURE__ */ new Date();
    }, at = {
      name: "appDuration",
      load: function(F) {
        return F.addOnError(function(U) {
          var ee = /* @__PURE__ */ new Date();
          U.app.duration = ee - We;
        }, !0), {
          reset: yt
        };
      }
    }, Lt = function(F) {
      return F === void 0 && (F = window), {
        load: function(U) {
          U.addOnError(function(ee) {
            ee.context === void 0 && (ee.context = F.location.pathname);
          }, !0);
        }
      };
    }, Ht = function(U, ee) {
      var j = "000000000" + U;
      return j.substr(j.length - ee);
    }, oi = typeof window == "object" ? window : self, mg = 0;
    for (var kl in oi)
      Object.hasOwnProperty.call(oi, kl) && mg++;
    var oI = navigator.mimeTypes ? navigator.mimeTypes.length : 0, wa = Ht((oI + navigator.userAgent.length).toString(36) + mg.toString(36), 4), AA = function() {
      return wa;
    }, II = 0, Zr = 4, lI = 36, Rs = Math.pow(lI, Zr);
    function CC() {
      return Ht((Math.random() * Rs << 0).toString(lI), Zr);
    }
    function va() {
      return II = II < Rs ? II : 0, II++, II - 1;
    }
    function bA() {
      var F = "c", U = (/* @__PURE__ */ new Date()).getTime().toString(lI), ee = Ht(va().toString(lI), Zr), j = AA(), ae = CC() + CC();
      return F + U + ee + j + ae;
    }
    bA.fingerprint = AA;
    var Ra = bA, Fl = "bugsnag-anonymous-id", Hc = function(F) {
      try {
        var U = F.localStorage, ee = U.getItem(Fl);
        return ee && /^c[a-z0-9]{20,32}$/.test(ee) || (ee = Ra(), U.setItem(Fl, ee)), ee;
      } catch {
      }
    }, kc = function(F, U) {
      return F === void 0 && (F = navigator), U === void 0 && (U = window), {
        load: function(ee) {
          var j = {
            locale: F.browserLanguage || F.systemLanguage || F.userLanguage || F.language,
            userAgent: F.userAgent
          };
          U && U.screen && U.screen.orientation && U.screen.orientation.type ? j.orientation = U.screen.orientation.type : U && U.document && (j.orientation = U.document.documentElement.clientWidth > U.document.documentElement.clientHeight ? "landscape" : "portrait"), ee._config.generateAnonymousId && (j.id = Hc(U)), ee.addOnSession(function(ae) {
            ae.device = h({}, ae.device, j), ee._config.collectUserIp || Xa(ae);
          }), ee.addOnError(function(ae) {
            ae.device = h({}, ae.device, j, {
              time: /* @__PURE__ */ new Date()
            }), ee._config.collectUserIp || Xa(ae);
          }, !0);
        },
        configSchema: {
          generateAnonymousId: {
            validate: function(ee) {
              return ee === !0 || ee === !1;
            },
            defaultValue: function() {
              return !0;
            },
            message: "should be true|false"
          }
        }
      };
    }, Xa = function(F) {
      var U = F.getUser();
      (!U || !U.id) && F.setUser(F.device.id);
    }, Ha = function(F) {
      return F === void 0 && (F = window), {
        load: function(U) {
          U.addOnError(function(ee) {
            ee.request && ee.request.url || (ee.request = h({}, ee.request, {
              url: F.location.href
            }));
          }, !0);
        }
      };
    }, uC = {
      load: function(F) {
        F._sessionDelegate = Fc;
      }
    }, Fc = {
      startSession: function(F, U) {
        var ee = F;
        return ee._session = U, ee._pausedSession = null, ee._config.enabledReleaseStages !== null && !r(ee._config.enabledReleaseStages, ee._config.releaseStage) ? (ee._logger.warn("Session not sent due to releaseStage/enabledReleaseStages configuration"), ee) : (ee._delivery.sendSession({
          notifier: ee._notifier,
          device: U.device,
          app: U.app,
          sessions: [{
            id: U.id,
            startedAt: U.startedAt,
            user: U._user
          }]
        }), ee);
      },
      resumeSession: function(F) {
        return F._session ? F : F._pausedSession ? (F._session = F._pausedSession, F._pausedSession = null, F) : F.startSession();
      },
      pauseSession: function(F) {
        F._pausedSession = F._session, F._session = null;
      }
    }, Xs = {
      load: function(F) {
        F._config.collectUserIp || F.addOnError(function(U) {
          U._user && typeof U._user.id > "u" && delete U._user.id, U._user = h({
            id: "[REDACTED]"
          }, U._user), U.request = h({
            clientIp: "[REDACTED]"
          }, U.request);
        });
      },
      configSchema: {
        collectUserIp: {
          defaultValue: function() {
            return !0;
          },
          message: "should be true|false",
          validate: function(F) {
            return F === !0 || F === !1;
          }
        }
      }
    }, ka = {};
    ka.load = function(F) {
      var U = /^(local-)?dev(elopment)?$/.test(F._config.releaseStage);
      U || !F._isBreadcrumbTypeEnabled("log") || B(AC, function(ee) {
        var j = console[ee];
        console[ee] = function() {
          for (var ae = arguments.length, be = new Array(ae), ke = 0; ke < ae; ke++)
            be[ke] = arguments[ke];
          F.leaveBreadcrumb("Console output", n(be, function(gt, Qe, ut) {
            var wt = "[Unknown value]";
            try {
              wt = String(Qe);
            } catch {
            }
            if (wt === "[object Object]")
              try {
                wt = JSON.stringify(Qe);
              } catch {
              }
            return gt["[" + ut + "]"] = wt, gt;
          }, {
            severity: ee.indexOf("group") === 0 ? "log" : ee
          }), "log"), j.apply(console, be);
        }, console[ee]._restore = function() {
          console[ee] = j;
        };
      });
    };
    var AC = g(["log", "debug", "info", "warn", "error"], function(F) {
      return typeof console < "u" && typeof console[F] == "function";
    }), bC = 200, mC = 5e5, hC = function(F, U) {
      return F === void 0 && (F = document), U === void 0 && (U = window), {
        load: function(ee) {
          if (!ee._config.trackInlineScripts)
            return;
          var j = U.location.href, ae = "", be = !!F.attachEvent, ke = be ? F.readyState === "complete" : F.readyState !== "loading", gt = function() {
            return F.documentElement.outerHTML;
          };
          ae = gt();
          var Qe = F.onreadystatechange;
          F.onreadystatechange = function() {
            F.readyState === "interactive" && (ae = gt(), ke = !0);
            try {
              Qe.apply(this, arguments);
            } catch {
            }
          };
          var ut = null, wt = function(Ot) {
            ut = Ot;
          }, Et = function() {
            var Ot = F.currentScript || ut;
            if (!Ot && !ke) {
              var yi = F.scripts || F.getElementsByTagName("script");
              Ot = yi[yi.length - 1];
            }
            return Ot;
          }, ht = function(Ot) {
            (!ke || !ae) && (ae = gt());
            var yi = ["<!-- DOC START -->"].concat(ae.split(`
`)), og = Ot - 1, Un = Math.max(og - 3, 0), Ig = Math.min(og + 3, yi.length);
            return n(yi.slice(Un, Ig), function(Ui, Ya, Eg) {
              return Ui[Un + 1 + Eg] = Ya.length <= bC ? Ya : Ya.substr(0, bC), Ui;
            }, {});
          };
          ee.addOnError(function(Ot) {
            Ot.errors[0].stacktrace = g(Ot.errors[0].stacktrace, function(Ui) {
              return !/__trace__$/.test(Ui.method);
            });
            var yi = Ot.errors[0].stacktrace[0], og = function(Ui) {
              return Ui.replace(/#.*$/, "").replace(/\?.*$/, "");
            };
            if (!(yi && yi.file && og(yi.file) !== og(j))) {
              var Un = Et();
              if (Un) {
                var Ig = Un.innerHTML;
                Ot.addMetadata("script", "content", Ig.length <= mC ? Ig : Ig.substr(0, mC)), yi && yi.lineNumber && (yi.code = ht(yi.lineNumber));
              }
            }
          }, !0);
          var ci = B(["setTimeout", "setInterval", "setImmediate", "requestAnimationFrame"], function(Ot) {
            return Yc(U, Ot, function(yi) {
              return vn(yi, function(og) {
                return {
                  get: function() {
                    return og[0];
                  },
                  replace: function(Un) {
                    og[0] = Un;
                  }
                };
              });
            });
          }), ai = ci[0];
          B(["EventTarget", "Window", "Node", "ApplicationCache", "AudioTrackList", "ChannelMergerNode", "CryptoOperation", "EventSource", "FileReader", "HTMLUnknownElement", "IDBDatabase", "IDBRequest", "IDBTransaction", "KeyOperation", "MediaController", "MessagePort", "ModalWindow", "Notification", "SVGElementInstance", "Screen", "TextTrack", "TextTrackCue", "TextTrackList", "WebSocket", "WebSocketWorker", "Worker", "XMLHttpRequest", "XMLHttpRequestEventTarget", "XMLHttpRequestUpload"], function(Ot) {
            !U[Ot] || !U[Ot].prototype || !Object.prototype.hasOwnProperty.call(U[Ot].prototype, "addEventListener") || (Yc(U[Ot].prototype, "addEventListener", function(yi) {
              return vn(yi, xc);
            }), Yc(U[Ot].prototype, "removeEventListener", function(yi) {
              return vn(yi, xc, !0);
            }));
          });
          function vn(Ot, yi, og) {
            return og === void 0 && (og = !1), function() {
              var Un = [].slice.call(arguments);
              try {
                var Ig = yi(Un), Ui = Ig.get();
                if (og && Ot.apply(this, Un), typeof Ui != "function")
                  return Ot.apply(this, Un);
                if (Ui.__trace__)
                  Ig.replace(Ui.__trace__);
                else {
                  var Ya = Et();
                  Ui.__trace__ = function() {
                    wt(Ya), ai(function() {
                      wt(null);
                    }, 0);
                    var BA = Ui.apply(this, arguments);
                    return wt(null), BA;
                  }, Ui.__trace__.__trace__ = Ui.__trace__, Ig.replace(Ui.__trace__);
                }
              } catch {
              }
              if (Ot.apply)
                return Ot.apply(this, Un);
              switch (Un.length) {
                case 1:
                  return Ot(Un[0]);
                case 2:
                  return Ot(Un[0], Un[1]);
                default:
                  return Ot();
              }
            };
          }
        },
        configSchema: {
          trackInlineScripts: {
            validate: function(ee) {
              return ee === !0 || ee === !1;
            },
            defaultValue: function() {
              return !0;
            },
            message: "should be true|false"
          }
        }
      };
    };
    function Yc(F, U, ee) {
      var j = F[U];
      if (!j)
        return j;
      var ae = ee(j);
      return F[U] = ae, j;
    }
    function xc(F) {
      var U = !!F[1] && typeof F[1].handleEvent == "function";
      return {
        get: function() {
          return U ? F[1].handleEvent : F[1];
        },
        replace: function(ee) {
          U ? F[1].handleEvent = ee : F[1] = ee;
        }
      };
    }
    var pC = function(F) {
      return F === void 0 && (F = window), {
        load: function(U) {
          "addEventListener" in F && U._isBreadcrumbTypeEnabled("user") && F.addEventListener("click", function(ee) {
            var j, ae;
            try {
              j = Hs(ee.target), ae = ZC(ee.target, F);
            } catch {
              j = "[hidden]", ae = "[hidden]", U._logger.error("Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z");
            }
            U.leaveBreadcrumb("UI click", {
              targetText: j,
              targetSelector: ae
            }, "user");
          }, !0);
        }
      };
    }, BC = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function Hs(F) {
      var U = F.textContent || F.innerText || "";
      return !U && (F.type === "submit" || F.type === "button") && (U = F.value), U = U.replace(BC, "$1"), U.length > 140 ? U.slice(0, 135) + "(...)" : U;
    }
    function ZC(F, U) {
      var ee = [F.tagName];
      if (F.id && ee.push("#" + F.id), F.className && F.className.length && ee.push("." + F.className.split(" ").join(".")), !U.document.querySelectorAll || !Array.prototype.indexOf)
        return ee.join("");
      try {
        if (U.document.querySelectorAll(ee.join("")).length === 1)
          return ee.join("");
      } catch {
        return ee.join("");
      }
      if (F.parentNode.childNodes.length > 1) {
        var j = Array.prototype.indexOf.call(F.parentNode.childNodes, F) + 1;
        ee.push(":nth-child(" + j + ")");
      }
      return U.document.querySelectorAll(ee.join("")).length === 1 ? ee.join("") : F.parentNode ? ZC(F.parentNode, U) + " > " + ee.join("") : ee.join("");
    }
    var Dc = {};
    Dc = function(F) {
      F === void 0 && (F = window);
      var U = {
        load: function(ee) {
          if ("addEventListener" in F && ee._isBreadcrumbTypeEnabled("navigation")) {
            var j = function(ae) {
              return function() {
                return ee.leaveBreadcrumb(ae, {}, "navigation");
              };
            };
            F.addEventListener("pagehide", j("Page hidden"), !0), F.addEventListener("pageshow", j("Page shown"), !0), F.addEventListener("load", j("Page loaded"), !0), F.document.addEventListener("DOMContentLoaded", j("DOMContentLoaded"), !0), F.addEventListener("load", function() {
              return F.addEventListener("popstate", j("Navigated back"), !0);
            }), F.addEventListener("hashchange", function(ae) {
              var be = ae.oldURL ? {
                from: Jc(ae.oldURL, F),
                to: Jc(ae.newURL, F),
                state: Fa(F)
              } : {
                to: Jc(F.location.href, F)
              };
              ee.leaveBreadcrumb("Hash changed", be, "navigation");
            }, !0), F.history.replaceState && fC(ee, F.history, "replaceState", F), F.history.pushState && fC(ee, F.history, "pushState", F);
          }
        }
      };
      return U;
    };
    var Jc = function(F, U) {
      var ee = U.document.createElement("A");
      return ee.href = F, "" + ee.pathname + ee.search + ee.hash;
    }, mA = function(F, U, ee, j) {
      var ae = Jc(F.location.href, F);
      return {
        title: ee,
        state: U,
        prevState: Fa(F),
        to: j || ae,
        from: ae
      };
    }, fC = function(F, U, ee, j) {
      var ae = U[ee];
      U[ee] = function(be, ke, gt) {
        F.leaveBreadcrumb("History " + ee, mA(j, be, ke, gt), "navigation"), typeof F.resetEventCount == "function" && F.resetEventCount(), F._config.autoTrackSessions && F.startSession(), ae.apply(U, [be, ke].concat(gt !== void 0 ? gt : []));
      };
    }, Fa = function(F) {
      try {
        return F.history.state;
      } catch {
      }
    }, Yl = "request", GC = function(F, U) {
      F === void 0 && (F = []), U === void 0 && (U = window);
      var ee = {
        load: function(j) {
          if (!j._isBreadcrumbTypeEnabled("request"))
            return;
          var ae = [j._config.endpoints.notify, j._config.endpoints.sessions].concat(F);
          be(), Qe();
          function be() {
            if ("addEventListener" in U.XMLHttpRequest.prototype) {
              var Et = U.XMLHttpRequest.prototype.open;
              U.XMLHttpRequest.prototype.open = function(ci, ai) {
                var vn = this, Ot = !1, yi = function() {
                  return gt(ci, ai);
                }, og = function() {
                  return ke(ci, ai, vn.status);
                };
                Ot && (this.removeEventListener("load", og), this.removeEventListener("error", yi)), this.addEventListener("load", og), this.addEventListener("error", yi), Ot = !0, Et.apply(this, arguments);
              };
            }
          }
          function ke(Et, ht, ci) {
            if (ht === void 0) {
              j._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
              return;
            }
            if (!(typeof ht == "string" && r(ae, ht.replace(/\?.*$/, "")))) {
              var ai = {
                status: ci,
                request: Et + " " + ht
              };
              ci >= 400 ? j.leaveBreadcrumb("XMLHttpRequest failed", ai, Yl) : j.leaveBreadcrumb("XMLHttpRequest succeeded", ai, Yl);
            }
          }
          function gt(Et, ht) {
            if (ht === void 0) {
              j._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
              return;
            }
            typeof ht == "string" && r(ae, ht.replace(/\?.*$/, "")) || j.leaveBreadcrumb("XMLHttpRequest error", {
              request: Et + " " + ht
            }, Yl);
          }
          function Qe() {
            if (!(!("fetch" in U) || U.fetch.polyfill)) {
              var Et = U.fetch;
              U.fetch = function() {
                var ci = arguments, ai = arguments[0], vn = arguments[1], Ot, yi = null;
                return ai && typeof ai == "object" ? (yi = ai.url, vn && "method" in vn ? Ot = vn.method : ai && "method" in ai && (Ot = ai.method)) : (yi = ai, vn && "method" in vn && (Ot = vn.method)), Ot === void 0 && (Ot = "GET"), new Promise(function(og, Un) {
                  Et.apply(void 0, ci).then(function(Ig) {
                    ut(Ig, Ot, yi), og(Ig);
                  }).catch(function(Ig) {
                    wt(Ot, yi), Un(Ig);
                  });
                });
              };
            }
          }
          var ut = function(Et, ht, ci) {
            var ai = {
              status: Et.status,
              request: ht + " " + ci
            };
            Et.status >= 400 ? j.leaveBreadcrumb("fetch() failed", ai, Yl) : j.leaveBreadcrumb("fetch() succeeded", ai, Yl);
          }, wt = function(Et, ht) {
            j.leaveBreadcrumb("fetch() error", {
              request: Et + " " + ht
            }, Yl);
          };
        }
      };
      return ee;
    }, Xh = {
      load: function(F) {
        var U = 0;
        F.addOnError(function(ee) {
          if (U >= F._config.maxEvents)
            return F._logger.warn("Cancelling event send due to maxEvents per session limit of " + F._config.maxEvents + " being reached"), !1;
          U++;
        }), F.resetEventCount = function() {
          U = 0;
        };
      },
      configSchema: {
        maxEvents: {
          defaultValue: function() {
            return 10;
          },
          message: "should be a positive integer ≤100",
          validate: function(F) {
            return d(1, 100)(F);
          }
        }
      }
    }, yC = {};
    yC = {
      load: function(F) {
        F.addOnError(function(U) {
          var ee = n(U.errors, function(j, ae) {
            return j.concat(ae.stacktrace);
          }, []);
          B(ee, function(j) {
            j.file = hA(j.file);
          });
        });
      }
    };
    var hA = yC._strip = function(F) {
      return typeof F == "string" ? F.replace(/\?.*$/, "").replace(/#.*$/, "") : F;
    }, Hh = function(F, U) {
      return F === void 0 && (F = window), U === void 0 && (U = "window onerror"), {
        load: function(ee) {
          if (!ee._config.autoDetectErrors || !ee._config.enabledErrorTypes.unhandledExceptions)
            return;
          function j(be, ke, gt, Qe, ut) {
            if (gt === 0 && /Script error\.?/.test(be))
              ee._logger.warn("Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z");
            else {
              var wt = {
                severity: "error",
                unhandled: !0,
                severityReason: {
                  type: "unhandledException"
                }
              }, Et;
              if (ut)
                Et = ee.Event.create(ut, !0, wt, U, 1), pA(Et.errors[0].stacktrace, ke, gt, Qe);
              else if (
                // This complex case detects "error" events that are typically synthesised
                // by jquery's trigger method (although can be created in other ways). In
                // order to detect this:
                // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                // - the second argument (url) must either not exist or be something other than a string (if it
                //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                //    function)
                // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                typeof be == "object" && be !== null && (!ke || typeof ke != "string") && !gt && !Qe && !ut
              ) {
                var ht = be.type ? "Event: " + be.type : "Error", ci = be.message || be.detail || "";
                Et = ee.Event.create({
                  name: ht,
                  message: ci
                }, !0, wt, U, 1), Et.originalError = be, Et.addMetadata(U, {
                  event: be,
                  extraParameters: ke
                });
              } else
                Et = ee.Event.create(be, !0, wt, U, 1), pA(Et.errors[0].stacktrace, ke, gt, Qe);
              ee._notify(Et);
            }
            typeof ae == "function" && ae.apply(this, arguments);
          }
          var ae = F.onerror;
          F.onerror = j;
        }
      };
    }, pA = function(F, U, ee, j) {
      F[0] || F.push({});
      var ae = F[0];
      !ae.file && typeof U == "string" && (ae.file = U), !ae.lineNumber && WC(ee) && (ae.lineNumber = ee), ae.columnNumber || (WC(j) ? ae.columnNumber = j : window.event && WC(window.event.errorCharacter) && (ae.columnNumber = window.event.errorCharacter));
    }, WC = function(F) {
      return typeof F == "number" && String.call(F) !== "NaN";
    }, kh = function(F) {
      F === void 0 && (F = window);
      var U = {
        load: function(ee) {
          if (!(!ee._config.autoDetectErrors || !ee._config.enabledErrorTypes.unhandledRejections)) {
            var j = function(ae) {
              var be = ae.reason, ke = !1;
              try {
                ae.detail && ae.detail.reason && (be = ae.detail.reason, ke = !0);
              } catch {
              }
              var gt = ee.Event.create(be, !1, {
                severity: "error",
                unhandled: !0,
                severityReason: {
                  type: "unhandledPromiseRejection"
                }
              }, "unhandledrejection handler", 1, ee._logger);
              ke && B(gt.errors[0].stacktrace, SC(be)), ee._notify(gt, function(Qe) {
                if (rt(Qe.originalError) && !Qe.originalError.stack) {
                  var ut;
                  Qe.addMetadata("unhandledRejection handler", (ut = {}, ut[Object.prototype.toString.call(Qe.originalError)] = {
                    name: Qe.originalError.name,
                    message: Qe.originalError.message,
                    code: Qe.originalError.code
                  }, ut));
                }
              });
            };
            "addEventListener" in F ? F.addEventListener("unhandledrejection", j) : F.onunhandledrejection = function(ae, be) {
              j({
                detail: {
                  reason: ae,
                  promise: be
                }
              });
            };
          }
        }
      };
      return U;
    }, SC = function(F) {
      return function(U) {
        U.file !== F.toString() && U.method && (U.method = U.method.replace(/^\s+/, ""));
      };
    }, NI = {}, Fh = "Bugsnag JavaScript", Yh = "7.22.7", xh = "https://github.com/bugsnag/bugsnag-js", Dh = h({}, A.schema, y), Gi = {
      _client: null,
      createClient: function(F) {
        typeof F == "string" && (F = {
          apiKey: F
        }), F || (F = {});
        var U = [
          // add browser-specific plugins
          at,
          kc(),
          Lt(),
          Ha(),
          Xh,
          uC,
          Xs,
          yC,
          Hh(),
          kh(),
          Dc(),
          pC(),
          GC(),
          ka,
          // this one added last to avoid wrapping functionality before bugsnag uses it
          hC()
        ], ee = new Ag(F, Dh, U, {
          name: Fh,
          version: Yh,
          url: xh
        });
        return ee._setDelivery(window.XDomainRequest ? Kn : He), ee._logger.debug("Loaded!"), ee.leaveBreadcrumb("Bugsnag loaded", {}, "state"), ee._config.autoTrackSessions ? ee.startSession() : ee;
      },
      start: function(F) {
        return Gi._client ? (Gi._client._logger.warn("Bugsnag.start() was called more than once. Ignoring."), Gi._client) : (Gi._client = Gi.createClient(F), Gi._client);
      },
      isStarted: function() {
        return Gi._client != null;
      }
    };
    return B(["resetEventCount"].concat(a(Ag.prototype)), function(F) {
      /^_/.test(F) || (Gi[F] = function() {
        if (!Gi._client)
          return console.log("Bugsnag." + F + "() was called before Bugsnag.start()");
        Gi._client._depth += 1;
        var U = Gi._client[F].apply(Gi._client, arguments);
        return Gi._client._depth -= 1, U;
      });
    }), NI = Gi, NI.Client = Ag, NI.Event = Ut, NI.Session = ln, NI.Breadcrumb = w, NI.default = Gi, NI;
  });
})(Une);
var J5t = Une.exports, K5t = J5t;
const Yz = /* @__PURE__ */ Tr(K5t);
var Pne = { exports: {} };
(function(e, t) {
  (function(i) {
    e.exports = i();
  })(function() {
    var i = {};
    function n() {
      return n = Object.assign ? Object.assign.bind() : function(a) {
        for (var d = 1; d < arguments.length; d++) {
          var C = arguments[d];
          for (var u in C)
            Object.prototype.hasOwnProperty.call(C, u) && (a[u] = C[u]);
        }
        return a;
      }, n.apply(this, arguments);
    }
    function g(a) {
      if (a === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return a;
    }
    function r(a, d) {
      a.prototype = Object.create(d.prototype), a.prototype.constructor = a, o(a, d);
    }
    function o(a, d) {
      return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, A) {
        return u.__proto__ = A, u;
      }, o(a, d);
    }
    i = /* @__PURE__ */ function() {
      function a() {
        var C = typeof window < "u" && window.React;
        if (this.name = "react", this.lazy = arguments.length === 0 && !C, !this.lazy && (this.React = (arguments.length <= 0 ? void 0 : arguments[0]) || C, !this.React))
          throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
      }
      var d = a.prototype;
      return d.load = function(u) {
        if (!this.lazy) {
          var A = s(this.React, u);
          return A.createErrorBoundary = function() {
            return A;
          }, A;
        }
        var m = function() {
          throw new Error(`@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:
Pass React to the plugin constructor

  \`Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })\`
and then call \`const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()\`

Or if React is not available until after Bugsnag has started,
construct the plugin with no arguments
  \`Bugsnag.start({ plugins: [new BugsnagPluginReact()] })\`,
then pass in React when available to construct your error boundary
  \`const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)\``);
        };
        return m.createErrorBoundary = function(h) {
          if (!h)
            throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
          return s(h, u);
        }, m;
      }, a;
    }();
    var I = function(a) {
      for (var d = a.split(/\s*\n\s*/g), C = "", u = 0, A = d.length; u < A; u++)
        d[u].length && (C += (C.length ? `
` : "") + d[u]);
      return C;
    }, s = function(a, d) {
      return /* @__PURE__ */ function(C) {
        r(u, C);
        function u(m) {
          var h;
          return h = C.call(this, m) || this, h.state = {
            error: null,
            info: null
          }, h.handleClearError = h.handleClearError.bind(g(h)), h;
        }
        var A = u.prototype;
        return A.handleClearError = function() {
          this.setState({
            error: null,
            info: null
          });
        }, A.componentDidCatch = function(h, B) {
          var f = this.props.onError, G = {
            severity: "error",
            unhandled: !0,
            severityReason: {
              type: "unhandledException"
            }
          }, y = d.Event.create(h, !0, G, 1);
          B && B.componentStack && (B.componentStack = I(B.componentStack)), y.addMetadata("react", B), d._notify(y, f), this.setState({
            error: h,
            info: B
          });
        }, A.render = function() {
          var h = this.state.error;
          if (h) {
            var B = this.props.FallbackComponent;
            return B ? a.createElement(B, n({}, this.state, {
              clearError: this.handleClearError
            })) : null;
          }
          return this.props.children;
        }, u;
      }(a.Component);
    };
    return i.formatComponentStack = I, i.default = i, i;
  });
})(Pne);
var E5t = Pne.exports;
const N5t = /* @__PURE__ */ Tr(E5t), L5t = function() {
  return null;
};
jV.setLicenseKey("9e1cb1654be631eaf1fa9b254d045a04T1JERVI6Mzk2MzEsRVhQSVJZPTE2Nzg4NzE3NjYwMDAsS0VZVkVSU0lPTj0x");
let a5 = /* @__PURE__ */ p(X5t, {});
window.Cypress && (window.store = u9);
if (jo.bugsnagKey) {
  Yz.start({
    apiKey: jo.bugsnagKey,
    plugins: [new N5t()]
  });
  const e = Yz.getPlugin("react").createErrorBoundary(Se);
  a5 = /* @__PURE__ */ p(e, { children: a5 });
}
window.Cypress && (window.store = u9);
Xxt();
const T5t = {
  ...D5t,
  ...Fxt
}, M5t = /* @__PURE__ */ p(tD, { styles: T5t }), gNt = (e) => {
  var i, n;
  const t = OZ();
  return et(() => {
    console.log(`K3 Version: ${Yge}`);
  }, []), /* @__PURE__ */ p(dJ.Provider, { value: {
    extensions: Object.keys(t.extensions).length ? t.extensions : e.extensions || {},
    additionalDynamicSettings: (i = t.additionalDynamicSettings) != null && i.length ? t.additionalDynamicSettings : e.additionalDynamicSettings || [],
    contexts: (n = t.contexts) != null && n.length ? t.contexts : e.contexts || [],
    themeOptionsCreator: e.themeOptionsCreator
  }, children: /* @__PURE__ */ p(F5t, { children: /* @__PURE__ */ ge(fet, { client: Y5t, children: [
    /* @__PURE__ */ p(Iye, { store: u9, context: HD, children: /* @__PURE__ */ p(oO, { theme: Cne, children: /* @__PURE__ */ ge(wqe, { maxSnack: 3, preventDuplicate: !0, autoHideDuration: 3e3, action: (g) => /* @__PURE__ */ p(kne, { messageKey: g }), children: [
      /* @__PURE__ */ p(tpe, { enableColorScheme: !0 }),
      M5t,
      /* @__PURE__ */ p(koe, { children: a5 }),
      /* @__PURE__ */ p(O_, {})
    ] }) }) }),
    /* @__PURE__ */ p(L5t, { initialIsOpen: !1, toggleButtonProps: {
      style: {
        left: "60px"
      },
      "data-cy": "React Dev Tools"
    } })
  ] }) }) });
}, rNt = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}, oNt = ({
  label: e = "Modell",
  modelKey: t = "",
  multiple: i = !1,
  onChange: n,
  onChangeMultiple: g
}) => {
  const r = (glt() ?? []).filter((s) => s.key), o = (s) => {
    if (Array.isArray(s)) {
      const a = s.reduce((d, C) => C.key ? [...d, C.key] : d, []);
      g == null || g(a);
    } else
      s != null && s.key && (n == null || n(s.key));
  }, I = i ? r.filter((s) => s.key && t.includes(s.key)) : (r == null ? void 0 : r.find((s) => s.key === t)) ?? null;
  return /* @__PURE__ */ p(oue, { id: "model-selector", "data-cy": "modelSelector", options: r, multiple: i, sx: {
    maxWidth: 1
  }, disableCloseOnSelect: i, value: I, renderInput: (s) => /* @__PURE__ */ p(Gu, { ...s, label: e }), onChange: (s, a) => {
    a && o(a);
  } });
};
export {
  n1 as $,
  ye as A,
  fe as B,
  Wm as C,
  bs as D,
  Sm as E,
  aO as F,
  sce as G,
  Qu as H,
  mi as I,
  Sle as J,
  gn as K,
  as as L,
  zg as M,
  Gg as N,
  kg as O,
  So as P,
  Ft as Q,
  fo as R,
  QO as S,
  Ne as T,
  br as U,
  qo as V,
  Ww as W,
  tk as X,
  As as Y,
  vZ as Z,
  k as _,
  y0e as a,
  ge as a$,
  dD as a0,
  Qm as a1,
  cBe as a2,
  aBe as a3,
  xi as a4,
  qO as a5,
  i1 as a6,
  bd as a7,
  Ou as a8,
  _w as a9,
  PO as aA,
  IDt as aB,
  M0 as aC,
  oDt as aD,
  oue as aE,
  YCe as aF,
  uCe as aG,
  Xce as aH,
  e1 as aI,
  fs as aJ,
  DO as aK,
  Gu as aL,
  Om as aM,
  hm as aN,
  qm as aO,
  Cn as aP,
  rkt as aQ,
  Y9t as aR,
  O4 as aS,
  rDt as aT,
  Mne as aU,
  kz as aV,
  m5t as aW,
  _ as aX,
  Ai as aY,
  Ud as aZ,
  ii as a_,
  oa as aa,
  Ch as ab,
  dg as ac,
  fKt as ad,
  GKt as ae,
  Iet as af,
  Ah as ag,
  Get as ah,
  Vet as ai,
  Xet as aj,
  wet as ak,
  vet as al,
  w7 as am,
  ket as an,
  Fet as ao,
  Het as ap,
  Ret as aq,
  yKt as ar,
  jV as as,
  pl as at,
  eo as au,
  tA as av,
  Uw as aw,
  xS as ax,
  $me as ay,
  Pme as az,
  yue as b,
  c6e as b$,
  p as b0,
  S5 as b1,
  RO as b2,
  Vs as b3,
  x7 as b4,
  WJ as b5,
  Bt as b6,
  HJ as b7,
  j1 as b8,
  y5 as b9,
  m7 as bA,
  z1 as bB,
  Dd as bC,
  xd as bD,
  Cr as bE,
  Yu as bF,
  oQ as bG,
  Yd as bH,
  ng as bI,
  TQe as bJ,
  gJt as bK,
  rJt as bL,
  ef as bM,
  PB as bN,
  me as bO,
  Za as bP,
  ce as bQ,
  jo as bR,
  sKt as bS,
  k7 as bT,
  SKt as bU,
  Rxt as bV,
  ate as bW,
  S1 as bX,
  Oet as bY,
  kgt as bZ,
  vfe as b_,
  Hj as ba,
  ha as bb,
  zt as bc,
  Li as bd,
  M1 as be,
  Qd as bf,
  wg as bg,
  C3 as bh,
  DKt as bi,
  da as bj,
  TZ as bk,
  uS as bl,
  XO as bm,
  Dw as bn,
  vqe as bo,
  S5t as bp,
  oK as bq,
  HKt as br,
  p$e as bs,
  $n as bt,
  jDt as bu,
  PQe as bv,
  UB as bw,
  Wbe as bx,
  DFt as by,
  $B as bz,
  lme as c,
  Uj as c$,
  a6e as c0,
  A6e as c1,
  rn as c2,
  qE as c3,
  bDt as c4,
  qS as c5,
  V1 as c6,
  Q1 as c7,
  Ket as c8,
  R2 as c9,
  J7 as cA,
  rIt as cB,
  XKt as cC,
  Cc as cD,
  ui as cE,
  ch as cF,
  woe as cG,
  oY as cH,
  iDt as cI,
  ev as cJ,
  RJ as cK,
  NDt as cL,
  tDt as cM,
  y5t as cN,
  h6e as cO,
  OD as cP,
  uhe as cQ,
  gDt as cR,
  Zce as cS,
  nDt as cT,
  eNt as cU,
  dye as cV,
  bue as cW,
  j9t as cX,
  pm as cY,
  yye as cZ,
  YY as c_,
  QQe as ca,
  b0t as cb,
  ZIt as cc,
  g1 as cd,
  $O as ce,
  Jd as cf,
  o1 as cg,
  b7 as ch,
  MY as ci,
  TY as cj,
  _1 as ck,
  tK as cl,
  ZKt as cm,
  DD as cn,
  m9t as co,
  I1 as cp,
  mc as cq,
  aJt as cr,
  OIt as cs,
  $$e as ct,
  $Dt as cu,
  REt as cv,
  Jet as cw,
  Z1 as cx,
  N_ as cy,
  EQe as cz,
  Si as d,
  HDt as d$,
  EDt as d0,
  Yb as d1,
  Xb as d2,
  Hb as d3,
  N4 as d4,
  $9t as d5,
  hJt as d6,
  Wje as d7,
  mJt as d8,
  GK as d9,
  ms as dA,
  HY as dB,
  jd as dC,
  M5 as dD,
  P5 as dE,
  U5 as dF,
  _$e as dG,
  mE as dH,
  _ue as dI,
  xm as dJ,
  cJt as dK,
  A9t as dL,
  YD as dM,
  Wa as dN,
  l1 as dO,
  uD as dP,
  aDt as dQ,
  ufe as dR,
  hot as dS,
  hKt as dT,
  CDt as dU,
  V$e as dV,
  YDt as dW,
  hi as dX,
  lh as dY,
  XDt as dZ,
  J6 as d_,
  zQe as da,
  O9t as db,
  PDt as dc,
  Q9t as dd,
  q9t as de,
  QDt as df,
  G0e as dg,
  _pe as dh,
  OO as di,
  RKt as dj,
  vKt as dk,
  j$ as dl,
  YKt as dm,
  px as dn,
  XEt as dp,
  Zz as dq,
  Cs as dr,
  gQ as ds,
  Aa as dt,
  DZ as du,
  f1 as dv,
  ys as dw,
  Gs as dx,
  us as dy,
  Ws as dz,
  qy as e,
  UCt as e$,
  MD as e0,
  Go as e1,
  Ba as e2,
  b6 as e3,
  ya as e4,
  VDt as e5,
  QB as e6,
  rGe as e7,
  pc as e8,
  F7 as e9,
  tD as eA,
  oO as eB,
  vxt as eC,
  AJt as eD,
  hje as eE,
  d6e as eF,
  Ej as eG,
  ID as eH,
  z9t as eI,
  Tr as eJ,
  RY as eK,
  o6e as eL,
  W6e as eM,
  eJt as eN,
  Sxt as eO,
  QZ as eP,
  to as eQ,
  DGe as eR,
  Uet as eS,
  tf as eT,
  J9t as eU,
  AV as eV,
  s2 as eW,
  G_ as eX,
  xEt as eY,
  $r as eZ,
  cKt as e_,
  AEt as ea,
  bEt as eb,
  Y7 as ec,
  mEt as ed,
  aKt as ee,
  Y6 as ef,
  tKt as eg,
  Ac as eh,
  iEt as ei,
  nEt as ej,
  gEt as ek,
  VKt as el,
  rEt as em,
  oEt as en,
  bKt as eo,
  YQ as ep,
  pKt as eq,
  G$e as er,
  Qet as es,
  qDt as et,
  iJt as eu,
  kKt as ev,
  U$e as ew,
  hr as ex,
  FKt as ey,
  kxt as ez,
  Kue as f,
  nNt as f$,
  ECt as f0,
  lr as f1,
  Q$ as f2,
  Fgt as f3,
  lD as f4,
  uc as f5,
  ax as f6,
  Dpe as f7,
  B$ as f8,
  CEt as f9,
  GEt as fA,
  mKt as fB,
  ua as fC,
  jhe as fD,
  Phe as fE,
  mj as fF,
  Gk as fG,
  ODt as fH,
  u6e as fI,
  nJt as fJ,
  v9t as fK,
  sJt as fL,
  LDt as fM,
  L9t as fN,
  G5t as fO,
  E9t as fP,
  U9t as fQ,
  K9t as fR,
  P9t as fS,
  Y5t as fT,
  N9t as fU,
  T9t as fV,
  jIt as fW,
  M9t as fX,
  iNt as fY,
  xKt as fZ,
  _9t as f_,
  nje as fa,
  Gye as fb,
  NQ as fc,
  IGe as fd,
  rZ as fe,
  V8 as ff,
  Det as fg,
  W_ as fh,
  Dg as fi,
  vg as fj,
  bz as fk,
  yxt as fl,
  aFt as fm,
  Qgt as fn,
  V9t as fo,
  qKt as fp,
  Jkt as fq,
  wKt as fr,
  xkt as fs,
  Dt as ft,
  S8 as fu,
  B$e as fv,
  SGe as fw,
  ZEt as fx,
  eKt as fy,
  pEt as fz,
  ace as g,
  R6 as g$,
  tNt as g0,
  f8 as g1,
  Ybe as g2,
  kd as g3,
  J8 as g4,
  A_ as g5,
  bJt as g6,
  E$ as g7,
  _Kt as g8,
  G8 as g9,
  RFt as gA,
  XFt as gB,
  uF as gC,
  Wye as gD,
  MDt as gE,
  A7 as gF,
  i7 as gG,
  Ote as gH,
  j$e as gI,
  _Dt as gJ,
  zee as gK,
  vpt as gL,
  ADt as gM,
  Zkt as gN,
  Wxt as gO,
  Cne as gP,
  cDt as gQ,
  JDt as gR,
  ZGe as gS,
  Xfe as gT,
  CKt as gU,
  wfe as gV,
  qIt as gW,
  Jn as gX,
  aD as gY,
  Rfe as gZ,
  Ju as g_,
  LZ as ga,
  lJt as gb,
  IJt as gc,
  dKt as gd,
  w6e as ge,
  EZ as gf,
  J$ as gg,
  Dqe as gh,
  IEt as gi,
  X9t as gj,
  R9t as gk,
  Cxt as gl,
  lEt as gm,
  d0t as gn,
  FV as go,
  Eu as gp,
  Wc as gq,
  Tet as gr,
  ig as gs,
  lf as gt,
  bJ as gu,
  Bn as gv,
  txt as gw,
  JKt as gx,
  ixt as gy,
  D9t as gz,
  xN as h,
  WJt as h$,
  _et as h0,
  P6 as h1,
  ZDt as h2,
  YEt as h3,
  FEt as h4,
  zXt as h5,
  vEt as h6,
  RDt as h7,
  yDt as h8,
  mDt as h9,
  kDt as hA,
  VO as hB,
  R$ as hC,
  rD as hD,
  AE as hE,
  SDt as hF,
  Qot as hG,
  fEt as hH,
  qJt as hI,
  EJt as hJ,
  NJt as hK,
  LJt as hL,
  TJt as hM,
  MJt as hN,
  UJt as hO,
  OJt as hP,
  PJt as hQ,
  zJt as hR,
  QJt as hS,
  jJt as hT,
  $Jt as hU,
  _Jt as hV,
  xJt as hW,
  mr as hX,
  VD as hY,
  wD as hZ,
  AKt as h_,
  ZD as ha,
  H_ as hb,
  OKt as hc,
  yB as hd,
  pr as he,
  jCt as hf,
  $M as hg,
  act as hh,
  dct as hi,
  g0t as hj,
  aK as hk,
  uct as hl,
  GCt as hm,
  gut as hn,
  Iut as ho,
  sCt as hp,
  UL as hq,
  dDt as hr,
  GDt as hs,
  WDt as ht,
  ju as hu,
  nn as hv,
  kJt as hw,
  DDt as hx,
  DJt as hy,
  Ni as hz,
  $Ae as i,
  sDt as i$,
  SJt as i0,
  VJt as i1,
  wJt as i2,
  vJt as i3,
  RJt as i4,
  XJt as i5,
  HJt as i6,
  KJt as i7,
  uDt as i8,
  EQ as i9,
  wEt as iA,
  hDt as iB,
  Net as iC,
  Hfe as iD,
  kEt as iE,
  BDt as iF,
  HEt as iG,
  tJt as iH,
  oJt as iI,
  E7 as iJ,
  Uqe as iK,
  wDt as iL,
  jfe as iM,
  Qfe as iN,
  EGe as iO,
  uJt as iP,
  oD as iQ,
  yJt as iR,
  pDt as iS,
  Sj as iT,
  tI as iU,
  xDt as iV,
  yd as iW,
  _B as iX,
  X$ as iY,
  Tj as iZ,
  BEt as i_,
  m1 as ia,
  y$e as ib,
  FJt as ic,
  YJt as id,
  JJt as ie,
  hEt as ig,
  QFt as ih,
  WEt as ii,
  fDt as ij,
  $d as ik,
  yEt as il,
  f6 as im,
  Nj as io,
  lKt as ip,
  Og as iq,
  GJt as ir,
  uKt as is,
  PCt as it,
  IZ as iu,
  eIt as iv,
  vDt as iw,
  SEt as ix,
  AJ as iy,
  VEt as iz,
  Wt as j,
  C0t as j$,
  FDt as j0,
  eI as j1,
  fGe as j2,
  Pj as j3,
  H9t as j4,
  k9t as j5,
  KDt as j6,
  zDt as j7,
  Yz as j8,
  Yge as j9,
  Skt as jA,
  ine as jB,
  cA as jC,
  IFt as jD,
  jkt as jE,
  _kt as jF,
  Dkt as jG,
  Ane as jH,
  uFt as jI,
  qee as jJ,
  _ee as jK,
  Dx as jL,
  HFt as jM,
  FFt as jN,
  jFt as jO,
  xFt as jP,
  one as jQ,
  KFt as jR,
  Pst as jS,
  _st as jT,
  hFt as jU,
  BFt as jV,
  IYt as jW,
  FB as jX,
  H$ as jY,
  qst as jZ,
  A0t as j_,
  xge as ja,
  gNt as jb,
  ZJt as jc,
  dJ as jd,
  OZ as je,
  FK as jf,
  Od as jg,
  oh as jh,
  h2 as ji,
  dJt as jj,
  CJt as jk,
  E1 as jl,
  Bf as jm,
  yCt as jn,
  Xl as jo,
  cte as jp,
  BI as jq,
  g9 as jr,
  kK as js,
  OYt as jt,
  kfe as ju,
  th as jv,
  w9t as jw,
  x9t as jx,
  une as jy,
  Fnt as jz,
  _t as k,
  f9t as k$,
  dut as k0,
  rNt as k1,
  oNt as k2,
  Ogt as k3,
  w8 as k4,
  znt as k5,
  Ont as k6,
  IA as k7,
  cnt as k8,
  EJ as k9,
  cK as kA,
  rlt as kB,
  dK as kC,
  e9t as kD,
  t$ as kE,
  t9t as kF,
  i9t as kG,
  i$ as kH,
  n9t as kI,
  n$ as kJ,
  g9t as kK,
  r9t as kL,
  o9t as kM,
  I9t as kN,
  l9t as kO,
  s9t as kP,
  a9t as kQ,
  c9t as kR,
  d9t as kS,
  C9t as kT,
  u9t as kU,
  b9t as kV,
  h9t as kW,
  olt as kX,
  p9t as kY,
  B9t as kZ,
  Z9t as k_,
  DEt as ka,
  JEt as kb,
  $_ as kc,
  $It as kd,
  KEt as ke,
  EEt as kf,
  NEt as kg,
  q_ as kh,
  LEt as ki,
  elt as kj,
  tlt as kk,
  ilt as kl,
  nlt as km,
  TEt as kn,
  MEt as ko,
  UEt as kp,
  PEt as kq,
  zEt as kr,
  OEt as ks,
  QEt as kt,
  jEt as ku,
  glt as kv,
  _Et as kw,
  $Et as kx,
  qEt as ky,
  e$ as kz,
  ame as l,
  jet as l$,
  G9t as l0,
  g$ as l1,
  Ilt as l2,
  y9t as l3,
  W9t as l4,
  S9t as l5,
  N1 as l6,
  nV as l7,
  iKt as l8,
  X$e as l9,
  E$e as lA,
  $6 as lB,
  q6 as lC,
  oKt as lD,
  dh as lE,
  N$e as lF,
  L$e as lG,
  T1 as lH,
  e7 as lI,
  IKt as lJ,
  t7 as lK,
  T$e as lL,
  hJ as lM,
  M$e as lN,
  _Z as lO,
  pJ as lP,
  un as lQ,
  U1 as lR,
  BKt as lS,
  EKt as lT,
  NKt as lU,
  lc as lV,
  Ii as lW,
  J1 as lX,
  fJt as lY,
  b$e as lZ,
  XJ as l_,
  iC as la,
  N6 as lb,
  H$e as lc,
  L6 as ld,
  sW as le,
  gs as lf,
  M6 as lg,
  F$e as lh,
  U6 as li,
  Y$e as lj,
  nKt as lk,
  x$e as ll,
  D$e as lm,
  gKt as ln,
  nC as lo,
  z6 as lp,
  O6 as lq,
  J$e as lr,
  jZ as ls,
  L1 as lt,
  Q6 as lu,
  mJ as lv,
  j6 as lw,
  _6 as lx,
  rKt as ly,
  K$e as lz,
  Cg as m,
  $1 as m0,
  yZ as n,
  ole as o,
  Re as p,
  Ue as q,
  Kg as r,
  Ao as s,
  lDt as t,
  Ve as u,
  K4 as v,
  Vt as w,
  St as x,
  Tle as y,
  ti as z
};
